/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(867);
	module.exports = __webpack_require__(1355);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(151);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2039)();
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The main AWS namespace
	 */
	var AWS = { util: __webpack_require__(34) };
	
	/**
	 * @api private
	 * @!macro [new] nobrowser
	 *   @note This feature is not supported in the browser environment of the SDK.
	 */
	var _hidden = {}; _hidden.toString(); // hack to parse macro
	
	/**
	 * @api private
	 */
	module.exports = AWS;
	
	AWS.util.update(AWS, {
	
	  /**
	   * @constant
	   */
	  VERSION: '2.507.0',
	
	  /**
	   * @api private
	   */
	  Signers: {},
	
	  /**
	   * @api private
	   */
	  Protocol: {
	    Json: __webpack_require__(277),
	    Query: __webpack_require__(432),
	    Rest: __webpack_require__(191),
	    RestJson: __webpack_require__(433),
	    RestXml: __webpack_require__(434)
	  },
	
	  /**
	   * @api private
	   */
	  XML: {
	    Builder: __webpack_require__(1052),
	    Parser: null // conditionally set based on environment
	  },
	
	  /**
	   * @api private
	   */
	  JSON: {
	    Builder: __webpack_require__(274),
	    Parser: __webpack_require__(275)
	  },
	
	  /**
	   * @api private
	   */
	  Model: {
	    Api: __webpack_require__(427),
	    Operation: __webpack_require__(429),
	    Shape: __webpack_require__(157),
	    Paginator: __webpack_require__(430),
	    ResourceWaiter: __webpack_require__(431)
	  },
	
	  /**
	   * @api private
	   */
	  apiLoader: __webpack_require__(993),
	
	  /**
	   * @api private
	   */
	  EndpointCache: __webpack_require__(1062).EndpointCache
	});
	__webpack_require__(435);
	__webpack_require__(1029);
	__webpack_require__(1000);
	__webpack_require__(426);
	__webpack_require__(1017);
	__webpack_require__(1025);
	__webpack_require__(1027);
	__webpack_require__(1026);
	__webpack_require__(1045);
	__webpack_require__(1019);
	
	/**
	 * @readonly
	 * @return [AWS.SequentialExecutor] a collection of global event listeners that
	 *   are attached to every sent request.
	 * @see AWS.Request AWS.Request for a list of events to listen for
	 * @example Logging the time taken to send a request
	 *   AWS.events.on('send', function startSend(resp) {
	 *     resp.startTime = new Date().getTime();
	 *   }).on('complete', function calculateTime(resp) {
	 *     var time = (new Date().getTime() - resp.startTime) / 1000;
	 *     console.log('Request took ' + time + ' seconds');
	 *   });
	 *
	 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
	 */
	AWS.events = new AWS.SequentialExecutor();
	
	//create endpoint cache lazily
	AWS.util.memoizedProperty(AWS, 'endpointCache', function() {
	  return new AWS.EndpointCache(AWS.config.endpointCacheSize);
	}, true);


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(2034)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _isPlaceholder = __webpack_require__(225);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var util = __webpack_require__(34);
	
	// browser specific modules
	util.crypto.lib = __webpack_require__(994);
	util.Buffer = __webpack_require__(100).Buffer;
	util.url = __webpack_require__(1058);
	util.querystring = __webpack_require__(218);
	util.realClock = __webpack_require__(1023);
	util.environment = 'js';
	util.createEventStream = __webpack_require__(1011).createEventStream;
	util.isBrowser = function() { return true; };
	util.isNode = function() { return false; };
	
	var AWS = __webpack_require__(4);
	
	/**
	 * @api private
	 */
	module.exports = AWS;
	
	__webpack_require__(422);
	__webpack_require__(423);
	__webpack_require__(1004);
	__webpack_require__(1001);
	__webpack_require__(1005);
	__webpack_require__(1002);
	__webpack_require__(1003);
	
	// Load the DOMParser XML parser
	AWS.XML.Parser = __webpack_require__(1051);
	
	// Load the XHR HttpClient
	__webpack_require__(1018);
	
	if (typeof process === 'undefined') {
	  var process = {
	    browser: true
	  };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ThemeProvider = __webpack_require__(2239);
	
	Object.defineProperty(exports, 'ThemeProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ThemeProvider).default;
	  }
	});
	
	var _themr = __webpack_require__(2240);
	
	Object.defineProperty(exports, 'themr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_themr).default;
	  }
	});
	Object.defineProperty(exports, 'themeable', {
	  enumerable: true,
	  get: function get() {
	    return _themr.themeable;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APP_BAR = exports.APP_BAR = 'RTAppBar';
	var AUTOCOMPLETE = exports.AUTOCOMPLETE = 'RTAutocomplete';
	var AVATAR = exports.AVATAR = 'RTAvatar';
	var BUTTON = exports.BUTTON = 'RTButton';
	var CARD = exports.CARD = 'RTCard';
	var CHIP = exports.CHIP = 'RTChip';
	var CHECKBOX = exports.CHECKBOX = 'RTCheckbox';
	var DATE_PICKER = exports.DATE_PICKER = 'RTDatePicker';
	var DIALOG = exports.DIALOG = 'RTDialog';
	var DRAWER = exports.DRAWER = 'RTDrawer';
	var DROPDOWN = exports.DROPDOWN = 'RTDropdown';
	var INPUT = exports.INPUT = 'RTInput';
	var LAYOUT = exports.LAYOUT = 'RTLayout';
	var LINK = exports.LINK = 'RTLink';
	var LIST = exports.LIST = 'RTList';
	var MENU = exports.MENU = 'RTMenu';
	var NAVIGATION = exports.NAVIGATION = 'RTNavigation';
	var OVERLAY = exports.OVERLAY = 'RTOverlay';
	var PROGRESS_BAR = exports.PROGRESS_BAR = 'RTProgressBar';
	var RADIO = exports.RADIO = 'RTRadio';
	var RIPPLE = exports.RIPPLE = 'RTRipple';
	var SLIDER = exports.SLIDER = 'RTSlider';
	var SNACKBAR = exports.SNACKBAR = 'RTSnackbar';
	var SWITCH = exports.SWITCH = 'RTSwitch';
	var TABLE = exports.TABLE = 'RTTable';
	var TABS = exports.TABS = 'RTTabs';
	var TOOLTIP = exports.TOOLTIP = 'RTTooltip';
	var TIME_PICKER = exports.TIME_PICKER = 'RTTimePicker';

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isFunction = function isFunction(input) {
	  return typeof input === 'function';
	};
	
	exports.default = function (predicate) {
	  return function (elemOrThunk) {
	    return predicate ? isFunction(elemOrThunk) ? elemOrThunk() : elemOrThunk : null;
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(225);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _curry2 = __webpack_require__(6);
	var _isPlaceholder = __webpack_require__(225);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * The main AWS namespace
	 */
	var AWS = { util: __webpack_require__(41) };
	
	/**
	 * @api private
	 * @!macro [new] nobrowser
	 *   @note This feature is not supported in the browser environment of the SDK.
	 */
	var _hidden = {}; _hidden.toString(); // hack to parse macro
	
	module.exports = AWS;
	
	AWS.util.update(AWS, {
	
	  /**
	   * @constant
	   */
	  VERSION: '2.177.0',
	
	  /**
	   * @api private
	   */
	  Signers: {},
	
	  /**
	   * @api private
	   */
	  Protocol: {
	    Json: __webpack_require__(272),
	    Query: __webpack_require__(413),
	    Rest: __webpack_require__(189),
	    RestJson: __webpack_require__(414),
	    RestXml: __webpack_require__(415)
	  },
	
	  /**
	   * @api private
	   */
	  XML: {
	    Builder: __webpack_require__(901),
	    Parser: null // conditionally set based on environment
	  },
	
	  /**
	   * @api private
	   */
	  JSON: {
	    Builder: __webpack_require__(270),
	    Parser: __webpack_require__(271)
	  },
	
	  /**
	   * @api private
	   */
	  Model: {
	    Api: __webpack_require__(408),
	    Operation: __webpack_require__(410),
	    Shape: __webpack_require__(156),
	    Paginator: __webpack_require__(411),
	    ResourceWaiter: __webpack_require__(412)
	  },
	
	  /**
	   * @api private
	   */
	  apiLoader: __webpack_require__(875)
	});
	
	__webpack_require__(889);
	__webpack_require__(876);
	
	__webpack_require__(407);
	__webpack_require__(416);
	__webpack_require__(881);
	__webpack_require__(886);
	__webpack_require__(888);
	__webpack_require__(887);
	__webpack_require__(893);
	__webpack_require__(883);
	
	/**
	 * @readonly
	 * @return [AWS.SequentialExecutor] a collection of global event listeners that
	 *   are attached to every sent request.
	 * @see AWS.Request AWS.Request for a list of events to listen for
	 * @example Logging the time taken to send a request
	 *   AWS.events.on('send', function startSend(resp) {
	 *     resp.startTime = new Date().getTime();
	 *   }).on('complete', function calculateTime(resp) {
	 *     var time = (new Date().getTime() - resp.startTime) / 1000;
	 *     console.log('Request took ' + time + ' seconds');
	 *   });
	 *
	 *   new AWS.S3().listBuckets(); // prints 'Request took 0.285 seconds'
	 */
	AWS.events = new AWS.SequentialExecutor();


/***/ },
/* 16 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(77);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(2345);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(2346);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(773);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(2347);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(2348);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(2349);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(2350);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(774);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(364);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(2351);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(2352);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(2353);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(2354);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(2355);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(1359);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2256);


/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1361);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1358);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(489);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(489);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	var _interopRequireWildcard = __webpack_require__(869);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(2333));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(769));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(2334));
	
	exports.connect = _connect.default;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Error = __webpack_require__(158);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Error2.default;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FullScreenLoader = __webpack_require__(1145);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FullScreenLoader2.default;

/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BrowseButton = exports.IconButton = exports.Button = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Button = __webpack_require__(247);
	
	var _BrowseButton = __webpack_require__(2374);
	
	var _IconButton = __webpack_require__(248);
	
	var _FontIcon = __webpack_require__(45);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _theme = __webpack_require__(1433);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = (0, _Button.buttonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon.FontIcon);
	var IconButton = (0, _IconButton.iconButtonFactory)((0, _ripple2.default)({ centered: true }), _FontIcon.FontIcon);
	var BrowseButton = (0, _BrowseButton.browseButtonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon.FontIcon);
	var ThemedButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(Button);
	var ThemedIconButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(IconButton);
	var ThemedBrowseButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(BrowseButton);
	
	exports.default = ThemedButton;
	exports.Button = ThemedButton;
	exports.IconButton = ThemedIconButton;
	exports.BrowseButton = ThemedBrowseButton;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(1357);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Input = __webpack_require__(149);
	
	var _FontIcon = __webpack_require__(45);
	
	var _theme = __webpack_require__(1441);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Input = (0, _Input.inputFactory)(_FontIcon.FontIcon);
	var ThemedInput = (0, _reactCssThemr.themr)(_identifiers.INPUT, _theme2.default, { withRef: true })(Input);
	
	exports.default = ThemedInput;
	exports.Input = ThemedInput;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
	var AWS;
	
	/**
	 * A set of utility methods for use with the AWS SDK.
	 *
	 * @!attribute abort
	 *   Return this value from an iterator function {each} or {arrayEach}
	 *   to break out of the iteration.
	 *   @example Breaking out of an iterator function
	 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
	 *       if (key == 'b') return AWS.util.abort;
	 *     });
	 *   @see each
	 *   @see arrayEach
	 * @api private
	 */
	var util = {
	  environment: 'nodejs',
	  engine: function engine() {
	    if (util.isBrowser() && typeof navigator !== 'undefined') {
	      return navigator.userAgent;
	    } else {
	      var engine = process.platform + '/' + process.version;
	      if (({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}).AWS_EXECUTION_ENV) {
	        engine += ' exec-env/' + ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}).AWS_EXECUTION_ENV;
	      }
	      return engine;
	    }
	  },
	
	  userAgent: function userAgent() {
	    var name = util.environment;
	    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(4).VERSION;
	    if (name === 'nodejs') agent += ' ' + util.engine();
	    return agent;
	  },
	
	  uriEscape: function uriEscape(string) {
	    var output = encodeURIComponent(string);
	    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
	
	    // AWS percent-encodes some extra non-standard characters in a URI
	    output = output.replace(/[*]/g, function(ch) {
	      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
	    });
	
	    return output;
	  },
	
	  uriEscapePath: function uriEscapePath(string) {
	    var parts = [];
	    util.arrayEach(string.split('/'), function (part) {
	      parts.push(util.uriEscape(part));
	    });
	    return parts.join('/');
	  },
	
	  urlParse: function urlParse(url) {
	    return util.url.parse(url);
	  },
	
	  urlFormat: function urlFormat(url) {
	    return util.url.format(url);
	  },
	
	  queryStringParse: function queryStringParse(qs) {
	    return util.querystring.parse(qs);
	  },
	
	  queryParamsToString: function queryParamsToString(params) {
	    var items = [];
	    var escape = util.uriEscape;
	    var sortedKeys = Object.keys(params).sort();
	
	    util.arrayEach(sortedKeys, function(name) {
	      var value = params[name];
	      var ename = escape(name);
	      var result = ename + '=';
	      if (Array.isArray(value)) {
	        var vals = [];
	        util.arrayEach(value, function(item) { vals.push(escape(item)); });
	        result = ename + '=' + vals.sort().join('&' + ename + '=');
	      } else if (value !== undefined && value !== null) {
	        result = ename + '=' + escape(value);
	      }
	      items.push(result);
	    });
	
	    return items.join('&');
	  },
	
	  readFileSync: function readFileSync(path) {
	    if (util.isBrowser()) return null;
	    return __webpack_require__(390).readFileSync(path, 'utf-8');
	  },
	
	  base64: {
	    encode: function encode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 encode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      var buf = util.buffer.toBuffer(string);
	      return buf.toString('base64');
	    },
	
	    decode: function decode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 decode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      return util.buffer.toBuffer(string, 'base64');
	    }
	
	  },
	
	  buffer: {
	    /**
	     * Buffer constructor for Node buffer and buffer pollyfill
	     */
	    toBuffer: function(data, encoding) {
	      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ?
	        util.Buffer.from(data, encoding) : new util.Buffer(data, encoding);
	    },
	
	    alloc: function(size, fill, encoding) {
	      if (typeof size !== 'number') {
	        throw new Error('size passed to alloc must be a number.');
	      }
	      if (typeof util.Buffer.alloc === 'function') {
	        return util.Buffer.alloc(size, fill, encoding);
	      } else {
	        var buf = new util.Buffer(size);
	        if (fill !== undefined && typeof buf.fill === 'function') {
	          buf.fill(fill, undefined, undefined, encoding);
	        }
	        return buf;
	      }
	    },
	
	    toStream: function toStream(buffer) {
	      if (!util.Buffer.isBuffer(buffer)) buffer =  util.buffer.toBuffer(buffer);
	
	      var readable = new (util.stream.Readable)();
	      var pos = 0;
	      readable._read = function(size) {
	        if (pos >= buffer.length) return readable.push(null);
	
	        var end = pos + size;
	        if (end > buffer.length) end = buffer.length;
	        readable.push(buffer.slice(pos, end));
	        pos = end;
	      };
	
	      return readable;
	    },
	
	    /**
	     * Concatenates a list of Buffer objects.
	     */
	    concat: function(buffers) {
	      var length = 0,
	          offset = 0,
	          buffer = null, i;
	
	      for (i = 0; i < buffers.length; i++) {
	        length += buffers[i].length;
	      }
	
	      buffer = util.buffer.alloc(length);
	
	      for (i = 0; i < buffers.length; i++) {
	        buffers[i].copy(buffer, offset);
	        offset += buffers[i].length;
	      }
	
	      return buffer;
	    }
	  },
	
	  string: {
	    byteLength: function byteLength(string) {
	      if (string === null || string === undefined) return 0;
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);
	
	      if (typeof string.byteLength === 'number') {
	        return string.byteLength;
	      } else if (typeof string.length === 'number') {
	        return string.length;
	      } else if (typeof string.size === 'number') {
	        return string.size;
	      } else if (typeof string.path === 'string') {
	        return __webpack_require__(390).lstatSync(string.path).size;
	      } else {
	        throw util.error(new Error('Cannot determine length of ' + string),
	          { object: string });
	      }
	    },
	
	    upperFirst: function upperFirst(string) {
	      return string[0].toUpperCase() + string.substr(1);
	    },
	
	    lowerFirst: function lowerFirst(string) {
	      return string[0].toLowerCase() + string.substr(1);
	    }
	  },
	
	  ini: {
	    parse: function string(ini) {
	      var currentSection, map = {};
	      util.arrayEach(ini.split(/\r?\n/), function(line) {
	        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
	        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
	        if (section) {
	          currentSection = section[1];
	        } else if (currentSection) {
	          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
	          if (item) {
	            map[currentSection] = map[currentSection] || {};
	            map[currentSection][item[1]] = item[2];
	          }
	        }
	      });
	
	      return map;
	    }
	  },
	
	  fn: {
	    noop: function() {},
	    callback: function (err) { if (err) throw err; },
	
	    /**
	     * Turn a synchronous function into as "async" function by making it call
	     * a callback. The underlying function is called with all but the last argument,
	     * which is treated as the callback. The callback is passed passed a first argument
	     * of null on success to mimick standard node callbacks.
	     */
	    makeAsync: function makeAsync(fn, expectedArgs) {
	      if (expectedArgs && expectedArgs <= fn.length) {
	        return fn;
	      }
	
	      return function() {
	        var args = Array.prototype.slice.call(arguments, 0);
	        var callback = args.pop();
	        var result = fn.apply(null, args);
	        callback(result);
	      };
	    }
	  },
	
	  /**
	   * Date and time utility functions.
	   */
	  date: {
	
	    /**
	     * @return [Date] the current JavaScript date object. Since all
	     *   AWS services rely on this date object, you can override
	     *   this function to provide a special time value to AWS service
	     *   requests.
	     */
	    getDate: function getDate() {
	      if (!AWS) AWS = __webpack_require__(4);
	      if (AWS.config.systemClockOffset) { // use offset when non-zero
	        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
	      } else {
	        return new Date();
	      }
	    },
	
	    /**
	     * @return [String] the date in ISO-8601 format
	     */
	    iso8601: function iso8601(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
	    },
	
	    /**
	     * @return [String] the date in RFC 822 format
	     */
	    rfc822: function rfc822(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toUTCString();
	    },
	
	    /**
	     * @return [Integer] the UNIX timestamp value for the current time
	     */
	    unixTimestamp: function unixTimestamp(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.getTime() / 1000;
	    },
	
	    /**
	     * @param [String,number,Date] date
	     * @return [Date]
	     */
	    from: function format(date) {
	      if (typeof date === 'number') {
	        return new Date(date * 1000); // unix timestamp
	      } else {
	        return new Date(date);
	      }
	    },
	
	    /**
	     * Given a Date or date-like value, this function formats the
	     * date into a string of the requested value.
	     * @param [String,number,Date] date
	     * @param [String] formatter Valid formats are:
	     #   * 'iso8601'
	     #   * 'rfc822'
	     #   * 'unixTimestamp'
	     * @return [String]
	     */
	    format: function format(date, formatter) {
	      if (!formatter) formatter = 'iso8601';
	      return util.date[formatter](util.date.from(date));
	    },
	
	    parseTimestamp: function parseTimestamp(value) {
	      if (typeof value === 'number') { // unix timestamp (number)
	        return new Date(value * 1000);
	      } else if (value.match(/^\d+$/)) { // unix timestamp
	        return new Date(value * 1000);
	      } else if (value.match(/^\d{4}/)) { // iso8601
	        return new Date(value);
	      } else if (value.match(/^\w{3},/)) { // rfc822
	        return new Date(value);
	      } else {
	        throw util.error(
	          new Error('unhandled timestamp format: ' + value),
	          {code: 'TimestampParserError'});
	      }
	    }
	
	  },
	
	  crypto: {
	    crc32Table: [
	     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
	     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
	     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
	     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
	     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
	     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
	     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
	     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
	     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
	     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
	     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
	     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
	     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
	     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
	     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
	     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
	     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
	     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
	     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
	     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
	     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
	     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
	     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
	     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
	     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
	     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
	     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
	     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
	     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
	     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
	     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
	     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
	     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
	     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
	     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
	     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
	     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
	     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
	     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
	     0x2D02EF8D],
	
	    crc32: function crc32(data) {
	      var tbl = util.crypto.crc32Table;
	      var crc = 0 ^ -1;
	
	      if (typeof data === 'string') {
	        data = util.buffer.toBuffer(data);
	      }
	
	      for (var i = 0; i < data.length; i++) {
	        var code = data.readUInt8(i);
	        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
	      }
	      return (crc ^ -1) >>> 0;
	    },
	
	    hmac: function hmac(key, string, digest, fn) {
	      if (!digest) digest = 'binary';
	      if (digest === 'buffer') { digest = undefined; }
	      if (!fn) fn = 'sha256';
	      if (typeof string === 'string') string = util.buffer.toBuffer(string);
	      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
	    },
	
	    md5: function md5(data, digest, callback) {
	      return util.crypto.hash('md5', data, digest, callback);
	    },
	
	    sha256: function sha256(data, digest, callback) {
	      return util.crypto.hash('sha256', data, digest, callback);
	    },
	
	    hash: function(algorithm, data, digest, callback) {
	      var hash = util.crypto.createHash(algorithm);
	      if (!digest) { digest = 'binary'; }
	      if (digest === 'buffer') { digest = undefined; }
	      if (typeof data === 'string') data = util.buffer.toBuffer(data);
	      var sliceFn = util.arraySliceFn(data);
	      var isBuffer = util.Buffer.isBuffer(data);
	      //Identifying objects with an ArrayBuffer as buffers
	      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;
	
	      if (callback && typeof data === 'object' &&
	          typeof data.on === 'function' && !isBuffer) {
	        data.on('data', function(chunk) { hash.update(chunk); });
	        data.on('error', function(err) { callback(err); });
	        data.on('end', function() { callback(null, hash.digest(digest)); });
	      } else if (callback && sliceFn && !isBuffer &&
	                 typeof FileReader !== 'undefined') {
	        // this might be a File/Blob
	        var index = 0, size = 1024 * 512;
	        var reader = new FileReader();
	        reader.onerror = function() {
	          callback(new Error('Failed to read data.'));
	        };
	        reader.onload = function() {
	          var buf = new util.Buffer(new Uint8Array(reader.result));
	          hash.update(buf);
	          index += buf.length;
	          reader._continueReading();
	        };
	        reader._continueReading = function() {
	          if (index >= data.size) {
	            callback(null, hash.digest(digest));
	            return;
	          }
	
	          var back = index + size;
	          if (back > data.size) back = data.size;
	          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
	        };
	
	        reader._continueReading();
	      } else {
	        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
	          data = new util.Buffer(new Uint8Array(data));
	        }
	        var out = hash.update(data).digest(digest);
	        if (callback) callback(null, out);
	        return out;
	      }
	    },
	
	    toHex: function toHex(data) {
	      var out = [];
	      for (var i = 0; i < data.length; i++) {
	        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
	      }
	      return out.join('');
	    },
	
	    createHash: function createHash(algorithm) {
	      return util.crypto.lib.createHash(algorithm);
	    }
	
	  },
	
	  /** @!ignore */
	
	  /* Abort constant */
	  abort: {},
	
	  each: function each(object, iterFunction) {
	    for (var key in object) {
	      if (Object.prototype.hasOwnProperty.call(object, key)) {
	        var ret = iterFunction.call(this, key, object[key]);
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  arrayEach: function arrayEach(array, iterFunction) {
	    for (var idx in array) {
	      if (Object.prototype.hasOwnProperty.call(array, idx)) {
	        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  update: function update(obj1, obj2) {
	    util.each(obj2, function iterator(key, item) {
	      obj1[key] = item;
	    });
	    return obj1;
	  },
	
	  merge: function merge(obj1, obj2) {
	    return util.update(util.copy(obj1), obj2);
	  },
	
	  copy: function copy(object) {
	    if (object === null || object === undefined) return object;
	    var dupe = {};
	    // jshint forin:false
	    for (var key in object) {
	      dupe[key] = object[key];
	    }
	    return dupe;
	  },
	
	  isEmpty: function isEmpty(obj) {
	    for (var prop in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
	        return false;
	      }
	    }
	    return true;
	  },
	
	  arraySliceFn: function arraySliceFn(obj) {
	    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
	    return typeof fn === 'function' ? fn : null;
	  },
	
	  isType: function isType(obj, type) {
	    // handle cross-"frame" objects
	    if (typeof type === 'function') type = util.typeName(type);
	    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
	  },
	
	  typeName: function typeName(type) {
	    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
	    var str = type.toString();
	    var match = str.match(/^\s*function (.+)\(/);
	    return match ? match[1] : str;
	  },
	
	  error: function error(err, options) {
	    var originalError = null;
	    if (typeof err.message === 'string' && err.message !== '') {
	      if (typeof options === 'string' || (options && options.message)) {
	        originalError = util.copy(err);
	        originalError.message = err.message;
	      }
	    }
	    err.message = err.message || null;
	
	    if (typeof options === 'string') {
	      err.message = options;
	    } else if (typeof options === 'object' && options !== null) {
	      util.update(err, options);
	      if (options.message)
	        err.message = options.message;
	      if (options.code || options.name)
	        err.code = options.code || options.name;
	      if (options.stack)
	        err.stack = options.stack;
	    }
	
	    if (typeof Object.defineProperty === 'function') {
	      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
	      Object.defineProperty(err, 'message', {enumerable: true});
	    }
	
	    err.name = options && options.name || err.name || err.code || 'Error';
	    err.time = new Date();
	
	    if (originalError) err.originalError = originalError;
	
	    return err;
	  },
	
	  /**
	   * @api private
	   */
	  inherit: function inherit(klass, features) {
	    var newObject = null;
	    if (features === undefined) {
	      features = klass;
	      klass = Object;
	      newObject = {};
	    } else {
	      var ctor = function ConstructorWrapper() {};
	      ctor.prototype = klass.prototype;
	      newObject = new ctor();
	    }
	
	    // constructor not supplied, create pass-through ctor
	    if (features.constructor === Object) {
	      features.constructor = function() {
	        if (klass !== Object) {
	          return klass.apply(this, arguments);
	        }
	      };
	    }
	
	    features.constructor.prototype = newObject;
	    util.update(features.constructor.prototype, features);
	    features.constructor.__super__ = klass;
	    return features.constructor;
	  },
	
	  /**
	   * @api private
	   */
	  mixin: function mixin() {
	    var klass = arguments[0];
	    for (var i = 1; i < arguments.length; i++) {
	      // jshint forin:false
	      for (var prop in arguments[i].prototype) {
	        var fn = arguments[i].prototype[prop];
	        if (prop !== 'constructor') {
	          klass.prototype[prop] = fn;
	        }
	      }
	    }
	    return klass;
	  },
	
	  /**
	   * @api private
	   */
	  hideProperties: function hideProperties(obj, props) {
	    if (typeof Object.defineProperty !== 'function') return;
	
	    util.arrayEach(props, function (key) {
	      Object.defineProperty(obj, key, {
	        enumerable: false, writable: true, configurable: true });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  property: function property(obj, name, value, enumerable, isValue) {
	    var opts = {
	      configurable: true,
	      enumerable: enumerable !== undefined ? enumerable : true
	    };
	    if (typeof value === 'function' && !isValue) {
	      opts.get = value;
	    }
	    else {
	      opts.value = value; opts.writable = true;
	    }
	
	    Object.defineProperty(obj, name, opts);
	  },
	
	  /**
	   * @api private
	   */
	  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
	    var cachedValue = null;
	
	    // build enumerable attribute for each value with lazy accessor.
	    util.property(obj, name, function() {
	      if (cachedValue === null) {
	        cachedValue = get();
	      }
	      return cachedValue;
	    }, enumerable);
	  },
	
	  /**
	   * TODO Remove in major version revision
	   * This backfill populates response data without the
	   * top-level payload name.
	   *
	   * @api private
	   */
	  hoistPayloadMember: function hoistPayloadMember(resp) {
	    var req = resp.request;
	    var operationName = req.operation;
	    var operation = req.service.api.operations[operationName];
	    var output = operation.output;
	    if (output.payload && !operation.hasEventOutput) {
	      var payloadMember = output.members[output.payload];
	      var responsePayload = resp.data[output.payload];
	      if (payloadMember.type === 'structure') {
	        util.each(responsePayload, function(key, value) {
	          util.property(resp.data, key, value, false);
	        });
	      }
	    }
	  },
	
	  /**
	   * Compute SHA-256 checksums of streams
	   *
	   * @api private
	   */
	  computeSha256: function computeSha256(body, done) {
	    if (util.isNode()) {
	      var Stream = util.stream.Stream;
	      var fs = __webpack_require__(390);
	      if (typeof Stream === 'function' && body instanceof Stream) {
	        if (typeof body.path === 'string') { // assume file object
	          var settings = {};
	          if (typeof body.start === 'number') {
	            settings.start = body.start;
	          }
	          if (typeof body.end === 'number') {
	            settings.end = body.end;
	          }
	          body = fs.createReadStream(body.path, settings);
	        } else { // TODO support other stream types
	          return done(new Error('Non-file stream objects are ' +
	                                'not supported with SigV4'));
	        }
	      }
	    }
	
	    util.crypto.sha256(body, 'hex', function(err, sha) {
	      if (err) done(err);
	      else done(null, sha);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(serverTime) {
	    if (serverTime) {
	      util.property(AWS.config, 'isClockSkewed',
	        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
	      return AWS.config.isClockSkewed;
	    }
	  },
	
	  applyClockOffset: function applyClockOffset(serverTime) {
	    if (serverTime)
	      AWS.config.systemClockOffset = serverTime - new Date().getTime();
	  },
	
	  /**
	   * @api private
	   */
	  extractRequestId: function extractRequestId(resp) {
	    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
	                     resp.httpResponse.headers['x-amzn-requestid'];
	
	    if (!requestId && resp.data && resp.data.ResponseMetadata) {
	      requestId = resp.data.ResponseMetadata.RequestId;
	    }
	
	    if (requestId) {
	      resp.requestId = requestId;
	    }
	
	    if (resp.error) {
	      resp.error.requestId = requestId;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  addPromises: function addPromises(constructors, PromiseDependency) {
	    var deletePromises = false;
	    if (PromiseDependency === undefined && AWS && AWS.config) {
	      PromiseDependency = AWS.config.getPromisesDependency();
	    }
	    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
	      PromiseDependency = Promise;
	    }
	    if (typeof PromiseDependency !== 'function') deletePromises = true;
	    if (!Array.isArray(constructors)) constructors = [constructors];
	
	    for (var ind = 0; ind < constructors.length; ind++) {
	      var constructor = constructors[ind];
	      if (deletePromises) {
	        if (constructor.deletePromisesFromClass) {
	          constructor.deletePromisesFromClass();
	        }
	      } else if (constructor.addPromisesToClass) {
	        constructor.addPromisesToClass(PromiseDependency);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
	    return function promise() {
	      var self = this;
	      return new PromiseDependency(function(resolve, reject) {
	        self[methodName](function(err, data) {
	          if (err) {
	            reject(err);
	          } else {
	            resolve(data);
	          }
	        });
	      });
	    };
	  },
	
	  /**
	   * @api private
	   */
	  isDualstackAvailable: function isDualstackAvailable(service) {
	    if (!service) return false;
	    var metadata = __webpack_require__(1787);
	    if (typeof service !== 'string') service = service.serviceIdentifier;
	    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
	    return !!metadata[service].dualstackAvailable;
	  },
	
	  /**
	   * @api private
	   */
	  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
	    if (!retryDelayOptions) retryDelayOptions = {};
	    var customBackoff = retryDelayOptions.customBackoff || null;
	    if (typeof customBackoff === 'function') {
	      return customBackoff(retryCount);
	    }
	    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
	    var delay = Math.random() * (Math.pow(2, retryCount) * base);
	    return delay;
	  },
	
	  /**
	   * @api private
	   */
	  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
	    if (!options) options = {};
	    var http = AWS.HttpClient.getInstance();
	    var httpOptions = options.httpOptions || {};
	    var retryCount = 0;
	
	    var errCallback = function(err) {
	      var maxRetries = options.maxRetries || 0;
	      if (err && err.code === 'TimeoutError') err.retryable = true;
	      if (err && err.retryable && retryCount < maxRetries) {
	        retryCount++;
	        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
	        setTimeout(sendRequest, delay + (err.retryAfter || 0));
	      } else {
	        cb(err);
	      }
	    };
	
	    var sendRequest = function() {
	      var data = '';
	      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
	        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
	        httpResponse.on('end', function() {
	          var statusCode = httpResponse.statusCode;
	          if (statusCode < 300) {
	            cb(null, data);
	          } else {
	            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
	            var err = util.error(new Error(),
	              { retryable: statusCode >= 500 || statusCode === 429 }
	            );
	            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
	            errCallback(err);
	          }
	        });
	      }, errCallback);
	    };
	
	    AWS.util.defer(sendRequest);
	  },
	
	  /**
	   * @api private
	   */
	  uuid: {
	    v4: function uuidV4() {
	      return __webpack_require__(1059).v4();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  convertPayloadToString: function convertPayloadToString(resp) {
	    var req = resp.request;
	    var operation = req.operation;
	    var rules = req.service.api.operations[operation].output || {};
	    if (rules.payload && resp.data[rules.payload]) {
	      resp.data[rules.payload] = resp.data[rules.payload].toString();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  defer: function defer(callback) {
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	      process.nextTick(callback);
	    } else if (typeof setImmediate === 'function') {
	      setImmediate(callback);
	    } else {
	      setTimeout(callback, 0);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getRequestPayloadShape: function getRequestPayloadShape(req) {
	    var operations = req.service.api.operations;
	    if (!operations) return undefined;
	    var operation = (operations || {})[req.operation];
	    if (!operation || !operation.input || !operation.input.payload) return undefined;
	    return operation.input.members[operation.input.payload];
	  },
	
	  /**
	   * @api private
	   */
	  defaultProfile: 'default',
	
	  /**
	   * @api private
	   */
	  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',
	
	  /**
	   * @api private
	   */
	  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',
	
	  /**
	   * @api private
	   */
	  sharedConfigFileEnv: 'AWS_CONFIG_FILE',
	
	  /**
	   * @api private
	   */
	  imdsDisabledEnv: 'AWS_EC2_METADATA_DISABLED'
	};
	
	/**
	 * @api private
	 */
	module.exports = util;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), __webpack_require__(859).setImmediate))

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createReducer = undefined;
	
	var _createReducer = __webpack_require__(1064);
	
	Object.defineProperty(exports, 'createReducer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createReducer).default;
	  }
	});
	
	var _redux = __webpack_require__(265);
	
	var _reactRouterRedux = __webpack_require__(241);
	
	var _reducers = __webpack_require__(1065);
	
	var reducers = _interopRequireWildcard(_reducers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootReducer = (0, _redux.combineReducers)(Object.assign({}, reducers, { routing: _reactRouterRedux.routerReducer }));
	
	exports.default = rootReducer;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var DOMProperty = __webpack_require__(146);
	var ReactDOMComponentFlags = __webpack_require__(746);
	
	var invariant = __webpack_require__(14);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logPageView = exports.initGA = undefined;
	
	var _reactGa = __webpack_require__(2315);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initGA = exports.initGA = function initGA() {
	  _reactGa2.default.initialize('UA-106192702-1');
	};
	var logPageView = exports.logPageView = function logPageView(path) {
	  _reactGa2.default.set({ page: path });
	  _reactGa2.default.pageview(path);
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SESSION_VALID = exports.SESSION_VALID = 'SESSION_VALID';
	var SESSION_LOGOUT = exports.SESSION_LOGOUT = 'SESSION_LOGOUT';
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = 'LOCATION_CHANGE';

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(102);
	var _isTransformer = __webpack_require__(336);
	
	
	/**
	 * Returns a function that dispatches with different strategies based on the
	 * object in list position (last argument). If it is an array, executes [fn].
	 * Otherwise, if it has a function with one of the given method names, it will
	 * execute that function (functor case). Otherwise, if it is a transformer,
	 * uses transducer [xf] to return a new transformer (transducer case).
	 * Otherwise, it will default to executing [fn].
	 *
	 * @private
	 * @param {Array} methodNames properties to check for a custom implementation
	 * @param {Function} xf transducer to initialize if object is transformer
	 * @param {Function} fn default ramda implementation
	 * @return {Function} A function that dispatches on object in list position
	 */
	module.exports = function _dispatchable(methodNames, xf, fn) {
	  return function() {
	    if (arguments.length === 0) {
	      return fn();
	    }
	    var args = Array.prototype.slice.call(arguments, 0);
	    var obj = args.pop();
	    if (!_isArray(obj)) {
	      var idx = 0;
	      while (idx < methodNames.length) {
	        if (typeof obj[methodNames[idx]] === 'function') {
	          return obj[methodNames[idx]].apply(obj, args);
	        }
	        idx += 1;
	      }
	      if (_isTransformer(obj)) {
	        var transducer = xf.apply(null, args);
	        return transducer(obj);
	      }
	    }
	    return fn.apply(this, arguments);
	  };
	};


/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/* eslint guard-for-in:0 */
	var AWS;
	
	/**
	 * A set of utility methods for use with the AWS SDK.
	 *
	 * @!attribute abort
	 *   Return this value from an iterator function {each} or {arrayEach}
	 *   to break out of the iteration.
	 *   @example Breaking out of an iterator function
	 *     AWS.util.each({a: 1, b: 2, c: 3}, function(key, value) {
	 *       if (key == 'b') return AWS.util.abort;
	 *     });
	 *   @see each
	 *   @see arrayEach
	 * @api private
	 */
	var util = {
	  environment: 'nodejs',
	  engine: function engine() {
	    if (util.isBrowser() && typeof navigator !== 'undefined') {
	      return navigator.userAgent;
	    } else {
	      var engine = process.platform + '/' + process.version;
	      if (({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}).AWS_EXECUTION_ENV) {
	        engine += ' exec-env/' + ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}).AWS_EXECUTION_ENV;
	      }
	      return engine;
	    }
	  },
	
	  userAgent: function userAgent() {
	    var name = util.environment;
	    var agent = 'aws-sdk-' + name + '/' + __webpack_require__(15).VERSION;
	    if (name === 'nodejs') agent += ' ' + util.engine();
	    return agent;
	  },
	
	  isBrowser: function isBrowser() { return process && process.browser; },
	  isNode: function isNode() { return !util.isBrowser(); },
	  uriEscape: function uriEscape(string) {
	    var output = encodeURIComponent(string);
	    output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
	
	    // AWS percent-encodes some extra non-standard characters in a URI
	    output = output.replace(/[*]/g, function(ch) {
	      return '%' + ch.charCodeAt(0).toString(16).toUpperCase();
	    });
	
	    return output;
	  },
	
	  uriEscapePath: function uriEscapePath(string) {
	    var parts = [];
	    util.arrayEach(string.split('/'), function (part) {
	      parts.push(util.uriEscape(part));
	    });
	    return parts.join('/');
	  },
	
	  urlParse: function urlParse(url) {
	    return util.url.parse(url);
	  },
	
	  urlFormat: function urlFormat(url) {
	    return util.url.format(url);
	  },
	
	  queryStringParse: function queryStringParse(qs) {
	    return util.querystring.parse(qs);
	  },
	
	  queryParamsToString: function queryParamsToString(params) {
	    var items = [];
	    var escape = util.uriEscape;
	    var sortedKeys = Object.keys(params).sort();
	
	    util.arrayEach(sortedKeys, function(name) {
	      var value = params[name];
	      var ename = escape(name);
	      var result = ename + '=';
	      if (Array.isArray(value)) {
	        var vals = [];
	        util.arrayEach(value, function(item) { vals.push(escape(item)); });
	        result = ename + '=' + vals.sort().join('&' + ename + '=');
	      } else if (value !== undefined && value !== null) {
	        result = ename + '=' + escape(value);
	      }
	      items.push(result);
	    });
	
	    return items.join('&');
	  },
	
	  readFileSync: function readFileSync(path) {
	    if (util.isBrowser()) return null;
	    return __webpack_require__(389).readFileSync(path, 'utf-8');
	  },
	
	  base64: {
	    encode: function encode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 encode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      var buf = (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string) : new util.Buffer(string);
	      return buf.toString('base64');
	    },
	
	    decode: function decode64(string) {
	      if (typeof string === 'number') {
	        throw util.error(new Error('Cannot base64 decode number ' + string));
	      }
	      if (string === null || typeof string === 'undefined') {
	        return string;
	      }
	      return (typeof util.Buffer.from === 'function' && util.Buffer.from !== Uint8Array.from) ? util.Buffer.from(string, 'base64') : new util.Buffer(string, 'base64');
	    }
	
	  },
	
	  buffer: {
	    toStream: function toStream(buffer) {
	      if (!util.Buffer.isBuffer(buffer)) buffer = new util.Buffer(buffer);
	
	      var readable = new (util.stream.Readable)();
	      var pos = 0;
	      readable._read = function(size) {
	        if (pos >= buffer.length) return readable.push(null);
	
	        var end = pos + size;
	        if (end > buffer.length) end = buffer.length;
	        readable.push(buffer.slice(pos, end));
	        pos = end;
	      };
	
	      return readable;
	    },
	
	    /**
	     * Concatenates a list of Buffer objects.
	     */
	    concat: function(buffers) {
	      var length = 0,
	          offset = 0,
	          buffer = null, i;
	
	      for (i = 0; i < buffers.length; i++) {
	        length += buffers[i].length;
	      }
	
	      buffer = new util.Buffer(length);
	
	      for (i = 0; i < buffers.length; i++) {
	        buffers[i].copy(buffer, offset);
	        offset += buffers[i].length;
	      }
	
	      return buffer;
	    }
	  },
	
	  string: {
	    byteLength: function byteLength(string) {
	      if (string === null || string === undefined) return 0;
	      if (typeof string === 'string') string = new util.Buffer(string);
	
	      if (typeof string.byteLength === 'number') {
	        return string.byteLength;
	      } else if (typeof string.length === 'number') {
	        return string.length;
	      } else if (typeof string.size === 'number') {
	        return string.size;
	      } else if (typeof string.path === 'string') {
	        return __webpack_require__(389).lstatSync(string.path).size;
	      } else {
	        throw util.error(new Error('Cannot determine length of ' + string),
	          { object: string });
	      }
	    },
	
	    upperFirst: function upperFirst(string) {
	      return string[0].toUpperCase() + string.substr(1);
	    },
	
	    lowerFirst: function lowerFirst(string) {
	      return string[0].toLowerCase() + string.substr(1);
	    }
	  },
	
	  ini: {
	    parse: function string(ini) {
	      var currentSection, map = {};
	      util.arrayEach(ini.split(/\r?\n/), function(line) {
	        line = line.split(/(^|\s)[;#]/)[0]; // remove comments
	        var section = line.match(/^\s*\[([^\[\]]+)\]\s*$/);
	        if (section) {
	          currentSection = section[1];
	        } else if (currentSection) {
	          var item = line.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
	          if (item) {
	            map[currentSection] = map[currentSection] || {};
	            map[currentSection][item[1]] = item[2];
	          }
	        }
	      });
	
	      return map;
	    }
	  },
	
	  fn: {
	    noop: function() {},
	
	    /**
	     * Turn a synchronous function into as "async" function by making it call
	     * a callback. The underlying function is called with all but the last argument,
	     * which is treated as the callback. The callback is passed passed a first argument
	     * of null on success to mimick standard node callbacks.
	     */
	    makeAsync: function makeAsync(fn, expectedArgs) {
	      if (expectedArgs && expectedArgs <= fn.length) {
	        return fn;
	      }
	
	      return function() {
	        var args = Array.prototype.slice.call(arguments, 0);
	        var callback = args.pop();
	        var result = fn.apply(null, args);
	        callback(result);
	      };
	    }
	  },
	
	  /**
	   * Date and time utility functions.
	   */
	  date: {
	
	    /**
	     * @return [Date] the current JavaScript date object. Since all
	     *   AWS services rely on this date object, you can override
	     *   this function to provide a special time value to AWS service
	     *   requests.
	     */
	    getDate: function getDate() {
	      if (!AWS) AWS = __webpack_require__(15);
	      if (AWS.config.systemClockOffset) { // use offset when non-zero
	        return new Date(new Date().getTime() + AWS.config.systemClockOffset);
	      } else {
	        return new Date();
	      }
	    },
	
	    /**
	     * @return [String] the date in ISO-8601 format
	     */
	    iso8601: function iso8601(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
	    },
	
	    /**
	     * @return [String] the date in RFC 822 format
	     */
	    rfc822: function rfc822(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.toUTCString();
	    },
	
	    /**
	     * @return [Integer] the UNIX timestamp value for the current time
	     */
	    unixTimestamp: function unixTimestamp(date) {
	      if (date === undefined) { date = util.date.getDate(); }
	      return date.getTime() / 1000;
	    },
	
	    /**
	     * @param [String,number,Date] date
	     * @return [Date]
	     */
	    from: function format(date) {
	      if (typeof date === 'number') {
	        return new Date(date * 1000); // unix timestamp
	      } else {
	        return new Date(date);
	      }
	    },
	
	    /**
	     * Given a Date or date-like value, this function formats the
	     * date into a string of the requested value.
	     * @param [String,number,Date] date
	     * @param [String] formatter Valid formats are:
	     #   * 'iso8601'
	     #   * 'rfc822'
	     #   * 'unixTimestamp'
	     * @return [String]
	     */
	    format: function format(date, formatter) {
	      if (!formatter) formatter = 'iso8601';
	      return util.date[formatter](util.date.from(date));
	    },
	
	    parseTimestamp: function parseTimestamp(value) {
	      if (typeof value === 'number') { // unix timestamp (number)
	        return new Date(value * 1000);
	      } else if (value.match(/^\d+$/)) { // unix timestamp
	        return new Date(value * 1000);
	      } else if (value.match(/^\d{4}/)) { // iso8601
	        return new Date(value);
	      } else if (value.match(/^\w{3},/)) { // rfc822
	        return new Date(value);
	      } else {
	        throw util.error(
	          new Error('unhandled timestamp format: ' + value),
	          {code: 'TimestampParserError'});
	      }
	    }
	
	  },
	
	  crypto: {
	    crc32Table: [
	     0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419,
	     0x706AF48F, 0xE963A535, 0x9E6495A3, 0x0EDB8832, 0x79DCB8A4,
	     0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07,
	     0x90BF1D91, 0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	     0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7, 0x136C9856,
	     0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9,
	     0xFA0F3D63, 0x8D080DF5, 0x3B6E20C8, 0x4C69105E, 0xD56041E4,
	     0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3,
	     0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 0x26D930AC, 0x51DE003A,
	     0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599,
	     0xB8BDA50F, 0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	     0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D, 0x76DC4190,
	     0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F,
	     0x9FBFE4A5, 0xE8B8D433, 0x7807C9A2, 0x0F00F934, 0x9609A88E,
	     0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED,
	     0x1B01A57B, 0x8208F4C1, 0xF50FC457, 0x65B0D9C6, 0x12B7E950,
	     0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3,
	     0xFBD44C65, 0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	     0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 0x4369E96A,
	     0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5,
	     0xAA0A4C5F, 0xDD0D7CC9, 0x5005713C, 0x270241AA, 0xBE0B1010,
	     0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17,
	     0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 0xEDB88320, 0x9ABFB3B6,
	     0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615,
	     0x73DC1683, 0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	     0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 0xF00F9344,
	     0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB,
	     0x196C3671, 0x6E6B06E7, 0xFED41B76, 0x89D32BE0, 0x10DA7A5A,
	     0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1,
	     0xA6BC5767, 0x3FB506DD, 0x48B2364B, 0xD80D2BDA, 0xAF0A1B4C,
	     0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF,
	     0x4669BE79, 0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	     0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 0xC5BA3BBE,
	     0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31,
	     0x2CD99E8B, 0x5BDEAE1D, 0x9B64C2B0, 0xEC63F226, 0x756AA39C,
	     0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B,
	     0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 0x86D3D2D4, 0xF1D4E242,
	     0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1,
	     0x18B74777, 0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	     0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 0xA00AE278,
	     0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7,
	     0x4969474D, 0x3E6E77DB, 0xAED16A4A, 0xD9D65ADC, 0x40DF0B66,
	     0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605,
	     0xCDD70693, 0x54DE5729, 0x23D967BF, 0xB3667A2E, 0xC4614AB8,
	     0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B,
	     0x2D02EF8D],
	
	    crc32: function crc32(data) {
	      var tbl = util.crypto.crc32Table;
	      var crc = 0 ^ -1;
	
	      if (typeof data === 'string') {
	        data = new util.Buffer(data);
	      }
	
	      for (var i = 0; i < data.length; i++) {
	        var code = data.readUInt8(i);
	        crc = (crc >>> 8) ^ tbl[(crc ^ code) & 0xFF];
	      }
	      return (crc ^ -1) >>> 0;
	    },
	
	    hmac: function hmac(key, string, digest, fn) {
	      if (!digest) digest = 'binary';
	      if (digest === 'buffer') { digest = undefined; }
	      if (!fn) fn = 'sha256';
	      if (typeof string === 'string') string = new util.Buffer(string);
	      return util.crypto.lib.createHmac(fn, key).update(string).digest(digest);
	    },
	
	    md5: function md5(data, digest, callback) {
	      return util.crypto.hash('md5', data, digest, callback);
	    },
	
	    sha256: function sha256(data, digest, callback) {
	      return util.crypto.hash('sha256', data, digest, callback);
	    },
	
	    hash: function(algorithm, data, digest, callback) {
	      var hash = util.crypto.createHash(algorithm);
	      if (!digest) { digest = 'binary'; }
	      if (digest === 'buffer') { digest = undefined; }
	      if (typeof data === 'string') data = new util.Buffer(data);
	      var sliceFn = util.arraySliceFn(data);
	      var isBuffer = util.Buffer.isBuffer(data);
	      //Identifying objects with an ArrayBuffer as buffers
	      if (util.isBrowser() && typeof ArrayBuffer !== 'undefined' && data && data.buffer instanceof ArrayBuffer) isBuffer = true;
	
	      if (callback && typeof data === 'object' &&
	          typeof data.on === 'function' && !isBuffer) {
	        data.on('data', function(chunk) { hash.update(chunk); });
	        data.on('error', function(err) { callback(err); });
	        data.on('end', function() { callback(null, hash.digest(digest)); });
	      } else if (callback && sliceFn && !isBuffer &&
	                 typeof FileReader !== 'undefined') {
	        // this might be a File/Blob
	        var index = 0, size = 1024 * 512;
	        var reader = new FileReader();
	        reader.onerror = function() {
	          callback(new Error('Failed to read data.'));
	        };
	        reader.onload = function() {
	          var buf = new util.Buffer(new Uint8Array(reader.result));
	          hash.update(buf);
	          index += buf.length;
	          reader._continueReading();
	        };
	        reader._continueReading = function() {
	          if (index >= data.size) {
	            callback(null, hash.digest(digest));
	            return;
	          }
	
	          var back = index + size;
	          if (back > data.size) back = data.size;
	          reader.readAsArrayBuffer(sliceFn.call(data, index, back));
	        };
	
	        reader._continueReading();
	      } else {
	        if (util.isBrowser() && typeof data === 'object' && !isBuffer) {
	          data = new util.Buffer(new Uint8Array(data));
	        }
	        var out = hash.update(data).digest(digest);
	        if (callback) callback(null, out);
	        return out;
	      }
	    },
	
	    toHex: function toHex(data) {
	      var out = [];
	      for (var i = 0; i < data.length; i++) {
	        out.push(('0' + data.charCodeAt(i).toString(16)).substr(-2, 2));
	      }
	      return out.join('');
	    },
	
	    createHash: function createHash(algorithm) {
	      return util.crypto.lib.createHash(algorithm);
	    }
	
	  },
	
	  /** @!ignore */
	
	  /* Abort constant */
	  abort: {},
	
	  each: function each(object, iterFunction) {
	    for (var key in object) {
	      if (Object.prototype.hasOwnProperty.call(object, key)) {
	        var ret = iterFunction.call(this, key, object[key]);
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  arrayEach: function arrayEach(array, iterFunction) {
	    for (var idx in array) {
	      if (Object.prototype.hasOwnProperty.call(array, idx)) {
	        var ret = iterFunction.call(this, array[idx], parseInt(idx, 10));
	        if (ret === util.abort) break;
	      }
	    }
	  },
	
	  update: function update(obj1, obj2) {
	    util.each(obj2, function iterator(key, item) {
	      obj1[key] = item;
	    });
	    return obj1;
	  },
	
	  merge: function merge(obj1, obj2) {
	    return util.update(util.copy(obj1), obj2);
	  },
	
	  copy: function copy(object) {
	    if (object === null || object === undefined) return object;
	    var dupe = {};
	    // jshint forin:false
	    for (var key in object) {
	      dupe[key] = object[key];
	    }
	    return dupe;
	  },
	
	  isEmpty: function isEmpty(obj) {
	    for (var prop in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
	        return false;
	      }
	    }
	    return true;
	  },
	
	  arraySliceFn: function arraySliceFn(obj) {
	    var fn = obj.slice || obj.webkitSlice || obj.mozSlice;
	    return typeof fn === 'function' ? fn : null;
	  },
	
	  isType: function isType(obj, type) {
	    // handle cross-"frame" objects
	    if (typeof type === 'function') type = util.typeName(type);
	    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
	  },
	
	  typeName: function typeName(type) {
	    if (Object.prototype.hasOwnProperty.call(type, 'name')) return type.name;
	    var str = type.toString();
	    var match = str.match(/^\s*function (.+)\(/);
	    return match ? match[1] : str;
	  },
	
	  error: function error(err, options) {
	    var originalError = null;
	    if (typeof err.message === 'string' && err.message !== '') {
	      if (typeof options === 'string' || (options && options.message)) {
	        originalError = util.copy(err);
	        originalError.message = err.message;
	      }
	    }
	    err.message = err.message || null;
	
	    if (typeof options === 'string') {
	      err.message = options;
	    } else if (typeof options === 'object' && options !== null) {
	      util.update(err, options);
	      if (options.message)
	        err.message = options.message;
	      if (options.code || options.name)
	        err.code = options.code || options.name;
	      if (options.stack)
	        err.stack = options.stack;
	    }
	
	    if (typeof Object.defineProperty === 'function') {
	      Object.defineProperty(err, 'name', {writable: true, enumerable: false});
	      Object.defineProperty(err, 'message', {enumerable: true});
	    }
	
	    err.name = options && options.name || err.name || err.code || 'Error';
	    err.time = new Date();
	
	    if (originalError) err.originalError = originalError;
	
	    return err;
	  },
	
	  /**
	   * @api private
	   */
	  inherit: function inherit(klass, features) {
	    var newObject = null;
	    if (features === undefined) {
	      features = klass;
	      klass = Object;
	      newObject = {};
	    } else {
	      var ctor = function ConstructorWrapper() {};
	      ctor.prototype = klass.prototype;
	      newObject = new ctor();
	    }
	
	    // constructor not supplied, create pass-through ctor
	    if (features.constructor === Object) {
	      features.constructor = function() {
	        if (klass !== Object) {
	          return klass.apply(this, arguments);
	        }
	      };
	    }
	
	    features.constructor.prototype = newObject;
	    util.update(features.constructor.prototype, features);
	    features.constructor.__super__ = klass;
	    return features.constructor;
	  },
	
	  /**
	   * @api private
	   */
	  mixin: function mixin() {
	    var klass = arguments[0];
	    for (var i = 1; i < arguments.length; i++) {
	      // jshint forin:false
	      for (var prop in arguments[i].prototype) {
	        var fn = arguments[i].prototype[prop];
	        if (prop !== 'constructor') {
	          klass.prototype[prop] = fn;
	        }
	      }
	    }
	    return klass;
	  },
	
	  /**
	   * @api private
	   */
	  hideProperties: function hideProperties(obj, props) {
	    if (typeof Object.defineProperty !== 'function') return;
	
	    util.arrayEach(props, function (key) {
	      Object.defineProperty(obj, key, {
	        enumerable: false, writable: true, configurable: true });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  property: function property(obj, name, value, enumerable, isValue) {
	    var opts = {
	      configurable: true,
	      enumerable: enumerable !== undefined ? enumerable : true
	    };
	    if (typeof value === 'function' && !isValue) {
	      opts.get = value;
	    }
	    else {
	      opts.value = value; opts.writable = true;
	    }
	
	    Object.defineProperty(obj, name, opts);
	  },
	
	  /**
	   * @api private
	   */
	  memoizedProperty: function memoizedProperty(obj, name, get, enumerable) {
	    var cachedValue = null;
	
	    // build enumerable attribute for each value with lazy accessor.
	    util.property(obj, name, function() {
	      if (cachedValue === null) {
	        cachedValue = get();
	      }
	      return cachedValue;
	    }, enumerable);
	  },
	
	  /**
	   * TODO Remove in major version revision
	   * This backfill populates response data without the
	   * top-level payload name.
	   *
	   * @api private
	   */
	  hoistPayloadMember: function hoistPayloadMember(resp) {
	    var req = resp.request;
	    var operation = req.operation;
	    var output = req.service.api.operations[operation].output;
	    if (output.payload) {
	      var payloadMember = output.members[output.payload];
	      var responsePayload = resp.data[output.payload];
	      if (payloadMember.type === 'structure') {
	        util.each(responsePayload, function(key, value) {
	          util.property(resp.data, key, value, false);
	        });
	      }
	    }
	  },
	
	  /**
	   * Compute SHA-256 checksums of streams
	   *
	   * @api private
	   */
	  computeSha256: function computeSha256(body, done) {
	    if (util.isNode()) {
	      var Stream = util.stream.Stream;
	      var fs = __webpack_require__(389);
	      if (body instanceof Stream) {
	        if (typeof body.path === 'string') { // assume file object
	          var settings = {};
	          if (typeof body.start === 'number') {
	            settings.start = body.start;
	          }
	          if (typeof body.end === 'number') {
	            settings.end = body.end;
	          }
	          body = fs.createReadStream(body.path, settings);
	        } else { // TODO support other stream types
	          return done(new Error('Non-file stream objects are ' +
	                                'not supported with SigV4'));
	        }
	      }
	    }
	
	    util.crypto.sha256(body, 'hex', function(err, sha) {
	      if (err) done(err);
	      else done(null, sha);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(serverTime) {
	    if (serverTime) {
	      util.property(AWS.config, 'isClockSkewed',
	        Math.abs(new Date().getTime() - serverTime) >= 300000, false);
	      return AWS.config.isClockSkewed;
	    }
	  },
	
	  applyClockOffset: function applyClockOffset(serverTime) {
	    if (serverTime)
	      AWS.config.systemClockOffset = serverTime - new Date().getTime();
	  },
	
	  /**
	   * @api private
	   */
	  extractRequestId: function extractRequestId(resp) {
	    var requestId = resp.httpResponse.headers['x-amz-request-id'] ||
	                     resp.httpResponse.headers['x-amzn-requestid'];
	
	    if (!requestId && resp.data && resp.data.ResponseMetadata) {
	      requestId = resp.data.ResponseMetadata.RequestId;
	    }
	
	    if (requestId) {
	      resp.requestId = requestId;
	    }
	
	    if (resp.error) {
	      resp.error.requestId = requestId;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  addPromises: function addPromises(constructors, PromiseDependency) {
	    if (PromiseDependency === undefined && AWS && AWS.config) {
	      PromiseDependency = AWS.config.getPromisesDependency();
	    }
	    if (PromiseDependency === undefined && typeof Promise !== 'undefined') {
	      PromiseDependency = Promise;
	    }
	    if (typeof PromiseDependency !== 'function') var deletePromises = true;
	    if (!Array.isArray(constructors)) constructors = [constructors];
	
	    for (var ind = 0; ind < constructors.length; ind++) {
	      var constructor = constructors[ind];
	      if (deletePromises) {
	        if (constructor.deletePromisesFromClass) {
	          constructor.deletePromisesFromClass();
	        }
	      } else if (constructor.addPromisesToClass) {
	        constructor.addPromisesToClass(PromiseDependency);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  promisifyMethod: function promisifyMethod(methodName, PromiseDependency) {
	    return function promise() {
	      var self = this;
	      return new PromiseDependency(function(resolve, reject) {
	        self[methodName](function(err, data) {
	          if (err) {
	            reject(err);
	          } else {
	            resolve(data);
	          }
	        });
	      });
	    };
	  },
	
	  /**
	   * @api private
	   */
	  isDualstackAvailable: function isDualstackAvailable(service) {
	    if (!service) return false;
	    var metadata = __webpack_require__(1644);
	    if (typeof service !== 'string') service = service.serviceIdentifier;
	    if (typeof service !== 'string' || !metadata.hasOwnProperty(service)) return false;
	    return !!metadata[service].dualstackAvailable;
	  },
	
	  /**
	   * @api private
	   */
	  calculateRetryDelay: function calculateRetryDelay(retryCount, retryDelayOptions) {
	    if (!retryDelayOptions) retryDelayOptions = {};
	    var customBackoff = retryDelayOptions.customBackoff || null;
	    if (typeof customBackoff === 'function') {
	      return customBackoff(retryCount);
	    }
	    var base = typeof retryDelayOptions.base === 'number' ? retryDelayOptions.base : 100;
	    var delay = Math.random() * (Math.pow(2, retryCount) * base);
	    return delay;
	  },
	
	  /**
	   * @api private
	   */
	  handleRequestWithRetries: function handleRequestWithRetries(httpRequest, options, cb) {
	    if (!options) options = {};
	    var http = AWS.HttpClient.getInstance();
	    var httpOptions = options.httpOptions || {};
	    var retryCount = 0;
	
	    var errCallback = function(err) {
	      var maxRetries = options.maxRetries || 0;
	      if (err && err.code === 'TimeoutError') err.retryable = true;
	      if (err && err.retryable && retryCount < maxRetries) {
	        retryCount++;
	        var delay = util.calculateRetryDelay(retryCount, options.retryDelayOptions);
	        setTimeout(sendRequest, delay + (err.retryAfter || 0));
	      } else {
	        cb(err);
	      }
	    };
	
	    var sendRequest = function() {
	      var data = '';
	      http.handleRequest(httpRequest, httpOptions, function(httpResponse) {
	        httpResponse.on('data', function(chunk) { data += chunk.toString(); });
	        httpResponse.on('end', function() {
	          var statusCode = httpResponse.statusCode;
	          if (statusCode < 300) {
	            cb(null, data);
	          } else {
	            var retryAfter = parseInt(httpResponse.headers['retry-after'], 10) * 1000 || 0;
	            var err = util.error(new Error(),
	              { retryable: statusCode >= 500 || statusCode === 429 }
	            );
	            if (retryAfter && err.retryable) err.retryAfter = retryAfter;
	            errCallback(err);
	          }
	        });
	      }, errCallback);
	    };
	
	    AWS.util.defer(sendRequest);
	  },
	
	  /**
	   * @api private
	   */
	  uuid: {
	    v4: function uuidV4() {
	      return __webpack_require__(909).v4();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  convertPayloadToString: function convertPayloadToString(resp) {
	    var req = resp.request;
	    var operation = req.operation;
	    var rules = req.service.api.operations[operation].output || {};
	    if (rules.payload && resp.data[rules.payload]) {
	      resp.data[rules.payload] = resp.data[rules.payload].toString();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  defer: function defer(callback) {
	    if (typeof process === 'object' && typeof process.nextTick === 'function') {
	      process.nextTick(callback);
	    } else if (typeof setImmediate === 'function') {
	      setImmediate(callback);
	    } else {
	      setTimeout(callback, 0);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  defaultProfile: 'default',
	
	  /**
	   * @api private
	   */
	  configOptInEnv: 'AWS_SDK_LOAD_CONFIG',
	
	  /**
	   * @api private
	   */
	  sharedCredentialsFileEnv: 'AWS_SHARED_CREDENTIALS_FILE',
	
	  /**
	   * @api private
	   */
	  sharedConfigFileEnv: 'AWS_CONFIG_FILE'
	};
	
	module.exports = util;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), __webpack_require__(859).setImmediate))

/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = {
	  init: function() {
	    return this.xf['@@transducer/init']();
	  },
	  result: function(result) {
	    return this.xf['@@transducer/result'](result);
	  }
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MiniFooter = __webpack_require__(1157);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MiniFooter2.default;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FontIcon = function FontIcon(_ref) {
	  var alt = _ref.alt,
	      children = _ref.children,
	      className = _ref.className,
	      theme = _ref.theme,
	      value = _ref.value,
	      other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'theme', 'value']);
	
	  return (// eslint-disable-line
	    _react2.default.createElement(
	      'span',
	      _extends({
	        'data-react-toolbox': 'font-icon',
	        'aria-label': alt,
	        className: (0, _classnames2.default)({ 'material-icons': typeof value === 'string' || typeof children === 'string' }, className)
	      }, other),
	      value,
	      children
	    )
	  );
	};
	
	FontIcon.propTypes = {
	  alt: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  theme: _propTypes2.default.object, // eslint-disable-line
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
	};
	
	FontIcon.defaultProps = {
	  alt: '',
	  className: ''
	};
	
	exports.default = FontIcon;
	exports.FontIcon = FontIcon;

/***/ },
/* 46 */
[2578, 262, 186, 71],
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actSuggestions = exports.actSuggestions = {
	  16: '16 or lower',
	  17: '17',
	  18: '18',
	  19: '19',
	  20: '20',
	  21: '21',
	  22: '22',
	  23: '23',
	  24: '24',
	  25: '25',
	  26: '26',
	  27: '27',
	  28: '28',
	  29: '29',
	  30: '30',
	  31: '31',
	  32: '32',
	  33: '33',
	  34: '34',
	  35: '35',
	  36: '36'
	};
	
	var states = exports.states = {
	  AL: 'Alabama',
	  AK: 'Alaska',
	  AZ: 'Arizona',
	  AR: 'Arkansas',
	  CA: 'California',
	  CO: 'Colorado',
	  CT: 'Connecticut',
	  DE: 'Delaware',
	  FL: 'Florida',
	  GA: 'Georgia',
	  HI: 'Hawaii',
	  ID: 'Idaho',
	  IL: 'Illinois',
	  IN: 'Indiana',
	  IA: 'Iowa',
	  KS: 'Kansas',
	  KY: 'Kentucky',
	  LA: 'Louisiana',
	  ME: 'Maine',
	  MD: 'Maryland',
	  MA: 'Massachusetts',
	  MI: 'Michigan',
	  MN: 'Minnesota',
	  MS: 'Mississippi',
	  MO: 'Missouri',
	  MT: 'Montana',
	  NE: 'Nebraska',
	  NV: 'Nevada',
	  NH: 'New Hampshire',
	  NJ: 'New Jersey',
	  NM: 'New Mexico',
	  NY: 'New York',
	  NC: 'North Carolina',
	  ND: 'North Dakota',
	  OH: 'Ohio',
	  OK: 'Oklahoma',
	  OR: 'Oregon',
	  PA: 'Pennsylvania',
	  RI: 'Rhode Island',
	  SC: 'South Carolina',
	  SD: 'South Dakota',
	  TN: 'Tennessee',
	  TX: 'Texas',
	  UT: 'Utah',
	  VT: 'Vermont',
	  VA: 'Virginia',
	  WA: 'Washington D.C',
	  WN: 'Washington',
	  WV: 'West Virginia',
	  WI: 'Wisconsin',
	  WY: 'Wyoming'
	};
	
	var statesArray = exports.statesArray = ['All States', 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington D.C', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
	
	var positions = exports.positions = {
	  QBDT: 'Quarterback - Duel Threat',
	  QBPS: 'Quarterback - Pro Style',
	  WR: 'Wide Receiver',
	  SR: 'Slot Receiver',
	  RB: 'Running Back',
	  FB: 'Full Back',
	  HB: 'H-Back',
	  TE: 'Tight End',
	  OG: 'Offensive Guard',
	  OT: 'Offensive Tackle',
	  C: 'Center',
	  DT: 'Defensive Tackle',
	  DE: 'Defensive End',
	  ML: 'Middle Linebacker',
	  OL: 'Outside Linebacker',
	  DB: 'Cornerback',
	  SS: 'Strong Safety',
	  FS: 'Free Safety',
	  K: 'Kicker',
	  P: 'Punter',
	  LS: 'Long Snapper'
	};
	
	var positionsArray = exports.positionsArray = ['All Positions', 'Quarterback - Duel Threat', 'Quarterback - Pro Style', 'Wide Receiver', 'Slot Receiver', 'Running Back', 'Full Back', 'H-Back', 'Tight End', 'Offensive Guard', 'Offensive Tackle', 'Center', 'Defensive Tackle', 'Defensive End', 'Middle Linebacker', 'Outside Linebacker', 'Cornerback', 'Strong Safety', 'Free Safety', 'Kicker', 'Punter', 'Long Snapper'];
	
	var offensivePositions = exports.offensivePositions = {
	  QBDT: 'Quarterback - Duel Threat',
	  QBPS: 'Quarterback - Pro Style',
	  WR: 'Wide Receiver',
	  SR: 'Slot Receiver',
	  RB: 'Running Back',
	  FB: 'Full Back',
	  HB: 'H-Back',
	  TE: 'Tight End',
	  OG: 'Offensive Guard',
	  OT: 'Offensive Tackle',
	  C: 'Center'
	};
	
	var defensivePositions = exports.defensivePositions = {
	  DT: 'Defensive Tackle',
	  DE: 'Defensive End',
	  ML: 'Middle Linebacker',
	  OL: 'Outside Linebacker',
	  DB: 'Cornerback',
	  SS: 'Strong Safety',
	  FS: 'Free Safety'
	
	};
	
	var specialTeamsPositions = exports.specialTeamsPositions = {
	  K: 'Kicker',
	  P: 'Punter',
	  LS: 'Long Snapper'
	};
	
	var positionNames = exports.positionNames = {
	  QBDT: 'primary_offensive_position_pref',
	  QBPS: 'primary_offensive_position_pref',
	  WR: 'primary_offensive_position_pref',
	  SR: 'primary_offensive_position_pref',
	  RB: 'primary_offensive_position_pref',
	  FB: 'primary_offensive_position_pref',
	  HB: 'primary_offensive_position_pref',
	  TE: 'primary_offensive_position_pref',
	  OG: 'primary_offensive_position_pref',
	  OT: 'primary_offensive_position_pref',
	  C: 'primary_offensive_position_pref',
	  DT: 'primary_defensive_position_pref',
	  DE: 'primary_defensive_position_pref',
	  ML: 'primary_defensive_position_pref',
	  OL: 'primary_defensive_position_pref',
	  DB: 'primary_defensive_position_pref',
	  SS: 'primary_defensive_position_pref',
	  FS: 'primary_defensive_position_pref'
	};
	
	var divisions = exports.divisions = {
	  D1: 'D1',
	  D2: 'D2',
	  D3: 'D3',
	  JUCO: 'JUCO',
	  NAIA: 'NAIA'
	};
	
	var allYears = exports.allYears = ['All Years', '2014', '2015', '2016', '2017', '2018', '2019', '2020'];
	
	var allGpa = exports.allGpa = ['Minimum Gpa 4.0', 'Minimum Gpa 3.9', 'Minimum Gpa 3.8', 'Minimum Gpa 3.7', 'Minimum Gpa 3.6', 'Minimum Gpa 3.5', 'Minimum Gpa 3.4', 'Minimum Gpa 3.3', 'Minimum Gpa 3.2', 'Minimum Gpa 3.1', 'Minimum Gpa 3.0', 'Minimum Gpa 2.9', 'Minimum Gpa 2.8', 'Minimum Gpa 2.7', 'Minimum Gpa 2.6', 'Minimum Gpa 2.5', 'Minimum Gpa 2.4', 'Minimum Gpa 2.3', 'Minimum Gpa 2.2', 'Minimum Gpa 2.1', 'Minimum Gpa 2.0 or lower'];
	
	var gpaKey = exports.gpaKey = {
	  4.0: 'Minimum Gpa 4.0',
	  3.9: 'Minimum Gpa 3.9',
	  3.8: 'Minimum Gpa 3.8',
	  3.7: 'Minimum Gpa 3.7',
	  3.6: 'Minimum Gpa 3.6',
	  3.5: 'Minimum Gpa 3.5',
	  3.4: 'Minimum Gpa 3.4',
	  3.3: 'Minimum Gpa 3.3',
	  3.2: 'Minimum Gpa 3.2',
	  3.1: 'Minimum Gpa 3.1',
	  3.0: 'Minimum Gpa 3.0',
	  2.9: 'Minimum Gpa 2.9',
	  2.8: 'Minimum Gpa 2.8',
	  2.7: 'Minimum Gpa 2.7',
	  2.6: 'Minimum Gpa 2.6',
	  2.5: 'Minimum Gpa 2.5',
	  2.4: 'Minimum Gpa 2.4',
	  2.3: 'Minimum Gpa 2.3',
	  2.2: 'Minimum Gpa 2.2',
	  2.1: 'Minimum Gpa 2.1',
	  2.0: 'Minimum Gpa 2.0 or lower'
	};
	
	var pagination = exports.pagination = ['Top 20', 'Top 50', 'Top 100'];
	
	var paginationKey = exports.paginationKey = [20, 50, 100];

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CustomButton = __webpack_require__(280);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CustomButton2.default;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _curry1 = __webpack_require__(12);
	var _curry2 = __webpack_require__(6);
	var _curryN = __webpack_require__(223);
	
	
	/**
	 * Returns a curried equivalent of the provided function, with the specified
	 * arity. The curried function has two unusual capabilities. First, its
	 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curry
	 * @example
	 *
	 *      var sumArgs = (...args) => R.sum(args);
	 *
	 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry2(function curryN(length, fn) {
	  if (length === 1) {
	    return _curry1(fn);
	  }
	  return _arity(length, _curryN(length, [], fn));
	});


/***/ },
/* 50 */
[2532, 1214],
/* 51 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 54 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Home = exports.Home = '/';
	var About = exports.About = '/about';
	var Dashboard = exports.Dashboard = '/dashboard';
	var Contact = exports.Contact = '/contact';
	var Sports = exports.Sports = '/sports';
	var OurResults = exports.OurResults = '/ourresults';
	var Login = exports.Login = '/login';
	var Register = exports.Register = '/register';
	var Athlete = exports.Athlete = '/athlete';
	var Parent = exports.Parent = '/parents';
	var Coach = exports.Coach = '/coach';
	var AthleteCoachView = exports.AthleteCoachView = '/coach/athlete';
	var RegisterAthlete = exports.RegisterAthlete = '/register/athlete';
	var ViewAthlete = exports.ViewAthlete = '/view/athlete';
	var ViewAthleteById = exports.ViewAthleteById = '/view/athlete/:profileId';
	var Forgot = exports.Forgot = '/forgot';
	var Settings = exports.Settings = '/settings';
	var CoachRegister = exports.CoachRegister = '/register/coach';
	var CoachProfile = exports.CoachProfile = '/view/coach';
	var CoachDashboard = exports.CoachDashboard = '/view/coach/dashboard';
	var Pricing = exports.Pricing = '/pricing';
	var Payment = exports.Payment = '/checkout';
	var RedirectPage = exports.RedirectPage = '/redirect';
	var RegisterParent = exports.RegisterParent = '/register/parent';
	var Support = exports.Support = '/admin/admin_portal_support';
	var AdminLogin = exports.AdminLogin = '/admin/admin_portal_login';
	var VerifyCoach = exports.VerifyCoach = '/verify_coach';
	var AdminBase = exports.AdminBase = '/admin/admin_portal';
	var Terms = exports.Terms = '/terms_and_use';
	var AthleteForCoach = exports.AthleteForCoach = '/athleteForCoach';
	var PublicAthlete = exports.PublicAthlete = '/sendSaContactToCoach';

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getItem = getItem;
	exports.setItem = setItem;
	exports.removeItem = removeItem;
	exports.getStorage = getStorage;
	
	var _localStorage = __webpack_require__(1887);
	
	var _localStorage2 = _interopRequireDefault(_localStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getItem(key) {
	  var objectFromLocalStorage = _localStorage2.default.getItem(key);
	  if (objectFromLocalStorage) {
	    return JSON.parse(objectFromLocalStorage);
	  }
	  return {};
	}
	function setItem(key, objectToBeStored) {
	  return _localStorage2.default.setItem(key, JSON.stringify(objectToBeStored));
	}
	
	function removeItem(key) {
	  _localStorage2.default.removeItem(key);
	}
	
	function getStorage() {
	  return _localStorage2.default;
	}

/***/ },
/* 57 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssign = __webpack_require__(1905),
	    baseCreate = __webpack_require__(1906);
	
	/**
	 * Creates an object that inherits from the `prototype` object. If a
	 * `properties` object is given, its own enumerable string keyed properties
	 * are assigned to the created object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Object
	 * @param {Object} prototype The object to inherit from.
	 * @param {Object} [properties] The properties to assign to the object.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * function Shape() {
	 *   this.x = 0;
	 *   this.y = 0;
	 * }
	 *
	 * function Circle() {
	 *   Shape.call(this);
	 * }
	 *
	 * Circle.prototype = _.create(Shape.prototype, {
	 *   'constructor': Circle
	 * });
	 *
	 * var circle = new Circle;
	 * circle instanceof Circle;
	 * // => true
	 *
	 * circle instanceof Shape;
	 * // => true
	 */
	function create(prototype, properties) {
	  var result = baseCreate(prototype);
	  return properties == null ? result : baseAssign(result, properties);
	}
	
	module.exports = create;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _map = __webpack_require__(227);
	var _reduce = __webpack_require__(62);
	var _xmap = __webpack_require__(2130);
	var curryN = __webpack_require__(49);
	var keys = __webpack_require__(63);
	
	
	/**
	 * Takes a function and
	 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
	 * applies the function to each of the functor's values, and returns
	 * a functor of the same shape.
	 *
	 * Ramda provides suitable `map` implementations for `Array` and `Object`,
	 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
	 *
	 * Dispatches to the `map` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * Also treats functions as functors and will compose them together.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Functor f => (a -> b) -> f a -> f b
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {Array} list The list to be iterated over.
	 * @return {Array} The new list.
	 * @see R.transduce, R.addIndex
	 * @example
	 *
	 *      var double = x => x * 2;
	 *
	 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
	 *
	 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
	 * @symb R.map(f, [a, b]) = [f(a), f(b)]
	 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
	 * @symb R.map(f, functor_o) = functor_o.map(f)
	 */
	module.exports = _curry2(_dispatchable(['map'], _xmap, function map(fn, functor) {
	  switch (Object.prototype.toString.call(functor)) {
	    case '[object Function]':
	      return curryN(functor.length, function() {
	        return fn.call(this, functor.apply(this, arguments));
	      });
	    case '[object Object]':
	      return _reduce(function(acc, key) {
	        acc[key] = fn(functor[key]);
	        return acc;
	      }, {}, keys(functor));
	    default:
	      return _map(fn, functor);
	  }
	}));


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValuePresent = exports.getAnimationModule = exports.removeNamespace = exports.transformKeys = exports.prepareValueForInput = exports.inputTypeForPrototype = exports.cloneObject = exports.getViewport = exports.round = exports.range = exports.angle360FromPositions = exports.angleFromPositions = undefined;
	
	var _assoc = __webpack_require__(168);
	
	var _assoc2 = _interopRequireDefault(_assoc);
	
	var _compose = __webpack_require__(220);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _keys = __webpack_require__(63);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _reduce = __webpack_require__(67);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _pickBy = __webpack_require__(727);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var angleFromPositions = exports.angleFromPositions = function angleFromPositions(cx, cy, ex, ey) {
	  var theta = Math.atan2(ey - cy, ex - cx) + Math.PI / 2;
	  return theta * 180 / Math.PI;
	};
	
	var angle360FromPositions = exports.angle360FromPositions = function angle360FromPositions(cx, cy, ex, ey) {
	  var angle = angleFromPositions(cx, cy, ex, ey);
	  return angle < 0 ? 360 + angle : angle;
	};
	
	var range = exports.range = function range() {
	  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var _start = 0,
	      _stop = start;
	
	  if (stop !== null) {
	    _start = start;
	    _stop = stop;
	  }
	  var length = Math.max(Math.ceil((_stop - _start) / step), 0);
	  var _range = Array(length);
	
	  for (var idx = 0; idx < length; idx += 1, _start += step) {
	    _range[idx] = _start;
	  }
	
	  return _range;
	};
	
	var round = exports.round = function round(number, decimals) {
	  if (!isNaN(parseFloat(number)) && isFinite(number)) {
	    var decimalPower = Math.pow(10, decimals);
	    return Math.round(parseFloat(number) * decimalPower) / decimalPower;
	  }
	  return NaN;
	};
	
	var getViewport = exports.getViewport = function getViewport() {
	  return {
	    height: window.innerHeight || document.documentElement.offsetHeight,
	    width: window.innerWidth || document.documentElement.offsetWidth
	  };
	};
	
	var cloneObject = exports.cloneObject = function cloneObject(object) {
	  return JSON.parse(JSON.stringify(object));
	};
	
	var inputTypeForPrototype = exports.inputTypeForPrototype = function inputTypeForPrototype(prototype) {
	  if (prototype === Date) return 'date';
	  if (prototype === Number) return 'number';
	  if (prototype === Boolean) return 'checkbox';
	  return 'text';
	};
	
	var prepareValueForInput = exports.prepareValueForInput = function prepareValueForInput(value, type) {
	  if (type === 'date') return new Date(value).toISOString().slice(0, 10);
	  if (type === 'checkbox') {
	    return value ? 'on' : '';
	  }
	  return value;
	};
	
	var transformKeys = exports.transformKeys = function transformKeys(fn) {
	  return function (obj) {
	    var addTransformedKey = function addTransformedKey(result, key) {
	      return (0, _assoc2.default)(fn(key), obj[key], result);
	    };
	    return (0, _reduce2.default)(addTransformedKey, {}, (0, _keys2.default)(obj));
	  };
	};
	
	var removeNamespace = exports.removeNamespace = function removeNamespace(namespace) {
	  return function (key) {
	    var capitalized = key.substr(namespace.length);
	    return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
	  };
	};
	
	var getAnimationModule = exports.getAnimationModule = function getAnimationModule(animation, theme) {
	  return (0, _compose2.default)(transformKeys(removeNamespace(animation)), (0, _pickBy2.default)(function (v, k) {
	    return k.startsWith(animation);
	  }))(theme);
	};
	
	var isValuePresent = exports.isValuePresent = function isValuePresent(value) {
	  return value !== null && value !== undefined && value !== '' && !(typeof value === 'number' && isNaN(value));
	};

/***/ },
/* 61 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(713);
	var bind = __webpack_require__(689);
	var isArrayLike = __webpack_require__(171);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _has = __webpack_require__(52);
	var _isArguments = __webpack_require__(706);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ },
/* 64 */
57,
/* 65 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var regExForName = exports.regExForName = new RegExp(/^[\w() -]{3,50}$/);
	// eslint-disable-next-line
	var regExForEmail = exports.regExForEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
	
	var regexQuery = '^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$';
	
	// eslint-disable-next-line
	var regExForUrl = exports.regExForUrl = new RegExp(regexQuery, "i");
	
	var regExForNumber = exports.regExForNumber = new RegExp(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/); //eslint-disable-line
	
	var regExForTwitter = exports.regExForTwitter = new RegExp('^(?:https://)?(?:www\\.)?twitter\\.com/(\\w+)$', 'i');
	
	var regExForInsta = exports.regExForInsta = new RegExp(/^\s*(https\:\/\/)??(?:www\\.)instagram\.com\/[a-z\d-_]{1,255}\s*$/i); //eslint-disable-line
	
	var regExForTwitterHandle = exports.regExForTwitterHandle = new RegExp(/^@([A-Za-z0-9_]{1,15})$/);
	
	var regExForTwitterURL = exports.regExForTwitterURL = new RegExp(/^https?:\/\/(?:www\.)?twitter\.com\/(?:#!\/)?@?([A-Za-z0-9_]{1,15})(?:\/status\/\d+)?\/?$/);

/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * Private `concat` function to merge two array-like objects.
	 *
	 * @private
	 * @param {Array|Arguments} [set1=[]] An array-like object.
	 * @param {Array|Arguments} [set2=[]] An array-like object.
	 * @return {Array} A new, merged array.
	 * @example
	 *
	 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 */
	module.exports = function _concat(set1, set2) {
	  set1 = set1 || [];
	  set2 = set2 || [];
	  var idx;
	  var len1 = set1.length;
	  var len2 = set2.length;
	  var result = [];
	
	  idx = 0;
	  while (idx < len1) {
	    result[result.length] = set1[idx];
	    idx += 1;
	  }
	  idx = 0;
	  while (idx < len2) {
	    result[result.length] = set2[idx];
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var _reduce = __webpack_require__(62);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2326);
	


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Autocomplete = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Autocomplete = __webpack_require__(2373);
	
	var _chip = __webpack_require__(791);
	
	var _input = __webpack_require__(33);
	
	var _theme = __webpack_require__(1431);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Autocomplete = (0, _Autocomplete.autocompleteFactory)(_chip.Chip, _input.Input);
	var ThemedAutocomplete = (0, _reactCssThemr.themr)(_identifiers.AUTOCOMPLETE, _theme2.default, { withRef: true })(Autocomplete);
	
	exports.default = ThemedAutocomplete;
	exports.Autocomplete = ThemedAutocomplete;

/***/ },
/* 71 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _session = __webpack_require__(1076);
	
	Object.defineProperty(exports, 'authenticateUser', {
	    enumerable: true,
	    get: function get() {
	        return _session.authenticateUser;
	    }
	});
	Object.defineProperty(exports, 'RegisterUser', {
	    enumerable: true,
	    get: function get() {
	        return _session.RegisterUser;
	    }
	});
	Object.defineProperty(exports, 'forgotPassword', {
	    enumerable: true,
	    get: function get() {
	        return _session.forgotPassword;
	    }
	});
	Object.defineProperty(exports, 'isSessionValid', {
	    enumerable: true,
	    get: function get() {
	        return _session.isSessionValid;
	    }
	});
	Object.defineProperty(exports, 'congnitoSyncHandler', {
	    enumerable: true,
	    get: function get() {
	        return _session.congnitoSyncHandler;
	    }
	});
	Object.defineProperty(exports, 'setPasswordByCode', {
	    enumerable: true,
	    get: function get() {
	        return _session.setPasswordByCode;
	    }
	});
	Object.defineProperty(exports, 'resetPassword', {
	    enumerable: true,
	    get: function get() {
	        return _session.resetPassword;
	    }
	});
	Object.defineProperty(exports, 'logoutUser', {
	    enumerable: true,
	    get: function get() {
	        return _session.logoutUser;
	    }
	});
	Object.defineProperty(exports, 'updateProfilePicture', {
	    enumerable: true,
	    get: function get() {
	        return _session.updateProfilePicture;
	    }
	});
	Object.defineProperty(exports, 'updateUserAttributes', {
	    enumerable: true,
	    get: function get() {
	        return _session.updateUserAttributes;
	    }
	});

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Divider = __webpack_require__(1135);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ },
/* 75 */
[2532, 1216],
/* 76 */
[2578, 299, 204, 98],
/* 77 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _equals = __webpack_require__(2105);
	
	
	/**
	 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
	 * cyclical data structures.
	 *
	 * Dispatches symmetrically to the `equals` methods of both arguments, if
	 * present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> b -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      R.equals(1, 1); //=> true
	 *      R.equals(1, '1'); //=> false
	 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
	 *
	 *      var a = {}; a.v = a;
	 *      var b = {}; b.v = b;
	 *      R.equals(a, b); //=> true
	 */
	module.exports = _curry2(function equals(a, b) {
	  return _equals(a, b, [], []);
	});


/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22),
	    _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(744);
	var PooledClass = __webpack_require__(119);
	var ReactFeatureFlags = __webpack_require__(749);
	var ReactReconciler = __webpack_require__(147);
	var Transaction = __webpack_require__(236);
	
	var invariant = __webpack_require__(14);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _dissoc = __webpack_require__(330);
	
	var _dissoc2 = _interopRequireDefault(_dissoc);
	
	var _identifiers = __webpack_require__(9);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _prefixer = __webpack_require__(255);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  centered: false,
	  className: '',
	  multiple: true,
	  passthrough: true,
	  spread: 2,
	  theme: {}
	};
	
	var rippleFactory = function rippleFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _defaults$options = _extends({}, defaults, options),
	      defaultCentered = _defaults$options.centered,
	      defaultClassName = _defaults$options.className,
	      defaultMultiple = _defaults$options.multiple,
	      defaultPassthrough = _defaults$options.passthrough,
	      defaultSpread = _defaults$options.spread,
	      defaultTheme = _defaults$options.theme,
	      props = _objectWithoutProperties(_defaults$options, ['centered', 'className', 'multiple', 'passthrough', 'spread', 'theme']);
	
	  return function (ComposedComponent) {
	    var RippledComponent = function (_Component) {
	      _inherits(RippledComponent, _Component);
	
	      function RippledComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RippledComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RippledComponent.__proto__ || Object.getPrototypeOf(RippledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          ripples: {}
	        }, _this.rippleNodes = {}, _this.doRipple = function () {
	          return !_this.props.disabled && _this.props.ripple;
	        }, _this.handleMouseDown = function (event) {
	          if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	          if (_this.doRipple()) {
	            var _events$getMousePosit = _events2.default.getMousePosition(event),
	                x = _events$getMousePosit.x,
	                y = _events$getMousePosit.y;
	
	            _this.animateRipple(x, y, false);
	          }
	        }, _this.handleTouchStart = function (event) {
	          if (_this.props.onTouchStart) _this.props.onTouchStart(event);
	          if (_this.doRipple()) {
	            var _events$getTouchPosit = _events2.default.getTouchPosition(event),
	                x = _events$getTouchPosit.x,
	                y = _events$getTouchPosit.y;
	
	            _this.animateRipple(x, y, true);
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(RippledComponent, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	          // If a new ripple was just added, add a remove event listener to its animation
	          if (Object.keys(prevState.ripples).length < Object.keys(this.state.ripples).length) {
	            this.addRippleRemoveEventListener(this.getLastKey());
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          var _this2 = this;
	
	          // Remove document event listeners for ripple if they still exists
	          Object.keys(this.state.ripples).forEach(function (key) {
	            _this2.state.ripples[key].endRipple();
	          });
	        }
	
	        /**
	         * Find out a descriptor object for the ripple element being created depending on
	         * the position where the it was triggered and the component's dimensions.
	         *
	         * @param {Number} x Coordinate x in the viewport where ripple was triggered
	         * @param {Number} y Coordinate y in the viewport where ripple was triggered
	         * @return {Object} Descriptor element including position and size of the element
	         */
	
	      }, {
	        key: 'getDescriptor',
	        value: function getDescriptor(x, y) {
	          var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this).getBoundingClientRect(),
	              left = _ReactDOM$findDOMNode.left,
	              top = _ReactDOM$findDOMNode.top,
	              height = _ReactDOM$findDOMNode.height,
	              width = _ReactDOM$findDOMNode.width;
	
	          var _props = this.props,
	              centered = _props.rippleCentered,
	              spread = _props.rippleSpread;
	
	          return {
	            left: centered ? 0 : x - left - width / 2,
	            top: centered ? 0 : y - top - height / 2,
	            width: width * spread
	          };
	        }
	
	        /**
	         * Increments and internal counter and returns the next value as a string. It
	         * is used to assign key references to new ripple elements.
	         *
	         * @return {String} Key to be assigned to a ripple.
	         */
	
	      }, {
	        key: 'getNextKey',
	        value: function getNextKey() {
	          this.currentCount = this.currentCount ? this.currentCount + 1 : 1;
	          return 'ripple' + this.currentCount;
	        }
	
	        /**
	         * Return the last generated key for a ripple element. When there is only one ripple
	         * and to get the reference when a ripple was just created.
	         *
	         * @return {String} The last generated ripple key.
	         */
	
	      }, {
	        key: 'getLastKey',
	        value: function getLastKey() {
	          return 'ripple' + this.currentCount;
	        }
	
	        /**
	         * Variable to store the ripple references
	         */
	
	      }, {
	        key: 'rippleShouldTrigger',
	
	
	        /**
	         * Determine if a ripple should start depending if its a touch event. For mobile both
	         * touchStart and mouseDown are launched so in case is touch we should always trigger
	         * but if its not we should check if a touch was already triggered to decide.
	         *
	         * @param {Boolean} isTouch True in case a touch event triggered the ripple false otherwise.
	         * @return {Boolean} True in case the ripple should trigger or false if it shouldn't.
	         */
	        value: function rippleShouldTrigger(isTouch) {
	          var shouldStart = isTouch ? true : !this.touchCache;
	          this.touchCache = isTouch;
	          return shouldStart;
	        }
	
	        /**
	         * Start a ripple animation on an specific point with touch or mouse events. First
	         * decides if the animation should trigger. If the ripple is multiple or there is no
	         * ripple present, it creates a new key. If it's a simple ripple and already exists,
	         * it just restarts the current ripple. The animation happens in two state changes
	         * to allow triggering via css.
	         *
	         * @param {Number} x Coordinate X on the screen where animation should start
	         * @param {Number} y Coordinate Y on the screen where animation should start
	         * @param {Boolean} isTouch Use events from touch or mouse.
	         */
	
	      }, {
	        key: 'animateRipple',
	        value: function animateRipple(x, y, isTouch) {
	          var _this3 = this;
	
	          if (this.rippleShouldTrigger(isTouch)) {
	            var _getDescriptor = this.getDescriptor(x, y),
	                top = _getDescriptor.top,
	                left = _getDescriptor.left,
	                width = _getDescriptor.width;
	
	            var noRipplesActive = Object.keys(this.state.ripples).length === 0;
	            var key = this.props.rippleMultiple || noRipplesActive ? this.getNextKey() : this.getLastKey();
	            var endRipple = this.addRippleDeactivateEventListener(isTouch, key);
	            var initialState = { active: false, restarting: true, top: top, left: left, width: width, endRipple: endRipple };
	            var runningState = { active: true, restarting: false };
	            var ripples = _extends({}, this.state.ripples, _defineProperty({}, key, initialState));
	            this.setState({ ripples: ripples }, function () {
	              if (_this3.rippleNodes[key]) _this3.rippleNodes[key].offsetWidth; // eslint-disable-line
	              _this3.setState({ ripples: _extends({}, _this3.state.ripples, _defineProperty({}, key, Object.assign({}, _this3.state.ripples[key], runningState))) });
	            });
	          }
	        }
	
	        /**
	         * Add an event listener to the reference with given key so when the animation transition
	         * ends we can be sure that it finished and it can be safely removed from the state.
	         * This function is called whenever a new ripple is added to the component.
	         *
	         * @param {String} rippleKey Is the key of the ripple to add the event.
	         */
	
	      }, {
	        key: 'addRippleRemoveEventListener',
	        value: function addRippleRemoveEventListener(rippleKey) {
	          var self = this;
	          var rippleNode = this.rippleNodes[rippleKey];
	          _events2.default.addEventListenerOnTransitionEnded(rippleNode, function onOpacityEnd(e) {
	            if (e.propertyName === 'opacity') {
	              if (self.props.onRippleEnded) self.props.onRippleEnded(e);
	              _events2.default.removeEventListenerOnTransitionEnded(self.rippleNodes[rippleKey], onOpacityEnd);
	              // self.rippleNodes = dissoc(rippleKey, self.rippleNodes);
	              delete self.rippleNodes[rippleKey];
	              self.setState({ ripples: (0, _dissoc2.default)(rippleKey, self.state.ripples) });
	            }
	          });
	        }
	
	        /**
	         * Add an event listener to the document needed to deactivate a ripple and make it dissappear.
	         * Deactivation can happen with a touchend or mouseup depending on the trigger type. The
	         * ending function is created from a factory function and returned.
	         *
	         * @param {Boolean} isTouch True in case the trigger was a touch event false otherwise.
	         * @param {String} rippleKey It's a key to identify the ripple that should be deactivated.
	         * @return {Function} Callback function that deactivates the ripple and removes the listener
	         */
	
	      }, {
	        key: 'addRippleDeactivateEventListener',
	        value: function addRippleDeactivateEventListener(isTouch, rippleKey) {
	          var eventType = isTouch ? 'touchend' : 'mouseup';
	          var endRipple = this.createRippleDeactivateCallback(eventType, rippleKey);
	          document.addEventListener(eventType, endRipple);
	          return endRipple;
	        }
	
	        /**
	         * Generates a function that can be called to deactivate a ripple and remove its finishing
	         * event listener. If is generated because we need to store it to be called on unmount in case
	         * the ripple is still running.
	         *
	         * @param {String} eventType Is the event type that can be touchend or mouseup
	         * @param {String} rippleKey Is the key representing the ripple
	         * @return {Function} Callback function that deactivates the ripple and removes the listener
	         */
	
	      }, {
	        key: 'createRippleDeactivateCallback',
	        value: function createRippleDeactivateCallback(eventType, rippleKey) {
	          var self = this;
	          return function endRipple() {
	            document.removeEventListener(eventType, endRipple);
	            self.setState({ ripples: _extends({}, self.state.ripples, _defineProperty({}, rippleKey, Object.assign({}, self.state.ripples[rippleKey], { active: false }))) });
	          };
	        }
	      }, {
	        key: 'renderRipple',
	        value: function renderRipple(key, className, _ref2) {
	          var _classnames,
	              _this4 = this;
	
	          var active = _ref2.active,
	              left = _ref2.left,
	              restarting = _ref2.restarting,
	              top = _ref2.top,
	              width = _ref2.width;
	
	          var scale = restarting ? 0 : 1;
	          var transform = 'translate3d(' + (-width / 2 + left) + 'px, ' + (-width / 2 + top) + 'px, 0) scale(' + scale + ')';
	          var _className = (0, _classnames3.default)(this.props.theme.ripple, (_classnames = {}, _defineProperty(_classnames, this.props.theme.rippleActive, active), _defineProperty(_classnames, this.props.theme.rippleRestarting, restarting), _classnames), className);
	          return _react2.default.createElement(
	            'span',
	            _extends({ key: key, 'data-react-toolbox': 'ripple', className: this.props.theme.rippleWrapper }, props),
	            _react2.default.createElement('span', {
	              className: _className,
	              ref: function ref(node) {
	                if (node) _this4.rippleNodes[key] = node;
	              },
	              style: (0, _prefixer2.default)({ transform: transform }, { width: width, height: width })
	            })
	          );
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this5 = this;
	
	          var _props2 = this.props,
	              children = _props2.children,
	              disabled = _props2.disabled,
	              ripple = _props2.ripple,
	              onRippleEnded = _props2.onRippleEnded,
	              rippleCentered = _props2.rippleCentered,
	              rippleClassName = _props2.rippleClassName,
	              rippleMultiple = _props2.rippleMultiple,
	              rippleSpread = _props2.rippleSpread,
	              theme = _props2.theme,
	              other = _objectWithoutProperties(_props2, ['children', 'disabled', 'ripple', 'onRippleEnded', 'rippleCentered', 'rippleClassName', 'rippleMultiple', 'rippleSpread', 'theme']);
	
	          var ripples = this.state.ripples;
	
	          var childRipples = Object.keys(ripples).map(function (key) {
	            return _this5.renderRipple(key, rippleClassName, ripples[key]);
	          });
	          var childProps = _extends({
	            onMouseDown: this.handleMouseDown,
	            onTouchStart: this.handleTouchStart
	          }, other);
	          var finalProps = defaultPassthrough ? _extends({}, childProps, { theme: theme, disabled: disabled }) : childProps;
	
	          return !ripple ? _react2.default.createElement(ComposedComponent, finalProps, children) : _react2.default.createElement(ComposedComponent, finalProps, [children, childRipples]);
	        }
	      }]);
	
	      return RippledComponent;
	    }(_react.Component);
	
	    RippledComponent.propTypes = {
	      children: _propTypes2.default.node,
	      disabled: _propTypes2.default.bool,
	      onMouseDown: _propTypes2.default.func,
	      onRippleEnded: _propTypes2.default.func,
	      onTouchStart: _propTypes2.default.func,
	      ripple: _propTypes2.default.bool,
	      rippleCentered: _propTypes2.default.bool,
	      rippleClassName: _propTypes2.default.string,
	      rippleMultiple: _propTypes2.default.bool,
	      rippleSpread: _propTypes2.default.number,
	      theme: _propTypes2.default.shape({
	        ripple: _propTypes2.default.string,
	        rippleActive: _propTypes2.default.string,
	        rippleRestarting: _propTypes2.default.string,
	        rippleWrapper: _propTypes2.default.string
	      })
	    };
	    RippledComponent.defaultProps = {
	      disabled: false,
	      ripple: true,
	      rippleCentered: defaultCentered,
	      rippleClassName: defaultClassName,
	      rippleMultiple: defaultMultiple,
	      rippleSpread: defaultSpread
	    };
	
	
	    return (0, _reactCssThemr.themr)(_identifiers.RIPPLE, defaultTheme)(RippledComponent);
	  };
	};
	
	exports.default = rippleFactory;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(71);
	var core = __webpack_require__(64);
	var hide = __webpack_require__(123);
	var redefine = __webpack_require__(124);
	var ctx = __webpack_require__(121);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavOnScroll = __webpack_require__(1166);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NavOnScroll2.default;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(535);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(119);
	
	var emptyFunction = __webpack_require__(77);
	var warning = __webpack_require__(17);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(778);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(779);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(780);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(365);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(242);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(781);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(782);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(366);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(243);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(784);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(63);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getMousePosition: function getMousePosition(event) {
	    return {
	      x: event.pageX - (window.scrollX || window.pageXOffset),
	      y: event.pageY - (window.scrollY || window.pageYOffset)
	    };
	  },
	  getTouchPosition: function getTouchPosition(event) {
	    return {
	      x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
	      y: event.touches[0].pageY - (window.scrollY || window.pageYOffset)
	    };
	  },
	  pauseEvent: function pauseEvent(event) {
	    event.stopPropagation();
	    event.preventDefault();
	  },
	  addEventsToDocument: function addEventsToDocument(eventMap) {
	    Object.keys(eventMap).forEach(function (key) {
	      document.addEventListener(key, eventMap[key], false);
	    });
	  },
	  removeEventsFromDocument: function removeEventsFromDocument(eventMap) {
	    Object.keys(eventMap).forEach(function (key) {
	      document.removeEventListener(key, eventMap[key], false);
	    });
	  },
	  targetIsDescendant: function targetIsDescendant(event, parent) {
	    var node = event.target;
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	    return false;
	  },
	  addEventListenerOnTransitionEnded: function addEventListenerOnTransitionEnded(element, fn) {
	    var eventName = transitionEventNamesFor(element);
	    if (!eventName) return false;
	    element.addEventListener(eventName, fn);
	    return true;
	  },
	  removeEventListenerOnTransitionEnded: function removeEventListenerOnTransitionEnded(element, fn) {
	    var eventName = transitionEventNamesFor(element);
	    if (!eventName) return false;
	    element.removeEventListener(eventName, fn);
	    return true;
	  }
	};
	
	
	var TRANSITIONS = {
	  transition: 'transitionend',
	  OTransition: 'oTransitionEnd',
	  MozTransition: 'transitionend',
	  WebkitTransition: 'webkitTransitionEnd'
	};
	
	function transitionEventNamesFor(element) {
	  return (0, _keys2.default)(TRANSITIONS).reduce(function (result, transition) {
	    return !result && element && element.style[transition] !== undefined ? TRANSITIONS[transition] : result;
	  }, null);
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasOwnProperty = __webpack_require__(2416);
	
	var _hasOwnProperty2 = _interopRequireDefault(_hasOwnProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateLocales = {
	  de: {
	    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sept_Okt_Nov_Dez'.split('_'),
	    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysLetter: 'S_M_D_M_D_F_S'.split('_')
	  },
	  no: {
	    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysLetter: []
	  },
	  en: {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysLetter: []
	  },
	  es: {
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort: 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysLetter: 'D_L_M_X_J_V_S'.split('_')
	  },
	  af: {
	    months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysLetter: []
	  },
	  ar: {
	    months: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
	    monthsShort: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysLetter: []
	  },
	  be: {
	    months: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	    monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	    weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysLetter: []
	  },
	  bg: {
	    months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysLetter: []
	  },
	  bn: {
	    months: 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort: 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	    weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	    weekdaysLetter: []
	  },
	  bo: {
	    months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysLetter: []
	  },
	  br: {
	    months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysLetter: []
	  },
	  bs: {
	    months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysLetter: []
	  },
	  ca: {
	    months: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort: 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysLetter: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_')
	  },
	  gl: {
	    months: 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	    monthsShort: 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	    weekdays: 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	    weekdaysShort: 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	    weekdaysLetter: 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_')
	  },
	  eu: {
	    months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysLetter: 'ig_al_ar_az_og_ol_lr'.split('_')
	  },
	  pt: {
	    months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysLetter: []
	  },
	  it: {
	    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays: 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort: 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysLetter: []
	  },
	  fr: {
	    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysLetter: []
	  },
	  ru: {
	    months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
	    monthsShort: 'Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
	    weekdays: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
	    weekdaysShort: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	    weekdaysLetter: []
	  },
	  ua: {
	    months: 'Січень_Лютий_Березень_Квітень_Травень_Червень_Липень_Серпень_Вересень_Жовтень_Листопад_Грудень'.split('_'),
	    monthsShort: 'Січ_Лют_Берез_Квіт_Трав_Черв_Лип_Серп_Верес_Жовт_Листоп_Груд'.split('_'),
	    weekdays: 'Неділя_Понеділок_Вівторок_Середа_Четвер_П’ятниця_Субота'.split('_'),
	    weekdaysShort: 'Нд_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	    weekdaysLetter: []
	  },
	  'zh-cn': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  },
	  'zh-hk': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  },
	  'zh-tw': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  }
	};
	
	var time = {
	  getDaysInMonth: function getDaysInMonth(d) {
	    var resultDate = this.getFirstDayOfMonth(d);
	    resultDate.setMonth(resultDate.getMonth() + 1);
	    resultDate.setDate(resultDate.getDate() - 1);
	    return resultDate.getDate();
	  },
	  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
	    return new Date(d.getFullYear(), d.getMonth(), 1);
	  },
	  getFirstWeekDay: function getFirstWeekDay(d) {
	    return this.getFirstDayOfMonth(d).getDay();
	  },
	  getTimeMode: function getTimeMode(d) {
	    return d.getHours() >= 12 ? 'pm' : 'am';
	  },
	  getFullMonth: function getFullMonth(d) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var month = d.getMonth();
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'months') ? l.months[month] || 'Unknown' : 'Unknown';
	  },
	  getShortMonth: function getShortMonth(d) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var month = d.getMonth();
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'monthsShort') ? l.monthsShort[month] || 'Unknown' : 'Unknown';
	  },
	  getFullDayOfWeek: function getFullDayOfWeek(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdays') ? l.weekdays[day] || 'Unknown' : 'Unknown';
	  },
	  getShortDayOfWeek: function getShortDayOfWeek(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdaysShort') ? l.weekdaysShort[day] || 'Unknown' : 'Unknown';
	  },
	  getDayOfWeekLetter: function getDayOfWeekLetter(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdaysLetter') ? l.weekdaysLetter[day] || this.getFullDayOfWeek(day, locale).charAt(0) : 'Unknown';
	  },
	  clone: function clone(d) {
	    return new Date(d.getTime());
	  },
	  cloneAsDate: function cloneAsDate(d) {
	    var clonedDate = this.clone(d);
	    clonedDate.setHours(0, 0, 0, 0);
	    return clonedDate;
	  },
	  isDateObject: function isDateObject(d) {
	    return d instanceof Date;
	  },
	  addDays: function addDays(d, days) {
	    var newDate = this.clone(d);
	    newDate.setDate(d.getDate() + days);
	    return newDate;
	  },
	  addMonths: function addMonths(d, months) {
	    var newDate = this.clone(d);
	    newDate.setMonth(d.getMonth() + months, 1);
	    return newDate;
	  },
	  addYears: function addYears(d, years) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(d.getFullYear() + years);
	    return newDate;
	  },
	  setDay: function setDay(d, day) {
	    var newDate = this.clone(d);
	    newDate.setDate(day);
	    return newDate;
	  },
	  setMonth: function setMonth(d, month) {
	    var newDate = this.clone(d);
	    newDate.setMonth(month);
	    return newDate;
	  },
	  setYear: function setYear(d, year) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(year);
	    return newDate;
	  },
	  setHours: function setHours(d, hours) {
	    var newDate = this.clone(d);
	    newDate.setHours(hours);
	    return newDate;
	  },
	  setMinutes: function setMinutes(d, minutes) {
	    var newDate = this.clone(d);
	    newDate.setMinutes(minutes);
	    return newDate;
	  },
	  toggleTimeMode: function toggleTimeMode(d) {
	    var newDate = this.clone(d);
	    var hours = newDate.getHours();
	
	    newDate.setHours(hours - (hours > 12 ? -12 : 12));
	    return newDate;
	  },
	  formatTime: function formatTime(date, format) {
	    var hours = date.getHours();
	    var mins = date.getMinutes().toString();
	
	    if (format === 'ampm') {
	      var isAM = hours < 12;
	      var additional = isAM ? ' am' : ' pm';
	
	      hours %= 12;
	      hours = (hours || 12).toString();
	      if (mins.length < 2) mins = '0' + mins;
	
	      return hours + (mins === '00' ? '' : ':' + mins) + additional;
	    }
	
	    hours = hours.toString();
	    if (hours.length < 2) hours = '0' + hours;
	    if (mins.length < 2) mins = '0' + mins;
	    return hours + ':' + mins;
	  },
	  dateOutOfRange: function dateOutOfRange(date, minDate, maxDate) {
	    return minDate && !(date >= minDate) || maxDate && !(date <= maxDate);
	  },
	  closestDate: function closestDate(to, date1, date2) {
	    var toTime = to.getTime();
	
	    var diff1 = Math.abs(toTime - date1.getTime());
	    var diff2 = Math.abs(toTime - date2.getTime());
	
	    return diff1 < diff2 ? date1 : date2;
	  },
	  formatDate: function formatDate(date) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    if (locale === 'en') {
	      return date.getDate() + ' ' + time.getFullMonth(date, locale) + ' ' + date.getFullYear();
	    }
	    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
	  }
	};
	
	exports.default = time;

/***/ },
/* 92 */
[2558, 120, 826, 385, 106],
/* 93 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _saProfile = __webpack_require__(1075);
	
	Object.defineProperty(exports, 'saveProfile', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.saveProfile;
	    }
	});
	Object.defineProperty(exports, 'getProfile', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.getProfile;
	    }
	});
	Object.defineProperty(exports, 'saveProfileVideo', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.saveProfileVideo;
	    }
	});
	Object.defineProperty(exports, 'searchSchoolsByName', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.searchSchoolsByName;
	    }
	});
	Object.defineProperty(exports, 'getPublicProfile', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.getPublicProfile;
	    }
	});
	Object.defineProperty(exports, 'getPublicProfileForCoach', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.getPublicProfileForCoach;
	    }
	});
	Object.defineProperty(exports, 'getPublicRequestById', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.getPublicRequestById;
	    }
	});
	Object.defineProperty(exports, 'removeVideoById', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.removeVideoById;
	    }
	});
	Object.defineProperty(exports, 'startTrial', {
	    enumerable: true,
	    get: function get() {
	        return _saProfile.startTrial;
	    }
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Banner = __webpack_require__(1093);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Banner2.default;

/***/ },
/* 96 */
[2543, 132],
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(98);
	var core = __webpack_require__(57);
	var ctx = __webpack_require__(292);
	var hide = __webpack_require__(133);
	var has = __webpack_require__(112);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 98 */
71,
/* 99 */
[2558, 131, 491, 301, 96],
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1407)
	var ieee754 = __webpack_require__(1612)
	var isArray = __webpack_require__(1636)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
	var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _propTypes2.default.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ },
/* 103 */
/***/ function(module, exports) {

	module.exports = function _reduced(x) {
	  return x && x['@@transducer/reduced'] ? x :
	    {
	      '@@transducer/value': x,
	      '@@transducer/reduced': true
	    };
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioGroup = exports.RadioButton = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _Radio = __webpack_require__(809);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _RadioButton = __webpack_require__(810);
	
	var _RadioGroup = __webpack_require__(2399);
	
	var _theme = __webpack_require__(1449);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedRadio = (0, _Radio2.default)((0, _ripple2.default)({ centered: true, spread: 2.6 }));
	var ThemedRadioButton = (0, _reactCssThemr.themr)(_identifiers.RADIO, _theme2.default)((0, _RadioButton.radioButtonFactory)(ThemedRadio));
	var ThemedRadioGroup = (0, _reactCssThemr.themr)(_identifiers.RADIO, _theme2.default)((0, _RadioGroup.radioGroupFactory)(ThemedRadioButton));
	
	exports.default = ThemedRadioButton;
	exports.RadioButton = ThemedRadioButton;
	exports.RadioGroup = ThemedRadioGroup;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	var _theme = __webpack_require__(1450);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (options) {
	  return (0, _Ripple2.default)(_extends({}, options, { theme: _theme2.default }));
	};

/***/ },
/* 106 */
[2543, 182],
/* 107 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachRegistration = __webpack_require__(1113);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachRegistration2.default;

/***/ },
/* 109 */
[2527, 1289],
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSAProfile = getSAProfile;
	exports.videoDetails = videoDetails;
	exports.saveUserImage = saveUserImage;
	exports.setCurrentVideo = setCurrentVideo;
	exports.removeVideo = removeVideo;
	
	var _immutable = __webpack_require__(11);
	
	var _localStorage = __webpack_require__(56);
	
	var _saProfile = __webpack_require__(94);
	
	var _actionTypes = __webpack_require__(200);
	
	var _session = __webpack_require__(73);
	
	var _actionTypes2 = __webpack_require__(288);
	
	function getSAProfile(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    (0, _saProfile.getProfile)(id).then(function (data) {
	      var temp = Object.assign({}, data);
	      if (data.profile_image !== undefined) {
	        (0, _localStorage.setItem)('profile_image', data.profile_image);
	      } else {
	        (0, _localStorage.setItem)('profile_image', '');
	      }
	      if (data.payment_info !== undefined) {
	        var lastItem = data.payment_info[data.payment_info.length - 1];
	        window.sessionStorage.setItem('kiro', lastItem.payment_status);
	      } else {
	        window.sessionStorage.setItem('kiro', false);
	      }
	      if (!data.contactedCount) {
	        temp.contactedCount = {
	          count: 0,
	          lastContacted: null
	        };
	      }
	      if (temp) {
	        dispatch({
	          type: _actionTypes2.SUCCESSFUL,
	          profile: (0, _immutable.fromJS)(temp)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work
	function videoDetails(video, cb) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.ADD_VIDEO_REQUESTED
	    });
	    (0, _saProfile.saveProfileVideo)(video).then(function (data) {
	      dispatch({
	        type: _actionTypes2.ADD_VIDEO_SUCCESSFUL,
	        profile: (0, _immutable.fromJS)(data)
	      });
	      if (cb) {
	        cb((0, _immutable.fromJS)(data.video_items));
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.ADD_VIDEO_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function saveUserImage(profileId, file) {
	  return function (dispatch) {
	    (0, _session.updateProfilePicture)(profileId, file, function (error, result) {
	      if (error) {
	        dispatch({
	          type: _actionTypes2.FAILED,
	          profile: (0, _immutable.fromJS)(result)
	        });
	      }
	    });
	  };
	}
	
	function setCurrentVideo(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.SET_CURRENT_VIDEO,
	      url: data
	    });
	    dispatch({
	      type: _actionTypes.CURRENT_VIDEO_URL,
	      url: data
	    });
	  };
	}
	
	function removeVideo(data, cb) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REMOVE_VIDEO_REQUESTED
	    });
	    (0, _saProfile.removeVideoById)(data).then(function (response) {
	      dispatch({
	        type: _actionTypes2.REMOVE_VIDEO_SUCCESSFUL,
	        profile: (0, _immutable.fromJS)(response)
	      });
	      cb();
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.REMOVE_VIDEO_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.SAProfilePage = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(288);
	
	var _functions = __webpack_require__(1331);
	
	var helpers = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  profile: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  requested: false,
	  videos: [],
	  isLoading: false,
	  currentVideoUrl: '',
	  totalCounts: {},
	  totalCountsLoading: false,
	  payload: (0, _immutable.Map)(),
	  subscribed: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    error: (0, _immutable.Map)(),
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.profile,
	    payload: helpers.generatePayload(action.profile),
	    subscribed: helpers.getSubscription(action.profile),
	    error: (0, _immutable.Map)(),
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_VIDEO_REQUESTED, function (state) {
	  return state.merge({
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_VIDEO_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    isLoading: false,
	    profile: action.profile
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_VIDEO_FAILED, function (state) {
	  return state.merge({
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.SAVE_VIDEO_DETAILS, function (state, action) {
	  return state.merge({
	    videos: action.video
	  });
	}), _defineProperty(_handlers, _actionTypes.SAVE_USER_IMAGE, function (state, action) {
	  return state.merge({
	    videos: action.video
	  });
	}), _defineProperty(_handlers, _actionTypes.SET_CURRENT_VIDEO, function (state, action) {
	  return state.merge({
	    currentVideoUrl: action.url
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_TOTAL_COUNTS_REQUESTED_PROFILE, function (state) {
	  return state.merge({
	    totalCountsLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_TOTAL_COUNTS_FAILED_PROFILE, function (state) {
	  return state.merge({
	    totalCountsLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE, function (state, action) {
	  return state.merge({
	    totalCounts: action.data,
	    totalCountsLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.REMOVE_VIDEO_REQUESTED, function (state) {
	  return state.merge({
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.REMOVE_VIDEO_FAILED, function (state) {
	  return state.merge({
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.REMOVE_VIDEO_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    profile: action.profile,
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    profile: (0, _immutable.Map)(),
	    error: (0, _immutable.Map)(),
	    requested: false,
	    videos: [],
	    isLoading: false,
	    currentVideoUrl: ''
	  });
	}), _defineProperty(_handlers, _actionTypes.INCREASE_CONTACT_COUNT, function (state, action) {
	  return state.merge({
	    profile: action.profile
	  });
	}), _handlers);
	
	var SAProfilePage = exports.SAProfilePage = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.SAProfilePage.get('error');
	};
	var getProfile = function getProfile(state) {
	  return state.SAProfilePage.get('profile');
	};
	var IsRequested = function IsRequested(state) {
	  return state.SAProfilePage.get('requested');
	};
	var getVideo = function getVideo(state) {
	  return state.SAProfilePage.get('videos');
	};
	var getisLoading = function getisLoading(state) {
	  return state.SAProfilePage.get('isLoading');
	};
	var getCurrentVideoUrl = function getCurrentVideoUrl(state) {
	  return state.SAProfilePage.get('currentVideoUrl');
	};
	var gettotalCountsLoading = function gettotalCountsLoading(state) {
	  return state.SAProfilePage.get('totalCountsLoading');
	};
	var getTotalCounts = function getTotalCounts(state) {
	  return state.SAProfilePage.get('totalCounts');
	};
	var getPayload = function getPayload(state) {
	  return state.SAProfilePage.get('payload');
	};
	var getSubscribed = function getSubscribed(state) {
	  return state.SAProfilePage.get('subscribed');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  profile: getProfile,
	  requested: IsRequested,
	  videos: getVideo,
	  isLoading: getisLoading,
	  currentVideoUrl: getCurrentVideoUrl,
	  totalCounts: getTotalCounts,
	  totalCountsLoading: gettotalCountsLoading,
	  payload: getPayload,
	  subscribed: getSubscribed
	});

/***/ },
/* 112 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 113 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"DashboardView__materialize-textarea___3TRCX","modal-2463794813":"DashboardView__modal-2463794813___KymgM","container":"DashboardView__container___WCafk","tabsContainer":"DashboardView__tabsContainer___3Kn6Y","tabsButton":"DashboardView__tabsButton___1LEnZ","schoolTab":"DashboardView__schoolTab___3Px_8","schoolTabWithoutBorder":"DashboardView__schoolTabWithoutBorder___3yYHZ","colorSchoolTab":"DashboardView__colorSchoolTab___1Htrg","postingTab":"DashboardView__postingTab___Lgq32","colorPostingTab":"DashboardView__colorPostingTab___11vF-","filterButtonsContainer":"DashboardView__filterButtonsContainer___3EhSc","filterButton":"DashboardView__filterButton___3ujqQ","sortbyDate":"DashboardView__sortbyDate___1A75J","filterImage":"DashboardView__filterImage___1vixd","gridButton":"DashboardView__gridButton___yKgjY","textBox":"DashboardView__textBox___2Shp9","infoContainer":"DashboardView__infoContainer___1lrZt","myrequestSpan":"DashboardView__myrequestSpan___fA0td","otherInfoContainer":"DashboardView__otherInfoContainer___3c2uP","noContentAvailable":"DashboardView__noContentAvailable___2XmUp","loadMoreButton":"DashboardView__loadMoreButton___2zw4w","filterContainer":"DashboardView__filterContainer___pxA6d","removePadding":"DashboardView__removePadding___ojKf1","emptyScreens":"DashboardView__emptyScreens___P5GHW","emptyImage":"DashboardView__emptyImage___18Yvg","noDescFound":"DashboardView__noDescFound___3xieK","tilesMinimumContainer":"DashboardView__tilesMinimumContainer___3YNI1","alignCenter":"DashboardView__alignCenter___pajRN","requestViewedCount":"DashboardView__requestViewedCount___2a0m-"};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1607);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1916),
	    getValue = __webpack_require__(1940);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(2493);
	var objectAssign = __webpack_require__(16);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var _indexOf = __webpack_require__(705);
	
	
	module.exports = function _contains(a, list) {
	  return _indexOf(list, a, 0) >= 0;
	};


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(169);
	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 120 */
[2538, 72],
/* 121 */
[2542, 821],
/* 122 */
112,
/* 123 */
[2546, 92, 184, 106],
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(71);
	var hide = __webpack_require__(123);
	var has = __webpack_require__(122);
	var SRC = __webpack_require__(186)('src');
	var $toString = __webpack_require__(2437);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(64).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(164);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 126 */
[2518, 7, 4, 1043, 1850, 1851],
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BASE_URL_II = 'https://260083nlx9.execute-api.us-east-1.amazonaws.com/pdev';
	
	/* const DEV_URL = 'https://9p9dy4z374.execute-api.us-east-1.amazonaws.com/dev';
	const DEV_URL_I = 'https://abt8sc23hl.execute-api.us-east-1.amazonaws.com/dev';
	const DEV_URL_II = 'https://jh2qflzfnh.execute-api.us-east-1.amazonaws.com/dev';
	const DEV_URL_III = 'https://jl6ltp48c0.execute-api.us-east-1.amazonaws.com/dev'; */
	// const SERVICES = 'https://api.dev.myrecruitboard.com/pr';
	// const DASHBOARD = 'https://api.dev.myrecruitboard.com/db';
	// const ELASTIC = 'https://api.dev.myrecruitboard.com/es';
	// const PAYMENT = 'https://api.dev.myrecruitboard.com/pg';
	// const DEV_URL_III = 'https://jl6ltp48c0.execute-api.us-east-1.amazonaws.com/dev';
	//  const SERVICES = 'https://api.dev.myrecruitboard.com/pr';
	//  const DASHBOARD = 'https://api.dev.myrecruitboard.com/db';
	//  const ELASTIC = 'https://api.dev.myrecruitboard.com/es';
	//  const PAYMENT = 'https://api.dev.myrecruitboard.com/pg';
	//  const ADMIN = 'https://bevbzc9j32.execute-api.us-east-1.amazonaws.com/dev/admin';
	var SERVICES = ("https://api.myrecruitboard.com") + '/pr';
	var DASHBOARD = ("https://api.myrecruitboard.com") + '/db';
	var ELASTIC = ("https://api.myrecruitboard.com") + '/es';
	var PAYMENT = ("https://api.myrecruitboard.com") + '/pg';
	var ADMIN = ("https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin");
	
	//  const SERVICES = 'https://api.myrecruitboard.com/pr';
	//  const DASHBOARD = 'https://api.myrecruitboard.com/db';
	//  const ELASTIC = 'https://api.myrecruitboard.com/es';
	//  const PAYMENT = 'https://api.myrecruitboard.com/pg';
	//  const ADMIN = 'https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin';
	
	var SAVE_SA_PROFILE = exports.SAVE_SA_PROFILE = SERVICES + '/saProfile/add/';
	var UPDATE_SA_PROFILE = exports.UPDATE_SA_PROFILE = SERVICES + '/saProfile/update/';
	
	var GET_SA_PROFILE = exports.GET_SA_PROFILE = SERVICES + '/saProfiles/get/';
	var ADD_SA_PROFILE_VIDEO = exports.ADD_SA_PROFILE_VIDEO = SERVICES + '/saProfileVideo/add';
	var SA_PROFILE_SCHOOLS = exports.SA_PROFILE_SCHOOLS = SERVICES + '/divisions/search';
	
	// export const COACH_PROFILE_URL_ENDPOINT = `${DEV_URL}/saProfile/add/`;
	
	var COACH_PROFILE_URL_ENDPOINT = exports.COACH_PROFILE_URL_ENDPOINT = SERVICES + '/saProfile/add/';
	
	// export const GET_SA_DASHBOARD_SCHOOLS = `${DEV_URL_II}/student/colleges`;
	
	var GET_SA_DASHBOARD_SCHOOLS = exports.GET_SA_DASHBOARD_SCHOOLS = ELASTIC + '/student/colleges';
	
	var GET_SA_DASHBOARD_POSTINGS = exports.GET_SA_DASHBOARD_POSTINGS = ELASTIC + '/student/postings';
	
	var SAVE_COACH_PROFILE = exports.SAVE_COACH_PROFILE = SERVICES + '/coaches/add/';
	var GET_COACH_PROFILE = exports.GET_COACH_PROFILE = SERVICES + '/coaches/get/';
	
	var ADD_POSTING = exports.ADD_POSTING = DASHBOARD + '/postings/add';
	var GET_ALL_POSTINGS = exports.GET_ALL_POSTINGS = DASHBOARD + '/postings/getall/';
	var GET_POSTING_BY_ID = exports.GET_POSTING_BY_ID = DASHBOARD + '/postings/get/';
	var UPDATE_POSTING = exports.UPDATE_POSTING = DASHBOARD + '/postings/update/';
	var DELETE_POSTING = exports.DELETE_POSTING = DASHBOARD + '/postings/delete/';
	
	var ADD_TO_WISHLIST = exports.ADD_TO_WISHLIST = SERVICES + '/saInterest/add';
	var REMOVE_FROM_LIST = exports.REMOVE_FROM_LIST = SERVICES + '/saInterest/delete';
	
	var ADD_TO_REQUEST = exports.ADD_TO_REQUEST = DASHBOARD + '/requests/add';
	
	var COACH_GET_REQUEST_LIST = exports.COACH_GET_REQUEST_LIST = DASHBOARD + '/requests/getbyclg/';
	
	var GET_COACH_DASHBOARD_REQUESTS = exports.GET_COACH_DASHBOARD_REQUESTS = DASHBOARD + '/requests/get/';
	
	// payment urls start
	var GET_CLIENT_TOKEN = exports.GET_CLIENT_TOKEN = PAYMENT + '/payment/client_token';
	
	var PUT_PAYMENT_NONCE = exports.PUT_PAYMENT_NONCE = BASE_URL_II + '/payment/customer/34b-37a8-51a0-9e5b-08f6547c7f3d';
	
	// payment urls end
	var POST_SUBSCRIPTION = exports.POST_SUBSCRIPTION = PAYMENT + '/payment/subscribe';
	
	var POST_SUBSCRIPTION_CS = exports.POST_SUBSCRIPTION_CS = BASE_URL_II + '/payment/customerCS';
	
	var GET_ATHLETE_BY_ID = exports.GET_ATHLETE_BY_ID = SERVICES + '/saProfiles/get_pubilc/';
	
	var GET_REQUEST_BY_ID = exports.GET_REQUEST_BY_ID = DASHBOARD + '/requests/getbyid/';
	
	// Request urls
	
	var ADD_CONVERSATION = exports.ADD_CONVERSATION = DASHBOARD + '/requests/add_conversation';
	
	var GET_PAYMENT_HISTORY = exports.GET_PAYMENT_HISTORY = PAYMENT + '/payment/transactions?customerId=';
	
	var SEND_CONTACT_MAIL = exports.SEND_CONTACT_MAIL = DASHBOARD + '/sg/contact';
	
	var VALIDATE_COACH_FROM_DATABASE = exports.VALIDATE_COACH_FROM_DATABASE = ELASTIC + '/coaches/checkdb';
	
	var GET_TOTAL_COUNTS_FOR_DASHBOARD = exports.GET_TOTAL_COUNTS_FOR_DASHBOARD = ELASTIC + '/elastic/getCollegesCount';
	
	var ADD_COACH_APPLICATION = exports.ADD_COACH_APPLICATION = SERVICES + '/coach_applications/add';
	
	var SEARCH_USER_ATHLETE = exports.SEARCH_USER_ATHLETE = ELASTIC + '/students/checkdb';
	
	var UPDATE_COACH_APPLICATION = exports.UPDATE_COACH_APPLICATION = SERVICES + '/coache_applications/update';
	
	var GET_COACHES_APPLICATION = exports.GET_COACHES_APPLICATION = SERVICES + '/coach_applications/getall/';
	
	var GET_ATHLETE_FOR_COACH_BY_ID = exports.GET_ATHLETE_FOR_COACH_BY_ID = DASHBOARD + '/requestTracker/get/';
	
	// export const DELETE_ATHLETE_VIDEO_BY_INDEX = 'https://noq1rs9sik.execute-api.us-east-1.amazonaws.com/dev/removeVideos';
	var DELETE_ATHLETE_VIDEO_BY_INDEX = exports.DELETE_ATHLETE_VIDEO_BY_INDEX = ADMIN + '/removeVideos';
	
	var UPGRADE_STUDENT = exports.UPGRADE_STUDENT = ADMIN + '/upgradeStudent';
	
	var OVERRIDE_DIVISION = exports.OVERRIDE_DIVISION = ADMIN + '/overrideStudent';
	
	var STUDENT_EVALUATION = exports.STUDENT_EVALUATION = ADMIN + '/studentEvaluation';
	
	var DELETE_COACH = exports.DELETE_COACH = ADMIN + '/deleteCoach';
	
	var MODIFY_COLLEGE = exports.MODIFY_COLLEGE = ADMIN + '/modifyCollege';
	
	var ADD_COACH = exports.ADD_COACH = ADMIN + '/addCoach';
	
	var GET_COACHES_FROM_COLLEGES = exports.GET_COACHES_FROM_COLLEGES = SERVICES + '/coaches/getall/';
	
	var ADD_COLLEGE_TO_DB = exports.ADD_COLLEGE_TO_DB = SERVICES + '/college/admin/addCollege';
	
	var ADD_STUDENT_CURRENT_DIVISION = exports.ADD_STUDENT_CURRENT_DIVISION = SERVICES + '/saProfile/addCurrentDivision';
	
	var GET_DIVISION_BASED_STUDENTS = exports.GET_DIVISION_BASED_STUDENTS = SERVICES + '/saProfile/getAllStudentsByDivision';
	
	var GET_FILTER_BASED_STUDENTS = exports.GET_FILTER_BASED_STUDENTS = SERVICES + '/saProfile/filterDivisionStudents';
	
	var GET_TOTAL_REQUEST_VIEWED_COUNT = exports.GET_TOTAL_REQUEST_VIEWED_COUNT = DASHBOARD + '/requests/getCounts/';
	
	var GET_STUDENTS_FOR_STUDENT_EXPLORER = exports.GET_STUDENTS_FOR_STUDENT_EXPLORER = ADMIN + '/getDivisionBasedStudents';
	
	var DELETE_COCAH_APPLICATION = exports.DELETE_COCAH_APPLICATION = ADMIN + '/deleteCoachApplication/';
	
	var RESET_STUDENT_DASHBOARD = exports.RESET_STUDENT_DASHBOARD = ADMIN + '/reset/dashboard/';
	
	var UPDATE_STUDENT_TRIAL = exports.UPDATE_STUDENT_TRIAL = DASHBOARD + '/user/trial';

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.api = exports.DELETE = exports.PUT = exports.POST = exports.GET = undefined;
	exports.fetchJSON = fetchJSON;
	exports.fetchPublicJSON = fetchPublicJSON;
	exports.fetchPublicCOACH = fetchPublicCOACH;
	
	var _aws = __webpack_require__(391);
	
	var _aws2 = _interopRequireDefault(_aws);
	
	var _isomorphicFetch = __webpack_require__(1637);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	__webpack_require__(1426);
	
	var _amazonCognitoIdentityJs = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userPool = new _amazonCognitoIdentityJs.CognitoUserPool(_aws2.default.pool); // eslint-disable-line
	
	function getAccessToken() {
	  return new Promise(function (resolve, reject) {
	    var user = userPool.getCurrentUser();
	    if (user) {
	      user.getSession(function (error, response) {
	        if (error) {
	          reject(error);
	        } else {
	          resolve(response.getIdToken().getJwtToken());
	        }
	      });
	    }
	  });
	}
	
	var GET = exports.GET = 'GET';
	var POST = exports.POST = 'POST';
	var PUT = exports.PUT = 'PUT';
	var DELETE = exports.DELETE = 'DELETE';
	var api = exports.api = 'https://apidev.leancubes.com/myrecboard';
	
	function fetchJSON(url) {
	  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GET;
	  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	  var modifiedHeaders = {
	    'Content-Type': 'application/json'
	  };
	  return getAccessToken().then(function (token) {
	    modifiedHeaders = Object.assign({}, modifiedHeaders, { Authorization: token }, headers);
	    if (method === POST || method === PUT) {
	      modifiedHeaders = Object.assign({}, modifiedHeaders, {
	        'Content-Type': 'application/json',
	        Accept: 'application/jsobgDesktopn'
	      });
	      return (0, _isomorphicFetch2.default)(url, {
	        method: method,
	        headers: modifiedHeaders,
	        params: params,
	        body: JSON.stringify(body)
	      }).then(function (response) {
	        if (response.ok) {
	          return response.json();
	        }
	        var res = response.json();
	        res.then(function (item) {
	          return { error: item, err: false };
	        });
	        return res;
	      });
	    }
	    return (0, _isomorphicFetch2.default)(url, {
	      method: method,
	      headers: modifiedHeaders,
	      params: params
	    }).then(function (response) {
	      if (response.ok) {
	        return response.json();
	      }
	      var res = response.json();
	      res.then(function (item) {
	        return { error: item, err: false };
	      });
	      return res;
	    });
	  });
	}
	function fetchPublicJSON(url) {
	  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GET;
	
	  var modifiedHeaders = {
	    'Content-Type': 'application/json'
	  };
	  return (0, _isomorphicFetch2.default)(url, {
	    method: method,
	    headers: modifiedHeaders
	  }).then(function (response) {
	    if (response.ok) {
	      return response.json();
	    }
	    throw new Error(response.json());
	  });
	}
	
	function fetchPublicCOACH(url) {
	  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GET;
	  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var modifiedHeaders = {
	    'Content-Type': 'application/json'
	  };
	  return (0, _isomorphicFetch2.default)(url, {
	    method: method,
	    headers: modifiedHeaders,
	    body: JSON.stringify(body)
	  }).then(function (response) {
	    if (response.ok) {
	      return response.json();
	    }
	    throw new Error(response.json());
	  });
	}

/***/ },
/* 129 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'DASHBOARD_REQUESTED';
	var FAILED = exports.FAILED = 'DASHBOARD_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'DASHBOARD_SUCCESSFUL';
	var SUCCESSFUL_POSTINGS = exports.SUCCESSFUL_POSTINGS = 'DASHBOARD_SUCCESSFUL_POSTINGS';
	var SUCCESSFUL_REQUESTS = exports.SUCCESSFUL_REQUESTS = 'DASHBOARD_SUCCESSFUL_REQUESTS';
	
	var UPDATE_FILTER = exports.UPDATE_FILTER = 'DASHBOARD_FILTER';
	var FILTER_REQUESTED = exports.FILTER_REQUESTED = 'FILTER_REQUESTED';
	var FILTER_FAILED = exports.FILTER_FAILED = 'FILTER_FAILED';
	var LOADING = exports.LOADING = 'DASHBOARD_LOADING';
	var INIT = exports.INIT = 'DASHBOARD_INIT';
	
	var UPDATE_IGNORELIST = exports.UPDATE_IGNORELIST = 'DASHBOARD_UPDATE_IGNORELIST';
	var UPDATE_WISHLIST = exports.UPDATE_WISHLIST = 'DASHBOARD_UPDATE_WISHLIST';
	var UPDATE_CONTACTEDLIST = exports.UPDATE_CONTACTEDLIST = 'DASHBOARD_UPDATE_CONTACTEDLIST';
	
	var UPDATE_CONTACTED = exports.UPDATE_CONTACTED = 'DASHBOARD_UPDATE_CONTACTED';
	
	var GET_TOTAL_COUNTS_REQUESTED = exports.GET_TOTAL_COUNTS_REQUESTED = 'GET_TOTAL_COUNTS_REQUESTED';
	var GET_TOTAL_COUNTS_SUCCESSFULL = exports.GET_TOTAL_COUNTS_SUCCESSFULL = 'GET_TOTAL_COUNTS_SUCCESSFUL';
	var GET_TOTAL_COUNTS_FAILED = exports.GET_TOTAL_COUNTS_FAILED = 'GET_TOTAL_COUNTS_FAILED';
	
	var REMOVE_LOADER = exports.REMOVE_LOADER = 'REMOVE_LOADER';
	
	var SYNC_DATA = exports.SYNC_DATA = 'SYNC_DATA';
	var SYNC_FAILED = exports.SYNC_FAILED = 'SYNC_FAILED';
	
	var CONTACTED_COUNT = exports.CONTACTED_COUNT = 'CONTACTED_COUNT';
	
	var ADD_STUDENT_CURRENT_DIVISION = exports.ADD_STUDENT_CURRENT_DIVISION = 'ADD_STUDENT_CURRENT_DIVISION';
	var ADD_CURRENT_DIVISION_FAILED = exports.ADD_CURRENT_DIVISION_FAILED = 'ADD_CURRENT_DIVISION_FAILED';
	var ADD_CURRENT_DIVISION_REQUESTED = exports.ADD_CURRENT_DIVISION_REQUESTED = 'ADD_CURRENT_DIVISION_REQUESTED';
	
	var REQUEST_VIEWED_COUNT_FAILED = exports.REQUEST_VIEWED_COUNT_FAILED = 'REQUEST_VIEWED_COUNT_FAILED';
	var REQUEST_VIEWED_COUNT_SUCCESSFUL = exports.REQUEST_VIEWED_COUNT_SUCCESSFUL = 'REQUEST_VIEWED_COUNT_SUCCESSFUL';
	var REQUEST_VIEWED_COUNT_REQUESTED = exports.REQUEST_VIEWED_COUNT_REQUESTED = 'REQUEST_VIEWED_COUNT_REQUESTED';

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOGIN_REQUESTED = exports.LOGIN_REQUESTED = 'LOGIN_REQUESTED';
	var LOGIN_FAILED = exports.LOGIN_FAILED = 'LOGIN_FAILED';
	var LOGIN_SUCCESSFUL = exports.LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';

/***/ },
/* 131 */
[2538, 134],
/* 132 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 133 */
[2546, 99, 163, 96],
/* 134 */
72,
/* 135 */
[2572, 492, 293],
/* 136 */
[2574, 293],
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 138 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	(function(exports) {
	  "use strict";
	
	  function isArray(obj) {
	    if (obj !== null) {
	      return Object.prototype.toString.call(obj) === "[object Array]";
	    } else {
	      return false;
	    }
	  }
	
	  function isObject(obj) {
	    if (obj !== null) {
	      return Object.prototype.toString.call(obj) === "[object Object]";
	    } else {
	      return false;
	    }
	  }
	
	  function strictDeepEqual(first, second) {
	    // Check the scalar case first.
	    if (first === second) {
	      return true;
	    }
	
	    // Check if they are the same type.
	    var firstType = Object.prototype.toString.call(first);
	    if (firstType !== Object.prototype.toString.call(second)) {
	      return false;
	    }
	    // We know that first and second have the same type so we can just check the
	    // first type from now on.
	    if (isArray(first) === true) {
	      // Short circuit if they're not the same length;
	      if (first.length !== second.length) {
	        return false;
	      }
	      for (var i = 0; i < first.length; i++) {
	        if (strictDeepEqual(first[i], second[i]) === false) {
	          return false;
	        }
	      }
	      return true;
	    }
	    if (isObject(first) === true) {
	      // An object is equal if it has the same key/value pairs.
	      var keysSeen = {};
	      for (var key in first) {
	        if (hasOwnProperty.call(first, key)) {
	          if (strictDeepEqual(first[key], second[key]) === false) {
	            return false;
	          }
	          keysSeen[key] = true;
	        }
	      }
	      // Now check that there aren't any keys in second that weren't
	      // in first.
	      for (var key2 in second) {
	        if (hasOwnProperty.call(second, key2)) {
	          if (keysSeen[key2] !== true) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	    return false;
	  }
	
	  function isFalse(obj) {
	    // From the spec:
	    // A false value corresponds to the following values:
	    // Empty list
	    // Empty object
	    // Empty string
	    // False boolean
	    // null value
	
	    // First check the scalar values.
	    if (obj === "" || obj === false || obj === null) {
	        return true;
	    } else if (isArray(obj) && obj.length === 0) {
	        // Check for an empty array.
	        return true;
	    } else if (isObject(obj)) {
	        // Check for an empty object.
	        for (var key in obj) {
	            // If there are any keys, then
	            // the object is not empty so the object
	            // is not false.
	            if (obj.hasOwnProperty(key)) {
	              return false;
	            }
	        }
	        return true;
	    } else {
	        return false;
	    }
	  }
	
	  function objValues(obj) {
	    var keys = Object.keys(obj);
	    var values = [];
	    for (var i = 0; i < keys.length; i++) {
	      values.push(obj[keys[i]]);
	    }
	    return values;
	  }
	
	  function merge(a, b) {
	      var merged = {};
	      for (var key in a) {
	          merged[key] = a[key];
	      }
	      for (var key2 in b) {
	          merged[key2] = b[key2];
	      }
	      return merged;
	  }
	
	  var trimLeft;
	  if (typeof String.prototype.trimLeft === "function") {
	    trimLeft = function(str) {
	      return str.trimLeft();
	    };
	  } else {
	    trimLeft = function(str) {
	      return str.match(/^\s*(.*)/)[1];
	    };
	  }
	
	  // Type constants used to define functions.
	  var TYPE_NUMBER = 0;
	  var TYPE_ANY = 1;
	  var TYPE_STRING = 2;
	  var TYPE_ARRAY = 3;
	  var TYPE_OBJECT = 4;
	  var TYPE_BOOLEAN = 5;
	  var TYPE_EXPREF = 6;
	  var TYPE_NULL = 7;
	  var TYPE_ARRAY_NUMBER = 8;
	  var TYPE_ARRAY_STRING = 9;
	
	  var TOK_EOF = "EOF";
	  var TOK_UNQUOTEDIDENTIFIER = "UnquotedIdentifier";
	  var TOK_QUOTEDIDENTIFIER = "QuotedIdentifier";
	  var TOK_RBRACKET = "Rbracket";
	  var TOK_RPAREN = "Rparen";
	  var TOK_COMMA = "Comma";
	  var TOK_COLON = "Colon";
	  var TOK_RBRACE = "Rbrace";
	  var TOK_NUMBER = "Number";
	  var TOK_CURRENT = "Current";
	  var TOK_EXPREF = "Expref";
	  var TOK_PIPE = "Pipe";
	  var TOK_OR = "Or";
	  var TOK_AND = "And";
	  var TOK_EQ = "EQ";
	  var TOK_GT = "GT";
	  var TOK_LT = "LT";
	  var TOK_GTE = "GTE";
	  var TOK_LTE = "LTE";
	  var TOK_NE = "NE";
	  var TOK_FLATTEN = "Flatten";
	  var TOK_STAR = "Star";
	  var TOK_FILTER = "Filter";
	  var TOK_DOT = "Dot";
	  var TOK_NOT = "Not";
	  var TOK_LBRACE = "Lbrace";
	  var TOK_LBRACKET = "Lbracket";
	  var TOK_LPAREN= "Lparen";
	  var TOK_LITERAL= "Literal";
	
	  // The "&", "[", "<", ">" tokens
	  // are not in basicToken because
	  // there are two token variants
	  // ("&&", "[?", "<=", ">=").  This is specially handled
	  // below.
	
	  var basicTokens = {
	    ".": TOK_DOT,
	    "*": TOK_STAR,
	    ",": TOK_COMMA,
	    ":": TOK_COLON,
	    "{": TOK_LBRACE,
	    "}": TOK_RBRACE,
	    "]": TOK_RBRACKET,
	    "(": TOK_LPAREN,
	    ")": TOK_RPAREN,
	    "@": TOK_CURRENT
	  };
	
	  var operatorStartToken = {
	      "<": true,
	      ">": true,
	      "=": true,
	      "!": true
	  };
	
	  var skipChars = {
	      " ": true,
	      "\t": true,
	      "\n": true
	  };
	
	
	  function isAlpha(ch) {
	      return (ch >= "a" && ch <= "z") ||
	             (ch >= "A" && ch <= "Z") ||
	             ch === "_";
	  }
	
	  function isNum(ch) {
	      return (ch >= "0" && ch <= "9") ||
	             ch === "-";
	  }
	  function isAlphaNum(ch) {
	      return (ch >= "a" && ch <= "z") ||
	             (ch >= "A" && ch <= "Z") ||
	             (ch >= "0" && ch <= "9") ||
	             ch === "_";
	  }
	
	  function Lexer() {
	  }
	  Lexer.prototype = {
	      tokenize: function(stream) {
	          var tokens = [];
	          this._current = 0;
	          var start;
	          var identifier;
	          var token;
	          while (this._current < stream.length) {
	              if (isAlpha(stream[this._current])) {
	                  start = this._current;
	                  identifier = this._consumeUnquotedIdentifier(stream);
	                  tokens.push({type: TOK_UNQUOTEDIDENTIFIER,
	                               value: identifier,
	                               start: start});
	              } else if (basicTokens[stream[this._current]] !== undefined) {
	                  tokens.push({type: basicTokens[stream[this._current]],
	                              value: stream[this._current],
	                              start: this._current});
	                  this._current++;
	              } else if (isNum(stream[this._current])) {
	                  token = this._consumeNumber(stream);
	                  tokens.push(token);
	              } else if (stream[this._current] === "[") {
	                  // No need to increment this._current.  This happens
	                  // in _consumeLBracket
	                  token = this._consumeLBracket(stream);
	                  tokens.push(token);
	              } else if (stream[this._current] === "\"") {
	                  start = this._current;
	                  identifier = this._consumeQuotedIdentifier(stream);
	                  tokens.push({type: TOK_QUOTEDIDENTIFIER,
	                               value: identifier,
	                               start: start});
	              } else if (stream[this._current] === "'") {
	                  start = this._current;
	                  identifier = this._consumeRawStringLiteral(stream);
	                  tokens.push({type: TOK_LITERAL,
	                               value: identifier,
	                               start: start});
	              } else if (stream[this._current] === "`") {
	                  start = this._current;
	                  var literal = this._consumeLiteral(stream);
	                  tokens.push({type: TOK_LITERAL,
	                               value: literal,
	                               start: start});
	              } else if (operatorStartToken[stream[this._current]] !== undefined) {
	                  tokens.push(this._consumeOperator(stream));
	              } else if (skipChars[stream[this._current]] !== undefined) {
	                  // Ignore whitespace.
	                  this._current++;
	              } else if (stream[this._current] === "&") {
	                  start = this._current;
	                  this._current++;
	                  if (stream[this._current] === "&") {
	                      this._current++;
	                      tokens.push({type: TOK_AND, value: "&&", start: start});
	                  } else {
	                      tokens.push({type: TOK_EXPREF, value: "&", start: start});
	                  }
	              } else if (stream[this._current] === "|") {
	                  start = this._current;
	                  this._current++;
	                  if (stream[this._current] === "|") {
	                      this._current++;
	                      tokens.push({type: TOK_OR, value: "||", start: start});
	                  } else {
	                      tokens.push({type: TOK_PIPE, value: "|", start: start});
	                  }
	              } else {
	                  var error = new Error("Unknown character:" + stream[this._current]);
	                  error.name = "LexerError";
	                  throw error;
	              }
	          }
	          return tokens;
	      },
	
	      _consumeUnquotedIdentifier: function(stream) {
	          var start = this._current;
	          this._current++;
	          while (this._current < stream.length && isAlphaNum(stream[this._current])) {
	              this._current++;
	          }
	          return stream.slice(start, this._current);
	      },
	
	      _consumeQuotedIdentifier: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (stream[this._current] !== "\"" && this._current < maxLength) {
	              // You can escape a double quote and you can escape an escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "\"")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          this._current++;
	          return JSON.parse(stream.slice(start, this._current));
	      },
	
	      _consumeRawStringLiteral: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (stream[this._current] !== "'" && this._current < maxLength) {
	              // You can escape a single quote and you can escape an escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "'")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          this._current++;
	          var literal = stream.slice(start + 1, this._current - 1);
	          return literal.replace("\\'", "'");
	      },
	
	      _consumeNumber: function(stream) {
	          var start = this._current;
	          this._current++;
	          var maxLength = stream.length;
	          while (isNum(stream[this._current]) && this._current < maxLength) {
	              this._current++;
	          }
	          var value = parseInt(stream.slice(start, this._current));
	          return {type: TOK_NUMBER, value: value, start: start};
	      },
	
	      _consumeLBracket: function(stream) {
	          var start = this._current;
	          this._current++;
	          if (stream[this._current] === "?") {
	              this._current++;
	              return {type: TOK_FILTER, value: "[?", start: start};
	          } else if (stream[this._current] === "]") {
	              this._current++;
	              return {type: TOK_FLATTEN, value: "[]", start: start};
	          } else {
	              return {type: TOK_LBRACKET, value: "[", start: start};
	          }
	      },
	
	      _consumeOperator: function(stream) {
	          var start = this._current;
	          var startingChar = stream[start];
	          this._current++;
	          if (startingChar === "!") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_NE, value: "!=", start: start};
	              } else {
	                return {type: TOK_NOT, value: "!", start: start};
	              }
	          } else if (startingChar === "<") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_LTE, value: "<=", start: start};
	              } else {
	                  return {type: TOK_LT, value: "<", start: start};
	              }
	          } else if (startingChar === ">") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_GTE, value: ">=", start: start};
	              } else {
	                  return {type: TOK_GT, value: ">", start: start};
	              }
	          } else if (startingChar === "=") {
	              if (stream[this._current] === "=") {
	                  this._current++;
	                  return {type: TOK_EQ, value: "==", start: start};
	              }
	          }
	      },
	
	      _consumeLiteral: function(stream) {
	          this._current++;
	          var start = this._current;
	          var maxLength = stream.length;
	          var literal;
	          while(stream[this._current] !== "`" && this._current < maxLength) {
	              // You can escape a literal char or you can escape the escape.
	              var current = this._current;
	              if (stream[current] === "\\" && (stream[current + 1] === "\\" ||
	                                               stream[current + 1] === "`")) {
	                  current += 2;
	              } else {
	                  current++;
	              }
	              this._current = current;
	          }
	          var literalString = trimLeft(stream.slice(start, this._current));
	          literalString = literalString.replace("\\`", "`");
	          if (this._looksLikeJSON(literalString)) {
	              literal = JSON.parse(literalString);
	          } else {
	              // Try to JSON parse it as "<literal>"
	              literal = JSON.parse("\"" + literalString + "\"");
	          }
	          // +1 gets us to the ending "`", +1 to move on to the next char.
	          this._current++;
	          return literal;
	      },
	
	      _looksLikeJSON: function(literalString) {
	          var startingChars = "[{\"";
	          var jsonLiterals = ["true", "false", "null"];
	          var numberLooking = "-0123456789";
	
	          if (literalString === "") {
	              return false;
	          } else if (startingChars.indexOf(literalString[0]) >= 0) {
	              return true;
	          } else if (jsonLiterals.indexOf(literalString) >= 0) {
	              return true;
	          } else if (numberLooking.indexOf(literalString[0]) >= 0) {
	              try {
	                  JSON.parse(literalString);
	                  return true;
	              } catch (ex) {
	                  return false;
	              }
	          } else {
	              return false;
	          }
	      }
	  };
	
	      var bindingPower = {};
	      bindingPower[TOK_EOF] = 0;
	      bindingPower[TOK_UNQUOTEDIDENTIFIER] = 0;
	      bindingPower[TOK_QUOTEDIDENTIFIER] = 0;
	      bindingPower[TOK_RBRACKET] = 0;
	      bindingPower[TOK_RPAREN] = 0;
	      bindingPower[TOK_COMMA] = 0;
	      bindingPower[TOK_RBRACE] = 0;
	      bindingPower[TOK_NUMBER] = 0;
	      bindingPower[TOK_CURRENT] = 0;
	      bindingPower[TOK_EXPREF] = 0;
	      bindingPower[TOK_PIPE] = 1;
	      bindingPower[TOK_OR] = 2;
	      bindingPower[TOK_AND] = 3;
	      bindingPower[TOK_EQ] = 5;
	      bindingPower[TOK_GT] = 5;
	      bindingPower[TOK_LT] = 5;
	      bindingPower[TOK_GTE] = 5;
	      bindingPower[TOK_LTE] = 5;
	      bindingPower[TOK_NE] = 5;
	      bindingPower[TOK_FLATTEN] = 9;
	      bindingPower[TOK_STAR] = 20;
	      bindingPower[TOK_FILTER] = 21;
	      bindingPower[TOK_DOT] = 40;
	      bindingPower[TOK_NOT] = 45;
	      bindingPower[TOK_LBRACE] = 50;
	      bindingPower[TOK_LBRACKET] = 55;
	      bindingPower[TOK_LPAREN] = 60;
	
	  function Parser() {
	  }
	
	  Parser.prototype = {
	      parse: function(expression) {
	          this._loadTokens(expression);
	          this.index = 0;
	          var ast = this.expression(0);
	          if (this._lookahead(0) !== TOK_EOF) {
	              var t = this._lookaheadToken(0);
	              var error = new Error(
	                  "Unexpected token type: " + t.type + ", value: " + t.value);
	              error.name = "ParserError";
	              throw error;
	          }
	          return ast;
	      },
	
	      _loadTokens: function(expression) {
	          var lexer = new Lexer();
	          var tokens = lexer.tokenize(expression);
	          tokens.push({type: TOK_EOF, value: "", start: expression.length});
	          this.tokens = tokens;
	      },
	
	      expression: function(rbp) {
	          var leftToken = this._lookaheadToken(0);
	          this._advance();
	          var left = this.nud(leftToken);
	          var currentToken = this._lookahead(0);
	          while (rbp < bindingPower[currentToken]) {
	              this._advance();
	              left = this.led(currentToken, left);
	              currentToken = this._lookahead(0);
	          }
	          return left;
	      },
	
	      _lookahead: function(number) {
	          return this.tokens[this.index + number].type;
	      },
	
	      _lookaheadToken: function(number) {
	          return this.tokens[this.index + number];
	      },
	
	      _advance: function() {
	          this.index++;
	      },
	
	      nud: function(token) {
	        var left;
	        var right;
	        var expression;
	        switch (token.type) {
	          case TOK_LITERAL:
	            return {type: "Literal", value: token.value};
	          case TOK_UNQUOTEDIDENTIFIER:
	            return {type: "Field", name: token.value};
	          case TOK_QUOTEDIDENTIFIER:
	            var node = {type: "Field", name: token.value};
	            if (this._lookahead(0) === TOK_LPAREN) {
	                throw new Error("Quoted identifier not allowed for function names.");
	            } else {
	                return node;
	            }
	            break;
	          case TOK_NOT:
	            right = this.expression(bindingPower.Not);
	            return {type: "NotExpression", children: [right]};
	          case TOK_STAR:
	            left = {type: "Identity"};
	            right = null;
	            if (this._lookahead(0) === TOK_RBRACKET) {
	                // This can happen in a multiselect,
	                // [a, b, *]
	                right = {type: "Identity"};
	            } else {
	                right = this._parseProjectionRHS(bindingPower.Star);
	            }
	            return {type: "ValueProjection", children: [left, right]};
	          case TOK_FILTER:
	            return this.led(token.type, {type: "Identity"});
	          case TOK_LBRACE:
	            return this._parseMultiselectHash();
	          case TOK_FLATTEN:
	            left = {type: TOK_FLATTEN, children: [{type: "Identity"}]};
	            right = this._parseProjectionRHS(bindingPower.Flatten);
	            return {type: "Projection", children: [left, right]};
	          case TOK_LBRACKET:
	            if (this._lookahead(0) === TOK_NUMBER || this._lookahead(0) === TOK_COLON) {
	                right = this._parseIndexExpression();
	                return this._projectIfSlice({type: "Identity"}, right);
	            } else if (this._lookahead(0) === TOK_STAR &&
	                       this._lookahead(1) === TOK_RBRACKET) {
	                this._advance();
	                this._advance();
	                right = this._parseProjectionRHS(bindingPower.Star);
	                return {type: "Projection",
	                        children: [{type: "Identity"}, right]};
	            } else {
	                return this._parseMultiselectList();
	            }
	            break;
	          case TOK_CURRENT:
	            return {type: TOK_CURRENT};
	          case TOK_EXPREF:
	            expression = this.expression(bindingPower.Expref);
	            return {type: "ExpressionReference", children: [expression]};
	          case TOK_LPAREN:
	            var args = [];
	            while (this._lookahead(0) !== TOK_RPAREN) {
	              if (this._lookahead(0) === TOK_CURRENT) {
	                expression = {type: TOK_CURRENT};
	                this._advance();
	              } else {
	                expression = this.expression(0);
	              }
	              args.push(expression);
	            }
	            this._match(TOK_RPAREN);
	            return args[0];
	          default:
	            this._errorToken(token);
	        }
	      },
	
	      led: function(tokenName, left) {
	        var right;
	        switch(tokenName) {
	          case TOK_DOT:
	            var rbp = bindingPower.Dot;
	            if (this._lookahead(0) !== TOK_STAR) {
	                right = this._parseDotRHS(rbp);
	                return {type: "Subexpression", children: [left, right]};
	            } else {
	                // Creating a projection.
	                this._advance();
	                right = this._parseProjectionRHS(rbp);
	                return {type: "ValueProjection", children: [left, right]};
	            }
	            break;
	          case TOK_PIPE:
	            right = this.expression(bindingPower.Pipe);
	            return {type: TOK_PIPE, children: [left, right]};
	          case TOK_OR:
	            right = this.expression(bindingPower.Or);
	            return {type: "OrExpression", children: [left, right]};
	          case TOK_AND:
	            right = this.expression(bindingPower.And);
	            return {type: "AndExpression", children: [left, right]};
	          case TOK_LPAREN:
	            var name = left.name;
	            var args = [];
	            var expression, node;
	            while (this._lookahead(0) !== TOK_RPAREN) {
	              if (this._lookahead(0) === TOK_CURRENT) {
	                expression = {type: TOK_CURRENT};
	                this._advance();
	              } else {
	                expression = this.expression(0);
	              }
	              if (this._lookahead(0) === TOK_COMMA) {
	                this._match(TOK_COMMA);
	              }
	              args.push(expression);
	            }
	            this._match(TOK_RPAREN);
	            node = {type: "Function", name: name, children: args};
	            return node;
	          case TOK_FILTER:
	            var condition = this.expression(0);
	            this._match(TOK_RBRACKET);
	            if (this._lookahead(0) === TOK_FLATTEN) {
	              right = {type: "Identity"};
	            } else {
	              right = this._parseProjectionRHS(bindingPower.Filter);
	            }
	            return {type: "FilterProjection", children: [left, right, condition]};
	          case TOK_FLATTEN:
	            var leftNode = {type: TOK_FLATTEN, children: [left]};
	            var rightNode = this._parseProjectionRHS(bindingPower.Flatten);
	            return {type: "Projection", children: [leftNode, rightNode]};
	          case TOK_EQ:
	          case TOK_NE:
	          case TOK_GT:
	          case TOK_GTE:
	          case TOK_LT:
	          case TOK_LTE:
	            return this._parseComparator(left, tokenName);
	          case TOK_LBRACKET:
	            var token = this._lookaheadToken(0);
	            if (token.type === TOK_NUMBER || token.type === TOK_COLON) {
	                right = this._parseIndexExpression();
	                return this._projectIfSlice(left, right);
	            } else {
	                this._match(TOK_STAR);
	                this._match(TOK_RBRACKET);
	                right = this._parseProjectionRHS(bindingPower.Star);
	                return {type: "Projection", children: [left, right]};
	            }
	            break;
	          default:
	            this._errorToken(this._lookaheadToken(0));
	        }
	      },
	
	      _match: function(tokenType) {
	          if (this._lookahead(0) === tokenType) {
	              this._advance();
	          } else {
	              var t = this._lookaheadToken(0);
	              var error = new Error("Expected " + tokenType + ", got: " + t.type);
	              error.name = "ParserError";
	              throw error;
	          }
	      },
	
	      _errorToken: function(token) {
	          var error = new Error("Invalid token (" +
	                                token.type + "): \"" +
	                                token.value + "\"");
	          error.name = "ParserError";
	          throw error;
	      },
	
	
	      _parseIndexExpression: function() {
	          if (this._lookahead(0) === TOK_COLON || this._lookahead(1) === TOK_COLON) {
	              return this._parseSliceExpression();
	          } else {
	              var node = {
	                  type: "Index",
	                  value: this._lookaheadToken(0).value};
	              this._advance();
	              this._match(TOK_RBRACKET);
	              return node;
	          }
	      },
	
	      _projectIfSlice: function(left, right) {
	          var indexExpr = {type: "IndexExpression", children: [left, right]};
	          if (right.type === "Slice") {
	              return {
	                  type: "Projection",
	                  children: [indexExpr, this._parseProjectionRHS(bindingPower.Star)]
	              };
	          } else {
	              return indexExpr;
	          }
	      },
	
	      _parseSliceExpression: function() {
	          // [start:end:step] where each part is optional, as well as the last
	          // colon.
	          var parts = [null, null, null];
	          var index = 0;
	          var currentToken = this._lookahead(0);
	          while (currentToken !== TOK_RBRACKET && index < 3) {
	              if (currentToken === TOK_COLON) {
	                  index++;
	                  this._advance();
	              } else if (currentToken === TOK_NUMBER) {
	                  parts[index] = this._lookaheadToken(0).value;
	                  this._advance();
	              } else {
	                  var t = this._lookahead(0);
	                  var error = new Error("Syntax error, unexpected token: " +
	                                        t.value + "(" + t.type + ")");
	                  error.name = "Parsererror";
	                  throw error;
	              }
	              currentToken = this._lookahead(0);
	          }
	          this._match(TOK_RBRACKET);
	          return {
	              type: "Slice",
	              children: parts
	          };
	      },
	
	      _parseComparator: function(left, comparator) {
	        var right = this.expression(bindingPower[comparator]);
	        return {type: "Comparator", name: comparator, children: [left, right]};
	      },
	
	      _parseDotRHS: function(rbp) {
	          var lookahead = this._lookahead(0);
	          var exprTokens = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER, TOK_STAR];
	          if (exprTokens.indexOf(lookahead) >= 0) {
	              return this.expression(rbp);
	          } else if (lookahead === TOK_LBRACKET) {
	              this._match(TOK_LBRACKET);
	              return this._parseMultiselectList();
	          } else if (lookahead === TOK_LBRACE) {
	              this._match(TOK_LBRACE);
	              return this._parseMultiselectHash();
	          }
	      },
	
	      _parseProjectionRHS: function(rbp) {
	          var right;
	          if (bindingPower[this._lookahead(0)] < 10) {
	              right = {type: "Identity"};
	          } else if (this._lookahead(0) === TOK_LBRACKET) {
	              right = this.expression(rbp);
	          } else if (this._lookahead(0) === TOK_FILTER) {
	              right = this.expression(rbp);
	          } else if (this._lookahead(0) === TOK_DOT) {
	              this._match(TOK_DOT);
	              right = this._parseDotRHS(rbp);
	          } else {
	              var t = this._lookaheadToken(0);
	              var error = new Error("Sytanx error, unexpected token: " +
	                                    t.value + "(" + t.type + ")");
	              error.name = "ParserError";
	              throw error;
	          }
	          return right;
	      },
	
	      _parseMultiselectList: function() {
	          var expressions = [];
	          while (this._lookahead(0) !== TOK_RBRACKET) {
	              var expression = this.expression(0);
	              expressions.push(expression);
	              if (this._lookahead(0) === TOK_COMMA) {
	                  this._match(TOK_COMMA);
	                  if (this._lookahead(0) === TOK_RBRACKET) {
	                    throw new Error("Unexpected token Rbracket");
	                  }
	              }
	          }
	          this._match(TOK_RBRACKET);
	          return {type: "MultiSelectList", children: expressions};
	      },
	
	      _parseMultiselectHash: function() {
	        var pairs = [];
	        var identifierTypes = [TOK_UNQUOTEDIDENTIFIER, TOK_QUOTEDIDENTIFIER];
	        var keyToken, keyName, value, node;
	        for (;;) {
	          keyToken = this._lookaheadToken(0);
	          if (identifierTypes.indexOf(keyToken.type) < 0) {
	            throw new Error("Expecting an identifier token, got: " +
	                            keyToken.type);
	          }
	          keyName = keyToken.value;
	          this._advance();
	          this._match(TOK_COLON);
	          value = this.expression(0);
	          node = {type: "KeyValuePair", name: keyName, value: value};
	          pairs.push(node);
	          if (this._lookahead(0) === TOK_COMMA) {
	            this._match(TOK_COMMA);
	          } else if (this._lookahead(0) === TOK_RBRACE) {
	            this._match(TOK_RBRACE);
	            break;
	          }
	        }
	        return {type: "MultiSelectHash", children: pairs};
	      }
	  };
	
	
	  function TreeInterpreter(runtime) {
	    this.runtime = runtime;
	  }
	
	  TreeInterpreter.prototype = {
	      search: function(node, value) {
	          return this.visit(node, value);
	      },
	
	      visit: function(node, value) {
	          var matched, current, result, first, second, field, left, right, collected, i;
	          switch (node.type) {
	            case "Field":
	              if (value === null ) {
	                  return null;
	              } else if (isObject(value)) {
	                  field = value[node.name];
	                  if (field === undefined) {
	                      return null;
	                  } else {
	                      return field;
	                  }
	              } else {
	                return null;
	              }
	              break;
	            case "Subexpression":
	              result = this.visit(node.children[0], value);
	              for (i = 1; i < node.children.length; i++) {
	                  result = this.visit(node.children[1], result);
	                  if (result === null) {
	                      return null;
	                  }
	              }
	              return result;
	            case "IndexExpression":
	              left = this.visit(node.children[0], value);
	              right = this.visit(node.children[1], left);
	              return right;
	            case "Index":
	              if (!isArray(value)) {
	                return null;
	              }
	              var index = node.value;
	              if (index < 0) {
	                index = value.length + index;
	              }
	              result = value[index];
	              if (result === undefined) {
	                result = null;
	              }
	              return result;
	            case "Slice":
	              if (!isArray(value)) {
	                return null;
	              }
	              var sliceParams = node.children.slice(0);
	              var computed = this.computeSliceParams(value.length, sliceParams);
	              var start = computed[0];
	              var stop = computed[1];
	              var step = computed[2];
	              result = [];
	              if (step > 0) {
	                  for (i = start; i < stop; i += step) {
	                      result.push(value[i]);
	                  }
	              } else {
	                  for (i = start; i > stop; i += step) {
	                      result.push(value[i]);
	                  }
	              }
	              return result;
	            case "Projection":
	              // Evaluate left child.
	              var base = this.visit(node.children[0], value);
	              if (!isArray(base)) {
	                return null;
	              }
	              collected = [];
	              for (i = 0; i < base.length; i++) {
	                current = this.visit(node.children[1], base[i]);
	                if (current !== null) {
	                  collected.push(current);
	                }
	              }
	              return collected;
	            case "ValueProjection":
	              // Evaluate left child.
	              base = this.visit(node.children[0], value);
	              if (!isObject(base)) {
	                return null;
	              }
	              collected = [];
	              var values = objValues(base);
	              for (i = 0; i < values.length; i++) {
	                current = this.visit(node.children[1], values[i]);
	                if (current !== null) {
	                  collected.push(current);
	                }
	              }
	              return collected;
	            case "FilterProjection":
	              base = this.visit(node.children[0], value);
	              if (!isArray(base)) {
	                return null;
	              }
	              var filtered = [];
	              var finalResults = [];
	              for (i = 0; i < base.length; i++) {
	                matched = this.visit(node.children[2], base[i]);
	                if (!isFalse(matched)) {
	                  filtered.push(base[i]);
	                }
	              }
	              for (var j = 0; j < filtered.length; j++) {
	                current = this.visit(node.children[1], filtered[j]);
	                if (current !== null) {
	                  finalResults.push(current);
	                }
	              }
	              return finalResults;
	            case "Comparator":
	              first = this.visit(node.children[0], value);
	              second = this.visit(node.children[1], value);
	              switch(node.name) {
	                case TOK_EQ:
	                  result = strictDeepEqual(first, second);
	                  break;
	                case TOK_NE:
	                  result = !strictDeepEqual(first, second);
	                  break;
	                case TOK_GT:
	                  result = first > second;
	                  break;
	                case TOK_GTE:
	                  result = first >= second;
	                  break;
	                case TOK_LT:
	                  result = first < second;
	                  break;
	                case TOK_LTE:
	                  result = first <= second;
	                  break;
	                default:
	                  throw new Error("Unknown comparator: " + node.name);
	              }
	              return result;
	            case TOK_FLATTEN:
	              var original = this.visit(node.children[0], value);
	              if (!isArray(original)) {
	                return null;
	              }
	              var merged = [];
	              for (i = 0; i < original.length; i++) {
	                current = original[i];
	                if (isArray(current)) {
	                  merged.push.apply(merged, current);
	                } else {
	                  merged.push(current);
	                }
	              }
	              return merged;
	            case "Identity":
	              return value;
	            case "MultiSelectList":
	              if (value === null) {
	                return null;
	              }
	              collected = [];
	              for (i = 0; i < node.children.length; i++) {
	                  collected.push(this.visit(node.children[i], value));
	              }
	              return collected;
	            case "MultiSelectHash":
	              if (value === null) {
	                return null;
	              }
	              collected = {};
	              var child;
	              for (i = 0; i < node.children.length; i++) {
	                child = node.children[i];
	                collected[child.name] = this.visit(child.value, value);
	              }
	              return collected;
	            case "OrExpression":
	              matched = this.visit(node.children[0], value);
	              if (isFalse(matched)) {
	                  matched = this.visit(node.children[1], value);
	              }
	              return matched;
	            case "AndExpression":
	              first = this.visit(node.children[0], value);
	
	              if (isFalse(first) === true) {
	                return first;
	              }
	              return this.visit(node.children[1], value);
	            case "NotExpression":
	              first = this.visit(node.children[0], value);
	              return isFalse(first);
	            case "Literal":
	              return node.value;
	            case TOK_PIPE:
	              left = this.visit(node.children[0], value);
	              return this.visit(node.children[1], left);
	            case TOK_CURRENT:
	              return value;
	            case "Function":
	              var resolvedArgs = [];
	              for (i = 0; i < node.children.length; i++) {
	                  resolvedArgs.push(this.visit(node.children[i], value));
	              }
	              return this.runtime.callFunction(node.name, resolvedArgs);
	            case "ExpressionReference":
	              var refNode = node.children[0];
	              // Tag the node with a specific attribute so the type
	              // checker verify the type.
	              refNode.jmespathType = TOK_EXPREF;
	              return refNode;
	            default:
	              throw new Error("Unknown node type: " + node.type);
	          }
	      },
	
	      computeSliceParams: function(arrayLength, sliceParams) {
	        var start = sliceParams[0];
	        var stop = sliceParams[1];
	        var step = sliceParams[2];
	        var computed = [null, null, null];
	        if (step === null) {
	          step = 1;
	        } else if (step === 0) {
	          var error = new Error("Invalid slice, step cannot be 0");
	          error.name = "RuntimeError";
	          throw error;
	        }
	        var stepValueNegative = step < 0 ? true : false;
	
	        if (start === null) {
	            start = stepValueNegative ? arrayLength - 1 : 0;
	        } else {
	            start = this.capSliceRange(arrayLength, start, step);
	        }
	
	        if (stop === null) {
	            stop = stepValueNegative ? -1 : arrayLength;
	        } else {
	            stop = this.capSliceRange(arrayLength, stop, step);
	        }
	        computed[0] = start;
	        computed[1] = stop;
	        computed[2] = step;
	        return computed;
	      },
	
	      capSliceRange: function(arrayLength, actualValue, step) {
	          if (actualValue < 0) {
	              actualValue += arrayLength;
	              if (actualValue < 0) {
	                  actualValue = step < 0 ? -1 : 0;
	              }
	          } else if (actualValue >= arrayLength) {
	              actualValue = step < 0 ? arrayLength - 1 : arrayLength;
	          }
	          return actualValue;
	      }
	
	  };
	
	  function Runtime(interpreter) {
	    this._interpreter = interpreter;
	    this.functionTable = {
	        // name: [function, <signature>]
	        // The <signature> can be:
	        //
	        // {
	        //   args: [[type1, type2], [type1, type2]],
	        //   variadic: true|false
	        // }
	        //
	        // Each arg in the arg list is a list of valid types
	        // (if the function is overloaded and supports multiple
	        // types.  If the type is "any" then no type checking
	        // occurs on the argument.  Variadic is optional
	        // and if not provided is assumed to be false.
	        abs: {_func: this._functionAbs, _signature: [{types: [TYPE_NUMBER]}]},
	        avg: {_func: this._functionAvg, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
	        ceil: {_func: this._functionCeil, _signature: [{types: [TYPE_NUMBER]}]},
	        contains: {
	            _func: this._functionContains,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]},
	                        {types: [TYPE_ANY]}]},
	        "ends_with": {
	            _func: this._functionEndsWith,
	            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
	        floor: {_func: this._functionFloor, _signature: [{types: [TYPE_NUMBER]}]},
	        length: {
	            _func: this._functionLength,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY, TYPE_OBJECT]}]},
	        map: {
	            _func: this._functionMap,
	            _signature: [{types: [TYPE_EXPREF]}, {types: [TYPE_ARRAY]}]},
	        max: {
	            _func: this._functionMax,
	            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
	        "merge": {
	            _func: this._functionMerge,
	            _signature: [{types: [TYPE_OBJECT], variadic: true}]
	        },
	        "max_by": {
	          _func: this._functionMaxBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        sum: {_func: this._functionSum, _signature: [{types: [TYPE_ARRAY_NUMBER]}]},
	        "starts_with": {
	            _func: this._functionStartsWith,
	            _signature: [{types: [TYPE_STRING]}, {types: [TYPE_STRING]}]},
	        min: {
	            _func: this._functionMin,
	            _signature: [{types: [TYPE_ARRAY_NUMBER, TYPE_ARRAY_STRING]}]},
	        "min_by": {
	          _func: this._functionMinBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        type: {_func: this._functionType, _signature: [{types: [TYPE_ANY]}]},
	        keys: {_func: this._functionKeys, _signature: [{types: [TYPE_OBJECT]}]},
	        values: {_func: this._functionValues, _signature: [{types: [TYPE_OBJECT]}]},
	        sort: {_func: this._functionSort, _signature: [{types: [TYPE_ARRAY_STRING, TYPE_ARRAY_NUMBER]}]},
	        "sort_by": {
	          _func: this._functionSortBy,
	          _signature: [{types: [TYPE_ARRAY]}, {types: [TYPE_EXPREF]}]
	        },
	        join: {
	            _func: this._functionJoin,
	            _signature: [
	                {types: [TYPE_STRING]},
	                {types: [TYPE_ARRAY_STRING]}
	            ]
	        },
	        reverse: {
	            _func: this._functionReverse,
	            _signature: [{types: [TYPE_STRING, TYPE_ARRAY]}]},
	        "to_array": {_func: this._functionToArray, _signature: [{types: [TYPE_ANY]}]},
	        "to_string": {_func: this._functionToString, _signature: [{types: [TYPE_ANY]}]},
	        "to_number": {_func: this._functionToNumber, _signature: [{types: [TYPE_ANY]}]},
	        "not_null": {
	            _func: this._functionNotNull,
	            _signature: [{types: [TYPE_ANY], variadic: true}]
	        }
	    };
	  }
	
	  Runtime.prototype = {
	    callFunction: function(name, resolvedArgs) {
	      var functionEntry = this.functionTable[name];
	      if (functionEntry === undefined) {
	          throw new Error("Unknown function: " + name + "()");
	      }
	      this._validateArgs(name, resolvedArgs, functionEntry._signature);
	      return functionEntry._func.call(this, resolvedArgs);
	    },
	
	    _validateArgs: function(name, args, signature) {
	        // Validating the args requires validating
	        // the correct arity and the correct type of each arg.
	        // If the last argument is declared as variadic, then we need
	        // a minimum number of args to be required.  Otherwise it has to
	        // be an exact amount.
	        var pluralized;
	        if (signature[signature.length - 1].variadic) {
	            if (args.length < signature.length) {
	                pluralized = signature.length === 1 ? " argument" : " arguments";
	                throw new Error("ArgumentError: " + name + "() " +
	                                "takes at least" + signature.length + pluralized +
	                                " but received " + args.length);
	            }
	        } else if (args.length !== signature.length) {
	            pluralized = signature.length === 1 ? " argument" : " arguments";
	            throw new Error("ArgumentError: " + name + "() " +
	                            "takes " + signature.length + pluralized +
	                            " but received " + args.length);
	        }
	        var currentSpec;
	        var actualType;
	        var typeMatched;
	        for (var i = 0; i < signature.length; i++) {
	            typeMatched = false;
	            currentSpec = signature[i].types;
	            actualType = this._getTypeName(args[i]);
	            for (var j = 0; j < currentSpec.length; j++) {
	                if (this._typeMatches(actualType, currentSpec[j], args[i])) {
	                    typeMatched = true;
	                    break;
	                }
	            }
	            if (!typeMatched) {
	                throw new Error("TypeError: " + name + "() " +
	                                "expected argument " + (i + 1) +
	                                " to be type " + currentSpec +
	                                " but received type " + actualType +
	                                " instead.");
	            }
	        }
	    },
	
	    _typeMatches: function(actual, expected, argValue) {
	        if (expected === TYPE_ANY) {
	            return true;
	        }
	        if (expected === TYPE_ARRAY_STRING ||
	            expected === TYPE_ARRAY_NUMBER ||
	            expected === TYPE_ARRAY) {
	            // The expected type can either just be array,
	            // or it can require a specific subtype (array of numbers).
	            //
	            // The simplest case is if "array" with no subtype is specified.
	            if (expected === TYPE_ARRAY) {
	                return actual === TYPE_ARRAY;
	            } else if (actual === TYPE_ARRAY) {
	                // Otherwise we need to check subtypes.
	                // I think this has potential to be improved.
	                var subtype;
	                if (expected === TYPE_ARRAY_NUMBER) {
	                  subtype = TYPE_NUMBER;
	                } else if (expected === TYPE_ARRAY_STRING) {
	                  subtype = TYPE_STRING;
	                }
	                for (var i = 0; i < argValue.length; i++) {
	                    if (!this._typeMatches(
	                            this._getTypeName(argValue[i]), subtype,
	                                             argValue[i])) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	        } else {
	            return actual === expected;
	        }
	    },
	    _getTypeName: function(obj) {
	        switch (Object.prototype.toString.call(obj)) {
	            case "[object String]":
	              return TYPE_STRING;
	            case "[object Number]":
	              return TYPE_NUMBER;
	            case "[object Array]":
	              return TYPE_ARRAY;
	            case "[object Boolean]":
	              return TYPE_BOOLEAN;
	            case "[object Null]":
	              return TYPE_NULL;
	            case "[object Object]":
	              // Check if it's an expref.  If it has, it's been
	              // tagged with a jmespathType attr of 'Expref';
	              if (obj.jmespathType === TOK_EXPREF) {
	                return TYPE_EXPREF;
	              } else {
	                return TYPE_OBJECT;
	              }
	        }
	    },
	
	    _functionStartsWith: function(resolvedArgs) {
	        return resolvedArgs[0].lastIndexOf(resolvedArgs[1]) === 0;
	    },
	
	    _functionEndsWith: function(resolvedArgs) {
	        var searchStr = resolvedArgs[0];
	        var suffix = resolvedArgs[1];
	        return searchStr.indexOf(suffix, searchStr.length - suffix.length) !== -1;
	    },
	
	    _functionReverse: function(resolvedArgs) {
	        var typeName = this._getTypeName(resolvedArgs[0]);
	        if (typeName === TYPE_STRING) {
	          var originalStr = resolvedArgs[0];
	          var reversedStr = "";
	          for (var i = originalStr.length - 1; i >= 0; i--) {
	              reversedStr += originalStr[i];
	          }
	          return reversedStr;
	        } else {
	          var reversedArray = resolvedArgs[0].slice(0);
	          reversedArray.reverse();
	          return reversedArray;
	        }
	    },
	
	    _functionAbs: function(resolvedArgs) {
	      return Math.abs(resolvedArgs[0]);
	    },
	
	    _functionCeil: function(resolvedArgs) {
	        return Math.ceil(resolvedArgs[0]);
	    },
	
	    _functionAvg: function(resolvedArgs) {
	        var sum = 0;
	        var inputArray = resolvedArgs[0];
	        for (var i = 0; i < inputArray.length; i++) {
	            sum += inputArray[i];
	        }
	        return sum / inputArray.length;
	    },
	
	    _functionContains: function(resolvedArgs) {
	        return resolvedArgs[0].indexOf(resolvedArgs[1]) >= 0;
	    },
	
	    _functionFloor: function(resolvedArgs) {
	        return Math.floor(resolvedArgs[0]);
	    },
	
	    _functionLength: function(resolvedArgs) {
	       if (!isObject(resolvedArgs[0])) {
	         return resolvedArgs[0].length;
	       } else {
	         // As far as I can tell, there's no way to get the length
	         // of an object without O(n) iteration through the object.
	         return Object.keys(resolvedArgs[0]).length;
	       }
	    },
	
	    _functionMap: function(resolvedArgs) {
	      var mapped = [];
	      var interpreter = this._interpreter;
	      var exprefNode = resolvedArgs[0];
	      var elements = resolvedArgs[1];
	      for (var i = 0; i < elements.length; i++) {
	          mapped.push(interpreter.visit(exprefNode, elements[i]));
	      }
	      return mapped;
	    },
	
	    _functionMerge: function(resolvedArgs) {
	      var merged = {};
	      for (var i = 0; i < resolvedArgs.length; i++) {
	        var current = resolvedArgs[i];
	        for (var key in current) {
	          merged[key] = current[key];
	        }
	      }
	      return merged;
	    },
	
	    _functionMax: function(resolvedArgs) {
	      if (resolvedArgs[0].length > 0) {
	        var typeName = this._getTypeName(resolvedArgs[0][0]);
	        if (typeName === TYPE_NUMBER) {
	          return Math.max.apply(Math, resolvedArgs[0]);
	        } else {
	          var elements = resolvedArgs[0];
	          var maxElement = elements[0];
	          for (var i = 1; i < elements.length; i++) {
	              if (maxElement.localeCompare(elements[i]) < 0) {
	                  maxElement = elements[i];
	              }
	          }
	          return maxElement;
	        }
	      } else {
	          return null;
	      }
	    },
	
	    _functionMin: function(resolvedArgs) {
	      if (resolvedArgs[0].length > 0) {
	        var typeName = this._getTypeName(resolvedArgs[0][0]);
	        if (typeName === TYPE_NUMBER) {
	          return Math.min.apply(Math, resolvedArgs[0]);
	        } else {
	          var elements = resolvedArgs[0];
	          var minElement = elements[0];
	          for (var i = 1; i < elements.length; i++) {
	              if (elements[i].localeCompare(minElement) < 0) {
	                  minElement = elements[i];
	              }
	          }
	          return minElement;
	        }
	      } else {
	        return null;
	      }
	    },
	
	    _functionSum: function(resolvedArgs) {
	      var sum = 0;
	      var listToSum = resolvedArgs[0];
	      for (var i = 0; i < listToSum.length; i++) {
	        sum += listToSum[i];
	      }
	      return sum;
	    },
	
	    _functionType: function(resolvedArgs) {
	        switch (this._getTypeName(resolvedArgs[0])) {
	          case TYPE_NUMBER:
	            return "number";
	          case TYPE_STRING:
	            return "string";
	          case TYPE_ARRAY:
	            return "array";
	          case TYPE_OBJECT:
	            return "object";
	          case TYPE_BOOLEAN:
	            return "boolean";
	          case TYPE_EXPREF:
	            return "expref";
	          case TYPE_NULL:
	            return "null";
	        }
	    },
	
	    _functionKeys: function(resolvedArgs) {
	        return Object.keys(resolvedArgs[0]);
	    },
	
	    _functionValues: function(resolvedArgs) {
	        var obj = resolvedArgs[0];
	        var keys = Object.keys(obj);
	        var values = [];
	        for (var i = 0; i < keys.length; i++) {
	            values.push(obj[keys[i]]);
	        }
	        return values;
	    },
	
	    _functionJoin: function(resolvedArgs) {
	        var joinChar = resolvedArgs[0];
	        var listJoin = resolvedArgs[1];
	        return listJoin.join(joinChar);
	    },
	
	    _functionToArray: function(resolvedArgs) {
	        if (this._getTypeName(resolvedArgs[0]) === TYPE_ARRAY) {
	            return resolvedArgs[0];
	        } else {
	            return [resolvedArgs[0]];
	        }
	    },
	
	    _functionToString: function(resolvedArgs) {
	        if (this._getTypeName(resolvedArgs[0]) === TYPE_STRING) {
	            return resolvedArgs[0];
	        } else {
	            return JSON.stringify(resolvedArgs[0]);
	        }
	    },
	
	    _functionToNumber: function(resolvedArgs) {
	        var typeName = this._getTypeName(resolvedArgs[0]);
	        var convertedValue;
	        if (typeName === TYPE_NUMBER) {
	            return resolvedArgs[0];
	        } else if (typeName === TYPE_STRING) {
	            convertedValue = +resolvedArgs[0];
	            if (!isNaN(convertedValue)) {
	                return convertedValue;
	            }
	        }
	        return null;
	    },
	
	    _functionNotNull: function(resolvedArgs) {
	        for (var i = 0; i < resolvedArgs.length; i++) {
	            if (this._getTypeName(resolvedArgs[i]) !== TYPE_NULL) {
	                return resolvedArgs[i];
	            }
	        }
	        return null;
	    },
	
	    _functionSort: function(resolvedArgs) {
	        var sortedArray = resolvedArgs[0].slice(0);
	        sortedArray.sort();
	        return sortedArray;
	    },
	
	    _functionSortBy: function(resolvedArgs) {
	        var sortedArray = resolvedArgs[0].slice(0);
	        if (sortedArray.length === 0) {
	            return sortedArray;
	        }
	        var interpreter = this._interpreter;
	        var exprefNode = resolvedArgs[1];
	        var requiredType = this._getTypeName(
	            interpreter.visit(exprefNode, sortedArray[0]));
	        if ([TYPE_NUMBER, TYPE_STRING].indexOf(requiredType) < 0) {
	            throw new Error("TypeError");
	        }
	        var that = this;
	        // In order to get a stable sort out of an unstable
	        // sort algorithm, we decorate/sort/undecorate (DSU)
	        // by creating a new list of [index, element] pairs.
	        // In the cmp function, if the evaluated elements are
	        // equal, then the index will be used as the tiebreaker.
	        // After the decorated list has been sorted, it will be
	        // undecorated to extract the original elements.
	        var decorated = [];
	        for (var i = 0; i < sortedArray.length; i++) {
	          decorated.push([i, sortedArray[i]]);
	        }
	        decorated.sort(function(a, b) {
	          var exprA = interpreter.visit(exprefNode, a[1]);
	          var exprB = interpreter.visit(exprefNode, b[1]);
	          if (that._getTypeName(exprA) !== requiredType) {
	              throw new Error(
	                  "TypeError: expected " + requiredType + ", received " +
	                  that._getTypeName(exprA));
	          } else if (that._getTypeName(exprB) !== requiredType) {
	              throw new Error(
	                  "TypeError: expected " + requiredType + ", received " +
	                  that._getTypeName(exprB));
	          }
	          if (exprA > exprB) {
	            return 1;
	          } else if (exprA < exprB) {
	            return -1;
	          } else {
	            // If they're equal compare the items by their
	            // order to maintain relative order of equal keys
	            // (i.e. to get a stable sort).
	            return a[0] - b[0];
	          }
	        });
	        // Undecorate: extract out the original list elements.
	        for (var j = 0; j < decorated.length; j++) {
	          sortedArray[j] = decorated[j][1];
	        }
	        return sortedArray;
	    },
	
	    _functionMaxBy: function(resolvedArgs) {
	      var exprefNode = resolvedArgs[1];
	      var resolvedArray = resolvedArgs[0];
	      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
	      var maxNumber = -Infinity;
	      var maxRecord;
	      var current;
	      for (var i = 0; i < resolvedArray.length; i++) {
	        current = keyFunction(resolvedArray[i]);
	        if (current > maxNumber) {
	          maxNumber = current;
	          maxRecord = resolvedArray[i];
	        }
	      }
	      return maxRecord;
	    },
	
	    _functionMinBy: function(resolvedArgs) {
	      var exprefNode = resolvedArgs[1];
	      var resolvedArray = resolvedArgs[0];
	      var keyFunction = this.createKeyFunction(exprefNode, [TYPE_NUMBER, TYPE_STRING]);
	      var minNumber = Infinity;
	      var minRecord;
	      var current;
	      for (var i = 0; i < resolvedArray.length; i++) {
	        current = keyFunction(resolvedArray[i]);
	        if (current < minNumber) {
	          minNumber = current;
	          minRecord = resolvedArray[i];
	        }
	      }
	      return minRecord;
	    },
	
	    createKeyFunction: function(exprefNode, allowedTypes) {
	      var that = this;
	      var interpreter = this._interpreter;
	      var keyFunc = function(x) {
	        var current = interpreter.visit(exprefNode, x);
	        if (allowedTypes.indexOf(that._getTypeName(current)) < 0) {
	          var msg = "TypeError: expected one of " + allowedTypes +
	                    ", received " + that._getTypeName(current);
	          throw new Error(msg);
	        }
	        return current;
	      };
	      return keyFunc;
	    }
	
	  };
	
	  function compile(stream) {
	    var parser = new Parser();
	    var ast = parser.parse(stream);
	    return ast;
	  }
	
	  function tokenize(stream) {
	      var lexer = new Lexer();
	      return lexer.tokenize(stream);
	  }
	
	  function search(data, expression) {
	      var parser = new Parser();
	      // This needs to be improved.  Both the interpreter and runtime depend on
	      // each other.  The runtime needs the interpreter to support exprefs.
	      // There's likely a clean way to avoid the cyclic dependency.
	      var runtime = new Runtime();
	      var interpreter = new TreeInterpreter(runtime);
	      runtime._interpreter = interpreter;
	      var node = parser.parse(expression);
	      return interpreter.search(node, data);
	  }
	
	  exports.tokenize = tokenize;
	  exports.compile = compile;
	  exports.search = search;
	  exports.strictDeepEqual = strictDeepEqual;
	})( false ? this.jmespath = {} : exports);


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(209),
	    getRawTag = __webpack_require__(1938),
	    objectToString = __webpack_require__(1963);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 141 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(2001);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Returns a function that always returns the given value. Note that for
	 * non-primitives the value returned is a reference to the original value.
	 *
	 * This function is known as `const`, `constant`, or `K` (for K combinator) in
	 * other languages and libraries.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> (* -> a)
	 * @param {*} val The value to wrap in a function
	 * @return {Function} A Function :: * -> val.
	 * @example
	 *
	 *      var t = R.always('Tee');
	 *      t(); //=> 'Tee'
	 */
	module.exports = _curry1(function always(val) {
	  return function() {
	    return val;
	  };
	});


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns the larger of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.maxBy, R.min
	 * @example
	 *
	 *      R.max(789, 123); //=> 789
	 *      R.max('a', 'b'); //=> 'b'
	 */
	module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(344);
	var setInnerHTML = __webpack_require__(238);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(352);
	var setTextContent = __webpack_require__(762);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(2279);
	var ReactInstrumentation = __webpack_require__(68);
	
	var warning = __webpack_require__(17);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = exports.inputFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames4 = __webpack_require__(3);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _utils = __webpack_require__(60);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(FontIcon) {
	  var Input = function (_React$Component) {
	    _inherits(Input, _React$Component);
	
	    function Input() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Input);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            onChange = _this$props.onChange,
	            multiline = _this$props.multiline,
	            maxLength = _this$props.maxLength;
	
	        var valueFromEvent = event.target.value;
	
	        // Trim value to maxLength if that exists (only on multiline inputs).
	        // Note that this is still required even tho we have the onKeyPress filter
	        // because the user could paste smt in the textarea.
	        var haveToTrim = multiline && maxLength && event.target.value.length > maxLength;
	        var value = haveToTrim ? valueFromEvent.substr(0, maxLength) : valueFromEvent;
	
	        // propagate to to store and therefore to the input
	        if (onChange) onChange(value, event);
	      }, _this.handleAutoresize = function () {
	        var element = _this.inputNode;
	        var rows = _this.props.rows;
	
	        if (typeof rows === 'number' && !isNaN(rows)) {
	          element.style.height = null;
	        } else {
	          // compute the height difference between inner height and outer height
	          var style = getComputedStyle(element, null);
	          var heightOffset = style.boxSizing === 'content-box' ? -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)) : parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
	
	          // resize the input to its content size
	          element.style.height = 'auto';
	          element.style.height = element.scrollHeight + heightOffset + 'px';
	        }
	      }, _this.handleKeyPress = function (event) {
	        // prevent insertion of more characters if we're a multiline input
	        // and maxLength exists
	        var _this$props2 = _this.props,
	            multiline = _this$props2.multiline,
	            maxLength = _this$props2.maxLength,
	            onKeyPress = _this$props2.onKeyPress;
	
	        if (multiline && maxLength) {
	          // check if smt is selected, in which case the newly added charcter would
	          // replace the selected characters, so the length of value doesn't actually
	          // increase.
	          var isReplacing = event.target.selectionEnd - event.target.selectionStart;
	          var value = event.target.value;
	
	          if (!isReplacing && value.length === maxLength) {
	            event.preventDefault();
	            event.stopPropagation();
	            return undefined;
	          }
	        }
	
	        if (onKeyPress) onKeyPress(event);
	        return undefined;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Input, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.multiline) {
	          window.addEventListener('resize', this.handleAutoresize);
	          this.handleAutoresize();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!this.props.multiline && nextProps.multiline) {
	          window.addEventListener('resize', this.handleAutoresize);
	        } else if (this.props.multiline && !nextProps.multiline) {
	          window.removeEventListener('resize', this.handleAutoresize);
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        // resize the textarea, if nessesary
	        if (this.props.multiline) this.handleAutoresize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.multiline) window.removeEventListener('resize', this.handleAutoresize);
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        this.inputNode.blur();
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this.inputNode.focus();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames2,
	            _this2 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            defaultValue = _props.defaultValue,
	            disabled = _props.disabled,
	            error = _props.error,
	            floating = _props.floating,
	            hint = _props.hint,
	            icon = _props.icon,
	            name = _props.name,
	            labelText = _props.label,
	            maxLength = _props.maxLength,
	            multiline = _props.multiline,
	            required = _props.required,
	            role = _props.role,
	            theme = _props.theme,
	            type = _props.type,
	            value = _props.value,
	            onKeyPress = _props.onKeyPress,
	            _props$rows = _props.rows,
	            rows = _props$rows === undefined ? 1 : _props$rows,
	            others = _objectWithoutProperties(_props, ['children', 'defaultValue', 'disabled', 'error', 'floating', 'hint', 'icon', 'name', 'label', 'maxLength', 'multiline', 'required', 'role', 'theme', 'type', 'value', 'onKeyPress', 'rows']);
	
	        var length = maxLength && value ? value.length : 0;
	        var labelClassName = (0, _classnames5.default)(theme.label, _defineProperty({}, theme.fixed, !floating));
	
	        var className = (0, _classnames5.default)(theme.input, (_classnames2 = {}, _defineProperty(_classnames2, theme.disabled, disabled), _defineProperty(_classnames2, theme.errored, error), _defineProperty(_classnames2, theme.hidden, type === 'hidden'), _defineProperty(_classnames2, theme.withIcon, icon), _classnames2), this.props.className);
	
	        var valuePresent = (0, _utils.isValuePresent)(value) || (0, _utils.isValuePresent)(defaultValue);
	
	        var inputElementProps = _extends({}, others, {
	          className: (0, _classnames5.default)(theme.inputElement, _defineProperty({}, theme.filled, valuePresent)),
	          onChange: this.handleChange,
	          ref: function ref(node) {
	            _this2.inputNode = node;
	          },
	          role: role,
	          name: name,
	          defaultValue: defaultValue,
	          disabled: disabled,
	          required: required,
	          type: type,
	          value: value
	        });
	        if (!multiline) {
	          inputElementProps.maxLength = maxLength;
	          inputElementProps.onKeyPress = onKeyPress;
	        } else {
	          inputElementProps.rows = rows;
	          inputElementProps.onKeyPress = this.handleKeyPress;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'input', className: className },
	          _react2.default.createElement(multiline ? 'textarea' : 'input', inputElementProps),
	          icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null,
	          _react2.default.createElement('span', { className: theme.bar }),
	          labelText ? _react2.default.createElement(
	            'label',
	            { className: labelClassName },
	            labelText,
	            required ? _react2.default.createElement(
	              'span',
	              { className: theme.required },
	              ' * '
	            ) : null
	          ) : null,
	          hint ? _react2.default.createElement(
	            'span',
	            { hidden: labelText, className: theme.hint },
	            hint
	          ) : null,
	          error ? _react2.default.createElement(
	            'span',
	            { className: theme.error },
	            error
	          ) : null,
	          maxLength ? _react2.default.createElement(
	            'span',
	            { className: theme.counter },
	            length,
	            '/',
	            maxLength
	          ) : null,
	          children
	        );
	      }
	    }]);
	
	    return Input;
	  }(_react2.default.Component);
	
	  Input.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    defaultValue: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    floating: _propTypes2.default.bool,
	    hint: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    maxLength: _propTypes2.default.number,
	    multiline: _propTypes2.default.bool,
	    name: _propTypes2.default.string,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    required: _propTypes2.default.bool,
	    role: _propTypes2.default.string,
	    rows: _propTypes2.default.number,
	    theme: _propTypes2.default.shape({
	      bar: _propTypes2.default.string,
	      counter: _propTypes2.default.string,
	      disabled: _propTypes2.default.string,
	      error: _propTypes2.default.string,
	      errored: _propTypes2.default.string,
	      hidden: _propTypes2.default.string,
	      hint: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      inputElement: _propTypes2.default.string,
	      required: _propTypes2.default.string,
	      withIcon: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string])
	  };
	  Input.defaultProps = {
	    className: '',
	    hint: '',
	    disabled: false,
	    floating: true,
	    multiline: false,
	    required: false,
	    role: 'input',
	    type: 'text'
	  };
	
	
	  return Input;
	};
	
	var Input = factory(_FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.INPUT)(Input);
	exports.inputFactory = factory;
	exports.Input = Input;

/***/ },
/* 150 */
[2572, 827, 257],
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactChildren = __webpack_require__(2471);
	var ReactComponent = __webpack_require__(387);
	var ReactPureComponent = __webpack_require__(2476);
	var ReactClass = __webpack_require__(2472);
	var ReactDOMFactories = __webpack_require__(2473);
	var ReactElement = __webpack_require__(152);
	var ReactPropTypes = __webpack_require__(2475);
	var ReactVersion = __webpack_require__(2477);
	
	var onlyChild = __webpack_require__(2480);
	var warning = __webpack_require__(17);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(93);
	
	var warning = __webpack_require__(17);
	var canDefineProperty = __webpack_require__(851);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(850);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 153 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(2485);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(125);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(852);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(853);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLRaw, XMLText, isEmpty, isFunction, isObject,
	    hasProp = {}.hasOwnProperty;
	
	  isObject = __webpack_require__(80);
	
	  isFunction = __webpack_require__(215);
	
	  isEmpty = __webpack_require__(1981);
	
	  XMLElement = null;
	
	  XMLCData = null;
	
	  XMLComment = null;
	
	  XMLDeclaration = null;
	
	  XMLDocType = null;
	
	  XMLRaw = null;
	
	  XMLText = null;
	
	  module.exports = XMLNode = (function() {
	    function XMLNode(parent) {
	      this.parent = parent;
	      this.options = this.parent.options;
	      this.stringify = this.parent.stringify;
	      if (XMLElement === null) {
	        XMLElement = __webpack_require__(865);
	        XMLCData = __webpack_require__(861);
	        XMLComment = __webpack_require__(862);
	        XMLDeclaration = __webpack_require__(863);
	        XMLDocType = __webpack_require__(864);
	        XMLRaw = __webpack_require__(2512);
	        XMLText = __webpack_require__(2514);
	      }
	    }
	
	    XMLNode.prototype.element = function(name, attributes, text) {
	      var childNode, item, j, k, key, lastChild, len, len1, ref, val;
	      lastChild = null;
	      if (attributes == null) {
	        attributes = {};
	      }
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref = [attributes, text], text = ref[0], attributes = ref[1];
	      }
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (Array.isArray(name)) {
	        for (j = 0, len = name.length; j < len; j++) {
	          item = name[j];
	          lastChild = this.element(item);
	        }
	      } else if (isFunction(name)) {
	        lastChild = this.element(name.apply());
	      } else if (isObject(name)) {
	        for (key in name) {
	          if (!hasProp.call(name, key)) continue;
	          val = name[key];
	          if (isFunction(val)) {
	            val = val.apply();
	          }
	          if ((isObject(val)) && (isEmpty(val))) {
	            val = null;
	          }
	          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
	            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
	          } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && key.indexOf(this.stringify.convertPIKey) === 0) {
	            lastChild = this.instruction(key.substr(this.stringify.convertPIKey.length), val);
	          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
	            for (k = 0, len1 = val.length; k < len1; k++) {
	              item = val[k];
	              childNode = {};
	              childNode[key] = item;
	              lastChild = this.element(childNode);
	            }
	          } else if (isObject(val)) {
	            lastChild = this.element(key);
	            lastChild.element(val);
	          } else {
	            lastChild = this.element(key, val);
	          }
	        }
	      } else {
	        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
	          lastChild = this.text(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
	          lastChild = this.cdata(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
	          lastChild = this.comment(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
	          lastChild = this.raw(text);
	        } else {
	          lastChild = this.node(name, attributes, text);
	        }
	      }
	      if (lastChild == null) {
	        throw new Error("Could not create any elements with: " + name);
	      }
	      return lastChild;
	    };
	
	    XMLNode.prototype.insertBefore = function(name, attributes, text) {
	      var child, i, removed;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i);
	      child = this.parent.element(name, attributes, text);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return child;
	    };
	
	    XMLNode.prototype.insertAfter = function(name, attributes, text) {
	      var child, i, removed;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i + 1);
	      child = this.parent.element(name, attributes, text);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return child;
	    };
	
	    XMLNode.prototype.remove = function() {
	      var i, ref;
	      if (this.isRoot) {
	        throw new Error("Cannot remove the root element");
	      }
	      i = this.parent.children.indexOf(this);
	      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref = [])), ref;
	      return this.parent;
	    };
	
	    XMLNode.prototype.node = function(name, attributes, text) {
	      var child, ref;
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (attributes == null) {
	        attributes = {};
	      }
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref = [attributes, text], text = ref[0], attributes = ref[1];
	      }
	      child = new XMLElement(this, name, attributes);
	      if (text != null) {
	        child.text(text);
	      }
	      this.children.push(child);
	      return child;
	    };
	
	    XMLNode.prototype.text = function(value) {
	      var child;
	      child = new XMLText(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.cdata = function(value) {
	      var child;
	      child = new XMLCData(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.comment = function(value) {
	      var child;
	      child = new XMLComment(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.raw = function(value) {
	      var child;
	      child = new XMLRaw(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.declaration = function(version, encoding, standalone) {
	      var doc, xmldec;
	      doc = this.document();
	      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
	      doc.xmldec = xmldec;
	      return doc.root();
	    };
	
	    XMLNode.prototype.doctype = function(pubID, sysID) {
	      var doc, doctype;
	      doc = this.document();
	      doctype = new XMLDocType(doc, pubID, sysID);
	      doc.doctype = doctype;
	      return doctype;
	    };
	
	    XMLNode.prototype.up = function() {
	      if (this.isRoot) {
	        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
	      }
	      return this.parent;
	    };
	
	    XMLNode.prototype.root = function() {
	      var child;
	      if (this.isRoot) {
	        return this;
	      }
	      child = this.parent;
	      while (!child.isRoot) {
	        child = child.parent;
	      }
	      return child;
	    };
	
	    XMLNode.prototype.document = function() {
	      return this.root().documentObject;
	    };
	
	    XMLNode.prototype.end = function(options) {
	      return this.document().toString(options);
	    };
	
	    XMLNode.prototype.prev = function() {
	      var i;
	      if (this.isRoot) {
	        throw new Error("Root node has no siblings");
	      }
	      i = this.parent.children.indexOf(this);
	      if (i < 1) {
	        throw new Error("Already at the first node");
	      }
	      return this.parent.children[i - 1];
	    };
	
	    XMLNode.prototype.next = function() {
	      var i;
	      if (this.isRoot) {
	        throw new Error("Root node has no siblings");
	      }
	      i = this.parent.children.indexOf(this);
	      if (i === -1 || i === this.parent.children.length - 1) {
	        throw new Error("Already at the last node");
	      }
	      return this.parent.children[i + 1];
	    };
	
	    XMLNode.prototype.importXMLBuilder = function(xmlbuilder) {
	      var clonedRoot;
	      clonedRoot = xmlbuilder.root().clone();
	      clonedRoot.parent = this;
	      clonedRoot.isRoot = false;
	      this.children.push(clonedRoot);
	      return this;
	    };
	
	    XMLNode.prototype.ele = function(name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLNode.prototype.nod = function(name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLNode.prototype.txt = function(value) {
	      return this.text(value);
	    };
	
	    XMLNode.prototype.dat = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLNode.prototype.com = function(value) {
	      return this.comment(value);
	    };
	
	    XMLNode.prototype.doc = function() {
	      return this.document();
	    };
	
	    XMLNode.prototype.dec = function(version, encoding, standalone) {
	      return this.declaration(version, encoding, standalone);
	    };
	
	    XMLNode.prototype.dtd = function(pubID, sysID) {
	      return this.doctype(pubID, sysID);
	    };
	
	    XMLNode.prototype.e = function(name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLNode.prototype.n = function(name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLNode.prototype.t = function(value) {
	      return this.text(value);
	    };
	
	    XMLNode.prototype.d = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLNode.prototype.c = function(value) {
	      return this.comment(value);
	    };
	
	    XMLNode.prototype.r = function(value) {
	      return this.raw(value);
	    };
	
	    XMLNode.prototype.u = function() {
	      return this.up();
	    };
	
	    return XMLNode;
	
	  })();
	
	}).call(this);


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var Collection = __webpack_require__(409);
	
	var util = __webpack_require__(41);
	
	function property(obj, name, value) {
	  if (value !== null && value !== undefined) {
	    util.property.apply(this, arguments);
	  }
	}
	
	function memoizedProperty(obj, name) {
	  if (!obj.constructor.prototype[name]) {
	    util.memoizedProperty.apply(this, arguments);
	  }
	}
	
	function Shape(shape, options, memberName) {
	  options = options || {};
	
	  property(this, 'shape', shape.shape);
	  property(this, 'api', options.api, false);
	  property(this, 'type', shape.type);
	  property(this, 'enum', shape.enum);
	  property(this, 'min', shape.min);
	  property(this, 'max', shape.max);
	  property(this, 'pattern', shape.pattern);
	  property(this, 'location', shape.location || this.location || 'body');
	  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
	    shape.locationName || memberName);
	  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
	  property(this, 'isComposite', shape.isComposite || false);
	  property(this, 'isShape', true, false);
	  property(this, 'isQueryName', Boolean(shape.queryName), false);
	  property(this, 'isLocationName', Boolean(shape.locationName), false);
	  property(this, 'isIdempotent', shape.idempotencyToken === true);
	  property(this, 'isJsonValue', shape.jsonvalue === true);
	  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
	
	  if (options.documentation) {
	    property(this, 'documentation', shape.documentation);
	    property(this, 'documentationUrl', shape.documentationUrl);
	  }
	
	  if (shape.xmlAttribute) {
	    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
	  }
	
	  // type conversion and parsing
	  property(this, 'defaultValue', null);
	  this.toWireFormat = function(value) {
	    if (value === null || value === undefined) return '';
	    return value;
	  };
	  this.toType = function(value) { return value; };
	}
	
	/**
	 * @api private
	 */
	Shape.normalizedTypes = {
	  character: 'string',
	  double: 'float',
	  long: 'integer',
	  short: 'integer',
	  biginteger: 'integer',
	  bigdecimal: 'float',
	  blob: 'binary'
	};
	
	/**
	 * @api private
	 */
	Shape.types = {
	  'structure': StructureShape,
	  'list': ListShape,
	  'map': MapShape,
	  'boolean': BooleanShape,
	  'timestamp': TimestampShape,
	  'float': FloatShape,
	  'integer': IntegerShape,
	  'string': StringShape,
	  'base64': Base64Shape,
	  'binary': BinaryShape
	};
	
	Shape.resolve = function resolve(shape, options) {
	  if (shape.shape) {
	    var refShape = options.api.shapes[shape.shape];
	    if (!refShape) {
	      throw new Error('Cannot find shape reference: ' + shape.shape);
	    }
	
	    return refShape;
	  } else {
	    return null;
	  }
	};
	
	Shape.create = function create(shape, options, memberName) {
	  if (shape.isShape) return shape;
	
	  var refShape = Shape.resolve(shape, options);
	  if (refShape) {
	    var filteredKeys = Object.keys(shape);
	    if (!options.documentation) {
	      filteredKeys = filteredKeys.filter(function(name) {
	        return !name.match(/documentation/);
	      });
	    }
	
	    // create an inline shape with extra members
	    var InlineShape = function() {
	      refShape.constructor.call(this, shape, options, memberName);
	    };
	    InlineShape.prototype = refShape;
	    return new InlineShape();
	  } else {
	    // set type if not set
	    if (!shape.type) {
	      if (shape.members) shape.type = 'structure';
	      else if (shape.member) shape.type = 'list';
	      else if (shape.key) shape.type = 'map';
	      else shape.type = 'string';
	    }
	
	    // normalize types
	    var origType = shape.type;
	    if (Shape.normalizedTypes[shape.type]) {
	      shape.type = Shape.normalizedTypes[shape.type];
	    }
	
	    if (Shape.types[shape.type]) {
	      return new Shape.types[shape.type](shape, options, memberName);
	    } else {
	      throw new Error('Unrecognized shape type: ' + origType);
	    }
	  }
	};
	
	function CompositeShape(shape) {
	  Shape.apply(this, arguments);
	  property(this, 'isComposite', true);
	
	  if (shape.flattened) {
	    property(this, 'flattened', shape.flattened || false);
	  }
	}
	
	function StructureShape(shape, options) {
	  var requiredMap = null, firstInit = !this.isShape;
	
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'members', {});
	    property(this, 'memberNames', []);
	    property(this, 'required', []);
	    property(this, 'isRequired', function() { return false; });
	  }
	
	  if (shape.members) {
	    property(this, 'members', new Collection(shape.members, options, function(name, member) {
	      return Shape.create(member, options, name);
	    }));
	    memoizedProperty(this, 'memberNames', function() {
	      return shape.xmlOrder || Object.keys(shape.members);
	    });
	  }
	
	  if (shape.required) {
	    property(this, 'required', shape.required);
	    property(this, 'isRequired', function(name) {
	      if (!requiredMap) {
	        requiredMap = {};
	        for (var i = 0; i < shape.required.length; i++) {
	          requiredMap[shape.required[i]] = true;
	        }
	      }
	
	      return requiredMap[name];
	    }, false, true);
	  }
	
	  property(this, 'resultWrapper', shape.resultWrapper || null);
	
	  if (shape.payload) {
	    property(this, 'payload', shape.payload);
	  }
	
	  if (typeof shape.xmlNamespace === 'string') {
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
	  } else if (typeof shape.xmlNamespace === 'object') {
	    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
	  }
	}
	
	function ListShape(shape, options) {
	  var self = this, firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return []; });
	  }
	
	  if (shape.member) {
	    memoizedProperty(this, 'member', function() {
	      return Shape.create(shape.member, options);
	    });
	  }
	
	  if (this.flattened) {
	    var oldName = this.name;
	    memoizedProperty(this, 'name', function() {
	      return self.member.name || oldName;
	    });
	  }
	}
	
	function MapShape(shape, options) {
	  var firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'key', Shape.create({type: 'string'}, options));
	    property(this, 'value', Shape.create({type: 'string'}, options));
	  }
	
	  if (shape.key) {
	    memoizedProperty(this, 'key', function() {
	      return Shape.create(shape.key, options);
	    });
	  }
	  if (shape.value) {
	    memoizedProperty(this, 'value', function() {
	      return Shape.create(shape.value, options);
	    });
	  }
	}
	
	function TimestampShape(shape) {
	  var self = this;
	  Shape.apply(this, arguments);
	
	  if (this.location === 'header') {
	    property(this, 'timestampFormat', 'rfc822');
	  } else if (shape.timestampFormat) {
	    property(this, 'timestampFormat', shape.timestampFormat);
	  } else if (!this.timestampFormat && this.api) {
	    if (this.api.timestampFormat) {
	      property(this, 'timestampFormat', this.api.timestampFormat);
	    } else {
	      switch (this.api.protocol) {
	        case 'json':
	        case 'rest-json':
	          property(this, 'timestampFormat', 'unixTimestamp');
	          break;
	        case 'rest-xml':
	        case 'query':
	        case 'ec2':
	          property(this, 'timestampFormat', 'iso8601');
	          break;
	      }
	    }
	  }
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    if (typeof value.toUTCString === 'function') return value;
	    return typeof value === 'string' || typeof value === 'number' ?
	           util.date.parseTimestamp(value) : null;
	  };
	
	  this.toWireFormat = function(value) {
	    return util.date.format(value, self.timestampFormat);
	  };
	}
	
	function StringShape() {
	  Shape.apply(this, arguments);
	
	  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
	  this.toType = function(value) {
	    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
	      value || '' : value;
	    if (this.isJsonValue) {
	      return JSON.parse(value);
	    }
	
	    return value && typeof value.toString === 'function' ?
	      value.toString() : value;
	  };
	
	  this.toWireFormat = function(value) {
	    return this.isJsonValue ? JSON.stringify(value) : value;
	  };
	}
	
	function FloatShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseFloat(value);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function IntegerShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseInt(value, 10);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function BinaryShape() {
	  Shape.apply(this, arguments);
	  this.toType = util.base64.decode;
	  this.toWireFormat = util.base64.encode;
	}
	
	function Base64Shape() {
	  BinaryShape.apply(this, arguments);
	}
	
	function BooleanShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (typeof value === 'boolean') return value;
	    if (value === null || value === undefined) return null;
	    return value === 'true';
	  };
	}
	
	/**
	 * @api private
	 */
	Shape.shapes = {
	  StructureShape: StructureShape,
	  ListShape: ListShape,
	  MapShape: MapShape,
	  StringShape: StringShape,
	  BooleanShape: BooleanShape,
	  Base64Shape: Base64Shape
	};
	
	module.exports = Shape;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var Collection = __webpack_require__(428);
	
	var util = __webpack_require__(34);
	
	function property(obj, name, value) {
	  if (value !== null && value !== undefined) {
	    util.property.apply(this, arguments);
	  }
	}
	
	function memoizedProperty(obj, name) {
	  if (!obj.constructor.prototype[name]) {
	    util.memoizedProperty.apply(this, arguments);
	  }
	}
	
	function Shape(shape, options, memberName) {
	  options = options || {};
	
	  property(this, 'shape', shape.shape);
	  property(this, 'api', options.api, false);
	  property(this, 'type', shape.type);
	  property(this, 'enum', shape.enum);
	  property(this, 'min', shape.min);
	  property(this, 'max', shape.max);
	  property(this, 'pattern', shape.pattern);
	  property(this, 'location', shape.location || this.location || 'body');
	  property(this, 'name', this.name || shape.xmlName || shape.queryName ||
	    shape.locationName || memberName);
	  property(this, 'isStreaming', shape.streaming || this.isStreaming || false);
	  property(this, 'requiresLength', shape.requiresLength, false);
	  property(this, 'isComposite', shape.isComposite || false);
	  property(this, 'isShape', true, false);
	  property(this, 'isQueryName', Boolean(shape.queryName), false);
	  property(this, 'isLocationName', Boolean(shape.locationName), false);
	  property(this, 'isIdempotent', shape.idempotencyToken === true);
	  property(this, 'isJsonValue', shape.jsonvalue === true);
	  property(this, 'isSensitive', shape.sensitive === true || shape.prototype && shape.prototype.sensitive === true);
	  property(this, 'isEventStream', Boolean(shape.eventstream), false);
	  property(this, 'isEvent', Boolean(shape.event), false);
	  property(this, 'isEventPayload', Boolean(shape.eventpayload), false);
	  property(this, 'isEventHeader', Boolean(shape.eventheader), false);
	  property(this, 'isTimestampFormatSet', Boolean(shape.timestampFormat) || shape.prototype && shape.prototype.isTimestampFormatSet === true, false);
	  property(this, 'endpointDiscoveryId', Boolean(shape.endpointdiscoveryid), false);
	  property(this, 'hostLabel', Boolean(shape.hostLabel), false);
	
	  if (options.documentation) {
	    property(this, 'documentation', shape.documentation);
	    property(this, 'documentationUrl', shape.documentationUrl);
	  }
	
	  if (shape.xmlAttribute) {
	    property(this, 'isXmlAttribute', shape.xmlAttribute || false);
	  }
	
	  // type conversion and parsing
	  property(this, 'defaultValue', null);
	  this.toWireFormat = function(value) {
	    if (value === null || value === undefined) return '';
	    return value;
	  };
	  this.toType = function(value) { return value; };
	}
	
	/**
	 * @api private
	 */
	Shape.normalizedTypes = {
	  character: 'string',
	  double: 'float',
	  long: 'integer',
	  short: 'integer',
	  biginteger: 'integer',
	  bigdecimal: 'float',
	  blob: 'binary'
	};
	
	/**
	 * @api private
	 */
	Shape.types = {
	  'structure': StructureShape,
	  'list': ListShape,
	  'map': MapShape,
	  'boolean': BooleanShape,
	  'timestamp': TimestampShape,
	  'float': FloatShape,
	  'integer': IntegerShape,
	  'string': StringShape,
	  'base64': Base64Shape,
	  'binary': BinaryShape
	};
	
	Shape.resolve = function resolve(shape, options) {
	  if (shape.shape) {
	    var refShape = options.api.shapes[shape.shape];
	    if (!refShape) {
	      throw new Error('Cannot find shape reference: ' + shape.shape);
	    }
	
	    return refShape;
	  } else {
	    return null;
	  }
	};
	
	Shape.create = function create(shape, options, memberName) {
	  if (shape.isShape) return shape;
	
	  var refShape = Shape.resolve(shape, options);
	  if (refShape) {
	    var filteredKeys = Object.keys(shape);
	    if (!options.documentation) {
	      filteredKeys = filteredKeys.filter(function(name) {
	        return !name.match(/documentation/);
	      });
	    }
	
	    // create an inline shape with extra members
	    var InlineShape = function() {
	      refShape.constructor.call(this, shape, options, memberName);
	    };
	    InlineShape.prototype = refShape;
	    return new InlineShape();
	  } else {
	    // set type if not set
	    if (!shape.type) {
	      if (shape.members) shape.type = 'structure';
	      else if (shape.member) shape.type = 'list';
	      else if (shape.key) shape.type = 'map';
	      else shape.type = 'string';
	    }
	
	    // normalize types
	    var origType = shape.type;
	    if (Shape.normalizedTypes[shape.type]) {
	      shape.type = Shape.normalizedTypes[shape.type];
	    }
	
	    if (Shape.types[shape.type]) {
	      return new Shape.types[shape.type](shape, options, memberName);
	    } else {
	      throw new Error('Unrecognized shape type: ' + origType);
	    }
	  }
	};
	
	function CompositeShape(shape) {
	  Shape.apply(this, arguments);
	  property(this, 'isComposite', true);
	
	  if (shape.flattened) {
	    property(this, 'flattened', shape.flattened || false);
	  }
	}
	
	function StructureShape(shape, options) {
	  var self = this;
	  var requiredMap = null, firstInit = !this.isShape;
	
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'members', {});
	    property(this, 'memberNames', []);
	    property(this, 'required', []);
	    property(this, 'isRequired', function() { return false; });
	  }
	
	  if (shape.members) {
	    property(this, 'members', new Collection(shape.members, options, function(name, member) {
	      return Shape.create(member, options, name);
	    }));
	    memoizedProperty(this, 'memberNames', function() {
	      return shape.xmlOrder || Object.keys(shape.members);
	    });
	
	    if (shape.event) {
	      memoizedProperty(this, 'eventPayloadMemberName', function() {
	        var members = self.members;
	        var memberNames = self.memberNames;
	        // iterate over members to find ones that are event payloads
	        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
	          if (members[memberNames[i]].isEventPayload) {
	            return memberNames[i];
	          }
	        }
	      });
	
	      memoizedProperty(this, 'eventHeaderMemberNames', function() {
	        var members = self.members;
	        var memberNames = self.memberNames;
	        var eventHeaderMemberNames = [];
	        // iterate over members to find ones that are event headers
	        for (var i = 0, iLen = memberNames.length; i < iLen; i++) {
	          if (members[memberNames[i]].isEventHeader) {
	            eventHeaderMemberNames.push(memberNames[i]);
	          }
	        }
	        return eventHeaderMemberNames;
	      });
	    }
	  }
	
	  if (shape.required) {
	    property(this, 'required', shape.required);
	    property(this, 'isRequired', function(name) {
	      if (!requiredMap) {
	        requiredMap = {};
	        for (var i = 0; i < shape.required.length; i++) {
	          requiredMap[shape.required[i]] = true;
	        }
	      }
	
	      return requiredMap[name];
	    }, false, true);
	  }
	
	  property(this, 'resultWrapper', shape.resultWrapper || null);
	
	  if (shape.payload) {
	    property(this, 'payload', shape.payload);
	  }
	
	  if (typeof shape.xmlNamespace === 'string') {
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace);
	  } else if (typeof shape.xmlNamespace === 'object') {
	    property(this, 'xmlNamespacePrefix', shape.xmlNamespace.prefix);
	    property(this, 'xmlNamespaceUri', shape.xmlNamespace.uri);
	  }
	}
	
	function ListShape(shape, options) {
	  var self = this, firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return []; });
	  }
	
	  if (shape.member) {
	    memoizedProperty(this, 'member', function() {
	      return Shape.create(shape.member, options);
	    });
	  }
	
	  if (this.flattened) {
	    var oldName = this.name;
	    memoizedProperty(this, 'name', function() {
	      return self.member.name || oldName;
	    });
	  }
	}
	
	function MapShape(shape, options) {
	  var firstInit = !this.isShape;
	  CompositeShape.apply(this, arguments);
	
	  if (firstInit) {
	    property(this, 'defaultValue', function() { return {}; });
	    property(this, 'key', Shape.create({type: 'string'}, options));
	    property(this, 'value', Shape.create({type: 'string'}, options));
	  }
	
	  if (shape.key) {
	    memoizedProperty(this, 'key', function() {
	      return Shape.create(shape.key, options);
	    });
	  }
	  if (shape.value) {
	    memoizedProperty(this, 'value', function() {
	      return Shape.create(shape.value, options);
	    });
	  }
	}
	
	function TimestampShape(shape) {
	  var self = this;
	  Shape.apply(this, arguments);
	
	  if (shape.timestampFormat) {
	    property(this, 'timestampFormat', shape.timestampFormat);
	  } else if (self.isTimestampFormatSet && this.timestampFormat) {
	    property(this, 'timestampFormat', this.timestampFormat);
	  } else if (this.location === 'header') {
	    property(this, 'timestampFormat', 'rfc822');
	  } else if (this.location === 'querystring') {
	    property(this, 'timestampFormat', 'iso8601');
	  } else if (this.api) {
	    switch (this.api.protocol) {
	      case 'json':
	      case 'rest-json':
	        property(this, 'timestampFormat', 'unixTimestamp');
	        break;
	      case 'rest-xml':
	      case 'query':
	      case 'ec2':
	        property(this, 'timestampFormat', 'iso8601');
	        break;
	    }
	  }
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    if (typeof value.toUTCString === 'function') return value;
	    return typeof value === 'string' || typeof value === 'number' ?
	           util.date.parseTimestamp(value) : null;
	  };
	
	  this.toWireFormat = function(value) {
	    return util.date.format(value, self.timestampFormat);
	  };
	}
	
	function StringShape() {
	  Shape.apply(this, arguments);
	
	  var nullLessProtocols = ['rest-xml', 'query', 'ec2'];
	  this.toType = function(value) {
	    value = this.api && nullLessProtocols.indexOf(this.api.protocol) > -1 ?
	      value || '' : value;
	    if (this.isJsonValue) {
	      return JSON.parse(value);
	    }
	
	    return value && typeof value.toString === 'function' ?
	      value.toString() : value;
	  };
	
	  this.toWireFormat = function(value) {
	    return this.isJsonValue ? JSON.stringify(value) : value;
	  };
	}
	
	function FloatShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseFloat(value);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function IntegerShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (value === null || value === undefined) return null;
	    return parseInt(value, 10);
	  };
	  this.toWireFormat = this.toType;
	}
	
	function BinaryShape() {
	  Shape.apply(this, arguments);
	  this.toType = function(value) {
	    var buf = util.base64.decode(value);
	    if (this.isSensitive && util.isNode() && typeof util.Buffer.alloc === 'function') {
	  /* Node.js can create a Buffer that is not isolated.
	   * i.e. buf.byteLength !== buf.buffer.byteLength
	   * This means that the sensitive data is accessible to anyone with access to buf.buffer.
	   * If this is the node shared Buffer, then other code within this process _could_ find this secret.
	   * Copy sensitive data to an isolated Buffer and zero the sensitive data.
	   * While this is safe to do here, copying this code somewhere else may produce unexpected results.
	   */
	      var secureBuf = util.Buffer.alloc(buf.length, buf);
	      buf.fill(0);
	      buf = secureBuf;
	    }
	    return buf;
	  };
	  this.toWireFormat = util.base64.encode;
	}
	
	function Base64Shape() {
	  BinaryShape.apply(this, arguments);
	}
	
	function BooleanShape() {
	  Shape.apply(this, arguments);
	
	  this.toType = function(value) {
	    if (typeof value === 'boolean') return value;
	    if (value === null || value === undefined) return null;
	    return value === 'true';
	  };
	}
	
	/**
	 * @api private
	 */
	Shape.shapes = {
	  StructureShape: StructureShape,
	  ListShape: ListShape,
	  MapShape: MapShape,
	  StringShape: StringShape,
	  BooleanShape: BooleanShape,
	  Base64Shape: Base64Shape
	};
	
	/**
	 * @api private
	 */
	module.exports = Shape;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Error = __webpack_require__(1488);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var Error = function Error(props) {
	  return _react2.default.createElement(
	    'label',
	    { htmlFor: 'error', className: _Error2.default.errorMessage },
	    props.message
	  );
	}; // to validate and set default props  coming to this component
	
	Error.propTypes = {
	  message: _propTypes2.default.string
	};
	
	Error.defaultProps = {
	  message: ''
	};
	
	exports.default = Error;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserNavbar = __webpack_require__(1167);
	
	var _UserNavbar2 = _interopRequireDefault(_UserNavbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UserNavbar2.default;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextField = __webpack_require__(1238);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 162 */
[2565, 497, 294],
/* 163 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(215),
	    isLength = __webpack_require__(318);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1901),
	    baseKeys = __webpack_require__(530),
	    isArrayLike = __webpack_require__(165);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  F: __webpack_require__(2043),
	  T: __webpack_require__(2044),
	  __: __webpack_require__(2045),
	  add: __webpack_require__(219),
	  addIndex: __webpack_require__(2046),
	  adjust: __webpack_require__(684),
	  all: __webpack_require__(2047),
	  allPass: __webpack_require__(2048),
	  always: __webpack_require__(143),
	  and: __webpack_require__(685),
	  any: __webpack_require__(686),
	  anyPass: __webpack_require__(2049),
	  ap: __webpack_require__(327),
	  aperture: __webpack_require__(2050),
	  append: __webpack_require__(2051),
	  apply: __webpack_require__(687),
	  applySpec: __webpack_require__(2052),
	  ascend: __webpack_require__(2053),
	  assoc: __webpack_require__(168),
	  assocPath: __webpack_require__(688),
	  binary: __webpack_require__(2054),
	  bind: __webpack_require__(689),
	  both: __webpack_require__(2055),
	  call: __webpack_require__(2056),
	  chain: __webpack_require__(328),
	  clamp: __webpack_require__(2057),
	  clone: __webpack_require__(2058),
	  comparator: __webpack_require__(2059),
	  complement: __webpack_require__(2060),
	  compose: __webpack_require__(220),
	  composeK: __webpack_require__(690),
	  composeP: __webpack_require__(2061),
	  concat: __webpack_require__(329),
	  cond: __webpack_require__(2062),
	  construct: __webpack_require__(2063),
	  constructN: __webpack_require__(691),
	  contains: __webpack_require__(2064),
	  converge: __webpack_require__(692),
	  countBy: __webpack_require__(2065),
	  curry: __webpack_require__(221),
	  curryN: __webpack_require__(49),
	  dec: __webpack_require__(2066),
	  descend: __webpack_require__(2067),
	  defaultTo: __webpack_require__(693),
	  difference: __webpack_require__(694),
	  differenceWith: __webpack_require__(695),
	  dissoc: __webpack_require__(330),
	  dissocPath: __webpack_require__(2068),
	  divide: __webpack_require__(2069),
	  drop: __webpack_require__(696),
	  dropLast: __webpack_require__(2070),
	  dropLastWhile: __webpack_require__(2071),
	  dropRepeats: __webpack_require__(2072),
	  dropRepeatsWith: __webpack_require__(697),
	  dropWhile: __webpack_require__(2073),
	  either: __webpack_require__(2074),
	  empty: __webpack_require__(698),
	  eqBy: __webpack_require__(2075),
	  eqProps: __webpack_require__(2076),
	  equals: __webpack_require__(81),
	  evolve: __webpack_require__(2077),
	  filter: __webpack_require__(331),
	  find: __webpack_require__(2078),
	  findIndex: __webpack_require__(2079),
	  findLast: __webpack_require__(2080),
	  findLastIndex: __webpack_require__(2081),
	  flatten: __webpack_require__(2082),
	  flip: __webpack_require__(222),
	  forEach: __webpack_require__(2083),
	  forEachObjIndexed: __webpack_require__(2084),
	  fromPairs: __webpack_require__(2085),
	  groupBy: __webpack_require__(2086),
	  groupWith: __webpack_require__(2087),
	  gt: __webpack_require__(2088),
	  gte: __webpack_require__(2089),
	  has: __webpack_require__(2090),
	  hasIn: __webpack_require__(2091),
	  head: __webpack_require__(2092),
	  identical: __webpack_require__(699),
	  identity: __webpack_require__(332),
	  ifElse: __webpack_require__(2093),
	  inc: __webpack_require__(2094),
	  indexBy: __webpack_require__(2095),
	  indexOf: __webpack_require__(2096),
	  init: __webpack_require__(2097),
	  insert: __webpack_require__(2098),
	  insertAll: __webpack_require__(2099),
	  intersection: __webpack_require__(2134),
	  intersectionWith: __webpack_require__(2135),
	  intersperse: __webpack_require__(2136),
	  into: __webpack_require__(2137),
	  invert: __webpack_require__(2138),
	  invertObj: __webpack_require__(2139),
	  invoker: __webpack_require__(170),
	  is: __webpack_require__(714),
	  isArrayLike: __webpack_require__(171),
	  isEmpty: __webpack_require__(2140),
	  isNil: __webpack_require__(2141),
	  join: __webpack_require__(2142),
	  juxt: __webpack_require__(715),
	  keys: __webpack_require__(63),
	  keysIn: __webpack_require__(2143),
	  last: __webpack_require__(716),
	  lastIndexOf: __webpack_require__(2144),
	  length: __webpack_require__(717),
	  lens: __webpack_require__(228),
	  lensIndex: __webpack_require__(2145),
	  lensPath: __webpack_require__(2146),
	  lensProp: __webpack_require__(2147),
	  lift: __webpack_require__(229),
	  liftN: __webpack_require__(718),
	  lt: __webpack_require__(2148),
	  lte: __webpack_require__(2149),
	  map: __webpack_require__(59),
	  mapAccum: __webpack_require__(2150),
	  mapAccumRight: __webpack_require__(2151),
	  mapObjIndexed: __webpack_require__(2152),
	  match: __webpack_require__(2153),
	  mathMod: __webpack_require__(2154),
	  max: __webpack_require__(144),
	  maxBy: __webpack_require__(2155),
	  mean: __webpack_require__(719),
	  median: __webpack_require__(2156),
	  memoize: __webpack_require__(2157),
	  merge: __webpack_require__(2158),
	  mergeAll: __webpack_require__(2159),
	  mergeWith: __webpack_require__(2160),
	  mergeWithKey: __webpack_require__(720),
	  min: __webpack_require__(2161),
	  minBy: __webpack_require__(2162),
	  modulo: __webpack_require__(2163),
	  multiply: __webpack_require__(721),
	  nAry: __webpack_require__(230),
	  negate: __webpack_require__(2164),
	  none: __webpack_require__(2165),
	  not: __webpack_require__(722),
	  nth: __webpack_require__(172),
	  nthArg: __webpack_require__(2166),
	  objOf: __webpack_require__(723),
	  of: __webpack_require__(2167),
	  omit: __webpack_require__(2168),
	  once: __webpack_require__(2169),
	  or: __webpack_require__(724),
	  over: __webpack_require__(725),
	  pair: __webpack_require__(2170),
	  partial: __webpack_require__(2171),
	  partialRight: __webpack_require__(2172),
	  partition: __webpack_require__(2173),
	  path: __webpack_require__(173),
	  pathEq: __webpack_require__(2174),
	  pathOr: __webpack_require__(2175),
	  pathSatisfies: __webpack_require__(2176),
	  pick: __webpack_require__(2177),
	  pickAll: __webpack_require__(726),
	  pickBy: __webpack_require__(727),
	  pipe: __webpack_require__(728),
	  pipeK: __webpack_require__(2178),
	  pipeP: __webpack_require__(729),
	  pluck: __webpack_require__(174),
	  prepend: __webpack_require__(730),
	  product: __webpack_require__(2179),
	  project: __webpack_require__(2180),
	  prop: __webpack_require__(337),
	  propEq: __webpack_require__(2181),
	  propIs: __webpack_require__(2182),
	  propOr: __webpack_require__(2183),
	  propSatisfies: __webpack_require__(2184),
	  props: __webpack_require__(2185),
	  range: __webpack_require__(2186),
	  reduce: __webpack_require__(67),
	  reduceBy: __webpack_require__(231),
	  reduceRight: __webpack_require__(731),
	  reduceWhile: __webpack_require__(2187),
	  reduced: __webpack_require__(2188),
	  reject: __webpack_require__(232),
	  remove: __webpack_require__(2189),
	  repeat: __webpack_require__(2190),
	  replace: __webpack_require__(2191),
	  reverse: __webpack_require__(233),
	  scan: __webpack_require__(2192),
	  sequence: __webpack_require__(732),
	  set: __webpack_require__(2193),
	  slice: __webpack_require__(118),
	  sort: __webpack_require__(2194),
	  sortBy: __webpack_require__(2195),
	  sortWith: __webpack_require__(2196),
	  split: __webpack_require__(2197),
	  splitAt: __webpack_require__(2198),
	  splitEvery: __webpack_require__(2199),
	  splitWhen: __webpack_require__(2200),
	  subtract: __webpack_require__(2201),
	  sum: __webpack_require__(733),
	  symmetricDifference: __webpack_require__(2202),
	  symmetricDifferenceWith: __webpack_require__(2203),
	  tail: __webpack_require__(338),
	  take: __webpack_require__(734),
	  takeLast: __webpack_require__(2204),
	  takeLastWhile: __webpack_require__(2205),
	  takeWhile: __webpack_require__(2206),
	  tap: __webpack_require__(2207),
	  test: __webpack_require__(2208),
	  times: __webpack_require__(735),
	  toLower: __webpack_require__(2209),
	  toPairs: __webpack_require__(2210),
	  toPairsIn: __webpack_require__(2211),
	  toString: __webpack_require__(175),
	  toUpper: __webpack_require__(2212),
	  transduce: __webpack_require__(2213),
	  transpose: __webpack_require__(2214),
	  traverse: __webpack_require__(2215),
	  trim: __webpack_require__(2216),
	  tryCatch: __webpack_require__(2217),
	  type: __webpack_require__(339),
	  unapply: __webpack_require__(2218),
	  unary: __webpack_require__(2219),
	  uncurryN: __webpack_require__(2220),
	  unfold: __webpack_require__(2221),
	  union: __webpack_require__(2222),
	  unionWith: __webpack_require__(2223),
	  uniq: __webpack_require__(340),
	  uniqBy: __webpack_require__(736),
	  uniqWith: __webpack_require__(341),
	  unless: __webpack_require__(2224),
	  unnest: __webpack_require__(2225),
	  until: __webpack_require__(2226),
	  update: __webpack_require__(737),
	  useWith: __webpack_require__(738),
	  values: __webpack_require__(739),
	  valuesIn: __webpack_require__(2227),
	  view: __webpack_require__(2228),
	  when: __webpack_require__(2229),
	  where: __webpack_require__(740),
	  whereEq: __webpack_require__(2230),
	  without: __webpack_require__(2231),
	  xprod: __webpack_require__(2232),
	  zip: __webpack_require__(2233),
	  zipObj: __webpack_require__(2234),
	  zipWith: __webpack_require__(2235)
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(102);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isFunction = __webpack_require__(224);
	var curryN = __webpack_require__(49);
	var toString = __webpack_require__(175);
	
	
	/**
	 * Turns a named method with a specified arity into a function that can be
	 * called directly supplied with arguments and a target object.
	 *
	 * The returned function is curried and accepts `arity + 1` parameters where
	 * the final parameter is the target object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
	 * @param {Number} arity Number of arguments the returned function should take
	 *        before the target object.
	 * @param {String} method Name of the method to call.
	 * @return {Function} A new curried function.
	 * @example
	 *
	 *      var sliceFrom = R.invoker(1, 'slice');
	 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
	 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
	 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
	 * @symb R.invoker(0, 'method')(o) = o['method']()
	 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
	 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
	 */
	module.exports = _curry2(function invoker(arity, method) {
	  return curryN(arity + 1, function() {
	    var target = arguments[arity];
	    if (target != null && _isFunction(target[method])) {
	      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
	    }
	    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
	  });
	});


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _isArray = __webpack_require__(102);
	var _isString = __webpack_require__(226);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @deprecated since v0.23.0
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isString = __webpack_require__(226);
	
	
	/**
	 * Returns the nth element of the given list or string. If n is negative the
	 * element at index length + n is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> a | Undefined
	 * @sig Number -> String -> String
	 * @param {Number} offset
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      var list = ['foo', 'bar', 'baz', 'quux'];
	 *      R.nth(1, list); //=> 'bar'
	 *      R.nth(-1, list); //=> 'quux'
	 *      R.nth(-99, list); //=> undefined
	 *
	 *      R.nth(2, 'abc'); //=> 'c'
	 *      R.nth(3, 'abc'); //=> ''
	 * @symb R.nth(-1, [a, b, c]) = c
	 * @symb R.nth(0, [a, b, c]) = a
	 * @symb R.nth(1, [a, b, c]) = b
	 */
	module.exports = _curry2(function nth(offset, list) {
	  var idx = offset < 0 ? list.length + offset : offset;
	  return _isString(list) ? list.charAt(idx) : list[idx];
	});


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Retrieve the value at a given path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> {a} -> a | Undefined
	 * @param {Array} path The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path`.
	 * @see R.prop
	 * @example
	 *
	 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
	 */
	module.exports = _curry2(function path(paths, obj) {
	  var val = obj;
	  var idx = 0;
	  while (idx < paths.length) {
	    if (val == null) {
	      return;
	    }
	    val = val[paths[idx]];
	    idx += 1;
	  }
	  return val;
	});


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var map = __webpack_require__(59);
	var prop = __webpack_require__(337);
	
	
	/**
	 * Returns a new list by plucking the same named property off all objects in
	 * the list supplied.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig k -> [{k: v}] -> [v]
	 * @param {Number|String} key The key name to pluck off of each object.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of values for the given key.
	 * @see R.props
	 * @example
	 *
	 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
	 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
	 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
	 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
	 */
	module.exports = _curry2(function pluck(p, list) {
	  return map(prop(p), list);
	});


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _toString = __webpack_require__(2117);
	
	
	/**
	 * Returns the string representation of the given value. `eval`'ing the output
	 * should result in a value equivalent to the input value. Many of the built-in
	 * `toString` methods do not satisfy this requirement.
	 *
	 * If the given value is an `[object Object]` with a `toString` method other
	 * than `Object.prototype.toString`, this method is invoked with no arguments
	 * to produce the return value. This means user-defined constructor functions
	 * can provide a suitable `toString` method. For example:
	 *
	 *     function Point(x, y) {
	 *       this.x = x;
	 *       this.y = y;
	 *     }
	 *
	 *     Point.prototype.toString = function() {
	 *       return 'new Point(' + this.x + ', ' + this.y + ')';
	 *     };
	 *
	 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category String
	 * @sig * -> String
	 * @param {*} val
	 * @return {String}
	 * @example
	 *
	 *      R.toString(42); //=> '42'
	 *      R.toString('abc'); //=> '"abc"'
	 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
	 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
	 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
	 */
	module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var EventPluginRegistry = __webpack_require__(345);
	var EventPluginUtils = __webpack_require__(346);
	var ReactErrorUtils = __webpack_require__(350);
	
	var accumulateInto = __webpack_require__(755);
	var forEachAccumulated = __webpack_require__(756);
	var invariant = __webpack_require__(14);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(176);
	var EventPluginUtils = __webpack_require__(346);
	
	var accumulateInto = __webpack_require__(755);
	var forEachAccumulated = __webpack_require__(756);
	var warning = __webpack_require__(17);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 178 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(88);
	
	var getEventTarget = __webpack_require__(355);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(2360);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(2314);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(2316);
	
	var _HelmetConstants = __webpack_require__(765);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.overrideComponentTypeChecker = overrideComponentTypeChecker;
	exports.defaultChecker = defaultChecker;
	exports.default = isComponentOfType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customChecker = void 0;
	
	/**
	 *  Sets customChecker which will be used for all components.
	 *
	 * @param providedChecker {Function} - Checker function
	 */
	function overrideComponentTypeChecker(providedChecker) {
	  customChecker = providedChecker;
	}
	
	/**
	 * Returns true if the provided element is a component of the provided type.
	 *
	 * @param classType {ReactElement class} - the class of a React Element
	 * @param reactElement {ReactElement} - any React Element (not a real DOM node)
	 */
	function defaultChecker(classType, reactElement) {
	  if (false) {
	    // https://github.com/gaearon/react-hot-loader/blob/v3.0.0-beta.7/docs/Known%20Limitations.md#checking-element-types
	    classType = _react2.default.createElement(classType).type; // eslint-disable-line no-param-reassign
	  }
	  return reactElement && reactElement.type === classType;
	}
	
	/**
	 * Executes customChecker if it's set or defaultChecker.
	 *
	 * @param classType {ReactElement class} - the class of a React Element
	 * @param reactElement {ReactElement} - any React Element (not a real DOM node)
	 */
	function isComponentOfType(classType, reactElement) {
	  return customChecker ? customChecker(classType, reactElement) : defaultChecker(classType, reactElement);
	}

/***/ },
/* 182 */
132,
/* 183 */
161,
/* 184 */
163,
/* 185 */
[2573, 384],
/* 186 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 187 */
[2518, 188, 15, 891, 1645, 1646],
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var util = __webpack_require__(41);
	
	// browser specific modules
	util.crypto.lib = __webpack_require__(902);
	util.Buffer = __webpack_require__(100).Buffer;
	util.url = __webpack_require__(908);
	util.querystring = __webpack_require__(218);
	util.environment = 'js';
	
	var AWS = __webpack_require__(15);
	module.exports = AWS;
	
	__webpack_require__(405);
	__webpack_require__(406);
	__webpack_require__(879);
	__webpack_require__(880);
	__webpack_require__(877);
	__webpack_require__(878);
	
	// Load the DOMParser XML parser
	AWS.XML.Parser = __webpack_require__(900);
	
	// Load the XHR HttpClient
	__webpack_require__(882);
	
	if (typeof process === 'undefined') {
	  process = {
	    browser: true
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	
	function populateMethod(req) {
	  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
	}
	
	function generateURI(endpointPath, operationPath, input, params) {
	  var uri = [endpointPath, operationPath].join('/');
	  uri = uri.replace(/\/+/g, '/');
	
	  var queryString = {}, queryStringSet = false;
	  util.each(input.members, function (name, member) {
	    var paramValue = params[name];
	    if (paramValue === null || paramValue === undefined) return;
	    if (member.location === 'uri') {
	      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
	      uri = uri.replace(regex, function(_, plus) {
	        var fn = plus ? util.uriEscapePath : util.uriEscape;
	        return fn(String(paramValue));
	      });
	    } else if (member.location === 'querystring') {
	      queryStringSet = true;
	
	      if (member.type === 'list') {
	        queryString[member.name] = paramValue.map(function(val) {
	          return util.uriEscape(String(val));
	        });
	      } else if (member.type === 'map') {
	        util.each(paramValue, function(key, value) {
	          if (Array.isArray(value)) {
	            queryString[key] = value.map(function(val) {
	              return util.uriEscape(String(val));
	            });
	          } else {
	            queryString[key] = util.uriEscape(String(value));
	          }
	        });
	      } else {
	        queryString[member.name] = util.uriEscape(String(paramValue));
	      }
	    }
	  });
	
	  if (queryStringSet) {
	    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
	    var parts = [];
	    util.arrayEach(Object.keys(queryString).sort(), function(key) {
	      if (!Array.isArray(queryString[key])) {
	        queryString[key] = [queryString[key]];
	      }
	      for (var i = 0; i < queryString[key].length; i++) {
	        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
	      }
	    });
	    uri += parts.join('&');
	  }
	
	  return uri;
	}
	
	function populateURI(req) {
	  var operation = req.service.api.operations[req.operation];
	  var input = operation.input;
	
	  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
	  req.httpRequest.path = uri;
	}
	
	function populateHeaders(req) {
	  var operation = req.service.api.operations[req.operation];
	  util.each(operation.input.members, function (name, member) {
	    var value = req.params[name];
	    if (value === null || value === undefined) return;
	
	    if (member.location === 'headers' && member.type === 'map') {
	      util.each(value, function(key, memberValue) {
	        req.httpRequest.headers[member.name + key] = memberValue;
	      });
	    } else if (member.location === 'header') {
	      value = member.toWireFormat(value).toString();
	      if (member.isJsonValue) {
	        value = util.base64.encode(value);
	      }
	      req.httpRequest.headers[member.name] = value;
	    }
	  });
	}
	
	function buildRequest(req) {
	  populateMethod(req);
	  populateURI(req);
	  populateHeaders(req);
	}
	
	function extractError() {
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var data = {};
	  var r = resp.httpResponse;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  // normalize headers names to lower-cased keys for matching
	  var headers = {};
	  util.each(r.headers, function (k, v) {
	    headers[k.toLowerCase()] = v;
	  });
	
	  util.each(output.members, function(name, member) {
	    var header = (member.name || name).toLowerCase();
	    if (member.location === 'headers' && member.type === 'map') {
	      data[name] = {};
	      var location = member.isLocationName ? member.name : '';
	      var pattern = new RegExp('^' + location + '(.+)', 'i');
	      util.each(r.headers, function (k, v) {
	        var result = k.match(pattern);
	        if (result !== null) {
	          data[name][result[1]] = v;
	        }
	      });
	    } else if (member.location === 'header') {
	      if (headers[header] !== undefined) {
	        var value = member.isJsonValue ?
	          util.base64.decode(headers[header]) :
	          headers[header];
	        data[name] = member.toType(value);
	      }
	    } else if (member.location === 'statusCode') {
	      data[name] = parseInt(r.statusCode, 10);
	    }
	  });
	
	  resp.data = data;
	}
	
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData,
	  generateURI: generateURI
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(100).Buffer;
	
	/**
	 * This is a polyfill for the static method `isView` of `ArrayBuffer`, which is
	 * e.g. missing in IE 10.
	 *
	 * @api private
	 */
	if (
	    typeof ArrayBuffer !== 'undefined' &&
	    typeof ArrayBuffer.isView === 'undefined'
	) {
	    ArrayBuffer.isView = function(arg) {
	        return viewStrings.indexOf(Object.prototype.toString.call(arg)) > -1;
	    };
	}
	
	/**
	 * @api private
	 */
	var viewStrings = [
	    '[object Int8Array]',
	    '[object Uint8Array]',
	    '[object Uint8ClampedArray]',
	    '[object Int16Array]',
	    '[object Uint16Array]',
	    '[object Int32Array]',
	    '[object Uint32Array]',
	    '[object Float32Array]',
	    '[object Float64Array]',
	    '[object DataView]',
	];
	
	/**
	 * @api private
	 */
	function isEmptyData(data) {
	    if (typeof data === 'string') {
	        return data.length === 0;
	    }
	    return data.byteLength === 0;
	}
	
	/**
	 * @api private
	 */
	function convertToBuffer(data) {
	    if (typeof data === 'string') {
	        data = new Buffer(data, 'utf8');
	    }
	
	    if (ArrayBuffer.isView(data)) {
	        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
	    }
	
	    return new Uint8Array(data);
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = {
	    isEmptyData: isEmptyData,
	    convertToBuffer: convertToBuffer,
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	var populateHostPrefix = __webpack_require__(276).populateHostPrefix;
	
	function populateMethod(req) {
	  req.httpRequest.method = req.service.api.operations[req.operation].httpMethod;
	}
	
	function generateURI(endpointPath, operationPath, input, params) {
	  var uri = [endpointPath, operationPath].join('/');
	  uri = uri.replace(/\/+/g, '/');
	
	  var queryString = {}, queryStringSet = false;
	  util.each(input.members, function (name, member) {
	    var paramValue = params[name];
	    if (paramValue === null || paramValue === undefined) return;
	    if (member.location === 'uri') {
	      var regex = new RegExp('\\{' + member.name + '(\\+)?\\}');
	      uri = uri.replace(regex, function(_, plus) {
	        var fn = plus ? util.uriEscapePath : util.uriEscape;
	        return fn(String(paramValue));
	      });
	    } else if (member.location === 'querystring') {
	      queryStringSet = true;
	
	      if (member.type === 'list') {
	        queryString[member.name] = paramValue.map(function(val) {
	          return util.uriEscape(member.member.toWireFormat(val).toString());
	        });
	      } else if (member.type === 'map') {
	        util.each(paramValue, function(key, value) {
	          if (Array.isArray(value)) {
	            queryString[key] = value.map(function(val) {
	              return util.uriEscape(String(val));
	            });
	          } else {
	            queryString[key] = util.uriEscape(String(value));
	          }
	        });
	      } else {
	        queryString[member.name] = util.uriEscape(member.toWireFormat(paramValue).toString());
	      }
	    }
	  });
	
	  if (queryStringSet) {
	    uri += (uri.indexOf('?') >= 0 ? '&' : '?');
	    var parts = [];
	    util.arrayEach(Object.keys(queryString).sort(), function(key) {
	      if (!Array.isArray(queryString[key])) {
	        queryString[key] = [queryString[key]];
	      }
	      for (var i = 0; i < queryString[key].length; i++) {
	        parts.push(util.uriEscape(String(key)) + '=' + queryString[key][i]);
	      }
	    });
	    uri += parts.join('&');
	  }
	
	  return uri;
	}
	
	function populateURI(req) {
	  var operation = req.service.api.operations[req.operation];
	  var input = operation.input;
	
	  var uri = generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
	  req.httpRequest.path = uri;
	}
	
	function populateHeaders(req) {
	  var operation = req.service.api.operations[req.operation];
	  util.each(operation.input.members, function (name, member) {
	    var value = req.params[name];
	    if (value === null || value === undefined) return;
	
	    if (member.location === 'headers' && member.type === 'map') {
	      util.each(value, function(key, memberValue) {
	        req.httpRequest.headers[member.name + key] = memberValue;
	      });
	    } else if (member.location === 'header') {
	      value = member.toWireFormat(value).toString();
	      if (member.isJsonValue) {
	        value = util.base64.encode(value);
	      }
	      req.httpRequest.headers[member.name] = value;
	    }
	  });
	}
	
	function buildRequest(req) {
	  populateMethod(req);
	  populateURI(req);
	  populateHeaders(req);
	  populateHostPrefix(req);
	}
	
	function extractError() {
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var data = {};
	  var r = resp.httpResponse;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  // normalize headers names to lower-cased keys for matching
	  var headers = {};
	  util.each(r.headers, function (k, v) {
	    headers[k.toLowerCase()] = v;
	  });
	
	  util.each(output.members, function(name, member) {
	    var header = (member.name || name).toLowerCase();
	    if (member.location === 'headers' && member.type === 'map') {
	      data[name] = {};
	      var location = member.isLocationName ? member.name : '';
	      var pattern = new RegExp('^' + location + '(.+)', 'i');
	      util.each(r.headers, function (k, v) {
	        var result = k.match(pattern);
	        if (result !== null) {
	          data[name][result[1]] = v;
	        }
	      });
	    } else if (member.location === 'header') {
	      if (headers[header] !== undefined) {
	        var value = member.isJsonValue ?
	          util.base64.decode(headers[header]) :
	          headers[header];
	        data[name] = member.toType(value);
	      }
	    } else if (member.location === 'statusCode') {
	      data[name] = parseInt(r.statusCode, 10);
	    }
	  });
	
	  resp.data = data;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData,
	  generateURI: generateURI
	};


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _coachProfile = __webpack_require__(1070);
	
	Object.defineProperty(exports, 'saveCoach', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.saveCoach;
	    }
	});
	Object.defineProperty(exports, 'getCoach', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.getCoach;
	    }
	});
	Object.defineProperty(exports, 'storePosting', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.storePosting;
	    }
	});
	Object.defineProperty(exports, 'getAllPostingsById', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.getAllPostingsById;
	    }
	});
	Object.defineProperty(exports, 'editPosting', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.editPosting;
	    }
	});
	Object.defineProperty(exports, 'updatePosting', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.updatePosting;
	    }
	});
	Object.defineProperty(exports, 'deletePostingById', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.deletePostingById;
	    }
	});
	Object.defineProperty(exports, 'validataCoachFromDatabase', {
	    enumerable: true,
	    get: function get() {
	        return _coachProfile.validataCoachFromDatabase;
	    }
	});

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bannerSelector = exports.banner = exports.bannerInitialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _BannerActionTypes = __webpack_require__(447);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var bannerInitialState = exports.bannerInitialState = (0, _immutable.Map)({
	  video: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _BannerActionTypes.SHOW_VIDEO, function (state) {
	  return state.merge({
	    video: true
	  });
	}), _defineProperty(_handlers, _BannerActionTypes.CLOSE_VIDEO, function (state) {
	  return state.merge({
	    video: false
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    video: false
	  });
	}), _handlers);
	
	var banner = exports.banner = (0, _reducers.createReducer)(bannerInitialState, handlers);
	
	// LOGIN SELECTOR
	var video = function video(state) {
	  return state.banner.get('video');
	};
	
	var bannerSelector = exports.bannerSelector = (0, _reselect.createStructuredSelector)({
	  video: video
	});

/***/ },
/* 194 */
[2527, 1118],
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DashboardView = __webpack_require__(113);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nocontentfound = function Nocontentfound(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12', _DashboardView2.default.emptyScreens) },
	    _react2.default.createElement(
	      'div',
	      { className: _DashboardView2.default.emptyImage },
	      _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png', alt: 'empty screen' })
	    ),
	    _react2.default.createElement('br', null),
	    ' ',
	    _react2.default.createElement('br', null),
	    props.text
	  );
	};
	
	Nocontentfound.propTypes = {
	  text: _propTypes2.default.string.isRequired
	};
	
	exports.default = Nocontentfound;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Details = __webpack_require__(1134);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Details2.default;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navigation = __webpack_require__(1168);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Navigation2.default;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProfileBanner = __webpack_require__(1186);
	
	var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProfileBanner2.default;

/***/ },
/* 199 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SEARCH_USER_REQUESTED = exports.SEARCH_USER_REQUESTED = 'SEARCH_USER_REQUESTED';
	var SEARCH_USER_FAILED = exports.SEARCH_USER_FAILED = 'SEARCH_USER_FAILED';
	var SEARCH_USER_SUCCESSFUL = exports.SEARCH_USER_SUCCESSFUL = 'SEARCH_USER_SUCCESSFUL';
	var GET_COACH_APPLICATIONS_REQUESTED = exports.GET_COACH_APPLICATIONS_REQUESTED = 'GET_COACH_APPLICATIONS_REQUESTED';
	var GET_COACH_APPLICATIONS_SUCCESSFUL = exports.GET_COACH_APPLICATIONS_SUCCESSFUL = 'GET_COACH_APPLICATIONS_SUCCESSFUL';
	var GET_COACH_APPLICATIONS_FAILED = exports.GET_COACH_APPLICATIONS_FAILED = 'GET_COACH_APPLICATIONS_FAILED';
	var COACH_APPLICATION_UPGRADE_REQUESTED = exports.COACH_APPLICATION_UPGRADE_REQUESTED = 'COACH_APPLICATION_UPGRADE_REQUESTED';
	var COACH_APPLICATION_UPGRADE_FAILED = exports.COACH_APPLICATION_UPGRADE_FAILED = 'COACH_APPLICATION_UPGRADE_FAILED';
	var COACH_APPLICATION_UPGRADE_SUCCESSFUL = exports.COACH_APPLICATION_UPGRADE_SUCCESSFUL = 'COACH_APPLICATION_UPGRADE_SUCCESSFUL';
	var ERASE_CURRENT_USER_DATA = exports.ERASE_CURRENT_USER_DATA = 'ERASE_CURRENT_USER_DATA';
	var START_LOADER = exports.START_LOADER = 'START_LOADER';
	var STOP_LOADER = exports.STOP_LOADER = 'STOP_LOADER';
	var UPGRADE_STUDENT_SUCCESSFUL = exports.UPGRADE_STUDENT_SUCCESSFUL = 'UPGRADE_STUDENT_SUCCESSFUL';
	var OVERRIDE_STUDENT_SUCCESSFUL = exports.OVERRIDE_STUDENT_SUCCESSFUL = 'OVERRIDE_STUDENT_SUCCESSFUL';
	var STUDENT_EVALUATION_SUCCESSFUL = exports.STUDENT_EVALUATION_SUCCESSFUL = 'STUDENT_EVALUATION_SUCCESSFUL';
	var DELETE_COACH_SUCCESSFUL = exports.DELETE_COACH_SUCCESSFUL = 'DELETE_COACH_SUCCESSFUL';
	var ADD_COACH = exports.ADD_COACH = 'ADD_COACH_SUCCESSFUL';
	var MODIFY_COLLEGE = exports.MODIFY_COLLEGE = 'MODIFY_COLLEGE_SUCCESSFUL';
	var RESET_DELETE_COACH = exports.RESET_DELETE_COACH = 'RESET_DELETE_COACH';
	var RESET_ADD_COACH = exports.RESET_ADD_COACH = 'RESET_ADD_COACH';
	var GET_COACHES_FROM_DB = exports.GET_COACHES_FROM_DB = 'GET_COACHES_FROM_DB';
	var ADD_COLLEGE_SUCCESSFUL = exports.ADD_COLLEGE_SUCCESSFUL = 'ADD_COLLEGE_SUCCESSFUL';
	var RESET_STUDENT_VALUES = exports.RESET_STUDENT_VALUES = 'RESET_STUDENT_VALUES';
	var GET_STUDENTS_FOR_STUDENT_EXPLORER = exports.GET_STUDENTS_FOR_STUDENT_EXPLORER = 'GET_STUDENTS_FOR_STUDENT_EXPLORER';
	var DELETE_COACH_APPLICATION_SUCCESSFUL = exports.DELETE_COACH_APPLICATION_SUCCESSFUL = 'DELETE_COACH_APPLICATION_SUCCESSFUL';
	var RESET_STUDENT_DASHBOARD_REQUESTED = exports.RESET_STUDENT_DASHBOARD_REQUESTED = 'RESET_STUDENT_DASHBOARD_REQUESTED';
	var RESET_STUDENT_DASHBOARD_SUCCESSFUL = exports.RESET_STUDENT_DASHBOARD_SUCCESSFUL = 'RESET_STUDENT_DASHBOARD_SUCCESSFUL';
	var RESET_STUDENT_DASHBOARD_FAILED = exports.RESET_STUDENT_DASHBOARD_FAILED = 'RESET_STUDENT_DASHBOARD_FAILED';
	var START_ES_LOADER = exports.START_ES_LOADER = 'START_ES_LOADER';
	var STOP_ES_LOADER = exports.STOP_ES_LOADER = 'STOP_ES_LOADER';
	var GET_ES_STUDENTS_FOR_STUDENT_EXPLORER = exports.GET_ES_STUDENTS_FOR_STUDENT_EXPLORER = 'GET_ES_STUDENTS_FOR_STUDENT_EXPLORER';
	var SEARCH_ES_USER_REQUESTED = exports.SEARCH_ES_USER_REQUESTED = 'SEARCH_ES_USER_REQUESTED';
	var SEARCH_ES_USER_FAILED = exports.SEARCH_ES_USER_FAILED = 'SEARCH_ES_USER_FAILED';
	var SEARCH_ES_USER_SUCCESSFUL = exports.SEARCH_ES_USER_SUCCESSFUL = 'SEARCH_ES_USER_SUCCESSFUL';

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'SA_PROFILE_VIEW_REQUESTED';
	var FAILED = exports.FAILED = 'SA_PROFILE_VIEW_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'SA_PROFILE_VIEW_SUCCESSFUL';
	var VIEWING_AS_COACH = exports.VIEWING_AS_COACH = 'VIEWING_AS_COACH';
	var CURRENT_VIDEO_URL = exports.CURRENT_VIDEO_URL = 'CURRENT_VIDEO_URL';
	var PUBLIC_ADD_CONVERSATION_REQUESTED = exports.PUBLIC_ADD_CONVERSATION_REQUESTED = 'PUBLIC_ADD_CONVERSATION_REQUESTED';
	var PUBLIC_ADD_CONVERSATION_FAILED = exports.PUBLIC_ADD_CONVERSATION_FAILED = 'PUBLIC_ADD_CONVERSATION_REQUESTED';
	var PUBLIC_ADD_CONVERSATION_SUCCESSFUL = exports.PUBLIC_ADD_CONVERSATION_SUCCESSFUL = 'PUBLIC_ADD_CONVERSATION_REQUESTED';

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REGISTER_REQUESTED = exports.REGISTER_REQUESTED = 'REGISTER_REQUESTED';
	var REGISTER_FAILED = exports.REGISTER_FAILED = 'REGISTER_FAILED';
	var REGISTER_SUCCESSFUL = exports.REGISTER_SUCCESSFUL = 'REGISTER_SUCCESSFUL';

/***/ },
/* 202 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 203 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 204 */
186,
/* 205 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createRule = __webpack_require__(521);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	var _updateRule = __webpack_require__(1886);
	
	var _updateRule2 = _interopRequireDefault(_updateRule);
	
	var _linkRule = __webpack_require__(522);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	var _StyleRule = __webpack_require__(519);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Contains rules objects and allows adding/removing etc.
	 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	 */
	var RuleList = function () {
	
	  // Original styles object.
	  function RuleList(options) {
	    _classCallCheck(this, RuleList);
	
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	
	    this.options = options;
	    this.classes = options.classes;
	  }
	
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  // Used to ensure correct rules order.
	
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	
	
	  _createClass(RuleList, [{
	    key: 'add',
	    value: function add(name, decl, options) {
	      var _options = this.options,
	          parent = _options.parent,
	          sheet = _options.sheet,
	          jss = _options.jss,
	          Renderer = _options.Renderer,
	          generateClassName = _options.generateClassName;
	
	
	      options = _extends({
	        classes: this.classes,
	        parent: parent,
	        sheet: sheet,
	        jss: jss,
	        Renderer: Renderer,
	        generateClassName: generateClassName
	      }, options);
	
	      if (!options.selector && this.classes[name]) options.selector = '.' + this.classes[name];
	
	      this.raw[name] = decl;
	
	      var rule = (0, _createRule2['default'])(name, decl, options);
	      this.register(rule);
	
	      var index = options.index === undefined ? this.index.length : options.index;
	      this.index.splice(index, 0, rule);
	
	      return rule;
	    }
	
	    /**
	     * Get a rule.
	     */
	
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this.map[name];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(rule) {
	      this.unregister(rule);
	      this.index.splice(this.indexOf(rule), 1);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.index.indexOf(rule);
	    }
	
	    /**
	     * Run `onProcessRule()` plugins on every rule.
	     */
	
	  }, {
	    key: 'process',
	    value: function process() {
	      var plugins = this.options.jss.plugins;
	      // We need to clone array because if we modify the index somewhere else during a loop
	      // we end up with very hard-to-track-down side effects.
	
	      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	    }
	
	    /**
	     * Register a rule in `.map` and `.classes` maps.
	     */
	
	  }, {
	    key: 'register',
	    value: function register(rule) {
	      this.map[rule.key] = rule;
	      if (rule instanceof _StyleRule2['default']) {
	        this.map[rule.selector] = rule;
	        this.classes[rule.key] = rule.selector.substr(1);
	      }
	    }
	
	    /**
	     * Unregister a rule.
	     */
	
	  }, {
	    key: 'unregister',
	    value: function unregister(rule) {
	      delete this.map[rule.key];
	      delete this.classes[rule.key];
	      if (rule instanceof _StyleRule2['default']) delete this.map[rule.selector];
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'update',
	    value: function update(name, data) {
	      if (typeof name === 'string') {
	        (0, _updateRule2['default'])(this.get(name), data, RuleList);
	        return;
	      }
	
	      for (var index = 0; index < this.index.length; index++) {
	        (0, _updateRule2['default'])(this.index[index], name, RuleList);
	      }
	    }
	
	    /**
	     * Link renderable rules with CSSRuleList.
	     */
	
	  }, {
	    key: 'link',
	    value: function link(cssRules) {
	      for (var i = 0; i < cssRules.length; i++) {
	        var cssRule = cssRules[i];
	        var rule = this.get(this.options.sheet.renderer.getSelector(cssRule));
	        if (rule) (0, _linkRule2['default'])(rule, cssRule);
	      }
	    }
	
	    /**
	     * Convert rules to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      var str = '';
	
	      for (var index = 0; index < this.index.length; index++) {
	        var rule = this.index[index];
	        var css = rule.toString(options);
	
	        // No need to render an empty rule.
	        if (!css) continue;
	
	        if (str) str += '\n';
	        str += css;
	      }
	
	      return str;
	    }
	  }]);
	
	  return RuleList;
	}();
	
	exports['default'] = RuleList;

/***/ },
/* 207 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1949),
	    listCacheDelete = __webpack_require__(1950),
	    listCacheGet = __webpack_require__(1951),
	    listCacheHas = __webpack_require__(1952),
	    listCacheSet = __webpack_require__(1953);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(87);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(214);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1947);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(115);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(319);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 214 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(140),
	    isObject = __webpack_require__(80);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(546);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(1996);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(2041);
	exports.encode = exports.stringify = __webpack_require__(2042);


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Adds two values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Number}
	 * @see R.subtract
	 * @example
	 *
	 *      R.add(2, 3);       //=>  5
	 *      R.add(7)(10);      //=> 17
	 */
	module.exports = _curry2(function add(a, b) {
	  return Number(a) + Number(b);
	});


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(728);
	var reverse = __webpack_require__(233);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var curryN = __webpack_require__(49);
	
	
	/**
	 * Returns a curried equivalent of the provided function. The curried function
	 * has two unusual capabilities. First, its arguments needn't be provided one
	 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
	 * following are equivalent:
	 *
	 *   - `g(1)(2)(3)`
	 *   - `g(1)(2, 3)`
	 *   - `g(1, 2)(3)`
	 *   - `g(1, 2, 3)`
	 *
	 * Secondly, the special placeholder value `R.__` may be used to specify
	 * "gaps", allowing partial application of any combination of arguments,
	 * regardless of their positions. If `g` is as above and `_` is `R.__`, the
	 * following are equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> a) -> (* -> a)
	 * @param {Function} fn The function to curry.
	 * @return {Function} A new, curried function.
	 * @see R.curryN
	 * @example
	 *
	 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
	 *
	 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
	 *      var f = curriedAddFourNumbers(1, 2);
	 *      var g = f(3);
	 *      g(4); //=> 10
	 */
	module.exports = _curry1(function curry(fn) {
	  return curryN(fn.length, fn);
	});


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var curry = __webpack_require__(221);
	
	
	/**
	 * Returns a new function much like the supplied one, except that the first two
	 * arguments' order is reversed.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
	 * @param {Function} fn The function to invoke with its first two parameters reversed.
	 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
	 * @example
	 *
	 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
	 *
	 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
	 * @symb R.flip(f)(a, b, c) = f(b, a, c)
	 */
	module.exports = _curry1(function flip(fn) {
	  return curry(function(a, b) {
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = b;
	    args[1] = a;
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _isPlaceholder = __webpack_require__(225);
	
	
	/**
	 * Internal curryN function.
	 *
	 * @private
	 * @category Function
	 * @param {Number} length The arity of the curried function.
	 * @param {Array} received An array of arguments received thus far.
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curryN(length, received, fn) {
	  return function() {
	    var combined = [];
	    var argsIdx = 0;
	    var left = length;
	    var combinedIdx = 0;
	    while (combinedIdx < received.length || argsIdx < arguments.length) {
	      var result;
	      if (combinedIdx < received.length &&
	          (!_isPlaceholder(received[combinedIdx]) ||
	           argsIdx >= arguments.length)) {
	        result = received[combinedIdx];
	      } else {
	        result = arguments[argsIdx];
	        argsIdx += 1;
	      }
	      combined[combinedIdx] = result;
	      if (!_isPlaceholder(result)) {
	        left -= 1;
	      }
	      combinedIdx += 1;
	    }
	    return left <= 0 ? fn.apply(this, combined)
	                     : _arity(left, _curryN(length, combined, fn));
	  };
	};


/***/ },
/* 224 */
/***/ function(module, exports) {

	module.exports = function _isFunction(x) {
	  return Object.prototype.toString.call(x) === '[object Function]';
	};


/***/ },
/* 225 */
/***/ function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ },
/* 226 */
/***/ function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ },
/* 227 */
/***/ function(module, exports) {

	module.exports = function _map(fn, functor) {
	  var idx = 0;
	  var len = functor.length;
	  var result = Array(len);
	  while (idx < len) {
	    result[idx] = fn(functor[idx]);
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var map = __webpack_require__(59);
	
	
	/**
	 * Returns a lens for the given getter and setter functions. The getter "gets"
	 * the value of the focus; the setter "sets" the value of the focus. The setter
	 * should not mutate the data structure.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
	 * @param {Function} getter
	 * @param {Function} setter
	 * @return {Lens}
	 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry2(function lens(getter, setter) {
	  return function(toFunctorFn) {
	    return function(target) {
	      return map(
	        function(focus) {
	          return setter(focus, target);
	        },
	        toFunctorFn(getter(target))
	      );
	    };
	  };
	});


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var liftN = __webpack_require__(718);
	
	
	/**
	 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
	 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.liftN
	 * @example
	 *
	 *      var madd3 = R.lift((a, b, c) => a + b + c);
	 *
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 *
	 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
	 *
	 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
	 */
	module.exports = _curry1(function lift(fn) {
	  return liftN(fn.length, fn);
	});


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly `n` parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig Number -> (* -> a) -> (* -> a)
	 * @param {Number} n The desired arity of the new function.
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity `n`.
	 * @example
	 *
	 *      var takesTwoArgs = (a, b) => [a, b];
	 *
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.nAry(1, takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only `n` arguments are passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.nAry(0, f)(a, b) = f()
	 * @symb R.nAry(1, f)(a, b) = f(a)
	 * @symb R.nAry(2, f)(a, b) = f(a, b)
	 */
	module.exports = _curry2(function nAry(n, fn) {
	  switch (n) {
	    case 0: return function() {return fn.call(this);};
	    case 1: return function(a0) {return fn.call(this, a0);};
	    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
	    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
	    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
	    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
	    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
	    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
	  }
	});


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(223);
	var _dispatchable = __webpack_require__(39);
	var _has = __webpack_require__(52);
	var _reduce = __webpack_require__(62);
	var _xreduceBy = __webpack_require__(2131);
	
	
	/**
	 * Groups the elements of the list according to the result of calling
	 * the String-returning function `keyFn` on each element and reduces the elements
	 * of each group to a single value via the reducer function `valueFn`.
	 *
	 * This function is basically a more general `groupBy` function.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
	 * @param {Function} valueFn The function that reduces the elements of each group to a single
	 *        value. Receives two values, accumulator for a particular group and the current element.
	 * @param {*} acc The (initial) accumulator value for each group.
	 * @param {Function} keyFn The function that maps the list's element into a key.
	 * @param {Array} list The array to group.
	 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
	 *         `valueFn` for elements which produced that key when passed to `keyFn`.
	 * @see R.groupBy, R.reduce
	 * @example
	 *
	 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
	 *      var namesByGrade = reduceToNamesBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Lucy', score: 92},
	 *                      {name: 'Drew', score: 85},
	 *                      // ...
	 *                      {name: 'Bart', score: 62}];
	 *      namesByGrade(students);
	 *      // {
	 *      //   'A': ['Lucy'],
	 *      //   'B': ['Drew']
	 *      //   // ...,
	 *      //   'F': ['Bart']
	 *      // }
	 */
	module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
	  function reduceBy(valueFn, valueAcc, keyFn, list) {
	    return _reduce(function(acc, elt) {
	      var key = keyFn(elt);
	      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
	      return acc;
	    }, {}, list);
	  }));


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(702);
	var _curry2 = __webpack_require__(6);
	var filter = __webpack_require__(331);
	
	
	/**
	 * The complement of `filter`.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.filter, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isOdd = (n) => n % 2 === 1;
	 *
	 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(function reject(pred, filterable) {
	  return filter(_complement(pred), filterable);
	});


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _isString = __webpack_require__(226);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventPluginRegistry = __webpack_require__(345);
	var ReactEventEmitterMixin = __webpack_require__(2271);
	var ViewportMetrics = __webpack_require__(754);
	
	var getVendorPrefixedEventName = __webpack_require__(2303);
	var isEventSupported = __webpack_require__(356);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(179);
	var ViewportMetrics = __webpack_require__(754);
	
	var getEventModifierState = __webpack_require__(354);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var DOMNamespaces = __webpack_require__(344);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(352);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDynamicStyles = exports.SheetsRegistry = exports.SheetsManager = exports.createGenerateClassNameDefault = undefined;
	
	var _createGenerateClassName = __webpack_require__(520);
	
	Object.defineProperty(exports, 'createGenerateClassNameDefault', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createGenerateClassName)['default'];
	  }
	});
	
	var _SheetsManager = __webpack_require__(516);
	
	Object.defineProperty(exports, 'SheetsManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SheetsManager)['default'];
	  }
	});
	
	var _jss = __webpack_require__(518);
	
	Object.defineProperty(exports, 'SheetsRegistry', {
	  enumerable: true,
	  get: function get() {
	    return _jss.SheetsRegistry;
	  }
	});
	Object.defineProperty(exports, 'getDynamicStyles', {
	  enumerable: true,
	  get: function get() {
	    return _jss.getDynamicStyles;
	  }
	});
	
	var _jssPresetDefault = __webpack_require__(1869);
	
	var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = (0, _jss.create)((0, _jssPresetDefault2['default'])());

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var Card = (function (_React$Component) {
	  _inherits(Card, _React$Component);
	
	  function Card() {
	    _classCallCheck(this, Card);
	
	    _get(Object.getPrototypeOf(Card.prototype), 'constructor', this).apply(this, arguments);
	
	    this.state = {
	      hover: false,
	      transition: 'opacity',
	      width: 0,
	      height: 0
	    };
	    this.margin = 15;
	    this.defaultArrowStyle = {
	      color: '#fff',
	      borderColor: 'rgba(0,0,0,.4)'
	    };
	  }
	
	  _createClass(Card, [{
	    key: 'getGlobalStyle',
	    value: function getGlobalStyle() {
	      if (!this.props.parentEl) {
	        return { display: 'none' };
	      }
	
	      var style = {
	        position: 'absolute',
	        padding: '5px',
	        background: '#fff',
	        boxShadow: '0 0 8px rgba(0,0,0,.3)',
	        borderRadius: '3px',
	        transition: this.state.transition + ' .3s ease-in-out, visibility .3s ease-in-out',
	        opacity: this.state.hover || this.props.active ? 1 : 0,
	        visibility: this.state.hover || this.props.active ? 'visible' : 'hidden',
	        zIndex: 50
	      };
	
	      (0, _objectAssign2['default'])(style, this.getStyle(this.props.position, this.props.arrow));
	
	      return this.mergeStyle(style, this.props.style.style);
	    }
	  }, {
	    key: 'getBaseArrowStyle',
	    value: function getBaseArrowStyle() {
	      return {
	        position: 'absolute',
	        content: '""',
	        transition: 'all .3s ease-in-out'
	      };
	    }
	  }, {
	    key: 'getArrowStyle',
	    value: function getArrowStyle() {
	      var fgStyle = this.getBaseArrowStyle();
	      var bgStyle = this.getBaseArrowStyle();
	      fgStyle.zIndex = 60;
	      bgStyle.zIndex = 55;
	
	      var arrowStyle = (0, _objectAssign2['default'])(this.defaultArrowStyle, this.props.style.arrowStyle);
	      var bgBorderColor = arrowStyle.borderColor ? arrowStyle.borderColor : 'transparent';
	
	      var fgSize = 8;
	      var bgSize = 9;
	      var fgColorBorder = '10px solid ' + arrowStyle.color;
	      var fgTransBorder = fgSize + 'px solid transparent';
	      var bgColorBorder = '11px solid ' + bgBorderColor;
	      var bgTransBorder = bgSize + 'px solid transparent';
	
	      var _props = this.props;
	      var position = _props.position;
	      var arrow = _props.arrow;
	
	      if (position === 'left' || position === 'right') {
	        fgStyle.top = '50%';
	        fgStyle.borderTop = fgTransBorder;
	        fgStyle.borderBottom = fgTransBorder;
	        fgStyle.marginTop = -7;
	
	        bgStyle.borderTop = bgTransBorder;
	        bgStyle.borderBottom = bgTransBorder;
	        bgStyle.top = '50%';
	        bgStyle.marginTop = -8;
	
	        if (position === 'left') {
	          fgStyle.right = -10;
	          fgStyle.borderLeft = fgColorBorder;
	          bgStyle.right = -11;
	          bgStyle.borderLeft = bgColorBorder;
	        } else {
	          fgStyle.left = -10;
	          fgStyle.borderRight = fgColorBorder;
	          bgStyle.left = -11;
	          bgStyle.borderRight = bgColorBorder;
	        }
	
	        if (arrow === 'top') {
	          fgStyle.top = this.margin;
	          bgStyle.top = this.margin;
	        }
	        if (arrow === 'bottom') {
	          fgStyle.top = null;
	          fgStyle.bottom = this.margin - 7;
	          bgStyle.top = null;
	          bgStyle.bottom = this.margin - 8;
	        }
	      } else {
	        fgStyle.left = '50%';
	        fgStyle.marginLeft = -10;
	        fgStyle.borderLeft = fgTransBorder;
	        fgStyle.borderRight = fgTransBorder;
	        bgStyle.left = '50%';
	        bgStyle.marginLeft = -11;
	        bgStyle.borderLeft = bgTransBorder;
	        bgStyle.borderRight = bgTransBorder;
	
	        if (position === 'top') {
	          fgStyle.bottom = -10;
	          fgStyle.borderTop = fgColorBorder;
	          bgStyle.bottom = -11;
	          bgStyle.borderTop = bgColorBorder;
	        } else {
	          fgStyle.top = -10;
	          fgStyle.borderBottom = fgColorBorder;
	          bgStyle.top = -11;
	          bgStyle.borderBottom = bgColorBorder;
	        }
	
	        if (arrow === 'right') {
	          fgStyle.left = null;
	          fgStyle.right = this.margin + 1 - fgSize;
	          fgStyle.marginLeft = 0;
	          bgStyle.left = null;
	          bgStyle.right = this.margin - fgSize;
	          bgStyle.marginLeft = 0;
	        }
	        if (arrow === 'left') {
	          fgStyle.left = this.margin + 1 - fgSize;
	          fgStyle.marginLeft = 0;
	          bgStyle.left = this.margin - fgSize;
	          bgStyle.marginLeft = 0;
	        }
	      }
	
	      var _props$style$arrowStyle = this.props.style.arrowStyle;
	      var color = _props$style$arrowStyle.color;
	      var borderColor = _props$style$arrowStyle.borderColor;
	
	      var propsArrowStyle = _objectWithoutProperties(_props$style$arrowStyle, ['color', 'borderColor']);
	
	      return {
	        fgStyle: this.mergeStyle(fgStyle, propsArrowStyle),
	        bgStyle: this.mergeStyle(bgStyle, propsArrowStyle)
	      };
	    }
	  }, {
	    key: 'mergeStyle',
	    value: function mergeStyle(style, theme) {
	      if (theme) {
	        var position = theme.position;
	        var _top2 = theme.top;
	        var left = theme.left;
	        var right = theme.right;
	        var bottom = theme.bottom;
	        var marginLeft = theme.marginLeft;
	        var marginRight = theme.marginRight;
	
	        var validTheme = _objectWithoutProperties(theme, ['position', 'top', 'left', 'right', 'bottom', 'marginLeft', 'marginRight']);
	
	        return (0, _objectAssign2['default'])(style, validTheme);
	      }
	
	      return style;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle(position, arrow) {
	      var _this = this;
	
	      var parent = this.props.parentEl;
	      var tooltipPosition = parent.getBoundingClientRect();
	      var scrollY = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
	      var scrollX = window.scrollX !== undefined ? window.scrollX : window.pageXOffset;
	      var _top = scrollY + tooltipPosition.top;
	      var _left = scrollX + tooltipPosition.left;
	      var style = {};
	
	      var stylesFromPosition = {
	        left: function left() {
	          style.top = _top + parent.offsetHeight / 2 - _this.state.height / 2;
	          style.left = _left - _this.state.width - _this.margin;
	        },
	        right: function right() {
	          style.top = _top + parent.offsetHeight / 2 - _this.state.height / 2;
	          style.left = _left + parent.offsetWidth + _this.margin;
	        },
	        top: function top() {
	          style.left = _left - _this.state.width / 2 + parent.offsetWidth / 2;
	          style.top = _top - _this.state.height - _this.margin;
	        },
	        bottom: function bottom() {
	          style.left = _left - _this.state.width / 2 + parent.offsetWidth / 2;
	          style.top = _top + parent.offsetHeight + _this.margin;
	        }
	      };
	
	      var stylesFromArrow = {
	        left: function left() {
	          style.left = _left + parent.offsetWidth / 2 - _this.margin;
	        },
	        right: function right() {
	          style.left = _left - _this.state.width + parent.offsetWidth / 2 + _this.margin;
	        },
	        top: function top() {
	          style.top = _top + parent.offsetHeight / 2 - _this.margin;
	        },
	        bottom: function bottom() {
	          style.top = _top + parent.offsetHeight / 2 - _this.state.height + _this.margin;
	        }
	      };
	
	      executeFunctionIfExist(stylesFromPosition, position);
	      executeFunctionIfExist(stylesFromArrow, arrow);
	
	      return style;
	    }
	  }, {
	    key: 'checkWindowPosition',
	    value: function checkWindowPosition(style, arrowStyle) {
	      if (this.props.position === 'top' || this.props.position === 'bottom') {
	        if (style.left < 0) {
	          var offset = style.left;
	          style.left = this.margin;
	          arrowStyle.fgStyle.marginLeft += offset;
	          arrowStyle.bgStyle.marginLeft += offset;
	        } else {
	          var rightOffset = style.left + this.state.width - window.innerWidth;
	          if (rightOffset > 0) {
	            var originalLeft = style.left;
	            style.left = window.innerWidth - this.state.width - this.margin;
	            arrowStyle.fgStyle.marginLeft += originalLeft - style.left;
	            arrowStyle.bgStyle.marginLeft += originalLeft - style.left;
	          }
	        }
	      }
	
	      return { style: style, arrowStyle: arrowStyle };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter() {
	      this.props.active && this.setState({ hover: true });
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave() {
	      this.setState({ hover: false });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateSize();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var _this2 = this;
	
	      this.setState({ transition: this.state.hover || this.props.active ? 'all' : 'opacity' }, function () {
	        _this2.updateSize();
	      });
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize() {
	      var self = _reactDom2['default'].findDOMNode(this);
	      this.setState({
	        width: self.offsetWidth,
	        height: self.offsetHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _checkWindowPosition = this.checkWindowPosition(this.getGlobalStyle(), this.getArrowStyle());
	
	      var style = _checkWindowPosition.style;
	      var arrowStyle = _checkWindowPosition.arrowStyle;
	
	      return _react2['default'].createElement(
	        'div',
	        { style: style, onMouseEnter: this.handleMouseEnter.bind(this), onMouseLeave: this.handleMouseLeave.bind(this) },
	        this.props.arrow ? _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('span', { style: arrowStyle.fgStyle }),
	          _react2['default'].createElement('span', { style: arrowStyle.bgStyle })
	        ) : null,
	        this.props.children
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      active: _propTypes2['default'].bool,
	      position: _propTypes2['default'].oneOf(['top', 'right', 'bottom', 'left']),
	      arrow: _propTypes2['default'].oneOf([null, 'center', 'top', 'right', 'bottom', 'left']),
	      style: _propTypes2['default'].object
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      active: false,
	      position: 'right',
	      arrow: null,
	      style: { style: {}, arrowStyle: {} }
	    },
	    enumerable: true
	  }]);
	
	  return Card;
	})(_react2['default'].Component);
	
	var portalNodes = {};
	
	var ToolTip = (function (_React$Component2) {
	  _inherits(ToolTip, _React$Component2);
	
	  function ToolTip() {
	    _classCallCheck(this, ToolTip);
	
	    _get(Object.getPrototypeOf(ToolTip.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ToolTip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.active) {
	        return;
	      }
	
	      this.renderPortal(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      if (!portalNodes[this.props.group] && !nextProps.active || !this.props.active && !nextProps.active) {
	        return;
	      }
	
	      var props = (0, _objectAssign2['default'])({}, nextProps);
	      var newProps = (0, _objectAssign2['default'])({}, nextProps);
	
	      if (portalNodes[this.props.group] && portalNodes[this.props.group].timeout) {
	        clearTimeout(portalNodes[this.props.group].timeout);
	      }
	
	      if (this.props.active && !props.active) {
	        newProps.active = true;
	        portalNodes[this.props.group].timeout = setTimeout(function () {
	          props.active = false;
	          _this3.renderPortal(props);
	        }, this.props.tooltipTimeout);
	      }
	
	      this.renderPortal(newProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (portalNodes[this.props.group]) {
	        _reactDom2['default'].unmountComponentAtNode(portalNodes[this.props.group].node);
	        clearTimeout(portalNodes[this.props.group].timeout);
	      }
	    }
	  }, {
	    key: 'createPortal',
	    value: function createPortal() {
	      portalNodes[this.props.group] = {
	        node: document.createElement('div'),
	        timeout: false
	      };
	      portalNodes[this.props.group].node.className = 'ToolTipPortal';
	      document.body.appendChild(portalNodes[this.props.group].node);
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!portalNodes[this.props.group]) {
	        this.createPortal();
	      }
	      var parent = props.parent;
	
	      var other = _objectWithoutProperties(props, ['parent']);
	
	      var parentEl = document.querySelector(parent);
	      (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, _react2['default'].createElement(Card, _extends({ parentEl: parentEl }, other)), portalNodes[this.props.group].node);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      return false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      parent: _propTypes2['default'].string.isRequired,
	      active: _propTypes2['default'].bool,
	      group: _propTypes2['default'].string,
	      tooltipTimeout: _propTypes2['default'].number
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      active: false,
	      group: 'main',
	      tooltipTimeout: 500
	    },
	    enumerable: true
	  }]);
	
	  return ToolTip;
	})(_react2['default'].Component);
	
	exports['default'] = ToolTip;
	
	var executeFunctionIfExist = function executeFunctionIfExist(object, key) {
	  if (Object.prototype.hasOwnProperty.call(object, key)) {
	    object[key]();
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.createMatchSelector = exports.getLocation = exports.ConnectedRouter = undefined;
	
	var _selectors = __webpack_require__(2358);
	
	Object.defineProperty(exports, 'getLocation', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.getLocation;
	  }
	});
	Object.defineProperty(exports, 'createMatchSelector', {
	  enumerable: true,
	  get: function get() {
	    return _selectors.createMatchSelector;
	  }
	});
	
	var _reducer = __webpack_require__(777);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(776);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _ConnectedRouter2 = __webpack_require__(2356);
	
	var _ConnectedRouter3 = _interopRequireDefault(_ConnectedRouter2);
	
	var _middleware = __webpack_require__(2357);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConnectedRouter = _ConnectedRouter3.default;
	exports.routerMiddleware = _middleware2.default;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(148);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(783);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var properties = __webpack_require__(2372);
	var PropTypes = __webpack_require__(2);
	
	module.exports = function(props, propName, componentName) {
	  var styles = props[propName];
	  if (!styles) {
	    return;
	  }
	
	  var failures = [];
	  Object.keys(styles).forEach(function(styleKey){
	    if (properties.indexOf(styleKey) === -1) {
	      failures.push(styleKey);
	    }
	  });
	  if (failures.length) {
	    throw new Error('Prop ' + propName + ' passed to ' + componentName + '. Has invalid keys ' + failures.join(', '));
	  }
	};
	
	module.exports.isRequired = function(props, propName, componentName) {
	  if (!props[propName]) {
	    throw new Error('Prop ' + propName + ' passed to ' + componentName + ' is required');
	  }
	  return module.exports(props, propName, componentName);
	};
	
	module.exports.supportingArrays = PropTypes.oneOfType([
	  PropTypes.arrayOf(module.exports),
	  module.exports
	]);


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Avatar = exports.avatarFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var factory = function factory(FontIcon) {
	  var Avatar = function Avatar(_ref) {
	    var alt = _ref.alt,
	        children = _ref.children,
	        className = _ref.className,
	        cover = _ref.cover,
	        icon = _ref.icon,
	        image = _ref.image,
	        theme = _ref.theme,
	        title = _ref.title,
	        other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'cover', 'icon', 'image', 'theme', 'title']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ 'data-react-toolbox': 'avatar', className: (0, _classnames2.default)(theme.avatar, className) }, other),
	      children,
	      cover && typeof image === 'string' && _react2.default.createElement('span', { 'aria-label': alt, className: theme.image, style: { backgroundImage: 'url(' + image + ')' } }),
	      !cover && (typeof image === 'string' ? _react2.default.createElement('img', { alt: alt, className: theme.image, src: image, title: title }) : image),
	      typeof icon === 'string' ? _react2.default.createElement(FontIcon, { className: theme.letter, value: icon, alt: alt }) : icon,
	      title ? _react2.default.createElement(
	        'span',
	        { className: theme.letter },
	        title[0]
	      ) : null
	    );
	  };
	
	  Avatar.propTypes = {
	    alt: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    cover: _propTypes2.default.bool,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    theme: _propTypes2.default.shape({
	      avatar: _propTypes2.default.string,
	      image: _propTypes2.default.string,
	      letter: _propTypes2.default.string
	    }),
	    title: _propTypes2.default.string
	  };
	
	  Avatar.defaultProps = {
	    alt: '',
	    cover: false
	  };
	
	  return Avatar;
	};
	
	var Avatar = factory(_FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.AVATAR)(Avatar);
	exports.avatarFactory = factory;
	exports.Avatar = Avatar;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Avatar = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Avatar = __webpack_require__(245);
	
	var _FontIcon = __webpack_require__(45);
	
	var _theme = __webpack_require__(1432);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Avatar = (0, _Avatar.avatarFactory)(_FontIcon.FontIcon);
	var ThemedAvatar = (0, _reactCssThemr.themr)(_identifiers.AVATAR, _theme2.default)(Avatar);
	
	exports.default = ThemedAvatar;
	exports.Avatar = ThemedAvatar;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = exports.buttonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var Button = function (_Component) {
	    _inherits(Button, _Component);
	
	    function Button() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Button);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.getShape = function () {
	        if (_this.props.raised) return 'raised';
	        if (_this.props.floating) return 'floating';
	        return 'flat';
	      }, _this.handleMouseUp = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Button, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            children = _props.children,
	            className = _props.className,
	            flat = _props.flat,
	            floating = _props.floating,
	            href = _props.href,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            label = _props.label,
	            mini = _props.mini,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            raised = _props.raised,
	            theme = _props.theme,
	            type = _props.type,
	            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'flat', 'floating', 'href', 'icon', 'inverse', 'label', 'mini', 'neutral', 'primary', 'raised', 'theme', 'type']);
	
	        var element = href ? 'a' : 'button';
	        var level = this.getLevel();
	        var shape = this.getShape();
	        var mouseEvents = {
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave
	        };
	
	        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, mouseEvents, {
	          href: href,
	          ref: function ref(node) {
	            _this2.buttonNode = node;
	          },
	          className: classes,
	          disabled: this.props.disabled,
	          type: !href ? type : null,
	          'data-react-toolbox': 'button'
	        });
	
	        var buttonElement = _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, label, children);
	
	        return others.onMouseEnter && this.props.disabled ? _react2.default.createElement(
	          'span',
	          mouseEvents,
	          buttonElement
	        ) : buttonElement;
	      }
	    }]);
	
	    return Button;
	  }(_react.Component);
	
	  Button.propTypes = {
	    accent: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    flat: _propTypes2.default.bool,
	    floating: _propTypes2.default.bool,
	    href: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    label: _propTypes2.default.string,
	    mini: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    raised: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  Button.defaultProps = {
	    accent: false,
	    className: '',
	    flat: false,
	    floating: false,
	    mini: false,
	    neutral: true,
	    primary: false,
	    raised: false,
	    type: 'button'
	  };
	
	
	  return ripple(Button);
	};
	
	var Button = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(Button);
	exports.buttonFactory = factory;
	exports.Button = Button;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconButton = exports.iconButtonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var IconButton = function (_Component) {
	    _inherits(IconButton, _Component);
	
	    function IconButton() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, IconButton);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.handleMouseUp = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(IconButton, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            children = _props.children,
	            className = _props.className,
	            href = _props.href,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            theme = _props.theme,
	            type = _props.type,
	            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'href', 'icon', 'inverse', 'neutral', 'primary', 'theme', 'type']);
	
	        var element = href ? 'a' : 'button';
	        var level = this.getLevel();
	        var classes = (0, _classnames3.default)([theme.toggle], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, {
	          href: href,
	          ref: function ref(node) {
	            _this2.buttonNode = node;
	          },
	          className: classes,
	          disabled: this.props.disabled,
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave,
	          type: !href ? type : null,
	          'data-react-toolbox': 'button'
	        });
	
	        var iconElement = typeof icon === 'string' ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : icon;
	
	        return _react2.default.createElement(element, props, icon && iconElement, children);
	      }
	    }]);
	
	    return IconButton;
	  }(_react.Component);
	
	  IconButton.propTypes = {
	    accent: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    href: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  IconButton.defaultProps = {
	    accent: false,
	    className: '',
	    neutral: true,
	    primary: false,
	    type: 'button'
	  };
	
	
	  return ripple(IconButton);
	};
	
	var IconButton = factory((0, _Ripple2.default)({ centered: true }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(IconButton);
	exports.iconButtonFactory = factory;
	exports.IconButton = IconButton;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkbox = exports.checkboxFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactStyleProptype = __webpack_require__(244);
	
	var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	var _Check = __webpack_require__(789);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Check) {
	  var Checkbox = function (_Component) {
	    _inherits(Checkbox, _Component);
	
	    function Checkbox() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Checkbox);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleToggle = function (event) {
	        if (event.pageX !== 0 && event.pageY !== 0) _this.blur();
	        if (!_this.props.disabled && _this.props.onChange) {
	          _this.props.onChange(!_this.props.checked, event);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Checkbox, [{
	      key: 'blur',
	      value: function blur() {
	        if (this.inputNode) {
	          this.inputNode.blur();
	        }
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        if (this.inputNode) {
	          this.inputNode.focus();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            checked = _props.checked,
	            children = _props.children,
	            disabled = _props.disabled,
	            label = _props.label,
	            name = _props.name,
	            style = _props.style,
	            onChange = _props.onChange,
	            onMouseEnter = _props.onMouseEnter,
	            onMouseLeave = _props.onMouseLeave,
	            theme = _props.theme,
	            others = _objectWithoutProperties(_props, ['checked', 'children', 'disabled', 'label', 'name', 'style', 'onChange', 'onMouseEnter', 'onMouseLeave', 'theme']);
	
	        var className = (0, _classnames3.default)(theme.field, _defineProperty({}, theme.disabled, this.props.disabled), this.props.className);
	
	        return _react2.default.createElement(
	          'label',
	          {
	            'data-react-toolbox': 'checkbox',
	            className: className,
	            onMouseEnter: onMouseEnter,
	            onMouseLeave: onMouseLeave
	          },
	          _react2.default.createElement('input', _extends({}, others, {
	            checked: checked,
	            className: theme.input,
	            disabled: disabled,
	            name: name,
	            onChange: function onChange() {},
	            onClick: this.handleToggle,
	            ref: function ref(node) {
	              _this2.inputNode = node;
	            },
	            type: 'checkbox'
	          })),
	          _react2.default.createElement(Check, {
	            checked: checked,
	            disabled: disabled,
	            rippleClassName: theme.ripple,
	            style: style,
	            theme: theme
	          }),
	          label ? _react2.default.createElement(
	            'span',
	            { 'data-react-toolbox': 'label', className: theme.text },
	            label
	          ) : null,
	          children
	        );
	      }
	    }]);
	
	    return Checkbox;
	  }(_react.Component);
	
	  Checkbox.propTypes = {
	    checked: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    name: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    style: _reactStyleProptype2.default,
	    theme: _propTypes2.default.shape({
	      disabled: _propTypes2.default.string,
	      field: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      ripple: _propTypes2.default.string
	    })
	  };
	  Checkbox.defaultProps = {
	    checked: false,
	    className: '',
	    disabled: false
	  };
	
	
	  return Checkbox;
	};
	
	var Check = (0, _Check2.default)((0, _Ripple2.default)({ centered: true, spread: 2.6 }));
	var Checkbox = factory(Check);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.CHECKBOX)(Checkbox);
	exports.checkboxFactory = factory;
	exports.Checkbox = Checkbox;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactStyleProptype = __webpack_require__(244);
	
	var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this._overlayTarget && nextProps.container !== this.props.container) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._portalContainerNode = getContainer(nextProps.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  }, {
	    key: 'getMountNode',
	    value: function getMountNode() {
	      return this._overlayTarget;
	    }
	  }, {
	    key: 'getOverlayDOMNode',
	    value: function getOverlayDOMNode() {
	      if (!this.isMounted()) {
	        // eslint-disable-line
	        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	      }
	
	      if (this._overlayInstance) {
	        if (this._overlayInstance.getWrappedDOMNode) {
	          return this._overlayInstance.getWrappedDOMNode();
	        }
	        return _reactDom2.default.findDOMNode(this._overlayInstance);
	      }
	
	      return null;
	    }
	  }, {
	    key: '_getOverlay',
	    value: function _getOverlay() {
	      if (!this.props.children) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className, style: this.props.style },
	        this.props.children
	      );
	    }
	  }, {
	    key: '_renderOverlay',
	    value: function _renderOverlay() {
	      var overlay = this._getOverlay();
	      if (overlay !== null) {
	        this._mountOverlayTarget();
	        this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	      } else {
	        this._unrenderOverlay();
	        this._unmountOverlayTarget();
	      }
	    }
	  }, {
	    key: '_unrenderOverlay',
	    value: function _unrenderOverlay() {
	      if (this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	        this._overlayInstance = null;
	      }
	    }
	  }, {
	    key: '_mountOverlayTarget',
	    value: function _mountOverlayTarget() {
	      if (!this._overlayTarget) {
	        this._overlayTarget = document.createElement('div');
	        this._portalContainerNode = getContainer(this.props.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: '_unmountOverlayTarget',
	    value: function _unmountOverlayTarget() {
	      if (this._overlayTarget) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._overlayTarget = null;
	      }
	      this._portalContainerNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  container: _propTypes2.default.node,
	  style: _reactStyleProptype2.default
	};
	Portal.defaultProps = {
	  className: ''
	};
	
	
	function getContainer(container) {
	  var _container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(_container) || document.body;
	}
	
	exports.default = Portal;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimePicker = exports.Tooltip = exports.Switch = exports.Snackbar = exports.Slider = exports.Ripple = exports.ProgressBar = exports.Navigation = exports.Link = exports.Input = exports.FontIcon = exports.Dropdown = exports.Drawer = exports.Dialog = exports.DatePicker = exports.Checkbox = exports.Chip = exports.Avatar = exports.Autocomplete = exports.AppBar = exports.overrideComponentTypeChecker = undefined;
	
	var _isComponentOfType = __webpack_require__(181);
	
	Object.defineProperty(exports, 'overrideComponentTypeChecker', {
	  enumerable: true,
	  get: function get() {
	    return _isComponentOfType.overrideComponentTypeChecker;
	  }
	});
	
	var _app_bar = __webpack_require__(788);
	
	Object.defineProperty(exports, 'AppBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_app_bar).default;
	  }
	});
	
	var _autocomplete = __webpack_require__(70);
	
	Object.defineProperty(exports, 'Autocomplete', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_autocomplete).default;
	  }
	});
	
	var _avatar = __webpack_require__(246);
	
	Object.defineProperty(exports, 'Avatar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_avatar).default;
	  }
	});
	
	var _button = __webpack_require__(31);
	
	Object.keys(_button).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _button[key];
	    }
	  });
	});
	
	var _card = __webpack_require__(2380);
	
	Object.keys(_card).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _card[key];
	    }
	  });
	});
	
	var _chip = __webpack_require__(791);
	
	Object.defineProperty(exports, 'Chip', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_chip).default;
	  }
	});
	
	var _checkbox = __webpack_require__(369);
	
	Object.defineProperty(exports, 'Checkbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_checkbox).default;
	  }
	});
	
	var _date_picker = __webpack_require__(2384);
	
	Object.defineProperty(exports, 'DatePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_date_picker).default;
	  }
	});
	
	var _dialog = __webpack_require__(371);
	
	Object.defineProperty(exports, 'Dialog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dialog).default;
	  }
	});
	
	var _drawer = __webpack_require__(373);
	
	Object.defineProperty(exports, 'Drawer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_drawer).default;
	  }
	});
	
	var _dropdown = __webpack_require__(2386);
	
	Object.defineProperty(exports, 'Dropdown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_dropdown).default;
	  }
	});
	
	var _font_icon = __webpack_require__(794);
	
	Object.defineProperty(exports, 'FontIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_font_icon).default;
	  }
	});
	
	var _input = __webpack_require__(33);
	
	Object.defineProperty(exports, 'Input', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_input).default;
	  }
	});
	
	var _layout = __webpack_require__(2389);
	
	Object.keys(_layout).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _layout[key];
	    }
	  });
	});
	
	var _link = __webpack_require__(798);
	
	Object.defineProperty(exports, 'Link', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_link).default;
	  }
	});
	
	var _list = __webpack_require__(2394);
	
	Object.keys(_list).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _list[key];
	    }
	  });
	});
	
	var _menu = __webpack_require__(806);
	
	Object.keys(_menu).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _menu[key];
	    }
	  });
	});
	
	var _navigation = __webpack_require__(2398);
	
	Object.defineProperty(exports, 'Navigation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_navigation).default;
	  }
	});
	
	var _progress_bar = __webpack_require__(253);
	
	Object.defineProperty(exports, 'ProgressBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_progress_bar).default;
	  }
	});
	
	var _radio = __webpack_require__(104);
	
	Object.keys(_radio).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _radio[key];
	    }
	  });
	});
	
	var _slider = __webpack_require__(2401);
	
	Object.defineProperty(exports, 'Slider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_slider).default;
	  }
	});
	
	var _snackbar = __webpack_require__(2403);
	
	Object.defineProperty(exports, 'Snackbar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_snackbar).default;
	  }
	});
	
	var _switch = __webpack_require__(812);
	
	Object.defineProperty(exports, 'Switch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_switch).default;
	  }
	});
	
	var _table = __webpack_require__(2406);
	
	Object.keys(_table).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _table[key];
	    }
	  });
	});
	
	var _tabs = __webpack_require__(254);
	
	Object.keys(_tabs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _tabs[key];
	    }
	  });
	});
	
	var _time_picker = __webpack_require__(2412);
	
	Object.defineProperty(exports, 'TimePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_time_picker).default;
	  }
	});
	
	__webpack_require__(2419);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _tooltip = __webpack_require__(2414);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Ripple = _ripple2.default;
	exports.Tooltip = _tooltip2.default;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemContent = exports.listItemContentFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ListItemText = __webpack_require__(803);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var types = ['auto', 'normal', 'large'];
	
	var factory = function factory(ListItemText) {
	  var ListItemContent = function (_Component) {
	    _inherits(ListItemContent, _Component);
	
	    function ListItemContent() {
	      _classCallCheck(this, ListItemContent);
	
	      return _possibleConstructorReturn(this, (ListItemContent.__proto__ || Object.getPrototypeOf(ListItemContent)).apply(this, arguments));
	    }
	
	    _createClass(ListItemContent, [{
	      key: 'getType',
	      value: function getType() {
	        var _props = this.props,
	            type = _props.type,
	            children = _props.children,
	            caption = _props.caption,
	            legend = _props.legend;
	
	
	        var count = _react2.default.Children.count(children);
	        [caption, legend].forEach(function (s) {
	          count += s ? 1 : 0;
	        });
	        var typeIndex = Math.min(count, types.length);
	
	        return type || types[typeIndex];
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            children = _props2.children,
	            caption = _props2.caption,
	            legend = _props2.legend,
	            theme = _props2.theme;
	
	        var contentType = this.getType();
	        var className = (0, _classnames3.default)(theme.itemContentRoot, _defineProperty({}, theme[contentType], theme[contentType]));
	
	        return _react2.default.createElement(
	          'span',
	          { className: className },
	          caption && _react2.default.createElement(
	            ListItemText,
	            { theme: theme, primary: true },
	            caption
	          ),
	          legend && _react2.default.createElement(
	            ListItemText,
	            { theme: theme },
	            legend
	          ),
	          children
	        );
	      }
	    }]);
	
	    return ListItemContent;
	  }(_react.Component);
	
	  ListItemContent.propTypes = {
	    caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    children: _propTypes2.default.node,
	    legend: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    theme: _propTypes2.default.shape({
	      auto: _propTypes2.default.string,
	      itemContentRoot: _propTypes2.default.string,
	      large: _propTypes2.default.string,
	      normal: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.oneOf(types)
	  };
	
	
	  return ListItemContent;
	};
	
	var ListItemContent = factory(_ListItemText2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemContent);
	exports.listItemContentFactory = factory;
	exports.ListItemContent = ListItemContent;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProgressBar = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ProgressBar = __webpack_require__(808);
	
	var _theme = __webpack_require__(1448);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedProgressBar = (0, _reactCssThemr.themr)(_identifiers.PROGRESS_BAR, _theme2.default)(_ProgressBar.ProgressBar);
	
	exports.default = ThemedProgressBar;
	exports.ProgressBar = ThemedProgressBar;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tabs = exports.Tab = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Tabs = __webpack_require__(2407);
	
	var _TabContent = __webpack_require__(816);
	
	var _Tab = __webpack_require__(815);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _FontIcon = __webpack_require__(45);
	
	var _theme = __webpack_require__(1455);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyTheme = function applyTheme(Component) {
	  return (0, _reactCssThemr.themr)(_identifiers.TABS, _theme2.default)(Component);
	};
	var ThemedTabContent = applyTheme(_TabContent.TabContent);
	var ThemedTab = applyTheme((0, _Tab.tabFactory)((0, _ripple2.default)({ centered: false }), _FontIcon.FontIcon));
	var ThemedTabs = applyTheme((0, _Tabs.tabsFactory)(ThemedTab, ThemedTabContent, _FontIcon.FontIcon));
	
	exports.Tab = ThemedTab;
	exports.Tabs = ThemedTabs;

/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var WEBKIT = 'Webkit';
	var MICROSOFT = 'Ms';
	
	var properties = {
	  transform: [WEBKIT, MICROSOFT]
	};
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.substr(1);
	}
	
	function getPrefixes(property, value) {
	  return properties[property].reduce(function (acc, item) {
	    acc['' + item + capitalize(property)] = value; // eslint-disable-line no-param-reassign
	    return acc;
	  }, {});
	}
	
	function addPrefixesTo(style, property, value) {
	  var vendor = getPrefixes(property, value);
	  for (var prefix in vendor) {
	    // eslint-disable-line no-restricted-syntax
	    if ({}.hasOwnProperty.call(vendor, prefix)) {
	      style[prefix] = vendor[prefix]; // eslint-disable-line no-param-reassign
	    }
	  }
	
	  return style;
	}
	
	function prefixer(style) {
	  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var _style = defaultValue;
	  for (var property in style) {
	    // eslint-disable-line no-restricted-syntax
	    if ({}.hasOwnProperty.call(style, property)) {
	      _style[property] = style[property];
	      if (properties[property]) {
	        addPrefixesTo(_style, property, style[property]);
	      }
	    }
	  }
	
	  return _style;
	}
	
	exports.default = prefixer;

/***/ },
/* 256 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 257 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(121);
	var call = __webpack_require__(830);
	var isArrayIter = __webpack_require__(828);
	var anObject = __webpack_require__(120);
	var toLength = __webpack_require__(185);
	var getIterFn = __webpack_require__(841);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 259 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 260 */
[2565, 836, 378],
/* 261 */
[2567, 92, 122, 46],
/* 262 */
[2569, 64, 71, 259],
/* 263 */
[2574, 257],
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(1412);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(2468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(855);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2490);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2489);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2488);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(854);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(856);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 266 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '__THEMING__';

/***/ },
/* 267 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 268 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(188);
	
	var AWS = __webpack_require__(15);
	if (typeof window !== 'undefined') window.AWS = AWS;
	if (true) module.exports = AWS;
	if (typeof self !== 'undefined') self.AWS = AWS;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	
	function JsonBuilder() { }
	
	JsonBuilder.prototype.build = function(value, shape) {
	  return JSON.stringify(translate(value, shape));
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined || value === null) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  var struct = {};
	  util.each(structure, function(name, value) {
	    var memberShape = shape.members[name];
	    if (memberShape) {
	      if (memberShape.location !== 'body') return;
	      var locationName = memberShape.isLocationName ? memberShape.name : name;
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[locationName] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result !== undefined) out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result !== undefined) out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toWireFormat(value);
	}
	
	module.exports = JsonBuilder;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	
	function JsonParser() { }
	
	JsonParser.prototype.parse = function(value, shape) {
	  return translate(JSON.parse(value), shape);
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  if (structure == null) return undefined;
	
	  var struct = {};
	  var shapeMembers = shape.members;
	  util.each(shapeMembers, function(name, memberShape) {
	    var locationName = memberShape.isLocationName ? memberShape.name : name;
	    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
	      var value = structure[locationName];
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[name] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  if (list == null) return undefined;
	
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result === undefined) out.push(null);
	    else out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  if (map == null) return undefined;
	
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result === undefined) out[key] = null;
	    else out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toType(value);
	}
	
	module.exports = JsonParser;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	var JsonBuilder = __webpack_require__(270);
	var JsonParser = __webpack_require__(271);
	
	function buildRequest(req) {
	  var httpRequest = req.httpRequest;
	  var api = req.service.api;
	  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
	  var version = api.jsonVersion || '1.0';
	  var input = api.operations[req.operation].input;
	  var builder = new JsonBuilder();
	
	  if (version === 1) version = '1.0';
	  httpRequest.body = builder.build(req.params || {}, input);
	  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
	  httpRequest.headers['X-Amz-Target'] = target;
	}
	
	function extractError(resp) {
	  var error = {};
	  var httpResponse = resp.httpResponse;
	
	  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
	  if (typeof error.code === 'string') {
	    error.code = error.code.split(':')[0];
	  }
	
	  if (httpResponse.body.length > 0) {
	    try {
	      var e = JSON.parse(httpResponse.body.toString());
	      if (e.__type || e.code) {
	        error.code = (e.__type || e.code).split('#').pop();
	      }
	      if (error.code === 'RequestEntityTooLarge') {
	        error.message = 'Request body must be less than 1 MB';
	      } else {
	        error.message = (e.message || e.Message || null);
	      }
	    } catch (e) {
	      error.statusCode = httpResponse.statusCode;
	      error.message = httpResponse.statusMessage;
	    }
	  } else {
	    error.statusCode = httpResponse.statusCode;
	    error.message = httpResponse.statusCode.toString();
	  }
	
	  resp.error = util.error(new Error(), error);
	}
	
	function extractData(resp) {
	  var body = resp.httpResponse.body.toString() || '{}';
	  if (resp.request.service.config.convertResponseTypes === false) {
	    resp.data = JSON.parse(body);
	  } else {
	    var operation = resp.request.service.api.operations[resp.request.operation];
	    var shape = operation.output || {};
	    var parser = new JsonParser();
	    resp.data = parser.parse(body, shape);
	  }
	}
	
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(100).Buffer;
	var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	
	function JsonBuilder() { }
	
	JsonBuilder.prototype.build = function(value, shape) {
	  return JSON.stringify(translate(value, shape));
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined || value === null) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  var struct = {};
	  util.each(structure, function(name, value) {
	    var memberShape = shape.members[name];
	    if (memberShape) {
	      if (memberShape.location !== 'body') return;
	      var locationName = memberShape.isLocationName ? memberShape.name : name;
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[locationName] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result !== undefined) out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result !== undefined) out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toWireFormat(value);
	}
	
	/**
	 * @api private
	 */
	module.exports = JsonBuilder;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	
	function JsonParser() { }
	
	JsonParser.prototype.parse = function(value, shape) {
	  return translate(JSON.parse(value), shape);
	};
	
	function translate(value, shape) {
	  if (!shape || value === undefined) return undefined;
	
	  switch (shape.type) {
	    case 'structure': return translateStructure(value, shape);
	    case 'map': return translateMap(value, shape);
	    case 'list': return translateList(value, shape);
	    default: return translateScalar(value, shape);
	  }
	}
	
	function translateStructure(structure, shape) {
	  if (structure == null) return undefined;
	
	  var struct = {};
	  var shapeMembers = shape.members;
	  util.each(shapeMembers, function(name, memberShape) {
	    var locationName = memberShape.isLocationName ? memberShape.name : name;
	    if (Object.prototype.hasOwnProperty.call(structure, locationName)) {
	      var value = structure[locationName];
	      var result = translate(value, memberShape);
	      if (result !== undefined) struct[name] = result;
	    }
	  });
	  return struct;
	}
	
	function translateList(list, shape) {
	  if (list == null) return undefined;
	
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = translate(value, shape.member);
	    if (result === undefined) out.push(null);
	    else out.push(result);
	  });
	  return out;
	}
	
	function translateMap(map, shape) {
	  if (map == null) return undefined;
	
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = translate(value, shape.value);
	    if (result === undefined) out[key] = null;
	    else out[key] = result;
	  });
	  return out;
	}
	
	function translateScalar(value, shape) {
	  return shape.toType(value);
	}
	
	/**
	 * @api private
	 */
	module.exports = JsonParser;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var util =  __webpack_require__(34);
	var AWS = __webpack_require__(4);
	
	/**
	 * Prepend prefix defined by API model to endpoint that's already
	 * constructed. This feature does not apply to operations using
	 * endpoint discovery and can be disabled.
	 * @api private
	 */
	function populateHostPrefix(request)  {
	  var enabled = request.service.config.hostPrefixEnabled;
	  if (!enabled) return request;
	  var operationModel = request.service.api.operations[request.operation];
	  //don't marshal host prefix when operation has endpoint discovery traits
	  if (hasEndpointDiscover(request)) return request;
	  if (operationModel.endpoint && operationModel.endpoint.hostPrefix) {
	    var hostPrefixNotation = operationModel.endpoint.hostPrefix;
	    var hostPrefix = expandHostPrefix(hostPrefixNotation, request.params, operationModel.input);
	    prependEndpointPrefix(request.httpRequest.endpoint, hostPrefix);
	    validateHostname(request.httpRequest.endpoint.hostname);
	  }
	  return request;
	}
	
	/**
	 * @api private
	 */
	function hasEndpointDiscover(request) {
	  var api = request.service.api;
	  var operationModel = api.operations[request.operation];
	  var isEndpointOperation = api.endpointOperation && (api.endpointOperation === util.string.lowerFirst(operationModel.name));
	  return (operationModel.endpointDiscoveryRequired !== 'NULL' || isEndpointOperation === true);
	}
	
	/**
	 * @api private
	 */
	function expandHostPrefix(hostPrefixNotation, params, shape) {
	  util.each(shape.members, function(name, member) {
	    if (member.hostLabel === true) {
	      if (typeof params[name] !== 'string' || params[name] === '') {
	        throw util.error(new Error(), {
	          message: 'Parameter ' + name + ' should be a non-empty string.',
	          code: 'InvalidParameter'
	        });
	      }
	      var regex = new RegExp('\\{' + name + '\\}', 'g');
	      hostPrefixNotation = hostPrefixNotation.replace(regex, params[name]);
	    }
	  });
	  return hostPrefixNotation;
	}
	
	/**
	 * @api private
	 */
	function prependEndpointPrefix(endpoint, prefix) {
	  if (endpoint.host) {
	    endpoint.host = prefix + endpoint.host;
	  }
	  if (endpoint.hostname) {
	    endpoint.hostname = prefix + endpoint.hostname;
	  }
	}
	
	/**
	 * @api private
	 */
	function validateHostname(hostname) {
	  var labels = hostname.split('.');
	  //Reference: https://tools.ietf.org/html/rfc1123#section-2
	  var hostPattern = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
	  util.arrayEach(labels, function(label) {
	    if (!label.length || label.length < 1 || label.length > 63) {
	      throw util.error(new Error(), {
	        code: 'ValidationError',
	        message: 'Hostname label length should be between 1 to 63 characters, inclusive.'
	      });
	    }
	    if (!hostPattern.test(label)) {
	      throw AWS.util.error(new Error(),
	        {code: 'ValidationError', message: label + ' is not hostname compatible.'});
	    }
	  });
	}
	
	module.exports = {
	  populateHostPrefix: populateHostPrefix
	};


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	var JsonBuilder = __webpack_require__(274);
	var JsonParser = __webpack_require__(275);
	var populateHostPrefix = __webpack_require__(276).populateHostPrefix;
	
	function buildRequest(req) {
	  var httpRequest = req.httpRequest;
	  var api = req.service.api;
	  var target = api.targetPrefix + '.' + api.operations[req.operation].name;
	  var version = api.jsonVersion || '1.0';
	  var input = api.operations[req.operation].input;
	  var builder = new JsonBuilder();
	
	  if (version === 1) version = '1.0';
	  httpRequest.body = builder.build(req.params || {}, input);
	  httpRequest.headers['Content-Type'] = 'application/x-amz-json-' + version;
	  httpRequest.headers['X-Amz-Target'] = target;
	
	  populateHostPrefix(req);
	}
	
	function extractError(resp) {
	  var error = {};
	  var httpResponse = resp.httpResponse;
	
	  error.code = httpResponse.headers['x-amzn-errortype'] || 'UnknownError';
	  if (typeof error.code === 'string') {
	    error.code = error.code.split(':')[0];
	  }
	
	  if (httpResponse.body.length > 0) {
	    try {
	      var e = JSON.parse(httpResponse.body.toString());
	      if (e.__type || e.code) {
	        error.code = (e.__type || e.code).split('#').pop();
	      }
	      if (error.code === 'RequestEntityTooLarge') {
	        error.message = 'Request body must be less than 1 MB';
	      } else {
	        error.message = (e.message || e.Message || null);
	      }
	    } catch (e) {
	      error.statusCode = httpResponse.statusCode;
	      error.message = httpResponse.statusMessage;
	    }
	  } else {
	    error.statusCode = httpResponse.statusCode;
	    error.message = httpResponse.statusCode.toString();
	  }
	
	  resp.error = util.error(new Error(), error);
	}
	
	function extractData(resp) {
	  var body = resp.httpResponse.body.toString() || '{}';
	  if (resp.request.service.config.convertResponseTypes === false) {
	    resp.data = JSON.parse(body);
	  } else {
	    var operation = resp.request.service.api.operations[resp.request.operation];
	    var shape = operation.output || {};
	    var parser = new JsonParser();
	    resp.data = parser.parse(body, shape);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AtheleteDesc = __webpack_require__(1088);
	
	var _AtheleteDesc2 = _interopRequireDefault(_AtheleteDesc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AtheleteDesc2.default;

/***/ },
/* 279 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'COACH_PROFILE_REQUESTED';
	var FAILED = exports.FAILED = 'COACH_PROFILE_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'COACH_PROFILE_SUCCESSFUL';
	var PROFILE_REQUESTED = exports.PROFILE_REQUESTED = 'GET_COACH_PROFILE_REQUESTED';
	var PROFILE_SUCCESSFUL = exports.PROFILE_SUCCESSFUL = 'GET_COACH_PROFILE_SUCCESFUL';
	var PROFILE_FAILED = exports.PROFILE_FAILED = 'GET_COACH_PROFILE_FAILED';
	var SCHOOL_SEARCH = exports.SCHOOL_SEARCH = 'SCHOOL_SEARCH';
	var SESSION_VALID = exports.SESSION_VALID = 'SESSION_VALID';
	var SESSION_LOGOUT = exports.SESSION_LOGOUT = 'SESSION_LOGOUT';
	var GET_COACH_FROM_DATABASE_REQUESTED = exports.GET_COACH_FROM_DATABASE_REQUESTED = 'GET_COACH_FROM_DATABASE_REQUESTED';
	var GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTER = exports.GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTER = 'GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTER';
	var GET_COACH_FROM_DATABASE_FAILED = exports.GET_COACH_FROM_DATABASE_FAILED = 'GET_COACH_FROM_DATABASE_FAILED';

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _CustomButton = __webpack_require__(1482);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to validate and set default props  coming to this component
	var CustomButton = function CustomButton(props) {
	  var onClickHandler = function onClickHandler() {
	    props.onClick();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: props.label === 'NEXT' ? _CustomButton2.default.customButtonContainerForCoach : (0, _classnames2.default)(_CustomButton2.default.customButtonContainer, props.style) },
	    _react2.default.createElement(_button2.default, { type: 'submit', label: props.label, className: _CustomButton2.default.customButton, onClick: onClickHandler })
	  );
	};
	
	CustomButton.propTypes = {
	  onClick: _propTypes2.default.func,
	  label: _propTypes2.default.string,
	  style: _propTypes2.default.string
	};
	
	CustomButton.defaultProps = {
	  onClick: function onClick() {},
	  label: 'SUBMIT',
	  style: ''
	};
	
	exports.default = CustomButton;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveSAProfile = saveSAProfile;
	exports.getSAProfile = getSAProfile;
	exports.searchSchools = searchSchools;
	
	var _immutable = __webpack_require__(11);
	
	var _saProfile = __webpack_require__(94);
	
	var _session = __webpack_require__(73);
	
	var _actionTypes = __webpack_require__(290);
	
	var _actionTypes2 = __webpack_require__(455);
	
	// use of immutablejs for various js operations to simplify our work
	
	
	function saveSAProfile(profile, id, cb) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    dispatch({
	      type: _actionTypes.UPDATE_SA_PROFILE_REQUESTED
	    });
	    (0, _saProfile.saveProfile)(profile, id).then(function (result) {
	      var temp = [{ Name: 'profile', Value: result.id }];
	      (0, _session.updateUserAttributes)(temp, function (err) {
	        if (!err) {
	          (0, _session.isSessionValid)(function (thisError, data) {
	            if (thisError) {
	              dispatch({
	                type: _actionTypes2.SESSION_LOGOUT
	              });
	            } else {
	              var token = data.session.idToken.jwtToken;
	
	              dispatch({
	                type: _actionTypes2.SESSION_VALID,
	                session: (0, _immutable.fromJS)(data.session),
	                user: (0, _immutable.fromJS)(data.user),
	                attributes: data.attributes,
	                token: token
	              });
	              dispatch({
	                type: _actionTypes2.SUCCESSFUL,
	                result: (0, _immutable.fromJS)(result)
	              });
	              dispatch({
	                type: _actionTypes.UPDATE_SA_PROFILE_SUCCESSFUL,
	                result: (0, _immutable.fromJS)(result)
	              });
	              cb();
	            }
	          });
	        }
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	      dispatch({
	        type: _actionTypes.UPDATE_SA_PROFILE_FAILED,
	        error: err
	      });
	      cb(err);
	    });
	  };
	}
	
	function getSAProfile(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.EDIT_REQUESTED
	    });
	    dispatch({
	      type: _actionTypes.SETTINGS_SA_PROFILE_REQUESTED
	    });
	    (0, _saProfile.getProfile)(id).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.EDIT_SUCCESSFUL,
	          profile: (0, _immutable.fromJS)(data)
	        });
	        dispatch({
	          type: _actionTypes.SETTINGS_SA_PROFILE_SUCCESSFUL,
	          profile: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	      dispatch({
	        type: _actionTypes.SETTINGS_SA_PROFILE_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function searchSchools(query) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    (0, _saProfile.searchSchoolsByName)({ school: query }).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.SCHOOL_SEARCH,
	          schools: data
	        });
	        dispatch({
	          type: _actionTypes.SETTINGS_SEARCH_SCHOOLS,
	          schools: data
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProfileData = __webpack_require__(1187);
	
	var _ProfileData2 = _interopRequireDefault(_ProfileData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProfileData2.default;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Header = __webpack_require__(1188);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Header2.default;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchUser = __webpack_require__(1207);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchUser2.default;

/***/ },
/* 285 */
[2531, 38],
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StaticHeader = __webpack_require__(1235);
	
	var _StaticHeader2 = _interopRequireDefault(_StaticHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticHeader2.default;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllRequests = getAllRequests;
	exports.updateConversation = updateConversation;
	exports.getCoachProfile = getCoachProfile;
	exports.getDivisionStudents = getDivisionStudents;
	exports.getFilteredDivisionStudents = getFilteredDivisionStudents;
	
	var _immutable = __webpack_require__(11);
	
	var _localStorage = __webpack_require__(56);
	
	var _dashboard = __webpack_require__(441);
	
	var _coachProfile = __webpack_require__(192);
	
	var _actionTypes = __webpack_require__(279);
	
	var _actionTypes2 = __webpack_require__(289);
	
	var _actionTypes3 = __webpack_require__(200);
	
	var _actionTypes4 = __webpack_require__(475);
	
	function getAllRequests(id) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes4.REQUEST_REQUESTED
	    });
	    (0, _dashboard.getRequestsCoach)(id).then(function (result) {
	      dispatch({
	        type: _actionTypes4.REQUEST_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes4.REQUEST_FAILED,
	        error: err
	      });
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work
	function updateConversation(convo, place) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes3.PUBLIC_ADD_CONVERSATION_REQUESTED
	    });
	    dispatch({
	      type: _actionTypes4.ADD_CONVERSATION_REQUESTED
	    });
	    (0, _dashboard.addConversation)(convo, place).then(function (result) {
	      dispatch({
	        type: _actionTypes3.PUBLIC_ADD_CONVERSATION_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	      dispatch({
	        type: _actionTypes4.ADD_CONVERSATION_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	      dispatch({
	        type: _actionTypes2.ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes3.PUBLIC_ADD_CONVERSATION_FAILED,
	        error: err
	      });
	      dispatch({
	        type: _actionTypes4.ADD_CONVERSATION_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getCoachProfile(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes4.COACH_PROFILE_REQUESTED
	    });
	    (0, _coachProfile.getCoach)(id).then(function (result) {
	      if (result.profile_image !== undefined) {
	        (0, _localStorage.setItem)('profile_image', result.profile_image);
	      } else {
	        (0, _localStorage.setItem)('profile_image', '');
	      }
	      dispatch({
	        type: _actionTypes4.COACH_PROFILE_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	      dispatch({
	        type: _actionTypes.SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes4.COACH_PROFILE_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getDivisionStudents() {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes4.DIVISION_STUDENT_REQUESTED
	    });
	    (0, _dashboard.getdivisionstudents)().then(function (result) {
	      dispatch({
	        type: _actionTypes4.DIVISION_STUDENT_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes4.DIVISION_STUDENT_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getFilteredDivisionStudents(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes4.FILTER_DIVISION_STUDENT_REQUESTED
	    });
	    (0, _dashboard.getfilterbasedstudents)(payload).then(function (result) {
	      dispatch({
	        type: _actionTypes4.FILTER_DIVISION_STUDENT_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes4.FILTER_DIVISION_STUDENT_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'SA_PROFILE_VIEW_REQUESTED';
	var FAILED = exports.FAILED = 'SA_PROFILE_VIEW_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'SA_PROFILE_VIEW_SUCCESSFUL';
	var ADD_VIDEO_REQUESTED = exports.ADD_VIDEO_REQUESTED = 'ADD_VIDEO_REQUESTED';
	var ADD_VIDEO_FAILED = exports.ADD_VIDEO_FAILED = 'ADD_VIDEO_FAILED';
	var ADD_VIDEO_SUCCESSFUL = exports.ADD_VIDEO_SUCCESSFUL = 'ADD_VIDEO_SUCCESSFUL';
	var SAVE_VIDEO_DETAILS = exports.SAVE_VIDEO_DETAILS = 'SAVE_VIDEO_DETAILS';
	var SAVE_USER_IMAGE = exports.SAVE_USER_IMAGE = 'SAVE_USER_IMAGE';
	var SET_CURRENT_VIDEO = exports.SET_CURRENT_VIDEO = 'SET_CURRENT_VIDEO';
	var GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE = exports.GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE = 'GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE';
	var GET_TOTAL_COUNTS_FAILED_PROFILE = exports.GET_TOTAL_COUNTS_FAILED_PROFILE = 'GET_TOTAL_COUNTS_FAILED_PROFILE';
	var GET_TOTAL_COUNTS_REQUESTED_PROFILE = exports.GET_TOTAL_COUNTS_REQUESTED_PROFILE = 'GET_TOTAL_COUNTS_REQUESTED_PROFILE';
	var REMOVE_VIDEO_REQUESTED = exports.REMOVE_VIDEO_REQUESTED = 'REMOVE_VIDEO_REQUESTED';
	var REMOVE_VIDEO_FAILED = exports.REMOVE_VIDEO_FAILED = 'REMOVE_VIDEO_FAILED';
	var REMOVE_VIDEO_SUCCESSFUL = exports.REMOVE_VIDEO_SUCCESSFUL = 'REMOVE_VIDEO_SUCCESSFUL';
	var INCREASE_CONTACT_COUNT = exports.INCREASE_CONTACT_COUNT = 'INCREASE_CONTACT_COUNT';

/***/ },
/* 289 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'SA_PROFILE_VIEW_REQUESTED';
	var FAILED = exports.FAILED = 'SA_PROFILE_VIEW_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'SA_PROFILE_VIEW_SUCCESSFUL';
	var PUBLIC_ATHLETE_REQUEST = exports.PUBLIC_ATHLETE_REQUEST = 'PUBLIC_ATHLETE_REQUEST';
	var CURRENT_VIDEO_URL = exports.CURRENT_VIDEO_URL = 'CURRENT_VIDEO_URL';
	var PUBLIC_ADD_CONVERSATION_REQUESTED = exports.PUBLIC_ADD_CONVERSATION_REQUESTED = 'PUBLIC_ADD_CONVERSATION_REQUESTED';
	var PUBLIC_ADD_CONVERSATION_FAILED = exports.PUBLIC_ADD_CONVERSATION_FAILED = 'PUBLIC_ADD_CONVERSATION_REQUESTED';
	var ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL = exports.ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL = 'ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL';

/***/ },
/* 290 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'RESET_PASSWORD_REQUESTED';
	var FAILED = exports.FAILED = 'RESET_PASSWORD_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'RESET_PASSWORD_SUCCESSFUL';
	var SETTINGS_SA_PROFILE_REQUESTED = exports.SETTINGS_SA_PROFILE_REQUESTED = 'SETTINGS_SA_PROFILE_REQUESTED';
	var SETTINGS_SA_PROFILE_FAILED = exports.SETTINGS_SA_PROFILE_FAILED = 'SETTINGS_SA_PROFILE_FAILED';
	var SETTINGS_SA_PROFILE_SUCCESSFUL = exports.SETTINGS_SA_PROFILE_SUCCESSFUL = 'SETTINGS_SA_PROFILE_SUCCESSFUL';
	var UPDATE_SA_PROFILE_REQUESTED = exports.UPDATE_SA_PROFILE_REQUESTED = 'UPDATE_SA_PROFILE_REQUESTED';
	var UPDATE_SA_PROFILE_FAILED = exports.UPDATE_SA_PROFILE_FAILED = 'UPDATE_SA_PROFILE_FAILED';
	var UPDATE_SA_PROFILE_SUCCESSFUL = exports.UPDATE_SA_PROFILE_SUCCESSFUL = 'UPDATE_SA_PROFILE_SUCCESSFUL';
	var PAYMENT_HISTORY_REQUESTED = exports.PAYMENT_HISTORY_REQUESTED = 'PAYMENT_HISTORY_REQUESTED';
	var PAYMENT_HISTORY_FAILED = exports.PAYMENT_HISTORY_FAILED = 'PAYMENT_HISTORY_FAILED';
	var PAYMENT_HISTORY_SUCCESSFUL = exports.PAYMENT_HISTORY_SUCCESSFUL = 'PAYMENT_HISTORY_SUCCESSFUL';
	var SETTINGS_SEARCH_SCHOOLS = exports.SETTINGS_SEARCH_SCHOOLS = 'SETTINGS_SEARCH_SCHOOLS';

/***/ },
/* 291 */
256,
/* 292 */
[2542, 1373],
/* 293 */
257,
/* 294 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 295 */
[2557, 131, 1388, 294, 298, 490, 1379],
/* 296 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 297 */
[2567, 99, 112, 76],
/* 298 */
[2568, 299, 204],
/* 299 */
[2569, 57, 98, 202],
/* 300 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 301 */
[2575, 134],
/* 302 */
[2576, 98, 57, 202, 303, 99],
/* 303 */
[2577, 76],
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1413);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 305 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInBrowser = __webpack_require__(205);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var js = ''; /**
	              * Export javascript style and css style vendor prefixes.
	              * Based on "transform" support test.
	              */
	
	var css = '';
	
	// We should not do anything if required serverside.
	if (_isInBrowser2['default']) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    // IE did it wrong again ...
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  }
	}
	
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String}}
	 * @api public
	 */
	exports['default'] = { js: js, css: css };

/***/ },
/* 307 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SheetsRegistry = __webpack_require__(517);
	
	var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	exports['default'] = new _SheetsRegistry2['default']();

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCss;
	
	var _toCssValue = __webpack_require__(523);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }return result + str;
	}
	
	/**
	 * Converts a Rule to CSS string.
	 */
	
	function toCss(selector, style) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var result = '';
	
	  if (!style) return result;
	
	  var _options$indent = options.indent,
	      indent = _options$indent === undefined ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	
	
	  indent++;
	
	  // Apply fallbacks first.
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	        for (var prop in fallback) {
	          var value = fallback[prop];
	          if (value != null) {
	            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
	          }
	        }
	      }
	    }
	    // Object syntax {fallbacks: {prop: value}}
	    else {
	        for (var _prop in fallbacks) {
	          var _value = fallbacks[_prop];
	          if (_value != null) {
	            result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
	          }
	        }
	      }
	  }
	
	  var hasFunctionValue = false;
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	    if (typeof _value2 === 'function') {
	      _value2 = style['$' + _prop2];
	      hasFunctionValue = true;
	    }
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
	    }
	  }
	
	  if (!result && !hasFunctionValue) return result;
	
	  indent--;
	  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);
	
	  return result;
	}

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(115),
	    root = __webpack_require__(87);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1954),
	    mapCacheDelete = __webpack_require__(1955),
	    mapCacheGet = __webpack_require__(1956),
	    mapCacheHas = __webpack_require__(1957),
	    mapCacheSet = __webpack_require__(1958);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 312 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(79),
	    isSymbol = __webpack_require__(319);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 314 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 315 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1913),
	    isObjectLike = __webpack_require__(141);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(87),
	    stubFalse = __webpack_require__(1985);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ },
/* 318 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(140),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1917),
	    baseUnary = __webpack_require__(1927),
	    nodeUtil = __webpack_require__(1962);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(1989);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(546);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(2000);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ },
/* 323 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ },
/* 324 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ },
/* 326 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry2 = __webpack_require__(6);
	var _reduce = __webpack_require__(62);
	var map = __webpack_require__(59);
	
	
	/**
	 * ap applies a list of functions to a list of values.
	 *
	 * Dispatches to the `ap` method of the second argument, if present. Also
	 * treats curried functions as applicatives.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig [a -> b] -> [a] -> [b]
	 * @sig Apply f => f (a -> b) -> f a -> f b
	 * @param {Array} fns An array of functions
	 * @param {Array} vs An array of values
	 * @return {Array} An array of results of applying each of `fns` to all of `vs` in turn.
	 * @example
	 *
	 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
	 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
	 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
	 */
	module.exports = _curry2(function ap(applicative, fn) {
	  return (
	    typeof applicative.ap === 'function' ?
	      applicative.ap(fn) :
	    typeof applicative === 'function' ?
	      function(x) { return applicative(x)(fn(x)); } :
	    // else
	      _reduce(function(acc, f) { return _concat(acc, map(f, fn)); }, [], applicative)
	  );
	});


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _makeFlat = __webpack_require__(710);
	var _xchain = __webpack_require__(2120);
	var map = __webpack_require__(59);
	
	
	/**
	 * `chain` maps a function over a list and concatenates the results. `chain`
	 * is also known as `flatMap` in some libraries
	 *
	 * Dispatches to the `chain` method of the second argument, if present,
	 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain m => (a -> m b) -> m a -> m b
	 * @param {Function} fn The function to map with
	 * @param {Array} list The list to map over
	 * @return {Array} The result of flat-mapping `list` with `fn`
	 * @example
	 *
	 *      var duplicate = n => [n, n];
	 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
	 *
	 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
	 */
	module.exports = _curry2(_dispatchable(['chain'], _xchain, function chain(fn, monad) {
	  if (typeof monad === 'function') {
	    return function(x) { return fn(monad(x))(x); };
	  }
	  return _makeFlat(false)(map(fn, monad));
	}));


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isArray = __webpack_require__(102);
	var _isFunction = __webpack_require__(224);
	var toString = __webpack_require__(175);
	
	
	/**
	 * Returns the result of concatenating the given lists or strings.
	 *
	 * Note: `R.concat` expects both arguments to be of the same type,
	 * unlike the native `Array.prototype.concat` method. It will throw
	 * an error if you `concat` an Array with a non-Array value.
	 *
	 * Dispatches to the `concat` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @sig String -> String -> String
	 * @param {Array|String} firstList The first list
	 * @param {Array|String} secondList The second list
	 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
	 * `secondList`.
	 *
	 * @example
	 *
	 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
	 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
	 *      R.concat([], []); //=> []
	 */
	module.exports = _curry2(function concat(a, b) {
	  if (a == null || !_isFunction(a.concat)) {
	    throw new TypeError(toString(a) + ' does not have a method named "concat"');
	  }
	  if (_isArray(a) && !_isArray(b)) {
	    throw new TypeError(toString(b) + ' is not an array');
	  }
	  return a.concat(b);
	});


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _filter = __webpack_require__(704);
	var _isObject = __webpack_require__(709);
	var _reduce = __webpack_require__(62);
	var _xfilter = __webpack_require__(2125);
	var keys = __webpack_require__(63);
	
	
	/**
	 * Takes a predicate and a "filterable", and returns a new filterable of the
	 * same type containing the members of the given filterable which satisfy the
	 * given predicate.
	 *
	 * Dispatches to the `filter` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> f a
	 * @param {Function} pred
	 * @param {Array} filterable
	 * @return {Array}
	 * @see R.reject, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
	 *
	 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
	 */
	module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
	  return (
	    _isObject(filterable) ?
	      _reduce(function(acc, key) {
	        if (pred(filterable[key])) {
	          acc[key] = filterable[key];
	        }
	        return acc;
	      }, {}, keys(filterable)) :
	    // else
	      _filter(pred, filterable)
	  );
	}));


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _identity = __webpack_require__(335);
	
	
	/**
	 * A function that does nothing but return the parameter supplied to it. Good
	 * as a default or placeholder function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x The value to return.
	 * @return {*} The input value, `x`.
	 * @example
	 *
	 *      R.identity(1); //=> 1
	 *
	 *      var obj = {};
	 *      R.identity(obj) === obj; //=> true
	 * @symb R.identity(a) = a
	 */
	module.exports = _curry1(_identity);


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var _objectAssign = __webpack_require__(2110);
	
	module.exports =
	  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ },
/* 334 */
/***/ function(module, exports) {

	module.exports = function _containsWith(pred, x, list) {
	  var idx = 0;
	  var len = list.length;
	
	  while (idx < len) {
	    if (pred(x, list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	};


/***/ },
/* 335 */
/***/ function(module, exports) {

	module.exports = function _identity(x) { return x; };


/***/ },
/* 336 */
/***/ function(module, exports) {

	module.exports = function _isTransformer(obj) {
	  return typeof obj['@@transducer/step'] === 'function';
	};


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a function that when supplied an object returns the indicated
	 * property of that object, if it exists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig s -> {s: a} -> a | Undefined
	 * @param {String} p The property name
	 * @param {Object} obj The object to query
	 * @return {*} The value at `obj.p`.
	 * @see R.path
	 * @example
	 *
	 *      R.prop('x', {x: 100}); //=> 100
	 *      R.prop('x', {}); //=> undefined
	 */
	module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(169);
	var _curry1 = __webpack_require__(12);
	var slice = __webpack_require__(118);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Gives a single-word string description of the (native) type of a value,
	 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
	 * attempt to distinguish user Object types any further, reporting them all as
	 * 'Object'.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Type
	 * @sig (* -> {*}) -> String
	 * @param {*} val The value to test
	 * @return {String}
	 * @example
	 *
	 *      R.type({}); //=> "Object"
	 *      R.type(1); //=> "Number"
	 *      R.type(false); //=> "Boolean"
	 *      R.type('s'); //=> "String"
	 *      R.type(null); //=> "Null"
	 *      R.type([]); //=> "Array"
	 *      R.type(/[A-z]/); //=> "RegExp"
	 */
	module.exports = _curry1(function type(val) {
	  return val === null      ? 'Null'      :
	         val === undefined ? 'Undefined' :
	         Object.prototype.toString.call(val).slice(8, -1);
	});


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(332);
	var uniqBy = __webpack_require__(736);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list. `R.equals` is used to determine equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
	 *      R.uniq([1, '1']);     //=> [1, '1']
	 *      R.uniq([[42], [42]]); //=> [[42]]
	 */
	module.exports = uniqBy(identity);


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(334);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied predicate to
	 * two list elements. Prefers the first item if two items compare equal based
	 * on the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      var strEq = R.eqBy(String);
	 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
	 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
	 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
	 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
	 */
	module.exports = _curry2(function uniqWith(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var item;
	  while (idx < len) {
	    item = list[idx];
	    if (!_containsWith(pred, item, result)) {
	      result[result.length] = item;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	
	var _require = __webpack_require__(21),
	    findDOMNode = _require.findDOMNode;
	
	var scrollIntoView = __webpack_require__(2236);
	
	var IMPERATIVE_API = ['blur', 'checkValidity', 'click', 'focus', 'select', 'setCustomValidity', 'setSelectionRange', 'setRangeText'];
	
	function getScrollOffset() {
	  return {
	    x: window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
	    y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
	  };
	}
	
	var Autocomplete = function (_React$Component) {
	  _inherits(Autocomplete, _React$Component);
	
	  function Autocomplete(props) {
	    _classCallCheck(this, Autocomplete);
	
	    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      highlightedIndex: null
	    };
	    _this._debugStates = [];
	    _this.ensureHighlightedIndex = _this.ensureHighlightedIndex.bind(_this);
	    _this.exposeAPI = _this.exposeAPI.bind(_this);
	    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
	    _this.handleInputBlur = _this.handleInputBlur.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleInputClick = _this.handleInputClick.bind(_this);
	    _this.maybeAutoCompleteText = _this.maybeAutoCompleteText.bind(_this);
	    return _this;
	  }
	
	  _createClass(Autocomplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.refs is frozen, so we need to assign a new object to it
	      this.refs = {};
	      this._ignoreBlur = false;
	      this._ignoreFocus = false;
	      this._scrollOffset = null;
	      this._scrollTimer = null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._scrollTimer);
	      this._scrollTimer = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.highlightedIndex !== null) {
	        this.setState(this.ensureHighlightedIndex);
	      }
	      if (nextProps.autoHighlight && (this.props.value !== nextProps.value || this.state.highlightedIndex === null)) {
	        this.setState(this.maybeAutoCompleteText);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.isOpen()) {
	        this.setMenuPositions();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.isOpen && !prevState.isOpen || 'open' in this.props && this.props.open && !prevProps.open) this.setMenuPositions();
	
	      this.maybeScrollItemIntoView();
	      if (prevState.isOpen !== this.state.isOpen) {
	        this.props.onMenuVisibilityChange(this.state.isOpen);
	      }
	    }
	  }, {
	    key: 'exposeAPI',
	    value: function exposeAPI(el) {
	      var _this2 = this;
	
	      this.refs.input = el;
	      IMPERATIVE_API.forEach(function (ev) {
	        return _this2[ev] = el && el[ev] && el[ev].bind(el);
	      });
	    }
	  }, {
	    key: 'maybeScrollItemIntoView',
	    value: function maybeScrollItemIntoView() {
	      if (this.isOpen() && this.state.highlightedIndex !== null) {
	        var itemNode = this.refs['item-' + this.state.highlightedIndex];
	        var menuNode = this.refs.menu;
	        scrollIntoView(findDOMNode(itemNode), findDOMNode(menuNode), { onlyScrollIfNeeded: true });
	      }
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(event) {
	      if (Autocomplete.keyDownHandlers[event.key]) Autocomplete.keyDownHandlers[event.key].call(this, event);else if (!this.isOpen()) {
	        this.setState({
	          isOpen: true
	        });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      this.props.onChange(event, event.target.value);
	    }
	  }, {
	    key: 'getFilteredItems',
	    value: function getFilteredItems(props) {
	      var items = props.items;
	
	      if (props.shouldItemRender) {
	        items = items.filter(function (item) {
	          return props.shouldItemRender(item, props.value);
	        });
	      }
	
	      if (props.sortItems) {
	        items.sort(function (a, b) {
	          return props.sortItems(a, b, props.value);
	        });
	      }
	
	      return items;
	    }
	  }, {
	    key: 'maybeAutoCompleteText',
	    value: function maybeAutoCompleteText(state, props) {
	      var highlightedIndex = state.highlightedIndex;
	      var value = props.value,
	          getItemValue = props.getItemValue;
	
	      var index = highlightedIndex === null ? 0 : highlightedIndex;
	      var items = this.getFilteredItems(props);
	      for (var i = 0; i < items.length; i++) {
	        if (props.isItemSelectable(items[index])) break;
	        index = (index + 1) % items.length;
	      }
	      var matchedItem = items[index] && props.isItemSelectable(items[index]) ? items[index] : null;
	      if (value !== '' && matchedItem) {
	        var itemValue = getItemValue(matchedItem);
	        var itemValueDoesMatch = itemValue.toLowerCase().indexOf(value.toLowerCase()) === 0;
	        if (itemValueDoesMatch) {
	          return { highlightedIndex: index };
	        }
	      }
	      return { highlightedIndex: null };
	    }
	  }, {
	    key: 'ensureHighlightedIndex',
	    value: function ensureHighlightedIndex(state, props) {
	      if (state.highlightedIndex >= this.getFilteredItems(props).length) {
	        return { highlightedIndex: null };
	      }
	    }
	  }, {
	    key: 'setMenuPositions',
	    value: function setMenuPositions() {
	      var node = this.refs.input;
	      var rect = node.getBoundingClientRect();
	      var computedStyle = global.window.getComputedStyle(node);
	      var marginBottom = parseInt(computedStyle.marginBottom, 10) || 0;
	      var marginLeft = parseInt(computedStyle.marginLeft, 10) || 0;
	      var marginRight = parseInt(computedStyle.marginRight, 10) || 0;
	      this.setState({
	        menuTop: rect.bottom + marginBottom,
	        menuLeft: rect.left + marginLeft,
	        menuWidth: rect.width + marginLeft + marginRight
	      });
	    }
	  }, {
	    key: 'highlightItemFromMouse',
	    value: function highlightItemFromMouse(index) {
	      this.setState({ highlightedIndex: index });
	    }
	  }, {
	    key: 'selectItemFromMouse',
	    value: function selectItemFromMouse(item) {
	      var _this3 = this;
	
	      var value = this.props.getItemValue(item);
	      // The menu will de-render before a mouseLeave event
	      // happens. Clear the flag to release control over focus
	      this.setIgnoreBlur(false);
	      this.setState({
	        isOpen: false,
	        highlightedIndex: null
	      }, function () {
	        _this3.props.onSelect(value, item);
	      });
	    }
	  }, {
	    key: 'setIgnoreBlur',
	    value: function setIgnoreBlur(ignore) {
	      this._ignoreBlur = ignore;
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _this4 = this;
	
	      var items = this.getFilteredItems(this.props).map(function (item, index) {
	        var element = _this4.props.renderItem(item, _this4.state.highlightedIndex === index, { cursor: 'default' });
	        return React.cloneElement(element, {
	          onMouseEnter: _this4.props.isItemSelectable(item) ? function () {
	            return _this4.highlightItemFromMouse(index);
	          } : null,
	          onClick: _this4.props.isItemSelectable(item) ? function () {
	            return _this4.selectItemFromMouse(item);
	          } : null,
	          ref: function ref(e) {
	            return _this4.refs['item-' + index] = e;
	          }
	        });
	      });
	      var style = {
	        left: this.state.menuLeft,
	        top: this.state.menuTop,
	        minWidth: this.state.menuWidth
	      };
	      var menu = this.props.renderMenu(items, this.props.value, style);
	      return React.cloneElement(menu, {
	        ref: function ref(e) {
	          return _this4.refs.menu = e;
	        },
	        // Ignore blur to prevent menu from de-rendering before we can process click
	        onTouchStart: function onTouchStart() {
	          return _this4.setIgnoreBlur(true);
	        },
	        onMouseEnter: function onMouseEnter() {
	          return _this4.setIgnoreBlur(true);
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this4.setIgnoreBlur(false);
	        }
	      });
	    }
	  }, {
	    key: 'handleInputBlur',
	    value: function handleInputBlur(event) {
	      var _this5 = this;
	
	      if (this._ignoreBlur) {
	        this._ignoreFocus = true;
	        this._scrollOffset = getScrollOffset();
	        this.refs.input.focus();
	        return;
	      }
	      var setStateCallback = void 0;
	      var highlightedIndex = this.state.highlightedIndex;
	
	      if (this.props.selectOnBlur && highlightedIndex !== null) {
	        var items = this.getFilteredItems(this.props);
	        var item = items[highlightedIndex];
	        var value = this.props.getItemValue(item);
	        setStateCallback = function setStateCallback() {
	          return _this5.props.onSelect(value, item);
	        };
	      }
	      this.setState({
	        isOpen: false,
	        highlightedIndex: null
	      }, setStateCallback);
	      var onBlur = this.props.inputProps.onBlur;
	
	      if (onBlur) {
	        onBlur(event);
	      }
	    }
	  }, {
	    key: 'handleInputFocus',
	    value: function handleInputFocus(event) {
	      var _this6 = this;
	
	      if (this._ignoreFocus) {
	        this._ignoreFocus = false;
	        var _scrollOffset = this._scrollOffset,
	            x = _scrollOffset.x,
	            y = _scrollOffset.y;
	
	        this._scrollOffset = null;
	        // Focus will cause the browser to scroll the <input> into view.
	        // This can cause the mouse coords to change, which in turn
	        // could cause a new highlight to happen, cancelling the click
	        // event (when selecting with the mouse)
	        window.scrollTo(x, y);
	        // Some browsers wait until all focus event handlers have been
	        // processed before scrolling the <input> into view, so let's
	        // scroll again on the next tick to ensure we're back to where
	        // the user was before focus was lost. We could do the deferred
	        // scroll only, but that causes a jarring split second jump in
	        // some browsers that scroll before the focus event handlers
	        // are triggered.
	        clearTimeout(this._scrollTimer);
	        this._scrollTimer = setTimeout(function () {
	          _this6._scrollTimer = null;
	          window.scrollTo(x, y);
	        }, 0);
	        return;
	      }
	      this.setState({ isOpen: true });
	      var onFocus = this.props.inputProps.onFocus;
	
	      if (onFocus) {
	        onFocus(event);
	      }
	    }
	  }, {
	    key: 'isInputFocused',
	    value: function isInputFocused() {
	      var el = this.refs.input;
	      return el.ownerDocument && el === el.ownerDocument.activeElement;
	    }
	  }, {
	    key: 'handleInputClick',
	    value: function handleInputClick() {
	      // Input will not be focused if it's disabled
	      if (this.isInputFocused() && !this.isOpen()) this.setState({ isOpen: true });
	    }
	  }, {
	    key: 'composeEventHandlers',
	    value: function composeEventHandlers(internal, external) {
	      return external ? function (e) {
	        internal(e);external(e);
	      } : internal;
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return 'open' in this.props ? this.props.open : this.state.isOpen;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.debug) {
	        // you don't like it, you love it
	        this._debugStates.push({
	          id: this._debugStates.length,
	          state: this.state
	        });
	      }
	
	      var inputProps = this.props.inputProps;
	
	      var open = this.isOpen();
	      return React.createElement(
	        'div',
	        _extends({ style: _extends({}, this.props.wrapperStyle) }, this.props.wrapperProps),
	        this.props.renderInput(_extends({}, inputProps, {
	          role: 'combobox',
	          'aria-autocomplete': 'list',
	          'aria-expanded': open,
	          autoComplete: 'off',
	          ref: this.exposeAPI,
	          onFocus: this.handleInputFocus,
	          onBlur: this.handleInputBlur,
	          onChange: this.handleChange,
	          onKeyDown: this.composeEventHandlers(this.handleKeyDown, inputProps.onKeyDown),
	          onClick: this.composeEventHandlers(this.handleInputClick, inputProps.onClick),
	          value: this.props.value
	        })),
	        open && this.renderMenu(),
	        this.props.debug && React.createElement(
	          'pre',
	          { style: { marginLeft: 300 } },
	          JSON.stringify(this._debugStates.slice(Math.max(0, this._debugStates.length - 5), this._debugStates.length), null, 2)
	        )
	      );
	    }
	  }]);
	
	  return Autocomplete;
	}(React.Component);
	
	Autocomplete.propTypes = {
	  /**
	   * The items to display in the dropdown menu
	   */
	  items: PropTypes.array.isRequired,
	  /**
	   * The value to display in the input field
	   */
	  value: PropTypes.any,
	  /**
	   * Arguments: `event: Event, value: String`
	   *
	   * Invoked every time the user changes the input's value.
	   */
	  onChange: PropTypes.func,
	  /**
	   * Arguments: `value: String, item: Any`
	   *
	   * Invoked when the user selects an item from the dropdown menu.
	   */
	  onSelect: PropTypes.func,
	  /**
	   * Arguments: `item: Any, value: String`
	   *
	   * Invoked for each entry in `items` and its return value is used to
	   * determine whether or not it should be displayed in the dropdown menu.
	   * By default all items are always rendered.
	   */
	  shouldItemRender: PropTypes.func,
	  /**
	   * Arguments: `item: Any`
	   *
	   * Invoked when attempting to select an item. The return value is used to
	   * determine whether the item should be selectable or not.
	   * By default all items are selectable.
	   */
	  isItemSelectable: PropTypes.func,
	  /**
	   * Arguments: `itemA: Any, itemB: Any, value: String`
	   *
	   * The function which is used to sort `items` before display.
	   */
	  sortItems: PropTypes.func,
	  /**
	   * Arguments: `item: Any`
	   *
	   * Used to read the display value from each entry in `items`.
	   */
	  getItemValue: PropTypes.func.isRequired,
	  /**
	   * Arguments: `item: Any, isHighlighted: Boolean, styles: Object`
	   *
	   * Invoked for each entry in `items` that also passes `shouldItemRender` to
	   * generate the render tree for each item in the dropdown menu. `styles` is
	   * an optional set of styles that can be applied to improve the look/feel
	   * of the items in the dropdown menu.
	   */
	  renderItem: PropTypes.func.isRequired,
	  /**
	   * Arguments: `items: Array<Any>, value: String, styles: Object`
	   *
	   * Invoked to generate the render tree for the dropdown menu. Ensure the
	   * returned tree includes every entry in `items` or else the highlight order
	   * and keyboard navigation logic will break. `styles` will contain
	   * { top, left, minWidth } which are the coordinates of the top-left corner
	   * and the width of the dropdown menu.
	   */
	  renderMenu: PropTypes.func,
	  /**
	   * Styles that are applied to the dropdown menu in the default `renderMenu`
	   * implementation. If you override `renderMenu` and you want to use
	   * `menuStyle` you must manually apply them (`this.props.menuStyle`).
	   */
	  menuStyle: PropTypes.object,
	  /**
	   * Arguments: `props: Object`
	   *
	   * Invoked to generate the input element. The `props` argument is the result
	   * of merging `props.inputProps` with a selection of props that are required
	   * both for functionality and accessibility. At the very least you need to
	   * apply `props.ref` and all `props.on<event>` event handlers. Failing to do
	   * this will cause `Autocomplete` to behave unexpectedly.
	   */
	  renderInput: PropTypes.func,
	  /**
	   * Props passed to `props.renderInput`. By default these props will be
	   * applied to the `<input />` element rendered by `Autocomplete`, unless you
	   * have specified a custom value for `props.renderInput`. Any properties
	   * supported by `HTMLInputElement` can be specified, apart from the
	   * following which are set by `Autocomplete`: value, autoComplete, role,
	   * aria-autocomplete. `inputProps` is commonly used for (but not limited to)
	   * placeholder, event handlers (onFocus, onBlur, etc.), autoFocus, etc..
	   */
	  inputProps: PropTypes.object,
	  /**
	   * Props that are applied to the element which wraps the `<input />` and
	   * dropdown menu elements rendered by `Autocomplete`.
	   */
	  wrapperProps: PropTypes.object,
	  /**
	   * This is a shorthand for `wrapperProps={{ style: <your styles> }}`.
	   * Note that `wrapperStyle` is applied before `wrapperProps`, so the latter
	   * will win if it contains a `style` entry.
	   */
	  wrapperStyle: PropTypes.object,
	  /**
	   * Whether or not to automatically highlight the top match in the dropdown
	   * menu.
	   */
	  autoHighlight: PropTypes.bool,
	  /**
	   * Whether or not to automatically select the highlighted item when the
	   * `<input>` loses focus.
	   */
	  selectOnBlur: PropTypes.bool,
	  /**
	   * Arguments: `isOpen: Boolean`
	   *
	   * Invoked every time the dropdown menu's visibility changes (i.e. every
	   * time it is displayed/hidden).
	   */
	  onMenuVisibilityChange: PropTypes.func,
	  /**
	   * Used to override the internal logic which displays/hides the dropdown
	   * menu. This is useful if you want to force a certain state based on your
	   * UX/business logic. Use it together with `onMenuVisibilityChange` for
	   * fine-grained control over the dropdown menu dynamics.
	   */
	  open: PropTypes.bool,
	  debug: PropTypes.bool
	};
	Autocomplete.defaultProps = {
	  value: '',
	  wrapperProps: {},
	  wrapperStyle: {
	    display: 'inline-block'
	  },
	  inputProps: {},
	  renderInput: function renderInput(props) {
	    return React.createElement('input', props);
	  },
	  onChange: function onChange() {},
	  onSelect: function onSelect() {},
	  isItemSelectable: function isItemSelectable() {
	    return true;
	  },
	  renderMenu: function renderMenu(items, value, style) {
	    return React.createElement('div', { style: _extends({}, style, this.menuStyle), children: items });
	  },
	
	  menuStyle: {
	    borderRadius: '3px',
	    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
	    background: 'rgba(255, 255, 255, 0.9)',
	    padding: '2px 0',
	    fontSize: '90%',
	    position: 'fixed',
	    overflow: 'auto',
	    maxHeight: '50%' },
	  autoHighlight: true,
	  selectOnBlur: false,
	  onMenuVisibilityChange: function onMenuVisibilityChange() {}
	};
	Autocomplete.keyDownHandlers = {
	  ArrowDown: function ArrowDown(event) {
	    event.preventDefault();
	    var items = this.getFilteredItems(this.props);
	    if (!items.length) return;
	    var highlightedIndex = this.state.highlightedIndex;
	
	    var index = highlightedIndex === null ? -1 : highlightedIndex;
	    for (var i = 0; i < items.length; i++) {
	      var p = (index + i + 1) % items.length;
	      if (this.props.isItemSelectable(items[p])) {
	        index = p;
	        break;
	      }
	    }
	    if (index > -1 && index !== highlightedIndex) {
	      this.setState({
	        highlightedIndex: index,
	        isOpen: true
	      });
	    }
	  },
	  ArrowUp: function ArrowUp(event) {
	    event.preventDefault();
	    var items = this.getFilteredItems(this.props);
	    if (!items.length) return;
	    var highlightedIndex = this.state.highlightedIndex;
	
	    var index = highlightedIndex === null ? items.length : highlightedIndex;
	    for (var i = 0; i < items.length; i++) {
	      var p = (index - (1 + i) + items.length) % items.length;
	      if (this.props.isItemSelectable(items[p])) {
	        index = p;
	        break;
	      }
	    }
	    if (index !== items.length) {
	      this.setState({
	        highlightedIndex: index,
	        isOpen: true
	      });
	    }
	  },
	  Enter: function Enter(event) {
	    var _this7 = this;
	
	    // Key code 229 is used for selecting items from character selectors (Pinyin, Kana, etc)
	    if (event.keyCode !== 13) return;
	    // In case the user is currently hovering over the menu
	    this.setIgnoreBlur(false);
	    if (!this.isOpen()) {
	      // menu is closed so there is no selection to accept -> do nothing
	      return;
	    } else if (this.state.highlightedIndex == null) {
	      // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
	      this.setState({
	        isOpen: false
	      }, function () {
	        _this7.refs.input.select();
	      });
	    } else {
	      // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
	      event.preventDefault();
	      var item = this.getFilteredItems(this.props)[this.state.highlightedIndex];
	      var value = this.props.getItemValue(item);
	      this.setState({
	        isOpen: false,
	        highlightedIndex: null
	      }, function () {
	        //this.refs.input.focus() // TODO: file issue
	        _this7.refs.input.setSelectionRange(value.length, value.length);
	        _this7.props.onSelect(value, item);
	      });
	    }
	  },
	  Escape: function Escape() {
	    // In case the user is currently hovering over the menu
	    this.setIgnoreBlur(false);
	    this.setState({
	      highlightedIndex: null,
	      isOpen: false
	    });
	  },
	  Tab: function Tab() {
	    // In case the user is currently hovering over the menu
	    this.setIgnoreBlur(false);
	  }
	};
	
	
	module.exports = Autocomplete;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(145);
	var Danger = __webpack_require__(2248);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(68);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(352);
	var setInnerHTML = __webpack_require__(238);
	var setTextContent = __webpack_require__(762);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 344 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var ReactErrorUtils = __webpack_require__(350);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 347 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var ReactPropTypesSecret = __webpack_require__(2277);
	var propTypesFactory = __webpack_require__(682);
	
	var React = __webpack_require__(151);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactInstanceMap = __webpack_require__(178);
	var ReactInstrumentation = __webpack_require__(68);
	var ReactUpdates = __webpack_require__(83);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 353 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 354 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 355 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 357 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var emptyFunction = __webpack_require__(77);
	var warning = __webpack_require__(17);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _classCallCheck = _interopDefault(__webpack_require__(2307));
	var _createClass = _interopDefault(__webpack_require__(2308));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(2313));
	var _inherits = _interopDefault(__webpack_require__(2310));
	var _typeof = _interopDefault(__webpack_require__(764));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(2312));
	var _objectSpread = _interopDefault(__webpack_require__(2311));
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var shallowEqual = _interopDefault(__webpack_require__(164));
	var warning = _interopDefault(__webpack_require__(53));
	
	function defineProperty(object, property, attr) {
	  return Object.defineProperty(object, property, attr);
	} // Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	
	
	var passiveOption = function () {
	  var cache = null;
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {//
	    }
	
	    cache = supportsPassiveOption;
	    return supportsPassiveOption;
	  }();
	}();
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return _objectSpread({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = _objectWithoutProperties(props, ["children", "target"]);
	
	  Object.keys(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	
	    var type = _typeof(prop);
	
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({
	        capture: capture
	      }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(EventListener, _React$Component);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return !shallowEqual(this.props, nextProps);
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: "addListeners",
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: "removeListeners",
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: "applyListeners",
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(React.Component);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: PropTypes.node,
	
	  /**
	   * The DOM target to listen to.
	   */
	  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
	} : {};
	
	exports.withOptions = withOptions;
	exports.default = EventListener;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2317);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 361 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Namespaces to avoid conflicts on the context.
	 */
	var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
	var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
	var providerId = exports.providerId = 'd9f144a51454eae08eb84ab3ade674a5';
	var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ },
/* 362 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMinimalistPortal = __webpack_require__(2325);
	
	var _reactMinimalistPortal2 = _interopRequireDefault(_reactMinimalistPortal);
	
	var _reactTransitionGroup = __webpack_require__(2467);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactJss = __webpack_require__(2322);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _noScroll = __webpack_require__(2035);
	
	var _noScroll2 = _interopRequireDefault(_noScroll);
	
	var _styles = __webpack_require__(2344);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
	
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    _this.onClickOverlay = _this.onClickOverlay.bind(_this);
	    _this.onClickCloseIcon = _this.onClickCloseIcon.bind(_this);
	    _this.state = {
	      showPortal: props.open,
	      open: props.open
	    };
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      // Block scroll when initial prop is open
	      if (this.props.open) {
	        this.blockScroll();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (!this.props.open && nextProps.open) {
	        this.setState({
	          open: true,
	          showPortal: true
	        }, function () {
	          _this2.blockScroll();
	        });
	      }
	      if (this.props.open && !nextProps.open) {
	        this.setState({ open: false });
	        // Let the animation finish
	        this.timeout = setTimeout(function () {
	          _this2.setState({ showPortal: false });
	          _this2.unblockScroll();
	        }, 500);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      this.unblockScroll();
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'onClickOverlay',
	    value: function onClickOverlay(e) {
	      var _props = this.props,
	          classes = _props.classes,
	          closeOnOverlayClick = _props.closeOnOverlayClick;
	
	      if (!closeOnOverlayClick || typeof e.target.className !== 'string') {
	        return;
	      }
	      var className = e.target.className.split(' ');
	      if (className.indexOf(classes.overlay) !== -1) {
	        e.stopPropagation();
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'onClickCloseIcon',
	    value: function onClickCloseIcon(e) {
	      e.stopPropagation();
	      this.props.onClose();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === 27) {
	        this.props.onClose();
	      }
	    }
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'blockScroll',
	    value: function blockScroll() {
	      _noScroll2.default.on();
	    }
	  }, {
	    key: 'unblockScroll',
	    value: function unblockScroll() {
	      var openedModals = document.getElementsByClassName(this.props.classes.modal);
	      if (openedModals.length === 0) {
	        _noScroll2.default.off();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          little = _props2.little,
	          classes = _props2.classes,
	          overlayClassName = _props2.overlayClassName,
	          modalClassName = _props2.modalClassName,
	          closeIconClassName = _props2.closeIconClassName,
	          overlayStyle = _props2.overlayStyle,
	          modalStyle = _props2.modalStyle,
	          showCloseIcon = _props2.showCloseIcon,
	          closeIconSize = _props2.closeIconSize;
	      var _state = this.state,
	          open = _state.open,
	          showPortal = _state.showPortal;
	
	      if (!showPortal) return null;
	      return _react2.default.createElement(
	        _reactMinimalistPortal2.default,
	        null,
	        _react2.default.createElement(
	          _reactTransitionGroup.CSSTransitionGroup,
	          {
	            transitionName: {
	              appear: classes.transitionEnter,
	              appearActive: classes.transitionEnterActive,
	              enter: classes.transitionEnter,
	              enterActive: classes.transitionEnterActive,
	              leave: classes.transitionLeave,
	              leaveActive: classes.transitionLeaveActive
	            },
	            transitionAppear: true,
	            transitionLeave: true,
	            transitionAppearTimeout: 500,
	            transitionEnterTimeout: 500,
	            transitionLeaveTimeout: 500
	          },
	          open && _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(classes.overlay, little ? classes.overlayLittle : null, overlayClassName),
	              onMouseDown: this.onClickOverlay,
	              style: overlayStyle
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(classes.modal, modalClassName),
	                style: modalStyle
	              },
	              showCloseIcon ? _react2.default.createElement(
	                'svg',
	                {
	                  className: (0, _classnames2.default)(classes.closeIcon, closeIconClassName),
	                  onClick: this.onClickCloseIcon,
	                  xmlns: 'http://www.w3.org/2000/svg',
	                  width: closeIconSize,
	                  height: closeIconSize,
	                  viewBox: '0 0 36 36'
	                },
	                _react2.default.createElement('path', { d: 'M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z' })
	              ) : null,
	              this.props.children
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOverlayClick: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func.isRequired,
	  open: _propTypes2.default.bool.isRequired,
	  overlayClassName: _propTypes2.default.string,
	  modalClassName: _propTypes2.default.string,
	  closeIconClassName: _propTypes2.default.string,
	  overlayStyle: _propTypes2.default.object,
	  modalStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  classes: _propTypes2.default.object.isRequired,
	  little: _propTypes2.default.bool,
	  showCloseIcon: _propTypes2.default.bool,
	  closeIconSize: _propTypes2.default.number
	};
	
	Modal.defaultProps = {
	  closeOnEsc: true,
	  closeOnOverlayClick: true,
	  showCloseIcon: true,
	  closeIconSize: 28,
	  overlayClassName: null,
	  modalClassName: null,
	  closeIconClassName: null,
	  overlayStyle: null,
	  modalStyle: null,
	  children: null,
	  little: false
	};
	
	exports.default = (0, _reactJss2.default)(_styles2.default)(Modal);

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(242);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(148);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(243);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(783);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(786);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem.getBoundingClientRect().height || elem.offsetHeight || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Stepper = __webpack_require__(2371);
	
	var _Stepper2 = _interopRequireDefault(_Stepper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Stepper2.default;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkbox = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _Checkbox = __webpack_require__(249);
	
	var _Check = __webpack_require__(789);
	
	var _Check2 = _interopRequireDefault(_Check);
	
	var _theme = __webpack_require__(1435);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedCheck = (0, _Check2.default)((0, _ripple2.default)({ centered: true, spread: 2.6 }));
	var ThemedCheckbox = (0, _reactCssThemr.themr)(_identifiers.CHECKBOX, _theme2.default)((0, _Checkbox.checkboxFactory)(ThemedCheck));
	
	exports.default = ThemedCheckbox;
	exports.Checkbox = ThemedCheckbox;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dialogFactory = exports.Dialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _classnames3 = __webpack_require__(3);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _identifiers = __webpack_require__(9);
	
	var _Portal = __webpack_require__(250);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ActivableRenderer = __webpack_require__(374);
	
	var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);
	
	var _Button = __webpack_require__(247);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Overlay = __webpack_require__(375);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable jsx-a11y/aria-role */
	
	
	var factory = function factory(Overlay, Button) {
	  var Dialog = function Dialog(props) {
	    var actions = props.actions.map(function (action, idx) {
	      var className = (0, _classnames4.default)(props.theme.button, _defineProperty({}, action.className, action.className));
	      return _react2.default.createElement(Button, _extends({ key: idx }, action, { className: className })); // eslint-disable-line
	    });
	
	    var className = (0, _classnames4.default)([props.theme.dialog, props.theme[props.type]], _defineProperty({}, props.theme.active, props.active), props.className);
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { className: props.theme.wrapper },
	      _react2.default.createElement(Overlay, {
	        active: props.active,
	        className: props.theme.overlay,
	        onClick: props.onOverlayClick,
	        onEscKeyDown: props.onEscKeyDown,
	        onMouseDown: props.onOverlayMouseDown,
	        onMouseMove: props.onOverlayMouseMove,
	        onMouseUp: props.onOverlayMouseUp,
	        theme: props.theme,
	        themeNamespace: 'overlay'
	      }),
	      _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'dialog', className: className },
	        _react2.default.createElement(
	          'section',
	          { role: 'body', className: props.theme.body },
	          props.title ? _react2.default.createElement(
	            'h6',
	            { className: props.theme.title },
	            props.title
	          ) : null,
	          props.children
	        ),
	        actions.length ? _react2.default.createElement(
	          'nav',
	          { className: props.theme.navigation },
	          actions
	        ) : null
	      )
	    );
	  };
	
	  Dialog.propTypes = {
	    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      className: _propTypes2.default.string,
	      label: _propTypes2.default.string,
	      children: _propTypes2.default.node
	    })),
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    onOverlayMouseDown: _propTypes2.default.func,
	    onOverlayMouseMove: _propTypes2.default.func,
	    onOverlayMouseUp: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      body: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      dialog: _propTypes2.default.string,
	      navigation: _propTypes2.default.string,
	      overflow: _propTypes2.default.string,
	      overlay: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      wrapper: _propTypes2.default.string
	    }),
	    title: _propTypes2.default.string,
	    type: _propTypes2.default.string
	  };
	
	  Dialog.defaultProps = {
	    actions: [],
	    active: false,
	    type: 'normal'
	  };
	
	  return (0, _ActivableRenderer2.default)()(Dialog);
	};
	
	var Dialog = factory(_Overlay2.default, _Button2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DIALOG)(Dialog);
	exports.Dialog = Dialog;
	exports.dialogFactory = factory;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dialog = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Dialog = __webpack_require__(370);
	
	var _overlay = __webpack_require__(807);
	
	var _button = __webpack_require__(31);
	
	var _theme = __webpack_require__(1438);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dialog = (0, _Dialog.dialogFactory)(_overlay.Overlay, _button.Button);
	var ThemedDialog = (0, _reactCssThemr.themr)(_identifiers.DIALOG, _theme2.default)(Dialog);
	
	exports.default = ThemedDialog;
	exports.Dialog = ThemedDialog;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Drawer = exports.drawerFactory = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Portal = __webpack_require__(250);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _identifiers = __webpack_require__(9);
	
	var _ActivableRenderer = __webpack_require__(374);
	
	var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);
	
	var _Overlay = __webpack_require__(375);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var factory = function factory(Overlay) {
	  var Drawer = function Drawer(_ref) {
	    var active = _ref.active,
	        children = _ref.children,
	        className = _ref.className,
	        insideTree = _ref.insideTree,
	        onOverlayClick = _ref.onOverlayClick,
	        onEscKeyDown = _ref.onEscKeyDown,
	        theme = _ref.theme,
	        type = _ref.type,
	        withOverlay = _ref.withOverlay;
	
	    var _className = (0, _classnames3.default)([theme.drawer, theme[type]], _defineProperty({}, theme.active, active), className);
	
	    var content = _react2.default.createElement(
	      'aside',
	      { 'data-react-toolbox': 'drawer', className: _className },
	      children
	    );
	
	    return _react2.default.createElement(insideTree ? 'div' : _Portal2.default, { className: theme.wrapper }, withOverlay && _react2.default.createElement(Overlay, {
	      active: active,
	      onClick: onOverlayClick,
	      onEscKeyDown: onEscKeyDown,
	      theme: theme,
	      themeNamespace: 'overlay'
	    }), content);
	  };
	
	  Drawer.propTypes = {
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    insideTree: _propTypes2.default.bool,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      drawer: _propTypes2.default.string,
	      left: _propTypes2.default.string,
	      right: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.oneOf(['left', 'right']),
	    withOverlay: _propTypes2.default.bool
	  };
	
	  Drawer.defaultProps = {
	    active: false,
	    className: '',
	    insideTree: false,
	    type: 'left',
	    withOverlay: true
	  };
	
	  return (0, _ActivableRenderer2.default)()(Drawer);
	};
	
	var Drawer = factory(_Overlay2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DRAWER)(Drawer);
	exports.drawerFactory = factory;
	exports.Drawer = Drawer;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Drawer = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _overlay = __webpack_require__(807);
	
	var _Drawer = __webpack_require__(372);
	
	var _theme = __webpack_require__(1439);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Drawer = (0, _Drawer.drawerFactory)(_overlay.Overlay);
	var ThemedDrawer = (0, _reactCssThemr.themr)(_identifiers.DRAWER, _theme2.default)(Drawer);
	
	exports.default = ThemedDrawer;
	exports.Drawer = ThemedDrawer;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivableRendererFactory = function ActivableRendererFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { delay: 500 };
	  return function (ActivableComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(ActivableRenderer, _Component);
	
	      function ActivableRenderer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ActivableRenderer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivableRenderer.__proto__ || Object.getPrototypeOf(ActivableRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          active: _this.props.active,
	          rendered: _this.props.active
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(ActivableRenderer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          if (nextProps.active && !this.props.active) this.renderAndActivate();
	          if (!nextProps.active && this.props.active) this.deactivateAndUnrender();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.activateTimeout);
	          clearTimeout(this.unrenderTimeout);
	        }
	      }, {
	        key: 'deactivateAndUnrender',
	        value: function deactivateAndUnrender() {
	          var _this2 = this;
	
	          this.setState({ rendered: true, active: false }, function () {
	            _this2.unrenderTimeout = setTimeout(function () {
	              _this2.setState({ rendered: false });
	              _this2.unrenderTimeout = null;
	            }, _this2.props.delay);
	          });
	        }
	      }, {
	        key: 'renderAndActivate',
	        value: function renderAndActivate() {
	          var _this3 = this;
	
	          if (this.unrenderTimeout) clearTimeout(this.unrenderTimeout);
	          this.setState({ rendered: true, active: false }, function () {
	            _this3.activateTimeout = setTimeout(function () {
	              return _this3.setState({ active: true });
	            }, 20);
	          });
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              delay = _props.delay,
	              others = _objectWithoutProperties(_props, ['delay']); // eslint-disable-line no-unused-vars
	
	
	          var _state = this.state,
	              active = _state.active,
	              rendered = _state.rendered;
	
	          return rendered ? _react2.default.createElement(ActivableComponent, _extends({}, others, { active: active })) : null;
	        }
	      }]);
	
	      return ActivableRenderer;
	    }(_react.Component), _class.propTypes = {
	      active: _propTypes2.default.bool.isRequired,
	      children: _propTypes2.default.node,
	      delay: _propTypes2.default.number
	    }, _class.defaultProps = {
	      delay: options.delay
	    }, _temp2;
	  };
	};
	
	exports.default = ActivableRendererFactory;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Overlay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Overlay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.handleEscKey = function (e) {
	      if (_this.props.active && _this.props.onEscKeyDown && e.which === 27) {
	        _this.props.onEscKeyDown(e);
	      }
	    }, _this.handleClick = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          active = _props.active,
	          lockScroll = _props.lockScroll,
	          onEscKeyDown = _props.onEscKeyDown;
	
	      if (onEscKeyDown) document.body.addEventListener('keydown', this.handleEscKey);
	      if (active && lockScroll) document.body.style.overflow = 'hidden';
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.lockScroll) {
	        var becomingActive = nextProps.active && !this.props.active;
	        var becomingUnactive = !nextProps.active && this.props.active;
	
	        if (becomingActive) {
	          document.body.style.overflow = 'hidden';
	        }
	
	        if (becomingUnactive && !document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
	          document.body.style.overflow = '';
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.onEscKeyDown) {
	        if (this.props.active && !prevProps.active) {
	          document.body.addEventListener('keydown', this.handleEscKey);
	        } else if (!this.props.active && prevProps.active) {
	          document.body.removeEventListener('keydown', this.handleEscKey);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.active && this.props.lockScroll) {
	        if (!document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
	          document.body.style.overflow = '';
	        }
	      }
	
	      if (this.props.onEscKeyDown) {
	        document.body.removeEventListener('keydown', this.handleEscKey);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          active = _props2.active,
	          className = _props2.className,
	          lockScroll = _props2.lockScroll,
	          theme = _props2.theme,
	          onEscKeyDown = _props2.onEscKeyDown,
	          other = _objectWithoutProperties(_props2, ['active', 'className', 'lockScroll', 'theme', 'onEscKeyDown']); // eslint-disable-line
	
	
	      return _react2.default.createElement('div', _extends({}, other, {
	        onClick: this.handleClick,
	        className: (0, _classnames3.default)(theme.overlay, _defineProperty({}, theme.active, active), className)
	      }));
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.propTypes = {
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  lockScroll: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onEscKeyDown: _propTypes2.default.func,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    backdrop: _propTypes2.default.string,
	    overlay: _propTypes2.default.string
	  })
	};
	Overlay.defaultProps = {
	  lockScroll: true
	};
	exports.default = (0, _reactCssThemr.themr)(_identifiers.OVERLAY)(Overlay);
	exports.Overlay = Overlay;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TableCell = exports.tableCellFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames3 = __webpack_require__(3);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ASC = 'asc';
	var DESC = 'desc';
	
	var factory = function factory(FontIcon) {
	  var TableCell = function (_Component) {
	    _inherits(TableCell, _Component);
	
	    function TableCell() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TableCell);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	        var _this$props = _this.props,
	            onClick = _this$props.onClick,
	            row = _this$props.row,
	            column = _this$props.column;
	
	        if (onClick) onClick(event, column, row);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TableCell, [{
	      key: 'render',
	      value: function render() {
	        var _classnames;
	
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className,
	            numeric = _props.numeric,
	            row = _props.row,
	            column = _props.column,
	            sorted = _props.sorted,
	            tagName = _props.tagName,
	            theme = _props.theme,
	            other = _objectWithoutProperties(_props, ['children', 'className', 'numeric', 'row', 'column', 'sorted', 'tagName', 'theme']);
	
	        var _className = (0, _classnames4.default)(theme.tableCell, (_classnames = {}, _defineProperty(_classnames, theme.headCell, tagName === 'th'), _defineProperty(_classnames, theme.rowCell, tagName === 'td'), _defineProperty(_classnames, theme.sorted, sorted), _defineProperty(_classnames, theme.numeric, numeric), _classnames), className);
	
	        var props = _extends({}, other, {
	          className: _className,
	          onClick: this.handleClick
	        });
	
	        return _react2.default.createElement(tagName, props, [sorted && _react2.default.createElement(FontIcon, {
	          className: (0, _classnames4.default)(theme.sortIcon, _defineProperty({}, theme.asc, sorted === ASC)),
	          key: 'icon',
	          value: 'arrow_downward'
	        }), children]);
	      }
	    }]);
	
	    return TableCell;
	  }(_react.Component);
	
	  TableCell.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    column: _propTypes2.default.number,
	    numeric: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func,
	    row: _propTypes2.default.number,
	    sorted: _propTypes2.default.oneOf([ASC, DESC]),
	    tagName: _propTypes2.default.oneOf(['td', 'th']),
	    theme: _propTypes2.default.shape({
	      asc: _propTypes2.default.string,
	      headCell: _propTypes2.default.string,
	      numeric: _propTypes2.default.string,
	      rowCell: _propTypes2.default.string,
	      sorted: _propTypes2.default.string,
	      sortIcon: _propTypes2.default.string,
	      tableCell: _propTypes2.default.string
	    })
	  };
	  TableCell.defaultProps = {
	    children: _propTypes2.default.node,
	    className: '',
	    numeric: false,
	    tagName: 'td'
	  };
	
	
	  return TableCell;
	};
	
	var TableCell = factory(_FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(TableCell);
	exports.tableCellFactory = factory;
	exports.TableCell = TableCell;

/***/ },
/* 377 */
[2540, 256, 46],
/* 378 */
294,
/* 379 */
[2554, 259, 85, 124, 123, 183, 2441, 261, 2444, 46],
/* 380 */
[2556, 186, 72, 122, 92, 182],
/* 381 */
[2557, 120, 2442, 378, 383, 824, 2438],
/* 382 */
203,
/* 383 */
[2568, 262, 186],
/* 384 */
300,
/* 385 */
[2575, 72],
/* 386 */
[2576, 71, 64, 259, 840, 92],
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(153);
	
	var ReactNoopUpdateQueue = __webpack_require__(388);
	
	var canDefineProperty = __webpack_require__(851);
	var emptyObject = __webpack_require__(137);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(17);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 389 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 390 */
389,
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  pool: {
	    UserPoolId: ("us-east-1_gq9355VWI"),
	    ClientId: ("2cqfk5fm73rilfj1fm1g29fsa7"),
	  },
	  region: ("us-east-1"),
	  IdentityPoolId: ("us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e"),
	};
	
	/*
	production credentials
	export STAGE=prod
	export DYNAMODB_PORT=8000
	export USER_POOL_ID=us-east-1_gq9355VWI
	export USERPOOL_COGNITO_ARN=arn:aws:cognito-idp:us-east-1:495483525753:userpool/us-east-1_gq9355VWI
	export USERPOOL_CLIENT_ID=2cqfk5fm73rilfj1fm1g29fsa7
	export AWS_SHARED_CREDENTIALS_FILE=~/.aws/credentials
	export AWS_ACCESS_KEY= AKIAJVKELIIJGLGP2Z7A
	export AWS_SECRET_KEY=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
	
	Identity Pool id = us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e */
	
	
	// /*
	// export DYNAMODB_PORT=8000
	// export USER_POOL_ID=us-east-1_xnqcFszqf
	// export USERPOOL_COGNITO_ARN=arn:aws:cognito-idp:us-east-1:
	//  269483161851:userpool/us-east-1_xnqcFszqf
	// export USERPOOL_CLIENT_ID=3on13ieac509iaegmr1r2oilq9
	// export AWS_SHARED_CREDENTIALS_FILE=~/.aws/credentials
	//
	// Identity Pool id = us-east-1:67ae8f01-a6ab-4c20-90cc-5b93ec056ad3*/


/***/ },
/* 392 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _global = __webpack_require__(269);
	
	var _BigInteger = __webpack_require__(394);
	
	var _BigInteger2 = _interopRequireDefault(_BigInteger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
	                                                                                                                                                           * Copyright 2016 Amazon.com,
	                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                           *
	                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                           * You may not use this file except in compliance with the
	                                                                                                                                                           * License. A copy of the License is located at
	                                                                                                                                                           *
	                                                                                                                                                           *     http://aws.amazon.com/asl/
	                                                                                                                                                           *
	                                                                                                                                                           * or in the "license" file accompanying this file. This file is
	                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                           * for the specific language governing permissions and
	                                                                                                                                                           * limitations under the License.
	                                                                                                                                                           */
	
	var initN = 'FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD1' + '29024E088A67CC74020BBEA63B139B22514A08798E3404DD' + 'EF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245' + 'E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7ED' + 'EE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3D' + 'C2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F' + '83655D23DCA3AD961C62F356208552BB9ED529077096966D' + '670C354E4ABC9804F1746C08CA18217C32905E462E36CE3B' + 'E39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9' + 'DE2BCBF6955817183995497CEA956AE515D2261898FA0510' + '15728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64' + 'ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7' + 'ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6B' + 'F12FFA06D98A0864D87602733EC86A64521F2B18177B200C' + 'BBE117577A615D6C770988C0BAD946E208E24FA074E5AB31' + '43DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF';
	
	var newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
	
	/** @class */
	
	var AuthenticationHelper = function () {
	  /**
	   * Constructs a new AuthenticationHelper object
	   * @param {string} PoolName Cognito user pool name.
	   */
	  function AuthenticationHelper(PoolName) {
	    _classCallCheck(this, AuthenticationHelper);
	
	    this.N = new _BigInteger2.default(initN, 16);
	    this.g = new _BigInteger2.default('2', 16);
	    this.k = new _BigInteger2.default(this.hexHash('00' + this.N.toString(16) + '0' + this.g.toString(16)), 16);
	
	    this.smallAValue = this.generateRandomSmallA();
	    this.getLargeAValue(function () {});
	
	    this.infoBits = new _global.util.Buffer('Caldera Derived Key', 'utf8');
	
	    this.poolName = PoolName;
	  }
	
	  /**
	   * @returns {BigInteger} small A, a random number
	   */
	
	
	  AuthenticationHelper.prototype.getSmallAValue = function getSmallAValue() {
	    return this.smallAValue;
	  };
	
	  /**
	   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
	   * @returns {void}
	   */
	
	
	  AuthenticationHelper.prototype.getLargeAValue = function getLargeAValue(callback) {
	    var _this = this;
	
	    if (this.largeAValue) {
	      callback(null, this.largeAValue);
	    } else {
	      this.calculateA(this.smallAValue, function (err, largeAValue) {
	        if (err) {
	          callback(err, null);
	        }
	
	        _this.largeAValue = largeAValue;
	        callback(null, _this.largeAValue);
	      });
	    }
	  };
	
	  /**
	   * helper function to generate a random big integer
	   * @returns {BigInteger} a random value.
	   * @private
	   */
	
	
	  AuthenticationHelper.prototype.generateRandomSmallA = function generateRandomSmallA() {
	    var hexRandom = _global.util.crypto.lib.randomBytes(128).toString('hex');
	
	    var randomBigInt = new _BigInteger2.default(hexRandom, 16);
	    var smallABigInt = randomBigInt.mod(this.N);
	
	    return smallABigInt;
	  };
	
	  /**
	   * helper function to generate a random string
	   * @returns {string} a random value.
	   * @private
	   */
	
	
	  AuthenticationHelper.prototype.generateRandomString = function generateRandomString() {
	    return _global.util.crypto.lib.randomBytes(40).toString('base64');
	  };
	
	  /**
	   * @returns {string} Generated random value included in password hash.
	   */
	
	
	  AuthenticationHelper.prototype.getRandomPassword = function getRandomPassword() {
	    return this.randomPassword;
	  };
	
	  /**
	   * @returns {string} Generated random value included in devices hash.
	   */
	
	
	  AuthenticationHelper.prototype.getSaltDevices = function getSaltDevices() {
	    return this.SaltToHashDevices;
	  };
	
	  /**
	   * @returns {string} Value used to verify devices.
	   */
	
	
	  AuthenticationHelper.prototype.getVerifierDevices = function getVerifierDevices() {
	    return this.verifierDevices;
	  };
	
	  /**
	   * Generate salts and compute verifier.
	   * @param {string} deviceGroupKey Devices to generate verifier for.
	   * @param {string} username User to generate verifier for.
	   * @param {nodeCallback<null>} callback Called with (err, null)
	   * @returns {void}
	   */
	
	
	  AuthenticationHelper.prototype.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
	    var _this2 = this;
	
	    this.randomPassword = this.generateRandomString();
	    var combinedString = '' + deviceGroupKey + username + ':' + this.randomPassword;
	    var hashedString = this.hash(combinedString);
	
	    var hexRandom = _global.util.crypto.lib.randomBytes(16).toString('hex');
	    this.SaltToHashDevices = this.padHex(new _BigInteger2.default(hexRandom, 16));
	
	    this.g.modPow(new _BigInteger2.default(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function (err, verifierDevicesNotPadded) {
	      if (err) {
	        callback(err, null);
	      }
	
	      _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
	      callback(null, null);
	    });
	  };
	
	  /**
	   * Calculate the client's public value A = g^a%N
	   * with the generated random number a
	   * @param {BigInteger} a Randomly generated small A.
	   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
	   * @returns {void}
	   * @private
	   */
	
	
	  AuthenticationHelper.prototype.calculateA = function calculateA(a, callback) {
	    var _this3 = this;
	
	    this.g.modPow(a, this.N, function (err, A) {
	      if (err) {
	        callback(err, null);
	      }
	
	      if (A.mod(_this3.N).equals(_BigInteger2.default.ZERO)) {
	        callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
	      }
	
	      callback(null, A);
	    });
	  };
	
	  /**
	   * Calculate the client's value U which is the hash of A and B
	   * @param {BigInteger} A Large A value.
	   * @param {BigInteger} B Server B value.
	   * @returns {BigInteger} Computed U value.
	   * @private
	   */
	
	
	  AuthenticationHelper.prototype.calculateU = function calculateU(A, B) {
	    this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
	    var finalU = new _BigInteger2.default(this.UHexHash, 16);
	
	    return finalU;
	  };
	
	  /**
	   * Calculate a hash from a bitArray
	   * @param {Buffer} buf Value to hash.
	   * @returns {String} Hex-encoded hash.
	   * @private
	   */
	
	
	  AuthenticationHelper.prototype.hash = function hash(buf) {
	    var hashHex = _global.util.crypto.sha256(buf, 'hex');
	    return new Array(64 - hashHex.length).join('0') + hashHex;
	  };
	
	  /**
	   * Calculate a hash from a hex string
	   * @param {String} hexStr Value to hash.
	   * @returns {String} Hex-encoded hash.
	   * @private
	   */
	
	
	  AuthenticationHelper.prototype.hexHash = function hexHash(hexStr) {
	    return this.hash(new _global.util.Buffer(hexStr, 'hex'));
	  };
	
	  /**
	   * Standard hkdf algorithm
	   * @param {Buffer} ikm Input key material.
	   * @param {Buffer} salt Salt value.
	   * @returns {Buffer} Strong key material.
	   * @private
	   */
	
	
	  AuthenticationHelper.prototype.computehkdf = function computehkdf(ikm, salt) {
	    var prk = _global.util.crypto.hmac(salt, ikm, 'buffer', 'sha256');
	    var infoBitsUpdate = _global.util.buffer.concat([this.infoBits, new _global.util.Buffer(String.fromCharCode(1), 'utf8')]);
	    var hmac = _global.util.crypto.hmac(prk, infoBitsUpdate, 'buffer', 'sha256');
	    return hmac.slice(0, 16);
	  };
	
	  /**
	   * Calculates the final hkdf based on computed S value, and computed U value and the key
	   * @param {String} username Username.
	   * @param {String} password Password.
	   * @param {BigInteger} serverBValue Server B value.
	   * @param {BigInteger} salt Generated salt.
	   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
	   * @returns {void}
	   */
	
	
	  AuthenticationHelper.prototype.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
	    var _this4 = this;
	
	    if (serverBValue.mod(this.N).equals(_BigInteger2.default.ZERO)) {
	      throw new Error('B cannot be zero.');
	    }
	
	    this.UValue = this.calculateU(this.largeAValue, serverBValue);
	
	    if (this.UValue.equals(_BigInteger2.default.ZERO)) {
	      throw new Error('U cannot be zero.');
	    }
	
	    var usernamePassword = '' + this.poolName + username + ':' + password;
	    var usernamePasswordHash = this.hash(usernamePassword);
	
	    var xValue = new _BigInteger2.default(this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
	    this.calculateS(xValue, serverBValue, function (err, sValue) {
	      if (err) {
	        callback(err, null);
	      }
	
	      var hkdf = _this4.computehkdf(new _global.util.Buffer(_this4.padHex(sValue), 'hex'), new _global.util.Buffer(_this4.padHex(_this4.UValue.toString(16)), 'hex'));
	
	      callback(null, hkdf);
	    });
	  };
	
	  /**
	   * Calculates the S value used in getPasswordAuthenticationKey
	   * @param {BigInteger} xValue Salted password hash value.
	   * @param {BigInteger} serverBValue Server B value.
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  AuthenticationHelper.prototype.calculateS = function calculateS(xValue, serverBValue, callback) {
	    var _this5 = this;
	
	    this.g.modPow(xValue, this.N, function (err, gModPowXN) {
	      if (err) {
	        callback(err, null);
	      }
	
	      var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
	      intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function (err2, result) {
	        if (err2) {
	          callback(err2, null);
	        }
	
	        callback(null, result.mod(_this5.N));
	      });
	    });
	  };
	
	  /**
	  * Return constant newPasswordRequiredChallengeUserAttributePrefix
	  * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
	  */
	
	
	  AuthenticationHelper.prototype.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
	    return newPasswordRequiredChallengeUserAttributePrefix;
	  };
	
	  /**
	   * Converts a BigInteger (or hex string) to hex format padded with zeroes for hashing
	   * @param {BigInteger|String} bigInt Number or string to pad.
	   * @returns {String} Padded hex string.
	   */
	
	
	  AuthenticationHelper.prototype.padHex = function padHex(bigInt) {
	    var hashStr = bigInt.toString(16);
	    if (hashStr.length % 2 === 1) {
	      hashStr = '0' + hashStr;
	    } else if ('89ABCDEFabcdef'.indexOf(hashStr[0]) !== -1) {
	      hashStr = '00' + hashStr;
	    }
	    return hashStr;
	  };
	
	  return AuthenticationHelper;
	}();
	
	exports.default = AuthenticationHelper;

/***/ },
/* 394 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
	//
	// All public methods have been removed except the following:
	//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
	//   toString (only radix 2, 4, 8, 16 and 32 supported)
	//   negate
	//   abs
	//   compareTo
	//   bitLength
	//   mod
	//   equals
	//   add
	//   subtract
	//   multiply
	//   divide
	//   modPow
	
	exports.default = BigInteger;
	
	/*
	 * Copyright (c) 2003-2005  Tom Wu
	 * All Rights Reserved.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
	 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
	 *
	 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
	 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
	 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
	 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
	 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
	 *
	 * In addition, the following condition applies:
	 *
	 * All redistributions must retain an intact copy of this copyright notice
	 * and disclaimer.
	 */
	
	// (public) Constructor
	
	function BigInteger(a, b) {
	  if (a != null) this.fromString(a, b);
	}
	
	// return new, unset BigInteger
	function nbi() {
	  return new BigInteger(null);
	}
	
	// Bits per digit
	var dbits;
	
	// JavaScript engine analysis
	var canary = 0xdeadbeefcafe;
	var j_lm = (canary & 0xffffff) == 0xefcafe;
	
	// am: Compute w_j += (x*this_i), propagate carries,
	// c is initial carry, returns final carry.
	// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
	// We need to select the fastest one that works in this environment.
	
	// am1: use a single mult and divide to get the high bits,
	// max digit bits should be 26 because
	// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
	function am1(i, x, w, j, c, n) {
	  while (--n >= 0) {
	    var v = x * this[i++] + w[j] + c;
	    c = Math.floor(v / 0x4000000);
	    w[j++] = v & 0x3ffffff;
	  }
	  return c;
	}
	// am2 avoids a big mult-and-extract completely.
	// Max digit bits should be <= 30 because we do bitwise ops
	// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
	function am2(i, x, w, j, c, n) {
	  var xl = x & 0x7fff,
	      xh = x >> 15;
	  while (--n >= 0) {
	    var l = this[i] & 0x7fff;
	    var h = this[i++] >> 15;
	    var m = xh * l + h * xl;
	    l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
	    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
	    w[j++] = l & 0x3fffffff;
	  }
	  return c;
	}
	// Alternately, set max digit bits to 28 since some
	// browsers slow down when dealing with 32-bit numbers.
	function am3(i, x, w, j, c, n) {
	  var xl = x & 0x3fff,
	      xh = x >> 14;
	  while (--n >= 0) {
	    var l = this[i] & 0x3fff;
	    var h = this[i++] >> 14;
	    var m = xh * l + h * xl;
	    l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
	    c = (l >> 28) + (m >> 14) + xh * h;
	    w[j++] = l & 0xfffffff;
	  }
	  return c;
	}
	var inBrowser = typeof navigator !== "undefined";
	if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
	  BigInteger.prototype.am = am2;
	  dbits = 30;
	} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
	  BigInteger.prototype.am = am1;
	  dbits = 26;
	} else {
	  // Mozilla/Netscape seems to prefer am3
	  BigInteger.prototype.am = am3;
	  dbits = 28;
	}
	
	BigInteger.prototype.DB = dbits;
	BigInteger.prototype.DM = (1 << dbits) - 1;
	BigInteger.prototype.DV = 1 << dbits;
	
	var BI_FP = 52;
	BigInteger.prototype.FV = Math.pow(2, BI_FP);
	BigInteger.prototype.F1 = BI_FP - dbits;
	BigInteger.prototype.F2 = 2 * dbits - BI_FP;
	
	// Digit conversions
	var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
	var BI_RC = new Array();
	var rr, vv;
	rr = "0".charCodeAt(0);
	for (vv = 0; vv <= 9; ++vv) {
	  BI_RC[rr++] = vv;
	}rr = "a".charCodeAt(0);
	for (vv = 10; vv < 36; ++vv) {
	  BI_RC[rr++] = vv;
	}rr = "A".charCodeAt(0);
	for (vv = 10; vv < 36; ++vv) {
	  BI_RC[rr++] = vv;
	}function int2char(n) {
	  return BI_RM.charAt(n);
	}
	function intAt(s, i) {
	  var c = BI_RC[s.charCodeAt(i)];
	  return c == null ? -1 : c;
	}
	
	// (protected) copy this to r
	function bnpCopyTo(r) {
	  for (var i = this.t - 1; i >= 0; --i) {
	    r[i] = this[i];
	  }r.t = this.t;
	  r.s = this.s;
	}
	
	// (protected) set from integer value x, -DV <= x < DV
	function bnpFromInt(x) {
	  this.t = 1;
	  this.s = x < 0 ? -1 : 0;
	  if (x > 0) this[0] = x;else if (x < -1) this[0] = x + this.DV;else this.t = 0;
	}
	
	// return bigint initialized to value
	function nbv(i) {
	  var r = nbi();
	
	  r.fromInt(i);
	
	  return r;
	}
	
	// (protected) set from string and radix
	function bnpFromString(s, b) {
	  var k;
	  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
	  this.t = 0;
	  this.s = 0;
	  var i = s.length,
	      mi = false,
	      sh = 0;
	  while (--i >= 0) {
	    var x = intAt(s, i);
	    if (x < 0) {
	      if (s.charAt(i) == "-") mi = true;
	      continue;
	    }
	    mi = false;
	    if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {
	      this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
	      this[this.t++] = x >> this.DB - sh;
	    } else this[this.t - 1] |= x << sh;
	    sh += k;
	    if (sh >= this.DB) sh -= this.DB;
	  }
	  this.clamp();
	  if (mi) BigInteger.ZERO.subTo(this, this);
	}
	
	// (protected) clamp off excess high words
	function bnpClamp() {
	  var c = this.s & this.DM;
	  while (this.t > 0 && this[this.t - 1] == c) {
	    --this.t;
	  }
	}
	
	// (public) return string representation in given radix
	function bnToString(b) {
	  if (this.s < 0) return "-" + this.negate().toString();
	  var k;
	  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
	  var km = (1 << k) - 1,
	      d,
	      m = false,
	      r = "",
	      i = this.t;
	  var p = this.DB - i * this.DB % k;
	  if (i-- > 0) {
	    if (p < this.DB && (d = this[i] >> p) > 0) {
	      m = true;
	      r = int2char(d);
	    }
	    while (i >= 0) {
	      if (p < k) {
	        d = (this[i] & (1 << p) - 1) << k - p;
	        d |= this[--i] >> (p += this.DB - k);
	      } else {
	        d = this[i] >> (p -= k) & km;
	        if (p <= 0) {
	          p += this.DB;
	          --i;
	        }
	      }
	      if (d > 0) m = true;
	      if (m) r += int2char(d);
	    }
	  }
	  return m ? r : "0";
	}
	
	// (public) -this
	function bnNegate() {
	  var r = nbi();
	
	  BigInteger.ZERO.subTo(this, r);
	
	  return r;
	}
	
	// (public) |this|
	function bnAbs() {
	  return this.s < 0 ? this.negate() : this;
	}
	
	// (public) return + if this > a, - if this < a, 0 if equal
	function bnCompareTo(a) {
	  var r = this.s - a.s;
	  if (r != 0) return r;
	  var i = this.t;
	  r = i - a.t;
	  if (r != 0) return this.s < 0 ? -r : r;
	  while (--i >= 0) {
	    if ((r = this[i] - a[i]) != 0) return r;
	  }return 0;
	}
	
	// returns bit length of the integer x
	function nbits(x) {
	  var r = 1,
	      t;
	  if ((t = x >>> 16) != 0) {
	    x = t;
	    r += 16;
	  }
	  if ((t = x >> 8) != 0) {
	    x = t;
	    r += 8;
	  }
	  if ((t = x >> 4) != 0) {
	    x = t;
	    r += 4;
	  }
	  if ((t = x >> 2) != 0) {
	    x = t;
	    r += 2;
	  }
	  if ((t = x >> 1) != 0) {
	    x = t;
	    r += 1;
	  }
	  return r;
	}
	
	// (public) return the number of bits in "this"
	function bnBitLength() {
	  if (this.t <= 0) return 0;
	  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
	}
	
	// (protected) r = this << n*DB
	function bnpDLShiftTo(n, r) {
	  var i;
	  for (i = this.t - 1; i >= 0; --i) {
	    r[i + n] = this[i];
	  }for (i = n - 1; i >= 0; --i) {
	    r[i] = 0;
	  }r.t = this.t + n;
	  r.s = this.s;
	}
	
	// (protected) r = this >> n*DB
	function bnpDRShiftTo(n, r) {
	  for (var i = n; i < this.t; ++i) {
	    r[i - n] = this[i];
	  }r.t = Math.max(this.t - n, 0);
	  r.s = this.s;
	}
	
	// (protected) r = this << n
	function bnpLShiftTo(n, r) {
	  var bs = n % this.DB;
	  var cbs = this.DB - bs;
	  var bm = (1 << cbs) - 1;
	  var ds = Math.floor(n / this.DB),
	      c = this.s << bs & this.DM,
	      i;
	  for (i = this.t - 1; i >= 0; --i) {
	    r[i + ds + 1] = this[i] >> cbs | c;
	    c = (this[i] & bm) << bs;
	  }
	  for (i = ds - 1; i >= 0; --i) {
	    r[i] = 0;
	  }r[ds] = c;
	  r.t = this.t + ds + 1;
	  r.s = this.s;
	  r.clamp();
	}
	
	// (protected) r = this >> n
	function bnpRShiftTo(n, r) {
	  r.s = this.s;
	  var ds = Math.floor(n / this.DB);
	  if (ds >= this.t) {
	    r.t = 0;
	    return;
	  }
	  var bs = n % this.DB;
	  var cbs = this.DB - bs;
	  var bm = (1 << bs) - 1;
	  r[0] = this[ds] >> bs;
	  for (var i = ds + 1; i < this.t; ++i) {
	    r[i - ds - 1] |= (this[i] & bm) << cbs;
	    r[i - ds] = this[i] >> bs;
	  }
	  if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
	  r.t = this.t - ds;
	  r.clamp();
	}
	
	// (protected) r = this - a
	function bnpSubTo(a, r) {
	  var i = 0,
	      c = 0,
	      m = Math.min(a.t, this.t);
	  while (i < m) {
	    c += this[i] - a[i];
	    r[i++] = c & this.DM;
	    c >>= this.DB;
	  }
	  if (a.t < this.t) {
	    c -= a.s;
	    while (i < this.t) {
	      c += this[i];
	      r[i++] = c & this.DM;
	      c >>= this.DB;
	    }
	    c += this.s;
	  } else {
	    c += this.s;
	    while (i < a.t) {
	      c -= a[i];
	      r[i++] = c & this.DM;
	      c >>= this.DB;
	    }
	    c -= a.s;
	  }
	  r.s = c < 0 ? -1 : 0;
	  if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;
	  r.t = i;
	  r.clamp();
	}
	
	// (protected) r = this * a, r != this,a (HAC 14.12)
	// "this" should be the larger one if appropriate.
	function bnpMultiplyTo(a, r) {
	  var x = this.abs(),
	      y = a.abs();
	  var i = x.t;
	  r.t = i + y.t;
	  while (--i >= 0) {
	    r[i] = 0;
	  }for (i = 0; i < y.t; ++i) {
	    r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
	  }r.s = 0;
	  r.clamp();
	  if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
	}
	
	// (protected) r = this^2, r != this (HAC 14.16)
	function bnpSquareTo(r) {
	  var x = this.abs();
	  var i = r.t = 2 * x.t;
	  while (--i >= 0) {
	    r[i] = 0;
	  }for (i = 0; i < x.t - 1; ++i) {
	    var c = x.am(i, x[i], r, 2 * i, 0, 1);
	    if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
	      r[i + x.t] -= x.DV;
	      r[i + x.t + 1] = 1;
	    }
	  }
	  if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
	  r.s = 0;
	  r.clamp();
	}
	
	// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
	// r != q, this != m.  q or r may be null.
	function bnpDivRemTo(m, q, r) {
	  var pm = m.abs();
	  if (pm.t <= 0) return;
	  var pt = this.abs();
	  if (pt.t < pm.t) {
	    if (q != null) q.fromInt(0);
	    if (r != null) this.copyTo(r);
	    return;
	  }
	  if (r == null) r = nbi();
	  var y = nbi(),
	      ts = this.s,
	      ms = m.s;
	  var nsh = this.DB - nbits(pm[pm.t - 1]);
	  // normalize modulus
	  if (nsh > 0) {
	    pm.lShiftTo(nsh, y);
	    pt.lShiftTo(nsh, r);
	  } else {
	    pm.copyTo(y);
	    pt.copyTo(r);
	  }
	  var ys = y.t;
	  var y0 = y[ys - 1];
	  if (y0 == 0) return;
	  var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
	  var d1 = this.FV / yt,
	      d2 = (1 << this.F1) / yt,
	      e = 1 << this.F2;
	  var i = r.t,
	      j = i - ys,
	      t = q == null ? nbi() : q;
	  y.dlShiftTo(j, t);
	  if (r.compareTo(t) >= 0) {
	    r[r.t++] = 1;
	    r.subTo(t, r);
	  }
	  BigInteger.ONE.dlShiftTo(ys, t);
	  t.subTo(y, y);
	  // "negative" y so we can replace sub with am later
	  while (y.t < ys) {
	    y[y.t++] = 0;
	  }while (--j >= 0) {
	    // Estimate quotient digit
	    var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
	    if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
	      // Try it out
	      y.dlShiftTo(j, t);
	      r.subTo(t, r);
	      while (r[i] < --qd) {
	        r.subTo(t, r);
	      }
	    }
	  }
	  if (q != null) {
	    r.drShiftTo(ys, q);
	    if (ts != ms) BigInteger.ZERO.subTo(q, q);
	  }
	  r.t = ys;
	  r.clamp();
	  if (nsh > 0) r.rShiftTo(nsh, r);
	  // Denormalize remainder
	  if (ts < 0) BigInteger.ZERO.subTo(r, r);
	}
	
	// (public) this mod a
	function bnMod(a) {
	  var r = nbi();
	  this.abs().divRemTo(a, null, r);
	  if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
	  return r;
	}
	
	// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
	// justification:
	//         xy == 1 (mod m)
	//         xy =  1+km
	//   xy(2-xy) = (1+km)(1-km)
	// x[y(2-xy)] = 1-k^2m^2
	// x[y(2-xy)] == 1 (mod m^2)
	// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
	// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
	// JS multiply "overflows" differently from C/C++, so care is needed here.
	function bnpInvDigit() {
	  if (this.t < 1) return 0;
	  var x = this[0];
	  if ((x & 1) == 0) return 0;
	  var y = x & 3;
	  // y == 1/x mod 2^2
	  y = y * (2 - (x & 0xf) * y) & 0xf;
	  // y == 1/x mod 2^4
	  y = y * (2 - (x & 0xff) * y) & 0xff;
	  // y == 1/x mod 2^8
	  y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff;
	  // y == 1/x mod 2^16
	  // last step - calculate inverse mod DV directly;
	  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
	  y = y * (2 - x * y % this.DV) % this.DV;
	  // y == 1/x mod 2^dbits
	  // we really want the negative inverse, and -DV < y < DV
	  return y > 0 ? this.DV - y : -y;
	}
	
	function bnEquals(a) {
	  return this.compareTo(a) == 0;
	}
	
	// (protected) r = this + a
	function bnpAddTo(a, r) {
	  var i = 0,
	      c = 0,
	      m = Math.min(a.t, this.t);
	  while (i < m) {
	    c += this[i] + a[i];
	    r[i++] = c & this.DM;
	    c >>= this.DB;
	  }
	  if (a.t < this.t) {
	    c += a.s;
	    while (i < this.t) {
	      c += this[i];
	      r[i++] = c & this.DM;
	      c >>= this.DB;
	    }
	    c += this.s;
	  } else {
	    c += this.s;
	    while (i < a.t) {
	      c += a[i];
	      r[i++] = c & this.DM;
	      c >>= this.DB;
	    }
	    c += a.s;
	  }
	  r.s = c < 0 ? -1 : 0;
	  if (c > 0) r[i++] = c;else if (c < -1) r[i++] = this.DV + c;
	  r.t = i;
	  r.clamp();
	}
	
	// (public) this + a
	function bnAdd(a) {
	  var r = nbi();
	
	  this.addTo(a, r);
	
	  return r;
	}
	
	// (public) this - a
	function bnSubtract(a) {
	  var r = nbi();
	
	  this.subTo(a, r);
	
	  return r;
	}
	
	// (public) this * a
	function bnMultiply(a) {
	  var r = nbi();
	
	  this.multiplyTo(a, r);
	
	  return r;
	}
	
	// (public) this / a
	function bnDivide(a) {
	  var r = nbi();
	
	  this.divRemTo(a, r, null);
	
	  return r;
	}
	
	// Montgomery reduction
	function Montgomery(m) {
	  this.m = m;
	  this.mp = m.invDigit();
	  this.mpl = this.mp & 0x7fff;
	  this.mph = this.mp >> 15;
	  this.um = (1 << m.DB - 15) - 1;
	  this.mt2 = 2 * m.t;
	}
	
	// xR mod m
	function montConvert(x) {
	  var r = nbi();
	  x.abs().dlShiftTo(this.m.t, r);
	  r.divRemTo(this.m, null, r);
	  if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
	  return r;
	}
	
	// x/R mod m
	function montRevert(x) {
	  var r = nbi();
	  x.copyTo(r);
	  this.reduce(r);
	  return r;
	}
	
	// x = x/R mod m (HAC 14.32)
	function montReduce(x) {
	  while (x.t <= this.mt2) {
	    // pad x so am has enough room later
	    x[x.t++] = 0;
	  }for (var i = 0; i < this.m.t; ++i) {
	    // faster way of calculating u0 = x[i]*mp mod DV
	    var j = x[i] & 0x7fff;
	    var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
	    // use am to combine the multiply-shift-add into one call
	    j = i + this.m.t;
	    x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
	    // propagate carry
	    while (x[j] >= x.DV) {
	      x[j] -= x.DV;
	      x[++j]++;
	    }
	  }
	  x.clamp();
	  x.drShiftTo(this.m.t, x);
	  if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
	}
	
	// r = "x^2/R mod m"; x != r
	function montSqrTo(x, r) {
	  x.squareTo(r);
	
	  this.reduce(r);
	}
	
	// r = "xy/R mod m"; x,y != r
	function montMulTo(x, y, r) {
	  x.multiplyTo(y, r);
	
	  this.reduce(r);
	}
	
	Montgomery.prototype.convert = montConvert;
	Montgomery.prototype.revert = montRevert;
	Montgomery.prototype.reduce = montReduce;
	Montgomery.prototype.mulTo = montMulTo;
	Montgomery.prototype.sqrTo = montSqrTo;
	
	// (public) this^e % m (HAC 14.85)
	function bnModPow(e, m, callback) {
	  var i = e.bitLength(),
	      k,
	      r = nbv(1),
	      z = new Montgomery(m);
	  if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6;
	
	  // precomputation
	  var g = new Array(),
	      n = 3,
	      k1 = k - 1,
	      km = (1 << k) - 1;
	  g[1] = z.convert(this);
	  if (k > 1) {
	    var g2 = nbi();
	    z.sqrTo(g[1], g2);
	    while (n <= km) {
	      g[n] = nbi();
	      z.mulTo(g2, g[n - 2], g[n]);
	      n += 2;
	    }
	  }
	
	  var j = e.t - 1,
	      w,
	      is1 = true,
	      r2 = nbi(),
	      t;
	  i = nbits(e[j]) - 1;
	  while (j >= 0) {
	    if (i >= k1) w = e[j] >> i - k1 & km;else {
	      w = (e[j] & (1 << i + 1) - 1) << k1 - i;
	      if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
	    }
	
	    n = k;
	    while ((w & 1) == 0) {
	      w >>= 1;
	      --n;
	    }
	    if ((i -= n) < 0) {
	      i += this.DB;
	      --j;
	    }
	    if (is1) {
	      // ret == 1, don't bother squaring or multiplying it
	      g[w].copyTo(r);
	      is1 = false;
	    } else {
	      while (n > 1) {
	        z.sqrTo(r, r2);
	        z.sqrTo(r2, r);
	        n -= 2;
	      }
	      if (n > 0) z.sqrTo(r, r2);else {
	        t = r;
	        r = r2;
	        r2 = t;
	      }
	      z.mulTo(r2, g[w], r);
	    }
	
	    while (j >= 0 && (e[j] & 1 << i) == 0) {
	      z.sqrTo(r, r2);
	      t = r;
	      r = r2;
	      r2 = t;
	      if (--i < 0) {
	        i = this.DB - 1;
	        --j;
	      }
	    }
	  }
	  var result = z.revert(r);
	  callback(null, result);
	  return result;
	}
	
	// protected
	BigInteger.prototype.copyTo = bnpCopyTo;
	BigInteger.prototype.fromInt = bnpFromInt;
	BigInteger.prototype.fromString = bnpFromString;
	BigInteger.prototype.clamp = bnpClamp;
	BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
	BigInteger.prototype.drShiftTo = bnpDRShiftTo;
	BigInteger.prototype.lShiftTo = bnpLShiftTo;
	BigInteger.prototype.rShiftTo = bnpRShiftTo;
	BigInteger.prototype.subTo = bnpSubTo;
	BigInteger.prototype.multiplyTo = bnpMultiplyTo;
	BigInteger.prototype.squareTo = bnpSquareTo;
	BigInteger.prototype.divRemTo = bnpDivRemTo;
	BigInteger.prototype.invDigit = bnpInvDigit;
	BigInteger.prototype.addTo = bnpAddTo;
	
	// public
	BigInteger.prototype.toString = bnToString;
	BigInteger.prototype.negate = bnNegate;
	BigInteger.prototype.abs = bnAbs;
	BigInteger.prototype.compareTo = bnCompareTo;
	BigInteger.prototype.bitLength = bnBitLength;
	BigInteger.prototype.mod = bnMod;
	BigInteger.prototype.equals = bnEquals;
	BigInteger.prototype.add = bnAdd;
	BigInteger.prototype.subtract = bnSubtract;
	BigInteger.prototype.multiply = bnMultiply;
	BigInteger.prototype.divide = bnDivide;
	BigInteger.prototype.modPow = bnModPow;
	
	// "constants"
	BigInteger.ZERO = nbv(0);
	BigInteger.ONE = nbv(1);

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CognitoJwtToken2 = __webpack_require__(397);
	
	var _CognitoJwtToken3 = _interopRequireDefault(_CognitoJwtToken2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 Amazon.com,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may not use this file except in compliance with the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License. A copy of the License is located at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://aws.amazon.com/asl/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * or in the "license" file accompanying this file. This file is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/** @class */
	var CognitoAccessToken = function (_CognitoJwtToken) {
	  _inherits(CognitoAccessToken, _CognitoJwtToken);
	
	  /**
	   * Constructs a new CognitoAccessToken object
	   * @param {string=} AccessToken The JWT access token.
	   */
	  function CognitoAccessToken() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        AccessToken = _ref.AccessToken;
	
	    _classCallCheck(this, CognitoAccessToken);
	
	    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, AccessToken || ''));
	  }
	
	  return CognitoAccessToken;
	}(_CognitoJwtToken3.default);
	
	exports.default = CognitoAccessToken;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CognitoJwtToken2 = __webpack_require__(397);
	
	var _CognitoJwtToken3 = _interopRequireDefault(_CognitoJwtToken2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 Amazon.com,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may not use this file except in compliance with the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * License. A copy of the License is located at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://aws.amazon.com/asl/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * or in the "license" file accompanying this file. This file is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/** @class */
	var CognitoIdToken = function (_CognitoJwtToken) {
	  _inherits(CognitoIdToken, _CognitoJwtToken);
	
	  /**
	   * Constructs a new CognitoIdToken object
	   * @param {string=} IdToken The JWT Id token
	   */
	  function CognitoIdToken() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        IdToken = _ref.IdToken;
	
	    _classCallCheck(this, CognitoIdToken);
	
	    return _possibleConstructorReturn(this, _CognitoJwtToken.call(this, IdToken || ''));
	  }
	
	  return CognitoIdToken;
	}(_CognitoJwtToken3.default);
	
	exports.default = CognitoIdToken;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _global = __webpack_require__(269);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
	                                                                                                                                                           * Copyright 2016 Amazon.com,
	                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                           *
	                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                           * You may not use this file except in compliance with the
	                                                                                                                                                           * License. A copy of the License is located at
	                                                                                                                                                           *
	                                                                                                                                                           *     http://aws.amazon.com/asl/
	                                                                                                                                                           *
	                                                                                                                                                           * or in the "license" file accompanying this file. This file is
	                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                           * for the specific language governing permissions and
	                                                                                                                                                           * limitations under the License.
	                                                                                                                                                           */
	
	/** @class */
	var CognitoJwtToken = function () {
	  /**
	   * Constructs a new CognitoJwtToken object
	   * @param {string=} token The JWT token.
	   */
	  function CognitoJwtToken(token) {
	    _classCallCheck(this, CognitoJwtToken);
	
	    // Assign object
	    this.jwtToken = token || '';
	    this.payload = this.decodePayload();
	  }
	
	  /**
	   * @returns {string} the record's token.
	   */
	
	
	  CognitoJwtToken.prototype.getJwtToken = function getJwtToken() {
	    return this.jwtToken;
	  };
	
	  /**
	   * @returns {int} the token's expiration (exp member).
	   */
	
	
	  CognitoJwtToken.prototype.getExpiration = function getExpiration() {
	    return this.payload.exp;
	  };
	
	  /**
	   * @returns {int} the token's "issued at" (iat member).
	   */
	
	
	  CognitoJwtToken.prototype.getIssuedAt = function getIssuedAt() {
	    return this.payload.iat;
	  };
	
	  /**
	   * @returns {object} the token's payload.
	   */
	
	
	  CognitoJwtToken.prototype.decodePayload = function decodePayload() {
	    var payload = this.jwtToken.split('.')[1];
	    try {
	      return JSON.parse(_global.util.base64.decode(payload).toString('utf8'));
	    } catch (err) {
	      return {};
	    }
	  };
	
	  return CognitoJwtToken;
	}();
	
	exports.default = CognitoJwtToken;

/***/ },
/* 398 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var CognitoRefreshToken = function () {
	  /**
	   * Constructs a new CognitoRefreshToken object
	   * @param {string=} RefreshToken The JWT refresh token.
	   */
	  function CognitoRefreshToken() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        RefreshToken = _ref.RefreshToken;
	
	    _classCallCheck(this, CognitoRefreshToken);
	
	    // Assign object
	    this.token = RefreshToken || '';
	  }
	
	  /**
	   * @returns {string} the record's token.
	   */
	
	
	  CognitoRefreshToken.prototype.getToken = function getToken() {
	    return this.token;
	  };
	
	  return CognitoRefreshToken;
	}();
	
	exports.default = CognitoRefreshToken;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _global = __webpack_require__(269);
	
	var _BigInteger = __webpack_require__(394);
	
	var _BigInteger2 = _interopRequireDefault(_BigInteger);
	
	var _AuthenticationHelper = __webpack_require__(393);
	
	var _AuthenticationHelper2 = _interopRequireDefault(_AuthenticationHelper);
	
	var _CognitoAccessToken = __webpack_require__(395);
	
	var _CognitoAccessToken2 = _interopRequireDefault(_CognitoAccessToken);
	
	var _CognitoIdToken = __webpack_require__(396);
	
	var _CognitoIdToken2 = _interopRequireDefault(_CognitoIdToken);
	
	var _CognitoRefreshToken = __webpack_require__(398);
	
	var _CognitoRefreshToken2 = _interopRequireDefault(_CognitoRefreshToken);
	
	var _CognitoUserSession = __webpack_require__(401);
	
	var _CognitoUserSession2 = _interopRequireDefault(_CognitoUserSession);
	
	var _DateHelper = __webpack_require__(402);
	
	var _DateHelper2 = _interopRequireDefault(_DateHelper);
	
	var _CognitoUserAttribute = __webpack_require__(400);
	
	var _CognitoUserAttribute2 = _interopRequireDefault(_CognitoUserAttribute);
	
	var _StorageHelper = __webpack_require__(403);
	
	var _StorageHelper2 = _interopRequireDefault(_StorageHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
	                                                                                                                                                           * Copyright 2016 Amazon.com,
	                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                           *
	                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                           * You may not use this file except in compliance with the
	                                                                                                                                                           * License. A copy of the License is located at
	                                                                                                                                                           *
	                                                                                                                                                           *     http://aws.amazon.com/asl/
	                                                                                                                                                           *
	                                                                                                                                                           * or in the "license" file accompanying this file. This file is
	                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                           * for the specific language governing permissions and
	                                                                                                                                                           * limitations under the License.
	                                                                                                                                                           */
	
	/**
	 * @callback nodeCallback
	 * @template T result
	 * @param {*} err The operation failure reason, or null.
	 * @param {T} result The operation result.
	 */
	
	/**
	 * @callback onFailure
	 * @param {*} err Failure reason.
	 */
	
	/**
	 * @callback onSuccess
	 * @template T result
	 * @param {T} result The operation result.
	 */
	
	/**
	 * @callback mfaRequired
	 * @param {*} details MFA challenge details.
	 */
	
	/**
	 * @callback customChallenge
	 * @param {*} details Custom challenge details.
	 */
	
	/**
	 * @callback inputVerificationCode
	 * @param {*} data Server response.
	 */
	
	/**
	 * @callback authSuccess
	 * @param {CognitoUserSession} session The new session.
	 * @param {bool=} userConfirmationNecessary User must be confirmed.
	 */
	
	/** @class */
	var CognitoUser = function () {
	  /**
	   * Constructs a new CognitoUser object
	   * @param {object} data Creation options
	   * @param {string} data.Username The user's username.
	   * @param {CognitoUserPool} data.Pool Pool containing the user.
	   * @param {object} data.Storage Optional storage object.
	   */
	  function CognitoUser(data) {
	    _classCallCheck(this, CognitoUser);
	
	    if (data == null || data.Username == null || data.Pool == null) {
	      throw new Error('Username and pool information are required.');
	    }
	
	    this.username = data.Username || '';
	    this.pool = data.Pool;
	    this.Session = null;
	
	    this.client = data.Pool.client;
	
	    this.signInUserSession = null;
	    this.authenticationFlowType = 'USER_SRP_AUTH';
	
	    this.storage = data.Storage || new _StorageHelper2.default().getStorage();
	  }
	
	  /**
	   * Sets the session for this user
	   * @param {CognitoUserSession} signInUserSession the session
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.setSignInUserSession = function setSignInUserSession(signInUserSession) {
	    this.clearCachedTokens();
	    this.signInUserSession = signInUserSession;
	    this.cacheTokens();
	  };
	
	  /**
	   * @returns {CognitoUserSession} the current session for this user
	   */
	
	
	  CognitoUser.prototype.getSignInUserSession = function getSignInUserSession() {
	    return this.signInUserSession;
	  };
	
	  /**
	   * @returns {string} the user's username
	   */
	
	
	  CognitoUser.prototype.getUsername = function getUsername() {
	    return this.username;
	  };
	
	  /**
	   * @returns {String} the authentication flow type
	   */
	
	
	  CognitoUser.prototype.getAuthenticationFlowType = function getAuthenticationFlowType() {
	    return this.authenticationFlowType;
	  };
	
	  /**
	   * sets authentication flow type
	   * @param {string} authenticationFlowType New value.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
	    this.authenticationFlowType = authenticationFlowType;
	  };
	
	  /**
	   * This is used for authenticating the user through the custom authentication flow.
	   * @param {AuthenticationDetails} authDetails Contains the authentication data
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {customChallenge} callback.customChallenge Custom challenge
	   *        response required to continue.
	   * @param {authSuccess} callback.onSuccess Called on success with the new session.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.initiateAuth = function initiateAuth(authDetails, callback) {
	    var _this = this;
	
	    var authParameters = authDetails.getAuthParameters();
	    authParameters.USERNAME = this.username;
	
	    var jsonReq = {
	      AuthFlow: 'CUSTOM_AUTH',
	      ClientId: this.pool.getClientId(),
	      AuthParameters: authParameters,
	      ClientMetadata: authDetails.getValidationData()
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	
	    this.client.makeUnauthenticatedRequest('initiateAuth', jsonReq, function (err, data) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      var challengeName = data.ChallengeName;
	      var challengeParameters = data.ChallengeParameters;
	
	      if (challengeName === 'CUSTOM_CHALLENGE') {
	        _this.Session = data.Session;
	        return callback.customChallenge(challengeParameters);
	      }
	      _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);
	      _this.cacheTokens();
	      return callback.onSuccess(_this.signInUserSession);
	    });
	  };
	
	  /**
	   * This is used for authenticating the user. it calls the AuthenticationHelper for SRP related
	   * stuff
	   * @param {AuthenticationDetails} authDetails Contains the authentication data
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {newPasswordRequired} callback.newPasswordRequired new
	   *        password and any required attributes are required to continue
	   * @param {mfaRequired} callback.mfaRequired MFA code
	   *        required to continue.
	   * @param {customChallenge} callback.customChallenge Custom challenge
	   *        response required to continue.
	   * @param {authSuccess} callback.onSuccess Called on success with the new session.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.authenticateUser = function authenticateUser(authDetails, callback) {
	    var _this2 = this;
	
	    var authenticationHelper = new _AuthenticationHelper2.default(this.pool.getUserPoolId().split('_')[1]);
	    var dateHelper = new _DateHelper2.default();
	
	    var serverBValue = void 0;
	    var salt = void 0;
	    var authParameters = {};
	
	    if (this.deviceKey != null) {
	      authParameters.DEVICE_KEY = this.deviceKey;
	    }
	
	    authParameters.USERNAME = this.username;
	    authenticationHelper.getLargeAValue(function (errOnAValue, aValue) {
	      // getLargeAValue callback start
	      if (errOnAValue) {
	        callback.onFailure(errOnAValue);
	      }
	
	      authParameters.SRP_A = aValue.toString(16);
	
	      if (_this2.authenticationFlowType === 'CUSTOM_AUTH') {
	        authParameters.CHALLENGE_NAME = 'SRP_A';
	      }
	
	      var jsonReq = {
	        AuthFlow: _this2.authenticationFlowType,
	        ClientId: _this2.pool.getClientId(),
	        AuthParameters: authParameters,
	        ClientMetadata: authDetails.getValidationData()
	      };
	      if (_this2.getUserContextData(_this2.username)) {
	        jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
	      }
	
	      _this2.client.makeUnauthenticatedRequest('initiateAuth', jsonReq, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	
	        var challengeParameters = data.ChallengeParameters;
	
	        _this2.username = challengeParameters.USER_ID_FOR_SRP;
	        serverBValue = new _BigInteger2.default(challengeParameters.SRP_B, 16);
	        salt = new _BigInteger2.default(challengeParameters.SALT, 16);
	        _this2.getCachedDeviceKeyAndPassword();
	
	        authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function (errOnHkdf, hkdf) {
	          // getPasswordAuthenticationKey callback start
	          if (errOnHkdf) {
	            callback.onFailure(errOnHkdf);
	          }
	
	          var dateNow = dateHelper.getNowString();
	
	          var signatureString = _global.util.crypto.hmac(hkdf, _global.util.buffer.concat([new _global.util.Buffer(_this2.pool.getUserPoolId().split('_')[1], 'utf8'), new _global.util.Buffer(_this2.username, 'utf8'), new _global.util.Buffer(challengeParameters.SECRET_BLOCK, 'base64'), new _global.util.Buffer(dateNow, 'utf8')]), 'base64', 'sha256');
	
	          var challengeResponses = {};
	
	          challengeResponses.USERNAME = _this2.username;
	          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
	          challengeResponses.TIMESTAMP = dateNow;
	          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
	
	          if (_this2.deviceKey != null) {
	            challengeResponses.DEVICE_KEY = _this2.deviceKey;
	          }
	
	          var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
	            return _this2.client.makeUnauthenticatedRequest('respondToAuthChallenge', challenge, function (errChallenge, dataChallenge) {
	              if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
	                challengeResponses.DEVICE_KEY = null;
	                _this2.deviceKey = null;
	                _this2.randomPassword = null;
	                _this2.deviceGroupKey = null;
	                _this2.clearCachedDeviceKeyAndPassword();
	                return respondToAuthChallenge(challenge, challengeCallback);
	              }
	              return challengeCallback(errChallenge, dataChallenge);
	            });
	          };
	
	          var jsonReqResp = {
	            ChallengeName: 'PASSWORD_VERIFIER',
	            ClientId: _this2.pool.getClientId(),
	            ChallengeResponses: challengeResponses,
	            Session: data.Session
	          };
	          if (_this2.getUserContextData()) {
	            jsonReqResp.UserContextData = _this2.getUserContextData();
	          }
	          respondToAuthChallenge(jsonReqResp, function (errAuthenticate, dataAuthenticate) {
	            if (errAuthenticate) {
	              return callback.onFailure(errAuthenticate);
	            }
	
	            var challengeName = dataAuthenticate.ChallengeName;
	            if (challengeName === 'NEW_PASSWORD_REQUIRED') {
	              _this2.Session = dataAuthenticate.Session;
	              var userAttributes = null;
	              var rawRequiredAttributes = null;
	              var requiredAttributes = [];
	              var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
	
	              if (dataAuthenticate.ChallengeParameters) {
	                userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
	                rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
	              }
	
	              if (rawRequiredAttributes) {
	                for (var i = 0; i < rawRequiredAttributes.length; i++) {
	                  requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
	                }
	              }
	              return callback.newPasswordRequired(userAttributes, requiredAttributes);
	            }
	            return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
	          });
	          return undefined;
	          // getPasswordAuthenticationKey callback end
	        });
	        return undefined;
	      });
	      // getLargeAValue callback end
	    });
	  };
	
	  /**
	  * PRIVATE ONLY: This is an internal only method and should not
	  * be directly called by the consumers.
	  * @param {object} dataAuthenticate authentication data
	  * @param {object} authenticationHelper helper created
	  * @param {callback} callback passed on from caller
	  * @returns {void}
	  */
	
	
	  CognitoUser.prototype.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
	    var _this3 = this;
	
	    var challengeName = dataAuthenticate.ChallengeName;
	    var challengeParameters = dataAuthenticate.ChallengeParameters;
	
	    if (challengeName === 'SMS_MFA') {
	      this.Session = dataAuthenticate.Session;
	      return callback.mfaRequired(challengeName, challengeParameters);
	    }
	
	    if (challengeName === 'SELECT_MFA_TYPE') {
	      this.Session = dataAuthenticate.Session;
	      return callback.selectMFAType(challengeName, challengeParameters);
	    }
	
	    if (challengeName === 'MFA_SETUP') {
	      this.Session = dataAuthenticate.Session;
	      return callback.mfaSetup(challengeName, challengeParameters);
	    }
	
	    if (challengeName === 'SOFTWARE_TOKEN_MFA') {
	      this.Session = dataAuthenticate.Session;
	      return callback.totpRequired(challengeName, challengeParameters);
	    }
	
	    if (challengeName === 'CUSTOM_CHALLENGE') {
	      this.Session = dataAuthenticate.Session;
	      return callback.customChallenge(challengeParameters);
	    }
	
	    if (challengeName === 'DEVICE_SRP_AUTH') {
	      this.getDeviceResponse(callback);
	      return undefined;
	    }
	
	    this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
	    this.cacheTokens();
	
	    var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
	    if (newDeviceMetadata == null) {
	      return callback.onSuccess(this.signInUserSession);
	    }
	
	    authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
	      if (errGenHash) {
	        return callback.onFailure(errGenHash);
	      }
	
	      var deviceSecretVerifierConfig = {
	        Salt: new _global.util.Buffer(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
	        PasswordVerifier: new _global.util.Buffer(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
	      };
	
	      _this3.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
	      _this3.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
	      _this3.randomPassword = authenticationHelper.getRandomPassword();
	
	      _this3.client.makeUnauthenticatedRequest('confirmDevice', {
	        DeviceKey: newDeviceMetadata.DeviceKey,
	        AccessToken: _this3.signInUserSession.getAccessToken().getJwtToken(),
	        DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
	        DeviceName: navigator.userAgent
	      }, function (errConfirm, dataConfirm) {
	        if (errConfirm) {
	          return callback.onFailure(errConfirm);
	        }
	
	        _this3.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
	        _this3.cacheDeviceKeyAndPassword();
	        if (dataConfirm.UserConfirmationNecessary === true) {
	          return callback.onSuccess(_this3.signInUserSession, dataConfirm.UserConfirmationNecessary);
	        }
	        return callback.onSuccess(_this3.signInUserSession);
	      });
	      return undefined;
	    });
	    return undefined;
	  };
	
	  /**
	  * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
	  * Pass the new password with any new user attributes to be updated.
	  * User attribute keys must be of format userAttributes.<attribute_name>.
	  * @param {string} newPassword new password for this user
	  * @param {object} requiredAttributeData map with values for all required attributes
	  * @param {object} callback Result callback map.
	  * @param {onFailure} callback.onFailure Called on any error.
	  * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
	  * @param {customChallenge} callback.customChallenge Custom challenge
	  *         response required to continue.
	  * @param {authSuccess} callback.onSuccess Called on success with the new session.
	  * @returns {void}
	  */
	
	
	  CognitoUser.prototype.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback) {
	    var _this4 = this;
	
	    if (!newPassword) {
	      return callback.onFailure(new Error('New password is required.'));
	    }
	    var authenticationHelper = new _AuthenticationHelper2.default(this.pool.getUserPoolId().split('_')[1]);
	    var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
	
	    var finalUserAttributes = {};
	    if (requiredAttributeData) {
	      Object.keys(requiredAttributeData).forEach(function (key) {
	        finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
	      });
	    }
	
	    finalUserAttributes.NEW_PASSWORD = newPassword;
	    finalUserAttributes.USERNAME = this.username;
	    var jsonReq = {
	      ChallengeName: 'NEW_PASSWORD_REQUIRED',
	      ClientId: this.pool.getClientId(),
	      ChallengeResponses: finalUserAttributes,
	      Session: this.Session
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	
	    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (errAuthenticate, dataAuthenticate) {
	      if (errAuthenticate) {
	        return callback.onFailure(errAuthenticate);
	      }
	      return _this4.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to get a session using device authentication. It is called at the end of user
	   * authentication
	   *
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {authSuccess} callback.onSuccess Called on success with the new session.
	   * @returns {void}
	   * @private
	   */
	
	
	  CognitoUser.prototype.getDeviceResponse = function getDeviceResponse(callback) {
	    var _this5 = this;
	
	    var authenticationHelper = new _AuthenticationHelper2.default(this.deviceGroupKey);
	    var dateHelper = new _DateHelper2.default();
	
	    var authParameters = {};
	
	    authParameters.USERNAME = this.username;
	    authParameters.DEVICE_KEY = this.deviceKey;
	    authenticationHelper.getLargeAValue(function (errAValue, aValue) {
	      // getLargeAValue callback start
	      if (errAValue) {
	        callback.onFailure(errAValue);
	      }
	
	      authParameters.SRP_A = aValue.toString(16);
	
	      var jsonReq = {
	        ChallengeName: 'DEVICE_SRP_AUTH',
	        ClientId: _this5.pool.getClientId(),
	        ChallengeResponses: authParameters
	      };
	      if (_this5.getUserContextData()) {
	        jsonReq.UserContextData = _this5.getUserContextData();
	      }
	      _this5.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	
	        var challengeParameters = data.ChallengeParameters;
	
	        var serverBValue = new _BigInteger2.default(challengeParameters.SRP_B, 16);
	        var salt = new _BigInteger2.default(challengeParameters.SALT, 16);
	
	        authenticationHelper.getPasswordAuthenticationKey(_this5.deviceKey, _this5.randomPassword, serverBValue, salt, function (errHkdf, hkdf) {
	          // getPasswordAuthenticationKey callback start
	          if (errHkdf) {
	            return callback.onFailure(errHkdf);
	          }
	
	          var dateNow = dateHelper.getNowString();
	
	          var signatureString = _global.util.crypto.hmac(hkdf, _global.util.buffer.concat([new _global.util.Buffer(_this5.deviceGroupKey, 'utf8'), new _global.util.Buffer(_this5.deviceKey, 'utf8'), new _global.util.Buffer(challengeParameters.SECRET_BLOCK, 'base64'), new _global.util.Buffer(dateNow, 'utf8')]), 'base64', 'sha256');
	
	          var challengeResponses = {};
	
	          challengeResponses.USERNAME = _this5.username;
	          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
	          challengeResponses.TIMESTAMP = dateNow;
	          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
	          challengeResponses.DEVICE_KEY = _this5.deviceKey;
	
	          var jsonReqResp = {
	            ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
	            ClientId: _this5.pool.getClientId(),
	            ChallengeResponses: challengeResponses,
	            Session: data.Session
	          };
	          if (_this5.getUserContextData()) {
	            jsonReqResp.UserContextData = _this5.getUserContextData();
	          }
	
	          _this5.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReqResp, function (errAuthenticate, dataAuthenticate) {
	            if (errAuthenticate) {
	              return callback.onFailure(errAuthenticate);
	            }
	
	            _this5.signInUserSession = _this5.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
	            _this5.cacheTokens();
	
	            return callback.onSuccess(_this5.signInUserSession);
	          });
	          return undefined;
	          // getPasswordAuthenticationKey callback end
	        });
	        return undefined;
	      });
	      // getLargeAValue callback end
	    });
	  };
	
	  /**
	   * This is used for a certain user to confirm the registration by using a confirmation code
	   * @param {string} confirmationCode Code entered by user.
	   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback) {
	    var jsonReq = {
	      ClientId: this.pool.getClientId(),
	      ConfirmationCode: confirmationCode,
	      Username: this.username,
	      ForceAliasCreation: forceAliasCreation
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	    this.client.makeUnauthenticatedRequest('confirmSignUp', jsonReq, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, 'SUCCESS');
	    });
	  };
	
	  /**
	   * This is used by the user once he has the responses to a custom challenge
	   * @param {string} answerChallenge The custom challange answer.
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {customChallenge} callback.customChallenge
	   *    Custom challenge response required to continue.
	   * @param {authSuccess} callback.onSuccess Called on success with the new session.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback) {
	    var _this6 = this;
	
	    var challengeResponses = {};
	    challengeResponses.USERNAME = this.username;
	    challengeResponses.ANSWER = answerChallenge;
	    var jsonReq = {
	      ChallengeName: 'CUSTOM_CHALLENGE',
	      ChallengeResponses: challengeResponses,
	      ClientId: this.pool.getClientId(),
	      Session: this.Session
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, data) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	
	      var challengeName = data.ChallengeName;
	
	      if (challengeName === 'CUSTOM_CHALLENGE') {
	        _this6.Session = data.Session;
	        return callback.customChallenge(data.ChallengeParameters);
	      }
	
	      _this6.signInUserSession = _this6.getCognitoUserSession(data.AuthenticationResult);
	      _this6.cacheTokens();
	      return callback.onSuccess(_this6.signInUserSession);
	    });
	  };
	
	  /**
	   * This is used by the user once he has an MFA code
	   * @param {string} confirmationCode The MFA code entered by the user.
	   * @param {object} callback Result callback map.
	   * @param {string} mfaType The mfa we are replying to.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {authSuccess} callback.onSuccess Called on success with the new session.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType) {
	    var _this7 = this;
	
	    var challengeResponses = {};
	    challengeResponses.USERNAME = this.username;
	    challengeResponses.SMS_MFA_CODE = confirmationCode;
	    var mfaTypeSelection = mfaType || 'SMS_MFA';
	    if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') {
	      challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
	    }
	
	    if (this.deviceKey != null) {
	      challengeResponses.DEVICE_KEY = this.deviceKey;
	    }
	
	    var jsonReq = {
	      ChallengeName: mfaTypeSelection,
	      ChallengeResponses: challengeResponses,
	      ClientId: this.pool.getClientId(),
	      Session: this.Session
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	
	    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, dataAuthenticate) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	
	      var challengeName = dataAuthenticate.ChallengeName;
	
	      if (challengeName === 'DEVICE_SRP_AUTH') {
	        _this7.getDeviceResponse(callback);
	        return undefined;
	      }
	
	      _this7.signInUserSession = _this7.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
	      _this7.cacheTokens();
	
	      if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
	        return callback.onSuccess(_this7.signInUserSession);
	      }
	
	      var authenticationHelper = new _AuthenticationHelper2.default(_this7.pool.getUserPoolId().split('_')[1]);
	      authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
	        if (errGenHash) {
	          return callback.onFailure(errGenHash);
	        }
	
	        var deviceSecretVerifierConfig = {
	          Salt: new _global.util.Buffer(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
	          PasswordVerifier: new _global.util.Buffer(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
	        };
	
	        _this7.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
	        _this7.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
	        _this7.randomPassword = authenticationHelper.getRandomPassword();
	
	        _this7.client.makeUnauthenticatedRequest('confirmDevice', {
	          DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
	          AccessToken: _this7.signInUserSession.getAccessToken().getJwtToken(),
	          DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
	          DeviceName: navigator.userAgent
	        }, function (errConfirm, dataConfirm) {
	          if (errConfirm) {
	            return callback.onFailure(errConfirm);
	          }
	
	          _this7.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
	          _this7.cacheDeviceKeyAndPassword();
	          if (dataConfirm.UserConfirmationNecessary === true) {
	            return callback.onSuccess(_this7.signInUserSession, dataConfirm.UserConfirmationNecessary);
	          }
	          return callback.onSuccess(_this7.signInUserSession);
	        });
	        return undefined;
	      });
	      return undefined;
	    });
	  };
	
	  /**
	   * This is used by an authenticated user to change the current password
	   * @param {string} oldUserPassword The current password.
	   * @param {string} newUserPassword The requested new password.
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.changePassword = function changePassword(oldUserPassword, newUserPassword, callback) {
	    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    this.client.makeUnauthenticatedRequest('changePassword', {
	      PreviousPassword: oldUserPassword,
	      ProposedPassword: newUserPassword,
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, 'SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by an authenticated user to enable MFA for himself
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.enableMFA = function enableMFA(callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    var mfaOptions = [];
	    var mfaEnabled = {
	      DeliveryMedium: 'SMS',
	      AttributeName: 'phone_number'
	    };
	    mfaOptions.push(mfaEnabled);
	
	    this.client.makeUnauthenticatedRequest('setUserSettings', {
	      MFAOptions: mfaOptions,
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, 'SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by an authenticated user to enable MFA for himself
	   * @param {string[]} smsMfaSettings the sms mfa settings
	   * @param {string[]} softwareTokenMfaSettings the software token mfa settings
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    this.client.makeUnauthenticatedRequest('setUserMFAPreference', {
	      SMSMfaSettings: smsMfaSettings,
	      SoftwareTokenMfaSettings: softwareTokenMfaSettings,
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, 'SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by an authenticated user to disable MFA for himself
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.disableMFA = function disableMFA(callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    var mfaOptions = [];
	
	    this.client.makeUnauthenticatedRequest('setUserSettings', {
	      MFAOptions: mfaOptions,
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, 'SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by an authenticated user to delete himself
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.deleteUser = function deleteUser(callback) {
	    var _this8 = this;
	
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    this.client.makeUnauthenticatedRequest('deleteUser', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      _this8.clearCachedTokens();
	      return callback(null, 'SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * @typedef {CognitoUserAttribute | { Name:string, Value:string }} AttributeArg
	   */
	  /**
	   * This is used by an authenticated user to change a list of attributes
	   * @param {AttributeArg[]} attributes A list of the new user attributes.
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.updateAttributes = function updateAttributes(attributes, callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    this.client.makeUnauthenticatedRequest('updateUserAttributes', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	      UserAttributes: attributes
	    }, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, 'SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by an authenticated user to get a list of attributes
	   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.getUserAttributes = function getUserAttributes(callback) {
	    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    this.client.makeUnauthenticatedRequest('getUser', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err, userData) {
	      if (err) {
	        return callback(err, null);
	      }
	
	      var attributeList = [];
	
	      for (var i = 0; i < userData.UserAttributes.length; i++) {
	        var attribute = {
	          Name: userData.UserAttributes[i].Name,
	          Value: userData.UserAttributes[i].Value
	        };
	        var userAttribute = new _CognitoUserAttribute2.default(attribute);
	        attributeList.push(userAttribute);
	      }
	
	      return callback(null, attributeList);
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by an authenticated user to get the MFAOptions
	   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.getMFAOptions = function getMFAOptions(callback) {
	    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    this.client.makeUnauthenticatedRequest('getUser', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err, userData) {
	      if (err) {
	        return callback(err, null);
	      }
	
	      return callback(null, userData.MFAOptions);
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by an authenticated user to delete a list of attributes
	   * @param {string[]} attributeList Names of the attributes to delete.
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.deleteAttributes = function deleteAttributes(attributeList, callback) {
	    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	      return callback(new Error('User is not authenticated'), null);
	    }
	
	    this.client.makeUnauthenticatedRequest('deleteUserAttributes', {
	      UserAttributeNames: attributeList,
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, 'SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used by a user to resend a confirmation code
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.resendConfirmationCode = function resendConfirmationCode(callback) {
	    var jsonReq = {
	      ClientId: this.pool.getClientId(),
	      Username: this.username
	    };
	
	    this.client.makeUnauthenticatedRequest('resendConfirmationCode', jsonReq, function (err, result) {
	      if (err) {
	        return callback(err, null);
	      }
	      return callback(null, result);
	    });
	  };
	
	  /**
	   * This is used to get a session, either from the session object
	   * or from  the local storage, or by using a refresh token
	   *
	   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.getSession = function getSession(callback) {
	    if (this.username == null) {
	      return callback(new Error('Username is null. Cannot retrieve a new session'), null);
	    }
	
	    if (this.signInUserSession != null && this.signInUserSession.isValid()) {
	      return callback(null, this.signInUserSession);
	    }
	
	    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	    var idTokenKey = keyPrefix + '.idToken';
	    var accessTokenKey = keyPrefix + '.accessToken';
	    var refreshTokenKey = keyPrefix + '.refreshToken';
	    var clockDriftKey = keyPrefix + '.clockDrift';
	
	    if (this.storage.getItem(idTokenKey)) {
	      var idToken = new _CognitoIdToken2.default({
	        IdToken: this.storage.getItem(idTokenKey)
	      });
	      var accessToken = new _CognitoAccessToken2.default({
	        AccessToken: this.storage.getItem(accessTokenKey)
	      });
	      var refreshToken = new _CognitoRefreshToken2.default({
	        RefreshToken: this.storage.getItem(refreshTokenKey)
	      });
	      var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
	
	      var sessionData = {
	        IdToken: idToken,
	        AccessToken: accessToken,
	        RefreshToken: refreshToken,
	        ClockDrift: clockDrift
	      };
	      var cachedSession = new _CognitoUserSession2.default(sessionData);
	      if (cachedSession.isValid()) {
	        this.signInUserSession = cachedSession;
	        return callback(null, this.signInUserSession);
	      }
	
	      if (refreshToken.getToken() == null) {
	        return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
	      }
	
	      this.refreshSession(refreshToken, callback);
	    } else {
	      callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
	    }
	
	    return undefined;
	  };
	
	  /**
	   * This uses the refreshToken to retrieve a new session
	   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
	   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.refreshSession = function refreshSession(refreshToken, callback) {
	    var _this9 = this;
	
	    var authParameters = {};
	    authParameters.REFRESH_TOKEN = refreshToken.getToken();
	    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
	    var lastUserKey = keyPrefix + '.LastAuthUser';
	
	    if (this.storage.getItem(lastUserKey)) {
	      this.username = this.storage.getItem(lastUserKey);
	      var deviceKeyKey = keyPrefix + '.' + this.username + '.deviceKey';
	      this.deviceKey = this.storage.getItem(deviceKeyKey);
	      authParameters.DEVICE_KEY = this.deviceKey;
	    }
	
	    var jsonReq = {
	      ClientId: this.pool.getClientId(),
	      AuthFlow: 'REFRESH_TOKEN_AUTH',
	      AuthParameters: authParameters
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	    this.client.makeUnauthenticatedRequest('initiateAuth', jsonReq, function (err, authResult) {
	      if (err) {
	        if (err.code === 'NotAuthorizedException') {
	          _this9.clearCachedTokens();
	        }
	        return callback(err, null);
	      }
	      if (authResult) {
	        var authenticationResult = authResult.AuthenticationResult;
	        if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) {
	          authenticationResult.RefreshToken = refreshToken.getToken();
	        }
	        _this9.signInUserSession = _this9.getCognitoUserSession(authenticationResult);
	        _this9.cacheTokens();
	        return callback(null, _this9.signInUserSession);
	      }
	      return undefined;
	    });
	  };
	
	  /**
	   * This is used to save the session tokens to local storage
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.cacheTokens = function cacheTokens() {
	    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
	    var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
	    var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
	    var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
	    var clockDriftKey = keyPrefix + '.' + this.username + '.clockDrift';
	    var lastUserKey = keyPrefix + '.LastAuthUser';
	
	    this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
	    this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
	    this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
	    this.storage.setItem(clockDriftKey, '' + this.signInUserSession.getClockDrift());
	    this.storage.setItem(lastUserKey, this.username);
	  };
	
	  /**
	   * This is used to cache the device key and device group and device password
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
	    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	    var deviceKeyKey = keyPrefix + '.deviceKey';
	    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
	    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';
	
	    this.storage.setItem(deviceKeyKey, this.deviceKey);
	    this.storage.setItem(randomPasswordKey, this.randomPassword);
	    this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
	  };
	
	  /**
	   * This is used to get current device key and device group and device password
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
	    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	    var deviceKeyKey = keyPrefix + '.deviceKey';
	    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
	    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';
	
	    if (this.storage.getItem(deviceKeyKey)) {
	      this.deviceKey = this.storage.getItem(deviceKeyKey);
	      this.randomPassword = this.storage.getItem(randomPasswordKey);
	      this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
	    }
	  };
	
	  /**
	   * This is used to clear the device key info from local storage
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
	    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	    var deviceKeyKey = keyPrefix + '.deviceKey';
	    var randomPasswordKey = keyPrefix + '.randomPasswordKey';
	    var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';
	
	    this.storage.removeItem(deviceKeyKey);
	    this.storage.removeItem(randomPasswordKey);
	    this.storage.removeItem(deviceGroupKeyKey);
	  };
	
	  /**
	   * This is used to clear the session tokens from local storage
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.clearCachedTokens = function clearCachedTokens() {
	    var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
	    var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
	    var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
	    var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
	    var lastUserKey = keyPrefix + '.LastAuthUser';
	
	    this.storage.removeItem(idTokenKey);
	    this.storage.removeItem(accessTokenKey);
	    this.storage.removeItem(refreshTokenKey);
	    this.storage.removeItem(lastUserKey);
	  };
	
	  /**
	   * This is used to build a user session from tokens retrieved in the authentication result
	   * @param {object} authResult Successful auth response from server.
	   * @returns {CognitoUserSession} The new user session.
	   * @private
	   */
	
	
	  CognitoUser.prototype.getCognitoUserSession = function getCognitoUserSession(authResult) {
	    var idToken = new _CognitoIdToken2.default(authResult);
	    var accessToken = new _CognitoAccessToken2.default(authResult);
	    var refreshToken = new _CognitoRefreshToken2.default(authResult);
	
	    var sessionData = {
	      IdToken: idToken,
	      AccessToken: accessToken,
	      RefreshToken: refreshToken
	    };
	
	    return new _CognitoUserSession2.default(sessionData);
	  };
	
	  /**
	   * This is used to initiate a forgot password request
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {inputVerificationCode?} callback.inputVerificationCode
	   *    Optional callback raised instead of onSuccess with response data.
	   * @param {onSuccess} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.forgotPassword = function forgotPassword(callback) {
	    var jsonReq = {
	      ClientId: this.pool.getClientId(),
	      Username: this.username
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	    this.client.makeUnauthenticatedRequest('forgotPassword', jsonReq, function (err, data) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      if (typeof callback.inputVerificationCode === 'function') {
	        return callback.inputVerificationCode(data);
	      }
	      return callback.onSuccess(data);
	    });
	  };
	
	  /**
	   * This is used to confirm a new password using a confirmationCode
	   * @param {string} confirmationCode Code entered by user.
	   * @param {string} newPassword Confirm new password.
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<void>} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback) {
	    var jsonReq = {
	      ClientId: this.pool.getClientId(),
	      Username: this.username,
	      ConfirmationCode: confirmationCode,
	      Password: newPassword
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	    this.client.makeUnauthenticatedRequest('confirmForgotPassword', jsonReq, function (err) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      return callback.onSuccess();
	    });
	  };
	
	  /**
	   * This is used to initiate an attribute confirmation request
	   * @param {string} attributeName User attribute that needs confirmation.
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('getUserAttributeVerificationCode', {
	      AttributeName: attributeName,
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err, data) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      if (typeof callback.inputVerificationCode === 'function') {
	        return callback.inputVerificationCode(data);
	      }
	      return callback.onSuccess();
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to confirm an attribute using a confirmation code
	   * @param {string} attributeName Attribute being confirmed.
	   * @param {string} confirmationCode Code entered by user.
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<string>} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('verifyUserAttribute', {
	      AttributeName: attributeName,
	      Code: confirmationCode,
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      return callback.onSuccess('SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to get the device information using the current device key
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.getDevice = function getDevice(callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('getDevice', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	      DeviceKey: this.deviceKey
	    }, function (err, data) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      return callback.onSuccess(data);
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to forget a specific device
	   * @param {string} deviceKey Device key.
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<string>} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('forgetDevice', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	      DeviceKey: deviceKey
	    }, function (err) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      return callback.onSuccess('SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to forget the current device
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<string>} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.forgetDevice = function forgetDevice(callback) {
	    var _this10 = this;
	
	    this.forgetSpecificDevice(this.deviceKey, {
	      onFailure: callback.onFailure,
	      onSuccess: function onSuccess(result) {
	        _this10.deviceKey = null;
	        _this10.deviceGroupKey = null;
	        _this10.randomPassword = null;
	        _this10.clearCachedDeviceKeyAndPassword();
	        return callback.onSuccess(result);
	      }
	    });
	  };
	
	  /**
	   * This is used to set the device status as remembered
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<string>} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('updateDeviceStatus', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	      DeviceKey: this.deviceKey,
	      DeviceRememberedStatus: 'remembered'
	    }, function (err) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      return callback.onSuccess('SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to set the device status as not remembered
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<string>} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('updateDeviceStatus', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	      DeviceKey: this.deviceKey,
	      DeviceRememberedStatus: 'not_remembered'
	    }, function (err) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      return callback.onSuccess('SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to list all devices for a user
	   *
	   * @param {int} limit the number of devices returned in a call
	   * @param {string} paginationToken the pagination token in case any was returned before
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.listDevices = function listDevices(limit, paginationToken, callback) {
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('listDevices', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	      Limit: limit,
	      PaginationToken: paginationToken
	    }, function (err, data) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      return callback.onSuccess(data);
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used to globally revoke all tokens issued to a user
	   * @param {object} callback Result callback map.
	   * @param {onFailure} callback.onFailure Called on any error.
	   * @param {onSuccess<string>} callback.onSuccess Called on success.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.globalSignOut = function globalSignOut(callback) {
	    var _this11 = this;
	
	    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	      return callback.onFailure(new Error('User is not authenticated'));
	    }
	
	    this.client.makeUnauthenticatedRequest('globalSignOut', {
	      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	    }, function (err) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      _this11.clearCachedTokens();
	      return callback.onSuccess('SUCCESS');
	    });
	    return undefined;
	  };
	
	  /**
	   * This is used for the user to signOut of the application and clear the cached tokens.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.signOut = function signOut() {
	    this.signInUserSession = null;
	    this.clearCachedTokens();
	  };
	
	  /**
	   * This is used by a user trying to select a given MFA
	   * @param {string} answerChallenge the mfa the user wants
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
	    var _this12 = this;
	
	    var challengeResponses = {};
	    challengeResponses.USERNAME = this.username;
	    challengeResponses.ANSWER = answerChallenge;
	
	    var jsonReq = {
	      ChallengeName: 'SELECT_MFA_TYPE',
	      ChallengeResponses: challengeResponses,
	      ClientId: this.pool.getClientId(),
	      Session: this.Session
	    };
	    if (this.getUserContextData()) {
	      jsonReq.UserContextData = this.getUserContextData();
	    }
	    this.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (err, data) {
	      if (err) {
	        return callback.onFailure(err);
	      }
	      _this12.Session = data.Session;
	      if (answerChallenge === 'SMS_MFA') {
	        return callback.mfaRequired(data.challengeName, data.challengeParameters);
	      }
	      if (answerChallenge === 'SOFTWARE_TOKEN_MFA') {
	        return callback.totpRequired(data.challengeName, data.challengeParameters);
	      }
	      return undefined;
	    });
	  };
	
	  /**
	   * This returns the user context data for advanced security feature.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.getUserContextData = function getUserContextData() {
	    var pool = this.pool;
	    return pool.getUserContextData(this.username);
	  };
	
	  /**
	   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.associateSoftwareToken = function associateSoftwareToken(callback) {
	    var _this13 = this;
	
	    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	      this.client.makeUnauthenticatedRequest('associateSoftwareToken', {
	        Session: this.Session
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        _this13.Session = data.Session;
	        return callback.associateSecretCode(data.SecretCode);
	      });
	    } else {
	      this.client.makeUnauthenticatedRequest('associateSoftwareToken', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.associateSecretCode(data.SecretCode);
	      });
	    }
	  };
	
	  /**
	   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
	   * @param {string} totpCode The MFA code entered by the user.
	   * @param {string} friendlyDeviceName The device name we are assigning to the device.
	   * @param {nodeCallback<string>} callback Called on success or error.
	   * @returns {void}
	   */
	
	
	  CognitoUser.prototype.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
	    var _this14 = this;
	
	    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	      this.client.makeUnauthenticatedRequest('verifySoftwareToken', {
	        Session: this.Session,
	        UserCode: totpCode,
	        FriendlyDeviceName: friendlyDeviceName
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        _this14.Session = data.Session;
	        var challengeResponses = {};
	        challengeResponses.USERNAME = _this14.username;
	        var jsonReq = {
	          ChallengeName: 'MFA_SETUP',
	          ClientId: _this14.pool.getClientId(),
	          ChallengeResponses: challengeResponses,
	          Session: _this14.Session
	        };
	        if (_this14.getUserContextData()) {
	          jsonReq.UserContextData = _this14.getUserContextData();
	        }
	        _this14.client.makeUnauthenticatedRequest('respondToAuthChallenge', jsonReq, function (errRespond, dataRespond) {
	          if (errRespond) {
	            return callback.onFailure(errRespond);
	          }
	          _this14.signInUserSession = _this14.getCognitoUserSession(dataRespond.AuthenticationResult);
	          _this14.cacheTokens();
	          return callback.onSuccess(_this14.signInUserSession);
	        });
	        return undefined;
	      });
	    } else {
	      this.client.makeUnauthenticatedRequest('verifySoftwareToken', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	        UserCode: totpCode,
	        FriendlyDeviceName: friendlyDeviceName
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback(null, data);
	      });
	    }
	  };
	
	  return CognitoUser;
	}();
	
	exports.default = CognitoUser;

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var CognitoUserAttribute = function () {
	  /**
	   * Constructs a new CognitoUserAttribute object
	   * @param {string=} Name The record's name
	   * @param {string=} Value The record's value
	   */
	  function CognitoUserAttribute() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        Name = _ref.Name,
	        Value = _ref.Value;
	
	    _classCallCheck(this, CognitoUserAttribute);
	
	    this.Name = Name || '';
	    this.Value = Value || '';
	  }
	
	  /**
	   * @returns {string} the record's value.
	   */
	
	
	  CognitoUserAttribute.prototype.getValue = function getValue() {
	    return this.Value;
	  };
	
	  /**
	   * Sets the record's value.
	   * @param {string} value The new value.
	   * @returns {CognitoUserAttribute} The record for method chaining.
	   */
	
	
	  CognitoUserAttribute.prototype.setValue = function setValue(value) {
	    this.Value = value;
	    return this;
	  };
	
	  /**
	   * @returns {string} the record's name.
	   */
	
	
	  CognitoUserAttribute.prototype.getName = function getName() {
	    return this.Name;
	  };
	
	  /**
	   * Sets the record's name
	   * @param {string} name The new name.
	   * @returns {CognitoUserAttribute} The record for method chaining.
	   */
	
	
	  CognitoUserAttribute.prototype.setName = function setName(name) {
	    this.Name = name;
	    return this;
	  };
	
	  /**
	   * @returns {string} a string representation of the record.
	   */
	
	
	  CognitoUserAttribute.prototype.toString = function toString() {
	    return JSON.stringify(this);
	  };
	
	  /**
	   * @returns {object} a flat object representing the record.
	   */
	
	
	  CognitoUserAttribute.prototype.toJSON = function toJSON() {
	    return {
	      Name: this.Name,
	      Value: this.Value
	    };
	  };
	
	  return CognitoUserAttribute;
	}();
	
	exports.default = CognitoUserAttribute;

/***/ },
/* 401 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var CognitoUserSession = function () {
	  /**
	   * Constructs a new CognitoUserSession object
	   * @param {CognitoIdToken} IdToken The session's Id token.
	   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
	   * @param {CognitoAccessToken} AccessToken The session's access token.
	   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
	   */
	  function CognitoUserSession() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        IdToken = _ref.IdToken,
	        RefreshToken = _ref.RefreshToken,
	        AccessToken = _ref.AccessToken,
	        ClockDrift = _ref.ClockDrift;
	
	    _classCallCheck(this, CognitoUserSession);
	
	    if (AccessToken == null || IdToken == null) {
	      throw new Error('Id token and Access Token must be present.');
	    }
	
	    this.idToken = IdToken;
	    this.refreshToken = RefreshToken;
	    this.accessToken = AccessToken;
	    this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
	  }
	
	  /**
	   * @returns {CognitoIdToken} the session's Id token
	   */
	
	
	  CognitoUserSession.prototype.getIdToken = function getIdToken() {
	    return this.idToken;
	  };
	
	  /**
	   * @returns {CognitoRefreshToken} the session's refresh token
	   */
	
	
	  CognitoUserSession.prototype.getRefreshToken = function getRefreshToken() {
	    return this.refreshToken;
	  };
	
	  /**
	   * @returns {CognitoAccessToken} the session's access token
	   */
	
	
	  CognitoUserSession.prototype.getAccessToken = function getAccessToken() {
	    return this.accessToken;
	  };
	
	  /**
	   * @returns {int} the session's clock drift
	   */
	
	
	  CognitoUserSession.prototype.getClockDrift = function getClockDrift() {
	    return this.clockDrift;
	  };
	
	  /**
	   * @returns {int} the computer's clock drift
	   */
	
	
	  CognitoUserSession.prototype.calculateClockDrift = function calculateClockDrift() {
	    var now = Math.floor(new Date() / 1000);
	    var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
	
	    return now - iat;
	  };
	
	  /**
	   * Checks to see if the session is still valid based on session expiry information found
	   * in tokens and the current time (adjusted with clock drift)
	   * @returns {boolean} if the session is still valid
	   */
	
	
	  CognitoUserSession.prototype.isValid = function isValid() {
	    var now = Math.floor(new Date() / 1000);
	    var adjusted = now - this.clockDrift;
	
	    return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
	  };
	
	  return CognitoUserSession;
	}();
	
	exports.default = CognitoUserSession;

/***/ },
/* 402 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	
	/** @class */
	
	var DateHelper = function () {
	  function DateHelper() {
	    _classCallCheck(this, DateHelper);
	  }
	
	  /**
	   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
	   */
	  DateHelper.prototype.getNowString = function getNowString() {
	    var now = new Date();
	
	    var weekDay = weekNames[now.getUTCDay()];
	    var month = monthNames[now.getUTCMonth()];
	    var day = now.getUTCDate();
	
	    var hours = now.getUTCHours();
	    if (hours < 10) {
	      hours = '0' + hours;
	    }
	
	    var minutes = now.getUTCMinutes();
	    if (minutes < 10) {
	      minutes = '0' + minutes;
	    }
	
	    var seconds = now.getUTCSeconds();
	    if (seconds < 10) {
	      seconds = '0' + seconds;
	    }
	
	    var year = now.getUTCFullYear();
	
	    // ddd MMM D HH:mm:ss UTC YYYY
	    var dateNow = weekDay + ' ' + month + ' ' + day + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC ' + year;
	
	    return dateNow;
	  };
	
	  return DateHelper;
	}();
	
	exports.default = DateHelper;

/***/ },
/* 403 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var dataMemory = {};
	
	/** @class */
	
	var MemoryStorage = function () {
	  function MemoryStorage() {
	    _classCallCheck(this, MemoryStorage);
	  }
	
	  /**
	   * This is used to set a specific item in storage
	   * @param {string} key - the key for the item
	   * @param {object} value - the value
	   * @returns {string} value that was set
	   */
	  MemoryStorage.setItem = function setItem(key, value) {
	    dataMemory[key] = value;
	    return dataMemory[key];
	  };
	
	  /**
	   * This is used to get a specific key from storage
	   * @param {string} key - the key for the item
	   * This is used to clear the storage
	   * @returns {string} the data item
	   */
	
	
	  MemoryStorage.getItem = function getItem(key) {
	    return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
	  };
	
	  /**
	   * This is used to remove an item from storage
	   * @param {string} key - the key being set
	   * @returns {string} value - value that was deleted
	   */
	
	
	  MemoryStorage.removeItem = function removeItem(key) {
	    return delete dataMemory[key];
	  };
	
	  /**
	   * This is used to clear the storage
	   * @returns {string} nothing
	   */
	
	
	  MemoryStorage.clear = function clear() {
	    dataMemory = {};
	    return dataMemory;
	  };
	
	  return MemoryStorage;
	}();
	
	/** @class */
	
	
	var StorageHelper = function () {
	
	  /**
	   * This is used to get a storage object
	   * @returns {object} the storage
	   */
	  function StorageHelper() {
	    _classCallCheck(this, StorageHelper);
	
	    try {
	      this.storageWindow = window.localStorage;
	      this.storageWindow.setItem('aws.cognito.test-ls', 1);
	      this.storageWindow.removeItem('aws.cognito.test-ls');
	    } catch (exception) {
	      this.storageWindow = MemoryStorage;
	    }
	  }
	
	  /**
	   * This is used to return the storage
	   * @returns {object} the storage
	   */
	
	
	  StorageHelper.prototype.getStorage = function getStorage() {
	    return this.storageWindow;
	  };
	
	  return StorageHelper;
	}();
	
	exports.default = StorageHelper;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AuthenticationDetails = __webpack_require__(870);
	
	Object.defineProperty(exports, 'AuthenticationDetails', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AuthenticationDetails).default;
	  }
	});
	
	var _AuthenticationHelper = __webpack_require__(393);
	
	Object.defineProperty(exports, 'AuthenticationHelper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AuthenticationHelper).default;
	  }
	});
	
	var _CognitoAccessToken = __webpack_require__(395);
	
	Object.defineProperty(exports, 'CognitoAccessToken', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoAccessToken).default;
	  }
	});
	
	var _CognitoIdToken = __webpack_require__(396);
	
	Object.defineProperty(exports, 'CognitoIdToken', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoIdToken).default;
	  }
	});
	
	var _CognitoRefreshToken = __webpack_require__(398);
	
	Object.defineProperty(exports, 'CognitoRefreshToken', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoRefreshToken).default;
	  }
	});
	
	var _CognitoUser = __webpack_require__(399);
	
	Object.defineProperty(exports, 'CognitoUser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUser).default;
	  }
	});
	
	var _CognitoUserAttribute = __webpack_require__(400);
	
	Object.defineProperty(exports, 'CognitoUserAttribute', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUserAttribute).default;
	  }
	});
	
	var _CognitoUserPool = __webpack_require__(871);
	
	Object.defineProperty(exports, 'CognitoUserPool', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUserPool).default;
	  }
	});
	
	var _CognitoUserSession = __webpack_require__(401);
	
	Object.defineProperty(exports, 'CognitoUserSession', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUserSession).default;
	  }
	});
	
	var _CookieStorage = __webpack_require__(872);
	
	Object.defineProperty(exports, 'CookieStorage', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CookieStorage).default;
	  }
	});
	
	var _DateHelper = __webpack_require__(402);
	
	Object.defineProperty(exports, 'DateHelper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateHelper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The version of crypto-browserify included by aws-sdk only
	// checks for window.crypto, not window.msCrypto as used by
	// IE 11 – so we set it explicitly here
	if (typeof window !== 'undefined' && !window.crypto && window.msCrypto) {
	  window.crypto = window.msCrypto;
	}

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	
	/**
	 * Represents your AWS security credentials, specifically the
	 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
	 * Creating a `Credentials` object allows you to pass around your
	 * security information to configuration and service objects.
	 *
	 * Note that this class typically does not need to be constructed manually,
	 * as the {AWS.Config} and {AWS.Service} classes both accept simple
	 * options hashes with the three keys. These structures will be converted
	 * into Credentials objects automatically.
	 *
	 * ## Expiring and Refreshing Credentials
	 *
	 * Occasionally credentials can expire in the middle of a long-running
	 * application. In this case, the SDK will automatically attempt to
	 * refresh the credentials from the storage location if the Credentials
	 * class implements the {refresh} method.
	 *
	 * If you are implementing a credential storage location, you
	 * will want to create a subclass of the `Credentials` class and
	 * override the {refresh} method. This method allows credentials to be
	 * retrieved from the backing store, be it a file system, database, or
	 * some network storage. The method should reset the credential attributes
	 * on the object.
	 *
	 * @!attribute expired
	 *   @return [Boolean] whether the credentials have been expired and
	 *     require a refresh. Used in conjunction with {expireTime}.
	 * @!attribute expireTime
	 *   @return [Date] a time when credentials should be considered expired. Used
	 *     in conjunction with {expired}.
	 * @!attribute accessKeyId
	 *   @return [String] the AWS access key ID
	 * @!attribute secretAccessKey
	 *   @return [String] the AWS secret access key
	 * @!attribute sessionToken
	 *   @return [String] an optional AWS session token
	 */
	AWS.Credentials = AWS.util.inherit({
	  /**
	   * A credentials object can be created using positional arguments or an options
	   * hash.
	   *
	   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
	   *   Creates a Credentials object with a given set of credential information
	   *   as positional arguments.
	   *   @param accessKeyId [String] the AWS access key ID
	   *   @param secretAccessKey [String] the AWS secret access key
	   *   @param sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
	   * @overload AWS.Credentials(options)
	   *   Creates a Credentials object with a given set of credential information
	   *   as an options hash.
	   *   @option options accessKeyId [String] the AWS access key ID
	   *   @option options secretAccessKey [String] the AWS secret access key
	   *   @option options sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials({
	   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
	   *     });
	   */
	  constructor: function Credentials() {
	    // hide secretAccessKey from being displayed with util.inspect
	    AWS.util.hideProperties(this, ['secretAccessKey']);
	
	    this.expired = false;
	    this.expireTime = null;
	    if (arguments.length === 1 && typeof arguments[0] === 'object') {
	      var creds = arguments[0].credentials || arguments[0];
	      this.accessKeyId = creds.accessKeyId;
	      this.secretAccessKey = creds.secretAccessKey;
	      this.sessionToken = creds.sessionToken;
	    } else {
	      this.accessKeyId = arguments[0];
	      this.secretAccessKey = arguments[1];
	      this.sessionToken = arguments[2];
	    }
	  },
	
	  /**
	   * @return [Integer] the number of seconds before {expireTime} during which
	   *   the credentials will be considered expired.
	   */
	  expiryWindow: 15,
	
	  /**
	   * @return [Boolean] whether the credentials object should call {refresh}
	   * @note Subclasses should override this method to provide custom refresh
	   *   logic.
	   */
	  needsRefresh: function needsRefresh() {
	    var currentTime = AWS.util.date.getDate().getTime();
	    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);
	
	    if (this.expireTime && adjustedTime > this.expireTime) {
	      return true;
	    } else {
	      return this.expired || !this.accessKeyId || !this.secretAccessKey;
	    }
	  },
	
	  /**
	   * Gets the existing credentials, refreshing them if they are not yet loaded
	   * or have expired. Users should call this method before using {refresh},
	   * as this will not attempt to reload credentials when they are already
	   * loaded into the object.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means either credentials
	   *   do not need to be refreshed or refreshed credentials information has
	   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
	   *   and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   */
	  get: function get(callback) {
	    var self = this;
	    if (this.needsRefresh()) {
	      this.refresh(function(err) {
	        if (!err) self.expired = false; // reset expired flag
	        if (callback) callback(err);
	      });
	    } else if (callback) {
	      callback();
	    }
	  },
	
	  /**
	   * @!method  getPromise()
	   *   Returns a 'thenable' promise.
	   *   Gets the existing credentials, refreshing them if they are not yet loaded
	   *   or have expired. Users should call this method before using {refresh},
	   *   as this will not attempt to reload credentials when they are already
	   *   loaded into the object.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means either credentials do not need to be refreshed or refreshed
	   *     credentials information has been loaded into the object (as the
	   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `get` call.
	   *   @example Calling the `getPromise` method.
	   *     var promise = credProvider.getPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * @!method  refreshPromise()
	   *   Returns a 'thenable' promise.
	   *   Refreshes the credentials. Users should call {get} before attempting
	   *   to forcibly refresh credentials.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means refreshed credentials information has been loaded into the object
	   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `refresh` call.
	   *   @example Calling the `refreshPromise` method.
	   *     var promise = credProvider.refreshPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * Refreshes the credentials. Users should call {get} before attempting
	   * to forcibly refresh credentials.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means refreshed
	   *   credentials information has been loaded into the object (as the
	   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @note Subclasses should override this class to reset the
	   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
	   *   on the credentials object and then call the callback with
	   *   any error information.
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.expired = false;
	    callback();
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
	  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.getPromise;
	  delete this.prototype.refreshPromise;
	};
	
	AWS.util.addPromises(AWS.Credentials);


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	
	/**
	 * Creates a credential provider chain that searches for AWS credentials
	 * in a list of credential providers specified by the {providers} property.
	 *
	 * By default, the chain will use the {defaultProviders} to resolve credentials.
	 * These providers will look in the environment using the
	 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
	 *
	 * ## Setting Providers
	 *
	 * Each provider in the {providers} list should be a function that returns
	 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
	 * form allows for delayed execution of the credential construction.
	 *
	 * ## Resolving Credentials from a Chain
	 *
	 * Call {resolve} to return the first valid credential object that can be
	 * loaded by the provider chain.
	 *
	 * For example, to resolve a chain with a custom provider that checks a file
	 * on disk after the set of {defaultProviders}:
	 *
	 * ```javascript
	 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
	 * var chain = new AWS.CredentialProviderChain();
	 * chain.providers.push(diskProvider);
	 * chain.resolve();
	 * ```
	 *
	 * The above code will return the `diskProvider` object if the
	 * file contains credentials and the `defaultProviders` do not contain
	 * any credential settings.
	 *
	 * @!attribute providers
	 *   @return [Array<AWS.Credentials, Function>]
	 *     a list of credentials objects or functions that return credentials
	 *     objects. If the provider is a function, the function will be
	 *     executed lazily when the provider needs to be checked for valid
	 *     credentials. By default, this object will be set to the
	 *     {defaultProviders}.
	 *   @see defaultProviders
	 */
	AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {
	
	  /**
	   * Creates a new CredentialProviderChain with a default set of providers
	   * specified by {defaultProviders}.
	   */
	  constructor: function CredentialProviderChain(providers) {
	    if (providers) {
	      this.providers = providers;
	    } else {
	      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
	    }
	  },
	
	  /**
	   * @!method  resolvePromise()
	   *   Returns a 'thenable' promise.
	   *   Resolves the provider chain by searching for the first set of
	   *   credentials in {providers}.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(credentials)
	   *     Called if the promise is fulfilled and the provider resolves the chain
	   *     to a credentials object
	   *     @param credentials [AWS.Credentials] the credentials object resolved
	   *       by the provider chain.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param err [Error] the error object returned if no credentials are found.
	   *   @return [Promise] A promise that represents the state of the `resolve` method call.
	   *   @example Calling the `resolvePromise` method.
	   *     var promise = chain.resolvePromise();
	   *     promise.then(function(credentials) { ... }, function(err) { ... });
	   */
	
	  /**
	   * Resolves the provider chain by searching for the first set of
	   * credentials in {providers}.
	   *
	   * @callback callback function(err, credentials)
	   *   Called when the provider resolves the chain to a credentials object
	   *   or null if no credentials can be found.
	   *
	   *   @param err [Error] the error object returned if no credentials are
	   *     found.
	   *   @param credentials [AWS.Credentials] the credentials object resolved
	   *     by the provider chain.
	   * @return [AWS.CredentialProviderChain] the provider, for chaining.
	   */
	  resolve: function resolve(callback) {
	    if (this.providers.length === 0) {
	      callback(new Error('No providers'));
	      return this;
	    }
	
	    var index = 0;
	    var providers = this.providers.slice(0);
	
	    function resolveNext(err, creds) {
	      if ((!err && creds) || index === providers.length) {
	        callback(err, creds);
	        return;
	      }
	
	      var provider = providers[index++];
	      if (typeof provider === 'function') {
	        creds = provider.call();
	      } else {
	        creds = provider;
	      }
	
	      if (creds.get) {
	        creds.get(function(getErr) {
	          resolveNext(getErr, getErr ? null : creds);
	        });
	      } else {
	        resolveNext(null, creds);
	      }
	    }
	
	    resolveNext();
	    return this;
	  }
	});
	
	/**
	 * The default set of providers used by a vanilla CredentialProviderChain.
	 *
	 * In the browser:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = []
	 * ```
	 *
	 * In Node.js:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = [
	 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
	 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
	 *   function () { return new AWS.SharedIniFileCredentials(); },
	 *   function () {
	 *     // if AWS_CONTAINER_CREDENTIALS_RELATIVE_URI is set
	 *       return new AWS.ECSCredentials();
	 *     // else
	 *       return new AWS.EC2MetadataCredentials();
	 *   }
	 * ]
	 * ```
	 */
	AWS.CredentialProviderChain.defaultProviders = [];
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.resolvePromise;
	};
	
	AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var inherit = AWS.util.inherit;
	
	/**
	 * The endpoint that a service will talk to, for example,
	 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
	 * you need to override an endpoint for a service, you can
	 * set the endpoint on a service by passing the endpoint
	 * object with the `endpoint` option key:
	 *
	 * ```javascript
	 * var ep = new AWS.Endpoint('awsproxy.example.com');
	 * var s3 = new AWS.S3({endpoint: ep});
	 * s3.service.endpoint.hostname == 'awsproxy.example.com'
	 * ```
	 *
	 * Note that if you do not specify a protocol, the protocol will
	 * be selected based on your current {AWS.config} configuration.
	 *
	 * @!attribute protocol
	 *   @return [String] the protocol (http or https) of the endpoint
	 *     URL
	 * @!attribute hostname
	 *   @return [String] the host portion of the endpoint, e.g.,
	 *     example.com
	 * @!attribute host
	 *   @return [String] the host portion of the endpoint including
	 *     the port, e.g., example.com:80
	 * @!attribute port
	 *   @return [Integer] the port of the endpoint
	 * @!attribute href
	 *   @return [String] the full URL of the endpoint
	 */
	AWS.Endpoint = inherit({
	
	  /**
	   * @overload Endpoint(endpoint)
	   *   Constructs a new endpoint given an endpoint URL. If the
	   *   URL omits a protocol (http or https), the default protocol
	   *   set in the global {AWS.config} will be used.
	   *   @param endpoint [String] the URL to construct an endpoint from
	   */
	  constructor: function Endpoint(endpoint, config) {
	    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);
	
	    if (typeof endpoint === 'undefined' || endpoint === null) {
	      throw new Error('Invalid endpoint: ' + endpoint);
	    } else if (typeof endpoint !== 'string') {
	      return AWS.util.copy(endpoint);
	    }
	
	    if (!endpoint.match(/^http/)) {
	      var useSSL = config && config.sslEnabled !== undefined ?
	        config.sslEnabled : AWS.config.sslEnabled;
	      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
	    }
	
	    AWS.util.update(this, AWS.util.urlParse(endpoint));
	
	    // Ensure the port property is set as an integer
	    if (this.port) {
	      this.port = parseInt(this.port, 10);
	    } else {
	      this.port = this.protocol === 'https:' ? 443 : 80;
	    }
	  }
	
	});
	
	/**
	 * The low level HTTP request object, encapsulating all HTTP header
	 * and body data sent by a service request.
	 *
	 * @!attribute method
	 *   @return [String] the HTTP method of the request
	 * @!attribute path
	 *   @return [String] the path portion of the URI, e.g.,
	 *     "/list/?start=5&num=10"
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *     a map of header keys and their respective values
	 * @!attribute body
	 *   @return [String] the request body payload
	 * @!attribute endpoint
	 *   @return [AWS.Endpoint] the endpoint for the request
	 * @!attribute region
	 *   @api private
	 *   @return [String] the region, for signing purposes only.
	 */
	AWS.HttpRequest = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpRequest(endpoint, region) {
	    endpoint = new AWS.Endpoint(endpoint);
	    this.method = 'POST';
	    this.path = endpoint.path || '/';
	    this.headers = {};
	    this.body = '';
	    this.endpoint = endpoint;
	    this.region = region;
	    this._userAgent = '';
	    this.setUserAgent();
	  },
	
	  /**
	   * @api private
	   */
	  setUserAgent: function setUserAgent() {
	    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
	  },
	
	  getUserAgentHeaderName: function getUserAgentHeaderName() {
	    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
	    return prefix + 'User-Agent';
	  },
	
	  /**
	   * @api private
	   */
	  appendToUserAgent: function appendToUserAgent(agentPartial) {
	    if (typeof agentPartial === 'string' && agentPartial) {
	      this._userAgent += ' ' + agentPartial;
	    }
	    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
	  },
	
	  /**
	   * @api private
	   */
	  getUserAgent: function getUserAgent() {
	    return this._userAgent;
	  },
	
	  /**
	   * @return [String] the part of the {path} excluding the
	   *   query string
	   */
	  pathname: function pathname() {
	    return this.path.split('?', 1)[0];
	  },
	
	  /**
	   * @return [String] the query string portion of the {path}
	   */
	  search: function search() {
	    var query = this.path.split('?', 2)[1];
	    if (query) {
	      query = AWS.util.queryStringParse(query);
	      return AWS.util.queryParamsToString(query);
	    }
	    return '';
	  }
	
	});
	
	/**
	 * The low level HTTP response object, encapsulating all HTTP header
	 * and body data returned from the request.
	 *
	 * @!attribute statusCode
	 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *      a map of response header keys and their respective values
	 * @!attribute body
	 *   @return [String] the response body payload
	 * @!attribute [r] streaming
	 *   @return [Boolean] whether this response is being streamed at a low-level.
	 *     Defaults to `false` (buffered reads). Do not modify this manually, use
	 *     {createUnbufferedStream} to convert the stream to unbuffered mode
	 *     instead.
	 */
	AWS.HttpResponse = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpResponse() {
	    this.statusCode = undefined;
	    this.headers = {};
	    this.body = undefined;
	    this.streaming = false;
	    this.stream = null;
	  },
	
	  /**
	   * Disables buffering on the HTTP response and returns the stream for reading.
	   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
	   *   Use this object to directly read data off of the stream.
	   * @note This object is only available after the {AWS.Request~httpHeaders}
	   *   event has fired. This method must be called prior to
	   *   {AWS.Request~httpData}.
	   * @example Taking control of a stream
	   *   request.on('httpHeaders', function(statusCode, headers) {
	   *     if (statusCode < 300) {
	   *       if (headers.etag === 'xyz') {
	   *         // pipe the stream, disabling buffering
	   *         var stream = this.response.httpResponse.createUnbufferedStream();
	   *         stream.pipe(process.stdout);
	   *       } else { // abort this request and set a better error message
	   *         this.abort();
	   *         this.response.error = new Error('Invalid ETag');
	   *       }
	   *     }
	   *   }).send(console.log);
	   */
	  createUnbufferedStream: function createUnbufferedStream() {
	    this.streaming = true;
	    return this.stream;
	  }
	});
	
	
	AWS.HttpClient = inherit({});
	
	/**
	 * @api private
	 */
	AWS.HttpClient.getInstance = function getInstance() {
	  if (this.singleton === undefined) {
	    this.singleton = new this();
	  }
	  return this.singleton;
	};


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var Collection = __webpack_require__(409);
	var Operation = __webpack_require__(410);
	var Shape = __webpack_require__(156);
	var Paginator = __webpack_require__(411);
	var ResourceWaiter = __webpack_require__(412);
	
	var util = __webpack_require__(41);
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Api(api, options) {
	  api = api || {};
	  options = options || {};
	  options.api = this;
	
	  api.metadata = api.metadata || {};
	
	  property(this, 'isApi', true, false);
	  property(this, 'apiVersion', api.metadata.apiVersion);
	  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
	  property(this, 'signingName', api.metadata.signingName);
	  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
	  property(this, 'signatureVersion', api.metadata.signatureVersion);
	  property(this, 'jsonVersion', api.metadata.jsonVersion);
	  property(this, 'targetPrefix', api.metadata.targetPrefix);
	  property(this, 'protocol', api.metadata.protocol);
	  property(this, 'timestampFormat', api.metadata.timestampFormat);
	  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
	  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
	  property(this, 'fullName', api.metadata.serviceFullName);
	
	  memoizedProperty(this, 'className', function() {
	    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
	    if (!name) return null;
	
	    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
	    if (name === 'ElasticLoadBalancing') name = 'ELB';
	    return name;
	  });
	
	  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
	    return new Operation(name, operation, options);
	  }, util.string.lowerFirst));
	
	  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
	    return Shape.create(shape, options);
	  }));
	
	  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
	    return new Paginator(name, paginator, options);
	  }));
	
	  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
	    return new ResourceWaiter(name, waiter, options);
	  }, util.string.lowerFirst));
	
	  if (options.documentation) {
	    property(this, 'documentation', api.documentation);
	    property(this, 'documentationUrl', api.documentationUrl);
	  }
	}
	
	module.exports = Api;


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var memoizedProperty = __webpack_require__(41).memoizedProperty;
	
	function memoize(name, value, fn, nameTr) {
	  memoizedProperty(this, nameTr(name), function() {
	    return fn(name, value);
	  });
	}
	
	function Collection(iterable, options, fn, nameTr) {
	  nameTr = nameTr || String;
	  var self = this;
	
	  for (var id in iterable) {
	    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
	      memoize.call(self, id, iterable[id], fn, nameTr);
	    }
	  }
	}
	
	module.exports = Collection;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var Shape = __webpack_require__(156);
	
	var util = __webpack_require__(41);
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Operation(name, operation, options) {
	  var self = this;
	  options = options || {};
	
	  property(this, 'name', operation.name || name);
	  property(this, 'api', options.api, false);
	
	  operation.http = operation.http || {};
	  property(this, 'httpMethod', operation.http.method || 'POST');
	  property(this, 'httpPath', operation.http.requestUri || '/');
	  property(this, 'authtype', operation.authtype || '');
	
	  memoizedProperty(this, 'input', function() {
	    if (!operation.input) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.input, options);
	  });
	
	  memoizedProperty(this, 'output', function() {
	    if (!operation.output) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.output, options);
	  });
	
	  memoizedProperty(this, 'errors', function() {
	    var list = [];
	    if (!operation.errors) return null;
	
	    for (var i = 0; i < operation.errors.length; i++) {
	      list.push(Shape.create(operation.errors[i], options));
	    }
	
	    return list;
	  });
	
	  memoizedProperty(this, 'paginator', function() {
	    return options.api.paginators[name];
	  });
	
	  if (options.documentation) {
	    property(this, 'documentation', operation.documentation);
	    property(this, 'documentationUrl', operation.documentationUrl);
	  }
	
	  // idempotentMembers only tracks top-level input shapes
	  memoizedProperty(this, 'idempotentMembers', function() {
	    var idempotentMembers = [];
	    var input = self.input;
	    var members = input.members;
	    if (!input.members) {
	      return idempotentMembers;
	    }
	    for (var name in members) {
	      if (!members.hasOwnProperty(name)) {
	        continue;
	      }
	      if (members[name].isIdempotent === true) {
	        idempotentMembers.push(name);
	      }
	    }
	    return idempotentMembers;
	  });
	
	}
	
	module.exports = Operation;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var property = __webpack_require__(41).property;
	
	function Paginator(name, paginator) {
	  property(this, 'inputToken', paginator.input_token);
	  property(this, 'limitKey', paginator.limit_key);
	  property(this, 'moreResults', paginator.more_results);
	  property(this, 'outputToken', paginator.output_token);
	  property(this, 'resultKey', paginator.result_key);
	}
	
	module.exports = Paginator;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	var property = util.property;
	
	function ResourceWaiter(name, waiter, options) {
	  options = options || {};
	  property(this, 'name', name);
	  property(this, 'api', options.api, false);
	
	  if (waiter.operation) {
	    property(this, 'operation', util.string.lowerFirst(waiter.operation));
	  }
	
	  var self = this;
	  var keys = [
	    'type',
	    'description',
	    'delay',
	    'maxAttempts',
	    'acceptors'
	  ];
	
	  keys.forEach(function(key) {
	    var value = waiter[key];
	    if (value) {
	      property(self, key, value);
	    }
	  });
	}
	
	module.exports = ResourceWaiter;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var util = __webpack_require__(41);
	var QueryParamSerializer = __webpack_require__(884);
	var Shape = __webpack_require__(156);
	
	function buildRequest(req) {
	  var operation = req.service.api.operations[req.operation];
	  var httpRequest = req.httpRequest;
	  httpRequest.headers['Content-Type'] =
	    'application/x-www-form-urlencoded; charset=utf-8';
	  httpRequest.params = {
	    Version: req.service.api.apiVersion,
	    Action: operation.name
	  };
	
	  // convert the request parameters into a list of query params,
	  // e.g. Deeply.NestedParam.0.Name=value
	  var builder = new QueryParamSerializer();
	  builder.serialize(req.params, operation.input, function(name, value) {
	    httpRequest.params[name] = value;
	  });
	  httpRequest.body = util.queryParamsToString(httpRequest.params);
	}
	
	function extractError(resp) {
	  var data, body = resp.httpResponse.body.toString();
	  if (body.match('<UnknownOperationException')) {
	    data = {
	      Code: 'UnknownOperation',
	      Message: 'Unknown operation ' + resp.request.operation
	    };
	  } else {
	    try {
	      data = new AWS.XML.Parser().parse(body);
	    } catch (e) {
	      data = {
	        Code: resp.httpResponse.statusCode,
	        Message: resp.httpResponse.statusMessage
	      };
	    }
	  }
	
	  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var operation = req.service.api.operations[req.operation];
	  var shape = operation.output || {};
	  var origRules = shape;
	
	  if (origRules.resultWrapper) {
	    var tmp = Shape.create({type: 'structure'});
	    tmp.members[origRules.resultWrapper] = shape;
	    tmp.memberNames = [origRules.resultWrapper];
	    util.property(shape, 'name', shape.resultWrapper);
	    shape = tmp;
	  }
	
	  var parser = new AWS.XML.Parser();
	
	  // TODO: Refactor XML Parser to parse RequestId from response.
	  if (shape && shape.members && !shape.members._XAMZRequestId) {
	    var requestIdShape = Shape.create(
	      { type: 'string' },
	      { api: { protocol: 'query' } },
	      'requestId'
	    );
	    shape.members._XAMZRequestId = requestIdShape;
	  }
	
	  var data = parser.parse(resp.httpResponse.body.toString(), shape);
	  resp.requestId = data._XAMZRequestId || data.requestId;
	
	  if (data._XAMZRequestId) delete data._XAMZRequestId;
	
	  if (origRules.resultWrapper) {
	    if (data[origRules.resultWrapper]) {
	      util.update(data, data[origRules.resultWrapper]);
	      delete data[origRules.resultWrapper];
	    }
	  }
	
	  resp.data = data;
	}
	
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	var Rest = __webpack_require__(189);
	var Json = __webpack_require__(272);
	var JsonBuilder = __webpack_require__(270);
	var JsonParser = __webpack_require__(271);
	
	function populateBody(req) {
	  var builder = new JsonBuilder();
	  var input = req.service.api.operations[req.operation].input;
	
	  if (input.payload) {
	    var params = {};
	    var payloadShape = input.members[input.payload];
	    params = req.params[input.payload];
	    if (params === undefined) return;
	
	    if (payloadShape.type === 'structure') {
	      req.httpRequest.body = builder.build(params, payloadShape);
	      applyContentTypeHeader(req);
	    } else { // non-JSON payload
	      req.httpRequest.body = params;
	      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
	        applyContentTypeHeader(req, true);
	      }
	    }
	  } else {
	    req.httpRequest.body = builder.build(req.params, input);
	    applyContentTypeHeader(req);
	  }
	}
	
	function applyContentTypeHeader(req, isBinary) {
	  var operation = req.service.api.operations[req.operation];
	  var input = operation.input;
	
	  if (!req.httpRequest.headers['Content-Type']) {
	    var type = isBinary ? 'binary/octet-stream' : 'application/json';
	    req.httpRequest.headers['Content-Type'] = type;
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on GET/HEAD/DELETE
	  if (['GET', 'HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Json.extractError(resp);
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var req = resp.request;
	  var rules = req.service.api.operations[req.operation].output || {};
	  if (rules.payload) {
	    var payloadMember = rules.members[rules.payload];
	    var body = resp.httpResponse.body;
	    if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
	      var parser = new JsonParser();
	      resp.data[rules.payload] = parser.parse(body, payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[rules.payload] = body;
	    } else {
	      resp.data[rules.payload] = payloadMember.toType(body);
	    }
	  } else {
	    var data = resp.data;
	    Json.extractData(resp);
	    resp.data = util.merge(data, resp.data);
	  }
	}
	
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var util = __webpack_require__(41);
	var Rest = __webpack_require__(189);
	
	function populateBody(req) {
	  var input = req.service.api.operations[req.operation].input;
	  var builder = new AWS.XML.Builder();
	  var params = req.params;
	
	  var payload = input.payload;
	  if (payload) {
	    var payloadMember = input.members[payload];
	    params = params[payload];
	    if (params === undefined) return;
	
	    if (payloadMember.type === 'structure') {
	      var rootElement = payloadMember.name;
	      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
	    } else { // non-xml payload
	      req.httpRequest.body = params;
	    }
	  } else {
	    req.httpRequest.body = builder.toXML(params, input, input.name ||
	      input.shape || util.string.upperFirst(req.operation) + 'Request');
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on GET/HEAD
	  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Rest.extractError(resp);
	
	  var data;
	  try {
	    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
	  } catch (e) {
	    data = {
	      Code: resp.httpResponse.statusCode,
	      Message: resp.httpResponse.statusMessage
	    };
	  }
	
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var parser;
	  var req = resp.request;
	  var body = resp.httpResponse.body;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  var payload = output.payload;
	  if (payload) {
	    var payloadMember = output.members[payload];
	    if (payloadMember.type === 'structure') {
	      parser = new AWS.XML.Parser();
	      resp.data[payload] = parser.parse(body.toString(), payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[payload] = body;
	    } else {
	      resp.data[payload] = payloadMember.toType(body);
	    }
	  } else if (body.length > 0) {
	    parser = new AWS.XML.Parser();
	    var data = parser.parse(body.toString(), output);
	    util.update(resp.data, data);
	  }
	}
	
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	
	/**
	 * @api private
	 * @!method on(eventName, callback)
	 *   Registers an event listener callback for the event given by `eventName`.
	 *   Parameters passed to the callback function depend on the individual event
	 *   being triggered. See the event documentation for those parameters.
	 *
	 *   @param eventName [String] the event name to register the listener for
	 *   @param callback [Function] the listener callback function
	 *   @return [AWS.SequentialExecutor] the same object for chaining
	 */
	AWS.SequentialExecutor = AWS.util.inherit({
	
	  constructor: function SequentialExecutor() {
	    this._events = {};
	  },
	
	  /**
	   * @api private
	   */
	  listeners: function listeners(eventName) {
	    return this._events[eventName] ? this._events[eventName].slice(0) : [];
	  },
	
	  on: function on(eventName, listener) {
	    if (this._events[eventName]) {
	      this._events[eventName].push(listener);
	    } else {
	      this._events[eventName] = [listener];
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  onAsync: function onAsync(eventName, listener) {
	    listener._isAsync = true;
	    return this.on(eventName, listener);
	  },
	
	  removeListener: function removeListener(eventName, listener) {
	    var listeners = this._events[eventName];
	    if (listeners) {
	      var length = listeners.length;
	      var position = -1;
	      for (var i = 0; i < length; ++i) {
	        if (listeners[i] === listener) {
	          position = i;
	        }
	      }
	      if (position > -1) {
	        listeners.splice(position, 1);
	      }
	    }
	    return this;
	  },
	
	  removeAllListeners: function removeAllListeners(eventName) {
	    if (eventName) {
	      delete this._events[eventName];
	    } else {
	      this._events = {};
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  emit: function emit(eventName, eventArgs, doneCallback) {
	    if (!doneCallback) doneCallback = function() { };
	    var listeners = this.listeners(eventName);
	    var count = listeners.length;
	    this.callListeners(listeners, eventArgs, doneCallback);
	    return count > 0;
	  },
	
	  /**
	   * @api private
	   */
	  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
	    var self = this;
	    var error = prevError || null;
	
	    function callNextListener(err) {
	      if (err) {
	        error = AWS.util.error(error || new Error(), err);
	        if (self._haltHandlersOnError) {
	          return doneCallback.call(self, error);
	        }
	      }
	      self.callListeners(listeners, args, doneCallback, error);
	    }
	
	    while (listeners.length > 0) {
	      var listener = listeners.shift();
	      if (listener._isAsync) { // asynchronous listener
	        listener.apply(self, args.concat([callNextListener]));
	        return; // stop here, callNextListener will continue
	      } else { // synchronous listener
	        try {
	          listener.apply(self, args);
	        } catch (err) {
	          error = AWS.util.error(error || new Error(), err);
	        }
	        if (error && self._haltHandlersOnError) {
	          doneCallback.call(self, error);
	          return;
	        }
	      }
	    }
	    doneCallback.call(self, error);
	  },
	
	  /**
	   * Adds or copies a set of listeners from another list of
	   * listeners or SequentialExecutor object.
	   *
	   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
	   *   a list of events and callbacks, or an event emitter object
	   *   containing listeners to add to this emitter object.
	   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
	   * @example Adding listeners from a map of listeners
	   *   emitter.addListeners({
	   *     event1: [function() { ... }, function() { ... }],
	   *     event2: [function() { ... }]
	   *   });
	   *   emitter.emit('event1'); // emitter has event1
	   *   emitter.emit('event2'); // emitter has event2
	   * @example Adding listeners from another emitter object
	   *   var emitter1 = new AWS.SequentialExecutor();
	   *   emitter1.on('event1', function() { ... });
	   *   emitter1.on('event2', function() { ... });
	   *   var emitter2 = new AWS.SequentialExecutor();
	   *   emitter2.addListeners(emitter1);
	   *   emitter2.emit('event1'); // emitter2 has event1
	   *   emitter2.emit('event2'); // emitter2 has event2
	   */
	  addListeners: function addListeners(listeners) {
	    var self = this;
	
	    // extract listeners if parameter is an SequentialExecutor object
	    if (listeners._events) listeners = listeners._events;
	
	    AWS.util.each(listeners, function(event, callbacks) {
	      if (typeof callbacks === 'function') callbacks = [callbacks];
	      AWS.util.arrayEach(callbacks, function(callback) {
	        self.on(event, callback);
	      });
	    });
	
	    return self;
	  },
	
	  /**
	   * Registers an event with {on} and saves the callback handle function
	   * as a property on the emitter object using a given `name`.
	   *
	   * @param name [String] the property name to set on this object containing
	   *   the callback function handle so that the listener can be removed in
	   *   the future.
	   * @param (see on)
	   * @return (see on)
	   * @example Adding a named listener DATA_CALLBACK
	   *   var listener = function() { doSomething(); };
	   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
	   *
	   *   // the following prints: true
	   *   console.log(emitter.DATA_CALLBACK == listener);
	   */
	  addNamedListener: function addNamedListener(name, eventName, callback) {
	    this[name] = callback;
	    this.addListener(eventName, callback);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback) {
	    callback._isAsync = true;
	    return this.addNamedListener(name, eventName, callback);
	  },
	
	  /**
	   * Helper method to add a set of named listeners using
	   * {addNamedListener}. The callback contains a parameter
	   * with a handle to the `addNamedListener` method.
	   *
	   * @callback callback function(add)
	   *   The callback function is called immediately in order to provide
	   *   the `add` function to the block. This simplifies the addition of
	   *   a large group of named listeners.
	   *   @param add [Function] the {addNamedListener} function to call
	   *     when registering listeners.
	   * @example Adding a set of named listeners
	   *   emitter.addNamedListeners(function(add) {
	   *     add('DATA_CALLBACK', 'data', function() { ... });
	   *     add('OTHER', 'otherEvent', function() { ... });
	   *     add('LAST', 'lastEvent', function() { ... });
	   *   });
	   *
	   *   // these properties are now set:
	   *   emitter.DATA_CALLBACK;
	   *   emitter.OTHER;
	   *   emitter.LAST;
	   */
	  addNamedListeners: function addNamedListeners(callback) {
	    var self = this;
	    callback(
	      function() {
	        self.addNamedListener.apply(self, arguments);
	      },
	      function() {
	        self.addNamedAsyncListener.apply(self, arguments);
	      }
	    );
	    return this;
	  }
	});
	
	/**
	 * {on} is the prefered method.
	 * @api private
	 */
	AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;
	
	module.exports = AWS.SequentialExecutor;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    var datetime = AWS.util.date.rfc822(date);
	
	    this.request.headers['X-Amz-Date'] = datetime;
	
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    this.request.headers['X-Amzn-Authorization'] =
	      this.authorization(credentials, datetime);
	
	  },
	
	  authorization: function authorization(credentials) {
	    return 'AWS3 ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'SignedHeaders=' + this.signedHeaders() + ',' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  signedHeaders: function signedHeaders() {
	    var headers = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      headers.push(h.toLowerCase());
	    });
	    return headers.sort().join(';');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = this.request.headers;
	    var parts = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
	    });
	    return parts.sort().join('\n') + '\n';
	  },
	
	  headersToSign: function headersToSign() {
	    var headers = [];
	    AWS.util.each(this.request.headers, function iterator(k) {
	      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
	        headers.push(k);
	      }
	    });
	    return headers;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push('/');
	    parts.push('');
	    parts.push(this.canonicalHeaders());
	    parts.push(this.request.body);
	    return AWS.util.crypto.sha256(parts.join('\n'));
	  }
	
	});
	
	module.exports = AWS.Signers.V3;


/***/ },
/* 418 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 419 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(rnds8);
	    return rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}
	
	module.exports = rng;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 420 */
[2516, 7, 4, 1032, 1693, 1694],
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	
	var AWS = __webpack_require__(4);
	
	if (typeof window !== 'undefined') window.AWS = AWS;
	if (true) {
	    /**
	     * @api private
	     */
	    module.exports = AWS;
	}
	if (typeof self !== 'undefined') self.AWS = AWS;
	
	/**
	 * @private
	 * DO NOT REMOVE
	 * browser builder will strip out this line if services are supplied on the command line.
	 */
	__webpack_require__(918);


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	/**
	 * Represents your AWS security credentials, specifically the
	 * {accessKeyId}, {secretAccessKey}, and optional {sessionToken}.
	 * Creating a `Credentials` object allows you to pass around your
	 * security information to configuration and service objects.
	 *
	 * Note that this class typically does not need to be constructed manually,
	 * as the {AWS.Config} and {AWS.Service} classes both accept simple
	 * options hashes with the three keys. These structures will be converted
	 * into Credentials objects automatically.
	 *
	 * ## Expiring and Refreshing Credentials
	 *
	 * Occasionally credentials can expire in the middle of a long-running
	 * application. In this case, the SDK will automatically attempt to
	 * refresh the credentials from the storage location if the Credentials
	 * class implements the {refresh} method.
	 *
	 * If you are implementing a credential storage location, you
	 * will want to create a subclass of the `Credentials` class and
	 * override the {refresh} method. This method allows credentials to be
	 * retrieved from the backing store, be it a file system, database, or
	 * some network storage. The method should reset the credential attributes
	 * on the object.
	 *
	 * @!attribute expired
	 *   @return [Boolean] whether the credentials have been expired and
	 *     require a refresh. Used in conjunction with {expireTime}.
	 * @!attribute expireTime
	 *   @return [Date] a time when credentials should be considered expired. Used
	 *     in conjunction with {expired}.
	 * @!attribute accessKeyId
	 *   @return [String] the AWS access key ID
	 * @!attribute secretAccessKey
	 *   @return [String] the AWS secret access key
	 * @!attribute sessionToken
	 *   @return [String] an optional AWS session token
	 */
	AWS.Credentials = AWS.util.inherit({
	  /**
	   * A credentials object can be created using positional arguments or an options
	   * hash.
	   *
	   * @overload AWS.Credentials(accessKeyId, secretAccessKey, sessionToken=null)
	   *   Creates a Credentials object with a given set of credential information
	   *   as positional arguments.
	   *   @param accessKeyId [String] the AWS access key ID
	   *   @param secretAccessKey [String] the AWS secret access key
	   *   @param sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials('akid', 'secret', 'session');
	   * @overload AWS.Credentials(options)
	   *   Creates a Credentials object with a given set of credential information
	   *   as an options hash.
	   *   @option options accessKeyId [String] the AWS access key ID
	   *   @option options secretAccessKey [String] the AWS secret access key
	   *   @option options sessionToken [String] the optional AWS session token
	   *   @example Create a credentials object with AWS credentials
	   *     var creds = new AWS.Credentials({
	   *       accessKeyId: 'akid', secretAccessKey: 'secret', sessionToken: 'session'
	   *     });
	   */
	  constructor: function Credentials() {
	    // hide secretAccessKey from being displayed with util.inspect
	    AWS.util.hideProperties(this, ['secretAccessKey']);
	
	    this.expired = false;
	    this.expireTime = null;
	    this.refreshCallbacks = [];
	    if (arguments.length === 1 && typeof arguments[0] === 'object') {
	      var creds = arguments[0].credentials || arguments[0];
	      this.accessKeyId = creds.accessKeyId;
	      this.secretAccessKey = creds.secretAccessKey;
	      this.sessionToken = creds.sessionToken;
	    } else {
	      this.accessKeyId = arguments[0];
	      this.secretAccessKey = arguments[1];
	      this.sessionToken = arguments[2];
	    }
	  },
	
	  /**
	   * @return [Integer] the number of seconds before {expireTime} during which
	   *   the credentials will be considered expired.
	   */
	  expiryWindow: 15,
	
	  /**
	   * @return [Boolean] whether the credentials object should call {refresh}
	   * @note Subclasses should override this method to provide custom refresh
	   *   logic.
	   */
	  needsRefresh: function needsRefresh() {
	    var currentTime = AWS.util.date.getDate().getTime();
	    var adjustedTime = new Date(currentTime + this.expiryWindow * 1000);
	
	    if (this.expireTime && adjustedTime > this.expireTime) {
	      return true;
	    } else {
	      return this.expired || !this.accessKeyId || !this.secretAccessKey;
	    }
	  },
	
	  /**
	   * Gets the existing credentials, refreshing them if they are not yet loaded
	   * or have expired. Users should call this method before using {refresh},
	   * as this will not attempt to reload credentials when they are already
	   * loaded into the object.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means either credentials
	   *   do not need to be refreshed or refreshed credentials information has
	   *   been loaded into the object (as the `accessKeyId`, `secretAccessKey`,
	   *   and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   */
	  get: function get(callback) {
	    var self = this;
	    if (this.needsRefresh()) {
	      this.refresh(function(err) {
	        if (!err) self.expired = false; // reset expired flag
	        if (callback) callback(err);
	      });
	    } else if (callback) {
	      callback();
	    }
	  },
	
	  /**
	   * @!method  getPromise()
	   *   Returns a 'thenable' promise.
	   *   Gets the existing credentials, refreshing them if they are not yet loaded
	   *   or have expired. Users should call this method before using {refresh},
	   *   as this will not attempt to reload credentials when they are already
	   *   loaded into the object.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means either credentials do not need to be refreshed or refreshed
	   *     credentials information has been loaded into the object (as the
	   *     `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `get` call.
	   *   @example Calling the `getPromise` method.
	   *     var promise = credProvider.getPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * @!method  refreshPromise()
	   *   Returns a 'thenable' promise.
	   *   Refreshes the credentials. Users should call {get} before attempting
	   *   to forcibly refresh credentials.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function()
	   *     Called if the promise is fulfilled. When this callback is called, it
	   *     means refreshed credentials information has been loaded into the object
	   *     (as the `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] if an error occurred, this value will be filled
	   *   @return [Promise] A promise that represents the state of the `refresh` call.
	   *   @example Calling the `refreshPromise` method.
	   *     var promise = credProvider.refreshPromise();
	   *     promise.then(function() { ... }, function(err) { ... });
	   */
	
	  /**
	   * Refreshes the credentials. Users should call {get} before attempting
	   * to forcibly refresh credentials.
	   *
	   * @callback callback function(err)
	   *   When this callback is called with no error, it means refreshed
	   *   credentials information has been loaded into the object (as the
	   *   `accessKeyId`, `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @note Subclasses should override this class to reset the
	   *   {accessKeyId}, {secretAccessKey} and optional {sessionToken}
	   *   on the credentials object and then call the callback with
	   *   any error information.
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.expired = false;
	    callback();
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  coalesceRefresh: function coalesceRefresh(callback, sync) {
	    var self = this;
	    if (self.refreshCallbacks.push(callback) === 1) {
	      self.load(function onLoad(err) {
	        AWS.util.arrayEach(self.refreshCallbacks, function(callback) {
	          if (sync) {
	            callback(err);
	          } else {
	            // callback could throw, so defer to ensure all callbacks are notified
	            AWS.util.defer(function () {
	              callback(err);
	            });
	          }
	        });
	        self.refreshCallbacks.length = 0;
	      });
	    }
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    callback();
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Credentials.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.getPromise = AWS.util.promisifyMethod('get', PromiseDependency);
	  this.prototype.refreshPromise = AWS.util.promisifyMethod('refresh', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.Credentials.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.getPromise;
	  delete this.prototype.refreshPromise;
	};
	
	AWS.util.addPromises(AWS.Credentials);


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	/**
	 * Creates a credential provider chain that searches for AWS credentials
	 * in a list of credential providers specified by the {providers} property.
	 *
	 * By default, the chain will use the {defaultProviders} to resolve credentials.
	 * These providers will look in the environment using the
	 * {AWS.EnvironmentCredentials} class with the 'AWS' and 'AMAZON' prefixes.
	 *
	 * ## Setting Providers
	 *
	 * Each provider in the {providers} list should be a function that returns
	 * a {AWS.Credentials} object, or a hardcoded credentials object. The function
	 * form allows for delayed execution of the credential construction.
	 *
	 * ## Resolving Credentials from a Chain
	 *
	 * Call {resolve} to return the first valid credential object that can be
	 * loaded by the provider chain.
	 *
	 * For example, to resolve a chain with a custom provider that checks a file
	 * on disk after the set of {defaultProviders}:
	 *
	 * ```javascript
	 * var diskProvider = new AWS.FileSystemCredentials('./creds.json');
	 * var chain = new AWS.CredentialProviderChain();
	 * chain.providers.push(diskProvider);
	 * chain.resolve();
	 * ```
	 *
	 * The above code will return the `diskProvider` object if the
	 * file contains credentials and the `defaultProviders` do not contain
	 * any credential settings.
	 *
	 * @!attribute providers
	 *   @return [Array<AWS.Credentials, Function>]
	 *     a list of credentials objects or functions that return credentials
	 *     objects. If the provider is a function, the function will be
	 *     executed lazily when the provider needs to be checked for valid
	 *     credentials. By default, this object will be set to the
	 *     {defaultProviders}.
	 *   @see defaultProviders
	 */
	AWS.CredentialProviderChain = AWS.util.inherit(AWS.Credentials, {
	
	  /**
	   * Creates a new CredentialProviderChain with a default set of providers
	   * specified by {defaultProviders}.
	   */
	  constructor: function CredentialProviderChain(providers) {
	    if (providers) {
	      this.providers = providers;
	    } else {
	      this.providers = AWS.CredentialProviderChain.defaultProviders.slice(0);
	    }
	    this.resolveCallbacks = [];
	  },
	
	  /**
	   * @!method  resolvePromise()
	   *   Returns a 'thenable' promise.
	   *   Resolves the provider chain by searching for the first set of
	   *   credentials in {providers}.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(credentials)
	   *     Called if the promise is fulfilled and the provider resolves the chain
	   *     to a credentials object
	   *     @param credentials [AWS.Credentials] the credentials object resolved
	   *       by the provider chain.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param err [Error] the error object returned if no credentials are found.
	   *   @return [Promise] A promise that represents the state of the `resolve` method call.
	   *   @example Calling the `resolvePromise` method.
	   *     var promise = chain.resolvePromise();
	   *     promise.then(function(credentials) { ... }, function(err) { ... });
	   */
	
	  /**
	   * Resolves the provider chain by searching for the first set of
	   * credentials in {providers}.
	   *
	   * @callback callback function(err, credentials)
	   *   Called when the provider resolves the chain to a credentials object
	   *   or null if no credentials can be found.
	   *
	   *   @param err [Error] the error object returned if no credentials are
	   *     found.
	   *   @param credentials [AWS.Credentials] the credentials object resolved
	   *     by the provider chain.
	   * @return [AWS.CredentialProviderChain] the provider, for chaining.
	   */
	  resolve: function resolve(callback) {
	    var self = this;
	    if (self.providers.length === 0) {
	      callback(new Error('No providers'));
	      return self;
	    }
	
	    if (self.resolveCallbacks.push(callback) === 1) {
	      var index = 0;
	      var providers = self.providers.slice(0);
	
	      function resolveNext(err, creds) {
	        if ((!err && creds) || index === providers.length) {
	          AWS.util.arrayEach(self.resolveCallbacks, function (callback) {
	            callback(err, creds);
	          });
	          self.resolveCallbacks.length = 0;
	          return;
	        }
	
	        var provider = providers[index++];
	        if (typeof provider === 'function') {
	          creds = provider.call();
	        } else {
	          creds = provider;
	        }
	
	        if (creds.get) {
	          creds.get(function (getErr) {
	            resolveNext(getErr, getErr ? null : creds);
	          });
	        } else {
	          resolveNext(null, creds);
	        }
	      }
	
	      resolveNext();
	    }
	
	    return self;
	  }
	});
	
	/**
	 * The default set of providers used by a vanilla CredentialProviderChain.
	 *
	 * In the browser:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = []
	 * ```
	 *
	 * In Node.js:
	 *
	 * ```javascript
	 * AWS.CredentialProviderChain.defaultProviders = [
	 *   function () { return new AWS.EnvironmentCredentials('AWS'); },
	 *   function () { return new AWS.EnvironmentCredentials('AMAZON'); },
	 *   function () { return new AWS.SharedIniFileCredentials(); },
	 *   function () { return new AWS.ECSCredentials(); },
	 *   function () { return new AWS.ProcessCredentials(); },
	 *   function () { return new AWS.EC2MetadataCredentials() }
	 * ]
	 * ```
	 */
	AWS.CredentialProviderChain.defaultProviders = [];
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.resolvePromise = AWS.util.promisifyMethod('resolve', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.CredentialProviderChain.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.resolvePromise;
	};
	
	AWS.util.addPromises(AWS.CredentialProviderChain);


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var typeOf = __webpack_require__(425).typeOf;
	
	/**
	 * @api private
	 */
	var memberTypeToSetType = {
	  'String': 'String',
	  'Number': 'Number',
	  'NumberValue': 'Number',
	  'Binary': 'Binary'
	};
	
	/**
	 * @api private
	 */
	var DynamoDBSet = util.inherit({
	
	  constructor: function Set(list, options) {
	    options = options || {};
	    this.wrapperName = 'Set';
	    this.initialize(list, options.validate);
	  },
	
	  initialize: function(list, validate) {
	    var self = this;
	    self.values = [].concat(list);
	    self.detectType();
	    if (validate) {
	      self.validate();
	    }
	  },
	
	  detectType: function() {
	    this.type = memberTypeToSetType[typeOf(this.values[0])];
	    if (!this.type) {
	      throw util.error(new Error(), {
	        code: 'InvalidSetType',
	        message: 'Sets can contain string, number, or binary values'
	      });
	    }
	  },
	
	  validate: function() {
	    var self = this;
	    var length = self.values.length;
	    var values = self.values;
	    for (var i = 0; i < length; i++) {
	      if (memberTypeToSetType[typeOf(values[i])] !== self.type) {
	        throw util.error(new Error(), {
	          code: 'InvalidType',
	          message: self.type + ' Set contains ' + typeOf(values[i]) + ' value'
	        });
	      }
	    }
	  },
	
	  /**
	   * Render the underlying values only when converting to JSON.
	   */
	  toJSON: function() {
	    var self = this;
	    return self.values;
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = DynamoDBSet;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	
	function typeOf(data) {
	  if (data === null && typeof data === 'object') {
	    return 'null';
	  } else if (data !== undefined && isBinary(data)) {
	    return 'Binary';
	  } else if (data !== undefined && data.constructor) {
	    return data.wrapperName || util.typeName(data.constructor);
	  } else if (data !== undefined && typeof data === 'object') {
	    // this object is the result of Object.create(null), hence the absence of a
	    // defined constructor
	    return 'Object';
	  } else {
	    return 'undefined';
	  }
	}
	
	function isBinary(data) {
	  var types = [
	    'Buffer', 'File', 'Blob', 'ArrayBuffer', 'DataView',
	    'Int8Array', 'Uint8Array', 'Uint8ClampedArray',
	    'Int16Array', 'Uint16Array', 'Int32Array', 'Uint32Array',
	    'Float32Array', 'Float64Array'
	  ];
	  if (util.isNode()) {
	    var Stream = util.stream.Stream;
	    if (util.Buffer.isBuffer(data) || data instanceof Stream) {
	      return true;
	    }
	  }
	
	  for (var i = 0; i < types.length; i++) {
	    if (data !== undefined && data.constructor) {
	      if (util.isType(data, types[i])) return true;
	      if (util.typeName(data.constructor) === types[i]) return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  typeOf: typeOf,
	  isBinary: isBinary
	};


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var inherit = AWS.util.inherit;
	
	/**
	 * The endpoint that a service will talk to, for example,
	 * `'https://ec2.ap-southeast-1.amazonaws.com'`. If
	 * you need to override an endpoint for a service, you can
	 * set the endpoint on a service by passing the endpoint
	 * object with the `endpoint` option key:
	 *
	 * ```javascript
	 * var ep = new AWS.Endpoint('awsproxy.example.com');
	 * var s3 = new AWS.S3({endpoint: ep});
	 * s3.service.endpoint.hostname == 'awsproxy.example.com'
	 * ```
	 *
	 * Note that if you do not specify a protocol, the protocol will
	 * be selected based on your current {AWS.config} configuration.
	 *
	 * @!attribute protocol
	 *   @return [String] the protocol (http or https) of the endpoint
	 *     URL
	 * @!attribute hostname
	 *   @return [String] the host portion of the endpoint, e.g.,
	 *     example.com
	 * @!attribute host
	 *   @return [String] the host portion of the endpoint including
	 *     the port, e.g., example.com:80
	 * @!attribute port
	 *   @return [Integer] the port of the endpoint
	 * @!attribute href
	 *   @return [String] the full URL of the endpoint
	 */
	AWS.Endpoint = inherit({
	
	  /**
	   * @overload Endpoint(endpoint)
	   *   Constructs a new endpoint given an endpoint URL. If the
	   *   URL omits a protocol (http or https), the default protocol
	   *   set in the global {AWS.config} will be used.
	   *   @param endpoint [String] the URL to construct an endpoint from
	   */
	  constructor: function Endpoint(endpoint, config) {
	    AWS.util.hideProperties(this, ['slashes', 'auth', 'hash', 'search', 'query']);
	
	    if (typeof endpoint === 'undefined' || endpoint === null) {
	      throw new Error('Invalid endpoint: ' + endpoint);
	    } else if (typeof endpoint !== 'string') {
	      return AWS.util.copy(endpoint);
	    }
	
	    if (!endpoint.match(/^http/)) {
	      var useSSL = config && config.sslEnabled !== undefined ?
	        config.sslEnabled : AWS.config.sslEnabled;
	      endpoint = (useSSL ? 'https' : 'http') + '://' + endpoint;
	    }
	
	    AWS.util.update(this, AWS.util.urlParse(endpoint));
	
	    // Ensure the port property is set as an integer
	    if (this.port) {
	      this.port = parseInt(this.port, 10);
	    } else {
	      this.port = this.protocol === 'https:' ? 443 : 80;
	    }
	  }
	
	});
	
	/**
	 * The low level HTTP request object, encapsulating all HTTP header
	 * and body data sent by a service request.
	 *
	 * @!attribute method
	 *   @return [String] the HTTP method of the request
	 * @!attribute path
	 *   @return [String] the path portion of the URI, e.g.,
	 *     "/list/?start=5&num=10"
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *     a map of header keys and their respective values
	 * @!attribute body
	 *   @return [String] the request body payload
	 * @!attribute endpoint
	 *   @return [AWS.Endpoint] the endpoint for the request
	 * @!attribute region
	 *   @api private
	 *   @return [String] the region, for signing purposes only.
	 */
	AWS.HttpRequest = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpRequest(endpoint, region) {
	    endpoint = new AWS.Endpoint(endpoint);
	    this.method = 'POST';
	    this.path = endpoint.path || '/';
	    this.headers = {};
	    this.body = '';
	    this.endpoint = endpoint;
	    this.region = region;
	    this._userAgent = '';
	    this.setUserAgent();
	  },
	
	  /**
	   * @api private
	   */
	  setUserAgent: function setUserAgent() {
	    this._userAgent = this.headers[this.getUserAgentHeaderName()] = AWS.util.userAgent();
	  },
	
	  getUserAgentHeaderName: function getUserAgentHeaderName() {
	    var prefix = AWS.util.isBrowser() ? 'X-Amz-' : '';
	    return prefix + 'User-Agent';
	  },
	
	  /**
	   * @api private
	   */
	  appendToUserAgent: function appendToUserAgent(agentPartial) {
	    if (typeof agentPartial === 'string' && agentPartial) {
	      this._userAgent += ' ' + agentPartial;
	    }
	    this.headers[this.getUserAgentHeaderName()] = this._userAgent;
	  },
	
	  /**
	   * @api private
	   */
	  getUserAgent: function getUserAgent() {
	    return this._userAgent;
	  },
	
	  /**
	   * @return [String] the part of the {path} excluding the
	   *   query string
	   */
	  pathname: function pathname() {
	    return this.path.split('?', 1)[0];
	  },
	
	  /**
	   * @return [String] the query string portion of the {path}
	   */
	  search: function search() {
	    var query = this.path.split('?', 2)[1];
	    if (query) {
	      query = AWS.util.queryStringParse(query);
	      return AWS.util.queryParamsToString(query);
	    }
	    return '';
	  },
	
	  /**
	   * @api private
	   * update httpRequest endpoint with endpoint string
	   */
	  updateEndpoint: function updateEndpoint(endpointStr) {
	    var newEndpoint = new AWS.Endpoint(endpointStr);
	    this.endpoint = newEndpoint;
	    this.path = newEndpoint.path || '/';
	  }
	});
	
	/**
	 * The low level HTTP response object, encapsulating all HTTP header
	 * and body data returned from the request.
	 *
	 * @!attribute statusCode
	 *   @return [Integer] the HTTP status code of the response (e.g., 200, 404)
	 * @!attribute headers
	 *   @return [map<String,String>]
	 *      a map of response header keys and their respective values
	 * @!attribute body
	 *   @return [String] the response body payload
	 * @!attribute [r] streaming
	 *   @return [Boolean] whether this response is being streamed at a low-level.
	 *     Defaults to `false` (buffered reads). Do not modify this manually, use
	 *     {createUnbufferedStream} to convert the stream to unbuffered mode
	 *     instead.
	 */
	AWS.HttpResponse = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function HttpResponse() {
	    this.statusCode = undefined;
	    this.headers = {};
	    this.body = undefined;
	    this.streaming = false;
	    this.stream = null;
	  },
	
	  /**
	   * Disables buffering on the HTTP response and returns the stream for reading.
	   * @return [Stream, XMLHttpRequest, null] the underlying stream object.
	   *   Use this object to directly read data off of the stream.
	   * @note This object is only available after the {AWS.Request~httpHeaders}
	   *   event has fired. This method must be called prior to
	   *   {AWS.Request~httpData}.
	   * @example Taking control of a stream
	   *   request.on('httpHeaders', function(statusCode, headers) {
	   *     if (statusCode < 300) {
	   *       if (headers.etag === 'xyz') {
	   *         // pipe the stream, disabling buffering
	   *         var stream = this.response.httpResponse.createUnbufferedStream();
	   *         stream.pipe(process.stdout);
	   *       } else { // abort this request and set a better error message
	   *         this.abort();
	   *         this.response.error = new Error('Invalid ETag');
	   *       }
	   *     }
	   *   }).send(console.log);
	   */
	  createUnbufferedStream: function createUnbufferedStream() {
	    this.streaming = true;
	    return this.stream;
	  }
	});
	
	
	AWS.HttpClient = inherit({});
	
	/**
	 * @api private
	 */
	AWS.HttpClient.getInstance = function getInstance() {
	  if (this.singleton === undefined) {
	    this.singleton = new this();
	  }
	  return this.singleton;
	};


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var Collection = __webpack_require__(428);
	var Operation = __webpack_require__(429);
	var Shape = __webpack_require__(157);
	var Paginator = __webpack_require__(430);
	var ResourceWaiter = __webpack_require__(431);
	
	var util = __webpack_require__(34);
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Api(api, options) {
	  var self = this;
	  api = api || {};
	  options = options || {};
	  options.api = this;
	
	  api.metadata = api.metadata || {};
	
	  property(this, 'isApi', true, false);
	  property(this, 'apiVersion', api.metadata.apiVersion);
	  property(this, 'endpointPrefix', api.metadata.endpointPrefix);
	  property(this, 'signingName', api.metadata.signingName);
	  property(this, 'globalEndpoint', api.metadata.globalEndpoint);
	  property(this, 'signatureVersion', api.metadata.signatureVersion);
	  property(this, 'jsonVersion', api.metadata.jsonVersion);
	  property(this, 'targetPrefix', api.metadata.targetPrefix);
	  property(this, 'protocol', api.metadata.protocol);
	  property(this, 'timestampFormat', api.metadata.timestampFormat);
	  property(this, 'xmlNamespaceUri', api.metadata.xmlNamespace);
	  property(this, 'abbreviation', api.metadata.serviceAbbreviation);
	  property(this, 'fullName', api.metadata.serviceFullName);
	  property(this, 'serviceId', api.metadata.serviceId);
	
	  memoizedProperty(this, 'className', function() {
	    var name = api.metadata.serviceAbbreviation || api.metadata.serviceFullName;
	    if (!name) return null;
	
	    name = name.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, '');
	    if (name === 'ElasticLoadBalancing') name = 'ELB';
	    return name;
	  });
	
	  function addEndpointOperation(name, operation) {
	    if (operation.endpointoperation === true) {
	      property(self, 'endpointOperation', util.string.lowerFirst(name));
	    }
	  }
	
	  property(this, 'operations', new Collection(api.operations, options, function(name, operation) {
	    return new Operation(name, operation, options);
	  }, util.string.lowerFirst, addEndpointOperation));
	
	  property(this, 'shapes', new Collection(api.shapes, options, function(name, shape) {
	    return Shape.create(shape, options);
	  }));
	
	  property(this, 'paginators', new Collection(api.paginators, options, function(name, paginator) {
	    return new Paginator(name, paginator, options);
	  }));
	
	  property(this, 'waiters', new Collection(api.waiters, options, function(name, waiter) {
	    return new ResourceWaiter(name, waiter, options);
	  }, util.string.lowerFirst));
	
	  if (options.documentation) {
	    property(this, 'documentation', api.documentation);
	    property(this, 'documentationUrl', api.documentationUrl);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = Api;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var memoizedProperty = __webpack_require__(34).memoizedProperty;
	
	function memoize(name, value, factory, nameTr) {
	  memoizedProperty(this, nameTr(name), function() {
	    return factory(name, value);
	  });
	}
	
	function Collection(iterable, options, factory, nameTr, callback) {
	  nameTr = nameTr || String;
	  var self = this;
	
	  for (var id in iterable) {
	    if (Object.prototype.hasOwnProperty.call(iterable, id)) {
	      memoize.call(self, id, iterable[id], factory, nameTr);
	      if (callback) callback(id, iterable[id]);
	    }
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = Collection;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var Shape = __webpack_require__(157);
	
	var util = __webpack_require__(34);
	var property = util.property;
	var memoizedProperty = util.memoizedProperty;
	
	function Operation(name, operation, options) {
	  var self = this;
	  options = options || {};
	
	  property(this, 'name', operation.name || name);
	  property(this, 'api', options.api, false);
	
	  operation.http = operation.http || {};
	  property(this, 'endpoint', operation.endpoint);
	  property(this, 'httpMethod', operation.http.method || 'POST');
	  property(this, 'httpPath', operation.http.requestUri || '/');
	  property(this, 'authtype', operation.authtype || '');
	  property(
	    this,
	    'endpointDiscoveryRequired',
	    operation.endpointdiscovery ?
	      (operation.endpointdiscovery.required ? 'REQUIRED' : 'OPTIONAL') :
	    'NULL'
	  );
	
	  memoizedProperty(this, 'input', function() {
	    if (!operation.input) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.input, options);
	  });
	
	  memoizedProperty(this, 'output', function() {
	    if (!operation.output) {
	      return new Shape.create({type: 'structure'}, options);
	    }
	    return Shape.create(operation.output, options);
	  });
	
	  memoizedProperty(this, 'errors', function() {
	    var list = [];
	    if (!operation.errors) return null;
	
	    for (var i = 0; i < operation.errors.length; i++) {
	      list.push(Shape.create(operation.errors[i], options));
	    }
	
	    return list;
	  });
	
	  memoizedProperty(this, 'paginator', function() {
	    return options.api.paginators[name];
	  });
	
	  if (options.documentation) {
	    property(this, 'documentation', operation.documentation);
	    property(this, 'documentationUrl', operation.documentationUrl);
	  }
	
	  // idempotentMembers only tracks top-level input shapes
	  memoizedProperty(this, 'idempotentMembers', function() {
	    var idempotentMembers = [];
	    var input = self.input;
	    var members = input.members;
	    if (!input.members) {
	      return idempotentMembers;
	    }
	    for (var name in members) {
	      if (!members.hasOwnProperty(name)) {
	        continue;
	      }
	      if (members[name].isIdempotent === true) {
	        idempotentMembers.push(name);
	      }
	    }
	    return idempotentMembers;
	  });
	
	  memoizedProperty(this, 'hasEventOutput', function() {
	    var output = self.output;
	    return hasEventStream(output);
	  });
	}
	
	function hasEventStream(topLevelShape) {
	  var members = topLevelShape.members;
	  var payload = topLevelShape.payload;
	
	  if (!topLevelShape.members) {
	    return false;
	  }
	
	  if (payload) {
	    var payloadMember = members[payload];
	    return payloadMember.isEventStream;
	  }
	
	  // check if any member is an event stream
	  for (var name in members) {
	    if (!members.hasOwnProperty(name)) {
	      if (members[name].isEventStream === true) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	/**
	 * @api private
	 */
	module.exports = Operation;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var property = __webpack_require__(34).property;
	
	function Paginator(name, paginator) {
	  property(this, 'inputToken', paginator.input_token);
	  property(this, 'limitKey', paginator.limit_key);
	  property(this, 'moreResults', paginator.more_results);
	  property(this, 'outputToken', paginator.output_token);
	  property(this, 'resultKey', paginator.result_key);
	}
	
	/**
	 * @api private
	 */
	module.exports = Paginator;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	var property = util.property;
	
	function ResourceWaiter(name, waiter, options) {
	  options = options || {};
	  property(this, 'name', name);
	  property(this, 'api', options.api, false);
	
	  if (waiter.operation) {
	    property(this, 'operation', util.string.lowerFirst(waiter.operation));
	  }
	
	  var self = this;
	  var keys = [
	    'type',
	    'description',
	    'delay',
	    'maxAttempts',
	    'acceptors'
	  ];
	
	  keys.forEach(function(key) {
	    var value = waiter[key];
	    if (value) {
	      property(self, key, value);
	    }
	  });
	}
	
	/**
	 * @api private
	 */
	module.exports = ResourceWaiter;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var util = __webpack_require__(34);
	var QueryParamSerializer = __webpack_require__(1021);
	var Shape = __webpack_require__(157);
	var populateHostPrefix = __webpack_require__(276).populateHostPrefix;
	
	function buildRequest(req) {
	  var operation = req.service.api.operations[req.operation];
	  var httpRequest = req.httpRequest;
	  httpRequest.headers['Content-Type'] =
	    'application/x-www-form-urlencoded; charset=utf-8';
	  httpRequest.params = {
	    Version: req.service.api.apiVersion,
	    Action: operation.name
	  };
	
	  // convert the request parameters into a list of query params,
	  // e.g. Deeply.NestedParam.0.Name=value
	  var builder = new QueryParamSerializer();
	  builder.serialize(req.params, operation.input, function(name, value) {
	    httpRequest.params[name] = value;
	  });
	  httpRequest.body = util.queryParamsToString(httpRequest.params);
	
	  populateHostPrefix(req);
	}
	
	function extractError(resp) {
	  var data, body = resp.httpResponse.body.toString();
	  if (body.match('<UnknownOperationException')) {
	    data = {
	      Code: 'UnknownOperation',
	      Message: 'Unknown operation ' + resp.request.operation
	    };
	  } else {
	    try {
	      data = new AWS.XML.Parser().parse(body);
	    } catch (e) {
	      data = {
	        Code: resp.httpResponse.statusCode,
	        Message: resp.httpResponse.statusMessage
	      };
	    }
	  }
	
	  if (data.requestId && !resp.requestId) resp.requestId = data.requestId;
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  var req = resp.request;
	  var operation = req.service.api.operations[req.operation];
	  var shape = operation.output || {};
	  var origRules = shape;
	
	  if (origRules.resultWrapper) {
	    var tmp = Shape.create({type: 'structure'});
	    tmp.members[origRules.resultWrapper] = shape;
	    tmp.memberNames = [origRules.resultWrapper];
	    util.property(shape, 'name', shape.resultWrapper);
	    shape = tmp;
	  }
	
	  var parser = new AWS.XML.Parser();
	
	  // TODO: Refactor XML Parser to parse RequestId from response.
	  if (shape && shape.members && !shape.members._XAMZRequestId) {
	    var requestIdShape = Shape.create(
	      { type: 'string' },
	      { api: { protocol: 'query' } },
	      'requestId'
	    );
	    shape.members._XAMZRequestId = requestIdShape;
	  }
	
	  var data = parser.parse(resp.httpResponse.body.toString(), shape);
	  resp.requestId = data._XAMZRequestId || data.requestId;
	
	  if (data._XAMZRequestId) delete data._XAMZRequestId;
	
	  if (origRules.resultWrapper) {
	    if (data[origRules.resultWrapper]) {
	      util.update(data, data[origRules.resultWrapper]);
	      delete data[origRules.resultWrapper];
	    }
	  }
	
	  resp.data = data;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	var Rest = __webpack_require__(191);
	var Json = __webpack_require__(277);
	var JsonBuilder = __webpack_require__(274);
	var JsonParser = __webpack_require__(275);
	
	function populateBody(req) {
	  var builder = new JsonBuilder();
	  var input = req.service.api.operations[req.operation].input;
	
	  if (input.payload) {
	    var params = {};
	    var payloadShape = input.members[input.payload];
	    params = req.params[input.payload];
	    if (params === undefined) return;
	
	    if (payloadShape.type === 'structure') {
	      req.httpRequest.body = builder.build(params, payloadShape);
	      applyContentTypeHeader(req);
	    } else { // non-JSON payload
	      req.httpRequest.body = params;
	      if (payloadShape.type === 'binary' || payloadShape.isStreaming) {
	        applyContentTypeHeader(req, true);
	      }
	    }
	  } else {
	    var body = builder.build(req.params, input);
	    if (body !== '{}' || req.httpRequest.method !== 'GET') { //don't send empty body for GET method
	      req.httpRequest.body = body;
	    }
	    applyContentTypeHeader(req);
	  }
	}
	
	function applyContentTypeHeader(req, isBinary) {
	  var operation = req.service.api.operations[req.operation];
	  var input = operation.input;
	
	  if (!req.httpRequest.headers['Content-Type']) {
	    var type = isBinary ? 'binary/octet-stream' : 'application/json';
	    req.httpRequest.headers['Content-Type'] = type;
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on HEAD/DELETE
	  if (['HEAD', 'DELETE'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Json.extractError(resp);
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var req = resp.request;
	  var operation = req.service.api.operations[req.operation];
	  var rules = req.service.api.operations[req.operation].output || {};
	  var parser;
	  var hasEventOutput = operation.hasEventOutput;
	
	  if (rules.payload) {
	    var payloadMember = rules.members[rules.payload];
	    var body = resp.httpResponse.body;
	    if (payloadMember.isEventStream) {
	      parser = new JsonParser();
	      resp.data[payload] = util.createEventStream(
	        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : body,
	        parser,
	        payloadMember
	      );
	    } else if (payloadMember.type === 'structure' || payloadMember.type === 'list') {
	      var parser = new JsonParser();
	      resp.data[rules.payload] = parser.parse(body, payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[rules.payload] = body;
	    } else {
	      resp.data[rules.payload] = payloadMember.toType(body);
	    }
	  } else {
	    var data = resp.data;
	    Json.extractData(resp);
	    resp.data = util.merge(data, resp.data);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var util = __webpack_require__(34);
	var Rest = __webpack_require__(191);
	
	function populateBody(req) {
	  var input = req.service.api.operations[req.operation].input;
	  var builder = new AWS.XML.Builder();
	  var params = req.params;
	
	  var payload = input.payload;
	  if (payload) {
	    var payloadMember = input.members[payload];
	    params = params[payload];
	    if (params === undefined) return;
	
	    if (payloadMember.type === 'structure') {
	      var rootElement = payloadMember.name;
	      req.httpRequest.body = builder.toXML(params, payloadMember, rootElement, true);
	    } else { // non-xml payload
	      req.httpRequest.body = params;
	    }
	  } else {
	    req.httpRequest.body = builder.toXML(params, input, input.name ||
	      input.shape || util.string.upperFirst(req.operation) + 'Request');
	  }
	}
	
	function buildRequest(req) {
	  Rest.buildRequest(req);
	
	  // never send body payload on GET/HEAD
	  if (['GET', 'HEAD'].indexOf(req.httpRequest.method) < 0) {
	    populateBody(req);
	  }
	}
	
	function extractError(resp) {
	  Rest.extractError(resp);
	
	  var data;
	  try {
	    data = new AWS.XML.Parser().parse(resp.httpResponse.body.toString());
	  } catch (e) {
	    data = {
	      Code: resp.httpResponse.statusCode,
	      Message: resp.httpResponse.statusMessage
	    };
	  }
	
	  if (data.Errors) data = data.Errors;
	  if (data.Error) data = data.Error;
	  if (data.Code) {
	    resp.error = util.error(new Error(), {
	      code: data.Code,
	      message: data.Message
	    });
	  } else {
	    resp.error = util.error(new Error(), {
	      code: resp.httpResponse.statusCode,
	      message: null
	    });
	  }
	}
	
	function extractData(resp) {
	  Rest.extractData(resp);
	
	  var parser;
	  var req = resp.request;
	  var body = resp.httpResponse.body;
	  var operation = req.service.api.operations[req.operation];
	  var output = operation.output;
	
	  var hasEventOutput = operation.hasEventOutput;
	
	  var payload = output.payload;
	  if (payload) {
	    var payloadMember = output.members[payload];
	    if (payloadMember.isEventStream) {
	      parser = new AWS.XML.Parser();
	      resp.data[payload] = util.createEventStream(
	        AWS.HttpClient.streamsApiVersion === 2 ? resp.httpResponse.stream : resp.httpResponse.body,
	        parser,
	        payloadMember
	      );
	    } else if (payloadMember.type === 'structure') {
	      parser = new AWS.XML.Parser();
	      resp.data[payload] = parser.parse(body.toString(), payloadMember);
	    } else if (payloadMember.type === 'binary' || payloadMember.isStreaming) {
	      resp.data[payload] = body;
	    } else {
	      resp.data[payload] = payloadMember.toType(body);
	    }
	  } else if (body.length > 0) {
	    parser = new AWS.XML.Parser();
	    var data = parser.parse(body.toString(), output);
	    util.update(resp.data, data);
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	  buildRequest: buildRequest,
	  extractError: extractError,
	  extractData: extractData
	};


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	/**
	 * @api private
	 * @!method on(eventName, callback)
	 *   Registers an event listener callback for the event given by `eventName`.
	 *   Parameters passed to the callback function depend on the individual event
	 *   being triggered. See the event documentation for those parameters.
	 *
	 *   @param eventName [String] the event name to register the listener for
	 *   @param callback [Function] the listener callback function
	 *   @param toHead [Boolean] attach the listener callback to the head of callback array if set to true.
	 *     Default to be false.
	 *   @return [AWS.SequentialExecutor] the same object for chaining
	 */
	AWS.SequentialExecutor = AWS.util.inherit({
	
	  constructor: function SequentialExecutor() {
	    this._events = {};
	  },
	
	  /**
	   * @api private
	   */
	  listeners: function listeners(eventName) {
	    return this._events[eventName] ? this._events[eventName].slice(0) : [];
	  },
	
	  on: function on(eventName, listener, toHead) {
	    if (this._events[eventName]) {
	      toHead ?
	        this._events[eventName].unshift(listener) :
	        this._events[eventName].push(listener);
	    } else {
	      this._events[eventName] = [listener];
	    }
	    return this;
	  },
	
	  onAsync: function onAsync(eventName, listener, toHead) {
	    listener._isAsync = true;
	    return this.on(eventName, listener, toHead);
	  },
	
	  removeListener: function removeListener(eventName, listener) {
	    var listeners = this._events[eventName];
	    if (listeners) {
	      var length = listeners.length;
	      var position = -1;
	      for (var i = 0; i < length; ++i) {
	        if (listeners[i] === listener) {
	          position = i;
	        }
	      }
	      if (position > -1) {
	        listeners.splice(position, 1);
	      }
	    }
	    return this;
	  },
	
	  removeAllListeners: function removeAllListeners(eventName) {
	    if (eventName) {
	      delete this._events[eventName];
	    } else {
	      this._events = {};
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  emit: function emit(eventName, eventArgs, doneCallback) {
	    if (!doneCallback) doneCallback = function() { };
	    var listeners = this.listeners(eventName);
	    var count = listeners.length;
	    this.callListeners(listeners, eventArgs, doneCallback);
	    return count > 0;
	  },
	
	  /**
	   * @api private
	   */
	  callListeners: function callListeners(listeners, args, doneCallback, prevError) {
	    var self = this;
	    var error = prevError || null;
	
	    function callNextListener(err) {
	      if (err) {
	        error = AWS.util.error(error || new Error(), err);
	        if (self._haltHandlersOnError) {
	          return doneCallback.call(self, error);
	        }
	      }
	      self.callListeners(listeners, args, doneCallback, error);
	    }
	
	    while (listeners.length > 0) {
	      var listener = listeners.shift();
	      if (listener._isAsync) { // asynchronous listener
	        listener.apply(self, args.concat([callNextListener]));
	        return; // stop here, callNextListener will continue
	      } else { // synchronous listener
	        try {
	          listener.apply(self, args);
	        } catch (err) {
	          error = AWS.util.error(error || new Error(), err);
	        }
	        if (error && self._haltHandlersOnError) {
	          doneCallback.call(self, error);
	          return;
	        }
	      }
	    }
	    doneCallback.call(self, error);
	  },
	
	  /**
	   * Adds or copies a set of listeners from another list of
	   * listeners or SequentialExecutor object.
	   *
	   * @param listeners [map<String,Array<Function>>, AWS.SequentialExecutor]
	   *   a list of events and callbacks, or an event emitter object
	   *   containing listeners to add to this emitter object.
	   * @return [AWS.SequentialExecutor] the emitter object, for chaining.
	   * @example Adding listeners from a map of listeners
	   *   emitter.addListeners({
	   *     event1: [function() { ... }, function() { ... }],
	   *     event2: [function() { ... }]
	   *   });
	   *   emitter.emit('event1'); // emitter has event1
	   *   emitter.emit('event2'); // emitter has event2
	   * @example Adding listeners from another emitter object
	   *   var emitter1 = new AWS.SequentialExecutor();
	   *   emitter1.on('event1', function() { ... });
	   *   emitter1.on('event2', function() { ... });
	   *   var emitter2 = new AWS.SequentialExecutor();
	   *   emitter2.addListeners(emitter1);
	   *   emitter2.emit('event1'); // emitter2 has event1
	   *   emitter2.emit('event2'); // emitter2 has event2
	   */
	  addListeners: function addListeners(listeners) {
	    var self = this;
	
	    // extract listeners if parameter is an SequentialExecutor object
	    if (listeners._events) listeners = listeners._events;
	
	    AWS.util.each(listeners, function(event, callbacks) {
	      if (typeof callbacks === 'function') callbacks = [callbacks];
	      AWS.util.arrayEach(callbacks, function(callback) {
	        self.on(event, callback);
	      });
	    });
	
	    return self;
	  },
	
	  /**
	   * Registers an event with {on} and saves the callback handle function
	   * as a property on the emitter object using a given `name`.
	   *
	   * @param name [String] the property name to set on this object containing
	   *   the callback function handle so that the listener can be removed in
	   *   the future.
	   * @param (see on)
	   * @return (see on)
	   * @example Adding a named listener DATA_CALLBACK
	   *   var listener = function() { doSomething(); };
	   *   emitter.addNamedListener('DATA_CALLBACK', 'data', listener);
	   *
	   *   // the following prints: true
	   *   console.log(emitter.DATA_CALLBACK == listener);
	   */
	  addNamedListener: function addNamedListener(name, eventName, callback, toHead) {
	    this[name] = callback;
	    this.addListener(eventName, callback, toHead);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  addNamedAsyncListener: function addNamedAsyncListener(name, eventName, callback, toHead) {
	    callback._isAsync = true;
	    return this.addNamedListener(name, eventName, callback, toHead);
	  },
	
	  /**
	   * Helper method to add a set of named listeners using
	   * {addNamedListener}. The callback contains a parameter
	   * with a handle to the `addNamedListener` method.
	   *
	   * @callback callback function(add)
	   *   The callback function is called immediately in order to provide
	   *   the `add` function to the block. This simplifies the addition of
	   *   a large group of named listeners.
	   *   @param add [Function] the {addNamedListener} function to call
	   *     when registering listeners.
	   * @example Adding a set of named listeners
	   *   emitter.addNamedListeners(function(add) {
	   *     add('DATA_CALLBACK', 'data', function() { ... });
	   *     add('OTHER', 'otherEvent', function() { ... });
	   *     add('LAST', 'lastEvent', function() { ... });
	   *   });
	   *
	   *   // these properties are now set:
	   *   emitter.DATA_CALLBACK;
	   *   emitter.OTHER;
	   *   emitter.LAST;
	   */
	  addNamedListeners: function addNamedListeners(callback) {
	    var self = this;
	    callback(
	      function() {
	        self.addNamedListener.apply(self, arguments);
	      },
	      function() {
	        self.addNamedAsyncListener.apply(self, arguments);
	      }
	    );
	    return this;
	  }
	});
	
	/**
	 * {on} is the prefered method.
	 * @api private
	 */
	AWS.SequentialExecutor.prototype.addListener = AWS.SequentialExecutor.prototype.on;
	
	/**
	 * @api private
	 */
	module.exports = AWS.SequentialExecutor;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V3 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    var datetime = AWS.util.date.rfc822(date);
	
	    this.request.headers['X-Amz-Date'] = datetime;
	
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    this.request.headers['X-Amzn-Authorization'] =
	      this.authorization(credentials, datetime);
	
	  },
	
	  authorization: function authorization(credentials) {
	    return 'AWS3 ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'SignedHeaders=' + this.signedHeaders() + ',' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  signedHeaders: function signedHeaders() {
	    var headers = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      headers.push(h.toLowerCase());
	    });
	    return headers.sort().join(';');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = this.request.headers;
	    var parts = [];
	    AWS.util.arrayEach(this.headersToSign(), function iterator(h) {
	      parts.push(h.toLowerCase().trim() + ':' + String(headers[h]).trim());
	    });
	    return parts.sort().join('\n') + '\n';
	  },
	
	  headersToSign: function headersToSign() {
	    var headers = [];
	    AWS.util.each(this.request.headers, function iterator(k) {
	      if (k === 'Host' || k === 'Content-Encoding' || k.match(/^X-Amz/i)) {
	        headers.push(k);
	      }
	    });
	    return headers;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push('/');
	    parts.push('');
	    parts.push(this.canonicalHeaders());
	    parts.push(this.request.body);
	    return AWS.util.crypto.sha256(parts.join('\n'));
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V3;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	/**
	 * @api private
	 */
	var cachedSecret = {};
	
	/**
	 * @api private
	 */
	var cacheQueue = [];
	
	/**
	 * @api private
	 */
	var maxCacheEntries = 50;
	
	/**
	 * @api private
	 */
	var v4Identifier = 'aws4_request';
	
	/**
	 * @api private
	 */
	module.exports = {
	  /**
	   * @api private
	   *
	   * @param date [String]
	   * @param region [String]
	   * @param serviceName [String]
	   * @return [String]
	   */
	  createScope: function createScope(date, region, serviceName) {
	    return [
	      date.substr(0, 8),
	      region,
	      serviceName,
	      v4Identifier
	    ].join('/');
	  },
	
	  /**
	   * @api private
	   *
	   * @param credentials [Credentials]
	   * @param date [String]
	   * @param region [String]
	   * @param service [String]
	   * @param shouldCache [Boolean]
	   * @return [String]
	   */
	  getSigningKey: function getSigningKey(
	    credentials,
	    date,
	    region,
	    service,
	    shouldCache
	  ) {
	    var credsIdentifier = AWS.util.crypto
	      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
	    var cacheKey = [credsIdentifier, date, region, service].join('_');
	    shouldCache = shouldCache !== false;
	    if (shouldCache && (cacheKey in cachedSecret)) {
	      return cachedSecret[cacheKey];
	    }
	
	    var kDate = AWS.util.crypto.hmac(
	      'AWS4' + credentials.secretAccessKey,
	      date,
	      'buffer'
	    );
	    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
	    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');
	
	    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
	    if (shouldCache) {
	      cachedSecret[cacheKey] = signingKey;
	      cacheQueue.push(cacheKey);
	      if (cacheQueue.length > maxCacheEntries) {
	        // remove the oldest entry (not the least recently used)
	        delete cachedSecret[cacheQueue.shift()];
	      }
	    }
	
	    return signingKey;
	  },
	
	  /**
	   * @api private
	   *
	   * Empties the derived signing key cache. Made available for testing purposes
	   * only.
	   */
	  emptyCache: function emptyCache() {
	    cachedSecret = {};
	    cacheQueue = [];
	  }
	};


/***/ },
/* 438 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([bth[buf[i++]], bth[buf[i++]], 
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]], '-',
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]],
		bth[buf[i++]], bth[buf[i++]]]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 439 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 440 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var allPositions = exports.allPositions = {
	  D1: [{
	    position: 'QBDT',
	    feet: 6,
	    inches: 4,
	    weight: 220,
	    t40: 4.5,
	    description: ''
	  }, {
	    position: 'QBPS',
	    feet: 6,
	    inches: 4,
	    weight: 220,
	    t40: 4.9,
	    description: ''
	  }, {
	    position: 'WR',
	    feet: 6,
	    inches: 2,
	    weight: 190,
	    t40: 4.5,
	    description: ''
	  }, {
	    position: 'SR',
	    feet: 6,
	    inches: 0,
	    weight: 190,
	    t40: 4.5,
	    description: ''
	  }, {
	    position: 'RB',
	    feet: 6,
	    inches: 0,
	    weight: 210,
	    t40: 4.4,
	    description: ''
	  }, {
	    position: 'FB',
	    feet: 6,
	    inches: 0,
	    weight: 230,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'HB',
	    feet: 6,
	    inches: 4,
	    weight: 230,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'TE',
	    feet: 6,
	    inches: 4,
	    weight: 230,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'C',
	    feet: 6,
	    inches: 5,
	    weight: 280,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'OG',
	    feet: 6,
	    inches: 6,
	    weight: 280,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'OT',
	    feet: 6,
	    inches: 7,
	    weight: 280,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'DT',
	    feet: 6,
	    inches: 4,
	    weight: 270,
	    t40: 4.8,
	    description: ''
	  }, {
	    position: 'DE',
	    feet: 6,
	    inches: 4,
	    weight: 230,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'ML',
	    feet: 6,
	    inches: 2,
	    weight: 220,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'OL',
	    feet: 6,
	    inches: 2,
	    weight: 220,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'DB',
	    feet: 6,
	    inches: 0,
	    weight: 185,
	    t40: 4.5,
	    description: ''
	  }, {
	    position: 'SS',
	    feet: 6,
	    inches: 2,
	    weight: 200,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'FS',
	    feet: 6,
	    inches: 2,
	    weight: 190,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'K',
	    feet: 6,
	    inches: 2,
	    weight: 190,
	    t40: 5,
	    description: 'Kick Offs D1 FBS Avg. Distance,65 Yards Longest,70+ Yards Avg. Hang Time,3.8 seconds Best Hang Time,4.3 seconds Field Goals D1 FBS/FCS/JUCO Hit 3 to 5 FG’s from long range (55-60 yards)'
	  }, {
	    position: 'P',
	    feet: 6,
	    inches: 2,
	    weight: 190,
	    t40: 5,
	    description: 'D1 FBS Avg. Distance,48 Yards Longest,60 Yards Avg. Hang Time,4.6 seconds Best Hang Time,5.0+ seconds'
	  }, {
	    position: 'LS',
	    feet: 6,
	    inches: 5,
	    weight: 260,
	    t40: 5,
	    description: 'FBS       .65 to .70 seconds        100% within 10 inches of target\n80% On Target 15 Yard Snap Average Time Accuracy'
	  }],
	  JUCO: [{
	    position: 'QBDT',
	    feet: 6,
	    inches: 2,
	    weight: 200,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'QBPS',
	    feet: 6,
	    inches: 2,
	    weight: 200,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'WR',
	    feet: 6,
	    inches: 0,
	    weight: 175,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'SR',
	    feet: 6,
	    inches: 0,
	    weight: 175,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'RB',
	    feet: 5,
	    inches: 11,
	    weight: 195,
	    t40: 4.5,
	    description: ''
	  }, {
	    position: 'FB',
	    feet: 5,
	    inches: 11,
	    weight: 215,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'HB',
	    feet: 6,
	    inches: 3,
	    weight: 220,
	    t40: 4.8,
	    description: ''
	  }, {
	    position: 'TE',
	    feet: 6,
	    inches: 3,
	    weight: 220,
	    t40: 4.8,
	    description: ''
	  }, {
	    position: 'C',
	    feet: 6,
	    inches: 2,
	    weight: 270,
	    t40: 5.2,
	    description: ''
	  }, {
	    position: 'OG',
	    feet: 6,
	    inches: 4,
	    weight: 270,
	    t40: 5.2,
	    description: ''
	  }, {
	    position: 'OT',
	    feet: 6,
	    inches: 6,
	    weight: 270,
	    t40: 5.2,
	    description: ''
	  }, {
	    position: 'DT',
	    feet: 6,
	    inches: 3,
	    weight: 250,
	    t40: 4.9,
	    description: ''
	  }, {
	    position: 'DE',
	    feet: 6,
	    inches: 3,
	    weight: 230,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'ML',
	    feet: 6,
	    inches: 1,
	    weight: 210,
	    t40: 4.65,
	    description: ''
	  }, {
	    position: 'OL',
	    feet: 6,
	    inches: 1,
	    weight: 210,
	    t40: 4.65,
	    description: ''
	  }, {
	    position: 'DB',
	    feet: 6,
	    inches: 0,
	    weight: 185,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'SS',
	    feet: 6,
	    inches: 1,
	    weight: 190,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'FS',
	    feet: 6,
	    inches: 1,
	    weight: 190,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'K',
	    feet: 6,
	    inches: 0,
	    weight: 175,
	    t40: 5,
	    description: 'Kick Offs JUCO Avg. Distance, 62 Yards Longest, 65+ Yards Avg. Hang Time, 3.6 seconds Best Hang Time, 4.1+ seconds'
	  }, {
	    position: 'P',
	    feet: 6,
	    inches: 0,
	    weight: 175,
	    t40: 5,
	    description: 'JUCO Avg. Distance, 45 Yards Longest, 55 Yards Avg. Hang Time, 4.4 seconds Best Hang Time,  4.85 seconds'
	  }, {
	    position: 'LS',
	    feet: 6,
	    inches: 3,
	    weight: 250,
	    t40: 5.2,
	    description: 'JUCO .70 to .75 seconds 100% within 10 inches of target  80% On Target 15 Yard Snap Average Time Accuracy'
	  }],
	  D2: [{
	    position: 'QBDT',
	    feet: 6,
	    weight: 200,
	    inches: 0,
	    t40: 4.7,
	    Description: ''
	  }, {
	    position: 'QBPS',
	    feet: 6,
	    weight: 200,
	    inches: 0,
	    t40: 5,
	    Description: ''
	  }, {
	    position: 'WR',
	    feet: 5,
	    weight: 165,
	    inches: 10,
	    t40: 4.6,
	    Description: ''
	  }, {
	    position: 'SR',
	    feet: 5,
	    weight: 165,
	    inches: 10,
	    t40: 4.6,
	    Description: ''
	  }, {
	    position: 'RB',
	    feet: 5,
	    weight: 175,
	    inches: 10,
	    t40: 4.6,
	    Description: ''
	  }, {
	    position: 'FB',
	    feet: 5,
	    weight: 195,
	    inches: 10,
	    t40: 4.6,
	    Description: ''
	  }, {
	    position: 'HB',
	    feet: 6,
	    weight: 215,
	    inches: 2,
	    t40: 4.85,
	    Description: ''
	  }, {
	    position: 'TE',
	    feet: 6,
	    weight: 215,
	    inches: 2,
	    t40: 4.85,
	    Description: ''
	  }, {
	    position: 'C',
	    feet: 6,
	    weight: 260,
	    inches: 1,
	    t40: 5.3,
	    Description: ''
	  }, {
	    position: 'OG',
	    feet: 6,
	    weight: 260,
	    inches: 3,
	    t40: 5.3,
	    Description: ''
	  }, {
	    position: 'OT',
	    feet: 6,
	    weight: 260,
	    inches: 5,
	    t40: 5.3,
	    Description: ''
	  }, {
	    position: 'DT',
	    feet: 6,
	    weight: 240,
	    inches: 2,
	    t40: 5,
	    Description: ''
	  }, {
	    position: 'DE',
	    feet: 6,
	    weight: 220,
	    inches: 2,
	    t40: 4.8,
	    Description: ''
	  }, {
	    position: 'ML',
	    feet: 6,
	    weight: 200,
	    inches: 0,
	    t40: 4.7,
	    Description: ''
	  }, {
	    position: 'OL',
	    feet: 6,
	    weight: 200,
	    inches: 0,
	    t40: 4.7,
	    Description: ''
	  }, {
	    position: 'DE',
	    feet: 5,
	    weight: 175,
	    inches: 10,
	    t40: 4.65,
	    Description: ''
	  }, {
	    position: 'SS',
	    feet: 5,
	    weight: 185,
	    inches: 11,
	    t40: 4.7,
	    Description: ''
	  }, {
	    position: 'FS',
	    feet: 5,
	    weight: 185,
	    inches: 11,
	    t40: 4.7,
	    Description: ''
	  }, {
	    position: 'K',
	    feet: 5,
	    weight: 165,
	    inches: 10,
	    t40: 5,
	    Description: 'Kick Offs Division 2        Avg. Distance,60+ Yards        Longest,65 Yards Avg. Hang Time,3.5 seconds        Best Hang Time,4.0+ seconds\nField Goals D2/NAIA   Hit 3 to 5 FG’s from medium-long range (45 yards)'
	  }, {
	    position: 'P',
	    feet: 5,
	    weight: 165,
	    inches: 10,
	    t40: 5,
	    Description: 'Division 2        Avg. Distance,43 Yards           Longest,53 Yards        Avg. Hang Time,4.2 seconds        Best Hang Time,4.75 seconds'
	  }, {
	    position: 'LS',
	    feet: 6,
	    weight: 240,
	    inches: 1,
	    t40: 5.3,
	    Description: 'Division 2        .75 to .78 seconds        80% within 10 inches of target\n60% On Target 15 Yard Snap Average Time Accuracy'
	  }],
	  NAIA: [{
	    position: 'QBDT',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'QBPS',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'WR',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'SR',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'RB',
	    feet: 5,
	    inches: 10,
	    weight: 175,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'FB',
	    feet: 5,
	    inches: 10,
	    weight: 195,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'HB',
	    feet: 6,
	    inches: 2,
	    weight: 215,
	    t40: 4.85,
	    description: ''
	  }, {
	    position: 'TE',
	    feet: 6,
	    inches: 2,
	    weight: 215,
	    t40: 4.85,
	    description: ''
	  }, {
	    position: 'C',
	    feet: 6,
	    inches: 1,
	    weight: 260,
	    t40: 5.3,
	    description: ''
	  }, {
	    position: 'OG',
	    feet: 6,
	    inches: 3,
	    weight: 260,
	    t40: 5.3,
	    description: ''
	  }, {
	    position: 'OT',
	    feet: 6,
	    inches: 5,
	    weight: 260,
	    t40: 5.3,
	    description: ''
	  }, {
	    position: 'DT',
	    feet: 6,
	    inches: 2,
	    weight: 240,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'DE',
	    feet: 6,
	    inches: 2,
	    weight: 220,
	    t40: 4.8,
	    description: ''
	  }, {
	    position: 'ML',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'OL',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'DE',
	    feet: 5,
	    inches: 10,
	    weight: 175,
	    t40: 4.65,
	    description: ''
	  }, {
	    position: 'SS',
	    feet: 5,
	    inches: 11,
	    weight: 185,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'FS',
	    feet: 5,
	    inches: 11,
	    weight: 185,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'K',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 5,
	    description: 'Kick Offs NAIA        Avg. Distance,60+ Yards        Longest,65 Yards Avg. Hang Time,3.5 seconds        Best Hang Time,4.0+ seconds\nField Goals D2/NAIA   Hit 3 to 5 FG’s from medium-long range (45 yards)'
	  }, {
	    position: 'P',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 5,
	    description: 'NAIA            Avg. Distance,43 Yards           Longest,53 Yards        Avg. Hang Time,4.2 seconds        Best Hang Time,4.75 seconds'
	  }, {
	    position: 'LS',
	    feet: 6,
	    inches: 1,
	    weight: 240,
	    t40: 5.3,
	    description: 'NAIA        .75 to .78 seconds        80% within 10 inches of target\n60% On Target 15 Yard Snap Average Time Accuracy'
	  }],
	  D3: [{
	    position: 'QBDT',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'QBPS',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'WR',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'SR',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'RB',
	    feet: 5,
	    inches: 10,
	    weight: 175,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'FB',
	    feet: 5,
	    inches: 10,
	    weight: 195,
	    t40: 4.6,
	    description: ''
	  }, {
	    position: 'HB',
	    feet: 6,
	    inches: 2,
	    weight: 215,
	    t40: 4.85,
	    description: ''
	  }, {
	    position: 'TE',
	    feet: 6,
	    inches: 2,
	    weight: 215,
	    t40: 4.85,
	    description: ''
	  }, {
	    position: 'C',
	    feet: 6,
	    inches: 1,
	    weight: 260,
	    t40: 5.3,
	    description: ''
	  }, {
	    position: 'OG',
	    feet: 6,
	    inches: 3,
	    weight: 260,
	    t40: 5.3,
	    description: ''
	  }, {
	    position: 'OT',
	    feet: 6,
	    inches: 5,
	    weight: 260,
	    t40: 5.3,
	    description: ''
	  }, {
	    position: 'DT',
	    feet: 6,
	    inches: 2,
	    weight: 240,
	    t40: 5,
	    description: ''
	  }, {
	    position: 'DE',
	    feet: 6,
	    inches: 2,
	    weight: 220,
	    t40: 4.8,
	    description: ''
	  }, {
	    position: 'ML',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'OL',
	    feet: 6,
	    inches: 0,
	    weight: 200,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'DE',
	    feet: 5,
	    inches: 10,
	    weight: 175,
	    t40: 4.65,
	    description: ''
	  }, {
	    position: 'SS',
	    feet: 5,
	    inches: 11,
	    weight: 185,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'FS',
	    feet: 5,
	    inches: 11,
	    weight: 185,
	    t40: 4.7,
	    description: ''
	  }, {
	    position: 'K',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 5,
	    description: 'Kick Offs NAIA        Avg. Distance,60+ Yards        Longest,65 Yards Avg. Hang Time,3.5 seconds        Best Hang Time,4.0+ seconds\nField Goals D2/NAIA   Hit 3 to 5 FG’s from medium-long range (45 yards)'
	  }, {
	    position: 'P',
	    feet: 5,
	    inches: 10,
	    weight: 165,
	    t40: 5,
	    description: 'NAIA            Avg. Distance,43 Yards           Longest,53 Yards        Avg. Hang Time,4.2 seconds        Best Hang Time,4.75 seconds'
	  }, {
	    position: 'LS',
	    feet: 6,
	    inches: 1,
	    weight: 240,
	    t40: 5.3,
	    description: 'NAIA        .75 to .78 seconds        80% within 10 inches of target\n60% On Target 15 Yard Snap Average Time Accuracy'
	  }]
	};
	
	var abc = exports.abc = {};

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _service = __webpack_require__(1071);
	
	Object.defineProperty(exports, 'getSchools', {
	    enumerable: true,
	    get: function get() {
	        return _service.getSchools;
	    }
	});
	Object.defineProperty(exports, 'getPostings', {
	    enumerable: true,
	    get: function get() {
	        return _service.getPostings;
	    }
	});
	Object.defineProperty(exports, 'addToWishList', {
	    enumerable: true,
	    get: function get() {
	        return _service.addToWishList;
	    }
	});
	Object.defineProperty(exports, 'totalCountsForDashboard', {
	    enumerable: true,
	    get: function get() {
	        return _service.totalCountsForDashboard;
	    }
	});
	Object.defineProperty(exports, 'addStudentCurrentDivision', {
	    enumerable: true,
	    get: function get() {
	        return _service.addStudentCurrentDivision;
	    }
	});
	Object.defineProperty(exports, 'addToRequest', {
	    enumerable: true,
	    get: function get() {
	        return _service.addToRequest;
	    }
	});
	Object.defineProperty(exports, 'getRequests', {
	    enumerable: true,
	    get: function get() {
	        return _service.getRequests;
	    }
	});
	Object.defineProperty(exports, 'removeFromList', {
	    enumerable: true,
	    get: function get() {
	        return _service.removeFromList;
	    }
	});
	Object.defineProperty(exports, 'addConversation', {
	    enumerable: true,
	    get: function get() {
	        return _service.addConversation;
	    }
	});
	Object.defineProperty(exports, 'getRequestsCoach', {
	    enumerable: true,
	    get: function get() {
	        return _service.getRequestsCoach;
	    }
	});
	Object.defineProperty(exports, 'getdivisionstudents', {
	    enumerable: true,
	    get: function get() {
	        return _service.getdivisionstudents;
	    }
	});
	Object.defineProperty(exports, 'getfilterbasedstudents', {
	    enumerable: true,
	    get: function get() {
	        return _service.getfilterbasedstudents;
	    }
	});
	Object.defineProperty(exports, 'getTotalRequestViewedCount', {
	    enumerable: true,
	    get: function get() {
	        return _service.getTotalRequestViewedCount;
	    }
	});

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _service = __webpack_require__(1074);
	
	Object.defineProperty(exports, 'getClientToken', {
	  enumerable: true,
	  get: function get() {
	    return _service.getClientToken;
	  }
	});
	Object.defineProperty(exports, 'submitPaymentNonce', {
	  enumerable: true,
	  get: function get() {
	    return _service.submitPaymentNonce;
	  }
	});
	Object.defineProperty(exports, 'postSubscription', {
	  enumerable: true,
	  get: function get() {
	    return _service.postSubscription;
	  }
	});
	Object.defineProperty(exports, 'postSubscriptionCS', {
	  enumerable: true,
	  get: function get() {
	    return _service.postSubscriptionCS;
	  }
	});
	Object.defineProperty(exports, 'getPayments', {
	  enumerable: true,
	  get: function get() {
	    return _service.getPayments;
	  }
	});

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = validateData;
	
	var _Regularexpression = __webpack_require__(65);
	
	function validateData(data) {
	  var updated = {};
	
	  // validation for college
	  if (data.college !== undefined) {
	    var enteredCollege = _typeof(data.college);
	    if (data.college.length > 5 && enteredCollege === 'string') {
	      updated.collegeIsValid = true;
	    } else {
	      updated.collegeErrorMessage = 'Please enter a valid college.';
	    }
	  } else {
	    updated.collegeErrorMessage = 'Please enter college details';
	  }
	  // twitter validation
	  if (data.college_twitter !== undefined) {
	    if (data.college_twitter.trim()[0] === '@') {
	      updated.twitterIsValid = true;
	    } else {
	      updated.twitterErrorMessage = 'Please enter valid twitter account';
	    }
	  } else {
	    updated.twitterErrorMessage = 'Please enter twitter details';
	  }
	  // city validations
	  if (data.city !== undefined) {
	    var enteredCity = _typeof(data.city);
	    if (data.city.length >= 3 && enteredCity === 'string') {
	      updated.cityIsValid = true;
	    } else {
	      updated.cityErrorMessage = 'Entered city is not valid.';
	    }
	  } else {
	    updated.cityErrorMessage = 'Please enter college details';
	  }
	
	  if (data.state !== undefined) {
	    var enteredState = _typeof(data.state);
	    if (data.state.length >= 2 && enteredState === 'string') {
	      updated.stateIsValid = true;
	    } else {
	      updated.stateErrorMessage = 'Entered state is not valid.';
	    }
	  } else {
	    updated.stateErrorMessage = 'Please enter state.';
	  }
	
	  // validation for min gpa
	  if (data.min_gpa !== undefined) {
	    if (data.min_gpa <= 4 && data.min_gpa !== '' && !isNaN(data.min_gpa)) {
	      updated.gpaIsValid = true;
	    } else {
	      updated.minGpaErrorMessage = 'Please enter a valid min gpa.';
	    }
	  } else {
	    updated.minGpaErrorMessage = 'Please enter gpa.';
	  }
	
	  // validation for min act
	  if (data.min_act !== undefined) {
	    if (data.min_act !== '' && !isNaN(data.min_act)) {
	      updated.actIsValid = true;
	    } else {
	      updated.minActErrorMessage = 'Please enter a valid min act.';
	    }
	  } else {
	    updated.minActErrorMessage = 'Please enter act.';
	  }
	
	  // validation for division
	  if (data.division !== undefined) {
	    var division = data.division;
	
	    if (division === 'D1' || division === 'D2' || division === 'D3' || division === 'JUCO' || division === 'NAIA') {
	      updated.divisionIsValid = true;
	    } else {
	      updated.divisionErrorMessage = 'Select a division from list.';
	    }
	  } else {
	    updated.divisionErrorMessage = 'Please select a division.';
	  }
	
	  // team page validation
	  if (data.team_page_link !== undefined) {
	    var validUrl = _Regularexpression.regExForUrl.test(data.team_page_link);
	    if (validUrl && data.team_page_link !== '') {
	      updated.teamPageLinkIsValid = true;
	    } else {
	      updated.teamPageErrorMessage = 'Entered team page is not valid.';
	    }
	  } else {
	    updated.teamPageErrorMessage = 'Please add a team page url.';
	  }
	  // questionaire validation
	  if (data.question_link !== undefined) {
	    var _validUrl = _Regularexpression.regExForUrl.test(data.question_link);
	    if (_validUrl && data.question_link !== '') {
	      updated.questionLinkIsValid = true;
	    } else {
	      updated.questionLinkErrorMessage = 'Entered questionaire page is not valid.';
	    }
	  } else {
	    updated.questionLinkErrorMessage = 'Please add a questionaire page url.';
	  }
	
	  // validation for football conference
	  if (data.football_conf !== undefined) {
	    if (data.football_conf !== '') {
	      updated.footballConferenceIsValid = true;
	    } else {
	      updated.footballConferenceErrorMessage = 'Please add a football conference.';
	    }
	  } else {
	    updated.footballConferenceErrorMessage = 'Please add a football conference.';
	  }
	
	  // validation for football division
	  if (data.football_div !== undefined) {
	    if (data.football_div !== '') {
	      updated.footballDivisionIsValid = true;
	    } else {
	      updated.footballDivisionErrorMessage = 'Please add a football division';
	    }
	  } else {
	    updated.footballDivisionErrorMessage = 'Please add a football division';
	  }
	
	  // team page validation
	  if (data.video_url !== undefined) {
	    var _validUrl2 = false;
	    if (/^(f|ht)tps?:\/\//i.test(data.video_url)) {
	      _validUrl2 = true;
	    }
	    debugger; // eslint-disable-line
	    if (_validUrl2 && data.video_url !== '') {
	      updated.urlIsValid = true;
	    } else {
	      updated.urlErrorMessage = 'Enter a valid video link.';
	    }
	  } else {
	    updated.urlErrorMessage = 'Enter a valid video link.';
	  }
	
	  if (data.video_title !== undefined) {
	    var enteredTitle = _typeof(data.video_title);
	    if (data.video_title.length >= 3 && enteredTitle === 'string') {
	      updated.titleIsValid = true;
	    } else {
	      updated.titleErrorMessage = 'Please enter title.';
	    }
	  } else {
	    updated.titleErrorMessage = 'Please enter title.';
	  }
	
	  return updated;
	}

/***/ },
/* 444 */
[2526, 1084],
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddVideo = __webpack_require__(1087);
	
	var _AddVideo2 = _interopRequireDefault(_AddVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AddVideo2.default;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateVideo = updateVideo;
	exports.closeVideo = closeVideo;
	
	var _BannerActionTypes = __webpack_require__(447);
	
	function updateVideo() {
	  return function (dispatch) {
	    dispatch({
	      type: _BannerActionTypes.SHOW_VIDEO
	    });
	  };
	}
	
	function closeVideo() {
	  return function (dispatch) {
	    dispatch({
	      type: _BannerActionTypes.CLOSE_VIDEO
	    });
	  };
	}

/***/ },
/* 447 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CLOSE_VIDEO = exports.CLOSE_VIDEO = 'CLOSE_VIDEO';
	var SHOW_VIDEO = exports.SHOW_VIDEO = 'SHOW_VIDEO';

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Popup = __webpack_require__(1110);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Popup2.default;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.coachRegistration = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _reselect = __webpack_require__(40);
	
	var _immutable = __webpack_require__(11);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(279);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  requested: false,
	  coachRegistered: false,
	  profile: (0, _immutable.Map)(),
	  isLoading: false,
	  saved: false,
	  schools: {},
	  validCoachData: (0, _immutable.Map)(),
	  validateCoachRequested: false,
	  coachVerified: false,
	  requestCount: 0
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    coachRegistered: false,
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state) {
	  return state.merge({
	    requested: false,
	    coachRegistered: false,
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state) {
	  return state.merge({
	    requested: false,
	    coachRegistered: true,
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PROFILE_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    isLoading: false,
	    profile: action.data,
	    saved: true
	  });
	}), _defineProperty(_handlers, _actionTypes.SCHOOL_SEARCH, function (state, action) {
	  return state.merge({
	    schools: action.schools,
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_FROM_DATABASE_REQUESTED, function (state) {
	  return state.merge({
	    validateCoachRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_FROM_DATABASE_FAILED, function (state) {
	  return state.merge({
	    // validateCoachRequested: false,
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTER, function (state, action) {
	  return state.merge({
	    validateCoachRequested: false,
	    validCoachData: action.validCoach,
	    coachVerified: true
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    requested: false,
	    coachRegistered: false,
	    profile: (0, _immutable.Map)(),
	    isLoading: false,
	    saved: false,
	    schools: {}
	  });
	}), _handlers);
	
	var coachRegistration = exports.coachRegistration = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getRequested = function getRequested(state) {
	  return state.coachRegistration.get('requested');
	};
	var getCoachRegistered = function getCoachRegistered(state) {
	  return state.coachRegistration.get('coachRegistered');
	};
	var getProfile = function getProfile(state) {
	  return state.coachRegistration.get('profile');
	};
	var getLoading = function getLoading(state) {
	  return state.coachRegistration.get('isLoading');
	};
	var getSchools = function getSchools(state) {
	  return state.coachRegistration.get('schools');
	};
	var getvalidateCoachRequested = function getvalidateCoachRequested(state) {
	  return state.coachRegistration.get('validateCoachRequested');
	};
	var getValidCoachData = function getValidCoachData(state) {
	  return state.coachRegistration.get('validCoachData');
	};
	var getcoachVerified = function getcoachVerified(state) {
	  return state.coachRegistration.get('coachVerified');
	};
	var getrequestCount = function getrequestCount(state) {
	  return state.coachRegistration.get('requestCount');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  requested: getRequested,
	  coachRegistered: getCoachRegistered,
	  isLoading: getLoading,
	  profile: getProfile,
	  schools: getSchools,
	  validateCoachRequested: getvalidateCoachRequested,
	  validCoachData: getValidCoachData,
	  coachVerified: getcoachVerified,
	  requestCount: getrequestCount
	});

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _tabs = __webpack_require__(254);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CoachTabs = __webpack_require__(1479);
	
	var _CoachTabs2 = _interopRequireDefault(_CoachTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	// to import local scss fle
	
	var CoachTabs = function (_React$Component) {
	  _inherits(CoachTabs, _React$Component);
	
	  function CoachTabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CoachTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CoachTabs.__proto__ || Object.getPrototypeOf(CoachTabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: 0,
	      fixedIndex: 1,
	      inverseIndex: 1
	    }, _this.handleTabChange = function (index) {
	      _this.setState({ index: index });
	      _this.props.tabListener(index);
	    }, _this.handleActive = function () {
	      // eslint-disable-next-lint
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CoachTabs, [{
	    key: 'render',
	    value: function render() {
	      var division = this.props.division;
	
	      var renderD1Tab = (0, _renderIf2.default)(division === 'D1');
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _CoachTabs2.default.container) },
	        _react2.default.createElement(
	          _tabs.Tabs,
	          { index: this.state.index, onChange: this.handleTabChange },
	          _react2.default.createElement(_tabs.Tab, { label: 'My Requests', onActive: this.handleActive, activeClassName: _CoachTabs2.default.activeClass }),
	          _react2.default.createElement(_tabs.Tab, { label: 'Postings', activeClassName: _CoachTabs2.default.activeClass }),
	          _react2.default.createElement(_tabs.Tab, { label: 'Recommendations', activeClassName: _CoachTabs2.default.activeClass }),
	          renderD1Tab(_react2.default.createElement(_tabs.Tab, { label: 'D1 Students', activeClassName: _CoachTabs2.default.activeClass }))
	        )
	      );
	    }
	  }]);
	
	  return CoachTabs;
	}(_react2.default.Component);
	
	CoachTabs.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired,
	  division: _propTypes2.default.string.isRequired
	};
	exports.default = CoachTabs;

/***/ },
/* 451 */
[2529, 1119],
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSchools = getSchools;
	exports.getPostings = getPostings;
	exports.initProfile = initProfile;
	exports.getRequests = getRequests;
	exports.updateFilter = updateFilter;
	exports.addToList = addToList;
	exports.removeFromList = removeFromList;
	exports.addToRequest = addToRequest;
	exports.getTotalCounts = getTotalCounts;
	exports.addStudentCurrentDivision = addStudentCurrentDivision;
	exports.getRequestsViewedCount = getRequestsViewedCount;
	
	var _dashboard = __webpack_require__(441);
	
	var service = _interopRequireWildcard(_dashboard);
	
	var _immutable = __webpack_require__(11);
	
	var _actionTypes = __webpack_require__(288);
	
	var _actionTypes2 = __webpack_require__(129);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// import { congnitoSyncHandler } from './synchandler';
	
	// use of immutablejs for various js operations to simplify our work
	
	function getSchools(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    service.getSchools(payload).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.SUCCESSFUL,
	          schools: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	}
	// import * as session from 'services/session.service';
	function getPostings(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    service.getPostings(payload).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.SUCCESSFUL_POSTINGS,
	          postings: (0, _immutable.fromJS)(data)
	        });
	        dispatch({
	          type: _actionTypes2.REMOVE_LOADER
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function initProfile(profile) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.INIT,
	      profile: profile
	    });
	  };
	}
	function getRequests(id) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    service.getRequests(id).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.SUCCESSFUL_REQUESTS,
	          requests: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function updateFilter(filter) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.UPDATE_FILTER,
	      filter: filter
	    });
	  };
	}
	
	function addToList(payload, action, attrib) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    service.addToWishList(payload).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.LOADING
	        });
	        dispatch({
	          type: action,
	          list: (0, _immutable.fromJS)(data[attrib])
	        });
	        dispatch({
	          type: _actionTypes.INCREASE_CONTACT_COUNT,
	          profile: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function removeFromList(payload, action, attrib) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    service.removeFromList(payload).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.LOADING
	        });
	        dispatch({
	          type: action,
	          list: (0, _immutable.fromJS)(data[attrib])
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function addToRequest(payload, action) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUESTED
	    });
	    service.addToRequest(payload).then(function (data) {
	      if (data) {
	        // console.log('data:', fromJS(data));
	        dispatch({
	          type: _actionTypes2.LOADING
	        });
	        dispatch({
	          type: action,
	          request: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getTotalCounts(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.GET_TOTAL_COUNTS_REQUESTED
	    });
	    dispatch({
	      type: _actionTypes.GET_TOTAL_COUNTS_REQUESTED_PROFILE
	    });
	    service.totalCountsForDashboard(payload).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes2.GET_TOTAL_COUNTS_SUCCESSFULL,
	          data: data
	        });
	        dispatch({
	          type: _actionTypes.GET_TOTAL_COUNTS_SUCCESSFUL_PROFILE,
	          data: data
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.GET_TOTAL_COUNTS_FAILED,
	        error: err
	      });
	      dispatch({
	        type: _actionTypes.GET_TOTAL_COUNTS_FAILED_PROFILE,
	        error: err
	      });
	    });
	  };
	}
	
	function addStudentCurrentDivision(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.ADD_CURRENT_DIVISION_REQUESTED
	    });
	    service.addStudentCurrentDivision(payload).then(function (data) {
	      dispatch({
	        type: _actionTypes2.ADD_STUDENT_CURRENT_DIVISION,
	        data: data
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.ADD_CURRENT_DIVISION_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getRequestsViewedCount(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes2.REQUEST_VIEWED_COUNT_REQUESTED
	    });
	    service.getTotalRequestViewedCount(payload).then(function (data) {
	      dispatch({
	        type: _actionTypes2.REQUEST_VIEWED_COUNT_SUCCESSFUL,
	        data: data
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes2.REQUEST_VIEWED_COUNT_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.dashboard = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(129);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  error: false,
	  success: false,
	  isRequested: false,
	  isLoading: true,
	  schools: [],
	  postings: [],
	  filter: {},
	  requests: [],
	  requestCount: 0,
	  ignoreList: [],
	  wishList: [],
	  contactedList: [],
	  contacted: [],
	  totalCounts: {},
	  totalCountsLoading: false,
	  recommendedDivision: '',
	  contactedCount: 0,
	  // syncData: Map(),
	  syncFailed: false,
	  divisionAddRequested: false,
	  requestViewedCount: 0,
	  payload: (0, _immutable.Map)()
	});
	var isLoading = function isLoading(state) {
	  return state.requestCount - 1 === 0;
	};
	
	var getPostings = function getPostings(postings) {
	  var allPostings = postings.toJS();
	  return allPostings.sort(function (a, b) {
	    return new Date(b.created_time) - new Date(a.created_time);
	  });
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.INIT, function (state, action) {
	  return state.merge({
	    ignoreList: action.profile.get('sa_ignorelist'),
	    wishList: action.profile.get('sa_wishlist'),
	    contactedList: action.profile.get('sa_contactedlist')
	  });
	}), _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    isRequested: true,
	    error: false,
	    success: false,
	    requestCount: state.get('requestCount') + 1,
	    isLoading: true,
	    syncFailed: false,
	    divisionAddRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state) {
	  return state.merge({
	    error: true,
	    success: false,
	    isRequested: false,
	    requestCount: state.get('requestCount') - 1,
	    isLoading: isLoading(state)
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  var schools = state.get('schools');
	  var recommendedDivision = state.get('recommendedDivision');
	  schools = action.schools.get('results');
	  if (action.schools.get('recommended_divisions') !== undefined) {
	    var temp = action.schools.get('recommended_divisions');
	    recommendedDivision = temp.get(0);
	  }
	
	  return state.merge({
	    success: true,
	    isRequested: false,
	    error: false,
	    schools: schools,
	    recommendedDivision: recommendedDivision,
	    requestCount: state.get('requestCount') - 1,
	    isLoading: isLoading(state),
	    contactedCount: 0
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL_POSTINGS, function (state, action) {
	  var postings = state.get('postings');
	  postings = action.postings.get('results');
	  return state.merge({
	    success: true,
	    isRequested: false,
	    error: false,
	    postings: getPostings(postings),
	    requestCount: state.get('requestCount') - 1,
	    postingLoader: false
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL_REQUESTS, function (state, action) {
	  var data = action.requests;
	  var contacted = [];
	  var requests = [];
	  if (data && data.size > 0) {
	    contacted = data.get(1).get('from_profile_id');
	    requests = data.get(0).get('to_profile_id');
	  }
	
	  return state.merge({
	    success: true,
	    isRequested: false,
	    error: false,
	    requests: requests,
	    contacted: contacted,
	    requestCount: state.get('requestCount') - 1
	    // isLoading: isLoading(state),
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_CONTACTEDLIST, function (state, action) {
	  return state.merge({
	    contactedList: action.list,
	    contactedCount: state.get('contactedCount') + 1
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_IGNORELIST, function (state, action) {
	  return state.merge({
	    ignoreList: action.list
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_WISHLIST, function (state, action) {
	  return state.merge({
	    wishList: action.list
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_CONTACTED, function (state, action) {
	  var list = (0, _immutable.List)();
	  if (_immutable.List.isList(action.request)) {
	    list = state.get('contacted').merge(action.request);
	  } else {
	    list = state.get('contacted').push(action.request);
	  }
	  return state.merge({
	    contacted: list
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_FILTER, function (state, action) {
	  return state.merge({
	    filter: action.filter
	  });
	}), _defineProperty(_handlers, _actionTypes.LOADING, function (state) {
	  return state.merge({
	    requestCount: state.get('requestCount') - 1,
	    isLoading: isLoading(state)
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_TOTAL_COUNTS_REQUESTED, function (state) {
	  return state.merge({
	    totalCountsLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_TOTAL_COUNTS_FAILED, function (state) {
	  return state.merge({
	    totalCountsLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_TOTAL_COUNTS_SUCCESSFULL, function (state, action) {
	  return state.merge({
	    totalCounts: action.data,
	    totalCountsLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_STUDENT_CURRENT_DIVISION, function (state) {
	  return state.merge({
	    currentDivisionAdded: true
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_CURRENT_DIVISION_REQUESTED, function (state) {
	  return state.merge({
	    divisionAddRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.REQUEST_VIEWED_COUNT_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requestViewedCount: action.data.counts
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    error: false,
	    success: false,
	    isRequested: false,
	    isLoading: true,
	    schools: [],
	    postings: [],
	    filter: {},
	    requests: [],
	    requestCount: 0
	  });
	}), _handlers);
	
	var dashboard = exports.dashboard = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.dashboard.get('error');
	};
	var getSuccess = function getSuccess(state) {
	  return state.dashboard.get('session');
	};
	var getIsRequested = function getIsRequested(state) {
	  return state.dashboard.get('isRequested');
	};
	var schools = function schools(state) {
	  return state.dashboard.get('schools');
	};
	var filter = function filter(state) {
	  return state.dashboard.get('filter');
	};
	var postings = function postings(state) {
	  return state.dashboard.get('postings');
	};
	var requests = function requests(state) {
	  return state.dashboard.get('requests');
	};
	var contacted = function contacted(state) {
	  return state.dashboard.get('contacted');
	};
	var getRequestCount = function getRequestCount(state) {
	  return state.dashboard.get('requestCount');
	};
	var loading = function loading(state) {
	  return state.dashboard.get('isLoading');
	};
	var wishList = function wishList(state) {
	  return state.dashboard.get('wishList');
	};
	var ignoreList = function ignoreList(state) {
	  return state.dashboard.get('ignoreList');
	};
	var contactedList = function contactedList(state) {
	  return state.dashboard.get('contactedList');
	};
	var gettotalCountsLoading = function gettotalCountsLoading(state) {
	  return state.dashboard.get('totalCountsLoading');
	};
	var getTotalCounts = function getTotalCounts(state) {
	  return state.dashboard.get('totalCounts');
	};
	var getRecommendedDivision = function getRecommendedDivision(state) {
	  return state.dashboard.get('recommendedDivision');
	};
	var getContactedCount = function getContactedCount(state) {
	  return state.dashboard.get('contactedCount');
	};
	// const syncData = state => state.dashboard.get('syncData');
	var syncFailed = function syncFailed(state) {
	  return state.dashboard.get('syncFailed');
	};
	var divisionAddRequested = function divisionAddRequested(state) {
	  return state.dashboard.get('divisionAddRequested');
	};
	var requestViewedCount = function requestViewedCount(state) {
	  return state.dashboard.get('requestViewedCount');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  success: getSuccess,
	  isRequested: getIsRequested,
	  schools: schools,
	  filter: filter,
	  postings: postings,
	  requests: requests,
	  isLoading: loading,
	  wishList: wishList,
	  contactedList: contactedList,
	  ignoreList: ignoreList,
	  contacted: contacted,
	  totalCounts: getTotalCounts,
	  totalCountsLoading: gettotalCountsLoading,
	  requestCount: getRequestCount,
	  recommendedDivision: getRecommendedDivision,
	  contactedCount: getContactedCount,
	  // syncData,
	  syncFailed: syncFailed,
	  divisionAddRequested: divisionAddRequested,
	  requestViewedCount: requestViewedCount
	});

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Footer = __webpack_require__(1140);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Footer2.default;

/***/ },
/* 455 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'SA_PROFILE_REQUESTED';
	var FAILED = exports.FAILED = 'SA_PROFILE_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'SA_PROFILE_SUCCESSFUL';
	var EDIT_REQUESTED = exports.EDIT_REQUESTED = 'SA_PROFILE_EDIT_REQUESTED';
	var EDIT_SUCCESSFUL = exports.EDIT_SUCCESSFUL = 'SA_PROFILE_EDIT_SUCCESSFUL';
	var EDIT_FAILED = exports.EDIT_FAILED = 'SA_PROFILE_EDIT_FAILED';
	var PROFILE_SUCCESSFUL = exports.PROFILE_SUCCESSFUL = 'SA_PROFILE_VIEW_SUCCESSFUL';
	var SCHOOL_SEARCH = exports.SCHOOL_SEARCH = 'SA_PROFILE_VIEW_SCHOOL_SEARCH';
	
	var SESSION_VALID = exports.SESSION_VALID = 'SESSION_VALID';
	var SESSION_LOGOUT = exports.SESSION_LOGOUT = 'SESSION_LOGOUT';

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GetUserDetails = __webpack_require__(1148);
	
	var _GetUserDetails2 = _interopRequireDefault(_GetUserDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _GetUserDetails2.default;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.createSAProfile = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(455);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  saved: false,
	  error: (0, _immutable.Map)(),
	  requested: false,
	  profile: (0, _immutable.Map)(),
	  schools: {},
	  editRequested: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    saved: false,
	    error: (0, _immutable.Map)()
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    saved: false,
	    error: action.error,
	    editRequested: false
	
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state) {
	  return state.merge({
	    requested: false,
	    saved: true,
	    error: (0, _immutable.Map)(),
	    editRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.EDIT_REQUESTED, function (state, action) {
	  return state.merge({
	    profile: action.profile,
	    editRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.EDIT_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    profile: action.profile,
	    editRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.SCHOOL_SEARCH, function (state, action) {
	  return state.merge({
	    schools: action.schools
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    saved: false,
	    error: (0, _immutable.Map)(),
	    requested: false,
	    profile: (0, _immutable.Map)(),
	    schools: {},
	    editRequested: false
	  });
	}), _handlers);
	
	var createSAProfile = exports.createSAProfile = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.createSAProfile.get('error');
	};
	var getIsSaved = function getIsSaved(state) {
	  return state.createSAProfile.get('saved');
	};
	var IsRequested = function IsRequested(state) {
	  return state.createSAProfile.get('requested');
	};
	var getProfile = function getProfile(state) {
	  return state.createSAProfile.get('profile');
	};
	var getSchools = function getSchools(state) {
	  return state.createSAProfile.get('schools');
	};
	var getEditRequested = function getEditRequested(state) {
	  return state.createSAProfile.get('editRequested');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  saved: getIsSaved,
	  requested: IsRequested,
	  profile: getProfile,
	  schools: getSchools,
	  editRequested: getEditRequested
	});

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MyrbLogo = __webpack_require__(1163);
	
	var _MyrbLogo2 = _interopRequireDefault(_MyrbLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MyrbLogo2.default;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Password = __webpack_require__(1175);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Password2.default;

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PostingInfo = __webpack_require__(1180);
	
	var _PostingInfo2 = _interopRequireDefault(_PostingInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PostingInfo2.default;

/***/ },
/* 461 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'ADD_POSTINGS_REQUESTED';
	var FAILED = exports.FAILED = 'ADD_POSTINGS_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'ADD_POSTINGS_SUCCESSFUL';
	
	var GET_ALL_POSTING_REQUESTED = exports.GET_ALL_POSTING_REQUESTED = 'GET_ALL_POSTING_REQUESTED';
	var GET_ALL_POSTING_FAILED = exports.GET_ALL_POSTING_FAILED = 'GET_ALL_POSTING_FAILED';
	var GET_ALL_POSTING_SUCCESSFUL = exports.GET_ALL_POSTING_SUCCESSFUL = 'GET_ALL_POSTING_SUCCESSFUL';
	
	var UPDATE_REQUESTED = exports.UPDATE_REQUESTED = 'UPDATE_POSTING_REQUESTED';
	var UPDATEG_FAILED = exports.UPDATEG_FAILED = 'UPDATE_POSTING_REQUESTED';
	var UPDATE_SUCCESSFUL = exports.UPDATE_SUCCESSFUL = 'UPDATE_POSTING_SUCCESSFUL';
	
	var DELETE_POSTING_REQUESTED = exports.DELETE_POSTING_REQUESTED = 'DELETE_POSTING_REQUESTED';
	var DELETE_POSTING_SUCCESSFUL = exports.DELETE_POSTING_SUCCESSFUL = 'DELETE_POSTING_SUCCESSFUL';
	var DELETE_POSTING_FAILED = exports.DELETE_POSTING_FAILED = 'DELETE_POSTING_FAILED';
	
	var ALL_POSTINGS_CREATED_SUCCESSFUL = exports.ALL_POSTINGS_CREATED_SUCCESSFUL = 'ALL_POSTINGS_CREATED_SUCCESSFUL';
	var CREATE_ALL_POSTINGS_FAILED = exports.CREATE_ALL_POSTINGS_FAILED = 'CREATE_ALL_POSTINGS_FAILED';
	var CREATE_POSTINGS_REQUESTED = exports.CREATE_POSTINGS_REQUESTED = 'CREATE_POSTINGS_REQUESTED';

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.postings = exports.postingsStore = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(461);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  postings: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  requested: false,
	  isLoading: false,
	  allPostings: (0, _immutable.List)(),
	  postingAdded: false,
	  postingGettingAdded: false,
	  editPostingRequested: false,
	  currentPosting: (0, _immutable.Map)(),
	  editedPosting: (0, _immutable.Map)(),
	  postingGettingDeleted: false,
	  postingDeleted: false,
	  requestPostings: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    error: (0, _immutable.Map)(),
	    isLoading: true,
	    postingGettingAdded: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    allPostings: state.get('allPostings').push(action.postings),
	    error: (0, _immutable.Map)(),
	    isLoading: false,
	    postingAdded: true,
	    postingGettingAdded: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_ALL_POSTING_REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    isLoading: true,
	    postingGettingAdded: true,
	    postingAdded: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_ALL_POSTING_FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.err,
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_ALL_POSTING_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    allPostings: action.data,
	    isLoading: false,
	    requestPostings: false,
	    postingAdded: false,
	    postingGettingAdded: false
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_REQUESTED, function (state) {
	  return state.merge({
	    isLoading: true,
	    editPostingRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_SUCCESSFUL, function (state, action) {
	  var updatedPostings = action.data.get('Attributes');
	  return state.merge({
	    allPostings: state.get('allPostings').set(action.index, updatedPostings),
	    postingAdded: true,
	    editPostingRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_FAILED, function (state, action) {
	  return state.merge({
	    err: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.DELETE_POSTING_REQUESTED, function (state) {
	  return state.merge({
	    postingGettingDeleted: true
	  });
	}), _defineProperty(_handlers, _actionTypes.DELETE_POSTING_SUCCESSFUL, function (state, action) {
	  var id = action.transaction.get('id');
	  var index = state.get('allPostings').findIndex(function (posting) {
	    return posting.get('id') === id;
	  });
	  var list = state.get('allPostings').delete(index);
	
	  return state.merge({
	    postingGettingDeleted: false,
	    postingDeleted: true,
	    allPostings: list
	  });
	}), _defineProperty(_handlers, _actionTypes.DELETE_POSTING_FAILED, function (state) {
	  return state.merge({
	    postingGettingDeleted: false
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    postings: (0, _immutable.Map)(),
	    error: (0, _immutable.Map)(),
	    requested: false,
	    isLoading: false,
	    allPostings: (0, _immutable.List)(),
	    postingAdded: false,
	    postingGettingAdded: false,
	    editPostingRequested: false,
	    currentPosting: (0, _immutable.Map)(),
	    editedPosting: (0, _immutable.Map)(),
	    postingGettingDeleted: false,
	    postingDeleted: false
	  });
	}), _defineProperty(_handlers, _actionTypes.ALL_POSTINGS_CREATED_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    allPostings: action.postings,
	    postingGettingAdded: false
	  });
	}), _defineProperty(_handlers, _actionTypes.CREATE_POSTINGS_REQUESTED, function (state) {
	  return state.merge({
	    postingGettingAdded: true
	  });
	}), _handlers);
	
	var postingsStore = exports.postingsStore = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.postingsStore.get('error');
	};
	var getPostings = function getPostings(state) {
	  return state.postingsStore.get('postings');
	};
	var IsRequested = function IsRequested(state) {
	  return state.postingsStore.get('requested');
	};
	var getAllPostings = function getAllPostings(state) {
	  return state.postingsStore.get('allPostings');
	};
	var getpostingAdded = function getpostingAdded(state) {
	  return state.postingsStore.get('postingAdded');
	};
	var getPostingGettingAdded = function getPostingGettingAdded(state) {
	  return state.postingsStore.get('postingGettingAdded');
	};
	var getEditPostingRequested = function getEditPostingRequested(state) {
	  return state.postingsStore.get('editPostingRequested');
	};
	var getCurrentPosting = function getCurrentPosting(state) {
	  return state.postingsStore.get('currentPosting');
	};
	var getEditedPosting = function getEditedPosting(state) {
	  return state.postingsStore.get('editedPosting');
	};
	var getPostingGettingDeleted = function getPostingGettingDeleted(state) {
	  return state.postingsStore.get('postingGettingDeleted');
	};
	var getPostingDeleted = function getPostingDeleted(state) {
	  return state.postingsStore.get('postingDeleted');
	};
	
	var postings = exports.postings = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  postings: getPostings,
	  requested: IsRequested,
	  allPostings: getAllPostings,
	  postingAdded: getpostingAdded,
	  postingGettingAdded: getPostingGettingAdded,
	  editPostingRequested: getEditPostingRequested,
	  currentPosting: getCurrentPosting,
	  editedPosting: getEditedPosting,
	  postingGettingDeleted: getPostingGettingDeleted,
	  postingDeleted: getPostingDeleted
	});

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SchoolListView = __webpack_require__(1205);
	
	var _SchoolListView2 = _interopRequireDefault(_SchoolListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SchoolListView2.default;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SchoolTile = __webpack_require__(1206);
	
	var _SchoolTile2 = _interopRequireDefault(_SchoolTile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SchoolTile2.default;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sendgrid = __webpack_require__(1210);
	
	var _Sendgrid2 = _interopRequireDefault(_Sendgrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sendgrid2.default;

/***/ },
/* 466 */
38,
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Signin = __webpack_require__(1224);
	
	var _Signin2 = _interopRequireDefault(_Signin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Signin2.default;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TrialNotification = __webpack_require__(1241);
	
	var _TrialNotification2 = _interopRequireDefault(_TrialNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TrialNotification2.default;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VideoPlayer = __webpack_require__(1256);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VideoPlayer2.default;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.admin = exports.initialState = exports.SAProfilePage = undefined;
	
	var _handlers;
	
	var _redux = __webpack_require__(111);
	
	Object.defineProperty(exports, 'SAProfilePage', {
	  enumerable: true,
	  get: function get() {
	    return _redux.SAProfilePage;
	  }
	});
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(199);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  error: '',
	  esError: '',
	  success: false,
	  isRequested: false,
	  isLoading: false,
	  isEsLoading: false,
	  coachApplicationRequested: false,
	  coachApplications: (0, _immutable.Map)(),
	  searchUserRequested: false,
	  searchUserData: (0, _immutable.Map)(),
	  searchEsUserRequested: false,
	  searchEsUserData: (0, _immutable.List)(),
	  applicationUpgradeRequested: false,
	  upgradeInfo: false,
	  overrideInfo: false,
	  evaluatedInfo: false,
	  coachDeleted: false,
	  coachAdded: false,
	  collegeAdded: false,
	  collegeModified: false,
	  coachesFromCollege: (0, _immutable.Map)(),
	  searchHappened: false,
	  searchEsHappened: false,
	  filterBasedStudents: (0, _immutable.List)(),
	  // filterBasedEsStudents: List(),
	  filterBasedEsAtheletes: (0, _immutable.List)()
	});
	
	var updateCoachApplication = function updateCoachApplication(id, state) {
	  var applications = state.get('coachApplications');
	  var temp = applications.toJS();
	  applications = temp;
	  for (var i = 0; i < applications.length; i++) {
	    // eslint-disable-line
	    if (applications[i].coach_id === id) {
	      applications.splice(i, 1);
	    }
	  }
	  return applications;
	};
	
	var getCuratedArrayFromElasticData = function getCuratedArrayFromElasticData(data) {
	  var array = [];
	  var temp = data.toJS();
	  for (var i = 0; i < temp.length; i++) {
	    // eslint-disable-line
	    array.push(temp[i]._source); // eslint-disable-line
	  }
	  return array;
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.SEARCH_USER_REQUESTED, function (state) {
	  return state.merge({
	    searchUserRequested: true,
	    searchHappened: false,
	    searchUserData: (0, _immutable.Map)(),
	    error: ''
	  });
	}), _defineProperty(_handlers, _actionTypes.SEARCH_USER_FAILED, function (state, action) {
	  return state.merge({
	    searchUserRequested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SEARCH_USER_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    searchUserRequested: false,
	    searchHappened: true,
	    searchUserData: action.data
	  });
	}), _defineProperty(_handlers, _actionTypes.SEARCH_ES_USER_REQUESTED, function (state) {
	  return state.merge({
	    searchEsUserRequested: true,
	    searchEsHappened: false,
	    searchEsUserData: (0, _immutable.List)(),
	    esError: ''
	  });
	}), _defineProperty(_handlers, _actionTypes.SEARCH_ES_USER_FAILED, function (state, action) {
	  return state.merge({
	    searchEsUserRequested: false,
	    esError: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SEARCH_ES_USER_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    searchEsUserRequested: false,
	    searchEsHappened: true,
	    searchEsUserData: getCuratedArrayFromElasticData(action.data)
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_APPLICATIONS_REQUESTED, function (state) {
	  return state.merge({
	    coachApplicationRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_APPLICATIONS_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    coachApplicationRequested: false,
	    coachApplications: action.data
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_APPLICATIONS_FAILED, function (state) {
	  return state.merge({
	    coachApplicationRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.COACH_APPLICATION_UPGRADE_REQUESTED, function (state) {
	  return state.merge({
	    applicationUpgradeRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.COACH_APPLICATION_UPGRADE_FAILED, function (state) {
	  return state.merge({
	    applicationUpgradeRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.COACH_APPLICATION_UPGRADE_SUCCESSFUL, function (state) {
	  return state.merge({
	    applicationUpgradeRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.ERASE_CURRENT_USER_DATA, function (state) {
	  return state.merge({
	    searchUserRequested: false,
	    searchHappened: false,
	    applicationUpgradeRequested: false,
	    upgradeInfo: false,
	    overrideInfo: false,
	    evaluatedInfo: false,
	    coachDeleted: false,
	    coachAdded: false,
	    collegeAdded: false,
	    collegeModified: false,
	    searchUserData: (0, _immutable.Map)(),
	    searchEsUserData: (0, _immutable.Map)(),
	    dashboardReset: false
	  });
	}), _defineProperty(_handlers, _actionTypes.START_LOADER, function (state) {
	  return state.merge({
	    isLoading: true,
	    collegeAdded: false,
	    dashboardReset: false
	  });
	}), _defineProperty(_handlers, _actionTypes.STOP_LOADER, function (state) {
	  return state.merge({
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.UPGRADE_STUDENT_SUCCESSFUL, function (state) {
	  return state.merge({
	    isLoading: false,
	    upgradeInfo: true
	  });
	}), _defineProperty(_handlers, _actionTypes.OVERRIDE_STUDENT_SUCCESSFUL, function (state) {
	  return state.merge({
	    isLoading: false,
	    overrideInfo: true
	  });
	}), _defineProperty(_handlers, _actionTypes.STUDENT_EVALUATION_SUCCESSFUL, function (state) {
	  return state.merge({
	    isLoading: false,
	    evaluatedInfo: true
	  });
	}), _defineProperty(_handlers, _actionTypes.DELETE_COACH_SUCCESSFUL, function (state) {
	  return state.merge({
	    isLoading: false,
	    coachDeleted: true
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_COACH, function (state) {
	  return state.merge({
	    isLoading: false,
	    coachAdded: true
	  });
	}), _defineProperty(_handlers, _actionTypes.MODIFY_COLLEGE, function (state) {
	  return state.merge({
	    isLoading: false,
	    collegeModified: true
	  });
	}), _defineProperty(_handlers, _actionTypes.RESET_DELETE_COACH, function (state) {
	  return state.merge({
	    coachDeleted: false
	  });
	}), _defineProperty(_handlers, _actionTypes.RESET_ADD_COACH, function (state) {
	  return state.merge({
	    coachAdded: false
	  });
	}), _defineProperty(_handlers, _actionTypes.RESET_STUDENT_VALUES, function (state) {
	  return state.merge({
	    upgradeInfo: false,
	    overrideInfo: false,
	    evaluatedInfo: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACHES_FROM_DB, function (state, action) {
	  return state.merge({
	    coachesFromCollege: action.data,
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_COLLEGE_SUCCESSFUL, function (state) {
	  return state.merge({
	    collegeAdded: true,
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.DELETE_COACH_APPLICATION_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    isLoading: false,
	    coachApplications: updateCoachApplication(action.id, state)
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_STUDENTS_FOR_STUDENT_EXPLORER, function (state, action) {
	  return state.merge({
	    filterBasedStudents: getCuratedArrayFromElasticData(action.data),
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.RESET_STUDENT_DASHBOARD_SUCCESSFUL, function (state) {
	  return state.merge({
	    isLoading: false,
	    dashboardReset: true
	  });
	}), _defineProperty(_handlers, _actionTypes.START_ES_LOADER, function (state) {
	  return state.merge({
	    isEsLoading: true,
	    collegeAdded: false,
	    dashboardReset: false
	  });
	}), _defineProperty(_handlers, _actionTypes.STOP_ES_LOADER, function (state) {
	  return state.merge({
	    isEsLoading: false
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    searchUserDataerror: false,
	    success: false,
	    isRequested: false,
	    coachApplicationRequested: false,
	    coachApplications: (0, _immutable.Map)(),
	    searchUserRequested: false,
	    searchUserData: (0, _immutable.Map)(),
	    searchEsUserData: (0, _immutable.Map)(),
	    applicationUpgradeRequested: false,
	    dashboardReset: false
	  });
	}), _handlers);
	
	var admin = exports.admin = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getCoachApplicationsRequested = function getCoachApplicationsRequested(state) {
	  return state.admin.get('coachApplicationRequested');
	};
	var getCoachApplications = function getCoachApplications(state) {
	  return state.admin.get('coachApplications');
	};
	var getSearchUserRequested = function getSearchUserRequested(state) {
	  return state.admin.get('searchUserRequested');
	};
	var getSearchedUserData = function getSearchedUserData(state) {
	  return state.admin.get('searchUserData');
	};
	var getSearchEsUserRequested = function getSearchEsUserRequested(state) {
	  return state.admin.get('searchEsUserRequested');
	};
	var getSearchedEsUserData = function getSearchedEsUserData(state) {
	  return state.admin.get('searchEsUserData');
	};
	var getapplicationUpgradeRequested = function getapplicationUpgradeRequested(state) {
	  return state.admin.get('applicationUpgradeRequested');
	};
	var getOverrideInfo = function getOverrideInfo(state) {
	  return state.admin.get('overrideInfo');
	};
	var getUpgradeInfo = function getUpgradeInfo(state) {
	  return state.admin.get('upgradeInfo');
	};
	var getEvaluatedInfo = function getEvaluatedInfo(state) {
	  return state.admin.get('evaluatedInfo');
	};
	var getIsLoading = function getIsLoading(state) {
	  return state.admin.get('isLoading');
	};
	var getIsEsLoading = function getIsEsLoading(state) {
	  return state.admin.get('isEsLoading');
	};
	var getDeletedCoach = function getDeletedCoach(state) {
	  return state.admin.get('coachDeleted');
	};
	var getCoachAdded = function getCoachAdded(state) {
	  return state.admin.get('coachAdded');
	};
	var getCollegeModified = function getCollegeModified(state) {
	  return state.admin.get('collegeModified');
	};
	var getCoachesFromCollege = function getCoachesFromCollege(state) {
	  return state.admin.get('coachesFromCollege');
	};
	var getCollegeAdded = function getCollegeAdded(state) {
	  return state.admin.get('collegeAdded');
	};
	var getSearchHappened = function getSearchHappened(state) {
	  return state.admin.get('searchHappened');
	};
	var getSearchEsHappened = function getSearchEsHappened(state) {
	  return state.admin.get('searchEsHappened');
	};
	var error = function error(state) {
	  return state.admin.get('error');
	};
	var esError = function esError(state) {
	  return state.admin.get('esError');
	};
	var filterBasedStudents = function filterBasedStudents(state) {
	  return state.admin.get('filterBasedStudents');
	};
	// const filterBasedEsStudents = state => state.admin.get('filterBasedEsStudents');
	var getDashboardReset = function getDashboardReset(state) {
	  return state.admin.get('dashboardReset');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  coachApplicationRequested: getCoachApplicationsRequested,
	  coachApplications: getCoachApplications,
	  searchUserRequested: getSearchUserRequested,
	  searchUserData: getSearchedUserData,
	  searchEsUserRequested: getSearchEsUserRequested,
	  searchEsUserData: getSearchedEsUserData,
	  applicationUpgradeRequested: getapplicationUpgradeRequested,
	  upgradeInfo: getUpgradeInfo,
	  overrideInfo: getOverrideInfo,
	  evaluatedInfo: getEvaluatedInfo,
	  isLoading: getIsLoading,
	  isEsLoading: getIsEsLoading,
	  coachDeleted: getDeletedCoach,
	  coachAdded: getCoachAdded,
	  collegeModified: getCollegeModified,
	  coachesFromCollege: getCoachesFromCollege,
	  collegeAdded: getCollegeAdded,
	  searchHappened: getSearchHappened,
	  searchEsHappened: getSearchEsHappened,
	  error: error,
	  esError: esError,
	  filterBasedStudents: filterBasedStudents,
	  // filterBasedEsStudents,
	  dashboardReset: getDashboardReset
	});

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.AthleteById = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(200);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  profile: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  requested: false,
	  videos: [],
	  conversationUpdated: false,
	  isLoading: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    conversationUpdated: false,
	    requested: true,
	    error: (0, _immutable.Map)(),
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.profile,
	    error: (0, _immutable.Map)(),
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.VIEWING_AS_COACH, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.profile,
	    request: action.request,
	    error: (0, _immutable.Map)(),
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PUBLIC_ADD_CONVERSATION_REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    conversationUpdated: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PUBLIC_ADD_CONVERSATION_SUCCESSFUL, function (state) {
	  return state.merge({
	    conversationUpdated: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PUBLIC_ADD_CONVERSATION_FAILED, function (state, action) {
	  return state.merge({
	    requested: true,
	    conversationUpdated: true,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    profile: (0, _immutable.Map)(),
	    error: (0, _immutable.Map)(),
	    requested: false,
	    videos: [],
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.CURRENT_VIDEO_URL, function (state, action) {
	  return state.merge({
	    currentVideoUrl: action.url
	  });
	}), _handlers);
	
	var AthleteById = exports.AthleteById = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.AthleteById.get('error');
	};
	var getProfile = function getProfile(state) {
	  return state.AthleteById.get('profile');
	};
	var getRequest = function getRequest(state) {
	  return state.AthleteById.get('request');
	};
	var IsRequested = function IsRequested(state) {
	  return state.AthleteById.get('requested');
	};
	var CurrentVideo = function CurrentVideo(state) {
	  return state.AthleteById.get('currentVideoUrl');
	};
	var getConversationUpdated = function getConversationUpdated(state) {
	  return state.AthleteById.get('conversationUpdated');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  profile: getProfile,
	  request: getRequest,
	  requested: IsRequested,
	  currentVideoUrl: CurrentVideo,
	  conversationUpdated: getConversationUpdated
	});

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _analytics = __webpack_require__(37);
	
	var _ProfileHeader = __webpack_require__(283);
	
	var _ProfileHeader2 = _interopRequireDefault(_ProfileHeader);
	
	var _ProfileData = __webpack_require__(282);
	
	var _ProfileData2 = _interopRequireDefault(_ProfileData);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _progress_bar = __webpack_require__(253);
	
	var _progress_bar2 = _interopRequireDefault(_progress_bar);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _CoachAthleteView = __webpack_require__(472);
	
	var _CoachAthleteView2 = _interopRequireDefault(_CoachAthleteView);
	
	var _redux = __webpack_require__(474);
	
	var _actions = __webpack_require__(1302);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	
	// to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	var CoachAthleteView = function (_Component) {
	  _inherits(CoachAthleteView, _Component);
	
	  function CoachAthleteView(props) {
	    _classCallCheck(this, CoachAthleteView);
	
	    var _this = _possibleConstructorReturn(this, (CoachAthleteView.__proto__ || Object.getPrototypeOf(CoachAthleteView)).call(this, props));
	
	    _this.state = {
	      isCoach: false
	    };
	    return _this;
	  }
	
	  _createClass(CoachAthleteView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var id = this.props.match.params.id;
	      if (id && id.length > 0) {
	        this.props.getSAProfile(id);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	
	      if (this.props.attributes && this.props.attributes.size > 0) {
	        var zone = this.props.attributes.get('zoneInfo');
	        if (zone === 'COACH') {
	          this.setState({ isCoach: true }); // eslint-disable-line
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var attributes = this.props.attributes;
	
	      if (nextProps.attributes && !(0, _immutable.is)(nextProps.attributes, attributes)) {
	        var zone = nextProps.attributes.get('zoneinfo');
	        if (zone === 'COACH') {
	          this.setState({ isCoach: true });
	        }
	      }
	      if (nextProps.profile.size > 0) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	
	        var academic = nextProps.profile.get('academic');
	
	        var newState = {
	          // profile
	          gender: nextProps.profile.get('gender'),
	          fullname: nextProps.profile.get('fullname'),
	          state: nextProps.profile.get('state'),
	          city: nextProps.profile.get('city'),
	
	          // sports
	          height: nextProps.profile.get('height'),
	          weight: nextProps.profile.get('weight'),
	          sportName: keys[0],
	          t40: sport.get('t40'),
	          bench: sport.get('bench'),
	          squats: sport.get('squats'),
	          description: sport.get('description'),
	          position_pref: sport.get('position_pref'),
	
	          // school
	          school: nextProps.profile.get('school'),
	          year_of_graduation: academic.get('year_of_graduation'),
	          gpa: academic.get('gpa'),
	          sat: academic.get('sat'),
	          act: academic.get('act'),
	
	          profileId: nextProps.profile.get('id'),
	          video: nextProps.profile.get('video_items').toJS()
	
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderIfProfile = (0, _renderIf2.default)(this.props.profile.size > 0);
	      var renderIfLoading = (0, _renderIf2.default)(this.props.requested);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderIfLoading(_react2.default.createElement(
	          'div',
	          { className: _CoachAthleteView2.default.loaderContainer },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate' })
	          )
	        )),
	        renderIfProfile(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _CoachAthleteView2.default.profileContainer) },
	          _react2.default.createElement(_ProfileHeader2.default, Object.assign({}, this.props, this.state)),
	          _react2.default.createElement(_ProfileData2.default, Object.assign({}, this.props, this.state)),
	          _react2.default.createElement(_MiniFooter2.default, null)
	        ))
	      );
	    }
	  }]);
	
	  return CoachAthleteView;
	}(_react.Component);
	
	CoachAthleteView.propTypes = {
	  profile: _propTypes2.default.shape(),
	  match: _propTypes2.default.shape(),
	  getSAProfile: _propTypes2.default.func,
	  requested: _propTypes2.default.bool,
	  attributes: _propTypes2.default.shape().isRequired
	};
	CoachAthleteView.defaultProps = {
	  history: {},
	  profile: (0, _immutable.Map)(),
	  getSAProfile: function getSAProfile() {},
	  requested: false,
	  match: {
	    params: {
	      id: ''
	    }
	  }
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSAProfile: _actions2.default })((0, _Session2.default)(CoachAthleteView));

/***/ },
/* 473 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'SA_PROFILE_VIEW_REQUESTED';
	var FAILED = exports.FAILED = 'SA_PROFILE_VIEW_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'SA_PROFILE_VIEW_SUCCESSFUL';

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.CoachAthleteView = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(473);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  profile: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  requested: false,
	  videos: [],
	  isLoading: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    error: (0, _immutable.Map)(),
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.profile,
	    error: (0, _immutable.Map)(),
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    profile: (0, _immutable.Map)(),
	    error: (0, _immutable.Map)(),
	    requested: false,
	    videos: [],
	    isLoading: false
	  });
	}), _handlers);
	
	var CoachAthleteView = exports.CoachAthleteView = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.SAProfilePage.get('error');
	};
	var getProfile = function getProfile(state) {
	  return state.SAProfilePage.get('profile');
	};
	var IsRequested = function IsRequested(state) {
	  return state.SAProfilePage.get('requested');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  profile: getProfile,
	  requested: IsRequested
	});

/***/ },
/* 475 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'COACH_DASHBOARD_REQUESTED';
	var FAILED = exports.FAILED = 'COACH_DASHBOARD_FORGOT_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'COACH_DASHBOARD_FORGOT_SUCCESSFUL';
	var REQUEST_REQUESTED = exports.REQUEST_REQUESTED = 'GET_ALL_REQUEST_REQUESTED';
	var REQUEST_FAILED = exports.REQUEST_FAILED = 'GET_ALL_REQUEST_FAILED';
	var REQUEST_SUCCESSFUL = exports.REQUEST_SUCCESSFUL = 'GET_ALL_REQUEST_SUCCESSFUL';
	var ADD_CONVERSATION_REQUESTED = exports.ADD_CONVERSATION_REQUESTED = 'ADD_CONVERSATION_REQUESTED';
	var ADD_CONVERSATION_FAILED = exports.ADD_CONVERSATION_FAILED = 'ADD_CONVERSATION_FAILED';
	var ADD_CONVERSATION_SUCCESSFUL = exports.ADD_CONVERSATION_SUCCESSFUL = 'ADD_CONVERSATION_SUCCESSFUL';
	var COACH_PROFILE_REQUESTED = exports.COACH_PROFILE_REQUESTED = 'COACH_PROFILE_REQUESTED';
	var COACH_PROFILE_SUCCESSFUL = exports.COACH_PROFILE_SUCCESSFUL = 'COACH_PROFILE_SUCCESSFUL';
	var COACH_PROFILE_FAILED = exports.COACH_PROFILE_FAILED = 'COACH_PROFILE_FAILED';
	var DIVISION_STUDENT_REQUESTED = exports.DIVISION_STUDENT_REQUESTED = 'DIVISION_STUDENT_REQUESTED';
	var DIVISION_STUDENT_FAILED = exports.DIVISION_STUDENT_FAILED = 'DIVISION_STUDENT_FAILED';
	var DIVISION_STUDENT_SUCCESSFUL = exports.DIVISION_STUDENT_SUCCESSFUL = 'FILTER_DIVISION_STUDENT_SUCCESSFUL';
	var FILTER_DIVISION_STUDENT_REQUESTED = exports.FILTER_DIVISION_STUDENT_REQUESTED = 'FILTER_DIVISION_STUDENT_REQUESTED';
	var FILTER_DIVISION_STUDENT_FAILED = exports.FILTER_DIVISION_STUDENT_FAILED = 'FILTER_DIVISION_STUDENT_FAILED';
	var FILTER_DIVISION_STUDENT_SUCCESSFUL = exports.FILTER_DIVISION_STUDENT_SUCCESSFUL = 'FILTER_DIVISION_STUDENT_SUCCESSFUL';

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.coachDashboardSelector = exports.coachDashboard = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(475);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var getCuratedArrayFromElasticData = function getCuratedArrayFromElasticData(data) {
	  var array = [];
	  var temp = data.toJS();
	  var temp1 = temp.hits.hits;
	  for (var i = 0; i < temp1.length; i++) {
	    // eslint-disable-line
	    array.push(temp1[i]._source); // eslint-disable-line
	  }
	  return array;
	};
	
	var getAllRequests = function getAllRequests(data) {
	  var allRequests = data.toJS();
	  return allRequests.sort(function (a, b) {
	    return new Date(b.created_time) - new Date(a.created_time);
	  });
	};
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  profile: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  requested: false,
	  allPostings: (0, _immutable.Map)(),
	  fetchRequest: false,
	  allRequests: (0, _immutable.Map)(),
	  requestLoaded: false,
	  conversationUpdated: false,
	  divisionBasedStudents: (0, _immutable.Map)()
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    error: (0, _immutable.Map)(),
	    requestLoaded: false
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.data
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.REQUEST_REQUESTED, function (state) {
	  return state.merge({
	    // requestLoaded: false,
	  });
	}), _defineProperty(_handlers, _actionTypes.REQUEST_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    fetchRequest: false,
	    allRequests: getAllRequests(action.data),
	    requestLoaded: true
	  });
	}), _defineProperty(_handlers, _actionTypes.REQUEST_FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    requestLoaded: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_CONVERSATION_REQUESTED, function (state) {
	  return state.merge({
	    conversationUpdated: true
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_CONVERSATION_SUCCESSFUL, function (state) {
	  return state.merge({
	    conversationUpdated: false
	  });
	}), _defineProperty(_handlers, _actionTypes.ADD_CONVERSATION_FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    conversationUpdated: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.COACH_PROFILE_REQUESTED, function (state) {
	  return state.merge({});
	}), _defineProperty(_handlers, _actionTypes.COACH_PROFILE_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    profile: action.data
	  });
	}), _defineProperty(_handlers, _actionTypes.COACH_PROFILE_FAILED, function (state, action) {
	  return state.merge({
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.DIVISION_STUDENT_REQUESTED, function (state) {
	  return state.merge({
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.DIVISION_STUDENT_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    isLoading: false,
	    divisionBasedStudents: getCuratedArrayFromElasticData(action.data)
	  });
	}), _defineProperty(_handlers, _actionTypes.DIVISION_STUDENT_FAILED, function (state, action) {
	  return state.merge({
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.FILTER_DIVISION_STUDENT_REQUESTED, function (state) {
	  return state.merge({
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FILTER_DIVISION_STUDENT_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    isLoading: false,
	    divisionBasedStudents: getCuratedArrayFromElasticData(action.data)
	  });
	}), _defineProperty(_handlers, _actionTypes.FILTER_DIVISION_STUDENT_FAILED, function (state, action) {
	  return state.merge({
	    error: action.error
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    profile: {},
	    error: (0, _immutable.Map)(),
	    requested: false,
	    allPostings: (0, _immutable.Map)(),
	    fetchRequest: false,
	    allRequests: (0, _immutable.Map)(),
	    requestLoaded: false,
	    conversationUpdated: false
	  });
	}), _handlers);
	
	var coachDashboard = exports.coachDashboard = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.coachDashboard.get('error');
	};
	var getProfile = function getProfile(state) {
	  return state.coachDashboard.get('profile');
	};
	var IsRequested = function IsRequested(state) {
	  return state.coachDashboard.get('requested');
	};
	var getRequests = function getRequests(state) {
	  return state.coachDashboard.get('allRequests');
	};
	var getFetchallRequests = function getFetchallRequests(state) {
	  return state.coachDashboard.get('fetchRequest');
	};
	var getRequestLoaded = function getRequestLoaded(state) {
	  return state.coachDashboard.get('requestLoaded');
	};
	var getConversationUpdated = function getConversationUpdated(state) {
	  return state.coachDashboard.get('conversationUpdated');
	};
	var getDivisionBasedStudent = function getDivisionBasedStudent(state) {
	  return state.coachDashboard.get('divisionBasedStudents');
	};
	var getIsLoading = function getIsLoading(state) {
	  return state.coachDashboard.get('isLoading');
	};
	
	var coachDashboardSelector = exports.coachDashboardSelector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  profile: getProfile,
	  requested: IsRequested,
	  allRequests: getRequests,
	  fetchRequest: getFetchallRequests,
	  requestLoaded: getRequestLoaded,
	  conversationUpdated: getConversationUpdated,
	  divisionBasedStudents: getDivisionBasedStudent,
	  isLoading: getIsLoading
	});

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forgotSelector = exports.forgot = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _ForgotPasswordActionTypes = __webpack_require__(478);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  error: false,
	  success: false,
	  isRequested: false,
	  errorMessage: '',
	  isLoading: false,
	  requestCount: 0,
	  resetPasswordsuccess: false
	});
	
	var isLoading = function isLoading(state) {
	  return state.requestCount - 1 === 0;
	};
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _ForgotPasswordActionTypes.REQUESTED, function (state) {
	  return state.merge({
	    isRequested: true,
	    error: false,
	    errorMessage: '',
	    success: false,
	    requestCount: state.get('requestCount') + 1,
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _ForgotPasswordActionTypes.FAILED, function (state, action) {
	  return state.merge({
	    error: action.error,
	    errorMessage: action.error.message,
	    success: false,
	    isRequested: false,
	    requestCount: state.get('requestCount') - 1,
	    isLoading: isLoading(state)
	  });
	}), _defineProperty(_handlers, _ForgotPasswordActionTypes.SUCCESSFUL, function (state) {
	  return state.merge({
	    success: true,
	    isRequested: false,
	    error: false,
	    requestCount: state.get('requestCount') - 1,
	    isLoading: isLoading(state)
	  });
	}), _defineProperty(_handlers, _ForgotPasswordActionTypes.RESET_PASSWORD_SUCCESSFUL, function (state) {
	  return state.merge({
	    resetPasswordsuccess: true,
	    isLoading: isLoading(state)
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    error: false,
	    success: false,
	    isRequested: false
	  });
	}), _handlers);
	
	var forgot = exports.forgot = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.forgot.get('error');
	};
	var getSuccess = function getSuccess(state) {
	  return state.forgot.get('success');
	};
	var getIsRequested = function getIsRequested(state) {
	  return state.forgot.get('isRequested');
	};
	var errorMessage = function errorMessage(state) {
	  return state.forgot.get('errorMessage');
	};
	var loading = function loading(state) {
	  return state.forgot.get('isLoading');
	};
	var getResetPassword = function getResetPassword(state) {
	  return state.forgot.get('resetPasswordsuccess');
	};
	
	var forgotSelector = exports.forgotSelector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  success: getSuccess,
	  isRequested: getIsRequested,
	  errorMessage: errorMessage,
	  isLoading: loading,
	  resetPasswordsuccess: getResetPassword
	});

/***/ },
/* 478 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'FORGOT_REQUESTED';
	var FAILED = exports.FAILED = 'FORGOT_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'FORGOT_SUCCESSFUL';
	var RESET_PASSWORD_SUCCESSFUL = exports.RESET_PASSWORD_SUCCESSFUL = 'RESET_PASSWORD_SUCCESSFUL';

/***/ },
/* 479 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'PAYMENT_REQUESTED';
	var FAILED = exports.FAILED = 'PAYMENT_FAILED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'PAYMENT_SUCCESSFUL';
	var CLIENT_TOKEN = exports.CLIENT_TOKEN = 'PAYMENT_CLIENT_TOKEN';
	var TRANSACTION_SUCCESS = exports.TRANSACTION_SUCCESS = 'PAYMENT_TRANSACTION_SUCCESS';

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.payment = exports.initialState = exports.SAProfilePage = undefined;
	
	var _handlers;
	
	var _redux = __webpack_require__(111);
	
	Object.defineProperty(exports, 'SAProfilePage', {
	  enumerable: true,
	  get: function get() {
	    return _redux.SAProfilePage;
	  }
	});
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(479);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  error: false,
	  showError: '',
	  success: false,
	  isRequested: false,
	  clientToken: '',
	  transaction: (0, _immutable.Map)(),
	  profile: (0, _immutable.Map)(),
	  showLoader: true
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    isRequested: true,
	    error: false,
	    success: false,
	    showLoader: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    error: true,
	    showError: action.error,
	    success: false,
	    isRequested: false,
	    showLoader: false
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state) {
	  return state.merge({
	    success: true,
	    isRequested: false,
	    error: false
	  });
	}), _defineProperty(_handlers, _actionTypes.CLIENT_TOKEN, function (state, action) {
	  return state.merge({
	    success: true,
	    isRequested: false,
	    error: false,
	    showLoader: false,
	    clientToken: action.token
	  });
	}), _defineProperty(_handlers, _actionTypes.TRANSACTION_SUCCESS, function (state, action) {
	  return state.merge({
	    transaction: action.transaction
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    error: false,
	    success: false,
	    isRequested: false,
	    clientToken: '',
	    transaction: (0, _immutable.Map)(),
	    profile: (0, _immutable.Map)(),
	    showError: ''
	  });
	}), _handlers);
	
	var payment = exports.payment = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.payment.get('error');
	};
	var getSuccess = function getSuccess(state) {
	  return state.payment.get('session');
	};
	var getIsRequested = function getIsRequested(state) {
	  return state.payment.get('isRequested');
	};
	var clientToken = function clientToken(state) {
	  return state.payment.get('clientToken');
	};
	var transaction = function transaction(state) {
	  return state.payment.get('transaction');
	};
	var showLoader = function showLoader(state) {
	  return state.payment.get('showLoader');
	};
	var gerShowError = function gerShowError(state) {
	  return state.payment.get('showError');
	};
	var profile = function profile(state) {
	  return state.SAProfilePage.get('profile');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  success: getSuccess,
	  isRequested: getIsRequested,
	  clientToken: clientToken,
	  transaction: transaction,
	  profile: profile,
	  showLoader: showLoader,
	  showError: gerShowError
	});

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.publicAthlete = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(289);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  profile: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  requested: false,
	  videos: [],
	  conversationUpdated: false,
	  isLoading: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    conversationUpdated: false,
	    requested: true,
	    error: (0, _immutable.Map)(),
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.profile,
	    error: (0, _immutable.Map)(),
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PUBLIC_ATHLETE_REQUEST, function (state, action) {
	  return state.merge({
	    requested: false,
	    request: action.request,
	    error: (0, _immutable.Map)(),
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PUBLIC_ADD_CONVERSATION_REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    conversationUpdated: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PUBLIC_ADD_CONVERSATION_SUCCESSFUL, function (state) {
	  return state.merge({
	    conversationUpdated: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PUBLIC_ADD_CONVERSATION_FAILED, function (state, action) {
	  return state.merge({
	    requested: true,
	    conversationUpdated: true,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.ATHLETE_PUBLIC_ADD_CONVESATION_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    request: action.data.get('Attributes'),
	    conversationUpdated: true
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    profile: (0, _immutable.Map)(),
	    error: (0, _immutable.Map)(),
	    requested: false,
	    videos: [],
	    isLoading: false
	  });
	}), _defineProperty(_handlers, _actionTypes.CURRENT_VIDEO_URL, function (state, action) {
	  return state.merge({
	    currentVideoUrl: action.url
	  });
	}), _handlers);
	
	var publicAthlete = exports.publicAthlete = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.publicAthlete.get('error');
	};
	var getProfile = function getProfile(state) {
	  return state.publicAthlete.get('profile');
	};
	var getRequest = function getRequest(state) {
	  return state.publicAthlete.get('request');
	};
	var IsRequested = function IsRequested(state) {
	  return state.publicAthlete.get('requested');
	};
	var CurrentVideo = function CurrentVideo(state) {
	  return state.publicAthlete.get('currentVideoUrl');
	};
	var getConversationUpdated = function getConversationUpdated(state) {
	  return state.publicAthlete.get('conversationUpdated');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  profile: getProfile,
	  request: getRequest,
	  requested: IsRequested,
	  currentVideoUrl: CurrentVideo,
	  conversationUpdated: getConversationUpdated
	});

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerSelector = exports.register = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _RegisterActionTypes = __webpack_require__(201);
	
	var _LoginActionTypes = __webpack_require__(130);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
	                                                                                                                                                                                                                   * Created by sairam on 14/04/17.
	                                                                                                                                                                                                                   */
	// use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  session: {},
	  user: {},
	  error: {},
	  errorMessage: '',
	  isLoading: false,
	  registered: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _RegisterActionTypes.REGISTER_REQUESTED, function (state) {
	  return state.merge({
	    isLoginRequested: true,
	    isLoading: true,
	    errorMessage: ''
	  });
	}), _defineProperty(_handlers, _RegisterActionTypes.REGISTER_FAILED, function (state, action) {
	  return state.merge({
	    isLoginRequested: false,
	    isLoading: false,
	    error: action.error,
	    errorMessage: action.error.message
	  });
	}), _defineProperty(_handlers, _RegisterActionTypes.REGISTER_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    session: action.session,
	    user: action.user,
	    registered: true,
	    isLoading: false,
	    errorMessage: ''
	  });
	}), _defineProperty(_handlers, _LoginActionTypes.LOGIN_REQUESTED, function (state) {
	  return state.merge({
	    isLoginRequested: true,
	    isLoading: true,
	    errorMessage: ''
	  });
	}), _defineProperty(_handlers, _LoginActionTypes.LOGIN_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    session: action.session,
	    user: action.user,
	    isLoading: false,
	    errorMessage: ','
	  });
	}), _defineProperty(_handlers, _LoginActionTypes.LOGIN_FAILED, function (state, action) {
	  return state.merge({
	    isLoginRequested: false,
	    isLoading: false,
	    error: action.error,
	    errorMessage: 'Incorrect username and password.'
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    session: {},
	    user: {},
	    error: {},
	    isLoading: false,
	    registered: false,
	    errorMessage: ''
	  });
	}), _handlers);
	
	var register = exports.register = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.register.get('error');
	};
	var getSession = function getSession(state) {
	  return state.register.get('session');
	};
	var getUser = function getUser(state) {
	  return state.register.get('user');
	};
	var getIsLoading = function getIsLoading(state) {
	  return state.register.get('isLoading');
	};
	var getRegistered = function getRegistered(state) {
	  return state.register.get('registered');
	};
	var errorMessage = function errorMessage(state) {
	  return state.register.get('errorMessage');
	};
	
	var registerSelector = exports.registerSelector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  session: getSession,
	  user: getUser,
	  isLoading: getIsLoading,
	  registered: getRegistered,
	  errorMessage: errorMessage
	});

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.settingStore = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(290);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  saved: false,
	  error: false,
	  requested: false,
	  profile: (0, _immutable.Map)(),
	  saRequested: false,
	  updateRequested: false,
	  transactions: (0, _immutable.Map)(),
	  paymentRequested: false,
	  redirect: false,
	  schools: {}
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    requested: true,
	    saved: false,
	    error: false
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state) {
	  return state.merge({
	    requested: false,
	    saved: false,
	    error: true
	  });
	}), _defineProperty(_handlers, _actionTypes.SETTINGS_SA_PROFILE_FAILED, function (state) {
	  return state.merge({
	    requested: false,
	    saved: false,
	    saRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.SETTINGS_SA_PROFILE_REQUESTED, function (state) {
	  return state.merge({
	    requested: false,
	    saved: false,
	    saRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state) {
	  return state.merge({
	    requested: false,
	    // updateRequested: false,
	    saved: true
	  });
	}), _defineProperty(_handlers, _actionTypes.SETTINGS_SA_PROFILE_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.profile,
	    updateRequested: false,
	    saRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_SA_PROFILE_REQUESTED, function (state) {
	  return state.merge({
	    updateRequested: true,
	    redirect: false
	  });
	}), _defineProperty(_handlers, _actionTypes.UPDATE_SA_PROFILE_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.result,
	    saRequested: false,
	    updateRequested: false,
	    redirect: true
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    saved: false,
	    error: false,
	    requested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.PAYMENT_HISTORY_REQUESTED, function (state) {
	  return state.merge({
	    paymentRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.PAYMENT_HISTORY_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    paymentRequested: false,
	    transactions: action.result
	  });
	}), _defineProperty(_handlers, _actionTypes.PAYMENT_HISTORY_FAILED, function (state, action) {
	  return state.merge({
	    paymentRequested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _actionTypes.SETTINGS_SEARCH_SCHOOLS, function (state, action) {
	  return state.merge({
	    schools: action.schools
	  });
	}), _handlers);
	
	var settingStore = exports.settingStore = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.settingStore.get('error');
	};
	var isSaved = function isSaved(state) {
	  return state.settingStore.get('saved');
	};
	var IsRequested = function IsRequested(state) {
	  return state.settingStore.get('requested');
	};
	var getProfile = function getProfile(state) {
	  return state.settingStore.get('profile');
	};
	var getsaRequested = function getsaRequested(state) {
	  return state.settingStore.get('saRequested');
	};
	var getUpdateRequested = function getUpdateRequested(state) {
	  return state.settingStore.get('updateRequested');
	};
	var getTransactions = function getTransactions(state) {
	  return state.settingStore.get('transactions');
	};
	var getPaymentsRequested = function getPaymentsRequested(state) {
	  return state.settingStore.get('paymentRequested');
	};
	var getRedirect = function getRedirect(state) {
	  return state.settingStore.get('redirect');
	};
	var getSchools = function getSchools(state) {
	  return state.settingStore.get('schools');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  saved: isSaved,
	  requested: IsRequested,
	  profile: getProfile,
	  saRequested: getsaRequested,
	  updateRequested: getUpdateRequested,
	  transactions: getTransactions,
	  paymentRequested: getPaymentsRequested,
	  redirect: getRedirect,
	  schools: getSchools
	});

/***/ },
/* 484 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GET_COACH_FROM_DATABASE_REQUESTED = exports.GET_COACH_FROM_DATABASE_REQUESTED = 'GET_COACH_FROM_DATABASE_REQUESTED';
	var GET_COACH_FROM_DATABASE_SUCCESSFUL = exports.GET_COACH_FROM_DATABASE_SUCCESSFUL = 'GET_COACH_FROM_DATABASE_SUCCESSFUL';
	var GET_COACH_FROM_DATABASE_FAILED = exports.GET_COACH_FROM_DATABASE_FAILED = 'GET_COACH_FROM_DATABASE_FAILED';

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selector = exports.verifyCoach = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _reselect = __webpack_require__(40);
	
	var _immutable = __webpack_require__(11);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(484);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  validCoachData: {},
	  validateCoachRequested: false,
	  coachVerified: false
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.GET_COACH_FROM_DATABASE_REQUESTED, function (state) {
	  return state.merge({
	    validateCoachRequested: true
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_FROM_DATABASE_FAILED, function (state) {
	  return state.merge({
	    validateCoachRequested: false
	  });
	}), _defineProperty(_handlers, _actionTypes.GET_COACH_FROM_DATABASE_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    validateCoachRequested: false,
	    validCoachData: action.validCoach,
	    coachVerified: true
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    requested: false,
	    coachRegistered: false,
	    profile: (0, _immutable.Map)(),
	    isLoading: false,
	    saved: false,
	    schools: {}
	  });
	}), _handlers);
	
	var verifyCoach = exports.verifyCoach = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getvalidateCoachRequested = function getvalidateCoachRequested(state) {
	  return state.verifyCoach.get('validateCoachRequested');
	};
	var getValidCoachData = function getValidCoachData(state) {
	  return state.verifyCoach.get('validCoachData');
	};
	var getcoachVerified = function getcoachVerified(state) {
	  return state.verifyCoach.get('coachVerified');
	};
	
	var selector = exports.selector = (0, _reselect.createStructuredSelector)({
	  validateCoachRequested: getvalidateCoachRequested,
	  validCoachData: getValidCoachData,
	  coachVerified: getcoachVerified
	});

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1364), __esModule: true };

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(486);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(486);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1363);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1362);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 490 */
[2544, 134, 98],
/* 491 */
[2548, 96, 132, 490],
/* 492 */
[2549, 291],
/* 493 */
[2554, 202, 97, 499, 133, 161, 1383, 297, 496, 76],
/* 494 */
[2560, 203, 163, 135, 301, 112, 491, 96],
/* 495 */
[2562, 497, 294],
/* 496 */
[2563, 112, 136, 298],
/* 497 */
[2564, 112, 135, 1375, 298],
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(97);
	var core = __webpack_require__(57);
	var fails = __webpack_require__(132);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(133);


/***/ },
/* 500 */
[2573, 300],
/* 501 */
[2582, 1391, 493],
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(1611);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1418));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 504 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 505 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 506 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 507 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 508 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Tutorial__materialize-textarea___BFCFV","modal-2463794813":"Tutorial__modal-2463794813___3jr-2","container":"Tutorial__container___3RdSZ","counter_container":"Tutorial__counter_container___1lQdz","header":"Tutorial__header___1df5c","tutorialsContainer":"Tutorial__tutorialsContainer___TvCqz","absoluteCross":"Tutorial__absoluteCross___2S784","helpButtons":"Tutorial__helpButtons___3nvAV","checkbox":"Tutorial__checkbox___3mTno","dontShowMeagain":"Tutorial__dontShowMeagain___SLIJR","labelStyle":"Tutorial__labelStyle___BZRxa","backgroundStyle":"Tutorial__backgroundStyle___2YVdX","nextButton":"Tutorial__nextButton___3Q9IH","containerBox":"Tutorial__containerBox___2Y1Ko","filterDescription":"Tutorial__filterDescription___2yq-q","counter_button_container":"Tutorial__counter_button_container___qXN6b","tryButton":"Tutorial__tryButton___2Txdw","notifyRed":"Tutorial__notifyRed___13t-x"};

/***/ },
/* 509 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"styles__materialize-textarea___3gaxL","modal-2463794813":"styles__modal-2463794813___38A4t","container":"styles__container___ivRZH","selectedButton":"styles__selectedButton___3Hu_m","plainButton":"styles__plainButton___3bj5U","selectPlan":"styles__selectPlan___2LWej","buttonContainer":"styles__buttonContainer___2F1D2","textarea":"styles__textarea___1SIYt","removePadding":"styles__removePadding___3uj8R","actionContainer":"styles__actionContainer___2ayec","successMessage":"styles__successMessage___26Mv3"};

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(77);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 511 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 512 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 513 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 514 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ },
/* 515 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager = function () {
	  function SheetsManager() {
	    _classCallCheck(this, SheetsManager);
	
	    this.sheets = [];
	    this.refs = [];
	    this.keys = [];
	  }
	
	  _createClass(SheetsManager, [{
	    key: 'get',
	    value: function get(key) {
	      var index = this.keys.indexOf(key);
	      return this.sheets[index];
	    }
	  }, {
	    key: 'add',
	    value: function add(key, sheet) {
	      var sheets = this.sheets,
	          refs = this.refs,
	          keys = this.keys;
	
	      var index = sheets.indexOf(sheet);
	
	      if (index !== -1) return index;
	
	      sheets.push(sheet);
	      refs.push(0);
	      keys.push(key);
	
	      return sheets.length - 1;
	    }
	  }, {
	    key: 'manage',
	    value: function manage(key) {
	      var index = this.keys.indexOf(key);
	      var sheet = this.sheets[index];
	      if (this.refs[index] === 0) sheet.attach();
	      this.refs[index]++;
	      if (!this.keys[index]) this.keys.splice(index, 0, key);
	      return sheet;
	    }
	  }, {
	    key: 'unmanage',
	    value: function unmanage(key) {
	      var index = this.keys.indexOf(key);
	      if (index === -1) {
	        // eslint-ignore-next-line no-console
	        (0, _warning2['default'])('SheetsManager: can\'t find sheet to unmanage');
	        return;
	      }
	      if (this.refs[index] > 0) {
	        this.refs[index]--;
	        if (this.refs[index] === 0) this.sheets[index].detach();
	      }
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	exports['default'] = SheetsManager;

/***/ },
/* 517 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry = function () {
	  function SheetsRegistry() {
	    _classCallCheck(this, SheetsRegistry);
	
	    this.registry = [];
	  }
	
	  _createClass(SheetsRegistry, [{
	    key: 'add',
	
	
	    /**
	     * Register a Style Sheet.
	     */
	    value: function add(sheet) {
	      var registry = this.registry;
	      var index = sheet.options.index;
	
	
	      if (registry.indexOf(sheet) !== -1) return;
	
	      if (registry.length === 0 || index >= this.index) {
	        registry.push(sheet);
	        return;
	      }
	
	      // Find a position.
	      for (var i = 0; i < registry.length; i++) {
	        if (registry[i].options.index > index) {
	          registry.splice(i, 0, sheet);
	          return;
	        }
	      }
	    }
	
	    /**
	     * Reset the registry.
	     */
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.registry = [];
	    }
	
	    /**
	     * Remove a Style Sheet.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(sheet) {
	      var index = this.registry.indexOf(sheet);
	      this.registry.splice(index, 1);
	    }
	
	    /**
	     * Convert all attached sheets to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return this.registry.filter(function (sheet) {
	        return sheet.attached;
	      }).map(function (sheet) {
	        return sheet.toString(options);
	      }).join('\n');
	    }
	  }, {
	    key: 'index',
	
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	exports['default'] = SheetsRegistry;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.getDynamicStyles = undefined;
	
	var _getDynamicStyles = __webpack_require__(1885);
	
	Object.defineProperty(exports, 'getDynamicStyles', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDynamicStyles)['default'];
	  }
	});
	
	var _SheetsRegistry = __webpack_require__(517);
	
	Object.defineProperty(exports, 'SheetsRegistry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SheetsRegistry)['default'];
	  }
	});
	
	var _SheetsManager = __webpack_require__(516);
	
	Object.defineProperty(exports, 'SheetsManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SheetsManager)['default'];
	  }
	});
	
	var _RuleList = __webpack_require__(206);
	
	Object.defineProperty(exports, 'RuleList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RuleList)['default'];
	  }
	});
	
	var _sheets = __webpack_require__(308);
	
	Object.defineProperty(exports, 'sheets', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sheets)['default'];
	  }
	});
	
	var _Jss = __webpack_require__(1872);
	
	var _Jss2 = _interopRequireDefault(_Jss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a new instance of Jss.
	 */
	var create = exports.create = function create(options) {
	  return new _Jss2['default'](options);
	};
	
	/**
	 * A global Jss instance.
	 */
	exports['default'] = create();

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(309);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	var _toCssValue = __webpack_require__(523);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleRule = function () {
	  function StyleRule(key, style, options) {
	    _classCallCheck(this, StyleRule);
	
	    this.type = 'style';
	    this.isProcessed = false;
	    var generateClassName = options.generateClassName,
	        sheet = options.sheet,
	        Renderer = options.Renderer,
	        selector = options.selector;
	
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    this.selectorText = selector || '.' + generateClassName(this, sheet);
	    this.renderer = sheet ? sheet.renderer : new Renderer();
	  }
	
	  /**
	   * Set selector string.
	   * TODO rewrite this #419
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  _createClass(StyleRule, [{
	    key: 'prop',
	
	
	    /**
	     * Get or set a style property.
	     */
	    value: function prop(name, nextValue) {
	      var $name = typeof this.style[name] === 'function' ? '$' + name : name;
	      var currValue = this.style[$name];
	
	      // Its a setter.
	      if (nextValue != null) {
	        // Don't do anything if the value has not changed.
	        if (currValue !== nextValue) {
	          nextValue = this.options.jss.plugins.onChangeValue(nextValue, name, this);
	          Object.defineProperty(this.style, $name, {
	            value: nextValue,
	            writable: true
	          });
	          // Defined if StyleSheet option `link` is true.
	          if (this.renderable) this.renderer.setStyle(this.renderable, name, nextValue);
	        }
	        return this;
	      }
	
	      // Its a getter, read the value from the DOM if its not cached.
	      if (this.renderable && currValue == null) {
	        // Cache the value after we have got it from the DOM first time.
	        Object.defineProperty(this.style, $name, {
	          value: this.renderer.getStyle(this.renderable, name),
	          writable: true
	        });
	      }
	
	      return this.style[$name];
	    }
	
	    /**
	     * Apply rule to an element inline.
	     */
	
	  }, {
	    key: 'applyTo',
	    value: function applyTo(renderable) {
	      var json = this.toJSON();
	      for (var prop in json) {
	        this.renderer.setStyle(renderable, prop, json[prop]);
	      }return this;
	    }
	
	    /**
	     * Returns JSON representation of the rule.
	     * Fallbacks are not supported.
	     * Useful for inline styles.
	     */
	
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      var json = {};
	      for (var prop in this.style) {
	        var value = this.style[prop];
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	        if (type === 'function') json[prop] = this.style['$' + prop];else if (type !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
	      }
	      return json;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return (0, _toCss2['default'])(this.selector, this.style, options);
	    }
	  }, {
	    key: 'selector',
	    set: function set(selector) {
	      var sheet = this.options.sheet;
	
	      // After we modify a selector, ref by old selector needs to be removed.
	
	      if (sheet) sheet.rules.unregister(this);
	
	      this.selectorText = selector;
	
	      if (!this.renderable) {
	        // Register the rule with new selector.
	        if (sheet) sheet.rules.register(this);
	        return;
	      }
	
	      var changed = this.renderer.setSelector(this.renderable, selector);
	
	      if (changed && sheet) {
	        sheet.rules.register(this);
	        return;
	      }
	
	      // If selector setter is not implemented, rerender the sheet.
	      // We need to delete renderable from the rule, because when sheet.deploy()
	      // calls rule.toString, it will get the old selector.
	      delete this.renderable;
	      if (sheet) {
	        sheet.rules.register(this);
	        sheet.deploy().link();
	      }
	    }
	
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      if (this.renderable) {
	        return this.renderer.getSelector(this.renderable);
	      }
	
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}();
	
	exports['default'] = StyleRule;

/***/ },
/* 520 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var globalRef = typeof window === 'undefined' ? global : window;
	
	var namespace = '__JSS_VERSION_COUNTER__';
	if (globalRef[namespace] == null) globalRef[namespace] = 0;
	// In case we have more than one JSS version.
	var jssCounter = globalRef[namespace]++;
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	
	exports['default'] = function () {
	  var ruleCounter = 0;
	
	  return function (rule) {
	    return rule.key + '-' + jssCounter + '-' + ruleCounter++;
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = createRule;
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _StyleRule = __webpack_require__(519);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _cloneStyle = __webpack_require__(1883);
	
	var _cloneStyle2 = _interopRequireDefault(_cloneStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Create a rule instance.
	 */
	function createRule() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
	  var decl = arguments[1];
	  var options = arguments[2];
	  var jss = options.jss;
	
	  var declCopy = (0, _cloneStyle2['default'])(decl);
	
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule;
	
	  // It is an at-rule and it has no instance.
	  if (name[0] === '@') {
	    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
	  }
	
	  return new _StyleRule2['default'](name, declCopy, options);
	}

/***/ },
/* 522 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = linkRule;
	/**
	 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
	 */
	function linkRule(rule, cssRule) {
	  rule.renderable = cssRule;
	  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
	}

/***/ },
/* 523 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCssValue;
	var joinWithSpace = function joinWithSpace(value) {
	  return value.join(' ');
	};
	
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 */
	function toCssValue(value) {
	  if (!Array.isArray(value)) return value;
	
	  // Support space separated values.
	  if (Array.isArray(value[0])) {
	    return toCssValue(value.map(joinWithSpace));
	  }
	
	  return value.join(', ');
	}

/***/ },
/* 524 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = assign;


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(208),
	    stackClear = __webpack_require__(1970),
	    stackDelete = __webpack_require__(1971),
	    stackGet = __webpack_require__(1972),
	    stackHas = __webpack_require__(1973),
	    stackSet = __webpack_require__(1974);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(527),
	    eq = __webpack_require__(214);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(533);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(531),
	    toKey = __webpack_require__(213);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1914),
	    isObjectLike = __webpack_require__(141);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(314),
	    nativeKeys = __webpack_require__(1961);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(79),
	    isKey = __webpack_require__(313),
	    stringToPath = __webpack_require__(1975),
	    toString = __webpack_require__(1986);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(526),
	    baseAssignValue = __webpack_require__(527);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(115);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1895),
	    arraySome = __webpack_require__(1904),
	    cacheHas = __webpack_require__(1928);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 535 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1891),
	    Map = __webpack_require__(310),
	    Promise = __webpack_require__(1893),
	    Set = __webpack_require__(1894),
	    WeakMap = __webpack_require__(1897),
	    baseGetTag = __webpack_require__(140),
	    toSource = __webpack_require__(541);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(214),
	    isArrayLike = __webpack_require__(165),
	    isIndex = __webpack_require__(312),
	    isObject = __webpack_require__(80);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(80);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 539 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 540 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 541 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(140),
	    getPrototype = __webpack_require__(1937),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(1992);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subheader = __webpack_require__(322);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	List.propTypes =  false ? {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = List;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(487);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(125);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(2011);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(207);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(544);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(1995);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div because the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var selectedIndex = void 0;
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	
	      if (this.props.multiple !== true) {
	        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
	      } else {
	        selectedIndex = this.state.focusIndex;
	      }
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var childIsDisabled = child.props.disabled;
	
	      var selectedChildStyles = {};
	      if (!childIsDisabled) {
	        var selected = this.isChildSelected(child, this.props);
	
	        if (selected) {
	          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
	        }
	      }
	      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
	
	      var extraProps = {
	        desktop: this.props.desktop,
	        style: mergedChildStyles
	      };
	      if (!childIsDisabled) {
	        var isFocused = childIndex === this.state.focusIndex;
	        var focusState = 'none';
	        if (isFocused) {
	          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	        }
	
	        (0, _simpleAssign2.default)(extraProps, {
	          focusState: focusState,
	          onClick: function onClick(event) {
	            _this2.handleMenuItemTouchTap(event, child, index);
	            if (child.props.onClick) child.props.onClick(event);
	          },
	          ref: isFocused ? 'focusedMenuItem' : null
	        });
	      }
	      return _react2.default.cloneElement(child, extraProps);
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getLastSelectedIndex',
	    value: function getLastSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        menuValue = menuValue || [];
	
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = menuValue,
	            _menuValue2 = (0, _toArray3.default)(_menuValue),
	            newMenuValue = _menuValue2.slice(0);
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          desktop = _props.desktop,
	          disableAutoFocus = _props.disableAutoFocus,
	          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          multiple = _props.multiple,
	          onItemTouchTap = _props.onItemTouchTap,
	          onEscKeyDown = _props.onEscKeyDown,
	          onMenuItemFocusChange = _props.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          menuItemStyle = _props.menuItemStyle,
	          style = _props.style,
	          value = _props.value,
	          valueLink = _props.valueLink,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer',
	            role: 'presentation'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles,
	              role: 'menu'
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    var focusIndex = _this5.state.focusIndex;
	
	    if (focusIndex < 0) {
	      return;
	    }
	
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var focusedItem = filteredChildren[focusIndex];
	    if (focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	Menu.propTypes =  false ? {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _propTypes2.default.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _propTypes2.default.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes4.default.stringOrNumber
	} : {};
	exports.default = Menu;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(125);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(547);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(2023);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(1993);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(545);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'default' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onClick: function onClick(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onClick) {
	            item.props.onClick(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: anchorOrigin,
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            targetOrigin: targetOrigin,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onClick = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          role: 'menuitem',
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  anchorOrigin: { horizontal: 'right', vertical: 'top' },
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false,
	  targetOrigin: { horizontal: 'left', vertical: 'top' }
	};
	MenuItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MenuItem.propTypes =  false ? {
	  /**
	   * Location of the anchor for the popover of nested `MenuItem`
	   * elements.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _propTypes2.default.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Location on the popover of nested `MenuItem` elements that will attach
	   * to the anchor's origin.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * The value of the menu item.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = MenuItem;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(359);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(2013);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(217);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(1890);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(1997);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          scrollableContainer = _this$props.scrollableContainer,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function () {
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.popoverRefs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = targetPosition.top + 'px';
	      targetEl.style.left = targetPosition.left + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.popoverRefs = {};
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open === this.props.open) {
	        return;
	      }
	
	      if (nextProps.open) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false
	        });
	      } else {
	        if (nextProps.animated) {
	          if (this.timeout !== null) return;
	          this.setState({ closing: true });
	          this.timeout = setTimeout(function () {
	            _this2.setState({
	              open: false
	            }, function () {
	              _this2.timeout = null;
	            });
	          }, 500);
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.placementTimeout);
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.placementTimeout) {
	        clearTimeout(this.placementTimeout);
	        this.placementTimeout = null;
	      }
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	      a.bottom = rect.bottom || a.top + a.height;
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: this.props.scrollableContainer,
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: function ref(_ref) {
	            return _this3.popoverRefs.layer = _ref;
	          },
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  scrollableContainer: 'window',
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Popover.propTypes =  false ? {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _propTypes2.default.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _propTypes2.default.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _propTypes2.default.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Represents the parent scrollable container.
	   * It can be an element or a string like `window`.
	   */
	  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _propTypes2.default.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Popover;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(1999);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _events = __webpack_require__(326);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(207);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(550);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(551);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.button.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	      }
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused,
	        style: {
	          overflow: 'hidden'
	        },
	        key: 'focusRipple'
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity,
	          key: 'touchRipple'
	        },
	        children
	      ) : undefined;
	
	      return [focusRipple, touchRipple, touchRipple ? undefined : children];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onClick: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      if (href) buttonProps.href = href;
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedButton.propTypes =  false ? {
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  disableFocusRipple: _propTypes2.default.bool,
	  disableKeyboardFocus: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focusRippleColor: _propTypes2.default.string,
	  focusRippleOpacity: _propTypes2.default.number,
	  href: _propTypes2.default.string,
	  keyboardFocused: _propTypes2.default.bool,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	  touchRippleColor: _propTypes2.default.string,
	  touchRippleOpacity: _propTypes2.default.number,
	  type: _propTypes2.default.string
	} : {};
	exports.default = EnhancedButton;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(125);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(324);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(2014);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FocusRipple.propTypes =  false ? {
	  color: _propTypes2.default.string,
	  innerStyle: _propTypes2.default.object,
	  opacity: _propTypes2.default.number,
	  show: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : {};
	exports.default = FocusRipple;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(488);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(487);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionGroup = __webpack_require__(264);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _dom = __webpack_require__(553);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(2009);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none',
	          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _TransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TouchRipple.propTypes =  false ? {
	  abortOnScroll: _propTypes2.default.bool,
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = TouchRipple;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(488);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(1889);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(325);
	
	var _lightBaseTheme = __webpack_require__(2018);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(2021);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(2028);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(2031);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(2033);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(2482);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(2020);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(323);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700,
	      opacity: 0.9
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme // To provide backward compatibility.
	  });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ },
/* 553 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(5)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(913);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(2040);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 683 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Applies a function to the value at the given index of an array, returning a
	 * new copy of the array with the element at the given index replaced with the
	 * result of the function application.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a -> a) -> Number -> [a] -> [a]
	 * @param {Function} fn The function to apply.
	 * @param {Number} idx The index.
	 * @param {Array|Arguments} list An array-like object whose value
	 *        at the supplied index will be replaced.
	 * @return {Array} A copy of the supplied array-like object with
	 *         the element at index `idx` replaced with the value
	 *         returned by applying `fn` to the existing element.
	 * @see R.update
	 * @example
	 *
	 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
	 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
	 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
	 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
	 */
	module.exports = _curry3(function adjust(fn, idx, list) {
	  if (idx >= list.length || idx < -list.length) {
	    return list;
	  }
	  var start = idx < 0 ? list.length : 0;
	  var _idx = start + idx;
	  var _list = _concat(list);
	  _list[_idx] = fn(list[_idx]);
	  return _list;
	});


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if both arguments are `true`; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if it is falsy, otherwise the second argument.
	 * @see R.both
	 * @example
	 *
	 *      R.and(true, true); //=> true
	 *      R.and(true, false); //=> false
	 *      R.and(false, true); //=> false
	 *      R.and(false, false); //=> false
	 */
	module.exports = _curry2(function and(a, b) {
	  return a && b;
	});


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xany = __webpack_require__(711);
	
	
	/**
	 * Returns `true` if at least one of elements of the list match the predicate,
	 * `false` otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
	 *         otherwise.
	 * @see R.all, R.none, R.transduce
	 * @example
	 *
	 *      var lessThan0 = R.flip(R.lt)(0);
	 *      var lessThan2 = R.flip(R.lt)(2);
	 *      R.any(lessThan0)([1, 2]); //=> false
	 *      R.any(lessThan2)([1, 2]); //=> true
	 */
	module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (fn(list[idx])) {
	      return true;
	    }
	    idx += 1;
	  }
	  return false;
	}));


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Applies function `fn` to the argument list `args`. This is useful for
	 * creating a fixed-arity function from a variadic function. `fn` should be a
	 * bound function if context is significant.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig (*... -> a) -> [*] -> a
	 * @param {Function} fn The function which will be called with `args`
	 * @param {Array} args The arguments to call `fn` with
	 * @return {*} result The result, equivalent to `fn(...args)`
	 * @see R.call, R.unapply
	 * @example
	 *
	 *      var nums = [1, 2, 3, -99, 42, 6, 7];
	 *      R.apply(Math.max, nums); //=> 42
	 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
	 */
	module.exports = _curry2(function apply(fn, args) {
	  return fn.apply(this, args);
	});


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var _has = __webpack_require__(52);
	var _isArray = __webpack_require__(102);
	var _isInteger = __webpack_require__(707);
	var assoc = __webpack_require__(168);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the nodes required
	 * to create the given path, and placing the specific value at the tail end of
	 * that path. Note that this copies and flattens prototype properties onto the
	 * new object as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> {a}
	 * @param {Array} path the path to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except along the specified path.
	 * @see R.dissocPath
	 * @example
	 *
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
	 *
	 *      // Any missing or non-object keys in path will be overridden
	 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
	 */
	module.exports = _curry3(function assocPath(path, val, obj) {
	  if (path.length === 0) {
	    return val;
	  }
	  var idx = path[0];
	  if (path.length > 1) {
	    var nextObj = _has(idx, obj) ? obj[idx] : _isInteger(path[1]) ? [] : {};
	    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
	  }
	  if (_isInteger(idx) && _isArray(obj)) {
	    var arr = [].concat(obj);
	    arr[idx] = val;
	    return arr;
	  } else {
	    return assoc(idx, val, obj);
	  }
	});


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var chain = __webpack_require__(328);
	var compose = __webpack_require__(220);
	var map = __webpack_require__(59);
	
	
	/**
	 * Returns the right-to-left Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipeK
	 * @example
	 *
	 *       //  get :: String -> Object -> Maybe *
	 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
	 *
	 *       //  getStateCode :: Maybe String -> Maybe String
	 *       var getStateCode = R.composeK(
	 *         R.compose(Maybe.of, R.toUpper),
	 *         get('state'),
	 *         get('address'),
	 *         get('user'),
	 *       );
	 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
	 *       getStateCode({}); //=> Maybe.Nothing()
	 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
	 */
	module.exports = function composeK() {
	  if (arguments.length === 0) {
	    throw new Error('composeK requires at least one argument');
	  }
	  var init = Array.prototype.slice.call(arguments);
	  var last = init.pop();
	  return compose(compose.apply(this, map(chain, init)), last);
	};


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var curry = __webpack_require__(221);
	var nAry = __webpack_require__(230);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type. The arity of the function
	 * returned is specified to allow using variadic constructor functions.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Function
	 * @sig Number -> (* -> {*}) -> (* -> {*})
	 * @param {Number} n The arity of the constructor function.
	 * @param {Function} Fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Variadic Constructor function
	 *      function Salad() {
	 *        this.ingredients = arguments;
	 *      };
	 *      Salad.prototype.recipe = function() {
	 *        var instructions = R.map((ingredient) => (
	 *          'Add a whollop of ' + ingredient, this.ingredients)
	 *        )
	 *        return R.join('\n', instructions)
	 *      }
	 *
	 *      var ThreeLayerSalad = R.constructN(3, Salad)
	 *
	 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
	 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
	 *      console.log(salad.recipe());
	 *      // Add a whollop of Mayonnaise
	 *      // Add a whollop of Potato Chips
	 *      // Add a whollop of Potato Ketchup
	 */
	module.exports = _curry2(function constructN(n, Fn) {
	  if (n > 10) {
	    throw new Error('Constructor with greater than ten arguments');
	  }
	  if (n === 0) {
	    return function() { return new Fn(); };
	  }
	  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
	    switch (arguments.length) {
	      case  1: return new Fn($0);
	      case  2: return new Fn($0, $1);
	      case  3: return new Fn($0, $1, $2);
	      case  4: return new Fn($0, $1, $2, $3);
	      case  5: return new Fn($0, $1, $2, $3, $4);
	      case  6: return new Fn($0, $1, $2, $3, $4, $5);
	      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
	      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
	      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
	      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
	    }
	  }));
	});


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _map = __webpack_require__(227);
	var curryN = __webpack_require__(49);
	var max = __webpack_require__(144);
	var pluck = __webpack_require__(174);
	var reduce = __webpack_require__(67);
	
	
	/**
	 * Accepts a converging function and a list of branching functions and returns
	 * a new function. When invoked, this new function is applied to some
	 * arguments, each branching function is applied to those same arguments. The
	 * results of each branching function are passed as arguments to the converging
	 * function to produce the return value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.2
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} after A function. `after` will be invoked with the return values of
	 *        `fn1` and `fn2` as its arguments.
	 * @param {Array} functions A list of functions.
	 * @return {Function} A new function.
	 * @see R.useWith
	 * @example
	 *
	 *      var average = R.converge(R.divide, [R.sum, R.length])
	 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
	 *
	 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
	 *      strangeConcat("Yodel") //=> "YODELyodel"
	 *
	 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
	 */
	module.exports = _curry2(function converge(after, fns) {
	  return curryN(reduce(max, 0, pluck('length', fns)), function() {
	    var args = arguments;
	    var context = this;
	    return after.apply(context, _map(function(fn) {
	      return fn.apply(context, args);
	    }, fns));
	  });
	});


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns the second argument if it is not `null`, `undefined` or `NaN`
	 * otherwise the first argument is returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {a} default The default value.
	 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
	 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
	 * @example
	 *
	 *      var defaultTo42 = R.defaultTo(42);
	 *
	 *      defaultTo42(null);  //=> 42
	 *      defaultTo42(undefined);  //=> 42
	 *      defaultTo42('Ramda');  //=> 'Ramda'
	 *      // parseInt('string') results in NaN
	 *      defaultTo42(parseInt('string')); //=> 42
	 */
	module.exports = _curry2(function defaultTo(d, v) {
	  return v == null || v !== v ? d : v;
	});


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(117);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Objects and Arrays are compared are compared
	 * in terms of value equality, not reference equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
	 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
	 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
	 */
	module.exports = _curry2(function difference(first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
	      out[out.length] = first[idx];
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(334);
	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements in the first list not
	 * contained in the second list. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` that are not in `list2`.
	 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
	 * @example
	 *
	 *      var cmp = (x, y) => x.a === y.a;
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
	 *      var l2 = [{a: 3}, {a: 4}];
	 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
	 */
	module.exports = _curry3(function differenceWith(pred, first, second) {
	  var out = [];
	  var idx = 0;
	  var firstLen = first.length;
	  while (idx < firstLen) {
	    if (!_containsWith(pred, first[idx], second) &&
	        !_containsWith(pred, first[idx], out)) {
	      out.push(first[idx]);
	    }
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xdrop = __webpack_require__(2121);
	var slice = __webpack_require__(118);
	
	
	/**
	 * Returns all but the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `drop` method).
	 *
	 * Dispatches to the `drop` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {[a]} list
	 * @return {[a]} A copy of list without the first `n` elements
	 * @see R.take, R.transduce, R.dropLast, R.dropWhile
	 * @example
	 *
	 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.drop(3, 'ramda');               //=> 'da'
	 */
	module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
	  return slice(Math.max(0, n), Infinity, xs);
	}));


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xdropRepeatsWith = __webpack_require__(712);
	var last = __webpack_require__(716);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. Equality is
	 * determined by applying the supplied predicate to each pair of consecutive elements. The
	 * first element in a series of equal elements will be preserved.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig (a, a -> Boolean) -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
	 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
	 */
	module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
	  var result = [];
	  var idx = 1;
	  var len = list.length;
	  if (len !== 0) {
	    result[0] = list[0];
	    while (idx < len) {
	      if (!pred(last(result), list[idx])) {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	  }
	  return result;
	}));
	


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _isArguments = __webpack_require__(706);
	var _isArray = __webpack_require__(102);
	var _isObject = __webpack_require__(709);
	var _isString = __webpack_require__(226);
	
	
	/**
	 * Returns the empty value of its argument's type. Ramda defines the empty
	 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
	 * types are supported if they define `<Type>.empty` and/or
	 * `<Type>.prototype.empty`.
	 *
	 * Dispatches to the `empty` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> a
	 * @param {*} x
	 * @return {*}
	 * @example
	 *
	 *      R.empty(Just(42));      //=> Nothing()
	 *      R.empty([1, 2, 3]);     //=> []
	 *      R.empty('unicorns');    //=> ''
	 *      R.empty({x: 1, y: 2});  //=> {}
	 */
	module.exports = _curry1(function empty(x) {
	  return (
	    (x != null && typeof x.empty === 'function') ?
	      x.empty() :
	    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
	      x.constructor.empty() :
	    _isArray(x) ?
	      [] :
	    _isString(x) ?
	      '' :
	    _isObject(x) ?
	      {} :
	    _isArguments(x) ?
	      (function() { return arguments; }()) :
	    // else
	      void 0
	  );
	});


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns true if its arguments are identical, false otherwise. Values are
	 * identical if they reference the same memory. `NaN` is identical to `NaN`;
	 * `0` and `-0` are not identical.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Relation
	 * @sig a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @example
	 *
	 *      var o = {};
	 *      R.identical(o, o); //=> true
	 *      R.identical(1, 1); //=> true
	 *      R.identical(1, '1'); //=> false
	 *      R.identical([], []); //=> false
	 *      R.identical(0, -0); //=> false
	 *      R.identical(NaN, NaN); //=> true
	 */
	module.exports = _curry2(function identical(a, b) {
	  // SameValue algorithm
	  if (a === b) { // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return a !== 0 || 1 / a === 1 / b;
	  } else {
	    // Step 6.a: NaN == NaN
	    return a !== a && b !== b;
	  }
	});


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(701);
	var type = __webpack_require__(339);
	
	
	/**
	 * Copies an object.
	 *
	 * @private
	 * @param {*} value The value to be copied
	 * @param {Array} refFrom Array containing the source references
	 * @param {Array} refTo Array containing the copied source references
	 * @param {Boolean} deep Whether or not to perform deep cloning.
	 * @return {*} The copied value.
	 */
	module.exports = function _clone(value, refFrom, refTo, deep) {
	  var copy = function copy(copiedValue) {
	    var len = refFrom.length;
	    var idx = 0;
	    while (idx < len) {
	      if (value === refFrom[idx]) {
	        return refTo[idx];
	      }
	      idx += 1;
	    }
	    refFrom[idx + 1] = value;
	    refTo[idx + 1] = copiedValue;
	    for (var key in value) {
	      copiedValue[key] = deep ?
	        _clone(value[key], refFrom, refTo, true) : value[key];
	    }
	    return copiedValue;
	  };
	  switch (type(value)) {
	    case 'Object':  return copy({});
	    case 'Array':   return copy([]);
	    case 'Date':    return new Date(value.valueOf());
	    case 'RegExp':  return _cloneRegExp(value);
	    default:        return value;
	  }
	};


/***/ },
/* 701 */
/***/ function(module, exports) {

	module.exports = function _cloneRegExp(pattern) {
	  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
	                                    (pattern.ignoreCase ? 'i' : '') +
	                                    (pattern.multiline  ? 'm' : '') +
	                                    (pattern.sticky     ? 'y' : '') +
	                                    (pattern.unicode    ? 'u' : ''));
	};


/***/ },
/* 702 */
/***/ function(module, exports) {

	module.exports = function _complement(f) {
	  return function() {
	    return !f.apply(this, arguments);
	  };
	};


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _curry2 = __webpack_require__(6);
	
	
	module.exports = function _createPartialApplicator(concat) {
	  return _curry2(function(fn, args) {
	    return _arity(Math.max(0, fn.length - args.length), function() {
	      return fn.apply(this, concat(args, arguments));
	    });
	  });
	};


/***/ },
/* 704 */
/***/ function(module, exports) {

	module.exports = function _filter(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	
	  while (idx < len) {
	    if (fn(list[idx])) {
	      result[result.length] = list[idx];
	    }
	    idx += 1;
	  }
	  return result;
	};


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var equals = __webpack_require__(81);
	
	
	module.exports = function _indexOf(list, a, idx) {
	  var inf, item;
	  // Array.prototype.indexOf doesn't exist below IE9
	  if (typeof list.indexOf === 'function') {
	    switch (typeof a) {
	      case 'number':
	        if (a === 0) {
	          // manually crawl the list to distinguish between +0 and -0
	          inf = 1 / a;
	          while (idx < list.length) {
	            item = list[idx];
	            if (item === 0 && 1 / item === inf) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        } else if (a !== a) {
	          // NaN
	          while (idx < list.length) {
	            item = list[idx];
	            if (typeof item === 'number' && item !== item) {
	              return idx;
	            }
	            idx += 1;
	          }
	          return -1;
	        }
	        // non-zero numbers can utilise Set
	        return list.indexOf(a, idx);
	
	      // all these types can utilise Set
	      case 'string':
	      case 'boolean':
	      case 'function':
	      case 'undefined':
	        return list.indexOf(a, idx);
	
	      case 'object':
	        if (a === null) {
	          // null can utilise Set
	          return list.indexOf(a, idx);
	        }
	    }
	  }
	  // anything else not covered above, defer to R.equals
	  while (idx < list.length) {
	    if (equals(list[idx], a)) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	};


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(52);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ },
/* 707 */
/***/ function(module, exports) {

	/**
	 * Determine if the passed argument is an integer.
	 *
	 * @private
	 * @param {*} n
	 * @category Type
	 * @return {Boolean}
	 */
	module.exports = Number.isInteger || function _isInteger(n) {
	  return (n << 0) === n;
	};


/***/ },
/* 708 */
/***/ function(module, exports) {

	module.exports = function _isNumber(x) {
	  return Object.prototype.toString.call(x) === '[object Number]';
	};


/***/ },
/* 709 */
/***/ function(module, exports) {

	module.exports = function _isObject(x) {
	  return Object.prototype.toString.call(x) === '[object Object]';
	};


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(171);
	
	
	/**
	 * `_makeFlat` is a helper function that returns a one-level or fully recursive
	 * function based on the flag passed in.
	 *
	 * @private
	 */
	module.exports = function _makeFlat(recursive) {
	  return function flatt(list) {
	    var value, jlen, j;
	    var result = [];
	    var idx = 0;
	    var ilen = list.length;
	
	    while (idx < ilen) {
	      if (isArrayLike(list[idx])) {
	        value = recursive ? flatt(list[idx]) : list[idx];
	        j = 0;
	        jlen = value.length;
	        while (j < jlen) {
	          result[result.length] = value[j];
	          j += 1;
	        }
	      } else {
	        result[result.length] = list[idx];
	      }
	      idx += 1;
	    }
	    return result;
	  };
	};


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduced = __webpack_require__(103);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XAny(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.any = false;
	  }
	  XAny.prototype['@@transducer/init'] = _xfBase.init;
	  XAny.prototype['@@transducer/result'] = function(result) {
	    if (!this.any) {
	      result = this.xf['@@transducer/step'](result, false);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAny.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.any = true;
	      result = _reduced(this.xf['@@transducer/step'](result, true));
	    }
	    return result;
	  };
	
	  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
	}());


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XDropRepeatsWith(pred, xf) {
	    this.xf = xf;
	    this.pred = pred;
	    this.lastValue = undefined;
	    this.seenFirstValue = false;
	  }
	
	  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
	  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
	  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
	    var sameAsLast = false;
	    if (!this.seenFirstValue) {
	      this.seenFirstValue = true;
	    } else if (this.pred(this.lastValue, input)) {
	      sameAsLast = true;
	    }
	    this.lastValue = input;
	    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
	}());


/***/ },
/* 713 */
/***/ function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * See if an object (`val`) is an instance of the supplied constructor. This
	 * function will check up the inheritance chain, if any.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Type
	 * @sig (* -> {*}) -> a -> Boolean
	 * @param {Object} ctor A constructor
	 * @param {*} val The value to test
	 * @return {Boolean}
	 * @example
	 *
	 *      R.is(Object, {}); //=> true
	 *      R.is(Number, 1); //=> true
	 *      R.is(Object, 1); //=> false
	 *      R.is(String, 's'); //=> true
	 *      R.is(String, new String('')); //=> true
	 *      R.is(Object, new String('')); //=> true
	 *      R.is(Object, 's'); //=> false
	 *      R.is(Number, {}); //=> false
	 */
	module.exports = _curry2(function is(Ctor, val) {
	  return val != null && val.constructor === Ctor || val instanceof Ctor;
	});


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var converge = __webpack_require__(692);
	
	
	/**
	 * juxt applies a list of functions to a list of values.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Function
	 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
	 * @param {Array} fns An array of functions
	 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
	 * @see R.applySpec
	 * @example
	 *
	 *      var getRange = R.juxt([Math.min, Math.max]);
	 *      getRange(3, 4, 9, -3); //=> [-3, 9]
	 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
	 */
	module.exports = _curry1(function juxt(fns) {
	  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
	});


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(172);
	
	
	/**
	 * Returns the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.init, R.head, R.tail
	 * @example
	 *
	 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
	 *      R.last([]); //=> undefined
	 *
	 *      R.last('abc'); //=> 'c'
	 *      R.last(''); //=> ''
	 */
	module.exports = nth(-1);


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _isNumber = __webpack_require__(708);
	
	
	/**
	 * Returns the number of elements in the array by returning `list.length`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [a] -> Number
	 * @param {Array} list The array to inspect.
	 * @return {Number} The length of the array.
	 * @example
	 *
	 *      R.length([]); //=> 0
	 *      R.length([1, 2, 3]); //=> 3
	 */
	module.exports = _curry1(function length(list) {
	  return list != null && _isNumber(list.length) ? list.length : NaN;
	});


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduce = __webpack_require__(62);
	var ap = __webpack_require__(327);
	var curryN = __webpack_require__(49);
	var map = __webpack_require__(59);
	
	
	/**
	 * "lifts" a function to be the specified arity, so that it may "map over" that
	 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Function
	 * @sig Number -> (*... -> *) -> ([*]... -> [*])
	 * @param {Function} fn The function to lift into higher context
	 * @return {Function} The lifted function.
	 * @see R.lift, R.ap
	 * @example
	 *
	 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
	 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
	 */
	module.exports = _curry2(function liftN(arity, fn) {
	  var lifted = curryN(arity, fn);
	  return curryN(arity, function() {
	    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
	  });
	});


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var sum = __webpack_require__(733);
	
	
	/**
	 * Returns the mean of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.mean([2, 7, 9]); //=> 6
	 *      R.mean([]); //=> NaN
	 */
	module.exports = _curry1(function mean(list) {
	  return sum(list) / list.length;
	});


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var _has = __webpack_require__(52);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the key
	 * and the values associated with the key in each object, with the result being
	 * used as the value associated with the key in the returned object. The key
	 * will be excluded from the returned object if the resulting value is
	 * `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWith
	 * @example
	 *
	 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
	 *      R.mergeWithKey(concatValues,
	 *                     { a: true, thing: 'foo', values: [10, 20] },
	 *                     { b: true, thing: 'bar', values: [15, 35] });
	 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
	 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
	 */
	module.exports = _curry3(function mergeWithKey(fn, l, r) {
	  var result = {};
	  var k;
	
	  for (k in l) {
	    if (_has(k, l)) {
	      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
	    }
	  }
	
	  for (k in r) {
	    if (_has(k, r) && !(_has(k, result))) {
	      result[k] = r[k];
	    }
	  }
	
	  return result;
	});


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Multiplies two numbers. Equivalent to `a * b` but curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a * b`.
	 * @see R.divide
	 * @example
	 *
	 *      var double = R.multiply(2);
	 *      var triple = R.multiply(3);
	 *      double(3);       //=>  6
	 *      triple(4);       //=> 12
	 *      R.multiply(2, 5);  //=> 10
	 */
	module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * A function that returns the `!` of its argument. It will return `true` when
	 * passed false-y value, and `false` when passed a truth-y one.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig * -> Boolean
	 * @param {*} a any value
	 * @return {Boolean} the logical inverse of passed argument.
	 * @see R.complement
	 * @example
	 *
	 *      R.not(true); //=> false
	 *      R.not(false); //=> true
	 *      R.not(0); //=> true
	 *      R.not(1); //=> false
	 */
	module.exports = _curry1(function not(a) {
	  return !a;
	});


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Creates an object containing a single key:value pair.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @sig String -> a -> {String:a}
	 * @param {String} key
	 * @param {*} val
	 * @return {Object}
	 * @see R.pair
	 * @example
	 *
	 *      var matchPhrases = R.compose(
	 *        R.objOf('must'),
	 *        R.map(R.objOf('match_phrase'))
	 *      );
	 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
	 */
	module.exports = _curry2(function objOf(key, val) {
	  var obj = {};
	  obj[key] = val;
	  return obj;
	});


/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if one or both of its arguments are `true`. Returns `false`
	 * if both arguments are `false`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> b -> a | b
	 * @param {Any} a
	 * @param {Any} b
	 * @return {Any} the first argument if truthy, otherwise the second argument.
	 * @see R.either
	 * @example
	 *
	 *      R.or(true, true); //=> true
	 *      R.or(true, false); //=> true
	 *      R.or(false, true); //=> true
	 *      R.or(false, false); //=> false
	 */
	module.exports = _curry2(function or(a, b) {
	  return a || b;
	});


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the result of applying the given function to
	 * the focused value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> (a -> a) -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
	 */
	module.exports = (function() {
	  // `Identity` is a functor that holds a single value, where `map` simply
	  // transforms the held value with the provided function.
	  var Identity = function(x) {
	    return {value: x, map: function(f) { return Identity(f(x)); }};
	  };
	
	  return _curry3(function over(lens, f, x) {
	    // The value returned by the getter function is first transformed with `f`,
	    // then set as the value of an `Identity`. This is then mapped over with the
	    // setter function of the lens.
	    return lens(function(y) { return Identity(f(y)); })(x).value;
	  });
	}());


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Similar to `pick` except that this one includes a `key: undefined` pair for
	 * properties that don't exist.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
	 */
	module.exports = _curry2(function pickAll(names, obj) {
	  var result = {};
	  var idx = 0;
	  var len = names.length;
	  while (idx < len) {
	    var name = names[idx];
	    result[name] = obj[name];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _pipe = __webpack_require__(2112);
	var reduce = __webpack_require__(67);
	var tail = __webpack_require__(338);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _pipeP = __webpack_require__(2113);
	var reduce = __webpack_require__(67);
	var tail = __webpack_require__(338);
	
	
	/**
	 * Performs left-to-right composition of one or more Promise-returning
	 * functions. The leftmost function may have any arity; the remaining functions
	 * must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.composeP
	 * @example
	 *
	 *      //  followersForUser :: String -> Promise [User]
	 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
	 */
	module.exports = function pipeP() {
	  if (arguments.length === 0) {
	    throw new Error('pipeP requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipeP, arguments[0], tail(arguments)));
	};


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a new list with the given element at the front, followed by the
	 * contents of the list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The item to add to the head of the output list.
	 * @param {Array} list The array to add to the tail of the output list.
	 * @return {Array} A new array.
	 * @see R.append
	 * @example
	 *
	 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
	 */
	module.exports = _curry2(function prepend(el, list) {
	  return _concat([el], list);
	});


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * Similar to `reduce`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two values: *(value, acc)*, while the arguments'
	 * order of `reduce`'s iterator function is *(acc, value)*.
	 *
	 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a, b -> b) -> b -> [a] -> b
	 * @param {Function} fn The iterator function. Receives two values, the current element from the array
	 *        and the accumulator.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.addIndex
	 * @example
	 *
	 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
	 *          -               -2
	 *         / \              / \
	 *        1   -            1   3
	 *           / \              / \
	 *          2   -     ==>    2  -1
	 *             / \              / \
	 *            3   -            3   4
	 *               / \              / \
	 *              4   0            4   0
	 *
	 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
	 */
	module.exports = _curry3(function reduceRight(fn, acc, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    acc = fn(list[idx], acc);
	    idx -= 1;
	  }
	  return acc;
	});


/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var ap = __webpack_require__(327);
	var map = __webpack_require__(59);
	var prepend = __webpack_require__(730);
	var reduceRight = __webpack_require__(731);
	
	
	/**
	 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
	 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
	 * Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
	 * @param {Function} of
	 * @param {*} traversable
	 * @return {*}
	 * @see R.traverse
	 * @example
	 *
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
	 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
	 *
	 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
	 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
	 */
	module.exports = _curry2(function sequence(of, traversable) {
	  return typeof traversable.sequence === 'function' ?
	    traversable.sequence(of) :
	    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
	                of([]),
	                traversable);
	});


/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(219);
	var reduce = __webpack_require__(67);
	
	
	/**
	 * Adds together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The sum of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.sum([2,4,6,8,100,1]); //=> 121
	 */
	module.exports = reduce(add, 0);


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xtake = __webpack_require__(2132);
	var slice = __webpack_require__(118);
	
	
	/**
	 * Returns the first `n` elements of the given list, string, or
	 * transducer/transformer (or object with a `take` method).
	 *
	 * Dispatches to the `take` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n
	 * @param {*} list
	 * @return {*}
	 * @see R.drop
	 * @example
	 *
	 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.take(3, 'ramda');               //=> 'ram'
	 *
	 *      var personnel = [
	 *        'Dave Brubeck',
	 *        'Paul Desmond',
	 *        'Eugene Wright',
	 *        'Joe Morello',
	 *        'Gerry Mulligan',
	 *        'Bob Bates',
	 *        'Joe Dodge',
	 *        'Ron Crotty'
	 *      ];
	 *
	 *      var takeFive = R.take(5);
	 *      takeFive(personnel);
	 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
	 * @symb R.take(-1, [a, b]) = [a, b]
	 * @symb R.take(0, [a, b]) = []
	 * @symb R.take(1, [a, b]) = [a]
	 * @symb R.take(2, [a, b]) = [a, b]
	 */
	module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
	  return slice(0, n < 0 ? Infinity : n, xs);
	}));


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Calls an input function `n` times, returning an array containing the results
	 * of those function calls.
	 *
	 * `fn` is passed one argument: The current value of `n`, which begins at `0`
	 * and is gradually incremented to `n - 1`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.3
	 * @category List
	 * @sig (Number -> a) -> Number -> [a]
	 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
	 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
	 * @return {Array} An array containing the return values of all calls to `fn`.
	 * @example
	 *
	 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
	 * @symb R.times(f, 0) = []
	 * @symb R.times(f, 1) = [f(0)]
	 * @symb R.times(f, 2) = [f(0), f(1)]
	 */
	module.exports = _curry2(function times(fn, n) {
	  var len = Number(n);
	  var idx = 0;
	  var list;
	
	  if (len < 0 || isNaN(len)) {
	    throw new RangeError('n must be a non-negative number');
	  }
	  list = new Array(len);
	  while (idx < len) {
	    list[idx] = fn(idx);
	    idx += 1;
	  }
	  return list;
	});


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var _Set = __webpack_require__(2100);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a new list containing only one copy of each element in the original
	 * list, based upon the value returned by applying the supplied function to
	 * each list element. Prefers the first item if the supplied function produces
	 * the same value on two items. `R.equals` is used for comparison.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> b) -> [a] -> [a]
	 * @param {Function} fn A function used to produce a value to use during comparisons.
	 * @param {Array} list The array to consider.
	 * @return {Array} The list of unique items.
	 * @example
	 *
	 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
	 */
	module.exports = _curry2(function uniqBy(fn, list) {
	  var set = new _Set();
	  var result = [];
	  var idx = 0;
	  var appliedItem, item;
	
	  while (idx < list.length) {
	    item = list[idx];
	    appliedItem = fn(item);
	    if (set.add(appliedItem)) {
	      result.push(item);
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var adjust = __webpack_require__(684);
	var always = __webpack_require__(143);
	
	
	/**
	 * Returns a new copy of the array with the element at the provided index
	 * replaced with the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} idx The index to update.
	 * @param {*} x The value to exist at the given index of the returned array.
	 * @param {Array|Arguments} list The source array-like object to be updated.
	 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
	 * @see R.adjust
	 * @example
	 *
	 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
	 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
	 * @symb R.update(-1, a, [b, c]) = [b, a]
	 * @symb R.update(0, a, [b, c]) = [a, c]
	 * @symb R.update(1, a, [b, c]) = [b, a]
	 */
	module.exports = _curry3(function update(idx, x, list) {
	  return adjust(always(x), idx, list);
	});


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var curryN = __webpack_require__(49);
	
	
	/**
	 * Accepts a function `fn` and a list of transformer functions and returns a
	 * new curried function. When the new function is invoked, it calls the
	 * function `fn` with parameters consisting of the result of calling each
	 * supplied handler on successive arguments to the new function.
	 *
	 * If more arguments are passed to the returned function than transformer
	 * functions, those arguments are passed directly to `fn` as additional
	 * parameters. If you expect additional arguments that don't need to be
	 * transformed, although you can ignore them, it's best to pass an identity
	 * function so that the new function reports the correct arity.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
	 * @param {Function} fn The function to wrap.
	 * @param {Array} transformers A list of transformer functions
	 * @return {Function} The wrapped function.
	 * @see R.converge
	 * @example
	 *
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
	 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
	 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
	 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
	 */
	module.exports = _curry2(function useWith(fn, transformers) {
	  return curryN(transformers.length, function() {
	    var args = [];
	    var idx = 0;
	    while (idx < transformers.length) {
	      args.push(transformers[idx].call(this, arguments[idx]));
	      idx += 1;
	    }
	    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
	  });
	});


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var keys = __webpack_require__(63);
	
	
	/**
	 * Returns a list of all the enumerable own properties of the supplied object.
	 * Note that the order of the output array is not guaranteed across different
	 * JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own properties.
	 * @example
	 *
	 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
	 */
	module.exports = _curry1(function values(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var vals = [];
	  var idx = 0;
	  while (idx < len) {
	    vals[idx] = obj[props[idx]];
	    idx += 1;
	  }
	  return vals;
	});


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _has = __webpack_require__(52);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec. Each of the spec's own properties must be a predicate function.
	 * Each predicate is applied to the value of the corresponding property of the
	 * test object. `where` returns true if all the predicates return true, false
	 * otherwise.
	 *
	 * `where` is well suited to declaratively expressing constraints for other
	 * functions such as `filter` and `find`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Object
	 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.where({
	 *        a: R.equals('foo'),
	 *        b: R.complement(R.equals('bar')),
	 *        x: R.gt(__, 10),
	 *        y: R.lt(__, 20)
	 *      });
	 *
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
	 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
	 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
	 */
	module.exports = _curry2(function where(spec, testObj) {
	  for (var prop in spec) {
	    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
	      return false;
	    }
	  }
	  return true;
	});


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Collapsible = _react2.default.createClass({
	  displayName: 'Collapsible',
	
	
	  //Set validation for prop types
	  propTypes: {
	    transitionTime: _react2.default.PropTypes.number,
	    easing: _react2.default.PropTypes.string,
	    open: _react2.default.PropTypes.bool,
	    classParentString: _react2.default.PropTypes.string,
	    openedClassName: _react2.default.PropTypes.string,
	    triggerClassName: _react2.default.PropTypes.string,
	    triggerOpenedClassName: _react2.default.PropTypes.string,
	    contentOuterClassName: _react2.default.PropTypes.string,
	    contentInnerClassName: _react2.default.PropTypes.string,
	    accordionPosition: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]),
	    handleTriggerClick: _react2.default.PropTypes.func,
	    onOpen: _react2.default.PropTypes.func,
	    onClose: _react2.default.PropTypes.func,
	    trigger: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]),
	    triggerWhenOpen: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]),
	    triggerDisabled: _react2.default.PropTypes.bool,
	    lazyRender: _react2.default.PropTypes.bool,
	    overflowWhenOpen: _react2.default.PropTypes.oneOf(['hidden', 'visible', 'auto', 'scroll', 'inherit', 'initial', 'unset']),
	    triggerSibling: _react2.default.PropTypes.element
	  },
	
	  //If no transition time or easing is passed then default to this
	  getDefaultProps: function getDefaultProps() {
	    return {
	      transitionTime: 400,
	      easing: 'linear',
	      open: false,
	      classParentString: 'Collapsible',
	      triggerDisabled: false,
	      lazyRender: false,
	      overflowWhenOpen: 'hidden',
	      openedClassName: '',
	      triggerClassName: '',
	      triggerOpenedClassName: '',
	      contentOuterClassName: '',
	      contentInnerClassName: '',
	      className: '',
	      triggerSibling: null,
	      onOpen: function onOpen() {},
	      onClose: function onClose() {}
	    };
	  },
	
	  //Defaults the dropdown to be closed
	  getInitialState: function getInitialState() {
	
	    if (this.props.open) {
	      return {
	        isClosed: false,
	        shouldSwitchAutoOnNextCycle: false,
	        height: 'auto',
	        transition: 'none',
	        hasBeenOpened: true,
	        overflow: this.props.overflowWhenOpen
	      };
	    } else {
	      return {
	        isClosed: true,
	        shouldSwitchAutoOnNextCycle: false,
	        height: 0,
	        transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
	        hasBeenOpened: false,
	        overflow: 'hidden'
	      };
	    }
	  },
	
	  // Taken from https://github.com/EvandroLG/transitionEnd/
	  // Determines which prefixed event to listen for
	  whichTransitionEnd: function whichTransitionEnd(element) {
	    var transitions = {
	      'WebkitTransition': 'webkitTransitionEnd',
	      'MozTransition': 'transitionend',
	      'OTransition': 'oTransitionEnd otransitionend',
	      'transition': 'transitionend'
	    };
	
	    for (var t in transitions) {
	      if (element.style[t] !== undefined) {
	        return transitions[t];
	      }
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    //Set up event listener to listen to transitionend so we can switch the height from fixed pixel to auto for much responsiveness;
	    //TODO:  Once Synthetic transitionend events have been exposed in the next release of React move this funciton to a function handed to the onTransitionEnd prop
	
	    this.refs.outer.addEventListener(this.whichTransitionEnd(this.refs.outer), function (event) {
	      if (_this.state.isClosed === false) {
	        _this.setState({
	          shouldSwitchAutoOnNextCycle: true
	        });
	      }
	    });
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	
	    if (this.state.shouldSwitchAutoOnNextCycle === true && this.state.isClosed === false) {
	      //Set the height to auto to make compoenent re-render with the height set to auto.
	      //This way the dropdown will be responsive and also change height if there is another dropdown within it.
	      this.makeResponsive();
	    }
	
	    if (this.state.shouldSwitchAutoOnNextCycle === true && this.state.isClosed === true) {
	      this.prepareToOpen();
	    }
	
	    //If there has been a change in the open prop (controlled by accordion)
	    if (prevProps.open != this.props.open) {
	      if (this.props.open === true) {
	        this.openCollapsible();
	      } else {
	        this.closeCollapsible();
	      }
	    }
	  },
	
	  handleTriggerClick: function handleTriggerClick(event) {
	
	    event.preventDefault();
	
	    if (this.props.triggerDisabled) {
	      return;
	    }
	
	    if (this.props.handleTriggerClick) {
	      this.props.handleTriggerClick(this.props.accordionPosition);
	    } else {
	
	      if (this.state.isClosed === true) {
	        this.openCollapsible();
	      } else {
	        this.closeCollapsible();
	      }
	    }
	  },
	
	  closeCollapsible: function closeCollapsible() {
	    this.setState({
	      isClosed: true,
	      shouldSwitchAutoOnNextCycle: true,
	      height: this.refs.inner.offsetHeight,
	      overflow: 'hidden'
	    }, this.props.onClose);
	  },
	
	  openCollapsible: function openCollapsible() {
	    this.setState({
	      height: this.refs.inner.offsetHeight,
	      transition: 'height ' + this.props.transitionTime + 'ms ' + this.props.easing,
	      isClosed: false,
	      hasBeenOpened: true
	    }, this.props.onOpen);
	  },
	
	  makeResponsive: function makeResponsive() {
	    this.setState({
	      height: 'auto',
	      transition: 'none',
	      shouldSwitchAutoOnNextCycle: false,
	      overflow: this.props.overflowWhenOpen
	    });
	  },
	
	  prepareToOpen: function prepareToOpen() {
	    var _this2 = this;
	
	    //The height has been changes back to fixed pixel, we set a small timeout to force the CSS transition back to 0 on the next tick.
	    window.setTimeout(function () {
	      _this2.setState({
	        height: 0,
	        shouldSwitchAutoOnNextCycle: false,
	        transition: 'height ' + _this2.props.transitionTime + 'ms ' + _this2.props.easing
	      });
	    }, 50);
	  },
	
	  renderNonClickableTriggerElement: function renderNonClickableTriggerElement() {
	    if (this.props.triggerSibling) {
	      return _react2.default.createElement(
	        'span',
	        { className: this.props.classParentString + "__trigger-sibling" },
	        this.props.triggerSibling
	      );
	    }
	
	    return null;
	  },
	
	  render: function render() {
	
	    var dropdownStyle = {
	      height: this.state.height,
	      WebkitTransition: this.state.transition,
	      msTransition: this.state.transition,
	      transition: this.state.transition,
	      overflow: this.state.overflow
	    };
	
	    var openClass = this.state.isClosed ? 'is-closed' : 'is-open';
	    var disabledClass = this.props.triggerDisabled ? 'is-disabled' : '';
	
	    //If user wants different text when tray is open
	    var trigger = this.state.isClosed === false && this.props.triggerWhenOpen !== undefined ? this.props.triggerWhenOpen : this.props.trigger;
	
	    // Don't render children until the first opening of the Collapsible if lazy rendering is enabled
	    var children = this.props.children;
	    if (this.props.lazyRender) if (!this.state.hasBeenOpened) children = null;
	
	    var triggerClassName = this.props.classParentString + "__trigger" + ' ' + openClass + ' ' + disabledClass;
	
	    if (this.state.isClosed) {
	      triggerClassName = triggerClassName + ' ' + this.props.triggerClassName;
	    } else {
	      triggerClassName = triggerClassName + ' ' + this.props.triggerOpenedClassName;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.classParentString + ' ' + (this.state.isClosed ? this.props.className : this.props.openedClassName) },
	      _react2.default.createElement(
	        'span',
	        { className: triggerClassName.trim(), onClick: this.handleTriggerClick },
	        trigger
	      ),
	      this.renderNonClickableTriggerElement(),
	      _react2.default.createElement(
	        'div',
	        { className: this.props.classParentString + "__contentOuter" + ' ' + this.props.contentOuterClassName, ref: 'outer', style: dropdownStyle },
	        _react2.default.createElement(
	          'div',
	          { className: this.props.classParentString + "__contentInner" + ' ' + this.props.contentInnerClassName, ref: 'inner' },
	          children
	        )
	      )
	    );
	  }
	});
	
	exports.default = Collapsible;
	


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(1));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ },
/* 743 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(119);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(146);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(68);
	
	var quoteAttributeValueForBrowser = __webpack_require__(2304);
	var warning = __webpack_require__(17);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 746 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var LinkedValueUtils = __webpack_require__(348);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(83);
	
	var warning = __webpack_require__(17);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 748 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 749 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(2264);
	
	var containsNode = __webpack_require__(1597);
	var focusNode = __webpack_require__(511);
	var getActiveElement = __webpack_require__(512);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var DOMLazyTree = __webpack_require__(145);
	var DOMProperty = __webpack_require__(146);
	var React = __webpack_require__(151);
	var ReactBrowserEventEmitter = __webpack_require__(234);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMContainerInfo = __webpack_require__(2258);
	var ReactDOMFeatureFlags = __webpack_require__(2260);
	var ReactFeatureFlags = __webpack_require__(749);
	var ReactInstanceMap = __webpack_require__(178);
	var ReactInstrumentation = __webpack_require__(68);
	var ReactMarkupChecksum = __webpack_require__(2274);
	var ReactReconciler = __webpack_require__(147);
	var ReactUpdateQueue = __webpack_require__(351);
	var ReactUpdates = __webpack_require__(83);
	
	var emptyObject = __webpack_require__(137);
	var instantiateReactComponent = __webpack_require__(760);
	var invariant = __webpack_require__(14);
	var setInnerHTML = __webpack_require__(238);
	var shouldUpdateReactComponent = __webpack_require__(357);
	var warning = __webpack_require__(17);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var React = __webpack_require__(151);
	
	var invariant = __webpack_require__(14);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 754 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 756 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(753);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22),
	    _assign = __webpack_require__(16);
	
	var ReactCompositeComponent = __webpack_require__(2255);
	var ReactEmptyComponent = __webpack_require__(748);
	var ReactHostComponent = __webpack_require__(750);
	
	var getNextDebugID = __webpack_require__(2479);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 761 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	var escapeTextContentForBrowser = __webpack_require__(237);
	var setInnerHTML = __webpack_require__(238);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var ReactCurrentOwner = __webpack_require__(93);
	var REACT_ELEMENT_TYPE = __webpack_require__(2270);
	
	var getIteratorFn = __webpack_require__(2301);
	var invariant = __webpack_require__(14);
	var KeyEscapeUtils = __webpack_require__(347);
	var warning = __webpack_require__(17);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 764 */
/***/ function(module, exports) {

	function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 765 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ns$jss$ns$sheetOptio;
	
	var _propTypes = __webpack_require__(2);
	
	var _jss = __webpack_require__(239);
	
	var _jss2 = _interopRequireDefault(_jss);
	
	var _ns = __webpack_require__(361);
	
	var ns = _interopRequireWildcard(_ns);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, (0, _propTypes.instanceOf)(_jss2['default'].constructor)), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, (0, _propTypes.instanceOf)(_jss.SheetsRegistry)), _defineProperty(_ns$jss$ns$sheetOptio, ns.providerId, _propTypes.number), _ns$jss$ns$sheetOptio);

/***/ },
/* 767 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 768 */
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(392));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(868));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(267));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(268));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(2343));
	
	var _invariant = _interopRequireDefault(__webpack_require__(78));
	
	var _react = __webpack_require__(1);
	
	var _reactIs = __webpack_require__(360);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(2340));
	
	var _PropTypes = __webpack_require__(771);
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(772));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(2341));
	
	var _warning = _interopRequireDefault(__webpack_require__(362));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(365);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 775 */
148,
/* 776 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 777 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  location: null
	
	  /**
	   * This reducer will update the state with the most recent location history
	   * has transitioned to. This may not be in sync with the router, particularly
	   * if you have asynchronously-loaded routes, so reading from and relying on
	   * this state is discouraged.
	   */
	};function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { location: payload });
	  }
	
	  return state;
	}

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(148);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(114);
	
	var _Router = __webpack_require__(242);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(148);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(114);
	
	var _generatePath = __webpack_require__(366);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(148);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(114);
	
	var _Router = __webpack_require__(242);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(148);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(243);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(2359)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(1610);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(365);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppBar = exports.appBarFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _IconButton = __webpack_require__(248);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(IconButton) {
	  var AppBar = function (_React$Component) {
	    _inherits(AppBar, _React$Component);
	
	    function AppBar() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AppBar);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppBar.__proto__ || Object.getPrototypeOf(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hidden: false, height: 0 }, _this.handleScroll = function () {
	        var scrollDiff = _this.curScroll - window.scrollY;
	        var hidden = scrollDiff < 0 && window.scrollY !== undefined && window.scrollY > _this.state.height;
	        _this.setState({ hidden: hidden });
	        _this.curScroll = window.scrollY;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AppBar, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.scrollHide) {
	          this.initializeScroll();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!this.props.scrollHide && nextProps.scrollHide) {
	          this.initializeScroll();
	        }
	
	        if (this.props.scrollHide && !nextProps.scrollHide) {
	          this.endScroll();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.scrollHide) {
	          this.endScroll();
	        }
	      }
	    }, {
	      key: 'initializeScroll',
	      value: function initializeScroll() {
	        window.addEventListener('scroll', this.handleScroll);
	
	        var _rootNode$getBounding = this.rootNode.getBoundingClientRect(),
	            height = _rootNode$getBounding.height;
	
	        this.curScroll = window.scrollY;
	        this.setState({ height: height });
	      }
	    }, {
	      key: 'endScroll',
	      value: function endScroll() {
	        window.removeEventListener('scroll', this.handleScroll);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _cn,
	            _this2 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            leftIcon = _props.leftIcon,
	            onLeftIconClick = _props.onLeftIconClick,
	            onRightIconClick = _props.onRightIconClick,
	            rightIcon = _props.rightIcon,
	            theme = _props.theme,
	            title = _props.title;
	
	
	        var className = (0, _classnames2.default)(theme.appBar, (_cn = {}, _defineProperty(_cn, theme.fixed, this.props.fixed), _defineProperty(_cn, theme.flat, this.props.flat), _defineProperty(_cn, theme.scrollHide, this.state.hidden), _cn), this.props.className);
	
	        var renderedTitle = typeof title === 'string' ? _react2.default.createElement(
	          'h1',
	          { className: (0, _classnames2.default)(theme.title) },
	          title
	        ) : title;
	
	        var renderedLeftIcon = leftIcon && _react2.default.createElement(IconButton, {
	          inverse: true,
	          className: (0, _classnames2.default)(theme.leftIcon),
	          onClick: onLeftIconClick,
	          icon: leftIcon
	        });
	
	        var renderedRightIcon = rightIcon && _react2.default.createElement(IconButton, {
	          inverse: true,
	          className: (0, _classnames2.default)(theme.rightIcon),
	          onClick: onRightIconClick,
	          icon: rightIcon
	        });
	
	        return _react2.default.createElement(
	          'header',
	          {
	            className: className,
	            'data-react-toolbox': 'app-bar',
	            ref: function ref(node) {
	              _this2.rootNode = node;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: theme.inner },
	            renderedLeftIcon,
	            renderedTitle,
	            children,
	            renderedRightIcon
	          )
	        );
	      }
	    }]);
	
	    return AppBar;
	  }(_react2.default.Component);
	
	  AppBar.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    fixed: _propTypes2.default.bool,
	    flat: _propTypes2.default.bool,
	    leftIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    onLeftIconClick: _propTypes2.default.func,
	    onRightIconClick: _propTypes2.default.func,
	    rightIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    scrollHide: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      appBar: _propTypes2.default.string,
	      inner: _propTypes2.default.string,
	      fixed: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      leftIcon: _propTypes2.default.string,
	      rightIcon: _propTypes2.default.string,
	      scrollHide: _propTypes2.default.string,
	      title: _propTypes2.default.string
	    }),
	    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
	  };
	  AppBar.defaultProps = {
	    className: '',
	    fixed: false,
	    flat: false,
	    scrollHide: false
	  };
	
	
	  return AppBar;
	};
	
	var AppBar = factory(_IconButton2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.APP_BAR)(AppBar);
	exports.appBarFactory = factory;
	exports.AppBar = AppBar;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppBar = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _AppBar = __webpack_require__(787);
	
	var _button = __webpack_require__(31);
	
	var _theme = __webpack_require__(1430);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppBar = (0, _AppBar.appBarFactory)(_button.IconButton);
	var ThemedAppBar = (0, _reactCssThemr.themr)(_identifiers.APP_BAR, _theme2.default)(AppBar);
	
	exports.default = ThemedAppBar;
	exports.AppBar = ThemedAppBar;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactStyleProptype = __webpack_require__(244);
	
	var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var factory = function factory(ripple) {
	  var Check = function Check(_ref) {
	    var checked = _ref.checked,
	        children = _ref.children,
	        onMouseDown = _ref.onMouseDown,
	        theme = _ref.theme,
	        style = _ref.style;
	    return _react2.default.createElement(
	      'div',
	      {
	        'data-react-toolbox': 'check',
	        className: (0, _classnames3.default)(theme.check, _defineProperty({}, theme.checked, checked)),
	        onMouseDown: onMouseDown,
	        style: style
	      },
	      children
	    );
	  };
	
	  Check.propTypes = {
	    checked: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    onMouseDown: _propTypes2.default.func,
	    style: _reactStyleProptype2.default,
	    theme: _propTypes2.default.shape({
	      check: _propTypes2.default.string,
	      checked: _propTypes2.default.string
	    })
	  };
	
	  return ripple(Check);
	};
	
	exports.default = factory;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chip = exports.chipFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Avatar = __webpack_require__(245);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var factory = function factory(Avatar) {
	  var Chip = function Chip(_ref) {
	    var _classnames;
	
	    var children = _ref.children,
	        className = _ref.className,
	        deletable = _ref.deletable,
	        onDeleteClick = _ref.onDeleteClick,
	        theme = _ref.theme,
	        other = _objectWithoutProperties(_ref, ['children', 'className', 'deletable', 'onDeleteClick', 'theme']);
	
	    var hasAvatar = false;
	    if (_react2.default.Children.count(children)) {
	      var flatChildren = _react2.default.Children.toArray(children);
	      var firstChild = flatChildren[0];
	      hasAvatar = firstChild && firstChild.type && firstChild.type === Avatar;
	    }
	
	    var classes = (0, _classnames3.default)(theme.chip, (_classnames = {}, _defineProperty(_classnames, theme.deletable, !!deletable), _defineProperty(_classnames, theme.avatar, !!hasAvatar), _classnames), className);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ 'data-react-toolbox': 'chip', className: classes }, other),
	      typeof children === 'string' ? _react2.default.createElement(
	        'span',
	        null,
	        children
	      ) : children,
	      deletable ? _react2.default.createElement(
	        'span',
	        { className: theme.delete, onClick: onDeleteClick },
	        _react2.default.createElement(
	          'svg',
	          { viewBox: '0 0 40 40', className: theme.deleteIcon },
	          _react2.default.createElement('path', { className: theme.deleteX, d: 'M 12,12 L 28,28 M 28,12 L 12,28' })
	        )
	      ) : null
	    );
	  };
	
	  Chip.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    deletable: _propTypes2.default.bool,
	    onDeleteClick: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      avatar: _propTypes2.default.string,
	      chip: _propTypes2.default.string,
	      deletable: _propTypes2.default.string,
	      delete: _propTypes2.default.string,
	      deleteIcon: _propTypes2.default.string,
	      deleteX: _propTypes2.default.string
	    })
	  };
	
	  Chip.defaultProps = {
	    className: '',
	    deletable: false
	  };
	
	  return Chip;
	};
	
	var Chip = factory(_Avatar2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.CHIP)(Chip);
	exports.chipFactory = factory;
	exports.Chip = Chip;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chip = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Chip = __webpack_require__(790);
	
	var _avatar = __webpack_require__(246);
	
	var _theme = __webpack_require__(1436);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chip = (0, _Chip.chipFactory)(_avatar.Avatar);
	var ThemedChip = (0, _reactCssThemr.themr)(_identifiers.CHIP, _theme2.default)(Chip);
	
	exports.default = ThemedChip;
	exports.Chip = ThemedChip;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(846);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransition = __webpack_require__(845);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _utils = __webpack_require__(60);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _CalendarMonth = __webpack_require__(2382);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIRECTION_STEPS = { left: -1, right: 1 };
	
	var factory = function factory(IconButton) {
	  var Calendar = function (_Component) {
	    _inherits(Calendar, _Component);
	
	    function Calendar() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Calendar);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        viewDate: _this.props.selectedDate
	      }, _this.handleDayClick = function (day) {
	        _this.props.onChange(_time2.default.setDay(_this.state.viewDate, day), true);
	      }, _this.handleYearClick = function (event) {
	        var year = parseInt(event.currentTarget.id, 10);
	        var viewDate = _time2.default.setYear(_this.props.selectedDate, year);
	        _this.setState({ viewDate: viewDate });
	        _this.props.onChange(viewDate, false);
	      }, _this.handleKeys = function (e) {
	        var selectedDate = _this.props.selectedDate;
	
	
	        if (e.which === 37 || e.which === 38 || e.which === 39 || e.which === 40 || e.which === 13) {
	          e.preventDefault();
	        }
	
	        switch (e.which) {
	          case 13:
	            _this.props.handleSelect();break; // enter
	          case 37:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -1));break; // left
	          case 38:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -7));break; // up
	          case 39:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 1));break; // right
	          case 40:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 7));break; // down
	          default:
	            break;
	        }
	      }, _this.handleDayArrowKey = function (date) {
	        _this.setState({ viewDate: date });
	        _this.props.onChange(date, false);
	      }, _this.changeViewMonth = function (event) {
	        var direction = event.currentTarget.id;
	        _this.setState({
	          direction: direction,
	          viewDate: _time2.default.addMonths(_this.state.viewDate, DIRECTION_STEPS[direction])
	        });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Calendar, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        document.body.addEventListener('keydown', this.handleKeys);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        if (this.activeYearNode) {
	          this.scrollToActive();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        document.body.removeEventListener('keydown', this.handleKeys);
	      }
	    }, {
	      key: 'scrollToActive',
	      value: function scrollToActive() {
	        var offset = this.yearsNode.offsetHeight / 2 + this.activeYearNode.offsetHeight / 2;
	        this.yearsNode.scrollTop = this.activeYearNode.offsetTop - offset;
	      }
	    }, {
	      key: 'renderYears',
	      value: function renderYears() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          'ul',
	          {
	            'data-react-toolbox': 'years',
	            className: this.props.theme.years,
	            ref: function ref(node) {
	              _this2.yearsNode = node;
	            }
	          },
	          (0, _utils.range)(1900, 2100).map(function (year) {
	            return _react2.default.createElement(
	              'li',
	              {
	                className: year === _this2.state.viewDate.getFullYear() ? _this2.props.theme.active : '',
	                id: year,
	                key: year,
	                onClick: _this2.handleYearClick,
	                ref: function ref(node) {
	                  if (year === _this2.state.viewDate.getFullYear()) {
	                    _this2.activeYearNode = node;
	                  }
	                }
	              },
	              year
	            );
	          })
	        );
	      }
	    }, {
	      key: 'renderMonths',
	      value: function renderMonths() {
	        var theme = this.props.theme;
	
	        var animation = this.state.direction === 'left' ? 'slideLeft' : 'slideRight';
	        var animationModule = (0, _utils.getAnimationModule)(animation, theme);
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'calendar' },
	          _react2.default.createElement(IconButton, { id: 'left', className: theme.prev, icon: 'chevron_left', onClick: this.changeViewMonth }),
	          _react2.default.createElement(IconButton, { id: 'right', className: theme.next, icon: 'chevron_right', onClick: this.changeViewMonth }),
	          _react2.default.createElement(
	            _TransitionGroup2.default,
	            null,
	            _react2.default.createElement(
	              _CSSTransition2.default,
	              { classNames: animationModule, timeout: 350 },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                enabledDates: this.props.enabledDates,
	                disabledDates: this.props.disabledDates,
	                key: this.state.viewDate.getMonth(),
	                locale: this.props.locale,
	                maxDate: this.props.maxDate,
	                minDate: this.props.minDate,
	                onDayClick: this.handleDayClick,
	                selectedDate: this.props.selectedDate,
	                sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek,
	                theme: this.props.theme,
	                viewDate: this.state.viewDate
	              })
	            )
	          )
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.theme.calendar },
	          this.props.display === 'months' ? this.renderMonths() : this.renderYears()
	        );
	      }
	    }]);
	
	    return Calendar;
	  }(_react.Component);
	
	  Calendar.propTypes = {
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    display: _propTypes2.default.oneOf(['months', 'years']),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    handleSelect: _propTypes2.default.func,
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    onChange: _propTypes2.default.func,
	    selectedDate: _propTypes2.default.instanceOf(Date),
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      calendar: _propTypes2.default.string,
	      next: _propTypes2.default.string,
	      prev: _propTypes2.default.string,
	      years: _propTypes2.default.string
	    })
	  };
	  Calendar.defaultProps = {
	    display: 'months',
	    selectedDate: new Date()
	  };
	
	
	  return Calendar;
	};
	
	exports.default = factory;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Dialog, Calendar) {
	  var CalendarDialog = function (_Component) {
	    _inherits(CalendarDialog, _Component);
	
	    function CalendarDialog() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, CalendarDialog);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalendarDialog.__proto__ || Object.getPrototypeOf(CalendarDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        display: 'months',
	        date: _this.props.value
	      }, _this.handleNewDate = function (value, dayClick) {
	        var state = { display: 'months', date: value };
	        if (_time2.default.dateOutOfRange(value, _this.props.minDate, _this.props.maxDate)) {
	          if (_this.props.maxDate && _this.props.minDate) {
	            state.date = _time2.default.closestDate(value, _this.props.maxDate, _this.props.minDate);
	          } else {
	            state.date = _this.props.maxDate || _this.props.minDate;
	          }
	        }
	        _this.setState(state);
	        if (dayClick && _this.props.autoOk && _this.props.onSelect) {
	          _this.props.onSelect(value);
	        }
	      }, _this.handleSelect = function (event) {
	        if (_this.props.onSelect) _this.props.onSelect(_this.state.date, event);
	      }, _this.handleSwitchDisplay = function (event) {
	        _this.setState({ display: event.target.id });
	      }, _this.updateStateDate = function (date) {
	        if (Object.prototype.toString.call(date) === '[object Date]') {
	          _this.handleNewDate(date, false);
	        }
	      }, _this.actions = [{
	        label: _this.props.cancelLabel,
	        className: _this.props.theme.button,
	        onClick: _this.props.onDismiss
	      }, {
	        label: _this.props.okLabel,
	        className: _this.props.theme.button,
	        name: _this.props.name,
	        onClick: _this.handleSelect
	      }], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CalendarDialog, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.updateStateDate(this.props.value);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.updateStateDate(nextProps.value);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var theme = this.props.theme;
	
	        var display = this.state.display + 'Display';
	        var className = (0, _classnames2.default)(theme.dialog, this.props.className);
	        var headerClassName = (0, _classnames2.default)(theme.header, theme[display]);
	        var shortDayOfWeek = _time2.default.getShortDayOfWeek(this.state.date.getDay(), this.props.locale);
	        var shortMonth = _time2.default.getShortMonth(this.state.date, this.props.locale);
	        var date = this.state.date.getDate();
	
	        return _react2.default.createElement(
	          Dialog,
	          {
	            actions: this.actions,
	            active: this.props.active,
	            className: className,
	            onEscKeyDown: this.props.onEscKeyDown,
	            onOverlayClick: this.props.onOverlayClick,
	            type: 'custom'
	          },
	          _react2.default.createElement(
	            'header',
	            { className: headerClassName },
	            _react2.default.createElement(
	              'span',
	              { id: 'years', className: theme.year, onClick: this.handleSwitchDisplay },
	              this.state.date.getFullYear()
	            ),
	            _react2.default.createElement(
	              'h3',
	              { id: 'months', className: theme.date, onClick: this.handleSwitchDisplay },
	              shortDayOfWeek,
	              ', ',
	              shortMonth,
	              ' ',
	              date
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: theme.calendarWrapper },
	            _react2.default.createElement(Calendar, {
	              disabledDates: this.props.disabledDates,
	              display: this.state.display,
	              enabledDates: this.props.enabledDates,
	              handleSelect: this.handleSelect,
	              maxDate: this.props.maxDate,
	              minDate: this.props.minDate,
	              onChange: this.handleNewDate,
	              selectedDate: this.state.date,
	              theme: this.props.theme,
	              locale: this.props.locale,
	              sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek
	            })
	          )
	        );
	      }
	    }]);
	
	    return CalendarDialog;
	  }(_react.Component);
	
	  CalendarDialog.propTypes = {
	    active: _propTypes2.default.bool,
	    autoOk: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      button: _propTypes2.default.string,
	      calendarWrapper: _propTypes2.default.string,
	      date: _propTypes2.default.string,
	      dialog: _propTypes2.default.string,
	      header: _propTypes2.default.string,
	      monthsDisplay: _propTypes2.default.string,
	      year: _propTypes2.default.string,
	      yearsDisplay: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.instanceOf(Date)
	  };
	  CalendarDialog.defaultProps = {
	    active: false,
	    cancelLabel: 'Cancel',
	    className: '',
	    okLabel: 'Ok',
	    value: new Date()
	  };
	
	
	  return CalendarDialog;
	};
	
	exports.default = factory;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontIcon = undefined;
	
	var _FontIcon = __webpack_require__(45);
	
	exports.default = _FontIcon.FontIcon;
	exports.FontIcon = _FontIcon.FontIcon;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavDrawer = exports.navDrawerFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _Drawer = __webpack_require__(372);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var factory = function factory(Drawer) {
	  var NavDrawer = function NavDrawer(_ref) {
	    var _classnames;
	
	    var active = _ref.active,
	        className = _ref.className,
	        clipped = _ref.clipped,
	        permanentAt = _ref.permanentAt,
	        pinned = _ref.pinned,
	        theme = _ref.theme,
	        rest = _objectWithoutProperties(_ref, ['active', 'className', 'clipped', 'permanentAt', 'pinned', 'theme']);
	
	    var _className = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, theme.pinned, pinned), _defineProperty(_classnames, theme.clipped, clipped), _classnames), className);
	
	    return _react2.default.createElement(Drawer, _extends({}, rest, {
	      active: active || pinned,
	      className: _className,
	      insideTree: true,
	      theme: theme,
	      themeNamespace: 'navDrawer',
	      withOverlay: !pinned
	    }));
	  };
	
	  NavDrawer.propTypes = {
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    clipped: _propTypes2.default.bool,
	    permanentAt: _propTypes2.default.oneOf(['sm', 'smTablet', 'md', 'lg', 'lgTablet', 'xl', 'xxl', 'xxxl']),
	    pinned: _propTypes2.default.bool,
	    right: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      clipped: _propTypes2.default.string,
	      pinned: _propTypes2.default.string
	    })
	  };
	
	  NavDrawer.defaultProps = {
	    className: '',
	    pinned: false
	  };
	
	  return NavDrawer;
	};
	
	var NavDrawer = factory(_Drawer2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(NavDrawer);
	exports.navDrawerFactory = factory;
	exports.NavDrawer = NavDrawer;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sidebar = exports.sidebarFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _Drawer = __webpack_require__(372);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var factory = function factory(Drawer) {
	  var Sidebar = function Sidebar(_ref) {
	    var _classnames;
	
	    var active = _ref.active,
	        className = _ref.className,
	        clipped = _ref.clipped,
	        permanentAt = _ref.permanentAt,
	        pinned = _ref.pinned,
	        theme = _ref.theme,
	        rest = _objectWithoutProperties(_ref, ['active', 'className', 'clipped', 'permanentAt', 'pinned', 'theme']);
	
	    var _className = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, theme.pinned, pinned), _defineProperty(_classnames, theme.clipped, clipped), _classnames), className);
	
	    return _react2.default.createElement(Drawer, _extends({}, rest, {
	      active: active || pinned,
	      className: _className,
	      insideTree: true,
	      theme: theme,
	      themeNamespace: 'sidebar',
	      type: 'right',
	      withOverlay: !pinned
	    }));
	  };
	
	  Sidebar.propTypes = {
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    clipped: _propTypes2.default.bool,
	    permanentAt: _propTypes2.default.oneOf(['sm', 'smTablet', 'md', 'lg', 'lgTablet', 'xl', 'xxl', 'xxxl']),
	    pinned: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      clipped: _propTypes2.default.string,
	      pinned: _propTypes2.default.string
	    }),
	    width: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 25, 33, 50, 66, 75, 100])
	  };
	
	  Sidebar.defaultProps = {
	    className: '',
	    pinned: false,
	    right: false
	  };
	
	  return Sidebar;
	};
	
	var Sidebar = factory(_Drawer2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(Sidebar);
	exports.sidebarFactory = factory;
	exports.Sidebar = Sidebar;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Link = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = function Link(_ref) {
	  var active = _ref.active,
	      children = _ref.children,
	      className = _ref.className,
	      count = _ref.count,
	      icon = _ref.icon,
	      label = _ref.label,
	      theme = _ref.theme,
	      others = _objectWithoutProperties(_ref, ['active', 'children', 'className', 'count', 'icon', 'label', 'theme']);
	
	  var _className = (0, _classnames3.default)(theme.link, _defineProperty({}, theme.active, active), className);
	
	  return _react2.default.createElement(
	    'a',
	    _extends({ 'data-react-toolbox': 'link', className: _className }, others),
	    icon ? _react2.default.createElement(_FontIcon.FontIcon, { className: theme.icon, value: icon }) : null,
	    label ? _react2.default.createElement(
	      'abbr',
	      null,
	      label
	    ) : null,
	    count && parseInt(count, 10) !== 0 ? _react2.default.createElement(
	      'small',
	      null,
	      count
	    ) : null,
	    children
	  );
	};
	
	Link.propTypes = {
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  count: _propTypes2.default.number,
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  label: _propTypes2.default.string,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    link: _propTypes2.default.string
	  })
	};
	
	Link.defaultProps = {
	  active: false,
	  className: ''
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LINK)(Link);
	exports.Link = Link;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Link = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Link = __webpack_require__(797);
	
	var _theme = __webpack_require__(1443);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedLink = (0, _reactCssThemr.themr)(_identifiers.LINK, _theme2.default)(_Link.Link);
	
	exports.default = ThemedLink;
	exports.Link = ThemedLink;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItem = exports.listItemFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ListItemContent = __webpack_require__(252);
	
	var _ListItemContent2 = _interopRequireDefault(_ListItemContent);
	
	var _ListItemLayout = __webpack_require__(802);
	
	var _ListItemLayout2 = _interopRequireDefault(_ListItemLayout);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, ListItemLayout, ListItemContent) {
	  var ListItem = function (_Component) {
	    _inherits(ListItem, _Component);
	
	    function ListItem() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ListItem);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	        if (_this.props.onClick && !_this.props.disabled) {
	          _this.props.onClick(event);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ListItem, [{
	      key: 'groupChildren',
	      value: function groupChildren() {
	        var children = {
	          leftActions: [],
	          rightActions: [],
	          ignored: []
	        };
	
	        _react2.default.Children.forEach(this.props.children, function (child, i) {
	          if (!_react2.default.isValidElement(child)) {
	            return undefined;
	          }
	
	          var _child$props = child.props,
	              listItemIgnore = _child$props.listItemIgnore,
	              rest = _objectWithoutProperties(_child$props, ['listItemIgnore']);
	
	          var strippedChild = _extends({}, child, { props: rest });
	
	          if (listItemIgnore) {
	            children.ignored.push(strippedChild);
	            return undefined;
	          }
	          if (child.type === ListItemContent) {
	            children.itemContent = strippedChild;
	            return undefined;
	          }
	          var bucket = children.itemContent ? 'rightActions' : 'leftActions';
	          children[bucket].push(_extends({}, strippedChild, { key: i }));
	          return undefined;
	        });
	
	        return children;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            hasRipple = _props.ripple,
	            onClick = _props.onClick,
	            onMouseDown = _props.onMouseDown,
	            onTouchStart = _props.onTouchStart,
	            theme = _props.theme,
	            to = _props.to,
	            other = _objectWithoutProperties(_props, ['className', 'ripple', 'onClick', 'onMouseDown', 'onTouchStart', 'theme', 'to']);
	
	        var children = this.groupChildren();
	        var content = _react2.default.createElement(ListItemLayout, _extends({ theme: theme }, children, other));
	        return _react2.default.createElement(
	          'li',
	          { className: theme.listItem + ' ' + className, onClick: this.handleClick, onMouseDown: onMouseDown, onTouchStart: onTouchStart },
	          to ? _react2.default.createElement(
	            'a',
	            { href: this.props.to },
	            content
	          ) : content,
	          children.ignored
	        );
	      }
	    }]);
	
	    return ListItem;
	  }(_react.Component);
	
	  ListItem.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    hasRipple: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func,
	    onMouseDown: _propTypes2.default.func,
	    onTouchStart: _propTypes2.default.func,
	    ripple: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      listItem: _propTypes2.default.string
	    }),
	    to: _propTypes2.default.string
	  };
	  ListItem.defaultProps = {
	    className: '',
	    disabled: false,
	    ripple: false
	  };
	
	
	  return ripple(ListItem);
	};
	
	var ripple = (0, _Ripple2.default)({ centered: false, listItemIgnore: true });
	var ListItem = factory(ripple, _ListItemLayout2.default, _ListItemContent2.default);
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItem);
	exports.listItemFactory = factory;
	exports.ListItem = ListItem;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemAction = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItemAction = function ListItemAction(_ref) {
	  var action = _ref.action,
	      theme = _ref.theme;
	  var _action$props = action.props,
	      onClick = _action$props.onClick,
	      onMouseDown = _action$props.onMouseDown;
	
	  var stopRipple = onClick && !onMouseDown;
	  var stop = function stop(e) {
	    return e.stopPropagation();
	  };
	  return _react2.default.createElement(
	    'span',
	    { className: theme.itemAction, onMouseDown: stopRipple && stop, onClick: onClick && stop },
	    action
	  );
	};
	
	ListItemAction.propTypes = {
	  action: _propTypes2.default.node,
	  theme: _propTypes2.default.shape({
	    itemAction: _propTypes2.default.string
	  })
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemAction);
	exports.ListItemAction = ListItemAction;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemActions = exports.listItemActionsFactory = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ListItemAction = __webpack_require__(800);
	
	var _ListItemAction2 = _interopRequireDefault(_ListItemAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var factory = function factory(ListItemAction) {
	  var ListItemActions = function ListItemActions(_ref) {
	    var type = _ref.type,
	        children = _ref.children,
	        theme = _ref.theme;
	
	    var validChildren = _react2.default.Children.toArray(children).filter(function (c) {
	      return _react2.default.isValidElement(c);
	    });
	
	    return _react2.default.createElement(
	      'span',
	      { className: theme[type] },
	      validChildren.map(function (action, i) {
	        return _react2.default.createElement(ListItemAction, { key: i, theme: theme, action: action }) // eslint-disable-line
	        ;
	      })
	    );
	  };
	
	  ListItemActions.propTypes = {
	    children: _propTypes2.default.node,
	    theme: _propTypes2.default.shape({
	      left: _propTypes2.default.string,
	      right: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.oneOf(['left', 'right'])
	  };
	
	  return ListItemActions;
	};
	
	var ListItemActions = factory(_ListItemAction2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemActions);
	exports.listItemActionsFactory = factory;
	exports.ListItemActions = ListItemActions;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemLayout = exports.listItemLayoutFactory = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _Avatar = __webpack_require__(245);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _ListItemContent = __webpack_require__(252);
	
	var _ListItemContent2 = _interopRequireDefault(_ListItemContent);
	
	var _ListItemActions = __webpack_require__(801);
	
	var _ListItemActions2 = _interopRequireDefault(_ListItemActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var factory = function factory(Avatar, ListItemContent, ListItemActions) {
	  var ListItemLayout = function ListItemLayout(props) {
	    var _classnames;
	
	    var className = (0, _classnames3.default)(props.theme.item, (_classnames = {}, _defineProperty(_classnames, props.theme.disabled, props.disabled), _defineProperty(_classnames, props.theme.selectable, props.selectable), _classnames), props.className);
	
	    var leftActions = [props.leftIcon && _react2.default.createElement(_FontIcon.FontIcon, { value: props.leftIcon, key: 'leftIcon' }), props.avatar && _react2.default.createElement(Avatar, { image: props.avatar, key: 'avatar' })].concat(_toConsumableArray(props.leftActions));
	    var rightActions = [props.rightIcon && _react2.default.createElement(_FontIcon.FontIcon, { value: props.rightIcon, key: 'rightIcon' })].concat(_toConsumableArray(props.rightActions));
	    var emptyActions = function emptyActions(item) {
	      return !item[0] && !item[1] && !item[2];
	    };
	    var content = props.itemContent || _react2.default.createElement(ListItemContent, { theme: props.theme, caption: props.caption, legend: props.legend });
	
	    return _react2.default.createElement(
	      'span',
	      { className: className },
	      !emptyActions(leftActions) > 0 && _react2.default.createElement(
	        ListItemActions,
	        { type: 'left', theme: props.theme },
	        leftActions
	      ),
	      content,
	      !emptyActions(rightActions) > 0 && _react2.default.createElement(
	        ListItemActions,
	        { type: 'right', theme: props.theme },
	        rightActions
	      )
	    );
	  };
	
	  ListItemLayout.propTypes = {
	    avatar: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    itemContent: _propTypes2.default.element,
	    leftActions: _propTypes2.default.arrayOf(_propTypes2.default.node),
	    leftIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    legend: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    rightActions: _propTypes2.default.arrayOf(_propTypes2.default.node),
	    rightIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    selectable: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      disabled: _propTypes2.default.string,
	      item: _propTypes2.default.string,
	      selectable: _propTypes2.default.string
	    })
	  };
	
	  ListItemLayout.defaultProps = {
	    disabled: false,
	    selectable: false
	  };
	
	  return ListItemLayout;
	};
	
	var ListItemLayout = factory(_Avatar2.default, _ListItemContent2.default, _ListItemActions2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemLayout);
	exports.listItemLayoutFactory = factory;
	exports.ListItemLayout = ListItemLayout;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListItemText = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ListItemText = function ListItemText(_ref) {
	  var className = _ref.className,
	      primary = _ref.primary,
	      children = _ref.children,
	      theme = _ref.theme,
	      other = _objectWithoutProperties(_ref, ['className', 'primary', 'children', 'theme']);
	
	  var _className = (0, _classnames3.default)(theme.itemText, _defineProperty({}, theme.primary, primary), className);
	  return _react2.default.createElement(
	    'span',
	    _extends({ 'data-react-toolbox': 'list-item-text', className: _className }, other),
	    children
	  );
	};
	
	ListItemText.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  primary: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    itemText: _propTypes2.default.string,
	    primary: _propTypes2.default.string
	  })
	};
	
	ListItemText.defaultProps = {
	  primary: false
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListItemText);
	exports.ListItemText = ListItemText;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Menu = exports.menuFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _utils = __webpack_require__(2417);
	
	var _utils2 = __webpack_require__(60);
	
	var _MenuItem = __webpack_require__(805);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POSITION = {
	  AUTO: 'auto',
	  STATIC: 'static',
	  TOP_LEFT: 'topLeft',
	  TOP_RIGHT: 'topRight',
	  BOTTOM_LEFT: 'bottomLeft',
	  BOTTOM_RIGHT: 'bottomRight'
	};
	
	var factory = function factory(MenuItem) {
	  var Menu = function (_Component) {
	    _inherits(Menu, _Component);
	
	    function Menu() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Menu);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        active: _this.props.active,
	        rippled: false
	      }, _this.handleDocumentClick = function (event) {
	        if (_this.state.active && !_utils.events.targetIsDescendant(event, _reactDom2.default.findDOMNode(_this))) {
	          _this.setState({ active: false, rippled: false });
	        }
	      }, _this.handleSelect = function (item, event) {
	        var _item$props = item.props,
	            value = _item$props.value,
	            onClick = _item$props.onClick;
	
	        if (onClick) event.persist();
	        _this.setState({ active: false, rippled: _this.props.ripple }, function () {
	          if (onClick) onClick(event);
	          if (_this.props.onSelect) _this.props.onSelect(value);
	        });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Menu, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this.positionTimeoutHandle = setTimeout(function () {
	          var _menuNode$getBounding = _this2.menuNode.getBoundingClientRect(),
	              width = _menuNode$getBounding.width,
	              height = _menuNode$getBounding.height;
	
	          var position = _this2.props.position === POSITION.AUTO ? _this2.calculatePosition() : _this2.props.position;
	          _this2.setState({ position: position, width: width, height: height });
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        if (this.props.position !== nextProps.position) {
	          var position = nextProps.position === POSITION.AUTO ? this.calculatePosition() : nextProps.position;
	          this.setState({ position: position });
	        }
	
	        /**
	         * If the menu is going to be activated via props and its not active, verify
	         * the position is appropriated and then show it recalculating position if its
	         * wrong. It should be shown in two consecutive setState.
	         */
	        if (!this.props.active && nextProps.active && !this.state.active) {
	          if (nextProps.position === POSITION.AUTO) {
	            var _position = this.calculatePosition();
	            if (this.state.position !== _position) {
	              this.setState({ position: _position, active: false }, function () {
	                _this3.activateTimeoutHandle = setTimeout(function () {
	                  _this3.show();
	                }, 20);
	              });
	            } else {
	              this.show();
	            }
	          } else {
	            this.show();
	          }
	        }
	
	        /**
	         * If the menu is being deactivated via props and the current state is
	         * active, it should be hid.
	         */
	        if (this.props.active && !nextProps.active && this.state.active) {
	          this.hide();
	        }
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if (!this.state.active && nextState.active) {
	          _utils.events.addEventsToDocument({
	            click: this.handleDocumentClick,
	            touchstart: this.handleDocumentClick
	          });
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        if (prevState.active && !this.state.active) {
	          if (this.props.onHide) this.props.onHide();
	          _utils.events.removeEventsFromDocument({
	            click: this.handleDocumentClick,
	            touchstart: this.handleDocumentClick
	          });
	        } else if (!prevState.active && this.state.active && this.props.onShow) {
	          this.props.onShow();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.state.active) {
	          _utils.events.removeEventsFromDocument({
	            click: this.handleDocumentClick,
	            touchstart: this.handleDocumentClick
	          });
	        }
	        clearTimeout(this.positionTimeoutHandle);
	        clearTimeout(this.activateTimeoutHandle);
	      }
	    }, {
	      key: 'getMenuStyle',
	      value: function getMenuStyle() {
	        var _state = this.state,
	            width = _state.width,
	            height = _state.height,
	            position = _state.position;
	
	        if (position !== POSITION.STATIC) {
	          if (this.state.active) {
	            return { clip: 'rect(0 ' + width + 'px ' + height + 'px 0)' };
	          } else if (position === POSITION.TOP_RIGHT) {
	            return { clip: 'rect(0 ' + width + 'px 0 ' + width + 'px)' };
	          } else if (position === POSITION.BOTTOM_RIGHT) {
	            return { clip: 'rect(' + height + 'px ' + width + 'px ' + height + 'px ' + width + 'px)' };
	          } else if (position === POSITION.BOTTOM_LEFT) {
	            return { clip: 'rect(' + height + 'px 0 ' + height + 'px 0)' };
	          } else if (position === POSITION.TOP_LEFT) {
	            return { clip: 'rect(0 0 0 0)' };
	          }
	        }
	
	        return undefined;
	      }
	    }, {
	      key: 'getRootStyle',
	      value: function getRootStyle() {
	        return this.state.position !== POSITION.STATIC ? { width: this.state.width, height: this.state.height } : undefined;
	      }
	    }, {
	      key: 'calculatePosition',
	      value: function calculatePosition() {
	        var parentNode = _reactDom2.default.findDOMNode(this).parentNode;
	        if (!parentNode) return undefined;
	
	        var _parentNode$getBoundi = parentNode.getBoundingClientRect(),
	            top = _parentNode$getBoundi.top,
	            left = _parentNode$getBoundi.left,
	            height = _parentNode$getBoundi.height,
	            width = _parentNode$getBoundi.width;
	
	        var _getViewport = (0, _utils2.getViewport)(),
	            wh = _getViewport.height,
	            ww = _getViewport.width;
	
	        var toTop = top < wh / 2 - height / 2;
	        var toLeft = left < ww / 2 - width / 2;
	        return '' + (toTop ? 'top' : 'bottom') + (toLeft ? 'Left' : 'Right');
	      }
	    }, {
	      key: 'show',
	      value: function show() {
	        var _menuNode$getBounding2 = this.menuNode.getBoundingClientRect(),
	            width = _menuNode$getBounding2.width,
	            height = _menuNode$getBounding2.height;
	
	        this.setState({ active: true, width: width, height: height });
	      }
	    }, {
	      key: 'hide',
	      value: function hide() {
	        this.setState({ active: false });
	      }
	    }, {
	      key: 'renderItems',
	      value: function renderItems() {
	        var _this4 = this;
	
	        return _react2.default.Children.map(this.props.children, function (item) {
	          if (!item) return item;
	          if (item.type === MenuItem) {
	            return _react2.default.cloneElement(item, {
	              ripple: item.props.ripple || _this4.props.ripple,
	              selected: typeof item.props.value !== 'undefined' && _this4.props.selectable && item.props.value === _this4.props.selected,
	              onClick: _this4.handleSelect.bind(_this4, item)
	            });
	          }
	          return _react2.default.cloneElement(item);
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this5 = this;
	
	        var theme = this.props.theme;
	
	        var outlineStyle = { width: this.state.width, height: this.state.height };
	        var className = (0, _classnames3.default)([theme.menu, theme[this.state.position]], (_classnames = {}, _defineProperty(_classnames, theme.active, this.state.active), _defineProperty(_classnames, theme.rippled, this.state.rippled), _classnames), this.props.className);
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'menu', className: className, style: this.getRootStyle() },
	          this.props.outline ? _react2.default.createElement('div', { className: theme.outline, style: outlineStyle }) : null,
	          _react2.default.createElement(
	            'ul',
	            {
	              ref: function ref(node) {
	                _this5.menuNode = node;
	              },
	              className: theme.menuInner,
	              style: this.getMenuStyle()
	            },
	            this.renderItems()
	          )
	        );
	      }
	    }]);
	
	    return Menu;
	  }(_react.Component);
	
	  Menu.propTypes = {
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    onHide: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    onShow: _propTypes2.default.func,
	    outline: _propTypes2.default.bool,
	    position: _propTypes2.default.oneOf(Object.keys(POSITION).map(function (key) {
	      return POSITION[key];
	    })),
	    ripple: _propTypes2.default.bool,
	    selectable: _propTypes2.default.bool,
	    selected: _propTypes2.default.node,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      bottomLeft: _propTypes2.default.string,
	      bottomRight: _propTypes2.default.string,
	      menu: _propTypes2.default.string,
	      menuInner: _propTypes2.default.string,
	      outline: _propTypes2.default.string,
	      rippled: _propTypes2.default.string,
	      static: _propTypes2.default.string,
	      topLeft: _propTypes2.default.string,
	      topRight: _propTypes2.default.string
	    })
	  };
	  Menu.defaultProps = {
	    active: false,
	    outline: true,
	    position: POSITION.STATIC,
	    ripple: true,
	    selectable: true
	  };
	
	
	  return Menu;
	};
	
	var Menu = factory(_MenuItem2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(Menu);
	exports.menuFactory = factory;
	exports.Menu = Menu;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuItem = exports.menuItemFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple) {
	  var MenuItem = function (_Component) {
	    _inherits(MenuItem, _Component);
	
	    function MenuItem() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, MenuItem);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	        if (_this.props.onClick && !_this.props.disabled) {
	          _this.props.onClick(event, _this);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MenuItem, [{
	      key: 'render',
	      value: function render() {
	        var _classnames;
	
	        var _props = this.props,
	            caption = _props.caption,
	            children = _props.children,
	            disabled = _props.disabled,
	            icon = _props.icon,
	            selected = _props.selected,
	            shortcut = _props.shortcut,
	            theme = _props.theme,
	            others = _objectWithoutProperties(_props, ['caption', 'children', 'disabled', 'icon', 'selected', 'shortcut', 'theme']);
	
	        var className = (0, _classnames3.default)(theme.menuItem, (_classnames = {}, _defineProperty(_classnames, theme.selected, selected), _defineProperty(_classnames, theme.disabled, disabled), _classnames), this.props.className);
	
	        return _react2.default.createElement(
	          'li',
	          _extends({}, others, { 'data-react-toolbox': 'menu-item', className: className, onClick: this.handleClick }),
	          icon ? _react2.default.createElement(_FontIcon.FontIcon, { value: icon, className: theme.icon }) : null,
	          _react2.default.createElement(
	            'span',
	            { className: theme.caption },
	            caption
	          ),
	          shortcut ? _react2.default.createElement(
	            'small',
	            { className: theme.shortcut },
	            shortcut
	          ) : null,
	          children
	        );
	      }
	    }]);
	
	    return MenuItem;
	  }(_react.Component);
	
	  MenuItem.propTypes = {
	    caption: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    onClick: _propTypes2.default.func,
	    selected: _propTypes2.default.bool,
	    shortcut: _propTypes2.default.string,
	    theme: _propTypes2.default.shape({
	      caption: _propTypes2.default.string,
	      disabled: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      menuItem: _propTypes2.default.string,
	      selected: _propTypes2.default.string,
	      shortcut: _propTypes2.default.string
	    })
	  };
	  MenuItem.defaultProps = {
	    className: '',
	    disabled: false,
	    selected: false
	  };
	
	
	  return ripple(MenuItem);
	};
	
	var MenuItem = factory((0, _Ripple2.default)({}));
	exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(MenuItem);
	exports.menuItemFactory = factory;
	exports.MenuItem = MenuItem;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconMenu = exports.Menu = exports.MenuItem = exports.MenuDivider = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _button = __webpack_require__(31);
	
	var _MenuDivider = __webpack_require__(2396);
	
	var _MenuItem = __webpack_require__(805);
	
	var _Menu = __webpack_require__(804);
	
	var _IconMenu = __webpack_require__(2395);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _theme = __webpack_require__(1445);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyTheme = function applyTheme(Component) {
	  return (0, _reactCssThemr.themr)(_identifiers.MENU, _theme2.default)(Component);
	};
	var ThemedMenuDivider = applyTheme(_MenuDivider.MenuDivider);
	var ThemedMenuItem = applyTheme((0, _MenuItem.menuItemFactory)((0, _ripple2.default)({})));
	var ThemedMenu = applyTheme((0, _Menu.menuFactory)(ThemedMenuItem));
	var ThemedIconMenu = applyTheme((0, _IconMenu.iconMenuFactory)(_button.IconButton, ThemedMenu));
	
	exports.MenuDivider = ThemedMenuDivider;
	exports.MenuItem = ThemedMenuItem;
	exports.Menu = ThemedMenu;
	exports.IconMenu = ThemedIconMenu;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Overlay = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Overlay = __webpack_require__(375);
	
	var _theme = __webpack_require__(1447);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedOverlay = (0, _reactCssThemr.themr)(_identifiers.OVERLAY, _theme2.default)(_Overlay.Overlay);
	exports.default = ThemedOverlay;
	exports.Overlay = ThemedOverlay;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ProgressBar = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _prefixer = __webpack_require__(255);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressBar = function (_Component) {
	  _inherits(ProgressBar, _Component);
	
	  function ProgressBar() {
	    _classCallCheck(this, ProgressBar);
	
	    return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
	  }
	
	  _createClass(ProgressBar, [{
	    key: 'calculateRatio',
	    value: function calculateRatio(value) {
	      if (value < this.props.min) return 0;
	      if (value > this.props.max) return 1;
	      return (value - this.props.min) / (this.props.max - this.props.min);
	    }
	  }, {
	    key: 'circularStyle',
	    value: function circularStyle() {
	      return this.props.mode !== 'indeterminate' ? { strokeDasharray: 2 * Math.PI * 25 * this.calculateRatio(this.props.value) + ', 400' } : undefined;
	    }
	  }, {
	    key: 'linearStyle',
	    value: function linearStyle() {
	      if (this.props.mode !== 'indeterminate') {
	        return {
	          buffer: (0, _prefixer2.default)({ transform: 'scaleX(' + this.calculateRatio(this.props.buffer) + ')' }),
	          value: (0, _prefixer2.default)({ transform: 'scaleX(' + this.calculateRatio(this.props.value) + ')' })
	        };
	      }
	      return {};
	    }
	  }, {
	    key: 'renderCircular',
	    value: function renderCircular() {
	      return _react2.default.createElement(
	        'svg',
	        { className: this.props.theme.circle, viewBox: '0 0 60 60' },
	        _react2.default.createElement('circle', { className: this.props.theme.path, style: this.circularStyle(), cx: '30', cy: '30', r: '25' })
	      );
	    }
	  }, {
	    key: 'renderLinear',
	    value: function renderLinear() {
	      var _linearStyle = this.linearStyle(),
	          buffer = _linearStyle.buffer,
	          value = _linearStyle.value;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('span', { 'data-ref': 'buffer', className: this.props.theme.buffer, style: buffer }),
	        _react2.default.createElement('span', { 'data-ref': 'value', className: this.props.theme.value, style: value })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled,
	          max = _props.max,
	          min = _props.min,
	          mode = _props.mode,
	          multicolor = _props.multicolor,
	          type = _props.type,
	          theme = _props.theme,
	          value = _props.value;
	
	      var _className = (0, _classnames3.default)(theme[type], (_classnames = {}, _defineProperty(_classnames, theme.indeterminate, mode === 'indeterminate'), _defineProperty(_classnames, theme.multicolor, multicolor), _classnames), className);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          disabled: disabled,
	          'data-react-toolbox': 'progress-bar',
	          'aria-valuenow': value,
	          'aria-valuemin': min,
	          'aria-valuemax': max,
	          className: _className
	        },
	        type === 'circular' ? this.renderCircular() : this.renderLinear()
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_react.Component);
	
	ProgressBar.propTypes = {
	  buffer: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  max: _propTypes2.default.number,
	  min: _propTypes2.default.number,
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  multicolor: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    buffer: _propTypes2.default.string,
	    circle: _propTypes2.default.string,
	    circular: _propTypes2.default.string,
	    indeterminate: _propTypes2.default.string,
	    linear: _propTypes2.default.string,
	    multicolor: _propTypes2.default.string,
	    path: _propTypes2.default.string,
	    value: _propTypes2.default.string
	  }),
	  type: _propTypes2.default.oneOf(['linear', 'circular']),
	  value: _propTypes2.default.number
	};
	ProgressBar.defaultProps = {
	  buffer: 0,
	  className: '',
	  max: 100,
	  min: 0,
	  mode: 'indeterminate',
	  multicolor: false,
	  type: 'linear',
	  value: 0
	};
	exports.default = (0, _reactCssThemr.themr)(_identifiers.PROGRESS_BAR)(ProgressBar);
	exports.ProgressBar = ProgressBar;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var factory = function factory(ripple) {
	  var Radio = function Radio(_ref) {
	    var checked = _ref.checked,
	        onMouseDown = _ref.onMouseDown,
	        theme = _ref.theme,
	        other = _objectWithoutProperties(_ref, ['checked', 'onMouseDown', 'theme']);
	
	    return _react2.default.createElement('div', _extends({
	      'data-react-toolbox': 'radio',
	      className: theme[checked ? 'radioChecked' : 'radio'],
	      onMouseDown: onMouseDown
	    }, other));
	  };
	
	  Radio.propTypes = {
	    checked: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    onMouseDown: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      radio: _propTypes2.default.string,
	      radioChecked: _propTypes2.default.string,
	      ripple: _propTypes2.default.string
	    })
	  };
	
	  return ripple(Radio);
	};
	
	exports.default = factory;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioButton = exports.radioButtonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	var _Radio = __webpack_require__(809);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Radio) {
	  var RadioButton = function (_Component) {
	    _inherits(RadioButton, _Component);
	
	    function RadioButton() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, RadioButton);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	        var _this$props = _this.props,
	            checked = _this$props.checked,
	            disabled = _this$props.disabled,
	            onChange = _this$props.onChange;
	
	        if (event.pageX !== 0 && event.pageY !== 0) _this.blur();
	        if (!disabled && !checked && onChange) onChange(event, _this);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RadioButton, [{
	      key: 'blur',
	      value: function blur() {
	        if (this.inputNode) {
	          this.inputNode.blur();
	        }
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        if (this.inputNode) {
	          this.inputNode.focus();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            checked = _props.checked,
	            children = _props.children,
	            className = _props.className,
	            disabled = _props.disabled,
	            label = _props.label,
	            name = _props.name,
	            onChange = _props.onChange,
	            onMouseEnter = _props.onMouseEnter,
	            onMouseLeave = _props.onMouseLeave,
	            theme = _props.theme,
	            others = _objectWithoutProperties(_props, ['checked', 'children', 'className', 'disabled', 'label', 'name', 'onChange', 'onMouseEnter', 'onMouseLeave', 'theme']);
	
	        var _className = (0, _classnames2.default)(theme[this.props.disabled ? 'disabled' : 'field'], className);
	        return _react2.default.createElement(
	          'label',
	          {
	            'data-react-toolbox': 'radio-button',
	            className: _className,
	            onMouseEnter: onMouseEnter,
	            onMouseLeave: onMouseLeave
	          },
	          _react2.default.createElement('input', _extends({}, others, {
	            checked: checked,
	            className: theme.input,
	            disabled: disabled,
	            name: name,
	            onChange: function onChange() {},
	            onClick: this.handleClick,
	            ref: function ref(node) {
	              _this2.inputNode = node;
	            },
	            type: 'radio'
	          })),
	          _react2.default.createElement(Radio, { checked: checked, disabled: disabled, theme: theme }),
	          label ? _react2.default.createElement(
	            'span',
	            { className: theme.text },
	            label
	          ) : null,
	          children
	        );
	      }
	    }]);
	
	    return RadioButton;
	  }(_react.Component);
	
	  RadioButton.propTypes = {
	    checked: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    name: _propTypes2.default.string,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      disabled: _propTypes2.default.string,
	      field: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      text: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.string
	  };
	  RadioButton.defaultProps = {
	    checked: false,
	    className: '',
	    disabled: false
	  };
	
	
	  return RadioButton;
	};
	
	var Radio = (0, _Radio2.default)((0, _Ripple2.default)({ centered: true, spread: 2.6 }));
	var RadioButton = factory(Radio);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.RADIO)(RadioButton);
	exports.radioButtonFactory = factory;
	exports.RadioButton = RadioButton;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var factory = function factory(ripple) {
	  var Thumb = function Thumb(_ref) {
	    var onMouseDown = _ref.onMouseDown,
	        theme = _ref.theme,
	        other = _objectWithoutProperties(_ref, ['onMouseDown', 'theme']);
	
	    return _react2.default.createElement('span', _extends({ className: theme.thumb, onMouseDown: onMouseDown }, other));
	  };
	
	  Thumb.propTypes = {
	    children: _propTypes2.default.node,
	    onMouseDown: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      ripple: _propTypes2.default.string,
	      thumb: _propTypes2.default.string
	    })
	  };
	
	  return ripple(Thumb);
	};
	
	exports.default = factory;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Switch = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _Switch = __webpack_require__(2404);
	
	var _identifiers = __webpack_require__(9);
	
	var _Thumb = __webpack_require__(811);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _theme = __webpack_require__(1453);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyTheme = function applyTheme(Component) {
	  return (0, _reactCssThemr.themr)(_identifiers.SWITCH, _theme2.default)(Component);
	};
	var ripple = (0, _ripple2.default)({ centered: true, spread: 2.6 });
	var ThemedThumb = applyTheme((0, _Thumb2.default)(ripple));
	var ThemedSwitch = applyTheme((0, _Switch.switchFactory)(ThemedThumb));
	
	exports.default = ThemedSwitch;
	exports.Switch = ThemedSwitch;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TableHead = exports.tableHeadFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Checkbox = __webpack_require__(249);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableCell = __webpack_require__(376);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Checkbox, TableCell) {
	  var TableHead = function (_Component) {
	    _inherits(TableHead, _Component);
	
	    function TableHead() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TableHead);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableHead.__proto__ || Object.getPrototypeOf(TableHead)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (value, event) {
	        _this.props.onSelect(value, event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TableHead, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            children = _props.children,
	            displaySelect = _props.displaySelect,
	            multiSelectable = _props.multiSelectable,
	            onSelect = _props.onSelect,
	            selectable = _props.selectable,
	            selected = _props.selected,
	            theme = _props.theme,
	            other = _objectWithoutProperties(_props, ['children', 'displaySelect', 'multiSelectable', 'onSelect', 'selectable', 'selected', 'theme']);
	
	        return _react2.default.createElement(
	          'tr',
	          other,
	          selectable && _react2.default.createElement(
	            TableCell,
	            { className: theme.checkboxCell, tagName: 'th' },
	            displaySelect && _react2.default.createElement(Checkbox, {
	              checked: selected,
	              disabled: !multiSelectable,
	              onChange: this.handleSelect
	            })
	          ),
	          _react2.default.Children.map(children, function (child, index) {
	            if (!child) return null;
	            return (0, _react.cloneElement)(child, {
	              column: index,
	              tagName: 'th'
	            });
	          })
	        );
	      }
	    }]);
	
	    return TableHead;
	  }(_react.Component);
	
	  TableHead.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    displaySelect: _propTypes2.default.bool,
	    multiSelectable: _propTypes2.default.bool,
	    onSelect: _propTypes2.default.func,
	    selectable: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      checkboxCell: _propTypes2.default.string
	    })
	  };
	  TableHead.defaultProps = {
	    displaySelect: true
	  };
	
	
	  return TableHead;
	};
	
	var TableHead = factory(_Checkbox2.default, _TableCell2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(TableHead);
	exports.tableHeadFactory = factory;
	exports.TableHead = TableHead;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TableRow = exports.tableRowFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Checkbox = __webpack_require__(249);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableCell = __webpack_require__(376);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Checkbox, TableCell) {
	  var TableRow = function (_Component) {
	    _inherits(TableRow, _Component);
	
	    function TableRow() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TableRow);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (value) {
	        var _this$props = _this.props,
	            idx = _this$props.idx,
	            onSelect = _this$props.onSelect;
	
	        if (onSelect) onSelect(idx, value);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TableRow, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className,
	            selectable = _props.selectable,
	            idx = _props.idx,
	            selected = _props.selected,
	            theme = _props.theme,
	            other = _objectWithoutProperties(_props, ['children', 'className', 'selectable', 'idx', 'selected', 'theme']); // eslint-disable-line
	
	
	        var _className = (0, _classnames3.default)(theme.row, _defineProperty({}, theme.selected, selectable && selected), className);
	        return _react2.default.createElement(
	          'tr',
	          _extends({}, other, { className: _className }),
	          selectable && _react2.default.createElement(
	            TableCell,
	            { className: theme.checkboxCell },
	            _react2.default.createElement(Checkbox, { theme: theme, checked: selected, onChange: this.handleSelect })
	          ),
	          _react2.default.Children.map(children, function (child, index) {
	            if (!child) return null;
	            return (0, _react.cloneElement)(child, {
	              column: index,
	              tagName: 'td'
	            });
	          })
	        );
	      }
	    }]);
	
	    return TableRow;
	  }(_react.Component);
	
	  TableRow.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    idx: _propTypes2.default.number,
	    onSelect: _propTypes2.default.func,
	    selectable: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      checkboxCell: _propTypes2.default.string,
	      row: _propTypes2.default.string,
	      selected: _propTypes2.default.string
	    })
	  };
	
	
	  return TableRow;
	};
	
	var TableRow = factory(_Checkbox2.default, _TableCell2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(TableRow);
	exports.tableRowFactory = factory;
	exports.TableRow = TableRow;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tab = exports.tabFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var Tab = function (_Component) {
	    _inherits(Tab, _Component);
	
	    function Tab() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Tab);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	        if (!_this.props.disabled && _this.props.onClick) {
	          _this.props.onClick(event, _this.props.index);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Tab, [{
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        if (!prevProps.active && this.props.active && this.props.onActive) {
	          this.props.onActive();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames;
	
	        var _props = this.props,
	            index = _props.index,
	            onActive = _props.onActive,
	            active = _props.active,
	            activeClassName = _props.activeClassName,
	            children = _props.children,
	            className = _props.className,
	            disabled = _props.disabled,
	            hidden = _props.hidden,
	            label = _props.label,
	            icon = _props.icon,
	            theme = _props.theme,
	            other = _objectWithoutProperties(_props, ['index', 'onActive', 'active', 'activeClassName', 'children', 'className', 'disabled', 'hidden', 'label', 'icon', 'theme']);
	
	        var _className = (0, _classnames3.default)(theme.label, (_classnames = {}, _defineProperty(_classnames, theme.active, active), _defineProperty(_classnames, theme.hidden, hidden), _defineProperty(_classnames, theme.withText, label), _defineProperty(_classnames, theme.withIcon, icon), _defineProperty(_classnames, theme.disabled, disabled), _defineProperty(_classnames, activeClassName, active), _classnames), className);
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, other, { 'data-react-toolbox': 'tab', role: 'tab', tabIndex: '0', className: _className, onClick: this.handleClick }),
	          icon && _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }),
	          label,
	          children
	        );
	      }
	    }]);
	
	    return Tab;
	  }(_react.Component);
	
	  Tab.propTypes = {
	    active: _propTypes2.default.bool,
	    activeClassName: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    hidden: _propTypes2.default.bool,
	    icon: _propTypes2.default.node,
	    index: _propTypes2.default.number,
	    label: _propTypes2.default.node,
	    onActive: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      disabled: _propTypes2.default.string,
	      hidden: _propTypes2.default.string,
	      label: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      withIcon: _propTypes2.default.string,
	      withText: _propTypes2.default.string
	    })
	  };
	  Tab.defaultProps = {
	    active: false,
	    className: '',
	    disabled: false,
	    hidden: false
	  };
	
	
	  return ripple(Tab);
	};
	
	var Tab = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TABS)(Tab);
	exports.tabFactory = factory;
	exports.Tab = Tab;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabContent = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabContent = function (_Component) {
	  _inherits(TabContent, _Component);
	
	  function TabContent() {
	    _classCallCheck(this, TabContent);
	
	    return _possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
	  }
	
	  _createClass(TabContent, [{
	    key: 'render',
	    // eslint-disable-line react/prefer-stateless-function
	    value: function render() {
	      var className = (0, _classnames3.default)(this.props.theme.tab, _defineProperty({}, this.props.theme.active, this.props.active), this.props.className);
	
	      return _react2.default.createElement(
	        'section',
	        { className: className, role: 'tabpanel', 'aria-expanded': this.props.hidden },
	        this.props.children
	      );
	    }
	  }]);
	
	  return TabContent;
	}(_react.Component);
	
	TabContent.propTypes = {
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  hidden: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    tab: _propTypes2.default.string
	  })
	};
	TabContent.defaultProps = {
	  active: false,
	  className: '',
	  hidden: true
	};
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TABS)(TabContent);
	exports.TabContent = TabContent;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-mixed-operators */
	
	
	var Face = function (_Component) {
	  _inherits(Face, _Component);
	
	  function Face() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Face);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Face.__proto__ || Object.getPrototypeOf(Face)).call.apply(_ref, [this].concat(args))), _this), _this.renderNumber = function (number, idx) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          radius = _this$props.radius,
	          spacing = _this$props.spacing,
	          theme = _this$props.theme,
	          twoDigits = _this$props.twoDigits;
	
	      return _react2.default.createElement(
	        'span',
	        {
	          className: (0, _classnames3.default)(theme.number, _defineProperty({}, theme.active, number === active)),
	          style: _this.numberStyle(radius - spacing, idx + 1),
	          key: number
	        },
	        twoDigits ? ('0' + number).slice(-2) : number
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Face, [{
	    key: 'numberStyle',
	    value: function numberStyle(rad, num) {
	      return {
	        position: 'absolute',
	        left: rad + rad * Math.sin(360 * (Math.PI / 180) / 12 * (num - 1)) + this.props.spacing,
	        top: rad - rad * Math.cos(360 * (Math.PI / 180) / 12 * (num - 1)) + this.props.spacing
	      };
	    }
	  }, {
	    key: 'faceStyle',
	    value: function faceStyle() {
	      return {
	        height: this.props.radius * 2,
	        width: this.props.radius * 2
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          numbers = _props.numbers,
	          onTouchStart = _props.onTouchStart,
	          onMouseDown = _props.onMouseDown,
	          theme = _props.theme; // eslint-disable-line
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: theme.face,
	          onTouchStart: onTouchStart,
	          onMouseDown: onMouseDown,
	          style: this.faceStyle()
	        },
	        numbers.map(this.renderNumber)
	      );
	    }
	  }]);
	
	  return Face;
	}(_react.Component);
	
	Face.propTypes = {
	  active: _propTypes2.default.number,
	  numbers: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  radius: _propTypes2.default.number,
	  spacing: _propTypes2.default.number,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    face: _propTypes2.default.string,
	    number: _propTypes2.default.string
	  }),
	  twoDigits: _propTypes2.default.bool
	};
	Face.defaultProps = {
	  active: null,
	  numbers: [],
	  radius: 0,
	  twoDigits: false
	};
	exports.default = Face;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(60);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _prefixer = __webpack_require__(255);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hand = function (_Component) {
	  _inherits(Hand, _Component);
	
	  function Hand() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hand);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hand.__proto__ || Object.getPrototypeOf(Hand)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      knobWidth: 0
	    }, _this.handleMouseMove = function (event) {
	      _this.move(_events2.default.getMousePosition(event));
	    }, _this.handleTouchMove = function (event) {
	      _this.move(_events2.default.getTouchPosition(event));
	    }, _this.handleMouseUp = function () {
	      _this.end(_this.getMouseEventMap());
	    }, _this.handleTouchEnd = function () {
	      _this.end(_this.getTouchEventMap());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hand, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({ knobWidth: _this2.knobNode.offsetWidth });
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _events2.default.removeEventsFromDocument(this.getMouseEventMap());
	      _events2.default.removeEventsFromDocument(this.getTouchEventMap());
	    }
	  }, {
	    key: 'getMouseEventMap',
	    value: function getMouseEventMap() {
	      return {
	        mousemove: this.handleMouseMove,
	        mouseup: this.handleMouseUp
	      };
	    }
	  }, {
	    key: 'getTouchEventMap',
	    value: function getTouchEventMap() {
	      return {
	        touchmove: this.handleTouchMove,
	        touchend: this.handleTouchEnd
	      };
	    }
	  }, {
	    key: 'getPositionRadius',
	    value: function getPositionRadius(position) {
	      var x = this.props.origin.x - position.x;
	      var y = this.props.origin.y - position.y;
	      return Math.sqrt(x * x + y * y);
	    }
	  }, {
	    key: 'mouseStart',
	    value: function mouseStart(event) {
	      _events2.default.addEventsToDocument(this.getMouseEventMap());
	      this.move(_events2.default.getMousePosition(event));
	    }
	  }, {
	    key: 'touchStart',
	    value: function touchStart(event) {
	      _events2.default.addEventsToDocument(this.getTouchEventMap());
	      this.move(_events2.default.getTouchPosition(event));
	      _events2.default.pauseEvent(event);
	    }
	  }, {
	    key: 'trimAngleToValue',
	    value: function trimAngleToValue(angle) {
	      return this.props.step * Math.round(angle / this.props.step);
	    }
	  }, {
	    key: 'positionToAngle',
	    value: function positionToAngle(position) {
	      return (0, _utils.angle360FromPositions)(this.props.origin.x, this.props.origin.y, position.x, position.y);
	    }
	  }, {
	    key: 'end',
	    value: function end(evts) {
	      if (this.props.onMoved) this.props.onMoved();
	      _events2.default.removeEventsFromDocument(evts);
	    }
	  }, {
	    key: 'move',
	    value: function move(position) {
	      var degrees = this.trimAngleToValue(this.positionToAngle(position));
	      var radius = this.getPositionRadius(position);
	      if (this.props.onMove) this.props.onMove(degrees === 360 ? 0 : degrees, radius);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var theme = this.props.theme;
	
	      var className = theme.hand + ' ' + this.props.className;
	      var handStyle = (0, _prefixer2.default)({
	        height: this.props.length - this.state.knobWidth / 2,
	        transform: 'rotate(' + this.props.angle + 'deg)'
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: handStyle },
	        _react2.default.createElement('div', { ref: function ref(node) {
	            _this3.knobNode = node;
	          }, className: theme.knob })
	      );
	    }
	  }]);
	
	  return Hand;
	}(_react.Component);
	
	Hand.propTypes = {
	  angle: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  length: _propTypes2.default.number,
	  onMove: _propTypes2.default.func,
	  onMoved: _propTypes2.default.func,
	  origin: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  step: _propTypes2.default.number,
	  theme: _propTypes2.default.shape({
	    hand: _propTypes2.default.string,
	    knob: _propTypes2.default.string
	  })
	};
	Hand.defaultProps = {
	  className: '',
	  angle: 0,
	  length: 0,
	  origin: {}
	};
	exports.default = Hand;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _Clock = __webpack_require__(2408);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Dialog) {
	  var TimePickerDialog = function (_Component) {
	    _inherits(TimePickerDialog, _Component);
	
	    function TimePickerDialog() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TimePickerDialog);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePickerDialog.__proto__ || Object.getPrototypeOf(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        display: 'hours',
	        displayTime: new Date(_this.props.value.getTime())
	      }, _this.handleClockChange = function (value) {
	        _this.setState({ displayTime: value });
	      }, _this.handleSelect = function (event) {
	        _this.props.onSelect(_this.state.displayTime, event);
	      }, _this.toggleTimeMode = function () {
	        _this.setState({ displayTime: _time2.default.toggleTimeMode(_this.state.displayTime) });
	      }, _this.handleHandMoved = function () {
	        if (_this.state.display === 'hours') _this.setState({ display: 'minutes' });
	      }, _this.switchDisplay = function (event) {
	        _this.setState({ display: event.target.id });
	      }, _this.actions = [{
	        label: _this.props.cancelLabel,
	        className: _this.props.theme.button,
	        onClick: _this.props.onDismiss
	      }, {
	        label: _this.props.okLabel,
	        className: _this.props.theme.button,
	        name: _this.props.name,
	        onClick: _this.handleSelect
	      }], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TimePickerDialog, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.value.getTime() !== this.state.displayTime.getTime()) {
	          this.setState({ displayTime: new Date(nextProps.value.getTime()) });
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        if (!prevProps.active && this.props.active) {
	          setTimeout(this.clockNode.handleCalculateShape, 1000);
	        }
	      }
	    }, {
	      key: 'formatHours',
	      value: function formatHours() {
	        if (this.props.format === 'ampm') {
	          return this.state.displayTime.getHours() % 12 || 12;
	        }
	        return this.state.displayTime.getHours();
	      }
	    }, {
	      key: 'renderAMPMLabels',
	      value: function renderAMPMLabels() {
	        var theme = this.props.theme;
	
	        if (this.props.format !== 'ampm') return undefined;
	        return _react2.default.createElement(
	          'div',
	          { className: theme.ampm },
	          _react2.default.createElement(
	            'span',
	            { className: theme.am, onClick: this.toggleTimeMode },
	            'AM'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: theme.pm, onClick: this.toggleTimeMode },
	            'PM'
	          )
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var theme = this.props.theme;
	
	        var display = this.state.display + 'Display';
	        var format = _time2.default.getTimeMode(this.state.displayTime) + 'Format';
	        var className = (0, _classnames2.default)([theme.dialog, theme[display], theme[format]], this.props.className);
	        return _react2.default.createElement(
	          Dialog,
	          {
	            actions: this.actions,
	            active: this.props.active,
	            className: className,
	            onEscKeyDown: this.props.onEscKeyDown,
	            onOverlayClick: this.props.onOverlayClick
	          },
	          _react2.default.createElement(
	            'header',
	            { className: theme.header },
	            _react2.default.createElement(
	              'span',
	              { id: 'hours', className: theme.hours, onClick: this.switchDisplay },
	              ('0' + this.formatHours()).slice(-2)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: theme.separator },
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              { id: 'minutes', className: theme.minutes, onClick: this.switchDisplay },
	              ('0' + this.state.displayTime.getMinutes()).slice(-2)
	            ),
	            this.renderAMPMLabels()
	          ),
	          _react2.default.createElement(_Clock2.default, {
	            ref: function ref(node) {
	              _this2.clockNode = node;
	            },
	            display: this.state.display,
	            format: this.props.format,
	            onChange: this.handleClockChange,
	            onHandMoved: this.handleHandMoved,
	            theme: this.props.theme,
	            time: this.state.displayTime
	          })
	        );
	      }
	    }]);
	
	    return TimePickerDialog;
	  }(_react.Component);
	
	  TimePickerDialog.propTypes = {
	    active: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    format: _propTypes2.default.oneOf(['24hr', 'ampm']),
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      am: _propTypes2.default.string,
	      amFormat: _propTypes2.default.string,
	      ampm: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      dialog: _propTypes2.default.string,
	      header: _propTypes2.default.string,
	      hours: _propTypes2.default.string,
	      hoursDisplay: _propTypes2.default.string,
	      minutes: _propTypes2.default.string,
	      minutesDisplay: _propTypes2.default.string,
	      pm: _propTypes2.default.string,
	      pmFormat: _propTypes2.default.string,
	      separator: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.instanceOf(Date)
	  };
	  TimePickerDialog.defaultProps = {
	    active: false,
	    cancelLabel: 'Cancel',
	    format: '24hr',
	    okLabel: 'Ok',
	    value: new Date()
	  };
	
	
	  return TimePickerDialog;
	};
	
	exports.default = factory;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (children, predicate) {
	  var _this = this;
	
	  if (children) {
	    var result = [];
	    _react2.default.Children.forEach(children, function (entry, idx) {
	      if (predicate && predicate.call(_this, entry, idx)) {
	        result.push(entry);
	      }
	    });
	    return result;
	  }
	
	  return undefined;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 821 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(46)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(123)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 823 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 824 */
[2544, 72, 71],
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(46)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 826 */
[2548, 106, 182, 824],
/* 827 */
[2549, 256],
/* 828 */
[2550, 183, 46],
/* 829 */
[2551, 256],
/* 830 */
[2552, 120],
/* 831 */
[2555, 46],
/* 832 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 833 */
[2560, 382, 184, 150, 385, 122, 826, 106],
/* 834 */
[2562, 836, 378],
/* 835 */
296,
/* 836 */
[2564, 122, 150, 2428, 383],
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(124);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(2440);
	var defined = __webpack_require__(257);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 840 */
[2577, 46],
/* 841 */
[2579, 377, 46, 183, 64],
/* 842 */
[2581, 822, 832, 183, 150, 379],
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(377);
	var test = {};
	test[__webpack_require__(46)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(124)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 844 */
[2582, 2449, 379],
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(503));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(504));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(2463));
	
	var _PropTypes = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(767);
	
	var _ChildMapping = __webpack_require__(2464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.nameShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  leave: _propTypes2.default.string,
	  leaveActive: _propTypes2.default.string,
	  appear: _propTypes2.default.string,
	  appearActive: _propTypes2.default.string
	})]);

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(153);
	
	var ReactCurrentOwner = __webpack_require__(93);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 850 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(2484);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(2483);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ },
/* 854 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(542);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2495);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 856 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createThemeListener;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _channel = __webpack_require__(266);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function createThemeListener() {
	  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  var contextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.object.isRequired);
	
	  function initial(context) {
	    if (!context[CHANNEL]) {
	      throw new Error('[' + this.displayName + '] Please use ThemeProvider to be able to use WithTheme');
	    }
	
	    return context[CHANNEL].getState();
	  }
	
	  function subscribe(context, cb) {
	    if (context[CHANNEL]) {
	      return context[CHANNEL].subscribe(cb);
	    }
	  }
	
	  function unsubscribe(context, subscriptionId) {
	    if (context[CHANNEL]) {
	      context[CHANNEL].unsubscribe(subscriptionId);
	    }
	  }
	
	  return {
	    contextTypes: contextTypes,
	    initial: initial,
	    subscribe: subscribe,
	    unsubscribe: unsubscribe
	  };
	}

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.themeListener = exports.ThemeProvider = exports.withTheme = exports.channel = undefined;
	exports.createTheming = createTheming;
	
	var _createThemeProvider = __webpack_require__(2497);
	
	var _createThemeProvider2 = _interopRequireDefault(_createThemeProvider);
	
	var _createWithTheme = __webpack_require__(2498);
	
	var _createWithTheme2 = _interopRequireDefault(_createWithTheme);
	
	var _createThemeListener = __webpack_require__(857);
	
	var _createThemeListener2 = _interopRequireDefault(_createThemeListener);
	
	var _channel = __webpack_require__(266);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var channel = exports.channel = _channel2.default;
	var withTheme = exports.withTheme = (0, _createWithTheme2.default)();
	var ThemeProvider = exports.ThemeProvider = (0, _createThemeProvider2.default)();
	var themeListener = exports.themeListener = (0, _createThemeListener2.default)();
	function createTheming() {
	  var customChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  return {
	    channel: customChannel,
	    withTheme: (0, _createWithTheme2.default)(customChannel),
	    ThemeProvider: (0, _createThemeProvider2.default)(customChannel),
	    themeListener: (0, _createThemeListener2.default)(customChannel)
	  };
	}
	
	exports.default = {
	  channel: _channel2.default,
	  withTheme: withTheme,
	  ThemeProvider: ThemeProvider,
	  themeListener: themeListener,
	  createTheming: createTheming
	};

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(2492);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(2502);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(2501);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(61)))

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLCData, XMLNode, create,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  create = __webpack_require__(58);
	
	  XMLNode = __webpack_require__(155);
	
	  module.exports = XMLCData = (function(superClass) {
	    extend(XMLCData, superClass);
	
	    function XMLCData(parent, text) {
	      XMLCData.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing CDATA text");
	      }
	      this.text = this.stringify.cdata(text);
	    }
	
	    XMLCData.prototype.clone = function() {
	      return create(XMLCData.prototype, this);
	    };
	
	    XMLCData.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<![CDATA[' + this.text + ']]>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLCData;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLComment, XMLNode, create,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  create = __webpack_require__(58);
	
	  XMLNode = __webpack_require__(155);
	
	  module.exports = XMLComment = (function(superClass) {
	    extend(XMLComment, superClass);
	
	    function XMLComment(parent, text) {
	      XMLComment.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing comment text");
	      }
	      this.text = this.stringify.comment(text);
	    }
	
	    XMLComment.prototype.clone = function() {
	      return create(XMLComment.prototype, this);
	    };
	
	    XMLComment.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<!-- ' + this.text + ' -->';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLComment;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLDeclaration, XMLNode, create, isObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  create = __webpack_require__(58);
	
	  isObject = __webpack_require__(80);
	
	  XMLNode = __webpack_require__(155);
	
	  module.exports = XMLDeclaration = (function(superClass) {
	    extend(XMLDeclaration, superClass);
	
	    function XMLDeclaration(parent, version, encoding, standalone) {
	      var ref;
	      XMLDeclaration.__super__.constructor.call(this, parent);
	      if (isObject(version)) {
	        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
	      }
	      if (!version) {
	        version = '1.0';
	      }
	      this.version = this.stringify.xmlVersion(version);
	      if (encoding != null) {
	        this.encoding = this.stringify.xmlEncoding(encoding);
	      }
	      if (standalone != null) {
	        this.standalone = this.stringify.xmlStandalone(standalone);
	      }
	    }
	
	    XMLDeclaration.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<?xml';
	      r += ' version="' + this.version + '"';
	      if (this.encoding != null) {
	        r += ' encoding="' + this.encoding + '"';
	      }
	      if (this.standalone != null) {
	        r += ' standalone="' + this.standalone + '"';
	      }
	      r += '?>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLDeclaration;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLProcessingInstruction, create, isObject;
	
	  create = __webpack_require__(58);
	
	  isObject = __webpack_require__(80);
	
	  XMLCData = __webpack_require__(861);
	
	  XMLComment = __webpack_require__(862);
	
	  XMLDTDAttList = __webpack_require__(2508);
	
	  XMLDTDEntity = __webpack_require__(2510);
	
	  XMLDTDElement = __webpack_require__(2509);
	
	  XMLDTDNotation = __webpack_require__(2511);
	
	  XMLProcessingInstruction = __webpack_require__(866);
	
	  module.exports = XMLDocType = (function() {
	    function XMLDocType(parent, pubID, sysID) {
	      var ref, ref1;
	      this.documentObject = parent;
	      this.stringify = this.documentObject.stringify;
	      this.children = [];
	      if (isObject(pubID)) {
	        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
	      }
	      if (sysID == null) {
	        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
	      }
	      if (pubID != null) {
	        this.pubID = this.stringify.dtdPubID(pubID);
	      }
	      if (sysID != null) {
	        this.sysID = this.stringify.dtdSysID(sysID);
	      }
	    }
	
	    XMLDocType.prototype.element = function(name, value) {
	      var child;
	      child = new XMLDTDElement(this, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      var child;
	      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.entity = function(name, value) {
	      var child;
	      child = new XMLDTDEntity(this, false, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.pEntity = function(name, value) {
	      var child;
	      child = new XMLDTDEntity(this, true, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.notation = function(name, value) {
	      var child;
	      child = new XMLDTDNotation(this, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.cdata = function(value) {
	      var child;
	      child = new XMLCData(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.comment = function(value) {
	      var child;
	      child = new XMLComment(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.instruction = function(target, value) {
	      var child;
	      child = new XMLProcessingInstruction(this, target, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.root = function() {
	      return this.documentObject.root();
	    };
	
	    XMLDocType.prototype.document = function() {
	      return this.documentObject;
	    };
	
	    XMLDocType.prototype.toString = function(options, level) {
	      var child, i, indent, len, newline, offset, pretty, r, ref, ref1, ref2, ref3, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<!DOCTYPE ' + this.root().name;
	      if (this.pubID && this.sysID) {
	        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
	      } else if (this.sysID) {
	        r += ' SYSTEM "' + this.sysID + '"';
	      }
	      if (this.children.length > 0) {
	        r += ' [';
	        if (pretty) {
	          r += newline;
	        }
	        ref3 = this.children;
	        for (i = 0, len = ref3.length; i < len; i++) {
	          child = ref3[i];
	          r += child.toString(options, level + 1);
	        }
	        r += ']';
	      }
	      r += '>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    XMLDocType.prototype.ele = function(name, value) {
	      return this.element(name, value);
	    };
	
	    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
	    };
	
	    XMLDocType.prototype.ent = function(name, value) {
	      return this.entity(name, value);
	    };
	
	    XMLDocType.prototype.pent = function(name, value) {
	      return this.pEntity(name, value);
	    };
	
	    XMLDocType.prototype.not = function(name, value) {
	      return this.notation(name, value);
	    };
	
	    XMLDocType.prototype.dat = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLDocType.prototype.com = function(value) {
	      return this.comment(value);
	    };
	
	    XMLDocType.prototype.ins = function(target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLDocType.prototype.up = function() {
	      return this.root();
	    };
	
	    XMLDocType.prototype.doc = function() {
	      return this.document();
	    };
	
	    return XMLDocType;
	
	  })();
	
	}).call(this);


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLAttribute, XMLElement, XMLNode, XMLProcessingInstruction, create, every, isFunction, isObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  create = __webpack_require__(58);
	
	  isObject = __webpack_require__(80);
	
	  isFunction = __webpack_require__(215);
	
	  every = __webpack_require__(1978);
	
	  XMLNode = __webpack_require__(155);
	
	  XMLAttribute = __webpack_require__(2506);
	
	  XMLProcessingInstruction = __webpack_require__(866);
	
	  module.exports = XMLElement = (function(superClass) {
	    extend(XMLElement, superClass);
	
	    function XMLElement(parent, name, attributes) {
	      XMLElement.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing element name");
	      }
	      this.name = this.stringify.eleName(name);
	      this.children = [];
	      this.instructions = [];
	      this.attributes = {};
	      if (attributes != null) {
	        this.attribute(attributes);
	      }
	    }
	
	    XMLElement.prototype.clone = function() {
	      var att, attName, clonedSelf, i, len, pi, ref, ref1;
	      clonedSelf = create(XMLElement.prototype, this);
	      if (clonedSelf.isRoot) {
	        clonedSelf.documentObject = null;
	      }
	      clonedSelf.attributes = {};
	      ref = this.attributes;
	      for (attName in ref) {
	        if (!hasProp.call(ref, attName)) continue;
	        att = ref[attName];
	        clonedSelf.attributes[attName] = att.clone();
	      }
	      clonedSelf.instructions = [];
	      ref1 = this.instructions;
	      for (i = 0, len = ref1.length; i < len; i++) {
	        pi = ref1[i];
	        clonedSelf.instructions.push(pi.clone());
	      }
	      clonedSelf.children = [];
	      this.children.forEach(function(child) {
	        var clonedChild;
	        clonedChild = child.clone();
	        clonedChild.parent = clonedSelf;
	        return clonedSelf.children.push(clonedChild);
	      });
	      return clonedSelf;
	    };
	
	    XMLElement.prototype.attribute = function(name, value) {
	      var attName, attValue;
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (isObject(name)) {
	        for (attName in name) {
	          if (!hasProp.call(name, attName)) continue;
	          attValue = name[attName];
	          this.attribute(attName, attValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        if (!this.options.skipNullAttributes || (value != null)) {
	          this.attributes[name] = new XMLAttribute(this, name, value);
	        }
	      }
	      return this;
	    };
	
	    XMLElement.prototype.removeAttribute = function(name) {
	      var attName, i, len;
	      if (name == null) {
	        throw new Error("Missing attribute name");
	      }
	      name = name.valueOf();
	      if (Array.isArray(name)) {
	        for (i = 0, len = name.length; i < len; i++) {
	          attName = name[i];
	          delete this.attributes[attName];
	        }
	      } else {
	        delete this.attributes[name];
	      }
	      return this;
	    };
	
	    XMLElement.prototype.instruction = function(target, value) {
	      var i, insTarget, insValue, instruction, len;
	      if (target != null) {
	        target = target.valueOf();
	      }
	      if (value != null) {
	        value = value.valueOf();
	      }
	      if (Array.isArray(target)) {
	        for (i = 0, len = target.length; i < len; i++) {
	          insTarget = target[i];
	          this.instruction(insTarget);
	        }
	      } else if (isObject(target)) {
	        for (insTarget in target) {
	          if (!hasProp.call(target, insTarget)) continue;
	          insValue = target[insTarget];
	          this.instruction(insTarget, insValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        instruction = new XMLProcessingInstruction(this, target, value);
	        this.instructions.push(instruction);
	      }
	      return this;
	    };
	
	    XMLElement.prototype.toString = function(options, level) {
	      var att, child, i, indent, instruction, j, len, len1, name, newline, offset, pretty, r, ref, ref1, ref2, ref3, ref4, ref5, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      ref3 = this.instructions;
	      for (i = 0, len = ref3.length; i < len; i++) {
	        instruction = ref3[i];
	        r += instruction.toString(options, level);
	      }
	      if (pretty) {
	        r += space;
	      }
	      r += '<' + this.name;
	      ref4 = this.attributes;
	      for (name in ref4) {
	        if (!hasProp.call(ref4, name)) continue;
	        att = ref4[name];
	        r += att.toString(options);
	      }
	      if (this.children.length === 0 || every(this.children, function(e) {
	        return e.value === '';
	      })) {
	        r += '/>';
	        if (pretty) {
	          r += newline;
	        }
	      } else if (pretty && this.children.length === 1 && (this.children[0].value != null)) {
	        r += '>';
	        r += this.children[0].value;
	        r += '</' + this.name + '>';
	        r += newline;
	      } else {
	        r += '>';
	        if (pretty) {
	          r += newline;
	        }
	        ref5 = this.children;
	        for (j = 0, len1 = ref5.length; j < len1; j++) {
	          child = ref5[j];
	          r += child.toString(options, level + 1);
	        }
	        if (pretty) {
	          r += space;
	        }
	        r += '</' + this.name + '>';
	        if (pretty) {
	          r += newline;
	        }
	      }
	      return r;
	    };
	
	    XMLElement.prototype.att = function(name, value) {
	      return this.attribute(name, value);
	    };
	
	    XMLElement.prototype.ins = function(target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLElement.prototype.a = function(name, value) {
	      return this.attribute(name, value);
	    };
	
	    XMLElement.prototype.i = function(target, value) {
	      return this.instruction(target, value);
	    };
	
	    return XMLElement;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLProcessingInstruction, create;
	
	  create = __webpack_require__(58);
	
	  module.exports = XMLProcessingInstruction = (function() {
	    function XMLProcessingInstruction(parent, target, value) {
	      this.stringify = parent.stringify;
	      if (target == null) {
	        throw new Error("Missing instruction target");
	      }
	      this.target = this.stringify.insTarget(target);
	      if (value) {
	        this.value = this.stringify.insValue(value);
	      }
	    }
	
	    XMLProcessingInstruction.prototype.clone = function() {
	      return create(XMLProcessingInstruction.prototype, this);
	    };
	
	    XMLProcessingInstruction.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<?';
	      r += this.target;
	      if (this.value) {
	        r += ' ' + this.value;
	      }
	      r += '?>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLProcessingInstruction;
	
	  })();
	
	}).call(this);


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(2037).enable();
	  global.Promise = __webpack_require__(2036);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2505);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(16);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 868 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 869 */
/***/ function(module, exports) {

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	          if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }
	
	    newObj["default"] = obj;
	    return newObj;
	  }
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 870 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var AuthenticationDetails = function () {
	  /**
	   * Constructs a new AuthenticationDetails object
	   * @param {object=} data Creation options.
	   * @param {string} data.Username User being authenticated.
	   * @param {string} data.Password Plain-text password to authenticate with.
	   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
	   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
	   */
	  function AuthenticationDetails(data) {
	    _classCallCheck(this, AuthenticationDetails);
	
	    var _ref = data || {},
	        ValidationData = _ref.ValidationData,
	        Username = _ref.Username,
	        Password = _ref.Password,
	        AuthParameters = _ref.AuthParameters;
	
	    this.validationData = ValidationData || [];
	    this.authParameters = AuthParameters || [];
	    this.username = Username;
	    this.password = Password;
	  }
	
	  /**
	   * @returns {string} the record's username
	   */
	
	
	  AuthenticationDetails.prototype.getUsername = function getUsername() {
	    return this.username;
	  };
	
	  /**
	   * @returns {string} the record's password
	   */
	
	
	  AuthenticationDetails.prototype.getPassword = function getPassword() {
	    return this.password;
	  };
	
	  /**
	   * @returns {Array} the record's validationData
	   */
	
	
	  AuthenticationDetails.prototype.getValidationData = function getValidationData() {
	    return this.validationData;
	  };
	
	  /**
	   * @returns {Array} the record's authParameters
	   */
	
	
	  AuthenticationDetails.prototype.getAuthParameters = function getAuthParameters() {
	    return this.authParameters;
	  };
	
	  return AuthenticationDetails;
	}();
	
	exports.default = AuthenticationDetails;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cognitoidentityserviceprovider = __webpack_require__(874);
	
	var _cognitoidentityserviceprovider2 = _interopRequireDefault(_cognitoidentityserviceprovider);
	
	var _CognitoUser = __webpack_require__(399);
	
	var _CognitoUser2 = _interopRequireDefault(_CognitoUser);
	
	var _StorageHelper = __webpack_require__(403);
	
	var _StorageHelper2 = _interopRequireDefault(_StorageHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /*!
	                                                                                                                                                           * Copyright 2016 Amazon.com,
	                                                                                                                                                           * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                           *
	                                                                                                                                                           * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                           * You may not use this file except in compliance with the
	                                                                                                                                                           * License. A copy of the License is located at
	                                                                                                                                                           *
	                                                                                                                                                           *     http://aws.amazon.com/asl/
	                                                                                                                                                           *
	                                                                                                                                                           * or in the "license" file accompanying this file. This file is
	                                                                                                                                                           * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                           * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                           * for the specific language governing permissions and
	                                                                                                                                                           * limitations under the License.
	                                                                                                                                                           */
	
	/** @class */
	var CognitoUserPool = function () {
	  /**
	   * Constructs a new CognitoUserPool object
	   * @param {object} data Creation options.
	   * @param {string} data.UserPoolId Cognito user pool id.
	   * @param {string} data.ClientId User pool application client id.
	   * @param {object} data.Storage Optional storage object.
	   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
	   *        boolean flag indicating if the data collection is enabled
	   *        to support cognito advanced security features. By default, this
	   *        flag is set to true.
	   */
	  function CognitoUserPool(data) {
	    _classCallCheck(this, CognitoUserPool);
	
	    var _ref = data || {},
	        UserPoolId = _ref.UserPoolId,
	        ClientId = _ref.ClientId,
	        endpoint = _ref.endpoint,
	        AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;
	
	    if (!UserPoolId || !ClientId) {
	      throw new Error('Both UserPoolId and ClientId are required.');
	    }
	    if (!/^[\w-]+_.+$/.test(UserPoolId)) {
	      throw new Error('Invalid UserPoolId format.');
	    }
	    var region = UserPoolId.split('_')[0];
	
	    this.userPoolId = UserPoolId;
	    this.clientId = ClientId;
	
	    this.client = new _cognitoidentityserviceprovider2.default({
	      apiVersion: '2016-04-19',
	      region: region,
	      endpoint: endpoint
	    });
	
	    /**
	     * By default, AdvancedSecurityDataCollectionFlag is set to true,
	     * if no input value is provided.
	     */
	    this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
	
	    this.storage = data.Storage || new _StorageHelper2.default().getStorage();
	  }
	
	  /**
	   * @returns {string} the user pool id
	   */
	
	
	  CognitoUserPool.prototype.getUserPoolId = function getUserPoolId() {
	    return this.userPoolId;
	  };
	
	  /**
	   * @returns {string} the client id
	   */
	
	
	  CognitoUserPool.prototype.getClientId = function getClientId() {
	    return this.clientId;
	  };
	
	  /**
	   * @typedef {object} SignUpResult
	   * @property {CognitoUser} user New user.
	   * @property {bool} userConfirmed If the user is already confirmed.
	   */
	  /**
	   * method for signing up a user
	   * @param {string} username User's username.
	   * @param {string} password Plain-text initial password entered by user.
	   * @param {(AttributeArg[])=} userAttributes New user attributes.
	   * @param {(AttributeArg[])=} validationData Application metadata.
	   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
	   * @returns {void}
	   */
	
	
	  CognitoUserPool.prototype.signUp = function signUp(username, password, userAttributes, validationData, callback) {
	    var _this = this;
	
	    var jsonReq = {
	      ClientId: this.clientId,
	      Username: username,
	      Password: password,
	      UserAttributes: userAttributes,
	      ValidationData: validationData
	    };
	    if (this.getUserContextData(username)) {
	      jsonReq.UserContextData = this.getUserContextData(username);
	    }
	    this.client.makeUnauthenticatedRequest('signUp', jsonReq, function (err, data) {
	      if (err) {
	        return callback(err, null);
	      }
	
	      var cognitoUser = {
	        Username: username,
	        Pool: _this,
	        Storage: _this.storage
	      };
	
	      var returnData = {
	        user: new _CognitoUser2.default(cognitoUser),
	        userConfirmed: data.UserConfirmed,
	        userSub: data.UserSub
	      };
	
	      return callback(null, returnData);
	    });
	  };
	
	  /**
	   * method for getting the current user of the application from the local storage
	   *
	   * @returns {CognitoUser} the user retrieved from storage
	   */
	
	
	  CognitoUserPool.prototype.getCurrentUser = function getCurrentUser() {
	    var lastUserKey = 'CognitoIdentityServiceProvider.' + this.clientId + '.LastAuthUser';
	
	    var lastAuthUser = this.storage.getItem(lastUserKey);
	    if (lastAuthUser) {
	      var cognitoUser = {
	        Username: lastAuthUser,
	        Pool: this,
	        Storage: this.storage
	      };
	
	      return new _CognitoUser2.default(cognitoUser);
	    }
	
	    return null;
	  };
	
	  /**
	   * This method returns the encoded data string used for cognito advanced security feature.
	   * This would be generated only when developer has included the JS used for collecting the
	   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
	   * features
	   * @param {string} username the username for the context data
	   * @returns {string} the user context data
	   **/
	
	
	  CognitoUserPool.prototype.getUserContextData = function getUserContextData(username) {
	    if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') {
	      return undefined;
	    }
	    /* eslint-disable */
	    var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
	    /* eslint-enable */
	
	    if (this.advancedSecurityDataCollectionFlag) {
	      var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);
	      if (advancedSecurityData) {
	        var userContextData = {
	          EncodedData: advancedSecurityData
	        };
	        return userContextData;
	      }
	    }
	    return {};
	  };
	
	  return CognitoUserPool;
	}();
	
	exports.default = CognitoUserPool;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jsCookie = __webpack_require__(1639);
	
	var Cookies = _interopRequireWildcard(_jsCookie);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** @class */
	var CookieStorage = function () {
	
	  /**
	   * Constructs a new CookieStorage object
	   * @param {object} data Creation options.
	   * @param {string} data.domain Cookies domain (mandatory).
	   * @param {string} data.path Cookies path (default: '/')
	   * @param {integer} data.expires Cookie expiration (in days, default: 365)
	   * @param {boolean} data.secure Cookie secure flag (default: true)
	   */
	  function CookieStorage(data) {
	    _classCallCheck(this, CookieStorage);
	
	    this.domain = data.domain;
	    if (data.path) {
	      this.path = data.path;
	    } else {
	      this.path = '/';
	    }
	    if (Object.prototype.hasOwnProperty.call(data, 'expires')) {
	      this.expires = data.expires;
	    } else {
	      this.expires = 365;
	    }
	    if (Object.prototype.hasOwnProperty.call(data, 'secure')) {
	      this.secure = data.secure;
	    } else {
	      this.secure = true;
	    }
	  }
	
	  /**
	   * This is used to set a specific item in storage
	   * @param {string} key - the key for the item
	   * @param {object} value - the value
	   * @returns {string} value that was set
	   */
	
	
	  CookieStorage.prototype.setItem = function setItem(key, value) {
	    Cookies.set(key, value, {
	      path: this.path,
	      expires: this.expires,
	      domain: this.domain,
	      secure: this.secure
	    });
	    return Cookies.get(key);
	  };
	
	  /**
	   * This is used to get a specific key from storage
	   * @param {string} key - the key for the item
	   * This is used to clear the storage
	   * @returns {string} the data item
	   */
	
	
	  CookieStorage.prototype.getItem = function getItem(key) {
	    return Cookies.get(key);
	  };
	
	  /**
	   * This is used to remove an item from storage
	   * @param {string} key - the key being set
	   * @returns {string} value - value that was deleted
	   */
	
	
	  CookieStorage.prototype.removeItem = function removeItem(key) {
	    return Cookies.remove(key, {
	      path: this.path,
	      domain: this.domain,
	      secure: this.secure
	    });
	  };
	
	  /**
	   * This is used to clear the storage
	   * @returns {string} nothing
	   */
	
	
	  CookieStorage.prototype.clear = function clear() {
	    var cookies = Cookies.get();
	    var index = void 0;
	    for (index = 0; index < cookies.length; ++index) {
	      Cookies.remove(cookies[index]);
	    }
	    return {};
	  };
	
	  return CookieStorage;
	}();
	
	exports.default = CookieStorage;

/***/ },
/* 873 */
[2516, 188, 15, 890, 1640, 1641],
/* 874 */
[2517, 188, 15, 1642, 1643],
/* 875 */
/***/ function(module, exports) {

	function apiLoader(svc, version) {
	  if (!apiLoader.services.hasOwnProperty(svc)) {
	    throw new Error('InvalidService: Failed to load api for ' + svc);
	  }
	  return apiLoader.services[svc][version];
	}
	
	/**
	 * This member of AWS.apiLoader is private, but changing it will necessitate a
	 * change to ../scripts/services-table-generator.ts
	 */
	apiLoader.services = {};
	module.exports = apiLoader;


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	__webpack_require__(405);
	__webpack_require__(406);
	var PromisesDependency;
	
	/**
	 * The main configuration class used by all service objects to set
	 * the region, credentials, and other options for requests.
	 *
	 * By default, credentials and region settings are left unconfigured.
	 * This should be configured by the application before using any
	 * AWS service APIs.
	 *
	 * In order to set global configuration options, properties should
	 * be assigned to the global {AWS.config} object.
	 *
	 * @see AWS.config
	 *
	 * @!group General Configuration Options
	 *
	 * @!attribute credentials
	 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
	 *
	 * @!attribute region
	 *   @example Set the global region setting to us-west-2
	 *     AWS.config.update({region: 'us-west-2'});
	 *   @return [AWS.Credentials] The region to send service requests to.
	 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
	 *     A list of available endpoints for each AWS service
	 *
	 * @!attribute maxRetries
	 *   @return [Integer] the maximum amount of retries to perform for a
	 *     service request. By default this value is calculated by the specific
	 *     service object that the request is being made to.
	 *
	 * @!attribute maxRedirects
	 *   @return [Integer] the maximum amount of redirects to follow for a
	 *     service request. Defaults to 10.
	 *
	 * @!attribute paramValidation
	 *   @return [Boolean|map] whether input parameters should be validated against
	 *     the operation description before sending the request. Defaults to true.
	 *     Pass a map to enable any of the following specific validation features:
	 *
	 *     * **min** [Boolean] &mdash; Validates that a value meets the min
	 *       constraint. This is enabled by default when paramValidation is set
	 *       to `true`.
	 *     * **max** [Boolean] &mdash; Validates that a value meets the max
	 *       constraint.
	 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	 *       regular expression.
	 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	 *       of the allowable enum values.
	 *
	 * @!attribute computeChecksums
	 *   @return [Boolean] whether to compute checksums for payload bodies when
	 *     the service accepts it (currently supported in S3 only).
	 *
	 * @!attribute convertResponseTypes
	 *   @return [Boolean] whether types are converted when parsing response data.
	 *     Currently only supported for JSON based services. Turning this off may
	 *     improve performance on large response payloads. Defaults to `true`.
	 *
	 * @!attribute correctClockSkew
	 *   @return [Boolean] whether to apply a clock skew correction and retry
	 *     requests that fail because of an skewed client clock. Defaults to
	 *     `false`.
	 *
	 * @!attribute sslEnabled
	 *   @return [Boolean] whether SSL is enabled for requests
	 *
	 * @!attribute s3ForcePathStyle
	 *   @return [Boolean] whether to force path style URLs for S3 objects
	 *
	 * @!attribute s3BucketEndpoint
	 *   @note Setting this configuration option requires an `endpoint` to be
	 *     provided explicitly to the service constructor.
	 *   @return [Boolean] whether the provided endpoint addresses an individual
	 *     bucket (false if it addresses the root API endpoint).
	 *
	 * @!attribute s3DisableBodySigning
	 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
	 *     Body signing can only be disabled when using https. Defaults to `true`.
	 *
	 * @!attribute useAccelerateEndpoint
	 *   @note This configuration option is only compatible with S3 while accessing
	 *     dns-compatible buckets.
	 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
	 *     Defaults to `false`.
	 *
	 * @!attribute retryDelayOptions
	 *   @example Set the base retry delay for all services to 300 ms
	 *     AWS.config.update({retryDelayOptions: {base: 300}});
	 *     // Delays with maxRetries = 3: 300, 600, 1200
	 *   @example Set a custom backoff function to provide delay values on retries
	 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
	 *       // returns delay in ms
	 *     }}});
	 *   @return [map] A set of options to configure the retry delay on retryable errors.
	 *     Currently supported options are:
	 *
	 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
	 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
	 *       DynamoDB, where it defaults to 50ms.
	 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
	 *       and returns the amount of time to delay in milliseconds. The `base` option will be
	 *       ignored if this option is supplied.
	 *
	 * @!attribute httpOptions
	 *   @return [map] A set of options to pass to the low-level HTTP request.
	 *     Currently supported options are:
	 *
	 *     * **proxy** [String] &mdash; the URL to proxy requests through
	 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	 *       HTTP requests with. Used for connection pooling. Defaults to the global
	 *       agent (`http.globalAgent`) for non-SSL connections. Note that for
	 *       SSL connections, a special Agent object is used in order to enable
	 *       peer certificate verification. This feature is only supported in the
	 *       Node.js environment.
	 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	 *       failing to establish a connection with the server after
	 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
	 *       connection has been established.
	 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
	 *       milliseconds of inactivity on the socket. Defaults to two minutes
	 *       (120000)
	 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	 *       HTTP requests. Used in the browser environment only. Set to false to
	 *       send requests synchronously. Defaults to true (async on).
	 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	 *       property of an XMLHttpRequest object. Used in the browser environment
	 *       only. Defaults to false.
	 * @!attribute logger
	 *   @return [#write,#log] an object that responds to .write() (like a stream)
	 *     or .log() (like the console object) in order to log information about
	 *     requests
	 *
	 * @!attribute systemClockOffset
	 *   @return [Number] an offset value in milliseconds to apply to all signing
	 *     times. Use this to compensate for clock skew when your system may be
	 *     out of sync with the service time. Note that this configuration option
	 *     can only be applied to the global `AWS.config` object and cannot be
	 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
	 *
	 * @!attribute signatureVersion
	 *   @return [String] the signature version to sign requests with (overriding
	 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
	 *
	 * @!attribute signatureCache
	 *   @return [Boolean] whether the signature to sign requests with (overriding
	 *     the API configuration) is cached. Only applies to the signature version 'v4'.
	 *     Defaults to `true`.
	 */
	AWS.Config = AWS.util.inherit({
	  /**
	   * @!endgroup
	   */
	
	  /**
	   * Creates a new configuration object. This is the object that passes
	   * option data along to service requests, including credentials, security,
	   * region information, and some service specific settings.
	   *
	   * @example Creating a new configuration object with credentials and region
	   *   var config = new AWS.Config({
	   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
	   *   });
	   * @option options accessKeyId [String] your AWS access key ID.
	   * @option options secretAccessKey [String] your AWS secret access key.
	   * @option options sessionToken [AWS.Credentials] the optional AWS
	   *   session token to sign requests with.
	   * @option options credentials [AWS.Credentials] the AWS credentials
	   *   to sign requests with. You can either specify this object, or
	   *   specify the accessKeyId and secretAccessKey options directly.
	   * @option options credentialProvider [AWS.CredentialProviderChain] the
	   *   provider chain used to resolve credentials if no static `credentials`
	   *   property is set.
	   * @option options region [String] the region to send service requests to.
	   *   See {region} for more information.
	   * @option options maxRetries [Integer] the maximum amount of retries to
	   *   attempt with a request. See {maxRetries} for more information.
	   * @option options maxRedirects [Integer] the maximum amount of redirects to
	   *   follow with a request. See {maxRedirects} for more information.
	   * @option options sslEnabled [Boolean] whether to enable SSL for
	   *   requests.
	   * @option options paramValidation [Boolean|map] whether input parameters
	   *   should be validated against the operation description before sending
	   *   the request. Defaults to true. Pass a map to enable any of the
	   *   following specific validation features:
	   *
	   *   * **min** [Boolean] &mdash; Validates that a value meets the min
	   *     constraint. This is enabled by default when paramValidation is set
	   *     to `true`.
	   *   * **max** [Boolean] &mdash; Validates that a value meets the max
	   *     constraint.
	   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *     regular expression.
	   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *     of the allowable enum values.
	   * @option options computeChecksums [Boolean] whether to compute checksums
	   *   for payload bodies when the service accepts it (currently supported
	   *   in S3 only)
	   * @option options convertResponseTypes [Boolean] whether types are converted
	   *     when parsing response data. Currently only supported for JSON based
	   *     services. Turning this off may improve performance on large response
	   *     payloads. Defaults to `true`.
	   * @option options correctClockSkew [Boolean] whether to apply a clock skew
	   *     correction and retry requests that fail because of an skewed client
	   *     clock. Defaults to `false`.
	   * @option options s3ForcePathStyle [Boolean] whether to force path
	   *   style URLs for S3 objects.
	   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
	   *   addresses an individual bucket (false if it addresses the root API
	   *   endpoint). Note that setting this configuration option requires an
	   *   `endpoint` to be provided explicitly to the service constructor.
	   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
	   *   should be disabled when using signature version `v4`. Body signing
	   *   can only be disabled when using https. Defaults to `true`.
	   *
	   * @option options retryDelayOptions [map] A set of options to configure
	   *   the retry delay on retryable errors. Currently supported options are:
	   *
	   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
	   *     exponential backoff for operation retries. Defaults to 100 ms for all
	   *     services except DynamoDB, where it defaults to 50ms.
	   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
	   *     and returns the amount of time to delay in milliseconds. The `base` option will be
	   *     ignored if this option is supplied.
	   * @option options httpOptions [map] A set of options to pass to the low-level
	   *   HTTP request. Currently supported options are:
	   *
	   *   * **proxy** [String] &mdash; the URL to proxy requests through
	   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	   *     HTTP requests with. Used for connection pooling. Defaults to the global
	   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
	   *     SSL connections, a special Agent object is used in order to enable
	   *     peer certificate verification. This feature is only available in the
	   *     Node.js environment.
	   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	   *     failing to establish a connection with the server after
	   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
	   *     connection has been established.
	   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
	   *     milliseconds of inactivity on the socket. Defaults to two minutes
	   *     (120000).
	   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	   *     HTTP requests. Used in the browser environment only. Set to false to
	   *     send requests synchronously. Defaults to true (async on).
	   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	   *     property of an XMLHttpRequest object. Used in the browser environment
	   *     only. Defaults to false.
	   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
	   *   (or a date) that represents the latest possible API version that can be
	   *   used in all services (unless overridden by `apiVersions`). Specify
	   *   'latest' to use the latest possible version.
	   * @option options apiVersions [map<String, String|Date>] a map of service
	   *   identifiers (the lowercase service class name) with the API version to
	   *   use when instantiating a service. Specify 'latest' for each individual
	   *   that can use the latest available version.
	   * @option options logger [#write,#log] an object that responds to .write()
	   *   (like a stream) or .log() (like the console object) in order to log
	   *   information about requests
	   * @option options systemClockOffset [Number] an offset value in milliseconds
	   *   to apply to all signing times. Use this to compensate for clock skew
	   *   when your system may be out of sync with the service time. Note that
	   *   this configuration option can only be applied to the global `AWS.config`
	   *   object and cannot be overridden in service-specific configuration.
	   *   Defaults to 0 milliseconds.
	   * @option options signatureVersion [String] the signature version to sign
	   *   requests with (overriding the API configuration). Possible values are:
	   *   'v2', 'v3', 'v4'.
	   * @option options signatureCache [Boolean] whether the signature to sign
	   *   requests with (overriding the API configuration) is cached. Only applies
	   *   to the signature version 'v4'. Defaults to `true`.
	   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
	   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
	   */
	  constructor: function Config(options) {
	    if (options === undefined) options = {};
	    options = this.extractCredentials(options);
	
	    AWS.util.each.call(this, this.keys, function (key, value) {
	      this.set(key, options[key], value);
	    });
	  },
	
	  /**
	   * @!group Managing Credentials
	   */
	
	  /**
	   * Loads credentials from the configuration object. This is used internally
	   * by the SDK to ensure that refreshable {Credentials} objects are properly
	   * refreshed and loaded when sending a request. If you want to ensure that
	   * your credentials are loaded prior to a request, you can use this method
	   * directly to provide accurate credential data stored in the object.
	   *
	   * @note If you configure the SDK with static or environment credentials,
	   *   the credential data should already be present in {credentials} attribute.
	   *   This method is primarily necessary to load credentials from asynchronous
	   *   sources, or sources that can refresh credentials periodically.
	   * @example Getting your access key
	   *   AWS.config.getCredentials(function(err) {
	   *     if (err) console.log(err.stack); // credentials not loaded
	   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
	   *   })
	   * @callback callback function(err)
	   *   Called when the {credentials} have been properly set on the configuration
	   *   object.
	   *
	   *   @param err [Error] if this is set, credentials were not successfully
	   *     loaded and this error provides information why.
	   * @see credentials
	   * @see Credentials
	   */
	  getCredentials: function getCredentials(callback) {
	    var self = this;
	
	    function finish(err) {
	      callback(err, err ? null : self.credentials);
	    }
	
	    function credError(msg, err) {
	      return new AWS.util.error(err || new Error(), {
	        code: 'CredentialsError',
	        message: msg,
	        name: 'CredentialsError'
	      });
	    }
	
	    function getAsyncCredentials() {
	      self.credentials.get(function(err) {
	        if (err) {
	          var msg = 'Could not load credentials from ' +
	            self.credentials.constructor.name;
	          err = credError(msg, err);
	        }
	        finish(err);
	      });
	    }
	
	    function getStaticCredentials() {
	      var err = null;
	      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
	        err = credError('Missing credentials');
	      }
	      finish(err);
	    }
	
	    if (self.credentials) {
	      if (typeof self.credentials.get === 'function') {
	        getAsyncCredentials();
	      } else { // static credentials
	        getStaticCredentials();
	      }
	    } else if (self.credentialProvider) {
	      self.credentialProvider.resolve(function(err, creds) {
	        if (err) {
	          err = credError('Could not load credentials from any providers', err);
	        }
	        self.credentials = creds;
	        finish(err);
	      });
	    } else {
	      finish(credError('No credentials to load'));
	    }
	  },
	
	  /**
	   * @!group Loading and Setting Configuration Options
	   */
	
	  /**
	   * @overload update(options, allowUnknownKeys = false)
	   *   Updates the current configuration object with new options.
	   *
	   *   @example Update maxRetries property of a configuration object
	   *     config.update({maxRetries: 10});
	   *   @param [Object] options a map of option keys and values.
	   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
	   *     the configuration object. Defaults to `false`.
	   *   @see constructor
	   */
	  update: function update(options, allowUnknownKeys) {
	    allowUnknownKeys = allowUnknownKeys || false;
	    options = this.extractCredentials(options);
	    AWS.util.each.call(this, options, function (key, value) {
	      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
	          AWS.Service.hasService(key)) {
	        this.set(key, value);
	      }
	    });
	  },
	
	  /**
	   * Loads configuration data from a JSON file into this config object.
	   * @note Loading configuration will reset all existing configuration
	   *   on the object.
	   * @!macro nobrowser
	   * @param path [String] the path relative to your process's current
	   *    working directory to load configuration from.
	   * @return [AWS.Config] the same configuration object
	   */
	  loadFromPath: function loadFromPath(path) {
	    this.clear();
	
	    var options = JSON.parse(AWS.util.readFileSync(path));
	    var fileSystemCreds = new AWS.FileSystemCredentials(path);
	    var chain = new AWS.CredentialProviderChain();
	    chain.providers.unshift(fileSystemCreds);
	    chain.resolve(function (err, creds) {
	      if (err) throw err;
	      else options.credentials = creds;
	    });
	
	    this.constructor(options);
	
	    return this;
	  },
	
	  /**
	   * Clears configuration data on this object
	   *
	   * @api private
	   */
	  clear: function clear() {
	    /*jshint forin:false */
	    AWS.util.each.call(this, this.keys, function (key) {
	      delete this[key];
	    });
	
	    // reset credential provider
	    this.set('credentials', undefined);
	    this.set('credentialProvider', undefined);
	  },
	
	  /**
	   * Sets a property on the configuration object, allowing for a
	   * default value
	   * @api private
	   */
	  set: function set(property, value, defaultValue) {
	    if (value === undefined) {
	      if (defaultValue === undefined) {
	        defaultValue = this.keys[property];
	      }
	      if (typeof defaultValue === 'function') {
	        this[property] = defaultValue.call(this);
	      } else {
	        this[property] = defaultValue;
	      }
	    } else if (property === 'httpOptions' && this[property]) {
	      // deep merge httpOptions
	      this[property] = AWS.util.merge(this[property], value);
	    } else {
	      this[property] = value;
	    }
	  },
	
	  /**
	   * All of the keys with their default values.
	   *
	   * @constant
	   * @api private
	   */
	  keys: {
	    credentials: null,
	    credentialProvider: null,
	    region: null,
	    logger: null,
	    apiVersions: {},
	    apiVersion: null,
	    endpoint: undefined,
	    httpOptions: {
	      timeout: 120000
	    },
	    maxRetries: undefined,
	    maxRedirects: 10,
	    paramValidation: true,
	    sslEnabled: true,
	    s3ForcePathStyle: false,
	    s3BucketEndpoint: false,
	    s3DisableBodySigning: true,
	    computeChecksums: true,
	    convertResponseTypes: true,
	    correctClockSkew: false,
	    customUserAgent: null,
	    dynamoDbCrc32: true,
	    systemClockOffset: 0,
	    signatureVersion: null,
	    signatureCache: true,
	    retryDelayOptions: {},
	    useAccelerateEndpoint: false
	  },
	
	  /**
	   * Extracts accessKeyId, secretAccessKey and sessionToken
	   * from a configuration hash.
	   *
	   * @api private
	   */
	  extractCredentials: function extractCredentials(options) {
	    if (options.accessKeyId && options.secretAccessKey) {
	      options = AWS.util.copy(options);
	      options.credentials = new AWS.Credentials(options);
	    }
	    return options;
	  },
	
	  /**
	   * Sets the promise dependency the SDK will use wherever Promises are returned.
	   * Passing `null` will force the SDK to use native Promises if they are available.
	   * If native Promises are not available, passing `null` will have no effect.
	   * @param [Constructor] dep A reference to a Promise constructor
	   */
	  setPromisesDependency: function setPromisesDependency(dep) {
	    PromisesDependency = dep;
	    // if null was passed in, we should try to use native promises
	    if (dep === null && typeof Promise === 'function') {
	      PromisesDependency = Promise;
	    }
	    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
	    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
	    AWS.util.addPromises(constructors, PromisesDependency);
	  },
	
	  /**
	   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
	   */
	  getPromisesDependency: function getPromisesDependency() {
	    return PromisesDependency;
	  }
	});
	
	/**
	 * @return [AWS.Config] The global configuration object singleton instance
	 * @readonly
	 * @see AWS.Config
	 */
	AWS.config = new AWS.Config();


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var CognitoIdentity = __webpack_require__(873);
	var STS = __webpack_require__(187);
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation using
	 * the Amazon Cognito Identity service.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
	 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
	 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
	 * obtain an `IdentityId`. If the identity or identity pool is not configured in
	 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
	 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
	 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
	 * is provided, then this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
	 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
	 *
	 * In addition, if this credential provider is used to provide authenticated
	 * login, the `Logins` map may be set to the tokens provided by the respective
	 * identity providers. See {constructor} for an example on creating a credentials
	 * object with proper property values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.CognitoIdentity.getId},
	 *     {AWS.CognitoIdentity.getOpenIdToken}, and
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 * @!attribute identityId
	 *   @return [String] the Cognito ID returned by the last call to
	 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
	 *     final resolved identity ID from Amazon Cognito.
	 */
	AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * @api private
	   */
	  localStorageKey: {
	    id: 'aws.cognito.identity-id.',
	    providers: 'aws.cognito.identity-providers.'
	  },
	
	  /**
	   * Creates a new credentials object.
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
	   *
	   *     // either IdentityPoolId or IdentityId is required
	   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
	   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
	   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
	   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
	   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
	   *
	   *     // optional, only necessary when the identity pool is not configured
	   *     // to use IAM roles in the Amazon Cognito Console
	   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
	   *
	   *     // optional tokens, used for authenticated login
	   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
	   *     Logins: {
	   *       'graph.facebook.com': 'FBTOKEN',
	   *       'www.amazon.com': 'AMAZONTOKEN',
	   *       'accounts.google.com': 'GOOGLETOKEN',
	   *       'api.twitter.com': 'TWITTERTOKEN',
	   *       'www.digits.com': 'DIGITSTOKEN'
	   *     },
	   *
	   *     // optional name, defaults to web-identity
	   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleSessionName: 'web',
	   *
	   *     // optional, only necessary when application runs in a browser
	   *     // and multiple users are signed in at once, used for caching
	   *     LoginId: 'example@gmail.com'
	   *
	   *   }, {
	   *      // optionally provide configuration to apply to the underlying service clients
	   *      // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *      // region should match the region your identity pool is located in
	   *      region: 'us-east-1',
	   *
	   *      // specify timeout options
	   *      httpOptions: {
	   *        timeout: 100
	   *      }
	   *   });
	   * @see AWS.CognitoIdentity.getId
	   * @see AWS.CognitoIdentity.getCredentialsForIdentity
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.CognitoIdentity.getOpenIdToken
	   * @see AWS.Config
	   * @note If a region is not provided in the global AWS.config, or
	   *   specified in the `clientConfig` to the CognitoIdentityCredentials
	   *   constructor, you may encounter a 'Missing credentials in config' error
	   *   when calling making a service call.
	   */
	  constructor: function CognitoIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.data = null;
	    this._identityId = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	    this.loadCachedId();
	    var self = this;
	    Object.defineProperty(this, 'identityId', {
	      get: function() {
	        self.loadCachedId();
	        return self._identityId || self.params.IdentityId;
	      },
	      set: function(identityId) {
	        self._identityId = identityId;
	      }
	    });
	  },
	
	  /**
	   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
	   * or {AWS.STS.assumeRoleWithWebIdentity}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    var self = this;
	    self.createClients();
	    self.data = null;
	    self._identityId = null;
	    self.getId(function(err) {
	      if (!err) {
	        if (!self.params.RoleArn) {
	          self.getCredentialsForIdentity(callback);
	        } else {
	          self.getCredentialsFromSTS(callback);
	        }
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * Clears the cached Cognito ID associated with the currently configured
	   * identity pool ID. Use this to manually invalidate your cache if
	   * the identity pool ID was deleted.
	   */
	  clearCachedId: function clearCache() {
	    this._identityId = null;
	    delete this.params.IdentityId;
	
	    var poolId = this.params.IdentityPoolId;
	    var loginId = this.params.LoginId || '';
	    delete this.storage[this.localStorageKey.id + poolId + loginId];
	    delete this.storage[this.localStorageKey.providers + poolId + loginId];
	  },
	
	  /**
	   * @api private
	   */
	  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
	    var self = this;
	    if (err.code == 'NotAuthorizedException') {
	      self.clearCachedId();
	    }
	  },
	
	  /**
	   * Retrieves a Cognito ID, loading from cache if it was already retrieved
	   * on this device.
	   *
	   * @callback callback function(err, identityId)
	   *   @param err [Error, null] an error object if the call failed or null if
	   *     it succeeded.
	   *   @param identityId [String, null] if successful, the callback will return
	   *     the Cognito ID.
	   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
	   *   localStorage in the browser environment of a device.
	   * @api private
	   */
	  getId: function getId(callback) {
	    var self = this;
	    if (typeof self.params.IdentityId === 'string') {
	      return callback(null, self.params.IdentityId);
	    }
	
	    self.cognito.getId(function(err, data) {
	      if (!err && data.IdentityId) {
	        self.params.IdentityId = data.IdentityId;
	        callback(null, data.IdentityId);
	      } else {
	        callback(err);
	      }
	    });
	  },
	
	
	  /**
	   * @api private
	   */
	  loadCredentials: function loadCredentials(data, credentials) {
	    if (!data || !credentials) return;
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
	    var self = this;
	    self.cognito.getCredentialsForIdentity(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.data = data;
	        self.loadCredentials(self.data, self);
	      } else {
	        self.clearIdOnNotAuthorized(err);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
	    var self = this;
	    self.cognito.getOpenIdToken(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.params.WebIdentityToken = data.Token;
	        self.webIdentityCredentials.refresh(function(webErr) {
	          if (!webErr) {
	            self.data = self.webIdentityCredentials.data;
	            self.sts.credentialsFrom(self.data, self);
	          }
	          callback(webErr);
	        });
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadCachedId: function loadCachedId() {
	    var self = this;
	
	    // in the browser we source default IdentityId from localStorage
	    if (AWS.util.isBrowser() && !self.params.IdentityId) {
	      var id = self.getStorage('id');
	      if (id && self.params.Logins) {
	        var actualProviders = Object.keys(self.params.Logins);
	        var cachedProviders =
	          (self.getStorage('providers') || '').split(',');
	
	        // only load ID if at least one provider used this ID before
	        var intersect = cachedProviders.filter(function(n) {
	          return actualProviders.indexOf(n) !== -1;
	        });
	        if (intersect.length !== 0) {
	          self.params.IdentityId = id;
	        }
	      } else if (id) {
	        self.params.IdentityId = id;
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    var clientConfig = this._clientConfig;
	    this.webIdentityCredentials = this.webIdentityCredentials ||
	      new AWS.WebIdentityCredentials(this.params, clientConfig);
	    if (!this.cognito) {
	      var cognitoConfig = AWS.util.merge({}, clientConfig);
	      cognitoConfig.params = this.params;
	      this.cognito = new CognitoIdentity(cognitoConfig);
	    }
	    this.sts = this.sts || new STS(clientConfig);
	  },
	
	  /**
	   * @api private
	   */
	  cacheId: function cacheId(data) {
	    this._identityId = data.IdentityId;
	    this.params.IdentityId = this._identityId;
	
	    // cache this IdentityId in browser localStorage if possible
	    if (AWS.util.isBrowser()) {
	      this.setStorage('id', data.IdentityId);
	
	      if (this.params.Logins) {
	        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getStorage: function getStorage(key) {
	    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
	  },
	
	  /**
	   * @api private
	   */
	  setStorage: function setStorage(key, val) {
	    try {
	      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
	    } catch (_) {}
	  },
	
	  /**
	   * @api private
	   */
	  storage: (function() {
	    try {
	      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
	          window.localStorage : {};
	
	      // Test set/remove which would throw an error in Safari's private browsing
	      storage['aws.test-storage'] = 'foobar';
	      delete storage['aws.test-storage'];
	
	      return storage;
	    } catch (_) {
	      return {};
	    }
	  })()
	});


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var STS = __webpack_require__(187);
	
	/**
	 * Represents credentials retrieved from STS SAML support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given, as well as a `PrincipalArn`
	 * representing the ARN for the SAML identity provider. In addition, the
	 * `SAMLAssertion` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the SAMLAssertion, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
	 *     `params.SAMLAssertion` property.
	 */
	AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithSAML)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.SAMLCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
	   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
	   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
	   *   });
	   * @see AWS.STS.assumeRoleWithSAML
	   */
	  constructor: function SAMLCredentials(params) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    var self = this;
	    self.createClients();
	    if (!callback) callback = function(err) { if (err) throw err; };
	
	    self.service.assumeRoleWithSAML(function (err, data) {
	      if (!err) {
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var STS = __webpack_require__(187);
	
	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * To setup temporary credentials, configure a set of master credentials
	 * using the standard credentials providers (environment, EC2 instance metadata,
	 * or from the filesystem), then set the global credentials to a new
	 * temporary credentials object:
	 *
	 * ```javascript
	 * // Note that environment credentials are loaded by default,
	 * // the following line is shown for clarity:
	 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
	 *
	 * // Now set temporary credentials seeded from the master credentials
	 * AWS.config.credentials = new AWS.TemporaryCredentials();
	 *
	 * // subsequent requests will now use temporary credentials from AWS STS.
	 * new AWS.S3().listBucket(function(err, data) { ... });
	 * ```
	 *
	 * @!attribute masterCredentials
	 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @note In order to create temporary credentials, you first need to have
	   *   "master" credentials configured in {AWS.Config.credentials}. These
	   *   master credentials are necessary to retrieve the temporary credentials,
	   *   as well as refresh the credentials when they expire.
	   * @param params [map] a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role.
	   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
	   *  used to get and refresh temporary credentials from AWS STS.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.TemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.TemporaryCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function TemporaryCredentials(params, masterCredentials) {
	    AWS.Credentials.call(this);
	    this.loadMasterCredentials(masterCredentials);
	    this.expired = true;
	
	    this.params = params || {};
	    if (this.params.RoleArn) {
	      this.params.RoleSessionName =
	        this.params.RoleSessionName || 'temporary-credentials';
	    }
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    var self = this;
	    self.createClients();
	    if (!callback) callback = function(err) { if (err) throw err; };
	
	    self.masterCredentials.get(function() {
	      self.service.config.credentials = self.masterCredentials;
	      var operation = self.params.RoleArn ?
	        self.service.assumeRole : self.service.getSessionToken;
	      operation.call(self.service, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadMasterCredentials: function loadMasterCredentials(masterCredentials) {
	    this.masterCredentials = masterCredentials || AWS.config.credentials;
	    while (this.masterCredentials.masterCredentials) {
	      this.masterCredentials = this.masterCredentials.masterCredentials;
	    }
	
	    if (typeof this.masterCredentials.get !== 'function') {
	      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var STS = __webpack_require__(187);
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given. In addition, the
	 * `WebIdentityToken` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn` and `WebIdentityToken` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 */
	AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithWebIdentity)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
	   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
	   *     RoleSessionName: 'web' // optional name, defaults to web-identity
	   *   }, {
	   *     // optionally provide configuration to apply to the underlying AWS.STS service client
	   *     // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *     // specify timeout options
	   *     httpOptions: {
	   *       timeout: 100
	   *     }
	   *   });
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.Config
	   */
	  constructor: function WebIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
	    this.data = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    var self = this;
	    self.createClients();
	    if (!callback) callback = function(err) { if (err) throw err; };
	
	    self.service.assumeRoleWithWebIdentity(function (err, data) {
	      self.data = null;
	      if (!err) {
	        self.data = data;
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    if (!this.service) {
	      var stsConfig = AWS.util.merge({}, this._clientConfig);
	      stsConfig.params = this.params;
	      this.service = new STS(stsConfig);
	    }
	  }
	
	});


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var SequentialExecutor = __webpack_require__(416);
	/**
	 * The namespace used to register global event listeners for request building
	 * and sending.
	 */
	AWS.EventListeners = {
	  /**
	   * @!attribute VALIDATE_CREDENTIALS
	   *   A request listener that validates whether the request is being
	   *   sent with credentials.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating credentials
	   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_REGION
	   *   A request listener that validates whether the region is set
	   *   for a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating region configuration
	   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_PARAMETERS
	   *   A request listener that validates input parameters in a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating parameters
	   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
	   *     request.removeListener('validate', listener);
	   *   @example Disable parameter validation globally
	   *     AWS.EventListeners.Core.removeListener('validate',
	   *       AWS.EventListeners.Core.VALIDATE_REGION);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute SEND
	   *   A request listener that initiates the HTTP connection for a
	   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
	   *   @example Replacing the HTTP handler
	   *     var listener = AWS.EventListeners.Core.SEND;
	   *     request.removeListener('send', listener);
	   *     request.on('send', function(response) {
	   *       customHandler.send(response);
	   *     });
	   *   @return [Function]
	   *   @readonly
	   * @!attribute HTTP_DATA
	   *   A request listener that reads data from the HTTP connection in order
	   *   to build the response data.
	   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
	   *   Remove this handler if you are overriding the 'httpData' event and
	   *   do not want extra data processing and buffering overhead.
	   *   @example Disabling default data processing
	   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
	   *     request.removeListener('httpData', listener);
	   *   @return [Function]
	   *   @readonly
	   */
	  Core: {} /* doc hack */
	};
	
	/**
	 * @api private
	 */
	function getOperationAuthtype(req) {
	  if (!req.service.api.operations) {
	    return '';
	  }
	  var operation = req.service.api.operations[req.operation];
	  return operation ? operation.authtype : '';
	}
	
	AWS.EventListeners = {
	  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
	    addAsync('VALIDATE_CREDENTIALS', 'validate',
	        function VALIDATE_CREDENTIALS(req, done) {
	      if (!req.service.api.signatureVersion) return done(); // none
	      req.service.config.getCredentials(function(err) {
	        if (err) {
	          req.response.error = AWS.util.error(err,
	            {code: 'CredentialsError', message: 'Missing credentials in config'});
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
	      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
	        req.response.error = AWS.util.error(new Error(),
	          {code: 'ConfigError', message: 'Missing region in config'});
	      }
	    });
	
	    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      if (!operation) {
	        return;
	      }
	      var idempotentMembers = operation.idempotentMembers;
	      if (!idempotentMembers.length) {
	        return;
	      }
	      // creates a copy of params so user's param object isn't mutated
	      var params = AWS.util.copy(req.params);
	      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
	        if (!params[idempotentMembers[i]]) {
	          // add the member
	          params[idempotentMembers[i]] = AWS.util.uuid.v4();
	        }
	      }
	      req.params = params;
	    });
	
	    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var rules = req.service.api.operations[req.operation].input;
	      var validation = req.service.config.paramValidation;
	      new AWS.ParamValidator(validation).validate(rules, req.params);
	    });
	
	    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
	      req.haltHandlersOnError();
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!req.service.api.signatureVersion && !authtype) return done(); // none
	      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	        var body = req.httpRequest.body || '';
	        if (authtype.indexOf('unsigned-body') >= 0) {
	          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	          return done();
	        }
	        AWS.util.computeSha256(body, function(err, sha) {
	          if (err) {
	            done(err);
	          }
	          else {
	            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
	            done();
	          }
	        });
	      } else {
	        done();
	      }
	    });
	
	    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
	      var authtype = getOperationAuthtype(req);
	      if (req.httpRequest.headers['Content-Length'] === undefined
	          && authtype.indexOf('unsigned-body') === -1) {
	        var length = AWS.util.string.byteLength(req.httpRequest.body);
	        req.httpRequest.headers['Content-Length'] = length;
	      }
	    });
	
	    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
	      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
	    });
	
	    add('RESTART', 'restart', function RESTART() {
	      var err = this.response.error;
	      if (!err || !err.retryable) return;
	
	      this.httpRequest = new AWS.HttpRequest(
	        this.service.endpoint,
	        this.service.region
	      );
	
	      if (this.response.retryCount < this.service.config.maxRetries) {
	        this.response.retryCount++;
	      } else {
	        this.response.error = null;
	      }
	    });
	
	    addAsync('SIGN', 'sign', function SIGN(req, done) {
	      var service = req.service;
	      var operations = req.service.api.operations || {};
	      var operation = operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!service.api.signatureVersion && !authtype) return done(); // none
	
	      service.config.getCredentials(function (err, credentials) {
	        if (err) {
	          req.response.error = err;
	          return done();
	        }
	
	        try {
	          var date = service.getSkewCorrectedDate();
	          var SignerClass = service.getSignerClass(req);
	          var signer = new SignerClass(req.httpRequest,
	            service.api.signingName || service.api.endpointPrefix,
	            {
	              signatureCache: service.config.signatureCache,
	              operation: operation
	            });
	          signer.setServiceClientId(service._clientId);
	
	          // clear old authorization headers
	          delete req.httpRequest.headers['Authorization'];
	          delete req.httpRequest.headers['Date'];
	          delete req.httpRequest.headers['X-Amz-Date'];
	
	          // add new authorization
	          signer.addAuthorization(credentials, date);
	          req.signedAt = date;
	        } catch (e) {
	          req.response.error = e;
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
	      if (this.service.successfulResponse(resp, this)) {
	        resp.data = {};
	        resp.error = null;
	      } else {
	        resp.data = null;
	        resp.error = AWS.util.error(new Error(),
	          {code: 'UnknownError', message: 'An unknown error occurred.'});
	      }
	    });
	
	    addAsync('SEND', 'send', function SEND(resp, done) {
	      resp.httpResponse._abortCallback = done;
	      resp.error = null;
	      resp.data = null;
	
	      function callback(httpResp) {
	        resp.httpResponse.stream = httpResp;
	        var stream = resp.request.httpRequest.stream;
	
	        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
	          resp.request.emit(
	            'httpHeaders',
	            [statusCode, headers, resp, statusMessage]
	          );
	
	          if (!resp.httpResponse.streaming) {
	            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
	              httpResp.on('readable', function onReadable() {
	                var data = httpResp.read();
	                if (data !== null) {
	                  resp.request.emit('httpData', [data, resp]);
	                }
	              });
	            } else { // legacy streams API
	              httpResp.on('data', function onData(data) {
	                resp.request.emit('httpData', [data, resp]);
	              });
	            }
	          }
	        });
	
	        httpResp.on('end', function onEnd() {
	          if (!stream || !stream.didCallback) {
	            resp.request.emit('httpDone');
	            done();
	          }
	        });
	      }
	
	      function progress(httpResp) {
	        httpResp.on('sendProgress', function onSendProgress(value) {
	          resp.request.emit('httpUploadProgress', [value, resp]);
	        });
	
	        httpResp.on('receiveProgress', function onReceiveProgress(value) {
	          resp.request.emit('httpDownloadProgress', [value, resp]);
	        });
	      }
	
	      function error(err) {
	        if (err.code !== 'RequestAbortedError') {
	          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
	          err = AWS.util.error(err, {
	            code: errCode,
	            region: resp.request.httpRequest.region,
	            hostname: resp.request.httpRequest.endpoint.hostname,
	            retryable: true
	          });
	        }
	        resp.error = err;
	        resp.request.emit('httpError', [resp.error, resp], function() {
	          done();
	        });
	      }
	
	      function executeSend() {
	        var http = AWS.HttpClient.getInstance();
	        var httpOptions = resp.request.service.config.httpOptions || {};
	        try {
	          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
	                                          callback, error);
	          progress(stream);
	        } catch (err) {
	          error(err);
	        }
	      }
	      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
	      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
	        this.emit('sign', [this], function(err) {
	          if (err) done(err);
	          else executeSend();
	        });
	      } else {
	        executeSend();
	      }
	    });
	
	    add('HTTP_HEADERS', 'httpHeaders',
	        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
	      resp.httpResponse.statusCode = statusCode;
	      resp.httpResponse.statusMessage = statusMessage;
	      resp.httpResponse.headers = headers;
	      resp.httpResponse.body = new AWS.util.Buffer('');
	      resp.httpResponse.buffers = [];
	      resp.httpResponse.numBytes = 0;
	      var dateHeader = headers.date || headers.Date;
	      var service = resp.request.service;
	      if (dateHeader) {
	        var serverTime = Date.parse(dateHeader);
	        if (service.config.correctClockSkew
	            && service.isClockSkewed(serverTime)) {
	          service.applyClockOffset(serverTime);
	        }
	      }
	    });
	
	    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
	      if (chunk) {
	        if (AWS.util.isNode()) {
	          resp.httpResponse.numBytes += chunk.length;
	
	          var total = resp.httpResponse.headers['content-length'];
	          var progress = { loaded: resp.httpResponse.numBytes, total: total };
	          resp.request.emit('httpDownloadProgress', [progress, resp]);
	        }
	
	        resp.httpResponse.buffers.push(new AWS.util.Buffer(chunk));
	      }
	    });
	
	    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
	      // convert buffers array into single buffer
	      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
	        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
	        resp.httpResponse.body = body;
	      }
	      delete resp.httpResponse.numBytes;
	      delete resp.httpResponse.buffers;
	    });
	
	    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
	      if (resp.httpResponse.statusCode) {
	        resp.error.statusCode = resp.httpResponse.statusCode;
	        if (resp.error.retryable === undefined) {
	          resp.error.retryable = this.service.retryableError(resp.error, this);
	        }
	      }
	    });
	
	    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
	      if (!resp.error) return;
	      switch (resp.error.code) {
	        case 'RequestExpired': // EC2 only
	        case 'ExpiredTokenException':
	        case 'ExpiredToken':
	          resp.error.retryable = true;
	          resp.request.service.config.credentials.expired = true;
	      }
	    });
	
	    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
	      var err = resp.error;
	      if (!err) return;
	      if (typeof err.code === 'string' && typeof err.message === 'string') {
	        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
	          resp.error.retryable = true;
	        }
	      }
	    });
	
	    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
	      if (!resp.error) return;
	      if (this.service.clockSkewError(resp.error)
	          && this.service.config.correctClockSkew) {
	        resp.error.retryable = true;
	      }
	    });
	
	    add('REDIRECT', 'retry', function REDIRECT(resp) {
	      if (resp.error && resp.error.statusCode >= 300 &&
	          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
	        this.httpRequest.endpoint =
	          new AWS.Endpoint(resp.httpResponse.headers['location']);
	        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
	        resp.error.redirect = true;
	        resp.error.retryable = true;
	      }
	    });
	
	    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
	      if (resp.error) {
	        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.error.retryDelay = 0;
	        } else if (resp.retryCount < resp.maxRetries) {
	          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
	        }
	      }
	    });
	
	    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
	      var delay, willRetry = false;
	
	      if (resp.error) {
	        delay = resp.error.retryDelay || 0;
	        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
	          resp.retryCount++;
	          willRetry = true;
	        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.redirectCount++;
	          willRetry = true;
	        }
	      }
	
	      if (willRetry) {
	        resp.error = null;
	        setTimeout(done, delay);
	      } else {
	        done();
	      }
	    });
	  }),
	
	  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
	    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
	    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);
	
	    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
	      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
	        var message = 'Inaccessible host: `' + err.hostname +
	          '\'. This service may not be available in the `' + err.region +
	          '\' region.';
	        this.response.error = AWS.util.error(new Error(message), {
	          code: 'UnknownEndpoint',
	          region: err.region,
	          hostname: err.hostname,
	          retryable: true,
	          originalError: err
	        });
	      }
	    });
	  }),
	
	  Logger: new SequentialExecutor().addNamedListeners(function(add) {
	    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
	      var req = resp.request;
	      var logger = req.service.config.logger;
	      if (!logger) return;
	      function filterSensitiveLog(inputShape, shape) {
	        if (!shape) {
	          return shape;
	        }
	        switch (inputShape.type) {
	          case 'structure':
	            var struct = {};
	            AWS.util.each(shape, function(subShapeName, subShape) {
	              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
	                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
	              } else {
	                struct[subShapeName] = subShape;
	              }
	            })
	            return struct
	          case 'list':
	            var list = [];
	            AWS.util.arrayEach(shape, function(subShape, index) {
	              list.push(filterSensitiveLog(inputShape.member, subShape));
	            })
	            return list;
	          case 'map':
	            var map = {};
	            AWS.util.each(shape, function(key, value) {
	              map[key] = filterSensitiveLog(inputShape.value, value);
	            })
	            return map;
	          default:
	            if (inputShape.isSensitive) {
	              return '***SensitiveInformation***'
	            } else {
	              return shape;
	            }
	        }
	      }
	
	      function buildMessage() {
	        var time = resp.request.service.getSkewCorrectedDate().getTime();
	        var delta = (time - req.startTime.getTime()) / 1000;
	        var ansi = logger.isTTY ? true : false;
	        var status = resp.httpResponse.statusCode;
	        var censoredParams = req.params;
	        if (
	          req.service.api.operations &&
	              req.service.api.operations[req.operation] &&
	              req.service.api.operations[req.operation].input
	        ) {
	          var inputShape = req.service.api.operations[req.operation].input;
	          censoredParams = filterSensitiveLog(inputShape, req.params);
	        }
	        var params = __webpack_require__(860).inspect(censoredParams, true, null);
	        var message = '';
	        if (ansi) message += '\x1B[33m';
	        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
	        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
	        if (ansi) message += '\x1B[0;1m';
	        message += ' ' + AWS.util.string.lowerFirst(req.operation);
	        message += '(' + params + ')';
	        if (ansi) message += '\x1B[0m';
	        return message;
	      }
	
	      var line = buildMessage();
	      if (typeof logger.log === 'function') {
	        logger.log(line);
	      } else if (typeof logger.write === 'function') {
	        logger.write(line + '\n');
	      }
	    });
	  }),
	
	  Json: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(272);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Rest: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(189);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(414);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(415);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Query: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(413);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  })
	};


/***/ },
/* 882 */
[2519, 15, 407],
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	
	/**
	 * @api private
	 */
	AWS.ParamValidator = AWS.util.inherit({
	  /**
	   * Create a new validator object.
	   *
	   * @param validation [Boolean|map] whether input parameters should be
	   *     validated against the operation description before sending the
	   *     request. Pass a map to enable any of the following specific
	   *     validation features:
	   *
	   *     * **min** [Boolean] &mdash; Validates that a value meets the min
	   *       constraint. This is enabled by default when paramValidation is set
	   *       to `true`.
	   *     * **max** [Boolean] &mdash; Validates that a value meets the max
	   *       constraint.
	   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *       regular expression.
	   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *       of the allowable enum values.
	   */
	  constructor: function ParamValidator(validation) {
	    if (validation === true || validation === undefined) {
	      validation = {'min': true};
	    }
	    this.validation = validation;
	  },
	
	  validate: function validate(shape, params, context) {
	    this.errors = [];
	    this.validateMember(shape, params || {}, context || 'params');
	
	    if (this.errors.length > 1) {
	      var msg = this.errors.join('\n* ');
	      msg = 'There were ' + this.errors.length +
	        ' validation errors:\n* ' + msg;
	      throw AWS.util.error(new Error(msg),
	        {code: 'MultipleValidationErrors', errors: this.errors});
	    } else if (this.errors.length === 1) {
	      throw this.errors[0];
	    } else {
	      return true;
	    }
	  },
	
	  fail: function fail(code, message) {
	    this.errors.push(AWS.util.error(new Error(message), {code: code}));
	  },
	
	  validateStructure: function validateStructure(shape, params, context) {
	    this.validateType(params, context, ['object'], 'structure');
	
	    var paramName;
	    for (var i = 0; shape.required && i < shape.required.length; i++) {
	      paramName = shape.required[i];
	      var value = params[paramName];
	      if (value === undefined || value === null) {
	        this.fail('MissingRequiredParameter',
	          'Missing required key \'' + paramName + '\' in ' + context);
	      }
	    }
	
	    // validate hash members
	    for (paramName in params) {
	      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;
	
	      var paramValue = params[paramName],
	          memberShape = shape.members[paramName];
	
	      if (memberShape !== undefined) {
	        var memberContext = [context, paramName].join('.');
	        this.validateMember(memberShape, paramValue, memberContext);
	      } else {
	        this.fail('UnexpectedParameter',
	          'Unexpected key \'' + paramName + '\' found in ' + context);
	      }
	    }
	
	    return true;
	  },
	
	  validateMember: function validateMember(shape, param, context) {
	    switch (shape.type) {
	      case 'structure':
	        return this.validateStructure(shape, param, context);
	      case 'list':
	        return this.validateList(shape, param, context);
	      case 'map':
	        return this.validateMap(shape, param, context);
	      default:
	        return this.validateScalar(shape, param, context);
	    }
	  },
	
	  validateList: function validateList(shape, params, context) {
	    if (this.validateType(params, context, [Array])) {
	      this.validateRange(shape, params.length, context, 'list member count');
	      // validate array members
	      for (var i = 0; i < params.length; i++) {
	        this.validateMember(shape.member, params[i], context + '[' + i + ']');
	      }
	    }
	  },
	
	  validateMap: function validateMap(shape, params, context) {
	    if (this.validateType(params, context, ['object'], 'map')) {
	      // Build up a count of map members to validate range traits.
	      var mapCount = 0;
	      for (var param in params) {
	        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
	        // Validate any map key trait constraints
	        this.validateMember(shape.key, param,
	                            context + '[key=\'' + param + '\']')
	        this.validateMember(shape.value, params[param],
	                            context + '[\'' + param + '\']');
	        mapCount++;
	      }
	      this.validateRange(shape, mapCount, context, 'map member count');
	    }
	  },
	
	  validateScalar: function validateScalar(shape, value, context) {
	    switch (shape.type) {
	      case null:
	      case undefined:
	      case 'string':
	        return this.validateString(shape, value, context);
	      case 'base64':
	      case 'binary':
	        return this.validatePayload(value, context);
	      case 'integer':
	      case 'float':
	        return this.validateNumber(shape, value, context);
	      case 'boolean':
	        return this.validateType(value, context, ['boolean']);
	      case 'timestamp':
	        return this.validateType(value, context, [Date,
	          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
	          'Date object, ISO-8601 string, or a UNIX timestamp');
	      default:
	        return this.fail('UnkownType', 'Unhandled type ' +
	                         shape.type + ' for ' + context);
	    }
	  },
	
	  validateString: function validateString(shape, value, context) {
	    var validTypes = ['string'];
	    if (shape.isJsonValue) {
	      validTypes = validTypes.concat(['number', 'object', 'boolean']);
	    }
	    if (value !== null && this.validateType(value, context, validTypes)) {
	      this.validateEnum(shape, value, context);
	      this.validateRange(shape, value.length, context, 'string length');
	      this.validatePattern(shape, value, context);
	    }
	  },
	
	  validatePattern: function validatePattern(shape, value, context) {
	    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
	      if (!(new RegExp(shape['pattern'])).test(value)) {
	        this.fail('PatternMatchError', 'Provided value "' + value + '" '
	          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
	          + context);
	      }
	    }
	  },
	
	  validateRange: function validateRange(shape, value, context, descriptor) {
	    if (this.validation['min']) {
	      if (shape['min'] !== undefined && value < shape['min']) {
	        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
	          + shape['min'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	    if (this.validation['max']) {
	      if (shape['max'] !== undefined && value > shape['max']) {
	        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
	          + shape['max'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	  },
	
	  validateEnum: function validateRange(shape, value, context) {
	    if (this.validation['enum'] && shape['enum'] !== undefined) {
	      // Fail if the string value is not present in the enum list
	      if (shape['enum'].indexOf(value) === -1) {
	        this.fail('EnumError', 'Found string value of ' + value + ', but '
	          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
	      }
	    }
	  },
	
	  validateType: function validateType(value, context, acceptedTypes, type) {
	    // We will not log an error for null or undefined, but we will return
	    // false so that callers know that the expected type was not strictly met.
	    if (value === null || value === undefined) return false;
	
	    var foundInvalidType = false;
	    for (var i = 0; i < acceptedTypes.length; i++) {
	      if (typeof acceptedTypes[i] === 'string') {
	        if (typeof value === acceptedTypes[i]) return true;
	      } else if (acceptedTypes[i] instanceof RegExp) {
	        if ((value || '').toString().match(acceptedTypes[i])) return true;
	      } else {
	        if (value instanceof acceptedTypes[i]) return true;
	        if (AWS.util.isType(value, acceptedTypes[i])) return true;
	        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
	        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
	      }
	      foundInvalidType = true;
	    }
	
	    var acceptedType = type;
	    if (!acceptedType) {
	      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
	    }
	
	    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
	              vowel + ' ' + acceptedType);
	    return false;
	  },
	
	  validateNumber: function validateNumber(shape, value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') {
	      var castedValue = parseFloat(value);
	      if (castedValue.toString() === value) value = castedValue;
	    }
	    if (this.validateType(value, context, ['number'])) {
	      this.validateRange(shape, value, context, 'numeric value');
	    }
	  },
	
	  validatePayload: function validatePayload(value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') return;
	    if (value && typeof value.byteLength === 'number') return; // typed arrays
	    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
	      var Stream = AWS.util.stream.Stream;
	      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
	    }
	
	    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
	    if (value) {
	      for (var i = 0; i < types.length; i++) {
	        if (AWS.util.isType(value, types[i])) return;
	        if (AWS.util.typeName(value.constructor) === types[i]) return;
	      }
	    }
	
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
	      'string, Buffer, Stream, Blob, or typed array object');
	  }
	});


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	
	function QueryParamSerializer() {
	}
	
	QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
	  serializeStructure('', params, shape, fn);
	};
	
	function ucfirst(shape) {
	  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
	    return shape.name;
	  } else {
	    return shape.name[0].toUpperCase() + shape.name.substr(1);
	  }
	}
	
	function serializeStructure(prefix, struct, rules, fn) {
	  util.each(rules.members, function(name, member) {
	    var value = struct[name];
	    if (value === null || value === undefined) return;
	
	    var memberName = ucfirst(member);
	    memberName = prefix ? prefix + '.' + memberName : memberName;
	    serializeMember(memberName, value, member, fn);
	  });
	}
	
	function serializeMap(name, map, rules, fn) {
	  var i = 1;
	  util.each(map, function (key, value) {
	    var prefix = rules.flattened ? '.' : '.entry.';
	    var position = prefix + (i++) + '.';
	    var keyName = position + (rules.key.name || 'key');
	    var valueName = position + (rules.value.name || 'value');
	    serializeMember(name + keyName, key, rules.key, fn);
	    serializeMember(name + valueName, value, rules.value, fn);
	  });
	}
	
	function serializeList(name, list, rules, fn) {
	  var memberRules = rules.member || {};
	
	  if (list.length === 0) {
	    fn.call(this, name, null);
	    return;
	  }
	
	  util.arrayEach(list, function (v, n) {
	    var suffix = '.' + (n + 1);
	    if (rules.api.protocol === 'ec2') {
	      // Do nothing for EC2
	      suffix = suffix + ''; // make linter happy
	    } else if (rules.flattened) {
	      if (memberRules.name) {
	        var parts = name.split('.');
	        parts.pop();
	        parts.push(ucfirst(memberRules));
	        name = parts.join('.');
	      }
	    } else {
	      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
	    }
	    serializeMember(name + suffix, v, memberRules, fn);
	  });
	}
	
	function serializeMember(name, value, rules, fn) {
	  if (value === null || value === undefined) return;
	  if (rules.type === 'structure') {
	    serializeStructure(name, value, rules, fn);
	  } else if (rules.type === 'list') {
	    serializeList(name, value, rules, fn);
	  } else if (rules.type === 'map') {
	    serializeMap(name, value, rules, fn);
	  } else {
	    fn(name, rules.toWireFormat(value).toString());
	  }
	}
	
	module.exports = QueryParamSerializer;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	var regionConfig = __webpack_require__(1647);
	
	function generateRegionPrefix(region) {
	  if (!region) return null;
	
	  var parts = region.split('-');
	  if (parts.length < 3) return null;
	  return parts.slice(0, parts.length - 2).join('-') + '-*';
	}
	
	function derivedKeys(service) {
	  var region = service.config.region;
	  var regionPrefix = generateRegionPrefix(region);
	  var endpointPrefix = service.api.endpointPrefix;
	
	  return [
	    [region, endpointPrefix],
	    [regionPrefix, endpointPrefix],
	    [region, '*'],
	    [regionPrefix, '*'],
	    ['*', endpointPrefix],
	    ['*', '*']
	  ].map(function(item) {
	    return item[0] && item[1] ? item.join('/') : null;
	  });
	}
	
	function applyConfig(service, config) {
	  util.each(config, function(key, value) {
	    if (key === 'globalEndpoint') return;
	    if (service.config[key] === undefined || service.config[key] === null) {
	      service.config[key] = value;
	    }
	  });
	}
	
	function configureEndpoint(service) {
	  var keys = derivedKeys(service);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!key) continue;
	
	    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
	      var config = regionConfig.rules[key];
	      if (typeof config === 'string') {
	        config = regionConfig.patterns[config];
	      }
	
	      // set dualstack endpoint
	      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
	        config = util.copy(config);
	        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
	      }
	
	      // set global endpoint
	      service.isGlobalEndpoint = !!config.globalEndpoint;
	
	      // signature version
	      if (!config.signatureVersion) config.signatureVersion = 'v4';
	
	      // merge config
	      applyConfig(service, config);
	      return;
	    }
	  }
	}
	
	module.exports = configureEndpoint;


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(15);
	var AcceptorStateMachine = __webpack_require__(899);
	var inherit = AWS.util.inherit;
	var domain = AWS.util.domain;
	var jmespath = __webpack_require__(139);
	
	/**
	 * @api private
	 */
	var hardErrorStates = {success: 1, error: 1, complete: 1};
	
	function isTerminalState(machine) {
	  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
	}
	
	var fsm = new AcceptorStateMachine();
	fsm.setupStates = function() {
	  var transition = function(_, done) {
	    var self = this;
	    self._haltHandlersOnError = false;
	
	    self.emit(self._asm.currentState, function(err) {
	      if (err) {
	        if (isTerminalState(self)) {
	          if (domain && self.domain instanceof domain.Domain) {
	            err.domainEmitter = self;
	            err.domain = self.domain;
	            err.domainThrown = false;
	            self.domain.emit('error', err);
	          } else {
	            throw err;
	          }
	        } else {
	          self.response.error = err;
	          done(err);
	        }
	      } else {
	        done(self.response.error);
	      }
	    });
	
	  };
	
	  this.addState('validate', 'build', 'error', transition);
	  this.addState('build', 'afterBuild', 'restart', transition);
	  this.addState('afterBuild', 'sign', 'restart', transition);
	  this.addState('sign', 'send', 'retry', transition);
	  this.addState('retry', 'afterRetry', 'afterRetry', transition);
	  this.addState('afterRetry', 'sign', 'error', transition);
	  this.addState('send', 'validateResponse', 'retry', transition);
	  this.addState('validateResponse', 'extractData', 'extractError', transition);
	  this.addState('extractError', 'extractData', 'retry', transition);
	  this.addState('extractData', 'success', 'retry', transition);
	  this.addState('restart', 'build', 'error', transition);
	  this.addState('success', 'complete', 'complete', transition);
	  this.addState('error', 'complete', 'complete', transition);
	  this.addState('complete', null, null, transition);
	};
	fsm.setupStates();
	
	/**
	 * ## Asynchronous Requests
	 *
	 * All requests made through the SDK are asynchronous and use a
	 * callback interface. Each service method that kicks off a request
	 * returns an `AWS.Request` object that you can use to register
	 * callbacks.
	 *
	 * For example, the following service method returns the request
	 * object as "request", which can be used to register callbacks:
	 *
	 * ```javascript
	 * // request is an AWS.Request object
	 * var request = ec2.describeInstances();
	 *
	 * // register callbacks on request to retrieve response data
	 * request.on('success', function(response) {
	 *   console.log(response.data);
	 * });
	 * ```
	 *
	 * When a request is ready to be sent, the {send} method should
	 * be called:
	 *
	 * ```javascript
	 * request.send();
	 * ```
	 *
	 * Since registered callbacks may or may not be idempotent, requests should only
	 * be sent once. To perform the same operation multiple times, you will need to
	 * create multiple request objects, each with its own registered callbacks.
	 *
	 * ## Removing Default Listeners for Events
	 *
	 * Request objects are built with default listeners for the various events,
	 * depending on the service type. In some cases, you may want to remove
	 * some built-in listeners to customize behaviour. Doing this requires
	 * access to the built-in listener functions, which are exposed through
	 * the {AWS.EventListeners.Core} namespace. For instance, you may
	 * want to customize the HTTP handler used when sending a request. In this
	 * case, you can remove the built-in listener associated with the 'send'
	 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
	 *
	 * ## Multiple Callbacks and Chaining
	 *
	 * You can register multiple callbacks on any request object. The
	 * callbacks can be registered for different events, or all for the
	 * same event. In addition, you can chain callback registration, for
	 * example:
	 *
	 * ```javascript
	 * request.
	 *   on('success', function(response) {
	 *     console.log("Success!");
	 *   }).
	 *   on('error', function(response) {
	 *     console.log("Error!");
	 *   }).
	 *   on('complete', function(response) {
	 *     console.log("Always!");
	 *   }).
	 *   send();
	 * ```
	 *
	 * The above example will print either "Success! Always!", or "Error! Always!",
	 * depending on whether the request succeeded or not.
	 *
	 * @!attribute httpRequest
	 *   @readonly
	 *   @!group HTTP Properties
	 *   @return [AWS.HttpRequest] the raw HTTP request object
	 *     containing request headers and body information
	 *     sent by the service.
	 *
	 * @!attribute startTime
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Date] the time that the request started
	 *
	 * @!group Request Building Events
	 *
	 * @!event validate(request)
	 *   Triggered when a request is being validated. Listeners
	 *   should throw an error if the request should not be sent.
	 *   @param request [Request] the request object being sent
	 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
	 *   @see AWS.EventListeners.Core.VALIDATE_REGION
	 *   @example Ensuring that a certain parameter is set before sending a request
	 *     var req = s3.putObject(params);
	 *     req.on('validate', function() {
	 *       if (!req.params.Body.match(/^Hello\s/)) {
	 *         throw new Error('Body must start with "Hello "');
	 *       }
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event build(request)
	 *   Triggered when the request payload is being built. Listeners
	 *   should fill the necessary information to send the request
	 *   over HTTP.
	 *   @param (see AWS.Request~validate)
	 *   @example Add a custom HTTP header to a request
	 *     var req = s3.putObject(params);
	 *     req.on('build', function() {
	 *       req.httpRequest.headers['Custom-Header'] = 'value';
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event sign(request)
	 *   Triggered when the request is being signed. Listeners should
	 *   add the correct authentication headers and/or adjust the body,
	 *   depending on the authentication mechanism being used.
	 *   @param (see AWS.Request~validate)
	 *
	 * @!group Request Sending Events
	 *
	 * @!event send(response)
	 *   Triggered when the request is ready to be sent. Listeners
	 *   should call the underlying transport layer to initiate
	 *   the sending of the request.
	 *   @param response [Response] the response object
	 *   @context [Request] the request object that was sent
	 *   @see AWS.EventListeners.Core.SEND
	 *
	 * @!event retry(response)
	 *   Triggered when a request failed and might need to be retried or redirected.
	 *   If the response is retryable, the listener should set the
	 *   `response.error.retryable` property to `true`, and optionally set
	 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
	 *   In the case of a redirect, `response.error.redirect` should be set to
	 *   `true` with `retryDelay` set to an optional delay on the next request.
	 *
	 *   If a listener decides that a request should not be retried,
	 *   it should set both `retryable` and `redirect` to false.
	 *
	 *   Note that a retryable error will be retried at most
	 *   {AWS.Config.maxRetries} times (based on the service object's config).
	 *   Similarly, a request that is redirected will only redirect at most
	 *   {AWS.Config.maxRedirects} times.
	 *
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @example Adding a custom retry for a 404 response
	 *     request.on('retry', function(response) {
	 *       // this resource is not yet available, wait 10 seconds to get it again
	 *       if (response.httpResponse.statusCode === 404 && response.error) {
	 *         response.error.retryable = true;   // retry this error
	 *         response.error.retryDelay = 10000; // wait 10 seconds
	 *       }
	 *     });
	 *
	 * @!group Data Parsing Events
	 *
	 * @!event extractError(response)
	 *   Triggered on all non-2xx requests so that listeners can extract
	 *   error details from the response body. Listeners to this event
	 *   should set the `response.error` property.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event extractData(response)
	 *   Triggered in successful requests to allow listeners to
	 *   de-serialize the response body into `response.data`.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group Completion Events
	 *
	 * @!event success(response)
	 *   Triggered when the request completed successfully.
	 *   `response.data` will contain the response data and
	 *   `response.error` will be null.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event error(error, response)
	 *   Triggered when an error occurs at any point during the
	 *   request. `response.error` will contain details about the error
	 *   that occurred. `response.data` will be null.
	 *   @param error [Error] the error object containing details about
	 *     the error that occurred.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event complete(response)
	 *   Triggered whenever a request cycle completes. `response.error`
	 *   should be checked, since the request may have failed.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group HTTP Events
	 *
	 * @!event httpHeaders(statusCode, headers, response, statusMessage)
	 *   Triggered when headers are sent by the remote server
	 *   @param statusCode [Integer] the HTTP response code
	 *   @param headers [map<String,String>] the response headers
	 *   @param (see AWS.Request~send)
	 *   @param statusMessage [String] A status message corresponding to the HTTP
	 *                                 response code
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpData(chunk, response)
	 *   Triggered when data is sent by the remote server
	 *   @param chunk [Buffer] the buffer data containing the next data chunk
	 *     from the server
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @see AWS.EventListeners.Core.HTTP_DATA
	 *
	 * @!event httpUploadProgress(progress, response)
	 *   Triggered when the HTTP request has uploaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpDownloadProgress(progress, response)
	 *   Triggered when the HTTP request has downloaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpError(error, response)
	 *   Triggered when the HTTP request failed
	 *   @param error [Error] the error object that was thrown
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpDone(response)
	 *   Triggered when the server is finished sending data
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @see AWS.Response
	 */
	AWS.Request = inherit({
	
	  /**
	   * Creates a request for an operation on a given service with
	   * a set of input parameters.
	   *
	   * @param service [AWS.Service] the service to perform the operation on
	   * @param operation [String] the operation to perform on the service
	   * @param params [Object] parameters to send to the operation.
	   *   See the operation's documentation for the format of the
	   *   parameters.
	   */
	  constructor: function Request(service, operation, params) {
	    var endpoint = service.endpoint;
	    var region = service.config.region;
	    var customUserAgent = service.config.customUserAgent;
	
	    // global endpoints sign as us-east-1
	    if (service.isGlobalEndpoint) region = 'us-east-1';
	
	    this.domain = domain && domain.active;
	    this.service = service;
	    this.operation = operation;
	    this.params = params || {};
	    this.httpRequest = new AWS.HttpRequest(endpoint, region);
	    this.httpRequest.appendToUserAgent(customUserAgent);
	    this.startTime = service.getSkewCorrectedDate();
	
	    this.response = new AWS.Response(this);
	    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
	    this._haltHandlersOnError = false;
	
	    AWS.SequentialExecutor.call(this);
	    this.emit = this.emitEvent;
	  },
	
	  /**
	   * @!group Sending a Request
	   */
	
	  /**
	   * @overload send(callback = null)
	   *   Sends the request object.
	   *
	   *   @callback callback function(err, data)
	   *     If a callback is supplied, it is called when a response is returned
	   *     from the service.
	   *     @context [AWS.Request] the request object being sent.
	   *     @param err [Error] the error object returned from the request.
	   *       Set to `null` if the request is successful.
	   *     @param data [Object] the de-serialized data returned from
	   *       the request. Set to `null` if a request error occurs.
	   *   @example Sending a request with a callback
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.send(function(err, data) { console.log(err, data); });
	   *   @example Sending a request with no callback (using event handlers)
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.on('complete', function(response) { ... }); // register a callback
	   *     request.send();
	   */
	  send: function send(callback) {
	    if (callback) {
	      // append to user agent
	      this.httpRequest.appendToUserAgent('callback');
	      this.on('complete', function (resp) {
	        callback.call(resp, resp.error, resp.data);
	      });
	    }
	    this.runTo();
	
	    return this.response;
	  },
	
	  /**
	   * @!method  promise()
	   *   Sends the request and returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [Object] the de-serialized data returned from the request.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param error [Error] the error object returned from the request.
	   *   @return [Promise] A promise that represents the state of the request.
	   *   @example Sending a request using promises.
	   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     var result = request.promise();
	   *     result.then(function(data) { ... }, function(error) { ... });
	   */
	
	  /**
	   * @api private
	   */
	  build: function build(callback) {
	    return this.runTo('send', callback);
	  },
	
	  /**
	   * @api private
	   */
	  runTo: function runTo(state, done) {
	    this._asm.runTo(state, done, this);
	    return this;
	  },
	
	  /**
	   * Aborts a request, emitting the error and complete events.
	   *
	   * @!macro nobrowser
	   * @example Aborting a request after sending
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: new Buffer(1024 * 1024 * 5) // 5MB payload
	   *   };
	   *   var request = s3.putObject(params);
	   *   request.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(request.abort.bind(request), 1000);
	   *
	   *   // prints "Error: RequestAbortedError Request aborted by user"
	   * @return [AWS.Request] the same request object, for chaining.
	   * @since v1.4.0
	   */
	  abort: function abort() {
	    this.removeAllListeners('validateResponse');
	    this.removeAllListeners('extractError');
	    this.on('validateResponse', function addAbortedError(resp) {
	      resp.error = AWS.util.error(new Error('Request aborted by user'), {
	         code: 'RequestAbortedError', retryable: false
	      });
	    });
	
	    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
	      this.httpRequest.stream.abort();
	      if (this.httpRequest._abortCallback) {
	         this.httpRequest._abortCallback();
	      } else {
	        this.removeAllListeners('send'); // haven't sent yet, so let's not
	      }
	    }
	
	    return this;
	  },
	
	  /**
	   * Iterates over each page of results given a pageable request, calling
	   * the provided callback with each page of data. After all pages have been
	   * retrieved, the callback is called with `null` data.
	   *
	   * @note This operation can generate multiple requests to a service.
	   * @example Iterating over multiple pages of objects in an S3 bucket
	   *   var pages = 1;
	   *   s3.listObjects().eachPage(function(err, data) {
	   *     if (err) return;
	   *     console.log("Page", pages++);
	   *     console.log(data);
	   *   });
	   * @example Iterating over multiple pages with an asynchronous callback
	   *   s3.listObjects(params).eachPage(function(err, data, done) {
	   *     doSomethingAsyncAndOrExpensive(function() {
	   *       // The next page of results isn't fetched until done is called
	   *       done();
	   *     });
	   *   });
	   * @callback callback function(err, data, [doneCallback])
	   *   Called with each page of resulting data from the request. If the
	   *   optional `doneCallback` is provided in the function, it must be called
	   *   when the callback is complete.
	   *
	   *   @param err [Error] an error object, if an error occurred.
	   *   @param data [Object] a single page of response data. If there is no
	   *     more data, this object will be `null`.
	   *   @param doneCallback [Function] an optional done callback. If this
	   *     argument is defined in the function declaration, it should be called
	   *     when the next page is ready to be retrieved. This is useful for
	   *     controlling serial pagination across asynchronous operations.
	   *   @return [Boolean] if the callback returns `false`, pagination will
	   *     stop.
	   *
	   * @see AWS.Request.eachItem
	   * @see AWS.Response.nextPage
	   * @since v1.4.0
	   */
	  eachPage: function eachPage(callback) {
	    // Make all callbacks async-ish
	    callback = AWS.util.fn.makeAsync(callback, 3);
	
	    function wrappedCallback(response) {
	      callback.call(response, response.error, response.data, function (result) {
	        if (result === false) return;
	
	        if (response.hasNextPage()) {
	          response.nextPage().on('complete', wrappedCallback).send();
	        } else {
	          callback.call(response, null, null, AWS.util.fn.noop);
	        }
	      });
	    }
	
	    this.on('complete', wrappedCallback).send();
	  },
	
	  /**
	   * Enumerates over individual items of a request, paging the responses if
	   * necessary.
	   *
	   * @api experimental
	   * @since v1.4.0
	   */
	  eachItem: function eachItem(callback) {
	    var self = this;
	    function wrappedCallback(err, data) {
	      if (err) return callback(err, null);
	      if (data === null) return callback(null, null);
	
	      var config = self.service.paginationConfig(self.operation);
	      var resultKey = config.resultKey;
	      if (Array.isArray(resultKey)) resultKey = resultKey[0];
	      var items = jmespath.search(data, resultKey);
	      var continueIteration = true;
	      AWS.util.arrayEach(items, function(item) {
	        continueIteration = callback(null, item);
	        if (continueIteration === false) {
	          return AWS.util.abort;
	        }
	      });
	      return continueIteration;
	    }
	
	    this.eachPage(wrappedCallback);
	  },
	
	  /**
	   * @return [Boolean] whether the operation can return multiple pages of
	   *   response data.
	   * @see AWS.Response.eachPage
	   * @since v1.4.0
	   */
	  isPageable: function isPageable() {
	    return this.service.paginationConfig(this.operation) ? true : false;
	  },
	
	  /**
	   * Sends the request and converts the request object into a readable stream
	   * that can be read from or piped into a writable stream.
	   *
	   * @note The data read from a readable stream contains only
	   *   the raw HTTP body contents.
	   * @example Manually reading from a stream
	   *   request.createReadStream().on('data', function(data) {
	   *     console.log("Got data:", data.toString());
	   *   });
	   * @example Piping a request body into a file
	   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
	   *   s3.service.getObject(params).createReadStream().pipe(out);
	   * @return [Stream] the readable stream object that can be piped
	   *   or read from (by registering 'data' event listeners).
	   * @!macro nobrowser
	   */
	  createReadStream: function createReadStream() {
	    var streams = AWS.util.stream;
	    var req = this;
	    var stream = null;
	
	    if (AWS.HttpClient.streamsApiVersion === 2) {
	      stream = new streams.PassThrough();
	      process.nextTick(function() { req.send(); });
	    } else {
	      stream = new streams.Stream();
	      stream.readable = true;
	
	      stream.sent = false;
	      stream.on('newListener', function(event) {
	        if (!stream.sent && event === 'data') {
	          stream.sent = true;
	          process.nextTick(function() { req.send(); });
	        }
	      });
	    }
	
	    this.on('error', function(err) {
	      stream.emit('error', err);
	    });
	
	    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
	      if (statusCode < 300) {
	        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
	        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
	        req.on('httpError', function streamHttpError(error) {
	          resp.error = error;
	          resp.error.retryable = false;
	        });
	
	        var shouldCheckContentLength = false;
	        var expectedLen;
	        if (req.httpRequest.method !== 'HEAD') {
	          expectedLen = parseInt(headers['content-length'], 10);
	        }
	        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
	          shouldCheckContentLength = true;
	          var receivedLen = 0;
	        }
	
	        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
	          if (shouldCheckContentLength && receivedLen !== expectedLen) {
	            stream.emit('error', AWS.util.error(
	              new Error('Stream content length mismatch. Received ' +
	                receivedLen + ' of ' + expectedLen + ' bytes.'),
	              { code: 'StreamContentLengthMismatch' }
	            ));
	          } else if (AWS.HttpClient.streamsApiVersion === 2) {
	            stream.end();
	          } else {
	            stream.emit('end');
	          }
	        };
	
	        var httpStream = resp.httpResponse.createUnbufferedStream();
	
	        if (AWS.HttpClient.streamsApiVersion === 2) {
	          if (shouldCheckContentLength) {
	            var lengthAccumulator = new streams.PassThrough();
	            lengthAccumulator._write = function(chunk) {
	              if (chunk && chunk.length) {
	                receivedLen += chunk.length;
	              }
	              return streams.PassThrough.prototype._write.apply(this, arguments);
	            };
	
	            lengthAccumulator.on('end', checkContentLengthAndEmit);
	            stream.on('error', function(err) {
	              shouldCheckContentLength = false;
	              httpStream.unpipe(lengthAccumulator);
	              lengthAccumulator.emit('end');
	              lengthAccumulator.end();
	            });
	            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
	          } else {
	            httpStream.pipe(stream);
	          }
	        } else {
	
	          if (shouldCheckContentLength) {
	            httpStream.on('data', function(arg) {
	              if (arg && arg.length) {
	                receivedLen += arg.length;
	              }
	            });
	          }
	
	          httpStream.on('data', function(arg) {
	            stream.emit('data', arg);
	          });
	          httpStream.on('end', checkContentLengthAndEmit);
	        }
	
	        httpStream.on('error', function(err) {
	          shouldCheckContentLength = false;
	          stream.emit('error', err);
	        });
	      }
	    });
	
	    return stream;
	  },
	
	  /**
	   * @param [Array,Response] args This should be the response object,
	   *   or an array of args to send to the event.
	   * @api private
	   */
	  emitEvent: function emit(eventName, args, done) {
	    if (typeof args === 'function') { done = args; args = null; }
	    if (!done) done = function() { };
	    if (!args) args = this.eventParameters(eventName, this.response);
	
	    var origEmit = AWS.SequentialExecutor.prototype.emit;
	    origEmit.call(this, eventName, args, function (err) {
	      if (err) this.response.error = err;
	      done.call(this, err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  eventParameters: function eventParameters(eventName) {
	    switch (eventName) {
	      case 'restart':
	      case 'validate':
	      case 'sign':
	      case 'build':
	      case 'afterValidate':
	      case 'afterBuild':
	        return [this];
	      case 'error':
	        return [this.response.error, this.response];
	      default:
	        return [this.response];
	    }
	  },
	
	  /**
	   * @api private
	   */
	  presign: function presign(expires, callback) {
	    if (!callback && typeof expires === 'function') {
	      callback = expires;
	      expires = null;
	    }
	    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
	  },
	
	  /**
	   * @api private
	   */
	  isPresigned: function isPresigned() {
	    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
	  },
	
	  /**
	   * @api private
	   */
	  toUnauthenticated: function toUnauthenticated() {
	    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
	    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  toGet: function toGet() {
	    if (this.service.api.protocol === 'query' ||
	        this.service.api.protocol === 'ec2') {
	      this.removeListener('build', this.buildAsGet);
	      this.addListener('build', this.buildAsGet);
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  buildAsGet: function buildAsGet(request) {
	    request.httpRequest.method = 'GET';
	    request.httpRequest.path = request.service.endpoint.path +
	                               '?' + request.httpRequest.body;
	    request.httpRequest.body = '';
	
	    // don't need these headers on a GET request
	    delete request.httpRequest.headers['Content-Length'];
	    delete request.httpRequest.headers['Content-Type'];
	  },
	
	  /**
	   * @api private
	   */
	  haltHandlersOnError: function haltHandlersOnError() {
	    this._haltHandlersOnError = true;
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = function promise() {
	    var self = this;
	    // append to user agent
	    this.httpRequest.appendToUserAgent('promise');
	    return new PromiseDependency(function(resolve, reject) {
	      self.on('complete', function(resp) {
	        if (resp.error) {
	          reject(resp.error);
	        } else {
	          // define $response property so that it is not enumberable
	          // this prevents circular reference errors when stringifying the JSON object
	          resolve(Object.defineProperty(
	            resp.data || {},
	            '$response',
	            {value: resp}
	          ));
	        }
	      });
	      self.runTo();
	    });
	  };
	};
	
	/**
	 * @api private
	 */
	AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};
	
	AWS.util.addPromises(AWS.Request);
	
	AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 887 */
[2520, 15],
/* 888 */
[2521, 15],
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var Api = __webpack_require__(408);
	var regionConfig = __webpack_require__(885);
	var inherit = AWS.util.inherit;
	var clientCount = 0;
	
	/**
	 * The service class representing an AWS service.
	 *
	 * @abstract
	 *
	 * @!attribute apiVersions
	 *   @return [Array<String>] the list of API versions supported by this service.
	 *   @readonly
	 */
	AWS.Service = inherit({
	  /**
	   * Create a new service object with a configuration object
	   *
	   * @param config [map] a map of configuration options
	   */
	  constructor: function Service(config) {
	    if (!this.loadServiceClass) {
	      throw AWS.util.error(new Error(),
	        'Service must be constructed with `new\' operator');
	    }
	    var ServiceClass = this.loadServiceClass(config || {});
	    if (ServiceClass) {
	      var originalConfig = AWS.util.copy(config);
	      var svc = new ServiceClass(config);
	      Object.defineProperty(svc, '_originalConfig', {
	        get: function() { return originalConfig; },
	        enumerable: false,
	        configurable: true
	      });
	      svc._clientId = ++clientCount;
	      return svc;
	    }
	    this.initialize(config);
	  },
	
	  /**
	   * @api private
	   */
	  initialize: function initialize(config) {
	    var svcConfig = AWS.config[this.serviceIdentifier];
	
	    this.config = new AWS.Config(AWS.config);
	    if (svcConfig) this.config.update(svcConfig, true);
	    if (config) this.config.update(config, true);
	
	    this.validateService();
	    if (!this.config.endpoint) regionConfig(this);
	
	    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
	    this.setEndpoint(this.config.endpoint);
	  },
	
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	  },
	
	  /**
	   * @api private
	   */
	  loadServiceClass: function loadServiceClass(serviceConfig) {
	    var config = serviceConfig;
	    if (!AWS.util.isEmpty(this.api)) {
	      return null;
	    } else if (config.apiConfig) {
	      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
	    } else if (!this.constructor.services) {
	      return null;
	    } else {
	      config = new AWS.Config(AWS.config);
	      config.update(serviceConfig, true);
	      var version = config.apiVersions[this.constructor.serviceIdentifier];
	      version = version || config.apiVersion;
	      return this.getLatestServiceClass(version);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceClass: function getLatestServiceClass(version) {
	    version = this.getLatestServiceVersion(version);
	    if (this.constructor.services[version] === null) {
	      AWS.Service.defineServiceApi(this.constructor, version);
	    }
	
	    return this.constructor.services[version];
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceVersion: function getLatestServiceVersion(version) {
	    if (!this.constructor.services || this.constructor.services.length === 0) {
	      throw new Error('No services defined on ' +
	                      this.constructor.serviceIdentifier);
	    }
	
	    if (!version) {
	      version = 'latest';
	    } else if (AWS.util.isType(version, Date)) {
	      version = AWS.util.date.iso8601(version).split('T')[0];
	    }
	
	    if (Object.hasOwnProperty(this.constructor.services, version)) {
	      return version;
	    }
	
	    var keys = Object.keys(this.constructor.services).sort();
	    var selectedVersion = null;
	    for (var i = keys.length - 1; i >= 0; i--) {
	      // versions that end in "*" are not available on disk and can be
	      // skipped, so do not choose these as selectedVersions
	      if (keys[i][keys[i].length - 1] !== '*') {
	        selectedVersion = keys[i];
	      }
	      if (keys[i].substr(0, 10) <= version) {
	        return selectedVersion;
	      }
	    }
	
	    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
	                    ' API to satisfy version constraint `' + version + '\'');
	  },
	
	  /**
	   * @api private
	   */
	  api: {},
	
	  /**
	   * @api private
	   */
	  defaultRetryCount: 3,
	
	  /**
	   * @api private
	   */
	  customizeRequests: function customizeRequests(callback) {
	    if (!callback) {
	      this.customRequestHandler = null;
	    } else if (typeof callback === 'function') {
	      this.customRequestHandler = callback;
	    } else {
	      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
	    }
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeRequest: function makeRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = null;
	    }
	
	    params = params || {};
	    if (this.config.params) { // copy only toplevel bound params
	      var rules = this.api.operations[operation];
	      if (rules) {
	        params = AWS.util.copy(params);
	        AWS.util.each(this.config.params, function(key, value) {
	          if (rules.input.members[key]) {
	            if (params[key] === undefined || params[key] === null) {
	              params[key] = value;
	            }
	          }
	        });
	      }
	    }
	
	    var request = new AWS.Request(this, operation, params);
	    this.addAllRequestListeners(request);
	
	    if (callback) request.send(callback);
	    return request;
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters, without
	   * any authentication data. This method is useful for "public" API operations.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = {};
	    }
	
	    var request = this.makeRequest(operation, params).toUnauthenticated();
	    return callback ? request.send(callback) : request;
	  },
	
	  /**
	   * Waits for a given state
	   *
	   * @param state [String] the state on the service to wait for
	   * @param params [map] a map of parameters to pass with each request
	   * @option params $waiter [map] a map of configuration options for the waiter
	   * @option params $waiter.delay [Number] The number of seconds to wait between
	   *                                       requests
	   * @option params $waiter.maxAttempts [Number] The maximum number of requests
	   *                                             to send while waiting
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  waitFor: function waitFor(state, params, callback) {
	    var waiter = new AWS.ResourceWaiter(this, state);
	    return waiter.wait(params, callback);
	  },
	
	  /**
	   * @api private
	   */
	  addAllRequestListeners: function addAllRequestListeners(request) {
	    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
	                AWS.EventListeners.CorePost];
	    for (var i = 0; i < list.length; i++) {
	      if (list[i]) request.addListeners(list[i]);
	    }
	
	    // disable parameter validation
	    if (!this.config.paramValidation) {
	      request.removeListener('validate',
	        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    }
	
	    if (this.config.logger) { // add logging events
	      request.addListeners(AWS.EventListeners.Logger);
	    }
	
	    this.setupRequestListeners(request);
	    // call prototype's customRequestHandler
	    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
	      this.constructor.prototype.customRequestHandler(request);
	    }
	    // call instance's customRequestHandler
	    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
	      this.customRequestHandler(request);
	    }
	  },
	
	  /**
	   * Override this method to setup any custom request listeners for each
	   * new request to the service.
	   *
	   * @abstract
	   */
	  setupRequestListeners: function setupRequestListeners() {
	  },
	
	  /**
	   * Gets the signer class for a given request
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var version;
	    // get operation authtype if present
	    var operation = null;
	    var authtype = '';
	    if (request) {
	      var operations = request.service.api.operations || {};
	      operation = operations[request.operation] || null;
	      authtype = operation ? operation.authtype : '';
	    }
	    if (this.config.signatureVersion) {
	      version = this.config.signatureVersion;
	    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
	      version = 'v4';
	    } else {
	      version = this.api.signatureVersion;
	    }
	    return AWS.Signers.RequestSigner.getVersion(version);
	  },
	
	  /**
	   * @api private
	   */
	  serviceInterface: function serviceInterface() {
	    switch (this.api.protocol) {
	      case 'ec2': return AWS.EventListeners.Query;
	      case 'query': return AWS.EventListeners.Query;
	      case 'json': return AWS.EventListeners.Json;
	      case 'rest-json': return AWS.EventListeners.RestJson;
	      case 'rest-xml': return AWS.EventListeners.RestXml;
	    }
	    if (this.api.protocol) {
	      throw new Error('Invalid service `protocol\' ' +
	        this.api.protocol + ' in API config');
	    }
	  },
	
	  /**
	   * @api private
	   */
	  successfulResponse: function successfulResponse(resp) {
	    return resp.httpResponse.statusCode < 300;
	  },
	
	  /**
	   * How many times a failed request should be retried before giving up.
	   * the defaultRetryCount can be overriden by service classes.
	   *
	   * @api private
	   */
	  numRetries: function numRetries() {
	    if (this.config.maxRetries !== undefined) {
	      return this.config.maxRetries;
	    } else {
	      return this.defaultRetryCount;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  retryDelays: function retryDelays(retryCount) {
	    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
	  },
	
	  /**
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (this.timeoutError(error)) return true;
	    if (this.networkingError(error)) return true;
	    if (this.expiredCredentialsError(error)) return true;
	    if (this.throttledError(error)) return true;
	    if (error.statusCode >= 500) return true;
	    return false;
	  },
	
	  /**
	   * @api private
	   */
	  networkingError: function networkingError(error) {
	    return error.code === 'NetworkingError';
	  },
	
	  /**
	   * @api private
	   */
	  timeoutError: function timeoutError(error) {
	    return error.code === 'TimeoutError';
	  },
	
	  /**
	   * @api private
	   */
	  expiredCredentialsError: function expiredCredentialsError(error) {
	    // TODO : this only handles *one* of the expired credential codes
	    return (error.code === 'ExpiredTokenException');
	  },
	
	  /**
	   * @api private
	   */
	  clockSkewError: function clockSkewError(error) {
	    switch (error.code) {
	      case 'RequestTimeTooSkewed':
	      case 'RequestExpired':
	      case 'InvalidSignatureException':
	      case 'SignatureDoesNotMatch':
	      case 'AuthFailure':
	      case 'RequestInTheFuture':
	        return true;
	      default: return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getSkewCorrectedDate: function getSkewCorrectedDate() {
	    return new Date(Date.now() + this.config.systemClockOffset);
	  },
	
	  /**
	   * @api private
	   */
	  applyClockOffset: function applyClockOffset(newServerTime) {
	    if (newServerTime) {
	      this.config.systemClockOffset = newServerTime - Date.now();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(newServerTime) {
	    if (newServerTime) {
	      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  throttledError: function throttledError(error) {
	    // this logic varies between services
	    switch (error.code) {
	      case 'ProvisionedThroughputExceededException':
	      case 'Throttling':
	      case 'ThrottlingException':
	      case 'RequestLimitExceeded':
	      case 'RequestThrottled':
	        return true;
	      default:
	        return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  endpointFromTemplate: function endpointFromTemplate(endpoint) {
	    if (typeof endpoint !== 'string') return endpoint;
	
	    var e = endpoint;
	    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
	    e = e.replace(/\{region\}/g, this.config.region);
	    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
	    return e;
	  },
	
	  /**
	   * @api private
	   */
	  setEndpoint: function setEndpoint(endpoint) {
	    this.endpoint = new AWS.Endpoint(endpoint, this.config);
	  },
	
	  /**
	   * @api private
	   */
	  paginationConfig: function paginationConfig(operation, throwException) {
	    var paginator = this.api.operations[operation].paginator;
	    if (!paginator) {
	      if (throwException) {
	        var e = new Error();
	        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
	      }
	      return null;
	    }
	
	    return paginator;
	  }
	});
	
	AWS.util.update(AWS.Service, {
	
	  /**
	   * Adds one method for each operation described in the api configuration
	   *
	   * @api private
	   */
	  defineMethods: function defineMethods(svc) {
	    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
	      if (svc.prototype[method]) return;
	      var operation = svc.prototype.api.operations[method];
	      if (operation.authtype === 'none') {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeUnauthenticatedRequest(method, params, callback);
	        };
	      } else {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeRequest(method, params, callback);
	        };
	      }
	    });
	  },
	
	  /**
	   * Defines a new Service class using a service identifier and list of versions
	   * including an optional set of features (functions) to apply to the class
	   * prototype.
	   *
	   * @param serviceIdentifier [String] the identifier for the service
	   * @param versions [Array<String>] a list of versions that work with this
	   *   service
	   * @param features [Object] an object to attach to the prototype
	   * @return [Class<Service>] the service class defined by this function.
	   */
	  defineService: function defineService(serviceIdentifier, versions, features) {
	    AWS.Service._serviceMap[serviceIdentifier] = true;
	    if (!Array.isArray(versions)) {
	      features = versions;
	      versions = [];
	    }
	
	    var svc = inherit(AWS.Service, features || {});
	
	    if (typeof serviceIdentifier === 'string') {
	      AWS.Service.addVersions(svc, versions);
	
	      var identifier = svc.serviceIdentifier || serviceIdentifier;
	      svc.serviceIdentifier = identifier;
	    } else { // defineService called with an API
	      svc.prototype.api = serviceIdentifier;
	      AWS.Service.defineMethods(svc);
	    }
	
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  addVersions: function addVersions(svc, versions) {
	    if (!Array.isArray(versions)) versions = [versions];
	
	    svc.services = svc.services || {};
	    for (var i = 0; i < versions.length; i++) {
	      if (svc.services[versions[i]] === undefined) {
	        svc.services[versions[i]] = null;
	      }
	    }
	
	    svc.apiVersions = Object.keys(svc.services).sort();
	  },
	
	  /**
	   * @api private
	   */
	  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
	    var svc = inherit(superclass, {
	      serviceIdentifier: superclass.serviceIdentifier
	    });
	
	    function setApi(api) {
	      if (api.isApi) {
	        svc.prototype.api = api;
	      } else {
	        svc.prototype.api = new Api(api);
	      }
	    }
	
	    if (typeof version === 'string') {
	      if (apiConfig) {
	        setApi(apiConfig);
	      } else {
	        try {
	          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
	        } catch (err) {
	          throw AWS.util.error(err, {
	            message: 'Could not find API configuration ' +
	              superclass.serviceIdentifier + '-' + version
	          });
	        }
	      }
	      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
	        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
	      }
	      superclass.services[version] = svc;
	    } else {
	      setApi(version);
	    }
	
	    AWS.Service.defineMethods(svc);
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  hasService: function(identifier) {
	    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
	  },
	
	  /**
	   * @api private
	   */
	  _serviceMap: {}
	});
	
	module.exports = AWS.Service;


/***/ },
/* 890 */
[2522, 15],
/* 891 */
[2523, 15],
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	function signedUrlBuilder(request) {
	  var expires = request.httpRequest.headers[expiresHeader];
	  var signerClass = request.service.getSignerClass(request);
	
	  delete request.httpRequest.headers['User-Agent'];
	  delete request.httpRequest.headers['X-Amz-User-Agent'];
	
	  if (signerClass === AWS.Signers.V4) {
	    if (expires > 604800) { // one week expiry is invalid
	      var message = 'Presigning does not support expiry time greater ' +
	                    'than a week with SigV4 signing.';
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidExpiryTime', message: message, retryable: false
	      });
	    }
	    request.httpRequest.headers[expiresHeader] = expires;
	  } else if (signerClass === AWS.Signers.S3) {
	    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
	    request.httpRequest.headers[expiresHeader] = parseInt(
	      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
	  } else {
	    throw AWS.util.error(new Error(), {
	      message: 'Presigning only supports S3 or SigV4 signing.',
	      code: 'UnsupportedSigner', retryable: false
	    });
	  }
	}
	
	/**
	 * @api private
	 */
	function signedUrlSigner(request) {
	  var endpoint = request.httpRequest.endpoint;
	  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
	  var queryParams = {};
	
	  if (parsedUrl.search) {
	    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
	  }
	
	  var auth = request.httpRequest.headers['Authorization'].split(' ');
	  if (auth[0] === 'AWS') {
	    auth = auth[1].split(':');
	    queryParams['AWSAccessKeyId'] = auth[0];
	    queryParams['Signature'] = auth[1];
	
	    AWS.util.each(request.httpRequest.headers, function (key, value) {
	      if (key === expiresHeader) key = 'Expires';
	      if (key.indexOf('x-amz-meta-') === 0) {
	        // Delete existing, potentially not normalized key
	        delete queryParams[key];
	        key = key.toLowerCase();
	      }
	      queryParams[key] = value;
	    });
	    delete request.httpRequest.headers[expiresHeader];
	    delete queryParams['Authorization'];
	    delete queryParams['Host'];
	  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
	    auth.shift();
	    var rest = auth.join(' ');
	    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
	    queryParams['X-Amz-Signature'] = signature;
	    delete queryParams['Expires'];
	  }
	
	  // build URL
	  endpoint.pathname = parsedUrl.pathname;
	  endpoint.search = AWS.util.queryParamsToString(queryParams);
	}
	
	/**
	 * @api private
	 */
	AWS.Signers.Presign = inherit({
	  /**
	   * @api private
	   */
	  sign: function sign(request, expireTime, callback) {
	    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
	    request.on('build', signedUrlBuilder);
	    request.on('sign', signedUrlSigner);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.COMPUTE_SHA256);
	
	    request.emit('beforePresign', [request]);
	
	    if (callback) {
	      request.build(function() {
	        if (this.response.error) callback(this.response.error);
	        else {
	          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
	        }
	      });
	    } else {
	      request.build();
	      if (request.response.error) throw request.response.error;
	      return AWS.util.urlFormat(request.httpRequest.endpoint);
	    }
	  }
	});
	
	module.exports = AWS.Signers.Presign;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.RequestSigner = inherit({
	  constructor: function RequestSigner(request) {
	    this.request = request;
	  },
	
	  setServiceClientId: function setServiceClientId(id) {
	    this.serviceClientId = id;
	  },
	
	  getServiceClientId: function getServiceClientId() {
	    return this.serviceClientId;
	  }
	});
	
	AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
	  switch (version) {
	    case 'v2': return AWS.Signers.V2;
	    case 'v3': return AWS.Signers.V3;
	    case 'v4': return AWS.Signers.V4;
	    case 's3': return AWS.Signers.S3;
	    case 'v3https': return AWS.Signers.V3Https;
	  }
	  throw new Error('Unknown signing version ' + version);
	};
	
	__webpack_require__(895);
	__webpack_require__(417);
	__webpack_require__(896);
	__webpack_require__(897);
	__webpack_require__(894);
	__webpack_require__(892);


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
	  /**
	   * When building the stringToSign, these sub resource params should be
	   * part of the canonical resource string with their NON-decoded values
	   */
	  subResources: {
	    'acl': 1,
	    'accelerate': 1,
	    'analytics': 1,
	    'cors': 1,
	    'lifecycle': 1,
	    'delete': 1,
	    'inventory': 1,
	    'location': 1,
	    'logging': 1,
	    'metrics': 1,
	    'notification': 1,
	    'partNumber': 1,
	    'policy': 1,
	    'requestPayment': 1,
	    'replication': 1,
	    'restore': 1,
	    'tagging': 1,
	    'torrent': 1,
	    'uploadId': 1,
	    'uploads': 1,
	    'versionId': 1,
	    'versioning': 1,
	    'versions': 1,
	    'website': 1
	  },
	
	  // when building the stringToSign, these querystring params should be
	  // part of the canonical resource string with their NON-encoded values
	  responseHeaders: {
	    'response-content-type': 1,
	    'response-content-language': 1,
	    'response-expires': 1,
	    'response-cache-control': 1,
	    'response-content-disposition': 1,
	    'response-content-encoding': 1
	  },
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    if (!this.request.headers['presigned-expires']) {
	      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
	    }
	
	    if (credentials.sessionToken) {
	      // presigned URLs require this header to be lowercased
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
	    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;
	
	    this.request.headers['Authorization'] = auth;
	  },
	
	  stringToSign: function stringToSign() {
	    var r = this.request;
	
	    var parts = [];
	    parts.push(r.method);
	    parts.push(r.headers['Content-MD5'] || '');
	    parts.push(r.headers['Content-Type'] || '');
	
	    // This is the "Date" header, but we use X-Amz-Date.
	    // The S3 signing mechanism requires us to pass an empty
	    // string for this Date header regardless.
	    parts.push(r.headers['presigned-expires'] || '');
	
	    var headers = this.canonicalizedAmzHeaders();
	    if (headers) parts.push(headers);
	    parts.push(this.canonicalizedResource());
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {
	
	    var amzHeaders = [];
	
	    AWS.util.each(this.request.headers, function (name) {
	      if (name.match(/^x-amz-/i))
	        amzHeaders.push(name);
	    });
	
	    amzHeaders.sort(function (a, b) {
	      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
	    });
	
	    var parts = [];
	    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
	      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
	    });
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedResource: function canonicalizedResource() {
	
	    var r = this.request;
	
	    var parts = r.path.split('?');
	    var path = parts[0];
	    var querystring = parts[1];
	
	    var resource = '';
	
	    if (r.virtualHostedBucket)
	      resource += '/' + r.virtualHostedBucket;
	
	    resource += path;
	
	    if (querystring) {
	
	      // collect a list of sub resources and query params that need to be signed
	      var resources = [];
	
	      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
	        var name = param.split('=')[0];
	        var value = param.split('=')[1];
	        if (this.subResources[name] || this.responseHeaders[name]) {
	          var subresource = { name: name };
	          if (value !== undefined) {
	            if (this.subResources[name]) {
	              subresource.value = value;
	            } else {
	              subresource.value = decodeURIComponent(value);
	            }
	          }
	          resources.push(subresource);
	        }
	      });
	
	      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });
	
	      if (resources.length) {
	
	        querystring = [];
	        AWS.util.arrayEach(resources, function (res) {
	          if (res.value === undefined) {
	            querystring.push(res.name);
	          } else {
	            querystring.push(res.name + '=' + res.value);
	          }
	        });
	
	        resource += '?' + querystring.join('&');
	      }
	
	    }
	
	    return resource;
	
	  },
	
	  sign: function sign(secret, string) {
	    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
	  }
	});
	
	module.exports = AWS.Signers.S3;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    if (!date) date = AWS.util.date.getDate();
	
	    var r = this.request;
	
	    r.params.Timestamp = AWS.util.date.iso8601(date);
	    r.params.SignatureVersion = '2';
	    r.params.SignatureMethod = 'HmacSHA256';
	    r.params.AWSAccessKeyId = credentials.accessKeyId;
	
	    if (credentials.sessionToken) {
	      r.params.SecurityToken = credentials.sessionToken;
	    }
	
	    delete r.params.Signature; // delete old Signature for re-signing
	    r.params.Signature = this.signature(credentials);
	
	    r.body = AWS.util.queryParamsToString(r.params);
	    r.headers['Content-Length'] = r.body.length;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push(this.request.endpoint.host.toLowerCase());
	    parts.push(this.request.pathname());
	    parts.push(AWS.util.queryParamsToString(this.request.params));
	    return parts.join('\n');
	  }
	
	});
	
	module.exports = AWS.Signers.V2;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var inherit = AWS.util.inherit;
	
	__webpack_require__(417);
	
	/**
	 * @api private
	 */
	AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
	  authorization: function authorization(credentials) {
	    return 'AWS3-HTTPS ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  stringToSign: function stringToSign() {
	    return this.request.headers['X-Amz-Date'];
	  }
	});
	
	module.exports = AWS.Signers.V3Https;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	var v4Credentials = __webpack_require__(898);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
	  constructor: function V4(request, serviceName, options) {
	    AWS.Signers.RequestSigner.call(this, request);
	    this.serviceName = serviceName;
	    options = options || {};
	    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
	    this.operation = options.operation;
	  },
	
	  algorithm: 'AWS4-HMAC-SHA256',
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');
	
	    if (this.isPresigned()) {
	      this.updateForPresigned(credentials, datetime);
	    } else {
	      this.addHeaders(credentials, datetime);
	    }
	
	    this.request.headers['Authorization'] =
	      this.authorization(credentials, datetime);
	  },
	
	  addHeaders: function addHeaders(credentials, datetime) {
	    this.request.headers['X-Amz-Date'] = datetime;
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	  },
	
	  updateForPresigned: function updateForPresigned(credentials, datetime) {
	    var credString = this.credentialString(datetime);
	    var qs = {
	      'X-Amz-Date': datetime,
	      'X-Amz-Algorithm': this.algorithm,
	      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
	      'X-Amz-Expires': this.request.headers[expiresHeader],
	      'X-Amz-SignedHeaders': this.signedHeaders()
	    };
	
	    if (credentials.sessionToken) {
	      qs['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	
	    if (this.request.headers['Content-Type']) {
	      qs['Content-Type'] = this.request.headers['Content-Type'];
	    }
	    if (this.request.headers['Content-MD5']) {
	      qs['Content-MD5'] = this.request.headers['Content-MD5'];
	    }
	    if (this.request.headers['Cache-Control']) {
	      qs['Cache-Control'] = this.request.headers['Cache-Control'];
	    }
	
	    // need to pull in any other X-Amz-* headers
	    AWS.util.each.call(this, this.request.headers, function(key, value) {
	      if (key === expiresHeader) return;
	      if (this.isSignableHeader(key)) {
	        var lowerKey = key.toLowerCase();
	        // Metadata should be normalized
	        if (lowerKey.indexOf('x-amz-meta-') === 0) {
	          qs[lowerKey] = value;
	        } else if (lowerKey.indexOf('x-amz-') === 0) {
	          qs[key] = value;
	        }
	      }
	    });
	
	    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
	    this.request.path += sep + AWS.util.queryParamsToString(qs);
	  },
	
	  authorization: function authorization(credentials, datetime) {
	    var parts = [];
	    var credString = this.credentialString(datetime);
	    parts.push(this.algorithm + ' Credential=' +
	      credentials.accessKeyId + '/' + credString);
	    parts.push('SignedHeaders=' + this.signedHeaders());
	    parts.push('Signature=' + this.signature(credentials, datetime));
	    return parts.join(', ');
	  },
	
	  signature: function signature(credentials, datetime) {
	    var signingKey = v4Credentials.getSigningKey(
	      credentials,
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName,
	      this.signatureCache
	    );
	    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
	  },
	
	  stringToSign: function stringToSign(datetime) {
	    var parts = [];
	    parts.push('AWS4-HMAC-SHA256');
	    parts.push(datetime);
	    parts.push(this.credentialString(datetime));
	    parts.push(this.hexEncodedHash(this.canonicalString()));
	    return parts.join('\n');
	  },
	
	  canonicalString: function canonicalString() {
	    var parts = [], pathname = this.request.pathname();
	    if (this.serviceName !== 's3') pathname = AWS.util.uriEscapePath(pathname);
	
	    parts.push(this.request.method);
	    parts.push(pathname);
	    parts.push(this.request.search());
	    parts.push(this.canonicalHeaders() + '\n');
	    parts.push(this.signedHeaders());
	    parts.push(this.hexEncodedBodyHash());
	    return parts.join('\n');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = [];
	    AWS.util.each.call(this, this.request.headers, function (key, item) {
	      headers.push([key, item]);
	    });
	    headers.sort(function (a, b) {
	      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
	    });
	    var parts = [];
	    AWS.util.arrayEach.call(this, headers, function (item) {
	      var key = item[0].toLowerCase();
	      if (this.isSignableHeader(key)) {
	        var value = item[1];
	        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
	          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
	            code: 'InvalidHeader'
	          });
	        }
	        parts.push(key + ':' +
	          this.canonicalHeaderValues(value.toString()));
	      }
	    });
	    return parts.join('\n');
	  },
	
	  canonicalHeaderValues: function canonicalHeaderValues(values) {
	    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
	  },
	
	  signedHeaders: function signedHeaders() {
	    var keys = [];
	    AWS.util.each.call(this, this.request.headers, function (key) {
	      key = key.toLowerCase();
	      if (this.isSignableHeader(key)) keys.push(key);
	    });
	    return keys.sort().join(';');
	  },
	
	  credentialString: function credentialString(datetime) {
	    return v4Credentials.createScope(
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName
	    );
	  },
	
	  hexEncodedHash: function hash(string) {
	    return AWS.util.crypto.sha256(string, 'hex');
	  },
	
	  hexEncodedBodyHash: function hexEncodedBodyHash() {
	    var request = this.request;
	    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
	      return 'UNSIGNED-PAYLOAD';
	    } else if (request.headers['X-Amz-Content-Sha256']) {
	      return request.headers['X-Amz-Content-Sha256'];
	    } else {
	      return this.hexEncodedHash(this.request.body || '');
	    }
	  },
	
	  unsignableHeaders: [
	    'authorization',
	    'content-type',
	    'content-length',
	    'user-agent',
	    expiresHeader,
	    'expect',
	    'x-amzn-trace-id'
	  ],
	
	  isSignableHeader: function isSignableHeader(key) {
	    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
	    return this.unsignableHeaders.indexOf(key) < 0;
	  },
	
	  isPresigned: function isPresigned() {
	    return this.request.headers[expiresHeader] ? true : false;
	  }
	
	});
	
	module.exports = AWS.Signers.V4;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(15);
	
	/**
	 * @api private
	 */
	var cachedSecret = {};
	
	/**
	 * @api private
	 */
	var cacheQueue = [];
	
	/**
	 * @api private
	 */
	var maxCacheEntries = 50;
	
	/**
	 * @api private
	 */
	var v4Identifier = 'aws4_request';
	
	module.exports = {
	  /**
	   * @api private
	   *
	   * @param date [String]
	   * @param region [String]
	   * @param serviceName [String]
	   * @return [String]
	   */
	  createScope: function createScope(date, region, serviceName) {
	    return [
	      date.substr(0, 8),
	      region,
	      serviceName,
	      v4Identifier
	    ].join('/');
	  },
	
	  /**
	   * @api private
	   *
	   * @param credentials [Credentials]
	   * @param date [String]
	   * @param region [String]
	   * @param service [String]
	   * @param shouldCache [Boolean]
	   * @return [String]
	   */
	  getSigningKey: function getSigningKey(
	    credentials,
	    date,
	    region,
	    service,
	    shouldCache
	  ) {
	    var credsIdentifier = AWS.util.crypto
	      .hmac(credentials.secretAccessKey, credentials.accessKeyId, 'base64');
	    var cacheKey = [credsIdentifier, date, region, service].join('_');
	    shouldCache = shouldCache !== false;
	    if (shouldCache && (cacheKey in cachedSecret)) {
	      return cachedSecret[cacheKey];
	    }
	
	    var kDate = AWS.util.crypto.hmac(
	      'AWS4' + credentials.secretAccessKey,
	      date,
	      'buffer'
	    );
	    var kRegion = AWS.util.crypto.hmac(kDate, region, 'buffer');
	    var kService = AWS.util.crypto.hmac(kRegion, service, 'buffer');
	
	    var signingKey = AWS.util.crypto.hmac(kService, v4Identifier, 'buffer');
	    if (shouldCache) {
	      cachedSecret[cacheKey] = signingKey;
	      cacheQueue.push(cacheKey);
	      if (cacheQueue.length > maxCacheEntries) {
	        // remove the oldest entry (not the least recently used)
	        delete cachedSecret[cacheQueue.shift()];
	      }
	    }
	
	    return signingKey;
	  },
	
	  /**
	   * @api private
	   *
	   * Empties the derived signing key cache. Made available for testing purposes
	   * only.
	   */
	  emptyCache: function emptyCache() {
	    cachedSecret = {};
	    cacheQueue = [];
	  }
	};


/***/ },
/* 899 */
/***/ function(module, exports) {

	function AcceptorStateMachine(states, state) {
	  this.currentState = state || null;
	  this.states = states || {};
	}
	
	AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
	  if (typeof finalState === 'function') {
	    inputError = bindObject; bindObject = done;
	    done = finalState; finalState = null;
	  }
	
	  var self = this;
	  var state = self.states[self.currentState];
	  state.fn.call(bindObject || self, inputError, function(err) {
	    if (err) {
	      if (state.fail) self.currentState = state.fail;
	      else return done ? done.call(bindObject, err) : null;
	    } else {
	      if (state.accept) self.currentState = state.accept;
	      else return done ? done.call(bindObject) : null;
	    }
	    if (self.currentState === finalState) {
	      return done ? done.call(bindObject, err) : null;
	    }
	
	    self.runTo(finalState, done, bindObject, err);
	  });
	};
	
	AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
	  if (typeof acceptState === 'function') {
	    fn = acceptState; acceptState = null; failState = null;
	  } else if (typeof failState === 'function') {
	    fn = failState; failState = null;
	  }
	
	  if (!this.currentState) this.currentState = name;
	  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
	  return this;
	};
	
	module.exports = AcceptorStateMachine;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	var Shape = __webpack_require__(156);
	
	function DomXmlParser() { }
	
	DomXmlParser.prototype.parse = function(xml, shape) {
	  if (xml.replace(/^\s+/, '') === '') return {};
	
	  var result, error;
	  try {
	    if (window.DOMParser) {
	      try {
	        var parser = new DOMParser();
	        result = parser.parseFromString(xml, 'text/xml');
	      } catch (syntaxError) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            originalError: syntaxError,
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      if (result.documentElement === null) {
	        throw util.error(new Error('Cannot parse empty document.'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      var isError = result.getElementsByTagName('parsererror')[0];
	      if (isError && (isError.parentNode === result ||
	          isError.parentNode.nodeName === 'body' ||
	          isError.parentNode.parentNode === result ||
	          isError.parentNode.parentNode.nodeName === 'body')) {
	        var errorElement = isError.getElementsByTagName('div')[0] || isError;
	        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else if (window.ActiveXObject) {
	      result = new window.ActiveXObject('Microsoft.XMLDOM');
	      result.async = false;
	
	      if (!result.loadXML(xml)) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else {
	      throw new Error('Cannot load XML parser');
	    }
	  } catch (e) {
	    error = e;
	  }
	
	  if (result && result.documentElement && !error) {
	    var data = parseXml(result.documentElement, shape);
	    var metadata = result.getElementsByTagName('ResponseMetadata')[0];
	    if (metadata) {
	      data.ResponseMetadata = parseXml(metadata, {});
	    }
	    return data;
	  } else if (error) {
	    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
	  } else { // empty xml document
	    return {};
	  }
	};
	
	function parseXml(xml, shape) {
	  if (!shape) shape = {};
	  switch (shape.type) {
	    case 'structure': return parseStructure(xml, shape);
	    case 'map': return parseMap(xml, shape);
	    case 'list': return parseList(xml, shape);
	    case undefined: case null: return parseUnknown(xml);
	    default: return parseScalar(xml, shape);
	  }
	}
	
	function parseStructure(xml, shape) {
	  var data = {};
	  if (xml === null) return data;
	
	  util.each(shape.members, function(memberName, memberShape) {
	    if (memberShape.isXmlAttribute) {
	      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
	        var value = xml.attributes[memberShape.name].value;
	        data[memberName] = parseXml({textContent: value}, memberShape);
	      }
	    } else {
	      var xmlChild = memberShape.flattened ? xml :
	        xml.getElementsByTagName(memberShape.name)[0];
	      if (xmlChild) {
	        data[memberName] = parseXml(xmlChild, memberShape);
	      } else if (!memberShape.flattened && memberShape.type === 'list') {
	        data[memberName] = memberShape.defaultValue;
	      }
	    }
	  });
	
	  return data;
	}
	
	function parseMap(xml, shape) {
	  var data = {};
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	  var tagName = shape.flattened ? shape.name : 'entry';
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      var key = child.getElementsByTagName(xmlKey)[0].textContent;
	      var value = child.getElementsByTagName(xmlValue)[0];
	      data[key] = parseXml(value, shape.value);
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseList(xml, shape) {
	  var data = [];
	  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      data.push(parseXml(child, shape.member));
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseScalar(xml, shape) {
	  if (xml.getAttribute) {
	    var encoding = xml.getAttribute('encoding');
	    if (encoding === 'base64') {
	      shape = new Shape.create({type: encoding});
	    }
	  }
	
	  var text = xml.textContent;
	  if (text === '') text = null;
	  if (typeof shape.toType === 'function') {
	    return shape.toType(text);
	  } else {
	    return text;
	  }
	}
	
	function parseUnknown(xml) {
	  if (xml === undefined || xml === null) return '';
	
	  // empty object
	  if (!xml.firstElementChild) {
	    if (xml.parentNode.parentNode === null) return {};
	    if (xml.childNodes.length === 0) return '';
	    else return xml.textContent;
	  }
	
	  // object, parse as structure
	  var shape = {type: 'structure', members: {}};
	  var child = xml.firstElementChild;
	  while (child) {
	    var tag = child.nodeName;
	    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
	      // multiple tags of the same name makes it a list
	      shape.members[tag].type = 'list';
	    } else {
	      shape.members[tag] = {name: tag};
	    }
	    child = child.nextElementSibling;
	  }
	  return parseStructure(xml, shape);
	}
	
	module.exports = DomXmlParser;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(41);
	var builder = __webpack_require__(2515);
	
	function XmlBuilder() { }
	
	XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
	  var xml = builder.create(rootElement);
	  applyNamespaces(xml, shape);
	  serialize(xml, params, shape);
	  return xml.children.length > 0 || noEmpty ? xml.root().toString() : '';
	};
	
	function serialize(xml, value, shape) {
	  switch (shape.type) {
	    case 'structure': return serializeStructure(xml, value, shape);
	    case 'map': return serializeMap(xml, value, shape);
	    case 'list': return serializeList(xml, value, shape);
	    default: return serializeScalar(xml, value, shape);
	  }
	}
	
	function serializeStructure(xml, params, shape) {
	  util.arrayEach(shape.memberNames, function(memberName) {
	    var memberShape = shape.members[memberName];
	    if (memberShape.location !== 'body') return;
	
	    var value = params[memberName];
	    var name = memberShape.name;
	    if (value !== undefined && value !== null) {
	      if (memberShape.isXmlAttribute) {
	        xml.att(name, value);
	      } else if (memberShape.flattened) {
	        serialize(xml, value, memberShape);
	      } else {
	        var element = xml.ele(name);
	        applyNamespaces(element, memberShape);
	        serialize(element, value, memberShape);
	      }
	    }
	  });
	}
	
	function serializeMap(xml, map, shape) {
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	
	  util.each(map, function(key, value) {
	    var entry = xml.ele(shape.flattened ? shape.name : 'entry');
	    serialize(entry.ele(xmlKey), key, shape.key);
	    serialize(entry.ele(xmlValue), value, shape.value);
	  });
	}
	
	function serializeList(xml, list, shape) {
	  if (shape.flattened) {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || shape.name;
	      var element = xml.ele(name);
	      serialize(element, value, shape.member);
	    });
	  } else {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || 'member';
	      var element = xml.ele(name);
	      serialize(element, value, shape.member);
	    });
	  }
	}
	
	function serializeScalar(xml, value, shape) {
	  xml.txt(shape.toWireFormat(value));
	}
	
	function applyNamespaces(xml, shape) {
	  var uri, prefix = 'xmlns';
	  if (shape.xmlNamespaceUri) {
	    uri = shape.xmlNamespaceUri;
	    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
	  } else if (xml.isRoot && shape.api.xmlNamespaceUri) {
	    uri = shape.api.xmlNamespaceUri;
	  }
	
	  if (uri) xml.att(prefix, uri);
	}
	
	module.exports = XmlBuilder;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(100).Buffer
	var sha = __webpack_require__(905)
	var sha256 = __webpack_require__(906)
	var rng = __webpack_require__(904)
	var md5 = __webpack_require__(903)
	
	var algorithms = {
	  sha1: sha,
	  sha256: sha256,
	  md5: md5
	}
	
	var blocksize = 64
	var zeroBuffer = new Buffer(blocksize); zeroBuffer.fill(0)
	function hmac(fn, key, data) {
	  if(!Buffer.isBuffer(key)) key = new Buffer(key)
	  if(!Buffer.isBuffer(data)) data = new Buffer(data)
	
	  if(key.length > blocksize) {
	    key = fn(key)
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = new Buffer(blocksize), opad = new Buffer(blocksize)
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  var hash = fn(Buffer.concat([ipad, data]))
	  return fn(Buffer.concat([opad, hash]))
	}
	
	function hash(alg, key) {
	  alg = alg || 'sha1'
	  var fn = algorithms[alg]
	  var bufs = []
	  var length = 0
	  if(!fn) error('algorithm:', alg, 'is not yet supported')
	  return {
	    update: function (data) {
	      if(!Buffer.isBuffer(data)) data = new Buffer(data)
	        
	      bufs.push(data)
	      length += data.length
	      return this
	    },
	    digest: function (enc) {
	      var buf = Buffer.concat(bufs)
	      var r = key ? hmac(fn, key, buf) : fn(buf)
	      bufs = null
	      return enc ? r.toString(enc) : r
	    }
	  }
	}
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = function (alg) { return hash(alg) }
	exports.createHmac = function (alg, key) { return hash(alg, key) }
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createCipher'
	, 'createCipheriv'
	, 'createDecipher'
	, 'createDecipheriv'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	, 'pbkdf2'], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(273);
	
	/*
	 * Perform a simple self-test to see if the VM is working
	 */
	function md5_vm_test()
	{
	  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
	}
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 904 */
/***/ function(module, exports) {

	// Original code adapted from Robert Kieffer.
	// details at https://github.com/broofa/node-uuid
	(function() {
	  var _global = this;
	
	  var mathRNG, whatwgRNG;
	
	  // NOTE: Math.random() does not guarantee "cryptographic quality"
	  mathRNG = function(size) {
	    var bytes = new Array(size);
	    var r;
	
	    for (var i = 0, r; i < size; i++) {
	      if ((i & 0x03) == 0) r = Math.random() * 0x100000000;
	      bytes[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return bytes;
	  }
	
	  if (_global.crypto && crypto.getRandomValues) {
	    whatwgRNG = function(size) {
	      var bytes = new Uint8Array(size);
	      crypto.getRandomValues(bytes);
	      return bytes;
	    }
	  }
	
	  module.exports = whatwgRNG || mathRNG;
	
	}())


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var helpers = __webpack_require__(273);
	
	/*
	 * Calculate the SHA-1 of an array of big-endian words, and a bit length
	 */
	function core_sha1(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << (24 - len % 32);
	  x[((len + 64 >> 9) << 4) + 15] = len;
	
	  var w = Array(80);
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	  var e = -1009589776;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	    var olde = e;
	
	    for(var j = 0; j < 80; j++)
	    {
	      if(j < 16) w[j] = x[i + j];
	      else w[j] = rol(w[j-3] ^ w[j-8] ^ w[j-14] ^ w[j-16], 1);
	      var t = safe_add(safe_add(rol(a, 5), sha1_ft(j, b, c, d)),
	                       safe_add(safe_add(e, w[j]), sha1_kt(j)));
	      e = d;
	      d = c;
	      c = rol(b, 30);
	      b = a;
	      a = t;
	    }
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	    e = safe_add(e, olde);
	  }
	  return Array(a, b, c, d, e);
	
	}
	
	/*
	 * Perform the appropriate triplet combination function for the current
	 * iteration
	 */
	function sha1_ft(t, b, c, d)
	{
	  if(t < 20) return (b & c) | ((~b) & d);
	  if(t < 40) return b ^ c ^ d;
	  if(t < 60) return (b & c) | (b & d) | (c & d);
	  return b ^ c ^ d;
	}
	
	/*
	 * Determine the appropriate additive constant for the current iteration
	 */
	function sha1_kt(t)
	{
	  return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	         (t < 60) ? -1894007588 : -899497514;
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function sha1(buf) {
	  return helpers.hash(buf, core_sha1, 20, true);
	};


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var helpers = __webpack_require__(273);
	
	var safe_add = function(x, y) {
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	};
	
	var S = function(X, n) {
	  return (X >>> n) | (X << (32 - n));
	};
	
	var R = function(X, n) {
	  return (X >>> n);
	};
	
	var Ch = function(x, y, z) {
	  return ((x & y) ^ ((~x) & z));
	};
	
	var Maj = function(x, y, z) {
	  return ((x & y) ^ (x & z) ^ (y & z));
	};
	
	var Sigma0256 = function(x) {
	  return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	};
	
	var Sigma1256 = function(x) {
	  return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	};
	
	var Gamma0256 = function(x) {
	  return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	};
	
	var Gamma1256 = function(x) {
	  return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	};
	
	var core_sha256 = function(m, l) {
	  var K = new Array(0x428A2F98,0x71374491,0xB5C0FBCF,0xE9B5DBA5,0x3956C25B,0x59F111F1,0x923F82A4,0xAB1C5ED5,0xD807AA98,0x12835B01,0x243185BE,0x550C7DC3,0x72BE5D74,0x80DEB1FE,0x9BDC06A7,0xC19BF174,0xE49B69C1,0xEFBE4786,0xFC19DC6,0x240CA1CC,0x2DE92C6F,0x4A7484AA,0x5CB0A9DC,0x76F988DA,0x983E5152,0xA831C66D,0xB00327C8,0xBF597FC7,0xC6E00BF3,0xD5A79147,0x6CA6351,0x14292967,0x27B70A85,0x2E1B2138,0x4D2C6DFC,0x53380D13,0x650A7354,0x766A0ABB,0x81C2C92E,0x92722C85,0xA2BFE8A1,0xA81A664B,0xC24B8B70,0xC76C51A3,0xD192E819,0xD6990624,0xF40E3585,0x106AA070,0x19A4C116,0x1E376C08,0x2748774C,0x34B0BCB5,0x391C0CB3,0x4ED8AA4A,0x5B9CCA4F,0x682E6FF3,0x748F82EE,0x78A5636F,0x84C87814,0x8CC70208,0x90BEFFFA,0xA4506CEB,0xBEF9A3F7,0xC67178F2);
	  var HASH = new Array(0x6A09E667, 0xBB67AE85, 0x3C6EF372, 0xA54FF53A, 0x510E527F, 0x9B05688C, 0x1F83D9AB, 0x5BE0CD19);
	    var W = new Array(64);
	    var a, b, c, d, e, f, g, h, i, j;
	    var T1, T2;
	  /* append padding */
	  m[l >> 5] |= 0x80 << (24 - l % 32);
	  m[((l + 64 >> 9) << 4) + 15] = l;
	  for (var i = 0; i < m.length; i += 16) {
	    a = HASH[0]; b = HASH[1]; c = HASH[2]; d = HASH[3]; e = HASH[4]; f = HASH[5]; g = HASH[6]; h = HASH[7];
	    for (var j = 0; j < 64; j++) {
	      if (j < 16) {
	        W[j] = m[j + i];
	      } else {
	        W[j] = safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
	      }
	      T1 = safe_add(safe_add(safe_add(safe_add(h, Sigma1256(e)), Ch(e, f, g)), K[j]), W[j]);
	      T2 = safe_add(Sigma0256(a), Maj(a, b, c));
	      h = g; g = f; f = e; e = safe_add(d, T1); d = c; c = b; b = a; a = safe_add(T1, T2);
	    }
	    HASH[0] = safe_add(a, HASH[0]); HASH[1] = safe_add(b, HASH[1]); HASH[2] = safe_add(c, HASH[2]); HASH[3] = safe_add(d, HASH[3]);
	    HASH[4] = safe_add(e, HASH[4]); HASH[5] = safe_add(f, HASH[5]); HASH[6] = safe_add(g, HASH[6]); HASH[7] = safe_add(h, HASH[7]);
	  }
	  return HASH;
	};
	
	module.exports = function sha256(buf) {
	  return helpers.hash(buf, core_sha256, 32, true);
	};


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module), (function() { return this; }())))

/***/ },
/* 908 */
[2524, 907],
/* 909 */
[2525, 910, 911],
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(419);
	var bytesToUuid = __webpack_require__(418);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(419);
	var bytesToUuid = __webpack_require__(418);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(421)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
	      return (factory(a0));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("aws-sdk"));
	  } else {
	    factory(root["AWS"]);
	  }
	}(this, function (AWS) {
	
	/**
	 * Copyright 2014 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 * 
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 * 
	 *     http://aws.amazon.com/asl/
	 * 
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License. 
	 */
	
	
	if(void 0===AWS)throw new Error("AWS SDK must be loaded before loading the Sync Manager.");AWS.CognitoSyncManager=function(a){a=a||{};var b="CognitoJavaScriptSDK/1";this.provider=AWS.config.credentials,this.identityPoolId=this.provider.params.IdentityPoolId,this.region=AWS.config.region,this.logger=a.log,"function"!=typeof this.logger&&(this.logger=function(){}),this.local=new AWS.CognitoSyncManager.LocalStorage({DataStore:a.DataStore?a.DataStore:AWS.CognitoSyncManager.StoreLocalStorage}),this.remote=new AWS.CognitoSyncManager.RemoteStorage(this.identityPoolId,this.provider),this.remote.setUserAgent(b)},AWS.CognitoSyncManager.prototype.openOrCreateDataset=function(a,b){var c=this,d=new RegExp("^[a-zA-Z0-9_.:-]{1,128}$");d.test(a)?this.local.createDataset(this.getIdentityId(),a,function(a,d){return a?b(a,null):void b(null,new AWS.CognitoSyncManager.Dataset(d,c.provider,c.local,c.remote,c.logger))}):b(new Error("Dataset name must match the pattern "+d.toString()))},AWS.CognitoSyncManager.prototype.listDatasets=function(a){this.local.getDatasets(this.getIdentityId(),a)},AWS.CognitoSyncManager.prototype.refreshDatasetMetadata=function(a){var b=this;this.remote.getDatasets(function(c,d){var e=[],f=function(a){b.local.updateDatasetMetadata(b.getIdentityId(),a,g)},g=function(b,c){e.push(c),d.length>0?f(d.shift()):a(null,e)};d.length>0?f(d.shift(),a):a(null,[])})},AWS.CognitoSyncManager.prototype.wipeData=function(){this.provider.clearCachedId(),this.local.wipeData()},AWS.CognitoSyncManager.prototype.getIdentityId=function(){return this.provider.identityId},AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.Conflict=function(){var a=function(a,b){if(!a||!b)throw new Error("Remote and local records cannot be null.");if(!a.getKey||!b.getKey)throw new Error("Records are not record objects.");if(a.getKey()!==b.getKey())throw new Error("Remote and local keys do not match.");this.key=a.getKey(),this.remoteRecord=a,this.localRecord=b};return a.prototype.getKey=function(){return this.key},a.prototype.getRemoteRecord=function(){return this.remoteRecord},a.prototype.getLocalRecord=function(){return this.localRecord},a.prototype.resolveWithRemoteRecord=function(){return this.remoteRecord.setModified(!1),this.remoteRecord},a.prototype.resolveWithLocalRecord=function(){return this.localRecord.setSyncCount(this.remoteRecord.getSyncCount()),this.localRecord.setModified(!0),this.localRecord},a.prototype.resolveWithValue=function(a){return new AWS.CognitoSyncManager.Record({Key:this.remoteRecord.getKey(),Value:a,SyncCount:this.remoteRecord.getSyncCount(),LastModifiedDate:new Date,LastModifiedBy:this.localRecord.getLastModifiedBy(),DeviceLastModifiedDate:new Date,Modified:!0})},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.Dataset=function(){var a=function(a,b,c,d,e){this.MAX_RETRY=3,this.datasetName=a,this.provider=b,this.local=c,this.remote=d,this.logger=e||function(){}};return a.prototype.validateKey=function(a){var b=new RegExp("^[a-zA-Z0-9_.:-]{1,128}$");return b.test(a)},a.prototype.put=function(a,b,c){var d=typeof b;return this.validateKey(a)?"string"!==d?c(new Error("The value type must be a string but was "+d+".")):void this.local.putValue(this.getIdentityId(),this.datasetName,a,b,c):c(new Error("Invalid key."))},a.prototype.remove=function(a,b){return this.validateKey(a)?void this.local.putValue(this.getIdentityId(),this.datasetName,a,null,b):b(new Error("Invalid key."))},a.prototype.get=function(a,b){return this.validateKey(a)?void this.local.getValue(this.getIdentityId(),this.datasetName,a,b):b(new Error("Invalid key."))},a.prototype.getAllRecords=function(a){this.local.getRecords(this.getIdentityId(),this.datasetName,a)},a.prototype.getDataStorage=function(a){this.getDatasetMetadata(function(b,c){return b?a(b):c?a(null,c.getDataStorage()):a(null,0)})},a.prototype.isChanged=function(a,b){return this.validateKey(a)?void this.local.getRecord(this.getIdentityId(),this.datasetName,a,function(a,c){b(null,c&&c.isModified())}):b(new Error("Invalid key."))},a.prototype.getDatasetMetadata=function(a){this.local.getDatasetMetadata(this.getIdentityId(),this.datasetName,a)},a.prototype.resolve=function(a,b){this.local.putRecords(this.getIdentityId(),this.datasetName,a,b)},a.prototype.putAll=function(a,b){var c=!0;for(var d in a)a.hasOwnProperty(d)&&(this.validateKey(d)||(c=!1));return c?void this.local.putAllValues(this.getIdentityId(),this.datasetName,a,b):b(new Error("Object contains invalid keys."))},a.prototype.getAll=function(a){var b,c={};this.local.getRecords(this.getIdentityId(),this.datasetName,function(d,e){if(d)return a(d);for(var f in e)e.hasOwnProperty(f)&&(b=e[f],b.isDeleted()||(c[b.getKey()]=b.getValue()));a(null,c)})},a.prototype.getIdentityId=function(){return this.provider.identityId},a.prototype.getModifiedRecords=function(a){this.local.getModifiedRecords(this.getIdentityId(),this.datasetName,a)},a.prototype.getLocalMergedDatasets=function(a){var b,c=[],d=this.datasetName+".";this.local.getDatasets(this.getIdentityId(),function(e,f){for(var g in f)f.hasOwnProperty(g)&&(b=f[g],0===b.getDatasetName().indexOf(d)&&c.push(b.getDatasetName()));a(null,c)})},a.prototype.synchronize=function(a,b){var c=this;return a=a||{},a.onSuccess=a.onSuccess||function(a,b){},a.onFailure=a.onFailure||function(a){},a.onConflict=a.onConflict||function(a,b,c){return c(!1)},a.onDatasetDeleted=a.onDatasetDeleted||function(a,b,c){return c(!1)},a.onDatasetsMerged=a.onDatasetsMerged||function(a,b,c){return c(!1)},void 0===b&&(b=this.MAX_RETRY),c.logger("Starting synchronization... (retries: "+b+")"),b<0?a.onFailure(new Error("Synchronize failed: exceeded maximum retry count.")):void this.getLocalMergedDatasets(function(d,e){return d&&a.onFailure(d),c.logger("Checking for locally merged datasets... found "+e.length+"."),e.length>0?(c.logger("Deferring to .onDatasetsMerged."),a.onDatasetsMerged(c,e,function(d){return d?c.synchronize(a,--b):a.onFailure(new Error("Synchronization cancelled by onDatasetsMerged() callback returning false."))})):void c.local.getLastSyncCount(c.getIdentityId(),c.datasetName,function(d,e){return d?a.onFailure(d):(c.logger("Detecting last sync count... "+e),void(parseInt(e)===-1?c.remote.deleteDataset(c.datasetName,function(b,d){return b?a.onFailure(b):void c.local.purgeDataset(c.getIdentityId(),c.datasetName,function(b){return b?a.onFailure(b):a.onSuccess(c)})}):c.remote.listUpdates(c.datasetName,e,function(d,f){if(d)return a.onFailure(d);c.logger("Fetching remote updates... found "+f.records.length+".");var g=f.getMergedDatasetNameList();if(c.logger("Checking for remote merged datasets... found "+g.length+"."),g.length>0)return c.logger("Deferring to .onDatasetsMerged."),a.onDatasetsMerged(c,g,function(d){d?c._synchronizeInternal(a,--b):a.onFailure(new Error("Cancelled due to .onDatasetsMerged result."))});if(0!==e&&!f||f.isDeleted())return a.onDatasetDeleted(c,f.getDatasetName(),function(d){return c.logger("Dataset should be deleted. Deferring to .onDatasetDeleted."),d?(c.logger(".onDatasetDeleted returned true, purging dataset locally."),c.local.purgeDataset(c.getIdentityId(),c.datasetName,function(d){return d?a.onFailure(d):c._synchronizeInternal(a,--b)})):(c.logger(".onDatasetDeleted returned false, cancelling sync."),a.onFailure(new Error("Cancelled due to .onDatasetDeleted result.")))});var h=f.getRecords(),i=f.getSyncCount(),j=f.getSyncSessionToken();c.logger("Checking for remote updates since last sync count... found "+h.length+"."),h.length>0?c._synchronizeResolveLocal(h,function(d,f){return d?a.onFailure(d):(c.logger("Checking for conflicts... found "+f.length+"."),void(f.length>0?(c.logger("Conflicts detected. Deferring to .onConflict."),a.onConflict(c,f,function(d){return d?void c._synchronizePushRemote(j,e,function(){return c.synchronize(a,--b)}):(c.logger(".onConflict returned false. Cancelling sync."),a.onFailure(new Error("Sync cancelled. Conflict callback returned false.")))})):(c.logger("No conflicts. Updating local records."),c.local.putRecords(c.getIdentityId(),c.datasetName,h,function(d){return d?a.onFailure(d):void c.local.updateLastSyncCount(c.getIdentityId(),c.datasetName,i,function(d){return d?a.onFailure(d):(c.logger("Finished resolving records. Restarting sync."),c.synchronize(a,--b))})}))))}):(c.logger("Nothing updated remotely. Pushing local changes to remote."),c._synchronizePushRemote(j,i,function(d){return d?(c.logger("Remote push failed. Likely concurrent sync conflict. Retrying..."),c.synchronize(a,--b)):(c.logger("Sync successful."),a.onSuccess(c,h))}))})))})})},a.prototype._synchronizeResolveLocal=function(a,b){var c=this,d=[];return a&&a.length>0?void c.local.getRecords(c.getIdentityId(),c.datasetName,function(c,e){var f,g,h,i={};for(f=0;f<e.length;f++)i[e[f].getKey()]=e[f];for(f=0;f<a.length;f++)g=a[f].getKey(),h=i[g],h&&h.isModified()&&h.getValue()!==a[f].getValue()&&d.push(new AWS.CognitoSyncManager.Conflict(a[f],h));return b(null,d)}):b(null,d)},a.prototype._synchronizePushRemote=function(a,b,c){var d=this;this.getModifiedRecords(function(b,e){return e.length>0?void d.remote.putRecords(d.datasetName,e,a,function(a,b){a&&c(a),d.local.putRecords(d.getIdentityId(),d.datasetName,b,function(a){if(a)return c(a);var e=0;for(var f in b)b.hasOwnProperty(f)&&(e=e<b[f].getSyncCount()?b[f].getSyncCount():e);d.local.updateLastSyncCount(d.getIdentityId(),d.datasetName,e,function(a){return a?c(a):c(null,!0)})})}):c(null,!0)})},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.DatasetMetadata=function(){var a=function(a){if(a=a||{},this.datasetName=a.DatasetName||"",this.creationDate=new Date(a.CreationDate)||new Date,this.lastModifiedDate=new Date(a.LastModifiedDate)||new Date,this.lastModifiedBy=a.LastModifiedBy||"",this.dataStorage=a.DataStorage||0,this.recordCount=a.NumRecords||0,this.lastSyncCount=a.LastSyncCount||0,this.lastSyncDate=a.LastSyncDate?new Date(a.LastSyncDate):new Date,this.dataStorage<0)throw new RangeError("Storage size cannot be negative.");if(this.recordCount<0)throw new RangeError("Record count cannot be negative.")};return a.prototype.getDatasetName=function(){return this.datasetName},a.prototype.setDatasetName=function(a){return this.datasetName=a,this},a.prototype.getCreationDate=function(){return this.creationDate},a.prototype.setCreationDate=function(a){return this.creationDate=new Date(a),this},a.prototype.getLastModifiedDate=function(){return this.lastModifiedDate},a.prototype.setLastModifiedDate=function(a){return this.lastModifiedDate=new Date(a),this},a.prototype.getLastModifiedBy=function(){return this.lastModifiedBy},a.prototype.setLastModifiedBy=function(a){return this.lastModifiedBy=a,this},a.prototype.getDataStorage=function(){return this.dataStorage},a.prototype.setDataStorage=function(a){return this.dataStorage=a,this},a.prototype.getRecordCount=function(){return this.recordCount},a.prototype.setRecordCount=function(a){return this.recordCount=a,this},a.prototype.getLastSyncCount=function(){return this.lastSyncCount},a.prototype.setLastSyncCount=function(a){return this.lastSyncCount=a,this},a.prototype.getLastSyncDate=function(){return this.lastSyncDate},a.prototype.setLastSyncDate=function(a){return this.lastSyncDate=a,this},a.prototype.toString=function(){return JSON.stringify(this.toJSON())},a.prototype.toJSON=function(){return{DatasetName:this.datasetName,CreationDate:this.creationDate,LastModifiedDate:this.lastModifiedDate,LastModifiedBy:this.lastModifiedBy,DataStorage:this.dataStorage,NumRecords:this.recordCount,LastSyncCount:this.lastSyncCount,LastSyncDate:this.lastSyncDate}},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.DatasetUpdates=function(){var a=function(a){this.datasetName=a,this.records=[],this.syncCount=0,this.syncSessionToken="",this.exists=!0,this.deleted=!1,this.mergedDatasetNameList=[]};return a.prototype.getDatasetName=function(){return this.datasetName},a.prototype.setDatasetName=function(a){return this.datasetName=a,this},a.prototype.getRecords=function(){return this.records},a.prototype.addRecord=function(a){return this.records.push(a),this},a.prototype.getSyncCount=function(){return this.syncCount},a.prototype.setSyncCount=function(a){return this.syncCount=a,this},a.prototype.getSyncSessionToken=function(){return this.syncSessionToken},a.prototype.setSyncSessionToken=function(a){return this.syncSessionToken=a,this},a.prototype.isExists=function(){return this.exists},a.prototype.setExists=function(a){return this.exists=a,this},a.prototype.isDeleted=function(){return this.deleted},a.prototype.setDeleted=function(a){return this.deleted=a,this},a.prototype.getMergedDatasetNameList=function(){return this.mergedDatasetNameList},a.prototype.setMergedDatasetNameList=function(a){return this.mergedDatasetNameList=a,this},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.LocalStorage=function(){var a=function(a){a=a||{},this.store=null,this.meta=null,a.DataStore?this.store=new a.DataStore:this.store=new AWS.CognitoSyncManager.StoreInMemory};return a.prototype.getMetadataKey=function(a,b){return a+"."+b},a.prototype.loadMetadataCache=function(a,b){var c=this;this.store.get("_internal","_metadata",a,function(a,d){return a?b(a,null):(d||(d={}),c.meta=d,void b(null,d))})},a.prototype.saveMetadataCache=function(a,b,c){this.store.set("_internal","_metadata",a,b,function(a){return a?c(a):c(null,b)})},a.prototype.createDataset=function(a,b,c){var d=this;return this.getDatasetMetadata(a,b,function(e,f){var g=(new Date).getTime();f?c(null,b):(f=new AWS.CognitoSyncManager.DatasetMetadata({DatasetName:b,CreationDate:g,LastModifiedDate:g}),d.setDatasetMetadata(a,b,f,function(a,b){}),c(null,b))}),this},a.prototype.getDatasetMetadata=function(a,b,c){var d=this.getMetadataKey(a,b);return null!==this.meta?this.meta[d]?c(null,new AWS.CognitoSyncManager.DatasetMetadata(this.meta[d])):c(null,void 0):this.loadMetadataCache(a,function(a,b){b[d]?c(null,new AWS.CognitoSyncManager.DatasetMetadata(b[d])):c(null,void 0)}),this},a.prototype.setDatasetMetadata=function(a,b,c,d){return this.meta[this.getMetadataKey(a,b)]=c.toJSON(),this.saveMetadataCache(a,this.meta,d),this},a.prototype.getValue=function(a,b,c,d){this.getRecord(a,b,c,function(a,b){return b?d(null,b.getValue()):d(null,void 0)})},a.prototype.putValue=function(a,b,c,d,e){var f=this;this.getRecord(a,b,c,function(g,h){return h&&h.getValue()===d?e(null,h):(h||(h=new AWS.CognitoSyncManager.Record),h.setKey(c).setValue(d).setModified(!0).setSyncCount(h?h.getSyncCount():0).setDeviceLastModifiedDate(new Date),void f.store.set(a,b,c,h.toJSON(),function(c){return c?e(c):void f.updateLastModifiedTimestamp(a,b,function(a){return e(a,h)})}))})},a.prototype.getValueMap=function(a,b,c){var d,e={};this.getRecords(a,b,function(a,b){for(var f in b)b.hasOwnProperty(f)&&(d=b[f],d.isDeleted()||(e[d.getKey()]=d.getValue()));c(null,e)})},a.prototype.putAllValues=function(a,b,c,d){var e=this,f=[];for(var g in c)c.hasOwnProperty(g)&&f.push(g);var h=function(g){var i;return g?d(g):void(f.length>0?(i=f.shift(),e.putValue(a,b,i,c[i],h)):d(null,!0))};h(null,null)},a.prototype.getDatasets=function(a,b){var c=[];if(null!==this.meta){for(var d in this.meta)this.meta.hasOwnProperty(d)&&c.push(new AWS.CognitoSyncManager.DatasetMetadata(this.meta[d]));return b(null,c)}this.loadMetadataCache(a,function(a,d){for(var e in d)d.hasOwnProperty(e)&&c.push(new AWS.CognitoSyncManager.DatasetMetadata(d[e]));return b(null,c)})},a.prototype.updateDatasetMetadata=function(a,b,c){var d=this;this.getDatasetMetadata(a,b.getDatasetName(),function(e,f){e&&c(e),f||(f=new AWS.CognitoSyncManager.DatasetMetadata),f.setDatasetName(b.getDatasetName()).setCreationDate(b.getCreationDate()).setLastModifiedDate(b.getLastModifiedDate()).setLastModifiedBy(b.getLastModifiedBy()).setLastSyncCount(b.getLastSyncCount()).setRecordCount(b.getRecordCount()).setDataStorage(b.getDataStorage()),d.meta[d.getMetadataKey(a,b.getDatasetName())]=f.toJSON(),d.saveMetadataCache(a,d.meta,function(a){return a?c(a):c(null,f)})})},a.prototype.getRecord=function(a,b,c,d){this.store.get(a,b,c,function(a,b){return b?d(null,new AWS.CognitoSyncManager.Record(b)):d(new Error("Key doesn't exist."),null)})},a.prototype.getRecords=function(a,b,c){var d=[];this.store.getAll(a,b,function(a,b){for(var e in b)b.hasOwnProperty(e)&&d.push(new AWS.CognitoSyncManager.Record(b[e]));c(null,d)})},a.prototype.putRecords=function(a,b,c,d){var e=this;c=c||[],c=c.slice();var f=function(){c.length>0&&e.updateAndClearRecord(a,b,c.shift(),function(a){return a?d(a):0===c.length?d(null,!0):void f()})};f()},a.prototype.deleteDataset=function(a,b,c){var d=this;this.store.removeAll(a,b,function(e){return e?c(e):void d.getDatasetMetadata(a,b,function(b,e){return b?c(b):(e.setLastModifiedDate(new Date),e.setLastSyncCount(-1),void d.updateDatasetMetadata(a,e,function(a){return a?c(a):c(null,!0)}))})})},a.prototype.purgeDataset=function(a,b,c){var d=this;this.deleteDataset(a,b,function(e){e&&c(e),delete d.meta[d.getMetadataKey(a,b)],d.saveMetadataCache(a,d.meta,c)})},a.prototype.getLastSyncCount=function(a,b,c){this.getDatasetMetadata(a,b,function(a,b){return b?c(null,b.getLastSyncCount()):void c(new Error("Dataset doesn't exist."),null)})},a.prototype.getModifiedRecords=function(a,b,c){var d=[];this.getRecords(a,b,function(a,b){for(var e=0;e<b.length;e++)b[e].isModified()&&d.push(b[e]);c(null,d)})},a.prototype.updateLastSyncCount=function(a,b,c,d){var e=this;this.getDatasetMetadata(a,b,function(b,f){b&&d(b),f.setLastSyncCount(c).setLastSyncDate(new Date),e.updateDatasetMetadata(a,f,function(a){a&&d(a),d(null,!0)})})},a.prototype.wipeData=function(a){this.store.wipe(a)},a.prototype.updateLastModifiedTimestamp=function(a,b,c){var d=this;this.getDatasetMetadata(a,b,function(b,e){return b?c(b):(e.setLastModifiedDate(new Date),void d.updateDatasetMetadata(a,e,function(a){return a?c(a):c(null,!0)}))})},a.prototype.removeRecord=function(a,b,c,d){this.store.remove(a,b,c,function(a){return a?d(a):d(null,!0)})},a.prototype.updateAndClearRecord=function(a,b,c,d){this.store.set(a,b,c.getKey(),c.toJSON(),function(a){return a?d(a):d(null,!0)})},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.Record=function(){var a=function(a){a=a||{},this.key=a.Key||"",this.value=a.Value||"",this.syncCount=a.SyncCount||0,this.lastModifiedDate=a.LastModifiedDate?new Date(a.LastModifiedDate):new Date,this.lastModifiedBy=a.LastModifiedBy||"",this.deviceLastModifiedDate=a.DeviceLastModifiedDate?new Date(a.DeviceLastModifiedDate):new Date,this.modified=a.Modified||!1};return a.prototype.getKey=function(){return this.key},a.prototype.setKey=function(a){return this.key=a,this},a.prototype.getValue=function(){return this.value},a.prototype.setValue=function(a){return this.value=a,this},a.prototype.getSyncCount=function(){return this.syncCount},a.prototype.setSyncCount=function(a){return this.syncCount=a,this},a.prototype.getLastModifiedDate=function(){return new Date(this.lastModifiedDate)},a.prototype.setLastModifiedDate=function(a){return this.lastModifiedDate=new Date(a),this},a.prototype.getLastModifiedBy=function(){return this.lastModifiedBy},a.prototype.setLastModifiedBy=function(a){return this.lastModifiedBy=a,this},a.prototype.getDeviceLastModifiedDate=function(){return new Date(this.deviceLastModifiedDate)},a.prototype.setDeviceLastModifiedDate=function(a){return this.deviceLastModifiedDate=new Date(a),this},a.prototype.isModified=function(){return this.modified},a.prototype.setModified=function(a){return this.modified=a,this},a.prototype.isDeleted=function(){return null===this.value},a.prototype.toString=function(){return JSON.stringify(this)},a.prototype.toJSON=function(){return{Key:this.key,Value:this.value,SyncCount:this.syncCount,LastModifiedDate:this.lastModifiedDate,LastModifiedBy:this.lastModifiedBy,DeviceLastModifiedDate:this.deviceLastModifiedDate,Modified:this.modified}},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.RemoteStorage=function(){var a=function(a,b){this.identityPoolId=a,this.provider=b,this.client=new AWS.CognitoSync};return a.prototype.userAgent="",a.prototype.getIdentityId=function(){return this.provider.identityId},a.prototype.getDatasets=function(a){var b=this,c=[],d=null,e=function(a,c){b.client.listDatasets({IdentityId:b.getIdentityId(),IdentityPoolId:b.identityPoolId,MaxResults:64,NextToken:a},c)},f=function(b,g){for(var h=g.Datasets||[],i=0;i<h.length;i++)c.push(new AWS.CognitoSyncManager.DatasetMetadata(h[i]));d=g.NextToken,d?e(d,f):a(null,c)};e(d,f)},a.prototype.listUpdates=function(a,b,c){var d=this,e=null,f=new AWS.CognitoSyncManager.DatasetUpdates(a),g=function(c,e){d.client.listRecords({DatasetName:a,IdentityId:d.getIdentityId(),IdentityPoolId:d.identityPoolId,LastSyncCount:b,MaxResults:1024,NextToken:c},e)},h=function(a,b){if(a)return c(a);b=b||{};for(var d,i=b.Records||[],j=0;j<i.length;j++)d=new AWS.CognitoSyncManager.Record(i[j]),d.setModified(!1),f.addRecord(d);f.setSyncSessionToken(b.SyncSessionToken).setSyncCount(b.DatasetSyncCount).setExists(b.DatasetExists).setDeleted(b.DatasetDeletedAfterRequestedSyncCount),b.MergedDatasetNames&&f.setMergedDatasetNameList(b.MergedDatasetNames),e=b.NextToken,e?g(e,h):c(null,f)};g(null,h)},a.prototype.putRecords=function(a,b,c,d){var e,f=this,g=[];for(var h in b)b.hasOwnProperty(h)&&(e=b[h],g.push({Key:e.getKey(),Op:e.getValue()?"replace":"remove",SyncCount:e.getSyncCount(),DeviceLastModifiedDate:e.getDeviceLastModifiedDate(),Value:e.getValue()}));this.client.updateRecords({DatasetName:a,IdentityId:f.getIdentityId(),IdentityPoolId:f.identityPoolId,SyncSessionToken:c,RecordPatches:g},function(b,c){var e="string"==typeof a?a:"(invalid dataset name)";if(b)return d(new Error("Failed to update records in dataset: "+e+" ("+b.message+")"),null);for(var f,g=[],h=0;h<c.Records.length;h++)f=new AWS.CognitoSyncManager.Record(c.Records[h]),f.setModified(!1),g.push(f);return d(null,g)})},a.prototype.deleteDataset=function(a,b){this.client.deleteDataset({DatasetName:a,IdentityId:this.getIdentityId(),IdentityPoolId:this.identityPoolId},function(a,c){return a?b(new Error("Failed to delete dataset."),null):b(null,c)})},a.prototype.getDatasetMetadata=function(a,b){this.client.describeDataset({DatasetName:a,IdentityId:this.getIdentityId(),IdentityPoolId:this.identityPoolId},function(a,c){return a?b(new Error("Failed to get dataset metadata."),null):b(null,new AWS.CognitoSyncManager.DatasetMetadata(c.Dataset))})},a.prototype.setUserAgent=function(a){this.userAgent=a},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.StoreInMemory=function(){var a=function(){this.store={}};return a.prototype.makeKey=function(a,b){return a+"."+b},a.prototype.get=function(a,b,c,d){var e=this.makeKey(a,b);return a&&b?this.store[e]&&this.store[e][c]?d(null,this.store[e][c]):d(null,void 0):d(new Error("You must provide an identity id and dataset name."),null)},a.prototype.getAll=function(a,b,c){var d=this.makeKey(a,b);return a&&b?c(null,this.store[d]):c(new Error("You must provide an identity id and dataset name."),null)},a.prototype.set=function(a,b,c,d,e){var f=this.makeKey(a,b),g=this.store[f]||{};return g[c]=d,this.store[f]=g,e(null,g)},a.prototype.setAll=function(a,b,c,d){var e=this.makeKey(a,b);return this.store[e]=c,d(null,c)},a.prototype.remove=function(a,b,c,d){var e=this.makeKey(a,b),f=JSON.parse(this.store[e]);return f||(f={}),delete f[c],this.store[e]=JSON.stringify(f),d(null,!0)},a.prototype.removeAll=function(a,b,c){var d=this.makeKey(a,b);return delete this.store[d],c(null,!0)},a.prototype.wipe=function(a){return this.store={},a(null,!0)},a}(),AWS=AWS||{},AWS.CognitoSyncManager=AWS.CognitoSyncManager||{},AWS.CognitoSyncManager.StoreLocalStorage=function(){var a=function(){this.store=window.localStorage};return a.prototype.makeKey=function(a,b){return a+"."+b},a.prototype.get=function(a,b,c,d){var e=this.makeKey(a,b);if(!a||!b)return d(new Error("You must provide an identity id and dataset name."),null);var f=JSON.parse(this.store.getItem(e));return f&&f[c]?d(null,f[c]):d(null,void 0)},a.prototype.getAll=function(a,b,c){var d=this.makeKey(a,b);return a&&b?c(null,JSON.parse(this.store.getItem(d))):c(new Error("You must provide an identity id and dataset name."),null)},a.prototype.set=function(a,b,c,d,e){var f=this.makeKey(a,b),g=JSON.parse(this.store.getItem(f));return g||(g={}),g[c]=d,this.store.setItem(f,JSON.stringify(g)),e(null,g),this},a.prototype.setAll=function(a,b,c,d){var e=this.makeKey(a,b);return this.store.setItem(e,JSON.stringify(c)),d(null,c)},a.prototype.remove=function(a,b,c,d){var e=this.makeKey(a,b),f=JSON.parse(this.store.getItem(e));return f||(f={}),delete f[c],this.store.setItem(e,JSON.stringify(f)),d(null,!0)},a.prototype.removeAll=function(a,b,c){var d=this.makeKey(a,b);return this.store.removeItem(d),c(null,!0)},a.prototype.wipe=function(a){for(var b in this.store)this.store.hasOwnProperty(b)&&b.indexOf("aws.cognito.identity")===-1&&this.store.removeItem(b);return a?a(null,!0):this},a}();
	//# sourceMappingURL=amazon-cognito.min.js.map
	
	}));


/***/ },
/* 913 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['acm'] = {};
	AWS.ACM = Service.defineService('acm', ['2015-12-08']);
	Object.defineProperty(apiLoader.services['acm'], '2015-12-08', {
	  get: function get() {
	    var model = __webpack_require__(1648);
	    model.paginators = __webpack_require__(1649).pagination;
	    model.waiters = __webpack_require__(1650).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ACM;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['apigateway'] = {};
	AWS.APIGateway = Service.defineService('apigateway', ['2015-07-09']);
	__webpack_require__(1030);
	Object.defineProperty(apiLoader.services['apigateway'], '2015-07-09', {
	  get: function get() {
	    var model = __webpack_require__(1651);
	    model.paginators = __webpack_require__(1652).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.APIGateway;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['applicationautoscaling'] = {};
	AWS.ApplicationAutoScaling = Service.defineService('applicationautoscaling', ['2016-02-06']);
	Object.defineProperty(apiLoader.services['applicationautoscaling'], '2016-02-06', {
	  get: function get() {
	    var model = __webpack_require__(1653);
	    model.paginators = __webpack_require__(1654).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ApplicationAutoScaling;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['autoscaling'] = {};
	AWS.AutoScaling = Service.defineService('autoscaling', ['2011-01-01']);
	Object.defineProperty(apiLoader.services['autoscaling'], '2011-01-01', {
	  get: function get() {
	    var model = __webpack_require__(1655);
	    model.paginators = __webpack_require__(1656).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.AutoScaling;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	module.exports = {
	  ACM: __webpack_require__(914),
	  APIGateway: __webpack_require__(915),
	  ApplicationAutoScaling: __webpack_require__(916),
	  AutoScaling: __webpack_require__(917),
	  CloudFormation: __webpack_require__(919),
	  CloudFront: __webpack_require__(920),
	  CloudHSM: __webpack_require__(921),
	  CloudTrail: __webpack_require__(922),
	  CloudWatch: __webpack_require__(923),
	  CloudWatchEvents: __webpack_require__(924),
	  CloudWatchLogs: __webpack_require__(925),
	  CodeBuild: __webpack_require__(926),
	  CodeCommit: __webpack_require__(927),
	  CodeDeploy: __webpack_require__(928),
	  CodePipeline: __webpack_require__(929),
	  CognitoIdentity: __webpack_require__(420),
	  CognitoIdentityServiceProvider: __webpack_require__(930),
	  CognitoSync: __webpack_require__(931),
	  ConfigService: __webpack_require__(934),
	  CUR: __webpack_require__(936),
	  DeviceFarm: __webpack_require__(937),
	  DirectConnect: __webpack_require__(938),
	  DynamoDB: __webpack_require__(939),
	  DynamoDBStreams: __webpack_require__(940),
	  EC2: __webpack_require__(941),
	  ECR: __webpack_require__(942),
	  ECS: __webpack_require__(943),
	  EFS: __webpack_require__(944),
	  ElastiCache: __webpack_require__(945),
	  ElasticBeanstalk: __webpack_require__(946),
	  ELB: __webpack_require__(948),
	  ELBv2: __webpack_require__(949),
	  EMR: __webpack_require__(950),
	  ElasticTranscoder: __webpack_require__(947),
	  Firehose: __webpack_require__(951),
	  GameLift: __webpack_require__(952),
	  IAM: __webpack_require__(953),
	  Inspector: __webpack_require__(954),
	  Iot: __webpack_require__(955),
	  IotData: __webpack_require__(956),
	  Kinesis: __webpack_require__(957),
	  KMS: __webpack_require__(961),
	  Lambda: __webpack_require__(962),
	  LexRuntime: __webpack_require__(964),
	  MachineLearning: __webpack_require__(965),
	  MarketplaceCommerceAnalytics: __webpack_require__(966),
	  MTurk: __webpack_require__(969),
	  MobileAnalytics: __webpack_require__(968),
	  OpsWorks: __webpack_require__(970),
	  Polly: __webpack_require__(974),
	  RDS: __webpack_require__(976),
	  Redshift: __webpack_require__(977),
	  Rekognition: __webpack_require__(978),
	  Route53: __webpack_require__(980),
	  Route53Domains: __webpack_require__(981),
	  S3: __webpack_require__(982),
	  ServiceCatalog: __webpack_require__(984),
	  SES: __webpack_require__(985),
	  SNS: __webpack_require__(986),
	  SQS: __webpack_require__(987),
	  SSM: __webpack_require__(988),
	  StorageGateway: __webpack_require__(989),
	  STS: __webpack_require__(126),
	  WAF: __webpack_require__(991),
	  WorkDocs: __webpack_require__(992),
	  LexModelBuildingService: __webpack_require__(963),
	  Pricing: __webpack_require__(975),
	  CostExplorer: __webpack_require__(935),
	  MediaStoreData: __webpack_require__(967),
	  Comprehend: __webpack_require__(932),
	  KinesisVideoArchivedMedia: __webpack_require__(959),
	  KinesisVideoMedia: __webpack_require__(960),
	  KinesisVideo: __webpack_require__(958),
	  Translate: __webpack_require__(990),
	  ResourceGroups: __webpack_require__(979),
	  SecretsManager: __webpack_require__(983),
	  ComprehendMedical: __webpack_require__(933),
	  Personalize: __webpack_require__(971),
	  PersonalizeEvents: __webpack_require__(972),
	  PersonalizeRuntime: __webpack_require__(973)
	};

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudformation'] = {};
	AWS.CloudFormation = Service.defineService('cloudformation', ['2010-05-15']);
	Object.defineProperty(apiLoader.services['cloudformation'], '2010-05-15', {
	  get: function get() {
	    var model = __webpack_require__(1659);
	    model.paginators = __webpack_require__(1660).pagination;
	    model.waiters = __webpack_require__(1661).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudFormation;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudfront'] = {};
	AWS.CloudFront = Service.defineService('cloudfront', ['2013-05-12*', '2013-11-11*', '2014-05-31*', '2014-10-21*', '2014-11-06*', '2015-04-17*', '2015-07-27*', '2015-09-17*', '2016-01-13*', '2016-01-28*', '2016-08-01*', '2016-08-20*', '2016-09-07*', '2016-09-29*', '2016-11-25', '2016-11-25*', '2017-03-25', '2017-03-25*', '2017-10-30', '2017-10-30*', '2018-06-18', '2018-06-18*', '2018-11-05', '2018-11-05*', '2019-03-26']);
	__webpack_require__(1031);
	Object.defineProperty(apiLoader.services['cloudfront'], '2016-11-25', {
	  get: function get() {
	    var model = __webpack_require__(1662);
	    model.paginators = __webpack_require__(1663).pagination;
	    model.waiters = __webpack_require__(1664).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2017-03-25', {
	  get: function get() {
	    var model = __webpack_require__(1665);
	    model.paginators = __webpack_require__(1666).pagination;
	    model.waiters = __webpack_require__(1667).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2017-10-30', {
	  get: function get() {
	    var model = __webpack_require__(1668);
	    model.paginators = __webpack_require__(1669).pagination;
	    model.waiters = __webpack_require__(1670).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2018-06-18', {
	  get: function get() {
	    var model = __webpack_require__(1671);
	    model.paginators = __webpack_require__(1672).pagination;
	    model.waiters = __webpack_require__(1673).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2018-11-05', {
	  get: function get() {
	    var model = __webpack_require__(1674);
	    model.paginators = __webpack_require__(1675).pagination;
	    model.waiters = __webpack_require__(1676).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['cloudfront'], '2019-03-26', {
	  get: function get() {
	    var model = __webpack_require__(1677);
	    model.paginators = __webpack_require__(1678).pagination;
	    model.waiters = __webpack_require__(1679).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudFront;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudhsm'] = {};
	AWS.CloudHSM = Service.defineService('cloudhsm', ['2014-05-30']);
	Object.defineProperty(apiLoader.services['cloudhsm'], '2014-05-30', {
	  get: function get() {
	    var model = __webpack_require__(1680);
	    model.paginators = __webpack_require__(1681).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudHSM;


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudtrail'] = {};
	AWS.CloudTrail = Service.defineService('cloudtrail', ['2013-11-01']);
	Object.defineProperty(apiLoader.services['cloudtrail'], '2013-11-01', {
	  get: function get() {
	    var model = __webpack_require__(1682);
	    model.paginators = __webpack_require__(1683).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudTrail;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudwatch'] = {};
	AWS.CloudWatch = Service.defineService('cloudwatch', ['2010-08-01']);
	Object.defineProperty(apiLoader.services['cloudwatch'], '2010-08-01', {
	  get: function get() {
	    var model = __webpack_require__(1789);
	    model.paginators = __webpack_require__(1790).pagination;
	    model.waiters = __webpack_require__(1791).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudWatch;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudwatchevents'] = {};
	AWS.CloudWatchEvents = Service.defineService('cloudwatchevents', ['2014-02-03*', '2015-10-07']);
	Object.defineProperty(apiLoader.services['cloudwatchevents'], '2015-10-07', {
	  get: function get() {
	    var model = __webpack_require__(1746);
	    model.paginators = __webpack_require__(1747).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudWatchEvents;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cloudwatchlogs'] = {};
	AWS.CloudWatchLogs = Service.defineService('cloudwatchlogs', ['2014-03-28']);
	Object.defineProperty(apiLoader.services['cloudwatchlogs'], '2014-03-28', {
	  get: function get() {
	    var model = __webpack_require__(1778);
	    model.paginators = __webpack_require__(1779).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CloudWatchLogs;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codebuild'] = {};
	AWS.CodeBuild = Service.defineService('codebuild', ['2016-10-06']);
	Object.defineProperty(apiLoader.services['codebuild'], '2016-10-06', {
	  get: function get() {
	    var model = __webpack_require__(1684);
	    model.paginators = __webpack_require__(1685).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodeBuild;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codecommit'] = {};
	AWS.CodeCommit = Service.defineService('codecommit', ['2015-04-13']);
	Object.defineProperty(apiLoader.services['codecommit'], '2015-04-13', {
	  get: function get() {
	    var model = __webpack_require__(1686);
	    model.paginators = __webpack_require__(1687).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodeCommit;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codedeploy'] = {};
	AWS.CodeDeploy = Service.defineService('codedeploy', ['2014-10-06']);
	Object.defineProperty(apiLoader.services['codedeploy'], '2014-10-06', {
	  get: function get() {
	    var model = __webpack_require__(1688);
	    model.paginators = __webpack_require__(1689).pagination;
	    model.waiters = __webpack_require__(1690).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodeDeploy;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['codepipeline'] = {};
	AWS.CodePipeline = Service.defineService('codepipeline', ['2015-07-09']);
	Object.defineProperty(apiLoader.services['codepipeline'], '2015-07-09', {
	  get: function get() {
	    var model = __webpack_require__(1691);
	    model.paginators = __webpack_require__(1692).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CodePipeline;


/***/ },
/* 930 */
[2517, 7, 4, 1695, 1696],
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cognitosync'] = {};
	AWS.CognitoSync = Service.defineService('cognitosync', ['2014-06-30']);
	Object.defineProperty(apiLoader.services['cognitosync'], '2014-06-30', {
	  get: function get() {
	    var model = __webpack_require__(1697);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CognitoSync;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['comprehend'] = {};
	AWS.Comprehend = Service.defineService('comprehend', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['comprehend'], '2017-11-27', {
	  get: function get() {
	    var model = __webpack_require__(1698);
	    model.paginators = __webpack_require__(1699).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Comprehend;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['comprehendmedical'] = {};
	AWS.ComprehendMedical = Service.defineService('comprehendmedical', ['2018-10-30']);
	Object.defineProperty(apiLoader.services['comprehendmedical'], '2018-10-30', {
	  get: function get() {
	    var model = __webpack_require__(1700);
	    model.paginators = __webpack_require__(1701).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ComprehendMedical;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['configservice'] = {};
	AWS.ConfigService = Service.defineService('configservice', ['2014-11-12']);
	Object.defineProperty(apiLoader.services['configservice'], '2014-11-12', {
	  get: function get() {
	    var model = __webpack_require__(1702);
	    model.paginators = __webpack_require__(1703).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ConfigService;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['costexplorer'] = {};
	AWS.CostExplorer = Service.defineService('costexplorer', ['2017-10-25']);
	Object.defineProperty(apiLoader.services['costexplorer'], '2017-10-25', {
	  get: function get() {
	    var model = __webpack_require__(1657);
	    model.paginators = __webpack_require__(1658).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CostExplorer;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cur'] = {};
	AWS.CUR = Service.defineService('cur', ['2017-01-06']);
	Object.defineProperty(apiLoader.services['cur'], '2017-01-06', {
	  get: function get() {
	    var model = __webpack_require__(1704);
	    model.paginators = __webpack_require__(1705).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CUR;


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['devicefarm'] = {};
	AWS.DeviceFarm = Service.defineService('devicefarm', ['2015-06-23']);
	Object.defineProperty(apiLoader.services['devicefarm'], '2015-06-23', {
	  get: function get() {
	    var model = __webpack_require__(1706);
	    model.paginators = __webpack_require__(1707).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DeviceFarm;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['directconnect'] = {};
	AWS.DirectConnect = Service.defineService('directconnect', ['2012-10-25']);
	Object.defineProperty(apiLoader.services['directconnect'], '2012-10-25', {
	  get: function get() {
	    var model = __webpack_require__(1708);
	    model.paginators = __webpack_require__(1709).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DirectConnect;


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['dynamodb'] = {};
	AWS.DynamoDB = Service.defineService('dynamodb', ['2011-12-05', '2012-08-10']);
	__webpack_require__(1033);
	Object.defineProperty(apiLoader.services['dynamodb'], '2011-12-05', {
	  get: function get() {
	    var model = __webpack_require__(1710);
	    model.paginators = __webpack_require__(1711).pagination;
	    model.waiters = __webpack_require__(1712).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['dynamodb'], '2012-08-10', {
	  get: function get() {
	    var model = __webpack_require__(1713);
	    model.paginators = __webpack_require__(1714).pagination;
	    model.waiters = __webpack_require__(1715).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DynamoDB;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['dynamodbstreams'] = {};
	AWS.DynamoDBStreams = Service.defineService('dynamodbstreams', ['2012-08-10']);
	Object.defineProperty(apiLoader.services['dynamodbstreams'], '2012-08-10', {
	  get: function get() {
	    var model = __webpack_require__(1848);
	    model.paginators = __webpack_require__(1849).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.DynamoDBStreams;


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ec2'] = {};
	AWS.EC2 = Service.defineService('ec2', ['2013-06-15*', '2013-10-15*', '2014-02-01*', '2014-05-01*', '2014-06-15*', '2014-09-01*', '2014-10-01*', '2015-03-01*', '2015-04-15*', '2015-10-01*', '2016-04-01*', '2016-09-15*', '2016-11-15']);
	__webpack_require__(1034);
	Object.defineProperty(apiLoader.services['ec2'], '2016-11-15', {
	  get: function get() {
	    var model = __webpack_require__(1716);
	    model.paginators = __webpack_require__(1717).pagination;
	    model.waiters = __webpack_require__(1718).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.EC2;


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ecr'] = {};
	AWS.ECR = Service.defineService('ecr', ['2015-09-21']);
	Object.defineProperty(apiLoader.services['ecr'], '2015-09-21', {
	  get: function get() {
	    var model = __webpack_require__(1719);
	    model.paginators = __webpack_require__(1720).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ECR;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ecs'] = {};
	AWS.ECS = Service.defineService('ecs', ['2014-11-13']);
	Object.defineProperty(apiLoader.services['ecs'], '2014-11-13', {
	  get: function get() {
	    var model = __webpack_require__(1721);
	    model.paginators = __webpack_require__(1722).pagination;
	    model.waiters = __webpack_require__(1723).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ECS;


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['efs'] = {};
	AWS.EFS = Service.defineService('efs', ['2015-02-01']);
	Object.defineProperty(apiLoader.services['efs'], '2015-02-01', {
	  get: function get() {
	    var model = __webpack_require__(1729);
	    model.paginators = __webpack_require__(1730).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.EFS;


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elasticache'] = {};
	AWS.ElastiCache = Service.defineService('elasticache', ['2012-11-15*', '2014-03-24*', '2014-07-15*', '2014-09-30*', '2015-02-02']);
	Object.defineProperty(apiLoader.services['elasticache'], '2015-02-02', {
	  get: function get() {
	    var model = __webpack_require__(1724);
	    model.paginators = __webpack_require__(1725).pagination;
	    model.waiters = __webpack_require__(1726).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ElastiCache;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elasticbeanstalk'] = {};
	AWS.ElasticBeanstalk = Service.defineService('elasticbeanstalk', ['2010-12-01']);
	Object.defineProperty(apiLoader.services['elasticbeanstalk'], '2010-12-01', {
	  get: function get() {
	    var model = __webpack_require__(1727);
	    model.paginators = __webpack_require__(1728).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ElasticBeanstalk;


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elastictranscoder'] = {};
	AWS.ElasticTranscoder = Service.defineService('elastictranscoder', ['2012-09-25']);
	Object.defineProperty(apiLoader.services['elastictranscoder'], '2012-09-25', {
	  get: function get() {
	    var model = __webpack_require__(1740);
	    model.paginators = __webpack_require__(1741).pagination;
	    model.waiters = __webpack_require__(1742).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ElasticTranscoder;


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elb'] = {};
	AWS.ELB = Service.defineService('elb', ['2012-06-01']);
	Object.defineProperty(apiLoader.services['elb'], '2012-06-01', {
	  get: function get() {
	    var model = __webpack_require__(1731);
	    model.paginators = __webpack_require__(1732).pagination;
	    model.waiters = __webpack_require__(1733).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ELB;


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['elbv2'] = {};
	AWS.ELBv2 = Service.defineService('elbv2', ['2015-12-01']);
	Object.defineProperty(apiLoader.services['elbv2'], '2015-12-01', {
	  get: function get() {
	    var model = __webpack_require__(1734);
	    model.paginators = __webpack_require__(1735).pagination;
	    model.waiters = __webpack_require__(1736).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ELBv2;


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['emr'] = {};
	AWS.EMR = Service.defineService('emr', ['2009-03-31']);
	Object.defineProperty(apiLoader.services['emr'], '2009-03-31', {
	  get: function get() {
	    var model = __webpack_require__(1737);
	    model.paginators = __webpack_require__(1738).pagination;
	    model.waiters = __webpack_require__(1739).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.EMR;


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['firehose'] = {};
	AWS.Firehose = Service.defineService('firehose', ['2015-08-04']);
	Object.defineProperty(apiLoader.services['firehose'], '2015-08-04', {
	  get: function get() {
	    var model = __webpack_require__(1748);
	    model.paginators = __webpack_require__(1749).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Firehose;


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['gamelift'] = {};
	AWS.GameLift = Service.defineService('gamelift', ['2015-10-01']);
	Object.defineProperty(apiLoader.services['gamelift'], '2015-10-01', {
	  get: function get() {
	    var model = __webpack_require__(1750);
	    model.paginators = __webpack_require__(1751).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.GameLift;


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['iam'] = {};
	AWS.IAM = Service.defineService('iam', ['2010-05-08']);
	Object.defineProperty(apiLoader.services['iam'], '2010-05-08', {
	  get: function get() {
	    var model = __webpack_require__(1752);
	    model.paginators = __webpack_require__(1753).pagination;
	    model.waiters = __webpack_require__(1754).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.IAM;


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['inspector'] = {};
	AWS.Inspector = Service.defineService('inspector', ['2015-08-18*', '2016-02-16']);
	Object.defineProperty(apiLoader.services['inspector'], '2016-02-16', {
	  get: function get() {
	    var model = __webpack_require__(1755);
	    model.paginators = __webpack_require__(1756).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Inspector;


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['iot'] = {};
	AWS.Iot = Service.defineService('iot', ['2015-05-28']);
	Object.defineProperty(apiLoader.services['iot'], '2015-05-28', {
	  get: function get() {
	    var model = __webpack_require__(1757);
	    model.paginators = __webpack_require__(1758).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Iot;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['iotdata'] = {};
	AWS.IotData = Service.defineService('iotdata', ['2015-05-28']);
	__webpack_require__(1035);
	Object.defineProperty(apiLoader.services['iotdata'], '2015-05-28', {
	  get: function get() {
	    var model = __webpack_require__(1759);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.IotData;


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesis'] = {};
	AWS.Kinesis = Service.defineService('kinesis', ['2013-12-02']);
	Object.defineProperty(apiLoader.services['kinesis'], '2013-12-02', {
	  get: function get() {
	    var model = __webpack_require__(1760);
	    model.paginators = __webpack_require__(1761).pagination;
	    model.waiters = __webpack_require__(1762).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Kinesis;


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesisvideo'] = {};
	AWS.KinesisVideo = Service.defineService('kinesisvideo', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideo'], '2017-09-30', {
	  get: function get() {
	    var model = __webpack_require__(1767);
	    model.paginators = __webpack_require__(1768).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KinesisVideo;


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesisvideoarchivedmedia'] = {};
	AWS.KinesisVideoArchivedMedia = Service.defineService('kinesisvideoarchivedmedia', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideoarchivedmedia'], '2017-09-30', {
	  get: function get() {
	    var model = __webpack_require__(1763);
	    model.paginators = __webpack_require__(1764).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KinesisVideoArchivedMedia;


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kinesisvideomedia'] = {};
	AWS.KinesisVideoMedia = Service.defineService('kinesisvideomedia', ['2017-09-30']);
	Object.defineProperty(apiLoader.services['kinesisvideomedia'], '2017-09-30', {
	  get: function get() {
	    var model = __webpack_require__(1765);
	    model.paginators = __webpack_require__(1766).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KinesisVideoMedia;


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['kms'] = {};
	AWS.KMS = Service.defineService('kms', ['2014-11-01']);
	Object.defineProperty(apiLoader.services['kms'], '2014-11-01', {
	  get: function get() {
	    var model = __webpack_require__(1769);
	    model.paginators = __webpack_require__(1770).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.KMS;


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lambda'] = {};
	AWS.Lambda = Service.defineService('lambda', ['2014-11-11', '2015-03-31']);
	__webpack_require__(1036);
	Object.defineProperty(apiLoader.services['lambda'], '2014-11-11', {
	  get: function get() {
	    var model = __webpack_require__(1771);
	    model.paginators = __webpack_require__(1772).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['lambda'], '2015-03-31', {
	  get: function get() {
	    var model = __webpack_require__(1773);
	    model.paginators = __webpack_require__(1774).pagination;
	    model.waiters = __webpack_require__(1775).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Lambda;


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lexmodelbuildingservice'] = {};
	AWS.LexModelBuildingService = Service.defineService('lexmodelbuildingservice', ['2017-04-19']);
	Object.defineProperty(apiLoader.services['lexmodelbuildingservice'], '2017-04-19', {
	  get: function get() {
	    var model = __webpack_require__(1776);
	    model.paginators = __webpack_require__(1777).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.LexModelBuildingService;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['lexruntime'] = {};
	AWS.LexRuntime = Service.defineService('lexruntime', ['2016-11-28']);
	Object.defineProperty(apiLoader.services['lexruntime'], '2016-11-28', {
	  get: function get() {
	    var model = __webpack_require__(1831);
	    model.paginators = __webpack_require__(1832).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.LexRuntime;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['machinelearning'] = {};
	AWS.MachineLearning = Service.defineService('machinelearning', ['2014-12-12']);
	__webpack_require__(1037);
	Object.defineProperty(apiLoader.services['machinelearning'], '2014-12-12', {
	  get: function get() {
	    var model = __webpack_require__(1780);
	    model.paginators = __webpack_require__(1781).pagination;
	    model.waiters = __webpack_require__(1782).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MachineLearning;


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['marketplacecommerceanalytics'] = {};
	AWS.MarketplaceCommerceAnalytics = Service.defineService('marketplacecommerceanalytics', ['2015-07-01']);
	Object.defineProperty(apiLoader.services['marketplacecommerceanalytics'], '2015-07-01', {
	  get: function get() {
	    var model = __webpack_require__(1783);
	    model.paginators = __webpack_require__(1784).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MarketplaceCommerceAnalytics;


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['mediastoredata'] = {};
	AWS.MediaStoreData = Service.defineService('mediastoredata', ['2017-09-01']);
	Object.defineProperty(apiLoader.services['mediastoredata'], '2017-09-01', {
	  get: function get() {
	    var model = __webpack_require__(1785);
	    model.paginators = __webpack_require__(1786).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MediaStoreData;


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['mobileanalytics'] = {};
	AWS.MobileAnalytics = Service.defineService('mobileanalytics', ['2014-06-05']);
	Object.defineProperty(apiLoader.services['mobileanalytics'], '2014-06-05', {
	  get: function get() {
	    var model = __webpack_require__(1788);
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MobileAnalytics;


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['mturk'] = {};
	AWS.MTurk = Service.defineService('mturk', ['2017-01-17']);
	Object.defineProperty(apiLoader.services['mturk'], '2017-01-17', {
	  get: function get() {
	    var model = __webpack_require__(1792);
	    model.paginators = __webpack_require__(1793).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.MTurk;


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['opsworks'] = {};
	AWS.OpsWorks = Service.defineService('opsworks', ['2013-02-18']);
	Object.defineProperty(apiLoader.services['opsworks'], '2013-02-18', {
	  get: function get() {
	    var model = __webpack_require__(1794);
	    model.paginators = __webpack_require__(1795).pagination;
	    model.waiters = __webpack_require__(1796).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.OpsWorks;


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['personalize'] = {};
	AWS.Personalize = Service.defineService('personalize', ['2018-05-22']);
	Object.defineProperty(apiLoader.services['personalize'], '2018-05-22', {
	  get: function get() {
	    var model = __webpack_require__(1797);
	    model.paginators = __webpack_require__(1798).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Personalize;


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['personalizeevents'] = {};
	AWS.PersonalizeEvents = Service.defineService('personalizeevents', ['2018-03-22']);
	Object.defineProperty(apiLoader.services['personalizeevents'], '2018-03-22', {
	  get: function get() {
	    var model = __webpack_require__(1799);
	    model.paginators = __webpack_require__(1800).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.PersonalizeEvents;


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['personalizeruntime'] = {};
	AWS.PersonalizeRuntime = Service.defineService('personalizeruntime', ['2018-05-22']);
	Object.defineProperty(apiLoader.services['personalizeruntime'], '2018-05-22', {
	  get: function get() {
	    var model = __webpack_require__(1801);
	    model.paginators = __webpack_require__(1802).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.PersonalizeRuntime;


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['polly'] = {};
	AWS.Polly = Service.defineService('polly', ['2016-06-10']);
	__webpack_require__(1038);
	Object.defineProperty(apiLoader.services['polly'], '2016-06-10', {
	  get: function get() {
	    var model = __webpack_require__(1803);
	    model.paginators = __webpack_require__(1804).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Polly;


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['pricing'] = {};
	AWS.Pricing = Service.defineService('pricing', ['2017-10-15']);
	Object.defineProperty(apiLoader.services['pricing'], '2017-10-15', {
	  get: function get() {
	    var model = __webpack_require__(1805);
	    model.paginators = __webpack_require__(1806).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Pricing;


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['rds'] = {};
	AWS.RDS = Service.defineService('rds', ['2013-01-10', '2013-02-12', '2013-09-09', '2014-09-01', '2014-09-01*', '2014-10-31']);
	__webpack_require__(1039);
	Object.defineProperty(apiLoader.services['rds'], '2013-01-10', {
	  get: function get() {
	    var model = __webpack_require__(1807);
	    model.paginators = __webpack_require__(1808).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2013-02-12', {
	  get: function get() {
	    var model = __webpack_require__(1809);
	    model.paginators = __webpack_require__(1810).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2013-09-09', {
	  get: function get() {
	    var model = __webpack_require__(1811);
	    model.paginators = __webpack_require__(1812).pagination;
	    model.waiters = __webpack_require__(1813).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2014-09-01', {
	  get: function get() {
	    var model = __webpack_require__(1814);
	    model.paginators = __webpack_require__(1815).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	Object.defineProperty(apiLoader.services['rds'], '2014-10-31', {
	  get: function get() {
	    var model = __webpack_require__(1816);
	    model.paginators = __webpack_require__(1817).pagination;
	    model.waiters = __webpack_require__(1818).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.RDS;


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['redshift'] = {};
	AWS.Redshift = Service.defineService('redshift', ['2012-12-01']);
	Object.defineProperty(apiLoader.services['redshift'], '2012-12-01', {
	  get: function get() {
	    var model = __webpack_require__(1819);
	    model.paginators = __webpack_require__(1820).pagination;
	    model.waiters = __webpack_require__(1821).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Redshift;


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['rekognition'] = {};
	AWS.Rekognition = Service.defineService('rekognition', ['2016-06-27']);
	Object.defineProperty(apiLoader.services['rekognition'], '2016-06-27', {
	  get: function get() {
	    var model = __webpack_require__(1822);
	    model.paginators = __webpack_require__(1823).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Rekognition;


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['resourcegroups'] = {};
	AWS.ResourceGroups = Service.defineService('resourcegroups', ['2017-11-27']);
	Object.defineProperty(apiLoader.services['resourcegroups'], '2017-11-27', {
	  get: function get() {
	    var model = __webpack_require__(1824);
	    model.paginators = __webpack_require__(1825).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ResourceGroups;


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['route53'] = {};
	AWS.Route53 = Service.defineService('route53', ['2013-04-01']);
	__webpack_require__(1040);
	Object.defineProperty(apiLoader.services['route53'], '2013-04-01', {
	  get: function get() {
	    var model = __webpack_require__(1826);
	    model.paginators = __webpack_require__(1827).pagination;
	    model.waiters = __webpack_require__(1828).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Route53;


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['route53domains'] = {};
	AWS.Route53Domains = Service.defineService('route53domains', ['2014-05-15']);
	Object.defineProperty(apiLoader.services['route53domains'], '2014-05-15', {
	  get: function get() {
	    var model = __webpack_require__(1829);
	    model.paginators = __webpack_require__(1830).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Route53Domains;


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['s3'] = {};
	AWS.S3 = Service.defineService('s3', ['2006-03-01']);
	__webpack_require__(1041);
	Object.defineProperty(apiLoader.services['s3'], '2006-03-01', {
	  get: function get() {
	    var model = __webpack_require__(1833);
	    model.paginators = __webpack_require__(1834).pagination;
	    model.waiters = __webpack_require__(1835).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.S3;


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['secretsmanager'] = {};
	AWS.SecretsManager = Service.defineService('secretsmanager', ['2017-10-17']);
	Object.defineProperty(apiLoader.services['secretsmanager'], '2017-10-17', {
	  get: function get() {
	    var model = __webpack_require__(1836);
	    model.paginators = __webpack_require__(1837).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SecretsManager;


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['servicecatalog'] = {};
	AWS.ServiceCatalog = Service.defineService('servicecatalog', ['2015-12-10']);
	Object.defineProperty(apiLoader.services['servicecatalog'], '2015-12-10', {
	  get: function get() {
	    var model = __webpack_require__(1838);
	    model.paginators = __webpack_require__(1839).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.ServiceCatalog;


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ses'] = {};
	AWS.SES = Service.defineService('ses', ['2010-12-01']);
	Object.defineProperty(apiLoader.services['ses'], '2010-12-01', {
	  get: function get() {
	    var model = __webpack_require__(1743);
	    model.paginators = __webpack_require__(1744).pagination;
	    model.waiters = __webpack_require__(1745).waiters;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SES;


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['sns'] = {};
	AWS.SNS = Service.defineService('sns', ['2010-03-31']);
	Object.defineProperty(apiLoader.services['sns'], '2010-03-31', {
	  get: function get() {
	    var model = __webpack_require__(1840);
	    model.paginators = __webpack_require__(1841).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SNS;


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['sqs'] = {};
	AWS.SQS = Service.defineService('sqs', ['2012-11-05']);
	__webpack_require__(1042);
	Object.defineProperty(apiLoader.services['sqs'], '2012-11-05', {
	  get: function get() {
	    var model = __webpack_require__(1842);
	    model.paginators = __webpack_require__(1843).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SQS;


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['ssm'] = {};
	AWS.SSM = Service.defineService('ssm', ['2014-11-06']);
	Object.defineProperty(apiLoader.services['ssm'], '2014-11-06', {
	  get: function get() {
	    var model = __webpack_require__(1844);
	    model.paginators = __webpack_require__(1845).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.SSM;


/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['storagegateway'] = {};
	AWS.StorageGateway = Service.defineService('storagegateway', ['2013-06-30']);
	Object.defineProperty(apiLoader.services['storagegateway'], '2013-06-30', {
	  get: function get() {
	    var model = __webpack_require__(1846);
	    model.paginators = __webpack_require__(1847).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.StorageGateway;


/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['translate'] = {};
	AWS.Translate = Service.defineService('translate', ['2017-07-01']);
	Object.defineProperty(apiLoader.services['translate'], '2017-07-01', {
	  get: function get() {
	    var model = __webpack_require__(1852);
	    model.paginators = __webpack_require__(1853).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.Translate;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['waf'] = {};
	AWS.WAF = Service.defineService('waf', ['2015-08-24']);
	Object.defineProperty(apiLoader.services['waf'], '2015-08-24', {
	  get: function get() {
	    var model = __webpack_require__(1854);
	    model.paginators = __webpack_require__(1855).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.WAF;


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	var AWS = __webpack_require__(4);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['workdocs'] = {};
	AWS.WorkDocs = Service.defineService('workdocs', ['2016-05-01']);
	Object.defineProperty(apiLoader.services['workdocs'], '2016-05-01', {
	  get: function get() {
	    var model = __webpack_require__(1856);
	    model.paginators = __webpack_require__(1857).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.WorkDocs;


/***/ },
/* 993 */
/***/ function(module, exports) {

	function apiLoader(svc, version) {
	  if (!apiLoader.services.hasOwnProperty(svc)) {
	    throw new Error('InvalidService: Failed to load api for ' + svc);
	  }
	  return apiLoader.services[svc][version];
	}
	
	/**
	 * @api private
	 *
	 * This member of AWS.apiLoader is private, but changing it will necessitate a
	 * change to ../scripts/services-table-generator.ts
	 */
	apiLoader.services = {};
	
	/**
	 * @api private
	 */
	module.exports = apiLoader;


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	var Hmac = __webpack_require__(995);
	var Md5 = __webpack_require__(996);
	var Sha1 = __webpack_require__(997);
	var Sha256 = __webpack_require__(998);
	
	/**
	 * @api private
	 */
	module.exports = exports = {
	    createHash: function createHash(alg) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Md5();
	      } else if (alg === 'sha256') {
	        return new Sha256();
	      } else if (alg === 'sha1') {
	        return new Sha1();
	      }
	
	      throw new Error('Hash algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createHmac: function createHmac(alg, key) {
	      alg = alg.toLowerCase();
	      if (alg === 'md5') {
	        return new Hmac(Md5, key);
	      } else if (alg === 'sha256') {
	        return new Hmac(Sha256, key);
	      } else if (alg === 'sha1') {
	        return new Hmac(Sha1, key);
	      }
	
	      throw new Error('HMAC algorithm ' + alg + ' is not supported in the browser SDK');
	    },
	    createSign: function() {
	      throw new Error('createSign is not implemented in the browser');
	    }
	  };


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	var hashUtils = __webpack_require__(190);
	
	/**
	 * @api private
	 */
	function Hmac(hashCtor, secret) {
	    this.hash = new hashCtor();
	    this.outer = new hashCtor();
	
	    var inner = bufferFromSecret(hashCtor, secret);
	    var outer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    outer.set(inner);
	
	    for (var i = 0; i < hashCtor.BLOCK_SIZE; i++) {
	        inner[i] ^= 0x36;
	        outer[i] ^= 0x5c;
	    }
	
	    this.hash.update(inner);
	    this.outer.update(outer);
	
	    // Zero out the copied key buffer.
	    for (var i = 0; i < inner.byteLength; i++) {
	        inner[i] = 0;
	    }
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Hmac;
	
	Hmac.prototype.update = function (toHash) {
	    if (hashUtils.isEmptyData(toHash) || this.error) {
	        return this;
	    }
	
	    try {
	        this.hash.update(hashUtils.convertToBuffer(toHash));
	    } catch (e) {
	        this.error = e;
	    }
	
	    return this;
	};
	
	Hmac.prototype.digest = function (encoding) {
	    if (!this.outer.finished) {
	        this.outer.update(this.hash.digest());
	    }
	
	    return this.outer.digest(encoding);
	};
	
	function bufferFromSecret(hashCtor, secret) {
	    var input = hashUtils.convertToBuffer(secret);
	    if (input.byteLength > hashCtor.BLOCK_SIZE) {
	        var bufferHash = new hashCtor;
	        bufferHash.update(input);
	        input = bufferHash.digest();
	    }
	    var buffer = new Uint8Array(hashCtor.BLOCK_SIZE);
	    buffer.set(input);
	    return buffer;
	}


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	var hashUtils = __webpack_require__(190);
	var Buffer = __webpack_require__(100).Buffer;
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 16;
	
	var INIT = [
	    0x67452301,
	    0xefcdab89,
	    0x98badcfe,
	    0x10325476,
	];
	
	/**
	 * @api private
	 */
	function Md5() {
	    this.state = [
	        0x67452301,
	        0xefcdab89,
	        0x98badcfe,
	        0x10325476,
	    ];
	    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    this.finished = false;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Md5;
	
	Md5.BLOCK_SIZE = BLOCK_SIZE;
	
	Md5.prototype.update = function (sourceData) {
	    if (hashUtils.isEmptyData(sourceData)) {
	        return this;
	    } else if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    var data = hashUtils.convertToBuffer(sourceData);
	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    while (byteLength > 0) {
	        this.buffer.setUint8(this.bufferLength++, data[position++]);
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }
	
	    return this;
	};
	
	Md5.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var _a = this, buffer = _a.buffer, undecoratedLength = _a.bufferLength, bytesHashed = _a.bytesHashed;
	        var bitsHashed = bytesHashed * 8;
	        buffer.setUint8(this.bufferLength++, 128);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                buffer.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            buffer.setUint8(i, 0);
	        }
	        buffer.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
	        buffer.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 0x100000000), true);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    var out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
	    for (var i = 0; i < 4; i++) {
	        out.setUint32(i * 4, this.state[i], true);
	    }
	    var buff = new Buffer(out.buffer, out.byteOffset, out.byteLength);
	    return encoding ? buff.toString(encoding) : buff;
	};
	
	Md5.prototype.hashBuffer = function () {
	    var _a = this, buffer = _a.buffer, state = _a.state;
	    var a = state[0], b = state[1], c = state[2], d = state[3];
	    a = ff(a, b, c, d, buffer.getUint32(0, true), 7, 0xd76aa478);
	    d = ff(d, a, b, c, buffer.getUint32(4, true), 12, 0xe8c7b756);
	    c = ff(c, d, a, b, buffer.getUint32(8, true), 17, 0x242070db);
	    b = ff(b, c, d, a, buffer.getUint32(12, true), 22, 0xc1bdceee);
	    a = ff(a, b, c, d, buffer.getUint32(16, true), 7, 0xf57c0faf);
	    d = ff(d, a, b, c, buffer.getUint32(20, true), 12, 0x4787c62a);
	    c = ff(c, d, a, b, buffer.getUint32(24, true), 17, 0xa8304613);
	    b = ff(b, c, d, a, buffer.getUint32(28, true), 22, 0xfd469501);
	    a = ff(a, b, c, d, buffer.getUint32(32, true), 7, 0x698098d8);
	    d = ff(d, a, b, c, buffer.getUint32(36, true), 12, 0x8b44f7af);
	    c = ff(c, d, a, b, buffer.getUint32(40, true), 17, 0xffff5bb1);
	    b = ff(b, c, d, a, buffer.getUint32(44, true), 22, 0x895cd7be);
	    a = ff(a, b, c, d, buffer.getUint32(48, true), 7, 0x6b901122);
	    d = ff(d, a, b, c, buffer.getUint32(52, true), 12, 0xfd987193);
	    c = ff(c, d, a, b, buffer.getUint32(56, true), 17, 0xa679438e);
	    b = ff(b, c, d, a, buffer.getUint32(60, true), 22, 0x49b40821);
	    a = gg(a, b, c, d, buffer.getUint32(4, true), 5, 0xf61e2562);
	    d = gg(d, a, b, c, buffer.getUint32(24, true), 9, 0xc040b340);
	    c = gg(c, d, a, b, buffer.getUint32(44, true), 14, 0x265e5a51);
	    b = gg(b, c, d, a, buffer.getUint32(0, true), 20, 0xe9b6c7aa);
	    a = gg(a, b, c, d, buffer.getUint32(20, true), 5, 0xd62f105d);
	    d = gg(d, a, b, c, buffer.getUint32(40, true), 9, 0x02441453);
	    c = gg(c, d, a, b, buffer.getUint32(60, true), 14, 0xd8a1e681);
	    b = gg(b, c, d, a, buffer.getUint32(16, true), 20, 0xe7d3fbc8);
	    a = gg(a, b, c, d, buffer.getUint32(36, true), 5, 0x21e1cde6);
	    d = gg(d, a, b, c, buffer.getUint32(56, true), 9, 0xc33707d6);
	    c = gg(c, d, a, b, buffer.getUint32(12, true), 14, 0xf4d50d87);
	    b = gg(b, c, d, a, buffer.getUint32(32, true), 20, 0x455a14ed);
	    a = gg(a, b, c, d, buffer.getUint32(52, true), 5, 0xa9e3e905);
	    d = gg(d, a, b, c, buffer.getUint32(8, true), 9, 0xfcefa3f8);
	    c = gg(c, d, a, b, buffer.getUint32(28, true), 14, 0x676f02d9);
	    b = gg(b, c, d, a, buffer.getUint32(48, true), 20, 0x8d2a4c8a);
	    a = hh(a, b, c, d, buffer.getUint32(20, true), 4, 0xfffa3942);
	    d = hh(d, a, b, c, buffer.getUint32(32, true), 11, 0x8771f681);
	    c = hh(c, d, a, b, buffer.getUint32(44, true), 16, 0x6d9d6122);
	    b = hh(b, c, d, a, buffer.getUint32(56, true), 23, 0xfde5380c);
	    a = hh(a, b, c, d, buffer.getUint32(4, true), 4, 0xa4beea44);
	    d = hh(d, a, b, c, buffer.getUint32(16, true), 11, 0x4bdecfa9);
	    c = hh(c, d, a, b, buffer.getUint32(28, true), 16, 0xf6bb4b60);
	    b = hh(b, c, d, a, buffer.getUint32(40, true), 23, 0xbebfbc70);
	    a = hh(a, b, c, d, buffer.getUint32(52, true), 4, 0x289b7ec6);
	    d = hh(d, a, b, c, buffer.getUint32(0, true), 11, 0xeaa127fa);
	    c = hh(c, d, a, b, buffer.getUint32(12, true), 16, 0xd4ef3085);
	    b = hh(b, c, d, a, buffer.getUint32(24, true), 23, 0x04881d05);
	    a = hh(a, b, c, d, buffer.getUint32(36, true), 4, 0xd9d4d039);
	    d = hh(d, a, b, c, buffer.getUint32(48, true), 11, 0xe6db99e5);
	    c = hh(c, d, a, b, buffer.getUint32(60, true), 16, 0x1fa27cf8);
	    b = hh(b, c, d, a, buffer.getUint32(8, true), 23, 0xc4ac5665);
	    a = ii(a, b, c, d, buffer.getUint32(0, true), 6, 0xf4292244);
	    d = ii(d, a, b, c, buffer.getUint32(28, true), 10, 0x432aff97);
	    c = ii(c, d, a, b, buffer.getUint32(56, true), 15, 0xab9423a7);
	    b = ii(b, c, d, a, buffer.getUint32(20, true), 21, 0xfc93a039);
	    a = ii(a, b, c, d, buffer.getUint32(48, true), 6, 0x655b59c3);
	    d = ii(d, a, b, c, buffer.getUint32(12, true), 10, 0x8f0ccc92);
	    c = ii(c, d, a, b, buffer.getUint32(40, true), 15, 0xffeff47d);
	    b = ii(b, c, d, a, buffer.getUint32(4, true), 21, 0x85845dd1);
	    a = ii(a, b, c, d, buffer.getUint32(32, true), 6, 0x6fa87e4f);
	    d = ii(d, a, b, c, buffer.getUint32(60, true), 10, 0xfe2ce6e0);
	    c = ii(c, d, a, b, buffer.getUint32(24, true), 15, 0xa3014314);
	    b = ii(b, c, d, a, buffer.getUint32(52, true), 21, 0x4e0811a1);
	    a = ii(a, b, c, d, buffer.getUint32(16, true), 6, 0xf7537e82);
	    d = ii(d, a, b, c, buffer.getUint32(44, true), 10, 0xbd3af235);
	    c = ii(c, d, a, b, buffer.getUint32(8, true), 15, 0x2ad7d2bb);
	    b = ii(b, c, d, a, buffer.getUint32(36, true), 21, 0xeb86d391);
	    state[0] = (a + state[0]) & 0xFFFFFFFF;
	    state[1] = (b + state[1]) & 0xFFFFFFFF;
	    state[2] = (c + state[2]) & 0xFFFFFFFF;
	    state[3] = (d + state[3]) & 0xFFFFFFFF;
	};
	
	function cmn(q, a, b, x, s, t) {
	    a = (((a + q) & 0xFFFFFFFF) + ((x + t) & 0xFFFFFFFF)) & 0xFFFFFFFF;
	    return (((a << s) | (a >>> (32 - s))) + b) & 0xFFFFFFFF;
	}
	
	function ff(a, b, c, d, x, s, t) {
	    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	
	function gg(a, b, c, d, x, s, t) {
	    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	
	function hh(a, b, c, d, x, s, t) {
	    return cmn(b ^ c ^ d, a, b, x, s, t);
	}
	
	function ii(a, b, c, d, x, s, t) {
	    return cmn(c ^ (b | (~d)), a, b, x, s, t);
	}


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(100).Buffer;
	var hashUtils = __webpack_require__(190);
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 20;
	
	var KEY = new Uint32Array([
	    0x5a827999,
	    0x6ed9eba1,
	    0x8f1bbcdc | 0,
	    0xca62c1d6 | 0
	]);
	
	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];
	
	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
	
	/**
	 * @api private
	 */
	function Sha1() {
	    this.h0 = 0x67452301;
	    this.h1 = 0xEFCDAB89;
	    this.h2 = 0x98BADCFE;
	    this.h3 = 0x10325476;
	    this.h4 = 0xC3D2E1F0;
	    // The first 64 bytes (16 words) is the data chunk
	    this.block = new Uint32Array(80);
	    this.offset = 0;
	    this.shift = 24;
	    this.totalLength = 0;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Sha1;
	
	Sha1.BLOCK_SIZE = BLOCK_SIZE;
	
	Sha1.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }
	
	    data = hashUtils.convertToBuffer(data);
	
	    var length = data.length;
	    this.totalLength += length * 8;
	    for (var i = 0; i < length; i++) {
	        this.write(data[i]);
	    }
	
	    return this;
	};
	
	Sha1.prototype.write = function write(byte) {
	    this.block[this.offset] |= (byte & 0xff) << this.shift;
	    if (this.shift) {
	        this.shift -= 8;
	    } else {
	        this.offset++;
	        this.shift = 24;
	    }
	
	    if (this.offset === 16) this.processBlock();
	};
	
	Sha1.prototype.digest = function (encoding) {
	    // Pad
	    this.write(0x80);
	    if (this.offset > 14 || (this.offset === 14 && this.shift < 24)) {
	      this.processBlock();
	    }
	    this.offset = 14;
	    this.shift = 24;
	
	    // 64-bit length big-endian
	    this.write(0x00); // numbers this big aren't accurate in javascript anyway
	    this.write(0x00); // ..So just hard-code to zero.
	    this.write(this.totalLength > 0xffffffffff ? this.totalLength / 0x10000000000 : 0x00);
	    this.write(this.totalLength > 0xffffffff ? this.totalLength / 0x100000000 : 0x00);
	    for (var s = 24; s >= 0; s -= 8) {
	        this.write(this.totalLength >> s);
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    var outView = new DataView(out.buffer);
	    outView.setUint32(0, this.h0, false);
	    outView.setUint32(4, this.h1, false);
	    outView.setUint32(8, this.h2, false);
	    outView.setUint32(12, this.h3, false);
	    outView.setUint32(16, this.h4, false);
	
	    return encoding ? out.toString(encoding) : out;
	};
	
	Sha1.prototype.processBlock = function processBlock() {
	    // Extend the sixteen 32-bit words into eighty 32-bit words:
	    for (var i = 16; i < 80; i++) {
	      var w = this.block[i - 3] ^ this.block[i - 8] ^ this.block[i - 14] ^ this.block[i - 16];
	      this.block[i] = (w << 1) | (w >>> 31);
	    }
	
	    // Initialize hash value for this chunk:
	    var a = this.h0;
	    var b = this.h1;
	    var c = this.h2;
	    var d = this.h3;
	    var e = this.h4;
	    var f, k;
	
	    // Main loop:
	    for (i = 0; i < 80; i++) {
	      if (i < 20) {
	        f = d ^ (b & (c ^ d));
	        k = 0x5A827999;
	      }
	      else if (i < 40) {
	        f = b ^ c ^ d;
	        k = 0x6ED9EBA1;
	      }
	      else if (i < 60) {
	        f = (b & c) | (d & (b | c));
	        k = 0x8F1BBCDC;
	      }
	      else {
	        f = b ^ c ^ d;
	        k = 0xCA62C1D6;
	      }
	      var temp = (a << 5 | a >>> 27) + f + e + k + (this.block[i]|0);
	      e = d;
	      d = c;
	      c = (b << 30 | b >>> 2);
	      b = a;
	      a = temp;
	    }
	
	    // Add this chunk's hash to result so far:
	    this.h0 = (this.h0 + a) | 0;
	    this.h1 = (this.h1 + b) | 0;
	    this.h2 = (this.h2 + c) | 0;
	    this.h3 = (this.h3 + d) | 0;
	    this.h4 = (this.h4 + e) | 0;
	
	    // The block is now reusable.
	    this.offset = 0;
	    for (i = 0; i < 16; i++) {
	        this.block[i] = 0;
	    }
	};


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	var Buffer = __webpack_require__(100).Buffer;
	var hashUtils = __webpack_require__(190);
	
	var BLOCK_SIZE = 64;
	
	var DIGEST_LENGTH = 32;
	
	var KEY = new Uint32Array([
	    0x428a2f98,
	    0x71374491,
	    0xb5c0fbcf,
	    0xe9b5dba5,
	    0x3956c25b,
	    0x59f111f1,
	    0x923f82a4,
	    0xab1c5ed5,
	    0xd807aa98,
	    0x12835b01,
	    0x243185be,
	    0x550c7dc3,
	    0x72be5d74,
	    0x80deb1fe,
	    0x9bdc06a7,
	    0xc19bf174,
	    0xe49b69c1,
	    0xefbe4786,
	    0x0fc19dc6,
	    0x240ca1cc,
	    0x2de92c6f,
	    0x4a7484aa,
	    0x5cb0a9dc,
	    0x76f988da,
	    0x983e5152,
	    0xa831c66d,
	    0xb00327c8,
	    0xbf597fc7,
	    0xc6e00bf3,
	    0xd5a79147,
	    0x06ca6351,
	    0x14292967,
	    0x27b70a85,
	    0x2e1b2138,
	    0x4d2c6dfc,
	    0x53380d13,
	    0x650a7354,
	    0x766a0abb,
	    0x81c2c92e,
	    0x92722c85,
	    0xa2bfe8a1,
	    0xa81a664b,
	    0xc24b8b70,
	    0xc76c51a3,
	    0xd192e819,
	    0xd6990624,
	    0xf40e3585,
	    0x106aa070,
	    0x19a4c116,
	    0x1e376c08,
	    0x2748774c,
	    0x34b0bcb5,
	    0x391c0cb3,
	    0x4ed8aa4a,
	    0x5b9cca4f,
	    0x682e6ff3,
	    0x748f82ee,
	    0x78a5636f,
	    0x84c87814,
	    0x8cc70208,
	    0x90befffa,
	    0xa4506ceb,
	    0xbef9a3f7,
	    0xc67178f2
	]);
	
	var INIT = [
	    0x6a09e667,
	    0xbb67ae85,
	    0x3c6ef372,
	    0xa54ff53a,
	    0x510e527f,
	    0x9b05688c,
	    0x1f83d9ab,
	    0x5be0cd19,
	];
	
	var MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
	
	/**
	 * @private
	 */
	function Sha256() {
	    this.state = [
	        0x6a09e667,
	        0xbb67ae85,
	        0x3c6ef372,
	        0xa54ff53a,
	        0x510e527f,
	        0x9b05688c,
	        0x1f83d9ab,
	        0x5be0cd19,
	    ];
	    this.temp = new Int32Array(64);
	    this.buffer = new Uint8Array(64);
	    this.bufferLength = 0;
	    this.bytesHashed = 0;
	    /**
	     * @private
	     */
	    this.finished = false;
	}
	
	/**
	 * @api private
	 */
	module.exports = exports = Sha256;
	
	Sha256.BLOCK_SIZE = BLOCK_SIZE;
	
	Sha256.prototype.update = function (data) {
	    if (this.finished) {
	        throw new Error('Attempted to update an already finished hash.');
	    }
	
	    if (hashUtils.isEmptyData(data)) {
	        return this;
	    }
	
	    data = hashUtils.convertToBuffer(data);
	
	    var position = 0;
	    var byteLength = data.byteLength;
	    this.bytesHashed += byteLength;
	    if (this.bytesHashed * 8 > MAX_HASHABLE_LENGTH) {
	        throw new Error('Cannot hash more than 2^53 - 1 bits');
	    }
	
	    while (byteLength > 0) {
	        this.buffer[this.bufferLength++] = data[position++];
	        byteLength--;
	        if (this.bufferLength === BLOCK_SIZE) {
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	    }
	
	    return this;
	};
	
	Sha256.prototype.digest = function (encoding) {
	    if (!this.finished) {
	        var bitsHashed = this.bytesHashed * 8;
	        var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
	        var undecoratedLength = this.bufferLength;
	        bufferView.setUint8(this.bufferLength++, 0x80);
	        // Ensure the final block has enough room for the hashed length
	        if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
	            for (var i = this.bufferLength; i < BLOCK_SIZE; i++) {
	                bufferView.setUint8(i, 0);
	            }
	            this.hashBuffer();
	            this.bufferLength = 0;
	        }
	        for (var i = this.bufferLength; i < BLOCK_SIZE - 8; i++) {
	            bufferView.setUint8(i, 0);
	        }
	        bufferView.setUint32(BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
	        bufferView.setUint32(BLOCK_SIZE - 4, bitsHashed);
	        this.hashBuffer();
	        this.finished = true;
	    }
	    // The value in state is little-endian rather than big-endian, so flip
	    // each word into a new Uint8Array
	    var out = new Buffer(DIGEST_LENGTH);
	    for (var i = 0; i < 8; i++) {
	        out[i * 4] = (this.state[i] >>> 24) & 0xff;
	        out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
	        out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
	        out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
	    }
	    return encoding ? out.toString(encoding) : out;
	};
	
	Sha256.prototype.hashBuffer = function () {
	    var _a = this,
	        buffer = _a.buffer,
	        state = _a.state;
	    var state0 = state[0],
	        state1 = state[1],
	        state2 = state[2],
	        state3 = state[3],
	        state4 = state[4],
	        state5 = state[5],
	        state6 = state[6],
	        state7 = state[7];
	    for (var i = 0; i < BLOCK_SIZE; i++) {
	        if (i < 16) {
	            this.temp[i] = (((buffer[i * 4] & 0xff) << 24) |
	                ((buffer[(i * 4) + 1] & 0xff) << 16) |
	                ((buffer[(i * 4) + 2] & 0xff) << 8) |
	                (buffer[(i * 4) + 3] & 0xff));
	        }
	        else {
	            var u = this.temp[i - 2];
	            var t1_1 = (u >>> 17 | u << 15) ^
	                (u >>> 19 | u << 13) ^
	                (u >>> 10);
	            u = this.temp[i - 15];
	            var t2_1 = (u >>> 7 | u << 25) ^
	                (u >>> 18 | u << 14) ^
	                (u >>> 3);
	            this.temp[i] = (t1_1 + this.temp[i - 7] | 0) +
	                (t2_1 + this.temp[i - 16] | 0);
	        }
	        var t1 = (((((state4 >>> 6 | state4 << 26) ^
	            (state4 >>> 11 | state4 << 21) ^
	            (state4 >>> 25 | state4 << 7))
	            + ((state4 & state5) ^ (~state4 & state6))) | 0)
	            + ((state7 + ((KEY[i] + this.temp[i]) | 0)) | 0)) | 0;
	        var t2 = (((state0 >>> 2 | state0 << 30) ^
	            (state0 >>> 13 | state0 << 19) ^
	            (state0 >>> 22 | state0 << 10)) + ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) | 0;
	        state7 = state6;
	        state6 = state5;
	        state5 = state4;
	        state4 = (state3 + t1) | 0;
	        state3 = state2;
	        state2 = state1;
	        state1 = state0;
	        state0 = (t1 + t2) | 0;
	    }
	    state[0] += state0;
	    state[1] += state1;
	    state[2] += state2;
	    state[3] += state3;
	    state[4] += state4;
	    state[5] += state5;
	    state[6] += state6;
	    state[7] += state7;
	};


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4),
	    url = AWS.util.url,
	    crypto = AWS.util.crypto.lib,
	    base64Encode = AWS.util.base64.encode,
	    inherit = AWS.util.inherit;
	
	var queryEncode = function (string) {
	    var replacements = {
	        '+': '-',
	        '=': '_',
	        '/': '~'
	    };
	    return string.replace(/[\+=\/]/g, function (match) {
	        return replacements[match];
	    });
	};
	
	var signPolicy = function (policy, privateKey) {
	    var sign = crypto.createSign('RSA-SHA1');
	    sign.write(policy);
	    return queryEncode(sign.sign(privateKey, 'base64'));
	};
	
	var signWithCannedPolicy = function (url, expires, keyPairId, privateKey) {
	    var policy = JSON.stringify({
	        Statement: [
	            {
	                Resource: url,
	                Condition: { DateLessThan: { 'AWS:EpochTime': expires } }
	            }
	        ]
	    });
	
	    return {
	        Expires: expires,
	        'Key-Pair-Id': keyPairId,
	        Signature: signPolicy(policy.toString(), privateKey)
	    };
	};
	
	var signWithCustomPolicy = function (policy, keyPairId, privateKey) {
	    policy = policy.replace(/\s/mg, '');
	
	    return {
	        Policy: queryEncode(base64Encode(policy)),
	        'Key-Pair-Id': keyPairId,
	        Signature: signPolicy(policy, privateKey)
	    };
	};
	
	var determineScheme = function (url) {
	    var parts = url.split('://');
	    if (parts.length < 2) {
	        throw new Error('Invalid URL.');
	    }
	
	    return parts[0].replace('*', '');
	};
	
	var getRtmpUrl = function (rtmpUrl) {
	    var parsed = url.parse(rtmpUrl);
	    return parsed.path.replace(/^\//, '') + (parsed.hash || '');
	};
	
	var getResource = function (url) {
	    switch (determineScheme(url)) {
	        case 'http':
	        case 'https':
	            return url;
	        case 'rtmp':
	            return getRtmpUrl(url);
	        default:
	            throw new Error('Invalid URI scheme. Scheme must be one of'
	                + ' http, https, or rtmp');
	    }
	};
	
	var handleError = function (err, callback) {
	    if (!callback || typeof callback !== 'function') {
	        throw err;
	    }
	
	    callback(err);
	};
	
	var handleSuccess = function (result, callback) {
	    if (!callback || typeof callback !== 'function') {
	        return result;
	    }
	
	    callback(null, result);
	};
	
	AWS.CloudFront.Signer = inherit({
	    /**
	     * A signer object can be used to generate signed URLs and cookies for granting
	     * access to content on restricted CloudFront distributions.
	     *
	     * @see http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/PrivateContent.html
	     *
	     * @param keyPairId [String]    (Required) The ID of the CloudFront key pair
	     *                              being used.
	     * @param privateKey [String]   (Required) A private key in RSA format.
	     */
	    constructor: function Signer(keyPairId, privateKey) {
	        if (keyPairId === void 0 || privateKey === void 0) {
	            throw new Error('A key pair ID and private key are required');
	        }
	
	        this.keyPairId = keyPairId;
	        this.privateKey = privateKey;
	    },
	
	    /**
	     * Create a signed Amazon CloudFront Cookie.
	     *
	     * @param options [Object]            The options to create a signed cookie.
	     * @option options url [String]     The URL to which the signature will grant
	     *                                  access. Required unless you pass in a full
	     *                                  policy.
	     * @option options expires [Number] A Unix UTC timestamp indicating when the
	     *                                  signature should expire. Required unless you
	     *                                  pass in a full policy.
	     * @option options policy [String]  A CloudFront JSON policy. Required unless
	     *                                  you pass in a url and an expiry time.
	     *
	     * @param cb [Function] if a callback is provided, this function will
	     *   pass the hash as the second parameter (after the error parameter) to
	     *   the callback function.
	     *
	     * @return [Object] if called synchronously (with no callback), returns the
	     *   signed cookie parameters.
	     * @return [null] nothing is returned if a callback is provided.
	     */
	    getSignedCookie: function (options, cb) {
	        var signatureHash = 'policy' in options
	            ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
	            : signWithCannedPolicy(options.url, options.expires, this.keyPairId, this.privateKey);
	
	        var cookieHash = {};
	        for (var key in signatureHash) {
	            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
	                cookieHash['CloudFront-' + key] = signatureHash[key];
	            }
	        }
	
	        return handleSuccess(cookieHash, cb);
	    },
	
	    /**
	     * Create a signed Amazon CloudFront URL.
	     *
	     * Keep in mind that URLs meant for use in media/flash players may have
	     * different requirements for URL formats (e.g. some require that the
	     * extension be removed, some require the file name to be prefixed
	     * - mp4:<path>, some require you to add "/cfx/st" into your URL).
	     *
	     * @param options [Object]          The options to create a signed URL.
	     * @option options url [String]     The URL to which the signature will grant
	     *                                  access. Any query params included with
	     *                                  the URL should be encoded. Required.
	     * @option options expires [Number] A Unix UTC timestamp indicating when the
	     *                                  signature should expire. Required unless you
	     *                                  pass in a full policy.
	     * @option options policy [String]  A CloudFront JSON policy. Required unless
	     *                                  you pass in a url and an expiry time.
	     *
	     * @param cb [Function] if a callback is provided, this function will
	     *   pass the URL as the second parameter (after the error parameter) to
	     *   the callback function.
	     *
	     * @return [String] if called synchronously (with no callback), returns the
	     *   signed URL.
	     * @return [null] nothing is returned if a callback is provided.
	     */
	    getSignedUrl: function (options, cb) {
	        try {
	            var resource = getResource(options.url);
	        } catch (err) {
	            return handleError(err, cb);
	        }
	
	        var parsedUrl = url.parse(options.url, true),
	            signatureHash = Object.prototype.hasOwnProperty.call(options, 'policy')
	                ? signWithCustomPolicy(options.policy, this.keyPairId, this.privateKey)
	                : signWithCannedPolicy(resource, options.expires, this.keyPairId, this.privateKey);
	
	        parsedUrl.search = null;
	        for (var key in signatureHash) {
	            if (Object.prototype.hasOwnProperty.call(signatureHash, key)) {
	                parsedUrl.query[key] = signatureHash[key];
	            }
	        }
	
	        try {
	            var signedUrl = determineScheme(options.url) === 'rtmp'
	                    ? getRtmpUrl(url.format(parsedUrl))
	                    : url.format(parsedUrl);
	        } catch (err) {
	            return handleError(err, cb);
	        }
	
	        return handleSuccess(signedUrl, cb);
	    }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.CloudFront.Signer;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	__webpack_require__(422);
	__webpack_require__(423);
	var PromisesDependency;
	
	/**
	 * The main configuration class used by all service objects to set
	 * the region, credentials, and other options for requests.
	 *
	 * By default, credentials and region settings are left unconfigured.
	 * This should be configured by the application before using any
	 * AWS service APIs.
	 *
	 * In order to set global configuration options, properties should
	 * be assigned to the global {AWS.config} object.
	 *
	 * @see AWS.config
	 *
	 * @!group General Configuration Options
	 *
	 * @!attribute credentials
	 *   @return [AWS.Credentials] the AWS credentials to sign requests with.
	 *
	 * @!attribute region
	 *   @example Set the global region setting to us-west-2
	 *     AWS.config.update({region: 'us-west-2'});
	 *   @return [AWS.Credentials] The region to send service requests to.
	 *   @see http://docs.amazonwebservices.com/general/latest/gr/rande.html
	 *     A list of available endpoints for each AWS service
	 *
	 * @!attribute maxRetries
	 *   @return [Integer] the maximum amount of retries to perform for a
	 *     service request. By default this value is calculated by the specific
	 *     service object that the request is being made to.
	 *
	 * @!attribute maxRedirects
	 *   @return [Integer] the maximum amount of redirects to follow for a
	 *     service request. Defaults to 10.
	 *
	 * @!attribute paramValidation
	 *   @return [Boolean|map] whether input parameters should be validated against
	 *     the operation description before sending the request. Defaults to true.
	 *     Pass a map to enable any of the following specific validation features:
	 *
	 *     * **min** [Boolean] &mdash; Validates that a value meets the min
	 *       constraint. This is enabled by default when paramValidation is set
	 *       to `true`.
	 *     * **max** [Boolean] &mdash; Validates that a value meets the max
	 *       constraint.
	 *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	 *       regular expression.
	 *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	 *       of the allowable enum values.
	 *
	 * @!attribute computeChecksums
	 *   @return [Boolean] whether to compute checksums for payload bodies when
	 *     the service accepts it (currently supported in S3 only).
	 *
	 * @!attribute convertResponseTypes
	 *   @return [Boolean] whether types are converted when parsing response data.
	 *     Currently only supported for JSON based services. Turning this off may
	 *     improve performance on large response payloads. Defaults to `true`.
	 *
	 * @!attribute correctClockSkew
	 *   @return [Boolean] whether to apply a clock skew correction and retry
	 *     requests that fail because of an skewed client clock. Defaults to
	 *     `false`.
	 *
	 * @!attribute sslEnabled
	 *   @return [Boolean] whether SSL is enabled for requests
	 *
	 * @!attribute s3ForcePathStyle
	 *   @return [Boolean] whether to force path style URLs for S3 objects
	 *
	 * @!attribute s3BucketEndpoint
	 *   @note Setting this configuration option requires an `endpoint` to be
	 *     provided explicitly to the service constructor.
	 *   @return [Boolean] whether the provided endpoint addresses an individual
	 *     bucket (false if it addresses the root API endpoint).
	 *
	 * @!attribute s3DisableBodySigning
	 *   @return [Boolean] whether to disable S3 body signing when using signature version `v4`.
	 *     Body signing can only be disabled when using https. Defaults to `true`.
	 *
	 * @!attribute useAccelerateEndpoint
	 *   @note This configuration option is only compatible with S3 while accessing
	 *     dns-compatible buckets.
	 *   @return [Boolean] Whether to use the Accelerate endpoint with the S3 service.
	 *     Defaults to `false`.
	 *
	 * @!attribute retryDelayOptions
	 *   @example Set the base retry delay for all services to 300 ms
	 *     AWS.config.update({retryDelayOptions: {base: 300}});
	 *     // Delays with maxRetries = 3: 300, 600, 1200
	 *   @example Set a custom backoff function to provide delay values on retries
	 *     AWS.config.update({retryDelayOptions: {customBackoff: function(retryCount) {
	 *       // returns delay in ms
	 *     }}});
	 *   @return [map] A set of options to configure the retry delay on retryable errors.
	 *     Currently supported options are:
	 *
	 *     * **base** [Integer] &mdash; The base number of milliseconds to use in the
	 *       exponential backoff for operation retries. Defaults to 100 ms for all services except
	 *       DynamoDB, where it defaults to 50ms.
	 *     * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
	 *       and returns the amount of time to delay in milliseconds. The `base` option will be
	 *       ignored if this option is supplied.
	 *
	 * @!attribute httpOptions
	 *   @return [map] A set of options to pass to the low-level HTTP request.
	 *     Currently supported options are:
	 *
	 *     * **proxy** [String] &mdash; the URL to proxy requests through
	 *     * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	 *       HTTP requests with. Used for connection pooling. Note that for
	 *       SSL connections, a special Agent object is used in order to enable
	 *       peer certificate verification. This feature is only supported in the
	 *       Node.js environment.
	 *     * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	 *       failing to establish a connection with the server after
	 *       `connectTimeout` milliseconds. This timeout has no effect once a socket
	 *       connection has been established.
	 *     * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
	 *       milliseconds of inactivity on the socket. Defaults to two minutes
	 *       (120000)
	 *     * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	 *       HTTP requests. Used in the browser environment only. Set to false to
	 *       send requests synchronously. Defaults to true (async on).
	 *     * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	 *       property of an XMLHttpRequest object. Used in the browser environment
	 *       only. Defaults to false.
	 * @!attribute logger
	 *   @return [#write,#log] an object that responds to .write() (like a stream)
	 *     or .log() (like the console object) in order to log information about
	 *     requests
	 *
	 * @!attribute systemClockOffset
	 *   @return [Number] an offset value in milliseconds to apply to all signing
	 *     times. Use this to compensate for clock skew when your system may be
	 *     out of sync with the service time. Note that this configuration option
	 *     can only be applied to the global `AWS.config` object and cannot be
	 *     overridden in service-specific configuration. Defaults to 0 milliseconds.
	 *
	 * @!attribute signatureVersion
	 *   @return [String] the signature version to sign requests with (overriding
	 *     the API configuration). Possible values are: 'v2', 'v3', 'v4'.
	 *
	 * @!attribute signatureCache
	 *   @return [Boolean] whether the signature to sign requests with (overriding
	 *     the API configuration) is cached. Only applies to the signature version 'v4'.
	 *     Defaults to `true`.
	 *
	 * @!attribute endpointDiscoveryEnabled
	 *   @return [Boolean] whether to enable endpoint discovery for operations that
	 *     allow optionally using an endpoint returned by the service.
	 *     Defaults to 'false'
	 *
	 * @!attribute endpointCacheSize
	 *   @return [Number] the size of the global cache storing endpoints from endpoint
	 *     discovery operations. Once endpoint cache is created, updating this setting
	 *     cannot change existing cache size.
	 *     Defaults to 1000
	 *
	 * @!attribute hostPrefixEnabled
	 *   @return [Boolean] whether to marshal request parameters to the prefix of
	 *     hostname. Defaults to `true`.
	 */
	AWS.Config = AWS.util.inherit({
	  /**
	   * @!endgroup
	   */
	
	  /**
	   * Creates a new configuration object. This is the object that passes
	   * option data along to service requests, including credentials, security,
	   * region information, and some service specific settings.
	   *
	   * @example Creating a new configuration object with credentials and region
	   *   var config = new AWS.Config({
	   *     accessKeyId: 'AKID', secretAccessKey: 'SECRET', region: 'us-west-2'
	   *   });
	   * @option options accessKeyId [String] your AWS access key ID.
	   * @option options secretAccessKey [String] your AWS secret access key.
	   * @option options sessionToken [AWS.Credentials] the optional AWS
	   *   session token to sign requests with.
	   * @option options credentials [AWS.Credentials] the AWS credentials
	   *   to sign requests with. You can either specify this object, or
	   *   specify the accessKeyId and secretAccessKey options directly.
	   * @option options credentialProvider [AWS.CredentialProviderChain] the
	   *   provider chain used to resolve credentials if no static `credentials`
	   *   property is set.
	   * @option options region [String] the region to send service requests to.
	   *   See {region} for more information.
	   * @option options maxRetries [Integer] the maximum amount of retries to
	   *   attempt with a request. See {maxRetries} for more information.
	   * @option options maxRedirects [Integer] the maximum amount of redirects to
	   *   follow with a request. See {maxRedirects} for more information.
	   * @option options sslEnabled [Boolean] whether to enable SSL for
	   *   requests.
	   * @option options paramValidation [Boolean|map] whether input parameters
	   *   should be validated against the operation description before sending
	   *   the request. Defaults to true. Pass a map to enable any of the
	   *   following specific validation features:
	   *
	   *   * **min** [Boolean] &mdash; Validates that a value meets the min
	   *     constraint. This is enabled by default when paramValidation is set
	   *     to `true`.
	   *   * **max** [Boolean] &mdash; Validates that a value meets the max
	   *     constraint.
	   *   * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *     regular expression.
	   *   * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *     of the allowable enum values.
	   * @option options computeChecksums [Boolean] whether to compute checksums
	   *   for payload bodies when the service accepts it (currently supported
	   *   in S3 only)
	   * @option options convertResponseTypes [Boolean] whether types are converted
	   *     when parsing response data. Currently only supported for JSON based
	   *     services. Turning this off may improve performance on large response
	   *     payloads. Defaults to `true`.
	   * @option options correctClockSkew [Boolean] whether to apply a clock skew
	   *     correction and retry requests that fail because of an skewed client
	   *     clock. Defaults to `false`.
	   * @option options s3ForcePathStyle [Boolean] whether to force path
	   *   style URLs for S3 objects.
	   * @option options s3BucketEndpoint [Boolean] whether the provided endpoint
	   *   addresses an individual bucket (false if it addresses the root API
	   *   endpoint). Note that setting this configuration option requires an
	   *   `endpoint` to be provided explicitly to the service constructor.
	   * @option options s3DisableBodySigning [Boolean] whether S3 body signing
	   *   should be disabled when using signature version `v4`. Body signing
	   *   can only be disabled when using https. Defaults to `true`.
	   *
	   * @option options retryDelayOptions [map] A set of options to configure
	   *   the retry delay on retryable errors. Currently supported options are:
	   *
	   *   * **base** [Integer] &mdash; The base number of milliseconds to use in the
	   *     exponential backoff for operation retries. Defaults to 100 ms for all
	   *     services except DynamoDB, where it defaults to 50ms.
	   *   * **customBackoff ** [function] &mdash; A custom function that accepts a retry count
	   *     and returns the amount of time to delay in milliseconds. The `base` option will be
	   *     ignored if this option is supplied.
	   * @option options httpOptions [map] A set of options to pass to the low-level
	   *   HTTP request. Currently supported options are:
	   *
	   *   * **proxy** [String] &mdash; the URL to proxy requests through
	   *   * **agent** [http.Agent, https.Agent] &mdash; the Agent object to perform
	   *     HTTP requests with. Used for connection pooling. Defaults to the global
	   *     agent (`http.globalAgent`) for non-SSL connections. Note that for
	   *     SSL connections, a special Agent object is used in order to enable
	   *     peer certificate verification. This feature is only available in the
	   *     Node.js environment.
	   *   * **connectTimeout** [Integer] &mdash; Sets the socket to timeout after
	   *     failing to establish a connection with the server after
	   *     `connectTimeout` milliseconds. This timeout has no effect once a socket
	   *     connection has been established.
	   *   * **timeout** [Integer] &mdash; Sets the socket to timeout after timeout
	   *     milliseconds of inactivity on the socket. Defaults to two minutes
	   *     (120000).
	   *   * **xhrAsync** [Boolean] &mdash; Whether the SDK will send asynchronous
	   *     HTTP requests. Used in the browser environment only. Set to false to
	   *     send requests synchronously. Defaults to true (async on).
	   *   * **xhrWithCredentials** [Boolean] &mdash; Sets the "withCredentials"
	   *     property of an XMLHttpRequest object. Used in the browser environment
	   *     only. Defaults to false.
	   * @option options apiVersion [String, Date] a String in YYYY-MM-DD format
	   *   (or a date) that represents the latest possible API version that can be
	   *   used in all services (unless overridden by `apiVersions`). Specify
	   *   'latest' to use the latest possible version.
	   * @option options apiVersions [map<String, String|Date>] a map of service
	   *   identifiers (the lowercase service class name) with the API version to
	   *   use when instantiating a service. Specify 'latest' for each individual
	   *   that can use the latest available version.
	   * @option options logger [#write,#log] an object that responds to .write()
	   *   (like a stream) or .log() (like the console object) in order to log
	   *   information about requests
	   * @option options systemClockOffset [Number] an offset value in milliseconds
	   *   to apply to all signing times. Use this to compensate for clock skew
	   *   when your system may be out of sync with the service time. Note that
	   *   this configuration option can only be applied to the global `AWS.config`
	   *   object and cannot be overridden in service-specific configuration.
	   *   Defaults to 0 milliseconds.
	   * @option options signatureVersion [String] the signature version to sign
	   *   requests with (overriding the API configuration). Possible values are:
	   *   'v2', 'v3', 'v4'.
	   * @option options signatureCache [Boolean] whether the signature to sign
	   *   requests with (overriding the API configuration) is cached. Only applies
	   *   to the signature version 'v4'. Defaults to `true`.
	   * @option options dynamoDbCrc32 [Boolean] whether to validate the CRC32
	   *   checksum of HTTP response bodies returned by DynamoDB. Default: `true`.
	   * @option options useAccelerateEndpoint [Boolean] Whether to use the
	   *   S3 Transfer Acceleration endpoint with the S3 service. Default: `false`.
	   * @option options clientSideMonitoring [Boolean] whether to collect and
	   *   publish this client's performance metrics of all its API requests.
	   * @option options endpointDiscoveryEnabled [Boolean] whether to enable endpoint
	   *   discovery for operations that allow optionally using an endpoint returned by
	   *   the service.
	   *   Defaults to 'false'
	   * @option options endpointCacheSize [Number] the size of the global cache storing
	   *   endpoints from endpoint discovery operations. Once endpoint cache is created,
	   *   updating this setting cannot change existing cache size.
	   *   Defaults to 1000
	   * @option options hostPrefixEnabled [Boolean] whether to marshal request
	   *   parameters to the prefix of hostname.
	   *   Defaults to `true`.
	   */
	  constructor: function Config(options) {
	    if (options === undefined) options = {};
	    options = this.extractCredentials(options);
	
	    AWS.util.each.call(this, this.keys, function (key, value) {
	      this.set(key, options[key], value);
	    });
	  },
	
	  /**
	   * @!group Managing Credentials
	   */
	
	  /**
	   * Loads credentials from the configuration object. This is used internally
	   * by the SDK to ensure that refreshable {Credentials} objects are properly
	   * refreshed and loaded when sending a request. If you want to ensure that
	   * your credentials are loaded prior to a request, you can use this method
	   * directly to provide accurate credential data stored in the object.
	   *
	   * @note If you configure the SDK with static or environment credentials,
	   *   the credential data should already be present in {credentials} attribute.
	   *   This method is primarily necessary to load credentials from asynchronous
	   *   sources, or sources that can refresh credentials periodically.
	   * @example Getting your access key
	   *   AWS.config.getCredentials(function(err) {
	   *     if (err) console.log(err.stack); // credentials not loaded
	   *     else console.log("Access Key:", AWS.config.credentials.accessKeyId);
	   *   })
	   * @callback callback function(err)
	   *   Called when the {credentials} have been properly set on the configuration
	   *   object.
	   *
	   *   @param err [Error] if this is set, credentials were not successfully
	   *     loaded and this error provides information why.
	   * @see credentials
	   * @see Credentials
	   */
	  getCredentials: function getCredentials(callback) {
	    var self = this;
	
	    function finish(err) {
	      callback(err, err ? null : self.credentials);
	    }
	
	    function credError(msg, err) {
	      return new AWS.util.error(err || new Error(), {
	        code: 'CredentialsError',
	        message: msg,
	        name: 'CredentialsError'
	      });
	    }
	
	    function getAsyncCredentials() {
	      self.credentials.get(function(err) {
	        if (err) {
	          var msg = 'Could not load credentials from ' +
	            self.credentials.constructor.name;
	          err = credError(msg, err);
	        }
	        finish(err);
	      });
	    }
	
	    function getStaticCredentials() {
	      var err = null;
	      if (!self.credentials.accessKeyId || !self.credentials.secretAccessKey) {
	        err = credError('Missing credentials');
	      }
	      finish(err);
	    }
	
	    if (self.credentials) {
	      if (typeof self.credentials.get === 'function') {
	        getAsyncCredentials();
	      } else { // static credentials
	        getStaticCredentials();
	      }
	    } else if (self.credentialProvider) {
	      self.credentialProvider.resolve(function(err, creds) {
	        if (err) {
	          err = credError('Could not load credentials from any providers', err);
	        }
	        self.credentials = creds;
	        finish(err);
	      });
	    } else {
	      finish(credError('No credentials to load'));
	    }
	  },
	
	  /**
	   * @!group Loading and Setting Configuration Options
	   */
	
	  /**
	   * @overload update(options, allowUnknownKeys = false)
	   *   Updates the current configuration object with new options.
	   *
	   *   @example Update maxRetries property of a configuration object
	   *     config.update({maxRetries: 10});
	   *   @param [Object] options a map of option keys and values.
	   *   @param [Boolean] allowUnknownKeys whether unknown keys can be set on
	   *     the configuration object. Defaults to `false`.
	   *   @see constructor
	   */
	  update: function update(options, allowUnknownKeys) {
	    allowUnknownKeys = allowUnknownKeys || false;
	    options = this.extractCredentials(options);
	    AWS.util.each.call(this, options, function (key, value) {
	      if (allowUnknownKeys || Object.prototype.hasOwnProperty.call(this.keys, key) ||
	          AWS.Service.hasService(key)) {
	        this.set(key, value);
	      }
	    });
	  },
	
	  /**
	   * Loads configuration data from a JSON file into this config object.
	   * @note Loading configuration will reset all existing configuration
	   *   on the object.
	   * @!macro nobrowser
	   * @param path [String] the path relative to your process's current
	   *    working directory to load configuration from.
	   * @return [AWS.Config] the same configuration object
	   */
	  loadFromPath: function loadFromPath(path) {
	    this.clear();
	
	    var options = JSON.parse(AWS.util.readFileSync(path));
	    var fileSystemCreds = new AWS.FileSystemCredentials(path);
	    var chain = new AWS.CredentialProviderChain();
	    chain.providers.unshift(fileSystemCreds);
	    chain.resolve(function (err, creds) {
	      if (err) throw err;
	      else options.credentials = creds;
	    });
	
	    this.constructor(options);
	
	    return this;
	  },
	
	  /**
	   * Clears configuration data on this object
	   *
	   * @api private
	   */
	  clear: function clear() {
	    /*jshint forin:false */
	    AWS.util.each.call(this, this.keys, function (key) {
	      delete this[key];
	    });
	
	    // reset credential provider
	    this.set('credentials', undefined);
	    this.set('credentialProvider', undefined);
	  },
	
	  /**
	   * Sets a property on the configuration object, allowing for a
	   * default value
	   * @api private
	   */
	  set: function set(property, value, defaultValue) {
	    if (value === undefined) {
	      if (defaultValue === undefined) {
	        defaultValue = this.keys[property];
	      }
	      if (typeof defaultValue === 'function') {
	        this[property] = defaultValue.call(this);
	      } else {
	        this[property] = defaultValue;
	      }
	    } else if (property === 'httpOptions' && this[property]) {
	      // deep merge httpOptions
	      this[property] = AWS.util.merge(this[property], value);
	    } else {
	      this[property] = value;
	    }
	  },
	
	  /**
	   * All of the keys with their default values.
	   *
	   * @constant
	   * @api private
	   */
	  keys: {
	    credentials: null,
	    credentialProvider: null,
	    region: null,
	    logger: null,
	    apiVersions: {},
	    apiVersion: null,
	    endpoint: undefined,
	    httpOptions: {
	      timeout: 120000
	    },
	    maxRetries: undefined,
	    maxRedirects: 10,
	    paramValidation: true,
	    sslEnabled: true,
	    s3ForcePathStyle: false,
	    s3BucketEndpoint: false,
	    s3DisableBodySigning: true,
	    computeChecksums: true,
	    convertResponseTypes: true,
	    correctClockSkew: false,
	    customUserAgent: null,
	    dynamoDbCrc32: true,
	    systemClockOffset: 0,
	    signatureVersion: null,
	    signatureCache: true,
	    retryDelayOptions: {},
	    useAccelerateEndpoint: false,
	    clientSideMonitoring: false,
	    endpointDiscoveryEnabled: false,
	    endpointCacheSize: 1000,
	    hostPrefixEnabled: true
	  },
	
	  /**
	   * Extracts accessKeyId, secretAccessKey and sessionToken
	   * from a configuration hash.
	   *
	   * @api private
	   */
	  extractCredentials: function extractCredentials(options) {
	    if (options.accessKeyId && options.secretAccessKey) {
	      options = AWS.util.copy(options);
	      options.credentials = new AWS.Credentials(options);
	    }
	    return options;
	  },
	
	  /**
	   * Sets the promise dependency the SDK will use wherever Promises are returned.
	   * Passing `null` will force the SDK to use native Promises if they are available.
	   * If native Promises are not available, passing `null` will have no effect.
	   * @param [Constructor] dep A reference to a Promise constructor
	   */
	  setPromisesDependency: function setPromisesDependency(dep) {
	    PromisesDependency = dep;
	    // if null was passed in, we should try to use native promises
	    if (dep === null && typeof Promise === 'function') {
	      PromisesDependency = Promise;
	    }
	    var constructors = [AWS.Request, AWS.Credentials, AWS.CredentialProviderChain];
	    if (AWS.S3 && AWS.S3.ManagedUpload) constructors.push(AWS.S3.ManagedUpload);
	    AWS.util.addPromises(constructors, PromisesDependency);
	  },
	
	  /**
	   * Gets the promise dependency set by `AWS.config.setPromisesDependency`.
	   */
	  getPromisesDependency: function getPromisesDependency() {
	    return PromisesDependency;
	  }
	});
	
	/**
	 * @return [AWS.Config] The global configuration object singleton instance
	 * @readonly
	 * @see AWS.Config
	 */
	AWS.config = new AWS.Config();


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(126);
	
	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * AWS.ChainableTemporaryCredentials differs from AWS.TemporaryCredentials in
	 * the way masterCredentials and refreshes are handled.
	 * AWS.ChainableTemporaryCredentials refreshes expired credentials using the
	 * masterCredentials passed by the user to support chaining of STS credentials.
	 * However, AWS.TemporaryCredentials recursively collapses the masterCredentials
	 * during instantiation, precluding the ability to refresh credentials which
	 * require intermediate, temporary credentials.
	 *
	 * For example, if the application should use RoleA, which must be assumed from
	 * RoleB, and the environment provides credentials which can assume RoleB, then
	 * AWS.ChainableTemporaryCredentials must be used to support refreshing the
	 * temporary credentials for RoleA:
	 *
	 * ```javascript
	 * var roleACreds = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: 'RoleA'},
	 *   masterCredentials: new AWS.ChainableTemporaryCredentials({
	 *     params: {RoleArn: 'RoleB'},
	 *     masterCredentials: new AWS.EnvironmentCredentials('AWS')
	 *   })
	 * });
	 * ```
	 *
	 * If AWS.TemporaryCredentials had been used in the previous example,
	 * `roleACreds` would fail to refresh because `roleACreds` would
	 * use the environment credentials for the AssumeRole request.
	 *
	 * Another difference is that AWS.ChainableTemporaryCredentials creates the STS
	 * service instance during instantiation while AWS.TemporaryCredentials creates
	 * the STS service instance during the first refresh. Creating the service
	 * instance during instantiation effectively captures the master credentials
	 * from the global config, so that subsequent changes to the global config do
	 * not affect the master credentials used to refresh the temporary credentials.
	 *
	 * This allows an instance of AWS.ChainableTemporaryCredentials to be assigned
	 * to AWS.config.credentials:
	 *
	 * ```javascript
	 * var envCreds = new AWS.EnvironmentCredentials('AWS');
	 * AWS.config.credentials = envCreds;
	 * // masterCredentials will be envCreds
	 * AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * Similarly, to use the CredentialProviderChain's default providers as the
	 * master credentials, simply create a new instance of
	 * AWS.ChainableTemporaryCredentials:
	 *
	 * ```javascript
	 * AWS.config.credentials = new ChainableTemporaryCredentials({
	 *   params: {RoleArn: '...'}
	 * });
	 * ```
	 *
	 * @!attribute service
	 *   @return [AWS.STS] the STS service instance used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.ChainableTemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @param options [map] a set of options
	   * @option options params [map] ({}) a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role. If a `SerialNumber` parameter is passed in, {tokenCodeFn} must
	   *   also be passed in or an error will be thrown.
	   * @option options masterCredentials [AWS.Credentials] the master credentials
	   *   used to get and refresh temporary credentials from AWS STS. By default,
	   *   AWS.config.credentials or AWS.config.credentialProvider will be used.
	   * @option options tokenCodeFn [Function] (null) Function to provide
	   *   `TokenCode`, if `SerialNumber` is provided for profile in {params}. Function
	   *   is called with value of `SerialNumber` and `callback`, and should provide
	   *   the `TokenCode` or an error to the callback in the format
	   *   `callback(err, token)`.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.ChainableTemporaryCredentials({
	   *     params: {
	   *       RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials'
	   *     }
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function ChainableTemporaryCredentials(options) {
	    AWS.Credentials.call(this);
	    options = options || {};
	    this.errorCode = 'ChainableTemporaryCredentialsProviderFailure';
	    this.expired = true;
	    this.tokenCodeFn = null;
	
	    var params = AWS.util.copy(options.params) || {};
	    if (params.RoleArn) {
	      params.RoleSessionName = params.RoleSessionName || 'temporary-credentials';
	    }
	    if (params.SerialNumber) {
	      if (!options.tokenCodeFn || (typeof options.tokenCodeFn !== 'function')) {
	        throw new AWS.util.error(
	          new Error('tokenCodeFn must be a function when params.SerialNumber is given'),
	          {code: this.errorCode}
	        );
	      } else {
	        this.tokenCodeFn = options.tokenCodeFn;
	      }
	    }
	    this.service = new STS({
	      params: params,
	      credentials: options.masterCredentials || AWS.config.credentials
	    });
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    var operation = self.service.config.params.RoleArn ? 'assumeRole' : 'getSessionToken';
	    this.getTokenCode(function (err, tokenCode) {
	      var params = {};
	      if (err) {
	        callback(err);
	        return;
	      }
	      if (tokenCode) {
	        params.TokenCode = tokenCode;
	      }
	      self.service[operation](params, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  getTokenCode: function getTokenCode(callback) {
	    var self = this;
	    if (this.tokenCodeFn) {
	      this.tokenCodeFn(this.service.config.params.SerialNumber, function (err, token) {
	        if (err) {
	          var message = err;
	          if (err instanceof Error) {
	            message = err.message;
	          }
	          callback(
	            AWS.util.error(
	              new Error('Error fetching MFA token: ' + message),
	              { code: self.errorCode}
	            )
	          );
	          return;
	        }
	        callback(null, token);
	      });
	    } else {
	      callback(null);
	    }
	  }
	});


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var CognitoIdentity = __webpack_require__(420);
	var STS = __webpack_require__(126);
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation using
	 * the Amazon Cognito Identity service.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.CognitoIdentity.getCredentialsForIdentity} service operation, which
	 * requires either an `IdentityId` or an `IdentityPoolId` (Amazon Cognito
	 * Identity Pool ID), which is used to call {AWS.CognitoIdentity.getId} to
	 * obtain an `IdentityId`. If the identity or identity pool is not configured in
	 * the Amazon Cognito Console to use IAM roles with the appropriate permissions,
	 * then additionally a `RoleArn` is required containing the ARN of the IAM trust
	 * policy for the Amazon Cognito role that the user will log into. If a `RoleArn`
	 * is provided, then this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation, after first getting an
	 * Open ID token from {AWS.CognitoIdentity.getOpenIdToken}.
	 *
	 * In addition, if this credential provider is used to provide authenticated
	 * login, the `Logins` map may be set to the tokens provided by the respective
	 * identity providers. See {constructor} for an example on creating a credentials
	 * object with proper property values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.Logins['graph.facebook.com'] = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.CognitoIdentity.getId},
	 *     {AWS.CognitoIdentity.getOpenIdToken}, and
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.CognitoIdentity.getCredentialsForIdentity}, or
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 * @!attribute identityId
	 *   @return [String] the Cognito ID returned by the last call to
	 *     {AWS.CognitoIdentity.getOpenIdToken}. This ID represents the actual
	 *     final resolved identity ID from Amazon Cognito.
	 */
	AWS.CognitoIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * @api private
	   */
	  localStorageKey: {
	    id: 'aws.cognito.identity-id.',
	    providers: 'aws.cognito.identity-providers.'
	  },
	
	  /**
	   * Creates a new credentials object.
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
	   *
	   *     // either IdentityPoolId or IdentityId is required
	   *     // See the IdentityPoolId param for AWS.CognitoIdentity.getID (linked below)
	   *     // See the IdentityId param for AWS.CognitoIdentity.getCredentialsForIdentity
	   *     // or AWS.CognitoIdentity.getOpenIdToken (linked below)
	   *     IdentityPoolId: 'us-east-1:1699ebc0-7900-4099-b910-2df94f52a030',
	   *     IdentityId: 'us-east-1:128d0a74-c82f-4553-916d-90053e4a8b0f'
	   *
	   *     // optional, only necessary when the identity pool is not configured
	   *     // to use IAM roles in the Amazon Cognito Console
	   *     // See the RoleArn param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleArn: 'arn:aws:iam::1234567890:role/MYAPP-CognitoIdentity',
	   *
	   *     // optional tokens, used for authenticated login
	   *     // See the Logins param for AWS.CognitoIdentity.getID (linked below)
	   *     Logins: {
	   *       'graph.facebook.com': 'FBTOKEN',
	   *       'www.amazon.com': 'AMAZONTOKEN',
	   *       'accounts.google.com': 'GOOGLETOKEN',
	   *       'api.twitter.com': 'TWITTERTOKEN',
	   *       'www.digits.com': 'DIGITSTOKEN'
	   *     },
	   *
	   *     // optional name, defaults to web-identity
	   *     // See the RoleSessionName param for AWS.STS.assumeRoleWithWebIdentity (linked below)
	   *     RoleSessionName: 'web',
	   *
	   *     // optional, only necessary when application runs in a browser
	   *     // and multiple users are signed in at once, used for caching
	   *     LoginId: 'example@gmail.com'
	   *
	   *   }, {
	   *      // optionally provide configuration to apply to the underlying service clients
	   *      // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *      // region should match the region your identity pool is located in
	   *      region: 'us-east-1',
	   *
	   *      // specify timeout options
	   *      httpOptions: {
	   *        timeout: 100
	   *      }
	   *   });
	   * @see AWS.CognitoIdentity.getId
	   * @see AWS.CognitoIdentity.getCredentialsForIdentity
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.CognitoIdentity.getOpenIdToken
	   * @see AWS.Config
	   * @note If a region is not provided in the global AWS.config, or
	   *   specified in the `clientConfig` to the CognitoIdentityCredentials
	   *   constructor, you may encounter a 'Missing credentials in config' error
	   *   when calling making a service call.
	   */
	  constructor: function CognitoIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.data = null;
	    this._identityId = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	    this.loadCachedId();
	    var self = this;
	    Object.defineProperty(this, 'identityId', {
	      get: function() {
	        self.loadCachedId();
	        return self._identityId || self.params.IdentityId;
	      },
	      set: function(identityId) {
	        self._identityId = identityId;
	      }
	    });
	  },
	
	  /**
	   * Refreshes credentials using {AWS.CognitoIdentity.getCredentialsForIdentity},
	   * or {AWS.STS.assumeRoleWithWebIdentity}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see AWS.Credentials.get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   * @param callback
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.data = null;
	    self._identityId = null;
	    self.getId(function(err) {
	      if (!err) {
	        if (!self.params.RoleArn) {
	          self.getCredentialsForIdentity(callback);
	        } else {
	          self.getCredentialsFromSTS(callback);
	        }
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * Clears the cached Cognito ID associated with the currently configured
	   * identity pool ID. Use this to manually invalidate your cache if
	   * the identity pool ID was deleted.
	   */
	  clearCachedId: function clearCache() {
	    this._identityId = null;
	    delete this.params.IdentityId;
	
	    var poolId = this.params.IdentityPoolId;
	    var loginId = this.params.LoginId || '';
	    delete this.storage[this.localStorageKey.id + poolId + loginId];
	    delete this.storage[this.localStorageKey.providers + poolId + loginId];
	  },
	
	  /**
	   * @api private
	   */
	  clearIdOnNotAuthorized: function clearIdOnNotAuthorized(err) {
	    var self = this;
	    if (err.code == 'NotAuthorizedException') {
	      self.clearCachedId();
	    }
	  },
	
	  /**
	   * Retrieves a Cognito ID, loading from cache if it was already retrieved
	   * on this device.
	   *
	   * @callback callback function(err, identityId)
	   *   @param err [Error, null] an error object if the call failed or null if
	   *     it succeeded.
	   *   @param identityId [String, null] if successful, the callback will return
	   *     the Cognito ID.
	   * @note If not loaded explicitly, the Cognito ID is loaded and stored in
	   *   localStorage in the browser environment of a device.
	   * @api private
	   */
	  getId: function getId(callback) {
	    var self = this;
	    if (typeof self.params.IdentityId === 'string') {
	      return callback(null, self.params.IdentityId);
	    }
	
	    self.cognito.getId(function(err, data) {
	      if (!err && data.IdentityId) {
	        self.params.IdentityId = data.IdentityId;
	        callback(null, data.IdentityId);
	      } else {
	        callback(err);
	      }
	    });
	  },
	
	
	  /**
	   * @api private
	   */
	  loadCredentials: function loadCredentials(data, credentials) {
	    if (!data || !credentials) return;
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsForIdentity: function getCredentialsForIdentity(callback) {
	    var self = this;
	    self.cognito.getCredentialsForIdentity(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.data = data;
	        self.loadCredentials(self.data, self);
	      } else {
	        self.clearIdOnNotAuthorized(err);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  getCredentialsFromSTS: function getCredentialsFromSTS(callback) {
	    var self = this;
	    self.cognito.getOpenIdToken(function(err, data) {
	      if (!err) {
	        self.cacheId(data);
	        self.params.WebIdentityToken = data.Token;
	        self.webIdentityCredentials.refresh(function(webErr) {
	          if (!webErr) {
	            self.data = self.webIdentityCredentials.data;
	            self.sts.credentialsFrom(self.data, self);
	          }
	          callback(webErr);
	        });
	      } else {
	        self.clearIdOnNotAuthorized(err);
	        callback(err);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadCachedId: function loadCachedId() {
	    var self = this;
	
	    // in the browser we source default IdentityId from localStorage
	    if (AWS.util.isBrowser() && !self.params.IdentityId) {
	      var id = self.getStorage('id');
	      if (id && self.params.Logins) {
	        var actualProviders = Object.keys(self.params.Logins);
	        var cachedProviders =
	          (self.getStorage('providers') || '').split(',');
	
	        // only load ID if at least one provider used this ID before
	        var intersect = cachedProviders.filter(function(n) {
	          return actualProviders.indexOf(n) !== -1;
	        });
	        if (intersect.length !== 0) {
	          self.params.IdentityId = id;
	        }
	      } else if (id) {
	        self.params.IdentityId = id;
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    var clientConfig = this._clientConfig;
	    this.webIdentityCredentials = this.webIdentityCredentials ||
	      new AWS.WebIdentityCredentials(this.params, clientConfig);
	    if (!this.cognito) {
	      var cognitoConfig = AWS.util.merge({}, clientConfig);
	      cognitoConfig.params = this.params;
	      this.cognito = new CognitoIdentity(cognitoConfig);
	    }
	    this.sts = this.sts || new STS(clientConfig);
	  },
	
	  /**
	   * @api private
	   */
	  cacheId: function cacheId(data) {
	    this._identityId = data.IdentityId;
	    this.params.IdentityId = this._identityId;
	
	    // cache this IdentityId in browser localStorage if possible
	    if (AWS.util.isBrowser()) {
	      this.setStorage('id', data.IdentityId);
	
	      if (this.params.Logins) {
	        this.setStorage('providers', Object.keys(this.params.Logins).join(','));
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getStorage: function getStorage(key) {
	    return this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')];
	  },
	
	  /**
	   * @api private
	   */
	  setStorage: function setStorage(key, val) {
	    try {
	      this.storage[this.localStorageKey[key] + this.params.IdentityPoolId + (this.params.LoginId || '')] = val;
	    } catch (_) {}
	  },
	
	  /**
	   * @api private
	   */
	  storage: (function() {
	    try {
	      var storage = AWS.util.isBrowser() && window.localStorage !== null && typeof window.localStorage === 'object' ?
	          window.localStorage : {};
	
	      // Test set/remove which would throw an error in Safari's private browsing
	      storage['aws.test-storage'] = 'foobar';
	      delete storage['aws.test-storage'];
	
	      return storage;
	    } catch (_) {
	      return {};
	    }
	  })()
	});


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(126);
	
	/**
	 * Represents credentials retrieved from STS SAML support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithSAML} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given, as well as a `PrincipalArn`
	 * representing the ARN for the SAML identity provider. In addition, the
	 * `SAMLAssertion` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn`, `PrincipalArn`, and `SAMLAssertion` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the SAMLAssertion, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.SAMLAssertion = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithSAML}. To update the token, set the
	 *     `params.SAMLAssertion` property.
	 */
	AWS.SAMLCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithSAML)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.SAMLCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/SAMLRole',
	   *     PrincipalArn: 'arn:aws:iam::1234567890:role/SAMLPrincipal',
	   *     SAMLAssertion: 'base64-token', // base64-encoded token from IdP
	   *   });
	   * @see AWS.STS.assumeRoleWithSAML
	   */
	  constructor: function SAMLCredentials(params) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithSAML}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithSAML(function (err, data) {
	      if (!err) {
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(126);
	
	/**
	 * Represents temporary credentials retrieved from {AWS.STS}. Without any
	 * extra parameters, credentials will be fetched from the
	 * {AWS.STS.getSessionToken} operation. If an IAM role is provided, the
	 * {AWS.STS.assumeRole} operation will be used to fetch credentials for the
	 * role instead.
	 *
	 * @note AWS.TemporaryCredentials is deprecated, but remains available for
	 *   backwards compatibility. {AWS.ChainableTemporaryCredentials} is the
	 *   preferred class for temporary credentials.
	 *
	 * To setup temporary credentials, configure a set of master credentials
	 * using the standard credentials providers (environment, EC2 instance metadata,
	 * or from the filesystem), then set the global credentials to a new
	 * temporary credentials object:
	 *
	 * ```javascript
	 * // Note that environment credentials are loaded by default,
	 * // the following line is shown for clarity:
	 * AWS.config.credentials = new AWS.EnvironmentCredentials('AWS');
	 *
	 * // Now set temporary credentials seeded from the master credentials
	 * AWS.config.credentials = new AWS.TemporaryCredentials();
	 *
	 * // subsequent requests will now use temporary credentials from AWS STS.
	 * new AWS.S3().listBucket(function(err, data) { ... });
	 * ```
	 *
	 * @!attribute masterCredentials
	 *   @return [AWS.Credentials] the master (non-temporary) credentials used to
	 *     get and refresh temporary credentials from AWS STS.
	 * @note (see constructor)
	 */
	AWS.TemporaryCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new temporary credentials object.
	   *
	   * @note In order to create temporary credentials, you first need to have
	   *   "master" credentials configured in {AWS.Config.credentials}. These
	   *   master credentials are necessary to retrieve the temporary credentials,
	   *   as well as refresh the credentials when they expire.
	   * @param params [map] a map of options that are passed to the
	   *   {AWS.STS.assumeRole} or {AWS.STS.getSessionToken} operations.
	   *   If a `RoleArn` parameter is passed in, credentials will be based on the
	   *   IAM role.
	   * @param masterCredentials [AWS.Credentials] the master (non-temporary) credentials
	   *  used to get and refresh temporary credentials from AWS STS.
	   * @example Creating a new credentials object for generic temporary credentials
	   *   AWS.config.credentials = new AWS.TemporaryCredentials();
	   * @example Creating a new credentials object for an IAM role
	   *   AWS.config.credentials = new AWS.TemporaryCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/TemporaryCredentials',
	   *   });
	   * @see AWS.STS.assumeRole
	   * @see AWS.STS.getSessionToken
	   */
	  constructor: function TemporaryCredentials(params, masterCredentials) {
	    AWS.Credentials.call(this);
	    this.loadMasterCredentials(masterCredentials);
	    this.expired = true;
	
	    this.params = params || {};
	    if (this.params.RoleArn) {
	      this.params.RoleSessionName =
	        this.params.RoleSessionName || 'temporary-credentials';
	    }
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRole} or
	   * {AWS.STS.getSessionToken}, depending on whether an IAM role ARN was passed
	   * to the credentials {constructor}.
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh (callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load (callback) {
	    var self = this;
	    self.createClients();
	    self.masterCredentials.get(function () {
	      self.service.config.credentials = self.masterCredentials;
	      var operation = self.params.RoleArn ?
	        self.service.assumeRole : self.service.getSessionToken;
	      operation.call(self.service, function (err, data) {
	        if (!err) {
	          self.service.credentialsFrom(data, self);
	        }
	        callback(err);
	      });
	    });
	  },
	
	  /**
	   * @api private
	   */
	  loadMasterCredentials: function loadMasterCredentials (masterCredentials) {
	    this.masterCredentials = masterCredentials || AWS.config.credentials;
	    while (this.masterCredentials.masterCredentials) {
	      this.masterCredentials = this.masterCredentials.masterCredentials;
	    }
	
	    if (typeof this.masterCredentials.get !== 'function') {
	      this.masterCredentials = new AWS.Credentials(this.masterCredentials);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function () {
	    this.service = this.service || new STS({params: this.params});
	  }
	
	});


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var STS = __webpack_require__(126);
	
	/**
	 * Represents credentials retrieved from STS Web Identity Federation support.
	 *
	 * By default this provider gets credentials using the
	 * {AWS.STS.assumeRoleWithWebIdentity} service operation. This operation
	 * requires a `RoleArn` containing the ARN of the IAM trust policy for the
	 * application for which credentials will be given. In addition, the
	 * `WebIdentityToken` must be set to the token provided by the identity
	 * provider. See {constructor} for an example on creating a credentials
	 * object with proper `RoleArn` and `WebIdentityToken` values.
	 *
	 * ## Refreshing Credentials from Identity Service
	 *
	 * In addition to AWS credentials expiring after a given amount of time, the
	 * login token from the identity provider will also expire. Once this token
	 * expires, it will not be usable to refresh AWS credentials, and another
	 * token will be needed. The SDK does not manage refreshing of the token value,
	 * but this can be done through a "refresh token" supported by most identity
	 * providers. Consult the documentation for the identity provider for refreshing
	 * tokens. Once the refreshed token is acquired, you should make sure to update
	 * this new token in the credentials object's {params} property. The following
	 * code will update the WebIdentityToken, assuming you have retrieved an updated
	 * token from the identity provider:
	 *
	 * ```javascript
	 * AWS.config.credentials.params.WebIdentityToken = updatedToken;
	 * ```
	 *
	 * Future calls to `credentials.refresh()` will now use the new token.
	 *
	 * @!attribute params
	 *   @return [map] the map of params passed to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. To update the token, set the
	 *     `params.WebIdentityToken` property.
	 * @!attribute data
	 *   @return [map] the raw data response from the call to
	 *     {AWS.STS.assumeRoleWithWebIdentity}. Use this if you want to get
	 *     access to other properties from the response.
	 */
	AWS.WebIdentityCredentials = AWS.util.inherit(AWS.Credentials, {
	  /**
	   * Creates a new credentials object.
	   * @param (see AWS.STS.assumeRoleWithWebIdentity)
	   * @example Creating a new credentials object
	   *   AWS.config.credentials = new AWS.WebIdentityCredentials({
	   *     RoleArn: 'arn:aws:iam::1234567890:role/WebIdentity',
	   *     WebIdentityToken: 'ABCDEFGHIJKLMNOP', // token from identity service
	   *     RoleSessionName: 'web' // optional name, defaults to web-identity
	   *   }, {
	   *     // optionally provide configuration to apply to the underlying AWS.STS service client
	   *     // if configuration is not provided, then configuration will be pulled from AWS.config
	   *
	   *     // specify timeout options
	   *     httpOptions: {
	   *       timeout: 100
	   *     }
	   *   });
	   * @see AWS.STS.assumeRoleWithWebIdentity
	   * @see AWS.Config
	   */
	  constructor: function WebIdentityCredentials(params, clientConfig) {
	    AWS.Credentials.call(this);
	    this.expired = true;
	    this.params = params;
	    this.params.RoleSessionName = this.params.RoleSessionName || 'web-identity';
	    this.data = null;
	    this._clientConfig = AWS.util.copy(clientConfig || {});
	  },
	
	  /**
	   * Refreshes credentials using {AWS.STS.assumeRoleWithWebIdentity}
	   *
	   * @callback callback function(err)
	   *   Called when the STS service responds (or fails). When
	   *   this callback is called with no error, it means that the credentials
	   *   information has been loaded into the object (as the `accessKeyId`,
	   *   `secretAccessKey`, and `sessionToken` properties).
	   *   @param err [Error] if an error occurred, this value will be filled
	   * @see get
	   */
	  refresh: function refresh(callback) {
	    this.coalesceRefresh(callback || AWS.util.fn.callback);
	  },
	
	  /**
	   * @api private
	   */
	  load: function load(callback) {
	    var self = this;
	    self.createClients();
	    self.service.assumeRoleWithWebIdentity(function (err, data) {
	      self.data = null;
	      if (!err) {
	        self.data = data;
	        self.service.credentialsFrom(data, self);
	      }
	      callback(err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  createClients: function() {
	    if (!this.service) {
	      var stsConfig = AWS.util.merge({}, this._clientConfig);
	      stsConfig.params = this.params;
	      this.service = new STS(stsConfig);
	    }
	  }
	
	});


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var util = __webpack_require__(34);
	var endpointDiscoveryEnabledEnvs = ['AWS_ENABLE_ENDPOINT_DISCOVERY', 'AWS_ENDPOINT_DISCOVERY_ENABLED'];
	
	/**
	 * Generate key (except resources and operation part) to index the endpoints in the cache
	 * If input shape has endpointdiscoveryid trait then use
	 *   accessKey + operation + resources + region + service as cache key
	 * If input shape doesn't have endpointdiscoveryid trait then use
	 *   accessKey + region + service as cache key
	 * @return [map<String,String>] object with keys to index endpoints.
	 * @api private
	 */
	function getCacheKey(request) {
	  var service = request.service;
	  var api = service.api || {};
	  var operations = api.operations;
	  var identifiers = {};
	  if (service.config.region) {
	    identifiers.region = service.config.region;
	  }
	  if (api.serviceId) {
	    identifiers.serviceId = api.serviceId;
	  }
	  if (service.config.credentials.accessKeyId) {
	    identifiers.accessKeyId = service.config.credentials.accessKeyId;
	  }
	  return identifiers;
	}
	
	/**
	 * Recursive helper for marshallCustomIdentifiers().
	 * Looks for required string input members that have 'endpointdiscoveryid' trait.
	 * @api private
	 */
	function marshallCustomIdentifiersHelper(result, params, shape) {
	  if (!shape || params === undefined || params === null) return;
	  if (shape.type === 'structure' && shape.required && shape.required.length > 0) {
	    util.arrayEach(shape.required, function(name) {
	      var memberShape = shape.members[name];
	      if (memberShape.endpointDiscoveryId === true) {
	        var locationName = memberShape.isLocationName ? memberShape.name : name;
	        result[locationName] = String(params[name]);
	      } else {
	        marshallCustomIdentifiersHelper(result, params[name], memberShape);
	      }
	    });
	  }
	}
	
	/**
	 * Get custom identifiers for cache key.
	 * Identifies custom identifiers by checking each shape's `endpointDiscoveryId` trait.
	 * @param [object] request object
	 * @param [object] input shape of the given operation's api
	 * @api private
	 */
	function marshallCustomIdentifiers(request, shape) {
	  var identifiers = {};
	  marshallCustomIdentifiersHelper(identifiers, request.params, shape);
	  return identifiers;
	}
	
	/**
	 * Call endpoint discovery operation when it's optional.
	 * When endpoint is available in cache then use the cached endpoints. If endpoints
	 * are unavailable then use regional endpoints and call endpoint discovery operation
	 * asynchronously. This is turned off by default.
	 * @param [object] request object
	 * @api private
	 */
	function optionalDiscoverEndpoint(request) {
	  var service = request.service;
	  var api = service.api;
	  var operationModel = api.operations ? api.operations[request.operation] : undefined;
	  var inputShape = operationModel ? operationModel.input : undefined;
	
	  var identifiers = marshallCustomIdentifiers(request, inputShape);
	  var cacheKey = getCacheKey(request);
	  if (Object.keys(identifiers).length > 0) {
	    cacheKey = util.update(cacheKey, identifiers);
	    if (operationModel) cacheKey.operation = operationModel.name;
	  }
	  var endpoints = AWS.endpointCache.get(cacheKey);
	  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
	    //endpoint operation is being made but response not yet received
	    //or endpoint operation just failed in 1 minute
	    return;
	  } else if (endpoints && endpoints.length > 0) {
	    //found endpoint record from cache
	    request.httpRequest.updateEndpoint(endpoints[0].Address);
	  } else {
	    //endpoint record not in cache or outdated. make discovery operation
	    var endpointRequest = service.makeRequest(api.endpointOperation, {
	      Operation: operationModel.name,
	      Identifiers: identifiers,
	    });
	    addApiVersionHeader(endpointRequest);
	    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    endpointRequest.removeListener('retry', AWS.EventListeners.Core.RETRY_CHECK);
	    //put in a placeholder for endpoints already requested, prevent
	    //too much in-flight calls
	    AWS.endpointCache.put(cacheKey, [{
	      Address: '',
	      CachePeriodInMinutes: 1
	    }]);
	    endpointRequest.send(function(err, data) {
	      if (data && data.Endpoints) {
	        AWS.endpointCache.put(cacheKey, data.Endpoints);
	      } else if (err) {
	        AWS.endpointCache.put(cacheKey, [{
	          Address: '',
	          CachePeriodInMinutes: 1 //not to make more endpoint operation in next 1 minute
	        }]);
	      }
	    });
	  }
	}
	
	var requestQueue = {};
	
	/**
	 * Call endpoint discovery operation when it's required.
	 * When endpoint is available in cache then use cached ones. If endpoints are
	 * unavailable then SDK should call endpoint operation then use returned new
	 * endpoint for the api call. SDK will automatically attempt to do endpoint
	 * discovery. This is turned off by default
	 * @param [object] request object
	 * @api private
	 */
	function requiredDiscoverEndpoint(request, done) {
	  var service = request.service;
	  var api = service.api;
	  var operationModel = api.operations ? api.operations[request.operation] : undefined;
	  var inputShape = operationModel ? operationModel.input : undefined;
	
	  var identifiers = marshallCustomIdentifiers(request, inputShape);
	  var cacheKey = getCacheKey(request);
	  if (Object.keys(identifiers).length > 0) {
	    cacheKey = util.update(cacheKey, identifiers);
	    if (operationModel) cacheKey.operation = operationModel.name;
	  }
	  var cacheKeyStr = AWS.EndpointCache.getKeyString(cacheKey);
	  var endpoints = AWS.endpointCache.get(cacheKeyStr); //endpoint cache also accepts string keys
	  if (endpoints && endpoints.length === 1 && endpoints[0].Address === '') {
	    //endpoint operation is being made but response not yet received
	    //push request object to a pending queue
	    if (!requestQueue[cacheKeyStr]) requestQueue[cacheKeyStr] = [];
	    requestQueue[cacheKeyStr].push({request: request, callback: done});
	    return;
	  } else if (endpoints && endpoints.length > 0) {
	    request.httpRequest.updateEndpoint(endpoints[0].Address);
	    done();
	  } else {
	    var endpointRequest = service.makeRequest(api.endpointOperation, {
	      Operation: operationModel.name,
	      Identifiers: identifiers,
	    });
	    endpointRequest.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    addApiVersionHeader(endpointRequest);
	
	    //put in a placeholder for endpoints already requested, prevent
	    //too much in-flight calls
	    AWS.endpointCache.put(cacheKeyStr, [{
	      Address: '',
	      CachePeriodInMinutes: 60 //long-live cache
	    }]);
	    endpointRequest.send(function(err, data) {
	      if (err) {
	        var errorParams = {
	          code: 'EndpointDiscoveryException',
	          message: 'Request cannot be fulfilled without specifying an endpoint',
	          retryable: false
	        };
	        request.response.error = util.error(err, errorParams);
	        AWS.endpointCache.remove(cacheKey);
	
	        //fail all the pending requests in batch
	        if (requestQueue[cacheKeyStr]) {
	          var pendingRequests = requestQueue[cacheKeyStr];
	          util.arrayEach(pendingRequests, function(requestContext) {
	            requestContext.request.response.error = util.error(err, errorParams);
	            requestContext.callback();
	          });
	          delete requestQueue[cacheKeyStr];
	        }
	      } else if (data) {
	        AWS.endpointCache.put(cacheKeyStr, data.Endpoints);
	        request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
	
	        //update the endpoint for all the pending requests in batch
	        if (requestQueue[cacheKeyStr]) {
	          var pendingRequests = requestQueue[cacheKeyStr];
	          util.arrayEach(pendingRequests, function(requestContext) {
	            requestContext.request.httpRequest.updateEndpoint(data.Endpoints[0].Address);
	            requestContext.callback();
	          });
	          delete requestQueue[cacheKeyStr];
	        }
	      }
	      done();
	    });
	  }
	}
	
	/**
	 * add api version header to endpoint operation
	 * @api private
	 */
	function addApiVersionHeader(endpointRequest) {
	  var api = endpointRequest.service.api;
	  var apiVersion = api.apiVersion;
	  if (apiVersion && !endpointRequest.httpRequest.headers['x-amz-api-version']) {
	    endpointRequest.httpRequest.headers['x-amz-api-version'] = apiVersion;
	  }
	}
	
	/**
	 * If api call gets invalid endpoint exception, SDK should attempt to remove the invalid
	 * endpoint from cache.
	 * @api private
	 */
	function invalidateCachedEndpoints(response) {
	  var error = response.error;
	  var httpResponse = response.httpResponse;
	  if (error &&
	    (error.code === 'InvalidEndpointException' || httpResponse.statusCode === 421)
	  ) {
	    var request = response.request;
	    var operations = request.service.api.operations || {};
	    var inputShape = operations[request.operation] ? operations[request.operation].input : undefined;
	    var identifiers = marshallCustomIdentifiers(request, inputShape);
	    var cacheKey = getCacheKey(request);
	    if (Object.keys(identifiers).length > 0) {
	      cacheKey = util.update(cacheKey, identifiers);
	      if (operations[request.operation]) cacheKey.operation = operations[request.operation].name;
	    }
	    AWS.endpointCache.remove(cacheKey);
	  }
	}
	
	/**
	 * If endpoint is explicitly configured, SDK should not do endpoint discovery in anytime.
	 * @param [object] client Service client object.
	 * @api private
	 */
	function hasCustomEndpoint(client) {
	  //if set endpoint is set for specific client, enable endpoint discovery will raise an error.
	  if (client._originalConfig && client._originalConfig.endpoint && client._originalConfig.endpointDiscoveryEnabled === true) {
	    throw util.error(new Error(), {
	      code: 'ConfigurationException',
	      message: 'Custom endpoint is supplied; endpointDiscoveryEnabled must not be true.'
	    });
	  };
	  var svcConfig = AWS.config[client.serviceIdentifier] || {};
	  return Boolean(AWS.config.endpoint || svcConfig.endpoint || (client._originalConfig && client._originalConfig.endpoint));
	}
	
	/**
	 * @api private
	 */
	function isFalsy(value) {
	  return ['false', '0'].indexOf(value) >= 0;
	}
	
	/**
	 * If endpoint discovery should perform for this request when endpoint discovery is optional.
	 * SDK performs config resolution in order like below:
	 * 1. If turned on client configuration(default to off) then turn on endpoint discovery.
	 * 2. If turned on in env AWS_ENABLE_ENDPOINT_DISCOVERY then turn on endpoint discovery.
	 * 3. If turned on in shared ini config file with key 'endpoint_discovery_enabled', then
	 *   turn on endpoint discovery.
	 * @param [object] request request object.
	 * @api private
	 */
	function isEndpointDiscoveryApplicable(request) {
	  var service = request.service || {};
	  if (service.config.endpointDiscoveryEnabled === true) return true;
	
	  //shared ini file is only available in Node
	  //not to check env in browser
	  if (util.isBrowser()) return false;
	
	  for (var i = 0; i < endpointDiscoveryEnabledEnvs.length; i++) {
	    var env = endpointDiscoveryEnabledEnvs[i];
	    if (Object.prototype.hasOwnProperty.call(({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}), env)) {
	      if (({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"})[env] === '' || ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"})[env] === undefined) {
	        throw util.error(new Error(), {
	          code: 'ConfigurationException',
	          message: 'environmental variable ' + env + ' cannot be set to nothing'
	        });
	      }
	      if (!isFalsy(({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"})[env])) return true;
	    }
	  }
	
	  var configFile = {};
	  try {
	    configFile = AWS.util.iniLoader ? AWS.util.iniLoader.loadFrom({
	      isConfig: true,
	      filename: ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"})[AWS.util.sharedConfigFileEnv]
	    }) : {};
	  } catch (e) {}
	  var sharedFileConfig = configFile[
	    ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}).AWS_PROFILE || AWS.util.defaultProfile
	  ] || {};
	  if (Object.prototype.hasOwnProperty.call(sharedFileConfig, 'endpoint_discovery_enabled')) {
	    if (sharedFileConfig.endpoint_discovery_enabled === undefined) {
	      throw util.error(new Error(), {
	        code: 'ConfigurationException',
	        message: 'config file entry \'endpoint_discovery_enabled\' cannot be set to nothing'
	      });
	    }
	    if (!isFalsy(sharedFileConfig.endpoint_discovery_enabled)) return true;
	  }
	  return false;
	}
	
	/**
	 * attach endpoint discovery logic to request object
	 * @param [object] request
	 * @api private
	 */
	function discoverEndpoint(request, done) {
	  var service = request.service || {};
	  if (hasCustomEndpoint(service) || request.isPresigned()) return done();
	
	  if (!isEndpointDiscoveryApplicable(request)) return done();
	
	  request.httpRequest.appendToUserAgent('endpoint-discovery');
	
	  var operations = service.api.operations || {};
	  var operationModel = operations[request.operation];
	  var isEndpointDiscoveryRequired = operationModel ? operationModel.endpointDiscoveryRequired : 'NULL';
	  switch (isEndpointDiscoveryRequired) {
	    case 'OPTIONAL':
	      optionalDiscoverEndpoint(request);
	      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
	      done();
	      break;
	    case 'REQUIRED':
	      request.addNamedListener('INVALIDATE_CACHED_ENDPOINTS', 'extractError', invalidateCachedEndpoints);
	      requiredDiscoverEndpoint(request, done);
	      break;
	    case 'NULL':
	    default:
	      done();
	      break;
	  }
	}
	
	module.exports = {
	  discoverEndpoint: discoverEndpoint,
	  requiredDiscoverEndpoint: requiredDiscoverEndpoint,
	  optionalDiscoverEndpoint: optionalDiscoverEndpoint,
	  marshallCustomIdentifiers: marshallCustomIdentifiers,
	  getCacheKey: getCacheKey,
	  invalidateCachedEndpoint: invalidateCachedEndpoints,
	};


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var util = AWS.util;
	var typeOf = __webpack_require__(425).typeOf;
	var DynamoDBSet = __webpack_require__(424);
	var NumberValue = __webpack_require__(1009);
	
	AWS.DynamoDB.Converter = {
	  /**
	   * Convert a JavaScript value to its equivalent DynamoDB AttributeValue type
	   *
	   * @param data [any] The data to convert to a DynamoDB AttributeValue
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   * @return [map] An object in the Amazon DynamoDB AttributeValue format
	   *
	   * @see AWS.DynamoDB.Converter.marshall AWS.DynamoDB.Converter.marshall to
	   *    convert entire records (rather than individual attributes)
	   */
	  input: function convertInput(data, options) {
	    options = options || {};
	    var type = typeOf(data);
	    if (type === 'Object') {
	      return formatMap(data, options);
	    } else if (type === 'Array') {
	      return formatList(data, options);
	    } else if (type === 'Set') {
	      return formatSet(data, options);
	    } else if (type === 'String') {
	      if (data.length === 0 && options.convertEmptyValues) {
	        return convertInput(null);
	      }
	      return { S: data };
	    } else if (type === 'Number' || type === 'NumberValue') {
	      return { N: data.toString() };
	    } else if (type === 'Binary') {
	      if (data.length === 0 && options.convertEmptyValues) {
	        return convertInput(null);
	      }
	      return { B: data };
	    } else if (type === 'Boolean') {
	      return { BOOL: data };
	    } else if (type === 'null') {
	      return { NULL: true };
	    } else if (type !== 'undefined' && type !== 'Function') {
	      // this value has a custom constructor
	      return formatMap(data, options);
	    }
	  },
	
	  /**
	   * Convert a JavaScript object into a DynamoDB record.
	   *
	   * @param data [any] The data to convert to a DynamoDB record
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [map] An object in the DynamoDB record format.
	   *
	   * @example Convert a JavaScript object into a DynamoDB record
	   *  var marshalled = AWS.DynamoDB.Converter.marshall({
	   *    string: 'foo',
	   *    list: ['fizz', 'buzz', 'pop'],
	   *    map: {
	   *      nestedMap: {
	   *        key: 'value',
	   *      }
	   *    },
	   *    number: 123,
	   *    nullValue: null,
	   *    boolValue: true,
	   *    stringSet: new DynamoDBSet(['foo', 'bar', 'baz'])
	   *  });
	   */
	  marshall: function marshallItem(data, options) {
	    return AWS.DynamoDB.Converter.input(data, options).M;
	  },
	
	  /**
	   * Convert a DynamoDB AttributeValue object to its equivalent JavaScript type.
	   *
	   * @param data [map] An object in the Amazon DynamoDB AttributeValue format
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [Object|Array|String|Number|Boolean|null]
	   *
	   * @see AWS.DynamoDB.Converter.unmarshall AWS.DynamoDB.Converter.unmarshall to
	   *    convert entire records (rather than individual attributes)
	   */
	  output: function convertOutput(data, options) {
	    options = options || {};
	    var list, map, i;
	    for (var type in data) {
	      var values = data[type];
	      if (type === 'M') {
	        map = {};
	        for (var key in values) {
	          map[key] = convertOutput(values[key], options);
	        }
	        return map;
	      } else if (type === 'L') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(convertOutput(values[i], options));
	        }
	        return list;
	      } else if (type === 'SS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(values[i] + '');
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'NS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(convertNumber(values[i], options.wrapNumbers));
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'BS') {
	        list = [];
	        for (i = 0; i < values.length; i++) {
	          list.push(AWS.util.buffer.toBuffer(values[i]));
	        }
	        return new DynamoDBSet(list);
	      } else if (type === 'S') {
	        return values + '';
	      } else if (type === 'N') {
	        return convertNumber(values, options.wrapNumbers);
	      } else if (type === 'B') {
	        return util.buffer.toBuffer(values);
	      } else if (type === 'BOOL') {
	        return (values === 'true' || values === 'TRUE' || values === true);
	      } else if (type === 'NULL') {
	        return null;
	      }
	    }
	  },
	
	  /**
	   * Convert a DynamoDB record into a JavaScript object.
	   *
	   * @param data [any] The DynamoDB record
	   * @param options [map]
	   * @option options convertEmptyValues [Boolean] Whether to automatically
	   *                                              convert empty strings, blobs,
	   *                                              and sets to `null`
	   * @option options wrapNumbers [Boolean]  Whether to return numbers as a
	   *                                        NumberValue object instead of
	   *                                        converting them to native JavaScript
	   *                                        numbers. This allows for the safe
	   *                                        round-trip transport of numbers of
	   *                                        arbitrary size.
	   *
	   * @return [map] An object whose properties have been converted from
	   *    DynamoDB's AttributeValue format into their corresponding native
	   *    JavaScript types.
	   *
	   * @example Convert a record received from a DynamoDB stream
	   *  var unmarshalled = AWS.DynamoDB.Converter.unmarshall({
	   *    string: {S: 'foo'},
	   *    list: {L: [{S: 'fizz'}, {S: 'buzz'}, {S: 'pop'}]},
	   *    map: {
	   *      M: {
	   *        nestedMap: {
	   *          M: {
	   *            key: {S: 'value'}
	   *          }
	   *        }
	   *      }
	   *    },
	   *    number: {N: '123'},
	   *    nullValue: {NULL: true},
	   *    boolValue: {BOOL: true}
	   *  });
	   */
	  unmarshall: function unmarshall(data, options) {
	    return AWS.DynamoDB.Converter.output({M: data}, options);
	  }
	};
	
	/**
	 * @api private
	 * @param data [Array]
	 * @param options [map]
	 */
	function formatList(data, options) {
	  var list = {L: []};
	  for (var i = 0; i < data.length; i++) {
	    list['L'].push(AWS.DynamoDB.Converter.input(data[i], options));
	  }
	  return list;
	}
	
	/**
	 * @api private
	 * @param value [String]
	 * @param wrapNumbers [Boolean]
	 */
	function convertNumber(value, wrapNumbers) {
	  return wrapNumbers ? new NumberValue(value) : Number(value);
	}
	
	/**
	 * @api private
	 * @param data [map]
	 * @param options [map]
	 */
	function formatMap(data, options) {
	  var map = {M: {}};
	  for (var key in data) {
	    var formatted = AWS.DynamoDB.Converter.input(data[key], options);
	    if (formatted !== void 0) {
	      map['M'][key] = formatted;
	    }
	  }
	  return map;
	}
	
	/**
	 * @api private
	 */
	function formatSet(data, options) {
	  options = options || {};
	  var values = data.values;
	  if (options.convertEmptyValues) {
	    values = filterEmptySetValues(data);
	    if (values.length === 0) {
	      return AWS.DynamoDB.Converter.input(null);
	    }
	  }
	
	  var map = {};
	  switch (data.type) {
	    case 'String': map['SS'] = values; break;
	    case 'Binary': map['BS'] = values; break;
	    case 'Number': map['NS'] = values.map(function (value) {
	      return value.toString();
	    });
	  }
	  return map;
	}
	
	/**
	 * @api private
	 */
	function filterEmptySetValues(set) {
	    var nonEmptyValues = [];
	    var potentiallyEmptyTypes = {
	        String: true,
	        Binary: true,
	        Number: false
	    };
	    if (potentiallyEmptyTypes[set.type]) {
	        for (var i = 0; i < set.values.length; i++) {
	            if (set.values[i].length === 0) {
	                continue;
	            }
	            nonEmptyValues.push(set.values[i]);
	        }
	
	        return nonEmptyValues;
	    }
	
	    return set.values;
	}
	
	/**
	 * @api private
	 */
	module.exports = AWS.DynamoDB.Converter;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var Translator = __webpack_require__(1010);
	var DynamoDBSet = __webpack_require__(424);
	
	/**
	 * The document client simplifies working with items in Amazon DynamoDB
	 * by abstracting away the notion of attribute values. This abstraction
	 * annotates native JavaScript types supplied as input parameters, as well
	 * as converts annotated response data to native JavaScript types.
	 *
	 * ## Marshalling Input and Unmarshalling Response Data
	 *
	 * The document client affords developers the use of native JavaScript types
	 * instead of `AttributeValue`s to simplify the JavaScript development
	 * experience with Amazon DynamoDB. JavaScript objects passed in as parameters
	 * are marshalled into `AttributeValue` shapes required by Amazon DynamoDB.
	 * Responses from DynamoDB are unmarshalled into plain JavaScript objects
	 * by the `DocumentClient`. The `DocumentClient`, does not accept
	 * `AttributeValue`s in favor of native JavaScript types.
	 *
	 * |                             JavaScript Type                            | DynamoDB AttributeValue |
	 * |:----------------------------------------------------------------------:|-------------------------|
	 * | String                                                                 | S                       |
	 * | Number                                                                 | N                       |
	 * | Boolean                                                                | BOOL                    |
	 * | null                                                                   | NULL                    |
	 * | Array                                                                  | L                       |
	 * | Object                                                                 | M                       |
	 * | Buffer, File, Blob, ArrayBuffer, DataView, and JavaScript typed arrays | B                       |
	 *
	 * ## Support for Sets
	 *
	 * The `DocumentClient` offers a convenient way to create sets from
	 * JavaScript Arrays. The type of set is inferred from the first element
	 * in the array. DynamoDB supports string, number, and binary sets. To
	 * learn more about supported types see the
	 * [Amazon DynamoDB Data Model Documentation](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html)
	 * For more information see {AWS.DynamoDB.DocumentClient.createSet}
	 *
	 */
	AWS.DynamoDB.DocumentClient = AWS.util.inherit({
	
	  /**
	   * Creates a DynamoDB document client with a set of configuration options.
	   *
	   * @option options params [map] An optional map of parameters to bind to every
	   *   request sent by this service object.
	   * @option options service [AWS.DynamoDB] An optional pre-configured instance
	   *  of the AWS.DynamoDB service object to use for requests. The object may
	   *  bound parameters used by the document client.
	   * @option options convertEmptyValues [Boolean] set to true if you would like
	   *  the document client to convert empty values (0-length strings, binary
	   *  buffers, and sets) to be converted to NULL types when persisting to
	   *  DynamoDB.
	   * @see AWS.DynamoDB.constructor
	   *
	   */
	  constructor: function DocumentClient(options) {
	    var self = this;
	    self.options = options || {};
	    self.configure(self.options);
	  },
	
	  /**
	   * @api private
	   */
	  configure: function configure(options) {
	    var self = this;
	    self.service = options.service;
	    self.bindServiceObject(options);
	    self.attrValue = options.attrValue =
	      self.service.api.operations.putItem.input.members.Item.value.shape;
	  },
	
	  /**
	   * @api private
	   */
	  bindServiceObject: function bindServiceObject(options) {
	    var self = this;
	    options = options || {};
	
	    if (!self.service) {
	      self.service = new AWS.DynamoDB(options);
	    } else {
	      var config = AWS.util.copy(self.service.config);
	      self.service = new self.service.constructor.__super__(config);
	      self.service.config.params =
	        AWS.util.merge(self.service.config.params || {}, options.params);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  makeServiceRequest: function(operation, params, callback) {
	    var self = this;
	    var request = self.service[operation](params);
	    self.setupRequest(request);
	    self.setupResponse(request);
	    if (typeof callback === 'function') {
	      request.send(callback);
	    }
	    return request;
	  },
	
	  /**
	   * @api private
	   */
	  serviceClientOperationsMap: {
	    batchGet: 'batchGetItem',
	    batchWrite: 'batchWriteItem',
	    delete: 'deleteItem',
	    get: 'getItem',
	    put: 'putItem',
	    query: 'query',
	    scan: 'scan',
	    update: 'updateItem',
	    transactGet: 'transactGetItems',
	    transactWrite: 'transactWriteItems'
	  },
	
	  /**
	   * Returns the attributes of one or more items from one or more tables
	   * by delegating to `AWS.DynamoDB.batchGetItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.batchGetItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.batchGetItem
	   * @example Get items from multiple tables
	   *  var params = {
	   *    RequestItems: {
	   *      'Table-1': {
	   *        Keys: [
	   *          {
	   *             HashKey: 'haskey',
	   *             NumberRangeKey: 1
	   *          }
	   *        ]
	   *      },
	   *      'Table-2': {
	   *        Keys: [
	   *          { foo: 'bar' },
	   *        ]
	   *      }
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.batchGet(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  batchGet: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['batchGet'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Puts or deletes multiple items in one or more tables by delegating
	   * to `AWS.DynamoDB.batchWriteItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.batchWriteItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.batchWriteItem
	   * @example Write to and delete from a table
	   *  var params = {
	   *    RequestItems: {
	   *      'Table-1': [
	   *        {
	   *          DeleteRequest: {
	   *            Key: { HashKey: 'someKey' }
	   *          }
	   *        },
	   *        {
	   *          PutRequest: {
	   *            Item: {
	   *              HashKey: 'anotherKey',
	   *              NumAttribute: 1,
	   *              BoolAttribute: true,
	   *              ListAttribute: [1, 'two', false],
	   *              MapAttribute: { foo: 'bar' }
	   *            }
	   *          }
	   *        }
	   *      ]
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.batchWrite(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  batchWrite: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['batchWrite'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Deletes a single item in a table by primary key by delegating to
	   * `AWS.DynamoDB.deleteItem()`
	   *
	   * Supply the same parameters as {AWS.DynamoDB.deleteItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.deleteItem
	   * @example Delete an item from a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Key: {
	   *      HashKey: 'hashkey',
	   *      NumberRangeKey: 1
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.delete(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  delete: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['delete'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Returns a set of attributes for the item with the given primary key
	   * by delegating to `AWS.DynamoDB.getItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.getItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.getItem
	   * @example Get an item from a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Key: {
	   *      HashKey: 'hashkey'
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.get(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  get: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['get'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Creates a new item, or replaces an old item with a new item by
	   * delegating to `AWS.DynamoDB.putItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.putItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.putItem
	   * @example Create a new item in a table
	   *  var params = {
	   *    TableName : 'Table',
	   *    Item: {
	   *       HashKey: 'haskey',
	   *       NumAttribute: 1,
	   *       BoolAttribute: true,
	   *       ListAttribute: [1, 'two', false],
	   *       MapAttribute: { foo: 'bar'},
	   *       NullAttribute: null
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.put(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  put: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['put'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Edits an existing item's attributes, or adds a new item to the table if
	   * it does not already exist by delegating to `AWS.DynamoDB.updateItem()`.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.updateItem} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.updateItem
	   * @example Update an item with expressions
	   *  var params = {
	   *    TableName: 'Table',
	   *    Key: { HashKey : 'hashkey' },
	   *    UpdateExpression: 'set #a = :x + :y',
	   *    ConditionExpression: '#a < :MAX',
	   *    ExpressionAttributeNames: {'#a' : 'Sum'},
	   *    ExpressionAttributeValues: {
	   *      ':x' : 20,
	   *      ':y' : 45,
	   *      ':MAX' : 100,
	   *    }
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.update(params, function(err, data) {
	   *     if (err) console.log(err);
	   *     else console.log(data);
	   *  });
	   *
	   */
	  update: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['update'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Returns one or more items and item attributes by accessing every item
	   * in a table or a secondary index.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.scan} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.scan
	   * @example Scan the table with a filter expression
	   *  var params = {
	   *    TableName : 'Table',
	   *    FilterExpression : 'Year = :this_year',
	   *    ExpressionAttributeValues : {':this_year' : 2015}
	   *  };
	   *
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  documentClient.scan(params, function(err, data) {
	   *     if (err) console.log(err);
	   *     else console.log(data);
	   *  });
	   *
	   */
	  scan: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['scan'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	   /**
	    * Directly access items from a table by primary key or a secondary index.
	    *
	    * Supply the same parameters as {AWS.DynamoDB.query} with
	    * `AttributeValue`s substituted by native JavaScript types.
	    *
	    * @see AWS.DynamoDB.query
	    * @example Query an index
	    *  var params = {
	    *    TableName: 'Table',
	    *    IndexName: 'Index',
	    *    KeyConditionExpression: 'HashKey = :hkey and RangeKey > :rkey',
	    *    ExpressionAttributeValues: {
	    *      ':hkey': 'key',
	    *      ':rkey': 2015
	    *    }
	    *  };
	    *
	    *  var documentClient = new AWS.DynamoDB.DocumentClient();
	    *
	    *  documentClient.query(params, function(err, data) {
	    *     if (err) console.log(err);
	    *     else console.log(data);
	    *  });
	    *
	    */
	  query: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['query'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Synchronous write operation that groups up to 10 action requests
	   *
	   * Supply the same parameters as {AWS.DynamoDB.transactWriteItems} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.transactWriteItems
	   * @example Get items from multiple tables
	   *  var params = {
	   *    TransactItems: [{
	   *      Put: {
	   *        TableName : 'Table0',
	   *        Item: {
	   *          HashKey: 'haskey',
	   *          NumAttribute: 1,
	   *          BoolAttribute: true,
	   *          ListAttribute: [1, 'two', false],
	   *          MapAttribute: { foo: 'bar'},
	   *          NullAttribute: null
	   *        }
	   *      }
	   *    }, {
	   *      Update: {
	   *        TableName: 'Table1',
	   *        Key: { HashKey : 'hashkey' },
	   *        UpdateExpression: 'set #a = :x + :y',
	   *        ConditionExpression: '#a < :MAX',
	   *        ExpressionAttributeNames: {'#a' : 'Sum'},
	   *        ExpressionAttributeValues: {
	   *          ':x' : 20,
	   *          ':y' : 45,
	   *          ':MAX' : 100,
	   *        }
	   *      }
	   *    }]
	   *  };
	   *
	   *  documentClient.transactWrite(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   */
	  transactWrite: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['transactWrite'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Atomically retrieves multiple items from one or more tables (but not from indexes)
	   * in a single account and region.
	   *
	   * Supply the same parameters as {AWS.DynamoDB.transactGetItems} with
	   * `AttributeValue`s substituted by native JavaScript types.
	   *
	   * @see AWS.DynamoDB.transactGetItems
	   * @example Get items from multiple tables
	   *  var params = {
	   *    TransactItems: [{
	   *      Get: {
	   *        TableName : 'Table0',
	   *        Key: {
	   *          HashKey: 'hashkey0'
	   *        }
	   *      }
	   *    }, {
	   *      Get: {
	   *        TableName : 'Table1',
	   *        Key: {
	   *          HashKey: 'hashkey1'
	   *        }
	   *      }
	   *    }]
	   *  };
	   *
	   *  documentClient.transactGet(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   */
	  transactGet: function(params, callback) {
	    var operation = this.serviceClientOperationsMap['transactGet'];
	    return this.makeServiceRequest(operation, params, callback);
	  },
	
	  /**
	   * Creates a set of elements inferring the type of set from
	   * the type of the first element. Amazon DynamoDB currently supports
	   * the number sets, string sets, and binary sets. For more information
	   * about DynamoDB data types see the documentation on the
	   * [Amazon DynamoDB Data Model](http://docs.aws.amazon.com/amazondynamodb/latest/developerguide/DataModel.html#DataModel.DataTypes).
	   *
	   * @param list [Array] Collection to represent your DynamoDB Set
	   * @param options [map]
	   *  * **validate** [Boolean] set to true if you want to validate the type
	   *    of each element in the set. Defaults to `false`.
	   * @example Creating a number set
	   *  var documentClient = new AWS.DynamoDB.DocumentClient();
	   *
	   *  var params = {
	   *    Item: {
	   *      hashkey: 'hashkey'
	   *      numbers: documentClient.createSet([1, 2, 3]);
	   *    }
	   *  };
	   *
	   *  documentClient.put(params, function(err, data) {
	   *    if (err) console.log(err);
	   *    else console.log(data);
	   *  });
	   *
	   */
	  createSet: function(list, options) {
	    options = options || {};
	    return new DynamoDBSet(list, options);
	  },
	
	  /**
	   * @api private
	   */
	  getTranslator: function() {
	    return new Translator(this.options);
	  },
	
	  /**
	   * @api private
	   */
	  setupRequest: function setupRequest(request) {
	    var self = this;
	    var translator = self.getTranslator();
	    var operation = request.operation;
	    var inputShape = request.service.api.operations[operation].input;
	    request._events.validate.unshift(function(req) {
	      req.rawParams = AWS.util.copy(req.params);
	      req.params = translator.translateInput(req.rawParams, inputShape);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  setupResponse: function setupResponse(request) {
	    var self = this;
	    var translator = self.getTranslator();
	    var outputShape = self.service.api.operations[request.operation].output;
	    request.on('extractData', function(response) {
	      response.data = translator.translateOutput(response.data, outputShape);
	    });
	
	    var response = request.response;
	    response.nextPage = function(cb) {
	      var resp = this;
	      var req = resp.request;
	      var config;
	      var service = req.service;
	      var operation = req.operation;
	      try {
	        config = service.paginationConfig(operation, true);
	      } catch (e) { resp.error = e; }
	
	      if (!resp.hasNextPage()) {
	        if (cb) cb(resp.error, null);
	        else if (resp.error) throw resp.error;
	        return null;
	      }
	
	      var params = AWS.util.copy(req.rawParams);
	      if (!resp.nextPageTokens) {
	        return cb ? cb(null, null) : null;
	      } else {
	        var inputTokens = config.inputToken;
	        if (typeof inputTokens === 'string') inputTokens = [inputTokens];
	        for (var i = 0; i < inputTokens.length; i++) {
	          params[inputTokens[i]] = resp.nextPageTokens[i];
	        }
	        return self[operation](params, cb);
	      }
	    };
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.DynamoDB.DocumentClient;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	
	/**
	 * An object recognizable as a numeric value that stores the underlying number
	 * as a string.
	 *
	 * Intended to be a deserialization target for the DynamoDB Document Client when
	 * the `wrapNumbers` flag is set. This allows for numeric values that lose
	 * precision when converted to JavaScript's `number` type.
	 */
	var DynamoDBNumberValue = util.inherit({
	  constructor: function NumberValue(value) {
	    this.wrapperName = 'NumberValue';
	    this.value = value.toString();
	  },
	
	  /**
	   * Render the underlying value as a number when converting to JSON.
	   */
	  toJSON: function () {
	    return this.toNumber();
	  },
	
	  /**
	   * Convert the underlying value to a JavaScript number.
	   */
	  toNumber: function () {
	    return Number(this.value);
	  },
	
	  /**
	   * Return a string representing the unaltered value provided to the
	   * constructor.
	   */
	  toString: function () {
	    return this.value;
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = DynamoDBNumberValue;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var convert = __webpack_require__(1007);
	
	var Translator = function(options) {
	  options = options || {};
	  this.attrValue = options.attrValue;
	  this.convertEmptyValues = Boolean(options.convertEmptyValues);
	  this.wrapNumbers = Boolean(options.wrapNumbers);
	};
	
	Translator.prototype.translateInput = function(value, shape) {
	  this.mode = 'input';
	  return this.translate(value, shape);
	};
	
	Translator.prototype.translateOutput = function(value, shape) {
	  this.mode = 'output';
	  return this.translate(value, shape);
	};
	
	Translator.prototype.translate = function(value, shape) {
	  var self = this;
	  if (!shape || value === undefined) return undefined;
	
	  if (shape.shape === self.attrValue) {
	    return convert[self.mode](value, {
	      convertEmptyValues: self.convertEmptyValues,
	      wrapNumbers: self.wrapNumbers,
	    });
	  }
	  switch (shape.type) {
	    case 'structure': return self.translateStructure(value, shape);
	    case 'map': return self.translateMap(value, shape);
	    case 'list': return self.translateList(value, shape);
	    default: return self.translateScalar(value, shape);
	  }
	};
	
	Translator.prototype.translateStructure = function(structure, shape) {
	  var self = this;
	  if (structure == null) return undefined;
	
	  var struct = {};
	  util.each(structure, function(name, value) {
	    var memberShape = shape.members[name];
	    if (memberShape) {
	      var result = self.translate(value, memberShape);
	      if (result !== undefined) struct[name] = result;
	    }
	  });
	  return struct;
	};
	
	Translator.prototype.translateList = function(list, shape) {
	  var self = this;
	  if (list == null) return undefined;
	
	  var out = [];
	  util.arrayEach(list, function(value) {
	    var result = self.translate(value, shape.member);
	    if (result === undefined) out.push(null);
	    else out.push(result);
	  });
	  return out;
	};
	
	Translator.prototype.translateMap = function(map, shape) {
	  var self = this;
	  if (map == null) return undefined;
	
	  var out = {};
	  util.each(map, function(key, value) {
	    var result = self.translate(value, shape.value);
	    if (result === undefined) out[key] = null;
	    else out[key] = result;
	  });
	  return out;
	};
	
	Translator.prototype.translateScalar = function(value, shape) {
	  return shape.toType(value);
	};
	
	/**
	 * @api private
	 */
	module.exports = Translator;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	var eventMessageChunker = __webpack_require__(1012).eventMessageChunker;
	var parseEvent = __webpack_require__(1014).parseEvent;
	
	function createEventStream(body, parser, model) {
	    var eventMessages = eventMessageChunker(body);
	
	    var events = [];
	
	    for (var i = 0; i < eventMessages.length; i++) {
	        events.push(parseEvent(parser, eventMessages[i], model));
	    }
	
	    return events;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    createEventStream: createEventStream
	};


/***/ },
/* 1012 */
/***/ function(module, exports) {

	/**
	 * Takes in a buffer of event messages and splits them into individual messages.
	 * @param {Buffer} buffer
	 * @api private
	 */
	function eventMessageChunker(buffer) {
	    /** @type Buffer[] */
	    var messages = [];
	    var offset = 0;
	
	    while (offset < buffer.length) {
	        var totalLength = buffer.readInt32BE(offset);
	
	        // create new buffer for individual message (shares memory with original)
	        var message = buffer.slice(offset, totalLength + offset);
	        // increment offset to it starts at the next message
	        offset += totalLength;
	
	        messages.push(message);
	    }
	
	    return messages;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    eventMessageChunker: eventMessageChunker
	};


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var toBuffer = util.buffer.toBuffer;
	
	/**
	 * A lossless representation of a signed, 64-bit integer. Instances of this
	 * class may be used in arithmetic expressions as if they were numeric
	 * primitives, but the binary representation will be preserved unchanged as the
	 * `bytes` property of the object. The bytes should be encoded as big-endian,
	 * two's complement integers.
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function Int64(bytes) {
	    if (bytes.length !== 8) {
	        throw new Error('Int64 buffers must be exactly 8 bytes');
	    }
	    if (!util.Buffer.isBuffer(bytes)) bytes = toBuffer(bytes);
	
	    this.bytes = bytes;
	}
	
	/**
	 * @param {number} number
	 * @returns {Int64}
	 *
	 * @api private
	 */
	Int64.fromNumber = function(number) {
	    if (number > 9223372036854775807 || number < -9223372036854775808) {
	        throw new Error(
	            number + ' is too large (or, if negative, too small) to represent as an Int64'
	        );
	    }
	
	    var bytes = new Uint8Array(8);
	    for (
	        var i = 7, remaining = Math.abs(Math.round(number));
	        i > -1 && remaining > 0;
	        i--, remaining /= 256
	    ) {
	        bytes[i] = remaining;
	    }
	
	    if (number < 0) {
	        negate(bytes);
	    }
	
	    return new Int64(bytes);
	};
	
	/**
	 * @returns {number}
	 *
	 * @api private
	 */
	Int64.prototype.valueOf = function() {
	    var bytes = this.bytes.slice(0);
	    var negative = bytes[0] & 128;
	    if (negative) {
	        negate(bytes);
	    }
	
	    return parseInt(bytes.toString('hex'), 16) * (negative ? -1 : 1);
	};
	
	Int64.prototype.toString = function() {
	    return String(this.valueOf());
	};
	
	/**
	 * @param {Buffer} bytes
	 *
	 * @api private
	 */
	function negate(bytes) {
	    for (var i = 0; i < 8; i++) {
	        bytes[i] ^= 0xFF;
	    }
	    for (var i = 7; i > -1; i--) {
	        bytes[i]++;
	        if (bytes[i] !== 0) {
	            break;
	        }
	    }
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    Int64: Int64
	};


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	var parseMessage = __webpack_require__(1015).parseMessage;
	
	/**
	 *
	 * @param {*} parser
	 * @param {Buffer} message
	 * @param {*} shape
	 * @api private
	 */
	function parseEvent(parser, message, shape) {
	    var parsedMessage = parseMessage(message);
	
	    // check if message is an event or error
	    var messageType = parsedMessage.headers[':message-type'];
	    if (messageType) {
	        if (messageType.value === 'error') {
	            throw parseError(parsedMessage);
	        } else if (messageType.value !== 'event') {
	            // not sure how to parse non-events/non-errors, ignore for now
	            return;
	        }
	    }
	
	    // determine event type
	    var eventType = parsedMessage.headers[':event-type'];
	    // check that the event type is modeled
	    var eventModel = shape.members[eventType.value];
	    if (!eventModel) {
	        return;
	    }
	
	    var result = {};
	    // check if an event payload exists
	    var eventPayloadMemberName = eventModel.eventPayloadMemberName;
	    if (eventPayloadMemberName) {
	        var payloadShape = eventModel.members[eventPayloadMemberName];
	        // if the shape is binary, return the byte array
	        if (payloadShape.type === 'binary') {
	            result[eventPayloadMemberName] = parsedMessage.body;
	        } else {
	            result[eventPayloadMemberName] = parser.parse(parsedMessage.body.toString(), payloadShape);
	        }
	    }
	
	    // read event headers
	    var eventHeaderNames = eventModel.eventHeaderMemberNames;
	    for (var i = 0; i < eventHeaderNames.length; i++) {
	        var name = eventHeaderNames[i];
	        if (parsedMessage.headers[name]) {
	            // parse the header!
	            result[name] = eventModel.members[name].toType(parsedMessage.headers[name].value);
	        }
	    }
	
	    var output = {};
	    output[eventType.value] = result;
	    return output;
	}
	
	function parseError(message) {
	    var errorCode = message.headers[':error-code'];
	    var errorMessage = message.headers[':error-message'];
	    var error = new Error(errorMessage.value || errorMessage);
	    error.code = error.name = errorCode.value || errorCode;
	    return error;
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    parseEvent: parseEvent
	};


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	var Int64 = __webpack_require__(1013).Int64;
	
	var splitMessage = __webpack_require__(1016).splitMessage;
	
	var BOOLEAN_TAG = 'boolean';
	var BYTE_TAG = 'byte';
	var SHORT_TAG = 'short';
	var INT_TAG = 'integer';
	var LONG_TAG = 'long';
	var BINARY_TAG = 'binary';
	var STRING_TAG = 'string';
	var TIMESTAMP_TAG = 'timestamp';
	var UUID_TAG = 'uuid';
	
	/**
	 * @api private
	 *
	 * @param {Buffer} headers
	 */
	function parseHeaders(headers) {
	    var out = {};
	    var position = 0;
	    while (position < headers.length) {
	        var nameLength = headers.readUInt8(position++);
	        var name = headers.slice(position, position + nameLength).toString();
	        position += nameLength;
	        switch (headers.readUInt8(position++)) {
	            case 0 /* boolTrue */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: true
	                };
	                break;
	            case 1 /* boolFalse */:
	                out[name] = {
	                    type: BOOLEAN_TAG,
	                    value: false
	                };
	                break;
	            case 2 /* byte */:
	                out[name] = {
	                    type: BYTE_TAG,
	                    value: headers.readInt8(position++)
	                };
	                break;
	            case 3 /* short */:
	                out[name] = {
	                    type: SHORT_TAG,
	                    value: headers.readInt16BE(position)
	                };
	                position += 2;
	                break;
	            case 4 /* integer */:
	                out[name] = {
	                    type: INT_TAG,
	                    value: headers.readInt32BE(position)
	                };
	                position += 4;
	                break;
	            case 5 /* long */:
	                out[name] = {
	                    type: LONG_TAG,
	                    value: new Int64(headers.slice(position, position + 8))
	                };
	                position += 8;
	                break;
	            case 6 /* byteArray */:
	                var binaryLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: BINARY_TAG,
	                    value: headers.slice(position, position + binaryLength)
	                };
	                position += binaryLength;
	                break;
	            case 7 /* string */:
	                var stringLength = headers.readUInt16BE(position);
	                position += 2;
	                out[name] = {
	                    type: STRING_TAG,
	                    value: headers.slice(
	                        position,
	                        position + stringLength
	                    ).toString()
	                };
	                position += stringLength;
	                break;
	            case 8 /* timestamp */:
	                out[name] = {
	                    type: TIMESTAMP_TAG,
	                    value: new Date(
	                        new Int64(headers.slice(position, position + 8))
	                            .valueOf()
	                    )
	                };
	                position += 8;
	                break;
	            case 9 /* uuid */:
	                var uuidChars = headers.slice(position, position + 16)
	                    .toString('hex');
	                position += 16;
	                out[name] = {
	                    type: UUID_TAG,
	                    value: uuidChars.substr(0, 8) + '-' +
	                        uuidChars.substr(8, 4) + '-' +
	                        uuidChars.substr(12, 4) + '-' +
	                        uuidChars.substr(16, 4) + '-' +
	                        uuidChars.substr(20)
	                };
	                break;
	            default:
	                throw new Error('Unrecognized header type tag');
	        }
	    }
	    return out;
	}
	
	function parseMessage(message) {
	    var parsed = splitMessage(message);
	    return { headers: parseHeaders(parsed.headers), body: parsed.body };
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    parseMessage: parseMessage
	};


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4).util;
	var toBuffer = util.buffer.toBuffer;
	
	// All prelude components are unsigned, 32-bit integers
	var PRELUDE_MEMBER_LENGTH = 4;
	// The prelude consists of two components
	var PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
	// Checksums are always CRC32 hashes.
	var CHECKSUM_LENGTH = 4;
	// Messages must include a full prelude, a prelude checksum, and a message checksum
	var MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
	
	/**
	 * @api private
	 *
	 * @param {Buffer} message
	 */
	function splitMessage(message) {
	    if (!util.Buffer.isBuffer(message)) message = toBuffer(message);
	
	    if (message.length < MINIMUM_MESSAGE_LENGTH) {
	        throw new Error('Provided message too short to accommodate event stream message overhead');
	    }
	
	    if (message.length !== message.readUInt32BE(0)) {
	        throw new Error('Reported message length does not match received message length');
	    }
	
	    var expectedPreludeChecksum = message.readUInt32BE(PRELUDE_LENGTH);
	
	    if (
	        expectedPreludeChecksum !== util.crypto.crc32(
	            message.slice(0, PRELUDE_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The prelude checksum specified in the message (' +
	            expectedPreludeChecksum +
	            ') does not match the calculated CRC32 checksum.'
	        );
	    }
	
	    var expectedMessageChecksum = message.readUInt32BE(message.length - CHECKSUM_LENGTH);
	
	    if (
	        expectedMessageChecksum !== util.crypto.crc32(
	            message.slice(0, message.length - CHECKSUM_LENGTH)
	        )
	    ) {
	        throw new Error(
	            'The message checksum did not match the expected value of ' +
	                expectedMessageChecksum
	        );
	    }
	
	    var headersStart = PRELUDE_LENGTH + CHECKSUM_LENGTH;
	    var headersEnd = headersStart + message.readUInt32BE(PRELUDE_MEMBER_LENGTH);
	
	    return {
	        headers: message.slice(headersStart, headersEnd),
	        body: message.slice(headersEnd, message.length - CHECKSUM_LENGTH),
	    };
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    splitMessage: splitMessage
	};


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var SequentialExecutor = __webpack_require__(435);
	var DISCOVER_ENDPOINT = __webpack_require__(1006).discoverEndpoint;
	/**
	 * The namespace used to register global event listeners for request building
	 * and sending.
	 */
	AWS.EventListeners = {
	  /**
	   * @!attribute VALIDATE_CREDENTIALS
	   *   A request listener that validates whether the request is being
	   *   sent with credentials.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating credentials
	   *     var listener = AWS.EventListeners.Core.VALIDATE_CREDENTIALS;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_REGION
	   *   A request listener that validates whether the region is set
	   *   for a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating region configuration
	   *     var listener = AWS.EventListeners.Core.VALIDATE_REGION;
	   *     request.removeListener('validate', listener);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute VALIDATE_PARAMETERS
	   *   A request listener that validates input parameters in a request.
	   *   Handles the {AWS.Request~validate 'validate' Request event}
	   *   @example Sending a request without validating parameters
	   *     var listener = AWS.EventListeners.Core.VALIDATE_PARAMETERS;
	   *     request.removeListener('validate', listener);
	   *   @example Disable parameter validation globally
	   *     AWS.EventListeners.Core.removeListener('validate',
	   *       AWS.EventListeners.Core.VALIDATE_REGION);
	   *   @readonly
	   *   @return [Function]
	   * @!attribute SEND
	   *   A request listener that initiates the HTTP connection for a
	   *   request being sent. Handles the {AWS.Request~send 'send' Request event}
	   *   @example Replacing the HTTP handler
	   *     var listener = AWS.EventListeners.Core.SEND;
	   *     request.removeListener('send', listener);
	   *     request.on('send', function(response) {
	   *       customHandler.send(response);
	   *     });
	   *   @return [Function]
	   *   @readonly
	   * @!attribute HTTP_DATA
	   *   A request listener that reads data from the HTTP connection in order
	   *   to build the response data.
	   *   Handles the {AWS.Request~httpData 'httpData' Request event}.
	   *   Remove this handler if you are overriding the 'httpData' event and
	   *   do not want extra data processing and buffering overhead.
	   *   @example Disabling default data processing
	   *     var listener = AWS.EventListeners.Core.HTTP_DATA;
	   *     request.removeListener('httpData', listener);
	   *   @return [Function]
	   *   @readonly
	   */
	  Core: {} /* doc hack */
	};
	
	/**
	 * @api private
	 */
	function getOperationAuthtype(req) {
	  if (!req.service.api.operations) {
	    return '';
	  }
	  var operation = req.service.api.operations[req.operation];
	  return operation ? operation.authtype : '';
	}
	
	AWS.EventListeners = {
	  Core: new SequentialExecutor().addNamedListeners(function(add, addAsync) {
	    addAsync('VALIDATE_CREDENTIALS', 'validate',
	        function VALIDATE_CREDENTIALS(req, done) {
	      if (!req.service.api.signatureVersion) return done(); // none
	      req.service.config.getCredentials(function(err) {
	        if (err) {
	          req.response.error = AWS.util.error(err,
	            {code: 'CredentialsError', message: 'Missing credentials in config'});
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_REGION', 'validate', function VALIDATE_REGION(req) {
	      if (!req.service.config.region && !req.service.isGlobalEndpoint) {
	        req.response.error = AWS.util.error(new Error(),
	          {code: 'ConfigError', message: 'Missing region in config'});
	      }
	    });
	
	    add('BUILD_IDEMPOTENCY_TOKENS', 'validate', function BUILD_IDEMPOTENCY_TOKENS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      if (!operation) {
	        return;
	      }
	      var idempotentMembers = operation.idempotentMembers;
	      if (!idempotentMembers.length) {
	        return;
	      }
	      // creates a copy of params so user's param object isn't mutated
	      var params = AWS.util.copy(req.params);
	      for (var i = 0, iLen = idempotentMembers.length; i < iLen; i++) {
	        if (!params[idempotentMembers[i]]) {
	          // add the member
	          params[idempotentMembers[i]] = AWS.util.uuid.v4();
	        }
	      }
	      req.params = params;
	    });
	
	    add('VALIDATE_PARAMETERS', 'validate', function VALIDATE_PARAMETERS(req) {
	      if (!req.service.api.operations) {
	        return;
	      }
	      var rules = req.service.api.operations[req.operation].input;
	      var validation = req.service.config.paramValidation;
	      new AWS.ParamValidator(validation).validate(rules, req.params);
	    });
	
	    addAsync('COMPUTE_SHA256', 'afterBuild', function COMPUTE_SHA256(req, done) {
	      req.haltHandlersOnError();
	      if (!req.service.api.operations) {
	        return;
	      }
	      var operation = req.service.api.operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!req.service.api.signatureVersion && !authtype) return done(); // none
	      if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	        var body = req.httpRequest.body || '';
	        if (authtype.indexOf('unsigned-body') >= 0) {
	          req.httpRequest.headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	          return done();
	        }
	        AWS.util.computeSha256(body, function(err, sha) {
	          if (err) {
	            done(err);
	          }
	          else {
	            req.httpRequest.headers['X-Amz-Content-Sha256'] = sha;
	            done();
	          }
	        });
	      } else {
	        done();
	      }
	    });
	
	    add('SET_CONTENT_LENGTH', 'afterBuild', function SET_CONTENT_LENGTH(req) {
	      var authtype = getOperationAuthtype(req);
	      var payloadMember = AWS.util.getRequestPayloadShape(req);
	      if (req.httpRequest.headers['Content-Length'] === undefined) {
	        try {
	          var length = AWS.util.string.byteLength(req.httpRequest.body);
	          req.httpRequest.headers['Content-Length'] = length;
	        } catch (err) {
	          if (payloadMember && payloadMember.isStreaming) {
	            if (payloadMember.requiresLength) {
	              //streaming payload requires length(s3, glacier)
	              throw err;
	            } else if (authtype.indexOf('unsigned-body') >= 0) {
	              //unbounded streaming payload(lex, mediastore)
	              req.httpRequest.headers['Transfer-Encoding'] = 'chunked';
	              return;
	            } else {
	              throw err;
	            }
	          }
	          throw err;
	        }
	      }
	    });
	
	    add('SET_HTTP_HOST', 'afterBuild', function SET_HTTP_HOST(req) {
	      req.httpRequest.headers['Host'] = req.httpRequest.endpoint.host;
	    });
	
	    add('RESTART', 'restart', function RESTART() {
	      var err = this.response.error;
	      if (!err || !err.retryable) return;
	
	      this.httpRequest = new AWS.HttpRequest(
	        this.service.endpoint,
	        this.service.region
	      );
	
	      if (this.response.retryCount < this.service.config.maxRetries) {
	        this.response.retryCount++;
	      } else {
	        this.response.error = null;
	      }
	    });
	
	    var addToHead = true;
	    addAsync('DISCOVER_ENDPOINT', 'sign', DISCOVER_ENDPOINT, addToHead);
	
	    addAsync('SIGN', 'sign', function SIGN(req, done) {
	      var service = req.service;
	      var operations = req.service.api.operations || {};
	      var operation = operations[req.operation];
	      var authtype = operation ? operation.authtype : '';
	      if (!service.api.signatureVersion && !authtype) return done(); // none
	
	      service.config.getCredentials(function (err, credentials) {
	        if (err) {
	          req.response.error = err;
	          return done();
	        }
	
	        try {
	          var date = service.getSkewCorrectedDate();
	          var SignerClass = service.getSignerClass(req);
	          var signer = new SignerClass(req.httpRequest,
	            service.api.signingName || service.api.endpointPrefix,
	            {
	              signatureCache: service.config.signatureCache,
	              operation: operation,
	              signatureVersion: service.api.signatureVersion
	            });
	          signer.setServiceClientId(service._clientId);
	
	          // clear old authorization headers
	          delete req.httpRequest.headers['Authorization'];
	          delete req.httpRequest.headers['Date'];
	          delete req.httpRequest.headers['X-Amz-Date'];
	
	          // add new authorization
	          signer.addAuthorization(credentials, date);
	          req.signedAt = date;
	        } catch (e) {
	          req.response.error = e;
	        }
	        done();
	      });
	    });
	
	    add('VALIDATE_RESPONSE', 'validateResponse', function VALIDATE_RESPONSE(resp) {
	      if (this.service.successfulResponse(resp, this)) {
	        resp.data = {};
	        resp.error = null;
	      } else {
	        resp.data = null;
	        resp.error = AWS.util.error(new Error(),
	          {code: 'UnknownError', message: 'An unknown error occurred.'});
	      }
	    });
	
	    addAsync('SEND', 'send', function SEND(resp, done) {
	      resp.httpResponse._abortCallback = done;
	      resp.error = null;
	      resp.data = null;
	
	      function callback(httpResp) {
	        resp.httpResponse.stream = httpResp;
	        var stream = resp.request.httpRequest.stream;
	        var service = resp.request.service;
	        var api = service.api;
	        var operationName = resp.request.operation;
	        var operation = api.operations[operationName] || {};
	
	        httpResp.on('headers', function onHeaders(statusCode, headers, statusMessage) {
	          resp.request.emit(
	            'httpHeaders',
	            [statusCode, headers, resp, statusMessage]
	          );
	
	          if (!resp.httpResponse.streaming) {
	            if (AWS.HttpClient.streamsApiVersion === 2) { // streams2 API check
	              // if we detect event streams, we're going to have to
	              // return the stream immediately
	              if (operation.hasEventOutput && service.successfulResponse(resp)) {
	                // skip reading the IncomingStream
	                resp.request.emit('httpDone');
	                done();
	                return;
	              }
	
	              httpResp.on('readable', function onReadable() {
	                var data = httpResp.read();
	                if (data !== null) {
	                  resp.request.emit('httpData', [data, resp]);
	                }
	              });
	            } else { // legacy streams API
	              httpResp.on('data', function onData(data) {
	                resp.request.emit('httpData', [data, resp]);
	              });
	            }
	          }
	        });
	
	        httpResp.on('end', function onEnd() {
	          if (!stream || !stream.didCallback) {
	            if (AWS.HttpClient.streamsApiVersion === 2 && (operation.hasEventOutput && service.successfulResponse(resp))) {
	              // don't concatenate response chunks when streaming event stream data when response is successful
	              return;
	            }
	            resp.request.emit('httpDone');
	            done();
	          }
	        });
	      }
	
	      function progress(httpResp) {
	        httpResp.on('sendProgress', function onSendProgress(value) {
	          resp.request.emit('httpUploadProgress', [value, resp]);
	        });
	
	        httpResp.on('receiveProgress', function onReceiveProgress(value) {
	          resp.request.emit('httpDownloadProgress', [value, resp]);
	        });
	      }
	
	      function error(err) {
	        if (err.code !== 'RequestAbortedError') {
	          var errCode = err.code === 'TimeoutError' ? err.code : 'NetworkingError';
	          err = AWS.util.error(err, {
	            code: errCode,
	            region: resp.request.httpRequest.region,
	            hostname: resp.request.httpRequest.endpoint.hostname,
	            retryable: true
	          });
	        }
	        resp.error = err;
	        resp.request.emit('httpError', [resp.error, resp], function() {
	          done();
	        });
	      }
	
	      function executeSend() {
	        var http = AWS.HttpClient.getInstance();
	        var httpOptions = resp.request.service.config.httpOptions || {};
	        try {
	          var stream = http.handleRequest(resp.request.httpRequest, httpOptions,
	                                          callback, error);
	          progress(stream);
	        } catch (err) {
	          error(err);
	        }
	      }
	      var timeDiff = (resp.request.service.getSkewCorrectedDate() - this.signedAt) / 1000;
	      if (timeDiff >= 60 * 10) { // if we signed 10min ago, re-sign
	        this.emit('sign', [this], function(err) {
	          if (err) done(err);
	          else executeSend();
	        });
	      } else {
	        executeSend();
	      }
	    });
	
	    add('HTTP_HEADERS', 'httpHeaders',
	        function HTTP_HEADERS(statusCode, headers, resp, statusMessage) {
	      resp.httpResponse.statusCode = statusCode;
	      resp.httpResponse.statusMessage = statusMessage;
	      resp.httpResponse.headers = headers;
	      resp.httpResponse.body = AWS.util.buffer.toBuffer('');
	      resp.httpResponse.buffers = [];
	      resp.httpResponse.numBytes = 0;
	      var dateHeader = headers.date || headers.Date;
	      var service = resp.request.service;
	      if (dateHeader) {
	        var serverTime = Date.parse(dateHeader);
	        if (service.config.correctClockSkew
	            && service.isClockSkewed(serverTime)) {
	          service.applyClockOffset(serverTime);
	        }
	      }
	    });
	
	    add('HTTP_DATA', 'httpData', function HTTP_DATA(chunk, resp) {
	      if (chunk) {
	        if (AWS.util.isNode()) {
	          resp.httpResponse.numBytes += chunk.length;
	
	          var total = resp.httpResponse.headers['content-length'];
	          var progress = { loaded: resp.httpResponse.numBytes, total: total };
	          resp.request.emit('httpDownloadProgress', [progress, resp]);
	        }
	
	        resp.httpResponse.buffers.push(AWS.util.buffer.toBuffer(chunk));
	      }
	    });
	
	    add('HTTP_DONE', 'httpDone', function HTTP_DONE(resp) {
	      // convert buffers array into single buffer
	      if (resp.httpResponse.buffers && resp.httpResponse.buffers.length > 0) {
	        var body = AWS.util.buffer.concat(resp.httpResponse.buffers);
	        resp.httpResponse.body = body;
	      }
	      delete resp.httpResponse.numBytes;
	      delete resp.httpResponse.buffers;
	    });
	
	    add('FINALIZE_ERROR', 'retry', function FINALIZE_ERROR(resp) {
	      if (resp.httpResponse.statusCode) {
	        resp.error.statusCode = resp.httpResponse.statusCode;
	        if (resp.error.retryable === undefined) {
	          resp.error.retryable = this.service.retryableError(resp.error, this);
	        }
	      }
	    });
	
	    add('INVALIDATE_CREDENTIALS', 'retry', function INVALIDATE_CREDENTIALS(resp) {
	      if (!resp.error) return;
	      switch (resp.error.code) {
	        case 'RequestExpired': // EC2 only
	        case 'ExpiredTokenException':
	        case 'ExpiredToken':
	          resp.error.retryable = true;
	          resp.request.service.config.credentials.expired = true;
	      }
	    });
	
	    add('EXPIRED_SIGNATURE', 'retry', function EXPIRED_SIGNATURE(resp) {
	      var err = resp.error;
	      if (!err) return;
	      if (typeof err.code === 'string' && typeof err.message === 'string') {
	        if (err.code.match(/Signature/) && err.message.match(/expired/)) {
	          resp.error.retryable = true;
	        }
	      }
	    });
	
	    add('CLOCK_SKEWED', 'retry', function CLOCK_SKEWED(resp) {
	      if (!resp.error) return;
	      if (this.service.clockSkewError(resp.error)
	          && this.service.config.correctClockSkew) {
	        resp.error.retryable = true;
	      }
	    });
	
	    add('REDIRECT', 'retry', function REDIRECT(resp) {
	      if (resp.error && resp.error.statusCode >= 300 &&
	          resp.error.statusCode < 400 && resp.httpResponse.headers['location']) {
	        this.httpRequest.endpoint =
	          new AWS.Endpoint(resp.httpResponse.headers['location']);
	        this.httpRequest.headers['Host'] = this.httpRequest.endpoint.host;
	        resp.error.redirect = true;
	        resp.error.retryable = true;
	      }
	    });
	
	    add('RETRY_CHECK', 'retry', function RETRY_CHECK(resp) {
	      if (resp.error) {
	        if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.error.retryDelay = 0;
	        } else if (resp.retryCount < resp.maxRetries) {
	          resp.error.retryDelay = this.service.retryDelays(resp.retryCount) || 0;
	        }
	      }
	    });
	
	    addAsync('RESET_RETRY_STATE', 'afterRetry', function RESET_RETRY_STATE(resp, done) {
	      var delay, willRetry = false;
	
	      if (resp.error) {
	        delay = resp.error.retryDelay || 0;
	        if (resp.error.retryable && resp.retryCount < resp.maxRetries) {
	          resp.retryCount++;
	          willRetry = true;
	        } else if (resp.error.redirect && resp.redirectCount < resp.maxRedirects) {
	          resp.redirectCount++;
	          willRetry = true;
	        }
	      }
	
	      if (willRetry) {
	        resp.error = null;
	        setTimeout(done, delay);
	      } else {
	        done();
	      }
	    });
	  }),
	
	  CorePost: new SequentialExecutor().addNamedListeners(function(add) {
	    add('EXTRACT_REQUEST_ID', 'extractData', AWS.util.extractRequestId);
	    add('EXTRACT_REQUEST_ID', 'extractError', AWS.util.extractRequestId);
	
	    add('ENOTFOUND_ERROR', 'httpError', function ENOTFOUND_ERROR(err) {
	      if (err.code === 'NetworkingError' && err.errno === 'ENOTFOUND') {
	        var message = 'Inaccessible host: `' + err.hostname +
	          '\'. This service may not be available in the `' + err.region +
	          '\' region.';
	        this.response.error = AWS.util.error(new Error(message), {
	          code: 'UnknownEndpoint',
	          region: err.region,
	          hostname: err.hostname,
	          retryable: true,
	          originalError: err
	        });
	      }
	    });
	  }),
	
	  Logger: new SequentialExecutor().addNamedListeners(function(add) {
	    add('LOG_REQUEST', 'complete', function LOG_REQUEST(resp) {
	      var req = resp.request;
	      var logger = req.service.config.logger;
	      if (!logger) return;
	      function filterSensitiveLog(inputShape, shape) {
	        if (!shape) {
	          return shape;
	        }
	        switch (inputShape.type) {
	          case 'structure':
	            var struct = {};
	            AWS.util.each(shape, function(subShapeName, subShape) {
	              if (Object.prototype.hasOwnProperty.call(inputShape.members, subShapeName)) {
	                struct[subShapeName] = filterSensitiveLog(inputShape.members[subShapeName], subShape);
	              } else {
	                struct[subShapeName] = subShape;
	              }
	            });
	            return struct;
	          case 'list':
	            var list = [];
	            AWS.util.arrayEach(shape, function(subShape, index) {
	              list.push(filterSensitiveLog(inputShape.member, subShape));
	            });
	            return list;
	          case 'map':
	            var map = {};
	            AWS.util.each(shape, function(key, value) {
	              map[key] = filterSensitiveLog(inputShape.value, value);
	            });
	            return map;
	          default:
	            if (inputShape.isSensitive) {
	              return '***SensitiveInformation***';
	            } else {
	              return shape;
	            }
	        }
	      }
	
	      function buildMessage() {
	        var time = resp.request.service.getSkewCorrectedDate().getTime();
	        var delta = (time - req.startTime.getTime()) / 1000;
	        var ansi = logger.isTTY ? true : false;
	        var status = resp.httpResponse.statusCode;
	        var censoredParams = req.params;
	        if (
	          req.service.api.operations &&
	              req.service.api.operations[req.operation] &&
	              req.service.api.operations[req.operation].input
	        ) {
	          var inputShape = req.service.api.operations[req.operation].input;
	          censoredParams = filterSensitiveLog(inputShape, req.params);
	        }
	        var params = __webpack_require__(860).inspect(censoredParams, true, null);
	        var message = '';
	        if (ansi) message += '\x1B[33m';
	        message += '[AWS ' + req.service.serviceIdentifier + ' ' + status;
	        message += ' ' + delta.toString() + 's ' + resp.retryCount + ' retries]';
	        if (ansi) message += '\x1B[0;1m';
	        message += ' ' + AWS.util.string.lowerFirst(req.operation);
	        message += '(' + params + ')';
	        if (ansi) message += '\x1B[0m';
	        return message;
	      }
	
	      var line = buildMessage();
	      if (typeof logger.log === 'function') {
	        logger.log(line);
	      } else if (typeof logger.write === 'function') {
	        logger.write(line + '\n');
	      }
	    });
	  }),
	
	  Json: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(277);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Rest: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(191);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestJson: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(433);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  RestXml: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(434);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  }),
	
	  Query: new SequentialExecutor().addNamedListeners(function(add) {
	    var svc = __webpack_require__(432);
	    add('BUILD', 'build', svc.buildRequest);
	    add('EXTRACT_DATA', 'extractData', svc.extractData);
	    add('EXTRACT_ERROR', 'extractError', svc.extractError);
	  })
	};


/***/ },
/* 1018 */
[2519, 4, 426],
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	/**
	 * @api private
	 */
	AWS.ParamValidator = AWS.util.inherit({
	  /**
	   * Create a new validator object.
	   *
	   * @param validation [Boolean|map] whether input parameters should be
	   *     validated against the operation description before sending the
	   *     request. Pass a map to enable any of the following specific
	   *     validation features:
	   *
	   *     * **min** [Boolean] &mdash; Validates that a value meets the min
	   *       constraint. This is enabled by default when paramValidation is set
	   *       to `true`.
	   *     * **max** [Boolean] &mdash; Validates that a value meets the max
	   *       constraint.
	   *     * **pattern** [Boolean] &mdash; Validates that a string value matches a
	   *       regular expression.
	   *     * **enum** [Boolean] &mdash; Validates that a string value matches one
	   *       of the allowable enum values.
	   */
	  constructor: function ParamValidator(validation) {
	    if (validation === true || validation === undefined) {
	      validation = {'min': true};
	    }
	    this.validation = validation;
	  },
	
	  validate: function validate(shape, params, context) {
	    this.errors = [];
	    this.validateMember(shape, params || {}, context || 'params');
	
	    if (this.errors.length > 1) {
	      var msg = this.errors.join('\n* ');
	      msg = 'There were ' + this.errors.length +
	        ' validation errors:\n* ' + msg;
	      throw AWS.util.error(new Error(msg),
	        {code: 'MultipleValidationErrors', errors: this.errors});
	    } else if (this.errors.length === 1) {
	      throw this.errors[0];
	    } else {
	      return true;
	    }
	  },
	
	  fail: function fail(code, message) {
	    this.errors.push(AWS.util.error(new Error(message), {code: code}));
	  },
	
	  validateStructure: function validateStructure(shape, params, context) {
	    this.validateType(params, context, ['object'], 'structure');
	
	    var paramName;
	    for (var i = 0; shape.required && i < shape.required.length; i++) {
	      paramName = shape.required[i];
	      var value = params[paramName];
	      if (value === undefined || value === null) {
	        this.fail('MissingRequiredParameter',
	          'Missing required key \'' + paramName + '\' in ' + context);
	      }
	    }
	
	    // validate hash members
	    for (paramName in params) {
	      if (!Object.prototype.hasOwnProperty.call(params, paramName)) continue;
	
	      var paramValue = params[paramName],
	          memberShape = shape.members[paramName];
	
	      if (memberShape !== undefined) {
	        var memberContext = [context, paramName].join('.');
	        this.validateMember(memberShape, paramValue, memberContext);
	      } else {
	        this.fail('UnexpectedParameter',
	          'Unexpected key \'' + paramName + '\' found in ' + context);
	      }
	    }
	
	    return true;
	  },
	
	  validateMember: function validateMember(shape, param, context) {
	    switch (shape.type) {
	      case 'structure':
	        return this.validateStructure(shape, param, context);
	      case 'list':
	        return this.validateList(shape, param, context);
	      case 'map':
	        return this.validateMap(shape, param, context);
	      default:
	        return this.validateScalar(shape, param, context);
	    }
	  },
	
	  validateList: function validateList(shape, params, context) {
	    if (this.validateType(params, context, [Array])) {
	      this.validateRange(shape, params.length, context, 'list member count');
	      // validate array members
	      for (var i = 0; i < params.length; i++) {
	        this.validateMember(shape.member, params[i], context + '[' + i + ']');
	      }
	    }
	  },
	
	  validateMap: function validateMap(shape, params, context) {
	    if (this.validateType(params, context, ['object'], 'map')) {
	      // Build up a count of map members to validate range traits.
	      var mapCount = 0;
	      for (var param in params) {
	        if (!Object.prototype.hasOwnProperty.call(params, param)) continue;
	        // Validate any map key trait constraints
	        this.validateMember(shape.key, param,
	                            context + '[key=\'' + param + '\']');
	        this.validateMember(shape.value, params[param],
	                            context + '[\'' + param + '\']');
	        mapCount++;
	      }
	      this.validateRange(shape, mapCount, context, 'map member count');
	    }
	  },
	
	  validateScalar: function validateScalar(shape, value, context) {
	    switch (shape.type) {
	      case null:
	      case undefined:
	      case 'string':
	        return this.validateString(shape, value, context);
	      case 'base64':
	      case 'binary':
	        return this.validatePayload(value, context);
	      case 'integer':
	      case 'float':
	        return this.validateNumber(shape, value, context);
	      case 'boolean':
	        return this.validateType(value, context, ['boolean']);
	      case 'timestamp':
	        return this.validateType(value, context, [Date,
	          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, 'number'],
	          'Date object, ISO-8601 string, or a UNIX timestamp');
	      default:
	        return this.fail('UnkownType', 'Unhandled type ' +
	                         shape.type + ' for ' + context);
	    }
	  },
	
	  validateString: function validateString(shape, value, context) {
	    var validTypes = ['string'];
	    if (shape.isJsonValue) {
	      validTypes = validTypes.concat(['number', 'object', 'boolean']);
	    }
	    if (value !== null && this.validateType(value, context, validTypes)) {
	      this.validateEnum(shape, value, context);
	      this.validateRange(shape, value.length, context, 'string length');
	      this.validatePattern(shape, value, context);
	      this.validateUri(shape, value, context);
	    }
	  },
	
	  validateUri: function validateUri(shape, value, context) {
	    if (shape['location'] === 'uri') {
	      if (value.length === 0) {
	        this.fail('UriParameterError', 'Expected uri parameter to have length >= 1,'
	          + ' but found "' + value +'" for ' + context);
	      }
	    }
	  },
	
	  validatePattern: function validatePattern(shape, value, context) {
	    if (this.validation['pattern'] && shape['pattern'] !== undefined) {
	      if (!(new RegExp(shape['pattern'])).test(value)) {
	        this.fail('PatternMatchError', 'Provided value "' + value + '" '
	          + 'does not match regex pattern /' + shape['pattern'] + '/ for '
	          + context);
	      }
	    }
	  },
	
	  validateRange: function validateRange(shape, value, context, descriptor) {
	    if (this.validation['min']) {
	      if (shape['min'] !== undefined && value < shape['min']) {
	        this.fail('MinRangeError', 'Expected ' + descriptor + ' >= '
	          + shape['min'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	    if (this.validation['max']) {
	      if (shape['max'] !== undefined && value > shape['max']) {
	        this.fail('MaxRangeError', 'Expected ' + descriptor + ' <= '
	          + shape['max'] + ', but found ' + value + ' for ' + context);
	      }
	    }
	  },
	
	  validateEnum: function validateRange(shape, value, context) {
	    if (this.validation['enum'] && shape['enum'] !== undefined) {
	      // Fail if the string value is not present in the enum list
	      if (shape['enum'].indexOf(value) === -1) {
	        this.fail('EnumError', 'Found string value of ' + value + ', but '
	          + 'expected ' + shape['enum'].join('|') + ' for ' + context);
	      }
	    }
	  },
	
	  validateType: function validateType(value, context, acceptedTypes, type) {
	    // We will not log an error for null or undefined, but we will return
	    // false so that callers know that the expected type was not strictly met.
	    if (value === null || value === undefined) return false;
	
	    var foundInvalidType = false;
	    for (var i = 0; i < acceptedTypes.length; i++) {
	      if (typeof acceptedTypes[i] === 'string') {
	        if (typeof value === acceptedTypes[i]) return true;
	      } else if (acceptedTypes[i] instanceof RegExp) {
	        if ((value || '').toString().match(acceptedTypes[i])) return true;
	      } else {
	        if (value instanceof acceptedTypes[i]) return true;
	        if (AWS.util.isType(value, acceptedTypes[i])) return true;
	        if (!type && !foundInvalidType) acceptedTypes = acceptedTypes.slice();
	        acceptedTypes[i] = AWS.util.typeName(acceptedTypes[i]);
	      }
	      foundInvalidType = true;
	    }
	
	    var acceptedType = type;
	    if (!acceptedType) {
	      acceptedType = acceptedTypes.join(', ').replace(/,([^,]+)$/, ', or$1');
	    }
	
	    var vowel = acceptedType.match(/^[aeiou]/i) ? 'n' : '';
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a' +
	              vowel + ' ' + acceptedType);
	    return false;
	  },
	
	  validateNumber: function validateNumber(shape, value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') {
	      var castedValue = parseFloat(value);
	      if (castedValue.toString() === value) value = castedValue;
	    }
	    if (this.validateType(value, context, ['number'])) {
	      this.validateRange(shape, value, context, 'numeric value');
	    }
	  },
	
	  validatePayload: function validatePayload(value, context) {
	    if (value === null || value === undefined) return;
	    if (typeof value === 'string') return;
	    if (value && typeof value.byteLength === 'number') return; // typed arrays
	    if (AWS.util.isNode()) { // special check for buffer/stream in Node.js
	      var Stream = AWS.util.stream.Stream;
	      if (AWS.util.Buffer.isBuffer(value) || value instanceof Stream) return;
	    } else {
	      if (typeof Blob !== void 0 && value instanceof Blob) return;
	    }
	
	    var types = ['Buffer', 'Stream', 'File', 'Blob', 'ArrayBuffer', 'DataView'];
	    if (value) {
	      for (var i = 0; i < types.length; i++) {
	        if (AWS.util.isType(value, types[i])) return;
	        if (AWS.util.typeName(value.constructor) === types[i]) return;
	      }
	    }
	
	    this.fail('InvalidParameterType', 'Expected ' + context + ' to be a ' +
	      'string, Buffer, Stream, Blob, or typed array object');
	  }
	});


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var rest = AWS.Protocol.Rest;
	
	/**
	 * A presigner object can be used to generate presigned urls for the Polly service.
	 */
	AWS.Polly.Presigner = AWS.util.inherit({
	    /**
	     * Creates a presigner object with a set of configuration options.
	     *
	     * @option options params [map] An optional map of parameters to bind to every
	     *   request sent by this service object.
	     * @option options service [AWS.Polly] An optional pre-configured instance
	     *  of the AWS.Polly service object to use for requests. The object may
	     *  bound parameters used by the presigner.
	     * @see AWS.Polly.constructor
	     */
	    constructor: function Signer(options) {
	        options = options || {};
	        this.options = options;
	        this.service = options.service;
	        this.bindServiceObject(options);
	        this._operations = {};
	    },
	
	    /**
	     * @api private
	     */
	    bindServiceObject: function bindServiceObject(options) {
	        options = options || {};
	        if (!this.service) {
	            this.service = new AWS.Polly(options);
	        } else {
	            var config = AWS.util.copy(this.service.config);
	            this.service = new this.service.constructor.__super__(config);
	            this.service.config.params = AWS.util.merge(this.service.config.params || {}, options.params);
	        }
	    },
	
	    /**
	     * @api private
	     */
	    modifyInputMembers: function modifyInputMembers(input) {
	        // make copies of the input so we don't overwrite the api
	        // need to be careful to copy anything we access/modify
	        var modifiedInput = AWS.util.copy(input);
	        modifiedInput.members = AWS.util.copy(input.members);
	        AWS.util.each(input.members, function(name, member) {
	            modifiedInput.members[name] = AWS.util.copy(member);
	            // update location and locationName
	            if (!member.location || member.location === 'body') {
	                modifiedInput.members[name].location = 'querystring';
	                modifiedInput.members[name].locationName = name;
	            }
	        });
	        return modifiedInput;
	    },
	
	    /**
	     * @api private
	     */
	    convertPostToGet: function convertPostToGet(req) {
	        // convert method
	        req.httpRequest.method = 'GET';
	
	        var operation = req.service.api.operations[req.operation];
	        // get cached operation input first
	        var input = this._operations[req.operation];
	        if (!input) {
	            // modify the original input
	            this._operations[req.operation] = input = this.modifyInputMembers(operation.input);
	        }
	
	        var uri = rest.generateURI(req.httpRequest.endpoint.path, operation.httpPath, input, req.params);
	
	        req.httpRequest.path = uri;
	        req.httpRequest.body = '';
	
	        // don't need these headers on a GET request
	        delete req.httpRequest.headers['Content-Length'];
	        delete req.httpRequest.headers['Content-Type'];
	    },
	
	    /**
	     * @overload getSynthesizeSpeechUrl(params = {}, [expires = 3600], [callback])
	     *   Generate a presigned url for {AWS.Polly.synthesizeSpeech}.
	     *   @note You must ensure that you have static or previously resolved
	     *     credentials if you call this method synchronously (with no callback),
	     *     otherwise it may not properly sign the request. If you cannot guarantee
	     *     this (you are using an asynchronous credential provider, i.e., EC2
	     *     IAM roles), you should always call this method with an asynchronous
	     *     callback.
	     *   @param params [map] parameters to pass to the operation. See the {AWS.Polly.synthesizeSpeech}
	     *     operation for the expected operation parameters.
	     *   @param expires [Integer] (3600) the number of seconds to expire the pre-signed URL operation in.
	     *     Defaults to 1 hour.
	     *   @return [string] if called synchronously (with no callback), returns the signed URL.
	     *   @return [null] nothing is returned if a callback is provided.
	     *   @callback callback function (err, url)
	     *     If a callback is supplied, it is called when a signed URL has been generated.
	     *     @param err [Error] the error object returned from the presigner.
	     *     @param url [String] the signed URL.
	     *   @see AWS.Polly.synthesizeSpeech
	     */
	    getSynthesizeSpeechUrl: function getSynthesizeSpeechUrl(params, expires, callback) {
	        var self = this;
	        var request = this.service.makeRequest('synthesizeSpeech', params);
	        // remove existing build listeners
	        request.removeAllListeners('build');
	        request.on('build', function(req) {
	            self.convertPostToGet(req);
	        });
	        return request.presign(expires, callback);
	    }
	});


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	
	function QueryParamSerializer() {
	}
	
	QueryParamSerializer.prototype.serialize = function(params, shape, fn) {
	  serializeStructure('', params, shape, fn);
	};
	
	function ucfirst(shape) {
	  if (shape.isQueryName || shape.api.protocol !== 'ec2') {
	    return shape.name;
	  } else {
	    return shape.name[0].toUpperCase() + shape.name.substr(1);
	  }
	}
	
	function serializeStructure(prefix, struct, rules, fn) {
	  util.each(rules.members, function(name, member) {
	    var value = struct[name];
	    if (value === null || value === undefined) return;
	
	    var memberName = ucfirst(member);
	    memberName = prefix ? prefix + '.' + memberName : memberName;
	    serializeMember(memberName, value, member, fn);
	  });
	}
	
	function serializeMap(name, map, rules, fn) {
	  var i = 1;
	  util.each(map, function (key, value) {
	    var prefix = rules.flattened ? '.' : '.entry.';
	    var position = prefix + (i++) + '.';
	    var keyName = position + (rules.key.name || 'key');
	    var valueName = position + (rules.value.name || 'value');
	    serializeMember(name + keyName, key, rules.key, fn);
	    serializeMember(name + valueName, value, rules.value, fn);
	  });
	}
	
	function serializeList(name, list, rules, fn) {
	  var memberRules = rules.member || {};
	
	  if (list.length === 0) {
	    fn.call(this, name, null);
	    return;
	  }
	
	  util.arrayEach(list, function (v, n) {
	    var suffix = '.' + (n + 1);
	    if (rules.api.protocol === 'ec2') {
	      // Do nothing for EC2
	      suffix = suffix + ''; // make linter happy
	    } else if (rules.flattened) {
	      if (memberRules.name) {
	        var parts = name.split('.');
	        parts.pop();
	        parts.push(ucfirst(memberRules));
	        name = parts.join('.');
	      }
	    } else {
	      suffix = '.' + (memberRules.name ? memberRules.name : 'member') + suffix;
	    }
	    serializeMember(name + suffix, v, memberRules, fn);
	  });
	}
	
	function serializeMember(name, value, rules, fn) {
	  if (value === null || value === undefined) return;
	  if (rules.type === 'structure') {
	    serializeStructure(name, value, rules, fn);
	  } else if (rules.type === 'list') {
	    serializeList(name, value, rules, fn);
	  } else if (rules.type === 'map') {
	    serializeMap(name, value, rules, fn);
	  } else {
	    fn(name, rules.toWireFormat(value).toString());
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = QueryParamSerializer;


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	/**
	 * @api private
	 */
	var service = null;
	
	/**
	 * @api private
	 */
	var api = {
	    signatureVersion: 'v4',
	    signingName: 'rds-db'
	};
	
	/**
	 * @api private
	 */
	var requiredAuthTokenOptions = {
	    region: 'string',
	    hostname: 'string',
	    port: 'number',
	    username: 'string'
	};
	
	/**
	 * A signer object can be used to generate an auth token to a database.
	 */
	AWS.RDS.Signer = AWS.util.inherit({
	    /**
	     * Creates a signer object can be used to generate an auth token.
	     *
	     * @option options credentials [AWS.Credentials] the AWS credentials
	     *   to sign requests with. Uses the default credential provider chain
	     *   if not specified.
	     * @option options hostname [String] the hostname of the database to connect to.
	     * @option options port [Number] the port number the database is listening on.
	     * @option options region [String] the region the database is located in.
	     * @option options username [String] the username to login as.
	     * @example Passing in options to constructor
	     *   var signer = new AWS.RDS.Signer({
	     *     credentials: new AWS.SharedIniFileCredentials({profile: 'default'}),
	     *     region: 'us-east-1',
	     *     hostname: 'db.us-east-1.rds.amazonaws.com',
	     *     port: 8000,
	     *     username: 'name'
	     *   });
	     */
	    constructor: function Signer(options) {
	        this.options = options || {};
	    },
	
	    /**
	     * @api private
	     * Strips the protocol from a url.
	     */
	    convertUrlToAuthToken: function convertUrlToAuthToken(url) {
	        // we are always using https as the protocol
	        var protocol = 'https://';
	        if (url.indexOf(protocol) === 0) {
	            return url.substring(protocol.length);
	        }
	    },
	
	    /**
	     * @overload getAuthToken(options = {}, [callback])
	     *   Generate an auth token to a database.
	     *   @note You must ensure that you have static or previously resolved
	     *     credentials if you call this method synchronously (with no callback),
	     *     otherwise it may not properly sign the request. If you cannot guarantee
	     *     this (you are using an asynchronous credential provider, i.e., EC2
	     *     IAM roles), you should always call this method with an asynchronous
	     *     callback.
	     *
	     *   @param options [map] The fields to use when generating an auth token.
	     *     Any options specified here will be merged on top of any options passed
	     *     to AWS.RDS.Signer:
	     *
	     *     * **credentials** (AWS.Credentials) &mdash; the AWS credentials
	     *         to sign requests with. Uses the default credential provider chain
	     *         if not specified.
	     *     * **hostname** (String) &mdash; the hostname of the database to connect to.
	     *     * **port** (Number) &mdash; the port number the database is listening on.
	     *     * **region** (String) &mdash; the region the database is located in.
	     *     * **username** (String) &mdash; the username to login as.
	     *   @return [String] if called synchronously (with no callback), returns the
	     *     auth token.
	     *   @return [null] nothing is returned if a callback is provided.
	     *   @callback callback function (err, token)
	     *     If a callback is supplied, it is called when an auth token has been generated.
	     *     @param err [Error] the error object returned from the signer.
	     *     @param token [String] the auth token.
	     *
	     *   @example Generating an auth token synchronously
	     *     var signer = new AWS.RDS.Signer({
	     *       // configure options
	     *       region: 'us-east-1',
	     *       username: 'default',
	     *       hostname: 'db.us-east-1.amazonaws.com',
	     *       port: 8000
	     *     });
	     *     var token = signer.getAuthToken({
	     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
	     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
	     *       username: 'test' // overriding username
	     *     });
	     *   @example Generating an auth token asynchronously
	     *     var signer = new AWS.RDS.Signer({
	     *       // configure options
	     *       region: 'us-east-1',
	     *       username: 'default',
	     *       hostname: 'db.us-east-1.amazonaws.com',
	     *       port: 8000
	     *     });
	     *     signer.getAuthToken({
	     *       // these options are merged with those defined when creating the signer, overriding in the case of a duplicate option
	     *       // credentials are not specified here or when creating the signer, so default credential provider will be used
	     *       username: 'test' // overriding username
	     *     }, function(err, token) {
	     *       if (err) {
	     *         // handle error
	     *       } else {
	     *         // use token
	     *       }
	     *     });
	     *
	     */
	    getAuthToken: function getAuthToken(options, callback) {
	        if (typeof options === 'function' && callback === undefined) {
	            callback = options;
	            options = {};
	        }
	        var self = this;
	        var hasCallback = typeof callback === 'function';
	        // merge options with existing options
	        options = AWS.util.merge(this.options, options);
	        // validate options
	        var optionsValidation = this.validateAuthTokenOptions(options);
	        if (optionsValidation !== true) {
	            if (hasCallback) {
	                return callback(optionsValidation, null);
	            }
	            throw optionsValidation;
	        }
	
	        // 15 minutes
	        var expires = 900;
	        // create service to generate a request from
	        var serviceOptions = {
	            region: options.region,
	            endpoint: new AWS.Endpoint(options.hostname + ':' + options.port),
	            paramValidation: false,
	            signatureVersion: 'v4'
	        };
	        if (options.credentials) {
	            serviceOptions.credentials = options.credentials;
	        }
	        service = new AWS.Service(serviceOptions);
	        // ensure the SDK is using sigv4 signing (config is not enough)
	        service.api = api;
	
	        var request = service.makeRequest();
	        // add listeners to request to properly build auth token
	        this.modifyRequestForAuthToken(request, options);
	
	        if (hasCallback) {
	            request.presign(expires, function(err, url) {
	                if (url) {
	                    url = self.convertUrlToAuthToken(url);
	                }
	                callback(err, url);
	            });
	        } else {
	            var url = request.presign(expires);
	            return this.convertUrlToAuthToken(url);
	        }
	    },
	
	    /**
	     * @api private
	     * Modifies a request to allow the presigner to generate an auth token.
	     */
	    modifyRequestForAuthToken: function modifyRequestForAuthToken(request, options) {
	        request.on('build', request.buildAsGet);
	        var httpRequest = request.httpRequest;
	        httpRequest.body = AWS.util.queryParamsToString({
	            Action: 'connect',
	            DBUser: options.username
	        });
	    },
	
	    /**
	     * @api private
	     * Validates that the options passed in contain all the keys with values of the correct type that
	     *   are needed to generate an auth token.
	     */
	    validateAuthTokenOptions: function validateAuthTokenOptions(options) {
	        // iterate over all keys in options
	        var message = '';
	        options = options || {};
	        for (var key in requiredAuthTokenOptions) {
	            if (!Object.prototype.hasOwnProperty.call(requiredAuthTokenOptions, key)) {
	                continue;
	            }
	            if (typeof options[key] !== requiredAuthTokenOptions[key]) {
	                message += 'option \'' + key + '\' should have been type \'' + requiredAuthTokenOptions[key] + '\', was \'' + typeof options[key] + '\'.\n';
	            }
	        }
	        if (message.length) {
	            return AWS.util.error(new Error(), {
	                code: 'InvalidParameter',
	                message: message
	            });
	        }
	        return true;
	    }
	});


/***/ },
/* 1023 */
/***/ function(module, exports) {

	module.exports = {
	  //provide realtime clock for performance measurement
	  now: function now() {
	    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
	      return performance.now();
	    }
	    return Date.now();
	  }
	};


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	var regionConfig = __webpack_require__(1858);
	
	function generateRegionPrefix(region) {
	  if (!region) return null;
	
	  var parts = region.split('-');
	  if (parts.length < 3) return null;
	  return parts.slice(0, parts.length - 2).join('-') + '-*';
	}
	
	function derivedKeys(service) {
	  var region = service.config.region;
	  var regionPrefix = generateRegionPrefix(region);
	  var endpointPrefix = service.api.endpointPrefix;
	
	  return [
	    [region, endpointPrefix],
	    [regionPrefix, endpointPrefix],
	    [region, '*'],
	    [regionPrefix, '*'],
	    ['*', endpointPrefix],
	    ['*', '*']
	  ].map(function(item) {
	    return item[0] && item[1] ? item.join('/') : null;
	  });
	}
	
	function applyConfig(service, config) {
	  util.each(config, function(key, value) {
	    if (key === 'globalEndpoint') return;
	    if (service.config[key] === undefined || service.config[key] === null) {
	      service.config[key] = value;
	    }
	  });
	}
	
	function configureEndpoint(service) {
	  var keys = derivedKeys(service);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!key) continue;
	
	    if (Object.prototype.hasOwnProperty.call(regionConfig.rules, key)) {
	      var config = regionConfig.rules[key];
	      if (typeof config === 'string') {
	        config = regionConfig.patterns[config];
	      }
	
	      // set dualstack endpoint
	      if (service.config.useDualstack && util.isDualstackAvailable(service)) {
	        config = util.copy(config);
	        config.endpoint = '{service}.dualstack.{region}.amazonaws.com';
	      }
	
	      // set global endpoint
	      service.isGlobalEndpoint = !!config.globalEndpoint;
	
	      // signature version
	      if (!config.signatureVersion) config.signatureVersion = 'v4';
	
	      // merge config
	      applyConfig(service, config);
	      return;
	    }
	  }
	}
	
	/**
	 * @api private
	 */
	module.exports = configureEndpoint;


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(4);
	var AcceptorStateMachine = __webpack_require__(1050);
	var inherit = AWS.util.inherit;
	var domain = AWS.util.domain;
	var jmespath = __webpack_require__(139);
	
	/**
	 * @api private
	 */
	var hardErrorStates = {success: 1, error: 1, complete: 1};
	
	function isTerminalState(machine) {
	  return Object.prototype.hasOwnProperty.call(hardErrorStates, machine._asm.currentState);
	}
	
	var fsm = new AcceptorStateMachine();
	fsm.setupStates = function() {
	  var transition = function(_, done) {
	    var self = this;
	    self._haltHandlersOnError = false;
	
	    self.emit(self._asm.currentState, function(err) {
	      if (err) {
	        if (isTerminalState(self)) {
	          if (domain && self.domain instanceof domain.Domain) {
	            err.domainEmitter = self;
	            err.domain = self.domain;
	            err.domainThrown = false;
	            self.domain.emit('error', err);
	          } else {
	            throw err;
	          }
	        } else {
	          self.response.error = err;
	          done(err);
	        }
	      } else {
	        done(self.response.error);
	      }
	    });
	
	  };
	
	  this.addState('validate', 'build', 'error', transition);
	  this.addState('build', 'afterBuild', 'restart', transition);
	  this.addState('afterBuild', 'sign', 'restart', transition);
	  this.addState('sign', 'send', 'retry', transition);
	  this.addState('retry', 'afterRetry', 'afterRetry', transition);
	  this.addState('afterRetry', 'sign', 'error', transition);
	  this.addState('send', 'validateResponse', 'retry', transition);
	  this.addState('validateResponse', 'extractData', 'extractError', transition);
	  this.addState('extractError', 'extractData', 'retry', transition);
	  this.addState('extractData', 'success', 'retry', transition);
	  this.addState('restart', 'build', 'error', transition);
	  this.addState('success', 'complete', 'complete', transition);
	  this.addState('error', 'complete', 'complete', transition);
	  this.addState('complete', null, null, transition);
	};
	fsm.setupStates();
	
	/**
	 * ## Asynchronous Requests
	 *
	 * All requests made through the SDK are asynchronous and use a
	 * callback interface. Each service method that kicks off a request
	 * returns an `AWS.Request` object that you can use to register
	 * callbacks.
	 *
	 * For example, the following service method returns the request
	 * object as "request", which can be used to register callbacks:
	 *
	 * ```javascript
	 * // request is an AWS.Request object
	 * var request = ec2.describeInstances();
	 *
	 * // register callbacks on request to retrieve response data
	 * request.on('success', function(response) {
	 *   console.log(response.data);
	 * });
	 * ```
	 *
	 * When a request is ready to be sent, the {send} method should
	 * be called:
	 *
	 * ```javascript
	 * request.send();
	 * ```
	 *
	 * Since registered callbacks may or may not be idempotent, requests should only
	 * be sent once. To perform the same operation multiple times, you will need to
	 * create multiple request objects, each with its own registered callbacks.
	 *
	 * ## Removing Default Listeners for Events
	 *
	 * Request objects are built with default listeners for the various events,
	 * depending on the service type. In some cases, you may want to remove
	 * some built-in listeners to customize behaviour. Doing this requires
	 * access to the built-in listener functions, which are exposed through
	 * the {AWS.EventListeners.Core} namespace. For instance, you may
	 * want to customize the HTTP handler used when sending a request. In this
	 * case, you can remove the built-in listener associated with the 'send'
	 * event, the {AWS.EventListeners.Core.SEND} listener and add your own.
	 *
	 * ## Multiple Callbacks and Chaining
	 *
	 * You can register multiple callbacks on any request object. The
	 * callbacks can be registered for different events, or all for the
	 * same event. In addition, you can chain callback registration, for
	 * example:
	 *
	 * ```javascript
	 * request.
	 *   on('success', function(response) {
	 *     console.log("Success!");
	 *   }).
	 *   on('error', function(error, response) {
	 *     console.log("Error!");
	 *   }).
	 *   on('complete', function(response) {
	 *     console.log("Always!");
	 *   }).
	 *   send();
	 * ```
	 *
	 * The above example will print either "Success! Always!", or "Error! Always!",
	 * depending on whether the request succeeded or not.
	 *
	 * @!attribute httpRequest
	 *   @readonly
	 *   @!group HTTP Properties
	 *   @return [AWS.HttpRequest] the raw HTTP request object
	 *     containing request headers and body information
	 *     sent by the service.
	 *
	 * @!attribute startTime
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Date] the time that the request started
	 *
	 * @!group Request Building Events
	 *
	 * @!event validate(request)
	 *   Triggered when a request is being validated. Listeners
	 *   should throw an error if the request should not be sent.
	 *   @param request [Request] the request object being sent
	 *   @see AWS.EventListeners.Core.VALIDATE_CREDENTIALS
	 *   @see AWS.EventListeners.Core.VALIDATE_REGION
	 *   @example Ensuring that a certain parameter is set before sending a request
	 *     var req = s3.putObject(params);
	 *     req.on('validate', function() {
	 *       if (!req.params.Body.match(/^Hello\s/)) {
	 *         throw new Error('Body must start with "Hello "');
	 *       }
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event build(request)
	 *   Triggered when the request payload is being built. Listeners
	 *   should fill the necessary information to send the request
	 *   over HTTP.
	 *   @param (see AWS.Request~validate)
	 *   @example Add a custom HTTP header to a request
	 *     var req = s3.putObject(params);
	 *     req.on('build', function() {
	 *       req.httpRequest.headers['Custom-Header'] = 'value';
	 *     });
	 *     req.send(function(err, data) { ... });
	 *
	 * @!event sign(request)
	 *   Triggered when the request is being signed. Listeners should
	 *   add the correct authentication headers and/or adjust the body,
	 *   depending on the authentication mechanism being used.
	 *   @param (see AWS.Request~validate)
	 *
	 * @!group Request Sending Events
	 *
	 * @!event send(response)
	 *   Triggered when the request is ready to be sent. Listeners
	 *   should call the underlying transport layer to initiate
	 *   the sending of the request.
	 *   @param response [Response] the response object
	 *   @context [Request] the request object that was sent
	 *   @see AWS.EventListeners.Core.SEND
	 *
	 * @!event retry(response)
	 *   Triggered when a request failed and might need to be retried or redirected.
	 *   If the response is retryable, the listener should set the
	 *   `response.error.retryable` property to `true`, and optionally set
	 *   `response.error.retryDelay` to the millisecond delay for the next attempt.
	 *   In the case of a redirect, `response.error.redirect` should be set to
	 *   `true` with `retryDelay` set to an optional delay on the next request.
	 *
	 *   If a listener decides that a request should not be retried,
	 *   it should set both `retryable` and `redirect` to false.
	 *
	 *   Note that a retryable error will be retried at most
	 *   {AWS.Config.maxRetries} times (based on the service object's config).
	 *   Similarly, a request that is redirected will only redirect at most
	 *   {AWS.Config.maxRedirects} times.
	 *
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @example Adding a custom retry for a 404 response
	 *     request.on('retry', function(response) {
	 *       // this resource is not yet available, wait 10 seconds to get it again
	 *       if (response.httpResponse.statusCode === 404 && response.error) {
	 *         response.error.retryable = true;   // retry this error
	 *         response.error.retryDelay = 10000; // wait 10 seconds
	 *       }
	 *     });
	 *
	 * @!group Data Parsing Events
	 *
	 * @!event extractError(response)
	 *   Triggered on all non-2xx requests so that listeners can extract
	 *   error details from the response body. Listeners to this event
	 *   should set the `response.error` property.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event extractData(response)
	 *   Triggered in successful requests to allow listeners to
	 *   de-serialize the response body into `response.data`.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group Completion Events
	 *
	 * @!event success(response)
	 *   Triggered when the request completed successfully.
	 *   `response.data` will contain the response data and
	 *   `response.error` will be null.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event error(error, response)
	 *   Triggered when an error occurs at any point during the
	 *   request. `response.error` will contain details about the error
	 *   that occurred. `response.data` will be null.
	 *   @param error [Error] the error object containing details about
	 *     the error that occurred.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event complete(response)
	 *   Triggered whenever a request cycle completes. `response.error`
	 *   should be checked, since the request may have failed.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!group HTTP Events
	 *
	 * @!event httpHeaders(statusCode, headers, response, statusMessage)
	 *   Triggered when headers are sent by the remote server
	 *   @param statusCode [Integer] the HTTP response code
	 *   @param headers [map<String,String>] the response headers
	 *   @param (see AWS.Request~send)
	 *   @param statusMessage [String] A status message corresponding to the HTTP
	 *                                 response code
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpData(chunk, response)
	 *   Triggered when data is sent by the remote server
	 *   @param chunk [Buffer] the buffer data containing the next data chunk
	 *     from the server
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @see AWS.EventListeners.Core.HTTP_DATA
	 *
	 * @!event httpUploadProgress(progress, response)
	 *   Triggered when the HTTP request has uploaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpDownloadProgress(progress, response)
	 *   Triggered when the HTTP request has downloaded more data
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request.
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *
	 * @!event httpError(error, response)
	 *   Triggered when the HTTP request failed
	 *   @param error [Error] the error object that was thrown
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @!event httpDone(response)
	 *   Triggered when the server is finished sending data
	 *   @param (see AWS.Request~send)
	 *   @context (see AWS.Request~send)
	 *
	 * @see AWS.Response
	 */
	AWS.Request = inherit({
	
	  /**
	   * Creates a request for an operation on a given service with
	   * a set of input parameters.
	   *
	   * @param service [AWS.Service] the service to perform the operation on
	   * @param operation [String] the operation to perform on the service
	   * @param params [Object] parameters to send to the operation.
	   *   See the operation's documentation for the format of the
	   *   parameters.
	   */
	  constructor: function Request(service, operation, params) {
	    var endpoint = service.endpoint;
	    var region = service.config.region;
	    var customUserAgent = service.config.customUserAgent;
	
	    // global endpoints sign as us-east-1
	    if (service.isGlobalEndpoint) region = 'us-east-1';
	
	    this.domain = domain && domain.active;
	    this.service = service;
	    this.operation = operation;
	    this.params = params || {};
	    this.httpRequest = new AWS.HttpRequest(endpoint, region);
	    this.httpRequest.appendToUserAgent(customUserAgent);
	    this.startTime = service.getSkewCorrectedDate();
	
	    this.response = new AWS.Response(this);
	    this._asm = new AcceptorStateMachine(fsm.states, 'validate');
	    this._haltHandlersOnError = false;
	
	    AWS.SequentialExecutor.call(this);
	    this.emit = this.emitEvent;
	  },
	
	  /**
	   * @!group Sending a Request
	   */
	
	  /**
	   * @overload send(callback = null)
	   *   Sends the request object.
	   *
	   *   @callback callback function(err, data)
	   *     If a callback is supplied, it is called when a response is returned
	   *     from the service.
	   *     @context [AWS.Request] the request object being sent.
	   *     @param err [Error] the error object returned from the request.
	   *       Set to `null` if the request is successful.
	   *     @param data [Object] the de-serialized data returned from
	   *       the request. Set to `null` if a request error occurs.
	   *   @example Sending a request with a callback
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.send(function(err, data) { console.log(err, data); });
	   *   @example Sending a request with no callback (using event handlers)
	   *     request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     request.on('complete', function(response) { ... }); // register a callback
	   *     request.send();
	   */
	  send: function send(callback) {
	    if (callback) {
	      // append to user agent
	      this.httpRequest.appendToUserAgent('callback');
	      this.on('complete', function (resp) {
	        callback.call(resp, resp.error, resp.data);
	      });
	    }
	    this.runTo();
	
	    return this.response;
	  },
	
	  /**
	   * @!method  promise()
	   *   Sends the request and returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [Object] the de-serialized data returned from the request.
	   *   @callback rejectedCallback function(error)
	   *     Called if the promise is rejected.
	   *     @param error [Error] the error object returned from the request.
	   *   @return [Promise] A promise that represents the state of the request.
	   *   @example Sending a request using promises.
	   *     var request = s3.putObject({Bucket: 'bucket', Key: 'key'});
	   *     var result = request.promise();
	   *     result.then(function(data) { ... }, function(error) { ... });
	   */
	
	  /**
	   * @api private
	   */
	  build: function build(callback) {
	    return this.runTo('send', callback);
	  },
	
	  /**
	   * @api private
	   */
	  runTo: function runTo(state, done) {
	    this._asm.runTo(state, done, this);
	    return this;
	  },
	
	  /**
	   * Aborts a request, emitting the error and complete events.
	   *
	   * @!macro nobrowser
	   * @example Aborting a request after sending
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: Buffer.alloc(1024 * 1024 * 5) // 5MB payload
	   *   };
	   *   var request = s3.putObject(params);
	   *   request.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(request.abort.bind(request), 1000);
	   *
	   *   // prints "Error: RequestAbortedError Request aborted by user"
	   * @return [AWS.Request] the same request object, for chaining.
	   * @since v1.4.0
	   */
	  abort: function abort() {
	    this.removeAllListeners('validateResponse');
	    this.removeAllListeners('extractError');
	    this.on('validateResponse', function addAbortedError(resp) {
	      resp.error = AWS.util.error(new Error('Request aborted by user'), {
	         code: 'RequestAbortedError', retryable: false
	      });
	    });
	
	    if (this.httpRequest.stream && !this.httpRequest.stream.didCallback) { // abort HTTP stream
	      this.httpRequest.stream.abort();
	      if (this.httpRequest._abortCallback) {
	         this.httpRequest._abortCallback();
	      } else {
	        this.removeAllListeners('send'); // haven't sent yet, so let's not
	      }
	    }
	
	    return this;
	  },
	
	  /**
	   * Iterates over each page of results given a pageable request, calling
	   * the provided callback with each page of data. After all pages have been
	   * retrieved, the callback is called with `null` data.
	   *
	   * @note This operation can generate multiple requests to a service.
	   * @example Iterating over multiple pages of objects in an S3 bucket
	   *   var pages = 1;
	   *   s3.listObjects().eachPage(function(err, data) {
	   *     if (err) return;
	   *     console.log("Page", pages++);
	   *     console.log(data);
	   *   });
	   * @example Iterating over multiple pages with an asynchronous callback
	   *   s3.listObjects(params).eachPage(function(err, data, done) {
	   *     doSomethingAsyncAndOrExpensive(function() {
	   *       // The next page of results isn't fetched until done is called
	   *       done();
	   *     });
	   *   });
	   * @callback callback function(err, data, [doneCallback])
	   *   Called with each page of resulting data from the request. If the
	   *   optional `doneCallback` is provided in the function, it must be called
	   *   when the callback is complete.
	   *
	   *   @param err [Error] an error object, if an error occurred.
	   *   @param data [Object] a single page of response data. If there is no
	   *     more data, this object will be `null`.
	   *   @param doneCallback [Function] an optional done callback. If this
	   *     argument is defined in the function declaration, it should be called
	   *     when the next page is ready to be retrieved. This is useful for
	   *     controlling serial pagination across asynchronous operations.
	   *   @return [Boolean] if the callback returns `false`, pagination will
	   *     stop.
	   *
	   * @see AWS.Request.eachItem
	   * @see AWS.Response.nextPage
	   * @since v1.4.0
	   */
	  eachPage: function eachPage(callback) {
	    // Make all callbacks async-ish
	    callback = AWS.util.fn.makeAsync(callback, 3);
	
	    function wrappedCallback(response) {
	      callback.call(response, response.error, response.data, function (result) {
	        if (result === false) return;
	
	        if (response.hasNextPage()) {
	          response.nextPage().on('complete', wrappedCallback).send();
	        } else {
	          callback.call(response, null, null, AWS.util.fn.noop);
	        }
	      });
	    }
	
	    this.on('complete', wrappedCallback).send();
	  },
	
	  /**
	   * Enumerates over individual items of a request, paging the responses if
	   * necessary.
	   *
	   * @api experimental
	   * @since v1.4.0
	   */
	  eachItem: function eachItem(callback) {
	    var self = this;
	    function wrappedCallback(err, data) {
	      if (err) return callback(err, null);
	      if (data === null) return callback(null, null);
	
	      var config = self.service.paginationConfig(self.operation);
	      var resultKey = config.resultKey;
	      if (Array.isArray(resultKey)) resultKey = resultKey[0];
	      var items = jmespath.search(data, resultKey);
	      var continueIteration = true;
	      AWS.util.arrayEach(items, function(item) {
	        continueIteration = callback(null, item);
	        if (continueIteration === false) {
	          return AWS.util.abort;
	        }
	      });
	      return continueIteration;
	    }
	
	    this.eachPage(wrappedCallback);
	  },
	
	  /**
	   * @return [Boolean] whether the operation can return multiple pages of
	   *   response data.
	   * @see AWS.Response.eachPage
	   * @since v1.4.0
	   */
	  isPageable: function isPageable() {
	    return this.service.paginationConfig(this.operation) ? true : false;
	  },
	
	  /**
	   * Sends the request and converts the request object into a readable stream
	   * that can be read from or piped into a writable stream.
	   *
	   * @note The data read from a readable stream contains only
	   *   the raw HTTP body contents.
	   * @example Manually reading from a stream
	   *   request.createReadStream().on('data', function(data) {
	   *     console.log("Got data:", data.toString());
	   *   });
	   * @example Piping a request body into a file
	   *   var out = fs.createWriteStream('/path/to/outfile.jpg');
	   *   s3.service.getObject(params).createReadStream().pipe(out);
	   * @return [Stream] the readable stream object that can be piped
	   *   or read from (by registering 'data' event listeners).
	   * @!macro nobrowser
	   */
	  createReadStream: function createReadStream() {
	    var streams = AWS.util.stream;
	    var req = this;
	    var stream = null;
	
	    if (AWS.HttpClient.streamsApiVersion === 2) {
	      stream = new streams.PassThrough();
	      process.nextTick(function() { req.send(); });
	    } else {
	      stream = new streams.Stream();
	      stream.readable = true;
	
	      stream.sent = false;
	      stream.on('newListener', function(event) {
	        if (!stream.sent && event === 'data') {
	          stream.sent = true;
	          process.nextTick(function() { req.send(); });
	        }
	      });
	    }
	
	    this.on('error', function(err) {
	      stream.emit('error', err);
	    });
	
	    this.on('httpHeaders', function streamHeaders(statusCode, headers, resp) {
	      if (statusCode < 300) {
	        req.removeListener('httpData', AWS.EventListeners.Core.HTTP_DATA);
	        req.removeListener('httpError', AWS.EventListeners.Core.HTTP_ERROR);
	        req.on('httpError', function streamHttpError(error) {
	          resp.error = error;
	          resp.error.retryable = false;
	        });
	
	        var shouldCheckContentLength = false;
	        var expectedLen;
	        if (req.httpRequest.method !== 'HEAD') {
	          expectedLen = parseInt(headers['content-length'], 10);
	        }
	        if (expectedLen !== undefined && !isNaN(expectedLen) && expectedLen >= 0) {
	          shouldCheckContentLength = true;
	          var receivedLen = 0;
	        }
	
	        var checkContentLengthAndEmit = function checkContentLengthAndEmit() {
	          if (shouldCheckContentLength && receivedLen !== expectedLen) {
	            stream.emit('error', AWS.util.error(
	              new Error('Stream content length mismatch. Received ' +
	                receivedLen + ' of ' + expectedLen + ' bytes.'),
	              { code: 'StreamContentLengthMismatch' }
	            ));
	          } else if (AWS.HttpClient.streamsApiVersion === 2) {
	            stream.end();
	          } else {
	            stream.emit('end');
	          }
	        };
	
	        var httpStream = resp.httpResponse.createUnbufferedStream();
	
	        if (AWS.HttpClient.streamsApiVersion === 2) {
	          if (shouldCheckContentLength) {
	            var lengthAccumulator = new streams.PassThrough();
	            lengthAccumulator._write = function(chunk) {
	              if (chunk && chunk.length) {
	                receivedLen += chunk.length;
	              }
	              return streams.PassThrough.prototype._write.apply(this, arguments);
	            };
	
	            lengthAccumulator.on('end', checkContentLengthAndEmit);
	            stream.on('error', function(err) {
	              shouldCheckContentLength = false;
	              httpStream.unpipe(lengthAccumulator);
	              lengthAccumulator.emit('end');
	              lengthAccumulator.end();
	            });
	            httpStream.pipe(lengthAccumulator).pipe(stream, { end: false });
	          } else {
	            httpStream.pipe(stream);
	          }
	        } else {
	
	          if (shouldCheckContentLength) {
	            httpStream.on('data', function(arg) {
	              if (arg && arg.length) {
	                receivedLen += arg.length;
	              }
	            });
	          }
	
	          httpStream.on('data', function(arg) {
	            stream.emit('data', arg);
	          });
	          httpStream.on('end', checkContentLengthAndEmit);
	        }
	
	        httpStream.on('error', function(err) {
	          shouldCheckContentLength = false;
	          stream.emit('error', err);
	        });
	      }
	    });
	
	    return stream;
	  },
	
	  /**
	   * @param [Array,Response] args This should be the response object,
	   *   or an array of args to send to the event.
	   * @api private
	   */
	  emitEvent: function emit(eventName, args, done) {
	    if (typeof args === 'function') { done = args; args = null; }
	    if (!done) done = function() { };
	    if (!args) args = this.eventParameters(eventName, this.response);
	
	    var origEmit = AWS.SequentialExecutor.prototype.emit;
	    origEmit.call(this, eventName, args, function (err) {
	      if (err) this.response.error = err;
	      done.call(this, err);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  eventParameters: function eventParameters(eventName) {
	    switch (eventName) {
	      case 'restart':
	      case 'validate':
	      case 'sign':
	      case 'build':
	      case 'afterValidate':
	      case 'afterBuild':
	        return [this];
	      case 'error':
	        return [this.response.error, this.response];
	      default:
	        return [this.response];
	    }
	  },
	
	  /**
	   * @api private
	   */
	  presign: function presign(expires, callback) {
	    if (!callback && typeof expires === 'function') {
	      callback = expires;
	      expires = null;
	    }
	    return new AWS.Signers.Presign().sign(this.toGet(), expires, callback);
	  },
	
	  /**
	   * @api private
	   */
	  isPresigned: function isPresigned() {
	    return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, 'presigned-expires');
	  },
	
	  /**
	   * @api private
	   */
	  toUnauthenticated: function toUnauthenticated() {
	    this._unAuthenticated = true;
	    this.removeListener('validate', AWS.EventListeners.Core.VALIDATE_CREDENTIALS);
	    this.removeListener('sign', AWS.EventListeners.Core.SIGN);
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  toGet: function toGet() {
	    if (this.service.api.protocol === 'query' ||
	        this.service.api.protocol === 'ec2') {
	      this.removeListener('build', this.buildAsGet);
	      this.addListener('build', this.buildAsGet);
	    }
	    return this;
	  },
	
	  /**
	   * @api private
	   */
	  buildAsGet: function buildAsGet(request) {
	    request.httpRequest.method = 'GET';
	    request.httpRequest.path = request.service.endpoint.path +
	                               '?' + request.httpRequest.body;
	    request.httpRequest.body = '';
	
	    // don't need these headers on a GET request
	    delete request.httpRequest.headers['Content-Length'];
	    delete request.httpRequest.headers['Content-Type'];
	  },
	
	  /**
	   * @api private
	   */
	  haltHandlersOnError: function haltHandlersOnError() {
	    this._haltHandlersOnError = true;
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.Request.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = function promise() {
	    var self = this;
	    // append to user agent
	    this.httpRequest.appendToUserAgent('promise');
	    return new PromiseDependency(function(resolve, reject) {
	      self.on('complete', function(resp) {
	        if (resp.error) {
	          reject(resp.error);
	        } else {
	          // define $response property so that it is not enumberable
	          // this prevents circular reference errors when stringifying the JSON object
	          resolve(Object.defineProperty(
	            resp.data || {},
	            '$response',
	            {value: resp}
	          ));
	        }
	      });
	      self.runTo();
	    });
	  };
	};
	
	/**
	 * @api private
	 */
	AWS.Request.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};
	
	AWS.util.addPromises(AWS.Request);
	
	AWS.util.mixin(AWS.Request, AWS.SequentialExecutor);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 1026 */
[2520, 4],
/* 1027 */
[2521, 4],
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var byteLength = AWS.util.string.byteLength;
	var Buffer = AWS.util.Buffer;
	
	/**
	 * The managed uploader allows for easy and efficient uploading of buffers,
	 * blobs, or streams, using a configurable amount of concurrency to perform
	 * multipart uploads where possible. This abstraction also enables uploading
	 * streams of unknown size due to the use of multipart uploads.
	 *
	 * To construct a managed upload object, see the {constructor} function.
	 *
	 * ## Tracking upload progress
	 *
	 * The managed upload object can also track progress by attaching an
	 * 'httpUploadProgress' listener to the upload manager. This event is similar
	 * to {AWS.Request~httpUploadProgress} but groups all concurrent upload progress
	 * into a single event. See {AWS.S3.ManagedUpload~httpUploadProgress} for more
	 * information.
	 *
	 * ## Handling Multipart Cleanup
	 *
	 * By default, this class will automatically clean up any multipart uploads
	 * when an individual part upload fails. This behavior can be disabled in order
	 * to manually handle failures by setting the `leavePartsOnError` configuration
	 * option to `true` when initializing the upload object.
	 *
	 * @!event httpUploadProgress(progress)
	 *   Triggered when the uploader has uploaded more data.
	 *   @note The `total` property may not be set if the stream being uploaded has
	 *     not yet finished chunking. In this case the `total` will be undefined
	 *     until the total stream size is known.
	 *   @note This event will not be emitted in Node.js 0.8.x.
	 *   @param progress [map] An object containing the `loaded` and `total` bytes
	 *     of the request and the `key` of the S3 object. Note that `total` may be undefined until the payload
	 *     size is known.
	 *   @context (see AWS.Request~send)
	 */
	AWS.S3.ManagedUpload = AWS.util.inherit({
	  /**
	   * Creates a managed upload object with a set of configuration options.
	   *
	   * @note A "Body" parameter is required to be set prior to calling {send}.
	   * @note In Node.js, sending "Body" as {https://nodejs.org/dist/latest/docs/api/stream.html#stream_object_mode object-mode stream}
	   *   may result in upload hangs. Using buffer stream is preferable.
	   * @option options params [map] a map of parameters to pass to the upload
	   *   requests. The "Body" parameter is required to be specified either on
	   *   the service or in the params option.
	   * @note ContentMD5 should not be provided when using the managed upload object.
	   *   Instead, setting "computeChecksums" to true will enable automatic ContentMD5 generation
	   *   by the managed upload object.
	   * @option options queueSize [Number] (4) the size of the concurrent queue
	   *   manager to upload parts in parallel. Set to 1 for synchronous uploading
	   *   of parts. Note that the uploader will buffer at most queueSize * partSize
	   *   bytes into memory at any given time.
	   * @option options partSize [Number] (5mb) the size in bytes for each
	   *   individual part to be uploaded. Adjust the part size to ensure the number
	   *   of parts does not exceed {maxTotalParts}. See {minPartSize} for the
	   *   minimum allowed part size.
	   * @option options leavePartsOnError [Boolean] (false) whether to abort the
	   *   multipart upload if an error occurs. Set to true if you want to handle
	   *   failures manually.
	   * @option options service [AWS.S3] an optional S3 service object to use for
	   *   requests. This object might have bound parameters used by the uploader.
	   * @option options tags [Array<map>] The tags to apply to the uploaded object.
	   *   Each tag should have a `Key` and `Value` keys.
	   * @example Creating a default uploader for a stream object
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with concurrency of 1 and partSize of 10mb
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     partSize: 10 * 1024 * 1024, queueSize: 1,
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream}
	   *   });
	   * @example Creating an uploader with tags
	   *   var upload = new AWS.S3.ManagedUpload({
	   *     params: {Bucket: 'bucket', Key: 'key', Body: stream},
	   *     tags: [{Key: 'tag1', Value: 'value1'}, {Key: 'tag2', Value: 'value2'}]
	   *   });
	   * @see send
	   */
	  constructor: function ManagedUpload(options) {
	    var self = this;
	    AWS.SequentialExecutor.call(self);
	    self.body = null;
	    self.sliceFn = null;
	    self.callback = null;
	    self.parts = {};
	    self.completeInfo = [];
	    self.fillQueue = function() {
	      self.callback(new Error('Unsupported body payload ' + typeof self.body));
	    };
	
	    self.configure(options);
	  },
	
	  /**
	   * @api private
	   */
	  configure: function configure(options) {
	    options = options || {};
	    this.partSize = this.minPartSize;
	
	    if (options.queueSize) this.queueSize = options.queueSize;
	    if (options.partSize) this.partSize = options.partSize;
	    if (options.leavePartsOnError) this.leavePartsOnError = true;
	    if (options.tags) {
	      if (!Array.isArray(options.tags)) {
	        throw new Error('Tags must be specified as an array; ' +
	          typeof options.tags + ' provided.');
	      }
	      this.tags = options.tags;
	    }
	
	    if (this.partSize < this.minPartSize) {
	      throw new Error('partSize must be greater than ' +
	                      this.minPartSize);
	    }
	
	    this.service = options.service;
	    this.bindServiceObject(options.params);
	    this.validateBody();
	    this.adjustTotalBytes();
	  },
	
	  /**
	   * @api private
	   */
	  leavePartsOnError: false,
	
	  /**
	   * @api private
	   */
	  queueSize: 4,
	
	  /**
	   * @api private
	   */
	  partSize: null,
	
	  /**
	   * @readonly
	   * @return [Number] the minimum number of bytes for an individual part
	   *   upload.
	   */
	  minPartSize: 1024 * 1024 * 5,
	
	  /**
	   * @readonly
	   * @return [Number] the maximum allowed number of parts in a multipart upload.
	   */
	  maxTotalParts: 10000,
	
	  /**
	   * Initiates the managed upload for the payload.
	   *
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *     * `Location` (String) the URL of the uploaded object
	   *     * `ETag` (String) the ETag of the uploaded object
	   *     * `Bucket` (String) the bucket to which the object was uploaded
	   *     * `Key` (String) the key to which the object was uploaded
	   * @example Sending a managed upload object
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *   var upload = new AWS.S3.ManagedUpload({params: params});
	   *   upload.send(function(err, data) {
	   *     console.log(err, data);
	   *   });
	   */
	  send: function(callback) {
	    var self = this;
	    self.failed = false;
	    self.callback = callback || function(err) { if (err) throw err; };
	
	    var runFill = true;
	    if (self.sliceFn) {
	      self.fillQueue = self.fillBuffer;
	    } else if (AWS.util.isNode()) {
	      var Stream = AWS.util.stream.Stream;
	      if (self.body instanceof Stream) {
	        runFill = false;
	        self.fillQueue = self.fillStream;
	        self.partBuffers = [];
	        self.body.
	          on('error', function(err) { self.cleanup(err); }).
	          on('readable', function() { self.fillQueue(); }).
	          on('end', function() {
	            self.isDoneChunking = true;
	            self.numParts = self.totalPartNumbers;
	            self.fillQueue.call(self);
	
	            if (self.isDoneChunking && self.totalPartNumbers >= 1 && self.doneParts === self.numParts) {
	              self.finishMultiPart();
	            }
	          });
	      }
	    }
	
	    if (runFill) self.fillQueue.call(self);
	  },
	
	  /**
	   * @!method  promise()
	   *   Returns a 'thenable' promise.
	   *
	   *   Two callbacks can be provided to the `then` method on the returned promise.
	   *   The first callback will be called if the promise is fulfilled, and the second
	   *   callback will be called if the promise is rejected.
	   *   @callback fulfilledCallback function(data)
	   *     Called if the promise is fulfilled.
	   *     @param data [map] The response data from the successful upload:
	   *       `Location` (String) the URL of the uploaded object
	   *       `ETag` (String) the ETag of the uploaded object
	   *       `Bucket` (String) the bucket to which the object was uploaded
	   *       `Key` (String) the key to which the object was uploaded
	   *   @callback rejectedCallback function(err)
	   *     Called if the promise is rejected.
	   *     @param err [Error] an error or null if no error occurred.
	   *   @return [Promise] A promise that represents the state of the upload request.
	   *   @example Sending an upload request using promises.
	   *     var upload = s3.upload({Bucket: 'bucket', Key: 'key', Body: stream});
	   *     var promise = upload.promise();
	   *     promise.then(function(data) { ... }, function(err) { ... });
	   */
	
	  /**
	   * Aborts a managed upload, including all concurrent upload requests.
	   * @note By default, calling this function will cleanup a multipart upload
	   *   if one was created. To leave the multipart upload around after aborting
	   *   a request, configure `leavePartsOnError` to `true` in the {constructor}.
	   * @note Calling {abort} in the browser environment will not abort any requests
	   *   that are already in flight. If a multipart upload was created, any parts
	   *   not yet uploaded will not be sent, and the multipart upload will be cleaned up.
	   * @example Aborting an upload
	   *   var params = {
	   *     Bucket: 'bucket', Key: 'key',
	   *     Body: Buffer.alloc(1024 * 1024 * 25) // 25MB payload
	   *   };
	   *   var upload = s3.upload(params);
	   *   upload.send(function (err, data) {
	   *     if (err) console.log("Error:", err.code, err.message);
	   *     else console.log(data);
	   *   });
	   *
	   *   // abort request in 1 second
	   *   setTimeout(upload.abort.bind(upload), 1000);
	   */
	  abort: function() {
	    var self = this;
	    //abort putObject request
	    if (self.isDoneChunking === true && self.totalPartNumbers === 1 && self.singlePart) {
	      self.singlePart.abort();
	    } else {
	      self.cleanup(AWS.util.error(new Error('Request aborted by user'), {
	        code: 'RequestAbortedError', retryable: false
	      }));
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBody: function validateBody() {
	    var self = this;
	    self.body = self.service.config.params.Body;
	    if (typeof self.body === 'string') {
	      self.body = AWS.util.buffer.toBuffer(self.body);
	    } else if (!self.body) {
	      throw new Error('params.Body is required');
	    }
	    self.sliceFn = AWS.util.arraySliceFn(self.body);
	  },
	
	  /**
	   * @api private
	   */
	  bindServiceObject: function bindServiceObject(params) {
	    params = params || {};
	    var self = this;
	    // bind parameters to new service object
	    if (!self.service) {
	      self.service = new AWS.S3({params: params});
	    } else {
	      var service = self.service;
	      var config = AWS.util.copy(service.config);
	      config.signatureVersion = service.getSignatureVersion();
	      self.service = new service.constructor.__super__(config);
	      self.service.config.params =
	        AWS.util.merge(self.service.config.params || {}, params);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  adjustTotalBytes: function adjustTotalBytes() {
	    var self = this;
	    try { // try to get totalBytes
	      self.totalBytes = byteLength(self.body);
	    } catch (e) { }
	
	    // try to adjust partSize if we know payload length
	    if (self.totalBytes) {
	      var newPartSize = Math.ceil(self.totalBytes / self.maxTotalParts);
	      if (newPartSize > self.partSize) self.partSize = newPartSize;
	    } else {
	      self.totalBytes = undefined;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isDoneChunking: false,
	
	  /**
	   * @api private
	   */
	  partPos: 0,
	
	  /**
	   * @api private
	   */
	  totalChunkedBytes: 0,
	
	  /**
	   * @api private
	   */
	  totalUploadedBytes: 0,
	
	  /**
	   * @api private
	   */
	  totalBytes: undefined,
	
	  /**
	   * @api private
	   */
	  numParts: 0,
	
	  /**
	   * @api private
	   */
	  totalPartNumbers: 0,
	
	  /**
	   * @api private
	   */
	  activeParts: 0,
	
	  /**
	   * @api private
	   */
	  doneParts: 0,
	
	  /**
	   * @api private
	   */
	  parts: null,
	
	  /**
	   * @api private
	   */
	  completeInfo: null,
	
	  /**
	   * @api private
	   */
	  failed: false,
	
	  /**
	   * @api private
	   */
	  multipartReq: null,
	
	  /**
	   * @api private
	   */
	  partBuffers: null,
	
	  /**
	   * @api private
	   */
	  partBufferLength: 0,
	
	  /**
	   * @api private
	   */
	  fillBuffer: function fillBuffer() {
	    var self = this;
	    var bodyLen = byteLength(self.body);
	
	    if (bodyLen === 0) {
	      self.isDoneChunking = true;
	      self.numParts = 1;
	      self.nextChunk(self.body);
	      return;
	    }
	
	    while (self.activeParts < self.queueSize && self.partPos < bodyLen) {
	      var endPos = Math.min(self.partPos + self.partSize, bodyLen);
	      var buf = self.sliceFn.call(self.body, self.partPos, endPos);
	      self.partPos += self.partSize;
	
	      if (byteLength(buf) < self.partSize || self.partPos === bodyLen) {
	        self.isDoneChunking = true;
	        self.numParts = self.totalPartNumbers + 1;
	      }
	      self.nextChunk(buf);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  fillStream: function fillStream() {
	    var self = this;
	    if (self.activeParts >= self.queueSize) return;
	
	    var buf = self.body.read(self.partSize - self.partBufferLength) ||
	              self.body.read();
	    if (buf) {
	      self.partBuffers.push(buf);
	      self.partBufferLength += buf.length;
	      self.totalChunkedBytes += buf.length;
	    }
	
	    if (self.partBufferLength >= self.partSize) {
	      // if we have single buffer we avoid copyfull concat
	      var pbuf = self.partBuffers.length === 1 ?
	        self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;
	
	      // if we have more than partSize, push the rest back on the queue
	      if (pbuf.length > self.partSize) {
	        var rest = pbuf.slice(self.partSize);
	        self.partBuffers.push(rest);
	        self.partBufferLength += rest.length;
	        pbuf = pbuf.slice(0, self.partSize);
	      }
	
	      self.nextChunk(pbuf);
	    }
	
	    if (self.isDoneChunking && !self.isDoneSending) {
	      // if we have single buffer we avoid copyfull concat
	      pbuf = self.partBuffers.length === 1 ?
	          self.partBuffers[0] : Buffer.concat(self.partBuffers);
	      self.partBuffers = [];
	      self.partBufferLength = 0;
	      self.totalBytes = self.totalChunkedBytes;
	      self.isDoneSending = true;
	
	      if (self.numParts === 0 || pbuf.length > 0) {
	        self.numParts++;
	        self.nextChunk(pbuf);
	      }
	    }
	
	    self.body.read(0);
	  },
	
	  /**
	   * @api private
	   */
	  nextChunk: function nextChunk(chunk) {
	    var self = this;
	    if (self.failed) return null;
	
	    var partNumber = ++self.totalPartNumbers;
	    if (self.isDoneChunking && partNumber === 1) {
	      var params = {Body: chunk};
	      if (this.tags) {
	        params.Tagging = this.getTaggingHeader();
	      }
	      var req = self.service.putObject(params);
	      req._managedUpload = self;
	      req.on('httpUploadProgress', self.progress).send(self.finishSinglePart);
	      self.singlePart = req; //save the single part request
	      return null;
	    } else if (self.service.config.params.ContentMD5) {
	      var err = AWS.util.error(new Error('The Content-MD5 you specified is invalid for multi-part uploads.'), {
	        code: 'InvalidDigest', retryable: false
	      });
	
	      self.cleanup(err);
	      return null;
	    }
	
	    if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) {
	      return null; // Already uploaded this part.
	    }
	
	    self.activeParts++;
	    if (!self.service.config.params.UploadId) {
	
	      if (!self.multipartReq) { // create multipart
	        self.multipartReq = self.service.createMultipartUpload();
	        self.multipartReq.on('success', function(resp) {
	          self.service.config.params.UploadId = resp.data.UploadId;
	          self.multipartReq = null;
	        });
	        self.queueChunks(chunk, partNumber);
	        self.multipartReq.on('error', function(err) {
	          self.cleanup(err);
	        });
	        self.multipartReq.send();
	      } else {
	        self.queueChunks(chunk, partNumber);
	      }
	    } else { // multipart is created, just send
	      self.uploadPart(chunk, partNumber);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getTaggingHeader: function getTaggingHeader() {
	    var kvPairStrings = [];
	    for (var i = 0; i < this.tags.length; i++) {
	      kvPairStrings.push(AWS.util.uriEscape(this.tags[i].Key) + '=' +
	        AWS.util.uriEscape(this.tags[i].Value));
	    }
	
	    return kvPairStrings.join('&');
	  },
	
	  /**
	   * @api private
	   */
	  uploadPart: function uploadPart(chunk, partNumber) {
	    var self = this;
	
	    var partParams = {
	      Body: chunk,
	      ContentLength: AWS.util.string.byteLength(chunk),
	      PartNumber: partNumber
	    };
	
	    var partInfo = {ETag: null, PartNumber: partNumber};
	    self.completeInfo[partNumber] = partInfo;
	
	    var req = self.service.uploadPart(partParams);
	    self.parts[partNumber] = req;
	    req._lastUploadedBytes = 0;
	    req._managedUpload = self;
	    req.on('httpUploadProgress', self.progress);
	    req.send(function(err, data) {
	      delete self.parts[partParams.PartNumber];
	      self.activeParts--;
	
	      if (!err && (!data || !data.ETag)) {
	        var message = 'No access to ETag property on response.';
	        if (AWS.util.isBrowser()) {
	          message += ' Check CORS configuration to expose ETag header.';
	        }
	
	        err = AWS.util.error(new Error(message), {
	          code: 'ETagMissing', retryable: false
	        });
	      }
	      if (err) return self.cleanup(err);
	      //prevent sending part being returned twice (https://github.com/aws/aws-sdk-js/issues/2304)
	      if (self.completeInfo[partNumber] && self.completeInfo[partNumber].ETag !== null) return null;
	      partInfo.ETag = data.ETag;
	      self.doneParts++;
	      if (self.isDoneChunking && self.doneParts === self.numParts) {
	        self.finishMultiPart();
	      } else {
	        self.fillQueue.call(self);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  queueChunks: function queueChunks(chunk, partNumber) {
	    var self = this;
	    self.multipartReq.on('success', function() {
	      self.uploadPart(chunk, partNumber);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  cleanup: function cleanup(err) {
	    var self = this;
	    if (self.failed) return;
	
	    // clean up stream
	    if (typeof self.body.removeAllListeners === 'function' &&
	        typeof self.body.resume === 'function') {
	      self.body.removeAllListeners('readable');
	      self.body.removeAllListeners('end');
	      self.body.resume();
	    }
	
	    // cleanup multipartReq listeners
	    if (self.multipartReq) {
	      self.multipartReq.removeAllListeners('success');
	      self.multipartReq.removeAllListeners('error');
	      self.multipartReq.removeAllListeners('complete');
	      delete self.multipartReq;
	    }
	
	    if (self.service.config.params.UploadId && !self.leavePartsOnError) {
	      self.service.abortMultipartUpload().send();
	    } else if (self.leavePartsOnError) {
	      self.isDoneChunking = false;
	    }
	
	    AWS.util.each(self.parts, function(partNumber, part) {
	      part.removeAllListeners('complete');
	      part.abort();
	    });
	
	    self.activeParts = 0;
	    self.partPos = 0;
	    self.numParts = 0;
	    self.totalPartNumbers = 0;
	    self.parts = {};
	    self.failed = true;
	    self.callback(err);
	  },
	
	  /**
	   * @api private
	   */
	  finishMultiPart: function finishMultiPart() {
	    var self = this;
	    var completeParams = { MultipartUpload: { Parts: self.completeInfo.slice(1) } };
	    self.service.completeMultipartUpload(completeParams, function(err, data) {
	      if (err) {
	        return self.cleanup(err);
	      }
	
	      if (data && typeof data.Location === 'string') {
	        data.Location = data.Location.replace(/%2F/g, '/');
	      }
	
	      if (Array.isArray(self.tags)) {
	        for (var i = 0; i < self.tags.length; i++) {
	          self.tags[i].Value = String(self.tags[i].Value);
	        }
	        self.service.putObjectTagging(
	          {Tagging: {TagSet: self.tags}},
	          function(e, d) {
	            if (e) {
	              self.callback(e);
	            } else {
	              self.callback(e, data);
	            }
	          }
	        );
	      } else {
	        self.callback(err, data);
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  finishSinglePart: function finishSinglePart(err, data) {
	    var upload = this.request._managedUpload;
	    var httpReq = this.request.httpRequest;
	    var endpoint = httpReq.endpoint;
	    if (err) return upload.callback(err);
	    data.Location =
	      [endpoint.protocol, '//', endpoint.host, httpReq.path].join('');
	    data.key = this.request.params.Key; // will stay undocumented
	    data.Key = this.request.params.Key;
	    data.Bucket = this.request.params.Bucket;
	    upload.callback(err, data);
	  },
	
	  /**
	   * @api private
	   */
	  progress: function progress(info) {
	    var upload = this._managedUpload;
	    if (this.operation === 'putObject') {
	      info.part = 1;
	      info.key = this.params.Key;
	    } else {
	      upload.totalUploadedBytes += info.loaded - this._lastUploadedBytes;
	      this._lastUploadedBytes = info.loaded;
	      info = {
	        loaded: upload.totalUploadedBytes,
	        total: upload.totalBytes,
	        part: this.params.PartNumber,
	        key: this.params.Key
	      };
	    }
	    upload.emit('httpUploadProgress', [info]);
	  }
	});
	
	AWS.util.mixin(AWS.S3.ManagedUpload, AWS.SequentialExecutor);
	
	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.addPromisesToClass = function addPromisesToClass(PromiseDependency) {
	  this.prototype.promise = AWS.util.promisifyMethod('send', PromiseDependency);
	};
	
	/**
	 * @api private
	 */
	AWS.S3.ManagedUpload.deletePromisesFromClass = function deletePromisesFromClass() {
	  delete this.prototype.promise;
	};
	
	AWS.util.addPromises(AWS.S3.ManagedUpload);
	
	/**
	 * @api private
	 */
	module.exports = AWS.S3.ManagedUpload;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var AWS = __webpack_require__(4);
	var Api = __webpack_require__(427);
	var regionConfig = __webpack_require__(1024);
	
	var inherit = AWS.util.inherit;
	var clientCount = 0;
	
	/**
	 * The service class representing an AWS service.
	 *
	 * @class_abstract This class is an abstract class.
	 *
	 * @!attribute apiVersions
	 *   @return [Array<String>] the list of API versions supported by this service.
	 *   @readonly
	 */
	AWS.Service = inherit({
	  /**
	   * Create a new service object with a configuration object
	   *
	   * @param config [map] a map of configuration options
	   */
	  constructor: function Service(config) {
	    if (!this.loadServiceClass) {
	      throw AWS.util.error(new Error(),
	        'Service must be constructed with `new\' operator');
	    }
	    var ServiceClass = this.loadServiceClass(config || {});
	    if (ServiceClass) {
	      var originalConfig = AWS.util.copy(config);
	      var svc = new ServiceClass(config);
	      Object.defineProperty(svc, '_originalConfig', {
	        get: function() { return originalConfig; },
	        enumerable: false,
	        configurable: true
	      });
	      svc._clientId = ++clientCount;
	      return svc;
	    }
	    this.initialize(config);
	  },
	
	  /**
	   * @api private
	   */
	  initialize: function initialize(config) {
	    var svcConfig = AWS.config[this.serviceIdentifier];
	    this.config = new AWS.Config(AWS.config);
	    if (svcConfig) this.config.update(svcConfig, true);
	    if (config) this.config.update(config, true);
	
	    this.validateService();
	    if (!this.config.endpoint) regionConfig(this);
	
	    this.config.endpoint = this.endpointFromTemplate(this.config.endpoint);
	    this.setEndpoint(this.config.endpoint);
	    //enable attaching listeners to service client
	    AWS.SequentialExecutor.call(this);
	    AWS.Service.addDefaultMonitoringListeners(this);
	    if ((this.config.clientSideMonitoring || AWS.Service._clientSideMonitoring) && this.publisher) {
	      var publisher = this.publisher;
	      this.addNamedListener('PUBLISH_API_CALL', 'apiCall', function PUBLISH_API_CALL(event) {
	        process.nextTick(function() {publisher.eventHandler(event);});
	      });
	      this.addNamedListener('PUBLISH_API_ATTEMPT', 'apiCallAttempt', function PUBLISH_API_ATTEMPT(event) {
	        process.nextTick(function() {publisher.eventHandler(event);});
	      });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	  },
	
	  /**
	   * @api private
	   */
	  loadServiceClass: function loadServiceClass(serviceConfig) {
	    var config = serviceConfig;
	    if (!AWS.util.isEmpty(this.api)) {
	      return null;
	    } else if (config.apiConfig) {
	      return AWS.Service.defineServiceApi(this.constructor, config.apiConfig);
	    } else if (!this.constructor.services) {
	      return null;
	    } else {
	      config = new AWS.Config(AWS.config);
	      config.update(serviceConfig, true);
	      var version = config.apiVersions[this.constructor.serviceIdentifier];
	      version = version || config.apiVersion;
	      return this.getLatestServiceClass(version);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceClass: function getLatestServiceClass(version) {
	    version = this.getLatestServiceVersion(version);
	    if (this.constructor.services[version] === null) {
	      AWS.Service.defineServiceApi(this.constructor, version);
	    }
	
	    return this.constructor.services[version];
	  },
	
	  /**
	   * @api private
	   */
	  getLatestServiceVersion: function getLatestServiceVersion(version) {
	    if (!this.constructor.services || this.constructor.services.length === 0) {
	      throw new Error('No services defined on ' +
	                      this.constructor.serviceIdentifier);
	    }
	
	    if (!version) {
	      version = 'latest';
	    } else if (AWS.util.isType(version, Date)) {
	      version = AWS.util.date.iso8601(version).split('T')[0];
	    }
	
	    if (Object.hasOwnProperty(this.constructor.services, version)) {
	      return version;
	    }
	
	    var keys = Object.keys(this.constructor.services).sort();
	    var selectedVersion = null;
	    for (var i = keys.length - 1; i >= 0; i--) {
	      // versions that end in "*" are not available on disk and can be
	      // skipped, so do not choose these as selectedVersions
	      if (keys[i][keys[i].length - 1] !== '*') {
	        selectedVersion = keys[i];
	      }
	      if (keys[i].substr(0, 10) <= version) {
	        return selectedVersion;
	      }
	    }
	
	    throw new Error('Could not find ' + this.constructor.serviceIdentifier +
	                    ' API to satisfy version constraint `' + version + '\'');
	  },
	
	  /**
	   * @api private
	   */
	  api: {},
	
	  /**
	   * @api private
	   */
	  defaultRetryCount: 3,
	
	  /**
	   * @api private
	   */
	  customizeRequests: function customizeRequests(callback) {
	    if (!callback) {
	      this.customRequestHandler = null;
	    } else if (typeof callback === 'function') {
	      this.customRequestHandler = callback;
	    } else {
	      throw new Error('Invalid callback type \'' + typeof callback + '\' provided in customizeRequests');
	    }
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeRequest: function makeRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = null;
	    }
	
	    params = params || {};
	    if (this.config.params) { // copy only toplevel bound params
	      var rules = this.api.operations[operation];
	      if (rules) {
	        params = AWS.util.copy(params);
	        AWS.util.each(this.config.params, function(key, value) {
	          if (rules.input.members[key]) {
	            if (params[key] === undefined || params[key] === null) {
	              params[key] = value;
	            }
	          }
	        });
	      }
	    }
	
	    var request = new AWS.Request(this, operation, params);
	    this.addAllRequestListeners(request);
	    this.attachMonitoringEmitter(request);
	    if (callback) request.send(callback);
	    return request;
	  },
	
	  /**
	   * Calls an operation on a service with the given input parameters, without
	   * any authentication data. This method is useful for "public" API operations.
	   *
	   * @param operation [String] the name of the operation to call on the service.
	   * @param params [map] a map of input options for the operation
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  makeUnauthenticatedRequest: function makeUnauthenticatedRequest(operation, params, callback) {
	    if (typeof params === 'function') {
	      callback = params;
	      params = {};
	    }
	
	    var request = this.makeRequest(operation, params).toUnauthenticated();
	    return callback ? request.send(callback) : request;
	  },
	
	  /**
	   * Waits for a given state
	   *
	   * @param state [String] the state on the service to wait for
	   * @param params [map] a map of parameters to pass with each request
	   * @option params $waiter [map] a map of configuration options for the waiter
	   * @option params $waiter.delay [Number] The number of seconds to wait between
	   *                                       requests
	   * @option params $waiter.maxAttempts [Number] The maximum number of requests
	   *                                             to send while waiting
	   * @callback callback function(err, data)
	   *   If a callback is supplied, it is called when a response is returned
	   *   from the service.
	   *   @param err [Error] the error object returned from the request.
	   *     Set to `null` if the request is successful.
	   *   @param data [Object] the de-serialized data returned from
	   *     the request. Set to `null` if a request error occurs.
	   */
	  waitFor: function waitFor(state, params, callback) {
	    var waiter = new AWS.ResourceWaiter(this, state);
	    return waiter.wait(params, callback);
	  },
	
	  /**
	   * @api private
	   */
	  addAllRequestListeners: function addAllRequestListeners(request) {
	    var list = [AWS.events, AWS.EventListeners.Core, this.serviceInterface(),
	                AWS.EventListeners.CorePost];
	    for (var i = 0; i < list.length; i++) {
	      if (list[i]) request.addListeners(list[i]);
	    }
	
	    // disable parameter validation
	    if (!this.config.paramValidation) {
	      request.removeListener('validate',
	        AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	    }
	
	    if (this.config.logger) { // add logging events
	      request.addListeners(AWS.EventListeners.Logger);
	    }
	
	    this.setupRequestListeners(request);
	    // call prototype's customRequestHandler
	    if (typeof this.constructor.prototype.customRequestHandler === 'function') {
	      this.constructor.prototype.customRequestHandler(request);
	    }
	    // call instance's customRequestHandler
	    if (Object.prototype.hasOwnProperty.call(this, 'customRequestHandler') && typeof this.customRequestHandler === 'function') {
	      this.customRequestHandler(request);
	    }
	  },
	
	  /**
	   * Event recording metrics for a whole API call.
	   * @returns {object} a subset of api call metrics
	   * @api private
	   */
	  apiCallEvent: function apiCallEvent(request) {
	    var api = request.service.api.operations[request.operation];
	    var monitoringEvent = {
	      Type: 'ApiCall',
	      Api: api ? api.name : request.operation,
	      Version: 1,
	      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
	      Region: request.httpRequest.region,
	      MaxRetriesExceeded: 0,
	      UserAgent: request.httpRequest.getUserAgent(),
	    };
	    var response = request.response;
	    if (response.httpResponse.statusCode) {
	      monitoringEvent.FinalHttpStatusCode = response.httpResponse.statusCode;
	    }
	    if (response.error) {
	      var error = response.error;
	      var statusCode = response.httpResponse.statusCode;
	      if (statusCode > 299) {
	        if (error.code) monitoringEvent.FinalAwsException = error.code;
	        if (error.message) monitoringEvent.FinalAwsExceptionMessage = error.message;
	      } else {
	        if (error.code || error.name) monitoringEvent.FinalSdkException = error.code || error.name;
	        if (error.message) monitoringEvent.FinalSdkExceptionMessage = error.message;
	      }
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Event recording metrics for an API call attempt.
	   * @returns {object} a subset of api call attempt metrics
	   * @api private
	   */
	  apiAttemptEvent: function apiAttemptEvent(request) {
	    var api = request.service.api.operations[request.operation];
	    var monitoringEvent = {
	      Type: 'ApiCallAttempt',
	      Api: api ? api.name : request.operation,
	      Version: 1,
	      Service: request.service.api.serviceId || request.service.api.endpointPrefix,
	      Fqdn: request.httpRequest.endpoint.hostname,
	      UserAgent: request.httpRequest.getUserAgent(),
	    };
	    var response = request.response;
	    if (response.httpResponse.statusCode) {
	      monitoringEvent.HttpStatusCode = response.httpResponse.statusCode;
	    }
	    if (
	      !request._unAuthenticated &&
	      request.service.config.credentials &&
	      request.service.config.credentials.accessKeyId
	    ) {
	      monitoringEvent.AccessKey = request.service.config.credentials.accessKeyId;
	    }
	    if (!response.httpResponse.headers) return monitoringEvent;
	    if (request.httpRequest.headers['x-amz-security-token']) {
	      monitoringEvent.SessionToken = request.httpRequest.headers['x-amz-security-token'];
	    }
	    if (response.httpResponse.headers['x-amzn-requestid']) {
	      monitoringEvent.XAmznRequestId = response.httpResponse.headers['x-amzn-requestid'];
	    }
	    if (response.httpResponse.headers['x-amz-request-id']) {
	      monitoringEvent.XAmzRequestId = response.httpResponse.headers['x-amz-request-id'];
	    }
	    if (response.httpResponse.headers['x-amz-id-2']) {
	      monitoringEvent.XAmzId2 = response.httpResponse.headers['x-amz-id-2'];
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Add metrics of failed request.
	   * @api private
	   */
	  attemptFailEvent: function attemptFailEvent(request) {
	    var monitoringEvent = this.apiAttemptEvent(request);
	    var response = request.response;
	    var error = response.error;
	    if (response.httpResponse.statusCode > 299 ) {
	      if (error.code) monitoringEvent.AwsException = error.code;
	      if (error.message) monitoringEvent.AwsExceptionMessage = error.message;
	    } else {
	      if (error.code || error.name) monitoringEvent.SdkException = error.code || error.name;
	      if (error.message) monitoringEvent.SdkExceptionMessage = error.message;
	    }
	    return monitoringEvent;
	  },
	
	  /**
	   * Attach listeners to request object to fetch metrics of each request
	   * and emit data object through \'ApiCall\' and \'ApiCallAttempt\' events.
	   * @api private
	   */
	  attachMonitoringEmitter: function attachMonitoringEmitter(request) {
	    var attemptTimestamp; //timestamp marking the beginning of a request attempt
	    var attemptStartRealTime; //Start time of request attempt. Used to calculating attemptLatency
	    var attemptLatency; //latency from request sent out to http response reaching SDK
	    var callStartRealTime; //Start time of API call. Used to calculating API call latency
	    var attemptCount = 0; //request.retryCount is not reliable here
	    var region; //region cache region for each attempt since it can be updated in plase (e.g. s3)
	    var callTimestamp; //timestamp when the request is created
	    var self = this;
	    var addToHead = true;
	
	    request.on('validate', function () {
	      callStartRealTime = AWS.util.realClock.now();
	      callTimestamp = Date.now();
	    }, addToHead);
	    request.on('sign', function () {
	      attemptStartRealTime = AWS.util.realClock.now();
	      attemptTimestamp = Date.now();
	      region = request.httpRequest.region;
	      attemptCount++;
	    }, addToHead);
	    request.on('validateResponse', function() {
	      attemptLatency = Math.round(AWS.util.realClock.now() - attemptStartRealTime);
	    });
	    request.addNamedListener('API_CALL_ATTEMPT', 'success', function API_CALL_ATTEMPT() {
	      var apiAttemptEvent = self.apiAttemptEvent(request);
	      apiAttemptEvent.Timestamp = attemptTimestamp;
	      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
	      apiAttemptEvent.Region = region;
	      self.emit('apiCallAttempt', [apiAttemptEvent]);
	    });
	    request.addNamedListener('API_CALL_ATTEMPT_RETRY', 'retry', function API_CALL_ATTEMPT_RETRY() {
	      var apiAttemptEvent = self.attemptFailEvent(request);
	      apiAttemptEvent.Timestamp = attemptTimestamp;
	      //attemptLatency may not be available if fail before response
	      attemptLatency = attemptLatency ||
	        Math.round(AWS.util.realClock.now() - attemptStartRealTime);
	      apiAttemptEvent.AttemptLatency = attemptLatency >= 0 ? attemptLatency : 0;
	      apiAttemptEvent.Region = region;
	      self.emit('apiCallAttempt', [apiAttemptEvent]);
	    });
	    request.addNamedListener('API_CALL', 'complete', function API_CALL() {
	      var apiCallEvent = self.apiCallEvent(request);
	      apiCallEvent.AttemptCount = attemptCount;
	      if (apiCallEvent.AttemptCount <= 0) return;
	      apiCallEvent.Timestamp = callTimestamp;
	      var latency = Math.round(AWS.util.realClock.now() - callStartRealTime);
	      apiCallEvent.Latency = latency >= 0 ? latency : 0;
	      var response = request.response;
	      if (
	        typeof response.retryCount === 'number' &&
	        typeof response.maxRetries === 'number' &&
	        (response.retryCount >= response.maxRetries)
	      ) {
	        apiCallEvent.MaxRetriesExceeded = 1;
	      }
	      self.emit('apiCall', [apiCallEvent]);
	    });
	  },
	
	  /**
	   * Override this method to setup any custom request listeners for each
	   * new request to the service.
	   *
	   * @method_abstract This is an abstract method.
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	  },
	
	  /**
	   * Gets the signer class for a given request
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var version;
	    // get operation authtype if present
	    var operation = null;
	    var authtype = '';
	    if (request) {
	      var operations = request.service.api.operations || {};
	      operation = operations[request.operation] || null;
	      authtype = operation ? operation.authtype : '';
	    }
	    if (this.config.signatureVersion) {
	      version = this.config.signatureVersion;
	    } else if (authtype === 'v4' || authtype === 'v4-unsigned-body') {
	      version = 'v4';
	    } else {
	      version = this.api.signatureVersion;
	    }
	    return AWS.Signers.RequestSigner.getVersion(version);
	  },
	
	  /**
	   * @api private
	   */
	  serviceInterface: function serviceInterface() {
	    switch (this.api.protocol) {
	      case 'ec2': return AWS.EventListeners.Query;
	      case 'query': return AWS.EventListeners.Query;
	      case 'json': return AWS.EventListeners.Json;
	      case 'rest-json': return AWS.EventListeners.RestJson;
	      case 'rest-xml': return AWS.EventListeners.RestXml;
	    }
	    if (this.api.protocol) {
	      throw new Error('Invalid service `protocol\' ' +
	        this.api.protocol + ' in API config');
	    }
	  },
	
	  /**
	   * @api private
	   */
	  successfulResponse: function successfulResponse(resp) {
	    return resp.httpResponse.statusCode < 300;
	  },
	
	  /**
	   * How many times a failed request should be retried before giving up.
	   * the defaultRetryCount can be overriden by service classes.
	   *
	   * @api private
	   */
	  numRetries: function numRetries() {
	    if (this.config.maxRetries !== undefined) {
	      return this.config.maxRetries;
	    } else {
	      return this.defaultRetryCount;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  retryDelays: function retryDelays(retryCount) {
	    return AWS.util.calculateRetryDelay(retryCount, this.config.retryDelayOptions);
	  },
	
	  /**
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (this.timeoutError(error)) return true;
	    if (this.networkingError(error)) return true;
	    if (this.expiredCredentialsError(error)) return true;
	    if (this.throttledError(error)) return true;
	    if (error.statusCode >= 500) return true;
	    return false;
	  },
	
	  /**
	   * @api private
	   */
	  networkingError: function networkingError(error) {
	    return error.code === 'NetworkingError';
	  },
	
	  /**
	   * @api private
	   */
	  timeoutError: function timeoutError(error) {
	    return error.code === 'TimeoutError';
	  },
	
	  /**
	   * @api private
	   */
	  expiredCredentialsError: function expiredCredentialsError(error) {
	    // TODO : this only handles *one* of the expired credential codes
	    return (error.code === 'ExpiredTokenException');
	  },
	
	  /**
	   * @api private
	   */
	  clockSkewError: function clockSkewError(error) {
	    switch (error.code) {
	      case 'RequestTimeTooSkewed':
	      case 'RequestExpired':
	      case 'InvalidSignatureException':
	      case 'SignatureDoesNotMatch':
	      case 'AuthFailure':
	      case 'RequestInTheFuture':
	        return true;
	      default: return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  getSkewCorrectedDate: function getSkewCorrectedDate() {
	    return new Date(Date.now() + this.config.systemClockOffset);
	  },
	
	  /**
	   * @api private
	   */
	  applyClockOffset: function applyClockOffset(newServerTime) {
	    if (newServerTime) {
	      this.config.systemClockOffset = newServerTime - Date.now();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isClockSkewed: function isClockSkewed(newServerTime) {
	    if (newServerTime) {
	      return Math.abs(this.getSkewCorrectedDate().getTime() - newServerTime) >= 30000;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  throttledError: function throttledError(error) {
	    // this logic varies between services
	    switch (error.code) {
	      case 'ProvisionedThroughputExceededException':
	      case 'Throttling':
	      case 'ThrottlingException':
	      case 'RequestLimitExceeded':
	      case 'RequestThrottled':
	      case 'RequestThrottledException':
	      case 'TooManyRequestsException':
	      case 'TransactionInProgressException': //dynamodb
	        return true;
	      default:
	        return false;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  endpointFromTemplate: function endpointFromTemplate(endpoint) {
	    if (typeof endpoint !== 'string') return endpoint;
	
	    var e = endpoint;
	    e = e.replace(/\{service\}/g, this.api.endpointPrefix);
	    e = e.replace(/\{region\}/g, this.config.region);
	    e = e.replace(/\{scheme\}/g, this.config.sslEnabled ? 'https' : 'http');
	    return e;
	  },
	
	  /**
	   * @api private
	   */
	  setEndpoint: function setEndpoint(endpoint) {
	    this.endpoint = new AWS.Endpoint(endpoint, this.config);
	  },
	
	  /**
	   * @api private
	   */
	  paginationConfig: function paginationConfig(operation, throwException) {
	    var paginator = this.api.operations[operation].paginator;
	    if (!paginator) {
	      if (throwException) {
	        var e = new Error();
	        throw AWS.util.error(e, 'No pagination configuration for ' + operation);
	      }
	      return null;
	    }
	
	    return paginator;
	  }
	});
	
	AWS.util.update(AWS.Service, {
	
	  /**
	   * Adds one method for each operation described in the api configuration
	   *
	   * @api private
	   */
	  defineMethods: function defineMethods(svc) {
	    AWS.util.each(svc.prototype.api.operations, function iterator(method) {
	      if (svc.prototype[method]) return;
	      var operation = svc.prototype.api.operations[method];
	      if (operation.authtype === 'none') {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeUnauthenticatedRequest(method, params, callback);
	        };
	      } else {
	        svc.prototype[method] = function (params, callback) {
	          return this.makeRequest(method, params, callback);
	        };
	      }
	    });
	  },
	
	  /**
	   * Defines a new Service class using a service identifier and list of versions
	   * including an optional set of features (functions) to apply to the class
	   * prototype.
	   *
	   * @param serviceIdentifier [String] the identifier for the service
	   * @param versions [Array<String>] a list of versions that work with this
	   *   service
	   * @param features [Object] an object to attach to the prototype
	   * @return [Class<Service>] the service class defined by this function.
	   */
	  defineService: function defineService(serviceIdentifier, versions, features) {
	    AWS.Service._serviceMap[serviceIdentifier] = true;
	    if (!Array.isArray(versions)) {
	      features = versions;
	      versions = [];
	    }
	
	    var svc = inherit(AWS.Service, features || {});
	
	    if (typeof serviceIdentifier === 'string') {
	      AWS.Service.addVersions(svc, versions);
	
	      var identifier = svc.serviceIdentifier || serviceIdentifier;
	      svc.serviceIdentifier = identifier;
	    } else { // defineService called with an API
	      svc.prototype.api = serviceIdentifier;
	      AWS.Service.defineMethods(svc);
	    }
	    AWS.SequentialExecutor.call(this.prototype);
	    //util.clientSideMonitoring is only available in node
	    if (!this.prototype.publisher && AWS.util.clientSideMonitoring) {
	      var Publisher = AWS.util.clientSideMonitoring.Publisher;
	      var configProvider = AWS.util.clientSideMonitoring.configProvider;
	      var publisherConfig = configProvider();
	      this.prototype.publisher = new Publisher(publisherConfig);
	      if (publisherConfig.enabled) {
	        //if csm is enabled in environment, SDK should send all metrics
	        AWS.Service._clientSideMonitoring = true;
	      }
	    }
	    AWS.SequentialExecutor.call(svc.prototype);
	    AWS.Service.addDefaultMonitoringListeners(svc.prototype);
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  addVersions: function addVersions(svc, versions) {
	    if (!Array.isArray(versions)) versions = [versions];
	
	    svc.services = svc.services || {};
	    for (var i = 0; i < versions.length; i++) {
	      if (svc.services[versions[i]] === undefined) {
	        svc.services[versions[i]] = null;
	      }
	    }
	
	    svc.apiVersions = Object.keys(svc.services).sort();
	  },
	
	  /**
	   * @api private
	   */
	  defineServiceApi: function defineServiceApi(superclass, version, apiConfig) {
	    var svc = inherit(superclass, {
	      serviceIdentifier: superclass.serviceIdentifier
	    });
	
	    function setApi(api) {
	      if (api.isApi) {
	        svc.prototype.api = api;
	      } else {
	        svc.prototype.api = new Api(api);
	      }
	    }
	
	    if (typeof version === 'string') {
	      if (apiConfig) {
	        setApi(apiConfig);
	      } else {
	        try {
	          setApi(AWS.apiLoader(superclass.serviceIdentifier, version));
	        } catch (err) {
	          throw AWS.util.error(err, {
	            message: 'Could not find API configuration ' +
	              superclass.serviceIdentifier + '-' + version
	          });
	        }
	      }
	      if (!Object.prototype.hasOwnProperty.call(superclass.services, version)) {
	        superclass.apiVersions = superclass.apiVersions.concat(version).sort();
	      }
	      superclass.services[version] = svc;
	    } else {
	      setApi(version);
	    }
	
	    AWS.Service.defineMethods(svc);
	    return svc;
	  },
	
	  /**
	   * @api private
	   */
	  hasService: function(identifier) {
	    return Object.prototype.hasOwnProperty.call(AWS.Service._serviceMap, identifier);
	  },
	
	  /**
	   * @param attachOn attach default monitoring listeners to object
	   *
	   * Each monitoring event should be emitted from service client to service constructor prototype and then
	   * to global service prototype like bubbling up. These default monitoring events listener will transfer
	   * the monitoring events to the upper layer.
	   * @api private
	   */
	  addDefaultMonitoringListeners: function addDefaultMonitoringListeners(attachOn) {
	    attachOn.addNamedListener('MONITOR_EVENTS_BUBBLE', 'apiCallAttempt', function EVENTS_BUBBLE(event) {
	      var baseClass = Object.getPrototypeOf(attachOn);
	      if (baseClass._events) baseClass.emit('apiCallAttempt', [event]);
	    });
	    attachOn.addNamedListener('CALL_EVENTS_BUBBLE', 'apiCall', function CALL_EVENTS_BUBBLE(event) {
	      var baseClass = Object.getPrototypeOf(attachOn);
	      if (baseClass._events) baseClass.emit('apiCall', [event]);
	    });
	  },
	
	  /**
	   * @api private
	   */
	  _serviceMap: {}
	});
	
	AWS.util.mixin(AWS.Service, AWS.SequentialExecutor);
	
	/**
	 * @api private
	 */
	module.exports = AWS.Service;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	AWS.util.update(AWS.APIGateway.prototype, {
	/**
	 * Sets the Accept header to application/json.
	 *
	 * @api private
	 */
	  setAcceptHeader: function setAcceptHeader(req) {
	    var httpRequest = req.httpRequest;
	    if (!httpRequest.headers.Accept) {
	      httpRequest.headers['Accept'] = 'application/json';
	    }
	  },
	
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('build', this.setAcceptHeader);
	    if (request.operation === 'getExport') {
	      var params = request.params || {};
	      if (params.exportType === 'swagger') {
	        request.addListener('extractData', AWS.util.convertPayloadToString);
	      }
	    }
	  }
	});
	


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	// pull in CloudFront signer
	__webpack_require__(999);
	
	AWS.util.update(AWS.CloudFront.prototype, {
	
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('extractData', AWS.util.hoistPayloadMember);
	  }
	
	});


/***/ },
/* 1032 */
[2522, 4],
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	__webpack_require__(1008);
	
	AWS.util.update(AWS.DynamoDB.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.service.config.dynamoDbCrc32) {
	      request.removeListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
	      request.addListener('extractData', this.checkCrc32);
	      request.addListener('extractData', AWS.EventListeners.Json.EXTRACT_DATA);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  checkCrc32: function checkCrc32(resp) {
	    if (!resp.httpResponse.streaming && !resp.request.service.crc32IsValid(resp)) {
	      resp.data = null;
	      resp.error = AWS.util.error(new Error(), {
	        code: 'CRC32CheckFailed',
	        message: 'CRC32 integrity check failed',
	        retryable: true
	      });
	      resp.request.haltHandlersOnError();
	      throw (resp.error);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  crc32IsValid: function crc32IsValid(resp) {
	    var crc = resp.httpResponse.headers['x-amz-crc32'];
	    if (!crc) return true; // no (valid) CRC32 header
	    return parseInt(crc, 10) === AWS.util.crypto.crc32(resp.httpResponse.body);
	  },
	
	  /**
	   * @api private
	   */
	  defaultRetryCount: 10,
	
	  /**
	   * @api private
	   */
	  retryDelays: function retryDelays(retryCount) {
	    var retryDelayOptions = AWS.util.copy(this.config.retryDelayOptions);
	
	    if (typeof retryDelayOptions.base !== 'number') {
	        retryDelayOptions.base = 50; // default for dynamodb
	    }
	    var delay = AWS.util.calculateRetryDelay(retryCount, retryDelayOptions);
	    return delay;
	  }
	});


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	AWS.util.update(AWS.EC2.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.removeListener('extractError', AWS.EventListeners.Query.EXTRACT_ERROR);
	    request.addListener('extractError', this.extractError);
	
	    if (request.operation === 'copySnapshot') {
	      request.onAsync('validate', this.buildCopySnapshotPresignedUrl);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  buildCopySnapshotPresignedUrl: function buildCopySnapshotPresignedUrl(req, done) {
	    if (req.params.PresignedUrl || req._subRequest) {
	      return done();
	    }
	
	    req.params = AWS.util.copy(req.params);
	    req.params.DestinationRegion = req.service.config.region;
	
	    var config = AWS.util.copy(req.service.config);
	    delete config.endpoint;
	    config.region = req.params.SourceRegion;
	    var svc = new req.service.constructor(config);
	    var newReq = svc[req.operation](req.params);
	    newReq._subRequest = true;
	    newReq.presign(function(err, url) {
	      if (err) done(err);
	      else {
	        req.params.PresignedUrl = url;
	        done();
	      }
	    });
	  },
	
	  /**
	   * @api private
	   */
	  extractError: function extractError(resp) {
	    // EC2 nests the error code and message deeper than other AWS Query services.
	    var httpResponse = resp.httpResponse;
	    var data = new AWS.XML.Parser().parse(httpResponse.body.toString() || '');
	    if (data.Errors) {
	      resp.error = AWS.util.error(new Error(), {
	        code: data.Errors.Error.Code,
	        message: data.Errors.Error.Message
	      });
	    } else {
	      resp.error = AWS.util.error(new Error(), {
	        code: httpResponse.statusCode,
	        message: null
	      });
	    }
	    resp.error.requestId = data.RequestID || null;
	  }
	});


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	/**
	 * @api private
	 */
	var blobPayloadOutputOps = [
	  'deleteThingShadow',
	  'getThingShadow',
	  'updateThingShadow'
	];
	
	/**
	 * Constructs a service interface object. Each API operation is exposed as a
	 * function on service.
	 *
	 * ### Sending a Request Using IotData
	 *
	 * ```javascript
	 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 * iotdata.getThingShadow(params, function (err, data) {
	 *   if (err) console.log(err, err.stack); // an error occurred
	 *   else     console.log(data);           // successful response
	 * });
	 * ```
	 *
	 * ### Locking the API Version
	 *
	 * In order to ensure that the IotData object uses this specific API,
	 * you can construct the object by passing the `apiVersion` option to the
	 * constructor:
	 *
	 * ```javascript
	 * var iotdata = new AWS.IotData({
	 *   endpoint: 'my.host.tld',
	 *   apiVersion: '2015-05-28'
	 * });
	 * ```
	 *
	 * You can also set the API version globally in `AWS.config.apiVersions` using
	 * the **iotdata** service identifier:
	 *
	 * ```javascript
	 * AWS.config.apiVersions = {
	 *   iotdata: '2015-05-28',
	 *   // other service API versions
	 * };
	 *
	 * var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 * ```
	 *
	 * @note You *must* provide an `endpoint` configuration parameter when
	 *   constructing this service. See {constructor} for more information.
	 *
	 * @!method constructor(options = {})
	 *   Constructs a service object. This object has one method for each
	 *   API operation.
	 *
	 *   @example Constructing a IotData object
	 *     var iotdata = new AWS.IotData({endpoint: 'my.host.tld'});
	 *   @note You *must* provide an `endpoint` when constructing this service.
	 *   @option (see AWS.Config.constructor)
	 *
	 * @service iotdata
	 * @version 2015-05-28
	 */
	AWS.util.update(AWS.IotData.prototype, {
	    /**
	     * @api private
	     */
	    validateService: function validateService() {
	        if (!this.config.endpoint || this.config.endpoint.indexOf('{') >= 0) {
	            var msg = 'AWS.IotData requires an explicit ' +
	                '`endpoint\' configuration option.';
	            throw AWS.util.error(new Error(),
	                {name: 'InvalidEndpoint', message: msg});
	        }
	    },
	
	    /**
	     * @api private
	     */
	    setupRequestListeners: function setupRequestListeners(request) {
	        request.addListener('validateResponse', this.validateResponseBody);
	        if (blobPayloadOutputOps.indexOf(request.operation) > -1) {
	            request.addListener('extractData', AWS.util.convertPayloadToString);
	        }
	    },
	
	    /**
	     * @api private
	     */
	    validateResponseBody: function validateResponseBody(resp) {
	        var body = resp.httpResponse.body.toString() || '{}';
	        var bodyCheck = body.trim();
	        if (!bodyCheck || bodyCheck.charAt(0) !== '{') {
	            resp.httpResponse.body = '';
	        }
	    }
	
	});


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	AWS.util.update(AWS.Lambda.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.operation === 'invoke') {
	      request.addListener('extractData', AWS.util.convertPayloadToString);
	    }
	  }
	});
	


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	AWS.util.update(AWS.MachineLearning.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    if (request.operation === 'predict') {
	      request.addListener('build', this.buildEndpoint);
	    }
	  },
	
	  /**
	   * Updates request endpoint from PredictEndpoint
	   * @api private
	   */
	  buildEndpoint: function buildEndpoint(request) {
	    var url = request.params.PredictEndpoint;
	    if (url) {
	      request.httpRequest.endpoint = new AWS.Endpoint(url);
	    }
	  }
	
	});


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1020);


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	__webpack_require__(1022);
	 /**
	  * @api private
	  */
	 var crossRegionOperations = ['copyDBSnapshot', 'createDBInstanceReadReplica', 'createDBCluster', 'copyDBClusterSnapshot'];
	
	 AWS.util.update(AWS.RDS.prototype, {
	   /**
	    * @api private
	    */
	   setupRequestListeners: function setupRequestListeners(request) {
	     if (crossRegionOperations.indexOf(request.operation) !== -1 &&
	         request.params.SourceRegion) {
	       request.params = AWS.util.copy(request.params);
	       if (request.params.PreSignedUrl ||
	           request.params.SourceRegion === this.config.region) {
	         delete request.params.SourceRegion;
	       } else {
	         var doesParamValidation = !!this.config.paramValidation;
	         // remove the validate parameters listener so we can re-add it after we build the URL
	         if (doesParamValidation) {
	           request.removeListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	         }
	         request.onAsync('validate', this.buildCrossRegionPresignedUrl);
	         if (doesParamValidation) {
	           request.addListener('validate', AWS.EventListeners.Core.VALIDATE_PARAMETERS);
	         }
	       }
	     }
	   },
	
	   /**
	    * @api private
	    */
	   buildCrossRegionPresignedUrl: function buildCrossRegionPresignedUrl(req, done) {
	     var config = AWS.util.copy(req.service.config);
	     config.region = req.params.SourceRegion;
	     delete req.params.SourceRegion;
	     delete config.endpoint;
	     // relevant params for the operation will already be in req.params
	     delete config.params;
	     config.signatureVersion = 'v4';
	     var destinationRegion = req.service.config.region;
	
	     var svc = new req.service.constructor(config);
	     var newReq = svc[req.operation](AWS.util.copy(req.params));
	     newReq.on('build', function addDestinationRegionParam(request) {
	       var httpRequest = request.httpRequest;
	       httpRequest.params.DestinationRegion = destinationRegion;
	       httpRequest.body = AWS.util.queryParamsToString(httpRequest.params);
	     });
	     newReq.presign(function(err, url) {
	       if (err) done(err);
	       else {
	         req.params.PreSignedUrl = url;
	         done();
	       }
	     });
	   }
	 });


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	AWS.util.update(AWS.Route53.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.on('build', this.sanitizeUrl);
	  },
	
	  /**
	   * @api private
	   */
	  sanitizeUrl: function sanitizeUrl(request) {
	    var path = request.httpRequest.path;
	    request.httpRequest.path = path.replace(/\/%2F\w+%2F/, '/');
	  },
	
	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error) {
	    if (error.code === 'PriorRequestNotComplete' &&
	        error.statusCode === 400) {
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error);
	    }
	  }
	});


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var v4Credentials = __webpack_require__(437);
	
	// Pull in managed upload extension
	__webpack_require__(1028);
	
	/**
	 * @api private
	 */
	var operationsWith200StatusCodeError = {
	  'completeMultipartUpload': true,
	  'copyObject': true,
	  'uploadPartCopy': true
	};
	
	/**
	 * @api private
	 */
	 var regionRedirectErrorCodes = [
	  'AuthorizationHeaderMalformed', // non-head operations on virtual-hosted global bucket endpoints
	  'BadRequest', // head operations on virtual-hosted global bucket endpoints
	  'PermanentRedirect', // non-head operations on path-style or regional endpoints
	  301 // head operations on path-style or regional endpoints
	 ];
	
	AWS.util.update(AWS.S3.prototype, {
	  /**
	   * @api private
	   */
	  getSignatureVersion: function getSignatureVersion(request) {
	    var defaultApiVersion = this.api.signatureVersion;
	    var userDefinedVersion = this._originalConfig ? this._originalConfig.signatureVersion : null;
	    var regionDefinedVersion = this.config.signatureVersion;
	    var isPresigned = request ? request.isPresigned() : false;
	    /*
	      1) User defined version specified:
	        a) always return user defined version
	      2) No user defined version specified:
	        a) default to lowest version the region supports
	        b) If using presigned urls, default to lowest version the region supports
	    */
	    if (userDefinedVersion) {
	      userDefinedVersion = userDefinedVersion === 'v2' ? 's3' : userDefinedVersion;
	      return userDefinedVersion;
	    }
	    if (isPresigned !== true) {
	      defaultApiVersion = 'v4';
	    } else if (regionDefinedVersion) {
	      defaultApiVersion = regionDefinedVersion;
	    }
	    return defaultApiVersion;
	  },
	
	  /**
	   * @api private
	   */
	  getSignerClass: function getSignerClass(request) {
	    var signatureVersion = this.getSignatureVersion(request);
	    return AWS.Signers.RequestSigner.getVersion(signatureVersion);
	  },
	
	  /**
	   * @api private
	   */
	  validateService: function validateService() {
	    var msg;
	    var messages = [];
	
	    // default to us-east-1 when no region is provided
	    if (!this.config.region) this.config.region = 'us-east-1';
	
	    if (!this.config.endpoint && this.config.s3BucketEndpoint) {
	      messages.push('An endpoint must be provided when configuring ' +
	                    '`s3BucketEndpoint` to true.');
	    }
	    if (messages.length === 1) {
	      msg = messages[0];
	    } else if (messages.length > 1) {
	      msg = 'Multiple configuration errors:\n' + messages.join('\n');
	    }
	    if (msg) {
	      throw AWS.util.error(new Error(),
	        {name: 'InvalidEndpoint', message: msg});
	    }
	  },
	
	  /**
	   * @api private
	   */
	  shouldDisableBodySigning: function shouldDisableBodySigning(request) {
	    var signerClass = this.getSignerClass();
	    if (this.config.s3DisableBodySigning === true && signerClass === AWS.Signers.V4
	        && request.httpRequest.endpoint.protocol === 'https:') {
	      return true;
	    }
	    return false;
	  },
	
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    var prependListener = true;
	    request.addListener('validate', this.validateScheme);
	    request.addListener('validate', this.validateBucketEndpoint);
	    request.addListener('validate', this.correctBucketRegionFromCache);
	    request.addListener('validate', this.validateBucketName, prependListener);
	
	    request.addListener('build', this.addContentType);
	    request.addListener('build', this.populateURI);
	    request.addListener('build', this.computeContentMd5);
	    request.addListener('build', this.computeSseCustomerKeyMd5);
	    request.addListener('afterBuild', this.addExpect100Continue);
	    request.removeListener('validate',
	      AWS.EventListeners.Core.VALIDATE_REGION);
	    request.addListener('extractError', this.extractError);
	    request.onAsync('extractError', this.requestBucketRegion);
	    request.addListener('extractData', this.extractData);
	    request.addListener('extractData', AWS.util.hoistPayloadMember);
	    request.addListener('beforePresign', this.prepareSignedUrl);
	    if (AWS.util.isBrowser()) {
	      request.onAsync('retry', this.reqRegionForNetworkingError);
	    }
	    if (this.shouldDisableBodySigning(request))  {
	      request.removeListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	      request.addListener('afterBuild', this.disableBodySigning);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateScheme: function(req) {
	    var params = req.params,
	        scheme = req.httpRequest.endpoint.protocol,
	        sensitive = params.SSECustomerKey || params.CopySourceSSECustomerKey;
	    if (sensitive && scheme !== 'https:') {
	      var msg = 'Cannot send SSE keys over HTTP. Set \'sslEnabled\'' +
	        'to \'true\' in your configuration';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBucketEndpoint: function(req) {
	    if (!req.params.Bucket && req.service.config.s3BucketEndpoint) {
	      var msg = 'Cannot send requests to root API with `s3BucketEndpoint` set.';
	      throw AWS.util.error(new Error(),
	        { code: 'ConfigError', message: msg });
	    }
	  },
	
	  /**
	   * @api private
	   */
	  validateBucketName: function validateBucketName(req) {
	    var service = req.service;
	    var signatureVersion = service.getSignatureVersion(req);
	    var bucket = req.params && req.params.Bucket;
	    var key = req.params && req.params.Key;
	    var slashIndex = bucket && bucket.indexOf('/');
	    if (bucket && slashIndex >= 0) {
	      if (typeof key === 'string' && slashIndex > 0) {
	        req.params = AWS.util.copy(req.params);
	        // Need to include trailing slash to match sigv2 behavior
	        var prefix = bucket.substr(slashIndex + 1) || '';
	        req.params.Key = prefix + '/' + key;
	        req.params.Bucket = bucket.substr(0, slashIndex);
	      } else if (signatureVersion === 'v4') {
	        var msg = 'Bucket names cannot contain forward slashes. Bucket: ' + bucket;
	        throw AWS.util.error(new Error(),
	          { code: 'InvalidBucket', message: msg });
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  isValidAccelerateOperation: function isValidAccelerateOperation(operation) {
	    var invalidOperations = [
	      'createBucket',
	      'deleteBucket',
	      'listBuckets'
	    ];
	    return invalidOperations.indexOf(operation) === -1;
	  },
	
	
	  /**
	   * S3 prefers dns-compatible bucket names to be moved from the uri path
	   * to the hostname as a sub-domain.  This is not possible, even for dns-compat
	   * buckets when using SSL and the bucket name contains a dot ('.').  The
	   * ssl wildcard certificate is only 1-level deep.
	   *
	   * @api private
	   */
	  populateURI: function populateURI(req) {
	    var httpRequest = req.httpRequest;
	    var b = req.params.Bucket;
	    var service = req.service;
	    var endpoint = httpRequest.endpoint;
	    if (b) {
	      if (!service.pathStyleBucketName(b)) {
	        if (service.config.useAccelerateEndpoint && service.isValidAccelerateOperation(req.operation)) {
	          if (service.config.useDualstack) {
	            endpoint.hostname = b + '.s3-accelerate.dualstack.amazonaws.com';
	          } else {
	            endpoint.hostname = b + '.s3-accelerate.amazonaws.com';
	          }
	        } else if (!service.config.s3BucketEndpoint) {
	          endpoint.hostname =
	            b + '.' + endpoint.hostname;
	        }
	
	        var port = endpoint.port;
	        if (port !== 80 && port !== 443) {
	          endpoint.host = endpoint.hostname + ':' +
	            endpoint.port;
	        } else {
	          endpoint.host = endpoint.hostname;
	        }
	
	        httpRequest.virtualHostedBucket = b; // needed for signing the request
	        service.removeVirtualHostedBucketFromPath(req);
	      }
	    }
	  },
	
	  /**
	   * Takes the bucket name out of the path if bucket is virtual-hosted
	   *
	   * @api private
	   */
	  removeVirtualHostedBucketFromPath: function removeVirtualHostedBucketFromPath(req) {
	    var httpRequest = req.httpRequest;
	    var bucket = httpRequest.virtualHostedBucket;
	    if (bucket && httpRequest.path) {
	      if (req.params && req.params.Key) {
	        var encodedS3Key = '/' + AWS.util.uriEscapePath(req.params.Key);
	        if (httpRequest.path.indexOf(encodedS3Key) === 0 && (httpRequest.path.length === encodedS3Key.length || httpRequest.path[encodedS3Key.length] === '?')) {
	          //path only contains key or path contains only key and querystring
	          return;
	        }
	      }
	      httpRequest.path = httpRequest.path.replace(new RegExp('/' + bucket), '');
	      if (httpRequest.path[0] !== '/') {
	        httpRequest.path = '/' + httpRequest.path;
	      }
	    }
	  },
	
	  /**
	   * Adds Expect: 100-continue header if payload is greater-or-equal 1MB
	   * @api private
	   */
	  addExpect100Continue: function addExpect100Continue(req) {
	    var len = req.httpRequest.headers['Content-Length'];
	    if (AWS.util.isNode() && (len >= 1024 * 1024 || req.params.Body instanceof AWS.util.stream.Stream)) {
	      req.httpRequest.headers['Expect'] = '100-continue';
	    }
	  },
	
	  /**
	   * Adds a default content type if none is supplied.
	   *
	   * @api private
	   */
	  addContentType: function addContentType(req) {
	    var httpRequest = req.httpRequest;
	    if (httpRequest.method === 'GET' || httpRequest.method === 'HEAD') {
	      // Content-Type is not set in GET/HEAD requests
	      delete httpRequest.headers['Content-Type'];
	      return;
	    }
	
	    if (!httpRequest.headers['Content-Type']) { // always have a Content-Type
	      httpRequest.headers['Content-Type'] = 'application/octet-stream';
	    }
	
	    var contentType = httpRequest.headers['Content-Type'];
	    if (AWS.util.isBrowser()) {
	      if (typeof httpRequest.body === 'string' && !contentType.match(/;\s*charset=/)) {
	        var charset = '; charset=UTF-8';
	        httpRequest.headers['Content-Type'] += charset;
	      } else {
	        var replaceFn = function(_, prefix, charsetName) {
	          return prefix + charsetName.toUpperCase();
	        };
	
	        httpRequest.headers['Content-Type'] =
	          contentType.replace(/(;\s*charset=)(.+)$/, replaceFn);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  computableChecksumOperations: {
	    putBucketCors: true,
	    putBucketLifecycle: true,
	    putBucketLifecycleConfiguration: true,
	    putBucketTagging: true,
	    deleteObjects: true,
	    putBucketReplication: true,
	    putObjectLegalHold: true,
	    putObjectRetention: true,
	    putObjectLockConfiguration: true
	  },
	
	  /**
	   * Checks whether checksums should be computed for the request.
	   * If the request requires checksums to be computed, this will always
	   * return true, otherwise it depends on whether {AWS.Config.computeChecksums}
	   * is set.
	   *
	   * @param req [AWS.Request] the request to check against
	   * @return [Boolean] whether to compute checksums for a request.
	   * @api private
	   */
	  willComputeChecksums: function willComputeChecksums(req) {
	    if (this.computableChecksumOperations[req.operation]) return true;
	    if (!this.config.computeChecksums) return false;
	
	    // TODO: compute checksums for Stream objects
	    if (!AWS.util.Buffer.isBuffer(req.httpRequest.body) &&
	        typeof req.httpRequest.body !== 'string') {
	      return false;
	    }
	
	    var rules = req.service.api.operations[req.operation].input.members;
	
	    // Sha256 signing disabled, and not a presigned url
	    if (req.service.shouldDisableBodySigning(req) && !Object.prototype.hasOwnProperty.call(req.httpRequest.headers, 'presigned-expires')) {
	      if (rules.ContentMD5 && !req.params.ContentMD5) {
	        return true;
	      }
	    }
	
	    // V4 signer uses SHA256 signatures so only compute MD5 if it is required
	    if (req.service.getSignerClass(req) === AWS.Signers.V4) {
	      if (rules.ContentMD5 && !rules.ContentMD5.required) return false;
	    }
	
	    if (rules.ContentMD5 && !req.params.ContentMD5) return true;
	  },
	
	  /**
	   * A listener that computes the Content-MD5 and sets it in the header.
	   * @see AWS.S3.willComputeChecksums
	   * @api private
	   */
	  computeContentMd5: function computeContentMd5(req) {
	    if (req.service.willComputeChecksums(req)) {
	      var md5 = AWS.util.crypto.md5(req.httpRequest.body, 'base64');
	      req.httpRequest.headers['Content-MD5'] = md5;
	    }
	  },
	
	  /**
	   * @api private
	   */
	  computeSseCustomerKeyMd5: function computeSseCustomerKeyMd5(req) {
	    var keys = {
	      SSECustomerKey: 'x-amz-server-side-encryption-customer-key-MD5',
	      CopySourceSSECustomerKey: 'x-amz-copy-source-server-side-encryption-customer-key-MD5'
	    };
	    AWS.util.each(keys, function(key, header) {
	      if (req.params[key]) {
	        var value = AWS.util.crypto.md5(req.params[key], 'base64');
	        req.httpRequest.headers[header] = value;
	      }
	    });
	  },
	
	  /**
	   * Returns true if the bucket name should be left in the URI path for
	   * a request to S3.  This function takes into account the current
	   * endpoint protocol (e.g. http or https).
	   *
	   * @api private
	   */
	  pathStyleBucketName: function pathStyleBucketName(bucketName) {
	    // user can force path style requests via the configuration
	    if (this.config.s3ForcePathStyle) return true;
	    if (this.config.s3BucketEndpoint) return false;
	
	    if (this.dnsCompatibleBucketName(bucketName)) {
	      return (this.config.sslEnabled && bucketName.match(/\./)) ? true : false;
	    } else {
	      return true; // not dns compatible names must always use path style
	    }
	  },
	
	  /**
	   * Returns true if the bucket name is DNS compatible.  Buckets created
	   * outside of the classic region MUST be DNS compatible.
	   *
	   * @api private
	   */
	  dnsCompatibleBucketName: function dnsCompatibleBucketName(bucketName) {
	    var b = bucketName;
	    var domain = new RegExp(/^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/);
	    var ipAddress = new RegExp(/(\d+\.){3}\d+/);
	    var dots = new RegExp(/\.\./);
	    return (b.match(domain) && !b.match(ipAddress) && !b.match(dots)) ? true : false;
	  },
	
	  /**
	   * @return [Boolean] whether response contains an error
	   * @api private
	   */
	  successfulResponse: function successfulResponse(resp) {
	    var req = resp.request;
	    var httpResponse = resp.httpResponse;
	    if (operationsWith200StatusCodeError[req.operation] &&
	        httpResponse.body.toString().match('<Error>')) {
	      return false;
	    } else {
	      return httpResponse.statusCode < 300;
	    }
	  },
	
	  /**
	   * @return [Boolean] whether the error can be retried
	   * @api private
	   */
	  retryableError: function retryableError(error, request) {
	    if (operationsWith200StatusCodeError[request.operation] &&
	        error.statusCode === 200) {
	      return true;
	    } else if (request._requestRegionForBucket &&
	        request.service.bucketRegionCache[request._requestRegionForBucket]) {
	      return false;
	    } else if (error && error.code === 'RequestTimeout') {
	      return true;
	    } else if (error &&
	        regionRedirectErrorCodes.indexOf(error.code) != -1 &&
	        error.region && error.region != request.httpRequest.region) {
	      request.httpRequest.region = error.region;
	      if (error.statusCode === 301) {
	        request.service.updateReqBucketRegion(request);
	      }
	      return true;
	    } else {
	      var _super = AWS.Service.prototype.retryableError;
	      return _super.call(this, error, request);
	    }
	  },
	
	  /**
	   * Updates httpRequest with region. If region is not provided, then
	   * the httpRequest will be updated based on httpRequest.region
	   *
	   * @api private
	   */
	  updateReqBucketRegion: function updateReqBucketRegion(request, region) {
	    var httpRequest = request.httpRequest;
	    if (typeof region === 'string' && region.length) {
	      httpRequest.region = region;
	    }
	    if (!httpRequest.endpoint.host.match(/s3(?!-accelerate).*\.amazonaws\.com$/)) {
	      return;
	    }
	    var service = request.service;
	    var s3Config = service.config;
	    var s3BucketEndpoint = s3Config.s3BucketEndpoint;
	    if (s3BucketEndpoint) {
	      delete s3Config.s3BucketEndpoint;
	    }
	    var newConfig = AWS.util.copy(s3Config);
	    delete newConfig.endpoint;
	    newConfig.region = httpRequest.region;
	
	    httpRequest.endpoint = (new AWS.S3(newConfig)).endpoint;
	    service.populateURI(request);
	    s3Config.s3BucketEndpoint = s3BucketEndpoint;
	    httpRequest.headers.Host = httpRequest.endpoint.host;
	
	    if (request._asm.currentState === 'validate') {
	      request.removeListener('build', service.populateURI);
	      request.addListener('build', service.removeVirtualHostedBucketFromPath);
	    }
	  },
	
	  /**
	   * Provides a specialized parser for getBucketLocation -- all other
	   * operations are parsed by the super class.
	   *
	   * @api private
	   */
	  extractData: function extractData(resp) {
	    var req = resp.request;
	    if (req.operation === 'getBucketLocation') {
	      var match = resp.httpResponse.body.toString().match(/>(.+)<\/Location/);
	      delete resp.data['_'];
	      if (match) {
	        resp.data.LocationConstraint = match[1];
	      } else {
	        resp.data.LocationConstraint = '';
	      }
	    }
	    var bucket = req.params.Bucket || null;
	    if (req.operation === 'deleteBucket' && typeof bucket === 'string' && !resp.error) {
	      req.service.clearBucketRegionCache(bucket);
	    } else {
	      var headers = resp.httpResponse.headers || {};
	      var region = headers['x-amz-bucket-region'] || null;
	      if (!region && req.operation === 'createBucket' && !resp.error) {
	        var createBucketConfiguration = req.params.CreateBucketConfiguration;
	        if (!createBucketConfiguration) {
	          region = 'us-east-1';
	        } else if (createBucketConfiguration.LocationConstraint === 'EU') {
	          region = 'eu-west-1';
	        } else {
	          region = createBucketConfiguration.LocationConstraint;
	        }
	      }
	      if (region) {
	          if (bucket && region !== req.service.bucketRegionCache[bucket]) {
	            req.service.bucketRegionCache[bucket] = region;
	          }
	      }
	    }
	    req.service.extractRequestIds(resp);
	  },
	
	  /**
	   * Extracts an error object from the http response.
	   *
	   * @api private
	   */
	  extractError: function extractError(resp) {
	    var codes = {
	      304: 'NotModified',
	      403: 'Forbidden',
	      400: 'BadRequest',
	      404: 'NotFound'
	    };
	
	    var req = resp.request;
	    var code = resp.httpResponse.statusCode;
	    var body = resp.httpResponse.body || '';
	
	    var headers = resp.httpResponse.headers || {};
	    var region = headers['x-amz-bucket-region'] || null;
	    var bucket = req.params.Bucket || null;
	    var bucketRegionCache = req.service.bucketRegionCache;
	    if (region && bucket && region !== bucketRegionCache[bucket]) {
	      bucketRegionCache[bucket] = region;
	    }
	
	    var cachedRegion;
	    if (codes[code] && body.length === 0) {
	      if (bucket && !region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }
	      resp.error = AWS.util.error(new Error(), {
	        code: codes[code],
	        message: null,
	        region: region
	      });
	    } else {
	      var data = new AWS.XML.Parser().parse(body.toString());
	
	      if (data.Region && !region) {
	        region = data.Region;
	        if (bucket && region !== bucketRegionCache[bucket]) {
	          bucketRegionCache[bucket] = region;
	        }
	      } else if (bucket && !region && !data.Region) {
	        cachedRegion = bucketRegionCache[bucket] || null;
	        if (cachedRegion !== req.httpRequest.region) {
	          region = cachedRegion;
	        }
	      }
	
	      resp.error = AWS.util.error(new Error(), {
	        code: data.Code || code,
	        message: data.Message || null,
	        region: region
	      });
	    }
	    req.service.extractRequestIds(resp);
	  },
	
	  /**
	   * If region was not obtained synchronously, then send async request
	   * to get bucket region for errors resulting from wrong region.
	   *
	   * @api private
	   */
	  requestBucketRegion: function requestBucketRegion(resp, done) {
	    var error = resp.error;
	    var req = resp.request;
	    var bucket = req.params.Bucket || null;
	
	    if (!error || !bucket || error.region || req.operation === 'listObjects' ||
	        (AWS.util.isNode() && req.operation === 'headBucket') ||
	        (error.statusCode === 400 && req.operation !== 'headObject') ||
	        regionRedirectErrorCodes.indexOf(error.code) === -1) {
	      return done();
	    }
	    var reqOperation = AWS.util.isNode() ? 'headBucket' : 'listObjects';
	    var reqParams = {Bucket: bucket};
	    if (reqOperation === 'listObjects') reqParams.MaxKeys = 0;
	    var regionReq = req.service[reqOperation](reqParams);
	    regionReq._requestRegionForBucket = bucket;
	    regionReq.send(function() {
	      var region = req.service.bucketRegionCache[bucket] || null;
	      error.region = region;
	      done();
	    });
	  },
	
	   /**
	   * For browser only. If NetworkingError received, will attempt to obtain
	   * the bucket region.
	   *
	   * @api private
	   */
	   reqRegionForNetworkingError: function reqRegionForNetworkingError(resp, done) {
	    if (!AWS.util.isBrowser()) {
	      return done();
	    }
	    var error = resp.error;
	    var request = resp.request;
	    var bucket = request.params.Bucket;
	    if (!error || error.code !== 'NetworkingError' || !bucket ||
	        request.httpRequest.region === 'us-east-1') {
	      return done();
	    }
	    var service = request.service;
	    var bucketRegionCache = service.bucketRegionCache;
	    var cachedRegion = bucketRegionCache[bucket] || null;
	
	    if (cachedRegion && cachedRegion !== request.httpRequest.region) {
	      service.updateReqBucketRegion(request, cachedRegion);
	      done();
	    } else if (!service.dnsCompatibleBucketName(bucket)) {
	      service.updateReqBucketRegion(request, 'us-east-1');
	      if (bucketRegionCache[bucket] !== 'us-east-1') {
	        bucketRegionCache[bucket] = 'us-east-1';
	      }
	      done();
	    } else if (request.httpRequest.virtualHostedBucket) {
	      var getRegionReq = service.listObjects({Bucket: bucket, MaxKeys: 0});
	      service.updateReqBucketRegion(getRegionReq, 'us-east-1');
	      getRegionReq._requestRegionForBucket = bucket;
	
	      getRegionReq.send(function() {
	        var region = service.bucketRegionCache[bucket] || null;
	        if (region && region !== request.httpRequest.region) {
	          service.updateReqBucketRegion(request, region);
	        }
	        done();
	      });
	    } else {
	      // DNS-compatible path-style
	      // (s3ForcePathStyle or bucket name with dot over https)
	      // Cannot obtain region information for this case
	      done();
	    }
	   },
	
	  /**
	   * Cache for bucket region.
	   *
	   * @api private
	   */
	   bucketRegionCache: {},
	
	  /**
	   * Clears bucket region cache.
	   *
	   * @api private
	   */
	   clearBucketRegionCache: function(buckets) {
	    var bucketRegionCache = this.bucketRegionCache;
	    if (!buckets) {
	      buckets = Object.keys(bucketRegionCache);
	    } else if (typeof buckets === 'string') {
	      buckets = [buckets];
	    }
	    for (var i = 0; i < buckets.length; i++) {
	      delete bucketRegionCache[buckets[i]];
	    }
	    return bucketRegionCache;
	   },
	
	   /**
	    * Corrects request region if bucket's cached region is different
	    *
	    * @api private
	    */
	  correctBucketRegionFromCache: function correctBucketRegionFromCache(req) {
	    var bucket = req.params.Bucket || null;
	    if (bucket) {
	      var service = req.service;
	      var requestRegion = req.httpRequest.region;
	      var cachedRegion = service.bucketRegionCache[bucket];
	      if (cachedRegion && cachedRegion !== requestRegion) {
	        service.updateReqBucketRegion(req, cachedRegion);
	      }
	    }
	  },
	
	  /**
	   * Extracts S3 specific request ids from the http response.
	   *
	   * @api private
	   */
	  extractRequestIds: function extractRequestIds(resp) {
	    var extendedRequestId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-id-2'] : null;
	    var cfId = resp.httpResponse.headers ? resp.httpResponse.headers['x-amz-cf-id'] : null;
	    resp.extendedRequestId = extendedRequestId;
	    resp.cfId = cfId;
	
	    if (resp.error) {
	      resp.error.requestId = resp.requestId || null;
	      resp.error.extendedRequestId = extendedRequestId;
	      resp.error.cfId = cfId;
	    }
	  },
	
	  /**
	   * Get a pre-signed URL for a given operation name.
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   * @note Not all operation parameters are supported when using pre-signed
	   *   URLs. Certain parameters, such as `SSECustomerKey`, `ACL`, `Expires`,
	   *   `ContentLength`, or `Tagging` must be provided as headers when sending a
	   *   request. If you are using pre-signed URLs to upload from a browser and
	   *   need to use these fields, see {createPresignedPost}.
	   * @note The default signer allows altering the request by adding corresponding
	   *   headers to set some parameters (e.g. Range) and these added parameters
	   *   won't be signed. You must use signatureVersion v4 to to include these
	   *   parameters in the signed portion of the URL and enforce exact matching
	   *   between headers and signed params in the URL.
	   * @note This operation cannot be used with a promise. See note above regarding
	   *   asynchronous credentials and use with a callback.
	   * @param operation [String] the name of the operation to call
	   * @param params [map] parameters to pass to the operation. See the given
	   *   operation for the expected operation parameters. In addition, you can
	   *   also pass the "Expires" parameter to inform S3 how long the URL should
	   *   work for.
	   * @option params Expires [Integer] (900) the number of seconds to expire
	   *   the pre-signed URL operation in. Defaults to 15 minutes.
	   * @param callback [Function] if a callback is provided, this function will
	   *   pass the URL as the second parameter (after the error parameter) to
	   *   the callback function.
	   * @return [String] if called synchronously (with no callback), returns the
	   *   signed URL.
	   * @return [null] nothing is returned if a callback is provided.
	   * @example Pre-signing a getObject operation (synchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url);
	   * @example Pre-signing a putObject (asynchronously)
	   *   var params = {Bucket: 'bucket', Key: 'key'};
	   *   s3.getSignedUrl('putObject', params, function (err, url) {
	   *     console.log('The URL is', url);
	   *   });
	   * @example Pre-signing a putObject operation with a specific payload
	   *   var params = {Bucket: 'bucket', Key: 'key', Body: 'body'};
	   *   var url = s3.getSignedUrl('putObject', params);
	   *   console.log('The URL is', url);
	   * @example Passing in a 1-minute expiry time for a pre-signed URL
	   *   var params = {Bucket: 'bucket', Key: 'key', Expires: 60};
	   *   var url = s3.getSignedUrl('getObject', params);
	   *   console.log('The URL is', url); // expires in 60 seconds
	   */
	  getSignedUrl: function getSignedUrl(operation, params, callback) {
	    params = AWS.util.copy(params || {});
	    var expires = params.Expires || 900;
	
	    if (typeof expires !== 'number') {
	      throw AWS.util.error(new Error(),
	        { code: 'InvalidParameterException', message: 'The expiration must be a number, received ' + typeof expires });
	    }
	
	    delete params.Expires; // we can't validate this
	    var request = this.makeRequest(operation, params);
	
	    if (callback) {
	      AWS.util.defer(function() {
	        request.presign(expires, callback);
	      });
	    } else {
	      return request.presign(expires, callback);
	    }
	  },
	
	
	  /**
	   * Get a pre-signed POST policy to support uploading to S3 directly from an
	   * HTML form.
	   *
	   * @param params [map]
	   * @option params Bucket [String]     The bucket to which the post should be
	   *                                    uploaded
	   * @option params Expires [Integer]   (3600) The number of seconds for which
	   *                                    the presigned policy should be valid.
	   * @option params Conditions [Array]  An array of conditions that must be met
	   *                                    for the presigned policy to allow the
	   *                                    upload. This can include required tags,
	   *                                    the accepted range for content lengths,
	   *                                    etc.
	   * @see http://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-HTTPPOSTConstructPolicy.html
	   * @option params Fields [map]        Fields to include in the form. All
	   *                                    values passed in as fields will be
	   *                                    signed as exact match conditions.
	   * @param callback [Function]
	   *
	   * @note All fields passed in when creating presigned post data will be signed
	   *   as exact match conditions. Any fields that will be interpolated by S3
	   *   must be added to the fields hash after signing, and an appropriate
	   *   condition for such fields must be explicitly added to the Conditions
	   *   array passed to this function before signing.
	   *
	   * @example Presiging post data with a known key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Fields: {
	   *       key: 'key'
	   *     }
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @example Presigning post data with an interpolated key
	   *   var params = {
	   *     Bucket: 'bucket',
	   *     Conditions: [
	   *       ['starts-with', '$key', 'path/to/uploads/']
	   *     ]
	   *   };
	   *   s3.createPresignedPost(params, function(err, data) {
	   *     if (err) {
	   *       console.error('Presigning post data encountered an error', err);
	   *     } else {
	   *       data.Fields.key = 'path/to/uploads/${filename}';
	   *       console.log('The post data is', data);
	   *     }
	   *   });
	   *
	   * @note You must ensure that you have static or previously resolved
	   *   credentials if you call this method synchronously (with no callback),
	   *   otherwise it may not properly sign the request. If you cannot guarantee
	   *   this (you are using an asynchronous credential provider, i.e., EC2
	   *   IAM roles), you should always call this method with an asynchronous
	   *   callback.
	   *
	   * @return [map]  If called synchronously (with no callback), returns a hash
	   *                with the url to set as the form action and a hash of fields
	   *                to include in the form.
	   * @return [null] Nothing is returned if a callback is provided.
	   *
	   * @callback callback function (err, data)
	   *  @param err [Error] the error object returned from the policy signer
	   *  @param data [map] The data necessary to construct an HTML form
	   *  @param data.url [String] The URL to use as the action of the form
	   *  @param data.fields [map] A hash of fields that must be included in the
	   *                           form for the upload to succeed. This hash will
	   *                           include the signed POST policy, your access key
	   *                           ID and security token (if present), etc. These
	   *                           may be safely included as input elements of type
	   *                           'hidden.'
	   */
	  createPresignedPost: function createPresignedPost(params, callback) {
	    if (typeof params === 'function' && callback === undefined) {
	      callback = params;
	      params = null;
	    }
	
	    params = AWS.util.copy(params || {});
	    var boundParams = this.config.params || {};
	    var bucket = params.Bucket || boundParams.Bucket,
	      self = this,
	      config = this.config,
	      endpoint = AWS.util.copy(this.endpoint);
	    if (!config.s3BucketEndpoint) {
	      endpoint.pathname = '/' + bucket;
	    }
	
	    function finalizePost() {
	      return {
	        url: AWS.util.urlFormat(endpoint),
	        fields: self.preparePostFields(
	          config.credentials,
	          config.region,
	          bucket,
	          params.Fields,
	          params.Conditions,
	          params.Expires
	        )
	      };
	    }
	
	    if (callback) {
	      config.getCredentials(function (err) {
	        if (err) {
	          callback(err);
	        }
	
	        callback(null, finalizePost());
	      });
	    } else {
	      return finalizePost();
	    }
	  },
	
	  /**
	   * @api private
	   */
	  preparePostFields: function preparePostFields(
	    credentials,
	    region,
	    bucket,
	    fields,
	    conditions,
	    expiresInSeconds
	  ) {
	    var now = this.getSkewCorrectedDate();
	    if (!credentials || !region || !bucket) {
	      throw new Error('Unable to create a POST object policy without a bucket,'
	        + ' region, and credentials');
	    }
	    fields = AWS.util.copy(fields || {});
	    conditions = (conditions || []).slice(0);
	    expiresInSeconds = expiresInSeconds || 3600;
	
	    var signingDate = AWS.util.date.iso8601(now).replace(/[:\-]|\.\d{3}/g, '');
	    var shortDate = signingDate.substr(0, 8);
	    var scope = v4Credentials.createScope(shortDate, region, 's3');
	    var credential = credentials.accessKeyId + '/' + scope;
	
	    fields['bucket'] = bucket;
	    fields['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256';
	    fields['X-Amz-Credential'] = credential;
	    fields['X-Amz-Date'] = signingDate;
	    if (credentials.sessionToken) {
	      fields['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	    for (var field in fields) {
	      if (fields.hasOwnProperty(field)) {
	        var condition = {};
	        condition[field] = fields[field];
	        conditions.push(condition);
	      }
	    }
	
	    fields.Policy = this.preparePostPolicy(
	      new Date(now.valueOf() + expiresInSeconds * 1000),
	      conditions
	    );
	    fields['X-Amz-Signature'] = AWS.util.crypto.hmac(
	      v4Credentials.getSigningKey(credentials, shortDate, region, 's3', true),
	      fields.Policy,
	      'hex'
	    );
	
	    return fields;
	  },
	
	  /**
	   * @api private
	   */
	  preparePostPolicy: function preparePostPolicy(expiration, conditions) {
	    return AWS.util.base64.encode(JSON.stringify({
	      expiration: AWS.util.date.iso8601(expiration),
	      conditions: conditions
	    }));
	  },
	
	  /**
	   * @api private
	   */
	  prepareSignedUrl: function prepareSignedUrl(request) {
	    request.addListener('validate', request.service.noPresignedContentLength);
	    request.removeListener('build', request.service.addContentType);
	    if (!request.params.Body) {
	      // no Content-MD5/SHA-256 if body is not provided
	      request.removeListener('build', request.service.computeContentMd5);
	    } else {
	      request.addListener('afterBuild', AWS.EventListeners.Core.COMPUTE_SHA256);
	    }
	  },
	
	  /**
	   * @api private
	   * @param request
	   */
	  disableBodySigning: function disableBodySigning(request) {
	    var headers = request.httpRequest.headers;
	    // Add the header to anything that isn't a presigned url, unless that presigned url had a body defined
	    if (!Object.prototype.hasOwnProperty.call(headers, 'presigned-expires')) {
	      headers['X-Amz-Content-Sha256'] = 'UNSIGNED-PAYLOAD';
	    }
	  },
	
	  /**
	   * @api private
	   */
	  noPresignedContentLength: function noPresignedContentLength(request) {
	    if (request.params.ContentLength !== undefined) {
	      throw AWS.util.error(new Error(), {code: 'UnexpectedParameter',
	        message: 'ContentLength is not supported in pre-signed URLs.'});
	    }
	  },
	
	  createBucket: function createBucket(params, callback) {
	    // When creating a bucket *outside* the classic region, the location
	    // constraint must be set for the bucket and it must match the endpoint.
	    // This chunk of code will set the location constraint param based
	    // on the region (when possible), but it will not override a passed-in
	    // location constraint.
	    if (typeof params === 'function' || !params) {
	      callback = callback || params;
	      params = {};
	    }
	    var hostname = this.endpoint.hostname;
	    if (hostname !== this.api.globalEndpoint && !params.CreateBucketConfiguration) {
	      params.CreateBucketConfiguration = { LocationConstraint: this.config.region };
	    }
	    return this.makeRequest('createBucket', params, callback);
	  },
	
	  /**
	   * @see AWS.S3.ManagedUpload
	   * @overload upload(params = {}, [options], [callback])
	   *   Uploads an arbitrarily sized buffer, blob, or stream, using intelligent
	   *   concurrent handling of parts if the payload is large enough. You can
	   *   configure the concurrent queue size by setting `options`. Note that this
	   *   is the only operation for which the SDK can retry requests with stream
	   *   bodies.
	   *
	   *   @param (see AWS.S3.putObject)
	   *   @option (see AWS.S3.ManagedUpload.constructor)
	   *   @return [AWS.S3.ManagedUpload] the managed upload object that can call
	   *     `send()` or track progress.
	   *   @example Uploading a stream object
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     s3.upload(params, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   *   @example Uploading a stream with concurrency of 1 and partSize of 10mb
	   *     var params = {Bucket: 'bucket', Key: 'key', Body: stream};
	   *     var options = {partSize: 10 * 1024 * 1024, queueSize: 1};
	   *     s3.upload(params, options, function(err, data) {
	   *       console.log(err, data);
	   *     });
	   * @callback callback function(err, data)
	   *   @param err [Error] an error or null if no error occurred.
	   *   @param data [map] The response data from the successful upload:
	   *   @param data.Location [String] the URL of the uploaded object
	   *   @param data.ETag [String] the ETag of the uploaded object
	   *   @param data.Bucket [String]  the bucket to which the object was uploaded
	   *   @param data.Key [String] the key to which the object was uploaded
	   */
	  upload: function upload(params, options, callback) {
	    if (typeof options === 'function' && callback === undefined) {
	      callback = options;
	      options = null;
	    }
	
	    options = options || {};
	    options = AWS.util.merge(options || {}, {service: this, params: params});
	
	    var uploader = new AWS.S3.ManagedUpload(options);
	    if (typeof callback === 'function') uploader.send(callback);
	    return uploader;
	  }
	});


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	AWS.util.update(AWS.SQS.prototype, {
	  /**
	   * @api private
	   */
	  setupRequestListeners: function setupRequestListeners(request) {
	    request.addListener('build', this.buildEndpoint);
	
	    if (request.service.config.computeChecksums) {
	      if (request.operation === 'sendMessage') {
	        request.addListener('extractData', this.verifySendMessageChecksum);
	      } else if (request.operation === 'sendMessageBatch') {
	        request.addListener('extractData', this.verifySendMessageBatchChecksum);
	      } else if (request.operation === 'receiveMessage') {
	        request.addListener('extractData', this.verifyReceiveMessageChecksum);
	      }
	    }
	  },
	
	  /**
	   * @api private
	   */
	  verifySendMessageChecksum: function verifySendMessageChecksum(response) {
	    if (!response.data) return;
	
	    var md5 = response.data.MD5OfMessageBody;
	    var body = this.params.MessageBody;
	    var calculatedMd5 = this.service.calculateChecksum(body);
	    if (calculatedMd5 !== md5) {
	      var msg = 'Got "' + response.data.MD5OfMessageBody +
	        '", expecting "' + calculatedMd5 + '".';
	      this.service.throwInvalidChecksumError(response,
	        [response.data.MessageId], msg);
	    }
	  },
	
	  /**
	   * @api private
	   */
	  verifySendMessageBatchChecksum: function verifySendMessageBatchChecksum(response) {
	    if (!response.data) return;
	
	    var service = this.service;
	    var entries = {};
	    var errors = [];
	    var messageIds = [];
	    AWS.util.arrayEach(response.data.Successful, function (entry) {
	      entries[entry.Id] = entry;
	    });
	    AWS.util.arrayEach(this.params.Entries, function (entry) {
	      if (entries[entry.Id]) {
	        var md5 = entries[entry.Id].MD5OfMessageBody;
	        var body = entry.MessageBody;
	        if (!service.isChecksumValid(md5, body)) {
	          errors.push(entry.Id);
	          messageIds.push(entries[entry.Id].MessageId);
	        }
	      }
	    });
	
	    if (errors.length > 0) {
	      service.throwInvalidChecksumError(response, messageIds,
	        'Invalid messages: ' + errors.join(', '));
	    }
	  },
	
	  /**
	   * @api private
	   */
	  verifyReceiveMessageChecksum: function verifyReceiveMessageChecksum(response) {
	    if (!response.data) return;
	
	    var service = this.service;
	    var messageIds = [];
	    AWS.util.arrayEach(response.data.Messages, function(message) {
	      var md5 = message.MD5OfBody;
	      var body = message.Body;
	      if (!service.isChecksumValid(md5, body)) {
	        messageIds.push(message.MessageId);
	      }
	    });
	
	    if (messageIds.length > 0) {
	      service.throwInvalidChecksumError(response, messageIds,
	        'Invalid messages: ' + messageIds.join(', '));
	    }
	  },
	
	  /**
	   * @api private
	   */
	  throwInvalidChecksumError: function throwInvalidChecksumError(response, ids, message) {
	    response.error = AWS.util.error(new Error(), {
	      retryable: true,
	      code: 'InvalidChecksum',
	      messageIds: ids,
	      message: response.request.operation +
	               ' returned an invalid MD5 response. ' + message
	    });
	  },
	
	  /**
	   * @api private
	   */
	  isChecksumValid: function isChecksumValid(checksum, data) {
	    return this.calculateChecksum(data) === checksum;
	  },
	
	  /**
	   * @api private
	   */
	  calculateChecksum: function calculateChecksum(data) {
	    return AWS.util.crypto.md5(data, 'hex');
	  },
	
	  /**
	   * @api private
	   */
	  buildEndpoint: function buildEndpoint(request) {
	    var url = request.httpRequest.params.QueueUrl;
	    if (url) {
	      request.httpRequest.endpoint = new AWS.Endpoint(url);
	
	      // signature version 4 requires the region name to be set,
	      // sqs queue urls contain the region name
	      var matches = request.httpRequest.endpoint.host.match(/^sqs\.(.+?)\./);
	      if (matches) request.httpRequest.region = matches[1];
	    }
	  }
	});


/***/ },
/* 1043 */
[2523, 4],
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	function signedUrlBuilder(request) {
	  var expires = request.httpRequest.headers[expiresHeader];
	  var signerClass = request.service.getSignerClass(request);
	
	  delete request.httpRequest.headers['User-Agent'];
	  delete request.httpRequest.headers['X-Amz-User-Agent'];
	
	  if (signerClass === AWS.Signers.V4) {
	    if (expires > 604800) { // one week expiry is invalid
	      var message = 'Presigning does not support expiry time greater ' +
	                    'than a week with SigV4 signing.';
	      throw AWS.util.error(new Error(), {
	        code: 'InvalidExpiryTime', message: message, retryable: false
	      });
	    }
	    request.httpRequest.headers[expiresHeader] = expires;
	  } else if (signerClass === AWS.Signers.S3) {
	    var now = request.service ? request.service.getSkewCorrectedDate() : AWS.util.date.getDate();
	    request.httpRequest.headers[expiresHeader] = parseInt(
	      AWS.util.date.unixTimestamp(now) + expires, 10).toString();
	  } else {
	    throw AWS.util.error(new Error(), {
	      message: 'Presigning only supports S3 or SigV4 signing.',
	      code: 'UnsupportedSigner', retryable: false
	    });
	  }
	}
	
	/**
	 * @api private
	 */
	function signedUrlSigner(request) {
	  var endpoint = request.httpRequest.endpoint;
	  var parsedUrl = AWS.util.urlParse(request.httpRequest.path);
	  var queryParams = {};
	
	  if (parsedUrl.search) {
	    queryParams = AWS.util.queryStringParse(parsedUrl.search.substr(1));
	  }
	
	  var auth = request.httpRequest.headers['Authorization'].split(' ');
	  if (auth[0] === 'AWS') {
	    auth = auth[1].split(':');
	    queryParams['AWSAccessKeyId'] = auth[0];
	    queryParams['Signature'] = auth[1];
	
	    AWS.util.each(request.httpRequest.headers, function (key, value) {
	      if (key === expiresHeader) key = 'Expires';
	      if (key.indexOf('x-amz-meta-') === 0) {
	        // Delete existing, potentially not normalized key
	        delete queryParams[key];
	        key = key.toLowerCase();
	      }
	      queryParams[key] = value;
	    });
	    delete request.httpRequest.headers[expiresHeader];
	    delete queryParams['Authorization'];
	    delete queryParams['Host'];
	  } else if (auth[0] === 'AWS4-HMAC-SHA256') { // SigV4 signing
	    auth.shift();
	    var rest = auth.join(' ');
	    var signature = rest.match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
	    queryParams['X-Amz-Signature'] = signature;
	    delete queryParams['Expires'];
	  }
	
	  // build URL
	  endpoint.pathname = parsedUrl.pathname;
	  endpoint.search = AWS.util.queryParamsToString(queryParams);
	}
	
	/**
	 * @api private
	 */
	AWS.Signers.Presign = inherit({
	  /**
	   * @api private
	   */
	  sign: function sign(request, expireTime, callback) {
	    request.httpRequest.headers[expiresHeader] = expireTime || 3600;
	    request.on('build', signedUrlBuilder);
	    request.on('sign', signedUrlSigner);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.SET_CONTENT_LENGTH);
	    request.removeListener('afterBuild',
	      AWS.EventListeners.Core.COMPUTE_SHA256);
	
	    request.emit('beforePresign', [request]);
	
	    if (callback) {
	      request.build(function() {
	        if (this.response.error) callback(this.response.error);
	        else {
	          callback(null, AWS.util.urlFormat(request.httpRequest.endpoint));
	        }
	      });
	    } else {
	      request.build();
	      if (request.response.error) throw request.response.error;
	      return AWS.util.urlFormat(request.httpRequest.endpoint);
	    }
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.Presign;


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.RequestSigner = inherit({
	  constructor: function RequestSigner(request) {
	    this.request = request;
	  },
	
	  setServiceClientId: function setServiceClientId(id) {
	    this.serviceClientId = id;
	  },
	
	  getServiceClientId: function getServiceClientId() {
	    return this.serviceClientId;
	  }
	});
	
	AWS.Signers.RequestSigner.getVersion = function getVersion(version) {
	  switch (version) {
	    case 'v2': return AWS.Signers.V2;
	    case 'v3': return AWS.Signers.V3;
	    case 's3v4': return AWS.Signers.V4;
	    case 'v4': return AWS.Signers.V4;
	    case 's3': return AWS.Signers.S3;
	    case 'v3https': return AWS.Signers.V3Https;
	  }
	  throw new Error('Unknown signing version ' + version);
	};
	
	__webpack_require__(1047);
	__webpack_require__(436);
	__webpack_require__(1048);
	__webpack_require__(1049);
	__webpack_require__(1046);
	__webpack_require__(1044);


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.S3 = inherit(AWS.Signers.RequestSigner, {
	  /**
	   * When building the stringToSign, these sub resource params should be
	   * part of the canonical resource string with their NON-decoded values
	   */
	  subResources: {
	    'acl': 1,
	    'accelerate': 1,
	    'analytics': 1,
	    'cors': 1,
	    'lifecycle': 1,
	    'delete': 1,
	    'inventory': 1,
	    'location': 1,
	    'logging': 1,
	    'metrics': 1,
	    'notification': 1,
	    'partNumber': 1,
	    'policy': 1,
	    'requestPayment': 1,
	    'replication': 1,
	    'restore': 1,
	    'tagging': 1,
	    'torrent': 1,
	    'uploadId': 1,
	    'uploads': 1,
	    'versionId': 1,
	    'versioning': 1,
	    'versions': 1,
	    'website': 1
	  },
	
	  // when building the stringToSign, these querystring params should be
	  // part of the canonical resource string with their NON-encoded values
	  responseHeaders: {
	    'response-content-type': 1,
	    'response-content-language': 1,
	    'response-expires': 1,
	    'response-cache-control': 1,
	    'response-content-disposition': 1,
	    'response-content-encoding': 1
	  },
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    if (!this.request.headers['presigned-expires']) {
	      this.request.headers['X-Amz-Date'] = AWS.util.date.rfc822(date);
	    }
	
	    if (credentials.sessionToken) {
	      // presigned URLs require this header to be lowercased
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	
	    var signature = this.sign(credentials.secretAccessKey, this.stringToSign());
	    var auth = 'AWS ' + credentials.accessKeyId + ':' + signature;
	
	    this.request.headers['Authorization'] = auth;
	  },
	
	  stringToSign: function stringToSign() {
	    var r = this.request;
	
	    var parts = [];
	    parts.push(r.method);
	    parts.push(r.headers['Content-MD5'] || '');
	    parts.push(r.headers['Content-Type'] || '');
	
	    // This is the "Date" header, but we use X-Amz-Date.
	    // The S3 signing mechanism requires us to pass an empty
	    // string for this Date header regardless.
	    parts.push(r.headers['presigned-expires'] || '');
	
	    var headers = this.canonicalizedAmzHeaders();
	    if (headers) parts.push(headers);
	    parts.push(this.canonicalizedResource());
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedAmzHeaders: function canonicalizedAmzHeaders() {
	
	    var amzHeaders = [];
	
	    AWS.util.each(this.request.headers, function (name) {
	      if (name.match(/^x-amz-/i))
	        amzHeaders.push(name);
	    });
	
	    amzHeaders.sort(function (a, b) {
	      return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
	    });
	
	    var parts = [];
	    AWS.util.arrayEach.call(this, amzHeaders, function (name) {
	      parts.push(name.toLowerCase() + ':' + String(this.request.headers[name]));
	    });
	
	    return parts.join('\n');
	
	  },
	
	  canonicalizedResource: function canonicalizedResource() {
	
	    var r = this.request;
	
	    var parts = r.path.split('?');
	    var path = parts[0];
	    var querystring = parts[1];
	
	    var resource = '';
	
	    if (r.virtualHostedBucket)
	      resource += '/' + r.virtualHostedBucket;
	
	    resource += path;
	
	    if (querystring) {
	
	      // collect a list of sub resources and query params that need to be signed
	      var resources = [];
	
	      AWS.util.arrayEach.call(this, querystring.split('&'), function (param) {
	        var name = param.split('=')[0];
	        var value = param.split('=')[1];
	        if (this.subResources[name] || this.responseHeaders[name]) {
	          var subresource = { name: name };
	          if (value !== undefined) {
	            if (this.subResources[name]) {
	              subresource.value = value;
	            } else {
	              subresource.value = decodeURIComponent(value);
	            }
	          }
	          resources.push(subresource);
	        }
	      });
	
	      resources.sort(function (a, b) { return a.name < b.name ? -1 : 1; });
	
	      if (resources.length) {
	
	        querystring = [];
	        AWS.util.arrayEach(resources, function (res) {
	          if (res.value === undefined) {
	            querystring.push(res.name);
	          } else {
	            querystring.push(res.name + '=' + res.value);
	          }
	        });
	
	        resource += '?' + querystring.join('&');
	      }
	
	    }
	
	    return resource;
	
	  },
	
	  sign: function sign(secret, string) {
	    return AWS.util.crypto.hmac(secret, string, 'base64', 'sha1');
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.S3;


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	AWS.Signers.V2 = inherit(AWS.Signers.RequestSigner, {
	  addAuthorization: function addAuthorization(credentials, date) {
	
	    if (!date) date = AWS.util.date.getDate();
	
	    var r = this.request;
	
	    r.params.Timestamp = AWS.util.date.iso8601(date);
	    r.params.SignatureVersion = '2';
	    r.params.SignatureMethod = 'HmacSHA256';
	    r.params.AWSAccessKeyId = credentials.accessKeyId;
	
	    if (credentials.sessionToken) {
	      r.params.SecurityToken = credentials.sessionToken;
	    }
	
	    delete r.params.Signature; // delete old Signature for re-signing
	    r.params.Signature = this.signature(credentials);
	
	    r.body = AWS.util.queryParamsToString(r.params);
	    r.headers['Content-Length'] = r.body.length;
	  },
	
	  signature: function signature(credentials) {
	    return AWS.util.crypto.hmac(credentials.secretAccessKey, this.stringToSign(), 'base64');
	  },
	
	  stringToSign: function stringToSign() {
	    var parts = [];
	    parts.push(this.request.method);
	    parts.push(this.request.endpoint.host.toLowerCase());
	    parts.push(this.request.pathname());
	    parts.push(AWS.util.queryParamsToString(this.request.params));
	    return parts.join('\n');
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V2;


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var inherit = AWS.util.inherit;
	
	__webpack_require__(436);
	
	/**
	 * @api private
	 */
	AWS.Signers.V3Https = inherit(AWS.Signers.V3, {
	  authorization: function authorization(credentials) {
	    return 'AWS3-HTTPS ' +
	      'AWSAccessKeyId=' + credentials.accessKeyId + ',' +
	      'Algorithm=HmacSHA256,' +
	      'Signature=' + this.signature(credentials);
	  },
	
	  stringToSign: function stringToSign() {
	    return this.request.headers['X-Amz-Date'];
	  }
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V3Https;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	var AWS = __webpack_require__(4);
	var v4Credentials = __webpack_require__(437);
	var inherit = AWS.util.inherit;
	
	/**
	 * @api private
	 */
	var expiresHeader = 'presigned-expires';
	
	/**
	 * @api private
	 */
	AWS.Signers.V4 = inherit(AWS.Signers.RequestSigner, {
	  constructor: function V4(request, serviceName, options) {
	    AWS.Signers.RequestSigner.call(this, request);
	    this.serviceName = serviceName;
	    options = options || {};
	    this.signatureCache = typeof options.signatureCache === 'boolean' ? options.signatureCache : true;
	    this.operation = options.operation;
	    this.signatureVersion = options.signatureVersion;
	  },
	
	  algorithm: 'AWS4-HMAC-SHA256',
	
	  addAuthorization: function addAuthorization(credentials, date) {
	    var datetime = AWS.util.date.iso8601(date).replace(/[:\-]|\.\d{3}/g, '');
	
	    if (this.isPresigned()) {
	      this.updateForPresigned(credentials, datetime);
	    } else {
	      this.addHeaders(credentials, datetime);
	    }
	
	    this.request.headers['Authorization'] =
	      this.authorization(credentials, datetime);
	  },
	
	  addHeaders: function addHeaders(credentials, datetime) {
	    this.request.headers['X-Amz-Date'] = datetime;
	    if (credentials.sessionToken) {
	      this.request.headers['x-amz-security-token'] = credentials.sessionToken;
	    }
	  },
	
	  updateForPresigned: function updateForPresigned(credentials, datetime) {
	    var credString = this.credentialString(datetime);
	    var qs = {
	      'X-Amz-Date': datetime,
	      'X-Amz-Algorithm': this.algorithm,
	      'X-Amz-Credential': credentials.accessKeyId + '/' + credString,
	      'X-Amz-Expires': this.request.headers[expiresHeader],
	      'X-Amz-SignedHeaders': this.signedHeaders()
	    };
	
	    if (credentials.sessionToken) {
	      qs['X-Amz-Security-Token'] = credentials.sessionToken;
	    }
	
	    if (this.request.headers['Content-Type']) {
	      qs['Content-Type'] = this.request.headers['Content-Type'];
	    }
	    if (this.request.headers['Content-MD5']) {
	      qs['Content-MD5'] = this.request.headers['Content-MD5'];
	    }
	    if (this.request.headers['Cache-Control']) {
	      qs['Cache-Control'] = this.request.headers['Cache-Control'];
	    }
	
	    // need to pull in any other X-Amz-* headers
	    AWS.util.each.call(this, this.request.headers, function(key, value) {
	      if (key === expiresHeader) return;
	      if (this.isSignableHeader(key)) {
	        var lowerKey = key.toLowerCase();
	        // Metadata should be normalized
	        if (lowerKey.indexOf('x-amz-meta-') === 0) {
	          qs[lowerKey] = value;
	        } else if (lowerKey.indexOf('x-amz-') === 0) {
	          qs[key] = value;
	        }
	      }
	    });
	
	    var sep = this.request.path.indexOf('?') >= 0 ? '&' : '?';
	    this.request.path += sep + AWS.util.queryParamsToString(qs);
	  },
	
	  authorization: function authorization(credentials, datetime) {
	    var parts = [];
	    var credString = this.credentialString(datetime);
	    parts.push(this.algorithm + ' Credential=' +
	      credentials.accessKeyId + '/' + credString);
	    parts.push('SignedHeaders=' + this.signedHeaders());
	    parts.push('Signature=' + this.signature(credentials, datetime));
	    return parts.join(', ');
	  },
	
	  signature: function signature(credentials, datetime) {
	    var signingKey = v4Credentials.getSigningKey(
	      credentials,
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName,
	      this.signatureCache
	    );
	    return AWS.util.crypto.hmac(signingKey, this.stringToSign(datetime), 'hex');
	  },
	
	  stringToSign: function stringToSign(datetime) {
	    var parts = [];
	    parts.push('AWS4-HMAC-SHA256');
	    parts.push(datetime);
	    parts.push(this.credentialString(datetime));
	    parts.push(this.hexEncodedHash(this.canonicalString()));
	    return parts.join('\n');
	  },
	
	  canonicalString: function canonicalString() {
	    var parts = [], pathname = this.request.pathname();
	    if (this.serviceName !== 's3' && this.signatureVersion !== 's3v4') pathname = AWS.util.uriEscapePath(pathname);
	
	    parts.push(this.request.method);
	    parts.push(pathname);
	    parts.push(this.request.search());
	    parts.push(this.canonicalHeaders() + '\n');
	    parts.push(this.signedHeaders());
	    parts.push(this.hexEncodedBodyHash());
	    return parts.join('\n');
	  },
	
	  canonicalHeaders: function canonicalHeaders() {
	    var headers = [];
	    AWS.util.each.call(this, this.request.headers, function (key, item) {
	      headers.push([key, item]);
	    });
	    headers.sort(function (a, b) {
	      return a[0].toLowerCase() < b[0].toLowerCase() ? -1 : 1;
	    });
	    var parts = [];
	    AWS.util.arrayEach.call(this, headers, function (item) {
	      var key = item[0].toLowerCase();
	      if (this.isSignableHeader(key)) {
	        var value = item[1];
	        if (typeof value === 'undefined' || value === null || typeof value.toString !== 'function') {
	          throw AWS.util.error(new Error('Header ' + key + ' contains invalid value'), {
	            code: 'InvalidHeader'
	          });
	        }
	        parts.push(key + ':' +
	          this.canonicalHeaderValues(value.toString()));
	      }
	    });
	    return parts.join('\n');
	  },
	
	  canonicalHeaderValues: function canonicalHeaderValues(values) {
	    return values.replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
	  },
	
	  signedHeaders: function signedHeaders() {
	    var keys = [];
	    AWS.util.each.call(this, this.request.headers, function (key) {
	      key = key.toLowerCase();
	      if (this.isSignableHeader(key)) keys.push(key);
	    });
	    return keys.sort().join(';');
	  },
	
	  credentialString: function credentialString(datetime) {
	    return v4Credentials.createScope(
	      datetime.substr(0, 8),
	      this.request.region,
	      this.serviceName
	    );
	  },
	
	  hexEncodedHash: function hash(string) {
	    return AWS.util.crypto.sha256(string, 'hex');
	  },
	
	  hexEncodedBodyHash: function hexEncodedBodyHash() {
	    var request = this.request;
	    if (this.isPresigned() && this.serviceName === 's3' && !request.body) {
	      return 'UNSIGNED-PAYLOAD';
	    } else if (request.headers['X-Amz-Content-Sha256']) {
	      return request.headers['X-Amz-Content-Sha256'];
	    } else {
	      return this.hexEncodedHash(this.request.body || '');
	    }
	  },
	
	  unsignableHeaders: [
	    'authorization',
	    'content-type',
	    'content-length',
	    'user-agent',
	    expiresHeader,
	    'expect',
	    'x-amzn-trace-id'
	  ],
	
	  isSignableHeader: function isSignableHeader(key) {
	    if (key.toLowerCase().indexOf('x-amz-') === 0) return true;
	    return this.unsignableHeaders.indexOf(key) < 0;
	  },
	
	  isPresigned: function isPresigned() {
	    return this.request.headers[expiresHeader] ? true : false;
	  }
	
	});
	
	/**
	 * @api private
	 */
	module.exports = AWS.Signers.V4;


/***/ },
/* 1050 */
/***/ function(module, exports) {

	function AcceptorStateMachine(states, state) {
	  this.currentState = state || null;
	  this.states = states || {};
	}
	
	AcceptorStateMachine.prototype.runTo = function runTo(finalState, done, bindObject, inputError) {
	  if (typeof finalState === 'function') {
	    inputError = bindObject; bindObject = done;
	    done = finalState; finalState = null;
	  }
	
	  var self = this;
	  var state = self.states[self.currentState];
	  state.fn.call(bindObject || self, inputError, function(err) {
	    if (err) {
	      if (state.fail) self.currentState = state.fail;
	      else return done ? done.call(bindObject, err) : null;
	    } else {
	      if (state.accept) self.currentState = state.accept;
	      else return done ? done.call(bindObject) : null;
	    }
	    if (self.currentState === finalState) {
	      return done ? done.call(bindObject, err) : null;
	    }
	
	    self.runTo(finalState, done, bindObject, err);
	  });
	};
	
	AcceptorStateMachine.prototype.addState = function addState(name, acceptState, failState, fn) {
	  if (typeof acceptState === 'function') {
	    fn = acceptState; acceptState = null; failState = null;
	  } else if (typeof failState === 'function') {
	    fn = failState; failState = null;
	  }
	
	  if (!this.currentState) this.currentState = name;
	  this.states[name] = { accept: acceptState, fail: failState, fn: fn };
	  return this;
	};
	
	/**
	 * @api private
	 */
	module.exports = AcceptorStateMachine;


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	var Shape = __webpack_require__(157);
	
	function DomXmlParser() { }
	
	DomXmlParser.prototype.parse = function(xml, shape) {
	  if (xml.replace(/^\s+/, '') === '') return {};
	
	  var result, error;
	  try {
	    if (window.DOMParser) {
	      try {
	        var parser = new DOMParser();
	        result = parser.parseFromString(xml, 'text/xml');
	      } catch (syntaxError) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            originalError: syntaxError,
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      if (result.documentElement === null) {
	        throw util.error(new Error('Cannot parse empty document.'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	
	      var isError = result.getElementsByTagName('parsererror')[0];
	      if (isError && (isError.parentNode === result ||
	          isError.parentNode.nodeName === 'body' ||
	          isError.parentNode.parentNode === result ||
	          isError.parentNode.parentNode.nodeName === 'body')) {
	        var errorElement = isError.getElementsByTagName('div')[0] || isError;
	        throw util.error(new Error(errorElement.textContent || 'Parser error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else if (window.ActiveXObject) {
	      result = new window.ActiveXObject('Microsoft.XMLDOM');
	      result.async = false;
	
	      if (!result.loadXML(xml)) {
	        throw util.error(new Error('Parse error in document'),
	          {
	            code: 'XMLParserError',
	            retryable: true
	          });
	      }
	    } else {
	      throw new Error('Cannot load XML parser');
	    }
	  } catch (e) {
	    error = e;
	  }
	
	  if (result && result.documentElement && !error) {
	    var data = parseXml(result.documentElement, shape);
	    var metadata = getElementByTagName(result.documentElement, 'ResponseMetadata');
	    if (metadata) {
	      data.ResponseMetadata = parseXml(metadata, {});
	    }
	    return data;
	  } else if (error) {
	    throw util.error(error || new Error(), {code: 'XMLParserError', retryable: true});
	  } else { // empty xml document
	    return {};
	  }
	};
	
	function getElementByTagName(xml, tag) {
	  var elements = xml.getElementsByTagName(tag);
	  for (var i = 0, iLen = elements.length; i < iLen; i++) {
	    if (elements[i].parentNode === xml) {
	      return elements[i];
	    }
	  }
	}
	
	function parseXml(xml, shape) {
	  if (!shape) shape = {};
	  switch (shape.type) {
	    case 'structure': return parseStructure(xml, shape);
	    case 'map': return parseMap(xml, shape);
	    case 'list': return parseList(xml, shape);
	    case undefined: case null: return parseUnknown(xml);
	    default: return parseScalar(xml, shape);
	  }
	}
	
	function parseStructure(xml, shape) {
	  var data = {};
	  if (xml === null) return data;
	
	  util.each(shape.members, function(memberName, memberShape) {
	    if (memberShape.isXmlAttribute) {
	      if (Object.prototype.hasOwnProperty.call(xml.attributes, memberShape.name)) {
	        var value = xml.attributes[memberShape.name].value;
	        data[memberName] = parseXml({textContent: value}, memberShape);
	      }
	    } else {
	      var xmlChild = memberShape.flattened ? xml :
	        getElementByTagName(xml, memberShape.name);
	      if (xmlChild) {
	        data[memberName] = parseXml(xmlChild, memberShape);
	      } else if (!memberShape.flattened && memberShape.type === 'list') {
	        data[memberName] = memberShape.defaultValue;
	      }
	    }
	  });
	
	  return data;
	}
	
	function parseMap(xml, shape) {
	  var data = {};
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	  var tagName = shape.flattened ? shape.name : 'entry';
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      var key = getElementByTagName(child, xmlKey).textContent;
	      var value = getElementByTagName(child, xmlValue);
	      data[key] = parseXml(value, shape.value);
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseList(xml, shape) {
	  var data = [];
	  var tagName = shape.flattened ? shape.name : (shape.member.name || 'member');
	
	  var child = xml.firstElementChild;
	  while (child) {
	    if (child.nodeName === tagName) {
	      data.push(parseXml(child, shape.member));
	    }
	    child = child.nextElementSibling;
	  }
	  return data;
	}
	
	function parseScalar(xml, shape) {
	  if (xml.getAttribute) {
	    var encoding = xml.getAttribute('encoding');
	    if (encoding === 'base64') {
	      shape = new Shape.create({type: encoding});
	    }
	  }
	
	  var text = xml.textContent;
	  if (text === '') text = null;
	  if (typeof shape.toType === 'function') {
	    return shape.toType(text);
	  } else {
	    return text;
	  }
	}
	
	function parseUnknown(xml) {
	  if (xml === undefined || xml === null) return '';
	
	  // empty object
	  if (!xml.firstElementChild) {
	    if (xml.parentNode.parentNode === null) return {};
	    if (xml.childNodes.length === 0) return '';
	    else return xml.textContent;
	  }
	
	  // object, parse as structure
	  var shape = {type: 'structure', members: {}};
	  var child = xml.firstElementChild;
	  while (child) {
	    var tag = child.nodeName;
	    if (Object.prototype.hasOwnProperty.call(shape.members, tag)) {
	      // multiple tags of the same name makes it a list
	      shape.members[tag].type = 'list';
	    } else {
	      shape.members[tag] = {name: tag};
	    }
	    child = child.nextElementSibling;
	  }
	  return parseStructure(xml, shape);
	}
	
	/**
	 * @api private
	 */
	module.exports = DomXmlParser;


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(34);
	var XmlNode = __webpack_require__(1055).XmlNode;
	var XmlText = __webpack_require__(1056).XmlText;
	
	function XmlBuilder() { }
	
	XmlBuilder.prototype.toXML = function(params, shape, rootElement, noEmpty) {
	  var xml = new XmlNode(rootElement);
	  applyNamespaces(xml, shape, true);
	  serialize(xml, params, shape);
	  return xml.children.length > 0 || noEmpty ? xml.toString() : '';
	};
	
	function serialize(xml, value, shape) {
	  switch (shape.type) {
	    case 'structure': return serializeStructure(xml, value, shape);
	    case 'map': return serializeMap(xml, value, shape);
	    case 'list': return serializeList(xml, value, shape);
	    default: return serializeScalar(xml, value, shape);
	  }
	}
	
	function serializeStructure(xml, params, shape) {
	  util.arrayEach(shape.memberNames, function(memberName) {
	    var memberShape = shape.members[memberName];
	    if (memberShape.location !== 'body') return;
	
	    var value = params[memberName];
	    var name = memberShape.name;
	    if (value !== undefined && value !== null) {
	      if (memberShape.isXmlAttribute) {
	        xml.addAttribute(name, value);
	      } else if (memberShape.flattened) {
	        serialize(xml, value, memberShape);
	      } else {
	        var element = new XmlNode(name);
	        xml.addChildNode(element);
	        applyNamespaces(element, memberShape);
	        serialize(element, value, memberShape);
	      }
	    }
	  });
	}
	
	function serializeMap(xml, map, shape) {
	  var xmlKey = shape.key.name || 'key';
	  var xmlValue = shape.value.name || 'value';
	
	  util.each(map, function(key, value) {
	    var entry = new XmlNode(shape.flattened ? shape.name : 'entry');
	    xml.addChildNode(entry);
	
	    var entryKey = new XmlNode(xmlKey);
	    var entryValue = new XmlNode(xmlValue);
	    entry.addChildNode(entryKey);
	    entry.addChildNode(entryValue);
	
	    serialize(entryKey, key, shape.key);
	    serialize(entryValue, value, shape.value);
	  });
	}
	
	function serializeList(xml, list, shape) {
	  if (shape.flattened) {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || shape.name;
	      var element = new XmlNode(name);
	      xml.addChildNode(element);
	      serialize(element, value, shape.member);
	    });
	  } else {
	    util.arrayEach(list, function(value) {
	      var name = shape.member.name || 'member';
	      var element = new XmlNode(name);
	      xml.addChildNode(element);
	      serialize(element, value, shape.member);
	    });
	  }
	}
	
	function serializeScalar(xml, value, shape) {
	  xml.addChildNode(
	    new XmlText(shape.toWireFormat(value))
	  );
	}
	
	function applyNamespaces(xml, shape, isRoot) {
	  var uri, prefix = 'xmlns';
	  if (shape.xmlNamespaceUri) {
	    uri = shape.xmlNamespaceUri;
	    if (shape.xmlNamespacePrefix) prefix += ':' + shape.xmlNamespacePrefix;
	  } else if (isRoot && shape.api.xmlNamespaceUri) {
	    uri = shape.api.xmlNamespaceUri;
	  }
	
	  if (uri) xml.addAttribute(prefix, uri);
	}
	
	/**
	 * @api private
	 */
	module.exports = XmlBuilder;


/***/ },
/* 1053 */
/***/ function(module, exports) {

	/**
	 * Escapes characters that can not be in an XML attribute.
	 */
	function escapeAttribute(value) {
	    return value.replace(/&/g, '&amp;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    escapeAttribute: escapeAttribute
	};


/***/ },
/* 1054 */
/***/ function(module, exports) {

	/**
	 * Escapes characters that can not be in an XML element.
	 */
	function escapeElement(value) {
	    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
	
	/**
	 * @api private
	 */
	module.exports = {
	    escapeElement: escapeElement
	};


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	var escapeAttribute = __webpack_require__(1053).escapeAttribute;
	
	/**
	 * Represents an XML node.
	 * @api private
	 */
	function XmlNode(name, children) {
	    if (children === void 0) { children = []; }
	    this.name = name;
	    this.children = children;
	    this.attributes = {};
	}
	XmlNode.prototype.addAttribute = function (name, value) {
	    this.attributes[name] = value;
	    return this;
	};
	XmlNode.prototype.addChildNode = function (child) {
	    this.children.push(child);
	    return this;
	};
	XmlNode.prototype.removeAttribute = function (name) {
	    delete this.attributes[name];
	    return this;
	};
	XmlNode.prototype.toString = function () {
	    var hasChildren = Boolean(this.children.length);
	    var xmlText = '<' + this.name;
	    // add attributes
	    var attributes = this.attributes;
	    for (var i = 0, attributeNames = Object.keys(attributes); i < attributeNames.length; i++) {
	        var attributeName = attributeNames[i];
	        var attribute = attributes[attributeName];
	        if (typeof attribute !== 'undefined' && attribute !== null) {
	            xmlText += ' ' + attributeName + '=\"' + escapeAttribute('' + attribute) + '\"';
	        }
	    }
	    return xmlText += !hasChildren ? '/>' : '>' + this.children.map(function (c) { return c.toString(); }).join('') + '</' + this.name + '>';
	};
	
	/**
	 * @api private
	 */
	module.exports = {
	    XmlNode: XmlNode
	};


/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	var escapeElement = __webpack_require__(1054).escapeElement;
	
	/**
	 * Represents an XML text value.
	 * @api private
	 */
	function XmlText(value) {
	    this.value = value;
	}
	
	XmlText.prototype.toString = function () {
	    return escapeElement('' + this.value);
	};
	
	/**
	 * @api private
	 */
	module.exports = {
	    XmlText: XmlText
	};


/***/ },
/* 1057 */
907,
/* 1058 */
[2524, 1057],
/* 1059 */
[2525, 1060, 1061],
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(439);
	var bytesToUuid = __webpack_require__(438);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(439);
	var bytesToUuid = __webpack_require__(438);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LRU_1 = __webpack_require__(1063);
	var CACHE_SIZE = 1000;
	/**
	 * Inspired node-lru-cache[https://github.com/isaacs/node-lru-cache]
	 */
	var EndpointCache = /** @class */ (function () {
	    function EndpointCache(maxSize) {
	        if (maxSize === void 0) { maxSize = CACHE_SIZE; }
	        this.maxSize = maxSize;
	        this.cache = new LRU_1.LRUCache(maxSize);
	    }
	    ;
	    Object.defineProperty(EndpointCache.prototype, "size", {
	        get: function () {
	            return this.cache.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    EndpointCache.prototype.put = function (key, value) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        var endpointRecord = this.populateValue(value);
	        this.cache.put(keyString, endpointRecord);
	    };
	    EndpointCache.prototype.get = function (key) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        var now = Date.now();
	        var records = this.cache.get(keyString);
	        if (records) {
	            for (var i = 0; i < records.length; i++) {
	                var record = records[i];
	                if (record.Expire < now) {
	                    this.cache.remove(keyString);
	                    return undefined;
	                }
	            }
	        }
	        return records;
	    };
	    EndpointCache.getKeyString = function (key) {
	        var identifiers = [];
	        var identifierNames = Object.keys(key).sort();
	        for (var i = 0; i < identifierNames.length; i++) {
	            var identifierName = identifierNames[i];
	            if (key[identifierName] === undefined)
	                continue;
	            identifiers.push(key[identifierName]);
	        }
	        return identifiers.join(' ');
	    };
	    EndpointCache.prototype.populateValue = function (endpoints) {
	        var now = Date.now();
	        return endpoints.map(function (endpoint) { return ({
	            Address: endpoint.Address || '',
	            Expire: now + (endpoint.CachePeriodInMinutes || 1) * 60 * 1000
	        }); });
	    };
	    EndpointCache.prototype.empty = function () {
	        this.cache.empty();
	    };
	    EndpointCache.prototype.remove = function (key) {
	      var keyString = typeof key !== 'string' ? EndpointCache.getKeyString(key) : key;
	        this.cache.remove(keyString);
	    };
	    return EndpointCache;
	}());
	exports.EndpointCache = EndpointCache;

/***/ },
/* 1063 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedListNode = /** @class */ (function () {
	    function LinkedListNode(key, value) {
	        this.key = key;
	        this.value = value;
	    }
	    return LinkedListNode;
	}());
	var LRUCache = /** @class */ (function () {
	    function LRUCache(size) {
	        this.nodeMap = {};
	        this.size = 0;
	        if (typeof size !== 'number' || size < 1) {
	            throw new Error('Cache size can only be positive number');
	        }
	        this.sizeLimit = size;
	    }
	    Object.defineProperty(LRUCache.prototype, "length", {
	        get: function () {
	            return this.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    LRUCache.prototype.prependToList = function (node) {
	        if (!this.headerNode) {
	            this.tailNode = node;
	        }
	        else {
	            this.headerNode.prev = node;
	            node.next = this.headerNode;
	        }
	        this.headerNode = node;
	        this.size++;
	    };
	    LRUCache.prototype.removeFromTail = function () {
	        if (!this.tailNode) {
	            return undefined;
	        }
	        var node = this.tailNode;
	        var prevNode = node.prev;
	        if (prevNode) {
	            prevNode.next = undefined;
	        }
	        node.prev = undefined;
	        this.tailNode = prevNode;
	        this.size--;
	        return node;
	    };
	    LRUCache.prototype.detachFromList = function (node) {
	        if (this.headerNode === node) {
	            this.headerNode = node.next;
	        }
	        if (this.tailNode === node) {
	            this.tailNode = node.prev;
	        }
	        if (node.prev) {
	            node.prev.next = node.next;
	        }
	        if (node.next) {
	            node.next.prev = node.prev;
	        }
	        node.next = undefined;
	        node.prev = undefined;
	        this.size--;
	    };
	    LRUCache.prototype.get = function (key) {
	        if (this.nodeMap[key]) {
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            this.prependToList(node);
	            return node.value;
	        }
	    };
	    LRUCache.prototype.remove = function (key) {
	        if (this.nodeMap[key]) {
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            delete this.nodeMap[key];
	        }
	    };
	    LRUCache.prototype.put = function (key, value) {
	        if (this.nodeMap[key]) {
	            this.remove(key);
	        }
	        else if (this.size === this.sizeLimit) {
	            var tailNode = this.removeFromTail();
	            var key_1 = tailNode.key;
	            delete this.nodeMap[key_1];
	        }
	        var newNode = new LinkedListNode(key, value);
	        this.nodeMap[key] = newNode;
	        this.prependToList(newNode);
	    };
	    LRUCache.prototype.empty = function () {
	        var keys = Object.keys(this.nodeMap);
	        for (var i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            var node = this.nodeMap[key];
	            this.detachFromList(node);
	            delete this.nodeMap[key];
	        }
	    };
	    return LRUCache;
	}());
	exports.LRUCache = LRUCache;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (initialState, handlers) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if ((0, _ramda.has)(action.type, handlers)) {
	      return handlers[action.type](state, action);
	    }
	    return state;
	  };
	};
	
	var _ramda = __webpack_require__(167);

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Banner = __webpack_require__(193);
	
	Object.defineProperty(exports, 'banner', {
	  enumerable: true,
	  get: function get() {
	    return _Banner.banner;
	  }
	});
	
	var _Register = __webpack_require__(482);
	
	Object.defineProperty(exports, 'register', {
	  enumerable: true,
	  get: function get() {
	    return _Register.register;
	  }
	});
	
	var _Session = __webpack_require__(285);
	
	Object.defineProperty(exports, 'session', {
	  enumerable: true,
	  get: function get() {
	    return _Session.session;
	  }
	});
	
	var _ForgotPassword = __webpack_require__(477);
	
	Object.defineProperty(exports, 'forgot', {
	  enumerable: true,
	  get: function get() {
	    return _ForgotPassword.forgot;
	  }
	});
	
	var _redux = __webpack_require__(457);
	
	Object.defineProperty(exports, 'createSAProfile', {
	  enumerable: true,
	  get: function get() {
	    return _redux.createSAProfile;
	  }
	});
	
	var _redux2 = __webpack_require__(111);
	
	Object.defineProperty(exports, 'SAProfilePage', {
	  enumerable: true,
	  get: function get() {
	    return _redux2.SAProfilePage;
	  }
	});
	
	var _redux3 = __webpack_require__(483);
	
	Object.defineProperty(exports, 'settingStore', {
	  enumerable: true,
	  get: function get() {
	    return _redux3.settingStore;
	  }
	});
	
	var _redux4 = __webpack_require__(1305);
	
	Object.defineProperty(exports, 'coachProfileView', {
	  enumerable: true,
	  get: function get() {
	    return _redux4.coachProfileView;
	  }
	});
	
	var _redux5 = __webpack_require__(449);
	
	Object.defineProperty(exports, 'coachRegistration', {
	  enumerable: true,
	  get: function get() {
	    return _redux5.coachRegistration;
	  }
	});
	
	var _redux6 = __webpack_require__(462);
	
	Object.defineProperty(exports, 'postingsStore', {
	  enumerable: true,
	  get: function get() {
	    return _redux6.postingsStore;
	  }
	});
	
	var _redux7 = __webpack_require__(453);
	
	Object.defineProperty(exports, 'dashboard', {
	  enumerable: true,
	  get: function get() {
	    return _redux7.dashboard;
	  }
	});
	
	var _redux8 = __webpack_require__(476);
	
	Object.defineProperty(exports, 'coachDashboard', {
	  enumerable: true,
	  get: function get() {
	    return _redux8.coachDashboard;
	  }
	});
	
	var _redux9 = __webpack_require__(480);
	
	Object.defineProperty(exports, 'payment', {
	  enumerable: true,
	  get: function get() {
	    return _redux9.payment;
	  }
	});
	
	var _redux10 = __webpack_require__(471);
	
	Object.defineProperty(exports, 'AthleteById', {
	  enumerable: true,
	  get: function get() {
	    return _redux10.AthleteById;
	  }
	});
	
	var _redux11 = __webpack_require__(474);
	
	Object.defineProperty(exports, 'CoachAthleteView', {
	  enumerable: true,
	  get: function get() {
	    return _redux11.CoachAthleteView;
	  }
	});
	
	var _redux12 = __webpack_require__(470);
	
	Object.defineProperty(exports, 'admin', {
	  enumerable: true,
	  get: function get() {
	    return _redux12.admin;
	  }
	});
	
	var _redux13 = __webpack_require__(485);
	
	Object.defineProperty(exports, 'verifyCoach', {
	  enumerable: true,
	  get: function get() {
	    return _redux13.verifyCoach;
	  }
	});
	
	var _redux14 = __webpack_require__(481);
	
	Object.defineProperty(exports, 'publicAthlete', {
	  enumerable: true,
	  get: function get() {
	    return _redux14.publicAthlete;
	  }
	});

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(1067);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _routes2.default;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _Login = __webpack_require__(1320);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Admin = __webpack_require__(1290);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	var _AdminLogin = __webpack_require__(1292);
	
	var _AdminLogin2 = _interopRequireDefault(_AdminLogin);
	
	var _VerifyCoach = __webpack_require__(1354);
	
	var _VerifyCoach2 = _interopRequireDefault(_VerifyCoach);
	
	var _Home = __webpack_require__(1316);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _About = __webpack_require__(1258);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Dashboard = __webpack_require__(1311);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _OurResults = __webpack_require__(1322);
	
	var _OurResults2 = _interopRequireDefault(_OurResults);
	
	var _Contact = __webpack_require__(1307);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _Sports = __webpack_require__(1349);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	var _Register = __webpack_require__(1342);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _Athelete = __webpack_require__(1294);
	
	var _Athelete2 = _interopRequireDefault(_Athelete);
	
	var _Profile = __webpack_require__(1334);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _ProfileView = __webpack_require__(1332);
	
	var _ProfileView2 = _interopRequireDefault(_ProfileView);
	
	var _ForgotPassword = __webpack_require__(1314);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _Settings = __webpack_require__(1347);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _CoachRegister = __webpack_require__(1299);
	
	var _CoachRegister2 = _interopRequireDefault(_CoachRegister);
	
	var _DashBoardCoach = __webpack_require__(1309);
	
	var _DashBoardCoach2 = _interopRequireDefault(_DashBoardCoach);
	
	var _Packages = __webpack_require__(1324);
	
	var _Packages2 = _interopRequireDefault(_Packages);
	
	var _Payment = __webpack_require__(1329);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _Redirect = __webpack_require__(1339);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _AthleteById = __webpack_require__(1297);
	
	var _AthleteById2 = _interopRequireDefault(_AthleteById);
	
	var _CoachAthleteView = __webpack_require__(1303);
	
	var _CoachAthleteView2 = _interopRequireDefault(_CoachAthleteView);
	
	var _Coach = __webpack_require__(1301);
	
	var _Coach2 = _interopRequireDefault(_Coach);
	
	var _Parents = __webpack_require__(1326);
	
	var _Parents2 = _interopRequireDefault(_Parents);
	
	var _RegisterParent = __webpack_require__(1344);
	
	var _RegisterParent2 = _interopRequireDefault(_RegisterParent);
	
	var _Terms = __webpack_require__(1351);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	var _PublicAthletePage = __webpack_require__(1337);
	
	var _PublicAthletePage2 = _interopRequireDefault(_PublicAthletePage);
	
	var _routeNames = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = _react2.default.createElement(
	  _reactRouterDom.Switch,
	  null,
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _Home2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.About, component: _About2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { path: _routeNames.Dashboard, component: _Dashboard2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Contact, component: _Contact2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Sports, component: _Sports2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.OurResults, component: _OurResults2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Login, component: _Login2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Register, component: _Register2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Athlete, component: _Athelete2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Athlete + '/:id', component: _AthleteById2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.AthleteCoachView + '/:id', component: _CoachAthleteView2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.RegisterAthlete, component: _Profile2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.ViewAthlete, component: _ProfileView2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.ViewAthleteById, component: _ProfileView2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Forgot, component: _ForgotPassword2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Settings, component: _Settings2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.CoachRegister, component: _CoachRegister2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.CoachDashboard, component: _DashBoardCoach2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Pricing, component: _Packages2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Payment, component: _Payment2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.RedirectPage, component: _Redirect2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Parent, component: _Parents2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Coach, component: _Coach2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.RegisterParent, component: _RegisterParent2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.AdminLogin, component: _AdminLogin2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.VerifyCoach, component: _VerifyCoach2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.AdminBase, component: _Admin2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.Terms, component: _Terms2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.AthleteForCoach + '/:id', component: _AthleteById2.default }),
	  _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: _routeNames.PublicAthlete, component: _PublicAthletePage2.default })
	);
	
	exports.default = routes;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _services = __webpack_require__(1069);
	
	Object.defineProperty(exports, 'searchUser', {
	    enumerable: true,
	    get: function get() {
	        return _services.searchUser;
	    }
	});
	Object.defineProperty(exports, 'getCoachApplications', {
	    enumerable: true,
	    get: function get() {
	        return _services.getCoachApplications;
	    }
	});
	Object.defineProperty(exports, 'updateCoachApplication', {
	    enumerable: true,
	    get: function get() {
	        return _services.updateCoachApplication;
	    }
	});
	Object.defineProperty(exports, 'upgradeStudent', {
	    enumerable: true,
	    get: function get() {
	        return _services.upgradeStudent;
	    }
	});
	Object.defineProperty(exports, 'overrideStudent', {
	    enumerable: true,
	    get: function get() {
	        return _services.overrideStudent;
	    }
	});
	Object.defineProperty(exports, 'evaluateStudent', {
	    enumerable: true,
	    get: function get() {
	        return _services.evaluateStudent;
	    }
	});
	Object.defineProperty(exports, 'modifyCollege', {
	    enumerable: true,
	    get: function get() {
	        return _services.modifyCollege;
	    }
	});
	Object.defineProperty(exports, 'deleteCoach', {
	    enumerable: true,
	    get: function get() {
	        return _services.deleteCoach;
	    }
	});
	Object.defineProperty(exports, 'addCoach', {
	    enumerable: true,
	    get: function get() {
	        return _services.addCoach;
	    }
	});
	Object.defineProperty(exports, 'getCoachesFromColleges', {
	    enumerable: true,
	    get: function get() {
	        return _services.getCoachesFromColleges;
	    }
	});
	Object.defineProperty(exports, 'addCollegeToDB', {
	    enumerable: true,
	    get: function get() {
	        return _services.addCollegeToDB;
	    }
	});
	Object.defineProperty(exports, 'getStudentForStudentExplorer', {
	    enumerable: true,
	    get: function get() {
	        return _services.getStudentForStudentExplorer;
	    }
	});
	Object.defineProperty(exports, 'deleteCoachApplication', {
	    enumerable: true,
	    get: function get() {
	        return _services.deleteCoachApplication;
	    }
	});
	Object.defineProperty(exports, 'resetStudentDashboard', {
	    enumerable: true,
	    get: function get() {
	        return _services.resetStudentDashboard;
	    }
	});

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.searchUser = searchUser;
	exports.getCoachApplications = getCoachApplications;
	exports.updateCoachApplication = updateCoachApplication;
	exports.upgradeStudent = upgradeStudent;
	exports.overrideStudent = overrideStudent;
	exports.evaluateStudent = evaluateStudent;
	exports.deleteCoach = deleteCoach;
	exports.addCoach = addCoach;
	exports.modifyCollege = modifyCollege;
	exports.getCoachesFromColleges = getCoachesFromColleges;
	exports.addCollegeToDB = addCollegeToDB;
	exports.getStudentForStudentExplorer = getStudentForStudentExplorer;
	exports.deleteCoachApplication = deleteCoachApplication;
	exports.resetStudentDashboard = resetStudentDashboard;
	
	var _http = __webpack_require__(128);
	
	var _urls = __webpack_require__(127);
	
	function searchUser(data, role) {
	  var url = _urls.VALIDATE_COACH_FROM_DATABASE;
	  if (role === 'STUDENT') {
	    url = _urls.SEARCH_USER_ATHLETE;
	  }
	  return (0, _http.fetchJSON)(url, _http.POST, {}, data, {});
	}
	
	function getCoachApplications(id) {
	  return (0, _http.fetchJSON)(_urls.GET_COACHES_APPLICATION + id, _http.GET, {}, {}, {});
	}
	
	function updateCoachApplication(payload) {
	  return (0, _http.fetchJSON)(_urls.UPDATE_COACH_APPLICATION, _http.POST, {}, payload, {});
	}
	
	function upgradeStudent(payload) {
	  return (0, _http.fetchJSON)(_urls.UPGRADE_STUDENT, _http.POST, {}, payload, {});
	}
	
	function overrideStudent(payload) {
	  return (0, _http.fetchJSON)(_urls.OVERRIDE_DIVISION, _http.POST, {}, payload, {});
	}
	
	function evaluateStudent(payload) {
	  return (0, _http.fetchJSON)(_urls.STUDENT_EVALUATION, _http.POST, {}, payload, {});
	}
	
	function deleteCoach(payload) {
	  return (0, _http.fetchJSON)(_urls.DELETE_COACH, _http.POST, {}, payload, {});
	}
	
	function addCoach(payload) {
	  return (0, _http.fetchJSON)(_urls.ADD_COACH, _http.POST, {}, payload, {});
	}
	
	function modifyCollege(payload) {
	  return (0, _http.fetchJSON)(_urls.MODIFY_COLLEGE, _http.POST, {}, payload, {});
	}
	
	function getCoachesFromColleges(id) {
	  return (0, _http.fetchJSON)(_urls.GET_COACHES_FROM_COLLEGES + id, _http.GET, {}, {}, {});
	}
	function addCollegeToDB(payload) {
	  return (0, _http.fetchJSON)(_urls.ADD_COLLEGE_TO_DB, _http.POST, {}, payload, {});
	}
	
	function getStudentForStudentExplorer(payload) {
	  return (0, _http.fetchJSON)(_urls.GET_STUDENTS_FOR_STUDENT_EXPLORER, _http.POST, {}, payload, {});
	}
	
	function deleteCoachApplication(id) {
	  return (0, _http.fetchJSON)(_urls.DELETE_COCAH_APPLICATION + id, _http.GET, {}, {}, {});
	}
	
	function resetStudentDashboard(id) {
	  return (0, _http.fetchJSON)(_urls.RESET_STUDENT_DASHBOARD + id, _http.GET, {}, {}, {});
	}

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveCoach = saveCoach;
	exports.getCoach = getCoach;
	exports.storePosting = storePosting;
	exports.getAllPostingsById = getAllPostingsById;
	exports.editPosting = editPosting;
	exports.updatePosting = updatePosting;
	exports.deletePostingById = deletePostingById;
	exports.validataCoachFromDatabase = validataCoachFromDatabase;
	
	var _http = __webpack_require__(128);
	
	var _urls = __webpack_require__(127);
	
	function saveCoach(data) {
	  return (0, _http.fetchJSON)(_urls.SAVE_COACH_PROFILE, _http.POST, {}, data, {});
	}
	
	function getCoach(id) {
	  return (0, _http.fetchJSON)(_urls.GET_COACH_PROFILE + id, _http.GET, {}, {}, {});
	}
	
	function storePosting(data) {
	  return (0, _http.fetchJSON)(_urls.ADD_POSTING, _http.POST, {}, data, {});
	}
	
	function getAllPostingsById(id) {
	  return (0, _http.fetchJSON)(_urls.GET_ALL_POSTINGS + id, _http.GET, {}, {}, {});
	}
	
	function editPosting(id) {
	  return (0, _http.fetchJSON)(_urls.GET_POSTING_BY_ID + id, _http.GET, {}, {}, {});
	}
	
	function updatePosting(payload) {
	  return (0, _http.fetchJSON)(_urls.UPDATE_POSTING, _http.POST, {}, payload, {});
	}
	
	function deletePostingById(id) {
	  return (0, _http.fetchJSON)(_urls.DELETE_POSTING + id, _http.GET, {}, {}, {});
	}
	
	function validataCoachFromDatabase(data) {
	  return (0, _http.fetchJSON)(_urls.VALIDATE_COACH_FROM_DATABASE, _http.POST, {}, data, {});
	}

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSchools = getSchools;
	exports.getPostings = getPostings;
	exports.addToWishList = addToWishList;
	exports.removeFromList = removeFromList;
	exports.addToRequest = addToRequest;
	exports.getRequests = getRequests;
	exports.getRequestsCoach = getRequestsCoach;
	exports.addConversation = addConversation;
	exports.totalCountsForDashboard = totalCountsForDashboard;
	exports.addStudentCurrentDivision = addStudentCurrentDivision;
	exports.getdivisionstudents = getdivisionstudents;
	exports.getfilterbasedstudents = getfilterbasedstudents;
	exports.getTotalRequestViewedCount = getTotalRequestViewedCount;
	
	var _http = __webpack_require__(128);
	
	var _urls = __webpack_require__(127);
	
	function getSchools(payload) {
	  return (0, _http.fetchJSON)(_urls.GET_SA_DASHBOARD_SCHOOLS, _http.POST, {}, payload, {});
	}
	
	function getPostings(payload) {
	  return (0, _http.fetchJSON)(_urls.GET_SA_DASHBOARD_POSTINGS, _http.POST, {}, payload, {});
	}
	
	function addToWishList(payload) {
	  return (0, _http.fetchJSON)(_urls.ADD_TO_WISHLIST, _http.POST, {}, payload, {});
	}
	
	function removeFromList(payload) {
	  return (0, _http.fetchJSON)(_urls.REMOVE_FROM_LIST, _http.POST, {}, payload, {});
	}
	
	function addToRequest(payload) {
	  return (0, _http.fetchJSON)(_urls.ADD_TO_REQUEST, _http.POST, {}, payload, {});
	}
	
	function getRequests(id) {
	  return (0, _http.fetchJSON)(_urls.GET_COACH_DASHBOARD_REQUESTS + id, _http.GET, {}, {}, {});
	}
	
	function getRequestsCoach(id) {
	  return (0, _http.fetchJSON)(_urls.COACH_GET_REQUEST_LIST + id, _http.GET, {}, {}, {});
	}
	
	function addConversation(data, place) {
	  if (place === 'public') {
	    return (0, _http.fetchPublicCOACH)(_urls.ADD_CONVERSATION, _http.POST, data);
	  }
	  return (0, _http.fetchJSON)(_urls.ADD_CONVERSATION, _http.POST, {}, data, {});
	}
	
	function totalCountsForDashboard(data) {
	  return (0, _http.fetchJSON)(_urls.GET_TOTAL_COUNTS_FOR_DASHBOARD, _http.POST, {}, data, {});
	}
	
	function addStudentCurrentDivision(payload) {
	  return (0, _http.fetchJSON)(_urls.ADD_STUDENT_CURRENT_DIVISION, _http.POST, {}, payload, {});
	}
	
	function getdivisionstudents() {
	  return (0, _http.fetchJSON)(_urls.GET_DIVISION_BASED_STUDENTS, _http.GET, {}, {}, {});
	}
	
	function getfilterbasedstudents(payload) {
	  return (0, _http.fetchJSON)(_urls.GET_FILTER_BASED_STUDENTS, _http.POST, {}, payload, {});
	}
	
	function getTotalRequestViewedCount(id) {
	  return (0, _http.fetchJSON)(_urls.GET_TOTAL_REQUEST_VIEWED_COUNT + id, _http.GET, {}, {}, {});
	}

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _service = __webpack_require__(1073);
	
	Object.defineProperty(exports, 'sendMail', {
	  enumerable: true,
	  get: function get() {
	    return _service.sendMail;
	  }
	});
	Object.defineProperty(exports, 'sendMoreNotification', {
	  enumerable: true,
	  get: function get() {
	    return _service.sendMoreNotification;
	  }
	});

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendMail = sendMail;
	exports.sendMoreNotification = sendMoreNotification;
	
	var _http = __webpack_require__(128);
	
	var _urls = __webpack_require__(127);
	
	function sendMail(body, coach_application) {
	  // eslint-disable-line
	  debugger; // eslint-disable-line
	  var URL = _urls.SEND_CONTACT_MAIL;
	  if (coach_application) {
	    // eslint-disable-line
	    URL = _urls.ADD_COACH_APPLICATION;
	    return (0, _http.fetchJSON)(URL, _http.POST, {}, body, {});
	  }
	  return (0, _http.fetchPublicCOACH)(URL, _http.POST, body, {});
	}
	
	function sendMoreNotification() {
	  return (0, _http.fetchJSON)(_urls.SEND_CONTACT_MAIL);
	}

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getClientToken = getClientToken;
	exports.submitPaymentNonce = submitPaymentNonce;
	exports.postSubscription = postSubscription;
	exports.postSubscriptionCS = postSubscriptionCS;
	exports.getPayments = getPayments;
	
	var _http = __webpack_require__(128);
	
	var _urls = __webpack_require__(127);
	
	function getClientToken(id) {
	  var url = _urls.GET_CLIENT_TOKEN;
	  if (id) {
	    url = url + '?customer_id=' + id;
	  }
	  return (0, _http.fetchJSON)(url);
	}
	
	function submitPaymentNonce(body) {
	  return (0, _http.fetchJSON)(_urls.PUT_PAYMENT_NONCE, _http.PUT, {}, body, {});
	}
	
	function postSubscription(body) {
	  return (0, _http.fetchJSON)(_urls.POST_SUBSCRIPTION, _http.POST, {}, body, {});
	}
	
	function postSubscriptionCS(body) {
	  return (0, _http.fetchJSON)(_urls.POST_SUBSCRIPTION_CS, _http.POST, {}, body, {});
	}
	
	function getPayments(id) {
	  return (0, _http.fetchJSON)(_urls.GET_PAYMENT_HISTORY + id, _http.GET, {}, {}, {});
	}

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveProfile = saveProfile;
	exports.getProfile = getProfile;
	exports.saveProfileVideo = saveProfileVideo;
	exports.searchSchoolsByName = searchSchoolsByName;
	exports.getPublicProfile = getPublicProfile;
	exports.getPublicProfileForCoach = getPublicProfileForCoach;
	exports.getPublicRequestById = getPublicRequestById;
	exports.removeVideoById = removeVideoById;
	exports.startTrial = startTrial;
	
	var _http = __webpack_require__(128);
	
	var _urls = __webpack_require__(127);
	
	function saveProfile(profile, id) {
	  if (id === 'PENDING') {
	    return (0, _http.fetchJSON)(_urls.SAVE_SA_PROFILE, _http.POST, {}, profile, {});
	  }
	  return (0, _http.fetchJSON)(_urls.UPDATE_SA_PROFILE, _http.POST, {}, profile, {});
	}
	
	function getProfile(id) {
	  return (0, _http.fetchJSON)(_urls.GET_SA_PROFILE + id);
	}
	
	function saveProfileVideo(video) {
	  return (0, _http.fetchJSON)(_urls.ADD_SA_PROFILE_VIDEO, _http.POST, {}, video, {});
	}
	
	function searchSchoolsByName(query) {
	  return (0, _http.fetchJSON)(_urls.SA_PROFILE_SCHOOLS, _http.POST, {}, query, {});
	}
	
	function getPublicProfile(id) {
	  return (0, _http.fetchPublicJSON)(_urls.GET_ATHLETE_BY_ID + id);
	}
	
	function getPublicProfileForCoach(id) {
	  return (0, _http.fetchPublicJSON)(_urls.GET_ATHLETE_FOR_COACH_BY_ID + id);
	}
	
	function getPublicRequestById(id) {
	  return (0, _http.fetchPublicJSON)(_urls.GET_REQUEST_BY_ID + id);
	}
	
	function removeVideoById(data) {
	  return (0, _http.fetchJSON)(_urls.DELETE_ATHLETE_VIDEO_BY_INDEX, _http.POST, {}, data, {});
	}
	
	function startTrial(data) {
	  return (0, _http.fetchJSON)(_urls.UPDATE_STUDENT_TRIAL, _http.POST, {}, data, {});
	}

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authenticateUser = authenticateUser;
	exports.RegisterUser = RegisterUser;
	exports.forgotPassword = forgotPassword;
	exports.setPasswordByCode = setPasswordByCode;
	exports.resetPassword = resetPassword;
	exports.isSessionValid = isSessionValid;
	exports.updateUserAttributes = updateUserAttributes;
	exports.logoutUser = logoutUser;
	exports.updateProfilePicture = updateProfilePicture;
	
	var _aws = __webpack_require__(391);
	
	var _aws2 = _interopRequireDefault(_aws);
	
	var _awsSdk = __webpack_require__(421);
	
	var _awsSdk2 = _interopRequireDefault(_awsSdk);
	
	var _amazonCognitoIdentityJs = __webpack_require__(404);
	
	var _amazonCognitoJs = __webpack_require__(912);
	
	var _immutable = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// use of immutablejs for various js operations to simplify our work
	
	// eslint-disable-line
	_awsSdk.Config.region = _aws2.default.region;
	_awsSdk2.default.config.region = _aws2.default.region;
	var userPool = new _amazonCognitoIdentityJs.CognitoUserPool(_aws2.default.pool);
	
	_awsSdk.Config.region = _aws2.default.region;
	_awsSdk.Config.credentials = new _awsSdk.CognitoIdentityCredentials({
	  IdentityPoolId: _aws2.default.IdentityPoolId
	});
	
	/*
	* Not so great file as we have callback. Not ideal. Keep this file free unless it is very critical
	*/
	function authenticateUser(username, password, cb) {
	  var authenticationDetails = new _amazonCognitoIdentityJs.AuthenticationDetails({ email: username, Password: password });
	  var userData = { Username: username, Pool: userPool };
	  var cognitoUser = new _amazonCognitoIdentityJs.CognitoUser(userData);
	  cognitoUser.authenticateUser(authenticationDetails, {
	    onSuccess: function onSuccess(result) {
	      var Logins = {};
	      Logins['cognito-idp.' + _aws2.default.region + '.amazonaws.com/' + _aws2.default.pool.UserPoolId] = result.getIdToken().getJwtToken();
	      _awsSdk2.default.config.credentials = new _awsSdk.CognitoIdentityCredentials({
	        IdentityPoolId: _aws2.default.IdentityPoolId,
	        Logins: Logins
	      });
	      // Initialize the Cognito Sync client
	      // AWS.config.credentials = new CognitoIdentityCredentials({
	      //   IdentityPoolId: awsConfig.IdentityPoolId,
	      // });
	      _awsSdk2.default.config.credentials.get(function () {
	        var syncClient = new _awsSdk2.default.CognitoSyncManager();
	
	        syncClient.openOrCreateDataset('preferences', function (err1, dataset) {
	          dataset.put('count', '3', function (error1, record) {
	            // eslint-disable-line
	            dataset.synchronize({
	              onSuccess: function onSuccess(dataa, newRecords) {// eslint-disable-line
	                // Your handler code here
	              }
	            });
	          });
	        });
	      });
	
	      cb(false, { session: JSON.parse(JSON.stringify(result)), user: cognitoUser });
	    },
	    onFailure: function onFailure(err) {
	      cb(err, null);
	    }
	  });
	  global.cognitoUser = cognitoUser;
	}
	
	function RegisterUser(username, password, attributes, cb) {
	  var attributeList = [];
	  attributes.forEach(function (attribute) {
	    attributeList.push(new _amazonCognitoIdentityJs.CognitoUserAttribute(attribute));
	  });
	  userPool.signUp(username, password, attributeList, null, function (err) {
	    if (err) {
	      cb(err, null);
	    } else {
	      authenticateUser(username, password, cb);
	    }
	  });
	}
	
	function forgotPassword(username, cb) {
	  var params = {
	    ClientId: _aws2.default.pool.ClientId, /* required */
	    Username: username /* required */
	  };
	  var CognitoIdentityServiceProvider = new _awsSdk2.default.CognitoIdentityServiceProvider();
	  CognitoIdentityServiceProvider.forgotPassword(params, function (err, data) {
	    if (err) cb(err, null); // an error occurred
	    else cb(false, data); // successful response
	  });
	}
	
	function setPasswordByCode(username, password, code, cb) {
	  var params = {
	    ClientId: _aws2.default.pool.ClientId, /* required */
	    ConfirmationCode: code, /* required */
	    Password: password, /* required */
	    Username: username /* required */
	  };
	  var CognitoIdentityServiceProvider = new _awsSdk2.default.CognitoIdentityServiceProvider();
	
	  CognitoIdentityServiceProvider.confirmForgotPassword(params, function (err, data) {
	    if (err) cb(err, null); // an error occurred
	    else cb(false, data); // successful response
	  });
	}
	
	function resetPassword(currentPassword, newPassword, cb) {
	  var user = userPool.getCurrentUser();
	
	  if (user != null) {
	    user.getSession(function (err, session) {
	      if (err) {
	        cb(true);
	        return;
	      }
	      user.changePassword(currentPassword, newPassword, function (error, data) {
	        if (error) {
	          cb(true);
	          return;
	        }
	        cb(false, { session: session, data: data });
	      });
	    });
	  } else {
	    cb(true);
	  }
	}
	
	function isSessionValid(cb) {
	  var adminSupport = window.sessionStorage.getItem('admin_support');
	
	  var user = userPool.getCurrentUser();
	  if (adminSupport) {
	    var session = window.sessionStorage.getItem('session');
	    var previousUser = window.sessionStorage.getItem('user');
	    var attributes = window.sessionStorage.getItem('attributes');
	    cb(false, session, previousUser, attributes);
	  } else if (user != null) {
	    user.getSession(function (err, session) {
	      if (err) {
	        cb(true);
	        return;
	      }
	      user.getUserAttributes(function (error, data) {
	        if (error) {
	          var temp = (0, _immutable.Map)();
	          cb(false, { session: session, user: user, temp: temp });
	          return;
	        }
	        var attributes = (0, _immutable.Map)(data.reduce(function (previous, current) {
	          var temp = previous;
	          temp[current.Name] = current.Value;
	          return temp;
	        }, {}));
	        cb(false, { session: session, user: user, attributes: attributes });
	      });
	    });
	  } else {
	    cb(true);
	  }
	}
	
	function updateUserAttributes(attributes, cb) {
	  var user = userPool.getCurrentUser();
	  if (user != null) {
	    user.getSession(function (err) {
	      if (err) {
	        cb(true);
	        return;
	      }
	      var attributeList = [];
	      attributes.forEach(function (attribute) {
	        attributeList.push(new _amazonCognitoIdentityJs.CognitoUserAttribute(attribute));
	      });
	
	      user.updateAttributes(attributeList, function (error, data) {
	        if (error) {
	          cb(error);
	          return;
	        }
	        cb(false, data);
	      });
	    });
	  } else {
	    cb(true);
	  }
	}
	
	function logoutUser(cb) {
	  var user = userPool.getCurrentUser();
	
	  if (user != null) {
	    user.signOut();
	  }
	  cb(false, null);
	}
	
	function s4() {
	  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	}
	
	function guid() {
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
	
	function updateProfilePicture(profileId, file, cb) {
	  _awsSdk2.default.config.update({
	    accessKeyId: ("AKIAXGXI6TJ44SLMS3VU"),
	    secretAccessKey: ("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"),
	    region: _aws2.default.region
	  });
	
	  var S3 = new _awsSdk2.default.S3({ params: { Bucket: 'myrbimages' } });
	  var params = {
	    Key: guid() + '.jpg',
	    ContentType: file.type,
	    Body: file,
	    ACL: 'public-read',
	    Metadata: { profileId: profileId }
	  };
	  S3.upload(params, function (err, result) {
	    if (err) {
	      return cb(true, err);
	    }
	    return cb(false, result);
	  });
	}
	
	// TODO here we are handling cognitoSycn
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.abc = exports.getUpdatedPostingData = undefined;
	
	var _postingData = __webpack_require__(440);
	
	var getUpdatedPostingData = exports.getUpdatedPostingData = function getUpdatedPostingData(division, selectedPosition, gpa) {
	  var index = _postingData.allPositions[division].findIndex(function (element) {
	    return element.position === selectedPosition;
	  });
	  var currentObject = _postingData.allPositions[division][index];
	
	  return {
	    heightInInches: currentObject.inches,
	    heightInFeet: currentObject.feet,
	    height: currentObject.feet + '\'' + currentObject.inches,
	    t40: currentObject.t40,
	    weight: currentObject.weight,
	    description: currentObject.description,
	    gpa: gpa
	  };
	};
	
	var abc = exports.abc = function abc() {};

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToolbox = __webpack_require__(251);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AboutTabs = __webpack_require__(1458);
	
	var _AboutTabs2 = _interopRequireDefault(_AboutTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	// to import local scss fle
	
	var AboutTabs = function (_React$Component) {
	  _inherits(AboutTabs, _React$Component);
	
	  function AboutTabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AboutTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AboutTabs.__proto__ || Object.getPrototypeOf(AboutTabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: 0,
	      fixedIndex: 1,
	      inverseIndex: 1
	    }, _this.handleTabChange = function (index) {
	      _this.setState({ index: index });
	      _this.props.tabListener(index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AboutTabs, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _AboutTabs2.default.container) },
	        _react2.default.createElement(
	          _reactToolbox.Tabs,
	          { index: this.state.index, onChange: this.handleTabChange },
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'ABOUT', activeClassName: _AboutTabs2.default.activeClass }),
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'RECRUITING TIPS', activeClassName: _AboutTabs2.default.activeClass }),
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'MYTHS', activeClassName: _AboutTabs2.default.activeClass })
	        )
	      );
	    }
	  }]);
	
	  return AboutTabs;
	}(_react2.default.Component);
	
	AboutTabs.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired
	};
	exports.default = AboutTabs;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AboutTabs = __webpack_require__(1078);
	
	var _AboutTabs2 = _interopRequireDefault(_AboutTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AboutTabs2.default;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _reactAutocomplete = __webpack_require__(342);
	
	var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _radio = __webpack_require__(104);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _immutable = __webpack_require__(11);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _AcademicBoard = __webpack_require__(1459);
	
	var _AcademicBoard2 = _interopRequireDefault(_AcademicBoard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to display error messages on invalid user input
	// to use input from react-toolbox library
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// use of immutablejs for various js operations to simplify our work
	// to show loder on screen whenever there is a api call or operations in component
	
	
	// to import local scss fle
	
	var gpaSuggestions = {};
	var satSuggestions = {};
	var emptyObject = {};
	
	var AcademicBoard = function (_React$Component) {
	  _inherits(AcademicBoard, _React$Component);
	
	  function AcademicBoard(props) {
	    _classCallCheck(this, AcademicBoard);
	
	    var _this = _possibleConstructorReturn(this, (AcademicBoard.__proto__ || Object.getPrototypeOf(AcademicBoard)).call(this, props));
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value)));
	    };
	
	    _this.removeErrorMessage = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, '')));
	    };
	
	    _this.state = {
	      school: '',
	      year_of_graduation: '',
	      gpa: '',
	      sat: '',
	      act: '',
	      hbcu: 'no',
	      schoolNames: [],
	      loader: false,
	      satSuggestions: {},
	      schoolErrorMessage: '',
	      gpaErrorMessage: '',
	      satErrorMessage: '',
	      actErrorMessage: '',
	      yearOfPassingErrorMessage: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.schoolSearch = _this.schoolSearch.bind(_this);
	    _this.saveAndLoad = _this.saveAndLoad.bind(_this);
	    _this.handleQueryChange = _this.handleQueryChange.bind(_this);
	    _this.removeErrorMessage = _this.removeErrorMessage.bind(_this);
	    _this.timer = null;
	    _this.Map = _immutable.Map;
	    _this.is = _immutable.is;
	    return _this;
	  }
	
	  _createClass(AcademicBoard, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          _props$profile = _props.profile,
	          profile = _props$profile === undefined ? (0, _immutable.Map)() : _props$profile,
	          _props$schools = _props.schools,
	          schools = _props$schools === undefined ? {} : _props$schools;
	
	      if (nextProps.profile.size > 0 && !(0, _immutable.is)(profile, nextProps.profile)) {
	        var academic = nextProps.profile.get('academic');
	        var newState = {
	          school: nextProps.profile.get('school'),
	          year_of_graduation: academic.get('year_of_graduation'),
	          gpa: academic.get('gpa'),
	          sat: academic.get('sat'),
	          act: academic.get('act')
	        };
	        this.setState(newState);
	      } else if (this.Map.isMap(nextProps.schools) && !this.is(nextProps.schools, schools) && nextProps.schools.get('hits')) {
	        var hits = nextProps.schools.get('hits');
	        var total = hits.get('total');
	        var tempHits = [];
	        if (total > 0) {
	          var results = nextProps.schools.get('hits');
	          results = results.get('hits');
	          results = results.toJS();
	
	          results.forEach(function (school) {
	            var obj = {};
	            var college = school._source.school; // eslint-disable-line
	            var key = college;
	            obj.key = key;
	            obj.value = college;
	            tempHits.push(obj);
	          });
	          this.setState({ schoolNames: tempHits });
	        }
	      }
	    }
	  }, {
	    key: 'schoolSearch',
	    value: function schoolSearch(name, value) {
	      var _this2 = this;
	
	      var query = {};
	      if (this.timer) {
	        clearTimeout(this.timer);
	      }
	
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	
	      if (value && value.length >= 3) {
	        this.timer = setTimeout(function () {
	          var obj = {};
	          obj.key = 'school';
	          obj.value = value;
	          query.push(obj);
	          _this2.props.searchSchools(query);
	        }, 100);
	      }
	    }
	  }, {
	    key: 'handleQueryChange',
	    value: function handleQueryChange(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'saveAndLoad',
	    value: function saveAndLoad(data) {
	      /* school validation */
	      var validSchool = false;
	      var enteredScool = _typeof(this.state.school);
	      if (enteredScool === 'string' && this.state.school !== '') {
	        validSchool = true;
	      } else {
	        this.setState({ schoolErrorMessage: 'Please select a school.' });
	      }
	      /* school validation */
	
	      /* year of passing */
	      var validYearOfPassing = false;
	
	      if (this.state.year_of_graduation !== '' && !isNaN(this.state.year_of_graduation)) {
	        validYearOfPassing = true;
	      } else {
	        this.setState({ yearOfPassingErrorMessage: 'Please add a valid graduation year.' });
	      }
	      /* year of passing */
	
	      /* Gpa validation */
	      var validGpa = false;
	      if (this.state.gpa !== '' && !isNaN(this.state.gpa) && this.state.gpa >= 2 && this.state.gpa <= 4.0) {
	        validGpa = true;
	      } else {
	        this.setState({ gpaErrorMessage: 'Please select a Gpa from list.' });
	      }
	      /* Gpa validation */
	
	      /* Act validation */
	      var validAct = false;
	      if (this.state.act >= 16 && this.state.act <= 36) {
	        validAct = true;
	      } else if (this.state.act === '') {
	        validAct = true;
	      } else {
	        this.setState({ actErrorMessage: 'Enter Act between 16 - 36.' });
	      }
	
	      /* Act validation */
	
	      /* Sat validation */
	      var validSat = false;
	      if (this.state.sat >= 600 && this.state.sat <= 1600) {
	        validSat = true;
	      } else if (this.state.sat === '') {
	        validSat = true;
	      } else {
	        this.setState({ satErrorMessage: 'Enter Sat between 600 - 1600.' });
	      }
	      /* Sat validation */
	
	      if (validSchool && validGpa && validYearOfPassing && validAct && validSat) {
	        this.setState({ loader: true });
	        this.props.save(data);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      for (var i = 6; i < 16; i++) {
	        //eslint-disable-line
	        for (var x = 1; x <= 10; x++) {
	          //eslint-disable-line
	          var listItem = '';
	          var left = '';
	          var right = '';
	          listItem = i * 100 + x * 10;
	          left = listItem;
	          right = listItem;
	          if (listItem === 600) {
	            left = '600';right = '600 or Lower';
	          }
	          satSuggestions['' + left] = '' + right;
	        }
	      }
	      // for (let i = 16; i <= 36; i++) { //eslint-disable-line
	      //   let listItem = '';
	      //   if (i === 16) {
	      //     listItem = `${`${i} or Lower`}`;
	      //   } else {
	      //     listItem = `${i}`;
	      //   }
	      //
	      //   actSuggestions[`${listItem}`] = `${listItem}`;
	      // }
	      for (var _i = 2; _i < 4; _i++) {
	        //eslint-disable-line
	        for (var _x = 0; _x <= 10; _x++) {
	          //eslint-disable-line
	          var _listItem = '';
	          var _left = '';
	          var _right = '';
	          _listItem = '' + (_i + "." + _x); // eslint-disable-line
	          if (_x === 10) {
	            _listItem = _i + 1 + '.0'; // eslint-disable-line
	          }
	          _left = _listItem;
	          _right = _listItem;
	          if (_listItem === '2.0') {
	            _left = '2.0';_right = '2.0 or higher';
	          } else if (_listItem === '4.0') {
	            _left = '4.0';_right = '4.0 or Higher';
	          }
	          gpaSuggestions['' + _left] = '' + _right;
	        }
	      }
	      var renderIfShow = (0, _renderIf2.default)(this.props.show);
	      var renderLoader = (0, _renderIf2.default)(this.state.loader);
	      var _state = this.state,
	          schoolErrorMessage = _state.schoolErrorMessage,
	          satErrorMessage = _state.satErrorMessage,
	          gpaErrorMessage = _state.gpaErrorMessage,
	          actErrorMessage = _state.actErrorMessage,
	          yearOfPassingErrorMessage = _state.yearOfPassingErrorMessage;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderIfShow(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _AcademicBoard2.default.academicContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _AcademicBoard2.default.fullWidth) },
	            _react2.default.createElement(
	              'div',
	              { className: schoolErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithAutoComplete) : (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithAutoCompleteError) },
	              _react2.default.createElement(
	                'span',
	                { className: _AcademicBoard2.default.spanBlock },
	                'HIGH SCHOOL'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _AcademicBoard2.default.autoCompleteContainer },
	                _react2.default.createElement(_reactAutocomplete2.default, {
	                  inputProps: { name: 'School', id: 'schools-autocomplete' },
	                  ref: 'schools-autocomplete' // eslint-disable-line
	                  , value: this.state.school,
	                  items: this.state.schoolNames,
	                  getItemValue: function getItemValue(item) {
	                    return item.value;
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('schoolErrorMessage');
	                  },
	                  onSelect: function onSelect(school, item) {
	                    // set the menu to only the selected item
	                    _this3.setState({ school: item.value });
	                    // or you could reset it to a default list again
	                    // this.setState({ unitedStates: getStates() })
	                  },
	                  onChange: function onChange(event, value) {
	                    if (_this3.timer) {
	                      clearTimeout(_this3.timer);
	                    }
	
	                    _this3.setState(Object.assign({}, _this3.state, { school: value, schoolErrorMessage: '' }));
	
	                    if (value && value.length >= 3) {
	                      _this3.timer = setTimeout(function () {
	                        _this3.props.searchSchools(value);
	                      }, 100);
	                    }
	                  },
	                  renderItem: function renderItem(item) {
	                    return _react2.default.createElement(
	                      'div',
	                      {
	                        key: item.key,
	                        id: item.key
	                      },
	                      item.value
	                    );
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: schoolErrorMessage })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: yearOfPassingErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'GRADUATION YEAR'
	              ),
	              _react2.default.createElement(_input2.default, {
	                onChange: function onChange(val) {
	                  return _this3.handleChange('year_of_graduation', val);
	                },
	                value: this.state.year_of_graduation,
	                onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('yearOfPassingErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: yearOfPassingErrorMessage })
	            ),
	            _react2.default.createElement(_Divider2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _AcademicBoard2.default.fullWidth) },
	            _react2.default.createElement(
	              'div',
	              { className: gpaErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'GPA'
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                source: this.state.gpa === '' ? emptyObject : gpaSuggestions,
	                selectedPosition: 'below',
	                direction: 'down',
	                value: this.state.gpa,
	                allowCreate: true,
	                multiple: false,
	                onChange: function onChange(val) {
	                  return _this3.handleChange('gpa', val);
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this3.handleChange('gpa', val);
	                },
	                onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('gpaErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: gpaErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: satErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'SAT',
	                _react2.default.createElement(
	                  'span',
	                  { className: _AcademicBoard2.default.optionalTag },
	                  '\xA0\xA0(Optional)'
	                )
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                source: this.state.sat === '' ? emptyObject : satSuggestions,
	                selectedPosition: 'below',
	                direction: 'down',
	                value: this.state.sat,
	                multiple: false,
	                onChange: function onChange(val) {
	                  return _this3.handleChange('sat', val);
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this3.handleChange('sat', val);
	                },
	                onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('satErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: satErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: actErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'ACT',
	                _react2.default.createElement(
	                  'span',
	                  { className: _AcademicBoard2.default.optionalTag },
	                  '\xA0\xA0(Optional)'
	                )
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                source: this.state.act === '' ? emptyObject : _DropdownsValues.actSuggestions,
	                selectedPosition: 'below',
	                direction: 'down',
	                value: this.state.act,
	                multiple: false,
	                onChange: function onChange(val) {
	                  return _this3.handleChange('act', val);
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this3.handleChange('act', val);
	                },
	                onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('actErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: actErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m6', _AcademicBoard2.default.halfWidthRadio) },
	              _react2.default.createElement(
	                'p',
	                null,
	                'ARE YOU INTERESTED IN ATTENDING HBCUs? (Historically Black Colleges/Universities)'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s4', _AcademicBoard2.default.removePadding) },
	                _react2.default.createElement(
	                  _radio.RadioGroup,
	                  { name: 'hbcu', value: this.state.hbcu, onChange: function onChange(val) {
	                      return _this3.handleChange('hbcu', val);
	                    } },
	                  _react2.default.createElement(_radio.RadioButton, { label: 'Yes', value: 'yes' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s4', _AcademicBoard2.default.radioContainer) },
	                _react2.default.createElement(
	                  _radio.RadioGroup,
	                  { name: 'hbcu', value: this.state.hbcu, onChange: function onChange(val) {
	                      return _this3.handleChange('hbcu', val);
	                    } },
	                  _react2.default.createElement(_radio.RadioButton, { label: 'No', value: 'no' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _AcademicBoard2.default.buttonContainer) },
	            _react2.default.createElement(_button2.default, { label: '< PREVIOUS', className: _AcademicBoard2.default.back, onClick: this.props.back }),
	            _react2.default.createElement(_button2.default, { label: 'CONTINUE', raised: true, className: _AcademicBoard2.default.continue, onClick: function onClick() {
	                return _this3.saveAndLoad(_this3.state);
	              } })
	          )
	        ))
	      );
	    }
	  }]);
	
	  return AcademicBoard;
	}(_react2.default.Component);
	
	AcademicBoard.propTypes = {
	  save: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool.isRequired,
	  back: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.instanceOf(_immutable.Map),
	  schools: _propTypes2.default.shape(),
	  searchSchools: _propTypes2.default.func
	};
	AcademicBoard.defaultProps = {
	  save: function save() {},
	  show: false,
	  profile: (0, _immutable.Map)(),
	  schools: { school: 'enter school name' },
	  searchSchools: function searchSchools() {}
	};
	exports.default = AcademicBoard;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AcademicBoard = __webpack_require__(1080);
	
	var _AcademicBoard2 = _interopRequireDefault(_AcademicBoard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AcademicBoard2.default;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localStorage = __webpack_require__(56);
	
	var _routeNames = __webpack_require__(55);
	
	var _reactPortalTooltip = __webpack_require__(240);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _AccountDropdown = __webpack_require__(1460);
	
	var _AccountDropdown2 = _interopRequireDefault(_AccountDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  to change path from inside or to alter react-router-dom path
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	
	// to import local scss fle
	
	var AccountDropdown = function (_Component) {
	  _inherits(AccountDropdown, _Component);
	
	  function AccountDropdown(props) {
	    _classCallCheck(this, AccountDropdown);
	
	    var _this = _possibleConstructorReturn(this, (AccountDropdown.__proto__ || Object.getPrototypeOf(AccountDropdown)).call(this, props));
	
	    _this.state = {
	      isTooltipActive: false,
	      profileIcon: '',
	      renderLogOutCurrentUSer: ''
	    };
	    _this.showTooltip = _this.showTooltip.bind(_this);
	    _this.hideTooltip = _this.hideTooltip.bind(_this);
	    _this.logoutCurrentUser = _this.logoutCurrentUser.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccountDropdown, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var profileImage = (0, _localStorage.getItem)('profile_image');
	      this.setState({ profileIcon: profileImage });
	      var currentUser = (0, _localStorage.getItem)('user_cred');
	      var currentLocalZone = (0, _localStorage.getItem)('localZone');
	      if (currentUser) {
	        this.setState({ renderLogOutCurrentUSer: true });
	      }
	      if (currentLocalZone === 'STUDENT') {
	        this.setState({ localZone: currentLocalZone });
	      } else {
	        this.setState({ localZone: currentLocalZone });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.userLoggedOut !== nextProps.userLoggedOut) {
	        this.props.history.push('/');
	      }
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      this.setState({ isTooltipActive: true });
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      this.setState({ isTooltipActive: false });
	    }
	  }, {
	    key: 'logoutCurrentUser',
	    value: function logoutCurrentUser() {
	      this.props.logoutCurrentUserForAdmin();
	      this.props.history.push(_routeNames.AdminBase);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var match = this.props.match;
	
	      var renderCocahLinks = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'COACH');
	      var renderStudentLinks = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'STUDENT');
	      var renderAdminLinks = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'ADMIN');
	      var renderAdminStudentLinks = (0, _renderIf2.default)(this.state.localZone === 'STUDENT' && match.url !== '/admin/admin_portal');
	      var renderAdminCoachLinks = (0, _renderIf2.default)(this.state.localZone === 'COACH' && match.url !== '/admin/admin_portal');
	      var renderLogoutLink = (0, _renderIf2.default)(this.state.renderLogOutCurrentUSer && match.url !== '/admin/admin_portal' && (this.state.localZone === 'COACH' || this.state.localZone === 'STUDENT') && match.params.id === undefined);
	      return _react2.default.createElement(
	        'div',
	        { className: _AccountDropdown2.default.container },
	        _react2.default.createElement(
	          'xx',
	          {
	            id: 'text',
	            onMouseEnter: this.showTooltip,
	            onMouseLeave: this.hideTooltip,
	            onClick: this.showTooltip,
	            className: _AccountDropdown2.default.dropdownIcon,
	            src: this.state.profileIcon !== '' ? 'https://s3.amazonaws.com/myrbimagesdev/' + this.state.profileIcon : 'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	            alt: 'icon'
	          },
	          'MENU'
	        ),
	        _react2.default.createElement(
	          _reactPortalTooltip2.default,
	          { active: this.state.isTooltipActive, position: 'bottom', arrow: 'right', parent: '#text' },
	          _react2.default.createElement(
	            'div',
	            { className: _AccountDropdown2.default.dropdownContainer },
	            _react2.default.createElement(
	              'span',
	              null,
	              renderCocahLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'HOME'
	                  ),
	                  _react2.default.createElement(_Divider2.default, null)
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/coach/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              )),
	              renderStudentLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'HOME'
	                  ),
	                  _react2.default.createElement(_Divider2.default, null)
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/athlete' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'PROFILE'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              ))
	            ),
	            renderAdminLinks(_react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/' },
	                _react2.default.createElement(
	                  'button',
	                  { className: _AccountDropdown2.default.menuItem },
	                  'HOME'
	                )
	              ),
	              renderAdminStudentLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/athlete' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'PROFILE'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              )),
	              renderAdminCoachLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/coach/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              )),
	              renderLogoutLink(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  'button',
	                  { className: _AccountDropdown2.default.menuItem, onClick: this.logoutCurrentUser },
	                  'LOGOUT CURRENT USER'
	                )
	              ))
	            )),
	            _react2.default.createElement(_Divider2.default, null),
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  return _this2.props.logoutUser(_this2.props.attributes.get('zoneinfo'));
	                }, className: _AccountDropdown2.default.menuItem },
	              'SIGNOUT'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountDropdown;
	}(_react.Component);
	
	AccountDropdown.propTypes = {
	  logoutUser: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape().isRequired,
	  logoutCurrentUserForAdmin: _propTypes2.default.bool.isRequired,
	  history: _propTypes2.default.shape(),
	  userLoggedOut: _propTypes2.default.bool.isRequired,
	  match: _propTypes2.default.shape.isRequired
	};
	AccountDropdown.defaultProps = {
	  logoutUser: function logoutUser() {},
	  dropDownWithUser: false,
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = AccountDropdown;

/***/ },
/* 1083 */
[2526, 1082],
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _localStorage = __webpack_require__(56);
	
	var _routeNames = __webpack_require__(55);
	
	var _reactPortalTooltip = __webpack_require__(240);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _AccountDropdown = __webpack_require__(1461);
	
	var _AccountDropdown2 = _interopRequireDefault(_AccountDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  to change path from inside or to alter react-router-dom path
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	
	// to import local scss fle
	
	var AccountDropdown = function (_Component) {
	  _inherits(AccountDropdown, _Component);
	
	  function AccountDropdown(props) {
	    _classCallCheck(this, AccountDropdown);
	
	    var _this = _possibleConstructorReturn(this, (AccountDropdown.__proto__ || Object.getPrototypeOf(AccountDropdown)).call(this, props));
	
	    _this.state = {
	      isTooltipActive: false,
	      profileIcon: '',
	      renderLogOutCurrentUSer: ''
	    };
	    _this.showTooltip = _this.showTooltip.bind(_this);
	    _this.hideTooltip = _this.hideTooltip.bind(_this);
	    _this.logoutCurrentUser = _this.logoutCurrentUser.bind(_this);
	    return _this;
	  }
	
	  _createClass(AccountDropdown, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var profileImage = (0, _localStorage.getItem)('profile_image');
	      this.setState({ profileIcon: profileImage });
	      var currentUser = (0, _localStorage.getItem)('user_cred');
	      var currentLocalZone = (0, _localStorage.getItem)('localZone');
	      if (currentUser) {
	        this.setState({ renderLogOutCurrentUSer: true });
	      }
	      if (currentLocalZone === 'STUDENT') {
	        this.setState({ localZone: currentLocalZone });
	      } else {
	        this.setState({ localZone: currentLocalZone });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.userLoggedOut !== nextProps.userLoggedOut) {
	        this.props.history.push('/');
	      }
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      this.setState({ isTooltipActive: true });
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      this.setState({ isTooltipActive: false });
	    }
	  }, {
	    key: 'logoutCurrentUser',
	    value: function logoutCurrentUser() {
	      this.props.logoutCurrentUserForAdmin();
	      this.props.history.push(_routeNames.AdminBase);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var match = this.props.match;
	
	      var renderCocahLinks = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'COACH');
	      var renderStudentLinks = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'STUDENT');
	      var renderAdminLinks = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'ADMIN');
	      var renderAdminStudentLinks = (0, _renderIf2.default)(this.state.localZone === 'STUDENT' && match.url !== '/admin/admin_portal');
	      var renderAdminCoachLinks = (0, _renderIf2.default)(this.state.localZone === 'COACH' && match.url !== '/admin/admin_portal');
	      var renderLogoutLink = (0, _renderIf2.default)(this.state.renderLogOutCurrentUSer && match.url !== '/admin/admin_portal' && (this.state.localZone === 'COACH' || this.state.localZone === 'STUDENT') && match.params.id === undefined);
	      return _react2.default.createElement(
	        'div',
	        { className: _AccountDropdown2.default.container },
	        renderCocahLinks(_react2.default.createElement('img', {
	          id: 'text',
	          onMouseEnter: this.showTooltip,
	          onMouseLeave: this.hideTooltip,
	          onClick: this.showTooltip,
	          className: _AccountDropdown2.default.dropdownIcon,
	          src: 'https://media.dev.myrecruitboard.com/Images/coachIcon.png',
	          alt: 'icon'
	        })),
	        renderAdminLinks(_react2.default.createElement('img', {
	          id: 'text',
	          onMouseEnter: this.showTooltip,
	          onMouseLeave: this.hideTooltip,
	          onClick: this.showTooltip,
	          className: _AccountDropdown2.default.dropdownIcon,
	          src: 'https://media.dev.myrecruitboard.com/Images/coachIcon.png',
	          alt: 'icon'
	        })),
	        renderStudentLinks(_react2.default.createElement('img', {
	          id: 'text',
	          onMouseEnter: this.showTooltip,
	          onMouseLeave: this.hideTooltip,
	          onClick: this.showTooltip,
	          className: _AccountDropdown2.default.dropdownIcon,
	          src: this.state.profileIcon !== '' ? 'https://s3.amazonaws.com/myrbimages/' + this.state.profileIcon : 'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	          alt: 'icon'
	        })),
	        _react2.default.createElement(
	          _reactPortalTooltip2.default,
	          { active: this.state.isTooltipActive, position: 'bottom', arrow: 'right', parent: '#text' },
	          _react2.default.createElement(
	            'div',
	            { className: _AccountDropdown2.default.dropdownContainer },
	            _react2.default.createElement(
	              'span',
	              null,
	              renderCocahLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'HOME'
	                  ),
	                  _react2.default.createElement(_Divider2.default, null)
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/coach/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              )),
	              renderStudentLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'HOME'
	                  ),
	                  _react2.default.createElement(_Divider2.default, null)
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/athlete' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'PROFILE'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              ))
	            ),
	            renderAdminLinks(_react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/' },
	                _react2.default.createElement(
	                  'button',
	                  { className: _AccountDropdown2.default.menuItem },
	                  'HOME'
	                )
	              ),
	              renderAdminStudentLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/athlete' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'PROFILE'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              )),
	              renderAdminCoachLinks(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/coach/dashboard' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'DASHBOARD'
	                  )
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _AccountDropdown2.default.menuItem },
	                    'SETTINGS'
	                  )
	                )
	              )),
	              renderLogoutLink(_react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  'button',
	                  { className: _AccountDropdown2.default.menuItem, onClick: this.logoutCurrentUser },
	                  'LOGOUT CURRENT USER'
	                )
	              ))
	            )),
	            _react2.default.createElement(_Divider2.default, null),
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  return _this2.props.logoutUser(_this2.props.attributes.get('zoneinfo'));
	                }, className: _AccountDropdown2.default.menuItem },
	              'SIGNOUT'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountDropdown;
	}(_react.Component);
	
	AccountDropdown.propTypes = {
	  logoutUser: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape().isRequired,
	  logoutCurrentUserForAdmin: _propTypes2.default.bool.isRequired,
	  history: _propTypes2.default.shape(),
	  userLoggedOut: _propTypes2.default.bool.isRequired,
	  match: _propTypes2.default.shape.isRequired
	};
	AccountDropdown.defaultProps = {
	  logoutUser: function logoutUser() {},
	  dropDownWithUser: false,
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = AccountDropdown;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactStepperHorizontal = __webpack_require__(368);
	
	var _reactStepperHorizontal2 = _interopRequireDefault(_reactStepperHorizontal);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _Subheader = __webpack_require__(322);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _SelectField = __webpack_require__(548);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(216);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _AddPosting = __webpack_require__(1462);
	
	var _AddPosting2 = _interopRequireDefault(_AddPosting);
	
	var _helpers = __webpack_require__(1077);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// to display error messages on invalid user input
	// to use input from react-toolbox library
	
	
	// to import local scss fle
	
	
	var inlineStyles = {
	  menuStyle: {
	    borderBottom: 'none'
	  },
	  iconStyle: {
	    height: '40px',
	    width: '40px'
	  },
	  underlineStyle: {
	    borderBottom: 'none'
	  },
	  tileContainer: {
	    fontWeight: '500',
	    height: '39px',
	    paddingLeft: '5px',
	    fontFamily: 'unset',
	    fontSize: '14px',
	    border: '0.5px solid rgba(153,153,153,0.7)'
	  }
	};
	
	var t40Suggestions = {};
	var gpaSuggestions = {};
	var satSuggestions = {};
	
	var AddPosting = function (_Component) {
	  _inherits(AddPosting, _Component);
	
	  function AddPosting(props) {
	    _classCallCheck(this, AddPosting);
	
	    var _this = _possibleConstructorReturn(this, (AddPosting.__proto__ || Object.getPrototypeOf(AddPosting)).call(this, props));
	
	    _this.handleHeight = function (name, value) {
	      if (name === 'heightInFeet') {
	        if (value.target.value <= 7 && value.target.value >= 4 || value.target.value === '') {
	          _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	            _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	          });
	        }
	      } else if (value.target.value < 12 && value.target.value >= 0 || value.target.value === '') {
	        _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	          _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	        });
	      }
	    };
	
	    _this.handleWeight = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)));
	    };
	
	    _this.handlePostingChange = function (event, index, value) {
	      var profile = _this.props.profile;
	
	      var updatedPostingData = (0, _helpers.getUpdatedPostingData)('D1', value, profile.get('gpa'));
	      console.log(updatedPostingData, 'object'); // eslint-disable-line
	      _this.setState(Object.assign({}, _this.state, { postingTitle: value }, updatedPostingData));
	    };
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value)), function () {}); //eslint-disable-line
	    };
	
	    _this.removeErrorMessage = function (name) {
	      var _Object$assign5;
	
	      _this.setState(Object.assign({}, _this.state, (_Object$assign5 = {}, _defineProperty(_Object$assign5, name, ''), _defineProperty(_Object$assign5, 'squatsSuggestions', {}), _defineProperty(_Object$assign5, 'benchSuggestions', {}), _defineProperty(_Object$assign5, 'actSuggestions', {}), _Object$assign5)));
	    };
	
	    _this.state = {
	      open: false,
	      postingTitle: '',
	      postingTitleErrorMessage: '',
	      description: '',
	      descriptionErrorMessage: '',
	      t40: '',
	      t40ErrorMessage: '',
	      bench: '',
	      benchErrorMessage: '',
	      feetErrorMessage: '',
	      endDate: '',
	      endDateErrorMessage: '',
	      heightInInches: '',
	      heightInFeet: '',
	      heightInchesErrorMessage: '',
	      heightInFeetErrorMessage: '',
	      weightErrorMessage: '',
	      squats: '',
	      squatsErrorMessage: '',
	      act: '',
	      actErrorMessage: '',
	      gpa: '',
	      gpaErrorMessage: '',
	      sat: '',
	      satErrorMessage: '',
	      startDate: (0, _moment2.default)(),
	      postingStatus: 'active',
	      currentStep: 0,
	      height: '',
	      weight: '',
	      steps: [{
	        onClick: function onClick(e) {
	          _this.setState({
	            firstInfo: true,
	            currentStep: 0
	          });
	          e.preventDefault();
	        } }, {
	        onClick: function onClick(e) {
	          _this.setState({
	            secondInfo: true,
	            firstInfo: false,
	            currentStep: 1
	          });
	          e.preventDefault();
	        } }]
	    };
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handlePostings = _this.handlePostings.bind(_this);
	    _this.removeErrorMessage = _this.removeErrorMessage.bind(_this);
	    _this.next = _this.next.bind(_this);
	    _this.handleHeight = _this.handleHeight.bind(_this);
	    _this.handleWeight = _this.handleWeight.bind(_this);
	    // this.handlePostingChange = this.handlePostingChange.bind(this);
	    return _this;
	  }
	
	  _createClass(AddPosting, [{
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var _state = this.state,
	          postingTitle = _state.postingTitle,
	          heightInInches = _state.heightInInches,
	          heightInFeet = _state.heightInFeet,
	          weight = _state.weight,
	          t40 = _state.t40;
	
	      var updated = {};
	      var validPostingTiltle = void 0;
	      var validHeightInInches = void 0;
	      var validHeightInFeet = void 0;
	      var validWeight = void 0;
	      var validT40 = void 0;
	      if (postingTitle !== '') {
	        validPostingTiltle = true;
	      } else {
	        updated.postingTitleErrorMessage = 'Enter correct posting title';
	      }
	      if (heightInInches !== '') {
	        validHeightInInches = true;
	      } else {
	        updated.heightInchesErrorMessage = 'Please add height in inches';
	      }
	      if (heightInFeet !== '') {
	        validHeightInFeet = true;
	      } else {
	        updated.heightInFeetErrorMessage = 'Please add height in feet';
	      }
	      if (weight !== '') {
	        validWeight = true;
	      } else {
	        updated.weightErrorMessage = 'Please add a valid weight.';
	      }
	
	      /* T40 validation */
	
	      if (t40 !== '') {
	        validT40 = true;
	      } else {
	        updated.t40ErrorMessage = 'Please add a valid 40-Yard Dash.';
	      }
	      /* T40 validation */
	      /* squats validation */
	      if (validHeightInFeet && validHeightInInches && validPostingTiltle && validT40 && validWeight) {
	        this.setState({ currentStep: 1 });
	      } else {
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'handlePostings',
	    value: function handlePostings() {
	      var payload = {};
	
	      var updated = {};
	      var profile = this.props.profile;
	      var _state2 = this.state,
	          postingTitle = _state2.postingTitle,
	          description = _state2.description,
	          t40 = _state2.t40,
	          postingStatus = _state2.postingStatus,
	          height = _state2.height,
	          weight = _state2.weight,
	          gpa = _state2.gpa;
	
	      /* Gpa validation */
	
	      var validGpa = false;
	      if (gpa !== '') {
	        validGpa = true;
	      } else {
	        updated.gpaErrorMessage = 'Gpa is not valid.';
	      }
	      /* Gpa validation */
	
	      if (validGpa) {
	        var id = this.props.attributes.get('profile');
	        var requirements = {
	          min_gpa: gpa,
	          min_t40: t40,
	          min_height: height,
	          min_weight: weight
	        };
	        if (this.state.sat !== '') {
	          requirements['min_sat'] = this.state.sat; // eslint-disable-line
	        }
	        if (this.state.act !== '') {
	          requirements['min_act'] = this.state.act; // eslint-disable-line
	        }
	        payload = Object.assign(payload, {
	          coach_id: id,
	          posting_title: postingTitle,
	          posting_sport: 'sport',
	          team_name: 'teamName',
	          coach_name: this.props.user.username,
	          college_name: profile.get('college'),
	          college_id: profile.get('college_id'),
	          college_image: 'asdfjklasdfkj',
	          city: profile.get('city'),
	          state: profile.get('state'),
	          team_page_link: profile.get('team_page_link'),
	          question_link: profile.get('question_link'),
	          division: profile.get('division'),
	          posting_status: postingStatus,
	          interested_profiles_list: [],
	          requirements: requirements
	        });
	
	        if (description !== '') {
	          payload['description'] = description; // eslint-disable-line
	        } else {
	          payload['description'] = null; // eslint-disable-line
	        }
	        this.props.addPostings(payload);
	        this.setState({
	          open: false,
	          postingTitle: '',
	          description: '',
	          t40: '',
	          currentStep: 0,
	          heightInFeet: '',
	          heightInInches: '',
	          squats: '',
	          gpa: '',
	          sat: '',
	          act: '',
	          startDate: (0, _moment2.default)(),
	          bench: '',
	          weight: ''
	        });
	      } else {
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)'
	        },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          borderRadius: '0px',
	          maxWidth: '70%',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      for (var i = 6; i <= 16; i++) {
	        //eslint-disable-line
	        for (var x = 1; x <= 10; x++) {
	          //eslint-disable-line
	          var listItem = '';
	          listItem = i * 100 + x * 10;
	          if (listItem === 600) {
	            listItem = '600 or Lower';
	          }
	          satSuggestions['' + listItem] = '' + listItem;
	        }
	      }
	      for (var _i = 16; _i <= 36; _i++) {
	        //eslint-disable-line
	        var _listItem = '';
	        if (_i === 16) {
	          _listItem = '' + (_i + ' or Lower');
	        } else {
	          _listItem = '' + _i;
	        }
	
	        _DropdownsValues.actSuggestions['' + _listItem] = '' + _listItem;
	      }
	      for (var _i2 = 2; _i2 < 4; _i2++) {
	        //eslint-disable-line
	        for (var _x = 0; _x <= 10; _x++) {
	          //eslint-disable-line
	          var _listItem2 = '';
	          _listItem2 = '' + (_i2 + "." + _x); // eslint-disable-line
	          if (_x === 10) {
	            _listItem2 = _i2 + 1 + '.0'; // eslint-disable-line
	          }
	          if (_listItem2 === '2.0') {
	            _listItem2 = '2.0 or Lower';
	          } else if (_listItem2 === '4.0') {
	            _listItem2 = '4.0 or Higher';
	          }
	          gpaSuggestions['' + _listItem2] = '' + _listItem2;
	        }
	      }
	      for (var _i3 = 4; _i3 < 6; _i3++) {
	        //eslint-disable-line
	        for (var _x2 = 0; _x2 <= 10; _x2++) {
	          //eslint-disable-line
	          var _listItem3 = '';
	          _listItem3 = '' + (_i3 + "." + _x2); // eslint-disable-line
	          if (_x2 === 10) {
	            _listItem3 = _i3 + 1 + '.0'; // eslint-disable-line
	          }
	          if (_listItem3 >= '4.3' && _listItem3 <= '5.5') {
	            if (_listItem3 === '4.3') {
	              _listItem3 = '4.3 or Lower';
	            } else if (_listItem3 === '5.5') {
	              _listItem3 = '5.5 or Higher';
	            }
	            t40Suggestions['' + _listItem3] = '' + _listItem3;
	          }
	        }
	      }
	      var _state3 = this.state,
	          heightInchesErrorMessage = _state3.heightInchesErrorMessage,
	          postingTitleErrorMessage = _state3.postingTitleErrorMessage,
	          weightErrorMessage = _state3.weightErrorMessage,
	          satErrorMessage = _state3.satErrorMessage,
	          actErrorMessage = _state3.actErrorMessage,
	          gpaErrorMessage = _state3.gpaErrorMessage,
	          t40ErrorMessage = _state3.t40ErrorMessage,
	          heightInFeetErrorMessage = _state3.heightInFeetErrorMessage,
	          open = _state3.open;
	      var _props = this.props,
	          createAllPostingForThisCollege = _props.createAllPostingForThisCollege,
	          profile = _props.profile,
	          user = _props.user,
	          attributes = _props.attributes;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _AddPosting2.default.container) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _AddPosting2.default.buttonPostingContainer) },
	          _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick() {
	                return createAllPostingForThisCollege(profile, user, attributes);
	              },
	              className: _AddPosting2.default.addNewPosting
	            },
	            'Create all postings'
	          ),
	          _react2.default.createElement(
	            'button',
	            { onClick: this.onOpenModal, className: _AddPosting2.default.addNewPosting },
	            'Add new posting'
	          )
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: open, onRequestClose: this.onCloseModal },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row') },
	            _react2.default.createElement(
	              'div',
	              { className: _AddPosting2.default.absoluteCross, onClick: this.onCloseModal },
	              'x'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _AddPosting2.default.header) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Add New Posting!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _AddPosting2.default.fullWidth) },
	              _react2.default.createElement(
	                'div',
	                { className: _AddPosting2.default.stepperContainer },
	                _react2.default.createElement(_reactStepperHorizontal2.default, {
	                  steps: this.state.steps,
	                  activeColor: '#333',
	                  circleFontColor: '#FFF',
	                  defaultTitleColor: '#EBEBEB',
	                  activeTitleColor: '#FFF',
	                  completeColor: '#EBEBEB',
	                  activeStep: this.state.currentStep
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.currentStep === 0 ? (0, _classnames2.default)('col s12', _AddPosting2.default.fullWidth) : _AddPosting2.default.hidden },
	              _react2.default.createElement(
	                'div',
	                { className: postingTitleErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpanonError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'POSITION I AM RECRUITING'
	                ),
	                _react2.default.createElement(
	                  _SelectField2.default,
	                  {
	                    style: inlineStyles.tileContainer,
	                    value: this.state.postingTitle,
	                    onChange: this.handlePostingChange,
	                    menuStyle: inlineStyles.menuStyle,
	                    iconStyle: inlineStyles.iconStyle,
	                    underlineStyle: inlineStyles.underlineStyle,
	                    autoWidth: false,
	                    maxHeight: 300
	                  },
	                  _react2.default.createElement(
	                    _Subheader2.default,
	                    null,
	                    'OFFENSIVE POSITIONS'
	                  ),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'QBDT', primaryText: 'Quarterback - Duel Threat' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'QBPS', primaryText: 'Quarterback - Pro Style' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'WR', primaryText: 'Wide Receiver' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'SR', primaryText: 'Slot Receiver' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'RB', primaryText: 'Running Back' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'FB', primaryText: 'Full Back' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'HB', primaryText: 'H-Back' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'TE', primaryText: 'Tight End' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'OG', primaryText: 'Offensive Guard' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'OT', primaryText: 'Offensive Tackle' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'C', primaryText: 'Center' }),
	                  _react2.default.createElement(
	                    _Subheader2.default,
	                    null,
	                    'DEFENSIVE POSITIONS'
	                  ),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'DT', primaryText: 'Defensive Tackle' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'DE', primaryText: 'Defensive End' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'ML', primaryText: 'Middle Linebacker' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'OL', primaryText: 'Outside Linebacker' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'DB', primaryText: 'Cornerback' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'SS', primaryText: 'Strong Safety' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'FS', primaryText: 'Free Safety' }),
	                  _react2.default.createElement(
	                    _Subheader2.default,
	                    null,
	                    'SPECIAL TEAM POSITIONS'
	                  ),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'K', primaryText: 'Kicker' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'P', primaryText: 'Punter' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'LS', primaryText: 'Long Snapper' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _AddPosting2.default.heightAndWidthContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12 m6', _AddPosting2.default.heightWidth) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM HEIGHT'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s12', _AddPosting2.default.heightContainer) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s6', _AddPosting2.default.feetContainer) },
	                      _react2.default.createElement('input', {
	                        className: heightInFeetErrorMessage === '' ? (0, _classnames2.default)('col s12', _AddPosting2.default.simpleInput) : (0, _classnames2.default)('col s12', _AddPosting2.default.simpleInputError),
	                        type: 'text',
	                        placeholder: 'Feet',
	                        value: this.state.heightInFeet,
	                        onFocus: function onFocus() {
	                          return _this2.removeErrorMessage('heightInFeetErrorMessage');
	                        },
	                        onChange: function onChange(val) {
	                          return _this2.handleHeight('heightInFeet', val);
	                        }
	                      }),
	                      _react2.default.createElement(_ErrorMessage2.default, { message: heightInFeetErrorMessage })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s6', _AddPosting2.default.inchesContainer) },
	                      _react2.default.createElement('input', {
	                        className: heightInchesErrorMessage === '' ? (0, _classnames2.default)('col s12', _AddPosting2.default.simpleInput) : (0, _classnames2.default)('col s12', _AddPosting2.default.simpleInputError),
	                        type: 'text',
	                        placeholder: 'Inches',
	                        value: this.state.heightInInches,
	                        onFocus: function onFocus() {
	                          return _this2.removeErrorMessage('heightInchesErrorMessage');
	                        },
	                        onChange: function onChange(val) {
	                          return _this2.handleHeight('heightInInches', val);
	                        }
	                      }),
	                      _react2.default.createElement(_ErrorMessage2.default, { message: heightInchesErrorMessage })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: weightErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AddPosting2.default.weightSection) : (0, _classnames2.default)('col s16 m6', _AddPosting2.default.weightSectionOnError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM WEIGHT'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s12', _AddPosting2.default.removePaddingWeight) },
	                    _react2.default.createElement('input', {
	                      className: _AddPosting2.default.simpleInput,
	                      value: this.state.weight,
	                      onChange: function onChange(val) {
	                        return _this2.handleWeight('weight', val);
	                      },
	                      onFocus: function onFocus() {
	                        return _this2.removeErrorMessage('weightErrorMessage');
	                      },
	                      placeholder: 'Pounds'
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: this.state.weightErrorMessage })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _AddPosting2.default.dropdowns) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: t40ErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpanonError) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'SLOWEST 40-YARD DASH'
	                    ),
	                    _react2.default.createElement(_autocomplete2.default, {
	                      source: t40Suggestions,
	                      selectedPosition: 'below',
	                      direction: 'down',
	                      value: this.state.t40,
	                      multiple: false,
	                      onFocus: function onFocus() {
	                        return _this2.removeErrorMessage('t40ErrorMessage');
	                      },
	                      onChange: function onChange(val) {
	                        return _this2.handleChange('t40', val);
	                      },
	                      onQueryChange: function onQueryChange(val) {
	                        return _this2.handleChange('t40', val);
	                      }
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: t40ErrorMessage })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _AddPosting2.default.buttonContainer) },
	                _react2.default.createElement(_button2.default, { onClick: this.next, label: 'NEXT' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.currentStep === 1 ? (0, _classnames2.default)('col s12', _AddPosting2.default.fullWidth) : _AddPosting2.default.hidden },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _AddPosting2.default.dropdowns) },
	                _react2.default.createElement(
	                  'div',
	                  { className: gpaErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpanonError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM GPA'
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: gpaSuggestions,
	                    selectedPosition: 'below',
	                    direction: 'down',
	                    allowCreate: true,
	                    value: this.state.gpa,
	                    multiple: false,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('gpa', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.removeErrorMessage('gpaErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: gpaErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: satErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AddPosting2.default.rightSection) : (0, _classnames2.default)('col s12 m6', _AddPosting2.default.rightSectionOnError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM SAT',
	                    _react2.default.createElement(
	                      'span',
	                      { className: _AddPosting2.default.optionalTag },
	                      '\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: satSuggestions,
	                    selectedPosition: 'below',
	                    direction: 'down',
	                    value: this.state.sat,
	                    multiple: false,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('sat', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.removeErrorMessage('satErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: satErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: actErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddPosting2.default.halfWidthWithSpanonError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM ACT',
	                    _react2.default.createElement(
	                      'span',
	                      { className: _AddPosting2.default.optionalTag },
	                      '\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: _DropdownsValues.actSuggestions,
	                    selectedPosition: 'below',
	                    direction: 'down',
	                    value: this.state.act,
	                    multiple: false,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('act', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.removeErrorMessage('actErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: actErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _AddPosting2.default.halfWidthWithSpan) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'DESCRIPTION',
	                    _react2.default.createElement(
	                      'span',
	                      { className: _AddPosting2.default.optionalTag },
	                      '\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'full_name',
	                    value: this.state.description,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('description', val);
	                    },
	                    multiline: true
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _AddPosting2.default.buttonContainer) },
	                  _react2.default.createElement(_button2.default, { onClick: this.handlePostings, label: 'POST' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddPosting;
	}(_react.Component);
	
	AddPosting.propTypes = {
	  addPostings: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape(),
	  user: _propTypes2.default.shape(),
	  profile: _propTypes2.default.shape(),
	  createAllPostingForThisCollege: _propTypes2.default.func
	};
	AddPosting.defaultProps = {
	  addPostings: function addPostings() {},
	  attributes: {},
	  user: {},
	  profile: {},
	  createAllPostingForThisCollege: function createAllPostingForThisCollege() {}
	};
	exports.default = AddPosting;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddPosting = __webpack_require__(1085);
	
	var _AddPosting2 = _interopRequireDefault(_AddPosting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AddPosting2.default;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsiveModal = __webpack_require__(363);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _queryString = __webpack_require__(116);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _validations = __webpack_require__(443);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _AddVideo = __webpack_require__(1463);
	
	var _AddVideo2 = _interopRequireDefault(_AddVideo);
	
	var _Error = __webpack_require__(158);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var AddVideo = function (_Component) {
	  _inherits(AddVideo, _Component);
	
	  function AddVideo(props) {
	    _classCallCheck(this, AddVideo);
	
	    var _this = _possibleConstructorReturn(this, (AddVideo.__proto__ || Object.getPrototypeOf(AddVideo)).call(this, props));
	
	    _this.onOpenModal = function () {
	      _this.setState({ open: true });
	    };
	
	    _this.onCloseModal = function () {
	      _this.setState({ open: false, urlErrorMessage: '', titleErrorMessage: '' });
	    };
	
	    _this.handleChange = function (name, errorMessage, value) {
	      var _Object$assign;
	
	      _this.setState(Object.assign({}, _this.state, (_Object$assign = {}, _defineProperty(_Object$assign, name, value.target.value), _defineProperty(_Object$assign, errorMessage, ''), _Object$assign)));
	    };
	
	    _this.saveVideoDetails = function () {
	      var query = _queryString2.default.parse(_this.state.url);
	      var thumbImage = 'https://media.dev.myrecruitboard.com/Images/videoThumbnail.png';
	      if (query && Object.prototype.hasOwnProperty.call(query, 'https://www.youtube.com/watch?v')) {
	        thumbImage = 'https://img.youtube.com/vi/' + query['https://www.youtube.com/watch?v'] + '/0.jpg';
	      }
	      var video = {
	        id: _this.props.profileId,
	        video_url: _this.state.url,
	        video_title: _this.state.title,
	        thumbnail_url: thumbImage
	      };
	      var validation = (0, _validations2.default)(video);
	      if (validation.urlIsValid && validation.titleIsValid) {
	        _this.setState({ open: false, title: '', urlErrorMessage: '', titleErrorMessage: '' });
	        _this.props.videoDetails(video);
	      } else {
	        _this.setState({
	          urlErrorMessage: validation.urlErrorMessage,
	          titleErrorMessage: validation.titleErrorMessage });
	      }
	    };
	
	    _this.state = {
	      open: false,
	      title: '',
	      url: '',
	      titleErrorMessage: '',
	      urlErrorMessage: ''
	    };
	    return _this;
	  }
	
	  _createClass(AddVideo, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var modalStyle = {
	        width: '100%',
	        padding: '0'
	      };
	      var _state = this.state,
	          open = _state.open,
	          titleErrorMessage = _state.titleErrorMessage,
	          urlErrorMessage = _state.urlErrorMessage;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_button2.default, { icon: '+', label: 'ADD VIDEOS', onClick: this.onOpenModal, flat: true, primary: true }),
	        _react2.default.createElement(
	          _reactResponsiveModal2.default,
	          { modalStyle: modalStyle, open: open, onClose: this.onCloseModal, little: true },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row') },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _AddVideo2.default.removePadding) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _AddVideo2.default.videoHeader) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Add your videos here'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _AddVideo2.default.inputFields },
	                _react2.default.createElement('input', { type: 'text', placeholder: 'Enter Video title', onChange: function onChange(val) {
	                    return _this2.handleChange('title', 'titleErrorMessage', val);
	                  } }),
	                ' ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_Error2.default, { message: titleErrorMessage }),
	                _react2.default.createElement('input', { type: 'text', placeholder: 'Enter Video Url', onChange: function onChange(val) {
	                    return _this2.handleChange('url', 'urlErrorMessage', val);
	                  } }),
	                ' ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_Error2.default, { message: urlErrorMessage }),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _AddVideo2.default.buttonContainer) },
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.saveVideoDetails },
	                    'Submit'
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddVideo;
	}(_react.Component);
	
	AddVideo.propTypes = {
	  videoDetails: _propTypes2.default.func,
	  profileId: _propTypes2.default.string.isRequired
	};
	AddVideo.defaultProps = {
	  videoDetails: function videoDetails() {},
	  profileId: ''
	};
	exports.default = AddVideo;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _AtheleteDesc = __webpack_require__(1464);
	
	var _AtheleteDesc2 = _interopRequireDefault(_AtheleteDesc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	//  to change path from inside or to alter react-router-dom path
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	
	
	// to import local scss fle
	
	var AtheleteDesc = function (_Component) {
	  _inherits(AtheleteDesc, _Component);
	
	  function AtheleteDesc(props) {
	    _classCallCheck(this, AtheleteDesc);
	
	    var _this = _possibleConstructorReturn(this, (AtheleteDesc.__proto__ || Object.getPrototypeOf(AtheleteDesc)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(AtheleteDesc, [{
	    key: 'render',
	    value: function render() {
	      var renderAthlete = (0, _renderIf2.default)(this.props.viewer === 'athlete');
	      var renderParent = (0, _renderIf2.default)(this.props.viewer === 'parents');
	      var renderCoach = (0, _renderIf2.default)(this.props.viewer === 'coach');
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _AtheleteDesc2.default.signinSection) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _AtheleteDesc2.default.signinHeader) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _AtheleteDesc2.default.joinUsButtonContainer) },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'HOME'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/about' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'ABOUT'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/sports' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'SPORTS'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/ourresults' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'OUR RESULTS'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/contact' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'CONTACT'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _AtheleteDesc2.default.signinBody) },
	          _react2.default.createElement(
	            'span',
	            { className: (0, _classnames2.default)('col s12', _AtheleteDesc2.default.signinBodyAlignCenter) },
	            renderAthlete(_react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                'For Athletes'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
	              )
	            )),
	            renderParent(_react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                'For Parents'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
	              )
	            )),
	            renderCoach(_react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                'For Coach'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'
	              )
	            ))
	          )
	        )
	      );
	    }
	  }]);
	
	  return AtheleteDesc;
	}(_react.Component);
	
	AtheleteDesc.propTypes = {
	  viewer: _propTypes2.default.string.isRequired
	};
	exports.default = AtheleteDesc;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _switch = __webpack_require__(812);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _AddVideos = __webpack_require__(445);
	
	var _AddVideos2 = _interopRequireDefault(_AddVideos);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _redux = __webpack_require__(111);
	
	var _actions = __webpack_require__(281);
	
	var _actions2 = __webpack_require__(110);
	
	var _style = __webpack_require__(1465);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	
	// to use input from react-toolbox library
	// to use conditional rendering based on values that is provided to component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var Info = function (_Component) {
	  _inherits(Info, _Component);
	
	  function Info(props) {
	    _classCallCheck(this, Info);
	
	    // this.onOpenModal = this.onOpenModal.bind(this);
	    // this.onCloseModal = this.onCloseModal.bind(this);
	    var _this = _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).call(this, props));
	
	    _this.removeVideo = function (index) {
	      var data = {
	        student_id: _this.props.item.id,
	        video_index: index
	      };
	      _this.props.removeVideo(data, function () {
	        _this.setState({
	          video: _this.state.video.filter(function (item, i) {
	            return i !== index;
	          }),
	          openDelete: false
	        });
	      });
	    };
	
	    _this.saveVideo = function (videoData) {
	      _this.props.videoDetails(videoData, function (newVideos) {
	        _this.setState({ video: [].concat(_toConsumableArray(newVideos.toJS())) });
	      });
	    };
	
	    _this.Close = function () {
	      _this.props.close();
	      // this.setState({ video: [],
	      //   sa_state: '',
	      //   sa_twitter: '',
	      // });
	    };
	
	    _this.validateInput = function () {
	      var payload = {};
	      var _this$state = _this.state,
	          sa_twitter = _this$state.sa_twitter,
	          sa_state = _this$state.sa_state,
	          switchMails = _this$state.switchMails;
	      // eslint-disable-next-line camelcase
	
	      if (sa_twitter) {
	        var twitterUrl = '';
	        if (sa_twitter.startsWith('https')) {
	          // eslint-disable-next-line camelcase
	          twitterUrl = sa_twitter;
	        } else {
	          // eslint-disable-next-line camelcase
	          twitterUrl = 'https://twitter.com/' + sa_twitter;
	        }
	
	        // eslint-disable-next-line camelcase
	        payload.sa_twitter = twitterUrl;
	      }
	      // eslint-disable-next-line camelcase
	      if (sa_state) {
	        // eslint-disable-next-line camelcase
	        payload.sa_state = sa_state;
	      }
	      payload.switchMails = switchMails;
	      payload.id = _this.props.item.id;
	      _this.props.saveSAProfile(payload, _this.props.item.id, function (error) {
	        if (error) {
	          _this.setState({ errorMessage: 'Failed to save' });
	        } else {
	          _this.props.close();
	          // this.setState({
	          //   video: [],
	          //   sa_state: '',
	          //   sa_twitter: '',
	          // });
	        }
	      });
	    };
	
	    _this.state = {
	      // id: this.props.item.get('id'),
	      open: true,
	      openDelete: false,
	      switchMails: false,
	      title: '',
	      userImage: '',
	      sa_state: '',
	      sa_twitter: '',
	      currentVideo: '',
	      changeImage: false,
	      errorMessage: '',
	      video: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.onMouseHover = _this.onMouseHover.bind(_this);
	    _this.onMouseOut = _this.onMouseOut.bind(_this);
	    _this.validateInput = _this.validateInput.bind(_this);
	    _this.handleChangeImage = _this.handleChangeImage.bind(_this);
	    return _this;
	  }
	
	  _createClass(Info, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProp) {
	      if (nextProp.item.switchMails !== undefined) {
	        this.setState({ switchMails: nextProp.item.switchMails });
	      } else {
	        this.setState({ switchMails: true });
	      }
	      this.setState({ video: nextProp.item.video_items || [],
	        sa_state: nextProp.item.state,
	        sa_twitter: nextProp.item.sa_twitter
	      });
	    }
	  }, {
	    key: 'onMouseHover',
	    value: function onMouseHover() {
	      this.setState({ changeImage: true });
	    }
	  }, {
	    key: 'onMouseOut',
	    value: function onMouseOut() {
	      this.setState({ changeImage: false });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	    }
	  }, {
	    key: 'handleChangeImage',
	    value: function handleChangeImage(event) {
	      var _this2 = this;
	
	      var reader = new window.FileReader();
	      var file = event.target.files[0];
	      reader.onloadend = function () {
	        _this2.setState({
	          userImage: reader.result
	        });
	      };
	      reader.readAsDataURL(file);
	      // this.setState({ userImage: image });
	      this.props.saveUserImage(this.props.item.id, file);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)'
	        },
	        content: {
	          width: '80%',
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          paddingTop: '50px',
	          height: '500px',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      var modalStyleText = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)'
	        },
	        content: {
	          width: '40%',
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          paddingTop: '50px',
	          height: '200px',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      var _state = this.state,
	          openDelete = _state.openDelete,
	          currentVideo = _state.currentVideo,
	          video = _state.video,
	          sa_state = _state.sa_state,
	          sa_twitter = _state.sa_twitter;
	
	      var studentVideo = video;
	      var _props = this.props,
	          open = _props.open,
	          item = _props.item;
	      // const video = item.get('video_items');
	      // eslint-disable-next-line no-console
	
	      var renderChangeImage = (0, _renderIf2.default)(this.state.changeImage);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            style: modalStyle,
	            isOpen: open,
	            onRequestClose: this.onCloseModal
	          },
	          _react2.default.createElement(
	            'h2',
	            { className: _style2.default.confirmText, style: { marginLeft: 30 } },
	            'EDIT ATHLETE DETAILS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)("col s12", _style2.default.imageHeader) },
	            _react2.default.createElement(
	              'div',
	              {
	                className: _style2.default.image,
	                onMouseOver: this.onMouseHover,
	                onMouseOut: this.onMouseOut
	              },
	              this.state.userImage !== "" ? _react2.default.createElement('img', {
	                className: _style2.default.image,
	                src: this.state.userImage,
	                alt: 'user_image'
	              }) : _react2.default.createElement('img', {
	                className: _style2.default.image,
	                src: this.props.profile_image && this.props.profile_image !== "" ? 'https://s3.amazonaws.com/myrbimages/' + item.profile_image : "https://media.dev.myrecruitboard.com/Images/defaultAthlete.png",
	                alt: 'profile'
	              }),
	              renderChangeImage(_react2.default.createElement(
	                'div',
	                { className: _style2.default.changeImage },
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.changeImageText },
	                  'change image.'
	                )
	              )),
	              _react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement('input', {
	                  className: _style2.default.fileInput,
	                  type: 'file',
	                  ref: 'file' //eslint-disable-line
	                  , name: 'myImage',
	                  accept: '.jpg,.jpeg',
	                  onChange: this.handleChangeImage
	                })
	              )
	            )
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)("col s12"), style: { display: 'flex' } },
	            _react2.default.createElement(
	              'div',
	              { style: { marginRight: 80 } },
	              _react2.default.createElement(
	                'span',
	                null,
	                'STATE'
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                source: _DropdownsValues.states,
	                onQueryChange: function onQueryChange(val) {
	                  return _this3.handleChange('sa_state', val);
	                },
	                selectedPosition: 'below',
	                direction: 'down',
	                value: sa_state,
	                allowCreate: true,
	                multiple: false,
	                onChange: function onChange(val) {
	                  return _this3.handleChange('sa_state', val);
	                },
	                onFocus: function onFocus() {
	                  return _this3.removeValue('stateErrorMessage');
	                },
	                className: _style2.default.autocomplete
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { marginRight: 50 } },
	              _react2.default.createElement(
	                'span',
	                null,
	                'TWITTER LINK'
	              ),
	              _react2.default.createElement(_input2.default, {
	                className: _style2.default.autoInput
	                // value={item.get('sa_twitter')}
	                , type: 'text',
	                name: 'sa_twitter',
	                value: sa_twitter
	                // onFocus={() => this.removeErrorMessage('twitterErrorMessage')}
	                , onChange: function onChange(val) {
	                  return _this3.handleChange('sa_twitter', val);
	                },
	                style: { marginTop: 12 }
	              })
	            )
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', flexWrap: 'wrap' } },
	            studentVideo && studentVideo.map(function (item, i) {
	              return _react2.default.createElement(
	                'div',
	                { key: i, className: (0, _classnames2.default)('col  s6 ', _style2.default.videoBox) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.video },
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                        return _this3.setState({ openDelete: true, currentVideo: i });
	                      }, className: _style2.default.editIcon },
	                    _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/white_delete.png', alt: 'edit-icon' })
	                  ),
	                  _react2.default.createElement('img', { className: _style2.default.videoImage, src: item.thumbnail_url, alt: 'thumbnail' }),
	                  _react2.default.createElement(
	                    'button',
	                    { className: _style2.default.playbutton },
	                    _react2.default.createElement(
	                      'a',
	                      { href: item.video_url, target: '_blank', rel: 'noopener noreferrer' },
	                      _react2.default.createElement('img', { className: _style2.default.playButtonImage, src: 'https://media.dev.myrecruitboard.com/Images/video-icon_3%403x.png', alt: 'video' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.titile },
	                  item.video_title
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(_AddVideos2.default, { videoDetails: this.saveVideo, profileId: item.id }),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(_switch2.default, {
	            checked: this.state.switchMails,
	            label: 'Stop Sending Mail To Coaches',
	            onChange: function onChange(val) {
	              return _this3.handleChange('switchMails', val);
	            }
	          }),
	          _react2.default.createElement(_ErrorMessage2.default, { message: this.state.errorMessage }),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12'), style: { display: 'flex', justifyContent: 'center' } },
	            _react2.default.createElement(
	              'button',
	              {
	                className: _style2.default.buttonContainer,
	                onClick: this.validateInput, style: { margin: 10 }
	              },
	              'SAVE'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: _style2.default.buttonClose,
	                onClick: this.Close, style: { margin: 10 }
	              },
	              'CLOSE'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            style: modalStyleText,
	            isOpen: openDelete,
	            onRequestClose: this.onCloseModal
	          },
	          _react2.default.createElement(
	            'h1',
	            { className: _style2.default.confirmText, style: { marginLeft: 30 } },
	            'Please confirm before deleting permanently'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12'), style: { display: 'flex', justifyContent: 'center' } },
	            _react2.default.createElement(
	              'button',
	              { className: _style2.default.buttonContainer, onClick: function onClick() {
	                  return _this3.removeVideo(currentVideo);
	                }, style: { margin: 10 } },
	              'DELETE'
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: _style2.default.buttonClose, onClick: function onClick() {
	                  return _this3.setState({ openDelete: false });
	                }, style: { margin: 10 } },
	              'CLOSE'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Info;
	}(_react.Component);
	
	Info.propTypes = {
	  open: _propTypes2.default.bool.isRequired,
	  close: _propTypes2.default.func.isRequired,
	  saveSAProfile: _propTypes2.default.func,
	  item: _propTypes2.default.shape(),
	  removeVideo: _propTypes2.default.func,
	  videoDetails: _propTypes2.default.func,
	  saveUserImage: _propTypes2.default.func.isRequired
	};
	Info.defaultProps = {
	  item: {},
	  saveSAProfile: function saveSAProfile() {},
	  removeVideo: function removeVideo() {},
	  videoDetails: function videoDetails() {},
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSAProfile: _actions2.getSAProfile,
	  saveSAProfile: _actions.saveSAProfile,
	  saveUserImage: _actions2.saveUserImage,
	  videoDetails: _actions2.videoDetails,
	  setCurrentVideo: _actions2.setCurrentVideo,
	  removeVideo: _actions2.removeVideo
	})(Info);

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AtheletePopup = __webpack_require__(1089);
	
	var _AtheletePopup2 = _interopRequireDefault(_AtheletePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AtheletePopup2.default;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BackgroundImage = __webpack_require__(1466);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to validate and set default props  coming to this component
	var BackgroundImage = function BackgroundImage(_ref) {
	  var props = _ref.props,
	      otherPages = _ref.otherPages;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _BackgroundImage2.default.backgroundImageContainer) },
	    _react2.default.createElement('div', {
	      // alt="background" src={props.usedFor === 'login' ? 'https://media.dev.myrecruitboard.com/Images/login.jpg'
	      //   : 'https://media.dev.myrecruitboard.com/Images/login.jpg'}
	      className: otherPages === true ? _BackgroundImage2.default.backgroundImageDesktop : (0, _classnames2.default)('col s12', _BackgroundImage2.default.backgroundImageMobile)
	    }),
	    _react2.default.createElement('img', { alt: 'background', src: props, className: otherPages === true ? _BackgroundImage2.default.hidden : _BackgroundImage2.default.backgroundImageDesktop })
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	
	
	BackgroundImage.propTypes = {
	  props: _propTypes2.default.string.isRequired,
	  otherPages: _propTypes2.default.bool.isRequired
	  // usedFor: PropTypes.string,
	};
	
	BackgroundImage.defaultProps = {
	  props: '',
	  otherPages: false,
	  usedFor: ''
	};
	exports.default = BackgroundImage;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BackgroundImage = __webpack_require__(1091);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BackgroundImage2.default;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _Navigation = __webpack_require__(197);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Video = __webpack_require__(1255);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _BackgroundImage = __webpack_require__(1092);
	
	var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);
	
	var _Banner = __webpack_require__(446);
	
	var _Banner2 = __webpack_require__(193);
	
	var _Banner3 = __webpack_require__(1467);
	
	var _Banner4 = _interopRequireDefault(_Banner3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to use global class name eg. classes from grid.css in public folder
	//  to change path from inside or to alter react-router-dom path
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	
	
	// to import local scss fle
	
	var Banner = function (_Component) {
	  _inherits(Banner, _Component);
	
	  function Banner(props) {
	    _classCallCheck(this, Banner);
	
	    var _this = _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).call(this, props));
	
	    _this.state = {
	      showVideo: false
	    };
	
	    _this.toggleVideo = _this.toggleVideo.bind(_this);
	    return _this;
	  }
	
	  _createClass(Banner, [{
	    key: 'toggleVideo',
	    value: function toggleVideo() {
	      this.setState({ showVideo: !this.state.showVideo });
	      this.props.updateVideo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      var renderVideo = false;
	      if (window.innerWidth > 700) {
	        renderVideo = true;
	      }
	      var renderBackgroundVideo = (0, _renderIf2.default)(renderVideo);
	      var renderNavbar = (0, _renderIf2.default)(!data.otherPages);
	      var renderNavbarOnOtherPages = (0, _renderIf2.default)(data.otherPages);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Banner4.default.bannerContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: this.state.showVideo === true ? _Banner4.default.hidden : (0, _classnames2.default)('col s12', _Banner4.default.bannerSection) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Banner4.default.bannerHeader) },
	            renderNavbar(_react2.default.createElement(_Navigation2.default, Object.assign({}, this.props, { page: 'home' }))),
	            renderNavbarOnOtherPages(_react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/' },
	                _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/logo%402x.png', alt: 'logo' })
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Banner4.default.bannerQuotes) },
	            _react2.default.createElement(
	              'div',
	              { className: _Banner4.default.centerDiv },
	              _react2.default.createElement(
	                'div',
	                { className: data.otherPages === true ? _Banner4.default.bigScreens : _Banner4.default.alignCenter },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'FOOTBALL RECRUITING',
	                  _react2.default.createElement('br', null),
	                  'DOWN TO A SCIENCE'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Banner4.default.bannerDesc },
	                  data.bannerDesc
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/about' },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: data.otherPages === true ? _Banner4.default.whiteLearnMore : _Banner4.default.learnMore
	                    },
	                    'LEARN MORE'
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: data.otherPages === true ? _Banner4.default.hidden : _Banner4.default.playvideo,
	                    onClick: this.toggleVideo
	                  },
	                  ' WATCH OUR FILM'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: data.fullsize === true ? _Banner4.default.fullbanner : _Banner4.default.halfBanner },
	          data.fullsize === true ? _react2.default.createElement(
	            'div',
	            null,
	            renderBackgroundVideo(_react2.default.createElement(_Video2.default, null))
	          ) : _react2.default.createElement(_BackgroundImage2.default, {
	            props: data.backgroundUrl,
	            otherPages: data.otherPages
	          })
	        )
	      );
	    }
	  }]);
	
	  return Banner;
	}(_react.Component);
	
	Banner.propTypes = {
	  updateVideo: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.shape()
	};
	Banner.defaultProps = {
	  data: {}
	};
	exports.default = (0, _reactRedux.connect)(_Banner2.bannerSelector, {
	  updateVideo: _Banner.updateVideo
	})(Banner);

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Benefits = __webpack_require__(1468);
	
	var _Benefits2 = _interopRequireDefault(_Benefits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var Benefits = function Benefits() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _Benefits2.default.benefitsContainer) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Benefits2.default.desc) },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'BENEFITS OF MYRECRUITBOARD'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m6', _Benefits2.default.halfList) },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'Affordable.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'Easy to use. '
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'High success rates.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'We will find a college for you.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'Instant college and coach matches.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m6', _Benefits2.default.halfList) },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'Direct contact with college coaches.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'Data driven results specifically formulated for each individual.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement('div', { className: _Benefits2.default.redDot }),
	            'Largest football only recruiting Twitter account.'
	          )
	        )
	      )
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = Benefits;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Benefits = __webpack_require__(1094);
	
	var _Benefits2 = _interopRequireDefault(_Benefits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Benefits2.default;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(11);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _button = __webpack_require__(31);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Billings = __webpack_require__(1469);
	
	var _Billings2 = _interopRequireDefault(_Billings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to show loder on screen whenever there is a api call or operations in component
	//  to change path from inside or to alter react-router-dom path
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	
	var Billings = function (_Component) {
	  _inherits(Billings, _Component);
	
	  function Billings(props) {
	    _classCallCheck(this, Billings);
	
	    var _this = _possibleConstructorReturn(this, (Billings.__proto__ || Object.getPrototypeOf(Billings)).call(this, props));
	
	    _this.state = {
	      noContentFound: false
	    };
	    return _this;
	  }
	
	  _createClass(Billings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.profile.size > 0) {
	        var paymentInfo = this.props.profile.get('payment_info');
	        if (paymentInfo !== undefined) {
	          var customerId = this.props.profile.get('customer_id');
	          this.props.getPaymentHistory(customerId);
	        } else {
	          this.setState({ noContentFound: true });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderLoader = (0, _renderIf2.default)(this.props.paymentRequested);
	      var currentPlanId = (0, _immutable.List)();
	      if (this.props.transactions.size > 0) {
	        currentPlanId = this.props.transactions.get('transactions').last();
	      }
	      var renderNoContentFound = (0, _renderIf2.default)(this.state.noContentFound);
	      var renderCurrentPlanId = (0, _renderIf2.default)(currentPlanId.size > 0);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Billings2.default.container) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderNoContentFound(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: _Billings2.default.dontHaveAnything },
	            'You dont have any payment history. '
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Billings2.default.buttonContainer) },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/pricing' },
	              _react2.default.createElement(
	                _button.Button,
	                { className: _Billings2.default.continue },
	                'UPGRADE NOW '
	              )
	            )
	          )
	        )),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Billings2.default.currentPlan) },
	          _react2.default.createElement(
	            'span',
	            null,
	            'YOUR CURRENT PLAN'
	          )
	        ),
	        renderCurrentPlanId(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Billings2.default.packageInfo) },
	          currentPlanId.get('planId')
	        )),
	        this.props.transactions.map(function (payments) {
	          return payments.map(function (payment) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('div', { className: (0, _classnames2.default)('col s12', _Billings2.default.buttonContainer) }),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _Billings2.default.invoiceHistory) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'INVOICE HISTORY'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _Billings2.default.invoiceListContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _Billings2.default.invoiceList) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s6', _Billings2.default.firstHalf) },
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Billings2.default.alignMiddle },
	                      _react2.default.createElement(
	                        'span',
	                        { className: _Billings2.default.planIdInList },
	                        payment.get('planId')
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement(
	                        'span',
	                        { className: _Billings2.default.paymentMadeOn },
	                        'Payment made on ',
	                        payment.get('transactionDate')
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s6', _Billings2.default.secondHalf) },
	                    _react2.default.createElement(
	                      'span',
	                      { className: _Billings2.default.alignMiddle },
	                      _react2.default.createElement(
	                        'span',
	                        { className: _Billings2.default.transactionId },
	                        'Transaction ID ',
	                        _react2.default.createElement('br', null),
	                        payment.get('id')
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          });
	        })
	      );
	    }
	  }]);
	
	  return Billings;
	}(_react.Component);
	
	Billings.propTypes = {
	  getPaymentHistory: _propTypes2.default.func,
	  profile: _propTypes2.default.shape(),
	  transactions: _propTypes2.default.shape(),
	  paymentRequested: _propTypes2.default.bool
	};
	Billings.defaultProps = {
	  getPaymentHistory: function getPaymentHistory() {},
	  profile: {},
	  transactions: {},
	  paymentRequested: false
	};
	exports.default = Billings;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Billings = __webpack_require__(1096);
	
	var _Billings2 = _interopRequireDefault(_Billings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Billings2.default;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _CoachApplication = __webpack_require__(1470);
	
	var _CoachApplication2 = _interopRequireDefault(_CoachApplication);
	
	var _Error = __webpack_require__(158);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Application = function Application(props) {
	  if (props.item.get('application_status') === 'VERIFIED') {
	    return null;
	  }
	  return _react2.default.createElement(
	    'div',
	    {
	      className: props.item.get('college_id') !== undefined ? (0, _classnames2.default)('col s12', _CoachApplication2.default.listContainer) : (0, _classnames2.default)('col s12', _CoachApplication2.default.listContainerWithoutBottomPadding)
	    },
	    _react2.default.createElement(
	      'button',
	      { className: _CoachApplication2.default.deleteButton, onClick: props.deleteCoachApplication },
	      _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/deleteicon.png', alt: 'delete-icon' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m2', _CoachApplication2.default.profileImage) },
	      _react2.default.createElement('img', { alt: 'profile_icon', src: 'https://media.dev.myrecruitboard.com/Images/coachIcon.png' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m7', _CoachApplication2.default.infoContainer) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m6', _CoachApplication2.default.infoContainer) },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'pp',
	            { className: _CoachApplication2.default.lightText },
	            ' ',
	            props.item.get('name')
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'pp',
	            { className: _CoachApplication2.default.lightText },
	            ' ',
	            props.item.get('college')
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'pp',
	            { className: _CoachApplication2.default.lightText },
	            ' ',
	            props.item.get('city'),
	            ',',
	            props.item.get('state')
	          ),
	          _react2.default.createElement('br', null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m6', _CoachApplication2.default.infoContainer) },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'pp',
	            { className: _CoachApplication2.default.lightText },
	            ' ',
	            props.item.get('coach_email')
	          ),
	          _react2.default.createElement('br', null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m3', _CoachApplication2.default.buttonContainer) },
	      _react2.default.createElement(
	        'span',
	        null,
	        props.item.get('college_id') !== undefined ? _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return props.handleApplicationUpgrade(props.item.get('coach_id'));
	            } },
	          'verify'
	        ) : ''
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col 12') },
	      props.item.get('college_id') === undefined ? _react2.default.createElement(
	        'div',
	        { className: _CoachApplication2.default.troubleFindingClassNameMondayMorning },
	        _react2.default.createElement(_Error2.default, {
	          message: 'This coach added application in college which is not in our system. Add college first by clicking college tab, once done add coach in that college using given email id.'
	        })
	      ) : ''
	    )
	  );
	};
	
	Application.propTypes = {
	  item: _propTypes2.default.shape.isRequired,
	  handleApplicationUpgrade: _propTypes2.default.func.isRequired,
	  deleteCoachApplication: _propTypes2.default.func.isRequired
	};
	
	var CoachApplication = function (_Component) {
	  _inherits(CoachApplication, _Component);
	
	  function CoachApplication(props) {
	    _classCallCheck(this, CoachApplication);
	
	    var _this = _possibleConstructorReturn(this, (CoachApplication.__proto__ || Object.getPrototypeOf(CoachApplication)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    _this.handleApplicationUpgrade = _this.handleApplicationUpgrade.bind(_this);
	    return _this;
	  }
	
	  _createClass(CoachApplication, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.coachApplications.size === 0) {
	        var id = 1234;
	        this.props.getCoachApplications(id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.applicationUpgradeRequested) {
	        var id = 1234;
	        this.props.getCoachApplications(id);
	      }
	    }
	  }, {
	    key: 'handleApplicationUpgrade',
	    value: function handleApplicationUpgrade(id) {
	      var payload = Object.assign({
	        coach_id: id,
	        application_status: 'VERIFIED'
	      });
	      this.props.upgradeCoachApplication(payload);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _deleteCoachApplication = this.props.deleteCoachApplication;
	
	      var renderLoader = (0, _renderIf2.default)(this.props.coachApplicationRequested || this.props.applicationUpgradeRequested);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _CoachApplication2.default.container) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        this.props.coachApplications.map(function (item) {
	          return _react2.default.createElement(Application, {
	            item: item,
	            deleteCoachApplication: function deleteCoachApplication() {
	              return _deleteCoachApplication(item.get('coach_id'));
	            },
	            handleApplicationUpgrade: _this2.handleApplicationUpgrade
	          });
	        })
	      );
	    }
	  }]);
	
	  return CoachApplication;
	}(_react.Component);
	
	CoachApplication.propTypes = {
	  getCoachApplications: _propTypes2.default.func.isRequired,
	  upgradeCoachApplication: _propTypes2.default.func,
	  coachApplicationRequested: _propTypes2.default.bool.isRequired,
	  coachApplications: _propTypes2.default.shape(),
	  applicationUpgradeRequested: _propTypes2.default.bool.isRequired,
	  deleteCoachApplication: _propTypes2.default.bool.isRequired
	};
	CoachApplication.defaultProps = {
	  coachApplications: {},
	  upgradeCoachApplication: function upgradeCoachApplication() {}
	};
	exports.default = CoachApplication;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachApplication = __webpack_require__(1098);
	
	var _CoachApplication2 = _interopRequireDefault(_CoachApplication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachApplication2.default;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Postings = __webpack_require__(1185);
	
	var _Postings2 = _interopRequireDefault(_Postings);
	
	var _Requests = __webpack_require__(1196);
	
	var _Requests2 = _interopRequireDefault(_Requests);
	
	var _DivisionBasedStudent = __webpack_require__(1106);
	
	var _DivisionBasedStudent2 = _interopRequireDefault(_DivisionBasedStudent);
	
	var _CoachDashboardView = __webpack_require__(1471);
	
	var _CoachDashboardView2 = _interopRequireDefault(_CoachDashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var CoachDashboardView = function (_Component) {
	  _inherits(CoachDashboardView, _Component);
	
	  function CoachDashboardView(props) {
	    _classCallCheck(this, CoachDashboardView);
	
	    var _this = _possibleConstructorReturn(this, (CoachDashboardView.__proto__ || Object.getPrototypeOf(CoachDashboardView)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(CoachDashboardView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.getDivisionStudents();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var tab = this.props.tab;
	
	      var renderDefault = (0, _renderIf2.default)(tab === 0);
	      var renderPostings = (0, _renderIf2.default)(tab === 1);
	      var renderRecommendation = (0, _renderIf2.default)(tab === 2);
	      var renderDivision = (0, _renderIf2.default)(tab === 3);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _CoachDashboardView2.default.container) },
	        renderDefault(_react2.default.createElement(_Requests2.default, this.props)),
	        renderPostings(_react2.default.createElement(_Postings2.default, this.props)),
	        renderDivision(_react2.default.createElement(_DivisionBasedStudent2.default, this.props)),
	        renderRecommendation(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _CoachDashboardView2.default.adaptContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: _CoachDashboardView2.default.emptyImage },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/no-reco-found%403x.png', alt: 'empty screen' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _CoachDashboardView2.default.noDescFound },
	            'No recommendations found.'
	          )
	        ))
	      );
	    }
	  }]);
	
	  return CoachDashboardView;
	}(_react.Component);
	
	CoachDashboardView.propTypes = {
	  tab: _propTypes2.default.number,
	  getDivisionStudents: _propTypes2.default.func.isRequired
	};
	CoachDashboardView.defaultProps = {
	  tab: 0
	};
	exports.default = CoachDashboardView;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Filter = __webpack_require__(1103);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _style = __webpack_require__(1474);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Tiles = __webpack_require__(1105);
	
	var _Tiles2 = _interopRequireDefault(_Tiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to import local scss fle
	
	
	var DivisionBasedStudents = function (_React$Component) {
	  _inherits(DivisionBasedStudents, _React$Component);
	
	  function DivisionBasedStudents() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DivisionBasedStudents);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DivisionBasedStudents.__proto__ || Object.getPrototypeOf(DivisionBasedStudents)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DivisionBasedStudents, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          divisionBasedStudents = _props.divisionBasedStudents,
	          getDivisionStudents = _props.getDivisionStudents,
	          getFilteredDivisionStudents = _props.getFilteredDivisionStudents;
	
	      var renderTiles = (0, _renderIf2.default)(divisionBasedStudents.size > 0);
	      var renderNoContentFind = (0, _renderIf2.default)(divisionBasedStudents.size === 0);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _style2.default.mainContainer) },
	        _react2.default.createElement(_Filter2.default, {
	          getDivisionStudents: getDivisionStudents,
	          getFilteredDivisionStudents: getFilteredDivisionStudents
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _style2.default.container) },
	          renderTiles(_react2.default.createElement(
	            'div',
	            null,
	            divisionBasedStudents.map(function (item) {
	              return _react2.default.createElement(_Tiles2.default, { item: item });
	            })
	          )),
	          renderNoContentFind(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _style2.default.adaptContainer) },
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.emptyImage },
	              _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/no-reco-found%403x.png', alt: 'empty screen' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.noDescFound },
	              'No recommendations found.'
	            )
	          ))
	        )
	      );
	    }
	  }]);
	
	  return DivisionBasedStudents;
	}(_react2.default.Component);
	
	DivisionBasedStudents.propTypes = {
	  divisionBasedStudents: _propTypes2.default.func.isRequired,
	  getDivisionStudents: _propTypes2.default.func.isRequired,
	  getFilteredDivisionStudents: _propTypes2.default.func.isRequired
	};
	exports.default = DivisionBasedStudents;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(1888);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _DropDownMenu = __webpack_require__(321);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	var _MenuItem = __webpack_require__(216);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _style = __webpack_require__(1472);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	var styl = {
	  positionWidth: {
	    width: '250px'
	  },
	  yearWidth: {
	    width: '150px'
	  },
	  labelStyle: {
	    color: '#4a4a4a',
	    fontSize: '12px',
	    fontWeight: '400'
	  },
	  iconStyle: {
	    color: 'blue'
	  }
	};
	
	var items = [];
	for (var i = 0; i < _DropdownsValues.positionsArray.length; i++) {
	  //eslint-disable-line
	  items.push(_react2.default.createElement(_MenuItem2.default, { value: i, key: i, primaryText: '' + _DropdownsValues.positionsArray[i] }));
	}
	
	var yearsMenuItem = [];
	for (var _i = 0; _i < _DropdownsValues.allYears.length; _i++) {
	  //eslint-disable-line
	  yearsMenuItem.push(_react2.default.createElement(_MenuItem2.default, { value: _i, key: _i, primaryText: '' + _DropdownsValues.allYears[_i] }));
	}
	
	var paginationMenuItem = [];
	for (var _i2 = 0; _i2 < _DropdownsValues.pagination.length; _i2++) {
	  //eslint-disable-line
	  paginationMenuItem.push(_react2.default.createElement(_MenuItem2.default, { value: _i2, key: _i2, primaryText: '' + _DropdownsValues.pagination[_i2] }));
	}
	
	var gpaItems = [];
	for (var _i3 = 0; _i3 < _DropdownsValues.allGpa.length; _i3++) {
	  //eslint-disable-line
	  gpaItems.push(_react2.default.createElement(_MenuItem2.default, { value: _i3, key: _i3, primaryText: '' + _DropdownsValues.allGpa[_i3] }));
	}
	
	var statesItems = [];
	for (var _i4 = 0; _i4 < _DropdownsValues.statesArray.length; _i4++) {
	  //eslint-disable-line
	  statesItems.push(_react2.default.createElement(_MenuItem2.default, { value: _i4, key: _i4, primaryText: '' + _DropdownsValues.statesArray[_i4] }));
	}
	
	var Filter = function (_React$Component) {
	  _inherits(Filter, _React$Component);
	
	  function Filter(props) {
	    _classCallCheck(this, Filter);
	
	    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));
	
	    _this.handlePositionChange = function (event, index, value) {
	      if (_this.state.positionIndex !== index) {
	        _this.setState({ positionValue: value, positionIndex: index }, _this.handleFilterChange);
	      }
	    };
	
	    _this.handlePaginationChange = function (event, index, value) {
	      if (_this.state.paginationIndex !== index) {
	        _this.setState({ paginationValue: _DropdownsValues.paginationKey[value], paginationIndex: index }, _this.handleFilterChange);
	      }
	    };
	
	    _this.handleYearChange = function (event, index, value) {
	      if (_this.state.yearIndex !== index) {
	        _this.setState({ selectedYear: _DropdownsValues.allYears[value], yearIndex: index }, _this.handleFilterChange);
	      }
	    };
	
	    _this.handleGpaChange = function (event, index, value) {
	      if (_this.state.gpaIndex !== index) {
	        _this.setState({ gpaIndex: value }, _this.handleFilterChange);
	      }
	    };
	
	    _this.handleStateChange = function (event, index, value) {
	      if (_this.state.statesIndex !== index) {
	        _this.setState({ statesIndex: value }, _this.handleFilterChange);
	      }
	    };
	
	    _this.handleFilterChange = function () {
	      var _this$state = _this.state,
	          paginationValue = _this$state.paginationValue,
	          paginationIndex = _this$state.paginationIndex,
	          yearIndex = _this$state.yearIndex,
	          statesIndex = _this$state.statesIndex,
	          positionValue = _this$state.positionValue,
	          selectedYear = _this$state.selectedYear,
	          positionIndex = _this$state.positionIndex,
	          gpaIndex = _this$state.gpaIndex;
	
	      var payload = {
	        pagination: paginationValue,
	        min_gpa: parseFloat((0, _lodash2.default)(_DropdownsValues.gpaKey, function (o) {
	          return o === _DropdownsValues.allGpa[gpaIndex];
	        }))
	      };
	      if (paginationIndex === 0 && positionIndex === 0 && yearIndex === 0 && statesIndex === 0 && gpaIndex === 0) {
	        _this.props.getDivisionStudents();
	      } else {
	        if (yearIndex) payload['year_of_graduation'] = selectedYear; // eslint-disable-line
	        if (positionIndex) {
	          var positionKey = (0, _lodash2.default)(_DropdownsValues.positions, function (o) {
	            return o === _DropdownsValues.positionsArray[positionValue];
	          });
	          var position = {
	            position_value: positionKey,
	            position_name: _DropdownsValues.positionNames[positionKey]
	          };
	          payload['position'] = position; // eslint-disable-line
	        }
	        if (statesIndex) payload['state'] = (0, _lodash2.default)(_DropdownsValues.states, function (o) {
	          return o === _DropdownsValues.statesArray[statesIndex];
	        }); // eslint-disable-line
	        if (gpaIndex) payload['min_gpa'] = parseFloat((0, _lodash2.default)(_DropdownsValues.gpaKey, function (o) {
	          return o === _DropdownsValues.allGpa[gpaIndex];
	        })); // eslint-disable-line
	        _this.props.getFilteredDivisionStudents(payload);
	      }
	    };
	
	    _this.resetFilters = function () {
	      _this.setState({
	        positionIndex: 0,
	        yearIndex: 0,
	        gpaIndex: 0,
	        statesIndex: 0,
	        paginationIndex: 0,
	        paginationValue: 20,
	        positionValue: 'All Positions',
	        selectedYear: 'All Years'
	      });
	      _this.props.getDivisionStudents();
	    };
	
	    _this.state = {
	      positionIndex: 0,
	      yearIndex: 0,
	      gpaIndex: 0,
	      statesIndex: 0,
	      paginationIndex: 0,
	      paginationValue: 20,
	      positionValue: 'All Positions',
	      selectedYear: 'All Years'
	    };
	    return _this;
	  }
	
	  _createClass(Filter, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          positionIndex = _state.positionIndex,
	          yearIndex = _state.yearIndex,
	          paginationIndex = _state.paginationIndex,
	          gpaIndex = _state.gpaIndex,
	          statesIndex = _state.statesIndex,
	          positionValue = _state.positionValue,
	          selectedYear = _state.selectedYear;
	
	      var renderClearFilter = (0, _renderIf2.default)(positionIndex !== 0 || yearIndex !== 0 || gpaIndex !== 0 || statesIndex !== 0 || paginationIndex !== 0 || positionValue !== 'All Positions' || selectedYear !== 'All Years');
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _style2.default.remove_padding) },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _DropDownMenu2.default,
	            {
	              className: _style2.default.paginationDropdown,
	              value: paginationIndex,
	              onChange: this.handlePaginationChange,
	              autoWidth: true,
	              labelStyle: styl.labelStyle,
	              maxHeight: 300,
	              iconStyle: styl.iconStyle
	            },
	            paginationMenuItem
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _DropDownMenu2.default,
	            {
	              className: _style2.default.dropDownMenu,
	              value: yearIndex,
	              onChange: this.handleYearChange,
	              autoWidth: true,
	              labelStyle: styl.labelStyle,
	              maxHeight: 300,
	              iconStyle: styl.iconStyle
	            },
	            yearsMenuItem
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _DropDownMenu2.default,
	            {
	              className: _style2.default.dropDownMenu,
	              value: positionIndex,
	              onChange: this.handlePositionChange,
	              autoWidth: true,
	              labelStyle: styl.labelStyle,
	              maxHeight: 250,
	              iconStyle: styl.iconStyle
	            },
	            items
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _DropDownMenu2.default,
	            {
	              className: _style2.default.dropDownMenu,
	              value: gpaIndex,
	              onChange: this.handleGpaChange,
	              autoWidth: true,
	              labelStyle: styl.labelStyle,
	              maxHeight: 300,
	              iconStyle: styl.iconStyle
	            },
	            gpaItems
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _style2.default.remove_padding) },
	          _react2.default.createElement(
	            _DropDownMenu2.default,
	            {
	              className: _style2.default.allStates,
	              value: statesIndex,
	              onChange: this.handleStateChange,
	              autoWidth: true,
	              labelStyle: styl.labelStyle,
	              maxHeight: 300,
	              iconStyle: styl.iconStyle
	            },
	            statesItems
	          ),
	          renderClearFilter(_react2.default.createElement(
	            'button',
	            { onClick: this.resetFilters, className: _style2.default.clearFilter },
	            'Clear filter'
	          ))
	        )
	      );
	    }
	  }]);
	
	  return Filter;
	}(_react2.default.Component);
	
	Filter.propTypes = {
	  getDivisionStudents: _propTypes2.default.func.isRequired,
	  getFilteredDivisionStudents: _propTypes2.default.func.isRequired
	};
	exports.default = Filter;

/***/ },
/* 1103 */
[2527, 1102],
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _Rtiles = __webpack_require__(1473);
	
	var _Rtiles2 = _interopRequireDefault(_Rtiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	//  to change path from inside or to alter react-router-dom path
	// import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';
	// import Divider from 'components/Divider';
	
	
	// to import local scss fle
	
	var Rtiles = function (_Component) {
	  _inherits(Rtiles, _Component);
	
	  function Rtiles(props) {
	    _classCallCheck(this, Rtiles);
	
	    var _this = _possibleConstructorReturn(this, (Rtiles.__proto__ || Object.getPrototypeOf(Rtiles)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Rtiles, [{
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	
	
	      var athleteHaveProfileImage = false;
	      if (item.get('sa_image') !== undefined) {
	        athleteHaveProfileImage = true;
	      }
	      var sport = item.get('sports');
	      var position = sport.get('FOOTBALL');
	      return _react2.default.createElement(
	        'div',
	        { className: _Rtiles2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _Rtiles2.default.tile },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/athlete/' + item.get('id'), target: '_blank' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', {
	                className: _Rtiles2.default.colgeIcon,
	                src: athleteHaveProfileImage === true ? //eslint-disable-line
	                'https://s3.amazonaws.com/myrbimagesdev/' + item.get('sa_image') : //eslint-disable-line
	                'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	                alt: 'athlete-icon'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _Rtiles2.default.collegeName },
	                item.get('fullname')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Rtiles2.default.sportName },
	                position.get('primary_offensive_position_pref') !== undefined ? _react2.default.createElement(
	                  'span',
	                  null,
	                  position.get('primary_offensive_position_pref')
	                ) : '',
	                position.get('primary_defensive_position_pref') !== undefined ? _react2.default.createElement(
	                  'span',
	                  null,
	                  ',\xA0\xA0',
	                  position.get('primary_defensive_position_pref')
	                ) : '',
	                position.get('secondary_offensive_position_pref') !== undefined ? _react2.default.createElement(
	                  'span',
	                  null,
	                  ',\xA0',
	                  position.get('secondary_offensive_position_pref')
	                ) : '',
	                '\xA0',
	                position.get('secondary_defensive_position_pref') !== undefined ? _react2.default.createElement(
	                  'span',
	                  null,
	                  ',\xA0',
	                  position.get('secondary_defensive_position_pref')
	                ) : ''
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Rtiles2.default.userNameIcon },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Rtiles2.default.schoolName },
	                    item.get('school')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Rtiles2.default.cityName },
	                    item.get('city'),
	                    ', ',
	                    _DropdownsValues.states[item.get('sa_state')]
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Rtiles2.default.lightText },
	                    item.get('academic').get('year_of_graduation'),
	                    ',\xA0\xA0',
	                    item.getIn(['academic', 'gpa'])
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Rtiles;
	}(_react.Component);
	
	Rtiles.propTypes = {
	  item: _propTypes2.default.shape()
	};
	Rtiles.defaultProps = {
	  item: {}
	};
	exports.default = Rtiles;

/***/ },
/* 1105 */
[2528, 1104],
/* 1106 */
[2527, 1101],
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachDashboardView = __webpack_require__(1100);
	
	var _CoachDashboardView2 = _interopRequireDefault(_CoachDashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachDashboardView2.default;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navbar = __webpack_require__(159);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _immutable = __webpack_require__(11);
	
	var _CoachHeader = __webpack_require__(1475);
	
	var _CoachHeader2 = _interopRequireDefault(_CoachHeader);
	
	var _CoachTabs = __webpack_require__(450);
	
	var _CoachTabs2 = _interopRequireDefault(_CoachTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	//  to change path from inside or to alter react-router-dom path
	// to import local scss fle
	
	
	var CoachHeader = function (_Component) {
	  _inherits(CoachHeader, _Component);
	
	  function CoachHeader(props) {
	    _classCallCheck(this, CoachHeader);
	
	    var _this = _possibleConstructorReturn(this, (CoachHeader.__proto__ || Object.getPrototypeOf(CoachHeader)).call(this, props));
	
	    _this.state = {
	      removeDropdownLinks: true
	    };
	    return _this;
	  }
	
	  _createClass(CoachHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          college = _props.college,
	          questionLink = _props.questionLink,
	          city = _props.city,
	          sport = _props.sport,
	          teamPageLink = _props.teamPageLink,
	          profile = _props.profile;
	
	      var renderQuestionLink = (0, _renderIf2.default)(this.props.questionLink !== '');
	      var immutableProfile = (0, _immutable.fromJS)(profile);
	      var renderTabs = (0, _renderIf2.default)(immutableProfile.size > 0);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _CoachHeader2.default.container) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _CoachHeader2.default.navContainer) },
	          _react2.default.createElement(_Navbar2.default, Object.assign({}, this.props, { navBarUsedBy: 'coach' }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _CoachHeader2.default.details) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _CoachHeader2.default.imageAndName) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s4 m2 l1', _CoachHeader2.default.imageContainer) },
	              _react2.default.createElement('div', { className: _CoachHeader2.default.userImage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s8 m10 l11', _CoachHeader2.default.basicInfo) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _CoachHeader2.default.infoText) },
	                _react2.default.createElement(
	                  'p',
	                  { className: _CoachHeader2.default.playerName },
	                  name
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'p',
	                  { className: _CoachHeader2.default.sports },
	                  _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/Football-01.png', alt: 'football-icon' }),
	                  sport,
	                  ' Coach'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'p',
	                  { className: _CoachHeader2.default.location },
	                  college,
	                  ',',
	                  city,
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12 m10 l11', _CoachHeader2.default.basicInfoReplica) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s6 m4 l3', _CoachHeader2.default.removePadding) },
	                    _react2.default.createElement(
	                      'a',
	                      { href: teamPageLink, target: '_blank' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: _CoachHeader2.default.linkButton },
	                        ' TEAM PAGE'
	                      )
	                    )
	                  ),
	                  renderQuestionLink(_react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s6 m4 l3', _CoachHeader2.default.removePadding) },
	                    _react2.default.createElement(
	                      'a',
	                      { href: questionLink, target: '_blank' },
	                      _react2.default.createElement(
	                        'span',
	                        { className: _CoachHeader2.default.linkButton },
	                        ' QUESTIONAIRE LINK'
	                      )
	                    )
	                  ))
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/settings' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: _CoachHeader2.default.coachEditButton },
	                    'EDIT PROFILE'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _CoachHeader2.default.otherDescription) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _CoachHeader2.default.basicInfoReplica) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s6', _CoachHeader2.default.removePadding) },
	                _react2.default.createElement(
	                  'a',
	                  { href: teamPageLink, target: '_blank' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _CoachHeader2.default.linkButton },
	                    ' TEAM PAGE'
	                  )
	                )
	              ),
	              renderQuestionLink(_react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s6', _CoachHeader2.default.removePadding) },
	                _react2.default.createElement(
	                  'a',
	                  { href: questionLink, target: '_blank' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _CoachHeader2.default.linkButton },
	                    ' QUESTIONAIRE LINK'
	                  )
	                )
	              ))
	            )
	          )
	        ),
	        renderTabs(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _CoachHeader2.default.tabsContainer) },
	          _react2.default.createElement(_CoachTabs2.default, { tabListener: this.props.tabListener, division: immutableProfile.get('division') })
	        ))
	      );
	    }
	  }]);
	
	  return CoachHeader;
	}(_react.Component);
	
	CoachHeader.propTypes = {
	  name: _propTypes2.default.string,
	  college: _propTypes2.default.string,
	  questionLink: _propTypes2.default.string,
	  city: _propTypes2.default.string,
	  sport: _propTypes2.default.string,
	  teamPageLink: _propTypes2.default.string,
	  tabListener: _propTypes2.default.func,
	  profile: _propTypes2.default.shape()
	};
	CoachHeader.defaultProps = {
	  name: '',
	  college: '',
	  questionLink: '',
	  city: '',
	  sport: '',
	  teamPageLink: '',
	  profile: (0, _immutable.Map)(),
	  tabListener: function tabListener() {}
	};
	exports.default = CoachHeader;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachHeader = __webpack_require__(1108);
	
	var _CoachHeader2 = _interopRequireDefault(_CoachHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachHeader2.default;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Popup = __webpack_require__(1476);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var Info = function (_Component) {
	  _inherits(Info, _Component);
	
	  function Info(props) {
	    _classCallCheck(this, Info);
	
	    var _this = _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).call(this, props));
	
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.state = {
	      open: true,
	      title: ''
	    };
	    return _this;
	  }
	  // static propTypes = {
	  //   totalCounts: PropTypes.shape().isRequired,
	  // };
	
	
	  _createClass(Info, [{
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)'
	        },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          paddingTop: '50px',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      var open = this.state.open;
	      // let getTotalCountsCompleted = false;
	      // if (this.props.totalCounts.size > 0) {
	      //   getTotalCountsCompleted = true;
	      // }
	      // const renderModal = renderIf(getTotalCountsCompleted);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: open, onRequestClose: this.onCloseModal },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row', _Popup2.default.popupContainer) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12') },
	              this.props.text
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Popup2.default.buttonContainer) },
	              _react2.default.createElement(
	                'button',
	                { onClick: this.onCloseModal },
	                'CLOSE'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Info;
	}(_react.Component);
	
	Info.defaultProps = {
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = Info;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CoachPostings = __webpack_require__(1477);
	
	var _CoachPostings2 = _interopRequireDefault(_CoachPostings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	
	// to import local scss fle
	
	var positions = {
	  QBDT: 'Quarterback - Duel Threat',
	  QBPS: 'Quarterback - Pro Style',
	  WR: 'Wide Receiver',
	  SR: 'Slot Receiver',
	  RB: 'Running Back',
	  FB: 'Full Back',
	  HB: 'H-Back',
	  TE: 'Tight End',
	  OG: 'Offensive Guard',
	  OT: 'Offensive Tackle',
	  C: 'Center',
	  DT: 'Defensive Tackle',
	  DE: 'Defensive End',
	  ML: 'Middle Linebacker',
	  OL: 'Outside Linebacker',
	  DB: 'Cornerback',
	  SS: 'Strong Safety',
	  FS: 'Free Safety',
	  K: 'Kicker',
	  P: 'Punter',
	  LS: 'Long Snapper'
	};
	
	var PostingTile = function (_Component) {
	  _inherits(PostingTile, _Component);
	
	  function PostingTile(props) {
	    _classCallCheck(this, PostingTile);
	
	    var _this = _possibleConstructorReturn(this, (PostingTile.__proto__ || Object.getPrototypeOf(PostingTile)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    _this.openEditPosting = _this.openEditPosting.bind(_this);
	    return _this;
	  }
	
	  _createClass(PostingTile, [{
	    key: 'openEditPosting',
	    value: function openEditPosting(id, index) {
	      this.props.editPosting();
	      this.props.setPostingId(id, index);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          item = _props.item,
	          index = _props.index;
	
	      var requirements = item.get('requirements');
	      return _react2.default.createElement(
	        'div',
	        { className: _CoachPostings2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _CoachPostings2.default.tile },
	          _react2.default.createElement(
	            'button',
	            { onClick: function onClick() {
	                return _this2.openEditPosting(item.get('id'), index);
	              }, className: _CoachPostings2.default.editIcon },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/editIcon.png', alt: 'edit-icon' })
	          ),
	          _react2.default.createElement('img', { className: _CoachPostings2.default.colgeIcon, src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon' }),
	          _react2.default.createElement(
	            'div',
	            { className: _CoachPostings2.default.collegeName },
	            _react2.default.createElement(
	              'span',
	              null,
	              item.get('college_name')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _CoachPostings2.default.lightText },
	              item.get('city')
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _CoachPostings2.default.postingTitle },
	            _react2.default.createElement(
	              'span',
	              null,
	              positions[item.get('posting_title')]
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _CoachPostings2.default.lightText },
	            ' Height:',
	            requirements.get('min_height'),
	            ' , Weight: ',
	            requirements.get('min_weight'),
	            ', Gpa : ',
	            requirements.get('min_gpa'),
	            ', 40-Yard Dash : ',
	            requirements.get('min_t40')
	          )
	        )
	      );
	    }
	  }]);
	
	  return PostingTile;
	}(_react.Component);
	
	PostingTile.propTypes = {
	  item: _propTypes2.default.shape(),
	  editPosting: _propTypes2.default.func,
	  setPostingId: _propTypes2.default.func,
	  index: _propTypes2.default.number
	};
	PostingTile.defaultProps = {
	  item: {},
	  attributes: {},
	  editPosting: function editPosting() {},
	  setPostingId: function setPostingId() {},
	  index: 0
	};
	exports.default = PostingTile;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachPostings = __webpack_require__(1111);
	
	var _CoachPostings2 = _interopRequireDefault(_CoachPostings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachPostings2.default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _reactAutocomplete = __webpack_require__(342);
	
	var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _reactRouterRedux = __webpack_require__(241);
	
	var _immutable = __webpack_require__(11);
	
	var _redux = __webpack_require__(449);
	
	var _actions = __webpack_require__(1114);
	
	var _CoachRegistration = __webpack_require__(1478);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// to connect to redux store from containers redux.js or any other redux store
	// to use input from react-toolbox library
	// to use conditional rendering based oemailErrorMessagen values that is provided to component
	// to display error messages on invalid user input
	// to show loder on screen whenever there is a api call or operations in component
	// regular expressions to validate user input
	// use of immutablejs for various js operations to simplify our work
	
	
	// to import local scss fle
	
	var Allstate = {
	  AL: 'Alabama',
	  AK: 'Alaska',
	  AZ: 'Arizona',
	  AR: 'Arkansas',
	  CA: 'California',
	  CO: 'Colorado',
	  CT: 'Connecticut',
	  DE: 'Delaware',
	  DC: 'District Of Columbia',
	  FM: 'Federated States Of Micronesia',
	  FL: 'Florida',
	  GA: 'Georgia',
	  HI: 'Hawaii',
	  ID: 'Idaho',
	  IL: 'Illinois',
	  IN: 'Indiana',
	  IA: 'Iowa',
	  KS: 'Kansas',
	  KY: 'Kentucky',
	  LA: 'Louisiana',
	  ME: 'Maine',
	  MD: 'Maryland',
	  MA: 'Massachusetts',
	  MI: 'Michigan',
	  MN: 'Minnesota',
	  MS: 'Mississippi',
	  MO: 'Missouri',
	  MT: 'Montana',
	  NE: 'Nebraska',
	  NV: 'Nevada',
	  NH: 'New Hampshire',
	  NJ: 'New Jersey',
	  NM: 'New Mexico',
	  NY: 'New York',
	  NC: 'North Carolina',
	  ND: 'North Dakota',
	  OH: 'Ohio',
	  OK: 'Oklahoma',
	  OR: 'Oregon',
	  PA: 'Pennsylvania',
	  RI: 'Rhode Island',
	  SC: 'South Carolina',
	  SD: 'South Dakota',
	  TN: 'Tennessee',
	  TX: 'Texas',
	  UT: 'Utah',
	  VT: 'Vermont',
	  VA: 'Virginia',
	  WA: 'Washington',
	  WV: 'West Virginia',
	  WI: 'Wisconsin',
	  WY: 'Wyoming'
	};
	
	var CoachRegistrationModal = function (_Component) {
	  _inherits(CoachRegistrationModal, _Component);
	
	  function CoachRegistrationModal(props) {
	    _classCallCheck(this, CoachRegistrationModal);
	
	    var _this = _possibleConstructorReturn(this, (CoachRegistrationModal.__proto__ || Object.getPrototypeOf(CoachRegistrationModal)).call(this, props));
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value)));
	    };
	
	    _this.state = {
	      fullname: '',
	      collegeName: '',
	      school: '',
	      schoolNames: [],
	      states: '',
	      city: '',
	      division: '',
	      sport: 'FOOTBALL',
	      validHighSchool: false,
	      highSchoolErrorMessage: '',
	      validState: false,
	      stateErrorMessage: '',
	      validCity: false,
	      cityErrorMessage: '',
	      validTeamPageUrl: false,
	      teamPageUrlErrorMessage: '',
	      schoolOnContact: '',
	      validQuestionaire: false,
	      questionaireErrorMessage: '',
	      startLoader: false
	    };
	    _this.schoolSearch = _this.schoolSearch.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.removeValue = _this.removeValue.bind(_this);
	    _this.Map = _immutable.Map;
	    _this.is = _immutable.is;
	    return _this;
	  }
	
	  _createClass(CoachRegistrationModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.attributes && this.props.attributes.size > 0 && !this.props.validCoachData.size > 0) {
	        var payload = {};
	        payload = Object.assign({
	          coach_email: this.props.attributes.get('email')
	        });
	        this.props.getCoachFromDatabase(payload);
	      }
	      if (this.props.validCoachData.size > 0) {
	        var results = this.props.validCoachData.get('hits');
	        var totalHits = results.get('hits').size;
	        if (totalHits > 0) {
	          results = results.get('hits');
	          results = results.toJS();
	          var firstItemFromElastic = results[0]._source; // eslint-disable-line
	          var newState = {
	            coachId: firstItemFromElastic.coach_id,
	            schoolId: firstItemFromElastic.college_id,
	            teamPageUrl: firstItemFromElastic.team_page_link,
	            questionLink: firstItemFromElastic.question_link,
	            division: firstItemFromElastic.division,
	            city: firstItemFromElastic.city,
	            name: firstItemFromElastic.name,
	            states: firstItemFromElastic.state,
	            sport: firstItemFromElastic.sport,
	            school: firstItemFromElastic.college,
	            coachEmail: firstItemFromElastic.coach_email,
	            description: firstItemFromElastic.description
	          };
	          this.setState(newState);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.coachRegistered && this.props.coachRegistered !== nextProps.coachRegistered && (0, _immutable.is)(this.props.schools, nextProps.schools)) {
	        this.props.history.push('/view/coach/dashboard');
	        debugger; // eslint-disable-line
	      }
	      // if ( nextProps.coachRegistered && !nextProps.isLoading ){
	      //   this.props.history.push('/view/coach/dashboard');
	      // }
	      // debugger;  // eslint-disable-line
	      if (nextProps.attributes.size > 0 && !nextProps.validCoachData.size > 0 && !nextProps.validateCoachRequested) {
	        var payload = {};
	        payload = Object.assign({
	          coach_email: nextProps.attributes.get('email')
	        });
	        this.props.getCoachFromDatabase(payload);
	      } else if (nextProps.validCoachData.size > 0 && (0, _immutable.is)(this.props.schools, nextProps.schools)) {
	        var results = nextProps.validCoachData.get('hits');
	        var totalHits = results.get('hits').size;
	        if (totalHits > 0) {
	          results = results.get('hits');
	          results = results.toJS();
	          var firstItemFromElastic = results[0]._source; // eslint-disable-line
	          var newState = {
	            coachId: firstItemFromElastic.coach_id,
	            schoolId: firstItemFromElastic.college_id,
	            teamPageUrl: firstItemFromElastic.team_page_link,
	            questionLink: firstItemFromElastic.question_link,
	            division: firstItemFromElastic.division,
	            city: firstItemFromElastic.city,
	            name: firstItemFromElastic.name,
	            states: firstItemFromElastic.state,
	            sport: firstItemFromElastic.sport,
	            school: firstItemFromElastic.college,
	            coachEmail: firstItemFromElastic.coach_email,
	            description: firstItemFromElastic.description
	          };
	          this.setState(newState);
	        }
	      }
	      var _props$schools = this.props.schools,
	          schools = _props$schools === undefined ? {} : _props$schools;
	
	      if (this.Map.isMap(nextProps.schools) && !this.is(nextProps.schools, schools)) {
	        var total = nextProps.schools.get('hits').get('total');
	        var hits = [];
	        if (total > 0) {
	          var _results = nextProps.schools.get('hits');
	          _results = _results.get('hits');
	          _results = _results.toJS();
	
	          _results.forEach(function (school) {
	            var obj = {};
	            var college = school._source.college; // eslint-disable-line
	            var collegeId = school._source.id; // eslint-disable-line
	            var cityFromCollege = school._source.city; // eslint-disable-line
	            var stateFromCollege = school._source.state; // eslint-disable-line
	            var question = school._source.football_questionaire_page; // eslint-disable-line
	            var teamPage = school._source.football_team_page; // eslint-disable-line
	            var twitter = school._source.college_twitter; // eslint-disable-line
	            var coachDivision = school._source.division; // eslint-disable-line
	            var id = school._source.id; // eslint-disable-line
	            var idKey = collegeId; // eslint-disable-line
	            var hbcu = school._source.hbcu; // eslint-disable-line
	            var minAct = school._source.min_act; // eslint-disable-line
	            var minGpa = school._source.min_gpa; // eslint-disable-line
	            obj.minGpa = minGpa;
	            obj.minAct = minAct;
	            obj.hbcu = hbcu;
	            obj.value = college;
	            obj.key = idKey;
	            obj.state = stateFromCollege;
	            obj.city = cityFromCollege;
	            obj.teamPageUrl = teamPage;
	            obj.collegetwitter = twitter;
	            obj.questionLink = question;
	            obj.division = coachDivision;
	            obj.id = id;
	            hits.push(obj);
	          });
	          this.setState({ schoolNames: hits });
	        }
	      }
	    }
	  }, {
	    key: 'schoolSearch',
	    value: function schoolSearch(name, value) {
	      var _this2 = this;
	
	      if (this.timer) {
	        clearTimeout(this.timer);
	      }
	
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	
	      if (value && value.length >= 3) {
	        this.timer = setTimeout(function () {
	          _this2.props.searchSchools(value);
	        }, 100);
	      }
	    }
	  }, {
	    key: 'removeValue',
	    value: function removeValue(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'handleOnclick',
	    value: function handleOnclick(value) {
	      var _this3 = this;
	
	      /* validations for field */
	      var enteredValue = this.state.school;
	      var highSchool = typeof enteredValue === 'string';
	      var updated = {};
	      if (highSchool && this.state.school !== '') {
	        updated.validHighSchool = true;
	      } else {
	        updated.highSchoolErrorMessage = 'PLease insert a valid school name';
	      }
	      /* validations for field */
	
	      /* validation for state */
	      if (this.state.states === '') {
	        updated.stateErrorMessage = 'Please select state.';
	      } else {
	        updated.validState = true;
	      }
	      /* validation for state */
	
	      /* validation of city */
	      var selectedCity = _Regularexpression.regExForName.test(this.state.city);
	      if (selectedCity && this.state.city !== '') {
	        updated.validCity = true;
	      } else {
	        updated.cityErrorMessage = 'City is not added.';
	      }
	      /* validation of city */
	
	      /* validation for teamPageUrl */
	      // const enteredTeamPageUrl = regExForUrl.test(this.state.teamPageUrl);
	      if (this.state.teamPageUrl !== '' && this.state.teamPageUrl !== undefined) {
	        updated.validTeamPageUrl = true;
	      } else {
	        updated.teamPageUrlErrorMessage = 'Please insert a valid url.';
	      }
	      /* validation for teamPageUrl */
	
	      /* validation for Questionnaire Link */
	      // const enteredQuestionaireLink = regExForUrl.test(this.state.questionLink);
	      if (this.state.questionLink === '' && this.state.questionLink !== undefined) {
	        updated.validQuestionaire = true;
	      } else if (this.state.questionLink === 'no page') {
	        updated.questionaireErrorMessage = 'Please add a valid questionaire url';
	      } else if (this.state.questionLink !== '' && this.state.questionLink !== undefined) {
	        updated.validQuestionaire = true;
	      } else {
	        updated.questionaireErrorMessage = 'Please add a valid questionaire url';
	      }
	      /* validation for question lin */
	
	      this.setState(updated, function () {
	        var payload = {};
	        var s = _this3.state;
	        // eslint-disable-next-line
	        var profile_pic = 'no_profile_pic';
	        var school = s.school,
	            schoolId = s.schoolId,
	            sport = s.sport,
	            states = s.states,
	            city = s.city,
	            teamPageUrl = s.teamPageUrl,
	            questionLink = s.questionLink,
	            division = s.division,
	            validHighSchool = s.validHighSchool,
	            validQuestionaire = s.validQuestionaire,
	            validTeamPageUrl = s.validTeamPageUrl,
	            validCity = s.validCity,
	            validState = s.validState,
	            coachId = s.coachId;
	
	
	        payload = Object.assign(payload, {
	          fullname: _this3.props.attributes.get('name'),
	          college: school,
	          coach_id: coachId,
	          college_id: schoolId,
	          sport: sport,
	          state: states,
	          city: city,
	          profile_pic: profile_pic,
	          division: division,
	          team_page_link: teamPageUrl
	        });
	        if (questionLink !== '') {
	          payload['question_link'] = questionLink; // eslint-disable-line
	        }
	        if (validHighSchool && validQuestionaire && validTeamPageUrl && validCity && validState) {
	          _this3.props.saveCoachProfile(payload);
	          if (value === 'loader') {
	            _this3.setState({ startLoader: true });
	          }
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          usedFor = _props.usedFor,
	          adminStyles = _props.adminStyles;
	
	      var renderWhileRegistration = (0, _renderIf2.default)(this.props.usedFor === 'register');
	      var renderWhileModify = (0, _renderIf2.default)(this.props.usedFor === 'modify');
	      var renderInContactForm = (0, _renderIf2.default)(this.props.usedFor === 'contact');
	      var renderLoader = (0, _renderIf2.default)(this.state.startLoader);
	      var renderLoaderWhileRegistration = (0, _renderIf2.default)(this.state.startLoader);
	      return _react2.default.createElement(
	        'div',
	        { className: usedFor === 'register' ? (0, _classnames2.default)('row', _CoachRegistration2.default.coachRegistrationContainer) : (0, _classnames2.default)('row', adminStyles) },
	        renderInContactForm(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _CoachRegistration2.default.autoCompleteContact) },
	          _react2.default.createElement(
	            'div',
	            { className: this.state.highSchoolErrorMessage === '' ? _CoachRegistration2.default.autoCompleteContainer : _CoachRegistration2.default.autoCompleteContainerOnError },
	            _react2.default.createElement(_reactAutocomplete2.default, {
	              inputProps: { name: 'School', id: 'schools-autocomplete', placeholder: 'College' },
	              ref: 'schools-autocomplete' // eslint-disable-line
	              , value: this.state.schoolOnContact,
	              items: this.state.schoolNames,
	              getItemValue: function getItemValue(item) {
	                return item.value;
	              },
	              onSelect: function onSelect(school, item) {
	                // set the menu to only the selected item
	                _this4.setState({ schoolOnContact: item.value, highSchoolErrorMessage: '' });
	                _this4.props.getDataForCoach(item);
	              },
	              onChange: function onChange(event, value) {
	                if (_this4.timer) {
	                  clearTimeout(_this4.timer);
	                }
	                _this4.setState(Object.assign({}, _this4.state, {
	                  schoolOnContact: value,
	                  highSchoolErrorMessage: '',
	                  city: '',
	                  states: '',
	                  teamPageUrl: '',
	                  questionLink: '',
	                  divisions: '' }));
	
	                if (value && value.length >= 3) {
	                  _this4.timer = setTimeout(function () {
	                    _this4.props.searchSchools(value);
	                  }, 100);
	                }
	                _this4.props.writeCollegeName(value);
	              },
	              renderItem: function renderItem(item, isHighlighted) {
	                return _react2.default.createElement(
	                  'div',
	                  {
	                    style: { background: isHighlighted ? 'lightgray' : 'white' },
	                    key: item.key,
	                    id: item.key
	                  },
	                  item.value
	                );
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.highSchoolErrorMessage })
	          )
	        )),
	        renderWhileRegistration(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _CoachRegistration2.default.wrapper) },
	          renderLoaderWhileRegistration(_react2.default.createElement(_FullScreenLoader2.default, null)),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _CoachRegistration2.default.header) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Almost there! ',
	              _react2.default.createElement('br', null),
	              ' Fill the below details'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _CoachRegistration2.default.inputsContainer) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.autoComplete) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'COLLEGE NAME'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.highSchoolErrorMessage === '' ? _CoachRegistration2.default.autoCompleteContainer : _CoachRegistration2.default.autoCompleteContainerOnError },
	                _react2.default.createElement(_reactAutocomplete2.default, {
	                  inputProps: { name: 'School', id: 'schools-autocomplete' },
	                  ref: 'schools-autocomplete' // eslint-disable-line
	                  , value: this.state.school,
	                  items: this.state.schoolNames,
	                  getItemValue: function getItemValue(item) {
	                    return item.value;
	                  },
	                  onSelect: function onSelect(school, item) {
	                    // set the menu to only the selected item
	                    _this4.setState({ school: item.value, highSchoolErrorMessage: '' });
	                    _this4.setState({ schoolId: item.key,
	                      city: item.city,
	                      states: item.state,
	                      teamPageUrl: item.teamPageUrl,
	                      questionLink: item.questionLink,
	                      divisions: item.divisions });
	                    // or you could reset it to a default list again
	                    // this.setState({ unitedStates: getStates() })
	                  },
	                  onChange: function onChange(event, value) {
	                    if (_this4.timer) {
	                      clearTimeout(_this4.timer);
	                    }
	                    _this4.setState(Object.assign({}, _this4.state, {
	                      school: value,
	                      highSchoolErrorMessage: '',
	                      city: '',
	                      states: '',
	                      teamPageUrl: '',
	                      questionLink: '',
	                      divisions: '' }));
	
	                    if (value && value.length >= 3) {
	                      _this4.timer = setTimeout(function () {
	                        _this4.props.searchSchools(value);
	                      }, 100);
	                    }
	                  },
	                  renderItem: function renderItem(item, isHighlighted) {
	                    return _react2.default.createElement(
	                      'div',
	                      {
	                        style: { background: isHighlighted ? 'lightgray' : 'white' },
	                        key: item.key,
	                        id: item.key
	                      },
	                      item.value
	                    );
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: this.state.highSchoolErrorMessage })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.autoComplete) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'SPORT'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _CoachRegistration2.default.autoCompleteToolbox },
	                _react2.default.createElement(_autocomplete2.default, {
	                  value: this.state.sport,
	                  onChange: function onChange(val) {
	                    return _this4.handleChange('sport', val);
	                  },
	                  multiple: false
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.autoCompleteState) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'STATE'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: this.state.stateErrorMessage === '' ? _CoachRegistration2.default.autoCompleteToolbox : _CoachRegistration2.default.autoCompleteToolboxOnError },
	                _react2.default.createElement(_autocomplete2.default, {
	                  onChange: function onChange(val) {
	                    return _this4.handleChange('states', val);
	                  },
	                  source: Allstate,
	                  onFocus: function onFocus() {
	                    return _this4.removeValue('stateErrorMessage');
	                  },
	                  onQueryChange: function onQueryChange(val) {
	                    return _this4.handleChange('states', val);
	                  },
	                  value: this.state.states,
	                  multiple: false
	                })
	              ),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.stateErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.cityErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanOnError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'CITY'
	              ),
	              _react2.default.createElement(_input2.default, {
	                value: this.state.city,
	                onChange: function onChange(val) {
	                  return _this4.handleChange('city', val);
	                },
	                onFocus: function onFocus() {
	                  return _this4.removeValue('cityErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.cityErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.teamPageUrlErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpace) : (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpaceOnError)
	              },
	              _react2.default.createElement(
	                'span',
	                null,
	                'TEAM PAGE URL'
	              ),
	              _react2.default.createElement(_input2.default, {
	                value: this.state.teamPageUrl,
	                onChange: function onChange(val) {
	                  return _this4.handleChange('teamPageUrl', val);
	                },
	                onFocus: function onFocus() {
	                  return _this4.removeValue('teamPageUrlErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.teamPageUrlErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: this.state.questionaireErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpace) : (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpaceOnError)
	              },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Questionnaire Link'
	              ),
	              _react2.default.createElement(_input2.default, {
	                value: this.state.questionLink,
	                onChange: function onChange(val) {
	                  return _this4.handleChange('questionLink', val);
	                },
	                onFocus: function onFocus() {
	                  return _this4.removeValue('questionaireErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.questionaireErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _CoachRegistration2.default.buttonContainer) },
	              _react2.default.createElement(_CustomButton2.default, { label: 'NEXT', onClick: function onClick() {
	                  return _this4.handleOnclick('loader');
	                } })
	            )
	          )
	        )),
	        renderWhileModify(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m7', _CoachRegistration2.default.modifyContainer) },
	          renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.autoComplete) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'COLLEGE NAME'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _CoachRegistration2.default.autoCompleteToolbox },
	              _react2.default.createElement(_autocomplete2.default, {
	                value: this.state.school,
	                disabled: true,
	                onChange: function onChange(val) {
	                  return _this4.handleChange('sport', val);
	                },
	                multiple: false
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.autoComplete) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'SPORT'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _CoachRegistration2.default.autoCompleteToolbox },
	              _react2.default.createElement(_autocomplete2.default, {
	                value: this.state.sport,
	                onChange: function onChange(val) {
	                  return _this4.handleChange('sport', val);
	                },
	                multiple: false
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.autoCompleteState) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'STATE'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.stateErrorMessage === '' ? _CoachRegistration2.default.autoCompleteToolbox : _CoachRegistration2.default.autoCompleteToolboxOnError },
	              _react2.default.createElement(_autocomplete2.default, {
	                onChange: function onChange(val) {
	                  return _this4.handleChange('states', val);
	                },
	                source: Allstate,
	                onFocus: function onFocus() {
	                  return _this4.removeValue('stateErrorMessage');
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this4.handleChange('states', val);
	                },
	                value: this.state.states,
	                multiple: false
	              })
	            ),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.stateErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: this.state.cityErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'CITY'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: this.state.city,
	              onChange: function onChange(val) {
	                return _this4.handleChange('city', val);
	              },
	              onFocus: function onFocus() {
	                return _this4.removeValue('cityErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.cityErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.teamPageUrlErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpace) : (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpaceOnError)
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              'TEAM PAGE URL'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: this.state.teamPageUrl,
	              onChange: function onChange(val) {
	                return _this4.handleChange('teamPageUrl', val);
	              },
	              onFocus: function onFocus() {
	                return _this4.removeValue('teamPageUrlErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.teamPageUrlErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.questionaireErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpace) : (0, _classnames2.default)('col s12 m6', _CoachRegistration2.default.halfWidthWithSpanWithoutTopSpaceOnError)
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Questionnaire Link'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: this.state.questionLink,
	              onChange: function onChange(val) {
	                return _this4.handleChange('questionLink', val);
	              },
	              onFocus: function onFocus() {
	                return _this4.removeValue('questionaireErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.questionaireErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _CoachRegistration2.default.modifyButtonContainer) },
	            _react2.default.createElement(
	              'button',
	              { onClick: function onClick() {
	                  return _this4.handleOnclick('loader');
	                } },
	              'UPDATE CHANGES'
	            )
	          )
	        ))
	      );
	    }
	  }]);
	
	  return CoachRegistrationModal;
	}(_react.Component);
	
	CoachRegistrationModal.propTypes = {
	  saveCoachProfile: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape(),
	  validateCoachRequested: _propTypes2.default.bool.isRequired, // eslint-disable-line
	  schools: _propTypes2.default.shape(),
	  searchSchools: _propTypes2.default.func,
	  coachRegistered: _propTypes2.default.bool,
	  history: _propTypes2.default.func.isRequired,
	  usedFor: _propTypes2.default.string,
	  getDataForCoach: _propTypes2.default.func.isRequired,
	  getCoachFromDatabase: _propTypes2.default.func.isRequired,
	  validCoachData: _propTypes2.default.func.isRequired,
	  adminStyles: _propTypes2.default.string,
	  writeCollegeName: _propTypes2.default.func
	};
	CoachRegistrationModal.defaultProps = {
	  saved: false,
	  saveCoachProfile: function saveCoachProfile() {},
	  coachRegistered: false,
	  router: {
	    push: function push() {}
	  },
	  history: {},
	  profile: (0, _immutable.Map)(),
	  attributes: {},
	  user: {},
	  getCoachProfile: function getCoachProfile() {},
	  schools: { school: 'enter school name' },
	  searchSchools: function searchSchools() {},
	  usedFor: '',
	  adminStyles: '',
	  getScholsName: function getScholsName() {},
	  writeCollegeName: function writeCollegeName() {}
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { saveCoachProfile: _actions.saveCoachProfile,
	  getCoachProfile: _actions.getCoachProfile,
	  searchSchools: _actions.searchSchools,
	  getCoachFromDatabase: _actions.getCoachFromDatabase,
	  push: _reactRouterRedux.push })(CoachRegistrationModal);

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveCoachProfile = saveCoachProfile;
	exports.getCoachProfile = getCoachProfile;
	exports.searchSchools = searchSchools;
	exports.getCoachFromDatabase = getCoachFromDatabase;
	
	var _coachProfile = __webpack_require__(192);
	
	var _saProfile = __webpack_require__(94);
	
	var _session = __webpack_require__(73);
	
	var _immutable = __webpack_require__(11);
	
	var _actionTypes = __webpack_require__(279);
	
	function saveCoachProfile(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _coachProfile.saveCoach)(payload).then(function (result) {
	      var temp = [{ Name: 'profile', Value: result.coach_id }];
	      (0, _session.updateUserAttributes)(temp, function (err) {
	        if (!err) {
	          (0, _session.isSessionValid)(function (thisError, data) {
	            if (thisError) {
	              dispatch({
	                type: _actionTypes.SESSION_LOGOUT
	              });
	            } else {
	              var token = data.session.idToken.jwtToken;
	
	              dispatch({
	                type: _actionTypes.SESSION_VALID,
	                session: (0, _immutable.fromJS)(data.session),
	                user: (0, _immutable.fromJS)(data.user),
	                attributes: data.attributes,
	                token: token
	              });
	              dispatch({
	                type: _actionTypes.SUCCESSFUL,
	                result: (0, _immutable.fromJS)(result)
	              });
	            }
	          });
	        }
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work
	function getCoachProfile(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.PROFILE_REQUESTED
	    });
	    (0, _coachProfile.getCoach)(id).then(function (result) {
	      dispatch({
	        type: _actionTypes.PROFILE_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.PROFILE_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function searchSchools(query) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _saProfile.searchSchoolsByName)({ college: query }).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.SCHOOL_SEARCH,
	          schools: data
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getCoachFromDatabase(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.GET_COACH_FROM_DATABASE_REQUESTED
	    });
	    (0, _coachProfile.validataCoachFromDatabase)(payload).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTER,
	          validCoach: data
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.GET_COACH_FROM_DATABASE_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachTabs = __webpack_require__(450);
	
	var _CoachTabs2 = _interopRequireDefault(_CoachTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachTabs2.default;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TotalCounts = __webpack_require__(1240);
	
	var _TotalCounts2 = _interopRequireDefault(_TotalCounts);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _Community = __webpack_require__(1480);
	
	var _Community2 = _interopRequireDefault(_Community);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var Community = function (_Component) {
	  _inherits(Community, _Component);
	
	  function Community(props) {
	    _classCallCheck(this, Community);
	
	    var _this = _possibleConstructorReturn(this, (Community.__proto__ || Object.getPrototypeOf(Community)).call(this, props));
	
	    _this.handleShowMoreTest = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, true)));
	    };
	
	    _this.state = {
	      athleteShowMoreText: false,
	      parentShowMoreText: false,
	      coachShowMoreText: false
	    };
	    _this.handleShowMoreTest = _this.handleShowMoreTest.bind(_this);
	    return _this;
	  }
	
	  _createClass(Community, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          athleteShowMoreText = _state.athleteShowMoreText,
	          parentShowMoreText = _state.parentShowMoreText,
	          coachShowMoreText = _state.coachShowMoreText;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Community2.default.communityContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 l4', _Community2.default.categories) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Community2.default.athleteIcon) },
	            _react2.default.createElement('img', { alt: 'Athelete', src: 'https://media.dev.myrecruitboard.com/Images/athketes%403x.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Community2.default.categoryHeader },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'ATHLETES'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Community2.default.categoryDescription) },
	            athleteShowMoreText === true ? _react2.default.createElement(
	              'div',
	              { className: _Community2.default.textContainer },
	              'RECRUITING PROBLEMS:',
	              _react2.default.createElement('br', null),
	              'Underexposed?',
	              _react2.default.createElement('br', null),
	              'Not being recruited?',
	              _react2.default.createElement('br', null),
	              'Live in a small town?',
	              _react2.default.createElement('br', null),
	              'Got letters, but no offers?',
	              _react2.default.createElement('br', null),
	              'Know players younger than you getting offers?',
	              _react2.default.createElement('br', null),
	              'Has a college coach has stopped communicating with you?',
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement('br', null),
	              'You will not get a scholarship by randomly tagging coaches to your Hudl video on Twitter.  College coaches use trusted companies to recruit prospects. Randomly contacting a college coach will most often go unanswered or lead to nowhere.  Save your time and use our website to get recruited today.  We help football players in every situation get recruited. ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'YOUR SOLUTION: ',
	              _react2.default.createElement('br', null),
	              'Make a profile to discover hundreds of colleges looking to recruit players matching your biometrics and academic standings.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/register' },
	                  'Join Now'
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: _Community2.default.textContainer },
	              'Underexposed? Not being recruited? Live in a small town? Got letters, but no offers? Know players younger than you getting offers? Has a college coach has stopped communicating with you?',
	              '...',
	              _react2.default.createElement(
	                'span',
	                { onClick: function onClick() {
	                    return _this2.handleShowMoreTest('athleteShowMoreText');
	                  } },
	                'show more'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/register' },
	                  'Join Now'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 l4', _Community2.default.categories) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Community2.default.parentIcon) },
	            _react2.default.createElement('img', { alt: 'Parents', src: 'https://media.dev.myrecruitboard.com/Images/parents%402x.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Community2.default.categoryHeader },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'PARENTS'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Community2.default.categoryDescription) },
	            parentShowMoreText === true ? _react2.default.createElement(
	              'div',
	              { className: _Community2.default.textContainer },
	              'RECRUITING PROBLEMS: ',
	              _react2.default.createElement('br', null),
	              'Is your son more talented, bigger, stronger, faster, or smarter than other players being seriously recruited?',
	              _react2.default.createElement('br', null),
	              'Don\'t believe this statement: "If he\'s talented they will find him." ',
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement('br', null),
	              'Likewise, don\'t let the school he attends, where you live or his coach\'s "connections" limit your son\'s ability to get recruited.',
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement('br', null),
	              'YOUR SOLUTION:',
	              _react2.default.createElement('br', null),
	              'We help families get the most academic and athletic scholarship money possible to pay for the high cost of a college education. Make a profile to discover hundreds of colleges looking to recruit players matching your son\'s biometrics and academic standings.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/register' },
	                  'Join Now'
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: _Community2.default.textContainer },
	              'Is your son more talented, bigger, stronger, faster, or smarter than other players being seriously recruited? Don\'t believe this statement: "If he\'s talented they will find him." Likewise, don\'t let',
	              '...',
	              _react2.default.createElement(
	                'span',
	                { onClick: function onClick() {
	                    return _this2.handleShowMoreTest('parentShowMoreText');
	                  } },
	                'show more'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/register' },
	                  'Join Now'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 l4', _Community2.default.categories) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Community2.default.cocahIcon) },
	            _react2.default.createElement('img', { alt: 'Coaches', src: 'https://media.dev.myrecruitboard.com/Images/coaches%402x.png' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Community2.default.categoryHeader },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'COACHES'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Community2.default.categoryDescription) },
	            coachShowMoreText === true ? _react2.default.createElement(
	              'div',
	              { className: _Community2.default.textContainer },
	              'RECRUITING PROBLEMS: ',
	              _react2.default.createElement('br', null),
	              'Building a new program? ',
	              _react2.default.createElement('br', null),
	              'Unfamiliar recruiting area?',
	              _react2.default.createElement('br', null),
	              'Need to find quality talent?',
	              _react2.default.createElement('br', null),
	              'Newly hired staff member?',
	              _react2.default.createElement('br', null),
	              'Very specific academic type?',
	              _react2.default.createElement('br', null),
	              'Hard-to-sell college or location?',
	              _react2.default.createElement('br', null),
	              'Need to recruit at a lower level of play?',
	              _react2.default.createElement('br', null),
	              'Need to find under-recruited D1 talent?',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              'YOUR SOLUTION: ',
	              _react2.default.createElement('br', null),
	              'Let us find the best players you need and want.',
	              _react2.default.createElement('br', null),
	              'Connect directly with the recruits that you want.',
	              _react2.default.createElement('br', null),
	              'Evaluate the recruits that have shown interest in your team.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/register' },
	                  'Join Now'
	                )
	              )
	            ) : _react2.default.createElement(
	              'div',
	              { className: _Community2.default.textContainer },
	              'Building a new program? Unfamiliar recruiting area? Need to find quality talent? Newly hired staff member?',
	              '...',
	              _react2.default.createElement(
	                'span',
	                { onClick: function onClick() {
	                    return _this2.handleShowMoreTest('coachShowMoreText');
	                  } },
	                'show more'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/register' },
	                  'Join Now'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Community2.default.ourCommunity) },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'OUR MISSION'
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _Community2.default.communityText },
	              'The mission of MyRecruitBoard is simple.',
	              _react2.default.createElement('br', null),
	              'To expose every football player in America to the colleges they fit best using our cutting edge technology. Ultimately making their recruitment affordable, productive, and successful.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Community2.default.countsContainer) },
	          _react2.default.createElement(_TotalCounts2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Community;
	}(_react.Component);
	
	exports.default = Community;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Community = __webpack_require__(1116);
	
	var _Community2 = _interopRequireDefault(_Community);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Community2.default;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tabs = __webpack_require__(254);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _style = __webpack_require__(1481);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	// to import local scss fle
	
	var Createtabs = function (_React$Component) {
	  _inherits(Createtabs, _React$Component);
	
	  function Createtabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Createtabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Createtabs.__proto__ || Object.getPrototypeOf(Createtabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: 0,
	      fixedIndex: 1,
	      inverseIndex: 1
	    }, _this.handleTabChange = function (index) {
	      _this.setState({ index: index });
	      _this.props.tabListener(index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Createtabs, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tabs = _props.tabs,
	          activeClass = _props.activeClass,
	          container = _props.container,
	          index = _props.index;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _style2.default.container, container) },
	        _react2.default.createElement(
	          _tabs.Tabs,
	          { index: index, onChange: this.handleTabChange },
	          tabs.map(function (item) {
	            return _react2.default.createElement(_tabs.Tab, { label: item, activeClassName: (0, _classnames2.default)(_style2.default.activeClass, activeClass) });
	          })
	        )
	      );
	    }
	  }]);
	
	  return Createtabs;
	}(_react2.default.Component);
	
	Createtabs.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired,
	  tabs: _propTypes2.default.shape.isRequired,
	  container: _propTypes2.default.string.isRequired,
	  activeClass: _propTypes2.default.string.isRequired,
	  index: _propTypes2.default.number.isRequired
	};
	exports.default = Createtabs;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Navbar = __webpack_require__(159);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _StudentsTabs = __webpack_require__(1237);
	
	var _StudentsTabs2 = _interopRequireDefault(_StudentsTabs);
	
	var _SettingsCoachTabs = __webpack_require__(1219);
	
	var _SettingsCoachTabs2 = _interopRequireDefault(_SettingsCoachTabs);
	
	var _SettingsTabs = __webpack_require__(1221);
	
	var _SettingsTabs2 = _interopRequireDefault(_SettingsTabs);
	
	var _CoachTabs = __webpack_require__(1115);
	
	var _CoachTabs2 = _interopRequireDefault(_CoachTabs);
	
	var _DashBoardHeader = __webpack_require__(1483);
	
	var _DashBoardHeader2 = _interopRequireDefault(_DashBoardHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	
	
	// to import local scss fle
	
	var DashBoardHeader = function (_Component) {
	  _inherits(DashBoardHeader, _Component);
	
	  function DashBoardHeader(props) {
	    _classCallCheck(this, DashBoardHeader);
	
	    var _this = _possibleConstructorReturn(this, (DashBoardHeader.__proto__ || Object.getPrototypeOf(DashBoardHeader)).call(this, props));
	
	    _this.state = {
	      headerOnDashboard: true
	    };
	    return _this;
	  }
	
	  _createClass(DashBoardHeader, [{
	    key: 'render',
	    value: function render() {
	      var usedFor = this.props.usedFor;
	
	      var settingsAthleteHeader = (0, _renderIf2.default)(usedFor === 'settingsAthlete');
	      var settingsCoachHeader = (0, _renderIf2.default)(usedFor === 'settingsCoach');
	      var renderCoachItems = (0, _renderIf2.default)(usedFor === 'coachDashboard');
	      var renderAtheleteItems = (0, _renderIf2.default)(usedFor === 'athleteDashboard');
	      return _react2.default.createElement(
	        'div',
	        { className: usedFor === 'coachDashboard' || usedFor === 'settingsCoach' ? (0, _classnames2.default)('row', _DashBoardHeader2.default.coachContainer) : (0, _classnames2.default)('row', _DashBoardHeader2.default.container) },
	        _react2.default.createElement(_Navbar2.default, Object.assign({}, this.props, { headerOnDashboard: this.state.headerOnDashboard })),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _DashBoardHeader2.default.currentUrl) },
	          usedFor === ('settingsAthlete' || 'settingsCoach' || 'settingsParents') ? 'Settings' : 'My Dashboard'
	        ),
	        settingsAthleteHeader(_react2.default.createElement(_SettingsTabs2.default, Object.assign({ tabListener: this.props.tabListener }, this.props))),
	        renderCoachItems(_react2.default.createElement(_CoachTabs2.default, { tabListener: this.props.tabListener })),
	        renderAtheleteItems(_react2.default.createElement(_StudentsTabs2.default, { tabListener: this.props.tabListener })),
	        settingsCoachHeader(_react2.default.createElement(_SettingsCoachTabs2.default, { tabListener: this.props.tabListener }))
	      );
	    }
	  }]);
	
	  return DashBoardHeader;
	}(_react.Component);
	
	DashBoardHeader.propTypes = {
	  usedFor: _propTypes2.default.string.isRequired,
	  tabListener: _propTypes2.default.func.isRequired
	};
	DashBoardHeader.defaultProps = {
	  coachHeader: false
	};
	exports.default = DashBoardHeader;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(27);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _Default = __webpack_require__(1121);
	
	var _Default2 = _interopRequireDefault(_Default);
	
	var _dashboardnav = __webpack_require__(1130);
	
	var _dashboardnav2 = _interopRequireDefault(_dashboardnav);
	
	var _requests = __webpack_require__(1132);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _wishlist = __webpack_require__(1133);
	
	var _wishlist2 = _interopRequireDefault(_wishlist);
	
	var _Tutorial = __webpack_require__(1129);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _Counter = __webpack_require__(1126);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	var _DashboardView = __webpack_require__(113);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	var _redux = __webpack_require__(453);
	
	var _actions = __webpack_require__(452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to use global class name eg.
	// to validate and set default props  coming to this component
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	
	// import UpgradeTiles from 'components/UpgradeTiles';
	// to import local scss fle
	
	
	var DashboardView = function (_Component) {
	  _inherits(DashboardView, _Component);
	
	  function DashboardView(props) {
	    _classCallCheck(this, DashboardView);
	
	    var _this = _possibleConstructorReturn(this, (DashboardView.__proto__ || Object.getPrototypeOf(DashboardView)).call(this, props));
	
	    _this.toggleView = function () {
	      _this.setState({ gridView: !_this.state.gridView });
	    };
	
	    _this.toggleSchools = function (show) {
	      if (show === 'school') {
	        _this.setState({ showSchools: true });
	      } else {
	        _this.setState({ showSchools: false });
	      }
	    };
	
	    _this.toggleFilter = function () {
	      _this.setState({ showFilter: !_this.state.showFilter });
	    };
	
	    _this.showSnackBar = function (label) {
	      _this.setState({ showSnackBar: true, snackBarLable: label });
	    };
	
	    _this.handleSnackbarTimeout = function () {
	      _this.setState({ showSnackBar: false });
	    };
	
	    _this.addNotification = function (msg) {
	      _this.setState({ showNotification: true, message: msg });
	      setTimeout(function () {
	        _this.setState({ showNotification: false });
	      }, 3000);
	    };
	
	    _this.loadMoreColleges = function () {
	      var payloadFilter = _this.props.payload.toJS();
	      payloadFilter['size'] = payloadFilter.size + _this.props.contactedCount; // eslint-disable-line
	      _this.props.getSchools(payloadFilter);
	    };
	
	    _this.showCounterpopUp = function () {
	      _this.setState({ showCounterScreen: !_this.state.showCounterScreen });
	    };
	
	    _this.state = {
	      value: '',
	      gridView: true,
	      showSchools: true,
	      profileId: '',
	      showFilter: true,
	      showUpgrade: false,
	      showSnackBar: false,
	      snackBarLable: '',
	      payload: {},
	      showNotification: false,
	      message: '',
	      displayTutorial: true,
	      showCounterScreen: false,
	      onTrial: false
	    };
	    return _this;
	  }
	
	  _createClass(DashboardView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var localCount = window.localStorage.getItem('count');
	      if (localCount === '111') {
	        this.setState({ displayTutorial: false });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          subscribed = _props.subscribed,
	          payload = _props.payload,
	          profile = _props.profile;
	
	      if (profile.size > 0) {
	        var PAYLOAD = payload.toJS();
	        // if (profile.get('override_division') !== undefined) {
	        //   const filterByDivision = [];
	        //   filterByDivision.push(this.props.profile.get('override_division'));
	        //   PAYLOAD['filter_divisions'] = filterByDivision; // eslint-disable-line
	        // }
	        if (profile.get('override_division') !== undefined || profile.get('current_division') !== undefined) {
	          var filterByDivision = [];
	          var currentDivision = [];
	          var D1 = ['D1', 'D2', 'D3', 'NAIA', 'JUCO'];
	          var D2 = ['D2', 'D3', 'NAIA', 'JUCO'];
	          var D3 = ['D3', 'NAIA', 'JUCO'];
	          var NAIA = ['NAIA', 'JUCO'];
	          var JUCO = ['JUCO'];
	          if (profile.get('current_division') !== undefined && profile.get('current_division') !== 'NA') {
	            if (profile.get('current_division') === 'D1') currentDivision = D1;
	            if (profile.get('current_division') === 'D2') currentDivision = D2;
	            if (profile.get('current_division') === 'D3') currentDivision = D3;
	            if (profile.get('current_division') === 'NAIA') currentDivision = NAIA;
	            if (profile.get('current_division') === 'JUCO') currentDivision = JUCO;
	            PAYLOAD['filter_divisions'] = currentDivision; // eslint-disable-line
	          }
	          if (profile.get('override_division') !== undefined) {
	            if (profile.get('override_division') === 'D1') filterByDivision = D1;
	            if (profile.get('override_division') === 'D2') filterByDivision = D2;
	            if (profile.get('override_division') === 'D3') filterByDivision = D3;
	            if (profile.get('override_division') === 'NAIA') filterByDivision = NAIA;
	            if (profile.get('override_division') === 'JUCO') filterByDivision = JUCO;
	            PAYLOAD['filter_divisions'] = filterByDivision; // eslint-disable-line
	          }
	        }
	        this.props.initProfile(profile);
	        // if (subscribed) {
	        this.props.getSchools(PAYLOAD);
	        this.props.getPostings(PAYLOAD);
	        this.props.getRequestsViewedCount(profile.get('id'));
	        this.props.getRequests(profile.get('id'));
	        // }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var localCount = window.localStorage.getItem('count');
	      if (localCount === '111') {
	        this.setState({ displayTutorial: false });
	      }
	      var _props2 = this.props,
	          profile = _props2.profile,
	          profileId = _props2.profileId,
	          filter = _props2.filter;
	      // eslint-disable-next-line no-unused-vars
	
	      var subscribed = nextProps.subscribed,
	          payload = nextProps.payload;
	
	
	      if (this.props.profile !== undefined) {
	        if (this.props.profile.get('trialEndDate')) {
	          this.setState({
	            onTrial: (0, _moment2.default)().isBefore(this.props.profile.get('trialEndDate'))
	          });
	        }
	      }
	
	      var PAYLOAD = payload.toJS();
	      // to fetch postings and colleges
	      if (nextProps.profile.size > 0 && !(0, _immutable.is)(profile, nextProps.profile)) {
	        this.props.initProfile(nextProps.profile);
	        // if (subscribed) {
	        if (nextProps.profile.get('override_division') !== undefined || nextProps.profile.get('current_division') !== undefined) {
	          var filterByDivision = [];
	          var currentDivision = [];
	          var D1 = ['D1', 'D2', 'D3', 'NAIA', 'JUCO'];
	          var D2 = ['D2', 'D3', 'NAIA', 'JUCO'];
	          var D3 = ['D3', 'NAIA', 'JUCO'];
	          var NAIA = ['NAIA', 'JUCO'];
	          var JUCO = ['JUCO'];
	          if (nextProps.profile.get('current_division') !== undefined && nextProps.profile.get('current_division') !== 'NA') {
	            if (nextProps.profile.get('current_division') === 'D1') currentDivision = D1;
	            if (nextProps.profile.get('current_division') === 'D2') currentDivision = D2;
	            if (nextProps.profile.get('current_division') === 'D3') currentDivision = D3;
	            if (nextProps.profile.get('current_division') === 'NAIA') currentDivision = NAIA;
	            if (nextProps.profile.get('current_division') === 'JUCO') currentDivision = JUCO;
	            PAYLOAD['filter_divisions'] = currentDivision; // eslint-disable-line
	          }
	          if (nextProps.profile.get('override_division') !== undefined) {
	            if (nextProps.profile.get('override_division') === 'D1') filterByDivision = D1;
	            if (nextProps.profile.get('override_division') === 'D2') filterByDivision = D2;
	            if (nextProps.profile.get('override_division') === 'D3') filterByDivision = D3;
	            PAYLOAD['filter_divisions'] = filterByDivision; // eslint-disable-line
	          }
	        }
	
	        this.props.getSchools(PAYLOAD);
	        this.props.getPostings(PAYLOAD);
	        this.props.getRequestsViewedCount(nextProps.profile.get('id'));
	        // }
	
	        // to fetch postings
	        if (nextProps.profileId && nextProps.profileId !== profileId) {
	          this.props.getRequests(nextProps.profileId);
	        }
	
	        // if sync fails by any chances or conditions fails in sync-handler.js
	        // if (nextProps.syncFailed) {
	        //   this.setState({ showCounterScreen: true });
	        // }
	      }
	
	      // to handle filer changes
	      if (!(0, _immutable.is)(filter, nextProps.filter)) {
	        if (nextProps.filter.get('apply')) {
	          var requestBody = Object.assign({}, payload.toJS(), nextProps.filter.get('data').toJS());
	          this.props.getSchools(requestBody);
	          this.props.getPostings(requestBody);
	        }
	      }
	
	      if (nextProps.recommendedDivision !== '' && !nextProps.divisionAddRequested) {
	        var payloadToaddCurrentDivision = {
	          id: nextProps.profile.get('id'),
	          current_division: nextProps.recommendedDivision
	        };
	        this.props.addStudentCurrentDivision(payloadToaddCurrentDivision);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // console.log('state: ', this.state);
	      // eslint-disable-next-line no-unused-vars
	      var _props3 = this.props,
	          tab = _props3.tab,
	          filter = _props3.filter,
	          subscribed = _props3.subscribed,
	          schools = _props3.schools,
	          postings = _props3.postings,
	          contacted = _props3.contacted,
	          requestViewedCount = _props3.requestViewedCount,
	          profile = _props3.profile;
	      var _state = this.state,
	          showFilter = _state.showFilter,
	          showSchools = _state.showSchools,
	          gridView = _state.gridView,
	          onTrial = _state.onTrial;
	
	      var renderIfWishList = (0, _renderIf2.default)(tab === 2);
	      var renderIfContacted = (0, _renderIf2.default)(tab === 1);
	      var renderIfDefault = (0, _renderIf2.default)(tab === 0);
	      // const renderFilterSchools = tab === 0 && subscribed && showFilter;
	      var renderFilterSchools = tab === 0 && showFilter;
	      //
	      // const renderIfUpgrade = renderIf(!subscribed);
	      //     const renderIfNotUpgrade = renderIf(!this.state.showUpgrade);
	      var loaderDecider = false;
	      if (this.props.requestCount > 0) {
	        loaderDecider = true;
	      }
	      var showCountOne = false;
	      if (!subscribed) {
	        if (this.props.profile.get('trialEndDate') !== undefined) {
	          showCountOne = !(0, _moment2.default)().isBefore(this.props.profile.get('trialEndDate'));
	        } else {
	          showCountOne = true;
	        }
	      }
	      var renderLoading = (0, _renderIf2.default)(loaderDecider);
	      //     const renderDashboardLoader = renderIf(false);
	      //
	      //     const renderFilterIcon = renderIf(this.props.tab === 0);
	      //     const renderNotification = renderIf(this.state.showNotification);
	      // const renderTutorial = renderIf(this.state.displayTutorial && subscribed);
	      var renderTutorial = (0, _renderIf2.default)(this.state.displayTutorial);
	      var showTrialButton = false;
	      if (this.props.profile.get('trialEndDate') === undefined && this.props.profile.get('payment_info') === undefined) {
	        showTrialButton = true;
	      }
	
	      //     const { showSchools } = this.state;
	      //     const renderRedText =
	      //     renderIf(this.props.syncData.get('count') === 2); // change it to perfect counter
	      var renderCounterPopUp = (0, _renderIf2.default)(this.state.showCounterScreen);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _DashboardView2.default.container) },
	        _react2.default.createElement(_dashboardnav2.default, Object.assign({
	          tab: tab,
	          toggleSchools: this.toggleSchools,
	          toggleView: this.toggleView,
	          toggleFilter: this.toggleFilter,
	          filter: filter,
	          renderFilterSchools: renderFilterSchools,
	          showSchools: showSchools,
	          showSnackBar: this.showSnackBar
	        }, this.props, {
	          onTrial: onTrial
	        })),
	        renderIfDefault(_react2.default.createElement(_Default2.default, Object.assign({
	          gridView: gridView,
	          showSchools: showSchools,
	          schools: schools,
	          postings: postings,
	          addNotification: this.addNotification,
	          showCounterpopUp: this.showCounterpopUp,
	          showSnackBar: this.showSnackBar,
	          loadmoreColleges: this.loadMoreColleges
	        }, this.props, {
	          onTrial: onTrial
	        }))),
	        renderIfWishList(_react2.default.createElement(_wishlist2.default, Object.assign({
	          gridView: gridView,
	          showSchools: showSchools,
	          schools: schools,
	          postings: postings,
	          addNotification: this.addNotification,
	          showCounterpopUp: this.showCounterpopUp,
	          showSnackBar: this.showSnackBar
	        }, this.props, {
	          onTrial: onTrial
	        }))),
	        renderIfContacted(_react2.default.createElement(_requests2.default, {
	          requests: contacted,
	          gridView: gridView,
	          subscribed: true,
	          requestViewedCount: requestViewedCount,
	          onTrial: onTrial
	        })),
	        renderLoading(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderTutorial(_react2.default.createElement(_Tutorial2.default, null)),
	        renderCounterPopUp(_react2.default.createElement(_Counter2.default, {
	          show: this.state.showCounterScreen,
	          showCounterScreen: this.showCounterpopUp,
	          showCountOne: showCountOne,
	          onTrial: onTrial,
	          subscribed: subscribed,
	          showTrialButton: showTrialButton,
	          saProfileID: profile.get('id')
	        }))
	      );
	    }
	  }]);
	
	  return DashboardView;
	}(_react.Component);
	
	DashboardView.propTypes = {
	  getSchools: _propTypes2.default.func.isRequired,
	  getPostings: _propTypes2.default.func.isRequired,
	  getRequests: _propTypes2.default.func.isRequired,
	  initProfile: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.shape(),
	  filter: _propTypes2.default.shape.isRequired,
	  profileId: _propTypes2.default.string.isRequired,
	  tab: _propTypes2.default.number,
	  contactedCount: _propTypes2.default.number,
	  recommendedDivision: _propTypes2.default.string.isRequired, // eslint-disable-line
	  addStudentCurrentDivision: _propTypes2.default.string.isRequired,
	  divisionAddRequested: _propTypes2.default.bool.isRequired, // eslint-disable-line
	  schools: _propTypes2.default.shape(),
	  postings: _propTypes2.default.shape(),
	  getRequestsViewedCount: _propTypes2.default.func.isRequired,
	  contacted: _propTypes2.default.shape(),
	  requestCount: _propTypes2.default.number,
	  requestViewedCount: _propTypes2.default.number.isRequired,
	  // syncFailed: PropTypes.bool.isRequired,
	  subscribed: _propTypes2.default.bool.isRequired,
	  payload: _propTypes2.default.bool.isRequired
	};
	DashboardView.defaultProps = {
	  profile: (0, _immutable.Map)(),
	  schools: [],
	  postings: [],
	  wishList: [],
	  contactedList: [],
	  fillQList: [],
	  inviteToCampList: [],
	  ignoreList: [],
	  tab: 0,
	  requests: [],
	  contacted: [],
	  isLoading: false,
	  contactedCount: 0,
	  requestCount: 0
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSchools: _actions.getSchools,
	  getPostings: _actions.getPostings,
	  updateFilter: _actions.updateFilter,
	  addToList: _actions.addToList,
	  addToRequest: _actions.addToRequest,
	  getRequests: _actions.getRequests,
	  removeFromList: _actions.removeFromList,
	  initProfile: _actions.initProfile,
	  addStudentCurrentDivision: _actions.addStudentCurrentDivision,
	  getTotalCounts: _actions.getTotalCounts,
	  getRequestsViewedCount: _actions.getRequestsViewedCount
	})(DashboardView);

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _collegeview = __webpack_require__(1122);
	
	var _collegeview2 = _interopRequireDefault(_collegeview);
	
	var _postingview = __webpack_require__(1123);
	
	var _postingview2 = _interopRequireDefault(_postingview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import styles from '../DashboardView.scss';
	
	// import cn from 'classnames';
	var Default = function Default(props) {
	  return props.showSchools ? _react2.default.createElement(_collegeview2.default, props) : _react2.default.createElement(_postingview2.default, props);
	};
	
	Default.propTypes = {
	  showSchools: _propTypes2.default.bool.isRequired
	};
	
	exports.default = Default;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SchoolTile = __webpack_require__(464);
	
	var _SchoolTile2 = _interopRequireDefault(_SchoolTile);
	
	var _SchoolListView = __webpack_require__(463);
	
	var _SchoolListView2 = _interopRequireDefault(_SchoolListView);
	
	var _Nocontentfound = __webpack_require__(195);
	
	var _Nocontentfound2 = _interopRequireDefault(_Nocontentfound);
	
	var _DashboardView = __webpack_require__(113);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	var _LoadMore = __webpack_require__(1125);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollegeView = function CollegeView(props) {
	  // let countForSchool = 0;
	  var contactedList = props.contactedList,
	      schools = props.schools,
	      wishList = props.wishList,
	      fillQList = props.fillQList,
	      inviteToCampList = props.inviteToCampList,
	      addToList = props.addToList,
	      gridView = props.gridView,
	      profileId = props.profileId,
	      addToRequest = props.addToRequest,
	      removeFromList = props.removeFromList,
	      showCounterpopUp = props.showCounterpopUp,
	      addNotification = props.addNotification,
	      contactedCount = props.contactedCount,
	      loadmoreColleges = props.loadmoreColleges,
	      subscribed = props.subscribed;
	
	  var renderNoContentFound = (0, _renderIf2.default)(schools.size === 0 && subscribed);
	  // let trialEndDate = '';
	  // if (props.profile.get('trialEndDate') !== undefined) {
	  //   trialEndDate = props.profile.get('trialEndDate');
	  // }
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12', _DashboardView2.default.alignCenter) },
	    renderNoContentFound(_react2.default.createElement(_Nocontentfound2.default, { text: '' })),
	    schools.map(function (item) {
	      var interested = contactedList.indexOf(item.get('id')) > -1;
	      // if (countForSchool >= 50 || interested) {
	      if (interested) {
	        // // eslint-disable-next-line no-console
	        // console.log('count', countForSchool);
	        return null;
	      }
	      // countForSchool++; //eslint-disable-line
	      var wishListId = wishList.indexOf(item.get('id'));
	      var inWishList = wishListId > -1;
	      var fillQ = fillQList.indexOf(item.get('id')) > -1;
	      var inviteToCamp = inviteToCampList.indexOf(item.get('id')) > -1;
	      return _react2.default.createElement(
	        'span',
	        null,
	        gridView ? _react2.default.createElement(_SchoolTile2.default, Object.assign({
	          saSchool: item,
	          addToList: addToList,
	          profileId: profileId,
	          addToRequest: addToRequest,
	          inWishList: inWishList,
	          interested: interested,
	          removeFromList: removeFromList,
	          wishListId: wishListId,
	          showCounterScreen: showCounterpopUp
	        }, props, {
	          fillQ: fillQ,
	          inviteToCamp: inviteToCamp,
	          showSnackBar: function showSnackBar(val) {
	            return addNotification(val);
	          },
	          usedFor: 'schools'
	        })) : _react2.default.createElement(_SchoolListView2.default, Object.assign({
	          saSchool: item,
	          addToList: addToList,
	          profileId: profileId,
	          addToRequest: addToRequest,
	          inWishList: inWishList,
	          interested: interested,
	          removeFromList: removeFromList,
	          wishListId: wishListId,
	          showCounterScreen: showCounterpopUp
	        }, props, {
	          fillQ: fillQ,
	          inviteToCamp: inviteToCamp,
	          showSnackBar: function showSnackBar(val) {
	            return addNotification(val);
	          },
	          usedFor: 'schools'
	        }))
	      );
	    }),
	    _react2.default.createElement(_LoadMore2.default, { loadmoreColleges: loadmoreColleges, contactedCount: contactedCount })
	  );
	}; /* eslint-disable max-len */
	
	
	CollegeView.propTypes = {
	  addToList: _propTypes2.default.func.isRequired,
	  addToRequest: _propTypes2.default.func.isRequired,
	  wishList: _propTypes2.default.shape.isRequired,
	  contactedList: _propTypes2.default.shape.isRequired,
	  fillQList: _propTypes2.default.shape.isRequired,
	  inviteToCampList: _propTypes2.default.shape.isRequired,
	  profileId: _propTypes2.default.string.isRequired,
	  removeFromList: _propTypes2.default.func.isRequired,
	  gridView: _propTypes2.default.bool.isRequired,
	  showCounterpopUp: _propTypes2.default.func.isRequired,
	  addNotification: _propTypes2.default.func.isRequired,
	  schools: _propTypes2.default.shape.isRequired,
	  contactedCount: _propTypes2.default.number.isRequired,
	  loadmoreColleges: _propTypes2.default.func.isRequired,
	  subscribed: _propTypes2.default.bool.isRequired
	};
	
	exports.default = CollegeView;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PostingTile = __webpack_require__(1182);
	
	var _PostingTile2 = _interopRequireDefault(_PostingTile);
	
	var _ListView = __webpack_require__(1154);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	var _DashboardView = __webpack_require__(113);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	var _Nocontentfound = __webpack_require__(195);
	
	var _Nocontentfound2 = _interopRequireDefault(_Nocontentfound);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostingView = function PostingView(props) {
	  // let countForSchool = 0;
	  var contactedList = props.contactedList,
	      ignoreList = props.ignoreList,
	      postings = props.postings,
	      addToList = props.addToList,
	      profileId = props.profileId,
	      addToRequest = props.addToRequest,
	      gridView = props.gridView,
	      showSnackBar = props.showSnackBar;
	
	  var renderNoContentFound = (0, _renderIf2.default)(postings.size === 0);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12', _DashboardView2.default.alignCenter) },
	    renderNoContentFound(_react2.default.createElement(_Nocontentfound2.default, { text: '' })),
	    postings.map(function (item) {
	      var interested = contactedList.indexOf(item.get('college_id')) > -1;
	      var ignoreListId = ignoreList.indexOf(item.get('college_id')) > -1 || interested;
	      if (ignoreListId) {
	        return null;
	      }
	      // countForSchool++; //eslint-disable-line
	      // if (countForSchool > 25) {
	      //   return null;
	      // }
	      return _react2.default.createElement(
	        'span',
	        null,
	        gridView ? _react2.default.createElement(_PostingTile2.default, Object.assign({
	          posting: item,
	          addToList: addToList,
	          profileId: profileId,
	          addToRequest: addToRequest,
	          interested: interested
	        }, props, {
	          showCounterScreen: props.showCounterpopUp,
	          showSnackBar: showSnackBar
	        })) : _react2.default.createElement(_ListView2.default, Object.assign({
	          posting: item,
	          addToList: addToList,
	          profileId: profileId,
	          addToRequest: addToRequest,
	          interested: interested,
	          showCounterScreen: props.showCounterpopUp
	        }, props, {
	          showSnackBar: showSnackBar
	        }))
	      );
	    })
	  );
	};
	
	PostingView.propTypes = {
	  addToList: _propTypes2.default.func.isRequired,
	  addToRequest: _propTypes2.default.func.isRequired,
	  contactedList: _propTypes2.default.shape.isRequired,
	  ignoreList: _propTypes2.default.shape.isRequired,
	  profileId: _propTypes2.default.string.isRequired,
	  gridView: _propTypes2.default.bool.isRequired,
	  postings: _propTypes2.default.shape.isRequired,
	  showSnackBar: _propTypes2.default.func.isRequired,
	  showCounterpopUp: _propTypes2.default.func.isRequired
	};
	
	exports.default = PostingView;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LoadMore = __webpack_require__(1484);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadMore = function LoadMore(props) {
	  if (window.innerWidth < 700 && props.contactedCount >= 2) {
	    return _react2.default.createElement(
	      'div',
	      { className: _LoadMore2.default.loadmoreContainerOnMobile },
	      _react2.default.createElement(
	        'div',
	        { className: _LoadMore2.default.overlay },
	        _react2.default.createElement(
	          'button',
	          { onClick: function onClick() {
	              return props.loadmoreColleges();
	            } },
	          'LOAD MORE COLLEGES'
	        )
	      )
	    );
	  } else if (window.innerWidth >= 700 && props.contactedCount >= 5) {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _LoadMore2.default.desktopLoadMoreContainer) },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Click below button to add more colleges!'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'button',
	        { onClick: function onClick() {
	            return props.loadmoreColleges();
	          } },
	        'LOAD MORE'
	      )
	    );
	  }
	  return null;
	};
	
	LoadMore.propTypes = {
	  contactedCount: _propTypes2.default.number,
	  loadmoreColleges: _propTypes2.default.func
	};
	
	LoadMore.defaultProps = {
	  contactedCount: 0,
	  loadmoreColleges: function loadmoreColleges() {}
	};
	
	exports.default = LoadMore;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Loadmore = __webpack_require__(1124);
	
	var _Loadmore2 = _interopRequireDefault(_Loadmore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Loadmore2.default;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tutorial = __webpack_require__(508);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _saProfile = __webpack_require__(94);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
	// to import local scss fle
	
	
	var Tutorials = function (_Component) {
	  _inherits(Tutorials, _Component);
	
	  function Tutorials(props) {
	    _classCallCheck(this, Tutorials);
	
	    var _this = _possibleConstructorReturn(this, (Tutorials.__proto__ || Object.getPrototypeOf(Tutorials)).call(this, props));
	
	    _this.onCloseModal = function () {
	      // console.log('id; ', this.props.saProfileID);
	      _this.props.showCounterScreen();
	    };
	
	    _this.setLoader = function () {
	      _this.setState({
	        isLoading: !_this.isLoading
	      });
	    };
	
	    _this.state = {
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Tutorials, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var isLoading = this.state.isLoading;
	
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)',
	          zIndex: 1
	        },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          minHeight: '300px',
	          paddingTop: '20px',
	          paddingLeft: '0px',
	          paddingRight: '0px',
	          paddingBottom: '0',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	
	      var onPressTryForFree = function onPressTryForFree() {
	        _this2.setLoader();
	        var params = {
	          id: _this2.props.saProfileID,
	          trialType: 'free_trial_1'
	        };
	        (0, _saProfile.startTrial)(params).then(function (res, err) {
	          if (!err) {
	            _this2.setLoader();
	            window.location.reload();
	            // console.log(res);
	          } else {
	            _this2.setLoader();
	            window.location.reload();
	            // console.log(err);
	          }
	        });
	      };
	      var renderLoader = (0, _renderIf2.default)(isLoading);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: this.props.show },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row', _Tutorial2.default.counter_container) },
	            _react2.default.createElement(
	              'button',
	              { className: _Tutorial2.default.absoluteCross, onClick: this.onCloseModal },
	              'x'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Tutorial2.default.header) },
	              'LIMIT EXCEEDED'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Tutorial2.default.tutorialData },
	              _react2.default.createElement(
	                'div',
	                { className: _Tutorial2.default.containerBox },
	                _react2.default.createElement(
	                  'div',
	                  { className: _Tutorial2.default.imageContainer },
	                  _react2.default.createElement('img', { alt: 'filter icon', src: 'https://s3.amazonaws.com/myrbmedia-dev/Images/loadmore.png', className: _Tutorial2.default.filterImage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Tutorial2.default.filterDescription },
	                  'You have reached the contact limit of ',
	                  this.props.showCountOne ? '1' : '10',
	                  ' college(s) for the day. We are actively communicating with the coaches. Check back after 24hrs to contact more colleges.',
	                  !this.props.subscribed && this.props.onTrial ? _react2.default.createElement(
	                    'span',
	                    { style: { color: '#ef4136' } },
	                    ' You are currently on a free trial.'
	                  ) : '',
	                  this.props.showCountOne ? _react2.default.createElement(
	                    'span',
	                    { style: { color: '#ef4136' } },
	                    ' You are currently using a free account.'
	                  ) : ''
	                )
	              )
	            ),
	            this.props.subscribed ? _react2.default.createElement(
	              'div',
	              { className: _Tutorial2.default.counter_button_container },
	              _react2.default.createElement(
	                'button',
	                { onClick: this.onCloseModal },
	                'Close'
	              ),
	              ' '
	            ) : _react2.default.createElement(
	              'div',
	              { className: _Tutorial2.default.counter_button_container },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/pricing' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'UPGRADE NOW'
	                )
	              ),
	              this.props.showTrialButton ? _react2.default.createElement(
	                'button',
	                { className: _Tutorial2.default.tryButton, onClick: onPressTryForFree },
	                'TRY FOR FREE'
	              ) : ''
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tutorials;
	}(_react.Component);
	
	Tutorials.propTypes = {
	  showCounterScreen: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool.isRequired,
	  showCountOne: _propTypes2.default.bool.isRequired,
	  onTrial: _propTypes2.default.bool.isRequired,
	  subscribed: _propTypes2.default.bool.isRequired,
	  showTrialButton: _propTypes2.default.bool.isRequired,
	  saProfileID: _propTypes2.default.string.isRequired
	};
	exports.default = Tutorials;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _Checkbox = __webpack_require__(1988);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tutorial = __webpack_require__(508);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _TutorialData = __webpack_require__(1128);
	
	var _TutorialData2 = _interopRequireDefault(_TutorialData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to import local scss fle
	
	
	var TutorialBox = function TutorialBox(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _Tutorial2.default.containerBox },
	    _react2.default.createElement(
	      'div',
	      { className: _Tutorial2.default.imageContainer },
	      _react2.default.createElement('img', { alt: 'filter icon', src: 'https://s3.amazonaws.com/myrbmedia-dev/Images/' + props.data.image, className: _Tutorial2.default.filterImage })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _Tutorial2.default.filterDescription },
	      props.data.text,
	      props.data.header === 'Recommendations' ? _react2.default.createElement(
	        'span',
	        { className: _Tutorial2.default.notifyRed },
	        'You can contact up to 10 colleges per day while subscribed.'
	      ) : ''
	    )
	  );
	};
	
	TutorialBox.propTypes = {
	  data: _propTypes2.default.shape().isRequired
	};
	
	var titles = {
	  0: 'RECOMMENDATIONS',
	  1: 'FILTER',
	  2: 'LOAD MORE'
	};
	
	var checkboxStyles = {
	  checkbox: {
	    marginBottom: 16
	  },
	  labelStyle: {
	    fontSize: 12
	  },
	  iconStyle: {
	    fill: '#4a90e2'
	  }
	};
	
	var Tutorials = function (_Component) {
	  _inherits(Tutorials, _Component);
	
	  function Tutorials(props) {
	    _classCallCheck(this, Tutorials);
	
	    var _this = _possibleConstructorReturn(this, (Tutorials.__proto__ || Object.getPrototypeOf(Tutorials)).call(this, props));
	
	    _this.updateCheck = function () {
	      _this.setState({ checked: !_this.state.checked });
	      window.localStorage.setItem('count', 111);
	    };
	
	    _this.updateTab = function () {
	      if (_this.state.tab === 2) {
	        var count = window.localStorage.getItem('count');
	        if (count === undefined) {
	          window.localStorage.setItem('count', 1);
	        } else if (!_this.state.checked) {
	          window.localStorage.setItem('count', count + 1); //eslint-disable-line
	        }
	        _this.onCloseModal();
	      } else {
	        _this.setState({ tab: _this.state.tab + 1 });
	      }
	    };
	
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.state = {
	      open: true,
	      title: 'RECOMMENDATIONS',
	      tab: 0,
	      checked: false
	    };
	    return _this;
	  }
	  // static propTypes = {
	  //
	  // };
	
	
	  _createClass(Tutorials, [{
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)',
	          zIndex: 1
	        },
	        // content: {
	        //   top: '50%',
	        //   left: '50%',
	        //   right: 'auto',
	        //   bottom: 'auto',
	        //   marginRight: '-50%',
	        //   minHeight: '300px',
	        //   transform: 'translate(-50%, -50%)',
	        // },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          minHeight: '300px',
	          paddingTop: '20px',
	          paddingLeft: '0px',
	          paddingRight: '0px',
	          paddingBottom: '0',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      var _state = this.state,
	          open = _state.open,
	          tab = _state.tab;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: open },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row', _Tutorial2.default.container) },
	            _react2.default.createElement(
	              'button',
	              { className: _Tutorial2.default.absoluteCross, onClick: this.onCloseModal },
	              'x'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Tutorial2.default.header) },
	              titles[tab]
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Tutorial2.default.tutorialData },
	              _react2.default.createElement(TutorialBox, { data: _TutorialData2.default[tab] })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Tutorial2.default.dontShowMeagain) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m8') },
	                _react2.default.createElement(_Checkbox2.default, {
	                  label: 'Don\'t show this message again.',
	                  checked: this.state.checked,
	                  onCheck: this.updateCheck,
	                  labelStyle: checkboxStyles.labelStyle,
	                  iconStyle: checkboxStyles.iconStyle
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m4', _Tutorial2.default.helpButtons) },
	                _react2.default.createElement(
	                  _button2.default,
	                  { className: _Tutorial2.default.nextButton, onClick: this.updateTab },
	                  'NEXT'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tutorials;
	}(_react.Component);
	
	Tutorials.defaultProps = {
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = Tutorials;

/***/ },
/* 1128 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var tutorialData = [{
	  header: 'Recommendations',
	  text: 'Here are your first 50 college coach matches. As you contact them they will be replaced by new matches. Contact every coach you see to maximize your recruitment. \n',
	  image: 'recommendations.png'
	}, {
	  header: 'Filter',
	  text: 'Try Filter to view and contact coaches from other divisions. Remember, the more exposure you get, the better your chances are. You never know the perfect fit for you until you explore all of your options. Contact every coach you have matched for your best recruitment outcome. \n',
	  image: 'filter.png'
	}, {
	  header: 'Load More',
	  text: 'Click load more button to view more colleges.\n',
	  image: 'loadmore.png'
	}];
	
	exports.default = tutorialData;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tutorial = __webpack_require__(1127);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Tutorial2.default;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _Filter = __webpack_require__(1139);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DashboardView = __webpack_require__(113);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardNav = function DashboardNav(props) {
	  // eslint-disable-next-line no-unused-vars
	  var tab = props.tab,
	      toggleSchools = props.toggleSchools,
	      toggleView = props.toggleView,
	      toggleFilter = props.toggleFilter,
	      filter = props.filter,
	      updateFilter = props.updateFilter,
	      subscribed = props.subscribed,
	      showSchools = props.showSchools;
	
	  var renderIfDefault = (0, _renderIf2.default)(tab === 0);
	  var renderIfContacted = (0, _renderIf2.default)(tab === 1);
	  var renderIfWishList = (0, _renderIf2.default)(tab === 2);
	  var renderIfNotUpgrade = (0, _renderIf2.default)(true);
	  var renderFilterIcon = (0, _renderIf2.default)(tab === 0);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12', _DashboardView2.default.removePadding) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _DashboardView2.default.tabsContainer) },
	      renderIfDefault(_react2.default.createElement(
	        'div',
	        { className: _DashboardView2.default.tabsButton },
	        _react2.default.createElement(
	          'button',
	          {
	            className: showSchools === true ? _DashboardView2.default.colorSchoolTab : _DashboardView2.default.schoolTab, onClick: function onClick() {
	              return toggleSchools('school');
	            }
	          },
	          'COLLEGES'
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: showSchools === true ? _DashboardView2.default.postingTab : _DashboardView2.default.colorPostingTab,
	            onClick: function onClick() {
	              return toggleSchools('posting');
	            }
	          },
	          'POSTINGS'
	        )
	      )),
	      renderIfContacted(_react2.default.createElement(
	        'div',
	        { className: _DashboardView2.default.tabsButton },
	        _react2.default.createElement(
	          'span',
	          { className: _DashboardView2.default.myrequestSpan },
	          'COACHES YOU HAVE CONTACTED'
	        )
	      )),
	      renderIfWishList(_react2.default.createElement(
	        'div',
	        { className: _DashboardView2.default.tabsButton },
	        _react2.default.createElement(
	          'button',
	          {
	            className: _DashboardView2.default.schoolTabWithoutBorder,
	            onClick: function onClick() {
	              return undefined.toggleSchools('school');
	            }
	          },
	          'SCHOOLS'
	        )
	      )),
	      renderIfNotUpgrade(_react2.default.createElement(
	        'span',
	        { className: _DashboardView2.default.filterButtonsContainer },
	        renderFilterIcon(_react2.default.createElement(
	          'button',
	          {
	            className: _DashboardView2.default.gridButton,
	            onClick: function onClick() {
	              return toggleFilter();
	            }
	          },
	          _react2.default.createElement('img', { alt: 'filtericon', src: 'https://media.dev.myrecruitboard.com/Images/filterNormal.png' })
	        )),
	        _react2.default.createElement(
	          'button',
	          { className: _DashboardView2.default.gridButton, onClick: toggleView },
	          _react2.default.createElement('img', {
	            alt: 'filtericon',
	            src: 'https://media.dev.myrecruitboard.com/Images/lineIcon.png'
	          })
	        )
	      ))
	    ),
	    _react2.default.createElement(_Divider2.default, null),
	    renderIfDefault(_react2.default.createElement(
	      'div',
	      { className: _DashboardView2.default.tabsButton },
	      _react2.default.createElement(
	        'span',
	        { className: _DashboardView2.default.myrequestSpan },
	        'MATCHES BASED ON YOUR ACADEMIC AND BIOMETRIC PROFILES'
	      )
	    )),
	    _react2.default.createElement(_Filter2.default, Object.assign({
	      updateFilter: updateFilter,
	      filter: filter,
	      toggleFilter: toggleFilter,
	      usedFor: 'schools'
	    }, props))
	  );
	};
	
	DashboardNav.propTypes = {
	  tab: _propTypes2.default.number.isRequired,
	  toggleSchools: _propTypes2.default.func.isRequired,
	  toggleView: _propTypes2.default.func.isRequired,
	  toggleFilter: _propTypes2.default.func.isRequired,
	  updateFilter: _propTypes2.default.shape.isRequired,
	  filter: _propTypes2.default.shape().isRequired,
	  subscribed: _propTypes2.default.bool.isRequired,
	  showSchools: _propTypes2.default.bool.isRequired
	};
	
	exports.default = DashboardNav;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DashboardView = __webpack_require__(1120);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DashboardView2.default;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _RequestsTile = __webpack_require__(1198);
	
	var _RequestsTile2 = _interopRequireDefault(_RequestsTile);
	
	var _RequestListView = __webpack_require__(1194);
	
	var _RequestListView2 = _interopRequireDefault(_RequestListView);
	
	var _Nocontentfound = __webpack_require__(195);
	
	var _Nocontentfound2 = _interopRequireDefault(_Nocontentfound);
	
	var _DashboardView = __webpack_require__(113);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequestView = function RequestView(props) {
	  var gridView = props.gridView,
	      requests = props.requests,
	      subscribed = props.subscribed,
	      requestViewedCount = props.requestViewedCount;
	
	  var myRequests = requests || [];
	  var newestContacted = [];
	  for (var i = 0; i < myRequests.size; i++) {
	    // eslint-disable-line
	    var temp = myRequests.get(i);
	    if (temp.get('conversation').size > 1) {
	      newestContacted.push(temp);
	      myRequests = myRequests.delete(i);
	    }
	  }
	
	  var renderGridView = (0, _renderIf2.default)(gridView);
	  var renderListView = (0, _renderIf2.default)(!gridView);
	  var renderNoContentFound = (0, _renderIf2.default)(requests.size === 0 && subscribed);
	  var renderCounterText = (0, _renderIf2.default)(requestViewedCount);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12', _DashboardView2.default.alignCenter) },
	    renderCounterText(_react2.default.createElement(
	      'p',
	      { className: _DashboardView2.default.requestViewedCount },
	      requestViewedCount,
	      ' ',
	      requestViewedCount === 1 ? 'Coach' : 'Coaches',
	      ' viewed your profile.'
	    )),
	    renderGridView(_react2.default.createElement(
	      'div',
	      null,
	      newestContacted.map(function (item) {
	        return _react2.default.createElement(_RequestsTile2.default, { request: item });
	      }),
	      myRequests.map(function (item) {
	        return _react2.default.createElement(_RequestsTile2.default, { request: item });
	      })
	    )),
	    renderListView(_react2.default.createElement(
	      'div',
	      null,
	      newestContacted.map(function (item) {
	        return _react2.default.createElement(_RequestListView2.default, { request: item });
	      }),
	      myRequests.map(function (item) {
	        return _react2.default.createElement(_RequestListView2.default, { request: item });
	      })
	    )),
	    renderNoContentFound(_react2.default.createElement(_Nocontentfound2.default, { text: '' }))
	  );
	};
	
	RequestView.propTypes = {
	  gridView: _propTypes2.default.bool.isRequired,
	  requests: _propTypes2.default.shape.isRequired,
	  subscribed: _propTypes2.default.bool.isRequired,
	  requestViewedCount: _propTypes2.default.number.isRequired
	};
	
	exports.default = RequestView;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SchoolTile = __webpack_require__(464);
	
	var _SchoolTile2 = _interopRequireDefault(_SchoolTile);
	
	var _SchoolListView = __webpack_require__(463);
	
	var _SchoolListView2 = _interopRequireDefault(_SchoolListView);
	
	var _Nocontentfound = __webpack_require__(195);
	
	var _Nocontentfound2 = _interopRequireDefault(_Nocontentfound);
	
	var _DashboardView = __webpack_require__(113);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WishlistView = function WishlistView(props) {
	  var contactedList = props.contactedList,
	      schools = props.schools,
	      wishList = props.wishList,
	      inviteToCampList = props.inviteToCampList,
	      addToList = props.addToList,
	      fillQList = props.fillQList,
	      profileId = props.profileId,
	      addToRequest = props.addToRequest,
	      removeFromList = props.removeFromList,
	      showCounterpopUp = props.showCounterpopUp,
	      addNotification = props.addNotification,
	      gridView = props.gridView,
	      subscribed = props.subscribed;
	
	  var renderNoContentFound = (0, _renderIf2.default)(wishList.size === 0 && subscribed);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12', _DashboardView2.default.alignCenter) },
	    renderNoContentFound(_react2.default.createElement(_Nocontentfound2.default, { text: 'You don\'t have any items in wishlist.' })),
	    schools.map(function (item) {
	      var wishListId = wishList.indexOf(item.get('id'));
	      var inWishList = wishListId > -1;
	      var interested = contactedList.indexOf(item.get('id')) > -1;
	      var fillQ = fillQList.indexOf(item.get('id')) > -1;
	      var inviteToCamp = inviteToCampList.indexOf(item.get('id')) > -1;
	      var show = wishListId > -1 && interested > -1;
	      if (show) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          gridView ? _react2.default.createElement(_SchoolTile2.default, Object.assign({
	            saSchool: item,
	            addToList: addToList,
	            profileId: profileId,
	            addToRequest: addToRequest,
	            inWishList: inWishList,
	            interested: interested,
	            removeFromList: removeFromList,
	            wishListId: wishListId,
	            showCounterScreen: showCounterpopUp
	          }, props, {
	            fillQ: fillQ,
	            inviteToCamp: inviteToCamp,
	            showSnackBar: function showSnackBar(val) {
	              return addNotification(val);
	            },
	            usedFor: 'schools'
	          })) : _react2.default.createElement(_SchoolListView2.default, Object.assign({
	            saSchool: item,
	            addToList: addToList,
	            profileId: profileId,
	            addToRequest: addToRequest,
	            inWishList: inWishList,
	            interested: interested,
	            removeFromList: removeFromList,
	            wishListId: wishListId,
	            showCounterScreen: showCounterpopUp
	          }, props, {
	            fillQ: fillQ,
	            inviteToCamp: inviteToCamp,
	            showSnackBar: function showSnackBar(val) {
	              return addNotification(val);
	            },
	            usedFor: 'schools'
	          }))
	        );
	      }
	      return null;
	    })
	  );
	};
	
	WishlistView.propTypes = {
	  addToList: _propTypes2.default.func.isRequired,
	  addToRequest: _propTypes2.default.func.isRequired,
	  wishList: _propTypes2.default.shape.isRequired,
	  contactedList: _propTypes2.default.shape.isRequired,
	  inviteToCampList: _propTypes2.default.shape.isRequired,
	  profileId: _propTypes2.default.string.isRequired,
	  removeFromList: _propTypes2.default.func.isRequired,
	  gridView: _propTypes2.default.bool.isRequired,
	  showCounterpopUp: _propTypes2.default.func.isRequired,
	  addNotification: _propTypes2.default.func.isRequired,
	  schools: _propTypes2.default.shape.isRequired,
	  fillQList: _propTypes2.default.shape.isRequired,
	  subscribed: _propTypes2.default.bool.isRequired
	};
	
	exports.default = WishlistView;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Details = __webpack_require__(1485);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	
	// to display error messages on invalid user input
	//  to change path from inside or to alter react-router-dom path
	var Details = function Details(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _Details2.default.signinSection) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Details2.default.signinHeader) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _Details2.default.joinUsButtonContainer) },
	        props.data.page === 'register' ? _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/' },
	            _react2.default.createElement(
	              'button',
	              { className: _Details2.default.notAMember },
	              _react2.default.createElement(
	                'spann',
	                { className: _Details2.default.loginPageNav },
	                'HOME'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: _Details2.default.notAMember },
	            _react2.default.createElement(
	              'spann',
	              { className: _Details2.default.loginPageNavLight },
	              'Already a member?'
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/login' },
	            _react2.default.createElement(
	              'button',
	              { className: _Details2.default.detailsHeaderButton },
	              'SIGN IN'
	            )
	          )
	        ) : _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/' },
	            _react2.default.createElement(
	              'button',
	              { className: _Details2.default.notAMember },
	              _react2.default.createElement(
	                'spann',
	                { className: _Details2.default.loginPageNav },
	                'HOME'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: _Details2.default.notAMember },
	            _react2.default.createElement(
	              'spann',
	              { className: _Details2.default.loginPageNavLight },
	              'Not a member?'
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/register' },
	            _react2.default.createElement(
	              'button',
	              { className: _Details2.default.detailsHeaderButton },
	              'JOIN US'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Details2.default.signinBody) },
	      _react2.default.createElement(
	        'span',
	        { className: _Details2.default.signinBodyAlignCenter },
	        _react2.default.createElement(
	          'span',
	          { className: _Details2.default.detailsHeader },
	          props.data.detailsHeader
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _Details2.default.detailsDesc },
	          props.data.detailsDesc
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Details2.default.errorMessageContainer },
	          _react2.default.createElement(_ErrorMessage2.default, { message: props.errorMessage })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _Details2.default.editableContainer },
	          props.children
	        )
	      )
	    )
	  );
	}; // to validate and set default props  coming to this component
	
	// to use global class name eg. classes from grid.css in public folder
	
	
	Details.propTypes = {
	  data: _propTypes2.default.shape({
	    detailsHeader: _propTypes2.default.string,
	    detailsDesc: _propTypes2.default.string,
	    page: _propTypes2.default.string
	  }),
	  children: _propTypes2.default.node.isRequired,
	  errorMessage: _propTypes2.default.string
	};
	
	Details.defaultProps = {
	  data: {},
	  errorMessage: ''
	};
	
	exports.default = Details;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Divider = __webpack_require__(1486);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var Divider = function Divider() {
	  return _react2.default.createElement('div', { className: (0, _classnames2.default)('col s12', _Divider2.default.dividerLine) });
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = Divider;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _reactStepperHorizontal = __webpack_require__(368);
	
	var _reactStepperHorizontal2 = _interopRequireDefault(_reactStepperHorizontal);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _Subheader = __webpack_require__(322);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _SelectField = __webpack_require__(548);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(216);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _EditPosting = __webpack_require__(1487);
	
	var _EditPosting2 = _interopRequireDefault(_EditPosting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// to display error messages on invalid user input
	// to use input from react-toolbox library
	
	
	// to import local scss fle
	
	/* const benchSuggestions = {
	  200: '200',
	  210: '210',
	  220: '220',
	}; */
	
	var inlineStyles = {
	  menuStyle: {
	    borderBottom: 'none'
	  },
	  iconStyle: {
	    height: '40px',
	    width: '40px'
	  },
	  underlineStyle: {
	    borderBottom: 'none'
	  },
	  tileContainer: {
	    fontWeight: '500',
	    height: '39px',
	    paddingLeft: '5px',
	    fontFamily: 'unset',
	    fontSize: '14px',
	    border: '0.5px solid rgba(153,153,153,0.7)'
	  }
	};
	
	var t40Suggestions = {
	  4.3: '4.3 or lower',
	  4.4: '4.4',
	  4.5: '4.5',
	  4.6: '4.6',
	  4.7: '4.7',
	  4.8: '4.8',
	  4.9: '4.9',
	  5.0: '5.0',
	  5.1: '5.1',
	  5.2: '5.2',
	  5.3: '5.3',
	  5.4: '5.4',
	  5.5: '5.5 or higher'
	};
	var gpaSuggestions = {};
	var satSuggestions = {};
	var actSuggestions = {};
	
	var EditPosting = function (_Component) {
	  _inherits(EditPosting, _Component);
	
	  function EditPosting(props) {
	    _classCallCheck(this, EditPosting);
	
	    var _this = _possibleConstructorReturn(this, (EditPosting.__proto__ || Object.getPrototypeOf(EditPosting)).call(this, props));
	
	    _this.handleHeight = function (name, value) {
	      if (name === 'heightInFeet') {
	        if (value.target.value <= 7 && value.target.value >= 4 || value.target.value === '') {
	          _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	            _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	          });
	        }
	      } else if (value.target.value < 12 && value.target.value >= 0 || value.target.value === '') {
	        _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	          _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	        });
	      }
	    };
	
	    _this.handleWeight = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)));
	    };
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value)), function () {}); //eslint-disable-line
	    };
	
	    _this.removeErrorMessage = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, '')));
	    };
	
	    _this.state = {
	      open: false,
	      postingTitle: '',
	      postingTitleErrorMessage: '',
	      description: '',
	      descriptionErrorMessage: '',
	      t40: '',
	      t40ErrorMessage: '',
	      bench: '',
	      benchErrorMessage: '',
	      feetErrorMessage: '',
	      endDate: '',
	      endDateErrorMessage: '',
	      heightInInches: '',
	      heightInFeet: '',
	      heightInchesErrorMessage: '',
	      heightInFeetErrorMessage: '',
	      weightErrorMessage: '',
	      squats: '',
	      squatsErrorMessage: '',
	      act: '',
	      actErrorMessage: '',
	      gpa: '',
	      gpaErrorMessage: '',
	      sat: '',
	      satErrorMessage: '',
	      startDate: (0, _moment2.default)(),
	      postingStatus: 'active',
	      currentStep: 0,
	      height: '',
	      weight: '',
	      steps: [{
	        onClick: function onClick(e) {
	          _this.setState({
	            firstInfo: true,
	            currentStep: 0
	          });
	          e.preventDefault();
	        } }, {
	        onClick: function onClick(e) {
	          _this.setState({
	            secondInfo: true,
	            firstInfo: false,
	            currentStep: 1
	          });
	          e.preventDefault();
	        } }]
	    };
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handlePostings = _this.handlePostings.bind(_this);
	    _this.removeErrorMessage = _this.removeErrorMessage.bind(_this);
	    _this.next = _this.next.bind(_this);
	    _this.handleHeight = _this.handleHeight.bind(_this);
	    _this.handleWeight = _this.handleWeight.bind(_this);
	    _this.deletePosting = _this.deletePosting.bind(_this);
	    _this.handlePostingChange = _this.handlePostingChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(EditPosting, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var combinedHeight = this.props.currentPosting.get('requirements').get('min_height');
	      var sat = '';
	      var act = '';
	      if (this.props.currentPosting.get('requirements').get('min_sat') !== undefined) {
	        sat = this.props.currentPosting.get('requirements').get('min_sat');
	      }
	      if (this.props.currentPosting.get('requirements').get('min_act') !== undefined) {
	        act = this.props.currentPosting.get('requirements').get('min_act');
	      }
	      var desc = '';
	      var postingDescription = this.props.currentPosting.get('description');
	      if (postingDescription === null) {
	        desc = '';
	      } else {
	        desc = this.props.currentPosting.get('description');
	      }
	      var newState = {
	        postingTitle: this.props.currentPosting.get('posting_title'),
	        description: desc,
	        t40: this.props.currentPosting.get('requirements').get('min_t40'),
	        gpa: this.props.currentPosting.get('requirements').get('min_gpa'),
	        weight: this.props.currentPosting.get('requirements').get('min_weight'),
	        updatedTime: this.props.currentPosting.get('updated_time'),
	        heightInFeet: combinedHeight.charAt(0),
	        heightInInches: combinedHeight.substr(2, 2).replace(/['"]+/g, ''),
	        height: combinedHeight,
	        act: act,
	        sat: sat
	      };
	      this.setState(newState);
	    }
	  }, {
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.props.editPosting();
	    }
	  }, {
	    key: 'handlePostingChange',
	    value: function handlePostingChange(event, index, value) {
	      this.setState(Object.assign({}, this.state, { postingTitle: value }));
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      var _state = this.state,
	          postingTitle = _state.postingTitle,
	          heightInInches = _state.heightInInches,
	          heightInFeet = _state.heightInFeet,
	          weight = _state.weight,
	          t40 = _state.t40;
	
	      var updated = {};
	      var validPostingTiltle = void 0;
	      var validHeightInInches = void 0;
	      var validHeightInFeet = void 0;
	      var validWeight = void 0;
	      var validT40 = void 0;
	      if (postingTitle !== '') {
	        validPostingTiltle = true;
	      } else {
	        updated.postingTitleErrorMessage = 'Enter correct posting title';
	      }
	      if (heightInInches !== '') {
	        validHeightInInches = true;
	      } else {
	        updated.heightInchesErrorMessage = 'Please add height in inches';
	      }
	      if (heightInFeet !== '') {
	        validHeightInFeet = true;
	      } else {
	        updated.heightInFeetErrorMessage = 'Please add height in feet';
	      }
	      if (weight !== '') {
	        validWeight = true;
	      } else {
	        updated.weightErrorMessage = 'Please add a valid weight.';
	      }
	
	      /* T40 validation */
	
	      if (t40 !== '') {
	        validT40 = true;
	      } else {
	        updated.t40ErrorMessage = 'Please add a valid 40-Yard Dash.';
	      }
	      /* T40 validation */
	
	      /* squats validation */
	      if (validHeightInFeet && validHeightInInches && validPostingTiltle && validT40 && validWeight) {
	        this.setState({ currentStep: 1 });
	      } else {
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'handlePostings',
	    value: function handlePostings() {
	      var payload = {};
	      var updated = {};
	      var profile = this.props.profile;
	      var _state2 = this.state,
	          postingTitle = _state2.postingTitle,
	          description = _state2.description,
	          t40 = _state2.t40,
	          postingStatus = _state2.postingStatus,
	          height = _state2.height,
	          weight = _state2.weight,
	          gpa = _state2.gpa;
	
	      /* Gpa validation */
	
	      var validGpa = false;
	      if (gpa !== '') {
	        validGpa = true;
	      } else {
	        updated.gpaErrorMessage = 'Gpa is not valid.';
	      }
	      /* Gpa validation */
	      var requirements = {
	        min_gpa: gpa,
	        min_t40: t40,
	        min_height: height,
	        min_weight: weight
	      };
	      if (validGpa) {
	        if (this.state.sat !== '') {
	          requirements['min_sat'] = this.state.sat; // eslint-disable-line
	        }
	        if (this.state.act !== '') {
	          requirements['min_act'] = this.state.act; // eslint-disable-line
	        }
	        var id = this.props.currentPosting.get('id');
	        payload = Object.assign(payload, {
	          id: id,
	          posting_title: postingTitle,
	          posting_sport: 'sport',
	          team_name: 'teamName',
	          coach_name: this.props.user.username,
	          college_name: profile.get('college'),
	          college_id: profile.get('college_id'),
	          college_image: 'asdfjklasdfkj',
	          city: profile.get('city'),
	          team_page_link: profile.get('team_page_link'),
	          question_link: profile.get('question_link'),
	          division: 'D1',
	          posting_status: postingStatus,
	          interested_profiles_list: [],
	          requirements: requirements
	        });
	        if (description !== '') {
	          payload['description'] === description; // eslint-disable-line
	        }
	        this.props.updatePostings(payload, this.props.postingIndex);
	        this.props.editPosting();
	        this.setState({
	          open: false,
	          postingTitle: '',
	          description: '',
	          t40: '',
	          currentStep: 0,
	          heightInFeet: '',
	          heightInInches: ''
	        });
	      } else {
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'deletePosting',
	    value: function deletePosting() {
	      this.props.deleteposting(this.props.postingId);
	      this.props.editPosting();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      for (var i = 6; i <= 16; i++) {
	        //eslint-disable-line
	        for (var x = 1; x <= 10; x++) {
	          //eslint-disable-line
	          var listItem = '';
	          listItem = i * 100 + x * 10;
	          if (listItem === 600) {
	            listItem = '600 or Lower';
	          }
	          satSuggestions['' + listItem] = '' + listItem;
	        }
	      }
	      for (var _i = 16; _i <= 36; _i++) {
	        //eslint-disable-line
	        var _listItem = '';
	        if (_i === 16) {
	          _listItem = '' + (_i + ' or Lower');
	        } else {
	          _listItem = '' + _i;
	        }
	
	        actSuggestions['' + _listItem] = '' + _listItem;
	      }
	      for (var _i2 = 2; _i2 < 4; _i2++) {
	        //eslint-disable-line
	        for (var _x = 0; _x <= 10; _x++) {
	          //eslint-disable-line
	          var _listItem2 = '';
	          _listItem2 = '' + (_i2 + "." + _x); // eslint-disable-line
	          if (_x === 10) {
	            _listItem2 = _i2 + 1 + '.0'; // eslint-disable-line
	          }
	          if (_listItem2 === '2.0') {
	            _listItem2 = '2.0 or Lower';
	          } else if (_listItem2 === '4.0') {
	            _listItem2 = '4.0 or Higher';
	          }
	          gpaSuggestions['' + _listItem2] = '' + _listItem2;
	        }
	      }
	      var _state3 = this.state,
	          heightInchesErrorMessage = _state3.heightInchesErrorMessage,
	          postingTitleErrorMessage = _state3.postingTitleErrorMessage,
	          weightErrorMessage = _state3.weightErrorMessage,
	          satErrorMessage = _state3.satErrorMessage,
	          actErrorMessage = _state3.actErrorMessage,
	          gpaErrorMessage = _state3.gpaErrorMessage,
	          t40ErrorMessage = _state3.t40ErrorMessage,
	          heightInFeetErrorMessage = _state3.heightInFeetErrorMessage;
	
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)',
	          zIndex: 1
	        },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          borderRadius: '0px',
	          maxWidth: '70%',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _EditPosting2.default.container) },
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            style: modalStyle,
	            isOpen: this.props.openPosting,
	            onClose: this.onCloseModal
	            // little
	          },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row') },
	            _react2.default.createElement(
	              'button',
	              { className: _EditPosting2.default.absoluteCross, onClick: this.onCloseModal },
	              'x'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _EditPosting2.default.header) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'EDIT YOUR POSTING!'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _EditPosting2.default.fullWidth) },
	              _react2.default.createElement(
	                'div',
	                { className: _EditPosting2.default.stepperContainer },
	                _react2.default.createElement(_reactStepperHorizontal2.default, {
	                  steps: this.state.steps,
	                  activeColor: '#333',
	                  circleFontColor: '#FFF',
	                  defaultTitleColor: '#EBEBEB',
	                  activeTitleColor: '#FFF',
	                  completeColor: '#EBEBEB',
	                  activeStep: this.state.currentStep
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.currentStep === 0 ? (0, _classnames2.default)('col s12', _EditPosting2.default.fullWidth) : _EditPosting2.default.hidden },
	              _react2.default.createElement(
	                'div',
	                { className: postingTitleErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpanonError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'POSITION I AM RECRUITING'
	                ),
	                _react2.default.createElement(
	                  _SelectField2.default,
	                  {
	                    style: inlineStyles.tileContainer,
	                    value: this.state.postingTitle,
	                    onChange: this.handlePostingChange,
	                    menuStyle: inlineStyles.menuStyle,
	                    iconStyle: inlineStyles.iconStyle,
	                    underlineStyle: inlineStyles.underlineStyle,
	                    autoWidth: false,
	                    maxHeight: 300
	                  },
	                  _react2.default.createElement(
	                    _Subheader2.default,
	                    null,
	                    'OFFENSIVE POSITIONS'
	                  ),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'QBDT', primaryText: 'Quarterback - Duel Threat' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'QBPS', primaryText: 'Quarterback - Pro Style' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'WR', primaryText: 'Wide Receiver' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'SR', primaryText: 'Slot Receiver' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'RB', primaryText: 'Running Back' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'FB', primaryText: 'Full Back' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'HB', primaryText: 'H-Back' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'TE', primaryText: 'Tight End' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'OL', primaryText: 'Offensive Guard' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'OT', primaryText: 'Offensive Tackle' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'C', primaryText: 'Center' }),
	                  _react2.default.createElement(
	                    _Subheader2.default,
	                    null,
	                    'DEFENSIVE POSITIONS'
	                  ),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'DT', primaryText: 'Defensive Tackle' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'DE', primaryText: 'Defensive End' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'ML', primaryText: 'Middle Linebacker' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'OL', primaryText: 'Outside Linebacker' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'DB', primaryText: 'Cornerback' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'SS', primaryText: 'Strong Safety' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'FS', primaryText: 'Free Safety' }),
	                  _react2.default.createElement(
	                    _Subheader2.default,
	                    null,
	                    'SPECIAL TEAM POSITIONS'
	                  ),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'K', primaryText: 'Kicker' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'P', primaryText: 'Punter' }),
	                  _react2.default.createElement(_MenuItem2.default, { value: 'LS', primaryText: 'Long Snapper' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _EditPosting2.default.heightAndWidthContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12 m6', _EditPosting2.default.heightWidth) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM HEIGHT'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s12', _EditPosting2.default.heightContainer) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s6', _EditPosting2.default.feetContainer) },
	                      _react2.default.createElement('input', {
	                        className: heightInFeetErrorMessage === '' ? (0, _classnames2.default)('col s12', _EditPosting2.default.simpleInput) : (0, _classnames2.default)('col s12', _EditPosting2.default.simpleInputError),
	                        type: 'text',
	                        placeholder: 'Feet',
	                        value: this.state.heightInFeet,
	                        onFocus: function onFocus() {
	                          return _this2.removeErrorMessage('heightInFeetErrorMessage');
	                        },
	                        onChange: function onChange(val) {
	                          return _this2.handleHeight('heightInFeet', val);
	                        }
	                      }),
	                      _react2.default.createElement(_ErrorMessage2.default, { message: heightInFeetErrorMessage })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s6', _EditPosting2.default.inchesContainer) },
	                      _react2.default.createElement('input', {
	                        className: heightInchesErrorMessage === '' ? (0, _classnames2.default)('col s12', _EditPosting2.default.simpleInput) : (0, _classnames2.default)('col s12', _EditPosting2.default.simpleInputError),
	                        type: 'text',
	                        placeholder: 'Inches',
	                        value: this.state.heightInInches,
	                        onFocus: function onFocus() {
	                          return _this2.removeErrorMessage('heightInchesErrorMessage');
	                        },
	                        onChange: function onChange(val) {
	                          return _this2.handleHeight('heightInInches', val);
	                        }
	                      }),
	                      _react2.default.createElement(_ErrorMessage2.default, { message: heightInchesErrorMessage })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: weightErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _EditPosting2.default.weightSection) : (0, _classnames2.default)('col s12 m6', _EditPosting2.default.weightSectionOnError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM WEIGHT'
	                  ),
	                  _react2.default.createElement('input', {
	                    className: (0, _classnames2.default)('col s12', _EditPosting2.default.simpleInput),
	                    value: this.state.weight,
	                    onChange: function onChange(val) {
	                      return _this2.handleWeight('weight', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.removeErrorMessage('weightErrorMessage');
	                    },
	                    placeholder: 'Pounds'
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.weightErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _EditPosting2.default.dropdowns) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: t40ErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpanonError) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'SLOWEST 40-YARD DASH'
	                    ),
	                    _react2.default.createElement(_autocomplete2.default, {
	                      source: t40Suggestions,
	                      selectedPosition: 'below',
	                      direction: 'down',
	                      value: this.state.t40,
	                      multiple: false,
	                      onFocus: function onFocus() {
	                        return _this2.removeErrorMessage('t40ErrorMessage');
	                      },
	                      onChange: function onChange(val) {
	                        return _this2.handleChange('t40', val);
	                      },
	                      onQueryChange: function onQueryChange(val) {
	                        return _this2.handleChange('t40', val);
	                      }
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: t40ErrorMessage })
	                  )
	                )
	              ),
	              _react2.default.createElement('div', null),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _EditPosting2.default.buttonContainer) },
	                _react2.default.createElement(_button2.default, { label: 'NEXT', onClick: this.next })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: this.state.currentStep === 1 ? (0, _classnames2.default)('col s12', _EditPosting2.default.fullWidth) : _EditPosting2.default.hidden },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _EditPosting2.default.dropdowns) },
	                _react2.default.createElement(
	                  'div',
	                  { className: gpaErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpanonError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM GPA'
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: gpaSuggestions,
	                    selectedPosition: 'below',
	                    direction: 'down',
	                    allowCreate: true,
	                    value: this.state.gpa,
	                    multiple: false,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('gpa', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.removeErrorMessage('gpaErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: gpaErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: satErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _EditPosting2.default.rightSection) : (0, _classnames2.default)('col s12 m6', _EditPosting2.default.rightSectionOnError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM SAT',
	                    _react2.default.createElement(
	                      'span',
	                      { className: _EditPosting2.default.optionalTag },
	                      '\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: satSuggestions,
	                    selectedPosition: 'below',
	                    direction: 'down',
	                    value: this.state.sat,
	                    multiple: false,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('sat', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.removeErrorMessage('satErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: satErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: actErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _EditPosting2.default.halfWidthWithSpanonError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MINIMUM ACT',
	                    _react2.default.createElement(
	                      'span',
	                      { className: _EditPosting2.default.optionalTag },
	                      '\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: actSuggestions,
	                    selectedPosition: 'below',
	                    direction: 'down',
	                    value: this.state.act,
	                    multiple: false,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('act', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.removeErrorMessage('actErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: actErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _EditPosting2.default.halfWidthWithSpan) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'DESCRIPTION',
	                    _react2.default.createElement(
	                      'span',
	                      { className: _EditPosting2.default.optionalTag },
	                      '\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'full_name',
	                    value: this.state.description,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('description', val);
	                    },
	                    multiline: true
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _EditPosting2.default.buttonContainer) },
	                  _react2.default.createElement(_button2.default, { onClick: this.handlePostings, label: 'POST' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: _EditPosting2.default.deleteButton, onClick: function onClick() {
	                  return _this2.deletePosting();
	                } },
	              _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/deleteicon.png', alt: 'delete-icon' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return EditPosting;
	}(_react.Component);
	
	EditPosting.propTypes = {
	  updatePostings: _propTypes2.default.func,
	  postingIndex: _propTypes2.default.number,
	  user: _propTypes2.default.shape(),
	  profile: _propTypes2.default.shape(),
	  deleteposting: _propTypes2.default.func,
	  editPosting: _propTypes2.default.func,
	  postingId: _propTypes2.default.string,
	  openPosting: _propTypes2.default.bool,
	  currentPosting: _propTypes2.default.shape()
	};
	EditPosting.defaultProps = {
	
	  updatePostings: function updatePostings() {},
	  postingIndex: '',
	  user: {},
	  profile: {},
	  deleteposting: function deleteposting() {},
	  editPosting: function editPosting() {},
	  postingId: '',
	  openPosting: false,
	  currentPosting: _propTypes2.default.shape()
	};
	exports.default = EditPosting;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EditPosting = __webpack_require__(1136);
	
	var _EditPosting2 = _interopRequireDefault(_EditPosting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _EditPosting2.default;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _DropDownMenu = __webpack_require__(321);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	var _MenuItem = __webpack_require__(216);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Filter = __webpack_require__(1489);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// import Checkbox from 'react-toolbox/lib/checkbox';
	// use of immutablejs for various js operations to simplify our work
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var items = [];
	for (var i = 0; i < _DropdownsValues.statesArray.length; i++) {
	  //eslint-disable-line
	  items.push(_react2.default.createElement(_MenuItem2.default, { value: i, key: i, primaryText: '' + _DropdownsValues.statesArray[i] }));
	}
	
	var styles = {
	  customWidth: {
	    width: 180
	  },
	  labelStyle: {
	    color: '#4a4a4a',
	    fontSize: '12px',
	    fontWeight: '400'
	  },
	  iconStyle: {
	    color: 'blue'
	  }
	};
	
	var Filter = function (_Component) {
	  _inherits(Filter, _Component);
	
	  function Filter(props) {
	    _classCallCheck(this, Filter);
	
	    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));
	
	    _this.handleChange = function (event, index, value) {
	      _this.setState({ divisions: value });
	    };
	
	    _this.state = {
	      value: 0,
	      stateIndex: 0,
	      D1: false,
	      D2: false,
	      D3: false,
	      currentState: 'All States',
	      divisions: 'All Divisions',
	      filterCleared: false
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleStateChange = _this.handleStateChange.bind(_this);
	    _this.onClickApply = _this.onClickApply.bind(_this);
	    _this.onClickClose = _this.onClickClose.bind(_this);
	    _this.onClickClear = _this.onClickClear.bind(_this);
	    _this.filters = {};
	    return _this;
	  }
	
	  _createClass(Filter, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var filter = this.props.filter;
	
	      var that = this;
	      if (filter && filter.size > 0) {
	        var data = filter.get('data');
	        that.setState({ state: filter.get('state') });
	        var divisions = data.get('filter_divisions');
	        if (_immutable.List.isList(divisions) && divisions.size > 0) {
	          that.filters.filter_divisions = [];
	          divisions.forEach(function (div) {
	            var temp = {};
	            temp[div] = true;
	            that.setState(temp);
	            that.filters.filter_divisions.push(div);
	            return div;
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filter = nextProps.filter;
	
	      var that = this;
	      if (nextProps.filter.size > 0) {
	        if (filter.get('clear') === undefined) {
	          this.setState({ filterCleared: true });
	        } else {
	          this.setState({ filterCleared: false });
	        }
	      }
	      if (filter && filter.size > 0) {
	        var data = filter.get('data');
	        this.setState({ state: filter.get('state') });
	        var divisions = data.get('filter_divisions');
	        if (_immutable.List.isList(divisions)) {
	          divisions.map(function (div) {
	            var temp = {};
	            temp[div] = true;
	            that.setState(temp);
	            return null;
	          });
	        }
	      }
	    }
	  }, {
	    key: 'onClickApply',
	    value: function onClickApply() {
	      var profile = this.props.profile;
	
	      var divisonArray = [];
	      if (this.state.currentState === 'All States') {
	        var prop = 'state';
	        delete this.filters[prop]; // eslint-disable-lint
	      }
	      divisonArray.push(this.state.divisions);
	      if (this.state.divisions === 'All Divisions') {
	        if (this.props.recommendedDivision === 'D1' || profile.get('current_division') === 'D1' || profile.get('override_division') === 'D1') {
	          divisonArray = ['D1'];
	        }
	
	        if (this.props.recommendedDivision === 'D2' || profile.get('current_division') === 'D2' || profile.get('override_division') === 'D2') {
	          divisonArray = ['D2', 'D3', 'JUCO', 'NAIA'];
	        }
	        if (this.props.recommendedDivision === 'D3' || profile.get('current_division') === 'D2' || profile.get('override_division') === 'D2') {
	          divisonArray = ['D3', 'JUCO', 'NAIA'];
	        }
	        if (this.props.recommendedDivision === 'JUCO' || profile.get('current_division') === 'JUCO' || profile.get('override_division') === 'JUCO') {
	          divisonArray = ['JUCO', 'NAIA'];
	        }
	        if (this.props.recommendedDivision === 'NAIA' || profile.get('current_division') === 'NAIA' || profile.get('override_division') === 'NAIA') {
	          divisonArray = ['NAIA'];
	        }
	        this.setState({ filterCleared: true });
	      }
	      this.filters['filter_divisions'] = divisonArray; //eslint-disable-line
	      var sendStates = this.state.currentState;
	      if (this.state.currentState === 'All States') {
	        sendStates = '';
	        // this.filters.filter_divisions = [];
	      }
	      this.props.updateFilter({ data: this.filters, apply: true, state: sendStates });
	    }
	  }, {
	    key: 'onClickClear',
	    value: function onClickClear() {
	      this.props.updateFilter({ data: {}, apply: true, state: '', clear: true });
	      this.setState({ filterCleared: false, stateIndex: 0, divisions: 'All Divisions', currentState: 'All States' });
	      // this.props.toggleFilter();
	    }
	  }, {
	    key: 'onClickClose',
	    value: function onClickClose() {
	      this.props.updateFilter({ data: this.filters, apply: false, state: this.state.state });
	      this.props.toggleFilter();
	    }
	  }, {
	    key: 'handleStateChange',
	    value: function handleStateChange(event, index, value) {
	      this.setState({ currentState: _DropdownsValues.statesArray[value], stateIndex: index });
	      if (_DropdownsValues.statesArray[value] !== 'All States') {
	        if (_DropdownsValues.statesArray[value] === 'Washington D.C') {
	          this.filters.state = 'D.C.';
	        } else {
	          this.filters.state = _DropdownsValues.statesArray[value];
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var filterCleared = this.state.filterCleared;
	      var _props = this.props,
	          recommendedDivision = _props.recommendedDivision,
	          renderFilterSchools = _props.renderFilterSchools,
	          currentDivision = _props.currentDivision,
	          overrideDivision = _props.overrideDivision;
	
	      var renderClearFilter = (0, _renderIf2.default)(filterCleared);
	      if (!renderFilterSchools) {
	        return null;
	      }
	
	      var disableD1 = recommendedDivision === 'D2' || recommendedDivision === 'D3' || recommendedDivision === 'NAIA' || recommendedDivision === 'JUCO' || currentDivision === 'D2' || currentDivision === 'D3' || currentDivision === 'NAIA' || currentDivision === 'JUCO' || overrideDivision === 'D2' || overrideDivision === 'D3';
	      var disableD2 = recommendedDivision === 'D3' || recommendedDivision === 'NAIA' || recommendedDivision === 'JUCO' || currentDivision === 'D3' || currentDivision === 'NAIA' || currentDivision === 'JUCO' || overrideDivision === 'D3';
	
	      var disableD3 = recommendedDivision === 'NAIA' || recommendedDivision === 'JUCO' || currentDivision === 'NAIA' || currentDivision === 'JUCO';
	
	      var disableNaia = recommendedDivision === 'JUCO' || currentDivision === 'JUCO';
	
	      if (overrideDivision === 'D1') disableD1 = false;
	      if (overrideDivision === 'D2') disableD2 = false;
	      if (overrideDivision === 'D2') disableD3 = false;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _Filter2.default.containerFilter) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m8') },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s6 m4', _Filter2.default.removePadding) },
	            _react2.default.createElement(
	              _DropDownMenu2.default,
	              {
	                className: _Filter2.default.removePadding,
	                value: this.state.stateIndex,
	                onChange: this.handleStateChange,
	                style: styles.customWidth,
	                autoWidth: false,
	                labelStyle: styles.labelStyle,
	                maxHeight: 300,
	                iconStyle: styles.iconStyle
	              },
	              items
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s5 m4', _Filter2.default.removePadding) },
	            _react2.default.createElement(
	              _DropDownMenu2.default,
	              {
	                value: this.state.divisions,
	                onChange: this.handleChange,
	                style: styles.customWidth,
	                labelStyle: styles.labelStyle,
	                autoWidth: false,
	                iconStyle: styles.iconStyle
	              },
	              _react2.default.createElement(_MenuItem2.default, {
	                value: 'All Divisions',
	                primaryText: 'All Divisions'
	              }),
	              _react2.default.createElement(_MenuItem2.default, {
	                value: 'D1',
	                disabled: disableD1
	                // disabled={(recommendedDivision === 'D2' || recommendedDivision === 'D3' ||
	                // recommendedDivision === 'JUCO' ||
	                // recommendedDivision === 'NAIA') ? true : false} // eslint-disable-line
	                , primaryText: 'Division 1'
	              }),
	              _react2.default.createElement(_MenuItem2.default, {
	                value: 'D2',
	                disabled: disableD2,
	                primaryText: 'Division 2'
	              }),
	              _react2.default.createElement(_MenuItem2.default, {
	                value: 'D3',
	                disabled: disableD3,
	                primaryText: 'Division 3'
	              }),
	              _react2.default.createElement(_MenuItem2.default, {
	                value: 'NAIA',
	                disabled: disableNaia,
	                primaryText: 'NAIA'
	              }),
	              _react2.default.createElement(_MenuItem2.default, {
	                value: 'JUCO',
	                primaryText: 'JUCO'
	              })
	            )
	          ),
	          renderClearFilter(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s4', _Filter2.default.clearFilter) },
	            _react2.default.createElement(
	              'button',
	              { onClick: this.onClickClear },
	              'CLEAR FILTER'
	            )
	          ))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m4', _Filter2.default.applyButton) },
	          _react2.default.createElement(
	            'button',
	            { onClick: this.onClickClose },
	            'CLOSE'
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: _Filter2.default.apply, onClick: this.onClickApply },
	            'APPLY'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Filter2.default.filterInSmall) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s4') },
	            _react2.default.createElement(
	              'button',
	              { onClick: this.onClickClose, className: _Filter2.default.closeButtonInSmall },
	              'CLOSE'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s4') },
	            renderClearFilter(_react2.default.createElement(
	              'button',
	              { onClick: this.onClickClear, className: _Filter2.default.clearFilterForSmall },
	              'CLEAR'
	            ))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s4') },
	            _react2.default.createElement(
	              'button',
	              { onClick: this.onClickApply, className: _Filter2.default.applyButtonInSmall },
	              'APPLY'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Filter;
	}(_react.Component);
	
	Filter.propTypes = {
	  updateFilter: _propTypes2.default.func.isRequired,
	  toggleFilter: _propTypes2.default.func.isRequired,
	  filter: _propTypes2.default.func.isRequired,
	  renderFilterSchools: _propTypes2.default.bool.isRequired,
	  recommendedDivision: _propTypes2.default.string.isRequired,
	  profile: _propTypes2.default.shape.isRequired,
	  currentDivision: _propTypes2.default.string.isRequired,
	  overrideDivision: _propTypes2.default.string.isRequired
	};
	exports.default = Filter;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Filter = __webpack_require__(1138);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Filter2.default;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FooterContact = __webpack_require__(1142);
	
	var _FooterContact2 = _interopRequireDefault(_FooterContact);
	
	var _FooterNav = __webpack_require__(1144);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	var _MyrbLogo = __webpack_require__(458);
	
	var _MyrbLogo2 = _interopRequireDefault(_MyrbLogo);
	
	var _SocialIcons = __webpack_require__(1230);
	
	var _SocialIcons2 = _interopRequireDefault(_SocialIcons);
	
	var _Footer = __webpack_require__(1490);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _Footer2.default.footerContainer) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Footer2.default.footerInBigScreen) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _Footer2.default.footerLogo) },
	        _react2.default.createElement(_MyrbLogo2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _Footer2.default.footerNav) },
	        _react2.default.createElement(_FooterNav2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s6', _Footer2.default.footerContact) },
	        _react2.default.createElement(_FooterContact2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('row', _Footer2.default.footerInSmallScreen) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row') },
	        _react2.default.createElement(_FooterContact2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Footer2.default.footerBorderInSmall) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s6') },
	          _react2.default.createElement(_MyrbLogo2.default, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s6') },
	          _react2.default.createElement(_FooterNav2.default, null)
	        )
	      )
	    ),
	    _react2.default.createElement(_SocialIcons2.default, null)
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = Footer;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _button = __webpack_require__(31);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _SendGrid = __webpack_require__(465);
	
	var _SendGrid2 = _interopRequireDefault(_SendGrid);
	
	var _FooterContact = __webpack_require__(1491);
	
	var _FooterContact2 = _interopRequireDefault(_FooterContact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to use input from react-toolbox library
	// to validate and set default props  coming to this component
	// regular expressions to validate user input
	
	
	// to import local scss fle
	
	
	var modalStyle = {
	  overlay: {
	    backgroundColor: 'rgba(0, 0, 0, 0.75)'
	  },
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var FooterContact = function (_Component) {
	  _inherits(FooterContact, _Component);
	
	  function FooterContact(props) {
	    _classCallCheck(this, FooterContact);
	
	    var _this = _possibleConstructorReturn(this, (FooterContact.__proto__ || Object.getPrototypeOf(FooterContact)).call(this, props));
	
	    _this.state = {
	      value: '',
	      firstName: '',
	      lastName: '',
	      email: '',
	      message: '',
	      invalidFirstName: false,
	      invalidLastName: false,
	      invalidEmail: false,
	      invalidMessage: false
	    };
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleChangeFocus = _this.handleChangeFocus.bind(_this);
	    _this.handleTextAreaChange = _this.handleTextAreaChange.bind(_this);
	    _this.sendMail = _this.sendMail.bind(_this);
	    return _this;
	  }
	
	  _createClass(FooterContact, [{
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	    }
	  }, {
	    key: 'handleChangeFocus',
	    value: function handleChangeFocus(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, false)));
	    }
	  }, {
	    key: 'handleTextAreaChange',
	    value: function handleTextAreaChange(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value.target.value)));
	    }
	  }, {
	    key: 'sendMail',
	    value: function sendMail() {
	      var _state = this.state,
	          firstName = _state.firstName,
	          lastName = _state.lastName,
	          email = _state.email,
	          message = _state.message;
	
	      var updated = {};
	      var validFirstName = false;
	      var validLastName = false;
	      var validEmail = false;
	      var validMessage = false;
	
	      var enteredName = _Regularexpression.regExForName.test(firstName);
	      if (firstName !== '' && enteredName) {
	        validFirstName = true;
	      } else {
	        updated.invalidFirstName = true;
	      }
	
	      var enteredLastName = _Regularexpression.regExForName.test(lastName);
	      if (lastName === '') {
	        validLastName = true;
	      } else if (enteredLastName) {
	        updated.invalidLastName = false;
	        validLastName = true;
	      } else {
	        updated.invalidLastName = true;
	      }
	
	      var enteredEmail = _Regularexpression.regExForEmail.test(email);
	      if (email !== '' && enteredEmail) {
	        validEmail = true;
	      } else {
	        updated.invalidEmail = true;
	      }
	
	      if (message !== '') {
	        validMessage = true;
	      } else {
	        updated.invalidMessage = true;
	      }
	
	      if (validFirstName && validLastName && validEmail && validMessage) {
	        var payload = {};
	        payload = Object.assign(payload, {
	          firstname: this.state.firstName,
	          lastname: this.state.lastName,
	          email: this.state.email,
	          message: this.state.message
	        });
	        this.setState({ firstName: '', lastName: '', email: '', message: '' });
	        this.props.sendContactForm(payload);
	        this.onOpenModal();
	      } else {
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          invalidFirstName = _state2.invalidFirstName,
	          invalidLastName = _state2.invalidLastName,
	          invalidEmail = _state2.invalidEmail,
	          invalidMessage = _state2.invalidMessage,
	          open = _state2.open;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _FooterContact2.default.contactContainer) },
	        _react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: open, onRequestClose: this.onCloseModal },
	          'We will get back to you soon. Keep Exploring!',
	          _react2.default.createElement(
	            'button',
	            { className: _FooterContact2.default.okbuttonModal, onClick: this.onCloseModal },
	            'OK'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: (0, _classnames2.default)('col s12', _FooterContact2.default.text) },
	          'Fill out this form to contact us if you have any further questions'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _FooterContact2.default.fullWidth) },
	          _react2.default.createElement(
	            'div',
	            { className: invalidFirstName === false ? (0, _classnames2.default)('col s6', _FooterContact2.default.firstName) : (0, _classnames2.default)('col s6', _FooterContact2.default.firstNameOnError) },
	            _react2.default.createElement(_input2.default, {
	              value: this.state.firstName,
	              type: 'text',
	              placeholder: 'FIRST NAME',
	              onChange: function onChange(val) {
	                return _this2.handleChange('firstName', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.handleChangeFocus('invalidFirstName');
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: invalidLastName === false ? (0, _classnames2.default)('col s6', _FooterContact2.default.lastName) : (0, _classnames2.default)('col s6', _FooterContact2.default.lastNameOnError) },
	            _react2.default.createElement(_input2.default, {
	              value: this.state.lastName,
	              type: 'text', placeholder: 'LAST NAME',
	              onChange: function onChange(val) {
	                return _this2.handleChange('lastName', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.handleChangeFocus('invalidLastName');
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: invalidEmail === false ? (0, _classnames2.default)('col s12', _FooterContact2.default.emailField) : (0, _classnames2.default)('col s12', _FooterContact2.default.emailFieldOnError) },
	          _react2.default.createElement(_input2.default, {
	            value: this.state.email,
	            type: 'Email', placeholder: 'ENTER EMAIL',
	            onChange: function onChange(val) {
	              return _this2.handleChange('email', val);
	            },
	            onFocus: function onFocus() {
	              return _this2.handleChangeFocus('invalidEmail');
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _FooterContact2.default.fullWidth) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _FooterContact2.default.textareaContainer) },
	            _react2.default.createElement('textarea', {
	              value: this.state.message,
	              className: invalidMessage === false ? _FooterContact2.default.textarea : _FooterContact2.default.textareaOnError,
	              placeholder: 'MESSAGE',
	              onChange: function onChange(val) {
	                return _this2.handleTextAreaChange('message', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.handleChangeFocus('invalidMessage');
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _FooterContact2.default.fullWidth) },
	          _react2.default.createElement(_button.Button, { label: 'SUBMIT', className: _FooterContact2.default.submitButton, onClick: this.sendMail, raised: true })
	        )
	      );
	    }
	  }]);
	
	  return FooterContact;
	}(_react.Component);
	
	FooterContact.propTypes = {
	  sendContactForm: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _SendGrid2.default)(FooterContact);

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FooterContact = __webpack_require__(1141);
	
	var _FooterContact2 = _interopRequireDefault(_FooterContact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FooterContact2.default;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _FooterNav = __webpack_require__(1492);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to use global class name eg. classes from grid.css in public folder
	var FooterNav = function FooterNav() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _FooterNav2.default.navContainer) },
	    _react2.default.createElement(
	      'div',
	      { className: _FooterNav2.default.buttonContainer },
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/' },
	        _react2.default.createElement(
	          'button',
	          null,
	          'HOME'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/about' },
	        _react2.default.createElement(
	          'button',
	          null,
	          'ABOUT'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/sports' },
	        _react2.default.createElement(
	          'button',
	          null,
	          'SPORT'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/pricing' },
	        _react2.default.createElement(
	          'button',
	          null,
	          'PRICING'
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/contact' },
	        _react2.default.createElement(
	          'button',
	          null,
	          'CONTACT'
	        ),
	        _react2.default.createElement('br', null)
	      )
	    )
	  );
	}; //  to change path from inside or to alter react-router-dom path
	exports.default = FooterNav;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FooterNav = __webpack_require__(1143);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FooterNav2.default;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _progress_bar = __webpack_require__(253);
	
	var _progress_bar2 = _interopRequireDefault(_progress_bar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FullScreenLoader = function (_Component) {
	  _inherits(FullScreenLoader, _Component);
	
	  function FullScreenLoader(props) {
	    _classCallCheck(this, FullScreenLoader);
	
	    var _this = _possibleConstructorReturn(this, (FullScreenLoader.__proto__ || Object.getPrototypeOf(FullScreenLoader)).call(this, props));
	
	    _this.state = {
	      open: true,
	      title: '',
	      url: '',
	      showCloseIcon: false
	    };
	    return _this;
	  }
	
	  _createClass(FullScreenLoader, [{
	    key: 'render',
	    value: function render() {
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)'
	        },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          transform: 'translate(-50%, -50%)',
	          background: 'none',
	          border: 'none'
	        }
	      };
	      var _state = this.state,
	          open = _state.open,
	          showCloseIcon = _state.showCloseIcon;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            style: modalStyle,
	            showCloseIcon: showCloseIcon, isOpen: open
	          },
	          _react2.default.createElement(_progress_bar2.default, { type: 'circular', mode: 'indeterminate' })
	        )
	      );
	    }
	  }]);
	
	  return FullScreenLoader;
	}(_react.Component);
	
	exports.default = FullScreenLoader;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Banner = __webpack_require__(446);
	
	var _Banner2 = __webpack_require__(193);
	
	var _FullScreenVideo = __webpack_require__(1493);
	
	var _FullScreenVideo2 = _interopRequireDefault(_FullScreenVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	var FullScreenVideo = function (_Component) {
	  _inherits(FullScreenVideo, _Component);
	
	  function FullScreenVideo(props) {
	    _classCallCheck(this, FullScreenVideo);
	
	    var _this = _possibleConstructorReturn(this, (FullScreenVideo.__proto__ || Object.getPrototypeOf(FullScreenVideo)).call(this, props));
	
	    _this.state = {};
	    _this.toggleVideo = _this.toggleVideo.bind(_this);
	    return _this;
	  }
	
	  _createClass(FullScreenVideo, [{
	    key: 'toggleVideo',
	    value: function toggleVideo() {
	      this.props.closeVideo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _FullScreenVideo2.default.videoContainer) },
	        _react2.default.createElement(
	          'video',
	          { autoPlay: true, controls: true },
	          _react2.default.createElement('source', { src: 'https://media.dev.myrecruitboard.com/Images/bigVideo.mp4', type: 'video/mp4' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: this.toggleVideo, className: _FullScreenVideo2.default.closeButton },
	          'X'
	        )
	      );
	    }
	  }]);
	
	  return FullScreenVideo;
	}(_react.Component);
	
	FullScreenVideo.propTypes = {
	  closeVideo: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(_Banner2.bannerSelector, {
	  closeVideo: _Banner.closeVideo
	})(FullScreenVideo);

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FullScreenVideo = __webpack_require__(1146);
	
	var _FullScreenVideo2 = _interopRequireDefault(_FullScreenVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FullScreenVideo2.default;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PersonalInfo = __webpack_require__(1179);
	
	var _PersonalInfo2 = _interopRequireDefault(_PersonalInfo);
	
	var _ParentInfo = __webpack_require__(1174);
	
	var _ParentInfo2 = _interopRequireDefault(_ParentInfo);
	
	var _SportsBoard = __webpack_require__(1232);
	
	var _SportsBoard2 = _interopRequireDefault(_SportsBoard);
	
	var _reactStepperHorizontal = __webpack_require__(368);
	
	var _reactStepperHorizontal2 = _interopRequireDefault(_reactStepperHorizontal);
	
	var _AcademicBoard = __webpack_require__(1081);
	
	var _AcademicBoard2 = _interopRequireDefault(_AcademicBoard);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _actions = __webpack_require__(281);
	
	var _redux = __webpack_require__(457);
	
	var _GetUserDetails = __webpack_require__(1494);
	
	var _GetUserDetails2 = _interopRequireDefault(_GetUserDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	// to use conditional rendering based on values that is provided to component
	// to show loder on screen whenever there is a api call or operations in component
	
	// to import local scss fle
	
	
	var GetUserDetails = function (_Component) {
	  _inherits(GetUserDetails, _Component);
	
	  _createClass(GetUserDetails, null, [{
	    key: 'deriveState',
	    value: function deriveState(value) {
	      var state = { basicInfo: false,
	        sportsBoard: false,
	        academicBoard: false,
	        parentFirstStep: false,
	        parentSecondStep: false,
	        parentThirdStep: false,
	        parentLastStep: false
	      };
	      if (value === 'personalInfo') {
	        state.basicInfo = true;
	      } else if (value === 'sportsBoard') {
	        state.sportsBoard = true;
	      } else if (value === 'academicBoard') {
	        state.academicBoard = true;
	      } else if (value === 'parentFirstStep') {
	        state.parentFirstStep = true;
	      } else if (value === 'parentSecondStep') {
	        state.parentSecondStep = true;
	      } else if (value === 'parentThirdStep') {
	        state.parentThirdStep = true;
	      } else {
	        state.parentLastStep = true;
	      }
	      return state;
	    }
	  }]);
	
	  function GetUserDetails(props) {
	    _classCallCheck(this, GetUserDetails);
	
	    var _this = _possibleConstructorReturn(this, (GetUserDetails.__proto__ || Object.getPrototypeOf(GetUserDetails)).call(this, props));
	
	    _this.state = {
	      basicInfo: true,
	      sportsBoard: false,
	      academicBoard: false,
	      showCrossButton: false,
	      parentFirstStep: true,
	      parentSecondStep: false,
	      parentThirdStep: false,
	      parentLastStep: false,
	      steps: [{
	        onClick: function onClick(e) {
	          _this.setState({
	            basicInfo: true,
	            sportsBoard: false,
	            academicBoard: false,
	            currentStep: 0
	          });
	          e.preventDefault();
	        } }, {
	        onClick: function onClick(e) {
	          _this.setState({
	            basicInfo: false,
	            sportsBoard: true,
	            academicBoard: false,
	            currentStep: 1
	          });
	          e.preventDefault();
	        } }, {
	        onClick: function onClick(e) {
	          _this.setState({
	            basicInfo: false,
	            sportsBoard: false,
	            academicBoard: true,
	            currentStep: 2
	          });
	          e.preventDefault();
	        } }],
	      parentSteps: [{
	        onClick: function onClick(e) {
	          _this.setState({
	            parentFirstStep: true,
	            parentSecondStep: false,
	            parentThirdStep: false,
	            parentLastStep: false,
	            currentStep: 0
	          });
	          e.preventDefault();
	        } }, {
	        onClick: function onClick(e) {
	          _this.setState({
	            parentFirstStep: false,
	            parentSecondStep: true,
	            parentThirdStep: false,
	            parentLastStep: false,
	            currentStep: 1
	          });
	          e.preventDefault();
	        } }, {
	        onClick: function onClick(e) {
	          _this.setState({
	            parentFirstStep: false,
	            parentSecondStep: false,
	            parentThirdStep: true,
	            parentLastStep: false,
	            currentStep: 2
	          });
	          e.preventDefault();
	        } }, {
	        onClick: function onClick(e) {
	          _this.setState({
	            parentFirstStep: false,
	            parentSecondStep: false,
	            parentThirdStep: false,
	            parentLastStep: true,
	            currentStep: 3
	          });
	          e.preventDefault();
	        } }],
	      currentStep: 0,
	      profile: 'PENDING'
	    };
	    _this.next = _this.next.bind(_this);
	    _this.save = _this.save.bind(_this);
	    _this.tooglePreference = _this.tooglePreference.bind(_this);
	    return _this;
	  }
	
	  _createClass(GetUserDetails, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.saved && this.props.saved !== nextProps.saved) {
	        this.props.history.push('/view/athlete');
	      } else if (this.props.attributes !== nextProps.attributes) {
	        var profile = nextProps.attributes.get('profile');
	
	        if (profile !== 'PENDING') {
	          this.setState({ profile: profile });
	          this.setState({ showCrossButton: true });
	          this.props.getSAProfile(profile);
	        }
	      }
	    }
	  }, {
	    key: 'tooglePreference',
	    value: function tooglePreference(value) {
	      this.setState({ currentStep: this.state.currentStep - 1 });
	      this.setState(Object.assign({}, GetUserDetails.deriveState(value)));
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'next',
	    value: function next(to, state) {
	      window.scrollTo(0, 0);
	      this.setState({ currentStep: this.state.currentStep + 1 });
	      this.setState(Object.assign({}, GetUserDetails.deriveState(to), state));
	    }
	  }, {
	    key: 'save',
	    value: function save(newState) {
	      var _this2 = this;
	
	      this.setState(Object.assign({}, newState), function () {
	        var s = _this2.state;
	        var payload = _this2.props.profile.toJS();
	        var city = s.city,
	            state = s.state,
	            school = s.school,
	            height = s.height,
	            weight = s.weight,
	            year_of_graduation = s.year_of_graduation,
	            gpa = s.gpa,
	            sat = s.sat,
	            act = s.act,
	            sportName = s.sportName,
	            t40 = s.t40,
	            bench = s.bench,
	            squats = s.squats,
	            firstName = s.firstName,
	            lastName = s.lastName,
	            primary_offensive_position_pref = s.primary_offensive_position_pref,
	            primary_defensive_position_pref = s.primary_defensive_position_pref,
	            instagram = s.instagram,
	            twitter = s.twitter,
	            secondary_offensive_position_pref = s.secondary_offensive_position_pref,
	            mobile = s.mobile,
	            secondary_defensive_position_pref = s.secondary_defensive_position_pref,
	            special_teams = s.special_teams,
	            hbcu = s.hbcu;
	
	        var academic = { year_of_graduation: year_of_graduation, gpa: gpa, hbcu: hbcu };
	        if (sat !== '') {
	          academic['sat'] = sat; //eslint-disable-line
	        }
	        if (act !== '') {
	          academic['act'] = act; //eslint-disable-line
	        }
	
	        var sports = {};
	        if (_this2.state.profile === 'PENDING') {
	          sports = { sportName: sportName,
	            t40: t40,
	            bench: bench,
	            squats: squats };
	          if (primary_offensive_position_pref !== '') {
	            //eslint-disable-line
	            sports['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
	          }
	          if (primary_defensive_position_pref !== '') {
	            //eslint-disable-line
	            sports['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
	          }
	          if (secondary_defensive_position_pref !== '') {
	            //eslint-disable-line
	            sports['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref !== '') {
	            //eslint-disable-line
	            sports['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
	          }
	          if (special_teams !== '') {
	            //eslint-disable-line
	            sports['special_teams'] = special_teams; //eslint-disable-line
	          }
	        } else {
	          sports[sportName] = { t40: t40, bench: bench, squats: squats };
	          if (primary_offensive_position_pref !== '') {
	            //eslint-disable-line
	            sports[sportName] = primary_offensive_position_pref; //eslint-disable-line
	          }
	          if (primary_defensive_position_pref !== '') {
	            //eslint-disable-line
	            sports[sportName] = primary_defensive_position_pref; //eslint-disable-line
	          }
	          if (secondary_defensive_position_pref !== '') {
	            //eslint-disable-line
	            sports[sportName] = secondary_defensive_position_pref; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref !== '') {
	            //eslint-disable-line
	            sports[sportName] = secondary_offensive_position_pref; //eslint-disable-line
	          }
	          if (special_teams !== '') {
	            //eslint-disable-line
	            sports[sportName] = special_teams; //eslint-disable-line
	          }
	        }
	        var fullname = firstName + ' ' + lastName;
	        payload = Object.assign(payload, {
	          city: city,
	          sa_state: state,
	          school: school,
	          height: height,
	          weight: weight,
	          academic: academic,
	          sports: sports,
	          sa_mobile: mobile,
	          fullname: fullname
	        });
	        if (instagram) {
	          var instagramUrl = '';
	          if (instagram.startsWith('https')) {
	            instagramUrl = instagram;
	          } else {
	            instagramUrl = 'https://instagram.com/' + instagram;
	          }
	          payload['sa_instagram'] = instagramUrl; //eslint-disable-line
	        }
	        if (twitter) {
	          var twitterUrl = '';
	          if (twitter.startsWith('https')) {
	            twitterUrl = twitter;
	          } else {
	            twitterUrl = 'https://twitter.com/' + twitter;
	          }
	
	          payload['sa_twitter'] = twitterUrl; //eslint-disable-line
	        }
	        _this2.props.saveSAProfile(payload, _this2.state.profile);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var renderLoader = (0, _renderIf2.default)(this.props.editRequested);
	      var renderItForAthlete = (0, _renderIf2.default)(this.props.usedFor === 'athlete');
	      var renderItForParent = (0, _renderIf2.default)(this.props.usedFor === 'parent');
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _GetUserDetails2.default.getUserDetailsContainer) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderItForAthlete(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12') },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.tabsContainer) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.tabsHeader) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Step ',
	                this.state.currentStep + 1,
	                ' of 3'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.tabsButtonsContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: _GetUserDetails2.default.maxWidth },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_reactStepperHorizontal2.default, {
	                    steps: this.state.steps,
	                    activeColor: '#FFF',
	                    circleFontColor: '#FFF',
	                    defaultTitleColor: '#EBEBEB',
	                    activeTitleColor: '#FFF',
	                    completeBarColor: '#FFF',
	                    activeStep: this.state.currentStep
	                  }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.texts) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s4', _GetUserDetails2.default.textBelow) },
	                      'Personal Info'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s4', _GetUserDetails2.default.textBelow) },
	                      'Sports Board'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s4', _GetUserDetails2.default.textBelow) },
	                      'Academic Board'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.getInfoBox) },
	            _react2.default.createElement(_PersonalInfo2.default, Object.assign({}, this.props, { next: function next(state) {
	                return _this3.next('sportsBoard', state);
	              }, show: this.state.basicInfo })),
	            _react2.default.createElement(_SportsBoard2.default, Object.assign({}, this.props, { next: function next(state) {
	                return _this3.next('academicBoard', state);
	              }, back: function back() {
	                return _this3.tooglePreference('personalInfo');
	              }, show: this.state.sportsBoard })),
	            _react2.default.createElement(_AcademicBoard2.default, Object.assign({}, this.props, { back: function back() {
	                return _this3.tooglePreference('sportsBoard');
	              }, save: function save(state) {
	                return _this3.save(state);
	              }, show: this.state.academicBoard }))
	          )
	        )),
	        renderItForParent(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12') },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.tabsContainer) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.tabsHeader) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Step ',
	                this.state.currentStep + 1,
	                ' of 3'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.tabsButtonsContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: _GetUserDetails2.default.maxWidth },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_reactStepperHorizontal2.default, {
	                    steps: this.state.parentSteps,
	                    activeColor: '#FFF',
	                    circleFontColor: '#FFF',
	                    defaultTitleColor: '#EBEBEB',
	                    activeTitleColor: '#FFF',
	                    activeStep: this.state.currentStep
	                  }),
	                  _react2.default.createElement(
	                    'span',
	                    { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.texts) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s3', _GetUserDetails2.default.textBelow) },
	                      'PersonalInfo'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s3', _GetUserDetails2.default.textBelow) },
	                      'StudentInfo'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s3', _GetUserDetails2.default.textBelow) },
	                      'Sports Board'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s3', _GetUserDetails2.default.textBelow) },
	                      'Academic Board'
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _GetUserDetails2.default.getInfoBox) },
	            _react2.default.createElement(_ParentInfo2.default, Object.assign({}, this.props, { next: function next(state) {
	                return _this3.next('parentSecondStep', state);
	              }, show: this.state.parentFirstStep })),
	            _react2.default.createElement(_PersonalInfo2.default, Object.assign({}, this.props, { next: function next(state) {
	                return _this3.next('parentThirdStep', state);
	              }, show: this.state.parentSecondStep })),
	            _react2.default.createElement(_SportsBoard2.default, Object.assign({}, this.props, { next: function next(state) {
	                return _this3.next('', state);
	              }, back: function back() {
	                return _this3.tooglePreference('personalInfo');
	              }, show: this.state.parentThirdStep })),
	            _react2.default.createElement(_AcademicBoard2.default, Object.assign({}, this.props, { back: function back() {
	                return _this3.tooglePreference('sportsBoard');
	              }, save: function save(state) {
	                return _this3.save(state);
	              }, show: this.state.parentLastStep }))
	          )
	        ))
	      );
	    }
	  }]);
	
	  return GetUserDetails;
	}(_react.Component);
	
	GetUserDetails.propTypes = {
	  saved: _propTypes2.default.bool,
	  history: _propTypes2.default.shape(),
	  saveSAProfile: _propTypes2.default.func,
	  getSAProfile: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape(),
	  editRequested: _propTypes2.default.bool,
	  profile: _propTypes2.default.shape(),
	  usedFor: _propTypes2.default.string
	};
	GetUserDetails.defaultProps = {
	  saved: false,
	  history: { push: function push() {} },
	  saveSAProfile: function saveSAProfile() {},
	  getSAProfile: function getSAProfile() {},
	  attributes: {},
	  profile: {},
	  editRequested: false,
	  usedFor: ''
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { saveSAProfile: _actions.saveSAProfile, getSAProfile: _actions.getSAProfile, searchSchools: _actions.searchSchools })(GetUserDetails);

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPortalTooltip = __webpack_require__(240);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _CoachPopup = __webpack_require__(448);
	
	var _CoachPopup2 = _interopRequireDefault(_CoachPopup);
	
	var _Actionable = __webpack_require__(1495);
	
	var _Actionable2 = _interopRequireDefault(_Actionable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Actionable = function (_Component) {
	  _inherits(Actionable, _Component);
	
	  function Actionable(props) {
	    _classCallCheck(this, Actionable);
	
	    var _this = _possibleConstructorReturn(this, (Actionable.__proto__ || Object.getPrototypeOf(Actionable)).call(this, props));
	
	    _this.state = {
	      actionableToolTip: false,
	      bubbleToolTip: true,
	      requestCreatedBy: 'SA',
	      disableInviteToCamp: false,
	      disableFillQuestionaire: false,
	      disableAddedToWathcList: false,
	      disableIgnored: false,
	      disableNeedMoreFilms: false,
	      disableSendContactInfo: false,
	      showPopup: false,
	      text: ''
	    };
	    _this.showTooltip = _this.showTooltip.bind(_this);
	    _this.hideTooltip = _this.hideTooltip.bind(_this);
	    _this.addQuestionaire = _this.addQuestionaire.bind(_this);
	    _this.inviteToCamp = _this.inviteToCamp.bind(_this);
	    _this.needMoreFilms = _this.needMoreFilms.bind(_this);
	    _this.sendContactInfo = _this.sendContactInfo.bind(_this);
	    _this.addToWatchList = _this.addToWatchList.bind(_this);
	    _this.ignoredList = _this.ignoredList.bind(_this);
	    return _this;
	  }
	
	  _createClass(Actionable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var updated = {};
	      var convo = this.props.request.get('conversation');
	      var allConvo = convo.toIndexedSeq().toArray();
	      for (var i = 0; i < allConvo.length; i++) {
	        // eslint-disable-line
	        var temp = allConvo[i];
	        if (temp.get('action') === 'INVITE TO CAMP') {
	          updated.disableInviteToCamp = true;
	        }
	        if (temp.get('action') === 'FILL QUESTIONAIRE') {
	          updated.disableFillQuestionaire = true;
	        }
	        if (temp.get('action') === 'SA SENT CONTACT INFO') {
	          updated.disableSendContactInfo = true;
	        }
	        if (temp.get('action') === 'ADDED TO WATCHLIST') {
	          updated.disableAddedToWathcList = true;
	        }
	        if (temp.get('action') === 'NEED MORE FILMS') {
	          updated.disableNeedMoreFilms = true;
	        }
	        if (temp.get('action') === 'IGNORED') {
	          updated.disableIgnored = true;
	        }
	      }
	      this.setState(updated);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var updated = {};
	      var convo = nextProps.request.get('conversation');
	      var allConvo = convo.toIndexedSeq().toArray();
	      for (var i = 0; i < allConvo.length; i++) {
	        // eslint-disable-line
	        var temp = allConvo[i];
	        if (temp.get('action') === 'INVITE TO CAMP') {
	          updated.disableInviteToCamp = true;
	        }
	        if (temp.get('action') === 'FILL QUESTIONAIRE') {
	          updated.disableFillQuestionaire = true;
	        }
	        if (temp.get('action') === 'SA SENT CONTACT INFO') {
	          updated.disableSendContactInfo = true;
	        }
	        if (temp.get('action') === 'ADDED TO WATCHLIST') {
	          updated.disableaddedToWathcList = true;
	        }
	        if (temp.get('action') === 'NEED MORE FILMS') {
	          updated.disableNeedMoreFilms = true;
	        }
	        if (temp.get('action') === 'IGNORED') {
	          updated.disableIgnored = true;
	        }
	      }
	      // const lastItemInConversation = convo.last();
	      this.setState(updated);
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      this.setState({ actionableToolTip: true });
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      this.setState({ bubbleToolTip: false, actionableToolTip: false });
	    }
	  }, {
	    key: 'addQuestionaire',
	    value: function addQuestionaire(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'FILL QUESTIONAIRE', // let backend know if you change something here
	        link: this.props.profile.get('question_link'),
	        sa_email: email,
	        sa_name: name,
	        created_by: this.state.requestCreatedBy,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.setState({ showPopup: true, text: 'Hi Coach! We have notified student athlete to fill your college questionnaire.' });
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'inviteToCamp',
	    value: function inviteToCamp(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'INVITE TO CAMP',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'needMoreFilms',
	    value: function needMoreFilms(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'NEED MORE FILMS',
	        sa_email: email,
	        created_by: this.state.requestCreatedBy,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'addToWatchList',
	    value: function addToWatchList(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'ADDED TO WATCHLIST',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'ignoredList',
	    value: function ignoredList(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'IGNORED',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'sendContactInfo',
	    value: function sendContactInfo(requestId, email, name, mobile) {
	      var conversation = {
	        id: requestId,
	        action: 'SA SENT CONTACT INFO',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        sa_mobile: mobile,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.setState({ showPopup: true, text: 'Hi Coach! We mailed you student athlete contact details.' });
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.profile;
	      var request = this.props.request;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.showPopup ? _react2.default.createElement(_CoachPopup2.default, { text: this.state.text }) : '',
	        _react2.default.createElement(
	          'button',
	          {
	            className: _Actionable2.default.bubbleButton,
	            id: 'action',
	            onClick: this.showTooltip,
	            onMouseEnter: this.showTooltip,
	            onMouseLeave: this.hideTooltip
	          },
	          'CONTACT PLAYER'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactPortalTooltip2.default,
	            { active: this.state.actionableToolTip, position: 'bottom', arrow: 'center', parent: '#action' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  onClick: function onClick() {
	                    return _this2.addQuestionaire(request.get('id'), item.get('sa_email'), item.get('sa_name'));
	                  },
	                  className: _Actionable2.default.options,
	                  disabled: this.state.disableFillQuestionaire
	                },
	                'Send My Questionnaire'
	              ),
	              _react2.default.createElement(_Divider2.default, null),
	              _react2.default.createElement(
	                'button',
	                {
	                  onClick: function onClick() {
	                    return _this2.sendContactInfo(request.get('id'), item.get('sa_email'), item.get('fullname'), item.get('sa_mobile'));
	                  },
	                  className: _Actionable2.default.options,
	                  disabled: this.state.disableSendContactInfo
	                },
	                'Request Student Contact Information'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Actionable;
	}(_react.Component);
	
	Actionable.propTypes = {
	  updateConversation: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.shape().isRequired,
	  request: _propTypes2.default.shape().isRequired,
	  coachEmail: _propTypes2.default.string.isRequired
	};
	exports.default = Actionable;

/***/ },
/* 1150 */
[2530, 1149],
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Navbar = __webpack_require__(159);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Createtabs = __webpack_require__(194);
	
	var _Createtabs2 = _interopRequireDefault(_Createtabs);
	
	var _DashBoardHeader = __webpack_require__(1496);
	
	var _DashBoardHeader2 = _interopRequireDefault(_DashBoardHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var tabs = ['Student', 'Coach', 'College'];
	
	var DashBoardHeader = function (_Component) {
	  _inherits(DashBoardHeader, _Component);
	
	  function DashBoardHeader(props) {
	    _classCallCheck(this, DashBoardHeader);
	
	    var _this = _possibleConstructorReturn(this, (DashBoardHeader.__proto__ || Object.getPrototypeOf(DashBoardHeader)).call(this, props));
	
	    _this.state = {
	      headerOnDashboard: true
	    };
	    return _this;
	  }
	
	  _createClass(DashBoardHeader, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _DashBoardHeader2.default.container) },
	        _react2.default.createElement(_Navbar2.default, this.props),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _DashBoardHeader2.default.currentUrl) },
	          'Admin Panel'
	        ),
	        _react2.default.createElement(_Createtabs2.default, { index: this.props.tab, tabs: tabs, tabListener: this.props.tabListener })
	      );
	    }
	  }]);
	
	  return DashBoardHeader;
	}(_react.Component);
	
	DashBoardHeader.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired,
	  tab: _propTypes2.default.number.isRequired
	};
	exports.default = DashBoardHeader;

/***/ },
/* 1152 */
[2529, 1151],
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PostingInfo = __webpack_require__(460);
	
	var _PostingInfo2 = _interopRequireDefault(_PostingInfo);
	
	var _actionTypes = __webpack_require__(129);
	
	var action = _interopRequireWildcard(_actionTypes);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ListView = __webpack_require__(1497);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	var ListView = function ListView(props) {
	  var clickToRequest = function clickToRequest() {
	    var subscribed = props.subscribed,
	        onTrial = props.onTrial;
	
	    var contactedCountMap = props.profile.get('contactedCount');
	    var contactedCount = void 0;
	    if (contactedCountMap) {
	      contactedCount = contactedCountMap.toJS();
	    }
	    var counter = contactedCount.count; // eslint-disable-line
	    // const undefinedCase = props.profile.get('contactedCount');
	    var difference = (0, _moment2.default)().diff(contactedCount.lastContacted, 'hours');
	    var req = {
	      from_profile_id: props.profileId,
	      posting_id: props.posting.get('id'),
	      request_type: 'INTEREST',
	      coach_name: props.posting.get('coach_name'),
	      college_name: props.posting.get('college_name'),
	      college_image: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png',
	      city: props.posting.get('city'),
	      division: props.posting.get('division'),
	      college_id: props.posting.get('college_id') ? props.posting.get('college_id') : 'college_id',
	      sa_name: props.fullname,
	      sa_state: _DropdownsValues.states[props.state],
	      sa_preference: props.position_pref,
	      sa_school: props.school,
	      sa_city: props.city,
	      sa_image: props.sa_image,
	      sa_email: props.sa_email,
	      year_of_graduation: props.year_of_graduation,
	      team_page_link: props.posting.get('team_page_link'),
	      question_link: props.posting.get('question_link'),
	      sa_twitter: props.profile.get('sa_twitter') !== undefined && props.profile.get('sa_twitter') !== null ? props.profile.get('sa_twitter').substring('https://twitter.com/'.length) : '',
	      sa_height: props.profile.get('height'),
	      sa_weight: props.profile.get('weight'),
	      sa_t40: props.t40,
	      request_views: props.requestViewedCount
	    };
	    var maxCount = 1;
	    if (subscribed || onTrial) {
	      maxCount = 10;
	    }
	    if (counter < maxCount || contactedCountMap === undefined) {
	      var payload = {
	        student_profile_id: props.profileId,
	        college_id: props.posting.get('college_id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else if (counter >= maxCount && difference >= 23) {
	      var _payload = {
	        student_profile_id: props.profileId,
	        college_id: props.posting.get('college_id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(_payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else {
	      props.showCounterScreen();
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _ListView2.default.container) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _ListView2.default.listInBig) },
	      _react2.default.createElement(
	        'span',
	        { className: _ListView2.default.absoluteHeart },
	        _react2.default.createElement(_PostingInfo2.default, props)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s5', _ListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s2') },
	          _react2.default.createElement('img', { className: _ListView2.default.colgeIcon, src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s10', _ListView2.default.textContainer) },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.collegeName },
	              _react2.default.createElement(
	                'a',
	                { href: props.posting.get('team_page_link'), target: '_blank' },
	                props.posting.get('college_name')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.lightText },
	              props.posting.get('city')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.lightText },
	              props.posting.get('state')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _ListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _ListView2.default.textContainer) },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.positionHeader },
	              props.posting.get('posting_title')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s1', _ListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _ListView2.default.textContainer) },
	          _react2.default.createElement('span', null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _ListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: _ListView2.default.buttonContainer },
	          _react2.default.createElement(
	            'span',
	            null,
	            props.interested ? _react2.default.createElement(
	              'button',
	              { className: _ListView2.default.interested },
	              'INTERESTED'
	            ) : _react2.default.createElement(
	              'button',
	              { className: _ListView2.default.respond, onClick: clickToRequest },
	              'CONTACT COACH'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _ListView2.default.listInSmall) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _ListView2.default.firstDiv) },
	        _react2.default.createElement('img', { className: _ListView2.default.colgeIcon, src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s9', _ListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _ListView2.default.textContainer) },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.collegeName },
	              _react2.default.createElement(
	                'a',
	                { href: props.posting.get('team_page_link'), target: '_blank' },
	                props.posting.get('college_name')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.lightText },
	              props.posting.get('city')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.lightText },
	              props.posting.get('state')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ListView2.default.positionHeader },
	              props.posting.get('posting_title')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _ListView2.default.absoluteHeart },
	          _react2.default.createElement(_PostingInfo2.default, props)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _ListView2.default.smallButtonContainer) },
	        _react2.default.createElement(
	          'span',
	          null,
	          props.interested ? _react2.default.createElement(
	            'button',
	            { className: _ListView2.default.interested },
	            'INTERESTED'
	          ) : _react2.default.createElement(
	            'button',
	            { className: _ListView2.default.respond, onClick: clickToRequest },
	            'CONTACT COACH'
	          )
	        )
	      )
	    )
	  );
	};
	{} /* eslint-disable */ // eslint-disable-line
	ListView.propTypes = {
	  posting: _propTypes2.default.shape().isRequired,
	  addToRequest: _propTypes2.default.func.isRequired,
	  addToList: _propTypes2.default.func.isRequired,
	  interested: _propTypes2.default.bool,
	  profileId: _propTypes2.default.string.isRequired,
	  fullname: _propTypes2.default.string.isRequired,
	  position_pref: _propTypes2.default.string.isRequired,
	  school: _propTypes2.default.string.isRequired,
	  city: _propTypes2.default.string.isRequired,
	  sa_image: _propTypes2.default.string.isRequired,
	  showSnackBar: _propTypes2.default.func.isRequired,
	  state: _propTypes2.default.string.isRequired,
	  sa_email: _propTypes2.default.string.isRequired,
	  footballTeamPage: _propTypes2.default.string.isRequired,
	  questionAireLink: _propTypes2.default.string.isRequired,
	  showCounterScreen: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.shape.isRequired,
	  year_of_graduation: _propTypes2.default.string.isRequired,
	  requestViewedCount: _propTypes2.default.number.isRequired,
	  t40: _propTypes2.default.string.isRequired
	};
	{/* eslint-enable */}
	ListView.defaultProps = {
	  interested: false
	};
	
	exports.default = ListView;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ListView = __webpack_require__(1153);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ListView2.default;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _drawer = __webpack_require__(373);
	
	var _drawer2 = _interopRequireDefault(_drawer);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(167);
	
	var _immutable = __webpack_require__(11);
	
	var _localStorage = __webpack_require__(56);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Drawer = __webpack_require__(1498);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  to change path from inside or to alter react-router-dom path
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	// use of immutablejs for various js operations to simplify our work
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var MenuDrawer = function (_React$Component) {
	  _inherits(MenuDrawer, _React$Component);
	
	  function MenuDrawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuDrawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuDrawer.__proto__ || Object.getPrototypeOf(MenuDrawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      profileIcon: ''
	    }, _this.handleSignOut = function () {
	      _this.props.logoutUser(_this.props.attributes.get('zoneinfo'));
	      _this.handleToggle();
	    }, _this.handleToggle = function () {
	      _this.setState({ active: !_this.state.active });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuDrawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var profileImage = (0, _localStorage.getItem)('profile_image');
	      this.setState({ profileIcon: profileImage });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$user = _props.user,
	          user = _props$user === undefined ? (0, _immutable.Map)() : _props$user,
	          attributes = _props.attributes;
	
	      var username = user.username;
	      var renderCoachItems = (0, _renderIf2.default)(attributes.get('zoneinfo') === 'COACH');
	      var renderAthleteItems = (0, _renderIf2.default)(attributes.get('zoneinfo') === 'STUDENT');
	      var renderLoggedOutLinks = (0, _renderIf2.default)(MenuDrawer.isEmpty(username));
	      var renderLoggedInLinks = (0, _renderIf2.default)((0, _ramda.not)(MenuDrawer.isEmpty(username)));
	      return _react2.default.createElement(
	        'div',
	        { className: _Drawer2.default.container },
	        _react2.default.createElement(
	          'button',
	          { className: _Drawer2.default.menuIcon, onClick: this.handleToggle },
	          _react2.default.createElement('img', { alt: 'menu', src: 'https://media.dev.myrecruitboard.com/Images/menu.png' })
	        ),
	        _react2.default.createElement(
	          _drawer2.default,
	          { active: this.state.active, className: (0, _classnames2.default)('row', _Drawer2.default.drawerContainer), type: 'right', onOverlayClick: this.handleToggle },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Drawer2.default.closeButton) },
	            _react2.default.createElement(
	              'button',
	              { onClick: this.handleToggle },
	              _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/whiteCross.png', alt: 'close' })
	            )
	          ),
	          renderLoggedInLinks(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12') },
	            renderCoachItems(_react2.default.createElement('img', {
	              id: 'text',
	              className: _Drawer2.default.dropdownIcon,
	              src: 'https://media.dev.myrecruitboard.com/Images/coachIcon.png',
	              alt: 'icon'
	            })),
	            renderAthleteItems(_react2.default.createElement('img', {
	              className: _Drawer2.default.dropdownIcon,
	              src: this.state.profileIcon !== '' ? 'https://s3.amazonaws.com/myrbimagesdev/' + this.state.profileIcon : 'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	              alt: 'icon'
	            })),
	            _react2.default.createElement(
	              'span',
	              { className: _Drawer2.default.userName },
	              attributes.get('name')
	            )
	          )),
	          renderLoggedInLinks(_react2.default.createElement(
	            'div',
	            null,
	            renderCoachItems(_react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: 'view/coach/dashboard' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'DASHBOARD'
	              )
	            )),
	            renderAthleteItems(_react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/dashboard' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'DASHBOARD'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/view/athlete' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'PROFILE'
	                )
	              )
	            )),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/settings' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'SETTINGS'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' },
	              _react2.default.createElement(
	                'button',
	                { onClick: this.handleSignOut },
	                'SIGNOUT'
	              )
	            )
	          )),
	          renderLoggedOutLinks(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Drawer2.default.buttonContainer) },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'HOME'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/about' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'ABOUT US'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/terms_and_use' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'TERMS OF USE'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/contact' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'CONTACT'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/pricing' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'PRICING'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/sports' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'WHY'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s6', _Drawer2.default.loginButtonContainer) },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/login' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'SIGN IN'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s6', _Drawer2.default.joinUsButtonContainer) },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/register' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'JOIN US'
	                )
	              )
	            )
	          ))
	        )
	      );
	    }
	  }], [{
	    key: 'isEmpty',
	    value: function isEmpty(val) {
	      if (val) {
	        return false;
	      }
	      return true;
	    }
	  }]);
	
	  return MenuDrawer;
	}(_react2.default.Component);
	
	MenuDrawer.propTypes = {
	  user: _propTypes2.default.shape(),
	  logoutUser: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape()
	};
	MenuDrawer.defaultProps = {
	  user: {},
	  logoutUser: function logoutUser() {},
	  attributes: {}
	};
	exports.default = MenuDrawer;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Drawer = __webpack_require__(1155);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MyrbLogo = __webpack_require__(458);
	
	var _MyrbLogo2 = _interopRequireDefault(_MyrbLogo);
	
	var _MiniFooter = __webpack_require__(1499);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to use global class name eg. classes from grid.css in public folder
	var MiniFooter = function MiniFooter() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _MiniFooter2.default.container) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _MiniFooter2.default.miniFooterInBig) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m4', _MiniFooter2.default.logoContainer) },
	        _react2.default.createElement(_MyrbLogo2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m8', _MiniFooter2.default.icons) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _MiniFooter2.default.socialIcons) },
	          _react2.default.createElement(
	            'span',
	            { className: _MiniFooter2.default.connectWithUs },
	            'Connect with us'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.facebook.com/MyRecruitboard/', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/facebook.png', alt: 'web_feed' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/myrecruitboard?lang=en', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/twitter.png', alt: 'web_feed' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.instagram.com/explore/tags/myrecruitboard/', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/instagram.png', alt: 'web_feed' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.snapchat.com/MyRecruitBoard', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/snapchat.png', alt: 'web_feed' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _MiniFooter2.default.copyRight) },
	          'Copyright \xA9 2022. All Rights Reserved'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m4', _MiniFooter2.default.miniFooterInSmall) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m8', _MiniFooter2.default.lineBelowSocialIcons) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _MiniFooter2.default.socialIcons) },
	          _react2.default.createElement(
	            'span',
	            { className: _MiniFooter2.default.connectWithUs },
	            'Connect with us'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.facebook.com/MyRecruitboard/', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/facebook.png', alt: 'web_feed' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://twitter.com/myrecruitboard?lang=en', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/twitter.png', alt: 'web_feed' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.instagram.com/explore/tags/myrecruitboard/', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/instagram.png', alt: 'web_feed' })
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.snapchat.com/MyRecruitBoard', target: 'blank' },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/snapchat.png', alt: 'web_feed' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m4', _MiniFooter2.default.logoPadding) },
	        _react2.default.createElement(_MyrbLogo2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _MiniFooter2.default.copyRight) },
	        'Copyright \xA9 2022. All Rights Reserved'
	      )
	    )
	  );
	};
	
	exports.default = MiniFooter;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCollapsible = __webpack_require__(741);
	
	var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _immutable = __webpack_require__(11);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _radio = __webpack_require__(104);
	
	var _ModifyParent = __webpack_require__(1500);
	
	var _ModifyParent2 = _interopRequireDefault(_ModifyParent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to use input from react-toolbox library
	// to display error messages on invalid user input
	// use of immutablejs for various js operations to simplify our work
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// to show loder on screen whenever there is a api call or operations in component
	// regular expressions to validate user input
	
	// to import local scss fle
	
	var ModifyParent = function (_Component) {
	  _inherits(ModifyParent, _Component);
	
	  function ModifyParent(props) {
	    _classCallCheck(this, ModifyParent);
	
	    var _this = _possibleConstructorReturn(this, (ModifyParent.__proto__ || Object.getPrototypeOf(ModifyParent)).call(this, props));
	
	    _this.state = {
	      value: '',
	      /* parent info fields */
	      parentGender: 'male',
	      parentFullNameErrorMessage: '',
	      parentEmailErrorMessage: '',
	      parentMobileNumberErrorMessage: '',
	      parentFullName: '',
	      parentEmail: '',
	      mobileNumber: '',
	      /* parent info fields */
	
	      /* student info fields */
	      studentGender: 'male',
	      studentFullName: '',
	      studentCity: '',
	      studentState: '',
	      studentFullNameErrorMessage: '',
	      studentEmailErrorMessage: '',
	      studentStateErrorMessage: '',
	      studentCityErrorMessage: '',
	      /* student info fields */
	
	      /* student sports info */
	      position_pref: '',
	      height: '',
	      weight: '',
	      sportName: 'FOOTBALL',
	      t40: '',
	      bench: '',
	      squats: '',
	      positions: '',
	      description: '',
	      heightErrorMessage: '',
	      weightErrorMessage: '',
	      mySport: 'FOOTBALL',
	      t40ErrorMessage: '',
	      squatsErrorMessage: '',
	      benchErrorMessage: '',
	      descriptionErrorMessage: '',
	      /* student sports info */
	
	      /* academic info */
	      school: '',
	      gpa: '',
	      act: '',
	      sat: '',
	      yearOfPassing: '',
	      schoolErrorMessage: '',
	      yearOfPassingErrorMessage: '',
	      gpaErrorMessage: '',
	      satErrorMessage: '',
	      actErrorMessage: '',
	      /* academic info */
	      parentCollapsible: true,
	      emailErrorMessage: '',
	      firstNameErrorMessage: ''
	    };
	    _this.validateInput = _this.validateInput.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ModifyParent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.attributes.size > 0) {
	        var profile = this.props.attributes.get('profile');
	        this.props.getSAProfile(profile);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((0, _immutable.is)(this.props.profile, nextProps.profile) && nextProps.saRequested) {
	        if (nextProps.attributes.size > 0) {
	          var profile = nextProps.attributes.get('profile');
	          this.props.getSAProfile(profile);
	        }
	      }
	      var newState = {};
	      if (nextProps.profile.size > 0) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        var academic = nextProps.profile.get('academic');
	        newState.studentFullName = nextProps.profile.get('fullname');
	        newState.studentGender = nextProps.profile.get('gender');
	        newState.studentState = nextProps.profile.get('sa_state');
	        newState.studentCity = nextProps.profile.get('city');
	        newState.height = nextProps.profile.get('height');
	        newState.weight = nextProps.profile.get('weight');
	        newState.sportName = keys[0];
	        newState.t40 = sport.get('t40');
	        newState.bench = sport.get('bench');
	        newState.squats = sport.get('squats');
	        newState.description = sport.get('description');
	        newState.position = sport.get('position_pref');
	        newState.school = nextProps.profile.get('school');
	        newState.yearOfPassing = academic.get('year_of_graduation');
	        newState.gpa = academic.get('gpa');
	        newState.sat = academic.get('sat');
	        newState.act = academic.get('act');
	      }
	      this.setState(Object.assign({}, newState));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	    }
	  }, {
	    key: 'removeErrorMessage',
	    value: function removeErrorMessage(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'validateInput',
	    value: function validateInput() {
	      var _this2 = this;
	
	      var _state = this.state,
	          parentFullName = _state.parentFullName,
	          studentFullName = _state.studentFullName,
	          studentCity = _state.studentCity,
	          studentState = _state.studentState;
	      /* validation personal info */
	
	      var parentValidFullName = false;
	      var updated = {};
	      /* validation for Full Name */
	      var enteredFullName = _Regularexpression.regExForName.test(parentFullName);
	      if (enteredFullName && parentFullName !== '') {
	        parentValidFullName = true;
	      } else {
	        updated.parentFullNameErrorMessage = 'Please enter a valid name.';
	      }
	      /* validation for Full Name */
	      /* validation for student info */
	      var validStudentFullName = false;
	      var validStudentCity = false;
	      var validStudentState = false;
	
	      /* validation for Full Name */
	      var enteredStudentFullName = _Regularexpression.regExForName.test(studentFullName);
	      if (enteredStudentFullName && studentFullName !== '') {
	        validStudentFullName = true;
	      } else {
	        updated.studentFullNameErrorMessage = 'Please enter a valid name.';
	      }
	      /* validation for Full Name */
	
	      /* validation for city */
	      var enteredStudentCity = _Regularexpression.regExForName.test(studentCity);
	      if (enteredStudentCity && studentCity !== '') {
	        validStudentCity = true;
	      } else {
	        updated.studentCityErrorMessage = 'Please enter a valid city.';
	      }
	      /* validation for city */
	
	      /* validation for state */
	      var enteredStudentState = _Regularexpression.regExForName.test(studentState);
	      if (enteredStudentState && studentState !== '') {
	        validStudentState = true;
	      } else {
	        updated.studentStateErrorMessage = 'Please enter a valid state.';
	      }
	      /* validation for student info */
	
	      /* validation for sports info */
	      /* Height Validation */
	      var validHeight = false;
	
	      if (this.state.height !== '') {
	        validHeight = true;
	      } else {
	        updated.heightErrorMessage = 'Enter valid height.';
	      }
	      /* Height Validation */
	
	      /* weight validation */
	      var validWeight = false;
	      if (this.state.weight !== '') {
	        validWeight = true;
	      } else {
	        updated.weightErrorMessage = 'Please add a valid weight.';
	      }
	      /* weight validation */
	
	      /* Preferred Position validation */
	      /* let validPosition = false;
	       if (this.state.position_pref !== '') {
	       validPosition = true;
	       } else {
	       updated.positionErrorMessage = 'Please select preferred position.';
	       } */
	      /* Preferred Position validation */
	
	      /* description validation */
	      var validDescription = false;
	      if (this.state.description !== '') {
	        validDescription = true;
	      } else {
	        updated.descriptionErrorMessage = 'Please add description.';
	      }
	      /* description validation */
	
	      /* T40 validation */
	      var validT40 = false;
	      if (this.state.t40 !== '') {
	        validT40 = true;
	      } else {
	        updated.t40ErrorMessage = 'Please add a valid T40.';
	      }
	      /* T40 validation */
	
	      /* squats validation */
	      var validSquats = false;
	      if (this.state.t40 !== '') {
	        validSquats = true;
	      } else {
	        updated.squatsErrorMessage = 'Please add a valid Squats.';
	      }
	      /* squats validation */
	
	      /* Bench validation */
	      var validBench = false;
	      if (this.state.t40 !== '') {
	        validBench = true;
	      } else {
	        updated.benchErrorMessage = 'Please add a valid Bench.';
	      }
	      /* squats validation */
	      /* validation for sports info */
	
	      /* validation for academic info */
	      var validSchool = false;
	      var enteredScool = _Regularexpression.regExForName.test(this.state.school);
	      if (enteredScool && this.state.school !== '') {
	        validSchool = true;
	      } else {
	        updated.schoolErrorMessage = 'Please select a school.';
	      }
	      /* school validation */
	
	      /* year of passing */
	      var validYearOfPassing = false;
	
	      if (this.state.yearOfPassing !== '') {
	        validYearOfPassing = true;
	      } else {
	        updated.yearOfPassingErrorMessage = 'Please add graduation year.';
	      }
	      /* year of passing */
	
	      /* Gpa validation */
	      var validGpa = false;
	      if (this.state.gpa !== '') {
	        validGpa = true;
	      } else {
	        updated.gpaErrorMessage = 'Gpa is not valid.';
	      }
	      /* Gpa validation */
	
	      /* Act validation */
	      var validAct = false;
	      if (this.state.act !== '') {
	        validAct = true;
	      } else {
	        updated.actErrorMessage = 'Act is not valid.';
	      }
	      /* Act validation */
	
	      /* Sat validation */
	      var validSat = false;
	      if (this.state.gpa !== '') {
	        validSat = true;
	      } else {
	        updated.satErrorMessage = 'Sat is not valid.';
	      }
	      /* Sat validation */
	      /* validation for academic info */
	      var _state2 = this.state,
	          yearOfPassing = _state2.yearOfPassing,
	          gpa = _state2.gpa,
	          sat = _state2.sat,
	          act = _state2.act,
	          sportName = _state2.sportName,
	          t40 = _state2.t40,
	          school = _state2.school,
	          height = _state2.height,
	          weight = _state2.weight,
	          bench = _state2.bench,
	          squats = _state2.squats,
	          position = _state2.position,
	          description = _state2.description,
	          studentGender = _state2.studentGender;
	
	      var academic = { yearOfPassing: yearOfPassing,
	        gpa: gpa,
	        sat: sat,
	        act: act,
	        sportName: sportName,
	        t40: t40,
	        bench: bench,
	        squats: squats,
	        position: position,
	        description: description };
	
	      var sports = {};
	      var payload = this.props.profile.toJS();
	      sports[sportName] = { t40: t40, bench: bench, squats: squats, position: position, description: description };
	
	      this.setState(updated, function () {
	        payload = Object.assign(payload, {
	          city: studentCity,
	          sa_state: studentState,
	          school: school,
	          height: height,
	          weight: weight,
	          year_of_graduation: yearOfPassing,
	          academic: academic,
	          sports: sports,
	          fullname: studentFullName,
	          gender: studentGender
	        });
	        if (parentValidFullName && validStudentFullName && validStudentCity && validStudentState && validHeight && validWeight && validT40 && validDescription && validBench && validSquats && validSat && validAct && validGpa && validYearOfPassing && validSchool) {
	          _this2.props.saveSAProfile(payload, _this2.state.profile);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state3 = this.state,
	          parentFullNameErrorMessage = _state3.parentFullNameErrorMessage,
	          parentEmailErrorMessage = _state3.parentEmailErrorMessage,
	          heightErrorMessage = _state3.heightErrorMessage,
	          weightErrorMessage = _state3.weightErrorMessage,
	          emailErrorMessage = _state3.emailErrorMessage,
	          studentFullNameErrorMessage = _state3.studentFullNameErrorMessage,
	          studentStateErrorMessage = _state3.studentStateErrorMessage,
	          studentCityErrorMessage = _state3.studentCityErrorMessage,
	          t40ErrorMessage = _state3.t40ErrorMessage,
	          squatsErrorMessage = _state3.squatsErrorMessage,
	          benchErrorMessage = _state3.benchErrorMessage,
	          descriptionErrorMessage = _state3.descriptionErrorMessage,
	          satErrorMessage = _state3.satErrorMessage,
	          gpaErrorMessage = _state3.gpaErrorMessage,
	          schoolErrorMessage = _state3.schoolErrorMessage,
	          yearOfPassingErrorMessage = _state3.yearOfPassingErrorMessage,
	          actErrorMessage = _state3.actErrorMessage;
	
	      var renderLoader = (0, _renderIf2.default)(this.props.saRequested || this.props.updateRequested);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _ModifyParent2.default.container) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _ModifyParent2.default.collapseContainer) },
	          _react2.default.createElement(
	            _reactCollapsible2.default,
	            {
	              trigger: 'Parent Info',
	              transitionTime: 100,
	              contentOuterClassName: _ModifyParent2.default.bottomPadding,
	              open: this.state.parentCollapsible
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _ModifyParent2.default.inputContainer },
	              _react2.default.createElement(
	                'div',
	                { className: parentFullNameErrorMessage === '' ? (0, _classnames2.default)('col s6', _ModifyParent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s6', _ModifyParent2.default.halfWidthWithSpanError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'FULL NAME'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'full_name',
	                  value: this.props.attributes.get('name'),
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('parentFullNameErrorMessage');
	                  },
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('parentFullName', val);
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: this.state.parentFullNameErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: parentEmailErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'EMAIL'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'email',
	                  disabled: true,
	                  value: this.props.attributes.get('email')
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: parentEmailErrorMessage })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: _ModifyParent2.default.space }),
	          _react2.default.createElement(
	            _reactCollapsible2.default,
	            {
	              trigger: 'Student Info',
	              transitionTime: 100,
	              contentOuterClassName: _ModifyParent2.default.bottomPadding,
	              open: this.state.parentCollapsible
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _ModifyParent2.default.inputContainer },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s8', _ModifyParent2.default.personalInfo) },
	                _react2.default.createElement(
	                  'div',
	                  { className: studentFullNameErrorMessage === '' ? (0, _classnames2.default)('col s12', _ModifyParent2.default.halfWidthWithSpan) : _ModifyParent2.default.halfWidthWithSpanError },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'FIRST NAME'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'full_name',
	                    value: this.state.studentFullName,
	                    onFocus: function onFocus() {
	                      return _this3.removeErrorMessage('studentFullNameErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this3.handleChange('studentFullName', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.studentFullNameErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: studentStateErrorMessage === '' ? (0, _classnames2.default)('col s12', _ModifyParent2.default.halfWidthWithSpan) : _ModifyParent2.default.halfWidthWithSpanError },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'STATE'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'full_name',
	                    value: this.state.studentState,
	                    onFocus: function onFocus() {
	                      return _this3.removeErrorMessage('studentStateErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this3.handleChange('studentState', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.studentStateErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: studentCityErrorMessage === '' ? (0, _classnames2.default)('col s12', _ModifyParent2.default.halfWidthWithSpan) : _ModifyParent2.default.halfWidthWithSpanError },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'CITY'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'full_name',
	                    value: this.state.studentCity,
	                    onFocus: function onFocus() {
	                      return _this3.removeErrorMessage('studentCityErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this3.handleChange('studentCity', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.studentCityErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthRadio) },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'GENDER'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s6', _ModifyParent2.default.radioContainer) },
	                    _react2.default.createElement(
	                      _radio.RadioGroup,
	                      { name: 'gender', value: this.state.gender, onChange: function onChange(val) {
	                          return _this3.handleChange('gender', val);
	                        } },
	                      _react2.default.createElement(_radio.RadioButton, { label: 'Male', value: 'male' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s6', _ModifyParent2.default.radioContainer) },
	                    _react2.default.createElement(
	                      _radio.RadioGroup,
	                      { name: 'gender', value: this.state.gender, onChange: function onChange(val) {
	                          return _this3.handleChange('gender', val);
	                        } },
	                      _react2.default.createElement(_radio.RadioButton, { label: 'Female', value: 'female' })
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s4', _ModifyParent2.default.personalInfo) },
	              _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/defaultProfile.jpg', alt: 'profile_ima' })
	            )
	          ),
	          _react2.default.createElement('div', { className: _ModifyParent2.default.space }),
	          _react2.default.createElement(
	            _reactCollapsible2.default,
	            {
	              trigger: 'Sports Info',
	              transitionTime: 100,
	              contentOuterClassName: _ModifyParent2.default.bottomPadding,
	              open: this.state.parentCollapsible
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _ModifyParent2.default.inputContainer },
	              _react2.default.createElement(
	                'div',
	                { className: heightErrorMessage === '' ? (0, _classnames2.default)('col s6', _ModifyParent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s6', _ModifyParent2.default.halfWidthWithSpanError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'HEIGHT'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'full_name',
	                  value: this.state.height,
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('heightErrorMessage');
	                  },
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('height', val);
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: this.state.heightErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: weightErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'WEIGHT'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.weight,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('weight', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('weightErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: weightErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _ModifyParent2.default.sportsInfo) },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'SPORTS DETAILS'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _ModifyParent2.default.removePadding) },
	                _react2.default.createElement(
	                  'div',
	                  { className: emailErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MY SPORT'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'city',
	                    value: this.state.mySport
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: emailErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s6') },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _ModifyParent2.default.makeAnotherPreference },
	                    'ADD PREFERENCE POSITIONS'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _ModifyParent2.default.textAreaContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: descriptionErrorMessage === '' ? (0, _classnames2.default)('col s12 ', _ModifyParent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12', _ModifyParent2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'DESCRIPTION'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'city',
	                    value: this.state.description,
	                    onChange: function onChange(val) {
	                      return _this3.handleChange('description', val);
	                    },
	                    multiline: true,
	                    onFocus: function onFocus() {
	                      return _this3.removeErrorMessage('descriptionErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: descriptionErrorMessage })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: t40ErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'T40'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.t40,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('t40', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('t40ErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: t40ErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: squatsErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'SQUATS'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.squats,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('squats', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('squatsErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: squatsErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: benchErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'BENCH'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.bench,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('bench', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('benchErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: benchErrorMessage })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: _ModifyParent2.default.space }),
	          _react2.default.createElement(
	            _reactCollapsible2.default,
	            {
	              trigger: 'Academic Info',
	              transitionTime: 100,
	              contentOuterClassName: _ModifyParent2.default.bottomPadding,
	              open: this.state.parentCollapsible
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _ModifyParent2.default.inputContainer },
	              _react2.default.createElement(
	                'div',
	                { className: schoolErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'SCHOOL'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.school,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('school', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('schoolErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: schoolErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: yearOfPassingErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'GRADUATION YEAR'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.yearOfPassing,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('yearOfPassing', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('yearOfPassingErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: yearOfPassingErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: gpaErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'GPA'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.gpa,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('gpa', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('gpaErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: gpaErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: satErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'SAT'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.sat,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('sat', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('satErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: satErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: actErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyParent2.default.halfWidthAutoCompleteError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'ACT'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  type: 'text',
	                  name: 'city',
	                  value: this.state.act,
	                  onChange: function onChange(val) {
	                    return _this3.handleChange('act', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('actErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: actErrorMessage })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: _ModifyParent2.default.space }),
	          _react2.default.createElement(
	            _button2.default,
	            { className: _ModifyParent2.default.continue, onClick: this.validateInput },
	            'UPDATE PROFILE'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModifyParent;
	}(_react.Component);
	
	ModifyParent.propTypes = {
	  getSAProfile: _propTypes2.default.func,
	  saveSAProfile: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape(),
	  profile: _propTypes2.default.shape(),
	  saRequested: _propTypes2.default.bool,
	  updateRequested: _propTypes2.default.bool
	  /* searchSchools: PropTypes.func, */
	};
	ModifyParent.defaultProps = {
	  getSAProfile: function getSAProfile() {},
	  saveSAProfile: function saveSAProfile() {},
	  attributes: {},
	  profile: {},
	  saRequested: true,
	  updateRequested: false,
	  searchSchools: function searchSchools() {}
	};
	exports.default = ModifyParent;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModifyParent = __webpack_require__(1158);
	
	var _ModifyParent2 = _interopRequireDefault(_ModifyParent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ModifyParent2.default;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCollapsible = __webpack_require__(741);
	
	var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _radio = __webpack_require__(104);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _reactAutocomplete = __webpack_require__(342);
	
	var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _ModifyStudent = __webpack_require__(1501);
	
	var _ModifyStudent2 = _interopRequireDefault(_ModifyStudent);
	
	var _theme = __webpack_require__(1590);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// to use input from react-toolbox library
	// to display error messages on invalid user input
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	// regular expressions to validate user input
	// to show loder on screen whenever there is a api call or operations in component
	// to import local scss fle
	
	
	var emptyObject = {};
	
	var autostyle = {
	  item: {
	    padding: '2px 6px',
	    cursor: 'default'
	  },
	
	  highlightedItem: {
	    color: 'white',
	    background: '#eeeeee',
	    padding: '2px 6px',
	    cursor: 'default'
	  }
	};
	
	var t40Suggestions = {};
	var squatsSuggestions = {};
	var benchSuggestions = {};
	var gpaSuggestions = {};
	var satSuggestions = {};
	
	var ModifyProfile = function (_React$Component) {
	  _inherits(ModifyProfile, _React$Component);
	
	  function ModifyProfile(props) {
	    _classCallCheck(this, ModifyProfile);
	
	    var _this = _possibleConstructorReturn(this, (ModifyProfile.__proto__ || Object.getPrototypeOf(ModifyProfile)).call(this, props));
	
	    _this.handleWeight = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)));
	    };
	
	    _this.handleHeight = function (name, value) {
	      if (name === 'heightInFeet') {
	        if (value.target.value <= 7 && value.target.value >= 4 || value.target.value === '') {
	          _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	            _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	          });
	        }
	      } else if (value.target.value < 12 && value.target.value >= 0 || value.target.value === '') {
	        _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	          _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	        });
	      }
	    };
	
	    _this.state = {
	      value: '',
	      /* student info fields */
	      studentFullName: '',
	      studentCity: '',
	      studentState: '',
	      twitter: '',
	      mobile: '',
	      instagram: '',
	      hbcu: 'no',
	      studentFullNameErrorMessage: '',
	      studentEmailErrorMessage: '',
	      studentStateErrorMessage: '',
	      studentCityErrorMessage: '',
	      twitterErrorMessage: '',
	      instagramErrorMessage: '',
	      mobileErrorMessage: '',
	      secondaryDefensiveError: '',
	      /* student info fields */
	
	      /* student sports info */
	      position_pref: '',
	      height: '',
	      weight: '',
	      sportName: 'FOOTBALL',
	      t40: '',
	      bench: '',
	      squats: '',
	      position: '',
	      description: '',
	      heightErrorMessage: '',
	      heightInchesErrorMessage: '',
	      heightInFeetErrorMessage: '',
	      weightErrorMessage: '',
	      offensiveErrorMessage: '',
	      defensiveErrorMessage: '',
	      mySport: 'FOOTBALL',
	      t40ErrorMessage: '',
	      squatsErrorMessage: '',
	      benchErrorMessage: '',
	      specialTeamsErrorMessage: '',
	      specialTeams: '',
	      descriptionErrorMessage: '',
	      secondaryOffensiveError: '',
	      secondaryPosition: [],
	      showSecondaryButton: false,
	      primary_offensive_position_pref: '',
	      secondary_offensive_position_pref: '',
	      primary_defensive_position_pref: '',
	      secondary_defensive_position_pref: '',
	      special_teams: '',
	      /* student sports info */
	
	      /* academic info */
	      school: {},
	      schoolNames: [],
	      gpa: '',
	      act: '',
	      sat: '',
	      yearOfPassing: '',
	      schoolErrorMessage: '',
	      positionErrorMessage: '',
	      yearOfPassingErrorMessage: '',
	      gpaErrorMessage: '',
	      satErrorMessage: '',
	      actErrorMessage: '',
	      /* academic info */
	      parentCollapsible: true,
	      emailErrorMessage: '',
	      firstNameErrorMessage: ''
	    };
	    _this.validateInput = _this.validateInput.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleQueryChange = _this.handleQueryChange.bind(_this);
	    _this.handleQueryChangeT40 = _this.handleQueryChangeT40.bind(_this);
	    _this.handleWeight = _this.handleWeight.bind(_this);
	    _this.handleHeight = _this.handleHeight.bind(_this);
	    _this.addAnotherPreference = _this.addAnotherPreference.bind(_this);
	    _this.removeSecondaryPosition = _this.removeSecondaryPosition.bind(_this);
	    _this.timer = null;
	    _this.Map = _immutable.Map;
	    _this.is = _immutable.is;
	    return _this;
	  }
	
	  _createClass(ModifyProfile, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.attributes.size > 0 && !this.props.profile.size > 0) {
	        var profile = this.props.attributes.get('profile');
	        this.props.getSAProfile(profile);
	      } else {
	        var newState = {};
	
	        var saSports = this.props.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        if (sport.get('primary_offensive_position_pref') !== undefined) {
	          newState.primary_offensive_position_pref = sport.get('primary_offensive_position_pref');
	        }
	        if (sport.get('primary_defensive_position_pref') !== undefined) {
	          newState.primary_defensive_position_pref = sport.get('primary_defensive_position_pref');
	        }
	        if (sport.get('secondary_offensive_position_pref') !== undefined) {
	          newState.secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref');
	        }
	        if (sport.get('secondary_defensive_position_pref') !== undefined) {
	          newState.secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref');
	        }
	        if (sport.get('special_teams') !== undefined) {
	          newState.special_teams = sport.get('special_teams');
	        }
	        if (this.props.profile.get('sa_twitter') !== undefined) {
	          newState.twitter = this.props.profile.get('sa_twitter');
	        }
	        if (this.props.profile.get('sa_instagram') !== undefined) {
	          newState.instagram = this.props.profile.get('sa_instagram');
	        }
	        var academic = this.props.profile.get('academic');
	        var combinedHeight = this.props.profile.get('height');
	        newState.height = this.props.profile.get('height');
	        newState.studentFullName = this.props.profile.get('fullname');
	        newState.email = this.props.profile.get('sa_email');
	        newState.studentGender = this.props.profile.get('gender');
	        newState.studentState = this.props.profile.get('sa_state');
	        newState.studentCity = this.props.profile.get('city');
	        newState.heightInFeet = combinedHeight.charAt(0);
	        newState.heightInInches = combinedHeight.substr(2, 2).replace(/['"]+/g, '');
	        newState.weight = this.props.profile.get('weight');
	        newState.sportName = keys[0];
	        newState.t40 = sport.get('t40');
	        newState.bench = sport.get('bench');
	        newState.squats = sport.get('squats');
	        newState.description = sport.get('description');
	        newState.position = sport.get('position_pref');
	        newState.school = this.props.profile.get('school');
	        newState.yearOfPassing = academic.get('year_of_graduation');
	        newState.gpa = academic.get('gpa');
	        newState.hbcu = academic.get('hbcu');
	        if (academic.get('sat') !== undefined) {
	          newState.sat = academic.get('sat');
	        }
	        if (academic.get('act') !== undefined) {
	          newState.act = academic.get('act');
	        }
	        newState.mobile = this.props.profile.get('sa_mobile');
	        this.setState(Object.assign({}, newState));
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.redirect !== nextProps.redirect && nextProps.redirect === true) {
	        this.props.history.push('/view/athlete');
	      }
	      if ((0, _immutable.is)(this.props.profile, nextProps.profile) && nextProps.saRequested && (0, _immutable.is)(this.props.schools, nextProps.schools)) {
	        if (nextProps.attributes.size > 0) {
	          var profile = nextProps.attributes.get('profile');
	          this.props.getSAProfile(profile);
	        }
	      } else if (this.Map.isMap(nextProps.schools) && !this.is(nextProps.schools, this.props.schools) && nextProps.schools.get('hits')) {
	        var hits = nextProps.schools.get('hits');
	        var total = hits.get('total');
	        var tempHits = [];
	        if (total > 0) {
	          var results = nextProps.schools.get('hits');
	          results = results.get('hits');
	          results = results.toJS();
	
	          results.forEach(function (school) {
	            var obj = {};
	            var college = school._source.school; // eslint-disable-line
	            var key = college;
	            obj.key = key;
	            obj.value = college;
	            tempHits.push(obj);
	          });
	          this.setState({ schoolNames: tempHits });
	        }
	      }
	
	      var newState = {};
	      if (nextProps.profile.size > 0 && !(0, _immutable.is)(this.props.profile, nextProps.profile)) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        if (sport.get('primary_offensive_position_pref') !== undefined) {
	          newState.primary_offensive_position_pref = sport.get('primary_offensive_position_pref');
	        }
	        if (sport.get('primary_defensive_position_pref') !== undefined) {
	          newState.primary_defensive_position_pref = sport.get('primary_defensive_position_pref');
	        }
	        if (sport.get('secondary_offensive_position_pref') !== undefined) {
	          newState.secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref');
	        }
	        if (sport.get('secondary_defensive_position_pref') !== undefined) {
	          newState.secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref');
	        }
	        if (sport.get('special_teams') !== undefined) {
	          newState.special_teams = sport.get('special_teams');
	        }
	        if (nextProps.profile.get('sa_twitter') !== undefined) {
	          newState.twitter = nextProps.profile.get('sa_twitter');
	        }
	        if (nextProps.profile.get('sa_instagram') !== undefined) {
	          newState.instagram = nextProps.profile.get('sa_instagram');
	        }
	        var academic = nextProps.profile.get('academic');
	        var combinedHeight = nextProps.profile.get('height');
	        newState.height = nextProps.profile.get('height');
	        newState.studentFullName = nextProps.profile.get('fullname');
	        newState.email = nextProps.profile.get('sa_email');
	        newState.studentGender = nextProps.profile.get('gender');
	        newState.studentState = nextProps.profile.get('sa_state');
	        newState.studentCity = nextProps.profile.get('city');
	        newState.heightInFeet = combinedHeight.charAt(0);
	        newState.heightInInches = combinedHeight.substr(2, 2).replace(/['"]+/g, '');
	        newState.weight = nextProps.profile.get('weight');
	        newState.sportName = keys[0];
	        newState.t40 = sport.get('t40');
	        newState.bench = sport.get('bench');
	        newState.squats = sport.get('squats');
	        newState.description = sport.get('description');
	        newState.position = sport.get('position_pref');
	        newState.school = nextProps.profile.get('school');
	        newState.yearOfPassing = academic.get('year_of_graduation');
	        newState.mobile = nextProps.profile.get('sa_mobile');
	        newState.gpa = academic.get('gpa');
	        if (academic.get('hbcu') !== undefined) {
	          newState.hbcu = academic.get('hbcu');
	        }
	        if (academic.get('sat') !== undefined) {
	          newState.sat = academic.get('sat');
	        }
	        if (academic.get('act') !== undefined) {
	          newState.act = academic.get('act');
	        }
	      }
	      this.setState(Object.assign({}, newState));
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	    }
	  }, {
	    key: 'handleQueryChange',
	    value: function handleQueryChange(val) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, val, '')));
	    }
	  }, {
	    key: 'handleQueryChangeT40',
	    value: function handleQueryChangeT40(val) {
	      if (this.state.t40.length === 3) {
	        this.setState(Object.assign({}, this.state, { t40: '' }));
	      } else {
	        this.setState(Object.assign({}, this.state, { t40: val }));
	      }
	    }
	  }, {
	    key: 'removeErrorMessage',
	    value: function removeErrorMessage(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'validateInput',
	    value: function validateInput() {
	      var _this2 = this;
	
	      var _state = this.state,
	          studentFullName = _state.studentFullName,
	          studentCity = _state.studentCity,
	          studentState = _state.studentState;
	
	      var updated = {};
	      /* validation for student info */
	      var validStudentFullName = false;
	      var validMobile = false;
	      var validStudentCity = false;
	      var validStudentState = false;
	      /* validation for Full Name */
	      var enteredStudentFullName = _Regularexpression.regExForName.test(studentFullName);
	      if (enteredStudentFullName && studentFullName !== '') {
	        validStudentFullName = true;
	      } else {
	        updated.studentFullNameErrorMessage = 'Please enter a valid name.';
	      }
	      /* validation for Full Name */
	
	      /* validation for city */
	      var enteredStudentCity = _Regularexpression.regExForName.test(studentCity);
	      if (enteredStudentCity && studentCity !== '') {
	        validStudentCity = true;
	      } else {
	        updated.studentCityErrorMessage = 'Please enter a valid city.';
	      }
	      /* validation for city */
	
	      /* Validation for mobile */
	      var enteredMobile = _Regularexpression.regExForNumber.test(this.state.mobile);
	      if (enteredMobile && this.state.mobile !== '') {
	        validMobile = true;
	      } else {
	        this.setState({ mobileErrorMessage: 'Please enter a valid mobile number.' });
	      }
	      /* Validation for mobile */
	      /* validation for state */
	      var enteredStudentState = typeof studentState === 'string';
	      if (enteredStudentState && studentState !== '') {
	        validStudentState = true;
	      } else {
	        updated.studentStateErrorMessage = 'Please enter a valid state.';
	      }
	      /* validation for student info */
	
	      /* validation for sports info */
	      /* Height Validation */
	      var validHeight = false;
	      if (this.state.height !== '') {
	        validHeight = true;
	      } else {
	        updated.heightErrorMessage = 'Enter valid height.';
	      }
	      /* Height Validation */
	
	      /* weight validation */
	      var validWeight = false;
	      if (this.state.weight !== '' && this.state.weight >= 120 && this.state.weight <= 350) {
	        validWeight = true;
	      } else if (!(this.state.weight >= 120 && this.state.weight <= 350) && this.state.weight !== '') {
	        this.setState({ weightErrorMessage: 'Enter weight between 120-350 pounds.' });
	      } else {
	        this.setState({ weightErrorMessage: 'Please  add a valid weight.' });
	      }
	      /* weight validation */
	
	      /* T40 validation */
	      var validT40 = false;
	      if (this.state.t40 !== '' && this.state.t40 >= 4 && this.state.t40 <= 5.5) {
	        validT40 = true;
	      } else if (!(this.state.t40 >= 4 && this.state.t40 <= 5.5) && this.state.t40 !== '') {
	        this.setState({ t40ErrorMessage: 'Enter 40-Yard Dash between 4-5.5 seconds.' });
	      } else {
	        this.setState({ t40ErrorMessage: 'Please add a valid 40-Yard Dash.' });
	      }
	
	      /* T40 validation */
	
	      /* squats validation */
	      var validSquats = false;
	      if (this.state.squats !== '' && !isNaN(this.state.squats)) {
	        validSquats = true;
	      } else {
	        updated.squatsErrorMessage = 'Please add a valid Squats.';
	      }
	      /* squats validation */
	
	      /* Bench validation */
	      var validBench = false;
	      if (this.state.bench !== '' && !isNaN(this.state.bench)) {
	        validBench = true;
	      } else {
	        updated.benchErrorMessage = 'Please add a valid Bench.';
	      }
	      /* squats validation */
	      /* validation for sports info */
	
	      /* validation for academic info */
	      var validSchool = false;
	      var enteredScool = _typeof(this.state.school);
	      if (enteredScool === 'string' && this.state.school !== '') {
	        validSchool = true;
	      } else {
	        updated.schoolErrorMessage = 'Please select a school.';
	      }
	      /* school validation */
	
	      /* year of passing */
	      var validYearOfPassing = false;
	
	      if (this.state.yearOfPassing !== '' && !isNaN(this.state.yearOfPassing)) {
	        validYearOfPassing = true;
	      } else {
	        updated.yearOfPassingErrorMessage = 'Please add graduation year';
	      }
	      /* year of passing */
	
	      /* Gpa validation */
	      var validGpa = false;
	      if (this.state.gpa !== '' && !isNaN(this.state.gpa) && this.state.gpa >= 2 && this.state.gpa <= 4) {
	        validGpa = true;
	      } else {
	        updated.gpaErrorMessage = 'Please select a Gpa from list.';
	      }
	      /* Gpa validation */
	
	      /* Act validation */
	      var validAct = false;
	      if (this.state.act !== '' && this.state.act >= 16 && this.state.act <= 36) {
	        validAct = true;
	      } else if (this.state.act === '') {
	        validAct = true;
	      } else {
	        this.setState({ actErrorMessage: 'Enter Act between 16 - 36.' });
	      }
	      /* Act validation */
	
	      /* Sat validation */
	      var validSat = false;
	      if (this.state.sat !== '' && this.state.sat >= 600 && this.state.sat <= 1600) {
	        validSat = true;
	      } else if (this.state.sat === '') {
	        validSat = true;
	      } else {
	        this.setState({ satErrorMessage: 'Enter Sat between 600 - 1600.' });
	      }
	
	      var validPrimaryPosition = false;
	      if (this.state.primary_defensive_position_pref !== '' || this.state.primary_offensive_position_pref !== '') {
	        validPrimaryPosition = true;
	      } else {
	        updated.offensiveErrorMessage = 'Please select one primary position.';
	      }
	
	      var validSecondaryPositionCase = false;
	      if (this.state.secondary_defensive_position_pref !== '' && this.state.primary_defensive_position_pref === '') {
	        validSecondaryPositionCase = false;
	        updated.secondaryDefensiveError = 'Please fill primary defensive first.';
	      } else if (this.state.primary_defensive_position_pref === '' || this.state.secondary_defensive_position_pref === '') {
	        validSecondaryPositionCase = true;
	      } else if (this.state.primary_offensive_position_pref !== '' && this.state.primary_defensive_position_pref !== '') {
	        validSecondaryPositionCase = true;
	      }
	
	      var validSamePositionsOffensive = false;
	      if (this.state.secondary_offensive_position_pref === '') {
	        validSamePositionsOffensive = true;
	      } else if (this.state.primary_offensive_position_pref === this.state.secondary_offensive_position_pref) {
	        validSamePositionsOffensive = false;
	        updated.secondaryOffensiveError = 'Primary and secondary positions can not be same.';
	      } else if (this.state.secondary_offensive_position_pref !== '') {
	        validSamePositionsOffensive = true;
	      }
	
	      var validSamePositionsDefensive = false;
	      if (this.state.secondary_defensive_position_pref === '') {
	        validSamePositionsDefensive = true;
	      } else if (this.state.primary_defensive_position_pref === this.state.secondary_defensive_position_pref) {
	        validSamePositionsDefensive = false;
	        updated.secondaryDefensiveError = 'Primary and secondary positions can not be same.';
	      } else if (this.state.secondary_defensive_position_pref !== '') {
	        validSamePositionsDefensive = true;
	      }
	      /* Sat validation */
	      /* validation for academic info */
	      var _state2 = this.state,
	          yearOfPassing = _state2.yearOfPassing,
	          gpa = _state2.gpa,
	          sat = _state2.sat,
	          act = _state2.act,
	          sportName = _state2.sportName,
	          t40 = _state2.t40,
	          school = _state2.school,
	          height = _state2.height,
	          weight = _state2.weight,
	          bench = _state2.bench,
	          squats = _state2.squats,
	          instagram = _state2.instagram,
	          twitter = _state2.twitter,
	          mobile = _state2.mobile,
	          primary_offensive_position_pref = _state2.primary_offensive_position_pref,
	          primary_defensive_position_pref = _state2.primary_defensive_position_pref,
	          secondary_offensive_position_pref = _state2.secondary_offensive_position_pref,
	          secondary_defensive_position_pref = _state2.secondary_defensive_position_pref,
	          special_teams = _state2.special_teams,
	          hbcu = _state2.hbcu;
	
	      var academic = {
	        year_of_graduation: yearOfPassing,
	        gpa: gpa,
	        hbcu: hbcu
	      };
	      if (act !== '') {
	        academic['act'] = act; //eslint-disable-line
	      }
	      if (sat !== '') {
	        academic['sat'] = sat; //eslint-disable-line
	      }
	
	      var sports = {};
	      var payload = this.props.profile.toJS();
	      sports[sportName] = { t40: t40, bench: bench, squats: squats };
	      var temp = sports[sportName];
	      if (primary_offensive_position_pref !== '') {
	        //eslint-disable-line
	        temp['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
	      }
	      if (primary_defensive_position_pref !== '') {
	        //eslint-disable-line
	        temp['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
	      }
	      if (secondary_defensive_position_pref !== '') {
	        //eslint-disable-line
	        temp['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
	      }
	      if (secondary_offensive_position_pref !== '') {
	        //eslint-disable-line
	        temp['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
	      }
	      if (special_teams !== '') {
	        //eslint-disable-line
	        temp['special_teams'] = special_teams; //eslint-disable-line
	      }
	      sports[sportName] = temp;
	      this.setState(updated, function () {
	        payload = Object.assign(payload, {
	          city: studentCity,
	          sa_state: studentState,
	          school: school,
	          height: height,
	          weight: weight,
	          year_of_graduation: yearOfPassing,
	          academic: academic,
	          sports: sports,
	          sa_mobile: mobile,
	          fullname: studentFullName,
	          current_division: 'NA'
	        });
	        if (instagram) {
	          var instagramUrl = '';
	          if (instagram.startsWith('https')) {
	            instagramUrl = instagram;
	          } else {
	            instagramUrl = 'https://instagram.com/' + instagram;
	          }
	          payload['sa_instagram'] = instagramUrl; //eslint-disable-line
	        } else {
	          payload['sa_instagram'] = null; //eslint-disable-line
	        }
	        if (twitter) {
	          var twitterUrl = '';
	          if (twitter.startsWith('https')) {
	            twitterUrl = twitter;
	          } else {
	            twitterUrl = 'https://twitter.com/' + twitter;
	          }
	          payload['sa_twitter'] = twitterUrl; //eslint-disable-line
	        } else {
	          payload['sa_twitter'] = null; //eslint-disable-line
	        }
	        if (validStudentFullName && validStudentCity && validStudentState && validHeight && validWeight && validT40 && validBench && validSquats && validSat && validAct && validGpa && validYearOfPassing && validSchool && validMobile && validPrimaryPosition && validSamePositionsDefensive && validSecondaryPositionCase && validSamePositionsOffensive) {
	          _this2.props.saveSAProfile(payload, _this2.state.profile);
	        }
	      });
	    }
	  }, {
	    key: 'addAnotherPreference',
	    value: function addAnotherPreference() {
	      var tempData = []; // eslint-disable-line
	      tempData = [{
	        id: 'OFFENSIVE',
	        positionValue: ''
	      }, {
	        id: 'DEFENSIVE',
	        positionValue: ''
	      }];
	      this.setState({ secondaryPosition: tempData, showSecondaryButton: false });
	    }
	  }, {
	    key: 'addValuesToSecondaryPosition',
	    value: function addValuesToSecondaryPosition(value, i) {
	      var tempData = [];
	      tempData = this.state.secondaryPosition;
	      tempData[i].positionValue = value;
	      this.setState({ secondaryPosition: tempData });
	    }
	  }, {
	    key: 'removeSecondaryPosition',
	    value: function removeSecondaryPosition(name) {
	      if (name === 'secondary_defensive_position_pref') {
	        var _Object$assign7;
	
	        this.setState(Object.assign({}, this.state, (_Object$assign7 = {}, _defineProperty(_Object$assign7, name, ''), _defineProperty(_Object$assign7, 'secondaryDefensiveError', ''), _Object$assign7)));
	      } else {
	        var _Object$assign8;
	
	        this.setState(Object.assign({}, this.state, (_Object$assign8 = {}, _defineProperty(_Object$assign8, name, ''), _defineProperty(_Object$assign8, 'secondaryOffensiveError', ''), _Object$assign8)));
	      }
	    }
	  }, {
	    key: 'schoolSearch',
	    value: function schoolSearch(name, value) {
	      var _this3 = this;
	
	      var query = {};
	      if (this.timer) {
	        clearTimeout(this.timer);
	      }
	
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	
	      if (value && value.length >= 3) {
	        this.timer = setTimeout(function () {
	          var obj = {};
	          obj.key = 'school';
	          obj.value = value;
	          query.push(obj);
	          _this3.props.searchSchools(query);
	        }, 100);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      for (var i = 1; i < 5; i++) {
	        //eslint-disable-line
	        for (var x = 0; x <= 10; x++) {
	          //eslint-disable-line
	          var listItem = '';
	          listItem = i * 100 + x * 10;
	          squatsSuggestions['' + listItem] = '' + listItem;
	        }
	      }
	      for (var _i = 1; _i < 4; _i++) {
	        //eslint-disable-line
	        for (var _x = 0; _x <= 10; _x++) {
	          //eslint-disable-line
	          var _listItem = '';
	          _listItem = _i * 100 + _x * 10;
	          benchSuggestions['' + _listItem] = '' + _listItem;
	        }
	      }
	      for (var _i2 = 4; _i2 < 6; _i2++) {
	        //eslint-disable-line
	        for (var _x2 = 0; _x2 <= 10; _x2++) {
	          //eslint-disable-line
	          var _listItem2 = '';
	          _listItem2 = '' + (_i2 + "." + _x2); // eslint-disable-line
	          if (_x2 === 10) {
	            _listItem2 = _i2 + 1 + '.0'; // eslint-disable-line
	          }
	          if (_listItem2 <= '5.5') {
	            if (_listItem2 === '4.0') {
	              _listItem2 = '4.0 or Lower';
	            } else if (_listItem2 === '5.5') {
	              _listItem2 = '5.5 or Higher';
	            }
	            t40Suggestions['' + _listItem2] = '' + _listItem2;
	          }
	        }
	      }
	      for (var _i3 = 6; _i3 < 16; _i3++) {
	        //eslint-disable-line
	        for (var _x3 = 1; _x3 <= 10; _x3++) {
	          //eslint-disable-line
	          var _listItem3 = '';
	          var left = '';
	          var right = '';
	          _listItem3 = _i3 * 100 + _x3 * 10;
	          left = _listItem3;
	          right = _listItem3;
	          if (_listItem3 === 600) {
	            left = '600';right = '600 or Lower';
	          }
	          satSuggestions['' + left] = '' + right;
	        }
	      }
	      for (var _i4 = 2; _i4 < 4; _i4++) {
	        //eslint-disable-line
	        for (var _x4 = 0; _x4 <= 10; _x4++) {
	          //eslint-disable-line
	          var _listItem4 = '';
	          var _left = '';
	          var _right = '';
	          _listItem4 = '' + (_i4 + "." + _x4); // eslint-disable-line
	          if (_x4 === 10) {
	            _listItem4 = _i4 + 1 + '.0'; // eslint-disable-line
	          }
	          _left = _listItem4;
	          _right = _listItem4;
	          if (_listItem4 === '2.0') {
	            _left = '2.0';_right = '2.0 or higher';
	          } else if (_listItem4 === '4.0') {
	            _left = '4.0';_right = '4.0 or Higher';
	          }
	          gpaSuggestions['' + _left] = '' + _right;
	        }
	      }
	      var _state3 = this.state,
	          heightInchesErrorMessage = _state3.heightInchesErrorMessage,
	          heightInFeetErrorMessage = _state3.heightInFeetErrorMessage,
	          weightErrorMessage = _state3.weightErrorMessage,
	          offensiveErrorMessage = _state3.offensiveErrorMessage,
	          defensiveErrorMessage = _state3.defensiveErrorMessage,
	          studentFullNameErrorMessage = _state3.studentFullNameErrorMessage,
	          studentStateErrorMessage = _state3.studentStateErrorMessage,
	          studentCityErrorMessage = _state3.studentCityErrorMessage,
	          t40ErrorMessage = _state3.t40ErrorMessage,
	          squatsErrorMessage = _state3.squatsErrorMessage,
	          specialTeamsErrorMessage = _state3.specialTeamsErrorMessage,
	          benchErrorMessage = _state3.benchErrorMessage,
	          satErrorMessage = _state3.satErrorMessage,
	          gpaErrorMessage = _state3.gpaErrorMessage,
	          schoolErrorMessage = _state3.schoolErrorMessage,
	          yearOfPassingErrorMessage = _state3.yearOfPassingErrorMessage,
	          actErrorMessage = _state3.actErrorMessage,
	          twitterErrorMessage = _state3.twitterErrorMessage,
	          mobileErrorMessage = _state3.mobileErrorMessage,
	          secondaryOffensiveError = _state3.secondaryOffensiveError,
	          instagramErrorMessage = _state3.instagramErrorMessage,
	          primary_offensive_position_pref = _state3.primary_offensive_position_pref,
	          primary_defensive_position_pref = _state3.primary_defensive_position_pref,
	          secondary_offensive_position_pref = _state3.secondary_offensive_position_pref,
	          secondary_defensive_position_pref = _state3.secondary_defensive_position_pref,
	          special_teams = _state3.special_teams,
	          secondaryDefensiveError = _state3.secondaryDefensiveError,
	          hbcu = _state3.hbcu;
	
	
	      var renderLoader = (0, _renderIf2.default)(this.props.saRequested || this.props.updateRequested);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.container) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.collapseContainer) },
	          _react2.default.createElement(
	            _reactCollapsible2.default,
	            {
	              trigger: 'Student Info',
	              easing: 'cubic-bezier(0.175, 0.885, 0.32, 2.275)',
	              transitionTime: 100,
	              contentOuterClassName: _ModifyStudent2.default.bottomPadding,
	              open: this.state.parentCollapsible
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _ModifyStudent2.default.inputContainer },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m10', _ModifyStudent2.default.personalInfo) },
	                _react2.default.createElement(
	                  'div',
	                  { className: studentFullNameErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'FULL NAME'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'full_name',
	                    value: this.state.studentFullName,
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('studentFullNameErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('studentFullName', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.studentFullNameErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'EMAIL'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    value: this.state.email,
	                    disabled: true
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.studentStateErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: mobileErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'MOBILE'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'mobile',
	                    value: this.state.mobile,
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('mobileErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('mobile', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: mobileErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: studentStateErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'STATE'
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('studentState', val);
	                    },
	                    onQueryChange: function onQueryChange(val) {
	                      return _this4.handleChange('studentState', val);
	                    },
	                    source: this.state.studentState === '' ? emptyObject : _DropdownsValues.states,
	                    value: this.state.studentState,
	                    multiple: false,
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('studentStateErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.studentStateErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: studentCityErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'CITY'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'full_name',
	                    value: this.state.studentCity,
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('studentCityErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('studentCity', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: this.state.studentCityErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: twitterErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'TWITTER',
	                    _react2.default.createElement(
	                      'spann',
	                      { className: _ModifyStudent2.default.optionalTag },
	                      '\xA0\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'twitter',
	                    value: this.state.twitter,
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('twitterErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('twitter', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: twitterErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: instagramErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'INSTAGRAM',
	                    _react2.default.createElement(
	                      'spann',
	                      { className: _ModifyStudent2.default.optionalTag },
	                      '\xA0\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'instagram',
	                    value: this.state.instagram,
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('instagramErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('instagram', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: instagramErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthRadio) },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'ARE YOU INTERESTED IN ATTENDING HBCUs? (Historically Black Colleges/Universities)'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s4', _ModifyStudent2.default.removePadding) },
	                    _react2.default.createElement(
	                      _radio.RadioGroup,
	                      { name: 'hbcu', value: hbcu, onChange: function onChange(val) {
	                          return _this4.handleChange('hbcu', val);
	                        } },
	                      _react2.default.createElement(_radio.RadioButton, { label: 'Yes', value: 'yes' })
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s4', _ModifyStudent2.default.radioContainer) },
	                    _react2.default.createElement(
	                      _radio.RadioGroup,
	                      { name: 'hbcu', value: hbcu, onChange: function onChange(val) {
	                          return _this4.handleChange('hbcu', val);
	                        } },
	                      _react2.default.createElement(_radio.RadioButton, { label: 'No', value: 'no' })
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: _ModifyStudent2.default.space }),
	          _react2.default.createElement(
	            _reactCollapsible2.default,
	            {
	              trigger: 'Sports Info',
	              transitionTime: 100,
	              contentOuterClassName: _ModifyStudent2.default.bottomPadding,
	              open: this.state.parentCollapsible
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _ModifyStudent2.default.inputContainer },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m10', _ModifyStudent2.default.removeLeftPadding) },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.heightAndWidthContainer) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.heightWidth) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'HEIGHT'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.heightContainer) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('col s6', _ModifyStudent2.default.feetContainer) },
	                        _react2.default.createElement('input', {
	                          className: heightInFeetErrorMessage === '' ? (0, _classnames2.default)('col s12', _ModifyStudent2.default.simpleInput) : (0, _classnames2.default)('col s12', _ModifyStudent2.default.simpleInputError),
	                          type: 'text',
	                          placeholder: 'Feet',
	                          value: this.state.heightInFeet,
	                          onFocus: function onFocus() {
	                            return _this4.removeErrorMessage('heightInFeetErrorMessage');
	                          },
	                          onChange: function onChange(val) {
	                            return _this4.handleHeight('heightInFeet', val);
	                          }
	                        }),
	                        _react2.default.createElement(_ErrorMessage2.default, { message: heightInFeetErrorMessage })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('col s6', _ModifyStudent2.default.inchesContainer) },
	                        _react2.default.createElement('input', {
	                          className: heightInchesErrorMessage === '' ? (0, _classnames2.default)('col s12', _ModifyStudent2.default.simpleInput) : (0, _classnames2.default)('col s12', _ModifyStudent2.default.simpleInputError),
	                          type: 'text',
	                          placeholder: 'Inches',
	                          value: this.state.heightInInches,
	                          onFocus: function onFocus() {
	                            return _this4.removeErrorMessage('heightInchesErrorMessage');
	                          },
	                          onChange: function onChange(val) {
	                            return _this4.handleHeight('heightInInches', val);
	                          }
	                        }),
	                        _react2.default.createElement(_ErrorMessage2.default, { message: heightInchesErrorMessage })
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: weightErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'WEIGHT'
	                    ),
	                    _react2.default.createElement('input', {
	                      className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.simpleInput),
	                      value: this.state.weight,
	                      onChange: function onChange(val) {
	                        return _this4.handleWeight('weight', val);
	                      },
	                      onFocus: function onFocus() {
	                        return _this4.removeErrorMessage('weightErrorMessage');
	                      },
	                      placeholder: 'Pounds'
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: this.state.weightErrorMessage })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.fullWidth) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.mysportContainer) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'MY SPORT'
	                    ),
	                    _react2.default.createElement('input', {
	                      /* source={sports} */
	                      value: this.state.sportName
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.preferedPositionContainer) },
	                    _react2.default.createElement(
	                      'div',
	                      { className: offensiveErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        'PRIMARY OFFENSIVE POSITION'
	                      ),
	                      _react2.default.createElement(_autocomplete2.default, {
	                        source: _DropdownsValues.offensivePositions,
	                        value: primary_offensive_position_pref //eslint-disable-line
	                        , onChange: function onChange(val) {
	                          return _this4.handleChange('primary_offensive_position_pref', val);
	                        },
	                        multiple: false,
	                        onQueryChange: function onQueryChange() {
	                          return _this4.handleQueryChange('primary_offensive_position_pref');
	                        },
	                        direction: 'down',
	                        onFocus: function onFocus() {
	                          return _this4.removeErrorMessage('offensiveErrorMessage');
	                        }
	                      }),
	                      _react2.default.createElement(_ErrorMessage2.default, { message: offensiveErrorMessage })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: defensiveErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        'PRIMARY DEFENSIVE POSITION'
	                      ),
	                      _react2.default.createElement(_autocomplete2.default, {
	                        source: _DropdownsValues.defensivePositions,
	                        value: primary_defensive_position_pref //eslint-disable-line
	                        , onChange: function onChange(val) {
	                          return _this4.handleChange('primary_defensive_position_pref', val);
	                        },
	                        multiple: false,
	                        onQueryChange: function onQueryChange() {
	                          return _this4.handleQueryChange('primary_defensive_position_pref');
	                        },
	                        direction: 'down',
	                        onFocus: function onFocus() {
	                          return _this4.removeErrorMessage('defensiveErrorMessage');
	                        }
	                      }),
	                      _react2.default.createElement(_ErrorMessage2.default, { message: defensiveErrorMessage })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.removePadding) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.removePadding) },
	                        _react2.default.createElement(
	                          'div',
	                          { className: secondaryOffensiveError === '' ? (0, _classnames2.default)('col s11 m11', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s11 m11', _ModifyStudent2.default.halfWidthWithSpanError) },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'SECONDARY OFFENSIVE POSITION',
	                            _react2.default.createElement(
	                              'spann',
	                              { className: _ModifyStudent2.default.optionalTag },
	                              '\xA0\xA0\xA0 (Optional)'
	                            )
	                          ),
	                          _react2.default.createElement(_autocomplete2.default, {
	                            source: _DropdownsValues.offensivePositions,
	                            value: secondary_offensive_position_pref // eslint-disable-line
	                            , onChange: function onChange(val) {
	                              return _this4.handleChange('secondary_offensive_position_pref', val);
	                            },
	                            multiple: false,
	                            onQueryChange: function onQueryChange() {
	                              return _this4.handleQueryChange('secondary_offensive_position_pref');
	                            },
	                            direction: 'down',
	                            onFocus: function onFocus() {
	                              return _this4.removeErrorMessage('defensiveErrorMessage');
	                            }
	                          }),
	                          _react2.default.createElement(_ErrorMessage2.default, { message: secondaryOffensiveError })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: (0, _classnames2.default)('col s1 m1', _ModifyStudent2.default.removePadding) },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: _ModifyStudent2.default.removeButton,
	                              onClick: function onClick() {
	                                return _this4.removeSecondaryPosition('secondary_offensive_position_pref');
	                              }
	                            },
	                            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/redCross.png', alt: 'remove' })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.removePadding) },
	                        _react2.default.createElement(
	                          'div',
	                          { className: secondaryDefensiveError === '' ? (0, _classnames2.default)('col s11 m11', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s11 m11', _ModifyStudent2.default.halfWidthWithSpanError) },
	                          _react2.default.createElement(
	                            'span',
	                            null,
	                            'SECONDARY DEFENSIVE POSITION',
	                            _react2.default.createElement(
	                              'spann',
	                              { className: _ModifyStudent2.default.optionalTag },
	                              '\xA0\xA0\xA0 (Optional)'
	                            )
	                          ),
	                          _react2.default.createElement(_autocomplete2.default, {
	                            source: _DropdownsValues.defensivePositions,
	                            value: secondary_defensive_position_pref // eslint-disable-line
	                            , onChange: function onChange(val) {
	                              return _this4.handleChange('secondary_defensive_position_pref', val);
	                            },
	                            multiple: false,
	                            onQueryChange: function onQueryChange() {
	                              return _this4.handleQueryChange('secondary_defensive_position_pref');
	                            },
	                            direction: 'down',
	                            onFocus: function onFocus() {
	                              return _this4.removeErrorMessage('secondaryDefensiveError');
	                            }
	                          }),
	                          _react2.default.createElement(_ErrorMessage2.default, { message: secondaryDefensiveError })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: (0, _classnames2.default)('col s1 m1', _ModifyStudent2.default.removePadding) },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: _ModifyStudent2.default.removeButton,
	                              onClick: function onClick() {
	                                return _this4.removeSecondaryPosition('secondary_defensive_position_pref');
	                              }
	                            },
	                            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/redCross.png', alt: 'remove' })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.removePadding) },
	                      _react2.default.createElement(
	                        'div',
	                        { className: specialTeamsErrorMessage === '' ? (0, _classnames2.default)('col s11 m5', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s11 m5', _ModifyStudent2.default.halfWidthWithSpanError) },
	                        _react2.default.createElement(
	                          'span',
	                          null,
	                          'SPECIAL TEAMS',
	                          _react2.default.createElement(
	                            'spann',
	                            { className: _ModifyStudent2.default.optionalTag },
	                            '\xA0\xA0\xA0(Optional)'
	                          )
	                        ),
	                        _react2.default.createElement(_autocomplete2.default, {
	                          source: _DropdownsValues.specialTeamsPositions,
	                          value: special_teams // eslint-disable-line
	                          , onChange: function onChange(val) {
	                            return _this4.handleChange('special_teams', val);
	                          },
	                          multiple: false,
	                          onQueryChange: function onQueryChange() {
	                            return _this4.handleQueryChange('special_teams');
	                          },
	                          selectedPosition: 'up',
	                          direction: 'up',
	                          onFocus: function onFocus() {
	                            return _this4.removeErrorMessage('specialTeamsErrorMessage');
	                          }
	                        }),
	                        _react2.default.createElement(_ErrorMessage2.default, { message: specialTeamsErrorMessage })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)('col s1 m1', _ModifyStudent2.default.removePadding) },
	                        _react2.default.createElement(
	                          'button',
	                          {
	                            className: _ModifyStudent2.default.removeButton,
	                            onClick: function onClick() {
	                              return _this4.removeSecondaryPosition('special_teams');
	                            }
	                          },
	                          _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/redCross.png', alt: 'remove' })
	                        )
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _ModifyStudent2.default.fullWidth },
	                  _react2.default.createElement(
	                    'div',
	                    { className: t40ErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      '40-YARD DASH'
	                    ),
	                    _react2.default.createElement(_autocomplete2.default, {
	                      source: this.state.t40 === '' ? emptyObject : t40Suggestions,
	                      multiple: false,
	                      allowCreate: true,
	                      selectedPosition: 'up',
	                      direction: 'up',
	                      value: this.state.t40,
	                      onChange: function onChange(val) {
	                        return _this4.handleChange('t40', val);
	                      },
	                      onQueryChange: function onQueryChange(val) {
	                        return _this4.handleQueryChangeT40(val);
	                      }
	                      /* onQueryChange={() => this.handleQueryChange('t40')} */
	                      , onFocus: function onFocus() {
	                        return _this4.removeErrorMessage('t40ErrorMessage');
	                      },
	                      theme: _theme2.default
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: t40ErrorMessage })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: squatsErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'SQUATS MAXIMUM'
	                    ),
	                    _react2.default.createElement(_autocomplete2.default, {
	                      source: this.state.squats === '' ? emptyObject : squatsSuggestions,
	                      allowCreate: true,
	                      multiple: false,
	                      value: this.state.squats,
	                      selectedPosition: 'up',
	                      direction: 'up',
	                      onChange: function onChange(val) {
	                        return _this4.handleChange('squats', val);
	                      },
	                      onQueryChange: function onQueryChange(val) {
	                        return _this4.handleChange('squats', val);
	                      },
	                      theme: _theme2.default
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: squatsErrorMessage })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.fullWidth) },
	                  _react2.default.createElement(
	                    'div',
	                    { className: benchErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthWithSpanError) },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      'BENCH MAXIMUM'
	                    ),
	                    _react2.default.createElement(_autocomplete2.default, {
	                      source: this.state.bench === '' ? emptyObject : benchSuggestions,
	                      value: this.state.bench,
	                      multiple: false,
	                      allowCreate: true,
	                      selectedPosition: 'up',
	                      direction: 'up',
	                      onChange: function onChange(val) {
	                        return _this4.handleChange('bench', val);
	                      },
	                      onQueryChange: function onQueryChange(val) {
	                        return _this4.handleChange('bench', val);
	                      },
	                      theme: _theme2.default,
	                      onFocus: function onFocus() {
	                        return _this4.removeErrorMessage('benchErrorMessage');
	                      }
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: benchErrorMessage })
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: _ModifyStudent2.default.space }),
	          _react2.default.createElement(
	            'xx',
	            { className: _ModifyStudent2.default.academicInfo },
	            'Academic info'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.removePadding) },
	            _react2.default.createElement(
	              'div',
	              { className: _ModifyStudent2.default.inputContainer },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m10', _ModifyStudent2.default.removeLeftPadding) },
	                _react2.default.createElement(
	                  'div',
	                  { className: schoolErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoCompleteError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'HIGH SCHOOL'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _ModifyStudent2.default.autoCompleteContainer },
	                    _react2.default.createElement(_reactAutocomplete2.default, {
	                      menuStyle: autostyle,
	                      inputProps: { name: 'School', id: 'schools-autocomplete' },
	                      ref: 'schools-autocomplete' // eslint-disable-line
	                      , value: this.state.school,
	                      items: this.state.schoolNames,
	                      getItemValue: function getItemValue(item) {
	                        return item.value;
	                      },
	                      onFocus: function onFocus() {
	                        return _this4.removeErrorMessage('schoolErrorMessage');
	                      },
	                      onSelect: function onSelect(school, item) {
	                        // set the menu to only the selected item
	                        _this4.setState({ school: item.value });
	                        // or you could reset it to a default list again
	                        // this.setState({ unitedStates: getStates() })
	                      },
	                      onChange: function onChange(event, value) {
	                        if (_this4.timer) {
	                          clearTimeout(_this4.timer);
	                        }
	
	                        _this4.setState(Object.assign({}, _this4.state, { school: value, schoolErrorMessage: '' }));
	
	                        if (value && value.length >= 3) {
	                          _this4.timer = setTimeout(function () {
	                            _this4.props.searchSchools(value);
	                          }, 100);
	                        }
	                      },
	                      renderItem: function renderItem(item) {
	                        return _react2.default.createElement(
	                          'div',
	                          {
	                            key: item.key,
	                            id: item.key
	                          },
	                          item.value
	                        );
	                      }
	                    }),
	                    _react2.default.createElement(_ErrorMessage2.default, { message: schoolErrorMessage })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: yearOfPassingErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoCompleteError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'GRADUATION YEAR'
	                  ),
	                  _react2.default.createElement(_input2.default, {
	                    type: 'text',
	                    name: 'city',
	                    value: this.state.yearOfPassing,
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('yearOfPassing', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('yearOfPassingErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: yearOfPassingErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: gpaErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoCompleteError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'GPA'
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: this.state.gpa === '' ? emptyObject : gpaSuggestions,
	                    value: this.state.gpa,
	                    multiple: false,
	                    allowCreate: true,
	                    selectedPosition: 'up',
	                    direction: 'down',
	                    onQueryChange: function onQueryChange(val) {
	                      return _this4.handleChange('gpa', val);
	                    },
	                    theme: _theme2.default,
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('gpa', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('gpaErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: gpaErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: satErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoCompleteError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'SAT',
	                    _react2.default.createElement(
	                      'spann',
	                      { className: _ModifyStudent2.default.optionalTag },
	                      '\xA0\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: this.state.sat === '' ? emptyObject : satSuggestions,
	                    value: this.state.sat,
	                    multiple: false,
	                    allowCreate: true,
	                    selectedPosition: 'up',
	                    direction: 'down',
	                    onQueryChange: function onQueryChange(val) {
	                      return _this4.handleChange('sat', val);
	                    },
	                    theme: _theme2.default,
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('sat', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('satErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: satErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: actErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ModifyStudent2.default.halfWidthAutoCompleteError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'ACT',
	                    _react2.default.createElement(
	                      'spann',
	                      { className: _ModifyStudent2.default.optionalTag },
	                      '\xA0\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: this.state.act === '' ? emptyObject : _DropdownsValues.actSuggestions,
	                    value: this.state.act,
	                    multiple: false,
	                    allowCreate: true,
	                    selectedPosition: 'up',
	                    direction: 'down',
	                    onQueryChange: function onQueryChange(val) {
	                      return _this4.handleChange('act', val);
	                    },
	                    theme: _theme2.default,
	                    onChange: function onChange(val) {
	                      return _this4.handleChange('act', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this4.removeErrorMessage('actErrorMessage');
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: actErrorMessage })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: (0, _classnames2.default)('col s12', _ModifyStudent2.default.space) }),
	          _react2.default.createElement(
	            _button2.default,
	            { className: _ModifyStudent2.default.continue, onClick: this.validateInput },
	            'UPDATE PROFILE'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModifyProfile;
	}(_react2.default.Component);
	
	ModifyProfile.propTypes = {
	  getSAProfile: _propTypes2.default.func,
	  saveSAProfile: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape(),
	  profile: _propTypes2.default.shape(),
	  saRequested: _propTypes2.default.bool,
	  updateRequested: _propTypes2.default.bool,
	  redirect: _propTypes2.default.bool,
	  history: _propTypes2.default.shape(),
	  searchSchools: _propTypes2.default.func,
	  schools: _propTypes2.default.shape()
	};
	ModifyProfile.defaultProps = {
	  getSAProfile: function getSAProfile() {},
	  saveSAProfile: function saveSAProfile() {},
	  attributes: {},
	  profile: {},
	  saRequested: true,
	  updateRequested: false,
	  searchSchools: function searchSchools() {},
	  redirect: false,
	  push: _propTypes2.default.func.isRequired,
	  history: {
	    push: function push() {}
	  },
	  schools: {}
	};
	exports.default = ModifyProfile;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ModifyStudent = __webpack_require__(1160);
	
	var _ModifyStudent2 = _interopRequireDefault(_ModifyStudent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ModifyStudent2.default;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MyrbDescription = __webpack_require__(1502);
	
	var _MyrbDescription2 = _interopRequireDefault(_MyrbDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var MyrbDescription = function MyrbDescription() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _MyrbDescription2.default.descContainer) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _MyrbDescription2.default.descriptionBox) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _MyrbDescription2.default.descHeader) },
	        'MyRecruitBoard'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _MyrbDescription2.default.descriptionText) },
	        _react2.default.createElement(
	          'span',
	          { className: _MyrbDescription2.default.eyeCaching },
	          'The Only Network Built Exclusively on Innovative, Scientific, and Data Focused Recruiting'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your biometric measurables and academic standings are analyzed by our scientific algorithm to maximize your fit and exposure to colleges in your state and across the nation. 90% of our newly upgraded members are contacted by college coaches within 48 hours.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12') },
	      _react2.default.createElement('img', { className: _MyrbDescription2.default.descImage, alt: 'Description', src: 'https://media.dev.myrecruitboard.com/Images/currentFootball.png' })
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = MyrbDescription;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _MyrbLogo = __webpack_require__(1503);
	
	var _MyrbLogo2 = _interopRequireDefault(_MyrbLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to use global class name eg. classes from grid.css in public folder
	var MyrbLogo = function MyrbLogo() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12') },
	    _react2.default.createElement(
	      _reactRouterDom.Link,
	      { to: '/' },
	      _react2.default.createElement('img', { className: (0, _classnames2.default)('col s12', _MyrbLogo2.default.rblogo), src: 'https://media.dev.myrecruitboard.com/Images/logo_footer.png', alt: 'logo' })
	    )
	  );
	}; //  to change path from inside or to alter react-router-dom path
	exports.default = MyrbLogo;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Myths = __webpack_require__(1504);
	
	var _Myths2 = _interopRequireDefault(_Myths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Myths = function Myths() {
	      return _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row') },
	            _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _Myths2.default.sportsWeSupport) },
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.bigHeader },
	                        'COLLEGE FOOTBALL RECRUITING MYTHS:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'I Don\'t Need A Recruiting Service. I\'m Already Getting Emails or Mail From a College Coach.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'Every season college football programs will send out 10,000 to 20,000 letters to future prospects. College coaches and Graduate Assistants will watch 2,000 to 5,000 videos. They\'ll call 200 to 1,000 football players they want to recruit. Next, college coaches will "Verbally Offer" 50 to 200 players a scholarship. Then, college coaches extend up to 80 players a paid "Official Campus Visit". Finally, a college football team will only sign 25 players. This is why it\'s important to start early! Once a coach fulfills his need at your position they\'re done looking in your class.',
	                        _react2.default.createElement('br', null),
	                        ' ',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                              'span',
	                              { className: _Myths2.default.darkHeaderSmall },
	                              'College Football Recruiting Filter:'
	                        ),
	                        _react2.default.createElement('br', null),
	                        '20,000 Football Recruits',
	                        _react2.default.createElement('br', null),
	                        '5,000 Football Recruiting Videos',
	                        _react2.default.createElement('br', null),
	                        '1,000 Phone Calls',
	                        _react2.default.createElement('br', null),
	                        '200 Verbal Offers',
	                        _react2.default.createElement('br', null),
	                        '80 Paid Campus Visits',
	                        _react2.default.createElement('br', null),
	                        '25 Football Scholarships',
	                        _react2.default.createElement('br', null)
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'I Can Wait Until My Senior Year To Start The RecruitIng Process.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'One of the worst mistakes you can make is starting the recruiting process during your senior year. Most college coaches want to build relationships with future prospects as early as their freshman year or even in middle school. The earlier you join MyRecruitBoard the more offers you\'ll receive. The ultimate goal of starting the recruiting process early is to get the most scholarship money possible to pay for college. Starting your recruitment during your senior year doesn\'t mean you won\'t get recruited it only means you will have to work smarter & harder. We can solve your late recruitment needs with our scientific recruiting tools.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'My Coach Will Get Me A Scholarship. I Play On The Best Team In My State.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'Coaches can or cannot be part of your recruiting process. We\'ve helped football players every year who\'s high school coach had no idea they were being recruited. Sadly, there are coaches who don\'t care to help every player on their team get recruited. One of the problems with playing on a Power-House high school team is a college coaches doesn\'t know how good you are versus how well coached your team is. Don\'t expect anyone to care more about your dream to play college football than you. Your coach\u2019s paid job is to coach your football team not to personally find you an athletic scholarship. We have more connections and resources than your high school coach period, hands down! We are a nationally recognized football recruiting service. College coaches use us because were not partial or biased like many high school coaches who want to say "I coached that kid". We connect you with college football teams that are a good fit for you. Your high school coach doesn\'t have the time or resources that we have to help every player with their specific recruiting needs. You and your parents have to take ownership of your college football recruiting process.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'Football Recruiting is Expensive & My Coach Said I Don\'t Need It.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'We know Private Coaches, Trainers, Camps, and 7on7 teams are important for you to reach your full potential, but none of these can guarantee you will get recruited. College coaches use their own football camps and clinics to evaluate players. For the thousands of players they can\'t see in person college coaches use trusted recruiting services like MyRecruitBoard. Don\u2019t be fooled into thinking if you spend lots of money on a private exposure camp or combine you will be recruited. We only advise attending college football camps for recruiting exposure.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'A College Coach Will Contact Me First.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'One of the biggest mistakes football players do in the college recruiting process is believing a college coach will find you. College Coaches will not find you, you have to be seen or shown to them. Every year very talent players go under-recruited or not recruited at all. Playing hard and posting film on Hudl doesn\'t mean a coach will recruit you. Unless you are one of the top 500 football players in America, you will most likely be unnoticed or lost in the college football recruiting filter by college coaches.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'I Don\'t Need a Video Because My Coach or Someone I Know Has Connections.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'Most college coaches can\'t afford to attend any games of the player they are recruiting. Moreover, if a college coach is talking to your coach he\'s most likely talking to every other coach in your team\'s conference not just your head coach. Use MyRecruitBoard to get your video seen by every college in America you match. ',
	                        _react2.default.createElement('br', null),
	                        'Here are some video tips:',
	                        _react2.default.createElement('br', null),
	                        'Best Highlights 1st - Show your best plays first!',
	                        _react2.default.createElement('br', null),
	                        'Keep it Short \u2013 Two-three minutes maximum!',
	                        _react2.default.createElement('br', null),
	                        'Video Quality - Only use high quality footage!',
	                        _react2.default.createElement('br', null)
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'College Coaches Don\'t Want To Be Contacted First.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'College coaches love and get excited when they are contacted by a good fit for their program first. Many players look down upon certain levels of play or won\'t return a message to a coach at certain colleges. We highly advise you to always reply to a college coach proptly. Always remember until you sign a National Letter of Intent nothing is certain!'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'I Need A Full Football Scholarship.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'Only NCAA D1 FBS football programs are required to give full football scholarships. NCAA D1 FCS, NCAA Division II, NAIA and Junior colleges offer partial scholarships typically ranging from 25% to 75%. 100% scholarships at these levels are very competitive. NCAA Division III schools don\'t offer football scholarships, but they do offer very competitive academic scholarships. Being a good fit academically as well as a football player will get you lots of scholarship money in NCAA D3. Many times more than any other level of play for most football players. The number one reason to join MyRecruitBoard is to get the most scholarship funds possible to pay for the high cost of college.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'MYTH:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'I\'m a Good Football Player and I Have The Size, Speed, & Body Type.'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.darkHeader },
	                        'FACT:'
	                  ),
	                  _react2.default.createElement(
	                        'div',
	                        { className: _Myths2.default.desc },
	                        'There are thousands of football players every year who don\'t get recruited or go under-recruited because they didn\'t use MyRecruitBoard. Likewise, there are thousands of football players every year who don\'t get recruited because they have severely limited their college football choices. Please remember just because you\'re good doesn\'t mean a college coach can\'t find a player like yourself somewhere else in the country. College football coaches have very limited football recruiting budgets. They won\'t travel around the country looking for you. Coaches use MyRecruitBoard and trust the prospects we present to them. If you wait to get recruited it may never happen, even if you are the Man! Juniors and seniors if you aren\'t being recruited or you are under-recruited you need to join MyRecruitBoard ASAP! If you don\'t you risk losing thousands of dollars in college scholarship money.'
	                  )
	            )
	      );
	};
	
	exports.default = Myths;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Myths = __webpack_require__(1164);
	
	var _Myths2 = _interopRequireDefault(_Myths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Myths2.default;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navigation = __webpack_require__(197);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _NavOnScroll = __webpack_require__(1505);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var NavOnScroll = function NavOnScroll(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _NavOnScroll2.default.container },
	    _react2.default.createElement(_Navigation2.default, props)
	  );
	};
	
	exports.default = NavOnScroll;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _AccountDropdown = __webpack_require__(444);
	
	var _AccountDropdown2 = _interopRequireDefault(_AccountDropdown);
	
	var _AccountDropDownReplica = __webpack_require__(1083);
	
	var _AccountDropDownReplica2 = _interopRequireDefault(_AccountDropDownReplica);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _reactPortalTooltip = __webpack_require__(240);
	
	var _reactPortalTooltip2 = _interopRequireDefault(_reactPortalTooltip);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UserNavbar = __webpack_require__(1506);
	
	var _UserNavbar2 = _interopRequireDefault(_UserNavbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	//  to change path from inside or to alter react-router-dom path
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	var UserNavbar = function (_Component) {
	  _inherits(UserNavbar, _Component);
	
	  function UserNavbar(props) {
	    _classCallCheck(this, UserNavbar);
	
	    var _this = _possibleConstructorReturn(this, (UserNavbar.__proto__ || Object.getPrototypeOf(UserNavbar)).call(this, props));
	
	    _this.state = {
	      profileIcon: '',
	      isTooltipActive: false
	    };
	    _this.showTooltip = _this.showTooltip.bind(_this);
	    _this.hideTooltip = _this.hideTooltip.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserNavbar, [{
	    key: 'showTooltip',
	    value: function showTooltip() {
	      this.setState({ isTooltipActive: true });
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      this.setState({ isTooltipActive: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var match = this.props.match;
	
	      var renderDropDownInSmall = false;
	      if (window.innerWidth < 700) {
	        renderDropDownInSmall = true;
	      }
	      var renderDropDownInSmallScreen = (0, _renderIf2.default)(renderDropDownInSmall);
	      var renderDropDownInBigScreen = (0, _renderIf2.default)(!renderDropDownInSmall);
	      var renderCoachItems = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'COACH');
	      var renderAthleteItems = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'STUDENT');
	      var renderAdminItems = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'ADMIN');
	      var renderHeaderonDashboard = (0, _renderIf2.default)(this.props.headerOnDashboard);
	      var renderHeaderonProfilePage = (0, _renderIf2.default)(this.props.usedFor === 'profile_page');
	      var dashboardOnSettings = (0, _renderIf2.default)(this.props.usedFor === 'settingsAthlete');
	      var renderDropDown = (0, _renderIf2.default)(this.props.attributes.size > 0 && match.params.id === undefined);
	      var renderPublicNavLinks = (0, _renderIf2.default)(this.props.attributes.size === 0 || match.params.id !== undefined);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _UserNavbar2.default.container) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4', _UserNavbar2.default.navBarLogo) },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' },
	              _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/logo%402x.png', alt: 'logo' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s8', _UserNavbar2.default.navBarLinks) },
	          renderPublicNavLinks(_react2.default.createElement(
	            'span',
	            { className: _UserNavbar2.default.displayInline },
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'HOME'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/about' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'ABOUT'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/sports' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'SPORTS'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/contact' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'CONTACT'
	              )
	            )
	          )),
	          renderPublicNavLinks(_react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'xx',
	              {
	                id: 'smallMenu',
	                onMouseEnter: this.showTooltip,
	                onMouseLeave: this.hideTooltip,
	                onClick: this.showTooltip,
	                className: _UserNavbar2.default.dropdownIconPublic,
	                src: this.state.profileIcon !== '' ? 'https://s3.amazonaws.com/myrbimagesdev/' + this.state.profileIcon : 'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	                alt: 'icon'
	              },
	              'MENU'
	            ),
	            _react2.default.createElement(
	              _reactPortalTooltip2.default,
	              { active: this.state.isTooltipActive, position: 'bottom', arrow: 'right', parent: '#smallMenu' },
	              _react2.default.createElement(
	                'div',
	                { className: _UserNavbar2.default.dropdownContainer },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: '/' },
	                    _react2.default.createElement(
	                      'button',
	                      null,
	                      'HOME'
	                    )
	                  ),
	                  _react2.default.createElement(_Divider2.default, null),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: '/about' },
	                    _react2.default.createElement(
	                      'button',
	                      null,
	                      'ABOUT'
	                    )
	                  ),
	                  _react2.default.createElement(_Divider2.default, null),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: '/sports' },
	                    _react2.default.createElement(
	                      'button',
	                      null,
	                      'SPORTS'
	                    )
	                  ),
	                  _react2.default.createElement(_Divider2.default, null),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: '/contact' },
	                    _react2.default.createElement(
	                      'button',
	                      null,
	                      'CONTACT'
	                    )
	                  )
	                )
	              )
	            )
	          )),
	          renderDropDown(_react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/', className: _UserNavbar2.default.displayInline },
	              _react2.default.createElement(
	                'button',
	                null,
	                'HOME'
	              )
	            ),
	            renderHeaderonDashboard(_react2.default.createElement(
	              'div',
	              { className: _UserNavbar2.default.displayInline },
	              renderAthleteItems(_react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/view/athlete' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'PROFILE'
	                )
	              )),
	              dashboardOnSettings(_react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/dashboard' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'DASHBOARD'
	                )
	              ))
	            )),
	            renderHeaderonProfilePage(_react2.default.createElement(
	              'div',
	              { className: _UserNavbar2.default.displayInline },
	              renderAthleteItems(_react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/dashboard' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'DASHBOARD'
	                )
	              )),
	              renderAdminItems(_react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/dashboard' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'DASHBOARD'
	                )
	              )),
	              renderCoachItems(_react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/settings' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'SETTINGS'
	                )
	              ))
	            )),
	            renderDropDown(_react2.default.createElement(
	              'a',
	              { className: _UserNavbar2.default.dropdown },
	              renderDropDownInBigScreen(_react2.default.createElement(_AccountDropdown2.default, Object.assign({}, this.props, {
	                dropDownWithUser: this.props.headerOnDashboard
	              }))),
	              renderDropDownInSmallScreen(_react2.default.createElement(_AccountDropDownReplica2.default, Object.assign({}, this.props, {
	                dropDownWithUser: this.props.headerOnDashboard
	              })))
	            ))
	          ))
	        )
	      );
	    }
	  }]);
	
	  return UserNavbar;
	}(_react.Component);
	
	UserNavbar.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  headerOnDashboard: _propTypes2.default.bool,
	  usedFor: _propTypes2.default.string,
	  match: _propTypes2.default.shape.isRequired
	};
	UserNavbar.defaultProps = {
	  attributes: {},
	  headerOnDashboard: false,
	  usedFor: ''
	};
	exports.default = UserNavbar;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _ramda = __webpack_require__(167);
	
	var _immutable = __webpack_require__(11);
	
	var _AccountDropdown = __webpack_require__(444);
	
	var _AccountDropdown2 = _interopRequireDefault(_AccountDropdown);
	
	var _MenuDrawer = __webpack_require__(1156);
	
	var _MenuDrawer2 = _interopRequireDefault(_MenuDrawer);
	
	var _Navigation = __webpack_require__(1507);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  to change path from inside or to alter react-router-dom path
	// to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// use of immutablejs for various js operations to simplify our work
	
	
	// to import local scss fle
	
	var NavBar = function (_Component) {
	  _inherits(NavBar, _Component);
	
	  _createClass(NavBar, null, [{
	    key: 'isEmpty',
	    value: function isEmpty(val) {
	      if (val) {
	        return false;
	      }
	      return true;
	    }
	  }]);
	
	  function NavBar(props) {
	    _classCallCheck(this, NavBar);
	
	    var _this = _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).call(this, props));
	
	    _this.state = {
	      showMenu: false
	    };
	    return _this;
	  }
	
	  _createClass(NavBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$user = _props.user,
	          user = _props$user === undefined ? (0, _immutable.Map)() : _props$user,
	          location = _props.location;
	
	      var username = user.username;
	      var renderLoggedOutLinks = (0, _renderIf2.default)(NavBar.isEmpty(username));
	      var renderLoggedInLinks = (0, _renderIf2.default)((0, _ramda.not)(NavBar.isEmpty(username)));
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Navigation2.default.navigationContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Navigation2.default.links) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s6 m4', _Navigation2.default.logo) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Navigation2.default.logoContainer) },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/' },
	                  _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/logo%402x.png', alt: 'logo' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s6 m8', _Navigation2.default.navigationLinks) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Navigation2.default.simpleNav) },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: location.pathname === '/' ? _Navigation2.default.darkNavigation : '' },
	                    'HOME'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/about' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: location.pathname === '/about' ? _Navigation2.default.darkNavigation : '' },
	                    'ABOUT'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/sports' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: location.pathname === '/sports' ? _Navigation2.default.darkNavigation : '' },
	                    'WHY'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/terms_and_use' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: location.pathname === '/terms_and_use' ? _Navigation2.default.darkNavigation : '' },
	                    'TERMS OF USE'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/pricing' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: location.pathname === '/pricing' ? _Navigation2.default.darkNavigation : '' },
	                    'PRICING'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/contact' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: location.pathname === '/contact' ? _Navigation2.default.darkNavigation : '' },
	                    'CONTACT'
	                  )
	                ),
	                renderLoggedOutLinks(
	                // eslint-disable-next-line
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '', className: this.props.profileBanner === true ? _Navigation2.default.hidden : '' },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: '/login' },
	                    _react2.default.createElement(
	                      'button',
	                      null,
	                      'SIGN IN'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: '/register' },
	                    _react2.default.createElement(_button2.default, { label: 'JOIN US', className: _Navigation2.default.learnMoreNav })
	                  )
	                )),
	                renderLoggedInLinks(_react2.default.createElement(
	                  'a',
	                  { className: _Navigation2.default.dropdownBox },
	                  _react2.default.createElement(_AccountDropdown2.default, this.props)
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Navigation2.default.menuInSmall) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _Navigation2.default.menu) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_MenuDrawer2.default, this.props)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavBar;
	}(_react.Component);
	
	NavBar.propTypes = {
	  user: _propTypes2.default.shape(),
	  profileBanner: _propTypes2.default.bool.isRequired,
	  location: _propTypes2.default.shape().isRequired
	};
	NavBar.defaultProps = {
	  user: {},
	  profileBanner: false,
	  logoutUser: function logoutUser() {}
	};
	exports.default = NavBar;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _OurResultsData = __webpack_require__(1508);
	
	var _OurResultsData2 = _interopRequireDefault(_OurResultsData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	
	var OurResultsData = function OurResultsData() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _OurResultsData2.default.container) },
	    _react2.default.createElement(
	      'div',
	      { className: ('col s12', _OurResultsData2.default.textContainer) },
	      _react2.default.createElement(
	        'span',
	        { className: _OurResultsData2.default.header },
	        'OUR RESULTS'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: _OurResultsData2.default.desc },
	        'Our goal is to make college sports recruiting more accessible through technology. To do so, we made it simple, but faster and more personal with greater exposure. MyRecruitBoard represents a new season in the relationship coaches and student athletes have with technology. It\u2019s the most personalized college recruiting service ever developed, because it\u2019s the first one designed to be truly interactive. You will receive up to the minute notifications for all your favorite users and can send messages more easily and intuitively. Connections are in your hands, not controlled by a third party evaluator. The people who know you best: coaches, counselors, and teachers, evaluate your talent so that college coaches can determine if you are the best fit for their program. With MyRecruitBoard every interaction is NOT about feeding you a sales pitch but IS about making a genuine connection...'
	      )
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = OurResultsData;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OurResultsData = __webpack_require__(1169);
	
	var _OurResultsData2 = _interopRequireDefault(_OurResultsData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _OurResultsData2.default;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(1509);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	// import PlanModel from 'components/PlanModel';
	//  to change path from inside or to alter react-router-dom path
	
	
	// to import local scss fle
	
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List(props) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));
	
	    _this.state = {
	      paymentStatus: false
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var payment = window.sessionStorage.getItem('kiro');
	      if (payment === 'true') {
	        this.setState({ paymentStatus: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderAlreadyPaidButton = (0, _renderIf2.default)(this.state.paymentStatus);
	      var renderRedirectButton = (0, _renderIf2.default)(!this.props.attributes.size > 0);
	      var renderPaymentButton = (0, _renderIf2.default)(this.props.attributes.size > 0 && !this.state.paymentStatus);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _List2.default.container) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _List2.default.listContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _List2.default.benefitContainer) },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'h6',
	                null,
	                'MONTHLY SUBSCRIPTION'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Premium members get national exposure to every college that matches your academics and biometrics. Upgrade today!'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _List2.default.buynow) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m8', _List2.default.buynowContainer) },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { className: _List2.default.priceValue },
	                  'MONTHLY PAYMENT OF ',
	                  _react2.default.createElement('br', null),
	                  '$14.99'
	                ),
	                _react2.default.createElement('br', null)
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m4', _List2.default.buynowContainer) },
	              _react2.default.createElement(
	                'span',
	                null,
	                renderAlreadyPaidButton(_react2.default.createElement(
	                  'button',
	                  null,
	                  'Already Paid!'
	                )),
	                renderPaymentButton(_react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/checkout?plan=monthlySubscription&once=true' },
	                  _react2.default.createElement(
	                    'button',
	                    null,
	                    'BUY NOW'
	                  )
	                )),
	                renderRedirectButton(_react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/register' },
	                  _react2.default.createElement(
	                    'button',
	                    null,
	                    'BUY NOW'
	                  )
	                ))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.propTypes = {
	  attributes: _propTypes2.default.shape().isRequired
	};
	exports.default = List;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(1171);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List2.default;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _immutable = __webpack_require__(11);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ParentInfo = __webpack_require__(1510);
	
	var _ParentInfo2 = _interopRequireDefault(_ParentInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use input from react-toolbox library
	// to display error messages on invalid user input
	// regular expressions to validate user input
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// use of immutablejs for various js operations to simplify our work
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var ParentInfo = function (_React$Component) {
	  _inherits(ParentInfo, _React$Component);
	
	  function ParentInfo(props) {
	    _classCallCheck(this, ParentInfo);
	
	    var _this = _possibleConstructorReturn(this, (ParentInfo.__proto__ || Object.getPrototypeOf(ParentInfo)).call(this, props));
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value)));
	    };
	
	    _this.removeErrorMessage = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, '')));
	    };
	
	    _this.state = {
	      gender: 'male',
	      fullname: '',
	      validFullName: false,
	      fullNameErrorMessage: '',
	      mobileErrorMessage: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.goToNextTab = _this.goToNextTab.bind(_this);
	    _this.removeErrorMessage = _this.removeErrorMessage.bind(_this);
	    _this.handleQueryChange = _this.handleQueryChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(ParentInfo, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _immutable.is)(nextProps.attributes, this.props.attributes)) {
	        this.setState({ fullname: nextProps.attributes.get('name') });
	      }
	
	      var _props$profile = this.props.profile,
	          profile = _props$profile === undefined ? (0, _immutable.Map)() : _props$profile;
	
	      if (nextProps.profile.size > 0 && !(0, _immutable.is)(profile, nextProps.profile)) {
	        var newState = {
	          gender: nextProps.profile.get('gender'),
	          fullname: nextProps.profile.get('fullname'),
	          state: nextProps.profile.get('sa_state'),
	          city: nextProps.profile.get('city')
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'goToNextTab',
	    value: function goToNextTab() {
	      var fullname = this.state.fullname;
	
	
	      var validFullName = false;
	      /* validation for Full Name */
	      var enteredFullName = _Regularexpression.regExForName.test(fullname);
	      if (enteredFullName && fullname !== '') {
	        validFullName = true;
	      } else {
	        this.setState({ fullNameErrorMessage: 'Please enter a valid name.' });
	      }
	      /* validation for Full Name */
	      if (validFullName) {
	        this.props.next(this.state);
	      }
	    }
	  }, {
	    key: 'handleQueryChange',
	    value: function handleQueryChange(val) {
	      if (!val && val.length === 0) {
	        this.handleChange('state', '');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          fullNameErrorMessage = _state.fullNameErrorMessage,
	          mobileErrorMessage = _state.mobileErrorMessage;
	
	      var renderIfShow = (0, _renderIf2.default)(this.props.show);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderIfShow(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _ParentInfo2.default.personalInfoContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _ParentInfo2.default.fullWidth) },
	            _react2.default.createElement(
	              'div',
	              { className: fullNameErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ParentInfo2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _ParentInfo2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'FULL NAME'
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'full_name',
	                value: this.state.fullname,
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('fullNameErrorMessage');
	                },
	                onChange: function onChange(val) {
	                  return _this2.handleChange('fullname', val);
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.fullNameErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: mobileErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _ParentInfo2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _ParentInfo2.default.halfWidthAutoCompleteError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'EMAIL'
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'city',
	                value: this.props.attributes.get('email'),
	                disabled: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _ParentInfo2.default.buttonContainer) },
	            _react2.default.createElement(_button2.default, { label: 'CONTINUE', raised: true, className: _ParentInfo2.default.continue, onClick: function onClick() {
	                return _this2.goToNextTab();
	              } })
	          )
	        ))
	      );
	    }
	  }]);
	
	  return ParentInfo;
	}(_react2.default.Component);
	
	ParentInfo.propTypes = {
	  next: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool.isRequired,
	  profile: _propTypes2.default.instanceOf(_immutable.Map),
	  attributes: _propTypes2.default.shape()
	};
	ParentInfo.defaultProps = {
	  next: function next() {},
	  show: true,
	  profile: (0, _immutable.Map)(),
	  attributes: function attributes() {}
	};
	exports.default = ParentInfo;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ParentInfo = __webpack_require__(1173);
	
	var _ParentInfo2 = _interopRequireDefault(_ParentInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ParentInfo2.default;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Password = __webpack_require__(1511);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	// to change path from inside or to alter react-router-dom path
	var Password = function Password(props) {
	  var handleOnChange = function handleOnChange(e) {
	    props.onChange(e);
	  };
	  var renderForgotPassword = (0, _renderIf2.default)(props.addForgotPassword);
	  var renderError = (0, _renderIf2.default)(props.errorMessage);
	  return _react2.default.createElement(
	    'div',
	    { className: props.errorMessage === '' ? (0, _classnames2.default)('row', _Password2.default.passwordContainer) : (0, _classnames2.default)('row', _Password2.default.passwordContainerOnError) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Password2.default.labelsContainer) },
	      _react2.default.createElement(
	        'label',
	        { className: _Password2.default.label, htmlFor: 'PASSWORD' },
	        'PASSWORD'
	      ),
	      renderForgotPassword(_react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/forgot', tabIndex: '-1' },
	        _react2.default.createElement(
	          'label',
	          { tabIndex: '-1', htmlFor: 'FORGOT PASSWORD?', className: _Password2.default.forgotPassword },
	          'Forgot Password?'
	        )
	      ))
	    ),
	    _react2.default.createElement(_input2.default, {
	      className: (0, _classnames2.default)('col s12', _Password2.default.input),
	      type: 'Password',
	      onChange: handleOnChange,
	      onKeyPress: props.onKeyPress,
	      onFocus: props.onFocus
	    }),
	    renderError(_react2.default.createElement(_ErrorMessage2.default, { message: props.errorMessage }))
	  );
	}; // to display error messages on invalid user input
	// to use input from react-toolbox library
	// to use global class name eg. classes from grid.css in public folder
	
	
	Password.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  addForgotPassword: _propTypes2.default.isRequired,
	  errorMessage: _propTypes2.default.string.isRequired,
	  onKeyPress: _propTypes2.default.func.isRequired,
	  onFocus: _propTypes2.default.func
	};
	
	Password.defaultProps = {
	  onChange: function onChange() {},
	  addForgotPassword: true,
	  errorMessage: '',
	  onFocus: function onFocus() {}
	};
	
	exports.default = Password;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _braintreeWebDropIn = __webpack_require__(1409);
	
	var _braintreeWebDropIn2 = _interopRequireDefault(_braintreeWebDropIn);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// to validate and set default props  coming to this component
	
	var Dropin = function (_Component) {
	  _inherits(Dropin, _Component);
	
	  function Dropin(props) {
	    _classCallCheck(this, Dropin);
	
	    var _this = _possibleConstructorReturn(this, (Dropin.__proto__ || Object.getPrototypeOf(Dropin)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Dropin, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var form = this.props.form;
	      var onPaymentMethodReceived = this.props.onPaymentMethodReceived;
	      _braintreeWebDropIn2.default.create({
	        authorization: this.props.clientToken,
	        container: '#dropin-container',
	        paypal: {
	          flow: 'vault'
	        }
	      }, function (err, dropinInstance) {
	        // eslint-disable-line
	        if (err) {
	          // Handle any errors that might've occurred when creating Drop-in
	          return;
	        }
	        form.addEventListener('submit', function (event) {
	          event.preventDefault();
	          dropinInstance.requestPaymentMethod(function (requestPaymentMethodError, payload) {
	            if (requestPaymentMethodError) {
	              // Handle errors in requesting payment method
	              return;
	            }
	            // Send payload.nonce to your server
	            /* nonceInput.value = payload.nonce; */
	            onPaymentMethodReceived(payload);
	          });
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { id: 'dropin-container' });
	    }
	  }]);
	
	  return Dropin;
	}(_react.Component);
	
	Dropin.propTypes = {
	  clientToken: _propTypes2.default.string,
	  form: _propTypes2.default.shape.isRequired,
	  onPaymentMethodReceived: _propTypes2.default.func
	};
	Dropin.defaultProps = {
	  clientToken: '',
	  onPaymentMethodReceived: function onPaymentMethodReceived() {}
	};
	exports.default = Dropin;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dropin = __webpack_require__(1176);
	
	var _Dropin2 = _interopRequireDefault(_Dropin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dropin2.default;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _immutable = __webpack_require__(11);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PersonalInfo = __webpack_require__(1512);
	
	var _PersonalInfo2 = _interopRequireDefault(_PersonalInfo);
	
	var _theme = __webpack_require__(1591);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use input from react-toolbox library
	// to display error messages on invalid user input
	// regular expressions to validate user input
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// use of immutablejs for various js operations to simplify our work
	// to use global class name eg. classes from grid.css in public folder
	// to import local scss fle
	
	
	var emptyObject = {};
	
	var state = {
	  AL: 'Alabama',
	  AK: 'Alaska',
	  AZ: 'Arizona',
	  AR: 'Arkansas',
	  CA: 'California',
	  CO: 'Colorado',
	  CT: 'Connecticut',
	  DE: 'Delaware',
	  FL: 'Florida',
	  GA: 'Georgia',
	  HI: 'Hawaii',
	  ID: 'Idaho',
	  IL: 'Illinois',
	  IN: 'Indiana',
	  IA: 'Iowa',
	  KS: 'Kansas',
	  KY: 'Kentucky',
	  LA: 'Louisiana',
	  ME: 'Maine',
	  MD: 'Maryland',
	  MA: 'Massachusetts',
	  MI: 'Michigan',
	  MN: 'Minnesota',
	  MS: 'Mississippi',
	  MO: 'Missouri',
	  MT: 'Montana',
	  NE: 'Nebraska',
	  NV: 'Nevada',
	  NH: 'New Hampshire',
	  NJ: 'New Jersey',
	  NM: 'New Mexico',
	  NY: 'New York',
	  NC: 'North Carolina',
	  ND: 'North Dakota',
	  OH: 'Ohio',
	  OK: 'Oklahoma',
	  OR: 'Oregon',
	  PA: 'Pennsylvania',
	  RI: 'Rhode Island',
	  SC: 'South Carolina',
	  SD: 'South Dakota',
	  TN: 'Tennessee',
	  TX: 'Texas',
	  UT: 'Utah',
	  VT: 'Vermont',
	  VA: 'Virginia',
	  WA: 'Washington D.C',
	  WN: 'Washington',
	  WV: 'West Virginia',
	  WI: 'Wisconsin',
	  WY: 'Wyoming'
	};
	
	var PersonalInfo = function (_React$Component) {
	  _inherits(PersonalInfo, _React$Component);
	
	  function PersonalInfo(props) {
	    _classCallCheck(this, PersonalInfo);
	
	    var _this = _possibleConstructorReturn(this, (PersonalInfo.__proto__ || Object.getPrototypeOf(PersonalInfo)).call(this, props));
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value)));
	    };
	
	    _this.removeErrorMessage = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, '')));
	    };
	
	    _this.state = {
	      gender: 'male',
	      fullname: '',
	      state: '',
	      city: '',
	      mobile: '',
	      twitter: '',
	      instagram: '',
	      firstNameErrorMessage: '',
	      lastNameErrorMessage: '',
	      stateErrorMessage: '',
	      mobileErrorMessage: '',
	      cityErrorMessage: '',
	      twitterErrorMessage: '',
	      instagramErrorMessage: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.goToNextTab = _this.goToNextTab.bind(_this);
	    _this.removeErrorMessage = _this.removeErrorMessage.bind(_this);
	    _this.handleQueryChange = _this.handleQueryChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(PersonalInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.scrollTo(0, 0);
	      if (this.props.attributes.size > 0) {
	        var fullName = this.props.attributes.get('name');
	        var parts = fullName.split(' ');
	        var firstName = parts.shift();
	        var lastnamefirst = parts.shift() || '';
	        var lastNamesecond = parts.shift() || '';
	        var lastName = lastnamefirst + ' ' + lastNamesecond;
	        this.setState({ firstName: firstName, lastName: lastName });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _immutable.is)(nextProps.attributes, this.props.attributes) && nextProps.attributes.size > 0) {
	        var fullName = nextProps.attributes.get('name');
	        var parts = fullName.split(' ');
	        var firstName = parts.shift();
	        var lastnamefirst = parts.shift() || '';
	        var lastNamesecond = parts.shift() || '';
	        var lastName = lastnamefirst + ' ' + lastNamesecond;
	        this.setState({ firstName: firstName, lastName: lastName });
	      }
	
	      var _props$profile = this.props.profile,
	          profile = _props$profile === undefined ? (0, _immutable.Map)() : _props$profile;
	
	      if (nextProps.profile.size > 0 && !(0, _immutable.is)(profile, nextProps.profile)) {
	        var newState = {
	          gender: nextProps.profile.get('gender'),
	          firstName: nextProps.profile.get('firstName'),
	          lastName: nextProps.profile.get('lastName'),
	          state: nextProps.profile.get('sa_state'),
	          city: nextProps.profile.get('city')
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'goToNextTab',
	    value: function goToNextTab() {
	      var _state = this.state,
	          firstName = _state.firstName,
	          lastName = _state.lastName,
	          city = _state.city;
	
	
	      var validState = false;
	      var validCity = false;
	      var validFirstName = false;
	      var ValidLastName = false;
	      var validMobile = false;
	      // const validTwitter = false;
	      // const validInstagram = false;
	      /* validation for Full Name */
	      var enteredFirstName = typeof firstName === 'string';
	      if (enteredFirstName && firstName !== '') {
	        validFirstName = true;
	      } else {
	        this.setState({ firstNameErrorMessage: 'Please enter a valid name.' });
	      }
	      /* validation for Full Name */
	
	      /* validation for Full Name */
	      var enteredLastName = typeof lastName === 'string';
	      if (enteredLastName && lastName !== '') {
	        ValidLastName = true;
	      } else {
	        this.setState({ lastNameErrorMessage: 'Please enter a valid name.' });
	      }
	      /* validation for Full Name */
	
	      /* validation for city */
	      var enteredCity = _Regularexpression.regExForName.test(city);
	      if (enteredCity && city !== '') {
	        validCity = true;
	      } else {
	        this.setState({ cityErrorMessage: 'Please enter a valid city.' });
	      }
	      /* validation for city */
	
	      /* validation for state */
	      var enteredState = typeof this.state.state === 'string';
	      if (enteredState && this.state.state !== '') {
	        validState = true;
	      } else {
	        this.setState({ stateErrorMessage: 'Please enter a valid state.' });
	      }
	      /* validation for state */
	
	      /* Validation for mobile */
	      var enteredMobile = _Regularexpression.regExForNumber.test(this.state.mobile);
	      if (enteredMobile && this.state.mobile !== '') {
	        validMobile = true;
	      } else {
	        this.setState({ mobileErrorMessage: 'Please enter a valid mobile number.' });
	      }
	      /* Validation for mobile */
	
	      // const enteredTwitter = 'twitter.com';
	      // if (this.state.twitter === '') {
	      //   validTwitter = true;
	      // } else if (this.state.twitter.indexOf(enteredTwitter) === -1) {
	      //   this.setState({ twitterErrorMessage: 'Please enter a valid twitter link.' });
	      // } else {
	      //   validTwitter = true;
	      // }
	      //   /* Validation for mobile */
	      // const enteredInstagram = 'instagram.com';
	      // if (this.state.instagram === '') {
	      //   validInstagram = true;
	      // } else if (this.state.instagram.indexOf(enteredInstagram) === -1) {
	      //   this.setState({ instagramErrorMessage: 'Please enter a valid instagram link.' });
	      // } else {
	      //   validInstagram = true;
	      // }
	      /* Validation for mobile */
	
	      if (validFirstName && ValidLastName && validCity && validState && validMobile) {
	        this.props.next(this.state);
	      }
	    }
	  }, {
	    key: 'handleQueryChange',
	    value: function handleQueryChange(val) {
	      this.handleChange('state', val);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          firstNameErrorMessage = _state2.firstNameErrorMessage,
	          lastNameErrorMessage = _state2.lastNameErrorMessage,
	          stateErrorMessage = _state2.stateErrorMessage,
	          instagramErrorMessage = _state2.instagramErrorMessage,
	          cityErrorMessage = _state2.cityErrorMessage,
	          mobileErrorMessage = _state2.mobileErrorMessage,
	          twitterErrorMessage = _state2.twitterErrorMessage;
	
	      var renderIfShow = (0, _renderIf2.default)(this.props.show);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderIfShow(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _PersonalInfo2.default.personalInfoContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _PersonalInfo2.default.fullWidth) },
	            _react2.default.createElement(
	              'div',
	              { className: firstNameErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'FIRST NAME'
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'full_name',
	                value: this.state.firstName,
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('firstNameErrorMessage');
	                },
	                onChange: function onChange(val) {
	                  return _this2.handleChange('firstName', val);
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.firstNameErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: lastNameErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'LAST NAME'
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'full_name',
	                value: this.state.lastName,
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('lastNameErrorMessage');
	                },
	                onChange: function onChange(val) {
	                  return _this2.handleChange('lastName', val);
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.lastNameErrorMessage })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _PersonalInfo2.default.fullWidth) },
	            _react2.default.createElement(
	              'div',
	              { className: stateErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoCompleteError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'STATE'
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                onChange: function onChange(val) {
	                  return _this2.handleChange('state', val);
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this2.handleQueryChange(val);
	                },
	                source: this.state.state === '' ? emptyObject : state,
	                value: this.state.state,
	                multiple: false,
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('stateErrorMessage');
	                },
	                theme: _theme2.default
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: stateErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: cityErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoCompleteError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'CITY'
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'city',
	                value: this.state.city,
	                onChange: function onChange(val) {
	                  return _this2.handleChange('city', val);
	                },
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('cityErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: cityErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: mobileErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoCompleteError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'PHONE'
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'mobile',
	                value: this.state.mobile,
	                onChange: function onChange(val) {
	                  return _this2.handleChange('mobile', val);
	                },
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('mobileErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: mobileErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: twitterErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoCompleteError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'TWITTER HANDLE (OR)  URL',
	                _react2.default.createElement(
	                  'span',
	                  { className: _PersonalInfo2.default.optionalTag },
	                  '\xA0\xA0(Optional)'
	                )
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'twitter',
	                value: this.state.twitter,
	                onChange: function onChange(val) {
	                  return _this2.handleChange('twitter', val);
	                },
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('twitterErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: twitterErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: instagramErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoComplete) : (0, _classnames2.default)('col s12 m6', _PersonalInfo2.default.halfWidthAutoCompleteError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'INSTAGRAM HANDLE  (OR) URL',
	                _react2.default.createElement(
	                  'span',
	                  { className: _PersonalInfo2.default.optionalTag },
	                  '\xA0\xA0(Optional)'
	                )
	              ),
	              _react2.default.createElement(_input2.default, {
	                type: 'text',
	                name: 'instagram',
	                value: this.state.instagram,
	                onChange: function onChange(val) {
	                  return _this2.handleChange('instagram', val);
	                },
	                onFocus: function onFocus() {
	                  return _this2.removeErrorMessage('instagramErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: instagramErrorMessage })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _PersonalInfo2.default.buttonContainer) },
	            _react2.default.createElement(_button2.default, { label: 'CONTINUE', raised: true, className: _PersonalInfo2.default.continue, onClick: function onClick() {
	                return _this2.goToNextTab();
	              } })
	          )
	        ))
	      );
	    }
	  }]);
	
	  return PersonalInfo;
	}(_react2.default.Component);
	
	PersonalInfo.propTypes = {
	  next: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool.isRequired,
	  profile: _propTypes2.default.instanceOf(_immutable.Map),
	  attributes: _propTypes2.default.shape()
	};
	PersonalInfo.defaultProps = {
	  next: function next() {},
	  show: true,
	  profile: (0, _immutable.Map)(),
	  attributes: function attributes() {}
	};
	exports.default = PersonalInfo;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PersonalInfo = __webpack_require__(1178);
	
	var _PersonalInfo2 = _interopRequireDefault(_PersonalInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PersonalInfo2.default;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsiveModal = __webpack_require__(363);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PostingInfo = __webpack_require__(1513);
	
	var _PostingInfo2 = _interopRequireDefault(_PostingInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	var PostingInfo = function (_Component) {
	  _inherits(PostingInfo, _Component);
	
	  function PostingInfo(props) {
	    _classCallCheck(this, PostingInfo);
	
	    var _this = _possibleConstructorReturn(this, (PostingInfo.__proto__ || Object.getPrototypeOf(PostingInfo)).call(this, props));
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)));
	    };
	
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.state = {
	      open: false,
	      title: '',
	      url: ''
	    };
	    return _this;
	  }
	
	  _createClass(PostingInfo, [{
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalStyle = {
	        width: '100%',
	        padding: '0'
	      };
	      var open = this.state.open;
	      var posting = this.props.posting;
	
	      var requirements = posting.get('requirements');
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'button',
	          { onClick: this.onOpenModal, className: _PostingInfo2.default.infoButton },
	          _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/postingInfo.png', alt: 'info' })
	        ),
	        _react2.default.createElement(
	          _reactResponsiveModal2.default,
	          { modalStyle: modalStyle, open: open, onClose: this.onCloseModal, little: true },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row') },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _PostingInfo2.default.removePadding) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _PostingInfo2.default.videoHeader) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'ABOUT POSTING'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12') },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s4') },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.mainHeader },
	                    'COLLEGE NAME'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.lightText },
	                    posting.get('college_name')
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s4') },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.mainHeader },
	                    'POSTING TITLE'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.lightText },
	                    posting.get('posting_title')
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12') },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.mainHeader },
	                    'DESCRIPTION'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.lightText },
	                    posting.get('description')
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12') },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.mainHeader },
	                    'REQUIREMENTS'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _PostingInfo2.default.lightText },
	                    'Gpa: ',
	                    requirements.get('min_gpa'),
	                    ',\xA0\xA0\xA0\xA0 Height: ',
	                    requirements.get('min_height'),
	                    ',\xA0\xA0\xA0 Weight: ',
	                    requirements.get('min_weight'),
	                    '\xA0\xA0\xA0 40-Yard Dash: ',
	                    requirements.get('min_t40'),
	                    '\xA0\xA0\xA0 Bench: ',
	                    requirements.get('min_bench'),
	                    '\xA0\xA0\xA0 Squats: ',
	                    requirements.get('min_squats'),
	                    ' \xA0\xA0\xA0'
	                  ),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement('br', null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PostingInfo;
	}(_react.Component);
	
	PostingInfo.propTypes = {
	  posting: _propTypes2.default.shape().isRequired
	};
	exports.default = PostingInfo;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PostingInfo = __webpack_require__(460);
	
	var _PostingInfo2 = _interopRequireDefault(_PostingInfo);
	
	var _actionTypes = __webpack_require__(129);
	
	var action = _interopRequireWildcard(_actionTypes);
	
	var _PostingTile = __webpack_require__(1514);
	
	var _PostingTile2 = _interopRequireDefault(_PostingTile);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to validate and set default props  coming to this component
	var PostingTile = function PostingTile(props) {
	  var clickToRequest = function clickToRequest() {
	    var subscribed = props.subscribed,
	        onTrial = props.onTrial;
	
	    var contactedCountMap = props.profile.get('contactedCount');
	    var contactedCount = void 0;
	    if (contactedCountMap) {
	      contactedCount = contactedCountMap.toJS();
	    }
	    var counter = contactedCount.count; // eslint-disable-line
	    // const undefinedCase = props.profile.get('contactedCount');
	    var difference = (0, _moment2.default)().diff(contactedCount.lastContacted, 'hours');
	    var req = {
	      from_profile_id: props.profileId,
	      posting_id: props.posting.get('id'),
	      request_type: 'INTEREST',
	      coach_name: props.posting.get('coach_name'),
	      college_name: props.posting.get('college_name'),
	      college_image: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png',
	      city: props.posting.get('city'),
	      division: props.posting.get('division'),
	      college_id: props.posting.get('college_id') ? props.posting.get('college_id') : 'college_id',
	      sa_name: props.fullname,
	      sa_state: _DropdownsValues.states[props.state],
	      sa_preference: props.position_pref,
	      sa_school: props.school,
	      sa_city: props.city,
	      sa_image: props.sa_image,
	      sa_email: props.sa_email,
	      year_of_graduation: props.year_of_graduation,
	      team_page_link: props.posting.get('team_page_link'),
	      question_link: props.posting.get('question_link'),
	      sa_twitter: props.profile.get('sa_twitter') !== undefined && props.profile.get('sa_twitter') !== null ? props.profile.get('sa_twitter').substring('https://twitter.com/'.length) : '',
	      sa_height: props.profile.get('height'),
	      sa_weight: props.profile.get('weight'),
	      sa_t40: props.t40,
	      request_views: props.requestViewedCount
	    };
	    var maxCount = 1;
	    if (subscribed || onTrial) {
	      maxCount = 10;
	    }
	    if (counter < maxCount || contactedCountMap === undefined) {
	      var payload = {
	        student_profile_id: props.profileId,
	        college_id: props.posting.get('college_id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else if (counter >= maxCount && difference >= 23) {
	      var _payload = {
	        student_profile_id: props.profileId,
	        college_id: props.posting.get('college_id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(_payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else {
	      props.showCounterScreen();
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _PostingTile2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _PostingTile2.default.tile },
	      _react2.default.createElement(
	        'span',
	        { className: _PostingTile2.default.heartIcon },
	        _react2.default.createElement(_PostingInfo2.default, props)
	      ),
	      _react2.default.createElement('img', { className: _PostingTile2.default.colgeIcon, src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon' }),
	      _react2.default.createElement(
	        'div',
	        { className: _PostingTile2.default.collegeName },
	        _react2.default.createElement(
	          'a',
	          { href: props.posting.get('team_page_link'), target: '_blank' },
	          props.posting.get('college_name')
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _PostingTile2.default.lightText },
	          props.posting.get('city')
	        ),
	        ' ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _PostingTile2.default.lightText },
	          props.posting.get('state') === 'D.C.' ? 'Washington D.C' : props.posting.get('state')
	        ),
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: _PostingTile2.default.lightText },
	        _DropdownsValues.positions[props.posting.get('posting_title')]
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: _PostingTile2.default.lightText },
	        props.posting.get('division')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _PostingTile2.default.tileFooter },
	        props.interested ? _react2.default.createElement(
	          'button',
	          { className: _PostingTile2.default.interested },
	          'INTERESTED'
	        ) : _react2.default.createElement(
	          'button',
	          { className: _PostingTile2.default.showInterest, onClick: clickToRequest },
	          'CONTACT COACH'
	        )
	      )
	    )
	  );
	};
	
	PostingTile.propTypes = {
	  posting: _propTypes2.default.shape().isRequired,
	  addToRequest: _propTypes2.default.func.isRequired,
	  addToList: _propTypes2.default.func.isRequired,
	  interested: _propTypes2.default.bool,
	  profileId: _propTypes2.default.string.isRequired,
	  fullname: _propTypes2.default.string.isRequired,
	  position_pref: _propTypes2.default.string.isRequired,
	  school: _propTypes2.default.string.isRequired,
	  city: _propTypes2.default.string.isRequired,
	  sa_image: _propTypes2.default.string.isRequired,
	  showSnackBar: _propTypes2.default.func.isRequired,
	  state: _propTypes2.default.string.isRequired,
	  sa_email: _propTypes2.default.string.isRequired,
	  showCounterScreen: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.shape.isRequired,
	  year_of_graduation: _propTypes2.default.string.isRequired,
	  requestViewedCount: _propTypes2.default.number.isRequired,
	  t40: _propTypes2.default.string.isRequired
	};
	
	PostingTile.defaultProps = {
	  interested: false
	};
	
	exports.default = PostingTile;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PostingTile = __webpack_require__(1181);
	
	var _PostingTile2 = _interopRequireDefault(_PostingTile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PostingTile2.default;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _CoachPostings = __webpack_require__(1112);
	
	var _CoachPostings2 = _interopRequireDefault(_CoachPostings);
	
	var _AddPosting = __webpack_require__(1086);
	
	var _AddPosting2 = _interopRequireDefault(_AddPosting);
	
	var _EditPosting = __webpack_require__(1137);
	
	var _EditPosting2 = _interopRequireDefault(_EditPosting);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _actions = __webpack_require__(1184);
	
	var _redux = __webpack_require__(462);
	
	var _Postings = __webpack_require__(1515);
	
	var _Postings2 = _interopRequireDefault(_Postings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	// to show loder on screen whenever there is a api call or operations in component
	
	
	// to import local scss fle
	
	var Postings = function (_Component) {
	  _inherits(Postings, _Component);
	
	  function Postings(props) {
	    _classCallCheck(this, Postings);
	
	    var _this = _possibleConstructorReturn(this, (Postings.__proto__ || Object.getPrototypeOf(Postings)).call(this, props));
	
	    _this.state = {
	      editPost: false,
	      postingId: '',
	      postingIndex: 0
	    };
	    _this.editPosting = _this.editPosting.bind(_this);
	    _this.setPostingId = _this.setPostingId.bind(_this);
	    return _this;
	  }
	
	  _createClass(Postings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.attributes.size > 0) {
	        var id = this.props.attributes.get('profile');
	        this.props.getAllPostings(id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.attributes.size > 0 && !(0, _immutable.is)(nextProps.attributes, this.props.attributes)) {
	        var id = nextProps.attributes.get('profile');
	        this.props.getAllPostings(id);
	      }
	    }
	  }, {
	    key: 'setPostingId',
	    value: function setPostingId(id, index) {
	      this.setState({ postingId: id, postingIndex: index });
	    }
	  }, {
	    key: 'editPosting',
	    value: function editPosting(item) {
	      this.setState({ editPost: !this.state.editPost, currentPosting: item });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      /* let finalPostings = [];
	      if (this.props.postingDeleted === true) {
	        finalPostings = [];
	      } else {
	        finalPostings = this.props.allPostings;
	      } */
	      var allPostings = this.props.allPostings;
	      var renderLoader = (0, _renderIf2.default)(this.props.postingGettingAdded || this.props.editPostingRequested || this.props.postingGettingDeleted || this.props.requestPostings);
	      var renderEditPost = (0, _renderIf2.default)(this.state.editPost);
	      var renderNoPostings = (0, _renderIf2.default)(this.props.requestPostings === false && this.props.allPostings.size === 0 && !this.props.postingGettingAdded);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Postings2.default.container) },
	        _react2.default.createElement(_AddPosting2.default, this.props),
	        renderEditPost(_react2.default.createElement(_EditPosting2.default, Object.assign({}, this.state, this.props, {
	          currentPosting: this.state.currentPosting,
	          openPosting: this.state.editPost,
	          editPosting: function editPosting() {
	            return _this2.editPosting();
	          }
	        }))),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Postings2.default.coachPostings) },
	          renderLoader(_react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_FullScreenLoader2.default, null)
	          )),
	          renderNoPostings(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Postings2.default.emptyScreens) },
	            _react2.default.createElement(
	              'div',
	              { className: _Postings2.default.emptyImage },
	              _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png', alt: 'empty screen' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Postings2.default.noDescFound },
	              'You don\'t have any postings.'
	            )
	          )),
	          allPostings.map(function (item, index) {
	            return _react2.default.createElement(_CoachPostings2.default, Object.assign({}, _this2.props, {
	              item: item,
	              index: index,
	              editPosting: function editPosting() {
	                return _this2.editPosting(item);
	              },
	              setPostingId: _this2.setPostingId
	            }));
	          })
	        )
	      );
	    }
	  }]);
	
	  return Postings;
	}(_react.Component);
	
	Postings.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  allPostings: _propTypes2.default.shape(),
	  getAllPostings: _propTypes2.default.func,
	  postingGettingAdded: _propTypes2.default.bool,
	  postingGettingDeleted: _propTypes2.default.bool,
	  requestPostings: _propTypes2.default.bool,
	  editPostingRequested: _propTypes2.default.bool
	};
	Postings.defaultProps = {
	  attributes: {},
	  allPostings: {},
	  getAllPostings: function getAllPostings() {},
	  postingGettingAdded: false,
	  postingGettingDeleted: false,
	  postingDeleted: false,
	  requestPostings: false,
	  editPostingRequested: false
	};
	exports.default = (0, _reactRedux.connect)(_redux.postings, {
	  addPostings: _actions.addPostings,
	  getAllPostings: _actions.getAllPostings,
	  updatePostings: _actions.updatePostings,
	  createAllPostingForThisCollege: _actions.createAllPostingForThisCollege,
	  deleteposting: _actions.deleteposting
	})(Postings);

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createAllPostingForThisCollege = undefined;
	exports.getAllPostings = getAllPostings;
	exports.addPostings = addPostings;
	exports.updatePostings = updatePostings;
	exports.deleteposting = deleteposting;
	
	var _immutable = __webpack_require__(11);
	
	var _coachProfile = __webpack_require__(192);
	
	var service = _interopRequireWildcard(_coachProfile);
	
	var _actionTypes = __webpack_require__(461);
	
	var _postingData = __webpack_require__(440);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getAllPostings(id) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.GET_ALL_POSTING_REQUESTED
	    });
	    service.getAllPostingsById(id).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.GET_ALL_POSTING_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.GET_ALL_POSTING_FAILED,
	        error: err
	      });
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work
	
	function addPostings(data) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    service.storePosting(data).then(function (result) {
	      dispatch({
	        type: _actionTypes.SUCCESSFUL,
	        postings: (0, _immutable.fromJS)(result)
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	// export function getPostingById(id) {
	//   return (dispatch) => {
	//     dispatch({
	//       type: EDIT_POSTING_REQUESTED,
	//     });
	//     service.editPosting(id)
	//         .then((result) => {
	//           dispatch({
	//             type: EDIT_POSTING_SUCCESSFUL,
	//             data: fromJS(result),
	//           });
	//         })
	//         .catch((err) => {
	//           dispatch({
	//             type: EDIT_POSTING_FAILED,
	//             error: err,
	//           });
	//         });
	//   };
	// }
	
	
	function updatePostings(payload, index) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.UPDATE_REQUESTED
	    });
	    service.updatePosting(payload).then(function (result) {
	      dispatch({
	        type: _actionTypes.UPDATE_SUCCESSFUL,
	        data: (0, _immutable.fromJS)(result),
	        index: index
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.UPDATE_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function deleteposting(id) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.DELETE_POSTING_REQUESTED
	    });
	    service.deletePostingById(id).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.DELETE_POSTING_SUCCESSFUL,
	          transaction: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.DELETE_POSTING_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	var createAllPostingForThisCollege = exports.createAllPostingForThisCollege = function createAllPostingForThisCollege(profile, user) {
	  return function (dispatch) {
	    var positionArray = _postingData.allPositions[profile.get('division') === 'NJCAA' ? 'JUCO' : profile.get('division')];
	
	    var allPayloads = positionArray.map(function (item) {
	      return {
	        coach_id: profile.get('coach_id'),
	        posting_title: item.position,
	        posting_sport: 'sport',
	        team_name: 'teamName',
	        coach_name: user.username,
	        college_name: profile.get('college'),
	        college_id: profile.get('college_id'),
	        college_image: 'not found',
	        city: profile.get('city'),
	        state: profile.get('state'),
	        team_page_link: profile.get('team_page_link'),
	        question_link: profile.get('question_link'),
	        division: profile.get('division') === 'NJCAA' ? 'JUCO' : profile.get('division'),
	        posting_status: 'active',
	        requirements: {
	          min_gpa: profile.get('gpa'),
	          min_height: item.feet + '\'' + item.inches,
	          min_weight: item.weight,
	          min_t40: item.t40
	        },
	        description: item.description || null
	      };
	    });
	    dispatch({
	      type: _actionTypes.CREATE_POSTINGS_REQUESTED
	    });
	    Promise.all(allPayloads.map(function (item) {
	      return service.storePosting(item);
	    })).then(function (results) {
	      dispatch({
	        type: _actionTypes.ALL_POSTINGS_CREATED_SUCCESSFUL,
	        postings: (0, _immutable.fromJS)(results)
	      });
	    }).catch(function (error) {
	      dispatch({
	        type: _actionTypes.CREATE_ALL_POSTINGS_FAILED,
	        error: error
	      });
	    });
	  };
	};

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Postings = __webpack_require__(1183);
	
	var _Postings2 = _interopRequireDefault(_Postings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Postings2.default;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Navigation = __webpack_require__(197);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _ProfileBanner = __webpack_require__(1516);
	
	var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to validate and set default props  coming to this component
	var ProfileBanner = function ProfileBanner(props) {
	  var profileBanner = false;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: props.usedFor === 'pricing' ? (0, _classnames2.default)('row', _ProfileBanner2.default.container) : (0, _classnames2.default)('row', _ProfileBanner2.default.profileBannerContainer)
	    },
	    _react2.default.createElement(_Navigation2.default, Object.assign({ profileBanner: profileBanner }, props)),
	    _react2.default.createElement(
	      'div',
	      { className: props.usedFor === 'pricing' ? (0, _classnames2.default)('row', _ProfileBanner2.default.textOnPricingbanner) : (0, _classnames2.default)('row', _ProfileBanner2.default.textOnbanner) },
	      props.usedFor === 'pricing' ? _react2.default.createElement(
	        'span',
	        null,
	        'Experience the Full Power of MyRecruitBoard',
	        _react2.default.createElement(
	          'span',
	          { className: _ProfileBanner2.default.smallText },
	          'Upgrade to Premium'
	        )
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        'Almost there!Complete your profile.'
	      )
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	
	ProfileBanner.propTypes = {
	  usedFor: _propTypes2.default.string.isRequired
	};
	
	exports.default = ProfileBanner;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserDesc = __webpack_require__(1249);
	
	var _UserDesc2 = _interopRequireDefault(_UserDesc);
	
	var _UserInfo = __webpack_require__(1251);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProfileData = __webpack_require__(1517);
	
	var _ProfileData2 = _interopRequireDefault(_ProfileData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	var ProfileData = function (_Component) {
	  _inherits(ProfileData, _Component);
	
	  function ProfileData(props) {
	    _classCallCheck(this, ProfileData);
	
	    var _this = _possibleConstructorReturn(this, (ProfileData.__proto__ || Object.getPrototypeOf(ProfileData)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(ProfileData, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _ProfileData2.default.profileDataContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _ProfileData2.default.dataInBigScreens) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s6', _ProfileData2.default.userDescription) },
	            _react2.default.createElement(_UserDesc2.default, Object.assign({}, this.props, { removeVideoScreen: this.props.removeVideoScreen }))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s6', _ProfileData2.default.userInfo) },
	            _react2.default.createElement(_UserInfo2.default, this.props)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _ProfileData2.default.dataInSmallScreens) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _ProfileData2.default.userInfo) },
	            _react2.default.createElement(_UserInfo2.default, this.props)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _ProfileData2.default.userDescription) },
	            _react2.default.createElement(_UserDesc2.default, this.props)
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfileData;
	}(_react.Component);
	
	ProfileData.propTypes = {
	  removeVideoScreen: _propTypes2.default.func.isRequired
	};
	exports.default = ProfileData;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _User = __webpack_require__(1247);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Navbar = __webpack_require__(159);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _HeaderActionableItems = __webpack_require__(1150);
	
	var _HeaderActionableItems2 = _interopRequireDefault(_HeaderActionableItems);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Header = __webpack_require__(1518);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to use conditional rendering based on values that is provided to component
	var ProfileHeader = function ProfileHeader(props) {
	  var renderAthlete = (0, _renderIf2.default)(!props.coachProfile);
	  var renderActionItems = (0, _renderIf2.default)(props.actionItems);
	  var headerOnDashboard = false;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: props.coachProfile === true ? (0, _classnames2.default)('row', _Header2.default.headerContainerCoach) : (0, _classnames2.default)('row', _Header2.default.headerContainer)
	    },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Header2.default.navBar) },
	      _react2.default.createElement(_Navbar2.default, Object.assign({}, props, { headerOnDashboard: headerOnDashboard, usedFor: 'profile_page' }))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Header2.default.profileDetails) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m7', _Header2.default.userContainer) },
	        props.page === 'coachAthleteView' ? '' : _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: '/settings' },
	          _react2.default.createElement(
	            'button',
	            { className: _Header2.default.editIcon },
	            _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/editIconProfile.png', alt: 'edit_icon' })
	          )
	        ),
	        renderAthlete(_react2.default.createElement(_User2.default, props))
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12 m5', _Header2.default.buttonContainer) },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _Header2.default.textAlignCenter },
	            renderActionItems(_react2.default.createElement(_HeaderActionableItems2.default, props))
	          ),
	          props.page === 'coachAthleteView' ? '' : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/settings' },
	              _react2.default.createElement(
	                'button',
	                null,
	                'EDIT PROFILE'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	//  to change path from inside or to alter react-router-dom path
	// to validate and set default props  coming to this component
	
	
	ProfileHeader.propTypes = {
	  coachProfile: _propTypes2.default.isRequired,
	  page: _propTypes2.default.string.isRequired,
	  // description: PropTypes.string.isRequired,
	  actionItems: _propTypes2.default.bool
	};
	
	ProfileHeader.defaultProps = {
	  actionItems: false
	};
	
	exports.default = ProfileHeader;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CoachPopup = __webpack_require__(448);
	
	var _CoachPopup2 = _interopRequireDefault(_CoachPopup);
	
	var _Actionable = __webpack_require__(1519);
	
	var _Actionable2 = _interopRequireDefault(_Actionable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Actionable = function (_Component) {
	  _inherits(Actionable, _Component);
	
	  function Actionable(props) {
	    _classCallCheck(this, Actionable);
	
	    var _this = _possibleConstructorReturn(this, (Actionable.__proto__ || Object.getPrototypeOf(Actionable)).call(this, props));
	
	    _this.state = {
	      actionableToolTip: false,
	      bubbleToolTip: true,
	      requestCreatedBy: 'SA',
	      disableInviteToCamp: false,
	      disableFillQuestionaire: false,
	      disableAddedToWathcList: false,
	      disableIgnored: false,
	      disableNeedMoreFilms: false,
	      disableSendContactInfo: false,
	      showPopup: false
	    };
	    _this.showTooltip = _this.showTooltip.bind(_this);
	    _this.hideTooltip = _this.hideTooltip.bind(_this);
	    _this.addQuestionaire = _this.addQuestionaire.bind(_this);
	    _this.inviteToCamp = _this.inviteToCamp.bind(_this);
	    _this.needMoreFilms = _this.needMoreFilms.bind(_this);
	    _this.sendContactInfo = _this.sendContactInfo.bind(_this);
	    _this.addToWatchList = _this.addToWatchList.bind(_this);
	    _this.ignoredList = _this.ignoredList.bind(_this);
	    return _this;
	  }
	
	  _createClass(Actionable, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var updated = {};
	      var convo = this.props.request.get('conversation');
	      var allConvo = convo.toIndexedSeq().toArray();
	      for (var i = 0; i < allConvo.length; i++) {
	        // eslint-disable-line
	        var temp = allConvo[i];
	        if (temp.get('action') === 'INVITE TO CAMP') {
	          updated.disableInviteToCamp = true;
	        }
	        if (temp.get('action') === 'FILL QUESTIONAIRE') {
	          updated.disableFillQuestionaire = true;
	        }
	        if (temp.get('action') === 'SA SENT CONTACT INFO') {
	          updated.disableSendContactInfo = true;
	        }
	        if (temp.get('action') === 'ADDED TO WATCHLIST') {
	          updated.disableAddedToWathcList = true;
	        }
	        if (temp.get('action') === 'NEED MORE FILMS') {
	          updated.disableNeedMoreFilms = true;
	        }
	        if (temp.get('action') === 'IGNORED') {
	          updated.disableIgnored = true;
	        }
	      }
	      this.setState(updated);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var updated = {};
	      var convo = nextProps.request.get('conversation');
	      var allConvo = convo.toIndexedSeq().toArray();
	      for (var i = 0; i < allConvo.length; i++) {
	        // eslint-disable-line
	        var temp = allConvo[i];
	        if (temp.get('action') === 'INVITE TO CAMP') {
	          updated.disableInviteToCamp = true;
	        }
	        if (temp.get('action') === 'FILL QUESTIONAIRE') {
	          updated.disableFillQuestionaire = true;
	        }
	        if (temp.get('action') === 'SA SENT CONTACT INFO') {
	          updated.disableSendContactInfo = true;
	        }
	        if (temp.get('action') === 'ADDED TO WATCHLIST') {
	          updated.disableaddedToWathcList = true;
	        }
	        if (temp.get('action') === 'NEED MORE FILMS') {
	          updated.disableNeedMoreFilms = true;
	        }
	        if (temp.get('action') === 'IGNORED') {
	          updated.disableIgnored = true;
	        }
	      }
	      // const lastItemInConversation = convo.last();
	      this.setState(updated);
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      this.setState({ actionableToolTip: !this.state.actionableToolTip });
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      this.setState({ bubbleToolTip: false, actionableToolTip: false });
	    }
	  }, {
	    key: 'addQuestionaire',
	    value: function addQuestionaire(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'FILL QUESTIONAIRE', // let backend know if you change something here
	        link: this.props.profile.get('question_link'),
	        sa_email: email,
	        sa_name: name,
	        created_by: this.state.requestCreatedBy,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.setState({ showPopup: true, text: 'Hi Coach! We have notified student athlete to fill your college questionnaire.' });
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'inviteToCamp',
	    value: function inviteToCamp(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'INVITE TO CAMP',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'needMoreFilms',
	    value: function needMoreFilms(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'NEED MORE FILMS',
	        sa_email: email,
	        created_by: this.state.requestCreatedBy,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'addToWatchList',
	    value: function addToWatchList(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'ADDED TO WATCHLIST',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'ignoredList',
	    value: function ignoredList(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'IGNORED',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'sendContactInfo',
	    value: function sendContactInfo(requestId, email, name, mobile) {
	      var conversation = {
	        id: requestId,
	        action: 'SA SENT CONTACT INFO',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        sa_mobile: mobile,
	        coach_email: this.props.coachEmail
	      };
	      this.showTooltip();
	      this.setState({ showPopup: true, text: 'Hi Coach! We mailed you student athlete contact details.' });
	      this.props.updateConversation(conversation, 'public');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.profile;
	      var request = this.props.request;
	      var _state = this.state,
	          disableSendContactInfo = _state.disableSendContactInfo,
	          disableFillQuestionaire = _state.disableFillQuestionaire;
	
	      return (
	        /*eslint-disable*/
	        _react2.default.createElement(
	          'div',
	          { className: this.state.actionableToolTip ? _Actionable2.default.fullScreen : '', onClick: this.showTooltip },
	          _react2.default.createElement(
	            'div',
	            { className: _Actionable2.default.bubbleButton, id: 'actionableButton' },
	            this.state.showPopup ? _react2.default.createElement(_CoachPopup2.default, { text: this.state.text }) : '',
	            _react2.default.createElement(
	              'button',
	              {
	                // onMouseEnter={this.showTooltip}
	                // onMouseLeave={this.hideTooltip}
	                onClick: this.showTooltip
	              },
	              'CONTACT PLAYER'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: this.state.actionableToolTip === true ? _Actionable2.default.popupBubble : _Actionable2.default.hidden
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  onClick: function onClick() {
	                    return _this2.addQuestionaire(request.get('id'), item.get('fullname'), item.get('sa_name'));
	                  },
	                  className: _Actionable2.default.options,
	                  disabled: disableFillQuestionaire
	                },
	                'Send My Questionnaire'
	              ),
	              _react2.default.createElement(_Divider2.default, null),
	              _react2.default.createElement(
	                'button',
	                {
	                  onClick: function onClick() {
	                    return _this2.sendContactInfo(request.get('id'), item.get('sa_email'), item.get('fullname'), item.get('sa_mobile'));
	                  },
	                  className: _Actionable2.default.options,
	                  disabled: disableSendContactInfo
	                },
	                'Request Student Contact Information'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Actionable;
	}(_react.Component);
	
	Actionable.propTypes = {
	  updateConversation: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.shape().isRequired,
	  request: _propTypes2.default.shape().isRequired,
	  coachEmail: _propTypes2.default.string.isRequired
	};
	exports.default = Actionable;

/***/ },
/* 1190 */
[2530, 1189],
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tips = __webpack_require__(1520);
	
	var _Tips2 = _interopRequireDefault(_Tips);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tips = function Tips() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row') },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _Tips2.default.sportsWeSupport) },
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.darkHeader },
	        'SENIOR FOOTBALL RECRUITING TIPS:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.desc },
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'MyRecruitBoard is the ONLY service that scientifically matches you to every football college in America.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Don\'t pay an expensive third-party scout to evaluate and ultimately lessen your opportunities. Don\'t be fooled by "Free to Signup" recruiting services who only want to call your family and scare them into paying hundreds or even worse thousands of dollars.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'It\'s never too late, MyRecruitboard can still get you what you need and where you want to be. Join NOW! ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Attend one day camps to get the most exposure. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Video (highlights and whole game). ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Choose a university that offers you the best environment for athletic, academic and personal development.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Take the SAT or ACT (retake if needed).',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Register with the NAIA & NCAA Eligibility Center.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Use MyRecruitBoard to get National Exposure.',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.darkHeader },
	        'JUNIOR FOOTBALL RECRUITING TIPS:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.desc },
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'MyRecruitBoard is the ONLY service that scientifically matches you to every football college in America. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Don\'t pay an expensive third-party scout to evaluate and ultimately lessen your opportunities. Don\'t be fooled by "Free to Signup" recruiting services who only want to call your family and scare them into paying hundreds or even worse thousands of dollars.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'You need exposure now!',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Almost all talented players in your junior class has been discovered by college coaches. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Contact every college you can realistically play at.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Register with the NAIA & NCAA Eligibility Center. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Video (highlights and game).',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Attend camps that college coaches invite you to from MyRecruitBoard.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Take the SAT or ACT (retake if needed).',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.darkHeader },
	        'SOPHOMORE FOOTBALL RECRUITING TIPS:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.desc },
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'MyRecruitBoard is the ONLY service that scientifically matches you to every football college in America.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Don\'t pay an expensive third-party scout to evaluate and ultimately lessen your opportunities. Don\'t be fooled by "Free to Signup" recruiting services who only want to call your family and scare them into paying hundreds or even worse thousands of dollars.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        '80% of Div 1 athletes have been discovered by their Sophomore year.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Keep your profile up-to-date.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Work on improving your biometric ratings.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Keep contacting coaches and colleges.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Video (highlights and game).',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Attend camps that college coaches invite you to from MyRecruitBoard.',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.darkHeader },
	        'FRESHMAN & MIDDLE SCHOOL FOOTBALL RECRUITING TIPS:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.desc },
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'MyRecruitBoard is the ONLY service that scientifically matches you to every football college in America.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Don\'t pay an expensive third-party scout to evaluate and ultimately lessen your opportunities. Don\'t be fooled by "Free to Signup" recruiting services who only want to call your family and scare them into paying hundreds or even worse thousands of dollars. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Join MyRecruitboard. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Start contacting coaches and schools through your MyRecruitboard profile. ',
	        _react2.default.createElement('br', null),
	        'Share your video and biometrics with hundreds of coaches. ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Start contacting coaches and schools through your MyRecruitboard profile. ',
	        _react2.default.createElement('br', null),
	        'Attend camps that college coaches invite you to from MyRecruitBoard. ',
	        _react2.default.createElement('br', null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.darkHeader },
	        'JUCO & COLLEGE TRANSFER FOOTBALL RECRUITING TIPS:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _Tips2.default.desc },
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'MyRecruitBoard is the ONLY service that scientifically matches you to every football college in America.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Don\'t pay an expensive third-party scout to evaluate and ultimately lessen your opportunities. Don\'t be fooled by "Free to Signup" recruiting services who only want to call your family and scare them into paying hundreds or even worse thousands of dollars.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'It\'s important to get your video seen early in your JUCO season. JUCO Signing Day is earlier than high school Signing Day. If you wait too long you risk having to play at a lower division.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('div', { className: _Tips2.default.redDot }),
	        'Typically D1 colleges only offer one or two JUCO players per year. It is VERY competitive! ',
	        _react2.default.createElement('br', null)
	      )
	    )
	  );
	};
	
	exports.default = Tips;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tips = __webpack_require__(1191);
	
	var _Tips2 = _interopRequireDefault(_Tips);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Tips2.default;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _RequestListView = __webpack_require__(1521);
	
	var _RequestListView2 = _interopRequireDefault(_RequestListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var RequestListView = function (_Component) {
	  _inherits(RequestListView, _Component);
	
	  function RequestListView(props) {
	    _classCallCheck(this, RequestListView);
	
	    var _this = _possibleConstructorReturn(this, (RequestListView.__proto__ || Object.getPrototypeOf(RequestListView)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    _this.getStyles = _this.getStyles.bind(_this);
	    return _this;
	  }
	  /* eslint-disable */
	
	
	  _createClass(RequestListView, [{
	    key: 'getStyles',
	    value: function getStyles(value) {
	      var returnValue = 'interestedButtonList';
	      if (value === 'FILL QUESTIONAIRE') {
	        returnValue = 'greenButtonList';
	      }
	      if (value === 'INVITE TO CAMP') {
	        returnValue = 'inviteToCampButtonList';
	      }
	      if (value === 'NEED MORE FILMS') {
	        returnValue = 'needMoreFilmsButtonList';
	      }
	      if (value === 'ADDED TO WATCHLIST') {
	        returnValue = 'addedToWatchListButtonList';
	      }
	      if (value === 'IGNORED') {
	        returnValue = 'ignoredButtonList';
	      }
	      if (value === 'SEND CONTACT INFO') {
	        returnValue = 'sendContactInfoButtonList';
	      }
	      if (value === 'SA SENT CONTACT INFO') {
	        returnValue = 'addedToWatchListButtonList';
	      }
	      return returnValue;
	    }
	    /* eslint-disable */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var request = this.props.request;
	
	      var convo = request.get('conversation');
	      var last = convo.last();
	      var flag = last.get('link') && last.get('link').length > 0;
	      // const renderAction = renderIf(flag);
	      // const renderNoAction = renderIf(!flag);
	
	      var link = '';
	
	      if (flag) {
	        link = last.get('link');
	        link = link.startsWith('http') ? link : 'http://' + link;
	      }
	
	      if (!link) {
	        link = request.get('question_link');
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _RequestListView2.default.container) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _RequestListView2.default.listInBig) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s5', _RequestListView2.default.firstDiv) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s2', _RequestListView2.default.removePadding) },
	              _react2.default.createElement('img', {
	                className: _RequestListView2.default.colgeIcon,
	                src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png',
	                alt: 'college-icon'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s10', _RequestListView2.default.textContainer) },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: _RequestListView2.default.collegeName },
	                  request.get('college_name') || 'College Name'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _RequestListView2.default.lightText },
	                  request.get('city')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s1', _RequestListView2.default.equalDivs) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s8', _RequestListView2.default.textContainer) },
	              this.state.value
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s3', _RequestListView2.default.equalDivs) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s8', _RequestListView2.default.textContainer) },
	              _react2.default.createElement(
	                'span',
	                { className: _RequestListView2.default.veryLightText },
	                request.get('status') !== undefined && last.get('action') === 'INTERESTED' ? _react2.default.createElement(
	                  'span',
	                  { className: _RequestListView2.default.boldText },
	                  request.get('status'),
	                  ' '
	                ) : last.get('action') === 'INTERESTED' ? 'Awaiting response' : '',
	                last.get('action') === 'FILL QUESTIONAIRE' ? 'Complete Recruiting Questionaire' : '',
	                last.get('action') === 'IGNORED' ? 'Not Interested' : '',
	                last.get('action') === 'NEED MORE FILMS' ? 'Need more films' : '',
	                last.get('action') === 'ADDED TO WATCHLIST' ? 'Added to my Watchlist' : '',
	                last.get('action') === 'SEND CONTACT INFO' ? 'Check your mail to send info' : '',
	                last.get('action') === 'SA SENT CONTACT INFO' ? 'Your info has been sent' : '',
	                last.get('action') === 'INVITE TO CAMP' ? 'Attend Our Camp' : ''
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s3', _RequestListView2.default.lastDiv) },
	            _react2.default.createElement(
	              'div',
	              { className: _RequestListView2.default.buttonContainer },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  { className: (0, _classnames2.default)(this.getStyles(convo.get(convo.size - 1).get('action'))) },
	                  last.get('action') === 'INTERESTED' ? _react2.default.createElement(
	                    'a',
	                    null,
	                    last.get('action')
	                  ) : '',
	                  last.get('action') === 'IGNORED' ? _react2.default.createElement(
	                    'a',
	                    null,
	                    last.get('action')
	                  ) : '',
	                  last.get('action') === 'SEND CONTACT INFO' ? _react2.default.createElement(
	                    'a',
	                    null,
	                    last.get('action')
	                  ) : '',
	                  last.get('action') === 'SA SENT CONTACT INFO' ? _react2.default.createElement(
	                    'a',
	                    null,
	                    'CONTACT INFO SENT'
	                  ) : '',
	                  last.get('action') === 'FILL QUESTIONAIRE' ? _react2.default.createElement(
	                    'a',
	                    { href: link, target: '_blank' },
	                    last.get('action')
	                  ) : '',
	                  last.get('action') === 'NEED MORE FILMS' ? _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { to: '/view/athlete' },
	                    last.get('action')
	                  ) : '',
	                  last.get('action') === 'ADDED TO WATCHLIST' ? _react2.default.createElement(
	                    'a',
	                    null,
	                    last.get('action')
	                  ) : '',
	                  last.get('action') === 'INVITE TO CAMP' ? _react2.default.createElement(
	                    'a',
	                    null,
	                    last.get('action')
	                  ) : ''
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _RequestListView2.default.listInSmall) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s3', _RequestListView2.default.firstDiv) },
	            _react2.default.createElement('img', {
	              className: _RequestListView2.default.colgeIcon,
	              src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s9', _RequestListView2.default.equalDivs) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _RequestListView2.default.textContainer) },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: _RequestListView2.default.collegeName },
	                  this.props.request.get('college_name') || 'College Name'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _RequestListView2.default.lightText },
	                  this.props.request.get('city')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _RequestListView2.default.responseText) },
	            request.get('status') !== undefined && last.get('action') === 'INTERESTED' ? _react2.default.createElement(
	              'span',
	              { className: _RequestListView2.default.responseTextBold },
	              request.get('status'),
	              ' '
	            ) : last.get('action') === 'INTERESTED' ? 'Awaiting response' : '',
	            last.get('action') === 'FILL QUESTIONAIRE' ? 'Complete Recruiting Questionaire' : '',
	            last.get('action') === 'IGNORED' ? 'Not Interested' : '',
	            last.get('action') === 'SEND CONTACT INFO' ? 'Check mail to send info.' : '',
	            last.get('action') === 'ADDED TO WATCHLIST' ? 'Added to my Watchlist' : '',
	            last.get('action') === 'NEED MORE FILMS' ? 'Need more films' : '',
	            last.get('action') === 'SA SENT CONTACT INFO' ? 'Your info has been sent' : '',
	            last.get('action') === 'INVITE TO CAMP' ? 'Attend Our Camp' : ''
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _RequestListView2.default.smallButtonContainer) },
	            _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'button',
	                { className: (0, _classnames2.default)(this.getStyles(convo.get(convo.size - 1).get('action'))) },
	                last.get('action') === 'INTERESTED' ? _react2.default.createElement(
	                  'a',
	                  null,
	                  last.get('action')
	                ) : '',
	                last.get('action') === 'IGNORED' ? _react2.default.createElement(
	                  'a',
	                  null,
	                  last.get('action')
	                ) : '',
	                last.get('action') === 'SEND CONTACT INFO' ? _react2.default.createElement(
	                  'a',
	                  { href: "mailto:" + last.get('coach_email') + "?Subject=Hello%20again", target: '_top' },
	                  last.get('action')
	                ) : '',
	                last.get('action') === 'SA SENT CONTACT INFO' ? _react2.default.createElement(
	                  'a',
	                  null,
	                  'CONTACT INFO SENT'
	                ) : '',
	                last.get('action') === 'FILL QUESTIONAIRE' ? _react2.default.createElement(
	                  'a',
	                  { href: link, target: '_blank' },
	                  last.get('action')
	                ) : '',
	                last.get('action') === 'NEED MORE FILMS' ? _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/view/athlete' },
	                  last.get('action')
	                ) : '',
	                last.get('action') === 'ADDED TO WATCHLIST' ? _react2.default.createElement(
	                  'a',
	                  null,
	                  last.get('action')
	                ) : '',
	                last.get('action') === 'INVITE TO CAMP' ? _react2.default.createElement(
	                  'a',
	                  null,
	                  last.get('action')
	                ) : ''
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RequestListView;
	}(_react.Component);
	
	RequestListView.propTypes = {
	  request: _propTypes2.default.shape().isRequired
	};
	exports.default = RequestListView;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RequestListView = __webpack_require__(1193);
	
	var _RequestListView2 = _interopRequireDefault(_RequestListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RequestListView2.default;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Rtiles = __webpack_require__(1204);
	
	var _Rtiles2 = _interopRequireDefault(_Rtiles);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(11);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _Requests = __webpack_require__(1522);
	
	var _Requests2 = _interopRequireDefault(_Requests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	// to show loder on screen whenever there is a api call or operations in component
	
	// to import local scss fle
	
	var Requests = function (_Component) {
	  _inherits(Requests, _Component);
	
	  function Requests(props) {
	    _classCallCheck(this, Requests);
	
	    var _this = _possibleConstructorReturn(this, (Requests.__proto__ || Object.getPrototypeOf(Requests)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Requests, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.attributes.size > 0 && this.props.profile.size > 0) {
	        var id = this.props.profile.get('college_id');
	        this.props.getAllRequests(id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.profile.size > 0 && (0, _immutable.is)(this.props.allRequests, nextProps.allRequests) && !nextProps.requestLoaded && !nextProps.conversationUpdated && !nextProps.allRequests.size > 0) {
	        var id = nextProps.profile.get('college_id');
	        this.props.getAllRequests(id);
	      } else if (nextProps.conversationUpdated) {
	        var _id = nextProps.profile.get('college_id');
	        this.props.getAllRequests(_id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var renderLoader = (0, _renderIf2.default)(!this.props.requestLoaded || this.props.conversationUpdated);
	      var renderRequests = (0, _renderIf2.default)(this.props.requestLoaded);
	      var toProfileId = [];
	      var fromProfileId = [];
	      var noToProfileId = true;
	      var noFromProfileId = true;
	      if (this.props.allRequests && this.props.allRequests.size > 0) {
	        toProfileId = this.props.allRequests;
	        fromProfileId = []; // udate this when you want to show tiles, when coach made any request
	        if (this.props.allRequests.size > 0) {
	          noToProfileId = false;
	        }
	        if (fromProfileId.length > 0) {
	          // udate this when you want to show tiles,
	          // when coach made any request
	          noFromProfileId = false;
	        }
	      }
	      var renderNoToProfileId = (0, _renderIf2.default)(noToProfileId || !this.props.requestLoaded);
	      var renderNoFromProfileId = (0, _renderIf2.default)(noFromProfileId);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement('div', { className: (0, _classnames2.default)('row', _Requests2.default.container) }),
	        renderRequests(_react2.default.createElement(
	          'div',
	          { className: _Requests2.default.container },
	          _react2.default.createElement(
	            'div',
	            { className: _Requests2.default.fromToContainer },
	            _react2.default.createElement(
	              'span',
	              { className: _Requests2.default.studentShowedInterest },
	              'STUDENTS WHO HAVE SHOWN INTEREST IN YOUR PROGRAM.'
	            ),
	            _react2.default.createElement(_Divider2.default, null),
	            renderNoToProfileId(_react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Requests2.default.adaptContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: _Requests2.default.emptyImage },
	                _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png', alt: 'empty screen' })
	              )
	            )),
	            toProfileId.map(function (item) {
	              return _react2.default.createElement(_Rtiles2.default, Object.assign({}, _this2.props, { item: item }));
	            })
	          ),
	          fromProfileId.size > 0 ? _react2.default.createElement(
	            'div',
	            { className: _Requests2.default.fromToContainer },
	            _react2.default.createElement(
	              'span',
	              { className: _Requests2.default.studentShowedInterest },
	              'Student whom you showed interest.'
	            ),
	            _react2.default.createElement(_Divider2.default, null),
	            renderNoFromProfileId(_react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Requests2.default.adaptContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: _Requests2.default.emptyImage },
	                _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/no-content-found%403x.png', alt: 'empty screen' })
	              )
	            )),
	            fromProfileId.map(function (item) {
	              return _react2.default.createElement(_Rtiles2.default, Object.assign({}, _this2.props, { item: item }));
	            })
	          ) : ''
	        ))
	      );
	    }
	  }]);
	
	  return Requests;
	}(_react.Component);
	
	Requests.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  getAllRequests: _propTypes2.default.func,
	  allRequests: _propTypes2.default.shape(),
	  requestLoaded: _propTypes2.default.bool,
	  conversationUpdated: _propTypes2.default.bool,
	  profile: _propTypes2.default.shape()
	};
	Requests.defaultProps = {
	  attributes: {},
	  getAllRequests: function getAllRequests() {},
	  allRequests: {},
	  requestLoaded: false,
	  conversationUpdated: false,
	  profile: {}
	};
	exports.default = Requests;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Requests = __webpack_require__(1195);
	
	var _Requests2 = _interopRequireDefault(_Requests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Requests2.default;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _RequestsTile = __webpack_require__(1523);
	
	var _RequestsTile2 = _interopRequireDefault(_RequestsTile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var SchoolTile = function (_Component) {
	    _inherits(SchoolTile, _Component);
	
	    function SchoolTile(props) {
	        _classCallCheck(this, SchoolTile);
	
	        var _this = _possibleConstructorReturn(this, (SchoolTile.__proto__ || Object.getPrototypeOf(SchoolTile)).call(this, props));
	
	        _this.state = {
	            value: ''
	        };
	        _this.getStyles = _this.getStyles.bind(_this);
	        return _this;
	    }
	    /* eslint-disable */
	
	
	    _createClass(SchoolTile, [{
	        key: 'getStyles',
	        value: function getStyles(value) {
	            var returnValue = 'interestedButton';
	            if (value === 'FILL QUESTIONAIRE') {
	                returnValue = 'greenButton';
	            }
	            if (value === 'INVITE TO CAMP') {
	                returnValue = 'inviteToCampButton';
	            }
	            if (value === 'NEED MORE FILMS') {
	                returnValue = 'needMoreFilmsButton';
	            }
	            if (value === 'ADDED TO WATCHLIST') {
	                returnValue = 'addedToWatchListButton';
	            }
	            if (value === 'IGNORED') {
	                returnValue = 'ignoredButton';
	            }
	            if (value === 'SEND CONTACT INFO') {
	                returnValue = 'sendContactInfoButton';
	            }
	            if (value === 'SA SENT CONTACT INFO') {
	                returnValue = 'addedToWatchListButton';
	            }
	            return returnValue;
	        }
	        /* eslint-disable */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var request = this.props.request;
	
	            var convo = request.get('conversation');
	            var last = convo.last();
	            var flag = last.get('link') && last.get('link').length > 0;
	            var link = '';
	
	            if (flag) {
	                link = last.get('link');
	                link = link.startsWith('http') ? link : 'http://' + link;
	            }
	            if (!link) {
	                link = request.get('question_link');
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: _RequestsTile2.default.container },
	                _react2.default.createElement(
	                    'div',
	                    { className: _RequestsTile2.default.tile },
	                    _react2.default.createElement('img', { className: _RequestsTile2.default.colgeIcon,
	                        src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png',
	                        alt: 'college-icon' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _RequestsTile2.default.collegeName },
	                        request.get('college_name') || 'College Name',
	                        ' ',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'span',
	                            { className: _RequestsTile2.default.lightText },
	                            request.get('city')
	                        ),
	                        ' ',
	                        _react2.default.createElement('br', null)
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: _RequestsTile2.default.lightText },
	                        request.get('division')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _RequestsTile2.default.veryLightText },
	                        request.get('status') !== undefined && last.get('action') === 'INTERESTED' ? _react2.default.createElement(
	                            'span',
	                            { className: _RequestsTile2.default.boldText },
	                            request.get('status'),
	                            ' '
	                        ) : last.get('action') === 'INTERESTED' ? 'Awaiting response' : '',
	                        last.get('action') === 'FILL QUESTIONAIRE' ? 'Complete Recruiting Questionaire' : '',
	                        last.get('action') === 'IGNORED' ? 'Not Interested' : '',
	                        last.get('action') === 'SEND CONTACT INFO' ? 'Check mail to send info' : '',
	                        last.get('action') === 'ADDED TO WATCHLIST' ? 'Added to my Watchlist' : '',
	                        last.get('action') === 'NEED MORE FILMS' ? 'Need more films' : '',
	                        last.get('action') === 'INVITE TO CAMP' ? 'Attend Our Camp' : '',
	                        last.get('action') === 'SA SENT CONTACT INFO' ? 'Your info has been sent' : ''
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: (0, _classnames2.default)(this.getStyles(convo.get(convo.size - 1).get('action'))) },
	                        last.get('action') === 'INTERESTED' ? _react2.default.createElement(
	                            'a',
	                            { target: '_blank' },
	                            last.get('action')
	                        ) : '',
	                        last.get('action') === 'IGNORED' ? _react2.default.createElement(
	                            'a',
	                            { target: '_blank' },
	                            last.get('action')
	                        ) : '',
	                        last.get('action') === 'SEND CONTACT INFO' ? _react2.default.createElement(
	                            'a',
	                            null,
	                            last.get('action')
	                        ) : '',
	                        last.get('action') === 'SA SENT CONTACT INFO' ? _react2.default.createElement(
	                            'a',
	                            null,
	                            'CONTACT INFO SENT'
	                        ) : '',
	                        last.get('action') === 'FILL QUESTIONAIRE' ? _react2.default.createElement(
	                            'a',
	                            { href: link, target: '_blank' },
	                            last.get('action')
	                        ) : '',
	                        last.get('action') === 'NEED MORE FILMS' ? _react2.default.createElement(
	                            _reactRouterDom.Link,
	                            { to: '/view/athlete' },
	                            last.get('action')
	                        ) : '',
	                        last.get('action') === 'ADDED TO WATCHLIST' ? _react2.default.createElement(
	                            'a',
	                            null,
	                            last.get('action')
	                        ) : '',
	                        last.get('action') === 'INVITE TO CAMP' ? _react2.default.createElement(
	                            'a',
	                            null,
	                            last.get('action')
	                        ) : ''
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SchoolTile;
	}(_react.Component);
	
	SchoolTile.propTypes = {
	    request: _propTypes2.default.shape().isRequired
	};
	exports.default = SchoolTile;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RequestsTile = __webpack_require__(1197);
	
	var _RequestsTile2 = _interopRequireDefault(_RequestsTile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RequestsTile2.default;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Reset = __webpack_require__(1524);
	
	var _Reset2 = _interopRequireDefault(_Reset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use input from react-toolbox library
	// to use global class name eg. classes from grid.css in public folder
	// to use conditional rendering based on values that is provided to component
	// to show loder on screen whenever there is a api call or operations in component
	// to display error messages on invalid user input
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	
	var Reset = function (_Component) {
	  _inherits(Reset, _Component);
	
	  function Reset(props) {
	    _classCallCheck(this, Reset);
	
	    var _this = _possibleConstructorReturn(this, (Reset.__proto__ || Object.getPrototypeOf(Reset)).call(this, props));
	
	    _this.state = {
	      value: '',
	      reEnterNewPasswordError: '',
	      newPasswordErrorMessage: '',
	      currentPasswordErrorMessage: '',
	      newPassword: '',
	      verifyNewPassword: '',
	      currentPassword: '',
	      password: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.validateInput = _this.validateInput.bind(_this);
	    _this.removeErrorMessage = _this.removeErrorMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(Reset, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.error !== nextProps.error) {
	        this.setState({ currentPasswordErrorMessage: 'Current password did not match!' });
	      }
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	    }
	  }, {
	    key: 'removeErrorMessage',
	    value: function removeErrorMessage(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'validateInput',
	    value: function validateInput() {
	      var _this2 = this;
	
	      var validCurrentPassword = false;
	      var validNewPassword = false;
	      var validReenteredpassword = false;
	      var updated = {};
	      if (this.state.currentPassword !== '') {
	        validCurrentPassword = true;
	      } else {
	        updated.currentPasswordErrorMessage = 'Enter a valid current password.';
	      }
	      if (this.state.newPassword !== '') {
	        validNewPassword = true;
	      } else {
	        updated.newPasswordErrorMessage = 'Enter a valid new password.';
	      }
	      if (this.state.verifyNewPassword !== '' && this.state.newPassword === this.state.verifyNewPassword) {
	        validReenteredpassword = true;
	      } else {
	        updated.reEnterNewPasswordError = 'Password does not match.';
	      }
	      this.setState(updated, function () {
	        if (validReenteredpassword && validNewPassword && validCurrentPassword) {
	          _this2.props.changePassword(_this2.state.currentPassword, _this2.state.newPassword);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var renderModifyPassword = (0, _renderIf2.default)(!this.props.saved);
	      var sucessMessage = (0, _renderIf2.default)(this.props.saved);
	      var renderLoader = (0, _renderIf2.default)(this.props.requested);
	      var _state = this.state,
	          reEnterNewPasswordError = _state.reEnterNewPasswordError,
	          currentPassword = _state.currentPassword,
	          newPassword = _state.newPassword,
	          currentPasswordErrorMessage = _state.currentPasswordErrorMessage,
	          newPasswordErrorMessage = _state.newPasswordErrorMessage,
	          verifyNewPassword = _state.verifyNewPassword;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col row') },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        sucessMessage(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12') },
	          'Password updated Sucessfully.'
	        )),
	        renderModifyPassword(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6') },
	          _react2.default.createElement(
	            'div',
	            { className: currentPasswordErrorMessage === '' ? (0, _classnames2.default)('col s12', _Reset2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12', _Reset2.default.halfWidthWithSpanError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'OLD PASSWORD'
	            ),
	            _react2.default.createElement(_input2.default, {
	              type: 'password',
	              name: 'current_password',
	              value: currentPassword,
	              onFocus: function onFocus() {
	                return _this3.removeErrorMessage('currentPasswordErrorMessage');
	              },
	              onChange: function onChange(val) {
	                return _this3.handleChange('currentPassword', val);
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.currentPasswordErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: newPasswordErrorMessage === '' ? (0, _classnames2.default)('col s12', _Reset2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12', _Reset2.default.halfWidthWithSpanError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'NEW PASSWORD'
	            ),
	            _react2.default.createElement(_input2.default, {
	              type: 'password',
	              name: 'new_password',
	              value: newPassword,
	              onFocus: function onFocus() {
	                return _this3.removeErrorMessage('newPasswordErrorMessage');
	              },
	              onChange: function onChange(val) {
	                return _this3.handleChange('newPassword', val);
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.newPasswordErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: reEnterNewPasswordError === '' ? (0, _classnames2.default)('col s12', _Reset2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12', _Reset2.default.halfWidthWithSpanError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'RE-ENTER PASSWORD'
	            ),
	            _react2.default.createElement(_input2.default, {
	              type: 'password',
	              name: 're-enter-password',
	              value: verifyNewPassword,
	              onFocus: function onFocus() {
	                return _this3.removeErrorMessage('reEnterNewPasswordError');
	              },
	              onChange: function onChange(val) {
	                return _this3.handleChange('verifyNewPassword', val);
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.reEnterNewPasswordError })
	          ),
	          _react2.default.createElement(
	            _button2.default,
	            { className: (0, _classnames2.default)('col s12', _Reset2.default.continue), onClick: this.validateInput },
	            'SAVE CHANGES'
	          )
	        ))
	      );
	    }
	  }]);
	
	  return Reset;
	}(_react.Component);
	
	Reset.propTypes = {
	  changePassword: _propTypes2.default.func,
	  saved: _propTypes2.default.bool,
	  requested: _propTypes2.default.bool,
	  error: _propTypes2.default.bool
	};
	Reset.defaultProps = {
	  changePassword: function changePassword() {},
	  saved: false,
	  requested: false,
	  error: false
	};
	exports.default = Reset;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Reset = __webpack_require__(1199);
	
	var _Reset2 = _interopRequireDefault(_Reset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Reset2.default;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSlick = __webpack_require__(2364);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _Reviews = __webpack_require__(1525);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var Reviews = function (_Component) {
	  _inherits(Reviews, _Component);
	
	  function Reviews(props) {
	    _classCallCheck(this, Reviews);
	
	    var _this = _possibleConstructorReturn(this, (Reviews.__proto__ || Object.getPrototypeOf(Reviews)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Reviews, [{
	    key: 'render',
	    value: function render() {
	      var settings = {
	        dots: true,
	        speed: 500,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        autoplay: true,
	        autoplaySpeed: 2000
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Reviews2.default.reviewsContainer) },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'TESTIMONIALS'
	        ),
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: _Reviews2.default.review },
	              'We appreciate and discover large amounts of talented under-recruited players on your website and Twitter timeline.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Reviews2.default.reviewBy },
	              '"Anonymous D1 Football Coach"'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: _Reviews2.default.review },
	              'I am very pleased! Thanks, to everyone at MyRecruitBoard for helping me get recruited. It\'s an amazing service and I had a number of college coaches contact me. Very easy to use. I appreciate you all!'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Reviews2.default.reviewBy },
	              '"J. Hernandez, Texas"'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: _Reviews2.default.review },
	              'Thank you for your great service without your website I wouldn\'t have gotten recruited.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Reviews2.default.reviewBy },
	              '"Brandon V. New Jersey"'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Reviews;
	}(_react.Component);
	
	exports.default = Reviews;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Reviews = __webpack_require__(1201);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Reviews2.default;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _menu = __webpack_require__(806);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Rtiles = __webpack_require__(1526);
	
	var _Rtiles2 = _interopRequireDefault(_Rtiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	//  to change path from inside or to alter react-router-dom path
	
	
	// to import local scss fle
	
	var Rtiles = function (_Component) {
	  _inherits(Rtiles, _Component);
	
	  function Rtiles(props) {
	    _classCallCheck(this, Rtiles);
	
	    var _this = _possibleConstructorReturn(this, (Rtiles.__proto__ || Object.getPrototypeOf(Rtiles)).call(this, props));
	
	    _this.state = {
	      value: '',
	      requestCreatedBy: 'SA' // in  the my request tab it should be COACH
	    };
	    _this.addQuestionaire = _this.addQuestionaire.bind(_this);
	    _this.inviteToCamp = _this.inviteToCamp.bind(_this);
	    _this.needMoreFilms = _this.needMoreFilms.bind(_this);
	    _this.sendContactInfo = _this.sendContactInfo.bind(_this);
	    _this.addToWatchList = _this.addToWatchList.bind(_this);
	    _this.ignoredList = _this.ignoredList.bind(_this);
	    _this.getStyles = _this.getStyles.bind(_this);
	    return _this;
	  }
	  /* eslint-disable */
	
	
	  _createClass(Rtiles, [{
	    key: 'getStyles',
	    value: function getStyles(value) {
	      var returnValue = 'interestedButton';
	      if (value === 'FILL QUESTIONAIRE') {
	        returnValue = 'greenButton';
	      }
	      if (value === 'INVITE TO CAMP') {
	        returnValue = 'inviteToCampButton';
	      }
	      if (value === 'NEED MORE FILMS') {
	        returnValue = 'needMoreFilmsButton';
	      }
	      if (value === 'ADDED TO WATCHLIST') {
	        returnValue = 'addedToWatchListButton';
	      }
	      if (value === 'IGNORED') {
	        returnValue = 'ignoredButton';
	      }
	      if (value === 'SEND CONTACT INFO') {
	        returnValue = 'sendContactInfoButton';
	      }
	      return returnValue;
	    }
	    /* eslint-enable */
	
	  }, {
	    key: 'addQuestionaire',
	    value: function addQuestionaire(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'FILL QUESTIONAIRE', // let backend know if you change something here
	        link: this.props.profile.get('question_link'),
	        sa_email: email,
	        sa_name: name,
	        created_by: this.state.requestCreatedBy,
	        coach_email: this.props.attributes.get('username')
	      };
	      this.props.updateConversation(conversation);
	    }
	  }, {
	    key: 'inviteToCamp',
	    value: function inviteToCamp(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'INVITE TO CAMP',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.attributes.get('username')
	      };
	      this.props.updateConversation(conversation);
	    }
	  }, {
	    key: 'needMoreFilms',
	    value: function needMoreFilms(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'NEED MORE FILMS',
	        sa_email: email,
	        created_by: this.state.requestCreatedBy,
	        sa_name: name,
	        coach_email: this.props.attributes.get('username')
	      };
	      this.props.updateConversation(conversation);
	    }
	  }, {
	    key: 'addToWatchList',
	    value: function addToWatchList(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'ADDED TO WATCHLIST',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.attributes.get('username')
	      };
	      this.props.updateConversation(conversation);
	    }
	  }, {
	    key: 'ignoredList',
	    value: function ignoredList(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'IGNORED',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.attributes.get('username')
	      };
	      this.props.updateConversation(conversation);
	    }
	  }, {
	    key: 'sendContactInfo',
	    value: function sendContactInfo(requestId, email, name) {
	      var conversation = {
	        id: requestId,
	        action: 'SEND CONTACT INFO',
	        created_by: this.state.requestCreatedBy,
	        sa_email: email,
	        sa_name: name,
	        coach_email: this.props.attributes.get('username')
	      };
	      this.props.updateConversation(conversation);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var item = this.props.item;
	
	      var arr = [];
	      if (item.get('sa_preference') !== undefined) {
	        var preference = item.get('sa_preference');
	        arr = preference.toIndexedSeq().toArray();
	      }
	      var convo = item.get('conversation');
	      var athleteHaveProfileImage = false;
	
	      if (item.get('sa_image') !== undefined) {
	        athleteHaveProfileImage = true;
	      }
	      /* const requirements = item.get('requirements'); */
	      return _react2.default.createElement(
	        'div',
	        { className: _Rtiles2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _Rtiles2.default.tile },
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { to: '/athlete/' + item.get('from_profile_id') },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', {
	                className: _Rtiles2.default.colgeIcon,
	                src: athleteHaveProfileImage === true ? //eslint-disable-line
	                'https://s3.amazonaws.com/myrbimages/' + item.get('sa_image') : //eslint-disable-line
	                'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	                alt: 'athlete-icon'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _Rtiles2.default.collegeName },
	                item.get('sa_name')
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Rtiles2.default.sportName },
	                arr.map(function (position, i) {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    position,
	                    i < arr.length - 1 ? ', ' : ''
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Rtiles2.default.userNameIcon },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Rtiles2.default.schoolName },
	                    item.get('sa_school')
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _Rtiles2.default.cityName },
	                    item.get('sa_city'),
	                    ', ',
	                    item.get('sa_state')
	                  ),
	                  item.get('year_of_graduation') && _react2.default.createElement(
	                    'div',
	                    { className: _Rtiles2.default.cityName },
	                    'Year of graduation: ',
	                    item.get('year_of_graduation')
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(this.getStyles(convo.get(convo.size - 1).get('action'))) },
	            _react2.default.createElement(
	              'span',
	              null,
	              convo.get(convo.size - 1).get('action')
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _Rtiles2.default.dotIcons },
	              _react2.default.createElement(
	                _menu.IconMenu,
	                { icon: '...', position: 'topRight' },
	                _react2.default.createElement(
	                  _menu.MenuItem,
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                        return _this2.addQuestionaire(item.get('id'), item.get('sa_email'), item.get('sa_name'));
	                      } },
	                    'Send My Recruiting Questionaire'
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _menu.MenuItem,
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                        return _this2.inviteToCamp(item.get('id'), item.get('sa_email'), item.get('sa_name'));
	                      } },
	                    'Invite To My Camp'
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _menu.MenuItem,
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                        return _this2.needMoreFilms(item.get('id'), item.get('sa_email'), item.get('sa_name'));
	                      } },
	                    'Please Send More Film'
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _menu.MenuItem,
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                        return _this2.sendContactInfo(item.get('id'), item.get('sa_email'), item.get('sa_name'));
	                      } },
	                    'Please Send Your Contact Information'
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _menu.MenuItem,
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                        return _this2.addToWatchList(item.get('id'), item.get('sa_email'), item.get('sa_name'));
	                      } },
	                    'Add To My Watchlist'
	                  ),
	                  _react2.default.createElement('br', null)
	                ),
	                _react2.default.createElement(_Divider2.default, null),
	                _react2.default.createElement(
	                  _menu.MenuItem,
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: function onClick() {
	                        return _this2.ignoredList(item.get('id'), item.get('sa_email'), item.get('sa_name'));
	                      } },
	                    'I\'m Not Interested'
	                  ),
	                  _react2.default.createElement('br', null)
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Rtiles;
	}(_react.Component);
	
	Rtiles.propTypes = {
	  item: _propTypes2.default.shape(),
	  updateConversation: _propTypes2.default.func,
	  profile: _propTypes2.default.func.isRequired,
	  attributes: _propTypes2.default.shape
	};
	Rtiles.defaultProps = {
	  item: {},
	  updateConversation: function updateConversation() {},
	  attributes: {}
	};
	exports.default = Rtiles;

/***/ },
/* 1204 */
[2528, 1203],
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _actionTypes = __webpack_require__(129);
	
	var action = _interopRequireWildcard(_actionTypes);
	
	var _SchoolListView = __webpack_require__(1527);
	
	var _SchoolListView2 = _interopRequireDefault(_SchoolListView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	var states = {
	  AL: 'Alabama',
	  AK: 'Alaska',
	  AZ: 'Arizona',
	  AR: 'Arkansas',
	  CA: 'California',
	  CO: 'Colorado',
	  CT: 'Connecticut',
	  DE: 'Delaware',
	  FL: 'Florida',
	  GA: 'Georgia',
	  HI: 'Hawaii',
	  ID: 'Idaho',
	  IL: 'Illinois',
	  IN: 'Indiana',
	  IA: 'Iowa',
	  KS: 'Kansas',
	  KY: 'Kentucky',
	  LA: 'Louisiana',
	  ME: 'Maine',
	  MD: 'Maryland',
	  MA: 'Massachusetts',
	  MI: 'Michigan',
	  MN: 'Minnesota',
	  MS: 'Mississippi',
	  MO: 'Missouri',
	  MT: 'Montana',
	  NE: 'Nebraska',
	  NV: 'Nevada',
	  NH: 'New Hampshire',
	  NJ: 'New Jersey',
	  NM: 'New Mexico',
	  NY: 'New York',
	  NC: 'North Carolina',
	  ND: 'North Dakota',
	  OH: 'Ohio',
	  OK: 'Oklahoma',
	  OR: 'Oregon',
	  PA: 'Pennsylvania',
	  RI: 'Rhode Island',
	  SC: 'South Carolina',
	  SD: 'South Dakota',
	  TN: 'Tennessee',
	  TX: 'Texas',
	  UT: 'Utah',
	  VT: 'Vermont',
	  VA: 'Virginia',
	  WA: 'Washington D.C',
	  WN: 'Washington',
	  WV: 'West Virginia',
	  WI: 'Wisconsin',
	  WY: 'Wyoming'
	}; // to use global class name eg. classes from grid.css in public folder
	
	var SchoolListView = function SchoolListView(props) {
	  // console.log('preference: ', props.t40);
	  var clickToAdd = function clickToAdd() {
	    var payload = {
	      student_profile_id: props.profileId,
	      college_id: props.saSchool.get('id'),
	      type_of_list: 'WISHLIST'
	    };
	    props.addToList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
	  };
	
	  var clickToRemoveFromWishList = function clickToRemoveFromWishList() {
	    var payload = {
	      student_profile_id: props.profileId,
	      college_id_index: props.wishListId,
	      type_of_list: 'WISHLIST'
	    };
	    props.removeFromList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
	  };
	
	  if (props.profile !== undefined) {
	    // console.log('name: ', props.profile.get('fullname'));
	  }
	
	  var clickToRequest = function clickToRequest() {
	    var subscribed = props.subscribed,
	        onTrial = props.onTrial;
	
	    var contactedCountMap = props.profile.get('contactedCount');
	    var contactedCount = void 0;
	    if (contactedCountMap) {
	      contactedCount = contactedCountMap.toJS();
	    }
	    var counter = contactedCount.count; // eslint-disable-line
	    // console.log('contactedCount: ', contactedCount);
	    // const undefinedCase = props.profile.get('contactedCount');
	    var difference = (0, _moment2.default)().diff(contactedCount.lastContacted, 'hours');
	    // console.log('hola', counter, difference, contactedCountMap);
	    var req = {
	      from_profile_id: props.profileId,
	      college_id: props.saSchool.get('id'),
	      request_type: 'INTEREST',
	      college_name: props.saSchool.get('college'),
	      college_image: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png',
	      city: props.saSchool.get('city'),
	      division: props.saSchool.get('division'),
	      sa_name: props.fullname,
	      sa_state: states[props.state],
	      sa_preference: props.position_pref,
	      sa_school: props.school,
	      sa_city: props.city,
	      sa_image: props.sa_image,
	      sa_email: props.sa_email,
	      year_of_graduation: props.year_of_graduation,
	      team_page_link: props.saSchool.get('football_team_page'),
	      question_link: props.saSchool.get('football_questionaire_page'),
	      sa_twitter: props.profile.get('sa_twitter') !== undefined && props.profile.get('sa_twitter') !== null ? props.profile.get('sa_twitter').substring('https://twitter.com/'.length) : '',
	      sa_height: props.profile.get('height'),
	      sa_weight: props.profile.get('weight'),
	      sa_t40: props.t40,
	      request_views: props.requestViewedCount
	    };
	    var maxCount = 1;
	    if (subscribed || onTrial) {
	      maxCount = 10;
	    }
	    // if (subscribed) {
	    if (counter < maxCount || contactedCountMap === undefined) {
	      // console.log('In 1st');
	      var payload = {
	        student_profile_id: props.profileId,
	        college_id: props.saSchool.get('id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	      if (props.inWishList) {
	        clickToRemoveFromWishList();
	      }
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else if (counter >= maxCount && difference >= 23) {
	      // console.log('In 2nd');
	      var _payload = {
	        student_profile_id: props.profileId,
	        college_id: props.saSchool.get('id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(_payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	      if (props.inWishList) {
	        clickToRemoveFromWishList();
	      }
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else {
	      // console.log('subscribed');
	      props.showCounterScreen();
	    }
	    // }
	    // if (onTrial) {
	    //   console.log('Ok here in trial if');
	    //   if (counter < 10 || contactedCountMap === undefined) {
	    //     console.log('In 1st');
	    //     const payload = {
	    //       student_profile_id: props.profileId,
	    //       college_id: props.saSchool.get('id'),
	    //       type_of_list: 'CONTACTED',
	    //     };
	    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	    //     if (props.inWishList) {
	    //       clickToRemoveFromWishList();
	    //     }
	    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //     props.showSnackBar('Added to contacted list, will keep you informed.');
	    //   } else if (counter >= 10 && difference >= 4) {
	    //     console.log('In 2nd');
	    //     const payload = {
	    //       student_profile_id: props.profileId,
	    //       college_id: props.saSchool.get('id'),
	    //       type_of_list: 'CONTACTED',
	    //     };
	    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	    //     if (props.inWishList) {
	    //       clickToRemoveFromWishList();
	    //     }
	    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //     props.showSnackBar('Added to contacted list, will keep you informed.');
	    //   } else {
	    //     console.log('trial');
	    //     props.showCounterScreen();
	    //   }
	    // }
	    // if (!subscribed && (counter < 1 || contactedCountMap === undefined)) {
	    //   // eslint-disable-next-line no-debugger
	    //   // debugger;
	    //   const payload = {
	    //     student_profile_id: props.profileId,
	    //     college_id: props.saSchool.get('id'),
	    //     type_of_list: 'CONTACTED',
	    //   };
	    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	    //   if (props.inWishList) {
	    //     clickToRemoveFromWishList();
	    //   }
	    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //   props.showSnackBar('Added to contacted list, will keep you informed.');
	    // } else if (!subscribed && (counter >= 1 && difference >= 5)) {
	    //   // eslint-disable-next-line no-debugger
	    //   // debugger;
	    //   const payload = {
	    //     student_profile_id: props.profileId,
	    //     college_id: props.saSchool.get('id'),
	    //     type_of_list: 'CONTACTED',
	    //   };
	    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	    //   if (props.inWishList) {
	    //     clickToRemoveFromWishList();
	    //   }
	    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //   props.showSnackBar('Added to contacted list, will keep you informed.');
	    // } else if (!subscribed && !onTrial) {
	    //   console.log('free');
	    //   props.showCounterScreen();
	    // }
	  };
	
	  var renderIfIgnored = (0, _renderIf2.default)(props.ignoreListId === -1);
	
	  var showDefaultStatus = props.fillQ || props.inviteToCamp;
	  var renderDefaultStatus = (0, _renderIf2.default)(!showDefaultStatus);
	
	  var renderFillQ = (0, _renderIf2.default)(props.fillQ && !props.inviteToCamp);
	  var renderInviteToCamp = (0, _renderIf2.default)(props.inviteToCamp);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _SchoolListView2.default.container) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _SchoolListView2.default.listInBig) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s5', _SchoolListView2.default.firstDiv) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s2', _SchoolListView2.default.removePadding) },
	          _react2.default.createElement('img', { className: _SchoolListView2.default.colgeIcon, src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s10', _SchoolListView2.default.textContainer) },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.collegeName },
	              _react2.default.createElement(
	                'a',
	                { href: props.saSchool.get('football_team_page'), target: '_blank' },
	                props.saSchool.get('college')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.lightText },
	              props.saSchool.get('state')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _SchoolListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s8', _SchoolListView2.default.textContainer) },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.collegeName },
	              props.saSchool.get('city')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.lightText },
	              props.saSchool.get('division')
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: (0, _classnames2.default)('col s1', _SchoolListView2.default.lastDiv) }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _SchoolListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: _SchoolListView2.default.buttonContainer },
	          renderIfIgnored(_react2.default.createElement(
	            'span',
	            null,
	            props.inWishList ? _react2.default.createElement(
	              'a',
	              { href: 'javascript:void(0)', title: 'Add to wishList', onClick: clickToRemoveFromWishList },
	              _react2.default.createElement('img', { className: _SchoolListView2.default.heartIcon, src: 'https://media.dev.myrecruitboard.com/Images/heart-full.png', alt: 'heartIcon' })
	            ) : _react2.default.createElement(
	              'a',
	              { href: 'javascript:void(0)', title: 'Add to wishList', onClick: clickToAdd },
	              _react2.default.createElement('img', { className: _SchoolListView2.default.heartIcon, src: 'https://media.dev.myrecruitboard.com/Images/hearIcon.png', alt: 'heartIcon' })
	            ),
	            props.interested ? _react2.default.createElement(
	              'button',
	              { className: _SchoolListView2.default.interested },
	              renderDefaultStatus('Awaiting Response'),
	              renderFillQ('Fill Questionaire'),
	              renderInviteToCamp('Invited to Camp')
	            ) : _react2.default.createElement(
	              'button',
	              { className: _SchoolListView2.default.respond, onClick: clickToRequest },
	              'CONTACT COACH'
	            )
	          ))
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _SchoolListView2.default.listInSmall) },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s3', _SchoolListView2.default.firstDiv) },
	        _react2.default.createElement('img', { className: _SchoolListView2.default.colgeIcon, src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s9', _SchoolListView2.default.equalDivs) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _SchoolListView2.default.textContainer) },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.collegeName },
	              _react2.default.createElement(
	                'a',
	                { href: props.saSchool.get('football_team_page'), target: '_blank' },
	                props.saSchool.get('college')
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.lightText },
	              props.saSchool.get('state')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.lightText },
	              props.saSchool.get('city')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _SchoolListView2.default.lightText },
	              props.saSchool.get('division')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _SchoolListView2.default.absoluteHeart },
	          props.inWishList ? _react2.default.createElement(
	            'a',
	            { href: 'javascript:void(0)', title: 'Add to wishList', onClick: clickToRemoveFromWishList },
	            _react2.default.createElement('img', { className: _SchoolListView2.default.heartIcon, src: 'https://media.dev.myrecruitboard.com/Images/heart-full.png', alt: 'heartIcon' })
	          ) : _react2.default.createElement(
	            'a',
	            { href: 'javascript:void(0)', title: 'Add to wishList', onClick: clickToAdd },
	            _react2.default.createElement('img', { className: _SchoolListView2.default.heartIcon, src: 'https://media.dev.myrecruitboard.com/Images/hearIcon.png', alt: 'heartIcon' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _SchoolListView2.default.smallButtonContainer) },
	        _react2.default.createElement(
	          'button',
	          { onClick: clickToRequest },
	          'CONTACT COACH'
	        )
	      )
	    )
	  );
	};
	
	SchoolListView.propTypes = {
	  saSchool: _propTypes2.default.shape().isRequired,
	  inWishList: _propTypes2.default.bool,
	  inviteToCamp: _propTypes2.default.bool,
	  fillQ: _propTypes2.default.bool,
	  profileId: _propTypes2.default.string.isRequired,
	  fullname: _propTypes2.default.string.isRequired,
	  position_pref: _propTypes2.default.string.isRequired,
	  state: _propTypes2.default.string.isRequired,
	  city: _propTypes2.default.string.isRequired,
	  sa_image: _propTypes2.default.string.isRequired,
	  school: _propTypes2.default.string.isRequired,
	  addToList: _propTypes2.default.func.isRequired,
	  addToRequest: _propTypes2.default.func.isRequired,
	  interested: _propTypes2.default.bool,
	  wishListId: _propTypes2.default.number, // eslint-disable-line
	  removeFromList: _propTypes2.default.func.isRequired, // eslint-disable-line
	  ignoreListId: _propTypes2.default.number,
	  showSnackBar: _propTypes2.default.func.isRequired,
	  sa_email: _propTypes2.default.string.isRequired,
	  profile: _propTypes2.default.shape().isRequired,
	  showCounterScreen: _propTypes2.default.func.isRequired,
	  year_of_graduation: _propTypes2.default.string.isRequired,
	  weight: _propTypes2.default.string.isRequired,
	  height: _propTypes2.default.string.isRequired,
	  requestViewedCount: _propTypes2.default.number.isRequired,
	  t40: _propTypes2.default.string.isRequired
	};
	
	SchoolListView.defaultProps = {
	  inWishList: false,
	  interested: false,
	  wishListId: -1,
	  ignoreListId: -1,
	  inviteToCamp: false,
	  fillQ: false
	};
	
	exports.default = SchoolListView;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _actionTypes = __webpack_require__(129);
	
	var action = _interopRequireWildcard(_actionTypes);
	
	var _SchoolTile = __webpack_require__(1528);
	
	var _SchoolTile2 = _interopRequireDefault(_SchoolTile);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	// un comment the below block to enable ignore functionality
	/* import { IconMenu, MenuItem } from 'react-toolbox/lib/menu'; */
	var SchoolTile = function SchoolTile(props) {
	  // console.log('props in schoolTile: ', props);
	  var clickToRemoveFromWishList = function clickToRemoveFromWishList() {
	    var payload = {
	      student_profile_id: props.profileId,
	      college_id_index: props.wishListId,
	      type_of_list: 'WISHLIST',
	      sa_email: props.sa_email
	
	    };
	    props.removeFromList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
	  };
	  var clickToAdd = function clickToAdd() {
	    var payload = {
	      student_profile_id: props.profileId,
	      college_id: props.saSchool.get('id'),
	      type_of_list: 'WISHLIST'
	
	    };
	    props.addToList(payload, action.UPDATE_WISHLIST, 'sa_wishlist');
	  };
	
	  // TODO un comment the below block to enable ignore functionality
	
	  /* const clickToIgnore = () => {
	    const payload = {
	      student_profile_id: props.profileId,
	      college_id: props.saSchool.get('id'),
	      type_of_list: 'IGNORE',
	    };
	    props.addToList(payload, action.UPDATE_IGNORELIST, 'sa_ignorelist');
	  }; */
	
	  var clickToUnIgnore = function clickToUnIgnore() {
	    var payload = {
	      student_profile_id: props.profileId,
	      college_id_index: props.ignoreListId,
	      type_of_list: 'IGNORE',
	      sa_email: props.sa_email
	
	    };
	    props.removeFromList(payload, action.UPDATE_IGNORELIST, 'sa_ignorelist');
	  };
	
	  var clickToRequest = function clickToRequest() {
	    var subscribed = props.subscribed,
	        onTrial = props.onTrial;
	
	    var contactedCountMap = props.profile.get('contactedCount');
	    // const trialEndDate = props.profile.get('trialEndDate');
	    var contactedCount = void 0;
	    if (contactedCountMap) {
	      contactedCount = contactedCountMap.toJS();
	    }
	    var counter = contactedCount.count; // eslint-disable-line
	    // console.log('contactedCount ontrial: ', contactedCount, onTrial);
	    // const undefinedCase = props.profile.get('contactedCount');
	    // const difference = moment().diff(contactedCount.lastContacted, 'hours');
	    var difference = (0, _moment2.default)().isSame((0, _moment2.default)(contactedCount.lastContacted), 'day');
	    // eslint-disable-next-line no-console
	    // console.log('check', moment().isAfter(contactedCount.lastContacted, 'days'));
	    // eslint-disable-next-line no-console
	    // console.log('school tile', counter, difference, contactedCount, moment());
	
	    var req = {
	      from_profile_id: props.profileId,
	      college_id: props.saSchool.get('id'),
	      request_type: 'INTEREST',
	      college_name: props.saSchool.get('college'),
	      college_image: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png',
	      city: props.saSchool.get('city'),
	      division: props.saSchool.get('division'),
	      sa_name: props.fullname,
	      sa_state: _DropdownsValues.states[props.state],
	      sa_preference: props.position_pref,
	      sa_school: props.school,
	      sa_city: props.city,
	      sa_image: props.sa_image,
	      sa_email: props.sa_email,
	      year_of_graduation: props.year_of_graduation,
	      team_page_link: props.saSchool.get('football_team_page'),
	      question_link: props.saSchool.get('football_questionaire_page'),
	      sa_twitter: props.profile.get('sa_twitter') !== undefined && props.profile.get('sa_twitter') !== null ? props.profile.get('sa_twitter').substring('https://twitter.com/'.length) : '',
	      sa_height: props.profile.get('height'),
	      sa_weight: props.profile.get('weight'),
	      sa_t40: props.t40,
	      request_views: props.requestViewedCount
	    };
	
	    var maxCount = 1;
	    if (subscribed || onTrial) {
	      maxCount = 10;
	    }
	
	    // if (subscribed) {
	    if (counter < maxCount || contactedCountMap === undefined) {
	      // console.log('In 1st');
	      var payload = {
	        student_profile_id: props.profileId,
	        college_id: props.saSchool.get('id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	      if (props.inWishList) {
	        clickToRemoveFromWishList();
	      }
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else if (counter >= maxCount && !difference) {
	      // console.log('In 2nd');
	      var _payload = {
	        student_profile_id: props.profileId,
	        college_id: props.saSchool.get('id'),
	        type_of_list: 'CONTACTED'
	      };
	      props.addToList(_payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	      if (props.inWishList) {
	        clickToRemoveFromWishList();
	      }
	      props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	      props.showSnackBar('Added to contacted list, will keep you informed.');
	    } else {
	      // console.log('subscribed');
	      props.showCounterScreen();
	    }
	    // }
	    // if (onTrial) {
	    //   console.log('Ok here in trial if');
	    //   if (counter < 10 || contactedCountMap === undefined) {
	    //     console.log('In 1st');
	    //     const payload = {
	    //       student_profile_id: props.profileId,
	    //       college_id: props.saSchool.get('id'),
	    //       type_of_list: 'CONTACTED',
	    //     };
	    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	    //     if (props.inWishList) {
	    //       clickToRemoveFromWishList();
	    //     }
	    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //     props.showSnackBar('Added to contacted list, will keep you informed.');
	    //   } else if (counter >= 10 && difference >= 4) {
	    //     console.log('In 2nd');
	    //     const payload = {
	    //       student_profile_id: props.profileId,
	    //       college_id: props.saSchool.get('id'),
	    //       type_of_list: 'CONTACTED',
	    //     };
	    //     props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	    //     if (props.inWishList) {
	    //       clickToRemoveFromWishList();
	    //     }
	    //     props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //     props.showSnackBar('Added to contacted list, will keep you informed.');
	    //   } else {
	    //     console.log('trial');
	    //     props.showCounterScreen();
	    //   }
	    // }
	
	    // if (!subscribed && (counter < 1 || contactedCountMap === undefined)) {
	    //   // eslint-disable-next-line no-debugger
	    //   // debugger;
	    //   const payload = {
	    //     student_profile_id: props.profileId,
	    //     college_id: props.saSchool.get('id'),
	    //     type_of_list: 'CONTACTED',
	    //   };
	    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	
	    //   if (props.inWishList) {
	    //     clickToRemoveFromWishList();
	    //   }
	    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //   props.showSnackBar('Added to contacted list, will keep you informed.');
	    // } else if (!subscribed && (counter >= 1 && difference >= 5)) {
	    //   // eslint-disable-next-line no-debugger
	    //   // debugger;
	    //   const payload = {
	    //     student_profile_id: props.profileId,
	    //     college_id: props.saSchool.get('id'),
	    //     type_of_list: 'CONTACTED',
	    //   };
	    //   props.addToList(payload, action.UPDATE_CONTACTEDLIST, 'sa_contactedlist');
	    //   if (props.inWishList) {
	    //     clickToRemoveFromWishList();
	    //   }
	    //   props.addToRequest(req, action.UPDATE_CONTACTED); // eslint-disable-line
	    //   props.showSnackBar('Added to contacted list, will keep you informed.');
	    // } else if (!subscribed && !onTrial) {
	    //   console.log('free');
	    //   props.showCounterScreen();
	    // }
	  };
	
	  // const handleRequest = () => {
	  //   const counter = parseInt(props.syncData.get('count')); // eslint-disable-line
	  //   const difference = moment().diff(props.syncData.get('lastModified'), 'minutes');
	  //   console.log('difference', difference);
	  //   if (counter < 2) {
	  //     clickToRequest;
	  //   } else if (counter === 2 && difference > 1) {
	  //     clickToRequest;
	  //   } else {
	  //     props.showCounterScreen();
	  //   }
	  // };
	
	  var renderIfIgnored = (0, _renderIf2.default)(props.ignoreListId === -1);
	  var renderIfUnIgnored = (0, _renderIf2.default)(props.ignoreListId >= 0);
	  var showDefaultStatus = props.fillQ || props.inviteToCamp || props.interested;
	  var renderDefaultStatus = (0, _renderIf2.default)(showDefaultStatus);
	
	  var renderFillQ = (0, _renderIf2.default)(props.fillQ && !props.inviteToCamp);
	  var renderInviteToCamp = (0, _renderIf2.default)(props.inviteToCamp);
	  var renderJuco = false;
	  if (props.saSchool.get('division') === 'SCFA' || props.saSchool.get('division') === 'NJCAA' || props.saSchool.get('division') === 'CCCAA') {
	    renderJuco = true;
	  }
	
	  // const trialEndDate = props.profile.get('trialEndDate');
	  // console.log('trialdate', trialEndDate);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _SchoolTile2.default.container },
	    _react2.default.createElement('img', { className: _SchoolTile2.default.hide, src: 'https://media.dev.myrecruitboard.com/Images/heart-full.png', alt: 'heartIcon' }),
	    _react2.default.createElement(
	      'div',
	      { className: _SchoolTile2.default.tile },
	      renderIfIgnored(_react2.default.createElement(
	        'span',
	        null,
	        props.inWishList ? _react2.default.createElement(
	          'a',
	          { href: 'javascript:void(0)', title: 'Add to wishList', onClick: clickToRemoveFromWishList },
	          _react2.default.createElement('img', { className: _SchoolTile2.default.heartIcon, src: 'https://media.dev.myrecruitboard.com/Images/heart-full.png', alt: 'heartIcon' })
	        ) : _react2.default.createElement(
	          'a',
	          { href: 'javascript:void(0)', title: 'Add to wishList', onClick: clickToAdd },
	          _react2.default.createElement('img', { className: _SchoolTile2.default.heartIcon, src: 'https://media.dev.myrecruitboard.com/Images/hearIcon.png', alt: 'heartIcon' })
	        )
	      )),
	      _react2.default.createElement('img', { className: _SchoolTile2.default.colgeIcon, src: 'https://media.dev.myrecruitboard.com/Images/myrb-logo-for-college.png', alt: 'college-icon' }),
	      _react2.default.createElement(
	        'div',
	        { className: props.usedFor === 'schools' ? _SchoolTile2.default.collegeName : _SchoolTile2.default.collegeNameOnWishList },
	        _react2.default.createElement(
	          'a',
	          { href: props.saSchool.get('football_team_page'), target: '_blank' },
	          props.saSchool.get('college')
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _SchoolTile2.default.lightText },
	          props.saSchool.get('city')
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _SchoolTile2.default.lightText },
	          props.saSchool.get('state') === 'D.C.' ? 'Washington D.C' : props.saSchool.get('state')
	        )
	      ),
	      props.usedFor === 'schools' ? '' : _react2.default.createElement('br', null),
	      renderJuco === true ? _react2.default.createElement(
	        'span',
	        { className: _SchoolTile2.default.lightText },
	        'JUCO'
	      ) : _react2.default.createElement(
	        'span',
	        { className: _SchoolTile2.default.lightText },
	        props.saSchool.get('division')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: props.usedFor === 'schools' ? _SchoolTile2.default.veryLightTextt : _SchoolTile2.default.veryLightTextWithHeight },
	        renderDefaultStatus(_react2.default.createElement(
	          'span',
	          null,
	          'Awaiting Response'
	        )),
	        renderFillQ(_react2.default.createElement(
	          'span',
	          null,
	          'Fill Questionaire'
	        )),
	        renderInviteToCamp(_react2.default.createElement(
	          'span',
	          null,
	          'Invited to Camp'
	        ))
	      ),
	      renderIfUnIgnored(_react2.default.createElement(
	        'div',
	        { className: _SchoolTile2.default.tileFooter },
	        _react2.default.createElement(
	          'span',
	          { className: _SchoolTile2.default.unignore, onClick: clickToUnIgnore },
	          'UNIGNORE'
	        )
	      )),
	      renderIfIgnored(_react2.default.createElement(
	        'div',
	        { className: props.interested ? _SchoolTile2.default.coloredTileFooter : _SchoolTile2.default.tileFooter },
	        props.interested ? _react2.default.createElement(
	          'span',
	          null,
	          'INTERESTED'
	        ) : _react2.default.createElement(
	          'span',
	          { className: _SchoolTile2.default.clickable, onClick: function onClick() {
	              return clickToRequest();
	            } },
	          'CONTACT COACH'
	        ),
	        _react2.default.createElement('span', { className: _SchoolTile2.default.dotIcons })
	      ))
	    )
	  );
	};
	
	SchoolTile.propTypes = {
	  saSchool: _propTypes2.default.shape().isRequired,
	  inWishList: _propTypes2.default.bool,
	  inviteToCamp: _propTypes2.default.bool,
	  fillQ: _propTypes2.default.bool,
	  profileId: _propTypes2.default.string.isRequired,
	  fullname: _propTypes2.default.string.isRequired,
	  state: _propTypes2.default.string.isRequired,
	  position_pref: _propTypes2.default.string.isRequired,
	  city: _propTypes2.default.string.isRequired,
	  sa_image: _propTypes2.default.string.isRequired,
	  school: _propTypes2.default.string.isRequired,
	  addToList: _propTypes2.default.func.isRequired,
	  addToRequest: _propTypes2.default.func.isRequired,
	  interested: _propTypes2.default.bool,
	  wishListId: _propTypes2.default.number, // eslint-disable-line
	  removeFromList: _propTypes2.default.func.isRequired, // eslint-disable-line
	  ignoreListId: _propTypes2.default.number,
	  showSnackBar: _propTypes2.default.func.isRequired,
	  sa_email: _propTypes2.default.string.isRequired,
	  profile: _propTypes2.default.shape(), // eslint-disable-line
	  showCounterScreen: _propTypes2.default.func.isRequired,
	  year_of_graduation: _propTypes2.default.string.isRequired,
	  t40: _propTypes2.default.string.isRequired,
	  requestViewedCount: _propTypes2.default.number.isRequired
	};
	
	SchoolTile.defaultProps = {
	  inWishList: false,
	  interested: false,
	  wishListId: -1,
	  ignoreListId: -1,
	  inviteToCamp: false,
	  fillQ: false,
	  user: {}
	  // syncData: {},
	};
	
	exports.default = SchoolTile;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _localStorage = __webpack_require__(56);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Userinfo = __webpack_require__(109);
	
	var _Userinfo2 = _interopRequireDefault(_Userinfo);
	
	var _SearchUser = __webpack_require__(1529);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { ViewAthlete, CoachDashboard } from 'routes/routeNames';
	
	
	var SearchUser = function (_Component) {
	  _inherits(SearchUser, _Component);
	
	  function SearchUser(props) {
	    _classCallCheck(this, SearchUser);
	
	    var _this = _possibleConstructorReturn(this, (SearchUser.__proto__ || Object.getPrototypeOf(SearchUser)).call(this, props));
	
	    _this.userNameHandler = function (username) {
	      _this.setState({ username: username, errorMessage: '' });
	    };
	
	    _this.identifyEnter = function (e) {
	      var username = _this.state.username;
	      var userType = _this.props.userType;
	
	      var code = e.keyCode ? e.keyCode : e.which;
	      if (code === 13) {
	        // Enter keycode
	        var payload = {};
	        if (userType === 'STUDENT') {
	          payload = Object.assign({
	            sa_email: username
	          });
	        } else {
	          payload = Object.assign({
	            coach_email: username
	          });
	        }
	        var validEmail = _Regularexpression.regExForEmail.test(username);
	        if (username !== '' && validEmail) {
	          _this.props.SearchUser(payload, userType);
	        } else {
	          _this.setState({ errorMessage: 'Please enter a valid username.' });
	        }
	      }
	    };
	
	    _this.searchUser = function () {
	      var username = _this.state.username;
	      var userType = _this.props.userType;
	
	      var payload = {};
	      if (userType === 'STUDENT') {
	        payload = Object.assign({
	          sa_email: username
	        });
	      } else {
	        payload = Object.assign({
	          coach_email: username
	        });
	      }
	      var validEmail = _Regularexpression.regExForEmail.test(username);
	      if (username !== '' && validEmail) {
	        _this.props.SearchUser(payload, userType);
	      } else {
	        _this.setState({ errorMessage: 'Please enter a valid username.' });
	      }
	    };
	
	    _this.removeUserInfo = function () {
	      _this.props.catchUserInfo('studentInfo', {});
	      _this.props.catchUserInfo();
	    };
	
	    _this.state = {
	      user: '',
	      username: '',
	      errorMessage: ''
	    };
	    return _this;
	  }
	
	  _createClass(SearchUser, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var userType = this.props.userType;
	
	      if (nextProps.searchHappened && nextProps.searchUserData.size === 0 || nextProps.error !== '') {
	        this.setState({ errorMessage: 'User not found.' });
	      }
	      if (nextProps.searchUserData.size > 0 && this.props.userInfo.name === undefined) {
	        var results = nextProps.searchUserData.get('hits');
	        var totalHits = results.get('hits').size;
	        if (totalHits > 0) {
	          results = results.get('hits');
	          results = results.toJS();
	          var firstItemFromElastic = results[0]._source; // eslint-disable-line
	          if (userType === 'STUDENT') {
	            (0, _localStorage.setItem)('user_cred', firstItemFromElastic.id);
	            (0, _localStorage.setItem)('localZone', 'STUDENT');
	            var football = firstItemFromElastic.sports.FOOTBALL;
	            var userInfo = {
	              name: firstItemFromElastic.fullname,
	              student_id: firstItemFromElastic.id,
	              email: firstItemFromElastic.sa_email,
	              school: firstItemFromElastic.school,
	              evaluationText: firstItemFromElastic.evaluation_text,
	              overrideDivision: firstItemFromElastic.override_division,
	              t40: football.t40,
	              squats: football.squats,
	              bench: football.bench,
	              primaryOff: football.primary_offensive_position_pref,
	              primaryDef: football.primary_defensive_position_pref,
	              secondaryOff: football.secondary_defensive_position_pref,
	              secondaryDef: football.secondary_defensive_position_pref,
	              id: firstItemFromElastic.id
	            };
	            this.props.catchUserInfo('studentInfo', userInfo);
	          } else {
	            (0, _localStorage.setItem)('user_cred', firstItemFromElastic.coach_id);
	            (0, _localStorage.setItem)('localZone', 'COACH');
	            var _userInfo = {
	              name: firstItemFromElastic.name,
	              coach_id: firstItemFromElastic.coach_id,
	              email: firstItemFromElastic.coach_email,
	              college: firstItemFromElastic.college
	            };
	            this.props.catchUserInfo('coachInfo', _userInfo);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          searchUserRequested = _props.searchUserRequested,
	          userInfo = _props.userInfo,
	          label = _props.label,
	          fieldHeader = _props.fieldHeader,
	          userType = _props.userType;
	
	      var renderLoader = (0, _renderIf2.default)(searchUserRequested);
	      var renderSearchComponent = (0, _renderIf2.default)(userInfo.name === undefined);
	      var renderUserInfo = (0, _renderIf2.default)(userInfo.name !== undefined);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _SearchUser2.default.removePadding) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderUserInfo(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Userinfo2.default, { userInfo: userInfo, userType: userType }),
	          userType === 'STUDENT' ? _react2.default.createElement(_CustomButton2.default, {
	            type: 'submit', label: 'SEARCH ANOTHER USER',
	            onClick: this.removeUserInfo,
	            style: _SearchUser2.default.buttonContainer
	          }) : ''
	        )),
	        renderSearchComponent(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m4', _SearchUser2.default.removePadding) },
	          _react2.default.createElement(_TextField2.default, {
	            label: fieldHeader === undefined ? 'ENTER USER EMAIL' : fieldHeader,
	            onChange: this.userNameHandler, onKeyPress: this.identifyEnter
	          }),
	          _react2.default.createElement(_ErrorMessage2.default, { message: this.state.errorMessage }),
	          _react2.default.createElement(_CustomButton2.default, {
	            type: 'submit', label: label === undefined ? 'SEARCH USER' : label,
	            onClick: this.searchUser
	          })
	        ))
	      );
	    }
	  }]);
	
	  return SearchUser;
	}(_react.Component);
	
	SearchUser.propTypes = {
	  SearchUser: _propTypes2.default.func.isRequired,
	  searchUserRequested: _propTypes2.default.bool.isRequired,
	  searchUserData: _propTypes2.default.bool.isRequired, // eslint-disable-line
	  userType: _propTypes2.default.string.isRequired,
	  userInfo: _propTypes2.default.shape.isRequired,
	  catchUserInfo: _propTypes2.default.func.isRequired,
	  fieldHeader: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  searchHappened: _propTypes2.default.bool.isRequired, // eslint-disable-line
	  error: _propTypes2.default.string.isRequired // eslint-disable-line
	};
	SearchUser.defaultProps = {
	  fieldHeader: undefined,
	  label: undefined
	};
	exports.default = SearchUser;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(11);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _UserAthelete = __webpack_require__(1288);
	
	var _UserAthelete2 = _interopRequireDefault(_UserAthelete);
	
	var _SearchUserByFullName = __webpack_require__(1530);
	
	var _SearchUserByFullName2 = _interopRequireDefault(_SearchUserByFullName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
	
	// import Tiles from '../../containers/Admin/components/StudentView/components/Tiles';
	
	
	var SearchUserByFullName = function (_Component) {
	  _inherits(SearchUserByFullName, _Component);
	
	  function SearchUserByFullName(props) {
	    _classCallCheck(this, SearchUserByFullName);
	
	    var _this = _possibleConstructorReturn(this, (SearchUserByFullName.__proto__ || Object.getPrototypeOf(SearchUserByFullName)).call(this, props));
	
	    _this.handleChange = function (name, value) {
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.searchAnotherStudent = function () {
	      _this.setState({
	        username: '',
	        errorMessage: '',
	        name: '',
	        student_id: '',
	        key: '',
	        email: undefined,
	        school: '',
	        evaluationText: '',
	        overrideDivision: '',
	        t40: '',
	        squats: '',
	        bench: '',
	        primaryOff: '',
	        primaryDef: '',
	        secondaryOff: '',
	        secondaryDef: '',
	        id: '',
	        studentfullname: '',
	        fullNames: [],
	        fullnameoncontact: ''
	      });
	    };
	
	    _this.searchStudent = function () {
	      if (_this.state.firstname === '' && _this.state.lastname === '') {
	        _this.setState({ firstNameErrorMessage: 'Please enter a first name!',
	          lastNameErrorMessage: 'Please enter a last name!'
	        });
	      } else {
	        _this.setState({ firstNameErrorMessage: '',
	          lastNameErrorMessage: ''
	        });
	        var StudentFullName = _this.state.firstname.concat(' ', _this.state.lastname);
	        var payload = {};
	        payload = Object.assign({
	          full_name: StudentFullName
	        });
	        _this.props.SearchAtheleteByName(payload);
	      }
	      _this.setState({ errorMessage: ''
	      });
	    };
	
	    _this.state = {
	      firstname: '',
	      lastname: '',
	      firstNameErrorMessage: '',
	      lastNameErrorMessage: '',
	      username: '',
	      errorMessage: '',
	      name: '',
	      student_id: '',
	      key: '',
	      email: undefined,
	      school: '',
	      evaluationText: '',
	      overrideDivision: '',
	      t40: '',
	      squats: '',
	      bench: '',
	      primaryOff: '',
	      primaryDef: '',
	      secondaryOff: '',
	      secondaryDef: '',
	      id: '',
	      studentfullname: '',
	      // fullNames: [],
	      // fullnameoncontact: '',
	      filterStudentByName: (0, _immutable.List)()
	    };
	    return _this;
	  }
	
	  _createClass(SearchUserByFullName, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.searchEsUserData && nextProps.searchEsUserData.size === 0 && nextProps.searchEsUserRequested === false) {
	        this.setState({ errorMessage: 'User not found.' });
	      }
	      if (nextProps.searchEsUserData && nextProps.searchEsUserData.size > 0) {
	        // const total = nextProps.filterBasedEsStudents.get('hits').get('total');
	        // const hits = [];
	        // if (total > 0) {
	        // let results = nextProps.filterBasedEsStudents.get('hits');
	        // results = results.get('hits');
	        // results = results.toJS();
	        this.setState({ filterStudentByName: nextProps.searchEsUserData.toJS() });
	        // const results = nextProps.searchEsUserData;
	        // results.forEach((fname) => {
	        //   const grad = fname.get('academic');
	        //   const sport = fname.get('sports');
	        //   const position = sport.get('FOOTBALL');
	        //   const obj = {};
	        //   const name = fname.get('fullname');
	        //   const city = fname.get('city');
	        //   const state = fname.get('state');
	        //   const studentid = fname.get('id');
	        //   const email = fname.get('sa_email');
	        //   const school = fname.get('school');
	        //   const evaluationText = fname.get('evaluation_text');
	        //   const overrideDivision = fname.get('override_division');
	        //   const t40 = position.get('t40');
	        //   const squats = position.get('squats');
	        //   const bench = position.get('bench');
	        //   const primaryOff = position.get('primary_offensive_position_pref');
	        //   const primaryDef = position.get('primary_defensive_position_pref');
	        //   const secondaryOff = position.get('secondary_offensive_position_pref');
	        //   const secondaryDef = position.get('secondary_defensive_position_pref');
	        //   const yearOfGraduation = grad.get('year_of_graduation');
	        //   const gpa = grad.get('gpa');
	        //   const id = fname.get('id');
	        //   const idKey = studentid;
	        //   obj.value = name;
	        //   obj.student_id = studentid;
	        //   obj.email = email;
	        //   obj.state = state;
	        //   obj.city = city;
	        //   obj.school = school;
	        //   obj.t40 = t40;
	        //   obj.squats = squats;
	        //   obj.bench = bench;
	        //   obj.id = id;
	        //   obj.gpa = gpa;
	        //   obj.name = name;
	        //   obj.primary_offensive_position_pref = primaryOff;
	        //   obj.primary_defensive_position_pref = primaryDef;
	        //   obj.secondary_offensive_position_pref = secondaryOff;
	        //   obj.secondary_defensive_position_pref = secondaryDef;
	        //   obj.overrideDivision = overrideDivision;
	        //   obj.evaluationText = evaluationText;
	        //   obj.year_of_graduation = yearOfGraduation;
	        //   obj.Key = idKey;
	        //   hits.push(obj);
	        // });
	        // this.setState({ fullNames: hits });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var filterStudentByName = this.state.filterStudentByName;
	      var searchEsUserRequested = this.props.searchEsUserRequested;
	
	      var renderLoader = (0, _renderIf2.default)(searchEsUserRequested === true);
	      var renderSearchComponent = (0, _renderIf2.default)(true);
	      var renderUserInfo = (0, _renderIf2.default)(true);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _SearchUserByFullName2.default.removePadding) },
	        renderSearchComponent(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m4 l2', _SearchUserByFullName2.default.removePaddingInnerDiv) },
	            _react2.default.createElement(_TextField2.default, {
	              label: 'ENTER FIRST NAME',
	              onChange: function onChange(val) {
	                return _this2.handleChange('firstname', val);
	              },
	              value: this.state.firstname,
	              errorMessage: this.state.firstNameErrorMessage
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m4 l2', _SearchUserByFullName2.default.removePaddingInnerDiv) },
	            _react2.default.createElement(_TextField2.default, {
	              label: 'ENTER LAST NAME',
	              onChange: function onChange(val) {
	                return _this2.handleChange('lastname', val);
	              },
	              value: this.state.lastname,
	              errorMessage: this.state.lastNameErrorMessage
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m4 l2', _SearchUserByFullName2.default.removePaddingInnerDiv), style: { marginTop: 5 } },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_CustomButton2.default, {
	                type: 'submit', label: 'SEARCH USER',
	                onClick: this.searchStudent,
	                style: _SearchUserByFullName2.default.buttonContainer
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.errorMessage })
	            )
	          )
	        )),
	        renderLoader(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _SearchUserByFullName2.default.removePadding) },
	          _react2.default.createElement(_FullScreenLoader2.default, null),
	          ','
	        )),
	        renderUserInfo(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _SearchUserByFullName2.default.removePadding), style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' } },
	          filterStudentByName.map(function (item) {
	            return _react2.default.createElement(_UserAthelete2.default, { item: item });
	          })
	        ))
	      );
	    }
	  }]);
	
	  return SearchUserByFullName;
	}(_react.Component);
	
	SearchUserByFullName.propTypes = {
	  SearchAtheleteByName: _propTypes2.default.func.isRequired,
	  searchEsUserData: _propTypes2.default.shape().isRequired, // eslint-disable-line
	  searchEsUserRequested: _propTypes2.default.bool.isRequired,
	  // IsLoading: PropTypes.bool.isRequired,
	  // userType: PropTypes.string.isRequired,
	  // catchUserInfo: PropTypes.func.isRequired,
	  // writeCollegeName: PropTypes.func,
	  // searchEsHappened: PropTypes.bool.isRequired, // eslint-disable-line
	  esError: _propTypes2.default.string.isRequired // eslint-disable-line
	  // filterBasedEsStudents: PropTypes.shape().isRequired,
	};
	SearchUserByFullName.defaultProps = {
	  fieldHeader: undefined,
	  label: undefined,
	  searchSchools: function searchSchools() {},
	  writeCollegeName: function writeCollegeName() {}
	};
	exports.default = SearchUserByFullName;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SearchUserByFullName = __webpack_require__(1208);
	
	var _SearchUserByFullName2 = _interopRequireDefault(_SearchUserByFullName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SearchUserByFullName2.default;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = Sendgrid;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _actions = __webpack_require__(1212);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _Session = __webpack_require__(285);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	
	
	function Sendgrid(Component) {
	  var Child = function (_React$Component) {
	    _inherits(Child, _React$Component);
	
	    function Child(props) {
	      _classCallCheck(this, Child);
	
	      var _this = _possibleConstructorReturn(this, (Child.__proto__ || Object.getPrototypeOf(Child)).call(this, props));
	
	      _this.state = {
	        value: 'i am value'
	      };
	      return _this;
	    }
	
	    _createClass(Child, [{
	      key: 'render',
	      value: function render() {
	        // here you can pass down whatever you want 'inherited' by the child
	        return _react2.default.createElement(Component, Object.assign({}, this.props, this.state));
	      }
	    }]);
	
	    return Child;
	  }(_react2.default.Component);
	
	  return (0, _reactRedux.connect)(_Session.sessionSelector, {
	    sendContactForm: _actions2.default
	  })(Child);
	}

/***/ },
/* 1211 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAIL_SEND_SUCCEFFSUL = exports.MAIL_SEND_SUCCEFFSUL = 'MAIL_SEND';
	var MAIL_SEND_FAILED = exports.MAIL_SEND_FAILED = 'MAIL_SEND_FAILED';
	var MAIL_SEND_REQUESTED = exports.MAIL_SEND_REQUESTED = 'MAIL_SEND_REQUESTED';

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sendContactForm;
	
	var _mail = __webpack_require__(1072);
	
	var _actionTypes = __webpack_require__(1211);
	
	function sendContactForm(payload, add_coach_application) {
	  // eslint-disable-line
	
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.MAIL_SEND_REQUESTED
	    });
	    (0, _mail.sendMail)(payload, add_coach_application).then(function (result) {
	      dispatch({
	        type: _actionTypes.MAIL_SEND_SUCCEFFSUL,
	        result: result
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.MAIL_SEND_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSessionValid = isSessionValid;
	exports.logoutUser = logoutUser;
	exports.logoutCurrentUserForAdmin = logoutCurrentUserForAdmin;
	
	var _actionTypes = __webpack_require__(199);
	
	var _immutable = __webpack_require__(11);
	
	var _localStorage = __webpack_require__(56);
	
	var _session = __webpack_require__(73);
	
	var service = _interopRequireWildcard(_session);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function isSessionValid() {
	  // eslint-disable-line
	  return function (dispatch) {
	    service.isSessionValid(function (err, result) {
	      if (err) {
	        dispatch({
	          type: _SessionActionTypes.SESSION_LOGOUT
	        });
	      } else {
	        var token = result.session.idToken.jwtToken;
	        dispatch({
	          type: _SessionActionTypes.SESSION_VALID,
	          session: (0, _immutable.fromJS)(result.session),
	          user: (0, _immutable.fromJS)(result.user),
	          attributes: (0, _immutable.fromJS)(result.attributes),
	          token: token
	        });
	      }
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work
	/**
	 * Created by sairam on 25/04/17.
	 */
	function logoutUser(zoneinfo) {
	  // eslint-disable-line
	  return function (dispatch) {
	    var temp = [{ Name: 'profile', Value: 'PENDING' }];
	    var admin = (0, _localStorage.getItem)('user_cred');
	    if (admin && admin.length > 5 && zoneinfo === 'ADMIN') {
	      service.updateUserAttributes(temp, function (err) {
	        if (!err) {
	          service.logoutUser(function () {
	            window.sessionStorage.setItem('user', null);
	            (0, _localStorage.setItem)('user_cred', '');
	            (0, _localStorage.setItem)('localZone', '');
	            dispatch({
	              type: _SessionActionTypes.SESSION_LOGOUT
	            });
	          });
	        }
	      });
	    } else {
	      service.logoutUser(function () {
	        window.sessionStorage.setItem('user', null);
	        (0, _localStorage.setItem)('user_cred', '');
	        (0, _localStorage.setItem)('localZone', '');
	        dispatch({
	          type: _SessionActionTypes.SESSION_LOGOUT
	        });
	      });
	    }
	  };
	}
	
	function logoutCurrentUserForAdmin() {
	  // eslint-disable-line
	  return function (dispatch) {
	    var admin = (0, _localStorage.getItem)('user_cred');
	    if (admin && admin.length > 5) {
	      var temp = [{ Name: 'profile', Value: 'PENDING' }];
	      service.updateUserAttributes(temp, function (err) {
	        if (!err) {
	          // window.sessionStorage.setItem('kiro', false);
	          (0, _localStorage.setItem)('user', '');
	          (0, _localStorage.setItem)('user_cred', '');
	          (0, _localStorage.setItem)('localZone', '');
	          dispatch({
	            type: _actionTypes.ERASE_CURRENT_USER_DATA
	          });
	        }
	      });
	    }
	  };
	}

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = Session;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(89);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Session = __webpack_require__(285);
	
	var _Session2 = __webpack_require__(1213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	
	
	function Session(Component) {
	  var Child = function (_React$Component) {
	    _inherits(Child, _React$Component);
	
	    function Child(props) {
	      _classCallCheck(this, Child);
	
	      var _this = _possibleConstructorReturn(this, (Child.__proto__ || Object.getPrototypeOf(Child)).call(this, props));
	
	      _this.state = {/* inital state */};
	      return _this;
	    }
	
	    _createClass(Child, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.props.isSessionValid();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var isValid = nextProps.isValid;
	
	
	        if (!isValid && this.props.history.location.pathname !== '/') {
	          this.props.history.push('/');
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        // here you can pass down whatever you want 'inherited' by the child
	        return _react2.default.createElement(Component, Object.assign({}, this.props, this.state));
	      }
	    }]);
	
	    return Child;
	  }(_react2.default.Component);
	
	  Child.propTypes = {
	    isSessionValid: _propTypes2.default.func,
	    isValid: _propTypes2.default.bool.isRequired,
	    history: _propTypes2.default.func.isRequired
	  };
	  Child.defaultProps = {
	    isSessionValid: function isSessionValid() {}
	  };
	
	
	  return (0, _reactRedux.connect)(_Session.sessionSelector, {
	    isSessionValid: _Session2.isSessionValid,
	    logoutUser: _Session2.logoutUser,
	    logoutCurrentUserForAdmin: _Session2.logoutCurrentUserForAdmin
	  })((0, _reactRouter.withRouter)(Child));
	}

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSessionValid = isSessionValid;
	exports.logoutUser = logoutUser;
	exports.logoutCurrentUserForAdmin = logoutCurrentUserForAdmin;
	
	var _actionTypes = __webpack_require__(199);
	
	var _localStorage = __webpack_require__(56);
	
	var _immutable = __webpack_require__(11);
	
	var _session = __webpack_require__(73);
	
	var service = _interopRequireWildcard(_session);
	
	var _SessionActionTypes = __webpack_require__(466);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// use of immutablejs for various js operations to simplify our work
	function isSessionValid() {
	  // eslint-disable-line
	  return function (dispatch) {
	    service.isSessionValid(function (err, result) {
	      if (err) {
	        dispatch({
	          type: _SessionActionTypes.SESSION_LOGOUT
	        });
	      } else {
	        var token = result.session.idToken.jwtToken;
	        dispatch({
	          type: _SessionActionTypes.SESSION_VALID,
	          session: (0, _immutable.fromJS)(result.session),
	          user: (0, _immutable.fromJS)(result.user),
	          attributes: (0, _immutable.fromJS)(result.attributes),
	          token: token
	        });
	      }
	    });
	  };
	} /**
	   * Created by sairam on 25/04/17.
	   */
	function logoutUser(zoneinfo) {
	  // eslint-disable-line
	  return function (dispatch) {
	    var temp = [{ Name: 'profile', Value: 'PENDING' }];
	    var admin = (0, _localStorage.getItem)('user_cred');
	    if (admin && admin.length > 5 && zoneinfo === 'ADMIN') {
	      service.updateUserAttributes(temp, function (err) {
	        if (!err) {
	          service.logoutUser(function () {
	            window.sessionStorage.setItem('user', null);
	            (0, _localStorage.setItem)('user_cred', '');
	            (0, _localStorage.setItem)('localZone', '');
	            dispatch({
	              type: _SessionActionTypes.SESSION_LOGOUT
	            });
	          });
	        }
	      });
	    } else {
	      service.logoutUser(function () {
	        window.sessionStorage.setItem('user', null);
	        (0, _localStorage.setItem)('user_cred', '');
	        (0, _localStorage.setItem)('localZone', '');
	        dispatch({
	          type: _SessionActionTypes.SESSION_LOGOUT
	        });
	      });
	    }
	  };
	}
	
	function logoutCurrentUserForAdmin() {
	  // eslint-disable-line
	  return function (dispatch) {
	    var admin = (0, _localStorage.getItem)('user_cred');
	    if (admin && admin.length > 5) {
	      var temp = [{ Name: 'profile', Value: 'PENDING' }];
	      service.updateUserAttributes(temp, function (err) {
	        if (!err) {
	          // window.sessionStorage.setItem('kiro', false);
	          (0, _localStorage.setItem)('user', '');
	          (0, _localStorage.setItem)('user_cred', '');
	          (0, _localStorage.setItem)('localZone', '');
	          dispatch({
	            type: _actionTypes.ERASE_CURRENT_USER_DATA
	          });
	        }
	      });
	    }
	  };
	}

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = Session;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(89);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Session = __webpack_require__(1217);
	
	var _Session2 = __webpack_require__(1215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	
	
	function Session(Component) {
	  var Child = function (_React$Component) {
	    _inherits(Child, _React$Component);
	
	    function Child(props) {
	      _classCallCheck(this, Child);
	
	      var _this = _possibleConstructorReturn(this, (Child.__proto__ || Object.getPrototypeOf(Child)).call(this, props));
	
	      _this.state = {/* inital state */};
	      return _this;
	    }
	
	    _createClass(Child, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.props.isSessionValid();
	      }
	
	      /* componentWillReceiveProps(nextProps) {
	        const { isValid } = nextProps;
	         if (!isValid && this.props.history.location.pathname !== '/') {
	          this.props.history.push('/');
	        }
	      } */
	
	    }, {
	      key: 'render',
	      value: function render() {
	        // here you can pass down whatever you want 'inherited' by the child
	        return _react2.default.createElement(Component, Object.assign({}, this.props, this.state));
	      }
	    }]);
	
	    return Child;
	  }(_react2.default.Component);
	
	  Child.propTypes = {
	    isSessionValid: _propTypes2.default.func
	  };
	  Child.defaultProps = {
	    isSessionValid: function isSessionValid() {}
	  };
	
	
	  return (0, _reactRedux.connect)(_Session.sessionSelector, {
	    isSessionValid: _Session2.isSessionValid,
	    logoutUser: _Session2.logoutUser
	  })((0, _reactRouter.withRouter)(Child));
	}

/***/ },
/* 1217 */
[2531, 466],
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToolbox = __webpack_require__(251);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SettingsCoachTabs = __webpack_require__(1531);
	
	var _SettingsCoachTabs2 = _interopRequireDefault(_SettingsCoachTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	// to import local scss fle
	
	var SettingsCoachTabs = function (_React$Component) {
	  _inherits(SettingsCoachTabs, _React$Component);
	
	  function SettingsCoachTabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SettingsCoachTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingsCoachTabs.__proto__ || Object.getPrototypeOf(SettingsCoachTabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: 0,
	      fixedIndex: 1,
	      inverseIndex: 1
	    }, _this.handleTabChange = function (index) {
	      _this.setState({ index: index });
	      _this.props.tabListener(index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SettingsCoachTabs, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _SettingsCoachTabs2.default.container) },
	        _react2.default.createElement(
	          _reactToolbox.Tabs,
	          { index: this.state.index, onChange: this.handleTabChange },
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'Profile', activeClassName: _SettingsCoachTabs2.default.activeClass }),
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'Reset Password', activeClassName: _SettingsCoachTabs2.default.activeClass })
	        )
	      );
	    }
	  }]);
	
	  return SettingsCoachTabs;
	}(_react2.default.Component);
	
	SettingsCoachTabs.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired
	};
	exports.default = SettingsCoachTabs;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SettingsCoachTabs = __webpack_require__(1218);
	
	var _SettingsCoachTabs2 = _interopRequireDefault(_SettingsCoachTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SettingsCoachTabs2.default;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToolbox = __webpack_require__(251);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SettingsTabs = __webpack_require__(1532);
	
	var _SettingsTabs2 = _interopRequireDefault(_SettingsTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	// to import local scss fle
	
	var StudentTabs = function (_React$Component) {
	  _inherits(StudentTabs, _React$Component);
	
	  function StudentTabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StudentTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StudentTabs.__proto__ || Object.getPrototypeOf(StudentTabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: 0,
	      fixedIndex: 1,
	      inverseIndex: 1
	    }, _this.handleTabChange = function (index) {
	      _this.setState({ index: index });
	      _this.props.tabListener(index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StudentTabs, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _SettingsTabs2.default.container) },
	        _react2.default.createElement(
	          _reactToolbox.Tabs,
	          { index: this.props.location.search === '?reset_password' ? 1 : this.state.index, onChange: this.handleTabChange },
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'Profile', activeClassName: _SettingsTabs2.default.activeClass }),
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'Reset Password', activeClassName: _SettingsTabs2.default.activeClass }),
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'Billings', activeClassName: _SettingsTabs2.default.activeClass })
	        )
	      );
	    }
	  }]);
	
	  return StudentTabs;
	}(_react2.default.Component);
	
	StudentTabs.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired,
	  location: _propTypes2.default.shape().isRequired
	};
	exports.default = StudentTabs;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SettingsTabs = __webpack_require__(1220);
	
	var _SettingsTabs2 = _interopRequireDefault(_SettingsTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SettingsTabs2.default;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localStorage = __webpack_require__(56);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _CoachRegistration = __webpack_require__(108);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	var _ResetPassword = __webpack_require__(1200);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ModifyStudent = __webpack_require__(1161);
	
	var _ModifyStudent2 = _interopRequireDefault(_ModifyStudent);
	
	var _ModifyParent = __webpack_require__(1159);
	
	var _ModifyParent2 = _interopRequireDefault(_ModifyParent);
	
	var _Billings = __webpack_require__(1097);
	
	var _Billings2 = _interopRequireDefault(_Billings);
	
	var _SettingsView = __webpack_require__(1533);
	
	var _SettingsView2 = _interopRequireDefault(_SettingsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var SettingsView = function (_Component) {
	  _inherits(SettingsView, _Component);
	
	  function SettingsView(props) {
	    _classCallCheck(this, SettingsView);
	
	    var _this = _possibleConstructorReturn(this, (SettingsView.__proto__ || Object.getPrototypeOf(SettingsView)).call(this, props));
	
	    _this.state = {
	      localZone: ''
	    };
	    return _this;
	  }
	
	  _createClass(SettingsView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var currentLocalZone = (0, _localStorage.getItem)('localZone');
	      if (currentLocalZone === 'STUDENT') {
	        this.setState({ localZone: currentLocalZone });
	      } else {
	        this.setState({ localZone: currentLocalZone });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var currentLocalZone = (0, _localStorage.getItem)('localZone');
	      if (currentLocalZone === 'STUDENT') {
	        this.setState({ localZone: currentLocalZone });
	      } else {
	        this.setState({ localZone: currentLocalZone });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderDefault = (0, _renderIf2.default)(this.props.tab === 0);
	      var renderResetPassword = (0, _renderIf2.default)(this.props.tab === 1);
	      var renderBillings = (0, _renderIf2.default)(this.props.tab === 2);
	      var renderCoachProfile = (0, _renderIf2.default)(this.props.usedFor === 'coach' || this.state.localZone === 'COACH');
	      var renderParentProfile = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'PARENT');
	      var renderAthleteProfile = (0, _renderIf2.default)(this.props.usedFor === 'athlete' && (this.props.attributes.get('zoneinfo') === 'STUDENT' || this.state.localZone === 'STUDENT'));
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _SettingsView2.default.container) },
	        renderDefault(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _SettingsView2.default.profileContainer) },
	          renderCoachProfile(_react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_CoachRegistration2.default, Object.assign({}, this.props, { usedFor: 'modify' }))
	          )),
	          renderAthleteProfile(_react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_ModifyStudent2.default, this.props)
	          )),
	          renderParentProfile(_react2.default.createElement(_ModifyParent2.default, this.props))
	        )),
	        renderResetPassword(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_ResetPassword2.default, this.props)
	        )),
	        renderBillings(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Billings2.default, this.props)
	        ))
	      );
	    }
	  }]);
	
	  return SettingsView;
	}(_react.Component);
	
	SettingsView.propTypes = {
	  tab: _propTypes2.default.number,
	  usedFor: _propTypes2.default.string,
	  attributes: _propTypes2.default.shape()
	};
	SettingsView.defaultProps = {
	  tab: 0,
	  usedFor: '',
	  attributes: {}
	};
	exports.default = SettingsView;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SettingsView = __webpack_require__(1222);
	
	var _SettingsView2 = _interopRequireDefault(_SettingsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SettingsView2.default;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Signin = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _ramda = __webpack_require__(167);
	
	var _immutable = __webpack_require__(11);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _routeNames = __webpack_require__(55);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Password = __webpack_require__(459);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	var _Login = __webpack_require__(1317);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Login3 = __webpack_require__(1319);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Signin = __webpack_require__(1534);
	
	var _Signin2 = _interopRequireDefault(_Signin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// use of immutablejs for various js operations to simplify our work
	// to show loder on screen whenever there is a api call or operations in component
	
	// import { goto } from 'utils/navigation';
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var Signin = exports.Signin = function (_Component) {
	  _inherits(Signin, _Component);
	
	  function Signin(props) {
	    _classCallCheck(this, Signin);
	
	    var _this = _possibleConstructorReturn(this, (Signin.__proto__ || Object.getPrototypeOf(Signin)).call(this, props));
	
	    _this.passwordHandler = function (password) {
	      _this.setState({ password: password });
	    };
	
	    _this.login = function () {
	      if (_this.state.username !== '' && _this.state.password !== '') {
	        _this.props.loginUser(_this.state.username, _this.state.password);
	      } else if (_this.state.username === '' && _this.state.password === '') {
	        _this.setState({ userNameErrorMessage: 'Please enter a user name!', passwordErrorMessage: 'Please enter a password!' });
	      } else if (_this.state.username === '') {
	        _this.setState({ userNameErrorMessage: 'Please enter a user name!' });
	      } else if (_this.state.password === '') {
	        _this.setState({ passwordErrorMessage: 'Please enter a password!' });
	      }
	    };
	
	    _this.emailHandler = function (username) {
	      _this.setState({ username: username });
	    };
	
	    _this.state = {
	      userNameErrorMessage: '',
	      passwordErrorMessage: '',
	      username: '',
	      password: ''
	    };
	    _this.emailHandler = _this.emailHandler.bind(_this);
	    _this.passwordHandler = _this.passwordHandler.bind(_this);
	    _this.identifyEnter = _this.identifyEnter.bind(_this);
	    _this.login = _this.login.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    return _this;
	  }
	
	  // componentWillMount() {
	  //   const { session = {} } = this.props;
	  //       // this.props.loginUser('shasti@gmail.com', 'test123!');
	  //   if (!session) {
	  //     goto('');
	  //   }
	  // }
	
	  _createClass(Signin, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props$session = this.props.session,
	          session = _props$session === undefined ? (0, _immutable.Map)() : _props$session;
	
	      if (nextProps.session && !(0, _immutable.is)(nextProps.session, session) && !nextProps.session.isEmpty()) {
	        this.props.history.push(_routeNames.RedirectPage);
	      }
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'identifyEnter',
	    value: function identifyEnter(e) {
	      var code = e.keyCode ? e.keyCode : e.which;
	      if (code === 13) {
	        // Enter keycode
	        if (this.state.username !== '' && this.state.password !== '') {
	          this.login();
	        } else if (this.state.username === '' && this.state.password === '') {
	          this.setState({ userNameErrorMessage: 'Please enter a user name!', passwordErrorMessage: 'Please enter a password!' });
	        } else if (this.state.username === '') {
	          this.setState({ userNameErrorMessage: 'Please enter a user name!' });
	        } else if (this.state.password === '') {
	          this.setState({ passwordErrorMessage: 'Please enter a password!' });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isLoading = _props.isLoading,
	          errorMessage = _props.errorMessage;
	
	      // Conditional rendering
	
	      var renderIfLoading = (0, _renderIf2.default)(isLoading);
	      var renderIfErrorIsNotEmpty = (0, _renderIf2.default)((0, _ramda.not)((0, _ramda.isEmpty)(errorMessage)));
	      var renderIfNotLoading = (0, _renderIf2.default)((0, _ramda.not)(false));
	      return _react2.default.createElement(
	        'div',
	        { className: _Signin2.default.signInContainer },
	        renderIfLoading(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderIfErrorIsNotEmpty(_react2.default.createElement(
	          'div',
	          { className: _Signin2.default.errorContainer },
	          _react2.default.createElement(_ErrorMessage2.default, {
	            message: errorMessage
	          })
	        )),
	        renderIfNotLoading(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _Signin2.default.signInContainer) },
	          _react2.default.createElement(_TextField2.default, {
	            label: 'EMAIL',
	            onChange: this.emailHandler,
	            onKeyPress: this.identifyEnter,
	            errorMessage: this.state.userNameErrorMessage,
	            onFocus: function onFocus() {
	              return _this2.onFocus('userNameErrorMessage');
	            }
	          }),
	          _react2.default.createElement(_Password2.default, {
	            onChange: this.passwordHandler,
	            onKeyPress: this.identifyEnter,
	            errorMessage: this.state.passwordErrorMessage,
	            onFocus: function onFocus() {
	              return _this2.onFocus('passwordErrorMessage');
	            }
	          }),
	          _react2.default.createElement(_CustomButton2.default, { type: 'submit', onClick: this.login })
	        ))
	      );
	    }
	  }]);
	
	  return Signin;
	}(_react.Component);
	
	Signin.propTypes = {
	  session: _propTypes2.default.shape(),
	  loginUser: _propTypes2.default.func.isRequired,
	  isLoading: _propTypes2.default.bool,
	  push: _propTypes2.default.func.isRequired,
	  history: _propTypes2.default.shape(),
	  attributes: _propTypes2.default.shape(), // eslint-disable-line
	  errorMessage: _propTypes2.default.string
	};
	Signin.defaultProps = {
	  session: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  isLoading: false,
	  history: {
	    push: function push() {}
	  },
	  attributes: {},
	  errorMessage: ''
	};
	exports.default = (0, _reactRedux.connect)(_Login3.loginSelector, {
	  loginUser: _Login2.default
	})(Signin);

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Signup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _ramda = __webpack_require__(167);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Password = __webpack_require__(459);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	var _SignupCategory = __webpack_require__(1228);
	
	var _SignupCategory2 = _interopRequireDefault(_SignupCategory);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// regular expressions to validate user input
	// to show loder on screen whenever there is a api call or operations in component
	
	var Signup = exports.Signup = function (_Component) {
	  _inherits(Signup, _Component);
	
	  function Signup(props) {
	    _classCallCheck(this, Signup);
	
	    var _this = _possibleConstructorReturn(this, (Signup.__proto__ || Object.getPrototypeOf(Signup)).call(this, props));
	
	    _this.firstNameHandler = function (firstName) {
	      _this.setState({ firstName: firstName, firstNameErrorMessage: '' });
	    };
	
	    _this.lastNameHandler = function (lastName) {
	      _this.setState({ lastName: lastName, lastNameErrorMessage: '' });
	    };
	
	    _this.emailHandler = function (temp) {
	      var username = temp.toLowerCase();
	      _this.setState({ username: username, emailErrorMessage: '' });
	    };
	
	    _this.passwordHandler = function (password) {
	      _this.setState({ password: password, passwordErrorMessage: '' });
	    };
	
	    _this.zoneHandler = function (zone) {
	      _this.setState({ zone: zone });
	    };
	
	    _this.register = function () {
	      var attributes = [];
	      /* Name validation */
	      var validFirstName = false;
	      var nameError = typeof _this.state.firstName === 'string';
	      if (nameError && _this.state.firstName !== '') {
	        validFirstName = true;
	      } else {
	        _this.setState({ firstNameErrorMessage: 'Please enter a valid first name.' });
	      }
	      /* Name validation */
	
	      /* Name validation */
	      var validLastName = false;
	      var lastNameError = typeof _this.state.lastName === 'string';
	      if (lastNameError && _this.state.lastName !== '') {
	        validLastName = true;
	      } else {
	        _this.setState({ lastNameErrorMessage: 'Please enter a valid last name.' });
	      }
	      /* Name validation */
	
	      /* Email Validation */
	      var validEmail = false;
	      var emailError = _Regularexpression.regExForEmail.test(_this.state.username);
	      if (emailError) {
	        validEmail = true;
	      } else {
	        _this.setState({ emailErrorMessage: 'Please enter a valid email.' });
	      }
	      /* Email Validation */
	
	      /* Password Validation */
	      var validPassword = false;
	      if (_this.state.password.length > 6) {
	        validPassword = true;
	      } else {
	        _this.setState({ passwordErrorMessage: 'Password length should be greater than 7.' });
	      }
	      /* Password Validation */
	
	      var combinedName = _this.state.firstName + ' ' + _this.state.lastName;
	      attributes.push({
	        Name: 'email',
	        Value: _this.state.username // your email here
	      });
	      attributes.push({
	        Name: 'name',
	        Value: combinedName
	      });
	      attributes.push({
	        Name: 'zoneinfo',
	        Value: _this.state.zone
	      });
	
	      attributes.push({
	        Name: 'profile',
	        Value: 'PENDING'
	      });
	
	      if (validFirstName && validLastName && validEmail && validPassword) {
	        _this.props.registerUser(_this.state.username, _this.state.password, attributes);
	      }
	    };
	
	    _this.state = {
	      zone: 'STUDENT',
	      forgotPassword: false,
	      nameErrorMessage: '',
	      emailErrorMessage: '',
	      passwordErrorMessage: '',
	      name: '',
	      firstName: '',
	      lastName: '',
	      password: ''
	    };
	
	    _this.firstNameHandler = _this.firstNameHandler.bind(_this);
	    _this.lastNameHandler = _this.lastNameHandler.bind(_this);
	    _this.emailHandler = _this.emailHandler.bind(_this);
	    _this.passwordHandler = _this.passwordHandler.bind(_this);
	    _this.zoneHandler = _this.zoneHandler.bind(_this);
	    _this.identifyEnter = _this.identifyEnter.bind(_this);
	    _this.register = _this.register.bind(_this);
	    return _this;
	  }
	
	  _createClass(Signup, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.registered) {
	        if (this.state.zone === 'COACH') {
	          this.props.history.push('redirect');
	        } else if (this.state.zone === 'STUDENT') {
	          this.props.history.push('register/athlete');
	        } else {
	          this.props.history.push('register/parent');
	        }
	      }
	    }
	  }, {
	    key: 'identifyEnter',
	    value: function identifyEnter(e) {
	      var code = e.keyCode ? e.keyCode : e.which;
	      if (code === 13) {
	        // Enter keycode
	        this.register();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$error = _props.error,
	          error = _props$error === undefined ? {} : _props$error,
	          isLoading = _props.isLoading;
	      // Conditional rendering
	
	      var renderIfLoading = (0, _renderIf2.default)(isLoading);
	      var renderIfErrorIsNotEmpty = (0, _renderIf2.default)((0, _ramda.not)((0, _ramda.isEmpty)(error)));
	      var renderIfNotLoading = (0, _renderIf2.default)((0, _ramda.not)(false));
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderIfLoading(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderIfErrorIsNotEmpty(_react2.default.createElement(
	          'div',
	          null,
	          error.message
	        )),
	        renderIfNotLoading(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_TextField2.default, { errorMessage: this.state.firstNameErrorMessage, label: 'FIRST NAME', onChange: this.firstNameHandler }),
	            _react2.default.createElement(_TextField2.default, { errorMessage: this.state.lastNameErrorMessage, label: 'LAST NAME', onChange: this.lastNameHandler }),
	            _react2.default.createElement(_TextField2.default, { errorMessage: this.state.emailErrorMessage, usedFor: 'signupEmail', label: 'EMAIL', onChange: this.emailHandler }),
	            _react2.default.createElement(_Password2.default, {
	              addForgotPassword: this.state.forgotPassword,
	              onChange: this.passwordHandler,
	              errorMessage: this.state.passwordErrorMessage,
	              onKeyPress: this.identifyEnter
	            }),
	            _react2.default.createElement(_SignupCategory2.default, { onChange: this.zoneHandler }),
	            _react2.default.createElement(_CustomButton2.default, { onClick: this.register })
	          )
	        ))
	      );
	    }
	  }]);
	
	  return Signup;
	}(_react.Component);
	
	Signup.propTypes = {
	  error: _propTypes2.default.shape(),
	  registerUser: _propTypes2.default.func.isRequired,
	  isLoading: _propTypes2.default.bool,
	  registered: _propTypes2.default.bool, // eslint-disable-line
	  history: _propTypes2.default.shape()
	};
	Signup.defaultProps = {
	  session: {},
	  error: {},
	  isLoading: false,
	  registered: false,
	  history: {}
	};
	exports.default = Signup;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Signup = __webpack_require__(1225);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Signup2.default;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radio = __webpack_require__(104);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SignupCategory = __webpack_require__(1535);
	
	var _SignupCategory2 = _interopRequireDefault(_SignupCategory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	var Category = function (_React$Component) {
	  _inherits(Category, _React$Component);
	
	  function Category(props) {
	    _classCallCheck(this, Category);
	
	    var _this = _possibleConstructorReturn(this, (Category.__proto__ || Object.getPrototypeOf(Category)).call(this, props));
	
	    _this.handleChange = function (value) {
	      _this.setState({ value: value });
	      _this.props.onChange(value);
	    };
	
	    _this.state = { value: 'STUDENT' };
	    return _this;
	  }
	
	  _createClass(Category, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _SignupCategory2.default.container) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4') },
	          _react2.default.createElement(
	            _radio.RadioGroup,
	            { name: 'comic', value: this.state.value, onChange: this.handleChange },
	            _react2.default.createElement(_radio.RadioButton, { label: 'Athlete', value: 'STUDENT' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4') },
	          _react2.default.createElement(
	            _radio.RadioGroup,
	            { name: 'comic', value: this.state.value, onChange: this.handleChange },
	            _react2.default.createElement(_radio.RadioButton, { label: 'Coach', value: 'COACH' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Category;
	}(_react2.default.Component);
	
	Category.propTypes = {
	  onChange: _propTypes2.default.func.isRequired
	};
	Category.defaultProps = {
	  onChange: function onChange() {}
	};
	exports.default = Category;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SignupCategory = __webpack_require__(1227);
	
	var _SignupCategory2 = _interopRequireDefault(_SignupCategory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SignupCategory2.default;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SocialIcons = __webpack_require__(1536);
	
	var _SocialIcons2 = _interopRequireDefault(_SocialIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var SocialIcons = function SocialIcons() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12', _SocialIcons2.default.socialIconContainer) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m6', _SocialIcons2.default.socialIcons) },
	      _react2.default.createElement(
	        'span',
	        { className: _SocialIcons2.default.connectWithUs },
	        'Connect with us'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.facebook.com/MyRecruitboard/', target: 'blank' },
	        _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/facebook.png', alt: 'web_feed' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://twitter.com/myrecruitboard?lang=en', target: 'blank' },
	        _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/twitter.png', alt: 'web_feed' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.instagram.com/explore/tags/myrecruitboard/', target: 'blank' },
	        _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/instagram.png', alt: 'web_feed' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.snapchat.com/MyRecruitBoard', target: 'blank' },
	        _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/snapchat.png', alt: 'web_feed' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m6', _SocialIcons2.default.copyRight) },
	      'Copyright \xA9 2022. All Rights Reserved'
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = SocialIcons;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SocialIcons = __webpack_require__(1229);
	
	var _SocialIcons2 = _interopRequireDefault(_SocialIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SocialIcons2.default;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _button = __webpack_require__(31);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutabilityHelper = __webpack_require__(1613);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _immutable = __webpack_require__(11);
	
	var _SportsBoard = __webpack_require__(1537);
	
	var _SportsBoard2 = _interopRequireDefault(_SportsBoard);
	
	var _theme = __webpack_require__(1592);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to display error messages on invalid user input
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	// to use global class name eg. classes from grid.css in public folder
	// use of immutablejs for various js operations to simplify our work
	
	// to import local scss fle
	
	
	var emptyObject = {};
	var offensivePositions = {
	  QBDT: 'Quarterback - Duel Threat',
	  QBPS: 'Quarterback - Pro Style',
	  WR: 'Wide Receiver',
	  SR: 'Slot Receiver',
	  RB: 'Running Back',
	  FB: 'Full Back',
	  HB: 'H-Back',
	  TE: 'Tight End',
	  OG: 'Offensive Guard',
	  OT: 'Offensive Tackle',
	  C: 'Center'
	};
	
	var defensivePositions = {
	  DT: 'Defensive Tackle',
	  DE: 'Defensive End',
	  ML: 'Middle Linebacker',
	  OL: 'Outside Linebacker',
	  DB: 'Cornerback',
	  SS: 'Strong Safety',
	  FS: 'Free Safety'
	
	};
	
	var specialTeamsPositions = {
	  K: 'Kicker',
	  P: 'Punter',
	  LS: 'Long Snapper'
	};
	
	var t40Suggestions = {};
	/* let squatsSuggestions = { 101: '101', 102: '102' }; */
	var squatsSuggestions = {};
	var benchSuggestions = {};
	
	var SportsBoard = function (_React$Component) {
	  _inherits(SportsBoard, _React$Component);
	
	  function SportsBoard(props) {
	    _classCallCheck(this, SportsBoard);
	
	    var _this = _possibleConstructorReturn(this, (SportsBoard.__proto__ || Object.getPrototypeOf(SportsBoard)).call(this, props));
	
	    _this.state = {
	      primary_offensive_position_pref: '',
	      secondary_offensive_position_pref: '',
	      primary_defensive_position_pref: '',
	      secondary_defensive_position_pref: '',
	      special_teams: '',
	      height: '',
	      heightInFeet: '',
	      heightInInches: '',
	      weight: '',
	      sportName: 'FOOTBALL',
	      t40: '',
	      bench: '',
	      squats: '',
	      offensivePosition: '',
	      defensivePosition: '',
	      secondaryPosition: [],
	      addSecondaryPosition: false,
	      description: '',
	      specialTeams: '',
	      primaryOffensiveErrorMessage: '',
	      primaryDefensiveErrorMessage: '',
	      defensiveErrorMessage: '',
	      offensiveErrorMessage: '',
	      feetErrorMessage: '',
	      heightInchesErrorMessage: '',
	      heightInFeetErrorMessage: '',
	      weightErrorMessage: '',
	      sportNameErrorMessage: '',
	      t40ErrorMessage: '',
	      benchErrorMessage: '',
	      squatsErrorMessage: '',
	      descriptionErrorMessage: '',
	      specialTeamsErrorMessage: '',
	      showSecondaryButton: true
	    };
	
	    _this.handleChange = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value)));
	    };
	
	    _this.handleWeight = function (name, value) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)));
	    };
	
	    _this.removeErrorMessage = function (name) {
	      if (name === 'primaryOffensiveErrorMessage' || name === 'primaryDefensiveErrorMessage') {
	        _this.setState({ primaryOffensiveErrorMessage: '', primaryDefensiveErrorMessage: '' });
	      } else {
	        _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, '')));
	      }
	    };
	
	    _this.handleHeight = function (name, value) {
	      if (name === 'heightInFeet') {
	        if (value.target.value <= 7 && value.target.value >= 4 || value.target.value === '') {
	          _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	            _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	          });
	        }
	      } else if (value.target.value < 12 && value.target.value >= 0 || value.target.value === '') {
	        _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, value.target.value)), function () {
	          _this.setState({ height: _this.state.heightInFeet + '\'' + _this.state.heightInInches + '"' });
	        });
	      }
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleHeight = _this.handleHeight.bind(_this);
	    _this.handleWeight = _this.handleWeight.bind(_this);
	    _this.handleQueryChange = _this.handleQueryChange.bind(_this);
	    _this.addHeightAndSave = _this.addHeightAndSave.bind(_this);
	    _this.addAnotherPreference = _this.addAnotherPreference.bind(_this);
	    _this.removeSecondaryPosition = _this.removeSecondaryPosition.bind(_this);
	    _this.deleteSecondaryPositionValue = _this.deleteSecondaryPositionValue.bind(_this);
	    return _this;
	  }
	
	  _createClass(SportsBoard, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props$profile = this.props.profile,
	          profile = _props$profile === undefined ? (0, _immutable.Map)() : _props$profile;
	
	      if (nextProps.profile.size > 0 && !(0, _immutable.is)(profile, nextProps.profile)) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        var combinedHeight = nextProps.profile.get('height');
	        var newState = {
	          height: nextProps.profile.get('height'),
	          heightInFeet: combinedHeight.charAt(0),
	          heightInInches: combinedHeight.charAt(2),
	          weight: nextProps.profile.get('weight'),
	          sportName: keys[0],
	          t40: sport.get('t40'),
	          bench: sport.get('bench'),
	          squats: sport.get('squats'),
	          description: sport.get('description'),
	          position_pref: sport.get('position_pref')
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'handleQueryChange',
	    value: function handleQueryChange(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'addAnotherPreference',
	    value: function addAnotherPreference() {
	      var tempData = []; // eslint-disable-line
	      tempData = [{
	        id: 'OFFENSIVE',
	        positionValue: ''
	      }, {
	        id: 'DEFENSIVE',
	        positionValue: ''
	      }];
	      this.setState({ secondaryPosition: tempData,
	        showSecondaryButton: false,
	        offensiveErrorMessage: '',
	        defensiveErrorMessage: '' });
	    }
	  }, {
	    key: 'addValuesToSecondaryPosition',
	    value: function addValuesToSecondaryPosition(name, value, i) {
	      var tempData = [];
	      tempData = this.state.secondaryPosition;
	      tempData[i].positionValue = value;
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, tempData[i].positionValue)));
	    }
	  }, {
	    key: 'deleteSecondaryPositionValue',
	    value: function deleteSecondaryPositionValue(x) {
	      var temp = this.state.secondaryPosition;
	      temp[x].positionValue = '';
	      this.setState({ secondaryPosition: temp });
	      if (x === 0) {
	        this.setState({ secondary_offensive_position_pref: '' });
	      } else {
	        this.setState({ secondary_defensive_position_pref: '' });
	      }
	    }
	  }, {
	    key: 'removeSecondaryPosition',
	    value: function removeSecondaryPosition(i) {
	      var _this2 = this;
	
	      var temp = this.state.secondaryPosition;
	      var index = temp.findIndex(function (x) {
	        return x.id === i;
	      });
	      this.setState({
	        secondaryPosition: (0, _immutabilityHelper2.default)(this.state.secondaryPosition, { $splice: [[index, 1]] })
	      }, function () {
	        if (_this2.state.secondaryPosition.length === 0) {
	          _this2.setState({ showSecondaryButton: true });
	        }
	      });
	      if (i === 'OFFENSIVE') {
	        this.setState({ secondary_offensive_position_pref: '' });
	      } else {
	        this.setState({ secondary_defensive_position_pref: '' });
	      }
	    }
	  }, {
	    key: 'addHeightAndSave',
	    value: function addHeightAndSave() {
	      var updated = {};
	      /* Height Validation */
	      var validHeightInfeet = false;
	      var validHeightInInches = false;
	
	      if (this.state.heightInFeet !== '' && !isNaN(this.state.heightInFeet)) {
	        validHeightInfeet = true;
	      } else {
	        updated.heightInFeetErrorMessage = 'Enter height in feet.';
	      }
	
	      if (this.state.heightInInches !== '' && !isNaN(this.state.heightInInches)) {
	        validHeightInInches = true;
	      } else {
	        updated.heightInchesErrorMessage = 'Enter height in inches.';
	      }
	
	      /* Height Validation */
	
	      /* weight validation */
	      var validWeight = false;
	      if (this.state.weight !== '' && this.state.weight >= 120 && this.state.weight <= 350) {
	        validWeight = true;
	      } else if (!(this.state.weight >= 120 && this.state.weight <= 350) && this.state.weight !== '') {
	        updated.weightErrorMessage = 'Enter weight between 120-350 pounds.';
	      } else {
	        updated.weightErrorMessage = 'Please  add a valid weight.';
	      }
	      /* weight validation */
	
	      /* Preferred Position validation */
	      var validPrimaryPosition = false;
	      if (this.state.primary_defensive_position_pref !== '' || this.state.primary_offensive_position_pref !== '') {
	        validPrimaryPosition = true;
	      } else {
	        updated.primaryOffensiveErrorMessage = 'Please select one primary position.';
	      }
	      /* Preferred Position validation */
	
	      /* T40 validation */
	      var validT40 = false;
	      if (this.state.t40 !== '' && this.state.t40 >= 4 && this.state.t40 <= 5.5) {
	        validT40 = true;
	      } else if (!(this.state.t40 >= 4 && this.state.t40 <= 5.5) && this.state.t40 !== '') {
	        updated.t40ErrorMessage = 'Enter 40-Yard Dash between 4-5.5 seconds.';
	      } else {
	        updated.t40ErrorMessage = 'Please add a valid 40-Yard Dash.';
	      }
	      /* T40 validation */
	
	      /* squats validation */
	      var validSquats = false;
	      if (this.state.squats !== '' && !isNaN(this.state.squats)) {
	        validSquats = true;
	      } else {
	        updated.squatsErrorMessage = 'Please add a valid Squats.';
	      }
	      /* squats validation */
	
	      /* Bench validation */
	      var validBench = false;
	      if (this.state.bench !== '' && !isNaN(this.state.bench)) {
	        validBench = true;
	      } else {
	        updated.benchErrorMessage = 'Please add a valid Bench.';
	      }
	      /* squats validation */
	      var validSecondaryPositionCase = false;
	      if (this.state.secondary_defensive_position_pref !== '' && this.state.primary_defensive_position_pref === '') {
	        validSecondaryPositionCase = false;
	        updated.defensiveErrorMessage = 'Please fill primary defensive first.';
	      } else if (this.state.primary_defensive_position_pref === '' || this.state.secondary_defensive_position_pref === '') {
	        validSecondaryPositionCase = true;
	      } else if (this.state.primary_offensive_position_pref !== '' && this.state.secondary_defensive_position_pref !== '' && this.state.primary_defensive_position_pref !== '' && this.state.secondary_offensive_position_pref !== '') {
	        validSecondaryPositionCase = true;
	      }
	
	      var validSamePositionsOffensive = false;
	      if (this.state.secondary_offensive_position_pref === '') {
	        validSamePositionsOffensive = true;
	      } else if (this.state.primary_offensive_position_pref === this.state.secondary_offensive_position_pref) {
	        validSamePositionsOffensive = false;
	        updated.offensiveErrorMessage = 'Primary and secondary positions can not be same.';
	      } else if (this.state.secondary_offensive_position_pref !== '') {
	        validSamePositionsOffensive = true;
	      }
	
	      var validSamePositionsDefensive = false;
	      if (this.state.secondary_defensive_position_pref === '') {
	        validSamePositionsDefensive = true;
	      } else if (this.state.primary_defensive_position_pref === this.state.secondary_defensive_position_pref) {
	        validSamePositionsDefensive = false;
	        updated.defensiveErrorMessage = 'Primary and secondary positions can not be same.';
	      } else if (this.state.secondary_defensive_position_pref !== '') {
	        validSamePositionsDefensive = true;
	      }
	
	      if (validWeight && validPrimaryPosition && validSamePositionsDefensive && validSecondaryPositionCase && validSamePositionsOffensive && validBench && validSquats && validT40 && validHeightInfeet && validHeightInInches) {
	        this.setState({ height: this.state.heightInFeet + '\'' + this.state.heightInInches + '"' });
	        this.props.next(this.state);
	      } else {
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      for (var i = 1; i < 5; i++) {
	        //eslint-disable-line
	        for (var x = 0; x <= 10; x++) {
	          //eslint-disable-line
	          var listItem = '';
	          listItem = i * 100 + x * 10;
	          squatsSuggestions['' + listItem] = '' + listItem;
	        }
	      }
	      for (var _i = 1; _i < 4; _i++) {
	        //eslint-disable-line
	        for (var _x = 0; _x <= 10; _x++) {
	          //eslint-disable-line
	          var _listItem = '';
	          _listItem = _i * 100 + _x * 10;
	          benchSuggestions['' + _listItem] = '' + _listItem;
	        }
	      }
	      for (var _i2 = 4; _i2 < 6; _i2++) {
	        //eslint-disable-line
	        for (var _x2 = 0; _x2 <= 10; _x2++) {
	          //eslint-disable-line
	          var _listItem2 = '';
	          _listItem2 = '' + (_i2 + "." + _x2); // eslint-disable-line
	          if (_x2 === 10) {
	            _listItem2 = _i2 + 1 + '.0'; // eslint-disable-line
	          }
	          if (_listItem2 >= '4.3' && _listItem2 <= '5.5') {
	            var left = _listItem2;
	            var right = _listItem2;
	            if (_listItem2 === '4.3') {
	              left = _listItem2;
	              right = '4.3 or Lower';
	            } else if (_listItem2 === '5.5') {
	              left = _listItem2;
	              right = '5.5 or Higher';
	            }
	            t40Suggestions['' + left] = '' + right;
	          }
	        }
	      }
	      var _state = this.state,
	          benchErrorMessage = _state.benchErrorMessage,
	          weightErrorMessage = _state.weightErrorMessage,
	          squatsErrorMessage = _state.squatsErrorMessage,
	          t40ErrorMessage = _state.t40ErrorMessage,
	          primaryDefensiveErrorMessage = _state.primaryDefensiveErrorMessage,
	          defensiveErrorMessage = _state.defensiveErrorMessage,
	          offensiveErrorMessage = _state.offensiveErrorMessage,
	          heightInchesErrorMessage = _state.heightInchesErrorMessage,
	          heightInFeetErrorMessage = _state.heightInFeetErrorMessage,
	          showSecondaryButton = _state.showSecondaryButton,
	          secondaryPosition = _state.secondaryPosition,
	          specialTeamsErrorMessage = _state.specialTeamsErrorMessage,
	          primary_offensive_position_pref = _state.primary_offensive_position_pref,
	          primaryOffensiveErrorMessage = _state.primaryOffensiveErrorMessage,
	          primary_defensive_position_pref = _state.primary_defensive_position_pref,
	          special_teams = _state.special_teams;
	
	      var renderIfShow = (0, _renderIf2.default)(this.props.show);
	      var showAddSecondaryButton = (0, _renderIf2.default)(showSecondaryButton);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderIfShow(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _SportsBoard2.default.sportsBoardContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.heightAndWidthContainer) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.heightWidth) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'HEIGHT'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.heightContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s6', _SportsBoard2.default.feetContainer) },
	                  _react2.default.createElement('input', {
	                    className: heightInFeetErrorMessage === '' ? (0, _classnames2.default)('col s12', _SportsBoard2.default.simpleInput) : (0, _classnames2.default)('col s12', _SportsBoard2.default.simpleInputError),
	                    type: 'text',
	                    placeholder: 'Feet',
	                    value: this.state.heightInFeet,
	                    onFocus: function onFocus() {
	                      return _this3.removeErrorMessage('heightInFeetErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this3.handleHeight('heightInFeet', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: heightInFeetErrorMessage })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s6', _SportsBoard2.default.inchesContainer) },
	                  _react2.default.createElement('input', {
	                    className: heightInchesErrorMessage === '' ? (0, _classnames2.default)('col s12', _SportsBoard2.default.simpleInput) : (0, _classnames2.default)('col s12', _SportsBoard2.default.simpleInputError),
	                    type: 'text',
	                    placeholder: 'Inches',
	                    value: this.state.heightInInches,
	                    onFocus: function onFocus() {
	                      return _this3.removeErrorMessage('heightInchesErrorMessage');
	                    },
	                    onChange: function onChange(val) {
	                      return _this3.handleHeight('heightInInches', val);
	                    }
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: heightInchesErrorMessage })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: weightErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'WEIGHT'
	              ),
	              _react2.default.createElement('input', {
	                className: (0, _classnames2.default)('col s12', _SportsBoard2.default.simpleInput),
	                value: this.state.weight,
	                onChange: function onChange(val) {
	                  return _this3.handleWeight('weight', val);
	                },
	                onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('weightErrorMessage');
	                },
	                placeholder: 'Pounds'
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: this.state.weightErrorMessage })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.fullWidth) },
	            _react2.default.createElement(
	              'p',
	              { className: _SportsBoard2.default.mySport },
	              'MEASURABLES'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.mysportContainer) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'MY SPORT'
	              ),
	              _react2.default.createElement('input', {
	                /* source={sports} */
	                value: this.state.sportName
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.preferedPositionContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: primaryOffensiveErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpanError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'PRIMARY OFFENSIVE POSITION'
	                ),
	                _react2.default.createElement(_autocomplete2.default, {
	                  source: offensivePositions,
	                  value: primary_offensive_position_pref // eslint-disable-line
	                  , onChange: function onChange(val) {
	                    return _this3.handleChange('primary_offensive_position_pref', val);
	                  },
	                  multiple: false,
	                  onQueryChange: function onQueryChange() {
	                    return _this3.handleQueryChange('primary_offensive_position_pref');
	                  },
	                  direction: 'down',
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('primaryOffensiveErrorMessage');
	                  },
	                  theme: _theme2.default
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: primaryOffensiveErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: primaryDefensiveErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpanError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'PRIMARY DEFENSIVE POSITION',
	                  _react2.default.createElement(
	                    'span',
	                    { className: _SportsBoard2.default.optionalTag },
	                    '\xA0\xA0(Optional)'
	                  )
	                ),
	                _react2.default.createElement(_autocomplete2.default, {
	                  source: defensivePositions,
	                  value: primary_defensive_position_pref // eslint-disable-line
	                  , onChange: function onChange(val) {
	                    return _this3.handleChange('primary_defensive_position_pref', val);
	                  },
	                  multiple: false,
	                  onQueryChange: function onQueryChange() {
	                    return _this3.handleQueryChange('primary_defensive_position_pref');
	                  },
	                  direction: 'down',
	                  onFocus: function onFocus() {
	                    return _this3.removeErrorMessage('primaryDefensiveErrorMessage');
	                  },
	                  theme: _theme2.default
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: primaryDefensiveErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.removePadding) },
	                secondaryPosition.map(function (i, x) {
	                  return _react2.default.createElement(
	                    'div',
	                    { className: (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.removePadding) },
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        key: i.id, className: (i.id === 'OFFENSIVE' ? offensiveErrorMessage : defensiveErrorMessage) === '' ? (0, _classnames2.default)('col s11 m11', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s11 m11', _SportsBoard2.default.halfWidthWithSpanError)
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        'SECONDARY ',
	                        i.id,
	                        ' POSITION '
	                      ),
	                      _react2.default.createElement(_autocomplete2.default, {
	                        source: i.id === 'OFFENSIVE' ? offensivePositions : defensivePositions,
	                        value: i.positionValue,
	                        onChange: function onChange(val) {
	                          return _this3.addValuesToSecondaryPosition(i.id === 'OFFENSIVE' ? 'secondary_offensive_position_pref' : 'secondary_defensive_position_pref', val, x);
	                        },
	                        multiple: false,
	                        onQueryChange: function onQueryChange() {
	                          return _this3.deleteSecondaryPositionValue(x);
	                        } //eslint-disable-line
	                        , direction: 'down',
	                        onFocus: function onFocus() {
	                          return _this3.removeErrorMessage(i.id === 'OFFENSIVE' ? 'offensiveErrorMessage' : 'defensiveErrorMessage');
	                        },
	                        theme: _theme2.default
	                      }),
	                      _react2.default.createElement(_ErrorMessage2.default, { message: i.id === 'OFFENSIVE' ? offensiveErrorMessage : defensiveErrorMessage })
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: (0, _classnames2.default)('col s1 m1', _SportsBoard2.default.removePadding) },
	                      _react2.default.createElement(
	                        'button',
	                        {
	                          className: _SportsBoard2.default.removeButton,
	                          onClick: function onClick() {
	                            return _this3.removeSecondaryPosition(i.id, i.id === 'OFFENSIVE' ? 'offensiveErrorMessage' : 'defensiveErrorMessage');
	                          }
	                        },
	                        _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/redCross.png', alt: 'remove' })
	                      )
	                    )
	                  );
	                })
	              ),
	              showAddSecondaryButton(_react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.addButtonContainer) },
	                _react2.default.createElement(
	                  'button',
	                  { className: _SportsBoard2.default.addButton, onClick: this.addAnotherPreference },
	                  'Add secondary position.'
	                )
	              )),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.removePadding) },
	                _react2.default.createElement(
	                  'div',
	                  { className: specialTeamsErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpanError) },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'SPECIAL TEAMS',
	                    _react2.default.createElement(
	                      'span',
	                      { className: _SportsBoard2.default.optionalTag },
	                      '\xA0\xA0(Optional)'
	                    )
	                  ),
	                  _react2.default.createElement(_autocomplete2.default, {
	                    source: specialTeamsPositions,
	                    value: special_teams //eslint-disable-line
	                    , onChange: function onChange(val) {
	                      return _this3.handleChange('special_teams', val);
	                    },
	                    multiple: false,
	                    onQueryChange: function onQueryChange() {
	                      return _this3.handleQueryChange('special_teams');
	                    },
	                    direction: 'down',
	                    onFocus: function onFocus() {
	                      return _this3.removeErrorMessage('specialTeamsErrorMessage');
	                    },
	                    theme: _theme2.default
	                  }),
	                  _react2.default.createElement(_ErrorMessage2.default, { message: specialTeamsErrorMessage })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _SportsBoard2.default.fullWidth },
	            _react2.default.createElement(
	              'div',
	              { className: t40ErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                '40-YARD DASH'
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                source: this.state.t40 === '' ? emptyObject : t40Suggestions,
	                multiple: false,
	                allowCreate: true,
	                selectedPosition: 'below',
	                direction: 'down',
	                value: this.state.t40,
	                onChange: function onChange(val) {
	                  return _this3.handleChange('t40', val);
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this3.handleChange('t40', val);
	                }
	                /* onQueryChange={() => this.handleQueryChange('t40')} */
	                , onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('t40ErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: t40ErrorMessage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: squatsErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'SQUATS MAXIMUM'
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                source: this.state.squats === '' ? emptyObject : squatsSuggestions,
	                allowCreate: true,
	                multiple: false,
	                value: this.state.squats,
	                selectedPosition: 'below',
	                direction: 'down',
	                onChange: function onChange(val) {
	                  return _this3.handleChange('squats', val);
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this3.handleChange('squats', val);
	                },
	                onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('squatsErrorMessage');
	                }
	                /* onQueryChange={val => this.generateDropdown(val, 'squatsSuggestions')}
	                onFocus={() => this.removeErrorMessage('squatsErrorMessage')} */
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: squatsErrorMessage })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.fullWidth) },
	            _react2.default.createElement(
	              'div',
	              { className: benchErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _SportsBoard2.default.halfWidthWithSpanError) },
	              _react2.default.createElement(
	                'span',
	                null,
	                'BENCH MAXIMUM'
	              ),
	              _react2.default.createElement(_autocomplete2.default, {
	                source: this.state.bench === '' ? emptyObject : benchSuggestions,
	                value: this.state.bench,
	                multiple: false,
	                allowCreate: true,
	                selectedPosition: 'below',
	                direction: 'down',
	                onChange: function onChange(val) {
	                  return _this3.handleChange('bench', val);
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this3.handleChange('bench', val);
	                }
	                /* onQueryChange={val => this.generateDropdown(val, 'benchSuggestions')} */
	                , onFocus: function onFocus() {
	                  return _this3.removeErrorMessage('benchErrorMessage');
	                }
	              }),
	              _react2.default.createElement(_ErrorMessage2.default, { message: benchErrorMessage })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _SportsBoard2.default.buttonContainer) },
	            _react2.default.createElement(_button2.default, { label: '< PREVIOUS', className: _SportsBoard2.default.back, onClick: this.props.back }),
	            _react2.default.createElement(_button2.default, { label: 'CONTINUE', raised: true, className: _SportsBoard2.default.continue, onClick: function onClick() {
	                return _this3.addHeightAndSave();
	              } })
	          )
	        ))
	      );
	    }
	  }]);
	
	  return SportsBoard;
	}(_react2.default.Component);
	
	SportsBoard.propTypes = {
	  next: _propTypes2.default.func.isRequired,
	  show: _propTypes2.default.bool.isRequired,
	  back: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.instanceOf(_immutable.Map)
	};
	SportsBoard.defaultProps = {
	  next: function next() {},
	  show: false,
	  back: function back() {},
	  profile: (0, _immutable.Map)()
	};
	exports.default = SportsBoard;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SportsBoard = __webpack_require__(1231);
	
	var _SportsBoard2 = _interopRequireDefault(_SportsBoard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SportsBoard2.default;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _Footer = __webpack_require__(454);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _StaticContainer = __webpack_require__(1538);
	
	var _StaticContainer2 = _interopRequireDefault(_StaticContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	var StaticContainer = function (_Component) {
	  _inherits(StaticContainer, _Component);
	
	  function StaticContainer(props) {
	    _classCallCheck(this, StaticContainer);
	
	    var _this = _possibleConstructorReturn(this, (StaticContainer.__proto__ || Object.getPrototypeOf(StaticContainer)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(StaticContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _StaticContainer2.default.container },
	        _react2.default.createElement(_NavOnScroll2.default, this.props),
	        this.props.children,
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return StaticContainer;
	}(_react.Component);
	
	StaticContainer.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	exports.default = (0, _Session2.default)(StaticContainer);

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StaticContainer = __webpack_require__(1233);
	
	var _StaticContainer2 = _interopRequireDefault(_StaticContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticContainer2.default;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navigation = __webpack_require__(197);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _StaticHeader = __webpack_require__(1539);
	
	var _StaticHeader2 = _interopRequireDefault(_StaticHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to validate and set default props  coming to this component
	var StaticHeader = function StaticHeader(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.page === 'sports' ? (0, _classnames2.default)('col s12', _StaticHeader2.default.sportsHeader) : (0, _classnames2.default)('col s12', _StaticHeader2.default.aboutUsHeader) },
	    _react2.default.createElement(_Navigation2.default, props),
	    _react2.default.createElement(
	      'div',
	      { className: _StaticHeader2.default.bottomText },
	      _react2.default.createElement(
	        'span',
	        null,
	        props.page === 'sports' ? 'We Provide Unmatched Social Media Exposure!' : '',
	        props.page === 'about_us' ? 'College Football Recruiting Never Stops!' : '',
	        props.page === 't&c' ? 'TERMS OF SERVICE AND USER AGREEMENT' : ''
	      )
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	
	
	StaticHeader.propTypes = {
	  page: _propTypes2.default.string.isRequired
	};
	
	exports.default = StaticHeader;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactToolbox = __webpack_require__(251);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StudentTabs = __webpack_require__(1540);
	
	var _StudentTabs2 = _interopRequireDefault(_StudentTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	
	// to import local scss fle
	
	var StudentTabs = function (_React$Component) {
	  _inherits(StudentTabs, _React$Component);
	
	  function StudentTabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StudentTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StudentTabs.__proto__ || Object.getPrototypeOf(StudentTabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: 0,
	      fixedIndex: 1,
	      inverseIndex: 1
	    }, _this.handleTabChange = function (index) {
	      _this.setState({ index: index });
	      _this.props.tabListener(index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StudentTabs, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _StudentTabs2.default.container) },
	        _react2.default.createElement(
	          _reactToolbox.Tabs,
	          { index: this.state.index, onChange: this.handleTabChange },
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'Recommendations', activeClassName: _StudentTabs2.default.activeClass }),
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'My Requests', activeClassName: _StudentTabs2.default.activeClass }),
	          _react2.default.createElement(_reactToolbox.Tab, { label: 'Wishlist', activeClassName: _StudentTabs2.default.activeClass })
	        )
	      );
	    }
	  }]);
	
	  return StudentTabs;
	}(_react2.default.Component);
	
	StudentTabs.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired
	};
	exports.default = StudentTabs;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StudentTabs = __webpack_require__(1236);
	
	var _StudentTabs2 = _interopRequireDefault(_StudentTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StudentTabs2.default;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _TextField = __webpack_require__(1541);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	// to use global class name eg. classes from grid.css in public folder
	// to use input from react-toolbox library
	var TextField = function TextField(props) {
	  var handleOnChange = function handleOnChange(e) {
	    props.onChange(e);
	  };
	  /* const handleError = () => {
	      // eslint-disable-next-line
	    props.emptyError;
	  }; */
	  var showErrorMessage = (0, _renderIf2.default)(props.errorMessage !== '');
	  return _react2.default.createElement(
	    'div',
	    { className: props.errorMessage === '' ? (0, _classnames2.default)('row', _TextField2.default.textFieldContainer) : (0, _classnames2.default)('row', _TextField2.default.textFieldContainerOnError) },
	    _react2.default.createElement(
	      'label',
	      { className: _TextField2.default.label, htmlFor: 'Email' },
	      props.label
	    ),
	    props.usedFor === 'forgotPassword' ? _react2.default.createElement(_input2.default, {
	      htmlFor: 'name',
	      type: 'password',
	      onChange: handleOnChange,
	      onFocus: props.onFocus,
	      onKeyPress: props.onKeyPress
	    }) : _react2.default.createElement(_input2.default, {
	      htmlFor: 'password',
	      type: 'text',
	      className: props.usedFor === 'signupEmail' ? _TextField2.default.makeEmailSmall : '',
	      onChange: handleOnChange,
	      onFocus: props.onFocus,
	      onKeyPress: props.onKeyPress
	    }),
	    showErrorMessage(_react2.default.createElement(_ErrorMessage2.default, { message: props.errorMessage }))
	  );
	}; // to use conditional rendering based on values that is provided to component
	// to display error messages on invalid user input
	// to validate and set default props  coming to this component
	
	
	TextField.propTypes = {
	  // eslint-disable-next-line
	  onChange: _propTypes2.default.func.isRequired,
	  onFocus: _propTypes2.default.func,
	  /* emptyError: PropTypes.func.isRequired, */
	  label: _propTypes2.default.string.isRequired,
	  errorMessage: _propTypes2.default.string.isRequired,
	  usedFor: _propTypes2.default.string,
	  onKeyPress: _propTypes2.default.func.isRequired
	};
	
	TextField.defaultProps = {
	  onChange: function onChange() {},
	  label: '',
	  onFocus: function onFocus() {},
	  errorMessage: '',
	  usedFor: ''
	};
	
	exports.default = TextField;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Totalcounts = __webpack_require__(1542);
	
	var _Totalcounts2 = _interopRequireDefault(_Totalcounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var Totalcounts = function Totalcounts() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _Totalcounts2.default.counts) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s6 m3', _Totalcounts2.default.countsBody) },
	      _react2.default.createElement(
	        'div',
	        { className: _Totalcounts2.default.centerDiv },
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumber },
	          '135,199'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumberText },
	          'TWITTER FOLLOWERS'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: _Totalcounts2.default.underline })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s6 m3', _Totalcounts2.default.countsBody) },
	      _react2.default.createElement(
	        'div',
	        { className: _Totalcounts2.default.centerDiv },
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumber },
	          '898'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumberText },
	          'FOOTBALL COLLEGES AND UNIVERSITIES'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: _Totalcounts2.default.underline })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s6 m3', _Totalcounts2.default.countsBody) },
	      _react2.default.createElement(
	        'div',
	        { className: _Totalcounts2.default.centerDiv },
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumber },
	          '5,483'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumberText },
	          'ACTIVE FOOTBALL COACHES'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: _Totalcounts2.default.underline })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s6 m3', _Totalcounts2.default.countsBody) },
	      _react2.default.createElement(
	        'div',
	        { className: _Totalcounts2.default.centerDiv },
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumber },
	          '262 '
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: _Totalcounts2.default.totalNumberText },
	          'D1 FCS AND FBS SCHOOLS'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement('div', { className: _Totalcounts2.default.underline })
	        )
	      )
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = Totalcounts;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Totalcounts = __webpack_require__(1239);
	
	var _Totalcounts2 = _interopRequireDefault(_Totalcounts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Totalcounts2.default;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TrialNotification = __webpack_require__(1543);
	
	var _TrialNotification2 = _interopRequireDefault(_TrialNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	
	// to use global class name eg. classes from grid.css in public folder
	/* eslint-disable max-len */
	function TrialNotification(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _TrialNotification2.default.container) },
	    _react2.default.createElement(
	      'span',
	      { className: (0, _classnames2.default)('col s12', _TrialNotification2.default.notification) },
	      'You are currently on a free trial which expires at ',
	      (0, _moment2.default)(props.trialEndDate).format('HH:MM on MMM DD YYYY'),
	      '. To contact coaches please click on menu and dashboard, then click contact coach for any you are interested in. Please upgrade your account to continue uninterrupted paid services.',
	      ' ',
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/pricing' },
	        'Upgrade Now'
	      )
	    )
	  );
	}
	// eslint-disable-next-line no-unused-vars
	
	
	TrialNotification.propTypes = {
	  trialEndDate: _propTypes2.default.string.isRequired
	};
	
	exports.default = TrialNotification;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UpgradeTiles = __webpack_require__(1245);
	
	var _UpgradeTiles2 = _interopRequireDefault(_UpgradeTiles);
	
	var _UpgradePopup = __webpack_require__(1544);
	
	var _UpgradePopup2 = _interopRequireDefault(_UpgradePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// import renderIf from 'render-if';
	
	
	// to import local scss fle
	
	var PlanModel = function (_Component) {
	  _inherits(PlanModel, _Component);
	
	  function PlanModel(props) {
	    _classCallCheck(this, PlanModel);
	
	    var _this = _possibleConstructorReturn(this, (PlanModel.__proto__ || Object.getPrototypeOf(PlanModel)).call(this, props));
	
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.state = {
	      open: true,
	      title: ''
	    };
	    return _this;
	  }
	
	  _createClass(PlanModel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var paymentStatus = window.sessionStorage.getItem('kiro');
	      this.setState({ payment: paymentStatus });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var paymentStatus = window.sessionStorage.getItem('kiro');
	      this.setState({ payment: paymentStatus });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)'
	        },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          minHeight: '300px',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      var open = this.state.open;
	      // let getTotalCountsCompleted = false;
	      // if (this.props.totalCounts.size > 0) {
	      //   getTotalCountsCompleted = true;
	      // }
	      // const renderModal = renderIf(getTotalCountsCompleted);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: open, onRequestClose: this.onCloseModal },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row', _UpgradePopup2.default.container) },
	            _react2.default.createElement(
	              'div',
	              { className: _UpgradePopup2.default.absoluteCross, onClick: this.onCloseModal },
	              'x'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _UpgradePopup2.default.header) },
	              'UPGRADE'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12') },
	              _react2.default.createElement(_UpgradeTiles2.default, Object.assign({}, this.props, { showTrialButton: this.props.showTrialButton }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PlanModel;
	}(_react.Component);
	
	PlanModel.propTypes = {
	  showTrialButton: _propTypes2.default.bool.isRequired
	};
	PlanModel.defaultProps = {
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = PlanModel;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UpgradePopup = __webpack_require__(1242);
	
	var _UpgradePopup2 = _interopRequireDefault(_UpgradePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UpgradePopup2.default;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _UpgradeTiles = __webpack_require__(1545);
	
	var _UpgradeTiles2 = _interopRequireDefault(_UpgradeTiles);
	
	var _saProfile = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
	// to use global class name eg. classes from grid.css in public folder
	//  to change path from inside or to alter react-router-dom path
	// to import local scss fle
	
	
	var UpgradeTiles = function (_Component) {
	  _inherits(UpgradeTiles, _Component);
	
	  function UpgradeTiles(props) {
	    _classCallCheck(this, UpgradeTiles);
	
	    var _this = _possibleConstructorReturn(this, (UpgradeTiles.__proto__ || Object.getPrototypeOf(UpgradeTiles)).call(this, props));
	
	    _this.setLoader = function () {
	      _this.setState({
	        isLoading: !_this.isLoading
	      });
	    };
	
	    _this.state = {
	      value: '',
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(UpgradeTiles, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.profile.size > 0) {
	        var saSports = this.props.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	
	        var academic = this.props.profile.get('academic');
	
	        var combinedHeight = this.props.profile.get('height');
	        var heightIncm = parseInt(combinedHeight.charAt(0)) * 12 + parseInt(combinedHeight.substr(2, 2)); // eslint-disable-line
	        var payload = {
	          stats: {
	            student_parameters: {
	              squats: parseInt(sport.get('squats'), 10),
	              bench: parseInt(sport.get('bench'), 10),
	              forty: parseFloat(sport.get('t40')),
	              weight: parseInt(this.props.profile.get('weight'), 10),
	              height: heightIncm
	            },
	            role: 'QB',
	            consider_squats_and_bench: 'yes'
	          },
	          gpa: parseFloat(academic.get('gpa'), 10),
	          act: parseInt(academic.get('act'), 10)
	        };
	        this.props.getTotalCounts(payload);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.profile.size > 0 && !nextProps.totalCounts.size > 0) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	
	        var academic = nextProps.profile.get('academic');
	
	        var combinedHeight = nextProps.profile.get('height');
	        var heightIncm = parseInt(combinedHeight.charAt(0)) * 12 + parseInt(combinedHeight.substr(2, 2)); // eslint-disable-line
	        var payload = {
	          stats: {
	            student_parameters: {
	              squats: parseInt(sport.get('squats'), 10),
	              bench: parseInt(sport.get('bench'), 10),
	              forty: parseFloat(sport.get('t40')),
	              weight: parseInt(this.props.profile.get('weight'), 10),
	              height: heightIncm
	            },
	            role: 'QB',
	            consider_squats_and_bench: 'yes'
	          },
	          gpa: parseFloat(academic.get('gpa'), 10),
	          act: parseInt(academic.get('act'), 10)
	        };
	        this.props.getTotalCounts(payload);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getTotalCountsCompleted = false;
	      var saProfileID = '';
	      var showTrialButton = this.props.showTrialButton;
	
	      if (this.props.profile !== undefined) {
	        saProfileID = this.props.profile.get('id');
	      }
	      if (this.props.totalCounts.size > 0) {
	        getTotalCountsCompleted = true;
	      }
	      var onPressTryForFree = function onPressTryForFree() {
	        _this2.setLoader();
	        var params = {
	          id: saProfileID,
	          trialType: 'free_trial_1'
	        };
	        (0, _saProfile.startTrial)(params).then(function (res, err) {
	          if (!err) {
	            _this2.setLoader();
	            window.location.reload();
	            // console.log(res);
	          } else {
	            _this2.setLoader();
	            window.location.reload();
	            // console.log(err);
	          }
	        });
	      };
	      var renderLoader = (0, _renderIf2.default)(!getTotalCountsCompleted || this.state.isLoading);
	      // console.log('ontrialtile: ', this.props.onTrial);
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.usedFor === 'profile_page' ? (0, _classnames2.default)('col s12', _UpgradeTiles2.default.smallContainer) : (0, _classnames2.default)('col s12', _UpgradeTiles2.default.container) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        getTotalCountsCompleted ? _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12') },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _UpgradeTiles2.default.tilesContainer) },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/blur%403x.png', alt: 'blur' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _UpgradeTiles2.default.upgradeText },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Congratulations your biometrics, position, and academics matched to ',
	              this.props.totalCounts.get('count'),
	              ' colleges. Upgrade your account to start your recruiting process with these matches.',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null),
	              this.props.onTrial ? 'You are currently on a two day free trial. You can contact up to 10 colleges every 24 hours while your trial lasts. After that you will go back to 1 request every 24 hours. Please upgrade your account to continue the premium benefits after your trial ends.' : 'You are currently on a free account. You can contact 1 college every 24 hours. Please upgrade your account to contact up to 10 colleges a day.',
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { to: '/pricing' },
	                  _react2.default.createElement(
	                    'button',
	                    { style: { marginTop: 20 } },
	                    'UPGRADE NOW'
	                  )
	                ),
	                showTrialButton ? _react2.default.createElement(
	                  'button',
	                  { className: _UpgradeTiles2.default.tryButton, onClick: onPressTryForFree },
	                  'TRY FOR FREE'
	                ) : ''
	              )
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	
	  return UpgradeTiles;
	}(_react.Component);
	
	UpgradeTiles.propTypes = {
	  getTotalCounts: _propTypes2.default.func.isRequired,
	  profile: _propTypes2.default.shape().isRequired,
	  totalCounts: _propTypes2.default.shape().isRequired,
	  usedFor: _propTypes2.default.string,
	  showTrialButton: _propTypes2.default.bool.isRequired,
	  onTrial: _propTypes2.default.bool.isRequired
	};
	UpgradeTiles.defaultProps = {
	  usedFor: ''
	};
	exports.default = UpgradeTiles;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UpgradeTiles = __webpack_require__(1244);
	
	var _UpgradeTiles2 = _interopRequireDefault(_UpgradeTiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UpgradeTiles2.default;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _actions = __webpack_require__(110);
	
	var _User = __webpack_require__(1546);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	
	
	// to import local scss fle
	
	var state = {
	  AL: 'Alabama',
	  AK: 'Alaska',
	  AZ: 'Arizona',
	  AR: 'Arkansas',
	  CA: 'California',
	  CO: 'Colorado',
	  CT: 'Connecticut',
	  DE: 'Delaware',
	  FL: 'Florida',
	  GA: 'Georgia',
	  HI: 'Hawaii',
	  ID: 'Idaho',
	  IL: 'Illinois',
	  IN: 'Indiana',
	  IA: 'Iowa',
	  KS: 'Kansas',
	  KY: 'Kentucky',
	  LA: 'Louisiana',
	  ME: 'Maine',
	  MD: 'Maryland',
	  MA: 'Massachusetts',
	  MI: 'Michigan',
	  MN: 'Minnesota',
	  MS: 'Mississippi',
	  MO: 'Missouri',
	  MT: 'Montana',
	  NE: 'Nebraska',
	  NV: 'Nevada',
	  NH: 'New Hampshire',
	  NJ: 'New Jersey',
	  NM: 'New Mexico',
	  NY: 'New York',
	  NC: 'North Carolina',
	  ND: 'North Dakota',
	  OH: 'Ohio',
	  OK: 'Oklahoma',
	  OR: 'Oregon',
	  PA: 'Pennsylvania',
	  RI: 'Rhode Island',
	  SC: 'South Carolina',
	  SD: 'South Dakota',
	  TN: 'Tennessee',
	  TX: 'Texas',
	  UT: 'Utah',
	  VT: 'Vermont',
	  VA: 'Virginia',
	  WA: 'Washington D.C',
	  WN: 'Washington',
	  WV: 'West Virginia',
	  WI: 'Wisconsin',
	  WY: 'Wyoming'
	};
	
	var User = function (_Component) {
	  _inherits(User, _Component);
	
	  function User(props) {
	    _classCallCheck(this, User);
	
	    var _this = _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).call(this, props));
	
	    _this.state = {
	      changeImage: false,
	      userImage: ''
	    };
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.onMouseHover = _this.onMouseHover.bind(_this);
	    _this.onMouseOut = _this.onMouseOut.bind(_this);
	    return _this;
	  }
	
	  _createClass(User, [{
	    key: 'onMouseHover',
	    value: function onMouseHover() {
	      this.setState({ changeImage: true });
	    }
	  }, {
	    key: 'onMouseOut',
	    value: function onMouseOut() {
	      this.setState({ changeImage: false });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var _this2 = this;
	
	      var reader = new window.FileReader();
	      var file = event.target.files[0];
	      reader.onloadend = function () {
	        _this2.setState({
	          userImage: reader.result
	        });
	      };
	      reader.readAsDataURL(file);
	      // this.setState({ userImage: image });
	      this.props.saveUserImage(this.props.profileId, file);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderChangeImage = (0, _renderIf2.default)(this.state.changeImage && !(this.props.navBarUsedBy === 'coach'));
	      var renderChangeImageForm = (0, _renderIf2.default)(this.props.navBarUsedBy === 'athlete');
	      var renderTwitterIcon = (0, _renderIf2.default)(this.props.twitter !== '');
	      var renderInstagramIcon = (0, _renderIf2.default)(this.props.instagram !== '');
	      // console.log(this.props);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _User2.default.userContainer) },
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _User2.default.profileInfo) },
	            _react2.default.createElement(
	              'div',
	              {
	                className: _User2.default.image, onMouseOver: this.onMouseHover,
	                onMouseOut: this.onMouseOut
	              },
	              this.state.userImage !== '' ? _react2.default.createElement('img', {
	                className: _User2.default.image,
	                src: this.state.userImage,
	                alt: 'user_image'
	              }) : _react2.default.createElement('img', {
	                className: _User2.default.image,
	                src: this.props.profile_image !== '' ? 'https://s3.amazonaws.com/myrbimages/' + this.props.profile_image : 'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	                alt: 'profile'
	              }),
	              renderChangeImage(_react2.default.createElement(
	                'div',
	                { className: _User2.default.changeImage },
	                _react2.default.createElement(
	                  'div',
	                  { className: _User2.default.changeImageText },
	                  'change image.'
	                )
	              )),
	              renderChangeImageForm(_react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement('input', {
	                  className: _User2.default.fileInput,
	                  type: 'file',
	                  ref: 'file' //eslint-disable-line
	                  , name: 'myImage',
	                  accept: '.jpg,.jpeg',
	                  onChange: this.handleChange
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _User2.default.description },
	              _react2.default.createElement(
	                'p',
	                { className: _User2.default.playerName },
	                this.props.fullname
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _User2.default.location },
	                _react2.default.createElement(
	                  'spann',
	                  null,
	                  this.props.city
	                ),
	                ', \xA0',
	                state[this.props.state]
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: _User2.default.location },
	                this.props.school,
	                _react2.default.createElement('br', null),
	                this.props.year_of_graduation
	              ),
	              renderTwitterIcon(_react2.default.createElement(
	                'a',
	                { className: _User2.default.twitterIcon, target: '_blank', href: this.props.twitter },
	                _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/twitterForProfile.png', alt: 'twitter_icon' })
	              )),
	              renderInstagramIcon(_react2.default.createElement(
	                'a',
	                { className: _User2.default.instaIcon, target: '_blank', href: this.props.instagram },
	                _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/instaForProfile.png', alt: 'twitter_icon' })
	              )),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/athlete/' + this.props.profileId, target: '_blank' },
	                _react2.default.createElement('img', { className: _User2.default.shareIcon, src: 'https://media.dev.myrecruitboard.com/Images/share-icon.png', alt: 'share-icon', title: 'Go to public profile' })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return User;
	}(_react.Component);
	
	User.propTypes = {
	  fullname: _propTypes2.default.string,
	  state: _propTypes2.default.string,
	  city: _propTypes2.default.string,
	  school: _propTypes2.default.string,
	  year_of_graduation: _propTypes2.default.string,
	  saveUserImage: _propTypes2.default.func.isRequired,
	  profileId: _propTypes2.default.string,
	  profile_image: _propTypes2.default.string,
	  navBarUsedBy: _propTypes2.default.string,
	  instagram: _propTypes2.default.string.isRequired,
	  twitter: _propTypes2.default.string.isRequired
	};
	User.defaultProps = {
	  fullname: '',
	  state: '',
	  city: '',
	  school: '',
	  year_of_graduation: '',
	  profileId: '',
	  profile_image: _propTypes2.default.string,
	  navBarUsedBy: _propTypes2.default.string
	};
	exports.default = (0, _reactRedux.connect)(null, {
	  saveUserImage: _actions.saveUserImage
	})(User);

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _User = __webpack_require__(1246);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _User2.default;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AddVideos = __webpack_require__(445);
	
	var _AddVideos2 = _interopRequireDefault(_AddVideos);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _UserDesc = __webpack_require__(1547);
	
	var _UserDesc2 = _interopRequireDefault(_UserDesc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to validate and set default props  coming to this component
	// to use conditional rendering based on values that is provided to component
	
	// to import local scss fle
	
	
	var UserDesc = function (_Component) {
	  _inherits(UserDesc, _Component);
	
	  _createClass(UserDesc, null, [{
	    key: 'isEmpty',
	    value: function isEmpty(val) {
	      if (val) {
	        return false;
	      }
	      return true;
	    }
	  }]);
	
	  function UserDesc(props) {
	    _classCallCheck(this, UserDesc);
	
	    var _this = _possibleConstructorReturn(this, (UserDesc.__proto__ || Object.getPrototypeOf(UserDesc)).call(this, props));
	
	    _this.removeVideo = function (index) {
	      var data = {
	        student_id: _this.props.profile.get('id'),
	        video_index: index
	      };
	      _this.props.removeVideo(data);
	    };
	
	    _this.state = {
	      value: '',
	      seeAll: false
	    };
	    _this.displayVideo = _this.displayVideo.bind(_this);
	    _this.seeAll = _this.seeAll.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserDesc, [{
	    key: 'displayVideo',
	    value: function displayVideo(link) {
	      this.props.removeVideoScreen();
	      this.props.setCurrentVideo(link);
	    }
	  }, {
	    key: 'seeAll',
	    value: function seeAll() {
	      this.setState({ seeAll: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          video = _props.video,
	          attributes = _props.attributes,
	          evaluationText = _props.evaluationText;
	
	      var renderVideoButton = (0, _renderIf2.default)(!this.props.public === 'yes');
	      var renderSeeAll = (0, _renderIf2.default)(video.length > 4 && !this.state.seeAll);
	      var renderVideo = (0, _renderIf2.default)(video.length > 0);
	      var renderEvaluationText = (0, _renderIf2.default)(evaluationText !== undefined);
	      var renderdeleteButton = (0, _renderIf2.default)(this.props.public !== 'yes');
	      var userIsCoach = false;
	      if (this.props.attributes.size > 0) {
	        if (this.props.attributes.get('zoneinfo') === 'COACH') {
	          userIsCoach = true;
	        }
	      }
	      var renderAddVideo = (0, _renderIf2.default)(attributes.size > 0 && !userIsCoach && this.props.public !== 'yes');
	      var showVideos = video;
	      if (!this.state.seeAll) {
	        showVideos = video.slice(0, 5);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _UserDesc2.default.userDescContainer) },
	        renderEvaluationText(_react2.default.createElement(
	          'div',
	          { className: _UserDesc2.default.hideInSmall },
	          _react2.default.createElement(
	            'span',
	            { className: _UserDesc2.default.blackHeader },
	            'STUDENT EVALUATION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _UserDesc2.default.desciption },
	            evaluationText,
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null)
	          )
	        )),
	        renderVideoButton(_react2.default.createElement(_AddVideos2.default, this.props)),
	        renderVideo(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _UserDesc2.default.videoheader) },
	          _react2.default.createElement(
	            'span',
	            { className: _UserDesc2.default.blackHeader },
	            'VIDEOS'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _UserDesc2.default.seeAllVideos },
	            renderSeeAll(_react2.default.createElement(
	              'span',
	              { onClick: this.seeAll },
	              'See All(',
	              video.length,
	              ')'
	            ))
	          )
	        )),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _UserDesc2.default.videoSection) },
	          showVideos.map(function (item, i) {
	            return _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col  s6 ', _UserDesc2.default.videoBox) },
	              _react2.default.createElement(
	                'div',
	                { className: _UserDesc2.default.video },
	                renderdeleteButton(_react2.default.createElement(
	                  'button',
	                  { onClick: function onClick() {
	                      return _this2.removeVideo(i);
	                    }, className: _UserDesc2.default.editIcon },
	                  _react2.default.createElement('img', { src: 'https://media.dev.myrecruitboard.com/Images/white_delete.png', alt: 'edit-icon' })
	                )),
	                _react2.default.createElement('img', { className: _UserDesc2.default.videoImage, src: item.thumbnail_url, alt: 'thumbnail' }),
	                item.thumbnail_url && item.thumbnail_url.length > 0 && item.thumbnail_url.indexOf('youtube') > -1 ? _react2.default.createElement(
	                  'button',
	                  {
	                    className: _UserDesc2.default.playbutton,
	                    onClick: function onClick() {
	                      return _this2.displayVideo(item.video_url);
	                    }
	                  },
	                  _react2.default.createElement('img', { className: _UserDesc2.default.playButtonImage, src: 'https://media.dev.myrecruitboard.com/Images/video-icon_3%403x.png', alt: 'video' })
	                ) : _react2.default.createElement(
	                  'button',
	                  { className: _UserDesc2.default.playbutton },
	                  _react2.default.createElement(
	                    'a',
	                    { href: item.video_url, target: '_blank', rel: 'noopener noreferrer' },
	                    _react2.default.createElement('img', { className: _UserDesc2.default.playButtonImage, src: 'https://media.dev.myrecruitboard.com/Images/video-icon_3%403x.png', alt: 'video' })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _UserDesc2.default.titile },
	                item.video_title
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12') },
	          renderAddVideo(_react2.default.createElement(_AddVideos2.default, this.props))
	        )
	      );
	    }
	  }]);
	
	  return UserDesc;
	}(_react.Component);
	
	UserDesc.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  profile: _propTypes2.default.shape(),
	  video: _propTypes2.default.shape(),
	  setCurrentVideo: _propTypes2.default.func,
	  removeVideoScreen: _propTypes2.default.func,
	  removeVideo: _propTypes2.default.func,
	  public: _propTypes2.default.string.isRequired,
	  evaluationText: _propTypes2.default.string.isRequired
	};
	UserDesc.defaultProps = {
	  video: [],
	  attributes: {},
	  description: '',
	  profile: {},
	  removeVideo: function removeVideo() {},
	  setCurrentVideo: function setCurrentVideo() {},
	  removeVideoScreen: function removeVideoScreen() {}
	};
	exports.default = UserDesc;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserDesc = __webpack_require__(1248);
	
	var _UserDesc2 = _interopRequireDefault(_UserDesc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UserDesc2.default;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Divider = __webpack_require__(74);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _UserInfo = __webpack_require__(1548);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	
	// to validate and set default props  coming to this component
	var UserInfo = function UserInfo(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _UserInfo2.default.userInfoContainer) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _UserInfo2.default.dataBox) },
	      _react2.default.createElement(
	        'span',
	        { className: _UserInfo2.default.mainHeader },
	        'MY BIOMETERIC INFO'
	      ),
	      _react2.default.createElement(_Divider2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePadding) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' HEIGHT'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.otherText },
	            props.height
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' WEIGHT'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.otherText },
	            props.weight
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' BENCH MAX'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.position },
	            ' ',
	            props.bench
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' SQUATS MAX'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.position },
	            ' ',
	            props.squats
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s6') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' 40-YARD DASH'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.position },
	            ' ',
	            props.t40
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _UserInfo2.default.dataBox) },
	      _react2.default.createElement(
	        'span',
	        { className: _UserInfo2.default.mainHeader },
	        'MY SPORT INFO'
	      ),
	      _react2.default.createElement(_Divider2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePadding) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col 2') },
	          _react2.default.createElement('img', { className: _UserInfo2.default.icon, src: 'https://media.dev.myrecruitboard.com/Images/defaultFootball.png', alt: 'footballIcon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.gameName },
	            props.sportName
	          ),
	          _react2.default.createElement('br', null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePaddingReplica) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col 12') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            'POSITIONS'
	          ),
	          _react2.default.createElement('br', null),
	          props.primary_offensive_position_pref !== '' || props.secondary_offensive_position_pref ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePaddingReplica) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s4', _UserInfo2.default.attackType) },
	              _react2.default.createElement(
	                'span',
	                { className: _UserInfo2.default.positionHeader },
	                'OFFENSIVE: \xA0'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s8', _UserInfo2.default.position) },
	              _DropdownsValues.positions[props.primary_offensive_position_pref],
	              ' ',
	              _react2.default.createElement('br', null),
	              _DropdownsValues.positions[props.secondary_offensive_position_pref]
	            )
	          ) : '',
	          props.primary_defensive_position_pref || props.secondary_defensive_position_pref ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePaddingReplica) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s4', _UserInfo2.default.attackType) },
	              _react2.default.createElement(
	                'span',
	                { className: _UserInfo2.default.positionHeader },
	                'DEFENSIVE: \xA0'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s8', _UserInfo2.default.position) },
	              _DropdownsValues.positions[props.primary_defensive_position_pref],
	              ' ',
	              _react2.default.createElement('br', null),
	              _DropdownsValues.positions[props.secondary_defensive_position_pref]
	            )
	          ) : '',
	          props.special_teams ? _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePaddingReplica) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s4', _UserInfo2.default.attackType) },
	              _react2.default.createElement(
	                'span',
	                { className: _UserInfo2.default.positionHeader },
	                'SPECIAL TEAMS: \xA0'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s8', _UserInfo2.default.position) },
	              _DropdownsValues.positions[props.special_teams],
	              ' ',
	              _react2.default.createElement('br', null)
	            )
	          ) : ''
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _UserInfo2.default.dataBox) },
	      _react2.default.createElement(
	        'span',
	        { className: _UserInfo2.default.mainHeader },
	        'MY ACADEMIC BOARD'
	      ),
	      _react2.default.createElement(_Divider2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePadding) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col 2') },
	          _react2.default.createElement('img', { className: _UserInfo2.default.icon, src: 'https://media.dev.myrecruitboard.com/Images/defaultCollege.png', alt: 'footballIcon' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s10') },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.gameName },
	            props.school
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.position },
	            ' Year of Graduation - ',
	            props.year_of_graduation
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4 m4', _UserInfo2.default.topSpace) },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' GPA'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.position },
	            ' ',
	            props.gpa
	          )
	        ),
	        props.sat !== '' ? _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4 m4', _UserInfo2.default.topSpace) },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' SAT'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.position },
	            ' ',
	            props.sat
	          )
	        ) : '',
	        props.act !== '' ? _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s4 m4', _UserInfo2.default.topSpace) },
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.blackHeader },
	            ' ACT '
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            { className: _UserInfo2.default.position },
	            ' ',
	            props.act
	          )
	        ) : ''
	      )
	    )
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	
	
	UserInfo.propTypes = {
	  height: _propTypes2.default.string.isRequired,
	  weight: _propTypes2.default.string.isRequired,
	  sportName: _propTypes2.default.string.isRequired,
	  t40: _propTypes2.default.string.isRequired,
	  bench: _propTypes2.default.string.isRequired,
	  squats: _propTypes2.default.string.isRequired,
	  school: _propTypes2.default.string.isRequired,
	  year_of_graduation: _propTypes2.default.string.isRequired,
	  gpa: _propTypes2.default.string.isRequired,
	  sat: _propTypes2.default.string.isRequired,
	  act: _propTypes2.default.string.isRequired,
	  primary_offensive_position_pref: _propTypes2.default.string.isRequired,
	  primary_defensive_position_pref: _propTypes2.default.string.isRequired,
	  secondary_offensive_position_pref: _propTypes2.default.string.isRequired,
	  secondary_defensive_position_pref: _propTypes2.default.string.isRequired,
	  special_teams: _propTypes2.default.string.isRequired
	};
	
	exports.default = UserInfo;

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _UserInfo = __webpack_require__(1250);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UserInfo2.default;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _immutable = __webpack_require__(11);
	
	var _routeNames = __webpack_require__(55);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _ValidateCoach = __webpack_require__(1549);
	
	var _ValidateCoach2 = _interopRequireDefault(_ValidateCoach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var ValidateCoach = function (_Component) {
	  _inherits(ValidateCoach, _Component);
	
	  function ValidateCoach(props) {
	    _classCallCheck(this, ValidateCoach);
	
	    var _this = _possibleConstructorReturn(this, (ValidateCoach.__proto__ || Object.getPrototypeOf(ValidateCoach)).call(this, props));
	
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.state = {
	      open: true,
	      title: '',
	      renderPopUp: false,
	      makeCoachLogOutFromHere: false
	    };
	    return _this;
	  }
	
	  _createClass(ValidateCoach, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.attributes.size > 0) {
	        var payload = {};
	        payload = {
	          coach_email: this.props.attributes.get('email')
	        };
	        this.props.getCoachFromDatabase(payload);
	      }
	      var currentUser = window.sessionStorage.getItem('user');
	      if (currentUser === 'COACH') {
	        this.setState({ makeCoachLogOutFromHere: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var currentUser = window.sessionStorage.getItem('user');
	      if (currentUser === 'COACH') {
	        this.setState({ makeCoachLogOutFromHere: true });
	      }
	      if (nextProps.attributes.size > 0 && !nextProps.validCoachData.size > 0 && (0, _immutable.is)(this.props.validCoachData, nextProps.validCoachData) && !nextProps.validateCoachRequested) {
	        var payload = {};
	        payload = Object.assign({
	          coach_email: nextProps.attributes.get('email')
	        });
	        this.props.getCoachFromDatabase(payload);
	        debugger; // eslint-disable-line
	      }
	      if (nextProps.validCoachData.size > 0) {
	        var results = nextProps.validCoachData.get('hits');
	
	        var totalHits = results.get('hits').size;
	        if (totalHits > 0) {
	          results = results.get('hits');
	          results = results.toJS();
	          var firstItemFromElastic = results[0]._source; // eslint-disable-line
	          if (this.props.attributes.get('email') === firstItemFromElastic.coach_email) {
	            this.props.history.push(_routeNames.CoachRegister);
	          }
	        } else {
	          this.setState({ renderPopUp: true });
	        }
	      }
	    }
	  }, {
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var modalStyle = {
	        overlay: {
	          backgroundColor: 'rgba(0, 0, 0, 0.75)'
	        },
	        content: {
	          top: '50%',
	          left: '50%',
	          right: 'auto',
	          bottom: 'auto',
	          marginRight: '-50%',
	          transform: 'translate(-50%, -50%)'
	        }
	      };
	      var open = this.state.open;
	
	      var renderLoader = (0, _renderIf2.default)(this.props.validateCoachRequested);
	      var renderPopUp = (0, _renderIf2.default)(this.state.renderPopUp);
	      var renderCoachLogout = (0, _renderIf2.default)(this.state.makeCoachLogOutFromHere);
	      var renderWhileRegistration = (0, _renderIf2.default)(!this.state.makeCoachLogOutFromHere);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderPopUp(_react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: open },
	          renderCoachLogout(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row', _ValidateCoach2.default.container) },
	            _react2.default.createElement(
	              'span',
	              { className: _ValidateCoach2.default.header },
	              'We are glad to see you again!. We are processing all coaches application. We will get back to you soon. Please add an application if you haven\'t added one.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ValidateCoach2.default.buttonContainer },
	              _react2.default.createElement(
	                'button',
	                { onClick: this.props.logoutUser },
	                'OK'
	              ),
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/contact?coach_add_application' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'CONTACT US'
	                )
	              )
	            )
	          )),
	          renderWhileRegistration(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('row', _ValidateCoach2.default.container) },
	            _react2.default.createElement(
	              'span',
	              { className: _ValidateCoach2.default.header },
	              'We couldn\'t find you in our system. Please click below button to contact us. We will get back to you soon.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _ValidateCoach2.default.buttonContainer },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: '/contact?coach_add_application' },
	                _react2.default.createElement(
	                  'button',
	                  null,
	                  'CONTACT US'
	                )
	              )
	            )
	          ))
	        ))
	      );
	    }
	  }]);
	
	  return ValidateCoach;
	}(_react.Component);
	
	ValidateCoach.propTypes = {
	  getCoachFromDatabase: _propTypes2.default.func,
	  attributes: _propTypes2.default.shape,
	  validateCoachRequested: _propTypes2.default.bool,
	  validCoachData: _propTypes2.default.shape(),
	  history: _propTypes2.default.shape(),
	  logoutUser: _propTypes2.default.func.isRequired
	  // coachVerified: PropTypes.bool.isRequired,
	};
	ValidateCoach.defaultProps = {
	  getCoachFromDatabase: function getCoachFromDatabase() {},
	  attributes: {},
	  history: {
	    push: function push() {}
	  },
	  validateCoachRequested: false,
	  validCoachData: {}
	};
	exports.default = ValidateCoach;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ValidateCoach = __webpack_require__(1252);
	
	var _ValidateCoach2 = _interopRequireDefault(_ValidateCoach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ValidateCoach2.default;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BackgroundVideo = __webpack_require__(1550);
	
	var _BackgroundVideo2 = _interopRequireDefault(_BackgroundVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	var BackgroundVideo = function BackgroundVideo() {
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('row', _BackgroundVideo2.default.videoContainer) },
	    _react2.default.createElement(
	      'video',
	      { className: (0, _classnames2.default)('col s12', _BackgroundVideo2.default.videoWidth), autoPlay: true, loop: true, muted: true },
	      _react2.default.createElement('source', { src: 'https://media.dev.myrecruitboard.com/Images/5571395.mov', type: 'video/mp4' })
	    ),
	    _react2.default.createElement('div', { className: _BackgroundVideo2.default.videoOverlay })
	  );
	}; // to use global class name eg. classes from grid.css in public folder
	exports.default = BackgroundVideo;

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BackgroundVideo = __webpack_require__(1254);
	
	var _BackgroundVideo2 = _interopRequireDefault(_BackgroundVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BackgroundVideo2.default;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsiveModal = __webpack_require__(363);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _queryString = __webpack_require__(116);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _VideoPlayer = __webpack_require__(1551);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	
	/* import styles from './VideoPlayer.scss';// to import local scss fle  */
	
	
	var modalStyle = {
	  width: '100%',
	  padding: '0',
	  height: '100%',
	  maxWidth: 'inherit'
	};
	
	var VideoPlayer = function (_Component) {
	  _inherits(VideoPlayer, _Component);
	
	  function VideoPlayer(props) {
	    _classCallCheck(this, VideoPlayer);
	
	    var _this = _possibleConstructorReturn(this, (VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call(this, props));
	
	    _this.state = {
	      open: true
	    };
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.getUrl = _this.getUrl.bind(_this);
	    return _this;
	  }
	
	  _createClass(VideoPlayer, [{
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      if (this.props.showVideo) {
	        this.props.removeVideoScreen();
	      }
	    }
	
	    /* eslint-disable */
	
	  }, {
	    key: 'getUrl',
	    value: function getUrl(url) {
	      var query = _queryString2.default.parse(url);
	      var id = '';
	      if (query && Object.prototype.hasOwnProperty.call(query, 'https://www.youtube.com/watch?v')) {
	        id = query['https://www.youtube.com/watch?v'];
	      }
	      return 'https://www.youtube.com/embed/' + id;
	    }
	    /* eslint-enable */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          showVideo = _props.showVideo,
	          currentVideoUrl = _props.currentVideoUrl;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactResponsiveModal2.default,
	          {
	            closeIconClassName: _VideoPlayer2.default.closeButton,
	            modalStyle: modalStyle,
	            open: showVideo,
	            onClose: this.onCloseModal
	          },
	          _react2.default.createElement('iframe', {
	            src: this.getUrl(currentVideoUrl),
	            width: '100%', height: '100%', frameBorder: '0', allowFullScreen: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return VideoPlayer;
	}(_react.Component);
	
	VideoPlayer.propTypes = {
	  removeVideoScreen: _propTypes2.default.func.isRequired,
	  currentVideoUrl: _propTypes2.default.string,
	  showVideo: _propTypes2.default.bool
	};
	VideoPlayer.defaultProps = {
	  currentVideoUrl: '',
	  showVideo: true
	};
	exports.default = VideoPlayer;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StaticPageHeader = __webpack_require__(286);
	
	var _StaticPageHeader2 = _interopRequireDefault(_StaticPageHeader);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _RecruitingTips = __webpack_require__(1192);
	
	var _RecruitingTips2 = _interopRequireDefault(_RecruitingTips);
	
	var _Myths = __webpack_require__(1165);
	
	var _Myths2 = _interopRequireDefault(_Myths);
	
	var _AboutTabs = __webpack_require__(1079);
	
	var _AboutTabs2 = _interopRequireDefault(_AboutTabs);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _analytics = __webpack_require__(37);
	
	var _reactHelmet = __webpack_require__(180);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _About = __webpack_require__(1552);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About(props) {
	    _classCallCheck(this, About);
	
	    var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));
	
	    _this.state = {
	      showFixedNavbar: false,
	      tab: 0
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    _this.tabListener = _this.tabListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(About, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      if (scrollTop > 80) {
	        this.setState({ showFixedNavbar: true });
	      } else {
	        this.setState({ showFixedNavbar: false });
	      }
	    }
	  }, {
	    key: 'tabListener',
	    value: function tabListener(tab) {
	      this.setState({ tab: tab });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var tab = this.state.tab;
	
	      var renderAboutUs = (0, _renderIf2.default)(tab === 0);
	      var renderMyths = (0, _renderIf2.default)(tab === 2);
	      var renderTips = (0, _renderIf2.default)(tab === 1);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _About2.default.container) },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement('meta', { charSet: 'utf-8' }),
	          _react2.default.createElement(
	            'title',
	            null,
	            'MyRecruitBoard \u2013 Get Recruited. College Football Recruiting Never Stops!'
	          ),
	          _react2.default.createElement('meta', { name: 'description', content: 'College Football Recruiting Never Stops!' }),
	          _react2.default.createElement('meta', {
	            name: 'Keywords', content: 'RECRUITING TIPS, RECRUITING Myths, SOPHOMORE RECRUITING TIPS, JUNIOR RECRUITING TIPS, SENIOR RECRUITING TIPS, FRESHMAN & MIDDLE SCHOOL RECRUITING TIPS,JUCO & COLLEGE TRANSFER RECRUITING TIPS '
	          })
	        ),
	        this.state.showFixedNavbar === true ? _react2.default.createElement(_NavOnScroll2.default, this.props) : '',
	        _react2.default.createElement(_StaticPageHeader2.default, Object.assign({ page: 'about_us' }, this.props)),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _About2.default.tabContainer) },
	          _react2.default.createElement(_AboutTabs2.default, Object.assign({}, this.state, {
	            tabListener: this.tabListener
	          }))
	        ),
	        renderAboutUs(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.bigAboutUs },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.content) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about1.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'OVERVIEW'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'The most personalized college recruiting service yet.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'Our goal is to make college football recruiting more accessible through our Football Data Science Technology. We\'ve made football exposure simpler and faster. Don\'t waste your valuable time and money with "free" recruiting phone consultations by other high cost recruiting services. Join MyRecruitBoard today and you can start contacting college coaches immediately. MyRecruitBoard represents a new season in the relationship college coaches and football players have with finding each other. We provide the best exposure for college football recruiting.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.overviewContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'FEATURES'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'Football recruiting down to a science.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'SOCIAL NETWORKING INTEGRATIONS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'We have the largest college football recruiting service on Twitter. No other recruiting service covers every level of college football more than we do. College coaches use our Twitter more than any other social network to find new recruits. Every member who upgrades their account receives unlimited tweets and retweets during their entire paid recruiting process. College Coaches watch our timeline and recruit the players who we tweet about. MyRecruitBoard\'s social networking exposes a detailed breakdown of your film, activities, camps, awards, and accomplishment making it easier for college coach can find you'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'DYNAMIC TOOLS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'We have every football college in America on our website. Our Football Data Science technology only matches you with colleges that you directly match. Our technologies combine college coach\'s biometric and academic requirements of recruits so you increase your chances of being recruited. This ensures college coaches are happy with the recruits contacting them from our service. You must be a perfect fit in order to contact college coaches. Join today and find out how many colleges across America you match.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m5', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about2.jpg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.technologyContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about3.jpg' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'TECHNOLOGY'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'How MyRecruitBoard Works.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.darkHeaderSmall },
	                    'Step 1:'
	                  ),
	                  'Every college football team in America has given us their ideal football recruit\'s biometrics and academics.  We know things such as a minimum GPA you\'ll need to attend their college, and height, weight, and 40-Yard Dash time minimums for every position on their roster.',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.darkHeaderSmall },
	                    'Step 2:'
	                  ),
	                  'Based on the academic and biometric info you provide our Football Data Science patent pending algorithm will match you to every college in America which you are a direct fit.  Next you\'ll need to contact each of these coaches after you upgrade. College coaches will contact you on our site to find out more about you.',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.darkHeaderSmall },
	                    'Step 3:'
	                  ),
	                  'Get Recruited!'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.overviewContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m7', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'DESIGN'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'We make it simple to get national exposure.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'Coaches can view your profile on our website whenever they want. Only upgraded members will be able to contact coaches on our website. Additionally, only paying members will be recommended to every college in America when coaches search for prospects.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m5', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about4.jpg' })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _About2.default.smallAboutUs },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.content) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'OVERVIEW'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'The most personalized college recruiting service yet.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'Our goal is to make college football recruiting more accessible through our Football Data Science Technology. We\'ve made football exposure simpler and faster. Don\'t waste your valuable time and money with "free" recruiting phone consultations by other high cost recruiting services. Join MyRecruitBoard today and you can start contacting college coaches immediately. MyRecruitBoard represents a new season in the relationship college coaches and football players have with finding each other. We provide the best exposure for college football recruiting.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about1.jpg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.content) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'FEATURES'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'Football recruiting down to a science.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'SOCIAL NETWORKING INTEGRATIONS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'We have the largest college football recruiting service on Twitter. No other recruiting service covers every level of college football more than we do. College coaches use our Twitter more than any other social network to find new recruits. Every member who upgrades their account receives unlimited tweets and retweets during their entire paid recruiting process. College Coaches watch our timeline and recruit the players who we tweet about. MyRecruitBoard\'s social networking exposes a detailed breakdown of your film, activities, camps, awards, and accomplishment making it easier for college coach can find you'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'DYNAMIC TOOLS'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'We have every football college in America on our website. Our Football Data Science technology only matches you with colleges that you directly match. Our technologies combine college coach\'s biometric and academic requirements of recruits so you increase your chances of being recruited. This ensures college coaches are happy with the recruits contacting them from our service. You must be a perfect fit in order to contact college coaches. Join today and find out how many colleges across America you match.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about2.jpg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.technologyContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'TECHNOLOGY'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'How MyRecruitBoard Works.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.darkHeaderSmall },
	                    'Step 1:'
	                  ),
	                  'Every college football team in America has given us their ideal football recruit\'s biometrics and academics.  We know things such as a minimum GPA you\'ll need to attend their college, and height, weight, and 40-Yard Dash time minimums for every position on their roster.',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.darkHeaderSmall },
	                    'Step 2:'
	                  ),
	                  'Based on the academic and biometric info you provide our Football Data Science patent pending algorithm will match you to every college in America which you are a direct fit.  Next you\'ll need to contact each of these coaches after you upgrade. College coaches will contact you on our site to find out more about you.',
	                  _react2.default.createElement('br', null),
	                  ' ',
	                  _react2.default.createElement('br', null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: _About2.default.darkHeaderSmall },
	                    'Step 3:'
	                  ),
	                  'Get Recruited!'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about3.jpg' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _About2.default.technologyContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.textContainer) },
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.darkHeader },
	                  'DESIGN'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.bigHeader },
	                  'We make it simple to get national exposure.'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _About2.default.desc },
	                  'Coaches can view your profile on our website whenever they want. Only upgraded members will be able to contact coaches on our website. Additionally, only paying members will be recommended to every college in America when coaches search for prospects.'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m6', _About2.default.imageContainer) },
	                _react2.default.createElement('img', { alt: 'about feature', src: 'https://media.dev.myrecruitboard.com/Images/about4.jpg' })
	              )
	            )
	          )
	        )),
	        renderMyths(_react2.default.createElement(_Myths2.default, null)),
	        renderTips(_react2.default.createElement(_RecruitingTips2.default, null)),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _About2.default.removePadding) },
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	exports.default = (0, _SessionReplica2.default)(About);

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _About = __webpack_require__(1257);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _About2.default;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _HeaderWithTabs = __webpack_require__(1152);
	
	var _HeaderWithTabs2 = _interopRequireDefault(_HeaderWithTabs);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _routeNames = __webpack_require__(55);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _StudentView = __webpack_require__(1286);
	
	var _StudentView2 = _interopRequireDefault(_StudentView);
	
	var _CollegeView = __webpack_require__(1273);
	
	var _CollegeView2 = _interopRequireDefault(_CollegeView);
	
	var _CoachView = __webpack_require__(1265);
	
	var _CoachView2 = _interopRequireDefault(_CoachView);
	
	var _actions = __webpack_require__(1260);
	
	var _redux = __webpack_require__(470);
	
	var _Admin = __webpack_require__(1553);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	
	
	var Admin = function (_Component) {
	  _inherits(Admin, _Component);
	
	  function Admin(props) {
	    _classCallCheck(this, Admin);
	
	    var _this = _possibleConstructorReturn(this, (Admin.__proto__ || Object.getPrototypeOf(Admin)).call(this, props));
	
	    _this.setTabToInitial = function () {
	      _this.setState({ innerTab: 0 });
	    };
	
	    _this.tabListener = function (tab) {
	      _this.setState({ tab: tab });
	      _this.innerTabListener(0);
	    };
	
	    _this.innerTabListener = function (innerTab) {
	      _this.setState({ innerTab: innerTab });
	    };
	
	    _this.catchUserInfo = function (name, info) {
	      if (name === 'studentInfo') _this.props.resetValues('RESET_STUDENT_VALUES');
	      _this.setState(_defineProperty({}, name, info));
	    };
	
	    _this.redirectUser = function () {
	      _this.props.history.push(_this.state.tab === 0 ? _routeNames.ViewAthlete : _routeNames.CoachDashboard);
	    };
	
	    _this.deleteCoachApplication = function (item) {
	      _this.props.deleteCoachApplication(item.id);
	    };
	
	    _this.state = {
	      value: '',
	      tab: 0,
	      coachInfo: {},
	      innerTab: 0,
	      studentInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(Admin, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          attributes = _props.attributes,
	          history = _props.history;
	
	      if (attributes.size > 0) {
	        if (attributes.get('zoneinfo') !== 'ADMIN') {
	          history.goBack();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var attributes = nextProps.attributes,
	          history = nextProps.history;
	
	      if (attributes.size > 0) {
	        if (attributes.get('zoneinfo') !== 'ADMIN') {
	          history.goBack();
	        }
	      }
	      if (nextProps.coachDeleted === true) {
	        this.setState({ coachInfo: {} });
	      }
	    }
	
	    // redirectAthelete = () => {
	    //   this.props.history.push(ViewAthlete);
	    // };
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          innerTab = _state.innerTab,
	          studentInfo = _state.studentInfo,
	          coachInfo = _state.coachInfo,
	          tab = _state.tab,
	          coachData = _state.coachData;
	
	      var renderLoader = (0, _renderIf2.default)(this.props.isLoading);
	      var renderStudentView = (0, _renderIf2.default)(tab === 0);
	      var renderCoachView = (0, _renderIf2.default)(tab === 1);
	      var renderCollegeView = (0, _renderIf2.default)(tab === 2);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Admin2.default.container) },
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement(_HeaderWithTabs2.default, Object.assign({}, this.props, { tab: tab, tabListener: this.tabListener })),
	        renderStudentView(_react2.default.createElement(_StudentView2.default, Object.assign({
	          tab: innerTab,
	          tabListener: this.innerTabListener,
	          userInfo: studentInfo,
	          catchUserInfo: this.catchUserInfo,
	          setTabToInitial: this.setTabToInitial,
	          redirectUser: this.redirectUser
	          // redirectAthelete={this.redirectAthelete}
	        }, this.props))),
	        renderCoachView(_react2.default.createElement(_CoachView2.default, Object.assign({
	          tab: innerTab,
	          tabListener: this.innerTabListener,
	          userInfo: coachInfo,
	          catchUserInfo: this.catchUserInfo,
	          redirectUser: this.redirectUser
	        }, this.props))),
	        renderCollegeView(_react2.default.createElement(_CollegeView2.default, Object.assign({
	          tab: innerTab,
	          tabListener: this.innerTabListener,
	          coachData: coachData
	        }, this.props)))
	      );
	    }
	  }]);
	
	  return Admin;
	}(_react.Component);
	
	Admin.propTypes = {
	  history: _propTypes2.default.shape.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  attributes: _propTypes2.default.shape.isRequired,
	  resetValues: _propTypes2.default.func.isRequired,
	  coachDeleted: _propTypes2.default.bool.isRequired, // eslint-disable-line
	  deleteCoachApplication: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { SearchUser: _actions.SearchUser,
	  // SearchUserByFullName,
	  // SearchStudentByFullName,
	  SearchAtheleteByName: _actions.SearchAtheleteByName,
	  esError: _actions.esError,
	  searchEsUserRequested: _actions.searchEsUserRequested,
	  searchEsUserData: _actions.searchEsUserData,
	  getCoachApplications: _actions.getCoachApplications,
	  upgradeStudent: _actions.upgradeStudent,
	  overrideStudent: _actions.overrideStudent,
	  evaluateStudent: _actions.evaluateStudent,
	  deleteCoach: _actions.deleteCoach,
	  addCoach: _actions.addCoach,
	  modifyCollege: _actions.modifyCollege,
	  resetValues: _actions.resetValues,
	  getCoachesFromColleges: _actions.getCoachesFromColleges,
	  addCollegeToDB: _actions.addCollegeToDB,
	  getStudentForStudentExplorer: _actions.getStudentForStudentExplorer,
	  deleteCoachApplication: _actions.deleteCoachApplication,
	  resetStudentDashboard: _actions.resetStudentDashboard,
	  upgradeCoachApplication: _actions.upgradeCoachApplication })((0, _Session2.default)(Admin));

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetStudentDashboard = undefined;
	exports.SearchUser = SearchUser;
	exports.getCoachApplications = getCoachApplications;
	exports.upgradeCoachApplication = upgradeCoachApplication;
	exports.upgradeStudent = upgradeStudent;
	exports.overrideStudent = overrideStudent;
	exports.evaluateStudent = evaluateStudent;
	exports.deleteCoach = deleteCoach;
	exports.deleteCoachApplication = deleteCoachApplication;
	exports.addCoach = addCoach;
	exports.modifyCollege = modifyCollege;
	exports.getCoachesFromColleges = getCoachesFromColleges;
	exports.addCollegeToDB = addCollegeToDB;
	exports.resetValues = resetValues;
	exports.getStudentForStudentExplorer = getStudentForStudentExplorer;
	exports.SearchAtheleteByName = SearchAtheleteByName;
	
	var _immutable = __webpack_require__(11);
	
	var _admin = __webpack_require__(1068);
	
	var service = _interopRequireWildcard(_admin);
	
	var _session = __webpack_require__(73);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(199);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// use of immutablejs for various js operations to simplify our work
	function SearchUser(payload, role) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.SEARCH_USER_REQUESTED
	    });
	    service.searchUser(payload, role).then(function (result) {
	      var res = result.hits;
	
	      if (res.hits.length > 0) {
	        res = res.hits[0]._source; // eslint-disable-line
	        var currentId = '';
	        if (role === 'STUDENT') {
	          currentId = res.id;
	        } else {
	          currentId = res.coach_id;
	        }
	        var temp = [{ Name: 'profile', Value: currentId }];
	        (0, _session.updateUserAttributes)(temp, function (err) {
	          if (!err) {
	            (0, _session.isSessionValid)(function (sessionErr, sessionResult) {
	              if (sessionErr) {
	                dispatch({
	                  type: _SessionActionTypes.SESSION_LOGOUT
	                });
	              } else {
	                var token = sessionResult.session.idToken.jwtToken;
	                dispatch({
	                  type: _SessionActionTypes.SESSION_VALID,
	                  session: (0, _immutable.fromJS)(sessionResult.session),
	                  user: (0, _immutable.fromJS)(sessionResult.user),
	                  attributes: (0, _immutable.fromJS)(sessionResult.attributes),
	                  token: token
	                });
	                if (result) {
	                  dispatch({
	                    type: _actionTypes.SEARCH_USER_SUCCESSFUL,
	                    data: (0, _immutable.fromJS)(result)
	                  });
	                }
	              }
	            });
	          }
	        });
	      } else {
	        dispatch({
	          type: _actionTypes.SEARCH_USER_FAILED,
	          error: 'User not found'
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.SEARCH_USER_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getCoachApplications(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.GET_COACH_APPLICATIONS_REQUESTED
	    });
	    service.getCoachApplications(id).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.GET_COACH_APPLICATIONS_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.GET_COACH_APPLICATIONS_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function upgradeCoachApplication(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.COACH_APPLICATION_UPGRADE_REQUESTED
	    });
	    service.updateCoachApplication(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.COACH_APPLICATION_UPGRADE_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.COACH_APPLICATION_UPGRADE_FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function upgradeStudent(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.upgradeStudent(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.UPGRADE_STUDENT_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function overrideStudent(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.overrideStudent(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.OVERRIDE_STUDENT_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function evaluateStudent(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.evaluateStudent(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.STUDENT_EVALUATION_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	var resetStudentDashboard = exports.resetStudentDashboard = function resetStudentDashboard(studentId) {
	  return function (dispatch) {
	    // console.log(studentId);
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.resetStudentDashboard(studentId).then(function (result) {
	      dispatch({
	        type: _actionTypes.RESET_STUDENT_DASHBOARD_SUCCESSFUL,
	        result: result
	      });
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	};
	
	function deleteCoach(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.deleteCoach(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.DELETE_COACH_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function deleteCoachApplication(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.deleteCoachApplication(id).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.DELETE_COACH_APPLICATION_SUCCESSFUL,
	          id: id
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function addCoach(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.addCoach(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.ADD_COACH,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function modifyCollege(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.modifyCollege(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.MODIFY_COLLEGE,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function getCoachesFromColleges(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.getCoachesFromColleges(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.GET_COACHES_FROM_DB,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function addCollegeToDB(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.addCollegeToDB(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.ADD_COLLEGE_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	function resetValues(action) {
	  return function (dispatch) {
	    dispatch({
	      type: action
	    });
	  };
	}
	
	function getStudentForStudentExplorer(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.START_LOADER
	    });
	    service.getStudentForStudentExplorer(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.GET_STUDENTS_FOR_STUDENT_EXPLORER,
	          data: (0, _immutable.fromJS)(result.hits.hits)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.STOP_LOADER,
	        error: err
	      });
	    });
	  };
	}
	
	// export function SearchUserByFullName(payload) {
	//   return (dispatch) => {
	//     dispatch({
	//       type: START_ES_LOADER,
	//     });
	//     service.getStudentForStudentExplorer(payload)
	//       .then((result) => {
	//         if (result) {
	//           dispatch({
	//             type: GET_ES_STUDENTS_FOR_STUDENT_EXPLORER,
	//             data: fromJS(result.hits.hits),
	//           });
	//         }
	//       })
	//       .catch((err) => {
	//         dispatch({
	//           type: STOP_ES_LOADER,
	//           error: err,
	//         });
	//       });
	//   };
	// }
	
	// export function SearchAtheleteByName(payload) {
	//   // eslint-disable-next-line no-console
	//   console.log('Action');
	//   return (dispatch) => {
	//     dispatch({
	//       type: SEARCH_ES_USER_REQUESTED,
	//     });
	//     service.getStudentForStudentExplorer(payload)
	//             .then((result) => {
	//               let res = result.hits;
	
	//               if (res.hits.length > 0) {
	//                 res = res.hits[0]._source; // eslint-disable-line
	//                 let currentId = '';
	//                 currentId = res.id;
	//                 const temp = [{ Name: 'profile', Value: currentId }];
	//                 updateUserAttributes(temp, (err) => {
	//                   if (!err) {
	//                     isSessionValid((sessionErr, sessionResult) => {
	//                       if (sessionErr) {
	//                         dispatch({
	//                           type: SESSION_LOGOUT,
	//                         });
	//                       } else {
	//                         const token = sessionResult.session.idToken.jwtToken;
	//                         dispatch({
	//                           type: SESSION_VALID,
	//                           session: fromJS(sessionResult.session),
	//                           user: fromJS(sessionResult.user),
	//                           attributes: fromJS(sessionResult.attributes),
	//                           token,
	//                         });
	//                         if (result) {
	//                           dispatch({
	//                             type: SEARCH_ES_USER_SUCCESSFUL,
	//                             data: fromJS(result.hits.hits),
	//                           });
	//                         }
	//                       }
	//                     });
	//                   }
	//                 });
	//               } else {
	//                 dispatch({
	//                   type: SEARCH_ES_USER_FAILED,
	//                   error: 'User not found',
	//                 });
	//               }
	//             })
	//             .catch((err) => {
	//               dispatch({
	//                 type: SEARCH_ES_USER_FAILED,
	//                 error: err,
	//               });
	//             });
	//   };
	// }
	
	function SearchAtheleteByName(payload) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.SEARCH_ES_USER_REQUESTED
	    });
	    service.getStudentForStudentExplorer(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.SEARCH_ES_USER_SUCCESSFUL,
	          data: (0, _immutable.fromJS)(result.hits.hits)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.SEARCH_ES_USER_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Createtabs = __webpack_require__(194);
	
	var _Createtabs2 = _interopRequireDefault(_Createtabs);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _SearchUser = __webpack_require__(284);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	var _CoachApplication = __webpack_require__(1099);
	
	var _CoachApplication2 = _interopRequireDefault(_CoachApplication);
	
	var _AddCoach = __webpack_require__(1263);
	
	var _AddCoach2 = _interopRequireDefault(_AddCoach);
	
	var _style = __webpack_require__(1556);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _View = __webpack_require__(1264);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabs = ['Application', 'Add Coach', 'Delete Coach', 'Login As coach'];
	
	var CoachView = function CoachView(props) {
	  var userInfo = props.userInfo,
	      tab = props.tab,
	      addCoach = props.addCoach,
	      coachAdded = props.coachAdded,
	      redirectUser = props.redirectUser,
	      resetValues = props.resetValues;
	
	  var coachApplication = (0, _renderIf2.default)(tab === 0);
	  var renderAddCoach = (0, _renderIf2.default)(tab === 1);
	  var renderLoginButton = (0, _renderIf2.default)(userInfo.name !== undefined);
	  var deleteCoach = (0, _renderIf2.default)(tab === 2);
	  var loginAsCoach = (0, _renderIf2.default)(tab === 3);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12') },
	    _react2.default.createElement(_Createtabs2.default, {
	      tabs: tabs,
	      index: props.tab,
	      activeClass: _style2.default.activeClass,
	      container: _style2.default.container,
	      tabListener: props.tabListener
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _style2.default.tabViews) },
	      coachApplication(_react2.default.createElement(_CoachApplication2.default, props)),
	      renderAddCoach(_react2.default.createElement(_AddCoach2.default, { addCoach: addCoach, coachAdded: coachAdded, resetValues: resetValues })),
	      deleteCoach(_react2.default.createElement(_View2.default, Object.assign({ userInfo: userInfo }, props))),
	      loginAsCoach(_react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SearchUser2.default, Object.assign({}, props, { userType: 'COACH', label: 'SEARCH USER TO LOGIN' })),
	        renderLoginButton(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_CustomButton2.default, { label: 'LOGIN AS ABOVE USER', style: _style2.default.buttonContainer, onClick: redirectUser }),
	          _react2.default.createElement(_CustomButton2.default, { label: 'SELECT ANOTHER COACH', style: _style2.default.buttonContainer, onClick: function onClick() {
	              return props.catchUserInfo('coachInfo', {});
	            } })
	        ))
	      ))
	    )
	  );
	};
	
	CoachView.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired,
	  tab: _propTypes2.default.number.isRequired,
	  userInfo: _propTypes2.default.shape.isRequired,
	  addCoach: _propTypes2.default.func.isRequired,
	  coachAdded: _propTypes2.default.bool.isRequired,
	  redirectUser: _propTypes2.default.func.isRequired,
	  resetValues: _propTypes2.default.func.isRequired,
	  catchUserInfo: _propTypes2.default.func.isRequired
	};
	
	exports.default = CoachView;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _CoachRegistration = __webpack_require__(108);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _styles = __webpack_require__(1554);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to use input from react-toolbox library
	
	// import UserInfo from '../../../Userinfo/index';
	
	
	// to import local scss fle
	
	var DeleteCoach = function (_Component) {
	  _inherits(DeleteCoach, _Component);
	
	  function DeleteCoach(props) {
	    _classCallCheck(this, DeleteCoach);
	
	    var _this = _possibleConstructorReturn(this, (DeleteCoach.__proto__ || Object.getPrototypeOf(DeleteCoach)).call(this, props));
	
	    _this.getDataForCoach = function (value) {
	      var newState = {
	        city: value.city,
	        division: value.division,
	        questionLink: value.questionLink,
	        state: value.state,
	        teamPageUrl: value.teamPageUrl,
	        college: value.value,
	        college_id: value.id
	      };
	      _this.setState(newState);
	    };
	
	    _this.handleChange = function (name, value) {
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.removeValue = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, '')));
	    };
	
	    _this.addAnotherCoach = function () {
	      _this.setState({
	        addAnotherCoach: true,
	        city: '',
	        state: '',
	        fullName: '',
	        email: '',
	        collegeId: '',
	        teamPageUrl: '',
	        questionLink: ''
	      });
	      _this.props.resetValues('RESET_ADD_COACH');
	    };
	
	    _this.handleOnclick = function () {
	      /* validations for field */
	      var enteredValue = _this.state.college;
	      var highSchool = typeof enteredValue === 'string';
	      var updated = {};
	      if (highSchool && _this.state.college !== '') {
	        updated.validHighSchool = true;
	      } else {
	        updated.highSchoolErrorMessage = 'PLease insert a valid school name';
	      }
	      /* validations for field */
	
	      /* validation for state */
	      if (_this.state.state === '') {
	        updated.stateErrorMessage = 'Please select state.';
	      } else {
	        updated.validState = true;
	      }
	      /* validation for state */
	
	      /* validation of city */
	      var selectedCity = _Regularexpression.regExForName.test(_this.state.city);
	      if (selectedCity && _this.state.city !== '') {
	        updated.validCity = true;
	      } else {
	        updated.cityErrorMessage = 'City is not added.';
	      }
	      /* validation of city */
	
	      /* validation of fullname */
	      var fullnameAdded = _Regularexpression.regExForName.test(_this.state.fullName);
	      if (fullnameAdded && _this.state.fullName !== '') {
	        updated.validCity = true;
	      } else {
	        updated.fullNameErrorMessage = 'Add a valid name';
	      }
	      /* validation of fullname */
	
	      /* validation of fullname */
	      var validEmail = false;
	      var emailAdded = _Regularexpression.regExForEmail.test(_this.state.email);
	      if (emailAdded && _this.state.email !== '') {
	        validEmail = true;
	      } else {
	        updated.emailErrorMessage = 'Add a valid email.';
	      }
	      /* validation of fullname */
	
	      /* validation for teamPageUrl */
	      // const enteredTeamPageUrl = regExForUrl.test(this.state.teamPageUrl);
	      if (_this.state.teamPageUrl !== '' && _this.state.teamPageUrl !== undefined) {
	        updated.validTeamPageUrl = true;
	      } else {
	        updated.teamPageUrlErrorMessage = 'Please insert a valid url.';
	      }
	      /* validation for teamPageUrl */
	
	      /* validation for Questionnaire Link */
	      // const enteredQuestionaireLink = regExForUrl.test(this.state.questionLink);
	      if (_this.state.questionLink === '' && _this.state.questionLink !== undefined) {
	        updated.validQuestionaire = true;
	      } else if (_this.state.questionLink === 'no page') {
	        updated.questionaireErrorMessage = 'Please add a valid questionaire url';
	      } else if (_this.state.questionLink !== '' && _this.state.questionLink !== undefined) {
	        updated.validQuestionaire = true;
	      } else {
	        updated.questionaireErrorMessage = 'Please add a valid questionaire url';
	      }
	      /* validation for question lin */
	
	      _this.setState(updated, function () {
	        var payload = {};
	        var s = _this.state;
	        // eslint-disable-next-line
	        var profile_pic = 'no_profile_pic';
	        var college = s.college,
	            fullName = s.fullName,
	            college_id = s.college_id,
	            sport = s.sport,
	            states = s.states,
	            city = s.city,
	            teamPageUrl = s.teamPageUrl,
	            questionLink = s.questionLink,
	            email = s.email,
	            division = s.division,
	            validHighSchool = s.validHighSchool,
	            validQuestionaire = s.validQuestionaire,
	            validTeamPageUrl = s.validTeamPageUrl,
	            validCity = s.validCity,
	            validState = s.validState;
	
	
	        payload = Object.assign(payload, {
	          name: fullName,
	          college: college,
	          coach_email: email,
	          college_id: college_id,
	          sport: sport,
	          state: states,
	          city: city,
	          profile_pic: profile_pic,
	          division: division,
	          question_link: questionLink,
	          team_page_link: teamPageUrl
	        });
	        if (questionLink !== '') {
	          payload['question_link'] = questionLink; // eslint-disable-line
	        }
	        if (validHighSchool && validQuestionaire && validTeamPageUrl && validCity && validState && validEmail) {
	          _this.props.addCoach(payload);
	        }
	      });
	    };
	
	    _this.state = {
	      fullName: '',
	      fullNameErrorMessage: '',
	      college: '',
	      state: '',
	      city: '',
	      sport: 'FOOTBALL',
	      validHighSchool: false,
	      highSchoolErrorMessage: '',
	      validState: false,
	      stateErrorMessage: '',
	      validCity: false,
	      cityErrorMessage: '',
	      validTeamPageUrl: false,
	      teamPageUrlErrorMessage: '',
	      validQuestionaire: false,
	      questionaireErrorMessage: '',
	      email: '',
	      emailErrorMessage: '',
	      addAnotherCoach: false
	    };
	    return _this;
	  }
	
	  _createClass(DeleteCoach, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.coachAdded) {
	        this.setState({ addAnotherCoach: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          cityErrorMessage = _state.cityErrorMessage,
	          city = _state.city,
	          fullName = _state.fullName,
	          fullNameErrorMessage = _state.fullNameErrorMessage,
	          highSchoolErrorMessage = _state.highSchoolErrorMessage,
	          stateErrorMessage = _state.stateErrorMessage,
	          sport = _state.sport,
	          state = _state.state,
	          teamPageUrlErrorMessage = _state.teamPageUrlErrorMessage,
	          teamPageUrl = _state.teamPageUrl,
	          email = _state.email,
	          emailErrorMessage = _state.emailErrorMessage,
	          questionaireErrorMessage = _state.questionaireErrorMessage,
	          questionLink = _state.questionLink;
	      var coachAdded = this.props.coachAdded;
	
	      var renderForm = (0, _renderIf2.default)(!coachAdded);
	      var renderSuccessMessage = (0, _renderIf2.default)(coachAdded);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	        renderForm(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m7', _styles2.default.removePadding) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12') },
	            _react2.default.createElement(_ErrorMessage2.default, { message: 'All fields are mandatory.' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: highSchoolErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'SELECT COLLEGE'
	            ),
	            _react2.default.createElement(_CoachRegistration2.default, { usedFor: 'contact', getDataForCoach: this.getDataForCoach })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _styles2.default.autoComplete) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'SPORT'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.autoCompleteToolbox },
	              _react2.default.createElement(_autocomplete2.default, {
	                value: sport,
	                onChange: function onChange(val) {
	                  return _this2.handleChange('sport', val);
	                },
	                multiple: false
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: fullNameErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FULLNAME'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: fullName,
	              onChange: function onChange(val) {
	                return _this2.handleChange('fullName', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('fullNameErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: fullNameErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: emailErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'EMAIL'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: email,
	              onChange: function onChange(val) {
	                return _this2.handleChange('email', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('emailErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: emailErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _styles2.default.autoCompleteState) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'STATE'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: stateErrorMessage === '' ? _styles2.default.autoCompleteToolbox : _styles2.default.autoCompleteToolboxOnError },
	              _react2.default.createElement(_autocomplete2.default, {
	                onChange: function onChange(val) {
	                  return _this2.handleChange('state', val);
	                },
	                source: _DropdownsValues.states,
	                onFocus: function onFocus() {
	                  return _this2.removeValue('stateErrorMessage');
	                },
	                onQueryChange: function onQueryChange(val) {
	                  return _this2.handleChange('state', val);
	                },
	                value: state,
	                multiple: false
	              })
	            ),
	            _react2.default.createElement(_ErrorMessage2.default, { message: stateErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: cityErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'CITY'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: city,
	              onChange: function onChange(val) {
	                return _this2.handleChange('city', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('cityErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: cityErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: teamPageUrlErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanWithoutTopSpace) : (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanWithoutTopSpaceOnError)
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              'TEAM PAGE URL'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: teamPageUrl,
	              onChange: function onChange(val) {
	                return _this2.handleChange('teamPageUrl', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('teamPageUrlErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: this.state.teamPageUrlErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: questionaireErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanWithoutTopSpace) : (0, _classnames2.default)('col s12 m6', _styles2.default.halfWidthWithSpanWithoutTopSpaceOnError)
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              'QUESTIONAIRE LINK'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: questionLink,
	              onChange: function onChange(val) {
	                return _this2.handleChange('questionLink', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('questionaireErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: questionaireErrorMessage })
	          ),
	          _react2.default.createElement(_CustomButton2.default, { label: 'ADD COACH', onClick: this.handleOnclick, style: _styles2.default.buttonContainer })
	        )),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          { className: _styles2.default.successMessage },
	          'Coach added. ',
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_CustomButton2.default, { label: 'ADD ANOTHER COACH', onClick: this.addAnotherCoach, style: _styles2.default.buttonContainer })
	        ))
	      );
	    }
	  }]);
	
	  return DeleteCoach;
	}(_react.Component);
	
	DeleteCoach.propTypes = {
	  addCoach: _propTypes2.default.func.isRequired,
	  coachAdded: _propTypes2.default.func.isRequired,
	  resetValues: _propTypes2.default.func.isRequired
	};
	exports.default = DeleteCoach;

/***/ },
/* 1263 */
[2527, 1262],
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _SearchUser = __webpack_require__(284);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	var _styles = __webpack_require__(1555);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	// import UserInfo from '../../../Userinfo/index';
	
	
	// to import local scss fle
	
	var DeleteCoach = function (_Component) {
	  _inherits(DeleteCoach, _Component);
	
	  function DeleteCoach(props) {
	    _classCallCheck(this, DeleteCoach);
	
	    var _this = _possibleConstructorReturn(this, (DeleteCoach.__proto__ || Object.getPrototypeOf(DeleteCoach)).call(this, props));
	
	    _this.deleteCoach = function () {
	      var payload = {
	        coach_id: _this.props.userInfo.coach_id
	      };
	      _this.props.deleteCoach(payload);
	      _this.setState({ deleteAnotherCoach: false });
	    };
	
	    _this.deleteAnotherCoach = function () {
	      _this.props.resetValues('RESET_DELETE_COACH');
	      _this.props.catchUserInfo('coachInfo', {});
	    };
	
	    _this.state = {
	      deleteAnotherCoach: false
	    };
	    return _this;
	  }
	
	  _createClass(DeleteCoach, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userInfo = _props.userInfo,
	          coachDeleted = _props.coachDeleted;
	
	      var renderUserNotSelected = (0, _renderIf2.default)(!coachDeleted);
	      var renderUserSelected = (0, _renderIf2.default)(userInfo.name !== undefined && !coachDeleted);
	      var renderSuccessMessage = (0, _renderIf2.default)(coachDeleted);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	        renderUserNotSelected(_react2.default.createElement(_SearchUser2.default, Object.assign({}, this.props, { userType: 'COACH', label: 'SEARCH USER TO DELETE' }))),
	        renderUserSelected(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_CustomButton2.default, { label: 'DELETE ABOVE COACH', style: _styles2.default.buttonContainer, onClick: this.deleteCoach }),
	          _react2.default.createElement(_CustomButton2.default, { label: 'SELECT ANOTHER COACH', style: _styles2.default.buttonContainer, onClick: this.deleteAnotherCoach })
	        )),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          { className: _styles2.default.successMessage },
	          'Coach with email id ',
	          userInfo.email,
	          ' deleted.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_CustomButton2.default, { label: 'DELETE ANOTHER COACH', style: _styles2.default.buttonContainer, onClick: this.deleteAnotherCoach })
	        ))
	      );
	    }
	  }]);
	
	  return DeleteCoach;
	}(_react.Component);
	
	DeleteCoach.propTypes = {
	  userInfo: _propTypes2.default.shape.isRequired,
	  deleteCoach: _propTypes2.default.shape.isRequired,
	  coachDeleted: _propTypes2.default.bool.isRequired,
	  resetValues: _propTypes2.default.func.isRequired,
	  catchUserInfo: _propTypes2.default.func.isRequired
	};
	exports.default = DeleteCoach;

/***/ },
/* 1265 */
[2527, 1261],
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _Createtabs = __webpack_require__(194);
	
	var _Createtabs2 = _interopRequireDefault(_Createtabs);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ModifyCollege = __webpack_require__(1272);
	
	var _ModifyCollege2 = _interopRequireDefault(_ModifyCollege);
	
	var _DeleteCoach = __webpack_require__(1270);
	
	var _DeleteCoach2 = _interopRequireDefault(_DeleteCoach);
	
	var _AddCollege = __webpack_require__(1268);
	
	var _AddCollege2 = _interopRequireDefault(_AddCollege);
	
	var _style = __webpack_require__(1560);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabs = ['Add College', 'Modify College', 'Delete Coach By College'];
	
	var CollegeView = function CollegeView(props) {
	  var tab = props.tab;
	
	  var renderAddCollege = (0, _renderIf2.default)(tab === 0);
	  var renderModifyCollege = (0, _renderIf2.default)(tab === 1);
	  var renderDeleteCoach = (0, _renderIf2.default)(tab === 2);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12') },
	    _react2.default.createElement(_Createtabs2.default, {
	      tabs: tabs,
	      index: props.tab,
	      activeClass: _style2.default.activeClass,
	      container: _style2.default.container,
	      tabListener: props.tabListener
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _style2.default.tabViews) },
	      renderAddCollege(_react2.default.createElement(_AddCollege2.default, props)),
	      renderModifyCollege(_react2.default.createElement(_ModifyCollege2.default, props)),
	      renderDeleteCoach(_react2.default.createElement(_DeleteCoach2.default, props))
	    )
	  );
	};
	
	CollegeView.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired,
	  tab: _propTypes2.default.number.isRequired
	};
	
	exports.default = CollegeView;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _autocomplete = __webpack_require__(70);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _radio = __webpack_require__(104);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _validations = __webpack_require__(443);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _AddCollege = __webpack_require__(1557);
	
	var _AddCollege2 = _interopRequireDefault(_AddCollege);
	
	var _theme = __webpack_require__(1593);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to use input from react-toolbox library
	
	
	// to import local scss fle
	
	var AddCollege = function (_Component) {
	  _inherits(AddCollege, _Component);
	
	  function AddCollege(props) {
	    _classCallCheck(this, AddCollege);
	
	    var _this = _possibleConstructorReturn(this, (AddCollege.__proto__ || Object.getPrototypeOf(AddCollege)).call(this, props));
	
	    _this.getDataForCoach = function (value) {
	      var newState = {
	        city: value.city,
	        division: value.division,
	        questionLink: value.questionLink,
	        state: value.state,
	        teamPageUrl: value.teamPageUrl,
	        college: value.value,
	        collegeId: value.id,
	        minAct: value.minAct,
	        minGpa: value.minGpa,
	        hbcu: value.hbcu || 'no'
	      };
	      _this.setState(newState);
	    };
	
	    _this.handleChange = function (name, value) {
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.removeValue = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, undefined)));
	    };
	
	    _this.addAnotherCollege = function () {
	      _this.setState({
	        addAnotherCollege: true,
	        division: '',
	        city: '',
	        state: '',
	        questionLink: '',
	        footballConference: '',
	        footballDivision: '',
	        teamPageUrl: '',
	        college: '',
	        collegeId: '',
	        hbcu: 'no',
	        minGpa: '',
	        minAct: '',
	        twitter: ''
	      });
	    };
	
	    _this.handleDivisionChange = function (hbcu) {
	      _this.setState({ hbcu: hbcu });
	    };
	
	    _this.handleOnclick = function () {
	      var _this$state = _this.state,
	          minGpa = _this$state.minGpa,
	          city = _this$state.city,
	          state = _this$state.state,
	          division = _this$state.division,
	          minAct = _this$state.minAct,
	          college = _this$state.college,
	          footballDivision = _this$state.footballDivision,
	          footballConference = _this$state.footballConference,
	          teamPageUrl = _this$state.teamPageUrl,
	          questionLink = _this$state.questionLink,
	          hbcu = _this$state.hbcu,
	          twitter = _this$state.twitter;
	
	      var payload = {
	        college: college,
	        city: city,
	        state: state,
	        division: division,
	        hbcu: hbcu,
	        football_div: footballDivision,
	        football_conf: footballConference,
	        team_page_link: teamPageUrl,
	        question_link: questionLink,
	        college_twitter: twitter,
	        min_act: parseInt(minAct), // eslint-disable-line
	        min_gpa: parseInt(minGpa) // eslint-disable-line
	      };
	      var checkData = (0, _validations2.default)(payload);
	      if (checkData.collegeIsValid && checkData.gpaIsValid && checkData.actIsValid && checkData.twitterIsValid && checkData.questionLinkIsValid && checkData.teamPageLinkIsValid && checkData.divisionIsValid && checkData.footballConferenceIsValid && checkData.footballDivisionIsValid) {
	        _this.setState({ addAnotherCollege: false });
	        _this.props.addCollegeToDB(payload);
	      } else {
	        _this.setState(checkData);
	      }
	    };
	
	    _this.state = {
	      addAnotherCollege: false,
	      showButton: false,
	      hbcu: 'no',
	      division: 'D1'
	    };
	    return _this;
	  }
	
	  _createClass(AddCollege, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          addAnotherCollege = _state.addAnotherCollege,
	          minGpa = _state.minGpa,
	          minAct = _state.minAct,
	          questionLink = _state.questionLink,
	          teamPageUrl = _state.teamPageUrl,
	          footballConference = _state.footballConference,
	          college = _state.college,
	          city = _state.city,
	          state = _state.state,
	          division = _state.division,
	          hbcu = _state.hbcu,
	          minGpaErrorMessage = _state.minGpaErrorMessage,
	          questionLinkErrorMessage = _state.questionLinkErrorMessage,
	          teamPageErrorMessage = _state.teamPageErrorMessage,
	          minActErrorMessage = _state.minActErrorMessage,
	          collegeErrorMessage = _state.collegeErrorMessage,
	          stateErrorMessage = _state.stateErrorMessage,
	          divisionErrorMessage = _state.divisionErrorMessage,
	          cityErrorMessage = _state.cityErrorMessage,
	          footballConferenceErrorMessage = _state.footballConferenceErrorMessage,
	          footballDivisionErrorMessage = _state.footballDivisionErrorMessage,
	          footballDivision = _state.footballDivision,
	          twitter = _state.twitter,
	          twitterErrorMessage = _state.twitterErrorMessage;
	      var collegeAdded = this.props.collegeAdded;
	
	      var form = true;
	      if (collegeAdded) {
	        form = false;
	      }
	      if (collegeAdded && addAnotherCollege) {
	        form = true;
	      }
	      var renderForm = (0, _renderIf2.default)(form);
	      var renderSuccessMessage = (0, _renderIf2.default)(collegeAdded && !addAnotherCollege);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _AddCollege2.default.removePadding) },
	        renderForm(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m7', _AddCollege2.default.addMargin) },
	          _react2.default.createElement(
	            'div',
	            { className: collegeErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'COLLEGE NAME'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: college,
	              onChange: function onChange(val) {
	                return _this2.handleChange('college', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('collegeErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: collegeErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: divisionErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'DIVISION'
	            ),
	            _react2.default.createElement(_autocomplete2.default, {
	              source: _DropdownsValues.divisions,
	              selectedPosition: 'below',
	              direction: 'down',
	              value: division,
	              theme: _theme.theme,
	              multiple: false,
	              onChange: function onChange(val) {
	                return _this2.handleChange('division', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('divisionErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: divisionErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: cityErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'CITY'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: city,
	              onChange: function onChange(val) {
	                return _this2.handleChange('city', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('cityErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: cityErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: stateErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'STATE'
	            ),
	            _react2.default.createElement(_autocomplete2.default, {
	              source: _DropdownsValues.states,
	              selectedPosition: 'below',
	              direction: 'down',
	              value: state,
	              allowCreate: true,
	              multiple: false,
	              onChange: function onChange(val) {
	                return _this2.handleChange('state', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('stateErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: stateErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: teamPageErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'TEAMPAGE URL'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: teamPageUrl,
	              onChange: function onChange(val) {
	                return _this2.handleChange('teamPageUrl', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('teamPageErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: teamPageErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: questionLinkErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'QUESTIONAIRE URL'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: questionLink,
	              onChange: function onChange(val) {
	                return _this2.handleChange('questionLink', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('questionLinkErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: questionLinkErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: footballConferenceErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FOOTBALL CONFERENCE'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: footballConference,
	              onChange: function onChange(val) {
	                return _this2.handleChange('footballConference', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('footballConferenceErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: footballConferenceErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: footballDivisionErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'FOOTBALL DIVISION'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: footballDivision,
	              onChange: function onChange(val) {
	                return _this2.handleChange('footballDivision', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('footballDivisionErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: footballDivisionErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: minGpaErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'MINIMUM GPA'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: minGpa,
	              onChange: function onChange(val) {
	                return _this2.handleChange('minGpa', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('minGpaErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: minGpaErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: minActErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'MINIMUM ACT'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: minAct,
	              onChange: function onChange(val) {
	                return _this2.handleChange('minAct', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('minActErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: minActErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: twitterErrorMessage === undefined ? (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _AddCollege2.default.halfWidthWithSpanOnError) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'TWITTER'
	            ),
	            _react2.default.createElement(_input2.default, {
	              value: twitter,
	              onChange: function onChange(val) {
	                return _this2.handleChange('twitter', val);
	              },
	              onFocus: function onFocus() {
	                return _this2.removeValue('twitterErrorMessage');
	              }
	            }),
	            _react2.default.createElement(_ErrorMessage2.default, { message: twitterErrorMessage })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _AddCollege2.default.removePadding) },
	            _react2.default.createElement(
	              'span',
	              { className: _AddCollege2.default.hbcuSpan },
	              'HBCU'
	            ),
	            _react2.default.createElement(
	              _radio.RadioGroup,
	              { name: 'hbcu', value: hbcu, onChange: this.handleDivisionChange },
	              _react2.default.createElement(_radio.RadioButton, { label: 'Yes', value: 'yes' }),
	              _react2.default.createElement(_radio.RadioButton, { label: 'No', value: 'no' })
	            )
	          ),
	          _react2.default.createElement(_CustomButton2.default, { label: 'ADD COLLEGE', onClick: this.handleOnclick, style: _AddCollege2.default.buttonContainer })
	        )),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          { className: _AddCollege2.default.successMessage },
	          'College details are updated. ',
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_CustomButton2.default, { label: 'MODIFY ANOTHER COLLEGE', onClick: this.addAnotherCollege, style: _AddCollege2.default.buttonContainer })
	        ))
	      );
	    }
	  }]);
	
	  return AddCollege;
	}(_react.Component);
	
	AddCollege.propTypes = {
	  addCollegeToDB: _propTypes2.default.func.isRequired,
	  collegeAdded: _propTypes2.default.bool.isRequired
	};
	exports.default = AddCollege;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddCollege = __webpack_require__(1267);
	
	var _AddCollege2 = _interopRequireDefault(_AddCollege);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AddCollege2.default;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _CoachRegistration = __webpack_require__(108);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	var _index = __webpack_require__(109);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _styles = __webpack_require__(1558);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Error = __webpack_require__(158);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	// import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
	// import Button from 'components/CustomButton';
	
	
	// to import local scss fle
	
	var DeleteCoach = function (_Component) {
	  _inherits(DeleteCoach, _Component);
	
	  function DeleteCoach(props) {
	    _classCallCheck(this, DeleteCoach);
	
	    var _this = _possibleConstructorReturn(this, (DeleteCoach.__proto__ || Object.getPrototypeOf(DeleteCoach)).call(this, props));
	
	    _this.getDataForCoach = function (value) {
	      _this.props.getCoachesFromColleges(value.id);
	    };
	
	    _this.deleteCoach = function (itemId, coachId) {
	      var payload = {
	        coach_id: coachId
	      };
	      _this.props.deleteCoach(payload);
	      var coaches = _this.state.coachData;
	      if (itemId > -1) {
	        coaches.splice(itemId, 1);
	      }
	      _this.setState({ coachData: coaches });
	    };
	
	    _this.deleteAnotherCoach = function () {
	      _this.props.resetValues('RESET_DELETED_COACHES');
	    };
	
	    _this.state = {
	      coachData: [],
	      showNoCoaches: false
	    };
	    return _this;
	  }
	
	  _createClass(DeleteCoach, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(np) {
	      var updated = {};
	      if (!(0, _immutable.is)(np.coachesFromCollege, this.props.coachesFromCollege)) {
	        var results = np.coachesFromCollege.toJS();
	        var coachdata = [];
	        results.forEach(function (coaches) {
	          var obj = {};
	          obj.name = coaches.name;
	          obj.email = coaches.coach_email;
	          obj.coach_id = coaches.coach_id;
	          coachdata.push(obj);
	        });
	        if (np.coachesFromCollege.size === 0) {
	          updated.showNoCoaches = true;
	        }
	        updated.coachData = coachdata;
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          coachData = _state.coachData,
	          showNoCoaches = _state.showNoCoaches;
	
	      var renderCoachList = (0, _renderIf2.default)(coachData.length);
	      var renderMessage = (0, _renderIf2.default)(coachData.length === 0 && showNoCoaches);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m7', _styles2.default.removePadding) },
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.selectCollege },
	            'SELECT COLLEGE'
	          ),
	          _react2.default.createElement(_CoachRegistration2.default, { usedFor: 'contact', getDataForCoach: this.getDataForCoach })
	        ),
	        renderCoachList(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	          coachData.map(function (item, id) {
	            return _react2.default.createElement(_index2.default, {
	              userInfo: item,
	              usedFor: 'DELETE COACH',
	              deleteCoach: _this2.deleteCoach,
	              id: id
	            });
	          })
	        )),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	          renderMessage(_react2.default.createElement(_Error2.default, { message: 'No coaches found in this college.' }))
	        )
	      );
	    }
	  }]);
	
	  return DeleteCoach;
	}(_react.Component);
	
	DeleteCoach.propTypes = {
	  resetValues: _propTypes2.default.func.isRequired,
	  getCoachesFromColleges: _propTypes2.default.func.isRequired,
	  coachesFromCollege: _propTypes2.default.shape.isRequired, // eslint-disable-line
	  deleteCoach: _propTypes2.default.func.isRequired
	};
	exports.default = DeleteCoach;

/***/ },
/* 1270 */
[2527, 1269],
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _input = __webpack_require__(33);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _radio = __webpack_require__(104);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _CoachRegistration = __webpack_require__(108);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Modify = __webpack_require__(1559);
	
	var _Modify2 = _interopRequireDefault(_Modify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to use input from react-toolbox library
	
	
	// to import local scss fle
	
	var ModifyCollege = function (_Component) {
	  _inherits(ModifyCollege, _Component);
	
	  function ModifyCollege(props) {
	    _classCallCheck(this, ModifyCollege);
	
	    var _this = _possibleConstructorReturn(this, (ModifyCollege.__proto__ || Object.getPrototypeOf(ModifyCollege)).call(this, props));
	
	    _this.getDataForCoach = function (value) {
	      var newState = {
	        city: value.city,
	        division: value.division,
	        questionLink: value.questionLink,
	        state: value.state,
	        teamPageUrl: value.teamPageUrl,
	        college: value.value,
	        collegeId: value.id,
	        minAct: value.minAct,
	        minGpa: value.minGpa,
	        hbcu: value.hbcu || 'no',
	        twitter: value.collegetwitter
	      };
	      _this.setState(newState);
	    };
	
	    _this.handleChange = function (name, value) {
	      var _this$setState;
	
	      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, 'showButton', true), _this$setState));
	    };
	
	    _this.removeValue = function (name) {
	      _this.setState(Object.assign({}, _this.state, _defineProperty({}, name, '')));
	    };
	
	    _this.modifyAnotherCollege = function () {
	      _this.setState({
	        modifyAnotherCollege: true,
	        division: '',
	        city: '',
	        state: '',
	        questionLink: '',
	        teamPageUrl: '',
	        college: undefined,
	        collegeId: '',
	        hbcu: 'no',
	        minGpa: '',
	        minAct: '',
	        twitter: ''
	      });
	    };
	
	    _this.handleDivisionChange = function (hbcu) {
	      _this.setState({ hbcu: hbcu, showButton: true });
	    };
	
	    _this.handleOnclick = function () {
	      var updated = {};
	      var _this$state = _this.state,
	          minGpa = _this$state.minGpa,
	          minAct = _this$state.minAct,
	          hbcu = _this$state.hbcu,
	          teamPageUrl = _this$state.teamPageUrl,
	          questionLink = _this$state.questionLink,
	          collegeId = _this$state.collegeId,
	          twitter = _this$state.twitter,
	          collegeNewId = _this$state.collegeNewId;
	      // valudation for gpa
	
	      var validGpa = false;
	      if (minGpa !== '' && minGpa <= 4) {
	        validGpa = true;
	      } else {
	        updated.minGpaErrorMessage = 'Please add a valid gpa.';
	      }
	      // validation for act
	      var validAct = false;
	      if (minAct !== '' && minAct <= 36) {
	        validAct = true;
	      } else {
	        updated.minActErrorMessage = 'Please add a valid act.';
	      }
	      // validation for twitter
	      var validTwitter = true;
	      if (twitter && twitter.trim()[0] !== '@') {
	        validTwitter = false;
	        updated.twitterErrorMessage = 'Please enter valid twitter account';
	      }
	
	      // if (twitter !== '') updated.twitterErrorMessage = 'Please enter valid twitter account';
	
	      if (validAct && validGpa && validTwitter) {
	        var payload = {
	          college_id: collegeId,
	          min_act: parseInt(minAct), // eslint-disable-line
	          min_gpa: parseFloat(minGpa, 10), // eslint-disable-line
	          hbcu: hbcu,
	          football_questionaire_page: questionLink,
	          football_team_page: teamPageUrl,
	          twitter: twitter
	        };
	        _this.props.modifyCollege(payload);
	        if (collegeId === collegeNewId) {
	          updated.modifyAnotherCollege = false;
	        }
	      }
	      updated.collegeNewId = collegeId;
	      _this.setState(updated);
	    };
	
	    _this.state = {
	      minGpaErrorMessage: '',
	      questionaireLinkErrorMessage: '',
	      teamPageErrorMessage: '',
	      minActErrorMessage: '',
	      twitterErrorMessage: '',
	      collegeNewId: '',
	      modifyAnotherCollege: false,
	      showButton: false
	    };
	    return _this;
	  }
	
	  _createClass(ModifyCollege, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          modifyAnotherCollege = _state.modifyAnotherCollege,
	          minGpa = _state.minGpa,
	          minAct = _state.minAct,
	          questionLink = _state.questionLink,
	          teamPageUrl = _state.teamPageUrl,
	          minGpaErrorMessage = _state.minGpaErrorMessage,
	          questionaireLinkErrorMessage = _state.questionaireLinkErrorMessage,
	          teamPageErrorMessage = _state.teamPageErrorMessage,
	          minActErrorMessage = _state.minActErrorMessage,
	          college = _state.college,
	          city = _state.city,
	          state = _state.state,
	          division = _state.division,
	          hbcu = _state.hbcu,
	          twitter = _state.twitter,
	          showButton = _state.showButton,
	          twitterErrorMessage = _state.twitterErrorMessage;
	      var collegeModified = this.props.collegeModified;
	
	      var form = true;
	      if (collegeModified) {
	        form = false;
	      }
	      if (collegeModified && modifyAnotherCollege) {
	        form = true;
	      }
	      var renderForm = (0, _renderIf2.default)(form);
	      var renderCollegeDetails = (0, _renderIf2.default)(college !== undefined);
	      var renderSuccessMessage = (0, _renderIf2.default)(collegeModified && !modifyAnotherCollege);
	      var renderShowButton = (0, _renderIf2.default)(showButton);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _Modify2.default.removePadding) },
	        renderForm(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m7', _Modify2.default.addMargin) },
	          _react2.default.createElement(
	            'div',
	            { className: ('col s12', _Modify2.default.halfWidthWithSpan) },
	            _react2.default.createElement(
	              'span',
	              null,
	              'SELECT COLLEGE'
	            ),
	            _react2.default.createElement(_CoachRegistration2.default, { usedFor: 'contact', getDataForCoach: this.getDataForCoach })
	          ),
	          renderCollegeDetails(_react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.selectPlan },
	              'COLLEGE DETAILS'
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.desc },
	              'College Name:'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.data },
	              college
	            ),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.desc },
	              'City:\xA0\xA0'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.data },
	              city
	            ),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.desc },
	              'State:\xA0\xA0'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.data },
	              state
	            ),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.desc },
	              'Division:\xA0\xA0'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _Modify2.default.data },
	              division
	            ),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: _Modify2.default.selectPlan },
	                'Editable details'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                { className: minGpaErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpanOnError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'MINIMUM GPA'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  value: minGpa,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('minGpa', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.removeValue('minGpaErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: minGpaErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: minActErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpanOnError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'MINIMUM ACT'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  value: minAct,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('minAct', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.removeValue('minActErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: minActErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: teamPageErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpanOnError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'FOOTBALL TEAMPAGE LINK'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  value: teamPageUrl,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('teamPageUrl', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.removeValue('teamPageErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: teamPageErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: questionaireLinkErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpanOnError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'QUESTIONNAIRE LINK'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  value: questionLink,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('questionLink', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.removeValue('questionaireLinkErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: questionaireLinkErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: twitterErrorMessage === '' ? (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpan) : (0, _classnames2.default)('col s12 m6', _Modify2.default.halfWidthWithSpanOnError) },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'TWITTER LINK'
	                ),
	                _react2.default.createElement(_input2.default, {
	                  value: twitter,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('twitter', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.removeValue('twitterErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_ErrorMessage2.default, { message: twitterErrorMessage })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12 m12', _Modify2.default.removePadding) },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Modify2.default.hbcuSpan },
	                  'HBCU'
	                ),
	                _react2.default.createElement(
	                  _radio.RadioGroup,
	                  { name: 'hbcu', value: hbcu, onChange: this.handleDivisionChange },
	                  _react2.default.createElement(_radio.RadioButton, { label: 'Yes', value: 'yes' }),
	                  _react2.default.createElement(_radio.RadioButton, { label: 'No', value: 'no' })
	                )
	              )
	            ),
	            renderShowButton(_react2.default.createElement(_CustomButton2.default, { label: 'MODIFY COLLEGE', onClick: this.handleOnclick, style: _Modify2.default.buttonContainer }))
	          ))
	        )),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          { className: _Modify2.default.successMessage },
	          'College details are updated. ',
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_CustomButton2.default, { label: 'MODIFY ANOTHER COLLEGE', onClick: this.modifyAnotherCollege, style: _Modify2.default.buttonContainer })
	        ))
	      );
	    }
	  }]);
	
	  return ModifyCollege;
	}(_react.Component);
	
	ModifyCollege.propTypes = {
	  modifyCollege: _propTypes2.default.func.isRequired,
	  collegeModified: _propTypes2.default.bool.isRequired
	};
	exports.default = ModifyCollege;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modify = __webpack_require__(1271);
	
	var _Modify2 = _interopRequireDefault(_Modify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modify2.default;

/***/ },
/* 1273 */
[2527, 1266],
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Createtabs = __webpack_require__(194);
	
	var _Createtabs2 = _interopRequireDefault(_Createtabs);
	
	var _SearchUser = __webpack_require__(284);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	var _CustomButton = __webpack_require__(280);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _Userinfo = __webpack_require__(109);
	
	var _Userinfo2 = _interopRequireDefault(_Userinfo);
	
	var _UpgradeStudent = __webpack_require__(1285);
	
	var _UpgradeStudent2 = _interopRequireDefault(_UpgradeStudent);
	
	var _OverrideStudent = __webpack_require__(1276);
	
	var _OverrideStudent2 = _interopRequireDefault(_OverrideStudent);
	
	var _StudentExplorer = __webpack_require__(1281);
	
	var _StudentExplorer2 = _interopRequireDefault(_StudentExplorer);
	
	var _View = __webpack_require__(1279);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ResetDashboard = __webpack_require__(1278);
	
	var _ResetDashboard2 = _interopRequireDefault(_ResetDashboard);
	
	var _style = __webpack_require__(1565);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Error = __webpack_require__(158);
	
	var _Error2 = _interopRequireDefault(_Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabs = ['Select User', 'Upgrade Student', 'Override Student', 'Student Evaluation', 'Login As User', 'Dashboard Reset', 'Student Explorer'];
	// import SearchUserByName from 'components/SearchUserByName';
	
	var StudentView = function StudentView(props) {
	  var setTabToInitial = props.setTabToInitial,
	      userInfo = props.userInfo,
	      redirectUser = props.redirectUser,
	      upgradeStudent = props.upgradeStudent,
	      getStudentForStudentExplorer = props.getStudentForStudentExplorer,
	      evaluateStudent = props.evaluateStudent,
	      overrideStudent = props.overrideStudent,
	      upgradeInfo = props.upgradeInfo,
	      overrideInfo = props.overrideInfo,
	      evaluatedInfo = props.evaluatedInfo,
	      esError = props.esError,
	      filterBasedStudents = props.filterBasedStudents,
	      isLoading = props.isLoading,
	      dashboardReset = props.dashboardReset,
	      resetStudentDashboard = props.resetStudentDashboard,
	      searchEsUserData = props.searchEsUserData,
	      SearchAtheleteByName = props.SearchAtheleteByName,
	      searchEsUserRequested = props.searchEsUserRequested,
	      isEsLoading = props.isEsLoading;
	
	  var selectUser = (0, _renderIf2.default)(props.tab === 0);
	  var renderUpgradeStudent = (0, _renderIf2.default)(props.tab === 1);
	  var renderOverrideStudent = (0, _renderIf2.default)(props.tab === 2);
	  var studentEvaluation = (0, _renderIf2.default)(props.tab === 3);
	  var loginAsStudent = (0, _renderIf2.default)(props.tab === 4);
	  var resetDashboard = (0, _renderIf2.default)(props.tab === 5);
	  var studentExplorer = (0, _renderIf2.default)(props.tab === 6);
	  var renderLoginButton = (0, _renderIf2.default)(userInfo.name !== undefined);
	  var renderErrorMessage = (0, _renderIf2.default)(userInfo.name === undefined);
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('col s12') },
	    _react2.default.createElement(_Createtabs2.default, {
	      tabs: tabs,
	      index: props.tab,
	      activeClass: _style2.default.activeClass,
	      container: _style2.default.container,
	      tabListener: props.tabListener
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _style2.default.tabViews) },
	      selectUser(_react2.default.createElement(_SearchUser2.default, Object.assign({}, props, { userType: 'STUDENT' }))),
	      renderUpgradeStudent(_react2.default.createElement(_UpgradeStudent2.default, {
	        userInfo: userInfo,
	        setTabToInitial: setTabToInitial,
	        upgradeStudent: upgradeStudent,
	        upgradeInfo: upgradeInfo
	      })),
	      renderOverrideStudent(_react2.default.createElement(_OverrideStudent2.default, {
	        userInfo: userInfo,
	        setTabToInitial: setTabToInitial,
	        overrideStudent: overrideStudent,
	        overrideInfo: overrideInfo
	      })),
	      studentEvaluation(_react2.default.createElement(_View2.default, {
	        userInfo: userInfo,
	        setTabToInitial: setTabToInitial,
	        evaluateStudent: evaluateStudent,
	        evaluatedInfo: evaluatedInfo
	      })),
	      studentExplorer(_react2.default.createElement(_StudentExplorer2.default, {
	        getStudentForStudentExplorer: getStudentForStudentExplorer
	        // SearchUserByFullName={SearchUserByFullName}
	        , SearchAtheleteByName: SearchAtheleteByName,
	        searchEsUserRequested: searchEsUserRequested,
	        esError: esError
	        // redirectAthelete={redirectAthelete}
	        , searchEsUserData: searchEsUserData,
	        filterBasedStudents: filterBasedStudents
	        // filterBasedEsStudents={filterBasedEsStudents}
	        , loading: isLoading,
	        IsLoading: isEsLoading
	      })),
	      loginAsStudent(_react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _style2.default.loginContainer) },
	        renderLoginButton(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _style2.default.removePadding) },
	          _react2.default.createElement(_Userinfo2.default, { userInfo: userInfo, userType: 'STUDENT' }),
	          _react2.default.createElement(_CustomButton2.default, { onClick: redirectUser, style: _style2.default.buttonContainer, label: 'LOGIN AS ABOVE USER' })
	        )),
	        renderErrorMessage(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Error2.default, { message: 'Please select user in first tab' }),
	          _react2.default.createElement(_CustomButton2.default, { onClick: setTabToInitial, style: _style2.default.dummyContainer, label: 'SELECT USER' })
	        ))
	      )),
	      resetDashboard(_react2.default.createElement(_ResetDashboard2.default, {
	        userInfo: userInfo,
	        setTabToInitial: setTabToInitial,
	        dashboardReset: dashboardReset,
	        resetStudentDashboard: resetStudentDashboard
	      }))
	    )
	  );
	};
	
	StudentView.propTypes = {
	  tabListener: _propTypes2.default.func.isRequired,
	  tab: _propTypes2.default.number.isRequired,
	  userInfo: _propTypes2.default.shape.isRequired,
	  setTabToInitial: _propTypes2.default.func.isRequired,
	  redirectUser: _propTypes2.default.func.isRequired,
	  // redirectAthelete: PropTypes.func.isRequired,
	  upgradeStudent: _propTypes2.default.func.isRequired,
	  overrideStudent: _propTypes2.default.func.isRequired,
	  evaluateStudent: _propTypes2.default.func.isRequired,
	  getStudentForStudentExplorer: _propTypes2.default.func.isRequired,
	  // SearchUserByFullName: PropTypes.func.isRequired,
	  SearchAtheleteByName: _propTypes2.default.func.isRequired,
	  searchEsUserRequested: _propTypes2.default.bool.isRequired,
	  esError: _propTypes2.default.bool.isRequired,
	  searchEsUserData: _propTypes2.default.shape.isRequired,
	  upgradeInfo: _propTypes2.default.bool.isRequired,
	  overrideInfo: _propTypes2.default.bool.isRequired,
	  evaluatedInfo: _propTypes2.default.bool.isRequired,
	  filterBasedStudents: _propTypes2.default.shape.isRequired,
	  // filterBasedEsStudents: PropTypes.shape.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired,
	  isEsLoading: _propTypes2.default.bool.isRequired,
	  dashboardReset: _propTypes2.default.bool.isRequired,
	  resetStudentDashboard: _propTypes2.default.func.isRequired
	};
	
	exports.default = StudentView;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _radio = __webpack_require__(104);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _index = __webpack_require__(109);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _styles = __webpack_require__(1561);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var OverrideDivision = function (_Component) {
	  _inherits(OverrideDivision, _Component);
	
	  function OverrideDivision(props) {
	    _classCallCheck(this, OverrideDivision);
	
	    var _this = _possibleConstructorReturn(this, (OverrideDivision.__proto__ || Object.getPrototypeOf(OverrideDivision)).call(this, props));
	
	    _this.handleDivisionChange = function (selectedDivision) {
	      _this.setState({ division: selectedDivision });
	    };
	
	    _this.overrideStudent = function () {
	      var payload = {
	        student_id: _this.props.userInfo.student_id,
	        override_division: _this.state.division
	      };
	      _this.props.overrideStudent(payload);
	    };
	
	    _this.state = {
	      division: 'D1'
	    };
	    return _this;
	  }
	
	  _createClass(OverrideDivision, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ division: this.props.userInfo.overrideDivision || 'D1' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          userInfo = _props.userInfo,
	          setTabToInitial = _props.setTabToInitial,
	          overrideInfo = _props.overrideInfo;
	      var division = this.state.division;
	
	      var renderUserNotSelected = (0, _renderIf2.default)(userInfo.name === undefined);
	      var renderUserSelected = (0, _renderIf2.default)(userInfo.name !== undefined && !overrideInfo);
	      var renderSuccessMessage = (0, _renderIf2.default)(overrideInfo && userInfo.name !== undefined);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	        renderUserNotSelected(_react2.default.createElement(_ErrorMessage2.default, { message: 'Please select user in first tab' })),
	        renderUserSelected(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _styles2.default.container) },
	          _react2.default.createElement(_index2.default, { userInfo: userInfo, userType: 'STUDENT' }),
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _styles2.default.actionContainer) },
	            _react2.default.createElement(
	              'span',
	              { className: _styles2.default.selectPlan },
	              'Select Division.'
	            ),
	            ' ',
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	            _react2.default.createElement(
	              _radio.RadioGroup,
	              { name: 'division', value: division || 'D1', onChange: this.handleDivisionChange },
	              _react2.default.createElement(_radio.RadioButton, { label: 'Division 1', value: 'D1' }),
	              _react2.default.createElement(_radio.RadioButton, { label: 'Division 2', value: 'D2' }),
	              _react2.default.createElement(_radio.RadioButton, { label: 'Division 3', value: 'D3' })
	            )
	          )
	        )),
	        renderUserSelected(_react2.default.createElement(_CustomButton2.default, { label: 'UPGRADE USER', style: _styles2.default.buttonContainer, onClick: this.overrideStudent })),
	        renderUserNotSelected(_react2.default.createElement(_CustomButton2.default, { label: 'SELECT USER', style: _styles2.default.buttonContainer, onClick: setTabToInitial })),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          { className: _styles2.default.successMessage },
	          'User division is modified.'
	        ))
	      );
	    }
	  }]);
	
	  return OverrideDivision;
	}(_react.Component);
	
	OverrideDivision.propTypes = {
	  userInfo: _propTypes2.default.shape.isRequired,
	  setTabToInitial: _propTypes2.default.func.isRequired,
	  overrideStudent: _propTypes2.default.func.isRequired,
	  overrideInfo: _propTypes2.default.shape.isRequired
	};
	exports.default = OverrideDivision;

/***/ },
/* 1276 */
[2527, 1275],
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _index = __webpack_require__(109);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _styles = __webpack_require__(509);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var ResetDashboard = function (_Component) {
	  _inherits(ResetDashboard, _Component);
	
	  function ResetDashboard(props) {
	    _classCallCheck(this, ResetDashboard);
	
	    var _this = _possibleConstructorReturn(this, (ResetDashboard.__proto__ || Object.getPrototypeOf(ResetDashboard)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ResetDashboard, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          userInfo = _props.userInfo,
	          setTabToInitial = _props.setTabToInitial,
	          dashboardReset = _props.dashboardReset;
	      // const { showError } = this.state;
	
	      var renderUserNotSelected = (0, _renderIf2.default)(userInfo.name === undefined);
	      var renderUserSelected = (0, _renderIf2.default)(userInfo.name !== undefined);
	      var renderSuccessMessage = (0, _renderIf2.default)(dashboardReset && userInfo.name !== undefined);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	        renderUserNotSelected(_react2.default.createElement(_ErrorMessage2.default, { message: 'Please select user in first tab' })),
	        renderUserSelected(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _styles2.default.container) },
	          _react2.default.createElement(_index2.default, { userInfo: userInfo, userType: 'STUDENT' }),
	          _react2.default.createElement('br', null)
	        )),
	        renderUserSelected(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _styles2.default.actionContainer) },
	          _react2.default.createElement(_CustomButton2.default, {
	            label: 'RESET ABOVE STUDENT',
	            style: _styles2.default.buttonContainer,
	            onClick: function onClick() {
	              return _this2.props.resetStudentDashboard(userInfo.id);
	            }
	          })
	        )),
	        renderUserNotSelected(_react2.default.createElement(_CustomButton2.default, { label: 'SELECT USER', style: _styles2.default.buttonContainer, onClick: setTabToInitial })),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.successMessage },
	            'Student dashboard has been reset.'
	          )
	        ))
	      );
	    }
	  }]);
	
	  return ResetDashboard;
	}(_react.Component);
	
	ResetDashboard.propTypes = {
	  userInfo: _propTypes2.default.shape.isRequired,
	  setTabToInitial: _propTypes2.default.func.isRequired,
	  resetStudentDashboard: _propTypes2.default.func.isRequired,
	  dashboardReset: _propTypes2.default.bool.isRequired
	};
	exports.default = ResetDashboard;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResetDashboard = __webpack_require__(1277);
	
	var _ResetDashboard2 = _interopRequireDefault(_ResetDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResetDashboard2.default;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _index = __webpack_require__(109);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _styles = __webpack_require__(509);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var StudentEvaluation = function (_Component) {
	  _inherits(StudentEvaluation, _Component);
	
	  function StudentEvaluation(props) {
	    _classCallCheck(this, StudentEvaluation);
	
	    var _this = _possibleConstructorReturn(this, (StudentEvaluation.__proto__ || Object.getPrototypeOf(StudentEvaluation)).call(this, props));
	
	    _this.handleChange = function (event) {
	      _this.setState({ evaluationText: event });
	    };
	
	    _this.evaluateStudent = function () {
	      if (_this.state.evaluationText !== '') {
	        var payload = {
	          student_id: _this.props.userInfo.student_id,
	          evaluation_text: _this.state.evaluationText
	        };
	        _this.props.evaluateStudent(payload);
	      } else {
	        _this.setState({ showError: true });
	      }
	    };
	
	    _this.removeErrorMessage = function () {
	      _this.setState({ showError: false });
	    };
	
	    _this.state = {
	      evaluationText: '',
	      showError: false,
	      errorMessage: ''
	    };
	    return _this;
	  }
	
	  _createClass(StudentEvaluation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ evaluationText: this.props.userInfo.evaluationText });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          userInfo = _props.userInfo,
	          setTabToInitial = _props.setTabToInitial,
	          evaluatedInfo = _props.evaluatedInfo;
	      var _state = this.state,
	          showError = _state.showError,
	          evaluationText = _state.evaluationText;
	
	      var renderUserNotSelected = (0, _renderIf2.default)(userInfo.name === undefined);
	      var renderUserSelected = (0, _renderIf2.default)(userInfo.name !== undefined && !evaluatedInfo);
	      var renderSuccessMessage = (0, _renderIf2.default)(evaluatedInfo && userInfo.name !== undefined);
	      var renderErrorMessage = (0, _renderIf2.default)(showError);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _styles2.default.removePadding) },
	        renderUserNotSelected(_react2.default.createElement(_ErrorMessage2.default, { message: 'Please select user in first tab' })),
	        renderUserSelected(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _styles2.default.container) },
	          _react2.default.createElement(_index2.default, { userInfo: userInfo, userType: 'STUDENT' }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _styles2.default.actionContainer) },
	            _react2.default.createElement(
	              'span',
	              { className: _styles2.default.selectPlan },
	              'Add description about student.'
	            ),
	            ' ',
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement('textarea', {
	            value: evaluationText || '',
	            className: _styles2.default.textarea,
	            onFocus: this.removeErrorMessage,
	            onChange: function onChange(event) {
	              return _this2.handleChange(event.target.value);
	            }
	          }),
	          renderErrorMessage(_react2.default.createElement(_ErrorMessage2.default, { message: 'Please add something to update.' }))
	        )),
	        renderUserSelected(_react2.default.createElement(_CustomButton2.default, { label: 'EVALUATE ABOVE STUDENT', style: _styles2.default.buttonContainer, onClick: this.evaluateStudent })),
	        renderUserNotSelected(_react2.default.createElement(_CustomButton2.default, { label: 'SELECT USER', style: _styles2.default.buttonContainer, onClick: setTabToInitial })),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.successMessage },
	            'Below description is added to user.'
	          ),
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'spam',
	            null,
	            this.state.evaluationText
	          )
	        ))
	      );
	    }
	  }]);
	
	  return StudentEvaluation;
	}(_react.Component);
	
	StudentEvaluation.propTypes = {
	  userInfo: _propTypes2.default.shape.isRequired,
	  setTabToInitial: _propTypes2.default.func.isRequired,
	  evaluateStudent: _propTypes2.default.func.isRequired,
	  evaluatedInfo: _propTypes2.default.shape.isRequired
	};
	exports.default = StudentEvaluation;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _tabs = __webpack_require__(254);
	
	var _SearchUserByFullName = __webpack_require__(1209);
	
	var _SearchUserByFullName2 = _interopRequireDefault(_SearchUserByFullName);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Tiles = __webpack_require__(1283);
	
	var _Tiles2 = _interopRequireDefault(_Tiles);
	
	var _Explorer = __webpack_require__(1562);
	
	var _Explorer2 = _interopRequireDefault(_Explorer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	// import SearchUserByName from 'components/SearchUserByName';
	
	// import moment from 'moment/moment';
	// import Button from 'components/CustomButton';
	
	var divisions = ['D1', 'D2', 'D3', 'NAIA', 'JUCO'];
	var evaluation = ['NONE', 'EVALUATED', 'NON EVALUATED'];
	var paid = ['NONE', 'PAID ATHLETES', 'UNPAID ATHLETES'];
	// to import local scss fle
	
	// const tabs = ['Search Student By Division', 'Search Student By Name'];
	
	var UpgradeStudent = function (_Component) {
	  _inherits(UpgradeStudent, _Component);
	
	  function UpgradeStudent(props) {
	    _classCallCheck(this, UpgradeStudent);
	
	    var _this = _possibleConstructorReturn(this, (UpgradeStudent.__proto__ || Object.getPrototypeOf(UpgradeStudent)).call(this, props));
	
	    _this.handleTabChange = function (index) {
	      _this.setState({ index: index });
	    };
	
	    _this.handleFixedTabChange = function (index) {
	      _this.setState({ fixedIndex: index });
	    };
	
	    _this.handleInverseTabChange = function (index) {
	      _this.setState({ inverseIndex: index });
	    };
	
	    _this.handleFilterChange = function (name, index) {
	      var _this$state = _this.state,
	          planIndex = _this$state.planIndex,
	          divisionIndex = _this$state.divisionIndex,
	          evaluationIndex = _this$state.evaluationIndex;
	
	      var applyFilter = false;
	      if (name === 'planIndex' && planIndex !== index) applyFilter = true;
	      if (name === 'divisionIndex' && divisionIndex !== index) applyFilter = true;
	      if (name === 'evaluationIndex' && evaluationIndex !== index) applyFilter = true;
	      if (applyFilter) _this.setState(_defineProperty({}, name, index), _this.applyFilters);
	    };
	
	    _this.applyFilters = function () {
	      var _this$state2 = _this.state,
	          divisionIndex = _this$state2.divisionIndex,
	          evaluationIndex = _this$state2.evaluationIndex,
	          planIndex = _this$state2.planIndex;
	
	      var payload = {};
	      payload['division'] = divisions[divisionIndex]; // eslint-disable-line
	      if (evaluationIndex) payload['evaluated'] = evaluationIndex === 1 ? true : false; // eslint-disable-line
	      if (planIndex) payload['paid'] = planIndex === 1 ? true : false; // eslint-disable-line
	      _this.props.getStudentForStudentExplorer(payload);
	    };
	
	    _this.state = {
	      planIndex: 0,
	      index: 0,
	      fixedIndex: 1,
	      inverseIndex: 1,
	      divisionIndex: 0,
	      evaluationIndex: 0,
	      selectedPlan: {}
	    };
	    return _this;
	  }
	
	  _createClass(UpgradeStudent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var payload = {
	        division: 'D1'
	      };
	      // if (this.state.index === 0) {
	      this.props.getStudentForStudentExplorer(payload);
	      // }
	    }
	
	    // handleActive = () => {
	    //   // eslint-disable-next-line no-console
	    //   console.log('Special one activated');
	    // };
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          planIndex = _state.planIndex,
	          divisionIndex = _state.divisionIndex,
	          evaluationIndex = _state.evaluationIndex;
	      var _props = this.props,
	          filterBasedStudents = _props.filterBasedStudents,
	          isLoading = _props.isLoading;
	
	      var renderNoStudentFound = (0, _renderIf2.default)(filterBasedStudents.size === 0 && !isLoading);
	      var renderStudents = (0, _renderIf2.default)(filterBasedStudents.size > 0);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _tabs.Tabs,
	          { index: this.state.index, onChange: this.handleTabChange },
	          _react2.default.createElement(
	            _tabs.Tab,
	            { label: 'Search By Division' },
	            _react2.default.createElement(
	              'small',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('col s12', _Explorer2.default.removePadding) },
	                _react2.default.createElement(
	                  'span',
	                  { className: _Explorer2.default.filterType },
	                  'FILTER FOR DIVISION'
	                ),
	                ' ',
	                _react2.default.createElement('br', null),
	                divisions.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'button',
	                    {
	                      className: divisionIndex === i ? _Explorer2.default.selectedButton : _Explorer2.default.plainButton,
	                      onClick: function onClick() {
	                        return _this2.handleFilterChange('divisionIndex', i);
	                      }
	                    },
	                    item
	                  );
	                }),
	                ' ',
	                _react2.default.createElement('br', null),
	                ' ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Explorer2.default.filterType },
	                  'FILTER FOR EVALUATION'
	                ),
	                _react2.default.createElement('br', null),
	                evaluation.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'button',
	                    {
	                      className: evaluationIndex === i ? _Explorer2.default.selectedButton : _Explorer2.default.plainButton,
	                      onClick: function onClick() {
	                        return _this2.handleFilterChange('evaluationIndex', i);
	                      }
	                    },
	                    item
	                  );
	                }),
	                ' ',
	                _react2.default.createElement('br', null),
	                ' ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'span',
	                  { className: _Explorer2.default.filterType },
	                  'FILTER FOR PAID/UNPAID'
	                ),
	                ' ',
	                _react2.default.createElement('br', null),
	                paid.map(function (item, i) {
	                  return _react2.default.createElement(
	                    'button',
	                    {
	                      className: planIndex === i ? _Explorer2.default.selectedButton : _Explorer2.default.plainButton,
	                      onClick: function onClick() {
	                        return _this2.handleFilterChange('planIndex', i);
	                      }
	                    },
	                    item
	                  );
	                }),
	                renderNoStudentFound(_react2.default.createElement(_ErrorMessage2.default, { message: 'No Athlete found on above filter. Try different filter.' })),
	                renderStudents(_react2.default.createElement(
	                  'div',
	                  { className: (0, _classnames2.default)('col s12', _Explorer2.default.container) },
	                  filterBasedStudents.map(function (item) {
	                    return _react2.default.createElement(_Tiles2.default, { item: item });
	                  })
	                ))
	              ),
	              ','
	            )
	          ),
	          _react2.default.createElement(
	            _tabs.Tab,
	            { label: 'Search By Name' },
	            _react2.default.createElement(
	              'small',
	              null,
	              _react2.default.createElement(_SearchUserByFullName2.default, Object.assign({}, this.props, { userType: 'STUDENT' }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UpgradeStudent;
	}(_react.Component);
	
	UpgradeStudent.propTypes = {
	  getStudentForStudentExplorer: _propTypes2.default.func.isRequired,
	  filterBasedStudents: _propTypes2.default.shape.isRequired,
	  isLoading: _propTypes2.default.bool.isRequired
	};
	exports.default = UpgradeStudent;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Explorer = __webpack_require__(1280);
	
	var _Explorer2 = _interopRequireDefault(_Explorer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Explorer2.default;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _Rtiles = __webpack_require__(1563);
	
	var _Rtiles2 = _interopRequireDefault(_Rtiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	
	// import Popup from 'components/AtheletePopup';
	// import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';
	// import Divider from 'components/Divider';
	
	
	// to import local scss fle
	
	var Rtiles = function (_Component) {
	  _inherits(Rtiles, _Component);
	
	  function Rtiles(props) {
	    _classCallCheck(this, Rtiles);
	
	    var _this = _possibleConstructorReturn(this, (Rtiles.__proto__ || Object.getPrototypeOf(Rtiles)).call(this, props));
	
	    _this.onCloseModal = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.state = {
	      value: '',
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(Rtiles, [{
	    key: 'render',
	    value: function render() {
	      var item = this.props.item;
	      // const { open } = this.state;
	
	      var athleteHaveProfileImage = false;
	      if (item.get('sa_image') !== undefined) {
	        athleteHaveProfileImage = true;
	      }
	      var sport = item.get('sports');
	      var position = sport.get('FOOTBALL');
	      return _react2.default.createElement(
	        'div',
	        { className: _Rtiles2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _Rtiles2.default.tile },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/athlete/' + item.get('id'), target: '_blank' },
	              _react2.default.createElement('img', {
	                className: _Rtiles2.default.heartIcon,
	                src: 'https://media.dev.myrecruitboard.com/Images/link-new-tab.png', alt: 'public_profile'
	              })
	            ),
	            _react2.default.createElement('img', {
	              className: _Rtiles2.default.colgeIcon,
	              src: athleteHaveProfileImage === true ? //eslint-disable-line
	              'https://s3.amazonaws.com/myrbimages/' + item.get('sa_image') : //eslint-disable-line
	              'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	              alt: 'athlete-icon'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: _Rtiles2.default.collegeName },
	              item.get('fullname')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Rtiles2.default.sportName },
	              position.get('primary_offensive_position_pref') !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                position.get('primary_offensive_position_pref')
	              ) : '',
	              position.get('primary_defensive_position_pref') !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                ',\xA0\xA0',
	                position.get('primary_defensive_position_pref')
	              ) : '',
	              position.get('secondary_offensive_position_pref') !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                ',\xA0',
	                position.get('secondary_offensive_position_pref')
	              ) : '',
	              '\xA0',
	              position.get('secondary_defensive_position_pref') !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                ',\xA0',
	                position.get('secondary_defensive_position_pref')
	              ) : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Rtiles2.default.userNameIcon },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: _Rtiles2.default.email },
	                  item.get('sa_email')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Rtiles2.default.schoolName },
	                  item.get('school')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Rtiles2.default.cityName },
	                  item.get('city'),
	                  ', ',
	                  _DropdownsValues.states[item.get('sa_state')]
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _Rtiles2.default.lightText },
	                  item.get('academic').get('year_of_graduation'),
	                  ',\xA0\xA0',
	                  item.getIn(['academic', 'gpa'])
	                )
	              )
	            ),
	            _react2.default.createElement('br', null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Rtiles;
	}(_react.Component);
	
	Rtiles.propTypes = {
	  item: _propTypes2.default.shape()
	  // editable: PropTypes.bool,
	};
	Rtiles.defaultProps = {
	  item: {}
	  // editable: false,
	};
	exports.default = Rtiles;

/***/ },
/* 1283 */
[2528, 1282],
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _index = __webpack_require__(109);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _UpgradeStudent = __webpack_require__(1564);
	
	var _UpgradeStudent2 = _interopRequireDefault(_UpgradeStudent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	var plans = [{
	  title: '1 Month',
	  noOfMonths: 1,
	  planName: '29_99_once_1_month'
	}, {
	  title: '3 Month',
	  noOfMonths: 3,
	  planName: '19_99_per_month_3_months'
	}, {
	  title: '6 Month',
	  noOfMonths: 6,
	  planName: '75_once_6_months'
	}, {
	  title: '12 Month',
	  noOfMonths: 12,
	  planName: '99_once_12_months'
	}, {
	  title: 'Life Time',
	  noOfMonths: 12000,
	  planName: '199_once_lifetime'
	}];
	// to import local scss fle
	
	var UpgradeStudent = function (_Component) {
	  _inherits(UpgradeStudent, _Component);
	
	  function UpgradeStudent(props) {
	    _classCallCheck(this, UpgradeStudent);
	
	    var _this = _possibleConstructorReturn(this, (UpgradeStudent.__proto__ || Object.getPrototypeOf(UpgradeStudent)).call(this, props));
	
	    _this.handlePlanChange = function (index, item) {
	      _this.setState({ planIndex: index, selectedPlan: item });
	    };
	
	    _this.upgradeStudent = function () {
	      var selectedPlan = _this.state.selectedPlan;
	
	      var expiryDate = new Date();
	      var month = expiryDate.getMonth() + selectedPlan.noOfMonths;
	      var lastdate = (0, _moment2.default)(expiryDate);
	      lastdate.add(month, 'month');
	      var d = lastdate._d; // eslint-disable-line
	      var transactiondate = new Date().toISOString();
	
	      var payment = {
	        last_date: d,
	        payment_customer_id: 'free_access_customer_id',
	        transaction_id: 'free_access_transaction_id',
	        payment_status: true,
	        plan_id: selectedPlan.planName,
	        transaction_date: transactiondate
	      };
	      var payload = {
	        student_id: _this.props.userInfo.student_id,
	        payment_info: [payment]
	      };
	      _this.props.upgradeStudent(payload);
	    };
	
	    _this.state = {
	      planIndex: null,
	      selectedPlan: {}
	    };
	    return _this;
	  }
	
	  _createClass(UpgradeStudent, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          userInfo = _props.userInfo,
	          setTabToInitial = _props.setTabToInitial,
	          upgradeInfo = _props.upgradeInfo;
	      var _state = this.state,
	          planIndex = _state.planIndex,
	          selectedPlan = _state.selectedPlan;
	
	      var renderUserNotSelected = (0, _renderIf2.default)(userInfo.name === undefined);
	      var renderUserSelected = (0, _renderIf2.default)(userInfo.name !== undefined && !upgradeInfo);
	      var renderSuccessMessage = (0, _renderIf2.default)(upgradeInfo === true && userInfo.name !== undefined);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('col s12', _UpgradeStudent2.default.removePadding) },
	        renderUserNotSelected(_react2.default.createElement(_ErrorMessage2.default, { message: 'Please select user in first tab' })),
	        renderUserSelected(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _UpgradeStudent2.default.container) },
	          _react2.default.createElement(_index2.default, { userInfo: userInfo, userType: 'STUDENT' }),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _UpgradeStudent2.default.actionContainer) },
	            _react2.default.createElement(
	              'span',
	              { className: _UpgradeStudent2.default.selectPlan },
	              'Select plan.'
	            ),
	            ' ',
	            _react2.default.createElement('br', null)
	          ),
	          plans.map(function (item, i) {
	            return _react2.default.createElement(
	              'button',
	              {
	                className: planIndex === i ? _UpgradeStudent2.default.selectedButton : _UpgradeStudent2.default.plainButton,
	                onClick: function onClick() {
	                  return _this2.handlePlanChange(i, item);
	                }
	              },
	              item.title
	            );
	          })
	        )),
	        renderUserSelected(_react2.default.createElement(_CustomButton2.default, { label: 'UPGRADE USER', style: _UpgradeStudent2.default.buttonContainer, onClick: this.upgradeStudent })),
	        renderUserNotSelected(_react2.default.createElement(_CustomButton2.default, { label: 'SELECT USER', style: _UpgradeStudent2.default.buttonContainer, onClick: setTabToInitial })),
	        renderSuccessMessage(_react2.default.createElement(
	          'span',
	          { className: _UpgradeStudent2.default.successMessage },
	          'User is upgraded with ',
	          selectedPlan.title,
	          ' plan!'
	        ))
	      );
	    }
	  }]);
	
	  return UpgradeStudent;
	}(_react.Component);
	
	UpgradeStudent.propTypes = {
	  userInfo: _propTypes2.default.shape.isRequired,
	  setTabToInitial: _propTypes2.default.func.isRequired,
	  upgradeStudent: _propTypes2.default.func.isRequired,
	  upgradeInfo: _propTypes2.default.shape.isRequired
	};
	exports.default = UpgradeStudent;

/***/ },
/* 1285 */
[2527, 1284],
/* 1286 */
[2527, 1274],
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DropdownsValues = __webpack_require__(47);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _AtheletePopup = __webpack_require__(1090);
	
	var _AtheletePopup2 = _interopRequireDefault(_AtheletePopup);
	
	var _style = __webpack_require__(1566);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	
	// import { IconMenu, MenuItem } from 'react-toolbox/lib/menu';
	// import Divider from 'components/Divider';
	
	
	// to import local scss fle
	
	var Rtiles = function (_Component) {
	  _inherits(Rtiles, _Component);
	
	  function Rtiles(props) {
	    _classCallCheck(this, Rtiles);
	
	    var _this = _possibleConstructorReturn(this, (Rtiles.__proto__ || Object.getPrototypeOf(Rtiles)).call(this, props));
	
	    _this.onCloseModal = function () {
	      _this.setState({ open: false });
	    };
	
	    _this.state = {
	      value: '',
	      open: false
	    };
	    return _this;
	  }
	
	  _createClass(Rtiles, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // eslint-disable-next-line react/prop-types
	      var _props = this.props,
	          item = _props.item,
	          key = _props.key;
	      var open = this.state.open;
	
	      var athleteHaveProfileImage = false;
	      if (item.sa_image !== undefined) {
	        athleteHaveProfileImage = true;
	      }
	      var sport = item.sports;
	      var position = sport.FOOTBALL;
	      return _react2.default.createElement(
	        'div',
	        { key: key, className: _style2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.tile },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/athlete/' + item.id, target: '_blank' },
	              _react2.default.createElement('img', {
	                className: _style2.default.heartIcon,
	                src: 'https://media.dev.myrecruitboard.com/Images/link-new-tab.png', alt: 'public_profile'
	              })
	            ),
	            _react2.default.createElement('img', {
	              className: _style2.default.colgeIcon,
	              src: athleteHaveProfileImage === true ? //eslint-disable-line
	              'https://s3.amazonaws.com/myrbimagesdev/' + item.sa_image : //eslint-disable-line
	              'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png',
	              alt: 'athlete-icon'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.collegeName },
	              item.fullname
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.sportName },
	              position.primary_offensive_position_pref !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                position.primary_offensive_position_pref
	              ) : '',
	              position.primary_defensive_position_pre !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                ',\xA0\xA0',
	                position.primary_defensive_position_pref
	              ) : '',
	              position.secondary_offensive_position_pref !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                ',\xA0',
	                position.secondary_offensive_position_pref
	              ) : '',
	              '\xA0',
	              position.secondary_defensive_position_pref !== undefined ? _react2.default.createElement(
	                'span',
	                null,
	                ',\xA0',
	                position.secondary_defensive_position_pref
	              ) : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.userNameIcon },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.email },
	                  item.sa_email
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.schoolName },
	                  item.school
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.cityName },
	                  item.city,
	                  ', ',
	                  _DropdownsValues.states[item.sa_state]
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _style2.default.lightText },
	                  item.academic.year_of_graduation,
	                  ',\xA0\xA0',
	                  item.academic.gpa
	                )
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'button',
	              { className: _style2.default.buttonEdit, onClick: function onClick() {
	                  return _this2.setState({ open: true });
	                } },
	              'EDIT'
	            )
	          ),
	          _react2.default.createElement(_AtheletePopup2.default, { open: open, close: this.onCloseModal, item: item })
	        )
	      );
	    }
	  }]);
	
	  return Rtiles;
	}(_react.Component);
	
	Rtiles.propTypes = {
	  item: _propTypes2.default.shape()
	};
	Rtiles.defaultProps = {
	  item: {}
	};
	exports.default = Rtiles;

/***/ },
/* 1288 */
[2527, 1287],
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _CustomButton = __webpack_require__(280);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _UserInfo = __webpack_require__(1567);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserInfo = function UserInfo(props) {
	  var deleteCoach = props.deleteCoach,
	      userInfo = props.userInfo,
	      id = props.id,
	      userType = props.userType;
	
	  var renderDeleteButton = (0, _renderIf2.default)(props.usedFor === 'DELETE COACH');
	  var renderStudentDetails = (0, _renderIf2.default)(props.userType === 'STUDENT');
	  return _react2.default.createElement(
	    'div',
	    { className: userType === 'STUDENT' ? (0, _classnames2.default)('col s12', _UserInfo2.default.studentContainer) : (0, _classnames2.default)('col s12', _UserInfo2.default.container) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m8', _UserInfo2.default.removePadding) },
	      _react2.default.createElement(
	        'div',
	        { className: _UserInfo2.default.imageContainer },
	        _react2.default.createElement('img', { className: _UserInfo2.default.userIcon, src: 'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png', alt: 'college-icon' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _UserInfo2.default.textContainer },
	        _react2.default.createElement(
	          'span',
	          null,
	          userInfo.name
	        ),
	        ' ',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          null,
	          userInfo.email
	        ),
	        ' ',
	        _react2.default.createElement('br', null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12 m4', _UserInfo2.default.deleteButtonContainer) },
	      _react2.default.createElement(
	        'span',
	        null,
	        renderDeleteButton(_react2.default.createElement(_CustomButton2.default, { label: 'DELETE COACH', onClick: function onClick() {
	            return deleteCoach(id, userInfo.coach_id);
	          } }))
	      )
	    ),
	    renderStudentDetails(_react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('col s12', _UserInfo2.default.removePadding) },
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: _UserInfo2.default.header },
	        'STUDENT BIOMETRICS'
	      ),
	      _react2.default.createElement('br', null),
	      userInfo.t40 !== undefined ? _react2.default.createElement(
	        'span',
	        null,
	        '40TIME: \xA0\xA0',
	        userInfo.t40
	      ) : '',
	      ' \xA0\xA0\xA0',
	      userInfo.squats !== undefined ? _react2.default.createElement(
	        'span',
	        null,
	        'SQUATS: \xA0\xA0',
	        userInfo.squats
	      ) : '',
	      ' \xA0\xA0\xA0',
	      userInfo.bench !== undefined ? _react2.default.createElement(
	        'span',
	        null,
	        'BENCH: \xA0\xA0',
	        userInfo.bench
	      ) : '',
	      '\xA0\xA0\xA0 ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'span',
	        { className: _UserInfo2.default.header },
	        'POSITIONS'
	      ),
	      _react2.default.createElement('br', null),
	      userInfo.primaryOff !== undefined ? _react2.default.createElement(
	        'span',
	        null,
	        'Primary Offensive: \xA0\xA0',
	        userInfo.primaryOff
	      ) : '',
	      _react2.default.createElement('br', null),
	      userInfo.primaryDef !== undefined ? _react2.default.createElement(
	        'span',
	        null,
	        'Primary Defensive: \xA0\xA0',
	        userInfo.primaryDef
	      ) : '',
	      _react2.default.createElement('br', null),
	      userInfo.secondaryOff !== undefined ? _react2.default.createElement(
	        'span',
	        null,
	        'Secondary Offensive: \xA0\xA0',
	        userInfo.secondaryOff
	      ) : '',
	      '\xA0\xA0\xA0',
	      userInfo.secondaryDef !== undefined ? _react2.default.createElement(
	        'span',
	        null,
	        'Secondary Defensive: \xA0\xA0',
	        userInfo.secondaryDef
	      ) : '',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: '/athlete/' + userInfo.id, target: '_blank' },
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'a',
	          null,
	          'Go to his profile'
	        )
	      )
	    ))
	  );
	};
	
	UserInfo.propTypes = {
	  userInfo: _propTypes2.default.shape.isRequired,
	  usedFor: _propTypes2.default.string,
	  deleteCoach: _propTypes2.default.func.isRequired,
	  id: _propTypes2.default.number,
	  userType: _propTypes2.default.string
	};
	
	UserInfo.defaultProps = {
	  usedFor: '',
	  userType: '',
	  id: ''
	};
	
	exports.default = UserInfo;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Admin = __webpack_require__(1259);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Admin2.default;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Signin = __webpack_require__(467);
	
	var _Signin2 = _interopRequireDefault(_Signin);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Details = __webpack_require__(196);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _reactRouter = __webpack_require__(89);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Login = __webpack_require__(1568);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default propscoming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var AdminLogin = function (_Component) {
	  _inherits(AdminLogin, _Component);
	
	  function AdminLogin(props) {
	    _classCallCheck(this, AdminLogin);
	
	    var _this = _possibleConstructorReturn(this, (AdminLogin.__proto__ || Object.getPrototypeOf(AdminLogin)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(AdminLogin, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.isValid) {
	        this.props.history.push('/');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var signinData = {
	        bannerHeader: 'GET THE MORE OF YOU',
	        bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
	        detailsHeader: 'Sign in to MyRecruitBoard',
	        detailsDesc: 'Enter your details below.',
	        otherPages: true
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Login2.default.loginContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Login2.default.loginBanner) },
	          _react2.default.createElement(_Banner2.default, { data: signinData, usedFor: 'login' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Login2.default.inputFileds) },
	          _react2.default.createElement(
	            _Details2.default,
	            Object.assign({ data: signinData }, this.props),
	            _react2.default.createElement(_Signin2.default, this.props)
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminLogin;
	}(_react.Component);
	
	AdminLogin.propTypes = {
	  isValid: _propTypes2.default.bool.isRequired,
	  history: _propTypes2.default.shape()
	};
	AdminLogin.defaultProps = {
	  history: {}
	};
	exports.default = (0, _reactRouter.withRouter)((0, _SessionReplica2.default)(AdminLogin));

/***/ },
/* 1292 */
[2533, 1291],
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _AtheleteDetails = __webpack_require__(278);
	
	var _AtheleteDetails2 = _interopRequireDefault(_AtheleteDetails);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Athelete = __webpack_require__(1569);
	
	var _Athelete2 = _interopRequireDefault(_Athelete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var Athelete = function (_Component) {
	  _inherits(Athelete, _Component);
	
	  function Athelete(props) {
	    _classCallCheck(this, Athelete);
	
	    var _this = _possibleConstructorReturn(this, (Athelete.__proto__ || Object.getPrototypeOf(Athelete)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Athelete, [{
	    key: 'render',
	    value: function render() {
	      var bannerData = {
	        bannerHeader: 'GET DISCOVERED NATIONALLY',
	        bannerDesc: "We're proud to be the largest athletic recruiting platform since we were  founded. The sports recruiting world has shifted, and we're always evolving.",
	        backgroundUrl: 'https://media.dev.myrecruitboard.com/Images/bgDesktop.png',
	        fullsize: false,
	        otherPages: true
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Athelete2.default.atheleteContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Athelete2.default.bannerAthelete) },
	          _react2.default.createElement(_Banner2.default, { data: bannerData })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Athelete2.default.bannerAthelete) },
	          _react2.default.createElement(_AtheleteDetails2.default, { viewer: 'athlete' })
	        )
	      );
	    }
	  }]);
	
	  return Athelete;
	}(_react.Component);
	
	Athelete.propTypes = {
	  data: _propTypes2.default.isRequired
	};
	
	exports.default = Athelete;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Athelete = __webpack_require__(1293);
	
	var _Athelete2 = _interopRequireDefault(_Athelete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Athelete2.default;

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _immutable = __webpack_require__(11);
	
	var _PublicActionableItems = __webpack_require__(1190);
	
	var _PublicActionableItems2 = _interopRequireDefault(_PublicActionableItems);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _queryString = __webpack_require__(116);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProfileHeader = __webpack_require__(283);
	
	var _ProfileHeader2 = _interopRequireDefault(_ProfileHeader);
	
	var _ProfileData = __webpack_require__(282);
	
	var _ProfileData2 = _interopRequireDefault(_ProfileData);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _VideoPlayer = __webpack_require__(469);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	var _analytics = __webpack_require__(37);
	
	var _AthleteById = __webpack_require__(1570);
	
	var _AthleteById2 = _interopRequireDefault(_AthleteById);
	
	var _redux = __webpack_require__(471);
	
	var _actions = __webpack_require__(1296);
	
	var _actions2 = __webpack_require__(287);
	
	var _actions3 = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	// to show loder on screen whenever there is a api call or operations in component
	// to import local scss fle
	
	
	var AthleteById = function (_Component) {
	  _inherits(AthleteById, _Component);
	
	  function AthleteById(props) {
	    _classCallCheck(this, AthleteById);
	
	    var _this = _possibleConstructorReturn(this, (AthleteById.__proto__ || Object.getPrototypeOf(AthleteById)).call(this, props));
	
	    _this.state = {
	      showFullScreenVideo: false,
	      videoOnProfile: false,
	      showActionableItems: false,
	      coachEmail: ''
	    };
	    _this.removeVideoScreen = _this.removeVideoScreen.bind(_this);
	    return _this;
	  }
	
	  _createClass(AthleteById, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var query = _queryString2.default.parse(this.props.location.search);
	      var publicProfile = false;
	      if (query && Object.prototype.hasOwnProperty.call(query, 'coach_email') && this.props.match.path === '/athleteForCoach/:id') {
	        publicProfile = true;
	        var temp = query.coach_email;
	        this.setState({ showActionableItems: true, coachEmail: temp });
	      }
	      var id = this.props.match.params.id;
	      if (id && id.length > 0 && !publicProfile) {
	        this.props.getSAProfile(id);
	      } else {
	        this.props.getProfileForCoach(id);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.conversationUpdated !== this.props.conversationUpdated) {
	        var id = this.props.match.params.id;
	        this.props.getProfileForCoach(id);
	      }
	      if (nextProps.profile.size > 0) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        var profileImage = '';
	        var primary_offensive_position_pref = ''; //eslint-disable-line
	        var primary_defensive_position_pref = ''; //eslint-disable-line
	        var secondary_offensive_position_pref = ''; //eslint-disable-line
	        var secondary_defensive_position_pref = ''; //eslint-disable-line
	        var special_teams = ''; //eslint-disable-line
	
	        var sat = '';
	        var act = '';
	        if (nextProps.profile.get('profile_image') !== undefined) {
	          profileImage = nextProps.profile.get('profile_image');
	        } else {
	          profileImage = '';
	        }
	        var instagramLink = '';
	        if (nextProps.profile.get('sa_instagram')) {
	          instagramLink = nextProps.profile.get('sa_instagram');
	        } else {
	          instagramLink = '';
	        }
	        var twitterLink = '';
	        if (nextProps.profile.get('sa_twitter')) {
	          twitterLink = nextProps.profile.get('sa_twitter');
	        } else {
	          twitterLink = '';
	        }
	        if (sport.get('primary_offensive_position_pref') !== undefined) {
	          primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
	        } else {
	          primary_offensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('primary_defensive_position_pref') !== undefined) {
	          primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
	        } else {
	          primary_defensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('secondary_offensive_position_pref') !== undefined) {
	          secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
	        } else {
	          secondary_offensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('secondary_defensive_position_pref') !== undefined) {
	          secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
	        } else {
	          secondary_defensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('special_teams') !== undefined) {
	          special_teams = sport.get('special_teams'); //eslint-disable-line
	        } else {
	          special_teams = ''; //eslint-disable-line
	        }
	        var academic = nextProps.profile.get('academic');
	        if (academic.get('sat') !== undefined) {
	          sat = academic.get('sat');
	        }
	        if (academic.get('act') !== undefined) {
	          act = academic.get('act');
	        }
	
	        var newState = {
	          // profile
	          gender: nextProps.profile.get('gender'),
	          fullname: nextProps.profile.get('fullname'),
	          state: nextProps.profile.get('sa_state'),
	          city: nextProps.profile.get('city'),
	
	          // sports
	          height: nextProps.profile.get('height'),
	          weight: nextProps.profile.get('weight'),
	          sportName: keys[0],
	          t40: sport.get('t40'),
	          bench: sport.get('bench'),
	          squats: sport.get('squats'),
	          description: sport.get('description'),
	
	          primary_offensive_position_pref: primary_offensive_position_pref,
	          primary_defensive_position_pref: primary_defensive_position_pref,
	          secondary_offensive_position_pref: secondary_offensive_position_pref,
	          secondary_defensive_position_pref: secondary_defensive_position_pref,
	          special_teams: special_teams,
	          // school
	          school: nextProps.profile.get('school'),
	          year_of_graduation: academic.get('year_of_graduation'),
	          gpa: academic.get('gpa'),
	          sat: sat,
	          act: act,
	          profileId: nextProps.profile.get('id'),
	          video: nextProps.profile.get('video_items').toJS(),
	          profile_image: profileImage,
	          instagram: instagramLink,
	          twitter: twitterLink,
	          evaluationText: nextProps.profile.get('evaluation_text')
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'removeVideoScreen',
	    value: function removeVideoScreen() {
	      this.setState({ showFullScreenVideo: !this.state.showFullScreenVideo });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var id = this.props.match.params.id;
	      var renderIfProfile = (0, _renderIf2.default)(this.props.profile.size > 0);
	      var renderIfLoading = (0, _renderIf2.default)(this.props.requested);
	      var renderActionableItems = (0, _renderIf2.default)(this.state.showActionableItems && this.props.request.size > 0);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _AthleteById2.default.actionableContainer },
	          renderActionableItems(_react2.default.createElement(_PublicActionableItems2.default, Object.assign({}, this.props, this.state)))
	        ),
	        renderIfLoading(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement(_VideoPlayer2.default, Object.assign({
	          removeVideoScreen: this.removeVideoScreen,
	          showVideo: this.state.showFullScreenVideo
	        }, this.props)),
	        renderIfProfile(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _AthleteById2.default.profileContainer) },
	          _react2.default.createElement(_ProfileHeader2.default, Object.assign({}, this.props, this.state, {
	            actionItems: this.state.showActionableItems,
	            page: 'coachAthleteView',
	            navBarUsedBy: id !== '' ? 'coach' : 'athlete',
	            'public': 'yes'
	          })),
	          _react2.default.createElement(_ProfileData2.default, Object.assign({
	            removeVideoScreen: this.removeVideoScreen
	          }, this.props, this.state, {
	            'public': 'yes'
	          })),
	          _react2.default.createElement(_MiniFooter2.default, null)
	        ))
	      );
	    }
	  }]);
	
	  return AthleteById;
	}(_react.Component);
	
	AthleteById.propTypes = {
	  profile: _propTypes2.default.shape(),
	  match: _propTypes2.default.shape(),
	  getSAProfile: _propTypes2.default.func,
	  requested: _propTypes2.default.bool,
	  getProfileForCoach: _propTypes2.default.func,
	  request: _propTypes2.default.shape(),
	  conversationUpdated: _propTypes2.default.bool.isRequired,
	  location: _propTypes2.default.shape().isRequired
	};
	AthleteById.defaultProps = {
	  history: {},
	  profile: (0, _immutable.Map)(),
	  request: (0, _immutable.Map)(),
	  getSAProfile: function getSAProfile() {},
	  requested: false,
	  getProfileForCoach: function getProfileForCoach() {},
	  match: {
	    params: {
	      id: ''
	    }
	  }
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSAProfile: _actions.getSAProfile,
	  setCurrentVideo: _actions3.setCurrentVideo,
	  getProfileForCoach: _actions.getProfileForCoach,
	  updateConversation: _actions2.updateConversation
	})((0, _SessionReplica2.default)(AthleteById));

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSAProfile = getSAProfile;
	exports.getProfileForCoach = getProfileForCoach;
	
	var _immutable = __webpack_require__(11);
	
	var _saProfile = __webpack_require__(94);
	
	var _actionTypes = __webpack_require__(200);
	
	// use of immutablejs for various js operations to simplify our work
	
	function getSAProfile(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _saProfile.getPublicProfile)(id).then(function (data) {
	      // console.log('data', data);
	      if (data) {
	        dispatch({
	          type: _actionTypes.SUCCESSFUL,
	          profile: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getProfileForCoach(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _saProfile.getPublicProfileForCoach)(id).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.VIEWING_AS_COACH,
	          profile: (0, _immutable.fromJS)(data[1].saProfile),
	          request: (0, _immutable.fromJS)(data[0].request)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1297 */
[2534, 1295],
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ProfileBanner = __webpack_require__(198);
	
	var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _analytics = __webpack_require__(37);
	
	var _reactRouter = __webpack_require__(89);
	
	var _CoachRegistration = __webpack_require__(108);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	var _CoachRegistration3 = __webpack_require__(1571);
	
	var _CoachRegistration4 = _interopRequireDefault(_CoachRegistration3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var CoachRegister = function (_Component) {
	  _inherits(CoachRegister, _Component);
	
	  function CoachRegister(props) {
	    _classCallCheck(this, CoachRegister);
	
	    var _this = _possibleConstructorReturn(this, (CoachRegister.__proto__ || Object.getPrototypeOf(CoachRegister)).call(this, props));
	
	    _this.state = {
	      value: 'asdad'
	    };
	    return _this;
	  }
	
	  _createClass(CoachRegister, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          attributes = _props.attributes,
	          history = _props.history;
	
	      if (attributes.size > 0) {
	        var zoneinfo = attributes.get('zoneinfo');
	        if (zoneinfo !== 'COACH') {
	          history.goBack();
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var attributes = nextProps.attributes,
	          history = nextProps.history;
	
	      if (attributes.size > 0) {
	        var zoneinfo = attributes.get('zoneinfo');
	        if (zoneinfo !== 'COACH') {
	          history.goBack();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _CoachRegistration4.default.container) },
	        _react2.default.createElement(_ProfileBanner2.default, this.props),
	        _react2.default.createElement(_CoachRegistration2.default, Object.assign({}, this.props, { usedFor: 'register' })),
	        _react2.default.createElement(_MiniFooter2.default, null)
	      );
	    }
	  }]);
	
	  return CoachRegister;
	}(_react.Component);
	
	CoachRegister.propTypes = {
	  attributes: _propTypes2.default.shape.isRequired,
	  history: _propTypes2.default.shape.isRequired
	};
	exports.default = (0, _reactRouter.withRouter)((0, _Session2.default)(CoachRegister));

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachRegistration = __webpack_require__(1298);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachRegistration2.default;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _AtheleteDetails = __webpack_require__(278);
	
	var _AtheleteDetails2 = _interopRequireDefault(_AtheleteDetails);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Coach = __webpack_require__(1572);
	
	var _Coach2 = _interopRequireDefault(_Coach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var Coach = function (_Component) {
	  _inherits(Coach, _Component);
	
	  function Coach(props) {
	    _classCallCheck(this, Coach);
	
	    var _this = _possibleConstructorReturn(this, (Coach.__proto__ || Object.getPrototypeOf(Coach)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Coach, [{
	    key: 'render',
	    value: function render() {
	      var bannerData = {
	        bannerHeader: 'GET DISCOVERED NATIONALLY',
	        bannerDesc: "We're proud to be the largest athletic recruiting platform since we were  founded. The sports recruiting world has shifted, and we're always evolving.",
	        backgroundUrl: 'https://media.dev.myrecruitboard.com/Images/bgDesktop.png',
	        fullsize: false,
	        otherPages: true
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Coach2.default.atheleteContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Coach2.default.bannerAthelete) },
	          _react2.default.createElement(_Banner2.default, { data: bannerData })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Coach2.default.bannerAthelete) },
	          _react2.default.createElement(_AtheleteDetails2.default, { viewer: 'coach' })
	        )
	      );
	    }
	  }]);
	
	  return Coach;
	}(_react.Component);
	
	Coach.propTypes = {
	  data: _propTypes2.default.isRequired
	};
	
	exports.default = Coach;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Coach = __webpack_require__(1300);
	
	var _Coach2 = _interopRequireDefault(_Coach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Coach2.default;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSAProfile;
	
	var _immutable = __webpack_require__(11);
	
	var _saProfile = __webpack_require__(94);
	
	var _actionTypes = __webpack_require__(473);
	
	// use of immutablejs for various js operations to simplify our work
	
	function getSAProfile(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _saProfile.getPublicProfile)(id).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.SUCCESSFUL,
	          profile: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CoachAthleteView = __webpack_require__(472);
	
	var _CoachAthleteView2 = _interopRequireDefault(_CoachAthleteView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CoachAthleteView2.default;

/***/ },
/* 1304 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REQUESTED = exports.REQUESTED = 'COACH_PROFILE_VIEW_REQUESTED';
	var SUCCESSFUL = exports.SUCCESSFUL = 'COACH_PROFILE_VIEW_SUCESSFUL';
	var FAILED = exports.FAILED = 'COACH_PROFILE_VIEW_FAILED';

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.coachselector = exports.coachProfileView = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _SessionActionTypes = __webpack_require__(38);
	
	var _actionTypes = __webpack_require__(1304);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  profile: {},
	  error: (0, _immutable.Map)(),
	  requested: true
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _actionTypes.REQUESTED, function (state) {
	  return state.merge({
	    error: (0, _immutable.Map)()
	  });
	}), _defineProperty(_handlers, _actionTypes.SUCCESSFUL, function (state, action) {
	  return state.merge({
	    requested: false,
	    profile: action.data
	  });
	}), _defineProperty(_handlers, _actionTypes.FAILED, function (state, action) {
	  return state.merge({
	    requested: false,
	    error: action.error
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  return state.merge({
	    profile: {},
	    error: (0, _immutable.Map)(),
	    requested: false
	  });
	}), _handlers);
	
	var coachProfileView = exports.coachProfileView = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getError = function getError(state) {
	  return state.coachProfileView.get('error');
	};
	var getProfile = function getProfile(state) {
	  return state.coachProfileView.get('profile');
	};
	var IsRequested = function IsRequested(state) {
	  return state.coachProfileView.get('requested');
	};
	
	var coachselector = exports.coachselector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  profile: getProfile,
	  requested: IsRequested
	});

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _queryString = __webpack_require__(116);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _analytics = __webpack_require__(37);
	
	var _Regularexpression = __webpack_require__(65);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactModal = __webpack_require__(69);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _CoachRegistration = __webpack_require__(108);
	
	var _CoachRegistration2 = _interopRequireDefault(_CoachRegistration);
	
	var _SendGrid = __webpack_require__(465);
	
	var _SendGrid2 = _interopRequireDefault(_SendGrid);
	
	var _Contact = __webpack_require__(1573);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	// import { logoutUser } from 'components/Session/Session.actions';
	// regular expressions to validate user input
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	var modalStyle = {
	  overlay: {
	    backgroundColor: 'rgba(0, 0, 0, 0.75)'
	  },
	  content: {
	    top: '50%',
	    left: '50%',
	    right: 'auto',
	    bottom: 'auto',
	    marginRight: '-50%',
	    transform: 'translate(-50%, -50%)'
	  }
	};
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, (Contact.__proto__ || Object.getPrototypeOf(Contact)).call(this, props));
	
	    _this.writeCollegeName = function (value) {
	      _this.setState({ college: value });
	    };
	
	    _this.handleCloseModal = function () {
	      if (_this.state.renderCoachForm) {
	        _this.logOutUser();
	      } else {
	        _this.onCloseModal();
	      }
	    };
	
	    _this.state = {
	      value: '',
	      firstName: '',
	      lastName: '',
	      email: '',
	      division: '',
	      message: '',
	      questionLink: '',
	      teamPageLink: '',
	      college_id: '',
	      invalidFirstName: false,
	      invalidLastName: false,
	      invalidEmail: false,
	      invalidMessage: false,
	      open: false,
	      invalidCollege: false,
	      invalidState: false,
	      invalidCity: false,
	      renderCoachForm: false,
	      city: '',
	      state: '',
	      college: ''
	    };
	    _this.onOpenModal = _this.onOpenModal.bind(_this);
	    _this.onCloseModal = _this.onCloseModal.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleChangeFocus = _this.handleChangeFocus.bind(_this);
	    _this.sendMail = _this.sendMail.bind(_this);
	    _this.logOutUser = _this.logOutUser.bind(_this);
	    _this.getDataForCoach = _this.getDataForCoach.bind(_this);
	    return _this;
	  }
	
	  _createClass(Contact, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var location = this.props.location;
	
	      var query = _queryString2.default.parse(location.search);
	      if (query && Object.prototype.hasOwnProperty.call(query, 'coach_add_application')) {
	        if (this.props.attributes.size > 0) {
	          this.props.attributes.get('username');
	        }
	        this.setState({ renderCoachForm: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.attributes.size > 0) {
	        var fullName = nextProps.attributes.get('name');
	        var parts = fullName.split(' ');
	        var firstName = parts.shift();
	        var lastName = parts.shift() || '';
	        var newState = {
	          email: nextProps.attributes.get('email'),
	          firstName: firstName,
	          lastName: lastName
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'onOpenModal',
	    value: function onOpenModal() {
	      this.setState({ open: true });
	    }
	  }, {
	    key: 'onCloseModal',
	    value: function onCloseModal() {
	      this.setState({ open: false });
	    }
	  }, {
	    key: 'getDataForCoach',
	    value: function getDataForCoach(value) {
	      var newState = {
	        city: value.city,
	        division: value.division,
	        questionLink: value.questionLink,
	        state: value.state,
	        teamPageLink: value.teamPageUrl,
	        college: value.value,
	        college_id: value.id
	      };
	      this.setState(newState);
	    }
	  }, {
	    key: 'logOutUser',
	    value: function logOutUser() {
	      this.onCloseModal();
	      this.props.logoutUser();
	      this.props.history.push('/');
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value.target.value)));
	    }
	  }, {
	    key: 'handleChangeFocus',
	    value: function handleChangeFocus(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, false)));
	    }
	  }, {
	    key: 'sendMail',
	    value: function sendMail() {
	      var _state = this.state,
	          firstName = _state.firstName,
	          lastName = _state.lastName,
	          email = _state.email,
	          message = _state.message,
	          college = _state.college,
	          city = _state.city,
	          division = _state.division,
	          state = _state.state,
	          renderCoachForm = _state.renderCoachForm,
	          college_id = _state.college_id,
	          questionLink = _state.questionLink,
	          teamPageLink = _state.teamPageLink;
	
	      var updated = {};
	      var validFirstName = false;
	      var validLastName = false;
	      var validEmail = false;
	      var validMessage = false;
	      var validCollege = true;
	      var validCity = true;
	      var validState = true;
	
	      var enteredName = _Regularexpression.regExForName.test(firstName);
	      if (firstName !== '' && enteredName) {
	        validFirstName = true;
	      } else {
	        updated.invalidFirstName = true;
	      }
	
	      var enteredLastName = _Regularexpression.regExForName.test(lastName);
	      if (lastName === '') {
	        validLastName = true;
	      } else if (enteredLastName) {
	        updated.invalidLastName = false;
	        validLastName = true;
	      } else {
	        updated.invalidLastName = true;
	      }
	
	      var enteredEmail = _Regularexpression.regExForEmail.test(email);
	      if (email !== '' && enteredEmail) {
	        validEmail = true;
	      } else {
	        updated.invalidEmail = true;
	      }
	
	      if (message !== '') {
	        validMessage = true;
	      } else if (this.state.renderCoachForm) {
	        validMessage = true;
	      } else {
	        updated.invalidMessage = true;
	      }
	
	      if (college === '' && renderCoachForm) {
	        validCollege = false;
	        updated.invalidCollege = true;
	      }
	
	      if (city === '' && renderCoachForm) {
	        validCity = false;
	        updated.invalidCity = true;
	      }
	      if (state === '' && renderCoachForm) {
	        validState = false;
	        updated.invalidState = true;
	      }
	      if (validFirstName && validLastName && validEmail && validMessage && validCollege && validCity && validState) {
	        var payload = {};
	        if (!renderCoachForm) {
	          payload = Object.assign(payload, {
	            firstname: firstName,
	            lastname: lastName,
	            email: email,
	            message: message
	          });
	        }
	        if (this.state.renderCoachForm) {
	          payload = Object.assign(payload, {
	            fullname: firstName + ' ' + lastName,
	            email: email,
	            college: college,
	            city: city,
	            state: state,
	            sport: 'FOOTBALL'
	          });
	          /* eslint-disable */
	          if (college_id !== '') {
	            payload['college_id'] = college_id;
	            payload['division'] = division;
	            payload['question_link'] = questionLink;
	            payload['team_page_link'] = teamPageLink;
	          }
	          /* eslint-disable */
	        }
	        this.setState({ firstName: '', lastName: '', email: '', message: '', college: '', state: '', city: '' });
	        console.log(payload, renderCoachForm);
	        this.props.sendContactForm(payload, renderCoachForm);
	        this.onOpenModal();
	      } else {
	        this.setState(updated);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          invalidFirstName = _state2.invalidFirstName,
	          invalidLastName = _state2.invalidLastName,
	          invalidEmail = _state2.invalidEmail,
	          invalidMessage = _state2.invalidMessage,
	          open = _state2.open,
	          invalidCollege = _state2.invalidCollege,
	          invalidCity = _state2.invalidCity,
	          invalidState = _state2.invalidState;
	
	      var renderCoachForm = (0, _renderIf2.default)(this.state.renderCoachForm);
	      var renderMessageBox = (0, _renderIf2.default)(!this.state.renderCoachForm);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Contact2.default.container) },
	        _react2.default.createElement(
	          _reactModal2.default,
	          { style: modalStyle, isOpen: open },
	          'We will get back to you soon. Keep Exploring!',
	          _react2.default.createElement(
	            'button',
	            { className: _Contact2.default.okbuttonModal, onClick: this.handleCloseModal },
	            'OK'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Contact2.default.navbarContainer) },
	          _react2.default.createElement(_NavOnScroll2.default, this.props)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Contact2.default.contactContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s6', _Contact2.default.address) },
	            _react2.default.createElement(
	              'div',
	              { className: _Contact2.default.gotQuestionOrQur },
	              'Got Questions or Queries?',
	              _react2.default.createElement('br', null),
	              'Type your needed request and we\u2019ll ',
	              _react2.default.createElement('br', null),
	              ' fnd you a solution.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Contact2.default.header },
	              'MyRecruitBoard'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Contact2.default.headerText },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Email: info@myrecruitboard.com'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _Contact2.default.contactInSmall) },
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Contact2.default.removePadding) },
	              _react2.default.createElement(
	                'div',
	                { className: _Contact2.default.bigHeader },
	                'How can we assist you?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Contact2.default.formHeader },
	                'Fill out this form to contact us if you have any further questions'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Contact2.default.formContainer) },
	              _react2.default.createElement(
	                'div',
	                { className: invalidFirstName === false ? (0, _classnames2.default)('col s6', _Contact2.default.halfInput) : (0, _classnames2.default)('col s6', _Contact2.default.halfInputOnError) },
	                _react2.default.createElement('input', {
	                  value: this.state.firstName,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('firstName', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.handleChangeFocus('invalidFirstName');
	                  },
	                  placeholder: 'FirstName'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: invalidLastName === false ? (0, _classnames2.default)('col s6', _Contact2.default.secondHalfInput) : (0, _classnames2.default)('col s6', _Contact2.default.secondHalfInputOnError) },
	                _react2.default.createElement('input', {
	                  value: this.state.lastName,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('lastName', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.handleChangeFocus('invalidLastName');
	                  },
	                  placeholder: 'LastName'
	                })
	              ),
	              renderMessageBox(_react2.default.createElement(
	                'div',
	                { className: invalidEmail === false ? (0, _classnames2.default)('col s12', _Contact2.default.fullInput) : (0, _classnames2.default)('col s12', _Contact2.default.fullInputOnError) },
	                _react2.default.createElement('input', {
	                  value: this.state.email,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('email', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.handleChangeFocus('invalidEmail');
	                  },
	                  placeholder: 'Email'
	                })
	              )),
	              renderCoachForm(_react2.default.createElement(
	                'div',
	                { className: invalidEmail === false ? (0, _classnames2.default)('col s12', _Contact2.default.fullInput) : (0, _classnames2.default)('col s12', _Contact2.default.fullInputOnError) },
	                _react2.default.createElement('input', {
	                  value: this.state.email,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('email', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.handleChangeFocus('invalidEmail');
	                  },
	                  placeholder: 'Email',
	                  disabled: 'disabled'
	                })
	              )),
	              renderCoachForm(_react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: invalidCollege === false ? (0, _classnames2.default)('col s12', _Contact2.default.fullInput) : (0, _classnames2.default)('col s12', _Contact2.default.fullInputOnError) },
	                  _react2.default.createElement(_CoachRegistration2.default, {
	                    usedFor: 'contact',
	                    getDataForCoach: this.getDataForCoach,
	                    writeCollegeName: this.writeCollegeName
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: invalidState === false ? (0, _classnames2.default)('col s6', _Contact2.default.halfInput) : (0, _classnames2.default)('col s6', _Contact2.default.halfInputOnError) },
	                  _react2.default.createElement('input', {
	                    value: this.state.state,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('state', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.handleChangeFocus('invaidState');
	                    },
	                    placeholder: 'City'
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: invalidCity === false ? (0, _classnames2.default)('col s6', _Contact2.default.secondHalfInput) : (0, _classnames2.default)('col s6', _Contact2.default.secondHalfInputOnError) },
	                  _react2.default.createElement('input', {
	                    value: this.state.city,
	                    onChange: function onChange(val) {
	                      return _this2.handleChange('city', val);
	                    },
	                    onFocus: function onFocus() {
	                      return _this2.handleChangeFocus('invalidCity');
	                    },
	                    placeholder: 'State'
	                  })
	                )
	              )),
	              renderMessageBox(_react2.default.createElement(
	                'div',
	                { className: invalidMessage === false ? (0, _classnames2.default)('col s12', _Contact2.default.messageContainer) : (0, _classnames2.default)('col s12', _Contact2.default.messageContainerOnError) },
	                _react2.default.createElement('textarea', {
	                  value: this.state.message,
	                  onChange: function onChange(val) {
	                    return _this2.handleChange('message', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.handleChangeFocus('invalidMessage');
	                  },
	                  placeholder: 'Message'
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Contact2.default.buttonContainer) },
	              _react2.default.createElement(
	                'button',
	                { className: _Contact2.default.submitButton, onClick: this.sendMail },
	                'Submit'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)('col s12', _Contact2.default.addressInSmall) },
	              _react2.default.createElement(
	                'div',
	                { className: _Contact2.default.gotQuestionOrQur },
	                'Got Questions or Queries?',
	                _react2.default.createElement('br', null),
	                'Type your needed request and we\u2019ll fnd you a solution.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Contact2.default.header },
	                'MyRecruitBoard'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _Contact2.default.headerText },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Email: info@myrecruitboard.com'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Contact2.default.footerContainer) },
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Contact;
	}(_react.Component);
	
	Contact.propTypes = {
	  sendContactForm: _propTypes2.default.func.isRequired,
	  location: _propTypes2.default.shape().isRequired,
	  attributes: _propTypes2.default.shape().isRequired,
	  logoutUser: _propTypes2.default.func.isRequired,
	  history: _propTypes2.default.shape()
	};
	Contact.defaultProps = {
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = (0, _SessionReplica2.default)((0, _SendGrid2.default)(Contact));

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Contact = __webpack_require__(1306);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Contact2.default;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CoachHeader = __webpack_require__(1109);
	
	var _CoachHeader2 = _interopRequireDefault(_CoachHeader);
	
	var _CoachDashboardView = __webpack_require__(1107);
	
	var _CoachDashboardView2 = _interopRequireDefault(_CoachDashboardView);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _analytics = __webpack_require__(37);
	
	var _reactRedux = __webpack_require__(27);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _routeNames = __webpack_require__(55);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _immutable = __webpack_require__(11);
	
	var _redux = __webpack_require__(476);
	
	var _actions = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	// use of immutablejs for various js operations to simplify our work
	
	
	var DashboardCoach = function (_Component) {
	  _inherits(DashboardCoach, _Component);
	
	  function DashboardCoach(props) {
	    _classCallCheck(this, DashboardCoach);
	
	    var _this = _possibleConstructorReturn(this, (DashboardCoach.__proto__ || Object.getPrototypeOf(DashboardCoach)).call(this, props));
	
	    _this.state = {
	      value: '',
	      coach_id: ''
	    };
	    _this.tabListener = _this.tabListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(DashboardCoach, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          attributes = _props.attributes,
	          history = _props.history;
	
	      if (attributes.size > 0) {
	        var zoneinfo = attributes.get('zoneinfo');
	        if (!(zoneinfo === 'COACH' || zoneinfo === 'ADMIN')) {
	          history.goBack();
	        }
	        if (attributes.get('profile') === 'PENDING') {
	          history.push(_routeNames.CoachRegister);
	        } else {
	          var id = attributes.get('profile');
	          this.props.getCoachProfile(id);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.attributes.get('profile') === 'PENDING') {
	        this.props.history.push(_routeNames.CoachRegister);
	      }
	      if (!(0, _immutable.is)(nextProps.attributes, this.props.attributes)) {
	        if (nextProps.attributes.size > 0) {
	          var id = nextProps.attributes.get('profile');
	          this.props.getCoachProfile(id);
	        }
	      }
	      if ((0, _immutable.is)(this.props.profile, nextProps.profile) && nextProps.profile.size > 0) {
	        var questionlinkFromProfile = '';
	        if (nextProps.profile.get('question_link') !== undefined) {
	          questionlinkFromProfile = nextProps.profile.get('question_link');
	        } else {
	          questionlinkFromProfile = '';
	        }
	        var newState = {
	          name: nextProps.profile.get('name'),
	          city: nextProps.profile.get('city'),
	          questionLink: questionlinkFromProfile,
	          college: nextProps.profile.get('college'),
	          sport: nextProps.profile.get('sport'),
	          state: nextProps.profile.get('state'),
	          teamPageLink: nextProps.profile.get('team_page_link')
	        };
	        this.setState(newState);
	      }
	      if (nextProps.profile.size > 0) {
	        var _newState = {
	          name: nextProps.profile.get('name'),
	          city: nextProps.profile.get('city'),
	          questionLink: nextProps.profile.get('question_link'),
	          college: nextProps.profile.get('college'),
	          sport: nextProps.profile.get('sport'),
	          state: nextProps.profile.get('state'),
	          teamPageLink: nextProps.profile.get('team_page_link'),
	          coach_id: nextProps.profile.get('coach_id')
	        };
	        this.setState(_newState);
	      }
	    }
	  }, {
	    key: 'tabListener',
	    value: function tabListener(tab) {
	      this.setState({ tab: tab });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderLoadr = (0, _renderIf2.default)(this.props.isLoading);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderLoadr(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement(_CoachHeader2.default, Object.assign({ tabListener: this.tabListener }, this.props, this.state, { usedFor: 'coachDashboard' })),
	        _react2.default.createElement(_CoachDashboardView2.default, Object.assign({}, this.props, this.state)),
	        ',',
	        _react2.default.createElement(_MiniFooter2.default, null)
	      );
	    }
	  }]);
	
	  return DashboardCoach;
	}(_react.Component);
	
	DashboardCoach.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  getCoachProfile: _propTypes2.default.func,
	  profile: _propTypes2.default.shape(),
	  history: _propTypes2.default.shape(),
	  isLoading: _propTypes2.default.bool.isRequired
	};
	DashboardCoach.defaultProps = {
	  attributes: {},
	  getCoachProfile: function getCoachProfile() {},
	  profile: {},
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = (0, _reactRedux.connect)(_redux.coachDashboardSelector, { getAllRequests: _actions.getAllRequests,
	  updateConversation: _actions.updateConversation,
	  getCoachProfile: _actions.getCoachProfile,
	  getDivisionStudents: _actions.getDivisionStudents,
	  getFilteredDivisionStudents: _actions.getFilteredDivisionStudents
	})((0, _Session2.default)(DashboardCoach));

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DashboardCoach = __webpack_require__(1308);
	
	var _DashboardCoach2 = _interopRequireDefault(_DashboardCoach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DashboardCoach2.default;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _routeNames = __webpack_require__(55);
	
	var _reactRedux = __webpack_require__(27);
	
	var _analytics = __webpack_require__(37);
	
	var _immutable = __webpack_require__(11);
	
	var _DashBoardHeader = __webpack_require__(451);
	
	var _DashBoardHeader2 = _interopRequireDefault(_DashBoardHeader);
	
	var _DashboardView = __webpack_require__(1131);
	
	var _DashboardView2 = _interopRequireDefault(_DashboardView);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _TrialNotification = __webpack_require__(468);
	
	var _TrialNotification2 = _interopRequireDefault(_TrialNotification);
	
	var _actions = __webpack_require__(110);
	
	var _redux = __webpack_require__(111);
	
	var _Dashboard = __webpack_require__(1574);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to connect to redux store from containers redux.js or any other redux store
	// use of immutablejs for various js operations to simplify our work
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.state = {
	      value: '',
	      profileId: null,
	      tab: 0
	    };
	    _this.tabListener = _this.tabListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          attributes = _props.attributes,
	          history = _props.history;
	
	      if (attributes.size > 0) {
	        var zoneinfo = attributes.get('zoneinfo');
	        if (!(zoneinfo === 'STUDENT' || zoneinfo === 'ADMIN')) {
	          history.goBack();
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	
	      if (this.props.profile && this.props.profile.size > 0) {
	        var saSports = this.props.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        var positions = {};
	        var academic = this.props.profile.get('academic');
	        var primary_offensive_position_pref = ''; //eslint-disable-line
	        var primary_defensive_position_pref = ''; //eslint-disable-line
	        var secondary_offensive_position_pref = ''; //eslint-disable-line
	        var secondary_defensive_position_pref = ''; //eslint-disable-line
	        var special_teams = ''; //eslint-disable-line
	        if (sport.get('primary_offensive_position_pref') !== undefined) {
	          primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
	          if (primary_offensive_position_pref === 'QBDT' || primary_offensive_position_pref === 'QBPS') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'QB'; //eslint-disable-line
	          }
	          if (primary_offensive_position_pref === 'SR' || primary_offensive_position_pref === 'WR') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'WR'; //eslint-disable-line
	          }
	          if (primary_offensive_position_pref === 'RB' || primary_offensive_position_pref === 'FB' || primary_offensive_position_pref === 'HB') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'RB'; //eslint-disable-line
	          }
	          if (primary_offensive_position_pref === 'OG' || primary_offensive_position_pref === 'OT' || primary_offensive_position_pref === 'C') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'OL'; //eslint-disable-line
	          }
	          positions['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('primary_defensive_position_pref') !== undefined) {
	          primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
	          if (primary_defensive_position_pref === 'ML' || primary_defensive_position_pref === 'OL') {
	            //eslint-disable-line
	            primary_defensive_position_pref = 'LB'; //eslint-disable-line
	          }
	          if (primary_defensive_position_pref === 'SS' || primary_defensive_position_pref === 'FS') {
	            //eslint-disable-line
	            primary_defensive_position_pref = 'S'; //eslint-disable-line
	          }
	          positions['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('secondary_offensive_position_pref') !== undefined) {
	          secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
	          if (secondary_offensive_position_pref === 'QBDT' || secondary_offensive_position_pref === 'QBPS') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'QB'; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref === 'SR' || secondary_offensive_position_pref === 'WR') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'WR'; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref === 'RB' || secondary_offensive_position_pref === 'FB' || secondary_offensive_position_pref === 'HB') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'RB'; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref === 'OG' || secondary_offensive_position_pref === 'OT' || secondary_offensive_position_pref === 'C') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'OL'; //eslint-disable-line
	          }
	          positions['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('secondary_defensive_position_pref') !== undefined) {
	          secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
	          if (secondary_defensive_position_pref === 'ML' || secondary_defensive_position_pref === 'OL') {
	            //eslint-disable-line
	            secondary_defensive_position_pref = 'LB'; //eslint-disable-line
	          }
	          if (secondary_defensive_position_pref === 'SS' || secondary_defensive_position_pref === 'FS') {
	            //eslint-disable-line
	            secondary_defensive_position_pref = 'S'; //eslint-disable-line
	          }
	          positions['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('special_teams') !== undefined) {
	          special_teams = sport.get('special_teams'); //eslint-disable-line
	          positions['special_teams'] = special_teams; //eslint-disable-line
	        }
	        var newState = {
	          // profile
	          gender: this.props.profile.get('gender'),
	          fullname: this.props.profile.get('fullname'),
	          state: this.props.profile.get('sa_state'),
	          city: this.props.profile.get('city'),
	
	          // sports
	          height: this.props.profile.get('height'),
	          weight: this.props.profile.get('weight'),
	          sportName: keys[0],
	          t40: sport.get('t40'),
	          bench: sport.get('bench'),
	          squats: sport.get('squats'),
	          description: sport.get('description'),
	          position_pref: positions,
	          sa_image: this.props.profile.get('profile_image'),
	          sa_email: this.props.profile.get('sa_email'),
	          // school
	          school: this.props.profile.get('school'),
	          year_of_graduation: academic.get('year_of_graduation'),
	          gpa: academic.get('gpa'),
	          sat: academic.get('sat'),
	          act: academic.get('act'),
	
	          profileId: this.props.profile.get('id'),
	          currentDivision: this.props.profile.get('current_division'),
	          overrideDivision: this.props.profile.get('override_division')
	        };
	        this.setState(newState); //eslint-disable-line
	      } else if (this.props.attributes && this.props.attributes.size > 0) {
	        var saProfile = this.props.attributes.get('profile');
	        if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
	          this.props.getSAProfile(saProfile);
	        } else {
	          this.props.history.push(_routeNames.RegisterAthlete);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props2 = this.props,
	          attributes = _props2.attributes,
	          profile = _props2.profile;
	
	      if (!this.props.requested && nextProps.attributes && !(0, _immutable.is)(nextProps.attributes, attributes)) {
	        var saProfile = nextProps.attributes.get('profile');
	        if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
	          this.props.getSAProfile(saProfile);
	        } else {
	          this.props.history.push(_routeNames.RegisterAthlete);
	        }
	      } else if (nextProps.profile.size > 0 && !(0, _immutable.is)(nextProps.profile, profile)) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        var academic = nextProps.profile.get('academic');
	        var positions = {};
	        var primary_offensive_position_pref = ''; //eslint-disable-line
	        var primary_defensive_position_pref = ''; //eslint-disable-line
	        var secondary_offensive_position_pref = ''; //eslint-disable-line
	        var secondary_defensive_position_pref = ''; //eslint-disable-line
	        var special_teams = ''; //eslint-disable-line
	        if (sport.get('primary_offensive_position_pref') !== undefined) {
	          primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
	          if (primary_offensive_position_pref === 'QBDT' || primary_offensive_position_pref === 'QBPS') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'QB'; //eslint-disable-line
	          }
	          if (primary_offensive_position_pref === 'SR' || primary_offensive_position_pref === 'WR') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'WR'; //eslint-disable-line
	          }
	          if (primary_offensive_position_pref === 'RB' || primary_offensive_position_pref === 'FB' || primary_offensive_position_pref === 'HB') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'RB'; //eslint-disable-line
	          }
	          if (primary_offensive_position_pref === 'OG' || primary_offensive_position_pref === 'OT' || primary_offensive_position_pref === 'C') {
	            //eslint-disable-line
	            primary_offensive_position_pref = 'OL'; //eslint-disable-line
	          }
	          positions['primary_offensive_position_pref'] = primary_offensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('primary_defensive_position_pref') !== undefined) {
	          primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
	          if (primary_defensive_position_pref === 'ML' || primary_defensive_position_pref === 'OL') {
	            //eslint-disable-line
	            primary_defensive_position_pref = 'LB'; //eslint-disable-line
	          }
	          if (primary_defensive_position_pref === 'SS' || primary_defensive_position_pref === 'FS') {
	            //eslint-disable-line
	            primary_defensive_position_pref = 'S'; //eslint-disable-line
	          }
	          positions['primary_defensive_position_pref'] = primary_defensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('secondary_offensive_position_pref') !== undefined) {
	          secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
	          if (secondary_offensive_position_pref === 'QBDT' || secondary_offensive_position_pref === 'QBPS') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'QB'; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref === 'SR' || secondary_offensive_position_pref === 'WR') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'WR'; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref === 'RB' || secondary_offensive_position_pref === 'FB' || secondary_offensive_position_pref === 'HB') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'RB'; //eslint-disable-line
	          }
	          if (secondary_offensive_position_pref === 'OG' || secondary_offensive_position_pref === 'OT' || secondary_offensive_position_pref === 'C') {
	            //eslint-disable-line
	            secondary_offensive_position_pref = 'OL'; //eslint-disable-line
	          }
	          positions['secondary_offensive_position_pref'] = secondary_offensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('secondary_defensive_position_pref') !== undefined) {
	          secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
	          if (secondary_defensive_position_pref === 'ML' || secondary_defensive_position_pref === 'OL') {
	            //eslint-disable-line
	            secondary_defensive_position_pref = 'LB'; //eslint-disable-line
	          }
	          if (secondary_defensive_position_pref === 'SS' || secondary_defensive_position_pref === 'FS') {
	            //eslint-disable-line
	            secondary_defensive_position_pref = 'S'; //eslint-disable-line
	          }
	          positions['secondary_defensive_position_pref'] = secondary_defensive_position_pref; //eslint-disable-line
	        }
	        if (sport.get('special_teams') !== undefined) {
	          special_teams = sport.get('special_teams'); //eslint-disable-line
	          positions['special_teams'] = special_teams; //eslint-disable-line
	        }
	        var questionAireLink = '';
	        if (nextProps.profile.get('football_questionaire_page') !== undefined) {
	          questionAireLink = nextProps.profile.get('football_questionaire_page');
	        }
	        var footballTeamPage = '';
	        if (nextProps.profile.get('football_questionaire_page') !== undefined) {
	          footballTeamPage = nextProps.profile.get('football_team_page');
	        }
	        var newState = {
	          // profile
	          gender: nextProps.profile.get('gender'),
	          fullname: nextProps.profile.get('fullname'),
	          state: nextProps.profile.get('sa_state'),
	          city: nextProps.profile.get('city'),
	
	          // sports
	          height: nextProps.profile.get('height'),
	          weight: nextProps.profile.get('weight'),
	          sportName: keys[0],
	          t40: sport.get('t40'),
	          bench: sport.get('bench'),
	          squats: sport.get('squats'),
	          description: sport.get('description'),
	          position_pref: positions,
	          sa_image: nextProps.profile.get('profile_image'),
	          sa_email: nextProps.profile.get('sa_email'),
	
	          // school
	          school: nextProps.profile.get('school'),
	          year_of_graduation: academic.get('year_of_graduation'),
	          gpa: academic.get('gpa'),
	          sat: academic.get('sat'),
	          act: academic.get('act'),
	
	          profileId: nextProps.profile.get('id'),
	          video: nextProps.profile.get('video_items').toJS(),
	          wishList: nextProps.profile.get('sa_wishlist'),
	          ignoreList: nextProps.profile.get('sa_ignorelist'),
	          contactedList: nextProps.profile.get('sa_contactedlist'),
	          fillQList: nextProps.profile.get('sa_fill_questionaire_list'),
	          inviteToCampList: nextProps.profile.get('sa_invited_to_camp_list'),
	          footballTeamPage: footballTeamPage,
	          questionAireLink: questionAireLink,
	          currentDivision: nextProps.profile.get('current_division'),
	          overrideDivision: nextProps.profile.get('override_division')
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'tabListener',
	    value: function tabListener(tab) {
	      this.setState({ tab: tab });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var onTrial = false;
	      if (this.props.profile !== undefined) {
	        if (this.props.profile.get('trialEndDate')) {
	          onTrial = (0, _moment2.default)().isBefore(this.props.profile.get('trialEndDate'));
	        }
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Dashboard2.default.dashboardContainer) },
	        !this.props.subscribed && onTrial && _react2.default.createElement(_TrialNotification2.default, { trialEndDate: this.props.profile.get('trialEndDate') }),
	        _react2.default.createElement(_DashBoardHeader2.default, Object.assign({ tabListener: this.tabListener }, this.props, { usedFor: 'athleteDashboard' })),
	        _react2.default.createElement(_DashboardView2.default, Object.assign({}, this.props, this.state)),
	        _react2.default.createElement(_MiniFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	Dashboard.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  profile: _propTypes2.default.shape(),
	  history: _propTypes2.default.shape(),
	  getSAProfile: _propTypes2.default.func,
	  requested: _propTypes2.default.bool,
	  subscribed: _propTypes2.default.bool
	};
	Dashboard.defaultProps = {
	  attributes: {},
	  history: {},
	  profile: (0, _immutable.Map)(),
	  getSAProfile: function getSAProfile() {},
	  requested: false,
	  subscribed: false
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSAProfile: _actions.getSAProfile })((0, _Session2.default)(Dashboard));

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dashboard = __webpack_require__(1310);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dashboard2.default;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forgot = forgot;
	exports.setPassword = setPassword;
	
	var _immutable = __webpack_require__(11);
	
	var _session = __webpack_require__(73);
	
	var service = _interopRequireWildcard(_session);
	
	var _localStorage = __webpack_require__(56);
	
	var _ForgotPasswordActionTypes = __webpack_require__(478);
	
	var _LoginActionTypes = __webpack_require__(130);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// use of immutablejs for various js operations to simplify our work
	function forgot(username) {
	  // eslint-disable-line
	  var secondAttemptUserName = ''; // for second attempt login because of case sensitive username in userpools
	  var count = 0;
	
	  for (var i = 0; i < username.length; i++) {
	    // eslint-disable-line
	    if (/[A-Z]/.test(username.charAt(i))) {
	      count++; // eslint-disable-line
	    }
	  }
	
	  if (count === 0) {
	    secondAttemptUserName = username.charAt(0).toUpperCase() + username.slice(1);
	  } else if (count > 0) {
	    secondAttemptUserName = username.charAt(0).toLowerCase() + username.slice(1);
	  }
	  return function (dispatch) {
	    dispatch({
	      type: _ForgotPasswordActionTypes.REQUESTED
	    });
	    service.forgotPassword(username, function (err) {
	      if (err) {
	        service.forgotPassword(secondAttemptUserName, function (error) {
	          if (error) {
	            dispatch({
	              type: _ForgotPasswordActionTypes.FAILED,
	              error: err
	            });
	          } else {
	            dispatch({
	              type: _ForgotPasswordActionTypes.SUCCESSFUL
	            });
	          }
	        });
	      } else {
	        dispatch({
	          type: _ForgotPasswordActionTypes.SUCCESSFUL
	        });
	      }
	    });
	  };
	}
	
	function setPassword(userName, code, password) {
	  // eslint-disable-line
	  var secondAttemptUserName = ''; // for second attempt login because of case sensitive username in userpools
	  var count = 0;
	
	  for (var i = 0; i < userName.length; i++) {
	    // eslint-disable-line
	    if (/[A-Z]/.test(userName.charAt(i))) {
	      count++; // eslint-disable-line
	    }
	  }
	
	  if (count === 0) {
	    secondAttemptUserName = userName.charAt(0).toUpperCase() + userName.slice(1);
	  } else if (count > 0) {
	    secondAttemptUserName = userName.charAt(0).toLowerCase() + userName.slice(1);
	  }
	  return function (dispatch) {
	    dispatch({
	      type: _ForgotPasswordActionTypes.REQUESTED
	    });
	    service.setPasswordByCode(userName, password, code, function (err) {
	      if (err) {
	        service.setPasswordByCode(secondAttemptUserName, password, code, function (Error) {
	          if (Error) {
	            dispatch({
	              type: _ForgotPasswordActionTypes.FAILED,
	              error: Error
	            });
	          } else {
	            service.authenticateUser(secondAttemptUserName, password, function (errors, result) {
	              if (errors) {
	                dispatch({
	                  type: _LoginActionTypes.LOGIN_FAILED,
	                  error: {
	                    code: errors.code,
	                    message: errors.message
	                  }
	                });
	              } else {
	                // Storing token in to local storage
	                var token = result.session.idToken.jwtToken;
	                (0, _localStorage.setItem)('isLoggedIn', true);
	                (0, _localStorage.setItem)('token', token);
	                // end of dangerous code
	                dispatch({
	                  type: _LoginActionTypes.LOGIN_SUCCESSFUL,
	                  session: (0, _immutable.fromJS)(result.session),
	                  user: (0, _immutable.fromJS)(result.user),
	                  attributes: (0, _immutable.fromJS)(result.attributes),
	                  token: token
	                });
	              }
	              dispatch({
	                type: _ForgotPasswordActionTypes.RESET_PASSWORD_SUCCESSFUL
	              });
	            });
	          }
	        });
	      } else {
	        service.authenticateUser(userName, password, function (error, result) {
	          if (err) {
	            dispatch({
	              type: _LoginActionTypes.LOGIN_FAILED,
	              error: {
	                code: err.code,
	                message: err.message
	              }
	            });
	          } else {
	            // Storing token in to local storage
	            var token = result.session.idToken.jwtToken;
	            (0, _localStorage.setItem)('isLoggedIn', true);
	            (0, _localStorage.setItem)('token', token);
	            // end of dangerous code
	            dispatch({
	              type: _LoginActionTypes.LOGIN_SUCCESSFUL,
	              session: (0, _immutable.fromJS)(result.session),
	              user: (0, _immutable.fromJS)(result.user),
	              attributes: (0, _immutable.fromJS)(result.attributes),
	              token: token
	            });
	          }
	          dispatch({
	            type: _ForgotPasswordActionTypes.RESET_PASSWORD_SUCCESSFUL
	          });
	        });
	      }
	    });
	  };
	}

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(89);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _queryString = __webpack_require__(116);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(37);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Details = __webpack_require__(196);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _TextField = __webpack_require__(160);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _CustomButton = __webpack_require__(48);
	
	var _CustomButton2 = _interopRequireDefault(_CustomButton);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _routeNames = __webpack_require__(55);
	
	var _ForgotPassword = __webpack_require__(1312);
	
	var _ForgotPassword2 = __webpack_require__(477);
	
	var _ForgotPassword3 = __webpack_require__(1575);
	
	var _ForgotPassword4 = _interopRequireDefault(_ForgotPassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to connect to redux store from containers redux.js or any other redux store
	// to use conditional rendering based on values that is provided to component
	// to use global class name eg. classes from grid.css in public folder
	// to show loder on screen whenever there is a api call or operations in component
	
	
	// to import local scss fle
	
	var ForgotPassword = function (_Component) {
	  _inherits(ForgotPassword, _Component);
	
	  function ForgotPassword(props) {
	    _classCallCheck(this, ForgotPassword);
	
	    var _this = _possibleConstructorReturn(this, (ForgotPassword.__proto__ || Object.getPrototypeOf(ForgotPassword)).call(this, props));
	
	    _this.setPassword = function () {
	      var updated = {};
	      // validations for new password
	      var validUserName = false;
	      if (_this.state.usernameForReset !== '') {
	        validUserName = true;
	      } else {
	        updated.userNameErrorMessage = 'Enter a valid user name.';
	      }
	      var validNewPassword = false;
	      if (_this.state.newPassword !== '' && _this.state.newPassword.length >= 6) {
	        validNewPassword = true;
	      } else if (_this.state.newPassword.length <= 6) {
	        updated.newPasswordErrorMessage = 'Length of password should be more than 6.';
	      } else {
	        updated.newPasswordErrorMessage = 'New Password can not be blank.';
	      }
	
	      var validConfirmPassword = false;
	      if (_this.state.confirmPassword !== '') {
	        validConfirmPassword = true;
	      } else {
	        updated.confirmPasswordErrorMessage = 'Confirm Password can not be blank.';
	      }
	
	      // validation for if password matches
	      if (validNewPassword && validConfirmPassword && validUserName && _this.state.newPassword === _this.state.confirmPassword) {
	        _this.props.setPassword(_this.state.usernameForReset, _this.state.query.code, _this.state.newPassword);
	      } else if (_this.state.newPassword !== _this.state.confirmPassword) {
	        updated.confirmPasswordErrorMessage = 'Confirm password did not match.';
	      }
	
	      _this.setState(updated);
	    };
	
	    _this.emailHandler = function (username) {
	      _this.setState({ username: username });
	    };
	
	    _this.passwordHandler = function (password) {
	      _this.setState({ password: password });
	    };
	
	    _this.submit = function () {
	      _this.props.forgot(_this.state.username);
	    };
	
	    _this.identifyEnter = function (e) {
	      var username = _this.state.username;
	
	      var code = e.keyCode ? e.keyCode : e.which;
	      if (code === 13) {
	        // Enter keycode
	        if (username !== '') {
	          _this.props.forgot(username);
	        } else if (username === '' && _this.props.location.search === '') {
	          _this.setState({ userNameErrorMessage: 'Enter valid username' });
	        } else {
	          _this.setPassword();
	        }
	      }
	    };
	
	    _this.state = {
	      username: '',
	      setPassword: false,
	      password: '',
	      usernameForReset: '',
	      newPassword: '',
	      userName: '',
	      userNameErrorMessage: '',
	      newPasswordErrorMessage: '',
	      confirmPasswordErrorMessage: '',
	      passwordDidNotMatchErrorMessage: '',
	      confirmPassword: '',
	      query: {}
	    };
	    _this.emailHandler = _this.emailHandler.bind(_this);
	    _this.submit = _this.submit.bind(_this);
	    _this.passwordHandler = _this.passwordHandler.bind(_this);
	    _this.setPassword = _this.setPassword.bind(_this);
	    _this.handleNewPassword = _this.handleNewPassword.bind(_this);
	    _this.removeErrorMessage = _this.removeErrorMessage.bind(_this);
	    return _this;
	  }
	
	  _createClass(ForgotPassword, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var location = this.props.location;
	
	      var query = _queryString2.default.parse(location.search);
	      if (query && Object.prototype.hasOwnProperty.call(query, 'code')) {
	        this.setState({ query: query });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.resetPasswordsuccess !== this.props.resetPasswordsuccess) {
	        this.props.history.push(_routeNames.ViewAthlete);
	      }
	    }
	  }, {
	    key: 'handleNewPassword',
	    value: function handleNewPassword(name, value) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, value)));
	    }
	  }, {
	    key: 'removeErrorMessage',
	    value: function removeErrorMessage(name) {
	      this.setState(Object.assign({}, this.state, _defineProperty({}, name, '')));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var generateNewPassword = false;
	      if (this.props.location.search !== '') {
	        generateNewPassword = true;
	      }
	      var renderIfNotSetPassword = (0, _renderIf2.default)(!this.state.setPassword && !this.props.success && !generateNewPassword);
	      var renderLoading = (0, _renderIf2.default)(this.props.isLoading);
	      var renderIfForgotSuccess = (0, _renderIf2.default)(this.props.success && !generateNewPassword);
	      var renderIfNotSuccess = (0, _renderIf2.default)(!this.props.success && !generateNewPassword);
	      var renderUpdatePassword = (0, _renderIf2.default)(generateNewPassword);
	
	      var joinUsData = {
	        bannerHeader: 'GET THE MORE OF YOU',
	        bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
	        detailsHeader: 'Forgot your password?',
	        detailsDesc: 'Enter your email address below and we will get you back on track.',
	        otherPages: true,
	        page: 'logon'
	      };
	
	      var forgotData = {
	        bannerHeader: 'GET THE MORE OF YOU',
	        bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
	        detailsHeader: '',
	        detailsDesc: '',
	        otherPages: true,
	        page: 'register'
	      };
	
	      var createnewPassword = {
	        bannerHeader: 'GET THE MORE OF YOU',
	        bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
	        detailsHeader: 'Create new password!',
	        detailsDesc: '',
	        otherPages: true,
	        page: 'register'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _ForgotPassword4.default.container) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _ForgotPassword4.default.joinUsContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s6', _ForgotPassword4.default.joinUsBanner) },
	            _react2.default.createElement(_Banner2.default, { data: joinUsData })
	          ),
	          renderIfForgotSuccess(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _ForgotPassword4.default.joinUsDetails) },
	            _react2.default.createElement(
	              _Details2.default,
	              Object.assign({ data: forgotData }, this.props),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: _ForgotPassword4.default.successFull },
	                  'Reset password link sent to your email.'
	                )
	              )
	            )
	          )),
	          renderIfNotSuccess(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _ForgotPassword4.default.joinUsDetails) },
	            _react2.default.createElement(
	              _Details2.default,
	              Object.assign({ data: joinUsData }, this.props),
	              renderIfNotSetPassword(_react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_TextField2.default, {
	                  label: 'ENTER YOUR USERNAME',
	                  errorMessage: this.state.userNameErrorMessage,
	                  onChange: this.emailHandler,
	                  onKeyPress: this.identifyEnter
	                }),
	                _react2.default.createElement(_CustomButton2.default, { onClick: this.submit })
	              ))
	            )
	          )),
	          renderUpdatePassword(_react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _ForgotPassword4.default.joinUsDetails) },
	            _react2.default.createElement(
	              _Details2.default,
	              Object.assign({ data: createnewPassword }, this.props),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_TextField2.default, {
	                  label: 'ENTER USERNAME',
	                  errorMessage: this.state.userNameErrorMessage,
	                  onKeyPress: this.identifyEnter,
	                  onChange: function onChange(val) {
	                    return _this2.handleNewPassword('usernameForReset', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.removeErrorMessage('userNameErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_TextField2.default, {
	                  label: 'ENTER NEW PASSWORD',
	                  usedFor: 'forgotPassword',
	                  onKeyPress: this.identifyEnter,
	                  onChange: function onChange(val) {
	                    return _this2.handleNewPassword('newPassword', val);
	                  },
	                  errorMessage: this.state.newPasswordErrorMessage,
	                  onFocus: function onFocus() {
	                    return _this2.removeErrorMessage('newPasswordErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_TextField2.default, {
	                  label: 'CONFIRM PASSWORD AGAIN',
	                  usedFor: 'forgotPassword',
	                  onKeyPress: this.identifyEnter,
	                  errorMessage: this.state.confirmPasswordErrorMessage,
	                  onChange: function onChange(val) {
	                    return _this2.handleNewPassword('confirmPassword', val);
	                  },
	                  onFocus: function onFocus() {
	                    return _this2.removeErrorMessage('confirmPasswordErrorMessage');
	                  }
	                }),
	                _react2.default.createElement(_CustomButton2.default, { onClick: this.setPassword, label: 'save' })
	              )
	            )
	          ))
	        ),
	        renderLoading(_react2.default.createElement(_FullScreenLoader2.default, null))
	      );
	    }
	  }]);
	
	  return ForgotPassword;
	}(_react.Component);
	
	ForgotPassword.propTypes = {
	  success: _propTypes2.default.bool.isRequired,
	  forgot: _propTypes2.default.func.isRequired,
	  setPassword: _propTypes2.default.func.isRequired,
	  location: _propTypes2.default.shape,
	  isLoading: _propTypes2.default.bool.isRequired,
	  resetPasswordsuccess: _propTypes2.default.bool,
	  history: _propTypes2.default.shape().isRequired
	};
	ForgotPassword.defaultProps = {
	  success: false,
	  location: {},
	  resetPasswordsuccess: false
	};
	exports.default = (0, _reactRedux.connect)(_ForgotPassword2.forgotSelector, {
	  forgot: _ForgotPassword.forgot,
	  setPassword: _ForgotPassword.setPassword
	})((0, _reactRouter.withRouter)(ForgotPassword));

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ForgotPassword = __webpack_require__(1313);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ForgotPassword2.default;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _reactRedux = __webpack_require__(27);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _MyrbDescription = __webpack_require__(1162);
	
	var _MyrbDescription2 = _interopRequireDefault(_MyrbDescription);
	
	var _Benefits = __webpack_require__(1095);
	
	var _Benefits2 = _interopRequireDefault(_Benefits);
	
	var _Community = __webpack_require__(1117);
	
	var _Community2 = _interopRequireDefault(_Community);
	
	var _Reviews = __webpack_require__(1202);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FullScreenVideo = __webpack_require__(1147);
	
	var _FullScreenVideo2 = _interopRequireDefault(_FullScreenVideo);
	
	var _Banner3 = __webpack_require__(193);
	
	var _reactHelmet = __webpack_require__(180);
	
	var _Home = __webpack_require__(1576);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to connect to redux store from containers redux.js or any other redux store
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home(props) {
	    _classCallCheck(this, Home);
	
	    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));
	
	    _this.state = {
	      showFixedNavbar: false
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(Home, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      if (scrollTop > 80) {
	        this.setState({ showFixedNavbar: true });
	      } else {
	        this.setState({ showFixedNavbar: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bannerData = {
	        bannerHeader: 'GET DISCOVERED NATIONALLY',
	        bannerDesc: "The world's leader in innovative football recruiting using academics, biometrics, & athletic analysis.",
	        backgroundUrl: 'https://media.dev.myrecruitboard.com/Images/bgDesktop.png',
	        fullsize: true
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Home2.default.homePageContainer) },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'MyRecruitBoard \u2013 Get Recruited. College Football | MyRecruitBoard.com'
	          ),
	          _react2.default.createElement('meta', { name: 'description', content: 'Leader in College Football recruiting. Contact with Coaches Right away.' }),
	          _react2.default.createElement('meta', {
	            name: 'Keywords', content: 'College Football recruiting, Contact Football Coaches, College Sports, College Football Scholarships, Quarterback, Offensive Tackle, Offensive guard, Quarterback, Running back, Wide receiver, Tight end, Defensive tackle, Defensive end, Kicker '
	          })
	        ),
	        this.props.video === true ? _react2.default.createElement(_FullScreenVideo2.default, null) : _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _Home2.default.homePageContainer) },
	          this.state.showFixedNavbar === true ? _react2.default.createElement(_NavOnScroll2.default, this.props) : '',
	          _react2.default.createElement(_Banner2.default, Object.assign({}, this.props, { data: bannerData })),
	          _react2.default.createElement(_MyrbDescription2.default, null),
	          _react2.default.createElement(_Benefits2.default, null),
	          _react2.default.createElement(_Community2.default, null),
	          _react2.default.createElement(_Reviews2.default, null),
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Home;
	}(_react.Component);
	
	Home.propTypes = {
	  video: _propTypes2.default.bool
	
	};
	Home.defaultProps = {
	  video: false,
	  logoutUser: function logoutUser() {}
	};
	exports.default = (0, _reactRedux.connect)(_Banner3.bannerSelector, {})((0, _Session2.default)(Home));

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Home = __webpack_require__(1315);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Home2.default;

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = loginUser;
	
	var _immutable = __webpack_require__(11);
	
	var _localStorage = __webpack_require__(56);
	
	var _session = __webpack_require__(73);
	
	var service = _interopRequireWildcard(_session);
	
	var _LoginActionTypes = __webpack_require__(130);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function loginUser(username, password) {
	  // eslint-disable-line
	  var secondAttemptUserName = ''; // for second attempt login because of case sensitive username in userpools
	  var count = 0;
	
	  for (var i = 0; i < username.length; i++) {
	    // eslint-disable-line
	    if (/[A-Z]/.test(username.charAt(i))) {
	      count++; // eslint-disable-line
	    }
	  }
	
	  if (count === 0) {
	    secondAttemptUserName = username.charAt(0).toUpperCase() + username.slice(1);
	  } else if (count > 0) {
	    secondAttemptUserName = username.charAt(0).toLowerCase() + username.slice(1);
	  }
	
	  return function (dispatch) {
	    dispatch({
	      type: _LoginActionTypes.LOGIN_REQUESTED
	    });
	    service.authenticateUser(username, password, function (err, result) {
	      if (err) {
	        service.authenticateUser(secondAttemptUserName, password, function (secondError, secondResult) {
	          if (secondError) {
	            dispatch({
	              type: _LoginActionTypes.LOGIN_FAILED,
	              error: {
	                code: secondError.code,
	                message: secondError.message
	              }
	            });
	          } else {
	            var token = secondResult.session.idToken.jwtToken;
	            (0, _localStorage.setItem)('isLoggedIn', true);
	            (0, _localStorage.setItem)('token', token);
	            window.sessionStorage.setItem('user', 'COACH');
	            // end of dangerous code
	            dispatch({
	              type: _LoginActionTypes.LOGIN_SUCCESSFUL,
	              session: (0, _immutable.fromJS)(secondResult.session),
	              user: (0, _immutable.fromJS)(secondResult.user),
	              attributes: (0, _immutable.fromJS)(secondResult.attributes),
	              token: token
	            });
	          }
	        });
	      } else {
	        // Storing token in to local storage
	        var token = result.session.idToken.jwtToken;
	        (0, _localStorage.setItem)('isLoggedIn', true);
	        (0, _localStorage.setItem)('token', token);
	        window.sessionStorage.setItem('user', 'COACH');
	        // end of dangerous code
	        dispatch({
	          type: _LoginActionTypes.LOGIN_SUCCESSFUL,
	          session: (0, _immutable.fromJS)(result.session),
	          user: (0, _immutable.fromJS)(result.user),
	          attributes: (0, _immutable.fromJS)(result.attributes),
	          token: token
	        });
	      }
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Signin = __webpack_require__(467);
	
	var _Signin2 = _interopRequireDefault(_Signin);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Details = __webpack_require__(196);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _reactRouter = __webpack_require__(89);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(37);
	
	var _Login = __webpack_require__(1577);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default propscoming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.isValid) {
	        this.props.history.push('/');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var signinData = {
	        bannerHeader: 'GET THE MORE OF YOU',
	        bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
	        detailsHeader: 'Sign in to MyRecruitBoard',
	        detailsDesc: 'Enter your details below.',
	        otherPages: true
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Login2.default.loginContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Login2.default.loginBanner) },
	          _react2.default.createElement(_Banner2.default, { data: signinData, usedFor: 'login' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Login2.default.inputFileds) },
	          _react2.default.createElement(
	            _Details2.default,
	            Object.assign({ data: signinData }, this.props),
	            _react2.default.createElement(_Signin2.default, this.props)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	Login.propTypes = {
	  isValid: _propTypes2.default.bool.isRequired,
	  history: _propTypes2.default.shape()
	};
	Login.defaultProps = {
	  history: {}
	};
	exports.default = (0, _reactRouter.withRouter)((0, _SessionReplica2.default)(Login));

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loginSelector = exports.login = exports.loginInitialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _LoginActionTypes = __webpack_require__(130);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
	                                                                                                                                                                                                                   * Created by sairam on 14/04/17.
	                                                                                                                                                                                                                   */
	// use of immutablejs for various js operations to simplify our work
	
	
	var loginInitialState = exports.loginInitialState = (0, _immutable.Map)({
	  session: (0, _immutable.Map)(),
	  user: (0, _immutable.Map)(),
	  error: (0, _immutable.Map)(),
	  isLoading: false,
	  attrbutes: (0, _immutable.Map)(),
	  errorMessage: ''
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _LoginActionTypes.LOGIN_REQUESTED, function (state) {
	  return state.merge({
	    isLoginRequested: true,
	    isLoading: true
	  });
	}), _defineProperty(_handlers, _LoginActionTypes.LOGIN_FAILED, function (state, action) {
	  return state.merge({
	    isLoginRequested: false,
	    isLoading: false,
	    error: action.error,
	    errorMessage: action.erro
	  });
	}), _defineProperty(_handlers, _LoginActionTypes.LOGIN_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    session: action.session,
	    attributes: action.attributes,
	    isLoading: false
	  });
	}), _handlers);
	
	var login = exports.login = (0, _reducers.createReducer)(loginInitialState, handlers);
	
	// LOGIN SELECTOR
	// Selectors
	var getError = function getError(state) {
	  return state.register.get('error');
	};
	var getSession = function getSession(state) {
	  return state.register.get('session');
	};
	var getUser = function getUser(state) {
	  return state.register.get('user');
	};
	var getIsLoading = function getIsLoading(state) {
	  return state.register.get('isLoading');
	};
	var getAttributes = function getAttributes(state) {
	  return state.register.get('attributes');
	};
	var getErrorMessage = function getErrorMessage(state) {
	  return state.register.get('errorMessage');
	};
	
	var loginSelector = exports.loginSelector = (0, _reselect.createStructuredSelector)({
	  error: getError,
	  session: getSession,
	  user: getUser,
	  isLoading: getIsLoading,
	  attributes: getAttributes,
	  errorMessage: getErrorMessage
	});

/***/ },
/* 1320 */
[2533, 1318],
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OurResultsData = __webpack_require__(1170);
	
	var _OurResultsData2 = _interopRequireDefault(_OurResultsData);
	
	var _StaticContainer = __webpack_require__(1234);
	
	var _StaticContainer2 = _interopRequireDefault(_StaticContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OurResults = function OurResults() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _StaticContainer2.default,
	      null,
	      _react2.default.createElement(_OurResultsData2.default, null)
	    )
	  );
	};
	
	exports.default = OurResults;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OurResults = __webpack_require__(1321);
	
	var _OurResults2 = _interopRequireDefault(_OurResults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _OurResults2.default;

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _ProfileBanner = __webpack_require__(198);
	
	var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);
	
	var _PackagesList = __webpack_require__(1172);
	
	var _PackagesList2 = _interopRequireDefault(_PackagesList);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _actions = __webpack_require__(110);
	
	var _redux = __webpack_require__(111);
	
	var _routeNames = __webpack_require__(55);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _analytics = __webpack_require__(37);
	
	var _reactHelmet = __webpack_require__(180);
	
	var _Packages = __webpack_require__(1578);
	
	var _Packages2 = _interopRequireDefault(_Packages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to connect to redux store from containers redux.js or any other redux store
	// to show loder on screen whenever there is a api call or operations in component
	// to use conditional rendering based on values that is provided to component
	
	
	// to import local scss fle
	
	var Packages = function (_Component) {
	  _inherits(Packages, _Component);
	
	  function Packages(props) {
	    _classCallCheck(this, Packages);
	
	    var _this = _possibleConstructorReturn(this, (Packages.__proto__ || Object.getPrototypeOf(Packages)).call(this, props));
	
	    _this.state = {
	      showFixedNavbar: false
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(Packages, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	
	      var paymentStatus = window.sessionStorage.getItem('kiro');
	      if (this.props.attributes.size > 0 && !this.props.isLoading && this.props.attributes.zoneinfo === 'STUDENT' && !this.props.attributes.get('profile') === 'PENDING' && paymentStatus === null) {
	        var saProfile = this.props.attributes.get('profile');
	        this.props.getSAProfile(saProfile);
	      } else if (this.props.attributes.size > 0 && this.props.attributes.get('zoneinfo') === 'STUDENT' && this.props.attributes.get('profile') === 'PENDING') {
	        this.props.history.push(_routeNames.RegisterAthlete);
	      }
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var paymentStatus = window.sessionStorage.getItem('kiro');
	      if (nextProps.attributes.size > 0 && !nextProps.isLoading && !nextProps.profile.size > 0 && nextProps.attributes.get('zoneinfo') === 'STUDENT' && paymentStatus === null) {
	        var saProfile = nextProps.attributes.get('profile');
	        this.props.getSAProfile(saProfile);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      if (scrollTop > 80) {
	        this.setState({ showFixedNavbar: true });
	      } else {
	        this.setState({ showFixedNavbar: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderLoader = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'STUDENT' && this.props.isLoading);
	      return _react2.default.createElement(
	        'div',
	        { className: _Packages2.default.container },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'MyRecruitBoard \u2013 Get Recruited. Best Value for the Pricing'
	          ),
	          _react2.default.createElement('meta', { name: 'description', content: 'College Football Recruiting Best Value for the Pricing!' }),
	          _react2.default.createElement('meta', { name: 'Keywords', content: 'Affordable packages, Package for Senior, Package for Senior, Package for FRESHMAN, Package for SOPHOMORE, Package for Junior, Package for Middle school' })
	        ),
	        renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        this.state.showFixedNavbar === true ? _react2.default.createElement(_NavOnScroll2.default, this.props) : '',
	        _react2.default.createElement(_ProfileBanner2.default, Object.assign({}, this.props, { usedFor: 'pricing' })),
	        _react2.default.createElement(_PackagesList2.default, this.props),
	        _react2.default.createElement(_MiniFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Packages;
	}(_react.Component);
	
	Packages.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  getSAProfile: _propTypes2.default.func,
	  profile: _propTypes2.default.shape(), // eslint-disable-line
	  isLoading: _propTypes2.default.bool.isRequired,
	  history: _propTypes2.default.shape()
	};
	Packages.defaultProps = {
	  attributes: {},
	  getSAProfile: function getSAProfile() {},
	  profile: {},
	  push: _propTypes2.default.func.isRequired,
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSAProfile: _actions.getSAProfile })((0, _SessionReplica2.default)(Packages));

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Packages = __webpack_require__(1323);
	
	var _Packages2 = _interopRequireDefault(_Packages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Packages2.default;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _AtheleteDetails = __webpack_require__(278);
	
	var _AtheleteDetails2 = _interopRequireDefault(_AtheleteDetails);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Parent = __webpack_require__(1579);
	
	var _Parent2 = _interopRequireDefault(_Parent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var Parent = function (_Component) {
	  _inherits(Parent, _Component);
	
	  function Parent(props) {
	    _classCallCheck(this, Parent);
	
	    var _this = _possibleConstructorReturn(this, (Parent.__proto__ || Object.getPrototypeOf(Parent)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Parent, [{
	    key: 'render',
	    value: function render() {
	      var bannerData = {
	        bannerHeader: 'GET DISCOVERED NATIONALLY',
	        bannerDesc: "We're proud to be the largest athletic recruiting platform since we were  founded. The sports recruiting world has shifted, and we're always evolving.",
	        backgroundUrl: 'https://media.dev.myrecruitboard.com/Images/bgDesktop.png',
	        fullsize: false,
	        otherPages: true
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Parent2.default.atheleteContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Parent2.default.bannerAthelete) },
	          _react2.default.createElement(_Banner2.default, { data: bannerData })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Parent2.default.bannerAthelete) },
	          _react2.default.createElement(_AtheleteDetails2.default, { viewer: 'parents' })
	        )
	      );
	    }
	  }]);
	
	  return Parent;
	}(_react.Component);
	
	Parent.propTypes = {
	  data: _propTypes2.default.isRequired
	};
	
	exports.default = Parent;

/***/ },
/* 1326 */
[2535, 1325],
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(27);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _ErrorMessage = __webpack_require__(28);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _analytics = __webpack_require__(37);
	
	var _PaymentDropin = __webpack_require__(1177);
	
	var _PaymentDropin2 = _interopRequireDefault(_PaymentDropin);
	
	var _queryString = __webpack_require__(116);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _immutable = __webpack_require__(11);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _actions = __webpack_require__(110);
	
	var _routeNames = __webpack_require__(55);
	
	var _actions2 = __webpack_require__(1328);
	
	var _redux = __webpack_require__(480);
	
	var _Payment = __webpack_require__(1580);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to connect to redux store from containers redux.js or any other redux store
	
	/* import { DropIn } from 'braintree-react'; */
	// to use conditional rendering based on values that is provided to component
	
	/* import braintree from 'braintree-web'; */
	// to use global class name eg. classes from grid.css in public folder
	// use of immutablejs for various js operations to simplify our work
	// to show loder on screen whenever there is a api call or operations in component
	
	
	// to import local scss fle
	
	
	var Payment = function (_Component) {
	  _inherits(Payment, _Component);
	
	  _createClass(Payment, null, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {}
	  }]);
	
	  function Payment(props) {
	    _classCallCheck(this, Payment);
	
	    var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, props));
	
	    _this.state = { showSuccess: false, plan: false, renderOnce: 0 };
	    _this.onPaymentMethodReceived = _this.onPaymentMethodReceived.bind(_this);
	    _this.callback = _this.callback.bind(_this);
	    _this.plans = {
	      plan1: { price: 9.99, name: 'one_month_for_12_months', currency: 'USD', pay: 'Pay $9.99 per month for 12 months', url: '9_99_per_month_12_months' },
	      plan2: { price: 99, name: 'one_year_plan', currency: 'USD', pay: 'Pay $99 towards one year plan', url: '99_once_12_months' },
	      plan3: { price: 14.99, name: 'one_month_for_6_months', currency: 'USD', pay: 'Pay $14.99 per month for 6 months', url: '14_99_per_month_6_months' },
	      plan4: { price: 75, name: '6_month_plan', currency: 'USD', pay: 'Pay $75 towards 6 months plan', url: '75_once_6_months' },
	      plan5: { price: 19.99, name: 'one_month_for_3_months', currency: 'USD', pay: 'Pay $19.99 per month for 3 months', url: '19_99_per_month_3_months' },
	      plan6: { price: 50, name: '3_months_plan', currency: 'USD', pay: 'Pay $50 towards 3 months plan', url: '50_once_3_months' },
	      oneMonthPlan: { price: 29.99, name: '1_months_plan', currency: 'USD', pay: 'Pay $29.99 towards 1 month plan', url: '29_99_once_1_month' },
	      lifetime: { price: 199, name: 'lifetime', currency: 'USD', pay: 'Pay $199 towards lifetime plan', url: '199_once_lifetime' },
	      monthlySubscription: { price: 14.99, name: '14_99_per_month', currency: 'USD', pay: 'Pay $14.99 towards monthly plan', url: '14_99_per_month' }
	    };
	    return _this;
	  }
	
	  _createClass(Payment, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // window.scrollTo(0, 0);
	      var location = this.props.location;
	
	      var query = _queryString2.default.parse(location.search);
	      if (query && Object.prototype.hasOwnProperty.call(query, 'plan') && Object.prototype.hasOwnProperty.call(query, 'once')) {
	        this.setState({ query: query });
	        var plan = this.plans[query.plan];
	        if (plan && plan.url) {
	          this.setState({ plan: plan });
	        } else {
	          this.setState({ plan: false });
	        }
	      }
	    }
	
	    /** SA Profile will have CustomerID when the user registers for the first time in MyRB and
	    * payment_info object won't be present in SA profile now .
	    *
	    * If the payment is succesful , This CustomerID will be used to Create Customer
	    * in Braintree when the User pays for the first time
	    * and payment_info object would be added with the plan and transaction details
	    * "payment_info": {
	        "last_date": "2017-10-17T14:34:10.000Z",
	        "payment_customer_id": "a5460af8-a2c4-563b-a7f5-56136558f544",
	        "payment_status": true,
	        "plan_id": "29_99_once_1_month",
	        "transaction_date": "2017-09-17T14:34:10Z"
	    }
	     If payment_info is not null, it is understood that customer is already added to braintree and so
	    if the user is making another payment , we have to send customer_id in payment/clientToken GET
	     API as a query parameter.
	    For the first time payment, we don't need to send the client_token in this api . */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	
	
	      if (this.props.profile && this.props.profile.size > 0) {
	        var payment = this.props.profile.get('payment_info');
	        var customerId = this.props.profile.get('customer_id');
	        var name = this.props.profile.get('fullname');
	        var id = this.props.profile.get('id');
	        var newState = {
	          payment: payment,
	          customerId: customerId,
	          name: name,
	          id: id
	        };
	
	        var custId = '';
	
	        if (payment) {
	          custId = customerId;
	        }
	        this.props.getClientToken(custId);
	        this.setState(newState); //eslint-disable-line
	      } else if (this.props.attributes && this.props.attributes.size > 0) {
	        var saProfile = this.props.attributes.get('profile');
	        this.setState({ email: this.props.attributes.get('email') }); // eslint-disable-line
	
	        if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
	          this.props.getSAProfile(saProfile);
	        } else {
	          this.props.history.push(_routeNames.Pricing);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.clientToken) {
	        var temp = this.state.renderOnce + 1;
	        this.setState({ renderOnce: temp });
	      }
	      var _props = this.props,
	          attributes = _props.attributes,
	          profile = _props.profile,
	          transaction = _props.transaction;
	
	      if (nextProps.attributes && !(0, _immutable.is)(nextProps.attributes, attributes)) {
	        var saProfile = nextProps.attributes.get('profile');
	        this.setState({ email: nextProps.attributes.get('email') });
	        if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
	          this.props.getSAProfile(saProfile);
	        } else {
	          this.props.history.push(_routeNames.Pricing);
	        }
	      } else if (nextProps.profile.size > 0 && !(0, _immutable.is)(nextProps.profile, profile)) {
	        var payment = nextProps.profile.get('payment_info');
	        if (payment) {
	          payment = payment.toJS();
	        }
	        var customerId = nextProps.profile.get('customer_id');
	        var name = nextProps.profile.get('fullname');
	        var id = nextProps.profile.get('id');
	        var newState = {
	          payment: payment,
	          customerId: customerId,
	          name: name,
	          id: id
	        };
	
	        var custId = '';
	
	        if (payment) {
	          custId = customerId;
	        }
	        this.props.getClientToken(custId);
	
	        this.setState(newState); //eslint-disable-line
	      }
	      if (nextProps.transaction && !(0, _immutable.is)(nextProps.transaction, transaction)) {
	        this.setState({ showSuccess: true });
	        this.props.getSAProfile(this.state.id);
	        this.props.history.push(_routeNames.Dashboard);
	      }
	    }
	  }, {
	    key: 'onPaymentMethodReceived',
	    value: function onPaymentMethodReceived(payment) {
	      var pay = {
	        customer: {
	          firstName: this.state.name,
	          lastName: this.state.name,
	          company: '',
	          email: this.props.attributes.get('email'),
	          phone: '',
	          fax: '',
	          website: '',
	          id: this.state.customerId
	        },
	        paymentMethodNonce: payment.nonce,
	        planId: this.state.plan.url,
	        userId: this.state.id,
	        payment_info: this.props.profile.get('payment_info')
	      };
	      if (this.state.payment) {
	        pay = {
	          paymentMethodNonce: payment.nonce,
	          planId: this.state.plan.url,
	          userId: this.state.id,
	          payment_info: this.props.profile.get('payment_info')
	        };
	      }
	      this.props.sendPaymentNonce(pay);
	    }
	  }, {
	    key: 'callback',
	    value: function callback() {
	      this.setState({ showLoader: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clientToken = this.props.clientToken;
	      var _state = this.state,
	          showSuccess = _state.showSuccess,
	          plan = _state.plan;
	
	      var renderDropIn = (0, _renderIf2.default)(clientToken && clientToken.length > 0);
	      /* const paypal = {
	        currency: 'USD' }; */
	      var renderSuccess = (0, _renderIf2.default)(showSuccess && plan);
	      /* const renderPay = renderIf(!this.state.showLoader); */
	      var renderNormal = (0, _renderIf2.default)(!showSuccess && plan);
	      var renderPlanError = (0, _renderIf2.default)(this.props.showError !== '');
	      var renderLoader = (0, _renderIf2.default)(this.props.showLoader);
	      var form = document.querySelector('#payment-form');
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Payment2.default.container) },
	        _react2.default.createElement(_NavOnScroll2.default, this.props),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Payment2.default.dropInContainer) },
	          renderNormal(_react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: Payment.handleSubmit, id: 'payment-form', className: _Payment2.default.one },
	              renderPlanError(_react2.default.createElement(_ErrorMessage2.default, { message: this.props.showError })),
	              _react2.default.createElement(
	                'span',
	                { className: _Payment2.default.greenIndicator },
	                plan.pay
	              ),
	              _react2.default.createElement('div', { id: 'dropin-container' }),
	              renderDropIn(_react2.default.createElement(_PaymentDropin2.default, {
	                clientToken: this.props.clientToken,
	                form: form,
	                onPaymentMethodReceived: this.onPaymentMethodReceived
	              })),
	              _react2.default.createElement(
	                'div',
	                { className: _Payment2.default.buttonContainer },
	                _react2.default.createElement(
	                  'button',
	                  { className: _Payment2.default.button, type: 'submit' },
	                  ' PAY NOW '
	                )
	              )
	            ),
	            renderSuccess(_react2.default.createElement(
	              'div',
	              null,
	              ' Transaction successfull'
	            )),
	            renderLoader(_react2.default.createElement(_FullScreenLoader2.default, null))
	          ))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Payment2.default.removePadding) },
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Payment;
	}(_react.Component);
	
	Payment.propTypes = {
	  getClientToken: _propTypes2.default.func.isRequired,
	  sendPaymentNonce: _propTypes2.default.func.isRequired,
	  clientToken: _propTypes2.default.string.isRequired,
	  location: _propTypes2.default.shape().isRequired,
	  transaction: _propTypes2.default.shape(),
	  profile: _propTypes2.default.instanceOf(_immutable.Map),
	  attributes: _propTypes2.default.instanceOf(_immutable.Map),
	  getSAProfile: _propTypes2.default.func.isRequired,
	  history: _propTypes2.default.shape().isRequired,
	  showLoader: _propTypes2.default.bool,
	  showError: _propTypes2.default.string
	};
	Payment.defaultProps = {
	  transaction: (0, _immutable.Map)(),
	  profile: (0, _immutable.Map)(),
	  attributes: (0, _immutable.Map)(),
	  showLoader: false,
	  showError: ''
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, {
	  getClientToken: _actions2.getClientToken,
	  postSubscriptionCS: _actions2.postSubscriptionCS,
	  sendPaymentNonce: _actions2.sendPaymentNonce,
	  getSAProfile: _actions.getSAProfile
	})((0, _Session2.default)(Payment));

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getClientToken = getClientToken;
	exports.sendPaymentNonce = sendPaymentNonce;
	exports.postSubscriptionCS = postSubscriptionCS;
	
	var _payment = __webpack_require__(442);
	
	var s = _interopRequireWildcard(_payment);
	
	var _immutable = __webpack_require__(11);
	
	var _actionTypes = __webpack_require__(479);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function getClientToken(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    s.getClientToken(id).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.CLIENT_TOKEN,
	          token: result.client_token
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work
	function sendPaymentNonce(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    try {
	      s.postSubscription(payload).then(function (result) {
	        if (result.message) {
	          dispatch({
	            type: _actionTypes.FAILED,
	            error: result.message
	          });
	        } else {
	          dispatch({
	            type: _actionTypes.TRANSACTION_SUCCESS,
	            transaction: (0, _immutable.fromJS)(result)
	          });
	        }
	      });
	    } catch (err) {} // eslint-disable-line
	  };
	}
	
	function postSubscriptionCS(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    s.postSubscriptionCS(payload).then(function (result) {
	      if (result) {
	        dispatch({
	          type: _actionTypes.TRANSACTION_SUCCESS,
	          transaction: (0, _immutable.fromJS)(result)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Payment = __webpack_require__(1327);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Payment2.default;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(5);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(27);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _UpgradePopup = __webpack_require__(1243);
	
	var _UpgradePopup2 = _interopRequireDefault(_UpgradePopup);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProfileHeader = __webpack_require__(283);
	
	var _ProfileHeader2 = _interopRequireDefault(_ProfileHeader);
	
	var _ProfileData = __webpack_require__(282);
	
	var _ProfileData2 = _interopRequireDefault(_ProfileData);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _TrialNotification = __webpack_require__(468);
	
	var _TrialNotification2 = _interopRequireDefault(_TrialNotification);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(37);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _routeNames = __webpack_require__(55);
	
	var _VideoPlayer = __webpack_require__(469);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	var _actions = __webpack_require__(452);
	
	var _ProfileView = __webpack_require__(1581);
	
	var _ProfileView2 = _interopRequireDefault(_ProfileView);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _redux = __webpack_require__(111);
	
	var _actions2 = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	// to show loder on screen whenever there is a api call or operations in component
	// to import local scss fle
	
	var ProfileView = function (_Component) {
	  _inherits(ProfileView, _Component);
	
	  function ProfileView(props) {
	    _classCallCheck(this, ProfileView);
	
	    var _this = _possibleConstructorReturn(this, (ProfileView.__proto__ || Object.getPrototypeOf(ProfileView)).call(this, props));
	
	    _this.state = {
	      showFullScreenVideo: false,
	      videoOnProfile: false
	    };
	    _this.removeVideoScreen = _this.removeVideoScreen.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProfileView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          attributes = _props.attributes,
	          history = _props.history;
	
	      if (attributes.size > 0) {
	        var zoneinfo = attributes.get('zoneinfo');
	        if (!(zoneinfo === 'STUDENT' || zoneinfo === 'ADMIN')) {
	          history.push('/');
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	
	      if (this.props.attributes && this.props.attributes.size > 0) {
	        var saProfile = this.props.attributes.get('profile');
	        if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
	          this.props.getSAProfile(saProfile);
	        } else {
	          this.props.history.push(_routeNames.RegisterAthlete);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var attributes = this.props.attributes;
	      var history = nextProps.history;
	
	      if (nextProps.attributes.size > 0) {
	        var zoneinfo = nextProps.attributes.get('zoneinfo');
	        if (!(zoneinfo === 'STUDENT' || zoneinfo === 'ADMIN')) {
	          history.push('/');
	        }
	      }
	      if (!this.props.requested && nextProps.attributes && !(0, _immutable.is)(nextProps.attributes, attributes)) {
	        var saProfile = nextProps.attributes.get('profile');
	        if (saProfile && saProfile !== 'PENDING' && !Object.prototype.hasOwnProperty.call(this.props.profile, 'created_time')) {
	          this.props.getSAProfile(saProfile);
	        } else {
	          this.props.history.push(_routeNames.RegisterAthlete);
	        }
	      } else if (nextProps.profile.size > 0) {
	        var saSports = nextProps.profile.get('sports');
	        var keys = saSports.keySeq().toArray();
	        var sport = saSports.get(keys[0]);
	        var profileImage = '';
	        var primary_offensive_position_pref = ''; //eslint-disable-line
	        var primary_defensive_position_pref = ''; //eslint-disable-line
	        var secondary_offensive_position_pref = ''; //eslint-disable-line
	        var secondary_defensive_position_pref = ''; //eslint-disable-line
	        var special_teams = ''; //eslint-disable-line
	
	        var sat = '';
	        var act = '';
	        if (nextProps.profile.get('profile_image') !== undefined) {
	          profileImage = nextProps.profile.get('profile_image');
	        } else {
	          profileImage = '';
	        }
	        var instagramLink = '';
	        if (nextProps.profile.get('sa_instagram')) {
	          instagramLink = nextProps.profile.get('sa_instagram');
	        } else {
	          instagramLink = '';
	        }
	        var twitterLink = '';
	        if (nextProps.profile.get('sa_twitter')) {
	          twitterLink = nextProps.profile.get('sa_twitter');
	        } else {
	          twitterLink = '';
	        }
	        if (sport.get('primary_offensive_position_pref') !== undefined) {
	          primary_offensive_position_pref = sport.get('primary_offensive_position_pref'); //eslint-disable-line
	        } else {
	          primary_offensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('primary_defensive_position_pref') !== undefined) {
	          primary_defensive_position_pref = sport.get('primary_defensive_position_pref'); //eslint-disable-line
	        } else {
	          primary_defensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('secondary_offensive_position_pref') !== undefined) {
	          secondary_offensive_position_pref = sport.get('secondary_offensive_position_pref'); //eslint-disable-line
	        } else {
	          secondary_offensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('secondary_defensive_position_pref') !== undefined) {
	          secondary_defensive_position_pref = sport.get('secondary_defensive_position_pref'); //eslint-disable-line
	        } else {
	          secondary_defensive_position_pref = ''; //eslint-disable-line
	        }
	        if (sport.get('special_teams') !== undefined) {
	          special_teams = sport.get('special_teams'); //eslint-disable-line
	        } else {
	          special_teams = ''; //eslint-disable-line
	        }
	        var academic = nextProps.profile.get('academic');
	        if (academic.get('sat') !== undefined) {
	          sat = academic.get('sat');
	        }
	        if (academic.get('act') !== undefined) {
	          act = academic.get('act');
	        }
	
	        var newState = {
	          // profile
	          gender: nextProps.profile.get('gender'),
	          fullname: nextProps.profile.get('fullname'),
	          state: nextProps.profile.get('sa_state'),
	          city: nextProps.profile.get('city'),
	
	          // sports
	          height: nextProps.profile.get('height'),
	          weight: nextProps.profile.get('weight'),
	          sportName: keys[0],
	          t40: sport.get('t40'),
	          bench: sport.get('bench'),
	          squats: sport.get('squats'),
	          description: sport.get('description'),
	
	          primary_offensive_position_pref: primary_offensive_position_pref,
	          primary_defensive_position_pref: primary_defensive_position_pref,
	          secondary_offensive_position_pref: secondary_offensive_position_pref,
	          secondary_defensive_position_pref: secondary_defensive_position_pref,
	          special_teams: special_teams,
	          // school
	          school: nextProps.profile.get('school'),
	          year_of_graduation: academic.get('year_of_graduation'),
	          gpa: academic.get('gpa'),
	          sat: sat,
	          act: act,
	          profileId: nextProps.profile.get('id'),
	          video: nextProps.profile.get('video_items').toJS(),
	          profile_image: profileImage,
	          instagram: instagramLink,
	          twitter: twitterLink,
	          evaluationText: nextProps.profile.get('evaluation_text')
	        };
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'removeVideoScreen',
	    value: function removeVideoScreen() {
	      this.setState({ showFullScreenVideo: !this.state.showFullScreenVideo });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          profile = _props2.profile,
	          isLoading = _props2.isLoading,
	          subscribed = _props2.subscribed;
	
	      var renderIfProfile = (0, _renderIf2.default)(profile.size > 0);
	      var renderIfLoading = (0, _renderIf2.default)(isLoading);
	      var renderVideoPlayer = (0, _renderIf2.default)(this.state.showFullScreenVideo);
	      var renderPopup = true;
	      if (profile.get('payment_info') !== undefined && subscribed) {
	        renderPopup = false;
	      }
	      var showTrialButton = false;
	      if (this.props.profile.get('trialEndDate') === undefined && this.props.profile.get('payment_info') === undefined) {
	        showTrialButton = true;
	      }
	      var onTrial = false;
	      if (this.props.profile !== undefined) {
	        if (this.props.profile.get('trialEndDate')) {
	          onTrial = (0, _moment2.default)().isBefore(this.props.profile.get('trialEndDate'));
	        }
	      }
	      var renderUpgradePopup = (0, _renderIf2.default)(renderPopup);
	      return _react2.default.createElement(
	        'div',
	        null,
	        renderIfLoading(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        renderUpgradePopup(_react2.default.createElement(_UpgradePopup2.default, Object.assign({}, this.props, { usedFor: 'profile_page', showTrialButton: showTrialButton, onTrial: onTrial }))),
	        renderIfProfile(_react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _ProfileView2.default.profileContainer) },
	          !subscribed && onTrial && _react2.default.createElement(_TrialNotification2.default, { trialEndDate: this.props.profile.get('trialEndDate') }),
	          _react2.default.createElement(_ProfileHeader2.default, Object.assign({}, this.props, this.state, { page: 'athleteView', navBarUsedBy: 'athlete', onTrial: onTrial })),
	          _react2.default.createElement(_ProfileData2.default, Object.assign({
	            removeVideoScreen: this.removeVideoScreen
	          }, this.props, this.state)),
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )),
	        renderVideoPlayer(_react2.default.createElement(_VideoPlayer2.default, Object.assign({
	          removeVideoScreen: this.removeVideoScreen,
	          showVideo: this.state.showFullScreenVideo
	        }, this.props)))
	      );
	    }
	  }]);
	
	  return ProfileView;
	}(_react.Component);
	
	ProfileView.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  profile: _propTypes2.default.shape(),
	  history: _propTypes2.default.shape(),
	  getSAProfile: _propTypes2.default.func,
	  requested: _propTypes2.default.bool,
	  isLoading: _propTypes2.default.bool,
	  subscribed: _propTypes2.default.bool
	};
	ProfileView.defaultProps = {
	  attributes: {},
	  history: {},
	  profile: (0, _immutable.Map)(),
	  getSAProfile: function getSAProfile() {},
	  requested: false,
	  isLoading: false,
	  subscribed: false
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSAProfile: _actions2.getSAProfile,
	  saveUserImage: _actions2.saveUserImage,
	  videoDetails: _actions2.videoDetails,
	  setCurrentVideo: _actions2.setCurrentVideo,
	  getTotalCounts: _actions.getTotalCounts,
	  removeVideo: _actions2.removeVideo
	})((0, _Session2.default)(ProfileView));

/***/ },
/* 1331 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var generatePayload = exports.generatePayload = function generatePayload(profile) {
	  var payload = {};
	  if (profile.size > 0) {
	    var saSports = profile.get('sports');
	    var keys = saSports.keySeq().toArray();
	    var sport = saSports.get(keys[0]);
	    var primaryRole = '';
	    if (sport.get('primary_offensive_position_pref') !== undefined) {
	      if (sport.get('primary_offensive_position_pref') === 'QBDT' || sport.get('primary_offensive_position_pref') === 'QBPS') {
	        primaryRole = 'QB';
	      } else if (sport.get('primary_offensive_position_pref') === 'SR' || sport.get('primary_offensive_position_pref') === 'WR') {
	        primaryRole = 'WR';
	      } else if (sport.get('primary_offensive_position_pref') === 'RB' || sport.get('primary_offensive_position_pref') === 'FB' || sport.get('primary_offensive_position_pref') === 'SR' || sport.get('primary_offensive_position_pref') === 'HB') {
	        primaryRole = 'RB';
	      } else if (sport.get('primary_offensive_position_pref') === 'OG' || sport.get('primary_offensive_position_pref') === 'OT' || sport.get('primary_offensive_position_pref') === 'C') {
	        primaryRole = 'OL';
	      } else {
	        primaryRole = sport.get('primary_offensive_position_pref');
	      }
	    } else if (sport.get('primary_defensive_position_pref') !== undefined) {
	      if (sport.get('primary_defensive_position_pref') === 'ML' || sport.get('primary_defensive_position_pref') === 'OL') {
	        primaryRole = 'LB';
	      } else if (sport.get('primary_defensive_position_pref') === 'SS' || sport.get('primary_defensive_position_pref') === 'FS') {
	        primaryRole = 'S';
	      } else {
	        primaryRole = sport.get('primary_defensive_position_pref');
	      }
	    }
	    var academic = profile.get('academic');
	    var combinedHeight = profile.get('height');
	    var contactedCollegeLength = profile.get('sa_contactedlist').size;
	    var heightIncm = parseInt(combinedHeight.charAt(0)) * 12 + parseInt(combinedHeight.substr(2, 2)); // eslint-disable-line
	    payload = {
	      stats: {
	        student_parameters: {
	          squats: parseInt(sport.get('squats'), 10),
	          bench: parseInt(sport.get('bench'), 10),
	          forty: parseFloat(sport.get('t40'), 10),
	          weight: parseInt(profile.get('weight'), 10),
	          height: heightIncm
	        },
	        role: primaryRole,
	        consider_squats_and_bench: 'yes'
	      },
	      gpa: parseFloat(academic.get('gpa'), 10),
	      act: parseInt(academic.get('act'), 10),
	      from: 0,
	      size: 50 + contactedCollegeLength
	    };
	  }
	  return payload;
	};
	
	var getSubscription = exports.getSubscription = function getSubscription(profile) {
	  var subscribed = false;
	  if (profile && profile.size > 0) {
	    var payment = '';
	    if (profile.get('payment_info') !== undefined) {
	      payment = profile.get('payment_info').last();
	    }
	    if (payment) {
	      payment = payment.toJS();
	      if (payment.last_date !== null) {
	        var lastDate = new Date(payment.last_date);
	        var currentDate = new Date();
	        if (payment && payment.payment_status === true && lastDate.getTime() >= currentDate.getTime()) {
	          subscribed = true;
	        }
	      } else if (payment.last_date === null) {
	        if (payment && payment.payment_status === true) {
	          subscribed = true;
	        }
	      }
	    }
	  }
	  return subscribed;
	};

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProfileView = __webpack_require__(1330);
	
	var _ProfileView2 = _interopRequireDefault(_ProfileView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProfileView2.default;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProfileBanner = __webpack_require__(198);
	
	var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);
	
	var _GetUserDetails = __webpack_require__(456);
	
	var _GetUserDetails2 = _interopRequireDefault(_GetUserDetails);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(37);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _Profile = __webpack_require__(1582);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	// to import local scss fle
	
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    _classCallCheck(this, Profile);
	
	    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this.state = {
	      showFixedNavbar: false
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(Profile, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          attributes = _props.attributes,
	          history = _props.history;
	
	      if (attributes.size > 0) {
	        if (attributes.get('zoneinfo') !== 'STUDENT') {
	          history.goBack();
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	      if (this.props.attributes.get('sub') && this.props.attributes.get('profile') !== 'PENDING') {
	        this.props.history.push('/');
	      }
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var attributes = nextProps.attributes,
	          history = nextProps.history;
	
	      if (attributes.size > 0) {
	        if (attributes.get('zoneinfo') !== 'STUDENT') {
	          history.goBack();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      if (scrollTop > 80) {
	        this.setState({ showFixedNavbar: true });
	      } else {
	        this.setState({ showFixedNavbar: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Profile2.default.profileContainer) },
	        this.state.showFixedNavbar === true ? _react2.default.createElement(_NavOnScroll2.default, this.props) : '',
	        _react2.default.createElement(_ProfileBanner2.default, this.props),
	        _react2.default.createElement(_GetUserDetails2.default, Object.assign({}, this.props, { usedFor: 'athlete' })),
	        _react2.default.createElement(_MiniFooter2.default, null)
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	Profile.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  history: _propTypes2.default.shape()
	};
	Profile.defaultProps = {
	  history: {},
	  attributes: {}
	};
	exports.default = (0, _Session2.default)(Profile);

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Profile = __webpack_require__(1333);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Profile2.default;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(27);
	
	var _immutable = __webpack_require__(11);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _analytics = __webpack_require__(37);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _queryString = __webpack_require__(116);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _button = __webpack_require__(31);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _Navbar = __webpack_require__(159);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _FullScreenLoader = __webpack_require__(29);
	
	var _FullScreenLoader2 = _interopRequireDefault(_FullScreenLoader);
	
	var _AthleteById = __webpack_require__(1583);
	
	var _AthleteById2 = _interopRequireDefault(_AthleteById);
	
	var _redux = __webpack_require__(481);
	
	var _actions = __webpack_require__(1336);
	
	var _actions2 = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// use of immutablejs for various js operations to simplify our work
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	// to show loder on screen whenever there is a api call or operations in component
	
	// to import local scss fle
	
	
	var AthleteById = function (_Component) {
	  _inherits(AthleteById, _Component);
	
	  function AthleteById(props) {
	    _classCallCheck(this, AthleteById);
	
	    var _this = _possibleConstructorReturn(this, (AthleteById.__proto__ || Object.getPrototypeOf(AthleteById)).call(this, props));
	
	    _this.updateContactInfo = function () {
	      var _this$props = _this.props,
	          request = _this$props.request,
	          profile = _this$props.profile;
	
	      var lastconvo = request.get('conversation').last();
	      var conversation = {
	        id: request.get('id'),
	        action: 'SA SENT CONTACT INFO',
	        created_by: 'SA',
	        sa_email: profile.get('sa_email'),
	        sa_mobile: profile.get('sa_mobile'),
	        sa_name: profile.get('fullname'),
	        coach_email: lastconvo.get('coach_email')
	      };
	      _this.props.updateConversation(conversation, 'public');
	    };
	
	    _this.state = {
	      showFullScreenVideo: false,
	      videoOnProfile: false,
	      showActionableItems: false,
	      coachEmail: ''
	    };
	    return _this;
	  }
	
	  _createClass(AthleteById, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var query = _queryString2.default.parse(this.props.location.search);
	      var coachEmail = query.coach_email;
	      var saId = query.sa;
	      var requestId = query.req;
	      if (requestId && requestId.length > 0 && coachEmail && coachEmail.length > 0 && saId && saId.length > 0) {
	        this.props.getRequestById(requestId);
	        this.props.getSAProfile(saId);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.conversationUpdated !== this.props.conversationUpdated) {
	        var id = this.props.match.params.id;
	        this.props.getProfileForCoach(id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          request = _props.request,
	          requested = _props.requested;
	
	
	      var lastConvo = {};
	      var lastConvoAction = '';
	      if (request.size > 0) {
	        var convo = this.props.request.get('conversation');
	        lastConvo = convo.last();
	        lastConvoAction = lastConvo.get('action');
	      }
	      var renderSuccessful = (0, _renderIf2.default)(lastConvoAction === 'SA SENT CONTACT INFO');
	      var renderSendContactInfoButton = (0, _renderIf2.default)(lastConvoAction === 'SEND CONTACT INFO');
	      var renderIfLoading = (0, _renderIf2.default)(requested && request.size > 0);
	      return _react2.default.createElement(
	        'div',
	        { className: _AthleteById2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _AthleteById2.default.headerContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _AthleteById2.default.navBar) },
	            _react2.default.createElement(_Navbar2.default, Object.assign({}, this.props, { usedFor: 'profile_page' }))
	          )
	        ),
	        renderIfLoading(_react2.default.createElement(_FullScreenLoader2.default, null)),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _AthleteById2.default.infoContainer) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _AthleteById2.default.actionContainer) },
	            renderSuccessful(_react2.default.createElement(
	              'span',
	              { className: _AthleteById2.default.greenMessage },
	              'Your contact info has been sent successfully!'
	            )),
	            renderSendContactInfoButton(_react2.default.createElement(
	              'div',
	              { className: _AthleteById2.default.actionableButtonContainer },
	              _react2.default.createElement(
	                'span',
	                null,
	                'Click below button to send your contact info to coach.'
	              ),
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(_button.Button, { label: 'SEND CONTACT INFO', onClick: this.updateContactInfo })
	            ))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('row', _AthleteById2.default.profileContainer) },
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return AthleteById;
	}(_react.Component);
	
	AthleteById.propTypes = {
	  profile: _propTypes2.default.shape(),
	  match: _propTypes2.default.shape(),
	  requested: _propTypes2.default.bool,
	  getProfileForCoach: _propTypes2.default.func,
	  updateConversation: _propTypes2.default.func.isRequired,
	  getSAProfile: _propTypes2.default.func,
	  getRequestById: _propTypes2.default.func.isRequired,
	  request: _propTypes2.default.shape(),
	  conversationUpdated: _propTypes2.default.bool.isRequired,
	  location: _propTypes2.default.shape().isRequired
	};
	AthleteById.defaultProps = {
	  history: {},
	  profile: (0, _immutable.Map)(),
	  request: (0, _immutable.Map)(),
	  getSAProfile: function getSAProfile() {},
	  requested: false,
	  getProfileForCoach: function getProfileForCoach() {},
	  match: {
	    params: {
	      id: ''
	    }
	  }
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getRequestById: _actions.getRequestById,
	  getSAProfile: _actions.getSAProfile,
	  updateConversation: _actions2.updateConversation
	})((0, _SessionReplica2.default)(AthleteById));

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSAProfile = getSAProfile;
	exports.getRequestById = getRequestById;
	
	var _immutable = __webpack_require__(11);
	
	var _saProfile = __webpack_require__(94);
	
	var _actionTypes = __webpack_require__(289);
	
	// use of immutablejs for various js operations to simplify our work
	
	function getSAProfile(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _saProfile.getPublicProfile)(id).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.SUCCESSFUL,
	          profile: (0, _immutable.fromJS)(data)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}
	
	function getRequestById(id) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _saProfile.getPublicRequestById)(id).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.PUBLIC_ATHLETE_REQUEST,
	          request: (0, _immutable.fromJS)(data.request)
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1337 */
[2534, 1335],
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _analytics = __webpack_require__(37);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _routeNames = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to validate and set default props  coming to this component
	
	
	var Redirect = function (_Component) {
	  _inherits(Redirect, _Component);
	
	  function Redirect(props) {
	    _classCallCheck(this, Redirect);
	
	    var _this = _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Redirect, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.attributes.size > 0) {
	        if (this.props.attributes.get('zoneinfo') === 'COACH') {
	          this.props.history.push(_routeNames.VerifyCoach);
	        } else if (this.props.attributes.get('zoneinfo') === 'ADMIN') {
	          this.props.history.push(_routeNames.AdminBase);
	        } else if (this.props.attributes.get('zoneinfo') === 'STUDENT') {
	          this.props.history.push(_routeNames.ViewAthlete);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.attributes.size > 0) {
	        if (nextProps.attributes.get('zoneinfo') === 'COACH' && nextProps.attributes.get('profile') !== 'PENDING') {
	          this.props.history.push(_routeNames.CoachDashboard);
	        } else if (nextProps.attributes.get('zoneinfo') === 'COACH' && nextProps.attributes.get('profile') === 'PENDING') {
	          this.props.history.push(_routeNames.VerifyCoach);
	        } else if (nextProps.attributes.get('zoneinfo') === 'ADMIN') {
	          this.props.history.push(_routeNames.AdminBase);
	        } else if (nextProps.attributes.get('zoneinfo') === 'STUDENT') {
	          this.props.history.push(_routeNames.ViewAthlete);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', null);
	    }
	  }]);
	
	  return Redirect;
	}(_react.Component);
	
	Redirect.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  history: _propTypes2.default.shape()
	};
	Redirect.defaultProps = {
	  attributes: {},
	  push: _propTypes2.default.func.isRequired,
	  history: {
	    push: function push() {}
	  }
	};
	exports.default = (0, _Session2.default)(Redirect);

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Redirect = __webpack_require__(1338);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerUser;
	
	var _immutable = __webpack_require__(11);
	
	var _localStorage = __webpack_require__(56);
	
	var _session = __webpack_require__(73);
	
	var service = _interopRequireWildcard(_session);
	
	var _RegisterActionTypes = __webpack_require__(201);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Created by sairam on 25/04/17.
	 */
	function registerUser(username, password, attributes) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _RegisterActionTypes.REGISTER_REQUESTED
	    });
	    service.RegisterUser(username, password, attributes, function (err, result) {
	      if (err) {
	        dispatch({
	          type: _RegisterActionTypes.REGISTER_FAILED,
	          error: {
	            code: err.code,
	            message: err.message
	          }
	        });
	      } else {
	        // Storing token in to local storage
	        // const token = result.session.idToken.jwtToken;
	        (0, _localStorage.setItem)('isLoggedIn', true);
	        // setItem('token', token);
	        // end of dangerous code
	        dispatch({
	          type: _RegisterActionTypes.REGISTER_SUCCESSFUL,
	          session: (0, _immutable.fromJS)(result.session),
	          user: (0, _immutable.fromJS)(result.user)
	          // token,
	        });
	      }
	    });
	  };
	} // use of immutablejs for various js operations to simplify our work

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Signup = __webpack_require__(1226);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Banner = __webpack_require__(95);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Details = __webpack_require__(196);
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _reactRouter = __webpack_require__(89);
	
	var _analytics = __webpack_require__(37);
	
	var _reactRedux = __webpack_require__(27);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _Register = __webpack_require__(482);
	
	var _Register2 = __webpack_require__(1340);
	
	var _Register3 = _interopRequireDefault(_Register2);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Register4 = __webpack_require__(1584);
	
	var _Register5 = _interopRequireDefault(_Register4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to connect to redux store from containers redux.js or any other redux store
	// to validate and set default props  coming to this component
	// to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var Register = function (_Component) {
	  _inherits(Register, _Component);
	
	  function Register(props) {
	    _classCallCheck(this, Register);
	
	    var _this = _possibleConstructorReturn(this, (Register.__proto__ || Object.getPrototypeOf(Register)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Register, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.isValid) {
	        this.props.history.push('/');
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var joinUsData = {
	        bannerHeader: 'JOIN THE GREATEST',
	        bannerDesc: "We're proud to make recruiting simpler, faster and more personal with greater exposure.",
	        detailsHeader: 'Join MyRecruitBoard',
	        detailsDesc: '',
	        otherPages: true,
	        page: 'register'
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Register5.default.joinUsContainer) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s6', _Register5.default.joinUsBanner) },
	          _react2.default.createElement(_Banner2.default, { data: joinUsData, usedFor: 'register' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12 m6', _Register5.default.joinUsDetails) },
	          _react2.default.createElement(
	            _Details2.default,
	            Object.assign({ data: joinUsData }, this.props),
	            _react2.default.createElement(_Signup2.default, this.props)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Register;
	}(_react.Component);
	
	Register.propTypes = {
	  isValid: _propTypes2.default.bool.isRequired,
	  history: _propTypes2.default.shape()
	};
	Register.defaultProps = {
	  history: {}
	};
	exports.default = (0, _reactRedux.connect)(_Register.registerSelector, {
	  registerUser: _Register3.default
	})((0, _reactRouter.withRouter)((0, _SessionReplica2.default)(Register)));

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Register = __webpack_require__(1341);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Register2.default;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProfileBanner = __webpack_require__(198);
	
	var _ProfileBanner2 = _interopRequireDefault(_ProfileBanner);
	
	var _GetUserDetails = __webpack_require__(456);
	
	var _GetUserDetails2 = _interopRequireDefault(_GetUserDetails);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _Footer = __webpack_require__(454);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Parent = __webpack_require__(1585);
	
	var _Parent2 = _interopRequireDefault(_Parent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	
	// to import local scss fle
	
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile(props) {
	    _classCallCheck(this, Profile);
	
	    var _this = _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(Profile, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Parent2.default.profileContainer) },
	        _react2.default.createElement(_ProfileBanner2.default, null),
	        _react2.default.createElement(_GetUserDetails2.default, Object.assign({}, this.props, { usedFor: 'parent' })),
	        _react2.default.createElement(_Footer2.default, null)
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	exports.default = (0, _Session2.default)(Profile);

/***/ },
/* 1344 */
[2535, 1343],
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _localStorage = __webpack_require__(56);
	
	var _analytics = __webpack_require__(37);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(27);
	
	var _renderIf = __webpack_require__(10);
	
	var _renderIf2 = _interopRequireDefault(_renderIf);
	
	var _DashBoardHeader = __webpack_require__(451);
	
	var _DashBoardHeader2 = _interopRequireDefault(_DashBoardHeader);
	
	var _SettingsView = __webpack_require__(1223);
	
	var _SettingsView2 = _interopRequireDefault(_SettingsView);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(281);
	
	var _actions2 = __webpack_require__(1346);
	
	var _redux = __webpack_require__(483);
	
	var _Settings = __webpack_require__(1586);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	// to connect to redux store from containers redux.js or any other redux store
	// to use conditional rendering based on values that is provided to component
	// to validate and set default props  coming to this component
	
	
	// to import local scss fle
	
	var Settings = function (_Component) {
	  _inherits(Settings, _Component);
	
	  function Settings(props) {
	    _classCallCheck(this, Settings);
	
	    var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));
	
	    var currentIndex = 0;
	    if (_this.props.location.search !== '') {
	      currentIndex = 1;
	    }
	    _this.state = {
	      value: '',
	      tab: currentIndex,
	      localZone: ''
	    };
	    _this.tabListener = _this.tabListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(Settings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var currentLocalZone = (0, _localStorage.getItem)('localZone');
	      if (currentLocalZone === 'STUDENT') {
	        this.setState({ localZone: currentLocalZone });
	      } else {
	        this.setState({ localZone: currentLocalZone });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      var currentLocalZone = (0, _localStorage.getItem)('localZone');
	      if (currentLocalZone === 'STUDENT') {
	        this.setState({ localZone: currentLocalZone });
	      } else {
	        this.setState({ localZone: currentLocalZone });
	      }
	    }
	  }, {
	    key: 'tabListener',
	    value: function tabListener(tab) {
	      this.setState({ tab: tab });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderCoachSettingsScreen = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'COACH' || this.state.localZone === 'COACH');
	      var renderAthleteSettingsScreen = (0, _renderIf2.default)(this.props.attributes.get('zoneinfo') === 'STUDENT' || this.props.attributes.get('zoneinfo') === 'PARENT' || this.state.localZone === 'STUDENT');
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row', _Settings2.default.cotnainer) },
	        renderAthleteSettingsScreen(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_DashBoardHeader2.default, Object.assign({ tabListener: this.tabListener }, this.props, { usedFor: 'settingsAthlete' })),
	          _react2.default.createElement(_SettingsView2.default, Object.assign({}, this.props, this.state, { usedFor: 'athlete' })),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Settings2.default.removePadding) },
	            _react2.default.createElement(_MiniFooter2.default, null)
	          )
	        )),
	        renderCoachSettingsScreen(_react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_DashBoardHeader2.default, Object.assign({ tabListener: this.tabListener }, this.props, { usedFor: 'settingsCoach' })),
	          _react2.default.createElement(_SettingsView2.default, Object.assign({}, this.props, this.state, { usedFor: 'coach' })),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12', _Settings2.default.removePadding) },
	            _react2.default.createElement(_MiniFooter2.default, null)
	          )
	        ))
	      );
	    }
	  }]);
	
	  return Settings;
	}(_react.Component);
	
	Settings.propTypes = {
	  attributes: _propTypes2.default.shape(),
	  location: _propTypes2.default.shape().isRequired
	};
	Settings.defaultProps = {
	  attributes: {}
	};
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getSAProfile: _actions.getSAProfile,
	  saveSAProfile: _actions.saveSAProfile,
	  searchSchools: _actions.searchSchools,
	  changePassword: _actions2.changePassword,
	  getPaymentHistory: _actions2.getPaymentHistory
	})((0, _Session2.default)(Settings));

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changePassword = changePassword;
	exports.getPaymentHistory = getPaymentHistory;
	
	var _session = __webpack_require__(73);
	
	var _payment = __webpack_require__(442);
	
	var _actionTypes = __webpack_require__(290);
	
	function changePassword(currentPassword, password) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.REQUESTED
	    });
	    (0, _session.resetPassword)(currentPassword, password, function (err) {
	      if (err) {
	        dispatch({
	          type: _actionTypes.FAILED
	        });
	      } else {
	        dispatch({
	          type: _actionTypes.SUCCESSFUL
	        });
	      }
	    });
	  };
	}
	
	function getPaymentHistory(id) {
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.PAYMENT_HISTORY_REQUESTED
	    });
	    (0, _payment.getPayments)(id).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.PAYMENT_HISTORY_SUCCESSFUL,
	          result: data
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.PAYMENT_HISTORY_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Settings = __webpack_require__(1345);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Settings2.default;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _StaticPageHeader = __webpack_require__(286);
	
	var _StaticPageHeader2 = _interopRequireDefault(_StaticPageHeader);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _reactHelmet = __webpack_require__(180);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _analytics = __webpack_require__(37);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sports = __webpack_require__(1587);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	//  to change path from inside or to alter react-router-dom path
	
	
	// to import local scss fle
	
	var Sports = function (_Component) {
	  _inherits(Sports, _Component);
	
	  function Sports(props) {
	    _classCallCheck(this, Sports);
	
	    var _this = _possibleConstructorReturn(this, (Sports.__proto__ || Object.getPrototypeOf(Sports)).call(this, props));
	
	    _this.state = {
	      showFixedNavbar: false
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(Sports, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      if (scrollTop > 80) {
	        this.setState({ showFixedNavbar: true });
	      } else {
	        this.setState({ showFixedNavbar: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row') },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'MyRecruitBoard \u2013 Get Recruited. Unmatched Social Media Exposure!'
	          ),
	          _react2.default.createElement('meta', { name: 'description', content: 'College Football Recruiting Unmatched Social Media Exposure!' }),
	          _react2.default.createElement('meta', { name: 'Keywords', content: 'RECRUITING Exposure,Largest Football Recruiting, NCAA D1, D2, D3, NAIA, & JUCO College Coaches' })
	        ),
	        this.state.showFixedNavbar === true ? _react2.default.createElement(_NavOnScroll2.default, this.props) : '',
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Sports2.default.header) },
	          _react2.default.createElement(_StaticPageHeader2.default, Object.assign({ page: 'sports' }, this.props))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Sports2.default.sportsWeSupport) },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _Sports2.default.imageContainer) },
	            _react2.default.createElement('img', { alt: 'football', src: 'https://media.dev.myrecruitboard.com/Images/myrb-sports-pic1.jpg' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6') },
	            _react2.default.createElement(
	              'div',
	              { className: _Sports2.default.bigHeader },
	              'The Largest Football Recruiting Account on Twitter'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Sports2.default.darkHeader },
	              'GET RECRUITED TODAY!'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _Sports2.default.desc },
	              'We have the largest college football recruiting account on Twitter. Unlike other major national football recruiting companies we provide exposure to every level of college football.  MyRecruitBoard does all of this without charging your family hundreds or even worse thousands of dollars. ',
	              _react2.default.createElement('br', null),
	              'NCAA D1, D2, D3, NAIA, & JUCO College Coaches direct message us everyday looking for their next recruit.'
	            ),
	            this.props.attributes.size > 0 ? '' : _react2.default.createElement(
	              _reactRouterDom.Link,
	              { to: '/register' },
	              _react2.default.createElement(
	                'button',
	                { className: _Sports2.default.createProfile },
	                'JOIN NOW'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('col s12 m6', _Sports2.default.imageContainerInSmall) },
	            _react2.default.createElement('img', { alt: 'football', src: 'https://media.dev.myrecruitboard.com/Images/myrb-sports-pic1.jpg' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Sports2.default.footerContainer) },
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Sports;
	}(_react.Component);
	
	Sports.propTypes = {
	  attributes: _propTypes2.default.shape()
	};
	Sports.defaultProps = {
	  attributes: {}
	};
	exports.default = (0, _SessionReplica2.default)(Sports);

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Sports = __webpack_require__(1348);
	
	var _Sports2 = _interopRequireDefault(_Sports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sports2.default;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(37);
	
	var _reactHelmet = __webpack_require__(180);
	
	var _SessionReplica = __webpack_require__(75);
	
	var _SessionReplica2 = _interopRequireDefault(_SessionReplica);
	
	var _MiniFooter = __webpack_require__(44);
	
	var _MiniFooter2 = _interopRequireDefault(_MiniFooter);
	
	var _StaticPageHeader = __webpack_require__(286);
	
	var _StaticPageHeader2 = _interopRequireDefault(_StaticPageHeader);
	
	var _NavOnScroll = __webpack_require__(86);
	
	var _NavOnScroll2 = _interopRequireDefault(_NavOnScroll);
	
	var _Terms = __webpack_require__(1588);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // to use global class name eg. classes from grid.css in public folder
	
	// import { Link } from 'react-router-dom'; //
	// to change path from inside or to alter react-router-dom path
	// import PropTypes from 'prop-types';
	
	
	// to import local scss fle
	
	var Terms = function (_Component) {
	  _inherits(Terms, _Component);
	
	  function Terms(props) {
	    _classCallCheck(this, Terms);
	
	    var _this = _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).call(this, props));
	
	    _this.state = {
	      showFixedNavbar: false
	    };
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(Terms, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	
	      window.addEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('scroll', this.handleScroll);
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(event) {
	      var scrollTop = event.srcElement.body.scrollTop;
	      if (scrollTop > 80) {
	        this.setState({ showFixedNavbar: true });
	      } else {
	        this.setState({ showFixedNavbar: false });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('row') },
	        _react2.default.createElement(
	          _reactHelmet.Helmet,
	          null,
	          _react2.default.createElement(
	            'title',
	            null,
	            'MyRecruitBoard \u2013 Get Recruited. Terms and Conditions'
	          ),
	          _react2.default.createElement('meta', { name: 'description', content: 'MyRecruitBoard. Terms and Conditions' }),
	          _react2.default.createElement('meta', { name: 'Keywords', content: 'MyRecruitBoard Terms and Conditions' })
	        ),
	        this.state.showFixedNavbar === true ? _react2.default.createElement(_NavOnScroll2.default, this.props) : '',
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Terms2.default.header) },
	          _react2.default.createElement(_StaticPageHeader2.default, Object.assign({ page: 't&c' }, this.props))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Terms2.default.sportsWeSupport) },
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'INTRODUCTION'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'Welcome to www.MyRecruitBoard.com. This website is owned and operated by My RecruitBoard, LLC (hereafter referred to as \'we\', \'our\', or \'us\'). By visiting our website and accessing the information, resources, services, products, and tools we provide, you understand and agree to accept and adhere to the following terms and conditions as stated in this policy (hereafter referred to as \'User Agreement\').',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'This agreement is in effect as of May 1, 2015.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'We reserve the right to change this User Agreement from time to time without notice. You acknowledge and agree that it is your responsibility to review this User Agreement periodically to familiarize yourself with any modifications. Your continued use of this site after such modifications will constitute acknowledgment and agreement of the modified terms and conditions.'
	          ),
	          _react2.default.createElement('br', null),
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'RESPONSIBLE USE AND CONDUCT'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'By visiting our website and accessing the information, resources, services, products, and tools we provide for you, either directly or indirectly (hereafter referred to as \'Resources\'), you agree to use these Resources only for the purposes intended as permitted by (a) the terms of this User Agreement, and (b) applicable laws, regulations and generally accepted online practices or guidelines.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'Wherein, you understand that:',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'a. In order to access our Resources, you may be required to provide certain information about yourself (such as identification, contact details, etc.) as part of the registration process, or as part of your ability to use the Resources. You agree that any information you provide will always be accurate, correct, and up to date.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'b. You are responsible for maintaining the confidentiality of any login information associated with any account you use to access our Resources. Accordingly, you are responsible for all activities that occur under your account/s.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'c. Accessing (or attempting to access) any of our Resources by any means other than through the means we provide, is strictly prohibited. You specifically agree not to access (or attempt to access) any of our Resources through any automated, unethical or unconventional means.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'd. Engaging in any activity that disrupts or interferes with our Resources, including the servers and/or networks to which our Resources are located or connected, is strictly prohibited.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'e. Attempting to copy, duplicate, reproduce, sell, trade, or resell our Resources is strictly prohibited.  All information, search criteria, forums, layout/design, and database structure and coding of our website is OWNED by My RecruitBoard. It cannot be copied or redistributed in ANY way at ANY time.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'f. You are solely responsible for any consequences, losses, or damages that we may directly or indirectly incur or suffer due to any unauthorized activities conducted by you, as explained above, and may incur criminal or civil liability.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'g. We may provide various open communication tools on our website, such as blog comments, blog posts, public chat, forums, message boards, newsgroups, product ratings and reviews, various social media services, etc. You understand that generally we do not pre-screen or monitor the content posted by users of these various communication tools, which means that if you choose to use these tools to submit any type of content to our website, then it is your personal responsibility to use these tools in a responsible and ethical manner. By posting information or otherwise using any open communication tools as mentioned, you agree that you will not upload, post, share, or otherwise distribute any content that:',
	            _react2.default.createElement('br', null),
	            '1. Is illegal, threatening, defamatory, abusive, harassing, degrading, intimidating, fraudulent, deceptive, ',
	            _react2.default.createElement('br', null),
	            'invasive, racist, or contains any type of suggestive, inappropriate, or explicit language.',
	            _react2.default.createElement('br', null),
	            '2. Infringes on any trademark, patent, trade secret, copyright, or other proprietary right of any party.',
	            _react2.default.createElement('br', null),
	            '3. Contains any type of unauthorized or unsolicited advertising; or',
	            _react2.default.createElement('br', null),
	            '4. Impersonates any person or entity, including any www.MyRecruitBoard.com employees or representatives.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'We have the right at our sole discretion to remove any content that, we feel in our judgment does not comply with this User Agreement, along with any content that we feel is otherwise offensive, harmful, objectionable, inaccurate, or violates any 3rd party copyrights or trademarks. We are not responsible for any delay or failure in removing such content. If you post content that we choose to remove, you hereby consent to such removal, and consent to waive any claim against us.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'h. We do not assume any liability for any content posted by you or any other third party users of our website. However, any content posted by you using any open communication tools on our website, provided that it doesn&apo;t violate or infringe on any third party copyrights or trademarks, becomes the property of My RecruitBoard, and as such, gives us a perpetual, irrevocable, worldwide, royalty-free, exclusive license to reproduce, modify, adapt, translate, publish, publicly display and/or distribute as we see fit. This only refers and applies to content posted via open communication tools as described, and does not refer to information that is provided as part of the registration process, necessary in order to use our Resources.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'i. You agree to indemnify and hold harmless My RecruitBoard and its parent company and affiliates, and their directors, officers, managers, employees, donors, agents, and licensors, from and against all losses, expenses, damages and costs, including reasonable attorneys\' fees, resulting from any violation of this User Agreement or the failure to fulfill any obligations relating to your account incurred by you or any other person using your account. We reserve the right to take over the exclusive defense of any claim for which we are entitled to indemnification under this User Agreement. In such event, you shall provide us with such cooperation as is reasonably requested by us.',
	            _react2.default.createElement('br', null),
	            'j. We do not permit persons under the age of 13 to use our resources.  You agree that any information you provide will always be accurate, correct, and up to date.',
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'SUBSCRIPTION SERVICE TERMS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'My RecruitBoard accounts are available and must be obtained on a subscription basis with recurring payments. You agree to pay your subscription fee every month. We reserve the right to discontinue or modify any subscription fee payment option at any time without notice.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'PAYMENT METHOD AND TERMS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'We accept major credit cards and PayPal, as forms of payment. By becoming a member of My RecruitBoard, you authorize us to charge the account you specify for the subscription amount. All payments are final and are to be made in United States Dollars. If we do not receive your payment when it is due, for any reason, your membership will be temporarily suspended until full payment is received.  During this time, you will appear invisible to all other My RecruitBoard members (coaches and players alike). When your account returns to good standing, full access will be granted and you can continue using your account as normal.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'For monthly payment plans you are responsible for the following payment terms. You will be charged for the entire duration of the subscription length you selected upon payment agreement.',
	            _react2.default.createElement('br', null),
	            'When you have fulfilled your subscription, you can choose your method of renewal.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            '$9.99 USD per month for a minimum 12 month period.',
	            _react2.default.createElement('br', null),
	            '$14.99 USD per month for a minimum 6 month period.',
	            _react2.default.createElement('br', null),
	            '$19.99 USD per month for a minimum 3 month period.',
	            _react2.default.createElement('br', null),
	            '$29.99 USD for a single month.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'If you choose to pay for your entire subscription in full at the beginning of your term, you will have the option to renew at the end of the subscription period you selected upon payment agreement. Any cancellations will NOT PROVIDE A REFUND. You are also not able to opt out of completing the rest of your monthly payments during your contract term.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'CANCELLATION AND REFUNDS'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'Payments for Subscription Services are non-refundable. If for any reason you decide to cancel your subscription before the term for which you paid is up, your cancellation will take effect immediately and you will not receive a refund. However, your member page will stay active through the end of your prepaid billing cycle.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Limitation of Warranties'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'By using our website, you understand and agree that all resources we provide are "as is" and "as available". This means that we do not represent or warrant to you that:',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            '1. the use of our resources will meet your needs or requirements.',
	            _react2.default.createElement('br', null),
	            '2. the use of our resources will be uninterrupted, timely, secure or free from errors.',
	            _react2.default.createElement('br', null),
	            '3. the information obtained by using our resources will be accurate or reliable',
	            _react2.default.createElement('br', null),
	            ' and 4. any defects in the operation or functionality of any resources we provide will be repaired or corrected.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            'Furthermore, you understand and agree that:',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            '5. any content downloaded or otherwise obtained through the use of our Resources is done at your own discretion and risk, and that you are solely responsible for any damage to your computer or other devices for any loss of data that may result from the download of such content.',
	            _react2.default.createElement('br', null),
	            '6. no information or advice, whether expressed, implied, oral or written, obtained by you from My RecruitBoard or through any Resources we provide shall create any warranty, guarantee, or conditions of any kind, except for those expressly outlined in this User Agreement.',
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Limitation of Liability'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'In conjunction with the Limitation of Warranties as explained above, you expressly understand and agree that any claim against us shall be limited to the amount you paid, if any, for use of products and/or services. My RecruitBoard will not be liable for any direct, indirect, incidental, consequential or exemplary loss or damages which may be incurred by you as a result of using our Resources, or as a result of any changes, data loss or corruption, cancellation, loss of access, or downtime to the full extent that applicable limitation of liability laws apply.',
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Copyrights/Trademarks'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'All content and materials available on www.MyRecruitBoard.com, including but not limited to text, graphics, website name, code, images and logos are the intellectual property of My RecruitBoard and are protected by applicable copyright and trademark law. Any inappropriate use, including but not limited to the reproduction, distribution, display or transmission of any content on this site is strictly prohibited, unless specifically authorized by MyRecruitBoard.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Termination of Use'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'You agree that we may, at our sole discretion, suspend or terminate your access to all or part of our website and Resources with or without notice and for any reason, including, without limitation, breach of this User Agreement. Any suspected illegal, fraudulent or abusive activity may be grounds for terminating your relationship and may be referred to appropriate law enforcement authorities. Upon suspension or termination, your right to use the Resources we provide will immediately cease, and we reserve the right to remove or delete any information that you may have on file with us, including any account or login information.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Advertisements'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'MyRecruitBoard may engage in partnerships with third party providers or partners for the purpose of advertising their services, at any time.  You agree that MyRecruitBoard may use your information to selectively advertise to you.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Governing Law'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'This website is controlled by My RecruitBoard, LLC. It can be accessed by most countries around the world. By accessing our website, you agree that the statutes and laws of our state, without regard to the conflict of laws and the United Nations Convention on the International Sales of Goods, will apply to all matters relating to the use of this website and the purchase of any products or services through this site.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Furthermore, any action to enforce this User Agreement shall be brought in the federal or state courts you hereby agree to personal jurisdiction by such courts, and waive any jurisdictional, venue, or inconvenient forum objections to such courts.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Privacy'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'Your privacy is important to you, therefore it is important to My RecruitBoard.  Content that you display on your member page is available to all My RecruitBoard members, but will not be shared outside the website.  This includes biometric statistics, schedules, academic and personal information.  Links to outside websites that you share such as Twitter, Facebook, or YouTube, are protected by those individual sites and My RecruitBoard is not liable for any breach of this information.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.bigHeader },
	            'Guarantee'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'UNLESS OTHERWISE EXPRESSED, MyRecruitBoard, LLC EXPRESSLY DISCLAIMS ALL WARRANTIES AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _Terms2.default.desc },
	            'If you have any questions or comments about these our Terms of Service as outlined above, you can contact us at:',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:' },
	              'Info@MyRecruitBoard.com'
	            ),
	            _react2.default.createElement('br', null),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: _Terms2.default.bigHeader },
	              'Intellectual Property'
	            ),
	            _react2.default.createElement('br', null),
	            '\xA9 2015 My RecruitBoard, LLC.  All rights reserved.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('col s12', _Terms2.default.footerContainer) },
	          _react2.default.createElement(_MiniFooter2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Terms;
	}(_react.Component);
	
	Terms.propTypes = {
	  // attributes: PropTypes.shape(),
	};
	Terms.defaultProps = {
	  attributes: {}
	};
	exports.default = (0, _SessionReplica2.default)(Terms);

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Terms = __webpack_require__(1350);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Terms2.default;

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Session = __webpack_require__(50);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _analytics = __webpack_require__(37);
	
	var _reactRedux = __webpack_require__(27);
	
	var _ValidateCoach = __webpack_require__(1253);
	
	var _ValidateCoach2 = _interopRequireDefault(_ValidateCoach);
	
	var _redux = __webpack_require__(485);
	
	var _actions = __webpack_require__(1353);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import PropTypes from 'prop-types';
	// to connect to redux store from containers redux.js or any other redux store
	
	
	var VerifyCoach = function (_Component) {
	  _inherits(VerifyCoach, _Component);
	
	  // static propTypes = {
	  //   logoutUser: PropTypes.func.isRequired,
	  // };
	
	  function VerifyCoach(props) {
	    _classCallCheck(this, VerifyCoach);
	
	    var _this = _possibleConstructorReturn(this, (VerifyCoach.__proto__ || Object.getPrototypeOf(VerifyCoach)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	    return _this;
	  }
	
	  _createClass(VerifyCoach, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _analytics.initGA)();
	      (0, _analytics.logPageView)(this.props.match.path); // eslint-disable-line
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ValidateCoach2.default, this.props)
	      );
	    }
	  }]);
	
	  return VerifyCoach;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(_redux.selector, { getCoachFromDatabase: _actions2.default })((0, _Session2.default)(VerifyCoach));

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCoachFromDatabase;
	
	var _coachProfile = __webpack_require__(192);
	
	var _CoachRegistration = __webpack_require__(108);
	
	var _actionTypes = __webpack_require__(484);
	
	// import { fromJS } from 'immutable';
	function getCoachFromDatabase(payload) {
	  // eslint-disable-line
	  return function (dispatch) {
	    dispatch({
	      type: _actionTypes.GET_COACH_FROM_DATABASE_REQUESTED
	    });
	    (0, _coachProfile.validataCoachFromDatabase)(payload).then(function (data) {
	      if (data) {
	        dispatch({
	          type: _actionTypes.GET_COACH_FROM_DATABASE_SUCCESSFUL,
	          validCoach: data
	        });
	        dispatch({
	          type: _CoachRegistration.GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTRATION,
	          validCoach: data
	        });
	      }
	    }).catch(function (err) {
	      dispatch({
	        type: _actionTypes.GET_COACH_FROM_DATABASE_FAILED,
	        error: err
	      });
	    });
	  };
	}

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _VerifyCoach = __webpack_require__(1352);
	
	var _VerifyCoach2 = _interopRequireDefault(_VerifyCoach);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VerifyCoach2.default;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(21);
	
	var _createHashHistory = __webpack_require__(1608);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _reactRedux = __webpack_require__(27);
	
	var _reactRouterRedux = __webpack_require__(241);
	
	__webpack_require__(1428);
	
	__webpack_require__(1427);
	
	__webpack_require__(1429);
	
	var _MuiThemeProvider = __webpack_require__(2017);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(552);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _routes = __webpack_require__(1066);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(1356);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(1594);
	
	__webpack_require__(1589);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// to import local scss fle
	
	
	if (!window) {
	  window = global;
	}
	
	var history = (0, _createHashHistory2.default)();
	
	/* commit purpose */
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _MuiThemeProvider2.default,
	  { muiTheme: (0, _getMuiTheme2.default)() },
	  _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: _store2.default },
	    _react2.default.createElement(
	      _reactRouterRedux.ConnectedRouter,
	      { history: history },
	      _routes2.default
	    )
	  )
	), document.getElementById('root'));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(265);
	
	var _reactRouterDom = __webpack_require__(18);
	
	var _reducers = __webpack_require__(35);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxThunk = __webpack_require__(2487);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reactRouterRedux = __webpack_require__(241);
	
	var _reduxDevtoolsExtension = __webpack_require__(2486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-line
	
	var enhancer = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouterDom.browserHistory)));
	
	// Add the reducer to your store on the `routing` key
	var store = (0, _redux.createStore)(_reducers2.default, (0, _reduxDevtoolsExtension.composeWithDevTools)(enhancer));
	
	// Create an enhanced history that syncs navigation events with the store
	exports.default = store;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1365), __esModule: true };

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1366), __esModule: true };

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1367), __esModule: true };

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1370), __esModule: true };

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1371), __esModule: true };

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1372), __esModule: true };

/***/ },
/* 1364 */
[2536, 501, 1394, 57],
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1396);
	module.exports = __webpack_require__(57).Object.assign;


/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1397);
	var $Object = __webpack_require__(57).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1398);
	var $Object = __webpack_require__(57).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1399);
	module.exports = __webpack_require__(57).Object.getPrototypeOf;


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1400);
	module.exports = __webpack_require__(57).Object.keys;


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1401);
	module.exports = __webpack_require__(57).Object.setPrototypeOf;


/***/ },
/* 1371 */
[2537, 1403, 1402, 1404, 1405, 57],
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(501);
	__webpack_require__(1406);
	module.exports = __webpack_require__(303).f('iterator');


/***/ },
/* 1373 */
821,
/* 1374 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1375 */
[2539, 135, 500, 1392],
/* 1376 */
[2540, 291, 76],
/* 1377 */
[2541, 99, 163],
/* 1378 */
[2545, 162, 296, 203],
/* 1379 */
[2547, 98],
/* 1380 */
[2550, 161, 76],
/* 1381 */
[2551, 291],
/* 1382 */
[2552, 131],
/* 1383 */
[2553, 295, 163, 297, 133, 76],
/* 1384 */
[2555, 76],
/* 1385 */
832,
/* 1386 */
[2556, 204, 134, 112, 99, 132],
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(96);
	var getKeys = __webpack_require__(162);
	var gOPS = __webpack_require__(296);
	var pIE = __webpack_require__(203);
	var toObject = __webpack_require__(136);
	var IObject = __webpack_require__(492);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(132)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 1388 */
[2559, 99, 131, 162, 96],
/* 1389 */
[2561, 135, 495],
/* 1390 */
[2566, 134, 131, 292, 494],
/* 1391 */
[2570, 300, 293],
/* 1392 */
[2571, 300],
/* 1393 */
[2579, 1376, 76, 161, 57],
/* 1394 */
[2580, 292, 97, 136, 1382, 1380, 500, 1377, 1393, 1384],
/* 1395 */
[2581, 1374, 1385, 161, 135, 493],
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(97);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1387) });


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(97);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(295) });


/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(97);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(96), 'Object', { defineProperty: __webpack_require__(99).f });


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(136);
	var $getPrototypeOf = __webpack_require__(496);
	
	__webpack_require__(498)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(136);
	var $keys = __webpack_require__(162);
	
	__webpack_require__(498)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(97);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1390).set });


/***/ },
/* 1402 */
/***/ function(module, exports) {



/***/ },
/* 1403 */
[2583, 98, 112, 96, 97, 499, 1386, 132, 299, 297, 204, 76, 303, 302, 1378, 1381, 131, 134, 136, 135, 301, 163, 295, 1389, 494, 296, 99, 162, 495, 203, 202, 133],
/* 1404 */
[2584, 302],
/* 1405 */
[2585, 302],
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1395);
	var global = __webpack_require__(98);
	var hide = __webpack_require__(133);
	var Iterators = __webpack_require__(161);
	var TO_STRING_TAG = __webpack_require__(76)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 1407 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(2504)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}(g.braintree || (g.braintree = {})).dropin = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
	'use strict';
	
	var loadScript = require('./load-script');
	var loadStylesheet = require('./load-stylesheet');
	
	module.exports = {
	  loadScript: loadScript,
	  loadStylesheet: loadStylesheet
	};
	
	},{"./load-script":3,"./load-stylesheet":4}],2:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var PromisePolyfill = require('promise-polyfill');
	
	module.exports = global.Promise || PromisePolyfill;
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"promise-polyfill":127}],3:[function(require,module,exports){
	'use strict';
	
	var Promise = require('./lib/promise');
	var scriptPromiseCache = {};
	
	function loadScript(options) {
	  var attrs, container, script, scriptLoadPromise;
	  var stringifiedOptions = JSON.stringify(options);
	
	  if (!options.forceScriptReload) {
	    scriptLoadPromise = scriptPromiseCache[stringifiedOptions];
	
	    if (scriptLoadPromise) {
	      return scriptLoadPromise;
	    }
	  }
	
	  script = document.createElement('script');
	  attrs = options.dataAttributes || {};
	  container = options.container || document.head;
	
	  script.src = options.src;
	  script.id = options.id;
	  script.async = true;
	
	  if (options.crossorigin) {
	    script.setAttribute('crossorigin', options.crossorigin);
	  }
	
	  Object.keys(attrs).forEach(function (key) {
	    script.setAttribute('data-' + key, attrs[key]);
	  });
	
	  scriptLoadPromise = new Promise(function (resolve, reject) {
	    script.addEventListener('load', function () {
	      resolve(script);
	    });
	    script.addEventListener('error', function () {
	      reject(new Error(options.src + ' failed to load.'));
	    });
	    script.addEventListener('abort', function () {
	      reject(new Error(options.src + ' has aborted.'));
	    });
	    container.appendChild(script);
	  });
	
	  scriptPromiseCache[stringifiedOptions] = scriptLoadPromise;
	
	  return scriptLoadPromise;
	}
	
	loadScript.clearCache = function () {
	  scriptPromiseCache = {};
	};
	
	module.exports = loadScript;
	
	},{"./lib/promise":2}],4:[function(require,module,exports){
	'use strict';
	
	var Promise = require('./lib/promise');
	
	module.exports = function loadStylesheet(options) {
	  var container;
	  var stylesheet = document.querySelector('link[href="' + options.href + '"]');
	
	  if (stylesheet) {
	    return Promise.resolve(stylesheet);
	  }
	
	  stylesheet = document.createElement('link');
	  container = options.container || document.head;
	
	  stylesheet.setAttribute('rel', 'stylesheet');
	  stylesheet.setAttribute('type', 'text/css');
	  stylesheet.setAttribute('href', options.href);
	  stylesheet.setAttribute('id', options.id);
	
	  if (container.firstChild) {
	    container.insertBefore(stylesheet, container.firstChild);
	  } else {
	    container.appendChild(stylesheet);
	  }
	
	  return Promise.resolve(stylesheet);
	};
	
	},{"./lib/promise":2}],5:[function(require,module,exports){
	(function (global){
	'use strict';
	
	module.exports = function isAndroid(ua) {
	  ua = ua || global.navigator.userAgent;
	  return /Android/.test(ua);
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],6:[function(require,module,exports){
	'use strict';
	
	var isEdge = require('./is-edge');
	var isSamsung = require('./is-samsung');
	
	module.exports = function isChrome(ua) {
	  ua = ua || navigator.userAgent;
	  return (ua.indexOf('Chrome') !== -1 || ua.indexOf('CriOS') !== -1) && !isEdge(ua) && !isSamsung(ua);
	};
	
	},{"./is-edge":7,"./is-samsung":17}],7:[function(require,module,exports){
	'use strict';
	
	module.exports = function isEdge(ua) {
	  ua = ua || navigator.userAgent;
	  return ua.indexOf('Edge/') !== -1;
	};
	
	},{}],8:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var isIE11 = require('./is-ie11');
	
	module.exports = function isIE(ua) {
	  ua = ua || global.navigator.userAgent;
	  return ua.indexOf('MSIE') !== -1 || isIE11(ua);
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./is-ie11":10}],9:[function(require,module,exports){
	'use strict';
	
	module.exports = function isIe10(ua) {
	  ua = ua || navigator.userAgent;
	  return ua.indexOf('MSIE 10') !== -1;
	};
	
	},{}],10:[function(require,module,exports){
	'use strict';
	
	module.exports = function isIe11(ua) {
	  ua = ua || navigator.userAgent;
	  return ua.indexOf('Trident/7') !== -1;
	};
	
	},{}],11:[function(require,module,exports){
	'use strict';
	
	module.exports = function isIe9(ua) {
	  ua = ua || navigator.userAgent;
	  return ua.indexOf('MSIE 9') !== -1;
	};
	
	},{}],12:[function(require,module,exports){
	(function (global){
	'use strict';
	
	module.exports = function isIosFirefox(ua) {
	  ua = ua || global.navigator.userAgent;
	  return /FxiOS/i.test(ua);
	};
	
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],13:[function(require,module,exports){
	'use strict';
	
	var isIos = require('./is-ios');
	var webkitRegexp = /webkit/i;
	
	function isWebkit(ua) {
	  return ua.match(webkitRegexp);
	}
	
	module.exports = function isIosSafari(ua) {
	  ua = ua || navigator.userAgent;
	
	  return isIos(ua) && isWebkit(ua) && ua.indexOf('CriOS') === -1;
	};
	
	},{"./is-ios":15}],14:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var isIos = require('./is-ios');
	
	// The Google Search iOS app is technically a webview and doesn't support popups.
	function isGoogleSearchApp(ua) {
	  return /\bGSA\b/.test(ua);
	}
	
	module.exports = function isIosWebview(ua) {
	  ua = ua || global.navigator.userAgent;
	  if (isIos(ua)) {
	    if (isGoogleSearchApp(ua)) {
	      return true;
	    }
	    return /.+AppleWebKit(?!.*Safari)/.test(ua);
	  }
	  return false;
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./is-ios":15}],15:[function(require,module,exports){
	(function (global){
	'use strict';
	
	module.exports = function isIos(ua) {
	  ua = ua || global.navigator.userAgent;
	  return /iPhone|iPod|iPad/i.test(ua);
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],16:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var isIosFirefox = require('./is-ios-firefox');
	
	module.exports = function isMobileFirefox(ua) {
	  ua = ua || global.navigator.userAgent;
	  return isIosFirefox(ua) || /iPhone|iPod|iPad|Mobile|Tablet/i.test(ua) && /Firefox/i.test(ua);
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./is-ios-firefox":12}],17:[function(require,module,exports){
	(function (global){
	'use strict';
	
	module.exports = function isSamsungBrowser(ua) {
	  ua = ua || global.navigator.userAgent;
	  return /SamsungBrowser/i.test(ua);
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],18:[function(require,module,exports){
	'use strict';
	
	function _classesOf(element) {
	  return element.className.trim().split(/\s+/);
	}
	
	function add(element) {
	  var toAdd = Array.prototype.slice.call(arguments, 1);
	  var className = _classesOf(element).filter(function (classname) {
	    return toAdd.indexOf(classname) === -1;
	  }).concat(toAdd).join(' ');
	
	  element.className = className;
	}
	
	function remove(element) {
	  var toRemove = Array.prototype.slice.call(arguments, 1);
	  var className = _classesOf(element).filter(function (classname) {
	    return toRemove.indexOf(classname) === -1;
	  }).join(' ');
	
	  element.className = className;
	}
	
	function toggle(element, classname, adding) {
	  if (adding) {
	    add(element, classname);
	  } else {
	    remove(element, classname);
	  }
	}
	
	module.exports = {
	  add: add,
	  remove: remove,
	  toggle: toggle
	};
	
	},{}],19:[function(require,module,exports){
	'use strict';
	
	function EventEmitter() {
	  this._events = {};
	}
	
	EventEmitter.prototype.on = function (event, callback) {
	  if (this._events[event]) {
	    this._events[event].push(callback);
	  } else {
	    this._events[event] = [callback];
	  }
	};
	
	EventEmitter.prototype.off = function (event, callback) {
	  var eventCallbacks = this._events[event];
	  var indexOfCallback = eventCallbacks.indexOf(callback);
	
	  eventCallbacks.splice(indexOfCallback, 1);
	};
	
	EventEmitter.prototype._emit = function (event) {
	  var i, args;
	  var callbacks = this._events[event];
	
	  if (!callbacks) { return; }
	
	  args = Array.prototype.slice.call(arguments, 1);
	
	  for (i = 0; i < callbacks.length; i++) {
	    callbacks[i].apply(null, args);
	  }
	};
	
	EventEmitter.createChild = function (ChildObject) {
	  ChildObject.prototype = Object.create(EventEmitter.prototype, {
	    constructor: ChildObject
	  });
	};
	
	module.exports = EventEmitter;
	
	},{}],20:[function(require,module,exports){
	'use strict';
	
	var setAttributes = require('./lib/set-attributes');
	var defaultAttributes = require('./lib/default-attributes');
	var assign = require('./lib/assign');
	
	module.exports = function createFrame(options) {
	  var iframe = document.createElement('iframe');
	  var config = assign({}, defaultAttributes, options);
	
	  if (config.style && typeof config.style !== 'string') {
	    assign(iframe.style, config.style);
	    delete config.style;
	  }
	
	  setAttributes(iframe, config);
	
	  if (!iframe.getAttribute('id')) {
	    iframe.id = iframe.name;
	  }
	
	  return iframe;
	};
	
	},{"./lib/assign":21,"./lib/default-attributes":22,"./lib/set-attributes":23}],21:[function(require,module,exports){
	'use strict';
	
	module.exports = function assign(target) {
	  var objs = Array.prototype.slice.call(arguments, 1);
	
	  objs.forEach(function (obj) {
	    if (typeof obj !== 'object') { return; }
	
	    Object.keys(obj).forEach(function (key) {
	      target[key] = obj[key];
	    });
	  });
	
	  return target;
	}
	
	},{}],22:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  src: 'about:blank',
	  frameBorder: 0,
	  allowtransparency: true,
	  scrolling: 'no'
	};
	
	},{}],23:[function(require,module,exports){
	'use strict';
	
	module.exports = function setAttributes(element, attributes) {
	  var value;
	
	  for (var key in attributes) {
	    if (attributes.hasOwnProperty(key)) {
	      value = attributes[key];
	
	      if (value == null) {
	        element.removeAttribute(key);
	      } else {
	        element.setAttribute(key, value);
	      }
	    }
	  }
	};
	
	},{}],24:[function(require,module,exports){
	'use strict';
	
	function deferred(fn) {
	  return function () {
	    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
	    var args = arguments;
	
	    setTimeout(function () {
	      try {
	        fn.apply(null, args);
	      } catch (err) {
	        /* eslint-disable no-console */
	        console.log('Error in callback function');
	        console.log(err);
	        /* eslint-enable no-console */
	      }
	    }, 1);
	  };
	}
	
	module.exports = deferred;
	
	},{}],25:[function(require,module,exports){
	'use strict';
	
	function once(fn) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      fn.apply(null, arguments);
	    }
	  };
	}
	
	module.exports = once;
	
	},{}],26:[function(require,module,exports){
	'use strict';
	
	function promiseOrCallback(promise, callback) { // eslint-disable-line consistent-return
	  if (callback) {
	    promise
	      .then(function (data) {
	        callback(null, data);
	      })
	      .catch(function (err) {
	        callback(err);
	      });
	  } else {
	    return promise;
	  }
	}
	
	module.exports = promiseOrCallback;
	
	},{}],27:[function(require,module,exports){
	'use strict';
	
	var deferred = require('./lib/deferred');
	var once = require('./lib/once');
	var promiseOrCallback = require('./lib/promise-or-callback');
	
	function wrapPromise(fn) {
	  return function () {
	    var callback;
	    var args = Array.prototype.slice.call(arguments);
	    var lastArg = args[args.length - 1];
	
	    if (typeof lastArg === 'function') {
	      callback = args.pop();
	      callback = once(deferred(callback));
	    }
	
	    return promiseOrCallback(fn.apply(this, args), callback); // eslint-disable-line no-invalid-this
	  };
	}
	
	wrapPromise.wrapPrototype = function (target, options) {
	  var methods, ignoreMethods, includePrivateMethods;
	
	  options = options || {};
	  ignoreMethods = options.ignoreMethods || [];
	  includePrivateMethods = options.transformPrivateMethods === true;
	
	  methods = Object.getOwnPropertyNames(target.prototype).filter(function (method) {
	    var isNotPrivateMethod;
	    var isNonConstructorFunction = method !== 'constructor' &&
	      typeof target.prototype[method] === 'function';
	    var isNotAnIgnoredMethod = ignoreMethods.indexOf(method) === -1;
	
	    if (includePrivateMethods) {
	      isNotPrivateMethod = true;
	    } else {
	      isNotPrivateMethod = method.charAt(0) !== '_';
	    }
	
	    return isNonConstructorFunction &&
	      isNotPrivateMethod &&
	      isNotAnIgnoredMethod;
	  });
	
	  methods.forEach(function (method) {
	    var original = target.prototype[method];
	
	    target.prototype[method] = wrapPromise(original);
	  });
	
	  return target;
	};
	
	module.exports = wrapPromise;
	
	},{"./lib/deferred":24,"./lib/once":25,"./lib/promise-or-callback":26}],28:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var BraintreeError = require('../lib/braintree-error');
	var analytics = require('../lib/analytics');
	var errors = require('./errors');
	var Promise = require('../lib/promise');
	var methods = require('../lib/methods');
	var convertMethodsToError = require('../lib/convert-methods-to-error');
	var wrapPromise = require('@braintree/wrap-promise');
	
	/**
	 * @typedef {object} ApplePay~tokenizePayload
	 * @property {string} nonce The payment method nonce.
	 * @property {object} details Additional details.
	 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
	 * @property {string} details.cardHolderName The name of the card holder.
	 * @property {string} details.dpanLastTwo Last two digits of card number.
	 * @property {string} description A human-readable description.
	 * @property {string} type The payment method type, always `ApplePayCard`.
	 * @property {object} binData Information about the card based on the bin.
	 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.countryOfIssuance The country of issuance.
	 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.issuingBank The issuing bank.
	 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.productId The product id.
	 */
	
	/**
	 * An Apple Pay Payment Authorization Event object.
	 * @typedef {object} ApplePayPaymentAuthorizedEvent
	 * @external ApplePayPaymentAuthorizedEvent
	 * @see {@link https://developer.apple.com/reference/applepayjs/applepaypaymentauthorizedevent ApplePayPaymentAuthorizedEvent}
	 */
	
	/**
	 * An Apple Pay Payment Request object.
	 * @typedef {object} ApplePayPaymentRequest
	 * @external ApplePayPaymentRequest
	 * @see {@link https://developer.apple.com/reference/applepayjs/1916082-applepay_js_data_types/paymentrequest PaymentRequest}
	 */
	
	/**
	 * @class
	 * @param {object} options Options
	 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/apple-pay.create|braintree.applePay.create} instead.</strong>
	 * @classdesc This class represents an Apple Pay component. Instances of this class have methods for validating the merchant server and tokenizing payments.
	 */
	function ApplePay(options) {
	  this._client = options.client;
	  /**
	   * @name ApplePay#merchantIdentifier
	   * @description A special merchant ID which represents the merchant association with Braintree. Required when using `ApplePaySession.canMakePaymentsWithActiveCard`.
	   * @example
	   * var promise = ApplePaySession.canMakePaymentsWithActiveCard(applePayInstance.merchantIdentifier);
	   * promise.then(function (canMakePaymentsWithActiveCard) {
	   *   if (canMakePaymentsWithActiveCard) {
	   *     // Set up Apple Pay buttons
	   *   }
	   * });
	   */
	  Object.defineProperty(this, 'merchantIdentifier', {
	    value: this._client.getConfiguration().gatewayConfiguration.applePayWeb.merchantIdentifier,
	    configurable: false,
	    writable: false
	  });
	}
	
	/**
	 * Merges a payment request with Braintree defaults to return an {external:ApplePayPaymentRequest}.
	 *
	 * The following properties are assigned to `paymentRequest` if not already defined. Their default values come from the Braintree gateway.
	 * - `countryCode`
	 * - `currencyCode`
	 * - `merchantCapabilities`
	 * - `supportedNetworks`
	 * @public
	 * @param {external:ApplePayPaymentRequest} paymentRequest The payment request details to apply on top of those from Braintree.
	 * @returns {external:ApplePayPaymentRequest} The decorated `paymentRequest` object.
	 * @example
	 * var applePay = require('braintree-web/apple-pay');
	 *
	 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
	 *   if (applePayErr) {
	 *     // Handle error here
	 *     return;
	 *   }
	 *
	 *   var paymentRequest = applePayInstance.createPaymentRequest({
	 *     total: {
	 *       label: 'My Company',
	 *       amount: '19.99'
	 *     }
	 *   });
	 *
	 *   var session = new ApplePaySession(3, paymentRequest);
	 *
	 *   // ...
	 */
	ApplePay.prototype.createPaymentRequest = function (paymentRequest) {
	  var applePay = this._client.getConfiguration().gatewayConfiguration.applePayWeb;
	  var defaults = {
	    countryCode: applePay.countryCode,
	    currencyCode: applePay.currencyCode,
	    merchantCapabilities: applePay.merchantCapabilities || ['supports3DS'],
	    supportedNetworks: applePay.supportedNetworks.map(function (network) {
	      return network === 'mastercard' ? 'masterCard' : network;
	    })
	  };
	
	  return Object.assign({}, defaults, paymentRequest);
	};
	
	/**
	 * Validates your merchant website, as required by `ApplePaySession` before payment can be authorized.
	 * @public
	 * @param {object} options Options
	 * @param {string} options.validationURL The validationURL fram an `ApplePayValidateMerchantEvent`.
	 * @param {string} options.displayName The canonical name for your store. Use a non-localized name. This parameter should be a UTF-8 string that is a maximum of 128 characters. The system may display this name to the user.
	 * @param {callback} [callback] The second argument, <code>data</code>, is the Apple Pay merchant session object. If no callback is provided, `performValidation` returns a promise.
	 * Pass the merchant session to your Apple Pay session's `completeMerchantValidation` method.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * var applePay = require('braintree-web/apple-pay');
	 *
	 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
	 *   if (applePayErr) {
	 *     // Handle error here
	 *     return;
	 *   }
	 *
	 *   var paymentRequest = applePayInstance.createPaymentRequest({
	 *     total: {
	 *       label: 'My Company',
	 *       amount: '19.99'
	 *     }
	 *   });
	 *   var session = new ApplePaySession(3, paymentRequest);
	 *
	 *   session.onvalidatemerchant = function (event) {
	 *     applePayInstance.performValidation({
	 *       validationURL: event.validationURL,
	 *       displayName: 'My Great Store'
	 *     }, function (validationErr, validationData) {
	 *       if (validationErr) {
	 *         console.error(validationErr);
	 *         session.abort();
	 *         return;
	 *       }
	 *
	 *       session.completeMerchantValidation(validationData);
	 *     });
	 *   };
	 * });
	 */
	ApplePay.prototype.performValidation = function (options) {
	  var applePayWebSession;
	  var self = this;
	
	  if (!options || !options.validationURL) {
	    return Promise.reject(new BraintreeError(errors.APPLE_PAY_VALIDATION_URL_REQUIRED));
	  }
	
	  applePayWebSession = {
	    validationUrl: options.validationURL,
	    domainName: options.domainName || global.location.hostname,
	    merchantIdentifier: options.merchantIdentifier || this.merchantIdentifier
	  };
	
	  if (options.displayName != null) {
	    applePayWebSession.displayName = options.displayName;
	  }
	
	  return this._client.request({
	    method: 'post',
	    endpoint: 'apple_pay_web/sessions',
	    data: {
	      _meta: {source: 'apple-pay'},
	      applePayWebSession: applePayWebSession
	    }
	  }).then(function (response) {
	    analytics.sendEvent(self._client, 'applepay.performValidation.succeeded');
	
	    return Promise.resolve(response);
	  }).catch(function (err) {
	    analytics.sendEvent(self._client, 'applepay.performValidation.failed');
	
	    if (err.code === 'CLIENT_REQUEST_ERROR') {
	      return Promise.reject(new BraintreeError({
	        type: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.type,
	        code: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.code,
	        message: errors.APPLE_PAY_MERCHANT_VALIDATION_FAILED.message,
	        details: {
	          originalError: err.details.originalError
	        }
	      }));
	    }
	
	    return Promise.reject(new BraintreeError({
	      type: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.type,
	      code: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.code,
	      message: errors.APPLE_PAY_MERCHANT_VALIDATION_NETWORK.message,
	      details: {
	        originalError: err
	      }
	    }));
	  });
	};
	
	/**
	 * Tokenizes an Apple Pay payment. This will likely be called in your `ApplePaySession`'s `onpaymentauthorized` callback.
	 * @public
	 * @param {object} options Options
	 * @param {object} options.token The `payment.token` property of an {@link external:ApplePayPaymentAuthorizedEvent}.
	 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ApplePay~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a promise that resolves with a {@link ApplePay~tokenizePayload|tokenizePayload}.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * var applePay = require('braintree-web/apple-pay');
	 *
	 * applePay.create({client: clientInstance}, function (applePayErr, applePayInstance) {
	 *   if (applePayErr) {
	 *     // Handle error here
	 *     return;
	 *   }
	 *
	 *   var paymentRequest = applePayInstance.createPaymentRequest({
	 *     total: {
	 *       label: 'My Company',
	 *       amount: '19.99'
	 *     }
	 *   });
	 *   var session = new ApplePaySession(3, paymentRequest);
	 *
	 *   session.onpaymentauthorized = function (event) {
	 *     applePayInstance.tokenize({
	 *       token: event.payment.token
	 *     }, function (tokenizeErr, tokenizedPayload) {
	 *       if (tokenizeErr) {
	 *         session.completePayment(ApplePaySession.STATUS_FAILURE);
	 *         return;
	 *       }
	 *       // Send the tokenizedPayload to your server here!
	 *
	 *       // Once the transaction is complete, call completePayment
	 *       // to close the Apple Pay sheet
	 *       session.completePayment(ApplePaySession.STATUS_SUCCESS);
	 *     });
	 *   };
	 *
	 *   // ...
	 * });
	 */
	ApplePay.prototype.tokenize = function (options) {
	  var self = this;
	
	  if (!options.token) {
	    return Promise.reject(new BraintreeError(errors.APPLE_PAY_PAYMENT_TOKEN_REQUIRED));
	  }
	
	  return this._client.request({
	    method: 'post',
	    endpoint: 'payment_methods/apple_payment_tokens',
	    data: {
	      _meta: {
	        source: 'apple-pay'
	      },
	      applePaymentToken: Object.assign({}, options.token, {
	        // The gateway requires this key to be base64-encoded.
	        paymentData: btoa(JSON.stringify(options.token.paymentData))
	      })
	    }
	  }).then(function (response) {
	    analytics.sendEvent(self._client, 'applepay.tokenize.succeeded');
	
	    return Promise.resolve(response.applePayCards[0]);
	  }).catch(function (err) {
	    analytics.sendEvent(self._client, 'applepay.tokenize.failed');
	
	    return Promise.reject(new BraintreeError({
	      type: errors.APPLE_PAY_TOKENIZATION.type,
	      code: errors.APPLE_PAY_TOKENIZATION.code,
	      message: errors.APPLE_PAY_TOKENIZATION.message,
	      details: {
	        originalError: err
	      }
	    }));
	  });
	};
	
	/**
	 * Cleanly tear down anything set up by {@link module:braintree-web/apple-pay.create|create}.
	 * @public
	 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
	 * @example
	 * applePayInstance.teardown();
	 * @example <caption>With callback</caption>
	 * applePayInstance.teardown(function () {
	 *   // teardown is complete
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	ApplePay.prototype.teardown = function () {
	  convertMethodsToError(this, methods(ApplePay.prototype));
	
	  return Promise.resolve();
	};
	
	module.exports = wrapPromise.wrapPrototype(ApplePay);
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../lib/analytics":68,"../lib/braintree-error":73,"../lib/convert-methods-to-error":78,"../lib/methods":93,"../lib/promise":95,"./errors":29,"@braintree/wrap-promise":27}],29:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.Apple Pay - Creation Error Codes
	 * @description Errors that occur when [creating the Apple Pay component](/current/module-braintree-web_apple-pay.html#.create).
	 * @property {MERCHANT} APPLE_PAY_NOT_ENABLED Occurs when the authorization used is not authorized to process Apple Pay.
	 */
	
	/**
	 * @name BraintreeError.Apple Pay - performValidation Error Codes
	 * @description Errors that occur when [validating](/current/ApplePay.html#performValidation).
	 * @property {MERCHANT} APPLE_PAY_VALIDATION_URL_REQUIRED Occurs when the `validationURL` option is not passed in.
	 * @property {MERCHANT} APPLE_PAY_MERCHANT_VALIDATION_FAILED Occurs when the website domain has not been registered in the Braintree control panel.
	 * @property {NETWORK} APPLE_PAY_MERCHANT_VALIDATION_NETWORK Occurs when an unknown network error occurs.
	 */
	
	/**
	 * @name BraintreeError.Apple Pay - tokenize Error Codes
	 * @description Errors that occur when [tokenizing](/current/ApplePay.html#tokenize).
	 * @property {MERCHANT} APPLE_PAY_PAYMENT_TOKEN_REQUIRED Occurs when the `token` option is not passed in.
	 * @property {NETWORK} APPLE_PAY_TOKENIZATION Occurs when an unknown network error occurs.
	 */
	
	var BraintreeError = require('../lib/braintree-error');
	
	module.exports = {
	  APPLE_PAY_NOT_ENABLED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'APPLE_PAY_NOT_ENABLED',
	    message: 'Apple Pay is not enabled for this merchant.'
	  },
	  APPLE_PAY_VALIDATION_URL_REQUIRED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'APPLE_PAY_VALIDATION_URL_REQUIRED',
	    message: 'performValidation must be called with a validationURL.'
	  },
	  APPLE_PAY_MERCHANT_VALIDATION_NETWORK: {
	    type: BraintreeError.types.NETWORK,
	    code: 'APPLE_PAY_MERCHANT_VALIDATION_NETWORK',
	    message: 'A network error occurred when validating the Apple Pay merchant.'
	  },
	  APPLE_PAY_MERCHANT_VALIDATION_FAILED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'APPLE_PAY_MERCHANT_VALIDATION_FAILED',
	    message: 'Make sure you have registered your domain name in the Braintree Control Panel.'
	  },
	  APPLE_PAY_PAYMENT_TOKEN_REQUIRED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'APPLE_PAY_PAYMENT_TOKEN_REQUIRED',
	    message: 'tokenize must be called with a payment token.'
	  },
	  APPLE_PAY_TOKENIZATION: {
	    type: BraintreeError.types.NETWORK,
	    code: 'APPLE_PAY_TOKENIZATION',
	    message: 'A network error occurred when processing the Apple Pay payment.'
	  }
	};
	
	},{"../lib/braintree-error":73}],30:[function(require,module,exports){
	'use strict';
	
	/**
	 * @module braintree-web/apple-pay
	 * @description Accept Apple Pay on the Web. *This component is currently in beta and is subject to change.*
	 */
	
	var BraintreeError = require('../lib/braintree-error');
	var ApplePay = require('./apple-pay');
	var analytics = require('../lib/analytics');
	var basicComponentVerification = require('../lib/basic-component-verification');
	var createDeferredClient = require('../lib/create-deferred-client');
	var createAssetsUrl = require('../lib/create-assets-url');
	var errors = require('./errors');
	var VERSION = "3.47.0";
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	
	/**
	 * @static
	 * @function create
	 * @param {object} options Creation options:
	 * @param {Client} [options.client] A {@link Client} instance.
	 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
	 * @param {callback} [callback] The second argument, `data`, is the {@link ApplePay} instance. If no callback is provided, `create` returns a promise that resolves with the {@link ApplePay} instance.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	function create(options) {
	  var name = 'Apple Pay';
	
	  return basicComponentVerification.verify({
	    name: name,
	    client: options.client,
	    authorization: options.authorization
	  }).then(function () {
	    return createDeferredClient.create({
	      authorization: options.authorization,
	      client: options.client,
	      debug: options.debug,
	      assetsUrl: createAssetsUrl.create(options.authorization),
	      name: name
	    });
	  }).then(function (client) {
	    options.client = client;
	
	    if (!options.client.getConfiguration().gatewayConfiguration.applePayWeb) {
	      return Promise.reject(new BraintreeError(errors.APPLE_PAY_NOT_ENABLED));
	    }
	
	    analytics.sendEvent(options.client, 'applepay.initialized');
	
	    return new ApplePay(options);
	  });
	}
	
	module.exports = {
	  create: wrapPromise(create),
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/analytics":68,"../lib/basic-component-verification":71,"../lib/braintree-error":73,"../lib/create-assets-url":80,"../lib/create-deferred-client":82,"../lib/promise":95,"./apple-pay":28,"./errors":29,"@braintree/wrap-promise":27}],31:[function(require,module,exports){
	'use strict';
	
	var isIe = require('@braintree/browser-detection/is-ie');
	var isIe9 = require('@braintree/browser-detection/is-ie9');
	
	module.exports = {
	  isIe: isIe,
	  isIe9: isIe9
	};
	
	},{"@braintree/browser-detection/is-ie":8,"@braintree/browser-detection/is-ie9":11}],32:[function(require,module,exports){
	'use strict';
	
	var BRAINTREE_VERSION = require('./constants').BRAINTREE_VERSION;
	
	var GraphQL = require('./request/graphql');
	var request = require('./request');
	var isVerifiedDomain = require('../lib/is-verified-domain');
	var BraintreeError = require('../lib/braintree-error');
	var convertToBraintreeError = require('../lib/convert-to-braintree-error');
	var getGatewayConfiguration = require('./get-configuration').getConfiguration;
	var addMetadata = require('../lib/add-metadata');
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	var once = require('../lib/once');
	var deferred = require('../lib/deferred');
	var assign = require('../lib/assign').assign;
	var analytics = require('../lib/analytics');
	var constants = require('./constants');
	var errors = require('./errors');
	var sharedErrors = require('../lib/errors');
	var VERSION = require('../lib/constants').VERSION;
	var GRAPHQL_URLS = require('../lib/constants').GRAPHQL_URLS;
	var methods = require('../lib/methods');
	var convertMethodsToError = require('../lib/convert-methods-to-error');
	var assets = require('../lib/assets');
	var FRAUDNET_FNCLS = require('../lib/constants').FRAUDNET_FNCLS;
	var FRAUDNET_SOURCE = require('../lib/constants').FRAUDNET_SOURCE;
	var FRAUDNET_URL = require('../lib/constants').FRAUDNET_URL;
	
	var cachedClients = {};
	
	/**
	 * This object is returned by {@link Client#getConfiguration|getConfiguration}. This information is used extensively by other Braintree modules to properly configure themselves.
	 * @typedef {object} Client~configuration
	 * @property {object} client The braintree-web/client parameters.
	 * @property {string} client.authorization A tokenizationKey or clientToken.
	 * @property {object} gatewayConfiguration Gateway-supplied configuration.
	 * @property {object} analyticsMetadata Analytics-specific data.
	 * @property {string} analyticsMetadata.sessionId Uniquely identifies a browsing session.
	 * @property {string} analyticsMetadata.sdkVersion The braintree.js version.
	 * @property {string} analyticsMetadata.merchantAppId Identifies the merchant's web app.
	 */
	
	/**
	 * @class
	 * @param {Client~configuration} configuration Options
	 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/client.create|braintree.client.create} instead.</strong>
	 * @classdesc This class is required by many other Braintree components. It serves as the base API layer that communicates with our servers. It is also capable of being used to formulate direct calls to our servers, such as direct credit card tokenization. See {@link Client#request}.
	 */
	function Client(configuration) {
	  var configurationJSON, gatewayConfiguration, braintreeApiConfiguration;
	
	  configuration = configuration || {};
	
	  configurationJSON = JSON.stringify(configuration);
	  gatewayConfiguration = configuration.gatewayConfiguration;
	
	  if (!gatewayConfiguration) {
	    throw new BraintreeError(errors.CLIENT_MISSING_GATEWAY_CONFIGURATION);
	  }
	
	  [
	    'assetsUrl',
	    'clientApiUrl',
	    'configUrl'
	  ].forEach(function (property) {
	    if (property in gatewayConfiguration && !isVerifiedDomain(gatewayConfiguration[property])) {
	      throw new BraintreeError({
	        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
	        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
	        message: property + ' property is on an invalid domain.'
	      });
	    }
	  });
	
	  /**
	   * Returns a copy of the configuration values.
	   * @public
	   * @returns {Client~configuration} configuration
	   */
	  this.getConfiguration = function () {
	    return JSON.parse(configurationJSON);
	  };
	
	  this._request = request;
	  this._configuration = this.getConfiguration();
	
	  this._clientApiBaseUrl = gatewayConfiguration.clientApiUrl + '/v1/';
	
	  braintreeApiConfiguration = gatewayConfiguration.braintreeApi;
	  if (braintreeApiConfiguration) {
	    this._braintreeApi = {
	      baseUrl: braintreeApiConfiguration.url + '/',
	      accessToken: braintreeApiConfiguration.accessToken
	    };
	
	    if (!isVerifiedDomain(this._braintreeApi.baseUrl)) {
	      throw new BraintreeError({
	        type: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.type,
	        code: errors.CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN.code,
	        message: 'braintreeApi URL is on an invalid domain.'
	      });
	    }
	  }
	
	  if (gatewayConfiguration.graphQL) {
	    this._graphQL = new GraphQL({
	      graphQL: gatewayConfiguration.graphQL
	    });
	  }
	}
	
	Client.initialize = function (options) {
	  var clientInstance;
	  var promise = cachedClients[options.authorization];
	
	  if (promise) {
	    analytics.sendEvent(promise, 'custom.client.load.cached');
	
	    return promise;
	  }
	
	  promise = getGatewayConfiguration(options).then(function (configuration) {
	    if (options.debug) {
	      configuration.isDebug = true;
	    }
	
	    clientInstance = new Client(configuration);
	
	    return clientInstance;
	  });
	
	  cachedClients[options.authorization] = promise;
	
	  analytics.sendEvent(promise, 'custom.client.load.initialized');
	
	  return promise.then(function (client) {
	    analytics.sendEvent(clientInstance, 'custom.client.load.succeeded');
	
	    return client;
	  }).catch(function (err) {
	    delete cachedClients[options.authorization];
	
	    return Promise.reject(err);
	  });
	};
	
	// Primarily used for testing the client initalization call
	Client.clearCache = function () {
	  cachedClients = {};
	};
	
	Client.prototype._findOrCreateFraudnetJSON = function (clientMetadataId) {
	  var el = document.querySelector('script[fncls="' + FRAUDNET_FNCLS + '"]');
	  var config, additionalData, authorizationFingerprint, parameters;
	
	  if (!el) {
	    el = document.body.appendChild(document.createElement('script'));
	    el.type = 'application/json';
	    el.setAttribute('fncls', FRAUDNET_FNCLS);
	  }
	
	  config = this.getConfiguration();
	  additionalData = {
	    rda_tenant: 'bt_card', // eslint-disable-line camelcase
	    mid: config.gatewayConfiguration.merchantId
	  };
	  authorizationFingerprint = config.authorizationFingerprint;
	
	  if (authorizationFingerprint) {
	    authorizationFingerprint.split('&').forEach(function (pieces) {
	      var component = pieces.split('=');
	
	      if (component[0] === 'customer_id' && component.length > 1) {
	        additionalData.cid = component[1];
	      }
	    });
	  }
	
	  parameters = {
	    f: clientMetadataId.substr(0, 32),
	    fp: additionalData,
	    bu: false,
	    s: FRAUDNET_SOURCE
	  };
	  el.text = JSON.stringify(parameters);
	};
	
	/**
	 * Used by other modules to formulate all network requests to the Braintree gateway. It is also capable of being used directly from your own form to tokenize credit card information. However, be sure to satisfy PCI compliance if you use direct card tokenization.
	 * @public
	 * @param {object} options Request options:
	 * @param {string} options.method HTTP method, e.g. "get" or "post".
	 * @param {string} options.endpoint Endpoint path, e.g. "payment_methods".
	 * @param {object} options.data Data to send with the request.
	 * @param {number} [options.timeout=60000] Set a timeout (in milliseconds) for the request.
	 * @param {callback} [callback] The second argument, <code>data</code>, is the returned server data.
	 * @example
	 * <caption>Direct Credit Card Tokenization</caption>
	 * var createClient = require('braintree-web/client').create;
	 *
	 * createClient({
	 *   authorization: CLIENT_AUTHORIZATION
	 * }, function (createErr, clientInstance) {
	 *   var form = document.getElementById('my-form-id');
	 *   var data = {
	 *     creditCard: {
	 *       number: form['cc-number'].value,
	 *       cvv: form['cc-cvv'].value,
	 *       expirationDate: form['cc-expiration-date'].value,
	 *       billingAddress: {
	 *         postalCode: form['cc-postal-code'].value
	 *       },
	 *       options: {
	 *         validate: false
	 *       }
	 *     }
	 *   };
	 *
	 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
	 *   // payment fields cannot be hosted on your checkout page.
	 *   // For an alternative to the following, use Hosted Fields.
	 *   clientInstance.request({
	 *     endpoint: 'payment_methods/credit_cards',
	 *     method: 'post',
	 *     data: data
	 *   }, function (requestErr, response) {
	 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
	 *     if (requestErr) { throw new Error(requestErr); }
	 *
	 *     console.log('Got nonce:', response.creditCards[0].nonce);
	 *   });
	 * });
	 * @example
	 * <caption>Tokenizing Fields for AVS Checks</caption>
	 * var createClient = require('braintree-web/client').create;
	 *
	 * createClient({
	 *   authorization: CLIENT_AUTHORIZATION
	 * }, function (createErr, clientInstance) {
	 *   var form = document.getElementById('my-form-id');
	 *   var data = {
	 *     creditCard: {
	 *       number: form['cc-number'].value,
	 *       cvv: form['cc-cvv'].value,
	 *       expirationDate: form['cc-date'].value,
	 *       // The billing address can be checked with AVS rules.
	 *       // See: https://articles.braintreepayments.com/support/guides/fraud-tools/basic/avs-cvv-rules
	 *       billingAddress: {
	 *         postalCode: form['cc-postal-code'].value,
	 *         streetAddress: form['cc-street-address'].value,
	 *         countryName: form['cc-country-name'].value,
	 *         countryCodeAlpha2: form['cc-country-alpha2'].value,
	 *         countryCodeAlpha3: form['cc-country-alpha3'].value,
	 *         countryCodeNumeric: form['cc-country-numeric'].value
	 *       },
	 *       options: {
	 *         validate: false
	 *       }
	 *     }
	 *   };
	 *
	 *   // Warning: For a merchant to be eligible for the easiest level of PCI compliance (SAQ A),
	 *   // payment fields cannot be hosted on your checkout page.
	 *   // For an alternative to the following, use Hosted Fields.
	 *   clientInstance.request({
	 *     endpoint: 'payment_methods/credit_cards',
	 *     method: 'post',
	 *     data: data
	 *   }, function (requestErr, response) {
	 *     // More detailed example of handling API errors: https://codepen.io/braintree/pen/MbwjdM
	 *     if (requestErr) { throw new Error(requestErr); }
	 *
	 *     console.log('Got nonce:', response.creditCards[0].nonce);
	 *   });
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	Client.prototype.request = function (options, callback) {
	  var self = this; // eslint-disable-line no-invalid-this
	  var requestPromise = new Promise(function (resolve, reject) {
	    var optionName, api, baseUrl, requestOptions;
	    var shouldCollectData = Boolean(options.endpoint === 'payment_methods/credit_cards' && self.getConfiguration().gatewayConfiguration.creditCards.collectDeviceData);
	
	    if (options.api !== 'graphQLApi') {
	      if (!options.method) {
	        optionName = 'options.method';
	      } else if (!options.endpoint) {
	        optionName = 'options.endpoint';
	      }
	    }
	
	    if (optionName) {
	      throw new BraintreeError({
	        type: errors.CLIENT_OPTION_REQUIRED.type,
	        code: errors.CLIENT_OPTION_REQUIRED.code,
	        message: optionName + ' is required when making a request.'
	      });
	    }
	
	    if ('api' in options) {
	      api = options.api;
	    } else {
	      api = 'clientApi';
	    }
	
	    requestOptions = {
	      method: options.method,
	      graphQL: self._graphQL,
	      timeout: options.timeout,
	      metadata: self._configuration.analyticsMetadata
	    };
	
	    if (api === 'clientApi') {
	      baseUrl = self._clientApiBaseUrl;
	
	      requestOptions.data = addMetadata(self._configuration, options.data);
	    } else if (api === 'braintreeApi') {
	      if (!self._braintreeApi) {
	        throw new BraintreeError(sharedErrors.BRAINTREE_API_ACCESS_RESTRICTED);
	      }
	
	      baseUrl = self._braintreeApi.baseUrl;
	
	      requestOptions.data = options.data;
	
	      requestOptions.headers = {
	        'Braintree-Version': constants.BRAINTREE_API_VERSION_HEADER,
	        Authorization: 'Bearer ' + self._braintreeApi.accessToken
	      };
	    } else if (api === 'graphQLApi') {
	      baseUrl = GRAPHQL_URLS[self._configuration.gatewayConfiguration.environment];
	      options.endpoint = '';
	      requestOptions.method = 'post';
	      requestOptions.data = assign({
	        clientSdkMetadata: {
	          source: self._configuration.analyticsMetadata.source,
	          integration: self._configuration.analyticsMetadata.integration,
	          sessionId: self._configuration.analyticsMetadata.sessionId
	        }
	      }, options.data);
	
	      requestOptions.headers = getAuthorizationHeadersForGraphQL(self._configuration);
	    } else {
	      throw new BraintreeError({
	        type: errors.CLIENT_OPTION_INVALID.type,
	        code: errors.CLIENT_OPTION_INVALID.code,
	        message: 'options.api is invalid.'
	      });
	    }
	
	    requestOptions.url = baseUrl + options.endpoint;
	    requestOptions.sendAnalyticsEvent = function (kind) {
	      analytics.sendEvent(self, kind);
	    };
	
	    self._request(requestOptions, function (err, data, status) {
	      var resolvedData, requestError;
	
	      requestError = formatRequestError(status, err);
	
	      if (requestError) {
	        reject(requestError);
	
	        return;
	      }
	
	      if (api === 'graphQLApi' && data.errors) {
	        reject(convertToBraintreeError(data.errors, {
	          type: errors.CLIENT_GRAPHQL_REQUEST_ERROR.type,
	          code: errors.CLIENT_GRAPHQL_REQUEST_ERROR.code,
	          message: errors.CLIENT_GRAPHQL_REQUEST_ERROR.message
	        }));
	
	        return;
	      }
	
	      resolvedData = assign({_httpStatus: status}, data);
	
	      if (shouldCollectData && resolvedData.creditCards && resolvedData.creditCards.length > 0) {
	        self._findOrCreateFraudnetJSON(resolvedData.creditCards[0].nonce);
	
	        assets.loadScript({
	          src: FRAUDNET_URL,
	          forceScriptReload: true
	        });
	      }
	      resolve(resolvedData);
	    });
	  });
	
	  if (typeof callback === 'function') {
	    callback = once(deferred(callback));
	
	    requestPromise.then(function (response) {
	      callback(null, response, response._httpStatus);
	    }).catch(function (err) {
	      var status = err && err.details && err.details.httpStatus;
	
	      callback(err, null, status);
	    });
	
	    return;
	  }
	
	  return requestPromise; // eslint-disable-line consistent-return
	};
	
	function formatRequestError(status, err) { // eslint-disable-line consistent-return
	  var requestError;
	
	  if (status === -1) {
	    requestError = new BraintreeError(errors.CLIENT_REQUEST_TIMEOUT);
	  } else if (status === 403) {
	    requestError = new BraintreeError(errors.CLIENT_AUTHORIZATION_INSUFFICIENT);
	  } else if (status === 429) {
	    requestError = new BraintreeError(errors.CLIENT_RATE_LIMITED);
	  } else if (status >= 500) {
	    requestError = new BraintreeError(errors.CLIENT_GATEWAY_NETWORK);
	  } else if (status < 200 || status >= 400) {
	    requestError = convertToBraintreeError(err, {
	      type: errors.CLIENT_REQUEST_ERROR.type,
	      code: errors.CLIENT_REQUEST_ERROR.code,
	      message: errors.CLIENT_REQUEST_ERROR.message
	    });
	  }
	
	  if (requestError) {
	    requestError.details = requestError.details || {};
	    requestError.details.httpStatus = status;
	
	    return requestError;
	  }
	}
	
	Client.prototype.toJSON = function () {
	  return this.getConfiguration();
	};
	
	/**
	 * Returns the Client version.
	 * @public
	 * @returns {String} The created client's version.
	 * @example
	 * var createClient = require('braintree-web/client').create;
	 *
	 * createClient({
	 *   authorization: CLIENT_AUTHORIZATION
	 * }, function (createErr, clientInstance) {
	 *   console.log(clientInstance.getVersion()); // Ex: 1.0.0
	 * });
	 * @returns {void}
	 */
	Client.prototype.getVersion = function () {
	  return VERSION;
	};
	
	/**
	 * Cleanly tear down anything set up by {@link module:braintree-web/client.create|create}.
	 * @public
	 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
	 * @example
	 * clientInstance.teardown();
	 * @example <caption>With callback</caption>
	 * clientInstance.teardown(function () {
	 *   // teardown is complete
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	Client.prototype.teardown = wrapPromise(function () {
	  var self = this; // eslint-disable-line no-invalid-this
	
	  delete cachedClients[self.getConfiguration().authorization];
	  convertMethodsToError(self, methods(Client.prototype));
	
	  return Promise.resolve();
	});
	
	function getAuthorizationHeadersForGraphQL(configuration) {
	  var token = configuration.authorizationFingerprint || configuration.authorization;
	
	  return {
	    Authorization: 'Bearer ' + token,
	    'Braintree-Version': BRAINTREE_VERSION
	  };
	}
	
	module.exports = Client;
	
	},{"../lib/add-metadata":67,"../lib/analytics":68,"../lib/assets":69,"../lib/assign":70,"../lib/braintree-error":73,"../lib/constants":77,"../lib/convert-methods-to-error":78,"../lib/convert-to-braintree-error":79,"../lib/deferred":83,"../lib/errors":86,"../lib/is-verified-domain":91,"../lib/methods":93,"../lib/once":94,"../lib/promise":95,"./constants":33,"./errors":34,"./get-configuration":35,"./request":47,"./request/graphql":45,"@braintree/wrap-promise":27}],33:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  BRAINTREE_API_VERSION_HEADER: '2017-04-03',
	  BRAINTREE_VERSION: '2018-05-10'
	};
	
	},{}],34:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.Client - Interal Error Codes
	 * @ignore
	 * @description These codes should never be experienced by the mechant directly.
	 * @property {MERCHANT} CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN An error to prevent client creation for domains that are not allowed in the JS.
	 * @property {INTERNAL} CLIENT_MISSING_GATEWAY_CONFIGURATION Occurs when the client is created without a gateway configuration. Should never happen.
	 */
	
	/**
	 * @name BraintreeError.Client - Create Error Codes
	 * @description Errors that may occur when [creating the client](/current/module-braintree-web_client.html#.create)
	 * @property {MERCHANT} CLIENT_INVALID_AUTHORIZATION Occurs when client token cannot be parsed.
	 */
	
	/**
	 * @name BraintreeError.Client - Request Error Codes
	 * @description Errors that may occur when [using the request method](/current/Client.html#request)
	 * @property {MERCHANT} CLIENT_OPTION_REQUIRED An option required in the request method was not provided. Usually `options.method` or `options.endpoint`
	 * @property {MERCHANT} CLIENT_OPTION_INVALID The request option provided is invalid.
	 * @property {MERCHANT} CLIENT_GATEWAY_NETWORK The Braintree gateway could not be contacted.
	 * @property {NETWORK} CLIENT_REQUEST_TIMEOUT The request took too long to complete and timed out.
	 * @property {NETWORK} CLIENT_REQUEST_ERROR The response from a request had status 400 or greater.
	 * @property {NETWORK} CLIENT_GRAPHQL_REQUEST_ERROR The response from a request to GraphQL contained an error.
	 * @property {MERCHANT} CLIENT_RATE_LIMITED The response from a request had a status of 429, indicating rate limiting.
	 * @property {MERCHANT} CLIENT_AUTHORIZATION_INSUFFICIENT The user assocaited with the client token or tokenization key does not have permissions to make the request.
	 */
	
	var BraintreeError = require('../lib/braintree-error');
	
	module.exports = {
	  CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'CLIENT_GATEWAY_CONFIGURATION_INVALID_DOMAIN'
	  },
	  CLIENT_OPTION_REQUIRED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'CLIENT_OPTION_REQUIRED'
	  },
	  CLIENT_OPTION_INVALID: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'CLIENT_OPTION_INVALID'
	  },
	  CLIENT_MISSING_GATEWAY_CONFIGURATION: {
	    type: BraintreeError.types.INTERNAL,
	    code: 'CLIENT_MISSING_GATEWAY_CONFIGURATION',
	    message: 'Missing gatewayConfiguration.'
	  },
	  CLIENT_INVALID_AUTHORIZATION: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'CLIENT_INVALID_AUTHORIZATION',
	    message: 'Authorization is invalid. Make sure your client token or tokenization key is valid.'
	  },
	  CLIENT_GATEWAY_NETWORK: {
	    type: BraintreeError.types.NETWORK,
	    code: 'CLIENT_GATEWAY_NETWORK',
	    message: 'Cannot contact the gateway at this time.'
	  },
	  CLIENT_REQUEST_TIMEOUT: {
	    type: BraintreeError.types.NETWORK,
	    code: 'CLIENT_REQUEST_TIMEOUT',
	    message: 'Request timed out waiting for a reply.'
	  },
	  CLIENT_REQUEST_ERROR: {
	    type: BraintreeError.types.NETWORK,
	    code: 'CLIENT_REQUEST_ERROR',
	    message: 'There was a problem with your request.'
	  },
	  CLIENT_GRAPHQL_REQUEST_ERROR: {
	    type: BraintreeError.types.NETWORK,
	    code: 'CLIENT_GRAPHQL_REQUEST_ERROR',
	    message: 'There was a problem with your request.'
	  },
	  CLIENT_RATE_LIMITED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'CLIENT_RATE_LIMITED',
	    message: 'You are being rate-limited; please try again in a few minutes.'
	  },
	  CLIENT_AUTHORIZATION_INSUFFICIENT: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'CLIENT_AUTHORIZATION_INSUFFICIENT',
	    message: 'The authorization used has insufficient privileges.'
	  }
	};
	
	},{"../lib/braintree-error":73}],35:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var BraintreeError = require('../lib/braintree-error');
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	var request = require('./request');
	var uuid = require('../lib/vendor/uuid');
	var constants = require('../lib/constants');
	var createAuthorizationData = require('../lib/create-authorization-data');
	var errors = require('./errors');
	var GraphQL = require('./request/graphql');
	var isDateStringBeforeOrOn = require('../lib/is-date-string-before-or-on');
	
	var BRAINTREE_VERSION = require('./constants').BRAINTREE_VERSION;
	
	function getConfiguration(options) {
	  return new Promise(function (resolve, reject) {
	    var configuration, authData, attrs, configUrl, reqOptions;
	    var sessionId = uuid();
	    var analyticsMetadata = {
	      merchantAppId: global.location.host,
	      platform: constants.PLATFORM,
	      sdkVersion: constants.VERSION,
	      source: constants.SOURCE,
	      integration: constants.INTEGRATION,
	      integrationType: constants.INTEGRATION,
	      sessionId: sessionId
	    };
	
	    try {
	      authData = createAuthorizationData(options.authorization);
	    } catch (err) {
	      reject(new BraintreeError(errors.CLIENT_INVALID_AUTHORIZATION));
	
	      return;
	    }
	    attrs = authData.attrs;
	    configUrl = authData.configUrl;
	
	    attrs._meta = analyticsMetadata;
	    attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
	    attrs.configVersion = '3';
	
	    reqOptions = {
	      url: configUrl,
	      method: 'GET',
	      data: attrs
	    };
	
	    if (attrs.authorizationFingerprint && authData.graphQL) {
	      if (isDateStringBeforeOrOn(authData.graphQL.date, BRAINTREE_VERSION)) {
	        reqOptions.graphQL = new GraphQL({
	          graphQL: {
	            url: authData.graphQL.url,
	            features: ['configuration']
	          }
	        });
	      }
	
	      reqOptions.metadata = analyticsMetadata;
	    }
	
	    request(reqOptions, function (err, response, status) {
	      var errorTemplate;
	
	      if (err) {
	        if (status === 403) {
	          errorTemplate = errors.CLIENT_AUTHORIZATION_INSUFFICIENT;
	        } else {
	          errorTemplate = errors.CLIENT_GATEWAY_NETWORK;
	        }
	
	        reject(new BraintreeError({
	          type: errorTemplate.type,
	          code: errorTemplate.code,
	          message: errorTemplate.message,
	          details: {
	            originalError: err
	          }
	        }));
	
	        return;
	      }
	
	      configuration = {
	        authorization: options.authorization,
	        authorizationType: attrs.tokenizationKey ? 'TOKENIZATION_KEY' : 'CLIENT_TOKEN',
	        authorizationFingerprint: attrs.authorizationFingerprint,
	        analyticsMetadata: analyticsMetadata,
	        gatewayConfiguration: response
	      };
	
	      resolve(configuration);
	    });
	  });
	}
	
	module.exports = {
	  getConfiguration: wrapPromise(getConfiguration)
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../lib/braintree-error":73,"../lib/constants":77,"../lib/create-authorization-data":81,"../lib/is-date-string-before-or-on":89,"../lib/promise":95,"../lib/vendor/uuid":99,"./constants":33,"./errors":34,"./request":47,"./request/graphql":45,"@braintree/wrap-promise":27}],36:[function(require,module,exports){
	'use strict';
	
	var BraintreeError = require('../lib/braintree-error');
	var Client = require('./client');
	var VERSION = "3.47.0";
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	var sharedErrors = require('../lib/errors');
	
	/** @module braintree-web/client */
	
	/**
	 * @function create
	 * @description This function is the entry point for the <code>braintree.client</code> module. It is used for creating {@link Client} instances that service communication to Braintree servers.
	 * @param {object} options Object containing all {@link Client} options:
	 * @param {string} options.authorization A tokenizationKey or clientToken.
	 * @param {callback} [callback] The second argument, <code>data</code>, is the {@link Client} instance.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * var createClient = require('braintree-web/client').create;
	 *
	 * createClient({
	 *   authorization: CLIENT_AUTHORIZATION
	 * }, function (createErr, clientInstance) {
	 *   // ...
	 * });
	 * @static
	 */
	function create(options) {
	  if (!options.authorization) {
	    return Promise.reject(new BraintreeError({
	      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
	      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
	      message: 'options.authorization is required when instantiating a client.'
	    }));
	  }
	
	  return Client.initialize(options);
	}
	
	module.exports = {
	  create: wrapPromise(create),
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/braintree-error":73,"../lib/errors":86,"../lib/promise":95,"./client":32,"@braintree/wrap-promise":27}],37:[function(require,module,exports){
	'use strict';
	
	var querystring = require('../../lib/querystring');
	var browserDetection = require('../browser-detection');
	var assign = require('../../lib/assign').assign;
	var prepBody = require('./prep-body');
	var parseBody = require('./parse-body');
	var xhr = require('./xhr');
	var isXHRAvailable = xhr.isAvailable;
	var GraphQLRequest = require('./graphql/request');
	var DefaultRequest = require('./default-request');
	
	var MAX_TCP_RETRYCOUNT = 1;
	var TCP_PRECONNECT_BUG_STATUS_CODE = 408;
	
	function requestShouldRetry(status) {
	  return (!status || status === TCP_PRECONNECT_BUG_STATUS_CODE) && browserDetection.isIe();
	}
	
	function graphQLRequestShouldRetryWithClientApi(body) {
	  var errorClass = !body.data && body.errors &&
	      body.errors[0] &&
	      body.errors[0].extensions &&
	      body.errors[0].extensions.errorClass;
	
	  return errorClass === 'UNKNOWN' || errorClass === 'INTERNAL';
	}
	
	function _requestWithRetry(options, tcpRetryCount, cb) {
	  var status, resBody, ajaxRequest, body, method, headers, parsedBody;
	  var url = options.url;
	  var graphQL = options.graphQL;
	  var timeout = options.timeout;
	  var req = xhr.getRequestObject();
	  var callback = cb;
	  var isGraphQLRequest = Boolean(graphQL && graphQL.isGraphQLRequest(url, options.data));
	
	  options.headers = assign({'Content-Type': 'application/json'}, options.headers);
	
	  if (isGraphQLRequest) {
	    ajaxRequest = new GraphQLRequest(options);
	  } else {
	    ajaxRequest = new DefaultRequest(options);
	  }
	
	  url = ajaxRequest.getUrl();
	  body = ajaxRequest.getBody();
	  method = ajaxRequest.getMethod();
	  headers = ajaxRequest.getHeaders();
	
	  if (method === 'GET') {
	    url = querystring.queryify(url, body);
	    body = null;
	  }
	
	  if (isXHRAvailable) {
	    req.onreadystatechange = function () {
	      if (req.readyState !== 4) { return; }
	
	      if (req.status === 0 && isGraphQLRequest) {
	        // If a merchant experiences a connection
	        // issue to the GraphQL endpoint (possibly
	        // due to a Content Security Policy), retry
	        // the request against the old client API.
	        delete options.graphQL;
	        _requestWithRetry(options, tcpRetryCount, cb);
	
	        return;
	      }
	
	      parsedBody = parseBody(req.responseText);
	      resBody = ajaxRequest.adaptResponseBody(parsedBody);
	      status = ajaxRequest.determineStatus(req.status, parsedBody);
	
	      if (status >= 400 || status < 200) {
	        if (isGraphQLRequest && graphQLRequestShouldRetryWithClientApi(parsedBody)) {
	          delete options.graphQL;
	          _requestWithRetry(options, tcpRetryCount, cb);
	
	          return;
	        }
	
	        if (tcpRetryCount < MAX_TCP_RETRYCOUNT && requestShouldRetry(status)) {
	          tcpRetryCount++;
	          _requestWithRetry(options, tcpRetryCount, cb);
	
	          return;
	        }
	        callback(resBody || 'error', null, status || 500);
	      } else {
	        callback(null, resBody, status);
	      }
	    };
	  } else {
	    if (options.headers) {
	      url = querystring.queryify(url, headers);
	    }
	
	    req.onload = function () {
	      callback(null, parseBody(req.responseText), req.status);
	    };
	
	    req.onerror = function () {
	      // XDomainRequest does not report a body or status for errors, so
	      // hardcode to 'error' and 500, respectively
	      callback('error', null, 500);
	    };
	
	    // This must remain for IE9 to work
	    req.onprogress = function () {};
	
	    req.ontimeout = function () {
	      callback('timeout', null, -1);
	    };
	  }
	
	  try {
	    req.open(method, url, true);
	  } catch (requestOpenError) {
	    // If a merchant has a Content Security Policy and they have
	    // not allowed our endpoints, some browsers may
	    // synchronously throw an error. If it is not a GraphQL
	    // request, we throw the error. If it is a GraphQL request
	    // we remove the GraphQL option and try the request against
	    // the old client API.
	    if (!isGraphQLRequest) {
	      throw requestOpenError;
	    }
	
	    delete options.graphQL;
	
	    _requestWithRetry(options, tcpRetryCount, cb);
	
	    return;
	  }
	
	  req.timeout = timeout;
	
	  if (isXHRAvailable) {
	    Object.keys(headers).forEach(function (headerKey) {
	      req.setRequestHeader(headerKey, headers[headerKey]);
	    });
	  }
	
	  try {
	    req.send(prepBody(method, body));
	  } catch (e) { /* ignored */ }
	}
	
	function request(options, cb) {
	  _requestWithRetry(options, 0, cb);
	}
	
	module.exports = {
	  request: request
	};
	
	},{"../../lib/assign":70,"../../lib/querystring":96,"../browser-detection":31,"./default-request":38,"./graphql/request":46,"./parse-body":50,"./prep-body":51,"./xhr":52}],38:[function(require,module,exports){
	'use strict';
	
	function DefaultRequest(options) {
	  this._url = options.url;
	  this._data = options.data;
	  this._method = options.method;
	  this._headers = options.headers;
	}
	
	DefaultRequest.prototype.getUrl = function () {
	  return this._url;
	};
	
	DefaultRequest.prototype.getBody = function () {
	  return this._data;
	};
	
	DefaultRequest.prototype.getMethod = function () {
	  return this._method;
	};
	
	DefaultRequest.prototype.getHeaders = function () {
	  return this._headers;
	};
	
	DefaultRequest.prototype.adaptResponseBody = function (parsedBody) {
	  return parsedBody;
	};
	
	DefaultRequest.prototype.determineStatus = function (status) {
	  return status;
	};
	
	module.exports = DefaultRequest;
	
	},{}],39:[function(require,module,exports){
	(function (global){
	'use strict';
	
	module.exports = function getUserAgent() {
	  return global.navigator.userAgent;
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],40:[function(require,module,exports){
	'use strict';
	
	var errorResponseAdapter = require('./error');
	var assign = require('../../../../lib/assign').assign;
	
	/* eslint-disable camelcase */
	var cardTypeTransforms = {
	  creditCard: {
	    AMERICAN_EXPRESS: 'American Express',
	    DISCOVER: 'Discover',
	    INTERNATIONAL_MAESTRO: 'Maestro',
	    JCB: 'JCB',
	    MASTERCARD: 'MasterCard',
	    SOLO: 'Solo',
	    UK_MAESTRO: 'UK Maestro',
	    UNION_PAY: 'UnionPay',
	    VISA: 'Visa'
	  },
	  applePayWeb: {
	    VISA: 'visa',
	    MASTERCARD: 'mastercard',
	    DISCOVER: 'discover',
	    AMERICAN_EXPRESS: 'amex'
	  },
	  visaCheckout: {
	    VISA: 'Visa',
	    MASTERCARD: 'MasterCard',
	    DISCOVER: 'Discover',
	    AMERICAN_EXPRESS: 'American Express'
	  },
	  googlePay: {
	    VISA: 'visa',
	    MASTERCARD: 'mastercard',
	    DISCOVER: 'discover',
	    AMERICAN_EXPRESS: 'amex'
	  },
	  masterpass: {
	    VISA: 'visa',
	    MASTERCARD: 'master',
	    DISCOVER: 'discover',
	    AMERICAN_EXPRESS: 'amex',
	    DINERS: 'diners',
	    INTERNATIONAL_MAESTRO: 'maestro',
	    JCB: 'jcb'
	  }
	};
	/* eslint-enable camelcase */
	
	function configurationResponseAdapter(responseBody, ctx) {
	  var adaptedResponse;
	
	  if (responseBody.data && !responseBody.errors) {
	    adaptedResponse = adaptConfigurationResponseBody(responseBody, ctx);
	  } else {
	    adaptedResponse = errorResponseAdapter(responseBody);
	  }
	
	  return adaptedResponse;
	}
	
	function adaptConfigurationResponseBody(body, ctx) {
	  var configuration = body.data.clientConfiguration;
	  var response;
	
	  response = {
	    environment: configuration.environment.toLowerCase(),
	    clientApiUrl: configuration.clientApiUrl,
	    assetsUrl: configuration.assetsUrl,
	    analytics: {
	      url: configuration.analyticsUrl
	    },
	    merchantId: configuration.merchantId,
	    venmo: 'off'
	  };
	
	  if (configuration.supportedFeatures) {
	    response.graphQL = {
	      url: ctx._graphQL._config.url,
	      features: configuration.supportedFeatures.map(function (feature) {
	        return feature.toLowerCase();
	      })
	    };
	  }
	
	  if (configuration.braintreeApi) {
	    response.braintreeApi = configuration.braintreeApi;
	  }
	
	  if (configuration.applePayWeb) {
	    response.applePayWeb = configuration.applePayWeb;
	    response.applePayWeb.supportedNetworks = mapCardTypes(configuration.applePayWeb.supportedCardBrands, cardTypeTransforms.applePayWeb);
	
	    delete response.applePayWeb.supportedCardBrands;
	  }
	
	  if (configuration.ideal) {
	    response.ideal = configuration.ideal;
	  }
	
	  if (configuration.kount) {
	    response.kount = {
	      kountMerchantId: configuration.kount.merchantId
	    };
	  }
	
	  if (configuration.creditCard) {
	    response.challenges = configuration.creditCard.challenges.map(function (challenge) {
	      return challenge.toLowerCase();
	    });
	
	    response.creditCards = {
	      supportedCardTypes: mapCardTypes(configuration.creditCard.supportedCardBrands, cardTypeTransforms.creditCard)
	    };
	    response.threeDSecureEnabled = configuration.creditCard.threeDSecureEnabled;
	    response.threeDSecure = configuration.creditCard.threeDSecure;
	  } else {
	    response.challenges = [];
	    response.creditCards = {
	      supportedCardTypes: []
	    };
	    response.threeDSecureEnabled = false;
	  }
	
	  if (configuration.googlePay) {
	    response.androidPay = {
	      displayName: configuration.googlePay.displayName,
	      enabled: true,
	      environment: configuration.googlePay.environment.toLowerCase(),
	      googleAuthorizationFingerprint: configuration.googlePay.googleAuthorization,
	      supportedNetworks: mapCardTypes(configuration.googlePay.supportedCardBrands, cardTypeTransforms.googlePay)
	    };
	  }
	
	  if (configuration.venmo) {
	    response.payWithVenmo = {
	      merchantId: configuration.venmo.merchantId,
	      accessToken: configuration.venmo.accessToken,
	      environment: configuration.venmo.environment.toLowerCase()
	    };
	  }
	
	  if (configuration.paypal) {
	    response.paypalEnabled = true;
	    response.paypal = assign({}, configuration.paypal);
	    response.paypal.currencyIsoCode = response.paypal.currencyCode;
	    response.paypal.environment = response.paypal.environment.toLowerCase();
	
	    delete response.paypal.currencyCode;
	  } else {
	    response.paypalEnabled = false;
	  }
	
	  if (configuration.unionPay) {
	    response.unionPay = {
	      enabled: true,
	      merchantAccountId: configuration.unionPay.merchantAccountId
	    };
	  }
	
	  if (configuration.visaCheckout) {
	    response.visaCheckout = {
	      apikey: configuration.visaCheckout.apiKey,
	      externalClientId: configuration.visaCheckout.externalClientId,
	      supportedCardTypes: mapCardTypes(configuration.visaCheckout.supportedCardBrands, cardTypeTransforms.visaCheckout)
	    };
	  }
	
	  if (configuration.masterpass) {
	    response.masterpass = {
	      merchantCheckoutId: configuration.masterpass.merchantCheckoutId,
	      supportedNetworks: mapCardTypes(configuration.masterpass.supportedCardBrands, cardTypeTransforms.masterpass)
	    };
	  }
	
	  if (configuration.usBankAccount) {
	    response.usBankAccount = {
	      routeId: configuration.usBankAccount.routeId,
	      plaid: {
	        publicKey: configuration.usBankAccount.plaidPublicKey
	      }
	    };
	  }
	
	  return response;
	}
	
	function mapCardTypes(cardTypes, cardTypeTransformMap) {
	  return cardTypes.reduce(function (acc, type) {
	    if (cardTypeTransformMap.hasOwnProperty(type)) {
	      return acc.concat(cardTypeTransformMap[type]);
	    }
	
	    return acc;
	  }, []);
	}
	
	module.exports = configurationResponseAdapter;
	
	},{"../../../../lib/assign":70,"./error":42}],41:[function(require,module,exports){
	'use strict';
	
	var errorResponseAdapter = require('./error');
	
	var CARD_BRAND_MAP = {
	  /* eslint-disable camelcase */
	  AMERICAN_EXPRESS: 'American Express',
	  DINERS: 'Discover',
	  DISCOVER: 'Discover',
	  INTERNATIONAL_MAESTRO: 'Maestro',
	  JCB: 'JCB',
	  MASTERCARD: 'MasterCard',
	  UK_MAESTRO: 'Maestro',
	  UNION_PAY: 'Union Pay',
	  VISA: 'Visa'
	  /* eslint-enable camelcase */
	};
	
	var BIN_DATA_MAP = {
	  YES: 'Yes',
	  NO: 'No',
	  UNKNOWN: 'Unknown'
	};
	
	function creditCardTokenizationResponseAdapter(responseBody) {
	  var adaptedResponse;
	
	  if (responseBody.data && !responseBody.errors) {
	    adaptedResponse = adaptTokenizeCreditCardResponseBody(responseBody);
	  } else {
	    adaptedResponse = errorResponseAdapter(responseBody);
	  }
	
	  return adaptedResponse;
	}
	
	function adaptTokenizeCreditCardResponseBody(body) {
	  var data = body.data.tokenizeCreditCard;
	  var creditCard = data.creditCard;
	  var lastTwo = creditCard.last4 ? creditCard.last4.substr(2, 4) : '';
	  var binData = creditCard.binData;
	  var response;
	
	  if (binData) {
	    ['commercial', 'debit', 'durbinRegulated', 'healthcare', 'payroll', 'prepaid'].forEach(function (key) {
	      if (binData[key]) {
	        binData[key] = BIN_DATA_MAP[binData[key]];
	      } else {
	        binData[key] = 'Unknown';
	      }
	    });
	
	    ['issuingBank', 'countryOfIssuance', 'productId'].forEach(function (key) {
	      if (!binData[key]) { binData[key] = 'Unknown'; }
	    });
	  }
	
	  response = {
	    creditCards: [
	      {
	        binData: binData,
	        consumed: false,
	        description: lastTwo ? 'ending in ' + lastTwo : '',
	        nonce: data.token,
	        details: {
	          bin: creditCard.bin || '',
	          cardType: CARD_BRAND_MAP[creditCard.brandCode] || 'Unknown',
	          lastFour: creditCard.last4 || '',
	          lastTwo: lastTwo
	        },
	        type: 'CreditCard',
	        threeDSecureInfo: null
	      }
	    ]
	  };
	
	  return response;
	}
	
	module.exports = creditCardTokenizationResponseAdapter;
	
	},{"./error":42}],42:[function(require,module,exports){
	'use strict';
	
	function errorResponseAdapter(responseBody) {
	  var response;
	  var errorClass = responseBody.errors &&
	    responseBody.errors[0] &&
	    responseBody.errors[0].extensions &&
	    responseBody.errors[0].extensions.errorClass;
	
	  if (errorClass === 'VALIDATION') {
	    response = userErrorResponseAdapter(responseBody);
	  } else if (errorClass) {
	    response = errorWithClassResponseAdapter(responseBody);
	  } else {
	    response = {error: {message: 'There was a problem serving your request'}, fieldErrors: []};
	  }
	
	  return response;
	}
	
	function errorWithClassResponseAdapter(responseBody) {
	  return {error: {message: responseBody.errors[0].message}, fieldErrors: []};
	}
	
	function userErrorResponseAdapter(responseBody) {
	  var fieldErrors = buildFieldErrors(responseBody.errors);
	
	  return {error: {message: getLegacyMessage(fieldErrors)}, fieldErrors: fieldErrors};
	}
	
	function buildFieldErrors(errors) {
	  var fieldErrors = [];
	
	  errors.forEach(function (error) {
	    addFieldError(error.extensions.inputPath.slice(1), error, fieldErrors);
	  });
	
	  return fieldErrors;
	}
	
	function addFieldError(inputPath, errorDetail, fieldErrors) {
	  var fieldError;
	  var legacyCode = errorDetail.extensions.legacyCode;
	  var inputField = inputPath[0];
	
	  if (inputPath.length === 1) {
	    fieldErrors.push({
	      code: legacyCode,
	      field: inputField,
	      message: errorDetail.message
	    });
	
	    return;
	  }
	
	  fieldErrors.forEach(function (candidate) {
	    if (candidate.field === inputField) {
	      fieldError = candidate;
	    }
	  });
	
	  if (!fieldError) {
	    fieldError = {field: inputField, fieldErrors: []};
	    fieldErrors.push(fieldError);
	  }
	
	  addFieldError(inputPath.slice(1), errorDetail, fieldError.fieldErrors);
	}
	
	function getLegacyMessage(errors) {
	  var legacyMessages = {
	    creditCard: 'Credit card is invalid'
	  };
	
	  var field = errors[0].field;
	
	  return legacyMessages[field];
	}
	
	module.exports = errorResponseAdapter;
	
	},{}],43:[function(require,module,exports){
	'use strict';
	
	var CONFIGURATION_QUERY = 'query ClientConfiguration { ' +
	'  clientConfiguration { ' +
	'    analyticsUrl ' +
	'    environment ' +
	'    merchantId ' +
	'    assetsUrl ' +
	'    clientApiUrl ' +
	'    creditCard { ' +
	'      supportedCardBrands ' +
	'      challenges ' +
	'      threeDSecureEnabled ' +
	'      threeDSecure { ' +
	'        cardinalAuthenticationJWT ' +
	'      } ' +
	'    } ' +
	'    applePayWeb { ' +
	'      countryCode ' +
	'      currencyCode ' +
	'      merchantIdentifier ' +
	'      supportedCardBrands ' +
	'    } ' +
	'    googlePay { ' +
	'      displayName ' +
	'      supportedCardBrands ' +
	'      environment ' +
	'      googleAuthorization ' +
	'    } ' +
	'    ideal { ' +
	'      routeId ' +
	'      assetsUrl ' +
	'    } ' +
	'    kount { ' +
	'      merchantId ' +
	'    } ' +
	'    masterpass { ' +
	'      merchantCheckoutId ' +
	'      supportedCardBrands ' +
	'    } ' +
	'    paypal { ' +
	'      displayName ' +
	'      clientId ' +
	'      privacyUrl ' +
	'      userAgreementUrl ' +
	'      assetsUrl ' +
	'      environment ' +
	'      environmentNoNetwork ' +
	'      unvettedMerchant ' +
	'      braintreeClientId ' +
	'      billingAgreementsEnabled ' +
	'      merchantAccountId ' +
	'      currencyCode ' +
	'      payeeEmail ' +
	'    } ' +
	'    unionPay { ' +
	'      merchantAccountId ' +
	'    } ' +
	'    usBankAccount { ' +
	'      routeId ' +
	'      plaidPublicKey ' +
	'    } ' +
	'    venmo { ' +
	'      merchantId ' +
	'      accessToken ' +
	'      environment ' +
	'    } ' +
	'    visaCheckout { ' +
	'      apiKey ' +
	'      externalClientId ' +
	'      supportedCardBrands ' +
	'    } ' +
	'    braintreeApi { ' +
	'      accessToken ' +
	'      url ' +
	'    } ' +
	'    supportedFeatures ' +
	'  } ' +
	'}';
	
	function configuration() {
	  return {
	    query: CONFIGURATION_QUERY,
	    operationName: 'ClientConfiguration'
	  };
	}
	
	module.exports = configuration;
	
	},{}],44:[function(require,module,exports){
	'use strict';
	
	var assign = require('../../../../lib/assign').assign;
	
	var CREDIT_CARD_TOKENIZATION_MUTATION = 'mutation TokenizeCreditCard($input: TokenizeCreditCardInput!) { ' +
	'  tokenizeCreditCard(input: $input) { ' +
	'    token ' +
	'    creditCard { ' +
	'      bin ' +
	'      brandCode ' +
	'      last4 ' +
	'      binData { ' +
	'        prepaid ' +
	'        healthcare ' +
	'        debit ' +
	'        durbinRegulated ' +
	'        commercial ' +
	'        payroll ' +
	'        issuingBank ' +
	'        countryOfIssuance ' +
	'        productId ' +
	'      } ' +
	'    } ' +
	'  } ' +
	'}';
	
	function createCreditCardTokenizationBody(body) {
	  var cc = body.creditCard;
	  var billingAddress = cc && cc.billingAddress;
	  var expDate = cc && cc.expirationDate;
	  var expirationMonth = cc && (cc.expirationMonth || (expDate && expDate.split('/')[0].trim()));
	  var expirationYear = cc && (cc.expirationYear || (expDate && expDate.split('/')[1].trim()));
	  var variables = {
	    input: {
	      creditCard: {
	        number: cc && cc.number,
	        expirationMonth: expirationMonth,
	        expirationYear: expirationYear,
	        cvv: cc && cc.cvv,
	        cardholderName: cc && cc.cardholderName
	      },
	      options: {}
	    }
	  };
	
	  if (billingAddress) {
	    variables.input.creditCard.billingAddress = billingAddress;
	  }
	
	  variables.input = addValidationRule(body, variables.input);
	
	  return variables;
	}
	
	function addValidationRule(body, input) {
	  var validate;
	
	  if (body.creditCard && body.creditCard.options && typeof body.creditCard.options.validate === 'boolean') {
	    validate = body.creditCard.options.validate;
	  } else if ((body.authorizationFingerprint && body.tokenizationKey) || body.authorizationFingerprint) {
	    validate = true;
	  } else if (body.tokenizationKey) {
	    validate = false;
	  }
	
	  if (typeof validate === 'boolean') {
	    input.options = assign({
	      validate: validate
	    }, input.options);
	  }
	
	  return input;
	}
	
	function creditCardTokenization(body) {
	  return {
	    query: CREDIT_CARD_TOKENIZATION_MUTATION,
	    variables: createCreditCardTokenizationBody(body),
	    operationName: 'TokenizeCreditCard'
	  };
	}
	
	module.exports = creditCardTokenization;
	
	},{"../../../../lib/assign":70}],45:[function(require,module,exports){
	'use strict';
	
	var browserDetection = require('../../browser-detection');
	
	var features = {
	  tokenize_credit_cards: 'payment_methods/credit_cards', // eslint-disable-line camelcase
	  configuration: 'configuration'
	};
	
	var disallowedInputPaths = [
	  'creditCard.options.unionPayEnrollment'
	];
	
	function GraphQL(config) {
	  this._config = config.graphQL;
	}
	
	GraphQL.prototype.getGraphQLEndpoint = function () {
	  return this._config.url;
	};
	
	GraphQL.prototype.isGraphQLRequest = function (url, body) {
	  var featureEnabled;
	  var path = this.getClientApiPath(url);
	
	  if (!this._isGraphQLEnabled() || !path || browserDetection.isIe9()) {
	    return false;
	  }
	
	  featureEnabled = this._config.features.some(function (feature) {
	    return features[feature] === path;
	  });
	
	  if (containsDisallowedlistedKeys(body)) {
	    return false;
	  }
	
	  return featureEnabled;
	};
	
	GraphQL.prototype.getClientApiPath = function (url) {
	  var path;
	  var clientApiPrefix = '/client_api/v1/';
	  var pathParts = url.split(clientApiPrefix);
	
	  if (pathParts.length > 1) {
	    path = pathParts[1].split('?')[0];
	  }
	
	  return path;
	};
	
	GraphQL.prototype._isGraphQLEnabled = function () {
	  return Boolean(this._config);
	};
	
	function containsDisallowedlistedKeys(body) {
	  return disallowedInputPaths.some(function (keys) {
	    var value = keys.split('.').reduce(function (accumulator, key) {
	      return accumulator && accumulator[key];
	    }, body);
	
	    return value !== undefined; // eslint-disable-line no-undefined
	  });
	}
	
	module.exports = GraphQL;
	
	},{"../../browser-detection":31}],46:[function(require,module,exports){
	'use strict';
	
	var BRAINTREE_VERSION = require('../../constants').BRAINTREE_VERSION;
	
	var assign = require('../../../lib/assign').assign;
	
	var creditCardTokenizationBodyGenerator = require('./generators/credit-card-tokenization');
	var creditCardTokenizationResponseAdapter = require('./adapters/credit-card-tokenization');
	
	var configurationBodyGenerator = require('./generators/configuration');
	var configurationResponseAdapter = require('./adapters/configuration');
	
	var generators = {
	  'payment_methods/credit_cards': creditCardTokenizationBodyGenerator,
	  configuration: configurationBodyGenerator
	};
	var adapters = {
	  'payment_methods/credit_cards': creditCardTokenizationResponseAdapter,
	  configuration: configurationResponseAdapter
	};
	
	function GraphQLRequest(options) {
	  var clientApiPath = options.graphQL.getClientApiPath(options.url);
	
	  this._graphQL = options.graphQL;
	  this._data = options.data;
	  this._method = options.method;
	  this._headers = options.headers;
	  this._clientSdkMetadata = {
	    source: options.metadata.source,
	    integration: options.metadata.integration,
	    sessionId: options.metadata.sessionId
	  };
	  this._sendAnalyticsEvent = options.sendAnalyticsEvent || Function.prototype;
	
	  this._generator = generators[clientApiPath];
	  this._adapter = adapters[clientApiPath];
	
	  this._sendAnalyticsEvent('graphql.init');
	}
	
	GraphQLRequest.prototype.getUrl = function () {
	  return this._graphQL.getGraphQLEndpoint();
	};
	
	GraphQLRequest.prototype.getBody = function () {
	  var formattedBody = formatBodyKeys(this._data);
	  var generatedBody = this._generator(formattedBody);
	  var body = assign({clientSdkMetadata: this._clientSdkMetadata}, generatedBody);
	
	  return JSON.stringify(body);
	};
	
	GraphQLRequest.prototype.getMethod = function () {
	  return 'POST';
	};
	
	GraphQLRequest.prototype.getHeaders = function () {
	  var authorization, headers;
	
	  if (this._data.authorizationFingerprint) {
	    this._sendAnalyticsEvent('graphql.authorization-fingerprint');
	    authorization = this._data.authorizationFingerprint;
	  } else {
	    this._sendAnalyticsEvent('graphql.tokenization-key');
	    authorization = this._data.tokenizationKey;
	  }
	
	  headers = {
	    Authorization: 'Bearer ' + authorization,
	    'Braintree-Version': BRAINTREE_VERSION
	  };
	
	  return assign({}, this._headers, headers);
	};
	
	GraphQLRequest.prototype.adaptResponseBody = function (parsedBody) {
	  return this._adapter(parsedBody, this);
	};
	
	GraphQLRequest.prototype.determineStatus = function (httpStatus, parsedResponse) {
	  var status, errorClass;
	
	  if (httpStatus === 200) {
	    errorClass = parsedResponse.errors &&
	      parsedResponse.errors[0] &&
	      parsedResponse.errors[0].extensions &&
	      parsedResponse.errors[0].extensions.errorClass;
	
	    if (parsedResponse.data && !parsedResponse.errors) {
	      status = 200;
	    } else if (errorClass === 'VALIDATION') {
	      status = 422;
	    } else if (errorClass === 'AUTHORIZATION') {
	      status = 403;
	    } else if (errorClass === 'AUTHENTICATION') {
	      status = 401;
	    } else if (isGraphQLError(errorClass, parsedResponse)) {
	      status = 403;
	    } else {
	      status = 500;
	    }
	  } else if (!httpStatus) {
	    status = 500;
	  } else {
	    status = httpStatus;
	  }
	
	  this._sendAnalyticsEvent('graphql.status.' + httpStatus);
	  this._sendAnalyticsEvent('graphql.determinedStatus.' + status);
	
	  return status;
	};
	
	function isGraphQLError(errorClass, parsedResponse) {
	  return !errorClass && parsedResponse.errors[0].message;
	}
	
	function snakeCaseToCamelCase(snakeString) {
	  if (snakeString.indexOf('_') === -1) {
	    return snakeString;
	  }
	
	  return snakeString.toLowerCase().replace(/(\_\w)/g, function (match) {
	    return match[1].toUpperCase();
	  });
	}
	
	function formatBodyKeys(originalBody) {
	  var body = {};
	
	  Object.keys(originalBody).forEach(function (key) {
	    var camelCaseKey = snakeCaseToCamelCase(key);
	
	    if (typeof originalBody[key] === 'object') {
	      body[camelCaseKey] = formatBodyKeys(originalBody[key]);
	    } else if (typeof originalBody[key] === 'number') {
	      body[camelCaseKey] = String(originalBody[key]);
	    } else {
	      body[camelCaseKey] = originalBody[key];
	    }
	  });
	
	  return body;
	}
	
	module.exports = GraphQLRequest;
	
	},{"../../../lib/assign":70,"../../constants":33,"./adapters/configuration":40,"./adapters/credit-card-tokenization":41,"./generators/configuration":43,"./generators/credit-card-tokenization":44}],47:[function(require,module,exports){
	'use strict';
	
	var ajaxIsAvaliable;
	var once = require('../../lib/once');
	var JSONPDriver = require('./jsonp-driver');
	var AJAXDriver = require('./ajax-driver');
	var getUserAgent = require('./get-user-agent');
	var isHTTP = require('./is-http');
	
	function isAjaxAvailable() {
	  if (ajaxIsAvaliable == null) {
	    ajaxIsAvaliable = !(isHTTP() && /MSIE\s(8|9)/.test(getUserAgent()));
	  }
	
	  return ajaxIsAvaliable;
	}
	
	module.exports = function (options, cb) {
	  cb = once(cb || Function.prototype);
	  options.method = (options.method || 'GET').toUpperCase();
	  options.timeout = options.timeout == null ? 60000 : options.timeout;
	  options.data = options.data || {};
	
	  if (isAjaxAvailable()) {
	    AJAXDriver.request(options, cb);
	  } else {
	    JSONPDriver.request(options, cb);
	  }
	};
	
	},{"../../lib/once":94,"./ajax-driver":37,"./get-user-agent":39,"./is-http":48,"./jsonp-driver":49}],48:[function(require,module,exports){
	(function (global){
	'use strict';
	
	module.exports = function () {
	  return global.location.protocol === 'http:';
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],49:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var head;
	var uuid = require('../../lib/vendor/uuid');
	var querystring = require('../../lib/querystring');
	var timeouts = {};
	
	function _removeScript(script) {
	  if (script && script.parentNode) {
	    script.parentNode.removeChild(script);
	  }
	}
	
	function _createScriptTag(url, callbackName) {
	  var script = document.createElement('script');
	  var done = false;
	
	  script.src = url;
	  script.async = true;
	  script.onerror = function () {
	    global[callbackName]({message: 'error', status: 500});
	  };
	
	  script.onload = script.onreadystatechange = function () {
	    if (done) { return; }
	
	    if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
	      done = true;
	      script.onload = script.onreadystatechange = null;
	    }
	  };
	
	  return script;
	}
	
	function _cleanupGlobal(callbackName) {
	  try {
	    delete global[callbackName];
	  } catch (_) {
	    global[callbackName] = null;
	  }
	}
	
	function _setupTimeout(timeout, callbackName) {
	  timeouts[callbackName] = setTimeout(function () {
	    timeouts[callbackName] = null;
	
	    global[callbackName]({
	      error: 'timeout',
	      status: -1
	    });
	
	    global[callbackName] = function () {
	      _cleanupGlobal(callbackName);
	    };
	  }, timeout);
	}
	
	function _setupGlobalCallback(script, callback, callbackName) {
	  global[callbackName] = function (response) {
	    var status = response.status || 500;
	    var err = null;
	    var data = null;
	
	    delete response.status;
	
	    if (status >= 400 || status < 200) {
	      err = response;
	    } else {
	      data = response;
	    }
	
	    _cleanupGlobal(callbackName);
	    _removeScript(script);
	
	    clearTimeout(timeouts[callbackName]);
	    callback(err, data, status);
	  };
	}
	
	function request(options, callback) {
	  var script;
	  var callbackName = 'callback_json_' + uuid().replace(/-/g, '');
	  var url = options.url;
	  var attrs = options.data;
	  var method = options.method;
	  var timeout = options.timeout;
	
	  url = querystring.queryify(url, attrs);
	  url = querystring.queryify(url, {
	    _method: method,
	    callback: callbackName
	  });
	
	  script = _createScriptTag(url, callbackName);
	  _setupGlobalCallback(script, callback, callbackName);
	  _setupTimeout(timeout, callbackName);
	
	  if (!head) {
	    head = document.getElementsByTagName('head')[0];
	  }
	
	  head.appendChild(script);
	}
	
	module.exports = {
	  request: request
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../../lib/querystring":96,"../../lib/vendor/uuid":99}],50:[function(require,module,exports){
	'use strict';
	
	module.exports = function (body) {
	  try {
	    body = JSON.parse(body);
	  } catch (e) { /* ignored */ }
	
	  return body;
	};
	
	},{}],51:[function(require,module,exports){
	'use strict';
	
	module.exports = function (method, body) {
	  if (typeof method !== 'string') {
	    throw new Error('Method must be a string');
	  }
	
	  if (method.toLowerCase() !== 'get' && body != null) {
	    body = typeof body === 'string' ? body : JSON.stringify(body);
	  }
	
	  return body;
	};
	
	},{}],52:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var isXHRAvailable = global.XMLHttpRequest && 'withCredentials' in new global.XMLHttpRequest();
	
	function getRequestObject() {
	  return isXHRAvailable ? new global.XMLHttpRequest() : new global.XDomainRequest();
	}
	
	module.exports = {
	  isAvailable: isXHRAvailable,
	  getRequestObject: getRequestObject
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],53:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.Google Payment - Creation Error Codes
	 * @description Errors that occur when [creating the Google Payment component](/current/module-braintree-web_google-payment.html#.create).
	 * @property {MERCHANT} GOOGLE_PAYMENT_NOT_ENABLED Occurs when Google Pay is not enabled on the Braintree control panel.
	 * @property {MERCHANT} GOOGLE_PAYMENT_UNSUPPORTED_VERSION Occurs when a Google Pay version is used that is not supported by the Braintree SDK.
	 */
	
	/**
	 * @name BraintreeError.Google Payment - parseResponse Error Codes
	 * @description Errors that occur when [parsing the response from Google](/current/GooglePayment.html#parseResponse).
	 * @property {UNKNOWN} GOOGLE_PAYMENT_GATEWAY_ERROR Occurs when Google Pay could not be tokenized.
	 */
	
	var BraintreeError = require('../lib/braintree-error');
	
	module.exports = {
	  GOOGLE_PAYMENT_NOT_ENABLED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'GOOGLE_PAYMENT_NOT_ENABLED',
	    message: 'Google Pay is not enabled for this merchant.'
	  },
	  GOOGLE_PAYMENT_GATEWAY_ERROR: {
	    code: 'GOOGLE_PAYMENT_GATEWAY_ERROR',
	    message: 'There was an error when tokenizing the Google Pay payment method.',
	    type: BraintreeError.types.UNKNOWN
	  },
	  GOOGLE_PAYMENT_UNSUPPORTED_VERSION: {
	    code: 'GOOGLE_PAYMENT_UNSUPPORTED_VERSION',
	    type: BraintreeError.types.MERCHANT
	  }
	};
	
	},{"../lib/braintree-error":73}],54:[function(require,module,exports){
	'use strict';
	
	var analytics = require('../lib/analytics');
	var assign = require('../lib/assign').assign;
	var convertMethodsToError = require('../lib/convert-methods-to-error');
	var find = require('../lib/find');
	var generateGooglePayConfiguration = require('../lib/generate-google-pay-configuration');
	var BraintreeError = require('../lib/braintree-error');
	var errors = require('./errors');
	var methods = require('../lib/methods');
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	
	var CREATE_PAYMENT_DATA_REQUEST_METHODS = {
	  1: '_createV1PaymentDataRequest',
	  2: '_createV2PaymentDataRequest'
	};
	
	/**
	 * @typedef {object} GooglePayment~tokenizePayload
	 * @property {string} nonce The payment method nonce.
	 * @property {object} details Additional account details.
	 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
	 * @property {string} details.lastFour Last four digits of card number.
	 * @property {string} details.lastTwo Last two digits of card number.
	 * @property {string} description A human-readable description.
	 * @property {string} type The payment method type, `CreditCard` or `AndroidPayCard`.
	 * @property {object} binData Information about the card based on the bin.
	 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.countryOfIssuance The country of issuance.
	 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.issuingBank The issuing bank.
	 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.productId The product id.
	 */
	
	/**
	 * @class GooglePayment
	 * @param {object} options Google Payment {@link module:braintree-web/google-payment.create create} options.
	 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/google-payment.create|braintree-web.google-payment.create} instead.</strong>
	 * @classdesc This class represents a Google Payment component produced by {@link module:braintree-web/google-payment.create|braintree-web/google-payment.create}. Instances of this class have methods for initializing the Google Pay flow.
	 */
	function GooglePayment(options) {
	  this._client = options.client;
	  this._googlePayVersion = options.googlePayVersion || 1;
	  this._googleMerchantId = options.googleMerchantId;
	}
	
	GooglePayment.prototype._initialize = function () {
	  if (this._isUnsupportedGooglePayAPIVersion()) {
	    return Promise.reject(new BraintreeError({
	      code: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.code,
	      message: 'The Braintree SDK does not support Google Pay version ' + this._googlePayVersion + '. Please upgrade the version of your Braintree SDK and contact support if this error persists.',
	      type: errors.GOOGLE_PAYMENT_UNSUPPORTED_VERSION.type
	    }));
	  }
	
	  return Promise.resolve(this);
	};
	
	GooglePayment.prototype._isUnsupportedGooglePayAPIVersion = function () {
	  // if we don't have createPaymentDatqRequest method for the specific
	  // API version, then the version is not supported
	  return !(this._googlePayVersion in CREATE_PAYMENT_DATA_REQUEST_METHODS);
	};
	
	GooglePayment.prototype._getDefaultConfig = function () {
	  if (!this._defaultConfig) {
	    this._defaultConfig = generateGooglePayConfiguration(this._client.getConfiguration(), this._googlePayVersion, this._googleMerchantId);
	  }
	
	  return this._defaultConfig;
	};
	
	GooglePayment.prototype._createV1PaymentDataRequest = function (paymentDataRequest) {
	  var defaultConfig = this._getDefaultConfig();
	  var overrideCardNetworks = paymentDataRequest.cardRequirements && paymentDataRequest.cardRequirements.allowedCardNetworks;
	  var defaultConfigCardNetworks = defaultConfig.cardRequirements.allowedCardNetworks;
	  var allowedCardNetworks = overrideCardNetworks || defaultConfigCardNetworks;
	
	  paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);
	
	  // this way we can preserve allowedCardNetworks from default integration
	  // if merchant did not pass any in `cardRequirements`
	  paymentDataRequest.cardRequirements.allowedCardNetworks = allowedCardNetworks;
	
	  return paymentDataRequest;
	};
	
	GooglePayment.prototype._createV2PaymentDataRequest = function (paymentDataRequest) {
	  var defaultConfig = this._getDefaultConfig();
	
	  if (paymentDataRequest.allowedPaymentMethods) {
	    paymentDataRequest.allowedPaymentMethods.forEach(function (paymentMethod) {
	      var defaultPaymentMethod = find(defaultConfig.allowedPaymentMethods, 'type', paymentMethod.type);
	
	      if (defaultPaymentMethod) {
	        applyDefaultsToPaymentMethodConfiguration(paymentMethod, defaultPaymentMethod);
	      }
	    });
	  }
	
	  paymentDataRequest = assign({}, defaultConfig, paymentDataRequest);
	
	  return paymentDataRequest;
	};
	
	/**
	 * Create a configuration object for use in the `loadPaymentData` method.
	 *
	 * **Note**: Version 1 of the Google Pay Api is deprecated and will become unsupported in a future version. Until then, version 1 will continue to be used by default, and version 1 schema parameters and overrides will remain functional on existing integrations. However, new integrations and all following examples will be presented in the GooglePay version 2 schema. See [Google Pay's upgrade guide](https://developers.google.com/pay/api/web/guides/resources/update-to-latest-version) to see how to update your integration.
	 *
	 * If `options.googlePayVersion === 2` was set during the initial {@link module:braintree-web/google-payment.create|create} call, overrides must match the Google Pay v2 schema to be valid.
	 *
	 * @public
	 * @param {object} overrides The supplied parameters for creating the PaymentDataRequest object. Required parameters are:
	 *  @param {object} overrides.transactionInfo Object according to the [Google Pay Transaction Info](https://developers.google.com/pay/api/web/reference/object#TransactionInfo) spec.
	 *  Optionally, any of the parameters in the [PaymentDataRequest](https://developers.google.com/pay/api/web/reference/object#PaymentDataRequest) parameters can be overridden, but note that it is recommended only to override top level parameters to avoid squashing deeply nested configuration objects. An example can be found below showing how to safely edit these deeply nested objects.
	 * @example
	 * var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
	 *   merchantInfo: {
	 *     merchantId: 'my-merchant-id-from-google'
	 *   },
	 *   transactionInfo: {
	 *     currencyCode: 'USD',
	 *     totalPriceStatus: 'FINAL',
	 *     totalPrice: '100.00'
	 *   }
	 * });
	 *
	 * // Update card payment methods to require billing address
	 * var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods;
	 * cardPaymentMethod.parameters.billingAddressRequired = true;
	 * cardPaymentMethod.parameters.billingAddressParameters = {
	 *   format: 'FULL',
	 *   phoneNumberRequired: true
	 * };
	 *
	 * var paymentsClient = new google.payments.api.PaymentsClient({
	 *   environment: 'TEST' // or 'PRODUCTION'
	 * })
	 *
	 * paymentsClient.loadPaymentData(paymentDataRequest).then(function (response) {
	 *   // handle response with googlePaymentInstance.parseResponse
	 *   // (see below)
	 * });
	 * @returns {object} Returns a configuration object for Google PaymentDataRequest.
	 */
	GooglePayment.prototype.createPaymentDataRequest = function (overrides) {
	  var paymentDataRequest = assign({}, overrides);
	  var version = this._googlePayVersion;
	  var createPaymentDataRequestMethod = CREATE_PAYMENT_DATA_REQUEST_METHODS[version];
	
	  analytics.sendEvent(this._client, 'google-payment.v' + version + '.createPaymentDataRequest');
	
	  return this[createPaymentDataRequestMethod](paymentDataRequest);
	};
	
	/**
	 * Parse the response from the tokenization.
	 * @public
	 * @param {object} response The response back from the Google Pay tokenization.
	 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link GooglePay~tokenizePayload|tokenizePayload}. If no callback is provided, `parseResponse` returns a promise that resolves with a {@link GooglePayment~tokenizePayload|tokenizePayload}.
	 * @example with callback
	 * var paymentsClient = new google.payments.api.PaymentsClient({
	 *   environment: 'TEST' // or 'PRODUCTION'
	 * })
	 *
	 * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
	 *   googlePaymentInstance.parseResponse(response, function (err, data) {
	 *     if (err) {
	 *       // handle errors
	 *     }
	 *     // send parsedResponse.nonce to your server
	 *   });
	 * });
	 * @example with promise
	 * var paymentsClient = new google.payments.api.PaymentsClient({
	 *   environment: 'TEST' // or 'PRODUCTION'
	 * })
	 *
	 * paymentsClient.loadPaymentData(paymentDataRequestFromCreatePaymentDataRequest).then(function (response) {
	 *   return googlePaymentInstance.parseResponse(response);
	 * }).then(function (parsedResponse) {
	 *   // send parsedResponse.nonce to your server
	 * }).catch(function (err) {
	 *   // handle errors
	 * });
	 * @returns {Promise|void} Returns a promise that resolves the parsed response if no callback is provided.
	 */
	GooglePayment.prototype.parseResponse = function (response) {
	  var client = this._client;
	
	  return Promise.resolve().then(function () {
	    var payload;
	    var rawResponse = response.apiVersion === 2 ?
	      response.paymentMethodData.tokenizationData.token :
	      response.paymentMethodToken.token;
	    var parsedResponse = JSON.parse(rawResponse);
	    var error = parsedResponse.error;
	
	    if (error) {
	      return Promise.reject(error);
	    }
	
	    analytics.sendEvent(client, 'google-payment.parseResponse.succeeded');
	
	    if (parsedResponse.paypalAccounts) {
	      payload = parsedResponse.paypalAccounts[0];
	      analytics.sendEvent(client, 'google-payment.parseResponse.succeeded.paypal');
	
	      return Promise.resolve({
	        nonce: payload.nonce,
	        type: payload.type,
	        description: payload.description
	      });
	    }
	    payload = parsedResponse.androidPayCards[0];
	    analytics.sendEvent(client, 'google-payment.parseResponse.succeeded.google-payment');
	
	    return Promise.resolve({
	      nonce: payload.nonce,
	      type: payload.type,
	      description: payload.description,
	      details: {
	        cardType: payload.details.cardType,
	        lastFour: payload.details.lastFour,
	        lastTwo: payload.details.lastTwo
	      },
	      binData: payload.binData
	    });
	  }).catch(function (error) {
	    analytics.sendEvent(client, 'google-payment.parseResponse.failed');
	
	    return Promise.reject(new BraintreeError({
	      code: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.code,
	      message: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.message,
	      type: errors.GOOGLE_PAYMENT_GATEWAY_ERROR.type,
	      details: {
	        originalError: error
	      }
	    }));
	  });
	};
	
	/**
	 * Cleanly tear down anything set up by {@link module:braintree-web/google-payment.create|create}.
	 * @public
	 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
	 * @example
	 * googlePaymentInstance.teardown();
	 * @example <caption>With callback</caption>
	 * googlePaymentInstance.teardown(function () {
	 *   // teardown is complete
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	GooglePayment.prototype.teardown = function () {
	  convertMethodsToError(this, methods(GooglePayment.prototype));
	
	  return Promise.resolve();
	};
	
	function applyDefaultsToPaymentMethodConfiguration(merchantSubmittedPaymentMethod, defaultPaymentMethod) {
	  Object.keys(defaultPaymentMethod).forEach(function (parameter) {
	    if (typeof defaultPaymentMethod[parameter] === 'object') {
	      merchantSubmittedPaymentMethod[parameter] = assign(
	        {},
	        defaultPaymentMethod[parameter],
	        merchantSubmittedPaymentMethod[parameter]
	      );
	    } else {
	      merchantSubmittedPaymentMethod[parameter] = merchantSubmittedPaymentMethod[parameter] || defaultPaymentMethod[parameter];
	    }
	  });
	}
	
	module.exports = wrapPromise.wrapPrototype(GooglePayment);
	
	},{"../lib/analytics":68,"../lib/assign":70,"../lib/braintree-error":73,"../lib/convert-methods-to-error":78,"../lib/find":87,"../lib/generate-google-pay-configuration":88,"../lib/methods":93,"../lib/promise":95,"./errors":53,"@braintree/wrap-promise":27}],55:[function(require,module,exports){
	'use strict';
	/**
	 * @module braintree-web/google-payment
	 * @description A component to integrate with Google Pay. The majority of the integration uses [Google's pay.js JavaScript file](https://pay.google.com/gp/p/js/pay.js). The Braintree component generates the configuration object necessary for Google Pay to initiate the Payment Request and parse the returned data to retrieve the payment method nonce which is used to process the transaction on the server.
	 */
	
	var basicComponentVerification = require('../lib/basic-component-verification');
	var BraintreeError = require('../lib/braintree-error');
	var errors = require('./errors');
	var GooglePayment = require('./google-payment');
	var createDeferredClient = require('../lib/create-deferred-client');
	var createAssetsUrl = require('../lib/create-assets-url');
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	var VERSION = "3.47.0";
	
	/**
	 * @static
	 * @function create
	 * @param {object} options Creation options:
	 * @param {Client} [options.client] A {@link Client} instance.
	 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
	 * @param {Number} [options.googlePayVersion] The version of the Google Pay API to use. Value of 2 is required to accept parameters documented [by Google](https://developers.google.com/pay/api/web/reference/object). Omit this parameter to use the deprecated Google Pay Version 1.
	 * @param {String} [options.googleMerchantId] A Google merchant identifier issued after your website is approved by Google. Required when PaymentsClient is initialized with an environment property of PRODUCTION, but may be omitted in TEST environment.
	 * @param {callback} [callback] The second argument, `data`, is the {@link GooglePayment} instance. If no callback is provided, `create` returns a promise that resolves with the {@link GooglePayment} instance.
	 * @example <caption>Simple Example</caption>
	 * // include https://pay.google.com/gp/p/js/pay.js in a script tag
	 * // on your page to load the `google.payments.api.PaymentsClient` global object.
	 *
	 * var paymentButton = document.querySelector('#google-pay-button');
	 * var paymentsClient = new google.payments.api.PaymentsClient({
	 *   environment: 'TEST' // or 'PRODUCTION'
	 * });
	 *
	 * braintree.client.create({
	 *   authorization: 'tokenization-key-or-client-token'
	 * }).then(function (clientInstance) {
	 *   return braintree.googlePayment.create({
	 *     client: clientInstance,
	*      googlePayVersion: 2,
	*      googleMerchantId: 'your-merchant-id-from-google'
	 *   });
	 * }).then(function (googlePaymentInstance) {
	 *   paymentButton.addEventListener('click', function (event) {
	 *     var paymentDataRequest;
	 *
	 *     event.preventDefault();
	 *
	 *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
	 *       transactionInfo: {
	 *         currencyCode: 'USD',
	 *         totalPriceStatus: 'FINAL',
	 *         totalPrice: '100.00'
	 *       }
	 *     });
	 *
	 *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
	 *       return googlePaymentInstance.parseResponse(paymentData);
	 *     }).then(function (result) {
	 *       // send result.nonce to your server
	 *     }).catch(function (err) {
	 *       // handle err
	 *     });
	 *   });
	 * });
	 * @example <caption>Check Browser and Customer Compatibility</caption>
	 * var paymentsClient = new google.payments.api.PaymentsClient({
	 *   environment: 'TEST' // or 'PRODUCTION'
	 * });
	 *
	 * function setupGooglePayButton(googlePaymentInstance) {
	 *   var button = document.createElement('button');
	 *
	 *   button.id = 'google-pay';
	 *   button.appendChild(document.createTextNode('Google Pay'));
	 *   button.addEventListener('click', function (event) {
	 *     var paymentRequestData;
	 *
	 *     event.preventDefault();
	 *
	 *     paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
	 *       transactionInfo: {
	 *         currencyCode: 'USD',
	 *         totalPriceStatus: 'FINAL',
	 *         totalPrice: '100.00' // your amount
	 *       }
	 *     });
	 *
	 *     paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
	 *       return googlePaymentInstance.parseResponse(paymentData);
	*       }).then(function (result) {
	 *       // send result.nonce to your server
	 *     }).catch(function (err) {
	 *       // handle errors
	 *     });
	 *   });
	 *
	 *   document.getElementById('container').appendChild(button);
	 * }
	 *
	 * braintree.client.create({
	 *   authorization: 'tokenization-key-or-client-token'
	 * }).then(function (clientInstance) {
	 *   return braintree.googlePayment.create({
	 *     client: clientInstance,
	 *     googlePayVersion: 2,
	 *     googleMerchantId: 'your-merchant-id-from-google'
	 *   });
	 * }).then(function (googlePaymentInstance) {
	 *
	 *   return paymentsClient.isReadyToPay({
	 *     // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest for all options
	 *     apiVersion: 2,
	 *     apiVersionMinor: 0,
	 *     allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
	 *     existingPaymentMethodRequired: true
	 *   });
	 * }).then(function (response) {
	 *   if (response.result) {
	 *     setupGooglePayButton(googlePaymentInstance);
	 *   }
	 * }).catch(function (err) {
	 *   // handle setup errors
	 * });
	 *
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	function create(options) {
	  var name = 'Google Pay';
	
	  return basicComponentVerification.verify({
	    name: name,
	    client: options.client,
	    authorization: options.authorization
	  }).then(function () {
	    return createDeferredClient.create({
	      authorization: options.authorization,
	      client: options.client,
	      debug: options.debug,
	      assetsUrl: createAssetsUrl.create(options.authorization),
	      name: name
	    });
	  }).then(function (client) {
	    var gp;
	
	    options.client = client;
	
	    if (!options.client.getConfiguration().gatewayConfiguration.androidPay) {
	      return Promise.reject(new BraintreeError(errors.GOOGLE_PAYMENT_NOT_ENABLED));
	    }
	
	    gp = new GooglePayment(options);
	
	    return gp._initialize();
	  });
	}
	
	module.exports = {
	  create: wrapPromise(create),
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/basic-component-verification":71,"../lib/braintree-error":73,"../lib/create-assets-url":80,"../lib/create-deferred-client":82,"../lib/promise":95,"./errors":53,"./google-payment":54,"@braintree/wrap-promise":27}],56:[function(require,module,exports){
	'use strict';
	
	var BraintreeError = require('../../lib/braintree-error');
	var errors = require('../shared/errors');
	var allowedAttributes = require('../shared/constants').allowedAttributes;
	
	function attributeValidationError(attribute, value) {
	  var err;
	
	  if (!allowedAttributes.hasOwnProperty(attribute)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.type,
	      code: errors.HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED.code,
	      message: 'The "' + attribute + '" attribute is not supported in Hosted Fields.'
	    });
	  } else if (value != null && !_isValid(attribute, value)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.type,
	      code: errors.HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED.code,
	      message: 'Value "' + value + '" is not allowed for "' + attribute + '" attribute.'
	    });
	  }
	
	  return err;
	}
	
	function _isValid(attribute, value) {
	  if (allowedAttributes[attribute] === 'string') {
	    return typeof value === 'string' || typeof value === 'number';
	  } else if (allowedAttributes[attribute] === 'boolean') {
	    return String(value) === 'true' || String(value) === 'false';
	  }
	
	  return false;
	}
	
	module.exports = attributeValidationError;
	
	},{"../../lib/braintree-error":73,"../shared/constants":63,"../shared/errors":64}],57:[function(require,module,exports){
	'use strict';
	
	var constants = require('../shared/constants');
	var useMin = require('../../lib/use-min');
	
	module.exports = function composeUrl(assetsUrl, componentId, isDebug) {
	  return assetsUrl +
	    '/web/' +
	    constants.VERSION +
	    '/html/hosted-fields-frame' + useMin(isDebug) + '.html#' +
	    componentId;
	};
	
	},{"../../lib/use-min":97,"../shared/constants":63}],58:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var allowedStyles = require('../shared/constants').allowedStyles;
	
	module.exports = function getStylesFromClass(cssClass) {
	  var element = document.createElement('input');
	  var styles = {};
	  var computedStyles;
	
	  if (cssClass[0] === '.') {
	    cssClass = cssClass.substring(1);
	  }
	
	  element.className = cssClass;
	  element.style.display = 'none !important';
	  element.style.position = 'fixed !important';
	  element.style.left = '-99999px !important';
	  element.style.top = '-99999px !important';
	  global.document.body.appendChild(element);
	
	  computedStyles = global.getComputedStyle(element);
	
	  allowedStyles.forEach(function (style) {
	    var value = computedStyles[style];
	
	    if (value) {
	      styles[style] = value;
	    }
	  });
	
	  global.document.body.removeChild(element);
	
	  return styles;
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../shared/constants":63}],59:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var assign = require('../../lib/assign').assign;
	var createAssetsUrl = require('../../lib/create-assets-url');
	var Destructor = require('../../lib/destructor');
	var classList = require('@braintree/class-list');
	var iFramer = require('@braintree/iframer');
	var Bus = require('../../lib/bus');
	var createDeferredClient = require('../../lib/create-deferred-client');
	var BraintreeError = require('../../lib/braintree-error');
	var composeUrl = require('./compose-url');
	var getStylesFromClass = require('./get-styles-from-class');
	var constants = require('../shared/constants');
	var errors = require('../shared/errors');
	var INTEGRATION_TIMEOUT_MS = require('../../lib/constants').INTEGRATION_TIMEOUT_MS;
	var uuid = require('../../lib/vendor/uuid');
	var findParentTags = require('../shared/find-parent-tags');
	var browserDetection = require('../shared/browser-detection');
	var events = constants.events;
	var EventEmitter = require('@braintree/event-emitter');
	var injectFrame = require('./inject-frame');
	var analytics = require('../../lib/analytics');
	var allowedFields = constants.allowedFields;
	var methods = require('../../lib/methods');
	var convertMethodsToError = require('../../lib/convert-methods-to-error');
	var sharedErrors = require('../../lib/errors');
	var getCardTypes = require('../shared/get-card-types');
	var attributeValidationError = require('./attribute-validation-error');
	var Promise = require('../../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	
	/**
	 * @typedef {object} HostedFields~tokenizePayload
	 * @property {string} nonce The payment method nonce.
	 * @property {object} details Additional account details.
	 * @property {string} details.bin The BIN number of the card.
	 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
	 * @property {string} details.lastFour Last four digits of card number.
	 * @property {string} details.lastTwo Last two digits of card number.
	 * @property {string} description A human-readable description.
	 * @property {string} type The payment method type, always `CreditCard`.
	 * @property {object} binData Information about the card based on the bin.
	 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.countryOfIssuance The country of issuance.
	 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.issuingBank The issuing bank.
	 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.productId The product id.
	 */
	
	/**
	 * @typedef {object} HostedFields~stateObject
	 * @description The event payload sent from {@link HostedFields#on|on} or {@link HostedFields#getState|getState}.
	 * @property {HostedFields~hostedFieldsCard[]} cards
	 * This will return an array of potential {@link HostedFields~hostedFieldsCard|cards}. If the card type has been determined, the array will contain only one card.
	 * Internally, Hosted Fields uses <a href="https://github.com/braintree/credit-card-type">credit-card-type</a>,
	 * an open-source card detection library.
	 * @property {string} emittedBy
	 * The name of the field associated with an event. This will not be included if returned by {@link HostedFields#getState|getState}. It will be one of the following strings:<br>
	 * - `"number"`
	 * - `"cvv"`
	 * - `"expirationDate"`
	 * - `"expirationMonth"`
	 * - `"expirationYear"`
	 * - `"postalCode"`
	 * @property {object} fields
	 * @property {?HostedFields~hostedFieldsFieldData} fields.number {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the number field, if it is present.
	 * @property {?HostedFields~hostedFieldsFieldData} fields.cvv {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the CVV field, if it is present.
	 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationDate {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration date field, if it is present.
	 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationMonth {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration month field, if it is present.
	 * @property {?HostedFields~hostedFieldsFieldData} fields.expirationYear {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the expiration year field, if it is present.
	 * @property {?HostedFields~hostedFieldsFieldData} fields.postalCode {@link HostedFields~hostedFieldsFieldData|hostedFieldsFieldData} for the postal code field, if it is present.
	 */
	
	/**
	 * @typedef {object} HostedFields~hostedFieldsFieldData
	 * @description Data about Hosted Fields fields, sent in {@link HostedFields~stateObject|stateObjects}.
	 * @property {HTMLElement} container Reference to the container DOM element on your page associated with the current event.
	 * @property {boolean} isFocused Whether or not the input is currently focused.
	 * @property {boolean} isEmpty Whether or not the user has entered a value in the input.
	 * @property {boolean} isPotentiallyValid
	 * A determination based on the future validity of the input value.
	 * This is helpful when a user is entering a card number and types <code>"41"</code>.
	 * While that value is not valid for submission, it is still possible for
	 * it to become a fully qualified entry. However, if the user enters <code>"4x"</code>
	 * it is clear that the card number can never become valid and isPotentiallyValid will
	 * return false.
	 * @property {boolean} isValid Whether or not the value of the associated input is <i>fully</i> qualified for submission.
	 */
	
	/**
	 * @typedef {object} HostedFields~hostedFieldsCard
	 * @description Information about the card type, sent in {@link HostedFields~stateObject|stateObjects}.
	 * @property {string} type The code-friendly representation of the card type. It will be one of the following strings:
	 * - `american-express`
	 * - `diners-club`
	 * - `discover`
	 * - `jcb`
	 * - `maestro`
	 * - `master-card`
	 * - `unionpay`
	 * - `visa`
	 * @property {string} niceType The pretty-printed card type. It will be one of the following strings:
	 * - `American Express`
	 * - `Diners Club`
	 * - `Discover`
	 * - `JCB`
	 * - `Maestro`
	 * - `MasterCard`
	 * - `UnionPay`
	 * - `Visa`
	 * @property {object} code
	 * This object contains data relevant to the security code requirements of the card brand.
	 * For example, on a Visa card there will be a <code>CVV</code> of 3 digits, whereas an
	 * American Express card requires a 4-digit <code>CID</code>.
	 * @property {string} code.name <code>"CVV"</code> <code>"CID"</code> <code>"CVC"</code>
	 * @property {number} code.size The expected length of the security code. Typically, this is 3 or 4.
	 */
	
	/**
	 * @name HostedFields#on
	 * @function
	 * @param {string} event The name of the event to which you are subscribing.
	 * @param {function} handler A callback to handle the event.
	 * @description Subscribes a handler function to a named event. `event` should be {@link HostedFields#event:blur|blur}, {@link HostedFields#event:focus|focus}, {@link HostedFields#event:empty|empty}, {@link HostedFields#event:notEmpty|notEmpty}, {@link HostedFields#event:cardTypeChange|cardTypeChange}, {@link HostedFields#event:validityChange|validityChange}, or {@link HostedFields#event:inputSubmitRequest|inputSubmitRequest}. Events will emit a {@link HostedFields~stateObject|stateObject}.
	 * @example
	 * <caption>Listening to a Hosted Field event, in this case 'focus'</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('focus', function (event) {
	 *     console.log(event.emittedBy, 'has been focused');
	 *   });
	 * });
	 * @returns {void}
	 */
	
	/**
	 * @name HostedFields#off
	 * @function
	 * @param {string} event The name of the event to which you are unsubscribing.
	 * @param {function} handler The callback for the event you are unsubscribing from.
	 * @description Unsubscribes the handler function to a named event.
	 * @example
	 * <caption>Subscribing and then unsubscribing from a Hosted Field event, in this case 'focus'</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   var callback = function (event) {
	 *     console.log(event.emittedBy, 'has been focused');
	 *   };
	 *   hostedFieldsInstance.on('focus', callback);
	 *
	 *   // later on
	 *   hostedFieldsInstance.off('focus', callback);
	 * });
	 * @returns {void}
	 */
	
	/**
	 * This event is emitted when the user requests submission of an input field, such as by pressing the Enter or Return key on their keyboard, or mobile equivalent.
	 * @event HostedFields#inputSubmitRequest
	 * @type {HostedFields~stateObject}
	 * @example
	 * <caption>Clicking a submit button upon hitting Enter (or equivalent) within a Hosted Field</caption>
	 * var hostedFields = require('braintree-web/hosted-fields');
	 * var submitButton = document.querySelector('input[type="submit"]');
	 *
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('inputSubmitRequest', function () {
	 *     // User requested submission, e.g. by pressing Enter or equivalent
	 *     submitButton.click();
	 *   });
	 * });
	 */
	
	/**
	 * This event is emitted when a field transitions from having data to being empty.
	 * @event HostedFields#empty
	 * @type {HostedFields~stateObject}
	 * @example
	 * <caption>Listening to an empty event</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('empty', function (event) {
	 *     console.log(event.emittedBy, 'is now empty');
	 *   });
	 * });
	 */
	
	/**
	 * This event is emitted when a field transitions from being empty to having data.
	 * @event HostedFields#notEmpty
	 * @type {HostedFields~stateObject}
	 * @example
	 * <caption>Listening to an notEmpty event</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('notEmpty', function (event) {
	 *     console.log(event.emittedBy, 'is now not empty');
	 *   });
	 * });
	 */
	
	/**
	 * This event is emitted when a field loses focus.
	 * @event HostedFields#blur
	 * @type {HostedFields~stateObject}
	 * @example
	 * <caption>Listening to a blur event</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('blur', function (event) {
	 *     console.log(event.emittedBy, 'lost focus');
	 *   });
	 * });
	 */
	
	/**
	 * This event is emitted when a field gains focus.
	 * @event HostedFields#focus
	 * @type {HostedFields~stateObject}
	 * @example
	 * <caption>Listening to a focus event</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('focus', function (event) {
	 *     console.log(event.emittedBy, 'gained focus');
	 *   });
	 * });
	 */
	
	/**
	 * This event is emitted when activity within the number field has changed such that the possible card type has changed.
	 * @event HostedFields#cardTypeChange
	 * @type {HostedFields~stateObject}
	 * @example
	 * <caption>Listening to a cardTypeChange event</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('cardTypeChange', function (event) {
	 *     if (event.cards.length === 1) {
	 *       console.log(event.cards[0].type);
	 *     } else {
	 *       console.log('Type of card not yet known');
	 *     }
	 *   });
	 * });
	 */
	
	/**
	 * This event is emitted when the validity of a field has changed. Validity is represented in the {@link HostedFields~stateObject|stateObject} as two booleans: `isValid` and `isPotentiallyValid`.
	 * @event HostedFields#validityChange
	 * @type {HostedFields~stateObject}
	 * @example
	 * <caption>Listening to a validityChange event</caption>
	 * hostedFields.create({ ... }, function (createErr, hostedFieldsInstance) {
	 *   hostedFieldsInstance.on('validityChange', function (event) {
	 *     var field = event.fields[event.emittedBy];
	 *
	 *     if (field.isValid) {
	 *       console.log(event.emittedBy, 'is fully valid');
	 *     } else if (field.isPotentiallyValid) {
	 *       console.log(event.emittedBy, 'is potentially valid');
	 *     } else {
	 *       console.log(event.emittedBy, 'is not valid');
	 *     }
	 *   });
	 * });
	 */
	
	function createInputEventHandler(fields) {
	  return function (eventData) {
	    var field;
	    var merchantPayload = eventData.merchantPayload;
	    var emittedBy = merchantPayload.emittedBy;
	    var container = fields[emittedBy].containerElement;
	
	    Object.keys(merchantPayload.fields).forEach(function (key) {
	      merchantPayload.fields[key].container = fields[key].containerElement;
	    });
	
	    field = merchantPayload.fields[emittedBy];
	
	    if (eventData.type === 'blur') {
	      performBlurFixForIos(container);
	    }
	
	    classList.toggle(container, constants.externalClasses.FOCUSED, field.isFocused);
	    classList.toggle(container, constants.externalClasses.VALID, field.isValid);
	    classList.toggle(container, constants.externalClasses.INVALID, !field.isPotentiallyValid);
	
	    this._state = { // eslint-disable-line no-invalid-this
	      cards: merchantPayload.cards,
	      fields: merchantPayload.fields
	    };
	
	    this._emit(eventData.type, merchantPayload); // eslint-disable-line no-invalid-this
	  };
	}
	
	// iOS Safari has a bug where inputs in iframes
	// will not dismiss the keyboard when they lose
	// focus. We create a hidden button input that we
	// can focus on and blur to force the keyboard to
	// dismiss. See #229
	function performBlurFixForIos(container) {
	  var hiddenInput;
	
	  if (!browserDetection.isIos()) {
	    return;
	  }
	
	  if (document.activeElement === document.body) {
	    hiddenInput = container.querySelector('input');
	
	    if (!hiddenInput) {
	      hiddenInput = document.createElement('input');
	
	      hiddenInput.type = 'button';
	      hiddenInput.style.height = '0px';
	      hiddenInput.style.width = '0px';
	      hiddenInput.style.opacity = '0';
	      hiddenInput.style.padding = '0';
	      hiddenInput.style.position = 'absolute';
	      hiddenInput.style.left = '-200%';
	      hiddenInput.style.top = '0px';
	
	      container.insertBefore(hiddenInput, container.firstChild);
	    }
	
	    hiddenInput.focus();
	    hiddenInput.blur();
	  }
	}
	
	function isVisibleEnough(node) {
	  var boundingBox = node.getBoundingClientRect();
	  var verticalMidpoint = Math.floor(boundingBox.height / 2);
	  var horizontalMidpoint = Math.floor(boundingBox.width / 2);
	
	  return (
	    boundingBox.top < (global.innerHeight - verticalMidpoint || document.documentElement.clientHeight - verticalMidpoint) &&
	    boundingBox.right > horizontalMidpoint &&
	    boundingBox.bottom > verticalMidpoint &&
	    boundingBox.left < (global.innerWidth - horizontalMidpoint || document.documentElement.clientWidth - horizontalMidpoint)
	  );
	}
	
	function fieldsDOMOrder(configFields) {
	  var fieldPosition = [];
	  var fields = configFields;
	  var sortedFieldNames = [];
	  var validFieldsInUse = Object.keys(fields).filter(function (key) {
	    return allowedFields.hasOwnProperty(key);
	  });
	
	  validFieldsInUse.forEach(function (key) {
	    fieldPosition.push([key, fields[key].container]);
	  });
	
	  fieldPosition.sort(function (a, b) {
	    var element1 = a[1];
	    var element2 = b[1];
	    var position = element1.compareDocumentPosition(element2);
	
	    if (element1 === element2) { return 0; }
	
	    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	      return -1;
	    } else if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) {
	      return 1;
	    }
	
	    return 0;
	  });
	
	  fieldPosition.forEach(function (value) {
	    sortedFieldNames.push(value[0]);
	  });
	
	  return sortedFieldNames;
	}
	
	/**
	 * @class HostedFields
	 * @param {object} options The Hosted Fields {@link module:braintree-web/hosted-fields.create create} options.
	 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/hosted-fields.create|braintree-web.hosted-fields.create} instead.</strong>
	 * @classdesc This class represents a Hosted Fields component produced by {@link module:braintree-web/hosted-fields.create|braintree-web/hosted-fields.create}. Instances of this class have methods for interacting with the input fields within Hosted Fields' iframes.
	 */
	function HostedFields(options) {
	  var failureTimeout, clientConfig, assetsUrl, isDebug, hostedFieldsUrl;
	  var self = this;
	  var fields = {};
	  var frameReadyPromiseResolveFunctions = {};
	  var frameReadyPromises = [];
	  var componentId = uuid();
	
	  this._merchantConfigurationOptions = assign({}, options);
	
	  if (options.client) {
	    clientConfig = options.client.getConfiguration();
	    assetsUrl = clientConfig.gatewayConfiguration.assetsUrl;
	    isDebug = clientConfig.isDebug;
	  } else {
	    assetsUrl = createAssetsUrl.create(options.authorization);
	    isDebug = Boolean(options.isDebug);
	  }
	
	  this._clientPromise = createDeferredClient.create({
	    client: options.client,
	    authorization: options.authorization,
	    debug: isDebug,
	    assetsUrl: assetsUrl,
	    name: 'Hosted Fields'
	  });
	
	  hostedFieldsUrl = composeUrl(assetsUrl, componentId, isDebug);
	
	  if (!options.fields || Object.keys(options.fields).length === 0) {
	    throw new BraintreeError({
	      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
	      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
	      message: 'options.fields is required when instantiating Hosted Fields.'
	    });
	  }
	
	  EventEmitter.call(this);
	
	  this._injectedNodes = [];
	  this._destructor = new Destructor();
	  this._fields = fields;
	  this._state = {
	    fields: {},
	    cards: getCardTypes('')
	  };
	
	  this._bus = new Bus({
	    channel: componentId,
	    merchantUrl: location.href
	  });
	
	  this._destructor.registerFunctionForTeardown(function () {
	    self._bus.teardown();
	  });
	
	  // NEXT_MAJOR_VERSION analytics events should have present tense verbs
	  if (!options.client) {
	    analytics.sendEvent(this._clientPromise, 'custom.hosted-fields.initialized.deferred-client');
	  } else {
	    analytics.sendEvent(this._clientPromise, 'custom.hosted-fields.initialized');
	  }
	
	  Object.keys(options.fields).forEach(function (key) {
	    var field, container, frame, frameReadyPromise;
	
	    if (!constants.allowedFields.hasOwnProperty(key)) {
	      throw new BraintreeError({
	        type: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.type,
	        code: errors.HOSTED_FIELDS_INVALID_FIELD_KEY.code,
	        message: '"' + key + '" is not a valid field.'
	      });
	    }
	
	    field = options.fields[key];
	    // NEXT_MAJOR_VERSION remove selector as an option
	    // and simply make the API take a container
	    container = field.container || field.selector;
	
	    if (typeof container === 'string') {
	      container = document.querySelector(container);
	    }
	
	    if (!container || container.nodeType !== 1) {
	      throw new BraintreeError({
	        type: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.type,
	        code: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.code,
	        message: errors.HOSTED_FIELDS_INVALID_FIELD_SELECTOR.message,
	        details: {
	          fieldSelector: field.selector,
	          fieldContainer: field.container,
	          fieldKey: key
	        }
	      });
	    } else if (container.querySelector('iframe[name^="braintree-"]')) {
	      throw new BraintreeError({
	        type: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.type,
	        code: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.code,
	        message: errors.HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME.message,
	        details: {
	          fieldSelector: field.selector,
	          fieldContainer: field.container,
	          fieldKey: key
	        }
	      });
	    }
	
	    if (field.maxlength && typeof field.maxlength !== 'number') {
	      throw new BraintreeError({
	        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
	        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
	        message: 'The value for maxlength must be a number.',
	        details: {
	          fieldKey: key
	        }
	      });
	    }
	
	    if (field.minlength && typeof field.minlength !== 'number') {
	      throw new BraintreeError({
	        type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
	        code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
	        message: 'The value for minlength must be a number.',
	        details: {
	          fieldKey: key
	        }
	      });
	    }
	
	    frame = iFramer({
	      type: key,
	      name: 'braintree-hosted-field-' + key,
	      style: constants.defaultIFrameStyle,
	      title: 'Secure Credit Card Frame - ' + constants.allowedFields[key].label
	    });
	
	    this._injectedNodes.push.apply(this._injectedNodes, injectFrame(frame, container));
	    this._setupLabelFocus(key, container);
	    fields[key] = {
	      frameElement: frame,
	      containerElement: container
	    };
	    frameReadyPromise = new Promise(function (resolve) {
	      frameReadyPromiseResolveFunctions[key] = resolve;
	    });
	    frameReadyPromises.push(frameReadyPromise);
	
	    this._state.fields[key] = {
	      isEmpty: true,
	      isValid: false,
	      isPotentiallyValid: true,
	      isFocused: false,
	      container: container
	    };
	
	    setTimeout(function () {
	      // Edge has an intermittent issue where
	      // the iframes load, but the JavaScript
	      // can't message out to the parent page.
	      // We can fix this by setting the src
	      // to about:blank first followed by
	      // the actual source. Both instances
	      // of setting the src need to be in a
	      // setTimeout to work.
	      if (browserDetection.isIE() || browserDetection.isEdge()) {
	        frame.src = 'about:blank';
	        setTimeout(function () {
	          frame.src = hostedFieldsUrl;
	        }, 0);
	      } else {
	        frame.src = hostedFieldsUrl;
	      }
	    }, 0);
	  }.bind(this));
	
	  this._merchantConfigurationOptions.orderedFields = fieldsDOMOrder(this._state.fields);
	
	  if (this._merchantConfigurationOptions.styles) {
	    Object.keys(this._merchantConfigurationOptions.styles).forEach(function (selector) {
	      var className = self._merchantConfigurationOptions.styles[selector];
	
	      if (typeof className === 'string') {
	        self._merchantConfigurationOptions.styles[selector] = getStylesFromClass(className);
	      }
	    });
	  }
	
	  this._bus.on(events.READY_FOR_CLIENT, function (reply) {
	    self._clientPromise.then(function (client) {
	      reply(client);
	    });
	  });
	
	  this._bus.on(events.CARD_FORM_ENTRY_HAS_BEGUN, function () {
	    analytics.sendEvent(self._clientPromise, 'hosted-fields.input.started');
	  });
	
	  failureTimeout = setTimeout(function () {
	    analytics.sendEvent(self._clientPromise, 'custom.hosted-fields.load.timed-out');
	    self._emit('timeout');
	  }, INTEGRATION_TIMEOUT_MS);
	
	  Promise.all(frameReadyPromises).then(function (results) {
	    var reply = results[0];
	
	    clearTimeout(failureTimeout);
	    reply(self._merchantConfigurationOptions);
	    self._emit('ready');
	  });
	
	  this._bus.on(events.FRAME_READY, function (data, reply) {
	    frameReadyPromiseResolveFunctions[data.field](reply);
	  });
	
	  this._bus.on(
	    events.INPUT_EVENT,
	    createInputEventHandler(fields).bind(this)
	  );
	
	  this._bus.on(events.TRIGGER_INPUT_FOCUS, function (fieldName) {
	    var container = fields[fieldName].containerElement;
	
	    // Inputs outside of the viewport don't always scroll into view on
	    // focus in iOS Safari. 5ms timeout gives the browser a chance to
	    // do the right thing and prevents stuttering.
	    if (browserDetection.isIos()) {
	      setTimeout(function () {
	        if (!isVisibleEnough(container)) {
	          container.scrollIntoView();
	        }
	      }, 5);
	    }
	  });
	
	  this._destructor.registerFunctionForTeardown(function () {
	    var j, node, parent;
	
	    for (j = 0; j < self._injectedNodes.length; j++) {
	      node = self._injectedNodes[j];
	      parent = node.parentNode;
	
	      parent.removeChild(node);
	
	      classList.remove(
	        parent,
	        constants.externalClasses.FOCUSED,
	        constants.externalClasses.INVALID,
	        constants.externalClasses.VALID
	      );
	    }
	  });
	
	  this._destructor.registerFunctionForTeardown(function () {
	    var methodNames = methods(HostedFields.prototype).concat(methods(EventEmitter.prototype));
	
	    convertMethodsToError(self, methodNames);
	  });
	}
	
	EventEmitter.createChild(HostedFields);
	
	HostedFields.prototype._setupLabelFocus = function (type, container) {
	  var labels, i;
	  var shouldSkipLabelFocus = browserDetection.isIos();
	  var bus = this._bus;
	
	  if (shouldSkipLabelFocus) { return; }
	  if (container.id == null) { return; }
	
	  function triggerFocus() {
	    bus.emit(events.TRIGGER_INPUT_FOCUS, type);
	  }
	
	  labels = Array.prototype.slice.call(document.querySelectorAll('label[for="' + container.id + '"]'));
	  labels = labels.concat(findParentTags(container, 'label'));
	
	  for (i = 0; i < labels.length; i++) {
	    labels[i].addEventListener('click', triggerFocus, false);
	  }
	
	  this._destructor.registerFunctionForTeardown(function () {
	    for (i = 0; i < labels.length; i++) {
	      labels[i].removeEventListener('click', triggerFocus, false);
	    }
	  });
	};
	
	HostedFields.prototype._attachInvalidFieldContainersToError = function (err) {
	  if (!(err.details && err.details.invalidFieldKeys && err.details.invalidFieldKeys.length > 0)) {
	    return;
	  }
	  err.details.invalidFields = {};
	  err.details.invalidFieldKeys.forEach(function (field) {
	    err.details.invalidFields[field] = this._fields[field].containerElement;
	  }.bind(this));
	};
	
	/**
	 * Cleanly remove anything set up by {@link module:braintree-web/hosted-fields.create|create}.
	 * @public
	 * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` returns a promise.
	 * @example
	 * hostedFieldsInstance.teardown(function (teardownErr) {
	 *   if (teardownErr) {
	 *     console.error('Could not tear down Hosted Fields!');
	 *   } else {
	 *     console.info('Hosted Fields has been torn down!');
	 *   }
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.teardown = function () {
	  var self = this;
	
	  return new Promise(function (resolve, reject) {
	    self._destructor.teardown(function (err) {
	      analytics.sendEvent(self._clientPromise, 'custom.hosted-fields.teardown-completed');
	
	      if (err) {
	        reject(err);
	      } else {
	        resolve();
	      }
	    });
	  });
	};
	
	/**
	 * Tokenizes fields and returns a nonce payload.
	 * @public
	 * @param {object} [options] All tokenization options for the Hosted Fields component.
	 * @param {boolean} [options.vault=false] When true, will vault the tokenized card. Cards will only be vaulted when using a client created with a client token that includes a customer ID. Note: merchants using Advanced Fraud Tools should not use this option, as device data will not be included.
	 * @param {array} [options.fieldsToTokenize] By default, all fields will be tokenized. You may specify which fields specifically you wish to tokenize with this property. Valid options are `'number'`, `'cvv'`, `'expirationDate'`, `'expirationMonth'`, `'expirationYear'`, `'postalCode'`.
	 * @param {string} [options.cardholderName] When supplied, the cardholder name to be tokenized with the contents of the fields.
	 * @param {string} [options.billingAddress.postalCode] When supplied, this postal code will be tokenized along with the contents of the fields. If a postal code is provided as part of the Hosted Fields configuration, the value of the field will be tokenized and this value will be ignored.
	 * @param {string} [options.billingAddress.firstName] When supplied, this customer first name will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.lastName] When supplied, this customer last name will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.company] When supplied, this company name will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.streetAddress] When supplied, this street address will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.extendedAddress] When supplied, this extended address will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.locality] When supplied, this locality (the city) will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.region] When supplied, this region (the state) will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.countryCodeNumeric] When supplied, this numeric country code will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.countryCodeAlpha2] When supplied, this alpha 2 representation of a country will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.countryCodeAlpha3] When supplied, this alpha 3 representation of a country will be tokenized along with the contents of the fields.
	 * @param {string} [options.billingAddress.countryName] When supplied, this country name will be tokenized along with the contents of the fields.
	 *
	 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link HostedFields~tokenizePayload|tokenizePayload}. If no callback is provided, `tokenize` returns a function that resolves with a {@link HostedFields~tokenizePayload|tokenizePayload}.
	 * @example <caption>Tokenize a card</caption>
	 * hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
	 *   if (tokenizeErr) {
	 *     switch (tokenizeErr.code) {
	 *       case 'HOSTED_FIELDS_FIELDS_EMPTY':
	 *         // occurs when none of the fields are filled in
	 *         console.error('All fields are empty! Please fill out the form.');
	 *         break;
	 *       case 'HOSTED_FIELDS_FIELDS_INVALID':
	 *         // occurs when certain fields do not pass client side validation
	 *         console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
	 *
	 *         // you can also programtically access the field containers for the invalid fields
	 *         tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
	 *           fieldContainer.className = 'invalid';
	 *         });
	 *         break;
	 *       case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
	 *         // occurs when:
	 *         //   * the client token used for client authorization was generated
	 *         //     with a customer ID and the fail on duplicate payment method
	 *         //     option is set to true
	 *         //   * the card being tokenized has previously been vaulted (with any customer)
	 *         // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.fail_on_duplicate_payment_method
	 *         console.error('This payment method already exists in your vault.');
	 *         break;
	 *       case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
	 *         // occurs when:
	 *         //   * the client token used for client authorization was generated
	 *         //     with a customer ID and the verify card option is set to true
	 *         //     and you have credit card verification turned on in the Braintree
	 *         //     control panel
	 *         //   * the cvv does not pass verfication (https://developers.braintreepayments.com/reference/general/testing/#avs-and-cvv/cid-responses)
	 *         // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.verify_card
	 *         console.error('CVV did not pass verification');
	 *         break;
	 *       case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
	 *         // occurs for any other tokenization error on the server
	 *         console.error('Tokenization failed server side. Is the card valid?');
	 *         break;
	 *       case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
	 *         // occurs when the Braintree gateway cannot be contacted
	 *         console.error('Network error occurred when tokenizing.');
	 *         break;
	 *       default:
	 *         console.error('Something bad happened!', tokenizeErr);
	 *     }
	 *   } else {
	 *     console.log('Got nonce:', payload.nonce);
	 *   }
	 * });
	 * @example <caption>Tokenize and vault a card</caption>
	 * hostedFieldsInstance.tokenize({
	 *   vault: true
	 * }, function (tokenizeErr, payload) {
	 *   if (tokenizeErr) {
	 *     console.error(tokenizeErr);
	 *   } else {
	 *     console.log('Got nonce:', payload.nonce);
	 *   }
	 * });
	 * @example <caption>Tokenize a card with cardholder name</caption>
	 * hostedFieldsInstance.tokenize({
	 *   cardholderName: 'First Last'
	 * }, function (tokenizeErr, payload) {
	 *   if (tokenizeErr) {
	 *     console.error(tokenizeErr);
	 *   } else {
	 *     console.log('Got nonce:', payload.nonce);
	 *   }
	 * });
	 * @example <caption>Tokenize a card with the postal code option</caption>
	 * hostedFieldsInstance.tokenize({
	 *   billingAddress: {
	 *     postalCode: '11111'
	 *   }
	 * }, function (tokenizeErr, payload) {
	 *   if (tokenizeErr) {
	 *     console.error(tokenizeErr);
	 *   } else {
	 *     console.log('Got nonce:', payload.nonce);
	 *   }
	 * });
	 * @example <caption>Tokenize a card with additional billing address options</caption>
	 * hostedFieldsInstance.tokenize({
	 *   billingAddress: {
	 *     firstName: 'First',
	 *     lastName: 'Last',
	 *     company: 'Company',
	 *     streetAddress: '123 Street',
	 *     extendedAddress: 'Unit 1',
	 *     // passing just one of the country options is sufficient to
	 *     // associate the card details with a particular country
	 *     // valid country names and codes can be found here:
	 *     // https://developers.braintreepayments.com/reference/general/countries/ruby#list-of-countries
	 *     countryName: 'United States',
	 *     countryCodeAlpha2: 'US',
	 *     countryCodeAlpha3: 'USA',
	 *     countryCodeNumeric: '840'
	 *   }
	 * }, function (tokenizeErr, payload) {
	 *   if (tokenizeErr) {
	 *     console.error(tokenizeErr);
	 *   } else {
	 *     console.log('Got nonce:', payload.nonce);
	 *   }
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.tokenize = function (options) {
	  var self = this;
	
	  if (!options) {
	    options = {};
	  }
	
	  return new Promise(function (resolve, reject) {
	    self._bus.emit(events.TOKENIZATION_REQUEST, options, function (response) {
	      var err = response[0];
	      var payload = response[1];
	
	      if (err) {
	        self._attachInvalidFieldContainersToError(err);
	        reject(new BraintreeError(err));
	      } else {
	        resolve(payload);
	      }
	    });
	  });
	};
	
	/**
	 * Add a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
	 * @public
	 * @param {string} field The field you wish to add a class to. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
	 * @param {string} classname The class to be added.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is added successfully.
	 *
	 * @example
	 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
	 *   if (addClassErr) {
	 *     console.error(addClassErr);
	 *   }
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.addClass = function (field, classname) {
	  var err;
	
	  if (!allowedFields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
	      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
	      message: '"' + field + '" is not a valid field. You must use a valid field option when adding a class.'
	    });
	  } else if (!this._fields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
	      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
	      message: 'Cannot add class to "' + field + '" field because it is not part of the current Hosted Fields options.'
	    });
	  } else {
	    this._bus.emit(events.ADD_CLASS, field, classname);
	  }
	
	  if (err) {
	    return Promise.reject(err);
	  }
	
	  return Promise.resolve();
	};
	
	/**
	 * Removes a class to a {@link module:braintree-web/hosted-fields~field field}. Useful for updating field styles when events occur elsewhere in your checkout.
	 * @public
	 * @param {string} field The field you wish to remove a class from. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
	 * @param {string} classname The class to be removed.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the class is removed successfully.
	 *
	 * @example
	 * hostedFieldsInstance.addClass('number', 'custom-class', function (addClassErr) {
	 *   if (addClassErr) {
	 *     console.error(addClassErr);
	 *     return;
	 *   }
	 *
	 *   // some time later...
	 *   hostedFieldsInstance.removeClass('number', 'custom-class');
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.removeClass = function (field, classname) {
	  var err;
	
	  if (!allowedFields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
	      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
	      message: '"' + field + '" is not a valid field. You must use a valid field option when removing a class.'
	    });
	  } else if (!this._fields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
	      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
	      message: 'Cannot remove class from "' + field + '" field because it is not part of the current Hosted Fields options.'
	    });
	  } else {
	    this._bus.emit(events.REMOVE_CLASS, field, classname);
	  }
	
	  if (err) {
	    return Promise.reject(err);
	  }
	
	  return Promise.resolve();
	};
	
	/**
	 * Sets an attribute of a {@link module:braintree-web/hosted-fields~field field}.
	 * Supported attributes are `aria-invalid`, `aria-required`, `disabled`, and `placeholder`.
	 *
	 * @public
	 * @param {object} options The options for the attribute you wish to set.
	 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
	 * @param {string} options.attribute The name of the attribute you wish to add to the field.
	 * @param {string} options.value The value for the attribute.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is set successfully.
	 *
	 * @example <caption>Set the placeholder attribute of a field</caption>
	 * hostedFieldsInstance.setAttribute({
	 *   field: 'number',
	 *   attribute: 'placeholder',
	 *   value: '1111 1111 1111 1111'
	 * }, function (attributeErr) {
	 *   if (attributeErr) {
	 *     console.error(attributeErr);
	 *   }
	 * });
	 *
	 * @example <caption>Set the aria-required attribute of a field</caption>
	 * hostedFieldsInstance.setAttribute({
	 *   field: 'number',
	 *   attribute: 'aria-required',
	 *   value: true
	 * }, function (attributeErr) {
	 *   if (attributeErr) {
	 *     console.error(attributeErr);
	 *   }
	 * });
	 *
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.setAttribute = function (options) {
	  var attributeErr, err;
	
	  if (!allowedFields.hasOwnProperty(options.field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
	      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
	      message: '"' + options.field + '" is not a valid field. You must use a valid field option when setting an attribute.'
	    });
	  } else if (!this._fields.hasOwnProperty(options.field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
	      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
	      message: 'Cannot set attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
	    });
	  } else {
	    attributeErr = attributeValidationError(options.attribute, options.value);
	
	    if (attributeErr) {
	      err = attributeErr;
	    } else {
	      this._bus.emit(events.SET_ATTRIBUTE, options.field, options.attribute, options.value);
	    }
	  }
	
	  if (err) {
	    return Promise.reject(err);
	  }
	
	  return Promise.resolve();
	};
	
	/**
	 * Sets the month options for the expiration month field when presented as a select element.
	 *
	 * @public
	 * @param {array} options An array of 12 entries corresponding to the 12 months.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the options are updated succesfully. Errors if expirationMonth is not configured on the Hosted Fields instance or if the expirationMonth field is not configured to be a select input.
	 *
	 * @example <caption>Update the month options to spanish</caption>
	 * hostedFieldsInstance.setMonthOptions([
	 *   '01 - enero',
	 *   '02 - febrero',
	 *   '03 - marzo',
	 *   '04 - abril',
	 *   '05 - mayo',
	 *   '06 - junio',
	 *   '07 - julio',
	 *   '08 - agosto',
	 *   '09 - septiembre',
	 *   '10 - octubre',
	 *   '11 - noviembre',
	 *   '12 - diciembre'
	 * ]);
	 *
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.setMonthOptions = function (options) {
	  var self = this;
	  var merchantOptions = this._merchantConfigurationOptions.fields;
	  var errorMessage;
	
	  if (!merchantOptions.expirationMonth) {
	    errorMessage = 'Expiration month field must exist to use setMonthOptions.';
	  } else if (!merchantOptions.expirationMonth.select) {
	    errorMessage = 'Expiration month field must be a select element.';
	  }
	
	  if (errorMessage) {
	    return Promise.reject(new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.type,
	      code: errors.HOSTED_FIELDS_FIELD_PROPERTY_INVALID.code,
	      message: errorMessage
	    }));
	  }
	
	  return new Promise(function (resolve) {
	    self._bus.emit(events.SET_MONTH_OPTIONS, options, resolve);
	  });
	};
	
	/**
	 * Sets a visually hidden message (for screenreaders) on a {@link module:braintree-web/hosted-fields~field field}.
	 *
	 * @public
	 * @param {object} options The options for the attribute you wish to set.
	 * @param {string} options.field The field to which you wish to add an attribute. Must be a valid {@link module:braintree-web/hosted-fields~field field}.
	 * @param {string} options.message The message to set.
	 *
	 * @example <caption>Set an error message on a field</caption>
	 * hostedFieldsInstance.setMessage({
	 *   field: 'number',
	 *   message: 'Invalid card number'
	 * });
	 *
	 * @example <caption>Remove the message on a field</caption>
	 * hostedFieldsInstance.setMessage({
	 *   field: 'number',
	 *   message: ''
	 * });
	 *
	 * @returns {void}
	 */
	HostedFields.prototype.setMessage = function (options) {
	  this._bus.emit(events.SET_MESSAGE, options.field, options.message);
	};
	
	/**
	 * Removes a supported attribute from a {@link module:braintree-web/hosted-fields~field field}.
	 *
	 * @public
	 * @param {object} options The options for the attribute you wish to remove.
	 * @param {string} options.field The field from which you wish to remove an attribute. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
	 * @param {string} options.attribute The name of the attribute you wish to remove from the field.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the attribute is removed successfully.
	 *
	 * @example <caption>Remove the placeholder attribute of a field</caption>
	 * hostedFieldsInstance.removeAttribute({
	 *   field: 'number',
	 *   attribute: 'placeholder'
	 * }, function (attributeErr) {
	 *   if (attributeErr) {
	 *     console.error(attributeErr);
	 *   }
	 * });
	 *
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.removeAttribute = function (options) {
	  var attributeErr, err;
	
	  if (!allowedFields.hasOwnProperty(options.field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
	      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
	      message: '"' + options.field + '" is not a valid field. You must use a valid field option when removing an attribute.'
	    });
	  } else if (!this._fields.hasOwnProperty(options.field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
	      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
	      message: 'Cannot remove attribute for "' + options.field + '" field because it is not part of the current Hosted Fields options.'
	    });
	  } else {
	    attributeErr = attributeValidationError(options.attribute);
	
	    if (attributeErr) {
	      err = attributeErr;
	    } else {
	      this._bus.emit(events.REMOVE_ATTRIBUTE, options.field, options.attribute);
	    }
	  }
	
	  if (err) {
	    return Promise.reject(err);
	  }
	
	  return Promise.resolve();
	};
	
	/**
	 * @deprecated since version 3.8.0. Use {@link HostedFields#setAttribute|setAttribute} instead.
	 *
	 * @public
	 * @param {string} field The field whose placeholder you wish to change. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
	 * @param {string} placeholder Will be used as the `placeholder` attribute of the input.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the placeholder updated successfully.
	 *
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	HostedFields.prototype.setPlaceholder = function (field, placeholder) {
	  return this.setAttribute({
	    field: field,
	    attribute: 'placeholder',
	    value: placeholder
	  });
	};
	
	/**
	 * Clear the value of a {@link module:braintree-web/hosted-fields~field field}.
	 * @public
	 * @param {string} field The field you wish to clear. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field cleared successfully.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * hostedFieldsInstance.clear('number', function (clearErr) {
	 *   if (clearErr) {
	 *     console.error(clearErr);
	 *   }
	 * });
	 *
	 * @example <caption>Clear several fields</caption>
	 * hostedFieldsInstance.clear('number');
	 * hostedFieldsInstance.clear('cvv');
	 * hostedFieldsInstance.clear('expirationDate');
	 */
	HostedFields.prototype.clear = function (field) {
	  var err;
	
	  if (!allowedFields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
	      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
	      message: '"' + field + '" is not a valid field. You must use a valid field option when clearing a field.'
	    });
	  } else if (!this._fields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
	      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
	      message: 'Cannot clear "' + field + '" field because it is not part of the current Hosted Fields options.'
	    });
	  } else {
	    this._bus.emit(events.CLEAR_FIELD, field);
	  }
	
	  if (err) {
	    return Promise.reject(err);
	  }
	
	  return Promise.resolve();
	};
	
	/**
	 * Programmatically focus a {@link module:braintree-web/hosted-fields~field field}.
	 * @public
	 * @param {string} field The field you want to focus. Must be a valid {@link module:braintree-web/hosted-fields~fieldOptions fieldOption}.
	 * @param {callback} [callback] Callback executed on completion, containing an error if one occurred. No data is returned if the field focused successfully.
	 * @returns {void}
	 * @example
	 * hostedFieldsInstance.focus('number', function (focusErr) {
	 *   if (focusErr) {
	 *     console.error(focusErr);
	 *   }
	 * });
	 * @example <caption>Using an event listener</caption>
	 * myElement.addEventListener('click', function (e) {
	 *   // In Firefox, the focus method can be suppressed
	 *   //   if the element has a tabindex property or the element
	 *   //   is an anchor link with an href property.
	 *   // In Mobile Safari, the focus method is unable to
	 *   //   programatically open the keyboard, as only
	 *   //   touch events are allowed to do so.
	 *   e.preventDefault();
	 *   hostedFieldsInstance.focus('number');
	 * });
	 */
	HostedFields.prototype.focus = function (field) {
	  var err;
	
	  if (!allowedFields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_INVALID.type,
	      code: errors.HOSTED_FIELDS_FIELD_INVALID.code,
	      message: '"' + field + '" is not a valid field. You must use a valid field option when focusing a field.'
	    });
	  } else if (!this._fields.hasOwnProperty(field)) {
	    err = new BraintreeError({
	      type: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.type,
	      code: errors.HOSTED_FIELDS_FIELD_NOT_PRESENT.code,
	      message: 'Cannot focus "' + field + '" field because it is not part of the current Hosted Fields options.'
	    });
	  } else {
	    this._bus.emit(events.TRIGGER_INPUT_FOCUS, field);
	  }
	
	  if (err) {
	    return Promise.reject(err);
	  }
	
	  return Promise.resolve();
	};
	
	/**
	 * Returns an {@link HostedFields~stateObject|object} that includes the state of all fields and possible card types.
	 * @public
	 * @returns {object} {@link HostedFields~stateObject|stateObject}
	 * @example <caption>Check if all fields are valid</caption>
	 * var state = hostedFieldsInstance.getState();
	 *
	 * var formValid = Object.keys(state.fields).every(function (key) {
	 *   return state.fields[key].isValid;
	 * });
	 */
	HostedFields.prototype.getState = function () {
	  return this._state;
	};
	
	module.exports = wrapPromise.wrapPrototype(HostedFields);
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../../lib/analytics":68,"../../lib/assign":70,"../../lib/braintree-error":73,"../../lib/bus":76,"../../lib/constants":77,"../../lib/convert-methods-to-error":78,"../../lib/create-assets-url":80,"../../lib/create-deferred-client":82,"../../lib/destructor":84,"../../lib/errors":86,"../../lib/methods":93,"../../lib/promise":95,"../../lib/vendor/uuid":99,"../shared/browser-detection":62,"../shared/constants":63,"../shared/errors":64,"../shared/find-parent-tags":65,"../shared/get-card-types":66,"./attribute-validation-error":56,"./compose-url":57,"./get-styles-from-class":58,"./inject-frame":60,"@braintree/class-list":18,"@braintree/event-emitter":19,"@braintree/iframer":20,"@braintree/wrap-promise":27}],60:[function(require,module,exports){
	'use strict';
	
	module.exports = function injectFrame(frame, container) {
	  var clearboth = document.createElement('div');
	  var fragment = document.createDocumentFragment();
	
	  clearboth.style.clear = 'both';
	
	  fragment.appendChild(frame);
	  fragment.appendChild(clearboth);
	
	  container.appendChild(fragment);
	
	  return [frame, clearboth];
	};
	
	},{}],61:[function(require,module,exports){
	'use strict';
	/** @module braintree-web/hosted-fields */
	
	var HostedFields = require('./external/hosted-fields');
	var basicComponentVerification = require('../lib/basic-component-verification');
	var errors = require('./shared/errors');
	var supportsInputFormatting = require('restricted-input/supports-input-formatting');
	var wrapPromise = require('@braintree/wrap-promise');
	var BraintreeError = require('../lib/braintree-error');
	var Promise = require('../lib/promise');
	var VERSION = "3.47.0";
	
	/**
	 * Fields used in {@link module:braintree-web/hosted-fields~fieldOptions fields options}
	 * @typedef {object} field
	 * @property {string} selector Deprecated: Now an alias for `options.container`.
	 * @property {string|HTMLElement} container A DOM node or CSS selector to find the container where the hosted field will be inserted.
	 * @property {string} [placeholder] Will be used as the `placeholder` attribute of the input. If `placeholder` is not natively supported by the browser, it will be polyfilled.
	 * @property {string} [type] Will be used as the `type` attribute of the input. To mask `cvv` input, for instance, `type: "password"` can be used.
	 * @property {boolean} [formatInput=true] Enable or disable automatic formatting on this field.
	 * @property {object|boolean} [maskInput=false] Enable or disable input masking when input is not focused. If set to `true` instead of an object, the defaults for the `maskInput` parameters will be used.
	 * @property {string} [maskInput.character=•] The character to use when masking the input. The default character ('•') uses a unicode symbol, so the webpage must support UTF-8 characters when using the default.
	 * @property {Boolean} [maskInput.showLastFour=false] Only applicable for the credit card field. Whether or not to show the last 4 digits of the card when masking.
	 * @property {object|boolean} [select] If truthy, this field becomes a `<select>` dropdown list. This can only be used for `expirationMonth` and `expirationYear` fields. If you do not use a `placeholder` property for the field, the current month/year will be the default selected value.
	 * @property {string[]} [select.options] An array of 12 strings, one per month. This can only be used for the `expirationMonth` field. For example, the array can look like `['01 - January', '02 - February', ...]`.
	 * @property {number} [maxCardLength] This option applies only to the number field. Allows a limit to the length of the card number, even if the card brand may support numbers of a greater length. If the value passed is greater than the max length for a card brand, the smaller number of the 2 values will be used. For example, is `maxCardLength` is set to 16, but an American Express card is entered (which has a max card length of 15), a max card length of 15 will be used.
	 * @property {number} [maxlength] This option applies only to the CVV and postal code fields. Will be used as the `maxlength` attribute of the input if it is less than the default. The primary use cases for the `maxlength` option are: limiting the length of the CVV input for CVV-only verifications when the card type is known and limiting the length of the postal code input when cards are coming from a known region.
	 * @property {number} [minlength=3] This option applies only to the cvv and postal code fields. Will be used as the `minlength` attribute of the input.
	 * For postal code fields, the default value is 3, representing the Icelandic postal code length. This option's primary use case is to increase the `minlength`, e.g. for US customers, the postal code `minlength` can be set to 5.
	 * For cvv fields, the default value is 3. The `minlength` attribute only applies to integrations capturing a cvv without a number field.
	 * @property {string} [prefill] A value to prefill the field with. For example, when creating an update card form, you can prefill the expiration date fields with the old expiration date data.
	 * @property {boolean} [rejectUnsupportedCards=false] Deprecated since version 3.46.0, use `supportedCardBrands` instead. Only allow card types that your merchant account is able to process. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering a American Express card would get an invalid card field. This can only be used for the `number` field.
	 * @property {object} [supportedCardBrands] Override card brands that are supported by the card form. Pass `'card-brand-id': true` to override the default in the merchant configuration and enable a card brand. Pass `'card-brand-id': false` to disable a card brand. Unsupported card types will invalidate the card form. e.g. if you only process Visa cards, a customer entering an American Express card would get an invalid card field. This can only be used for the  `number` field. (Note: only allow card types that your merchant account is actually able to process.)
	 *
	 * Valid card brand ids are:
	 * * visa
	 * * mastercard
	 * * american-express
	 * * diners-club
	 * * discover
	 * * jcb
	 * * union-pay
	 * * maestro
	 * * elo
	 * * mir
	 * * hiper
	 * * hipercard
	 */
	
	/**
	 * An object that has {@link module:braintree-web/hosted-fields~field field objects} for each field. Used in {@link module:braintree-web/hosted-fields~create create}.
	 * @typedef {object} fieldOptions
	 * @property {field} [number] A field for card number.
	 * @property {field} [expirationDate] A field for expiration date in `MM/YYYY` or `MM/YY` format. This should not be used with the `expirationMonth` and `expirationYear` properties.
	 * @property {field} [expirationMonth] A field for expiration month in `MM` format. This should be used with the `expirationYear` property.
	 * @property {field} [expirationYear] A field for expiration year in `YYYY` or `YY` format. This should be used with the `expirationMonth` property.
	 * @property {field} [cvv] A field for 3 or 4 digit card verification code (like CVV or CID). If you wish to create a CVV-only payment method nonce to verify a card already stored in your Vault, omit all other fields to only collect CVV.
	 * @property {field} [postalCode] A field for postal or region code.
	 */
	
	/**
	 * An object that represents CSS that will be applied in each hosted field. This object looks similar to CSS. Typically, these styles involve fonts (such as `font-family` or `color`).
	 *
	 * You may also pass the name of a class on your site that contains the styles you would like to apply. The style properties will be automatically pulled off the class and applied to the Hosted Fields inputs. Note: this is recomended for `input` elements only. If using a `select` for the expiration date, unexpected styling may occur.
	 *
	 * These are the CSS properties that Hosted Fields supports. Any other CSS should be specified on your page and outside of any Braintree configuration. Trying to set unsupported properties will fail and put a warning in the console.
	 *
	 * Supported CSS properties are:
	 * `appearance`
	 * `color`
	 * `direction`
	 * `font-family`
	 * `font-size-adjust`
	 * `font-size`
	 * `font-stretch`
	 * `font-style`
	 * `font-variant-alternates`
	 * `font-variant-caps`
	 * `font-variant-east-asian`
	 * `font-variant-ligatures`
	 * `font-variant-numeric`
	 * `font-variant`
	 * `font-weight`
	 * `font`
	 * `letter-spacing`
	 * `line-height`
	 * `opacity`
	 * `outline`
	 * `padding`
	 * `text-shadow`
	 * `transition`
	 * `-moz-appearance`
	 * `-moz-osx-font-smoothing`
	 * `-moz-tap-highlight-color`
	 * `-moz-transition`
	 * `-webkit-appearance`
	 * `-webkit-font-smoothing`
	 * `-webkit-tap-highlight-color`
	 * `-webkit-transition`
	 * @typedef {object} styleOptions
	 */
	
	/**
	 * @static
	 * @function create
	 * @param {object} options Creation options:
	 * @param {Client} [options.client] A {@link Client} instance.
	 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
	 * @param {fieldOptions} options.fields A {@link module:braintree-web/hosted-fields~fieldOptions set of options for each field}.
	 * @param {styleOptions} [options.styles] {@link module:braintree-web/hosted-fields~styleOptions Styles} applied to each field.
	 * @param {callback} [callback] The second argument, `data`, is the {@link HostedFields} instance. If no callback is provided, `create` returns a promise that resolves with the {@link HostedFields} instance.
	 * @returns {void}
	 * @example
	 * braintree.hostedFields.create({
	 *   client: clientInstance,
	 *   styles: {
	 *     'input': {
	 *       'font-size': '16pt',
	 *       'color': '#3A3A3A'
	 *     },
	 *     '.number': {
	 *       'font-family': 'monospace'
	 *     },
	 *     '.valid': {
	 *       'color': 'green'
	 *     }
	 *   },
	 *   fields: {
	 *     number: {
	 *       container: '#card-number'
	 *     },
	 *     cvv: {
	 *       container: '#cvv',
	 *       placeholder: '•••'
	 *     },
	 *     expirationDate: {
	 *       container: '#expiration-date'
	 *     }
	 *   }
	 * }, callback);
	 * @example <caption>Applying styles with a class name</caption>
	 * // in document head
	 * <style>
	 *   .braintree-input-class {
	 *     color: black;
	 *   }
	 *   .braintree-valid-class {
	 *     color: green;
	 *   }
	 *   .braintree-invalid-class {
	 *     color: red;
	 *   }
	 * </style>
	 * // in a script tag
	 * braintree.hostedFields.create({
	 *   client: clientInstance,
	 *   styles: {
	 *     'input': 'braintree-input-class',
	 *     '.invalid': 'braintree-invalid-class',
	 *     '.valid': {
	 *       // you can also use the object syntax alongside
	 *       // the class name syntax
	 *       color: green;
	 *     }
	 *   },
	 *   fields: {
	 *     number: {
	 *       container: '#card-number'
	 *     },
	 *     // etc...
	 *   }
	 * }, callback);
	 * @example <caption>Right to Left Language Support</caption>
	 * braintree.hostedFields.create({
	 *   client: clientInstance,
	 *   styles: {
	 *     'input': {
	 *       // other styles
	 *       direction: 'rtl'
	 *     },
	 *   },
	 *   fields: {
	 *     number: {
	 *       container: '#card-number',
	 *       // Credit card formatting is not currently supported
	 *       // with RTL languages, so we need to turn it off for the number input
	 *       formatInput: false
	 *     },
	 *     cvv: {
	 *       container: '#cvv',
	 *       placeholder: '•••'
	 *     },
	 *     expirationDate: {
	 *       container: '#expiration-date',
	 *       type: 'month'
	 *     }
	 *   }
	 * }, callback);
	 * @example <caption>Setting up Hosted Fields to tokenize CVV only</caption>
	 * braintree.hostedFields.create({
	 *   client: clientInstance,
	 *   fields: {
	 *     // Only add the `cvv` option.
	 *     cvv: {
	 *       container: '#cvv',
	 *       placeholder: '•••'
	 *     }
	 *   }
	 * }, callback);
	 * @example <caption>Creating an expiration date update form with prefilled data</caption>
	 * var storedCreditCardInformation = {
	 *   // get this info from your server
	 *   // with a payment method lookup
	 *   month: '09',
	 *   year: '2017'
	 * };
	 *
	 * braintree.hostedFields.create({
	 *   client: clientInstance,
	 *   fields: {
	 *     expirationMonth: {
	 *       container: '#expiration-month',
	 *       prefill: storedCreditCardInformation.month
	 *     },
	 *     expirationYear: {
	 *       container: '#expiration-year',
	 *       prefill: storedCreditCardInformation.year
	 *     }
	 *   }
	 * }, callback);
	 * @example <caption>Validate the card form for supported card types</caption>
	 * braintree.hostedFields.create({
	 *   client: clientInstance,
	 *   fields: {
	 *     number: {
	 *       container: '#card-number',
	 *       supportedCardBrands: {
	 *         visa: false, // prevents Visas from showing up as valid even when the Braintree control panel is configured to allow them
	 *         'diners-club': true // allow Diners Club cards to be valid (processed as Discover cards on the Braintree backend)
	 *       }
	 *     },
	 *     cvv: {
	 *       container: '#cvv',
	 *       placeholder: '•••'
	 *     },
	 *     expirationDate: {
	 *       container: '#expiration-date',
	 *       type: 'month'
	 *     }
	 *   },
	 * }, callback);
	 */
	function create(options) {
	  return basicComponentVerification.verify({
	    name: 'Hosted Fields',
	    authorization: options.authorization,
	    client: options.client
	  }).then(function () {
	    var integration = new HostedFields(options);
	
	    return new Promise(function (resolve, reject) {
	      integration.on('ready', function () {
	        resolve(integration);
	      });
	      integration.on('timeout', function () {
	        reject(new BraintreeError(errors.HOSTED_FIELDS_TIMEOUT));
	      });
	    });
	  });
	}
	
	module.exports = {
	  /**
	   * @static
	   * @function supportsInputFormatting
	   * @description Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true. For a list of unsupported browsers, [go here](https://github.com/braintree/restricted-input/blob/master/README.md#browsers-where-formatting-is-turned-off-automatically).
	   * @returns {Boolean} Returns false if input formatting will be automatically disabled due to browser incompatibility. Otherwise, returns true.
	   * @example
	   * <caption>Conditionally choosing split expiration date inputs if formatting is unavailable</caption>
	   * var canFormat = braintree.hostedFields.supportsInputFormatting();
	   * var fields = {
	   *   number: {
	   *     container: '#card-number'
	   *   },
	   *   cvv: {
	   *     container: '#cvv'
	   *   }
	   * };
	   *
	   * if (canFormat) {
	   *   fields.expirationDate = {
	   *     selection: '#expiration-date'
	   *   };
	   *   functionToCreateAndInsertExpirationDateDivToForm();
	   * } else {
	   *   fields.expirationMonth = {
	   *     selection: '#expiration-month'
	   *   };
	   *   fields.expirationYear = {
	   *     selection: '#expiration-year'
	   *   };
	   *   functionToCreateAndInsertExpirationMonthAndYearDivsToForm();
	   * }
	   *
	   * braintree.hostedFields.create({
	   *   client: clientInstance,
	   *   styles: {
	   *     // Styles
	   *   },
	   *   fields: fields
	   * }, callback);
	   */
	  supportsInputFormatting: supportsInputFormatting,
	  create: wrapPromise(create),
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/basic-component-verification":71,"../lib/braintree-error":73,"../lib/promise":95,"./external/hosted-fields":59,"./shared/errors":64,"@braintree/wrap-promise":27,"restricted-input/supports-input-formatting":129}],62:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  isIE: require('@braintree/browser-detection/is-ie'),
	  isEdge: require('@braintree/browser-detection/is-edge'),
	  isIe9: require('@braintree/browser-detection/is-ie9'),
	  isIos: require('@braintree/browser-detection/is-ios'),
	  isIosWebview: require('@braintree/browser-detection/is-ios-webview')
	};
	
	},{"@braintree/browser-detection/is-edge":7,"@braintree/browser-detection/is-ie":8,"@braintree/browser-detection/is-ie9":11,"@braintree/browser-detection/is-ios":15,"@braintree/browser-detection/is-ios-webview":14}],63:[function(require,module,exports){
	'use strict';
	/* eslint-disable no-reserved-keys */
	
	var enumerate = require('../../lib/enumerate');
	var errors = require('./errors');
	var VERSION = "3.47.0";
	
	var constants = {
	  VERSION: VERSION,
	  maxExpirationYearAge: 19,
	  externalEvents: {
	    FOCUS: 'focus',
	    BLUR: 'blur',
	    EMPTY: 'empty',
	    NOT_EMPTY: 'notEmpty',
	    VALIDITY_CHANGE: 'validityChange',
	    CARD_TYPE_CHANGE: 'cardTypeChange'
	  },
	  defaultMaxLengths: {
	    number: 19,
	    postalCode: 8,
	    expirationDate: 7,
	    expirationMonth: 2,
	    expirationYear: 4,
	    cvv: 3
	  },
	  externalClasses: {
	    FOCUSED: 'braintree-hosted-fields-focused',
	    INVALID: 'braintree-hosted-fields-invalid',
	    VALID: 'braintree-hosted-fields-valid'
	  },
	  defaultIFrameStyle: {
	    border: 'none',
	    width: '100%',
	    height: '100%',
	    'float': 'left'
	  },
	  tokenizationErrorCodes: {
	    81724: errors.HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE,
	    // NEXT_MAJOR_VERSION this error triggers for both AVS and CVV errors
	    // but the code name implies that it would only trigger for CVV verification
	    // failures
	    81736: errors.HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED
	  },
	  allowedStyles: [
	    '-moz-appearance',
	    '-moz-osx-font-smoothing',
	    '-moz-tap-highlight-color',
	    '-moz-transition',
	    '-webkit-appearance',
	    '-webkit-font-smoothing',
	    '-webkit-tap-highlight-color',
	    '-webkit-transition',
	    'appearance',
	    'color',
	    'direction',
	    'font',
	    'font-family',
	    'font-size',
	    'font-size-adjust',
	    'font-stretch',
	    'font-style',
	    'font-variant',
	    'font-variant-alternates',
	    'font-variant-caps',
	    'font-variant-east-asian',
	    'font-variant-ligatures',
	    'font-variant-numeric',
	    'font-weight',
	    'letter-spacing',
	    'line-height',
	    'padding',
	    'opacity',
	    'outline',
	    'text-shadow',
	    'transition'
	  ],
	  allowedFields: {
	    number: {
	      name: 'credit-card-number',
	      label: 'Credit Card Number'
	    },
	    cvv: {
	      name: 'cvv',
	      label: 'CVV'
	    },
	    expirationDate: {
	      name: 'expiration',
	      label: 'Expiration Date'
	    },
	    expirationMonth: {
	      name: 'expiration-month',
	      label: 'Expiration Month'
	    },
	    expirationYear: {
	      name: 'expiration-year',
	      label: 'Expiration Year'
	    },
	    postalCode: {
	      name: 'postal-code',
	      label: 'Postal Code'
	    }
	  },
	  allowedAttributes: {
	    'aria-invalid': 'boolean',
	    'aria-required': 'boolean',
	    disabled: 'boolean',
	    placeholder: 'string'
	  },
	  autocompleteMappings: {
	    'credit-card-number': 'cc-number',
	    expiration: 'cc-exp',
	    'expiration-month': 'cc-exp-month',
	    'expiration-year': 'cc-exp-year',
	    cvv: 'cc-csc',
	    'postal-code': 'billing postal-code'
	  }
	};
	
	constants.events = enumerate([
	  'READY_FOR_CLIENT',
	  'FRAME_READY',
	  'CARD_FORM_ENTRY_HAS_BEGUN',
	  'VALIDATE_STRICT',
	  'CONFIGURATION',
	  'TOKENIZATION_REQUEST',
	  'INPUT_EVENT',
	  'TRIGGER_INPUT_FOCUS',
	  'ADD_CLASS',
	  'REMOVE_CLASS',
	  'SET_ATTRIBUTE',
	  'REMOVE_ATTRIBUTE',
	  'CLEAR_FIELD',
	  'AUTOFILL_EXPIRATION_DATE',
	  'SET_MESSAGE',
	  'SET_MONTH_OPTIONS'
	], 'hosted-fields:');
	
	module.exports = constants;
	
	},{"../../lib/enumerate":85,"./errors":64}],64:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.Hosted Fields - Creation Error Codes
	 * @description Errors that occur when [creating the Hosted Fields component](/current/module-braintree-web_hosted-fields.html#.create).
	 * @property {UNKNOWN} HOSTED_FIELDS_TIMEOUT Occurs when Hosted Fields does not finish setting up within 60 seconds.
	 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_KEY Occurs when Hosted Fields is instantated with an invalid Field option.
	 * @property {MERCHANT} HOSTED_FIELDS_INVALID_FIELD_SELECTOR Occurs when Hosted Fields given a field selector that is not valid.
	 * @property {MERCHANT} HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME Occurs when Hosted Fields given a field selector that already contains an iframe.
	 * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
	 */
	
	/**
	 * @name BraintreeError.Hosted Fields - Field Manipulation Error Codes
	 * @description Errors that occur when modifying fields through [`addClass`](/current/HostedFields.html#addClass), [`removeClass`](/current/HostedFields.html#removeClass), [`setAttribute`](/current/HostedFields.html#setAttribute), [`removeAttribute`](/current/HostedFields.html#removeAttribute), [`clear`](/current/HostedFields.html#clear), [`focus`](/current/HostedFields.html#focus), and [`setMonthOptions`](/current/HostedFields.html#setMonthOptions).
	 * @property {MERCHANT} HOSTED_FIELDS_FIELD_INVALID Occurs when attempting to modify a field that is not a valid Hosted Fields option.
	 * @property {MERCHANT} HOSTED_FIELDS_FIELD_NOT_PRESENT Occurs when attempting to modify a field that is not configured with Hosted Fields.
	 * @property {MERCHANT} HOSTED_FIELDS_FIELD_PROPERTY_INVALID Occurs when a field configuration option is not valid.
	 */
	
	/**
	 * @name BraintreeError.Hosted Fields - Set Attribtue Error Codes
	 * @description Errors that occur when using the [`setAttribtue` method](/current/HostedFields.html#setAttribute)
	 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED Occurs when trying to set an attribtue that is not supported to be set.
	 * @property {MERCHANT} HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED Occurs when the type of value for an attribue is not allowed to be set.
	 */
	
	/**
	 * @name BraintreeError.Hosted Fields - Tokenize Error Codes
	 * @description Errors that occur when [tokenizing the card details with Hosted Fields](/current/HostedFields.html#tokenize).
	 * @property {NETWORK} HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR Occurs when the Braintree gateway cannot be contacted.
	 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE Occurs when attempting to vault a card, but the client token being used is configured to fail if the card already exists in the vault.
	 * @property {CUSTOMER} HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED Occurs when cvv verification is turned on in the Braintree control panel.
	 * @property {CUSTOMER} HOSTED_FIELDS_FAILED_TOKENIZATION Occurs when the credit card details were sent to Braintree, but failed to tokenize.
	 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_EMPTY Occurs when all the Hosted Fields inputs are empty.
	 * @property {CUSTOMER} HOSTED_FIELDS_FIELDS_INVALID Occurs when one ore more fields are invalid.
	 */
	
	var BraintreeError = require('../../lib/braintree-error');
	
	module.exports = {
	  HOSTED_FIELDS_TIMEOUT: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'HOSTED_FIELDS_TIMEOUT',
	    message: 'Hosted Fields timed out when attempting to set up.'
	  },
	  HOSTED_FIELDS_INVALID_FIELD_KEY: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_INVALID_FIELD_KEY'
	  },
	  HOSTED_FIELDS_INVALID_FIELD_SELECTOR: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_INVALID_FIELD_SELECTOR',
	    message: 'Selector does not reference a valid DOM node.'
	  },
	  HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_FIELD_DUPLICATE_IFRAME',
	    message: 'Element already contains a Braintree iframe.'
	  },
	  HOSTED_FIELDS_FIELD_INVALID: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_FIELD_INVALID'
	  },
	  HOSTED_FIELDS_FIELD_NOT_PRESENT: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_FIELD_NOT_PRESENT'
	  },
	  HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR: {
	    type: BraintreeError.types.NETWORK,
	    code: 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR',
	    message: 'A tokenization network error occurred.'
	  },
	  HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE',
	    message: 'This credit card already exists in the merchant\'s vault.'
	  },
	  HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED',
	    message: 'CVV verification failed during tokenization.'
	  },
	  HOSTED_FIELDS_FAILED_TOKENIZATION: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'HOSTED_FIELDS_FAILED_TOKENIZATION',
	    message: 'The supplied card data failed tokenization.'
	  },
	  HOSTED_FIELDS_FIELDS_EMPTY: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'HOSTED_FIELDS_FIELDS_EMPTY',
	    message: 'All fields are empty. Cannot tokenize empty card fields.'
	  },
	  HOSTED_FIELDS_FIELDS_INVALID: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'HOSTED_FIELDS_FIELDS_INVALID',
	    message: 'Some payment input fields are invalid. Cannot tokenize invalid card fields.'
	  },
	  HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_ATTRIBUTE_NOT_SUPPORTED'
	  },
	  HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_ATTRIBUTE_VALUE_NOT_ALLOWED'
	  },
	  HOSTED_FIELDS_FIELD_PROPERTY_INVALID: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'HOSTED_FIELDS_FIELD_PROPERTY_INVALID'
	  }
	};
	
	},{"../../lib/braintree-error":73}],65:[function(require,module,exports){
	'use strict';
	
	function findParentTags(element, tag) {
	  var parent = element.parentNode;
	  var parents = [];
	
	  while (parent != null) {
	    if (parent.tagName != null && parent.tagName.toLowerCase() === tag) {
	      parents.push(parent);
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return parents;
	}
	
	module.exports = findParentTags;
	
	},{}],66:[function(require,module,exports){
	'use strict';
	
	var creditCardType = require('credit-card-type');
	
	module.exports = function (number) {
	  var results = creditCardType(number);
	
	  results.forEach(function (card) {
	    // NEXT_MAJOR_VERSION credit-card-type fixed the mastercard enum
	    // but we still pass master-card in the braintree API
	    // in a major version bump, we can remove this and
	    // this will be mastercard instead of master-card
	    if (card.type === 'mastercard') {
	      card.type = 'master-card';
	    }
	  });
	
	  return results;
	};
	
	},{"credit-card-type":118}],67:[function(require,module,exports){
	'use strict';
	
	var createAuthorizationData = require('./create-authorization-data');
	var jsonClone = require('./json-clone');
	var constants = require('./constants');
	
	function addMetadata(configuration, data) {
	  var key;
	  var attrs = data ? jsonClone(data) : {};
	  var authAttrs = createAuthorizationData(configuration.authorization).attrs;
	  var _meta = jsonClone(configuration.analyticsMetadata);
	
	  attrs.braintreeLibraryVersion = constants.BRAINTREE_LIBRARY_VERSION;
	
	  for (key in attrs._meta) {
	    if (attrs._meta.hasOwnProperty(key)) {
	      _meta[key] = attrs._meta[key];
	    }
	  }
	
	  attrs._meta = _meta;
	
	  if (authAttrs.tokenizationKey) {
	    attrs.tokenizationKey = authAttrs.tokenizationKey;
	  } else {
	    attrs.authorizationFingerprint = authAttrs.authorizationFingerprint;
	  }
	
	  return attrs;
	}
	
	module.exports = addMetadata;
	
	},{"./constants":77,"./create-authorization-data":81,"./json-clone":92}],68:[function(require,module,exports){
	'use strict';
	
	var Promise = require('./promise');
	var constants = require('./constants');
	var addMetadata = require('./add-metadata');
	
	function _millisToSeconds(millis) {
	  return Math.floor(millis / 1000);
	}
	
	function sendAnalyticsEvent(clientInstanceOrPromise, kind, callback) {
	  var timestamp = _millisToSeconds(Date.now());
	
	  return Promise.resolve(clientInstanceOrPromise).then(function (client) {
	    var timestampInPromise = _millisToSeconds(Date.now());
	    var configuration = client.getConfiguration();
	    var request = client._request;
	    var url = configuration.gatewayConfiguration.analytics.url;
	    var data = {
	      analytics: [{
	        kind: constants.ANALYTICS_PREFIX + kind,
	        isAsync: timestampInPromise !== timestamp,
	        timestamp: timestamp
	      }]
	    };
	
	    request({
	      url: url,
	      method: 'post',
	      data: addMetadata(configuration, data),
	      timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
	    }, callback);
	  });
	}
	
	module.exports = {
	  sendEvent: sendAnalyticsEvent
	};
	
	},{"./add-metadata":67,"./constants":77,"./promise":95}],69:[function(require,module,exports){
	'use strict';
	
	var loadScript = require('@braintree/asset-loader/load-script');
	
	module.exports = {
	  loadScript: loadScript
	};
	
	},{"@braintree/asset-loader/load-script":3}],70:[function(require,module,exports){
	'use strict';
	
	var assignNormalized = typeof Object.assign === 'function' ? Object.assign : assignPolyfill;
	
	function assignPolyfill(destination) {
	  var i, source, key;
	
	  for (i = 1; i < arguments.length; i++) {
	    source = arguments[i];
	    for (key in source) {
	      if (source.hasOwnProperty(key)) {
	        destination[key] = source[key];
	      }
	    }
	  }
	
	  return destination;
	}
	
	module.exports = {
	  assign: assignNormalized,
	  _assign: assignPolyfill
	};
	
	},{}],71:[function(require,module,exports){
	'use strict';
	
	var BraintreeError = require('./braintree-error');
	var Promise = require('./promise');
	var sharedErrors = require('./errors');
	var VERSION = "3.47.0";
	
	function basicComponentVerification(options) {
	  var client, authorization, name;
	
	  if (!options) {
	    return Promise.reject(new BraintreeError({
	      type: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.type,
	      code: sharedErrors.INVALID_USE_OF_INTERNAL_FUNCTION.code,
	      message: 'Options must be passed to basicComponentVerification function.'
	    }));
	  }
	
	  name = options.name;
	  client = options.client;
	  authorization = options.authorization;
	
	  if (client == null && authorization == null) {
	    return Promise.reject(new BraintreeError({
	      type: sharedErrors.INSTANTIATION_OPTION_REQUIRED.type,
	      code: sharedErrors.INSTANTIATION_OPTION_REQUIRED.code,
	      // NEXT_MAJOR_VERSION in major version, we expose passing in authorization for all components
	      // instead of passing in a client instance. Leave this a silent feature for now.
	      message: 'options.client is required when instantiating ' + name + '.'
	    }));
	  }
	
	  if (!authorization && client.getVersion() !== VERSION) {
	    return Promise.reject(new BraintreeError({
	      type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
	      code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
	      message: 'Client (version ' + client.getVersion() + ') and ' + name + ' (version ' + VERSION + ') components must be from the same SDK version.'
	    }));
	  }
	
	  return Promise.resolve();
	}
	
	module.exports = {
	  verify: basicComponentVerification
	};
	
	},{"./braintree-error":73,"./errors":86,"./promise":95}],72:[function(require,module,exports){
	'use strict';
	
	var once = require('./once');
	
	function call(fn, callback) {
	  var isSync = fn.length === 0;
	
	  if (isSync) {
	    fn();
	    callback(null);
	  } else {
	    fn(callback);
	  }
	}
	
	module.exports = function (functions, cb) {
	  var i;
	  var length = functions.length;
	  var remaining = length;
	  var callback = once(cb);
	
	  if (length === 0) {
	    callback(null);
	
	    return;
	  }
	
	  function finish(err) {
	    if (err) {
	      callback(err);
	
	      return;
	    }
	
	    remaining -= 1;
	    if (remaining === 0) {
	      callback(null);
	    }
	  }
	
	  for (i = 0; i < length; i++) {
	    call(functions[i], finish);
	  }
	};
	
	},{"./once":94}],73:[function(require,module,exports){
	'use strict';
	
	var enumerate = require('./enumerate');
	
	/**
	 * @class
	 * @global
	 * @param {object} options Construction options
	 * @classdesc This class is used to report error conditions, frequently as the first parameter to callbacks throughout the Braintree SDK.
	 * @description <strong>You cannot use this constructor directly. Interact with instances of this class through {@link callback callbacks}.</strong>
	 */
	function BraintreeError(options) {
	  if (!BraintreeError.types.hasOwnProperty(options.type)) {
	    throw new Error(options.type + ' is not a valid type.');
	  }
	
	  if (!options.code) {
	    throw new Error('Error code required.');
	  }
	
	  if (!options.message) {
	    throw new Error('Error message required.');
	  }
	
	  this.name = 'BraintreeError';
	
	  /**
	   * @type {string}
	   * @description A code that corresponds to specific errors.
	   */
	  this.code = options.code;
	
	  /**
	   * @type {string}
	   * @description A short description of the error.
	   */
	  this.message = options.message;
	
	  /**
	   * @type {BraintreeError.types}
	   * @description The type of error.
	   */
	  this.type = options.type;
	
	  /**
	   * @type {object=}
	   * @description Additional information about the error, such as an underlying network error response.
	   */
	  this.details = options.details;
	}
	
	BraintreeError.prototype = Object.create(Error.prototype);
	BraintreeError.prototype.constructor = BraintreeError;
	
	/**
	 * Enum for {@link BraintreeError} types.
	 * @name BraintreeError.types
	 * @enum
	 * @readonly
	 * @memberof BraintreeError
	 * @property {string} CUSTOMER An error caused by the customer.
	 * @property {string} MERCHANT An error that is actionable by the merchant.
	 * @property {string} NETWORK An error due to a network problem.
	 * @property {string} INTERNAL An error caused by Braintree code.
	 * @property {string} UNKNOWN An error where the origin is unknown.
	 */
	BraintreeError.types = enumerate([
	  'CUSTOMER',
	  'MERCHANT',
	  'NETWORK',
	  'INTERNAL',
	  'UNKNOWN'
	]);
	
	BraintreeError.findRootError = function (err) {
	  if (err instanceof BraintreeError && err.details && err.details.originalError) {
	    return BraintreeError.findRootError(err.details.originalError);
	  }
	
	  return err;
	};
	
	module.exports = BraintreeError;
	
	},{"./enumerate":85}],74:[function(require,module,exports){
	'use strict';
	
	var isVerifiedDomain = require('../is-verified-domain');
	
	function checkOrigin(postMessageOrigin, merchantUrl) {
	  var merchantOrigin, merchantHost;
	  var a = document.createElement('a');
	
	  a.href = merchantUrl;
	
	  if (a.protocol === 'https:') {
	    merchantHost = a.host.replace(/:443$/, '');
	  } else if (a.protocol === 'http:') {
	    merchantHost = a.host.replace(/:80$/, '');
	  } else {
	    merchantHost = a.host;
	  }
	
	  merchantOrigin = a.protocol + '//' + merchantHost;
	
	  if (merchantOrigin === postMessageOrigin) { return true; }
	
	  a.href = postMessageOrigin;
	
	  return isVerifiedDomain(postMessageOrigin);
	}
	
	module.exports = {
	  checkOrigin: checkOrigin
	};
	
	},{"../is-verified-domain":91}],75:[function(require,module,exports){
	'use strict';
	
	var enumerate = require('../enumerate');
	
	module.exports = enumerate([
	  'CONFIGURATION_REQUEST'
	], 'bus:');
	
	},{"../enumerate":85}],76:[function(require,module,exports){
	'use strict';
	
	var bus = require('framebus');
	var events = require('./events');
	var checkOrigin = require('./check-origin').checkOrigin;
	var BraintreeError = require('../braintree-error');
	
	function BraintreeBus(options) {
	  options = options || {};
	
	  this.channel = options.channel;
	  if (!this.channel) {
	    throw new BraintreeError({
	      type: BraintreeError.types.INTERNAL,
	      code: 'MISSING_CHANNEL_ID',
	      message: 'Channel ID must be specified.'
	    });
	  }
	
	  this.merchantUrl = options.merchantUrl;
	
	  this._isDestroyed = false;
	  this._isVerbose = false;
	
	  this._listeners = [];
	
	  this._log('new bus on channel ' + this.channel, [location.href]);
	}
	
	BraintreeBus.prototype.on = function (eventName, originalHandler) {
	  var namespacedEvent, args;
	  var handler = originalHandler;
	  var self = this;
	
	  if (this._isDestroyed) { return; }
	
	  if (this.merchantUrl) {
	    handler = function () {
	      /* eslint-disable no-invalid-this */
	      if (checkOrigin(this.origin, self.merchantUrl)) {
	        originalHandler.apply(this, arguments);
	      }
	      /* eslint-enable no-invalid-this */
	    };
	  }
	
	  namespacedEvent = this._namespaceEvent(eventName);
	  args = Array.prototype.slice.call(arguments);
	  args[0] = namespacedEvent;
	  args[1] = handler;
	
	  this._log('on', args);
	  bus.on.apply(bus, args);
	
	  this._listeners.push({
	    eventName: eventName,
	    handler: handler,
	    originalHandler: originalHandler
	  });
	};
	
	BraintreeBus.prototype.emit = function (eventName) {
	  var args;
	
	  if (this._isDestroyed) { return; }
	
	  args = Array.prototype.slice.call(arguments);
	  args[0] = this._namespaceEvent(eventName);
	
	  this._log('emit', args);
	  bus.emit.apply(bus, args);
	};
	
	BraintreeBus.prototype._offDirect = function (eventName) {
	  var args = Array.prototype.slice.call(arguments);
	
	  if (this._isDestroyed) { return; }
	
	  args[0] = this._namespaceEvent(eventName);
	
	  this._log('off', args);
	  bus.off.apply(bus, args);
	};
	
	BraintreeBus.prototype.off = function (eventName, originalHandler) {
	  var i, listener;
	  var handler = originalHandler;
	
	  if (this._isDestroyed) { return; }
	
	  if (this.merchantUrl) {
	    for (i = 0; i < this._listeners.length; i++) {
	      listener = this._listeners[i];
	
	      if (listener.originalHandler === originalHandler) {
	        handler = listener.handler;
	      }
	    }
	  }
	
	  this._offDirect(eventName, handler);
	};
	
	BraintreeBus.prototype._namespaceEvent = function (eventName) {
	  return ['braintree', this.channel, eventName].join(':');
	};
	
	BraintreeBus.prototype.teardown = function () {
	  var listener, i;
	
	  for (i = 0; i < this._listeners.length; i++) {
	    listener = this._listeners[i];
	    this._offDirect(listener.eventName, listener.handler);
	  }
	
	  this._listeners.length = 0;
	
	  this._isDestroyed = true;
	};
	
	BraintreeBus.prototype._log = function (functionName, args) {
	  if (this._isVerbose) {
	    console.log(functionName, args); // eslint-disable-line no-console
	  }
	};
	
	BraintreeBus.events = events;
	
	module.exports = BraintreeBus;
	
	},{"../braintree-error":73,"./check-origin":74,"./events":75,"framebus":125}],77:[function(require,module,exports){
	'use strict';
	
	var VERSION = "3.47.0";
	var PLATFORM = 'web';
	
	var CLIENT_API_URLS = {
	  production: 'https://api.braintreegateway.com:443',
	  sandbox: 'https://api.sandbox.braintreegateway.com:443'
	};
	
	var ASSETS_URLS = {
	  production: 'https://assets.braintreegateway.com',
	  sandbox: 'https://assets.braintreegateway.com'
	};
	
	var GRAPHQL_URLS = {
	  production: 'https://payments.braintree-api.com/graphql',
	  sandbox: 'https://payments.sandbox.braintree-api.com/graphql'
	};
	
	module.exports = {
	  ANALYTICS_PREFIX: PLATFORM + '.',
	  ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
	  ASSETS_URLS: ASSETS_URLS,
	  CLIENT_API_URLS: CLIENT_API_URLS,
	  FRAUDNET_SOURCE: 'BRAINTREE_SIGNIN',
	  FRAUDNET_FNCLS: 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99',
	  FRAUDNET_URL: 'https://c.paypal.com/da/r/fb.js',
	  GRAPHQL_URLS: GRAPHQL_URLS,
	  INTEGRATION_TIMEOUT_MS: 60000,
	  VERSION: VERSION,
	  INTEGRATION: 'custom',
	  SOURCE: 'client',
	  PLATFORM: PLATFORM,
	  BRAINTREE_LIBRARY_VERSION: 'braintree/' + PLATFORM + '/' + VERSION
	};
	
	},{}],78:[function(require,module,exports){
	'use strict';
	
	var BraintreeError = require('./braintree-error');
	var sharedErrors = require('./errors');
	
	module.exports = function (instance, methodNames) {
	  methodNames.forEach(function (methodName) {
	    instance[methodName] = function () {
	      throw new BraintreeError({
	        type: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.type,
	        code: sharedErrors.METHOD_CALLED_AFTER_TEARDOWN.code,
	        message: methodName + ' cannot be called after teardown.'
	      });
	    };
	  });
	};
	
	},{"./braintree-error":73,"./errors":86}],79:[function(require,module,exports){
	'use strict';
	
	var BraintreeError = require('./braintree-error');
	
	function convertToBraintreeError(originalErr, btErrorObject) {
	  if (originalErr instanceof BraintreeError) {
	    return originalErr;
	  }
	
	  return new BraintreeError({
	    type: btErrorObject.type,
	    code: btErrorObject.code,
	    message: btErrorObject.message,
	    details: {
	      originalError: originalErr
	    }
	  });
	}
	
	module.exports = convertToBraintreeError;
	
	},{"./braintree-error":73}],80:[function(require,module,exports){
	'use strict';
	
	var ASSETS_URLS = require('./constants').ASSETS_URLS;
	
	function createAssetsUrl(authorization) {
	
	  return ASSETS_URLS.production;
	}
	/* eslint-enable */
	
	module.exports = {
	  create: createAssetsUrl
	};
	
	},{"./constants":77}],81:[function(require,module,exports){
	'use strict';
	
	var atob = require('../lib/vendor/polyfill').atob;
	var CLIENT_API_URLS = require('../lib/constants').CLIENT_API_URLS;
	
	function _isTokenizationKey(str) {
	  return /^[a-zA-Z0-9]+_[a-zA-Z0-9]+_[a-zA-Z0-9_]+$/.test(str);
	}
	
	function _parseTokenizationKey(tokenizationKey) {
	  var tokens = tokenizationKey.split('_');
	  var environment = tokens[0];
	  var merchantId = tokens.slice(2).join('_');
	
	  return {
	    merchantId: merchantId,
	    environment: environment
	  };
	}
	
	function createAuthorizationData(authorization) {
	  var parsedClientToken, parsedTokenizationKey;
	  var data = {
	    attrs: {},
	    configUrl: ''
	  };
	
	  if (_isTokenizationKey(authorization)) {
	    parsedTokenizationKey = _parseTokenizationKey(authorization);
	    data.environment = parsedTokenizationKey.environment;
	    data.attrs.tokenizationKey = authorization;
	    data.configUrl = CLIENT_API_URLS[parsedTokenizationKey.environment] + '/merchants/' + parsedTokenizationKey.merchantId + '/client_api/v1/configuration';
	  } else {
	    parsedClientToken = JSON.parse(atob(authorization));
	    data.environment = parsedClientToken.environment;
	    data.attrs.authorizationFingerprint = parsedClientToken.authorizationFingerprint;
	    data.configUrl = parsedClientToken.configUrl;
	    data.graphQL = parsedClientToken.graphQL;
	  }
	
	  return data;
	}
	
	module.exports = createAuthorizationData;
	
	},{"../lib/constants":77,"../lib/vendor/polyfill":98}],82:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var BraintreeError = require('./braintree-error');
	var Promise = require('./promise');
	var assets = require('./assets');
	var sharedErrors = require('./errors');
	
	var VERSION = "3.47.0";
	
	function createDeferredClient(options) {
	  var promise = Promise.resolve();
	
	  if (options.client) {
	    return Promise.resolve(options.client);
	  }
	
	  if (!(global.braintree && global.braintree.client)) {
	    promise = assets.loadScript({
	      src: options.assetsUrl + '/web/' + VERSION + '/js/client.min.js'
	    }).catch(function (err) {
	      return Promise.reject(new BraintreeError({
	        type: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.type,
	        code: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.code,
	        message: sharedErrors.CLIENT_SCRIPT_FAILED_TO_LOAD.message,
	        details: {
	          originalError: err
	        }
	      }));
	    });
	  }
	
	  return promise.then(function () {
	    if (global.braintree.client.VERSION !== VERSION) {
	      return Promise.reject(new BraintreeError({
	        type: sharedErrors.INCOMPATIBLE_VERSIONS.type,
	        code: sharedErrors.INCOMPATIBLE_VERSIONS.code,
	        message: 'Client (version ' + global.braintree.client.VERSION + ') and ' + options.name + ' (version ' + VERSION + ') components must be from the same SDK version.'
	      }));
	    }
	
	    return global.braintree.client.create({
	      authorization: options.authorization,
	      debug: options.debug
	    });
	  });
	}
	
	module.exports = {
	  create: createDeferredClient
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"./assets":69,"./braintree-error":73,"./errors":86,"./promise":95}],83:[function(require,module,exports){
	'use strict';
	
	module.exports = function (fn) {
	  return function () {
	    // IE9 doesn't support passing arguments to setTimeout so we have to emulate it.
	    var args = arguments;
	
	    setTimeout(function () {
	      fn.apply(null, args);
	    }, 1);
	  };
	};
	
	},{}],84:[function(require,module,exports){
	'use strict';
	
	var batchExecuteFunctions = require('./batch-execute-functions');
	
	function Destructor() {
	  this._teardownRegistry = [];
	
	  this._isTearingDown = false;
	}
	
	Destructor.prototype.registerFunctionForTeardown = function (fn) {
	  if (typeof fn === 'function') {
	    this._teardownRegistry.push(fn);
	  }
	};
	
	Destructor.prototype.teardown = function (callback) {
	  if (this._isTearingDown) {
	    callback(new Error('Destructor is already tearing down'));
	
	    return;
	  }
	
	  this._isTearingDown = true;
	
	  batchExecuteFunctions(this._teardownRegistry, function (err) {
	    this._teardownRegistry = [];
	    this._isTearingDown = false;
	
	    if (typeof callback === 'function') {
	      callback(err);
	    }
	  }.bind(this));
	};
	
	module.exports = Destructor;
	
	},{"./batch-execute-functions":72}],85:[function(require,module,exports){
	'use strict';
	
	function enumerate(values, prefix) {
	  prefix = prefix == null ? '' : prefix;
	
	  return values.reduce(function (enumeration, value) {
	    enumeration[value] = prefix + value;
	
	    return enumeration;
	  }, {});
	}
	
	module.exports = enumerate;
	
	},{}],86:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.Shared Interal Error Codes
	 * @ignore
	 * @description These codes should never be experienced by the mechant directly.
	 * @property {INTERNAL} INVALID_USE_OF_INTERNAL_FUNCTION Occurs when the client is created without a gateway configuration. Should never happen.
	 */
	
	/**
	 * @name BraintreeError.Shared Errors - Component Creation Error Codes
	 * @description Errors that occur when creating components.
	 * @property {MERCHANT} INSTANTIATION_OPTION_REQUIRED Occurs when a component is created that is missing a required option.
	 * @property {MERCHANT} INCOMPATIBLE_VERSIONS Occurs when a component is created with a client with a different version than the component.
	 * @property {NETWORK} CLIENT_SCRIPT_FAILED_TO_LOAD Occurs when a component attempts to load the Braintree client script, but the request fails.
	 */
	
	/**
	 * @name BraintreeError.Shared Errors - Component Instance Error Codes
	 * @description Errors that occur when using instances of components.
	 * @property {MERCHANT} METHOD_CALLED_AFTER_TEARDOWN Occurs when a method is called on a component instance after it has been torn down.
	 * @property {MERCHANT} BRAINTREE_API_ACCESS_RESTRICTED Occurs when the client token or tokenization key does not have the correct permissions.
	 */
	
	var BraintreeError = require('./braintree-error');
	
	module.exports = {
	  INVALID_USE_OF_INTERNAL_FUNCTION: {
	    type: BraintreeError.types.INTERNAL,
	    code: 'INVALID_USE_OF_INTERNAL_FUNCTION'
	  },
	  INSTANTIATION_OPTION_REQUIRED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'INSTANTIATION_OPTION_REQUIRED'
	  },
	  INCOMPATIBLE_VERSIONS: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'INCOMPATIBLE_VERSIONS'
	  },
	  CLIENT_SCRIPT_FAILED_TO_LOAD: {
	    type: BraintreeError.types.NETWORK,
	    code: 'CLIENT_SCRIPT_FAILED_TO_LOAD',
	    message: 'Braintree client script could not be loaded.'
	  },
	  METHOD_CALLED_AFTER_TEARDOWN: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'METHOD_CALLED_AFTER_TEARDOWN'
	  },
	  BRAINTREE_API_ACCESS_RESTRICTED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'BRAINTREE_API_ACCESS_RESTRICTED',
	    message: 'Your access is restricted and cannot use this part of the Braintree API.'
	  }
	};
	
	},{"./braintree-error":73}],87:[function(require,module,exports){
	'use strict';
	
	module.exports = function (array, key, value) {
	  var i;
	
	  for (i = 0; i < array.length; i++) {
	    if (array[i].hasOwnProperty(key) && array[i][key] === value) {
	      return array[i];
	    }
	  }
	
	  return null;
	};
	
	},{}],88:[function(require,module,exports){
	'use strict';
	
	var VERSION = "3.47.0";
	var assign = require('./assign').assign;
	
	function generateTokenizationParameters(configuration, overrides) {
	  var metadata = configuration.analyticsMetadata;
	  var basicTokenizationParameters = {
	    gateway: 'braintree',
	    'braintree:merchantId': configuration.gatewayConfiguration.merchantId,
	    'braintree:apiVersion': 'v1',
	    'braintree:sdkVersion': VERSION,
	    'braintree:metadata': JSON.stringify({
	      source: metadata.source,
	      integration: metadata.integration,
	      sessionId: metadata.sessionId,
	      version: VERSION,
	      platform: metadata.platform
	    })
	  };
	
	  return assign({}, basicTokenizationParameters, overrides);
	}
	
	module.exports = function (configuration, googlePayVersion, googleMerchantId) {
	  var data, allowedPaymentMethod, paypalPaymentMethod;
	  var androidPayConfiguration = configuration.gatewayConfiguration.androidPay;
	  var environment = configuration.gatewayConfiguration.environment === 'production' ? 'PRODUCTION' : 'TEST';
	
	  if (googlePayVersion === 2) {
	    data = {
	      apiVersion: 2,
	      apiVersionMinor: 0,
	      environment: environment,
	      allowedPaymentMethods: [{
	        type: 'CARD',
	        parameters: {
	          allowedAuthMethods: [
	            'PAN_ONLY',
	            'CRYPTOGRAM_3DS'
	          ],
	          allowedCardNetworks:
	            androidPayConfiguration.supportedNetworks.map(function (card) { return card.toUpperCase(); })
	        },
	        tokenizationSpecification: {
	          type: 'PAYMENT_GATEWAY',
	          parameters: generateTokenizationParameters(configuration, {
	            'braintree:authorizationFingerprint': androidPayConfiguration.googleAuthorizationFingerprint
	          })
	        }
	      }]
	    };
	
	    if (googleMerchantId) {
	      data.merchantInfo = {
	        merchantId: googleMerchantId
	      };
	    }
	
	    if (configuration.authorizationType === 'TOKENIZATION_KEY') {
	      allowedPaymentMethod = find(data.allowedPaymentMethods, 'type', 'CARD');
	
	      if (allowedPaymentMethod) {
	        allowedPaymentMethod.tokenizationSpecification.parameters['braintree:clientKey'] = configuration.authorization;
	      }
	    }
	
	    if (androidPayConfiguration.paypalClientId) {
	      paypalPaymentMethod = {
	        type: 'PAYPAL',
	        parameters: {
	          /* eslint-disable camelcase */
	          purchase_context: {
	            purchase_units: [
	              {
	                payee: {
	                  client_id: androidPayConfiguration.paypalClientId
	                },
	                recurring_payment: true
	              }
	            ]
	          }
	          /* eslint-enable camelcase */
	        },
	        tokenizationSpecification: {
	          type: 'PAYMENT_GATEWAY',
	          parameters: generateTokenizationParameters(configuration, {
	            'braintree:paypalClientId': androidPayConfiguration.paypalClientId
	          })
	        }
	      };
	
	      data.allowedPaymentMethods.push(paypalPaymentMethod);
	    }
	  } else {
	    data = {
	      environment: environment,
	      allowedPaymentMethods: ['CARD', 'TOKENIZED_CARD'],
	      paymentMethodTokenizationParameters: {
	        tokenizationType: 'PAYMENT_GATEWAY',
	        parameters: generateTokenizationParameters(configuration, {
	          'braintree:authorizationFingerprint': androidPayConfiguration.googleAuthorizationFingerprint
	        })
	      },
	      cardRequirements: {
	        allowedCardNetworks: androidPayConfiguration.supportedNetworks.map(function (card) { return card.toUpperCase(); })
	      }
	    };
	
	    if (configuration.authorizationType === 'TOKENIZATION_KEY') {
	      data.paymentMethodTokenizationParameters.parameters['braintree:clientKey'] = configuration.authorization;
	    }
	
	    if (googleMerchantId) {
	      data.merchantId = googleMerchantId;
	    }
	
	    if (googlePayVersion) {
	      data.apiVersion = googlePayVersion;
	    }
	  }
	
	  return data;
	};
	
	},{"./assign":70}],89:[function(require,module,exports){
	'use strict';
	
	function convertDateStringToDate(dateString) {
	  var splitDate = dateString.split('-');
	
	  return new Date(splitDate[0], splitDate[1], splitDate[2]);
	}
	
	function isDateStringBeforeOrOn(firstDate, secondDate) {
	  return convertDateStringToDate(firstDate) <= convertDateStringToDate(secondDate);
	}
	
	module.exports = isDateStringBeforeOrOn;
	
	},{}],90:[function(require,module,exports){
	(function (global){
	'use strict';
	
	function isHTTPS(protocol) {
	  protocol = protocol || global.location.protocol;
	
	  return protocol === 'https:';
	}
	
	module.exports = {
	  isHTTPS: isHTTPS
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],91:[function(require,module,exports){
	'use strict';
	
	var parser;
	var legalHosts = {
	  'paypal.com': 1,
	  'braintreepayments.com': 1,
	  'braintreegateway.com': 1,
	  'braintree-api.com': 1
	};
	
	function stripSubdomains(domain) {
	  return domain.split('.').slice(-2).join('.');
	}
	
	function isVerifiedDomain(url) {
	  var mainDomain;
	
	  url = url.toLowerCase();
	
	  if (!/^https:/.test(url)) {
	    return false;
	  }
	
	  parser = parser || document.createElement('a');
	  parser.href = url;
	  mainDomain = stripSubdomains(parser.hostname);
	
	  return legalHosts.hasOwnProperty(mainDomain);
	}
	
	module.exports = isVerifiedDomain;
	
	},{}],92:[function(require,module,exports){
	'use strict';
	
	module.exports = function (value) {
	  return JSON.parse(JSON.stringify(value));
	};
	
	},{}],93:[function(require,module,exports){
	'use strict';
	
	module.exports = function (obj) {
	  return Object.keys(obj).filter(function (key) {
	    return typeof obj[key] === 'function';
	  });
	};
	
	},{}],94:[function(require,module,exports){
	arguments[4][25][0].apply(exports,arguments)
	},{"dup":25}],95:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var Promise = global.Promise || require('promise-polyfill');
	
	module.exports = Promise;
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"promise-polyfill":127}],96:[function(require,module,exports){
	(function (global){
	'use strict';
	
	function _notEmpty(obj) {
	  var key;
	
	  for (key in obj) {
	    if (obj.hasOwnProperty(key)) { return true; }
	  }
	
	  return false;
	}
	
	/* eslint-disable no-mixed-operators */
	function _isArray(value) {
	  return value && typeof value === 'object' && typeof value.length === 'number' &&
	    Object.prototype.toString.call(value) === '[object Array]' || false;
	}
	/* eslint-enable no-mixed-operators */
	
	function parse(url) {
	  var query, params;
	
	  url = url || global.location.href;
	
	  if (!/\?/.test(url)) {
	    return {};
	  }
	
	  query = url.replace(/#.*$/, '').replace(/^.*\?/, '').split('&');
	
	  params = query.reduce(function (toReturn, keyValue) {
	    var parts = keyValue.split('=');
	    var key = decodeURIComponent(parts[0]);
	    var value = decodeURIComponent(parts[1]);
	
	    toReturn[key] = value;
	
	    return toReturn;
	  }, {});
	
	  return params;
	}
	
	function stringify(params, namespace) {
	  var k, v, p;
	  var query = [];
	
	  for (p in params) {
	    if (!params.hasOwnProperty(p)) {
	      continue;
	    }
	
	    v = params[p];
	
	    if (namespace) {
	      if (_isArray(params)) {
	        k = namespace + '[]';
	      } else {
	        k = namespace + '[' + p + ']';
	      }
	    } else {
	      k = p;
	    }
	    if (typeof v === 'object') {
	      query.push(stringify(v, k));
	    } else {
	      query.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
	    }
	  }
	
	  return query.join('&');
	}
	
	function queryify(url, params) {
	  url = url || '';
	
	  if (params != null && typeof params === 'object' && _notEmpty(params)) {
	    url += url.indexOf('?') === -1 ? '?' : '';
	    url += url.indexOf('=') !== -1 ? '&' : '';
	    url += stringify(params);
	  }
	
	  return url;
	}
	
	module.exports = {
	  parse: parse,
	  stringify: stringify,
	  queryify: queryify
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],97:[function(require,module,exports){
	'use strict';
	
	function useMin(isDebug) {
	  return isDebug ? '' : '.min';
	}
	
	module.exports = useMin;
	
	},{}],98:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var atobNormalized = typeof global.atob === 'function' ? global.atob : atob;
	
	function atob(base64String) {
	  var a, b, c, b1, b2, b3, b4, i;
	  var base64Matcher = new RegExp('^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$');
	  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  var result = '';
	
	  if (!base64Matcher.test(base64String)) {
	    throw new Error('Non base64 encoded input passed to window.atob polyfill');
	  }
	
	  i = 0;
	  do {
	    b1 = characters.indexOf(base64String.charAt(i++));
	    b2 = characters.indexOf(base64String.charAt(i++));
	    b3 = characters.indexOf(base64String.charAt(i++));
	    b4 = characters.indexOf(base64String.charAt(i++));
	
	    a = (b1 & 0x3F) << 2 | b2 >> 4 & 0x3;
	    b = (b2 & 0xF) << 4 | b3 >> 2 & 0xF;
	    c = (b3 & 0x3) << 6 | b4 & 0x3F;
	
	    result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : '') + (c ? String.fromCharCode(c) : '');
	  } while (i < base64String.length);
	
	  return result;
	}
	
	module.exports = {
	  atob: function (base64String) {
	    return atobNormalized.call(global, base64String);
	  },
	  _atob: atob
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],99:[function(require,module,exports){
	'use strict';
	
	function uuid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c === 'x' ? r : r & 0x3 | 0x8;
	
	    return v.toString(16);
	  });
	}
	
	module.exports = uuid;
	
	},{}],100:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.PayPal Checkout - Creation Error Codes
	 * @description Errors that occur when [creating the PayPal Checkout component](/current/module-braintree-web_paypal-checkout.html#.create).
	 * @property {MERCHANT} PAYPAL_NOT_ENABLED Occurs when PayPal is not enabled on the Braintree control panel.
	 * @property {MERCHANT} PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED Occurs only when testing in Sandbox, when a PayPal sandbox account is not linked to the merchant account in the Braintree control panel.
	 */
	
	/**
	 * @name BraintreeError.PayPal Checkout - createPayment Error Codes
	 * @description Errors that occur when using the [`createPayment` method](/current/PayPalCheckout.html#createPayment).
	 * @property {MERCHANT} PAYPAL_FLOW_OPTION_REQUIRED Occurs when a required option is missing.
	 * @property {MERCHANT} PAYPAL_INVALID_PAYMENT_OPTION Occurs when an option contains an invalid value.
	 * @property {NETWORK} PAYPAL_FLOW_FAILED Occurs when something goes wrong when initializing the flow.
	 */
	
	/**
	 * @name BraintreeError.PayPal Checkout - tokenizePayment Error Codes
	 * @description Errors that occur when using the [`tokenizePayment` method](/current/PayPalCheckout.html#tokenizePayment).
	 * @property {NETWORK} PAYPAL_ACCOUNT_TOKENIZATION_FAILED Occurs when PayPal account could not be tokenized.
	 */
	
	var BraintreeError = require('../lib/braintree-error');
	
	module.exports = {
	  PAYPAL_NOT_ENABLED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'PAYPAL_NOT_ENABLED',
	    message: 'PayPal is not enabled for this merchant.'
	  },
	  PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED',
	    message: 'A linked PayPal Sandbox account is required to use PayPal Checkout in Sandbox. See https://developers.braintreepayments.com/guides/paypal/testing-go-live/#linked-paypal-testing for details on linking your PayPal sandbox with Braintree.'
	  },
	  PAYPAL_ACCOUNT_TOKENIZATION_FAILED: {
	    type: BraintreeError.types.NETWORK,
	    code: 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED',
	    message: 'Could not tokenize user\'s PayPal account.'
	  },
	  PAYPAL_FLOW_FAILED: {
	    type: BraintreeError.types.NETWORK,
	    code: 'PAYPAL_FLOW_FAILED',
	    message: 'Could not initialize PayPal flow.'
	  },
	  PAYPAL_FLOW_OPTION_REQUIRED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'PAYPAL_FLOW_OPTION_REQUIRED',
	    message: 'PayPal flow property is invalid or missing.'
	  },
	  PAYPAL_INVALID_PAYMENT_OPTION: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'PAYPAL_INVALID_PAYMENT_OPTION',
	    message: 'PayPal payment options are invalid.'
	  }
	};
	
	},{"../lib/braintree-error":73}],101:[function(require,module,exports){
	'use strict';
	/**
	 * @module braintree-web/paypal-checkout
	 * @description A component to integrate with the [PayPal Checkout.js library](https://github.com/paypal/paypal-checkout).
	 */
	
	var basicComponentVerification = require('../lib/basic-component-verification');
	var wrapPromise = require('@braintree/wrap-promise');
	var PayPalCheckout = require('./paypal-checkout');
	var VERSION = "3.47.0";
	
	/**
	 * @static
	 * @function create
	 * @description There are two ways to integrate the PayPal Checkout component. See the [PayPal Checkout constructor documentation](PayPalCheckout.html#PayPalCheckout) for more information and examples.
	 *
	 * @param {object} options Creation options:
	 * @param {Client} [options.client] A {@link Client} instance.
	 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
	 * @param {string} [options.merchantAccountId] A non-default merchant account ID to use for tokenization.
	 * @param {callback} [callback] The second argument, `data`, is the {@link PayPalCheckout} instance.
	 * @example
	 * braintree.client.create({
	 *   authorization: 'authorization'
	 * }).then(function (clientInstance) {
	 *   return braintree.paypalCheckout.create({
	 *     client: clientInstance
	 *   });
	 * }).then(function (paypalCheckoutInstance) {
	 *   // set up checkout.js
	 * }).catch(function (err) {
	 *   console.error('Error!', err);
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	function create(options) {
	  var name = 'PayPal Checkout';
	
	  return basicComponentVerification.verify({
	    name: name,
	    client: options.client,
	    authorization: options.authorization
	  }).then(function () {
	    var instance = new PayPalCheckout(options);
	
	    return instance._initialize(options);
	  });
	}
	
	/**
	 * @static
	 * @function isSupported
	 * @description Returns true if PayPal Checkout [supports this browser](index.html#browser-support-webviews).
	 * @deprecated Previously, this method checked for Popup support in the browser. Checkout.js now falls back to a modal if popups are not supported.
	 * @returns {Boolean} Returns true if PayPal Checkout supports this browser.
	 */
	function isSupported() {
	  return true;
	}
	
	module.exports = {
	  create: wrapPromise(create),
	  isSupported: isSupported,
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/basic-component-verification":71,"./paypal-checkout":102,"@braintree/wrap-promise":27}],102:[function(require,module,exports){
	'use strict';
	
	var analytics = require('../lib/analytics');
	var createDeferredClient = require('../lib/create-deferred-client');
	var createAssetsUrl = require('../lib/create-assets-url');
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	var BraintreeError = require('../lib/braintree-error');
	var convertToBraintreeError = require('../lib/convert-to-braintree-error');
	var errors = require('./errors');
	var constants = require('../paypal/shared/constants');
	var methods = require('../lib/methods');
	var convertMethodsToError = require('../lib/convert-methods-to-error');
	
	/**
	 * PayPal Checkout tokenized payload. Returned in {@link PayPalCheckout#tokenizePayment}'s callback as the second argument, `data`.
	 * @typedef {object} PayPalCheckout~tokenizePayload
	 * @property {string} nonce The payment method nonce.
	 * @property {string} type The payment method type, always `PayPalAccount`.
	 * @property {object} details Additional PayPal account details.
	 * @property {string} details.email User's email address.
	 * @property {string} details.payerId User's payer ID, the unique identifier for each PayPal account.
	 * @property {string} details.firstName User's given name.
	 * @property {string} details.lastName User's surname.
	 * @property {?string} details.countryCode User's 2 character country code.
	 * @property {?string} details.phone User's phone number (e.g. 555-867-5309).
	 * @property {?object} details.shippingAddress User's shipping address details, only available if shipping address is enabled.
	 * @property {string} details.shippingAddress.recipientName Recipient of postage.
	 * @property {string} details.shippingAddress.line1 Street number and name.
	 * @property {string} details.shippingAddress.line2 Extended address.
	 * @property {string} details.shippingAddress.city City or locality.
	 * @property {string} details.shippingAddress.state State or region.
	 * @property {string} details.shippingAddress.postalCode Postal code.
	 * @property {string} details.shippingAddress.countryCode 2 character country code (e.g. US).
	 * @property {?object} details.billingAddress User's billing address details.
	 * Not available to all merchants; [contact PayPal](https://developers.braintreepayments.com/support/guides/paypal/setup-guide#contacting-paypal-support) for details on eligibility and enabling this feature.
	 * Alternatively, see `shippingAddress` above as an available client option.
	 * @property {string} details.billingAddress.line1 Street number and name.
	 * @property {string} details.billingAddress.line2 Extended address.
	 * @property {string} details.billingAddress.city City or locality.
	 * @property {string} details.billingAddress.state State or region.
	 * @property {string} details.billingAddress.postalCode Postal code.
	 * @property {string} details.billingAddress.countryCode 2 character country code (e.g. US).
	 * @property {?object} creditFinancingOffered This property will only be present when the customer pays with PayPal Credit.
	 * @property {object} creditFinancingOffered.totalCost This is the estimated total payment amount including interest and fees the user will pay during the lifetime of the loan.
	 * @property {string} creditFinancingOffered.totalCost.value An amount defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
	 * @property {string} creditFinancingOffered.totalCost.currency 3 letter currency code as defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm).
	 * @property {number} creditFinancingOffered.term Length of financing terms in months.
	 * @property {object} creditFinancingOffered.monthlyPayment This is the estimated amount per month that the customer will need to pay including fees and interest.
	 * @property {string} creditFinancingOffered.monthlyPayment.value An amount defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
	 * @property {string} creditFinancingOffered.monthlyPayment.currency 3 letter currency code as defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm).
	 * @property {object} creditFinancingOffered.totalInterest Estimated interest or fees amount the payer will have to pay during the lifetime of the loan.
	 * @property {string} creditFinancingOffered.totalInterest.value An amount defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm) for the given currency.
	 * @property {string} creditFinancingOffered.totalInterest.currency 3 letter currency code as defined by [ISO 4217](http://www.iso.org/iso/home/standards/currency_codes.htm).
	 * @property {boolean} creditFinancingOffered.payerAcceptance Status of whether the customer ultimately was approved for and chose to make the payment using the approved installment credit.
	 * @property {boolean} creditFinancingOffered.cartAmountImmutable Indicates whether the cart amount is editable after payer's acceptance on PayPal side.
	 */
	
	/**
	 * @class
	 * @param {object} options see {@link module:braintree-web/paypal-checkout.create|paypal-checkout.create}
	 * @classdesc This class represents a PayPal Checkout component that coordinates with the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. Instances of this class can generate payment data and tokenize authorized payments.
	 *
	 * All UI (such as preventing actions on the parent page while authentication is in progress) is managed by the {@link https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page|PayPal SDK}. You must provide your PayPal `client-id` as a query parameter. You can [retrieve this value from the PayPal Dashboard](https://developer.paypal.com/docs/checkout/integrate/#1-get-paypal-rest-api-credentials).
	 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/paypal-checkout.create|braintree-web.paypal-checkout.create} instead.</strong>
	 *
	 * #### Integrate Checkout Flow with PayPal SDK
	 *
	 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
	 *
	 * ```html
	 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id"></script>
	 * <div id="paypal-button"></div>
	 * ```
	 *
	 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
	 *
	 * ```javascript
	 * braintree.client.create({
	 *   authorization: 'authorization'
	 * }).then(function (clientInstance) {
	 *   return braintree.paypalCheckout.create({
	 *     client: clientInstance
	 *   });
	 * }).then(function (paypalCheckoutInstance) {
	 *   return paypal.Buttons({
	 *     createOrder: function () {
	 *       return paypalCheckoutInstance.createPayment({
	 *         flow: 'checkout',
	 *         currency: 'USD',
	 *         amount: '10.00',
	 *         intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
	 *         // your other createPayment options here
	 *       });
	 *     },
	 *
	 *     onApprove: function (data, actions) {
	 *       // some logic here before tokenization happens below
	 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
	 *         // Submit payload.nonce to your server
	 *       });
	 *     },
	 *
	 *     onCancel: function () {
	 *       // handle case where user cancels
	 *     },
	 *
	 *     onError: function (err) {
	 *       // handle case where error occurs
	 *     }
	 *   }).render('#paypal-button');
	 * }).catch(function (err) {
	 *  console.error('Error!', err);
	 * });
	 * ```
	 *
	 * #### Integrate Vault Flow with PayPal SDK
	 *
	 * You must have [PayPal's script, configured with various query parameters](https://developer.paypal.com/docs/checkout/integrate/#2-add-the-paypal-script-to-your-web-page), loaded on your page:
	 *
	 * ```html
	 * <script src="https://www.paypal.com/sdk/js?client-id=your-sandbox-or-prod-client-id&vault=true"></script>
	 * <div id="paypal-button"></div>
	 * ```
	 *
	 * When passing values in the `createPayment` method, make sure they match the [corresponding parameters in the query parameters for the PayPal SDK script](https://developer.paypal.com/docs/checkout/reference/customize-sdk/).
	 *
	 * ```javascript
	 * braintree.client.create({
	 *   authorization: 'authorization'
	 * }).then(function (clientInstance) {
	 *   return braintree.paypalCheckout.create({
	 *     client: clientInstance
	 *   });
	 * }).then(function (paypalCheckoutInstance) {
	 *   return paypal.Buttons({
	 *     createBillingAgreement: function () {
	 *       return paypalCheckoutInstance.createPayment({
	 *         flow: 'vault'
	 *         // your other createPayment options here
	 *       });
	 *     },
	 *
	 *     onApprove: function (data, actions) {
	 *       // some logic here before tokenization happens below
	 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
	 *         // Submit payload.nonce to your server
	 *       });
	 *     },
	 *
	 *     onCancel: function () {
	 *       // handle case where user cancels
	 *     },
	 *
	 *     onError: function (err) {
	 *       // handle case where error occurs
	 *     }
	 *   }).render('#paypal-button');
	 * }).catch(function (err) {
	 *  console.error('Error!', err);
	 * });
	 * ```
	 *
	 * #### Integrate with Checkout.js (deprecated PayPal SDK)
	 *
	 * You must have PayPal's checkout.js script loaded on your page. You can either use the [paypal-checkout package on npm](https://www.npmjs.com/package/paypal-checkout) with a build tool or use a script hosted by PayPal:
	 *
	 * ```html
	 * <script src="https://www.paypalobjects.com/api/checkout.js" data-version-4 log-level="warn"></script>
	 * ```
	 *
	 * ```javascript
	 * braintree.client.create({
	 *   authorization: 'authorization'
	 * }).then(function (clientInstance) {
	 *   return braintree.paypalCheckout.create({
	 *     client: clientInstance
	 *   });
	 * }).then(function (paypalCheckoutInstance) {
	 *   return paypal.Button.render({
	 *     env: 'production', // or 'sandbox'
	 *
	 *     payment: function () {
	 *       return paypalCheckoutInstance.createPayment({
	 *         // your createPayment options here
	 *       });
	 *     },
	 *
	 *     onAuthorize: function (data, actions) {
	 *       // some logic here before tokenization happens below
	 *       return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
	 *         // Submit payload.nonce to your server
	 *       });
	 *     }
	 *   }, '#paypal-button');
	 * }).catch(function (err) {
	 *  console.error('Error!', err);
	 * });
	 * ```
	 */
	function PayPalCheckout(options) {
	  this._merchantAccountId = options.merchantAccountId;
	}
	
	PayPalCheckout.prototype._initialize = function (options) {
	  this._clientPromise = createDeferredClient.create({
	    authorization: options.authorization,
	    client: options.client,
	    debug: options.debug,
	    assetsUrl: createAssetsUrl.create(options.authorization),
	    name: 'PayPal Checkout'
	  }).then(function (client) {
	    this._configuration = client.getConfiguration();
	
	    // we skip these checks if a merchant account id is
	    // passed in, because the default merchant account
	    // may not have paypal enabled
	    if (!this._merchantAccountId) {
	      if (!this._configuration.gatewayConfiguration.paypalEnabled) {
	        this._setupError = new BraintreeError(errors.PAYPAL_NOT_ENABLED);
	      } else if (this._configuration.gatewayConfiguration.paypal.environmentNoNetwork === true) {
	        this._setupError = new BraintreeError(errors.PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED);
	      }
	    }
	
	    if (this._setupError) {
	      return Promise.reject(this._setupError);
	    }
	
	    analytics.sendEvent(client, 'paypal-checkout.initialized');
	
	    return client;
	  }.bind(this));
	
	  // if client was passed in, let config checks happen before
	  // resolving the instance. Otherwise, just resolve the instance
	  if (options.client) {
	    return this._clientPromise.then(function () {
	      return this;
	    }.bind(this));
	  }
	
	  return Promise.resolve(this);
	};
	
	/**
	 * @typedef {object} PayPalCheckout~lineItem
	 * @property {string} quantity Number of units of the item purchased. This value must be a whole number and can't be negative or zero.
	 * @property {string} unitAmount Per-unit price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
	 * @property {string} name Item name. Maximum 127 characters.
	 * @property {string} kind Indicates whether the line item is a debit (sale) or credit (refund) to the customer. Accepted values: `debit` and `credit`.
	 * @property {?string} unitTaxAmount Per-unit tax price of the item. Can include up to 2 decimal places. This value can't be negative or zero.
	 * @property {?string} description Item description. Maximum 127 characters.
	 * @property {?string} productCode Product or UPC code for the item. Maximum 127 characters.
	 * @property {?string} url The URL to product information.
	 */
	
	/**
	 * Creates a PayPal payment ID or billing token using the given options. This is meant to be passed to PayPal's checkout.js library.
	 * When a {@link callback} is defined, the function returns undefined and invokes the callback with the id to be used with the checkout.js library. Otherwise, it returns a Promise that resolves with the id.
	 * @public
	 * @param {object} options All options for the PayPalCheckout component.
	 * @param {string} options.flow Set to 'checkout' for one-time payment flow, or 'vault' for Vault flow. If 'vault' is used with a client token generated with a customer ID, the PayPal account will be added to that customer as a saved payment method.
	 * @param {string} [options.intent=authorize]
	 * * `authorize` - Submits the transaction for authorization but not settlement.
	 * * `order` - Validates the transaction without an authorization (i.e. without holding funds). Useful for authorizing and capturing funds up to 90 days after the order has been placed. Only available for Checkout flow.
	 * * `capture` - Payment will be immediately submitted for settlement upon creating a transaction. `sale` can be used as an alias for this value.
	 * @param {boolean} [options.offerCredit=false] Offers PayPal Credit as the default funding instrument for the transaction. If the customer isn't pre-approved for PayPal Credit, they will be prompted to apply for it.
	 * @param {string|number} [options.amount] The amount of the transaction. Required when using the Checkout flow.
	 * @param {string} [options.currency] The currency code of the amount, such as 'USD'. Required when using the Checkout flow.
	 * @param {string} [options.displayName] The merchant name displayed inside of the PayPal lightbox; defaults to the company name on your Braintree account
	 * @param {string} [options.locale=en_US] Use this option to change the language, links, and terminology used in the PayPal flow. This locale will be used unless the buyer has set a preferred locale for their account. If an unsupported locale is supplied, a fallback locale (determined by buyer preference or browser data) will be used and no error will be thrown.
	 *
	 * Supported locales are:
	 * `da_DK`,
	 * `de_DE`,
	 * `en_AU`,
	 * `en_GB`,
	 * `en_US`,
	 * `es_ES`,
	 * `fr_CA`,
	 * `fr_FR`,
	 * `id_ID`,
	 * `it_IT`,
	 * `ja_JP`,
	 * `ko_KR`,
	 * `nl_NL`,
	 * `no_NO`,
	 * `pl_PL`,
	 * `pt_BR`,
	 * `pt_PT`,
	 * `ru_RU`,
	 * `sv_SE`,
	 * `th_TH`,
	 * `zh_CN`,
	 * `zh_HK`,
	 * and `zh_TW`.
	 *
	 * @param {boolean} [options.enableShippingAddress=false] Returns a shipping address object in {@link PayPal#tokenize}.
	 * @param {object} [options.shippingAddressOverride] Allows you to pass a shipping address you have already collected into the PayPal payment flow.
	 * @param {string} options.shippingAddressOverride.line1 Street address.
	 * @param {string} [options.shippingAddressOverride.line2] Street address (extended).
	 * @param {string} options.shippingAddressOverride.city City.
	 * @param {string} options.shippingAddressOverride.state State.
	 * @param {string} options.shippingAddressOverride.postalCode Postal code.
	 * @param {string} options.shippingAddressOverride.countryCode Country.
	 * @param {string} [options.shippingAddressOverride.phone] Phone number.
	 * @param {string} [options.shippingAddressOverride.recipientName] Recipient's name.
	 * @param {boolean} [options.shippingAddressEditable=true] Set to false to disable user editing of the shipping address.
	 * @param {string} [options.billingAgreementDescription] Use this option to set the description of the preapproved payment agreement visible to customers in their PayPal profile during Vault flows. Max 255 characters.
	 * @param {string} [options.landingPageType] Use this option to specify the PayPal page to display when a user lands on the PayPal site to complete the payment.
	 * * `login` - A PayPal account login page is used.
	 * * `billing` - A non-PayPal account landing page is used.
	* @property {lineItem[]} [options.lineItems] The line items for this transaction. It can include up to 249 line items.
	 * @param {callback} [callback] The second argument is a PayPal `paymentId` or `billingToken` string, depending on whether `options.flow` is `checkout` or `vault`. This is also what is resolved by the promise if no callback is provided.
	 * @example
	 * // this paypal object is created by checkout.js
	 * // see https://github.com/paypal/paypal-checkout
	 * paypal.Buttons({
	 *   createOrder: function () {
	 *     // when createPayment resolves, it is automatically passed to checkout.js
	 *     return paypalCheckoutInstance.createPayment({
	 *       flow: 'checkout',
	 *       amount: '10.00',
	 *       currency: 'USD',
	 *       intent: 'capture' // this value must either be `capture` or match the intent passed into the PayPal SDK intent query parameter
	 *     });
	 *   },
	 *   // Add other options, e.g. onApproved, onCancel, onError
	 * }).render('#paypal-button');
	 *
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	PayPalCheckout.prototype.createPayment = function (options) {
	  var self = this;
	  var endpoint;
	
	  if (!options || !constants.FLOW_ENDPOINTS.hasOwnProperty(options.flow)) {
	    return Promise.reject(new BraintreeError(errors.PAYPAL_FLOW_OPTION_REQUIRED));
	  }
	
	  endpoint = 'paypal_hermes/' + constants.FLOW_ENDPOINTS[options.flow];
	
	  analytics.sendEvent(this._clientPromise, 'paypal-checkout.createPayment');
	  if (options.offerCredit === true) {
	    analytics.sendEvent(this._clientPromise, 'paypal-checkout.credit.offered');
	  }
	
	  return this._clientPromise.then(function (client) {
	    return client.request({
	      endpoint: endpoint,
	      method: 'post',
	      data: self._formatPaymentResourceData(options)
	    });
	  }).then(function (response) {
	    var flowToken;
	
	    if (options.flow === 'checkout') {
	      flowToken = response.paymentResource.redirectUrl.match(/EC-\w+/)[0];
	    } else {
	      flowToken = response.agreementSetup.tokenId;
	    }
	
	    return flowToken;
	  }).catch(function (err) {
	    var status;
	
	    if (self._setupError) {
	      return Promise.reject(self._setupError);
	    }
	
	    status = err.details && err.details.httpStatus;
	
	    if (status === 422) {
	      return Promise.reject(new BraintreeError({
	        type: errors.PAYPAL_INVALID_PAYMENT_OPTION.type,
	        code: errors.PAYPAL_INVALID_PAYMENT_OPTION.code,
	        message: errors.PAYPAL_INVALID_PAYMENT_OPTION.message,
	        details: {
	          originalError: err
	        }
	      }));
	    }
	
	    return Promise.reject(convertToBraintreeError(err, {
	      type: errors.PAYPAL_FLOW_FAILED.type,
	      code: errors.PAYPAL_FLOW_FAILED.code,
	      message: errors.PAYPAL_FLOW_FAILED.message
	    }));
	  });
	};
	
	/**
	 * Tokenizes the authorize data from PayPal's checkout.js library when completing a buyer approval flow.
	 * When a {@link callback} is defined, invokes the callback with {@link PayPalCheckout~tokenizePayload|tokenizePayload} and returns undefined. Otherwise, returns a Promise that resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
	 * @public
	 * @param {object} tokenizeOptions Tokens and IDs required to tokenize the payment.
	 * @param {string} tokenizeOptions.payerId Payer ID returned by PayPal `onApproved` callback.
	 * @param {string} [tokenizeOptions.paymentId] Payment ID returned by PayPal `onApproved` callback.
	 * @param {string} [tokenizeOptions.billingToken] Billing Token returned by PayPal `onApproved` callback.
	 * @param {callback} [callback] The second argument, <code>payload</code>, is a {@link PayPalCheckout~tokenizePayload|tokenizePayload}. If no callback is provided, the promise resolves with a {@link PayPalCheckout~tokenizePayload|tokenizePayload}.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	PayPalCheckout.prototype.tokenizePayment = function (tokenizeOptions) {
	  var self = this;
	  var payload;
	  var options = {
	    flow: tokenizeOptions.billingToken ? 'vault' : 'checkout',
	    intent: tokenizeOptions.intent
	  };
	  var params = {
	    // The paymentToken provided by Checkout.js v4 is the ECToken
	    ecToken: tokenizeOptions.paymentToken,
	    billingToken: tokenizeOptions.billingToken,
	    payerId: tokenizeOptions.payerID,
	    paymentId: tokenizeOptions.paymentID
	  };
	
	  analytics.sendEvent(this._clientPromise, 'paypal-checkout.tokenization.started');
	
	  return this._clientPromise.then(function (client) {
	    return client.request({
	      endpoint: 'payment_methods/paypal_accounts',
	      method: 'post',
	      data: self._formatTokenizeData(options, params)
	    });
	  }).then(function (response) {
	    payload = self._formatTokenizePayload(response);
	
	    analytics.sendEvent(self._clientPromise, 'paypal-checkout.tokenization.success');
	    if (payload.creditFinancingOffered) {
	      analytics.sendEvent(self._clientPromise, 'paypal-checkout.credit.accepted');
	    }
	
	    return payload;
	  }).catch(function (err) {
	    if (self._setupError) {
	      return Promise.reject(self._setupError);
	    }
	
	    analytics.sendEvent(self._clientPromise, 'paypal-checkout.tokenization.failed');
	
	    return Promise.reject(convertToBraintreeError(err, {
	      type: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.type,
	      code: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.code,
	      message: errors.PAYPAL_ACCOUNT_TOKENIZATION_FAILED.message
	    }));
	  });
	};
	
	PayPalCheckout.prototype._formatPaymentResourceData = function (options) {
	  var key;
	  var gatewayConfiguration = this._configuration.gatewayConfiguration;
	  // NEXT_MAJOR_VERSION default value for intent in PayPal SDK is capture
	  // but our integrations default value is authorize. Default this to capture
	  // in the next major version.
	  var intent = options.intent;
	  var paymentResource = {
	    // returnUrl and cancelUrl are required in hermes create_payment_resource route
	    // but are not used by the PayPal sdk, except to redirect to an error page
	    returnUrl: 'https://www.paypal.com/checkoutnow/error',
	    cancelUrl: 'https://www.paypal.com/checkoutnow/error',
	    offerPaypalCredit: options.offerCredit === true,
	    merchantAccountId: this._merchantAccountId,
	    experienceProfile: {
	      brandName: options.displayName || gatewayConfiguration.paypal.displayName,
	      localeCode: options.locale,
	      noShipping: (!options.enableShippingAddress).toString(),
	      addressOverride: options.shippingAddressEditable === false,
	      landingPageType: options.landingPageType
	    }
	  };
	
	  if (options.flow === 'checkout') {
	    paymentResource.amount = options.amount;
	    paymentResource.currencyIsoCode = options.currency;
	
	    if (intent) {
	      // 'sale' has been changed to 'capture' in PayPal's backend, but
	      // we use an old version with 'sale'. We provide capture as an alias
	      // to match the PayPal SDK
	      if (intent === 'capture') {
	        intent = 'sale';
	      }
	      paymentResource.intent = intent;
	    }
	
	    if (options.hasOwnProperty('lineItems')) {
	      paymentResource.lineItems = options.lineItems;
	    }
	
	    for (key in options.shippingAddressOverride) {
	      if (options.shippingAddressOverride.hasOwnProperty(key)) {
	        paymentResource[key] = options.shippingAddressOverride[key];
	      }
	    }
	  } else {
	    paymentResource.shippingAddress = options.shippingAddressOverride;
	
	    if (options.billingAgreementDescription) {
	      paymentResource.description = options.billingAgreementDescription;
	    }
	  }
	
	  return paymentResource;
	};
	
	PayPalCheckout.prototype._formatTokenizeData = function (options, params) {
	  var clientConfiguration = this._configuration;
	  var gatewayConfiguration = clientConfiguration.gatewayConfiguration;
	  var isTokenizationKey = clientConfiguration.authorizationType === 'TOKENIZATION_KEY';
	  var data = {
	    paypalAccount: {
	      correlationId: params.billingToken || params.ecToken,
	      options: {
	        validate: options.flow === 'vault' && !isTokenizationKey
	      }
	    }
	  };
	
	  if (params.billingToken) {
	    data.paypalAccount.billingAgreementToken = params.billingToken;
	  } else {
	    data.paypalAccount.paymentToken = params.paymentId;
	    data.paypalAccount.payerId = params.payerId;
	    data.paypalAccount.unilateral = gatewayConfiguration.paypal.unvettedMerchant;
	
	    if (options.intent) {
	      data.paypalAccount.intent = options.intent;
	    }
	  }
	
	  if (this._merchantAccountId) {
	    data.merchantAccountId = this._merchantAccountId;
	  }
	
	  return data;
	};
	
	PayPalCheckout.prototype._formatTokenizePayload = function (response) {
	  var payload;
	  var account = {};
	
	  if (response.paypalAccounts) {
	    account = response.paypalAccounts[0];
	  }
	
	  payload = {
	    nonce: account.nonce,
	    details: {},
	    type: account.type
	  };
	
	  if (account.details && account.details.payerInfo) {
	    payload.details = account.details.payerInfo;
	  }
	
	  if (account.details && account.details.creditFinancingOffered) {
	    payload.creditFinancingOffered = account.details.creditFinancingOffered;
	  }
	
	  return payload;
	};
	
	/**
	 * Cleanly tear down anything set up by {@link module:braintree-web/paypal-checkout.create|create}.
	 * @public
	 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
	 * @example
	 * paypalCheckoutInstance.teardown();
	 * @example <caption>With callback</caption>
	 * paypalCheckoutInstance.teardown(function () {
	 *   // teardown is complete
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	PayPalCheckout.prototype.teardown = function () {
	  convertMethodsToError(this, methods(PayPalCheckout.prototype));
	
	  return Promise.resolve();
	};
	
	module.exports = wrapPromise.wrapPrototype(PayPalCheckout);
	
	},{"../lib/analytics":68,"../lib/braintree-error":73,"../lib/convert-methods-to-error":78,"../lib/convert-to-braintree-error":79,"../lib/create-assets-url":80,"../lib/create-deferred-client":82,"../lib/methods":93,"../lib/promise":95,"../paypal/shared/constants":103,"./errors":100,"@braintree/wrap-promise":27}],103:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  LANDING_FRAME_NAME: 'braintreepaypallanding',
	  FLOW_ENDPOINTS: {
	    checkout: 'create_payment_resource',
	    vault: 'setup_billing_agreement'
	  }
	};
	
	},{}],104:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var BraintreeError = require('../../lib/braintree-error');
	var convertToBraintreeError = require('../../lib/convert-to-braintree-error');
	var analytics = require('../../lib/analytics');
	var assign = require('../../lib/assign').assign;
	var assets = require('../../lib/assets');
	var methods = require('../../lib/methods');
	var convertMethodsToError = require('../../lib/convert-methods-to-error');
	var constants = require('../shared/constants');
	var useMin = require('../../lib/use-min');
	var Bus = require('../../lib/bus');
	var uuid = require('../../lib/vendor/uuid');
	var deferred = require('../../lib/deferred');
	var errors = require('../shared/errors');
	var events = require('../shared/events');
	var iFramer = require('@braintree/iframer');
	var Promise = require('../../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	var INTEGRATION_TIMEOUT_MS = require('../../lib/constants').INTEGRATION_TIMEOUT_MS;
	
	var PLATFORM = require('../../lib/constants').PLATFORM;
	var VERSION = "3.47.0";
	
	var IFRAME_HEIGHT = 400;
	var IFRAME_WIDTH = 400;
	
	/**
	 * @deprecated
	 * @callback ThreeDSecure~addFrameCallback
	 * @param {?BraintreeError} [err] `null` or `undefined` if there was no error.
	 * @param {HTMLIFrameElement} iframe An iframe element containing the bank's authentication page that you must put on your page.
	 * @description **Deprecated** The callback used for options.addFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
	 * @returns {void}
	 */
	
	/**
	 * @deprecated
	 * @callback ThreeDSecure~removeFrameCallback
	 * @description **Deprecated** The callback used for options.removeFrame in 3DS 1.0's {@link ThreeDSecure#verifyCard|verifyCard}.
	 * @returns {void}
	 */
	
	/**
	 * @deprecated
	 * @typedef {object} ThreeDSecure~verifyCardCustomerObject
	 * @property {string} [customer.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, paranthesis and other characters.
	 * @property {string} [customer.email] The email used for verification.
	 * @property {string} [customer.shippingMethod] The 2-digit string indicating the shipping method chosen for the transaction.
	 * @property {string} [customer.billingAddress.firstName] The first name associated with the address.
	 * @property {string} [customer.billingAddress.lastName] The last name associated with the address.
	 * @property {string} [customer.billingAddress.streetAddress] Line 1 of the Address (eg. number, street, etc).
	 * @property {string} [customer.billingAddress.extendedAddress] Line 2 of the Address (eg. suite, apt #, etc.).
	 * @property {string} [customer.billingAddress.locality] The locality (city) name associated with the address.
	 * @property {string} [customer.billingAddress.region] The 2 letter code for US states, and the equivalent for other countries.
	 * @property {string} [customer.billingAddress.postalCode] The zip code or equivalent for countries that have them.
	 * @property {string} [customer.billingAddress.countryCodeAlpha2] The 2 character country code.
	 * @property {string} [customer.billingAddress.phoneNumber] The phone number associated with the address. Only numbers; remove dashes, paranthesis and other characters.
	 * @description **Deprecated** Optional customer information to be passed to 3DS 1.0 for verification.
	 */
	
	/**
	 * @typedef {object} ThreeDSecure~verifyPayload
	 * @property {string} nonce The new payment method nonce produced by the 3D Secure lookup. The original nonce passed into {@link ThreeDSecure#verifyCard|verifyCard} was consumed. This new nonce should be used to transact on your server.
	 * @property {object} details Additional account details.
	 * @property {string} details.cardType Type of card, ex: Visa, MasterCard.
	 * @property {string} details.lastFour Last four digits of card number.
	 * @property {string} details.lastTwo Last two digits of card number.
	 * @property {string} description A human-readable description.
	 * @property {object} binData Information about the card based on the bin.
	 * @property {string} binData.commercial Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.countryOfIssuance The country of issuance.
	 * @property {string} binData.debit Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.healthcare Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.issuingBank The issuing bank.
	 * @property {string} binData.payroll Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.prepaid Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} binData.productId The product id.
	 * @property {boolean} liabilityShiftPossible Indicates whether the card was eligible for 3D Secure.
	 * @property {boolean} liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
	 */
	
	/**
	 * @typedef {string} ThreeDSecure~prepareLookupPayload The client data to pass on when doing a server side lookup call.
	 */
	
	/**
	 * @typedef {object} ThreeDSecure~verificationData
	 * @property {object} threeDSecureInfo Contains liability shift details.
	 * @property {boolean} threeDSecureInfo.liabilityShiftPossible Indicates whether the card was eligible for 3D Secure.
	 * @property {boolean} threeDSecureInfo.liabilityShifted Indicates whether the liability for fraud has been shifted away from the merchant.
	 * @property {object} paymentMethod A {@link ThreeDSecure~verifyPayload|verifyPayload} object.
	 * @property {object} lookup Details about the 3D Secure lookup.
	 * @property {string} lookup.threeDSecureVersion The version of 3D Secure that will be used for the 3D Secure challenge.
	*/
	
	/**
	 * @typedef {object} ThreeDSecure~billingAddress
	 * @property {string} [givenName] The first name associated with the billing address.
	 * @property {string} [surname] The last name associated with the billing address.
	 * @property {number} [phoneNumber] The phone number associated with the billing address. Only numbers; remove dashes, paranthesis and other characters.
	 * @property {string} [streetAddress] Line 1 of the billing address (eg. number, street, etc).
	 * @property {string} [extendedAddress] Line 2 of the billing address (eg. suite, apt #, etc.).
	 * @property {string} [line3] Line 3 of the billing address if needed (eg. suite, apt #, etc).
	 * @property {string} [locality] The locality (city) name associated with the billing address.
	 * @property {string} [region] The 2 letter code for US states, and the equivalent for other countries.
	 * @property {string} [postalCode] The zip code or equivalent for countries that have them.
	 * @property {string} [countryCodeAlpha2] The 2 character country code.
	*/
	
	/**
	 * @typedef {object} ThreeDSecure~additionalInformation
	 * @property {number} [workPhoneNumber] The work phone number used for verification. Only numbers; remove dashes, parenthesis and other characters.
	 * @property {string} [shippingGivenName] The first name associated with the shipping address.
	 * @property {string} [shippingSurname] The last name associated with the shipping address.
	 * @property {object} [shippingAddress]
	 * @property {string} [shippingAddress.streetAddress] The first name associated with the shipping address.
	 * @property {string} [shippingAddress.extendedAddress] The last name associated with the shipping address.
	 * @property {string} [shippingAddress.line3] Line 3 of the shipping address if needed (eg. suite, apt #, etc).
	 * @property {string} [shippingAddress.locality] The locality (city) name associated with the shipping address.
	 * @property {string} [shippingAddress.region] The 2 letter code for US states, and the equivalent for other countries.
	 * @property {string} [shippingAddress.postalCode] The zip code or equivalent for countries that have them.
	 * @property {string} [shippingAddress.countryCodeAlpha2] The 2 character country code.
	 * @property {number} [shippingPhone] The phone number associated with the shipping address. Only numbers; remove dashes, parenthesis and other characters.
	 * @property {string} [shippingMethod] The 2-digit string indicating the name of the shipping method chosen for the transaction. Possible values:
	 * - `01` Same Day
	 * - `02` Overnight / Expedited
	 * - `03` Priority (2-3 Days)
	 * - `04` Ground
	 * - `05` Electronic Delivery
	 * - `06` Ship to Store
	 * @property {number} [shippingMethodIndicator] The 2-digit string indicating the shipping method chosen for the transaction Possible values.
	 * - `01` Ship to cardholder billing address
	 * - `02` Ship to another verified address on file with merchant
	 * - `03` Ship to address that is different than billing address
	 * - `04` Ship to store (store address should be populated on request)
	 * - `05` Digital goods
	 * - `06` Travel and event tickets, not shipped
	 * - `07` Other
	 * @property {string} [productCode] The 3-letter string representing the merchant product code. Possible values:
	 * - `AIR` Airline
	 * - `GEN` General Retail
	 * - `DIG` Digital Goods
	 * - `SVC` Services
	 * - `RES` Restaurant
	 * - `TRA` Travel
	 * - `DSP` Cash Dispensing
	 * - `REN` Car Rental
	 * - `GAS` Fueld
	 * - `LUX` Luxury Retail
	 * - `ACC` Accommodation Retail
	 * - `TBD` Other
	 * @property {number} [deliveryTimeframe] The 2-digit number indicating the delivery timeframe. Possible values:
	 * - `01` Electronic delivery
	 * - `02` Same day shipping
	 * - `03` Overnight shipping
	 * - `04` Two or more day shipping
	 * @property {string} [deliveryEmail] For electronic delivery, email address to which the merchandise was delivered.
	 * @property {number} [reorderindicator] The 2-digit number indicating whether the cardholder is reordering previously purchased merchandise. possible values:
	 * - `01` First time ordered
	 * - `02` Reordered
	 * @property {number} [preorderIndicator] The 2-digit number indicating whether cardholder is placing an order with a future availability or release date. possible values:
	 * - `01` Merchandise available
	 * - `02` Future availability
	 * @property {number} [preorderDate] The 8-digit number (format: YYYYMMDD) indicating expected date that a pre-ordered purchase will be available.
	 * @property {number} [giftCardAmount] The purchase amount total for prepaid gift cards in major units.
	 * @property {number} [giftCardCurrencyCode] ISO 4217 currency code for the gift card purchased.
	 * @property {number} [giftCardCount] Total count of individual prepaid gift cards purchased.
	 * @property {number} [accountAgeIndicator] The 2-digit value representing the length of time cardholder has had account. Possible values:
	 * - `01` No Account
	 * - `02` Created during transaction
	 * - `03` Less than 30 days
	 * - `04` 30-60 days
	 * - `05` More than 60 days
	 * @property {number} [accountCreateDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder opened the account.
	 * @property {number} [accountChangeIndicator] The 2-digit value representing the length of time since the last change to the cardholder account. This includes shipping address, new payment account or new user added. Possible values:
	 * - `01` Changed during transaction
	 * - `02` Less than 30 days
	 * - `03` 30-60 days
	 * - `04` More than 60 days
	 * @property {number} [accountChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder's account was last changed. This includes changes to the billing or shipping address, new payment accounts or new users added.
	 * @property {number} [accountPwdChangeIndicator] The 2-digit value representing the length of time since the cardholder changed or reset the password on the account. Possible values:
	 * - `01` No change
	 * - `02` Changed during transaction
	 * - `03` Less than 30 days
	 * - `04` 30-60 days
	 * - `05` More than 60 days
	 * @property {number} [accountPwdChangeDate] The 8-digit number (format: YYYYMMDD) indicating the date the cardholder last changed or reset password on account.
	 * @property {number} [shippingAddressUsageIndicator] The 2-digit value indicating when the shipping address used for transaction was first used. Possible values:
	 * - `01` This transaction
	 * - `02` Less than 30 days
	 * - `03` 30-60 days
	 * - `04` More than 60 days
	 * @property {number} [shippingAddressUsageDate] The 8-digit number (format: YYYYMMDD) indicating the date when the shipping address used for this transaction was first used.
	 * @property {number} [transactionCountDay] Number of transactions (successful or abandoned) for this cardholder account within the last 24 hours.
	 * @property {number} [transactionCountYear] Number of transactions (successful or abandoned) for this cardholder account within the last year.
	 * @property {number} [addCardAttempts] Number of add card attempts in the last 24 hours.
	 * @property {number} [accountPurchases] Number of purchases with this cardholder account during the previous six months.
	 * @property {number} [fraudActivity] The 2-digit value indicating whether the merchant experienced suspicious activity (including previous fraud) on the account. Possible values:
	 * - `01` No suspicious activity
	 * - `02` Suspicious activity observed
	 * @property {number} [shippingNameIndicator] The 2-digit value indicating if the cardholder name on the account is identical to the shipping name used for the transaction. Possible values:
	 * - `01` Account and shipping name identical
	 * - `02` Account and shipping name differ
	 * @property {number} [paymentAccountIndicator] The 2-digit value indicating the length of time that the payment account was enrolled in the merchant account. Possible values:
	 * - `01` No account (guest checkout)
	 * - `02` During the transaction
	 * - `03` Less than 30 days
	 * - `04` 30-60 days
	 * - `05` More than 60 days
	 * @property {number} [paymentAccountAge] The 8-digit number (format: YYYYMMDD) indicating the date the payment account was added to the cardholder account.
	 * @property {number} [acsWindowSize] The 2-digit number to set the challenge window size to display to the end cardholder.  The ACS will reply with content that is formatted appropriately to this window size to allow for the best user experience.  The sizes are width x height in pixels of the window displayed in the cardholder browser window. Possible values:
	 * - `01` 250x400
	 * - `02` 390x400
	 * - `03` 500x600
	 * - `04` 600x400
	 * - `05` Full page
	 * @property {number} [sdkMaxTimeout] The 2-digit number of minutes (minimum 05) to set the maximum amount of time for all 3DS 2.0 messages to be communicated between all components.
	 * @property {number} [addressMatch] The 1-character value (Y/N) indicating whether cardholder billing and shipping addresses match.
	 * @property {string} [accountId] Additional cardholder account information.
	 * @property {string} [ipAddress] The IP address of the consumer. IPv4 and IPv6 are supported.
	 * @property {string} [orderDescription] Brief description of items purchased.
	 * @property {number} [taxAmount] Unformatted tax amount without any decimalization (ie. $123.67 = 12367).
	 * @property {string} [userAgent] The exact content of the HTTP user agent header.
	 * @property {number} [authenticationIndicator] The 2-digit number indicating the type of authentication request. This field is required if a recurring or installment transaction request. Possible values:
	 *  - `02` Recurring
	 *  - `03` Installment
	 * @property {number} [installment] An integer value greater than 1 indicating the maximum number of permitted authorizations for installment payments. Required for recurring and installement transaction requests.
	 * @property {number} [purchaseDate] The 14-digit number (format: YYYYMMDDHHMMSS) indicating the date in UTC of original purchase. Required for recurring and installement transaction requests.
	 * @property {number} [recurringEnd] The 8-digit number (format: YYYYMMDD) indicating the date after which no further recurring authorizations should be performed. Required for recurring and installement transaction requests.
	 * @property {number} [recurringFrequency] Integer value indicating the minimum number of days between recurring authorizations. A frequency of monthly is indicated by the value 28. Multiple of 28 days will be used to indicate months (ex. 6 months = 168). Required for recurring and installement transaction requests.
	 */
	
	/**
	 * @class
	 * @param {object} options 3D Secure {@link module:braintree-web/three-d-secure.create create} options
	 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create} instead.</strong>
	 * @classdesc This class represents a ThreeDSecure component produced by {@link module:braintree-web/three-d-secure.create|braintree.threeDSecure.create}. Instances of this class have a method for launching a 3D Secure authentication flow.
	 *
	 * **Note**: 3D Secure 2.0 is documented below and will become the default integration method in a future version of Braintree-web. Until then, version 1.0 will continue to be supported. To view 3D Secure 1.0 documentation, look at Braintree-web documentation from version [3.40.0](https://braintree.github.io/braintree-web/3.40.0/ThreeDSecure.html) and earlier, or upgrade your integration by referring to the [3D Secure 2.0 adoption guide](https://developers.braintreepayments.com/guides/3d-secure/migration/javascript/v3).
	 */
	function ThreeDSecure(options) {
	  this._options = options;
	  this._assetsUrl = options.client.getConfiguration().gatewayConfiguration.assetsUrl + '/web/' + VERSION;
	  this._isDebug = options.client.getConfiguration().isDebug;
	  this._client = options.client;
	  this._clientMetadata = {
	    sdkVersion: PLATFORM + '/' + VERSION,
	    requestedThreeDSecureVersion: this._usesSongbirdFlow() ? '2' : '1'
	  };
	}
	
	/**
	 * Launch the 3D Secure login flow, returning a nonce payload.
	 *
	 * @public
	 * @param {object} options Options for card verification.
	 * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
	 * @param {string} options.bin The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`.
	 * @param {number} options.amount The amount of the transaction in the current merchant account's currency. For example, if you are running a transaction of $123.45 US dollars, `amount` would be 123.45.
	 * @param {boolean} [options.challengeRequested] If set to true, an authentication challenge will be forced if possible.
	 * @param {boolean} [options.exemptionRequested] If set to true, an exemption to the authentication challenge will be requested.
	 * @param {function} options.onLookupComplete Function to execute when lookup completes. The first argument, `data`, is a {@link ThreeDSecure~verificationData|verificationData} object, and the second argument, `next`, is a callback. `next` must be called to continue.
	 * @param {string} [options.email] The email used for verification.
	 * @param {string} [options.mobilePhoneNumber] The mobile phone number used for verification. Only numbers; remove dashes, paranthesis and other characters.
	 * @param {object} [options.billingAddress] An {@link ThreeDSecure~billingAddress|billingAddress} object for verification.
	 * @param {object} [options.additionalInformation] An {@link ThreeDSecure~additionalInformation|additionalInformation} object for verification.
	 * @param {object} [options.customer] **Deprecated** Customer information for use in 3DS 1.0 verifications. Can contain any subset of a {@link ThreeDSecure~verifyCardCustomerObject|verifyCardCustomerObject}. Only to be used for 3DS 1.0 integrations.
	 * @param {callback} options.addFrame **Deprecated** This {@link ThreeDSecure~addFrameCallback|addFrameCallback} will be called when the bank frame needs to be added to your page. Only to be used for 3DS 1.0 integrations.
	 * @param {callback} options.removeFrame **Deprecated** For use in 3DS 1.0 Flows. This {@link ThreeDSecure~removeFrameCallback|removeFrameCallback} will be called when the bank frame needs to be removed from your page. Only to be used in 3DS 1.0 integrations.
	 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~verifyPayload|verifyPayload}.
	
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * <caption>Verifying a payment method nonce with 3DS 2.0</caption>
	 * var my3DSContainer;
	 *
	 * threeDSecure.verifyCard({
	 *   amount: '123.45',
	 *   nonce: hostedFieldsTokenizationPayload.nonce,
	 *   bin: hostedFieldsTokenizationPayload.details.bin,
	 *   email: 'test@example.com'
	 *   billingAddress: {
	 *     givenName: 'Jill',
	 *     surname: 'Doe',
	 *     phoneNumber: '8101234567',
	 *     streetAddress: '555 Smith St.',
	 *     extendedAddress: '#5',
	 *     locality: 'Oakland',
	 *     region: 'CA',
	 *     postalCode: '12345',
	 *     countryCodeAlpha2: 'US'
	 *   },
	 *   additionalInformation: {
	 *     workPhoneNumber: '5555555555',
	 *     shippingGivenName: 'Jill',
	 *     shippingSurname: 'Doe',
	 *     shippingAddress: {
	 *       streetAddress: '555 Smith st',
	 *       extendedAddress: '#5',
	 *       locality: 'Oakland',
	 *       region: 'CA',
	 *       postalCode: '12345',
	 *       countryCodeAlpha2: 'US'
	 *     }
	 *     shippingPhone: '8101234567'
	 *   },
	 *   onLookupComplete: function (data, next) {
	 *     // use `data` here, then call `next()`
	 *     next();
	 *   }
	 * }, function (err, payload) {
	 *   if (err) {
	 *     console.error(err);
	 *     return;
	 *   }
	 *
	 *   if (payload.liabilityShifted) {
	 *     // Liablity has shifted
	 *     submitNonceToServer(payload.nonce);
	 *   } else if (payload.liabilityShiftPossible) {
	 *     // Liablity may still be shifted
	 *     // Decide if you want to submit the nonce
	 *   } else {
	 *     // Liablity has not shifted and will not shift
	 *     // Decide if you want to submit the nonce
	 *   }
	 * });
	 * @example
	 * <caption>Deprecated: Verifying an existing nonce with 3DS 1.0</caption>
	 * var my3DSContainer;
	 *
	 * threeDSecure.verifyCard({
	 *   nonce: existingNonce,
	 *   amount: 123.45,
	 *   addFrame: function (err, iframe) {
	 *     // Set up your UI and add the iframe.
	 *     my3DSContainer = document.createElement('div');
	 *     my3DSContainer.appendChild(iframe);
	 *     document.body.appendChild(my3DSContainer);
	 *   },
	 *   removeFrame: function () {
	 *     // Remove UI that you added in addFrame.
	 *     document.body.removeChild(my3DSContainer);
	 *   }
	 * }, function (err, payload) {
	 *   if (err) {
	 *     console.error(err);
	 *     return;
	 *   }
	 *
	 *   if (payload.liabilityShifted) {
	 *     // Liablity has shifted
	 *     submitNonceToServer(payload.nonce);
	 *   } else if (payload.liabilityShiftPossible) {
	 *     // Liablity may still be shifted
	 *     // Decide if you want to submit the nonce
	 *   } else {
	 *     // Liablity has not shifted and will not shift
	 *     // Decide if you want to submit the nonce
	 *   }
	 * });
	 */
	ThreeDSecure.prototype.verifyCard = function (options) {
	  var data,
	    showLoader,
	    addFrame,
	    removeFrame,
	    onLookupComplete,
	    error,
	    nonce;
	  var promise = Promise.resolve();
	  var additionalInformation = options.additionalInformation || {};
	  var self = this;
	
	  options = assign({}, options);
	
	  error = this._checkForVerifyCardError(options);
	
	  if (error) {
	    return Promise.reject(error);
	  }
	
	  showLoader = options.showLoader !== false;
	
	  this._verifyCardInProgress = true;
	
	  data = {
	    amount: options.amount
	  };
	
	  nonce = options.nonce;
	
	  if (this._usesSongbirdFlow()) {
	    onLookupComplete = deferred(options.onLookupComplete);
	    additionalInformation = this._transformBillingAddress(additionalInformation, options.billingAddress);
	    additionalInformation = this._transformShippingAddress(additionalInformation);
	    if (options.email) {
	      additionalInformation.email = options.email;
	    }
	    if (options.mobilePhoneNumber) {
	      additionalInformation.mobilePhoneNumber = options.mobilePhoneNumber;
	    }
	
	    data.additionalInfo = additionalInformation;
	
	    if (options.challengeRequested) {
	      data.challengeRequested = options.challengeRequested;
	    }
	    if (options.exemptionRequested) {
	      data.exemptionRequested = options.exemptionRequested;
	    }
	
	    promise = this._prepareRawLookup(data).then(function (transformedData) {
	      data = transformedData;
	    });
	  } else {
	    addFrame = deferred(options.addFrame);
	    removeFrame = deferred(options.removeFrame);
	    if (options.customer && options.customer.billingAddress) {
	      options.customer = this._transformV1CustomerBillingAddress(options.customer);
	      data.customer = options.customer;
	    }
	  }
	
	  analytics.sendEvent(this._options.client, 'three-d-secure.verification-flow.started');
	
	  return promise.then(function () {
	    var url = 'payment_methods/' + nonce + '/three_d_secure/lookup';
	
	    return self._client.request({
	      endpoint: url,
	      method: 'post',
	      data: data
	    });
	  }).then(function (response) {
	    analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.3ds-version.' + response.lookup.threeDSecureVersion);
	
	    return self._initializeChallengeWithLookupResponse(response, {
	      showLoader: showLoader,
	      addFrame: addFrame,
	      removeFrame: removeFrame,
	      onLookupComplete: onLookupComplete
	    });
	  }).then(function (payload) {
	    analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.completed');
	
	    return payload;
	  }).catch(function (err) {
	    self._verifyCardInProgress = false;
	
	    analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.failed');
	
	    return Promise.reject(err);
	  });
	};
	
	ThreeDSecure.prototype._checkForVerifyCardError = function (options) {
	  var errorOption;
	
	  if (this._verifyCardBlockingError) {
	    return this._verifyCardBlockingError;
	  } else if (this._verifyCardInProgress === true) {
	    return new BraintreeError(errors.THREEDS_AUTHENTICATION_IN_PROGRESS);
	  } else if (!options.nonce) {
	    errorOption = 'a nonce';
	  } else if (!options.amount) {
	    errorOption = 'an amount';
	  }
	
	  if (!errorOption) {
	    if (this._usesSongbirdFlow()) {
	      if (typeof options.onLookupComplete !== 'function') {
	        errorOption = 'an onLookupComplete function';
	      }
	    } else if (typeof options.addFrame !== 'function') {
	      errorOption = 'an addFrame function';
	    } else if (typeof options.removeFrame !== 'function') {
	      errorOption = 'a removeFrame function';
	    }
	  }
	
	  if (errorOption) {
	    return new BraintreeError({
	      type: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.type,
	      code: errors.THREEDS_MISSING_VERIFY_CARD_OPTION.code,
	      message: 'verifyCard options must include ' + errorOption + '.'
	    });
	  }
	
	  return null;
	};
	
	/* eslint-disable-next-line valid-jsdoc */
	/**
	 * Launch the iframe challenge using a 3D Secure lookup response from a server side lookup.
	 *
	 * @public
	 * @param {object} lookupResponse The lookup response from the server side call to lookup the 3D Secure information.
	 * @returns {Promise} Returns a promise.
	 * @example
	 * var my3DSContainer;
	 *
	 * threeDSecure.initializeChallengeWithLookupResponse(lookupResponseFromServer).then(function (payload) {
	 *   if (payload.liabilityShifted) {
	 *     // Liablity has shifted
	 *     submitNonceToServer(payload.nonce);
	 *   } else if (payload.liabilityShiftPossible) {
	 *     // Liablity may still be shifted
	 *     // Decide if you want to submit the nonce
	 *   } else {
	 *     // Liablity has not shifted and will not shift
	 *     // Decide if you want to submit the nonce
	 *   }
	 * });
	 */
	ThreeDSecure.prototype.initializeChallengeWithLookupResponse = function (lookupResponse) {
	  return this._initializeChallengeWithLookupResponse(lookupResponse);
	};
	
	// private version of the public method that allows additional options to be passed
	ThreeDSecure.prototype._initializeChallengeWithLookupResponse = function (lookupResponse, options) {
	  var self = this;
	
	  options = options || {};
	
	  this._lookupPaymentMethod = lookupResponse.paymentMethod;
	
	  return new Promise(function (resolve, reject) {
	    self._verifyCardCallback = function (verifyErr, payload) {
	      self._verifyCardInProgress = false;
	
	      if (verifyErr) {
	        reject(verifyErr);
	      } else {
	        analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.liability-shifted.' + String(payload.liabilityShifted));
	        analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.liability-shift-possible.' + String(payload.liabilityShiftPossible));
	
	        resolve(payload);
	      }
	    };
	    self._handleLookupResponse({
	      showLoader: options.showLoader,
	      lookupResponse: lookupResponse,
	      addFrame: options.addFrame,
	      removeFrame: options.removeFrame,
	      onLookupComplete: options.onLookupComplete
	    });
	  });
	};
	
	/**
	 * Gather the data needed for a 3D Secure lookup call.
	 *
	 * @public
	 * @param {object} options Options for 3D Secure lookup.
	 * @param {string} options.nonce The nonce representing the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.nonce`.
	 * @param {string} [options.bin] The numeric Bank Identification Number (bin) of the card from a tokenization payload. For example, this can be a {@link HostedFields~tokenizePayload|tokenizePayload} returned by Hosted Fields under `payload.details.bin`. Though not required to start the verification, it is required to receive a 3DS 2.0 lookup response.
	 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}. If no callback is provided, it will return a promise that resolves {@link ThreeDSecure~prepareLookupPayload|prepareLookupPayload}.
	
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * <caption>Preparing data for a 3D Secure lookup</caption>
	 * threeDSecure.prepareLookup({
	 *   nonce: hostedFieldsTokenizationPayload.nonce,
	 *   bin: hostedFieldsTokenizationPayload.details.bin
	 * }, function (err, payload) {
	 *   if (err) {
	 *     console.error(err);
	 *     return;
	 *   }
	 *
	 *   // send payload to server to do server side lookup
	 * });
	 */
	ThreeDSecure.prototype.prepareLookup = function (options) {
	  return this._prepareRawLookup(options).then(function (result) {
	    return JSON.stringify(result);
	  });
	};
	
	ThreeDSecure.prototype._prepareRawLookup = function (options) {
	  var data = assign({}, options);
	  var self = this;
	
	  return this._getDfReferenceId().then(function (id) {
	    data.dfReferenceId = id;
	  }).then(function () {
	    return self._triggerCardinalBinProcess(options.bin);
	  }).catch(function () {
	    // catch and ignore errors from looking up
	    // df reference and Cardinal bin process
	  }).then(function () {
	    data.clientMetadata = self._clientMetadata;
	    data.authorizationFingerprint = self._client.getConfiguration().authorizationFingerprint;
	    data.braintreeLibraryVersion = 'braintree/web/' + VERSION;
	
	    return data;
	  });
	};
	
	ThreeDSecure.prototype._triggerCardinalBinProcess = function (bin) {
	  var self = this;
	  var issuerStartTime = Date.now();
	
	  if (!bin) {
	    // skip bin lookup because bin wasn't passed in
	    return Promise.resolve();
	  }
	
	  return global.Cardinal.trigger('bin.process', bin).then(function (binResults) {
	    self._clientMetadata.issuerDeviceDataCollectionTimeElapsed = Date.now() - issuerStartTime;
	    self._clientMetadata.issuerDeviceDataCollectionResult = binResults && binResults.Status;
	  });
	};
	
	/**
	 * Cancel the 3DS flow and return the verification payload if available.
	 * @public
	 * @param {callback} [callback] The second argument is a {@link ThreeDSecure~verifyPayload|verifyPayload}. If there is no verifyPayload (the initial lookup did not complete), an error will be returned. If no callback is passed, `cancelVerifyCard` will return a promise.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * threeDSecure.cancelVerifyCard(function (err, verifyPayload) {
	 *   if (err) {
	 *     // Handle error
	 *     console.log(err.message); // No verification payload available
	 *     return;
	 *   }
	 *
	 *   verifyPayload.nonce; // The nonce returned from the 3ds lookup call
	 *   verifyPayload.liabilityShifted; // boolean
	 *   verifyPayload.liabilityShiftPossible; // boolean
	 * });
	 */
	ThreeDSecure.prototype.cancelVerifyCard = function () {
	  var response;
	
	  if (this._usesSongbirdFlow()) {
	    return Promise.reject(new BraintreeError({
	      type: errors.THREEDS_METHOD_DEPRECATED.type,
	      code: errors.THREEDS_METHOD_DEPRECATED.code,
	      message: 'cancelVerifyCard can not be used with 3D Secure v2.'
	    }));
	  }
	  this._verifyCardInProgress = false;
	
	  if (!this._lookupPaymentMethod) {
	    return Promise.reject(new BraintreeError(errors.THREEDS_NO_VERIFICATION_PAYLOAD));
	  }
	
	  response = assign({}, this._lookupPaymentMethod, {
	    liabilityShiftPossible: this._lookupPaymentMethod.threeDSecureInfo.liabilityShiftPossible,
	    liabilityShifted: this._lookupPaymentMethod.threeDSecureInfo.liabilityShifted,
	    verificationDetails: this._lookupPaymentMethod.threeDSecureInfo.verificationDetails
	  });
	
	  return Promise.resolve(response);
	};
	
	ThreeDSecure.prototype._handleLookupResponse = function (options) {
	  var details;
	  var self = this;
	  var lookupResponse = options.lookupResponse;
	
	  options.onLookupComplete = options.onLookupComplete || function (data, next) {
	    next();
	  };
	
	  options.onLookupComplete(lookupResponse, function () {
	    var challengePresented = Boolean(lookupResponse.lookup && lookupResponse.lookup.acsUrl);
	
	    analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.challenge-presented.' + String(challengePresented));
	
	    if (challengePresented) {
	      if (self._usesSongbirdFlow()) {
	        // set up listener for ref id to call out to bt before calling verify callback
	        global.Cardinal.continue('cca',
	          {
	            AcsUrl: lookupResponse.lookup.acsUrl,
	            Payload: lookupResponse.lookup.pareq
	          },
	          {
	            OrderDetails: {TransactionId: lookupResponse.lookup.transactionId}
	          }
	        );
	      } else {
	        // fallback to old iframe flow:
	        options.addFrame(null, self._createIframe({
	          showLoader: options.showLoader,
	          response: lookupResponse.lookup,
	          removeFrame: options.removeFrame
	        }));
	      }
	    } else {
	      details = self._formatAuthResponse(lookupResponse.paymentMethod, lookupResponse.threeDSecureInfo);
	      details.verificationDetails = lookupResponse.threeDSecureInfo;
	
	      self._verifyCardCallback(null, details);
	    }
	  });
	};
	
	ThreeDSecure.prototype._transformV1CustomerBillingAddress = function (customer) {
	  customer.billingAddress.line1 = customer.billingAddress.streetAddress;
	  customer.billingAddress.line2 = customer.billingAddress.extendedAddress;
	  customer.billingAddress.city = customer.billingAddress.locality;
	  customer.billingAddress.state = customer.billingAddress.region;
	  customer.billingAddress.countryCode = customer.billingAddress.countryCodeAlpha2;
	  delete customer.billingAddress.streetAddress;
	  delete customer.billingAddress.extendedAddress;
	  delete customer.billingAddress.locality;
	  delete customer.billingAddress.region;
	  delete customer.billingAddress.countryCodeAlpha2;
	
	  return customer;
	};
	
	ThreeDSecure.prototype._transformBillingAddress = function (additionalInformation, billingAddress) {
	  if (billingAddress) {
	    // map from public API to the API that the Gateway expects
	    additionalInformation.billingLine1 = billingAddress.streetAddress;
	    additionalInformation.billingLine2 = billingAddress.extendedAddress;
	    additionalInformation.billingLine3 = billingAddress.line3;
	    additionalInformation.billingCity = billingAddress.locality;
	    additionalInformation.billingState = billingAddress.region;
	    additionalInformation.billingPostalCode = billingAddress.postalCode;
	    additionalInformation.billingCountryCode = billingAddress.countryCodeAlpha2;
	    additionalInformation.billingPhoneNumber = billingAddress.phoneNumber;
	    additionalInformation.billingGivenName = billingAddress.givenName;
	    additionalInformation.billingSurname = billingAddress.surname;
	  }
	
	  return additionalInformation;
	};
	
	ThreeDSecure.prototype._transformShippingAddress = function (additionalInformation) {
	  var shippingAddress = additionalInformation.shippingAddress;
	
	  if (shippingAddress) {
	    // map from public API to the API that the Gateway expects
	    additionalInformation.shippingLine1 = shippingAddress.streetAddress;
	    additionalInformation.shippingLine2 = shippingAddress.extendedAddress;
	    additionalInformation.shippingLine3 = shippingAddress.line3;
	    additionalInformation.shippingCity = shippingAddress.locality;
	    additionalInformation.shippingState = shippingAddress.region;
	    additionalInformation.shippingPostalCode = shippingAddress.postalCode;
	    additionalInformation.shippingCountryCode = shippingAddress.countryCodeAlpha2;
	
	    delete additionalInformation.shippingAddress;
	  }
	
	  return additionalInformation;
	};
	
	ThreeDSecure.prototype._createIframe = function (options) {
	  var url,
	    authenticationCompleteBaseUrl;
	  var parentURL = window.location.href;
	  var response = options.response;
	
	  this._bus = new Bus({
	    channel: uuid(),
	    merchantUrl: location.href
	  });
	
	  authenticationCompleteBaseUrl = this._assetsUrl + '/html/three-d-secure-authentication-complete-frame.html?channel=' + encodeURIComponent(this._bus.channel) + '&';
	
	  if (parentURL.indexOf('#') > -1) {
	    parentURL = parentURL.split('#')[0];
	  }
	
	  this._bus.on(Bus.events.CONFIGURATION_REQUEST, function (reply) {
	    reply({
	      acsUrl: response.acsUrl,
	      pareq: response.pareq,
	      termUrl: response.termUrl + '&three_d_secure_version=' + VERSION + '&authentication_complete_base_url=' + encodeURIComponent(authenticationCompleteBaseUrl),
	      md: response.md,
	      parentUrl: parentURL
	    });
	  });
	
	  this._bus.on(events.AUTHENTICATION_COMPLETE, function (data) {
	    this._handleAuthResponse(data, options);
	  }.bind(this));
	
	  url = this._assetsUrl + '/html/three-d-secure-bank-frame' + useMin(this._isDebug) + '.html?showLoader=' + options.showLoader;
	
	  this._bankIframe = iFramer({
	    src: url,
	    height: IFRAME_HEIGHT,
	    width: IFRAME_WIDTH,
	    name: constants.LANDING_FRAME_NAME + '_' + this._bus.channel,
	    title: '3D Secure Authorization Frame'
	  });
	
	  return this._bankIframe;
	};
	
	ThreeDSecure.prototype._handleAuthResponse = function (data, options) {
	  var authResponse = JSON.parse(data.auth_response);
	
	  this._bus.teardown();
	
	  options.removeFrame();
	
	  // This also has to be in a setTimeout so it executes after the `removeFrame`.
	  deferred(function () {
	    if (authResponse.success) {
	      this._verifyCardCallback(null, this._formatAuthResponse(authResponse.paymentMethod, authResponse.threeDSecureInfo));
	    } else if (authResponse.threeDSecureInfo && authResponse.threeDSecureInfo.liabilityShiftPossible) {
	      this._verifyCardCallback(null, this._formatAuthResponse(this._lookupPaymentMethod, authResponse.threeDSecureInfo));
	    } else {
	      this._verifyCardCallback(new BraintreeError({
	        type: BraintreeError.types.UNKNOWN,
	        code: 'UNKNOWN_AUTH_RESPONSE',
	        message: authResponse.error.message
	      }));
	    }
	  }.bind(this))();
	};
	
	ThreeDSecure.prototype._formatAuthResponse = function (paymentMethod, threeDSecureInfo) {
	  return {
	    nonce: paymentMethod.nonce,
	    binData: paymentMethod.binData,
	    details: paymentMethod.details,
	    description: paymentMethod.description && paymentMethod.description.replace(/\+/g, ' '),
	    liabilityShifted: threeDSecureInfo && threeDSecureInfo.liabilityShifted,
	    liabilityShiftPossible: threeDSecureInfo && threeDSecureInfo.liabilityShiftPossible
	  };
	};
	
	/**
	 * Cleanly remove anything set up by {@link module:braintree-web/three-d-secure.create|create}.
	 * @public
	 * @param {callback} [callback] Called on completion. If no callback is passed, `teardown` will return a promise.
	 * @example
	 * threeDSecure.teardown();
	 * @example <caption>With callback</caption>
	 * threeDSecure.teardown(function () {
	 *   // teardown is complete
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	ThreeDSecure.prototype.teardown = function () {
	  convertMethodsToError(this, methods(ThreeDSecure.prototype));
	
	  analytics.sendEvent(this._options.client, 'three-d-secure.teardown-completed');
	
	  if (this._bus) {
	    this._bus.teardown();
	  }
	
	  if (this._bankIframe && this._bankIframe.parentNode) {
	    this._bankIframe.parentNode.removeChild(this._bankIframe);
	  }
	
	  if (global.Cardinal) {
	    global.Cardinal.off('payments.setupComplete');
	    global.Cardinal.off('payments.validated');
	  }
	
	  return Promise.resolve();
	};
	
	ThreeDSecure.prototype._usesSongbirdFlow = function () {
	  return this._options.version === 2;
	};
	
	ThreeDSecure.prototype._createPaymentsSetupCompleteCallback = function (resolve, timeoutReference) {
	  var self = this;
	
	  return function (data) {
	    if (self._getDfReferenceIdPromise) {
	      self._getDfReferenceIdResolveFunction(data.sessionId);
	    } else {
	      self._getDfReferenceIdPromise = Promise.resolve(data.sessionId);
	    }
	
	    global.clearTimeout(timeoutReference);
	    analytics.sendEvent(self._client, 'three-d-secure.cardinal-sdk.init.setup-completed');
	    resolve();
	  };
	};
	
	ThreeDSecure.prototype._createPaymentsValidatedCallback = function () {
	  var self = this;
	
	  /**
	   * @param {object} data Response Data
	   * @see {@link https://cardinaldocs.atlassian.net/wiki/spaces/CC/pages/98315/Response+Objects#ResponseObjects-ObjectDefinition}
	   * @param {string} data.ActionCode The resulting state of the transaction.
	   * @param {boolean} data.Validated Represents whether transaction was successfully or not.
	   * @param {number} data.ErrorNumber A non-zero value represents the error encountered while attempting the process the message request.
	   * @param {string} data.ErrorDescription Application error description for the associated error number.
	   * @param {string} validatedJwt Response JWT
	   * @returns {void}
	   * */
	  return function (data, validatedJwt) {
	    var formattedError = '';
	
	    analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.cardinal-sdk.action-code.' + data.ActionCode.toLowerCase());
	
	    switch (data.ActionCode) {
	      // Handle these scenarios based on liability shift information in the response.
	      case 'SUCCESS':
	      case 'NOACTION':
	      case 'FAILURE':
	        self._performJWTValidation(validatedJwt).then(function (payload) {
	          self._verifyCardCallback(null, payload);
	        }).catch(function (err) {
	          self._verifyCardCallback(err);
	        });
	        break;
	
	      case 'ERROR':
	        switch (data.ErrorNumber) {
	          case 10001:
	          case 10002:
	            formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT);
	            break;
	          case 10003:
	          case 10007:
	          case 10009:
	            formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT);
	            break;
	          case 10005:
	          case 10006:
	            formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_BAD_CONFIG);
	            break;
	          case 10008:
	          case 10010:
	            formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_BAD_JWT);
	            break;
	          case 10011:
	            analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.canceled');
	            formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_CANCELED);
	            break;
	          case 10004:
	          case 10012:
	          default:
	            formattedError = new BraintreeError(errors.THREEDS_CARDINAL_SDK_ERROR);
	        }
	
	        formattedError.details = {
	          originalError: {
	            code: data.ErrorNumber,
	            description: data.ErrorDescription
	          }
	        };
	
	        if (self._verifyCardCallback) {
	          self._verifyCardCallback(formattedError, null);
	        } else {
	          self._verifyCardBlockingError = formattedError;
	        }
	        break;
	
	      default:
	    }
	  };
	};
	
	ThreeDSecure.prototype._setupSongbird = function (setupOptions) {
	  var self = this;
	  var scriptSource = constants.CARDINAL_SCRIPT_SOURCE.sandbox;
	  var jwt = this._client.getConfiguration().gatewayConfiguration.threeDSecure.cardinalAuthenticationJWT;
	  var startTime = Date.now();
	
	  setupOptions = setupOptions || {};
	
	  return new Promise(function (resolve, reject) {
	    var timeoutReference = global.setTimeout(function () {
	      analytics.sendEvent(self._client, 'three-d-secure.cardinal-sdk.init.setup-timeout');
	      reject(new BraintreeError(errors.THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT));
	    }, setupOptions.timeout || INTEGRATION_TIMEOUT_MS);
	
	    if (setupOptions.isProduction) {
	      scriptSource = constants.CARDINAL_SCRIPT_SOURCE.production;
	    }
	    assets.loadScript({src: scriptSource}).catch(function (err) {
	      return Promise.reject(convertToBraintreeError(err, errors.THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED));
	    }).then(function (script) {
	      self._cardinalScript = script;
	      global.Cardinal.on('payments.setupComplete', self._createPaymentsSetupCompleteCallback(resolve, timeoutReference));
	
	      if (setupOptions.loggingEnabled) {
	        global.Cardinal.configure({
	          logging: {
	            level: 'verbose'
	          }
	        });
	      }
	
	      global.Cardinal.setup('init', {
	        jwt: jwt
	      });
	
	      self._clientMetadata.cardinalDeviceDataCollectionTimeElapsed = Date.now() - startTime;
	
	      global.Cardinal.on('payments.validated', self._createPaymentsValidatedCallback());
	    }).catch(function (err) {
	      var error = convertToBraintreeError(err, {
	        type: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.type,
	        code: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.code,
	        message: errors.THREEDS_CARDINAL_SDK_SETUP_FAILED.message
	      });
	
	      if (self._getDfReferenceIdPromise) {
	        self._getDfReferenceIdRejectFunction(error);
	      } else {
	        self._getDfReferenceIdError = error;
	      }
	
	      global.clearTimeout(timeoutReference);
	      analytics.sendEvent(self._client, 'three-d-secure.cardinal-sdk.init.setup-failed');
	      reject(error);
	    });
	  });
	};
	
	ThreeDSecure.prototype._getDfReferenceId = function () {
	  if (this._getDfReferenceIdError) {
	    return Promise.reject(this._getDfReferenceIdError);
	  }
	
	  if (!this._getDfReferenceIdPromise) {
	    this._getDfReferenceIdPromise = new Promise(function (resolve, reject) {
	      this._getDfReferenceIdResolveFunction = resolve;
	      this._getDfReferenceIdRejectFunction = reject;
	    }.bind(this));
	  }
	
	  return this._getDfReferenceIdPromise;
	};
	
	ThreeDSecure.prototype._performJWTValidation = function (jwt) {
	  var nonce = this._lookupPaymentMethod.nonce;
	  var url = 'payment_methods/' + nonce + '/three_d_secure/authenticate_from_jwt';
	  var self = this;
	
	  analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.upgrade-payment-method.started');
	
	  return this._client.request({
	    method: 'post',
	    endpoint: url,
	    data: {
	      jwt: jwt,
	      paymentMethodNonce: nonce
	    }
	  }).then(function (response) {
	    var paymentMethod = response.paymentMethod || self._lookupPaymentMethod;
	    var formattedResponse = self._formatAuthResponse(paymentMethod, response.threeDSecureInfo);
	
	    analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.upgrade-payment-method.succeeded');
	
	    return Promise.resolve(formattedResponse);
	  }).catch(function (err) {
	    var error = new BraintreeError({
	      type: errors.THREEDS_JWT_AUTHENTICATION_FAILED.type,
	      code: errors.THREEDS_JWT_AUTHENTICATION_FAILED.code,
	      message: errors.THREEDS_JWT_AUTHENTICATION_FAILED.message,
	      details: {
	        originalError: err
	      }
	    });
	
	    analytics.sendEvent(self._options.client, 'three-d-secure.verification-flow.upgrade-payment-method.errored');
	
	    return Promise.reject(error);
	  });
	};
	
	module.exports = wrapPromise.wrapPrototype(ThreeDSecure);
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../../lib/analytics":68,"../../lib/assets":69,"../../lib/assign":70,"../../lib/braintree-error":73,"../../lib/bus":76,"../../lib/constants":77,"../../lib/convert-methods-to-error":78,"../../lib/convert-to-braintree-error":79,"../../lib/deferred":83,"../../lib/methods":93,"../../lib/promise":95,"../../lib/use-min":97,"../../lib/vendor/uuid":99,"../shared/constants":106,"../shared/errors":107,"../shared/events":108,"@braintree/iframer":20,"@braintree/wrap-promise":27}],105:[function(require,module,exports){
	'use strict';
	/** @module braintree-web/three-d-secure */
	
	var ThreeDSecure = require('./external/three-d-secure');
	var isHTTPS = require('../lib/is-https').isHTTPS;
	var basicComponentVerification = require('../lib/basic-component-verification');
	var createDeferredClient = require('../lib/create-deferred-client');
	var createAssetsUrl = require('../lib/create-assets-url');
	var BraintreeError = require('../lib/braintree-error');
	var analytics = require('../lib/analytics');
	var errors = require('./shared/errors');
	var VERSION = "3.47.0";
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	
	/**
	 * @static
	 * @function create
	 * @param {object} options Creation options:
	 * @param {Client} [options.client] A {@link Client} instance.
	 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
	 * @param {number} [options.version=1] The version of 3DS to use. Pass in 2 to use 3DS 2.0.
	 * @param {callback} [callback] The second argument, `data`, is the {@link ThreeDSecure} instance. If no callback is provided, it returns a promise that resolves the {@link ThreeDSecure} instance.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	function create(options) {
	  var name = '3D Secure';
	
	  return basicComponentVerification.verify({
	    name: name,
	    client: options.client,
	    authorization: options.authorization
	  }).then(function () {
	    return createDeferredClient.create({
	      authorization: options.authorization,
	      client: options.client,
	      debug: options.debug,
	      assetsUrl: createAssetsUrl.create(options.authorization),
	      name: name
	    });
	  }).then(function (client) {
	    var error, isProduction, instance;
	    var config = client.getConfiguration();
	    var gwConfig = config.gatewayConfiguration;
	
	    options.client = client;
	
	    if (!gwConfig.threeDSecureEnabled) {
	      error = errors.THREEDS_NOT_ENABLED;
	    }
	
	    if (config.authorizationType === 'TOKENIZATION_KEY') {
	      error = errors.THREEDS_CAN_NOT_USE_TOKENIZATION_KEY;
	    }
	
	    isProduction = gwConfig.environment === 'production';
	
	    if (isProduction && !isHTTPS()) {
	      error = errors.THREEDS_HTTPS_REQUIRED;
	    }
	
	    if (options.version === 2 && !gwConfig.threeDSecure.cardinalAuthenticationJWT) {
	      error = errors.THREEDS_NOT_ENABLED_FOR_V2;
	    }
	
	    if (error) {
	      return Promise.reject(new BraintreeError(error));
	    }
	
	    analytics.sendEvent(options.client, 'three-d-secure.initialized');
	
	    instance = new ThreeDSecure(options);
	
	    if (options.version === 2) {
	      instance._setupSongbird({isProduction: isProduction, loggingEnabled: options.loggingEnabled});
	    }
	
	    return instance;
	  });
	}
	
	module.exports = {
	  create: wrapPromise(create),
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/analytics":68,"../lib/basic-component-verification":71,"../lib/braintree-error":73,"../lib/create-assets-url":80,"../lib/create-deferred-client":82,"../lib/is-https":90,"../lib/promise":95,"./external/three-d-secure":104,"./shared/errors":107,"@braintree/wrap-promise":27}],106:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  LANDING_FRAME_NAME: 'braintreethreedsecurelanding',
	  CARDINAL_SCRIPT_SOURCE: {
	    production: 'https://songbird.cardinalcommerce.com/cardinalcruise/v1/songbird.js',
	    sandbox: 'https://songbirdstag.cardinalcommerce.com/cardinalcruise/v1/songbird.js'
	  }
	};
	
	},{}],107:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.3D Secure - Creation Error Codes
	 * @description Errors that occur when [creating the 3D Secure component](/current/module-braintree-web_three-d-secure.html#.create).
	 * @property {MERCHANT} THREEDS_NOT_ENABLED Occurs when 3D Secure is not enabled in the Braintree control panel.
	 * @property {MERCHANT} THREEDS_CAN_NOT_USE_TOKENIZATION_KEY Occurs when 3D Secure component is created without a Client Token.
	 * @property {MERCHANT} THREEDS_HTTPS_REQUIRED Occurs when 3D Secure component is created in production over HTTPS.
	 * @property {MERCHANT} THREEDS_NOT_ENABLED_FOR_V2 Occurs when 3D Secure component is created with version 2 parameter, but merchant is not enabled to use version 2.
	 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_FAILED Occurs when Cardinal's Songbird.js library fails to setup for an unknown reason.
	 * @property {NETWORK} THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED Occurs when using version 2 and Cardinal's Songbird.js script could not be loaded.
	 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT Occurs when Cardinal's Songbird.js library takes longer than 60 seconds to set up.
	 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT Occurs when Cardinal sends a response indicating a timeout on /Validate, /Confirm, or /Continue.
	 * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_CONFIG Occurs when there is no JWT in the request. Also when there's some other malformed aspect of config.
	 * @property {MERCHANT} THREEDS_CARDINAL_SDK_BAD_JWT Occus when a malformed config causes a either a missing response JWT or a malformed Cardinal response.
	 * @property {UNKNOWN} THREEDS_CARDINAL_SDK_ERROR Occurs when a "general error" or a Cardinal hosted fields error happens. Description contains more details.
	 * @property {CUSTOMER} THREEDS_CARDINAL_SDK_CANCELED Occurs when customer cancels the transaction mid-flow, usually with alt-pays that have their own cancel buttons.
	 */
	
	/**
	 * @name BraintreeError.3D Secure - verifyCard Error Codes
	 * @description Errors that occur when using the [`verifyCard` method](/current/ThreeDSecure.html#verifyCard).
	 * @property {MERCHANT} THREEDS_AUTHENTICATION_IN_PROGRESS Occurs when another verification is already in progress.
	 * @property {MERCHANT} THREEDS_MISSING_VERIFY_CARD_OPTION Occurs when a required option is missing.
	 * @property {UNKNOWN} THREEDS_JWT_AUTHENTICATION_FAILED Occurs when something went wrong authenticating the JWT from the Cardinal SDK.
	 */
	
	/**
	 * @name BraintreeError.3D Secure - cancelVerifyCard Error Codes
	 * @description Errors that occur when using the [`cancelVerifyCard` method](/current/ThreeDSecure.html#cancelVerifyCard).
	 * @property {MERCHANT} THREEDS_NO_VERIFICATION_PAYLOAD Occurs when the 3D Secure flow is canceled, but there is no 3D Secure information available.
	 * @property {MERCHANT} THREEDS_NO_METHOD_DEPRECATED Occurs when `cancelVerifyCard` is called when using 3D Secure version 2.
	 */
	
	/**
	 * @name BraintreeError.3D Secure - Internal Error Codes
	 * @ignore
	 * @description Errors that occur internally
	 * @property {INTERNAL} THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN Occurs when iframe is initialized on a non-verified domain.
	 */
	
	var BraintreeError = require('../../lib/braintree-error');
	
	module.exports = {
	  THREEDS_NOT_ENABLED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_NOT_ENABLED',
	    message: '3D Secure is not enabled for this merchant.'
	  },
	  THREEDS_CAN_NOT_USE_TOKENIZATION_KEY: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_CAN_NOT_USE_TOKENIZATION_KEY',
	    message: '3D Secure can not use a tokenization key for authorization.'
	  },
	  THREEDS_HTTPS_REQUIRED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_HTTPS_REQUIRED',
	    message: '3D Secure requires HTTPS.'
	  },
	  THREEDS_NOT_ENABLED_FOR_V2: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_NOT_ENABLED_FOR_V2',
	    message: '3D Secure version 2 is not enabled for this merchant.'
	  },
	  THREEDS_CARDINAL_SDK_SETUP_FAILED: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'THREEDS_CARDINAL_SDK_SETUP_FAILED',
	    message: 'Something went wrong setting up Cardinal\'s Songbird.js library.'
	  },
	  THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED: {
	    type: BraintreeError.types.NETWORK,
	    code: 'THREEDS_CARDINAL_SDK_SCRIPT_LOAD_FAILED',
	    message: 'Cardinal\'s Songbird.js library could not be loaded.'
	  },
	  THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'THREEDS_CARDINAL_SDK_SETUP_TIMEDOUT',
	    message: 'Cardinal\'s Songbird.js took too long to setup.'
	  },
	  THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'THREEDS_CARDINAL_SDK_RESPONSE_TIMEDOUT',
	    message: 'Cardinal\'s API took too long to respond.'
	  },
	  THREEDS_CARDINAL_SDK_BAD_CONFIG: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_CARDINAL_SDK_BAD_CONFIG',
	    message: 'JWT or other required field missing. Please check your setup configuration.'
	  },
	  THREEDS_CARDINAL_SDK_BAD_JWT: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_CARDINAL_SDK_BAD_JWT',
	    message: 'Cardinal JWT missing or malformed. Please check your setup configuration.'
	  },
	  THREEDS_CARDINAL_SDK_ERROR: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'THREEDS_CARDINAL_SDK_ERROR',
	    message: 'A general error has occurred with Cardinal. See description for more information.'
	  },
	  THREEDS_CARDINAL_SDK_CANCELED: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'THREEDS_CARDINAL_SDK_CANCELED',
	    message: 'Canceled by user.'
	  },
	  THREEDS_AUTHENTICATION_IN_PROGRESS: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_AUTHENTICATION_IN_PROGRESS',
	    message: 'Cannot call verifyCard while existing authentication is in progress.'
	  },
	  THREEDS_MISSING_VERIFY_CARD_OPTION: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_MISSING_VERIFY_CARD_OPTION'
	  },
	  THREEDS_JWT_AUTHENTICATION_FAILED: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'THREEDS_JWT_AUTHENTICATION_FAILED',
	    message: 'Something went wrong authenticating the JWT from Cardinal'
	  },
	  THREEDS_NO_VERIFICATION_PAYLOAD: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_NO_VERIFICATION_PAYLOAD',
	    message: 'No verification payload available.'
	  },
	  THREEDS_METHOD_DEPRECATED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'THREEDS_METHOD_DEPRECATED'
	  },
	  THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN: {
	    type: BraintreeError.types.INTERNAL,
	    code: 'THREEDS_TERM_URL_REQUIRES_BRAINTREE_DOMAIN',
	    message: 'Term Url must be on a Braintree domain.'
	  }
	};
	
	},{"../../lib/braintree-error":73}],108:[function(require,module,exports){
	'use strict';
	
	var enumerate = require('../../lib/enumerate');
	
	module.exports = enumerate([
	  'AUTHENTICATION_COMPLETE'
	], 'threedsecure:');
	
	},{"../../lib/enumerate":85}],109:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.Vault Manager - deletePaymentMethod Error Codes
	 * @description Errors that occur when using the [`deletePaymentMethod` method](/current/VaultManager.html#deletePaymentMethod).
	 * @property {MERCHANT} VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN Occurs when vault manager is initalized with a tokenization key instead of a Client Token.
	 * @property {MERCHANT} VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND Occurs when the specified payment method can not be found.
	 * @property {UNKNOWN} VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR Occurs when there is an error attempting to delete the payment method.
	 */
	
	var BraintreeError = require('../lib/braintree-error');
	
	module.exports = {
	  VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN',
	    message: 'A client token with a customer id must be used to delete a payment method nonce.'
	  },
	  VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND'
	  },
	  VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR'
	  }
	};
	
	},{"../lib/braintree-error":73}],110:[function(require,module,exports){
	'use strict';
	/**
	 * @module braintree-web/vault-manager
	 * @description Manages customer's payment methods.
	 */
	
	var basicComponentVerification = require('../lib/basic-component-verification');
	var createDeferredClient = require('../lib/create-deferred-client');
	var createAssetsUrl = require('../lib/create-assets-url');
	var VaultManager = require('./vault-manager');
	var VERSION = "3.47.0";
	var wrapPromise = require('@braintree/wrap-promise');
	
	/**
	 * @static
	 * @function create
	 * @param {object} options Creation options:
	 * @param {Client} [options.client] A {@link Client} instance.
	 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
	 * @param {callback} callback The second argument, `data`, is the {@link VaultManager} instance.
	 * @returns {void}
	 */
	function create(options) {
	  var name = 'Vault Manager';
	
	  return basicComponentVerification.verify({
	    name: name,
	    client: options.client,
	    authorization: options.authorization
	  }).then(function () {
	    return createDeferredClient.create({
	      authorization: options.authorization,
	      client: options.client,
	      debug: options.debug,
	      assetsUrl: createAssetsUrl.create(options.authorization),
	      name: name
	    });
	  }).then(function (client) {
	    options.client = client;
	
	    return new VaultManager(options);
	  });
	}
	
	module.exports = {
	  create: wrapPromise(create),
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/basic-component-verification":71,"../lib/create-assets-url":80,"../lib/create-deferred-client":82,"./vault-manager":111,"@braintree/wrap-promise":27}],111:[function(require,module,exports){
	'use strict';
	
	var analytics = require('../lib/analytics');
	var BraintreeError = require('../lib/braintree-error');
	var errors = require('./errors');
	var convertMethodsToError = require('../lib/convert-methods-to-error');
	var methods = require('../lib/methods');
	var Promise = require('../lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	
	var DELETE_PAYMENT_METHOD_MUTATION = 'mutation DeletePaymentMethodFromSingleUseToken($input: DeletePaymentMethodFromSingleUseTokenInput!) {' +
	'  deletePaymentMethodFromSingleUseToken(input: $input) {' +
	'    clientMutationId' +
	'  }' +
	'}';
	
	/**
	 * @typedef {array} VaultManager~fetchPaymentMethodsPayload The customer's payment methods.
	 * @property {object} paymentMethod The payment method object.
	 * @property {string} paymentMethod.nonce A nonce that can be sent to your server to transact on the payment method.
	 * @property {boolean} paymentMethod.default Whether or not this is the default payment method for the customer.
	 * @property {object} paymentMethod.details Any additional details about the payment method. Varies depending on the type of payment method.
	 * @property {string} paymentMethod.type A constant indicating the type of payment method.
	 * @property {?string} paymentMethod.description Additional description about the payment method.
	 * @property {?object} paymentMethod.binData Bin data about the payment method.
	 *
	 */
	
	/**
	 * @class
	 * @param {object} options Options
	 * @description <strong>You cannot use this constructor directly. Use {@link module:braintree-web/vault-manager.create|braintree.vault-manager.create} instead.</strong>
	 * @classdesc This class allows you to manage a customer's payment methods on the client.
	 */
	function VaultManager(options) {
	  this._client = options.client;
	}
	
	/**
	 * Fetches payment methods owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
	 * @public
	 * @param {object} [options] Options for fetching payment methods.
	 * @param {boolean} [options.defaultFirst = false] If `true`, the payment methods will be returned with the default payment method for the customer first. Otherwise, the payment methods will be returned with the most recently used payment method first.
	 * @param {callback} [callback] The second argument is a {@link VaultManager~fetchPaymentMethodsPayload|fetchPaymentMehodsPayload}. This is also what is resolved by the promise if no callback is provided.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * vaultManagerInstance.fetchPaymentMethods(function (err, paymentMethods) {
	 *   paymentMethods.forEach(function (paymentMethod) {
	 *     // add payment method to UI
	 *     // paymentMethod.nonce <- transactable nonce associated with payment method
	 *     // paymentMethod.details <- object with additional information about payment method
	 *     // paymentMethod.type <- a constant signifying the type
	 *   });
	 * });
	 */
	VaultManager.prototype.fetchPaymentMethods = function (options) {
	  var defaultFirst;
	
	  options = options || {};
	
	  defaultFirst = options.defaultFirst === true ? 1 : 0;
	
	  return this._client.request({
	    endpoint: 'payment_methods',
	    method: 'get',
	    data: {
	      defaultFirst: defaultFirst
	    }
	  }).then(function (paymentMethodsPayload) {
	    analytics.sendEvent(this._client, 'vault-manager.fetch-payment-methods.succeeded');
	
	    return paymentMethodsPayload.paymentMethods.map(formatPaymentMethodPayload);
	  }.bind(this));
	};
	
	// TODO hide from jsdoc for now until the GraphQL API is on for all merchants by default
	/**
	 * Deletes a payment method owned by the customer whose id was used to generate the client token used to create the {@link module:braintree-web/client|client}.
	 * @public
	 * @ignore
	 * @param {string} paymentMethodNonce The payment method nonce that references a vaulted payment method.
	 * @param {callback} [callback] No data is returned if the operation is successful.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * vaultManagerInstance.deletePaymentMethod('nonce-to-delete', function (err) {
	 *   // handle err if it exists
	 * });
	 */
	VaultManager.prototype.deletePaymentMethod = function (paymentMethodNonce) {
	  var client = this._client;
	  var usesClientToken = this._client.getConfiguration().authorizationType === 'CLIENT_TOKEN';
	
	  if (!usesClientToken) {
	    return Promise.reject(new BraintreeError(errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_NONCE_REQUIRES_CLIENT_TOKEN));
	  }
	
	  return this._client.request({
	    api: 'graphQLApi',
	    data: {
	      query: DELETE_PAYMENT_METHOD_MUTATION,
	      variables: {
	        input: {
	          singleUseTokenId: paymentMethodNonce
	        }
	      },
	      operationName: 'DeletePaymentMethodFromSingleUseToken'
	    }
	  }).then(function () {
	    analytics.sendEvent(client, 'vault-manager.delete-payment-method.succeeded');
	
	    // noop to prevent sending back the raw graphql data
	  }).catch(function (error) {
	    var originalError = error.details.originalError;
	    var formattedError;
	
	    analytics.sendEvent(client, 'vault-manager.delete-payment-method.failed');
	
	    if (originalError[0] && originalError[0].extensions.errorClass === 'NOT_FOUND') {
	      formattedError = new BraintreeError({
	        type: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.type,
	        code: errors.VAULT_MANAGER_PAYMENT_METHOD_NONCE_NOT_FOUND.code,
	        message: 'A payment method for payment method nonce `' + paymentMethodNonce + '` could not be found.',
	        details: {
	          originalError: originalError
	        }
	      });
	    }
	
	    if (!formattedError) {
	      formattedError = new BraintreeError({
	        type: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.type,
	        code: errors.VAULT_MANAGER_DELETE_PAYMENT_METHOD_UNKNOWN_ERROR.code,
	        message: 'An unknown error occured when attempting to delete the payment method assocaited with the payment method nonce `' + paymentMethodNonce + '`.',
	        details: {
	          originalError: originalError
	        }
	      });
	    }
	
	    return Promise.reject(formattedError);
	  });
	};
	
	function formatPaymentMethodPayload(paymentMethod) {
	  var formattedPaymentMethod = {
	    nonce: paymentMethod.nonce,
	    'default': paymentMethod.default,
	    details: paymentMethod.details,
	    hasSubscription: paymentMethod.hasSubscription,
	    type: paymentMethod.type
	  };
	
	  if (paymentMethod.description) {
	    formattedPaymentMethod.description = paymentMethod.description;
	  }
	
	  if (paymentMethod.binData) {
	    formattedPaymentMethod.binData = paymentMethod.binData;
	  }
	
	  return formattedPaymentMethod;
	}
	
	/**
	 * Cleanly tear down anything set up by {@link module:braintree-web/vault-manager.create|create}.
	 * @public
	 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
	 * @example
	 * vaultManagerInstance.teardown();
	 * @example <caption>With callback</caption>
	 * vaultManagerInstance.teardown(function () {
	 *   // teardown is complete
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	VaultManager.prototype.teardown = function () {
	  convertMethodsToError(this, methods(VaultManager.prototype));
	
	  return Promise.resolve();
	};
	
	module.exports = wrapPromise.wrapPrototype(VaultManager);
	
	},{"../lib/analytics":68,"../lib/braintree-error":73,"../lib/convert-methods-to-error":78,"../lib/methods":93,"../lib/promise":95,"./errors":109,"@braintree/wrap-promise":27}],112:[function(require,module,exports){
	'use strict';
	/** @module braintree-web/venmo */
	
	var analytics = require('../lib/analytics');
	var basicComponentVerification = require('../lib/basic-component-verification');
	var createDeferredClient = require('../lib/create-deferred-client');
	var createAssetsUrl = require('../lib/create-assets-url');
	var errors = require('./shared/errors');
	var wrapPromise = require('@braintree/wrap-promise');
	var BraintreeError = require('../lib/braintree-error');
	var Venmo = require('./venmo');
	var Promise = require('../lib/promise');
	var supportsVenmo = require('./shared/supports-venmo');
	var VERSION = "3.47.0";
	
	/**
	 * @static
	 * @function create
	 * @param {object} options Creation options:
	 * @param {Client} [options.client] A {@link Client} instance.
	 * @param {string} [options.authorization] A tokenizationKey or clientToken. Can be used in place of `options.client`.
	 * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications. Doing so causes {@link Venmo#isBrowserSupported|isBrowserSupported} to return true only for mobile web browsers that support returning from the Venmo app to the same tab.
	 * @param {string} [options.profileId] The Venmo profile ID to be used during payment authorization. Customers will see the business name and logo associated with this Venmo profile, and it will show up in the Venmo app as a "Connected Merchant". Venmo profile IDs can be found in the Braintree Control Panel. Omitting this value will use the default Venmo profile.
	 * @param {string} [options.deepLinkReturnUrl] An override for the URL that the Venmo iOS app opens to return from an app switch.
	 * @param {callback} [callback] The second argument, `data`, is the {@link Venmo} instance. If no callback is provided, `create` returns a promise that resolves with the {@link Venmo} instance.
	 * @example
	 * braintree.venmo.create({
	 *   client: clientInstance
	 * }).then(function (venmoInstance) {
	 *   // venmoInstance is ready to be used.
	 * }).catch(function (createErr) {
	 *   console.error('Error creating Venmo instance', createErr);
	 * });
	 * @returns {Promise|void} Returns the Venmo instance.
	 */
	function create(options) {
	  var name = 'Venmo';
	
	  return basicComponentVerification.verify({
	    name: name,
	    client: options.client,
	    authorization: options.authorization
	  }).then(function () {
	    return createDeferredClient.create({
	      authorization: options.authorization,
	      client: options.client,
	      debug: options.debug,
	      assetsUrl: createAssetsUrl.create(options.authorization),
	      name: name
	    });
	  }).then(function (client) {
	    var instance;
	    var configuration = client.getConfiguration();
	
	    options.client = client;
	
	    if (!configuration.gatewayConfiguration.payWithVenmo) {
	      return Promise.reject(new BraintreeError(errors.VENMO_NOT_ENABLED));
	    }
	
	    if (options.profileId && typeof options.profileId !== 'string') {
	      return Promise.reject(new BraintreeError(errors.VENMO_INVALID_PROFILE_ID));
	    }
	
	    if (options.deepLinkReturnUrl && typeof options.deepLinkReturnUrl !== 'string') {
	      return Promise.reject(new BraintreeError(errors.VENMO_INVALID_DEEP_LINK_RETURN_URL));
	    }
	
	    instance = new Venmo(options);
	
	    analytics.sendEvent(options.client, 'venmo.initialized');
	
	    return instance._initialize();
	  });
	}
	
	/**
	 * @static
	 * @function isBrowserSupported
	 * @param {object} [options] browser support options:
	 * @param {boolean} [options.allowNewBrowserTab=true] This should be set to false if your payment flow requires returning to the same tab, e.g. single page applications.
	 * @example
	 * if (braintree.venmo.isBrowserSupported()) {
	 *   // set up Venmo
	 * }
	 * @example <caption>Explicitly require browser support returning to the same tab</caption>
	 * if (braintree.venmo.isBrowserSupported({
	 *   allowNewBrowserTab: false
	 * })) {
	 *   // set up Venmo
	 * }
	 * @returns {boolean} Whether or not the browser supports Venmo.
	 */
	function isBrowserSupported(options) {
	  return supportsVenmo.isBrowserSupported(options);
	}
	
	module.exports = {
	  create: wrapPromise(create),
	  isBrowserSupported: isBrowserSupported,
	  /**
	   * @description The current version of the SDK, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"../lib/analytics":68,"../lib/basic-component-verification":71,"../lib/braintree-error":73,"../lib/create-assets-url":80,"../lib/create-deferred-client":82,"../lib/promise":95,"./shared/errors":115,"./shared/supports-venmo":116,"./venmo":117,"@braintree/wrap-promise":27}],113:[function(require,module,exports){
	'use strict';
	
	var isAndroid = require('@braintree/browser-detection/is-android');
	var isChrome = require('@braintree/browser-detection/is-chrome');
	var isIos = require('@braintree/browser-detection/is-ios');
	var isIosSafari = require('@braintree/browser-detection/is-ios-safari');
	var isSamsungBrowser = require('@braintree/browser-detection/is-samsung');
	var isMobileFirefox = require('@braintree/browser-detection/is-mobile-firefox');
	
	module.exports = {
	  isAndroid: isAndroid,
	  isChrome: isChrome,
	  isIos: isIos,
	  isIosSafari: isIosSafari,
	  isSamsungBrowser: isSamsungBrowser,
	  isMobileFirefox: isMobileFirefox
	};
	
	},{"@braintree/browser-detection/is-android":5,"@braintree/browser-detection/is-chrome":6,"@braintree/browser-detection/is-ios":15,"@braintree/browser-detection/is-ios-safari":13,"@braintree/browser-detection/is-mobile-firefox":16,"@braintree/browser-detection/is-samsung":17}],114:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY: 500,
	  PROCESS_RESULTS_DELAY: 1000,
	  VENMO_OPEN_URL: 'https://venmo.com/braintree/checkout'
	};
	
	},{}],115:[function(require,module,exports){
	'use strict';
	
	/**
	 * @name BraintreeError.Venmo - Creation Error Codes
	 * @description Errors that occur when [creating the Venmo component](/current/module-braintree-web_venmo.html#.create).
	 * @property {MERCHANT} VENMO_NOT_ENABLED Occurs when Venmo is not enabled on the Braintree control panel.
	 * @property {MERCHANT} VENMO_INVALID_PROFILE_ID Occurs when Venmo is intilaized with a profile id, but it is invalid.
	 */
	
	/**
	 * @name BraintreeError.Venmo - tokenize Error Codes
	 * @description Errors that occur when using the [`tokenize` method](/current/Venmo.html#tokenize).
	 * @property {MERCHANT} VENMO_TOKENIZATION_REQUEST_ACTIVE Occurs when `tokenize` is called when the flow is already in progress.
	 * @property {UNKNOWN} VENMO_APP_FAILED Occurs when tokenization fails.
	 * @property {CUSTOMER} VENMO_APP_CANCELED Occurs when customer cancels flow from the Venmo app.
	 * @property {CUSTOMER} VENMO_CANCELED Occurs when customer cancels the flow or Venmo app is not available.
	 */
	
	var BraintreeError = require('../../lib/braintree-error');
	
	module.exports = {
	  VENMO_NOT_ENABLED: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'VENMO_NOT_ENABLED',
	    message: 'Venmo is not enabled for this merchant.'
	  },
	  VENMO_TOKENIZATION_REQUEST_ACTIVE: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'VENMO_TOKENIZATION_REQUEST_ACTIVE',
	    message: 'Another tokenization request is active.'
	  },
	  VENMO_APP_FAILED: {
	    type: BraintreeError.types.UNKNOWN,
	    code: 'VENMO_APP_FAILED',
	    message: 'Venmo app encountered a problem.'
	  },
	  VENMO_APP_CANCELED: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'VENMO_APP_CANCELED',
	    message: 'Venmo app authorization was canceled.'
	  },
	  VENMO_CANCELED: {
	    type: BraintreeError.types.CUSTOMER,
	    code: 'VENMO_CANCELED',
	    message: 'User canceled Venmo authorization, or Venmo app is not available.'
	  },
	  VENMO_INVALID_PROFILE_ID: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'VENMO_INVALID_PROFILE_ID',
	    message: 'Venmo profile ID is invalid.'
	  },
	  VENMO_INVALID_DEEP_LINK_RETURN_URL: {
	    type: BraintreeError.types.MERCHANT,
	    code: 'VENMO_INVALID_DEEP_LINK_RETURN_URL',
	    message: 'Venmo deep link return URL is invalid.'
	  }
	};
	
	},{"../../lib/braintree-error":73}],116:[function(require,module,exports){
	'use strict';
	
	var browserDetection = require('./browser-detection');
	
	function isBrowserSupported(options) {
	  var isAndroidChrome = browserDetection.isAndroid() && browserDetection.isChrome();
	  var isIosChrome = browserDetection.isIos() && browserDetection.isChrome();
	  var supportsReturnToSameTab = browserDetection.isIosSafari() || isAndroidChrome;
	  var supportsReturnToNewTab = isIosChrome || browserDetection.isSamsungBrowser() || browserDetection.isMobileFirefox();
	
	  options = options || {
	    allowNewBrowserTab: true
	  };
	
	  return supportsReturnToSameTab || (options.allowNewBrowserTab && supportsReturnToNewTab);
	}
	
	module.exports = {
	  isBrowserSupported: isBrowserSupported
	};
	
	},{"./browser-detection":113}],117:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var analytics = require('../lib/analytics');
	var isBrowserSupported = require('./shared/supports-venmo');
	var constants = require('./shared/constants');
	var errors = require('./shared/errors');
	var querystring = require('../lib/querystring');
	var methods = require('../lib/methods');
	var convertMethodsToError = require('../lib/convert-methods-to-error');
	var wrapPromise = require('@braintree/wrap-promise');
	var BraintreeError = require('../lib/braintree-error');
	var Promise = require('../lib/promise');
	var VERSION = "3.47.0";
	
	/**
	 * Venmo tokenize payload.
	 * @typedef {object} Venmo~tokenizePayload
	 * @property {string} nonce The payment method nonce.
	 * @property {string} type The payment method type, always `VenmoAccount`.
	 * @property {object} details Additional Venmo account details.
	 * @property {string} details.username Username of the Venmo account.
	 */
	
	/**
	 * @class
	 * @param {object} options The Venmo {@link module:braintree-web/venmo.create create} options.
	 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web/venmo.create|braintree-web.venmo.create} instead.</strong>
	 * @classdesc This class represents a Venmo component produced by {@link module:braintree-web/venmo.create|braintree-web/venmo.create}. Instances of this class have methods for tokenizing Venmo payments.
	 */
	function Venmo(options) {
	  var configuration;
	
	  this._client = options.client;
	  configuration = this._client.getConfiguration();
	  this._isDebug = configuration.isDebug;
	  this._assetsUrl = configuration.gatewayConfiguration.assetsUrl + '/web/' + VERSION;
	  this._allowNewBrowserTab = options.allowNewBrowserTab !== false;
	  this._profileId = options.profileId;
	  this._deepLinkReturnUrl = options.deepLinkReturnUrl;
	}
	
	Venmo.prototype._initialize = function () {
	  var params = {};
	  var currentUrl = this._deepLinkReturnUrl || global.location.href.replace(global.location.hash, '');
	  var configuration = this._client.getConfiguration();
	  var venmoConfiguration = configuration.gatewayConfiguration.payWithVenmo;
	  var analyticsMetadata = this._client.getConfiguration().analyticsMetadata;
	  var braintreeData = {
	    _meta: {
	      version: analyticsMetadata.sdkVersion,
	      integration: analyticsMetadata.integration,
	      platform: analyticsMetadata.platform,
	      sessionId: analyticsMetadata.sessionId
	    }
	  };
	
	  params['x-success'] = currentUrl + '#venmoSuccess=1';
	  params['x-cancel'] = currentUrl + '#venmoCancel=1';
	  params['x-error'] = currentUrl + '#venmoError=1';
	  params.ua = global.navigator.userAgent;
	  /* eslint-disable camelcase */
	  params.braintree_merchant_id = this._profileId || venmoConfiguration.merchantId;
	  params.braintree_access_token = venmoConfiguration.accessToken;
	  params.braintree_environment = venmoConfiguration.environment;
	  params.braintree_sdk_data = btoa(JSON.stringify(braintreeData));
	  /* eslint-enable camelcase */
	
	  this._url = constants.VENMO_OPEN_URL + '?' + querystring.stringify(params);
	
	  return Promise.resolve(this);
	};
	
	/**
	 * Returns a boolean indicating whether the current browser supports Venmo as a payment method.
	 *
	 * If `options.allowNewBrowserTab` is false when calling {@link module:braintree-web/venmo.create|venmo.create}, this method will return true only for browsers known to support returning from the Venmo app to the same browser tab. Currently, this is limited to iOS Safari and Android Chrome.
	 * @public
	 * @returns {boolean} True if the current browser is supported, false if not.
	 */
	Venmo.prototype.isBrowserSupported = function () {
	  return isBrowserSupported.isBrowserSupported({
	    allowNewBrowserTab: this._allowNewBrowserTab
	  });
	};
	
	/**
	 * Returns a boolean indicating whether a Venmo tokenization result is ready to be processed immediately.
	 *
	 * This method should be called after initialization to see if the result of Venmo authorization is available. If it returns true, call {@link Venmo#tokenize|tokenize} immediately to process the results.
	 *
	 * @public
	 * @returns {boolean} True if the results of Venmo payment authorization are available and ready to process.
	 */
	Venmo.prototype.hasTokenizationResult = function () {
	  var params = getFragmentParameters();
	
	  return typeof (params.venmoSuccess || params.venmoError || params.venmoCancel) !== 'undefined';
	};
	
	/**
	 * Launches the Venmo flow and returns a nonce payload.
	 *
	 * If {@link Venmo#hasTokenizationResult|hasTokenizationResult} returns true, calling tokenize will immediately process and return the results without initiating the Venmo payment authorization flow.
	 *
	 * Only one Venmo flow can be active at a time. One way to achieve this is to disable your Venmo button while the flow is open.
	 * @public
	 * @param {callback} [callback] The second argument, <code>data</code>, is a {@link Venmo~tokenizePayload|tokenizePayload}. If no callback is provided, the method will return a Promise that resolves with a {@link Venmo~tokenizePayload|tokenizePayload}.
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 * @example
	 * button.addEventListener('click', function () {
	 *   // Disable the button so that we don't attempt to open multiple popups.
	 *   button.setAttribute('disabled', 'disabled');
	 *
	 *   // Because tokenize opens a new window, this must be called
	 *   // as a result of a user action, such as a button click.
	 *   venmoInstance.tokenize().then(function (payload) {
	 *     // Submit payload.nonce to your server
	 *     // Use payload.username to get the Venmo username and display any UI
	 *   }).catch(function (tokenizeError) {
	 *     // Handle flow errors or premature flow closure
	 *     switch (tokenizeErr.code) {
	 *       case 'VENMO_APP_CANCELED':
	 *         console.log('User canceled Venmo flow.');
	 *         break;
	 *       case 'VENMO_CANCELED':
	 *         console.log('User canceled Venmo, or Venmo app is not available.');
	 *         break;
	 *       default:
	 *         console.error('Error!', tokenizeErr);
	 *     }
	 *   }).then(function () {
	 *     button.removeAttribute('disabled');
	 *   });
	 * });
	 */
	Venmo.prototype.tokenize = function () {
	  var self = this;
	
	  if (this._tokenizationInProgress === true) {
	    return Promise.reject(new BraintreeError(errors.VENMO_TOKENIZATION_REQUEST_ACTIVE));
	  }
	
	  if (this.hasTokenizationResult()) {
	    return this._processResults();
	  }
	
	  return new Promise(function (resolve, reject) {
	    self._tokenizationInProgress = true;
	    self._previousHash = global.location.hash;
	
	    // Deep link URLs do not launch iOS apps from a webview when using window.open or PopupBridge.open.
	    if (self._deepLinkReturnUrl) {
	      global.location = self._url;
	    } else {
	      global.open(self._url);
	    }
	
	    // Subscribe to document visibility change events to detect when app switch
	    // has returned.
	    self._visibilityChangeListener = function () {
	      if (!global.document.hidden) {
	        self._tokenizationInProgress = false;
	
	        setTimeout(function () {
	          self._processResults().then(resolve).catch(reject).then(function () {
	            global.location.hash = self._previousHash;
	            self._removeVisibilityEventListener();
	            delete self._visibilityChangeListener;
	          });
	        }, constants.PROCESS_RESULTS_DELAY);
	      }
	    };
	
	    // Add a brief delay to ignore visibility change events that occur right before app switch
	    setTimeout(function () {
	      global.document.addEventListener(documentVisibilityChangeEventName(), self._visibilityChangeListener);
	    }, constants.DOCUMENT_VISIBILITY_CHANGE_EVENT_DELAY);
	  });
	};
	
	/**
	 * Cleanly tear down anything set up by {@link module:braintree-web/venmo.create|create}.
	 * @public
	 * @param {callback} [callback] Called once teardown is complete. No data is returned if teardown completes successfully.
	 * @example
	 * venmoInstance.teardown();
	 * @example <caption>With callback</caption>
	 * venmoInstance.teardown(function () {
	 *   // teardown is complete
	 * });
	 * @returns {Promise|void} Returns a promise if no callback is provided.
	 */
	Venmo.prototype.teardown = function () {
	  this._removeVisibilityEventListener();
	  convertMethodsToError(this, methods(Venmo.prototype));
	
	  return Promise.resolve();
	};
	
	Venmo.prototype._removeVisibilityEventListener = function () {
	  global.document.removeEventListener(documentVisibilityChangeEventName(), this._visibilityChangeListener);
	};
	
	Venmo.prototype._processResults = function () {
	  var self = this;
	  var params = getFragmentParameters();
	
	  return new Promise(function (resolve, reject) {
	    if (params.venmoSuccess) {
	      analytics.sendEvent(self._client, 'venmo.appswitch.handle.success');
	      resolve(formatTokenizePayload(params));
	    } else if (params.venmoError) {
	      analytics.sendEvent(self._client, 'venmo.appswitch.handle.error');
	      reject(new BraintreeError({
	        type: errors.VENMO_APP_FAILED.type,
	        code: errors.VENMO_APP_FAILED.code,
	        message: errors.VENMO_APP_FAILED.message,
	        details: {
	          originalError: {
	            message: decodeURIComponent(params.errorMessage),
	            code: params.errorCode
	          }
	        }
	      }));
	    } else if (params.venmoCancel) {
	      analytics.sendEvent(self._client, 'venmo.appswitch.handle.cancel');
	      reject(new BraintreeError(errors.VENMO_APP_CANCELED));
	    } else {
	      // User has either manually switched back to browser, or app is not available for app switch
	      analytics.sendEvent(self._client, 'venmo.appswitch.cancel-or-unavailable');
	      reject(new BraintreeError(errors.VENMO_CANCELED));
	    }
	
	    clearFragmentParameters();
	  });
	};
	
	function getFragmentParameters() {
	  var keyValuesArray = global.location.hash.substring(1).split('&');
	
	  return keyValuesArray.reduce(function (toReturn, keyValue) {
	    var parts = keyValue.split('=');
	    var key = decodeURIComponent(parts[0]);
	    var value = decodeURIComponent(parts[1]);
	
	    toReturn[key] = value;
	
	    return toReturn;
	  }, {});
	}
	
	function clearFragmentParameters() {
	  if (typeof global.history.replaceState === 'function' && global.location.hash) {
	    history.pushState({}, '', global.location.href.slice(0, global.location.href.indexOf('#')));
	  }
	}
	
	function formatTokenizePayload(fragmentParams) {
	  return {
	    nonce: fragmentParams.paymentMethodNonce,
	    type: 'VenmoAccount',
	    details: {
	      username: fragmentParams.username
	    }
	  };
	}
	
	// From https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
	function documentVisibilityChangeEventName() {
	  var visibilityChange;
	
	  if (typeof global.document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
	    visibilityChange = 'visibilitychange';
	  } else if (typeof global.document.msHidden !== 'undefined') {
	    visibilityChange = 'msvisibilitychange';
	  } else if (typeof global.document.webkitHidden !== 'undefined') {
	    visibilityChange = 'webkitvisibilitychange';
	  }
	
	  return visibilityChange;
	}
	
	module.exports = wrapPromise.wrapPrototype(Venmo);
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../lib/analytics":68,"../lib/braintree-error":73,"../lib/convert-methods-to-error":78,"../lib/methods":93,"../lib/promise":95,"../lib/querystring":96,"./shared/constants":114,"./shared/errors":115,"./shared/supports-venmo":116,"@braintree/wrap-promise":27}],118:[function(require,module,exports){
	'use strict';
	
	var types = require('./lib/card-types');
	var clone = require('./lib/clone');
	var findBestMatch = require('./lib/find-best-match');
	var isValidInputType = require('./lib/is-valid-input-type');
	var addMatchingCardsToResults = require('./lib/add-matching-cards-to-results');
	
	var testOrder;
	var customCards = {};
	
	var cardNames = {
	  VISA: 'visa',
	  MASTERCARD: 'mastercard',
	  AMERICAN_EXPRESS: 'american-express',
	  DINERS_CLUB: 'diners-club',
	  DISCOVER: 'discover',
	  JCB: 'jcb',
	  UNIONPAY: 'unionpay',
	  MAESTRO: 'maestro',
	  ELO: 'elo',
	  MIR: 'mir',
	  HIPER: 'hiper',
	  HIPERCARD: 'hipercard'
	};
	
	var ORIGINAL_TEST_ORDER = [
	  cardNames.VISA,
	  cardNames.MASTERCARD,
	  cardNames.AMERICAN_EXPRESS,
	  cardNames.DINERS_CLUB,
	  cardNames.DISCOVER,
	  cardNames.JCB,
	  cardNames.UNIONPAY,
	  cardNames.MAESTRO,
	  cardNames.ELO,
	  cardNames.MIR,
	  cardNames.HIPER,
	  cardNames.HIPERCARD
	];
	
	testOrder = clone(ORIGINAL_TEST_ORDER);
	
	function findType(type) {
	  return customCards[type] || types[type];
	}
	
	function getAllCardTypes() {
	  return testOrder.map(function (type) {
	    return clone(findType(type));
	  });
	}
	
	function getCardPosition(name, ignoreErrorForNotExisting) {
	  var position = testOrder.indexOf(name);
	
	  if (!ignoreErrorForNotExisting && position === -1) {
	    throw new Error('"' + name + '" is not a supported card type.');
	  }
	
	  return position;
	}
	
	function creditCardType(cardNumber) {
	  var bestMatch;
	  var results = [];
	
	  if (!isValidInputType(cardNumber)) {
	    return [];
	  }
	
	  if (cardNumber.length === 0) {
	    return getAllCardTypes(testOrder);
	  }
	
	  testOrder.forEach(function (type) {
	    var cardConfiguration = findType(type);
	
	    addMatchingCardsToResults(cardNumber, cardConfiguration, results);
	  });
	
	  bestMatch = findBestMatch(results);
	
	  if (bestMatch) {
	    return [bestMatch];
	  }
	
	  return results;
	}
	
	creditCardType.getTypeInfo = function (type) {
	  return clone(findType(type));
	};
	
	creditCardType.removeCard = function (name) {
	  var position = getCardPosition(name);
	
	  testOrder.splice(position, 1);
	};
	
	creditCardType.addCard = function (config) {
	  var existingCardPosition = getCardPosition(config.type, true);
	
	  customCards[config.type] = config;
	
	  if (existingCardPosition === -1) {
	    testOrder.push(config.type);
	  }
	};
	
	creditCardType.updateCard = function (cardType, updates) {
	  var clonedCard;
	  var originalObject = customCards[cardType] || types[cardType];
	
	  if (!originalObject) {
	    throw new Error('"' + cardType + '" is not a recognized type. Use `addCard` instead.');
	  }
	
	  if (updates.type && originalObject.type !== updates.type) {
	    throw new Error('Cannot overwrite type parameter.');
	  }
	
	  clonedCard = clone(originalObject, true);
	
	  Object.keys(clonedCard).forEach(function (key) {
	    if (updates[key]) {
	      clonedCard[key] = updates[key];
	    }
	  });
	
	  customCards[clonedCard.type] = clonedCard;
	};
	
	creditCardType.changeOrder = function (name, position) {
	  var currentPosition = getCardPosition(name);
	
	  testOrder.splice(currentPosition, 1);
	  testOrder.splice(position, 0, name);
	};
	
	creditCardType.resetModifications = function () {
	  testOrder = clone(ORIGINAL_TEST_ORDER);
	  customCards = {};
	};
	
	creditCardType.types = cardNames;
	
	module.exports = creditCardType;
	
	},{"./lib/add-matching-cards-to-results":119,"./lib/card-types":120,"./lib/clone":121,"./lib/find-best-match":122,"./lib/is-valid-input-type":123}],119:[function(require,module,exports){
	'use strict';
	
	var clone = require('./clone');
	var matches = require('./matches');
	
	function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
	  var i, pattern, patternLength, clonedCardConfiguration;
	
	  for (i = 0; i < cardConfiguration.patterns.length; i++) {
	    pattern = cardConfiguration.patterns[i];
	
	    if (!matches(cardNumber, pattern)) {
	      continue;
	    }
	
	    clonedCardConfiguration = clone(cardConfiguration);
	
	    if (Array.isArray(pattern)) {
	      patternLength = String(pattern[0]).length;
	    } else {
	      patternLength = String(pattern).length;
	    }
	
	    if (cardNumber.length >= patternLength) {
	      clonedCardConfiguration.matchStrength = patternLength;
	    }
	
	    results.push(clonedCardConfiguration);
	    break;
	  }
	}
	
	module.exports = addMatchingCardsToResults;
	
	},{"./clone":121,"./matches":124}],120:[function(require,module,exports){
	'use strict';
	
	var cardTypes = {
	  visa: {
	    niceType: 'Visa',
	    type: 'visa',
	    patterns: [
	      4
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16, 18, 19],
	    code: {
	      name: 'CVV',
	      size: 3
	    }
	  },
	  mastercard: {
	    niceType: 'Mastercard',
	    type: 'mastercard',
	    patterns: [
	      [51, 55],
	      [2221, 2229],
	      [223, 229],
	      [23, 26],
	      [270, 271],
	      2720
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16],
	    code: {
	      name: 'CVC',
	      size: 3
	    }
	  },
	  'american-express': {
	    niceType: 'American Express',
	    type: 'american-express',
	    patterns: [
	      34,
	      37
	    ],
	    gaps: [4, 10],
	    lengths: [15],
	    code: {
	      name: 'CID',
	      size: 4
	    }
	  },
	  'diners-club': {
	    niceType: 'Diners Club',
	    type: 'diners-club',
	    patterns: [
	      [300, 305],
	      36,
	      38,
	      39
	    ],
	    gaps: [4, 10],
	    lengths: [14, 16, 19],
	    code: {
	      name: 'CVV',
	      size: 3
	    }
	  },
	  discover: {
	    niceType: 'Discover',
	    type: 'discover',
	    patterns: [
	      6011,
	      [644, 649],
	      65
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16, 19],
	    code: {
	      name: 'CID',
	      size: 3
	    }
	  },
	  jcb: {
	    niceType: 'JCB',
	    type: 'jcb',
	    patterns: [
	      2131,
	      1800,
	      [3528, 3589]
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16, 17, 18, 19],
	    code: {
	      name: 'CVV',
	      size: 3
	    }
	  },
	  unionpay: {
	    niceType: 'UnionPay',
	    type: 'unionpay',
	    patterns: [
	      620,
	      [624, 626],
	      [62100, 62182],
	      [62184, 62187],
	      [62185, 62197],
	      [62200, 62205],
	      [622010, 622999],
	      622018,
	      [622019, 622999],
	      [62207, 62209],
	      [622126, 622925],
	      [623, 626],
	      6270,
	      6272,
	      6276,
	      [627700, 627779],
	      [627781, 627799],
	      [6282, 6289],
	      6291,
	      6292
	    ],
	    gaps: [4, 8, 12],
	    lengths: [14, 15, 16, 17, 18, 19],
	    code: {
	      name: 'CVN',
	      size: 3
	    }
	  },
	  maestro: {
	    niceType: 'Maestro',
	    type: 'maestro',
	    patterns: [
	      493698,
	      [500000, 506698],
	      [506779, 508999],
	      [56, 59],
	      63,
	      67,
	      6
	    ],
	    gaps: [4, 8, 12],
	    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
	    code: {
	      name: 'CVC',
	      size: 3
	    }
	  },
	  elo: {
	    niceType: 'Elo',
	    type: 'elo',
	    patterns: [
	      401178,
	      401179,
	      438935,
	      457631,
	      457632,
	      431274,
	      451416,
	      457393,
	      504175,
	      [506699, 506778],
	      [509000, 509999],
	      627780,
	      636297,
	      636368,
	      [650031, 650033],
	      [650035, 650051],
	      [650405, 650439],
	      [650485, 650538],
	      [650541, 650598],
	      [650700, 650718],
	      [650720, 650727],
	      [650901, 650978],
	      [651652, 651679],
	      [655000, 655019],
	      [655021, 655058]
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16],
	    code: {
	      name: 'CVE',
	      size: 3
	    }
	  },
	  mir: {
	    niceType: 'Mir',
	    type: 'mir',
	    patterns: [
	      [2200, 2204]
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16, 17, 18, 19],
	    code: {
	      name: 'CVP2',
	      size: 3
	    }
	  },
	  hiper: {
	    niceType: 'Hiper',
	    type: 'hiper',
	    patterns: [
	      637095,
	      637568,
	      637599,
	      637609,
	      637612
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16],
	    code: {
	      name: 'CVC',
	      size: 3
	    }
	  },
	  hipercard: {
	    niceType: 'Hipercard',
	    type: 'hipercard',
	    patterns: [
	      606282
	    ],
	    gaps: [4, 8, 12],
	    lengths: [16],
	    code: {
	      name: 'CVC',
	      size: 3
	    }
	  }
	};
	
	module.exports = cardTypes;
	
	},{}],121:[function(require,module,exports){
	'use strict';
	
	function clone(originalObject) {
	  var dupe;
	
	  if (!originalObject) { return null; }
	
	  dupe = JSON.parse(JSON.stringify(originalObject));
	
	  return dupe;
	}
	
	module.exports = clone;
	
	},{}],122:[function(require,module,exports){
	'use strict';
	
	function hasEnoughResultsToDetermineBestMatch(results) {
	  var numberOfResultsWithMaxStrengthProperty = results.filter(function (result) {
	    return result.matchStrength;
	  }).length;
	
	  // if all possible results have a maxStrength property
	  // that means the card number is sufficiently long
	  // enough to determine conclusively what the type is
	  return numberOfResultsWithMaxStrengthProperty > 0 &&
	    numberOfResultsWithMaxStrengthProperty === results.length;
	}
	
	function findBestMatch(results) {
	  if (!hasEnoughResultsToDetermineBestMatch(results)) {
	    return;
	  }
	
	  return results.reduce(function (bestMatch, result) { // eslint-disable-line consistent-return
	    if (!bestMatch) {
	      return result;
	    }
	
	    // if the current best match pattern is less specific
	    // than this result, set the result as the new best match
	    if (bestMatch.matchStrength < result.matchStrength) {
	      return result;
	    }
	
	    return bestMatch;
	  });
	}
	
	module.exports = findBestMatch;
	
	},{}],123:[function(require,module,exports){
	'use strict';
	
	function isValidInputType(cardNumber) {
	  return typeof cardNumber === 'string' || cardNumber instanceof String;
	}
	
	module.exports = isValidInputType;
	
	},{}],124:[function(require,module,exports){
	'use strict';
	
	// Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
	function matchesRange(cardNumber, min, max) {
	  var maxLengthToCheck = String(min).length;
	  var substr = cardNumber.substr(0, maxLengthToCheck);
	  var integerRepresentationOfCardNumber = parseInt(substr, 10);
	
	  min = parseInt(String(min).substr(0, substr.length), 10);
	  max = parseInt(String(max).substr(0, substr.length), 10);
	
	  return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
	}
	
	function matchesPattern(cardNumber, pattern) {
	  pattern = String(pattern);
	
	  return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
	}
	
	function matches(cardNumber, pattern) {
	  if (Array.isArray(pattern)) {
	    return matchesRange(cardNumber, pattern[0], pattern[1]);
	  }
	
	  return matchesPattern(cardNumber, pattern);
	}
	
	module.exports = matches;
	
	},{}],125:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var win, framebus;
	var popups = [];
	var subscribers = {};
	var prefix = '/*framebus*/';
	
	function include(popup) {
	  if (popup == null) { return false; }
	  if (popup.Window == null) { return false; }
	  if (popup.constructor !== popup.Window) { return false; }
	
	  popups.push(popup);
	  return true;
	}
	
	function target(origin) {
	  var key;
	  var targetedFramebus = {};
	
	  for (key in framebus) {
	    if (!framebus.hasOwnProperty(key)) { continue; }
	
	    targetedFramebus[key] = framebus[key];
	  }
	
	  targetedFramebus._origin = origin || '*';
	
	  return targetedFramebus;
	}
	
	function publish(event) {
	  var payload, args;
	  var origin = _getOrigin(this); // eslint-disable-line no-invalid-this
	
	  if (_isntString(event)) { return false; }
	  if (_isntString(origin)) { return false; }
	
	  args = Array.prototype.slice.call(arguments, 1);
	
	  payload = _packagePayload(event, args, origin);
	  if (payload === false) { return false; }
	
	  _broadcast(win.top || win.self, payload, origin);
	
	  return true;
	}
	
	function subscribe(event, fn) {
	  var origin = _getOrigin(this); // eslint-disable-line no-invalid-this
	
	  if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }
	
	  subscribers[origin] = subscribers[origin] || {};
	  subscribers[origin][event] = subscribers[origin][event] || [];
	  subscribers[origin][event].push(fn);
	
	  return true;
	}
	
	function unsubscribe(event, fn) {
	  var i, subscriberList;
	  var origin = _getOrigin(this); // eslint-disable-line no-invalid-this
	
	  if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }
	
	  subscriberList = subscribers[origin] && subscribers[origin][event];
	  if (!subscriberList) { return false; }
	
	  for (i = 0; i < subscriberList.length; i++) {
	    if (subscriberList[i] === fn) {
	      subscriberList.splice(i, 1);
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function _getOrigin(scope) {
	  return scope && scope._origin || '*';
	}
	
	function _isntString(string) {
	  return typeof string !== 'string';
	}
	
	function _packagePayload(event, args, origin) {
	  var packaged = false;
	  var payload = {
	    event: event,
	    origin: origin
	  };
	  var reply = args[args.length - 1];
	
	  if (typeof reply === 'function') {
	    payload.reply = _subscribeReplier(reply, origin);
	    args = args.slice(0, -1);
	  }
	
	  payload.args = args;
	
	  try {
	    packaged = prefix + JSON.stringify(payload);
	  } catch (e) {
	    throw new Error('Could not stringify event: ' + e.message);
	  }
	  return packaged;
	}
	
	function _unpackPayload(e) {
	  var payload, replyOrigin, replySource, replyEvent;
	
	  if (e.data.slice(0, prefix.length) !== prefix) { return false; }
	
	  try {
	    payload = JSON.parse(e.data.slice(prefix.length));
	  } catch (err) {
	    return false;
	  }
	
	  if (payload.reply != null) {
	    replyOrigin = e.origin;
	    replySource = e.source;
	    replyEvent = payload.reply;
	
	    payload.reply = function reply(data) { // eslint-disable-line consistent-return
	      var replyPayload;
	
	      if (!replySource) { return false; }
	
	      replyPayload = _packagePayload(replyEvent, [data], replyOrigin);
	
	      if (replyPayload === false) { return false; }
	
	      replySource.postMessage(replyPayload, replyOrigin);
	    };
	
	    payload.args.push(payload.reply);
	  }
	
	  return payload;
	}
	
	function _attach(w) {
	  if (win) { return; }
	  win = w || global;
	
	  if (win.addEventListener) {
	    win.addEventListener('message', _onmessage, false);
	  } else if (win.attachEvent) {
	    win.attachEvent('onmessage', _onmessage);
	  } else if (win.onmessage === null) {
	    win.onmessage = _onmessage;
	  } else {
	    win = null;
	  }
	}
	
	// removeIf(production)
	function _detach() {
	  if (win == null) { return; }
	
	  if (win.removeEventListener) {
	    win.removeEventListener('message', _onmessage, false);
	  } else if (win.detachEvent) {
	    win.detachEvent('onmessage', _onmessage);
	  } else if (win.onmessage === _onmessage) {
	    win.onmessage = null;
	  }
	
	  win = null;
	  popups = [];
	  subscribers = {};
	}
	// endRemoveIf(production)
	
	function _uuid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c === 'x' ? r : r & 0x3 | 0x8;
	
	    return v.toString(16);
	  });
	}
	
	function _onmessage(e) {
	  var payload;
	
	  if (_isntString(e.data)) { return; }
	
	  payload = _unpackPayload(e);
	  if (!payload) { return; }
	
	  _dispatch('*', payload.event, payload.args, e);
	  _dispatch(e.origin, payload.event, payload.args, e);
	  _broadcastPopups(e.data, payload.origin, e.source);
	}
	
	function _dispatch(origin, event, args, e) {
	  var i;
	
	  if (!subscribers[origin]) { return; }
	  if (!subscribers[origin][event]) { return; }
	
	  for (i = 0; i < subscribers[origin][event].length; i++) {
	    subscribers[origin][event][i].apply(e, args);
	  }
	}
	
	function _hasOpener(frame) {
	  if (frame.top !== frame) { return false; }
	  if (frame.opener == null) { return false; }
	  if (frame.opener === frame) { return false; }
	  if (frame.opener.closed === true) { return false; }
	
	  return true;
	}
	
	function _broadcast(frame, payload, origin) {
	  var i = 0;
	  var frameToBroadcastTo;
	
	  try {
	    frame.postMessage(payload, origin);
	
	    if (_hasOpener(frame)) {
	      _broadcast(frame.opener.top, payload, origin);
	    }
	
	    // previously, our max value was frame.frames.length
	    // but frames.length inherits from window.length
	    // which can be overwritten if a developer does
	    // `var length = value;` outside of a function
	    // scope, it'll prevent us from looping through
	    // all the frames. With this, we loop through
	    // until there are no longer any frames
	    while (frameToBroadcastTo = frame.frames[i]) { // eslint-disable-line no-cond-assign
	      _broadcast(frameToBroadcastTo, payload, origin);
	      i++;
	    }
	  } catch (_) { /* ignored */ }
	}
	
	function _broadcastPopups(payload, origin, source) {
	  var i, popup;
	
	  for (i = popups.length - 1; i >= 0; i--) {
	    popup = popups[i];
	
	    if (popup.closed === true) {
	      popups = popups.slice(i, 1);
	    } else if (source !== popup) {
	      _broadcast(popup.top, payload, origin);
	    }
	  }
	}
	
	function _subscribeReplier(fn, origin) {
	  var uuid = _uuid();
	
	  function replier(d, o) {
	    fn(d, o);
	    framebus.target(origin).unsubscribe(uuid, replier);
	  }
	
	  framebus.target(origin).subscribe(uuid, replier);
	  return uuid;
	}
	
	function _subscriptionArgsInvalid(event, fn, origin) {
	  if (_isntString(event)) { return true; }
	  if (typeof fn !== 'function') { return true; }
	  if (_isntString(origin)) { return true; }
	
	  return false;
	}
	
	_attach();
	
	framebus = {
	  target: target,
	  // removeIf(production)
	  _packagePayload: _packagePayload,
	  _unpackPayload: _unpackPayload,
	  _attach: _attach,
	  _detach: _detach,
	  _dispatch: _dispatch,
	  _broadcast: _broadcast,
	  _subscribeReplier: _subscribeReplier,
	  _subscriptionArgsInvalid: _subscriptionArgsInvalid,
	  _onmessage: _onmessage,
	  _uuid: _uuid,
	  _getSubscribers: function () { return subscribers; },
	  _win: function () { return win; },
	  // endRemoveIf(production)
	  include: include,
	  publish: publish,
	  pub: publish,
	  trigger: publish,
	  emit: publish,
	  subscribe: subscribe,
	  sub: subscribe,
	  on: subscribe,
	  unsubscribe: unsubscribe,
	  unsub: unsubscribe,
	  off: unsubscribe
	};
	
	module.exports = framebus;
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],126:[function(require,module,exports){
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };
	
	},{}],127:[function(require,module,exports){
	(function (setImmediate){
	'use strict';
	
	/**
	 * @this {Promise}
	 */
	function finallyConstructor(callback) {
	  var constructor = this.constructor;
	  return this.then(
	    function(value) {
	      // @ts-ignore
	      return constructor.resolve(callback()).then(function() {
	        return value;
	      });
	    },
	    function(reason) {
	      // @ts-ignore
	      return constructor.resolve(callback()).then(function() {
	        // @ts-ignore
	        return constructor.reject(reason);
	      });
	    }
	  );
	}
	
	// Store setTimeout reference so promise-polyfill will be unaffected by
	// other code modifying setTimeout (like sinon.useFakeTimers())
	var setTimeoutFunc = setTimeout;
	
	function isArray(x) {
	  return Boolean(x && typeof x.length !== 'undefined');
	}
	
	function noop() {}
	
	// Polyfill for Function.prototype.bind
	function bind(fn, thisArg) {
	  return function() {
	    fn.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * @constructor
	 * @param {Function} fn
	 */
	function Promise(fn) {
	  if (!(this instanceof Promise))
	    throw new TypeError('Promises must be constructed via new');
	  if (typeof fn !== 'function') throw new TypeError('not a function');
	  /** @type {!number} */
	  this._state = 0;
	  /** @type {!boolean} */
	  this._handled = false;
	  /** @type {Promise|undefined} */
	  this._value = undefined;
	  /** @type {!Array<!Function>} */
	  this._deferreds = [];
	
	  doResolve(fn, this);
	}
	
	function handle(self, deferred) {
	  while (self._state === 3) {
	    self = self._value;
	  }
	  if (self._state === 0) {
	    self._deferreds.push(deferred);
	    return;
	  }
	  self._handled = true;
	  Promise._immediateFn(function() {
	    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	      return;
	    }
	    var ret;
	    try {
	      ret = cb(self._value);
	    } catch (e) {
	      reject(deferred.promise, e);
	      return;
	    }
	    resolve(deferred.promise, ret);
	  });
	}
	
	function resolve(self, newValue) {
	  try {
	    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	    if (newValue === self)
	      throw new TypeError('A promise cannot be resolved with itself.');
	    if (
	      newValue &&
	      (typeof newValue === 'object' || typeof newValue === 'function')
	    ) {
	      var then = newValue.then;
	      if (newValue instanceof Promise) {
	        self._state = 3;
	        self._value = newValue;
	        finale(self);
	        return;
	      } else if (typeof then === 'function') {
	        doResolve(bind(then, newValue), self);
	        return;
	      }
	    }
	    self._state = 1;
	    self._value = newValue;
	    finale(self);
	  } catch (e) {
	    reject(self, e);
	  }
	}
	
	function reject(self, newValue) {
	  self._state = 2;
	  self._value = newValue;
	  finale(self);
	}
	
	function finale(self) {
	  if (self._state === 2 && self._deferreds.length === 0) {
	    Promise._immediateFn(function() {
	      if (!self._handled) {
	        Promise._unhandledRejectionFn(self._value);
	      }
	    });
	  }
	
	  for (var i = 0, len = self._deferreds.length; i < len; i++) {
	    handle(self, self._deferreds[i]);
	  }
	  self._deferreds = null;
	}
	
	/**
	 * @constructor
	 */
	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, self) {
	  var done = false;
	  try {
	    fn(
	      function(value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      },
	      function(reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      }
	    );
	  } catch (ex) {
	    if (done) return;
	    done = true;
	    reject(self, ex);
	  }
	}
	
	Promise.prototype['catch'] = function(onRejected) {
	  return this.then(null, onRejected);
	};
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  // @ts-ignore
	  var prom = new this.constructor(noop);
	
	  handle(this, new Handler(onFulfilled, onRejected, prom));
	  return prom;
	};
	
	Promise.prototype['finally'] = finallyConstructor;
	
	Promise.all = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.all accepts an array'));
	    }
	
	    var args = Array.prototype.slice.call(arr);
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	
	    function res(i, val) {
	      try {
	        if (val && (typeof val === 'object' || typeof val === 'function')) {
	          var then = val.then;
	          if (typeof then === 'function') {
	            then.call(
	              val,
	              function(val) {
	                res(i, val);
	              },
	              reject
	            );
	            return;
	          }
	        }
	        args[i] = val;
	        if (--remaining === 0) {
	          resolve(args);
	        }
	      } catch (ex) {
	        reject(ex);
	      }
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.resolve = function(value) {
	  if (value && typeof value === 'object' && value.constructor === Promise) {
	    return value;
	  }
	
	  return new Promise(function(resolve) {
	    resolve(value);
	  });
	};
	
	Promise.reject = function(value) {
	  return new Promise(function(resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.race accepts an array'));
	    }
	
	    for (var i = 0, len = arr.length; i < len; i++) {
	      Promise.resolve(arr[i]).then(resolve, reject);
	    }
	  });
	};
	
	// Use polyfill for setImmediate for performance gains
	Promise._immediateFn =
	  // @ts-ignore
	  (typeof setImmediate === 'function' &&
	    function(fn) {
	      // @ts-ignore
	      setImmediate(fn);
	    }) ||
	  function(fn) {
	    setTimeoutFunc(fn, 0);
	  };
	
	Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	  if (typeof console !== 'undefined' && console) {
	    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	  }
	};
	
	module.exports = Promise;
	
	}).call(this,require("timers").setImmediate)
	},{"timers":130}],128:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var UA = global.navigator && global.navigator.userAgent;
	
	var isAndroid = require('@braintree/browser-detection/is-android');
	var isChrome = require('@braintree/browser-detection/is-chrome');
	var isIos = require('@braintree/browser-detection/is-ios');
	var isIE9 = require('@braintree/browser-detection/is-ie9');
	
	// Old Android Webviews used specific versions of Chrome with 0.0.0 as their version suffix
	// https://developer.chrome.com/multidevice/user-agent#webview_user_agent
	var KITKAT_WEBVIEW_REGEX = /Version\/\d\.\d* Chrome\/\d*\.0\.0\.0/;
	
	function _isOldSamsungBrowserOrSamsungWebview(ua) {
	  return !isChrome(ua) && ua.indexOf('Samsung') > -1;
	}
	
	function isKitKatWebview(uaArg) {
	  var ua = uaArg || UA;
	
	  return isAndroid(ua) && KITKAT_WEBVIEW_REGEX.test(ua);
	}
	
	function isAndroidChrome(uaArg) {
	  var ua = uaArg || UA;
	
	  return isAndroid(ua) && isChrome(ua);
	}
	
	function isSamsungBrowser(ua) {
	  ua = ua || UA;
	
	  return /SamsungBrowser/.test(ua) || _isOldSamsungBrowserOrSamsungWebview(ua);
	}
	
	module.exports = {
	  isIE9: isIE9,
	  isAndroidChrome: isAndroidChrome,
	  isIos: isIos,
	  isKitKatWebview: isKitKatWebview,
	  isSamsungBrowser: isSamsungBrowser
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"@braintree/browser-detection/is-android":5,"@braintree/browser-detection/is-chrome":6,"@braintree/browser-detection/is-ie9":11,"@braintree/browser-detection/is-ios":15}],129:[function(require,module,exports){
	'use strict';
	
	var device = require('./lib/device');
	
	module.exports = function () {
	  // Digits get dropped in samsung browser
	  return !device.isSamsungBrowser();
	};
	
	},{"./lib/device":128}],130:[function(require,module,exports){
	(function (setImmediate,clearImmediate){
	var nextTick = require('process/browser.js').nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	}).call(this,require("timers").setImmediate,require("timers").clearImmediate)
	},{"process/browser.js":126,"timers":130}],131:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  paymentOptionIDs: {
	    card: 'card',
	    paypal: 'paypal',
	    paypalCredit: 'paypalCredit',
	    applePay: 'applePay',
	    venmo: 'venmo',
	    googlePay: 'googlePay'
	  },
	  paymentMethodTypes: {
	    card: 'CreditCard',
	    paypal: 'PayPalAccount',
	    paypalCredit: 'PayPalAccount',
	    applePay: 'ApplePayCard',
	    venmo: 'VenmoAccount',
	    googlePay: 'AndroidPayCard'
	  },
	  analyticsKinds: {
	    CreditCard: 'card',
	    PayPalAccount: 'paypal',
	    ApplePayCard: 'applepay',
	    VenmoAccount: 'venmo',
	    AndroidPayCard: 'googlepay'
	  },
	  paymentMethodCardTypes: {
	    Visa: 'visa',
	    MasterCard: 'master-card',
	    'American Express': 'american-express',
	    'Diners Club': 'diners-club',
	    Discover: 'discover',
	    JCB: 'jcb',
	    UnionPay: 'unionpay',
	    Maestro: 'maestro'
	  },
	  configurationCardTypes: {
	    visa: 'Visa',
	    'master-card': 'MasterCard',
	    'american-express': 'American Express',
	    'diners-club': 'Discover',
	    discover: 'Discover',
	    jcb: 'JCB',
	    unionpay: 'UnionPay',
	    maestro: 'Maestro'
	  },
	  errors: {
	    NO_PAYMENT_METHOD_ERROR: 'No payment method is available.',
	    DEVELOPER_MISCONFIGURATION_MESSAGE: 'Developer Error: Something went wrong. Check the console for details.'
	  },
	  ANALYTICS_REQUEST_TIMEOUT_MS: 2000,
	  ANALYTICS_PREFIX: 'web.dropin.',
	  CHANGE_ACTIVE_PAYMENT_METHOD_TIMEOUT: 200,
	  CHECKOUT_JS_SOURCE: 'https://www.paypalobjects.com/api/checkout.min.js',
	  GOOGLE_PAYMENT_SOURCE: 'https://pay.google.com/gp/p/js/pay.js',
	  INTEGRATION: 'dropin2',
	  PAYPAL_CHECKOUT_SCRIPT_ID: 'braintree-dropin-paypal-checkout-script',
	  GOOGLE_PAYMENT_SCRIPT_ID: 'braintree-dropin-google-payment-script',
	  DATA_COLLECTOR_SCRIPT_ID: 'braintree-dropin-data-collector-script',
	  STYLESHEET_ID: 'braintree-dropin-stylesheet'
	};
	
	},{}],132:[function(require,module,exports){
	'use strict';
	
	var analytics = require('./lib/analytics');
	var DropinError = require('./lib/dropin-error');
	var EventEmitter = require('@braintree/event-emitter');
	var constants = require('./constants');
	var paymentMethodTypes = constants.paymentMethodTypes;
	var paymentOptionIDs = constants.paymentOptionIDs;
	var isGuestCheckout = require('./lib/is-guest-checkout');
	var Promise = require('./lib/promise');
	var paymentSheetViews = require('./views/payment-sheet-views');
	var vaultManager = require('braintree-web/vault-manager');
	
	var VAULTED_PAYMENT_METHOD_TYPES_THAT_SHOULD_BE_HIDDEN = [
	  paymentMethodTypes.applePay,
	  paymentMethodTypes.googlePay,
	  paymentMethodTypes.venmo
	];
	var DEFAULT_PAYMENT_OPTION_PRIORITY = [
	  paymentOptionIDs.card,
	  paymentOptionIDs.paypal,
	  paymentOptionIDs.paypalCredit,
	  paymentOptionIDs.venmo,
	  paymentOptionIDs.applePay,
	  paymentOptionIDs.googlePay
	];
	
	function DropinModel(options) {
	  this.componentID = options.componentID;
	  this.merchantConfiguration = options.merchantConfiguration;
	
	  this.isGuestCheckout = isGuestCheckout(options.client);
	
	  this.dependenciesInitializing = 0;
	  this.dependencySuccessCount = 0;
	  this.failedDependencies = {};
	  this._options = options;
	  this._setupComplete = false;
	
	  EventEmitter.call(this);
	}
	
	EventEmitter.createChild(DropinModel);
	
	DropinModel.prototype.initialize = function () {
	  var self = this;
	
	  return vaultManager.create({
	    client: self._options.client
	  }).then(function (vaultManagerInstance) {
	    self._vaultManager = vaultManagerInstance;
	
	    return getSupportedPaymentOptions(self._options);
	  }).then(function (paymentOptions) {
	    self.supportedPaymentOptions = paymentOptions;
	
	    return self.getVaultedPaymentMethods();
	  }).then(function (paymentMethods) {
	    self._paymentMethods = paymentMethods;
	    self._paymentMethodIsRequestable = self._paymentMethods.length > 0;
	  });
	};
	
	DropinModel.prototype.confirmDropinReady = function () {
	  this._setupComplete = true;
	};
	
	DropinModel.prototype.isPaymentMethodRequestable = function () {
	  return Boolean(this._paymentMethodIsRequestable);
	};
	
	DropinModel.prototype.addPaymentMethod = function (paymentMethod) {
	  this._paymentMethods.push(paymentMethod);
	  this._emit('addPaymentMethod', paymentMethod);
	  this.changeActivePaymentMethod(paymentMethod);
	};
	
	DropinModel.prototype.removePaymentMethod = function (paymentMethod) {
	  var paymentMethodLocation = this._paymentMethods.indexOf(paymentMethod);
	
	  if (paymentMethodLocation === -1) {
	    return;
	  }
	
	  this._paymentMethods.splice(paymentMethodLocation, 1);
	  this._emit('removePaymentMethod', paymentMethod);
	};
	
	DropinModel.prototype.refreshPaymentMethods = function () {
	  var self = this;
	
	  return self.getVaultedPaymentMethods().then(function (paymentMethods) {
	    self._paymentMethods = paymentMethods;
	
	    self._emit('refreshPaymentMethods');
	  });
	};
	
	DropinModel.prototype.changeActivePaymentMethod = function (paymentMethod) {
	  this._activePaymentMethod = paymentMethod;
	  this._emit('changeActivePaymentMethod', paymentMethod);
	};
	
	DropinModel.prototype.changeActivePaymentView = function (paymentViewID) {
	  this._activePaymentView = paymentViewID;
	  this._emit('changeActivePaymentView', paymentViewID);
	};
	
	DropinModel.prototype.removeActivePaymentMethod = function () {
	  this._activePaymentMethod = null;
	  this._emit('removeActivePaymentMethod');
	  this.setPaymentMethodRequestable({
	    isRequestable: false
	  });
	};
	
	DropinModel.prototype.selectPaymentOption = function (paymentViewID) {
	  this._emit('paymentOptionSelected', {
	    paymentOption: paymentViewID
	  });
	};
	
	DropinModel.prototype.enableEditMode = function () {
	  analytics.sendEvent(this._options.client, 'manager.appeared');
	  this._isInEditMode = true;
	  this._emit('enableEditMode');
	};
	
	DropinModel.prototype.disableEditMode = function () {
	  this._isInEditMode = false;
	  this._emit('disableEditMode');
	};
	
	DropinModel.prototype.isInEditMode = function () {
	  return Boolean(this._isInEditMode);
	};
	
	DropinModel.prototype.confirmPaymentMethodDeletion = function (paymentMethod) {
	  this._paymentMethodWaitingToBeDeleted = paymentMethod;
	  this._emit('confirmPaymentMethodDeletion', paymentMethod);
	};
	
	DropinModel.prototype._shouldEmitRequestableEvent = function (options) {
	  var requestableStateHasNotChanged = this.isPaymentMethodRequestable() === options.isRequestable;
	  var typeHasNotChanged = options.type === this._paymentMethodRequestableType;
	
	  if (!this._setupComplete) {
	    // don't emit event until after Drop-in is fully set up
	    // fixes issues with lazy loading of imports where event
	    // should not be emitted
	    // https://github.com/braintree/braintree-web-drop-in/issues/511
	    return false;
	  }
	
	  if (requestableStateHasNotChanged && (!options.isRequestable || typeHasNotChanged)) {
	    return false;
	  }
	
	  return true;
	};
	
	DropinModel.prototype.setPaymentMethodRequestable = function (options) {
	  var shouldEmitEvent = this._shouldEmitRequestableEvent(options);
	  var paymentMethodRequestableResponse = {
	    paymentMethodIsSelected: Boolean(options.selectedPaymentMethod),
	    type: options.type
	  };
	
	  this._paymentMethodIsRequestable = options.isRequestable;
	
	  if (options.isRequestable) {
	    this._paymentMethodRequestableType = options.type;
	  } else {
	    delete this._paymentMethodRequestableType;
	  }
	
	  if (!shouldEmitEvent) {
	    return;
	  }
	
	  if (options.isRequestable) {
	    this._emit('paymentMethodRequestable', paymentMethodRequestableResponse);
	  } else {
	    this._emit('noPaymentMethodRequestable');
	  }
	};
	
	DropinModel.prototype.getPaymentMethods = function () {
	  // we want to return a copy of the Array
	  // so we can loop through it in dropin.updateConfiguration
	  // while calling model.removePaymentMethod
	  // which updates the original array
	  return this._paymentMethods.slice();
	};
	
	DropinModel.prototype.getActivePaymentMethod = function () {
	  return this._activePaymentMethod;
	};
	
	DropinModel.prototype.getActivePaymentView = function () {
	  return this._activePaymentView;
	};
	
	DropinModel.prototype.reportAppSwitchPayload = function (payload) {
	  this.appSwitchPayload = payload;
	};
	
	DropinModel.prototype.reportAppSwitchError = function (sheetId, error) {
	  this.appSwitchError = {
	    id: sheetId,
	    error: error
	  };
	};
	
	DropinModel.prototype.asyncDependencyStarting = function () {
	  this.dependenciesInitializing++;
	};
	
	DropinModel.prototype.asyncDependencyReady = function () {
	  this.dependencySuccessCount++;
	  this.dependenciesInitializing--;
	  this._checkAsyncDependencyFinished();
	};
	
	DropinModel.prototype.asyncDependencyFailed = function (options) {
	  if (this.failedDependencies.hasOwnProperty(options.view)) {
	    return;
	  }
	  this.failedDependencies[options.view] = options.error;
	  this.dependenciesInitializing--;
	  this._checkAsyncDependencyFinished();
	};
	
	DropinModel.prototype._checkAsyncDependencyFinished = function () {
	  if (this.dependenciesInitializing === 0) {
	    this._emit('asyncDependenciesReady');
	  }
	};
	
	DropinModel.prototype.cancelInitialization = function (error) {
	  this._emit('cancelInitialization', error);
	};
	
	DropinModel.prototype.reportError = function (error) {
	  this._emit('errorOccurred', error);
	};
	
	DropinModel.prototype.clearError = function () {
	  this._emit('errorCleared');
	};
	
	DropinModel.prototype.preventUserAction = function () {
	  this._emit('preventUserAction');
	};
	
	DropinModel.prototype.allowUserAction = function () {
	  this._emit('allowUserAction');
	};
	
	DropinModel.prototype.deleteVaultedPaymentMethod = function () {
	  var self = this;
	  var promise = Promise.resolve();
	  var error;
	
	  this._emit('startVaultedPaymentMethodDeletion');
	
	  if (!self.isGuestCheckout) {
	    promise = this._vaultManager.deletePaymentMethod(this._paymentMethodWaitingToBeDeleted.nonce).catch(function (err) {
	      error = err;
	    });
	  }
	
	  return promise.then(function () {
	    delete self._paymentMethodWaitingToBeDeleted;
	
	    return self.refreshPaymentMethods();
	  }).then(function () {
	    self.disableEditMode();
	    self._emit('finishVaultedPaymentMethodDeletion', error);
	  });
	};
	
	DropinModel.prototype.cancelDeleteVaultedPaymentMethod = function () {
	  this._emit('cancelVaultedPaymentMethodDeletion');
	
	  delete this._paymentMethodWaitingToBeDeleted;
	};
	
	DropinModel.prototype.getVaultedPaymentMethods = function () {
	  var self = this;
	
	  if (self.isGuestCheckout) {
	    return Promise.resolve([]);
	  }
	
	  return self._vaultManager.fetchPaymentMethods({
	    defaultFirst: true
	  }).then(function (paymentMethods) {
	    return self._getSupportedPaymentMethods(paymentMethods).map(function (paymentMethod) {
	      paymentMethod.vaulted = true;
	
	      return paymentMethod;
	    });
	  }).catch(function () {
	    return Promise.resolve([]);
	  });
	};
	
	DropinModel.prototype._getSupportedPaymentMethods = function (paymentMethods) {
	  var supportedPaymentMethods = this.supportedPaymentOptions.reduce(function (array, key) {
	    var paymentMethodType = paymentMethodTypes[key];
	
	    if (canShowVaultedPaymentMethodType(paymentMethodType)) {
	      array.push(paymentMethodType);
	    }
	
	    return array;
	  }, []);
	
	  return paymentMethods.filter(function (paymentMethod) {
	    return supportedPaymentMethods.indexOf(paymentMethod.type) > -1;
	  });
	};
	
	function getSupportedPaymentOptions(options) {
	  var paymentOptionPriority = options.merchantConfiguration.paymentOptionPriority || DEFAULT_PAYMENT_OPTION_PRIORITY;
	  var promises;
	
	  if (!(paymentOptionPriority instanceof Array)) {
	    throw new DropinError('paymentOptionPriority must be an array.');
	  }
	
	  // Remove duplicates
	  paymentOptionPriority = paymentOptionPriority.filter(function (item, pos) { return paymentOptionPriority.indexOf(item) === pos; });
	
	  promises = paymentOptionPriority.map(function (paymentOption) {
	    return getPaymentOption(paymentOption, options);
	  });
	
	  return Promise.all(promises).then(function (result) {
	    result = result.filter(function (item) {
	      return item.success;
	    });
	
	    if (result.length === 0) {
	      return Promise.reject(new DropinError('No valid payment options available.'));
	    }
	
	    return result.map(function (item) { return item.id; });
	  });
	}
	
	function getPaymentOption(paymentOption, options) {
	  return isPaymentOptionEnabled(paymentOption, options).then(function (success) {
	    return {
	      success: success,
	      id: paymentOptionIDs[paymentOption]
	    };
	  });
	}
	
	function isPaymentOptionEnabled(paymentOption, options) {
	  var SheetView = paymentSheetViews[paymentOptionIDs[paymentOption]];
	
	  if (!SheetView) {
	    return Promise.reject(new DropinError('paymentOptionPriority: Invalid payment option specified.'));
	  }
	
	  return SheetView.isEnabled({
	    client: options.client,
	    merchantConfiguration: options.merchantConfiguration
	  }).catch(function (error) {
	    console.error(SheetView.ID + ' view errored when checking if it was supported.'); // eslint-disable-line no-console
	    console.error(error); // eslint-disable-line no-console
	
	    return Promise.resolve(false);
	  });
	}
	
	function canShowVaultedPaymentMethodType(paymentMethodType) {
	  return paymentMethodType && VAULTED_PAYMENT_METHOD_TYPES_THAT_SHOULD_BE_HIDDEN.indexOf(paymentMethodType) === -1;
	}
	
	module.exports = DropinModel;
	
	},{"./constants":131,"./lib/analytics":136,"./lib/dropin-error":141,"./lib/is-guest-checkout":143,"./lib/promise":148,"./views/payment-sheet-views":188,"@braintree/event-emitter":19,"braintree-web/vault-manager":110}],133:[function(require,module,exports){
	'use strict';
	
	var assign = require('./lib/assign').assign;
	var analytics = require('./lib/analytics');
	var classList = require('@braintree/class-list');
	var constants = require('./constants');
	var DropinError = require('./lib/dropin-error');
	var DropinModel = require('./dropin-model');
	var EventEmitter = require('@braintree/event-emitter');
	var assets = require('@braintree/asset-loader');
	
	var MainView = require('./views/main-view');
	var paymentMethodsViewID = require('./views/payment-methods-view').ID;
	var paymentOptionsViewID = require('./views/payment-options-view').ID;
	var paymentOptionIDs = constants.paymentOptionIDs;
	var translations = require('./translations').translations;
	var isUtf8 = require('./lib/is-utf-8');
	var uuid = require('./lib/uuid');
	var Promise = require('./lib/promise');
	var sanitizeHtml = require('./lib/sanitize-html');
	var DataCollector = require('./lib/data-collector');
	var ThreeDSecure = require('./lib/three-d-secure');
	var wrapPrototype = require('@braintree/wrap-promise').wrapPrototype;
	
	var mainHTML = "<div class=\"braintree-dropin\">\n  <div data-braintree-id=\"methods-label\" class=\"braintree-heading\">&nbsp;</div>\n  <div data-braintree-id=\"methods-edit\" class=\"braintree-hidden braintree-heading\">{{edit}}</div>\n  <div data-braintree-id=\"choose-a-way-to-pay\" class=\"braintree-heading\">{{chooseAWayToPay}}</div>\n  <div class=\"braintree-placeholder\">&nbsp;</div>\n\n  <div data-braintree-id=\"upper-container\" class=\"braintree-upper-container\">\n    <div data-braintree-id=\"loading-container\" class=\"braintree-loader__container\">\n      <div data-braintree-id=\"loading-indicator\" class=\"braintree-loader__indicator\">\n        <svg width=\"14\" height=\"16\" class=\"braintree-loader__lock\">\n          <use xlink:href=\"#iconLockLoader\"></use>\n        </svg>\n      </div>\n    </div>\n\n    <div data-braintree-id=\"delete-confirmation\" class=\"braintree-delete-confirmation braintree-sheet\">\n      <div data-braintree-id=\"delete-confirmation__message\"></div>\n      <div class=\"braintree-delete-confirmation__button-container\">\n        <div role=\"button\" data-braintree-id=\"delete-confirmation__no\" class=\"braintree-delete-confirmation__button\">{{deleteCancelButton}}</div>\n        <div role=\"button\" data-braintree-id=\"delete-confirmation__yes\" class=\"braintree-delete-confirmation__button\">{{deleteConfirmationButton}}</div>\n      </div>\n    </div>\n\n    <div data-braintree-id=\"methods\" class=\"braintree-methods braintree-methods-initial\">\n      <div data-braintree-id=\"methods-container\"></div>\n    </div>\n\n    <div data-braintree-id=\"options\" class=\"braintree-test-class braintree-options braintree-options-initial\">\n      <div data-braintree-id=\"payment-options-container\" class=\"braintree-options-list\"></div>\n    </div>\n\n    <div data-braintree-id=\"sheet-container\" class=\"braintree-sheet__container\">\n      <div data-braintree-id=\"paypal\" class=\"braintree-paypal braintree-sheet\">\n        <div data-braintree-id=\"paypal-sheet-header\" class=\"braintree-sheet__header\">\n          <div class=\"braintree-sheet__header-label\">\n            <div class=\"braintree-sheet__logo--header\">\n              <svg width=\"40\" height=\"24\">\n                <use xlink:href=\"#logoPayPal\"></use>\n              </svg>\n            </div>\n            <div class=\"braintree-sheet__label\">{{PayPal}}</div>\n          </div>\n        </div>\n        <div class=\"braintree-sheet__content braintree-sheet__content--button\">\n          <div data-braintree-id=\"paypal-button\" class=\"braintree-sheet__button--paypal\"></div>\n        </div>\n      </div>\n      <div data-braintree-id=\"paypalCredit\" class=\"braintree-paypalCredit braintree-sheet\">\n        <div data-braintree-id=\"paypal-credit-sheet-header\" class=\"braintree-sheet__header\">\n          <div class=\"braintree-sheet__header-label\">\n            <div class=\"braintree-sheet__logo--header\">\n              <svg width=\"40\" height=\"24\">\n                <use xlink:href=\"#logoPayPalCredit\"></use>\n              </svg>\n            </div>\n            <div class=\"braintree-sheet__label\">{{PayPal Credit}}</div>\n          </div>\n        </div>\n        <div class=\"braintree-sheet__content braintree-sheet__content--button\">\n          <div data-braintree-id=\"paypal-credit-button\" class=\"braintree-sheet__button--paypal\"></div>\n        </div>\n      </div>\n      <div data-braintree-id=\"applePay\" class=\"braintree-applePay braintree-sheet\">\n        <div data-braintree-id=\"apple-pay-sheet-header\" class=\"braintree-sheet__header\">\n          <div class=\"braintree-sheet__header-label\">\n            <div class=\"braintree-sheet__logo--header\">\n              <svg height=\"24\" width=\"40\">\n              <use xlink:href=\"#logoApplePay\"></use>\n              </svg>\n            </div>\n            <div class=\"braintree-sheet__label\">{{Apple Pay}}</div>\n          </div>\n        </div>\n        <div class=\"braintree-sheet__content braintree-sheet__content--button\">\n          <div data-braintree-id=\"apple-pay-button\" class=\"braintree-sheet__button--apple-pay apple-pay-button\"></div>\n        </div>\n      </div>\n      <div data-braintree-id=\"googlePay\" class=\"braintree-googlePay braintree-sheet\">\n        <div data-braintree-id=\"google-pay-sheet-header\" class=\"braintree-sheet__header\">\n          <div class=\"braintree-sheet__header-label\">\n            <div class=\"braintree-sheet__logo--header\">\n              <svg height=\"24\" width=\"40\">\n              <use xlink:href=\"#logoGooglePay\"></use>\n              </svg>\n            </div>\n            <div class=\"braintree-sheet__label\">{{Google Pay}}</div>\n          </div>\n        </div>\n        <div class=\"braintree-sheet__content braintree-sheet__content--button\">\n          <div data-braintree-id=\"google-pay-button\"></div>\n        </div>\n      </div>\n      <div data-braintree-id=\"venmo\" class=\"braintree-venmo braintree-sheet\">\n        <div data-braintree-id=\"venmo-sheet-header\" class=\"braintree-sheet__header\">\n          <div class=\"braintree-sheet__header-label\">\n            <div class=\"braintree-sheet__logo--header\">\n              <svg height=\"24\" width=\"40\">\n              <use xlink:href=\"#logoVenmo\"></use>\n              </svg>\n            </div>\n            <div class=\"braintree-sheet__label\">{{Venmo}}</div>\n          </div>\n        </div>\n        <div class=\"braintree-sheet__content braintree-sheet__content--button\">\n          <svg data-braintree-id=\"venmo-button\" class=\"braintree-sheet__button--venmo\">\n            <use xlink:href=\"#buttonVenmo\"></use>\n          </svg>\n        </div>\n      </div>\n      <div data-braintree-id=\"card\" class=\"braintree-card braintree-form braintree-sheet\">\n        <div data-braintree-id=\"card-sheet-header\" class=\"braintree-sheet__header\">\n          <div class=\"braintree-sheet__header-label\">\n            <div class=\"braintree-sheet__logo--header\">\n              <svg width=\"40\" height=\"24\" class=\"braintree-icon--bordered\">\n                <use xlink:href=\"#iconCardFront\"></use>\n              </svg>\n            </div>\n            <div class=\"braintree-sheet__text\">{{payWithCard}}</div>\n          </div>\n          <div data-braintree-id=\"card-view-icons\" class=\"braintree-sheet__icons\"></div>\n        </div>\n        <div class=\"braintree-sheet__content braintree-sheet__content--form\">\n          <div data-braintree-id=\"cardholder-name-field-group\" class=\"braintree-form__field-group\">\n            <label for=\"braintree__card-view-input__cardholder-name\">\n              <div class=\"braintree-form__label\">{{cardholderNameLabel}}</div>\n              <div class=\"braintree-form__field\">\n                <div class=\"braintree-form-cardholder-name braintree-form__hosted-field\">\n                  <input class=\"braintree-form__raw-input\" id=\"braintree__card-view-input__cardholder-name\" type=\"text\" placeholder=\"{{cardholderNamePlaceholder}}\"/>\n                </div>\n                <div class=\"braintree-form__icon-container\">\n                  <div class=\"braintree-form__icon braintree-form__field-error-icon\">\n                    <svg width=\"24\" height=\"24\">\n                      <use xlink:href=\"#iconError\"></use>\n                    </svg>\n                  </div>\n                </div>\n              </div>\n            </label>\n            <div data-braintree-id=\"cardholder-name-field-error\" class=\"braintree-form__field-error\"></div>\n          </div>\n          <div data-braintree-id=\"number-field-group\" class=\"braintree-form__field-group\">\n            <label>\n              <div class=\"braintree-form__label\">{{cardNumberLabel}}</div>\n              <div class=\"braintree-form__field\">\n                <div class=\"braintree-form-number braintree-form__hosted-field\"></div>\n                <div class=\"braintree-form__icon-container\">\n                  <div data-braintree-id=\"card-number-icon\" class=\"braintree-form__icon braintree-form__field-secondary-icon\">\n                    <svg width=\"40\" height=\"24\" class=\"braintree-icon--bordered\">\n                    <use data-braintree-id=\"card-number-icon-svg\" xlink:href=\"#iconCardFront\"></use>\n                    </svg>\n                  </div>\n                  <div class=\"braintree-form__icon braintree-form__field-error-icon\">\n                    <svg width=\"24\" height=\"24\">\n                      <use xlink:href=\"#iconError\"></use>\n                    </svg>\n                  </div>\n                </div>\n              </div>\n            </label>\n            <div data-braintree-id=\"number-field-error\" class=\"braintree-form__field-error\"></div>\n          </div>\n\n          <div class=\"braintree-form__flexible-fields\">\n            <div data-braintree-id=\"expiration-date-field-group\" class=\"braintree-form__field-group\">\n              <label>\n                <div class=\"braintree-form__label\">{{expirationDateLabel}}\n                  <span class=\"braintree-form__descriptor\">{{expirationDateLabelSubheading}}</span>\n                </div>\n                <div class=\"braintree-form__field\">\n                  <div class=\"braintree-form__hosted-field braintree-form-expiration\"></div>\n                  <div class=\"braintree-form__icon-container\">\n                    <div class=\"braintree-form__icon braintree-form__field-error-icon\">\n                      <svg width=\"24\" height=\"24\">\n                        <use xlink:href=\"#iconError\"></use>\n                      </svg>\n                    </div>\n                  </div>\n                </div>\n              </label>\n              <div data-braintree-id=\"expiration-date-field-error\" class=\"braintree-form__field-error\"></div>\n            </div>\n\n\n            <div data-braintree-id=\"cvv-field-group\" class=\"braintree-form__field-group\">\n              <label>\n                <div class=\"braintree-form__label\">{{cvvLabel}}\n                  <span data-braintree-id=\"cvv-label-descriptor\" class=\"braintree-form__descriptor\">{{cvvThreeDigitLabelSubheading}}</span>\n                </div>\n                <div class=\"braintree-form__field\">\n                  <div class=\"braintree-form__hosted-field braintree-form-cvv\"></div>\n                  <div class=\"braintree-form__icon-container\">\n                    <div data-braintree-id=\"cvv-icon\" class=\"braintree-form__icon braintree-form__field-secondary-icon\">\n                      <svg width=\"40\" height=\"24\" class=\"braintree-icon--bordered\">\n                      <use data-braintree-id=\"cvv-icon-svg\" xlink:href=\"#iconCVVBack\"></use>\n                      </svg>\n                    </div>\n                    <div class=\"braintree-form__icon braintree-form__field-error-icon\">\n                      <svg width=\"24\" height=\"24\">\n                        <use xlink:href=\"#iconError\"></use>\n                      </svg>\n                    </div>\n                  </div>\n                </div>\n              </label>\n              <div data-braintree-id=\"cvv-field-error\" class=\"braintree-form__field-error\"></div>\n            </div>\n\n            <div data-braintree-id=\"postal-code-field-group\" class=\"braintree-form__field-group\">\n              <label>\n                <div class=\"braintree-form__label\">{{postalCodeLabel}}</div>\n                <div class=\"braintree-form__field\">\n                  <div class=\"braintree-form__hosted-field braintree-form-postal-code\"></div>\n                  <div class=\"braintree-form__icon-container\">\n                    <div class=\"braintree-form__icon braintree-form__field-error-icon\">\n                      <svg width=\"24\" height=\"24\">\n                        <use xlink:href=\"#iconError\"></use>\n                      </svg>\n                    </div>\n                  </div>\n                </div>\n              </label>\n              <div data-braintree-id=\"postal-code-field-error\" class=\"braintree-form__field-error\"></div>\n            </div>\n          </div>\n\n          <div data-braintree-id=\"save-card-field-group\" class=\"braintree-form__field-group braintree-hidden\">\n            <label>\n              <div class=\"braintree-form__field braintree-form__checkbox\">\n                <input type=\"checkbox\" data-braintree-id=\"save-card-input\" checked />\n              </div>\n              <div class=\"braintree-form__label\">{{saveCardLabel}}</div>\n            </label>\n          </div>\n        </div>\n      </div>\n\n      <div data-braintree-id=\"sheet-error\" class=\"braintree-sheet__error\">\n        <div class=\"braintree-form__icon braintree-sheet__error-icon\">\n          <svg width=\"24\" height=\"24\">\n            <use xlink:href=\"#iconError\"></use>\n          </svg>\n        </div>\n        <div data-braintree-id=\"sheet-error-text\" class=\"braintree-sheet__error-text\"></div>\n      </div>\n    </div>\n  </div>\n\n  <div data-braintree-id=\"lower-container\" class=\"braintree-test-class braintree-options braintree-hidden\">\n    <div data-braintree-id=\"other-ways-to-pay\" class=\"braintree-heading\">{{otherWaysToPay}}</div>\n  </div>\n\n  <div data-braintree-id=\"toggle\" class=\"braintree-large-button braintree-toggle braintree-hidden\" tabindex=\"0\">\n    <span>{{chooseAnotherWayToPay}}</span>\n  </div>\n</div>\n<div data-braintree-id=\"disable-wrapper\" class=\"braintree-dropin__disabled braintree-hidden\"></div>\n";
	var svgHTML = "<svg data-braintree-id=\"svgs\" style=\"display: none\">\n  <defs>\n    <symbol id=\"icon-visa\" viewBox=\"0 0 40 24\">\n      <title>Visa</title>\n      <path d=\"M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z\" style=\"fill: #FFF\" />\n      <path d=\"M0 22.033C0 23.12.892 24 1.992 24h36.016c1.1 0 1.992-.88 1.992-1.967V20.08H0v1.953z\" style=\"fill: #F8B600\" />\n      <path d=\"M0 3.92h40V1.967C40 .88 39.108 0 38.008 0H1.992C.892 0 0 .88 0 1.967V3.92zM19.596 7.885l-2.11 9.478H14.93l2.11-9.478h2.554zm10.743 6.12l1.343-3.56.773 3.56H30.34zm2.85 3.358h2.36l-2.063-9.478H31.31c-.492 0-.905.274-1.088.695l-3.832 8.783h2.682l.532-1.415h3.276l.31 1.415zm-6.667-3.094c.01-2.502-3.6-2.64-3.577-3.76.008-.338.345-.7 1.083-.793.365-.045 1.373-.08 2.517.425l.448-2.01c-.615-.214-1.405-.42-2.39-.42-2.523 0-4.3 1.288-4.313 3.133-.016 1.364 1.268 2.125 2.234 2.58.996.464 1.33.762 1.325 1.177-.006.636-.793.918-1.526.928-1.285.02-2.03-.333-2.623-.6l-.462 2.08c.598.262 1.7.49 2.84.502 2.682 0 4.437-1.273 4.445-3.243zM15.948 7.884l-4.138 9.478h-2.7L7.076 9.8c-.123-.466-.23-.637-.606-.834-.615-.32-1.63-.62-2.52-.806l.06-.275h4.345c.554 0 1.052.354 1.178.966l1.076 5.486 2.655-6.45h2.683z\" style=\"fill: #1A1F71\" />\n    </symbol>\n\n    <symbol id=\"icon-master-card\" viewBox=\"0 0 40 24\">\n      <title>MasterCard</title>\n      <path d=\"M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z\" style=\"fill: #FFF\" />\n      <path d=\"M11.085 22.2v-1.36c0-.522-.318-.863-.864-.863-.272 0-.568.09-.773.386-.16-.25-.386-.386-.727-.386-.228 0-.455.068-.637.318v-.272h-.478V22.2h.478v-1.202c0-.386.204-.567.523-.567.318 0 .478.205.478.568V22.2h.477v-1.202c0-.386.23-.567.524-.567.32 0 .478.205.478.568V22.2h.523zm7.075-2.177h-.774v-.658h-.478v.658h-.432v.43h.432v.998c0 .5.205.795.75.795.206 0 .433-.068.592-.16l-.136-.407c-.136.09-.296.114-.41.114-.227 0-.318-.137-.318-.363v-.976h.774v-.43zm4.048-.046c-.273 0-.454.136-.568.318v-.272h-.478V22.2h.478v-1.225c0-.363.16-.567.455-.567.09 0 .204.023.295.046l.137-.454c-.09-.023-.228-.023-.32-.023zm-6.118.227c-.228-.16-.546-.227-.888-.227-.546 0-.91.272-.91.703 0 .363.274.567.75.635l.23.023c.25.045.385.113.385.227 0 .16-.182.272-.5.272-.32 0-.57-.113-.728-.227l-.228.363c.25.18.59.272.932.272.637 0 1-.295 1-.703 0-.385-.295-.59-.75-.658l-.227-.022c-.205-.023-.364-.068-.364-.204 0-.16.16-.25.41-.25.272 0 .545.114.682.182l.205-.386zm12.692-.227c-.273 0-.455.136-.568.318v-.272h-.478V22.2h.478v-1.225c0-.363.16-.567.455-.567.09 0 .203.023.294.046L29.1 20c-.09-.023-.227-.023-.318-.023zm-6.096 1.134c0 .66.455 1.135 1.16 1.135.32 0 .546-.068.774-.25l-.228-.385c-.182.136-.364.204-.57.204-.385 0-.658-.272-.658-.703 0-.407.273-.68.66-.702.204 0 .386.068.568.204l.228-.385c-.228-.182-.455-.25-.774-.25-.705 0-1.16.477-1.16 1.134zm4.413 0v-1.087h-.48v.272c-.158-.204-.385-.318-.68-.318-.615 0-1.093.477-1.093 1.134 0 .66.478 1.135 1.092 1.135.317 0 .545-.113.68-.317v.272h.48v-1.09zm-1.753 0c0-.384.25-.702.66-.702.387 0 .66.295.66.703 0 .387-.273.704-.66.704-.41-.022-.66-.317-.66-.703zm-5.71-1.133c-.636 0-1.09.454-1.09 1.134 0 .682.454 1.135 1.114 1.135.32 0 .638-.09.888-.295l-.228-.34c-.18.136-.41.227-.636.227-.296 0-.592-.136-.66-.522h1.615v-.18c.022-.704-.388-1.158-1.002-1.158zm0 .41c.297 0 .502.18.547.52h-1.137c.045-.295.25-.52.59-.52zm11.852.724v-1.95h-.48v1.135c-.158-.204-.385-.318-.68-.318-.615 0-1.093.477-1.093 1.134 0 .66.478 1.135 1.092 1.135.318 0 .545-.113.68-.317v.272h.48v-1.09zm-1.752 0c0-.384.25-.702.66-.702.386 0 .66.295.66.703 0 .387-.274.704-.66.704-.41-.022-.66-.317-.66-.703zm-15.97 0v-1.087h-.476v.272c-.16-.204-.387-.318-.683-.318-.615 0-1.093.477-1.093 1.134 0 .66.478 1.135 1.092 1.135.318 0 .545-.113.682-.317v.272h.477v-1.09zm-1.773 0c0-.384.25-.702.66-.702.386 0 .66.295.66.703 0 .387-.274.704-.66.704-.41-.022-.66-.317-.66-.703z\" style=\"fill: #000\" />\n      <path style=\"fill: #FF5F00\" d=\"M23.095 3.49H15.93v12.836h7.165\" />\n      <path d=\"M16.382 9.91c0-2.61 1.23-4.922 3.117-6.42-1.39-1.087-3.14-1.745-5.05-1.745-4.528 0-8.19 3.65-8.19 8.164 0 4.51 3.662 8.162 8.19 8.162 1.91 0 3.66-.657 5.05-1.746-1.89-1.474-3.118-3.81-3.118-6.417z\" style=\"fill: #EB001B\" />\n      <path d=\"M32.76 9.91c0 4.51-3.664 8.162-8.19 8.162-1.91 0-3.662-.657-5.05-1.746 1.91-1.496 3.116-3.81 3.116-6.417 0-2.61-1.228-4.922-3.116-6.42 1.388-1.087 3.14-1.745 5.05-1.745 4.526 0 8.19 3.674 8.19 8.164z\" style=\"fill: #F79E1B\" />\n    </symbol>\n\n    <symbol id=\"icon-unionpay\" viewBox=\"0 0 40 24\">\n      <title>Union Pay</title>\n      <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: #FFF\" />\n      <path d=\"M9.877 2h8.126c1.135 0 1.84.93 1.575 2.077l-3.783 16.35c-.267 1.142-1.403 2.073-2.538 2.073H5.13c-1.134 0-1.84-.93-1.574-2.073L7.34 4.076C7.607 2.93 8.74 2 9.878 2z\" style=\"fill: #E21836\" />\n      <path d=\"M17.325 2h9.345c1.134 0 .623.93.356 2.077l-3.783 16.35c-.265 1.142-.182 2.073-1.32 2.073H12.58c-1.137 0-1.84-.93-1.574-2.073l3.783-16.35C15.056 2.93 16.19 2 17.324 2z\" style=\"fill: #00447B\" />\n      <path d=\"M26.3 2h8.126c1.136 0 1.84.93 1.575 2.077l-3.782 16.35c-.266 1.142-1.402 2.073-2.54 2.073h-8.122c-1.137 0-1.842-.93-1.574-2.073l3.78-16.35C24.03 2.93 25.166 2 26.303 2z\" style=\"fill: #007B84\" />\n      <path d=\"M27.633 14.072l-.99 3.3h.266l-.208.68h-.266l-.062.212h-.942l.064-.21H23.58l.193-.632h.194l1.005-3.35.2-.676h.962l-.1.34s.255-.184.498-.248c.242-.064 1.636-.088 1.636-.088l-.206.672h-.33zm-1.695 0l-.254.843s.285-.13.44-.172c.16-.04.395-.057.395-.057l.182-.614h-.764zm-.38 1.262l-.263.877s.29-.15.447-.196c.157-.037.396-.066.396-.066l.185-.614h-.766zm-.614 2.046h.767l.222-.74h-.765l-.223.74z\" style=\"fill: #FEFEFE\" />\n      <path d=\"M28.055 13.4h1.027l.01.385c-.005.065.05.096.17.096h.208l-.19.637h-.555c-.48.035-.662-.172-.65-.406l-.02-.71zM28.193 16.415h-.978l.167-.566H28.5l.16-.517h-1.104l.19-.638h3.072l-.193.638h-1.03l-.16.516h1.032l-.17.565H29.18l-.2.24h.454l.11.712c.013.07.014.116.036.147.023.026.158.038.238.038h.137l-.21.694h-.348c-.054 0-.133-.004-.243-.01-.105-.008-.18-.07-.25-.105-.064-.03-.16-.11-.182-.24l-.11-.712-.507.7c-.162.222-.38.39-.748.39h-.712l.186-.62h.273c.078 0 .15-.03.2-.056.052-.023.098-.05.15-.126l.74-1.05zM17.478 14.867h2.59l-.19.622H18.84l-.16.53h1.06l-.194.64h-1.06l-.256.863c-.03.095.25.108.353.108l.53-.072-.212.71h-1.193c-.096 0-.168-.013-.272-.037-.1-.023-.145-.07-.19-.138-.043-.07-.11-.128-.064-.278l.343-1.143h-.588l.195-.65h.592l.156-.53h-.588l.188-.623zM19.223 13.75h1.063l-.194.65H18.64l-.157.136c-.067.066-.09.038-.18.087-.08.04-.254.123-.477.123h-.466l.19-.625h.14c.118 0 .198-.01.238-.036.046-.03.098-.096.157-.203l.267-.487h1.057l-.187.356zM20.74 13.4h.905l-.132.46s.286-.23.487-.313c.2-.075.65-.143.65-.143l1.464-.007-.498 1.672c-.085.286-.183.472-.244.555-.055.087-.12.16-.248.23-.124.066-.236.104-.34.115-.096.007-.244.01-.45.012h-1.41l-.4 1.324c-.037.13-.055.194-.03.23.02.03.068.066.135.066l.62-.06-.21.726h-.698c-.22 0-.383-.004-.495-.013-.108-.01-.22 0-.295-.058-.065-.058-.164-.133-.162-.21.007-.073.037-.192.082-.356l1.268-4.23zm1.922 1.69h-1.484l-.09.3h1.283c.152-.018.184.004.196-.003l.096-.297zm-1.402-.272s.29-.266.786-.353c.112-.022.82-.015.82-.015l.106-.357h-1.496l-.216.725z\" style=\"fill: #FEFEFE\" />\n      <path d=\"M23.382 16.1l-.084.402c-.036.125-.067.22-.16.302-.1.084-.216.172-.488.172l-.502.02-.004.455c-.006.13.028.117.048.138.024.022.045.032.067.04l.157-.008.48-.028-.198.663h-.552c-.385 0-.67-.008-.765-.084-.092-.057-.105-.132-.103-.26l.035-1.77h.88l-.013.362h.212c.072 0 .12-.007.15-.026.027-.02.047-.048.06-.093l.087-.282h.692zM10.84 7.222c-.032.143-.596 2.763-.598 2.764-.12.53-.21.91-.508 1.152-.172.14-.37.21-.6.21-.37 0-.587-.185-.624-.537l-.007-.12.113-.712s.593-2.388.7-2.703c.002-.017.005-.026.007-.035-1.152.01-1.357 0-1.37-.018-.007.024-.037.173-.037.173l-.605 2.688-.05.23-.1.746c0 .22.042.4.13.553.275.485 1.06.557 1.504.557.573 0 1.11-.123 1.47-.345.63-.375.797-.962.944-1.48l.067-.267s.61-2.48.716-2.803c.003-.017.006-.026.01-.035-.835.01-1.08 0-1.16-.018zM14.21 12.144c-.407-.006-.55-.006-1.03.018l-.018-.036c.042-.182.087-.363.127-.548l.06-.25c.086-.39.173-.843.184-.98.007-.084.036-.29-.2-.29-.1 0-.203.048-.307.096-.058.207-.174.79-.23 1.055-.118.558-.126.62-.178.897l-.036.037c-.42-.006-.566-.006-1.05.018l-.024-.04c.08-.332.162-.668.24-.998.203-.9.25-1.245.307-1.702l.04-.028c.47-.067.585-.08 1.097-.185l.043.047-.077.287c.086-.052.168-.104.257-.15.242-.12.51-.155.658-.155.223 0 .468.062.57.323.098.232.034.52-.094 1.084l-.066.287c-.13.627-.152.743-.225 1.174l-.05.036zM15.87 12.144c-.245 0-.405-.006-.56 0-.153 0-.303.008-.532.018l-.013-.02-.015-.02c.062-.238.097-.322.128-.406.03-.084.06-.17.115-.41.072-.315.116-.535.147-.728.033-.187.052-.346.075-.53l.02-.014.02-.018c.244-.036.4-.057.56-.082.16-.024.32-.055.574-.103l.008.023.008.022c-.047.195-.094.39-.14.588-.047.197-.094.392-.137.587-.093.414-.13.57-.152.68-.02.105-.026.163-.063.377l-.022.02-.023.017zM19.542 10.728c.143-.633.033-.928-.108-1.11-.213-.273-.59-.36-.978-.36-.235 0-.793.023-1.23.43-.312.29-.458.687-.546 1.066-.088.387-.19 1.086.447 1.344.198.085.48.108.662.108.466 0 .945-.13 1.304-.513.278-.312.405-.775.448-.965zm-1.07-.046c-.02.106-.113.503-.24.673-.086.123-.19.198-.305.198-.033 0-.235 0-.238-.3-.003-.15.027-.304.063-.47.108-.478.236-.88.56-.88.255 0 .27.298.16.78zM29.536 12.187c-.493-.004-.635-.004-1.09.015l-.03-.037c.124-.472.248-.943.358-1.42.142-.62.175-.882.223-1.244l.037-.03c.49-.07.625-.09 1.135-.186l.015.044c-.093.388-.186.777-.275 1.166-.19.816-.258 1.23-.33 1.658l-.044.035z\" style=\"fill: #FEFEFE\" />\n      <path d=\"M29.77 10.784c.144-.63-.432-.056-.525-.264-.14-.323-.052-.98-.62-1.2-.22-.085-.732.025-1.17.428-.31.29-.458.683-.544 1.062-.088.38-.19 1.078.444 1.328.2.085.384.11.567.103.638-.034 1.124-1.002 1.483-1.386.277-.303.326.115.368-.07zm-.974-.047c-.024.1-.117.503-.244.67-.083.117-.283.192-.397.192-.032 0-.232 0-.24-.3 0-.146.03-.3.067-.467.11-.47.235-.87.56-.87.254 0 .363.293.254.774zM22.332 12.144c-.41-.006-.55-.006-1.03.018l-.018-.036c.04-.182.087-.363.13-.548l.057-.25c.09-.39.176-.843.186-.98.008-.084.036-.29-.198-.29-.1 0-.203.048-.308.096-.057.207-.175.79-.232 1.055-.115.558-.124.62-.176.897l-.035.037c-.42-.006-.566-.006-1.05.018l-.022-.04.238-.998c.203-.9.25-1.245.307-1.702l.038-.028c.472-.067.587-.08 1.098-.185l.04.047-.073.287c.084-.052.17-.104.257-.15.24-.12.51-.155.655-.155.224 0 .47.062.575.323.095.232.03.52-.098 1.084l-.065.287c-.133.627-.154.743-.225 1.174l-.05.036zM26.32 8.756c-.07.326-.282.603-.554.736-.225.114-.498.123-.78.123h-.183l.013-.074.336-1.468.01-.076.007-.058.132.015.71.062c.275.105.388.38.31.74zM25.88 7.22l-.34.003c-.883.01-1.238.006-1.383-.012l-.037.182-.315 1.478-.793 3.288c.77-.01 1.088-.01 1.22.004l.21-1.024s.153-.644.163-.667c0 0 .047-.066.096-.092h.07c.665 0 1.417 0 2.005-.437.4-.298.675-.74.797-1.274.03-.132.054-.29.054-.446 0-.205-.04-.41-.16-.568-.3-.423-.896-.43-1.588-.433zM33.572 9.28l-.04-.043c-.502.1-.594.118-1.058.18l-.034.034-.005.023-.003-.007c-.345.803-.334.63-.615 1.26-.003-.03-.003-.048-.004-.077l-.07-1.37-.044-.043c-.53.1-.542.118-1.03.18l-.04.034-.006.056.003.007c.06.315.047.244.108.738.03.244.065.49.093.73.05.4.077.6.134 1.21-.328.55-.408.757-.722 1.238l.017.044c.478-.018.587-.018.94-.018l.08-.088c.265-.578 2.295-4.085 2.295-4.085zM16.318 9.62c.27-.19.304-.45.076-.586-.23-.137-.634-.094-.906.095-.273.186-.304.45-.075.586.228.134.633.094.905-.096z\" style=\"fill: #FEFEFE\" />\n      <path d=\"M31.238 13.415l-.397.684c-.124.232-.357.407-.728.41l-.632-.01.184-.618h.124c.064 0 .11-.004.148-.022.03-.01.054-.035.08-.072l.233-.373h.988z\" style=\"fill: #FEFEFE\" />\n    </symbol>\n\n    <symbol id=\"icon-american-express\" viewBox=\"0 0 40 24\">\n      <title>American Express</title>\n      <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: #FFF\" />\n      <path style=\"fill: #1478BE\" d=\"M6.26 12.32h2.313L7.415 9.66M27.353 9.977h-3.738v1.23h3.666v1.384h-3.675v1.385h3.821v1.005c.623-.77 1.33-1.466 2.025-2.235l.707-.77c-.934-1.004-1.87-2.08-2.804-3.075v1.077z\" />\n      <path d=\"M38.25 7h-5.605l-1.328 1.4L30.072 7H16.984l-1.017 2.416L14.877 7h-9.58L1.25 16.5h4.826l.623-1.556h1.4l.623 1.556H29.99l1.327-1.483 1.328 1.483h5.605l-4.36-4.667L38.25 7zm-17.685 8.1h-1.557V9.883L16.673 15.1h-1.33L13.01 9.883l-.084 5.217H9.73l-.623-1.556h-3.27L5.132 15.1H3.42l2.884-6.772h2.42l2.645 6.233V8.33h2.646l2.107 4.51 1.868-4.51h2.575V15.1zm14.727 0h-2.024l-2.024-2.26-2.023 2.26H22.06V8.328H29.53l1.795 2.177 2.024-2.177h2.025L32.26 11.75l3.032 3.35z\" style=\"fill: #1478BE\" />\n    </symbol>\n\n    <symbol id=\"icon-jcb\" viewBox=\"0 0 40 24\">\n      <title>JCB</title>\n      <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: #FFF\" />\n      <path d=\"M33.273 2.01h.013v17.062c-.004 1.078-.513 2.103-1.372 2.746-.63.47-1.366.67-2.14.67-.437 0-4.833.026-4.855 0-.01-.01 0-.07 0-.082v-6.82c0-.04.004-.064.033-.064h5.253c.867 0 1.344-.257 1.692-.61.44-.448.574-1.162.294-1.732-.24-.488-.736-.78-1.244-.913-.158-.04-.32-.068-.483-.083-.01 0-.064 0-.07-.006-.03-.034.023-.04.038-.046.102-.033.215-.042.32-.073.532-.164.993-.547 1.137-1.105.15-.577-.05-1.194-.524-1.552-.34-.257-.768-.376-1.187-.413-.43-.038-4.774-.022-5.21-.022-.072 0-.05-.02-.05-.09V5.63c0-.31.01-.616.073-.92.126-.592.41-1.144.815-1.59.558-.615 1.337-1.01 2.16-1.093.478-.048 4.89-.017 5.305-.017zm-4.06 8.616c.06.272-.01.567-.204.77-.173.176-.407.25-.648.253-.195.003-1.725 0-1.788 0l.003-1.645c.012-.027.02-.018.06-.018.097 0 1.713-.004 1.823.005.232.02.45.12.598.306.076.096.128.208.155.328zm-2.636 2.038h1.944c.242.002.47.063.652.228.226.204.327.515.283.815-.04.263-.194.5-.422.634-.187.112-.39.125-.6.125h-1.857v-1.8z\" style=\"fill: #53B230\" />\n      <path d=\"M6.574 13.89c-.06-.03-.06-.018-.07-.06-.006-.026-.005-8.365.003-8.558.04-.95.487-1.857 1.21-2.47.517-.434 1.16-.71 1.83-.778.396-.04.803-.018 1.2-.018.69 0 4.11-.013 4.12 0 .008.008.002 16.758 0 17.074-.003.956-.403 1.878-1.105 2.523-.506.465-1.15.77-1.83.86-.41.056-5.02.032-5.363.032-.066 0-.054.013-.066-.024-.01-.025 0-7 0-7.17.66.178 1.35.28 2.03.348.662.067 1.33.093 1.993.062.93-.044 1.947-.192 2.712-.762.32-.238.574-.553.73-.922.148-.353.2-.736.2-1.117 0-.348.006-3.93-.016-3.942-.023-.014-2.885-.015-2.9.012-.012.022 0 3.87 0 3.95-.003.47-.16.933-.514 1.252-.468.42-1.11.47-1.707.423-.687-.055-1.357-.245-1.993-.508-.157-.065-.312-.135-.466-.208z\" style=\"fill: #006CB9\" />\n      <path d=\"M15.95 9.835c-.025.02-.05.04-.072.06V6.05c0-.295-.012-.594.01-.888.12-1.593 1.373-2.923 2.944-3.126.382-.05 5.397-.042 5.41-.026.01.01 0 .062 0 .074v16.957c0 1.304-.725 2.52-1.89 3.1-.504.25-1.045.35-1.605.35-.322 0-4.757.015-4.834 0-.05-.01-.023.01-.035-.02-.007-.022 0-6.548 0-7.44v-.422c.554.48 1.256.75 1.96.908.536.12 1.084.176 1.63.196.537.02 1.076.01 1.61-.037.546-.05 1.088-.136 1.625-.244.137-.028.274-.057.41-.09.033-.006.17-.017.187-.044.013-.02 0-.097 0-.12v-1.324c-.582.292-1.19.525-1.83.652-.778.155-1.64.198-2.385-.123-.752-.326-1.2-1.024-1.274-1.837-.076-.837.173-1.716.883-2.212.736-.513 1.7-.517 2.553-.38.634.1 1.245.305 1.825.58.078.037.154.075.23.113V9.322c0-.02.013-.1 0-.118-.02-.028-.152-.038-.188-.046-.066-.016-.133-.03-.2-.045C22.38 9 21.84 8.908 21.3 8.85c-.533-.06-1.068-.077-1.603-.066-.542.01-1.086.054-1.62.154-.662.125-1.32.337-1.883.716-.085.056-.167.117-.245.18z\" style=\"fill: #E20138\" />\n    </symbol>\n\n    <symbol id=\"icon-discover\" viewBox=\"0 0 40 24\">\n      <title>Discover</title>\n      <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: #FFF\" />\n      <path d=\"M38.995 11.75S27.522 20.1 6.5 23.5h31.495c.552 0 1-.448 1-1V11.75z\" style=\"fill: #F48024\" />\n      <path d=\"M5.332 11.758c-.338.305-.776.438-1.47.438h-.29V8.55h.29c.694 0 1.115.124 1.47.446.37.33.595.844.595 1.372 0 .53-.224 1.06-.595 1.39zM4.077 7.615H2.5v5.515h1.57c.833 0 1.435-.197 1.963-.637.63-.52 1-1.305 1-2.116 0-1.628-1.214-2.762-2.956-2.762zM7.53 13.13h1.074V7.616H7.53M11.227 9.732c-.645-.24-.834-.397-.834-.695 0-.347.338-.61.8-.61.322 0 .587.132.867.446l.562-.737c-.462-.405-1.015-.612-1.618-.612-.975 0-1.718.678-1.718 1.58 0 .76.346 1.15 1.355 1.513.42.148.635.247.743.314.215.14.322.34.322.57 0 .448-.354.78-.834.78-.51 0-.924-.258-1.17-.736l-.695.67c.495.726 1.09 1.05 1.907 1.05 1.116 0 1.9-.745 1.9-1.812 0-.876-.363-1.273-1.585-1.72zM13.15 10.377c0 1.62 1.27 2.877 2.907 2.877.462 0 .858-.09 1.347-.32v-1.267c-.43.43-.81.604-1.297.604-1.082 0-1.85-.785-1.85-1.9 0-1.06.792-1.895 1.8-1.895.512 0 .9.183 1.347.62V7.83c-.472-.24-.86-.34-1.322-.34-1.627 0-2.932 1.283-2.932 2.887zM25.922 11.32l-1.468-3.705H23.28l2.337 5.656h.578l2.38-5.655H27.41M29.06 13.13h3.046v-.934h-1.973v-1.488h1.9v-.934h-1.9V8.55h1.973v-.935H29.06M34.207 10.154h-.314v-1.67h.33c.67 0 1.034.28 1.034.818 0 .554-.364.852-1.05.852zm2.155-.91c0-1.033-.71-1.628-1.95-1.628H32.82v5.514h1.073v-2.215h.14l1.487 2.215h1.32l-1.733-2.323c.81-.165 1.255-.72 1.255-1.563z\" style=\"fill: #221F20\" />\n      <path d=\"M23.6 10.377c0 1.62-1.31 2.93-2.927 2.93-1.617.002-2.928-1.31-2.928-2.93s1.31-2.932 2.928-2.932c1.618 0 2.928 1.312 2.928 2.932z\" style=\"fill: #F48024\" />\n    </symbol>\n\n    <symbol id=\"icon-diners-club\" viewBox=\"0 0 40 24\">\n      <title>Diners Club</title>\n      <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: #FFF\" />\n      <path d=\"M9.02 11.83c0-5.456 4.54-9.88 10.14-9.88 5.6 0 10.139 4.424 10.139 9.88-.002 5.456-4.54 9.88-10.14 9.88-5.6 0-10.14-4.424-10.14-9.88z\" style=\"fill: #FEFEFE\" />\n      <path style=\"fill: #FFF\" d=\"M32.522 22H8.5V1.5h24.022\" />\n      <path d=\"M25.02 11.732c-.003-2.534-1.607-4.695-3.868-5.55v11.102c2.26-.857 3.865-3.017 3.87-5.552zm-8.182 5.55V6.18c-2.26.86-3.86 3.017-3.867 5.55.007 2.533 1.61 4.69 3.868 5.55zm2.158-14.934c-5.25.002-9.503 4.202-9.504 9.384 0 5.182 4.254 9.38 9.504 9.382 5.25 0 9.504-4.2 9.505-9.382 0-5.182-4.254-9.382-9.504-9.384zM18.973 22C13.228 22.027 8.5 17.432 8.5 11.84 8.5 5.726 13.228 1.5 18.973 1.5h2.692c5.677 0 10.857 4.225 10.857 10.34 0 5.59-5.18 10.16-10.857 10.16h-2.692z\" style=\"fill: #004A97\" />\n    </symbol>\n\n    <symbol id=\"icon-maestro\" viewBox=\"0 0 40 24\">\n      <title>Maestro</title>\n      <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: #FFF\" />\n      <path d=\"M14.67 22.39V21c.022-.465-.303-.86-.767-.882h-.116c-.3-.023-.603.14-.788.394-.164-.255-.442-.417-.743-.394-.256-.023-.51.116-.65.324v-.278h-.487v2.203h.487v-1.183c-.046-.278.162-.533.44-.58h.094c.325 0 .488.21.488.58v1.23h.487v-1.23c-.047-.278.162-.556.44-.58h.093c.325 0 .487.21.487.58v1.23l.534-.024zm2.712-1.09v-1.113h-.487v.28c-.162-.21-.417-.326-.695-.326-.65 0-1.16.51-1.16 1.16 0 .65.51 1.16 1.16 1.16.278 0 .533-.117.695-.325v.278h.487V21.3zm-1.786 0c.024-.37.348-.65.72-.626.37.023.65.348.626.72-.023.347-.302.625-.673.625-.372 0-.674-.28-.674-.65-.023-.047-.023-.047 0-.07zm12.085-1.16c.163 0 .325.024.465.094.14.046.278.14.37.255.117.115.186.23.256.37.117.3.117.626 0 .927-.046.14-.138.255-.254.37-.116.117-.232.186-.37.256-.303.116-.65.116-.952 0-.14-.046-.28-.14-.37-.255-.118-.116-.187-.232-.257-.37-.116-.302-.116-.627 0-.928.047-.14.14-.255.256-.37.115-.117.23-.187.37-.256.163-.07.325-.116.488-.093zm0 .465c-.092 0-.185.023-.278.046-.092.024-.162.094-.232.14-.07.07-.116.14-.14.232-.068.185-.068.394 0 .58.024.092.094.162.14.23.07.07.14.117.232.14.186.07.37.07.557 0 .092-.023.16-.092.23-.14.07-.068.117-.138.14-.23.07-.186.07-.395 0-.58-.023-.093-.093-.162-.14-.232-.07-.07-.138-.116-.23-.14-.094-.045-.187-.07-.28-.045zm-7.677.695c0-.695-.44-1.16-1.043-1.16-.65 0-1.16.534-1.137 1.183.023.65.534 1.16 1.183 1.136.325 0 .65-.093.905-.302l-.23-.348c-.187.14-.42.232-.65.232-.326.023-.627-.21-.673-.533h1.646v-.21zm-1.646-.21c.023-.3.278-.532.58-.532.3 0 .556.232.556.533h-1.136zm3.664-.346c-.207-.116-.44-.186-.695-.186-.255 0-.417.093-.417.255 0 .163.162.186.37.21l.233.022c.488.07.766.278.766.672 0 .395-.37.72-1.02.72-.348 0-.673-.094-.95-.28l.23-.37c.21.162.465.232.743.232.324 0 .51-.094.51-.28 0-.115-.117-.185-.395-.23l-.232-.024c-.487-.07-.765-.302-.765-.65 0-.44.37-.718.927-.718.325 0 .627.07.905.232l-.21.394zm2.32-.116h-.788v.997c0 .23.07.37.325.37.14 0 .3-.046.417-.115l.14.417c-.186.116-.395.162-.604.162-.58 0-.765-.302-.765-.812v-1.02h-.44v-.44h.44v-.673h.487v.672h.79v.44zm1.67-.51c.117 0 .233.023.35.07l-.14.463c-.093-.045-.21-.045-.302-.045-.325 0-.464.208-.464.58v1.25h-.487v-2.2h.487v.277c.116-.255.325-.37.557-.394z\" style=\"fill: #000\" />\n      <path style=\"fill: #7673C0\" d=\"M23.64 3.287h-7.305V16.41h7.306\" />\n      <path d=\"M16.8 9.848c0-2.55 1.183-4.985 3.2-6.56C16.384.435 11.12 1.06 8.29 4.7 5.435 8.32 6.06 13.58 9.703 16.41c3.038 2.387 7.283 2.387 10.32 0-2.04-1.578-3.223-3.99-3.223-6.562z\" style=\"fill: #EB001B\" />\n      <path d=\"M33.5 9.848c0 4.613-3.735 8.346-8.35 8.346-1.88 0-3.69-.626-5.15-1.785 3.618-2.83 4.245-8.092 1.415-11.71-.418-.532-.882-.996-1.415-1.413C23.618.437 28.883 1.06 31.736 4.7 32.873 6.163 33.5 7.994 33.5 9.85z\" style=\"fill: #00A1DF\" />\n    </symbol>\n\n    <symbol id=\"logoPayPal\" viewBox=\"0 0 48 29\">\n      <title>PayPal Logo</title>\n      <path d=\"M46 29H2c-1.1 0-2-.87-2-1.932V1.934C0 .87.9 0 2 0h44c1.1 0 2 .87 2 1.934v25.134C48 28.13 47.1 29 46 29z\" fill-opacity=\"0\" style=\"fill: #FFF\" />\n      <path d=\"M31.216 16.4c.394-.7.69-1.5.886-2.4.196-.8.196-1.6.1-2.2-.1-.7-.396-1.2-.79-1.7-.195-.3-.59-.5-.885-.7.1-.8.1-1.5 0-2.1-.1-.6-.394-1.1-.886-1.6-.885-1-2.56-1.6-4.922-1.6h-6.4c-.492 0-.787.3-.886.8l-2.658 17.2c0 .2 0 .3.1.4.097.1.294.2.393.2h4.036l-.295 1.8c0 .1 0 .3.1.4.098.1.195.2.393.2h3.35c.393 0 .688-.3.786-.7v-.2l.59-4.1v-.2c.1-.4.395-.7.788-.7h.59c1.675 0 3.152-.4 4.137-1.1.59-.5 1.083-1 1.478-1.7h-.002z\" style=\"fill: #263B80\" />\n      <path d=\"M21.364 9.4c0-.3.196-.5.492-.6.098-.1.196-.1.394-.1h5.02c.592 0 1.183 0 1.675.1.1 0 .295.1.394.1.098 0 .294.1.393.1.1 0 .1 0 .197.102.295.1.492.2.69.3.295-1.6 0-2.7-.887-3.8-.985-1.1-2.658-1.6-4.923-1.6h-6.4c-.49 0-.885.3-.885.8l-2.758 17.3c-.098.3.197.6.59.6h3.94l.985-6.4 1.083-6.9z\" style=\"fill: #263B80\" />\n      <path d=\"M30.523 9.4c0 .1 0 .3-.098.4-.887 4.4-3.742 5.9-7.484 5.9h-1.87c-.492 0-.787.3-.886.8l-.985 6.2-.296 1.8c0 .3.196.6.492.6h3.348c.394 0 .69-.3.787-.7v-.2l.592-4.1v-.2c.1-.4.394-.7.787-.7h.69c3.248 0 5.808-1.3 6.497-5.2.296-1.6.197-3-.69-3.9-.196-.3-.49-.5-.885-.7z\" style=\"fill: #159BD7\" />\n      <path d=\"M29.635 9c-.098 0-.295-.1-.394-.1-.098 0-.294-.1-.393-.1-.492-.102-1.083-.102-1.673-.102h-5.022c-.1 0-.197 0-.394.1-.198.1-.394.3-.492.6l-1.083 6.9v.2c.1-.5.492-.8.886-.8h1.87c3.742 0 6.598-1.5 7.484-5.9 0-.1 0-.3.098-.4-.196-.1-.492-.2-.69-.3 0-.1-.098-.1-.196-.1z\" style=\"fill: #232C65\" />\n    </symbol>\n\n    <symbol id=\"logoPayPalCredit\" viewBox=\"0 0 48 29\">\n      <title>PayPal Credit Logo</title>\n      <path d=\"M46 29H2c-1.1 0-2-.87-2-1.932V1.934C0 .87.9 0 2 0h44c1.1 0 2 .87 2 1.934v25.134C48 28.13 47.1 29 46 29z\" fill-opacity=\"0\" style=\"fill: #FFF\" fill-rule=\"nonzero\" />\n      <path d=\"M27.44 21.6h.518c1.377 0 2.67-.754 2.953-2.484.248-1.588-.658-2.482-2.14-2.482h-.38c-.093 0-.172.067-.187.16l-.763 4.805zm-1.254-6.646c.024-.158.16-.273.32-.273h2.993c2.47 0 4.2 1.942 3.81 4.436-.4 2.495-2.752 4.436-5.21 4.436h-3.05c-.116 0-.205-.104-.187-.218l1.323-8.38zM22.308 16.907l-.192 1.21h2.38c.116 0 .204.103.186.217l-.23 1.462c-.023.157-.16.273-.318.273h-2.048c-.16 0-.294.114-.32.27l-.203 1.26h2.52c.117 0 .205.102.187.217l-.228 1.46c-.025.16-.16.275-.32.275h-4.55c-.116 0-.204-.104-.186-.218l1.322-8.38c.025-.158.16-.273.32-.273h4.55c.116 0 .205.104.187.22l-.23 1.46c-.024.158-.16.274-.32.274H22.63c-.16 0-.295.115-.32.273M35.325 23.552h-1.81c-.115 0-.203-.104-.185-.218l1.322-8.38c.025-.158.16-.273.32-.273h1.81c.115 0 .203.104.185.22l-1.322 8.38c-.025.156-.16.272-.32.272M14.397 18.657h.224c.754 0 1.62-.14 1.777-1.106.158-.963-.345-1.102-1.15-1.104h-.326c-.097 0-.18.07-.197.168l-.326 2.043zm3.96 4.895h-2.37c-.102 0-.194-.058-.238-.15l-1.565-3.262h-.023l-.506 3.19c-.02.128-.13.222-.26.222h-1.86c-.116 0-.205-.104-.187-.218l1.33-8.432c.02-.128.13-.22.26-.22h3.222c1.753 0 2.953.834 2.66 2.728-.2 1.224-1.048 2.283-2.342 2.506l2.037 3.35c.076.125-.014.286-.16.286zM40.216 23.552h-1.808c-.116 0-.205-.104-.187-.218l1.06-6.7h-1.684c-.116 0-.205-.104-.187-.218l.228-1.462c.025-.157.16-.273.32-.273h5.62c.116 0 .205.104.186.22l-.228 1.46c-.025.158-.16.274-.32.274h-1.63l-1.05 6.645c-.025.156-.16.272-.32.272M11.467 17.202c-.027.164-.228.223-.345.104-.395-.405-.975-.62-1.6-.62-1.41 0-2.526 1.083-2.75 2.458-.21 1.4.588 2.41 2.022 2.41.592 0 1.22-.225 1.74-.6.144-.105.34.02.313.194l-.328 2.03c-.02.12-.108.22-.226.254-.702.207-1.24.355-1.9.355-3.823 0-4.435-3.266-4.238-4.655.553-3.894 3.712-4.786 5.65-4.678.623.034 1.182.117 1.73.323.177.067.282.25.252.436l-.32 1.99\" style=\"fill: #21306F\" />\n      <path d=\"M23.184 7.67c-.11.717-.657.717-1.186.717h-.302l.212-1.34c.013-.08.082-.14.164-.14h.138c.36 0 .702 0 .877.206.105.123.137.305.097.557zm-.23-1.87h-1.998c-.137 0-.253.098-.274.233l-.808 5.123c-.016.1.062.192.165.192h1.024c.095 0 .177-.07.192-.164l.23-1.452c.02-.135.136-.235.273-.235h.63c1.317 0 2.076-.636 2.275-1.898.09-.553.003-.987-.255-1.29-.284-.334-.788-.51-1.456-.51z\" style=\"fill: #0093C7\" />\n      <path d=\"M8.936 7.67c-.11.717-.656.717-1.186.717h-.302l.212-1.34c.013-.08.082-.14.164-.14h.138c.36 0 .702 0 .877.206.104.123.136.305.096.557zm-.23-1.87H6.708c-.136 0-.253.098-.274.233l-.808 5.123c-.016.1.062.192.165.192h.955c.136 0 .252-.1.274-.234l.217-1.382c.02-.135.137-.235.274-.235h.633c1.316 0 2.075-.636 2.274-1.898.09-.553.003-.987-.255-1.29-.284-.334-.788-.51-1.456-.51zM13.343 9.51c-.092.545-.526.912-1.08.912-.277 0-.5-.09-.642-.258-.14-.168-.193-.406-.148-.672.086-.542.527-.92 1.072-.92.27 0 .492.09.637.26.148.172.205.412.163.677zm1.334-1.863h-.957c-.082 0-.152.06-.164.14l-.042.268-.067-.097c-.208-.3-.67-.4-1.13-.4-1.057 0-1.96.8-2.135 1.923-.092.56.038 1.097.356 1.47.29.344.708.487 1.204.487.852 0 1.325-.548 1.325-.548l-.043.265c-.016.1.062.193.164.193h.862c.136 0 .253-.1.274-.234l.517-3.275c.017-.102-.06-.193-.163-.193z\" style=\"fill: #21306F\" />\n      <path d=\"M27.59 9.51c-.09.545-.525.912-1.078.912-.278 0-.5-.09-.643-.258-.142-.168-.195-.406-.15-.672.086-.542.526-.92 1.07-.92.273 0 .494.09.64.26.146.172.203.412.16.677zm1.334-1.863h-.956c-.082 0-.152.06-.164.14l-.043.268-.065-.097c-.208-.3-.67-.4-1.13-.4-1.057 0-1.96.8-2.136 1.923-.092.56.038 1.097.355 1.47.292.344.71.487 1.205.487.852 0 1.325-.548 1.325-.548l-.043.265c-.016.1.062.193.164.193h.862c.136 0 .253-.1.274-.234l.517-3.275c.015-.102-.063-.193-.166-.193z\" style=\"fill: #0093C7\" />\n      <path d=\"M19.77 7.647h-.96c-.092 0-.178.045-.23.122L17.254 9.72l-.562-1.877c-.035-.118-.143-.198-.266-.198h-.945c-.113 0-.194.112-.157.22l1.06 3.108-.997 1.404c-.078.11 0 .262.136.262h.96c.092 0 .177-.044.23-.12l3.196-4.614c.077-.11-.002-.26-.137-.26\" style=\"fill: #21306F\" />\n      <path d=\"M30.052 5.94l-.82 5.216c-.016.1.062.192.165.192h.824c.138 0 .254-.1.275-.234l.81-5.122c.015-.1-.064-.193-.166-.193h-.924c-.082 0-.15.06-.164.14\" style=\"fill: #0093C7\" />\n    </symbol>\n\n    <symbol id=\"iconCardFront\" viewBox=\"0 0 48 29\">\n      <title>Generic Card</title>\n      <path d=\"M46.177 29H1.823C.9 29 0 28.13 0 27.187V1.813C0 .87.9 0 1.823 0h44.354C47.1 0 48 .87 48 1.813v25.375C48 28.13 47.1 29 46.177 29z\" style=\"fill: #FFF\" />\n      <path d=\"M4.8 9.14c0-.427.57-.973 1.067-.973h7.466c.496 0 1.067.546 1.067.972v3.888c0 .425-.57.972-1.067.972H5.867c-.496 0-1.067-.547-1.067-.972v-3.89z\" style=\"fill: #828282\" />\n      <rect style=\"fill: #828282\" x=\"10.8\" y=\"22.167\" width=\"3.6\" height=\"2.333\" rx=\"1.167\" />\n      <rect style=\"fill: #828282\" x=\"4.8\" y=\"22.167\" width=\"3.6\" height=\"2.333\" rx=\"1.167\" />\n      <path d=\"M6.55 16.333h34.9c.966 0 1.75.784 1.75 1.75 0 .967-.784 1.75-1.75 1.75H6.55c-.966 0-1.75-.783-1.75-1.75 0-.966.784-1.75 1.75-1.75z\" style=\"fill: #828282\" />\n      <ellipse style=\"fill: #828282\" cx=\"40.2\" cy=\"6.417\" rx=\"3\" ry=\"2.917\" />\n    </symbol>\n\n    <symbol id=\"iconCVVBack\" viewBox=\"0 0 40 24\">\n      <title>CVV Back</title>\n      <path d=\"M38.48 24H1.52C.75 24 0 23.28 0 22.5v-21C0 .72.75 0 1.52 0h36.96C39.25 0 40 .72 40 1.5v21c0 .78-.75 1.5-1.52 1.5z\" style=\"fill: #FFF\"/>\n      <path style=\"fill: #828282\" d=\"M0 5h40v4H0z\" />\n      <path d=\"M20 13.772v5.456c0 .423.37.772.82.772h13.36c.45 0 .82-.35.82-.772v-5.456c0-.423-.37-.772-.82-.772H20.82c-.45 0-.82.35-.82.772zm-1-.142c0-.9.76-1.63 1.68-1.63h13.64c.928 0 1.68.737 1.68 1.63v5.74c0 .9-.76 1.63-1.68 1.63H20.68c-.928 0-1.68-.737-1.68-1.63v-5.74z\" style=\"fill: #000\" fill-rule=\"nonzero\" />\n      <circle style=\"fill: #828282\" cx=\"23.5\" cy=\"16.5\" r=\"1.5\" />\n      <circle style=\"fill: #828282\" cx=\"27.5\" cy=\"16.5\" r=\"1.5\" />\n      <circle style=\"fill: #828282\" cx=\"31.5\" cy=\"16.5\" r=\"1.5\" />\n    </symbol>\n\n    <symbol id=\"iconCVVFront\" viewBox=\"0 0 40 24\">\n      <title>CVV Front</title>\n      <path d=\"M38.48 24H1.52C.75 24 0 23.28 0 22.5v-21C0 .72.75 0 1.52 0h36.96C39.25 0 40 .72 40 1.5v21c0 .78-.75 1.5-1.52 1.5z\" style=\"fill: #FFF\" />\n      <path d=\"M16 5.772v5.456c0 .423.366.772.81.772h17.38c.444 0 .81-.348.81-.772V5.772C35 5.35 34.634 5 34.19 5H16.81c-.444 0-.81.348-.81.772zm-1-.142c0-.9.75-1.63 1.66-1.63h17.68c.917 0 1.66.737 1.66 1.63v5.74c0 .9-.75 1.63-1.66 1.63H16.66c-.917 0-1.66-.737-1.66-1.63V5.63z\" style=\"fill: #000\" fill-rule=\"nonzero\" />\n      <circle style=\"fill: #828282\" cx=\"19.5\" cy=\"8.5\" r=\"1.5\" />\n      <circle style=\"fill: #828282\" cx=\"27.5\" cy=\"8.5\" r=\"1.5\" />\n      <circle style=\"fill: #828282\" cx=\"23.5\" cy=\"8.5\" r=\"1.5\" />\n      <circle style=\"fill: #828282\" cx=\"31.5\" cy=\"8.5\" r=\"1.5\" />\n      <path d=\"M4 7.833C4 7.47 4.476 7 4.89 7h6.22c.414 0 .89.47.89.833v3.334c0 .364-.476.833-.89.833H4.89c-.414 0-.89-.47-.89-.833V7.833zM4 18.5c0-.828.668-1.5 1.5-1.5h29c.828 0 1.5.666 1.5 1.5 0 .828-.668 1.5-1.5 1.5h-29c-.828 0-1.5-.666-1.5-1.5z\" style=\"fill: #828282\" />\n    </symbol>\n\n    <symbol id=\"iconCheck\" viewBox=\"0 0 42 32\">\n      <title>Check</title>\n      <path class=\"path1\" d=\"M14.379 29.76L39.741 3.415 36.194.001l-21.815 22.79-10.86-11.17L0 15.064z\" />\n    </symbol>\n\n    <symbol id=\"iconX\" viewBox=\"0 0 32 32\">\n      <title>X</title>\n      <path d=\"M29 3.54L25.46 0 14.5 10.97 3.54 0.01 0 3.54 10.96 14.5 0.01 25.46 3.54 28.99 14.5 18.04 25.46 29 28.99 25.46 18.03 14.5 29 3.54z\"/>\n    </symbol>\n\n    <symbol id=\"iconLockLoader\" viewBox=\"0 0 28 32\">\n      <title>Lock Loader</title>\n      <path d=\"M6 10V8c0-4.422 3.582-8 8-8 4.41 0 8 3.582 8 8v2h-4V7.995C18 5.79 16.205 4 14 4c-2.21 0-4 1.792-4 3.995V10H6zM.997 14c-.55 0-.997.445-.997.993v16.014c0 .548.44.993.997.993h26.006c.55 0 .997-.445.997-.993V14.993c0-.548-.44-.993-.997-.993H.997z\" />\n    </symbol>\n\n    <symbol id=\"iconError\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\">\n      <path d=\"M0 0h24v24H0z\" style=\"fill: none\" />\n      <path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" />\n    </symbol>\n\n    <symbol id=\"logoApplePay\" viewBox=\"0 0 165.52 105.97\" width=\"24\">\n      <title>Apple Pay Logo</title>\n      <defs>\n      <style>\n        .cls-1{fill:#231f20;}.cls-2{fill:#fff;}\n      </style>\n      </defs>\n      <path id=\"_Path_\" data-name=\"&lt;Path&gt;\" class=\"cls-1\" d=\"M150.7 0h-139a20.78 20.78 0 0 0-3.12.3 10.51 10.51 0 0 0-3 1 9.94 9.94 0 0 0-4.31 4.32 10.46 10.46 0 0 0-1 3A20.65 20.65 0 0 0 0 11.7v82.57a20.64 20.64 0 0 0 .3 3.11 10.46 10.46 0 0 0 1 3 9.94 9.94 0 0 0 4.35 4.35 10.47 10.47 0 0 0 3 1 20.94 20.94 0 0 0 3.11.27h142.06a21 21 0 0 0 3.11-.27 10.48 10.48 0 0 0 3-1 9.94 9.94 0 0 0 4.35-4.35 10.4 10.4 0 0 0 1-3 20.63 20.63 0 0 0 .27-3.11V11.69a20.64 20.64 0 0 0-.27-3.11 10.4 10.4 0 0 0-1-3 9.94 9.94 0 0 0-4.35-4.35 10.52 10.52 0 0 0-3-1 20.84 20.84 0 0 0-3.1-.23h-1.43z\"/>\n      <path id=\"_Path_2\" data-name=\"&lt;Path&gt;\" class=\"cls-2\" d=\"M150.7 3.53h3.03a17.66 17.66 0 0 1 2.58.22 7 7 0 0 1 2 .65 6.41 6.41 0 0 1 2.8 2.81 6.88 6.88 0 0 1 .64 2 17.56 17.56 0 0 1 .22 2.58v82.38a17.54 17.54 0 0 1-.22 2.59 6.85 6.85 0 0 1-.64 2 6.41 6.41 0 0 1-2.81 2.81 6.92 6.92 0 0 1-2 .65 18 18 0 0 1-2.57.22H11.79a18 18 0 0 1-2.58-.22 6.94 6.94 0 0 1-2-.65 6.41 6.41 0 0 1-2.8-2.8 6.93 6.93 0 0 1-.65-2 17.47 17.47 0 0 1-.22-2.58v-82.4a17.49 17.49 0 0 1 .22-2.59 6.92 6.92 0 0 1 .65-2 6.41 6.41 0 0 1 2.8-2.8 7 7 0 0 1 2-.65 17.63 17.63 0 0 1 2.58-.22H150.7\"/>\n      <g id=\"_Group_\" data-name=\"&lt;Group&gt;\">\n      <g id=\"_Group_2\" data-name=\"&lt;Group&gt;\">\n      <path id=\"_Path_3\" data-name=\"&lt;Path&gt;\" class=\"cls-1\" d=\"M43.51 35.77a9.15 9.15 0 0 0 2.1-6.52 9.07 9.07 0 0 0-6 3.11 8.56 8.56 0 0 0-2.16 6.27 7.57 7.57 0 0 0 6.06-2.86\"/>\n      <path id=\"_Path_4\" data-name=\"&lt;Path&gt;\" class=\"cls-1\" d=\"M45.59 39.08c-3.35-.2-6.2 1.9-7.79 1.9s-4-1.8-6.7-1.75a9.87 9.87 0 0 0-8.4 5.1c-3.6 6.2-.95 15.4 2.55 20.45 1.7 2.5 3.75 5.25 6.45 5.15s3.55-1.65 6.65-1.65 4 1.65 6.7 1.6 4.55-2.5 6.25-5a22.2 22.2 0 0 0 2.8-5.75 9.08 9.08 0 0 1-5.45-8.25A9.26 9.26 0 0 1 53 43.13a9.57 9.57 0 0 0-7.45-4\"/>\n      </g>\n      <g id=\"_Group_3\" data-name=\"&lt;Group&gt;\">\n      <path id=\"_Compound_Path_\" data-name=\"&lt;Compound Path&gt;\" class=\"cls-1\" d=\"M79 32.11c7.28 0 12.35 5 12.35 12.32S86.15 56.8 78.79 56.8h-8.06v12.82h-5.82V32.11zm-8.27 19.81h6.68c5.07 0 8-2.73 8-7.46S82.48 37 77.44 37h-6.71z\"/>\n      <path id=\"_Compound_Path_2\" data-name=\"&lt;Compound Path&gt;\" class=\"cls-1\" d=\"M92.76 61.85c0-4.81 3.67-7.56 10.42-8l7.25-.44v-2.06c0-3-2-4.7-5.56-4.7-2.94 0-5.07 1.51-5.51 3.82h-5.24c.16-4.86 4.73-8.4 10.92-8.4 6.65 0 11 3.48 11 8.89v18.66h-5.38v-4.5h-.13a9.59 9.59 0 0 1-8.58 4.78c-5.42 0-9.19-3.22-9.19-8.05zm17.68-2.42v-2.11l-6.47.42c-3.64.23-5.54 1.59-5.54 4s2 3.77 5.07 3.77c3.95-.05 6.94-2.57 6.94-6.08z\"/>\n      <path id=\"_Compound_Path_3\" data-name=\"&lt;Compound Path&gt;\" class=\"cls-1\" d=\"M121 79.65v-4.5a17.14 17.14 0 0 0 1.72.1c2.57 0 4-1.09 4.91-3.9l.52-1.66-9.88-27.29h6.08l6.86 22.15h.13l6.86-22.15h5.93l-10.21 28.67c-2.34 6.58-5 8.73-10.68 8.73a15.93 15.93 0 0 1-2.24-.15z\"/>\n      </g>\n      </g>\n    </symbol>\n    <symbol id=\"logoGooglePay\" viewBox=\"0 0 425 272\">\n      <title>GooglePay_mark_800_gray</title>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"GooglePay_mark_800_gray\">\n          <g id=\"border\">\n            <path d=\"M386.731012,0.0897642745 L38.039747,0.0897642745 C36.587241,0.0897642745 35.1321687,0.0897642745 33.6822289,0.0974583552 C32.4581205,0.107717129 31.2365783,0.120540597 30.0124699,0.153881613 C27.3461205,0.225693033 24.6566747,0.38213934 22.0236867,0.856607648 C19.3496386,1.33620534 16.8603614,2.12100157 14.4326747,3.35718387 C12.0434819,4.57028392 9.85959036,6.15782923 7.96312048,8.05057307 C6.06921687,9.94588161 4.4806988,12.1258711 3.26685542,14.5161655 C2.02991566,16.9423656 1.24463855,19.4301184 0.767313253,22.1050938 C0.289987952,24.739034 0.133445783,27.4242682 0.0615903614,30.0864201 C0.0282289157,31.3097789 0.0128313253,32.5305731 0.00513253012,33.7513672 C-0.00256626506,35.2029838 1.08420217e-19,36.6546003 1.08420217e-19,38.1087816 L1.08420217e-19,233.841064 C1.08420217e-19,235.295246 -0.00256626506,236.744298 0.00513253012,238.198479 C0.0128313253,239.419273 0.0282289157,240.642632 0.0615903614,241.863426 C0.133445783,244.523013 0.289987952,247.210812 0.767313253,249.842188 C1.24463855,252.517163 2.02991566,255.004916 3.26685542,257.43368 C4.4806988,259.82141 6.06921687,262.003964 7.96312048,263.896708 C9.85959036,265.792017 12.0434819,267.379562 14.4326747,268.590097 C16.8603614,269.828844 19.3496386,270.613641 22.0236867,271.095803 C24.6566747,271.565142 27.3461205,271.724153 30.0124699,271.795964 C31.2365783,271.824176 32.4581205,271.842129 33.6822289,271.847258 C35.1321687,271.857517 36.587241,271.857517 38.039747,271.857517 L386.731012,271.857517 C388.180952,271.857517 389.636024,271.857517 391.085964,271.847258 C392.307506,271.842129 393.529048,271.824176 394.758289,271.795964 C397.419506,271.724153 400.108952,271.565142 402.747072,271.095803 C405.418554,270.613641 407.907831,269.828844 410.338084,268.590097 C412.727277,267.379562 414.906036,265.792017 416.805072,263.896708 C418.69641,262.003964 420.284928,259.82141 421.501337,257.43368 C422.740843,255.004916 423.52612,252.517163 424.00088,249.842188 C424.478205,247.210812 424.632181,244.523013 424.704036,241.863426 C424.737398,240.642632 424.752795,239.419273 424.760494,238.198479 C424.770759,236.744298 424.770759,235.295246 424.770759,233.841064 L424.770759,38.1087816 C424.770759,36.6546003 424.770759,35.2029838 424.760494,33.7513672 C424.752795,32.5305731 424.737398,31.3097789 424.704036,30.0864201 C424.632181,27.4242682 424.478205,24.739034 424.00088,22.1050938 C423.52612,19.4301184 422.740843,16.9423656 421.501337,14.5161655 C420.284928,12.1258711 418.69641,9.94588161 416.805072,8.05057307 C414.906036,6.15782923 412.727277,4.57028392 410.338084,3.35718387 C407.907831,2.12100157 405.418554,1.33620534 402.747072,0.856607648 C400.108952,0.38213934 397.419506,0.225693033 394.758289,0.153881613 C393.529048,0.120540597 392.307506,0.107717129 391.085964,0.0974583552 C389.636024,0.0897642745 388.180952,0.0897642745 386.731012,0.0897642745\" id=\"Fill-1\" fill=\"#3C4043\"></path>\n            <path d=\"M386.731012,9.14826192 L391.021807,9.155956 C392.181759,9.16365008 393.344277,9.17647355 394.511928,9.20981456 C396.54441,9.26367313 398.923337,9.37395495 401.14059,9.77148245 C403.065289,10.1177161 404.682036,10.646043 406.23206,11.4334039 C407.76412,12.210506 409.165301,13.2312541 410.38941,14.4520482 C411.618651,15.6831011 412.640024,17.0859885 413.427867,18.6324987 C414.213145,20.1713148 414.736663,21.776813 415.083108,23.7157213 C415.478313,25.9085343 415.588663,28.2911346 415.642554,30.3351954 C415.675916,31.4867428 415.691313,32.6408549 415.696446,33.8231786 C415.706711,35.2517129 415.706711,36.6776826 415.706711,38.1087816 L415.706711,233.841064 C415.706711,235.272163 415.706711,236.698133 415.696446,238.154879 C415.691313,239.308991 415.675916,240.463103 415.642554,241.61978 C415.588663,243.658711 415.478313,246.041312 415.077976,248.257207 C414.736663,250.170468 414.213145,251.775966 413.422735,253.322477 C412.637458,254.866422 411.618651,256.266745 410.394542,257.490104 C409.162735,258.721157 407.766687,259.736775 406.216663,260.521572 C404.676904,261.306368 403.065289,261.834695 401.158554,262.175799 C398.895108,262.578456 396.418663,262.691302 394.552988,262.740031 C393.380205,262.768243 392.212554,262.783631 391.014108,262.788761 C389.589831,262.799019 388.157855,262.799019 386.731012,262.799019 L38.039747,262.799019 C38.0217831,262.799019 38.0038193,262.799019 37.9832892,262.799019 C36.5744096,262.799019 35.1603976,262.799019 33.7258554,262.788761 C32.5556386,262.783631 31.387988,262.768243 30.2588313,262.742596 C28.3495301,262.691302 25.8705181,262.578456 23.6276024,262.178364 C21.7029036,261.834695 20.0912892,261.306368 18.531,260.511313 C16.9963735,259.734211 15.6003253,258.718592 14.3685181,257.484974 C13.1469759,256.266745 12.1307349,254.868987 11.3454578,253.322477 C10.5576145,251.778531 10.0315301,250.167904 9.68508434,248.23156 C9.28731325,246.018229 9.17696386,243.648453 9.12050602,241.61978 C9.08971084,240.460539 9.07687952,239.298732 9.06918072,238.147185 L9.06404819,234.741272 L9.06404819,37.2111388 L9.06918072,33.8129199 C9.07687952,32.6511137 9.08971084,31.4918722 9.12050602,30.3326307 C9.17696386,28.3013934 9.28731325,25.9290519 9.69021687,23.6977685 C10.0315301,21.7819424 10.5576145,20.1687501 11.3480241,18.6171105 C12.1281687,17.0834238 13.1469759,15.6831011 14.3736506,14.4571776 C15.597759,13.2312541 17.001506,12.2156354 18.5438313,11.4308392 C20.0861566,10.6434783 21.7029036,10.1177161 23.6276024,9.77148245 C25.8448554,9.37395495 28.2237831,9.26367313 30.2613976,9.20981456 C31.4213494,9.17647355 32.5838675,9.16365008 33.7361205,9.155956 L38.039747,9.14826192 L386.731012,9.14826192\" id=\"wihit-fill\" fill=\"#FFFFFE\"></path>\n          </g>\n          <g id=\"GPay-logo\" transform=\"translate(48.759036, 76.981132)\">\n            <g id=\"Pay\" transform=\"translate(143.569904, 7.624798)\" fill=\"#3C4043\">\n              <path d=\"M12.1771332,57.6434717 L12.1771332,96.3774447 L0.0751674892,96.3774447 L0.0751674892,0.762479784 L32.1716854,0.762479784 C39.9139368,0.609983827 47.4306857,3.58365499 52.9179124,9.07350943 C63.8923658,19.4432345 64.5688732,36.9040216 54.2709272,48.1124744 C53.8199223,48.5699623 53.3689173,49.0274501 52.9179124,49.484938 C47.2803507,54.8985445 40.3649417,57.6434717 32.1716854,57.6434717 L12.1771332,57.6434717 Z M12.1771332,12.5046685 L12.1771332,45.901283 L32.4723553,45.901283 C36.9824047,46.053779 41.342119,44.2238275 44.4239861,40.9451644 C50.7380552,34.3115903 50.5877202,23.6368733 44.0481487,17.2320431 C40.9662816,14.182124 36.8320697,12.5046685 32.4723553,12.5046685 L12.1771332,12.5046685 Z\" id=\"Shape1\" fill-rule=\"nonzero\"></path>\n              <path d=\"M89.5244796,28.8217358 C98.4694108,28.8217358 105.535155,31.2616712 110.721712,36.0652938 C115.908268,40.8689164 118.463963,47.5787385 118.463963,56.0422642 L118.463963,96.3774447 L106.88817,96.3774447 L106.88817,87.3039353 L106.361997,87.3039353 C101.325775,94.7762372 94.7110364,98.5123881 86.3674451,98.5123881 C79.3017011,98.5123881 73.2883019,96.3774447 68.5527501,92.107558 C63.8923658,88.1426631 61.2615037,82.2715687 61.4118387,76.0954825 C61.4118387,69.3094124 63.9675333,63.9720539 69.0037551,59.9309111 C74.0399768,55.8897682 80.8050509,53.9073208 89.2238097,53.9073208 C96.4398886,53.9073208 102.302953,55.2797844 106.963337,57.8722156 L106.963337,55.0510404 C106.963337,50.8574016 105.159317,46.8925067 102.002283,44.1475795 C98.7700808,41.2501563 94.6358689,39.6489488 90.351322,39.6489488 C83.586248,39.6489488 78.2493562,42.546372 74.3406468,48.3412183 L63.6668633,41.5551482 C69.3795925,33.0916226 78.0238538,28.8217358 89.5244796,28.8217358 Z M73.8896419,76.3242264 C73.8896419,79.5266415 75.3929916,82.5003127 77.8735188,84.3302642 C80.5795484,86.4652075 83.8869179,87.6089272 87.2694549,87.5326792 C92.3808442,87.5326792 97.266731,85.4739838 100.87477,81.8140809 C104.858647,78.0016819 106.88817,73.5030512 106.88817,68.3181887 C103.129795,65.2682695 97.8680709,63.74331 91.1029969,63.819558 C86.2171101,63.819558 82.0828982,65.0395256 78.7755287,67.4032129 C75.5433266,69.7669003 73.8896419,72.7405714 73.8896419,76.3242264 Z\" id=\"Shape2\" fill-rule=\"nonzero\"></path>\n              <polygon id=\"Path1\" points=\"184.912023 30.9566792 144.471914 125.122933 131.994111 125.122933 147.027609 92.1838059 120.493485 30.9566792 133.647796 30.9566792 152.815506 77.925434 153.041008 77.925434 171.757713 30.9566792\"></polygon>\n            </g>\n            <g id=\"Super-G\">\n              <path d=\"M106.813002,56.8809919 C106.813002,53.144841 106.512332,49.40869 105.910992,45.7487871 L54.8722671,45.7487871 L54.8722671,66.8694771 L84.1124204,66.8694771 C82.9097406,73.6555472 79.0010311,79.7553854 73.2883019,83.5677844 L73.2883019,97.2924205 L90.7271594,97.2924205 C100.949938,87.7614232 106.813002,73.6555472 106.813002,56.8809919 Z\" id=\"Path2\" fill=\"#4285F4\"></path>\n              <path d=\"M54.8722671,110.559569 C69.45476,110.559569 81.7822282,105.679698 90.7271594,97.2924205 L73.2883019,83.5677844 C68.4024152,86.9226954 62.1635136,88.8288949 54.8722671,88.8288949 C40.7407791,88.8288949 28.7891484,79.1454016 24.5046015,66.1832453 L6.53957156,66.1832453 L6.53957156,80.3653693 C15.7100052,98.893628 34.42671,110.559569 54.8722671,110.559569 Z\" id=\"Path3\" fill=\"#34A853\"></path>\n              <path d=\"M24.5046015,66.1832453 C22.2495768,59.3971752 22.2495768,52.0011213 24.5046015,45.1388032 L24.5046015,31.0329272 L6.53957156,31.0329272 C-1.20267983,46.5112668 -1.20267983,64.8107817 6.53957156,80.2891213 L24.5046015,66.1832453 Z\" id=\"Path4\" fill=\"#FBBC04\"></path>\n              <path d=\"M54.8722671,22.4931536 C62.6145185,22.3406577 70.0560999,25.3143288 75.6184941,30.7279353 L91.1029969,15.0208518 C81.2560558,5.71859838 68.3272477,0.609983827 54.8722671,0.762479784 C34.42671,0.762479784 15.7100052,12.5046685 6.53957156,31.0329272 L24.5046015,45.2150512 C28.7891484,32.1766469 40.7407791,22.4931536 54.8722671,22.4931536 Z\" id=\"Path5\" fill=\"#EA4335\"></path>\n            </g>\n          </g>\n        </g>\n    </g>\n    </symbol>\n\n    <symbol id=\"logoVenmo\" viewBox=\"0 0 48 32\">\n      <title>Venmo</title>\n      <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect fill=\"#3D95CE\" width=\"47.4074074\" height=\"31.6049383\" rx=\"3.16049383\"/>\n        <path d=\"M33.1851852,10.1131555 C33.1851852,14.8373944 29.2425262,20.9745161 26.0425868,25.2839506 L18.7337285,25.2839506 L15.8024691,7.35534396 L22.202175,6.73384536 L23.7519727,19.4912014 C25.2000422,17.0781163 26.9870326,13.2859484 26.9870326,10.7005 C26.9870326,9.28531656 26.7500128,8.32139205 26.3796046,7.52770719 L32.207522,6.32098765 C32.8813847,7.45939896 33.1851852,8.63196439 33.1851852,10.1131555 Z\" fill=\"#FFF\"/>\n      </g>\n    </symbol>\n    <symbol id=\"buttonVenmo\" viewBox=\"0 0 295 42\">\n      <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect fill=\"#3D95CE\" width=\"295\" height=\"42\" rx=\"3\"/>\n        <path d=\"M11.3250791 0C11.7902741.780434316 12 1.58428287 12 2.59970884 12 5.838396 9.27822123 10.0456806 7.06917212 13L2.02356829 13 0 .709099732 4.41797878.283033306 5.48786751 9.02879887C6.48752911 7.3745159 7.72116169 4.77480706 7.72116169 3.00236102 7.72116169 2.03218642 7.55753727 1.37137098 7.30182933.827262801L11.3250791 0 11.3250791 0zM17.5051689 5.68512193C18.333931 5.68512193 20.4203856 5.28483546 20.4203856 4.03281548 20.4203856 3.43161451 20.0177536 3.13172102 19.5432882 3.13172102 18.7131868 3.13172102 17.6238766 4.18269796 17.5051689 5.68512193L17.5051689 5.68512193zM17.4102028 8.1647385C17.4102028 9.69351403 18.2153451 10.293301 19.2827401 10.293301 20.4451012 10.293301 21.5580312 9.99340752 23.0045601 9.21725797L22.4597224 13.1234575C21.440541 13.649203 19.8521716 14 18.310433 14 14.3996547 14 13 11.49596 13 8.36552446 13 4.30815704 15.2767521 0 19.9706358 0 22.554932 0 24 1.52864698 24 3.65720949 24.0002435 7.08869546 19.8287953 8.13992948 17.4102028 8.1647385L17.4102028 8.1647385zM37 2.84753211C37 3.32189757 36.9261179 4.00994664 36.8526108 4.45959542L35.4649774 12.9998782 30.9621694 12.9998782 32.2279161 5.1711436C32.2519185 4.95879931 32.3256755 4.53131032 32.3256755 4.29412759 32.3256755 3.72466988 31.9603904 3.5825794 31.5212232 3.5825794 30.9379171 3.5825794 30.3532359 3.84326124 29.9638234 4.03356751L28.5281854 13 24 13 26.0686989.213683657 29.9878258.213683657 30.0374555 1.23425123C30.9620444.641294408 32.1795365 3.90379019e-8 33.9069526 3.90379019e-8 36.1955476-.000243475057 37 1.1387937 37 2.84753211L37 2.84753211zM51.2981937 1.39967969C52.6582977.49918987 53.9425913 0 55.7133897 0 58.1518468 0 59 1.13900518 59 2.84769558 59 3.32204771 58.9223438 4.01007745 58.8448195 4.4597136L57.3830637 12.9997565 52.6328518 12.9997565 53.9932194 5.00577861C54.0182698 4.792101 54.0708756 4.53142648 54.0708756 4.36608506 54.0708756 3.72493046 53.6854953 3.58272222 53.2224587 3.58272222 52.6325881 3.58272222 52.0429812 3.81989829 51.6052587 4.03369766L50.0914245 12.9998782 45.3423992 12.9998782 46.7027668 5.00590037C46.7278172 4.79222275 46.7788409 4.53154824 46.7788409 4.36620681 46.7788409 3.72505221 46.3933287 3.58284398 45.9318743 3.58284398 45.3153711 3.58284398 44.7000546 3.84351849 44.2893602 4.03381941L42.7740757 13 38 13 40.1814929.214042876 44.2643098.214042876 44.3925941 1.28145692C45.3423992.641763367 46.6253743.000487014507 48.3452809.000487014507 49.8344603 0 50.8094476.593061916 51.2981937 1.39967969L51.2981937 1.39967969zM67.5285327 5.39061542C67.5285327 4.29258876 67.2694573 3.54396333 66.4936812 3.54396333 64.7759775 3.54396333 64.4232531 6.76273249 64.4232531 8.4093242 64.4232531 9.65848482 64.7530184 10.4315735 65.5285529 10.4315735 67.1521242 10.4315735 67.5285327 7.03707905 67.5285327 5.39061542L67.5285327 5.39061542zM60 8.21054461C60 3.96893154 62.1170713 0 66.988027 0 70.6583423 0 72 2.29633967 72 5.46592624 72 9.65835674 69.905767 14 64.9173573 14 61.2233579 14 60 11.4294418 60 8.21054461L60 8.21054461z\" transform=\"translate(112 14)\" fill=\"#FFF\"/>\n      </g>\n    </symbol>\n\n    <symbol id=\"iconClose\" width=\"21\" height=\"21\" viewBox=\"0 0 21 21\" overflow=\"visible\">\n      <path d=\"M16 5.414L14.586 4 10 8.586 5.414 4 4 5.414 8.586 10 4 14.586 5.414 16 10 11.414 14.586 16 16 14.586 11.414 10\"/>\n    </symbol>\n  </defs>\n</svg>\n";
	
	var UPDATABLE_CONFIGURATION_OPTIONS = [
	  paymentOptionIDs.paypal,
	  paymentOptionIDs.paypalCredit,
	  paymentOptionIDs.applePay,
	  paymentOptionIDs.googlePay,
	  'threeDSecure'
	];
	var UPDATABLE_CONFIGURATION_OPTIONS_THAT_REQUIRE_UNVAULTED_PAYMENT_METHODS_TO_BE_REMOVED = [
	  paymentOptionIDs.paypal,
	  paymentOptionIDs.paypalCredit,
	  paymentOptionIDs.applePay,
	  paymentOptionIDs.googlePay
	];
	var HAS_RAW_PAYMENT_DATA = {};
	var VERSION = '1.19.0';
	
	HAS_RAW_PAYMENT_DATA[constants.paymentMethodTypes.googlePay] = true;
	HAS_RAW_PAYMENT_DATA[constants.paymentMethodTypes.applePay] = true;
	
	/**
	 * @typedef {object} Dropin~cardPaymentMethodPayload
	 * @property {string} nonce The payment method nonce, used by your server to charge the card.
	 * @property {object} details Additional account details.
	 * @property {string} details.cardType Type of card, e.g. Visa, Mastercard.
	 * @property {string} details.lastTwo Last two digits of card number.
	 * @property {string} description A human-readable description.
	 * @property {string} type The payment method type, always `CreditCard` when the method requested is a card.
	 * @property {object} binData Information about the card based on the bin. Documented {@link Dropin~binData|here}.
	 * @property {?string} deviceData If data collector is configured, the device data property to be used when making a transaction.
	 * @property {?boolean} liabilityShifted If 3D Secure is configured, whether or not liability did shift.
	 * @property {?boolean} liabilityShiftPossible If 3D Secure is configured, whether or not liability shift is possible.
	 */
	
	/**
	 * @typedef {object} Dropin~paypalPaymentMethodPayload
	 * @property {string} nonce The payment method nonce, used by your server to charge the PayPal account.
	 * @property {object} details Additional PayPal account details. See a full list of details in the [PayPal client reference](http://braintree.github.io/braintree-web/3.47.0/PayPalCheckout.html#~tokenizePayload).
	 * @property {string} type The payment method type, always `PayPalAccount` when the method requested is a PayPal account.
	 * @property {?string} deviceData If data collector is configured, the device data property to be used when making a transaction.
	 */
	
	/**
	 * @typedef {object} Dropin~applePayPaymentMethodPayload
	 * @property {string} nonce The payment method nonce, used by your server to charge the Apple Pay provided card.
	 * @property {string} details.cardType Type of card, ex: Visa, Mastercard.
	 * @property {string} details.cardHolderName The name of the card holder.
	 * @property {string} details.dpanLastTwo Last two digits of card number.
	 * @property {external:ApplePayPayment} details.rawPaymentData The raw response back from the Apple Pay flow, which includes billing/shipping address, phone and email if passed in as required parameters.
	 * @property {string} description A human-readable description.
	 * @property {string} type The payment method type, always `ApplePayCard` when the method requested is an Apple Pay provided card.
	 * @property {object} binData Information about the card based on the bin. Documented {@link Dropin~binData|here}.
	 * @property {?string} deviceData If data collector is configured, the device data property to be used when making a transaction.
	 */
	
	/**
	 * @typedef {object} ApplePayPayment An [Apple Pay Payment object](https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypayment).
	 * @external ApplePayPayment
	 * @see {@link https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypayment ApplePayPayment}
	 */
	
	/**
	 * @typedef {object} Dropin~venmoPaymentMethodPayload
	 * @property {string} nonce The payment method nonce, used by your server to charge the Venmo account.
	 * @property {string} details.username The Venmo username.
	 * @property {string} type The payment method type, always `VenmoAccount` when the method requested is a Venmo account.
	 * @property {?string} deviceData If data collector is configured, the device data property to be used when making a transaction.
	 */
	
	/**
	 * @typedef {object} Dropin~googlePayPaymentMethodPayload
	 * @property {string} nonce The payment method nonce, used by your server to charge the Google Pay card.
	 * @property {string} details.cardType Type of card, ex: Visa, Mastercard.
	 * @property {string} details.lastFour The last 4 digits of the card.
	 * @property {string} details.lastTwo The last 2 digits of the card.
	 * @property {external:GooglePayPaymentData} details.rawPaymentData The raw response back from the Google Pay flow, which includes shipping address, phone and email if passed in as required parameters.
	 * @property {string} type The payment method type, always `AndroidPayCard` when the method requested is a Google Pay Card.
	 * @property {object} binData Information about the card based on the bin. Documented {@link Dropin~binData|here}.
	 * @property {?string} deviceData If data collector is configured, the device data property to be used when making a transaction.
	 */
	
	/**
	 * @typedef {object} GooglePayPaymentData A [Google Pay Payment Data object](https://developers.google.com/pay/api/web/object-reference#PaymentData).
	 * @external GooglePayPaymentData
	 * @see {@link https://developers.google.com/pay/api/web/object-reference#PaymentData PaymentData}
	 */
	
	/**
	 * @typedef {object} Dropin~binData Information about the card based on the bin.
	 * @property {string} commercial Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} countryOfIssuance The country of issuance.
	 * @property {string} debit Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} durbinRegulated Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} healthcare Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} issuingBank The issuing bank.
	 * @property {string} payroll Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} prepaid Possible values: 'Yes', 'No', 'Unknown'.
	 * @property {string} productId The product id.
	 */
	
	/**
	 * @name Dropin#on
	 * @function
	 * @param {string} event The name of the event to which you are subscribing.
	 * @param {function} handler A callback to handle the event.
	 * @description Subscribes a handler function to a named event. `event` should be one of the following:
	 *  * [`paymentMethodRequestable`](#event:paymentMethodRequestable)
	 *  * [`noPaymentMethodRequestable`](#event:noPaymentMethodRequestable)
	 *  * [`paymentOptionSelected`](#event:paymentOptionSelected)
	 * @returns {void}
	 * @example
	 * <caption>Dynamically enable or disable your submit button based on whether or not the payment method is requestable</caption>
	 * var submitButton = document.querySelector('#submit-button');
	 *
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container'
	 * }, function (err, dropinInstance) {
	 *   submitButton.addEventListener('click', function () {
	 *     dropinInstance.requestPaymentMethod(function (err, payload) {
	 *       // Send payload.nonce to your server.
	 *     });
	 *   });
	 *
	 *   if (dropinInstance.isPaymentMethodRequestable()) {
	 *     // This will be true if you generated the client token
	 *     // with a customer ID and there is a saved payment method
	 *     // available to tokenize with that customer.
	 *     submitButton.removeAttribute('disabled');
	 *   }
	 *
	 *   dropinInstance.on('paymentMethodRequestable', function (event) {
	 *     console.log(event.type); // The type of Payment Method, e.g 'CreditCard', 'PayPalAccount'.
	 *     console.log(event.paymentMethodIsSelected); // true if a customer has selected a payment method when paymentMethodRequestable fires
	 *
	 *     submitButton.removeAttribute('disabled');
	 *   });
	 *
	 *   dropinInstance.on('noPaymentMethodRequestable', function () {
	 *     submitButton.setAttribute('disabled', true);
	 *   });
	 * });
	 * @example
	 * <caption>Automatically submit nonce to server as soon as it becomes available</caption>
	 * var submitButton = document.querySelector('#submit-button');
	 *
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container'
	 * }, function (err, dropinInstance) {
	 *   function sendNonceToServer() {
	 *     dropinInstance.requestPaymentMethod(function (err, payload) {
	 *       if (err) {
	 *         // handle errors
	 *       }
	 *
	 *       // send payload.nonce to your server
	 *     });
	 *   }
	 *
	 *   // allows us to still request the payment method manually, such as
	 *   // when filling out a credit card form
	 *   submitButton.addEventListener('click', sendNonceToServer);
	 *
	 *   dropinInstance.on('paymentMethodRequestable', function (event) {
	 *     // if the nonce is already available (via PayPal authentication
	 *     // or by using a stored payment method), we can request the
	 *     // nonce right away. Otherwise, we wait for the customer to
	 *     // request the nonce by pressing the submit button once they
	 *     // are finished entering their credit card details
	 *     if (event.paymentMethodIsSelected) {
	 *       sendNonceToServer();
	 *     }
	 *   });
	 * });
	 */
	
	/**
	 * @name Dropin#off
	 * @function
	 * @param {string} event The name of the event to which you are unsubscribing.
	 * @param {function} handler A callback to unsubscribe from the event.
	 * @description Unsubscribes a handler function to a named event.
	 * @returns {void}
	 * @example
	 * <caption>Subscribe and then unsubscribe from event</caption>
	 * var callback = function (event) {
	 *   // do something
	 * };
	 * dropinInstance.on('paymentMethodRequestable', callback);
	 *
	 * // later on
	 * dropinInstance.off('paymentMethodRequestable', callback);
	 */
	
	/**
	 * This event is emitted when the payment method available in Drop-in changes. This includes when the state of Drop-in transitions from having no payment method available to having a payment method available and when the payment method available changes. This event is not fired if there is no payment method available on initialization. To check if there is a payment method requestable on initialization, use {@link Dropin#isPaymentMethodRequestable|`isPaymentMethodRequestable`}.
	 * @event Dropin#paymentMethodRequestable
	 * @type {Dropin~paymentMethodRequestablePayload}
	 */
	
	/**
	 * @typedef {object} Dropin~paymentMethodRequestablePayload
	 * @description The event payload sent from {@link Dropin#on|`on`} with the {@link Dropin#event:paymentMethodRequestable|`paymentMethodRequestable`} event.
	 * @property {string} type The type of payment method that is requestable. Either `CreditCard` or `PayPalAccount`.
	 * @property {boolean} paymentMethodIsSelected A property to determine if a payment method is currently selected when the payment method becomes requestable.
	 *
	 * This will be `true` any time a payment method is visibly selected in the Drop-in UI, such as when PayPal authentication completes or a stored payment method is selected.
	 *
	 * This will be `false` when {@link Dropin#requestPaymentMethod|`requestPaymentMethod`} can be called, but a payment method is not currently selected. For instance, when a card form has been filled in with valid values, but has not been submitted to be converted into a payment method nonce.
	 */
	
	/**
	 * This event is emitted when there is no payment method available in Drop-in. This event is not fired if there is no payment method available on initialization. To check if there is a payment method requestable on initialization, use {@link Dropin#isPaymentMethodRequestable|`isPaymentMethodRequestable`}. No payload is available in the callback for this event.
	 * @event Dropin#noPaymentMethodRequestable
	 */
	
	/**
	 * This event is emitted when the customer selects a new payment option type (e.g. PayPal, PayPal Credit, credit card). This event is not emitted when the user changes between existing saved payment methods. Only relevant when accepting multiple payment options.
	 * @event Dropin#paymentOptionSelected
	 * @type {Dropin~paymentOptionSelectedPayload}
	 */
	
	/**
	 * @typedef {object} Dropin~paymentOptionSelectedPayload
	 * @description The event payload sent from {@link Dropin#on|`on`} with the {@link Dropin#event:paymentOptionSelected|`paymentOptionSelected`} event.
	 * @property {string} paymentOption The payment option view selected. Either `card`, `paypal`, or `paypalCredit`.
	 */
	
	/**
	 * @class
	 * @param {object} options For create options, see {@link module:braintree-web-drop-in|dropin.create}.
	 * @description <strong>Do not use this constructor directly. Use {@link module:braintree-web-drop-in|dropin.create} instead.</strong>
	 * @classdesc This class represents a Drop-in component, that will create a pre-made UI for accepting cards and PayPal on your page. Instances of this class have methods for requesting a payment method and subscribing to events. For more information, see the [Drop-in guide](https://developers.braintreepayments.com/guides/drop-in/javascript/v3) in the Braintree Developer Docs. To be used in conjunction with the [Braintree Server SDKs](https://developers.braintreepayments.com/start/hello-server/).
	 */
	function Dropin(options) {
	  this._client = options.client;
	  this._componentID = uuid();
	  this._dropinWrapper = document.createElement('div');
	  this._dropinWrapper.id = 'braintree--dropin__' + this._componentID;
	  this._dropinWrapper.setAttribute('data-braintree-id', 'wrapper');
	  this._dropinWrapper.style.display = 'none';
	  this._dropinWrapper.className = 'braintree-loading';
	  this._merchantConfiguration = options.merchantConfiguration;
	
	  EventEmitter.call(this);
	}
	
	EventEmitter.createChild(Dropin);
	
	Dropin.prototype._initialize = function (callback) {
	  var localizedStrings, localizedHTML;
	  var self = this;
	  var container = self._merchantConfiguration.container || self._merchantConfiguration.selector;
	
	  self._injectStylesheet();
	
	  if (!container) {
	    analytics.sendEvent(self._client, 'configuration-error');
	    callback(new DropinError('options.container is required.'));
	
	    return;
	  } else if (self._merchantConfiguration.container && self._merchantConfiguration.selector) {
	    analytics.sendEvent(self._client, 'configuration-error');
	    callback(new DropinError('Must only have one options.selector or options.container.'));
	
	    return;
	  }
	
	  if (typeof container === 'string') {
	    container = document.querySelector(container);
	  }
	
	  if (!container || container.nodeType !== 1) {
	    analytics.sendEvent(self._client, 'configuration-error');
	    callback(new DropinError('options.selector or options.container must reference a valid DOM node.'));
	
	    return;
	  }
	
	  if (container.innerHTML.trim()) {
	    analytics.sendEvent(self._client, 'configuration-error');
	    callback(new DropinError('options.selector or options.container must reference an empty DOM node.'));
	
	    return;
	  }
	
	  // Backfill with `en`
	  self._strings = assign({}, translations.en);
	  if (self._merchantConfiguration.locale) {
	    localizedStrings = translations[self._merchantConfiguration.locale] || translations[self._merchantConfiguration.locale.split('_')[0]];
	    // Fill `strings` with `localizedStrings` that may exist
	    self._strings = assign(self._strings, localizedStrings);
	  }
	
	  if (!isUtf8()) {
	    // non-utf-8 encodings often don't support the bullet character
	    self._strings.endingIn = self._strings.endingIn.replace(/•/g, '*');
	  }
	
	  if (self._merchantConfiguration.translations) {
	    Object.keys(self._merchantConfiguration.translations).forEach(function (key) {
	      self._strings[key] = sanitizeHtml(self._merchantConfiguration.translations[key]);
	    });
	  }
	
	  localizedHTML = Object.keys(self._strings).reduce(function (result, stringKey) {
	    var stringValue = self._strings[stringKey];
	
	    return result.replace(RegExp('{{' + stringKey + '}}', 'g'), stringValue);
	  }, mainHTML);
	
	  self._dropinWrapper.innerHTML = svgHTML + localizedHTML;
	  container.appendChild(self._dropinWrapper);
	
	  self._model = new DropinModel({
	    client: self._client,
	    componentID: self._componentID,
	    merchantConfiguration: self._merchantConfiguration
	  });
	
	  self._model.initialize().then(function () {
	    self._model.on('cancelInitialization', function (err) {
	      self._dropinWrapper.innerHTML = '';
	      analytics.sendEvent(self._client, 'load-error');
	      callback(err);
	    });
	
	    self._model.on('asyncDependenciesReady', function () {
	      if (self._model.dependencySuccessCount >= 1) {
	        analytics.sendEvent(self._client, 'appeared');
	        self._disableErroredPaymentMethods();
	
	        self._handleAppSwitch();
	
	        self._model.confirmDropinReady();
	
	        callback(null, self);
	      } else {
	        self._model.cancelInitialization(new DropinError('All payment options failed to load.'));
	      }
	    });
	
	    self._model.on('paymentMethodRequestable', function (event) {
	      self._emit('paymentMethodRequestable', event);
	    });
	
	    self._model.on('noPaymentMethodRequestable', function () {
	      self._emit('noPaymentMethodRequestable');
	    });
	
	    self._model.on('paymentOptionSelected', function (event) {
	      self._emit('paymentOptionSelected', event);
	    });
	
	    return self._setUpDependenciesAndViews();
	  }).catch(function (err) {
	    self.teardown().then(function () {
	      callback(err);
	    });
	  });
	};
	
	/**
	 * Modify your configuration initially set in {@link module:braintree-web-drop-in|`dropin.create`}.
	 *
	 * If `updateConfiguration` is called after a user completes the PayPal authorization flow, any PayPal accounts not stored in the Vault record will be removed.
	 * @public
	 * @param {string} property The top-level property to update. Either `paypal`, `paypalCredit`, `applePay`, or `googlePay`.
	 * @param {string} key The key of the property to update, such as `amount` or `currency`.
	 * @param {any} value The value of the property to update. Must be the type of the property specified in {@link module:braintree-web-drop-in|`dropin.create`}.
	 * @returns {void}
	 * @example
	 * dropinInstance.updateConfiguration('paypal', 'amount', '10.00');
	 */
	Dropin.prototype.updateConfiguration = function (property, key, value) {
	  var view;
	
	  if (UPDATABLE_CONFIGURATION_OPTIONS.indexOf(property) === -1) {
	    return;
	  }
	
	  if (property === 'threeDSecure') {
	    if (this._threeDSecure) {
	      this._threeDSecure.updateConfiguration(key, value);
	    }
	
	    return;
	  }
	
	  view = this._mainView.getView(property);
	
	  if (!view) {
	    return;
	  }
	
	  view.updateConfiguration(key, value);
	
	  if (UPDATABLE_CONFIGURATION_OPTIONS_THAT_REQUIRE_UNVAULTED_PAYMENT_METHODS_TO_BE_REMOVED.indexOf(property) === -1) {
	    return;
	  }
	
	  this._removeUnvaultedPaymentMethods(function (paymentMethod) {
	    return paymentMethod.type === constants.paymentMethodTypes[property];
	  });
	  this._navigateToInitialView();
	};
	
	/**
	 * Removes the currently selected payment method and returns the customer to the payment options view. Does not remove vaulted payment methods.
	 * @public
	 * @returns {void}
	 * @example
	 * dropinInstance.requestPaymentMethod(function (requestPaymentMethodError, payload) {
	 *   if (requestPaymentMethodError) {
	 *     // handle errors
	 *     return;
	 *   }
	 *
	 *   functionToSendNonceToServer(payload.nonce, function (transactionError, response) {
	 *     if (transactionError) {
	 *       // transaction sale with selected payment method failed
	 *       // clear the selected payment method and add a message
	 *       // to the checkout page about the failure
	 *       dropinInstance.clearSelectedPaymentMethod();
	 *       divForErrorMessages.textContent = 'my error message about entering a different payment method.';
	 *     } else {
	 *       // redirect to success page
	 *     }
	 *   });
	 * });
	 */
	Dropin.prototype.clearSelectedPaymentMethod = function () {
	  this._removeUnvaultedPaymentMethods();
	  this._model.removeActivePaymentMethod();
	
	  if (this._model.getPaymentMethods().length === 0) {
	    this._navigateToInitialView();
	
	    return;
	  }
	
	  this._mainView.showLoadingIndicator();
	
	  this._model.refreshPaymentMethods().then(function () {
	    this._navigateToInitialView();
	    this._mainView.hideLoadingIndicator();
	  }.bind(this));
	};
	
	Dropin.prototype._setUpDataCollector = function () {
	  var self = this;
	  var config = assign({}, self._merchantConfiguration.dataCollector, {client: self._client});
	
	  this._model.asyncDependencyStarting();
	  this._dataCollector = new DataCollector(config);
	
	  this._dataCollector.initialize().then(function () {
	    self._model.asyncDependencyReady();
	  }).catch(function (err) {
	    self._model.cancelInitialization(new DropinError({
	      message: 'Data Collector failed to set up.',
	      braintreeWebError: err
	    }));
	  });
	};
	
	Dropin.prototype._setUpThreeDSecure = function () {
	  var self = this;
	  var config = assign({}, this._merchantConfiguration.threeDSecure);
	
	  this._model.asyncDependencyStarting();
	
	  this._threeDSecure = new ThreeDSecure(this._client, config);
	
	  this._threeDSecure.initialize().then(function () {
	    self._model.asyncDependencyReady();
	  }).catch(function (err) {
	    self._model.cancelInitialization(new DropinError({
	      message: '3D Secure failed to set up.',
	      braintreeWebError: err
	    }));
	  });
	};
	
	Dropin.prototype._setUpDependenciesAndViews = function () {
	  if (this._merchantConfiguration.dataCollector) {
	    this._setUpDataCollector();
	  }
	
	  if (this._merchantConfiguration.threeDSecure) {
	    this._setUpThreeDSecure();
	  }
	
	  this._mainView = new MainView({
	    client: this._client,
	    element: this._dropinWrapper,
	    model: this._model,
	    strings: this._strings
	  });
	};
	
	Dropin.prototype._removeUnvaultedPaymentMethods = function (filter) {
	  filter = filter || function () { return true; };
	
	  this._model.getPaymentMethods().forEach(function (paymentMethod) {
	    if (filter(paymentMethod) && !paymentMethod.vaulted) {
	      this._model.removePaymentMethod(paymentMethod);
	    }
	  }.bind(this));
	};
	
	Dropin.prototype._navigateToInitialView = function () {
	  var hasNoSavedPaymentMethods, hasOnlyOneSupportedPaymentOption;
	  var isOnMethodsView = this._mainView.primaryView.ID === paymentMethodsViewID;
	
	  if (isOnMethodsView) {
	    hasNoSavedPaymentMethods = this._model.getPaymentMethods().length === 0;
	
	    if (hasNoSavedPaymentMethods) {
	      hasOnlyOneSupportedPaymentOption = this._model.supportedPaymentOptions.length === 1;
	
	      if (hasOnlyOneSupportedPaymentOption) {
	        this._mainView.setPrimaryView(this._model.supportedPaymentOptions[0]);
	      } else {
	        this._mainView.setPrimaryView(paymentOptionsViewID);
	      }
	    }
	  }
	};
	
	Dropin.prototype._supportsPaymentOption = function (paymentOption) {
	  return this._model.supportedPaymentOptions.indexOf(paymentOption) !== -1;
	};
	
	Dropin.prototype._disableErroredPaymentMethods = function () {
	  var paymentMethodOptionsElements;
	  var failedDependencies = Object.keys(this._model.failedDependencies);
	
	  if (failedDependencies.length === 0) {
	    return;
	  }
	
	  paymentMethodOptionsElements = this._mainView.getOptionsElements();
	
	  failedDependencies.forEach(function (paymentMethodId) {
	    var element = paymentMethodOptionsElements[paymentMethodId];
	    var div = element.div;
	    var clickHandler = element.clickHandler;
	    var error = this._model.failedDependencies[paymentMethodId];
	    var errorMessageDiv = div.querySelector('.braintree-option__disabled-message');
	
	    classList.add(div, 'braintree-disabled');
	    div.removeEventListener('click', clickHandler);
	    errorMessageDiv.innerHTML = constants.errors.DEVELOPER_MISCONFIGURATION_MESSAGE;
	    console.error(error); // eslint-disable-line no-console
	  }.bind(this));
	};
	
	Dropin.prototype._sendVaultedPaymentMethodAppearAnalyticsEvents = function () {
	  var i, type;
	  var typesThatSentAnEvent = {};
	  var paymentMethods = this._model._paymentMethods;
	
	  for (i = 0; i < paymentMethods.length; i++) {
	    type = paymentMethods[i].type;
	
	    if (type in typesThatSentAnEvent) {
	      // prevents us from sending the analytic multiple times
	      // for the same payment method type
	      continue;
	    }
	
	    typesThatSentAnEvent[type] = true;
	
	    analytics.sendEvent(this._client, 'vaulted-' + constants.analyticsKinds[type] + '.appear');
	  }
	};
	
	Dropin.prototype._handleAppSwitch = function () {
	  if (this._model.appSwitchError) {
	    this._mainView.setPrimaryView(this._model.appSwitchError.id);
	    this._model.reportError(this._model.appSwitchError.error);
	  } else if (this._model.appSwitchPayload) {
	    this._model.addPaymentMethod(this._model.appSwitchPayload);
	  } else {
	    this._sendVaultedPaymentMethodAppearAnalyticsEvents();
	  }
	};
	
	/**
	 * Requests a payment method object which includes the payment method nonce used by by the [Braintree Server SDKs](https://developers.braintreepayments.com/start/hello-server/).
	 *
	 * If a payment method is not available, an error will appear in the UI. When a callback is used, an error will be passed to it. If no callback is used, the returned Promise will be rejected with an error.
	 * @public
	 * @param {object} [options] All options for requesting a payment method.
	 * @param {object} [options.threeDSecure] Any of the options in the [Braintree 3D Secure client reference](https://braintree.github.io/braintree-web/3.47.0/ThreeDSecure.html#verifyCard) except for `nonce`, `bin`, and `onLookupComplete`. If `amount` is provided, it will override the value of `amount` in the [3D Secure create options](module-braintree-web-drop-in.html#~threeDSecureOptions). The more options provided, the more likely the customer will not need to answer a 3DS challenge. The recommended fields for achieving a 3DS v2 verification are:
	 * * `email`
	 * * `mobilePhoneNumber`
	 * * `billingAddress`
	 * @param {callback} [callback] May be used as the only parameter in requestPaymentMethod if no `options` are provided. The first argument will be an error if no payment method is available and will otherwise be null. The second argument will be an object containing a payment method nonce; either a {@link Dropin~cardPaymentMethodPayload|cardPaymentMethodPayload}, a {@link Dropin~paypalPaymentMethodPayload|paypalPaymentMethodPayload}, a {@link Dropin~venmoPaymentMethodPayload|venmoPaymentMethodPayload}, a {@link Dropin~googlePayPaymentMethodPayload|googlePayPaymentMethodPayload} or an {@link Dropin~applePayPaymentMethodPayload|applePayPaymentMethodPayload}. If no callback is provided, `requestPaymentMethod` will return a promise.
	 * @returns {void|Promise} Returns a promise if no callback is provided.
	 * @example <caption>Requesting a payment method</caption>
	 * var form = document.querySelector('#my-form');
	 * var hiddenNonceInput = document.querySelector('#my-nonce-input');
	 *
	 * form.addEventListener('submit', function (event) {
	 *  event.preventDefault();
	 *
	 *  dropinInstance.requestPaymentMethod(function (err, payload) {
	 *    if (err) {
	 *      // handle error
	 *      return;
	 *    }
	 *    hiddenNonceInput.value = payload.nonce;
	 *    form.submit();
	 *  });
	 * });
	 * @example <caption>Requesting a payment method with data collector</caption>
	 * var form = document.querySelector('#my-form');
	 * var hiddenNonceInput = document.querySelector('#my-nonce-input');
	 * var hiddenDeviceDataInput = document.querySelector('#my-device-data-input');
	 *
	 * form.addEventListener('submit', function (event) {
	 *  event.preventDefault();
	 *
	 *  dropinInstance.requestPaymentMethod(function (err, payload) {
	 *    if (err) {
	 *      // handle error
	 *      return;
	 *    }
	 *    hiddenNonceInput.value = payload.nonce;
	 *    hiddenDeviceDataInput.value = payload.deviceData;
	 *    form.submit();
	 *  });
	 * });
	 *
	 * @example <caption>Requesting a payment method with 3D Secure</caption>
	 * var form = document.querySelector('#my-form');
	 * var hiddenNonceInput = document.querySelector('#my-nonce-input');
	 *
	 * form.addEventListener('submit', function (event) {
	 *  event.preventDefault();
	 *
	 *  dropinInstance.requestPaymentMethod(function (err, payload) {
	 *    if (err) {
	 *      // Handle error
	 *      return;
	 *    }
	 *
	 *    if (payload.liabilityShifted || payload.type !== 'CreditCard') {
	 *      hiddenNonceInput.value = payload.nonce;
	 *      form.submit();
	 *    } else {
	 *      // Decide if you will force the user to enter a different payment method
	 *      // if liability was not shifted
	 *      dropinInstance.clearSelectedPaymentMethod();
	 *    }
	 *  });
	 * });
	 */
	Dropin.prototype.requestPaymentMethod = function (options) {
	  var self = this;
	
	  options = options || {};
	
	  return this._mainView.requestPaymentMethod().then(function (payload) {
	    if (self._threeDSecure && payload.type === constants.paymentMethodTypes.card && payload.liabilityShifted == null) {
	      self._mainView.showLoadingIndicator();
	
	      return self._threeDSecure.verify(payload, options.threeDSecure).then(function (newPayload) {
	        payload.nonce = newPayload.nonce;
	        payload.liabilityShifted = newPayload.liabilityShifted;
	        payload.liabilityShiftPossible = newPayload.liabilityShiftPossible;
	
	        self._mainView.hideLoadingIndicator();
	
	        return payload;
	      }).catch(function (err) {
	        self._mainView.hideLoadingIndicator();
	
	        return Promise.reject(err);
	      });
	    }
	
	    return payload;
	  }).then(function (payload) {
	    if (self._dataCollector) {
	      payload.deviceData = self._dataCollector.getDeviceData();
	    }
	
	    return payload;
	  }).then(function (payload) {
	    return formatPaymentMethodPayload(payload);
	  });
	};
	
	Dropin.prototype._removeStylesheet = function () {
	  var stylesheet = document.getElementById(constants.STYLESHEET_ID);
	
	  if (stylesheet) {
	    stylesheet.parentNode.removeChild(stylesheet);
	  }
	};
	
	Dropin.prototype._injectStylesheet = function () {
	  var stylesheetUrl, assetsUrl;
	
	  if (document.getElementById(constants.STYLESHEET_ID)) { return; }
	
	  assetsUrl = this._client.getConfiguration().gatewayConfiguration.assetsUrl;
	  stylesheetUrl = assetsUrl + '/web/dropin/' + VERSION + '/css/dropin.css';
	
	  assets.loadStylesheet({
	    href: stylesheetUrl,
	    id: constants.STYLESHEET_ID
	  });
	};
	
	/**
	 * Cleanly remove anything set up by {@link module:braintree-web-drop-in|dropin.create}. This may be be useful in a single-page app.
	 * @public
	 * @param {callback} [callback] Called on completion, containing an error if one occurred. No data is returned if teardown completes successfully. If no callback is provided, `teardown` will return a promise.
	 * @returns {void|Promise} Returns a promise if no callback is provided.
	 */
	Dropin.prototype.teardown = function () {
	  var teardownError;
	  var promise = Promise.resolve();
	  var self = this;
	
	  this._removeStylesheet();
	
	  if (this._mainView) {
	    promise.then(function () {
	      return self._mainView.teardown().catch(function (err) {
	        teardownError = err;
	      });
	    });
	  }
	
	  if (this._dataCollector) {
	    promise.then(function () {
	      return this._dataCollector.teardown().catch(function (error) {
	        teardownError = new DropinError({
	          message: 'Drop-in errored tearing down Data Collector.',
	          braintreeWebError: error
	        });
	      });
	    }.bind(this));
	  }
	
	  if (this._threeDSecure) {
	    promise.then(function () {
	      return this._threeDSecure.teardown().catch(function (error) {
	        teardownError = new DropinError({
	          message: 'Drop-in errored tearing down 3D Secure.',
	          braintreeWebError: error
	        });
	      });
	    }.bind(this));
	  }
	
	  return promise.then(function () {
	    return self._removeDropinWrapper();
	  }).then(function () {
	    if (teardownError) {
	      return Promise.reject(teardownError);
	    }
	
	    return Promise.resolve();
	  });
	};
	
	/**
	 * Returns a boolean indicating if a payment method is available through {@link Dropin#requestPaymentMethod|requestPaymentMethod}. Particularly useful for detecting if using a client token with a customer ID to show vaulted payment methods.
	 * @public
	 * @returns {Boolean} True if a payment method is available, otherwise false.
	 */
	Dropin.prototype.isPaymentMethodRequestable = function () {
	  return this._model.isPaymentMethodRequestable();
	};
	
	Dropin.prototype._removeDropinWrapper = function () {
	  this._dropinWrapper.parentNode.removeChild(this._dropinWrapper);
	
	  return Promise.resolve();
	};
	
	function formatPaymentMethodPayload(paymentMethod) {
	  var formattedPaymentMethod = {
	    nonce: paymentMethod.nonce,
	    details: paymentMethod.details,
	    type: paymentMethod.type
	  };
	
	  if (paymentMethod.vaulted != null) {
	    formattedPaymentMethod.vaulted = paymentMethod.vaulted;
	  }
	
	  if (paymentMethod.type === constants.paymentMethodTypes.card) {
	    formattedPaymentMethod.description = paymentMethod.description;
	  }
	
	  if (paymentMethod.type in HAS_RAW_PAYMENT_DATA) {
	    formattedPaymentMethod.details.rawPaymentData = paymentMethod.rawPaymentData;
	  }
	
	  if (typeof paymentMethod.liabilityShiftPossible === 'boolean') {
	    formattedPaymentMethod.liabilityShifted = paymentMethod.liabilityShifted;
	    formattedPaymentMethod.liabilityShiftPossible = paymentMethod.liabilityShiftPossible;
	  }
	
	  if (paymentMethod.deviceData) {
	    formattedPaymentMethod.deviceData = paymentMethod.deviceData;
	  }
	
	  if (paymentMethod.binData) {
	    formattedPaymentMethod.binData = paymentMethod.binData;
	  }
	
	  return formattedPaymentMethod;
	}
	
	module.exports = wrapPrototype(Dropin);
	
	},{"./constants":131,"./dropin-model":132,"./lib/analytics":136,"./lib/assign":137,"./lib/data-collector":140,"./lib/dropin-error":141,"./lib/is-utf-8":145,"./lib/promise":148,"./lib/sanitize-html":149,"./lib/three-d-secure":151,"./lib/uuid":153,"./translations":163,"./views/main-view":180,"./views/payment-methods-view":182,"./views/payment-options-view":183,"@braintree/asset-loader":1,"@braintree/class-list":18,"@braintree/event-emitter":19,"@braintree/wrap-promise":27}],134:[function(require,module,exports){
	'use strict';
	/**
	 * @module braintree-web-drop-in
	 * @description There are two ways to integrate Drop-in into your page: a script tag integration and a JavaScript integration using [`dropin.create`](#.create).
	 *
	 * The script tag integration is the fastest way to integrate. All you need to do is add the Drop-in script inside your form element where you want Drop-in to appear and include a `data-braintree-dropin-authorization` property with your [tokenization key](https://developers.braintreepayments.com/guides/authorization/tokenization-key/javascript/v3) or [client token](https://developers.braintreepayments.com/guides/authorization/client-token).
	 *
	 * When your form is submitted, Drop-in will intercept the form submission and attempt to tokenize the payment method. If the tokenization is successful, it will insert the payment method nonce into a hidden input with the name `payment_method_nonce` and then submit your form. If the tokenization is unsuccessful, a relevant error will be shown in the UI.
	 *
	 * If you have data collector enabled, the device data will be injected into a hidden input with the name `device_data` before form submission.
	 *
	 * Specify creation options as data attributes in your script tag, as shown in the examples below. The following configuration properties may be set:
	 *
	 * * `data-locale`
	 * * `data-card.cardholder-name.required`
	 * * `data-payment-option-priority`
	 * * `data-data-collector.kount`
	 * * `data-data-collector.paypal`
	 * * `data-paypal.amount`
	 * * `data-paypal.currency`
	 * * `data-paypal.flow`
	 * * `data-paypal-credit.amount`
	 * * `data-paypal-credit.currency`
	 * * `data-paypal-credit.flow`
	 *
	 * For more control and customization, use [`dropin.create` instead](#.create).
	 *
	 * See our [demo app](../../script-tag-integration.html) for an example of using our script tag integration.
	 *
	 * @example
	 * <caption>A full example accepting only cards</caption>
	 * <!DOCTYPE html>
	 * <html lang="en">
	 *   <head>
	 *     <meta charset="utf-8">
	 *     <title>Checkout</title>
	 *   </head>
	 *   <body>
	 *     <form id="payment-form" action="/" method="post">
	 *       <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"
	 *        data-braintree-dropin-authorization="CLIENT_AUTHORIZATION"
	 *       ></script>
	 *       <input type="submit" value="Purchase"></input>
	 *     </form>
	 *   </body>
	 * </html>
	 *
	 * @example
	 * <caption>A full example accepting cards, PayPal, and PayPal credit</caption>
	 * <!DOCTYPE html>
	 * <html lang="en">
	 *   <head>
	 *     <meta charset="utf-8">
	 *     <title>Checkout</title>
	 *   </head>
	 *   <body>
	 *     <form id="payment-form" action="/" method="post">
	 *       <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"
	 *        data-braintree-dropin-authorization="CLIENT_AUTHORIZATION"
	 *        data-paypal.flow="checkout"
	 *        data-paypal.amount="10.00"
	 *        data-paypal.currency="USD"
	 *        data-paypal-credit.flow="vault"
	 *       ></script>
	 *       <input type="submit" value="Purchase"></input>
	 *     </form>
	 *   </body>
	 * </html>
	 *
	 * @example
	 * <caption>Specifying a locale and payment option priority</caption>
	 * <form id="payment-form" action="/" method="post">
	 *   <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"
	 *    data-braintree-dropin-authorization="CLIENT_AUTHORIZATION"
	 *    data-locale="de_DE"
	 *    data-payment-option-priority='["paypal","card", "paypalCredit"]'
	 *    data-paypal.flow="checkout"
	 *    data-paypal.amount="10.00"
	 *    data-paypal.currency="USD"
	 *    data-paypal-credit.flow="vault"
	 *   ></script>
	 *   <input type="submit" value="Purchase"></input>
	 * </form>
	 *
	 * @example
	 * <caption>Including an optional cardholder name field in card form</caption>
	 * <form id="payment-form" action="/" method="post">
	 *   <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"
	 *    data-braintree-dropin-authorization="CLIENT_AUTHORIZATION"
	 *    data-card.cardholder-name.required="false"
	 *   ></script>
	 *   <input type="submit" value="Purchase"></input>
	 * </form>
	 *
	 * @example
	 * <caption>Including a required cardholder name field in card form</caption>
	 * <form id="payment-form" action="/" method="post">
	 *   <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"
	 *    data-braintree-dropin-authorization="CLIENT_AUTHORIZATION"
	 *    data-card.cardholder-name.required="true"
	 *   ></script>
	 *   <input type="submit" value="Purchase"></input>
	 * </form>
	 */
	
	var Dropin = require('./dropin');
	var client = require('braintree-web/client');
	var createFromScriptTag = require('./lib/create-from-script-tag');
	var constants = require('./constants');
	var analytics = require('./lib/analytics');
	var DropinError = require('./lib/dropin-error');
	var Promise = require('./lib/promise');
	var wrapPromise = require('@braintree/wrap-promise');
	
	var VERSION = '1.19.0';
	
	/**
	 * @typedef {object} cardCreateOptions The configuration options for cards. Internally, Drop-in uses [Hosted Fields](http://braintree.github.io/braintree-web/3.47.0/module-braintree-web_hosted-fields.html) to render the card form. The `overrides.fields` and `overrides.styles` allow the Hosted Fields to be customized.
	 *
	 * @param {boolean|object} [cardholderName] Will enable a cardholder name field above the card number field. If set to an object, you can specify whether or not the field is required. If set to a `true`, it will default the field to being present, but not required.
	 * @param {boolean} [cardholderName.required=false] When true, the cardholder name field will be required to request the payment method nonce.
	 * @param {object} [overrides.fields] The Hosted Fields [`fields` options](http://braintree.github.io/braintree-web/3.47.0/module-braintree-web_hosted-fields.html#~fieldOptions). Only `number`, `cvv`, `expirationDate` and `postalCode` can be configured. Each is a [Hosted Fields `field` object](http://braintree.github.io/braintree-web/3.47.0/module-braintree-web_hosted-fields.html#~field). `selector` cannot be modified.
	 * @param {object} [overrides.styles] The Hosted Fields [`styles` options](http://braintree.github.io/braintree-web/3.47.0/module-braintree-web_hosted-fields.html#~styleOptions). These can be used to add custom styles to the Hosted Fields iframes. To style the rest of Drop-in, [review the documentation for customizing Drop-in](https://developers.braintreepayments.com/guides/drop-in/customization/javascript/v3#customize-your-ui).
	 * @param {boolean} [clearFieldsAfterTokenization=true] When false, the card form will not clear the card data when the customer returns to the card view after a successful tokenization.
	 * @param {object} [vault] Configuration for vaulting credit cards. Only applies when using a [client token with a customer id](https://developers.braintreepayments.com/reference/request/client-token/generate/#customer_id).
	 * @param {boolean} [vault.allowVaultCardOverride=false] When true, the card form will include an option to let the customer decide not to vault the credit card they enter.
	 * @param {boolean} [vault.vaultCard=true] Whether or not to vault the card upon tokenization. When set to `false` with `allowVaultCardOverride` set to `false`, then cards will not be vaulted.
	 */
	
	/**
	 * @typedef {object} dataCollectorOptions The configuration options for Data Collector. Requires [advanced fraud protection](https://developers.braintreepayments.com/guides/advanced-fraud-tools/client-side/javascript/v3) to be enabled in the Braintree gateway. Contact our [support team](https://developers.braintreepayments.com/forms/contact) to configure your Kount ID. The device data will be included on the {@link Dropin#requestPaymentMethod|requestPaymentMethod payload}.
	 *
	 * @param {boolean} [kount] If true, Kount fraud data collection is enabled. Required if `paypal` parameter is not used.
	 * @param {boolean} [paypal] If true, PayPal fraud data collection is enabled. Required if `kount` parameter is not used.
	 */
	
	/**
	 * @typedef {object} threeDSecureOptions The configuration options for 3D Secure. Requires [3D Secure](https://developers.braintreepayments.com/guides/3d-secure/overview) to be enabled in the Braintree gateway. The liability shift information will be included on the {@link Dropin#requestPaymentMethod|requestPaymentMethod payload}.
	 *
	 * @param {string} amount The amount to verify with 3D Secure.
	 */
	
	/** @typedef {object} paypalCreateOptions The configuration options for PayPal and PayPalCredit. For a full list of options see the [PayPal Checkout client reference options](http://braintree.github.io/braintree-web/3.47.0/PayPalCheckout.html#createPayment).
	 *
	 * @param {string} flow Either `checkout` for a one-time [Checkout with PayPal](https://developers.braintreepayments.com/guides/paypal/checkout-with-paypal/javascript/v3) flow or `vault` for a [Vault flow](https://developers.braintreepayments.com/guides/paypal/vault/javascript/v3). Required when using PayPal or PayPal Credit.
	 * @param {string|number} [amount] The amount of the transaction. Required when using the Checkout flow.
	 * @param {string} [currency] The currency code of the amount, such as `USD`. Required when using the Checkout flow.
	 * @param {string} [buttonStyle] The style object to apply to the PayPal button. Button customization includes color, shape, size, and label. The options [found here](https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/customize-button/#button-styles) are available.
	 * @param {boolean} [commit] The user action to show on the PayPal review page. If true, a `Pay Now` button will be shown. If false, a `Continue` button will be shown.
	 */
	
	/** @typedef {object} applePayCreateOptions The configuration options for Apple Pay.
	 *
	 * @param {string} [buttonStyle=black] Configures the Apple Pay button style. Valid values are `black`, `white`, `white-outline`.
	 * @param {string} displayName The canonical name for your store. Use a non-localized name. This parameter should be a utf-8 string that is a maximum of 128 characters. The system may display this name to the user.
	 * @param {number} [applePaySessionVersion=2] The [version of the `ApplePaySession`](https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_on_the_web_version_history) to use. It's recommended to use the lowest version that contains all the features you need for your checkout to maximize compatibility.
	 * @param {external:ApplePayPaymentRequest} paymentRequest The payment request details to apply on top of those from Braintree.
	 */
	
	/** @typedef {object} googlePayCreateOptions The configuration options for Google Pay. Additional options from the few listed here are available, many have default values applied based on the settings found in the Braintree Gateway. For more information, see [Google's Documentation](https://developers.google.com/pay/api/web/object-reference#request-objects).
	 *
	 * @param {string} merchantId The ID provided by Google for processing transactions in production. Not necessary for testing in sandbox.
	 * @param {string} [googlePayVersion=1] The version of the Google Pay API to use. Defaults to 1, but 2 can be passed in.
	 * @param {external:GooglePayTransactionInfo} transactionInfo The transaction details necessary for processing the payment.
	 * @param {external:GooglePayButtonOptions} [button] The button options for configuring the look of the Google Pay button. The `onClick` property cannot be overwritten.
	 */
	
	/**
	 * @typedef {object} ApplePayPaymentRequest An [Apple Pay Payment Request object](https://developer.apple.com/reference/applepayjs/1916082-applepay_js_data_types/paymentrequest).
	 * @external ApplePayPaymentRequest
	 * @see {@link https://developer.apple.com/reference/applepayjs/1916082-applepay_js_data_types/paymentrequest PaymentRequest}
	 */
	
	/**
	 * @typedef {object} GooglePayTransactionInfo A [Google Pay TransactionInfo object](https://developers.google.com/pay/api/web/object-reference#TransactionInfo).
	 * @external GooglePayTransactionInfo
	 * @see {@link https://developers.google.com/pay/api/web/object-reference#TransactionInfo TransactionInfo}
	 */
	
	/**
	 * @typedef {object} GooglePayButtonOptions A [Google Pay ButtonOptions object](https://developers.google.com/pay/api/web/reference/object#ButtonOptions).
	 * @external GooglePayButtonOptions
	 * @see {@link https://developers.google.com/pay/api/web/reference/object#ButtonOptions ButtonOptions}
	 */
	
	/** @typedef {object|boolean} venmoCreateOptions The configuration options for Venmo. If `true` is passed instead of a configuration object, the default settings listed will be used.
	 *
	 * @param {boolean} [allowNewBrowserTab=true] If false, it restricts supported browsers to those that can app switch to the Venmo app without opening a new tab.
	 */
	
	/**
	 * @static
	 * @function create
	 * @description This function is the entry point for `braintree.dropin`. It is used for creating {@link Dropin} instances.
	 * @param {object} options Object containing all {@link Dropin} options:
	 * @param {string} options.authorization A [tokenization key](https://developers.braintreepayments.com/guides/authorization/tokenization-key/javascript/v3) or a [client token](https://developers.braintreepayments.com/guides/authorization/client-token). If authorization is a client token created with a [customer ID](https://developers.braintreepayments.com/guides/drop-in/javascript/v3#customer-id), Drop-in will render saved payment methods and automatically store any newly-added payment methods in their Vault record.
	 * @param {string|HTMLElement} options.container A reference to an empty element, such as a `<div>`, where Drop-in will be included on your page or the selector for the empty element. e.g. `#dropin-container`.
	 * @param {string} options.selector Deprecated: Now an alias for `options.container`.
	 * @param {string} [options.locale=`en_US`] Use this option to change the language, links, and terminology used throughout Drop-in. Supported locales include:
	 * `da_DK`,
	 * `de_DE`,
	 * `en_AU`,
	 * `en_GB`,
	 * `en_US`,
	 * `es_ES`,
	 * `fr_CA`,
	 * `fr_FR`,
	 * `id_ID`,
	 * `it_IT`,
	 * `ja_JP`,
	 * `ko_KR`,
	 * `nl_NL`,
	 * `no_NO`,
	 * `pl_PL`,
	 * `pt_BR`,
	 * `pt_PT`,
	 * `ru_RU`,
	 * `sv_SE`,
	 * `th_TH`,
	 * `zh_CN`,
	 * `zh_HK`,
	 * `zh_TW`.
	 *
	 * @param {object} [options.translations] To use your own translations, pass an object with the strings you wish to replace. This object must use the same structure as the object used internally for supported translations, which can be found [here](https://github.com/braintree/braintree-web-drop-in/blob/master/src/translations/en_US.js). Any strings that are not included will be those from the provided `locale` or `en_US` if no `locale` is provided. See below for an example of creating Drop-in with custom translations.
	 * @param {array} [options.paymentOptionPriority] Use this option to indicate the order in which enabled payment options should appear when multiple payment options are enabled. By default, payment options will appear in this order: `['card', 'paypal', 'paypalCredit', 'venmo', 'applePay']`. Payment options omitted from this array will not be offered to the customer.
	 *
	 * @param {boolean|object} [options.card] The configuration options for cards. See [`cardCreateOptions`](#~cardCreateOptions) for all `card` options. If this option is omitted, cards will still appear as a payment option. To remove cards, pass `false` for the value.
	 * @param {object} [options.paypal] The configuration options for PayPal. To include a PayPal option in your Drop-in integration, include the `paypal` parameter and [enable PayPal in the Braintree Control Panel](https://developers.braintreepayments.com/guides/paypal/testing-go-live/#go-live). To test in Sandbox, you will need to [link a PayPal sandbox test account to your Braintree sandbox account](https://developers.braintreepayments.com/guides/paypal/testing-go-live/#linked-paypal-testing).
	 *
	 * Some of the PayPal configuration options are listed [here](#~paypalCreateOptions), but for a full list see the [PayPal Checkout client reference options](http://braintree.github.io/braintree-web/3.47.0/PayPalCheckout.html#createPayment).
	 *
	 * PayPal is not [supported in Internet Explorer versions lower than 11](https://developer.paypal.com/docs/checkout/reference/faq/#which-browsers-does-paypal-checkout-support).
	 *
	 * @param {object} [options.paypalCredit] The configuration options for PayPal Credit. To include a PayPal Credit option in your Drop-in integration, include the `paypalCredit` parameter and [enable PayPal in the Braintree Control Panel](https://developers.braintreepayments.com/guides/paypal/testing-go-live/#go-live).
	 *
	 * Some of the PayPal Credit configuration options are listed [here](#~paypalCreateOptions), but for a full list see the [PayPal Checkout client reference options](http://braintree.github.io/braintree-web/3.47.0/PayPalCheckout.html#createPayment). For more information on PayPal Credit, see the [Braintree Developer Docs](https://developers.braintreepayments.com/guides/paypal/paypal-credit/javascript/v3).
	 *
	 * PayPal Credit is not [supported in Internet Explorer versions lower than 11](https://developer.paypal.com/docs/checkout/reference/faq/#which-browsers-does-paypal-checkout-support).
	 *
	 * @param {object|boolean} [options.venmo] The configuration options for Pay with Venmo. To include a Venmo option in your Drop-in integration, include the `venmo` parameter and [follow the documentation for setting up Venmo in the Braintree control panel](https://articles.braintreepayments.com/guides/payment-methods/venmo#setup). If a user's browser does not support Venmo, the Venmo option will not be rendered.
	 *
	 * See [`venmoCreateOptions`](#~venmoCreateOptions) for `venmo` options.
	 *
	 * @param {object} [options.applePay] The configuration options for Apple Pay. To include an Apple Pay option in your Drop-in integration, include the `applePay` parameter and [enable Apple Pay in the Braintree Control Panel](https://developers.braintreepayments.com/guides/apple-pay/configuration/javascript/v3). If a user's browser does not support Apple Pay, the Apple Pay option will not be rendered. See [Apple's documentation](https://support.apple.com/en-us/HT201469) for browser and device support.
	 *
	 * See [`applePayCreateOptions`](#~applePayCreateOptions) for `applePay` options.
	 *
	 * @param {object} [options.googlePay] The configuration options for Google Pay. To include a Google Pay option in your Drop-in integration, include the `googlePay` parameter and [enable Google Pay in the Braintree Control Panel](https://developers.braintreepayments.com/guides/google-pay/configuration/javascript/v3). If a user's browser does not support Google Pay, the Google Pay option will not be rendered. See [Google's documentation](https://developers.google.com/pay/api/web/test-and-deploy) for browser and device support.
	 *
	 * See [`googlePayCreateOptions`](#~googlePayCreateOptions) for `googlePay` options.
	 *
	 * @param {object} [options.dataCollector] The configuration options for data collector. See [`dataCollectorOptions`](#~dataCollectorOptions) for all `dataCollector` options. If Data Collector is configured and fails to load, Drop-in creation will fail.
	 *
	 * @param {object} [options.threeDSecure] The configuration options for 3D Secure. See [`threeDSecureOptions`](#~threeDSecureOptions) for all `threeDSecure` options. If 3D Secure is configured and fails to load, Drop-in creation will fail.
	 *
	 * @param {boolean} [options.vaultManager=false] Whether or not to allow a customer to delete saved payment methods when used with a [client token with a customer id](https://developers.braintreepayments.com/reference/request/client-token/generate/#customer_id). *Note:* Deleting a payment method from Drop-in will permanently delete the payment method, so this option is not recommended for merchants using Braintree's recurring billing system. This feature is not supported in Internet Explorer 9.
	 *
	 * @param {boolean} [options.preselectVaultedPaymentMethod=true] Whether or not to initialize Drop-in with a vaulted payment method pre-selected. Only applicable when using a [client token with a customer id](https://developers.braintreepayments.com/reference/request/client-token/generate/#customer_id) and a customer with saved payment methods.
	 *
	 * @param {function} [callback] The second argument, `data`, is the {@link Dropin} instance. Returns a promise if no callback is provided.
	 * @returns {void|Promise} Returns a promise if no callback is provided.
	 * @example
	 * <caption>A full example of accepting credit cards with callback API</caption>
	 * <!DOCTYPE html>
	 * <html lang="en">
	 *   <head>
	 *     <meta charset="utf-8">
	 *     <title>Checkout</title>
	 *   </head>
	 *   <body>
	 *     <div id="dropin-container"></div>
	 *     <button id="submit-button">Purchase</button>
	 *
	 *     <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"></script>
	 *
	 *     <script>
	 *       var submitButton = document.querySelector('#submit-button');
	 *
	 *       braintree.dropin.create({
	 *         authorization: 'CLIENT_AUTHORIZATION',
	 *         container: '#dropin-container'
	 *       }, function (err, dropinInstance) {
	 *         if (err) {
	 *           // Handle any errors that might've occurred when creating Drop-in
	 *           console.error(err);
	 *           return;
	 *         }
	 *         submitButton.addEventListener('click', function () {
	 *           dropinInstance.requestPaymentMethod(function (err, payload) {
	 *             if (err) {
	 *               // Handle errors in requesting payment method
	 *             }
	 *
	 *             // Send payload.nonce to your server
	 *           });
	 *         });
	 *       });
	 *     </script>
	 *   </body>
	 * </html>
	 * @example
	 * <caption>A full example of accepting credit cards with promise API</caption>
	 * <!DOCTYPE html>
	 * <html lang="en">
	 *   <head>
	 *     <meta charset="utf-8">
	 *     <title>Checkout</title>
	 *   </head>
	 *   <body>
	 *     <div id="dropin-container"></div>
	 *     <button id="submit-button">Purchase</button>
	 *
	 *     <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"></script>
	 *
	 *     <script>
	 *       var submitButton = document.querySelector('#submit-button');
	 *
	 *       braintree.dropin.create({
	 *         authorization: 'CLIENT_AUTHORIZATION',
	 *         container: '#dropin-container'
	 *       }).then(function (dropinInstance) {
	 *         submitButton.addEventListener('click', function () {
	 *           dropinInstance.requestPaymentMethod().then(function (payload) {
	 *             // Send payload.nonce to your server
	 *           }).catch(function (err) {
	 *             // Handle errors in requesting payment method
	 *           });
	 *         });
	 *       }).catch(function (err) {
	 *         // Handle any errors that might've occurred when creating Drop-in
	 *         console.error(err);
	 *       });
	 *     </script>
	 *   </body>
	 * </html>
	 * @example
	 * <caption>Setting up a Drop-in instance to accept credit cards, PayPal, PayPal Credit, Venmo, and Apple Pay</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   applePay: {
	 *     displayName: 'Merchant Name',
	 *     paymentRequest: {
	   *     label: 'Localized Name',
	 *       total: '10.00'
	 *     }
	 *   },
	 *   paypal: {
	 *     flow: 'checkout',
	 *     amount: '10.00',
	 *     currency: 'USD'
	 *   },
	 *  paypalCredit: {
	 *    flow: 'checkout',
	 *    amount: '10.00',
	 *    currency: 'USD'
	 *   },
	 *   venmo: true
	 * }, function (err, dropinInstance) {
	 *   // Set up a handler to request a payment method and
	 *   // submit the payment method nonce to your server
	 * });
	 * @example
	 * <caption>Setting up a Drop-in instance to accept Venmo with restricted browser support</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   venmo: {
	 *     allowNewBrowserTab: false
	 *   }
	 * }, function (err, dropinInstance) {
	 *   // Set up a handler to request a payment method and
	 *   // submit the payment method nonce to your server
	 * });
	 *
	 * @example
	 * <caption>Submitting the payment method nonce to the server using a form</caption>
	 * <!DOCTYPE html>
	 * <html lang="en">
	 *   <head>
	 *     <meta charset="utf-8">
	 *     <title>Checkout</title>
	 *   </head>
	 *   <body>
	 *     <form id="payment-form" action="/" method="post">
	 *       <div id="dropin-container"></div>
	 *       <input type="submit" value="Purchase"></input>
	 *       <input type="hidden" id="nonce" name="payment_method_nonce"></input>
	 *     </form>
	 *
	 *     <script src="https://js.braintreegateway.com/web/dropin/1.19.0/js/dropin.min.js"></script>
	 *
	 *     <script>
	 *       var form = document.querySelector('#payment-form');
	 *       var nonceInput = document.querySelector('#nonce');
	 *
	 *       braintree.dropin.create({
	 *         authorization: 'CLIENT_AUTHORIZATION',
	 *         container: '#dropin-container'
	 *       }, function (err, dropinInstance) {
	 *         if (err) {
	 *           // Handle any errors that might've occurred when creating Drop-in
	 *           console.error(err);
	 *           return;
	 *         }
	 *         form.addEventListener('submit', function (event) {
	 *           event.preventDefault();
	 *
	 *           dropinInstance.requestPaymentMethod(function (err, payload) {
	 *             if (err) {
	 *               // Handle errors in requesting payment method
	 *               return;
	 *             }
	 *
	 *             // Send payload.nonce to your server
	 *             nonceInput.value = payload.nonce;
	 *             form.submit();
	 *           });
	 *         });
	 *       });
	 *     </script>
	 *   </body>
	 * </html>
	 *
	 * @example
	 * <caption>Use your own translations</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   translations: {
	 *     payingWith: 'You are paying with {{paymentSource}}',
	 *     chooseAnotherWayToPay: 'My custom chooseAnotherWayToPay string',
	 *     // Any other custom translation strings
	 *   }
	 * }, callback);
	 *
	 * @example
	 * <caption>Customizing Drop-in with card form overrides</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   card: {
	 *     overrides: {
	 *       fields: {
	 *         number: {
	 *           placeholder: '1111 1111 1111 1111' // Update the number field placeholder
	 *         },
	 *         postalCode: {
	 *           minlength: 5 // Set the minimum length of the postal code field
	 *         },
	 *         cvv: null // Remove the CVV field from your form
	 *       },
	 *       styles: {
	 *         input: {
	 *           'font-size': '18px' // Change the font size for all inputs
	 *         },
	 *         ':focus': {
	 *           color: 'red' // Change the focus color to red for all inputs
	 *         }
	 *       }
	 *     }
	 *   }
	 * }, callback);
	 *
	 * @example
	 * <caption>Mask Card Inputs</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   card: {
	 *     overrides: {
	 *       fields: {
	 *         number: {
	 *           maskInput: {
	 *             showLastFour: true
	 *           }
	 *         },
	 *         cvv: {
	 *           maskInput: true
	 *         }
	 *       }
	 *     }
	 *   }
	 * }, callback);
	 *
	 * @example
	 * <caption>Including a cardholder name field</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   card: {
	 *     cardholderName: true
	 *   }
	 * }, callback);
	 *
	 * @example
	 * <caption>Including a required cardholder name field</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   card: {
	 *     cardholderName: {
	 *       required: true
	 *     }
	 *   }
	 * }, callback);
	 *
	 * @example
	 * <caption>Enabling 3D Secure</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   threeDSecure: {
	 *     amount: '10.00'
	 *   }
	 * }, callback);
	 *
	 * @example
	 * <caption>Enabled Vault Manager</caption>
	 * braintree.dropin.create({
	 *   authorization: 'CLIENT_AUTHORIZATION',
	 *   container: '#dropin-container',
	 *   vaultManager: true
	 * }, callback);
	 */
	
	function create(options) {
	  if (!options.authorization) {
	    return Promise.reject(new DropinError('options.authorization is required.'));
	  }
	
	  return client.create({
	    authorization: options.authorization
	  }).catch(function (err) {
	    return Promise.reject(new DropinError({
	      message: 'There was an error creating Drop-in.',
	      braintreeWebError: err
	    }));
	  }).then(function (clientInstance) {
	    clientInstance = setAnalyticsIntegration(clientInstance);
	
	    if (clientInstance.getConfiguration().authorizationType === 'TOKENIZATION_KEY') {
	      analytics.sendEvent(clientInstance, 'started.tokenization-key');
	    } else {
	      analytics.sendEvent(clientInstance, 'started.client-token');
	    }
	
	    return new Promise(function (resolve, reject) {
	      new Dropin({
	        merchantConfiguration: options,
	        client: clientInstance
	      })._initialize(function (err, instance) {
	        if (err) {
	          reject(err);
	
	          return;
	        }
	
	        resolve(instance);
	      });
	    });
	  });
	}
	
	function setAnalyticsIntegration(clientInstance) {
	  var configuration = clientInstance.getConfiguration();
	
	  configuration.analyticsMetadata.integration = constants.INTEGRATION;
	  configuration.analyticsMetadata.integrationType = constants.INTEGRATION;
	  configuration.analyticsMetadata.dropinVersion = VERSION;
	
	  clientInstance.getConfiguration = function () {
	    return configuration;
	  };
	
	  return clientInstance;
	}
	
	// we check for document's existence to support server side rendering
	createFromScriptTag(create, typeof document !== 'undefined' && document.querySelector('script[data-braintree-dropin-authorization]'));
	
	module.exports = {
	  create: wrapPromise(create),
	  /**
	   * @description The current version of Drop-in, i.e. `1.19.0`.
	   * @type {string}
	   */
	  VERSION: VERSION
	};
	
	},{"./constants":131,"./dropin":133,"./lib/analytics":136,"./lib/create-from-script-tag":139,"./lib/dropin-error":141,"./lib/promise":148,"@braintree/wrap-promise":27,"braintree-web/client":36}],135:[function(require,module,exports){
	'use strict';
	
	function addSelectionEventHandler(element, func) {
	  element.addEventListener('click', func);
	  element.addEventListener('keyup', function (event) {
	    if (event.keyCode === 13) {
	      func();
	    }
	  });
	}
	
	module.exports = addSelectionEventHandler;
	
	},{}],136:[function(require,module,exports){
	'use strict';
	
	var atob = require('./polyfill').atob;
	var constants = require('../constants');
	var braintreeClientVersion = require('braintree-web/client').VERSION;
	
	function _millisToSeconds(millis) {
	  return Math.floor(millis / 1000);
	}
	
	function sendAnalyticsEvent(client, kind, callback) {
	  var configuration = client.getConfiguration();
	  var analyticsRequest = client._request;
	  var timestamp = _millisToSeconds(Date.now());
	  var url = configuration.gatewayConfiguration.analytics.url;
	  var data = {
	    analytics: [{
	      kind: constants.ANALYTICS_PREFIX + kind,
	      timestamp: timestamp
	    }],
	    _meta: configuration.analyticsMetadata,
	    braintreeLibraryVersion: braintreeClientVersion
	  };
	
	  if (configuration.authorizationType === 'TOKENIZATION_KEY') {
	    data.tokenizationKey = configuration.authorization;
	  } else {
	    data.authorizationFingerprint = JSON.parse(atob(configuration.authorization)).authorizationFingerprint;
	  }
	
	  analyticsRequest({
	    url: url,
	    method: 'post',
	    data: data,
	    timeout: constants.ANALYTICS_REQUEST_TIMEOUT_MS
	  }, callback);
	}
	
	module.exports = {
	  sendEvent: sendAnalyticsEvent
	};
	
	},{"../constants":131,"./polyfill":147,"braintree-web/client":36}],137:[function(require,module,exports){
	arguments[4][70][0].apply(exports,arguments)
	},{"dup":70}],138:[function(require,module,exports){
	'use strict';
	
	var isIe9 = require('@braintree/browser-detection/is-ie9');
	var isIe10 = require('@braintree/browser-detection/is-ie10');
	
	module.exports = {
	  isIe9: isIe9,
	  isIe10: isIe10
	};
	
	},{"@braintree/browser-detection/is-ie10":9,"@braintree/browser-detection/is-ie9":11}],139:[function(require,module,exports){
	'use strict';
	
	var analytics = require('./analytics');
	var find = require('./find-parent-form');
	var uuid = require('./uuid');
	var DropinError = require('./dropin-error');
	var kebabCaseToCamelCase = require('./kebab-case-to-camel-case');
	var WHITELISTED_DATA_ATTRIBUTES = [
	  'locale',
	  'payment-option-priority',
	
	  'data-collector.kount',
	  'data-collector.paypal',
	
	  // camelcase version was accidentally used initially.
	  // we add the kebab case version to match the docs, but
	  // we retain the camelcase version for backwards compatibility
	  'card.cardholderName',
	  'card.cardholderName.required',
	  'card.cardholder-name',
	  'card.cardholder-name.required',
	
	  'paypal.amount',
	  'paypal.currency',
	  'paypal.flow',
	  'paypal.landing-page-type',
	
	  'paypal-credit.amount',
	  'paypal-credit.currency',
	  'paypal-credit.flow',
	  'paypal-credit.landing-page-type'
	];
	
	function injectHiddenInput(name, value, form) {
	  var input = form.querySelector('[name="' + name + '"]');
	
	  if (!input) {
	    input = document.createElement('input');
	    input.type = 'hidden';
	    input.name = name;
	    form.appendChild(input);
	  }
	
	  input.value = value;
	}
	
	function addCompositeKeyValuePairToObject(obj, key, value) {
	  var decomposedKeys = key.split('.');
	  var topLevelKey = kebabCaseToCamelCase(decomposedKeys[0]);
	
	  if (decomposedKeys.length === 1) {
	    obj[topLevelKey] = deserialize(value);
	  } else {
	    obj[topLevelKey] = obj[topLevelKey] || {};
	    addCompositeKeyValuePairToObject(obj[topLevelKey], decomposedKeys.slice(1).join('.'), value);
	  }
	}
	
	function deserialize(value) {
	  try {
	    return JSON.parse(value);
	  } catch (e) {
	    return value;
	  }
	}
	
	function createFromScriptTag(createFunction, scriptTag) {
	  var authorization, container, createOptions, form;
	
	  if (!scriptTag) {
	    return;
	  }
	
	  authorization = scriptTag.getAttribute('data-braintree-dropin-authorization');
	
	  if (!authorization) {
	    throw new DropinError('Authorization not found in data-braintree-dropin-authorization attribute');
	  }
	
	  container = document.createElement('div');
	  container.id = 'braintree-dropin-' + uuid();
	
	  form = find.findParentForm(scriptTag);
	
	  if (!form) {
	    throw new DropinError('No form found for script tag integration.');
	  }
	
	  form.addEventListener('submit', function (event) {
	    event.preventDefault();
	  });
	
	  scriptTag.parentNode.insertBefore(container, scriptTag);
	
	  createOptions = {
	    authorization: authorization,
	    container: container
	  };
	
	  WHITELISTED_DATA_ATTRIBUTES.forEach(function (compositeKey) {
	    var value = scriptTag.getAttribute('data-' + compositeKey);
	
	    if (value == null) {
	      return;
	    }
	
	    addCompositeKeyValuePairToObject(createOptions, compositeKey, value);
	  });
	
	  createFunction(createOptions).then(function (instance) {
	    analytics.sendEvent(instance._client, 'integration-type.script-tag');
	    form.addEventListener('submit', function () {
	      instance.requestPaymentMethod(function (requestPaymentError, payload) {
	        if (requestPaymentError) {
	          return;
	        }
	
	        injectHiddenInput('payment_method_nonce', payload.nonce, form);
	
	        if (payload.deviceData) {
	          injectHiddenInput('device_data', payload.deviceData, form);
	        }
	
	        form.submit();
	      });
	    });
	  });
	}
	
	module.exports = createFromScriptTag;
	
	},{"./analytics":136,"./dropin-error":141,"./find-parent-form":142,"./kebab-case-to-camel-case":146,"./uuid":153}],140:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var constants = require('../constants');
	var analytics = require('./analytics');
	var assets = require('@braintree/asset-loader');
	var Promise = require('./promise');
	
	function DataCollector(config) {
	  this._config = config;
	}
	
	DataCollector.prototype.initialize = function () {
	  var self = this;
	
	  return Promise.resolve().then(function () {
	    var braintreeWebVersion;
	
	    if (global.braintree && global.braintree.dataCollector) {
	      return Promise.resolve();
	    }
	
	    braintreeWebVersion = self._config.client.getVersion();
	
	    return assets.loadScript({
	      src: 'https://js.braintreegateway.com/web/' + braintreeWebVersion + '/js/data-collector.min.js',
	      id: constants.DATA_COLLECTOR_SCRIPT_ID
	    });
	  }).then(function () {
	    return global.braintree.dataCollector.create(self._config);
	  }).then(function (instance) {
	    self._instance = instance;
	  }).catch(function (err) {
	    analytics.sendEvent(self._config.client, 'data-collector.setup-failed');
	    // log the Data Collector setup error
	    // but do not prevent Drop-in from loading
	    self.log(err);
	  });
	};
	
	DataCollector.prototype.log = function (message) {
	  console.log(message); // eslint-disable-line no-console
	};
	
	DataCollector.prototype.getDeviceData = function () {
	  if (!this._instance) {
	    return '';
	  }
	
	  return this._instance.deviceData;
	};
	
	DataCollector.prototype.teardown = function () {
	  if (!this._instance) {
	    return Promise.resolve();
	  }
	
	  return this._instance.teardown();
	};
	
	module.exports = DataCollector;
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../constants":131,"./analytics":136,"./promise":148,"@braintree/asset-loader":1}],141:[function(require,module,exports){
	'use strict';
	
	function isBraintreeWebError(err) {
	  return err.name === 'BraintreeError';
	}
	
	function DropinError(err) {
	  this.name = 'DropinError';
	
	  if (typeof err === 'string') {
	    this.message = err;
	  } else {
	    this.message = err.message;
	  }
	
	  if (isBraintreeWebError(err)) {
	    this._braintreeWebError = err;
	  } else {
	    this._braintreeWebError = err.braintreeWebError;
	  }
	}
	
	DropinError.prototype = Object.create(Error.prototype);
	DropinError.prototype.constructor = DropinError;
	
	module.exports = DropinError;
	
	},{}],142:[function(require,module,exports){
	'use strict';
	
	function findParentForm(element) {
	  var parentNode = element.parentNode;
	
	  if (!parentNode || parentNode.nodeName === 'FORM') {
	    return parentNode;
	  }
	
	  return findParentForm(parentNode);
	}
	
	module.exports = {
	  findParentForm: findParentForm
	};
	
	},{}],143:[function(require,module,exports){
	'use strict';
	
	var atob = require('./polyfill').atob;
	
	module.exports = function (client) {
	  var authorizationFingerprint;
	  var configuration = client.getConfiguration();
	
	  if (configuration.authorizationType !== 'TOKENIZATION_KEY') {
	    authorizationFingerprint = JSON.parse(atob(configuration.authorization)).authorizationFingerprint;
	
	    return !authorizationFingerprint || authorizationFingerprint.indexOf('customer_id=') === -1;
	  }
	
	  return true;
	};
	
	},{"./polyfill":147}],144:[function(require,module,exports){
	(function (global){
	'use strict';
	
	function isHTTPS() {
	  return global.location.protocol === 'https:';
	}
	
	module.exports = {
	  isHTTPS: isHTTPS
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],145:[function(require,module,exports){
	(function (global){
	'use strict';
	
	module.exports = function (win) {
	  win = win || global;
	
	  return Boolean(win.document.characterSet && win.document.characterSet.toLowerCase() === 'utf-8');
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],146:[function(require,module,exports){
	'use strict';
	
	function kebabCaseToCamelCase(kebab) {
	  var parts = kebab.split('-');
	  var first = parts.shift();
	  var capitalizedParts = parts.map(function (part) {
	    return part.charAt(0).toUpperCase() + part.substring(1);
	  });
	
	  return [first].concat(capitalizedParts).join('');
	}
	
	module.exports = kebabCaseToCamelCase;
	
	},{}],147:[function(require,module,exports){
	(function (global){
	'use strict';
	/* eslint-disable no-mixed-operators */
	
	var atobNormalized = typeof global.atob === 'function' ? global.atob : atob;
	
	function atob(base64String) {
	  var a, b, c, b1, b2, b3, b4, i;
	  var base64Matcher = new RegExp('^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$');
	  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	  var result = '';
	
	  if (!base64Matcher.test(base64String)) {
	    throw new Error('Non base64 encoded input passed to window.atob polyfill');
	  }
	
	  i = 0;
	  do {
	    b1 = characters.indexOf(base64String.charAt(i++));
	    b2 = characters.indexOf(base64String.charAt(i++));
	    b3 = characters.indexOf(base64String.charAt(i++));
	    b4 = characters.indexOf(base64String.charAt(i++));
	
	    a = (b1 & 0x3F) << 2 | b2 >> 4 & 0x3;
	    b = (b2 & 0xF) << 4 | b3 >> 2 & 0xF;
	    c = (b3 & 0x3) << 6 | b4 & 0x3F;
	
	    result += String.fromCharCode(a) + (b ? String.fromCharCode(b) : '') + (c ? String.fromCharCode(c) : '');
	  } while (i < base64String.length);
	
	  return result;
	}
	
	module.exports = {
	  atob: function (base64String) {
	    return atobNormalized.call(global, base64String);
	  },
	  _atob: atob
	};
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],148:[function(require,module,exports){
	arguments[4][95][0].apply(exports,arguments)
	},{"dup":95,"promise-polyfill":127}],149:[function(require,module,exports){
	'use strict';
	
	module.exports = function (string) {
	  if (typeof string !== 'string') {
	    return '';
	  }
	
	  return string
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;');
	};
	
	},{}],150:[function(require,module,exports){
	'use strict';
	
	module.exports = function () {
	  var el = document.createElement('div');
	  var prop = 'flex-basis: 1px';
	  var prefixes = [
	    '-webkit-',
	    '-moz-',
	    '-ms-',
	    '-o-',
	    ''
	  ];
	
	  prefixes.forEach(function (prefix) {
	    el.style.cssText += prefix + prop;
	  });
	
	  return Boolean(el.style.length);
	};
	
	},{}],151:[function(require,module,exports){
	'use strict';
	
	var assign = require('./assign').assign;
	var threeDSecure = require('braintree-web/three-d-secure');
	
	function ThreeDSecure(client, merchantConfiguration) {
	  this._client = client;
	  this._config = merchantConfiguration;
	}
	
	ThreeDSecure.prototype.initialize = function () {
	  var self = this;
	
	  return threeDSecure.create({
	    client: this._client,
	    version: 2
	  }).then(function (instance) {
	    self._instance = instance;
	  });
	};
	
	ThreeDSecure.prototype.verify = function (payload, merchantProvidedData) {
	  var verifyOptions = assign({
	    amount: this._config.amount
	  }, merchantProvidedData, {
	    nonce: payload.nonce,
	    bin: payload.details.bin,
	    // TODO in the future, we will allow
	    // merchants to pass in a custom
	    // onLookupComplete hook
	    onLookupComplete: function (data, next) {
	      next();
	    }
	  });
	
	  return this._instance.verifyCard(verifyOptions);
	};
	
	ThreeDSecure.prototype.updateConfiguration = function (key, value) {
	  this._config[key] = value;
	};
	
	ThreeDSecure.prototype.teardown = function () {
	  return this._instance.teardown();
	};
	
	module.exports = ThreeDSecure;
	
	},{"./assign":137,"braintree-web/three-d-secure":105}],152:[function(require,module,exports){
	'use strict';
	
	var browserDetection = require('./browser-detection');
	
	function isHidden(element) {
	  if (!element) { // no parentNode, so nothing containing the element is hidden
	    return false;
	  }
	
	  if (element.style.display === 'none') {
	    return true;
	  }
	
	  return isHidden(element.parentNode);
	}
	
	function onTransitionEnd(element, propertyName, callback) {
	  if (browserDetection.isIe9() || isHidden(element)) {
	    callback();
	
	    return;
	  }
	
	  function transitionEventListener(event) {
	    if (event.propertyName === propertyName) {
	      element.removeEventListener('transitionend', transitionEventListener);
	      callback();
	    }
	  }
	
	  element.addEventListener('transitionend', transitionEventListener);
	}
	
	module.exports = {
	  onTransitionEnd: onTransitionEnd
	};
	
	},{"./browser-detection":138}],153:[function(require,module,exports){
	'use strict';
	/* eslint-disable no-mixed-operators */
	
	function uuid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c === 'x' ? r : r & 0x3 | 0x8;
	
	    return v.toString(16);
	  });
	}
	
	module.exports = uuid;
	
	},{}],154:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Betaler med {{paymentSource}}",
	  "chooseAnotherWayToPay": "Vælg en anden betalingsmetode",
	  "chooseAWayToPay": "Vælg, hvordan du vil betale",
	  "otherWaysToPay": "Andre betalingsmetoder",
	  "edit": "Rediger",
	  "doneEditing": "Udført",
	  "editPaymentMethods": "Rediger betalingsmetoder",
	  "CreditCardDeleteConfirmationMessage": "Vil du slette {{secondaryIdentifier}}-kortet, der slutter på {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Vil du slette PayPal-kontoen {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Er du sikker på, at du vil slette Venmo-kontoen med brugernavnet {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Er du sikker på, at du vil slette denne betalingsmetode?",
	  "deleteCancelButton": "Annuller",
	  "deleteConfirmationButton": "Slet",
	  "fieldEmptyForCvv": "Du skal angive kontrolcifrene.",
	  "fieldEmptyForExpirationDate": "Du skal angive udløbsdatoen.",
	  "fieldEmptyForCardholderName": "Du skal angive kortindehaverens navn.",
	  "fieldTooLongForCardholderName": "Kortejerens navn skal være mindre end 256 tegn.",
	  "fieldEmptyForNumber": "Du skal angive et nummer.",
	  "fieldEmptyForPostalCode": "Du skal angive et postnummer.",
	  "fieldInvalidForCvv": "Sikkerhedskoden er ugyldig.",
	  "fieldInvalidForExpirationDate": "Udløbsdatoen er ugyldig.",
	  "fieldInvalidForNumber": "Kortnummeret er ugyldigt.",
	  "fieldInvalidForPostalCode": "Postnummeret er ugyldigt.",
	  "genericError": "Der opstod en fejl.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Dette betalingskort er allerede en gemt betalingsmetode.",
	  "hostedFieldsFailedTokenizationError": "Tjek oplysningerne, og prøv igen.",
	  "hostedFieldsFieldsInvalidError": "Tjek oplysningerne, og prøv igen.",
	  "hostedFieldsTokenizationNetworkErrorError": "Netværksfejl. Prøv igen.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Betalingskortet blev ikke bekræftet. Tjek oplysningerne, og prøv igen.",
	  "paypalButtonMustBeUsed": "Brug PayPal-knappen for at fortsætte med din betaling.",
	  "paypalAccountTokenizationFailedError": "PayPal-kontoen blev ikke tilføjet. Prøv igen.",
	  "paypalFlowFailedError": "Der kunne ikke oprettes forbindelse til PayPal. Prøv igen.",
	  "paypalTokenizationRequestActiveError": "PayPal-betalingen er i gang med at blive autoriseret.",
	  "venmoCanceledError": "Der opstod en fejl. Sørg for, at du har den seneste version af Venmo-appen installeret på din enhed, og at din browser understøtter skift til Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Vi kunne ikke slette betalingsmetoden. Prøv igen.",
	  "venmoAppFailedError": "Venmo-appen blev ikke fundet på din enhed.",
	  "unsupportedCardTypeError": "Korttypen understøttes ikke. Prøv et andet kort.",
	  "applePayTokenizationError": "Der opstod en netværksfejl under behandlingen af betalingen med Apple Pay. Prøv igen.",
	  "applePayActiveCardError": "Knyt et understøttet kort til din Apple Pay-e-pung.",
	  "cardholderNameLabel": "Kortindehaverens navn",
	  "cardNumberLabel": "Kortnummer",
	  "cvvLabel": "Kontrolcifre",
	  "cvvThreeDigitLabelSubheading": "(3 cifre)",
	  "cvvFourDigitLabelSubheading": "(4 cifre)",
	  "cardholderNamePlaceholder": "Kortindehaverens navn",
	  "expirationDateLabel": "Udløbsdato",
	  "expirationDateLabelSubheading": "(MM/ÅÅ)",
	  "expirationDatePlaceholder": "MM/ÅÅ",
	  "postalCodeLabel": "Postnummer",
	  "saveCardLabel": "Gem kort",
	  "payWithCard": "Betal med kort",
	  "endingIn": "Der slutter på {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Kort",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],155:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Zahlen mit {{paymentSource}}",
	  "chooseAnotherWayToPay": "Andere Zahlungsmethode wählen",
	  "chooseAWayToPay": "Wie möchten Sie bezahlen?",
	  "otherWaysToPay": "Andere Zahlungsmethoden",
	  "edit": "Bearbeiten",
	  "doneEditing": "Fertig",
	  "editPaymentMethods": "Zahlungsquellen bearbeiten",
	  "CreditCardDeleteConfirmationMessage": "{{secondaryIdentifier}} Karte mit den Endziffern {{identifier}} löschen?",
	  "PayPalAccountDeleteConfirmationMessage": "PayPal-Konto {{identifier}} löschen?",
	  "VenmoAccountDeleteConfirmationMessage": "Wollen Sie das Venmo-Konto mit dem Benutzernamen {{identifier}} wirklich löschen?",
	  "genericDeleteConfirmationMessage": "Wollen Sie diese Zahlungsquelle wirklich löschen?",
	  "deleteCancelButton": "Abbrechen",
	  "deleteConfirmationButton": "Löschen",
	  "fieldEmptyForCvv": "Geben Sie die Kartenprüfnummer ein.",
	  "fieldEmptyForExpirationDate": "Geben Sie das Ablaufdatum ein.",
	  "fieldEmptyForCardholderName": "Geben Sie den Namen des Karteninhabers ein.",
	  "fieldTooLongForCardholderName": "Der Name des Karteninhabers darf 255 Zeichen nicht übersteigen.",
	  "fieldEmptyForNumber": "Geben Sie die Nummer ein.",
	  "fieldEmptyForPostalCode": "Geben Sie die PLZ ein.",
	  "fieldInvalidForCvv": "Die Kartenprüfnummer ist ungültig.",
	  "fieldInvalidForExpirationDate": "Das Ablaufdatum ist ungültig.",
	  "fieldInvalidForNumber": "Die Kreditkartennummer ist ungültig.",
	  "fieldInvalidForPostalCode": "Die PLZ ist ungültig.",
	  "genericError": "Bei uns ist ein Problem aufgetreten.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Diese Kreditkarte ist bereits als gespeicherte Zahlungsmethode vorhanden.",
	  "hostedFieldsFailedTokenizationError": "Überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
	  "hostedFieldsFieldsInvalidError": "Überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
	  "hostedFieldsTokenizationNetworkErrorError": "Netzwerkfehler. Versuchen Sie es erneut.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Überprüfung der Karte fehlgeschlagen. Überprüfen Sie Ihre Eingabe und versuchen Sie es erneut.",
	  "paypalButtonMustBeUsed": "Verwenden Sie den PayPal-Button, um mit der Zahlung fortfahren.",
	  "paypalAccountTokenizationFailedError": "Beim Hinzufügen des PayPal-Kontos ist ein Problem aufgetreten. Versuchen Sie es erneut.",
	  "paypalFlowFailedError": "Beim Verbinden mit PayPal ist ein Problem aufgetreten. Versuchen Sie es erneut.",
	  "paypalTokenizationRequestActiveError": "Die PayPal-Zahlung wird bereits autorisiert.",
	  "venmoCanceledError": "Etwas ist schief gelaufen. Vergewissern Sie sich, dass Sie die neueste Version der Venmo-App auf Ihrem Gerät installiert haben und Ihr Browser den Wechsel zu Venmo unterstützt.",
	  "vaultManagerPaymentMethodDeletionError": "Die Zahlungsquelle konnte nicht gelöscht werden. Versuchen Sie es erneut.",
	  "venmoAppFailedError": "Die Venmo-App wurde auf Ihrem Gerät nicht gefunden.",
	  "unsupportedCardTypeError": "Dieser Kreditkartentyp wird nicht unterstützt. Versuchen Sie es mit einer anderen Karte.",
	  "applePayTokenizationError": "Netzwerkfehler bei der Zahlungsabwicklung mit Apple Pay. Versuchen Sie es erneut.",
	  "applePayActiveCardError": "Fügen Sie der Apple-Pay-Börse eine unterstützte Kreditkarte hinzu.",
	  "cardholderNameLabel": "Name des Karteninhabers",
	  "cardNumberLabel": "Kartennummer",
	  "cvvLabel": "Prüfnr.",
	  "cvvThreeDigitLabelSubheading": "(3-stellig)",
	  "cvvFourDigitLabelSubheading": "(4-stellig)",
	  "cardholderNamePlaceholder": "Name des Karteninhabers",
	  "expirationDateLabel": "Gültig bis",
	  "expirationDateLabelSubheading": "(MM/JJ)",
	  "expirationDatePlaceholder": "MM/JJ",
	  "postalCodeLabel": "PLZ",
	  "saveCardLabel": "Karte speichern",
	  "payWithCard": "Mit Kreditkarte zahlen",
	  "endingIn": "Mit den Endziffern {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Kreditkarte",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],156:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Paying with {{paymentSource}}",
	  "chooseAnotherWayToPay": "Choose another way to pay",
	  "chooseAWayToPay": "Choose a way to pay",
	  "otherWaysToPay": "Other ways to pay",
	  "edit": "Edit",
	  "doneEditing": "Done",
	  "editPaymentMethods": "Edit payment methods",
	  "CreditCardDeleteConfirmationMessage": "Delete {{secondaryIdentifier}} card ending in {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Delete PayPal account {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Are you sure you want to delete the Venmo account with username {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Are you sure you want to delete this payment method?",
	  "deleteCancelButton": "Cancel",
	  "deleteConfirmationButton": "Delete",
	  "fieldEmptyForCvv": "Please fill out a CVV.",
	  "fieldEmptyForExpirationDate": "Please fill out an expiry date.",
	  "fieldEmptyForCardholderName": "Please fill out a cardholder name.",
	  "fieldTooLongForCardholderName": "Cardholder name must be less than 256 characters.",
	  "fieldEmptyForNumber": "Please fill out a number.",
	  "fieldEmptyForPostalCode": "Please fill out a postcode.",
	  "fieldInvalidForCvv": "This security code is not valid.",
	  "fieldInvalidForExpirationDate": "This expiry date is not valid.",
	  "fieldInvalidForNumber": "This card number is not valid.",
	  "fieldInvalidForPostalCode": "This postcode is not valid.",
	  "genericError": "Something went wrong on our end.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "This credit card already exists as a saved payment method.",
	  "hostedFieldsFailedTokenizationError": "Check your entries and try again.",
	  "hostedFieldsFieldsInvalidError": "Check your entries and try again.",
	  "hostedFieldsTokenizationNetworkErrorError": "Network error. Please try again.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Credit card verification failed. Check your entries and try again.",
	  "paypalButtonMustBeUsed": "Use the PayPal button to continue with your payment.",
	  "paypalAccountTokenizationFailedError": "Something went wrong while adding the PayPal account. Please try again.",
	  "paypalFlowFailedError": "Something went wrong while connecting to PayPal. Please try again.",
	  "paypalTokenizationRequestActiveError": "PayPal payment authorisation is already in progress.",
	  "venmoCanceledError": "We're sorry, something seems to have gone wrong. Please ensure you have the most recent version of the Venmo app installed on your device and your browser supports switching to Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "We're sorry. We couldn't delete that payment method. Please try again.",
	  "venmoAppFailedError": "The Venmo app wasn't found on your device.",
	  "unsupportedCardTypeError": "This card type is not supported. Please try another card.",
	  "applePayTokenizationError": "A network error occurred while processing the Apple Pay payment. Please try again.",
	  "applePayActiveCardError": "Link a supported card to your Apple Pay Wallet.",
	  "cardholderNameLabel": "Cardholder Name",
	  "cardNumberLabel": "Card Number",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 digits)",
	  "cvvFourDigitLabelSubheading": "(4 digits)",
	  "cardholderNamePlaceholder": "Cardholder Name",
	  "expirationDateLabel": "Expiry date",
	  "expirationDateLabelSubheading": "(MM/YY)",
	  "expirationDatePlaceholder": "MM/YY",
	  "postalCodeLabel": "Postcode",
	  "saveCardLabel": "Save card",
	  "payWithCard": "Pay with credit or debit card",
	  "endingIn": "Ending in {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Card",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],157:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Paying with {{paymentSource}}",
	  "chooseAnotherWayToPay": "Choose another way to pay",
	  "chooseAWayToPay": "Choose a way to pay",
	  "otherWaysToPay": "Other ways to pay",
	  "edit": "Edit",
	  "doneEditing": "Done",
	  "editPaymentMethods": "Edit funding sources",
	  "CreditCardDeleteConfirmationMessage": "Delete {{secondaryIdentifier}} card ending in {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Delete PayPal account {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Are you sure you want to delete the Venmo account with username {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Are you sure you want to delete this funding source?",
	  "deleteCancelButton": "Cancel",
	  "deleteConfirmationButton": "Delete",
	  "fieldEmptyForCvv": "Please fill in a CSC.",
	  "fieldEmptyForExpirationDate": "Please fill in an expiry date.",
	  "fieldEmptyForCardholderName": "Please fill in a cardholder name.",
	  "fieldTooLongForCardholderName": "Cardholder name must be less than 256 characters.",
	  "fieldEmptyForNumber": "Please fill in a number.",
	  "fieldEmptyForPostalCode": "Please fill in a postcode.",
	  "fieldInvalidForCvv": "This security code is not valid.",
	  "fieldInvalidForExpirationDate": "This expiry date is not valid.",
	  "fieldInvalidForNumber": "This card number is not valid.",
	  "fieldInvalidForPostalCode": "This postcode is not valid.",
	  "genericError": "Something went wrong on our end.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "This credit card has already been added to your account as a funding source.",
	  "hostedFieldsFailedTokenizationError": "Please check your information and try again.",
	  "hostedFieldsFieldsInvalidError": "Please check your information and try again.",
	  "hostedFieldsTokenizationNetworkErrorError": "Network error. Please try again.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Credit card verification failed. Please check your information and try again.",
	  "paypalButtonMustBeUsed": "Use the PayPal button to continue with your payment.",
	  "paypalAccountTokenizationFailedError": "Something went wrong while adding the PayPal account. Please try again.",
	  "paypalFlowFailedError": "Something went wrong while connecting to PayPal. Please try again.",
	  "paypalTokenizationRequestActiveError": "PayPal payment authorisation is already in progress.",
	  "venmoCanceledError": "We're sorry, something seems to have gone wrong. Make sure you have the most recent version of the Venmo app installed on your device and your browser supports the switch to Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Unable to delete funding source, try again.",
	  "venmoAppFailedError": "The Venmo app isn't on your device.",
	  "unsupportedCardTypeError": "This card type is not supported. Please try another card.",
	  "applePayTokenizationError": "A network error occurred while processing the Apple Pay payment. Please try again.",
	  "applePayActiveCardError": "Add a supported card to your Apple Pay wallet.",
	  "cardholderNameLabel": "Cardholder name",
	  "cardNumberLabel": "Card number",
	  "cvvLabel": "CSC",
	  "cvvThreeDigitLabelSubheading": "(3 digits)",
	  "cvvFourDigitLabelSubheading": "(4 digits)",
	  "cardholderNamePlaceholder": "Cardholder name",
	  "expirationDateLabel": "Expiry date",
	  "expirationDateLabelSubheading": "(MM/YY)",
	  "expirationDatePlaceholder": "MM/YY",
	  "postalCodeLabel": "Postcode",
	  "saveCardLabel": "Save card",
	  "payWithCard": "Pay with card",
	  "endingIn": "Ending in {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Card",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],158:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  payingWith: 'Paying with {{paymentSource}}',
	  chooseAnotherWayToPay: 'Choose another way to pay',
	  chooseAWayToPay: 'Choose a way to pay',
	  otherWaysToPay: 'Other ways to pay',
	  edit: 'Edit',
	  doneEditing: 'Done',
	  editPaymentMethods: 'Edit payment methods',
	  CreditCardDeleteConfirmationMessage: 'Delete {{secondaryIdentifier}} card ending in {{identifier}}?',
	  PayPalAccountDeleteConfirmationMessage: 'Delete PayPal account {{identifier}}?',
	  VenmoAccountDeleteConfirmationMessage: 'Are you sure you want to delete Venmo account with username {{identifier}}?',
	  genericDeleteConfirmationMessage: 'Are you sure you want to delete this payment method?',
	  deleteCancelButton: 'Cancel',
	  deleteConfirmationButton: 'Delete',
	  // Errors
	  fieldEmptyForCvv: 'Please fill out a CVV.',
	  fieldEmptyForExpirationDate: 'Please fill out an expiration date.',
	  fieldEmptyForCardholderName: 'Please fill out a cardholder name.',
	  fieldEmptyForNumber: 'Please fill out a card number.',
	  fieldEmptyForPostalCode: 'Please fill out a postal code.',
	  fieldInvalidForCvv: 'This security code is not valid.',
	  fieldInvalidForExpirationDate: 'This expiration date is not valid.',
	  fieldInvalidForNumber: 'This card number is not valid.',
	  fieldInvalidForPostalCode: 'This postal code is not valid.',
	  fieldTooLongForCardholderName: 'Cardholder name must be less than 256 characters.',
	  genericError: 'Something went wrong on our end.',
	  hostedFieldsTokenizationFailOnDuplicateError: 'This credit card already exists as a saved payment method.',
	  hostedFieldsFailedTokenizationError: 'Please check your information and try again.',
	  hostedFieldsTokenizationCvvVerificationFailedError: 'Credit card verification failed. Please check your information and try again.',
	  hostedFieldsTokenizationNetworkErrorError: 'Network error. Please try again.',
	  hostedFieldsFieldsInvalidError: 'Please check your information and try again.',
	  paypalButtonMustBeUsed: 'Use the PayPal button to continue with your payment.',
	  paypalAccountTokenizationFailedError: 'Something went wrong adding the PayPal account. Please try again.',
	  paypalFlowFailedError: 'Something went wrong connecting to PayPal. Please try again.',
	  paypalTokenizationRequestActiveError: 'PayPal payment authorization is already in progress.',
	  applePayTokenizationError: 'A network error occurred while processing the Apple Pay payment. Please try again.',
	  applePayActiveCardError: 'Add a supported card to your Apple Pay wallet.',
	  vaultManagerPaymentMethodDeletionError: 'Unable to delete payment method, try again.',
	  venmoCanceledError: 'Something went wrong. Ensure you have the most recent version of the Venmo app installed on your device and your browser supports switching to Venmo.',
	  venmoAppFailedError: 'The Venmo app could not be found on your device.',
	  unsupportedCardTypeError: 'This card type is not supported. Please try another card.',
	  // Card form
	  cardholderNameLabel: 'Cardholder Name',
	  cardNumberLabel: 'Card Number',
	  cvvLabel: 'CVV',
	  cvvThreeDigitLabelSubheading: '(3 digits)',
	  cvvFourDigitLabelSubheading: '(4 digits)',
	  expirationDateLabel: 'Expiration Date',
	  expirationDateLabelSubheading: '(MM/YY)',
	  cardholderNamePlaceholder: 'Cardholder Name',
	  expirationDatePlaceholder: 'MM/YY',
	  postalCodeLabel: 'Postal Code',
	  saveCardLabel: 'Save card',
	  payWithCard: 'Pay with card',
	  // Payment Method descriptions
	  endingIn: 'Ending in {{lastFourCardDigits}}',
	  Card: 'Card',
	  PayPal: 'PayPal',
	  'PayPal Credit': 'PayPal Credit',
	  'Apple Pay': 'Apple Pay',
	  'Google Pay': 'Google Pay',
	  'Venmo': 'Venmo',
	  'American Express': 'American Express',
	  Discover: 'Discover',
	  'Diners Club': 'Diners Club',
	  MasterCard: 'Mastercard',
	  Visa: 'Visa',
	  JCB: 'JCB',
	  Maestro: 'Maestro',
	  UnionPay: 'UnionPay'
	};
	
	},{}],159:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Pago con {{paymentSource}}",
	  "chooseAnotherWayToPay": "Selecciona otra forma de pago.",
	  "chooseAWayToPay": "Selecciona una forma de pago.",
	  "otherWaysToPay": "Otras formas de pago",
	  "edit": "Modificar",
	  "doneEditing": "Hecho",
	  "editPaymentMethods": "Editar formas de pago",
	  "CreditCardDeleteConfirmationMessage": "¿Quieres eliminar la tarjeta {{secondaryIdentifier}} que termina en {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "¿Quieres eliminar la cuenta PayPal {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "¿Seguro de que deseas eliminar la cuenta de Venmo con nombre de usuario {{identifier}}?",
	  "genericDeleteConfirmationMessage": "¿Seguro que deseas eliminar esta forma de pago?",
	  "deleteCancelButton": "Cancelar",
	  "deleteConfirmationButton": "Eliminar",
	  "fieldEmptyForCvv": "Escribe el código CVV.",
	  "fieldEmptyForExpirationDate": "Escribe la fecha de vencimiento.",
	  "fieldEmptyForCardholderName": "Escribe el nombre de un titular de la tarjeta.",
	  "fieldTooLongForCardholderName": "El nombre del titular de la tarjeta debe tener menos de 256 caracteres.",
	  "fieldEmptyForNumber": "Escribe un número.",
	  "fieldEmptyForPostalCode": "Escribe el código postal.",
	  "fieldInvalidForCvv": "Este código de seguridad no es válido.",
	  "fieldInvalidForExpirationDate": "Esta fecha de vencimiento no es válida.",
	  "fieldInvalidForNumber": "Este número de tarjeta no es válido.",
	  "fieldInvalidForPostalCode": "Este código postal no es válido.",
	  "genericError": "Hemos tenido algún problema.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Esta tarjeta de crédito ya existe como forma de pago guardada.",
	  "hostedFieldsFailedTokenizationError": "Comprueba la información e inténtalo de nuevo.",
	  "hostedFieldsFieldsInvalidError": "Comprueba la información e inténtalo de nuevo.",
	  "hostedFieldsTokenizationNetworkErrorError": "Error de red. Inténtalo de nuevo.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Error de verificación de la tarjeta de crédito. Comprueba la información e inténtalo de nuevo.",
	  "paypalButtonMustBeUsed": "Utiliza el botón de PayPal para continuar con el pago.",
	  "paypalAccountTokenizationFailedError": "Se ha producido un error al vincular la cuenta PayPal. Inténtalo de nuevo.",
	  "paypalFlowFailedError": "Se ha producido un error al conectarse a PayPal. Inténtalo de nuevo.",
	  "paypalTokenizationRequestActiveError": "Ya hay una autorización de pago de PayPal en curso.",
	  "venmoCanceledError": "Ha habido un problema. Asegúrate de que tienes la versión más reciente de la aplicación de Venmo instalada en tu dispositivo y de que tu navegador es compatible con cambiar a Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "No se ha podido eliminar la forma de pago. Inténtalo de nuevo.",
	  "venmoAppFailedError": "No se ha encontrado la aplicación de Venmo en tu dispositivo.",
	  "unsupportedCardTypeError": "No se admite este tipo de tarjeta. Prueba con otra tarjeta.",
	  "applePayTokenizationError": "Se ha producido un error de red al procesar el pago con Apple Pay. Inténtalo de nuevo.",
	  "applePayActiveCardError": "Añade una tarjeta admitida a tu Wallet de Apple Pay.",
	  "cardholderNameLabel": "Nombre del titular de la tarjeta",
	  "cardNumberLabel": "Número de tarjeta",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 dígitos)",
	  "cvvFourDigitLabelSubheading": "(4 dígitos)",
	  "cardholderNamePlaceholder": "Nombre del titular de la tarjeta",
	  "expirationDateLabel": "Fecha de vencimiento",
	  "expirationDateLabelSubheading": "(MM/AA)",
	  "expirationDatePlaceholder": "MM/AA",
	  "postalCodeLabel": "Código postal",
	  "saveCardLabel": "Guardar tarjeta",
	  "payWithCard": "Pagar con tarjeta",
	  "endingIn": "Terminada en {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Tarjeta",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],160:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Payer avec {{paymentSource}}",
	  "chooseAnotherWayToPay": "Choisir un autre mode de paiement",
	  "chooseAWayToPay": "Choisir le mode de paiement",
	  "otherWaysToPay": "Autres modes de paiement",
	  "edit": "Modifier",
	  "doneEditing": "Terminé",
	  "editPaymentMethods": "Modifier les modes de paiement",
	  "CreditCardDeleteConfirmationMessage": "Supprimer la carte {{secondaryIdentifier}} se terminant par {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Supprimer le compte PayPal {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Souhaitez-vous vraiment supprimer le compte Venmo avec le nom d’utilisateur {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Voulez-vous vraiment supprimer ce mode de paiement?",
	  "deleteCancelButton": "Annuler",
	  "deleteConfirmationButton": "Supprimer",
	  "fieldEmptyForCvv": "Veuillez saisir un cryptogramme visuel.",
	  "fieldEmptyForExpirationDate": "Veuillez saisir une date d'expiration.",
	  "fieldEmptyForCardholderName": "Veuillez saisir un nom de titulaire de la carte.",
	  "fieldTooLongForCardholderName": "Le nom du titulaire de la carte doit contenir moins de 256 caractères.",
	  "fieldEmptyForNumber": "Veuillez saisir un numéro.",
	  "fieldEmptyForPostalCode": "Veuillez saisir un code postal.",
	  "fieldInvalidForCvv": "Ce cryptogramme visuel n'est pas valide.",
	  "fieldInvalidForExpirationDate": "Cette date d'expiration n'est pas valide.",
	  "fieldInvalidForNumber": "Ce numéro de carte n'est pas valide.",
	  "fieldInvalidForPostalCode": "Ce code postal n'est pas valide.",
	  "genericError": "Une erreur s'est produite de notre côté.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Cette carte de crédit existe déjà comme mode de paiement enregistré.",
	  "hostedFieldsFailedTokenizationError": "Vérifiez vos informations, puis réessayez.",
	  "hostedFieldsFieldsInvalidError": "Vérifiez vos informations, puis réessayez.",
	  "hostedFieldsTokenizationNetworkErrorError": "Erreur réseau. Veuillez réessayer.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "La vérification de la carte de crédit a échoué. Vérifiez vos informations, puis réessayez.",
	  "paypalButtonMustBeUsed": "Utilisez le bouton PayPal pour poursuivre votre paiement.",
	  "paypalAccountTokenizationFailedError": "Une erreur s'est produite lors de l'enregistrement du compte PayPal. Veuillez réessayer.",
	  "paypalFlowFailedError": "Une erreur s'est produite au cours de la connexion à PayPal. Veuillez réessayer.",
	  "paypalTokenizationRequestActiveError": "L'autorisation de paiement PayPal est déjà en cours.",
	  "venmoCanceledError": "Une erreur s'est produite. Assurez-vous que la version la plus récente de l'application Venmo est installée sur votre appareil et que votre navigateur prend Venmo en charge.",
	  "vaultManagerPaymentMethodDeletionError": "Impossible de supprimer le mode de paiement, essayez de nouveau.",
	  "venmoAppFailedError": "L'application Venmo est introuvable sur votre appareil.",
	  "unsupportedCardTypeError": "Ce type de carte n'est pas pris en charge. Veuillez essayer une autre carte.",
	  "applePayTokenizationError": "Une erreur de réseau s'est produite lors du traitement du paiement avec Apple Pay. Veuillez réessayer.",
	  "applePayActiveCardError": "Ajoutez une carte prise en charge à Apple Pay.",
	  "cardholderNameLabel": "Nom du titulaire de la carte",
	  "cardNumberLabel": "Numéro de carte",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 chiffres)",
	  "cvvFourDigitLabelSubheading": "(4 chiffres)",
	  "cardholderNamePlaceholder": "Nom du titulaire de la carte",
	  "expirationDateLabel": "Date d'expiration",
	  "expirationDateLabelSubheading": "(MM/AA)",
	  "expirationDatePlaceholder": "MM/AA",
	  "postalCodeLabel": "Code postal",
	  "saveCardLabel": "Enregistrer la carte",
	  "payWithCard": "Payer par carte",
	  "endingIn": "Se terminant par {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Carte",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],161:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Payer avec {{paymentSource}}",
	  "chooseAnotherWayToPay": "Choisissez une autre façon de payer.",
	  "chooseAWayToPay": "Choisissez comment payer.",
	  "otherWaysToPay": "Autres façons de payer",
	  "edit": "Modifier",
	  "doneEditing": "Terminé",
	  "editPaymentMethods": "Modifier les sources d'approvisionnement",
	  "CreditCardDeleteConfirmationMessage": "Supprimer la carte {{secondaryIdentifier}} se terminant par {{identifier}} ?",
	  "PayPalAccountDeleteConfirmationMessage": "Supprimer le compte PayPal {{identifier}} ?",
	  "VenmoAccountDeleteConfirmationMessage": "Êtes-vous sûr de vouloir supprimer le compte Venmo avec le nom d'utilisateur {{identifier}} ?",
	  "genericDeleteConfirmationMessage": "Êtes-vous sûr de vouloir supprimer cette source d'approvisionnement ?",
	  "deleteCancelButton": "Annuler",
	  "deleteConfirmationButton": "Supprimer",
	  "fieldEmptyForCvv": "Entrez un cryptogramme visuel.",
	  "fieldEmptyForExpirationDate": "Entrez une date d'expiration.",
	  "fieldEmptyForCardholderName": "Entrez un nom du titulaire de la carte.",
	  "fieldTooLongForCardholderName": "Le nom du titulaire de la carte doit contenir moins de 256 caractères.",
	  "fieldEmptyForNumber": "Entrez un numéro.",
	  "fieldEmptyForPostalCode": "Entrez un code postal.",
	  "fieldInvalidForCvv": "Ce cryptogramme visuel n'est pas valide.",
	  "fieldInvalidForExpirationDate": "Cette date d'expiration n'est pas valide.",
	  "fieldInvalidForNumber": "Ce numéro de carte n'est pas valide.",
	  "fieldInvalidForPostalCode": "Ce code postal n'est pas valide.",
	  "genericError": "Une erreur est survenue.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Cette carte bancaire existe déjà comme mode de paiement enregistré.",
	  "hostedFieldsFailedTokenizationError": "Vérifiez vos informations et réessayez.",
	  "hostedFieldsFieldsInvalidError": "Vérifiez vos informations et réessayez.",
	  "hostedFieldsTokenizationNetworkErrorError": "Erreur réseau. Réessayez.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Échec de vérification de la carte bancaire. Vérifiez vos informations et réessayez.",
	  "paypalButtonMustBeUsed": "Utilisez le bouton PayPal pour poursuivre votre paiement.",
	  "paypalAccountTokenizationFailedError": "Une erreur est survenue lors de l'ajout du compte PayPal. Réessayez.",
	  "paypalFlowFailedError": "Une erreur est survenue lors de la connexion à PayPal. Réessayez.",
	  "paypalTokenizationRequestActiveError": "L'autorisation de paiement PayPal est déjà en cours.",
	  "venmoCanceledError": "Une erreur est survenue. Vérifiez que vous disposez de la dernière version de l'application Venmo sur votre appareil et que votre navigateur prend en charge la redirection vers Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Impossible de supprimer la source d'approvisionnement. Réessayez.",
	  "venmoAppFailedError": "L'application Venmo est introuvable sur votre appareil.",
	  "unsupportedCardTypeError": "Ce type de carte n'est pas pris en charge. Essayez une autre carte.",
	  "applePayTokenizationError": "Une erreur réseau s'est produite lors du traitement du paiement Apple Pay. Réessayez.",
	  "applePayActiveCardError": "Enregistrez une carte prise en charge sur Apple Pay.",
	  "cardholderNameLabel": "Nom du titulaire de la carte",
	  "cardNumberLabel": "Nº de carte",
	  "cvvLabel": "Cryptogramme visuel",
	  "cvvThreeDigitLabelSubheading": "(3 chiffres)",
	  "cvvFourDigitLabelSubheading": "(4 chiffres)",
	  "cardholderNamePlaceholder": "Nom du titulaire de la carte",
	  "expirationDateLabel": "Date d'expiration",
	  "expirationDateLabelSubheading": "(MM/AA)",
	  "expirationDatePlaceholder": "MM/AA",
	  "postalCodeLabel": "Code postal",
	  "saveCardLabel": "Enregistrer une carte",
	  "payWithCard": "Payer par carte",
	  "endingIn": "Se terminant par {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Carte",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],162:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Membayar dengan {{paymentSource}}",
	  "chooseAnotherWayToPay": "Pilih metode pembayaran lain",
	  "chooseAWayToPay": "Pilih metode pembayaran",
	  "otherWaysToPay": "Metode pembayaran lain",
	  "edit": "Edit",
	  "doneEditing": "Selesai",
	  "editPaymentMethods": "Edit metode pembayaran",
	  "CreditCardDeleteConfirmationMessage": "Hapus kartu {{secondaryIdentifier}} yang berakhiran {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Hapus {{identifier}} rekening PayPal?",
	  "VenmoAccountDeleteConfirmationMessage": "Yakin akan menghapus rekening Venmo dengan nama pengguna {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Yakin akan menghapus metode pembayaran ini?",
	  "deleteCancelButton": "Batalkan",
	  "deleteConfirmationButton": "Hapus",
	  "fieldEmptyForCvv": "Masukkan CVV.",
	  "fieldEmptyForExpirationDate": "Masukkan tanggal akhir berlaku.",
	  "fieldEmptyForCardholderName": "Masukkan nama pemegang kartu.",
	  "fieldTooLongForCardholderName": "Nama pemegang kartu harus kurang dari 256 karakter.",
	  "fieldEmptyForNumber": "Masukkan nomor.",
	  "fieldEmptyForPostalCode": "Masukkan kode pos.",
	  "fieldInvalidForCvv": "Kode keamanan ini tidak valid.",
	  "fieldInvalidForExpirationDate": "Tanggal akhir berlaku ini tidak valid.",
	  "fieldInvalidForNumber": "Nomor kartu ini tidak valid.",
	  "fieldInvalidForPostalCode": "Kode pos ini tidak valid.",
	  "genericError": "Ada yang salah pada sistem kami.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Kartu kredit ini sudah dimasukkan sebagai metode pembayaran tersimpan.",
	  "hostedFieldsFailedTokenizationError": "Periksa informasi Anda dan coba lagi.",
	  "hostedFieldsFieldsInvalidError": "Periksa informasi Anda dan coba lagi.",
	  "hostedFieldsTokenizationNetworkErrorError": "Masalah jaringan. Coba lagi.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Verifikasi kartu kredit gagal. Periksa informasi Anda dan coba lagi.",
	  "paypalButtonMustBeUsed": "Gunakan tombol PayPal untuk melanjutkan pembayaran Anda.",
	  "paypalAccountTokenizationFailedError": "Terjadi kesalahan saat menambahkan rekening PayPal. Coba lagi.",
	  "paypalFlowFailedError": "Terjadi kesalahan saat menyambung ke PayPal. Coba lagi.",
	  "paypalTokenizationRequestActiveError": "Otorisasi pembayaran PayPal sedang diproses.",
	  "venmoCanceledError": "Terdapat kesalahan. Pastikan Anda telah menginstal aplikasi Venmo versi terbaru pada perangkat dan peramban Anda mendukung untuk beralih ke Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Tidak dapat menghapus metode pembayaran, coba lagi.",
	  "venmoAppFailedError": "Aplikasi Venmo tidak dapat ditemukan pada perangkat Anda.",
	  "unsupportedCardTypeError": "Jenis kartu ini tidak didukung. Coba kartu lainnya.",
	  "applePayTokenizationError": "Terjadi kesalahan jaringan sewaktu memproses pembayaran melalui Apple Pay. Coba lagi.",
	  "applePayActiveCardError": "Tambahkan kartu yang didukung ke wallet Apple Pay.",
	  "cardholderNameLabel": "Nama Pemegang Kartu",
	  "cardNumberLabel": "Nomor Kartu",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 angka)",
	  "cvvFourDigitLabelSubheading": "(4 angka)",
	  "cardholderNamePlaceholder": "Nama Pemegang Kartu",
	  "expirationDateLabel": "Tanggal Kedaluwarsa",
	  "expirationDateLabelSubheading": "(BB/TT)",
	  "expirationDatePlaceholder": "BB/TT",
	  "postalCodeLabel": "Kode Pos",
	  "saveCardLabel": "Simpan kartu",
	  "payWithCard": "Bayar dengan kartu",
	  "endingIn": "Berakhiran {{lastTwoCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Kartu",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],163:[function(require,module,exports){
	/* eslint-disable camelcase */
	'use strict';
	
	var assign = require('../lib/assign').assign;
	
	var fiveCharacterLocales = {
	  da_DK: require('./da_DK'),
	  de_DE: require('./de_DE'),
	  en_US: require('./en_US'),
	  en_AU: require('./en_AU'),
	  en_GB: require('./en_GB'),
	  es_ES: require('./es_ES'),
	  fr_CA: require('./fr_CA'),
	  fr_FR: require('./fr_FR'),
	  id_ID: require('./id_ID'),
	  it_IT: require('./it_IT'),
	  ja_JP: require('./ja_JP'),
	  ko_KR: require('./ko_KR'),
	  nl_NL: require('./nl_NL'),
	  no_NO: require('./no_NO'),
	  pl_PL: require('./pl_PL'),
	  pt_BR: require('./pt_BR'),
	  pt_PT: require('./pt_PT'),
	  ru_RU: require('./ru_RU'),
	  sv_SE: require('./sv_SE'),
	  th_TH: require('./th_TH'),
	  zh_CN: require('./zh_CN'),
	  zh_HK: require('./zh_HK'),
	  zh_TW: require('./zh_TW')
	};
	
	var twoCharacterLocaleAliases = {
	  da: fiveCharacterLocales.da_DK,
	  de: fiveCharacterLocales.de_DE,
	  en: fiveCharacterLocales.en_US,
	  es: fiveCharacterLocales.es_ES,
	  fr: fiveCharacterLocales.fr_FR,
	  id: fiveCharacterLocales.id_ID,
	  it: fiveCharacterLocales.it_IT,
	  ja: fiveCharacterLocales.ja_JP,
	  ko: fiveCharacterLocales.ko_KR,
	  nl: fiveCharacterLocales.nl_NL,
	  no: fiveCharacterLocales.no_NO,
	  pl: fiveCharacterLocales.pl_PL,
	  pt: fiveCharacterLocales.pt_PT,
	  ru: fiveCharacterLocales.ru_RU,
	  sv: fiveCharacterLocales.sv_SE,
	  th: fiveCharacterLocales.th_TH,
	  zh: fiveCharacterLocales.zh_CN
	};
	
	module.exports = {
	  twoCharacterLocaleAliases: twoCharacterLocaleAliases,
	  fiveCharacterLocales: fiveCharacterLocales,
	  translations: assign({}, twoCharacterLocaleAliases, fiveCharacterLocales)
	};
	/* eslint-enable camelcase */
	
	},{"../lib/assign":137,"./da_DK":154,"./de_DE":155,"./en_AU":156,"./en_GB":157,"./en_US":158,"./es_ES":159,"./fr_CA":160,"./fr_FR":161,"./id_ID":162,"./it_IT":164,"./ja_JP":165,"./ko_KR":166,"./nl_NL":167,"./no_NO":168,"./pl_PL":169,"./pt_BR":170,"./pt_PT":171,"./ru_RU":172,"./sv_SE":173,"./th_TH":174,"./zh_CN":175,"./zh_HK":176,"./zh_TW":177}],164:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Pagamento con {{paymentSource}}",
	  "chooseAnotherWayToPay": "Scegli di pagare in un altro modo",
	  "chooseAWayToPay": "Scegli come pagare",
	  "otherWaysToPay": "Altri modi di pagare",
	  "edit": "Modifica",
	  "doneEditing": "Fine",
	  "editPaymentMethods": "Modifica i metodi di pagamento",
	  "CreditCardDeleteConfirmationMessage": "Eliminare la carta {{secondaryIdentifier}} le cui ultime cifre sono {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Eliminare il conto PayPal {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Vuoi eliminare il conto Venmo con nome utente {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Vuoi eliminare questo metodo di pagamento?",
	  "deleteCancelButton": "Annulla",
	  "deleteConfirmationButton": "Rimuovi",
	  "fieldEmptyForCvv": "Immetti il codice di sicurezza (CVV).",
	  "fieldEmptyForExpirationDate": "Immetti la data di scadenza.",
	  "fieldEmptyForCardholderName": "Immetti il nome del titolare della carta.",
	  "fieldTooLongForCardholderName": "Il nome del titolare della carta deve avere meno di 256 caratteri.",
	  "fieldEmptyForNumber": "Immetti il numero di carta.",
	  "fieldEmptyForPostalCode": "Immetti il CAP.",
	  "fieldInvalidForCvv": "Il codice di sicurezza non è valido.",
	  "fieldInvalidForExpirationDate": "La data di scadenza non è valida.",
	  "fieldInvalidForNumber": "Il numero di carta non è valido.",
	  "fieldInvalidForPostalCode": "Il CAP non è valido.",
	  "genericError": "Si è verificato un errore nei nostri sistemi.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Questa carta di credito è già registrata come metodo di pagamento salvato.",
	  "hostedFieldsFailedTokenizationError": "Controlla e riprova.",
	  "hostedFieldsFieldsInvalidError": "Controlla e riprova.",
	  "hostedFieldsTokenizationNetworkErrorError": "Errore di rete. Riprova.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "La verifica della carta di credito non è andata a buon fine. Controlla i dati e riprova.",
	  "paypalButtonMustBeUsed": "Usa il pulsante PayPal per procedere al pagamento.",
	  "paypalAccountTokenizationFailedError": "Si è verificato un errore nel collegamento del conto PayPal. Riprova.",
	  "paypalFlowFailedError": "Si è verificato un errore di connessione a PayPal. Riprova.",
	  "paypalTokenizationRequestActiveError": "L'autorizzazione di pagamento PayPal è già in corso.",
	  "venmoCanceledError": "Si è verificato un errore. Assicurati di avere la versione più recente dell'app Venmo installata sul tuo dispositivo e che il browser supporti l'uso di Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Impossibile eliminare il metodo di pagamento; riprova.",
	  "venmoAppFailedError": "Impossibile trovare l'app Venmo sul dispositivo in uso.",
	  "unsupportedCardTypeError": "Questo tipo di carta non è supportato. Prova con un'altra carta.",
	  "applePayTokenizationError": "Si è verificato un errore di rete durante l'elaborazione del pagamento con Apple Pay. Riprova.",
	  "applePayActiveCardError": "Collega una carta supportata al tuo Apple Pay Wallet.",
	  "cardholderNameLabel": "Titolare della carta",
	  "cardNumberLabel": "Numero di carta",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 cifre)",
	  "cvvFourDigitLabelSubheading": "(4 cifre)",
	  "cardholderNamePlaceholder": "Titolare della carta",
	  "expirationDateLabel": "Data di scadenza",
	  "expirationDateLabelSubheading": "(MM/AA)",
	  "expirationDatePlaceholder": "MM/AA",
	  "postalCodeLabel": "CAP",
	  "saveCardLabel": "Salva carta",
	  "payWithCard": "Paga con una carta",
	  "endingIn": "Le cui ultime cifre sono {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Carta",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],165:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "{{paymentSource}}で支払う",
	  "chooseAnotherWayToPay": "別の支払方法を選択する",
	  "chooseAWayToPay": "支払方法を選択する",
	  "otherWaysToPay": "その他の支払方法",
	  "edit": "編集",
	  "doneEditing": "完了",
	  "editPaymentMethods": "支払方法の編集",
	  "CreditCardDeleteConfirmationMessage": "末尾が{{identifier}}の{{secondaryIdentifier}}カードを削除しますか?",
	  "PayPalAccountDeleteConfirmationMessage": "PayPalアカウント{{identifier}}を削除しますか?",
	  "VenmoAccountDeleteConfirmationMessage": "ユーザー名{{identifier}}のVenmoアカウントを削除してよろしいですか?",
	  "genericDeleteConfirmationMessage": "この支払い方法を削除してよろしいですか?",
	  "deleteCancelButton": "キャンセル",
	  "deleteConfirmationButton": "削除",
	  "fieldEmptyForCvv": "セキュリティコードを入力してください。",
	  "fieldEmptyForExpirationDate": "有効期限を入力してください。",
	  "fieldEmptyForCardholderName": "カード保有者の名前を入力してください。",
	  "fieldTooLongForCardholderName": "カード保有者の名前は256文字未満にしてください。",
	  "fieldEmptyForNumber": "番号を入力してください。",
	  "fieldEmptyForPostalCode": "郵便番号を入力してください。",
	  "fieldInvalidForCvv": "このセキュリティコードは無効です。",
	  "fieldInvalidForExpirationDate": "この有効期限は無効です。",
	  "fieldInvalidForNumber": "このカード番号は無効です。",
	  "fieldInvalidForPostalCode": "この郵便番号は無効です。",
	  "genericError": "弊社側で問題が発生しました。",
	  "hostedFieldsTokenizationFailOnDuplicateError": "このクレジットカードは、保存済みの支払方法としてすでに登録されています。",
	  "hostedFieldsFailedTokenizationError": "情報を確認してもう一度お試しください。",
	  "hostedFieldsFieldsInvalidError": "情報を確認してもう一度お試しください。",
	  "hostedFieldsTokenizationNetworkErrorError": "ネットワークエラーです。もう一度お試しください。",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "クレジットカードの認証に失敗しました。情報を確認してもう一度お試しください。",
	  "paypalButtonMustBeUsed": "お客さまの支払いを続行するには、PayPalボタンを使用します。",
	  "paypalAccountTokenizationFailedError": "PayPalアカウントの追加で問題が発生しました。もう一度お試しください。",
	  "paypalFlowFailedError": "PayPalへの接続に問題が発生しました。もう一度お試しください。",
	  "paypalTokenizationRequestActiveError": "PayPal支払いの承認はすでに処理中です。",
	  "venmoCanceledError": "問題が発生しました。お客さまの端末にインストールされているVenmoアプリが最新のバージョンであること、お使いのブラウザがVenmoへの切り替えをサポートしていることを確認してください。",
	  "vaultManagerPaymentMethodDeletionError": "支払方法を削除できません。もう一度お試しください。",
	  "venmoAppFailedError": "お客さまの端末でVenmoアプリが見つかりませんでした。",
	  "unsupportedCardTypeError": "このカードタイプはサポートされていません。別のカードをご使用ください。",
	  "applePayTokenizationError": "Apple Payの支払いを処理する際にネットワークエラーが発生しました。もう一度お試しください。",
	  "applePayActiveCardError": "Apple Payウォレットに対応しているカードを追加してください。",
	  "cardholderNameLabel": "カード保有者の名前",
	  "cardNumberLabel": "カード番号",
	  "cvvLabel": "セキュリティコード",
	  "cvvThreeDigitLabelSubheading": "(3桁)",
	  "cvvFourDigitLabelSubheading": "(4桁)",
	  "cardholderNamePlaceholder": "カード保有者の名前",
	  "expirationDateLabel": "有効期限",
	  "expirationDateLabelSubheading": "(MM/YY)",
	  "expirationDatePlaceholder": "MM/YY",
	  "postalCodeLabel": "郵便番号",
	  "saveCardLabel": "カードを保存",
	  "payWithCard": "カードで支払う",
	  "endingIn": "末尾が{{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "カード",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "銀聯(UnionPay)"
	};
	
	},{}],166:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "{{paymentSource}}(으)로 결제",
	  "chooseAnotherWayToPay": "다른 결제수단 선택",
	  "chooseAWayToPay": "결제수단 선택",
	  "otherWaysToPay": "다른 방법으로 결제",
	  "edit": "편집",
	  "doneEditing": "완료",
	  "editPaymentMethods": "결제수단 편집",
	  "CreditCardDeleteConfirmationMessage": "끝번호가 {{identifier}}인 {{secondaryIdentifier}} 카드를 삭제하시겠어요?",
	  "PayPalAccountDeleteConfirmationMessage": "PayPal 계정 {{identifier}}을(를) 삭제하시겠어요?",
	  "VenmoAccountDeleteConfirmationMessage": "사용자 이름이 {{identifier}}인 Venmo 계정을 삭제하시겠어요?",
	  "genericDeleteConfirmationMessage": "이 결제수단을 삭제하시겠어요?",
	  "deleteCancelButton": "취소",
	  "deleteConfirmationButton": "삭제",
	  "fieldEmptyForCvv": "CVV를 입력하세요.",
	  "fieldEmptyForExpirationDate": "만료일을 입력하세요.",
	  "fieldEmptyForCardholderName": "카드 소유자 이름을 입력하세요.",
	  "fieldTooLongForCardholderName": "카드 소유자 이름은 256자 미만이어야 합니다.",
	  "fieldEmptyForNumber": "번호를 입력하세요.",
	  "fieldEmptyForPostalCode": "우편번호를 입력하세요.",
	  "fieldInvalidForCvv": "이 보안 코드가 올바르지 않습니다.",
	  "fieldInvalidForExpirationDate": "이 만료일이 올바르지 않습니다.",
	  "fieldInvalidForNumber": "이 카드 번호가 올바르지 않습니다.",
	  "fieldInvalidForPostalCode": "이 우편번호가 올바르지 않습니다.",
	  "genericError": "저희 쪽에 문제가 발생했습니다.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "저장된 결제수단에 이미 이 신용카드가 존재합니다.",
	  "hostedFieldsFailedTokenizationError": "정보를 확인하고 다시 시도해 주세요.",
	  "hostedFieldsFieldsInvalidError": "정보를 확인하고 다시 시도해 주세요.",
	  "hostedFieldsTokenizationNetworkErrorError": "네트워크 오류가 발생했습니다. 다시 시도해 주세요.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "신용카드 인증에 실패했습니다. 정보를 확인하고 다시 시도해 주세요.",
	  "paypalButtonMustBeUsed": "결제를 계속하려면 PayPal 버튼을 사용하세요.",
	  "paypalAccountTokenizationFailedError": "PayPal 계정을 추가하는 동안 문제가 발생했습니다. 다시 시도해 주세요.",
	  "paypalFlowFailedError": "PayPal 계정을 연결하는 동안 문제가 발생했습니다. 다시 시도해 주세요.",
	  "paypalTokenizationRequestActiveError": "PayPal 결제 승인이 이미 진행 중입니다.",
	  "venmoCanceledError": "오류가 발생했습니다. 기기에 최신 버전의 Venmo 앱이 설치되어 있으며 브라우저가 Venmo로 전환 기능을 지원하는지 확인하세요.",
	  "vaultManagerPaymentMethodDeletionError": "결제수단을 삭제할 수 없습니다. 다시 시도해 주세요.",
	  "venmoAppFailedError": "기기에서 Venmo 앱을 찾을 수 없습니다.",
	  "unsupportedCardTypeError": "이 카드 형식은 지원되지 않습니다. 다른 카드로 시도해 주세요.",
	  "applePayTokenizationError": "Apple Pay 결제를 처리하는 동안 네트워크 오류가 발생했습니다. 다시 시도해 주세요.",
	  "applePayActiveCardError": "Apple Pay 전자지갑에 지원되는 카드를 추가하세요.",
	  "cardholderNameLabel": "카드 소유자 이름",
	  "cardNumberLabel": "카드 번호",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3자리)",
	  "cvvFourDigitLabelSubheading": "(4자리)",
	  "cardholderNamePlaceholder": "카드 소유자 이름",
	  "expirationDateLabel": "만료일",
	  "expirationDateLabelSubheading": "(MM/YY)",
	  "expirationDatePlaceholder": "MM/YY",
	  "postalCodeLabel": "우편번호",
	  "saveCardLabel": "카드 저장",
	  "payWithCard": "카드로 결제",
	  "endingIn": "끝번호: {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "카드",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],167:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Betalen met {{paymentSource}}",
	  "chooseAnotherWayToPay": "Kies een andere betaalmethode",
	  "chooseAWayToPay": "Kies een betaalwijze",
	  "otherWaysToPay": "Andere manieren om te betalen",
	  "edit": "Bewerk",
	  "doneEditing": "Klaar",
	  "editPaymentMethods": "Betaalmethoden aanpassen",
	  "CreditCardDeleteConfirmationMessage": "{{secondaryIdentifier}}-kaart eindigend op {{identifier}} verwijderen?",
	  "PayPalAccountDeleteConfirmationMessage": "PayPal-rekening {{identifier}} verwijderen?",
	  "VenmoAccountDeleteConfirmationMessage": "Weet u zeker dat u Venmo-rekening met gebruikersnaam {{identifier}} wilt verwijderen?",
	  "genericDeleteConfirmationMessage": "Weet u zeker dat u deze betaalmethode wilt verwijderen?",
	  "deleteCancelButton": "Annuleren",
	  "deleteConfirmationButton": "Verwijderen",
	  "fieldEmptyForCvv": "Vul een CSC in.",
	  "fieldEmptyForExpirationDate": "Vul een vervaldatum in.",
	  "fieldEmptyForCardholderName": "Vul een naam voor de kaarthouder in.",
	  "fieldTooLongForCardholderName": "De naam van de kaarthouder moet korter zijn dan 256 tekens.",
	  "fieldEmptyForNumber": "Vul een nummer in.",
	  "fieldEmptyForPostalCode": "Vul een postcode in.",
	  "fieldInvalidForCvv": "Deze CSC is ongeldig.",
	  "fieldInvalidForExpirationDate": "Deze vervaldatum is ongeldig.",
	  "fieldInvalidForNumber": "Dit creditcardnummer is ongeldig.",
	  "fieldInvalidForPostalCode": "Deze postcode is ongeldig.",
	  "genericError": "Er is iets fout gegaan.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Deze creditcard staat al geregistreerd als een opgeslagen betaalmethode.",
	  "hostedFieldsFailedTokenizationError": "Controleer uw gegevens en probeer het opnieuw.",
	  "hostedFieldsFieldsInvalidError": "Controleer uw gegevens en probeer het opnieuw.",
	  "hostedFieldsTokenizationNetworkErrorError": "Netwerkfout. Probeer het opnieuw.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "De controle van de creditcard is mislukt. Controleer uw gegevens en probeer het opnieuw.",
	  "paypalButtonMustBeUsed": "Gebruik de PayPal-knop om door te gaan met uw betaling.",
	  "paypalAccountTokenizationFailedError": "Er is iets misgegaan bij het toevoegen van de PayPal-rekening. Probeer het opnieuw.",
	  "paypalFlowFailedError": "Er is iets misgegaan bij de verbinding met PayPal. Probeer het opnieuw.",
	  "paypalTokenizationRequestActiveError": "De autorisatie van de PayPal-betaling is al in behandeling.",
	  "venmoCanceledError": "Er ging iets fout. Controleer of de meest recente versie van de Venmo-app op je apparaat is geïnstalleerd en dat je browser overschakelen naar Venmo ondersteunt.",
	  "vaultManagerPaymentMethodDeletionError": "Kan de betaalmethode niet verwijderen, probeer het opnieuw.",
	  "venmoAppFailedError": "De Venmo-app is niet aangetroffen op je apparaat.",
	  "unsupportedCardTypeError": "Dit type creditcard wordt niet ondersteund. Gebruik een andere creditcard.",
	  "applePayTokenizationError": "Er is een netwerkfout opgetreden bij het verwerken van de Apple Pay-betaling. Probeer het opnieuw.",
	  "applePayActiveCardError": "Voeg een ondersteunde creditcard toe aan je Apple Pay-wallet.",
	  "cardholderNameLabel": "Naam kaarthouder",
	  "cardNumberLabel": "Creditcardnummer",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 cijfers)",
	  "cvvFourDigitLabelSubheading": "(4 cijfers)",
	  "cardholderNamePlaceholder": "Naam kaarthouder",
	  "expirationDateLabel": "Vervaldatum",
	  "expirationDateLabelSubheading": "(MM/JJ)",
	  "expirationDatePlaceholder": "MM/JJ",
	  "postalCodeLabel": "Postcode",
	  "saveCardLabel": "Creditcard opslaan",
	  "payWithCard": "Betalen met creditcard",
	  "endingIn": "Eindigend op {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Creditcard",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],168:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Betaling med {{paymentSource}}",
	  "chooseAnotherWayToPay": "Velg en annen måte å betale på",
	  "chooseAWayToPay": "Velg betalingsmåte",
	  "otherWaysToPay": "Andre måter å betale på",
	  "edit": "Rediger",
	  "doneEditing": "Fullført",
	  "editPaymentMethods": "Endre betalingsmetodene dine",
	  "CreditCardDeleteConfirmationMessage": "Vil du slette {{secondaryIdentifier}}-kortet som slutter på {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Vil du slette PayPal-kontoen {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Er du sikker på at du vil slette Venmo-kontoen med brukernavnet {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Er du sikker på at du vil slette denne betalingsmetoden?",
	  "deleteCancelButton": "Avbryt",
	  "deleteConfirmationButton": "Slett",
	  "fieldEmptyForCvv": "Oppgi en kortsikkerhetskode (CVV).",
	  "fieldEmptyForExpirationDate": "Oppgi en utløpsdato.",
	  "fieldEmptyForCardholderName": "Oppgi et navn for kortinnehaveren.",
	  "fieldTooLongForCardholderName": "Makslengden for kortinnehaverens navn er 256 tegn.",
	  "fieldEmptyForNumber": "Oppgi et nummer.",
	  "fieldEmptyForPostalCode": "Oppgi et postnummer.",
	  "fieldInvalidForCvv": "Denne sikkerhetskoden er ikke gyldig.",
	  "fieldInvalidForExpirationDate": "Denne utløpsdatoen er ikke gyldig.",
	  "fieldInvalidForNumber": "Dette kortnummeret er ikke gyldig.",
	  "fieldInvalidForPostalCode": "Dette postnummeret er ikke gyldig.",
	  "genericError": "Noe gikk galt hos oss.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Dette betalingskortet eksisterer allerede som en lagret betalingsmetode.",
	  "hostedFieldsFailedTokenizationError": "Kontroller informasjonen og prøv på nytt.",
	  "hostedFieldsFieldsInvalidError": "Kontroller informasjonen og prøv på nytt.",
	  "hostedFieldsTokenizationNetworkErrorError": "Nettverksfeil. Prøv på nytt.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Bekreftelsen av betalingskortet mislyktes. Kontroller informasjonen og prøv på nytt.",
	  "paypalButtonMustBeUsed": "Bruk PayPal-knappen for å fortsette med betalingen.",
	  "paypalAccountTokenizationFailedError": "Noe gikk galt da PayPal-kontoen ble lagt til. Prøv på nytt.",
	  "paypalFlowFailedError": "Det oppsto et problem med tilkoblingen til PayPal. Prøv på nytt.",
	  "paypalTokenizationRequestActiveError": "Godkjenning av PayPal-betalingen pågår allerede",
	  "venmoCanceledError": "Noe gikk galt. Kontroller at du har installert den nyeste versjonen av Venmo-appen på enheten og at nettleseren din støtter bytte til Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Kunne ikke slette betalingsmetoden. Prøv på nytt.",
	  "venmoAppFailedError": "Finner ikke Venmo-appen på enheten.",
	  "unsupportedCardTypeError": "Denne korttypen støttes ikke. Prøv med et annet kort.",
	  "applePayTokenizationError": "Det oppsto en nettverksfeil under behandlingen av Apple Pay-betalingen. Prøv på nytt.",
	  "applePayActiveCardError": "Legg til et kort som støttes i Apple Pay-lommeboken din.",
	  "cardholderNameLabel": "Kortinnehaverens navn",
	  "cardNumberLabel": "Kortnummer",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 siffer)",
	  "cvvFourDigitLabelSubheading": "(4 siffer)",
	  "cardholderNamePlaceholder": "Kortinnehaverens navn",
	  "expirationDateLabel": "Utløpsdato",
	  "expirationDateLabelSubheading": "(MM/ÅÅ)",
	  "expirationDatePlaceholder": "MM/ÅÅ",
	  "postalCodeLabel": "Postnummer",
	  "saveCardLabel": "Lagre kort",
	  "payWithCard": "Betal med kort",
	  "endingIn": "Slutter på {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Kort",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],169:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Źródło finansowania płatności: {{paymentSource}}",
	  "chooseAnotherWayToPay": "Wybierz inne źródło finansowania płatności",
	  "chooseAWayToPay": "Wybierz źródło finansowania płatności",
	  "otherWaysToPay": "Inne źródła finansowania płatności",
	  "edit": "Edytuj",
	  "doneEditing": "Gotowe",
	  "editPaymentMethods": "Edytuj źródła finansowania płatności",
	  "CreditCardDeleteConfirmationMessage": "Usunąć kartę {{secondaryIdentifier}} o numerze zakończonym cyframi {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Usunąć konto PayPal {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Czy na pewno chcesz usunąć konto Venmo z nazwą użytkownika {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Czy na pewno chcesz usunąć to źródło finansowania płatności?",
	  "deleteCancelButton": "Anuluj",
	  "deleteConfirmationButton": "Usuń",
	  "fieldEmptyForCvv": "Podaj kod bezpieczeństwa.",
	  "fieldEmptyForExpirationDate": "Podaj datę ważności.",
	  "fieldEmptyForCardholderName": "Podaj imię i nazwisko posiadacza karty.",
	  "fieldTooLongForCardholderName": "Imię i nazwisko posiadacza karty musi mieć mniej niż 256 znaków.",
	  "fieldEmptyForNumber": "Podaj numer.",
	  "fieldEmptyForPostalCode": "Podaj kod pocztowy.",
	  "fieldInvalidForCvv": "Podany kod bezpieczeństwa jest nieprawidłowy.",
	  "fieldInvalidForExpirationDate": "Podana data ważności jest nieprawidłowa.",
	  "fieldInvalidForNumber": "Podany numer karty jest nieprawidłowy.",
	  "fieldInvalidForPostalCode": "Podany kod pocztowy jest nieprawidłowy.",
	  "genericError": "Wystąpił błąd po naszej stronie.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Ta karta kredytowa jest już zapisana jako źródło finansowania płatności.",
	  "hostedFieldsFailedTokenizationError": "Sprawdź swoje informacje i spróbuj ponownie.",
	  "hostedFieldsFieldsInvalidError": "Sprawdź swoje informacje i spróbuj ponownie.",
	  "hostedFieldsTokenizationNetworkErrorError": "Błąd sieci. Spróbuj ponownie.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Weryfikacja karty kredytowej nie powiodła się. Sprawdź swoje informacje i spróbuj ponownie.",
	  "paypalButtonMustBeUsed": "Użyj przycisku PayPal, aby kontynuować płatność.",
	  "paypalAccountTokenizationFailedError": "Coś poszło nie tak podczas dodawania konta PayPal. Spróbuj ponownie.",
	  "paypalFlowFailedError": "Coś poszło nie tak podczas łączenia z systemem PayPal. Spróbuj ponownie.",
	  "paypalTokenizationRequestActiveError": "Autoryzacja płatności PayPal jest już w trakcie realizacji.",
	  "venmoCanceledError": "Wystąpił problem. Upewnij się, czy na swoim urządzeniu masz zainstalowaną najnowszą wersję aplikacji Venmo i Twoja przeglądarka ją obsługuje.",
	  "vaultManagerPaymentMethodDeletionError": "Nie można usunąć źródła finansowania płatności. Spróbuj ponownie.",
	  "venmoAppFailedError": "Nie można odnaleźć aplikacji Venmo na urządzeniu.",
	  "unsupportedCardTypeError": "Ten typ karty nie jest obsługiwany. Spróbuj użyć innej karty.",
	  "applePayTokenizationError": "Wystąpił błąd sieci podczas przetwarzania płatności Apple Pay. Spróbuj ponownie.",
	  "applePayActiveCardError": "Dodaj obsługiwaną kartę do portfela Apple Pay.",
	  "cardholderNameLabel": "Imię i nazwisko posiadacza karty",
	  "cardNumberLabel": "Numer karty",
	  "cvvLabel": "Kod CVC",
	  "cvvThreeDigitLabelSubheading": "(3 cyfry)",
	  "cvvFourDigitLabelSubheading": "(4 cyfry)",
	  "cardholderNamePlaceholder": "Imię i nazwisko posiadacza karty",
	  "expirationDateLabel": "Data ważności",
	  "expirationDateLabelSubheading": "(MM/RR)",
	  "expirationDatePlaceholder": "MM/RR",
	  "postalCodeLabel": "Kod pocztowy",
	  "saveCardLabel": "Zapisz kartę",
	  "payWithCard": "Zapłać kartą",
	  "endingIn": "O numerze zakończonym cyframi {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Karta",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],170:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Pagando com {{paymentSource}}",
	  "chooseAnotherWayToPay": "Escolher outro meio de pagamento",
	  "chooseAWayToPay": "Escolher um meio de pagamento",
	  "otherWaysToPay": "Outro meio de pagamento",
	  "edit": "Editar",
	  "doneEditing": "Concluído",
	  "editPaymentMethods": "Editar meios de pagamento",
	  "CreditCardDeleteConfirmationMessage": "Excluir cartão com {{secondaryIdentifier}} com final {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Excluir conta do PayPal {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Tem certeza de que deseja excluir a conta do Venmo com o nome de usuário {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Tem certeza de que deseja excluir este meio de pagamento?",
	  "deleteCancelButton": "Cancelar",
	  "deleteConfirmationButton": "Excluir",
	  "fieldEmptyForCvv": "Informe o Código de Segurança.",
	  "fieldEmptyForExpirationDate": "Informe a data de vencimento.",
	  "fieldEmptyForCardholderName": "Informe o nome do titular do cartão.",
	  "fieldTooLongForCardholderName": "O nome do titular do cartão deve ter menos de 256 caracteres.",
	  "fieldEmptyForNumber": "Informe um número.",
	  "fieldEmptyForPostalCode": "Informe um CEP.",
	  "fieldInvalidForCvv": "Este código de segurança não é válido.",
	  "fieldInvalidForExpirationDate": "Esta data de vencimento não é válida.",
	  "fieldInvalidForNumber": "O número do cartão não é válido.",
	  "fieldInvalidForPostalCode": "Este CEP não é válido.",
	  "genericError": "Ocorreu um erro.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Este cartão de crédito já está salvo em seus meios de pagamento.",
	  "hostedFieldsFailedTokenizationError": "Verifique as informações e tente novamente.",
	  "hostedFieldsFieldsInvalidError": "Verifique as informações e tente novamente.",
	  "hostedFieldsTokenizationNetworkErrorError": "Erro de rede. Tente novamente.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Falha ao verificar o cartão de crédito. Verifique as informações e tente novamente.",
	  "paypalButtonMustBeUsed": "Use o botão do PayPal para prosseguir com o seu pagamento.",
	  "paypalAccountTokenizationFailedError": "Ocorreu um erro ao adicionar a conta do PayPal. Tente novamente.",
	  "paypalFlowFailedError": "Ocorreu um erro de conexão com o PayPal. Tente novamente.",
	  "paypalTokenizationRequestActiveError": "A autorização de pagamento do PayPal já está em andamento.",
	  "venmoCanceledError": "Ocorreu um erro. Certifique-se de ter a versão mais recente do aplicativo Venmo instalado no seu dispositivo e que o seu navegador suporte a mudança para o Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Não é possível excluir o meio de pagamento, tente novamente.",
	  "venmoAppFailedError": "Não foi possível encontrar o aplicativo Venmo no seu dispositivo.",
	  "unsupportedCardTypeError": "Este tipo de cartão não é aceito. Experimente outro cartão.",
	  "applePayTokenizationError": "Ocorreu um erro de rede ao processar o pagamento com Apple Pay. Tente novamente.",
	  "applePayActiveCardError": "Adicione cartão suportado à sua carteira do Apple Pay.",
	  "cardholderNameLabel": "Nome do titular do cartão",
	  "cardNumberLabel": "Número do cartão",
	  "cvvLabel": "CSC",
	  "cvvThreeDigitLabelSubheading": "(3 dígitos)",
	  "cvvFourDigitLabelSubheading": "(4 dígitos)",
	  "cardholderNamePlaceholder": "Nome do titular do cartão",
	  "expirationDateLabel": "Data de vencimento",
	  "expirationDateLabelSubheading": "(MM/AA)",
	  "expirationDatePlaceholder": "MM/AA",
	  "postalCodeLabel": "CEP",
	  "saveCardLabel": "Salvar cartão",
	  "payWithCard": "Pague com seu cartão",
	  "endingIn": "Com final {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Cartão",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],171:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Pagar com {{paymentSource}}",
	  "chooseAnotherWayToPay": "Escolher outra forma de pagamento",
	  "chooseAWayToPay": "Escolha um meio de pagamento",
	  "otherWaysToPay": "Outras formas de pagamento",
	  "edit": "Editar",
	  "doneEditing": "Concluído",
	  "editPaymentMethods": "Editar meios de pagamento",
	  "CreditCardDeleteConfirmationMessage": "Eliminar o cartão {{secondaryIdentifier}} terminado em {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Eliminar {{identifier}} da conta PayPal?",
	  "VenmoAccountDeleteConfirmationMessage": "Tem a certeza de que pretende eliminar a conta Venmo com o nome de utilizador {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Tem certeza de que pretende eliminar este meio de pagamento?",
	  "deleteCancelButton": "Cancelar",
	  "deleteConfirmationButton": "Eliminar",
	  "fieldEmptyForCvv": "Introduza o código CVV.",
	  "fieldEmptyForExpirationDate": "Introduza a data de validade.",
	  "fieldEmptyForCardholderName": "Introduza um nome do titular do cartão.",
	  "fieldTooLongForCardholderName": "O nome do titular do cartão tem de ter menos de 256 carateres.",
	  "fieldEmptyForNumber": "Introduza um número.",
	  "fieldEmptyForPostalCode": "Introduza o código postal.",
	  "fieldInvalidForCvv": "Este código de segurança não é válido.",
	  "fieldInvalidForExpirationDate": "Esta data de validade não é correta.",
	  "fieldInvalidForNumber": "Este número de cartão não é válido.",
	  "fieldInvalidForPostalCode": "Este código postal não é válido.",
	  "genericError": "Tudo indica que houve um problema.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Este cartão de crédito já está registado como um meio de pagamento guardado.",
	  "hostedFieldsFailedTokenizationError": "Verifique os dados e tente novamente.",
	  "hostedFieldsFieldsInvalidError": "Verifique os dados e tente novamente.",
	  "hostedFieldsTokenizationNetworkErrorError": "Erro de rede. Tente novamente.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "A verificação do cartão de crédito falhou. Verifique os dados e tente novamente.",
	  "paypalButtonMustBeUsed": "Use o botão PayPal para continuar com o seu pagamento.",
	  "paypalAccountTokenizationFailedError": "Ocorreu um erro ao associar a conta PayPal. Tente novamente.",
	  "paypalFlowFailedError": "Ocorreu um erro na ligação com PayPal. Tente novamente.",
	  "paypalTokenizationRequestActiveError": "Já há uma autorização de pagamento PayPal em curso.",
	  "venmoCanceledError": "Ocorreu um erro. Certifique-se de que tem a versão mais recente da aplicação Venmo instalada no seu dispositivo e que o navegador suporta a mudança para o Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Não é possível eliminar o meio de pagamento, tente novamente.",
	  "venmoAppFailedError": "Não foi possível encontrar a aplicação Venmo no dispositivo.",
	  "unsupportedCardTypeError": "Este tipo de cartão não é suportado. Tente usar outro cartão.",
	  "applePayTokenizationError": "Ocorreu um erro de rede ao processar o pagamento com Apple Pay. Tente novamente.",
	  "applePayActiveCardError": "Adicione um cartão suportado à sua carteira Apple Pay.",
	  "cardholderNameLabel": "Nome do titular do cartão",
	  "cardNumberLabel": "Número do cartão",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 dígitos)",
	  "cvvFourDigitLabelSubheading": "(4 dígitos)",
	  "cardholderNamePlaceholder": "Nome do titular do cartão",
	  "expirationDateLabel": "Data de validade",
	  "expirationDateLabelSubheading": "(MM/AA)",
	  "expirationDatePlaceholder": "MM/AA",
	  "postalCodeLabel": "Código postal",
	  "saveCardLabel": "Guardar cartão",
	  "payWithCard": "Pagar com cartão",
	  "endingIn": "Terminado em {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Cartão",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],172:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Способы оплаты: {{paymentSource}}",
	  "chooseAnotherWayToPay": "Выберите другой способ оплаты",
	  "chooseAWayToPay": "Выберите способ оплаты",
	  "otherWaysToPay": "Другие способы оплаты",
	  "edit": "Редактировать",
	  "doneEditing": "Готово",
	  "editPaymentMethods": "Редактировать способы оплаты",
	  "CreditCardDeleteConfirmationMessage": "Удалить карту {{secondaryIdentifier}}, оканчивающуюся на {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Удалить счет PayPal {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Вы действительно хотите удалить счет Venmo с именем пользователя {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Вы действительно хотите удалить этот способ оплаты?",
	  "deleteCancelButton": "Отмена",
	  "deleteConfirmationButton": "Удалить",
	  "fieldEmptyForCvv": "Укажите код безопасности.",
	  "fieldEmptyForExpirationDate": "Укажите дату окончания срока действия.",
	  "fieldEmptyForCardholderName": "Введите имя и фамилию владельца карты.",
	  "fieldTooLongForCardholderName": "Имя владельца карты должно содержать не более 256 символов.",
	  "fieldEmptyForNumber": "Введите номер.",
	  "fieldEmptyForPostalCode": "Укажите почтовый индекс.",
	  "fieldInvalidForCvv": "Этот код безопасности недействителен.",
	  "fieldInvalidForExpirationDate": "Эта дата окончания срока действия недействительна.",
	  "fieldInvalidForNumber": "Этот номер карты недействителен.",
	  "fieldInvalidForPostalCode": "Этот почтовый индекс недействителен.",
	  "genericError": "Возникла проблема с нашей стороны.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Эта кредитная карта уже указана как сохраненный источник средств.",
	  "hostedFieldsFailedTokenizationError": "Проверьте правильность ввода данных и повторите попытку.",
	  "hostedFieldsFieldsInvalidError": "Проверьте правильность ввода данных и повторите попытку.",
	  "hostedFieldsTokenizationNetworkErrorError": "Ошибка сети. Повторите попытку.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Проверка банковской карты не выполнена. Проверьте правильность ввода данных и повторите попытку.",
	  "paypalButtonMustBeUsed": "Используйте кнопку PayPal, чтобы продолжить совершение оплаты.",
	  "paypalAccountTokenizationFailedError": "Что-то пошло не так — не удалось добавить учетную запись PayPal. Повторите попытку.",
	  "paypalFlowFailedError": "Что-то пошло не так — не удалось подключиться к системе PayPal. Повторите попытку.",
	  "paypalTokenizationRequestActiveError": "Выполняется авторизация платежа PayPal.",
	  "venmoCanceledError": "Возникла ошибка. Просим вас убедиться, что у вас установлена новейшая версия приложения Venmo и ваш браузер поддерживает переключение к Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Не удалось удалить способ оплаты. Повторите попытку.",
	  "venmoAppFailedError": "Приложение Venmo не обнаружено на вашем устройстве.",
	  "unsupportedCardTypeError": "Этот тип карты не поддерживается. Попробуйте воспользоваться другой картой.",
	  "applePayTokenizationError": "При обработке платежа через Apple Pay возникла сетевая ошибка. Повторите попытку.",
	  "applePayActiveCardError": "Добавьте поддерживаемую карту к своему счету Apple Pay.",
	  "cardholderNameLabel": "Имя и фамилия владельца",
	  "cardNumberLabel": "Номер карты",
	  "cvvLabel": "Код безопасности",
	  "cvvThreeDigitLabelSubheading": "(3 цифры)",
	  "cvvFourDigitLabelSubheading": "(4 цифры)",
	  "cardholderNamePlaceholder": "Имя и фамилия владельца",
	  "expirationDateLabel": "Срок действия",
	  "expirationDateLabelSubheading": "(ММ/ГГ)",
	  "expirationDatePlaceholder": "ММ/ГГ",
	  "postalCodeLabel": "Индекс",
	  "saveCardLabel": "Сохранить карту",
	  "payWithCard": "Оплатить картой",
	  "endingIn": "Последние четыре цифры номера карты: {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Карта",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],173:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "Betalas med {{paymentSource}}",
	  "chooseAnotherWayToPay": "Välj ett annat sätt att betala",
	  "chooseAWayToPay": "Välj hur du vill betala",
	  "otherWaysToPay": "Andra sätt att betala",
	  "edit": "Ändra",
	  "doneEditing": "Klart",
	  "editPaymentMethods": "Redigera betalningsmetoder",
	  "CreditCardDeleteConfirmationMessage": "Ta bort {{secondaryIdentifier}}-kort som slutar på {{identifier}}?",
	  "PayPalAccountDeleteConfirmationMessage": "Ta bort PayPal-konto {{identifier}}?",
	  "VenmoAccountDeleteConfirmationMessage": "Är du säker på att du vill ta bort Venmo-konto med användarnamn {{identifier}}?",
	  "genericDeleteConfirmationMessage": "Är du säker på att du vill ta bort den här betalningsmetoden?",
	  "deleteCancelButton": "Avbryt",
	  "deleteConfirmationButton": "Ta bort",
	  "fieldEmptyForCvv": "Fyll i en CVV-kod.",
	  "fieldEmptyForExpirationDate": "Fyll i ett utgångsdatum.",
	  "fieldEmptyForCardholderName": "Fyll i kortinnehavarens namn.",
	  "fieldTooLongForCardholderName": "Kortinnehavarens namn måste vara kortare än 256 tecken.",
	  "fieldEmptyForNumber": "Fyll i ett nummer.",
	  "fieldEmptyForPostalCode": "Fyll i ett postnummer.",
	  "fieldInvalidForCvv": "Den här säkerhetskoden är inte giltig.",
	  "fieldInvalidForExpirationDate": "Det här utgångsdatumet är inte giltigt.",
	  "fieldInvalidForNumber": "Det här kortnumret är inte giltigt.",
	  "fieldInvalidForPostalCode": "Det här postnumret är inte giltigt.",
	  "genericError": "Ett fel uppstod.",
	  "hostedFieldsTokenizationFailOnDuplicateError": "Det här betalkortet finns redan som en sparad betalningsmetod.",
	  "hostedFieldsFailedTokenizationError": "Kontrollera uppgifterna och försök igen.",
	  "hostedFieldsFieldsInvalidError": "Kontrollera uppgifterna och försök igen.",
	  "hostedFieldsTokenizationNetworkErrorError": "Nätverksfel. Försök igen.",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "Verifieringen av betalkort misslyckades. Kontrollera uppgifterna och försök igen.",
	  "paypalButtonMustBeUsed": "Använd PayPal-knappen för att fortsätta med din betalning.",
	  "paypalAccountTokenizationFailedError": "Ett fel uppstod när PayPal-kontot skulle läggas till. Försök igen.",
	  "paypalFlowFailedError": "Ett fel uppstod när anslutningen till PayPal skulle upprättas. Försök igen.",
	  "paypalTokenizationRequestActiveError": "Betalningsgodkännandet för PayPal behandlas redan.",
	  "venmoCanceledError": "Något gick fel. Se till att du har den senaste versionen av Venmo-appen installerad på din enhet och att webbläsaren stöder att gå över till Venmo.",
	  "vaultManagerPaymentMethodDeletionError": "Det gick inte att ta bort betalningsmetoden. Försök igen.",
	  "venmoAppFailedError": "Venmo-appen kunde inte hittas på din enhet.",
	  "unsupportedCardTypeError": "Den här korttypen stöds inte. Pröva med ett annat kort.",
	  "applePayTokenizationError": "Ett nätverksfel inträffade när Apple Pay-betalningen skulle behandlas. Försök igen.",
	  "applePayActiveCardError": "Lägg till ett kort som stöds i Apple Pay-e-plånboken.",
	  "cardholderNameLabel": "Kortinnehavarens namn",
	  "cardNumberLabel": "Kortnummer",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 siffror)",
	  "cvvFourDigitLabelSubheading": "(4 siffror)",
	  "cardholderNamePlaceholder": "Kortinnehavarens namn",
	  "expirationDateLabel": "Utgångsdatum",
	  "expirationDateLabelSubheading": "(MM/ÅÅ)",
	  "expirationDatePlaceholder": "MM/ÅÅ",
	  "postalCodeLabel": "Postnummer",
	  "saveCardLabel": "Spara kort",
	  "payWithCard": "Betala med kort",
	  "endingIn": "Slutar på {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "Kort",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],174:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "การชำระเงินด้วย {{paymentSource}}",
	  "chooseAnotherWayToPay": "เลือกวิธีอื่นเพื่อชำระเงิน",
	  "chooseAWayToPay": "เลือกวิธีชำระเงิน",
	  "otherWaysToPay": "วิธีอื่นๆ ในการชำระเงิน",
	  "edit": "แก้ไข",
	  "doneEditing": "เสร็จแล้ว",
	  "editPaymentMethods": "แก้ไขวิธีการชำระเงิน",
	  "CreditCardDeleteConfirmationMessage": "ลบบัตร {{secondaryIdentifier }} ที่ลงท้ายด้วย {{identifier}} หรือไม่",
	  "PayPalAccountDeleteConfirmationMessage": "ลบ {{identifier}} บัญชี PayPal หรือไม่",
	  "VenmoAccountDeleteConfirmationMessage": "คุณมั่นใจว่าต้องการลบบัญชี Venmo ที่มีชื่อผู้ใช้ {{identifier}} หรือไม่",
	  "genericDeleteConfirmationMessage": "คุณมั่นใจว่าต้องการลบวิธีการชำระเงินนี้หรือไม่",
	  "deleteCancelButton": "ยกเลิก",
	  "deleteConfirmationButton": "ลบ",
	  "fieldEmptyForCvv": "โปรดกรอก CVV (รหัสการตรวจสอบยืนยันบัตร)",
	  "fieldEmptyForExpirationDate": "โปรดกรอกวันที่หมดอายุ",
	  "fieldEmptyForCardholderName": "โปรดกรอกชื่อเจ้าของบัตร",
	  "fieldTooLongForCardholderName": "ชื่อผู้ถือบัตรจะต้องไม่เกิน 256 อักขระ",
	  "fieldEmptyForNumber": "โปรดกรอกหมายเลข",
	  "fieldEmptyForPostalCode": "โปรดกรอกรหัสไปรษณีย์",
	  "fieldInvalidForCvv": "รหัสความปลอดภัยนี้ไม่ถูกต้อง",
	  "fieldInvalidForExpirationDate": "วันที่หมดอายุนี้ไม่ถูกต้อง",
	  "fieldInvalidForNumber": "หมายเลขบัตรนี้ไม่ถูกต้อง",
	  "fieldInvalidForPostalCode": "รหัสไปรษณีย์นี้ไม่ถูกต้อง",
	  "genericError": "เกิดข้อผิดพลาดขึ้นในระบบของเรา",
	  "hostedFieldsTokenizationFailOnDuplicateError": "บัตรเครดิตนี้ถูกบันทึกไว้เป็นวิธีการชำระเงิน",
	  "hostedFieldsFailedTokenizationError": "โปรดตรวจสอบข้อมูลของคุณ แล้วลองใหม่อีกครั้ง",
	  "hostedFieldsFieldsInvalidError": "โปรดตรวจสอบข้อมูลของคุณ แล้วลองใหม่อีกครั้ง",
	  "hostedFieldsTokenizationNetworkErrorError": "ข้อผิดพลาดด้านเครือข่าย โปรดลองอีกครั้ง",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "การตรวจสอบยืนยันบัตรเครดิตล้มเหลว โปรดตรวจสอบข้อมูลของคุณ แล้วลองใหม่อีกครั้ง",
	  "paypalButtonMustBeUsed": "ใช้ปุ่ม PayPal เพื่อดำเนินการชำระเงินต่อ",
	  "paypalAccountTokenizationFailedError": "เกิดข้อผิดพลาดในการเพิ่มบัญชี PayPal โปรดลองอีกครั้ง",
	  "paypalFlowFailedError": "เกิดข้อผิดพลาดในการเชื่อมต่อกับ PayPal โปรดลองอีกครั้ง",
	  "paypalTokenizationRequestActiveError": "การอนุญาตการชำระเงินของ PayPal อยู่ในระหว่างดำเนินการ",
	  "venmoCanceledError": "เกิดข้อผิดพลาดบางประการ ตรวจสอบว่าคุณมีแอป Venmo เวอร์ชันล่าสุดติดตั้งในอุปกรณ์ของคุณ และมีเบราเซอร์ที่รองรับ Venmo",
	  "vaultManagerPaymentMethodDeletionError": "ไม่สามารถลบวิธีการชำระเงินได้ ลองอีกครั้ง",
	  "venmoAppFailedError": "ไม่พบแอป Venmo บนอุปกรณ์ของคุณ",
	  "unsupportedCardTypeError": "ไม่รองรับบัตรประเภทนี้ โปรดลองใช้บัตรใบอื่น",
	  "applePayTokenizationError": "เกิดข้อผิดพลาดด้านเครือข่ายขึ้นขณะดำเนินการชำระเงินด้วย Apple Pay โปรดลองอีกครั้ง",
	  "applePayActiveCardError": "เพิ่มบัตรที่รองรับในกระเป๋าสตางค์ Apple Pay ของคุณ",
	  "cardholderNameLabel": "ชื่อเจ้าของบัตร",
	  "cardNumberLabel": "หมายเลขบัตร",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "(3 หลัก)",
	  "cvvFourDigitLabelSubheading": "(4 หลัก)",
	  "cardholderNamePlaceholder": "ชื่อเจ้าของบัตร",
	  "expirationDateLabel": "วันหมดอายุ",
	  "expirationDateLabelSubheading": "(ดด/ปป)",
	  "expirationDatePlaceholder": "ดด/ปป",
	  "postalCodeLabel": "รหัสไปรษณีย์",
	  "saveCardLabel": "บันทึกบัตร",
	  "payWithCard": "ชำระเงินด้วยบัตร",
	  "endingIn": "ลงท้ายด้วย {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "บัตร",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],175:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "正在使用{{paymentSource}}付款",
	  "chooseAnotherWayToPay": "选择其他付款方式",
	  "chooseAWayToPay": "选择付款方式",
	  "otherWaysToPay": "其他付款方式",
	  "edit": "编辑",
	  "doneEditing": "完成",
	  "editPaymentMethods": "编辑付款方式",
	  "CreditCardDeleteConfirmationMessage": "删除尾号为{{identifier}}的{{secondaryIdentifier}}卡？",
	  "PayPalAccountDeleteConfirmationMessage": "删除PayPal账户{{identifier}}？",
	  "VenmoAccountDeleteConfirmationMessage": "确定要删除用户名为{{identifier}}的Venmo账户吗？",
	  "genericDeleteConfirmationMessage": "确定要删除该付款方式吗？",
	  "deleteCancelButton": "取消",
	  "deleteConfirmationButton": "删除",
	  "fieldEmptyForCvv": "请填写CVV。",
	  "fieldEmptyForExpirationDate": "请填写有效期限。",
	  "fieldEmptyForCardholderName": "请填写持卡人的姓名。",
	  "fieldTooLongForCardholderName": "持卡人姓名必须少于256个字符。",
	  "fieldEmptyForNumber": "请填写一个号码。",
	  "fieldEmptyForPostalCode": "请填写邮政编码。",
	  "fieldInvalidForCvv": "此安全代码无效。",
	  "fieldInvalidForExpirationDate": "此有效期限无效。",
	  "fieldInvalidForNumber": "此卡号无效。",
	  "fieldInvalidForPostalCode": "此邮政编码无效。",
	  "genericError": "我们遇到了一些问题",
	  "hostedFieldsTokenizationFailOnDuplicateError": "此信用卡已作为保存后的付款方式存在。",
	  "hostedFieldsFailedTokenizationError": "请检查您的信息，然后重试。",
	  "hostedFieldsFieldsInvalidError": "请检查您的信息，然后重试。",
	  "hostedFieldsTokenizationNetworkErrorError": "网络错误。请重试。",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "信用卡验证失败。请检查您的信息，然后重试。",
	  "paypalButtonMustBeUsed": "使用PayPal按钮继续进行付款。",
	  "paypalAccountTokenizationFailedError": "添加PayPal账户时出错。请重试。",
	  "paypalFlowFailedError": "连接到PayPal时出错。请重试。",
	  "paypalTokenizationRequestActiveError": "PayPal付款授权已在进行中。",
	  "venmoCanceledError": "我们遇到了问题。请确保您的设备上已安装最新版本的Venmo应用，并且您的浏览器支持切换到Venmo。",
	  "vaultManagerPaymentMethodDeletionError": "无法删除付款方式，请重试。",
	  "venmoAppFailedError": "在您的设备上找不到Venmo应用。",
	  "unsupportedCardTypeError": "不支持该卡类型。请尝试其他卡。",
	  "applePayTokenizationError": "处理Apple Pay付款时出现网络错误。请重试。",
	  "applePayActiveCardError": "请添加受支持的卡到您的Apple Pay钱包。",
	  "cardholderNameLabel": "持卡人姓名",
	  "cardNumberLabel": "卡号",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "（3位数）",
	  "cvvFourDigitLabelSubheading": "（4位数）",
	  "cardholderNamePlaceholder": "持卡人姓名",
	  "expirationDateLabel": "有效期限",
	  "expirationDateLabelSubheading": "（MM/YY）",
	  "expirationDatePlaceholder": "MM/YY",
	  "postalCodeLabel": "邮政编码",
	  "saveCardLabel": "保存卡",
	  "payWithCard": "用卡付款",
	  "endingIn": "尾号为{{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "卡",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "银联"
	};
	
	},{}],176:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "付款方式為 {{paymentSource}}",
	  "chooseAnotherWayToPay": "選擇其他付款方式",
	  "chooseAWayToPay": "選擇付款方式",
	  "otherWaysToPay": "其他付款方式",
	  "edit": "編輯",
	  "doneEditing": "完成",
	  "editPaymentMethods": "編輯付款方式",
	  "CreditCardDeleteConfirmationMessage": "要刪除末碼為 {{identifier}} 的 {{secondaryIdentifier}} 卡嗎？",
	  "PayPalAccountDeleteConfirmationMessage": "要刪除 PayPal 帳戶 {{identifier}} 嗎？",
	  "VenmoAccountDeleteConfirmationMessage": "確定要刪除使用者名稱為 {{identifier}} 的 Venmo 帳戶嗎？",
	  "genericDeleteConfirmationMessage": "確定要刪除此付款方式嗎？",
	  "deleteCancelButton": "取消",
	  "deleteConfirmationButton": "刪除",
	  "fieldEmptyForCvv": "請填寫信用卡認證碼。",
	  "fieldEmptyForExpirationDate": "請填寫到期日。",
	  "fieldEmptyForCardholderName": "請填寫持卡人的名字。",
	  "fieldTooLongForCardholderName": "持卡人姓名必須少於 256 個字元。",
	  "fieldEmptyForNumber": "請填寫號碼。",
	  "fieldEmptyForPostalCode": "請填寫郵遞區號。",
	  "fieldInvalidForCvv": "此安全代碼無效。",
	  "fieldInvalidForExpirationDate": "此到期日無效。",
	  "fieldInvalidForNumber": "此卡號無效。",
	  "fieldInvalidForPostalCode": "此郵遞區號無效。",
	  "genericError": "系統發生錯誤。",
	  "hostedFieldsTokenizationFailOnDuplicateError": "此信用卡已存在，為已儲存的付款方式。",
	  "hostedFieldsFailedTokenizationError": "請檢查你的資料並再試一次。",
	  "hostedFieldsFieldsInvalidError": "請檢查你的資料並再試一次。",
	  "hostedFieldsTokenizationNetworkErrorError": "網絡錯誤。再試一次。",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "信用卡認證失敗。請檢查你的資料並再試一次。",
	  "paypalButtonMustBeUsed": "使用 PayPal 按鈕以繼續付款。",
	  "paypalAccountTokenizationFailedError": "加入 PayPal 帳戶時發生錯誤。再試一次。",
	  "paypalFlowFailedError": "連接 PayPal 時發生錯誤。再試一次。",
	  "paypalTokenizationRequestActiveError": "PayPal 付款授權已在處理中。",
	  "venmoCanceledError": "系統發生錯誤，請確保你已在裝置上安裝最新版本的 Venmo 應用程式，而且你的瀏覽器支援切換至 Venmo。",
	  "vaultManagerPaymentMethodDeletionError": "無法刪除付款方式，請再試一次。",
	  "venmoAppFailedError": "在你的裝置上找不到 Venmo 應用程式。",
	  "unsupportedCardTypeError": "不可使用此信用卡類型。請改用其他信用卡。",
	  "applePayTokenizationError": "處理 Apple Pay 付款時發生網絡錯誤。再試一次。",
	  "applePayActiveCardError": "在 Apple Pay 錢包中加入支援的信用卡。",
	  "cardholderNameLabel": "持卡人名字",
	  "cardNumberLabel": "卡號",
	  "cvvLabel": "信用卡認證碼",
	  "cvvThreeDigitLabelSubheading": "（3 位數）",
	  "cvvFourDigitLabelSubheading": "（4 位數）",
	  "cardholderNamePlaceholder": "持卡人名字",
	  "expirationDateLabel": "到期日",
	  "expirationDateLabelSubheading": "(MM/YY)",
	  "expirationDatePlaceholder": "月 / 年",
	  "postalCodeLabel": "郵遞區號",
	  "saveCardLabel": "儲存信用卡",
	  "payWithCard": "使用信用卡付款",
	  "endingIn": "末碼為 {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "信用卡",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal Credit",
	  "Google Pay": "Google Pay",
	  "American Express": "American Express",
	  "Discover": "Discover",
	  "Diners Club": "Diners Club",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],177:[function(require,module,exports){
	'use strict';
	
	module.exports = {
	  "payingWith": "以 {{paymentSource}} 付款",
	  "chooseAnotherWayToPay": "選擇付款的以其他方式付款",
	  "chooseAWayToPay": "選擇付款方式",
	  "otherWaysToPay": "其他付款方式",
	  "edit": "編輯",
	  "doneEditing": "完成",
	  "editPaymentMethods": "編輯付款方式",
	  "CreditCardDeleteConfirmationMessage": "確定要刪除末碼為 {{identifier}} 的 {{secondaryIdentifier}} 卡片嗎？",
	  "PayPalAccountDeleteConfirmationMessage": "確定要刪除 {{identifier}} PayPal 帳戶嗎？",
	  "VenmoAccountDeleteConfirmationMessage": "確定要刪除用戶名稱為 {{identifier}} 的 Venmo 帳戶嗎？",
	  "genericDeleteConfirmationMessage": "確定要刪除此付款方式？",
	  "deleteCancelButton": "取消",
	  "deleteConfirmationButton": "刪除",
	  "fieldEmptyForCvv": "請填妥信用卡驗證碼。",
	  "fieldEmptyForExpirationDate": "請填妥到期日。",
	  "fieldEmptyForCardholderName": "請填妥持卡人姓名。",
	  "fieldTooLongForCardholderName": "持卡人姓名不能超過 256 個字元。",
	  "fieldEmptyForNumber": "請填妥號碼。",
	  "fieldEmptyForPostalCode": "請填寫郵遞區號。",
	  "fieldInvalidForCvv": "這組安全代碼無效。",
	  "fieldInvalidForExpirationDate": "此到期日無效。",
	  "fieldInvalidForNumber": "此卡號無效。",
	  "fieldInvalidForPostalCode": "此郵遞區號無效。",
	  "genericError": "我們的系統發生問題。",
	  "hostedFieldsTokenizationFailOnDuplicateError": "此信用卡已存在，為已儲存的付款方式。",
	  "hostedFieldsFailedTokenizationError": "請檢查你的資料並重試。",
	  "hostedFieldsFieldsInvalidError": "請檢查你的資料並重試。",
	  "hostedFieldsTokenizationNetworkErrorError": "網路錯誤。請重試。",
	  "hostedFieldsTokenizationCvvVerificationFailedError": "信用卡認證失敗。請檢查你的資料並重試。",
	  "paypalButtonMustBeUsed": "使用 PayPal 按鈕以繼續付款。",
	  "paypalAccountTokenizationFailedError": "新增 PayPal 帳戶時，系統發生錯誤。請重試。",
	  "paypalFlowFailedError": "連結至 PayPal 時，系統發生錯誤。請重試。",
	  "paypalTokenizationRequestActiveError": "PayPal 支付款項的授權已在處理中。",
	  "venmoCanceledError": "系統發生錯誤。確認你的裝置上裝有最新版本的 Venmo 應用程式，而且瀏覽器支援切換至 Venmo。",
	  "vaultManagerPaymentMethodDeletionError": "無法刪除付款方式，請再試一次。",
	  "venmoAppFailedError": "你的裝置上找不到 Venmo 應用程式。",
	  "unsupportedCardTypeError": "不支援此卡片類型。請改用其他卡片。",
	  "applePayTokenizationError": "在處理 Apple Pay 付款時發生網路錯誤。請重試。",
	  "applePayActiveCardError": "新增支援的卡片至你的 Apple Pay 錢包。",
	  "cardholderNameLabel": "持卡人姓名",
	  "cardNumberLabel": "卡號",
	  "cvvLabel": "CVV",
	  "cvvThreeDigitLabelSubheading": "（3 位數）",
	  "cvvFourDigitLabelSubheading": "（4 位數）",
	  "cardholderNamePlaceholder": "持卡人姓名",
	  "expirationDateLabel": "到期日",
	  "expirationDateLabelSubheading": "（月 / 年）",
	  "expirationDatePlaceholder": "月 / 年",
	  "postalCodeLabel": "郵遞區號",
	  "saveCardLabel": "儲存卡片",
	  "payWithCard": "使用信用卡 / 扣帳卡付款",
	  "endingIn": "末碼為 {{lastFourCardDigits}}",
	  "Apple Pay": "Apple Pay",
	  "Venmo": "Venmo",
	  "Card": "信用卡或扣帳卡",
	  "PayPal": "PayPal",
	  "PayPal Credit": "PayPal 信貸",
	  "Google Pay": "Google Pay",
	  "American Express": "美國運通 (American Express)",
	  "Discover": "Discover",
	  "Diners Club": "大來國際 (Diners Club)",
	  "MasterCard": "Mastercard",
	  "Visa": "Visa",
	  "JCB": "JCB",
	  "Maestro": "Maestro",
	  "UnionPay": "UnionPay"
	};
	
	},{}],178:[function(require,module,exports){
	'use strict';
	
	var assign = require('../lib/assign').assign;
	var classList = require('@braintree/class-list');
	var DropinError = require('../lib/dropin-error');
	var errors = require('../constants').errors;
	var Promise = require('../lib/promise');
	
	function BaseView(options) {
	  options = options || {};
	
	  assign(this, options);
	}
	
	BaseView.prototype.getElementById = function (id) {
	  if (!this.element) { return null; }
	
	  return this.element.querySelector('[data-braintree-id="' + id + '"]');
	};
	
	BaseView.prototype.requestPaymentMethod = function () {
	  return Promise.reject(new DropinError(errors.NO_PAYMENT_METHOD_ERROR));
	};
	
	BaseView.prototype.getPaymentMethod = function () {
	  return this.activeMethodView && this.activeMethodView.paymentMethod;
	};
	
	BaseView.prototype.onSelection = function () {};
	
	BaseView.prototype.teardown = function () {
	  return Promise.resolve();
	};
	
	BaseView.prototype.preventUserAction = function () {
	  if (this.element) {
	    classList.add(this.element, 'braintree-sheet--loading');
	  }
	
	  this.model.preventUserAction();
	};
	
	BaseView.prototype.allowUserAction = function () {
	  if (this.element) {
	    classList.remove(this.element, 'braintree-sheet--loading');
	  }
	
	  this.model.allowUserAction();
	};
	
	module.exports = BaseView;
	
	},{"../constants":131,"../lib/assign":137,"../lib/dropin-error":141,"../lib/promise":148,"@braintree/class-list":18}],179:[function(require,module,exports){
	'use strict';
	
	var BaseView = require('./base-view');
	var addSelectionEventHandler = require('../lib/add-selection-event-handler');
	var paymentMethodTypes = require('../constants').paymentMethodTypes;
	
	function DeleteConfirmationView() {
	  BaseView.apply(this, arguments);
	
	  this._initialize();
	}
	
	DeleteConfirmationView.prototype = Object.create(BaseView.prototype);
	DeleteConfirmationView.prototype.constructor = DeleteConfirmationView;
	DeleteConfirmationView.ID = DeleteConfirmationView.prototype.ID = 'delete-confirmation';
	
	DeleteConfirmationView.prototype._initialize = function () {
	  this._yesButton = this.getElementById('delete-confirmation__yes');
	  this._noButton = this.getElementById('delete-confirmation__no');
	  this._messageBox = this.getElementById('delete-confirmation__message');
	
	  addSelectionEventHandler(this._yesButton, function () {
	    this.model.deleteVaultedPaymentMethod();
	  }.bind(this));
	  addSelectionEventHandler(this._noButton, function () {
	    this.model.cancelDeleteVaultedPaymentMethod();
	  }.bind(this));
	};
	
	DeleteConfirmationView.prototype.applyPaymentMethod = function (paymentMethod) {
	  var identifier, secondaryIdentifier;
	  var messageText = this.strings[paymentMethod.type + 'DeleteConfirmationMessage'];
	
	  if (messageText) {
	    switch (paymentMethod.type) {
	      case paymentMethodTypes.card:
	        identifier = paymentMethod.details.lastFour;
	        secondaryIdentifier = paymentMethod.details.cardType;
	        secondaryIdentifier = this.strings[secondaryIdentifier] || secondaryIdentifier;
	        break;
	      case paymentMethodTypes.paypal:
	        identifier = paymentMethod.details.email;
	        break;
	      case paymentMethodTypes.venmo:
	        identifier = paymentMethod.details.username;
	        break;
	      default:
	        break;
	    }
	
	    messageText = messageText.replace('{{identifier}}', identifier);
	    if (secondaryIdentifier) {
	      messageText = messageText.replace('{{secondaryIdentifier}}', secondaryIdentifier);
	    }
	  } else {
	    messageText = this.strings.genericDeleteConfirmationMessage;
	  }
	  this._messageBox.innerText = messageText;
	};
	
	module.exports = DeleteConfirmationView;
	
	},{"../constants":131,"../lib/add-selection-event-handler":135,"./base-view":178}],180:[function(require,module,exports){
	'use strict';
	
	var analytics = require('../lib/analytics');
	var analyticsKinds = require('../constants').analyticsKinds;
	var BaseView = require('./base-view');
	var classList = require('@braintree/class-list');
	var sheetViews = require('./payment-sheet-views');
	var PaymentMethodsView = require('./payment-methods-view');
	var PaymentOptionsView = require('./payment-options-view');
	var DeleteConfirmationView = require('./delete-confirmation-view');
	var addSelectionEventHandler = require('../lib/add-selection-event-handler');
	var Promise = require('../lib/promise');
	var supportsFlexbox = require('../lib/supports-flexbox');
	
	var CHANGE_ACTIVE_PAYMENT_METHOD_TIMEOUT = require('../constants').CHANGE_ACTIVE_PAYMENT_METHOD_TIMEOUT;
	var DEVELOPER_MISCONFIGURATION_MESSAGE = require('../constants').errors.DEVELOPER_MISCONFIGURATION_MESSAGE;
	
	function MainView() {
	  BaseView.apply(this, arguments);
	
	  this.dependenciesInitializing = 0;
	
	  this._initialize();
	}
	
	MainView.prototype = Object.create(BaseView.prototype);
	MainView.prototype.constructor = MainView;
	
	MainView.prototype._initialize = function () {
	  var paymentOptionsView;
	
	  this._hasMultiplePaymentOptions = this.model.supportedPaymentOptions.length > 1;
	
	  this._views = {};
	
	  this.sheetContainer = this.getElementById('sheet-container');
	  this.sheetErrorText = this.getElementById('sheet-error-text');
	
	  this.toggle = this.getElementById('toggle');
	  this.disableWrapper = this.getElementById('disable-wrapper');
	  this.lowerContainer = this.getElementById('lower-container');
	
	  this.loadingContainer = this.getElementById('loading-container');
	  this.dropinContainer = this.element.querySelector('.braintree-dropin');
	
	  this.supportsFlexbox = supportsFlexbox();
	
	  this.model.on('asyncDependenciesReady', this.hideLoadingIndicator.bind(this));
	
	  this.model.on('errorOccurred', this.showSheetError.bind(this));
	  this.model.on('errorCleared', this.hideSheetError.bind(this));
	  this.model.on('preventUserAction', this.preventUserAction.bind(this));
	  this.model.on('allowUserAction', this.allowUserAction.bind(this));
	
	  this.paymentSheetViewIDs = Object.keys(sheetViews).reduce(function (ids, sheetViewKey) {
	    var PaymentSheetView, paymentSheetView;
	
	    if (this.model.supportedPaymentOptions.indexOf(sheetViewKey) !== -1) {
	      PaymentSheetView = sheetViews[sheetViewKey];
	
	      paymentSheetView = new PaymentSheetView({
	        element: this.getElementById(PaymentSheetView.ID),
	        mainView: this,
	        model: this.model,
	        client: this.client,
	        strings: this.strings
	      });
	      paymentSheetView.initialize();
	
	      this.addView(paymentSheetView);
	      ids.push(paymentSheetView.ID);
	    }
	
	    return ids;
	  }.bind(this), []);
	
	  this.paymentMethodsViews = new PaymentMethodsView({
	    element: this.element,
	    model: this.model,
	    client: this.client,
	    strings: this.strings
	  });
	  this.addView(this.paymentMethodsViews);
	
	  this.deleteConfirmationView = new DeleteConfirmationView({
	    element: this.getElementById('delete-confirmation'),
	    model: this.model,
	    strings: this.strings
	  });
	  this.addView(this.deleteConfirmationView);
	
	  addSelectionEventHandler(this.toggle, this.toggleAdditionalOptions.bind(this));
	
	  this.model.on('changeActivePaymentMethod', function () {
	    setTimeout(function () {
	      this.setPrimaryView(PaymentMethodsView.ID);
	    }.bind(this), CHANGE_ACTIVE_PAYMENT_METHOD_TIMEOUT);
	  }.bind(this));
	
	  this.model.on('changeActivePaymentView', this._onChangeActivePaymentMethodView.bind(this));
	
	  this.model.on('removeActivePaymentMethod', function () {
	    var activePaymentView = this.getView(this.model.getActivePaymentView());
	
	    if (activePaymentView && typeof activePaymentView.removeActivePaymentMethod === 'function') {
	      activePaymentView.removeActivePaymentMethod();
	    }
	  }.bind(this));
	
	  this.model.on('enableEditMode', this.enableEditMode.bind(this));
	
	  this.model.on('disableEditMode', this.disableEditMode.bind(this));
	
	  this.model.on('confirmPaymentMethodDeletion', this.openConfirmPaymentMethodDeletionDialog.bind(this));
	  this.model.on('cancelVaultedPaymentMethodDeletion', this.cancelVaultedPaymentMethodDeletion.bind(this));
	  this.model.on('startVaultedPaymentMethodDeletion', this.startVaultedPaymentMethodDeletion.bind(this));
	  this.model.on('finishVaultedPaymentMethodDeletion', this.finishVaultedPaymentMethodDeletion.bind(this));
	
	  if (this._hasMultiplePaymentOptions) {
	    paymentOptionsView = new PaymentOptionsView({
	      client: this.client,
	      element: this.getElementById(PaymentOptionsView.ID),
	      mainView: this,
	      model: this.model,
	      strings: this.strings
	    });
	
	    this.addView(paymentOptionsView);
	  }
	
	  this._sendToDefaultView();
	};
	
	MainView.prototype._onChangeActivePaymentMethodView = function (id) {
	  var activePaymentView = this.getView(id);
	
	  if (id === PaymentMethodsView.ID) {
	    classList.add(this.paymentMethodsViews.container, 'braintree-methods--active');
	    classList.remove(this.sheetContainer, 'braintree-sheet--active');
	  } else {
	    setTimeout(function () {
	      classList.add(this.sheetContainer, 'braintree-sheet--active');
	    }.bind(this), 0);
	    classList.remove(this.paymentMethodsViews.container, 'braintree-methods--active');
	    if (!this.getView(id).getPaymentMethod()) {
	      this.model.setPaymentMethodRequestable({
	        isRequestable: false
	      });
	    }
	  }
	
	  activePaymentView.onSelection();
	};
	
	MainView.prototype.addView = function (view) {
	  this._views[view.ID] = view;
	};
	
	MainView.prototype.getView = function (id) {
	  return this._views[id];
	};
	
	MainView.prototype.setPrimaryView = function (id, secondaryViewId) {
	  var paymentMethod;
	
	  setTimeout(function () {
	    this.element.className = prefixShowClass(id);
	    if (secondaryViewId) {
	      classList.add(this.element, prefixShowClass(secondaryViewId));
	    }
	  }.bind(this), 0);
	
	  this.primaryView = this.getView(id);
	  this.model.changeActivePaymentView(id);
	
	  if (this.paymentSheetViewIDs.indexOf(id) !== -1) {
	    if (this.model.getPaymentMethods().length > 0 || this.getView(PaymentOptionsView.ID)) {
	      this.showToggle();
	    } else {
	      this.hideToggle();
	    }
	  } else if (id === PaymentMethodsView.ID) {
	    this.showToggle();
	    // Move options below the upper-container
	    this.getElementById('lower-container').appendChild(this.getElementById('options'));
	  } else if (id === PaymentOptionsView.ID) {
	    this.hideToggle();
	  }
	
	  if (!this.supportsFlexbox) {
	    this.element.setAttribute('data-braintree-no-flexbox', true);
	  }
	
	  paymentMethod = this.primaryView.getPaymentMethod();
	
	  this.model.setPaymentMethodRequestable({
	    isRequestable: Boolean(paymentMethod && !this.model.isInEditMode()),
	    type: paymentMethod && paymentMethod.type,
	    selectedPaymentMethod: paymentMethod
	  });
	
	  this.model.clearError();
	};
	
	MainView.prototype.requestPaymentMethod = function () {
	  var activePaymentView = this.getView(this.model.getActivePaymentView());
	
	  return activePaymentView.requestPaymentMethod().then(function (payload) {
	    analytics.sendEvent(this.client, 'request-payment-method.' + analyticsKinds[payload.type]);
	
	    return payload;
	  }.bind(this)).catch(function (err) {
	    analytics.sendEvent(this.client, 'request-payment-method.error');
	
	    return Promise.reject(err);
	  }.bind(this));
	};
	
	MainView.prototype.hideLoadingIndicator = function () {
	  classList.remove(this.dropinContainer, 'braintree-loading');
	  classList.add(this.dropinContainer, 'braintree-loaded');
	  classList.add(this.loadingContainer, 'braintree-hidden');
	};
	
	MainView.prototype.showLoadingIndicator = function () {
	  classList.add(this.dropinContainer, 'braintree-loading');
	  classList.remove(this.dropinContainer, 'braintree-loaded');
	  classList.remove(this.loadingContainer, 'braintree-hidden');
	};
	
	MainView.prototype.toggleAdditionalOptions = function () {
	  var sheetViewID;
	  var isPaymentSheetView = this.paymentSheetViewIDs.indexOf(this.primaryView.ID) !== -1;
	
	  this.hideToggle();
	
	  if (!this._hasMultiplePaymentOptions) {
	    sheetViewID = this.paymentSheetViewIDs[0];
	
	    classList.add(this.element, prefixShowClass(sheetViewID));
	    this.model.changeActivePaymentView(sheetViewID);
	  } else if (isPaymentSheetView) {
	    if (this.model.getPaymentMethods().length === 0) {
	      this.setPrimaryView(PaymentOptionsView.ID);
	    } else {
	      this.setPrimaryView(PaymentMethodsView.ID, PaymentOptionsView.ID);
	      this.hideToggle();
	    }
	  } else {
	    classList.add(this.element, prefixShowClass(PaymentOptionsView.ID));
	  }
	};
	
	MainView.prototype.showToggle = function () {
	  if (this.model.isInEditMode()) {
	    return;
	  }
	  classList.remove(this.toggle, 'braintree-hidden');
	  classList.add(this.lowerContainer, 'braintree-hidden');
	};
	
	MainView.prototype.hideToggle = function () {
	  classList.add(this.toggle, 'braintree-hidden');
	  classList.remove(this.lowerContainer, 'braintree-hidden');
	};
	
	MainView.prototype.showSheetError = function (error) {
	  var errorMessage;
	  var genericErrorMessage = this.strings.genericError;
	
	  if (this.strings.hasOwnProperty(error)) {
	    errorMessage = this.strings[error];
	  } else if (error && typeof error.code === 'string') {
	    errorMessage = this.strings[snakeCaseToCamelCase(error.code) + 'Error'] || genericErrorMessage;
	  } else if (error === 'developerError') {
	    errorMessage = DEVELOPER_MISCONFIGURATION_MESSAGE;
	  } else {
	    errorMessage = genericErrorMessage;
	  }
	
	  classList.add(this.dropinContainer, 'braintree-sheet--has-error');
	  this.sheetErrorText.innerHTML = errorMessage;
	};
	
	MainView.prototype.hideSheetError = function () {
	  classList.remove(this.dropinContainer, 'braintree-sheet--has-error');
	};
	
	MainView.prototype.getOptionsElements = function () {
	  return this._views.options.elements;
	};
	
	MainView.prototype.preventUserAction = function () {
	  classList.remove(this.disableWrapper, 'braintree-hidden');
	};
	
	MainView.prototype.allowUserAction = function () {
	  classList.add(this.disableWrapper, 'braintree-hidden');
	};
	
	MainView.prototype.teardown = function () {
	  var error;
	  var viewNames = Object.keys(this._views);
	  var teardownPromises = viewNames.map(function (view) {
	    return this._views[view].teardown().catch(function (err) {
	      error = err;
	    });
	  }.bind(this));
	
	  return Promise.all(teardownPromises).then(function () {
	    if (error) {
	      return Promise.reject(error);
	    }
	
	    return Promise.resolve();
	  });
	};
	
	MainView.prototype.enableEditMode = function () {
	  this.setPrimaryView(this.paymentMethodsViews.ID);
	  this.paymentMethodsViews.enableEditMode();
	  this.hideToggle();
	
	  this.model.setPaymentMethodRequestable({
	    isRequestable: false
	  });
	};
	
	MainView.prototype.disableEditMode = function () {
	  var paymentMethod;
	
	  this.hideSheetError();
	  this.paymentMethodsViews.disableEditMode();
	  this.showToggle();
	
	  paymentMethod = this.primaryView.getPaymentMethod();
	
	  this.model.setPaymentMethodRequestable({
	    isRequestable: Boolean(paymentMethod),
	    type: paymentMethod && paymentMethod.type,
	    selectedPaymentMethod: paymentMethod
	  });
	};
	
	MainView.prototype.openConfirmPaymentMethodDeletionDialog = function (paymentMethod) {
	  this.deleteConfirmationView.applyPaymentMethod(paymentMethod);
	  this.setPrimaryView(this.deleteConfirmationView.ID);
	};
	
	MainView.prototype.cancelVaultedPaymentMethodDeletion = function () {
	  this.setPrimaryView(this.paymentMethodsViews.ID);
	};
	
	MainView.prototype.startVaultedPaymentMethodDeletion = function () {
	  this.element.className = '';
	  this.showLoadingIndicator();
	};
	
	MainView.prototype.finishVaultedPaymentMethodDeletion = function (error) {
	  var self = this;
	
	  this.paymentMethodsViews.refreshPaymentMethods();
	
	  if (error && this.model.getPaymentMethods().length > 0) {
	    this.model.enableEditMode();
	    this.showSheetError('vaultManagerPaymentMethodDeletionError');
	  } else {
	    this._sendToDefaultView();
	  }
	
	  return new Promise(function (resolve) {
	    setTimeout(function () {
	      // allow all the views to reset before hiding the loading indicator
	      self.hideLoadingIndicator();
	      resolve();
	    }, 500);
	  });
	};
	
	MainView.prototype._sendToDefaultView = function () {
	  var paymentMethods = this.model.getPaymentMethods();
	  var preselectVaultedPaymentMethod = this.model.merchantConfiguration.preselectVaultedPaymentMethod !== false;
	
	  if (paymentMethods.length > 0) {
	    if (preselectVaultedPaymentMethod) {
	      analytics.sendEvent(this.client, 'vaulted-card.preselect');
	
	      this.model.changeActivePaymentMethod(paymentMethods[0]);
	    } else {
	      this.setPrimaryView(this.paymentMethodsViews.ID);
	    }
	  } else if (this._hasMultiplePaymentOptions) {
	    this.setPrimaryView(PaymentOptionsView.ID);
	  } else {
	    this.setPrimaryView(this.paymentSheetViewIDs[0]);
	  }
	};
	function snakeCaseToCamelCase(s) {
	  return s.toLowerCase().replace(/(\_\w)/g, function (m) {
	    return m[1].toUpperCase();
	  });
	}
	
	function prefixShowClass(classname) {
	  return 'braintree-show-' + classname;
	}
	
	module.exports = MainView;
	
	},{"../constants":131,"../lib/add-selection-event-handler":135,"../lib/analytics":136,"../lib/promise":148,"../lib/supports-flexbox":150,"./base-view":178,"./delete-confirmation-view":179,"./payment-methods-view":182,"./payment-options-view":183,"./payment-sheet-views":188,"@braintree/class-list":18}],181:[function(require,module,exports){
	'use strict';
	
	var analytics = require('../lib/analytics');
	var BaseView = require('./base-view');
	var classList = require('@braintree/class-list');
	var constants = require('../constants');
	
	var addSelectionEventHandler = require('../lib/add-selection-event-handler');
	
	var paymentMethodHTML = "<div class=\"braintree-method__icon-container braintree-method__delete-container\">\n  <div class=\"braintree-method__icon braintree-method__delete\">\n    <svg width=\"48\" height=\"29\">\n      <use xlink:href=\"#iconX\"></use>\n    </svg>\n  </div>\n</div>\n\n<div class=\"braintree-method__logo\">\n  <svg width=\"40\" height=\"24\" class=\"@CLASSNAME\">\n    <use xlink:href=\"#@ICON\"></use>\n  </svg>\n</div>\n\n<div class=\"braintree-method__label\">@TITLE<br><div class=\"braintree-method__label--small\">@SUBTITLE</div></div>\n\n<div class=\"braintree-method__icon-container braintree-method__check-container\">\n  <div class=\"braintree-method__icon braintree-method__check\">\n    <svg height=\"100%\" width=\"100%\">\n      <use xlink:href=\"#iconCheck\"></use>\n    </svg>\n  </div>\n</div>\n";
	
	function PaymentMethodView() {
	  BaseView.apply(this, arguments);
	
	  this._initialize();
	}
	
	PaymentMethodView.prototype = Object.create(BaseView.prototype);
	PaymentMethodView.prototype.constructor = PaymentMethodView;
	
	PaymentMethodView.prototype._initialize = function () {
	  var endingInText;
	  var html = paymentMethodHTML;
	  var paymentMethodCardTypes = constants.paymentMethodCardTypes;
	  var paymentMethodTypes = constants.paymentMethodTypes;
	
	  this.element = document.createElement('div');
	  this.element.className = 'braintree-method';
	  this.element.setAttribute('tabindex', '0');
	
	  addSelectionEventHandler(this.element, this._choosePaymentMethod.bind(this));
	
	  switch (this.paymentMethod.type) {
	    case paymentMethodTypes.applePay:
	      html = html.replace(/@ICON/g, 'logoApplePay')
	        .replace(/@CLASSNAME/g, '')
	        .replace(/@TITLE/g, this.strings['Apple Pay'])
	        .replace(/@SUBTITLE/g, '');
	      break;
	    case paymentMethodTypes.card:
	      endingInText = this.strings.endingIn.replace('{{lastFourCardDigits}}', this.paymentMethod.details.lastFour);
	      html = html.replace(/@ICON/g, 'icon-' + paymentMethodCardTypes[this.paymentMethod.details.cardType])
	        .replace(/@CLASSNAME/g, ' braintree-icon--bordered')
	        .replace(/@TITLE/g, endingInText)
	        .replace(/@SUBTITLE/g, this.strings[this.paymentMethod.details.cardType]);
	      break;
	    case paymentMethodTypes.googlePay:
	      html = html.replace(/@ICON/g, 'logoGooglePay')
	        .replace(/@CLASSNAME/g, '')
	        .replace(/@TITLE/g, this.strings['Google Pay'])
	        .replace(/@SUBTITLE/g, '');
	      break;
	    case paymentMethodTypes.paypal:
	      html = html.replace(/@ICON/g, 'logoPayPal')
	        .replace(/@CLASSNAME/g, '')
	        .replace(/@TITLE/g, this.paymentMethod.details.email)
	        .replace(/@SUBTITLE/g, this.strings.PayPal);
	      break;
	    case paymentMethodTypes.venmo:
	      html = html.replace(/@ICON/g, 'logoVenmo')
	        .replace(/@CLASSNAME/g, '')
	        .replace(/@TITLE/g, this.paymentMethod.details.username)
	        .replace(/@SUBTITLE/g, this.strings.Venmo);
	      break;
	    default:
	      break;
	  }
	
	  this.element.innerHTML = html;
	  this.checkMark = this.element.querySelector('.braintree-method__check-container');
	  addSelectionEventHandler(this.element.querySelector('.braintree-method__delete-container'), this._selectDelete.bind(this));
	};
	
	PaymentMethodView.prototype.setActive = function (isActive) {
	  // setTimeout required to animate addition of new payment methods
	  setTimeout(function () {
	    classList.toggle(this.element, 'braintree-method--active', isActive);
	  }.bind(this), 0);
	};
	
	PaymentMethodView.prototype.enableEditMode = function () {
	  classList.add(this.checkMark, 'braintree-hidden');
	  if (this.paymentMethod.hasSubscription) {
	    classList.add(this.element, 'braintree-method--disabled');
	  }
	};
	
	PaymentMethodView.prototype.disableEditMode = function () {
	  classList.remove(this.checkMark, 'braintree-hidden');
	  classList.remove(this.element, 'braintree-method--disabled');
	};
	
	PaymentMethodView.prototype._choosePaymentMethod = function () {
	  if (this.model.isInEditMode()) {
	    return;
	  }
	  if (this.paymentMethod.vaulted) {
	    analytics.sendEvent(this.client, 'vaulted-' + constants.analyticsKinds[this.paymentMethod.type] + '.select');
	  }
	
	  this.model.changeActivePaymentMethod(this.paymentMethod);
	};
	
	PaymentMethodView.prototype._selectDelete = function () {
	  this.model.confirmPaymentMethodDeletion(this.paymentMethod);
	};
	
	module.exports = PaymentMethodView;
	
	},{"../constants":131,"../lib/add-selection-event-handler":135,"../lib/analytics":136,"./base-view":178,"@braintree/class-list":18}],182:[function(require,module,exports){
	'use strict';
	
	var BaseView = require('./base-view');
	var PaymentMethodView = require('./payment-method-view');
	var DropinError = require('../lib/dropin-error');
	var classList = require('@braintree/class-list');
	var errors = require('../constants').errors;
	var Promise = require('../lib/promise');
	var addSelectionEventHandler = require('../lib/add-selection-event-handler');
	
	var PAYMENT_METHOD_TYPE_TO_TRANSLATION_STRING = {
	  CreditCard: 'Card',
	  PayPalAccount: 'PayPal',
	  ApplePayCard: 'Apple Pay',
	  AndroidPayCard: 'Google Pay',
	  VenmoAccount: 'Venmo'
	};
	
	function PaymentMethodsView() {
	  BaseView.apply(this, arguments);
	
	  this._initialize();
	}
	
	PaymentMethodsView.prototype = Object.create(BaseView.prototype);
	PaymentMethodsView.prototype.constructor = PaymentMethodsView;
	PaymentMethodsView.ID = PaymentMethodsView.prototype.ID = 'methods';
	
	PaymentMethodsView.prototype._initialize = function () {
	  this.views = [];
	  this.container = this.getElementById('methods-container');
	  this._headingLabel = this.getElementById('methods-label');
	  this._editButton = this.getElementById('methods-edit');
	
	  this.model.on('addPaymentMethod', this._addPaymentMethod.bind(this));
	  this.model.on('changeActivePaymentMethod', this._changeActivePaymentMethodView.bind(this));
	  this.model.on('refreshPaymentMethods', this.refreshPaymentMethods.bind(this));
	
	  this.refreshPaymentMethods();
	
	  if (this.model.merchantConfiguration.vaultManager) {
	    this.model.on('removePaymentMethod', this._removePaymentMethod.bind(this));
	
	    addSelectionEventHandler(this._editButton, function () {
	      if (this.model.isInEditMode()) {
	        this.model.disableEditMode();
	      } else {
	        this.model.enableEditMode();
	      }
	    }.bind(this));
	
	    classList.remove(this._editButton, 'braintree-hidden');
	  }
	};
	
	PaymentMethodsView.prototype.removeActivePaymentMethod = function () {
	  if (!this.activeMethodView) {
	    return;
	  }
	  this.activeMethodView.setActive(false);
	  this.activeMethodView = null;
	  classList.add(this._headingLabel, 'braintree-no-payment-method-selected');
	};
	
	PaymentMethodsView.prototype._getPaymentMethodString = function () {
	  var stringKey, paymentMethodTypeString;
	
	  if (!this.activeMethodView) {
	    return '';
	  }
	
	  stringKey = PAYMENT_METHOD_TYPE_TO_TRANSLATION_STRING[this.activeMethodView.paymentMethod.type];
	  paymentMethodTypeString = this.strings[stringKey];
	
	  return this.strings.payingWith.replace('{{paymentSource}}', paymentMethodTypeString);
	};
	
	PaymentMethodsView.prototype.enableEditMode = function () {
	  classList.add(this.container, 'braintree-methods--edit');
	
	  this._editButton.innerHTML = this.strings.deleteCancelButton;
	  this._headingLabel.innerHTML = this.strings.editPaymentMethods;
	
	  this.views.forEach(function (view) {
	    view.enableEditMode();
	  });
	};
	
	PaymentMethodsView.prototype.disableEditMode = function () {
	  classList.remove(this.container, 'braintree-methods--edit');
	
	  this._editButton.innerHTML = this.strings.edit;
	  this._headingLabel.innerHTML = this._getPaymentMethodString();
	
	  this.views.forEach(function (view) {
	    view.disableEditMode();
	  });
	};
	
	PaymentMethodsView.prototype._addPaymentMethod = function (paymentMethod) {
	  var paymentMethodView = new PaymentMethodView({
	    model: this.model,
	    paymentMethod: paymentMethod,
	    client: this.client,
	    strings: this.strings
	  });
	
	  if (this.model.isGuestCheckout && this.container.firstChild) {
	    this.container.removeChild(this.container.firstChild);
	    this.views.pop();
	  }
	
	  if (this.container.firstChild) {
	    this.container.insertBefore(paymentMethodView.element, this.container.firstChild);
	  } else {
	    this.container.appendChild(paymentMethodView.element);
	  }
	
	  this.views.push(paymentMethodView);
	};
	
	PaymentMethodsView.prototype._removePaymentMethod = function (paymentMethod) {
	  var i;
	
	  for (i = 0; i < this.views.length; i++) {
	    if (this.views[i].paymentMethod === paymentMethod) {
	      this.container.removeChild(this.views[i].element);
	      this._headingLabel.innerHTML = '&nbsp;';
	      this.views.splice(i, 1);
	      break;
	    }
	  }
	};
	
	PaymentMethodsView.prototype._changeActivePaymentMethodView = function (paymentMethod) {
	  var i;
	  var previousActiveMethodView = this.activeMethodView;
	
	  for (i = 0; i < this.views.length; i++) {
	    if (this.views[i].paymentMethod === paymentMethod) {
	      this.activeMethodView = this.views[i];
	      this._headingLabel.innerHTML = this._getPaymentMethodString();
	      break;
	    }
	  }
	
	  if (previousActiveMethodView) {
	    previousActiveMethodView.setActive(false);
	  }
	  this.activeMethodView.setActive(true);
	  classList.remove(this._headingLabel, 'braintree-no-payment-method-selected');
	};
	
	PaymentMethodsView.prototype.requestPaymentMethod = function () {
	  if (!this.activeMethodView || this.model.isInEditMode()) {
	    return Promise.reject(new DropinError(errors.NO_PAYMENT_METHOD_ERROR));
	  }
	
	  return Promise.resolve(this.activeMethodView.paymentMethod);
	};
	
	PaymentMethodsView.prototype.refreshPaymentMethods = function () {
	  var i;
	  var paymentMethods = this.model.getPaymentMethods();
	
	  this.views.forEach(function (view) {
	    this.container.removeChild(view.element);
	  }.bind(this));
	
	  this.views = [];
	
	  for (i = paymentMethods.length - 1; i >= 0; i--) {
	    this._addPaymentMethod(paymentMethods[i]);
	  }
	};
	
	module.exports = PaymentMethodsView;
	
	},{"../constants":131,"../lib/add-selection-event-handler":135,"../lib/dropin-error":141,"../lib/promise":148,"./base-view":178,"./payment-method-view":181,"@braintree/class-list":18}],183:[function(require,module,exports){
	'use strict';
	
	var analytics = require('../lib/analytics');
	var addSelectionEventHandler = require('../lib/add-selection-event-handler');
	var BaseView = require('./base-view');
	
	var paymentOptionIDs = require('../constants').paymentOptionIDs;
	
	var paymentMethodOptionHTML = "<div class=\"braintree-option__logo\">\n  <svg width=\"48\" height=\"29\" class=\"@CLASSNAME\">\n    <use xlink:href=\"#@ICON\"></use>\n  </svg>\n</div>\n\n<div class=\"braintree-option__label\" aria-label=\"@OPTION_LABEL\">\n  @OPTION_TITLE\n  <div class=\"braintree-option__disabled-message\"></div>\n</div>\n";
	
	function PaymentOptionsView() {
	  BaseView.apply(this, arguments);
	
	  this._initialize();
	}
	
	PaymentOptionsView.prototype = Object.create(BaseView.prototype);
	PaymentOptionsView.prototype.constructor = PaymentOptionsView;
	PaymentOptionsView.ID = PaymentOptionsView.prototype.ID = 'options';
	
	PaymentOptionsView.prototype._initialize = function () {
	  this.container = this.getElementById('payment-options-container');
	  this.elements = {};
	
	  this.model.supportedPaymentOptions.forEach(function (paymentOptionID) {
	    this._addPaymentOption(paymentOptionID);
	  }.bind(this));
	};
	
	PaymentOptionsView.prototype._addPaymentOption = function (paymentOptionID) {
	  var paymentSource;
	  var div = document.createElement('div');
	  var html = paymentMethodOptionHTML;
	  var clickHandler = function clickHandler() {
	    this.mainView.setPrimaryView(paymentOptionID);
	    this.model.selectPaymentOption(paymentOptionID);
	    analytics.sendEvent(this.client, 'selected.' + paymentOptionIDs[paymentOptionID]);
	  }.bind(this);
	
	  div.className = 'braintree-option braintree-option__' + paymentOptionID;
	  div.setAttribute('tabindex', '0');
	
	  switch (paymentOptionID) {
	    case paymentOptionIDs.applePay:
	      paymentSource = this.strings['Apple Pay'];
	      html = html.replace(/@ICON/g, 'logoApplePay');
	      break;
	    case paymentOptionIDs.card:
	      paymentSource = this.strings.Card;
	      html = html.replace(/@ICON/g, 'iconCardFront');
	      html = html.replace(/@CLASSNAME/g, 'braintree-icon--bordered');
	      break;
	    case paymentOptionIDs.googlePay:
	      paymentSource = this.strings['Google Pay'];
	      html = html.replace(/@ICON/g, 'logoGooglePay');
	      break;
	    case paymentOptionIDs.paypal:
	      paymentSource = this.strings.PayPal;
	      html = html.replace(/@ICON/g, 'logoPayPal');
	      break;
	    case paymentOptionIDs.paypalCredit:
	      paymentSource = this.strings['PayPal Credit'];
	      html = html.replace(/@ICON/g, 'logoPayPalCredit');
	      break;
	    case paymentOptionIDs.venmo:
	      paymentSource = this.strings.Venmo;
	      html = html.replace(/@ICON/g, 'logoVenmo');
	      break;
	    default:
	      break;
	  }
	
	  html = html.replace(/@OPTION_LABEL/g, this._generateOptionLabel(paymentSource));
	  html = html.replace(/@OPTION_TITLE/g, paymentSource);
	  html = html.replace(/@CLASSNAME/g, '');
	
	  div.innerHTML = html;
	
	  addSelectionEventHandler(div, clickHandler);
	
	  this.container.appendChild(div);
	  this.elements[paymentOptionID] = {
	    div: div,
	    clickHandler: clickHandler
	  };
	};
	
	PaymentOptionsView.prototype._generateOptionLabel = function (paymentSourceString) {
	  return this.strings.payingWith.replace('{{paymentSource}}', paymentSourceString);
	};
	
	module.exports = PaymentOptionsView;
	
	},{"../constants":131,"../lib/add-selection-event-handler":135,"../lib/analytics":136,"./base-view":178}],184:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var assign = require('../../lib/assign').assign;
	var BaseView = require('../base-view');
	var btApplePay = require('braintree-web/apple-pay');
	var DropinError = require('../../lib/dropin-error');
	var isHTTPS = require('../../lib/is-https');
	var Promise = require('../../lib/promise');
	var paymentOptionIDs = require('../../constants').paymentOptionIDs;
	
	var DEFAULT_APPLE_PAY_SESSION_VERSION = 2;
	
	function ApplePayView() {
	  BaseView.apply(this, arguments);
	}
	
	ApplePayView.prototype = Object.create(BaseView.prototype);
	ApplePayView.prototype.constructor = ApplePayView;
	ApplePayView.ID = ApplePayView.prototype.ID = paymentOptionIDs.applePay;
	
	ApplePayView.prototype.initialize = function () {
	  var self = this;
	
	  self.applePayConfiguration = assign({}, self.model.merchantConfiguration.applePay);
	  self.applePaySessionVersion = self.applePayConfiguration.applePaySessionVersion || DEFAULT_APPLE_PAY_SESSION_VERSION;
	
	  delete self.applePayConfiguration.applePaySessionVersion;
	
	  self.model.asyncDependencyStarting();
	
	  return btApplePay.create({client: this.client}).then(function (applePayInstance) {
	    var buttonDiv = self.getElementById('apple-pay-button');
	
	    self.applePayInstance = applePayInstance;
	
	    self.model.on('changeActivePaymentView', function (paymentViewID) {
	      if (paymentViewID !== self.ID) {
	        return;
	      }
	
	      global.ApplePaySession.canMakePaymentsWithActiveCard(self.applePayInstance.merchantIdentifier).then(function (canMakePayments) {
	        if (!canMakePayments) {
	          self.model.reportError('applePayActiveCardError');
	        }
	      });
	    });
	
	    buttonDiv.onclick = self._showPaymentSheet.bind(self);
	    buttonDiv.style['-apple-pay-button-style'] = self.model.merchantConfiguration.applePay.buttonStyle || 'black';
	
	    self.model.asyncDependencyReady();
	  }).catch(function (err) {
	    self.model.asyncDependencyFailed({
	      view: self.ID,
	      error: new DropinError(err)
	    });
	  });
	};
	
	ApplePayView.prototype._showPaymentSheet = function () {
	  var self = this;
	  var request = self.applePayInstance.createPaymentRequest(this.applePayConfiguration.paymentRequest);
	  var session = new global.ApplePaySession(self.applePaySessionVersion, request);
	
	  session.onvalidatemerchant = function (event) {
	    self.applePayInstance.performValidation({
	      validationURL: event.validationURL,
	      displayName: self.applePayConfiguration.displayName
	    }).then(function (validationData) {
	      session.completeMerchantValidation(validationData);
	    }).catch(function (validationErr) {
	      self.model.reportError(validationErr);
	      session.abort();
	    });
	  };
	
	  session.onpaymentauthorized = function (event) {
	    self.applePayInstance.tokenize({
	      token: event.payment.token
	    }).then(function (payload) {
	      session.completePayment(global.ApplePaySession.STATUS_SUCCESS);
	      payload.rawPaymentData = event.payment;
	      self.model.addPaymentMethod(payload);
	    }).catch(function (tokenizeErr) {
	      self.model.reportError(tokenizeErr);
	      session.completePayment(global.ApplePaySession.STATUS_FAILURE);
	    });
	  };
	
	  session.begin();
	
	  return false;
	};
	
	ApplePayView.prototype.updateConfiguration = function (key, value) {
	  this.applePayConfiguration[key] = value;
	};
	
	ApplePayView.isEnabled = function (options) {
	  var gatewayConfiguration = options.client.getConfiguration().gatewayConfiguration;
	  var applePayEnabled = gatewayConfiguration.applePayWeb && Boolean(options.merchantConfiguration.applePay);
	  var applePaySessionVersion = options.merchantConfiguration.applePay && options.merchantConfiguration.applePay.applePaySessionVersion;
	  var applePayBrowserSupported;
	
	  applePaySessionVersion = applePaySessionVersion || DEFAULT_APPLE_PAY_SESSION_VERSION;
	
	  if (!applePayEnabled) {
	    return Promise.resolve(false);
	  }
	
	  applePayBrowserSupported = global.ApplePaySession && isHTTPS.isHTTPS();
	
	  if (!applePayBrowserSupported) {
	    return Promise.resolve(false);
	  }
	
	  if (!global.ApplePaySession.supportsVersion(applePaySessionVersion)) {
	    return Promise.resolve(false);
	  }
	
	  return Promise.resolve(Boolean(global.ApplePaySession.canMakePayments()));
	};
	
	module.exports = ApplePayView;
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../../constants":131,"../../lib/assign":137,"../../lib/dropin-error":141,"../../lib/is-https":144,"../../lib/promise":148,"../base-view":178,"braintree-web/apple-pay":30}],185:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var analytics = require('../../lib/analytics');
	var assign = require('../../lib/assign').assign;
	var browserDetection = require('../../lib/browser-detection');
	var BaseView = require('../base-view');
	var btPaypal = require('braintree-web/paypal-checkout');
	var DropinError = require('../../lib/dropin-error');
	var constants = require('../../constants');
	var assets = require('@braintree/asset-loader');
	var translations = require('../../translations').fiveCharacterLocales;
	var Promise = require('../../lib/promise');
	
	var ASYNC_DEPENDENCY_TIMEOUT = 30000;
	var READ_ONLY_CONFIGURATION_OPTIONS = ['offerCredit', 'locale'];
	var DEFAULT_CHECKOUTJS_LOG_LEVEL = 'warn';
	
	var paypalScriptLoadInProgressPromise;
	
	function BasePayPalView() {
	  BaseView.apply(this, arguments);
	}
	
	BasePayPalView.prototype = Object.create(BaseView.prototype);
	
	BasePayPalView.prototype.initialize = function () {
	  var asyncDependencyTimeoutHandler;
	  var isCredit = Boolean(this._isPayPalCredit);
	  var setupComplete = false;
	  var self = this;
	  var paypalType = isCredit ? 'paypalCredit' : 'paypal';
	  var paypalConfiguration = this.model.merchantConfiguration[paypalType];
	
	  this.paypalConfiguration = assign({}, paypalConfiguration);
	
	  this.model.asyncDependencyStarting();
	  asyncDependencyTimeoutHandler = setTimeout(function () {
	    self.model.asyncDependencyFailed({
	      view: self.ID,
	      error: new DropinError('There was an error connecting to PayPal.')
	    });
	  }, ASYNC_DEPENDENCY_TIMEOUT);
	
	  return btPaypal.create({client: this.client}).then(function (paypalInstance) {
	    var checkoutJSConfiguration;
	    var buttonSelector = '[data-braintree-id="paypal-button"]';
	    var environment = self.client.getConfiguration().gatewayConfiguration.environment === 'production' ? 'production' : 'sandbox';
	    var locale = self.model.merchantConfiguration.locale;
	
	    self.paypalInstance = paypalInstance;
	
	    self.paypalConfiguration.offerCredit = Boolean(isCredit);
	    checkoutJSConfiguration = {
	      env: environment,
	      style: self.paypalConfiguration.buttonStyle || {},
	      commit: self.paypalConfiguration.commit,
	      payment: function () {
	        return paypalInstance.createPayment(self.paypalConfiguration).catch(reportError);
	      },
	      onAuthorize: function (data) {
	        return paypalInstance.tokenizePayment(data).then(function (tokenizePayload) {
	          if (self.paypalConfiguration.flow === 'vault' && !self.model.isGuestCheckout) {
	            tokenizePayload.vaulted = true;
	          }
	          self.model.addPaymentMethod(tokenizePayload);
	        }).catch(reportError);
	      },
	      onError: reportError
	    };
	
	    if (locale && locale in translations) {
	      self.paypalConfiguration.locale = locale;
	      checkoutJSConfiguration.locale = locale;
	    }
	
	    if (isCredit) {
	      buttonSelector = '[data-braintree-id="paypal-credit-button"]';
	      checkoutJSConfiguration.style.label = 'credit';
	    } else {
	      checkoutJSConfiguration.funding = {
	        disallowed: [global.paypal.FUNDING.CREDIT]
	      };
	    }
	
	    return global.paypal.Button.render(checkoutJSConfiguration, buttonSelector).then(function () {
	      self.model.asyncDependencyReady();
	      setupComplete = true;
	      clearTimeout(asyncDependencyTimeoutHandler);
	    });
	  }).catch(reportError);
	
	  function reportError(err) {
	    if (setupComplete) {
	      self.model.reportError(err);
	    } else {
	      self.model.asyncDependencyFailed({
	        view: self.ID,
	        error: err
	      });
	      clearTimeout(asyncDependencyTimeoutHandler);
	    }
	  }
	};
	
	BasePayPalView.prototype.requestPaymentMethod = function () {
	  this.model.reportError('paypalButtonMustBeUsed');
	
	  return BaseView.prototype.requestPaymentMethod.call(this);
	};
	
	BasePayPalView.prototype.updateConfiguration = function (key, value) {
	  if (READ_ONLY_CONFIGURATION_OPTIONS.indexOf(key) === -1) {
	    this.paypalConfiguration[key] = value;
	  }
	};
	
	BasePayPalView.isEnabled = function (options) {
	  var gatewayConfiguration = options.client.getConfiguration().gatewayConfiguration;
	
	  if (!gatewayConfiguration.paypalEnabled) {
	    return Promise.resolve(false);
	  }
	
	  if (browserDetection.isIe9() || browserDetection.isIe10()) {
	    analytics.sendEvent(options.client, options.viewID + '.checkout.js-browser-not-supported');
	
	    return Promise.resolve(false);
	  }
	
	  if (global.paypal && global.paypal.Button) {
	    return Promise.resolve(true);
	  }
	
	  if (paypalScriptLoadInProgressPromise) {
	    return paypalScriptLoadInProgressPromise;
	  }
	
	  paypalScriptLoadInProgressPromise = assets.loadScript({
	    src: constants.CHECKOUT_JS_SOURCE,
	    id: constants.PAYPAL_CHECKOUT_SCRIPT_ID,
	    dataAttributes: {
	      'log-level': options.merchantConfiguration.paypal.logLevel || DEFAULT_CHECKOUTJS_LOG_LEVEL
	    }
	  }).then(function () {
	    return Promise.resolve(true);
	  }).catch(function () {
	    return Promise.resolve(false);
	  }).then(function (result) {
	    paypalScriptLoadInProgressPromise = null;
	
	    return Promise.resolve(result);
	  });
	
	  return paypalScriptLoadInProgressPromise;
	};
	
	module.exports = BasePayPalView;
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../../constants":131,"../../lib/analytics":136,"../../lib/assign":137,"../../lib/browser-detection":138,"../../lib/dropin-error":141,"../../lib/promise":148,"../../translations":163,"../base-view":178,"@braintree/asset-loader":1,"braintree-web/paypal-checkout":101}],186:[function(require,module,exports){
	'use strict';
	
	var assign = require('../../lib/assign').assign;
	
	var BaseView = require('../base-view');
	var classList = require('@braintree/class-list');
	var constants = require('../../constants');
	var DropinError = require('../../lib/dropin-error');
	var hostedFields = require('braintree-web/hosted-fields');
	var isUtf8 = require('../../lib/is-utf-8');
	var transitionHelper = require('../../lib/transition-helper');
	var Promise = require('../../lib/promise');
	
	var cardIconHTML = "<div data-braintree-id=\"visa-card-icon\" class=\"braintree-sheet__card-icon\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-visa\"></use>\n    </svg>\n</div>\n<div data-braintree-id=\"master-card-card-icon\" class=\"braintree-sheet__card-icon\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-master-card\"></use>\n    </svg>\n</div>\n<div data-braintree-id=\"unionpay-card-icon\" class=\"braintree-sheet__card-icon braintree-hidden\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-unionpay\"></use>\n    </svg>\n</div>\n<div data-braintree-id=\"american-express-card-icon\" class=\"braintree-sheet__card-icon\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-american-express\"></use>\n    </svg>\n</div>\n<div data-braintree-id=\"jcb-card-icon\" class=\"braintree-sheet__card-icon\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-jcb\"></use>\n    </svg>\n</div>\n<!-- Remove braintree-hidden class when supportedCardType accurately indicates Diners Club support -->\n<div data-braintree-id=\"diners-club-card-icon\" class=\"braintree-sheet__card-icon braintree-hidden\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-diners-club\"></use>\n    </svg>\n</div>\n<div data-braintree-id=\"discover-card-icon\" class=\"braintree-sheet__card-icon\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-discover\"></use>\n    </svg>\n</div>\n<div data-braintree-id=\"maestro-card-icon\" class=\"braintree-sheet__card-icon\">\n    <svg width=\"40\" height=\"24\">\n        <use xlink:href=\"#icon-maestro\"></use>\n    </svg>\n</div>\n";
	
	function CardView() {
	  BaseView.apply(this, arguments);
	}
	
	CardView.prototype = Object.create(BaseView.prototype);
	CardView.prototype.constructor = CardView;
	CardView.ID = CardView.prototype.ID = constants.paymentOptionIDs.card;
	
	CardView.prototype.initialize = function () {
	  var cvvFieldGroup, postalCodeFieldGroup, hfOptions;
	  var cardholderNameField = this.getElementById('cardholder-name-field-group');
	  var cardIcons = this.getElementById('card-view-icons');
	
	  this.merchantConfiguration = this.model.merchantConfiguration.card || {};
	  this.merchantConfiguration.vault = this.merchantConfiguration.vault || {};
	  hfOptions = this._generateHostedFieldsOptions();
	
	  cardIcons.innerHTML = cardIconHTML;
	  this._hideUnsupportedCardIcons();
	
	  this.hasCVV = hfOptions.fields.cvv;
	  this.hasCardholderName = Boolean(this.merchantConfiguration.cardholderName);
	  this.cardholderNameInput = cardholderNameField.querySelector('input');
	  this.saveCardInput = this.getElementById('save-card-input');
	  this.cardNumberIcon = this.getElementById('card-number-icon');
	  this.cardNumberIconSvg = this.getElementById('card-number-icon-svg');
	  this.cvvIcon = this.getElementById('cvv-icon');
	  this.cvvIconSvg = this.getElementById('cvv-icon-svg');
	  this.cvvLabelDescriptor = this.getElementById('cvv-label-descriptor');
	  this.fieldErrors = {};
	  this.extraInputs = [
	    {
	      fieldName: 'cardholderName',
	      enabled: this.hasCardholderName,
	      required: this.hasCardholderName && this.merchantConfiguration.cardholderName.required,
	      requiredError: this.strings.fieldEmptyForCardholderName,
	      validations: [
	        {
	          isValid: function (value) {
	            return value.length < 256;
	          },
	          error: this.strings.fieldTooLongForCardholderName
	        }
	      ]
	    }
	  ];
	
	  if (!this.hasCVV) {
	    cvvFieldGroup = this.getElementById('cvv-field-group');
	    cvvFieldGroup.parentNode.removeChild(cvvFieldGroup);
	  }
	
	  if (!hfOptions.fields.postalCode) {
	    postalCodeFieldGroup = this.getElementById('postal-code-field-group');
	    postalCodeFieldGroup.parentNode.removeChild(postalCodeFieldGroup);
	  }
	
	  this.extraInputs.forEach(function (extraInput) {
	    if (extraInput.enabled) {
	      this._setupExtraInput(extraInput);
	    } else {
	      this._removeExtraInput(extraInput);
	    }
	  }.bind(this));
	
	  if (!this.model.isGuestCheckout && this.merchantConfiguration.vault.allowVaultCardOverride === true) {
	    classList.remove(this.getElementById('save-card-field-group'), 'braintree-hidden');
	  }
	
	  if (this.merchantConfiguration.vault.vaultCard === false) {
	    this.saveCardInput.checked = false;
	  }
	
	  this.model.asyncDependencyStarting();
	
	  return hostedFields.create(hfOptions).then(function (hostedFieldsInstance) {
	    this.hostedFieldsInstance = hostedFieldsInstance;
	    this.hostedFieldsInstance.on('blur', this._onBlurEvent.bind(this));
	    this.hostedFieldsInstance.on('cardTypeChange', this._onCardTypeChangeEvent.bind(this));
	    this.hostedFieldsInstance.on('focus', this._onFocusEvent.bind(this));
	    this.hostedFieldsInstance.on('notEmpty', this._onNotEmptyEvent.bind(this));
	    this.hostedFieldsInstance.on('validityChange', this._onValidityChangeEvent.bind(this));
	
	    this.model.asyncDependencyReady();
	  }.bind(this)).catch(function (err) {
	    this.model.asyncDependencyFailed({
	      view: this.ID,
	      error: err
	    });
	  }.bind(this));
	};
	
	CardView.prototype._setupExtraInput = function (extraInput) {
	  var self = this;
	  var fieldNameKebab = camelCaseToKebabCase(extraInput.fieldName);
	  var field = this.getElementById(fieldNameKebab + '-field-group');
	  var input = field.querySelector('input');
	  var nameContainer = field.querySelector('.braintree-form__hosted-field');
	
	  input.addEventListener('keyup', function () {
	    var valid = self._validateExtraInput(extraInput, true);
	
	    classList.toggle(nameContainer, 'braintree-form__field--valid', valid);
	
	    if (valid) {
	      self.hideFieldError(extraInput.fieldName);
	    }
	
	    self._sendRequestableEvent();
	  }, false);
	
	  if (extraInput.required) {
	    input.addEventListener('blur', function () {
	      // the active element inside the blur event is the document.body
	      // by taking it out of the event loop, we can detect the new
	      // active element (hosted field or other card view element)
	      setTimeout(function () {
	        if (isCardViewElement()) {
	          self._validateExtraInput(extraInput, true);
	        }
	      }, 0);
	    }, false);
	  }
	};
	
	CardView.prototype._removeExtraInput = function (extraInput) {
	  var field = this.getElementById(camelCaseToKebabCase(extraInput.fieldName) + '-field-group');
	
	  field.parentNode.removeChild(field);
	};
	
	CardView.prototype._sendRequestableEvent = function () {
	  if (!this._isTokenizing) {
	    this.model.setPaymentMethodRequestable({
	      isRequestable: this._validateForm(),
	      type: constants.paymentMethodTypes.card
	    });
	  }
	};
	
	CardView.prototype._generateHostedFieldsOptions = function () {
	  var challenges = this.client.getConfiguration().gatewayConfiguration.challenges;
	  var hasCVVChallenge = challenges.indexOf('cvv') !== -1;
	  var hasPostalCodeChallenge = challenges.indexOf('postal_code') !== -1;
	  var overrides = this.merchantConfiguration.overrides;
	  var options = {
	    client: this.client,
	    fields: {
	      number: {
	        selector: this._generateFieldSelector('number'),
	        placeholder: generateCardNumberPlaceholder()
	      },
	      expirationDate: {
	        selector: this._generateFieldSelector('expiration'),
	        placeholder: this.strings.expirationDatePlaceholder
	      },
	      cvv: {
	        selector: this._generateFieldSelector('cvv'),
	        placeholder: addBullets(3)
	      },
	      postalCode: {
	        selector: this._generateFieldSelector('postal-code')
	      }
	    },
	    styles: {
	      input: {
	        'font-size': '16px',
	        'font-family': '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
	        color: '#000'
	      },
	      ':focus': {
	        color: 'black'
	      },
	      '::-webkit-input-placeholder': {
	        color: '#6a6a6a'
	      },
	      ':-moz-placeholder': {
	        color: '#6a6a6a'
	      },
	      '::-moz-placeholder': {
	        color: '#6a6a6a'
	      },
	      ':-ms-input-placeholder ': {
	        color: '#6a6a6a'
	      },
	      'input::-ms-clear': {
	        color: 'transparent'
	      }
	    }
	  };
	
	  if (!hasCVVChallenge) {
	    delete options.fields.cvv;
	  }
	
	  if (!hasPostalCodeChallenge) {
	    delete options.fields.postalCode;
	  }
	
	  if (!overrides) { return options; }
	
	  if (overrides.fields) {
	    if (overrides.fields.cvv && typeof overrides.fields.cvv.placeholder !== 'undefined') {
	      this._hasCustomCVVPlaceholder = true;
	    }
	
	    Object.keys(overrides.fields).forEach(function (field) {
	      if ((field === 'cvv' || field === 'postalCode') && overrides.fields[field] === null) {
	        delete options.fields[field];
	
	        return;
	      }
	
	      if (!options.fields[field]) {
	        return;
	      }
	
	      assign(options.fields[field], overrides.fields[field], {
	        selector: options.fields[field].selector
	      });
	    });
	  }
	
	  if (overrides.styles) {
	    Object.keys(overrides.styles).forEach(function (style) {
	      if (overrides.styles[style] === null) {
	        delete options.styles[style];
	
	        return;
	      }
	
	      normalizeStyles(overrides.styles[style]);
	      options.styles[style] = options.styles[style] || {};
	
	      assign(options.styles[style], overrides.styles[style]);
	    });
	  }
	
	  return options;
	};
	
	CardView.prototype._validateForm = function (showFieldErrors) {
	  var cardType, cardTypeSupported, state;
	  var isValid = true;
	  var supportedCardTypes = this.client.getConfiguration().gatewayConfiguration.creditCards.supportedCardTypes;
	
	  if (!this.hostedFieldsInstance) {
	    return false;
	  }
	
	  state = this.hostedFieldsInstance.getState();
	
	  Object.keys(state.fields).forEach(function (key) {
	    var field = state.fields[key];
	
	    if (!showFieldErrors && !isValid) {
	      // return early if form is already invalid
	      // and we don't need to display all field errors
	      return;
	    }
	
	    if (field.isEmpty) {
	      isValid = false;
	
	      if (showFieldErrors) {
	        this.showFieldError(key, this.strings['fieldEmptyFor' + capitalize(key)]);
	      }
	    } else if (!field.isValid) {
	      isValid = false;
	
	      if (showFieldErrors) {
	        this.showFieldError(key, this.strings['fieldInvalidFor' + capitalize(key)]);
	      }
	    }
	  }.bind(this));
	
	  if (state.fields.number.isValid) {
	    cardType = constants.configurationCardTypes[state.cards[0].type];
	    cardTypeSupported = supportedCardTypes.indexOf(cardType) !== -1;
	
	    if (!cardTypeSupported) {
	      isValid = false;
	
	      if (showFieldErrors) {
	        this.showFieldError('number', this.strings.unsupportedCardTypeError);
	      }
	    }
	  }
	
	  if (this.extraInputs) {
	    this.extraInputs.forEach(function (extraInput) {
	      var fieldIsValid;
	
	      if (!extraInput.enabled) {
	        return;
	      }
	
	      fieldIsValid = this._validateExtraInput(extraInput, showFieldErrors);
	
	      isValid = isValid && fieldIsValid;
	    }.bind(this));
	  }
	
	  return isValid;
	};
	
	CardView.prototype._validateExtraInput = function (extraInput, showFieldError) {
	  var fieldNameKebab = camelCaseToKebabCase(extraInput.fieldName);
	  var field = this.getElementById(fieldNameKebab + '-field-group');
	  var input = field.querySelector('input');
	  var valid = true;
	
	  if (extraInput.required) {
	    valid = input.value.length > 0;
	
	    if (!valid && showFieldError) {
	      this.showFieldError(extraInput.fieldName, extraInput.requiredError);
	    }
	  }
	
	  extraInput.validations.forEach(function (validation) {
	    var validationPassed = validation.isValid(input.value);
	
	    if (!validationPassed && showFieldError) {
	      this.showFieldError(extraInput.fieldName, validation.error);
	    }
	
	    valid = valid && validationPassed;
	  }.bind(this));
	
	  return valid;
	};
	
	CardView.prototype.getPaymentMethod = function () { // eslint-disable-line consistent-return
	  var formIsValid = this._validateForm();
	
	  if (formIsValid) {
	    return {
	      type: constants.paymentMethodTypes.card
	    };
	  }
	};
	
	CardView.prototype.tokenize = function () {
	  var transitionCallback;
	  var self = this;
	  var state = self.hostedFieldsInstance.getState();
	  var tokenizeOptions = {
	    vault: this._shouldVault()
	  };
	
	  this.model.clearError();
	
	  if (!this._validateForm(true)) {
	    self.model.reportError('hostedFieldsFieldsInvalidError');
	    self.allowUserAction();
	
	    return Promise.reject(new DropinError(constants.errors.NO_PAYMENT_METHOD_ERROR));
	  }
	
	  if (this.hasCardholderName) {
	    tokenizeOptions.cardholderName = this.cardholderNameInput.value;
	  }
	
	  self._isTokenizing = true;
	
	  return self.hostedFieldsInstance.tokenize(tokenizeOptions).then(function (payload) {
	    var retainCardFields = self.merchantConfiguration.clearFieldsAfterTokenization === false;
	
	    if (!retainCardFields) {
	      Object.keys(state.fields).forEach(function (field) {
	        self.hostedFieldsInstance.clear(field);
	      });
	
	      if (self.hasCardholderName) {
	        self.cardholderNameInput.value = '';
	      }
	    }
	
	    if (self._shouldVault()) {
	      payload.vaulted = true;
	    }
	
	    return new Promise(function (resolve) {
	      transitionCallback = function () {
	        // Wait for braintree-sheet--tokenized class to be added in IE 9
	        // before attempting to remove it
	        setTimeout(function () {
	          self.model.addPaymentMethod(payload);
	          resolve(payload);
	          classList.remove(self.element, 'braintree-sheet--tokenized');
	        }, 0);
	      };
	
	      transitionHelper.onTransitionEnd(self.element, 'max-height', transitionCallback);
	
	      setTimeout(function () {
	        self.allowUserAction();
	        self._isTokenizing = false;
	      }, constants.CHANGE_ACTIVE_PAYMENT_METHOD_TIMEOUT);
	
	      classList.add(self.element, 'braintree-sheet--tokenized');
	    });
	  }).catch(function (err) {
	    self._isTokenizing = false;
	    // this is a little magical, but if the code property exists
	    // in the translations with the word Error appended to the end,
	    // then reportError will automatically print that translation.
	    // See https://github.com/braintree/braintree-web-drop-in/blob/6ecba73f2f16e8b7ae2119702ac162a1a985908e/src/views/main-view.js#L255-L256
	    self.model.reportError(err);
	    self.allowUserAction();
	
	    return Promise.reject(new DropinError({
	      message: constants.errors.NO_PAYMENT_METHOD_ERROR,
	      braintreeWebError: err
	    }));
	  });
	};
	
	CardView.prototype.showFieldError = function (field, errorMessage) {
	  var fieldError;
	  var fieldGroup = this.getElementById(camelCaseToKebabCase(field) + '-field-group');
	  var input = fieldGroup.querySelector('input');
	
	  if (!this.fieldErrors.hasOwnProperty(field)) {
	    this.fieldErrors[field] = this.getElementById(camelCaseToKebabCase(field) + '-field-error');
	  }
	
	  classList.add(fieldGroup, 'braintree-form__field-group--has-error');
	
	  fieldError = this.fieldErrors[field];
	  fieldError.innerHTML = errorMessage;
	
	  if (input && isNormalFieldElement(input)) {
	    input.setAttribute('aria-invalid', true);
	  } else {
	    this.hostedFieldsInstance.setAttribute({
	      field: field,
	      attribute: 'aria-invalid',
	      value: true
	    });
	    this.hostedFieldsInstance.setMessage({
	      field: field,
	      message: errorMessage
	    });
	  }
	};
	
	CardView.prototype.hideFieldError = function (field) {
	  var fieldGroup = this.getElementById(camelCaseToKebabCase(field) + '-field-group');
	  var input = fieldGroup.querySelector('input');
	
	  if (!this.fieldErrors.hasOwnProperty(field)) {
	    this.fieldErrors[field] = this.getElementById(camelCaseToKebabCase(field) + '-field-error');
	  }
	
	  classList.remove(fieldGroup, 'braintree-form__field-group--has-error');
	
	  if (input && isNormalFieldElement(input)) {
	    input.removeAttribute('aria-invalid');
	  } else {
	    this.hostedFieldsInstance.removeAttribute({
	      field: field,
	      attribute: 'aria-invalid'
	    });
	    this.hostedFieldsInstance.setMessage({
	      field: field,
	      message: ''
	    });
	  }
	};
	
	CardView.prototype.teardown = function () {
	  return this.hostedFieldsInstance.teardown();
	};
	
	CardView.prototype._shouldVault = function () {
	  return !this.model.isGuestCheckout && this.saveCardInput.checked;
	};
	
	CardView.prototype._generateFieldSelector = function (field) {
	  return '#braintree--dropin__' + this.model.componentID + ' .braintree-form-' + field;
	};
	
	CardView.prototype._onBlurEvent = function (event) {
	  var field = event.fields[event.emittedBy];
	  var fieldGroup = this.getElementById(camelCaseToKebabCase(event.emittedBy) + '-field-group');
	
	  classList.remove(fieldGroup, 'braintree-form__field-group--is-focused');
	
	  if (shouldApplyFieldEmptyError(field)) {
	    this.showFieldError(event.emittedBy, this.strings['fieldEmptyFor' + capitalize(event.emittedBy)]);
	  } else if (!field.isEmpty && !field.isValid) {
	    this.showFieldError(event.emittedBy, this.strings['fieldInvalidFor' + capitalize(event.emittedBy)]);
	  } else if (event.emittedBy === 'number' && !this._isCardTypeSupported(event.cards[0].type)) {
	    this.showFieldError('number', this.strings.unsupportedCardTypeError);
	  }
	
	  setTimeout(function () {
	    // when focusing on a field by clicking the label,
	    // we need to wait a bit for the iframe to be
	    // focused properly before applying validations
	    if (shouldApplyFieldEmptyError(field)) {
	      this.showFieldError(event.emittedBy, this.strings['fieldEmptyFor' + capitalize(event.emittedBy)]);
	    }
	  }.bind(this), 150);
	};
	
	CardView.prototype._onCardTypeChangeEvent = function (event) {
	  var cardType;
	  var cardNumberHrefLink = '#iconCardFront';
	  var cvvHrefLink = '#iconCVVBack';
	  var cvvDescriptor = this.strings.cvvThreeDigitLabelSubheading;
	  var cvvPlaceholder = addBullets(3);
	  var numberFieldGroup = this.getElementById('number-field-group');
	
	  if (event.cards.length === 1) {
	    cardType = event.cards[0].type;
	    cardNumberHrefLink = '#icon-' + cardType;
	    if (cardType === 'american-express') {
	      cvvHrefLink = '#iconCVVFront';
	      cvvDescriptor = this.strings.cvvFourDigitLabelSubheading;
	      cvvPlaceholder = addBullets(4);
	    }
	    // Keep icon visible when field is not focused
	    classList.add(numberFieldGroup, 'braintree-form__field-group--card-type-known');
	  } else {
	    classList.remove(numberFieldGroup, 'braintree-form__field-group--card-type-known');
	  }
	
	  this.cardNumberIconSvg.setAttribute('xlink:href', cardNumberHrefLink);
	
	  if (this.hasCVV) {
	    this.cvvIconSvg.setAttribute('xlink:href', cvvHrefLink);
	    this.cvvLabelDescriptor.innerHTML = cvvDescriptor;
	
	    if (!this._hasCustomCVVPlaceholder) {
	      this.hostedFieldsInstance.setAttribute({
	        field: 'cvv',
	        attribute: 'placeholder',
	        value: cvvPlaceholder
	      });
	    }
	  }
	};
	
	CardView.prototype._onFocusEvent = function (event) {
	  var fieldGroup = this.getElementById(camelCaseToKebabCase(event.emittedBy) + '-field-group');
	
	  classList.add(fieldGroup, 'braintree-form__field-group--is-focused');
	};
	
	CardView.prototype._onNotEmptyEvent = function (event) {
	  this.hideFieldError(event.emittedBy);
	};
	
	CardView.prototype._onValidityChangeEvent = function (event) {
	  var isValid;
	  var field = event.fields[event.emittedBy];
	
	  if (event.emittedBy === 'number' && event.cards[0]) {
	    isValid = field.isValid && this._isCardTypeSupported(event.cards[0].type);
	  } else {
	    isValid = field.isValid;
	  }
	
	  classList.toggle(field.container, 'braintree-form__field--valid', isValid);
	
	  if (field.isPotentiallyValid) {
	    this.hideFieldError(event.emittedBy);
	  }
	
	  this._sendRequestableEvent();
	};
	
	CardView.prototype.requestPaymentMethod = function () {
	  this.preventUserAction();
	
	  return this.tokenize();
	};
	
	CardView.prototype.onSelection = function () {
	  if (!this.hostedFieldsInstance) {
	    return;
	  }
	
	  if (this.hasCardholderName) {
	    setTimeout(function () { // wait until input is visible
	      this.cardholderNameInput.focus();
	    }.bind(this), 1);
	  } else {
	    this.hostedFieldsInstance.focus('number');
	  }
	};
	
	CardView.prototype._hideUnsupportedCardIcons = function () {
	  var supportedCardTypes = this.client.getConfiguration().gatewayConfiguration.creditCards.supportedCardTypes;
	
	  Object.keys(constants.configurationCardTypes).forEach(function (paymentMethodCardType) {
	    var cardIcon;
	    var configurationCardType = constants.configurationCardTypes[paymentMethodCardType];
	
	    if (supportedCardTypes.indexOf(configurationCardType) === -1) {
	      cardIcon = this.getElementById(paymentMethodCardType + '-card-icon');
	      classList.add(cardIcon, 'braintree-hidden');
	    }
	  }.bind(this));
	};
	
	CardView.prototype._isCardTypeSupported = function (cardType) {
	  var configurationCardType = constants.configurationCardTypes[cardType];
	  var supportedCardTypes = this.client.getConfiguration().gatewayConfiguration.creditCards.supportedCardTypes;
	
	  return supportedCardTypes.indexOf(configurationCardType) !== -1;
	};
	
	CardView.isEnabled = function (options) {
	  var gatewayConfiguration = options.client.getConfiguration().gatewayConfiguration;
	  var disabledByMerchant = options.merchantConfiguration.card === false;
	
	  return Promise.resolve(!disabledByMerchant && gatewayConfiguration.creditCards.supportedCardTypes.length > 0);
	};
	
	function isNormalFieldElement(element) {
	  return element.id.indexOf('braintree__card-view-input') !== -1;
	}
	
	function shouldApplyFieldEmptyError(field) {
	  return field.isEmpty && isCardViewElement();
	}
	
	function isCardViewElement() {
	  var activeId = document.activeElement && document.activeElement.id;
	  var isHostedFieldsElement = document.activeElement instanceof HTMLIFrameElement && activeId.indexOf('braintree-hosted-field') !== -1;
	
	  return isHostedFieldsElement || isNormalFieldElement(document.activeElement);
	}
	
	function camelCaseToKebabCase(string) {
	  return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	
	function capitalize(string) {
	  return string[0].toUpperCase() + string.substr(1);
	}
	
	function normalizeStyles(styles) {
	  Object.keys(styles).forEach(function (style) {
	    var transformedKeyName = camelCaseToKebabCase(style);
	
	    styles[transformedKeyName] = styles[style];
	  });
	}
	
	function addBullets(number) {
	  var bulletCharacter = isUtf8() ? '•' : '*';
	
	  return Array(number + 1).join(bulletCharacter);
	}
	
	function generateCardNumberPlaceholder() {
	  var four = addBullets(4);
	
	  return [four, four, four, four].join(' ');
	}
	
	module.exports = CardView;
	
	},{"../../constants":131,"../../lib/assign":137,"../../lib/dropin-error":141,"../../lib/is-utf-8":145,"../../lib/promise":148,"../../lib/transition-helper":152,"../base-view":178,"@braintree/class-list":18,"braintree-web/hosted-fields":61}],187:[function(require,module,exports){
	(function (global){
	'use strict';
	
	var assign = require('../../lib/assign').assign;
	var BaseView = require('../base-view');
	var btGooglePay = require('braintree-web/google-payment');
	var DropinError = require('../../lib/dropin-error');
	var constants = require('../../constants');
	var assets = require('@braintree/asset-loader');
	var Promise = require('../../lib/promise');
	var analytics = require('../../lib/analytics');
	
	function GooglePayView() {
	  BaseView.apply(this, arguments);
	}
	
	GooglePayView.prototype = Object.create(BaseView.prototype);
	GooglePayView.prototype.constructor = GooglePayView;
	GooglePayView.ID = GooglePayView.prototype.ID = constants.paymentOptionIDs.googlePay;
	
	GooglePayView.prototype.initialize = function () {
	  var self = this;
	  var buttonOptions, googlePayVersion, merchantId;
	
	  self.googlePayConfiguration = assign({}, self.model.merchantConfiguration.googlePay);
	  googlePayVersion = self.googlePayConfiguration.googlePayVersion;
	  merchantId = self.googlePayConfiguration.merchantId;
	
	  delete self.googlePayConfiguration.googlePayVersion;
	  delete self.googlePayConfiguration.merchantId;
	
	  buttonOptions = assign({
	    buttonType: 'short'
	  }, self.googlePayConfiguration.button, {
	    onClick: function (event) {
	      event.preventDefault();
	
	      self.preventUserAction();
	
	      self.tokenize().then(function () {
	        self.allowUserAction();
	      });
	    }
	  });
	
	  self.model.asyncDependencyStarting();
	
	  return btGooglePay.create({
	    client: self.client,
	    googlePayVersion: googlePayVersion,
	    googleMerchantId: merchantId
	  }).then(function (googlePayInstance) {
	    self.googlePayInstance = googlePayInstance;
	    self.paymentsClient = createPaymentsClient(self.client);
	  }).then(function () {
	    var buttonContainer = self.getElementById('google-pay-button');
	
	    buttonContainer.appendChild(self.paymentsClient.createButton(buttonOptions));
	
	    self.model.asyncDependencyReady();
	  }).catch(function (err) {
	    self.model.asyncDependencyFailed({
	      view: self.ID,
	      error: new DropinError(err)
	    });
	  });
	};
	
	GooglePayView.prototype.tokenize = function () {
	  var self = this;
	  var paymentDataRequest = self.googlePayInstance.createPaymentDataRequest(self.googlePayConfiguration);
	  var rawPaymentData;
	
	  return self.paymentsClient.loadPaymentData(paymentDataRequest).then(function (paymentData) {
	    rawPaymentData = paymentData;
	
	    return self.googlePayInstance.parseResponse(paymentData);
	  }).then(function (tokenizePayload) {
	    tokenizePayload.rawPaymentData = rawPaymentData;
	    self.model.addPaymentMethod(tokenizePayload);
	  }).catch(function (err) {
	    var reportedError = err;
	
	    if (err.statusCode === 'DEVELOPER_ERROR') {
	      console.error(err); // eslint-disable-line no-console
	      reportedError = 'developerError';
	    } else if (err.statusCode === 'CANCELED') {
	      analytics.sendEvent(self.client, 'googlepay.loadPaymentData.canceled');
	
	      return;
	    } else if (err.statusCode) {
	      analytics.sendEvent(self.client, 'googlepay.loadPaymentData.failed');
	    }
	
	    self.model.reportError(reportedError);
	  });
	};
	
	GooglePayView.prototype.updateConfiguration = function (key, value) {
	  this.googlePayConfiguration[key] = value;
	};
	
	GooglePayView.isEnabled = function (options) {
	  var gatewayConfiguration = options.client.getConfiguration().gatewayConfiguration;
	
	  if (!(gatewayConfiguration.androidPay && Boolean(options.merchantConfiguration.googlePay))) {
	    return Promise.resolve(false);
	  }
	
	  return Promise.resolve().then(function () {
	    if (!(global.google && global.google.payments && global.google.payments.api && global.google.payments.api.PaymentsClient)) {
	      return assets.loadScript({
	        id: constants.GOOGLE_PAYMENT_SCRIPT_ID,
	        src: constants.GOOGLE_PAYMENT_SOURCE
	      });
	    }
	
	    return Promise.resolve();
	  }).then(function () {
	    var paymentsClient = createPaymentsClient(options.client);
	
	    return paymentsClient.isReadyToPay({
	      allowedPaymentMethods: ['CARD', 'TOKENIZED_CARD']
	    });
	  }).then(function (response) {
	    return Boolean(response.result);
	  });
	};
	
	function createPaymentsClient(client) {
	  return new global.google.payments.api.PaymentsClient({
	    environment: client.getConfiguration().gatewayConfiguration.environment === 'production' ? 'PRODUCTION' : 'TEST'
	  });
	}
	
	module.exports = GooglePayView;
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"../../constants":131,"../../lib/analytics":136,"../../lib/assign":137,"../../lib/dropin-error":141,"../../lib/promise":148,"../base-view":178,"@braintree/asset-loader":1,"braintree-web/google-payment":55}],188:[function(require,module,exports){
	'use strict';
	
	var paymentOptionIDs = require('../../constants').paymentOptionIDs;
	
	var result = {};
	
	result[paymentOptionIDs.applePay] = require('./apple-pay-view');
	result[paymentOptionIDs.card] = require('./card-view');
	result[paymentOptionIDs.googlePay] = require('./google-pay-view');
	result[paymentOptionIDs.paypal] = require('./paypal-view');
	result[paymentOptionIDs.paypalCredit] = require('./paypal-credit-view');
	result[paymentOptionIDs.venmo] = require('./venmo-view');
	
	module.exports = result;
	
	},{"../../constants":131,"./apple-pay-view":184,"./card-view":186,"./google-pay-view":187,"./paypal-credit-view":189,"./paypal-view":190,"./venmo-view":191}],189:[function(require,module,exports){
	'use strict';
	
	var assign = require('../../lib/assign').assign;
	var Promise = require('../../lib/promise');
	var paymentOptionIDs = require('../../constants').paymentOptionIDs;
	var BasePayPalView = require('./base-paypal-view');
	
	function PayPalCreditView() {
	  BasePayPalView.apply(this, arguments);
	
	  this._isPayPalCredit = true;
	}
	
	PayPalCreditView.prototype = Object.create(BasePayPalView.prototype);
	PayPalCreditView.prototype.constructor = PayPalCreditView;
	PayPalCreditView.ID = PayPalCreditView.prototype.ID = paymentOptionIDs.paypalCredit;
	
	PayPalCreditView.isEnabled = function (options) {
	  if (!options.merchantConfiguration.paypalCredit) {
	    return Promise.resolve(false);
	  }
	
	  return BasePayPalView.isEnabled(assign({
	    viewID: PayPalCreditView.ID
	  }, options));
	};
	module.exports = PayPalCreditView;
	
	},{"../../constants":131,"../../lib/assign":137,"../../lib/promise":148,"./base-paypal-view":185}],190:[function(require,module,exports){
	'use strict';
	
	var assign = require('../../lib/assign').assign;
	var Promise = require('../../lib/promise');
	var paymentOptionIDs = require('../../constants').paymentOptionIDs;
	var BasePayPalView = require('./base-paypal-view');
	
	function PayPalView() {
	  BasePayPalView.apply(this, arguments);
	}
	
	PayPalView.prototype = Object.create(BasePayPalView.prototype);
	PayPalView.prototype.constructor = PayPalView;
	PayPalView.ID = PayPalView.prototype.ID = paymentOptionIDs.paypal;
	
	PayPalView.isEnabled = function (options) {
	  if (!options.merchantConfiguration.paypal) {
	    return Promise.resolve(false);
	  }
	
	  return BasePayPalView.isEnabled(assign({
	    viewID: PayPalView.ID
	  }, options));
	};
	
	module.exports = PayPalView;
	
	},{"../../constants":131,"../../lib/assign":137,"../../lib/promise":148,"./base-paypal-view":185}],191:[function(require,module,exports){
	'use strict';
	
	var assign = require('../../lib/assign').assign;
	var BaseView = require('../base-view');
	var btVenmo = require('braintree-web/venmo');
	var DropinError = require('../../lib/dropin-error');
	var Promise = require('../../lib/promise');
	var paymentOptionIDs = require('../../constants').paymentOptionIDs;
	
	function VenmoView() {
	  BaseView.apply(this, arguments);
	}
	
	VenmoView.prototype = Object.create(BaseView.prototype);
	VenmoView.prototype.constructor = VenmoView;
	VenmoView.ID = VenmoView.prototype.ID = paymentOptionIDs.venmo;
	
	VenmoView.prototype.initialize = function () {
	  var self = this;
	  var venmoConfiguration = assign({}, self.model.merchantConfiguration.venmo, {client: this.client});
	
	  self.model.asyncDependencyStarting();
	
	  return btVenmo.create(venmoConfiguration).then(function (venmoInstance) {
	    self.venmoInstance = venmoInstance;
	
	    if (!self.venmoInstance.hasTokenizationResult()) {
	      return Promise.resolve();
	    }
	
	    return self.venmoInstance.tokenize().then(function (payload) {
	      self.model.reportAppSwitchPayload(payload);
	    }).catch(function (err) {
	      if (self._isIgnorableError(err)) {
	        return;
	      }
	      self.model.reportAppSwitchError(paymentOptionIDs.venmo, err);
	    });
	  }).then(function () {
	    var button = self.getElementById('venmo-button');
	
	    button.addEventListener('click', function (event) {
	      event.preventDefault();
	
	      self.preventUserAction();
	
	      return self.venmoInstance.tokenize().then(function (payload) {
	        self.model.addPaymentMethod(payload);
	      }).catch(function (tokenizeErr) {
	        if (self._isIgnorableError(tokenizeErr)) {
	          return;
	        }
	
	        self.model.reportError(tokenizeErr);
	      }).then(function () {
	        self.allowUserAction();
	      });
	    });
	
	    self.model.asyncDependencyReady();
	  }).catch(function (err) {
	    self.model.asyncDependencyFailed({
	      view: self.ID,
	      error: new DropinError(err)
	    });
	  });
	};
	
	VenmoView.prototype._isIgnorableError = function (error) {
	  // customer cancels the flow in the app
	  // we don't emit an error because the customer
	  // initiated that action
	  return error.code === 'VENMO_APP_CANCELED';
	};
	
	VenmoView.isEnabled = function (options) {
	  var gatewayConfiguration = options.client.getConfiguration().gatewayConfiguration;
	  var venmoEnabled = gatewayConfiguration.payWithVenmo && Boolean(options.merchantConfiguration.venmo);
	
	  if (!venmoEnabled) {
	    return Promise.resolve(false);
	  }
	
	  return Promise.resolve(btVenmo.isBrowserSupported(options.merchantConfiguration.venmo));
	};
	
	module.exports = VenmoView;
	
	},{"../../constants":131,"../../lib/assign":137,"../../lib/dropin-error":141,"../../lib/promise":148,"../base-view":178,"braintree-web/venmo":112}]},{},[134])(134)
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1410 */
/***/ function(module, exports) {

	function createBroadcast (initialState) {
	  var listeners = {};
	  var id = 1;
	  var _state = initialState;
	
	  function getState () {
	    return _state
	  }
	
	  function setState (state) {
	    _state = state;
	    var keys = Object.keys(listeners);
	    var i = 0;
	    var len = keys.length;
	    for (; i < len; i++) {
	      // if a listener gets unsubscribed during setState we just skip it
	      if (listeners[keys[i]]) { listeners[keys[i]](state); }
	    }
	  }
	
	  // subscribe to changes and return the subscriptionId
	  function subscribe (listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('listener must be a function.')
	    }
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    return currentId
	  }
	
	  // remove subscription by removing the listener function
	  function unsubscribe (id) {
	    listeners[id] = undefined;
	  }
	
	  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
	}
	
	module.exports = createBroadcast;


/***/ },
/* 1411 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 1412 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var emptyObject = __webpack_require__(137);
	var _invariant = __webpack_require__(14);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 1414 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = camelize;
	var regExp = /[-\s]+(.)?/g;
	
	/**
	 * Convert dash separated strings to camel cased.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;
	
	var _prefix = __webpack_require__(306);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _supportedProperty = __webpack_require__(1416);
	
	var _supportedProperty2 = _interopRequireDefault(_supportedProperty);
	
	var _supportedValue = __webpack_require__(1417);
	
	var _supportedValue2 = _interopRequireDefault(_supportedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  prefix: _prefix2['default'],
	  supportedProperty: _supportedProperty2['default'],
	  supportedValue: _supportedValue2['default']
	}; /**
	    * CSS Vendor prefix detection and property feature testing.
	    *
	    * @copyright Oleg Slobodskoi 2015
	    * @website https://github.com/jsstyles/css-vendor
	    * @license MIT
	    */
	
	exports.prefix = _prefix2['default'];
	exports.supportedProperty = _supportedProperty2['default'];
	exports.supportedValue = _supportedValue2['default'];

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = supportedProperty;
	
	var _isInBrowser = __webpack_require__(205);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _prefix = __webpack_require__(306);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _camelize = __webpack_require__(1414);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var el = void 0;
	var cache = {};
	
	if (_isInBrowser2['default']) {
	  el = document.createElement('p');
	
	  /**
	   * We test every property on vendor prefix requirement.
	   * Once tested, result is cached. It gives us up to 70% perf boost.
	   * http://jsperf.com/element-style-object-access-vs-plain-object
	   *
	   * Prefill cache with known css properties to reduce amount of
	   * properties we need to feature test at runtime.
	   * http://davidwalsh.name/vendor-prefix
	   */
	  var computed = window.getComputedStyle(document.documentElement, '');
	  for (var key in computed) {
	    if (!isNaN(key)) cache[computed[key]] = computed[key];
	  }
	}
	
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @return {String|Boolean}
	 * @api public
	 */
	function supportedProperty(prop) {
	  // For server-side rendering.
	  if (!el) return prop;
	
	  // We have not tested this prop yet, lets do the test.
	  if (cache[prop] != null) return cache[prop];
	
	  // Camelization is required because we can't test using
	  // css syntax for e.g. in FF.
	  // Test if property is supported as it is.
	  if ((0, _camelize2['default'])(prop) in el.style) {
	    cache[prop] = prop;
	  }
	  // Test if property is supported with vendor prefix.
	  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
	      cache[prop] = _prefix2['default'].css + prop;
	    } else {
	      cache[prop] = false;
	    }
	
	  return cache[prop];
	}

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = supportedValue;
	
	var _isInBrowser = __webpack_require__(205);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _prefix = __webpack_require__(306);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var cache = {};
	var el = void 0;
	
	if (_isInBrowser2['default']) el = document.createElement('p');
	
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	function supportedValue(property, value) {
	  // For server-side rendering.
	  if (!el) return value;
	
	  // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;
	
	  var cacheKey = property + value;
	
	  if (cache[cacheKey] != null) return cache[cacheKey];
	
	  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
	  try {
	    // Test value as it is.
	    el.style[property] = value;
	  } catch (err) {
	    cache[cacheKey] = false;
	    return false;
	  }
	
	  // Value is supported as it is.
	  if (el.style[property] !== '') {
	    cache[cacheKey] = value;
	  } else {
	    // Test value with vendor prefix.
	    value = _prefix2['default'].css + value;
	
	    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	    if (value === '-ms-flex') value = '-ms-flexbox';
	
	    el.style[property] = value;
	
	    // Value is supported with vendor prefix.
	    if (el.style[property] !== '') cache[cacheKey] = value;
	  }
	
	  if (!cache[cacheKey]) cache[cacheKey] = false;
	
	  // Reset style value.
	  el.style[property] = '';
	
	  return cache[cacheKey];
	}

/***/ },
/* 1418 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(505));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(505));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1421 */
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1424);
	var each = __webpack_require__(506).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1422);
	var Util = __webpack_require__(506);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 1424 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1423);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.8+1e68dce6
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    var then$$1 = void 0;
	    try {
	      then$$1 = value.then;
	    } catch (error) {
	      reject(promise, error);
	      return;
	    }
	    handleMaybeThenable(promise, value, then$$1);
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = true;
	
	  if (hasCallback) {
	    try {
	      value = callback(detail);
	    } catch (e) {
	      succeeded = false;
	      error = e;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (succeeded === false) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = void 0;
	      var error = void 0;
	      var didError = false;
	      try {
	        _then = entry.then;
	      } catch (e) {
	        didError = true;
	        error = e;
	      }
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        if (didError) {
	          reject(promise, error);
	        } else {
	          handleMaybeThenable(promise, entry, _then);
	        }
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    if (isFunction(callback)) {
	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      });
	    }
	
	    return promise.then(callback, callback);
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), (function() { return this; }())))

/***/ },
/* 1427 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"react-datepicker__month--selecting-range":"react-datepicker-cssmodules__react-datepicker__month--selecting-range___Bpx6w"};

/***/ },
/* 1428 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rh5v-DefaultPlayer_component":"styles__rh5v-DefaultPlayer_component___2HRab","rh5v-DefaultPlayer_video":"styles__rh5v-DefaultPlayer_video___1ldYo","rh5v-DefaultPlayer_controls":"styles__rh5v-DefaultPlayer_controls___3MsvE","rh5v-DefaultPlayer_seek":"styles__rh5v-DefaultPlayer_seek___29np0","rh5v-Time_component":"styles__rh5v-Time_component___3jMdV","rh5v-Time_current":"styles__rh5v-Time_current___3xdQt","rh5v-Time_duration":"styles__rh5v-Time_duration___25Dgt","rh5v-Seek_component":"styles__rh5v-Seek_component___1LJ3D","rh5v-Seek_track":"styles__rh5v-Seek_track___23wQe","rh5v-Seek_buffer":"styles__rh5v-Seek_buffer___y-AVo","rh5v-Seek_fill":"styles__rh5v-Seek_fill___1eP3p","rh5v-Seek_input":"styles__rh5v-Seek_input___3Jrnt","rh5v-Volume_component":"styles__rh5v-Volume_component____wrSF","rh5v-Volume_button":"styles__rh5v-Volume_button___3BbsG","rh5v-Volume_icon":"styles__rh5v-Volume_icon___x4rqp","rh5v-Volume_slider":"styles__rh5v-Volume_slider___1IKS-","rh5v-Volume_track":"styles__rh5v-Volume_track___1X4My","rh5v-Volume_fill":"styles__rh5v-Volume_fill___3sBtd","rh5v-Volume_input":"styles__rh5v-Volume_input___34GUW","rh5v-Captions_component":"styles__rh5v-Captions_component___3tIzq","rh5v-Captions_button":"styles__rh5v-Captions_button___3WueR","rh5v-Captions_icon":"styles__rh5v-Captions_icon___1gzI-","rh5v-Captions_trackList":"styles__rh5v-Captions_trackList___JvT1v","rh5v-Captions_trackItem":"styles__rh5v-Captions_trackItem___1h1fE","rh5v-Captions_activeTrackItem":"styles__rh5v-Captions_activeTrackItem___2PkmF","rh5v-PlayPause_component":"styles__rh5v-PlayPause_component___1JB-7","rh5v-PlayPause_button":"styles__rh5v-PlayPause_button___evVt8","rh5v-PlayPause_icon":"styles__rh5v-PlayPause_icon___4e_Vx","rh5v-Fullscreen_component":"styles__rh5v-Fullscreen_component___1_-fV","rh5v-Fullscreen_button":"styles__rh5v-Fullscreen_button___218CH","rh5v-Fullscreen_icon":"styles__rh5v-Fullscreen_icon___3lhiQ","rh5v-Overlay_component":"styles__rh5v-Overlay_component___16gd4","rh5v-Overlay_inner":"styles__rh5v-Overlay_inner___1aKYm","rh5v-Overlay_icon":"styles__rh5v-Overlay_icon___32dUT"};

/***/ },
/* 1429 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toast-enter--bottom-right":"ReactToastify-min__toast-enter--bottom-right___9zDAS","toast-enter--top-right":"ReactToastify-min__toast-enter--top-right___6-V7e","toastify-bounceInRight":"ReactToastify-min__toastify-bounceInRight___2mzvf","toast-exit--bottom-right":"ReactToastify-min__toast-exit--bottom-right___24xCb","toast-exit--top-right":"ReactToastify-min__toast-exit--top-right___1r3K3","toastify-bounceOutRight":"ReactToastify-min__toastify-bounceOutRight___L2jgd","toast-enter--bottom-left":"ReactToastify-min__toast-enter--bottom-left___3VVgM","toast-enter--top-left":"ReactToastify-min__toast-enter--top-left___FuEXV","toastify-bounceInLeft":"ReactToastify-min__toastify-bounceInLeft___9tBR1","toast-exit--bottom-left":"ReactToastify-min__toast-exit--bottom-left___FM8oj","toast-exit--top-left":"ReactToastify-min__toast-exit--top-left___SiSld","toastify-bounceOutLeft":"ReactToastify-min__toastify-bounceOutLeft___uB8nP","toast-enter--bottom-center":"ReactToastify-min__toast-enter--bottom-center___kjGVq","toastify-bounceInUp":"ReactToastify-min__toastify-bounceInUp___3_RxC","toast-exit--top-center":"ReactToastify-min__toast-exit--top-center___10ShL","toastify-bounceOutUp":"ReactToastify-min__toastify-bounceOutUp___398ri","toast-enter--top-center":"ReactToastify-min__toast-enter--top-center___2ztHF","toastify-bounceInDown":"ReactToastify-min__toastify-bounceInDown___3WoH6","toast-exit--bottom-center":"ReactToastify-min__toast-exit--bottom-center___3VSRg","toastify-bounceOutDown":"ReactToastify-min__toastify-bounceOutDown___7REV2","toastify-animated":"ReactToastify-min__toastify-animated___2yBj-","toastify":"ReactToastify-min__toastify___2Aa5a","toastify--top-left":"ReactToastify-min__toastify--top-left___1A1Xh","toastify--top-center":"ReactToastify-min__toastify--top-center___WLIDk","toastify--top-right":"ReactToastify-min__toastify--top-right___6esx6","toastify--bottom-left":"ReactToastify-min__toastify--bottom-left___2yVHE","toastify--bottom-center":"ReactToastify-min__toastify--bottom-center___2nTjD","toastify--bottom-right":"ReactToastify-min__toastify--bottom-right___3bBTc","toastify__close":"ReactToastify-min__toastify__close___34ApL","toastify-content--default":"ReactToastify-min__toastify-content--default___3O0Im","toastify-content":"ReactToastify-min__toastify-content___Xjacj","toastify-content--info":"ReactToastify-min__toastify-content--info___393sH","toastify-content--success":"ReactToastify-min__toastify-content--success___1jDy-","toastify-content--warning":"ReactToastify-min__toastify-content--warning___vdnoC","toastify-content--error":"ReactToastify-min__toastify-content--error___30Tpy","toastify__body":"ReactToastify-min__toastify__body___Dpe91","toastify__progress":"ReactToastify-min__toastify__progress___DUkTp","track-progress":"ReactToastify-min__track-progress___2tRBS","toastify__progress--default":"ReactToastify-min__toastify__progress--default___1RBFr"};

/***/ },
/* 1430 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"appBar":"theme__appBar___3Py1Z","scrollHide":"theme__scrollHide___PyOfn","flat":"theme__flat___1J9he","fixed":"theme__fixed___2dwFx","inner":"theme__inner___lGWLJ","title":"theme__title___37vtt","leftIcon":"theme__leftIcon___30BcY","rightIcon":"theme__rightIcon___1hv3P"};

/***/ },
/* 1431 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"autocomplete":"theme__autocomplete____07g5","focus":"theme__focus___3qQkg","suggestions":"theme__suggestions___3-Nb6","values":"theme__values___14fVf","value":"theme__value___cBUoJ","up":"theme__up___3rmye","suggestion":"theme__suggestion___1erPE","active":"theme__active___kDY3Z","input":"theme__input___1ryxc"};

/***/ },
/* 1432 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"avatar":"theme__avatar___3OjJz","image":"theme__image___2Ueo9","letter":"theme__letter___26GdB"};

/***/ },
/* 1433 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"theme__button___2Agdx","rippleWrapper":"theme__rippleWrapper___3AVBi","squared":"theme__squared___2GH_L","icon":"theme__icon___3aBSX","solid":"theme__solid___1ZxqC","raised":"theme__raised___221ic theme__button___2Agdx theme__squared___2GH_L theme__solid___1ZxqC","flat":"theme__flat___1jWAQ theme__button___2Agdx theme__squared___2GH_L","floating":"theme__floating___3IRMZ theme__button___2Agdx theme__solid___1ZxqC","mini":"theme__mini___2DCN-","toggle":"theme__toggle___hC5Z2 theme__button___2Agdx","primary":"theme__primary___3tTAW","accent":"theme__accent___2wp6F","neutral":"theme__neutral___2CPs4","inverse":"theme__inverse___2SPZr"};

/***/ },
/* 1434 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"card":"theme__card___8pay8","raised":"theme__raised___1AHwB","cardMedia":"theme__cardMedia___3Yc6z","wide":"theme__wide___35NNe","square":"theme__square___1HBxg","content":"theme__content___ewAVM","contentOverlay":"theme__contentOverlay___1bBKz","cardTitle":"theme__cardTitle___1dU3o","cardActions":"theme__cardActions___ZoLIG","cardText":"theme__cardText___K_kzH","title":"theme__title___3qCP3","subtitle":"theme__subtitle___3p3mO","large":"theme__large___2iwOK","small":"theme__small___1RHxe"};

/***/ },
/* 1435 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field":"theme__field___3Tq32","ripple":"theme__ripple___2NWrZ","text":"theme__text___dXU7C","input":"theme__input___271V1","check":"theme__check___1CXAo","checked":"theme__checked___nSz7s","checkmark-expand":"theme__checkmark-expand___3GU9D","disabled":"theme__disabled___2jVLS"};

/***/ },
/* 1436 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"chip":"theme__chip___3Iv9P","avatar":"theme__avatar___2o8mD","deletable":"theme__deletable___2hlBs","delete":"theme__delete___3nnfj","deleteIcon":"theme__deleteIcon___2sopz","deleteX":"theme__deleteX___10NaZ"};

/***/ },
/* 1437 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"theme__input___2ISvI","disabled":"theme__disabled___Cf3yF","inputElement":"theme__inputElement___x7MhN","header":"theme__header___2vLUd","year":"theme__year___1VWY-","date":"theme__date___3K2Ws","calendarWrapper":"theme__calendarWrapper___1t-4v","yearsDisplay":"theme__yearsDisplay___2OzvT","monthsDisplay":"theme__monthsDisplay___2DDdC","dialog":"theme__dialog___3fCV6","button":"theme__button___2hL6u","calendar":"theme__calendar___1X9ls","prev":"theme__prev___Nv9Bc","next":"theme__next___3iPkS","title":"theme__title___2ESpD","years":"theme__years___zEdgW","active":"theme__active___1pjXb","week":"theme__week___PcByv","days":"theme__days___1qh3T","day":"theme__day___2qF_L","month":"theme__month___1hSm5","slideRightEnter":"theme__slideRightEnter___Rk89h","slideRightLeave":"theme__slideRightLeave___1nam4","slideRightEnterActive":"theme__slideRightEnterActive___m5B3T","slideRightLeaveActive":"theme__slideRightLeaveActive___2bZap","slideLeftEnter":"theme__slideLeftEnter___bGml_","slideLeftLeave":"theme__slideLeftLeave___2WGqM","slideLeftEnterActive":"theme__slideLeftEnterActive___3Ghls","slideLeftLeaveActive":"theme__slideLeftLeaveActive___2WLHG"};

/***/ },
/* 1438 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"theme__wrapper___3nrqp","dialog":"theme__dialog___3lw90","active":"theme__active___3ea_1","small":"theme__small___38VTT","normal":"theme__normal___1K3iz","large":"theme__large___10LcP","fullscreen":"theme__fullscreen___3tLXQ","title":"theme__title___2J-aP","body":"theme__body___1Ivuq","navigation":"theme__navigation___wgwdj","button":"theme__button___22_c6"};

/***/ },
/* 1439 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"theme__wrapper___3eRY8","drawer":"theme__drawer___1sAOY","active":"theme__active___EWFXC","right":"theme__right___2-4-H","left":"theme__left___FKhpR"};

/***/ },
/* 1440 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dropdown":"theme__dropdown___ZzBNK","active":"theme__active___1DQ-E","values":"theme__values___2767w","label":"theme__label___2KjGM","value":"theme__value___6c1D5","up":"theme__up___1OA-G","disabled":"theme__disabled___1skVH","field":"theme__field___d5bru","errored":"theme__errored___3dZUG","templateValue":"theme__templateValue___6dCtT","required":"theme__required___1j4LX","error":"theme__error___fySw3","selected":"theme__selected___3uiEo"};

/***/ },
/* 1441 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"theme__input___lFVgC","withIcon":"theme__withIcon___1nKdf","icon":"theme__icon___3ga1V","inputElement":"theme__inputElement___4bZUj","bar":"theme__bar___3FySS","label":"theme__label___34120","fixed":"theme__fixed___GRQEP","required":"theme__required___2G0aY","hint":"theme__hint___bMyi_","filled":"theme__filled___34NWn","error":"theme__error___2k5Jz","counter":"theme__counter___1oTuT","disabled":"theme__disabled___3ZfJq","errored":"theme__errored___2s74E","hidden":"theme__hidden___2gAMv"};

/***/ },
/* 1442 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"layout":"theme__layout___wiKya","panel":"theme__panel___3aW3s","bodyScroll":"theme__bodyScroll___2uzOU","sidebarDrawer":"theme__sidebarDrawer___2kCN0","navDrawerDrawer":"theme__navDrawerDrawer___Cte92","pinned":"theme__pinned___qf0ha","clipped":"theme__clipped___1y5eh","appbarInner":"theme__appbarInner___1S9wz","appbarFixed":"theme__appbarFixed___2Q-xL","appbarAppBar":"theme__appbarAppBar___F9Fy2","navDrawerPinned":"theme__navDrawerPinned___2eOy5","appbarLeftIcon":"theme__appbarLeftIcon___fZ13o","navDrawerClipped":"theme__navDrawerClipped___2kROG","navDrawerWrapper":"theme__navDrawerWrapper___2gpOZ","sidebarPinned":"theme__sidebarPinned___3yo9c","sidebarClipped":"theme__sidebarClipped___1paQt","sidebarWrapper":"theme__sidebarWrapper___1TUxm","sidebarWidth1":"theme__sidebarWidth1___1EWpa","sidebarWidth2":"theme__sidebarWidth2___37z5O","sidebarWidth3":"theme__sidebarWidth3___24Dtc","sidebarWidth4":"theme__sidebarWidth4___28mqi","sidebarWidth5":"theme__sidebarWidth5___K39iB","sidebarWidth6":"theme__sidebarWidth6___2PjBX","sidebarWidth7":"theme__sidebarWidth7___16Oxc","sidebarWidth8":"theme__sidebarWidth8___3fr9v","sidebarWidth9":"theme__sidebarWidth9___iF_4K","sidebarWidth10":"theme__sidebarWidth10___3mnwI","sidebarWidth11":"theme__sidebarWidth11___2uccf","sidebarWidth12":"theme__sidebarWidth12___1pU-9","sidebarWidth25":"theme__sidebarWidth25___10h-v","sidebarWidth33":"theme__sidebarWidth33___BYRr2","sidebarWidth50":"theme__sidebarWidth50___2L3ft","sidebarWidth66":"theme__sidebarWidth66___31jol","sidebarWidth75":"theme__sidebarWidth75___2Xvmh","sidebarWidth100":"theme__sidebarWidth100___3T7B6"};

/***/ },
/* 1443 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"theme__icon___1-mD4","link":"theme__link___1Od3D","active":"theme__active___3blKB"};

/***/ },
/* 1444 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"theme__list___caNNQ","divider":"theme__divider___2Jg3-","subheader":"theme__subheader___q2l8C","inset":"theme__inset___1HHo_","listItem":"theme__listItem___ni6RH","ripple":"theme__ripple___2mi0Y","item":"theme__item___2GtDw","selectable":"theme__selectable___1OoR-","disabled":"theme__disabled___38DD6","checkboxItem":"theme__checkboxItem___OVyge","checkbox":"theme__checkbox___3SG-0","left":"theme__left___bHOJq","right":"theme__right___OQ3Je","itemAction":"theme__itemAction___VB7pN","itemContentRoot":"theme__itemContentRoot___2FBCh","large":"theme__large___EO5bo","itemText":"theme__itemText___12FqV","primary":"theme__primary___3SxNr"};

/***/ },
/* 1445 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"iconMenu":"theme__iconMenu___2aMxm","icon":"theme__icon___1b8Ml","menu":"theme__menu___1gvr5","topLeft":"theme__topLeft___SYeW8","outline":"theme__outline___2PdTB","topRight":"theme__topRight___DFQvY","bottomLeft":"theme__bottomLeft___3i7lA","bottomRight":"theme__bottomRight___3q-zB","static":"theme__static___2xf5n","menuInner":"theme__menuInner___2t8UE","rippled":"theme__rippled___3o1JI","active":"theme__active___2Cekp","menuItem":"theme__menuItem___lyzBJ","disabled":"theme__disabled___zGTpA","selected":"theme__selected___2-j_P","ripple":"theme__ripple___2m_Cl","caption":"theme__caption___3MsfE","shortcut":"theme__shortcut___1anRY","menuDivider":"theme__menuDivider___VX5Lv"};

/***/ },
/* 1446 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"horizontal":"theme__horizontal___1MJ9B","vertical":"theme__vertical___xUlwz"};

/***/ },
/* 1447 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overlay":"theme__overlay___2LA9x","active":"theme__active___1mb5R"};

/***/ },
/* 1448 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"linear":"theme__linear___3vxHj","indeterminate":"theme__indeterminate___1gPzb","value":"theme__value___I0PhY","linear-indeterminate-bar":"theme__linear-indeterminate-bar___1cU21","buffer":"theme__buffer___SzbNd","circular":"theme__circular___2j3vC","circle":"theme__circle___DlWjM","circular-indeterminate-bar-rotate":"theme__circular-indeterminate-bar-rotate___zfZzh","path":"theme__path___1xZSU","circular-indeterminate-bar-dash":"theme__circular-indeterminate-bar-dash___3DSlU","multicolor":"theme__multicolor___3XHT8","colors":"theme__colors___Z_PDt"};

/***/ },
/* 1449 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"radio":"theme__radio___1vWJb","ripple":"theme__ripple___78FVB","radioChecked":"theme__radioChecked___210O6 theme__radio___1vWJb","field":"theme__field___36UDg","text":"theme__text___3guDD","input":"theme__input___2CPDD","disabled":"theme__disabled___39I6g theme__field___36UDg"};

/***/ },
/* 1450 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rippleWrapper":"theme__rippleWrapper___16N7o","ripple":"theme__ripple___3SV_u","rippleRestarting":"theme__rippleRestarting___2OZWa","rippleActive":"theme__rippleActive___3O2Ue"};

/***/ },
/* 1451 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"theme__container____-dLk","knob":"theme__knob___kq8Om","innerknob":"theme__innerknob___8VjZ5","snaps":"theme__snaps___2x5j_","snap":"theme__snap___12aGJ","input":"theme__input___2JHGy","progress":"theme__progress___2R4jW","innerprogress":"theme__innerprogress___3p0mR","slider":"theme__slider___3-BtZ","editable":"theme__editable___hkAL6","pinned":"theme__pinned___28Oo0","pressed":"theme__pressed___292qK","ring":"theme__ring___2Oh5L"};

/***/ },
/* 1452 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"snackbar":"theme__snackbar___zDi3X","accept":"theme__accept___2Y0Cy","button":"theme__button___2pCxU","warning":"theme__warning___2li3o","cancel":"theme__cancel___3731C","active":"theme__active___38CsO","label":"theme__label___1JIbY"};

/***/ },
/* 1453 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field":"theme__field___1T2D0","text":"theme__text___rxx-p","thumb":"theme__thumb___1pMry","ripple":"theme__ripple___1I9tv","on":"theme__on___p92Yp","off":"theme__off___25ui_","input":"theme__input___3BTU_","switch-on":"theme__switch-on___2Bwve","switch-off":"theme__switch-off___1ZBFp","disabled":"theme__disabled___1CQ_q theme__field___1T2D0"};

/***/ },
/* 1454 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"table":"theme__table___2xofu","head":"theme__head___1eF5Z","row":"theme__row___1qppP","selected":"theme__selected___1H1dU","rowCell":"theme__rowCell___18bqN","headCell":"theme__headCell___gfcPv","numeric":"theme__numeric___3suRQ","checkboxCell":"theme__checkboxCell___2yhwA","sorted":"theme__sorted___2r5OG","sortIcon":"theme__sortIcon___3NJs5","asc":"theme__asc___wZHUA"};

/***/ },
/* 1455 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tabs":"theme__tabs___2EaQV","navigation":"theme__navigation___3e55Z","navigationContainer":"theme__navigationContainer___3oZmF","arrow":"theme__arrow___wPL4g","arrowContainer":"theme__arrowContainer___i_TGW","label":"theme__label___1yb8L","rippleWrapper":"theme__rippleWrapper___3c0W3","active":"theme__active___2LZ7Z","disabled":"theme__disabled___2gi1s","hidden":"theme__hidden___3kq1J","withIcon":"theme__withIcon___1OFOx","withText":"theme__withText___1Yf4A","icon":"theme__icon___1LUZH","pointer":"theme__pointer___1xgdB","tab":"theme__tab___26SP9","fixed":"theme__fixed___3bROj","inverse":"theme__inverse___33mT_"};

/***/ },
/* 1456 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"theme__input___2APuy","disabled":"theme__disabled___2Vc_4","inputElement":"theme__inputElement___2Z4kT","header":"theme__header___2u1sB","hours":"theme__hours___3Kl2E","minutes":"theme__minutes___3Bp7w","separator":"theme__separator___1c2VQ","ampm":"theme__ampm___1vAVQ","am":"theme__am___14hQA","pm":"theme__pm___aU9C9","dialog":"theme__dialog___1YlHq","button":"theme__button___1Kf0L","hoursDisplay":"theme__hoursDisplay___2JeOG","minutesDisplay":"theme__minutesDisplay___3UMNx","amFormat":"theme__amFormat___26MJk","pmFormat":"theme__pmFormat___3H_-m","clock":"theme__clock___2CwF0","placeholder":"theme__placeholder___zCpyM","clockWrapper":"theme__clockWrapper___3paoD","face":"theme__face___3ui0r","number":"theme__number___qr9pw","active":"theme__active___30yS_","hand":"theme__hand___1rtAF","small":"theme__small___3eEHh","knob":"theme__knob___VqPQb","zoomInEnter":"theme__zoomInEnter___3DTnI","zoomInLeave":"theme__zoomInLeave___1tgJ3","zoomInEnterActive":"theme__zoomInEnterActive___1Fr4_","zoomInLeaveActive":"theme__zoomInLeaveActive___1EUpH","zoomOutEnter":"theme__zoomOutEnter___1Lb15","zoomOutLeave":"theme__zoomOutLeave___3LDEu","zoomOutEnterActive":"theme__zoomOutEnterActive___3y67C","zoomOutLeaveActive":"theme__zoomOutLeaveActive___18Ean"};

/***/ },
/* 1457 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"tooltip":"theme__tooltip___1v8bI","tooltipActive":"theme__tooltipActive___2xWjx","tooltipTop":"theme__tooltipTop___1PfOK","tooltipLeft":"theme__tooltipLeft___3uj3d","tooltipRight":"theme__tooltipRight___3UQWj","tooltipInner":"theme__tooltipInner___9q2WH"};

/***/ },
/* 1458 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AboutTabs__materialize-textarea___3yqnn","modal-2463794813":"AboutTabs__modal-2463794813___1bzeI","container":"AboutTabs__container___1Ybdy","activeClass":"AboutTabs__activeClass___3dbuu"};

/***/ },
/* 1459 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AcademicBoard__materialize-textarea___DWANu","modal-2463794813":"AcademicBoard__modal-2463794813___2erX9","container":"AcademicBoard__container___27Pjz","academicContainer":"AcademicBoard__academicContainer___1QqVY","fullWidth":"AcademicBoard__fullWidth___3_6cA","buttonContainer":"AcademicBoard__buttonContainer___3nbMg","halfWidthRadio":"AcademicBoard__halfWidthRadio___2gmlW","addAnotherSports":"AcademicBoard__addAnotherSports___3eIiK","continue":"AcademicBoard__continue___3Q6k-","mySport":"AcademicBoard__mySport___2LQHL","halfWidth":"AcademicBoard__halfWidth___2CGzQ","halfWidthWithAutoComplete":"AcademicBoard__halfWidthWithAutoComplete___j-Ncp","halfWidthWithAutoCompleteError":"AcademicBoard__halfWidthWithAutoCompleteError___NPUX0","autoCompleteContainer":"AcademicBoard__autoCompleteContainer___3rGRY","halfWidthWithSpan":"AcademicBoard__halfWidthWithSpan___362T8","spanBlock":"AcademicBoard__spanBlock___12zZ1","halfWidthWithSpanError":"AcademicBoard__halfWidthWithSpanError___1h4Pl","back":"AcademicBoard__back___1aDhW","removePadding":"AcademicBoard__removePadding___3QiyT","optionalTag":"AcademicBoard__optionalTag___3sVyz"};

/***/ },
/* 1460 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AccountDropdown__materialize-textarea___3NmxU","modal-2463794813":"AccountDropdown__modal-2463794813___2nG5N","container":"AccountDropdown__container___2t03V","dropdownIcon":"AccountDropdown__dropdownIcon___1hQDW","iconContainer":"AccountDropdown__iconContainer___1NeNp","dropdownContainer":"AccountDropdown__dropdownContainer___ppPLC","menuItem":"AccountDropdown__menuItem___zJlRl","menuButton":"AccountDropdown__menuButton___3LC37"};

/***/ },
/* 1461 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AccountDropdown__materialize-textarea___1W23r","modal-2463794813":"AccountDropdown__modal-2463794813___3jkjS","container":"AccountDropdown__container___39pSS","dropdownIcon":"AccountDropdown__dropdownIcon___335pg","iconContainer":"AccountDropdown__iconContainer___3tm3h","dropdownContainer":"AccountDropdown__dropdownContainer___17n_9","menuItem":"AccountDropdown__menuItem___2Lz3F","menuButton":"AccountDropdown__menuButton___22AoX"};

/***/ },
/* 1462 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AddPosting__materialize-textarea___Rjynb","modal-2463794813":"AddPosting__modal-2463794813___2aks6","container":"AddPosting__container___3HjGv","titleContainer":"AddPosting__titleContainer___BhFj8","absoluteCross":"AddPosting__absoluteCross___1cUFz","optionalTag":"AddPosting__optionalTag___2da0X","addNewPosting":"AddPosting__addNewPosting___CtIQ_","buttonPostingContainer":"AddPosting__buttonPostingContainer___MUZHQ","buttonContainer":"AddPosting__buttonContainer___U7_FG","fullWidth":"AddPosting__fullWidth___RSSnK","halfWidthWithSpan":"AddPosting__halfWidthWithSpan___1GBj5","secondHalf":"AddPosting__secondHalf___2PyIA","datePicker":"AddPosting__datePicker___2m8Oa","rightSection":"AddPosting__rightSection___vLeIS","buttonImage":"AddPosting__buttonImage___mEJxt","header":"AddPosting__header___2MNFg","removePadding":"AddPosting__removePadding___z67Ij","stepperContainer":"AddPosting__stepperContainer___3VGz0","heightAndWidthContainer":"AddPosting__heightAndWidthContainer___1X-XD","heightWidth":"AddPosting__heightWidth___M1FWX","heightContainer":"AddPosting__heightContainer___1k9rW","feetContainer":"AddPosting__feetContainer___baRP1","inchesContainer":"AddPosting__inchesContainer___18vyI","simpleInput":"AddPosting__simpleInput___lkm25","simpleInputError":"AddPosting__simpleInputError___3ROcK","weightSection":"AddPosting__weightSection___3vOqe","dropdowns":"AddPosting__dropdowns___2T4OU","hidden":"AddPosting__hidden___1-A90","halfWidthWithSpanonError":"AddPosting__halfWidthWithSpanonError___Uh7ad","rightSectionOnError":"AddPosting__rightSectionOnError___1MEOD","weightSectionOnError":"AddPosting__weightSectionOnError___1eqDS","removePaddingWeight":"AddPosting__removePaddingWeight___2hH-p"};

/***/ },
/* 1463 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoHeader":"AddVideo__videoHeader___1RAMb","removePadding":"AddVideo__removePadding___3Y_RJ","inputFields":"AddVideo__inputFields___8fU3h","buttonContainer":"AddVideo__buttonContainer___1MEA2"};

/***/ },
/* 1464 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AtheleteDesc__materialize-textarea___K7VKU","modal-2463794813":"AtheleteDesc__modal-2463794813___3DSsI","container":"AtheleteDesc__container___1xa0m","signinSection":"AtheleteDesc__signinSection___3finT","signinHeader":"AtheleteDesc__signinHeader___3Ythb","joinUsButtonContainer":"AtheleteDesc__joinUsButtonContainer___1WBSV","signinBody":"AtheleteDesc__signinBody___3lMtz","learnMore":"AtheleteDesc__learnMore___2YNHU"};

/***/ },
/* 1465 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___1rsX9","modal-2463794813":"style__modal-2463794813___2hfh8","container":"style__container___3PBey","popupContainer":"style__popupContainer___KjW1F","imageHeader":"style__imageHeader___1Ms45","editIcon":"style__editIcon___1sPTy","videoBox":"style__videoBox___E-V6e","video":"style__video___2Ge4g","videoImage":"style__videoImage___32ach","titile":"style__titile___19zva","playbutton":"style__playbutton___3bjbp","confirmText":"style__confirmText___1CX9w","playButtonImage":"style__playButtonImage___iAhkl","absoluteCross":"style__absoluteCross___35ISd","fileInput":"style__fileInput___2JonQ","changeImage":"style__changeImage___wJXZA","changeImageText":"style__changeImageText___12zVP","image":"style__image___1znoI","autocomplete":"style__autocomplete___2Y0vm","autoInput":"style__autoInput___1luJ-","buttonContainer":"style__buttonContainer___Vp9Di","buttonClose":"style__buttonClose___1nUIb"};

/***/ },
/* 1466 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"backgroundImageContainer":"BackgroundImage__backgroundImageContainer___2ysif","loginBackground":"BackgroundImage__loginBackground___Eg3xF","backgroundImageMobile":"BackgroundImage__backgroundImageMobile___3fjKC","backgroundImageDesktop":"BackgroundImage__backgroundImageDesktop___1bhDg","hidden":"BackgroundImage__hidden___3l59w"};

/***/ },
/* 1467 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Banner__materialize-textarea___IYGp_","modal-2463794813":"Banner__modal-2463794813___287J5","container":"Banner__container___3odO6","bannerContainer":"Banner__bannerContainer___35clp","bannerSection":"Banner__bannerSection___-u4dY","bannerHeader":"Banner__bannerHeader___3B_lb","bannerQuotes":"Banner__bannerQuotes___1hGIY","centerDiv":"Banner__centerDiv___2cbsJ","learnMore":"Banner__learnMore___1sUtW","whiteLearnMore":"Banner__whiteLearnMore___1dcXI","bannerDesc":"Banner__bannerDesc___1y9gi","fullbanner":"Banner__fullbanner___S6se4","halfBanner":"Banner__halfBanner___wNqkh","alignCenter":"Banner__alignCenter___wjUry","bigScreens":"Banner__bigScreens___hB_Yt","hidden":"Banner__hidden___3YF9_","playvideo":"Banner__playvideo___17OKO","playIcon":"Banner__playIcon___1LTA7"};

/***/ },
/* 1468 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Benefits__materialize-textarea___39tay","modal-2463794813":"Benefits__modal-2463794813___1cjl9","container":"Benefits__container___1jMzl","benefitsContainer":"Benefits__benefitsContainer___2BcIQ","desc":"Benefits__desc___3nLkK","redDot":"Benefits__redDot___3yeEq"};

/***/ },
/* 1469 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Billings__materialize-textarea___2py5y","modal-2463794813":"Billings__modal-2463794813___qJszi","container":"Billings__container___15euX","currentPlan":"Billings__currentPlan___1bvqQ","dontHaveAnything":"Billings__dontHaveAnything___Wl_NF","packageInfo":"Billings__packageInfo___3mRpV","planIdInList":"Billings__planIdInList___GApCX","buttonContainer":"Billings__buttonContainer___Dyol1","invoiceListContainer":"Billings__invoiceListContainer___17vc2","invoiceList":"Billings__invoiceList___1UE3c","alignMiddle":"Billings__alignMiddle___2zY8w","invoiceHistory":"Billings__invoiceHistory___1jC_o","alignRight":"Billings__alignRight___VzYuJ","firstHalf":"Billings__firstHalf___2Ue5G","secondHalf":"Billings__secondHalf___2E60F","paymentMadeOn":"Billings__paymentMadeOn___IDX7Z","transactionId":"Billings__transactionId___642Ro"};

/***/ },
/* 1470 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"CoachApplication__materialize-textarea___3M5TV","modal-2463794813":"CoachApplication__modal-2463794813___2nxTJ","container":"CoachApplication__container___3-lDU","listContainer":"CoachApplication__listContainer___2xptb","listContainerWithoutBottomPadding":"CoachApplication__listContainerWithoutBottomPadding___3_CiQ","profileImage":"CoachApplication__profileImage___2s5zo","infoContainer":"CoachApplication__infoContainer___2hIHv","lightText":"CoachApplication__lightText___17t59","buttonContainer":"CoachApplication__buttonContainer___ncAlC","deleteButton":"CoachApplication__deleteButton___1dWLo","greenColor":"CoachApplication__greenColor___2FA_I","troubleFindingClassNameMondayMorning":"CoachApplication__troubleFindingClassNameMondayMorning___11Ofs"};

/***/ },
/* 1471 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"CoachDashboardView__materialize-textarea___3Qd0k","modal-2463794813":"CoachDashboardView__modal-2463794813___11DHZ","container":"CoachDashboardView__container___1Kv8_","adaptContainer":"CoachDashboardView__adaptContainer___7p2L6","emptyScreens":"CoachDashboardView__emptyScreens___1INte","emptyImage":"CoachDashboardView__emptyImage___2rHyv","noDescFound":"CoachDashboardView__noDescFound___1_I8D"};

/***/ },
/* 1472 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___C_nw1","modal-2463794813":"style__modal-2463794813___2bFCR","container":"style__container___3aYlj","remove_padding":"style__remove_padding___1DWog","dropDownMenu":"style__dropDownMenu___3J6Fy","paginationDropdown":"style__paginationDropdown___vlgF3","allStates":"style__allStates___25dFP","clearFilter":"style__clearFilter___m5Gth"};

/***/ },
/* 1473 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Rtiles__materialize-textarea___1wKf5","modal-2463794813":"Rtiles__modal-2463794813___QnDQV","container":"Rtiles__container___3moc_","tile":"Rtiles__tile___1LEik","colgeIcon":"Rtiles__colgeIcon___1droL","collegeName":"Rtiles__collegeName___3g2iP","sportName":"Rtiles__sportName___2q7Lm","lightText":"Rtiles__lightText___3GbbE","icon":"Rtiles__icon___2afWe","userNameIcon":"Rtiles__userNameIcon___1T4-b","veryLightText":"Rtiles__veryLightText___1Crl_","tileFooter":"Rtiles__tileFooter___yljqD","interestedButton":"Rtiles__interestedButton___1U7uA","greenButton":"Rtiles__greenButton___15F9v","inviteToCampButton":"Rtiles__inviteToCampButton___2D0dt","needMoreFilmsButton":"Rtiles__needMoreFilmsButton___2nLoX","addedToWatchListButton":"Rtiles__addedToWatchListButton___3r15G","ignoredButton":"Rtiles__ignoredButton___9HtIp","sendContactInfoButton":"Rtiles__sendContactInfoButton___XuP-N","heartIcon":"Rtiles__heartIcon___3TWcr","dotIcons":"Rtiles__dotIcons___TFXNh"};

/***/ },
/* 1474 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___V4PPs","modal-2463794813":"style__modal-2463794813___1apWh","container":"style__container___VXT3d","adaptContainer":"style__adaptContainer___1vSiq","emptyScreens":"style__emptyScreens___3Lxma","emptyImage":"style__emptyImage___2wou2","noDescFound":"style__noDescFound___3GnuN"};

/***/ },
/* 1475 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"CoachHeader__materialize-textarea___lsHXY","modal-2463794813":"CoachHeader__modal-2463794813___2Dnm8","container":"CoachHeader__container___jEnxj","navContainer":"CoachHeader__navContainer___3mBv6","dataContainer":"CoachHeader__dataContainer___1U0Tf","details":"CoachHeader__details___L-4bm","imageContainer":"CoachHeader__imageContainer___2sDFV","imageContainerReplica":"CoachHeader__imageContainerReplica___HkfOX","basicInfo":"CoachHeader__basicInfo___3WqyL","basicInfoReplica":"CoachHeader__basicInfoReplica___2gnuY","coachEditButton":"CoachHeader__coachEditButton___1j8VK","linkButton":"CoachHeader__linkButton___3S6-N","editIcon":"CoachHeader__editIcon___34FRl","coachEditButtonInSmall":"CoachHeader__coachEditButtonInSmall___30Q6U","userImage":"CoachHeader__userImage___1l5HT","description":"CoachHeader__description___3Y__S","playerName":"CoachHeader__playerName___2UYNY","sports":"CoachHeader__sports___1ql1h","location":"CoachHeader__location___3dFOj","otherFilelds":"CoachHeader__otherFilelds___2ln52","blackHeader":"CoachHeader__blackHeader___3P-xr","otherText":"CoachHeader__otherText___12H6l","removePadding":"CoachHeader__removePadding___teLYo","descriptionContainer":"CoachHeader__descriptionContainer___1ePoG","otherDescription":"CoachHeader__otherDescription___1w-jd","infoText":"CoachHeader__infoText___rfla5","buttonInterested":"CoachHeader__buttonInterested___2XJS_","tabsContainer":"CoachHeader__tabsContainer___3k-Ej","editInSmall":"CoachHeader__editInSmall___dy_UQ"};

/***/ },
/* 1476 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Popup__materialize-textarea___14niy","modal-2463794813":"Popup__modal-2463794813___-qvG_","container":"Popup__container___29jAW","popupContainer":"Popup__popupContainer___3KB7W","absoluteCross":"Popup__absoluteCross___2alzf","buttonContainer":"Popup__buttonContainer___8ipJ4"};

/***/ },
/* 1477 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"CoachPostings__materialize-textarea___3bXx9","modal-2463794813":"CoachPostings__modal-2463794813___pDaOb","container":"CoachPostings__container___z1X5o","tile":"CoachPostings__tile___2wwOL","colgeIcon":"CoachPostings__colgeIcon___19gFQ","collegeName":"CoachPostings__collegeName___2nmqS","postingTitle":"CoachPostings__postingTitle___3tlqu","lightText":"CoachPostings__lightText___2kuFr","icon":"CoachPostings__icon___1ltue","userNameIcon":"CoachPostings__userNameIcon___IuT0j","veryLightText":"CoachPostings__veryLightText___2UyHa","tileFooter":"CoachPostings__tileFooter___2UO2h","editIcon":"CoachPostings__editIcon___38xys","dotIcons":"CoachPostings__dotIcons___2TTC_"};

/***/ },
/* 1478 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"CoachRegistration__materialize-textarea___2nlcN","modal-2463794813":"CoachRegistration__modal-2463794813___1yoGS","container":"CoachRegistration__container___2Jq5D","coachRegistrationContainer":"CoachRegistration__coachRegistrationContainer___2kWVu","wrapper":"CoachRegistration__wrapper___AokTh","inputsContainer":"CoachRegistration__inputsContainer___3U2U9","header":"CoachRegistration__header___2aeRM","fullWidth":"CoachRegistration__fullWidth___3rGSD","halfWidthWithSpan":"CoachRegistration__halfWidthWithSpan___2cpgi","halfWidthWithSpanWithoutTopSpace":"CoachRegistration__halfWidthWithSpanWithoutTopSpace___1XDZB","halfWidthWithSpanWithoutTopSpaceOnError":"CoachRegistration__halfWidthWithSpanWithoutTopSpaceOnError___1jL3J","halfWidthWithSpanOnError":"CoachRegistration__halfWidthWithSpanOnError___2jN0b","buttonContainer":"CoachRegistration__buttonContainer___2jrRV","modifyButtonContainer":"CoachRegistration__modifyButtonContainer___Gnq2X","autoComplete":"CoachRegistration__autoComplete___1d5Tr","autoCompleteContact":"CoachRegistration__autoCompleteContact___WbHAo","autoCompleteState":"CoachRegistration__autoCompleteState___1mD_g","halfWidthWithAutoComplete":"CoachRegistration__halfWidthWithAutoComplete___156Pm","autoCompleteContainer":"CoachRegistration__autoCompleteContainer___2IzC8","autoCompleteContainerOnError":"CoachRegistration__autoCompleteContainerOnError___2uPLB","correctAutoCompleteSpan":"CoachRegistration__correctAutoCompleteSpan___3nejU","autoCompleteToolbox":"CoachRegistration__autoCompleteToolbox___k9nqi","autoCompleteToolboxOnError":"CoachRegistration__autoCompleteToolboxOnError___2nYIs","modifyContainer":"CoachRegistration__modifyContainer___3Dgny"};

/***/ },
/* 1479 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"CoachTabs__materialize-textarea___3u_fD","modal-2463794813":"CoachTabs__modal-2463794813___1Qu_t","container":"CoachTabs__container___2FTIB","activeClass":"CoachTabs__activeClass___16ooB"};

/***/ },
/* 1480 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Community__materialize-textarea___1qC-6","modal-2463794813":"Community__modal-2463794813___2_w9s","container":"Community__container___172Za","communityContainer":"Community__communityContainer___3vU-e","categories":"Community__categories___1OH0d","categoryHeader":"Community__categoryHeader___20grY","categoryIcon":"Community__categoryIcon___11zIt","categoryDescription":"Community__categoryDescription___3cRuT","textContainer":"Community__textContainer___1saDE","ourCommunity":"Community__ourCommunity___g93iq","communityText":"Community__communityText___3pL0g","athleteIcon":"Community__athleteIcon___CXWpE","parentIcon":"Community__parentIcon___2goyJ","cocahIcon":"Community__cocahIcon___2AM20","countsContainer":"Community__countsContainer___2DG9i"};

/***/ },
/* 1481 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___3BWxi","modal-2463794813":"style__modal-2463794813___2xGxh","container":"style__container___3_NdK","activeClass":"style__activeClass___FGimM"};

/***/ },
/* 1482 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"customButtonContainer":"CustomButton__customButtonContainer___3lqxO","customButtonContainerForCoach":"CustomButton__customButtonContainerForCoach___1XaqV"};

/***/ },
/* 1483 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"DashBoardHeader__materialize-textarea___1maV-","modal-2463794813":"DashBoardHeader__modal-2463794813___3-Ptu","container":"DashBoardHeader__container___3n3r9","coachContainer":"DashBoardHeader__coachContainer___3Kevo","urlPath":"DashBoardHeader__urlPath___2h1ub","currentUrl":"DashBoardHeader__currentUrl___ufL05"};

/***/ },
/* 1484 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"LoadMore__materialize-textarea___1I1Uh","modal-2463794813":"LoadMore__modal-2463794813___31ygr","container":"LoadMore__container___3_rqy","desktopLoadMoreContainer":"LoadMore__desktopLoadMoreContainer___88C16","loadmoreContainerOnMobile":"LoadMore__loadmoreContainerOnMobile___30Zd1","overlay":"LoadMore__overlay___1UXfp","filterDescription":"LoadMore__filterDescription___3SS6R"};

/***/ },
/* 1485 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Details__materialize-textarea___1m6tO","modal-2463794813":"Details__modal-2463794813___2vH12","container":"Details__container___9MkEr","signinSection":"Details__signinSection___2MsDH","signinHeader":"Details__signinHeader___3pku5","closeButton":"Details__closeButton___20yDa","loginPageNav":"Details__loginPageNav___3RDHl","loginPageNavLight":"Details__loginPageNavLight___2JQJO","joinUsButtonContainer":"Details__joinUsButtonContainer___BdAaH","navigationDetails":"Details__navigationDetails___3wx4O","notAMember":"Details__notAMember___1ggnF","signinBody":"Details__signinBody___2sMhh","signinBodyAlignCenter":"Details__signinBodyAlignCenter___crB6r","editableContainer":"Details__editableContainer___BoUEs","detailsHeader":"Details__detailsHeader___1HvAv","errorMessageContainer":"Details__errorMessageContainer___3kZO-","detailsDesc":"Details__detailsDesc___2kCKt","notAMemberText":"Details__notAMemberText___3a3He"};

/***/ },
/* 1486 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dividerLine":"Divider__dividerLine___2r3eD"};

/***/ },
/* 1487 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"EditPosting__materialize-textarea___2gOwE","modal-2463794813":"EditPosting__modal-2463794813___2IZCK","container":"EditPosting__container___3kSOM","addNewPosting":"EditPosting__addNewPosting___5dRsJ","absoluteCross":"EditPosting__absoluteCross___3aImE","optionalTag":"EditPosting__optionalTag___2Syqr","buttonPostingContainer":"EditPosting__buttonPostingContainer___2MmML","buttonContainer":"EditPosting__buttonContainer___i6v4N","fullWidth":"EditPosting__fullWidth___1jrOL","halfWidthWithSpan":"EditPosting__halfWidthWithSpan___34ms9","halfWidthWithSpanonError":"EditPosting__halfWidthWithSpanonError___2zasW","secondHalf":"EditPosting__secondHalf___ui7FH","datePicker":"EditPosting__datePicker___As44S","rightSection":"EditPosting__rightSection___-eHlq","rightSectionOnError":"EditPosting__rightSectionOnError___2abv3","buttonImage":"EditPosting__buttonImage___MAmWp","header":"EditPosting__header___1_Aiv","removePadding":"EditPosting__removePadding___334xX","stepperContainer":"EditPosting__stepperContainer___1ztGw","heightAndWidthContainer":"EditPosting__heightAndWidthContainer___3vIJk","heightWidth":"EditPosting__heightWidth___2OFwK","heightContainer":"EditPosting__heightContainer___nRsdG","feetContainer":"EditPosting__feetContainer___1DG_w","inchesContainer":"EditPosting__inchesContainer___2vz1w","simpleInput":"EditPosting__simpleInput___2TkMf","simpleInputError":"EditPosting__simpleInputError___2rFjJ","weightSection":"EditPosting__weightSection___1XO-P","dropdowns":"EditPosting__dropdowns___3M9X2","hidden":"EditPosting__hidden___3uRAp","deleteButton":"EditPosting__deleteButton___EV872","weightSectionOnError":"EditPosting__weightSectionOnError___XrDlz"};

/***/ },
/* 1488 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Error__materialize-textarea___2VNLo","modal-2463794813":"Error__modal-2463794813___UC2R0","container":"Error__container___1Ov6m","errorMessage":"Error__errorMessage___1rKR4"};

/***/ },
/* 1489 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Filter__materialize-textarea___3JkJf","modal-2463794813":"Filter__modal-2463794813___3_QOw","container":"Filter__container___3hjxI","filterImage":"Filter__filterImage___2BThn","multipleSelectContainer":"Filter__multipleSelectContainer___2hGxg","applyButton":"Filter__applyButton___2R7oq","clearFilter":"Filter__clearFilter___1qE7G","filterBy":"Filter__filterBy___1lt6_","stateContainer":"Filter__stateContainer___2Mnbo","divisonContainer":"Filter__divisonContainer___iOWx0","containerFilter":"Filter__containerFilter___3QSTA","removePadding":"Filter__removePadding___2SfGI","filterHolder":"Filter__filterHolder___2dbHA","apply":"Filter__apply___1iQT7","autoCompleteContainer":"Filter__autoCompleteContainer___2Ar10","filterInSmall":"Filter__filterInSmall___3HOIk","applyButtonInSmall":"Filter__applyButtonInSmall___FXdpU","closeButtonInSmall":"Filter__closeButtonInSmall___AtKKc","clearFilterForSmall":"Filter__clearFilterForSmall___191XR"};

/***/ },
/* 1490 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footerContainer":"Footer__footerContainer___gODu9","button":"Footer__button___1DcNz","footerInBigScreen":"Footer__footerInBigScreen___2b19s","footerInSmallScreen":"Footer__footerInSmallScreen___2JYh2","footerBorderInSmall":"Footer__footerBorderInSmall___2f0Fh"};

/***/ },
/* 1491 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"FooterContact__materialize-textarea___1pvNC","modal-2463794813":"FooterContact__modal-2463794813___1xqoa","container":"FooterContact__container___kMqXd","contactContainer":"FooterContact__contactContainer___ZsSW6","fullWidth":"FooterContact__fullWidth___242DR","textareaContainer":"FooterContact__textareaContainer___1l45g","emailField":"FooterContact__emailField___2nqC9","emailFieldOnError":"FooterContact__emailFieldOnError___2BlrC","firstName":"FooterContact__firstName___3XtaR","firstNameOnError":"FooterContact__firstNameOnError___KjnHF","lastName":"FooterContact__lastName___18Z-Z","lastNameOnError":"FooterContact__lastNameOnError___lICjH","submitButton":"FooterContact__submitButton___3Oc2s","textarea":"FooterContact__textarea___Majft","textareaOnError":"FooterContact__textareaOnError___iOTN_","text":"FooterContact__text___1mCZ_","okbuttonModal":"FooterContact__okbuttonModal___3WGf9"};

/***/ },
/* 1492 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"FooterNav__materialize-textarea___3jGrj","modal-2463794813":"FooterNav__modal-2463794813___1VpqG","container":"FooterNav__container___1Rot3","navContainer":"FooterNav__navContainer___3s-yR","buttonContainer":"FooterNav__buttonContainer___NJbET"};

/***/ },
/* 1493 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoContainer":"FullScreenVideo__videoContainer___13Wg4","closeButton":"FullScreenVideo__closeButton___1o9y0"};

/***/ },
/* 1494 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"GetUserDetails__materialize-textarea___1t8Sj","modal-2463794813":"GetUserDetails__modal-2463794813___L-8xd","container":"GetUserDetails__container___37j1-","getUserDetailsContainer":"GetUserDetails__getUserDetailsContainer___1bjf-","contentContainer":"GetUserDetails__contentContainer___3hAA6","tabsContainer":"GetUserDetails__tabsContainer___3gura","tabsHeader":"GetUserDetails__tabsHeader___24uPY","tabsButtonsContainer":"GetUserDetails__tabsButtonsContainer___3dT9v","checkBoxContainer":"GetUserDetails__checkBoxContainer___36JjA","textSelected":"GetUserDetails__textSelected___2__jF","getInfoBox":"GetUserDetails__getInfoBox___ihAJx","whiteColor":"GetUserDetails__whiteColor___3WDNS","texts":"GetUserDetails__texts___13q11","textBelow":"GetUserDetails__textBelow___3wTS9","maxWidth":"GetUserDetails__maxWidth___11fP7"};

/***/ },
/* 1495 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Actionable__materialize-textarea___rNr1T","modal-2463794813":"Actionable__modal-2463794813___N-826","container":"Actionable__container___14k0q","fullScreen":"Actionable__fullScreen___2MsKD","bubbleButton":"Actionable__bubbleButton___BOM5h","options":"Actionable__options___2yEha","popupBubble":"Actionable__popupBubble___rOB5c","hidden":"Actionable__hidden___1HjtX","header":"Actionable__header___2hYzS","bubbleCross":"Actionable__bubbleCross___129w2"};

/***/ },
/* 1496 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"DashBoardHeader__materialize-textarea___gnZBl","modal-2463794813":"DashBoardHeader__modal-2463794813___3I1ex","container":"DashBoardHeader__container___2LgLL","coachContainer":"DashBoardHeader__coachContainer___2Ggd4","urlPath":"DashBoardHeader__urlPath___3RM_T","currentUrl":"DashBoardHeader__currentUrl___2Lfrz"};

/***/ },
/* 1497 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"ListView__materialize-textarea___33A0S","modal-2463794813":"ListView__modal-2463794813___2GauQ","container":"ListView__container___3gP-s","colgeIcon":"ListView__colgeIcon___3dmeW","collegeName":"ListView__collegeName___Y2FdG","lightText":"ListView__lightText___2Mq4b","positionHeader":"ListView__positionHeader___2gwjY","imageAndName":"ListView__imageAndName___3reOH","equalDivs":"ListView__equalDivs___1W8WX","textContainer":"ListView__textContainer___FTExT","buttonContainer":"ListView__buttonContainer___1mFtY","veryLightText":"ListView__veryLightText___ffhqw","icon":"ListView__icon___2Dg9q","respond":"ListView__respond___1jNmr","heartIcon":"ListView__heartIcon___2vszk","interested":"ListView__interested___3Xc3r","listInBig":"ListView__listInBig___1DDGN","listInSmall":"ListView__listInSmall___CoNoc","smallButtonContainer":"ListView__smallButtonContainer___wy5mq","absoluteHeart":"ListView__absoluteHeart___3Wdl5","responseText":"ListView__responseText___dKA6z"};

/***/ },
/* 1498 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Drawer__materialize-textarea___3FSWK","modal-2463794813":"Drawer__modal-2463794813___2lMfo","container":"Drawer__container___1NNoz","dropdownIcon":"Drawer__dropdownIcon___10QzZ","drawerContainer":"Drawer__drawerContainer___37mXv","menuIcon":"Drawer__menuIcon___1hY1Y","userName":"Drawer__userName___2nJDB","buttonContainer":"Drawer__buttonContainer___2VUtS","loginButtonContainer":"Drawer__loginButtonContainer___1wOtT","joinUsButtonContainer":"Drawer__joinUsButtonContainer___1xzOc","closeButton":"Drawer__closeButton___132JP"};

/***/ },
/* 1499 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"MiniFooter__materialize-textarea___37N2I","modal-2463794813":"MiniFooter__modal-2463794813___pYSFr","container":"MiniFooter__container___1Nh4n","socialIcons":"MiniFooter__socialIcons___J1iJ5","connectWithUs":"MiniFooter__connectWithUs___3tJEb","logoPadding":"MiniFooter__logoPadding___2mqLE","copyRight":"MiniFooter__copyRight___Xbk4D","miniFooterInSmall":"MiniFooter__miniFooterInSmall___2-JMS","miniFooterInBig":"MiniFooter__miniFooterInBig___3W-is","lineBelowSocialIcons":"MiniFooter__lineBelowSocialIcons___2GiRV"};

/***/ },
/* 1500 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"ModifyParent__materialize-textarea___1vryo","modal-2463794813":"ModifyParent__modal-2463794813___27ZbM","container":"ModifyParent__container___5VIwX","personalInfoContainer":"ModifyParent__personalInfoContainer___2KW6R","collapseContainer":"ModifyParent__collapseContainer___eRZqX","inputContainer":"ModifyParent__inputContainer___1hVZV","halfWidthWithSpan":"ModifyParent__halfWidthWithSpan___3qQ65","halfWidthWithSpanError":"ModifyParent__halfWidthWithSpanError___nq50M","halfWidthAutoComplete":"ModifyParent__halfWidthAutoComplete___D0MJ_","halfWidthAutoCompleteError":"ModifyParent__halfWidthAutoCompleteError___OwZbT","halfWidthRadio":"ModifyParent__halfWidthRadio___GWSqF","radioContainer":"ModifyParent__radioContainer___349wf","personalInfo":"ModifyParent__personalInfo___3GjS8","sportsInfo":"ModifyParent__sportsInfo___2J2vA","removePadding":"ModifyParent__removePadding___1MBJ7","textAreaContainer":"ModifyParent__textAreaContainer___pAlp1","textAreaContainerError":"ModifyParent__textAreaContainerError___3V9M6","makeAnotherPreference":"ModifyParent__makeAnotherPreference___3Myle","continue":"ModifyParent__continue___3ELfQ","space":"ModifyParent__space___XVjfy"};

/***/ },
/* 1501 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"ModifyStudent__materialize-textarea___1VNW8","modal-2463794813":"ModifyStudent__modal-2463794813___36Cje","container":"ModifyStudent__container___1QxhA","personalInfoContainer":"ModifyStudent__personalInfoContainer___3t3fU","optionalTag":"ModifyStudent__optionalTag___1yhkY","collapseContainer":"ModifyStudent__collapseContainer___CfgdQ","academicInfo":"ModifyStudent__academicInfo___7X15i","inputContainer":"ModifyStudent__inputContainer___1M3-K","halfWidthAutoComplete":"ModifyStudent__halfWidthAutoComplete___2iMo5","halfWidthAutoCompleteError":"ModifyStudent__halfWidthAutoCompleteError___3dIRQ","halfWidthRadio":"ModifyStudent__halfWidthRadio___2YKmO","radioContainer":"ModifyStudent__radioContainer___2ghEU","personalInfo":"ModifyStudent__personalInfo___2GBjM","sportsInfo":"ModifyStudent__sportsInfo___1g2BS","removePadding":"ModifyStudent__removePadding___1GLBU","textAreaContainer":"ModifyStudent__textAreaContainer___3qs3H","textAreaContainerError":"ModifyStudent__textAreaContainerError___1_nbp","makeAnotherPreference":"ModifyStudent__makeAnotherPreference___1FinK","continue":"ModifyStudent__continue___1jPZC","space":"ModifyStudent__space___7DX3F","inviteEmail":"ModifyStudent__inviteEmail___1G414","halfWidthWithSpan":"ModifyStudent__halfWidthWithSpan___2wURX","inviteButton":"ModifyStudent__inviteButton___1bBXK","sportsBoardContainer":"ModifyStudent__sportsBoardContainer___2DQtT","fullWidth":"ModifyStudent__fullWidth___1MhPy","heightAndWidthContainer":"ModifyStudent__heightAndWidthContainer___3nwfm","buttonContainer":"ModifyStudent__buttonContainer___1FIo7","halfWidth":"ModifyStudent__halfWidth___1ALAg","addAnotherSports":"ModifyStudent__addAnotherSports___1ZmGJ","mySport":"ModifyStudent__mySport___3Mb-m","halfWidthWithSpanError":"ModifyStudent__halfWidthWithSpanError___33WGI","textArea":"ModifyStudent__textArea___36jUL","removeLeftPadding":"ModifyStudent__removeLeftPadding___1Mw_0","textAreaError":"ModifyStudent__textAreaError___2KqDx","simpleInput":"ModifyStudent__simpleInput___1NcC_","simpleInputError":"ModifyStudent__simpleInputError___1DNP-","heightContainer":"ModifyStudent__heightContainer___2nnCu","feetContainer":"ModifyStudent__feetContainer___2wtm-","inchesContainer":"ModifyStudent__inchesContainer___1iA2d","heightWidth":"ModifyStudent__heightWidth___3aCmH","back":"ModifyStudent__back___1rMdt","mysportContainer":"ModifyStudent__mysportContainer___d2MJb","preferedPositionContainer":"ModifyStudent__preferedPositionContainer___1eswu","addButtonContainer":"ModifyStudent__addButtonContainer___rtMNi","addButton":"ModifyStudent__addButton___1Y2zO","removeButton":"ModifyStudent__removeButton___3gT2b","autoCompleteContainer":"ModifyStudent__autoCompleteContainer___2-WPz"};

/***/ },
/* 1502 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"MyrbDescription__materialize-textarea___2qejg","modal-2463794813":"MyrbDescription__modal-2463794813___2ReL5","container":"MyrbDescription__container___aRlwO","descContainer":"MyrbDescription__descContainer___3RMlQ","bottomText":"MyrbDescription__bottomText___3AkHK","bottomTag":"MyrbDescription__bottomTag___9aLSf","descHeader":"MyrbDescription__descHeader___3EYb1","descriptionText":"MyrbDescription__descriptionText___31zhh","descImage":"MyrbDescription__descImage___bIaMn","eyeCaching":"MyrbDescription__eyeCaching___2VBTQ","descriptionBox":"MyrbDescription__descriptionBox___1T3gd"};

/***/ },
/* 1503 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rblogo":"MyrbLogo__rblogo___ryU2O"};

/***/ },
/* 1504 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Myths__materialize-textarea___3sk6c","modal-2463794813":"Myths__modal-2463794813___K9m7I","container":"Myths__container___1hyib","header":"Myths__header___37Xgi","sportsWeSupport":"Myths__sportsWeSupport___19LfN","bigHeader":"Myths__bigHeader___3eG1D","darkHeader":"Myths__darkHeader___2dcur","darkHeaderSmall":"Myths__darkHeaderSmall___3jXdf","desc":"Myths__desc___1TEqE","createProfile":"Myths__createProfile___nJyOi","imageContainer":"Myths__imageContainer___2oV8o","moreSportsComingSoon":"Myths__moreSportsComingSoon___1Pgqb","plansAndPricing":"Myths__plansAndPricing___1_KFz","listContainer":"Myths__listContainer___2AwiL","buynow":"Myths__buynow___3b980","buynowContainer":"Myths__buynowContainer___Igm5Q","priceValue":"Myths__priceValue___1e0F4","coverText":"Myths__coverText___3vxcF","footerContainer":"Myths__footerContainer___TF12w","pricingHeader":"Myths__pricingHeader___cEXom","imageContainerInSmall":"Myths__imageContainerInSmall___1kgvB"};

/***/ },
/* 1505 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"NavOnScroll__container___3L4HQ"};

/***/ },
/* 1506 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"UserNavbar__materialize-textarea___EtYSB","modal-2463794813":"UserNavbar__modal-2463794813___1f1cT","container":"UserNavbar__container___vwueC","navBarLogo":"UserNavbar__navBarLogo___6jMb0","navBarLinks":"UserNavbar__navBarLinks___3L9UQ","dropdownContainer":"UserNavbar__dropdownContainer___1sRm5","dropdownIcon":"UserNavbar__dropdownIcon___3CLwM","dropdownIconPublic":"UserNavbar__dropdownIconPublic___1_qEt","dropdown":"UserNavbar__dropdown___3kgCj","displayInline":"UserNavbar__displayInline___H2wB0","dropdownInSmall":"UserNavbar__dropdownInSmall___3IQ7A","dropdownInBig":"UserNavbar__dropdownInBig___9WzBv"};

/***/ },
/* 1507 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Navigation__materialize-textarea___34vYy","modal-2463794813":"Navigation__modal-2463794813___v1TuO","container":"Navigation__container___Q5NE2","navigationContainer":"Navigation__navigationContainer___1VPFe","links":"Navigation__links___1F9W2","logo":"Navigation__logo___3CXOV","logoContainer":"Navigation__logoContainer___3alM-","navigationLinks":"Navigation__navigationLinks____ZB5K","simpleNav":"Navigation__simpleNav___XQwga","learnMoreNav":"Navigation__learnMoreNav___3q-gs","menu":"Navigation__menu___3VviX","hidden":"Navigation__hidden___2YjBM","dropdownBox":"Navigation__dropdownBox___2HKt1","menuInSmall":"Navigation__menuInSmall___32-TO","menuBox":"Navigation__menuBox___ONsL9","darkNavigation":"Navigation__darkNavigation___12rz6","dropdownIcon":"Navigation__dropdownIcon___14xxb"};

/***/ },
/* 1508 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"OurResultsData__materialize-textarea___1TrfX","modal-2463794813":"OurResultsData__modal-2463794813___nmTx2","container":"OurResultsData__container___1eR3E","textContainer":"OurResultsData__textContainer___31Jem","header":"OurResultsData__header___3wSEY","question":"OurResultsData__question___16JEv","desc":"OurResultsData__desc___2zoj-"};

/***/ },
/* 1509 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"List__materialize-textarea___hCCOW","modal-2463794813":"List__modal-2463794813___Jw-1D","container":"List__container___2T9LC","listContainer":"List__listContainer___vSVXD","buynow":"List__buynow___3dmh7","buynowContainer":"List__buynowContainer___29L0X","priceValue":"List__priceValue___22nxu","coverText":"List__coverText___DhCGH","benefitContainer":"List__benefitContainer___3Yv6A"};

/***/ },
/* 1510 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"ParentInfo__materialize-textarea___gxyHW","modal-2463794813":"ParentInfo__modal-2463794813___3gInX","container":"ParentInfo__container___3edxT","personalInfoContainer":"ParentInfo__personalInfoContainer___3lutt","fullWidth":"ParentInfo__fullWidth___2AgX7","buttonContainer":"ParentInfo__buttonContainer___1aSUT","halfWidth":"ParentInfo__halfWidth___4nvcs","continue":"ParentInfo__continue___3dvDK","mySport":"ParentInfo__mySport___38ViS","halfWidthRadio":"ParentInfo__halfWidthRadio___1tFXF","halfWidthWithSpan":"ParentInfo__halfWidthWithSpan___3PHmO","halfWidthWithSpanError":"ParentInfo__halfWidthWithSpanError___VfCAG","halfWidthAutoComplete":"ParentInfo__halfWidthAutoComplete___3DdtC","halfWidthAutoCompleteError":"ParentInfo__halfWidthAutoCompleteError___3geVt","radioContainer":"ParentInfo__radioContainer___1owFy","hidden":"ParentInfo__hidden___WYWfh"};

/***/ },
/* 1511 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Password__materialize-textarea___1Aq0E","modal-2463794813":"Password__modal-2463794813___83QSZ","container":"Password__container___2-KWQ","passwordContainer":"Password__passwordContainer___3QHBI","passwordContainerOnError":"Password__passwordContainerOnError___1shqS","labelsContainer":"Password__labelsContainer___1bu1K","forgotPassword":"Password__forgotPassword___2I3sR","label":"Password__label___3HFPQ","input":"Password__input___2JAqc"};

/***/ },
/* 1512 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"PersonalInfo__materialize-textarea___3u6k6","modal-2463794813":"PersonalInfo__modal-2463794813___3L_4n","container":"PersonalInfo__container___NW9xZ","personalInfoContainer":"PersonalInfo__personalInfoContainer___2pYIz","fullWidth":"PersonalInfo__fullWidth___Q3QkG","buttonContainer":"PersonalInfo__buttonContainer___2JfUw","halfWidth":"PersonalInfo__halfWidth___2cDaL","continue":"PersonalInfo__continue___3oIN6","mySport":"PersonalInfo__mySport___As0ge","halfWidthRadio":"PersonalInfo__halfWidthRadio___243S6","halfWidthWithSpan":"PersonalInfo__halfWidthWithSpan___1p_pp","halfWidthWithSpanError":"PersonalInfo__halfWidthWithSpanError___2n89Q","halfWidthAutoComplete":"PersonalInfo__halfWidthAutoComplete___3cHW9","halfWidthAutoCompleteError":"PersonalInfo__halfWidthAutoCompleteError___2KRh7","radioContainer":"PersonalInfo__radioContainer___3pBg6","hidden":"PersonalInfo__hidden___3inRJ","optionalTag":"PersonalInfo__optionalTag___y5PCX"};

/***/ },
/* 1513 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"PostingInfo__materialize-textarea___vFS8w","modal-2463794813":"PostingInfo__modal-2463794813___2WXxu","container":"PostingInfo__container___3iGkJ","videoHeader":"PostingInfo__videoHeader___2XZIc","mainHeader":"PostingInfo__mainHeader___2pUii","lightText":"PostingInfo__lightText___2IjIp","removePadding":"PostingInfo__removePadding___2fbDQ","inputFields":"PostingInfo__inputFields____LPsv","buttonContainer":"PostingInfo__buttonContainer___2ElIh","infoButton":"PostingInfo__infoButton___3ZXKv"};

/***/ },
/* 1514 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"PostingTile__materialize-textarea___3J9SE","modal-2463794813":"PostingTile__modal-2463794813___1W4nh","container":"PostingTile__container___1XbFw","tile":"PostingTile__tile___D6ilX","colgeIcon":"PostingTile__colgeIcon___yNpdA","collegeName":"PostingTile__collegeName___2FXxs","postingTitle":"PostingTile__postingTitle___2DtGm","division":"PostingTile__division___3aCQx","lightText":"PostingTile__lightText___38Nvd","icon":"PostingTile__icon___18qK7","userNameIcon":"PostingTile__userNameIcon___2KRoW","veryLightText":"PostingTile__veryLightText___2Vn9u","tileFooter":"PostingTile__tileFooter___vrf81","showInterestButton":"PostingTile__showInterestButton___3vL-u","heartIcon":"PostingTile__heartIcon___17rUm","interested":"PostingTile__interested___2QTSf","showInterest":"PostingTile__showInterest___IUlW0"};

/***/ },
/* 1515 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Postings__materialize-textarea___V9xFc","modal-2463794813":"Postings__modal-2463794813___ErmDX","container":"Postings__container___2FKDH","coachPostings":"Postings__coachPostings___23ob_","emptyScreens":"Postings__emptyScreens___2GNzw","emptyImage":"Postings__emptyImage___2Tid0","noDescFound":"Postings__noDescFound___3wwDE"};

/***/ },
/* 1516 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"ProfileBanner__materialize-textarea___1ceQT","modal-2463794813":"ProfileBanner__modal-2463794813___3pxzT","container":"ProfileBanner__container___P_oWy","profileBannerContainer":"ProfileBanner__profileBannerContainer___2-kPI","textOnbanner":"ProfileBanner__textOnbanner___TGnvn","textOnPricingbanner":"ProfileBanner__textOnPricingbanner___22Ghq","logoContainer":"ProfileBanner__logoContainer___3PouQ","smallText":"ProfileBanner__smallText___3E0yp"};

/***/ },
/* 1517 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"profileDataContainer":"ProfileData__profileDataContainer___3erwS","userDescription":"ProfileData__userDescription___6Qa5d","userInfo":"ProfileData__userInfo___3P6cS","blackHeader":"ProfileData__blackHeader___1y6GZ","dataInSmallScreens":"ProfileData__dataInSmallScreens___1ra4L","dataInBigScreens":"ProfileData__dataInBigScreens___3kT2G"};

/***/ },
/* 1518 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Header__materialize-textarea___-C4oJ","modal-2463794813":"Header__modal-2463794813___2VB21","container":"Header__container___2xQPG","headerContainer":"Header__headerContainer___1Wofg","textAlignCenter":"Header__textAlignCenter___1FYfd","navBar":"Header__navBar___142s6","profileIcon":"Header__profileIcon___2ZuFh","profileDetails":"Header__profileDetails___1P9cH","userContainer":"Header__userContainer___2Nocx","editIcon":"Header__editIcon___1P_VA","buttonContainer":"Header__buttonContainer___2zdKy","descriptionOnHeader":"Header__descriptionOnHeader___2E_bT","socialLinks":"Header__socialLinks___3VsD9","blackHeader":"Header__blackHeader___3B50L","dummyDiv":"Header__dummyDiv___nr6Ib"};

/***/ },
/* 1519 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Actionable__materialize-textarea___2YA7R","modal-2463794813":"Actionable__modal-2463794813___3knlp","container":"Actionable__container___8kNcA","fullScreen":"Actionable__fullScreen___1KXUX","bubbleButton":"Actionable__bubbleButton___2BoN5","options":"Actionable__options___2SvLn","popupBubble":"Actionable__popupBubble___2VR3N","hidden":"Actionable__hidden___1-QMU","header":"Actionable__header___TUlMn","bubbleCross":"Actionable__bubbleCross___3yHIs"};

/***/ },
/* 1520 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Tips__materialize-textarea___sANpK","modal-2463794813":"Tips__modal-2463794813___32snA","container":"Tips__container___3VHnT","header":"Tips__header___2arec","sportsWeSupport":"Tips__sportsWeSupport___2NtIw","redDot":"Tips__redDot___2DNmj","bigHeader":"Tips__bigHeader___36DJr","darkHeader":"Tips__darkHeader___2EzTi","desc":"Tips__desc___32jpD","createProfile":"Tips__createProfile___ysq7f","imageContainer":"Tips__imageContainer___2mTgc","moreSportsComingSoon":"Tips__moreSportsComingSoon___3g_Ds","plansAndPricing":"Tips__plansAndPricing___1k3Pw","listContainer":"Tips__listContainer___12-Rq","buynow":"Tips__buynow___18vas","buynowContainer":"Tips__buynowContainer___3WMje","priceValue":"Tips__priceValue___2G-r0","coverText":"Tips__coverText___2Yvgh","footerContainer":"Tips__footerContainer___3sADa","pricingHeader":"Tips__pricingHeader___1U3BK","imageContainerInSmall":"Tips__imageContainerInSmall___zUwun"};

/***/ },
/* 1521 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"RequestListView__materialize-textarea___xGU16","modal-2463794813":"RequestListView__modal-2463794813___1p9q6","container":"RequestListView__container___9Aj2n","colgeIcon":"RequestListView__colgeIcon___mQhrU","collegeName":"RequestListView__collegeName___1E3Wz","lightText":"RequestListView__lightText___7jIiZ","positionHeader":"RequestListView__positionHeader___13b72","imageAndName":"RequestListView__imageAndName___2nqsM","equalDivs":"RequestListView__equalDivs___3Sdve","firstDiv":"RequestListView__firstDiv___292HW","lastDiv":"RequestListView__lastDiv___2rt4b","textContainer":"RequestListView__textContainer___13-l-","buttonContainer":"RequestListView__buttonContainer___3c_bz","veryLightText":"RequestListView__veryLightText___OtCrT","boldText":"RequestListView__boldText___1MSKs","icon":"RequestListView__icon___1Ea1N","respond":"RequestListView__respond___1UZkD","interested":"RequestListView__interested___1N8_x","heartIcon":"RequestListView__heartIcon___3wNZc","greenColorButton":"RequestListView__greenColorButton___3YVdy","listInBig":"RequestListView__listInBig___nX-lG","listInSmall":"RequestListView__listInSmall___1hpY5","smallButtonContainer":"RequestListView__smallButtonContainer___IFEtU","absoluteHeart":"RequestListView__absoluteHeart___22mJS","responseText":"RequestListView__responseText___PAHLd","responseTextBold":"RequestListView__responseTextBold___2--r2"};

/***/ },
/* 1522 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Requests__materialize-textarea___1Kq2S","modal-2463794813":"Requests__modal-2463794813___2FxIO","container":"Requests__container___3JiVD","adaptContainer":"Requests__adaptContainer___twIFY","emptyScreens":"Requests__emptyScreens___3j2bV","emptyImage":"Requests__emptyImage___3b-Gw","noDescFound":"Requests__noDescFound___1PSNM","studentShowedInterest":"Requests__studentShowedInterest___73z5N","fromToContainer":"Requests__fromToContainer___2EYIw"};

/***/ },
/* 1523 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"RequestsTile__materialize-textarea___15gEC","modal-2463794813":"RequestsTile__modal-2463794813___26H1A","container":"RequestsTile__container___9EWZA","minHeight":"RequestsTile__minHeight___19niN","tile":"RequestsTile__tile___1U4C-","colgeIcon":"RequestsTile__colgeIcon___2woQc","collegeName":"RequestsTile__collegeName___pgODl","lightText":"RequestsTile__lightText___1Scd1","coachNameIcon":"RequestsTile__coachNameIcon___2ANjw","icon":"RequestsTile__icon___vOUAH","userNameIcon":"RequestsTile__userNameIcon___28mmg","veryLightText":"RequestsTile__veryLightText___3moIB","boldText":"RequestsTile__boldText___2A_Qc","tileFooter":"RequestsTile__tileFooter___24V1q","heartIcon":"RequestsTile__heartIcon___JuVyl","ignoreIcon":"RequestsTile__ignoreIcon___1diCb","clickable":"RequestsTile__clickable___BETmW","dotIcons":"RequestsTile__dotIcons___iZ2-q","dummyText":"RequestsTile__dummyText___fEX5u","colorButton":"RequestsTile__colorButton___1L3JW","greenColorButton":"RequestsTile__greenColorButton___1zttK"};

/***/ },
/* 1524 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Reset__materialize-textarea___WRdsz","modal-2463794813":"Reset__modal-2463794813___3uOc4","container":"Reset__container___1uGcy","halfWidthWithSpan":"Reset__halfWidthWithSpan___yrhPY","halfWidthWithSpanError":"Reset__halfWidthWithSpanError___G6YnL","continue":"Reset__continue___2oHlG"};

/***/ },
/* 1525 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Reviews__materialize-textarea___29Bvi","modal-2463794813":"Reviews__modal-2463794813___UgawX","container":"Reviews__container___1kanP","reviewsContainer":"Reviews__reviewsContainer___3AJP9","reviewHeader":"Reviews__reviewHeader___2Suil","review":"Reviews__review___1JWoB","reviewBy":"Reviews__reviewBy___22ED1","textContainer":"Reviews__textContainer___1-NIS"};

/***/ },
/* 1526 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Rtiles__materialize-textarea___1CXJf","modal-2463794813":"Rtiles__modal-2463794813___3AJyq","container":"Rtiles__container___DFg8S","tile":"Rtiles__tile___DFpmJ","colgeIcon":"Rtiles__colgeIcon___3WVa0","collegeName":"Rtiles__collegeName___1UwQ8","sportName":"Rtiles__sportName___2LMVJ","lightText":"Rtiles__lightText___zHy7t","icon":"Rtiles__icon___3NUI-","userNameIcon":"Rtiles__userNameIcon___1dIN9","veryLightText":"Rtiles__veryLightText___2W-rc","tileFooter":"Rtiles__tileFooter___3HhFM","interestedButton":"Rtiles__interestedButton___3XpgS","greenButton":"Rtiles__greenButton___3kBi9","inviteToCampButton":"Rtiles__inviteToCampButton___H_ku2","needMoreFilmsButton":"Rtiles__needMoreFilmsButton___3UzJC","addedToWatchListButton":"Rtiles__addedToWatchListButton___1duPx","ignoredButton":"Rtiles__ignoredButton___1eWxl","sendContactInfoButton":"Rtiles__sendContactInfoButton___1pBEL","heartIcon":"Rtiles__heartIcon___3yfk4","dotIcons":"Rtiles__dotIcons___2y-Aw"};

/***/ },
/* 1527 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"SchoolListView__materialize-textarea___1_BiI","modal-2463794813":"SchoolListView__modal-2463794813___8I-St","container":"SchoolListView__container___3hJLa","colgeIcon":"SchoolListView__colgeIcon___2mMzK","collegeName":"SchoolListView__collegeName___3onWY","lightText":"SchoolListView__lightText___S7dqf","positionHeader":"SchoolListView__positionHeader___3Mkgt","imageAndName":"SchoolListView__imageAndName___2pvgA","equalDivs":"SchoolListView__equalDivs___3fhoI","firstDiv":"SchoolListView__firstDiv___2kASy","lastDiv":"SchoolListView__lastDiv___2SZ9P","textContainer":"SchoolListView__textContainer___1zbwX","buttonContainer":"SchoolListView__buttonContainer___16xVO","veryLightText":"SchoolListView__veryLightText___wYEmo","icon":"SchoolListView__icon___316lR","respond":"SchoolListView__respond___1ucsu","interested":"SchoolListView__interested___1fITo","heartIcon":"SchoolListView__heartIcon___1epjm","listInBig":"SchoolListView__listInBig___2narC","listInSmall":"SchoolListView__listInSmall___1xo1z","smallButtonContainer":"SchoolListView__smallButtonContainer___13f_x","absoluteHeart":"SchoolListView__absoluteHeart___1oC_F"};

/***/ },
/* 1528 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"SchoolTile__materialize-textarea___36aom","modal-2463794813":"SchoolTile__modal-2463794813___2DV5b","container":"SchoolTile__container___1n4zY","tile":"SchoolTile__tile___JRBcW","colgeIcon":"SchoolTile__colgeIcon___3bmsx","collegeName":"SchoolTile__collegeName___1UmIY","collegeNameOnWishList":"SchoolTile__collegeNameOnWishList___1k0HO","lightText":"SchoolTile__lightText___1XUzF","icon":"SchoolTile__icon___19xcl","userNameIcon":"SchoolTile__userNameIcon___GCnCS","veryLightText":"SchoolTile__veryLightText___2-Z-q","veryLightTextWithHeight":"SchoolTile__veryLightTextWithHeight___3iIr0","tileFooter":"SchoolTile__tileFooter___LqsSk","coloredTileFooter":"SchoolTile__coloredTileFooter___3JF0_","heartIcon":"SchoolTile__heartIcon___2WXVj","ignoreIcon":"SchoolTile__ignoreIcon___2CokC","clickable":"SchoolTile__clickable___3fkcU","unignore":"SchoolTile__unignore___1bBR7","dotIcons":"SchoolTile__dotIcons___9KssW","dummyText":"SchoolTile__dummyText___2dk9z","hide":"SchoolTile__hide___Gngv-"};

/***/ },
/* 1529 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"removePadding":"SearchUser__removePadding___18UN1","buttonContainer":"SearchUser__buttonContainer___1vTD5"};

/***/ },
/* 1530 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"removePadding":"SearchUserByFullName__removePadding___1dfKg","removePaddingInnerDiv":"SearchUserByFullName__removePaddingInnerDiv___Nxr9s","buttonContainer":"SearchUserByFullName__buttonContainer___3_-rS"};

/***/ },
/* 1531 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"activeClass":"SettingsCoachTabs__activeClass___3b0Sr","container":"SettingsCoachTabs__container___NPoF4"};

/***/ },
/* 1532 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"SettingsTabs__materialize-textarea___1yVBy","modal-2463794813":"SettingsTabs__modal-2463794813___2f-s3","container":"SettingsTabs__container___2g6d0","activeClass":"SettingsTabs__activeClass___5fIXx"};

/***/ },
/* 1533 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"SettingsView__materialize-textarea___hPbFj","modal-2463794813":"SettingsView__modal-2463794813___ROXq2","container":"SettingsView__container___2er9H","profileContainer":"SettingsView__profileContainer___xZVaE","adaptContainer":"SettingsView__adaptContainer___2EQ45","emptyScreens":"SettingsView__emptyScreens___2KPFR","emptyImage":"SettingsView__emptyImage___25MYh","noDescFound":"SettingsView__noDescFound___3e7Bt"};

/***/ },
/* 1534 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"signInContainer":"Signin__signInContainer___rs6Z3","loader":"Signin__loader___3dOTw","errorContainer":"Signin__errorContainer___fW0IQ"};

/***/ },
/* 1535 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"SignupCategory__materialize-textarea___2Y_F-","modal-2463794813":"SignupCategory__modal-2463794813___2cE-B","container":"SignupCategory__container___34BoP"};

/***/ },
/* 1536 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"SocialIcons__materialize-textarea___2RdfQ","modal-2463794813":"SocialIcons__modal-2463794813___FpMZm","container":"SocialIcons__container___Gu4Y5","socialIconContainer":"SocialIcons__socialIconContainer___1YBi7","copyRight":"SocialIcons__copyRight___1Ix3A","connectWithUs":"SocialIcons__connectWithUs___3j0TR","socialIcons":"SocialIcons__socialIcons____dOxd"};

/***/ },
/* 1537 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"SportsBoard__materialize-textarea___3gGLD","modal-2463794813":"SportsBoard__modal-2463794813___1_vjK","container":"SportsBoard__container___3fVhE","sportsBoardContainer":"SportsBoard__sportsBoardContainer___2-Jo_","fullWidth":"SportsBoard__fullWidth___24Z21","heightAndWidthContainer":"SportsBoard__heightAndWidthContainer___3umTm","buttonContainer":"SportsBoard__buttonContainer___280SG","halfWidth":"SportsBoard__halfWidth___3EDUK","addAnotherSports":"SportsBoard__addAnotherSports___3Rm9L","continue":"SportsBoard__continue___3cGJ9","mySport":"SportsBoard__mySport___3r1EX","halfWidthWithSpan":"SportsBoard__halfWidthWithSpan___hjmzy","optionalTag":"SportsBoard__optionalTag___3A5Wa","halfWidthWithSpanError":"SportsBoard__halfWidthWithSpanError___33Vp0","textArea":"SportsBoard__textArea___2sF6Z","textAreaError":"SportsBoard__textAreaError___1584L","simpleInput":"SportsBoard__simpleInput___3p4Dh","simpleInputError":"SportsBoard__simpleInputError___3Vs37","heightContainer":"SportsBoard__heightContainer___78-2N","feetContainer":"SportsBoard__feetContainer___2dUG7","inchesContainer":"SportsBoard__inchesContainer___2GkLX","heightWidth":"SportsBoard__heightWidth___2GxJ5","back":"SportsBoard__back___Vc9yj","mysportContainer":"SportsBoard__mysportContainer___2b-DT","preferedPositionContainer":"SportsBoard__preferedPositionContainer___3brAp","removePadding":"SportsBoard__removePadding___2SlVi","addButtonContainer":"SportsBoard__addButtonContainer___Jk7jA","addButton":"SportsBoard__addButton___2GxBC","removeButton":"SportsBoard__removeButton___3VU-h"};

/***/ },
/* 1538 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1539 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"StaticHeader__materialize-textarea___3P2pA","modal-2463794813":"StaticHeader__modal-2463794813___15IkH","container":"StaticHeader__container___2a3nk","aboutUsHeader":"StaticHeader__aboutUsHeader___2YU44","sportsHeader":"StaticHeader__sportsHeader___1Pke-","bottomText":"StaticHeader__bottomText___3yQn_"};

/***/ },
/* 1540 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"StudentTabs__materialize-textarea___Md4uU","modal-2463794813":"StudentTabs__modal-2463794813___Y7p6j","container":"StudentTabs__container___2m-3W","activeClass":"StudentTabs__activeClass___2wPUe"};

/***/ },
/* 1541 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"TextField__materialize-textarea___sNEG-","modal-2463794813":"TextField__modal-2463794813___1KGxe","container":"TextField__container___hncGR","textFieldContainerOnError":"TextField__textFieldContainerOnError___22b7L","textFieldContainer":"TextField__textFieldContainer___3uP81","label":"TextField__label___3LECa","makeEmailSmall":"TextField__makeEmailSmall___2WhLQ"};

/***/ },
/* 1542 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Totalcounts__materialize-textarea___3Qkkp","modal-2463794813":"Totalcounts__modal-2463794813___1MK-L","container":"Totalcounts__container___3LNfj","counts":"Totalcounts__counts___2gVO5","centerDiv":"Totalcounts__centerDiv___1Xvwc","countsBody":"Totalcounts__countsBody___26Xor","totalNumberText":"Totalcounts__totalNumberText___-BJoC","totalNumber":"Totalcounts__totalNumber___YrdMF","underline":"Totalcounts__underline___3saV1"};

/***/ },
/* 1543 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"TrialNotification__materialize-textarea___3q0C0","modal-2463794813":"TrialNotification__modal-2463794813___3I7m_","container":"TrialNotification__container___1lZ8V","notification":"TrialNotification__notification___3SAIb"};

/***/ },
/* 1544 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"UpgradePopup__materialize-textarea___3dIpd","modal-2463794813":"UpgradePopup__modal-2463794813___6Qunm","container":"UpgradePopup__container___1Pz3S","emptyContainer":"UpgradePopup__emptyContainer___1GmUr","plans":"UpgradePopup__plans___1526N","planContainer":"UpgradePopup__planContainer___2JVBV","planContainerSelected":"UpgradePopup__planContainerSelected___3nn_3","header":"UpgradePopup__header___3lh3f","tickContainer":"UpgradePopup__tickContainer___1ANDY","priceTag":"UpgradePopup__priceTag___M6F_c","dollarTag":"UpgradePopup__dollarTag___3MwaG","desc":"UpgradePopup__desc___hF46-","savingTag":"UpgradePopup__savingTag___1CFNZ","buttonContainer":"UpgradePopup__buttonContainer___1ke38","buttonContainerDashboard":"UpgradePopup__buttonContainerDashboard___I5j7y","absoluteCross":"UpgradePopup__absoluteCross___RLnai"};

/***/ },
/* 1545 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"UpgradeTiles__materialize-textarea___2p8OW","modal-2463794813":"UpgradeTiles__modal-2463794813___1VhmV","container":"UpgradeTiles__container___2c2ao","smallContainer":"UpgradeTiles__smallContainer___YXS9h","tilesContainer":"UpgradeTiles__tilesContainer___2_KjI","upgradeText":"UpgradeTiles__upgradeText___1YXUh","tiles":"UpgradeTiles__tiles___19Urf","tryButton":"UpgradeTiles__tryButton___3hT59"};

/***/ },
/* 1546 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"User__materialize-textarea___1FlQY","modal-2463794813":"User__modal-2463794813___1ougu","container":"User__container___4BLL-","userContainer":"User__userContainer___2aX64","profileInfo":"User__profileInfo___17G5v","image":"User__image___3mVtu","description":"User__description___3pX2l","playerName":"User__playerName___2QsOZ","sports":"User__sports___2662Z","location":"User__location___2PUnN","changeImage":"User__changeImage___HFHG_","changeImageText":"User__changeImageText___cAPoY","fileInput":"User__fileInput___2zXDH","twitterIcon":"User__twitterIcon___2sbBl","instaIcon":"User__instaIcon___3pKKC","shareIcon":"User__shareIcon___2vNTR"};

/***/ },
/* 1547 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"UserDesc__materialize-textarea___2qc_7","modal-2463794813":"UserDesc__modal-2463794813___2sWy1","container":"UserDesc__container___3ruDB","userDescContainer":"UserDesc__userDescContainer___2xhyv","blackHeader":"UserDesc__blackHeader___3o0rv","desciption":"UserDesc__desciption___iYDni","videoheader":"UserDesc__videoheader___28aod","seeAllVideos":"UserDesc__seeAllVideos___2cc4v","videoSection":"UserDesc__videoSection___UZ4Xl","videoBox":"UserDesc__videoBox___3zDQK","video":"UserDesc__video___5yux_","videoImage":"UserDesc__videoImage___eEMC7","titile":"UserDesc__titile___3RJoU","playbutton":"UserDesc__playbutton___92BNt","playButtonImage":"UserDesc__playButtonImage___4k_PN","editIcon":"UserDesc__editIcon___23PuI","socialLinks":"UserDesc__socialLinks___2e3ZS"};

/***/ },
/* 1548 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"UserInfo__materialize-textarea___2LdWe","modal-2463794813":"UserInfo__modal-2463794813___1-PJA","container":"UserInfo__container___3TyR8","userInfoContainer":"UserInfo__userInfoContainer___2aHj6","mainHeader":"UserInfo__mainHeader___35Y5l","blackHeader":"UserInfo__blackHeader___230Q2","otherText":"UserInfo__otherText___3mI_C","removePadding":"UserInfo__removePadding___1uCdX","dataBox":"UserInfo__dataBox___1SLJL","gameName":"UserInfo__gameName___2LDap","position":"UserInfo__position___3ZXWp","removePaddingReplica":"UserInfo__removePaddingReplica___3n0Ey","attackType":"UserInfo__attackType___cF6oE","positionHeader":"UserInfo__positionHeader___1pRBY","icon":"UserInfo__icon___2p5LT","topSpace":"UserInfo__topSpace___2s4-4"};

/***/ },
/* 1549 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"ValidateCoach__materialize-textarea___vUsy-","modal-2463794813":"ValidateCoach__modal-2463794813___2IGXR","container":"ValidateCoach__container___3uEN4","plans":"ValidateCoach__plans___SaA-W","planContainer":"ValidateCoach__planContainer___3VIbc","planContainerSelected":"ValidateCoach__planContainerSelected___p9MfY","header":"ValidateCoach__header___18FHE","tickContainer":"ValidateCoach__tickContainer___1fbzp","priceTag":"ValidateCoach__priceTag___3RVfX","dollarTag":"ValidateCoach__dollarTag___3rAUm","desc":"ValidateCoach__desc___3_KTP","savingTag":"ValidateCoach__savingTag___1tEFJ","buttonContainer":"ValidateCoach__buttonContainer___2zOA0","buttonContainerDashboard":"ValidateCoach__buttonContainerDashboard___2OwD_","absoluteCross":"ValidateCoach__absoluteCross___23N19"};

/***/ },
/* 1550 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoContainer":"BackgroundVideo__videoContainer___2vMcZ","videoWidth":"BackgroundVideo__videoWidth___W-ZKv","videoOverlay":"BackgroundVideo__videoOverlay___3jNwu"};

/***/ },
/* 1551 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"videoContainer":"VideoPlayer__videoContainer___3rHjj","closeButton":"VideoPlayer__closeButton___2rV6Q"};

/***/ },
/* 1552 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"About__materialize-textarea___30pbx","modal-2463794813":"About__modal-2463794813___1-6AU","container":"About__container___12LOL","content":"About__content___3AzRM","overviewContainer":"About__overviewContainer___15VeK","darkHeaderSmall":"About__darkHeaderSmall___3uh9S","technologyContainer":"About__technologyContainer___2wA07","imageContainer":"About__imageContainer___338HT","darkHeader":"About__darkHeader___1pP96","bigHeader":"About__bigHeader___27xn-","desc":"About__desc___2lwFi","removePadding":"About__removePadding___3Gj7L","smallAboutUs":"About__smallAboutUs___4dV2b","bigAboutUs":"About__bigAboutUs___1T76k","tabContainer":"About__tabContainer____kNS3"};

/***/ },
/* 1553 */
1538,
/* 1554 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"styles__materialize-textarea___26UP0","modal-2463794813":"styles__modal-2463794813___3_d_H","container":"styles__container___22HPW","buttonContainer":"styles__buttonContainer___2Dx4d","removePadding":"styles__removePadding___1iRCS","actionContainer":"styles__actionContainer___36AZT","successMessage":"styles__successMessage___2-k5p","autoComplete":"styles__autoComplete___10F3Y","autoCompleteToolbox":"styles__autoCompleteToolbox___2rJsm","autoCompleteToolboxOnError":"styles__autoCompleteToolboxOnError___1amxg","autoCompleteState":"styles__autoCompleteState___1-1-3","halfWidthWithSpan":"styles__halfWidthWithSpan___2a1xS","halfWidthWithSpanWithoutTopSpace":"styles__halfWidthWithSpanWithoutTopSpace___x8e_N","halfWidthWithSpanWithoutTopSpaceOnError":"styles__halfWidthWithSpanWithoutTopSpaceOnError___2r0Fu","halfWidthWithSpanOnError":"styles__halfWidthWithSpanOnError___tBV4W"};

/***/ },
/* 1555 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"styles__materialize-textarea___T8mt7","modal-2463794813":"styles__modal-2463794813___2YBfT","container":"styles__container___2GlcX","buttonContainer":"styles__buttonContainer___3sfUt","removePadding":"styles__removePadding___1bcw2","actionContainer":"styles__actionContainer___1Asds","successMessage":"styles__successMessage___VQ2sJ"};

/***/ },
/* 1556 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___2GsRC","modal-2463794813":"style__modal-2463794813___1LY4q","container":"style__container___1Z_Ew","activeClass":"style__activeClass___1wrR-","tabViews":"style__tabViews___2CsEU","buttonContainer":"style__buttonContainer___9nQC1","removePadding":"style__removePadding___cN_jT","actionContainer":"style__actionContainer___YCwfo"};

/***/ },
/* 1557 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AddCollege__materialize-textarea___OVW5f","modal-2463794813":"AddCollege__modal-2463794813___1_054","container":"AddCollege__container___3jRI4","buttonContainer":"AddCollege__buttonContainer___3TrJ5","removePadding":"AddCollege__removePadding___1hD6-","actionContainer":"AddCollege__actionContainer___t_oLO","successMessage":"AddCollege__successMessage___CCtWV","autoComplete":"AddCollege__autoComplete___onvSh","autoCompleteToolbox":"AddCollege__autoCompleteToolbox___3pBla","autoCompleteToolboxOnError":"AddCollege__autoCompleteToolboxOnError___2_Iiz","autoCompleteState":"AddCollege__autoCompleteState___3o-QP","halfWidthWithSpan":"AddCollege__halfWidthWithSpan___Xkr2h","halfWidthWithSpanWithoutTopSpace":"AddCollege__halfWidthWithSpanWithoutTopSpace___2-d-q","halfWidthWithSpanWithoutTopSpaceOnError":"AddCollege__halfWidthWithSpanWithoutTopSpaceOnError___XIg9t","halfWidthWithSpanOnError":"AddCollege__halfWidthWithSpanOnError___LXBFX","selectPlan":"AddCollege__selectPlan___2yTWB","desc":"AddCollege__desc___1t2GJ","data":"AddCollege__data___3GDNj","hbcuSpan":"AddCollege__hbcuSpan___2NyAz","addMargin":"AddCollege__addMargin___20VsS"};

/***/ },
/* 1558 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"styles__materialize-textarea___1QlQk","modal-2463794813":"styles__modal-2463794813___2dhC9","container":"styles__container___3O2Yc","buttonContainer":"styles__buttonContainer___9vpYk","removePadding":"styles__removePadding___3yatd","actionContainer":"styles__actionContainer___1XBHL","successMessage":"styles__successMessage___s6T4F","autoComplete":"styles__autoComplete___QsG9J","autoCompleteToolbox":"styles__autoCompleteToolbox___3U2Mk","autoCompleteToolboxOnError":"styles__autoCompleteToolboxOnError___4dqyz","autoCompleteState":"styles__autoCompleteState___1dWNi","halfWidthWithSpan":"styles__halfWidthWithSpan___2XEuB","halfWidthWithSpanWithoutTopSpace":"styles__halfWidthWithSpanWithoutTopSpace___2HJ2M","halfWidthWithSpanWithoutTopSpaceOnError":"styles__halfWidthWithSpanWithoutTopSpaceOnError___19Dxb","halfWidthWithSpanOnError":"styles__halfWidthWithSpanOnError___1Vhox","selectCollege":"styles__selectCollege___1yXM4"};

/***/ },
/* 1559 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Modify__materialize-textarea___N-Jpl","modal-2463794813":"Modify__modal-2463794813___2Nt2V","container":"Modify__container___1IWTE","buttonContainer":"Modify__buttonContainer___2cetu","removePadding":"Modify__removePadding___8Rw72","actionContainer":"Modify__actionContainer___1vlGh","successMessage":"Modify__successMessage___2Z7vK","autoComplete":"Modify__autoComplete___2McG1","autoCompleteToolbox":"Modify__autoCompleteToolbox___1pDg8","autoCompleteToolboxOnError":"Modify__autoCompleteToolboxOnError___U5lbM","autoCompleteState":"Modify__autoCompleteState___20R3g","halfWidthWithSpan":"Modify__halfWidthWithSpan___YwMb9","halfWidthWithSpanWithoutTopSpace":"Modify__halfWidthWithSpanWithoutTopSpace___12DVf","halfWidthWithSpanWithoutTopSpaceOnError":"Modify__halfWidthWithSpanWithoutTopSpaceOnError___2358Q","halfWidthWithSpanOnError":"Modify__halfWidthWithSpanOnError___311na","selectPlan":"Modify__selectPlan___3FW54","desc":"Modify__desc___9eKBo","data":"Modify__data___y3Q3w","hbcuSpan":"Modify__hbcuSpan___1lR4J","addMargin":"Modify__addMargin___2cQnF"};

/***/ },
/* 1560 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___1bqag","modal-2463794813":"style__modal-2463794813___1fKAI","container":"style__container___BhbsR","activeClass":"style__activeClass___2s8kK","tabViews":"style__tabViews___xRkca"};

/***/ },
/* 1561 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"styles__materialize-textarea___1VIXx","modal-2463794813":"styles__modal-2463794813___37Ge3","container":"styles__container___3BiXg","selectedButton":"styles__selectedButton___nOlwZ","plainButton":"styles__plainButton___2cbFQ","selectPlan":"styles__selectPlan___3Go20","buttonContainer":"styles__buttonContainer___1WbmI","removePadding":"styles__removePadding___crb2x","actionContainer":"styles__actionContainer___21k5g","successMessage":"styles__successMessage___2pYBH"};

/***/ },
/* 1562 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Explorer__materialize-textarea___y9lIG","modal-2463794813":"Explorer__modal-2463794813___30Nhz","container":"Explorer__container___yA8gt","removePadding":"Explorer__removePadding___3VUdL","selectedButton":"Explorer__selectedButton___3nGEk","plainButton":"Explorer__plainButton___3CZHz","filterType":"Explorer__filterType___1nRJa"};

/***/ },
/* 1563 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Rtiles__materialize-textarea___2lnxs","modal-2463794813":"Rtiles__modal-2463794813___1kPaZ","container":"Rtiles__container___r2k9g","tile":"Rtiles__tile___3OyZV","colgeIcon":"Rtiles__colgeIcon___2nmkA","collegeName":"Rtiles__collegeName___2rYqD","sportName":"Rtiles__sportName___3zU5V","lightText":"Rtiles__lightText___2ETiA","email":"Rtiles__email___1PsxJ","icon":"Rtiles__icon___3iE_S","userNameIcon":"Rtiles__userNameIcon___1gLVy","veryLightText":"Rtiles__veryLightText___ClqLW","tileFooter":"Rtiles__tileFooter___3In5X","interestedButton":"Rtiles__interestedButton___JPpMn","greenButton":"Rtiles__greenButton___3wyNT","inviteToCampButton":"Rtiles__inviteToCampButton___1Ouse","needMoreFilmsButton":"Rtiles__needMoreFilmsButton___RrHfa","addedToWatchListButton":"Rtiles__addedToWatchListButton___2xTZE","ignoredButton":"Rtiles__ignoredButton___1Kdd_","sendContactInfoButton":"Rtiles__sendContactInfoButton___3i_Jv","heartIcon":"Rtiles__heartIcon___2akWS"};

/***/ },
/* 1564 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"UpgradeStudent__materialize-textarea___3ucyP","modal-2463794813":"UpgradeStudent__modal-2463794813___8_-H6","container":"UpgradeStudent__container___3Mc-v","selectedButton":"UpgradeStudent__selectedButton____bJvo","plainButton":"UpgradeStudent__plainButton___36x4B","selectPlan":"UpgradeStudent__selectPlan___o9sV_","buttonContainer":"UpgradeStudent__buttonContainer___12dQY","removePadding":"UpgradeStudent__removePadding___nfeHC","actionContainer":"UpgradeStudent__actionContainer___2ehx_","successMessage":"UpgradeStudent__successMessage___3KYIV"};

/***/ },
/* 1565 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___3Txp1","modal-2463794813":"style__modal-2463794813___PYcCL","container":"style__container___2SWAE","activeClass":"style__activeClass___bJDwH","removePadding":"style__removePadding___HckqG","buttonContainer":"style__buttonContainer___1oDLa","dummyContainer":"style__dummyContainer___HPB00","tabViews":"style__tabViews___129Vz","loginContainer":"style__loginContainer___2-4kj","addPadding":"style__addPadding___12p3P"};

/***/ },
/* 1566 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"style__materialize-textarea___3VpiO","modal-2463794813":"style__modal-2463794813___22fk3","container":"style__container___2IBeN","buttonEdit":"style__buttonEdit___2xZNL","tile":"style__tile___19p0g","colgeIcon":"style__colgeIcon___1REnx","collegeName":"style__collegeName___LxFeF","sportName":"style__sportName___3cT4s","lightText":"style__lightText___EOIWt","email":"style__email___QlQA7","icon":"style__icon___3a33U","userNameIcon":"style__userNameIcon___2fc39","veryLightText":"style__veryLightText___2tiDI","tileFooter":"style__tileFooter___3_b-S","interestedButton":"style__interestedButton___318Sr","greenButton":"style__greenButton___21zRC","inviteToCampButton":"style__inviteToCampButton___3DJoG","needMoreFilmsButton":"style__needMoreFilmsButton___ykK9r","addedToWatchListButton":"style__addedToWatchListButton___VItGv","ignoredButton":"style__ignoredButton___KSnQQ","sendContactInfoButton":"style__sendContactInfoButton___2MJIK","heartIcon":"style__heartIcon___1Sq0U"};

/***/ },
/* 1567 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"UserInfo__materialize-textarea___19zz1","modal-2463794813":"UserInfo__modal-2463794813___1oaTz","container":"UserInfo__container___3cPL0","studentContainer":"UserInfo__studentContainer___38Vhd","header":"UserInfo__header___3qdvG","imageContainer":"UserInfo__imageContainer___K_KkI","textContainer":"UserInfo__textContainer___1bjKX","userIcon":"UserInfo__userIcon___2voHS","removePadding":"UserInfo__removePadding___32BEK","deleteButtonContainer":"UserInfo__deleteButtonContainer___3adAO"};

/***/ },
/* 1568 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loginContainer":"Login__loginContainer___1YF6O","loginBanner":"Login__loginBanner___l_TRS","inputFileds":"Login__inputFileds___wTJ5E"};

/***/ },
/* 1569 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"atheleteContainer":"Athelete__atheleteContainer___3DO2l","bannerAthelete":"Athelete__bannerAthelete___2lWx6"};

/***/ },
/* 1570 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"actionableContainer":"AthleteById__actionableContainer___14UTC","profileContainer":"AthleteById__profileContainer___21oBb","loaderContainer":"AthleteById__loaderContainer___2kpDw"};

/***/ },
/* 1571 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"Coach-registration__container___2u_7z","bannerContainer":"Coach-registration__bannerContainer___36h6m"};

/***/ },
/* 1572 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"atheleteContainer":"Coach__atheleteContainer___Ui3qK","bannerAthelete":"Coach__bannerAthelete___bxTzR"};

/***/ },
/* 1573 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Contact__materialize-textarea___UjxFY","modal-2463794813":"Contact__modal-2463794813___OtrGA","container":"Contact__container___1Ezb9","handleChange":"Contact__handleChange___3GPyl","gotQuestionOrQur":"Contact__gotQuestionOrQur___1qv83","navbarContainer":"Contact__navbarContainer___2_JWx","contactContainer":"Contact__contactContainer___3CN9n","header":"Contact__header___2WDvs","headerText":"Contact__headerText___1Brk1","bigHeader":"Contact__bigHeader___3-o3P","desc":"Contact__desc___1833v","formHeader":"Contact__formHeader___3igid","formContainer":"Contact__formContainer___P1hMk","halfInput":"Contact__halfInput___3lMb_","halfInputOnError":"Contact__halfInputOnError___3Lwil","secondHalfInput":"Contact__secondHalfInput___2Nbsv","secondHalfInputOnError":"Contact__secondHalfInputOnError___32kVM","fullInput":"Contact__fullInput___3JHvF","fullInputOnError":"Contact__fullInputOnError___1xaYz","messageContainer":"Contact__messageContainer___1Z4Jq","messageContainerOnError":"Contact__messageContainerOnError___1bstH","buttonContainer":"Contact__buttonContainer___1HnfE","footerContainer":"Contact__footerContainer___tNdfE","addressInSmall":"Contact__addressInSmall___14OVf","removePadding":"Contact__removePadding___1Brgm","okbuttonModal":"Contact__okbuttonModal___2yrCz","address":"Contact__address___TS11o","contactInSmall":"Contact__contactInSmall___tLl9c"};

/***/ },
/* 1574 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"dashboardContainer":"Dashboard__dashboardContainer___OVq1V"};

/***/ },
/* 1575 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"ForgotPassword__materialize-textarea___2RcH5","modal-2463794813":"ForgotPassword__modal-2463794813___3I9Wt","container":"ForgotPassword__container___5dLt3","centerDiv":"ForgotPassword__centerDiv___FFR_F","holder":"ForgotPassword__holder___2H3r-","joinUsContainer":"ForgotPassword__joinUsContainer___3iyN8","joinUsBanner":"ForgotPassword__joinUsBanner___30x2f","joinUsDetails":"ForgotPassword__joinUsDetails___3PPAk","forgotPasswordSucess":"ForgotPassword__forgotPasswordSucess___1QKZd","successFull":"ForgotPassword__successFull___17r3S"};

/***/ },
/* 1576 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"homePageContainer":"Home__homePageContainer___2cwKa","column":"Home__column___1xipn"};

/***/ },
/* 1577 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loginContainer":"Login__loginContainer___3chYj","loginBanner":"Login__loginBanner___2Rp5Q","inputFileds":"Login__inputFileds___zJoon"};

/***/ },
/* 1578 */
1538,
/* 1579 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"atheleteContainer":"Parent__atheleteContainer___26GRL","bannerAthelete":"Parent__bannerAthelete___wnzdF"};

/***/ },
/* 1580 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"Payment__container___1M1H_","button":"Payment__button___3UyHD","dropInContainer":"Payment__dropInContainer___oielT","navBarSpace":"Payment__navBarSpace___23gnN","removePadding":"Payment__removePadding___1ttCB","buttonContainer":"Payment__buttonContainer___2GTL_","greenIndicator":"Payment__greenIndicator___11zdL"};

/***/ },
/* 1581 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"profileContainer":"Profile-view__profileContainer___2aoxW","loaderContainer":"Profile-view__loaderContainer___2lFb3"};

/***/ },
/* 1582 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"profileContainer":"Profile__profileContainer___HEBXF"};

/***/ },
/* 1583 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"AthleteById__materialize-textarea___Vg8HI","modal-2463794813":"AthleteById__modal-2463794813___s_neb","container":"AthleteById__container___HPQPg","headerContainer":"AthleteById__headerContainer___3MK_b","actionableButtonContainer":"AthleteById__actionableButtonContainer___3crVv","successfullMessage":"AthleteById__successfullMessage___1myw1","actionContainer":"AthleteById__actionContainer___2ly91","greenMessage":"AthleteById__greenMessage___nGqNK","infoContainer":"AthleteById__infoContainer___1JTWs","navBar":"AthleteById__navBar___17v_Q","actionableContainer":"AthleteById__actionableContainer___gTS83","loaderContainer":"AthleteById__loaderContainer___1Y__u"};

/***/ },
/* 1584 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"joinUsContainer":"Register__joinUsContainer___2vAJG","joinUsBanner":"Register__joinUsBanner___3dpjl","joinUsDetails":"Register__joinUsDetails___2g_8J"};

/***/ },
/* 1585 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"profileContainer":"Parent__profileContainer___3uxA_"};

/***/ },
/* 1586 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"Settings__container___1nGlR","centerDiv":"Settings__centerDiv___36DfS","holder":"Settings__holder___1oXUI","joinUsContainer":"Settings__joinUsContainer___1SKCC","joinUsBanner":"Settings__joinUsBanner___1_6Cf","joinUsDetails":"Settings__joinUsDetails___YV8a_","removePadding":"Settings__removePadding___1uQIK"};

/***/ },
/* 1587 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Sports__materialize-textarea___2fho7","modal-2463794813":"Sports__modal-2463794813___VZ6We","container":"Sports__container___2zrDe","header":"Sports__header___yb302","sportsWeSupport":"Sports__sportsWeSupport___1Hfjr","bigHeader":"Sports__bigHeader___3JjRp","darkHeader":"Sports__darkHeader___2Cvli","desc":"Sports__desc___3OaQJ","createProfile":"Sports__createProfile___3aMvs","imageContainer":"Sports__imageContainer___20AiD","moreSportsComingSoon":"Sports__moreSportsComingSoon___sUZm6","plansAndPricing":"Sports__plansAndPricing___1kHJA","listContainer":"Sports__listContainer___29iqy","buynow":"Sports__buynow___2LFt-","buynowContainer":"Sports__buynowContainer___1_BnY","priceValue":"Sports__priceValue___2aDmt","coverText":"Sports__coverText___4VwJd","footerContainer":"Sports__footerContainer___13k6L","pricingHeader":"Sports__pricingHeader___vvmfb","imageContainerInSmall":"Sports__imageContainerInSmall___2kauA"};

/***/ },
/* 1588 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"Terms__materialize-textarea___1vYbb","modal-2463794813":"Terms__modal-2463794813___216J9","container":"Terms__container___LLPwx","header":"Terms__header___3HBr5","sportsWeSupport":"Terms__sportsWeSupport___25DpA","bigHeader":"Terms__bigHeader___1VV5A","darkHeader":"Terms__darkHeader___wSaTz","desc":"Terms__desc___3i96M","createProfile":"Terms__createProfile___1JPA9","imageContainer":"Terms__imageContainer___2Di18","moreSportsComingSoon":"Terms__moreSportsComingSoon___1zOPt","plansAndPricing":"Terms__plansAndPricing___3aLaM","listContainer":"Terms__listContainer___2Ybkm","buynow":"Terms__buynow___38Zij","buynowContainer":"Terms__buynowContainer___1jf1Z","priceValue":"Terms__priceValue___1Io32","coverText":"Terms__coverText___x1Lgb","footerContainer":"Terms__footerContainer___e3jQd","pricingHeader":"Terms__pricingHeader___2d4JP","imageContainerInSmall":"Terms__imageContainerInSmall___3rOG2"};

/***/ },
/* 1589 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"materialize-textarea":"common__materialize-textarea___25Fjl","modal-2463794813":"common__modal-2463794813___2a0_N","container":"common__container___2GEyh"};

/***/ },
/* 1590 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"suggestions":"theme__suggestions___3UbjO","up":"theme__up___2-Ks7"};

/***/ },
/* 1591 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"suggestions":"theme__suggestions___2tU4Z","up":"theme__up___3x2pM"};

/***/ },
/* 1592 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"suggestions":"theme__suggestions___1H82R","up":"theme__up___1tL-a"};

/***/ },
/* 1593 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"suggestions":"theme__suggestions___Mv6xf","up":"theme__up___W8g9n"};

/***/ },
/* 1594 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"index__root___4PyOE"};

/***/ },
/* 1595 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1595);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1605);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createArrayFromMixed = __webpack_require__(1598);
	var getMarkupWrap = __webpack_require__(1600);
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1601 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1602 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1602);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1604 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1604);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1606 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(n){return n&&"object"==typeof n&&"default"in n?n.default:n}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(2491)),valueEqual=_interopDefault(__webpack_require__(2503));__webpack_require__(2500);var invariant=_interopDefault(__webpack_require__(2499));function _extends(){return(_extends=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(n[a]=e[a])}return n}).apply(this,arguments)}function addLeadingSlash(n){return"/"===n.charAt(0)?n:"/"+n}function stripLeadingSlash(n){return"/"===n.charAt(0)?n.substr(1):n}function hasBasename(n,t){return new RegExp("^"+t+"(\\/|\\?|#|$)","i").test(n)}function stripBasename(n,t){return hasBasename(n,t)?n.substr(t.length):n}function stripTrailingSlash(n){return"/"===n.charAt(n.length-1)?n.slice(0,-1):n}function parsePath(n){var t=n||"/",e="",a="",o=t.indexOf("#");-1!==o&&(a=t.substr(o),t=t.substr(0,o));var r=t.indexOf("?");return-1!==r&&(e=t.substr(r),t=t.substr(0,r)),{pathname:t,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(n){var t=n.pathname,e=n.search,a=n.hash,o=t||"/";return e&&"?"!==e&&(o+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(o+="#"===a.charAt(0)?a:"#"+a),o}function createLocation(n,t,e,a){var o;"string"==typeof n?(o=parsePath(n)).state=t:(void 0===(o=_extends({},n)).pathname&&(o.pathname=""),o.search?"?"!==o.search.charAt(0)&&(o.search="?"+o.search):o.search="",o.hash?"#"!==o.hash.charAt(0)&&(o.hash="#"+o.hash):o.hash="",void 0!==t&&void 0===o.state&&(o.state=t));try{o.pathname=decodeURI(o.pathname)}catch(n){throw n instanceof URIError?new URIError('Pathname "'+o.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):n}return e&&(o.key=e),a?o.pathname?"/"!==o.pathname.charAt(0)&&(o.pathname=resolvePathname(o.pathname,a.pathname)):o.pathname=a.pathname:o.pathname||(o.pathname="/"),o}function locationsAreEqual(n,t){return n.pathname===t.pathname&&n.search===t.search&&n.hash===t.hash&&n.key===t.key&&valueEqual(n.state,t.state)}function createTransitionManager(){var r=null;var a=[];return{setPrompt:function(n){return r=n,function(){r===n&&(r=null)}},confirmTransitionTo:function(n,t,e,a){if(null!=r){var o="function"==typeof r?r(n,t):r;"string"==typeof o?"function"==typeof e?e(o,a):a(!0):a(!1!==o)}else a(!0)},appendListener:function(n){var t=!0;function e(){t&&n.apply(void 0,arguments)}return a.push(e),function(){t=!1,a=a.filter(function(n){return n!==e})}},notifyListeners:function(){for(var n=arguments.length,t=new Array(n),e=0;e<n;e++)t[e]=arguments[e];a.forEach(function(n){return n.apply(void 0,t)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(n,t){t(window.confirm(n))}function supportsHistory(){var n=window.navigator.userAgent;return(-1===n.indexOf("Android 2.")&&-1===n.indexOf("Android 4.0")||-1===n.indexOf("Mobile Safari")||-1!==n.indexOf("Chrome")||-1!==n.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(n){void 0===n.state&&navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(n){return{}}}function createBrowserHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var c=window.history,s=supportsHistory(),t=!supportsPopStateOnHashChange(),e=n,a=e.forceRefresh,h=void 0!==a&&a,o=e.getUserConfirmation,u=void 0===o?getConfirmation:o,r=e.keyLength,i=void 0===r?6:r,f=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"";function l(n){var t=n||{},e=t.key,a=t.state,o=window.location,r=o.pathname+o.search+o.hash;return f&&(r=stripBasename(r,f)),createLocation(r,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(n){_extends(T,n),T.length=c.length,v.notifyListeners(T.location,T.action)}function g(n){isExtraneousPopstateEvent(n)||w(l(n.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(t){if(m)m=!1,p();else{v.confirmTransitionTo(t,"POP",u,function(n){n?p({action:"POP",location:t}):function(n){var t=T.location,e=H.indexOf(t.key);-1===e&&(e=0);var a=H.indexOf(n.key);-1===a&&(a=0);var o=e-a;o&&(m=!0,L(o))}(t)})}}var y=l(getHistoryState()),H=[y.key];function x(n){return f+createPath(n)}function L(n){c.go(n)}var O=0;function E(n){1===(O+=n)&&1===n?(window.addEventListener(PopStateEvent,g),t&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),t&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:c.length,action:"POP",location:y,createHref:x,push:function(n,t){var i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.pushState({key:e,state:a},null,t),h)window.location.href=t;else{var o=H.indexOf(T.location.key),r=H.slice(0,-1===o?0:o+1);r.push(i.key),H=r,p({action:"PUSH",location:i})}else window.location.href=t}})},replace:function(n,t){var r="REPLACE",i=createLocation(n,t,d(),T.location);v.confirmTransitionTo(i,r,u,function(n){if(n){var t=x(i),e=i.key,a=i.state;if(s)if(c.replaceState({key:e,state:a},null,t),h)window.location.replace(t);else{var o=H.indexOf(T.location.key);-1!==o&&(H[o]=i.key),p({action:r,location:i})}else window.location.replace(t)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(n){void 0===n&&(n=!1);var t=v.setPrompt(n);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),t()}},listen:function(n){var t=v.appendListener(n);return E(1),function(){E(-1),t()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(n){return"!"===n.charAt(0)?n:"!/"+stripLeadingSlash(n)},decodePath:function(n){return"!"===n.charAt(0)?n.substr(1):n}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function getHashPath(){var n=window.location.href,t=n.indexOf("#");return-1===t?"":n.substring(t+1)}function pushHashPath(n){window.location.hash=n}function replaceHashPath(n){var t=window.location.href.indexOf("#");window.location.replace(window.location.href.slice(0,0<=t?t:0)+"#"+n)}function createHashHistory(n){void 0===n&&(n={}),canUseDOM||invariant(!1);var t=window.history,e=(supportsGoWithoutReloadUsingHash(),n),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,o=e.hashType,r=void 0===o?"slash":o,c=n.basename?stripTrailingSlash(addLeadingSlash(n.basename)):"",s=HashPathCoders[r],h=s.encodePath,u=s.decodePath;function f(){var n=u(getHashPath());return c&&(n=stripBasename(n,c)),createLocation(n)}var l=createTransitionManager();function d(n){_extends(E,n),E.length=t.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var n=getHashPath(),t=h(n);if(n!==t)replaceHashPath(t);else{var e=f(),a=E.location;if(!v&&locationsAreEqual(a,e))return;if(p===createPath(e))return;p=null,function(t){if(v)v=!1,d();else{l.confirmTransitionTo(t,"POP",i,function(n){n?d({action:"POP",location:t}):function(n){var t=E.location,e=y.lastIndexOf(createPath(t));-1===e&&(e=0);var a=y.lastIndexOf(createPath(n));-1===a&&(a=0);var o=e-a;o&&(v=!0,H(o))}(t)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(n){t.go(n)}var x=0;function L(n){1===(x+=n)&&1===n?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:t.length,action:"POP",location:w,createHref:function(n){return"#"+h(c+createPath(n))},push:function(n,t){var r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,"PUSH",i,function(n){if(n){var t=createPath(r),e=h(c+t);if(getHashPath()!==e){p=t,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),o=y.slice(0,-1===a?0:a+1);o.push(t),y=o,d({action:"PUSH",location:r})}else d()}})},replace:function(n,t){var o="REPLACE",r=createLocation(n,void 0,void 0,E.location);l.confirmTransitionTo(r,o,i,function(n){if(n){var t=createPath(r),e=h(c+t);getHashPath()!==e&&(p=t,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=t),d({action:o,location:r})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(n){void 0===n&&(n=!1);var t=l.setPrompt(n);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),t()}},listen:function(n){var t=l.appendListener(n);return L(1),function(){L(-1),t()}}};return E}function clamp(n,t,e){return Math.min(Math.max(n,t),e)}function createMemoryHistory(n){void 0===n&&(n={});var t=n,o=t.getUserConfirmation,e=t.initialEntries,a=void 0===e?["/"]:e,r=t.initialIndex,i=void 0===r?0:r,c=t.keyLength,s=void 0===c?6:c,h=createTransitionManager();function u(n){_extends(g,n),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,s)}var l=clamp(i,0,a.length-1),d=a.map(function(n){return createLocation(n,void 0,"string"==typeof n?f():n.key||f())}),v=createPath;function p(n){var t=clamp(g.index+n,0,g.entries.length-1),e=g.entries[t];h.confirmTransitionTo(e,"POP",o,function(n){n?u({action:"POP",location:e,index:t}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(n,t){var a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,"PUSH",o,function(n){if(n){var t=g.index+1,e=g.entries.slice(0);e.length>t?e.splice(t,e.length-t,a):e.push(a),u({action:"PUSH",location:a,index:t,entries:e})}})},replace:function(n,t){var e="REPLACE",a=createLocation(n,t,f(),g.location);h.confirmTransitionTo(a,e,o,function(n){n&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(n){var t=g.index+n;return 0<=t&&t<g.entries.length},block:function(n){return void 0===n&&(n=!1),h.setPrompt(n)},listen:function(n){return h.appendListener(n)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(1609)('createHashHistory');
	module.exports = __webpack_require__(114).createHashHistory;


/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(format, subs) {
	    var index = 0;
	    var message =
	      'Warning: ' +
	      (subs.length > 0
	        ? format.replace(/%s/g, function() {
	            return subs[index++];
	          })
	        : format);
	
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	
	    try {
	      // --- Welcome to debugging history ---
	      // This error was thrown as a convenience so that you can use the
	      // stack trace to find the callsite that triggered this warning.
	      throw new Error(message);
	    } catch (e) {}
	  };
	}
	
	module.exports = function(member) {
	  printWarning(
	    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
	      'Support for the latter will be removed in the next major release.',
	    [member, member]
	  );
	};


/***/ },
/* 1610 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1611 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 1612 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(78);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	
	var toString = Object.prototype.toString
	var type = function(obj) {
	  return toString.call(obj).slice(8, -1);
	}
	
	var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
	  getAllKeys(source).forEach(function(key) {
	    if (hasOwnProperty.call(source, key)) {
	      target[key] = source[key];
	    }
	  });
	  return target;
	};
	
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
	  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
	  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };
	
	/* istanbul ignore next */
	function copy(object) {
	  if (Array.isArray(object)) {
	    return assign(object.constructor(object.length), object)
	  } else if (type(object) === 'Map') {
	    return new Map(object)
	  } else if (type(object) === 'Set') {
	    return new Set(object)
	  } else if (object && typeof object === 'object') {
	    var prototype = Object.getPrototypeOf(object);
	    return assign(Object.create(prototype), object);
	  } else {
	    return object;
	  }
	}
	
	function newContext() {
	  var commands = assign({}, defaultCommands);
	  update.extend = function(directive, fn) {
	    commands[directive] = fn;
	  };
	  update.isEquals = function(a, b) { return a === b; };
	
	  return update;
	
	  function update(object, spec) {
	    if (typeof spec === 'function') {
	      spec = { $apply: spec };
	    }
	
	    if (!(Array.isArray(object) && Array.isArray(spec))) {
	      invariant(
	        !Array.isArray(spec),
	        'update(): You provided an invalid spec to update(). The spec may ' +
	        'not contain an array except as the value of $set, $push, $unshift, ' +
	        '$splice or any custom command allowing an array value.'
	      );
	    }
	
	    invariant(
	      typeof spec === 'object' && spec !== null,
	      'update(): You provided an invalid spec to update(). The spec and ' +
	      'every included key path must be plain objects containing one of the ' +
	      'following commands: %s.',
	      Object.keys(commands).join(', ')
	    );
	
	    var nextObject = object;
	    var index, key;
	    getAllKeys(spec).forEach(function(key) {
	      if (hasOwnProperty.call(commands, key)) {
	        var objectWasNextObject = object === nextObject;
	        nextObject = commands[key](spec[key], nextObject, spec, object);
	        if (objectWasNextObject && update.isEquals(nextObject, object)) {
	          nextObject = object;
	        }
	      } else {
	        var nextValueForKey =
	          type(object) === 'Map'
	            ? update(object.get(key), spec[key])
	            : update(object[key], spec[key]);
	        var nextObjectValue =
	          type(nextObject) === 'Map'
	              ? nextObject.get(key)
	              : nextObject[key];
	        if (!update.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
	          if (nextObject === object) {
	            nextObject = copy(object);
	          }
	          if (type(nextObject) === 'Map') {
	            nextObject.set(key, nextValueForKey);
	          } else {
	            nextObject[key] = nextValueForKey;
	          }
	        }
	      }
	    })
	    return nextObject;
	  }
	
	}
	
	var defaultCommands = {
	  $push: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$push');
	    return value.length ? nextObject.concat(value) : nextObject;
	  },
	  $unshift: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$unshift');
	    return value.length ? value.concat(nextObject) : nextObject;
	  },
	  $splice: function(value, nextObject, spec, originalObject) {
	    invariantSplices(nextObject, spec);
	    value.forEach(function(args) {
	      invariantSplice(args);
	      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
	      splice.apply(nextObject, args);
	    });
	    return nextObject;
	  },
	  $set: function(value, nextObject, spec) {
	    invariantSet(spec);
	    return value;
	  },
	  $toggle: function(targets, nextObject) {
	    invariantSpecArray(targets, '$toggle');
	    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
	
	    targets.forEach(function(target) {
	      nextObjectCopy[target] = !nextObject[target];
	    });
	
	    return nextObjectCopy;
	  },
	  $unset: function(value, nextObject, spec, originalObject) {
	    invariantSpecArray(value, '$unset');
	    value.forEach(function(key) {
	      if (Object.hasOwnProperty.call(nextObject, key)) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        delete nextObject[key];
	      }
	    });
	    return nextObject;
	  },
	  $add: function(value, nextObject, spec, originalObject) {
	    invariantMapOrSet(nextObject, '$add');
	    invariantSpecArray(value, '$add');
	    if (type(nextObject) === 'Map') {
	      value.forEach(function(pair) {
	        var key = pair[0];
	        var value = pair[1];
	        if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
	        nextObject.set(key, value);
	      });
	    } else {
	      value.forEach(function(value) {
	        if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
	        nextObject.add(value);
	      });
	    }
	    return nextObject;
	  },
	  $remove: function(value, nextObject, spec, originalObject) {
	    invariantMapOrSet(nextObject, '$remove');
	    invariantSpecArray(value, '$remove');
	    value.forEach(function(key) {
	      if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
	      nextObject.delete(key);
	    });
	    return nextObject;
	  },
	  $merge: function(value, nextObject, spec, originalObject) {
	    invariantMerge(nextObject, value);
	    getAllKeys(value).forEach(function(key) {
	      if (value[key] !== nextObject[key]) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        nextObject[key] = value[key];
	      }
	    });
	    return nextObject;
	  },
	  $apply: function(value, original) {
	    invariantApply(value);
	    return value(original);
	  }
	};
	
	var contextForExport = newContext();
	
	module.exports = contextForExport;
	module.exports.default = contextForExport;
	module.exports.newContext = newContext;
	
	// invariants
	
	function invariantPushAndUnshift(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  invariantSpecArray(spec[command], command)
	}
	
	function invariantSpecArray(spec, command) {
	  invariant(
	    Array.isArray(spec),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    spec
	  );
	}
	
	function invariantSplices(value, spec) {
	  invariant(
	    Array.isArray(value),
	    'Expected $splice target to be an array; got %s',
	    value
	  );
	  invariantSplice(spec['$splice']);
	}
	
	function invariantSplice(value) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	    'Did you forget to wrap your parameters in an array?',
	    value
	  );
	}
	
	function invariantApply(fn) {
	  invariant(
	    typeof fn === 'function',
	    'update(): expected spec of $apply to be a function; got %s.',
	    fn
	  );
	}
	
	function invariantSet(spec) {
	  invariant(
	    Object.keys(spec).length === 1,
	    'Cannot have more than one key in an object with $set'
	  );
	}
	
	function invariantMerge(target, specValue) {
	  invariant(
	    specValue && typeof specValue === 'object',
	    'update(): $merge expects a spec of type \'object\'; got %s',
	    specValue
	  );
	  invariant(
	    target && typeof target === 'object',
	    'update(): $merge expects a target of type \'object\'; got %s',
	    target
	  );
	}
	
	function invariantMapOrSet(target, command) {
	  var typeOfTarget = type(target);
	  invariant(
	    typeOfTarget === 'Map' || typeOfTarget === 'Set',
	    'update(): %s expects a target of type Set or Map; got %s',
	    command,
	    typeOfTarget
	  );
	}


/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(1630);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(1631);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(307);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(513);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(514);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(515);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	    * Instantiante a new prefixer
	    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	    * @param {string} keepUnprefixed - keeps unprefixed properties and values
	    */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value);
	            // handle array values
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	      * Returns a prefixed version of the style object using all vendor prefixes
	      * @param {Object} styles - Style object that gets prefixed properties added
	      * @returns {Object} - Style object with prefixed properties and values
	      */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(138);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(138);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(138);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(138);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(138);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(138);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	
	  // TODO: chrome & opera support it
	};function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(502);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    // memoize the prefix array for later use
	    if (!requiresPrefixDashCased) {
	      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateProperty2.default)(prop);
	      });
	    }
	
	    // only split multi values, not cubic beziers
	    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	    requiresPrefixDashCased.forEach(function (prop) {
	      multipleValues.forEach(function (val, index) {
	        if (val.indexOf(prop) > -1 && prop !== 'order') {
	          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	        }
	      });
	    });
	
	    return multipleValues.join(',');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(1632);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(515);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(513);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(514);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(305);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1624 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1625 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1626 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(305);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1628 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(502);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(305);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(307);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(1408);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  if (browserInfo.yandexbrowser) {
	    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
	  }
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ },
/* 1631 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(307);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1633 */
/***/ function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(1635);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ },
/* 1635 */
/***/ function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ },
/* 1636 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1638);
	module.exports = self.fetch.bind(self);


/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ },
/* 1640 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-30",
			"endpointPrefix": "cognito-identity",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Cognito Identity",
			"signatureVersion": "v4",
			"targetPrefix": "AWSCognitoIdentityService",
			"uid": "cognito-identity-2014-06-30"
		},
		"operations": {
			"CreateIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolName",
						"AllowUnauthenticatedIdentities"
					],
					"members": {
						"IdentityPoolName": {},
						"AllowUnauthenticatedIdentities": {
							"type": "boolean"
						},
						"SupportedLoginProviders": {
							"shape": "S4"
						},
						"DeveloperProviderName": {},
						"OpenIdConnectProviderARNs": {
							"shape": "S8"
						},
						"CognitoIdentityProviders": {
							"shape": "Sa"
						},
						"SamlProviderARNs": {
							"shape": "Sf"
						}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"DeleteIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityIdsToDelete"
					],
					"members": {
						"IdentityIdsToDelete": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UnprocessedIdentityIds": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityId": {},
									"ErrorCode": {}
								}
							}
						}
					}
				}
			},
			"DeleteIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				}
			},
			"DescribeIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {}
					}
				},
				"output": {
					"shape": "Sr"
				}
			},
			"DescribeIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"GetCredentialsForIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sw"
						},
						"CustomRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Credentials": {
							"type": "structure",
							"members": {
								"AccessKeyId": {},
								"SecretKey": {},
								"SessionToken": {},
								"Expiration": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"GetId": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"AccountId": {},
						"IdentityPoolId": {},
						"Logins": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"GetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S18"
						},
						"RoleMappings": {
							"shape": "S1a"
						}
					}
				}
			},
			"GetOpenIdToken": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"GetOpenIdTokenForDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Logins"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"Logins": {
							"shape": "Sw"
						},
						"TokenDuration": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"ListIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"MaxResults"
					],
					"members": {
						"IdentityPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"HideDisabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Identities": {
							"type": "list",
							"member": {
								"shape": "Sr"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPools": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPools": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityPoolId": {},
									"IdentityPoolName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"LookupDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"DeveloperUserIdentifier": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"DeveloperUserIdentifierList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"MergeDeveloperIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"SourceUserIdentifier",
						"DestinationUserIdentifier",
						"DeveloperProviderName",
						"IdentityPoolId"
					],
					"members": {
						"SourceUserIdentifier": {},
						"DestinationUserIdentifier": {},
						"DeveloperProviderName": {},
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"SetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Roles"
					],
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S18"
						},
						"RoleMappings": {
							"shape": "S1a"
						}
					}
				}
			},
			"UnlinkDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"IdentityPoolId",
						"DeveloperProviderName",
						"DeveloperUserIdentifier"
					],
					"members": {
						"IdentityId": {},
						"IdentityPoolId": {},
						"DeveloperProviderName": {},
						"DeveloperUserIdentifier": {}
					}
				}
			},
			"UnlinkIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"Logins",
						"LoginsToRemove"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sw"
						},
						"LoginsToRemove": {
							"shape": "Ss"
						}
					}
				}
			},
			"UpdateIdentityPool": {
				"input": {
					"shape": "Sg"
				},
				"output": {
					"shape": "Sg"
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S8": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ProviderName": {},
						"ClientId": {},
						"ServerSideTokenCheck": {
							"type": "boolean"
						}
					}
				}
			},
			"Sf": {
				"type": "list",
				"member": {}
			},
			"Sg": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Sf"
					}
				}
			},
			"Sr": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Ss"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"Ss": {
				"type": "list",
				"member": {}
			},
			"Sw": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S18": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1a": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"Type": {},
						"AmbiguousRoleResolution": {},
						"RulesConfiguration": {
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Claim",
											"MatchType",
											"Value",
											"RoleARN"
										],
										"members": {
											"Claim": {},
											"MatchType": {},
											"Value": {},
											"RoleARN": {}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1641 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {}
	};

/***/ },
/* 1642 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-04-18",
			"endpointPrefix": "cognito-idp",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Cognito Identity Provider",
			"signatureVersion": "v4",
			"targetPrefix": "AWSCognitoIdentityProviderService",
			"uid": "cognito-idp-2016-04-18"
		},
		"operations": {
			"AddCustomAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"CustomAttributes"
					],
					"members": {
						"UserPoolId": {},
						"CustomAttributes": {
							"type": "list",
							"member": {
								"shape": "S4"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminAddUserToGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"GroupName": {}
					}
				}
			},
			"AdminConfirmSignUp": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminCreateUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"ValidationData": {
							"shape": "Si"
						},
						"TemporaryPassword": {
							"shape": "Sm"
						},
						"ForceAliasCreation": {
							"type": "boolean"
						},
						"MessageAction": {},
						"DesiredDeliveryMediums": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"User": {
							"shape": "Ss"
						}
					}
				}
			},
			"AdminDeleteUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				}
			},
			"AdminDeleteUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"UserAttributeNames"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributeNames": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminDisableProviderForUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"User"
					],
					"members": {
						"UserPoolId": {},
						"User": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminDisableUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminEnableUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminForgetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"DeviceKey"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"DeviceKey": {}
					}
				}
			},
			"AdminGetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey",
						"UserPoolId",
						"Username"
					],
					"members": {
						"DeviceKey": {},
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Device"
					],
					"members": {
						"Device": {
							"shape": "S1d"
						}
					}
				}
			},
			"AdminGetUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Username"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"UserCreateDate": {
							"type": "timestamp"
						},
						"UserLastModifiedDate": {
							"type": "timestamp"
						},
						"Enabled": {
							"type": "boolean"
						},
						"UserStatus": {},
						"MFAOptions": {
							"shape": "Sv"
						},
						"PreferredMfaSetting": {},
						"UserMFASettingList": {
							"shape": "S1g"
						}
					}
				}
			},
			"AdminInitiateAuth": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId",
						"AuthFlow"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"AuthFlow": {},
						"AuthParameters": {
							"shape": "S1k"
						},
						"ClientMetadata": {
							"shape": "S1l"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"ContextData": {
							"shape": "S1n"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"AdminLinkProviderForUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"DestinationUser",
						"SourceUser"
					],
					"members": {
						"UserPoolId": {},
						"DestinationUser": {
							"shape": "S12"
						},
						"SourceUser": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminListDevices": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Devices": {
							"shape": "S24"
						},
						"PaginationToken": {}
					}
				}
			},
			"AdminListGroupsForUser": {
				"input": {
					"type": "structure",
					"required": [
						"Username",
						"UserPoolId"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserPoolId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "S28"
						},
						"NextToken": {}
					}
				}
			},
			"AdminListUserAuthEvents": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AuthEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"EventType": {},
									"CreationDate": {
										"type": "timestamp"
									},
									"EventResponse": {},
									"EventRisk": {
										"type": "structure",
										"members": {
											"RiskDecision": {},
											"RiskLevel": {}
										}
									},
									"ChallengeResponses": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"ChallengeName": {},
												"ChallengeResponse": {}
											}
										}
									},
									"EventContextData": {
										"type": "structure",
										"members": {
											"IpAddress": {},
											"DeviceName": {},
											"Timezone": {},
											"City": {},
											"Country": {}
										}
									},
									"EventFeedback": {
										"type": "structure",
										"required": [
											"FeedbackValue",
											"Provider"
										],
										"members": {
											"FeedbackValue": {},
											"Provider": {},
											"FeedbackDate": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"AdminRemoveUserFromGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"GroupName": {}
					}
				}
			},
			"AdminResetUserPassword": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminRespondToAuthChallenge": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId",
						"ChallengeName"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"ChallengeName": {},
						"ChallengeResponses": {
							"shape": "S2x"
						},
						"Session": {},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"ContextData": {
							"shape": "S1n"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"AdminSetUserMFAPreference": {
				"input": {
					"type": "structure",
					"required": [
						"Username",
						"UserPoolId"
					],
					"members": {
						"SMSMfaSettings": {
							"shape": "S30"
						},
						"SoftwareTokenMfaSettings": {
							"shape": "S31"
						},
						"Username": {
							"shape": "Sd"
						},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminSetUserSettings": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"MFAOptions"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateAuthEventFeedback": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"EventId",
						"FeedbackValue"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"EventId": {},
						"FeedbackValue": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateDeviceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"DeviceKey"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"DeviceKey": {},
						"DeviceRememberedStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"UserAttributes"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUserGlobalSignOut": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateSoftwareToken": {
				"input": {
					"type": "structure",
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"Session": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecretCode": {
							"type": "string",
							"sensitive": true
						},
						"Session": {}
					}
				}
			},
			"ChangePassword": {
				"input": {
					"type": "structure",
					"required": [
						"PreviousPassword",
						"ProposedPassword",
						"AccessToken"
					],
					"members": {
						"PreviousPassword": {
							"shape": "Sm"
						},
						"ProposedPassword": {
							"shape": "Sm"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"ConfirmDevice": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"DeviceKey": {},
						"DeviceSecretVerifierConfig": {
							"type": "structure",
							"members": {
								"PasswordVerifier": {},
								"Salt": {}
							}
						},
						"DeviceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserConfirmationNecessary": {
							"type": "boolean"
						}
					}
				}
			},
			"ConfirmForgotPassword": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"ConfirmationCode",
						"Password"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3p"
						},
						"Username": {
							"shape": "Sd"
						},
						"ConfirmationCode": {},
						"Password": {
							"shape": "Sm"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3r"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"ConfirmSignUp": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"ConfirmationCode"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3p"
						},
						"Username": {
							"shape": "Sd"
						},
						"ConfirmationCode": {},
						"ForceAliasCreation": {
							"type": "boolean"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3r"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"CreateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {},
						"Description": {},
						"RoleArn": {},
						"Precedence": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S29"
						}
					}
				}
			},
			"CreateIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName",
						"ProviderType",
						"ProviderDetails"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {},
						"ProviderType": {},
						"ProviderDetails": {
							"shape": "S40"
						},
						"AttributeMapping": {
							"shape": "S41"
						},
						"IdpIdentifiers": {
							"shape": "S43"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S46"
						}
					}
				}
			},
			"CreateResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier",
						"Name"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {},
						"Name": {},
						"Scopes": {
							"shape": "S4a"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServer"
					],
					"members": {
						"ResourceServer": {
							"shape": "S4f"
						}
					}
				}
			},
			"CreateUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobName",
						"UserPoolId",
						"CloudWatchLogsRoleArn"
					],
					"members": {
						"JobName": {},
						"UserPoolId": {},
						"CloudWatchLogsRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4j"
						}
					}
				}
			},
			"CreateUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"PoolName"
					],
					"members": {
						"PoolName": {},
						"Policies": {
							"shape": "S4r"
						},
						"LambdaConfig": {
							"shape": "S4u"
						},
						"AutoVerifiedAttributes": {
							"shape": "S4v"
						},
						"AliasAttributes": {
							"shape": "S4x"
						},
						"UsernameAttributes": {
							"shape": "S4z"
						},
						"SmsVerificationMessage": {},
						"EmailVerificationMessage": {},
						"EmailVerificationSubject": {},
						"VerificationMessageTemplate": {
							"shape": "S54"
						},
						"SmsAuthenticationMessage": {},
						"MfaConfiguration": {},
						"DeviceConfiguration": {
							"shape": "S59"
						},
						"EmailConfiguration": {
							"shape": "S5a"
						},
						"SmsConfiguration": {
							"shape": "S5c"
						},
						"UserPoolTags": {
							"shape": "S5d"
						},
						"AdminCreateUserConfig": {
							"shape": "S5e"
						},
						"Schema": {
							"shape": "S5h"
						},
						"UserPoolAddOns": {
							"shape": "S5i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPool": {
							"shape": "S5l"
						}
					}
				}
			},
			"CreateUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientName"
					],
					"members": {
						"UserPoolId": {},
						"ClientName": {},
						"GenerateSecret": {
							"type": "boolean"
						},
						"RefreshTokenValidity": {
							"type": "integer"
						},
						"ReadAttributes": {
							"shape": "S5s"
						},
						"WriteAttributes": {
							"shape": "S5s"
						},
						"ExplicitAuthFlows": {
							"shape": "S5u"
						},
						"SupportedIdentityProviders": {
							"shape": "S5w"
						},
						"CallbackURLs": {
							"shape": "S5x"
						},
						"LogoutURLs": {
							"shape": "S5z"
						},
						"DefaultRedirectURI": {},
						"AllowedOAuthFlows": {
							"shape": "S60"
						},
						"AllowedOAuthScopes": {
							"shape": "S62"
						},
						"AllowedOAuthFlowsUserPoolClient": {
							"type": "boolean"
						},
						"AnalyticsConfiguration": {
							"shape": "S64"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S67"
						}
					}
				}
			},
			"CreateUserPoolDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Domain",
						"UserPoolId"
					],
					"members": {
						"Domain": {},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {}
					}
				}
			},
			"DeleteIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {}
					}
				}
			},
			"DeleteResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {}
					}
				}
			},
			"DeleteUser": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"authtype": "none"
			},
			"DeleteUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserAttributeNames",
						"AccessToken"
					],
					"members": {
						"UserAttributeNames": {
							"shape": "Sz"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"DeleteUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				}
			},
			"DeleteUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				}
			},
			"DeleteUserPoolDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Domain",
						"UserPoolId"
					],
					"members": {
						"Domain": {},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S46"
						}
					}
				}
			},
			"DescribeResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServer"
					],
					"members": {
						"ResourceServer": {
							"shape": "S4f"
						}
					}
				}
			},
			"DescribeRiskConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RiskConfiguration"
					],
					"members": {
						"RiskConfiguration": {
							"shape": "S6r"
						}
					}
				}
			},
			"DescribeUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4j"
						}
					}
				}
			},
			"DescribeUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPool": {
							"shape": "S5l"
						}
					}
				}
			},
			"DescribeUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S67"
						}
					}
				}
			},
			"DescribeUserPoolDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Domain"
					],
					"members": {
						"Domain": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DomainDescription": {
							"type": "structure",
							"members": {
								"UserPoolId": {},
								"AWSAccountId": {},
								"Domain": {},
								"S3Bucket": {},
								"CloudFrontDistribution": {},
								"Version": {},
								"Status": {}
							}
						}
					}
				}
			},
			"ForgetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"DeviceKey": {}
					}
				}
			},
			"ForgotPassword": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3p"
						},
						"UserContextData": {
							"shape": "S3r"
						},
						"Username": {
							"shape": "Sd"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S7p"
						}
					}
				},
				"authtype": "none"
			},
			"GetCSVHeader": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolId": {},
						"CSVHeader": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey"
					],
					"members": {
						"DeviceKey": {},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Device"
					],
					"members": {
						"Device": {
							"shape": "S1d"
						}
					}
				}
			},
			"GetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S29"
						}
					}
				}
			},
			"GetIdentityProviderByIdentifier": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"IdpIdentifier"
					],
					"members": {
						"UserPoolId": {},
						"IdpIdentifier": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S46"
						}
					}
				}
			},
			"GetUICustomization": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"UICustomization"
					],
					"members": {
						"UICustomization": {
							"shape": "S81"
						}
					}
				}
			},
			"GetUser": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Username",
						"UserAttributes"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"MFAOptions": {
							"shape": "Sv"
						},
						"PreferredMfaSetting": {},
						"UserMFASettingList": {
							"shape": "S1g"
						}
					}
				},
				"authtype": "none"
			},
			"GetUserAttributeVerificationCode": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"AttributeName"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"AttributeName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S7p"
						}
					}
				},
				"authtype": "none"
			},
			"GetUserPoolMfaConfig": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SmsMfaConfiguration": {
							"shape": "S8b"
						},
						"SoftwareTokenMfaConfiguration": {
							"shape": "S8c"
						},
						"MfaConfiguration": {}
					}
				}
			},
			"GlobalSignOut": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"InitiateAuth": {
				"input": {
					"type": "structure",
					"required": [
						"AuthFlow",
						"ClientId"
					],
					"members": {
						"AuthFlow": {},
						"AuthParameters": {
							"shape": "S1k"
						},
						"ClientMetadata": {
							"shape": "S1l"
						},
						"ClientId": {
							"shape": "S1i"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3r"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"ListDevices": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Devices": {
							"shape": "S24"
						},
						"PaginationToken": {}
					}
				}
			},
			"ListGroups": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "S28"
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityProviders": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Providers"
					],
					"members": {
						"Providers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ProviderName": {},
									"ProviderType": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListResourceServers": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServers"
					],
					"members": {
						"ResourceServers": {
							"type": "list",
							"member": {
								"shape": "S4f"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListUserImportJobs": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"MaxResults"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJobs": {
							"type": "list",
							"member": {
								"shape": "S4j"
							}
						},
						"PaginationToken": {}
					}
				}
			},
			"ListUserPoolClients": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClients": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ClientId": {
										"shape": "S1i"
									},
									"UserPoolId": {},
									"ClientName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListUserPools": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPools": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"LambdaConfig": {
										"shape": "S4u"
									},
									"Status": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListUsers": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"AttributesToGet": {
							"type": "list",
							"member": {}
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {},
						"Filter": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Users": {
							"shape": "S9c"
						},
						"PaginationToken": {}
					}
				}
			},
			"ListUsersInGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"GroupName": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Users": {
							"shape": "S9c"
						},
						"NextToken": {}
					}
				}
			},
			"ResendConfirmationCode": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3p"
						},
						"UserContextData": {
							"shape": "S3r"
						},
						"Username": {
							"shape": "Sd"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S7p"
						}
					}
				},
				"authtype": "none"
			},
			"RespondToAuthChallenge": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"ChallengeName"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"ChallengeName": {},
						"Session": {},
						"ChallengeResponses": {
							"shape": "S2x"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3r"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"SetRiskConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"CompromisedCredentialsRiskConfiguration": {
							"shape": "S6s"
						},
						"AccountTakeoverRiskConfiguration": {
							"shape": "S6x"
						},
						"RiskExceptionConfiguration": {
							"shape": "S76"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RiskConfiguration"
					],
					"members": {
						"RiskConfiguration": {
							"shape": "S6r"
						}
					}
				}
			},
			"SetUICustomization": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"CSS": {},
						"ImageFile": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"UICustomization"
					],
					"members": {
						"UICustomization": {
							"shape": "S81"
						}
					}
				}
			},
			"SetUserMFAPreference": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"SMSMfaSettings": {
							"shape": "S30"
						},
						"SoftwareTokenMfaSettings": {
							"shape": "S31"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"SetUserPoolMfaConfig": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"SmsMfaConfiguration": {
							"shape": "S8b"
						},
						"SoftwareTokenMfaConfiguration": {
							"shape": "S8c"
						},
						"MfaConfiguration": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SmsMfaConfiguration": {
							"shape": "S8b"
						},
						"SoftwareTokenMfaConfiguration": {
							"shape": "S8c"
						},
						"MfaConfiguration": {}
					}
				}
			},
			"SetUserSettings": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"MFAOptions"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"SignUp": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"Password"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3p"
						},
						"Username": {
							"shape": "Sd"
						},
						"Password": {
							"shape": "Sm"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"ValidationData": {
							"shape": "Si"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3r"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"UserConfirmed",
						"UserSub"
					],
					"members": {
						"UserConfirmed": {
							"type": "boolean"
						},
						"CodeDeliveryDetails": {
							"shape": "S7p"
						},
						"UserSub": {}
					}
				},
				"authtype": "none"
			},
			"StartUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4j"
						}
					}
				}
			},
			"StopUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4j"
						}
					}
				}
			},
			"UpdateAuthEventFeedback": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"EventId",
						"FeedbackToken",
						"FeedbackValue"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"EventId": {},
						"FeedbackToken": {
							"shape": "S1v"
						},
						"FeedbackValue": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateDeviceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"DeviceKey": {},
						"DeviceRememberedStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {},
						"Description": {},
						"RoleArn": {},
						"Precedence": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S29"
						}
					}
				}
			},
			"UpdateIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {},
						"ProviderDetails": {
							"shape": "S40"
						},
						"AttributeMapping": {
							"shape": "S41"
						},
						"IdpIdentifiers": {
							"shape": "S43"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S46"
						}
					}
				}
			},
			"UpdateResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier",
						"Name"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {},
						"Name": {},
						"Scopes": {
							"shape": "S4a"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServer"
					],
					"members": {
						"ResourceServer": {
							"shape": "S4f"
						}
					}
				}
			},
			"UpdateUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserAttributes",
						"AccessToken"
					],
					"members": {
						"UserAttributes": {
							"shape": "Si"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetailsList": {
							"type": "list",
							"member": {
								"shape": "S7p"
							}
						}
					}
				},
				"authtype": "none"
			},
			"UpdateUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"Policies": {
							"shape": "S4r"
						},
						"LambdaConfig": {
							"shape": "S4u"
						},
						"AutoVerifiedAttributes": {
							"shape": "S4v"
						},
						"SmsVerificationMessage": {},
						"EmailVerificationMessage": {},
						"EmailVerificationSubject": {},
						"VerificationMessageTemplate": {
							"shape": "S54"
						},
						"SmsAuthenticationMessage": {},
						"MfaConfiguration": {},
						"DeviceConfiguration": {
							"shape": "S59"
						},
						"EmailConfiguration": {
							"shape": "S5a"
						},
						"SmsConfiguration": {
							"shape": "S5c"
						},
						"UserPoolTags": {
							"shape": "S5d"
						},
						"AdminCreateUserConfig": {
							"shape": "S5e"
						},
						"UserPoolAddOns": {
							"shape": "S5i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"ClientName": {},
						"RefreshTokenValidity": {
							"type": "integer"
						},
						"ReadAttributes": {
							"shape": "S5s"
						},
						"WriteAttributes": {
							"shape": "S5s"
						},
						"ExplicitAuthFlows": {
							"shape": "S5u"
						},
						"SupportedIdentityProviders": {
							"shape": "S5w"
						},
						"CallbackURLs": {
							"shape": "S5x"
						},
						"LogoutURLs": {
							"shape": "S5z"
						},
						"DefaultRedirectURI": {},
						"AllowedOAuthFlows": {
							"shape": "S60"
						},
						"AllowedOAuthScopes": {
							"shape": "S62"
						},
						"AllowedOAuthFlowsUserPoolClient": {
							"type": "boolean"
						},
						"AnalyticsConfiguration": {
							"shape": "S64"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S67"
						}
					}
				}
			},
			"VerifySoftwareToken": {
				"input": {
					"type": "structure",
					"required": [
						"UserCode"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"Session": {},
						"UserCode": {},
						"FriendlyDeviceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {},
						"Session": {}
					}
				}
			},
			"VerifyUserAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"AttributeName",
						"Code"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"AttributeName": {},
						"Code": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"Name": {},
					"AttributeDataType": {},
					"DeveloperOnlyAttribute": {
						"type": "boolean"
					},
					"Mutable": {
						"type": "boolean"
					},
					"Required": {
						"type": "boolean"
					},
					"NumberAttributeConstraints": {
						"type": "structure",
						"members": {
							"MinValue": {},
							"MaxValue": {}
						}
					},
					"StringAttributeConstraints": {
						"type": "structure",
						"members": {
							"MinLength": {},
							"MaxLength": {}
						}
					}
				}
			},
			"Sd": {
				"type": "string",
				"sensitive": true
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Value": {
							"type": "string",
							"sensitive": true
						}
					}
				}
			},
			"Sm": {
				"type": "string",
				"sensitive": true
			},
			"Ss": {
				"type": "structure",
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"Attributes": {
						"shape": "Si"
					},
					"UserCreateDate": {
						"type": "timestamp"
					},
					"UserLastModifiedDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"UserStatus": {},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"DeliveryMedium": {},
						"AttributeName": {}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {}
			},
			"S12": {
				"type": "structure",
				"members": {
					"ProviderName": {},
					"ProviderAttributeName": {},
					"ProviderAttributeValue": {}
				}
			},
			"S1d": {
				"type": "structure",
				"members": {
					"DeviceKey": {},
					"DeviceAttributes": {
						"shape": "Si"
					},
					"DeviceCreateDate": {
						"type": "timestamp"
					},
					"DeviceLastModifiedDate": {
						"type": "timestamp"
					},
					"DeviceLastAuthenticatedDate": {
						"type": "timestamp"
					}
				}
			},
			"S1g": {
				"type": "list",
				"member": {}
			},
			"S1i": {
				"type": "string",
				"sensitive": true
			},
			"S1k": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1l": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1m": {
				"type": "structure",
				"members": {
					"AnalyticsEndpointId": {}
				}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"IpAddress",
					"ServerName",
					"ServerPath",
					"HttpHeaders"
				],
				"members": {
					"IpAddress": {},
					"ServerName": {},
					"ServerPath": {},
					"HttpHeaders": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"headerName": {},
								"headerValue": {}
							}
						}
					},
					"EncodedData": {}
				}
			},
			"S1t": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"ExpiresIn": {
						"type": "integer"
					},
					"TokenType": {},
					"RefreshToken": {
						"shape": "S1v"
					},
					"IdToken": {
						"shape": "S1v"
					},
					"NewDeviceMetadata": {
						"type": "structure",
						"members": {
							"DeviceKey": {},
							"DeviceGroupKey": {}
						}
					}
				}
			},
			"S1v": {
				"type": "string",
				"sensitive": true
			},
			"S24": {
				"type": "list",
				"member": {
					"shape": "S1d"
				}
			},
			"S28": {
				"type": "list",
				"member": {
					"shape": "S29"
				}
			},
			"S29": {
				"type": "structure",
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					}
				}
			},
			"S2x": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S30": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"PreferredMfa": {
						"type": "boolean"
					}
				}
			},
			"S31": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"PreferredMfa": {
						"type": "boolean"
					}
				}
			},
			"S3p": {
				"type": "string",
				"sensitive": true
			},
			"S3r": {
				"type": "structure",
				"members": {
					"EncodedData": {}
				}
			},
			"S40": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S41": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S43": {
				"type": "list",
				"member": {}
			},
			"S46": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderType": {},
					"ProviderDetails": {
						"shape": "S40"
					},
					"AttributeMapping": {
						"shape": "S41"
					},
					"IdpIdentifiers": {
						"shape": "S43"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					}
				}
			},
			"S4a": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ScopeName",
						"ScopeDescription"
					],
					"members": {
						"ScopeName": {},
						"ScopeDescription": {}
					}
				}
			},
			"S4f": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S4a"
					}
				}
			},
			"S4j": {
				"type": "structure",
				"members": {
					"JobName": {},
					"JobId": {},
					"UserPoolId": {},
					"PreSignedUrl": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"StartDate": {
						"type": "timestamp"
					},
					"CompletionDate": {
						"type": "timestamp"
					},
					"Status": {},
					"CloudWatchLogsRoleArn": {},
					"ImportedUsers": {
						"type": "long"
					},
					"SkippedUsers": {
						"type": "long"
					},
					"FailedUsers": {
						"type": "long"
					},
					"CompletionMessage": {}
				}
			},
			"S4r": {
				"type": "structure",
				"members": {
					"PasswordPolicy": {
						"type": "structure",
						"members": {
							"MinimumLength": {
								"type": "integer"
							},
							"RequireUppercase": {
								"type": "boolean"
							},
							"RequireLowercase": {
								"type": "boolean"
							},
							"RequireNumbers": {
								"type": "boolean"
							},
							"RequireSymbols": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"S4u": {
				"type": "structure",
				"members": {
					"PreSignUp": {},
					"CustomMessage": {},
					"PostConfirmation": {},
					"PreAuthentication": {},
					"PostAuthentication": {},
					"DefineAuthChallenge": {},
					"CreateAuthChallenge": {},
					"VerifyAuthChallengeResponse": {},
					"PreTokenGeneration": {}
				}
			},
			"S4v": {
				"type": "list",
				"member": {}
			},
			"S4x": {
				"type": "list",
				"member": {}
			},
			"S4z": {
				"type": "list",
				"member": {}
			},
			"S54": {
				"type": "structure",
				"members": {
					"SmsMessage": {},
					"EmailMessage": {},
					"EmailSubject": {},
					"EmailMessageByLink": {},
					"EmailSubjectByLink": {},
					"DefaultEmailOption": {}
				}
			},
			"S59": {
				"type": "structure",
				"members": {
					"ChallengeRequiredOnNewDevice": {
						"type": "boolean"
					},
					"DeviceOnlyRememberedOnUserPrompt": {
						"type": "boolean"
					}
				}
			},
			"S5a": {
				"type": "structure",
				"members": {
					"SourceArn": {},
					"ReplyToEmailAddress": {}
				}
			},
			"S5c": {
				"type": "structure",
				"required": [
					"SnsCallerArn"
				],
				"members": {
					"SnsCallerArn": {},
					"ExternalId": {}
				}
			},
			"S5d": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S5e": {
				"type": "structure",
				"members": {
					"AllowAdminCreateUserOnly": {
						"type": "boolean"
					},
					"UnusedAccountValidityDays": {
						"type": "integer"
					},
					"InviteMessageTemplate": {
						"type": "structure",
						"members": {
							"SMSMessage": {},
							"EmailMessage": {},
							"EmailSubject": {}
						}
					}
				}
			},
			"S5h": {
				"type": "list",
				"member": {
					"shape": "S4"
				}
			},
			"S5i": {
				"type": "structure",
				"required": [
					"AdvancedSecurityMode"
				],
				"members": {
					"AdvancedSecurityMode": {}
				}
			},
			"S5l": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Policies": {
						"shape": "S4r"
					},
					"LambdaConfig": {
						"shape": "S4u"
					},
					"Status": {},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"SchemaAttributes": {
						"shape": "S5h"
					},
					"AutoVerifiedAttributes": {
						"shape": "S4v"
					},
					"AliasAttributes": {
						"shape": "S4x"
					},
					"UsernameAttributes": {
						"shape": "S4z"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S54"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S59"
					},
					"EstimatedNumberOfUsers": {
						"type": "integer"
					},
					"EmailConfiguration": {
						"shape": "S5a"
					},
					"SmsConfiguration": {
						"shape": "S5c"
					},
					"UserPoolTags": {
						"shape": "S5d"
					},
					"SmsConfigurationFailure": {},
					"EmailConfigurationFailure": {},
					"Domain": {},
					"AdminCreateUserConfig": {
						"shape": "S5e"
					},
					"UserPoolAddOns": {
						"shape": "S5i"
					}
				}
			},
			"S5s": {
				"type": "list",
				"member": {}
			},
			"S5u": {
				"type": "list",
				"member": {}
			},
			"S5w": {
				"type": "list",
				"member": {}
			},
			"S5x": {
				"type": "list",
				"member": {}
			},
			"S5z": {
				"type": "list",
				"member": {}
			},
			"S60": {
				"type": "list",
				"member": {}
			},
			"S62": {
				"type": "list",
				"member": {}
			},
			"S64": {
				"type": "structure",
				"required": [
					"ApplicationId",
					"RoleArn",
					"ExternalId"
				],
				"members": {
					"ApplicationId": {},
					"RoleArn": {},
					"ExternalId": {},
					"UserDataShared": {
						"type": "boolean"
					}
				}
			},
			"S67": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ClientName": {},
					"ClientId": {
						"shape": "S1i"
					},
					"ClientSecret": {
						"type": "string",
						"sensitive": true
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S5s"
					},
					"WriteAttributes": {
						"shape": "S5s"
					},
					"ExplicitAuthFlows": {
						"shape": "S5u"
					},
					"SupportedIdentityProviders": {
						"shape": "S5w"
					},
					"CallbackURLs": {
						"shape": "S5x"
					},
					"LogoutURLs": {
						"shape": "S5z"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S60"
					},
					"AllowedOAuthScopes": {
						"shape": "S62"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					},
					"AnalyticsConfiguration": {
						"shape": "S64"
					}
				}
			},
			"S6r": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"CompromisedCredentialsRiskConfiguration": {
						"shape": "S6s"
					},
					"AccountTakeoverRiskConfiguration": {
						"shape": "S6x"
					},
					"RiskExceptionConfiguration": {
						"shape": "S76"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"S6s": {
				"type": "structure",
				"required": [
					"Actions"
				],
				"members": {
					"EventFilter": {
						"type": "list",
						"member": {}
					},
					"Actions": {
						"type": "structure",
						"required": [
							"EventAction"
						],
						"members": {
							"EventAction": {}
						}
					}
				}
			},
			"S6x": {
				"type": "structure",
				"required": [
					"Actions"
				],
				"members": {
					"NotifyConfiguration": {
						"type": "structure",
						"required": [
							"SourceArn"
						],
						"members": {
							"From": {},
							"ReplyTo": {},
							"SourceArn": {},
							"BlockEmail": {
								"shape": "S6z"
							},
							"NoActionEmail": {
								"shape": "S6z"
							},
							"MfaEmail": {
								"shape": "S6z"
							}
						}
					},
					"Actions": {
						"type": "structure",
						"members": {
							"LowAction": {
								"shape": "S73"
							},
							"MediumAction": {
								"shape": "S73"
							},
							"HighAction": {
								"shape": "S73"
							}
						}
					}
				}
			},
			"S6z": {
				"type": "structure",
				"required": [
					"Subject"
				],
				"members": {
					"Subject": {},
					"HtmlBody": {},
					"TextBody": {}
				}
			},
			"S73": {
				"type": "structure",
				"required": [
					"Notify",
					"EventAction"
				],
				"members": {
					"Notify": {
						"type": "boolean"
					},
					"EventAction": {}
				}
			},
			"S76": {
				"type": "structure",
				"members": {
					"BlockedIPRangeList": {
						"type": "list",
						"member": {}
					},
					"SkippedIPRangeList": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S7p": {
				"type": "structure",
				"members": {
					"Destination": {},
					"DeliveryMedium": {},
					"AttributeName": {}
				}
			},
			"S81": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"ImageUrl": {},
					"CSS": {},
					"CSSVersion": {},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					}
				}
			},
			"S8b": {
				"type": "structure",
				"members": {
					"SmsAuthenticationMessage": {},
					"SmsConfiguration": {
						"shape": "S5c"
					}
				}
			},
			"S8c": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S9c": {
				"type": "list",
				"member": {
					"shape": "Ss"
				}
			}
		}
	};

/***/ },
/* 1643 */
1641,
/* 1644 */
/***/ function(module, exports) {

	module.exports = {
		"acm": {
			"name": "ACM",
			"cors": true
		},
		"apigateway": {
			"name": "APIGateway",
			"cors": true
		},
		"applicationautoscaling": {
			"prefix": "application-autoscaling",
			"name": "ApplicationAutoScaling",
			"cors": true
		},
		"appstream": {
			"name": "AppStream"
		},
		"autoscaling": {
			"name": "AutoScaling",
			"cors": true
		},
		"batch": {
			"name": "Batch"
		},
		"budgets": {
			"name": "Budgets"
		},
		"clouddirectory": {
			"name": "CloudDirectory"
		},
		"cloudformation": {
			"name": "CloudFormation",
			"cors": true
		},
		"cloudfront": {
			"name": "CloudFront",
			"versions": [
				"2013-05-12*",
				"2013-11-11*",
				"2014-05-31*",
				"2014-10-21*",
				"2014-11-06*",
				"2015-04-17*",
				"2015-07-27*",
				"2015-09-17*",
				"2016-01-13*",
				"2016-01-28*",
				"2016-08-01*",
				"2016-08-20*",
				"2016-09-07*",
				"2016-09-29*",
				"2016-11-25*"
			],
			"cors": true
		},
		"cloudhsm": {
			"name": "CloudHSM",
			"cors": true
		},
		"cloudsearch": {
			"name": "CloudSearch"
		},
		"cloudsearchdomain": {
			"name": "CloudSearchDomain"
		},
		"cloudtrail": {
			"name": "CloudTrail",
			"cors": true
		},
		"cloudwatch": {
			"prefix": "monitoring",
			"name": "CloudWatch",
			"cors": true
		},
		"cloudwatchevents": {
			"prefix": "events",
			"name": "CloudWatchEvents",
			"versions": [
				"2014-02-03*"
			],
			"cors": true
		},
		"cloudwatchlogs": {
			"prefix": "logs",
			"name": "CloudWatchLogs",
			"cors": true
		},
		"codebuild": {
			"name": "CodeBuild"
		},
		"codecommit": {
			"name": "CodeCommit",
			"cors": true
		},
		"codedeploy": {
			"name": "CodeDeploy",
			"cors": true
		},
		"codepipeline": {
			"name": "CodePipeline",
			"cors": true
		},
		"cognitoidentity": {
			"prefix": "cognito-identity",
			"name": "CognitoIdentity",
			"cors": true
		},
		"cognitoidentityserviceprovider": {
			"prefix": "cognito-idp",
			"name": "CognitoIdentityServiceProvider",
			"cors": true
		},
		"cognitosync": {
			"prefix": "cognito-sync",
			"name": "CognitoSync",
			"cors": true
		},
		"configservice": {
			"prefix": "config",
			"name": "ConfigService",
			"cors": true
		},
		"cur": {
			"name": "CUR",
			"cors": true
		},
		"datapipeline": {
			"name": "DataPipeline"
		},
		"devicefarm": {
			"name": "DeviceFarm",
			"cors": true
		},
		"directconnect": {
			"name": "DirectConnect",
			"cors": true
		},
		"directoryservice": {
			"prefix": "ds",
			"name": "DirectoryService"
		},
		"discovery": {
			"name": "Discovery"
		},
		"dms": {
			"name": "DMS"
		},
		"dynamodb": {
			"name": "DynamoDB",
			"cors": true
		},
		"dynamodbstreams": {
			"prefix": "streams.dynamodb",
			"name": "DynamoDBStreams",
			"cors": true
		},
		"ec2": {
			"name": "EC2",
			"versions": [
				"2013-06-15*",
				"2013-10-15*",
				"2014-02-01*",
				"2014-05-01*",
				"2014-06-15*",
				"2014-09-01*",
				"2014-10-01*",
				"2015-03-01*",
				"2015-04-15*",
				"2015-10-01*",
				"2016-04-01*",
				"2016-09-15*"
			],
			"cors": true
		},
		"ecr": {
			"name": "ECR",
			"cors": true
		},
		"ecs": {
			"name": "ECS",
			"cors": true
		},
		"efs": {
			"prefix": "elasticfilesystem",
			"name": "EFS",
			"cors": true
		},
		"elasticache": {
			"name": "ElastiCache",
			"versions": [
				"2012-11-15*",
				"2014-03-24*",
				"2014-07-15*",
				"2014-09-30*"
			],
			"cors": true
		},
		"elasticbeanstalk": {
			"name": "ElasticBeanstalk",
			"cors": true
		},
		"elb": {
			"prefix": "elasticloadbalancing",
			"name": "ELB",
			"cors": true
		},
		"elbv2": {
			"prefix": "elasticloadbalancingv2",
			"name": "ELBv2",
			"cors": true
		},
		"emr": {
			"prefix": "elasticmapreduce",
			"name": "EMR",
			"cors": true
		},
		"es": {
			"name": "ES"
		},
		"elastictranscoder": {
			"name": "ElasticTranscoder",
			"cors": true
		},
		"firehose": {
			"name": "Firehose",
			"cors": true
		},
		"gamelift": {
			"name": "GameLift",
			"cors": true
		},
		"glacier": {
			"name": "Glacier"
		},
		"health": {
			"name": "Health"
		},
		"iam": {
			"name": "IAM"
		},
		"importexport": {
			"name": "ImportExport"
		},
		"inspector": {
			"name": "Inspector",
			"versions": [
				"2015-08-18*"
			],
			"cors": true
		},
		"iot": {
			"name": "Iot",
			"cors": true
		},
		"iotdata": {
			"prefix": "iot-data",
			"name": "IotData",
			"cors": true
		},
		"kinesis": {
			"name": "Kinesis",
			"cors": true
		},
		"kinesisanalytics": {
			"name": "KinesisAnalytics"
		},
		"kms": {
			"name": "KMS",
			"cors": true
		},
		"lambda": {
			"name": "Lambda",
			"cors": true
		},
		"lexruntime": {
			"prefix": "runtime.lex",
			"name": "LexRuntime",
			"cors": true
		},
		"lightsail": {
			"name": "Lightsail"
		},
		"machinelearning": {
			"name": "MachineLearning",
			"cors": true
		},
		"marketplacecommerceanalytics": {
			"name": "MarketplaceCommerceAnalytics",
			"cors": true
		},
		"marketplacemetering": {
			"prefix": "meteringmarketplace",
			"name": "MarketplaceMetering"
		},
		"mturk": {
			"prefix": "mturk-requester",
			"name": "MTurk",
			"cors": true
		},
		"mobileanalytics": {
			"name": "MobileAnalytics",
			"cors": true
		},
		"opsworks": {
			"name": "OpsWorks",
			"cors": true
		},
		"opsworkscm": {
			"name": "OpsWorksCM"
		},
		"organizations": {
			"name": "Organizations"
		},
		"pinpoint": {
			"name": "Pinpoint"
		},
		"polly": {
			"name": "Polly",
			"cors": true
		},
		"rds": {
			"name": "RDS",
			"versions": [
				"2014-09-01*"
			],
			"cors": true
		},
		"redshift": {
			"name": "Redshift",
			"cors": true
		},
		"rekognition": {
			"name": "Rekognition",
			"cors": true
		},
		"resourcegroupstaggingapi": {
			"name": "ResourceGroupsTaggingAPI"
		},
		"route53": {
			"name": "Route53",
			"cors": true
		},
		"route53domains": {
			"name": "Route53Domains",
			"cors": true
		},
		"s3": {
			"name": "S3",
			"dualstackAvailable": true,
			"cors": true
		},
		"servicecatalog": {
			"name": "ServiceCatalog",
			"cors": true
		},
		"ses": {
			"prefix": "email",
			"name": "SES",
			"cors": true
		},
		"shield": {
			"name": "Shield"
		},
		"simpledb": {
			"prefix": "sdb",
			"name": "SimpleDB"
		},
		"sms": {
			"name": "SMS"
		},
		"snowball": {
			"name": "Snowball"
		},
		"sns": {
			"name": "SNS",
			"cors": true
		},
		"sqs": {
			"name": "SQS",
			"cors": true
		},
		"ssm": {
			"name": "SSM",
			"cors": true
		},
		"storagegateway": {
			"name": "StorageGateway",
			"cors": true
		},
		"stepfunctions": {
			"prefix": "states",
			"name": "StepFunctions"
		},
		"sts": {
			"name": "STS",
			"cors": true
		},
		"support": {
			"name": "Support"
		},
		"swf": {
			"name": "SWF"
		},
		"xray": {
			"name": "XRay"
		},
		"waf": {
			"name": "WAF",
			"cors": true
		},
		"wafregional": {
			"prefix": "waf-regional",
			"name": "WAFRegional"
		},
		"workdocs": {
			"name": "WorkDocs",
			"cors": true
		},
		"workspaces": {
			"name": "WorkSpaces"
		},
		"codestar": {
			"name": "CodeStar"
		},
		"lexmodelbuildingservice": {
			"prefix": "lex-models",
			"name": "LexModelBuildingService",
			"cors": true
		},
		"marketplaceentitlementservice": {
			"prefix": "entitlement.marketplace",
			"name": "MarketplaceEntitlementService"
		},
		"athena": {
			"name": "Athena"
		},
		"greengrass": {
			"name": "Greengrass"
		},
		"dax": {
			"name": "DAX"
		},
		"migrationhub": {
			"prefix": "AWSMigrationHub",
			"name": "MigrationHub"
		},
		"cloudhsmv2": {
			"name": "CloudHSMV2"
		},
		"glue": {
			"name": "Glue"
		},
		"mobile": {
			"name": "Mobile"
		},
		"pricing": {
			"name": "Pricing"
		},
		"costexplorer": {
			"prefix": "ce",
			"name": "CostExplorer"
		},
		"mediaconvert": {
			"name": "MediaConvert"
		},
		"medialive": {
			"name": "MediaLive"
		},
		"mediapackage": {
			"name": "MediaPackage"
		},
		"mediastore": {
			"name": "MediaStore"
		},
		"mediastoredata": {
			"prefix": "mediastore-data",
			"name": "MediaStoreData"
		},
		"appsync": {
			"name": "AppSync"
		},
		"guardduty": {
			"name": "GuardDuty"
		},
		"mq": {
			"name": "MQ"
		},
		"comprehend": {
			"name": "Comprehend"
		},
		"iotjobsdataplane": {
			"prefix": "iot-jobs-data",
			"name": "IoTJobsDataPlane"
		},
		"kinesisvideoarchivedmedia": {
			"prefix": "kinesis-video-archived-media",
			"name": "KinesisVideoArchivedMedia"
		},
		"kinesisvideomedia": {
			"prefix": "kinesis-video-media",
			"name": "KinesisVideoMedia"
		},
		"kinesisvideo": {
			"name": "KinesisVideo"
		},
		"sagemakerruntime": {
			"prefix": "runtime.sagemaker",
			"name": "SageMakerRuntime"
		},
		"sagemaker": {
			"name": "SageMaker"
		},
		"translate": {
			"name": "Translate"
		},
		"resourcegroups": {
			"prefix": "resource-groups",
			"name": "ResourceGroups"
		},
		"alexaforbusiness": {
			"name": "AlexaForBusiness"
		},
		"cloud9": {
			"name": "Cloud9"
		},
		"serverlessapplicationrepository": {
			"prefix": "serverlessrepo",
			"name": "ServerlessApplicationRepository"
		},
		"servicediscovery": {
			"name": "ServiceDiscovery"
		},
		"workmail": {
			"name": "WorkMail"
		}
	};

/***/ },
/* 1645 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-06-15",
			"endpointPrefix": "sts",
			"globalEndpoint": "sts.amazonaws.com",
			"protocol": "query",
			"serviceAbbreviation": "AWS STS",
			"serviceFullName": "AWS Security Token Service",
			"signatureVersion": "v4",
			"uid": "sts-2011-06-15",
			"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
		},
		"operations": {
			"AssumeRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						},
						"ExternalId": {},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"AssumedRoleUser": {
							"shape": "Sf"
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"AssumeRoleWithSAML": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"PrincipalArn",
						"SAMLAssertion"
					],
					"members": {
						"RoleArn": {},
						"PrincipalArn": {},
						"SAMLAssertion": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithSAMLResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"AssumedRoleUser": {
							"shape": "Sf"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Subject": {},
						"SubjectType": {},
						"Issuer": {},
						"Audience": {},
						"NameQualifier": {}
					}
				}
			},
			"AssumeRoleWithWebIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName",
						"WebIdentityToken"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"WebIdentityToken": {},
						"ProviderId": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithWebIdentityResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"SubjectFromWebIdentityToken": {},
						"AssumedRoleUser": {
							"shape": "Sf"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Provider": {},
						"Audience": {}
					}
				}
			},
			"DecodeAuthorizationMessage": {
				"input": {
					"type": "structure",
					"required": [
						"EncodedMessage"
					],
					"members": {
						"EncodedMessage": {}
					}
				},
				"output": {
					"resultWrapper": "DecodeAuthorizationMessageResult",
					"type": "structure",
					"members": {
						"DecodedMessage": {}
					}
				}
			},
			"GetCallerIdentity": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "GetCallerIdentityResult",
					"type": "structure",
					"members": {
						"UserId": {},
						"Account": {},
						"Arn": {}
					}
				}
			},
			"GetFederationToken": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "GetFederationTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"FederatedUser": {
							"type": "structure",
							"required": [
								"FederatedUserId",
								"Arn"
							],
							"members": {
								"FederatedUserId": {},
								"Arn": {}
							}
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"GetSessionToken": {
				"input": {
					"type": "structure",
					"members": {
						"DurationSeconds": {
							"type": "integer"
						},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "GetSessionTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						}
					}
				}
			}
		},
		"shapes": {
			"Sa": {
				"type": "structure",
				"required": [
					"AccessKeyId",
					"SecretAccessKey",
					"SessionToken",
					"Expiration"
				],
				"members": {
					"AccessKeyId": {},
					"SecretAccessKey": {},
					"SessionToken": {},
					"Expiration": {
						"type": "timestamp"
					}
				}
			},
			"Sf": {
				"type": "structure",
				"required": [
					"AssumedRoleId",
					"Arn"
				],
				"members": {
					"AssumedRoleId": {},
					"Arn": {}
				}
			}
		}
	};

/***/ },
/* 1646 */
1641,
/* 1647 */
/***/ function(module, exports) {

	module.exports = {
		"rules": {
			"*/*": {
				"endpoint": "{service}.{region}.amazonaws.com"
			},
			"cn-*/*": {
				"endpoint": "{service}.{region}.amazonaws.com.cn"
			},
			"*/budgets": "globalSSL",
			"*/cloudfront": "globalSSL",
			"*/iam": "globalSSL",
			"*/sts": "globalSSL",
			"*/importexport": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "v2",
				"globalEndpoint": true
			},
			"*/route53": {
				"endpoint": "https://{service}.amazonaws.com",
				"signatureVersion": "v3https",
				"globalEndpoint": true
			},
			"*/waf": "globalSSL",
			"us-gov-*/iam": "globalGovCloud",
			"us-gov-*/sts": {
				"endpoint": "{service}.{region}.amazonaws.com"
			},
			"us-gov-west-1/s3": "s3signature",
			"us-west-1/s3": "s3signature",
			"us-west-2/s3": "s3signature",
			"eu-west-1/s3": "s3signature",
			"ap-southeast-1/s3": "s3signature",
			"ap-southeast-2/s3": "s3signature",
			"ap-northeast-1/s3": "s3signature",
			"sa-east-1/s3": "s3signature",
			"us-east-1/s3": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "s3"
			},
			"us-east-1/sdb": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "v2"
			},
			"*/sdb": {
				"endpoint": "{service}.{region}.amazonaws.com",
				"signatureVersion": "v2"
			}
		},
		"patterns": {
			"globalSSL": {
				"endpoint": "https://{service}.amazonaws.com",
				"globalEndpoint": true
			},
			"globalGovCloud": {
				"endpoint": "{service}.us-gov.amazonaws.com"
			},
			"s3signature": {
				"endpoint": "{service}.{region}.amazonaws.com",
				"signatureVersion": "s3"
			}
		}
	};

/***/ },
/* 1648 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-12-08",
			"endpointPrefix": "acm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "ACM",
			"serviceFullName": "AWS Certificate Manager",
			"serviceId": "ACM",
			"signatureVersion": "v4",
			"targetPrefix": "CertificateManager",
			"uid": "acm-2015-12-08"
		},
		"operations": {
			"AddTagsToCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Tags"
					],
					"members": {
						"CertificateArn": {},
						"Tags": {
							"shape": "S3"
						}
					}
				}
			},
			"DeleteCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"DescribeCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Certificate": {
							"type": "structure",
							"members": {
								"CertificateArn": {},
								"DomainName": {},
								"SubjectAlternativeNames": {
									"shape": "Sc"
								},
								"DomainValidationOptions": {
									"shape": "Sd"
								},
								"Serial": {},
								"Subject": {},
								"Issuer": {},
								"CreatedAt": {
									"type": "timestamp"
								},
								"IssuedAt": {
									"type": "timestamp"
								},
								"ImportedAt": {
									"type": "timestamp"
								},
								"Status": {},
								"RevokedAt": {
									"type": "timestamp"
								},
								"RevocationReason": {},
								"NotBefore": {
									"type": "timestamp"
								},
								"NotAfter": {
									"type": "timestamp"
								},
								"KeyAlgorithm": {},
								"SignatureAlgorithm": {},
								"InUseBy": {
									"type": "list",
									"member": {}
								},
								"FailureReason": {},
								"Type": {},
								"RenewalSummary": {
									"type": "structure",
									"required": [
										"RenewalStatus",
										"DomainValidationOptions",
										"UpdatedAt"
									],
									"members": {
										"RenewalStatus": {},
										"DomainValidationOptions": {
											"shape": "Sd"
										},
										"RenewalStatusReason": {},
										"UpdatedAt": {
											"type": "timestamp"
										}
									}
								},
								"KeyUsages": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"ExtendedKeyUsages": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"OID": {}
										}
									}
								},
								"CertificateAuthorityArn": {},
								"RenewalEligibility": {},
								"Options": {
									"shape": "S11"
								}
							}
						}
					}
				}
			},
			"ExportCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Passphrase"
					],
					"members": {
						"CertificateArn": {},
						"Passphrase": {
							"type": "blob",
							"sensitive": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Certificate": {},
						"CertificateChain": {},
						"PrivateKey": {
							"type": "string",
							"sensitive": true
						}
					}
				}
			},
			"GetCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Certificate": {},
						"CertificateChain": {}
					}
				}
			},
			"ImportCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"Certificate",
						"PrivateKey"
					],
					"members": {
						"CertificateArn": {},
						"Certificate": {
							"type": "blob"
						},
						"PrivateKey": {
							"type": "blob",
							"sensitive": true
						},
						"CertificateChain": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"ListCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"CertificateStatuses": {
							"type": "list",
							"member": {}
						},
						"Includes": {
							"type": "structure",
							"members": {
								"extendedKeyUsage": {
									"type": "list",
									"member": {}
								},
								"keyUsage": {
									"type": "list",
									"member": {}
								},
								"keyTypes": {
									"type": "list",
									"member": {}
								}
							}
						},
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"CertificateSummaryList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CertificateArn": {},
									"DomainName": {}
								}
							}
						}
					}
				}
			},
			"ListTagsForCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S3"
						}
					}
				}
			},
			"RemoveTagsFromCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Tags"
					],
					"members": {
						"CertificateArn": {},
						"Tags": {
							"shape": "S3"
						}
					}
				}
			},
			"RenewCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"RequestCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"ValidationMethod": {},
						"SubjectAlternativeNames": {
							"shape": "Sc"
						},
						"IdempotencyToken": {},
						"DomainValidationOptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"DomainName",
									"ValidationDomain"
								],
								"members": {
									"DomainName": {},
									"ValidationDomain": {}
								}
							}
						},
						"Options": {
							"shape": "S11"
						},
						"CertificateAuthorityArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"ResendValidationEmail": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Domain",
						"ValidationDomain"
					],
					"members": {
						"CertificateArn": {},
						"Domain": {},
						"ValidationDomain": {}
					}
				}
			},
			"UpdateCertificateOptions": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Options"
					],
					"members": {
						"CertificateArn": {},
						"Options": {
							"shape": "S11"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sc": {
				"type": "list",
				"member": {}
			},
			"Sd": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"ValidationEmails": {
							"type": "list",
							"member": {}
						},
						"ValidationDomain": {},
						"ValidationStatus": {},
						"ResourceRecord": {
							"type": "structure",
							"required": [
								"Name",
								"Type",
								"Value"
							],
							"members": {
								"Name": {},
								"Type": {},
								"Value": {}
							}
						},
						"ValidationMethod": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"CertificateTransparencyLoggingPreference": {}
				}
			}
		}
	};

/***/ },
/* 1649 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCertificates": {
				"input_token": "NextToken",
				"limit_key": "MaxItems",
				"output_token": "NextToken",
				"result_key": "CertificateSummaryList"
			}
		}
	};

/***/ },
/* 1650 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"CertificateValidated": {
				"delay": 60,
				"maxAttempts": 40,
				"operation": "DescribeCertificate",
				"acceptors": [
					{
						"matcher": "pathAll",
						"expected": "SUCCESS",
						"argument": "Certificate.DomainValidationOptions[].ValidationStatus",
						"state": "success"
					},
					{
						"matcher": "pathAny",
						"expected": "PENDING_VALIDATION",
						"argument": "Certificate.DomainValidationOptions[].ValidationStatus",
						"state": "retry"
					},
					{
						"matcher": "path",
						"expected": "FAILED",
						"argument": "Certificate.Status",
						"state": "failure"
					},
					{
						"matcher": "error",
						"expected": "ResourceNotFoundException",
						"state": "failure"
					}
				]
			}
		}
	};

/***/ },
/* 1651 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-07-09",
			"endpointPrefix": "apigateway",
			"protocol": "rest-json",
			"serviceFullName": "Amazon API Gateway",
			"serviceId": "API Gateway",
			"signatureVersion": "v4",
			"uid": "apigateway-2015-07-09"
		},
		"operations": {
			"CreateApiKey": {
				"http": {
					"requestUri": "/apikeys",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"enabled": {
							"type": "boolean"
						},
						"generateDistinctId": {
							"type": "boolean"
						},
						"value": {},
						"stageKeys": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"restApiId": {},
									"stageName": {}
								}
							}
						},
						"customerId": {},
						"tags": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"CreateAuthorizer": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/authorizers",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"name",
						"type"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"name": {},
						"type": {},
						"providerARNs": {
							"shape": "Sc"
						},
						"authType": {},
						"authorizerUri": {},
						"authorizerCredentials": {},
						"identitySource": {},
						"identityValidationExpression": {},
						"authorizerResultTtlInSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "Sf"
				}
			},
			"CreateBasePathMapping": {
				"http": {
					"requestUri": "/domainnames/{domain_name}/basepathmappings",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"restApiId"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {},
						"restApiId": {},
						"stage": {}
					}
				},
				"output": {
					"shape": "Sh"
				}
			},
			"CreateDeployment": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/deployments",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {},
						"stageDescription": {},
						"description": {},
						"cacheClusterEnabled": {
							"type": "boolean"
						},
						"cacheClusterSize": {},
						"variables": {
							"shape": "S6"
						},
						"canarySettings": {
							"type": "structure",
							"members": {
								"percentTraffic": {
									"type": "double"
								},
								"stageVariableOverrides": {
									"shape": "S6"
								},
								"useStageCache": {
									"type": "boolean"
								}
							}
						},
						"tracingEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "Sn"
				}
			},
			"CreateDocumentationPart": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/documentation/parts",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"location",
						"properties"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"location": {
							"shape": "Ss"
						},
						"properties": {}
					}
				},
				"output": {
					"shape": "Sv"
				}
			},
			"CreateDocumentationVersion": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/documentation/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {},
						"stageName": {},
						"description": {}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"CreateDomainName": {
				"http": {
					"requestUri": "/domainnames",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {},
						"certificateName": {},
						"certificateBody": {},
						"certificatePrivateKey": {},
						"certificateChain": {},
						"certificateArn": {},
						"regionalCertificateName": {},
						"regionalCertificateArn": {},
						"endpointConfiguration": {
							"shape": "Sz"
						},
						"tags": {
							"shape": "S6"
						},
						"securityPolicy": {}
					}
				},
				"output": {
					"shape": "S13"
				}
			},
			"CreateModel": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/models",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"name",
						"contentType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"name": {},
						"description": {},
						"schema": {},
						"contentType": {}
					}
				},
				"output": {
					"shape": "S16"
				}
			},
			"CreateRequestValidator": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/requestvalidators",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"name": {},
						"validateRequestBody": {
							"type": "boolean"
						},
						"validateRequestParameters": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S18"
				}
			},
			"CreateResource": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/resources/{parent_id}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"parentId",
						"pathPart"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"parentId": {
							"location": "uri",
							"locationName": "parent_id"
						},
						"pathPart": {}
					}
				},
				"output": {
					"shape": "S1a"
				}
			},
			"CreateRestApi": {
				"http": {
					"requestUri": "/restapis",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"description": {},
						"version": {},
						"cloneFrom": {},
						"binaryMediaTypes": {
							"shape": "S9"
						},
						"minimumCompressionSize": {
							"type": "integer"
						},
						"apiKeySource": {},
						"endpointConfiguration": {
							"shape": "Sz"
						},
						"policy": {},
						"tags": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S1q"
				}
			},
			"CreateStage": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/stages",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {},
						"deploymentId": {},
						"description": {},
						"cacheClusterEnabled": {
							"type": "boolean"
						},
						"cacheClusterSize": {},
						"variables": {
							"shape": "S6"
						},
						"documentationVersion": {},
						"canarySettings": {
							"shape": "S1s"
						},
						"tracingEnabled": {
							"type": "boolean"
						},
						"tags": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S1t"
				}
			},
			"CreateUsagePlan": {
				"http": {
					"requestUri": "/usageplans",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"description": {},
						"apiStages": {
							"shape": "S20"
						},
						"throttle": {
							"shape": "S23"
						},
						"quota": {
							"shape": "S24"
						},
						"tags": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S26"
				}
			},
			"CreateUsagePlanKey": {
				"http": {
					"requestUri": "/usageplans/{usageplanId}/keys",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId",
						"keyType"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {},
						"keyType": {}
					}
				},
				"output": {
					"shape": "S28"
				}
			},
			"CreateVpcLink": {
				"http": {
					"requestUri": "/vpclinks",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"targetArns"
					],
					"members": {
						"name": {},
						"description": {},
						"targetArns": {
							"shape": "S9"
						},
						"tags": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S2a"
				}
			},
			"DeleteApiKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/apikeys/{api_Key}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"apiKey"
					],
					"members": {
						"apiKey": {
							"location": "uri",
							"locationName": "api_Key"
						}
					}
				}
			},
			"DeleteAuthorizer": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						}
					}
				}
			},
			"DeleteBasePathMapping": {
				"http": {
					"method": "DELETE",
					"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"basePath"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {
							"location": "uri",
							"locationName": "base_path"
						}
					}
				}
			},
			"DeleteClientCertificate": {
				"http": {
					"method": "DELETE",
					"requestUri": "/clientcertificates/{clientcertificate_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"clientCertificateId"
					],
					"members": {
						"clientCertificateId": {
							"location": "uri",
							"locationName": "clientcertificate_id"
						}
					}
				}
			},
			"DeleteDeployment": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "uri",
							"locationName": "deployment_id"
						}
					}
				}
			},
			"DeleteDocumentationPart": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationPartId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationPartId": {
							"location": "uri",
							"locationName": "part_id"
						}
					}
				}
			},
			"DeleteDocumentationVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {
							"location": "uri",
							"locationName": "doc_version"
						}
					}
				}
			},
			"DeleteDomainName": {
				"http": {
					"method": "DELETE",
					"requestUri": "/domainnames/{domain_name}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						}
					}
				}
			},
			"DeleteGatewayResponse": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"responseType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"responseType": {
							"location": "uri",
							"locationName": "response_type"
						}
					}
				}
			},
			"DeleteIntegration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				}
			},
			"DeleteIntegrationResponse": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				}
			},
			"DeleteMethod": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				}
			},
			"DeleteMethodResponse": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				}
			},
			"DeleteModel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						}
					}
				}
			},
			"DeleteRequestValidator": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"requestValidatorId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"requestValidatorId": {
							"location": "uri",
							"locationName": "requestvalidator_id"
						}
					}
				}
			},
			"DeleteResource": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						}
					}
				}
			},
			"DeleteRestApi": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						}
					}
				}
			},
			"DeleteStage": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				}
			},
			"DeleteUsagePlan": {
				"http": {
					"method": "DELETE",
					"requestUri": "/usageplans/{usageplanId}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						}
					}
				}
			},
			"DeleteUsagePlanKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "uri",
							"locationName": "keyId"
						}
					}
				}
			},
			"DeleteVpcLink": {
				"http": {
					"method": "DELETE",
					"requestUri": "/vpclinks/{vpclink_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"vpcLinkId"
					],
					"members": {
						"vpcLinkId": {
							"location": "uri",
							"locationName": "vpclink_id"
						}
					}
				}
			},
			"FlushStageAuthorizersCache": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				}
			},
			"FlushStageCache": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/data",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				}
			},
			"GenerateClientCertificate": {
				"http": {
					"requestUri": "/clientcertificates",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"description": {},
						"tags": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S31"
				}
			},
			"GetAccount": {
				"http": {
					"method": "GET",
					"requestUri": "/account"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"shape": "S33"
				}
			},
			"GetApiKey": {
				"http": {
					"method": "GET",
					"requestUri": "/apikeys/{api_Key}"
				},
				"input": {
					"type": "structure",
					"required": [
						"apiKey"
					],
					"members": {
						"apiKey": {
							"location": "uri",
							"locationName": "api_Key"
						},
						"includeValue": {
							"location": "querystring",
							"locationName": "includeValue",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"GetApiKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/apikeys"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"nameQuery": {
							"location": "querystring",
							"locationName": "name"
						},
						"customerId": {
							"location": "querystring",
							"locationName": "customerId"
						},
						"includeValues": {
							"location": "querystring",
							"locationName": "includeValues",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"warnings": {
							"shape": "S9"
						},
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S7"
							}
						}
					}
				}
			},
			"GetAuthorizer": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						}
					}
				},
				"output": {
					"shape": "Sf"
				}
			},
			"GetAuthorizers": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/authorizers"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sf"
							}
						}
					}
				}
			},
			"GetBasePathMapping": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"basePath"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {
							"location": "uri",
							"locationName": "base_path"
						}
					}
				},
				"output": {
					"shape": "Sh"
				}
			},
			"GetBasePathMappings": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames/{domain_name}/basepathmappings"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sh"
							}
						}
					}
				}
			},
			"GetClientCertificate": {
				"http": {
					"method": "GET",
					"requestUri": "/clientcertificates/{clientcertificate_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"clientCertificateId"
					],
					"members": {
						"clientCertificateId": {
							"location": "uri",
							"locationName": "clientcertificate_id"
						}
					}
				},
				"output": {
					"shape": "S31"
				}
			},
			"GetClientCertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/clientcertificates"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S31"
							}
						}
					}
				}
			},
			"GetDeployment": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "uri",
							"locationName": "deployment_id"
						},
						"embed": {
							"shape": "S9",
							"location": "querystring",
							"locationName": "embed"
						}
					}
				},
				"output": {
					"shape": "Sn"
				}
			},
			"GetDeployments": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/deployments"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sn"
							}
						}
					}
				}
			},
			"GetDocumentationPart": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationPartId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationPartId": {
							"location": "uri",
							"locationName": "part_id"
						}
					}
				},
				"output": {
					"shape": "Sv"
				}
			},
			"GetDocumentationParts": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/parts"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"type": {
							"location": "querystring",
							"locationName": "type"
						},
						"nameQuery": {
							"location": "querystring",
							"locationName": "name"
						},
						"path": {
							"location": "querystring",
							"locationName": "path"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"locationStatus": {
							"location": "querystring",
							"locationName": "locationStatus"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sv"
							}
						}
					}
				}
			},
			"GetDocumentationVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {
							"location": "uri",
							"locationName": "doc_version"
						}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"GetDocumentationVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/versions"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sx"
							}
						}
					}
				}
			},
			"GetDomainName": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames/{domain_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						}
					}
				},
				"output": {
					"shape": "S13"
				}
			},
			"GetDomainNames": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S13"
							}
						}
					}
				}
			},
			"GetExport": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName",
						"exportType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						},
						"exportType": {
							"location": "uri",
							"locationName": "export_type"
						},
						"parameters": {
							"shape": "S6",
							"location": "querystring"
						},
						"accepts": {
							"location": "header",
							"locationName": "Accept"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"contentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				}
			},
			"GetGatewayResponse": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"responseType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"responseType": {
							"location": "uri",
							"locationName": "response_type"
						}
					}
				},
				"output": {
					"shape": "S45"
				}
			},
			"GetGatewayResponses": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/gatewayresponses"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S45"
							}
						}
					}
				}
			},
			"GetIntegration": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				},
				"output": {
					"shape": "S1h"
				}
			},
			"GetIntegrationResponse": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				},
				"output": {
					"shape": "S1n"
				}
			},
			"GetMethod": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"GetMethodResponse": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				},
				"output": {
					"shape": "S1f"
				}
			},
			"GetModel": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						},
						"flatten": {
							"location": "querystring",
							"locationName": "flatten",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S16"
				}
			},
			"GetModelTemplate": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}/default_template"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"value": {}
					}
				}
			},
			"GetModels": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/models"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S16"
							}
						}
					}
				}
			},
			"GetRequestValidator": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"requestValidatorId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"requestValidatorId": {
							"location": "uri",
							"locationName": "requestvalidator_id"
						}
					}
				},
				"output": {
					"shape": "S18"
				}
			},
			"GetRequestValidators": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/requestvalidators"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S18"
							}
						}
					}
				}
			},
			"GetResource": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"embed": {
							"shape": "S9",
							"location": "querystring",
							"locationName": "embed"
						}
					}
				},
				"output": {
					"shape": "S1a"
				}
			},
			"GetResources": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"embed": {
							"shape": "S9",
							"location": "querystring",
							"locationName": "embed"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S1a"
							}
						}
					}
				}
			},
			"GetRestApi": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						}
					}
				},
				"output": {
					"shape": "S1q"
				}
			},
			"GetRestApis": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S1q"
							}
						}
					}
				}
			},
			"GetSdk": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName",
						"sdkType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						},
						"sdkType": {
							"location": "uri",
							"locationName": "sdk_type"
						},
						"parameters": {
							"shape": "S6",
							"location": "querystring"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"contentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				}
			},
			"GetSdkType": {
				"http": {
					"method": "GET",
					"requestUri": "/sdktypes/{sdktype_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"id"
					],
					"members": {
						"id": {
							"location": "uri",
							"locationName": "sdktype_id"
						}
					}
				},
				"output": {
					"shape": "S4y"
				}
			},
			"GetSdkTypes": {
				"http": {
					"method": "GET",
					"requestUri": "/sdktypes"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S4y"
							}
						}
					}
				}
			},
			"GetStage": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				},
				"output": {
					"shape": "S1t"
				}
			},
			"GetStages": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "querystring",
							"locationName": "deploymentId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"item": {
							"type": "list",
							"member": {
								"shape": "S1t"
							}
						}
					}
				}
			},
			"GetTags": {
				"http": {
					"method": "GET",
					"requestUri": "/tags/{resource_arn}"
				},
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {
							"location": "uri",
							"locationName": "resource_arn"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "S6"
						}
					}
				}
			},
			"GetUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}/usage"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"startDate",
						"endDate"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "querystring",
							"locationName": "keyId"
						},
						"startDate": {
							"location": "querystring",
							"locationName": "startDate"
						},
						"endDate": {
							"location": "querystring",
							"locationName": "endDate"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S5b"
				}
			},
			"GetUsagePlan": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						}
					}
				},
				"output": {
					"shape": "S26"
				}
			},
			"GetUsagePlanKey": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "uri",
							"locationName": "keyId"
						}
					}
				},
				"output": {
					"shape": "S28"
				}
			},
			"GetUsagePlanKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}/keys"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"nameQuery": {
							"location": "querystring",
							"locationName": "name"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S28"
							}
						}
					}
				}
			},
			"GetUsagePlans": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"keyId": {
							"location": "querystring",
							"locationName": "keyId"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S26"
							}
						}
					}
				}
			},
			"GetVpcLink": {
				"http": {
					"method": "GET",
					"requestUri": "/vpclinks/{vpclink_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"vpcLinkId"
					],
					"members": {
						"vpcLinkId": {
							"location": "uri",
							"locationName": "vpclink_id"
						}
					}
				},
				"output": {
					"shape": "S2a"
				}
			},
			"GetVpcLinks": {
				"http": {
					"method": "GET",
					"requestUri": "/vpclinks"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S2a"
							}
						}
					}
				}
			},
			"ImportApiKeys": {
				"http": {
					"requestUri": "/apikeys?mode=import",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"body",
						"format"
					],
					"members": {
						"body": {
							"type": "blob"
						},
						"format": {
							"location": "querystring",
							"locationName": "format"
						},
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						}
					},
					"payload": "body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ids": {
							"shape": "S9"
						},
						"warnings": {
							"shape": "S9"
						}
					}
				}
			},
			"ImportDocumentationParts": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/documentation/parts"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"body"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"mode": {
							"location": "querystring",
							"locationName": "mode"
						},
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ids": {
							"shape": "S9"
						},
						"warnings": {
							"shape": "S9"
						}
					}
				}
			},
			"ImportRestApi": {
				"http": {
					"requestUri": "/restapis?mode=import",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"body"
					],
					"members": {
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						},
						"parameters": {
							"shape": "S6",
							"location": "querystring"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				},
				"output": {
					"shape": "S1q"
				}
			},
			"PutGatewayResponse": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"responseType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"responseType": {
							"location": "uri",
							"locationName": "response_type"
						},
						"statusCode": {},
						"responseParameters": {
							"shape": "S6"
						},
						"responseTemplates": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S45"
				}
			},
			"PutIntegration": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"type"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"type": {},
						"integrationHttpMethod": {
							"locationName": "httpMethod"
						},
						"uri": {},
						"connectionType": {},
						"connectionId": {},
						"credentials": {},
						"requestParameters": {
							"shape": "S6"
						},
						"requestTemplates": {
							"shape": "S6"
						},
						"passthroughBehavior": {},
						"cacheNamespace": {},
						"cacheKeyParameters": {
							"shape": "S9"
						},
						"contentHandling": {},
						"timeoutInMillis": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S1h"
				}
			},
			"PutIntegrationResponse": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"selectionPattern": {},
						"responseParameters": {
							"shape": "S6"
						},
						"responseTemplates": {
							"shape": "S6"
						},
						"contentHandling": {}
					}
				},
				"output": {
					"shape": "S1n"
				}
			},
			"PutMethod": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"authorizationType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"authorizationType": {},
						"authorizerId": {},
						"apiKeyRequired": {
							"type": "boolean"
						},
						"operationName": {},
						"requestParameters": {
							"shape": "S1d"
						},
						"requestModels": {
							"shape": "S6"
						},
						"requestValidatorId": {},
						"authorizationScopes": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"PutMethodResponse": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"responseParameters": {
							"shape": "S1d"
						},
						"responseModels": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S1f"
				}
			},
			"PutRestApi": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"body"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"mode": {
							"location": "querystring",
							"locationName": "mode"
						},
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						},
						"parameters": {
							"shape": "S6",
							"location": "querystring"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				},
				"output": {
					"shape": "S1q"
				}
			},
			"TagResource": {
				"http": {
					"method": "PUT",
					"requestUri": "/tags/{resource_arn}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {
							"location": "uri",
							"locationName": "resource_arn"
						},
						"tags": {
							"shape": "S6"
						}
					}
				}
			},
			"TestInvokeAuthorizer": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						},
						"headers": {
							"shape": "S6"
						},
						"multiValueHeaders": {
							"shape": "S67"
						},
						"pathWithQueryString": {},
						"body": {},
						"stageVariables": {
							"shape": "S6"
						},
						"additionalContext": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"clientStatus": {
							"type": "integer"
						},
						"log": {},
						"latency": {
							"type": "long"
						},
						"principalId": {},
						"policy": {},
						"authorization": {
							"shape": "S67"
						},
						"claims": {
							"shape": "S6"
						}
					}
				}
			},
			"TestInvokeMethod": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"pathWithQueryString": {},
						"body": {},
						"headers": {
							"shape": "S6"
						},
						"multiValueHeaders": {
							"shape": "S67"
						},
						"clientCertificateId": {},
						"stageVariables": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {
							"type": "integer"
						},
						"body": {},
						"headers": {
							"shape": "S6"
						},
						"multiValueHeaders": {
							"shape": "S67"
						},
						"log": {},
						"latency": {
							"type": "long"
						}
					}
				}
			},
			"UntagResource": {
				"http": {
					"method": "DELETE",
					"requestUri": "/tags/{resource_arn}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {
							"location": "uri",
							"locationName": "resource_arn"
						},
						"tagKeys": {
							"shape": "S9",
							"location": "querystring",
							"locationName": "tagKeys"
						}
					}
				}
			},
			"UpdateAccount": {
				"http": {
					"method": "PATCH",
					"requestUri": "/account"
				},
				"input": {
					"type": "structure",
					"members": {
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S33"
				}
			},
			"UpdateApiKey": {
				"http": {
					"method": "PATCH",
					"requestUri": "/apikeys/{api_Key}"
				},
				"input": {
					"type": "structure",
					"required": [
						"apiKey"
					],
					"members": {
						"apiKey": {
							"location": "uri",
							"locationName": "api_Key"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"UpdateAuthorizer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "Sf"
				}
			},
			"UpdateBasePathMapping": {
				"http": {
					"method": "PATCH",
					"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"basePath"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {
							"location": "uri",
							"locationName": "base_path"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "Sh"
				}
			},
			"UpdateClientCertificate": {
				"http": {
					"method": "PATCH",
					"requestUri": "/clientcertificates/{clientcertificate_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"clientCertificateId"
					],
					"members": {
						"clientCertificateId": {
							"location": "uri",
							"locationName": "clientcertificate_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S31"
				}
			},
			"UpdateDeployment": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "uri",
							"locationName": "deployment_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "Sn"
				}
			},
			"UpdateDocumentationPart": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationPartId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationPartId": {
							"location": "uri",
							"locationName": "part_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "Sv"
				}
			},
			"UpdateDocumentationVersion": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {
							"location": "uri",
							"locationName": "doc_version"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"UpdateDomainName": {
				"http": {
					"method": "PATCH",
					"requestUri": "/domainnames/{domain_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S13"
				}
			},
			"UpdateGatewayResponse": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/gatewayresponses/{response_type}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"responseType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"responseType": {
							"location": "uri",
							"locationName": "response_type"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S45"
				}
			},
			"UpdateIntegration": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S1h"
				}
			},
			"UpdateIntegrationResponse": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S1n"
				}
			},
			"UpdateMethod": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"UpdateMethodResponse": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S1f"
				}
			},
			"UpdateModel": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S16"
				}
			},
			"UpdateRequestValidator": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"requestValidatorId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"requestValidatorId": {
							"location": "uri",
							"locationName": "requestvalidator_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S18"
				}
			},
			"UpdateResource": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S1a"
				}
			},
			"UpdateRestApi": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S1q"
				}
			},
			"UpdateStage": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S1t"
				}
			},
			"UpdateUsage": {
				"http": {
					"method": "PATCH",
					"requestUri": "/usageplans/{usageplanId}/keys/{keyId}/usage"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "uri",
							"locationName": "keyId"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S5b"
				}
			},
			"UpdateUsagePlan": {
				"http": {
					"method": "PATCH",
					"requestUri": "/usageplans/{usageplanId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S26"
				}
			},
			"UpdateVpcLink": {
				"http": {
					"method": "PATCH",
					"requestUri": "/vpclinks/{vpclink_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"vpcLinkId"
					],
					"members": {
						"vpcLinkId": {
							"location": "uri",
							"locationName": "vpclink_id"
						},
						"patchOperations": {
							"shape": "S6d"
						}
					}
				},
				"output": {
					"shape": "S2a"
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S7": {
				"type": "structure",
				"members": {
					"id": {},
					"value": {},
					"name": {},
					"customerId": {},
					"description": {},
					"enabled": {
						"type": "boolean"
					},
					"createdDate": {
						"type": "timestamp"
					},
					"lastUpdatedDate": {
						"type": "timestamp"
					},
					"stageKeys": {
						"shape": "S9"
					},
					"tags": {
						"shape": "S6"
					}
				}
			},
			"S9": {
				"type": "list",
				"member": {}
			},
			"Sc": {
				"type": "list",
				"member": {}
			},
			"Sf": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"type": {},
					"providerARNs": {
						"shape": "Sc"
					},
					"authType": {},
					"authorizerUri": {},
					"authorizerCredentials": {},
					"identitySource": {},
					"identityValidationExpression": {},
					"authorizerResultTtlInSeconds": {
						"type": "integer"
					}
				}
			},
			"Sh": {
				"type": "structure",
				"members": {
					"basePath": {},
					"restApiId": {},
					"stage": {}
				}
			},
			"Sn": {
				"type": "structure",
				"members": {
					"id": {},
					"description": {},
					"createdDate": {
						"type": "timestamp"
					},
					"apiSummary": {
						"type": "map",
						"key": {},
						"value": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"authorizationType": {},
									"apiKeyRequired": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"Ss": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"path": {},
					"method": {},
					"statusCode": {},
					"name": {}
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"id": {},
					"location": {
						"shape": "Ss"
					},
					"properties": {}
				}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"version": {},
					"createdDate": {
						"type": "timestamp"
					},
					"description": {}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"types": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S13": {
				"type": "structure",
				"members": {
					"domainName": {},
					"certificateName": {},
					"certificateArn": {},
					"certificateUploadDate": {
						"type": "timestamp"
					},
					"regionalDomainName": {},
					"regionalHostedZoneId": {},
					"regionalCertificateName": {},
					"regionalCertificateArn": {},
					"distributionDomainName": {},
					"distributionHostedZoneId": {},
					"endpointConfiguration": {
						"shape": "Sz"
					},
					"domainNameStatus": {},
					"domainNameStatusMessage": {},
					"securityPolicy": {},
					"tags": {
						"shape": "S6"
					}
				}
			},
			"S16": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"description": {},
					"schema": {},
					"contentType": {}
				}
			},
			"S18": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"validateRequestBody": {
						"type": "boolean"
					},
					"validateRequestParameters": {
						"type": "boolean"
					}
				}
			},
			"S1a": {
				"type": "structure",
				"members": {
					"id": {},
					"parentId": {},
					"pathPart": {},
					"path": {},
					"resourceMethods": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S1c"
						}
					}
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"httpMethod": {},
					"authorizationType": {},
					"authorizerId": {},
					"apiKeyRequired": {
						"type": "boolean"
					},
					"requestValidatorId": {},
					"operationName": {},
					"requestParameters": {
						"shape": "S1d"
					},
					"requestModels": {
						"shape": "S6"
					},
					"methodResponses": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S1f"
						}
					},
					"methodIntegration": {
						"shape": "S1h"
					},
					"authorizationScopes": {
						"shape": "S9"
					}
				}
			},
			"S1d": {
				"type": "map",
				"key": {},
				"value": {
					"type": "boolean"
				}
			},
			"S1f": {
				"type": "structure",
				"members": {
					"statusCode": {},
					"responseParameters": {
						"shape": "S1d"
					},
					"responseModels": {
						"shape": "S6"
					}
				}
			},
			"S1h": {
				"type": "structure",
				"members": {
					"type": {},
					"httpMethod": {},
					"uri": {},
					"connectionType": {},
					"connectionId": {},
					"credentials": {},
					"requestParameters": {
						"shape": "S6"
					},
					"requestTemplates": {
						"shape": "S6"
					},
					"passthroughBehavior": {},
					"contentHandling": {},
					"timeoutInMillis": {
						"type": "integer"
					},
					"cacheNamespace": {},
					"cacheKeyParameters": {
						"shape": "S9"
					},
					"integrationResponses": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S1n"
						}
					}
				}
			},
			"S1n": {
				"type": "structure",
				"members": {
					"statusCode": {},
					"selectionPattern": {},
					"responseParameters": {
						"shape": "S6"
					},
					"responseTemplates": {
						"shape": "S6"
					},
					"contentHandling": {}
				}
			},
			"S1q": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"description": {},
					"createdDate": {
						"type": "timestamp"
					},
					"version": {},
					"warnings": {
						"shape": "S9"
					},
					"binaryMediaTypes": {
						"shape": "S9"
					},
					"minimumCompressionSize": {
						"type": "integer"
					},
					"apiKeySource": {},
					"endpointConfiguration": {
						"shape": "Sz"
					},
					"policy": {},
					"tags": {
						"shape": "S6"
					}
				}
			},
			"S1s": {
				"type": "structure",
				"members": {
					"percentTraffic": {
						"type": "double"
					},
					"deploymentId": {},
					"stageVariableOverrides": {
						"shape": "S6"
					},
					"useStageCache": {
						"type": "boolean"
					}
				}
			},
			"S1t": {
				"type": "structure",
				"members": {
					"deploymentId": {},
					"clientCertificateId": {},
					"stageName": {},
					"description": {},
					"cacheClusterEnabled": {
						"type": "boolean"
					},
					"cacheClusterSize": {},
					"cacheClusterStatus": {},
					"methodSettings": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"metricsEnabled": {
									"type": "boolean"
								},
								"loggingLevel": {},
								"dataTraceEnabled": {
									"type": "boolean"
								},
								"throttlingBurstLimit": {
									"type": "integer"
								},
								"throttlingRateLimit": {
									"type": "double"
								},
								"cachingEnabled": {
									"type": "boolean"
								},
								"cacheTtlInSeconds": {
									"type": "integer"
								},
								"cacheDataEncrypted": {
									"type": "boolean"
								},
								"requireAuthorizationForCacheControl": {
									"type": "boolean"
								},
								"unauthorizedCacheControlHeaderStrategy": {}
							}
						}
					},
					"variables": {
						"shape": "S6"
					},
					"documentationVersion": {},
					"accessLogSettings": {
						"type": "structure",
						"members": {
							"format": {},
							"destinationArn": {}
						}
					},
					"canarySettings": {
						"shape": "S1s"
					},
					"tracingEnabled": {
						"type": "boolean"
					},
					"webAclArn": {},
					"tags": {
						"shape": "S6"
					},
					"createdDate": {
						"type": "timestamp"
					},
					"lastUpdatedDate": {
						"type": "timestamp"
					}
				}
			},
			"S20": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"apiId": {},
						"stage": {},
						"throttle": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "S23"
							}
						}
					}
				}
			},
			"S23": {
				"type": "structure",
				"members": {
					"burstLimit": {
						"type": "integer"
					},
					"rateLimit": {
						"type": "double"
					}
				}
			},
			"S24": {
				"type": "structure",
				"members": {
					"limit": {
						"type": "integer"
					},
					"offset": {
						"type": "integer"
					},
					"period": {}
				}
			},
			"S26": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"description": {},
					"apiStages": {
						"shape": "S20"
					},
					"throttle": {
						"shape": "S23"
					},
					"quota": {
						"shape": "S24"
					},
					"productCode": {},
					"tags": {
						"shape": "S6"
					}
				}
			},
			"S28": {
				"type": "structure",
				"members": {
					"id": {},
					"type": {},
					"value": {},
					"name": {}
				}
			},
			"S2a": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"description": {},
					"targetArns": {
						"shape": "S9"
					},
					"status": {},
					"statusMessage": {},
					"tags": {
						"shape": "S6"
					}
				}
			},
			"S31": {
				"type": "structure",
				"members": {
					"clientCertificateId": {},
					"description": {},
					"pemEncodedCertificate": {},
					"createdDate": {
						"type": "timestamp"
					},
					"expirationDate": {
						"type": "timestamp"
					},
					"tags": {
						"shape": "S6"
					}
				}
			},
			"S33": {
				"type": "structure",
				"members": {
					"cloudwatchRoleArn": {},
					"throttleSettings": {
						"shape": "S23"
					},
					"features": {
						"shape": "S9"
					},
					"apiKeyVersion": {}
				}
			},
			"S45": {
				"type": "structure",
				"members": {
					"responseType": {},
					"statusCode": {},
					"responseParameters": {
						"shape": "S6"
					},
					"responseTemplates": {
						"shape": "S6"
					},
					"defaultResponse": {
						"type": "boolean"
					}
				}
			},
			"S4y": {
				"type": "structure",
				"members": {
					"id": {},
					"friendlyName": {},
					"description": {},
					"configurationProperties": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {},
								"friendlyName": {},
								"description": {},
								"required": {
									"type": "boolean"
								},
								"defaultValue": {}
							}
						}
					}
				}
			},
			"S5b": {
				"type": "structure",
				"members": {
					"usagePlanId": {},
					"startDate": {},
					"endDate": {},
					"position": {},
					"items": {
						"locationName": "values",
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"type": "list",
								"member": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S67": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S9"
				}
			},
			"S6d": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"op": {},
						"path": {},
						"value": {},
						"from": {}
					}
				}
			}
		}
	};

/***/ },
/* 1652 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetApiKeys": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetBasePathMappings": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetClientCertificates": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetDeployments": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetDomainNames": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetModels": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetResources": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetRestApis": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetUsage": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetUsagePlanKeys": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetUsagePlans": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			},
			"GetVpcLinks": {
				"input_token": "position",
				"limit_key": "limit",
				"output_token": "position",
				"result_key": "items"
			}
		}
	};

/***/ },
/* 1653 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-02-06",
			"endpointPrefix": "autoscaling",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Application Auto Scaling",
			"serviceId": "Application Auto Scaling",
			"signatureVersion": "v4",
			"signingName": "application-autoscaling",
			"targetPrefix": "AnyScaleFrontendService",
			"uid": "application-autoscaling-2016-02-06"
		},
		"operations": {
			"DeleteScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName",
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"PolicyName": {},
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteScheduledAction": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace",
						"ScheduledActionName",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"ServiceNamespace": {},
						"ScheduledActionName": {},
						"ResourceId": {},
						"ScalableDimension": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterScalableTarget": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeScalableTargets": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceIds": {
							"shape": "Sb"
						},
						"ScalableDimension": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalableTargets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ServiceNamespace",
									"ResourceId",
									"ScalableDimension",
									"MinCapacity",
									"MaxCapacity",
									"RoleARN",
									"CreationTime"
								],
								"members": {
									"ServiceNamespace": {},
									"ResourceId": {},
									"ScalableDimension": {},
									"MinCapacity": {
										"type": "integer"
									},
									"MaxCapacity": {
										"type": "integer"
									},
									"RoleARN": {},
									"CreationTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingActivities": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalingActivities": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ActivityId",
									"ServiceNamespace",
									"ResourceId",
									"ScalableDimension",
									"Description",
									"Cause",
									"StartTime",
									"StatusCode"
								],
								"members": {
									"ActivityId": {},
									"ServiceNamespace": {},
									"ResourceId": {},
									"ScalableDimension": {},
									"Description": {},
									"Cause": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"StatusCode": {},
									"StatusMessage": {},
									"Details": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace"
					],
					"members": {
						"PolicyNames": {
							"shape": "Sb"
						},
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalingPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"PolicyARN",
									"PolicyName",
									"ServiceNamespace",
									"ResourceId",
									"ScalableDimension",
									"PolicyType",
									"CreationTime"
								],
								"members": {
									"PolicyARN": {},
									"PolicyName": {},
									"ServiceNamespace": {},
									"ResourceId": {},
									"ScalableDimension": {},
									"PolicyType": {},
									"StepScalingPolicyConfiguration": {
										"shape": "Sv"
									},
									"TargetTrackingScalingPolicyConfiguration": {
										"shape": "S14"
									},
									"Alarms": {
										"shape": "S1i"
									},
									"CreationTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScheduledActions": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace"
					],
					"members": {
						"ScheduledActionNames": {
							"shape": "Sb"
						},
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScheduledActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ScheduledActionName",
									"ScheduledActionARN",
									"ServiceNamespace",
									"Schedule",
									"ResourceId",
									"CreationTime"
								],
								"members": {
									"ScheduledActionName": {},
									"ScheduledActionARN": {},
									"ServiceNamespace": {},
									"Schedule": {},
									"ResourceId": {},
									"ScalableDimension": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"ScalableTargetAction": {
										"shape": "S1p"
									},
									"CreationTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName",
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"PolicyName": {},
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"PolicyType": {},
						"StepScalingPolicyConfiguration": {
							"shape": "Sv"
						},
						"TargetTrackingScalingPolicyConfiguration": {
							"shape": "S14"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"PolicyARN"
					],
					"members": {
						"PolicyARN": {},
						"Alarms": {
							"shape": "S1i"
						}
					}
				}
			},
			"PutScheduledAction": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace",
						"ScheduledActionName",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"ServiceNamespace": {},
						"Schedule": {},
						"ScheduledActionName": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"ScalableTargetAction": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RegisterScalableTarget": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"MinCapacity": {
							"type": "integer"
						},
						"MaxCapacity": {
							"type": "integer"
						},
						"RoleARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"Sb": {
				"type": "list",
				"member": {}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"AdjustmentType": {},
					"StepAdjustments": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"ScalingAdjustment"
							],
							"members": {
								"MetricIntervalLowerBound": {
									"type": "double"
								},
								"MetricIntervalUpperBound": {
									"type": "double"
								},
								"ScalingAdjustment": {
									"type": "integer"
								}
							}
						}
					},
					"MinAdjustmentMagnitude": {
						"type": "integer"
					},
					"Cooldown": {
						"type": "integer"
					},
					"MetricAggregationType": {}
				}
			},
			"S14": {
				"type": "structure",
				"required": [
					"TargetValue"
				],
				"members": {
					"TargetValue": {
						"type": "double"
					},
					"PredefinedMetricSpecification": {
						"type": "structure",
						"required": [
							"PredefinedMetricType"
						],
						"members": {
							"PredefinedMetricType": {},
							"ResourceLabel": {}
						}
					},
					"CustomizedMetricSpecification": {
						"type": "structure",
						"required": [
							"MetricName",
							"Namespace",
							"Statistic"
						],
						"members": {
							"MetricName": {},
							"Namespace": {},
							"Dimensions": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Name",
										"Value"
									],
									"members": {
										"Name": {},
										"Value": {}
									}
								}
							},
							"Statistic": {},
							"Unit": {}
						}
					},
					"ScaleOutCooldown": {
						"type": "integer"
					},
					"ScaleInCooldown": {
						"type": "integer"
					},
					"DisableScaleIn": {
						"type": "boolean"
					}
				}
			},
			"S1i": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AlarmName",
						"AlarmARN"
					],
					"members": {
						"AlarmName": {},
						"AlarmARN": {}
					}
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"MinCapacity": {
						"type": "integer"
					},
					"MaxCapacity": {
						"type": "integer"
					}
				}
			}
		}
	};

/***/ },
/* 1654 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeScalableTargets": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ScalableTargets"
			},
			"DescribeScalingActivities": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ScalingActivities"
			},
			"DescribeScalingPolicies": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ScalingPolicies"
			}
		}
	};

/***/ },
/* 1655 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-01-01",
			"endpointPrefix": "autoscaling",
			"protocol": "query",
			"serviceFullName": "Auto Scaling",
			"serviceId": "Auto Scaling",
			"signatureVersion": "v4",
			"uid": "autoscaling-2011-01-01",
			"xmlNamespace": "http://autoscaling.amazonaws.com/doc/2011-01-01/"
		},
		"operations": {
			"AttachInstances": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {}
					}
				}
			},
			"AttachLoadBalancerTargetGroups": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TargetGroupARNs"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TargetGroupARNs": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"resultWrapper": "AttachLoadBalancerTargetGroupsResult",
					"type": "structure",
					"members": {}
				}
			},
			"AttachLoadBalancers": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"LoadBalancerNames"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LoadBalancerNames": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "AttachLoadBalancersResult",
					"type": "structure",
					"members": {}
				}
			},
			"BatchDeleteScheduledAction": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ScheduledActionNames"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledActionNames": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"resultWrapper": "BatchDeleteScheduledActionResult",
					"type": "structure",
					"members": {
						"FailedScheduledActions": {
							"shape": "Sg"
						}
					}
				}
			},
			"BatchPutScheduledUpdateGroupAction": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ScheduledUpdateGroupActions"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledUpdateGroupActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ScheduledActionName"
								],
								"members": {
									"ScheduledActionName": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"Recurrence": {},
									"MinSize": {
										"type": "integer"
									},
									"MaxSize": {
										"type": "integer"
									},
									"DesiredCapacity": {
										"type": "integer"
									}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "BatchPutScheduledUpdateGroupActionResult",
					"type": "structure",
					"members": {
						"FailedScheduledUpdateGroupActions": {
							"shape": "Sg"
						}
					}
				}
			},
			"CompleteLifecycleAction": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName",
						"LifecycleActionResult"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {},
						"LifecycleActionToken": {},
						"LifecycleActionResult": {},
						"InstanceId": {}
					}
				},
				"output": {
					"resultWrapper": "CompleteLifecycleActionResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"MinSize",
						"MaxSize"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LaunchConfigurationName": {},
						"LaunchTemplate": {
							"shape": "Sy"
						},
						"MixedInstancesPolicy": {
							"shape": "S10"
						},
						"InstanceId": {},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						},
						"DesiredCapacity": {
							"type": "integer"
						},
						"DefaultCooldown": {
							"type": "integer"
						},
						"AvailabilityZones": {
							"shape": "S1a"
						},
						"LoadBalancerNames": {
							"shape": "Sa"
						},
						"TargetGroupARNs": {
							"shape": "S6"
						},
						"HealthCheckType": {},
						"HealthCheckGracePeriod": {
							"type": "integer"
						},
						"PlacementGroup": {},
						"VPCZoneIdentifier": {},
						"TerminationPolicies": {
							"shape": "S1e"
						},
						"NewInstancesProtectedFromScaleIn": {
							"type": "boolean"
						},
						"LifecycleHookSpecificationList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"LifecycleHookName",
									"LifecycleTransition"
								],
								"members": {
									"LifecycleHookName": {},
									"LifecycleTransition": {},
									"NotificationMetadata": {},
									"HeartbeatTimeout": {
										"type": "integer"
									},
									"DefaultResult": {},
									"NotificationTargetARN": {},
									"RoleARN": {}
								}
							}
						},
						"Tags": {
							"shape": "S1n"
						},
						"ServiceLinkedRoleARN": {}
					}
				}
			},
			"CreateLaunchConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchConfigurationName"
					],
					"members": {
						"LaunchConfigurationName": {},
						"ImageId": {},
						"KeyName": {},
						"SecurityGroups": {
							"shape": "S1t"
						},
						"ClassicLinkVPCId": {},
						"ClassicLinkVPCSecurityGroups": {
							"shape": "S1u"
						},
						"UserData": {},
						"InstanceId": {},
						"InstanceType": {},
						"KernelId": {},
						"RamdiskId": {},
						"BlockDeviceMappings": {
							"shape": "S1w"
						},
						"InstanceMonitoring": {
							"shape": "S25"
						},
						"SpotPrice": {},
						"IamInstanceProfile": {},
						"EbsOptimized": {
							"type": "boolean"
						},
						"AssociatePublicIpAddress": {
							"type": "boolean"
						},
						"PlacementTenancy": {}
					}
				}
			},
			"CreateOrUpdateTags": {
				"input": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S1n"
						}
					}
				}
			},
			"DeleteAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ForceDelete": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteLaunchConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchConfigurationName"
					],
					"members": {
						"LaunchConfigurationName": {}
					}
				}
			},
			"DeleteLifecycleHook": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLifecycleHookResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteNotificationConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TopicARN"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TopicARN": {}
					}
				}
			},
			"DeletePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"PolicyName": {}
					}
				}
			},
			"DeleteScheduledAction": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ScheduledActionName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledActionName": {}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S1n"
						}
					}
				}
			},
			"DescribeAccountLimits": {
				"output": {
					"resultWrapper": "DescribeAccountLimitsResult",
					"type": "structure",
					"members": {
						"MaxNumberOfAutoScalingGroups": {
							"type": "integer"
						},
						"MaxNumberOfLaunchConfigurations": {
							"type": "integer"
						},
						"NumberOfAutoScalingGroups": {
							"type": "integer"
						},
						"NumberOfLaunchConfigurations": {
							"type": "integer"
						}
					}
				}
			},
			"DescribeAdjustmentTypes": {
				"output": {
					"resultWrapper": "DescribeAdjustmentTypesResult",
					"type": "structure",
					"members": {
						"AdjustmentTypes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AdjustmentType": {}
								}
							}
						}
					}
				}
			},
			"DescribeAutoScalingGroups": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupNames": {
							"shape": "S2t"
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeAutoScalingGroupsResult",
					"type": "structure",
					"required": [
						"AutoScalingGroups"
					],
					"members": {
						"AutoScalingGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"AutoScalingGroupName",
									"MinSize",
									"MaxSize",
									"DesiredCapacity",
									"DefaultCooldown",
									"AvailabilityZones",
									"HealthCheckType",
									"CreatedTime"
								],
								"members": {
									"AutoScalingGroupName": {},
									"AutoScalingGroupARN": {},
									"LaunchConfigurationName": {},
									"LaunchTemplate": {
										"shape": "Sy"
									},
									"MixedInstancesPolicy": {
										"shape": "S10"
									},
									"MinSize": {
										"type": "integer"
									},
									"MaxSize": {
										"type": "integer"
									},
									"DesiredCapacity": {
										"type": "integer"
									},
									"DefaultCooldown": {
										"type": "integer"
									},
									"AvailabilityZones": {
										"shape": "S1a"
									},
									"LoadBalancerNames": {
										"shape": "Sa"
									},
									"TargetGroupARNs": {
										"shape": "S6"
									},
									"HealthCheckType": {},
									"HealthCheckGracePeriod": {
										"type": "integer"
									},
									"Instances": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"InstanceId",
												"AvailabilityZone",
												"LifecycleState",
												"HealthStatus",
												"ProtectedFromScaleIn"
											],
											"members": {
												"InstanceId": {},
												"AvailabilityZone": {},
												"LifecycleState": {},
												"HealthStatus": {},
												"LaunchConfigurationName": {},
												"LaunchTemplate": {
													"shape": "Sy"
												},
												"ProtectedFromScaleIn": {
													"type": "boolean"
												}
											}
										}
									},
									"CreatedTime": {
										"type": "timestamp"
									},
									"SuspendedProcesses": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"ProcessName": {},
												"SuspensionReason": {}
											}
										}
									},
									"PlacementGroup": {},
									"VPCZoneIdentifier": {},
									"EnabledMetrics": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Metric": {},
												"Granularity": {}
											}
										}
									},
									"Status": {},
									"Tags": {
										"shape": "S35"
									},
									"TerminationPolicies": {
										"shape": "S1e"
									},
									"NewInstancesProtectedFromScaleIn": {
										"type": "boolean"
									},
									"ServiceLinkedRoleARN": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAutoScalingInstances": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAutoScalingInstancesResult",
					"type": "structure",
					"members": {
						"AutoScalingInstances": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"InstanceId",
									"AutoScalingGroupName",
									"AvailabilityZone",
									"LifecycleState",
									"HealthStatus",
									"ProtectedFromScaleIn"
								],
								"members": {
									"InstanceId": {},
									"AutoScalingGroupName": {},
									"AvailabilityZone": {},
									"LifecycleState": {},
									"HealthStatus": {},
									"LaunchConfigurationName": {},
									"LaunchTemplate": {
										"shape": "Sy"
									},
									"ProtectedFromScaleIn": {
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAutoScalingNotificationTypes": {
				"output": {
					"resultWrapper": "DescribeAutoScalingNotificationTypesResult",
					"type": "structure",
					"members": {
						"AutoScalingNotificationTypes": {
							"shape": "S3c"
						}
					}
				}
			},
			"DescribeLaunchConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"LaunchConfigurationNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLaunchConfigurationsResult",
					"type": "structure",
					"required": [
						"LaunchConfigurations"
					],
					"members": {
						"LaunchConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"LaunchConfigurationName",
									"ImageId",
									"InstanceType",
									"CreatedTime"
								],
								"members": {
									"LaunchConfigurationName": {},
									"LaunchConfigurationARN": {},
									"ImageId": {},
									"KeyName": {},
									"SecurityGroups": {
										"shape": "S1t"
									},
									"ClassicLinkVPCId": {},
									"ClassicLinkVPCSecurityGroups": {
										"shape": "S1u"
									},
									"UserData": {},
									"InstanceType": {},
									"KernelId": {},
									"RamdiskId": {},
									"BlockDeviceMappings": {
										"shape": "S1w"
									},
									"InstanceMonitoring": {
										"shape": "S25"
									},
									"SpotPrice": {},
									"IamInstanceProfile": {},
									"CreatedTime": {
										"type": "timestamp"
									},
									"EbsOptimized": {
										"type": "boolean"
									},
									"AssociatePublicIpAddress": {
										"type": "boolean"
									},
									"PlacementTenancy": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeLifecycleHookTypes": {
				"output": {
					"resultWrapper": "DescribeLifecycleHookTypesResult",
					"type": "structure",
					"members": {
						"LifecycleHookTypes": {
							"shape": "S3c"
						}
					}
				}
			},
			"DescribeLifecycleHooks": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LifecycleHookNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLifecycleHooksResult",
					"type": "structure",
					"members": {
						"LifecycleHooks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LifecycleHookName": {},
									"AutoScalingGroupName": {},
									"LifecycleTransition": {},
									"NotificationTargetARN": {},
									"RoleARN": {},
									"NotificationMetadata": {},
									"HeartbeatTimeout": {
										"type": "integer"
									},
									"GlobalTimeout": {
										"type": "integer"
									},
									"DefaultResult": {}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancerTargetGroups": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerTargetGroupsResult",
					"type": "structure",
					"members": {
						"LoadBalancerTargetGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerTargetGroupARN": {},
									"State": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeLoadBalancers": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancersResult",
					"type": "structure",
					"members": {
						"LoadBalancers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"State": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMetricCollectionTypes": {
				"output": {
					"resultWrapper": "DescribeMetricCollectionTypesResult",
					"type": "structure",
					"members": {
						"Metrics": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Metric": {}
								}
							}
						},
						"Granularities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Granularity": {}
								}
							}
						}
					}
				}
			},
			"DescribeNotificationConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupNames": {
							"shape": "S2t"
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeNotificationConfigurationsResult",
					"type": "structure",
					"required": [
						"NotificationConfigurations"
					],
					"members": {
						"NotificationConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutoScalingGroupName": {},
									"TopicARN": {},
									"NotificationType": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePolicies": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupName": {},
						"PolicyNames": {
							"type": "list",
							"member": {}
						},
						"PolicyTypes": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribePoliciesResult",
					"type": "structure",
					"members": {
						"ScalingPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutoScalingGroupName": {},
									"PolicyName": {},
									"PolicyARN": {},
									"PolicyType": {},
									"AdjustmentType": {},
									"MinAdjustmentStep": {
										"shape": "S4c"
									},
									"MinAdjustmentMagnitude": {
										"type": "integer"
									},
									"ScalingAdjustment": {
										"type": "integer"
									},
									"Cooldown": {
										"type": "integer"
									},
									"StepAdjustments": {
										"shape": "S4f"
									},
									"MetricAggregationType": {},
									"EstimatedInstanceWarmup": {
										"type": "integer"
									},
									"Alarms": {
										"shape": "S4j"
									},
									"TargetTrackingConfiguration": {
										"shape": "S4l"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingActivities": {
				"input": {
					"type": "structure",
					"members": {
						"ActivityIds": {
							"type": "list",
							"member": {}
						},
						"AutoScalingGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeScalingActivitiesResult",
					"type": "structure",
					"required": [
						"Activities"
					],
					"members": {
						"Activities": {
							"shape": "S51"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingProcessTypes": {
				"output": {
					"resultWrapper": "DescribeScalingProcessTypesResult",
					"type": "structure",
					"members": {
						"Processes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ProcessName"
								],
								"members": {
									"ProcessName": {}
								}
							}
						}
					}
				}
			},
			"DescribeScheduledActions": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledActionNames": {
							"shape": "Se"
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeScheduledActionsResult",
					"type": "structure",
					"members": {
						"ScheduledUpdateGroupActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutoScalingGroupName": {},
									"ScheduledActionName": {},
									"ScheduledActionARN": {},
									"Time": {
										"type": "timestamp"
									},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"Recurrence": {},
									"MinSize": {
										"type": "integer"
									},
									"MaxSize": {
										"type": "integer"
									},
									"DesiredCapacity": {
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S35"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeTerminationPolicyTypes": {
				"output": {
					"resultWrapper": "DescribeTerminationPolicyTypesResult",
					"type": "structure",
					"members": {
						"TerminationPolicyTypes": {
							"shape": "S1e"
						}
					}
				}
			},
			"DetachInstances": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ShouldDecrementDesiredCapacity"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {},
						"ShouldDecrementDesiredCapacity": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachInstancesResult",
					"type": "structure",
					"members": {
						"Activities": {
							"shape": "S51"
						}
					}
				}
			},
			"DetachLoadBalancerTargetGroups": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TargetGroupARNs"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TargetGroupARNs": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachLoadBalancerTargetGroupsResult",
					"type": "structure",
					"members": {}
				}
			},
			"DetachLoadBalancers": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"LoadBalancerNames"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LoadBalancerNames": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachLoadBalancersResult",
					"type": "structure",
					"members": {}
				}
			},
			"DisableMetricsCollection": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"Metrics": {
							"shape": "S5q"
						}
					}
				}
			},
			"EnableMetricsCollection": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"Granularity"
					],
					"members": {
						"AutoScalingGroupName": {},
						"Metrics": {
							"shape": "S5q"
						},
						"Granularity": {}
					}
				}
			},
			"EnterStandby": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ShouldDecrementDesiredCapacity"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {},
						"ShouldDecrementDesiredCapacity": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "EnterStandbyResult",
					"type": "structure",
					"members": {
						"Activities": {
							"shape": "S51"
						}
					}
				}
			},
			"ExecutePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"PolicyName": {},
						"HonorCooldown": {
							"type": "boolean"
						},
						"MetricValue": {
							"type": "double"
						},
						"BreachThreshold": {
							"type": "double"
						}
					}
				}
			},
			"ExitStandby": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "ExitStandbyResult",
					"type": "structure",
					"members": {
						"Activities": {
							"shape": "S51"
						}
					}
				}
			},
			"PutLifecycleHook": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {},
						"LifecycleTransition": {},
						"RoleARN": {},
						"NotificationTargetARN": {},
						"NotificationMetadata": {},
						"HeartbeatTimeout": {
							"type": "integer"
						},
						"DefaultResult": {}
					}
				},
				"output": {
					"resultWrapper": "PutLifecycleHookResult",
					"type": "structure",
					"members": {}
				}
			},
			"PutNotificationConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TopicARN",
						"NotificationTypes"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TopicARN": {},
						"NotificationTypes": {
							"shape": "S3c"
						}
					}
				}
			},
			"PutScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"PolicyName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"PolicyName": {},
						"PolicyType": {},
						"AdjustmentType": {},
						"MinAdjustmentStep": {
							"shape": "S4c"
						},
						"MinAdjustmentMagnitude": {
							"type": "integer"
						},
						"ScalingAdjustment": {
							"type": "integer"
						},
						"Cooldown": {
							"type": "integer"
						},
						"MetricAggregationType": {},
						"StepAdjustments": {
							"shape": "S4f"
						},
						"EstimatedInstanceWarmup": {
							"type": "integer"
						},
						"TargetTrackingConfiguration": {
							"shape": "S4l"
						}
					}
				},
				"output": {
					"resultWrapper": "PutScalingPolicyResult",
					"type": "structure",
					"members": {
						"PolicyARN": {},
						"Alarms": {
							"shape": "S4j"
						}
					}
				}
			},
			"PutScheduledUpdateGroupAction": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ScheduledActionName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledActionName": {},
						"Time": {
							"type": "timestamp"
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Recurrence": {},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						},
						"DesiredCapacity": {
							"type": "integer"
						}
					}
				}
			},
			"RecordLifecycleActionHeartbeat": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {},
						"LifecycleActionToken": {},
						"InstanceId": {}
					}
				},
				"output": {
					"resultWrapper": "RecordLifecycleActionHeartbeatResult",
					"type": "structure",
					"members": {}
				}
			},
			"ResumeProcesses": {
				"input": {
					"shape": "S66"
				}
			},
			"SetDesiredCapacity": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"DesiredCapacity"
					],
					"members": {
						"AutoScalingGroupName": {},
						"DesiredCapacity": {
							"type": "integer"
						},
						"HonorCooldown": {
							"type": "boolean"
						}
					}
				}
			},
			"SetInstanceHealth": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"HealthStatus"
					],
					"members": {
						"InstanceId": {},
						"HealthStatus": {},
						"ShouldRespectGracePeriod": {
							"type": "boolean"
						}
					}
				}
			},
			"SetInstanceProtection": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds",
						"AutoScalingGroupName",
						"ProtectedFromScaleIn"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {},
						"ProtectedFromScaleIn": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetInstanceProtectionResult",
					"type": "structure",
					"members": {}
				}
			},
			"SuspendProcesses": {
				"input": {
					"shape": "S66"
				}
			},
			"TerminateInstanceInAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"ShouldDecrementDesiredCapacity"
					],
					"members": {
						"InstanceId": {},
						"ShouldDecrementDesiredCapacity": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "TerminateInstanceInAutoScalingGroupResult",
					"type": "structure",
					"members": {
						"Activity": {
							"shape": "S52"
						}
					}
				}
			},
			"UpdateAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LaunchConfigurationName": {},
						"LaunchTemplate": {
							"shape": "Sy"
						},
						"MixedInstancesPolicy": {
							"shape": "S10"
						},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						},
						"DesiredCapacity": {
							"type": "integer"
						},
						"DefaultCooldown": {
							"type": "integer"
						},
						"AvailabilityZones": {
							"shape": "S1a"
						},
						"HealthCheckType": {},
						"HealthCheckGracePeriod": {
							"type": "integer"
						},
						"PlacementGroup": {},
						"VPCZoneIdentifier": {},
						"TerminationPolicies": {
							"shape": "S1e"
						},
						"NewInstancesProtectedFromScaleIn": {
							"type": "boolean"
						},
						"ServiceLinkedRoleARN": {}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S6": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Sg": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ScheduledActionName"
					],
					"members": {
						"ScheduledActionName": {},
						"ErrorCode": {},
						"ErrorMessage": {}
					}
				}
			},
			"Sy": {
				"type": "structure",
				"members": {
					"LaunchTemplateId": {},
					"LaunchTemplateName": {},
					"Version": {}
				}
			},
			"S10": {
				"type": "structure",
				"members": {
					"LaunchTemplate": {
						"type": "structure",
						"members": {
							"LaunchTemplateSpecification": {
								"shape": "Sy"
							},
							"Overrides": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"InstanceType": {}
									}
								}
							}
						}
					},
					"InstancesDistribution": {
						"type": "structure",
						"members": {
							"OnDemandAllocationStrategy": {},
							"OnDemandBaseCapacity": {
								"type": "integer"
							},
							"OnDemandPercentageAboveBaseCapacity": {
								"type": "integer"
							},
							"SpotAllocationStrategy": {},
							"SpotInstancePools": {
								"type": "integer"
							},
							"SpotMaxPrice": {}
						}
					}
				}
			},
			"S1a": {
				"type": "list",
				"member": {}
			},
			"S1e": {
				"type": "list",
				"member": {}
			},
			"S1n": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"ResourceId": {},
						"ResourceType": {},
						"Key": {},
						"Value": {},
						"PropagateAtLaunch": {
							"type": "boolean"
						}
					}
				}
			},
			"S1t": {
				"type": "list",
				"member": {}
			},
			"S1u": {
				"type": "list",
				"member": {}
			},
			"S1w": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"DeviceName"
					],
					"members": {
						"VirtualName": {},
						"DeviceName": {},
						"Ebs": {
							"type": "structure",
							"members": {
								"SnapshotId": {},
								"VolumeSize": {
									"type": "integer"
								},
								"VolumeType": {},
								"DeleteOnTermination": {
									"type": "boolean"
								},
								"Iops": {
									"type": "integer"
								},
								"Encrypted": {
									"type": "boolean"
								}
							}
						},
						"NoDevice": {
							"type": "boolean"
						}
					}
				}
			},
			"S25": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S2t": {
				"type": "list",
				"member": {}
			},
			"S35": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {},
						"Key": {},
						"Value": {},
						"PropagateAtLaunch": {
							"type": "boolean"
						}
					}
				}
			},
			"S3c": {
				"type": "list",
				"member": {}
			},
			"S4c": {
				"type": "integer",
				"deprecated": true
			},
			"S4f": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ScalingAdjustment"
					],
					"members": {
						"MetricIntervalLowerBound": {
							"type": "double"
						},
						"MetricIntervalUpperBound": {
							"type": "double"
						},
						"ScalingAdjustment": {
							"type": "integer"
						}
					}
				}
			},
			"S4j": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"AlarmName": {},
						"AlarmARN": {}
					}
				}
			},
			"S4l": {
				"type": "structure",
				"required": [
					"TargetValue"
				],
				"members": {
					"PredefinedMetricSpecification": {
						"type": "structure",
						"required": [
							"PredefinedMetricType"
						],
						"members": {
							"PredefinedMetricType": {},
							"ResourceLabel": {}
						}
					},
					"CustomizedMetricSpecification": {
						"type": "structure",
						"required": [
							"MetricName",
							"Namespace",
							"Statistic"
						],
						"members": {
							"MetricName": {},
							"Namespace": {},
							"Dimensions": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"Name",
										"Value"
									],
									"members": {
										"Name": {},
										"Value": {}
									}
								}
							},
							"Statistic": {},
							"Unit": {}
						}
					},
					"TargetValue": {
						"type": "double"
					},
					"DisableScaleIn": {
						"type": "boolean"
					}
				}
			},
			"S51": {
				"type": "list",
				"member": {
					"shape": "S52"
				}
			},
			"S52": {
				"type": "structure",
				"required": [
					"ActivityId",
					"AutoScalingGroupName",
					"Cause",
					"StartTime",
					"StatusCode"
				],
				"members": {
					"ActivityId": {},
					"AutoScalingGroupName": {},
					"Description": {},
					"Cause": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"StatusCode": {},
					"StatusMessage": {},
					"Progress": {
						"type": "integer"
					},
					"Details": {}
				}
			},
			"S5q": {
				"type": "list",
				"member": {}
			},
			"S66": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"ScalingProcesses": {
						"type": "list",
						"member": {}
					}
				}
			}
		}
	};

/***/ },
/* 1656 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeAutoScalingGroups": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "AutoScalingGroups"
			},
			"DescribeAutoScalingInstances": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "AutoScalingInstances"
			},
			"DescribeLaunchConfigurations": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "LaunchConfigurations"
			},
			"DescribeNotificationConfigurations": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "NotificationConfigurations"
			},
			"DescribePolicies": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "ScalingPolicies"
			},
			"DescribeScalingActivities": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "Activities"
			},
			"DescribeScheduledActions": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "ScheduledUpdateGroupActions"
			},
			"DescribeTags": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "Tags"
			}
		}
	};

/***/ },
/* 1657 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-10-25",
			"endpointPrefix": "ce",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "AWS Cost Explorer",
			"serviceFullName": "AWS Cost Explorer Service",
			"serviceId": "Cost Explorer",
			"signatureVersion": "v4",
			"signingName": "ce",
			"targetPrefix": "AWSInsightsIndexService",
			"uid": "ce-2017-10-25"
		},
		"operations": {
			"GetCostAndUsage": {
				"input": {
					"type": "structure",
					"required": [
						"TimePeriod"
					],
					"members": {
						"TimePeriod": {
							"shape": "S2"
						},
						"Granularity": {},
						"Filter": {
							"shape": "S5"
						},
						"Metrics": {
							"shape": "Sd"
						},
						"GroupBy": {
							"shape": "Sf"
						},
						"NextPageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextPageToken": {},
						"GroupDefinitions": {
							"shape": "Sf"
						},
						"ResultsByTime": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TimePeriod": {
										"shape": "S2"
									},
									"Total": {
										"shape": "Sn"
									},
									"Groups": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Keys": {
													"type": "list",
													"member": {}
												},
												"Metrics": {
													"shape": "Sn"
												}
											}
										}
									},
									"Estimated": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"GetCostForecast": {
				"input": {
					"type": "structure",
					"required": [
						"TimePeriod",
						"Metric",
						"Granularity"
					],
					"members": {
						"TimePeriod": {
							"shape": "S2"
						},
						"Metric": {},
						"Granularity": {},
						"Filter": {
							"shape": "S5"
						},
						"PredictionIntervalLevel": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Total": {
							"shape": "So"
						},
						"ForecastResultsByTime": {
							"shape": "S10"
						}
					}
				}
			},
			"GetDimensionValues": {
				"input": {
					"type": "structure",
					"required": [
						"TimePeriod",
						"Dimension"
					],
					"members": {
						"SearchString": {},
						"TimePeriod": {
							"shape": "S2"
						},
						"Dimension": {},
						"Context": {},
						"NextPageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DimensionValues",
						"ReturnSize",
						"TotalSize"
					],
					"members": {
						"DimensionValues": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Value": {},
									"Attributes": {
										"shape": "S19"
									}
								}
							}
						},
						"ReturnSize": {
							"type": "integer"
						},
						"TotalSize": {
							"type": "integer"
						},
						"NextPageToken": {}
					}
				}
			},
			"GetReservationCoverage": {
				"input": {
					"type": "structure",
					"required": [
						"TimePeriod"
					],
					"members": {
						"TimePeriod": {
							"shape": "S2"
						},
						"GroupBy": {
							"shape": "Sf"
						},
						"Granularity": {},
						"Filter": {
							"shape": "S5"
						},
						"Metrics": {
							"shape": "Sd"
						},
						"NextPageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"CoveragesByTime"
					],
					"members": {
						"CoveragesByTime": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TimePeriod": {
										"shape": "S2"
									},
									"Groups": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Attributes": {
													"shape": "S19"
												},
												"Coverage": {
													"shape": "S1j"
												}
											}
										}
									},
									"Total": {
										"shape": "S1j"
									}
								}
							}
						},
						"Total": {
							"shape": "S1j"
						},
						"NextPageToken": {}
					}
				}
			},
			"GetReservationPurchaseRecommendation": {
				"input": {
					"type": "structure",
					"required": [
						"Service"
					],
					"members": {
						"AccountId": {},
						"Service": {},
						"AccountScope": {},
						"LookbackPeriodInDays": {},
						"TermInYears": {},
						"PaymentOption": {},
						"ServiceSpecification": {
							"shape": "S21"
						},
						"PageSize": {
							"type": "integer"
						},
						"NextPageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Metadata": {
							"type": "structure",
							"members": {
								"RecommendationId": {},
								"GenerationTimestamp": {}
							}
						},
						"Recommendations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AccountScope": {},
									"LookbackPeriodInDays": {},
									"TermInYears": {},
									"PaymentOption": {},
									"ServiceSpecification": {
										"shape": "S21"
									},
									"RecommendationDetails": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"AccountId": {},
												"InstanceDetails": {
													"type": "structure",
													"members": {
														"EC2InstanceDetails": {
															"type": "structure",
															"members": {
																"Family": {},
																"InstanceType": {},
																"Region": {},
																"AvailabilityZone": {},
																"Platform": {},
																"Tenancy": {},
																"CurrentGeneration": {
																	"type": "boolean"
																},
																"SizeFlexEligible": {
																	"type": "boolean"
																}
															}
														},
														"RDSInstanceDetails": {
															"type": "structure",
															"members": {
																"Family": {},
																"InstanceType": {},
																"Region": {},
																"DatabaseEngine": {},
																"DatabaseEdition": {},
																"DeploymentOption": {},
																"LicenseModel": {},
																"CurrentGeneration": {
																	"type": "boolean"
																},
																"SizeFlexEligible": {
																	"type": "boolean"
																}
															}
														},
														"RedshiftInstanceDetails": {
															"type": "structure",
															"members": {
																"Family": {},
																"NodeType": {},
																"Region": {},
																"CurrentGeneration": {
																	"type": "boolean"
																},
																"SizeFlexEligible": {
																	"type": "boolean"
																}
															}
														},
														"ElastiCacheInstanceDetails": {
															"type": "structure",
															"members": {
																"Family": {},
																"NodeType": {},
																"Region": {},
																"ProductDescription": {},
																"CurrentGeneration": {
																	"type": "boolean"
																},
																"SizeFlexEligible": {
																	"type": "boolean"
																}
															}
														},
														"ESInstanceDetails": {
															"type": "structure",
															"members": {
																"InstanceClass": {},
																"InstanceSize": {},
																"Region": {},
																"CurrentGeneration": {
																	"type": "boolean"
																},
																"SizeFlexEligible": {
																	"type": "boolean"
																}
															}
														}
													}
												},
												"RecommendedNumberOfInstancesToPurchase": {},
												"RecommendedNormalizedUnitsToPurchase": {},
												"MinimumNumberOfInstancesUsedPerHour": {},
												"MinimumNormalizedUnitsUsedPerHour": {},
												"MaximumNumberOfInstancesUsedPerHour": {},
												"MaximumNormalizedUnitsUsedPerHour": {},
												"AverageNumberOfInstancesUsedPerHour": {},
												"AverageNormalizedUnitsUsedPerHour": {},
												"AverageUtilization": {},
												"EstimatedBreakEvenInMonths": {},
												"CurrencyCode": {},
												"EstimatedMonthlySavingsAmount": {},
												"EstimatedMonthlySavingsPercentage": {},
												"EstimatedMonthlyOnDemandCost": {},
												"EstimatedReservationCostForLookbackPeriod": {},
												"UpfrontCost": {},
												"RecurringStandardMonthlyCost": {}
											}
										}
									},
									"RecommendationSummary": {
										"type": "structure",
										"members": {
											"TotalEstimatedMonthlySavingsAmount": {},
											"TotalEstimatedMonthlySavingsPercentage": {},
											"CurrencyCode": {}
										}
									}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"GetReservationUtilization": {
				"input": {
					"type": "structure",
					"required": [
						"TimePeriod"
					],
					"members": {
						"TimePeriod": {
							"shape": "S2"
						},
						"GroupBy": {
							"shape": "Sf"
						},
						"Granularity": {},
						"Filter": {
							"shape": "S5"
						},
						"NextPageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"UtilizationsByTime"
					],
					"members": {
						"UtilizationsByTime": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TimePeriod": {
										"shape": "S2"
									},
									"Groups": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Key": {},
												"Value": {},
												"Attributes": {
													"shape": "S19"
												},
												"Utilization": {
													"shape": "S2r"
												}
											}
										}
									},
									"Total": {
										"shape": "S2r"
									}
								}
							}
						},
						"Total": {
							"shape": "S2r"
						},
						"NextPageToken": {}
					}
				}
			},
			"GetRightsizingRecommendation": {
				"input": {
					"type": "structure",
					"required": [
						"Service"
					],
					"members": {
						"Filter": {
							"shape": "S5"
						},
						"Service": {},
						"PageSize": {
							"type": "integer"
						},
						"NextPageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Metadata": {
							"type": "structure",
							"members": {
								"RecommendationId": {},
								"GenerationTimestamp": {},
								"LookbackPeriodInDays": {}
							}
						},
						"Summary": {
							"type": "structure",
							"members": {
								"TotalRecommendationCount": {},
								"EstimatedTotalMonthlySavingsAmount": {},
								"SavingsCurrencyCode": {},
								"SavingsPercentage": {}
							}
						},
						"RightsizingRecommendations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AccountId": {},
									"CurrentInstance": {
										"type": "structure",
										"members": {
											"ResourceId": {},
											"Tags": {
												"type": "list",
												"member": {
													"shape": "Sb"
												}
											},
											"ResourceDetails": {
												"shape": "S3e"
											},
											"ResourceUtilization": {
												"shape": "S3g"
											},
											"ReservationCoveredHoursInLookbackPeriod": {},
											"OnDemandHoursInLookbackPeriod": {},
											"TotalRunningHoursInLookbackPeriod": {},
											"MonthlyCost": {},
											"CurrencyCode": {}
										}
									},
									"RightsizingType": {},
									"ModifyRecommendationDetail": {
										"type": "structure",
										"members": {
											"TargetInstances": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"EstimatedMonthlyCost": {},
														"EstimatedMonthlySavings": {},
														"CurrencyCode": {},
														"DefaultTargetInstance": {
															"type": "boolean"
														},
														"ResourceDetails": {
															"shape": "S3e"
														},
														"ExpectedResourceUtilization": {
															"shape": "S3g"
														}
													}
												}
											}
										}
									},
									"TerminateRecommendationDetail": {
										"type": "structure",
										"members": {
											"EstimatedMonthlySavings": {},
											"CurrencyCode": {}
										}
									}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"GetTags": {
				"input": {
					"type": "structure",
					"required": [
						"TimePeriod"
					],
					"members": {
						"SearchString": {},
						"TimePeriod": {
							"shape": "S2"
						},
						"TagKey": {},
						"NextPageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags",
						"ReturnSize",
						"TotalSize"
					],
					"members": {
						"NextPageToken": {},
						"Tags": {
							"type": "list",
							"member": {}
						},
						"ReturnSize": {
							"type": "integer"
						},
						"TotalSize": {
							"type": "integer"
						}
					}
				}
			},
			"GetUsageForecast": {
				"input": {
					"type": "structure",
					"required": [
						"TimePeriod",
						"Metric",
						"Granularity"
					],
					"members": {
						"TimePeriod": {
							"shape": "S2"
						},
						"Metric": {},
						"Granularity": {},
						"Filter": {
							"shape": "S5"
						},
						"PredictionIntervalLevel": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Total": {
							"shape": "So"
						},
						"ForecastResultsByTime": {
							"shape": "S10"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"Start",
					"End"
				],
				"members": {
					"Start": {},
					"End": {}
				}
			},
			"S5": {
				"type": "structure",
				"members": {
					"Or": {
						"shape": "S6"
					},
					"And": {
						"shape": "S6"
					},
					"Not": {
						"shape": "S5"
					},
					"Dimensions": {
						"type": "structure",
						"members": {
							"Key": {},
							"Values": {
								"shape": "S9"
							}
						}
					},
					"Tags": {
						"shape": "Sb"
					}
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"shape": "S5"
				}
			},
			"S9": {
				"type": "list",
				"member": {}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"Key": {},
					"Values": {
						"shape": "S9"
					}
				}
			},
			"Sd": {
				"type": "list",
				"member": {}
			},
			"Sf": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Type": {},
						"Key": {}
					}
				}
			},
			"Sn": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "So"
				}
			},
			"So": {
				"type": "structure",
				"members": {
					"Amount": {},
					"Unit": {}
				}
			},
			"S10": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"TimePeriod": {
							"shape": "S2"
						},
						"MeanValue": {},
						"PredictionIntervalLowerBound": {},
						"PredictionIntervalUpperBound": {}
					}
				}
			},
			"S19": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"CoverageHours": {
						"type": "structure",
						"members": {
							"OnDemandHours": {},
							"ReservedHours": {},
							"TotalRunningHours": {},
							"CoverageHoursPercentage": {}
						}
					},
					"CoverageNormalizedUnits": {
						"type": "structure",
						"members": {
							"OnDemandNormalizedUnits": {},
							"ReservedNormalizedUnits": {},
							"TotalRunningNormalizedUnits": {},
							"CoverageNormalizedUnitsPercentage": {}
						}
					},
					"CoverageCost": {
						"type": "structure",
						"members": {
							"OnDemandCost": {}
						}
					}
				}
			},
			"S21": {
				"type": "structure",
				"members": {
					"EC2Specification": {
						"type": "structure",
						"members": {
							"OfferingClass": {}
						}
					}
				}
			},
			"S2r": {
				"type": "structure",
				"members": {
					"UtilizationPercentage": {},
					"UtilizationPercentageInUnits": {},
					"PurchasedHours": {},
					"PurchasedUnits": {},
					"TotalActualHours": {},
					"TotalActualUnits": {},
					"UnusedHours": {},
					"UnusedUnits": {},
					"OnDemandCostOfRIHoursUsed": {},
					"NetRISavings": {},
					"TotalPotentialRISavings": {},
					"AmortizedUpfrontFee": {},
					"AmortizedRecurringFee": {},
					"TotalAmortizedFee": {}
				}
			},
			"S3e": {
				"type": "structure",
				"members": {
					"EC2ResourceDetails": {
						"type": "structure",
						"members": {
							"HourlyOnDemandRate": {},
							"InstanceType": {},
							"Platform": {},
							"Region": {},
							"Sku": {},
							"Memory": {},
							"NetworkPerformance": {},
							"Storage": {},
							"Vcpu": {}
						}
					}
				}
			},
			"S3g": {
				"type": "structure",
				"members": {
					"EC2ResourceUtilization": {
						"type": "structure",
						"members": {
							"MaxCpuUtilizationPercentage": {},
							"MaxMemoryUtilizationPercentage": {},
							"MaxStorageUtilizationPercentage": {}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1658 */
1641,
/* 1659 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-05-15",
			"endpointPrefix": "cloudformation",
			"protocol": "query",
			"serviceFullName": "AWS CloudFormation",
			"serviceId": "CloudFormation",
			"signatureVersion": "v4",
			"uid": "cloudformation-2010-05-15",
			"xmlNamespace": "http://cloudformation.amazonaws.com/doc/2010-05-15/"
		},
		"operations": {
			"CancelUpdateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"ClientRequestToken": {}
					}
				}
			},
			"ContinueUpdateRollback": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"RoleARN": {},
						"ResourcesToSkip": {
							"type": "list",
							"member": {}
						},
						"ClientRequestToken": {}
					}
				},
				"output": {
					"resultWrapper": "ContinueUpdateRollbackResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"StackName",
						"ChangeSetName"
					],
					"members": {
						"StackName": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"UsePreviousTemplate": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "Se"
						},
						"Capabilities": {
							"shape": "Sj"
						},
						"ResourceTypes": {
							"shape": "Sl"
						},
						"RoleARN": {},
						"RollbackConfiguration": {
							"shape": "Sn"
						},
						"NotificationARNs": {
							"shape": "St"
						},
						"Tags": {
							"shape": "Sv"
						},
						"ChangeSetName": {},
						"ClientToken": {},
						"Description": {},
						"ChangeSetType": {}
					}
				},
				"output": {
					"resultWrapper": "CreateChangeSetResult",
					"type": "structure",
					"members": {
						"Id": {},
						"StackId": {}
					}
				}
			},
			"CreateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"Parameters": {
							"shape": "Se"
						},
						"DisableRollback": {
							"type": "boolean"
						},
						"RollbackConfiguration": {
							"shape": "Sn"
						},
						"TimeoutInMinutes": {
							"type": "integer"
						},
						"NotificationARNs": {
							"shape": "St"
						},
						"Capabilities": {
							"shape": "Sj"
						},
						"ResourceTypes": {
							"shape": "Sl"
						},
						"RoleARN": {},
						"OnFailure": {},
						"StackPolicyBody": {},
						"StackPolicyURL": {},
						"Tags": {
							"shape": "Sv"
						},
						"ClientRequestToken": {},
						"EnableTerminationProtection": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateStackResult",
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"CreateStackInstances": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName",
						"Accounts",
						"Regions"
					],
					"members": {
						"StackSetName": {},
						"Accounts": {
							"shape": "S1g"
						},
						"Regions": {
							"shape": "S1i"
						},
						"ParameterOverrides": {
							"shape": "Se"
						},
						"OperationPreferences": {
							"shape": "S1k"
						},
						"OperationId": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"resultWrapper": "CreateStackInstancesResult",
					"type": "structure",
					"members": {
						"OperationId": {}
					}
				}
			},
			"CreateStackSet": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName"
					],
					"members": {
						"StackSetName": {},
						"Description": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"Parameters": {
							"shape": "Se"
						},
						"Capabilities": {
							"shape": "Sj"
						},
						"Tags": {
							"shape": "Sv"
						},
						"AdministrationRoleARN": {},
						"ExecutionRoleName": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"resultWrapper": "CreateStackSetResult",
					"type": "structure",
					"members": {
						"StackSetId": {}
					}
				}
			},
			"DeleteChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeSetName"
					],
					"members": {
						"ChangeSetName": {},
						"StackName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteChangeSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"RetainResources": {
							"type": "list",
							"member": {}
						},
						"RoleARN": {},
						"ClientRequestToken": {}
					}
				}
			},
			"DeleteStackInstances": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName",
						"Accounts",
						"Regions",
						"RetainStacks"
					],
					"members": {
						"StackSetName": {},
						"Accounts": {
							"shape": "S1g"
						},
						"Regions": {
							"shape": "S1i"
						},
						"OperationPreferences": {
							"shape": "S1k"
						},
						"RetainStacks": {
							"type": "boolean"
						},
						"OperationId": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteStackInstancesResult",
					"type": "structure",
					"members": {
						"OperationId": {}
					}
				}
			},
			"DeleteStackSet": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName"
					],
					"members": {
						"StackSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteStackSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DescribeAccountLimits": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAccountLimitsResult",
					"type": "structure",
					"members": {
						"AccountLimits": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Value": {
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeSetName"
					],
					"members": {
						"ChangeSetName": {},
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeChangeSetResult",
					"type": "structure",
					"members": {
						"ChangeSetName": {},
						"ChangeSetId": {},
						"StackId": {},
						"StackName": {},
						"Description": {},
						"Parameters": {
							"shape": "Se"
						},
						"CreationTime": {
							"type": "timestamp"
						},
						"ExecutionStatus": {},
						"Status": {},
						"StatusReason": {},
						"NotificationARNs": {
							"shape": "St"
						},
						"RollbackConfiguration": {
							"shape": "Sn"
						},
						"Capabilities": {
							"shape": "Sj"
						},
						"Tags": {
							"shape": "Sv"
						},
						"Changes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"ResourceChange": {
										"type": "structure",
										"members": {
											"Action": {},
											"LogicalResourceId": {},
											"PhysicalResourceId": {},
											"ResourceType": {},
											"Replacement": {},
											"Scope": {
												"type": "list",
												"member": {}
											},
											"Details": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"Target": {
															"type": "structure",
															"members": {
																"Attribute": {},
																"Name": {},
																"RequiresRecreation": {}
															}
														},
														"Evaluation": {},
														"ChangeSource": {},
														"CausingEntity": {}
													}
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeStackDriftDetectionStatus": {
				"input": {
					"type": "structure",
					"required": [
						"StackDriftDetectionId"
					],
					"members": {
						"StackDriftDetectionId": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackDriftDetectionStatusResult",
					"type": "structure",
					"required": [
						"StackId",
						"StackDriftDetectionId",
						"DetectionStatus",
						"Timestamp"
					],
					"members": {
						"StackId": {},
						"StackDriftDetectionId": {},
						"StackDriftStatus": {},
						"DetectionStatus": {},
						"DetectionStatusReason": {},
						"DriftedStackResourceCount": {
							"type": "integer"
						},
						"Timestamp": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeStackEvents": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackEventsResult",
					"type": "structure",
					"members": {
						"StackEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"StackId",
									"EventId",
									"StackName",
									"Timestamp"
								],
								"members": {
									"StackId": {},
									"EventId": {},
									"StackName": {},
									"LogicalResourceId": {},
									"PhysicalResourceId": {},
									"ResourceType": {},
									"Timestamp": {
										"type": "timestamp"
									},
									"ResourceStatus": {},
									"ResourceStatusReason": {},
									"ResourceProperties": {},
									"ClientRequestToken": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeStackInstance": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName",
						"StackInstanceAccount",
						"StackInstanceRegion"
					],
					"members": {
						"StackSetName": {},
						"StackInstanceAccount": {},
						"StackInstanceRegion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackInstanceResult",
					"type": "structure",
					"members": {
						"StackInstance": {
							"type": "structure",
							"members": {
								"StackSetId": {},
								"Region": {},
								"Account": {},
								"StackId": {},
								"ParameterOverrides": {
									"shape": "Se"
								},
								"Status": {},
								"StatusReason": {}
							}
						}
					}
				}
			},
			"DescribeStackResource": {
				"input": {
					"type": "structure",
					"required": [
						"StackName",
						"LogicalResourceId"
					],
					"members": {
						"StackName": {},
						"LogicalResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackResourceResult",
					"type": "structure",
					"members": {
						"StackResourceDetail": {
							"type": "structure",
							"required": [
								"LogicalResourceId",
								"ResourceType",
								"LastUpdatedTimestamp",
								"ResourceStatus"
							],
							"members": {
								"StackName": {},
								"StackId": {},
								"LogicalResourceId": {},
								"PhysicalResourceId": {},
								"ResourceType": {},
								"LastUpdatedTimestamp": {
									"type": "timestamp"
								},
								"ResourceStatus": {},
								"ResourceStatusReason": {},
								"Description": {},
								"Metadata": {},
								"DriftInformation": {
									"shape": "S3o"
								}
							}
						}
					}
				}
			},
			"DescribeStackResourceDrifts": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"StackResourceDriftStatusFilters": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackResourceDriftsResult",
					"type": "structure",
					"required": [
						"StackResourceDrifts"
					],
					"members": {
						"StackResourceDrifts": {
							"type": "list",
							"member": {
								"shape": "S3v"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeStackResources": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"LogicalResourceId": {},
						"PhysicalResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackResourcesResult",
					"type": "structure",
					"members": {
						"StackResources": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"LogicalResourceId",
									"ResourceType",
									"Timestamp",
									"ResourceStatus"
								],
								"members": {
									"StackName": {},
									"StackId": {},
									"LogicalResourceId": {},
									"PhysicalResourceId": {},
									"ResourceType": {},
									"Timestamp": {
										"type": "timestamp"
									},
									"ResourceStatus": {},
									"ResourceStatusReason": {},
									"Description": {},
									"DriftInformation": {
										"shape": "S3o"
									}
								}
							}
						}
					}
				}
			},
			"DescribeStackSet": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName"
					],
					"members": {
						"StackSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackSetResult",
					"type": "structure",
					"members": {
						"StackSet": {
							"type": "structure",
							"members": {
								"StackSetName": {},
								"StackSetId": {},
								"Description": {},
								"Status": {},
								"TemplateBody": {},
								"Parameters": {
									"shape": "Se"
								},
								"Capabilities": {
									"shape": "Sj"
								},
								"Tags": {
									"shape": "Sv"
								},
								"StackSetARN": {},
								"AdministrationRoleARN": {},
								"ExecutionRoleName": {}
							}
						}
					}
				}
			},
			"DescribeStackSetOperation": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName",
						"OperationId"
					],
					"members": {
						"StackSetName": {},
						"OperationId": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackSetOperationResult",
					"type": "structure",
					"members": {
						"StackSetOperation": {
							"type": "structure",
							"members": {
								"OperationId": {},
								"StackSetId": {},
								"Action": {},
								"Status": {},
								"OperationPreferences": {
									"shape": "S1k"
								},
								"RetainStacks": {
									"type": "boolean"
								},
								"AdministrationRoleARN": {},
								"ExecutionRoleName": {},
								"CreationTimestamp": {
									"type": "timestamp"
								},
								"EndTimestamp": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"DescribeStacks": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStacksResult",
					"type": "structure",
					"members": {
						"Stacks": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"StackName",
									"CreationTime",
									"StackStatus"
								],
								"members": {
									"StackId": {},
									"StackName": {},
									"ChangeSetId": {},
									"Description": {},
									"Parameters": {
										"shape": "Se"
									},
									"CreationTime": {
										"type": "timestamp"
									},
									"DeletionTime": {
										"type": "timestamp"
									},
									"LastUpdatedTime": {
										"type": "timestamp"
									},
									"RollbackConfiguration": {
										"shape": "Sn"
									},
									"StackStatus": {},
									"StackStatusReason": {},
									"DisableRollback": {
										"type": "boolean"
									},
									"NotificationARNs": {
										"shape": "St"
									},
									"TimeoutInMinutes": {
										"type": "integer"
									},
									"Capabilities": {
										"shape": "Sj"
									},
									"Outputs": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"OutputKey": {},
												"OutputValue": {},
												"Description": {},
												"ExportName": {}
											}
										}
									},
									"RoleARN": {},
									"Tags": {
										"shape": "Sv"
									},
									"EnableTerminationProtection": {
										"type": "boolean"
									},
									"ParentId": {},
									"RootId": {},
									"DriftInformation": {
										"type": "structure",
										"required": [
											"StackDriftStatus"
										],
										"members": {
											"StackDriftStatus": {},
											"LastCheckTimestamp": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DetectStackDrift": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"LogicalResourceIds": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DetectStackDriftResult",
					"type": "structure",
					"required": [
						"StackDriftDetectionId"
					],
					"members": {
						"StackDriftDetectionId": {}
					}
				}
			},
			"DetectStackResourceDrift": {
				"input": {
					"type": "structure",
					"required": [
						"StackName",
						"LogicalResourceId"
					],
					"members": {
						"StackName": {},
						"LogicalResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "DetectStackResourceDriftResult",
					"type": "structure",
					"required": [
						"StackResourceDrift"
					],
					"members": {
						"StackResourceDrift": {
							"shape": "S3v"
						}
					}
				}
			},
			"EstimateTemplateCost": {
				"input": {
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"TemplateURL": {},
						"Parameters": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"resultWrapper": "EstimateTemplateCostResult",
					"type": "structure",
					"members": {
						"Url": {}
					}
				}
			},
			"ExecuteChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeSetName"
					],
					"members": {
						"ChangeSetName": {},
						"StackName": {},
						"ClientRequestToken": {}
					}
				},
				"output": {
					"resultWrapper": "ExecuteChangeSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"GetStackPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {}
					}
				},
				"output": {
					"resultWrapper": "GetStackPolicyResult",
					"type": "structure",
					"members": {
						"StackPolicyBody": {}
					}
				}
			},
			"GetTemplate": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"ChangeSetName": {},
						"TemplateStage": {}
					}
				},
				"output": {
					"resultWrapper": "GetTemplateResult",
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"StagesAvailable": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetTemplateSummary": {
				"input": {
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"TemplateURL": {},
						"StackName": {},
						"StackSetName": {}
					}
				},
				"output": {
					"resultWrapper": "GetTemplateSummaryResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ParameterKey": {},
									"DefaultValue": {},
									"ParameterType": {},
									"NoEcho": {
										"type": "boolean"
									},
									"Description": {},
									"ParameterConstraints": {
										"type": "structure",
										"members": {
											"AllowedValues": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						},
						"Description": {},
						"Capabilities": {
							"shape": "Sj"
						},
						"CapabilitiesReason": {},
						"ResourceTypes": {
							"shape": "Sl"
						},
						"Version": {},
						"Metadata": {},
						"DeclaredTransforms": {
							"shape": "S5r"
						}
					}
				}
			},
			"ListChangeSets": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListChangeSetsResult",
					"type": "structure",
					"members": {
						"Summaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackId": {},
									"StackName": {},
									"ChangeSetId": {},
									"ChangeSetName": {},
									"ExecutionStatus": {},
									"Status": {},
									"StatusReason": {},
									"CreationTime": {
										"type": "timestamp"
									},
									"Description": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListExports": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListExportsResult",
					"type": "structure",
					"members": {
						"Exports": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ExportingStackId": {},
									"Name": {},
									"Value": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListImports": {
				"input": {
					"type": "structure",
					"required": [
						"ExportName"
					],
					"members": {
						"ExportName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListImportsResult",
					"type": "structure",
					"members": {
						"Imports": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"ListStackInstances": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName"
					],
					"members": {
						"StackSetName": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"StackInstanceAccount": {},
						"StackInstanceRegion": {}
					}
				},
				"output": {
					"resultWrapper": "ListStackInstancesResult",
					"type": "structure",
					"members": {
						"Summaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackSetId": {},
									"Region": {},
									"Account": {},
									"StackId": {},
									"Status": {},
									"StatusReason": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStackResources": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListStackResourcesResult",
					"type": "structure",
					"members": {
						"StackResourceSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"LogicalResourceId",
									"ResourceType",
									"LastUpdatedTimestamp",
									"ResourceStatus"
								],
								"members": {
									"LogicalResourceId": {},
									"PhysicalResourceId": {},
									"ResourceType": {},
									"LastUpdatedTimestamp": {
										"type": "timestamp"
									},
									"ResourceStatus": {},
									"ResourceStatusReason": {},
									"DriftInformation": {
										"type": "structure",
										"required": [
											"StackResourceDriftStatus"
										],
										"members": {
											"StackResourceDriftStatus": {},
											"LastCheckTimestamp": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStackSetOperationResults": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName",
						"OperationId"
					],
					"members": {
						"StackSetName": {},
						"OperationId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListStackSetOperationResultsResult",
					"type": "structure",
					"members": {
						"Summaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Account": {},
									"Region": {},
									"Status": {},
									"StatusReason": {},
									"AccountGateResult": {
										"type": "structure",
										"members": {
											"Status": {},
											"StatusReason": {}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStackSetOperations": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName"
					],
					"members": {
						"StackSetName": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListStackSetOperationsResult",
					"type": "structure",
					"members": {
						"Summaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"OperationId": {},
									"Action": {},
									"Status": {},
									"CreationTimestamp": {
										"type": "timestamp"
									},
									"EndTimestamp": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStackSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Status": {}
					}
				},
				"output": {
					"resultWrapper": "ListStackSetsResult",
					"type": "structure",
					"members": {
						"Summaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackSetName": {},
									"StackSetId": {},
									"Description": {},
									"Status": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStacks": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"StackStatusFilter": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "ListStacksResult",
					"type": "structure",
					"members": {
						"StackSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"StackName",
									"CreationTime",
									"StackStatus"
								],
								"members": {
									"StackId": {},
									"StackName": {},
									"TemplateDescription": {},
									"CreationTime": {
										"type": "timestamp"
									},
									"LastUpdatedTime": {
										"type": "timestamp"
									},
									"DeletionTime": {
										"type": "timestamp"
									},
									"StackStatus": {},
									"StackStatusReason": {},
									"ParentId": {},
									"RootId": {},
									"DriftInformation": {
										"type": "structure",
										"required": [
											"StackDriftStatus"
										],
										"members": {
											"StackDriftStatus": {},
											"LastCheckTimestamp": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"SetStackPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"StackPolicyBody": {},
						"StackPolicyURL": {}
					}
				}
			},
			"SignalResource": {
				"input": {
					"type": "structure",
					"required": [
						"StackName",
						"LogicalResourceId",
						"UniqueId",
						"Status"
					],
					"members": {
						"StackName": {},
						"LogicalResourceId": {},
						"UniqueId": {},
						"Status": {}
					}
				}
			},
			"StopStackSetOperation": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName",
						"OperationId"
					],
					"members": {
						"StackSetName": {},
						"OperationId": {}
					}
				},
				"output": {
					"resultWrapper": "StopStackSetOperationResult",
					"type": "structure",
					"members": {}
				}
			},
			"UpdateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"UsePreviousTemplate": {
							"type": "boolean"
						},
						"StackPolicyDuringUpdateBody": {},
						"StackPolicyDuringUpdateURL": {},
						"Parameters": {
							"shape": "Se"
						},
						"Capabilities": {
							"shape": "Sj"
						},
						"ResourceTypes": {
							"shape": "Sl"
						},
						"RoleARN": {},
						"RollbackConfiguration": {
							"shape": "Sn"
						},
						"StackPolicyBody": {},
						"StackPolicyURL": {},
						"NotificationARNs": {
							"shape": "St"
						},
						"Tags": {
							"shape": "Sv"
						},
						"ClientRequestToken": {}
					}
				},
				"output": {
					"resultWrapper": "UpdateStackResult",
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"UpdateStackInstances": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName",
						"Accounts",
						"Regions"
					],
					"members": {
						"StackSetName": {},
						"Accounts": {
							"shape": "S1g"
						},
						"Regions": {
							"shape": "S1i"
						},
						"ParameterOverrides": {
							"shape": "Se"
						},
						"OperationPreferences": {
							"shape": "S1k"
						},
						"OperationId": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateStackInstancesResult",
					"type": "structure",
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateStackSet": {
				"input": {
					"type": "structure",
					"required": [
						"StackSetName"
					],
					"members": {
						"StackSetName": {},
						"Description": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"UsePreviousTemplate": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "Se"
						},
						"Capabilities": {
							"shape": "Sj"
						},
						"Tags": {
							"shape": "Sv"
						},
						"OperationPreferences": {
							"shape": "S1k"
						},
						"AdministrationRoleARN": {},
						"ExecutionRoleName": {},
						"OperationId": {
							"idempotencyToken": true
						},
						"Accounts": {
							"shape": "S1g"
						},
						"Regions": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateStackSetResult",
					"type": "structure",
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateTerminationProtection": {
				"input": {
					"type": "structure",
					"required": [
						"EnableTerminationProtection",
						"StackName"
					],
					"members": {
						"EnableTerminationProtection": {
							"type": "boolean"
						},
						"StackName": {}
					}
				},
				"output": {
					"resultWrapper": "UpdateTerminationProtectionResult",
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"ValidateTemplate": {
				"input": {
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"TemplateURL": {}
					}
				},
				"output": {
					"resultWrapper": "ValidateTemplateResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ParameterKey": {},
									"DefaultValue": {},
									"NoEcho": {
										"type": "boolean"
									},
									"Description": {}
								}
							}
						},
						"Description": {},
						"Capabilities": {
							"shape": "Sj"
						},
						"CapabilitiesReason": {},
						"DeclaredTransforms": {
							"shape": "S5r"
						}
					}
				}
			}
		},
		"shapes": {
			"Se": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ParameterKey": {},
						"ParameterValue": {},
						"UsePreviousValue": {
							"type": "boolean"
						},
						"ResolvedValue": {}
					}
				}
			},
			"Sj": {
				"type": "list",
				"member": {}
			},
			"Sl": {
				"type": "list",
				"member": {}
			},
			"Sn": {
				"type": "structure",
				"members": {
					"RollbackTriggers": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Arn",
								"Type"
							],
							"members": {
								"Arn": {},
								"Type": {}
							}
						}
					},
					"MonitoringTimeInMinutes": {
						"type": "integer"
					}
				}
			},
			"St": {
				"type": "list",
				"member": {}
			},
			"Sv": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1g": {
				"type": "list",
				"member": {}
			},
			"S1i": {
				"type": "list",
				"member": {}
			},
			"S1k": {
				"type": "structure",
				"members": {
					"RegionOrder": {
						"shape": "S1i"
					},
					"FailureToleranceCount": {
						"type": "integer"
					},
					"FailureTolerancePercentage": {
						"type": "integer"
					},
					"MaxConcurrentCount": {
						"type": "integer"
					},
					"MaxConcurrentPercentage": {
						"type": "integer"
					}
				}
			},
			"S3o": {
				"type": "structure",
				"required": [
					"StackResourceDriftStatus"
				],
				"members": {
					"StackResourceDriftStatus": {},
					"LastCheckTimestamp": {
						"type": "timestamp"
					}
				}
			},
			"S3v": {
				"type": "structure",
				"required": [
					"StackId",
					"LogicalResourceId",
					"ResourceType",
					"StackResourceDriftStatus",
					"Timestamp"
				],
				"members": {
					"StackId": {},
					"LogicalResourceId": {},
					"PhysicalResourceId": {},
					"PhysicalResourceIdContext": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Key",
								"Value"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					},
					"ResourceType": {},
					"ExpectedProperties": {},
					"ActualProperties": {},
					"PropertyDifferences": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"PropertyPath",
								"ExpectedValue",
								"ActualValue",
								"DifferenceType"
							],
							"members": {
								"PropertyPath": {},
								"ExpectedValue": {},
								"ActualValue": {},
								"DifferenceType": {}
							}
						}
					},
					"StackResourceDriftStatus": {},
					"Timestamp": {
						"type": "timestamp"
					}
				}
			},
			"S5r": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1660 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeStackEvents": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "StackEvents"
			},
			"DescribeStackResourceDrifts": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"DescribeStackResources": {
				"result_key": "StackResources"
			},
			"DescribeStacks": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Stacks"
			},
			"ListExports": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Exports"
			},
			"ListImports": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Imports"
			},
			"ListStackResources": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "StackResourceSummaries"
			},
			"ListStacks": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "StackSummaries"
			}
		}
	};

/***/ },
/* 1661 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"StackExists": {
				"delay": 5,
				"operation": "DescribeStacks",
				"maxAttempts": 20,
				"acceptors": [
					{
						"matcher": "status",
						"expected": 200,
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "ValidationError",
						"state": "retry"
					}
				]
			},
			"StackCreateComplete": {
				"delay": 30,
				"operation": "DescribeStacks",
				"maxAttempts": 120,
				"description": "Wait until stack status is CREATE_COMPLETE.",
				"acceptors": [
					{
						"argument": "Stacks[].StackStatus",
						"expected": "CREATE_COMPLETE",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "CREATE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_COMPLETE",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "ROLLBACK_COMPLETE",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"expected": "ValidationError",
						"matcher": "error",
						"state": "failure"
					}
				]
			},
			"StackDeleteComplete": {
				"delay": 30,
				"operation": "DescribeStacks",
				"maxAttempts": 120,
				"description": "Wait until stack status is DELETE_COMPLETE.",
				"acceptors": [
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_COMPLETE",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"expected": "ValidationError",
						"matcher": "error",
						"state": "success"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "CREATE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_ROLLBACK_IN_PROGRESS",
						"matcher": "pathAny",
						"state": "failure"
					}
				]
			},
			"StackUpdateComplete": {
				"delay": 30,
				"maxAttempts": 120,
				"operation": "DescribeStacks",
				"description": "Wait until stack status is UPDATE_COMPLETE.",
				"acceptors": [
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_COMPLETE",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"expected": "UPDATE_FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Stacks[].StackStatus"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"expected": "UPDATE_ROLLBACK_COMPLETE",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Stacks[].StackStatus"
					},
					{
						"expected": "ValidationError",
						"matcher": "error",
						"state": "failure"
					}
				]
			},
			"ChangeSetCreateComplete": {
				"delay": 30,
				"operation": "DescribeChangeSet",
				"maxAttempts": 120,
				"description": "Wait until change set status is CREATE_COMPLETE.",
				"acceptors": [
					{
						"argument": "Status",
						"expected": "CREATE_COMPLETE",
						"matcher": "path",
						"state": "success"
					},
					{
						"argument": "Status",
						"expected": "FAILED",
						"matcher": "path",
						"state": "failure"
					},
					{
						"expected": "ValidationError",
						"matcher": "error",
						"state": "failure"
					}
				]
			}
		}
	};

/***/ },
/* 1662 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-11-25",
			"endpointPrefix": "cloudfront",
			"globalEndpoint": "cloudfront.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "CloudFront",
			"serviceFullName": "Amazon CloudFront",
			"serviceId": "CloudFront",
			"signatureVersion": "v4",
			"uid": "cloudfront-2016-11-25"
		},
		"operations": {
			"CreateCloudFrontOriginAccessIdentity": {
				"http": {
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"CreateDistribution": {
				"http": {
					"requestUri": "/2016-11-25/distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateDistributionWithTags": {
				"http": {
					"requestUri": "/2016-11-25/distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfigWithTags"
					],
					"members": {
						"DistributionConfigWithTags": {
							"locationName": "DistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							},
							"type": "structure",
							"required": [
								"DistributionConfig",
								"Tags"
							],
							"members": {
								"DistributionConfig": {
									"shape": "S7"
								},
								"Tags": {
									"shape": "S21"
								}
							}
						}
					},
					"payload": "DistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateInvalidation": {
				"http": {
					"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"InvalidationBatch"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"InvalidationBatch": {
							"shape": "S28",
							"locationName": "InvalidationBatch",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "InvalidationBatch"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"Invalidation": {
							"shape": "S2c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"CreateStreamingDistribution": {
				"http": {
					"requestUri": "/2016-11-25/streaming-distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"CreateStreamingDistributionWithTags": {
				"http": {
					"requestUri": "/2016-11-25/streaming-distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfigWithTags"
					],
					"members": {
						"StreamingDistributionConfigWithTags": {
							"locationName": "StreamingDistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							},
							"type": "structure",
							"required": [
								"StreamingDistributionConfig",
								"Tags"
							],
							"members": {
								"StreamingDistributionConfig": {
									"shape": "S2e"
								},
								"Tags": {
									"shape": "S21"
								}
							}
						}
					},
					"payload": "StreamingDistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"DeleteCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2016-11-25/distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteStreamingDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"GetCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"GetCloudFrontOriginAccessIdentityConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				}
			},
			"GetDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"GetDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionConfig": {
							"shape": "S7"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "DistributionConfig"
				}
			},
			"GetInvalidation": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"Id"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Invalidation": {
							"shape": "S2c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"GetStreamingDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"GetStreamingDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistributionConfig"
				}
			},
			"ListCloudFrontOriginAccessIdentities": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "CloudFrontOriginAccessIdentitySummary",
										"type": "structure",
										"required": [
											"Id",
											"S3CanonicalUserId",
											"Comment"
										],
										"members": {
											"Id": {},
											"S3CanonicalUserId": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityList"
				}
			},
			"ListDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S3a"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListDistributionsByWebACLId": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distributionsByWebACLId/{WebACLId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						},
						"WebACLId": {
							"location": "uri",
							"locationName": "WebACLId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S3a"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListInvalidations": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidationList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "InvalidationSummary",
										"type": "structure",
										"required": [
											"Id",
											"CreateTime",
											"Status"
										],
										"members": {
											"Id": {},
											"CreateTime": {
												"type": "timestamp"
											},
											"Status": {}
										}
									}
								}
							}
						}
					},
					"payload": "InvalidationList"
				}
			},
			"ListStreamingDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/streaming-distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "StreamingDistributionSummary",
										"type": "structure",
										"required": [
											"Id",
											"ARN",
											"Status",
											"LastModifiedTime",
											"DomainName",
											"S3Origin",
											"Aliases",
											"TrustedSigners",
											"Comment",
											"PriceClass",
											"Enabled"
										],
										"members": {
											"Id": {},
											"ARN": {},
											"Status": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"DomainName": {},
											"S3Origin": {
												"shape": "S2f"
											},
											"Aliases": {
												"shape": "S8"
											},
											"TrustedSigners": {
												"shape": "Sy"
											},
											"Comment": {},
											"PriceClass": {},
											"Enabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"payload": "StreamingDistributionList"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S21"
						}
					},
					"payload": "Tags"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2016-11-25/tagging?Operation=Tag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"Tags": {
							"shape": "S21",
							"locationName": "Tags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "Tags"
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/2016-11-25/tagging?Operation=Untag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"TagKeys": {
							"locationName": "TagKeys",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							},
							"type": "structure",
							"members": {
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Key"
									}
								}
							}
						}
					},
					"payload": "TagKeys"
				}
			},
			"UpdateCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "PUT",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig",
						"Id"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"UpdateDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2016-11-25/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig",
						"Id"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"UpdateStreamingDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig",
						"Id"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Comment"
				],
				"members": {
					"CallerReference": {},
					"Comment": {}
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"Id",
					"S3CanonicalUserId"
				],
				"members": {
					"Id": {},
					"S3CanonicalUserId": {},
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					}
				}
			},
			"S7": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Origins",
					"DefaultCacheBehavior",
					"Comment",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"Aliases": {
						"shape": "S8"
					},
					"DefaultRootObject": {},
					"Origins": {
						"shape": "Sb"
					},
					"DefaultCacheBehavior": {
						"shape": "Sn"
					},
					"CacheBehaviors": {
						"shape": "S1a"
					},
					"CustomErrorResponses": {
						"shape": "S1d"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"IncludeCookies",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"IncludeCookies": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					},
					"ViewerCertificate": {
						"shape": "S1i"
					},
					"Restrictions": {
						"shape": "S1m"
					},
					"WebACLId": {},
					"HttpVersion": {},
					"IsIPV6Enabled": {
						"type": "boolean"
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CNAME"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Origin",
							"type": "structure",
							"required": [
								"Id",
								"DomainName"
							],
							"members": {
								"Id": {},
								"DomainName": {},
								"OriginPath": {},
								"CustomHeaders": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginCustomHeader",
												"type": "structure",
												"required": [
													"HeaderName",
													"HeaderValue"
												],
												"members": {
													"HeaderName": {},
													"HeaderValue": {}
												}
											}
										}
									}
								},
								"S3OriginConfig": {
									"type": "structure",
									"required": [
										"OriginAccessIdentity"
									],
									"members": {
										"OriginAccessIdentity": {}
									}
								},
								"CustomOriginConfig": {
									"type": "structure",
									"required": [
										"HTTPPort",
										"HTTPSPort",
										"OriginProtocolPolicy"
									],
									"members": {
										"HTTPPort": {
											"type": "integer"
										},
										"HTTPSPort": {
											"type": "integer"
										},
										"OriginProtocolPolicy": {},
										"OriginSslProtocols": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "SslProtocol"
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"TargetOriginId",
					"ForwardedValues",
					"TrustedSigners",
					"ViewerProtocolPolicy",
					"MinTTL"
				],
				"members": {
					"TargetOriginId": {},
					"ForwardedValues": {
						"shape": "So"
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"ViewerProtocolPolicy": {},
					"MinTTL": {
						"type": "long"
					},
					"AllowedMethods": {
						"shape": "S12"
					},
					"SmoothStreaming": {
						"type": "boolean"
					},
					"DefaultTTL": {
						"type": "long"
					},
					"MaxTTL": {
						"type": "long"
					},
					"Compress": {
						"type": "boolean"
					},
					"LambdaFunctionAssociations": {
						"shape": "S16"
					}
				}
			},
			"So": {
				"type": "structure",
				"required": [
					"QueryString",
					"Cookies"
				],
				"members": {
					"QueryString": {
						"type": "boolean"
					},
					"Cookies": {
						"type": "structure",
						"required": [
							"Forward"
						],
						"members": {
							"Forward": {},
							"WhitelistedNames": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "Name"
										}
									}
								}
							}
						}
					},
					"Headers": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					},
					"QueryStringCacheKeys": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "AwsAccountNumber"
						}
					}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"shape": "S13"
					},
					"CachedMethods": {
						"type": "structure",
						"required": [
							"Quantity",
							"Items"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"shape": "S13"
							}
						}
					}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"locationName": "Method"
				}
			},
			"S16": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "LambdaFunctionAssociation",
							"type": "structure",
							"members": {
								"LambdaFunctionARN": {},
								"EventType": {}
							}
						}
					}
				}
			},
			"S1a": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CacheBehavior",
							"type": "structure",
							"required": [
								"PathPattern",
								"TargetOriginId",
								"ForwardedValues",
								"TrustedSigners",
								"ViewerProtocolPolicy",
								"MinTTL"
							],
							"members": {
								"PathPattern": {},
								"TargetOriginId": {},
								"ForwardedValues": {
									"shape": "So"
								},
								"TrustedSigners": {
									"shape": "Sy"
								},
								"ViewerProtocolPolicy": {},
								"MinTTL": {
									"type": "long"
								},
								"AllowedMethods": {
									"shape": "S12"
								},
								"SmoothStreaming": {
									"type": "boolean"
								},
								"DefaultTTL": {
									"type": "long"
								},
								"MaxTTL": {
									"type": "long"
								},
								"Compress": {
									"type": "boolean"
								},
								"LambdaFunctionAssociations": {
									"shape": "S16"
								}
							}
						}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CustomErrorResponse",
							"type": "structure",
							"required": [
								"ErrorCode"
							],
							"members": {
								"ErrorCode": {
									"type": "integer"
								},
								"ResponsePagePath": {},
								"ResponseCode": {},
								"ErrorCachingMinTTL": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"CloudFrontDefaultCertificate": {
						"type": "boolean"
					},
					"IAMCertificateId": {},
					"ACMCertificateArn": {},
					"SSLSupportMethod": {},
					"MinimumProtocolVersion": {},
					"Certificate": {
						"deprecated": true
					},
					"CertificateSource": {
						"deprecated": true
					}
				}
			},
			"S1m": {
				"type": "structure",
				"required": [
					"GeoRestriction"
				],
				"members": {
					"GeoRestriction": {
						"type": "structure",
						"required": [
							"RestrictionType",
							"Quantity"
						],
						"members": {
							"RestrictionType": {},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Location"
								}
							}
						}
					}
				}
			},
			"S1s": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"LastModifiedTime",
					"InProgressInvalidationBatches",
					"DomainName",
					"ActiveTrustedSigners",
					"DistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"InProgressInvalidationBatches": {
						"type": "integer"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1u"
					},
					"DistributionConfig": {
						"shape": "S7"
					}
				}
			},
			"S1u": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Signer",
							"type": "structure",
							"members": {
								"AwsAccountNumber": {},
								"KeyPairIds": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "KeyPairId"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S21": {
				"type": "structure",
				"members": {
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Tag",
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S28": {
				"type": "structure",
				"required": [
					"Paths",
					"CallerReference"
				],
				"members": {
					"Paths": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Path"
								}
							}
						}
					},
					"CallerReference": {}
				}
			},
			"S2c": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"CreateTime",
					"InvalidationBatch"
				],
				"members": {
					"Id": {},
					"Status": {},
					"CreateTime": {
						"type": "timestamp"
					},
					"InvalidationBatch": {
						"shape": "S28"
					}
				}
			},
			"S2e": {
				"type": "structure",
				"required": [
					"CallerReference",
					"S3Origin",
					"Comment",
					"TrustedSigners",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"S3Origin": {
						"shape": "S2f"
					},
					"Aliases": {
						"shape": "S8"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S2f": {
				"type": "structure",
				"required": [
					"DomainName",
					"OriginAccessIdentity"
				],
				"members": {
					"DomainName": {},
					"OriginAccessIdentity": {}
				}
			},
			"S2i": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"DomainName",
					"ActiveTrustedSigners",
					"StreamingDistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1u"
					},
					"StreamingDistributionConfig": {
						"shape": "S2e"
					}
				}
			},
			"S3a": {
				"type": "structure",
				"required": [
					"Marker",
					"MaxItems",
					"IsTruncated",
					"Quantity"
				],
				"members": {
					"Marker": {},
					"NextMarker": {},
					"MaxItems": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "DistributionSummary",
							"type": "structure",
							"required": [
								"Id",
								"ARN",
								"Status",
								"LastModifiedTime",
								"DomainName",
								"Aliases",
								"Origins",
								"DefaultCacheBehavior",
								"CacheBehaviors",
								"CustomErrorResponses",
								"Comment",
								"PriceClass",
								"Enabled",
								"ViewerCertificate",
								"Restrictions",
								"WebACLId",
								"HttpVersion",
								"IsIPV6Enabled"
							],
							"members": {
								"Id": {},
								"ARN": {},
								"Status": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"DomainName": {},
								"Aliases": {
									"shape": "S8"
								},
								"Origins": {
									"shape": "Sb"
								},
								"DefaultCacheBehavior": {
									"shape": "Sn"
								},
								"CacheBehaviors": {
									"shape": "S1a"
								},
								"CustomErrorResponses": {
									"shape": "S1d"
								},
								"Comment": {},
								"PriceClass": {},
								"Enabled": {
									"type": "boolean"
								},
								"ViewerCertificate": {
									"shape": "S1i"
								},
								"Restrictions": {
									"shape": "S1m"
								},
								"WebACLId": {},
								"HttpVersion": {},
								"IsIPV6Enabled": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1663 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCloudFrontOriginAccessIdentities": {
				"input_token": "Marker",
				"output_token": "CloudFrontOriginAccessIdentityList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "CloudFrontOriginAccessIdentityList.IsTruncated",
				"result_key": "CloudFrontOriginAccessIdentityList.Items"
			},
			"ListDistributions": {
				"input_token": "Marker",
				"output_token": "DistributionList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "DistributionList.IsTruncated",
				"result_key": "DistributionList.Items"
			},
			"ListInvalidations": {
				"input_token": "Marker",
				"output_token": "InvalidationList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "InvalidationList.IsTruncated",
				"result_key": "InvalidationList.Items"
			},
			"ListStreamingDistributions": {
				"input_token": "Marker",
				"output_token": "StreamingDistributionList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "StreamingDistributionList.IsTruncated",
				"result_key": "StreamingDistributionList.Items"
			}
		}
	};

/***/ },
/* 1664 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DistributionDeployed": {
				"delay": 60,
				"operation": "GetDistribution",
				"maxAttempts": 25,
				"description": "Wait until a distribution is deployed.",
				"acceptors": [
					{
						"expected": "Deployed",
						"matcher": "path",
						"state": "success",
						"argument": "Distribution.Status"
					}
				]
			},
			"InvalidationCompleted": {
				"delay": 20,
				"operation": "GetInvalidation",
				"maxAttempts": 30,
				"description": "Wait until an invalidation has completed.",
				"acceptors": [
					{
						"expected": "Completed",
						"matcher": "path",
						"state": "success",
						"argument": "Invalidation.Status"
					}
				]
			},
			"StreamingDistributionDeployed": {
				"delay": 60,
				"operation": "GetStreamingDistribution",
				"maxAttempts": 25,
				"description": "Wait until a streaming distribution is deployed.",
				"acceptors": [
					{
						"expected": "Deployed",
						"matcher": "path",
						"state": "success",
						"argument": "StreamingDistribution.Status"
					}
				]
			}
		}
	};

/***/ },
/* 1665 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-03-25",
			"endpointPrefix": "cloudfront",
			"globalEndpoint": "cloudfront.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "CloudFront",
			"serviceFullName": "Amazon CloudFront",
			"serviceId": "CloudFront",
			"signatureVersion": "v4",
			"uid": "cloudfront-2017-03-25"
		},
		"operations": {
			"CreateCloudFrontOriginAccessIdentity": {
				"http": {
					"requestUri": "/2017-03-25/origin-access-identity/cloudfront",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"CreateDistribution": {
				"http": {
					"requestUri": "/2017-03-25/distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateDistributionWithTags": {
				"http": {
					"requestUri": "/2017-03-25/distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfigWithTags"
					],
					"members": {
						"DistributionConfigWithTags": {
							"locationName": "DistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							},
							"type": "structure",
							"required": [
								"DistributionConfig",
								"Tags"
							],
							"members": {
								"DistributionConfig": {
									"shape": "S7"
								},
								"Tags": {
									"shape": "S21"
								}
							}
						}
					},
					"payload": "DistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateInvalidation": {
				"http": {
					"requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"InvalidationBatch"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"InvalidationBatch": {
							"shape": "S28",
							"locationName": "InvalidationBatch",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						}
					},
					"payload": "InvalidationBatch"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"Invalidation": {
							"shape": "S2c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"CreateStreamingDistribution": {
				"http": {
					"requestUri": "/2017-03-25/streaming-distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"CreateStreamingDistributionWithTags": {
				"http": {
					"requestUri": "/2017-03-25/streaming-distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfigWithTags"
					],
					"members": {
						"StreamingDistributionConfigWithTags": {
							"locationName": "StreamingDistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							},
							"type": "structure",
							"required": [
								"StreamingDistributionConfig",
								"Tags"
							],
							"members": {
								"StreamingDistributionConfig": {
									"shape": "S2e"
								},
								"Tags": {
									"shape": "S21"
								}
							}
						}
					},
					"payload": "StreamingDistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"DeleteCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-03-25/distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteServiceLinkedRole": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-03-25/service-linked-role/{RoleName}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {
							"location": "uri",
							"locationName": "RoleName"
						}
					}
				}
			},
			"DeleteStreamingDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-03-25/streaming-distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"GetCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"GetCloudFrontOriginAccessIdentityConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				}
			},
			"GetDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"GetDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionConfig": {
							"shape": "S7"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "DistributionConfig"
				}
			},
			"GetInvalidation": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"Id"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Invalidation": {
							"shape": "S2c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"GetStreamingDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/streaming-distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"GetStreamingDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistributionConfig"
				}
			},
			"ListCloudFrontOriginAccessIdentities": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/origin-access-identity/cloudfront"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "CloudFrontOriginAccessIdentitySummary",
										"type": "structure",
										"required": [
											"Id",
											"S3CanonicalUserId",
											"Comment"
										],
										"members": {
											"Id": {},
											"S3CanonicalUserId": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityList"
				}
			},
			"ListDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S3b"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListDistributionsByWebACLId": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/distributionsByWebACLId/{WebACLId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						},
						"WebACLId": {
							"location": "uri",
							"locationName": "WebACLId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S3b"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListInvalidations": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/distribution/{DistributionId}/invalidation"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidationList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "InvalidationSummary",
										"type": "structure",
										"required": [
											"Id",
											"CreateTime",
											"Status"
										],
										"members": {
											"Id": {},
											"CreateTime": {
												"type": "timestamp"
											},
											"Status": {}
										}
									}
								}
							}
						}
					},
					"payload": "InvalidationList"
				}
			},
			"ListStreamingDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/streaming-distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "StreamingDistributionSummary",
										"type": "structure",
										"required": [
											"Id",
											"ARN",
											"Status",
											"LastModifiedTime",
											"DomainName",
											"S3Origin",
											"Aliases",
											"TrustedSigners",
											"Comment",
											"PriceClass",
											"Enabled"
										],
										"members": {
											"Id": {},
											"ARN": {},
											"Status": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"DomainName": {},
											"S3Origin": {
												"shape": "S2f"
											},
											"Aliases": {
												"shape": "S8"
											},
											"TrustedSigners": {
												"shape": "Sy"
											},
											"Comment": {},
											"PriceClass": {},
											"Enabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"payload": "StreamingDistributionList"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-25/tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S21"
						}
					},
					"payload": "Tags"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2017-03-25/tagging?Operation=Tag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"Tags": {
							"shape": "S21",
							"locationName": "Tags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						}
					},
					"payload": "Tags"
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/2017-03-25/tagging?Operation=Untag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"TagKeys": {
							"locationName": "TagKeys",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							},
							"type": "structure",
							"members": {
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Key"
									}
								}
							}
						}
					},
					"payload": "TagKeys"
				}
			},
			"UpdateCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-03-25/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig",
						"Id"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"UpdateDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-03-25/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig",
						"Id"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"UpdateStreamingDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-03-25/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig",
						"Id"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-03-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Comment"
				],
				"members": {
					"CallerReference": {},
					"Comment": {}
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"Id",
					"S3CanonicalUserId"
				],
				"members": {
					"Id": {},
					"S3CanonicalUserId": {},
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					}
				}
			},
			"S7": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Origins",
					"DefaultCacheBehavior",
					"Comment",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"Aliases": {
						"shape": "S8"
					},
					"DefaultRootObject": {},
					"Origins": {
						"shape": "Sb"
					},
					"DefaultCacheBehavior": {
						"shape": "Sn"
					},
					"CacheBehaviors": {
						"shape": "S1a"
					},
					"CustomErrorResponses": {
						"shape": "S1d"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"IncludeCookies",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"IncludeCookies": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					},
					"ViewerCertificate": {
						"shape": "S1i"
					},
					"Restrictions": {
						"shape": "S1m"
					},
					"WebACLId": {},
					"HttpVersion": {},
					"IsIPV6Enabled": {
						"type": "boolean"
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CNAME"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Origin",
							"type": "structure",
							"required": [
								"Id",
								"DomainName"
							],
							"members": {
								"Id": {},
								"DomainName": {},
								"OriginPath": {},
								"CustomHeaders": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginCustomHeader",
												"type": "structure",
												"required": [
													"HeaderName",
													"HeaderValue"
												],
												"members": {
													"HeaderName": {},
													"HeaderValue": {}
												}
											}
										}
									}
								},
								"S3OriginConfig": {
									"type": "structure",
									"required": [
										"OriginAccessIdentity"
									],
									"members": {
										"OriginAccessIdentity": {}
									}
								},
								"CustomOriginConfig": {
									"type": "structure",
									"required": [
										"HTTPPort",
										"HTTPSPort",
										"OriginProtocolPolicy"
									],
									"members": {
										"HTTPPort": {
											"type": "integer"
										},
										"HTTPSPort": {
											"type": "integer"
										},
										"OriginProtocolPolicy": {},
										"OriginSslProtocols": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "SslProtocol"
													}
												}
											}
										},
										"OriginReadTimeout": {
											"type": "integer"
										},
										"OriginKeepaliveTimeout": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"TargetOriginId",
					"ForwardedValues",
					"TrustedSigners",
					"ViewerProtocolPolicy",
					"MinTTL"
				],
				"members": {
					"TargetOriginId": {},
					"ForwardedValues": {
						"shape": "So"
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"ViewerProtocolPolicy": {},
					"MinTTL": {
						"type": "long"
					},
					"AllowedMethods": {
						"shape": "S12"
					},
					"SmoothStreaming": {
						"type": "boolean"
					},
					"DefaultTTL": {
						"type": "long"
					},
					"MaxTTL": {
						"type": "long"
					},
					"Compress": {
						"type": "boolean"
					},
					"LambdaFunctionAssociations": {
						"shape": "S16"
					}
				}
			},
			"So": {
				"type": "structure",
				"required": [
					"QueryString",
					"Cookies"
				],
				"members": {
					"QueryString": {
						"type": "boolean"
					},
					"Cookies": {
						"type": "structure",
						"required": [
							"Forward"
						],
						"members": {
							"Forward": {},
							"WhitelistedNames": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "Name"
										}
									}
								}
							}
						}
					},
					"Headers": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					},
					"QueryStringCacheKeys": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "AwsAccountNumber"
						}
					}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"shape": "S13"
					},
					"CachedMethods": {
						"type": "structure",
						"required": [
							"Quantity",
							"Items"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"shape": "S13"
							}
						}
					}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"locationName": "Method"
				}
			},
			"S16": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "LambdaFunctionAssociation",
							"type": "structure",
							"members": {
								"LambdaFunctionARN": {},
								"EventType": {}
							}
						}
					}
				}
			},
			"S1a": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CacheBehavior",
							"type": "structure",
							"required": [
								"PathPattern",
								"TargetOriginId",
								"ForwardedValues",
								"TrustedSigners",
								"ViewerProtocolPolicy",
								"MinTTL"
							],
							"members": {
								"PathPattern": {},
								"TargetOriginId": {},
								"ForwardedValues": {
									"shape": "So"
								},
								"TrustedSigners": {
									"shape": "Sy"
								},
								"ViewerProtocolPolicy": {},
								"MinTTL": {
									"type": "long"
								},
								"AllowedMethods": {
									"shape": "S12"
								},
								"SmoothStreaming": {
									"type": "boolean"
								},
								"DefaultTTL": {
									"type": "long"
								},
								"MaxTTL": {
									"type": "long"
								},
								"Compress": {
									"type": "boolean"
								},
								"LambdaFunctionAssociations": {
									"shape": "S16"
								}
							}
						}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CustomErrorResponse",
							"type": "structure",
							"required": [
								"ErrorCode"
							],
							"members": {
								"ErrorCode": {
									"type": "integer"
								},
								"ResponsePagePath": {},
								"ResponseCode": {},
								"ErrorCachingMinTTL": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"CloudFrontDefaultCertificate": {
						"type": "boolean"
					},
					"IAMCertificateId": {},
					"ACMCertificateArn": {},
					"SSLSupportMethod": {},
					"MinimumProtocolVersion": {},
					"Certificate": {
						"deprecated": true
					},
					"CertificateSource": {
						"deprecated": true
					}
				}
			},
			"S1m": {
				"type": "structure",
				"required": [
					"GeoRestriction"
				],
				"members": {
					"GeoRestriction": {
						"type": "structure",
						"required": [
							"RestrictionType",
							"Quantity"
						],
						"members": {
							"RestrictionType": {},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Location"
								}
							}
						}
					}
				}
			},
			"S1s": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"LastModifiedTime",
					"InProgressInvalidationBatches",
					"DomainName",
					"ActiveTrustedSigners",
					"DistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"InProgressInvalidationBatches": {
						"type": "integer"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1u"
					},
					"DistributionConfig": {
						"shape": "S7"
					}
				}
			},
			"S1u": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Signer",
							"type": "structure",
							"members": {
								"AwsAccountNumber": {},
								"KeyPairIds": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "KeyPairId"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S21": {
				"type": "structure",
				"members": {
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Tag",
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S28": {
				"type": "structure",
				"required": [
					"Paths",
					"CallerReference"
				],
				"members": {
					"Paths": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Path"
								}
							}
						}
					},
					"CallerReference": {}
				}
			},
			"S2c": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"CreateTime",
					"InvalidationBatch"
				],
				"members": {
					"Id": {},
					"Status": {},
					"CreateTime": {
						"type": "timestamp"
					},
					"InvalidationBatch": {
						"shape": "S28"
					}
				}
			},
			"S2e": {
				"type": "structure",
				"required": [
					"CallerReference",
					"S3Origin",
					"Comment",
					"TrustedSigners",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"S3Origin": {
						"shape": "S2f"
					},
					"Aliases": {
						"shape": "S8"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S2f": {
				"type": "structure",
				"required": [
					"DomainName",
					"OriginAccessIdentity"
				],
				"members": {
					"DomainName": {},
					"OriginAccessIdentity": {}
				}
			},
			"S2i": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"DomainName",
					"ActiveTrustedSigners",
					"StreamingDistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1u"
					},
					"StreamingDistributionConfig": {
						"shape": "S2e"
					}
				}
			},
			"S3b": {
				"type": "structure",
				"required": [
					"Marker",
					"MaxItems",
					"IsTruncated",
					"Quantity"
				],
				"members": {
					"Marker": {},
					"NextMarker": {},
					"MaxItems": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "DistributionSummary",
							"type": "structure",
							"required": [
								"Id",
								"ARN",
								"Status",
								"LastModifiedTime",
								"DomainName",
								"Aliases",
								"Origins",
								"DefaultCacheBehavior",
								"CacheBehaviors",
								"CustomErrorResponses",
								"Comment",
								"PriceClass",
								"Enabled",
								"ViewerCertificate",
								"Restrictions",
								"WebACLId",
								"HttpVersion",
								"IsIPV6Enabled"
							],
							"members": {
								"Id": {},
								"ARN": {},
								"Status": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"DomainName": {},
								"Aliases": {
									"shape": "S8"
								},
								"Origins": {
									"shape": "Sb"
								},
								"DefaultCacheBehavior": {
									"shape": "Sn"
								},
								"CacheBehaviors": {
									"shape": "S1a"
								},
								"CustomErrorResponses": {
									"shape": "S1d"
								},
								"Comment": {},
								"PriceClass": {},
								"Enabled": {
									"type": "boolean"
								},
								"ViewerCertificate": {
									"shape": "S1i"
								},
								"Restrictions": {
									"shape": "S1m"
								},
								"WebACLId": {},
								"HttpVersion": {},
								"IsIPV6Enabled": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1666 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCloudFrontOriginAccessIdentities": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "CloudFrontOriginAccessIdentityList.IsTruncated",
				"output_token": "CloudFrontOriginAccessIdentityList.NextMarker",
				"result_key": "CloudFrontOriginAccessIdentityList.Items"
			},
			"ListDistributions": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "DistributionList.IsTruncated",
				"output_token": "DistributionList.NextMarker",
				"result_key": "DistributionList.Items"
			},
			"ListInvalidations": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "InvalidationList.IsTruncated",
				"output_token": "InvalidationList.NextMarker",
				"result_key": "InvalidationList.Items"
			},
			"ListStreamingDistributions": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "StreamingDistributionList.IsTruncated",
				"output_token": "StreamingDistributionList.NextMarker",
				"result_key": "StreamingDistributionList.Items"
			}
		}
	};

/***/ },
/* 1667 */
1664,
/* 1668 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-10-30",
			"endpointPrefix": "cloudfront",
			"globalEndpoint": "cloudfront.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "CloudFront",
			"serviceFullName": "Amazon CloudFront",
			"serviceId": "CloudFront",
			"signatureVersion": "v4",
			"uid": "cloudfront-2017-10-30"
		},
		"operations": {
			"CreateCloudFrontOriginAccessIdentity": {
				"http": {
					"requestUri": "/2017-10-30/origin-access-identity/cloudfront",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"CreateDistribution": {
				"http": {
					"requestUri": "/2017-10-30/distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateDistributionWithTags": {
				"http": {
					"requestUri": "/2017-10-30/distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfigWithTags"
					],
					"members": {
						"DistributionConfigWithTags": {
							"locationName": "DistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							},
							"type": "structure",
							"required": [
								"DistributionConfig",
								"Tags"
							],
							"members": {
								"DistributionConfig": {
									"shape": "S7"
								},
								"Tags": {
									"shape": "S22"
								}
							}
						}
					},
					"payload": "DistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateFieldLevelEncryptionConfig": {
				"http": {
					"requestUri": "/2017-10-30/field-level-encryption",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S29",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2k"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"CreateFieldLevelEncryptionProfile": {
				"http": {
					"requestUri": "/2017-10-30/field-level-encryption-profile",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2m",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S2t"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"CreateInvalidation": {
				"http": {
					"requestUri": "/2017-10-30/distribution/{DistributionId}/invalidation",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"InvalidationBatch"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"InvalidationBatch": {
							"shape": "S2v",
							"locationName": "InvalidationBatch",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "InvalidationBatch"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"Invalidation": {
							"shape": "S2z"
						}
					},
					"payload": "Invalidation"
				}
			},
			"CreatePublicKey": {
				"http": {
					"requestUri": "/2017-10-30/public-key",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S31",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S33"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"CreateStreamingDistribution": {
				"http": {
					"requestUri": "/2017-10-30/streaming-distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S35",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"CreateStreamingDistributionWithTags": {
				"http": {
					"requestUri": "/2017-10-30/streaming-distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfigWithTags"
					],
					"members": {
						"StreamingDistributionConfigWithTags": {
							"locationName": "StreamingDistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							},
							"type": "structure",
							"required": [
								"StreamingDistributionConfig",
								"Tags"
							],
							"members": {
								"StreamingDistributionConfig": {
									"shape": "S35"
								},
								"Tags": {
									"shape": "S22"
								}
							}
						}
					},
					"payload": "StreamingDistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"DeleteCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-10-30/distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionConfig": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-10-30/field-level-encryption/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionProfile": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-10-30/field-level-encryption-profile/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeletePublicKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-10-30/public-key/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteStreamingDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-10-30/streaming-distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"GetCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"GetCloudFrontOriginAccessIdentityConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				}
			},
			"GetDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"GetDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionConfig": {
							"shape": "S7"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "DistributionConfig"
				}
			},
			"GetFieldLevelEncryption": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/field-level-encryption/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2k"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"GetFieldLevelEncryptionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S29"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				}
			},
			"GetFieldLevelEncryptionProfile": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/field-level-encryption-profile/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S2t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"GetFieldLevelEncryptionProfileConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2m"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				}
			},
			"GetInvalidation": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/distribution/{DistributionId}/invalidation/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"Id"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Invalidation": {
							"shape": "S2z"
						}
					},
					"payload": "Invalidation"
				}
			},
			"GetPublicKey": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/public-key/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S33"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"GetPublicKeyConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyConfig": {
							"shape": "S31"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKeyConfig"
				}
			},
			"GetStreamingDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/streaming-distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"GetStreamingDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S35"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistributionConfig"
				}
			},
			"ListCloudFrontOriginAccessIdentities": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/origin-access-identity/cloudfront"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "CloudFrontOriginAccessIdentitySummary",
										"type": "structure",
										"required": [
											"Id",
											"S3CanonicalUserId",
											"Comment"
										],
										"members": {
											"Id": {},
											"S3CanonicalUserId": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityList"
				}
			},
			"ListDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4g"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListDistributionsByWebACLId": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/distributionsByWebACLId/{WebACLId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						},
						"WebACLId": {
							"location": "uri",
							"locationName": "WebACLId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4g"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListFieldLevelEncryptionConfigs": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/field-level-encryption"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Comment": {},
											"QueryArgProfileConfig": {
												"shape": "S2a"
											},
											"ContentTypeProfileConfig": {
												"shape": "S2e"
											}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionList"
				}
			},
			"ListFieldLevelEncryptionProfiles": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/field-level-encryption-profile"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionProfileSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime",
											"Name",
											"EncryptionEntities"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Name": {},
											"EncryptionEntities": {
												"shape": "S2n"
											},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileList"
				}
			},
			"ListInvalidations": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/distribution/{DistributionId}/invalidation"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidationList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "InvalidationSummary",
										"type": "structure",
										"required": [
											"Id",
											"CreateTime",
											"Status"
										],
										"members": {
											"Id": {},
											"CreateTime": {
												"type": "timestamp"
											},
											"Status": {}
										}
									}
								}
							}
						}
					},
					"payload": "InvalidationList"
				}
			},
			"ListPublicKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/public-key"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "PublicKeySummary",
										"type": "structure",
										"required": [
											"Id",
											"Name",
											"CreatedTime",
											"EncodedKey"
										],
										"members": {
											"Id": {},
											"Name": {},
											"CreatedTime": {
												"type": "timestamp"
											},
											"EncodedKey": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "PublicKeyList"
				}
			},
			"ListStreamingDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/streaming-distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "StreamingDistributionSummary",
										"type": "structure",
										"required": [
											"Id",
											"ARN",
											"Status",
											"LastModifiedTime",
											"DomainName",
											"S3Origin",
											"Aliases",
											"TrustedSigners",
											"Comment",
											"PriceClass",
											"Enabled"
										],
										"members": {
											"Id": {},
											"ARN": {},
											"Status": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"DomainName": {},
											"S3Origin": {
												"shape": "S36"
											},
											"Aliases": {
												"shape": "S8"
											},
											"TrustedSigners": {
												"shape": "Sy"
											},
											"Comment": {},
											"PriceClass": {},
											"Enabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"payload": "StreamingDistributionList"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-10-30/tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S22"
						}
					},
					"payload": "Tags"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2017-10-30/tagging?Operation=Tag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"Tags": {
							"shape": "S22",
							"locationName": "Tags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						}
					},
					"payload": "Tags"
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/2017-10-30/tagging?Operation=Untag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"TagKeys": {
							"locationName": "TagKeys",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							},
							"type": "structure",
							"members": {
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Key"
									}
								}
							}
						}
					},
					"payload": "TagKeys"
				}
			},
			"UpdateCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-10-30/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig",
						"Id"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"UpdateDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-10-30/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig",
						"Id"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"UpdateFieldLevelEncryptionConfig": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-10-30/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S29",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2k"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"UpdateFieldLevelEncryptionProfile": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-10-30/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2m",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S2t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"UpdatePublicKey": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-10-30/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig",
						"Id"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S31",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S33"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"UpdateStreamingDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-10-30/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig",
						"Id"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S35",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2017-10-30/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Comment"
				],
				"members": {
					"CallerReference": {},
					"Comment": {}
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"Id",
					"S3CanonicalUserId"
				],
				"members": {
					"Id": {},
					"S3CanonicalUserId": {},
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					}
				}
			},
			"S7": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Origins",
					"DefaultCacheBehavior",
					"Comment",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"Aliases": {
						"shape": "S8"
					},
					"DefaultRootObject": {},
					"Origins": {
						"shape": "Sb"
					},
					"DefaultCacheBehavior": {
						"shape": "Sn"
					},
					"CacheBehaviors": {
						"shape": "S1b"
					},
					"CustomErrorResponses": {
						"shape": "S1e"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"IncludeCookies",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"IncludeCookies": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					},
					"ViewerCertificate": {
						"shape": "S1j"
					},
					"Restrictions": {
						"shape": "S1n"
					},
					"WebACLId": {},
					"HttpVersion": {},
					"IsIPV6Enabled": {
						"type": "boolean"
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CNAME"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Origin",
							"type": "structure",
							"required": [
								"Id",
								"DomainName"
							],
							"members": {
								"Id": {},
								"DomainName": {},
								"OriginPath": {},
								"CustomHeaders": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginCustomHeader",
												"type": "structure",
												"required": [
													"HeaderName",
													"HeaderValue"
												],
												"members": {
													"HeaderName": {},
													"HeaderValue": {}
												}
											}
										}
									}
								},
								"S3OriginConfig": {
									"type": "structure",
									"required": [
										"OriginAccessIdentity"
									],
									"members": {
										"OriginAccessIdentity": {}
									}
								},
								"CustomOriginConfig": {
									"type": "structure",
									"required": [
										"HTTPPort",
										"HTTPSPort",
										"OriginProtocolPolicy"
									],
									"members": {
										"HTTPPort": {
											"type": "integer"
										},
										"HTTPSPort": {
											"type": "integer"
										},
										"OriginProtocolPolicy": {},
										"OriginSslProtocols": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "SslProtocol"
													}
												}
											}
										},
										"OriginReadTimeout": {
											"type": "integer"
										},
										"OriginKeepaliveTimeout": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"TargetOriginId",
					"ForwardedValues",
					"TrustedSigners",
					"ViewerProtocolPolicy",
					"MinTTL"
				],
				"members": {
					"TargetOriginId": {},
					"ForwardedValues": {
						"shape": "So"
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"ViewerProtocolPolicy": {},
					"MinTTL": {
						"type": "long"
					},
					"AllowedMethods": {
						"shape": "S12"
					},
					"SmoothStreaming": {
						"type": "boolean"
					},
					"DefaultTTL": {
						"type": "long"
					},
					"MaxTTL": {
						"type": "long"
					},
					"Compress": {
						"type": "boolean"
					},
					"LambdaFunctionAssociations": {
						"shape": "S16"
					},
					"FieldLevelEncryptionId": {}
				}
			},
			"So": {
				"type": "structure",
				"required": [
					"QueryString",
					"Cookies"
				],
				"members": {
					"QueryString": {
						"type": "boolean"
					},
					"Cookies": {
						"type": "structure",
						"required": [
							"Forward"
						],
						"members": {
							"Forward": {},
							"WhitelistedNames": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "Name"
										}
									}
								}
							}
						}
					},
					"Headers": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					},
					"QueryStringCacheKeys": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "AwsAccountNumber"
						}
					}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"shape": "S13"
					},
					"CachedMethods": {
						"type": "structure",
						"required": [
							"Quantity",
							"Items"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"shape": "S13"
							}
						}
					}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"locationName": "Method"
				}
			},
			"S16": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "LambdaFunctionAssociation",
							"type": "structure",
							"required": [
								"LambdaFunctionARN",
								"EventType"
							],
							"members": {
								"LambdaFunctionARN": {},
								"EventType": {}
							}
						}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CacheBehavior",
							"type": "structure",
							"required": [
								"PathPattern",
								"TargetOriginId",
								"ForwardedValues",
								"TrustedSigners",
								"ViewerProtocolPolicy",
								"MinTTL"
							],
							"members": {
								"PathPattern": {},
								"TargetOriginId": {},
								"ForwardedValues": {
									"shape": "So"
								},
								"TrustedSigners": {
									"shape": "Sy"
								},
								"ViewerProtocolPolicy": {},
								"MinTTL": {
									"type": "long"
								},
								"AllowedMethods": {
									"shape": "S12"
								},
								"SmoothStreaming": {
									"type": "boolean"
								},
								"DefaultTTL": {
									"type": "long"
								},
								"MaxTTL": {
									"type": "long"
								},
								"Compress": {
									"type": "boolean"
								},
								"LambdaFunctionAssociations": {
									"shape": "S16"
								},
								"FieldLevelEncryptionId": {}
							}
						}
					}
				}
			},
			"S1e": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CustomErrorResponse",
							"type": "structure",
							"required": [
								"ErrorCode"
							],
							"members": {
								"ErrorCode": {
									"type": "integer"
								},
								"ResponsePagePath": {},
								"ResponseCode": {},
								"ErrorCachingMinTTL": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"CloudFrontDefaultCertificate": {
						"type": "boolean"
					},
					"IAMCertificateId": {},
					"ACMCertificateArn": {},
					"SSLSupportMethod": {},
					"MinimumProtocolVersion": {},
					"Certificate": {
						"deprecated": true
					},
					"CertificateSource": {
						"deprecated": true
					}
				}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"GeoRestriction"
				],
				"members": {
					"GeoRestriction": {
						"type": "structure",
						"required": [
							"RestrictionType",
							"Quantity"
						],
						"members": {
							"RestrictionType": {},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Location"
								}
							}
						}
					}
				}
			},
			"S1t": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"LastModifiedTime",
					"InProgressInvalidationBatches",
					"DomainName",
					"ActiveTrustedSigners",
					"DistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"InProgressInvalidationBatches": {
						"type": "integer"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1v"
					},
					"DistributionConfig": {
						"shape": "S7"
					}
				}
			},
			"S1v": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Signer",
							"type": "structure",
							"members": {
								"AwsAccountNumber": {},
								"KeyPairIds": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "KeyPairId"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S22": {
				"type": "structure",
				"members": {
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Tag",
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S29": {
				"type": "structure",
				"required": [
					"CallerReference"
				],
				"members": {
					"CallerReference": {},
					"Comment": {},
					"QueryArgProfileConfig": {
						"shape": "S2a"
					},
					"ContentTypeProfileConfig": {
						"shape": "S2e"
					}
				}
			},
			"S2a": {
				"type": "structure",
				"required": [
					"ForwardWhenQueryArgProfileIsUnknown"
				],
				"members": {
					"ForwardWhenQueryArgProfileIsUnknown": {
						"type": "boolean"
					},
					"QueryArgProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "QueryArgProfile",
									"type": "structure",
									"required": [
										"QueryArg",
										"ProfileId"
									],
									"members": {
										"QueryArg": {},
										"ProfileId": {}
									}
								}
							}
						}
					}
				}
			},
			"S2e": {
				"type": "structure",
				"required": [
					"ForwardWhenContentTypeIsUnknown"
				],
				"members": {
					"ForwardWhenContentTypeIsUnknown": {
						"type": "boolean"
					},
					"ContentTypeProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "ContentTypeProfile",
									"type": "structure",
									"required": [
										"Format",
										"ContentType"
									],
									"members": {
										"Format": {},
										"ProfileId": {},
										"ContentType": {}
									}
								}
							}
						}
					}
				}
			},
			"S2k": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionConfig": {
						"shape": "S29"
					}
				}
			},
			"S2m": {
				"type": "structure",
				"required": [
					"Name",
					"CallerReference",
					"EncryptionEntities"
				],
				"members": {
					"Name": {},
					"CallerReference": {},
					"Comment": {},
					"EncryptionEntities": {
						"shape": "S2n"
					}
				}
			},
			"S2n": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "EncryptionEntity",
							"type": "structure",
							"required": [
								"PublicKeyId",
								"ProviderId",
								"FieldPatterns"
							],
							"members": {
								"PublicKeyId": {},
								"ProviderId": {},
								"FieldPatterns": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "FieldPattern"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S2t": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionProfileConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionProfileConfig": {
						"shape": "S2m"
					}
				}
			},
			"S2v": {
				"type": "structure",
				"required": [
					"Paths",
					"CallerReference"
				],
				"members": {
					"Paths": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Path"
								}
							}
						}
					},
					"CallerReference": {}
				}
			},
			"S2z": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"CreateTime",
					"InvalidationBatch"
				],
				"members": {
					"Id": {},
					"Status": {},
					"CreateTime": {
						"type": "timestamp"
					},
					"InvalidationBatch": {
						"shape": "S2v"
					}
				}
			},
			"S31": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Name",
					"EncodedKey"
				],
				"members": {
					"CallerReference": {},
					"Name": {},
					"EncodedKey": {},
					"Comment": {}
				}
			},
			"S33": {
				"type": "structure",
				"required": [
					"Id",
					"CreatedTime",
					"PublicKeyConfig"
				],
				"members": {
					"Id": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"PublicKeyConfig": {
						"shape": "S31"
					}
				}
			},
			"S35": {
				"type": "structure",
				"required": [
					"CallerReference",
					"S3Origin",
					"Comment",
					"TrustedSigners",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"S3Origin": {
						"shape": "S36"
					},
					"Aliases": {
						"shape": "S8"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S36": {
				"type": "structure",
				"required": [
					"DomainName",
					"OriginAccessIdentity"
				],
				"members": {
					"DomainName": {},
					"OriginAccessIdentity": {}
				}
			},
			"S39": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"DomainName",
					"ActiveTrustedSigners",
					"StreamingDistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1v"
					},
					"StreamingDistributionConfig": {
						"shape": "S35"
					}
				}
			},
			"S4g": {
				"type": "structure",
				"required": [
					"Marker",
					"MaxItems",
					"IsTruncated",
					"Quantity"
				],
				"members": {
					"Marker": {},
					"NextMarker": {},
					"MaxItems": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "DistributionSummary",
							"type": "structure",
							"required": [
								"Id",
								"ARN",
								"Status",
								"LastModifiedTime",
								"DomainName",
								"Aliases",
								"Origins",
								"DefaultCacheBehavior",
								"CacheBehaviors",
								"CustomErrorResponses",
								"Comment",
								"PriceClass",
								"Enabled",
								"ViewerCertificate",
								"Restrictions",
								"WebACLId",
								"HttpVersion",
								"IsIPV6Enabled"
							],
							"members": {
								"Id": {},
								"ARN": {},
								"Status": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"DomainName": {},
								"Aliases": {
									"shape": "S8"
								},
								"Origins": {
									"shape": "Sb"
								},
								"DefaultCacheBehavior": {
									"shape": "Sn"
								},
								"CacheBehaviors": {
									"shape": "S1b"
								},
								"CustomErrorResponses": {
									"shape": "S1e"
								},
								"Comment": {},
								"PriceClass": {},
								"Enabled": {
									"type": "boolean"
								},
								"ViewerCertificate": {
									"shape": "S1j"
								},
								"Restrictions": {
									"shape": "S1n"
								},
								"WebACLId": {},
								"HttpVersion": {},
								"IsIPV6Enabled": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1669 */
1666,
/* 1670 */
1664,
/* 1671 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2018-06-18",
			"endpointPrefix": "cloudfront",
			"globalEndpoint": "cloudfront.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "CloudFront",
			"serviceFullName": "Amazon CloudFront",
			"serviceId": "CloudFront",
			"signatureVersion": "v4",
			"uid": "cloudfront-2018-06-18"
		},
		"operations": {
			"CreateCloudFrontOriginAccessIdentity": {
				"http": {
					"requestUri": "/2018-06-18/origin-access-identity/cloudfront",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"CreateDistribution": {
				"http": {
					"requestUri": "/2018-06-18/distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateDistributionWithTags": {
				"http": {
					"requestUri": "/2018-06-18/distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfigWithTags"
					],
					"members": {
						"DistributionConfigWithTags": {
							"locationName": "DistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							},
							"type": "structure",
							"required": [
								"DistributionConfig",
								"Tags"
							],
							"members": {
								"DistributionConfig": {
									"shape": "S7"
								},
								"Tags": {
									"shape": "S22"
								}
							}
						}
					},
					"payload": "DistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateFieldLevelEncryptionConfig": {
				"http": {
					"requestUri": "/2018-06-18/field-level-encryption",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S29",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2k"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"CreateFieldLevelEncryptionProfile": {
				"http": {
					"requestUri": "/2018-06-18/field-level-encryption-profile",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2m",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S2t"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"CreateInvalidation": {
				"http": {
					"requestUri": "/2018-06-18/distribution/{DistributionId}/invalidation",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"InvalidationBatch"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"InvalidationBatch": {
							"shape": "S2v",
							"locationName": "InvalidationBatch",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "InvalidationBatch"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"Invalidation": {
							"shape": "S2z"
						}
					},
					"payload": "Invalidation"
				}
			},
			"CreatePublicKey": {
				"http": {
					"requestUri": "/2018-06-18/public-key",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S31",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S33"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"CreateStreamingDistribution": {
				"http": {
					"requestUri": "/2018-06-18/streaming-distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S35",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"CreateStreamingDistributionWithTags": {
				"http": {
					"requestUri": "/2018-06-18/streaming-distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfigWithTags"
					],
					"members": {
						"StreamingDistributionConfigWithTags": {
							"locationName": "StreamingDistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							},
							"type": "structure",
							"required": [
								"StreamingDistributionConfig",
								"Tags"
							],
							"members": {
								"StreamingDistributionConfig": {
									"shape": "S35"
								},
								"Tags": {
									"shape": "S22"
								}
							}
						}
					},
					"payload": "StreamingDistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"DeleteCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-06-18/distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionConfig": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-06-18/field-level-encryption/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionProfile": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-06-18/field-level-encryption-profile/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeletePublicKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-06-18/public-key/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteStreamingDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-06-18/streaming-distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"GetCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"GetCloudFrontOriginAccessIdentityConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				}
			},
			"GetDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"GetDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionConfig": {
							"shape": "S7"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "DistributionConfig"
				}
			},
			"GetFieldLevelEncryption": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/field-level-encryption/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2k"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"GetFieldLevelEncryptionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S29"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				}
			},
			"GetFieldLevelEncryptionProfile": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/field-level-encryption-profile/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S2t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"GetFieldLevelEncryptionProfileConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2m"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				}
			},
			"GetInvalidation": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/distribution/{DistributionId}/invalidation/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"Id"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Invalidation": {
							"shape": "S2z"
						}
					},
					"payload": "Invalidation"
				}
			},
			"GetPublicKey": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/public-key/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S33"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"GetPublicKeyConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyConfig": {
							"shape": "S31"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKeyConfig"
				}
			},
			"GetStreamingDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/streaming-distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"GetStreamingDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S35"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistributionConfig"
				}
			},
			"ListCloudFrontOriginAccessIdentities": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/origin-access-identity/cloudfront"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "CloudFrontOriginAccessIdentitySummary",
										"type": "structure",
										"required": [
											"Id",
											"S3CanonicalUserId",
											"Comment"
										],
										"members": {
											"Id": {},
											"S3CanonicalUserId": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityList"
				}
			},
			"ListDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4g"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListDistributionsByWebACLId": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/distributionsByWebACLId/{WebACLId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						},
						"WebACLId": {
							"location": "uri",
							"locationName": "WebACLId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4g"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListFieldLevelEncryptionConfigs": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/field-level-encryption"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Comment": {},
											"QueryArgProfileConfig": {
												"shape": "S2a"
											},
											"ContentTypeProfileConfig": {
												"shape": "S2e"
											}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionList"
				}
			},
			"ListFieldLevelEncryptionProfiles": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/field-level-encryption-profile"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionProfileSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime",
											"Name",
											"EncryptionEntities"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Name": {},
											"EncryptionEntities": {
												"shape": "S2n"
											},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileList"
				}
			},
			"ListInvalidations": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/distribution/{DistributionId}/invalidation"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidationList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "InvalidationSummary",
										"type": "structure",
										"required": [
											"Id",
											"CreateTime",
											"Status"
										],
										"members": {
											"Id": {},
											"CreateTime": {
												"type": "timestamp"
											},
											"Status": {}
										}
									}
								}
							}
						}
					},
					"payload": "InvalidationList"
				}
			},
			"ListPublicKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/public-key"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "PublicKeySummary",
										"type": "structure",
										"required": [
											"Id",
											"Name",
											"CreatedTime",
											"EncodedKey"
										],
										"members": {
											"Id": {},
											"Name": {},
											"CreatedTime": {
												"type": "timestamp"
											},
											"EncodedKey": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "PublicKeyList"
				}
			},
			"ListStreamingDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/streaming-distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "StreamingDistributionSummary",
										"type": "structure",
										"required": [
											"Id",
											"ARN",
											"Status",
											"LastModifiedTime",
											"DomainName",
											"S3Origin",
											"Aliases",
											"TrustedSigners",
											"Comment",
											"PriceClass",
											"Enabled"
										],
										"members": {
											"Id": {},
											"ARN": {},
											"Status": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"DomainName": {},
											"S3Origin": {
												"shape": "S36"
											},
											"Aliases": {
												"shape": "S8"
											},
											"TrustedSigners": {
												"shape": "Sy"
											},
											"Comment": {},
											"PriceClass": {},
											"Enabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"payload": "StreamingDistributionList"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-06-18/tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S22"
						}
					},
					"payload": "Tags"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2018-06-18/tagging?Operation=Tag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"Tags": {
							"shape": "S22",
							"locationName": "Tags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						}
					},
					"payload": "Tags"
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/2018-06-18/tagging?Operation=Untag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"TagKeys": {
							"locationName": "TagKeys",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							},
							"type": "structure",
							"members": {
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Key"
									}
								}
							}
						}
					},
					"payload": "TagKeys"
				}
			},
			"UpdateCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-06-18/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig",
						"Id"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"UpdateDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-06-18/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig",
						"Id"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"UpdateFieldLevelEncryptionConfig": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-06-18/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S29",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2k"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"UpdateFieldLevelEncryptionProfile": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-06-18/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2m",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S2t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"UpdatePublicKey": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-06-18/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig",
						"Id"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S31",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S33"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"UpdateStreamingDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-06-18/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig",
						"Id"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S35",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-06-18/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S39"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Comment"
				],
				"members": {
					"CallerReference": {},
					"Comment": {}
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"Id",
					"S3CanonicalUserId"
				],
				"members": {
					"Id": {},
					"S3CanonicalUserId": {},
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					}
				}
			},
			"S7": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Origins",
					"DefaultCacheBehavior",
					"Comment",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"Aliases": {
						"shape": "S8"
					},
					"DefaultRootObject": {},
					"Origins": {
						"shape": "Sb"
					},
					"DefaultCacheBehavior": {
						"shape": "Sn"
					},
					"CacheBehaviors": {
						"shape": "S1b"
					},
					"CustomErrorResponses": {
						"shape": "S1e"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"IncludeCookies",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"IncludeCookies": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					},
					"ViewerCertificate": {
						"shape": "S1j"
					},
					"Restrictions": {
						"shape": "S1n"
					},
					"WebACLId": {},
					"HttpVersion": {},
					"IsIPV6Enabled": {
						"type": "boolean"
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CNAME"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Origin",
							"type": "structure",
							"required": [
								"Id",
								"DomainName"
							],
							"members": {
								"Id": {},
								"DomainName": {},
								"OriginPath": {},
								"CustomHeaders": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginCustomHeader",
												"type": "structure",
												"required": [
													"HeaderName",
													"HeaderValue"
												],
												"members": {
													"HeaderName": {},
													"HeaderValue": {}
												}
											}
										}
									}
								},
								"S3OriginConfig": {
									"type": "structure",
									"required": [
										"OriginAccessIdentity"
									],
									"members": {
										"OriginAccessIdentity": {}
									}
								},
								"CustomOriginConfig": {
									"type": "structure",
									"required": [
										"HTTPPort",
										"HTTPSPort",
										"OriginProtocolPolicy"
									],
									"members": {
										"HTTPPort": {
											"type": "integer"
										},
										"HTTPSPort": {
											"type": "integer"
										},
										"OriginProtocolPolicy": {},
										"OriginSslProtocols": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "SslProtocol"
													}
												}
											}
										},
										"OriginReadTimeout": {
											"type": "integer"
										},
										"OriginKeepaliveTimeout": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"TargetOriginId",
					"ForwardedValues",
					"TrustedSigners",
					"ViewerProtocolPolicy",
					"MinTTL"
				],
				"members": {
					"TargetOriginId": {},
					"ForwardedValues": {
						"shape": "So"
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"ViewerProtocolPolicy": {},
					"MinTTL": {
						"type": "long"
					},
					"AllowedMethods": {
						"shape": "S12"
					},
					"SmoothStreaming": {
						"type": "boolean"
					},
					"DefaultTTL": {
						"type": "long"
					},
					"MaxTTL": {
						"type": "long"
					},
					"Compress": {
						"type": "boolean"
					},
					"LambdaFunctionAssociations": {
						"shape": "S16"
					},
					"FieldLevelEncryptionId": {}
				}
			},
			"So": {
				"type": "structure",
				"required": [
					"QueryString",
					"Cookies"
				],
				"members": {
					"QueryString": {
						"type": "boolean"
					},
					"Cookies": {
						"type": "structure",
						"required": [
							"Forward"
						],
						"members": {
							"Forward": {},
							"WhitelistedNames": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "Name"
										}
									}
								}
							}
						}
					},
					"Headers": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					},
					"QueryStringCacheKeys": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "AwsAccountNumber"
						}
					}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"shape": "S13"
					},
					"CachedMethods": {
						"type": "structure",
						"required": [
							"Quantity",
							"Items"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"shape": "S13"
							}
						}
					}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"locationName": "Method"
				}
			},
			"S16": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "LambdaFunctionAssociation",
							"type": "structure",
							"required": [
								"LambdaFunctionARN",
								"EventType"
							],
							"members": {
								"LambdaFunctionARN": {},
								"EventType": {},
								"IncludeBody": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CacheBehavior",
							"type": "structure",
							"required": [
								"PathPattern",
								"TargetOriginId",
								"ForwardedValues",
								"TrustedSigners",
								"ViewerProtocolPolicy",
								"MinTTL"
							],
							"members": {
								"PathPattern": {},
								"TargetOriginId": {},
								"ForwardedValues": {
									"shape": "So"
								},
								"TrustedSigners": {
									"shape": "Sy"
								},
								"ViewerProtocolPolicy": {},
								"MinTTL": {
									"type": "long"
								},
								"AllowedMethods": {
									"shape": "S12"
								},
								"SmoothStreaming": {
									"type": "boolean"
								},
								"DefaultTTL": {
									"type": "long"
								},
								"MaxTTL": {
									"type": "long"
								},
								"Compress": {
									"type": "boolean"
								},
								"LambdaFunctionAssociations": {
									"shape": "S16"
								},
								"FieldLevelEncryptionId": {}
							}
						}
					}
				}
			},
			"S1e": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CustomErrorResponse",
							"type": "structure",
							"required": [
								"ErrorCode"
							],
							"members": {
								"ErrorCode": {
									"type": "integer"
								},
								"ResponsePagePath": {},
								"ResponseCode": {},
								"ErrorCachingMinTTL": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"CloudFrontDefaultCertificate": {
						"type": "boolean"
					},
					"IAMCertificateId": {},
					"ACMCertificateArn": {},
					"SSLSupportMethod": {},
					"MinimumProtocolVersion": {},
					"Certificate": {
						"deprecated": true
					},
					"CertificateSource": {
						"deprecated": true
					}
				}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"GeoRestriction"
				],
				"members": {
					"GeoRestriction": {
						"type": "structure",
						"required": [
							"RestrictionType",
							"Quantity"
						],
						"members": {
							"RestrictionType": {},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Location"
								}
							}
						}
					}
				}
			},
			"S1t": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"LastModifiedTime",
					"InProgressInvalidationBatches",
					"DomainName",
					"ActiveTrustedSigners",
					"DistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"InProgressInvalidationBatches": {
						"type": "integer"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1v"
					},
					"DistributionConfig": {
						"shape": "S7"
					}
				}
			},
			"S1v": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Signer",
							"type": "structure",
							"members": {
								"AwsAccountNumber": {},
								"KeyPairIds": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "KeyPairId"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S22": {
				"type": "structure",
				"members": {
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Tag",
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S29": {
				"type": "structure",
				"required": [
					"CallerReference"
				],
				"members": {
					"CallerReference": {},
					"Comment": {},
					"QueryArgProfileConfig": {
						"shape": "S2a"
					},
					"ContentTypeProfileConfig": {
						"shape": "S2e"
					}
				}
			},
			"S2a": {
				"type": "structure",
				"required": [
					"ForwardWhenQueryArgProfileIsUnknown"
				],
				"members": {
					"ForwardWhenQueryArgProfileIsUnknown": {
						"type": "boolean"
					},
					"QueryArgProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "QueryArgProfile",
									"type": "structure",
									"required": [
										"QueryArg",
										"ProfileId"
									],
									"members": {
										"QueryArg": {},
										"ProfileId": {}
									}
								}
							}
						}
					}
				}
			},
			"S2e": {
				"type": "structure",
				"required": [
					"ForwardWhenContentTypeIsUnknown"
				],
				"members": {
					"ForwardWhenContentTypeIsUnknown": {
						"type": "boolean"
					},
					"ContentTypeProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "ContentTypeProfile",
									"type": "structure",
									"required": [
										"Format",
										"ContentType"
									],
									"members": {
										"Format": {},
										"ProfileId": {},
										"ContentType": {}
									}
								}
							}
						}
					}
				}
			},
			"S2k": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionConfig": {
						"shape": "S29"
					}
				}
			},
			"S2m": {
				"type": "structure",
				"required": [
					"Name",
					"CallerReference",
					"EncryptionEntities"
				],
				"members": {
					"Name": {},
					"CallerReference": {},
					"Comment": {},
					"EncryptionEntities": {
						"shape": "S2n"
					}
				}
			},
			"S2n": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "EncryptionEntity",
							"type": "structure",
							"required": [
								"PublicKeyId",
								"ProviderId",
								"FieldPatterns"
							],
							"members": {
								"PublicKeyId": {},
								"ProviderId": {},
								"FieldPatterns": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "FieldPattern"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S2t": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionProfileConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionProfileConfig": {
						"shape": "S2m"
					}
				}
			},
			"S2v": {
				"type": "structure",
				"required": [
					"Paths",
					"CallerReference"
				],
				"members": {
					"Paths": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Path"
								}
							}
						}
					},
					"CallerReference": {}
				}
			},
			"S2z": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"CreateTime",
					"InvalidationBatch"
				],
				"members": {
					"Id": {},
					"Status": {},
					"CreateTime": {
						"type": "timestamp"
					},
					"InvalidationBatch": {
						"shape": "S2v"
					}
				}
			},
			"S31": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Name",
					"EncodedKey"
				],
				"members": {
					"CallerReference": {},
					"Name": {},
					"EncodedKey": {},
					"Comment": {}
				}
			},
			"S33": {
				"type": "structure",
				"required": [
					"Id",
					"CreatedTime",
					"PublicKeyConfig"
				],
				"members": {
					"Id": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"PublicKeyConfig": {
						"shape": "S31"
					}
				}
			},
			"S35": {
				"type": "structure",
				"required": [
					"CallerReference",
					"S3Origin",
					"Comment",
					"TrustedSigners",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"S3Origin": {
						"shape": "S36"
					},
					"Aliases": {
						"shape": "S8"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S36": {
				"type": "structure",
				"required": [
					"DomainName",
					"OriginAccessIdentity"
				],
				"members": {
					"DomainName": {},
					"OriginAccessIdentity": {}
				}
			},
			"S39": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"DomainName",
					"ActiveTrustedSigners",
					"StreamingDistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1v"
					},
					"StreamingDistributionConfig": {
						"shape": "S35"
					}
				}
			},
			"S4g": {
				"type": "structure",
				"required": [
					"Marker",
					"MaxItems",
					"IsTruncated",
					"Quantity"
				],
				"members": {
					"Marker": {},
					"NextMarker": {},
					"MaxItems": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "DistributionSummary",
							"type": "structure",
							"required": [
								"Id",
								"ARN",
								"Status",
								"LastModifiedTime",
								"DomainName",
								"Aliases",
								"Origins",
								"DefaultCacheBehavior",
								"CacheBehaviors",
								"CustomErrorResponses",
								"Comment",
								"PriceClass",
								"Enabled",
								"ViewerCertificate",
								"Restrictions",
								"WebACLId",
								"HttpVersion",
								"IsIPV6Enabled"
							],
							"members": {
								"Id": {},
								"ARN": {},
								"Status": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"DomainName": {},
								"Aliases": {
									"shape": "S8"
								},
								"Origins": {
									"shape": "Sb"
								},
								"DefaultCacheBehavior": {
									"shape": "Sn"
								},
								"CacheBehaviors": {
									"shape": "S1b"
								},
								"CustomErrorResponses": {
									"shape": "S1e"
								},
								"Comment": {},
								"PriceClass": {},
								"Enabled": {
									"type": "boolean"
								},
								"ViewerCertificate": {
									"shape": "S1j"
								},
								"Restrictions": {
									"shape": "S1n"
								},
								"WebACLId": {},
								"HttpVersion": {},
								"IsIPV6Enabled": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1672 */
1666,
/* 1673 */
1664,
/* 1674 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2018-11-05",
			"endpointPrefix": "cloudfront",
			"globalEndpoint": "cloudfront.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "CloudFront",
			"serviceFullName": "Amazon CloudFront",
			"serviceId": "CloudFront",
			"signatureVersion": "v4",
			"uid": "cloudfront-2018-11-05"
		},
		"operations": {
			"CreateCloudFrontOriginAccessIdentity": {
				"http": {
					"requestUri": "/2018-11-05/origin-access-identity/cloudfront",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"CreateDistribution": {
				"http": {
					"requestUri": "/2018-11-05/distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S22"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateDistributionWithTags": {
				"http": {
					"requestUri": "/2018-11-05/distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfigWithTags"
					],
					"members": {
						"DistributionConfigWithTags": {
							"locationName": "DistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							},
							"type": "structure",
							"required": [
								"DistributionConfig",
								"Tags"
							],
							"members": {
								"DistributionConfig": {
									"shape": "S7"
								},
								"Tags": {
									"shape": "S2b"
								}
							}
						}
					},
					"payload": "DistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S22"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateFieldLevelEncryptionConfig": {
				"http": {
					"requestUri": "/2018-11-05/field-level-encryption",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S2i",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2t"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"CreateFieldLevelEncryptionProfile": {
				"http": {
					"requestUri": "/2018-11-05/field-level-encryption-profile",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2v",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S32"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"CreateInvalidation": {
				"http": {
					"requestUri": "/2018-11-05/distribution/{DistributionId}/invalidation",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"InvalidationBatch"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"InvalidationBatch": {
							"shape": "S34",
							"locationName": "InvalidationBatch",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "InvalidationBatch"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"Invalidation": {
							"shape": "S38"
						}
					},
					"payload": "Invalidation"
				}
			},
			"CreatePublicKey": {
				"http": {
					"requestUri": "/2018-11-05/public-key",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S3a",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S3c"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"CreateStreamingDistribution": {
				"http": {
					"requestUri": "/2018-11-05/streaming-distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S3e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"CreateStreamingDistributionWithTags": {
				"http": {
					"requestUri": "/2018-11-05/streaming-distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfigWithTags"
					],
					"members": {
						"StreamingDistributionConfigWithTags": {
							"locationName": "StreamingDistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							},
							"type": "structure",
							"required": [
								"StreamingDistributionConfig",
								"Tags"
							],
							"members": {
								"StreamingDistributionConfig": {
									"shape": "S3e"
								},
								"Tags": {
									"shape": "S2b"
								}
							}
						}
					},
					"payload": "StreamingDistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"DeleteCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-11-05/distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionConfig": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-11-05/field-level-encryption/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionProfile": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-11-05/field-level-encryption-profile/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeletePublicKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-11-05/public-key/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteStreamingDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-11-05/streaming-distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"GetCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"GetCloudFrontOriginAccessIdentityConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				}
			},
			"GetDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S22"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"GetDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionConfig": {
							"shape": "S7"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "DistributionConfig"
				}
			},
			"GetFieldLevelEncryption": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/field-level-encryption/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"GetFieldLevelEncryptionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S2i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				}
			},
			"GetFieldLevelEncryptionProfile": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/field-level-encryption-profile/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S32"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"GetFieldLevelEncryptionProfileConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2v"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				}
			},
			"GetInvalidation": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/distribution/{DistributionId}/invalidation/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"Id"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Invalidation": {
							"shape": "S38"
						}
					},
					"payload": "Invalidation"
				}
			},
			"GetPublicKey": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/public-key/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S3c"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"GetPublicKeyConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyConfig": {
							"shape": "S3a"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKeyConfig"
				}
			},
			"GetStreamingDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/streaming-distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"GetStreamingDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S3e"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistributionConfig"
				}
			},
			"ListCloudFrontOriginAccessIdentities": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/origin-access-identity/cloudfront"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "CloudFrontOriginAccessIdentitySummary",
										"type": "structure",
										"required": [
											"Id",
											"S3CanonicalUserId",
											"Comment"
										],
										"members": {
											"Id": {},
											"S3CanonicalUserId": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityList"
				}
			},
			"ListDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4p"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListDistributionsByWebACLId": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/distributionsByWebACLId/{WebACLId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						},
						"WebACLId": {
							"location": "uri",
							"locationName": "WebACLId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4p"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListFieldLevelEncryptionConfigs": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/field-level-encryption"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Comment": {},
											"QueryArgProfileConfig": {
												"shape": "S2j"
											},
											"ContentTypeProfileConfig": {
												"shape": "S2n"
											}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionList"
				}
			},
			"ListFieldLevelEncryptionProfiles": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/field-level-encryption-profile"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionProfileSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime",
											"Name",
											"EncryptionEntities"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Name": {},
											"EncryptionEntities": {
												"shape": "S2w"
											},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileList"
				}
			},
			"ListInvalidations": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/distribution/{DistributionId}/invalidation"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidationList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "InvalidationSummary",
										"type": "structure",
										"required": [
											"Id",
											"CreateTime",
											"Status"
										],
										"members": {
											"Id": {},
											"CreateTime": {
												"type": "timestamp"
											},
											"Status": {}
										}
									}
								}
							}
						}
					},
					"payload": "InvalidationList"
				}
			},
			"ListPublicKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/public-key"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "PublicKeySummary",
										"type": "structure",
										"required": [
											"Id",
											"Name",
											"CreatedTime",
											"EncodedKey"
										],
										"members": {
											"Id": {},
											"Name": {},
											"CreatedTime": {
												"type": "timestamp"
											},
											"EncodedKey": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "PublicKeyList"
				}
			},
			"ListStreamingDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/streaming-distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "StreamingDistributionSummary",
										"type": "structure",
										"required": [
											"Id",
											"ARN",
											"Status",
											"LastModifiedTime",
											"DomainName",
											"S3Origin",
											"Aliases",
											"TrustedSigners",
											"Comment",
											"PriceClass",
											"Enabled"
										],
										"members": {
											"Id": {},
											"ARN": {},
											"Status": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"DomainName": {},
											"S3Origin": {
												"shape": "S3f"
											},
											"Aliases": {
												"shape": "S8"
											},
											"TrustedSigners": {
												"shape": "S17"
											},
											"Comment": {},
											"PriceClass": {},
											"Enabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"payload": "StreamingDistributionList"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-11-05/tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S2b"
						}
					},
					"payload": "Tags"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2018-11-05/tagging?Operation=Tag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"Tags": {
							"shape": "S2b",
							"locationName": "Tags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						}
					},
					"payload": "Tags"
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/2018-11-05/tagging?Operation=Untag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"TagKeys": {
							"locationName": "TagKeys",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							},
							"type": "structure",
							"members": {
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Key"
									}
								}
							}
						}
					},
					"payload": "TagKeys"
				}
			},
			"UpdateCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-11-05/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig",
						"Id"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"UpdateDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-11-05/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig",
						"Id"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S22"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"UpdateFieldLevelEncryptionConfig": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-11-05/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S2i",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2t"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"UpdateFieldLevelEncryptionProfile": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-11-05/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2v",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S32"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"UpdatePublicKey": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-11-05/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig",
						"Id"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S3a",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S3c"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"UpdateStreamingDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2018-11-05/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig",
						"Id"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S3e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2018-11-05/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Comment"
				],
				"members": {
					"CallerReference": {},
					"Comment": {}
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"Id",
					"S3CanonicalUserId"
				],
				"members": {
					"Id": {},
					"S3CanonicalUserId": {},
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					}
				}
			},
			"S7": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Origins",
					"DefaultCacheBehavior",
					"Comment",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"Aliases": {
						"shape": "S8"
					},
					"DefaultRootObject": {},
					"Origins": {
						"shape": "Sb"
					},
					"OriginGroups": {
						"shape": "Sn"
					},
					"DefaultCacheBehavior": {
						"shape": "Sw"
					},
					"CacheBehaviors": {
						"shape": "S1k"
					},
					"CustomErrorResponses": {
						"shape": "S1n"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"IncludeCookies",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"IncludeCookies": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					},
					"ViewerCertificate": {
						"shape": "S1s"
					},
					"Restrictions": {
						"shape": "S1w"
					},
					"WebACLId": {},
					"HttpVersion": {},
					"IsIPV6Enabled": {
						"type": "boolean"
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CNAME"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Origin",
							"type": "structure",
							"required": [
								"Id",
								"DomainName"
							],
							"members": {
								"Id": {},
								"DomainName": {},
								"OriginPath": {},
								"CustomHeaders": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginCustomHeader",
												"type": "structure",
												"required": [
													"HeaderName",
													"HeaderValue"
												],
												"members": {
													"HeaderName": {},
													"HeaderValue": {}
												}
											}
										}
									}
								},
								"S3OriginConfig": {
									"type": "structure",
									"required": [
										"OriginAccessIdentity"
									],
									"members": {
										"OriginAccessIdentity": {}
									}
								},
								"CustomOriginConfig": {
									"type": "structure",
									"required": [
										"HTTPPort",
										"HTTPSPort",
										"OriginProtocolPolicy"
									],
									"members": {
										"HTTPPort": {
											"type": "integer"
										},
										"HTTPSPort": {
											"type": "integer"
										},
										"OriginProtocolPolicy": {},
										"OriginSslProtocols": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "SslProtocol"
													}
												}
											}
										},
										"OriginReadTimeout": {
											"type": "integer"
										},
										"OriginKeepaliveTimeout": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "OriginGroup",
							"type": "structure",
							"required": [
								"Id",
								"FailoverCriteria",
								"Members"
							],
							"members": {
								"Id": {},
								"FailoverCriteria": {
									"type": "structure",
									"required": [
										"StatusCodes"
									],
									"members": {
										"StatusCodes": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "StatusCode",
														"type": "integer"
													}
												}
											}
										}
									}
								},
								"Members": {
									"type": "structure",
									"required": [
										"Quantity",
										"Items"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginGroupMember",
												"type": "structure",
												"required": [
													"OriginId"
												],
												"members": {
													"OriginId": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"Sw": {
				"type": "structure",
				"required": [
					"TargetOriginId",
					"ForwardedValues",
					"TrustedSigners",
					"ViewerProtocolPolicy",
					"MinTTL"
				],
				"members": {
					"TargetOriginId": {},
					"ForwardedValues": {
						"shape": "Sx"
					},
					"TrustedSigners": {
						"shape": "S17"
					},
					"ViewerProtocolPolicy": {},
					"MinTTL": {
						"type": "long"
					},
					"AllowedMethods": {
						"shape": "S1b"
					},
					"SmoothStreaming": {
						"type": "boolean"
					},
					"DefaultTTL": {
						"type": "long"
					},
					"MaxTTL": {
						"type": "long"
					},
					"Compress": {
						"type": "boolean"
					},
					"LambdaFunctionAssociations": {
						"shape": "S1f"
					},
					"FieldLevelEncryptionId": {}
				}
			},
			"Sx": {
				"type": "structure",
				"required": [
					"QueryString",
					"Cookies"
				],
				"members": {
					"QueryString": {
						"type": "boolean"
					},
					"Cookies": {
						"type": "structure",
						"required": [
							"Forward"
						],
						"members": {
							"Forward": {},
							"WhitelistedNames": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "Name"
										}
									}
								}
							}
						}
					},
					"Headers": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					},
					"QueryStringCacheKeys": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					}
				}
			},
			"S17": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "AwsAccountNumber"
						}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"shape": "S1c"
					},
					"CachedMethods": {
						"type": "structure",
						"required": [
							"Quantity",
							"Items"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"shape": "S1c"
							}
						}
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {
					"locationName": "Method"
				}
			},
			"S1f": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "LambdaFunctionAssociation",
							"type": "structure",
							"required": [
								"LambdaFunctionARN",
								"EventType"
							],
							"members": {
								"LambdaFunctionARN": {},
								"EventType": {},
								"IncludeBody": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"S1k": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CacheBehavior",
							"type": "structure",
							"required": [
								"PathPattern",
								"TargetOriginId",
								"ForwardedValues",
								"TrustedSigners",
								"ViewerProtocolPolicy",
								"MinTTL"
							],
							"members": {
								"PathPattern": {},
								"TargetOriginId": {},
								"ForwardedValues": {
									"shape": "Sx"
								},
								"TrustedSigners": {
									"shape": "S17"
								},
								"ViewerProtocolPolicy": {},
								"MinTTL": {
									"type": "long"
								},
								"AllowedMethods": {
									"shape": "S1b"
								},
								"SmoothStreaming": {
									"type": "boolean"
								},
								"DefaultTTL": {
									"type": "long"
								},
								"MaxTTL": {
									"type": "long"
								},
								"Compress": {
									"type": "boolean"
								},
								"LambdaFunctionAssociations": {
									"shape": "S1f"
								},
								"FieldLevelEncryptionId": {}
							}
						}
					}
				}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CustomErrorResponse",
							"type": "structure",
							"required": [
								"ErrorCode"
							],
							"members": {
								"ErrorCode": {
									"type": "integer"
								},
								"ResponsePagePath": {},
								"ResponseCode": {},
								"ErrorCachingMinTTL": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S1s": {
				"type": "structure",
				"members": {
					"CloudFrontDefaultCertificate": {
						"type": "boolean"
					},
					"IAMCertificateId": {},
					"ACMCertificateArn": {},
					"SSLSupportMethod": {},
					"MinimumProtocolVersion": {},
					"Certificate": {
						"deprecated": true
					},
					"CertificateSource": {
						"deprecated": true
					}
				}
			},
			"S1w": {
				"type": "structure",
				"required": [
					"GeoRestriction"
				],
				"members": {
					"GeoRestriction": {
						"type": "structure",
						"required": [
							"RestrictionType",
							"Quantity"
						],
						"members": {
							"RestrictionType": {},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Location"
								}
							}
						}
					}
				}
			},
			"S22": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"LastModifiedTime",
					"InProgressInvalidationBatches",
					"DomainName",
					"ActiveTrustedSigners",
					"DistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"InProgressInvalidationBatches": {
						"type": "integer"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S24"
					},
					"DistributionConfig": {
						"shape": "S7"
					}
				}
			},
			"S24": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Signer",
							"type": "structure",
							"members": {
								"AwsAccountNumber": {},
								"KeyPairIds": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "KeyPairId"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S2b": {
				"type": "structure",
				"members": {
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Tag",
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S2i": {
				"type": "structure",
				"required": [
					"CallerReference"
				],
				"members": {
					"CallerReference": {},
					"Comment": {},
					"QueryArgProfileConfig": {
						"shape": "S2j"
					},
					"ContentTypeProfileConfig": {
						"shape": "S2n"
					}
				}
			},
			"S2j": {
				"type": "structure",
				"required": [
					"ForwardWhenQueryArgProfileIsUnknown"
				],
				"members": {
					"ForwardWhenQueryArgProfileIsUnknown": {
						"type": "boolean"
					},
					"QueryArgProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "QueryArgProfile",
									"type": "structure",
									"required": [
										"QueryArg",
										"ProfileId"
									],
									"members": {
										"QueryArg": {},
										"ProfileId": {}
									}
								}
							}
						}
					}
				}
			},
			"S2n": {
				"type": "structure",
				"required": [
					"ForwardWhenContentTypeIsUnknown"
				],
				"members": {
					"ForwardWhenContentTypeIsUnknown": {
						"type": "boolean"
					},
					"ContentTypeProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "ContentTypeProfile",
									"type": "structure",
									"required": [
										"Format",
										"ContentType"
									],
									"members": {
										"Format": {},
										"ProfileId": {},
										"ContentType": {}
									}
								}
							}
						}
					}
				}
			},
			"S2t": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionConfig": {
						"shape": "S2i"
					}
				}
			},
			"S2v": {
				"type": "structure",
				"required": [
					"Name",
					"CallerReference",
					"EncryptionEntities"
				],
				"members": {
					"Name": {},
					"CallerReference": {},
					"Comment": {},
					"EncryptionEntities": {
						"shape": "S2w"
					}
				}
			},
			"S2w": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "EncryptionEntity",
							"type": "structure",
							"required": [
								"PublicKeyId",
								"ProviderId",
								"FieldPatterns"
							],
							"members": {
								"PublicKeyId": {},
								"ProviderId": {},
								"FieldPatterns": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "FieldPattern"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S32": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionProfileConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionProfileConfig": {
						"shape": "S2v"
					}
				}
			},
			"S34": {
				"type": "structure",
				"required": [
					"Paths",
					"CallerReference"
				],
				"members": {
					"Paths": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Path"
								}
							}
						}
					},
					"CallerReference": {}
				}
			},
			"S38": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"CreateTime",
					"InvalidationBatch"
				],
				"members": {
					"Id": {},
					"Status": {},
					"CreateTime": {
						"type": "timestamp"
					},
					"InvalidationBatch": {
						"shape": "S34"
					}
				}
			},
			"S3a": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Name",
					"EncodedKey"
				],
				"members": {
					"CallerReference": {},
					"Name": {},
					"EncodedKey": {},
					"Comment": {}
				}
			},
			"S3c": {
				"type": "structure",
				"required": [
					"Id",
					"CreatedTime",
					"PublicKeyConfig"
				],
				"members": {
					"Id": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"PublicKeyConfig": {
						"shape": "S3a"
					}
				}
			},
			"S3e": {
				"type": "structure",
				"required": [
					"CallerReference",
					"S3Origin",
					"Comment",
					"TrustedSigners",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"S3Origin": {
						"shape": "S3f"
					},
					"Aliases": {
						"shape": "S8"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"TrustedSigners": {
						"shape": "S17"
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S3f": {
				"type": "structure",
				"required": [
					"DomainName",
					"OriginAccessIdentity"
				],
				"members": {
					"DomainName": {},
					"OriginAccessIdentity": {}
				}
			},
			"S3i": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"DomainName",
					"ActiveTrustedSigners",
					"StreamingDistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S24"
					},
					"StreamingDistributionConfig": {
						"shape": "S3e"
					}
				}
			},
			"S4p": {
				"type": "structure",
				"required": [
					"Marker",
					"MaxItems",
					"IsTruncated",
					"Quantity"
				],
				"members": {
					"Marker": {},
					"NextMarker": {},
					"MaxItems": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "DistributionSummary",
							"type": "structure",
							"required": [
								"Id",
								"ARN",
								"Status",
								"LastModifiedTime",
								"DomainName",
								"Aliases",
								"Origins",
								"DefaultCacheBehavior",
								"CacheBehaviors",
								"CustomErrorResponses",
								"Comment",
								"PriceClass",
								"Enabled",
								"ViewerCertificate",
								"Restrictions",
								"WebACLId",
								"HttpVersion",
								"IsIPV6Enabled"
							],
							"members": {
								"Id": {},
								"ARN": {},
								"Status": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"DomainName": {},
								"Aliases": {
									"shape": "S8"
								},
								"Origins": {
									"shape": "Sb"
								},
								"OriginGroups": {
									"shape": "Sn"
								},
								"DefaultCacheBehavior": {
									"shape": "Sw"
								},
								"CacheBehaviors": {
									"shape": "S1k"
								},
								"CustomErrorResponses": {
									"shape": "S1n"
								},
								"Comment": {},
								"PriceClass": {},
								"Enabled": {
									"type": "boolean"
								},
								"ViewerCertificate": {
									"shape": "S1s"
								},
								"Restrictions": {
									"shape": "S1w"
								},
								"WebACLId": {},
								"HttpVersion": {},
								"IsIPV6Enabled": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1675 */
1666,
/* 1676 */
1664,
/* 1677 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2019-03-26",
			"endpointPrefix": "cloudfront",
			"globalEndpoint": "cloudfront.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "CloudFront",
			"serviceFullName": "Amazon CloudFront",
			"serviceId": "CloudFront",
			"signatureVersion": "v4",
			"uid": "cloudfront-2019-03-26"
		},
		"operations": {
			"CreateCloudFrontOriginAccessIdentity": {
				"http": {
					"requestUri": "/2019-03-26/origin-access-identity/cloudfront",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"CreateDistribution": {
				"http": {
					"requestUri": "/2019-03-26/distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S23"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateDistributionWithTags": {
				"http": {
					"requestUri": "/2019-03-26/distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfigWithTags"
					],
					"members": {
						"DistributionConfigWithTags": {
							"locationName": "DistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							},
							"type": "structure",
							"required": [
								"DistributionConfig",
								"Tags"
							],
							"members": {
								"DistributionConfig": {
									"shape": "S7"
								},
								"Tags": {
									"shape": "S2f"
								}
							}
						}
					},
					"payload": "DistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S23"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateFieldLevelEncryptionConfig": {
				"http": {
					"requestUri": "/2019-03-26/field-level-encryption",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S2m",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2x"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"CreateFieldLevelEncryptionProfile": {
				"http": {
					"requestUri": "/2019-03-26/field-level-encryption-profile",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2z",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S36"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"CreateInvalidation": {
				"http": {
					"requestUri": "/2019-03-26/distribution/{DistributionId}/invalidation",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"InvalidationBatch"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"InvalidationBatch": {
							"shape": "S38",
							"locationName": "InvalidationBatch",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "InvalidationBatch"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"Invalidation": {
							"shape": "S3c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"CreatePublicKey": {
				"http": {
					"requestUri": "/2019-03-26/public-key",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S3e",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S3g"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"CreateStreamingDistribution": {
				"http": {
					"requestUri": "/2019-03-26/streaming-distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S3i",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3m"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"CreateStreamingDistributionWithTags": {
				"http": {
					"requestUri": "/2019-03-26/streaming-distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfigWithTags"
					],
					"members": {
						"StreamingDistributionConfigWithTags": {
							"locationName": "StreamingDistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							},
							"type": "structure",
							"required": [
								"StreamingDistributionConfig",
								"Tags"
							],
							"members": {
								"StreamingDistributionConfig": {
									"shape": "S3i"
								},
								"Tags": {
									"shape": "S2f"
								}
							}
						}
					},
					"payload": "StreamingDistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3m"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"DeleteCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2019-03-26/distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionConfig": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2019-03-26/field-level-encryption/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteFieldLevelEncryptionProfile": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2019-03-26/field-level-encryption-profile/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeletePublicKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2019-03-26/public-key/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteStreamingDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2019-03-26/streaming-distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"GetCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"GetCloudFrontOriginAccessIdentityConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				}
			},
			"GetDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S23"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"GetDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionConfig": {
							"shape": "S7"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "DistributionConfig"
				}
			},
			"GetFieldLevelEncryption": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/field-level-encryption/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2x"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"GetFieldLevelEncryptionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S2m"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				}
			},
			"GetFieldLevelEncryptionProfile": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/field-level-encryption-profile/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S36"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"GetFieldLevelEncryptionProfileConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2z"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				}
			},
			"GetInvalidation": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/distribution/{DistributionId}/invalidation/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"Id"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Invalidation": {
							"shape": "S3c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"GetPublicKey": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/public-key/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S3g"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"GetPublicKeyConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyConfig": {
							"shape": "S3e"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKeyConfig"
				}
			},
			"GetStreamingDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/streaming-distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3m"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"GetStreamingDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S3i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistributionConfig"
				}
			},
			"ListCloudFrontOriginAccessIdentities": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/origin-access-identity/cloudfront"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "CloudFrontOriginAccessIdentitySummary",
										"type": "structure",
										"required": [
											"Id",
											"S3CanonicalUserId",
											"Comment"
										],
										"members": {
											"Id": {},
											"S3CanonicalUserId": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityList"
				}
			},
			"ListDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4t"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListDistributionsByWebACLId": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/distributionsByWebACLId/{WebACLId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						},
						"WebACLId": {
							"location": "uri",
							"locationName": "WebACLId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S4t"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListFieldLevelEncryptionConfigs": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/field-level-encryption"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Comment": {},
											"QueryArgProfileConfig": {
												"shape": "S2n"
											},
											"ContentTypeProfileConfig": {
												"shape": "S2r"
											}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionList"
				}
			},
			"ListFieldLevelEncryptionProfiles": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/field-level-encryption-profile"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfileList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "FieldLevelEncryptionProfileSummary",
										"type": "structure",
										"required": [
											"Id",
											"LastModifiedTime",
											"Name",
											"EncryptionEntities"
										],
										"members": {
											"Id": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"Name": {},
											"EncryptionEntities": {
												"shape": "S30"
											},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "FieldLevelEncryptionProfileList"
				}
			},
			"ListInvalidations": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/distribution/{DistributionId}/invalidation"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidationList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "InvalidationSummary",
										"type": "structure",
										"required": [
											"Id",
											"CreateTime",
											"Status"
										],
										"members": {
											"Id": {},
											"CreateTime": {
												"type": "timestamp"
											},
											"Status": {}
										}
									}
								}
							}
						}
					},
					"payload": "InvalidationList"
				}
			},
			"ListPublicKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/public-key"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyList": {
							"type": "structure",
							"required": [
								"MaxItems",
								"Quantity"
							],
							"members": {
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "PublicKeySummary",
										"type": "structure",
										"required": [
											"Id",
											"Name",
											"CreatedTime",
											"EncodedKey"
										],
										"members": {
											"Id": {},
											"Name": {},
											"CreatedTime": {
												"type": "timestamp"
											},
											"EncodedKey": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "PublicKeyList"
				}
			},
			"ListStreamingDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/streaming-distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "StreamingDistributionSummary",
										"type": "structure",
										"required": [
											"Id",
											"ARN",
											"Status",
											"LastModifiedTime",
											"DomainName",
											"S3Origin",
											"Aliases",
											"TrustedSigners",
											"Comment",
											"PriceClass",
											"Enabled"
										],
										"members": {
											"Id": {},
											"ARN": {},
											"Status": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"DomainName": {},
											"S3Origin": {
												"shape": "S3j"
											},
											"Aliases": {
												"shape": "S8"
											},
											"TrustedSigners": {
												"shape": "S17"
											},
											"Comment": {},
											"PriceClass": {},
											"Enabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"payload": "StreamingDistributionList"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2019-03-26/tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S2f"
						}
					},
					"payload": "Tags"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2019-03-26/tagging?Operation=Tag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"Tags": {
							"shape": "S2f",
							"locationName": "Tags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						}
					},
					"payload": "Tags"
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/2019-03-26/tagging?Operation=Untag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"TagKeys": {
							"locationName": "TagKeys",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							},
							"type": "structure",
							"members": {
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Key"
									}
								}
							}
						}
					},
					"payload": "TagKeys"
				}
			},
			"UpdateCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "PUT",
					"requestUri": "/2019-03-26/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig",
						"Id"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"UpdateDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2019-03-26/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig",
						"Id"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S23"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"UpdateFieldLevelEncryptionConfig": {
				"http": {
					"method": "PUT",
					"requestUri": "/2019-03-26/field-level-encryption/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionConfig": {
							"shape": "S2m",
							"locationName": "FieldLevelEncryptionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryption": {
							"shape": "S2x"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryption"
				}
			},
			"UpdateFieldLevelEncryptionProfile": {
				"http": {
					"method": "PUT",
					"requestUri": "/2019-03-26/field-level-encryption-profile/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"FieldLevelEncryptionProfileConfig",
						"Id"
					],
					"members": {
						"FieldLevelEncryptionProfileConfig": {
							"shape": "S2z",
							"locationName": "FieldLevelEncryptionProfileConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "FieldLevelEncryptionProfileConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"FieldLevelEncryptionProfile": {
							"shape": "S36"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "FieldLevelEncryptionProfile"
				}
			},
			"UpdatePublicKey": {
				"http": {
					"method": "PUT",
					"requestUri": "/2019-03-26/public-key/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"PublicKeyConfig",
						"Id"
					],
					"members": {
						"PublicKeyConfig": {
							"shape": "S3e",
							"locationName": "PublicKeyConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "PublicKeyConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKey": {
							"shape": "S3g"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "PublicKey"
				}
			},
			"UpdateStreamingDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2019-03-26/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig",
						"Id"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S3i",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2019-03-26/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S3m"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Comment"
				],
				"members": {
					"CallerReference": {},
					"Comment": {}
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"Id",
					"S3CanonicalUserId"
				],
				"members": {
					"Id": {},
					"S3CanonicalUserId": {},
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					}
				}
			},
			"S7": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Origins",
					"DefaultCacheBehavior",
					"Comment",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"Aliases": {
						"shape": "S8"
					},
					"DefaultRootObject": {},
					"Origins": {
						"shape": "Sb"
					},
					"OriginGroups": {
						"shape": "Sn"
					},
					"DefaultCacheBehavior": {
						"shape": "Sw"
					},
					"CacheBehaviors": {
						"shape": "S1k"
					},
					"CustomErrorResponses": {
						"shape": "S1n"
					},
					"Comment": {
						"type": "string",
						"sensitive": true
					},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"IncludeCookies",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"IncludeCookies": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					},
					"ViewerCertificate": {
						"shape": "S1t"
					},
					"Restrictions": {
						"shape": "S1x"
					},
					"WebACLId": {},
					"HttpVersion": {},
					"IsIPV6Enabled": {
						"type": "boolean"
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CNAME"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Origin",
							"type": "structure",
							"required": [
								"Id",
								"DomainName"
							],
							"members": {
								"Id": {},
								"DomainName": {},
								"OriginPath": {},
								"CustomHeaders": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginCustomHeader",
												"type": "structure",
												"required": [
													"HeaderName",
													"HeaderValue"
												],
												"members": {
													"HeaderName": {},
													"HeaderValue": {}
												}
											}
										}
									}
								},
								"S3OriginConfig": {
									"type": "structure",
									"required": [
										"OriginAccessIdentity"
									],
									"members": {
										"OriginAccessIdentity": {}
									}
								},
								"CustomOriginConfig": {
									"type": "structure",
									"required": [
										"HTTPPort",
										"HTTPSPort",
										"OriginProtocolPolicy"
									],
									"members": {
										"HTTPPort": {
											"type": "integer"
										},
										"HTTPSPort": {
											"type": "integer"
										},
										"OriginProtocolPolicy": {},
										"OriginSslProtocols": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "SslProtocol"
													}
												}
											}
										},
										"OriginReadTimeout": {
											"type": "integer"
										},
										"OriginKeepaliveTimeout": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "OriginGroup",
							"type": "structure",
							"required": [
								"Id",
								"FailoverCriteria",
								"Members"
							],
							"members": {
								"Id": {},
								"FailoverCriteria": {
									"type": "structure",
									"required": [
										"StatusCodes"
									],
									"members": {
										"StatusCodes": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "StatusCode",
														"type": "integer"
													}
												}
											}
										}
									}
								},
								"Members": {
									"type": "structure",
									"required": [
										"Quantity",
										"Items"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginGroupMember",
												"type": "structure",
												"required": [
													"OriginId"
												],
												"members": {
													"OriginId": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"Sw": {
				"type": "structure",
				"required": [
					"TargetOriginId",
					"ForwardedValues",
					"TrustedSigners",
					"ViewerProtocolPolicy",
					"MinTTL"
				],
				"members": {
					"TargetOriginId": {},
					"ForwardedValues": {
						"shape": "Sx"
					},
					"TrustedSigners": {
						"shape": "S17"
					},
					"ViewerProtocolPolicy": {},
					"MinTTL": {
						"type": "long"
					},
					"AllowedMethods": {
						"shape": "S1b"
					},
					"SmoothStreaming": {
						"type": "boolean"
					},
					"DefaultTTL": {
						"type": "long"
					},
					"MaxTTL": {
						"type": "long"
					},
					"Compress": {
						"type": "boolean"
					},
					"LambdaFunctionAssociations": {
						"shape": "S1f"
					},
					"FieldLevelEncryptionId": {}
				}
			},
			"Sx": {
				"type": "structure",
				"required": [
					"QueryString",
					"Cookies"
				],
				"members": {
					"QueryString": {
						"type": "boolean"
					},
					"Cookies": {
						"type": "structure",
						"required": [
							"Forward"
						],
						"members": {
							"Forward": {},
							"WhitelistedNames": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "Name"
										}
									}
								}
							}
						}
					},
					"Headers": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					},
					"QueryStringCacheKeys": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					}
				}
			},
			"S17": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "AwsAccountNumber"
						}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"shape": "S1c"
					},
					"CachedMethods": {
						"type": "structure",
						"required": [
							"Quantity",
							"Items"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"shape": "S1c"
							}
						}
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {
					"locationName": "Method"
				}
			},
			"S1f": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "LambdaFunctionAssociation",
							"type": "structure",
							"required": [
								"LambdaFunctionARN",
								"EventType"
							],
							"members": {
								"LambdaFunctionARN": {},
								"EventType": {},
								"IncludeBody": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"S1k": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CacheBehavior",
							"type": "structure",
							"required": [
								"PathPattern",
								"TargetOriginId",
								"ForwardedValues",
								"TrustedSigners",
								"ViewerProtocolPolicy",
								"MinTTL"
							],
							"members": {
								"PathPattern": {},
								"TargetOriginId": {},
								"ForwardedValues": {
									"shape": "Sx"
								},
								"TrustedSigners": {
									"shape": "S17"
								},
								"ViewerProtocolPolicy": {},
								"MinTTL": {
									"type": "long"
								},
								"AllowedMethods": {
									"shape": "S1b"
								},
								"SmoothStreaming": {
									"type": "boolean"
								},
								"DefaultTTL": {
									"type": "long"
								},
								"MaxTTL": {
									"type": "long"
								},
								"Compress": {
									"type": "boolean"
								},
								"LambdaFunctionAssociations": {
									"shape": "S1f"
								},
								"FieldLevelEncryptionId": {}
							}
						}
					}
				}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CustomErrorResponse",
							"type": "structure",
							"required": [
								"ErrorCode"
							],
							"members": {
								"ErrorCode": {
									"type": "integer"
								},
								"ResponsePagePath": {},
								"ResponseCode": {},
								"ErrorCachingMinTTL": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S1t": {
				"type": "structure",
				"members": {
					"CloudFrontDefaultCertificate": {
						"type": "boolean"
					},
					"IAMCertificateId": {},
					"ACMCertificateArn": {},
					"SSLSupportMethod": {},
					"MinimumProtocolVersion": {},
					"Certificate": {
						"deprecated": true
					},
					"CertificateSource": {
						"deprecated": true
					}
				}
			},
			"S1x": {
				"type": "structure",
				"required": [
					"GeoRestriction"
				],
				"members": {
					"GeoRestriction": {
						"type": "structure",
						"required": [
							"RestrictionType",
							"Quantity"
						],
						"members": {
							"RestrictionType": {},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Location"
								}
							}
						}
					}
				}
			},
			"S23": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"LastModifiedTime",
					"InProgressInvalidationBatches",
					"DomainName",
					"ActiveTrustedSigners",
					"DistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"InProgressInvalidationBatches": {
						"type": "integer"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S25"
					},
					"DistributionConfig": {
						"shape": "S7"
					},
					"AliasICPRecordals": {
						"shape": "S2a"
					}
				}
			},
			"S25": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Signer",
							"type": "structure",
							"members": {
								"AwsAccountNumber": {},
								"KeyPairIds": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "KeyPairId"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S2a": {
				"type": "list",
				"member": {
					"locationName": "AliasICPRecordal",
					"type": "structure",
					"members": {
						"CNAME": {},
						"ICPRecordalStatus": {}
					}
				}
			},
			"S2f": {
				"type": "structure",
				"members": {
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Tag",
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S2m": {
				"type": "structure",
				"required": [
					"CallerReference"
				],
				"members": {
					"CallerReference": {},
					"Comment": {},
					"QueryArgProfileConfig": {
						"shape": "S2n"
					},
					"ContentTypeProfileConfig": {
						"shape": "S2r"
					}
				}
			},
			"S2n": {
				"type": "structure",
				"required": [
					"ForwardWhenQueryArgProfileIsUnknown"
				],
				"members": {
					"ForwardWhenQueryArgProfileIsUnknown": {
						"type": "boolean"
					},
					"QueryArgProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "QueryArgProfile",
									"type": "structure",
									"required": [
										"QueryArg",
										"ProfileId"
									],
									"members": {
										"QueryArg": {},
										"ProfileId": {}
									}
								}
							}
						}
					}
				}
			},
			"S2r": {
				"type": "structure",
				"required": [
					"ForwardWhenContentTypeIsUnknown"
				],
				"members": {
					"ForwardWhenContentTypeIsUnknown": {
						"type": "boolean"
					},
					"ContentTypeProfiles": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "ContentTypeProfile",
									"type": "structure",
									"required": [
										"Format",
										"ContentType"
									],
									"members": {
										"Format": {},
										"ProfileId": {},
										"ContentType": {}
									}
								}
							}
						}
					}
				}
			},
			"S2x": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionConfig": {
						"shape": "S2m"
					}
				}
			},
			"S2z": {
				"type": "structure",
				"required": [
					"Name",
					"CallerReference",
					"EncryptionEntities"
				],
				"members": {
					"Name": {},
					"CallerReference": {},
					"Comment": {},
					"EncryptionEntities": {
						"shape": "S30"
					}
				}
			},
			"S30": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "EncryptionEntity",
							"type": "structure",
							"required": [
								"PublicKeyId",
								"ProviderId",
								"FieldPatterns"
							],
							"members": {
								"PublicKeyId": {},
								"ProviderId": {},
								"FieldPatterns": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "FieldPattern"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S36": {
				"type": "structure",
				"required": [
					"Id",
					"LastModifiedTime",
					"FieldLevelEncryptionProfileConfig"
				],
				"members": {
					"Id": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"FieldLevelEncryptionProfileConfig": {
						"shape": "S2z"
					}
				}
			},
			"S38": {
				"type": "structure",
				"required": [
					"Paths",
					"CallerReference"
				],
				"members": {
					"Paths": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Path"
								}
							}
						}
					},
					"CallerReference": {}
				}
			},
			"S3c": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"CreateTime",
					"InvalidationBatch"
				],
				"members": {
					"Id": {},
					"Status": {},
					"CreateTime": {
						"type": "timestamp"
					},
					"InvalidationBatch": {
						"shape": "S38"
					}
				}
			},
			"S3e": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Name",
					"EncodedKey"
				],
				"members": {
					"CallerReference": {},
					"Name": {},
					"EncodedKey": {},
					"Comment": {}
				}
			},
			"S3g": {
				"type": "structure",
				"required": [
					"Id",
					"CreatedTime",
					"PublicKeyConfig"
				],
				"members": {
					"Id": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"PublicKeyConfig": {
						"shape": "S3e"
					}
				}
			},
			"S3i": {
				"type": "structure",
				"required": [
					"CallerReference",
					"S3Origin",
					"Comment",
					"TrustedSigners",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"S3Origin": {
						"shape": "S3j"
					},
					"Aliases": {
						"shape": "S8"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"TrustedSigners": {
						"shape": "S17"
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S3j": {
				"type": "structure",
				"required": [
					"DomainName",
					"OriginAccessIdentity"
				],
				"members": {
					"DomainName": {},
					"OriginAccessIdentity": {}
				}
			},
			"S3m": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"DomainName",
					"ActiveTrustedSigners",
					"StreamingDistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S25"
					},
					"StreamingDistributionConfig": {
						"shape": "S3i"
					}
				}
			},
			"S4t": {
				"type": "structure",
				"required": [
					"Marker",
					"MaxItems",
					"IsTruncated",
					"Quantity"
				],
				"members": {
					"Marker": {},
					"NextMarker": {},
					"MaxItems": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "DistributionSummary",
							"type": "structure",
							"required": [
								"Id",
								"ARN",
								"Status",
								"LastModifiedTime",
								"DomainName",
								"Aliases",
								"Origins",
								"DefaultCacheBehavior",
								"CacheBehaviors",
								"CustomErrorResponses",
								"Comment",
								"PriceClass",
								"Enabled",
								"ViewerCertificate",
								"Restrictions",
								"WebACLId",
								"HttpVersion",
								"IsIPV6Enabled"
							],
							"members": {
								"Id": {},
								"ARN": {},
								"Status": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"DomainName": {},
								"Aliases": {
									"shape": "S8"
								},
								"Origins": {
									"shape": "Sb"
								},
								"OriginGroups": {
									"shape": "Sn"
								},
								"DefaultCacheBehavior": {
									"shape": "Sw"
								},
								"CacheBehaviors": {
									"shape": "S1k"
								},
								"CustomErrorResponses": {
									"shape": "S1n"
								},
								"Comment": {},
								"PriceClass": {},
								"Enabled": {
									"type": "boolean"
								},
								"ViewerCertificate": {
									"shape": "S1t"
								},
								"Restrictions": {
									"shape": "S1x"
								},
								"WebACLId": {},
								"HttpVersion": {},
								"IsIPV6Enabled": {
									"type": "boolean"
								},
								"AliasICPRecordals": {
									"shape": "S2a"
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1678 */
1666,
/* 1679 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DistributionDeployed": {
				"delay": 60,
				"operation": "GetDistribution",
				"maxAttempts": 35,
				"description": "Wait until a distribution is deployed.",
				"acceptors": [
					{
						"expected": "Deployed",
						"matcher": "path",
						"state": "success",
						"argument": "Distribution.Status"
					}
				]
			},
			"InvalidationCompleted": {
				"delay": 20,
				"operation": "GetInvalidation",
				"maxAttempts": 30,
				"description": "Wait until an invalidation has completed.",
				"acceptors": [
					{
						"expected": "Completed",
						"matcher": "path",
						"state": "success",
						"argument": "Invalidation.Status"
					}
				]
			},
			"StreamingDistributionDeployed": {
				"delay": 60,
				"operation": "GetStreamingDistribution",
				"maxAttempts": 25,
				"description": "Wait until a streaming distribution is deployed.",
				"acceptors": [
					{
						"expected": "Deployed",
						"matcher": "path",
						"state": "success",
						"argument": "StreamingDistribution.Status"
					}
				]
			}
		}
	};

/***/ },
/* 1680 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-05-30",
			"endpointPrefix": "cloudhsm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CloudHSM",
			"serviceFullName": "Amazon CloudHSM",
			"serviceId": "CloudHSM",
			"signatureVersion": "v4",
			"targetPrefix": "CloudHsmFrontendService",
			"uid": "cloudhsm-2014-05-30"
		},
		"operations": {
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagList"
					],
					"members": {
						"ResourceArn": {},
						"TagList": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"CreateHapg": {
				"input": {
					"type": "structure",
					"required": [
						"Label"
					],
					"members": {
						"Label": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HapgArn": {}
					}
				}
			},
			"CreateHsm": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId",
						"SshKey",
						"IamRoleArn",
						"SubscriptionType"
					],
					"members": {
						"SubnetId": {
							"locationName": "SubnetId"
						},
						"SshKey": {
							"locationName": "SshKey"
						},
						"EniIp": {
							"locationName": "EniIp"
						},
						"IamRoleArn": {
							"locationName": "IamRoleArn"
						},
						"ExternalId": {
							"locationName": "ExternalId"
						},
						"SubscriptionType": {
							"locationName": "SubscriptionType"
						},
						"ClientToken": {
							"locationName": "ClientToken"
						},
						"SyslogIp": {
							"locationName": "SyslogIp"
						}
					},
					"locationName": "CreateHsmRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmArn": {}
					}
				}
			},
			"CreateLunaClient": {
				"input": {
					"type": "structure",
					"required": [
						"Certificate"
					],
					"members": {
						"Label": {},
						"Certificate": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientArn": {}
					}
				}
			},
			"DeleteHapg": {
				"input": {
					"type": "structure",
					"required": [
						"HapgArn"
					],
					"members": {
						"HapgArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"DeleteHsm": {
				"input": {
					"type": "structure",
					"required": [
						"HsmArn"
					],
					"members": {
						"HsmArn": {
							"locationName": "HsmArn"
						}
					},
					"locationName": "DeleteHsmRequest"
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"DeleteLunaClient": {
				"input": {
					"type": "structure",
					"required": [
						"ClientArn"
					],
					"members": {
						"ClientArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"DescribeHapg": {
				"input": {
					"type": "structure",
					"required": [
						"HapgArn"
					],
					"members": {
						"HapgArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HapgArn": {},
						"HapgSerial": {},
						"HsmsLastActionFailed": {
							"shape": "Sz"
						},
						"HsmsPendingDeletion": {
							"shape": "Sz"
						},
						"HsmsPendingRegistration": {
							"shape": "Sz"
						},
						"Label": {},
						"LastModifiedTimestamp": {},
						"PartitionSerialList": {
							"shape": "S11"
						},
						"State": {}
					}
				}
			},
			"DescribeHsm": {
				"input": {
					"type": "structure",
					"members": {
						"HsmArn": {},
						"HsmSerialNumber": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmArn": {},
						"Status": {},
						"StatusDetails": {},
						"AvailabilityZone": {},
						"EniId": {},
						"EniIp": {},
						"SubscriptionType": {},
						"SubscriptionStartDate": {},
						"SubscriptionEndDate": {},
						"VpcId": {},
						"SubnetId": {},
						"IamRoleArn": {},
						"SerialNumber": {},
						"VendorName": {},
						"HsmType": {},
						"SoftwareVersion": {},
						"SshPublicKey": {},
						"SshKeyLastUpdated": {},
						"ServerCertUri": {},
						"ServerCertLastUpdated": {},
						"Partitions": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"DescribeLunaClient": {
				"input": {
					"type": "structure",
					"members": {
						"ClientArn": {},
						"CertificateFingerprint": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientArn": {},
						"Certificate": {},
						"CertificateFingerprint": {},
						"LastModifiedTimestamp": {},
						"Label": {}
					}
				}
			},
			"GetConfig": {
				"input": {
					"type": "structure",
					"required": [
						"ClientArn",
						"ClientVersion",
						"HapgList"
					],
					"members": {
						"ClientArn": {},
						"ClientVersion": {},
						"HapgList": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigType": {},
						"ConfigFile": {},
						"ConfigCred": {}
					}
				}
			},
			"ListAvailableZones": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AZList": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ListHapgs": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HapgList"
					],
					"members": {
						"HapgList": {
							"shape": "S1i"
						},
						"NextToken": {}
					}
				}
			},
			"ListHsms": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmList": {
							"shape": "Sz"
						},
						"NextToken": {}
					}
				}
			},
			"ListLunaClients": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ClientList"
					],
					"members": {
						"ClientList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagList"
					],
					"members": {
						"TagList": {
							"shape": "S3"
						}
					}
				}
			},
			"ModifyHapg": {
				"input": {
					"type": "structure",
					"required": [
						"HapgArn"
					],
					"members": {
						"HapgArn": {},
						"Label": {},
						"PartitionSerialList": {
							"shape": "S11"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HapgArn": {}
					}
				}
			},
			"ModifyHsm": {
				"input": {
					"type": "structure",
					"required": [
						"HsmArn"
					],
					"members": {
						"HsmArn": {
							"locationName": "HsmArn"
						},
						"SubnetId": {
							"locationName": "SubnetId"
						},
						"EniIp": {
							"locationName": "EniIp"
						},
						"IamRoleArn": {
							"locationName": "IamRoleArn"
						},
						"ExternalId": {
							"locationName": "ExternalId"
						},
						"SyslogIp": {
							"locationName": "SyslogIp"
						}
					},
					"locationName": "ModifyHsmRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmArn": {}
					}
				}
			},
			"ModifyLunaClient": {
				"input": {
					"type": "structure",
					"required": [
						"ClientArn",
						"Certificate"
					],
					"members": {
						"ClientArn": {},
						"Certificate": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientArn": {}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeyList"
					],
					"members": {
						"ResourceArn": {},
						"TagKeyList": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {}
			},
			"S11": {
				"type": "list",
				"member": {}
			},
			"S1i": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1681 */
1641,
/* 1682 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-11-01",
			"endpointPrefix": "cloudtrail",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CloudTrail",
			"serviceFullName": "AWS CloudTrail",
			"serviceId": "CloudTrail",
			"signatureVersion": "v4",
			"targetPrefix": "com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101",
			"uid": "cloudtrail-2013-11-01"
		},
		"operations": {
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"ResourceId": {},
						"TagsList": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"CreateTrail": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"S3BucketName"
					],
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"EnableLogFileValidation": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {},
						"IsOrganizationTrail": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {
							"deprecated": true
						},
						"SnsTopicARN": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"TrailARN": {},
						"LogFileValidationEnabled": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {},
						"IsOrganizationTrail": {
							"type": "boolean"
						}
					}
				},
				"idempotent": true
			},
			"DeleteTrail": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"DescribeTrails": {
				"input": {
					"type": "structure",
					"members": {
						"trailNameList": {
							"type": "list",
							"member": {}
						},
						"includeShadowTrails": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"trailList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"S3BucketName": {},
									"S3KeyPrefix": {},
									"SnsTopicName": {
										"deprecated": true
									},
									"SnsTopicARN": {},
									"IncludeGlobalServiceEvents": {
										"type": "boolean"
									},
									"IsMultiRegionTrail": {
										"type": "boolean"
									},
									"HomeRegion": {},
									"TrailARN": {},
									"LogFileValidationEnabled": {
										"type": "boolean"
									},
									"CloudWatchLogsLogGroupArn": {},
									"CloudWatchLogsRoleArn": {},
									"KmsKeyId": {},
									"HasCustomEventSelectors": {
										"type": "boolean"
									},
									"IsOrganizationTrail": {
										"type": "boolean"
									}
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"GetEventSelectors": {
				"input": {
					"type": "structure",
					"required": [
						"TrailName"
					],
					"members": {
						"TrailName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrailARN": {},
						"EventSelectors": {
							"shape": "Si"
						}
					}
				},
				"idempotent": true
			},
			"GetTrailStatus": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsLogging": {
							"type": "boolean"
						},
						"LatestDeliveryError": {},
						"LatestNotificationError": {},
						"LatestDeliveryTime": {
							"type": "timestamp"
						},
						"LatestNotificationTime": {
							"type": "timestamp"
						},
						"StartLoggingTime": {
							"type": "timestamp"
						},
						"StopLoggingTime": {
							"type": "timestamp"
						},
						"LatestCloudWatchLogsDeliveryError": {},
						"LatestCloudWatchLogsDeliveryTime": {
							"type": "timestamp"
						},
						"LatestDigestDeliveryTime": {
							"type": "timestamp"
						},
						"LatestDigestDeliveryError": {},
						"LatestDeliveryAttemptTime": {},
						"LatestNotificationAttemptTime": {},
						"LatestNotificationAttemptSucceeded": {},
						"LatestDeliveryAttemptSucceeded": {},
						"TimeLoggingStarted": {},
						"TimeLoggingStopped": {}
					}
				},
				"idempotent": true
			},
			"ListPublicKeys": {
				"input": {
					"type": "structure",
					"members": {
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Value": {
										"type": "blob"
									},
									"ValidityStartTime": {
										"type": "timestamp"
									},
									"ValidityEndTime": {
										"type": "timestamp"
									},
									"Fingerprint": {}
								}
							}
						},
						"NextToken": {}
					}
				},
				"idempotent": true
			},
			"ListTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceIdList"
					],
					"members": {
						"ResourceIdList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceTagList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceId": {},
									"TagsList": {
										"shape": "S3"
									}
								}
							}
						},
						"NextToken": {}
					}
				},
				"idempotent": true
			},
			"LookupEvents": {
				"input": {
					"type": "structure",
					"members": {
						"LookupAttributes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"AttributeKey",
									"AttributeValue"
								],
								"members": {
									"AttributeKey": {},
									"AttributeValue": {}
								}
							}
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"EventName": {},
									"ReadOnly": {},
									"AccessKeyId": {},
									"EventTime": {
										"type": "timestamp"
									},
									"EventSource": {},
									"Username": {},
									"Resources": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"ResourceType": {},
												"ResourceName": {}
											}
										}
									},
									"CloudTrailEvent": {}
								}
							}
						},
						"NextToken": {}
					}
				},
				"idempotent": true
			},
			"PutEventSelectors": {
				"input": {
					"type": "structure",
					"required": [
						"TrailName",
						"EventSelectors"
					],
					"members": {
						"TrailName": {},
						"EventSelectors": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrailARN": {},
						"EventSelectors": {
							"shape": "Si"
						}
					}
				},
				"idempotent": true
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"ResourceId": {},
						"TagsList": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"StartLogging": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"StopLogging": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"UpdateTrail": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"EnableLogFileValidation": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {},
						"IsOrganizationTrail": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {
							"deprecated": true
						},
						"SnsTopicARN": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"TrailARN": {},
						"LogFileValidationEnabled": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {},
						"IsOrganizationTrail": {
							"type": "boolean"
						}
					}
				},
				"idempotent": true
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ReadWriteType": {},
						"IncludeManagementEvents": {
							"type": "boolean"
						},
						"DataResources": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1683 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeTrails": {
				"result_key": "trailList"
			},
			"LookupEvents": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Events"
			}
		}
	};

/***/ },
/* 1684 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-10-06",
			"endpointPrefix": "codebuild",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS CodeBuild",
			"serviceId": "CodeBuild",
			"signatureVersion": "v4",
			"targetPrefix": "CodeBuild_20161006",
			"uid": "codebuild-2016-10-06"
		},
		"operations": {
			"BatchDeleteBuilds": {
				"input": {
					"type": "structure",
					"required": [
						"ids"
					],
					"members": {
						"ids": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"buildsDeleted": {
							"shape": "S2"
						},
						"buildsNotDeleted": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"id": {},
									"statusCode": {}
								}
							}
						}
					}
				}
			},
			"BatchGetBuilds": {
				"input": {
					"type": "structure",
					"required": [
						"ids"
					],
					"members": {
						"ids": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"builds": {
							"type": "list",
							"member": {
								"shape": "Sb"
							}
						},
						"buildsNotFound": {
							"shape": "S2"
						}
					}
				}
			},
			"BatchGetProjects": {
				"input": {
					"type": "structure",
					"required": [
						"names"
					],
					"members": {
						"names": {
							"shape": "S1k"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"projects": {
							"type": "list",
							"member": {
								"shape": "S1n"
							}
						},
						"projectsNotFound": {
							"shape": "S1k"
						}
					}
				}
			},
			"CreateProject": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"source",
						"artifacts",
						"environment",
						"serviceRole"
					],
					"members": {
						"name": {},
						"description": {},
						"source": {
							"shape": "Sk"
						},
						"secondarySources": {
							"shape": "Sr"
						},
						"sourceVersion": {},
						"secondarySourceVersions": {
							"shape": "Ss"
						},
						"artifacts": {
							"shape": "S1q"
						},
						"secondaryArtifacts": {
							"shape": "S1u"
						},
						"cache": {
							"shape": "Sw"
						},
						"environment": {
							"shape": "S10"
						},
						"serviceRole": {},
						"timeoutInMinutes": {
							"type": "integer"
						},
						"queuedTimeoutInMinutes": {
							"type": "integer"
						},
						"encryptionKey": {},
						"tags": {
							"shape": "S1w"
						},
						"vpcConfig": {
							"shape": "S1f"
						},
						"badgeEnabled": {
							"type": "boolean"
						},
						"logsConfig": {
							"shape": "S26"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "S1n"
						}
					}
				}
			},
			"CreateWebhook": {
				"input": {
					"type": "structure",
					"required": [
						"projectName"
					],
					"members": {
						"projectName": {},
						"branchFilter": {},
						"filterGroups": {
							"shape": "S21"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"webhook": {
							"shape": "S20"
						}
					}
				}
			},
			"DeleteProject": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteSourceCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"arn": {}
					}
				}
			},
			"DeleteWebhook": {
				"input": {
					"type": "structure",
					"required": [
						"projectName"
					],
					"members": {
						"projectName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ImportSourceCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"token",
						"serverType",
						"authType"
					],
					"members": {
						"username": {},
						"token": {
							"type": "string",
							"sensitive": true
						},
						"serverType": {},
						"authType": {},
						"shouldOverwrite": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"arn": {}
					}
				}
			},
			"InvalidateProjectCache": {
				"input": {
					"type": "structure",
					"required": [
						"projectName"
					],
					"members": {
						"projectName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ListBuilds": {
				"input": {
					"type": "structure",
					"members": {
						"sortOrder": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ids": {
							"shape": "S2"
						},
						"nextToken": {}
					}
				}
			},
			"ListBuildsForProject": {
				"input": {
					"type": "structure",
					"required": [
						"projectName"
					],
					"members": {
						"projectName": {},
						"sortOrder": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ids": {
							"shape": "S2"
						},
						"nextToken": {}
					}
				}
			},
			"ListCuratedEnvironmentImages": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"platforms": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"platform": {},
									"languages": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"language": {},
												"images": {
													"type": "list",
													"member": {
														"type": "structure",
														"members": {
															"name": {},
															"description": {},
															"versions": {
																"type": "list",
																"member": {}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"ListProjects": {
				"input": {
					"type": "structure",
					"members": {
						"sortBy": {},
						"sortOrder": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"projects": {
							"shape": "S1k"
						}
					}
				}
			},
			"ListSourceCredentials": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"sourceCredentialsInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"arn": {},
									"serverType": {},
									"authType": {}
								}
							}
						}
					}
				}
			},
			"StartBuild": {
				"input": {
					"type": "structure",
					"required": [
						"projectName"
					],
					"members": {
						"projectName": {},
						"secondarySourcesOverride": {
							"shape": "Sr"
						},
						"secondarySourcesVersionOverride": {
							"shape": "Ss"
						},
						"sourceVersion": {},
						"artifactsOverride": {
							"shape": "S1q"
						},
						"secondaryArtifactsOverride": {
							"shape": "S1u"
						},
						"environmentVariablesOverride": {
							"shape": "S13"
						},
						"sourceTypeOverride": {},
						"sourceLocationOverride": {},
						"sourceAuthOverride": {
							"shape": "Sp"
						},
						"gitCloneDepthOverride": {
							"type": "integer"
						},
						"gitSubmodulesConfigOverride": {
							"shape": "Sn"
						},
						"buildspecOverride": {},
						"insecureSslOverride": {
							"type": "boolean"
						},
						"reportBuildStatusOverride": {
							"type": "boolean"
						},
						"environmentTypeOverride": {},
						"imageOverride": {},
						"computeTypeOverride": {},
						"certificateOverride": {},
						"cacheOverride": {
							"shape": "Sw"
						},
						"serviceRoleOverride": {},
						"privilegedModeOverride": {
							"type": "boolean"
						},
						"timeoutInMinutesOverride": {
							"type": "integer"
						},
						"queuedTimeoutInMinutesOverride": {
							"type": "integer"
						},
						"idempotencyToken": {},
						"logsConfigOverride": {
							"shape": "S26"
						},
						"registryCredentialOverride": {
							"shape": "S16"
						},
						"imagePullCredentialsTypeOverride": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"build": {
							"shape": "Sb"
						}
					}
				}
			},
			"StopBuild": {
				"input": {
					"type": "structure",
					"required": [
						"id"
					],
					"members": {
						"id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"build": {
							"shape": "Sb"
						}
					}
				}
			},
			"UpdateProject": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"description": {},
						"source": {
							"shape": "Sk"
						},
						"secondarySources": {
							"shape": "Sr"
						},
						"sourceVersion": {},
						"secondarySourceVersions": {
							"shape": "Ss"
						},
						"artifacts": {
							"shape": "S1q"
						},
						"secondaryArtifacts": {
							"shape": "S1u"
						},
						"cache": {
							"shape": "Sw"
						},
						"environment": {
							"shape": "S10"
						},
						"serviceRole": {},
						"timeoutInMinutes": {
							"type": "integer"
						},
						"queuedTimeoutInMinutes": {
							"type": "integer"
						},
						"encryptionKey": {},
						"tags": {
							"shape": "S1w"
						},
						"vpcConfig": {
							"shape": "S1f"
						},
						"badgeEnabled": {
							"type": "boolean"
						},
						"logsConfig": {
							"shape": "S26"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "S1n"
						}
					}
				}
			},
			"UpdateWebhook": {
				"input": {
					"type": "structure",
					"required": [
						"projectName"
					],
					"members": {
						"projectName": {},
						"branchFilter": {},
						"rotateSecret": {
							"type": "boolean"
						},
						"filterGroups": {
							"shape": "S21"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"webhook": {
							"shape": "S20"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"id": {},
					"arn": {},
					"startTime": {
						"type": "timestamp"
					},
					"endTime": {
						"type": "timestamp"
					},
					"currentPhase": {},
					"buildStatus": {},
					"sourceVersion": {},
					"resolvedSourceVersion": {},
					"projectName": {},
					"phases": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"phaseType": {},
								"phaseStatus": {},
								"startTime": {
									"type": "timestamp"
								},
								"endTime": {
									"type": "timestamp"
								},
								"durationInSeconds": {
									"type": "long"
								},
								"contexts": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"statusCode": {},
											"message": {}
										}
									}
								}
							}
						}
					},
					"source": {
						"shape": "Sk"
					},
					"secondarySources": {
						"shape": "Sr"
					},
					"secondarySourceVersions": {
						"shape": "Ss"
					},
					"artifacts": {
						"shape": "Su"
					},
					"secondaryArtifacts": {
						"type": "list",
						"member": {
							"shape": "Su"
						}
					},
					"cache": {
						"shape": "Sw"
					},
					"environment": {
						"shape": "S10"
					},
					"serviceRole": {},
					"logs": {
						"type": "structure",
						"members": {
							"groupName": {},
							"streamName": {},
							"deepLink": {},
							"s3DeepLink": {},
							"cloudWatchLogs": {
								"shape": "S1a"
							},
							"s3Logs": {
								"shape": "S1c"
							}
						}
					},
					"timeoutInMinutes": {
						"type": "integer"
					},
					"queuedTimeoutInMinutes": {
						"type": "integer"
					},
					"buildComplete": {
						"type": "boolean"
					},
					"initiator": {},
					"vpcConfig": {
						"shape": "S1f"
					},
					"networkInterface": {
						"type": "structure",
						"members": {
							"subnetId": {},
							"networkInterfaceId": {}
						}
					},
					"encryptionKey": {}
				}
			},
			"Sk": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"location": {},
					"gitCloneDepth": {
						"type": "integer"
					},
					"gitSubmodulesConfig": {
						"shape": "Sn"
					},
					"buildspec": {},
					"auth": {
						"shape": "Sp"
					},
					"reportBuildStatus": {
						"type": "boolean"
					},
					"insecureSsl": {
						"type": "boolean"
					},
					"sourceIdentifier": {}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"fetchSubmodules"
				],
				"members": {
					"fetchSubmodules": {
						"type": "boolean"
					}
				}
			},
			"Sp": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"resource": {}
				}
			},
			"Sr": {
				"type": "list",
				"member": {
					"shape": "Sk"
				}
			},
			"Ss": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"sourceIdentifier",
						"sourceVersion"
					],
					"members": {
						"sourceIdentifier": {},
						"sourceVersion": {}
					}
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"location": {},
					"sha256sum": {},
					"md5sum": {},
					"overrideArtifactName": {
						"type": "boolean"
					},
					"encryptionDisabled": {
						"type": "boolean"
					},
					"artifactIdentifier": {}
				}
			},
			"Sw": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"location": {},
					"modes": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S10": {
				"type": "structure",
				"required": [
					"type",
					"image",
					"computeType"
				],
				"members": {
					"type": {},
					"image": {},
					"computeType": {},
					"environmentVariables": {
						"shape": "S13"
					},
					"privilegedMode": {
						"type": "boolean"
					},
					"certificate": {},
					"registryCredential": {
						"shape": "S16"
					},
					"imagePullCredentialsType": {}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"name",
						"value"
					],
					"members": {
						"name": {},
						"value": {},
						"type": {}
					}
				}
			},
			"S16": {
				"type": "structure",
				"required": [
					"credential",
					"credentialProvider"
				],
				"members": {
					"credential": {},
					"credentialProvider": {}
				}
			},
			"S1a": {
				"type": "structure",
				"required": [
					"status"
				],
				"members": {
					"status": {},
					"groupName": {},
					"streamName": {}
				}
			},
			"S1c": {
				"type": "structure",
				"required": [
					"status"
				],
				"members": {
					"status": {},
					"location": {},
					"encryptionDisabled": {
						"type": "boolean"
					}
				}
			},
			"S1f": {
				"type": "structure",
				"members": {
					"vpcId": {},
					"subnets": {
						"type": "list",
						"member": {}
					},
					"securityGroupIds": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S1k": {
				"type": "list",
				"member": {}
			},
			"S1n": {
				"type": "structure",
				"members": {
					"name": {},
					"arn": {},
					"description": {},
					"source": {
						"shape": "Sk"
					},
					"secondarySources": {
						"shape": "Sr"
					},
					"sourceVersion": {},
					"secondarySourceVersions": {
						"shape": "Ss"
					},
					"artifacts": {
						"shape": "S1q"
					},
					"secondaryArtifacts": {
						"shape": "S1u"
					},
					"cache": {
						"shape": "Sw"
					},
					"environment": {
						"shape": "S10"
					},
					"serviceRole": {},
					"timeoutInMinutes": {
						"type": "integer"
					},
					"queuedTimeoutInMinutes": {
						"type": "integer"
					},
					"encryptionKey": {},
					"tags": {
						"shape": "S1w"
					},
					"created": {
						"type": "timestamp"
					},
					"lastModified": {
						"type": "timestamp"
					},
					"webhook": {
						"shape": "S20"
					},
					"vpcConfig": {
						"shape": "S1f"
					},
					"badge": {
						"type": "structure",
						"members": {
							"badgeEnabled": {
								"type": "boolean"
							},
							"badgeRequestUrl": {}
						}
					},
					"logsConfig": {
						"shape": "S26"
					}
				}
			},
			"S1q": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"location": {},
					"path": {},
					"namespaceType": {},
					"name": {},
					"packaging": {},
					"overrideArtifactName": {
						"type": "boolean"
					},
					"encryptionDisabled": {
						"type": "boolean"
					},
					"artifactIdentifier": {}
				}
			},
			"S1u": {
				"type": "list",
				"member": {
					"shape": "S1q"
				}
			},
			"S1w": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"S20": {
				"type": "structure",
				"members": {
					"url": {},
					"payloadUrl": {},
					"secret": {},
					"branchFilter": {},
					"filterGroups": {
						"shape": "S21"
					},
					"lastModifiedSecret": {
						"type": "timestamp"
					}
				}
			},
			"S21": {
				"type": "list",
				"member": {
					"type": "list",
					"member": {
						"type": "structure",
						"required": [
							"type",
							"pattern"
						],
						"members": {
							"type": {},
							"pattern": {},
							"excludeMatchedPattern": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"S26": {
				"type": "structure",
				"members": {
					"cloudWatchLogs": {
						"shape": "S1a"
					},
					"s3Logs": {
						"shape": "S1c"
					}
				}
			}
		}
	};

/***/ },
/* 1685 */
1641,
/* 1686 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-04-13",
			"endpointPrefix": "codecommit",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CodeCommit",
			"serviceFullName": "AWS CodeCommit",
			"serviceId": "CodeCommit",
			"signatureVersion": "v4",
			"targetPrefix": "CodeCommit_20150413",
			"uid": "codecommit-2015-04-13"
		},
		"operations": {
			"BatchDescribeMergeConflicts": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"destinationCommitSpecifier",
						"sourceCommitSpecifier",
						"mergeOption"
					],
					"members": {
						"repositoryName": {},
						"destinationCommitSpecifier": {},
						"sourceCommitSpecifier": {},
						"mergeOption": {},
						"maxMergeHunks": {
							"type": "integer"
						},
						"maxConflictFiles": {
							"type": "integer"
						},
						"filePaths": {
							"type": "list",
							"member": {}
						},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"conflicts",
						"destinationCommitId",
						"sourceCommitId"
					],
					"members": {
						"conflicts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"conflictMetadata": {
										"shape": "Se"
									},
									"mergeHunks": {
										"shape": "St"
									}
								}
							}
						},
						"nextToken": {},
						"errors": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"filePath",
									"exceptionName",
									"message"
								],
								"members": {
									"filePath": {},
									"exceptionName": {},
									"message": {}
								}
							}
						},
						"destinationCommitId": {},
						"sourceCommitId": {},
						"baseCommitId": {}
					}
				}
			},
			"BatchGetRepositories": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryNames"
					],
					"members": {
						"repositoryNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositories": {
							"type": "list",
							"member": {
								"shape": "S18"
							}
						},
						"repositoriesNotFound": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"CreateBranch": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"branchName",
						"commitId"
					],
					"members": {
						"repositoryName": {},
						"branchName": {},
						"commitId": {}
					}
				}
			},
			"CreateCommit": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"branchName"
					],
					"members": {
						"repositoryName": {},
						"branchName": {},
						"parentCommitId": {},
						"authorName": {},
						"email": {},
						"commitMessage": {},
						"keepEmptyFolders": {
							"type": "boolean"
						},
						"putFiles": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"filePath"
								],
								"members": {
									"filePath": {},
									"fileMode": {},
									"fileContent": {
										"type": "blob"
									},
									"sourceFile": {
										"type": "structure",
										"required": [
											"filePath"
										],
										"members": {
											"filePath": {},
											"isMove": {
												"type": "boolean"
											}
										}
									}
								}
							}
						},
						"deleteFiles": {
							"shape": "S1u"
						},
						"setFileModes": {
							"shape": "S1w"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"commitId": {},
						"treeId": {},
						"filesAdded": {
							"shape": "S1z"
						},
						"filesUpdated": {
							"shape": "S1z"
						},
						"filesDeleted": {
							"shape": "S1z"
						}
					}
				}
			},
			"CreatePullRequest": {
				"input": {
					"type": "structure",
					"required": [
						"title",
						"targets"
					],
					"members": {
						"title": {},
						"description": {},
						"targets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"repositoryName",
									"sourceReference"
								],
								"members": {
									"repositoryName": {},
									"sourceReference": {},
									"destinationReference": {}
								}
							}
						},
						"clientRequestToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"pullRequest"
					],
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"CreateRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"repositoryDescription": {},
						"tags": {
							"shape": "S2h"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryMetadata": {
							"shape": "S18"
						}
					}
				}
			},
			"CreateUnreferencedMergeCommit": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"sourceCommitSpecifier",
						"destinationCommitSpecifier",
						"mergeOption"
					],
					"members": {
						"repositoryName": {},
						"sourceCommitSpecifier": {},
						"destinationCommitSpecifier": {},
						"mergeOption": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {},
						"authorName": {},
						"email": {},
						"commitMessage": {},
						"keepEmptyFolders": {
							"type": "boolean"
						},
						"conflictResolution": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"commitId": {},
						"treeId": {}
					}
				}
			},
			"DeleteBranch": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"branchName"
					],
					"members": {
						"repositoryName": {},
						"branchName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deletedBranch": {
							"shape": "S2t"
						}
					}
				}
			},
			"DeleteCommentContent": {
				"input": {
					"type": "structure",
					"required": [
						"commentId"
					],
					"members": {
						"commentId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"comment": {
							"shape": "S2x"
						}
					}
				}
			},
			"DeleteFile": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"branchName",
						"filePath",
						"parentCommitId"
					],
					"members": {
						"repositoryName": {},
						"branchName": {},
						"filePath": {},
						"parentCommitId": {},
						"keepEmptyFolders": {
							"type": "boolean"
						},
						"commitMessage": {},
						"name": {},
						"email": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"commitId",
						"blobId",
						"treeId",
						"filePath"
					],
					"members": {
						"commitId": {},
						"blobId": {},
						"treeId": {},
						"filePath": {}
					}
				}
			},
			"DeleteRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryId": {}
					}
				}
			},
			"DescribeMergeConflicts": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"destinationCommitSpecifier",
						"sourceCommitSpecifier",
						"mergeOption",
						"filePath"
					],
					"members": {
						"repositoryName": {},
						"destinationCommitSpecifier": {},
						"sourceCommitSpecifier": {},
						"mergeOption": {},
						"maxMergeHunks": {
							"type": "integer"
						},
						"filePath": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"conflictMetadata",
						"mergeHunks",
						"destinationCommitId",
						"sourceCommitId"
					],
					"members": {
						"conflictMetadata": {
							"shape": "Se"
						},
						"mergeHunks": {
							"shape": "St"
						},
						"nextToken": {},
						"destinationCommitId": {},
						"sourceCommitId": {},
						"baseCommitId": {}
					}
				}
			},
			"DescribePullRequestEvents": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId"
					],
					"members": {
						"pullRequestId": {},
						"pullRequestEventType": {},
						"actorArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"pullRequestEvents"
					],
					"members": {
						"pullRequestEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"pullRequestId": {},
									"eventDate": {
										"type": "timestamp"
									},
									"pullRequestEventType": {},
									"actorArn": {},
									"pullRequestCreatedEventMetadata": {
										"type": "structure",
										"members": {
											"repositoryName": {},
											"sourceCommitId": {},
											"destinationCommitId": {},
											"mergeBase": {}
										}
									},
									"pullRequestStatusChangedEventMetadata": {
										"type": "structure",
										"members": {
											"pullRequestStatus": {}
										}
									},
									"pullRequestSourceReferenceUpdatedEventMetadata": {
										"type": "structure",
										"members": {
											"repositoryName": {},
											"beforeCommitId": {},
											"afterCommitId": {},
											"mergeBase": {}
										}
									},
									"pullRequestMergedStateChangedEventMetadata": {
										"type": "structure",
										"members": {
											"repositoryName": {},
											"destinationReference": {},
											"mergeMetadata": {
												"shape": "S2e"
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetBlob": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"blobId"
					],
					"members": {
						"repositoryName": {},
						"blobId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"content"
					],
					"members": {
						"content": {
							"type": "blob"
						}
					}
				}
			},
			"GetBranch": {
				"input": {
					"type": "structure",
					"members": {
						"repositoryName": {},
						"branchName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"branch": {
							"shape": "S2t"
						}
					}
				}
			},
			"GetComment": {
				"input": {
					"type": "structure",
					"required": [
						"commentId"
					],
					"members": {
						"commentId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"comment": {
							"shape": "S2x"
						}
					}
				}
			},
			"GetCommentsForComparedCommit": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"afterCommitId"
					],
					"members": {
						"repositoryName": {},
						"beforeCommitId": {},
						"afterCommitId": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"commentsForComparedCommitData": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"repositoryName": {},
									"beforeCommitId": {},
									"afterCommitId": {},
									"beforeBlobId": {},
									"afterBlobId": {},
									"location": {
										"shape": "S3r"
									},
									"comments": {
										"shape": "S3u"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetCommentsForPullRequest": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId"
					],
					"members": {
						"pullRequestId": {},
						"repositoryName": {},
						"beforeCommitId": {},
						"afterCommitId": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"commentsForPullRequestData": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"pullRequestId": {},
									"repositoryName": {},
									"beforeCommitId": {},
									"afterCommitId": {},
									"beforeBlobId": {},
									"afterBlobId": {},
									"location": {
										"shape": "S3r"
									},
									"comments": {
										"shape": "S3u"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetCommit": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"commitId"
					],
					"members": {
						"repositoryName": {},
						"commitId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"commit"
					],
					"members": {
						"commit": {
							"type": "structure",
							"members": {
								"commitId": {},
								"treeId": {},
								"parents": {
									"type": "list",
									"member": {}
								},
								"message": {},
								"author": {
									"shape": "S43"
								},
								"committer": {
									"shape": "S43"
								},
								"additionalData": {}
							}
						}
					}
				}
			},
			"GetDifferences": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"afterCommitSpecifier"
					],
					"members": {
						"repositoryName": {},
						"beforeCommitSpecifier": {},
						"afterCommitSpecifier": {},
						"beforePath": {},
						"afterPath": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"differences": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"beforeBlob": {
										"shape": "S4b"
									},
									"afterBlob": {
										"shape": "S4b"
									},
									"changeType": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetFile": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"filePath"
					],
					"members": {
						"repositoryName": {},
						"commitSpecifier": {},
						"filePath": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"commitId",
						"blobId",
						"filePath",
						"fileMode",
						"fileSize",
						"fileContent"
					],
					"members": {
						"commitId": {},
						"blobId": {},
						"filePath": {},
						"fileMode": {},
						"fileSize": {
							"type": "long"
						},
						"fileContent": {
							"type": "blob"
						}
					}
				}
			},
			"GetFolder": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"folderPath"
					],
					"members": {
						"repositoryName": {},
						"commitSpecifier": {},
						"folderPath": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"commitId",
						"folderPath"
					],
					"members": {
						"commitId": {},
						"folderPath": {},
						"treeId": {},
						"subFolders": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"treeId": {},
									"absolutePath": {},
									"relativePath": {}
								}
							}
						},
						"files": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"blobId": {},
									"absolutePath": {},
									"relativePath": {},
									"fileMode": {}
								}
							}
						},
						"symbolicLinks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"blobId": {},
									"absolutePath": {},
									"relativePath": {},
									"fileMode": {}
								}
							}
						},
						"subModules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"commitId": {},
									"absolutePath": {},
									"relativePath": {}
								}
							}
						}
					}
				}
			},
			"GetMergeCommit": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"sourceCommitSpecifier",
						"destinationCommitSpecifier"
					],
					"members": {
						"repositoryName": {},
						"sourceCommitSpecifier": {},
						"destinationCommitSpecifier": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"sourceCommitId": {},
						"destinationCommitId": {},
						"baseCommitId": {},
						"mergedCommitId": {}
					}
				}
			},
			"GetMergeConflicts": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"destinationCommitSpecifier",
						"sourceCommitSpecifier",
						"mergeOption"
					],
					"members": {
						"repositoryName": {},
						"destinationCommitSpecifier": {},
						"sourceCommitSpecifier": {},
						"mergeOption": {},
						"conflictDetailLevel": {},
						"maxConflictFiles": {
							"type": "integer"
						},
						"conflictResolutionStrategy": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"mergeable",
						"destinationCommitId",
						"sourceCommitId",
						"conflictMetadataList"
					],
					"members": {
						"mergeable": {
							"type": "boolean"
						},
						"destinationCommitId": {},
						"sourceCommitId": {},
						"baseCommitId": {},
						"conflictMetadataList": {
							"type": "list",
							"member": {
								"shape": "Se"
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetMergeOptions": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"sourceCommitSpecifier",
						"destinationCommitSpecifier"
					],
					"members": {
						"repositoryName": {},
						"sourceCommitSpecifier": {},
						"destinationCommitSpecifier": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"mergeOptions",
						"sourceCommitId",
						"destinationCommitId",
						"baseCommitId"
					],
					"members": {
						"mergeOptions": {
							"type": "list",
							"member": {}
						},
						"sourceCommitId": {},
						"destinationCommitId": {},
						"baseCommitId": {}
					}
				}
			},
			"GetPullRequest": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId"
					],
					"members": {
						"pullRequestId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"pullRequest"
					],
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"GetRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryMetadata": {
							"shape": "S18"
						}
					}
				}
			},
			"GetRepositoryTriggers": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configurationId": {},
						"triggers": {
							"shape": "S56"
						}
					}
				}
			},
			"ListBranches": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"branches": {
							"shape": "S5a"
						},
						"nextToken": {}
					}
				}
			},
			"ListPullRequests": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"authorArn": {},
						"pullRequestStatus": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"pullRequestIds"
					],
					"members": {
						"pullRequestIds": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListRepositories": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"sortBy": {},
						"order": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositories": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"repositoryName": {},
									"repositoryId": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "S2h"
						},
						"nextToken": {}
					}
				}
			},
			"MergeBranchesByFastForward": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"sourceCommitSpecifier",
						"destinationCommitSpecifier"
					],
					"members": {
						"repositoryName": {},
						"sourceCommitSpecifier": {},
						"destinationCommitSpecifier": {},
						"targetBranch": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"commitId": {},
						"treeId": {}
					}
				}
			},
			"MergeBranchesBySquash": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"sourceCommitSpecifier",
						"destinationCommitSpecifier"
					],
					"members": {
						"repositoryName": {},
						"sourceCommitSpecifier": {},
						"destinationCommitSpecifier": {},
						"targetBranch": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {},
						"authorName": {},
						"email": {},
						"commitMessage": {},
						"keepEmptyFolders": {
							"type": "boolean"
						},
						"conflictResolution": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"commitId": {},
						"treeId": {}
					}
				}
			},
			"MergeBranchesByThreeWay": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"sourceCommitSpecifier",
						"destinationCommitSpecifier"
					],
					"members": {
						"repositoryName": {},
						"sourceCommitSpecifier": {},
						"destinationCommitSpecifier": {},
						"targetBranch": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {},
						"authorName": {},
						"email": {},
						"commitMessage": {},
						"keepEmptyFolders": {
							"type": "boolean"
						},
						"conflictResolution": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"commitId": {},
						"treeId": {}
					}
				}
			},
			"MergePullRequestByFastForward": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId",
						"repositoryName"
					],
					"members": {
						"pullRequestId": {},
						"repositoryName": {},
						"sourceCommitId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"MergePullRequestBySquash": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId",
						"repositoryName"
					],
					"members": {
						"pullRequestId": {},
						"repositoryName": {},
						"sourceCommitId": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {},
						"commitMessage": {},
						"authorName": {},
						"email": {},
						"keepEmptyFolders": {
							"type": "boolean"
						},
						"conflictResolution": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"MergePullRequestByThreeWay": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId",
						"repositoryName"
					],
					"members": {
						"pullRequestId": {},
						"repositoryName": {},
						"sourceCommitId": {},
						"conflictDetailLevel": {},
						"conflictResolutionStrategy": {},
						"commitMessage": {},
						"authorName": {},
						"email": {},
						"keepEmptyFolders": {
							"type": "boolean"
						},
						"conflictResolution": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"PostCommentForComparedCommit": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"afterCommitId",
						"content"
					],
					"members": {
						"repositoryName": {},
						"beforeCommitId": {},
						"afterCommitId": {},
						"location": {
							"shape": "S3r"
						},
						"content": {},
						"clientRequestToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryName": {},
						"beforeCommitId": {},
						"afterCommitId": {},
						"beforeBlobId": {},
						"afterBlobId": {},
						"location": {
							"shape": "S3r"
						},
						"comment": {
							"shape": "S2x"
						}
					}
				},
				"idempotent": true
			},
			"PostCommentForPullRequest": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId",
						"repositoryName",
						"beforeCommitId",
						"afterCommitId",
						"content"
					],
					"members": {
						"pullRequestId": {},
						"repositoryName": {},
						"beforeCommitId": {},
						"afterCommitId": {},
						"location": {
							"shape": "S3r"
						},
						"content": {},
						"clientRequestToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryName": {},
						"pullRequestId": {},
						"beforeCommitId": {},
						"afterCommitId": {},
						"beforeBlobId": {},
						"afterBlobId": {},
						"location": {
							"shape": "S3r"
						},
						"comment": {
							"shape": "S2x"
						}
					}
				},
				"idempotent": true
			},
			"PostCommentReply": {
				"input": {
					"type": "structure",
					"required": [
						"inReplyTo",
						"content"
					],
					"members": {
						"inReplyTo": {},
						"clientRequestToken": {
							"idempotencyToken": true
						},
						"content": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"comment": {
							"shape": "S2x"
						}
					}
				},
				"idempotent": true
			},
			"PutFile": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"branchName",
						"fileContent",
						"filePath"
					],
					"members": {
						"repositoryName": {},
						"branchName": {},
						"fileContent": {
							"type": "blob"
						},
						"filePath": {},
						"fileMode": {},
						"parentCommitId": {},
						"commitMessage": {},
						"name": {},
						"email": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"commitId",
						"blobId",
						"treeId"
					],
					"members": {
						"commitId": {},
						"blobId": {},
						"treeId": {}
					}
				}
			},
			"PutRepositoryTriggers": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"triggers"
					],
					"members": {
						"repositoryName": {},
						"triggers": {
							"shape": "S56"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configurationId": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "S2h"
						}
					}
				}
			},
			"TestRepositoryTriggers": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"triggers"
					],
					"members": {
						"repositoryName": {},
						"triggers": {
							"shape": "S56"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"successfulExecutions": {
							"type": "list",
							"member": {}
						},
						"failedExecutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"trigger": {},
									"failureMessage": {}
								}
							}
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {},
						"tagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"UpdateComment": {
				"input": {
					"type": "structure",
					"required": [
						"commentId",
						"content"
					],
					"members": {
						"commentId": {},
						"content": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"comment": {
							"shape": "S2x"
						}
					}
				}
			},
			"UpdateDefaultBranch": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"defaultBranchName"
					],
					"members": {
						"repositoryName": {},
						"defaultBranchName": {}
					}
				}
			},
			"UpdatePullRequestDescription": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId",
						"description"
					],
					"members": {
						"pullRequestId": {},
						"description": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"pullRequest"
					],
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"UpdatePullRequestStatus": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId",
						"pullRequestStatus"
					],
					"members": {
						"pullRequestId": {},
						"pullRequestStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"pullRequest"
					],
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"UpdatePullRequestTitle": {
				"input": {
					"type": "structure",
					"required": [
						"pullRequestId",
						"title"
					],
					"members": {
						"pullRequestId": {},
						"title": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"pullRequest"
					],
					"members": {
						"pullRequest": {
							"shape": "S29"
						}
					}
				}
			},
			"UpdateRepositoryDescription": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"repositoryDescription": {}
					}
				}
			},
			"UpdateRepositoryName": {
				"input": {
					"type": "structure",
					"required": [
						"oldName",
						"newName"
					],
					"members": {
						"oldName": {},
						"newName": {}
					}
				}
			}
		},
		"shapes": {
			"Se": {
				"type": "structure",
				"members": {
					"filePath": {},
					"fileSizes": {
						"type": "structure",
						"members": {
							"source": {
								"type": "long"
							},
							"destination": {
								"type": "long"
							},
							"base": {
								"type": "long"
							}
						}
					},
					"fileModes": {
						"type": "structure",
						"members": {
							"source": {},
							"destination": {},
							"base": {}
						}
					},
					"objectTypes": {
						"type": "structure",
						"members": {
							"source": {},
							"destination": {},
							"base": {}
						}
					},
					"numberOfConflicts": {
						"type": "integer"
					},
					"isBinaryFile": {
						"type": "structure",
						"members": {
							"source": {
								"type": "boolean"
							},
							"destination": {
								"type": "boolean"
							},
							"base": {
								"type": "boolean"
							}
						}
					},
					"contentConflict": {
						"type": "boolean"
					},
					"fileModeConflict": {
						"type": "boolean"
					},
					"objectTypeConflict": {
						"type": "boolean"
					},
					"mergeOperations": {
						"type": "structure",
						"members": {
							"source": {},
							"destination": {}
						}
					}
				}
			},
			"St": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"isConflict": {
							"type": "boolean"
						},
						"source": {
							"shape": "Sw"
						},
						"destination": {
							"shape": "Sw"
						},
						"base": {
							"shape": "Sw"
						}
					}
				}
			},
			"Sw": {
				"type": "structure",
				"members": {
					"startLine": {
						"type": "integer"
					},
					"endLine": {
						"type": "integer"
					},
					"hunkContent": {}
				}
			},
			"S18": {
				"type": "structure",
				"members": {
					"accountId": {},
					"repositoryId": {},
					"repositoryName": {},
					"repositoryDescription": {},
					"defaultBranch": {},
					"lastModifiedDate": {
						"type": "timestamp"
					},
					"creationDate": {
						"type": "timestamp"
					},
					"cloneUrlHttp": {},
					"cloneUrlSsh": {},
					"Arn": {}
				}
			},
			"S1u": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"filePath"
					],
					"members": {
						"filePath": {}
					}
				}
			},
			"S1w": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"filePath",
						"fileMode"
					],
					"members": {
						"filePath": {},
						"fileMode": {}
					}
				}
			},
			"S1z": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"absolutePath": {},
						"blobId": {},
						"fileMode": {}
					}
				}
			},
			"S29": {
				"type": "structure",
				"members": {
					"pullRequestId": {},
					"title": {},
					"description": {},
					"lastActivityDate": {
						"type": "timestamp"
					},
					"creationDate": {
						"type": "timestamp"
					},
					"pullRequestStatus": {},
					"authorArn": {},
					"pullRequestTargets": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"repositoryName": {},
								"sourceReference": {},
								"destinationReference": {},
								"destinationCommit": {},
								"sourceCommit": {},
								"mergeBase": {},
								"mergeMetadata": {
									"shape": "S2e"
								}
							}
						}
					},
					"clientRequestToken": {}
				}
			},
			"S2e": {
				"type": "structure",
				"members": {
					"isMerged": {
						"type": "boolean"
					},
					"mergedBy": {},
					"mergeCommitId": {},
					"mergeOption": {}
				}
			},
			"S2h": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S2m": {
				"type": "structure",
				"members": {
					"replaceContents": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"filePath",
								"replacementType"
							],
							"members": {
								"filePath": {},
								"replacementType": {},
								"content": {
									"type": "blob"
								},
								"fileMode": {}
							}
						}
					},
					"deleteFiles": {
						"shape": "S1u"
					},
					"setFileModes": {
						"shape": "S1w"
					}
				}
			},
			"S2t": {
				"type": "structure",
				"members": {
					"branchName": {},
					"commitId": {}
				}
			},
			"S2x": {
				"type": "structure",
				"members": {
					"commentId": {},
					"content": {},
					"inReplyTo": {},
					"creationDate": {
						"type": "timestamp"
					},
					"lastModifiedDate": {
						"type": "timestamp"
					},
					"authorArn": {},
					"deleted": {
						"type": "boolean"
					},
					"clientRequestToken": {}
				}
			},
			"S3r": {
				"type": "structure",
				"members": {
					"filePath": {},
					"filePosition": {
						"type": "long"
					},
					"relativeFileVersion": {}
				}
			},
			"S3u": {
				"type": "list",
				"member": {
					"shape": "S2x"
				}
			},
			"S43": {
				"type": "structure",
				"members": {
					"name": {},
					"email": {},
					"date": {}
				}
			},
			"S4b": {
				"type": "structure",
				"members": {
					"blobId": {},
					"path": {},
					"mode": {}
				}
			},
			"S56": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"name",
						"destinationArn",
						"events"
					],
					"members": {
						"name": {},
						"destinationArn": {},
						"customData": {},
						"branches": {
							"shape": "S5a"
						},
						"events": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S5a": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1687 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeMergeConflicts": {
				"input_token": "nextToken",
				"limit_key": "maxMergeHunks",
				"output_token": "nextToken"
			},
			"DescribePullRequestEvents": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken"
			},
			"GetCommentsForComparedCommit": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken"
			},
			"GetCommentsForPullRequest": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken"
			},
			"GetDifferences": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetMergeConflicts": {
				"input_token": "nextToken",
				"limit_key": "maxConflictFiles",
				"output_token": "nextToken"
			},
			"ListBranches": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "branches"
			},
			"ListPullRequests": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken"
			},
			"ListRepositories": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "repositories"
			}
		}
	};

/***/ },
/* 1688 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-10-06",
			"endpointPrefix": "codedeploy",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CodeDeploy",
			"serviceFullName": "AWS CodeDeploy",
			"serviceId": "CodeDeploy",
			"signatureVersion": "v4",
			"targetPrefix": "CodeDeploy_20141006",
			"uid": "codedeploy-2014-10-06"
		},
		"operations": {
			"AddTagsToOnPremisesInstances": {
				"input": {
					"type": "structure",
					"required": [
						"tags",
						"instanceNames"
					],
					"members": {
						"tags": {
							"shape": "S2"
						},
						"instanceNames": {
							"shape": "S6"
						}
					}
				}
			},
			"BatchGetApplicationRevisions": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"revisions"
					],
					"members": {
						"applicationName": {},
						"revisions": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"errorMessage": {},
						"revisions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"revisionLocation": {
										"shape": "Sb"
									},
									"genericRevisionInfo": {
										"shape": "Su"
									}
								}
							}
						}
					}
				}
			},
			"BatchGetApplications": {
				"input": {
					"type": "structure",
					"required": [
						"applicationNames"
					],
					"members": {
						"applicationNames": {
							"shape": "S10"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationsInfo": {
							"type": "list",
							"member": {
								"shape": "S13"
							}
						}
					}
				}
			},
			"BatchGetDeploymentGroups": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupNames"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupNames": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentGroupsInfo": {
							"type": "list",
							"member": {
								"shape": "S1b"
							}
						},
						"errorMessage": {}
					}
				}
			},
			"BatchGetDeploymentInstances": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId",
						"instanceIds"
					],
					"members": {
						"deploymentId": {},
						"instanceIds": {
							"shape": "S31"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instancesSummary": {
							"type": "list",
							"member": {
								"shape": "S35"
							}
						},
						"errorMessage": {}
					}
				},
				"deprecated": true,
				"deprecatedMessage": "This operation is deprecated, use BatchGetDeploymentTargets instead."
			},
			"BatchGetDeploymentTargets": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {},
						"targetIds": {
							"shape": "S3i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentTargets": {
							"type": "list",
							"member": {
								"shape": "S3m"
							}
						}
					}
				}
			},
			"BatchGetDeployments": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentIds"
					],
					"members": {
						"deploymentIds": {
							"shape": "S46"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentsInfo": {
							"type": "list",
							"member": {
								"shape": "S49"
							}
						}
					}
				}
			},
			"BatchGetOnPremisesInstances": {
				"input": {
					"type": "structure",
					"required": [
						"instanceNames"
					],
					"members": {
						"instanceNames": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceInfos": {
							"type": "list",
							"member": {
								"shape": "S4o"
							}
						}
					}
				}
			},
			"ContinueDeployment": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {},
						"deploymentWaitType": {}
					}
				}
			},
			"CreateApplication": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {},
						"computePlatform": {},
						"tags": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationId": {}
					}
				}
			},
			"CreateDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {},
						"revision": {
							"shape": "Sb"
						},
						"deploymentConfigName": {},
						"description": {},
						"ignoreApplicationStopFailures": {
							"type": "boolean"
						},
						"targetInstances": {
							"shape": "S4g"
						},
						"autoRollbackConfiguration": {
							"shape": "S1z"
						},
						"updateOutdatedInstancesOnly": {
							"type": "boolean"
						},
						"fileExistsBehavior": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentId": {}
					}
				}
			},
			"CreateDeploymentConfig": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentConfigName"
					],
					"members": {
						"deploymentConfigName": {},
						"minimumHealthyHosts": {
							"shape": "S4z"
						},
						"trafficRoutingConfig": {
							"shape": "S52"
						},
						"computePlatform": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentConfigId": {}
					}
				}
			},
			"CreateDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupName",
						"serviceRoleArn"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {},
						"deploymentConfigName": {},
						"ec2TagFilters": {
							"shape": "S1e"
						},
						"onPremisesInstanceTagFilters": {
							"shape": "S1h"
						},
						"autoScalingGroups": {
							"shape": "S4h"
						},
						"serviceRoleArn": {},
						"triggerConfigurations": {
							"shape": "S1p"
						},
						"alarmConfiguration": {
							"shape": "S1v"
						},
						"autoRollbackConfiguration": {
							"shape": "S1z"
						},
						"deploymentStyle": {
							"shape": "S22"
						},
						"blueGreenDeploymentConfiguration": {
							"shape": "S25"
						},
						"loadBalancerInfo": {
							"shape": "S2d"
						},
						"ec2TagSet": {
							"shape": "S2s"
						},
						"ecsServices": {
							"shape": "S2w"
						},
						"onPremisesTagSet": {
							"shape": "S2u"
						},
						"tags": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentGroupId": {}
					}
				}
			},
			"DeleteApplication": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {}
					}
				}
			},
			"DeleteDeploymentConfig": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentConfigName"
					],
					"members": {
						"deploymentConfigName": {}
					}
				}
			},
			"DeleteDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupName"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"hooksNotCleanedUp": {
							"shape": "S1k"
						}
					}
				}
			},
			"DeleteGitHubAccountToken": {
				"input": {
					"type": "structure",
					"members": {
						"tokenName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tokenName": {}
					}
				}
			},
			"DeregisterOnPremisesInstance": {
				"input": {
					"type": "structure",
					"required": [
						"instanceName"
					],
					"members": {
						"instanceName": {}
					}
				}
			},
			"GetApplication": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"application": {
							"shape": "S13"
						}
					}
				}
			},
			"GetApplicationRevision": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"revision"
					],
					"members": {
						"applicationName": {},
						"revision": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"revision": {
							"shape": "Sb"
						},
						"revisionInfo": {
							"shape": "Su"
						}
					}
				}
			},
			"GetDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId"
					],
					"members": {
						"deploymentId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentInfo": {
							"shape": "S49"
						}
					}
				}
			},
			"GetDeploymentConfig": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentConfigName"
					],
					"members": {
						"deploymentConfigName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentConfigInfo": {
							"type": "structure",
							"members": {
								"deploymentConfigId": {},
								"deploymentConfigName": {},
								"minimumHealthyHosts": {
									"shape": "S4z"
								},
								"createTime": {
									"type": "timestamp"
								},
								"computePlatform": {},
								"trafficRoutingConfig": {
									"shape": "S52"
								}
							}
						}
					}
				}
			},
			"GetDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupName"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentGroupInfo": {
							"shape": "S1b"
						}
					}
				}
			},
			"GetDeploymentInstance": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId",
						"instanceId"
					],
					"members": {
						"deploymentId": {},
						"instanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceSummary": {
							"shape": "S35"
						}
					}
				},
				"deprecated": true,
				"deprecatedMessage": "This operation is deprecated, use GetDeploymentTarget instead."
			},
			"GetDeploymentTarget": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {},
						"targetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentTarget": {
							"shape": "S3m"
						}
					}
				}
			},
			"GetOnPremisesInstance": {
				"input": {
					"type": "structure",
					"required": [
						"instanceName"
					],
					"members": {
						"instanceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceInfo": {
							"shape": "S4o"
						}
					}
				}
			},
			"ListApplicationRevisions": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {},
						"sortBy": {},
						"sortOrder": {},
						"s3Bucket": {},
						"s3KeyPrefix": {},
						"deployed": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"revisions": {
							"shape": "Sa"
						},
						"nextToken": {}
					}
				}
			},
			"ListApplications": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applications": {
							"shape": "S10"
						},
						"nextToken": {}
					}
				}
			},
			"ListDeploymentConfigs": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentConfigsList": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListDeploymentGroups": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"deploymentGroups": {
							"shape": "Sw"
						},
						"nextToken": {}
					}
				}
			},
			"ListDeploymentInstances": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId"
					],
					"members": {
						"deploymentId": {},
						"nextToken": {},
						"instanceStatusFilter": {
							"type": "list",
							"member": {
								"shape": "S36"
							}
						},
						"instanceTypeFilter": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instancesList": {
							"shape": "S31"
						},
						"nextToken": {}
					}
				},
				"deprecated": true,
				"deprecatedMessage": "This operation is deprecated, use ListDeploymentTargets instead."
			},
			"ListDeploymentTargets": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {},
						"nextToken": {},
						"targetFilters": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"targetIds": {
							"shape": "S3i"
						},
						"nextToken": {}
					}
				}
			},
			"ListDeployments": {
				"input": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"deploymentGroupName": {},
						"includeOnlyStatuses": {
							"type": "list",
							"member": {}
						},
						"createTimeRange": {
							"type": "structure",
							"members": {
								"start": {
									"type": "timestamp"
								},
								"end": {
									"type": "timestamp"
								}
							}
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deployments": {
							"shape": "S46"
						},
						"nextToken": {}
					}
				}
			},
			"ListGitHubAccountTokenNames": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tokenNameList": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListOnPremisesInstances": {
				"input": {
					"type": "structure",
					"members": {
						"registrationStatus": {},
						"tagFilters": {
							"shape": "S1h"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceNames": {
							"shape": "S6"
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S2"
						},
						"NextToken": {}
					}
				}
			},
			"PutLifecycleEventHookExecutionStatus": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {},
						"lifecycleEventHookExecutionId": {},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"lifecycleEventHookExecutionId": {}
					}
				}
			},
			"RegisterApplicationRevision": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"revision"
					],
					"members": {
						"applicationName": {},
						"description": {},
						"revision": {
							"shape": "Sb"
						}
					}
				}
			},
			"RegisterOnPremisesInstance": {
				"input": {
					"type": "structure",
					"required": [
						"instanceName"
					],
					"members": {
						"instanceName": {},
						"iamSessionArn": {},
						"iamUserArn": {}
					}
				}
			},
			"RemoveTagsFromOnPremisesInstances": {
				"input": {
					"type": "structure",
					"required": [
						"tags",
						"instanceNames"
					],
					"members": {
						"tags": {
							"shape": "S2"
						},
						"instanceNames": {
							"shape": "S6"
						}
					}
				}
			},
			"SkipWaitTimeForInstanceTermination": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {}
					}
				},
				"deprecated": true,
				"deprecatedMessage": "This operation is deprecated, use ContinueDeployment with DeploymentWaitType instead."
			},
			"StopDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId"
					],
					"members": {
						"deploymentId": {},
						"autoRollbackEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {},
						"statusMessage": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Tags"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeys"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateApplication": {
				"input": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"newApplicationName": {}
					}
				}
			},
			"UpdateDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"currentDeploymentGroupName"
					],
					"members": {
						"applicationName": {},
						"currentDeploymentGroupName": {},
						"newDeploymentGroupName": {},
						"deploymentConfigName": {},
						"ec2TagFilters": {
							"shape": "S1e"
						},
						"onPremisesInstanceTagFilters": {
							"shape": "S1h"
						},
						"autoScalingGroups": {
							"shape": "S4h"
						},
						"serviceRoleArn": {},
						"triggerConfigurations": {
							"shape": "S1p"
						},
						"alarmConfiguration": {
							"shape": "S1v"
						},
						"autoRollbackConfiguration": {
							"shape": "S1z"
						},
						"deploymentStyle": {
							"shape": "S22"
						},
						"blueGreenDeploymentConfiguration": {
							"shape": "S25"
						},
						"loadBalancerInfo": {
							"shape": "S2d"
						},
						"ec2TagSet": {
							"shape": "S2s"
						},
						"ecsServices": {
							"shape": "S2w"
						},
						"onPremisesTagSet": {
							"shape": "S2u"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"hooksNotCleanedUp": {
							"shape": "S1k"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S6": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {
					"shape": "Sb"
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"revisionType": {},
					"s3Location": {
						"type": "structure",
						"members": {
							"bucket": {},
							"key": {},
							"bundleType": {},
							"version": {},
							"eTag": {}
						}
					},
					"gitHubLocation": {
						"type": "structure",
						"members": {
							"repository": {},
							"commitId": {}
						}
					},
					"string": {
						"type": "structure",
						"members": {
							"content": {},
							"sha256": {}
						},
						"deprecated": true,
						"deprecatedMessage": "RawString and String revision type are deprecated, use AppSpecContent type instead."
					},
					"appSpecContent": {
						"type": "structure",
						"members": {
							"content": {},
							"sha256": {}
						}
					}
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"description": {},
					"deploymentGroups": {
						"shape": "Sw"
					},
					"firstUsedTime": {
						"type": "timestamp"
					},
					"lastUsedTime": {
						"type": "timestamp"
					},
					"registerTime": {
						"type": "timestamp"
					}
				}
			},
			"Sw": {
				"type": "list",
				"member": {}
			},
			"S10": {
				"type": "list",
				"member": {}
			},
			"S13": {
				"type": "structure",
				"members": {
					"applicationId": {},
					"applicationName": {},
					"createTime": {
						"type": "timestamp"
					},
					"linkedToGitHub": {
						"type": "boolean"
					},
					"gitHubAccountName": {},
					"computePlatform": {}
				}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroupId": {},
					"deploymentGroupName": {},
					"deploymentConfigName": {},
					"ec2TagFilters": {
						"shape": "S1e"
					},
					"onPremisesInstanceTagFilters": {
						"shape": "S1h"
					},
					"autoScalingGroups": {
						"shape": "S1k"
					},
					"serviceRoleArn": {},
					"targetRevision": {
						"shape": "Sb"
					},
					"triggerConfigurations": {
						"shape": "S1p"
					},
					"alarmConfiguration": {
						"shape": "S1v"
					},
					"autoRollbackConfiguration": {
						"shape": "S1z"
					},
					"deploymentStyle": {
						"shape": "S22"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S25"
					},
					"loadBalancerInfo": {
						"shape": "S2d"
					},
					"lastSuccessfulDeployment": {
						"shape": "S2p"
					},
					"lastAttemptedDeployment": {
						"shape": "S2p"
					},
					"ec2TagSet": {
						"shape": "S2s"
					},
					"onPremisesTagSet": {
						"shape": "S2u"
					},
					"computePlatform": {},
					"ecsServices": {
						"shape": "S2w"
					}
				}
			},
			"S1e": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {},
						"Type": {}
					}
				}
			},
			"S1h": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {},
						"Type": {}
					}
				}
			},
			"S1k": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"hook": {}
					}
				}
			},
			"S1p": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"triggerName": {},
						"triggerTargetArn": {},
						"triggerEvents": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S1v": {
				"type": "structure",
				"members": {
					"enabled": {
						"type": "boolean"
					},
					"ignorePollAlarmFailure": {
						"type": "boolean"
					},
					"alarms": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {}
							}
						}
					}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"enabled": {
						"type": "boolean"
					},
					"events": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S22": {
				"type": "structure",
				"members": {
					"deploymentType": {},
					"deploymentOption": {}
				}
			},
			"S25": {
				"type": "structure",
				"members": {
					"terminateBlueInstancesOnDeploymentSuccess": {
						"type": "structure",
						"members": {
							"action": {},
							"terminationWaitTimeInMinutes": {
								"type": "integer"
							}
						}
					},
					"deploymentReadyOption": {
						"type": "structure",
						"members": {
							"actionOnTimeout": {},
							"waitTimeInMinutes": {
								"type": "integer"
							}
						}
					},
					"greenFleetProvisioningOption": {
						"type": "structure",
						"members": {
							"action": {}
						}
					}
				}
			},
			"S2d": {
				"type": "structure",
				"members": {
					"elbInfoList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {}
							}
						}
					},
					"targetGroupInfoList": {
						"shape": "S2h"
					},
					"targetGroupPairInfoList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"targetGroups": {
									"shape": "S2h"
								},
								"prodTrafficRoute": {
									"shape": "S2m"
								},
								"testTrafficRoute": {
									"shape": "S2m"
								}
							}
						}
					}
				}
			},
			"S2h": {
				"type": "list",
				"member": {
					"shape": "S2i"
				}
			},
			"S2i": {
				"type": "structure",
				"members": {
					"name": {}
				}
			},
			"S2m": {
				"type": "structure",
				"members": {
					"listenerArns": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S2p": {
				"type": "structure",
				"members": {
					"deploymentId": {},
					"status": {},
					"endTime": {
						"type": "timestamp"
					},
					"createTime": {
						"type": "timestamp"
					}
				}
			},
			"S2s": {
				"type": "structure",
				"members": {
					"ec2TagSetList": {
						"type": "list",
						"member": {
							"shape": "S1e"
						}
					}
				}
			},
			"S2u": {
				"type": "structure",
				"members": {
					"onPremisesTagSetList": {
						"type": "list",
						"member": {
							"shape": "S1h"
						}
					}
				}
			},
			"S2w": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"serviceName": {},
						"clusterName": {}
					}
				}
			},
			"S31": {
				"type": "list",
				"member": {}
			},
			"S35": {
				"type": "structure",
				"members": {
					"deploymentId": {},
					"instanceId": {},
					"status": {
						"shape": "S36"
					},
					"lastUpdatedAt": {
						"type": "timestamp"
					},
					"lifecycleEvents": {
						"shape": "S37"
					},
					"instanceType": {}
				},
				"deprecated": true,
				"deprecatedMessage": "InstanceSummary is deprecated, use DeploymentTarget instead."
			},
			"S36": {
				"type": "string",
				"deprecated": true,
				"deprecatedMessage": "InstanceStatus is deprecated, use TargetStatus instead."
			},
			"S37": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"lifecycleEventName": {},
						"diagnostics": {
							"type": "structure",
							"members": {
								"errorCode": {},
								"scriptName": {},
								"message": {},
								"logTail": {}
							}
						},
						"startTime": {
							"type": "timestamp"
						},
						"endTime": {
							"type": "timestamp"
						},
						"status": {}
					}
				}
			},
			"S3i": {
				"type": "list",
				"member": {}
			},
			"S3m": {
				"type": "structure",
				"members": {
					"deploymentTargetType": {},
					"instanceTarget": {
						"type": "structure",
						"members": {
							"deploymentId": {},
							"targetId": {},
							"targetArn": {},
							"status": {},
							"lastUpdatedAt": {
								"type": "timestamp"
							},
							"lifecycleEvents": {
								"shape": "S37"
							},
							"instanceLabel": {}
						}
					},
					"lambdaTarget": {
						"type": "structure",
						"members": {
							"deploymentId": {},
							"targetId": {},
							"targetArn": {},
							"status": {},
							"lastUpdatedAt": {
								"type": "timestamp"
							},
							"lifecycleEvents": {
								"shape": "S37"
							},
							"lambdaFunctionInfo": {
								"type": "structure",
								"members": {
									"functionName": {},
									"functionAlias": {},
									"currentVersion": {},
									"targetVersion": {},
									"targetVersionWeight": {
										"type": "double"
									}
								}
							}
						}
					},
					"ecsTarget": {
						"type": "structure",
						"members": {
							"deploymentId": {},
							"targetId": {},
							"targetArn": {},
							"lastUpdatedAt": {
								"type": "timestamp"
							},
							"lifecycleEvents": {
								"shape": "S37"
							},
							"status": {},
							"taskSetsInfo": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"identifer": {},
										"desiredCount": {
											"type": "long"
										},
										"pendingCount": {
											"type": "long"
										},
										"runningCount": {
											"type": "long"
										},
										"status": {},
										"trafficWeight": {
											"type": "double"
										},
										"targetGroup": {
											"shape": "S2i"
										},
										"taskSetLabel": {}
									}
								}
							}
						}
					}
				}
			},
			"S46": {
				"type": "list",
				"member": {}
			},
			"S49": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"deploymentConfigName": {},
					"deploymentId": {},
					"previousRevision": {
						"shape": "Sb"
					},
					"revision": {
						"shape": "Sb"
					},
					"status": {},
					"errorInformation": {
						"type": "structure",
						"members": {
							"code": {},
							"message": {}
						}
					},
					"createTime": {
						"type": "timestamp"
					},
					"startTime": {
						"type": "timestamp"
					},
					"completeTime": {
						"type": "timestamp"
					},
					"deploymentOverview": {
						"type": "structure",
						"members": {
							"Pending": {
								"type": "long"
							},
							"InProgress": {
								"type": "long"
							},
							"Succeeded": {
								"type": "long"
							},
							"Failed": {
								"type": "long"
							},
							"Skipped": {
								"type": "long"
							},
							"Ready": {
								"type": "long"
							}
						}
					},
					"description": {},
					"creator": {},
					"ignoreApplicationStopFailures": {
						"type": "boolean"
					},
					"autoRollbackConfiguration": {
						"shape": "S1z"
					},
					"updateOutdatedInstancesOnly": {
						"type": "boolean"
					},
					"rollbackInfo": {
						"type": "structure",
						"members": {
							"rollbackDeploymentId": {},
							"rollbackTriggeringDeploymentId": {},
							"rollbackMessage": {}
						}
					},
					"deploymentStyle": {
						"shape": "S22"
					},
					"targetInstances": {
						"shape": "S4g"
					},
					"instanceTerminationWaitTimeStarted": {
						"type": "boolean"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S25"
					},
					"loadBalancerInfo": {
						"shape": "S2d"
					},
					"additionalDeploymentStatusInfo": {
						"type": "string",
						"deprecated": true,
						"deprecatedMessage": "AdditionalDeploymentStatusInfo is deprecated, use DeploymentStatusMessageList instead."
					},
					"fileExistsBehavior": {},
					"deploymentStatusMessages": {
						"type": "list",
						"member": {}
					},
					"computePlatform": {}
				}
			},
			"S4g": {
				"type": "structure",
				"members": {
					"tagFilters": {
						"shape": "S1e"
					},
					"autoScalingGroups": {
						"shape": "S4h"
					},
					"ec2TagSet": {
						"shape": "S2s"
					}
				}
			},
			"S4h": {
				"type": "list",
				"member": {}
			},
			"S4o": {
				"type": "structure",
				"members": {
					"instanceName": {},
					"iamSessionArn": {},
					"iamUserArn": {},
					"instanceArn": {},
					"registerTime": {
						"type": "timestamp"
					},
					"deregisterTime": {
						"type": "timestamp"
					},
					"tags": {
						"shape": "S2"
					}
				}
			},
			"S4z": {
				"type": "structure",
				"members": {
					"value": {
						"type": "integer"
					},
					"type": {}
				}
			},
			"S52": {
				"type": "structure",
				"members": {
					"type": {},
					"timeBasedCanary": {
						"type": "structure",
						"members": {
							"canaryPercentage": {
								"type": "integer"
							},
							"canaryInterval": {
								"type": "integer"
							}
						}
					},
					"timeBasedLinear": {
						"type": "structure",
						"members": {
							"linearPercentage": {
								"type": "integer"
							},
							"linearInterval": {
								"type": "integer"
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1689 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListApplicationRevisions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "revisions"
			},
			"ListApplications": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "applications"
			},
			"ListDeploymentConfigs": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "deploymentConfigsList"
			},
			"ListDeploymentGroups": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "deploymentGroups"
			},
			"ListDeploymentInstances": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "instancesList"
			},
			"ListDeployments": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "deployments"
			}
		}
	};

/***/ },
/* 1690 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DeploymentSuccessful": {
				"delay": 15,
				"operation": "GetDeployment",
				"maxAttempts": 120,
				"acceptors": [
					{
						"expected": "Succeeded",
						"matcher": "path",
						"state": "success",
						"argument": "deploymentInfo.status"
					},
					{
						"expected": "Failed",
						"matcher": "path",
						"state": "failure",
						"argument": "deploymentInfo.status"
					},
					{
						"expected": "Stopped",
						"matcher": "path",
						"state": "failure",
						"argument": "deploymentInfo.status"
					}
				]
			}
		}
	};

/***/ },
/* 1691 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-07-09",
			"endpointPrefix": "codepipeline",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CodePipeline",
			"serviceFullName": "AWS CodePipeline",
			"serviceId": "CodePipeline",
			"signatureVersion": "v4",
			"targetPrefix": "CodePipeline_20150709",
			"uid": "codepipeline-2015-07-09"
		},
		"operations": {
			"AcknowledgeJob": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"nonce"
					],
					"members": {
						"jobId": {},
						"nonce": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {}
					}
				}
			},
			"AcknowledgeThirdPartyJob": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"nonce",
						"clientToken"
					],
					"members": {
						"jobId": {},
						"nonce": {},
						"clientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {}
					}
				}
			},
			"CreateCustomActionType": {
				"input": {
					"type": "structure",
					"required": [
						"category",
						"provider",
						"version",
						"inputArtifactDetails",
						"outputArtifactDetails"
					],
					"members": {
						"category": {},
						"provider": {},
						"version": {},
						"settings": {
							"shape": "Se"
						},
						"configurationProperties": {
							"shape": "Sh"
						},
						"inputArtifactDetails": {
							"shape": "Sn"
						},
						"outputArtifactDetails": {
							"shape": "Sn"
						},
						"tags": {
							"shape": "Sq"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"actionType"
					],
					"members": {
						"actionType": {
							"shape": "Sv"
						},
						"tags": {
							"shape": "Sq"
						}
					}
				}
			},
			"CreatePipeline": {
				"input": {
					"type": "structure",
					"required": [
						"pipeline"
					],
					"members": {
						"pipeline": {
							"shape": "Sz"
						},
						"tags": {
							"shape": "Sq"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipeline": {
							"shape": "Sz"
						},
						"tags": {
							"shape": "Sq"
						}
					}
				}
			},
			"DeleteCustomActionType": {
				"input": {
					"type": "structure",
					"required": [
						"category",
						"provider",
						"version"
					],
					"members": {
						"category": {},
						"provider": {},
						"version": {}
					}
				}
			},
			"DeletePipeline": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				}
			},
			"DeleteWebhook": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterWebhookWithThirdParty": {
				"input": {
					"type": "structure",
					"members": {
						"webhookName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisableStageTransition": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"transitionType",
						"reason"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"transitionType": {},
						"reason": {}
					}
				}
			},
			"EnableStageTransition": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"transitionType"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"transitionType": {}
					}
				}
			},
			"GetJobDetails": {
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobDetails": {
							"type": "structure",
							"members": {
								"id": {},
								"data": {
									"shape": "S28"
								},
								"accountId": {}
							}
						}
					}
				}
			},
			"GetPipeline": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"version": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipeline": {
							"shape": "Sz"
						},
						"metadata": {
							"type": "structure",
							"members": {
								"pipelineArn": {},
								"created": {
									"type": "timestamp"
								},
								"updated": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"GetPipelineExecution": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"pipelineExecutionId"
					],
					"members": {
						"pipelineName": {},
						"pipelineExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineExecution": {
							"type": "structure",
							"members": {
								"pipelineName": {},
								"pipelineVersion": {
									"type": "integer"
								},
								"pipelineExecutionId": {},
								"status": {},
								"artifactRevisions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"name": {},
											"revisionId": {},
											"revisionChangeIdentifier": {},
											"revisionSummary": {},
											"created": {
												"type": "timestamp"
											},
											"revisionUrl": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"GetPipelineState": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineName": {},
						"pipelineVersion": {
							"type": "integer"
						},
						"stageStates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"stageName": {},
									"inboundTransitionState": {
										"type": "structure",
										"members": {
											"enabled": {
												"type": "boolean"
											},
											"lastChangedBy": {},
											"lastChangedAt": {
												"type": "timestamp"
											},
											"disabledReason": {}
										}
									},
									"actionStates": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"actionName": {},
												"currentRevision": {
													"shape": "S3g"
												},
												"latestExecution": {
													"type": "structure",
													"members": {
														"status": {},
														"summary": {},
														"lastStatusChange": {
															"type": "timestamp"
														},
														"token": {},
														"lastUpdatedBy": {},
														"externalExecutionId": {},
														"externalExecutionUrl": {},
														"percentComplete": {
															"type": "integer"
														},
														"errorDetails": {
															"type": "structure",
															"members": {
																"code": {},
																"message": {}
															}
														}
													}
												},
												"entityUrl": {},
												"revisionUrl": {}
											}
										}
									},
									"latestExecution": {
										"type": "structure",
										"required": [
											"pipelineExecutionId",
											"status"
										],
										"members": {
											"pipelineExecutionId": {},
											"status": {}
										}
									}
								}
							}
						},
						"created": {
							"type": "timestamp"
						},
						"updated": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetThirdPartyJobDetails": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"clientToken"
					],
					"members": {
						"jobId": {},
						"clientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobDetails": {
							"type": "structure",
							"members": {
								"id": {},
								"data": {
									"type": "structure",
									"members": {
										"actionTypeId": {
											"shape": "Sw"
										},
										"actionConfiguration": {
											"shape": "S29"
										},
										"pipelineContext": {
											"shape": "S2a"
										},
										"inputArtifacts": {
											"shape": "S2g"
										},
										"outputArtifacts": {
											"shape": "S2g"
										},
										"artifactCredentials": {
											"shape": "S2o"
										},
										"continuationToken": {},
										"encryptionKey": {
											"shape": "S15"
										}
									}
								},
								"nonce": {}
							}
						}
					}
				}
			},
			"ListActionExecutions": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName"
					],
					"members": {
						"pipelineName": {},
						"filter": {
							"type": "structure",
							"members": {
								"pipelineExecutionId": {}
							}
						},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"actionExecutionDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"pipelineExecutionId": {},
									"actionExecutionId": {},
									"pipelineVersion": {
										"type": "integer"
									},
									"stageName": {},
									"actionName": {},
									"startTime": {
										"type": "timestamp"
									},
									"lastUpdateTime": {
										"type": "timestamp"
									},
									"status": {},
									"input": {
										"type": "structure",
										"members": {
											"actionTypeId": {
												"shape": "Sw"
											},
											"configuration": {
												"shape": "S1l"
											},
											"roleArn": {},
											"region": {},
											"inputArtifacts": {
												"shape": "S45"
											}
										}
									},
									"output": {
										"type": "structure",
										"members": {
											"outputArtifacts": {
												"shape": "S45"
											},
											"executionResult": {
												"type": "structure",
												"members": {
													"externalExecutionId": {},
													"externalExecutionSummary": {},
													"externalExecutionUrl": {}
												}
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListActionTypes": {
				"input": {
					"type": "structure",
					"members": {
						"actionOwnerFilter": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"actionTypes"
					],
					"members": {
						"actionTypes": {
							"type": "list",
							"member": {
								"shape": "Sv"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListPipelineExecutions": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName"
					],
					"members": {
						"pipelineName": {},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineExecutionSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"pipelineExecutionId": {},
									"status": {},
									"startTime": {
										"type": "timestamp"
									},
									"lastUpdateTime": {
										"type": "timestamp"
									},
									"sourceRevisions": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"actionName"
											],
											"members": {
												"actionName": {},
												"revisionId": {},
												"revisionSummary": {},
												"revisionUrl": {}
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListPipelines": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelines": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"version": {
										"type": "integer"
									},
									"created": {
										"type": "timestamp"
									},
									"updated": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "Sq"
						},
						"nextToken": {}
					}
				}
			},
			"ListWebhooks": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"webhooks": {
							"type": "list",
							"member": {
								"shape": "S4x"
							}
						},
						"NextToken": {}
					}
				}
			},
			"PollForJobs": {
				"input": {
					"type": "structure",
					"required": [
						"actionTypeId"
					],
					"members": {
						"actionTypeId": {
							"shape": "Sw"
						},
						"maxBatchSize": {
							"type": "integer"
						},
						"queryParam": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"id": {},
									"data": {
										"shape": "S28"
									},
									"nonce": {},
									"accountId": {}
								}
							}
						}
					}
				}
			},
			"PollForThirdPartyJobs": {
				"input": {
					"type": "structure",
					"required": [
						"actionTypeId"
					],
					"members": {
						"actionTypeId": {
							"shape": "Sw"
						},
						"maxBatchSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"clientId": {},
									"jobId": {}
								}
							}
						}
					}
				}
			},
			"PutActionRevision": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"actionName",
						"actionRevision"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"actionName": {},
						"actionRevision": {
							"shape": "S3g"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"newRevision": {
							"type": "boolean"
						},
						"pipelineExecutionId": {}
					}
				}
			},
			"PutApprovalResult": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"actionName",
						"result",
						"token"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"actionName": {},
						"result": {
							"type": "structure",
							"required": [
								"summary",
								"status"
							],
							"members": {
								"summary": {},
								"status": {}
							}
						},
						"token": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"approvedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"PutJobFailureResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"failureDetails"
					],
					"members": {
						"jobId": {},
						"failureDetails": {
							"shape": "S5x"
						}
					}
				}
			},
			"PutJobSuccessResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {},
						"currentRevision": {
							"shape": "S60"
						},
						"continuationToken": {},
						"executionDetails": {
							"shape": "S62"
						}
					}
				}
			},
			"PutThirdPartyJobFailureResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"clientToken",
						"failureDetails"
					],
					"members": {
						"jobId": {},
						"clientToken": {},
						"failureDetails": {
							"shape": "S5x"
						}
					}
				}
			},
			"PutThirdPartyJobSuccessResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"clientToken"
					],
					"members": {
						"jobId": {},
						"clientToken": {},
						"currentRevision": {
							"shape": "S60"
						},
						"continuationToken": {},
						"executionDetails": {
							"shape": "S62"
						}
					}
				}
			},
			"PutWebhook": {
				"input": {
					"type": "structure",
					"required": [
						"webhook"
					],
					"members": {
						"webhook": {
							"shape": "S4y"
						},
						"tags": {
							"shape": "Sq"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"webhook": {
							"shape": "S4x"
						}
					}
				}
			},
			"RegisterWebhookWithThirdParty": {
				"input": {
					"type": "structure",
					"members": {
						"webhookName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RetryStageExecution": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"pipelineExecutionId",
						"retryMode"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"pipelineExecutionId": {},
						"retryMode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineExecutionId": {}
					}
				}
			},
			"StartPipelineExecution": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"clientRequestToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineExecutionId": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "Sq"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {},
						"tagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdatePipeline": {
				"input": {
					"type": "structure",
					"required": [
						"pipeline"
					],
					"members": {
						"pipeline": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipeline": {
							"shape": "Sz"
						}
					}
				}
			}
		},
		"shapes": {
			"Se": {
				"type": "structure",
				"members": {
					"thirdPartyConfigurationUrl": {},
					"entityUrlTemplate": {},
					"executionUrlTemplate": {},
					"revisionUrlTemplate": {}
				}
			},
			"Sh": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"name",
						"required",
						"key",
						"secret"
					],
					"members": {
						"name": {},
						"required": {
							"type": "boolean"
						},
						"key": {
							"type": "boolean"
						},
						"secret": {
							"type": "boolean"
						},
						"queryable": {
							"type": "boolean"
						},
						"description": {},
						"type": {}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"minimumCount",
					"maximumCount"
				],
				"members": {
					"minimumCount": {
						"type": "integer"
					},
					"maximumCount": {
						"type": "integer"
					}
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key",
						"value"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"Sv": {
				"type": "structure",
				"required": [
					"id",
					"inputArtifactDetails",
					"outputArtifactDetails"
				],
				"members": {
					"id": {
						"shape": "Sw"
					},
					"settings": {
						"shape": "Se"
					},
					"actionConfigurationProperties": {
						"shape": "Sh"
					},
					"inputArtifactDetails": {
						"shape": "Sn"
					},
					"outputArtifactDetails": {
						"shape": "Sn"
					}
				}
			},
			"Sw": {
				"type": "structure",
				"required": [
					"category",
					"owner",
					"provider",
					"version"
				],
				"members": {
					"category": {},
					"owner": {},
					"provider": {},
					"version": {}
				}
			},
			"Sz": {
				"type": "structure",
				"required": [
					"name",
					"roleArn",
					"stages"
				],
				"members": {
					"name": {},
					"roleArn": {},
					"artifactStore": {
						"shape": "S12"
					},
					"artifactStores": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S12"
						}
					},
					"stages": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"name",
								"actions"
							],
							"members": {
								"name": {},
								"blockers": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"name",
											"type"
										],
										"members": {
											"name": {},
											"type": {}
										}
									}
								},
								"actions": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"name",
											"actionTypeId"
										],
										"members": {
											"name": {},
											"actionTypeId": {
												"shape": "Sw"
											},
											"runOrder": {
												"type": "integer"
											},
											"configuration": {
												"shape": "S1l"
											},
											"outputArtifacts": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"name"
													],
													"members": {
														"name": {}
													}
												}
											},
											"inputArtifacts": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"name"
													],
													"members": {
														"name": {}
													}
												}
											},
											"roleArn": {},
											"region": {}
										}
									}
								}
							}
						}
					},
					"version": {
						"type": "integer"
					}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"type",
					"location"
				],
				"members": {
					"type": {},
					"location": {},
					"encryptionKey": {
						"shape": "S15"
					}
				}
			},
			"S15": {
				"type": "structure",
				"required": [
					"id",
					"type"
				],
				"members": {
					"id": {},
					"type": {}
				}
			},
			"S1l": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S28": {
				"type": "structure",
				"members": {
					"actionTypeId": {
						"shape": "Sw"
					},
					"actionConfiguration": {
						"shape": "S29"
					},
					"pipelineContext": {
						"shape": "S2a"
					},
					"inputArtifacts": {
						"shape": "S2g"
					},
					"outputArtifacts": {
						"shape": "S2g"
					},
					"artifactCredentials": {
						"shape": "S2o"
					},
					"continuationToken": {},
					"encryptionKey": {
						"shape": "S15"
					}
				}
			},
			"S29": {
				"type": "structure",
				"members": {
					"configuration": {
						"shape": "S1l"
					}
				}
			},
			"S2a": {
				"type": "structure",
				"members": {
					"pipelineName": {},
					"stage": {
						"type": "structure",
						"members": {
							"name": {}
						}
					},
					"action": {
						"type": "structure",
						"members": {
							"name": {},
							"actionExecutionId": {}
						}
					},
					"pipelineArn": {},
					"pipelineExecutionId": {}
				}
			},
			"S2g": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"revision": {},
						"location": {
							"type": "structure",
							"members": {
								"type": {},
								"s3Location": {
									"type": "structure",
									"required": [
										"bucketName",
										"objectKey"
									],
									"members": {
										"bucketName": {},
										"objectKey": {}
									}
								}
							}
						}
					}
				}
			},
			"S2o": {
				"type": "structure",
				"required": [
					"accessKeyId",
					"secretAccessKey",
					"sessionToken"
				],
				"members": {
					"accessKeyId": {},
					"secretAccessKey": {},
					"sessionToken": {}
				},
				"sensitive": true
			},
			"S3g": {
				"type": "structure",
				"required": [
					"revisionId",
					"revisionChangeId",
					"created"
				],
				"members": {
					"revisionId": {},
					"revisionChangeId": {},
					"created": {
						"type": "timestamp"
					}
				}
			},
			"S45": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"s3location": {
							"type": "structure",
							"members": {
								"bucket": {},
								"key": {}
							}
						}
					}
				}
			},
			"S4x": {
				"type": "structure",
				"required": [
					"definition",
					"url"
				],
				"members": {
					"definition": {
						"shape": "S4y"
					},
					"url": {},
					"errorMessage": {},
					"errorCode": {},
					"lastTriggered": {
						"type": "timestamp"
					},
					"arn": {},
					"tags": {
						"shape": "Sq"
					}
				}
			},
			"S4y": {
				"type": "structure",
				"required": [
					"name",
					"targetPipeline",
					"targetAction",
					"filters",
					"authentication",
					"authenticationConfiguration"
				],
				"members": {
					"name": {},
					"targetPipeline": {},
					"targetAction": {},
					"filters": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"jsonPath"
							],
							"members": {
								"jsonPath": {},
								"matchEquals": {}
							}
						}
					},
					"authentication": {},
					"authenticationConfiguration": {
						"type": "structure",
						"members": {
							"AllowedIPRange": {},
							"SecretToken": {}
						}
					}
				}
			},
			"S5x": {
				"type": "structure",
				"required": [
					"type",
					"message"
				],
				"members": {
					"type": {},
					"message": {},
					"externalExecutionId": {}
				}
			},
			"S60": {
				"type": "structure",
				"required": [
					"revision",
					"changeIdentifier"
				],
				"members": {
					"revision": {},
					"changeIdentifier": {},
					"created": {
						"type": "timestamp"
					},
					"revisionSummary": {}
				}
			},
			"S62": {
				"type": "structure",
				"members": {
					"summary": {},
					"externalExecutionId": {},
					"percentComplete": {
						"type": "integer"
					}
				}
			}
		}
	};

/***/ },
/* 1692 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListActionExecutions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "actionExecutionDetails"
			},
			"ListActionTypes": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "actionTypes"
			},
			"ListPipelineExecutions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "pipelineExecutionSummaries"
			},
			"ListPipelines": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "pipelines"
			},
			"ListTagsForResource": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "tags"
			},
			"ListWebhooks": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "webhooks"
			}
		}
	};

/***/ },
/* 1693 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-30",
			"endpointPrefix": "cognito-identity",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Cognito Identity",
			"serviceId": "Cognito Identity",
			"signatureVersion": "v4",
			"targetPrefix": "AWSCognitoIdentityService",
			"uid": "cognito-identity-2014-06-30"
		},
		"operations": {
			"CreateIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolName",
						"AllowUnauthenticatedIdentities"
					],
					"members": {
						"IdentityPoolName": {},
						"AllowUnauthenticatedIdentities": {
							"type": "boolean"
						},
						"SupportedLoginProviders": {
							"shape": "S4"
						},
						"DeveloperProviderName": {},
						"OpenIdConnectProviderARNs": {
							"shape": "S8"
						},
						"CognitoIdentityProviders": {
							"shape": "Sa"
						},
						"SamlProviderARNs": {
							"shape": "Sf"
						},
						"IdentityPoolTags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"shape": "Sj"
				}
			},
			"DeleteIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityIdsToDelete"
					],
					"members": {
						"IdentityIdsToDelete": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UnprocessedIdentityIds": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityId": {},
									"ErrorCode": {}
								}
							}
						}
					}
				}
			},
			"DeleteIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				}
			},
			"DescribeIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {}
					}
				},
				"output": {
					"shape": "Su"
				}
			},
			"DescribeIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"shape": "Sj"
				}
			},
			"GetCredentialsForIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						},
						"CustomRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Credentials": {
							"type": "structure",
							"members": {
								"AccessKeyId": {},
								"SecretKey": {},
								"SessionToken": {},
								"Expiration": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"GetId": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"AccountId": {},
						"IdentityPoolId": {},
						"Logins": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"GetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S1b"
						},
						"RoleMappings": {
							"shape": "S1d"
						}
					}
				}
			},
			"GetOpenIdToken": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"GetOpenIdTokenForDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Logins"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						},
						"TokenDuration": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"ListIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"MaxResults"
					],
					"members": {
						"IdentityPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"HideDisabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Identities": {
							"type": "list",
							"member": {
								"shape": "Su"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPools": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPools": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityPoolId": {},
									"IdentityPoolName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "Sg"
						}
					}
				}
			},
			"LookupDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"DeveloperUserIdentifier": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"DeveloperUserIdentifierList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"MergeDeveloperIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"SourceUserIdentifier",
						"DestinationUserIdentifier",
						"DeveloperProviderName",
						"IdentityPoolId"
					],
					"members": {
						"SourceUserIdentifier": {},
						"DestinationUserIdentifier": {},
						"DeveloperProviderName": {},
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"SetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Roles"
					],
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S1b"
						},
						"RoleMappings": {
							"shape": "S1d"
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UnlinkDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"IdentityPoolId",
						"DeveloperProviderName",
						"DeveloperUserIdentifier"
					],
					"members": {
						"IdentityId": {},
						"IdentityPoolId": {},
						"DeveloperProviderName": {},
						"DeveloperUserIdentifier": {}
					}
				}
			},
			"UnlinkIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"Logins",
						"LoginsToRemove"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sz"
						},
						"LoginsToRemove": {
							"shape": "Sv"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateIdentityPool": {
				"input": {
					"shape": "Sj"
				},
				"output": {
					"shape": "Sj"
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S8": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ProviderName": {},
						"ClientId": {},
						"ServerSideTokenCheck": {
							"type": "boolean"
						}
					}
				}
			},
			"Sf": {
				"type": "list",
				"member": {}
			},
			"Sg": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sj": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Sf"
					},
					"IdentityPoolTags": {
						"shape": "Sg"
					}
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sv"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {}
			},
			"Sz": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1b": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1d": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"Type": {},
						"AmbiguousRoleResolution": {},
						"RulesConfiguration": {
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Claim",
											"MatchType",
											"Value",
											"RoleARN"
										],
										"members": {
											"Claim": {},
											"MatchType": {},
											"Value": {},
											"RoleARN": {}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1694 */
1641,
/* 1695 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-04-18",
			"endpointPrefix": "cognito-idp",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Cognito Identity Provider",
			"serviceId": "Cognito Identity Provider",
			"signatureVersion": "v4",
			"targetPrefix": "AWSCognitoIdentityProviderService",
			"uid": "cognito-idp-2016-04-18"
		},
		"operations": {
			"AddCustomAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"CustomAttributes"
					],
					"members": {
						"UserPoolId": {},
						"CustomAttributes": {
							"type": "list",
							"member": {
								"shape": "S4"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminAddUserToGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"GroupName": {}
					}
				}
			},
			"AdminConfirmSignUp": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminCreateUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"ValidationData": {
							"shape": "Si"
						},
						"TemporaryPassword": {
							"shape": "Sm"
						},
						"ForceAliasCreation": {
							"type": "boolean"
						},
						"MessageAction": {},
						"DesiredDeliveryMediums": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"User": {
							"shape": "Ss"
						}
					}
				}
			},
			"AdminDeleteUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				}
			},
			"AdminDeleteUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"UserAttributeNames"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributeNames": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminDisableProviderForUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"User"
					],
					"members": {
						"UserPoolId": {},
						"User": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminDisableUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminEnableUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminForgetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"DeviceKey"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"DeviceKey": {}
					}
				}
			},
			"AdminGetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey",
						"UserPoolId",
						"Username"
					],
					"members": {
						"DeviceKey": {},
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Device"
					],
					"members": {
						"Device": {
							"shape": "S1d"
						}
					}
				}
			},
			"AdminGetUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Username"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"UserCreateDate": {
							"type": "timestamp"
						},
						"UserLastModifiedDate": {
							"type": "timestamp"
						},
						"Enabled": {
							"type": "boolean"
						},
						"UserStatus": {},
						"MFAOptions": {
							"shape": "Sv"
						},
						"PreferredMfaSetting": {},
						"UserMFASettingList": {
							"shape": "S1g"
						}
					}
				}
			},
			"AdminInitiateAuth": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId",
						"AuthFlow"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"AuthFlow": {},
						"AuthParameters": {
							"shape": "S1k"
						},
						"ClientMetadata": {
							"shape": "S1l"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"ContextData": {
							"shape": "S1n"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"AdminLinkProviderForUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"DestinationUser",
						"SourceUser"
					],
					"members": {
						"UserPoolId": {},
						"DestinationUser": {
							"shape": "S12"
						},
						"SourceUser": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminListDevices": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Devices": {
							"shape": "S24"
						},
						"PaginationToken": {}
					}
				}
			},
			"AdminListGroupsForUser": {
				"input": {
					"type": "structure",
					"required": [
						"Username",
						"UserPoolId"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserPoolId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "S28"
						},
						"NextToken": {}
					}
				}
			},
			"AdminListUserAuthEvents": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AuthEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"EventType": {},
									"CreationDate": {
										"type": "timestamp"
									},
									"EventResponse": {},
									"EventRisk": {
										"type": "structure",
										"members": {
											"RiskDecision": {},
											"RiskLevel": {}
										}
									},
									"ChallengeResponses": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"ChallengeName": {},
												"ChallengeResponse": {}
											}
										}
									},
									"EventContextData": {
										"type": "structure",
										"members": {
											"IpAddress": {},
											"DeviceName": {},
											"Timezone": {},
											"City": {},
											"Country": {}
										}
									},
									"EventFeedback": {
										"type": "structure",
										"required": [
											"FeedbackValue",
											"Provider"
										],
										"members": {
											"FeedbackValue": {},
											"Provider": {},
											"FeedbackDate": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"AdminRemoveUserFromGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"GroupName": {}
					}
				}
			},
			"AdminResetUserPassword": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminRespondToAuthChallenge": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId",
						"ChallengeName"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"ChallengeName": {},
						"ChallengeResponses": {
							"shape": "S2x"
						},
						"Session": {},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"ContextData": {
							"shape": "S1n"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"AdminSetUserMFAPreference": {
				"input": {
					"type": "structure",
					"required": [
						"Username",
						"UserPoolId"
					],
					"members": {
						"SMSMfaSettings": {
							"shape": "S30"
						},
						"SoftwareTokenMfaSettings": {
							"shape": "S31"
						},
						"Username": {
							"shape": "Sd"
						},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminSetUserPassword": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"Password"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"Password": {
							"shape": "Sm"
						},
						"Permanent": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminSetUserSettings": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"MFAOptions"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateAuthEventFeedback": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"EventId",
						"FeedbackValue"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"EventId": {},
						"FeedbackValue": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateDeviceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"DeviceKey"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"DeviceKey": {},
						"DeviceRememberedStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"UserAttributes"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUserGlobalSignOut": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateSoftwareToken": {
				"input": {
					"type": "structure",
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"Session": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecretCode": {
							"type": "string",
							"sensitive": true
						},
						"Session": {}
					}
				}
			},
			"ChangePassword": {
				"input": {
					"type": "structure",
					"required": [
						"PreviousPassword",
						"ProposedPassword",
						"AccessToken"
					],
					"members": {
						"PreviousPassword": {
							"shape": "Sm"
						},
						"ProposedPassword": {
							"shape": "Sm"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"ConfirmDevice": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"DeviceKey": {},
						"DeviceSecretVerifierConfig": {
							"type": "structure",
							"members": {
								"PasswordVerifier": {},
								"Salt": {}
							}
						},
						"DeviceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserConfirmationNecessary": {
							"type": "boolean"
						}
					}
				}
			},
			"ConfirmForgotPassword": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"ConfirmationCode",
						"Password"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3r"
						},
						"Username": {
							"shape": "Sd"
						},
						"ConfirmationCode": {},
						"Password": {
							"shape": "Sm"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"ConfirmSignUp": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"ConfirmationCode"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3r"
						},
						"Username": {
							"shape": "Sd"
						},
						"ConfirmationCode": {},
						"ForceAliasCreation": {
							"type": "boolean"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"CreateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {},
						"Description": {},
						"RoleArn": {},
						"Precedence": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S29"
						}
					}
				}
			},
			"CreateIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName",
						"ProviderType",
						"ProviderDetails"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {},
						"ProviderType": {},
						"ProviderDetails": {
							"shape": "S42"
						},
						"AttributeMapping": {
							"shape": "S43"
						},
						"IdpIdentifiers": {
							"shape": "S45"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S48"
						}
					}
				}
			},
			"CreateResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier",
						"Name"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {},
						"Name": {},
						"Scopes": {
							"shape": "S4c"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServer"
					],
					"members": {
						"ResourceServer": {
							"shape": "S4h"
						}
					}
				}
			},
			"CreateUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobName",
						"UserPoolId",
						"CloudWatchLogsRoleArn"
					],
					"members": {
						"JobName": {},
						"UserPoolId": {},
						"CloudWatchLogsRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4l"
						}
					}
				}
			},
			"CreateUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"PoolName"
					],
					"members": {
						"PoolName": {},
						"Policies": {
							"shape": "S4t"
						},
						"LambdaConfig": {
							"shape": "S4x"
						},
						"AutoVerifiedAttributes": {
							"shape": "S4y"
						},
						"AliasAttributes": {
							"shape": "S50"
						},
						"UsernameAttributes": {
							"shape": "S52"
						},
						"SmsVerificationMessage": {},
						"EmailVerificationMessage": {},
						"EmailVerificationSubject": {},
						"VerificationMessageTemplate": {
							"shape": "S57"
						},
						"SmsAuthenticationMessage": {},
						"MfaConfiguration": {},
						"DeviceConfiguration": {
							"shape": "S5c"
						},
						"EmailConfiguration": {
							"shape": "S5d"
						},
						"SmsConfiguration": {
							"shape": "S5g"
						},
						"UserPoolTags": {
							"shape": "S5h"
						},
						"AdminCreateUserConfig": {
							"shape": "S5k"
						},
						"Schema": {
							"shape": "S5n"
						},
						"UserPoolAddOns": {
							"shape": "S5o"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPool": {
							"shape": "S5r"
						}
					}
				}
			},
			"CreateUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientName"
					],
					"members": {
						"UserPoolId": {},
						"ClientName": {},
						"GenerateSecret": {
							"type": "boolean"
						},
						"RefreshTokenValidity": {
							"type": "integer"
						},
						"ReadAttributes": {
							"shape": "S5y"
						},
						"WriteAttributes": {
							"shape": "S5y"
						},
						"ExplicitAuthFlows": {
							"shape": "S60"
						},
						"SupportedIdentityProviders": {
							"shape": "S62"
						},
						"CallbackURLs": {
							"shape": "S63"
						},
						"LogoutURLs": {
							"shape": "S65"
						},
						"DefaultRedirectURI": {},
						"AllowedOAuthFlows": {
							"shape": "S66"
						},
						"AllowedOAuthScopes": {
							"shape": "S68"
						},
						"AllowedOAuthFlowsUserPoolClient": {
							"type": "boolean"
						},
						"AnalyticsConfiguration": {
							"shape": "S6a"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S6d"
						}
					}
				}
			},
			"CreateUserPoolDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Domain",
						"UserPoolId"
					],
					"members": {
						"Domain": {},
						"UserPoolId": {},
						"CustomDomainConfig": {
							"shape": "S6g"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontDomain": {}
					}
				}
			},
			"DeleteGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {}
					}
				}
			},
			"DeleteIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {}
					}
				}
			},
			"DeleteResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {}
					}
				}
			},
			"DeleteUser": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"authtype": "none"
			},
			"DeleteUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserAttributeNames",
						"AccessToken"
					],
					"members": {
						"UserAttributeNames": {
							"shape": "Sz"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"DeleteUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				}
			},
			"DeleteUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				}
			},
			"DeleteUserPoolDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Domain",
						"UserPoolId"
					],
					"members": {
						"Domain": {},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S48"
						}
					}
				}
			},
			"DescribeResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServer"
					],
					"members": {
						"ResourceServer": {
							"shape": "S4h"
						}
					}
				}
			},
			"DescribeRiskConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RiskConfiguration"
					],
					"members": {
						"RiskConfiguration": {
							"shape": "S6y"
						}
					}
				}
			},
			"DescribeUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4l"
						}
					}
				}
			},
			"DescribeUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPool": {
							"shape": "S5r"
						}
					}
				}
			},
			"DescribeUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S6d"
						}
					}
				}
			},
			"DescribeUserPoolDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Domain"
					],
					"members": {
						"Domain": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DomainDescription": {
							"type": "structure",
							"members": {
								"UserPoolId": {},
								"AWSAccountId": {},
								"Domain": {},
								"S3Bucket": {},
								"CloudFrontDistribution": {},
								"Version": {},
								"Status": {},
								"CustomDomainConfig": {
									"shape": "S6g"
								}
							}
						}
					}
				}
			},
			"ForgetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"DeviceKey": {}
					}
				}
			},
			"ForgotPassword": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3r"
						},
						"UserContextData": {
							"shape": "S3t"
						},
						"Username": {
							"shape": "Sd"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S7w"
						}
					}
				},
				"authtype": "none"
			},
			"GetCSVHeader": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolId": {},
						"CSVHeader": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey"
					],
					"members": {
						"DeviceKey": {},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Device"
					],
					"members": {
						"Device": {
							"shape": "S1d"
						}
					}
				}
			},
			"GetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S29"
						}
					}
				}
			},
			"GetIdentityProviderByIdentifier": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"IdpIdentifier"
					],
					"members": {
						"UserPoolId": {},
						"IdpIdentifier": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S48"
						}
					}
				}
			},
			"GetSigningCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Certificate": {}
					}
				}
			},
			"GetUICustomization": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"UICustomization"
					],
					"members": {
						"UICustomization": {
							"shape": "S8a"
						}
					}
				}
			},
			"GetUser": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Username",
						"UserAttributes"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"MFAOptions": {
							"shape": "Sv"
						},
						"PreferredMfaSetting": {},
						"UserMFASettingList": {
							"shape": "S1g"
						}
					}
				},
				"authtype": "none"
			},
			"GetUserAttributeVerificationCode": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"AttributeName"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"AttributeName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S7w"
						}
					}
				},
				"authtype": "none"
			},
			"GetUserPoolMfaConfig": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SmsMfaConfiguration": {
							"shape": "S8k"
						},
						"SoftwareTokenMfaConfiguration": {
							"shape": "S8l"
						},
						"MfaConfiguration": {}
					}
				}
			},
			"GlobalSignOut": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"InitiateAuth": {
				"input": {
					"type": "structure",
					"required": [
						"AuthFlow",
						"ClientId"
					],
					"members": {
						"AuthFlow": {},
						"AuthParameters": {
							"shape": "S1k"
						},
						"ClientMetadata": {
							"shape": "S1l"
						},
						"ClientId": {
							"shape": "S1i"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"ListDevices": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Devices": {
							"shape": "S24"
						},
						"PaginationToken": {}
					}
				}
			},
			"ListGroups": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "S28"
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityProviders": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Providers"
					],
					"members": {
						"Providers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ProviderName": {},
									"ProviderType": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListResourceServers": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServers"
					],
					"members": {
						"ResourceServers": {
							"type": "list",
							"member": {
								"shape": "S4h"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S5h"
						}
					}
				}
			},
			"ListUserImportJobs": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"MaxResults"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJobs": {
							"type": "list",
							"member": {
								"shape": "S4l"
							}
						},
						"PaginationToken": {}
					}
				}
			},
			"ListUserPoolClients": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClients": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ClientId": {
										"shape": "S1i"
									},
									"UserPoolId": {},
									"ClientName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListUserPools": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPools": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"LambdaConfig": {
										"shape": "S4x"
									},
									"Status": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListUsers": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"AttributesToGet": {
							"type": "list",
							"member": {}
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {},
						"Filter": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Users": {
							"shape": "S9n"
						},
						"PaginationToken": {}
					}
				}
			},
			"ListUsersInGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"GroupName": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Users": {
							"shape": "S9n"
						},
						"NextToken": {}
					}
				}
			},
			"ResendConfirmationCode": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3r"
						},
						"UserContextData": {
							"shape": "S3t"
						},
						"Username": {
							"shape": "Sd"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S7w"
						}
					}
				},
				"authtype": "none"
			},
			"RespondToAuthChallenge": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"ChallengeName"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"ChallengeName": {},
						"Session": {},
						"ChallengeResponses": {
							"shape": "S2x"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1t"
						},
						"AuthenticationResult": {
							"shape": "S1u"
						}
					}
				}
			},
			"SetRiskConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"CompromisedCredentialsRiskConfiguration": {
							"shape": "S6z"
						},
						"AccountTakeoverRiskConfiguration": {
							"shape": "S74"
						},
						"RiskExceptionConfiguration": {
							"shape": "S7d"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RiskConfiguration"
					],
					"members": {
						"RiskConfiguration": {
							"shape": "S6y"
						}
					}
				}
			},
			"SetUICustomization": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"CSS": {},
						"ImageFile": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"UICustomization"
					],
					"members": {
						"UICustomization": {
							"shape": "S8a"
						}
					}
				}
			},
			"SetUserMFAPreference": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"SMSMfaSettings": {
							"shape": "S30"
						},
						"SoftwareTokenMfaSettings": {
							"shape": "S31"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"SetUserPoolMfaConfig": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"SmsMfaConfiguration": {
							"shape": "S8k"
						},
						"SoftwareTokenMfaConfiguration": {
							"shape": "S8l"
						},
						"MfaConfiguration": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SmsMfaConfiguration": {
							"shape": "S8k"
						},
						"SoftwareTokenMfaConfiguration": {
							"shape": "S8l"
						},
						"MfaConfiguration": {}
					}
				}
			},
			"SetUserSettings": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"MFAOptions"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"SignUp": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"Password"
					],
					"members": {
						"ClientId": {
							"shape": "S1i"
						},
						"SecretHash": {
							"shape": "S3r"
						},
						"Username": {
							"shape": "Sd"
						},
						"Password": {
							"shape": "Sm"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"ValidationData": {
							"shape": "Si"
						},
						"AnalyticsMetadata": {
							"shape": "S1m"
						},
						"UserContextData": {
							"shape": "S3t"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"UserConfirmed",
						"UserSub"
					],
					"members": {
						"UserConfirmed": {
							"type": "boolean"
						},
						"CodeDeliveryDetails": {
							"shape": "S7w"
						},
						"UserSub": {}
					}
				},
				"authtype": "none"
			},
			"StartUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4l"
						}
					}
				}
			},
			"StopUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S4l"
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S5h"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateAuthEventFeedback": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"EventId",
						"FeedbackToken",
						"FeedbackValue"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"EventId": {},
						"FeedbackToken": {
							"shape": "S1v"
						},
						"FeedbackValue": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateDeviceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"DeviceKey": {},
						"DeviceRememberedStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {},
						"Description": {},
						"RoleArn": {},
						"Precedence": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S29"
						}
					}
				}
			},
			"UpdateIdentityProvider": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ProviderName"
					],
					"members": {
						"UserPoolId": {},
						"ProviderName": {},
						"ProviderDetails": {
							"shape": "S42"
						},
						"AttributeMapping": {
							"shape": "S43"
						},
						"IdpIdentifiers": {
							"shape": "S45"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"IdentityProvider"
					],
					"members": {
						"IdentityProvider": {
							"shape": "S48"
						}
					}
				}
			},
			"UpdateResourceServer": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Identifier",
						"Name"
					],
					"members": {
						"UserPoolId": {},
						"Identifier": {},
						"Name": {},
						"Scopes": {
							"shape": "S4c"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceServer"
					],
					"members": {
						"ResourceServer": {
							"shape": "S4h"
						}
					}
				}
			},
			"UpdateUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserAttributes",
						"AccessToken"
					],
					"members": {
						"UserAttributes": {
							"shape": "Si"
						},
						"AccessToken": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetailsList": {
							"type": "list",
							"member": {
								"shape": "S7w"
							}
						}
					}
				},
				"authtype": "none"
			},
			"UpdateUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"Policies": {
							"shape": "S4t"
						},
						"LambdaConfig": {
							"shape": "S4x"
						},
						"AutoVerifiedAttributes": {
							"shape": "S4y"
						},
						"SmsVerificationMessage": {},
						"EmailVerificationMessage": {},
						"EmailVerificationSubject": {},
						"VerificationMessageTemplate": {
							"shape": "S57"
						},
						"SmsAuthenticationMessage": {},
						"MfaConfiguration": {},
						"DeviceConfiguration": {
							"shape": "S5c"
						},
						"EmailConfiguration": {
							"shape": "S5d"
						},
						"SmsConfiguration": {
							"shape": "S5g"
						},
						"UserPoolTags": {
							"shape": "S5h"
						},
						"AdminCreateUserConfig": {
							"shape": "S5k"
						},
						"UserPoolAddOns": {
							"shape": "S5o"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1i"
						},
						"ClientName": {},
						"RefreshTokenValidity": {
							"type": "integer"
						},
						"ReadAttributes": {
							"shape": "S5y"
						},
						"WriteAttributes": {
							"shape": "S5y"
						},
						"ExplicitAuthFlows": {
							"shape": "S60"
						},
						"SupportedIdentityProviders": {
							"shape": "S62"
						},
						"CallbackURLs": {
							"shape": "S63"
						},
						"LogoutURLs": {
							"shape": "S65"
						},
						"DefaultRedirectURI": {},
						"AllowedOAuthFlows": {
							"shape": "S66"
						},
						"AllowedOAuthScopes": {
							"shape": "S68"
						},
						"AllowedOAuthFlowsUserPoolClient": {
							"type": "boolean"
						},
						"AnalyticsConfiguration": {
							"shape": "S6a"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S6d"
						}
					}
				}
			},
			"UpdateUserPoolDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Domain",
						"UserPoolId",
						"CustomDomainConfig"
					],
					"members": {
						"Domain": {},
						"UserPoolId": {},
						"CustomDomainConfig": {
							"shape": "S6g"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontDomain": {}
					}
				}
			},
			"VerifySoftwareToken": {
				"input": {
					"type": "structure",
					"required": [
						"UserCode"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"Session": {},
						"UserCode": {},
						"FriendlyDeviceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {},
						"Session": {}
					}
				}
			},
			"VerifyUserAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"AttributeName",
						"Code"
					],
					"members": {
						"AccessToken": {
							"shape": "S1v"
						},
						"AttributeName": {},
						"Code": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"Name": {},
					"AttributeDataType": {},
					"DeveloperOnlyAttribute": {
						"type": "boolean"
					},
					"Mutable": {
						"type": "boolean"
					},
					"Required": {
						"type": "boolean"
					},
					"NumberAttributeConstraints": {
						"type": "structure",
						"members": {
							"MinValue": {},
							"MaxValue": {}
						}
					},
					"StringAttributeConstraints": {
						"type": "structure",
						"members": {
							"MinLength": {},
							"MaxLength": {}
						}
					}
				}
			},
			"Sd": {
				"type": "string",
				"sensitive": true
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Value": {
							"type": "string",
							"sensitive": true
						}
					}
				}
			},
			"Sm": {
				"type": "string",
				"sensitive": true
			},
			"Ss": {
				"type": "structure",
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"Attributes": {
						"shape": "Si"
					},
					"UserCreateDate": {
						"type": "timestamp"
					},
					"UserLastModifiedDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"UserStatus": {},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"DeliveryMedium": {},
						"AttributeName": {}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {}
			},
			"S12": {
				"type": "structure",
				"members": {
					"ProviderName": {},
					"ProviderAttributeName": {},
					"ProviderAttributeValue": {}
				}
			},
			"S1d": {
				"type": "structure",
				"members": {
					"DeviceKey": {},
					"DeviceAttributes": {
						"shape": "Si"
					},
					"DeviceCreateDate": {
						"type": "timestamp"
					},
					"DeviceLastModifiedDate": {
						"type": "timestamp"
					},
					"DeviceLastAuthenticatedDate": {
						"type": "timestamp"
					}
				}
			},
			"S1g": {
				"type": "list",
				"member": {}
			},
			"S1i": {
				"type": "string",
				"sensitive": true
			},
			"S1k": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1l": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1m": {
				"type": "structure",
				"members": {
					"AnalyticsEndpointId": {}
				}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"IpAddress",
					"ServerName",
					"ServerPath",
					"HttpHeaders"
				],
				"members": {
					"IpAddress": {},
					"ServerName": {},
					"ServerPath": {},
					"HttpHeaders": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"headerName": {},
								"headerValue": {}
							}
						}
					},
					"EncodedData": {}
				}
			},
			"S1t": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"ExpiresIn": {
						"type": "integer"
					},
					"TokenType": {},
					"RefreshToken": {
						"shape": "S1v"
					},
					"IdToken": {
						"shape": "S1v"
					},
					"NewDeviceMetadata": {
						"type": "structure",
						"members": {
							"DeviceKey": {},
							"DeviceGroupKey": {}
						}
					}
				}
			},
			"S1v": {
				"type": "string",
				"sensitive": true
			},
			"S24": {
				"type": "list",
				"member": {
					"shape": "S1d"
				}
			},
			"S28": {
				"type": "list",
				"member": {
					"shape": "S29"
				}
			},
			"S29": {
				"type": "structure",
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					}
				}
			},
			"S2x": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S30": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"PreferredMfa": {
						"type": "boolean"
					}
				}
			},
			"S31": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"PreferredMfa": {
						"type": "boolean"
					}
				}
			},
			"S3r": {
				"type": "string",
				"sensitive": true
			},
			"S3t": {
				"type": "structure",
				"members": {
					"EncodedData": {}
				}
			},
			"S42": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S43": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S45": {
				"type": "list",
				"member": {}
			},
			"S48": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderType": {},
					"ProviderDetails": {
						"shape": "S42"
					},
					"AttributeMapping": {
						"shape": "S43"
					},
					"IdpIdentifiers": {
						"shape": "S45"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					}
				}
			},
			"S4c": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ScopeName",
						"ScopeDescription"
					],
					"members": {
						"ScopeName": {},
						"ScopeDescription": {}
					}
				}
			},
			"S4h": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S4c"
					}
				}
			},
			"S4l": {
				"type": "structure",
				"members": {
					"JobName": {},
					"JobId": {},
					"UserPoolId": {},
					"PreSignedUrl": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"StartDate": {
						"type": "timestamp"
					},
					"CompletionDate": {
						"type": "timestamp"
					},
					"Status": {},
					"CloudWatchLogsRoleArn": {},
					"ImportedUsers": {
						"type": "long"
					},
					"SkippedUsers": {
						"type": "long"
					},
					"FailedUsers": {
						"type": "long"
					},
					"CompletionMessage": {}
				}
			},
			"S4t": {
				"type": "structure",
				"members": {
					"PasswordPolicy": {
						"type": "structure",
						"members": {
							"MinimumLength": {
								"type": "integer"
							},
							"RequireUppercase": {
								"type": "boolean"
							},
							"RequireLowercase": {
								"type": "boolean"
							},
							"RequireNumbers": {
								"type": "boolean"
							},
							"RequireSymbols": {
								"type": "boolean"
							},
							"TemporaryPasswordValidityDays": {
								"type": "integer"
							}
						}
					}
				}
			},
			"S4x": {
				"type": "structure",
				"members": {
					"PreSignUp": {},
					"CustomMessage": {},
					"PostConfirmation": {},
					"PreAuthentication": {},
					"PostAuthentication": {},
					"DefineAuthChallenge": {},
					"CreateAuthChallenge": {},
					"VerifyAuthChallengeResponse": {},
					"PreTokenGeneration": {},
					"UserMigration": {}
				}
			},
			"S4y": {
				"type": "list",
				"member": {}
			},
			"S50": {
				"type": "list",
				"member": {}
			},
			"S52": {
				"type": "list",
				"member": {}
			},
			"S57": {
				"type": "structure",
				"members": {
					"SmsMessage": {},
					"EmailMessage": {},
					"EmailSubject": {},
					"EmailMessageByLink": {},
					"EmailSubjectByLink": {},
					"DefaultEmailOption": {}
				}
			},
			"S5c": {
				"type": "structure",
				"members": {
					"ChallengeRequiredOnNewDevice": {
						"type": "boolean"
					},
					"DeviceOnlyRememberedOnUserPrompt": {
						"type": "boolean"
					}
				}
			},
			"S5d": {
				"type": "structure",
				"members": {
					"SourceArn": {},
					"ReplyToEmailAddress": {},
					"EmailSendingAccount": {}
				}
			},
			"S5g": {
				"type": "structure",
				"required": [
					"SnsCallerArn"
				],
				"members": {
					"SnsCallerArn": {},
					"ExternalId": {}
				}
			},
			"S5h": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S5k": {
				"type": "structure",
				"members": {
					"AllowAdminCreateUserOnly": {
						"type": "boolean"
					},
					"UnusedAccountValidityDays": {
						"type": "integer"
					},
					"InviteMessageTemplate": {
						"type": "structure",
						"members": {
							"SMSMessage": {},
							"EmailMessage": {},
							"EmailSubject": {}
						}
					}
				}
			},
			"S5n": {
				"type": "list",
				"member": {
					"shape": "S4"
				}
			},
			"S5o": {
				"type": "structure",
				"required": [
					"AdvancedSecurityMode"
				],
				"members": {
					"AdvancedSecurityMode": {}
				}
			},
			"S5r": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Policies": {
						"shape": "S4t"
					},
					"LambdaConfig": {
						"shape": "S4x"
					},
					"Status": {},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"SchemaAttributes": {
						"shape": "S5n"
					},
					"AutoVerifiedAttributes": {
						"shape": "S4y"
					},
					"AliasAttributes": {
						"shape": "S50"
					},
					"UsernameAttributes": {
						"shape": "S52"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S57"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S5c"
					},
					"EstimatedNumberOfUsers": {
						"type": "integer"
					},
					"EmailConfiguration": {
						"shape": "S5d"
					},
					"SmsConfiguration": {
						"shape": "S5g"
					},
					"UserPoolTags": {
						"shape": "S5h"
					},
					"SmsConfigurationFailure": {},
					"EmailConfigurationFailure": {},
					"Domain": {},
					"CustomDomain": {},
					"AdminCreateUserConfig": {
						"shape": "S5k"
					},
					"UserPoolAddOns": {
						"shape": "S5o"
					},
					"Arn": {}
				}
			},
			"S5y": {
				"type": "list",
				"member": {}
			},
			"S60": {
				"type": "list",
				"member": {}
			},
			"S62": {
				"type": "list",
				"member": {}
			},
			"S63": {
				"type": "list",
				"member": {}
			},
			"S65": {
				"type": "list",
				"member": {}
			},
			"S66": {
				"type": "list",
				"member": {}
			},
			"S68": {
				"type": "list",
				"member": {}
			},
			"S6a": {
				"type": "structure",
				"required": [
					"ApplicationId",
					"RoleArn",
					"ExternalId"
				],
				"members": {
					"ApplicationId": {},
					"RoleArn": {},
					"ExternalId": {},
					"UserDataShared": {
						"type": "boolean"
					}
				}
			},
			"S6d": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ClientName": {},
					"ClientId": {
						"shape": "S1i"
					},
					"ClientSecret": {
						"type": "string",
						"sensitive": true
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S5y"
					},
					"WriteAttributes": {
						"shape": "S5y"
					},
					"ExplicitAuthFlows": {
						"shape": "S60"
					},
					"SupportedIdentityProviders": {
						"shape": "S62"
					},
					"CallbackURLs": {
						"shape": "S63"
					},
					"LogoutURLs": {
						"shape": "S65"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S66"
					},
					"AllowedOAuthScopes": {
						"shape": "S68"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					},
					"AnalyticsConfiguration": {
						"shape": "S6a"
					}
				}
			},
			"S6g": {
				"type": "structure",
				"required": [
					"CertificateArn"
				],
				"members": {
					"CertificateArn": {}
				}
			},
			"S6y": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"CompromisedCredentialsRiskConfiguration": {
						"shape": "S6z"
					},
					"AccountTakeoverRiskConfiguration": {
						"shape": "S74"
					},
					"RiskExceptionConfiguration": {
						"shape": "S7d"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"S6z": {
				"type": "structure",
				"required": [
					"Actions"
				],
				"members": {
					"EventFilter": {
						"type": "list",
						"member": {}
					},
					"Actions": {
						"type": "structure",
						"required": [
							"EventAction"
						],
						"members": {
							"EventAction": {}
						}
					}
				}
			},
			"S74": {
				"type": "structure",
				"required": [
					"Actions"
				],
				"members": {
					"NotifyConfiguration": {
						"type": "structure",
						"required": [
							"SourceArn"
						],
						"members": {
							"From": {},
							"ReplyTo": {},
							"SourceArn": {},
							"BlockEmail": {
								"shape": "S76"
							},
							"NoActionEmail": {
								"shape": "S76"
							},
							"MfaEmail": {
								"shape": "S76"
							}
						}
					},
					"Actions": {
						"type": "structure",
						"members": {
							"LowAction": {
								"shape": "S7a"
							},
							"MediumAction": {
								"shape": "S7a"
							},
							"HighAction": {
								"shape": "S7a"
							}
						}
					}
				}
			},
			"S76": {
				"type": "structure",
				"required": [
					"Subject"
				],
				"members": {
					"Subject": {},
					"HtmlBody": {},
					"TextBody": {}
				}
			},
			"S7a": {
				"type": "structure",
				"required": [
					"Notify",
					"EventAction"
				],
				"members": {
					"Notify": {
						"type": "boolean"
					},
					"EventAction": {}
				}
			},
			"S7d": {
				"type": "structure",
				"members": {
					"BlockedIPRangeList": {
						"type": "list",
						"member": {}
					},
					"SkippedIPRangeList": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S7w": {
				"type": "structure",
				"members": {
					"Destination": {},
					"DeliveryMedium": {},
					"AttributeName": {}
				}
			},
			"S8a": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"ImageUrl": {},
					"CSS": {},
					"CSSVersion": {},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					}
				}
			},
			"S8k": {
				"type": "structure",
				"members": {
					"SmsAuthenticationMessage": {},
					"SmsConfiguration": {
						"shape": "S5g"
					}
				}
			},
			"S8l": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S9n": {
				"type": "list",
				"member": {
					"shape": "Ss"
				}
			}
		}
	};

/***/ },
/* 1696 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"AdminListGroupsForUser": {
				"input_token": "NextToken",
				"limit_key": "Limit",
				"output_token": "NextToken",
				"result_key": "Groups"
			},
			"AdminListUserAuthEvents": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "AuthEvents"
			},
			"ListGroups": {
				"input_token": "NextToken",
				"limit_key": "Limit",
				"output_token": "NextToken",
				"result_key": "Groups"
			},
			"ListIdentityProviders": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Providers"
			},
			"ListResourceServers": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ResourceServers"
			},
			"ListUserPoolClients": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "UserPoolClients"
			},
			"ListUserPools": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "UserPools"
			},
			"ListUsersInGroup": {
				"input_token": "NextToken",
				"limit_key": "Limit",
				"output_token": "NextToken",
				"result_key": "Users"
			}
		}
	};

/***/ },
/* 1697 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-30",
			"endpointPrefix": "cognito-sync",
			"jsonVersion": "1.1",
			"serviceFullName": "Amazon Cognito Sync",
			"serviceId": "Cognito Sync",
			"signatureVersion": "v4",
			"protocol": "rest-json",
			"uid": "cognito-sync-2014-06-30"
		},
		"operations": {
			"BulkPublish": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/bulkpublish",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {}
					}
				}
			},
			"DeleteDataset": {
				"http": {
					"method": "DELETE",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Dataset": {
							"shape": "S8"
						}
					}
				}
			},
			"DescribeDataset": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Dataset": {
							"shape": "S8"
						}
					}
				}
			},
			"DescribeIdentityPoolUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolUsage": {
							"shape": "Sg"
						}
					}
				}
			},
			"DescribeIdentityUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityUsage": {
							"type": "structure",
							"members": {
								"IdentityId": {},
								"IdentityPoolId": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"DatasetCount": {
									"type": "integer"
								},
								"DataStorage": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"GetBulkPublishDetails": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/getBulkPublishDetails",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"BulkPublishStartTime": {
							"type": "timestamp"
						},
						"BulkPublishCompleteTime": {
							"type": "timestamp"
						},
						"BulkPublishStatus": {},
						"FailureMessage": {}
					}
				}
			},
			"GetCognitoEvents": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/events",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Events": {
							"shape": "Sq"
						}
					}
				}
			},
			"GetIdentityPoolConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"PushSync": {
							"shape": "Sv"
						},
						"CognitoStreams": {
							"shape": "Sz"
						}
					}
				}
			},
			"ListDatasets": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Datasets": {
							"type": "list",
							"member": {
								"shape": "S8"
							}
						},
						"Count": {
							"type": "integer"
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPoolUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolUsages": {
							"type": "list",
							"member": {
								"shape": "Sg"
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"Count": {
							"type": "integer"
						},
						"NextToken": {}
					}
				}
			},
			"ListRecords": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"LastSyncCount": {
							"location": "querystring",
							"locationName": "lastSyncCount",
							"type": "long"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"SyncSessionToken": {
							"location": "querystring",
							"locationName": "syncSessionToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Records": {
							"shape": "S1c"
						},
						"NextToken": {},
						"Count": {
							"type": "integer"
						},
						"DatasetSyncCount": {
							"type": "long"
						},
						"LastModifiedBy": {},
						"MergedDatasetNames": {
							"type": "list",
							"member": {}
						},
						"DatasetExists": {
							"type": "boolean"
						},
						"DatasetDeletedAfterRequestedSyncCount": {
							"type": "boolean"
						},
						"SyncSessionToken": {}
					}
				}
			},
			"RegisterDevice": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/identity/{IdentityId}/device",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"Platform",
						"Token"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"Platform": {},
						"Token": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeviceId": {}
					}
				}
			},
			"SetCognitoEvents": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/events",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Events"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"Events": {
							"shape": "Sq"
						}
					}
				}
			},
			"SetIdentityPoolConfiguration": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"PushSync": {
							"shape": "Sv"
						},
						"CognitoStreams": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"PushSync": {
							"shape": "Sv"
						},
						"CognitoStreams": {
							"shape": "Sz"
						}
					}
				}
			},
			"SubscribeToDataset": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName",
						"DeviceId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"DeviceId": {
							"location": "uri",
							"locationName": "DeviceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UnsubscribeFromDataset": {
				"http": {
					"method": "DELETE",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName",
						"DeviceId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"DeviceId": {
							"location": "uri",
							"locationName": "DeviceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateRecords": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName",
						"SyncSessionToken"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"DeviceId": {},
						"RecordPatches": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Op",
									"Key",
									"SyncCount"
								],
								"members": {
									"Op": {},
									"Key": {},
									"Value": {},
									"SyncCount": {
										"type": "long"
									},
									"DeviceLastModifiedDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"SyncSessionToken": {},
						"ClientContext": {
							"location": "header",
							"locationName": "x-amz-Client-Context"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Records": {
							"shape": "S1c"
						}
					}
				}
			}
		},
		"shapes": {
			"S8": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"DatasetName": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"LastModifiedBy": {},
					"DataStorage": {
						"type": "long"
					},
					"NumRecords": {
						"type": "long"
					}
				}
			},
			"Sg": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"SyncSessionsCount": {
						"type": "long"
					},
					"DataStorage": {
						"type": "long"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"Sq": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"ApplicationArns": {
						"type": "list",
						"member": {}
					},
					"RoleArn": {}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"StreamName": {},
					"RoleArn": {},
					"StreamingStatus": {}
				}
			},
			"S1c": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {},
						"SyncCount": {
							"type": "long"
						},
						"LastModifiedDate": {
							"type": "timestamp"
						},
						"LastModifiedBy": {},
						"DeviceLastModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			}
		},
		"examples": {}
	};

/***/ },
/* 1698 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-11-27",
			"endpointPrefix": "comprehend",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Comprehend",
			"serviceId": "Comprehend",
			"signatureVersion": "v4",
			"signingName": "comprehend",
			"targetPrefix": "Comprehend_20171127",
			"uid": "comprehend-2017-11-27"
		},
		"operations": {
			"BatchDetectDominantLanguage": {
				"input": {
					"type": "structure",
					"required": [
						"TextList"
					],
					"members": {
						"TextList": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResultList",
						"ErrorList"
					],
					"members": {
						"ResultList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Index": {
										"type": "integer"
									},
									"Languages": {
										"shape": "S8"
									}
								}
							}
						},
						"ErrorList": {
							"shape": "Sb"
						}
					}
				}
			},
			"BatchDetectEntities": {
				"input": {
					"type": "structure",
					"required": [
						"TextList",
						"LanguageCode"
					],
					"members": {
						"TextList": {
							"shape": "S2"
						},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResultList",
						"ErrorList"
					],
					"members": {
						"ResultList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Index": {
										"type": "integer"
									},
									"Entities": {
										"shape": "Si"
									}
								}
							}
						},
						"ErrorList": {
							"shape": "Sb"
						}
					}
				}
			},
			"BatchDetectKeyPhrases": {
				"input": {
					"type": "structure",
					"required": [
						"TextList",
						"LanguageCode"
					],
					"members": {
						"TextList": {
							"shape": "S2"
						},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResultList",
						"ErrorList"
					],
					"members": {
						"ResultList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Index": {
										"type": "integer"
									},
									"KeyPhrases": {
										"shape": "Sp"
									}
								}
							}
						},
						"ErrorList": {
							"shape": "Sb"
						}
					}
				}
			},
			"BatchDetectSentiment": {
				"input": {
					"type": "structure",
					"required": [
						"TextList",
						"LanguageCode"
					],
					"members": {
						"TextList": {
							"shape": "S2"
						},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResultList",
						"ErrorList"
					],
					"members": {
						"ResultList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Index": {
										"type": "integer"
									},
									"Sentiment": {},
									"SentimentScore": {
										"shape": "Sw"
									}
								}
							}
						},
						"ErrorList": {
							"shape": "Sb"
						}
					}
				}
			},
			"BatchDetectSyntax": {
				"input": {
					"type": "structure",
					"required": [
						"TextList",
						"LanguageCode"
					],
					"members": {
						"TextList": {
							"shape": "S2"
						},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResultList",
						"ErrorList"
					],
					"members": {
						"ResultList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Index": {
										"type": "integer"
									},
									"SyntaxTokens": {
										"shape": "S12"
									}
								}
							}
						},
						"ErrorList": {
							"shape": "Sb"
						}
					}
				}
			},
			"CreateDocumentClassifier": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentClassifierName",
						"DataAccessRoleArn",
						"InputDataConfig",
						"LanguageCode"
					],
					"members": {
						"DocumentClassifierName": {},
						"DataAccessRoleArn": {},
						"Tags": {
							"shape": "S19"
						},
						"InputDataConfig": {
							"shape": "S1d"
						},
						"OutputDataConfig": {
							"shape": "S1f"
						},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"LanguageCode": {},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentClassifierArn": {}
					}
				}
			},
			"CreateEntityRecognizer": {
				"input": {
					"type": "structure",
					"required": [
						"RecognizerName",
						"DataAccessRoleArn",
						"InputDataConfig",
						"LanguageCode"
					],
					"members": {
						"RecognizerName": {},
						"DataAccessRoleArn": {},
						"Tags": {
							"shape": "S19"
						},
						"InputDataConfig": {
							"shape": "S1q"
						},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"LanguageCode": {},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EntityRecognizerArn": {}
					}
				}
			},
			"DeleteDocumentClassifier": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentClassifierArn"
					],
					"members": {
						"DocumentClassifierArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteEntityRecognizer": {
				"input": {
					"type": "structure",
					"required": [
						"EntityRecognizerArn"
					],
					"members": {
						"EntityRecognizerArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeDocumentClassificationJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentClassificationJobProperties": {
							"shape": "S26"
						}
					}
				}
			},
			"DescribeDocumentClassifier": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentClassifierArn"
					],
					"members": {
						"DocumentClassifierArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentClassifierProperties": {
							"shape": "S2g"
						}
					}
				}
			},
			"DescribeDominantLanguageDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DominantLanguageDetectionJobProperties": {
							"shape": "S2n"
						}
					}
				}
			},
			"DescribeEntitiesDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EntitiesDetectionJobProperties": {
							"shape": "S2q"
						}
					}
				}
			},
			"DescribeEntityRecognizer": {
				"input": {
					"type": "structure",
					"required": [
						"EntityRecognizerArn"
					],
					"members": {
						"EntityRecognizerArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EntityRecognizerProperties": {
							"shape": "S2t"
						}
					}
				}
			},
			"DescribeKeyPhrasesDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyPhrasesDetectionJobProperties": {
							"shape": "S31"
						}
					}
				}
			},
			"DescribeSentimentDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SentimentDetectionJobProperties": {
							"shape": "S34"
						}
					}
				}
			},
			"DescribeTopicsDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TopicsDetectionJobProperties": {
							"shape": "S37"
						}
					}
				}
			},
			"DetectDominantLanguage": {
				"input": {
					"type": "structure",
					"required": [
						"Text"
					],
					"members": {
						"Text": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Languages": {
							"shape": "S8"
						}
					}
				}
			},
			"DetectEntities": {
				"input": {
					"type": "structure",
					"required": [
						"Text",
						"LanguageCode"
					],
					"members": {
						"Text": {},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Entities": {
							"shape": "Si"
						}
					}
				}
			},
			"DetectKeyPhrases": {
				"input": {
					"type": "structure",
					"required": [
						"Text",
						"LanguageCode"
					],
					"members": {
						"Text": {},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyPhrases": {
							"shape": "Sp"
						}
					}
				}
			},
			"DetectSentiment": {
				"input": {
					"type": "structure",
					"required": [
						"Text",
						"LanguageCode"
					],
					"members": {
						"Text": {},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Sentiment": {},
						"SentimentScore": {
							"shape": "Sw"
						}
					}
				}
			},
			"DetectSyntax": {
				"input": {
					"type": "structure",
					"required": [
						"Text",
						"LanguageCode"
					],
					"members": {
						"Text": {},
						"LanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SyntaxTokens": {
							"shape": "S12"
						}
					}
				}
			},
			"ListDocumentClassificationJobs": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"JobName": {},
								"JobStatus": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentClassificationJobPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S26"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListDocumentClassifiers": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"Status": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentClassifierPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S2g"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListDominantLanguageDetectionJobs": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"JobName": {},
								"JobStatus": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DominantLanguageDetectionJobPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S2n"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListEntitiesDetectionJobs": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"JobName": {},
								"JobStatus": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EntitiesDetectionJobPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S2q"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListEntityRecognizers": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"Status": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EntityRecognizerPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S2t"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListKeyPhrasesDetectionJobs": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"JobName": {},
								"JobStatus": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyPhrasesDetectionJobPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S31"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListSentimentDetectionJobs": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"JobName": {},
								"JobStatus": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SentimentDetectionJobPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S34"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S19"
						}
					}
				}
			},
			"ListTopicsDetectionJobs": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "structure",
							"members": {
								"JobName": {},
								"JobStatus": {},
								"SubmitTimeBefore": {
									"type": "timestamp"
								},
								"SubmitTimeAfter": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TopicsDetectionJobPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S37"
							}
						},
						"NextToken": {}
					}
				}
			},
			"StartDocumentClassificationJob": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentClassifierArn",
						"InputDataConfig",
						"OutputDataConfig",
						"DataAccessRoleArn"
					],
					"members": {
						"JobName": {},
						"DocumentClassifierArn": {},
						"InputDataConfig": {
							"shape": "S2b"
						},
						"OutputDataConfig": {
							"shape": "S2d"
						},
						"DataAccessRoleArn": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StartDominantLanguageDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"InputDataConfig",
						"OutputDataConfig",
						"DataAccessRoleArn"
					],
					"members": {
						"InputDataConfig": {
							"shape": "S2b"
						},
						"OutputDataConfig": {
							"shape": "S2d"
						},
						"DataAccessRoleArn": {},
						"JobName": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StartEntitiesDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"InputDataConfig",
						"OutputDataConfig",
						"DataAccessRoleArn",
						"LanguageCode"
					],
					"members": {
						"InputDataConfig": {
							"shape": "S2b"
						},
						"OutputDataConfig": {
							"shape": "S2d"
						},
						"DataAccessRoleArn": {},
						"JobName": {},
						"EntityRecognizerArn": {},
						"LanguageCode": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StartKeyPhrasesDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"InputDataConfig",
						"OutputDataConfig",
						"DataAccessRoleArn",
						"LanguageCode"
					],
					"members": {
						"InputDataConfig": {
							"shape": "S2b"
						},
						"OutputDataConfig": {
							"shape": "S2d"
						},
						"DataAccessRoleArn": {},
						"JobName": {},
						"LanguageCode": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StartSentimentDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"InputDataConfig",
						"OutputDataConfig",
						"DataAccessRoleArn",
						"LanguageCode"
					],
					"members": {
						"InputDataConfig": {
							"shape": "S2b"
						},
						"OutputDataConfig": {
							"shape": "S2d"
						},
						"DataAccessRoleArn": {},
						"JobName": {},
						"LanguageCode": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StartTopicsDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"InputDataConfig",
						"OutputDataConfig",
						"DataAccessRoleArn"
					],
					"members": {
						"InputDataConfig": {
							"shape": "S2b"
						},
						"OutputDataConfig": {
							"shape": "S2d"
						},
						"DataAccessRoleArn": {},
						"JobName": {},
						"NumberOfTopics": {
							"type": "integer"
						},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"VolumeKmsKeyId": {},
						"VpcConfig": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StopDominantLanguageDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StopEntitiesDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StopKeyPhrasesDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StopSentimentDetectionJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {},
						"JobStatus": {}
					}
				}
			},
			"StopTrainingDocumentClassifier": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentClassifierArn"
					],
					"members": {
						"DocumentClassifierArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StopTrainingEntityRecognizer": {
				"input": {
					"type": "structure",
					"required": [
						"EntityRecognizerArn"
					],
					"members": {
						"EntityRecognizerArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Tags"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S19"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeys"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S8": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"LanguageCode": {},
						"Score": {
							"type": "float"
						}
					}
				}
			},
			"Sb": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Index": {
							"type": "integer"
						},
						"ErrorCode": {},
						"ErrorMessage": {}
					}
				}
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Score": {
							"type": "float"
						},
						"Type": {},
						"Text": {},
						"BeginOffset": {
							"type": "integer"
						},
						"EndOffset": {
							"type": "integer"
						}
					}
				}
			},
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Score": {
							"type": "float"
						},
						"Text": {},
						"BeginOffset": {
							"type": "integer"
						},
						"EndOffset": {
							"type": "integer"
						}
					}
				}
			},
			"Sw": {
				"type": "structure",
				"members": {
					"Positive": {
						"type": "float"
					},
					"Negative": {
						"type": "float"
					},
					"Neutral": {
						"type": "float"
					},
					"Mixed": {
						"type": "float"
					}
				}
			},
			"S12": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"TokenId": {
							"type": "integer"
						},
						"Text": {},
						"BeginOffset": {
							"type": "integer"
						},
						"EndOffset": {
							"type": "integer"
						},
						"PartOfSpeech": {
							"type": "structure",
							"members": {
								"Tag": {},
								"Score": {
									"type": "float"
								}
							}
						}
					}
				}
			},
			"S19": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"required": [
					"S3Uri"
				],
				"members": {
					"S3Uri": {}
				}
			},
			"S1f": {
				"type": "structure",
				"members": {
					"S3Uri": {},
					"KmsKeyId": {}
				}
			},
			"S1i": {
				"type": "structure",
				"required": [
					"SecurityGroupIds",
					"Subnets"
				],
				"members": {
					"SecurityGroupIds": {
						"type": "list",
						"member": {}
					},
					"Subnets": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S1q": {
				"type": "structure",
				"required": [
					"EntityTypes",
					"Documents"
				],
				"members": {
					"EntityTypes": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Type"
							],
							"members": {
								"Type": {}
							}
						}
					},
					"Documents": {
						"type": "structure",
						"required": [
							"S3Uri"
						],
						"members": {
							"S3Uri": {}
						}
					},
					"Annotations": {
						"type": "structure",
						"required": [
							"S3Uri"
						],
						"members": {
							"S3Uri": {}
						}
					},
					"EntityList": {
						"type": "structure",
						"required": [
							"S3Uri"
						],
						"members": {
							"S3Uri": {}
						}
					}
				}
			},
			"S26": {
				"type": "structure",
				"members": {
					"JobId": {},
					"JobName": {},
					"JobStatus": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"DocumentClassifierArn": {},
					"InputDataConfig": {
						"shape": "S2b"
					},
					"OutputDataConfig": {
						"shape": "S2d"
					},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			},
			"S2b": {
				"type": "structure",
				"required": [
					"S3Uri"
				],
				"members": {
					"S3Uri": {},
					"InputFormat": {}
				}
			},
			"S2d": {
				"type": "structure",
				"required": [
					"S3Uri"
				],
				"members": {
					"S3Uri": {},
					"KmsKeyId": {}
				}
			},
			"S2g": {
				"type": "structure",
				"members": {
					"DocumentClassifierArn": {},
					"LanguageCode": {},
					"Status": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"TrainingStartTime": {
						"type": "timestamp"
					},
					"TrainingEndTime": {
						"type": "timestamp"
					},
					"InputDataConfig": {
						"shape": "S1d"
					},
					"OutputDataConfig": {
						"shape": "S1f"
					},
					"ClassifierMetadata": {
						"type": "structure",
						"members": {
							"NumberOfLabels": {
								"type": "integer"
							},
							"NumberOfTrainedDocuments": {
								"type": "integer"
							},
							"NumberOfTestDocuments": {
								"type": "integer"
							},
							"EvaluationMetrics": {
								"type": "structure",
								"members": {
									"Accuracy": {
										"type": "double"
									},
									"Precision": {
										"type": "double"
									},
									"Recall": {
										"type": "double"
									},
									"F1Score": {
										"type": "double"
									}
								}
							}
						}
					},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			},
			"S2n": {
				"type": "structure",
				"members": {
					"JobId": {},
					"JobName": {},
					"JobStatus": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"InputDataConfig": {
						"shape": "S2b"
					},
					"OutputDataConfig": {
						"shape": "S2d"
					},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			},
			"S2q": {
				"type": "structure",
				"members": {
					"JobId": {},
					"JobName": {},
					"JobStatus": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"EntityRecognizerArn": {},
					"InputDataConfig": {
						"shape": "S2b"
					},
					"OutputDataConfig": {
						"shape": "S2d"
					},
					"LanguageCode": {},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			},
			"S2t": {
				"type": "structure",
				"members": {
					"EntityRecognizerArn": {},
					"LanguageCode": {},
					"Status": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"TrainingStartTime": {
						"type": "timestamp"
					},
					"TrainingEndTime": {
						"type": "timestamp"
					},
					"InputDataConfig": {
						"shape": "S1q"
					},
					"RecognizerMetadata": {
						"type": "structure",
						"members": {
							"NumberOfTrainedDocuments": {
								"type": "integer"
							},
							"NumberOfTestDocuments": {
								"type": "integer"
							},
							"EvaluationMetrics": {
								"type": "structure",
								"members": {
									"Precision": {
										"type": "double"
									},
									"Recall": {
										"type": "double"
									},
									"F1Score": {
										"type": "double"
									}
								}
							},
							"EntityTypes": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Type": {},
										"EvaluationMetrics": {
											"type": "structure",
											"members": {
												"Precision": {
													"type": "double"
												},
												"Recall": {
													"type": "double"
												},
												"F1Score": {
													"type": "double"
												}
											}
										},
										"NumberOfTrainMentions": {
											"type": "integer"
										}
									}
								}
							}
						}
					},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			},
			"S31": {
				"type": "structure",
				"members": {
					"JobId": {},
					"JobName": {},
					"JobStatus": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"InputDataConfig": {
						"shape": "S2b"
					},
					"OutputDataConfig": {
						"shape": "S2d"
					},
					"LanguageCode": {},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			},
			"S34": {
				"type": "structure",
				"members": {
					"JobId": {},
					"JobName": {},
					"JobStatus": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"InputDataConfig": {
						"shape": "S2b"
					},
					"OutputDataConfig": {
						"shape": "S2d"
					},
					"LanguageCode": {},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			},
			"S37": {
				"type": "structure",
				"members": {
					"JobId": {},
					"JobName": {},
					"JobStatus": {},
					"Message": {},
					"SubmitTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"InputDataConfig": {
						"shape": "S2b"
					},
					"OutputDataConfig": {
						"shape": "S2d"
					},
					"NumberOfTopics": {
						"type": "integer"
					},
					"DataAccessRoleArn": {},
					"VolumeKmsKeyId": {},
					"VpcConfig": {
						"shape": "S1i"
					}
				}
			}
		}
	};

/***/ },
/* 1699 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListDocumentClassificationJobs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListDocumentClassifiers": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListDominantLanguageDetectionJobs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListEntitiesDetectionJobs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListEntityRecognizers": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListKeyPhrasesDetectionJobs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListSentimentDetectionJobs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListTopicsDetectionJobs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1700 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2018-10-30",
			"endpointPrefix": "comprehendmedical",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "ComprehendMedical",
			"serviceFullName": "AWS Comprehend Medical",
			"serviceId": "ComprehendMedical",
			"signatureVersion": "v4",
			"signingName": "comprehendmedical",
			"targetPrefix": "ComprehendMedical_20181030",
			"uid": "comprehendmedical-2018-10-30"
		},
		"operations": {
			"DetectEntities": {
				"input": {
					"type": "structure",
					"required": [
						"Text"
					],
					"members": {
						"Text": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Entities"
					],
					"members": {
						"Entities": {
							"shape": "S4"
						},
						"UnmappedAttributes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"Attribute": {
										"shape": "Sf"
									}
								}
							}
						},
						"PaginationToken": {}
					}
				}
			},
			"DetectPHI": {
				"input": {
					"type": "structure",
					"required": [
						"Text"
					],
					"members": {
						"Text": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Entities"
					],
					"members": {
						"Entities": {
							"shape": "S4"
						},
						"PaginationToken": {}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Id": {
							"type": "integer"
						},
						"BeginOffset": {
							"type": "integer"
						},
						"EndOffset": {
							"type": "integer"
						},
						"Score": {
							"type": "float"
						},
						"Text": {},
						"Category": {},
						"Type": {},
						"Traits": {
							"shape": "Sb"
						},
						"Attributes": {
							"type": "list",
							"member": {
								"shape": "Sf"
							}
						}
					}
				}
			},
			"Sb": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Name": {},
						"Score": {
							"type": "float"
						}
					}
				}
			},
			"Sf": {
				"type": "structure",
				"members": {
					"Type": {},
					"Score": {
						"type": "float"
					},
					"RelationshipScore": {
						"type": "float"
					},
					"Id": {
						"type": "integer"
					},
					"BeginOffset": {
						"type": "integer"
					},
					"EndOffset": {
						"type": "integer"
					},
					"Text": {},
					"Traits": {
						"shape": "Sb"
					}
				}
			}
		}
	};

/***/ },
/* 1701 */
1641,
/* 1702 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-12",
			"endpointPrefix": "config",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Config Service",
			"serviceFullName": "AWS Config",
			"serviceId": "Config Service",
			"signatureVersion": "v4",
			"targetPrefix": "StarlingDoveService",
			"uid": "config-2014-11-12"
		},
		"operations": {
			"BatchGetAggregateResourceConfig": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName",
						"ResourceIdentifiers"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"ResourceIdentifiers": {
							"type": "list",
							"member": {
								"shape": "S4"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaseConfigurationItems": {
							"shape": "Sb"
						},
						"UnprocessedResourceIdentifiers": {
							"type": "list",
							"member": {
								"shape": "S4"
							}
						}
					}
				}
			},
			"BatchGetResourceConfig": {
				"input": {
					"type": "structure",
					"required": [
						"resourceKeys"
					],
					"members": {
						"resourceKeys": {
							"shape": "Sq"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"baseConfigurationItems": {
							"shape": "Sb"
						},
						"unprocessedResourceKeys": {
							"shape": "Sq"
						}
					}
				}
			},
			"DeleteAggregationAuthorization": {
				"input": {
					"type": "structure",
					"required": [
						"AuthorizedAccountId",
						"AuthorizedAwsRegion"
					],
					"members": {
						"AuthorizedAccountId": {},
						"AuthorizedAwsRegion": {}
					}
				}
			},
			"DeleteConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {}
					}
				}
			},
			"DeleteConfigurationAggregator": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName"
					],
					"members": {
						"ConfigurationAggregatorName": {}
					}
				}
			},
			"DeleteConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorderName"
					],
					"members": {
						"ConfigurationRecorderName": {}
					}
				}
			},
			"DeleteDeliveryChannel": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryChannelName"
					],
					"members": {
						"DeliveryChannelName": {}
					}
				}
			},
			"DeleteEvaluationResults": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteOrganizationConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"OrganizationConfigRuleName"
					],
					"members": {
						"OrganizationConfigRuleName": {}
					}
				}
			},
			"DeletePendingAggregationRequest": {
				"input": {
					"type": "structure",
					"required": [
						"RequesterAccountId",
						"RequesterAwsRegion"
					],
					"members": {
						"RequesterAccountId": {},
						"RequesterAwsRegion": {}
					}
				}
			},
			"DeleteRemediationConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {},
						"ResourceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRetentionConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"RetentionConfigurationName"
					],
					"members": {
						"RetentionConfigurationName": {}
					}
				}
			},
			"DeliverConfigSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"deliveryChannelName"
					],
					"members": {
						"deliveryChannelName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configSnapshotId": {}
					}
				}
			},
			"DescribeAggregateComplianceByConfigRules": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"Filters": {
							"type": "structure",
							"members": {
								"ConfigRuleName": {},
								"ComplianceType": {},
								"AccountId": {},
								"AwsRegion": {}
							}
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AggregateComplianceByConfigRules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ConfigRuleName": {},
									"Compliance": {
										"shape": "S1l"
									},
									"AccountId": {},
									"AwsRegion": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAggregationAuthorizations": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AggregationAuthorizations": {
							"type": "list",
							"member": {
								"shape": "S1t"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeComplianceByConfigRule": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"shape": "S1w"
						},
						"ComplianceTypes": {
							"shape": "S1x"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceByConfigRules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ConfigRuleName": {},
									"Compliance": {
										"shape": "S1l"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeComplianceByResource": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"ComplianceTypes": {
							"shape": "S1x"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceByResources": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceType": {},
									"ResourceId": {},
									"Compliance": {
										"shape": "S1l"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigRuleEvaluationStatus": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"shape": "S1w"
						},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigRulesEvaluationStatus": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ConfigRuleName": {},
									"ConfigRuleArn": {},
									"ConfigRuleId": {},
									"LastSuccessfulInvocationTime": {
										"type": "timestamp"
									},
									"LastFailedInvocationTime": {
										"type": "timestamp"
									},
									"LastSuccessfulEvaluationTime": {
										"type": "timestamp"
									},
									"LastFailedEvaluationTime": {
										"type": "timestamp"
									},
									"FirstActivatedTime": {
										"type": "timestamp"
									},
									"LastErrorCode": {},
									"LastErrorMessage": {},
									"FirstEvaluationStarted": {
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigRules": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"shape": "S1w"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigRules": {
							"type": "list",
							"member": {
								"shape": "S2f"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigurationAggregatorSourcesStatus": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"UpdateStatus": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AggregatedSourceStatusList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SourceId": {},
									"SourceType": {},
									"AwsRegion": {},
									"LastUpdateStatus": {},
									"LastUpdateTime": {
										"type": "timestamp"
									},
									"LastErrorCode": {},
									"LastErrorMessage": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigurationAggregators": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigurationAggregatorNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigurationAggregators": {
							"type": "list",
							"member": {
								"shape": "S34"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigurationRecorderStatus": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigurationRecorderNames": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigurationRecordersStatus": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"lastStartTime": {
										"type": "timestamp"
									},
									"lastStopTime": {
										"type": "timestamp"
									},
									"recording": {
										"type": "boolean"
									},
									"lastStatus": {},
									"lastErrorCode": {},
									"lastErrorMessage": {},
									"lastStatusChangeTime": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeConfigurationRecorders": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigurationRecorderNames": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigurationRecorders": {
							"type": "list",
							"member": {
								"shape": "S3k"
							}
						}
					}
				}
			},
			"DescribeDeliveryChannelStatus": {
				"input": {
					"type": "structure",
					"members": {
						"DeliveryChannelNames": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeliveryChannelsStatus": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"configSnapshotDeliveryInfo": {
										"shape": "S3u"
									},
									"configHistoryDeliveryInfo": {
										"shape": "S3u"
									},
									"configStreamDeliveryInfo": {
										"type": "structure",
										"members": {
											"lastStatus": {},
											"lastErrorCode": {},
											"lastErrorMessage": {},
											"lastStatusChangeTime": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDeliveryChannels": {
				"input": {
					"type": "structure",
					"members": {
						"DeliveryChannelNames": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeliveryChannels": {
							"type": "list",
							"member": {
								"shape": "S40"
							}
						}
					}
				}
			},
			"DescribeOrganizationConfigRuleStatuses": {
				"input": {
					"type": "structure",
					"members": {
						"OrganizationConfigRuleNames": {
							"shape": "S43"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OrganizationConfigRuleStatuses": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"OrganizationConfigRuleName",
									"OrganizationRuleStatus"
								],
								"members": {
									"OrganizationConfigRuleName": {},
									"OrganizationRuleStatus": {},
									"ErrorCode": {},
									"ErrorMessage": {},
									"LastUpdateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeOrganizationConfigRules": {
				"input": {
					"type": "structure",
					"members": {
						"OrganizationConfigRuleNames": {
							"shape": "S43"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OrganizationConfigRules": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"OrganizationConfigRuleName",
									"OrganizationConfigRuleArn"
								],
								"members": {
									"OrganizationConfigRuleName": {},
									"OrganizationConfigRuleArn": {},
									"OrganizationManagedRuleMetadata": {
										"shape": "S4d"
									},
									"OrganizationCustomRuleMetadata": {
										"shape": "S4i"
									},
									"ExcludedAccounts": {
										"shape": "S4l"
									},
									"LastUpdateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePendingAggregationRequests": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PendingAggregationRequests": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RequesterAccountId": {},
									"RequesterAwsRegion": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeRemediationConfigurations": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleNames"
					],
					"members": {
						"ConfigRuleNames": {
							"shape": "S1w"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RemediationConfigurations": {
							"shape": "S4t"
						}
					}
				}
			},
			"DescribeRemediationExecutionStatus": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {},
						"ResourceKeys": {
							"shape": "Sq"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RemediationExecutionStatuses": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceKey": {
										"shape": "Sr"
									},
									"State": {},
									"StepDetails": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Name": {},
												"State": {},
												"ErrorMessage": {},
												"StartTime": {
													"type": "timestamp"
												},
												"StopTime": {
													"type": "timestamp"
												}
											}
										}
									},
									"InvocationTime": {
										"type": "timestamp"
									},
									"LastUpdatedTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeRetentionConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"RetentionConfigurationNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RetentionConfigurations": {
							"type": "list",
							"member": {
								"shape": "S5e"
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetAggregateComplianceDetailsByConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName",
						"ConfigRuleName",
						"AccountId",
						"AwsRegion"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"ConfigRuleName": {},
						"AccountId": {},
						"AwsRegion": {},
						"ComplianceType": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AggregateEvaluationResults": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EvaluationResultIdentifier": {
										"shape": "S5k"
									},
									"ComplianceType": {},
									"ResultRecordedTime": {
										"type": "timestamp"
									},
									"ConfigRuleInvokedTime": {
										"type": "timestamp"
									},
									"Annotation": {},
									"AccountId": {},
									"AwsRegion": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetAggregateConfigRuleComplianceSummary": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"Filters": {
							"type": "structure",
							"members": {
								"AccountId": {},
								"AwsRegion": {}
							}
						},
						"GroupByKey": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GroupByKey": {},
						"AggregateComplianceCounts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GroupName": {},
									"ComplianceSummary": {
										"shape": "S5s"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetAggregateDiscoveredResourceCounts": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"Filters": {
							"type": "structure",
							"members": {
								"ResourceType": {},
								"AccountId": {},
								"Region": {}
							}
						},
						"GroupByKey": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TotalDiscoveredResources"
					],
					"members": {
						"TotalDiscoveredResources": {
							"type": "long"
						},
						"GroupByKey": {},
						"GroupedResourceCounts": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"GroupName",
									"ResourceCount"
								],
								"members": {
									"GroupName": {},
									"ResourceCount": {
										"type": "long"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetAggregateResourceConfig": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName",
						"ResourceIdentifier"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"ResourceIdentifier": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigurationItem": {
							"shape": "S62"
						}
					}
				}
			},
			"GetComplianceDetailsByConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {},
						"ComplianceTypes": {
							"shape": "S1x"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationResults": {
							"shape": "S6e"
						},
						"NextToken": {}
					}
				}
			},
			"GetComplianceDetailsByResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"ComplianceTypes": {
							"shape": "S1x"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationResults": {
							"shape": "S6e"
						},
						"NextToken": {}
					}
				}
			},
			"GetComplianceSummaryByConfigRule": {
				"output": {
					"type": "structure",
					"members": {
						"ComplianceSummary": {
							"shape": "S5s"
						}
					}
				}
			},
			"GetComplianceSummaryByResourceType": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceTypes": {
							"shape": "S6k"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceSummariesByResourceType": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceType": {},
									"ComplianceSummary": {
										"shape": "S5s"
									}
								}
							}
						}
					}
				}
			},
			"GetDiscoveredResourceCounts": {
				"input": {
					"type": "structure",
					"members": {
						"resourceTypes": {
							"shape": "S6k"
						},
						"limit": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"totalDiscoveredResources": {
							"type": "long"
						},
						"resourceCounts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"resourceType": {},
									"count": {
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetOrganizationConfigRuleDetailedStatus": {
				"input": {
					"type": "structure",
					"required": [
						"OrganizationConfigRuleName"
					],
					"members": {
						"OrganizationConfigRuleName": {},
						"Filters": {
							"type": "structure",
							"members": {
								"AccountId": {},
								"MemberAccountRuleStatus": {}
							}
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OrganizationConfigRuleDetailedStatus": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"AccountId",
									"ConfigRuleName",
									"MemberAccountRuleStatus"
								],
								"members": {
									"AccountId": {},
									"ConfigRuleName": {},
									"MemberAccountRuleStatus": {},
									"ErrorCode": {},
									"ErrorMessage": {},
									"LastUpdateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetResourceConfigHistory": {
				"input": {
					"type": "structure",
					"required": [
						"resourceType",
						"resourceId"
					],
					"members": {
						"resourceType": {},
						"resourceId": {},
						"laterTime": {
							"type": "timestamp"
						},
						"earlierTime": {
							"type": "timestamp"
						},
						"chronologicalOrder": {},
						"limit": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configurationItems": {
							"type": "list",
							"member": {
								"shape": "S62"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAggregateDiscoveredResources": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName",
						"ResourceType"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"ResourceType": {},
						"Filters": {
							"type": "structure",
							"members": {
								"AccountId": {},
								"ResourceId": {},
								"ResourceName": {},
								"Region": {}
							}
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceIdentifiers": {
							"type": "list",
							"member": {
								"shape": "S4"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListDiscoveredResources": {
				"input": {
					"type": "structure",
					"required": [
						"resourceType"
					],
					"members": {
						"resourceType": {},
						"resourceIds": {
							"type": "list",
							"member": {}
						},
						"resourceName": {},
						"limit": {
							"type": "integer"
						},
						"includeDeletedResources": {
							"type": "boolean"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"resourceIdentifiers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"resourceType": {},
									"resourceId": {},
									"resourceName": {},
									"resourceDeletionTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S7h"
						},
						"NextToken": {}
					}
				}
			},
			"PutAggregationAuthorization": {
				"input": {
					"type": "structure",
					"required": [
						"AuthorizedAccountId",
						"AuthorizedAwsRegion"
					],
					"members": {
						"AuthorizedAccountId": {},
						"AuthorizedAwsRegion": {},
						"Tags": {
							"shape": "S7m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AggregationAuthorization": {
							"shape": "S1t"
						}
					}
				}
			},
			"PutConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRule"
					],
					"members": {
						"ConfigRule": {
							"shape": "S2f"
						},
						"Tags": {
							"shape": "S7m"
						}
					}
				}
			},
			"PutConfigurationAggregator": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationAggregatorName"
					],
					"members": {
						"ConfigurationAggregatorName": {},
						"AccountAggregationSources": {
							"shape": "S36"
						},
						"OrganizationAggregationSource": {
							"shape": "S3a"
						},
						"Tags": {
							"shape": "S7m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigurationAggregator": {
							"shape": "S34"
						}
					}
				}
			},
			"PutConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorder"
					],
					"members": {
						"ConfigurationRecorder": {
							"shape": "S3k"
						}
					}
				}
			},
			"PutDeliveryChannel": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryChannel"
					],
					"members": {
						"DeliveryChannel": {
							"shape": "S40"
						}
					}
				}
			},
			"PutEvaluations": {
				"input": {
					"type": "structure",
					"required": [
						"ResultToken"
					],
					"members": {
						"Evaluations": {
							"shape": "S7u"
						},
						"ResultToken": {},
						"TestMode": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEvaluations": {
							"shape": "S7u"
						}
					}
				}
			},
			"PutOrganizationConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"OrganizationConfigRuleName"
					],
					"members": {
						"OrganizationConfigRuleName": {},
						"OrganizationManagedRuleMetadata": {
							"shape": "S4d"
						},
						"OrganizationCustomRuleMetadata": {
							"shape": "S4i"
						},
						"ExcludedAccounts": {
							"shape": "S4l"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OrganizationConfigRuleArn": {}
					}
				}
			},
			"PutRemediationConfigurations": {
				"input": {
					"type": "structure",
					"required": [
						"RemediationConfigurations"
					],
					"members": {
						"RemediationConfigurations": {
							"shape": "S4t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedBatches": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FailureMessage": {},
									"FailedItems": {
										"shape": "S4t"
									}
								}
							}
						}
					}
				}
			},
			"PutRetentionConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"RetentionPeriodInDays"
					],
					"members": {
						"RetentionPeriodInDays": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RetentionConfiguration": {
							"shape": "S5e"
						}
					}
				}
			},
			"SelectResourceConfig": {
				"input": {
					"type": "structure",
					"required": [
						"Expression"
					],
					"members": {
						"Expression": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {}
						},
						"QueryInfo": {
							"type": "structure",
							"members": {
								"SelectFields": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"StartConfigRulesEvaluation": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StartConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorderName"
					],
					"members": {
						"ConfigurationRecorderName": {}
					}
				}
			},
			"StartRemediationExecution": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName",
						"ResourceKeys"
					],
					"members": {
						"ConfigRuleName": {},
						"ResourceKeys": {
							"shape": "Sq"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailureMessage": {},
						"FailedItems": {
							"shape": "Sq"
						}
					}
				}
			},
			"StopConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorderName"
					],
					"members": {
						"ConfigurationRecorderName": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Tags"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S7h"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeys"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"required": [
					"SourceAccountId",
					"SourceRegion",
					"ResourceId",
					"ResourceType"
				],
				"members": {
					"SourceAccountId": {},
					"SourceRegion": {},
					"ResourceId": {},
					"ResourceType": {},
					"ResourceName": {}
				}
			},
			"Sb": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"version": {},
						"accountId": {},
						"configurationItemCaptureTime": {
							"type": "timestamp"
						},
						"configurationItemStatus": {},
						"configurationStateId": {},
						"arn": {},
						"resourceType": {},
						"resourceId": {},
						"resourceName": {},
						"awsRegion": {},
						"availabilityZone": {},
						"resourceCreationTime": {
							"type": "timestamp"
						},
						"configuration": {},
						"supplementaryConfiguration": {
							"shape": "Sl"
						}
					}
				}
			},
			"Sl": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sq": {
				"type": "list",
				"member": {
					"shape": "Sr"
				}
			},
			"Sr": {
				"type": "structure",
				"required": [
					"resourceType",
					"resourceId"
				],
				"members": {
					"resourceType": {},
					"resourceId": {}
				}
			},
			"S1l": {
				"type": "structure",
				"members": {
					"ComplianceType": {},
					"ComplianceContributorCount": {
						"shape": "S1m"
					}
				}
			},
			"S1m": {
				"type": "structure",
				"members": {
					"CappedCount": {
						"type": "integer"
					},
					"CapExceeded": {
						"type": "boolean"
					}
				}
			},
			"S1t": {
				"type": "structure",
				"members": {
					"AggregationAuthorizationArn": {},
					"AuthorizedAccountId": {},
					"AuthorizedAwsRegion": {},
					"CreationTime": {
						"type": "timestamp"
					}
				}
			},
			"S1w": {
				"type": "list",
				"member": {}
			},
			"S1x": {
				"type": "list",
				"member": {}
			},
			"S2f": {
				"type": "structure",
				"required": [
					"Source"
				],
				"members": {
					"ConfigRuleName": {},
					"ConfigRuleArn": {},
					"ConfigRuleId": {},
					"Description": {},
					"Scope": {
						"type": "structure",
						"members": {
							"ComplianceResourceTypes": {
								"type": "list",
								"member": {}
							},
							"TagKey": {},
							"TagValue": {},
							"ComplianceResourceId": {}
						}
					},
					"Source": {
						"type": "structure",
						"required": [
							"Owner",
							"SourceIdentifier"
						],
						"members": {
							"Owner": {},
							"SourceIdentifier": {},
							"SourceDetails": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"EventSource": {},
										"MessageType": {},
										"MaximumExecutionFrequency": {}
									}
								}
							}
						}
					},
					"InputParameters": {},
					"MaximumExecutionFrequency": {},
					"ConfigRuleState": {},
					"CreatedBy": {}
				}
			},
			"S34": {
				"type": "structure",
				"members": {
					"ConfigurationAggregatorName": {},
					"ConfigurationAggregatorArn": {},
					"AccountAggregationSources": {
						"shape": "S36"
					},
					"OrganizationAggregationSource": {
						"shape": "S3a"
					},
					"CreationTime": {
						"type": "timestamp"
					},
					"LastUpdatedTime": {
						"type": "timestamp"
					}
				}
			},
			"S36": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AccountIds"
					],
					"members": {
						"AccountIds": {
							"type": "list",
							"member": {}
						},
						"AllAwsRegions": {
							"type": "boolean"
						},
						"AwsRegions": {
							"shape": "S39"
						}
					}
				}
			},
			"S39": {
				"type": "list",
				"member": {}
			},
			"S3a": {
				"type": "structure",
				"required": [
					"RoleArn"
				],
				"members": {
					"RoleArn": {},
					"AwsRegions": {
						"shape": "S39"
					},
					"AllAwsRegions": {
						"type": "boolean"
					}
				}
			},
			"S3c": {
				"type": "list",
				"member": {}
			},
			"S3k": {
				"type": "structure",
				"members": {
					"name": {},
					"roleARN": {},
					"recordingGroup": {
						"type": "structure",
						"members": {
							"allSupported": {
								"type": "boolean"
							},
							"includeGlobalResourceTypes": {
								"type": "boolean"
							},
							"resourceTypes": {
								"type": "list",
								"member": {}
							}
						}
					}
				}
			},
			"S3q": {
				"type": "list",
				"member": {}
			},
			"S3u": {
				"type": "structure",
				"members": {
					"lastStatus": {},
					"lastErrorCode": {},
					"lastErrorMessage": {},
					"lastAttemptTime": {
						"type": "timestamp"
					},
					"lastSuccessfulTime": {
						"type": "timestamp"
					},
					"nextDeliveryTime": {
						"type": "timestamp"
					}
				}
			},
			"S40": {
				"type": "structure",
				"members": {
					"name": {},
					"s3BucketName": {},
					"s3KeyPrefix": {},
					"snsTopicARN": {},
					"configSnapshotDeliveryProperties": {
						"type": "structure",
						"members": {
							"deliveryFrequency": {}
						}
					}
				}
			},
			"S43": {
				"type": "list",
				"member": {}
			},
			"S4d": {
				"type": "structure",
				"required": [
					"RuleIdentifier"
				],
				"members": {
					"Description": {},
					"RuleIdentifier": {},
					"InputParameters": {},
					"MaximumExecutionFrequency": {},
					"ResourceTypesScope": {
						"shape": "S4g"
					},
					"ResourceIdScope": {},
					"TagKeyScope": {},
					"TagValueScope": {}
				}
			},
			"S4g": {
				"type": "list",
				"member": {}
			},
			"S4i": {
				"type": "structure",
				"required": [
					"LambdaFunctionArn",
					"OrganizationConfigRuleTriggerTypes"
				],
				"members": {
					"Description": {},
					"LambdaFunctionArn": {},
					"OrganizationConfigRuleTriggerTypes": {
						"type": "list",
						"member": {}
					},
					"InputParameters": {},
					"MaximumExecutionFrequency": {},
					"ResourceTypesScope": {
						"shape": "S4g"
					},
					"ResourceIdScope": {},
					"TagKeyScope": {},
					"TagValueScope": {}
				}
			},
			"S4l": {
				"type": "list",
				"member": {}
			},
			"S4t": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ConfigRuleName",
						"TargetType",
						"TargetId"
					],
					"members": {
						"ConfigRuleName": {},
						"TargetType": {},
						"TargetId": {},
						"TargetVersion": {},
						"Parameters": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"ResourceValue": {
										"type": "structure",
										"members": {
											"Value": {}
										}
									},
									"StaticValue": {
										"type": "structure",
										"members": {
											"Values": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						},
						"ResourceType": {}
					}
				}
			},
			"S5e": {
				"type": "structure",
				"required": [
					"Name",
					"RetentionPeriodInDays"
				],
				"members": {
					"Name": {},
					"RetentionPeriodInDays": {
						"type": "integer"
					}
				}
			},
			"S5k": {
				"type": "structure",
				"members": {
					"EvaluationResultQualifier": {
						"type": "structure",
						"members": {
							"ConfigRuleName": {},
							"ResourceType": {},
							"ResourceId": {}
						}
					},
					"OrderingTimestamp": {
						"type": "timestamp"
					}
				}
			},
			"S5s": {
				"type": "structure",
				"members": {
					"CompliantResourceCount": {
						"shape": "S1m"
					},
					"NonCompliantResourceCount": {
						"shape": "S1m"
					},
					"ComplianceSummaryTimestamp": {
						"type": "timestamp"
					}
				}
			},
			"S62": {
				"type": "structure",
				"members": {
					"version": {},
					"accountId": {},
					"configurationItemCaptureTime": {
						"type": "timestamp"
					},
					"configurationItemStatus": {},
					"configurationStateId": {},
					"configurationItemMD5Hash": {},
					"arn": {},
					"resourceType": {},
					"resourceId": {},
					"resourceName": {},
					"awsRegion": {},
					"availabilityZone": {},
					"resourceCreationTime": {
						"type": "timestamp"
					},
					"tags": {
						"type": "map",
						"key": {},
						"value": {}
					},
					"relatedEvents": {
						"type": "list",
						"member": {}
					},
					"relationships": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"resourceType": {},
								"resourceId": {},
								"resourceName": {},
								"relationshipName": {}
							}
						}
					},
					"configuration": {},
					"supplementaryConfiguration": {
						"shape": "Sl"
					}
				}
			},
			"S6e": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"EvaluationResultIdentifier": {
							"shape": "S5k"
						},
						"ComplianceType": {},
						"ResultRecordedTime": {
							"type": "timestamp"
						},
						"ConfigRuleInvokedTime": {
							"type": "timestamp"
						},
						"Annotation": {},
						"ResultToken": {}
					}
				}
			},
			"S6k": {
				"type": "list",
				"member": {}
			},
			"S7h": {
				"type": "list",
				"member": {
					"shape": "S7i"
				}
			},
			"S7i": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S7m": {
				"type": "list",
				"member": {
					"shape": "S7i"
				}
			},
			"S7u": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ComplianceResourceType",
						"ComplianceResourceId",
						"ComplianceType",
						"OrderingTimestamp"
					],
					"members": {
						"ComplianceResourceType": {},
						"ComplianceResourceId": {},
						"ComplianceType": {},
						"Annotation": {},
						"OrderingTimestamp": {
							"type": "timestamp"
						}
					}
				}
			}
		}
	};

/***/ },
/* 1703 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeRemediationExecutionStatus": {
				"input_token": "NextToken",
				"limit_key": "Limit",
				"output_token": "NextToken",
				"result_key": "RemediationExecutionStatuses"
			},
			"GetResourceConfigHistory": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": "configurationItems"
			}
		}
	};

/***/ },
/* 1704 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-01-06",
			"endpointPrefix": "cur",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Cost and Usage Report Service",
			"serviceId": "Cost and Usage Report Service",
			"signatureVersion": "v4",
			"signingName": "cur",
			"targetPrefix": "AWSOrigamiServiceGatewayService",
			"uid": "cur-2017-01-06"
		},
		"operations": {
			"DeleteReportDefinition": {
				"input": {
					"type": "structure",
					"members": {
						"ReportName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResponseMessage": {}
					}
				}
			},
			"DescribeReportDefinitions": {
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReportDefinitions": {
							"type": "list",
							"member": {
								"shape": "Sa"
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutReportDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"ReportDefinition"
					],
					"members": {
						"ReportDefinition": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"Sa": {
				"type": "structure",
				"required": [
					"ReportName",
					"TimeUnit",
					"Format",
					"Compression",
					"AdditionalSchemaElements",
					"S3Bucket",
					"S3Prefix",
					"S3Region"
				],
				"members": {
					"ReportName": {},
					"TimeUnit": {},
					"Format": {},
					"Compression": {},
					"AdditionalSchemaElements": {
						"type": "list",
						"member": {}
					},
					"S3Bucket": {},
					"S3Prefix": {},
					"S3Region": {},
					"AdditionalArtifacts": {
						"type": "list",
						"member": {}
					},
					"RefreshClosedReports": {
						"type": "boolean"
					},
					"ReportVersioning": {}
				}
			}
		}
	};

/***/ },
/* 1705 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeReportDefinitions": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1706 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-06-23",
			"endpointPrefix": "devicefarm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Device Farm",
			"serviceId": "Device Farm",
			"signatureVersion": "v4",
			"targetPrefix": "DeviceFarm_20150623",
			"uid": "devicefarm-2015-06-23"
		},
		"operations": {
			"CreateDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"name",
						"rules"
					],
					"members": {
						"projectArn": {},
						"name": {},
						"description": {},
						"rules": {
							"shape": "S5"
						},
						"maxDevices": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePool": {
							"shape": "Sc"
						}
					}
				}
			},
			"CreateInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"description": {},
						"packageCleanup": {
							"type": "boolean"
						},
						"excludeAppPackagesFromCleanup": {
							"shape": "Sg"
						},
						"rebootAfterUse": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceProfile": {
							"shape": "Si"
						}
					}
				}
			},
			"CreateNetworkProfile": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"name"
					],
					"members": {
						"projectArn": {},
						"name": {},
						"description": {},
						"type": {},
						"uplinkBandwidthBits": {
							"type": "long"
						},
						"downlinkBandwidthBits": {
							"type": "long"
						},
						"uplinkDelayMs": {
							"type": "long"
						},
						"downlinkDelayMs": {
							"type": "long"
						},
						"uplinkJitterMs": {
							"type": "long"
						},
						"downlinkJitterMs": {
							"type": "long"
						},
						"uplinkLossPercent": {
							"type": "integer"
						},
						"downlinkLossPercent": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"networkProfile": {
							"shape": "So"
						}
					}
				}
			},
			"CreateProject": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"defaultJobTimeoutMinutes": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "Ss"
						}
					}
				}
			},
			"CreateRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"deviceArn"
					],
					"members": {
						"projectArn": {},
						"deviceArn": {},
						"instanceArn": {},
						"sshPublicKey": {},
						"remoteDebugEnabled": {
							"type": "boolean"
						},
						"remoteRecordEnabled": {
							"type": "boolean"
						},
						"remoteRecordAppArn": {},
						"name": {},
						"clientId": {},
						"configuration": {
							"type": "structure",
							"members": {
								"billingMethod": {},
								"vpceConfigurationArns": {
									"shape": "Sz"
								}
							}
						},
						"interactionMode": {},
						"skipAppResign": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSession": {
							"shape": "S12"
						}
					}
				}
			},
			"CreateUpload": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"name",
						"type"
					],
					"members": {
						"projectArn": {},
						"name": {},
						"type": {},
						"contentType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"upload": {
							"shape": "S1n"
						}
					}
				}
			},
			"CreateVPCEConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"vpceConfigurationName",
						"vpceServiceName",
						"serviceDnsName"
					],
					"members": {
						"vpceConfigurationName": {},
						"vpceServiceName": {},
						"serviceDnsName": {},
						"vpceConfigurationDescription": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"vpceConfiguration": {
							"shape": "S1y"
						}
					}
				}
			},
			"DeleteDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteNetworkProfile": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteProject": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRun": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteUpload": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteVPCEConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"GetAccountSettings": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"accountSettings": {
							"type": "structure",
							"members": {
								"awsAccountNumber": {},
								"unmeteredDevices": {
									"shape": "S2j"
								},
								"unmeteredRemoteAccessDevices": {
									"shape": "S2j"
								},
								"maxJobTimeoutMinutes": {
									"type": "integer"
								},
								"trialMinutes": {
									"type": "structure",
									"members": {
										"total": {
											"type": "double"
										},
										"remaining": {
											"type": "double"
										}
									}
								},
								"maxSlots": {
									"type": "map",
									"key": {},
									"value": {
										"type": "integer"
									}
								},
								"defaultJobTimeoutMinutes": {
									"type": "integer"
								},
								"skipAppResign": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"GetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"device": {
							"shape": "S15"
						}
					}
				}
			},
			"GetDeviceInstance": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deviceInstance": {
							"shape": "S1c"
						}
					}
				}
			},
			"GetDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePool": {
							"shape": "Sc"
						}
					}
				}
			},
			"GetDevicePoolCompatibility": {
				"input": {
					"type": "structure",
					"required": [
						"devicePoolArn"
					],
					"members": {
						"devicePoolArn": {},
						"appArn": {},
						"testType": {},
						"test": {
							"shape": "S2u"
						},
						"configuration": {
							"shape": "S2x"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"compatibleDevices": {
							"shape": "S35"
						},
						"incompatibleDevices": {
							"shape": "S35"
						}
					}
				}
			},
			"GetInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceProfile": {
							"shape": "Si"
						}
					}
				}
			},
			"GetJob": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"job": {
							"shape": "S3d"
						}
					}
				}
			},
			"GetNetworkProfile": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"networkProfile": {
							"shape": "So"
						}
					}
				}
			},
			"GetOfferingStatus": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"current": {
							"shape": "S3l"
						},
						"nextPeriod": {
							"shape": "S3l"
						},
						"nextToken": {}
					}
				}
			},
			"GetProject": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "Ss"
						}
					}
				}
			},
			"GetRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSession": {
							"shape": "S12"
						}
					}
				}
			},
			"GetRun": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"run": {
							"shape": "S42"
						}
					}
				}
			},
			"GetSuite": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"suite": {
							"shape": "S4b"
						}
					}
				}
			},
			"GetTest": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"test": {
							"shape": "S4e"
						}
					}
				}
			},
			"GetUpload": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"upload": {
							"shape": "S1n"
						}
					}
				}
			},
			"GetVPCEConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"vpceConfiguration": {
							"shape": "S1y"
						}
					}
				}
			},
			"InstallToRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"remoteAccessSessionArn",
						"appArn"
					],
					"members": {
						"remoteAccessSessionArn": {},
						"appArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"appUpload": {
							"shape": "S1n"
						}
					}
				}
			},
			"ListArtifacts": {
				"input": {
					"type": "structure",
					"required": [
						"arn",
						"type"
					],
					"members": {
						"arn": {},
						"type": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"artifacts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"arn": {},
									"name": {},
									"type": {},
									"extension": {},
									"url": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListDeviceInstances": {
				"input": {
					"type": "structure",
					"members": {
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deviceInstances": {
							"shape": "S1b"
						},
						"nextToken": {}
					}
				}
			},
			"ListDevicePools": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"type": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePools": {
							"type": "list",
							"member": {
								"shape": "Sc"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListDevices": {
				"input": {
					"type": "structure",
					"members": {
						"arn": {},
						"nextToken": {},
						"filters": {
							"shape": "S45"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devices": {
							"type": "list",
							"member": {
								"shape": "S15"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListInstanceProfiles": {
				"input": {
					"type": "structure",
					"members": {
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceProfiles": {
							"type": "list",
							"member": {
								"shape": "Si"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListJobs": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobs": {
							"type": "list",
							"member": {
								"shape": "S3d"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListNetworkProfiles": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"type": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"networkProfiles": {
							"type": "list",
							"member": {
								"shape": "So"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListOfferingPromotions": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offeringPromotions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"id": {},
									"description": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListOfferingTransactions": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offeringTransactions": {
							"type": "list",
							"member": {
								"shape": "S5g"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offerings": {
							"type": "list",
							"member": {
								"shape": "S3p"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListProjects": {
				"input": {
					"type": "structure",
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"projects": {
							"type": "list",
							"member": {
								"shape": "Ss"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListRemoteAccessSessions": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSessions": {
							"type": "list",
							"member": {
								"shape": "S12"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListRuns": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"runs": {
							"type": "list",
							"member": {
								"shape": "S42"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListSamples": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"samples": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"arn": {},
									"type": {},
									"url": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListSuites": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"suites": {
							"type": "list",
							"member": {
								"shape": "S4b"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN"
					],
					"members": {
						"ResourceARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S64"
						}
					}
				}
			},
			"ListTests": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tests": {
							"type": "list",
							"member": {
								"shape": "S4e"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListUniqueProblems": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"uniqueProblems": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"message": {},
										"problems": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"run": {
														"shape": "S6i"
													},
													"job": {
														"shape": "S6i"
													},
													"suite": {
														"shape": "S6i"
													},
													"test": {
														"shape": "S6i"
													},
													"device": {
														"shape": "S15"
													},
													"result": {},
													"message": {}
												}
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListUploads": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"type": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"uploads": {
							"type": "list",
							"member": {
								"shape": "S1n"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListVPCEConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"vpceConfigurations": {
							"type": "list",
							"member": {
								"shape": "S1y"
							}
						},
						"nextToken": {}
					}
				}
			},
			"PurchaseOffering": {
				"input": {
					"type": "structure",
					"members": {
						"offeringId": {},
						"quantity": {
							"type": "integer"
						},
						"offeringPromotionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offeringTransaction": {
							"shape": "S5g"
						}
					}
				}
			},
			"RenewOffering": {
				"input": {
					"type": "structure",
					"members": {
						"offeringId": {},
						"quantity": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offeringTransaction": {
							"shape": "S5g"
						}
					}
				}
			},
			"ScheduleRun": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"test"
					],
					"members": {
						"projectArn": {},
						"appArn": {},
						"devicePoolArn": {},
						"deviceSelectionConfiguration": {
							"type": "structure",
							"required": [
								"filters",
								"maxDevices"
							],
							"members": {
								"filters": {
									"shape": "S45"
								},
								"maxDevices": {
									"type": "integer"
								}
							}
						},
						"name": {},
						"test": {
							"shape": "S2u"
						},
						"configuration": {
							"shape": "S2x"
						},
						"executionConfiguration": {
							"type": "structure",
							"members": {
								"jobTimeoutMinutes": {
									"type": "integer"
								},
								"accountsCleanup": {
									"type": "boolean"
								},
								"appPackagesCleanup": {
									"type": "boolean"
								},
								"videoCapture": {
									"type": "boolean"
								},
								"skipAppResign": {
									"type": "boolean"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"run": {
							"shape": "S42"
						}
					}
				}
			},
			"StopJob": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"job": {
							"shape": "S3d"
						}
					}
				}
			},
			"StopRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSession": {
							"shape": "S12"
						}
					}
				}
			},
			"StopRun": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"run": {
							"shape": "S42"
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"Tags"
					],
					"members": {
						"ResourceARN": {},
						"Tags": {
							"shape": "S64"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"TagKeys"
					],
					"members": {
						"ResourceARN": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateDeviceInstance": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"profileArn": {},
						"labels": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deviceInstance": {
							"shape": "S1c"
						}
					}
				}
			},
			"UpdateDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"name": {},
						"description": {},
						"rules": {
							"shape": "S5"
						},
						"maxDevices": {
							"type": "integer"
						},
						"clearMaxDevices": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePool": {
							"shape": "Sc"
						}
					}
				}
			},
			"UpdateInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"name": {},
						"description": {},
						"packageCleanup": {
							"type": "boolean"
						},
						"excludeAppPackagesFromCleanup": {
							"shape": "Sg"
						},
						"rebootAfterUse": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceProfile": {
							"shape": "Si"
						}
					}
				}
			},
			"UpdateNetworkProfile": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"name": {},
						"description": {},
						"type": {},
						"uplinkBandwidthBits": {
							"type": "long"
						},
						"downlinkBandwidthBits": {
							"type": "long"
						},
						"uplinkDelayMs": {
							"type": "long"
						},
						"downlinkDelayMs": {
							"type": "long"
						},
						"uplinkJitterMs": {
							"type": "long"
						},
						"downlinkJitterMs": {
							"type": "long"
						},
						"uplinkLossPercent": {
							"type": "integer"
						},
						"downlinkLossPercent": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"networkProfile": {
							"shape": "So"
						}
					}
				}
			},
			"UpdateProject": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"name": {},
						"defaultJobTimeoutMinutes": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "Ss"
						}
					}
				}
			},
			"UpdateUpload": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"name": {},
						"contentType": {},
						"editContent": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"upload": {
							"shape": "S1n"
						}
					}
				}
			},
			"UpdateVPCEConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"vpceConfigurationName": {},
						"vpceServiceName": {},
						"serviceDnsName": {},
						"vpceConfigurationDescription": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"vpceConfiguration": {
							"shape": "S1y"
						}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"attribute": {},
						"operator": {},
						"value": {}
					}
				}
			},
			"Sc": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"description": {},
					"type": {},
					"rules": {
						"shape": "S5"
					},
					"maxDevices": {
						"type": "integer"
					}
				}
			},
			"Sg": {
				"type": "list",
				"member": {}
			},
			"Si": {
				"type": "structure",
				"members": {
					"arn": {},
					"packageCleanup": {
						"type": "boolean"
					},
					"excludeAppPackagesFromCleanup": {
						"shape": "Sg"
					},
					"rebootAfterUse": {
						"type": "boolean"
					},
					"name": {},
					"description": {}
				}
			},
			"So": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"description": {},
					"type": {},
					"uplinkBandwidthBits": {
						"type": "long"
					},
					"downlinkBandwidthBits": {
						"type": "long"
					},
					"uplinkDelayMs": {
						"type": "long"
					},
					"downlinkDelayMs": {
						"type": "long"
					},
					"uplinkJitterMs": {
						"type": "long"
					},
					"downlinkJitterMs": {
						"type": "long"
					},
					"uplinkLossPercent": {
						"type": "integer"
					},
					"downlinkLossPercent": {
						"type": "integer"
					}
				}
			},
			"Ss": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"defaultJobTimeoutMinutes": {
						"type": "integer"
					},
					"created": {
						"type": "timestamp"
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {}
			},
			"S12": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"message": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"device": {
						"shape": "S15"
					},
					"instanceArn": {},
					"remoteDebugEnabled": {
						"type": "boolean"
					},
					"remoteRecordEnabled": {
						"type": "boolean"
					},
					"remoteRecordAppArn": {},
					"hostAddress": {},
					"clientId": {},
					"billingMethod": {},
					"deviceMinutes": {
						"shape": "S1h"
					},
					"endpoint": {},
					"deviceUdid": {},
					"interactionMode": {},
					"skipAppResign": {
						"type": "boolean"
					}
				}
			},
			"S15": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"manufacturer": {},
					"model": {},
					"modelId": {},
					"formFactor": {},
					"platform": {},
					"os": {},
					"cpu": {
						"type": "structure",
						"members": {
							"frequency": {},
							"architecture": {},
							"clock": {
								"type": "double"
							}
						}
					},
					"resolution": {
						"type": "structure",
						"members": {
							"width": {
								"type": "integer"
							},
							"height": {
								"type": "integer"
							}
						}
					},
					"heapSize": {
						"type": "long"
					},
					"memory": {
						"type": "long"
					},
					"image": {},
					"carrier": {},
					"radio": {},
					"remoteAccessEnabled": {
						"type": "boolean"
					},
					"remoteDebugEnabled": {
						"type": "boolean"
					},
					"fleetType": {},
					"fleetName": {},
					"instances": {
						"shape": "S1b"
					},
					"availability": {}
				}
			},
			"S1b": {
				"type": "list",
				"member": {
					"shape": "S1c"
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"arn": {},
					"deviceArn": {},
					"labels": {
						"shape": "S1d"
					},
					"status": {},
					"udid": {},
					"instanceProfile": {
						"shape": "Si"
					}
				}
			},
			"S1d": {
				"type": "list",
				"member": {}
			},
			"S1h": {
				"type": "structure",
				"members": {
					"total": {
						"type": "double"
					},
					"metered": {
						"type": "double"
					},
					"unmetered": {
						"type": "double"
					}
				}
			},
			"S1n": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"created": {
						"type": "timestamp"
					},
					"type": {},
					"status": {},
					"url": {},
					"metadata": {},
					"contentType": {},
					"message": {},
					"category": {}
				}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"arn": {},
					"vpceConfigurationName": {},
					"vpceServiceName": {},
					"serviceDnsName": {},
					"vpceConfigurationDescription": {}
				}
			},
			"S2j": {
				"type": "map",
				"key": {},
				"value": {
					"type": "integer"
				}
			},
			"S2u": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"testPackageArn": {},
					"testSpecArn": {},
					"filter": {},
					"parameters": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			},
			"S2x": {
				"type": "structure",
				"members": {
					"extraDataPackageArn": {},
					"networkProfileArn": {},
					"locale": {},
					"location": {
						"shape": "S2y"
					},
					"vpceConfigurationArns": {
						"shape": "Sz"
					},
					"customerArtifactPaths": {
						"shape": "S2z"
					},
					"radios": {
						"shape": "S33"
					},
					"auxiliaryApps": {
						"shape": "Sz"
					},
					"billingMethod": {}
				}
			},
			"S2y": {
				"type": "structure",
				"required": [
					"latitude",
					"longitude"
				],
				"members": {
					"latitude": {
						"type": "double"
					},
					"longitude": {
						"type": "double"
					}
				}
			},
			"S2z": {
				"type": "structure",
				"members": {
					"iosPaths": {
						"type": "list",
						"member": {}
					},
					"androidPaths": {
						"type": "list",
						"member": {}
					},
					"deviceHostPaths": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S33": {
				"type": "structure",
				"members": {
					"wifi": {
						"type": "boolean"
					},
					"bluetooth": {
						"type": "boolean"
					},
					"nfc": {
						"type": "boolean"
					},
					"gps": {
						"type": "boolean"
					}
				}
			},
			"S35": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"device": {
							"shape": "S15"
						},
						"compatible": {
							"type": "boolean"
						},
						"incompatibilityMessages": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"message": {},
									"type": {}
								}
							}
						}
					}
				}
			},
			"S3d": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S3e"
					},
					"message": {},
					"device": {
						"shape": "S15"
					},
					"instanceArn": {},
					"deviceMinutes": {
						"shape": "S1h"
					},
					"videoEndpoint": {},
					"videoCapture": {
						"type": "boolean"
					}
				}
			},
			"S3e": {
				"type": "structure",
				"members": {
					"total": {
						"type": "integer"
					},
					"passed": {
						"type": "integer"
					},
					"failed": {
						"type": "integer"
					},
					"warned": {
						"type": "integer"
					},
					"errored": {
						"type": "integer"
					},
					"stopped": {
						"type": "integer"
					},
					"skipped": {
						"type": "integer"
					}
				}
			},
			"S3l": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S3n"
				}
			},
			"S3n": {
				"type": "structure",
				"members": {
					"type": {},
					"offering": {
						"shape": "S3p"
					},
					"quantity": {
						"type": "integer"
					},
					"effectiveOn": {
						"type": "timestamp"
					}
				}
			},
			"S3p": {
				"type": "structure",
				"members": {
					"id": {},
					"description": {},
					"type": {},
					"platform": {},
					"recurringCharges": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"cost": {
									"shape": "S3t"
								},
								"frequency": {}
							}
						}
					}
				}
			},
			"S3t": {
				"type": "structure",
				"members": {
					"amount": {
						"type": "double"
					},
					"currencyCode": {}
				}
			},
			"S42": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"platform": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S3e"
					},
					"message": {},
					"totalJobs": {
						"type": "integer"
					},
					"completedJobs": {
						"type": "integer"
					},
					"billingMethod": {},
					"deviceMinutes": {
						"shape": "S1h"
					},
					"networkProfile": {
						"shape": "So"
					},
					"parsingResultUrl": {},
					"resultCode": {},
					"seed": {
						"type": "integer"
					},
					"appUpload": {},
					"eventCount": {
						"type": "integer"
					},
					"jobTimeoutMinutes": {
						"type": "integer"
					},
					"devicePoolArn": {},
					"locale": {},
					"radios": {
						"shape": "S33"
					},
					"location": {
						"shape": "S2y"
					},
					"customerArtifactPaths": {
						"shape": "S2z"
					},
					"webUrl": {},
					"skipAppResign": {
						"type": "boolean"
					},
					"testSpecArn": {},
					"deviceSelectionResult": {
						"type": "structure",
						"members": {
							"filters": {
								"shape": "S45"
							},
							"matchedDevicesCount": {
								"type": "integer"
							},
							"maxDevices": {
								"type": "integer"
							}
						}
					}
				}
			},
			"S45": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"attribute": {},
						"operator": {},
						"values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S4b": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S3e"
					},
					"message": {},
					"deviceMinutes": {
						"shape": "S1h"
					}
				}
			},
			"S4e": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S3e"
					},
					"message": {},
					"deviceMinutes": {
						"shape": "S1h"
					}
				}
			},
			"S5g": {
				"type": "structure",
				"members": {
					"offeringStatus": {
						"shape": "S3n"
					},
					"transactionId": {},
					"offeringPromotionId": {},
					"createdOn": {
						"type": "timestamp"
					},
					"cost": {
						"shape": "S3t"
					}
				}
			},
			"S64": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S6i": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {}
				}
			}
		}
	};

/***/ },
/* 1707 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetOfferingStatus": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": [
					"current",
					"nextPeriod"
				]
			},
			"ListArtifacts": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "artifacts"
			},
			"ListDevicePools": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "devicePools"
			},
			"ListDevices": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "devices"
			},
			"ListJobs": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "jobs"
			},
			"ListOfferingTransactions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "offeringTransactions"
			},
			"ListOfferings": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "offerings"
			},
			"ListProjects": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "projects"
			},
			"ListRuns": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "runs"
			},
			"ListSamples": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "samples"
			},
			"ListSuites": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "suites"
			},
			"ListTests": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "tests"
			},
			"ListUniqueProblems": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "uniqueProblems"
			},
			"ListUploads": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "uploads"
			}
		}
	};

/***/ },
/* 1708 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-10-25",
			"endpointPrefix": "directconnect",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Direct Connect",
			"serviceId": "Direct Connect",
			"signatureVersion": "v4",
			"targetPrefix": "OvertureService",
			"uid": "directconnect-2012-10-25"
		},
		"operations": {
			"AcceptDirectConnectGatewayAssociationProposal": {
				"input": {
					"type": "structure",
					"required": [
						"directConnectGatewayId",
						"proposalId",
						"associatedGatewayOwnerAccount"
					],
					"members": {
						"directConnectGatewayId": {},
						"proposalId": {},
						"associatedGatewayOwnerAccount": {},
						"overrideAllowedPrefixesToDirectConnectGateway": {
							"shape": "S5"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociation": {
							"shape": "S9"
						}
					}
				}
			},
			"AllocateConnectionOnInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"bandwidth",
						"connectionName",
						"ownerAccount",
						"interconnectId",
						"vlan"
					],
					"members": {
						"bandwidth": {},
						"connectionName": {},
						"ownerAccount": {},
						"interconnectId": {},
						"vlan": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "So"
				},
				"deprecated": true
			},
			"AllocateHostedConnection": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"ownerAccount",
						"bandwidth",
						"connectionName",
						"vlan"
					],
					"members": {
						"connectionId": {},
						"ownerAccount": {},
						"bandwidth": {},
						"connectionName": {},
						"vlan": {
							"type": "integer"
						},
						"tags": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"shape": "So"
				}
			},
			"AllocatePrivateVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"ownerAccount",
						"newPrivateVirtualInterfaceAllocation"
					],
					"members": {
						"connectionId": {},
						"ownerAccount": {},
						"newPrivateVirtualInterfaceAllocation": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"mtu": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"addressFamily": {},
								"customerAddress": {},
								"tags": {
									"shape": "Sz"
								}
							}
						}
					}
				},
				"output": {
					"shape": "S1d"
				}
			},
			"AllocatePublicVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"ownerAccount",
						"newPublicVirtualInterfaceAllocation"
					],
					"members": {
						"connectionId": {},
						"ownerAccount": {},
						"newPublicVirtualInterfaceAllocation": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"routeFilterPrefixes": {
									"shape": "S5"
								},
								"tags": {
									"shape": "Sz"
								}
							}
						}
					}
				},
				"output": {
					"shape": "S1d"
				}
			},
			"AllocateTransitVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"ownerAccount",
						"newTransitVirtualInterfaceAllocation"
					],
					"members": {
						"connectionId": {},
						"ownerAccount": {},
						"newTransitVirtualInterfaceAllocation": {
							"type": "structure",
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"mtu": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"tags": {
									"shape": "Sz"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterface": {
							"shape": "S1d"
						}
					}
				}
			},
			"AssociateConnectionWithLag": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"lagId"
					],
					"members": {
						"connectionId": {},
						"lagId": {}
					}
				},
				"output": {
					"shape": "So"
				}
			},
			"AssociateHostedConnection": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"parentConnectionId"
					],
					"members": {
						"connectionId": {},
						"parentConnectionId": {}
					}
				},
				"output": {
					"shape": "So"
				}
			},
			"AssociateVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId",
						"connectionId"
					],
					"members": {
						"virtualInterfaceId": {},
						"connectionId": {}
					}
				},
				"output": {
					"shape": "S1d"
				}
			},
			"ConfirmConnection": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"connectionState": {}
					}
				}
			},
			"ConfirmPrivateVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId"
					],
					"members": {
						"virtualInterfaceId": {},
						"virtualGatewayId": {
							"shape": "Sh"
						},
						"directConnectGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaceState": {}
					}
				}
			},
			"ConfirmPublicVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId"
					],
					"members": {
						"virtualInterfaceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaceState": {}
					}
				}
			},
			"ConfirmTransitVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId",
						"directConnectGatewayId"
					],
					"members": {
						"virtualInterfaceId": {},
						"directConnectGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaceState": {}
					}
				}
			},
			"CreateBGPPeer": {
				"input": {
					"type": "structure",
					"members": {
						"virtualInterfaceId": {},
						"newBGPPeer": {
							"type": "structure",
							"members": {
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"addressFamily": {},
								"amazonAddress": {},
								"customerAddress": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterface": {
							"shape": "S1d"
						}
					}
				}
			},
			"CreateConnection": {
				"input": {
					"type": "structure",
					"required": [
						"location",
						"bandwidth",
						"connectionName"
					],
					"members": {
						"location": {},
						"bandwidth": {},
						"connectionName": {},
						"lagId": {},
						"tags": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"shape": "So"
				}
			},
			"CreateDirectConnectGateway": {
				"input": {
					"type": "structure",
					"required": [
						"directConnectGatewayName"
					],
					"members": {
						"directConnectGatewayName": {},
						"amazonSideAsn": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGateway": {
							"shape": "S2b"
						}
					}
				}
			},
			"CreateDirectConnectGatewayAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"directConnectGatewayId"
					],
					"members": {
						"directConnectGatewayId": {},
						"gatewayId": {},
						"addAllowedPrefixesToDirectConnectGateway": {
							"shape": "S5"
						},
						"virtualGatewayId": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociation": {
							"shape": "S9"
						}
					}
				}
			},
			"CreateDirectConnectGatewayAssociationProposal": {
				"input": {
					"type": "structure",
					"required": [
						"directConnectGatewayId",
						"directConnectGatewayOwnerAccount",
						"gatewayId"
					],
					"members": {
						"directConnectGatewayId": {},
						"directConnectGatewayOwnerAccount": {},
						"gatewayId": {},
						"addAllowedPrefixesToDirectConnectGateway": {
							"shape": "S5"
						},
						"removeAllowedPrefixesToDirectConnectGateway": {
							"shape": "S5"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociationProposal": {
							"shape": "S2i"
						}
					}
				}
			},
			"CreateInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectName",
						"bandwidth",
						"location"
					],
					"members": {
						"interconnectName": {},
						"bandwidth": {},
						"location": {},
						"lagId": {},
						"tags": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"shape": "S2m"
				}
			},
			"CreateLag": {
				"input": {
					"type": "structure",
					"required": [
						"numberOfConnections",
						"location",
						"connectionsBandwidth",
						"lagName"
					],
					"members": {
						"numberOfConnections": {
							"type": "integer"
						},
						"location": {},
						"connectionsBandwidth": {},
						"lagName": {},
						"connectionId": {},
						"tags": {
							"shape": "Sz"
						},
						"childConnectionTags": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"shape": "S2r"
				}
			},
			"CreatePrivateVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"newPrivateVirtualInterface"
					],
					"members": {
						"connectionId": {},
						"newPrivateVirtualInterface": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"mtu": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"virtualGatewayId": {
									"shape": "Sh"
								},
								"directConnectGatewayId": {},
								"tags": {
									"shape": "Sz"
								}
							}
						}
					}
				},
				"output": {
					"shape": "S1d"
				}
			},
			"CreatePublicVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"newPublicVirtualInterface"
					],
					"members": {
						"connectionId": {},
						"newPublicVirtualInterface": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"routeFilterPrefixes": {
									"shape": "S5"
								},
								"tags": {
									"shape": "Sz"
								}
							}
						}
					}
				},
				"output": {
					"shape": "S1d"
				}
			},
			"CreateTransitVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"newTransitVirtualInterface"
					],
					"members": {
						"connectionId": {},
						"newTransitVirtualInterface": {
							"type": "structure",
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"mtu": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"directConnectGatewayId": {},
								"tags": {
									"shape": "Sz"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterface": {
							"shape": "S1d"
						}
					}
				}
			},
			"DeleteBGPPeer": {
				"input": {
					"type": "structure",
					"members": {
						"virtualInterfaceId": {},
						"asn": {
							"type": "integer"
						},
						"customerAddress": {},
						"bgpPeerId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterface": {
							"shape": "S1d"
						}
					}
				}
			},
			"DeleteConnection": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {}
					}
				},
				"output": {
					"shape": "So"
				}
			},
			"DeleteDirectConnectGateway": {
				"input": {
					"type": "structure",
					"required": [
						"directConnectGatewayId"
					],
					"members": {
						"directConnectGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGateway": {
							"shape": "S2b"
						}
					}
				}
			},
			"DeleteDirectConnectGatewayAssociation": {
				"input": {
					"type": "structure",
					"members": {
						"associationId": {},
						"directConnectGatewayId": {},
						"virtualGatewayId": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociation": {
							"shape": "S9"
						}
					}
				}
			},
			"DeleteDirectConnectGatewayAssociationProposal": {
				"input": {
					"type": "structure",
					"required": [
						"proposalId"
					],
					"members": {
						"proposalId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociationProposal": {
							"shape": "S2i"
						}
					}
				}
			},
			"DeleteInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectId"
					],
					"members": {
						"interconnectId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"interconnectState": {}
					}
				}
			},
			"DeleteLag": {
				"input": {
					"type": "structure",
					"required": [
						"lagId"
					],
					"members": {
						"lagId": {}
					}
				},
				"output": {
					"shape": "S2r"
				}
			},
			"DeleteVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId"
					],
					"members": {
						"virtualInterfaceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaceState": {}
					}
				}
			},
			"DescribeConnectionLoa": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {},
						"providerName": {},
						"loaContentType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"loa": {
							"shape": "S3k"
						}
					}
				},
				"deprecated": true
			},
			"DescribeConnections": {
				"input": {
					"type": "structure",
					"members": {
						"connectionId": {}
					}
				},
				"output": {
					"shape": "S3n"
				}
			},
			"DescribeConnectionsOnInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectId"
					],
					"members": {
						"interconnectId": {}
					}
				},
				"output": {
					"shape": "S3n"
				},
				"deprecated": true
			},
			"DescribeDirectConnectGatewayAssociationProposals": {
				"input": {
					"type": "structure",
					"members": {
						"directConnectGatewayId": {},
						"proposalId": {},
						"associatedGatewayId": {},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociationProposals": {
							"type": "list",
							"member": {
								"shape": "S2i"
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeDirectConnectGatewayAssociations": {
				"input": {
					"type": "structure",
					"members": {
						"associationId": {},
						"associatedGatewayId": {},
						"directConnectGatewayId": {},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {},
						"virtualGatewayId": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociations": {
							"type": "list",
							"member": {
								"shape": "S9"
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeDirectConnectGatewayAttachments": {
				"input": {
					"type": "structure",
					"members": {
						"directConnectGatewayId": {},
						"virtualInterfaceId": {},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAttachments": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"directConnectGatewayId": {},
									"virtualInterfaceId": {},
									"virtualInterfaceRegion": {},
									"virtualInterfaceOwnerAccount": {},
									"attachmentState": {},
									"attachmentType": {},
									"stateChangeError": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeDirectConnectGateways": {
				"input": {
					"type": "structure",
					"members": {
						"directConnectGatewayId": {},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGateways": {
							"type": "list",
							"member": {
								"shape": "S2b"
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeHostedConnections": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {}
					}
				},
				"output": {
					"shape": "S3n"
				}
			},
			"DescribeInterconnectLoa": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectId"
					],
					"members": {
						"interconnectId": {},
						"providerName": {},
						"loaContentType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"loa": {
							"shape": "S3k"
						}
					}
				},
				"deprecated": true
			},
			"DescribeInterconnects": {
				"input": {
					"type": "structure",
					"members": {
						"interconnectId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"interconnects": {
							"type": "list",
							"member": {
								"shape": "S2m"
							}
						}
					}
				}
			},
			"DescribeLags": {
				"input": {
					"type": "structure",
					"members": {
						"lagId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"lags": {
							"type": "list",
							"member": {
								"shape": "S2r"
							}
						}
					}
				}
			},
			"DescribeLoa": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {},
						"providerName": {},
						"loaContentType": {}
					}
				},
				"output": {
					"shape": "S3k"
				}
			},
			"DescribeLocations": {
				"output": {
					"type": "structure",
					"members": {
						"locations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"locationCode": {},
									"locationName": {},
									"region": {},
									"availablePortSpeeds": {
										"type": "list",
										"member": {}
									}
								}
							}
						}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArns"
					],
					"members": {
						"resourceArns": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"resourceTags": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"resourceArn": {},
									"tags": {
										"shape": "Sz"
									}
								}
							}
						}
					}
				}
			},
			"DescribeVirtualGateways": {
				"output": {
					"type": "structure",
					"members": {
						"virtualGateways": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"virtualGatewayId": {
										"shape": "Sh"
									},
									"virtualGatewayState": {}
								}
							}
						}
					}
				}
			},
			"DescribeVirtualInterfaces": {
				"input": {
					"type": "structure",
					"members": {
						"connectionId": {},
						"virtualInterfaceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaces": {
							"type": "list",
							"member": {
								"shape": "S1d"
							}
						}
					}
				}
			},
			"DisassociateConnectionFromLag": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"lagId"
					],
					"members": {
						"connectionId": {},
						"lagId": {}
					}
				},
				"output": {
					"shape": "So"
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {},
						"tagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateDirectConnectGatewayAssociation": {
				"input": {
					"type": "structure",
					"members": {
						"associationId": {},
						"addAllowedPrefixesToDirectConnectGateway": {
							"shape": "S5"
						},
						"removeAllowedPrefixesToDirectConnectGateway": {
							"shape": "S5"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"directConnectGatewayAssociation": {
							"shape": "S9"
						}
					}
				}
			},
			"UpdateLag": {
				"input": {
					"type": "structure",
					"required": [
						"lagId"
					],
					"members": {
						"lagId": {},
						"lagName": {},
						"minimumLinks": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S2r"
				}
			},
			"UpdateVirtualInterfaceAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId"
					],
					"members": {
						"virtualInterfaceId": {},
						"mtu": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S1d"
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"cidr": {}
					}
				}
			},
			"S9": {
				"type": "structure",
				"members": {
					"directConnectGatewayId": {},
					"directConnectGatewayOwnerAccount": {},
					"associationState": {},
					"stateChangeError": {},
					"associatedGateway": {
						"shape": "Sc"
					},
					"associationId": {},
					"allowedPrefixesToDirectConnectGateway": {
						"shape": "S5"
					},
					"virtualGatewayId": {
						"shape": "Sh"
					},
					"virtualGatewayRegion": {
						"type": "string",
						"deprecated": true
					},
					"virtualGatewayOwnerAccount": {}
				}
			},
			"Sc": {
				"type": "structure",
				"members": {
					"id": {},
					"type": {},
					"ownerAccount": {},
					"region": {}
				}
			},
			"Sh": {
				"type": "string",
				"deprecated": true
			},
			"So": {
				"type": "structure",
				"members": {
					"ownerAccount": {},
					"connectionId": {},
					"connectionName": {},
					"connectionState": {},
					"region": {},
					"location": {},
					"bandwidth": {},
					"vlan": {
						"type": "integer"
					},
					"partnerName": {},
					"loaIssueTime": {
						"type": "timestamp"
					},
					"lagId": {},
					"awsDevice": {
						"shape": "Sv"
					},
					"jumboFrameCapable": {
						"type": "boolean"
					},
					"awsDeviceV2": {},
					"hasLogicalRedundancy": {},
					"tags": {
						"shape": "Sz"
					}
				}
			},
			"Sv": {
				"type": "string",
				"deprecated": true
			},
			"Sz": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"members": {
					"ownerAccount": {},
					"virtualInterfaceId": {},
					"location": {},
					"connectionId": {},
					"virtualInterfaceType": {},
					"virtualInterfaceName": {},
					"vlan": {
						"type": "integer"
					},
					"asn": {
						"type": "integer"
					},
					"amazonSideAsn": {
						"type": "long"
					},
					"authKey": {},
					"amazonAddress": {},
					"customerAddress": {},
					"addressFamily": {},
					"virtualInterfaceState": {},
					"customerRouterConfig": {},
					"mtu": {
						"type": "integer"
					},
					"jumboFrameCapable": {
						"type": "boolean"
					},
					"virtualGatewayId": {
						"shape": "Sh"
					},
					"directConnectGatewayId": {},
					"routeFilterPrefixes": {
						"shape": "S5"
					},
					"bgpPeers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"bgpPeerId": {},
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"addressFamily": {},
								"amazonAddress": {},
								"customerAddress": {},
								"bgpPeerState": {},
								"bgpStatus": {},
								"awsDeviceV2": {}
							}
						}
					},
					"region": {},
					"awsDeviceV2": {},
					"tags": {
						"shape": "Sz"
					}
				}
			},
			"S2b": {
				"type": "structure",
				"members": {
					"directConnectGatewayId": {},
					"directConnectGatewayName": {},
					"amazonSideAsn": {
						"type": "long"
					},
					"ownerAccount": {},
					"directConnectGatewayState": {},
					"stateChangeError": {}
				}
			},
			"S2i": {
				"type": "structure",
				"members": {
					"proposalId": {},
					"directConnectGatewayId": {},
					"directConnectGatewayOwnerAccount": {},
					"proposalState": {},
					"associatedGateway": {
						"shape": "Sc"
					},
					"existingAllowedPrefixesToDirectConnectGateway": {
						"shape": "S5"
					},
					"requestedAllowedPrefixesToDirectConnectGateway": {
						"shape": "S5"
					}
				}
			},
			"S2m": {
				"type": "structure",
				"members": {
					"interconnectId": {},
					"interconnectName": {},
					"interconnectState": {},
					"region": {},
					"location": {},
					"bandwidth": {},
					"loaIssueTime": {
						"type": "timestamp"
					},
					"lagId": {},
					"awsDevice": {
						"shape": "Sv"
					},
					"jumboFrameCapable": {
						"type": "boolean"
					},
					"awsDeviceV2": {},
					"hasLogicalRedundancy": {},
					"tags": {
						"shape": "Sz"
					}
				}
			},
			"S2r": {
				"type": "structure",
				"members": {
					"connectionsBandwidth": {},
					"numberOfConnections": {
						"type": "integer"
					},
					"lagId": {},
					"ownerAccount": {},
					"lagName": {},
					"lagState": {},
					"location": {},
					"region": {},
					"minimumLinks": {
						"type": "integer"
					},
					"awsDevice": {
						"shape": "Sv"
					},
					"awsDeviceV2": {},
					"connections": {
						"shape": "S2t"
					},
					"allowsHostedConnections": {
						"type": "boolean"
					},
					"jumboFrameCapable": {
						"type": "boolean"
					},
					"hasLogicalRedundancy": {},
					"tags": {
						"shape": "Sz"
					}
				}
			},
			"S2t": {
				"type": "list",
				"member": {
					"shape": "So"
				}
			},
			"S3k": {
				"type": "structure",
				"members": {
					"loaContent": {
						"type": "blob"
					},
					"loaContentType": {}
				}
			},
			"S3n": {
				"type": "structure",
				"members": {
					"connections": {
						"shape": "S2t"
					}
				}
			}
		}
	};

/***/ },
/* 1709 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeConnections": {
				"result_key": "connections"
			},
			"DescribeConnectionsOnInterconnect": {
				"result_key": "connections"
			},
			"DescribeInterconnects": {
				"result_key": "interconnects"
			},
			"DescribeLocations": {
				"result_key": "locations"
			},
			"DescribeVirtualGateways": {
				"result_key": "virtualGateways"
			},
			"DescribeVirtualInterfaces": {
				"result_key": "virtualInterfaces"
			}
		}
	};

/***/ },
/* 1710 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-12-05",
			"endpointPrefix": "dynamodb",
			"jsonVersion": "1.0",
			"protocol": "json",
			"serviceAbbreviation": "DynamoDB",
			"serviceFullName": "Amazon DynamoDB",
			"serviceId": "DynamoDB",
			"signatureVersion": "v4",
			"targetPrefix": "DynamoDB_20111205",
			"uid": "dynamodb-2011-12-05"
		},
		"operations": {
			"BatchGetItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Responses": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"Items": {
										"shape": "Sk"
									},
									"ConsumedCapacityUnits": {
										"type": "double"
									}
								}
							}
						},
						"UnprocessedKeys": {
							"shape": "S2"
						}
					}
				}
			},
			"BatchWriteItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "So"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Responses": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"ConsumedCapacityUnits": {
										"type": "double"
									}
								}
							}
						},
						"UnprocessedItems": {
							"shape": "So"
						}
					}
				}
			},
			"CreateTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"KeySchema",
						"ProvisionedThroughput"
					],
					"members": {
						"TableName": {},
						"KeySchema": {
							"shape": "Sy"
						},
						"ProvisionedThroughput": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S15"
						}
					}
				}
			},
			"DeleteItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"Expected": {
							"shape": "S1b"
						},
						"ReturnValues": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"DeleteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S15"
						}
					}
				}
			},
			"DescribeTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Table": {
							"shape": "S15"
						}
					}
				}
			},
			"GetItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributesToGet": {
							"shape": "Se"
						},
						"ConsistentRead": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Item": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"ListTables": {
				"input": {
					"type": "structure",
					"members": {
						"ExclusiveStartTableName": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableNames": {
							"type": "list",
							"member": {}
						},
						"LastEvaluatedTableName": {}
					}
				}
			},
			"PutItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Item"
					],
					"members": {
						"TableName": {},
						"Item": {
							"shape": "Ss"
						},
						"Expected": {
							"shape": "S1b"
						},
						"ReturnValues": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"Query": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"HashKeyValue"
					],
					"members": {
						"TableName": {},
						"AttributesToGet": {
							"shape": "Se"
						},
						"Limit": {
							"type": "integer"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"Count": {
							"type": "boolean"
						},
						"HashKeyValue": {
							"shape": "S7"
						},
						"RangeKeyCondition": {
							"shape": "S1u"
						},
						"ScanIndexForward": {
							"type": "boolean"
						},
						"ExclusiveStartKey": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sk"
						},
						"Count": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"Scan": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {},
						"AttributesToGet": {
							"shape": "Se"
						},
						"Limit": {
							"type": "integer"
						},
						"Count": {
							"type": "boolean"
						},
						"ScanFilter": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "S1u"
							}
						},
						"ExclusiveStartKey": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sk"
						},
						"Count": {
							"type": "integer"
						},
						"ScannedCount": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"UpdateItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key",
						"AttributeUpdates"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributeUpdates": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"Value": {
										"shape": "S7"
									},
									"Action": {}
								}
							}
						},
						"Expected": {
							"shape": "S1b"
						},
						"ReturnValues": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"UpdateTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"ProvisionedThroughput"
					],
					"members": {
						"TableName": {},
						"ProvisionedThroughput": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S15"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Keys"
					],
					"members": {
						"Keys": {
							"type": "list",
							"member": {
								"shape": "S6"
							}
						},
						"AttributesToGet": {
							"shape": "Se"
						},
						"ConsistentRead": {
							"type": "boolean"
						}
					}
				}
			},
			"S6": {
				"type": "structure",
				"required": [
					"HashKeyElement"
				],
				"members": {
					"HashKeyElement": {
						"shape": "S7"
					},
					"RangeKeyElement": {
						"shape": "S7"
					}
				}
			},
			"S7": {
				"type": "structure",
				"members": {
					"S": {},
					"N": {},
					"B": {
						"type": "blob"
					},
					"SS": {
						"type": "list",
						"member": {}
					},
					"NS": {
						"type": "list",
						"member": {}
					},
					"BS": {
						"type": "list",
						"member": {
							"type": "blob"
						}
					}
				}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Sk": {
				"type": "list",
				"member": {
					"shape": "Sl"
				}
			},
			"Sl": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S7"
				}
			},
			"So": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"PutRequest": {
								"type": "structure",
								"required": [
									"Item"
								],
								"members": {
									"Item": {
										"shape": "Ss"
									}
								}
							},
							"DeleteRequest": {
								"type": "structure",
								"required": [
									"Key"
								],
								"members": {
									"Key": {
										"shape": "S6"
									}
								}
							}
						}
					}
				}
			},
			"Ss": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S7"
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"HashKeyElement"
				],
				"members": {
					"HashKeyElement": {
						"shape": "Sz"
					},
					"RangeKeyElement": {
						"shape": "Sz"
					}
				}
			},
			"Sz": {
				"type": "structure",
				"required": [
					"AttributeName",
					"AttributeType"
				],
				"members": {
					"AttributeName": {},
					"AttributeType": {}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"ReadCapacityUnits",
					"WriteCapacityUnits"
				],
				"members": {
					"ReadCapacityUnits": {
						"type": "long"
					},
					"WriteCapacityUnits": {
						"type": "long"
					}
				}
			},
			"S15": {
				"type": "structure",
				"members": {
					"TableName": {},
					"KeySchema": {
						"shape": "Sy"
					},
					"TableStatus": {},
					"CreationDateTime": {
						"type": "timestamp"
					},
					"ProvisionedThroughput": {
						"type": "structure",
						"members": {
							"LastIncreaseDateTime": {
								"type": "timestamp"
							},
							"LastDecreaseDateTime": {
								"type": "timestamp"
							},
							"NumberOfDecreasesToday": {
								"type": "long"
							},
							"ReadCapacityUnits": {
								"type": "long"
							},
							"WriteCapacityUnits": {
								"type": "long"
							}
						}
					},
					"TableSizeBytes": {
						"type": "long"
					},
					"ItemCount": {
						"type": "long"
					}
				}
			},
			"S1b": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Value": {
							"shape": "S7"
						},
						"Exists": {
							"type": "boolean"
						}
					}
				}
			},
			"S1u": {
				"type": "structure",
				"required": [
					"ComparisonOperator"
				],
				"members": {
					"AttributeValueList": {
						"type": "list",
						"member": {
							"shape": "S7"
						}
					},
					"ComparisonOperator": {}
				}
			}
		}
	};

/***/ },
/* 1711 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"BatchGetItem": {
				"input_token": "RequestItems",
				"output_token": "UnprocessedKeys"
			},
			"ListTables": {
				"input_token": "ExclusiveStartTableName",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedTableName",
				"result_key": "TableNames"
			},
			"Query": {
				"input_token": "ExclusiveStartKey",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedKey",
				"result_key": "Items"
			},
			"Scan": {
				"input_token": "ExclusiveStartKey",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedKey",
				"result_key": "Items"
			}
		}
	};

/***/ },
/* 1712 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"TableExists": {
				"delay": 20,
				"operation": "DescribeTable",
				"maxAttempts": 25,
				"acceptors": [
					{
						"expected": "ACTIVE",
						"matcher": "path",
						"state": "success",
						"argument": "Table.TableStatus"
					},
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "retry"
					}
				]
			},
			"TableNotExists": {
				"delay": 20,
				"operation": "DescribeTable",
				"maxAttempts": 25,
				"acceptors": [
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 1713 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-08-10",
			"endpointPrefix": "dynamodb",
			"jsonVersion": "1.0",
			"protocol": "json",
			"serviceAbbreviation": "DynamoDB",
			"serviceFullName": "Amazon DynamoDB",
			"serviceId": "DynamoDB",
			"signatureVersion": "v4",
			"targetPrefix": "DynamoDB_20120810",
			"uid": "dynamodb-2012-08-10"
		},
		"operations": {
			"BatchGetItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "S2"
						},
						"ReturnConsumedCapacity": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Responses": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "Sr"
							}
						},
						"UnprocessedKeys": {
							"shape": "S2"
						},
						"ConsumedCapacity": {
							"shape": "St"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"BatchWriteItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "S10"
						},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UnprocessedItems": {
							"shape": "S10"
						},
						"ItemCollectionMetrics": {
							"shape": "S18"
						},
						"ConsumedCapacity": {
							"shape": "St"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"CreateBackup": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"BackupName"
					],
					"members": {
						"TableName": {},
						"BackupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BackupDetails": {
							"shape": "S1h"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"CreateGlobalTable": {
				"input": {
					"type": "structure",
					"required": [
						"GlobalTableName",
						"ReplicationGroup"
					],
					"members": {
						"GlobalTableName": {},
						"ReplicationGroup": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GlobalTableDescription": {
							"shape": "S1t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"CreateTable": {
				"input": {
					"type": "structure",
					"required": [
						"AttributeDefinitions",
						"TableName",
						"KeySchema"
					],
					"members": {
						"AttributeDefinitions": {
							"shape": "S1z"
						},
						"TableName": {},
						"KeySchema": {
							"shape": "S23"
						},
						"LocalSecondaryIndexes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IndexName",
									"KeySchema",
									"Projection"
								],
								"members": {
									"IndexName": {},
									"KeySchema": {
										"shape": "S23"
									},
									"Projection": {
										"shape": "S28"
									}
								}
							}
						},
						"GlobalSecondaryIndexes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IndexName",
									"KeySchema",
									"Projection"
								],
								"members": {
									"IndexName": {},
									"KeySchema": {
										"shape": "S23"
									},
									"Projection": {
										"shape": "S28"
									},
									"ProvisionedThroughput": {
										"shape": "S2e"
									}
								}
							}
						},
						"BillingMode": {},
						"ProvisionedThroughput": {
							"shape": "S2e"
						},
						"StreamSpecification": {
							"shape": "S2h"
						},
						"SSESpecification": {
							"shape": "S2k"
						},
						"Tags": {
							"shape": "S2o"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S2t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DeleteBackup": {
				"input": {
					"type": "structure",
					"required": [
						"BackupArn"
					],
					"members": {
						"BackupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BackupDescription": {
							"shape": "S3g"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DeleteItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"Expected": {
							"shape": "S3t"
						},
						"ConditionalOperator": {},
						"ReturnValues": {},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {},
						"ConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S41"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						},
						"ItemCollectionMetrics": {
							"shape": "S1a"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DeleteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S2t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DescribeBackup": {
				"input": {
					"type": "structure",
					"required": [
						"BackupArn"
					],
					"members": {
						"BackupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BackupDescription": {
							"shape": "S3g"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DescribeContinuousBackups": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ContinuousBackupsDescription": {
							"shape": "S4a"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DescribeEndpoints": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"Endpoints"
					],
					"members": {
						"Endpoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Address",
									"CachePeriodInMinutes"
								],
								"members": {
									"Address": {},
									"CachePeriodInMinutes": {
										"type": "long"
									}
								}
							}
						}
					}
				},
				"endpointoperation": true
			},
			"DescribeGlobalTable": {
				"input": {
					"type": "structure",
					"required": [
						"GlobalTableName"
					],
					"members": {
						"GlobalTableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GlobalTableDescription": {
							"shape": "S1t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DescribeGlobalTableSettings": {
				"input": {
					"type": "structure",
					"required": [
						"GlobalTableName"
					],
					"members": {
						"GlobalTableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GlobalTableName": {},
						"ReplicaSettings": {
							"shape": "S4m"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DescribeLimits": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountMaxReadCapacityUnits": {
							"type": "long"
						},
						"AccountMaxWriteCapacityUnits": {
							"type": "long"
						},
						"TableMaxReadCapacityUnits": {
							"type": "long"
						},
						"TableMaxWriteCapacityUnits": {
							"type": "long"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DescribeTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Table": {
							"shape": "S2t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"DescribeTimeToLive": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TimeToLiveDescription": {
							"shape": "S3p"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"GetItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"ReturnConsumedCapacity": {},
						"ProjectionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Item": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"ListBackups": {
				"input": {
					"type": "structure",
					"members": {
						"TableName": {},
						"Limit": {
							"type": "integer"
						},
						"TimeRangeLowerBound": {
							"type": "timestamp"
						},
						"TimeRangeUpperBound": {
							"type": "timestamp"
						},
						"ExclusiveStartBackupArn": {},
						"BackupType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BackupSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TableName": {},
									"TableId": {},
									"TableArn": {},
									"BackupArn": {},
									"BackupName": {},
									"BackupCreationDateTime": {
										"type": "timestamp"
									},
									"BackupExpiryDateTime": {
										"type": "timestamp"
									},
									"BackupStatus": {},
									"BackupType": {},
									"BackupSizeBytes": {
										"type": "long"
									}
								}
							}
						},
						"LastEvaluatedBackupArn": {}
					}
				},
				"endpointdiscovery": {}
			},
			"ListGlobalTables": {
				"input": {
					"type": "structure",
					"members": {
						"ExclusiveStartGlobalTableName": {},
						"Limit": {
							"type": "integer"
						},
						"RegionName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GlobalTables": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GlobalTableName": {},
									"ReplicationGroup": {
										"shape": "S1p"
									}
								}
							}
						},
						"LastEvaluatedGlobalTableName": {}
					}
				},
				"endpointdiscovery": {}
			},
			"ListTables": {
				"input": {
					"type": "structure",
					"members": {
						"ExclusiveStartTableName": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableNames": {
							"type": "list",
							"member": {}
						},
						"LastEvaluatedTableName": {}
					}
				},
				"endpointdiscovery": {}
			},
			"ListTagsOfResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S2o"
						},
						"NextToken": {}
					}
				},
				"endpointdiscovery": {}
			},
			"PutItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Item"
					],
					"members": {
						"TableName": {},
						"Item": {
							"shape": "S14"
						},
						"Expected": {
							"shape": "S3t"
						},
						"ReturnValues": {},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {},
						"ConditionalOperator": {},
						"ConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S41"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						},
						"ItemCollectionMetrics": {
							"shape": "S1a"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"Query": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {},
						"IndexName": {},
						"Select": {},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"Limit": {
							"type": "integer"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"KeyConditions": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "S5w"
							}
						},
						"QueryFilter": {
							"shape": "S5x"
						},
						"ConditionalOperator": {},
						"ScanIndexForward": {
							"type": "boolean"
						},
						"ExclusiveStartKey": {
							"shape": "S6"
						},
						"ReturnConsumedCapacity": {},
						"ProjectionExpression": {},
						"FilterExpression": {},
						"KeyConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S41"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sr"
						},
						"Count": {
							"type": "integer"
						},
						"ScannedCount": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"RestoreTableFromBackup": {
				"input": {
					"type": "structure",
					"required": [
						"TargetTableName",
						"BackupArn"
					],
					"members": {
						"TargetTableName": {},
						"BackupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S2t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"RestoreTableToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceTableName",
						"TargetTableName"
					],
					"members": {
						"SourceTableName": {},
						"TargetTableName": {},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"RestoreDateTime": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S2t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"Scan": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {},
						"IndexName": {},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"Limit": {
							"type": "integer"
						},
						"Select": {},
						"ScanFilter": {
							"shape": "S5x"
						},
						"ConditionalOperator": {},
						"ExclusiveStartKey": {
							"shape": "S6"
						},
						"ReturnConsumedCapacity": {},
						"TotalSegments": {
							"type": "integer"
						},
						"Segment": {
							"type": "integer"
						},
						"ProjectionExpression": {},
						"FilterExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S41"
						},
						"ConsistentRead": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sr"
						},
						"Count": {
							"type": "integer"
						},
						"ScannedCount": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Tags"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S2o"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"TransactGetItems": {
				"input": {
					"type": "structure",
					"required": [
						"TransactItems"
					],
					"members": {
						"TransactItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Get"
								],
								"members": {
									"Get": {
										"type": "structure",
										"required": [
											"Key",
											"TableName"
										],
										"members": {
											"Key": {
												"shape": "S6"
											},
											"TableName": {},
											"ProjectionExpression": {},
											"ExpressionAttributeNames": {
												"shape": "Sm"
											}
										}
									}
								}
							}
						},
						"ReturnConsumedCapacity": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConsumedCapacity": {
							"shape": "St"
						},
						"Responses": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Item": {
										"shape": "Ss"
									}
								}
							}
						}
					}
				},
				"endpointdiscovery": {}
			},
			"TransactWriteItems": {
				"input": {
					"type": "structure",
					"required": [
						"TransactItems"
					],
					"members": {
						"TransactItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ConditionCheck": {
										"type": "structure",
										"required": [
											"Key",
											"TableName",
											"ConditionExpression"
										],
										"members": {
											"Key": {
												"shape": "S6"
											},
											"TableName": {},
											"ConditionExpression": {},
											"ExpressionAttributeNames": {
												"shape": "Sm"
											},
											"ExpressionAttributeValues": {
												"shape": "S41"
											},
											"ReturnValuesOnConditionCheckFailure": {}
										}
									},
									"Put": {
										"type": "structure",
										"required": [
											"Item",
											"TableName"
										],
										"members": {
											"Item": {
												"shape": "S14"
											},
											"TableName": {},
											"ConditionExpression": {},
											"ExpressionAttributeNames": {
												"shape": "Sm"
											},
											"ExpressionAttributeValues": {
												"shape": "S41"
											},
											"ReturnValuesOnConditionCheckFailure": {}
										}
									},
									"Delete": {
										"type": "structure",
										"required": [
											"Key",
											"TableName"
										],
										"members": {
											"Key": {
												"shape": "S6"
											},
											"TableName": {},
											"ConditionExpression": {},
											"ExpressionAttributeNames": {
												"shape": "Sm"
											},
											"ExpressionAttributeValues": {
												"shape": "S41"
											},
											"ReturnValuesOnConditionCheckFailure": {}
										}
									},
									"Update": {
										"type": "structure",
										"required": [
											"Key",
											"UpdateExpression",
											"TableName"
										],
										"members": {
											"Key": {
												"shape": "S6"
											},
											"UpdateExpression": {},
											"TableName": {},
											"ConditionExpression": {},
											"ExpressionAttributeNames": {
												"shape": "Sm"
											},
											"ExpressionAttributeValues": {
												"shape": "S41"
											},
											"ReturnValuesOnConditionCheckFailure": {}
										}
									}
								}
							}
						},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConsumedCapacity": {
							"shape": "St"
						},
						"ItemCollectionMetrics": {
							"shape": "S18"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeys"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"endpointdiscovery": {}
			},
			"UpdateContinuousBackups": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"PointInTimeRecoverySpecification"
					],
					"members": {
						"TableName": {},
						"PointInTimeRecoverySpecification": {
							"type": "structure",
							"required": [
								"PointInTimeRecoveryEnabled"
							],
							"members": {
								"PointInTimeRecoveryEnabled": {
									"type": "boolean"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ContinuousBackupsDescription": {
							"shape": "S4a"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"UpdateGlobalTable": {
				"input": {
					"type": "structure",
					"required": [
						"GlobalTableName",
						"ReplicaUpdates"
					],
					"members": {
						"GlobalTableName": {},
						"ReplicaUpdates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Create": {
										"type": "structure",
										"required": [
											"RegionName"
										],
										"members": {
											"RegionName": {}
										}
									},
									"Delete": {
										"type": "structure",
										"required": [
											"RegionName"
										],
										"members": {
											"RegionName": {}
										}
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GlobalTableDescription": {
							"shape": "S1t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"UpdateGlobalTableSettings": {
				"input": {
					"type": "structure",
					"required": [
						"GlobalTableName"
					],
					"members": {
						"GlobalTableName": {},
						"GlobalTableBillingMode": {},
						"GlobalTableProvisionedWriteCapacityUnits": {
							"type": "long"
						},
						"GlobalTableProvisionedWriteCapacityAutoScalingSettingsUpdate": {
							"shape": "S74"
						},
						"GlobalTableGlobalSecondaryIndexSettingsUpdate": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IndexName"
								],
								"members": {
									"IndexName": {},
									"ProvisionedWriteCapacityUnits": {
										"type": "long"
									},
									"ProvisionedWriteCapacityAutoScalingSettingsUpdate": {
										"shape": "S74"
									}
								}
							}
						},
						"ReplicaSettingsUpdate": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"RegionName"
								],
								"members": {
									"RegionName": {},
									"ReplicaProvisionedReadCapacityUnits": {
										"type": "long"
									},
									"ReplicaProvisionedReadCapacityAutoScalingSettingsUpdate": {
										"shape": "S74"
									},
									"ReplicaGlobalSecondaryIndexSettingsUpdate": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"IndexName"
											],
											"members": {
												"IndexName": {},
												"ProvisionedReadCapacityUnits": {
													"type": "long"
												},
												"ProvisionedReadCapacityAutoScalingSettingsUpdate": {
													"shape": "S74"
												}
											}
										}
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GlobalTableName": {},
						"ReplicaSettings": {
							"shape": "S4m"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"UpdateItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributeUpdates": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"Value": {
										"shape": "S8"
									},
									"Action": {}
								}
							}
						},
						"Expected": {
							"shape": "S3t"
						},
						"ConditionalOperator": {},
						"ReturnValues": {},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {},
						"UpdateExpression": {},
						"ConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S41"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						},
						"ItemCollectionMetrics": {
							"shape": "S1a"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"UpdateTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"AttributeDefinitions": {
							"shape": "S1z"
						},
						"TableName": {},
						"BillingMode": {},
						"ProvisionedThroughput": {
							"shape": "S2e"
						},
						"GlobalSecondaryIndexUpdates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Update": {
										"type": "structure",
										"required": [
											"IndexName",
											"ProvisionedThroughput"
										],
										"members": {
											"IndexName": {},
											"ProvisionedThroughput": {
												"shape": "S2e"
											}
										}
									},
									"Create": {
										"type": "structure",
										"required": [
											"IndexName",
											"KeySchema",
											"Projection"
										],
										"members": {
											"IndexName": {},
											"KeySchema": {
												"shape": "S23"
											},
											"Projection": {
												"shape": "S28"
											},
											"ProvisionedThroughput": {
												"shape": "S2e"
											}
										}
									},
									"Delete": {
										"type": "structure",
										"required": [
											"IndexName"
										],
										"members": {
											"IndexName": {}
										}
									}
								}
							}
						},
						"StreamSpecification": {
							"shape": "S2h"
						},
						"SSESpecification": {
							"shape": "S2k"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S2t"
						}
					}
				},
				"endpointdiscovery": {}
			},
			"UpdateTimeToLive": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"TimeToLiveSpecification"
					],
					"members": {
						"TableName": {},
						"TimeToLiveSpecification": {
							"shape": "S7s"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TimeToLiveSpecification": {
							"shape": "S7s"
						}
					}
				},
				"endpointdiscovery": {}
			}
		},
		"shapes": {
			"S2": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Keys"
					],
					"members": {
						"Keys": {
							"type": "list",
							"member": {
								"shape": "S6"
							}
						},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"ProjectionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						}
					}
				}
			},
			"S6": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"S8": {
				"type": "structure",
				"members": {
					"S": {},
					"N": {},
					"B": {
						"type": "blob"
					},
					"SS": {
						"type": "list",
						"member": {}
					},
					"NS": {
						"type": "list",
						"member": {}
					},
					"BS": {
						"type": "list",
						"member": {
							"type": "blob"
						}
					},
					"M": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S8"
						}
					},
					"L": {
						"type": "list",
						"member": {
							"shape": "S8"
						}
					},
					"NULL": {
						"type": "boolean"
					},
					"BOOL": {
						"type": "boolean"
					}
				}
			},
			"Sj": {
				"type": "list",
				"member": {}
			},
			"Sm": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sr": {
				"type": "list",
				"member": {
					"shape": "Ss"
				}
			},
			"Ss": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"St": {
				"type": "list",
				"member": {
					"shape": "Su"
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"TableName": {},
					"CapacityUnits": {
						"type": "double"
					},
					"ReadCapacityUnits": {
						"type": "double"
					},
					"WriteCapacityUnits": {
						"type": "double"
					},
					"Table": {
						"shape": "Sw"
					},
					"LocalSecondaryIndexes": {
						"shape": "Sx"
					},
					"GlobalSecondaryIndexes": {
						"shape": "Sx"
					}
				}
			},
			"Sw": {
				"type": "structure",
				"members": {
					"ReadCapacityUnits": {
						"type": "double"
					},
					"WriteCapacityUnits": {
						"type": "double"
					},
					"CapacityUnits": {
						"type": "double"
					}
				}
			},
			"Sx": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "Sw"
				}
			},
			"S10": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"PutRequest": {
								"type": "structure",
								"required": [
									"Item"
								],
								"members": {
									"Item": {
										"shape": "S14"
									}
								}
							},
							"DeleteRequest": {
								"type": "structure",
								"required": [
									"Key"
								],
								"members": {
									"Key": {
										"shape": "S6"
									}
								}
							}
						}
					}
				}
			},
			"S14": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"S18": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {
						"shape": "S1a"
					}
				}
			},
			"S1a": {
				"type": "structure",
				"members": {
					"ItemCollectionKey": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S8"
						}
					},
					"SizeEstimateRangeGB": {
						"type": "list",
						"member": {
							"type": "double"
						}
					}
				}
			},
			"S1h": {
				"type": "structure",
				"required": [
					"BackupArn",
					"BackupName",
					"BackupStatus",
					"BackupType",
					"BackupCreationDateTime"
				],
				"members": {
					"BackupArn": {},
					"BackupName": {},
					"BackupSizeBytes": {
						"type": "long"
					},
					"BackupStatus": {},
					"BackupType": {},
					"BackupCreationDateTime": {
						"type": "timestamp"
					},
					"BackupExpiryDateTime": {
						"type": "timestamp"
					}
				}
			},
			"S1p": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"RegionName": {}
					}
				}
			},
			"S1t": {
				"type": "structure",
				"members": {
					"ReplicationGroup": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"RegionName": {}
							}
						}
					},
					"GlobalTableArn": {},
					"CreationDateTime": {
						"type": "timestamp"
					},
					"GlobalTableStatus": {},
					"GlobalTableName": {}
				}
			},
			"S1z": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AttributeName",
						"AttributeType"
					],
					"members": {
						"AttributeName": {},
						"AttributeType": {}
					}
				}
			},
			"S23": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AttributeName",
						"KeyType"
					],
					"members": {
						"AttributeName": {},
						"KeyType": {}
					}
				}
			},
			"S28": {
				"type": "structure",
				"members": {
					"ProjectionType": {},
					"NonKeyAttributes": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S2e": {
				"type": "structure",
				"required": [
					"ReadCapacityUnits",
					"WriteCapacityUnits"
				],
				"members": {
					"ReadCapacityUnits": {
						"type": "long"
					},
					"WriteCapacityUnits": {
						"type": "long"
					}
				}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"StreamEnabled": {
						"type": "boolean"
					},
					"StreamViewType": {}
				}
			},
			"S2k": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"SSEType": {},
					"KMSMasterKeyId": {}
				}
			},
			"S2o": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S2t": {
				"type": "structure",
				"members": {
					"AttributeDefinitions": {
						"shape": "S1z"
					},
					"TableName": {},
					"KeySchema": {
						"shape": "S23"
					},
					"TableStatus": {},
					"CreationDateTime": {
						"type": "timestamp"
					},
					"ProvisionedThroughput": {
						"shape": "S2v"
					},
					"TableSizeBytes": {
						"type": "long"
					},
					"ItemCount": {
						"type": "long"
					},
					"TableArn": {},
					"TableId": {},
					"BillingModeSummary": {
						"shape": "S30"
					},
					"LocalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S23"
								},
								"Projection": {
									"shape": "S28"
								},
								"IndexSizeBytes": {
									"type": "long"
								},
								"ItemCount": {
									"type": "long"
								},
								"IndexArn": {}
							}
						}
					},
					"GlobalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S23"
								},
								"Projection": {
									"shape": "S28"
								},
								"IndexStatus": {},
								"Backfilling": {
									"type": "boolean"
								},
								"ProvisionedThroughput": {
									"shape": "S2v"
								},
								"IndexSizeBytes": {
									"type": "long"
								},
								"ItemCount": {
									"type": "long"
								},
								"IndexArn": {}
							}
						}
					},
					"StreamSpecification": {
						"shape": "S2h"
					},
					"LatestStreamLabel": {},
					"LatestStreamArn": {},
					"RestoreSummary": {
						"type": "structure",
						"required": [
							"RestoreDateTime",
							"RestoreInProgress"
						],
						"members": {
							"SourceBackupArn": {},
							"SourceTableArn": {},
							"RestoreDateTime": {
								"type": "timestamp"
							},
							"RestoreInProgress": {
								"type": "boolean"
							}
						}
					},
					"SSEDescription": {
						"shape": "S3b"
					}
				}
			},
			"S2v": {
				"type": "structure",
				"members": {
					"LastIncreaseDateTime": {
						"type": "timestamp"
					},
					"LastDecreaseDateTime": {
						"type": "timestamp"
					},
					"NumberOfDecreasesToday": {
						"type": "long"
					},
					"ReadCapacityUnits": {
						"type": "long"
					},
					"WriteCapacityUnits": {
						"type": "long"
					}
				}
			},
			"S30": {
				"type": "structure",
				"members": {
					"BillingMode": {},
					"LastUpdateToPayPerRequestDateTime": {
						"type": "timestamp"
					}
				}
			},
			"S3b": {
				"type": "structure",
				"members": {
					"Status": {},
					"SSEType": {},
					"KMSMasterKeyArn": {}
				}
			},
			"S3g": {
				"type": "structure",
				"members": {
					"BackupDetails": {
						"shape": "S1h"
					},
					"SourceTableDetails": {
						"type": "structure",
						"required": [
							"TableName",
							"TableId",
							"KeySchema",
							"TableCreationDateTime",
							"ProvisionedThroughput"
						],
						"members": {
							"TableName": {},
							"TableId": {},
							"TableArn": {},
							"TableSizeBytes": {
								"type": "long"
							},
							"KeySchema": {
								"shape": "S23"
							},
							"TableCreationDateTime": {
								"type": "timestamp"
							},
							"ProvisionedThroughput": {
								"shape": "S2e"
							},
							"ItemCount": {
								"type": "long"
							},
							"BillingMode": {}
						}
					},
					"SourceTableFeatureDetails": {
						"type": "structure",
						"members": {
							"LocalSecondaryIndexes": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"IndexName": {},
										"KeySchema": {
											"shape": "S23"
										},
										"Projection": {
											"shape": "S28"
										}
									}
								}
							},
							"GlobalSecondaryIndexes": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"IndexName": {},
										"KeySchema": {
											"shape": "S23"
										},
										"Projection": {
											"shape": "S28"
										},
										"ProvisionedThroughput": {
											"shape": "S2e"
										}
									}
								}
							},
							"StreamDescription": {
								"shape": "S2h"
							},
							"TimeToLiveDescription": {
								"shape": "S3p"
							},
							"SSEDescription": {
								"shape": "S3b"
							}
						}
					}
				}
			},
			"S3p": {
				"type": "structure",
				"members": {
					"TimeToLiveStatus": {},
					"AttributeName": {}
				}
			},
			"S3t": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Value": {
							"shape": "S8"
						},
						"Exists": {
							"type": "boolean"
						},
						"ComparisonOperator": {},
						"AttributeValueList": {
							"shape": "S3x"
						}
					}
				}
			},
			"S3x": {
				"type": "list",
				"member": {
					"shape": "S8"
				}
			},
			"S41": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"S4a": {
				"type": "structure",
				"required": [
					"ContinuousBackupsStatus"
				],
				"members": {
					"ContinuousBackupsStatus": {},
					"PointInTimeRecoveryDescription": {
						"type": "structure",
						"members": {
							"PointInTimeRecoveryStatus": {},
							"EarliestRestorableDateTime": {
								"type": "timestamp"
							},
							"LatestRestorableDateTime": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"S4m": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"RegionName"
					],
					"members": {
						"RegionName": {},
						"ReplicaStatus": {},
						"ReplicaBillingModeSummary": {
							"shape": "S30"
						},
						"ReplicaProvisionedReadCapacityUnits": {
							"type": "long"
						},
						"ReplicaProvisionedReadCapacityAutoScalingSettings": {
							"shape": "S4p"
						},
						"ReplicaProvisionedWriteCapacityUnits": {
							"type": "long"
						},
						"ReplicaProvisionedWriteCapacityAutoScalingSettings": {
							"shape": "S4p"
						},
						"ReplicaGlobalSecondaryIndexSettings": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IndexName"
								],
								"members": {
									"IndexName": {},
									"IndexStatus": {},
									"ProvisionedReadCapacityUnits": {
										"type": "long"
									},
									"ProvisionedReadCapacityAutoScalingSettings": {
										"shape": "S4p"
									},
									"ProvisionedWriteCapacityUnits": {
										"type": "long"
									},
									"ProvisionedWriteCapacityAutoScalingSettings": {
										"shape": "S4p"
									}
								}
							}
						}
					}
				}
			},
			"S4p": {
				"type": "structure",
				"members": {
					"MinimumUnits": {
						"type": "long"
					},
					"MaximumUnits": {
						"type": "long"
					},
					"AutoScalingDisabled": {
						"type": "boolean"
					},
					"AutoScalingRoleArn": {},
					"ScalingPolicies": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PolicyName": {},
								"TargetTrackingScalingPolicyConfiguration": {
									"type": "structure",
									"required": [
										"TargetValue"
									],
									"members": {
										"DisableScaleIn": {
											"type": "boolean"
										},
										"ScaleInCooldown": {
											"type": "integer"
										},
										"ScaleOutCooldown": {
											"type": "integer"
										},
										"TargetValue": {
											"type": "double"
										}
									}
								}
							}
						}
					}
				}
			},
			"S5w": {
				"type": "structure",
				"required": [
					"ComparisonOperator"
				],
				"members": {
					"AttributeValueList": {
						"shape": "S3x"
					},
					"ComparisonOperator": {}
				}
			},
			"S5x": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S5w"
				}
			},
			"S74": {
				"type": "structure",
				"members": {
					"MinimumUnits": {
						"type": "long"
					},
					"MaximumUnits": {
						"type": "long"
					},
					"AutoScalingDisabled": {
						"type": "boolean"
					},
					"AutoScalingRoleArn": {},
					"ScalingPolicyUpdate": {
						"type": "structure",
						"required": [
							"TargetTrackingScalingPolicyConfiguration"
						],
						"members": {
							"PolicyName": {},
							"TargetTrackingScalingPolicyConfiguration": {
								"type": "structure",
								"required": [
									"TargetValue"
								],
								"members": {
									"DisableScaleIn": {
										"type": "boolean"
									},
									"ScaleInCooldown": {
										"type": "integer"
									},
									"ScaleOutCooldown": {
										"type": "integer"
									},
									"TargetValue": {
										"type": "double"
									}
								}
							}
						}
					}
				}
			},
			"S7s": {
				"type": "structure",
				"required": [
					"Enabled",
					"AttributeName"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"AttributeName": {}
				}
			}
		}
	};

/***/ },
/* 1714 */
1711,
/* 1715 */
1712,
/* 1716 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-11-15",
			"endpointPrefix": "ec2",
			"protocol": "ec2",
			"serviceAbbreviation": "Amazon EC2",
			"serviceFullName": "Amazon Elastic Compute Cloud",
			"serviceId": "EC2",
			"signatureVersion": "v4",
			"uid": "ec2-2016-11-15",
			"xmlNamespace": "http://ec2.amazonaws.com/doc/2016-11-15"
		},
		"operations": {
			"AcceptReservedInstancesExchangeQuote": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstanceIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ReservedInstanceIds": {
							"shape": "S3",
							"locationName": "ReservedInstanceId"
						},
						"TargetConfigurations": {
							"shape": "S5",
							"locationName": "TargetConfiguration"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ExchangeId": {
							"locationName": "exchangeId"
						}
					}
				}
			},
			"AcceptTransitGatewayVpcAttachment": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayAttachmentId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayVpcAttachment": {
							"shape": "Sb",
							"locationName": "transitGatewayVpcAttachment"
						}
					}
				}
			},
			"AcceptVpcEndpointConnections": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceId",
						"VpcEndpointIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceId": {},
						"VpcEndpointIds": {
							"shape": "Sd",
							"locationName": "VpcEndpointId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "Sm",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"AcceptVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringConnection": {
							"shape": "Sr",
							"locationName": "vpcPeeringConnection"
						}
					}
				}
			},
			"AdvertiseByoipCidr": {
				"input": {
					"type": "structure",
					"required": [
						"Cidr"
					],
					"members": {
						"Cidr": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByoipCidr": {
							"shape": "S12",
							"locationName": "byoipCidr"
						}
					}
				}
			},
			"AllocateAddress": {
				"input": {
					"type": "structure",
					"members": {
						"Domain": {},
						"Address": {},
						"PublicIpv4Pool": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicIp": {
							"locationName": "publicIp"
						},
						"AllocationId": {
							"locationName": "allocationId"
						},
						"PublicIpv4Pool": {
							"locationName": "publicIpv4Pool"
						},
						"Domain": {
							"locationName": "domain"
						}
					}
				}
			},
			"AllocateHosts": {
				"input": {
					"type": "structure",
					"required": [
						"AvailabilityZone",
						"InstanceType",
						"Quantity"
					],
					"members": {
						"AutoPlacement": {
							"locationName": "autoPlacement"
						},
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"InstanceType": {
							"locationName": "instanceType"
						},
						"Quantity": {
							"locationName": "quantity",
							"type": "integer"
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"HostRecovery": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HostIds": {
							"shape": "S1e",
							"locationName": "hostIdSet"
						}
					}
				}
			},
			"ApplySecurityGroupsToClientVpnTargetNetwork": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"VpcId",
						"SecurityGroupIds"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"VpcId": {},
						"SecurityGroupIds": {
							"shape": "S1g",
							"locationName": "SecurityGroupId"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecurityGroupIds": {
							"shape": "S1g",
							"locationName": "securityGroupIds"
						}
					}
				}
			},
			"AssignIpv6Addresses": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"Ipv6AddressCount": {
							"locationName": "ipv6AddressCount",
							"type": "integer"
						},
						"Ipv6Addresses": {
							"shape": "S1j",
							"locationName": "ipv6Addresses"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssignedIpv6Addresses": {
							"shape": "S1j",
							"locationName": "assignedIpv6Addresses"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						}
					}
				}
			},
			"AssignPrivateIpAddresses": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"AllowReassignment": {
							"locationName": "allowReassignment",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"PrivateIpAddresses": {
							"shape": "S1m",
							"locationName": "privateIpAddress"
						},
						"SecondaryPrivateIpAddressCount": {
							"locationName": "secondaryPrivateIpAddressCount",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"AssignedPrivateIpAddresses": {
							"locationName": "assignedPrivateIpAddressesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"PrivateIpAddress": {
										"locationName": "privateIpAddress"
									}
								}
							}
						}
					}
				}
			},
			"AssociateAddress": {
				"input": {
					"type": "structure",
					"members": {
						"AllocationId": {},
						"InstanceId": {},
						"PublicIp": {},
						"AllowReassociation": {
							"locationName": "allowReassociation",
							"type": "boolean"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				}
			},
			"AssociateClientVpnTargetNetwork": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"SubnetId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"SubnetId": {},
						"ClientToken": {
							"idempotencyToken": true
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						},
						"Status": {
							"shape": "S1u",
							"locationName": "status"
						}
					}
				}
			},
			"AssociateDhcpOptions": {
				"input": {
					"type": "structure",
					"required": [
						"DhcpOptionsId",
						"VpcId"
					],
					"members": {
						"DhcpOptionsId": {},
						"VpcId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"AssociateIamInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamInstanceProfile",
						"InstanceId"
					],
					"members": {
						"IamInstanceProfile": {
							"shape": "S1y"
						},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociation": {
							"shape": "S20",
							"locationName": "iamInstanceProfileAssociation"
						}
					}
				}
			},
			"AssociateRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId",
						"SubnetId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						},
						"SubnetId": {
							"locationName": "subnetId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				}
			},
			"AssociateSubnetCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"Ipv6CidrBlock",
						"SubnetId"
					],
					"members": {
						"Ipv6CidrBlock": {
							"locationName": "ipv6CidrBlock"
						},
						"SubnetId": {
							"locationName": "subnetId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Ipv6CidrBlockAssociation": {
							"shape": "S27",
							"locationName": "ipv6CidrBlockAssociation"
						},
						"SubnetId": {
							"locationName": "subnetId"
						}
					}
				}
			},
			"AssociateTransitGatewayRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId",
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"TransitGatewayAttachmentId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Association": {
							"shape": "S2c",
							"locationName": "association"
						}
					}
				}
			},
			"AssociateVpcCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"AmazonProvidedIpv6CidrBlock": {
							"locationName": "amazonProvidedIpv6CidrBlock",
							"type": "boolean"
						},
						"CidrBlock": {},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Ipv6CidrBlockAssociation": {
							"shape": "S2h",
							"locationName": "ipv6CidrBlockAssociation"
						},
						"CidrBlockAssociation": {
							"shape": "S2k",
							"locationName": "cidrBlockAssociation"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"AttachClassicLinkVpc": {
				"input": {
					"type": "structure",
					"required": [
						"Groups",
						"InstanceId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Groups": {
							"shape": "S2m",
							"locationName": "SecurityGroupId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"AttachInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"InternetGatewayId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayId": {
							"locationName": "internetGatewayId"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"AttachNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceIndex",
						"InstanceId",
						"NetworkInterfaceId"
					],
					"members": {
						"DeviceIndex": {
							"locationName": "deviceIndex",
							"type": "integer"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AttachmentId": {
							"locationName": "attachmentId"
						}
					}
				}
			},
			"AttachVolume": {
				"input": {
					"type": "structure",
					"required": [
						"Device",
						"InstanceId",
						"VolumeId"
					],
					"members": {
						"Device": {},
						"InstanceId": {},
						"VolumeId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S2s"
				}
			},
			"AttachVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId",
						"VpnGatewayId"
					],
					"members": {
						"VpcId": {},
						"VpnGatewayId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcAttachment": {
							"shape": "S2w",
							"locationName": "attachment"
						}
					}
				}
			},
			"AuthorizeClientVpnIngress": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"TargetNetworkCidr"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"TargetNetworkCidr": {},
						"AccessGroupId": {},
						"AuthorizeAllGroups": {
							"type": "boolean"
						},
						"Description": {},
						"ClientToken": {
							"idempotencyToken": true
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"shape": "S30",
							"locationName": "status"
						}
					}
				}
			},
			"AuthorizeSecurityGroupEgress": {
				"input": {
					"type": "structure",
					"required": [
						"GroupId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupId": {
							"locationName": "groupId"
						},
						"IpPermissions": {
							"shape": "S33",
							"locationName": "ipPermissions"
						},
						"CidrIp": {
							"locationName": "cidrIp"
						},
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"SourceSecurityGroupName": {
							"locationName": "sourceSecurityGroupName"
						},
						"SourceSecurityGroupOwnerId": {
							"locationName": "sourceSecurityGroupOwnerId"
						}
					}
				}
			},
			"AuthorizeSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"members": {
						"CidrIp": {},
						"FromPort": {
							"type": "integer"
						},
						"GroupId": {},
						"GroupName": {},
						"IpPermissions": {
							"shape": "S33"
						},
						"IpProtocol": {},
						"SourceSecurityGroupName": {},
						"SourceSecurityGroupOwnerId": {},
						"ToPort": {
							"type": "integer"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"BundleInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Storage"
					],
					"members": {
						"InstanceId": {},
						"Storage": {
							"shape": "S3f"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BundleTask": {
							"shape": "S3j",
							"locationName": "bundleInstanceTask"
						}
					}
				}
			},
			"CancelBundleTask": {
				"input": {
					"type": "structure",
					"required": [
						"BundleId"
					],
					"members": {
						"BundleId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BundleTask": {
							"shape": "S3j",
							"locationName": "bundleInstanceTask"
						}
					}
				}
			},
			"CancelCapacityReservation": {
				"input": {
					"type": "structure",
					"required": [
						"CapacityReservationId"
					],
					"members": {
						"CapacityReservationId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"CancelConversionTask": {
				"input": {
					"type": "structure",
					"required": [
						"ConversionTaskId"
					],
					"members": {
						"ConversionTaskId": {
							"locationName": "conversionTaskId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ReasonMessage": {
							"locationName": "reasonMessage"
						}
					}
				}
			},
			"CancelExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"ExportTaskId"
					],
					"members": {
						"ExportTaskId": {
							"locationName": "exportTaskId"
						}
					}
				}
			},
			"CancelImportTask": {
				"input": {
					"type": "structure",
					"members": {
						"CancelReason": {},
						"DryRun": {
							"type": "boolean"
						},
						"ImportTaskId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportTaskId": {
							"locationName": "importTaskId"
						},
						"PreviousState": {
							"locationName": "previousState"
						},
						"State": {
							"locationName": "state"
						}
					}
				}
			},
			"CancelReservedInstancesListing": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstancesListingId"
					],
					"members": {
						"ReservedInstancesListingId": {
							"locationName": "reservedInstancesListingId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesListings": {
							"shape": "S3w",
							"locationName": "reservedInstancesListingsSet"
						}
					}
				}
			},
			"CancelSpotFleetRequests": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestIds",
						"TerminateInstances"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotFleetRequestIds": {
							"shape": "Sd",
							"locationName": "spotFleetRequestId"
						},
						"TerminateInstances": {
							"locationName": "terminateInstances",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SuccessfulFleetRequests": {
							"locationName": "successfulFleetRequestSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CurrentSpotFleetRequestState": {
										"locationName": "currentSpotFleetRequestState"
									},
									"PreviousSpotFleetRequestState": {
										"locationName": "previousSpotFleetRequestState"
									},
									"SpotFleetRequestId": {
										"locationName": "spotFleetRequestId"
									}
								}
							}
						},
						"UnsuccessfulFleetRequests": {
							"locationName": "unsuccessfulFleetRequestSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Error": {
										"locationName": "error",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Message": {
												"locationName": "message"
											}
										}
									},
									"SpotFleetRequestId": {
										"locationName": "spotFleetRequestId"
									}
								}
							}
						}
					}
				}
			},
			"CancelSpotInstanceRequests": {
				"input": {
					"type": "structure",
					"required": [
						"SpotInstanceRequestIds"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotInstanceRequestIds": {
							"shape": "S4h",
							"locationName": "SpotInstanceRequestId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CancelledSpotInstanceRequests": {
							"locationName": "spotInstanceRequestSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"SpotInstanceRequestId": {
										"locationName": "spotInstanceRequestId"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						}
					}
				}
			},
			"ConfirmProductInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"ProductCode"
					],
					"members": {
						"InstanceId": {},
						"ProductCode": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OwnerId": {
							"locationName": "ownerId"
						},
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"CopyFpgaImage": {
				"input": {
					"type": "structure",
					"required": [
						"SourceFpgaImageId",
						"SourceRegion"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"SourceFpgaImageId": {},
						"Description": {},
						"Name": {},
						"SourceRegion": {},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FpgaImageId": {
							"locationName": "fpgaImageId"
						}
					}
				}
			},
			"CopyImage": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"SourceImageId",
						"SourceRegion"
					],
					"members": {
						"ClientToken": {},
						"Description": {},
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						},
						"Name": {},
						"SourceImageId": {},
						"SourceRegion": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageId": {
							"locationName": "imageId"
						}
					}
				}
			},
			"CopySnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceRegion",
						"SourceSnapshotId"
					],
					"members": {
						"Description": {},
						"DestinationRegion": {
							"locationName": "destinationRegion"
						},
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						},
						"PresignedUrl": {
							"locationName": "presignedUrl"
						},
						"SourceRegion": {},
						"SourceSnapshotId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SnapshotId": {
							"locationName": "snapshotId"
						}
					}
				}
			},
			"CreateCapacityReservation": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceType",
						"InstancePlatform",
						"InstanceCount"
					],
					"members": {
						"ClientToken": {},
						"InstanceType": {},
						"InstancePlatform": {},
						"AvailabilityZone": {},
						"AvailabilityZoneId": {},
						"Tenancy": {},
						"InstanceCount": {
							"type": "integer"
						},
						"EbsOptimized": {
							"type": "boolean"
						},
						"EphemeralStorage": {
							"type": "boolean"
						},
						"EndDate": {
							"type": "timestamp"
						},
						"EndDateType": {},
						"InstanceMatchCriteria": {},
						"TagSpecifications": {
							"shape": "S19"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CapacityReservation": {
							"shape": "S50",
							"locationName": "capacityReservation"
						}
					}
				}
			},
			"CreateClientVpnEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"ClientCidrBlock",
						"ServerCertificateArn",
						"AuthenticationOptions",
						"ConnectionLogOptions"
					],
					"members": {
						"ClientCidrBlock": {},
						"ServerCertificateArn": {},
						"AuthenticationOptions": {
							"locationName": "Authentication",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"ActiveDirectory": {
										"type": "structure",
										"members": {
											"DirectoryId": {}
										}
									},
									"MutualAuthentication": {
										"type": "structure",
										"members": {
											"ClientRootCertificateChainArn": {}
										}
									}
								}
							}
						},
						"ConnectionLogOptions": {
							"shape": "S58"
						},
						"DnsServers": {
							"shape": "Sd"
						},
						"TransportProtocol": {},
						"Description": {},
						"SplitTunnel": {
							"type": "boolean"
						},
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientVpnEndpointId": {
							"locationName": "clientVpnEndpointId"
						},
						"Status": {
							"shape": "S5b",
							"locationName": "status"
						},
						"DnsName": {
							"locationName": "dnsName"
						}
					}
				}
			},
			"CreateClientVpnRoute": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"DestinationCidrBlock",
						"TargetVpcSubnetId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"DestinationCidrBlock": {},
						"TargetVpcSubnetId": {},
						"Description": {},
						"ClientToken": {
							"idempotencyToken": true
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"shape": "S5f",
							"locationName": "status"
						}
					}
				}
			},
			"CreateCustomerGateway": {
				"input": {
					"type": "structure",
					"required": [
						"BgpAsn",
						"PublicIp",
						"Type"
					],
					"members": {
						"BgpAsn": {
							"type": "integer"
						},
						"PublicIp": {
							"locationName": "IpAddress"
						},
						"Type": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CustomerGateway": {
							"shape": "S5k",
							"locationName": "customerGateway"
						}
					}
				}
			},
			"CreateDefaultSubnet": {
				"input": {
					"type": "structure",
					"required": [
						"AvailabilityZone"
					],
					"members": {
						"AvailabilityZone": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Subnet": {
							"shape": "S5n",
							"locationName": "subnet"
						}
					}
				}
			},
			"CreateDefaultVpc": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpc": {
							"shape": "S5s",
							"locationName": "vpc"
						}
					}
				}
			},
			"CreateDhcpOptions": {
				"input": {
					"type": "structure",
					"required": [
						"DhcpConfigurations"
					],
					"members": {
						"DhcpConfigurations": {
							"locationName": "dhcpConfiguration",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Key": {
										"locationName": "key"
									},
									"Values": {
										"shape": "Sd",
										"locationName": "Value"
									}
								}
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DhcpOptions": {
							"shape": "S61",
							"locationName": "dhcpOptions"
						}
					}
				}
			},
			"CreateEgressOnlyInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"ClientToken": {},
						"DryRun": {
							"type": "boolean"
						},
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientToken": {
							"locationName": "clientToken"
						},
						"EgressOnlyInternetGateway": {
							"shape": "S68",
							"locationName": "egressOnlyInternetGateway"
						}
					}
				}
			},
			"CreateFleet": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchTemplateConfigs",
						"TargetCapacitySpecification"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {},
						"SpotOptions": {
							"type": "structure",
							"members": {
								"AllocationStrategy": {},
								"InstanceInterruptionBehavior": {},
								"InstancePoolsToUseCount": {
									"type": "integer"
								},
								"SingleInstanceType": {
									"type": "boolean"
								},
								"SingleAvailabilityZone": {
									"type": "boolean"
								},
								"MinTargetCapacity": {
									"type": "integer"
								},
								"MaxTotalPrice": {}
							}
						},
						"OnDemandOptions": {
							"type": "structure",
							"members": {
								"AllocationStrategy": {},
								"SingleInstanceType": {
									"type": "boolean"
								},
								"SingleAvailabilityZone": {
									"type": "boolean"
								},
								"MinTargetCapacity": {
									"type": "integer"
								},
								"MaxTotalPrice": {}
							}
						},
						"ExcessCapacityTerminationPolicy": {},
						"LaunchTemplateConfigs": {
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"LaunchTemplateSpecification": {
										"type": "structure",
										"members": {
											"LaunchTemplateId": {},
											"LaunchTemplateName": {},
											"Version": {}
										}
									},
									"Overrides": {
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"InstanceType": {},
												"MaxPrice": {},
												"SubnetId": {},
												"AvailabilityZone": {},
												"WeightedCapacity": {
													"type": "double"
												},
												"Priority": {
													"type": "double"
												},
												"Placement": {
													"shape": "S6q"
												}
											}
										}
									}
								}
							}
						},
						"TargetCapacitySpecification": {
							"shape": "S6r"
						},
						"TerminateInstancesWithExpiration": {
							"type": "boolean"
						},
						"Type": {},
						"ValidFrom": {
							"type": "timestamp"
						},
						"ValidUntil": {
							"type": "timestamp"
						},
						"ReplaceUnhealthyInstances": {
							"type": "boolean"
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {
							"locationName": "fleetId"
						},
						"Errors": {
							"locationName": "errorSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"LaunchTemplateAndOverrides": {
										"shape": "S6y",
										"locationName": "launchTemplateAndOverrides"
									},
									"Lifecycle": {
										"locationName": "lifecycle"
									},
									"ErrorCode": {
										"locationName": "errorCode"
									},
									"ErrorMessage": {
										"locationName": "errorMessage"
									}
								}
							}
						},
						"Instances": {
							"locationName": "fleetInstanceSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"LaunchTemplateAndOverrides": {
										"shape": "S6y",
										"locationName": "launchTemplateAndOverrides"
									},
									"Lifecycle": {
										"locationName": "lifecycle"
									},
									"InstanceIds": {
										"shape": "S75",
										"locationName": "instanceIds"
									},
									"InstanceType": {
										"locationName": "instanceType"
									},
									"Platform": {
										"locationName": "platform"
									}
								}
							}
						}
					}
				}
			},
			"CreateFlowLogs": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceIds",
						"ResourceType",
						"TrafficType"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {},
						"DeliverLogsPermissionArn": {},
						"LogGroupName": {},
						"ResourceIds": {
							"shape": "Sd",
							"locationName": "ResourceId"
						},
						"ResourceType": {},
						"TrafficType": {},
						"LogDestinationType": {},
						"LogDestination": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientToken": {
							"locationName": "clientToken"
						},
						"FlowLogIds": {
							"shape": "Sd",
							"locationName": "flowLogIdSet"
						},
						"Unsuccessful": {
							"shape": "Sm",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"CreateFpgaImage": {
				"input": {
					"type": "structure",
					"required": [
						"InputStorageLocation"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"InputStorageLocation": {
							"shape": "S7e"
						},
						"LogsStorageLocation": {
							"shape": "S7e"
						},
						"Description": {},
						"Name": {},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FpgaImageId": {
							"locationName": "fpgaImageId"
						},
						"FpgaImageGlobalId": {
							"locationName": "fpgaImageGlobalId"
						}
					}
				}
			},
			"CreateImage": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Name"
					],
					"members": {
						"BlockDeviceMappings": {
							"shape": "S7h",
							"locationName": "blockDeviceMapping"
						},
						"Description": {
							"locationName": "description"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Name": {
							"locationName": "name"
						},
						"NoReboot": {
							"locationName": "noReboot",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageId": {
							"locationName": "imageId"
						}
					}
				}
			},
			"CreateInstanceExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"Description": {
							"locationName": "description"
						},
						"ExportToS3Task": {
							"locationName": "exportToS3",
							"type": "structure",
							"members": {
								"ContainerFormat": {
									"locationName": "containerFormat"
								},
								"DiskImageFormat": {
									"locationName": "diskImageFormat"
								},
								"S3Bucket": {
									"locationName": "s3Bucket"
								},
								"S3Prefix": {
									"locationName": "s3Prefix"
								}
							}
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"TargetEnvironment": {
							"locationName": "targetEnvironment"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportTask": {
							"shape": "S7s",
							"locationName": "exportTask"
						}
					}
				}
			},
			"CreateInternetGateway": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InternetGateway": {
							"shape": "S7y",
							"locationName": "internetGateway"
						}
					}
				}
			},
			"CreateKeyPair": {
				"input": {
					"type": "structure",
					"required": [
						"KeyName"
					],
					"members": {
						"KeyName": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyFingerprint": {
							"locationName": "keyFingerprint"
						},
						"KeyMaterial": {
							"locationName": "keyMaterial"
						},
						"KeyName": {
							"locationName": "keyName"
						}
					}
				}
			},
			"CreateLaunchTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchTemplateName",
						"LaunchTemplateData"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {},
						"LaunchTemplateName": {},
						"VersionDescription": {},
						"LaunchTemplateData": {
							"shape": "S83"
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchTemplate": {
							"shape": "S93",
							"locationName": "launchTemplate"
						}
					}
				}
			},
			"CreateLaunchTemplateVersion": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchTemplateData"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {},
						"LaunchTemplateId": {},
						"LaunchTemplateName": {},
						"SourceVersion": {},
						"VersionDescription": {},
						"LaunchTemplateData": {
							"shape": "S83"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchTemplateVersion": {
							"shape": "S96",
							"locationName": "launchTemplateVersion"
						}
					}
				}
			},
			"CreateNatGateway": {
				"input": {
					"type": "structure",
					"required": [
						"AllocationId",
						"SubnetId"
					],
					"members": {
						"AllocationId": {},
						"ClientToken": {},
						"SubnetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientToken": {
							"locationName": "clientToken"
						},
						"NatGateway": {
							"shape": "S9z",
							"locationName": "natGateway"
						}
					}
				}
			},
			"CreateNetworkAcl": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkAcl": {
							"shape": "Sa6",
							"locationName": "networkAcl"
						}
					}
				}
			},
			"CreateNetworkAclEntry": {
				"input": {
					"type": "structure",
					"required": [
						"Egress",
						"NetworkAclId",
						"Protocol",
						"RuleAction",
						"RuleNumber"
					],
					"members": {
						"CidrBlock": {
							"locationName": "cidrBlock"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Egress": {
							"locationName": "egress",
							"type": "boolean"
						},
						"IcmpTypeCode": {
							"shape": "Sab",
							"locationName": "Icmp"
						},
						"Ipv6CidrBlock": {
							"locationName": "ipv6CidrBlock"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						},
						"PortRange": {
							"shape": "Sac",
							"locationName": "portRange"
						},
						"Protocol": {
							"locationName": "protocol"
						},
						"RuleAction": {
							"locationName": "ruleAction"
						},
						"RuleNumber": {
							"locationName": "ruleNumber",
							"type": "integer"
						}
					}
				}
			},
			"CreateNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId"
					],
					"members": {
						"Description": {
							"locationName": "description"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Groups": {
							"shape": "S8a",
							"locationName": "SecurityGroupId"
						},
						"Ipv6AddressCount": {
							"locationName": "ipv6AddressCount",
							"type": "integer"
						},
						"Ipv6Addresses": {
							"shape": "S9e",
							"locationName": "ipv6Addresses"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"PrivateIpAddresses": {
							"shape": "S8d",
							"locationName": "privateIpAddresses"
						},
						"SecondaryPrivateIpAddressCount": {
							"locationName": "secondaryPrivateIpAddressCount",
							"type": "integer"
						},
						"InterfaceType": {},
						"SubnetId": {
							"locationName": "subnetId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterface": {
							"shape": "Sai",
							"locationName": "networkInterface"
						}
					}
				}
			},
			"CreateNetworkInterfacePermission": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId",
						"Permission"
					],
					"members": {
						"NetworkInterfaceId": {},
						"AwsAccountId": {},
						"AwsService": {},
						"Permission": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InterfacePermission": {
							"shape": "Saw",
							"locationName": "interfacePermission"
						}
					}
				}
			},
			"CreatePlacementGroup": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {
							"locationName": "groupName"
						},
						"Strategy": {
							"locationName": "strategy"
						},
						"PartitionCount": {
							"type": "integer"
						}
					}
				}
			},
			"CreateReservedInstancesListing": {
				"input": {
					"type": "structure",
					"required": [
						"ClientToken",
						"InstanceCount",
						"PriceSchedules",
						"ReservedInstancesId"
					],
					"members": {
						"ClientToken": {
							"locationName": "clientToken"
						},
						"InstanceCount": {
							"locationName": "instanceCount",
							"type": "integer"
						},
						"PriceSchedules": {
							"locationName": "priceSchedules",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"Price": {
										"locationName": "price",
										"type": "double"
									},
									"Term": {
										"locationName": "term",
										"type": "long"
									}
								}
							}
						},
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesListings": {
							"shape": "S3w",
							"locationName": "reservedInstancesListingsSet"
						}
					}
				}
			},
			"CreateRoute": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DestinationCidrBlock": {
							"locationName": "destinationCidrBlock"
						},
						"DestinationIpv6CidrBlock": {
							"locationName": "destinationIpv6CidrBlock"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EgressOnlyInternetGatewayId": {
							"locationName": "egressOnlyInternetGatewayId"
						},
						"GatewayId": {
							"locationName": "gatewayId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"NatGatewayId": {
							"locationName": "natGatewayId"
						},
						"TransitGatewayId": {},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"CreateRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RouteTable": {
							"shape": "Sb9",
							"locationName": "routeTable"
						}
					}
				}
			},
			"CreateSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"Description",
						"GroupName"
					],
					"members": {
						"Description": {
							"locationName": "GroupDescription"
						},
						"GroupName": {},
						"VpcId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GroupId": {
							"locationName": "groupId"
						}
					}
				}
			},
			"CreateSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"Description": {},
						"VolumeId": {},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "Sbl"
				}
			},
			"CreateSnapshots": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceSpecification"
					],
					"members": {
						"Description": {},
						"InstanceSpecification": {
							"type": "structure",
							"members": {
								"InstanceId": {},
								"ExcludeBootVolume": {
									"type": "boolean"
								}
							}
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"DryRun": {
							"type": "boolean"
						},
						"CopyTagsFromSource": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Snapshots": {
							"locationName": "snapshotSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Description": {
										"locationName": "description"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"Encrypted": {
										"locationName": "encrypted",
										"type": "boolean"
									},
									"VolumeId": {
										"locationName": "volumeId"
									},
									"State": {
										"locationName": "state"
									},
									"VolumeSize": {
										"locationName": "volumeSize",
										"type": "integer"
									},
									"StartTime": {
										"locationName": "startTime",
										"type": "timestamp"
									},
									"Progress": {
										"locationName": "progress"
									},
									"OwnerId": {
										"locationName": "ownerId"
									},
									"SnapshotId": {
										"locationName": "snapshotId"
									}
								}
							}
						}
					}
				}
			},
			"CreateSpotDatafeedSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"locationName": "bucket"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Prefix": {
							"locationName": "prefix"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotDatafeedSubscription": {
							"shape": "Sbw",
							"locationName": "spotDatafeedSubscription"
						}
					}
				}
			},
			"CreateSubnet": {
				"input": {
					"type": "structure",
					"required": [
						"CidrBlock",
						"VpcId"
					],
					"members": {
						"AvailabilityZone": {},
						"AvailabilityZoneId": {},
						"CidrBlock": {},
						"Ipv6CidrBlock": {},
						"VpcId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Subnet": {
							"shape": "S5n",
							"locationName": "subnet"
						}
					}
				}
			},
			"CreateTags": {
				"input": {
					"type": "structure",
					"required": [
						"Resources",
						"Tags"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Resources": {
							"shape": "Sc2",
							"locationName": "ResourceId"
						},
						"Tags": {
							"shape": "Si",
							"locationName": "Tag"
						}
					}
				}
			},
			"CreateTrafficMirrorFilter": {
				"input": {
					"type": "structure",
					"members": {
						"Description": {},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilter": {
							"shape": "Sc5",
							"locationName": "trafficMirrorFilter"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateTrafficMirrorFilterRule": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorFilterId",
						"TrafficDirection",
						"RuleNumber",
						"RuleAction",
						"DestinationCidrBlock",
						"SourceCidrBlock"
					],
					"members": {
						"TrafficMirrorFilterId": {},
						"TrafficDirection": {},
						"RuleNumber": {
							"type": "integer"
						},
						"RuleAction": {},
						"DestinationPortRange": {
							"shape": "Sce"
						},
						"SourcePortRange": {
							"shape": "Sce"
						},
						"Protocol": {
							"type": "integer"
						},
						"DestinationCidrBlock": {},
						"SourceCidrBlock": {},
						"Description": {},
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilterRule": {
							"shape": "Sc7",
							"locationName": "trafficMirrorFilterRule"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateTrafficMirrorSession": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId",
						"TrafficMirrorTargetId",
						"TrafficMirrorFilterId",
						"SessionNumber"
					],
					"members": {
						"NetworkInterfaceId": {},
						"TrafficMirrorTargetId": {},
						"TrafficMirrorFilterId": {},
						"PacketLength": {
							"type": "integer"
						},
						"SessionNumber": {
							"type": "integer"
						},
						"VirtualNetworkId": {
							"type": "integer"
						},
						"Description": {},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorSession": {
							"shape": "Sci",
							"locationName": "trafficMirrorSession"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateTrafficMirrorTarget": {
				"input": {
					"type": "structure",
					"members": {
						"NetworkInterfaceId": {},
						"NetworkLoadBalancerArn": {},
						"Description": {},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorTarget": {
							"shape": "Scl",
							"locationName": "trafficMirrorTarget"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateTransitGateway": {
				"input": {
					"type": "structure",
					"members": {
						"Description": {},
						"Options": {
							"type": "structure",
							"members": {
								"AmazonSideAsn": {
									"type": "long"
								},
								"AutoAcceptSharedAttachments": {},
								"DefaultRouteTableAssociation": {},
								"DefaultRouteTablePropagation": {},
								"VpnEcmpSupport": {},
								"DnsSupport": {}
							}
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGateway": {
							"shape": "Scu",
							"locationName": "transitGateway"
						}
					}
				}
			},
			"CreateTransitGatewayRoute": {
				"input": {
					"type": "structure",
					"required": [
						"DestinationCidrBlock",
						"TransitGatewayRouteTableId"
					],
					"members": {
						"DestinationCidrBlock": {},
						"TransitGatewayRouteTableId": {},
						"TransitGatewayAttachmentId": {},
						"Blackhole": {
							"type": "boolean"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Route": {
							"shape": "Scz",
							"locationName": "route"
						}
					}
				}
			},
			"CreateTransitGatewayRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayId"
					],
					"members": {
						"TransitGatewayId": {},
						"TagSpecifications": {
							"shape": "S19"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayRouteTable": {
							"shape": "Sd6",
							"locationName": "transitGatewayRouteTable"
						}
					}
				}
			},
			"CreateTransitGatewayVpcAttachment": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayId",
						"VpcId",
						"SubnetIds"
					],
					"members": {
						"TransitGatewayId": {},
						"VpcId": {},
						"SubnetIds": {
							"shape": "Sd"
						},
						"Options": {
							"type": "structure",
							"members": {
								"DnsSupport": {},
								"Ipv6Support": {}
							}
						},
						"TagSpecifications": {
							"shape": "S19"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayVpcAttachment": {
							"shape": "Sb",
							"locationName": "transitGatewayVpcAttachment"
						}
					}
				}
			},
			"CreateVolume": {
				"input": {
					"type": "structure",
					"required": [
						"AvailabilityZone"
					],
					"members": {
						"AvailabilityZone": {},
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"KmsKeyId": {},
						"Size": {
							"type": "integer"
						},
						"SnapshotId": {},
						"VolumeType": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						}
					}
				},
				"output": {
					"shape": "Sdc"
				}
			},
			"CreateVpc": {
				"input": {
					"type": "structure",
					"required": [
						"CidrBlock"
					],
					"members": {
						"CidrBlock": {},
						"AmazonProvidedIpv6CidrBlock": {
							"locationName": "amazonProvidedIpv6CidrBlock",
							"type": "boolean"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceTenancy": {
							"locationName": "instanceTenancy"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpc": {
							"shape": "S5s",
							"locationName": "vpc"
						}
					}
				}
			},
			"CreateVpcEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId",
						"ServiceName"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcEndpointType": {},
						"VpcId": {},
						"ServiceName": {},
						"PolicyDocument": {},
						"RouteTableIds": {
							"shape": "Sd",
							"locationName": "RouteTableId"
						},
						"SubnetIds": {
							"shape": "Sd",
							"locationName": "SubnetId"
						},
						"SecurityGroupIds": {
							"shape": "Sd",
							"locationName": "SecurityGroupId"
						},
						"ClientToken": {},
						"PrivateDnsEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcEndpoint": {
							"shape": "Sdk",
							"locationName": "vpcEndpoint"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateVpcEndpointConnectionNotification": {
				"input": {
					"type": "structure",
					"required": [
						"ConnectionNotificationArn",
						"ConnectionEvents"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceId": {},
						"VpcEndpointId": {},
						"ConnectionNotificationArn": {},
						"ConnectionEvents": {
							"shape": "Sd"
						},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConnectionNotification": {
							"shape": "Sds",
							"locationName": "connectionNotification"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateVpcEndpointServiceConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkLoadBalancerArns"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"AcceptanceRequired": {
							"type": "boolean"
						},
						"NetworkLoadBalancerArns": {
							"shape": "Sd",
							"locationName": "NetworkLoadBalancerArn"
						},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceConfiguration": {
							"shape": "Sdx",
							"locationName": "serviceConfiguration"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PeerOwnerId": {
							"locationName": "peerOwnerId"
						},
						"PeerVpcId": {
							"locationName": "peerVpcId"
						},
						"VpcId": {
							"locationName": "vpcId"
						},
						"PeerRegion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringConnection": {
							"shape": "Sr",
							"locationName": "vpcPeeringConnection"
						}
					}
				}
			},
			"CreateVpnConnection": {
				"input": {
					"type": "structure",
					"required": [
						"CustomerGatewayId",
						"Type"
					],
					"members": {
						"CustomerGatewayId": {},
						"Type": {},
						"VpnGatewayId": {},
						"TransitGatewayId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Options": {
							"locationName": "options",
							"type": "structure",
							"members": {
								"StaticRoutesOnly": {
									"locationName": "staticRoutesOnly",
									"type": "boolean"
								},
								"TunnelOptions": {
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"TunnelInsideCidr": {},
											"PreSharedKey": {}
										}
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnConnection": {
							"shape": "Se9",
							"locationName": "vpnConnection"
						}
					}
				}
			},
			"CreateVpnConnectionRoute": {
				"input": {
					"type": "structure",
					"required": [
						"DestinationCidrBlock",
						"VpnConnectionId"
					],
					"members": {
						"DestinationCidrBlock": {},
						"VpnConnectionId": {}
					}
				}
			},
			"CreateVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"AvailabilityZone": {},
						"Type": {},
						"AmazonSideAsn": {
							"type": "long"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnGateway": {
							"shape": "Sel",
							"locationName": "vpnGateway"
						}
					}
				}
			},
			"DeleteClientVpnEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"shape": "S5b",
							"locationName": "status"
						}
					}
				}
			},
			"DeleteClientVpnRoute": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"DestinationCidrBlock"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"TargetVpcSubnetId": {},
						"DestinationCidrBlock": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"shape": "S5f",
							"locationName": "status"
						}
					}
				}
			},
			"DeleteCustomerGateway": {
				"input": {
					"type": "structure",
					"required": [
						"CustomerGatewayId"
					],
					"members": {
						"CustomerGatewayId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteDhcpOptions": {
				"input": {
					"type": "structure",
					"required": [
						"DhcpOptionsId"
					],
					"members": {
						"DhcpOptionsId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteEgressOnlyInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"EgressOnlyInternetGatewayId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"EgressOnlyInternetGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReturnCode": {
							"locationName": "returnCode",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteFleets": {
				"input": {
					"type": "structure",
					"required": [
						"FleetIds",
						"TerminateInstances"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"FleetIds": {
							"shape": "Sew",
							"locationName": "FleetId"
						},
						"TerminateInstances": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SuccessfulFleetDeletions": {
							"locationName": "successfulFleetDeletionSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CurrentFleetState": {
										"locationName": "currentFleetState"
									},
									"PreviousFleetState": {
										"locationName": "previousFleetState"
									},
									"FleetId": {
										"locationName": "fleetId"
									}
								}
							}
						},
						"UnsuccessfulFleetDeletions": {
							"locationName": "unsuccessfulFleetDeletionSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Error": {
										"locationName": "error",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Message": {
												"locationName": "message"
											}
										}
									},
									"FleetId": {
										"locationName": "fleetId"
									}
								}
							}
						}
					}
				}
			},
			"DeleteFlowLogs": {
				"input": {
					"type": "structure",
					"required": [
						"FlowLogIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"FlowLogIds": {
							"shape": "Sd",
							"locationName": "FlowLogId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "Sm",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"DeleteFpgaImage": {
				"input": {
					"type": "structure",
					"required": [
						"FpgaImageId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"FpgaImageId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"InternetGatewayId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayId": {
							"locationName": "internetGatewayId"
						}
					}
				}
			},
			"DeleteKeyPair": {
				"input": {
					"type": "structure",
					"required": [
						"KeyName"
					],
					"members": {
						"KeyName": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteLaunchTemplate": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"LaunchTemplateId": {},
						"LaunchTemplateName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchTemplate": {
							"shape": "S93",
							"locationName": "launchTemplate"
						}
					}
				}
			},
			"DeleteLaunchTemplateVersions": {
				"input": {
					"type": "structure",
					"required": [
						"Versions"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"LaunchTemplateId": {},
						"LaunchTemplateName": {},
						"Versions": {
							"shape": "Sfe",
							"locationName": "LaunchTemplateVersion"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SuccessfullyDeletedLaunchTemplateVersions": {
							"locationName": "successfullyDeletedLaunchTemplateVersionSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"LaunchTemplateId": {
										"locationName": "launchTemplateId"
									},
									"LaunchTemplateName": {
										"locationName": "launchTemplateName"
									},
									"VersionNumber": {
										"locationName": "versionNumber",
										"type": "long"
									}
								}
							}
						},
						"UnsuccessfullyDeletedLaunchTemplateVersions": {
							"locationName": "unsuccessfullyDeletedLaunchTemplateVersionSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"LaunchTemplateId": {
										"locationName": "launchTemplateId"
									},
									"LaunchTemplateName": {
										"locationName": "launchTemplateName"
									},
									"VersionNumber": {
										"locationName": "versionNumber",
										"type": "long"
									},
									"ResponseError": {
										"locationName": "responseError",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Message": {
												"locationName": "message"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DeleteNatGateway": {
				"input": {
					"type": "structure",
					"required": [
						"NatGatewayId"
					],
					"members": {
						"NatGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NatGatewayId": {
							"locationName": "natGatewayId"
						}
					}
				}
			},
			"DeleteNetworkAcl": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkAclId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						}
					}
				}
			},
			"DeleteNetworkAclEntry": {
				"input": {
					"type": "structure",
					"required": [
						"Egress",
						"NetworkAclId",
						"RuleNumber"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Egress": {
							"locationName": "egress",
							"type": "boolean"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						},
						"RuleNumber": {
							"locationName": "ruleNumber",
							"type": "integer"
						}
					}
				}
			},
			"DeleteNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						}
					}
				}
			},
			"DeleteNetworkInterfacePermission": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfacePermissionId"
					],
					"members": {
						"NetworkInterfacePermissionId": {},
						"Force": {
							"type": "boolean"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DeletePlacementGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {
							"locationName": "groupName"
						}
					}
				}
			},
			"DeleteRoute": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DestinationCidrBlock": {
							"locationName": "destinationCidrBlock"
						},
						"DestinationIpv6CidrBlock": {
							"locationName": "destinationIpv6CidrBlock"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						}
					}
				}
			},
			"DeleteRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						}
					}
				}
			},
			"DeleteSecurityGroup": {
				"input": {
					"type": "structure",
					"members": {
						"GroupId": {},
						"GroupName": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotId"
					],
					"members": {
						"SnapshotId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteSpotDatafeedSubscription": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteSubnet": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId"
					],
					"members": {
						"SubnetId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"Resources"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Resources": {
							"shape": "Sc2",
							"locationName": "resourceId"
						},
						"Tags": {
							"shape": "Si",
							"locationName": "tag"
						}
					}
				}
			},
			"DeleteTrafficMirrorFilter": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorFilterId"
					],
					"members": {
						"TrafficMirrorFilterId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilterId": {
							"locationName": "trafficMirrorFilterId"
						}
					}
				}
			},
			"DeleteTrafficMirrorFilterRule": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorFilterRuleId"
					],
					"members": {
						"TrafficMirrorFilterRuleId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilterRuleId": {
							"locationName": "trafficMirrorFilterRuleId"
						}
					}
				}
			},
			"DeleteTrafficMirrorSession": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorSessionId"
					],
					"members": {
						"TrafficMirrorSessionId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorSessionId": {
							"locationName": "trafficMirrorSessionId"
						}
					}
				}
			},
			"DeleteTrafficMirrorTarget": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorTargetId"
					],
					"members": {
						"TrafficMirrorTargetId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorTargetId": {
							"locationName": "trafficMirrorTargetId"
						}
					}
				}
			},
			"DeleteTransitGateway": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayId"
					],
					"members": {
						"TransitGatewayId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGateway": {
							"shape": "Scu",
							"locationName": "transitGateway"
						}
					}
				}
			},
			"DeleteTransitGatewayRoute": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId",
						"DestinationCidrBlock"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"DestinationCidrBlock": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Route": {
							"shape": "Scz",
							"locationName": "route"
						}
					}
				}
			},
			"DeleteTransitGatewayRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayRouteTable": {
							"shape": "Sd6",
							"locationName": "transitGatewayRouteTable"
						}
					}
				}
			},
			"DeleteTransitGatewayVpcAttachment": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayAttachmentId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayVpcAttachment": {
							"shape": "Sb",
							"locationName": "transitGatewayVpcAttachment"
						}
					}
				}
			},
			"DeleteVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteVpc": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"VpcId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteVpcEndpointConnectionNotifications": {
				"input": {
					"type": "structure",
					"required": [
						"ConnectionNotificationIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ConnectionNotificationIds": {
							"shape": "Sd",
							"locationName": "ConnectionNotificationId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "Sm",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"DeleteVpcEndpointServiceConfigurations": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceIds": {
							"shape": "Sd",
							"locationName": "ServiceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "Sm",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"DeleteVpcEndpoints": {
				"input": {
					"type": "structure",
					"required": [
						"VpcEndpointIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcEndpointIds": {
							"shape": "Sd",
							"locationName": "VpcEndpointId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "Sm",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"DeleteVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"required": [
						"VpcPeeringConnectionId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteVpnConnection": {
				"input": {
					"type": "structure",
					"required": [
						"VpnConnectionId"
					],
					"members": {
						"VpnConnectionId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteVpnConnectionRoute": {
				"input": {
					"type": "structure",
					"required": [
						"DestinationCidrBlock",
						"VpnConnectionId"
					],
					"members": {
						"DestinationCidrBlock": {},
						"VpnConnectionId": {}
					}
				}
			},
			"DeleteVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpnGatewayId"
					],
					"members": {
						"VpnGatewayId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeprovisionByoipCidr": {
				"input": {
					"type": "structure",
					"required": [
						"Cidr"
					],
					"members": {
						"Cidr": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByoipCidr": {
							"shape": "S12",
							"locationName": "byoipCidr"
						}
					}
				}
			},
			"DeregisterImage": {
				"input": {
					"type": "structure",
					"required": [
						"ImageId"
					],
					"members": {
						"ImageId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DescribeAccountAttributes": {
				"input": {
					"type": "structure",
					"members": {
						"AttributeNames": {
							"locationName": "attributeName",
							"type": "list",
							"member": {
								"locationName": "attributeName"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountAttributes": {
							"locationName": "accountAttributeSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AttributeName": {
										"locationName": "attributeName"
									},
									"AttributeValues": {
										"locationName": "attributeValueSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"AttributeValue": {
													"locationName": "attributeValue"
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeAddresses": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"PublicIps": {
							"locationName": "PublicIp",
							"type": "list",
							"member": {
								"locationName": "PublicIp"
							}
						},
						"AllocationIds": {
							"locationName": "AllocationId",
							"type": "list",
							"member": {
								"locationName": "AllocationId"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Addresses": {
							"locationName": "addressesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {
										"locationName": "instanceId"
									},
									"PublicIp": {
										"locationName": "publicIp"
									},
									"AllocationId": {
										"locationName": "allocationId"
									},
									"AssociationId": {
										"locationName": "associationId"
									},
									"Domain": {
										"locationName": "domain"
									},
									"NetworkInterfaceId": {
										"locationName": "networkInterfaceId"
									},
									"NetworkInterfaceOwnerId": {
										"locationName": "networkInterfaceOwnerId"
									},
									"PrivateIpAddress": {
										"locationName": "privateIpAddress"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"PublicIpv4Pool": {
										"locationName": "publicIpv4Pool"
									}
								}
							}
						}
					}
				}
			},
			"DescribeAggregateIdFormat": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UseLongIdsAggregated": {
							"locationName": "useLongIdsAggregated",
							"type": "boolean"
						},
						"Statuses": {
							"shape": "Shf",
							"locationName": "statusSet"
						}
					}
				}
			},
			"DescribeAvailabilityZones": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"ZoneNames": {
							"locationName": "ZoneName",
							"type": "list",
							"member": {
								"locationName": "ZoneName"
							}
						},
						"ZoneIds": {
							"locationName": "ZoneId",
							"type": "list",
							"member": {
								"locationName": "ZoneId"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"locationName": "availabilityZoneInfo",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"State": {
										"locationName": "zoneState"
									},
									"Messages": {
										"locationName": "messageSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Message": {
													"locationName": "message"
												}
											}
										}
									},
									"RegionName": {
										"locationName": "regionName"
									},
									"ZoneName": {
										"locationName": "zoneName"
									},
									"ZoneId": {
										"locationName": "zoneId"
									}
								}
							}
						}
					}
				}
			},
			"DescribeBundleTasks": {
				"input": {
					"type": "structure",
					"members": {
						"BundleIds": {
							"locationName": "BundleId",
							"type": "list",
							"member": {
								"locationName": "BundleId"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BundleTasks": {
							"locationName": "bundleInstanceTasksSet",
							"type": "list",
							"member": {
								"shape": "S3j",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeByoipCidrs": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByoipCidrs": {
							"locationName": "byoipCidrSet",
							"type": "list",
							"member": {
								"shape": "S12",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeCapacityReservations": {
				"input": {
					"type": "structure",
					"members": {
						"CapacityReservationIds": {
							"locationName": "CapacityReservationId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"CapacityReservations": {
							"locationName": "capacityReservationSet",
							"type": "list",
							"member": {
								"shape": "S50",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeClassicLinkInstances": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"locationName": "instancesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Groups": {
										"shape": "Sal",
										"locationName": "groupSet"
									},
									"InstanceId": {
										"locationName": "instanceId"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"VpcId": {
										"locationName": "vpcId"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeClientVpnAuthorizationRules": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"DryRun": {
							"type": "boolean"
						},
						"NextToken": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AuthorizationRules": {
							"locationName": "authorizationRule",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ClientVpnEndpointId": {
										"locationName": "clientVpnEndpointId"
									},
									"Description": {
										"locationName": "description"
									},
									"GroupId": {
										"locationName": "groupId"
									},
									"AccessAll": {
										"locationName": "accessAll",
										"type": "boolean"
									},
									"DestinationCidr": {
										"locationName": "destinationCidr"
									},
									"Status": {
										"shape": "S30",
										"locationName": "status"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeClientVpnConnections": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Connections": {
							"locationName": "connections",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ClientVpnEndpointId": {
										"locationName": "clientVpnEndpointId"
									},
									"Timestamp": {
										"locationName": "timestamp"
									},
									"ConnectionId": {
										"locationName": "connectionId"
									},
									"Username": {
										"locationName": "username"
									},
									"ConnectionEstablishedTime": {
										"locationName": "connectionEstablishedTime"
									},
									"IngressBytes": {
										"locationName": "ingressBytes"
									},
									"EgressBytes": {
										"locationName": "egressBytes"
									},
									"IngressPackets": {
										"locationName": "ingressPackets"
									},
									"EgressPackets": {
										"locationName": "egressPackets"
									},
									"ClientIp": {
										"locationName": "clientIp"
									},
									"CommonName": {
										"locationName": "commonName"
									},
									"Status": {
										"shape": "Sik",
										"locationName": "status"
									},
									"ConnectionEndTime": {
										"locationName": "connectionEndTime"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeClientVpnEndpoints": {
				"input": {
					"type": "structure",
					"members": {
						"ClientVpnEndpointIds": {
							"shape": "Sd",
							"locationName": "ClientVpnEndpointId"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientVpnEndpoints": {
							"locationName": "clientVpnEndpoint",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ClientVpnEndpointId": {
										"locationName": "clientVpnEndpointId"
									},
									"Description": {
										"locationName": "description"
									},
									"Status": {
										"shape": "S5b",
										"locationName": "status"
									},
									"CreationTime": {
										"locationName": "creationTime"
									},
									"DeletionTime": {
										"locationName": "deletionTime"
									},
									"DnsName": {
										"locationName": "dnsName"
									},
									"ClientCidrBlock": {
										"locationName": "clientCidrBlock"
									},
									"DnsServers": {
										"shape": "Sd",
										"locationName": "dnsServer"
									},
									"SplitTunnel": {
										"locationName": "splitTunnel",
										"type": "boolean"
									},
									"VpnProtocol": {
										"locationName": "vpnProtocol"
									},
									"TransportProtocol": {
										"locationName": "transportProtocol"
									},
									"AssociatedTargetNetworks": {
										"deprecated": true,
										"deprecatedMessage": "This property is deprecated. To view the target networks associated with a Client VPN endpoint, call DescribeClientVpnTargetNetworks and inspect the clientVpnTargetNetworks response element.",
										"locationName": "associatedTargetNetwork",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"NetworkId": {
													"locationName": "networkId"
												},
												"NetworkType": {
													"locationName": "networkType"
												}
											}
										}
									},
									"ServerCertificateArn": {
										"locationName": "serverCertificateArn"
									},
									"AuthenticationOptions": {
										"locationName": "authenticationOptions",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Type": {
													"locationName": "type"
												},
												"ActiveDirectory": {
													"locationName": "activeDirectory",
													"type": "structure",
													"members": {
														"DirectoryId": {
															"locationName": "directoryId"
														}
													}
												},
												"MutualAuthentication": {
													"locationName": "mutualAuthentication",
													"type": "structure",
													"members": {
														"ClientRootCertificateChain": {
															"locationName": "clientRootCertificateChain"
														}
													}
												}
											}
										}
									},
									"ConnectionLogOptions": {
										"locationName": "connectionLogOptions",
										"type": "structure",
										"members": {
											"Enabled": {
												"type": "boolean"
											},
											"CloudwatchLogGroup": {},
											"CloudwatchLogStream": {}
										}
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeClientVpnRoutes": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Routes": {
							"locationName": "routes",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ClientVpnEndpointId": {
										"locationName": "clientVpnEndpointId"
									},
									"DestinationCidr": {
										"locationName": "destinationCidr"
									},
									"TargetSubnet": {
										"locationName": "targetSubnet"
									},
									"Type": {
										"locationName": "type"
									},
									"Origin": {
										"locationName": "origin"
									},
									"Status": {
										"shape": "S5f",
										"locationName": "status"
									},
									"Description": {
										"locationName": "description"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeClientVpnTargetNetworks": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"AssociationIds": {
							"shape": "Sd"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientVpnTargetNetworks": {
							"locationName": "clientVpnTargetNetworks",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AssociationId": {
										"locationName": "associationId"
									},
									"VpcId": {
										"locationName": "vpcId"
									},
									"TargetNetworkId": {
										"locationName": "targetNetworkId"
									},
									"ClientVpnEndpointId": {
										"locationName": "clientVpnEndpointId"
									},
									"Status": {
										"shape": "S1u",
										"locationName": "status"
									},
									"SecurityGroups": {
										"shape": "Sd",
										"locationName": "securityGroups"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeConversionTasks": {
				"input": {
					"type": "structure",
					"members": {
						"ConversionTaskIds": {
							"locationName": "conversionTaskId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConversionTasks": {
							"locationName": "conversionTasks",
							"type": "list",
							"member": {
								"shape": "Sje",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeCustomerGateways": {
				"input": {
					"type": "structure",
					"members": {
						"CustomerGatewayIds": {
							"locationName": "CustomerGatewayId",
							"type": "list",
							"member": {
								"locationName": "CustomerGatewayId"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CustomerGateways": {
							"locationName": "customerGatewaySet",
							"type": "list",
							"member": {
								"shape": "S5k",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeDhcpOptions": {
				"input": {
					"type": "structure",
					"members": {
						"DhcpOptionsIds": {
							"locationName": "DhcpOptionsId",
							"type": "list",
							"member": {
								"locationName": "DhcpOptionsId"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DhcpOptions": {
							"locationName": "dhcpOptionsSet",
							"type": "list",
							"member": {
								"shape": "S61",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeEgressOnlyInternetGateways": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"EgressOnlyInternetGatewayIds": {
							"locationName": "EgressOnlyInternetGatewayId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EgressOnlyInternetGateways": {
							"locationName": "egressOnlyInternetGatewaySet",
							"type": "list",
							"member": {
								"shape": "S68",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeElasticGpus": {
				"input": {
					"type": "structure",
					"members": {
						"ElasticGpuIds": {
							"locationName": "ElasticGpuId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ElasticGpuSet": {
							"locationName": "elasticGpuSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ElasticGpuId": {
										"locationName": "elasticGpuId"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"ElasticGpuType": {
										"locationName": "elasticGpuType"
									},
									"ElasticGpuHealth": {
										"locationName": "elasticGpuHealth",
										"type": "structure",
										"members": {
											"Status": {
												"locationName": "status"
											}
										}
									},
									"ElasticGpuState": {
										"locationName": "elasticGpuState"
									},
									"InstanceId": {
										"locationName": "instanceId"
									}
								}
							}
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeExportTasks": {
				"input": {
					"type": "structure",
					"members": {
						"ExportTaskIds": {
							"locationName": "exportTaskId",
							"type": "list",
							"member": {
								"locationName": "ExportTaskId"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportTasks": {
							"locationName": "exportTaskSet",
							"type": "list",
							"member": {
								"shape": "S7s",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeFleetHistory": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"StartTime"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"EventType": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"FleetId": {},
						"StartTime": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HistoryRecords": {
							"locationName": "historyRecordSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"EventInformation": {
										"shape": "Ski",
										"locationName": "eventInformation"
									},
									"EventType": {
										"locationName": "eventType"
									},
									"Timestamp": {
										"locationName": "timestamp",
										"type": "timestamp"
									}
								}
							}
						},
						"LastEvaluatedTime": {
							"locationName": "lastEvaluatedTime",
							"type": "timestamp"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"FleetId": {
							"locationName": "fleetId"
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeFleetInstances": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"FleetId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ActiveInstances": {
							"shape": "Skl",
							"locationName": "activeInstanceSet"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"FleetId": {
							"locationName": "fleetId"
						}
					}
				}
			},
			"DescribeFleets": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"FleetIds": {
							"shape": "Sew",
							"locationName": "FleetId"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"Fleets": {
							"locationName": "fleetSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ActivityStatus": {
										"locationName": "activityStatus"
									},
									"CreateTime": {
										"locationName": "createTime",
										"type": "timestamp"
									},
									"FleetId": {
										"locationName": "fleetId"
									},
									"FleetState": {
										"locationName": "fleetState"
									},
									"ClientToken": {
										"locationName": "clientToken"
									},
									"ExcessCapacityTerminationPolicy": {
										"locationName": "excessCapacityTerminationPolicy"
									},
									"FulfilledCapacity": {
										"locationName": "fulfilledCapacity",
										"type": "double"
									},
									"FulfilledOnDemandCapacity": {
										"locationName": "fulfilledOnDemandCapacity",
										"type": "double"
									},
									"LaunchTemplateConfigs": {
										"locationName": "launchTemplateConfigs",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"LaunchTemplateSpecification": {
													"shape": "S6z",
													"locationName": "launchTemplateSpecification"
												},
												"Overrides": {
													"locationName": "overrides",
													"type": "list",
													"member": {
														"shape": "S70",
														"locationName": "item"
													}
												}
											}
										}
									},
									"TargetCapacitySpecification": {
										"locationName": "targetCapacitySpecification",
										"type": "structure",
										"members": {
											"TotalTargetCapacity": {
												"locationName": "totalTargetCapacity",
												"type": "integer"
											},
											"OnDemandTargetCapacity": {
												"locationName": "onDemandTargetCapacity",
												"type": "integer"
											},
											"SpotTargetCapacity": {
												"locationName": "spotTargetCapacity",
												"type": "integer"
											},
											"DefaultTargetCapacityType": {
												"locationName": "defaultTargetCapacityType"
											}
										}
									},
									"TerminateInstancesWithExpiration": {
										"locationName": "terminateInstancesWithExpiration",
										"type": "boolean"
									},
									"Type": {
										"locationName": "type"
									},
									"ValidFrom": {
										"locationName": "validFrom",
										"type": "timestamp"
									},
									"ValidUntil": {
										"locationName": "validUntil",
										"type": "timestamp"
									},
									"ReplaceUnhealthyInstances": {
										"locationName": "replaceUnhealthyInstances",
										"type": "boolean"
									},
									"SpotOptions": {
										"locationName": "spotOptions",
										"type": "structure",
										"members": {
											"AllocationStrategy": {
												"locationName": "allocationStrategy"
											},
											"InstanceInterruptionBehavior": {
												"locationName": "instanceInterruptionBehavior"
											},
											"InstancePoolsToUseCount": {
												"locationName": "instancePoolsToUseCount",
												"type": "integer"
											},
											"SingleInstanceType": {
												"locationName": "singleInstanceType",
												"type": "boolean"
											},
											"SingleAvailabilityZone": {
												"locationName": "singleAvailabilityZone",
												"type": "boolean"
											},
											"MinTargetCapacity": {
												"locationName": "minTargetCapacity",
												"type": "integer"
											},
											"MaxTotalPrice": {
												"locationName": "maxTotalPrice"
											}
										}
									},
									"OnDemandOptions": {
										"locationName": "onDemandOptions",
										"type": "structure",
										"members": {
											"AllocationStrategy": {
												"locationName": "allocationStrategy"
											},
											"SingleInstanceType": {
												"locationName": "singleInstanceType",
												"type": "boolean"
											},
											"SingleAvailabilityZone": {
												"locationName": "singleAvailabilityZone",
												"type": "boolean"
											},
											"MinTargetCapacity": {
												"locationName": "minTargetCapacity",
												"type": "integer"
											},
											"MaxTotalPrice": {
												"locationName": "maxTotalPrice"
											}
										}
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"Errors": {
										"locationName": "errorSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"LaunchTemplateAndOverrides": {
													"shape": "S6y",
													"locationName": "launchTemplateAndOverrides"
												},
												"Lifecycle": {
													"locationName": "lifecycle"
												},
												"ErrorCode": {
													"locationName": "errorCode"
												},
												"ErrorMessage": {
													"locationName": "errorMessage"
												}
											}
										}
									},
									"Instances": {
										"locationName": "fleetInstanceSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"LaunchTemplateAndOverrides": {
													"shape": "S6y",
													"locationName": "launchTemplateAndOverrides"
												},
												"Lifecycle": {
													"locationName": "lifecycle"
												},
												"InstanceIds": {
													"shape": "S75",
													"locationName": "instanceIds"
												},
												"InstanceType": {
													"locationName": "instanceType"
												},
												"Platform": {
													"locationName": "platform"
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeFlowLogs": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filter": {
							"shape": "Sh6"
						},
						"FlowLogIds": {
							"shape": "Sd",
							"locationName": "FlowLogId"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FlowLogs": {
							"locationName": "flowLogSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CreationTime": {
										"locationName": "creationTime",
										"type": "timestamp"
									},
									"DeliverLogsErrorMessage": {
										"locationName": "deliverLogsErrorMessage"
									},
									"DeliverLogsPermissionArn": {
										"locationName": "deliverLogsPermissionArn"
									},
									"DeliverLogsStatus": {
										"locationName": "deliverLogsStatus"
									},
									"FlowLogId": {
										"locationName": "flowLogId"
									},
									"FlowLogStatus": {
										"locationName": "flowLogStatus"
									},
									"LogGroupName": {
										"locationName": "logGroupName"
									},
									"ResourceId": {
										"locationName": "resourceId"
									},
									"TrafficType": {
										"locationName": "trafficType"
									},
									"LogDestinationType": {
										"locationName": "logDestinationType"
									},
									"LogDestination": {
										"locationName": "logDestination"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeFpgaImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"FpgaImageId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"FpgaImageId": {},
						"Attribute": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FpgaImageAttribute": {
							"shape": "Sla",
							"locationName": "fpgaImageAttribute"
						}
					}
				}
			},
			"DescribeFpgaImages": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"FpgaImageIds": {
							"locationName": "FpgaImageId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"Owners": {
							"shape": "Slj",
							"locationName": "Owner"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FpgaImages": {
							"locationName": "fpgaImageSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"FpgaImageId": {
										"locationName": "fpgaImageId"
									},
									"FpgaImageGlobalId": {
										"locationName": "fpgaImageGlobalId"
									},
									"Name": {
										"locationName": "name"
									},
									"Description": {
										"locationName": "description"
									},
									"ShellVersion": {
										"locationName": "shellVersion"
									},
									"PciId": {
										"locationName": "pciId",
										"type": "structure",
										"members": {
											"DeviceId": {},
											"VendorId": {},
											"SubsystemId": {},
											"SubsystemVendorId": {}
										}
									},
									"State": {
										"locationName": "state",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Message": {
												"locationName": "message"
											}
										}
									},
									"CreateTime": {
										"locationName": "createTime",
										"type": "timestamp"
									},
									"UpdateTime": {
										"locationName": "updateTime",
										"type": "timestamp"
									},
									"OwnerId": {
										"locationName": "ownerId"
									},
									"OwnerAlias": {
										"locationName": "ownerAlias"
									},
									"ProductCodes": {
										"shape": "Sle",
										"locationName": "productCodes"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tags"
									},
									"Public": {
										"locationName": "public",
										"type": "boolean"
									},
									"DataRetentionSupport": {
										"locationName": "dataRetentionSupport",
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeHostReservationOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"shape": "Sh6"
						},
						"MaxDuration": {
							"type": "integer"
						},
						"MaxResults": {
							"type": "integer"
						},
						"MinDuration": {
							"type": "integer"
						},
						"NextToken": {},
						"OfferingId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"OfferingSet": {
							"locationName": "offeringSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"Duration": {
										"locationName": "duration",
										"type": "integer"
									},
									"HourlyPrice": {
										"locationName": "hourlyPrice"
									},
									"InstanceFamily": {
										"locationName": "instanceFamily"
									},
									"OfferingId": {
										"locationName": "offeringId"
									},
									"PaymentOption": {
										"locationName": "paymentOption"
									},
									"UpfrontPrice": {
										"locationName": "upfrontPrice"
									}
								}
							}
						}
					}
				}
			},
			"DescribeHostReservations": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"shape": "Sh6"
						},
						"HostReservationIdSet": {
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HostReservationSet": {
							"locationName": "hostReservationSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Count": {
										"locationName": "count",
										"type": "integer"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"Duration": {
										"locationName": "duration",
										"type": "integer"
									},
									"End": {
										"locationName": "end",
										"type": "timestamp"
									},
									"HostIdSet": {
										"shape": "Sm2",
										"locationName": "hostIdSet"
									},
									"HostReservationId": {
										"locationName": "hostReservationId"
									},
									"HourlyPrice": {
										"locationName": "hourlyPrice"
									},
									"InstanceFamily": {
										"locationName": "instanceFamily"
									},
									"OfferingId": {
										"locationName": "offeringId"
									},
									"PaymentOption": {
										"locationName": "paymentOption"
									},
									"Start": {
										"locationName": "start",
										"type": "timestamp"
									},
									"State": {
										"locationName": "state"
									},
									"UpfrontPrice": {
										"locationName": "upfrontPrice"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeHosts": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"shape": "Sh6",
							"locationName": "filter"
						},
						"HostIds": {
							"shape": "Sm5",
							"locationName": "hostId"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Hosts": {
							"locationName": "hostSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AutoPlacement": {
										"locationName": "autoPlacement"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"AvailableCapacity": {
										"locationName": "availableCapacity",
										"type": "structure",
										"members": {
											"AvailableInstanceCapacity": {
												"locationName": "availableInstanceCapacity",
												"type": "list",
												"member": {
													"locationName": "item",
													"type": "structure",
													"members": {
														"AvailableCapacity": {
															"locationName": "availableCapacity",
															"type": "integer"
														},
														"InstanceType": {
															"locationName": "instanceType"
														},
														"TotalCapacity": {
															"locationName": "totalCapacity",
															"type": "integer"
														}
													}
												}
											},
											"AvailableVCpus": {
												"locationName": "availableVCpus",
												"type": "integer"
											}
										}
									},
									"ClientToken": {
										"locationName": "clientToken"
									},
									"HostId": {
										"locationName": "hostId"
									},
									"HostProperties": {
										"locationName": "hostProperties",
										"type": "structure",
										"members": {
											"Cores": {
												"locationName": "cores",
												"type": "integer"
											},
											"InstanceType": {
												"locationName": "instanceType"
											},
											"Sockets": {
												"locationName": "sockets",
												"type": "integer"
											},
											"TotalVCpus": {
												"locationName": "totalVCpus",
												"type": "integer"
											}
										}
									},
									"HostReservationId": {
										"locationName": "hostReservationId"
									},
									"Instances": {
										"locationName": "instances",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"InstanceId": {
													"locationName": "instanceId"
												},
												"InstanceType": {
													"locationName": "instanceType"
												}
											}
										}
									},
									"State": {
										"locationName": "state"
									},
									"AllocationTime": {
										"locationName": "allocationTime",
										"type": "timestamp"
									},
									"ReleaseTime": {
										"locationName": "releaseTime",
										"type": "timestamp"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"HostRecovery": {
										"locationName": "hostRecovery"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeIamInstanceProfileAssociations": {
				"input": {
					"type": "structure",
					"members": {
						"AssociationIds": {
							"locationName": "AssociationId",
							"type": "list",
							"member": {
								"locationName": "AssociationId"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociations": {
							"locationName": "iamInstanceProfileAssociationSet",
							"type": "list",
							"member": {
								"shape": "S20",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeIdFormat": {
				"input": {
					"type": "structure",
					"members": {
						"Resource": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Statuses": {
							"shape": "Shf",
							"locationName": "statusSet"
						}
					}
				}
			},
			"DescribeIdentityIdFormat": {
				"input": {
					"type": "structure",
					"required": [
						"PrincipalArn"
					],
					"members": {
						"PrincipalArn": {
							"locationName": "principalArn"
						},
						"Resource": {
							"locationName": "resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Statuses": {
							"shape": "Shf",
							"locationName": "statusSet"
						}
					}
				}
			},
			"DescribeImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"ImageId"
					],
					"members": {
						"Attribute": {},
						"ImageId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BlockDeviceMappings": {
							"shape": "Sms",
							"locationName": "blockDeviceMapping"
						},
						"ImageId": {
							"locationName": "imageId"
						},
						"LaunchPermissions": {
							"shape": "Smt",
							"locationName": "launchPermission"
						},
						"ProductCodes": {
							"shape": "Sle",
							"locationName": "productCodes"
						},
						"Description": {
							"shape": "S65",
							"locationName": "description"
						},
						"KernelId": {
							"shape": "S65",
							"locationName": "kernel"
						},
						"RamdiskId": {
							"shape": "S65",
							"locationName": "ramdisk"
						},
						"SriovNetSupport": {
							"shape": "S65",
							"locationName": "sriovNetSupport"
						}
					}
				}
			},
			"DescribeImages": {
				"input": {
					"type": "structure",
					"members": {
						"ExecutableUsers": {
							"locationName": "ExecutableBy",
							"type": "list",
							"member": {
								"locationName": "ExecutableBy"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"ImageIds": {
							"locationName": "ImageId",
							"type": "list",
							"member": {
								"locationName": "ImageId"
							}
						},
						"Owners": {
							"shape": "Slj",
							"locationName": "Owner"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Images": {
							"locationName": "imagesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Architecture": {
										"locationName": "architecture"
									},
									"CreationDate": {
										"locationName": "creationDate"
									},
									"ImageId": {
										"locationName": "imageId"
									},
									"ImageLocation": {
										"locationName": "imageLocation"
									},
									"ImageType": {
										"locationName": "imageType"
									},
									"Public": {
										"locationName": "isPublic",
										"type": "boolean"
									},
									"KernelId": {
										"locationName": "kernelId"
									},
									"OwnerId": {
										"locationName": "imageOwnerId"
									},
									"Platform": {
										"locationName": "platform"
									},
									"ProductCodes": {
										"shape": "Sle",
										"locationName": "productCodes"
									},
									"RamdiskId": {
										"locationName": "ramdiskId"
									},
									"State": {
										"locationName": "imageState"
									},
									"BlockDeviceMappings": {
										"shape": "Sms",
										"locationName": "blockDeviceMapping"
									},
									"Description": {
										"locationName": "description"
									},
									"EnaSupport": {
										"locationName": "enaSupport",
										"type": "boolean"
									},
									"Hypervisor": {
										"locationName": "hypervisor"
									},
									"ImageOwnerAlias": {
										"locationName": "imageOwnerAlias"
									},
									"Name": {
										"locationName": "name"
									},
									"RootDeviceName": {
										"locationName": "rootDeviceName"
									},
									"RootDeviceType": {
										"locationName": "rootDeviceType"
									},
									"SriovNetSupport": {
										"locationName": "sriovNetSupport"
									},
									"StateReason": {
										"shape": "Sn6",
										"locationName": "stateReason"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"VirtualizationType": {
										"locationName": "virtualizationType"
									}
								}
							}
						}
					}
				}
			},
			"DescribeImportImageTasks": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6"
						},
						"ImportTaskIds": {
							"shape": "Sn9",
							"locationName": "ImportTaskId"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportImageTasks": {
							"locationName": "importImageTaskSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Architecture": {
										"locationName": "architecture"
									},
									"Description": {
										"locationName": "description"
									},
									"Encrypted": {
										"locationName": "encrypted",
										"type": "boolean"
									},
									"Hypervisor": {
										"locationName": "hypervisor"
									},
									"ImageId": {
										"locationName": "imageId"
									},
									"ImportTaskId": {
										"locationName": "importTaskId"
									},
									"KmsKeyId": {
										"locationName": "kmsKeyId"
									},
									"LicenseType": {
										"locationName": "licenseType"
									},
									"Platform": {
										"locationName": "platform"
									},
									"Progress": {
										"locationName": "progress"
									},
									"SnapshotDetails": {
										"shape": "Snd",
										"locationName": "snapshotDetailSet"
									},
									"Status": {
										"locationName": "status"
									},
									"StatusMessage": {
										"locationName": "statusMessage"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeImportSnapshotTasks": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6"
						},
						"ImportTaskIds": {
							"shape": "Sn9",
							"locationName": "ImportTaskId"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportSnapshotTasks": {
							"locationName": "importSnapshotTaskSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Description": {
										"locationName": "description"
									},
									"ImportTaskId": {
										"locationName": "importTaskId"
									},
									"SnapshotTaskDetail": {
										"shape": "Snk",
										"locationName": "snapshotTaskDetail"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeInstanceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"InstanceId"
					],
					"members": {
						"Attribute": {
							"locationName": "attribute"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "Sal",
							"locationName": "groupSet"
						},
						"BlockDeviceMappings": {
							"shape": "Sno",
							"locationName": "blockDeviceMapping"
						},
						"DisableApiTermination": {
							"shape": "Snr",
							"locationName": "disableApiTermination"
						},
						"EnaSupport": {
							"shape": "Snr",
							"locationName": "enaSupport"
						},
						"EbsOptimized": {
							"shape": "Snr",
							"locationName": "ebsOptimized"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"InstanceInitiatedShutdownBehavior": {
							"shape": "S65",
							"locationName": "instanceInitiatedShutdownBehavior"
						},
						"InstanceType": {
							"shape": "S65",
							"locationName": "instanceType"
						},
						"KernelId": {
							"shape": "S65",
							"locationName": "kernel"
						},
						"ProductCodes": {
							"shape": "Sle",
							"locationName": "productCodes"
						},
						"RamdiskId": {
							"shape": "S65",
							"locationName": "ramdisk"
						},
						"RootDeviceName": {
							"shape": "S65",
							"locationName": "rootDeviceName"
						},
						"SourceDestCheck": {
							"shape": "Snr",
							"locationName": "sourceDestCheck"
						},
						"SriovNetSupport": {
							"shape": "S65",
							"locationName": "sriovNetSupport"
						},
						"UserData": {
							"shape": "S65",
							"locationName": "userData"
						}
					}
				}
			},
			"DescribeInstanceCreditSpecifications": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceCreditSpecifications": {
							"locationName": "instanceCreditSpecificationSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {
										"locationName": "instanceId"
									},
									"CpuCredits": {
										"locationName": "cpuCredits"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeInstanceStatus": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"IncludeAllInstances": {
							"locationName": "includeAllInstances",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceStatuses": {
							"locationName": "instanceStatusSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Events": {
										"locationName": "eventsSet",
										"type": "list",
										"member": {
											"shape": "So2",
											"locationName": "item"
										}
									},
									"InstanceId": {
										"locationName": "instanceId"
									},
									"InstanceState": {
										"shape": "So5",
										"locationName": "instanceState"
									},
									"InstanceStatus": {
										"shape": "So7",
										"locationName": "instanceStatus"
									},
									"SystemStatus": {
										"shape": "So7",
										"locationName": "systemStatus"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeInstances": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Reservations": {
							"locationName": "reservationSet",
							"type": "list",
							"member": {
								"shape": "Sog",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeInternetGateways": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayIds": {
							"shape": "Sd",
							"locationName": "internetGatewayId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InternetGateways": {
							"locationName": "internetGatewaySet",
							"type": "list",
							"member": {
								"shape": "S7y",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeKeyPairs": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"KeyNames": {
							"locationName": "KeyName",
							"type": "list",
							"member": {
								"locationName": "KeyName"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyPairs": {
							"locationName": "keySet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"KeyFingerprint": {
										"locationName": "keyFingerprint"
									},
									"KeyName": {
										"locationName": "keyName"
									}
								}
							}
						}
					}
				}
			},
			"DescribeLaunchTemplateVersions": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"LaunchTemplateId": {},
						"LaunchTemplateName": {},
						"Versions": {
							"shape": "Sfe",
							"locationName": "LaunchTemplateVersion"
						},
						"MinVersion": {},
						"MaxVersion": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchTemplateVersions": {
							"locationName": "launchTemplateVersionSet",
							"type": "list",
							"member": {
								"shape": "S96",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeLaunchTemplates": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"LaunchTemplateIds": {
							"shape": "Sd",
							"locationName": "LaunchTemplateId"
						},
						"LaunchTemplateNames": {
							"locationName": "LaunchTemplateName",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchTemplates": {
							"locationName": "launchTemplates",
							"type": "list",
							"member": {
								"shape": "S93",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeMovingAddresses": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"PublicIps": {
							"shape": "Sd",
							"locationName": "publicIp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MovingAddressStatuses": {
							"locationName": "movingAddressStatusSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"MoveStatus": {
										"locationName": "moveStatus"
									},
									"PublicIp": {
										"locationName": "publicIp"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeNatGateways": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"shape": "Sh6"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NatGatewayIds": {
							"shape": "Sd",
							"locationName": "NatGatewayId"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NatGateways": {
							"locationName": "natGatewaySet",
							"type": "list",
							"member": {
								"shape": "S9z",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeNetworkAcls": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclIds": {
							"shape": "Sd",
							"locationName": "NetworkAclId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkAcls": {
							"locationName": "networkAclSet",
							"type": "list",
							"member": {
								"shape": "Sa6",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeNetworkInterfaceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"Attribute": {
							"locationName": "attribute"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attachment": {
							"shape": "Sak",
							"locationName": "attachment"
						},
						"Description": {
							"shape": "S65",
							"locationName": "description"
						},
						"Groups": {
							"shape": "Sal",
							"locationName": "groupSet"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"SourceDestCheck": {
							"shape": "Snr",
							"locationName": "sourceDestCheck"
						}
					}
				}
			},
			"DescribeNetworkInterfacePermissions": {
				"input": {
					"type": "structure",
					"members": {
						"NetworkInterfacePermissionIds": {
							"locationName": "NetworkInterfacePermissionId",
							"type": "list",
							"member": {}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfacePermissions": {
							"locationName": "networkInterfacePermissions",
							"type": "list",
							"member": {
								"shape": "Saw",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeNetworkInterfaces": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceIds": {
							"locationName": "NetworkInterfaceId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfaces": {
							"locationName": "networkInterfaceSet",
							"type": "list",
							"member": {
								"shape": "Sai",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribePlacementGroups": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupNames": {
							"locationName": "groupName",
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlacementGroups": {
							"locationName": "placementGroupSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"GroupName": {
										"locationName": "groupName"
									},
									"State": {
										"locationName": "state"
									},
									"Strategy": {
										"locationName": "strategy"
									},
									"PartitionCount": {
										"locationName": "partitionCount",
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DescribePrefixLists": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"PrefixListIds": {
							"shape": "Sd",
							"locationName": "PrefixListId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"PrefixLists": {
							"locationName": "prefixListSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Cidrs": {
										"shape": "Sd",
										"locationName": "cidrSet"
									},
									"PrefixListId": {
										"locationName": "prefixListId"
									},
									"PrefixListName": {
										"locationName": "prefixListName"
									}
								}
							}
						}
					}
				}
			},
			"DescribePrincipalIdFormat": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Resources": {
							"locationName": "Resource",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Principals": {
							"locationName": "principalSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Arn": {
										"locationName": "arn"
									},
									"Statuses": {
										"shape": "Shf",
										"locationName": "statusSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribePublicIpv4Pools": {
				"input": {
					"type": "structure",
					"members": {
						"PoolIds": {
							"shape": "Sd",
							"locationName": "PoolId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicIpv4Pools": {
							"locationName": "publicIpv4PoolSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"PoolId": {
										"locationName": "poolId"
									},
									"Description": {
										"locationName": "description"
									},
									"PoolAddressRanges": {
										"locationName": "poolAddressRangeSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"FirstAddress": {
													"locationName": "firstAddress"
												},
												"LastAddress": {
													"locationName": "lastAddress"
												},
												"AddressCount": {
													"locationName": "addressCount",
													"type": "integer"
												},
												"AvailableAddressCount": {
													"locationName": "availableAddressCount",
													"type": "integer"
												}
											}
										}
									},
									"TotalAddressCount": {
										"locationName": "totalAddressCount",
										"type": "integer"
									},
									"TotalAvailableAddressCount": {
										"locationName": "totalAvailableAddressCount",
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeRegions": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"RegionNames": {
							"locationName": "RegionName",
							"type": "list",
							"member": {
								"locationName": "RegionName"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"AllRegions": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Regions": {
							"locationName": "regionInfo",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Endpoint": {
										"locationName": "regionEndpoint"
									},
									"RegionName": {
										"locationName": "regionName"
									},
									"OptInStatus": {
										"locationName": "optInStatus"
									}
								}
							}
						}
					}
				}
			},
			"DescribeReservedInstances": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"OfferingClass": {},
						"ReservedInstancesIds": {
							"shape": "Sr3",
							"locationName": "ReservedInstancesId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"OfferingType": {
							"locationName": "offeringType"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstances": {
							"locationName": "reservedInstancesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Duration": {
										"locationName": "duration",
										"type": "long"
									},
									"End": {
										"locationName": "end",
										"type": "timestamp"
									},
									"FixedPrice": {
										"locationName": "fixedPrice",
										"type": "float"
									},
									"InstanceCount": {
										"locationName": "instanceCount",
										"type": "integer"
									},
									"InstanceType": {
										"locationName": "instanceType"
									},
									"ProductDescription": {
										"locationName": "productDescription"
									},
									"ReservedInstancesId": {
										"locationName": "reservedInstancesId"
									},
									"Start": {
										"locationName": "start",
										"type": "timestamp"
									},
									"State": {
										"locationName": "state"
									},
									"UsagePrice": {
										"locationName": "usagePrice",
										"type": "float"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"InstanceTenancy": {
										"locationName": "instanceTenancy"
									},
									"OfferingClass": {
										"locationName": "offeringClass"
									},
									"OfferingType": {
										"locationName": "offeringType"
									},
									"RecurringCharges": {
										"shape": "Srb",
										"locationName": "recurringCharges"
									},
									"Scope": {
										"locationName": "scope"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									}
								}
							}
						}
					}
				}
			},
			"DescribeReservedInstancesListings": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						},
						"ReservedInstancesListingId": {
							"locationName": "reservedInstancesListingId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesListings": {
							"shape": "S3w",
							"locationName": "reservedInstancesListingsSet"
						}
					}
				}
			},
			"DescribeReservedInstancesModifications": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"ReservedInstancesModificationIds": {
							"locationName": "ReservedInstancesModificationId",
							"type": "list",
							"member": {
								"locationName": "ReservedInstancesModificationId"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"ReservedInstancesModifications": {
							"locationName": "reservedInstancesModificationsSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ClientToken": {
										"locationName": "clientToken"
									},
									"CreateDate": {
										"locationName": "createDate",
										"type": "timestamp"
									},
									"EffectiveDate": {
										"locationName": "effectiveDate",
										"type": "timestamp"
									},
									"ModificationResults": {
										"locationName": "modificationResultSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"ReservedInstancesId": {
													"locationName": "reservedInstancesId"
												},
												"TargetConfiguration": {
													"shape": "Sro",
													"locationName": "targetConfiguration"
												}
											}
										}
									},
									"ReservedInstancesIds": {
										"locationName": "reservedInstancesSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"ReservedInstancesId": {
													"locationName": "reservedInstancesId"
												}
											}
										}
									},
									"ReservedInstancesModificationId": {
										"locationName": "reservedInstancesModificationId"
									},
									"Status": {
										"locationName": "status"
									},
									"StatusMessage": {
										"locationName": "statusMessage"
									},
									"UpdateDate": {
										"locationName": "updateDate",
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeReservedInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"AvailabilityZone": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"IncludeMarketplace": {
							"type": "boolean"
						},
						"InstanceType": {},
						"MaxDuration": {
							"type": "long"
						},
						"MaxInstanceCount": {
							"type": "integer"
						},
						"MinDuration": {
							"type": "long"
						},
						"OfferingClass": {},
						"ProductDescription": {},
						"ReservedInstancesOfferingIds": {
							"locationName": "ReservedInstancesOfferingId",
							"type": "list",
							"member": {}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceTenancy": {
							"locationName": "instanceTenancy"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"OfferingType": {
							"locationName": "offeringType"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesOfferings": {
							"locationName": "reservedInstancesOfferingsSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Duration": {
										"locationName": "duration",
										"type": "long"
									},
									"FixedPrice": {
										"locationName": "fixedPrice",
										"type": "float"
									},
									"InstanceType": {
										"locationName": "instanceType"
									},
									"ProductDescription": {
										"locationName": "productDescription"
									},
									"ReservedInstancesOfferingId": {
										"locationName": "reservedInstancesOfferingId"
									},
									"UsagePrice": {
										"locationName": "usagePrice",
										"type": "float"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"InstanceTenancy": {
										"locationName": "instanceTenancy"
									},
									"Marketplace": {
										"locationName": "marketplace",
										"type": "boolean"
									},
									"OfferingClass": {
										"locationName": "offeringClass"
									},
									"OfferingType": {
										"locationName": "offeringType"
									},
									"PricingDetails": {
										"locationName": "pricingDetailsSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Count": {
													"locationName": "count",
													"type": "integer"
												},
												"Price": {
													"locationName": "price",
													"type": "double"
												}
											}
										}
									},
									"RecurringCharges": {
										"shape": "Srb",
										"locationName": "recurringCharges"
									},
									"Scope": {
										"locationName": "scope"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeRouteTables": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableIds": {
							"shape": "Sd",
							"locationName": "RouteTableId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RouteTables": {
							"locationName": "routeTableSet",
							"type": "list",
							"member": {
								"shape": "Sb9",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeScheduledInstanceAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"FirstSlotStartTimeRange",
						"Recurrence"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"FirstSlotStartTimeRange": {
							"type": "structure",
							"required": [
								"EarliestTime",
								"LatestTime"
							],
							"members": {
								"EarliestTime": {
									"type": "timestamp"
								},
								"LatestTime": {
									"type": "timestamp"
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"MaxSlotDurationInHours": {
							"type": "integer"
						},
						"MinSlotDurationInHours": {
							"type": "integer"
						},
						"NextToken": {},
						"Recurrence": {
							"type": "structure",
							"members": {
								"Frequency": {},
								"Interval": {
									"type": "integer"
								},
								"OccurrenceDays": {
									"locationName": "OccurrenceDay",
									"type": "list",
									"member": {
										"locationName": "OccurenceDay",
										"type": "integer"
									}
								},
								"OccurrenceRelativeToEnd": {
									"type": "boolean"
								},
								"OccurrenceUnit": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"ScheduledInstanceAvailabilitySet": {
							"locationName": "scheduledInstanceAvailabilitySet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"AvailableInstanceCount": {
										"locationName": "availableInstanceCount",
										"type": "integer"
									},
									"FirstSlotStartTime": {
										"locationName": "firstSlotStartTime",
										"type": "timestamp"
									},
									"HourlyPrice": {
										"locationName": "hourlyPrice"
									},
									"InstanceType": {
										"locationName": "instanceType"
									},
									"MaxTermDurationInDays": {
										"locationName": "maxTermDurationInDays",
										"type": "integer"
									},
									"MinTermDurationInDays": {
										"locationName": "minTermDurationInDays",
										"type": "integer"
									},
									"NetworkPlatform": {
										"locationName": "networkPlatform"
									},
									"Platform": {
										"locationName": "platform"
									},
									"PurchaseToken": {
										"locationName": "purchaseToken"
									},
									"Recurrence": {
										"shape": "Ssa",
										"locationName": "recurrence"
									},
									"SlotDurationInHours": {
										"locationName": "slotDurationInHours",
										"type": "integer"
									},
									"TotalScheduledInstanceHours": {
										"locationName": "totalScheduledInstanceHours",
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DescribeScheduledInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"ScheduledInstanceIds": {
							"locationName": "ScheduledInstanceId",
							"type": "list",
							"member": {
								"locationName": "ScheduledInstanceId"
							}
						},
						"SlotStartTimeRange": {
							"type": "structure",
							"members": {
								"EarliestTime": {
									"type": "timestamp"
								},
								"LatestTime": {
									"type": "timestamp"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"ScheduledInstanceSet": {
							"locationName": "scheduledInstanceSet",
							"type": "list",
							"member": {
								"shape": "Ssh",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeSecurityGroupReferences": {
				"input": {
					"type": "structure",
					"required": [
						"GroupId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"GroupId": {
							"type": "list",
							"member": {
								"locationName": "item"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecurityGroupReferenceSet": {
							"locationName": "securityGroupReferenceSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"GroupId": {
										"locationName": "groupId"
									},
									"ReferencingVpcId": {
										"locationName": "referencingVpcId"
									},
									"VpcPeeringConnectionId": {
										"locationName": "vpcPeeringConnectionId"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"GroupIds": {
							"shape": "S2m",
							"locationName": "GroupId"
						},
						"GroupNames": {
							"shape": "Sso",
							"locationName": "GroupName"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecurityGroups": {
							"locationName": "securityGroupInfo",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Description": {
										"locationName": "groupDescription"
									},
									"GroupName": {
										"locationName": "groupName"
									},
									"IpPermissions": {
										"shape": "S33",
										"locationName": "ipPermissions"
									},
									"OwnerId": {
										"locationName": "ownerId"
									},
									"GroupId": {
										"locationName": "groupId"
									},
									"IpPermissionsEgress": {
										"shape": "S33",
										"locationName": "ipPermissionsEgress"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"VpcId": {
										"locationName": "vpcId"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"SnapshotId"
					],
					"members": {
						"Attribute": {},
						"SnapshotId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CreateVolumePermissions": {
							"shape": "Ssw",
							"locationName": "createVolumePermission"
						},
						"ProductCodes": {
							"shape": "Sle",
							"locationName": "productCodes"
						},
						"SnapshotId": {
							"locationName": "snapshotId"
						}
					}
				}
			},
			"DescribeSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"OwnerIds": {
							"shape": "Slj",
							"locationName": "Owner"
						},
						"RestorableByUserIds": {
							"locationName": "RestorableBy",
							"type": "list",
							"member": {}
						},
						"SnapshotIds": {
							"locationName": "SnapshotId",
							"type": "list",
							"member": {
								"locationName": "SnapshotId"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Snapshots": {
							"locationName": "snapshotSet",
							"type": "list",
							"member": {
								"shape": "Sbl",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSpotDatafeedSubscription": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotDatafeedSubscription": {
							"shape": "Sbw",
							"locationName": "spotDatafeedSubscription"
						}
					}
				}
			},
			"DescribeSpotFleetInstances": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ActiveInstances": {
							"shape": "Skl",
							"locationName": "activeInstanceSet"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						}
					}
				}
			},
			"DescribeSpotFleetRequestHistory": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId",
						"StartTime"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EventType": {
							"locationName": "eventType"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HistoryRecords": {
							"locationName": "historyRecordSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"EventInformation": {
										"shape": "Ski",
										"locationName": "eventInformation"
									},
									"EventType": {
										"locationName": "eventType"
									},
									"Timestamp": {
										"locationName": "timestamp",
										"type": "timestamp"
									}
								}
							}
						},
						"LastEvaluatedTime": {
							"locationName": "lastEvaluatedTime",
							"type": "timestamp"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeSpotFleetRequests": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"SpotFleetRequestIds": {
							"shape": "Sd",
							"locationName": "spotFleetRequestId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"SpotFleetRequestConfigs": {
							"locationName": "spotFleetRequestConfigSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ActivityStatus": {
										"locationName": "activityStatus"
									},
									"CreateTime": {
										"locationName": "createTime",
										"type": "timestamp"
									},
									"SpotFleetRequestConfig": {
										"shape": "Stj",
										"locationName": "spotFleetRequestConfig"
									},
									"SpotFleetRequestId": {
										"locationName": "spotFleetRequestId"
									},
									"SpotFleetRequestState": {
										"locationName": "spotFleetRequestState"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSpotInstanceRequests": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotInstanceRequestIds": {
							"shape": "S4h",
							"locationName": "SpotInstanceRequestId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotInstanceRequests": {
							"shape": "Su8",
							"locationName": "spotInstanceRequestSet"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSpotPriceHistory": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EndTime": {
							"locationName": "endTime",
							"type": "timestamp"
						},
						"InstanceTypes": {
							"locationName": "InstanceType",
							"type": "list",
							"member": {}
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"ProductDescriptions": {
							"locationName": "ProductDescription",
							"type": "list",
							"member": {}
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"SpotPriceHistory": {
							"locationName": "spotPriceHistorySet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"InstanceType": {
										"locationName": "instanceType"
									},
									"ProductDescription": {
										"locationName": "productDescription"
									},
									"SpotPrice": {
										"locationName": "spotPrice"
									},
									"Timestamp": {
										"locationName": "timestamp",
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeStaleSecurityGroups": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"StaleSecurityGroupSet": {
							"locationName": "staleSecurityGroupSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Description": {
										"locationName": "description"
									},
									"GroupId": {
										"locationName": "groupId"
									},
									"GroupName": {
										"locationName": "groupName"
									},
									"StaleIpPermissions": {
										"shape": "Suq",
										"locationName": "staleIpPermissions"
									},
									"StaleIpPermissionsEgress": {
										"shape": "Suq",
										"locationName": "staleIpPermissionsEgress"
									},
									"VpcId": {
										"locationName": "vpcId"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSubnets": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"SubnetIds": {
							"locationName": "SubnetId",
							"type": "list",
							"member": {
								"locationName": "SubnetId"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Subnets": {
							"locationName": "subnetSet",
							"type": "list",
							"member": {
								"shape": "S5n",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"Tags": {
							"locationName": "tagSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Key": {
										"locationName": "key"
									},
									"ResourceId": {
										"locationName": "resourceId"
									},
									"ResourceType": {
										"locationName": "resourceType"
									},
									"Value": {
										"locationName": "value"
									}
								}
							}
						}
					}
				}
			},
			"DescribeTrafficMirrorFilters": {
				"input": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilterIds": {
							"shape": "Sd",
							"locationName": "TrafficMirrorFilterId"
						},
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilters": {
							"locationName": "trafficMirrorFilterSet",
							"type": "list",
							"member": {
								"shape": "Sc5",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeTrafficMirrorSessions": {
				"input": {
					"type": "structure",
					"members": {
						"TrafficMirrorSessionIds": {
							"shape": "Sd",
							"locationName": "TrafficMirrorSessionId"
						},
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorSessions": {
							"locationName": "trafficMirrorSessionSet",
							"type": "list",
							"member": {
								"shape": "Sci",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeTrafficMirrorTargets": {
				"input": {
					"type": "structure",
					"members": {
						"TrafficMirrorTargetIds": {
							"shape": "Sd",
							"locationName": "TrafficMirrorTargetId"
						},
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorTargets": {
							"locationName": "trafficMirrorTargetSet",
							"type": "list",
							"member": {
								"shape": "Scl",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeTransitGatewayAttachments": {
				"input": {
					"type": "structure",
					"members": {
						"TransitGatewayAttachmentIds": {
							"shape": "Svf"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayAttachments": {
							"locationName": "transitGatewayAttachments",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"TransitGatewayAttachmentId": {
										"locationName": "transitGatewayAttachmentId"
									},
									"TransitGatewayId": {
										"locationName": "transitGatewayId"
									},
									"TransitGatewayOwnerId": {
										"locationName": "transitGatewayOwnerId"
									},
									"ResourceOwnerId": {
										"locationName": "resourceOwnerId"
									},
									"ResourceType": {
										"locationName": "resourceType"
									},
									"ResourceId": {
										"locationName": "resourceId"
									},
									"State": {
										"locationName": "state"
									},
									"Association": {
										"locationName": "association",
										"type": "structure",
										"members": {
											"TransitGatewayRouteTableId": {
												"locationName": "transitGatewayRouteTableId"
											},
											"State": {
												"locationName": "state"
											}
										}
									},
									"CreationTime": {
										"locationName": "creationTime",
										"type": "timestamp"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeTransitGatewayRouteTables": {
				"input": {
					"type": "structure",
					"members": {
						"TransitGatewayRouteTableIds": {
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayRouteTables": {
							"locationName": "transitGatewayRouteTables",
							"type": "list",
							"member": {
								"shape": "Sd6",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeTransitGatewayVpcAttachments": {
				"input": {
					"type": "structure",
					"members": {
						"TransitGatewayAttachmentIds": {
							"shape": "Svf"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayVpcAttachments": {
							"locationName": "transitGatewayVpcAttachments",
							"type": "list",
							"member": {
								"shape": "Sb",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeTransitGateways": {
				"input": {
					"type": "structure",
					"members": {
						"TransitGatewayIds": {
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGateways": {
							"locationName": "transitGatewaySet",
							"type": "list",
							"member": {
								"shape": "Scu",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVolumeAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"VolumeId"
					],
					"members": {
						"Attribute": {},
						"VolumeId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AutoEnableIO": {
							"shape": "Snr",
							"locationName": "autoEnableIO"
						},
						"ProductCodes": {
							"shape": "Sle",
							"locationName": "productCodes"
						},
						"VolumeId": {
							"locationName": "volumeId"
						}
					}
				}
			},
			"DescribeVolumeStatus": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"VolumeIds": {
							"shape": "Sw0",
							"locationName": "VolumeId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"VolumeStatuses": {
							"locationName": "volumeStatusSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Actions": {
										"locationName": "actionsSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Code": {
													"locationName": "code"
												},
												"Description": {
													"locationName": "description"
												},
												"EventId": {
													"locationName": "eventId"
												},
												"EventType": {
													"locationName": "eventType"
												}
											}
										}
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Events": {
										"locationName": "eventsSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Description": {
													"locationName": "description"
												},
												"EventId": {
													"locationName": "eventId"
												},
												"EventType": {
													"locationName": "eventType"
												},
												"NotAfter": {
													"locationName": "notAfter",
													"type": "timestamp"
												},
												"NotBefore": {
													"locationName": "notBefore",
													"type": "timestamp"
												}
											}
										}
									},
									"VolumeId": {
										"locationName": "volumeId"
									},
									"VolumeStatus": {
										"locationName": "volumeStatus",
										"type": "structure",
										"members": {
											"Details": {
												"locationName": "details",
												"type": "list",
												"member": {
													"locationName": "item",
													"type": "structure",
													"members": {
														"Name": {
															"locationName": "name"
														},
														"Status": {
															"locationName": "status"
														}
													}
												}
											},
											"Status": {
												"locationName": "status"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeVolumes": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"VolumeIds": {
							"shape": "Sw0",
							"locationName": "VolumeId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Volumes": {
							"locationName": "volumeSet",
							"type": "list",
							"member": {
								"shape": "Sdc",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVolumesModifications": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VolumeIds": {
							"shape": "Sw0",
							"locationName": "VolumeId"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumesModifications": {
							"locationName": "volumeModificationSet",
							"type": "list",
							"member": {
								"shape": "Swj",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"VpcId"
					],
					"members": {
						"Attribute": {},
						"VpcId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcId": {
							"locationName": "vpcId"
						},
						"EnableDnsHostnames": {
							"shape": "Snr",
							"locationName": "enableDnsHostnames"
						},
						"EnableDnsSupport": {
							"shape": "Snr",
							"locationName": "enableDnsSupport"
						}
					}
				}
			},
			"DescribeVpcClassicLink": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcIds": {
							"shape": "Swp",
							"locationName": "VpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpcs": {
							"locationName": "vpcSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ClassicLinkEnabled": {
										"locationName": "classicLinkEnabled",
										"type": "boolean"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									},
									"VpcId": {
										"locationName": "vpcId"
									}
								}
							}
						}
					}
				}
			},
			"DescribeVpcClassicLinkDnsSupport": {
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"VpcIds": {
							"shape": "Swp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"Vpcs": {
							"locationName": "vpcs",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ClassicLinkDnsSupported": {
										"locationName": "classicLinkDnsSupported",
										"type": "boolean"
									},
									"VpcId": {
										"locationName": "vpcId"
									}
								}
							}
						}
					}
				}
			},
			"DescribeVpcEndpointConnectionNotifications": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ConnectionNotificationId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConnectionNotificationSet": {
							"locationName": "connectionNotificationSet",
							"type": "list",
							"member": {
								"shape": "Sds",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcEndpointConnections": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcEndpointConnections": {
							"locationName": "vpcEndpointConnectionSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ServiceId": {
										"locationName": "serviceId"
									},
									"VpcEndpointId": {
										"locationName": "vpcEndpointId"
									},
									"VpcEndpointOwner": {
										"locationName": "vpcEndpointOwner"
									},
									"VpcEndpointState": {
										"locationName": "vpcEndpointState"
									},
									"CreationTimestamp": {
										"locationName": "creationTimestamp",
										"type": "timestamp"
									},
									"DnsEntries": {
										"shape": "Sdo",
										"locationName": "dnsEntrySet"
									},
									"NetworkLoadBalancerArns": {
										"shape": "Sd",
										"locationName": "networkLoadBalancerArnSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcEndpointServiceConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceIds": {
							"shape": "Sd",
							"locationName": "ServiceId"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceConfigurations": {
							"locationName": "serviceConfigurationSet",
							"type": "list",
							"member": {
								"shape": "Sdx",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcEndpointServicePermissions": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AllowedPrincipals": {
							"locationName": "allowedPrincipals",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"PrincipalType": {
										"locationName": "principalType"
									},
									"Principal": {
										"locationName": "principal"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcEndpointServices": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceNames": {
							"shape": "Sd",
							"locationName": "ServiceName"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceNames": {
							"shape": "Sd",
							"locationName": "serviceNameSet"
						},
						"ServiceDetails": {
							"locationName": "serviceDetailSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ServiceName": {
										"locationName": "serviceName"
									},
									"ServiceId": {
										"locationName": "serviceId"
									},
									"ServiceType": {
										"shape": "Sdy",
										"locationName": "serviceType"
									},
									"AvailabilityZones": {
										"shape": "Sd",
										"locationName": "availabilityZoneSet"
									},
									"Owner": {
										"locationName": "owner"
									},
									"BaseEndpointDnsNames": {
										"shape": "Sd",
										"locationName": "baseEndpointDnsNameSet"
									},
									"PrivateDnsName": {
										"locationName": "privateDnsName"
									},
									"VpcEndpointPolicySupported": {
										"locationName": "vpcEndpointPolicySupported",
										"type": "boolean"
									},
									"AcceptanceRequired": {
										"locationName": "acceptanceRequired",
										"type": "boolean"
									},
									"ManagesVpcEndpoints": {
										"locationName": "managesVpcEndpoints",
										"type": "boolean"
									},
									"Tags": {
										"shape": "Si",
										"locationName": "tagSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcEndpoints": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcEndpointIds": {
							"shape": "Sd",
							"locationName": "VpcEndpointId"
						},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcEndpoints": {
							"locationName": "vpcEndpointSet",
							"type": "list",
							"member": {
								"shape": "Sdk",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcPeeringConnections": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionIds": {
							"shape": "Sd",
							"locationName": "VpcPeeringConnectionId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringConnections": {
							"locationName": "vpcPeeringConnectionSet",
							"type": "list",
							"member": {
								"shape": "Sr",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcs": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"VpcIds": {
							"locationName": "VpcId",
							"type": "list",
							"member": {
								"locationName": "VpcId"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpcs": {
							"locationName": "vpcSet",
							"type": "list",
							"member": {
								"shape": "S5s",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpnConnections": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"VpnConnectionIds": {
							"locationName": "VpnConnectionId",
							"type": "list",
							"member": {
								"locationName": "VpnConnectionId"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnConnections": {
							"locationName": "vpnConnectionSet",
							"type": "list",
							"member": {
								"shape": "Se9",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeVpnGateways": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"VpnGatewayIds": {
							"locationName": "VpnGatewayId",
							"type": "list",
							"member": {
								"locationName": "VpnGatewayId"
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnGateways": {
							"locationName": "vpnGatewaySet",
							"type": "list",
							"member": {
								"shape": "Sel",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DetachClassicLinkVpc": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DetachInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"InternetGatewayId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayId": {
							"locationName": "internetGatewayId"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"DetachNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"AttachmentId"
					],
					"members": {
						"AttachmentId": {
							"locationName": "attachmentId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Force": {
							"locationName": "force",
							"type": "boolean"
						}
					}
				}
			},
			"DetachVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"Device": {},
						"Force": {
							"type": "boolean"
						},
						"InstanceId": {},
						"VolumeId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S2s"
				}
			},
			"DetachVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId",
						"VpnGatewayId"
					],
					"members": {
						"VpcId": {},
						"VpnGatewayId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DisableEbsEncryptionByDefault": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EbsEncryptionByDefault": {
							"locationName": "ebsEncryptionByDefault",
							"type": "boolean"
						}
					}
				}
			},
			"DisableTransitGatewayRouteTablePropagation": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId",
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"TransitGatewayAttachmentId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Propagation": {
							"shape": "Syc",
							"locationName": "propagation"
						}
					}
				}
			},
			"DisableVgwRoutePropagation": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayId",
						"RouteTableId"
					],
					"members": {
						"GatewayId": {},
						"RouteTableId": {}
					}
				}
			},
			"DisableVpcClassicLink": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DisableVpcClassicLinkDnsSupport": {
				"input": {
					"type": "structure",
					"members": {
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DisassociateAddress": {
				"input": {
					"type": "structure",
					"members": {
						"AssociationId": {},
						"PublicIp": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DisassociateClientVpnTargetNetwork": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"AssociationId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"AssociationId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						},
						"Status": {
							"shape": "S1u",
							"locationName": "status"
						}
					}
				}
			},
			"DisassociateIamInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociation": {
							"shape": "S20",
							"locationName": "iamInstanceProfileAssociation"
						}
					}
				}
			},
			"DisassociateRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DisassociateSubnetCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Ipv6CidrBlockAssociation": {
							"shape": "S27",
							"locationName": "ipv6CidrBlockAssociation"
						},
						"SubnetId": {
							"locationName": "subnetId"
						}
					}
				}
			},
			"DisassociateTransitGatewayRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId",
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"TransitGatewayAttachmentId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Association": {
							"shape": "S2c",
							"locationName": "association"
						}
					}
				}
			},
			"DisassociateVpcCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Ipv6CidrBlockAssociation": {
							"shape": "S2h",
							"locationName": "ipv6CidrBlockAssociation"
						},
						"CidrBlockAssociation": {
							"shape": "S2k",
							"locationName": "cidrBlockAssociation"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"EnableEbsEncryptionByDefault": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EbsEncryptionByDefault": {
							"locationName": "ebsEncryptionByDefault",
							"type": "boolean"
						}
					}
				}
			},
			"EnableTransitGatewayRouteTablePropagation": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId",
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"TransitGatewayAttachmentId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Propagation": {
							"shape": "Syc",
							"locationName": "propagation"
						}
					}
				}
			},
			"EnableVgwRoutePropagation": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayId",
						"RouteTableId"
					],
					"members": {
						"GatewayId": {},
						"RouteTableId": {}
					}
				}
			},
			"EnableVolumeIO": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {
							"locationName": "volumeId"
						}
					}
				}
			},
			"EnableVpcClassicLink": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"EnableVpcClassicLinkDnsSupport": {
				"input": {
					"type": "structure",
					"members": {
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ExportClientVpnClientCertificateRevocationList": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CertificateRevocationList": {
							"locationName": "certificateRevocationList"
						},
						"Status": {
							"locationName": "status",
							"type": "structure",
							"members": {
								"Code": {
									"locationName": "code"
								},
								"Message": {
									"locationName": "message"
								}
							}
						}
					}
				}
			},
			"ExportClientVpnClientConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientConfiguration": {
							"locationName": "clientConfiguration"
						}
					}
				}
			},
			"ExportTransitGatewayRoutes": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId",
						"S3Bucket"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"S3Bucket": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"S3Location": {
							"locationName": "s3Location"
						}
					}
				}
			},
			"GetCapacityReservationUsage": {
				"input": {
					"type": "structure",
					"required": [
						"CapacityReservationId"
					],
					"members": {
						"CapacityReservationId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"CapacityReservationId": {
							"locationName": "capacityReservationId"
						},
						"InstanceType": {
							"locationName": "instanceType"
						},
						"TotalInstanceCount": {
							"locationName": "totalInstanceCount",
							"type": "integer"
						},
						"AvailableInstanceCount": {
							"locationName": "availableInstanceCount",
							"type": "integer"
						},
						"State": {
							"locationName": "state"
						},
						"InstanceUsages": {
							"locationName": "instanceUsageSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AccountId": {
										"locationName": "accountId"
									},
									"UsedInstanceCount": {
										"locationName": "usedInstanceCount",
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"GetConsoleOutput": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Latest": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Output": {
							"locationName": "output"
						},
						"Timestamp": {
							"locationName": "timestamp",
							"type": "timestamp"
						}
					}
				}
			},
			"GetConsoleScreenshot": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"InstanceId": {},
						"WakeUp": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageData": {
							"locationName": "imageData"
						},
						"InstanceId": {
							"locationName": "instanceId"
						}
					}
				}
			},
			"GetEbsDefaultKmsKeyId": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						}
					}
				}
			},
			"GetEbsEncryptionByDefault": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EbsEncryptionByDefault": {
							"locationName": "ebsEncryptionByDefault",
							"type": "boolean"
						}
					}
				}
			},
			"GetHostReservationPurchasePreview": {
				"input": {
					"type": "structure",
					"required": [
						"HostIdSet",
						"OfferingId"
					],
					"members": {
						"HostIdSet": {
							"shape": "Szr"
						},
						"OfferingId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CurrencyCode": {
							"locationName": "currencyCode"
						},
						"Purchase": {
							"shape": "Szt",
							"locationName": "purchase"
						},
						"TotalHourlyPrice": {
							"locationName": "totalHourlyPrice"
						},
						"TotalUpfrontPrice": {
							"locationName": "totalUpfrontPrice"
						}
					}
				}
			},
			"GetLaunchTemplateData": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchTemplateData": {
							"shape": "S97",
							"locationName": "launchTemplateData"
						}
					}
				}
			},
			"GetPasswordData": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"PasswordData": {
							"locationName": "passwordData"
						},
						"Timestamp": {
							"locationName": "timestamp",
							"type": "timestamp"
						}
					}
				}
			},
			"GetReservedInstancesExchangeQuote": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstanceIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ReservedInstanceIds": {
							"shape": "S3",
							"locationName": "ReservedInstanceId"
						},
						"TargetConfigurations": {
							"shape": "S5",
							"locationName": "TargetConfiguration"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CurrencyCode": {
							"locationName": "currencyCode"
						},
						"IsValidExchange": {
							"locationName": "isValidExchange",
							"type": "boolean"
						},
						"OutputReservedInstancesWillExpireAt": {
							"locationName": "outputReservedInstancesWillExpireAt",
							"type": "timestamp"
						},
						"PaymentDue": {
							"locationName": "paymentDue"
						},
						"ReservedInstanceValueRollup": {
							"shape": "S101",
							"locationName": "reservedInstanceValueRollup"
						},
						"ReservedInstanceValueSet": {
							"locationName": "reservedInstanceValueSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ReservationValue": {
										"shape": "S101",
										"locationName": "reservationValue"
									},
									"ReservedInstanceId": {
										"locationName": "reservedInstanceId"
									}
								}
							}
						},
						"TargetConfigurationValueRollup": {
							"shape": "S101",
							"locationName": "targetConfigurationValueRollup"
						},
						"TargetConfigurationValueSet": {
							"locationName": "targetConfigurationValueSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ReservationValue": {
										"shape": "S101",
										"locationName": "reservationValue"
									},
									"TargetConfiguration": {
										"locationName": "targetConfiguration",
										"type": "structure",
										"members": {
											"InstanceCount": {
												"locationName": "instanceCount",
												"type": "integer"
											},
											"OfferingId": {
												"locationName": "offeringId"
											}
										}
									}
								}
							}
						},
						"ValidationFailureReason": {
							"locationName": "validationFailureReason"
						}
					}
				}
			},
			"GetTransitGatewayAttachmentPropagations": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayAttachmentId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayAttachmentPropagations": {
							"locationName": "transitGatewayAttachmentPropagations",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"TransitGatewayRouteTableId": {
										"locationName": "transitGatewayRouteTableId"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"GetTransitGatewayRouteTableAssociations": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Associations": {
							"locationName": "associations",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"TransitGatewayAttachmentId": {
										"locationName": "transitGatewayAttachmentId"
									},
									"ResourceId": {
										"locationName": "resourceId"
									},
									"ResourceType": {
										"locationName": "resourceType"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"GetTransitGatewayRouteTablePropagations": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayRouteTablePropagations": {
							"locationName": "transitGatewayRouteTablePropagations",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"TransitGatewayAttachmentId": {
										"locationName": "transitGatewayAttachmentId"
									},
									"ResourceId": {
										"locationName": "resourceId"
									},
									"ResourceType": {
										"locationName": "resourceType"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"ImportClientVpnClientCertificateRevocationList": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"CertificateRevocationList"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"CertificateRevocationList": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ImportImage": {
				"input": {
					"type": "structure",
					"members": {
						"Architecture": {},
						"ClientData": {
							"shape": "S10m"
						},
						"ClientToken": {},
						"Description": {},
						"DiskContainers": {
							"locationName": "DiskContainer",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Description": {},
									"DeviceName": {},
									"Format": {},
									"SnapshotId": {},
									"Url": {},
									"UserBucket": {
										"shape": "S10p"
									}
								}
							}
						},
						"DryRun": {
							"type": "boolean"
						},
						"Encrypted": {
							"type": "boolean"
						},
						"Hypervisor": {},
						"KmsKeyId": {},
						"LicenseType": {},
						"Platform": {},
						"RoleName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Architecture": {
							"locationName": "architecture"
						},
						"Description": {
							"locationName": "description"
						},
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"Hypervisor": {
							"locationName": "hypervisor"
						},
						"ImageId": {
							"locationName": "imageId"
						},
						"ImportTaskId": {
							"locationName": "importTaskId"
						},
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						},
						"LicenseType": {
							"locationName": "licenseType"
						},
						"Platform": {
							"locationName": "platform"
						},
						"Progress": {
							"locationName": "progress"
						},
						"SnapshotDetails": {
							"shape": "Snd",
							"locationName": "snapshotDetailSet"
						},
						"Status": {
							"locationName": "status"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						}
					}
				}
			},
			"ImportInstance": {
				"input": {
					"type": "structure",
					"required": [
						"Platform"
					],
					"members": {
						"Description": {
							"locationName": "description"
						},
						"DiskImages": {
							"locationName": "diskImage",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Description": {},
									"Image": {
										"shape": "S10u"
									},
									"Volume": {
										"shape": "S10v"
									}
								}
							}
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"LaunchSpecification": {
							"locationName": "launchSpecification",
							"type": "structure",
							"members": {
								"AdditionalInfo": {
									"locationName": "additionalInfo"
								},
								"Architecture": {
									"locationName": "architecture"
								},
								"GroupIds": {
									"shape": "S8a",
									"locationName": "GroupId"
								},
								"GroupNames": {
									"shape": "S8o",
									"locationName": "GroupName"
								},
								"InstanceInitiatedShutdownBehavior": {
									"locationName": "instanceInitiatedShutdownBehavior"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"Monitoring": {
									"locationName": "monitoring",
									"type": "boolean"
								},
								"Placement": {
									"shape": "S6q",
									"locationName": "placement"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"UserData": {
									"locationName": "userData",
									"type": "structure",
									"members": {
										"Data": {
											"locationName": "data"
										}
									}
								}
							}
						},
						"Platform": {
							"locationName": "platform"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConversionTask": {
							"shape": "Sje",
							"locationName": "conversionTask"
						}
					}
				}
			},
			"ImportKeyPair": {
				"input": {
					"type": "structure",
					"required": [
						"KeyName",
						"PublicKeyMaterial"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"KeyName": {
							"locationName": "keyName"
						},
						"PublicKeyMaterial": {
							"locationName": "publicKeyMaterial",
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyFingerprint": {
							"locationName": "keyFingerprint"
						},
						"KeyName": {
							"locationName": "keyName"
						}
					}
				}
			},
			"ImportSnapshot": {
				"input": {
					"type": "structure",
					"members": {
						"ClientData": {
							"shape": "S10m"
						},
						"ClientToken": {},
						"Description": {},
						"DiskContainer": {
							"type": "structure",
							"members": {
								"Description": {},
								"Format": {},
								"Url": {},
								"UserBucket": {
									"shape": "S10p"
								}
							}
						},
						"DryRun": {
							"type": "boolean"
						},
						"Encrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"RoleName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Description": {
							"locationName": "description"
						},
						"ImportTaskId": {
							"locationName": "importTaskId"
						},
						"SnapshotTaskDetail": {
							"shape": "Snk",
							"locationName": "snapshotTaskDetail"
						}
					}
				}
			},
			"ImportVolume": {
				"input": {
					"type": "structure",
					"required": [
						"AvailabilityZone",
						"Image",
						"Volume"
					],
					"members": {
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						},
						"Description": {
							"locationName": "description"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Image": {
							"shape": "S10u",
							"locationName": "image"
						},
						"Volume": {
							"shape": "S10v",
							"locationName": "volume"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConversionTask": {
							"shape": "Sje",
							"locationName": "conversionTask"
						}
					}
				}
			},
			"ModifyCapacityReservation": {
				"input": {
					"type": "structure",
					"required": [
						"CapacityReservationId"
					],
					"members": {
						"CapacityReservationId": {},
						"InstanceCount": {
							"type": "integer"
						},
						"EndDate": {
							"type": "timestamp"
						},
						"EndDateType": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyClientVpnEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"ServerCertificateArn": {},
						"ConnectionLogOptions": {
							"shape": "S58"
						},
						"DnsServers": {
							"type": "structure",
							"members": {
								"CustomDnsServers": {
									"shape": "Sd"
								},
								"Enabled": {
									"type": "boolean"
								}
							}
						},
						"Description": {},
						"SplitTunnel": {
							"type": "boolean"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyEbsDefaultKmsKeyId": {
				"input": {
					"type": "structure",
					"required": [
						"KmsKeyId"
					],
					"members": {
						"KmsKeyId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						}
					}
				}
			},
			"ModifyFleet": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"TargetCapacitySpecification"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ExcessCapacityTerminationPolicy": {},
						"FleetId": {},
						"TargetCapacitySpecification": {
							"shape": "S6r"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyFpgaImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"FpgaImageId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"FpgaImageId": {},
						"Attribute": {},
						"OperationType": {},
						"UserIds": {
							"shape": "S11h",
							"locationName": "UserId"
						},
						"UserGroups": {
							"shape": "S11i",
							"locationName": "UserGroup"
						},
						"ProductCodes": {
							"shape": "S11j",
							"locationName": "ProductCode"
						},
						"LoadPermission": {
							"type": "structure",
							"members": {
								"Add": {
									"shape": "S11l"
								},
								"Remove": {
									"shape": "S11l"
								}
							}
						},
						"Description": {},
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FpgaImageAttribute": {
							"shape": "Sla",
							"locationName": "fpgaImageAttribute"
						}
					}
				}
			},
			"ModifyHosts": {
				"input": {
					"type": "structure",
					"required": [
						"HostIds"
					],
					"members": {
						"AutoPlacement": {
							"locationName": "autoPlacement"
						},
						"HostIds": {
							"shape": "Sm5",
							"locationName": "hostId"
						},
						"HostRecovery": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Successful": {
							"shape": "S1e",
							"locationName": "successful"
						},
						"Unsuccessful": {
							"shape": "S11q",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"ModifyIdFormat": {
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"UseLongIds"
					],
					"members": {
						"Resource": {},
						"UseLongIds": {
							"type": "boolean"
						}
					}
				}
			},
			"ModifyIdentityIdFormat": {
				"input": {
					"type": "structure",
					"required": [
						"PrincipalArn",
						"Resource",
						"UseLongIds"
					],
					"members": {
						"PrincipalArn": {
							"locationName": "principalArn"
						},
						"Resource": {
							"locationName": "resource"
						},
						"UseLongIds": {
							"locationName": "useLongIds",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"ImageId"
					],
					"members": {
						"Attribute": {},
						"Description": {
							"shape": "S65"
						},
						"ImageId": {},
						"LaunchPermission": {
							"type": "structure",
							"members": {
								"Add": {
									"shape": "Smt"
								},
								"Remove": {
									"shape": "Smt"
								}
							}
						},
						"OperationType": {},
						"ProductCodes": {
							"shape": "S11j",
							"locationName": "ProductCode"
						},
						"UserGroups": {
							"shape": "S11i",
							"locationName": "UserGroup"
						},
						"UserIds": {
							"shape": "S11h",
							"locationName": "UserId"
						},
						"Value": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyInstanceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"SourceDestCheck": {
							"shape": "Snr"
						},
						"Attribute": {
							"locationName": "attribute"
						},
						"BlockDeviceMappings": {
							"locationName": "blockDeviceMapping",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"DeviceName": {
										"locationName": "deviceName"
									},
									"Ebs": {
										"locationName": "ebs",
										"type": "structure",
										"members": {
											"DeleteOnTermination": {
												"locationName": "deleteOnTermination",
												"type": "boolean"
											},
											"VolumeId": {
												"locationName": "volumeId"
											}
										}
									},
									"NoDevice": {
										"locationName": "noDevice"
									},
									"VirtualName": {
										"locationName": "virtualName"
									}
								}
							}
						},
						"DisableApiTermination": {
							"shape": "Snr",
							"locationName": "disableApiTermination"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EbsOptimized": {
							"shape": "Snr",
							"locationName": "ebsOptimized"
						},
						"EnaSupport": {
							"shape": "Snr",
							"locationName": "enaSupport"
						},
						"Groups": {
							"shape": "S2m",
							"locationName": "GroupId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"InstanceInitiatedShutdownBehavior": {
							"shape": "S65",
							"locationName": "instanceInitiatedShutdownBehavior"
						},
						"InstanceType": {
							"shape": "S65",
							"locationName": "instanceType"
						},
						"Kernel": {
							"shape": "S65",
							"locationName": "kernel"
						},
						"Ramdisk": {
							"shape": "S65",
							"locationName": "ramdisk"
						},
						"SriovNetSupport": {
							"shape": "S65",
							"locationName": "sriovNetSupport"
						},
						"UserData": {
							"locationName": "userData",
							"type": "structure",
							"members": {
								"Value": {
									"locationName": "value",
									"type": "blob"
								}
							}
						},
						"Value": {
							"locationName": "value"
						}
					}
				}
			},
			"ModifyInstanceCapacityReservationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"CapacityReservationSpecification"
					],
					"members": {
						"InstanceId": {},
						"CapacityReservationSpecification": {
							"shape": "S121"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyInstanceCreditSpecification": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceCreditSpecifications"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {},
						"InstanceCreditSpecifications": {
							"locationName": "InstanceCreditSpecification",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {},
									"CpuCredits": {}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SuccessfulInstanceCreditSpecifications": {
							"locationName": "successfulInstanceCreditSpecificationSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {
										"locationName": "instanceId"
									}
								}
							}
						},
						"UnsuccessfulInstanceCreditSpecifications": {
							"locationName": "unsuccessfulInstanceCreditSpecificationSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {
										"locationName": "instanceId"
									},
									"Error": {
										"locationName": "error",
										"type": "structure",
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Message": {
												"locationName": "message"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"ModifyInstanceEventStartTime": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"InstanceEventId",
						"NotBefore"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"InstanceId": {},
						"InstanceEventId": {},
						"NotBefore": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Event": {
							"shape": "So2",
							"locationName": "event"
						}
					}
				}
			},
			"ModifyInstancePlacement": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"Affinity": {
							"locationName": "affinity"
						},
						"GroupName": {},
						"HostId": {
							"locationName": "hostId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Tenancy": {
							"locationName": "tenancy"
						},
						"PartitionNumber": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyLaunchTemplate": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {},
						"LaunchTemplateId": {},
						"LaunchTemplateName": {},
						"DefaultVersion": {
							"locationName": "SetDefaultVersion"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchTemplate": {
							"shape": "S93",
							"locationName": "launchTemplate"
						}
					}
				}
			},
			"ModifyNetworkInterfaceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"Attachment": {
							"locationName": "attachment",
							"type": "structure",
							"members": {
								"AttachmentId": {
									"locationName": "attachmentId"
								},
								"DeleteOnTermination": {
									"locationName": "deleteOnTermination",
									"type": "boolean"
								}
							}
						},
						"Description": {
							"shape": "S65",
							"locationName": "description"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Groups": {
							"shape": "S8a",
							"locationName": "SecurityGroupId"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"SourceDestCheck": {
							"shape": "Snr",
							"locationName": "sourceDestCheck"
						}
					}
				}
			},
			"ModifyReservedInstances": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstancesIds",
						"TargetConfigurations"
					],
					"members": {
						"ReservedInstancesIds": {
							"shape": "Sr3",
							"locationName": "ReservedInstancesId"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"TargetConfigurations": {
							"locationName": "ReservedInstancesConfigurationSetItemType",
							"type": "list",
							"member": {
								"shape": "Sro",
								"locationName": "item"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesModificationId": {
							"locationName": "reservedInstancesModificationId"
						}
					}
				}
			},
			"ModifySnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotId"
					],
					"members": {
						"Attribute": {},
						"CreateVolumePermission": {
							"type": "structure",
							"members": {
								"Add": {
									"shape": "Ssw"
								},
								"Remove": {
									"shape": "Ssw"
								}
							}
						},
						"GroupNames": {
							"shape": "Sso",
							"locationName": "UserGroup"
						},
						"OperationType": {},
						"SnapshotId": {},
						"UserIds": {
							"shape": "S11h",
							"locationName": "UserId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"ModifySpotFleetRequest": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId"
					],
					"members": {
						"ExcessCapacityTerminationPolicy": {
							"locationName": "excessCapacityTerminationPolicy"
						},
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"TargetCapacity": {
							"locationName": "targetCapacity",
							"type": "integer"
						},
						"OnDemandTargetCapacity": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifySubnetAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId"
					],
					"members": {
						"AssignIpv6AddressOnCreation": {
							"shape": "Snr"
						},
						"MapPublicIpOnLaunch": {
							"shape": "Snr"
						},
						"SubnetId": {
							"locationName": "subnetId"
						}
					}
				}
			},
			"ModifyTrafficMirrorFilterNetworkServices": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorFilterId"
					],
					"members": {
						"TrafficMirrorFilterId": {},
						"AddNetworkServices": {
							"shape": "Scb",
							"locationName": "AddNetworkService"
						},
						"RemoveNetworkServices": {
							"shape": "Scb",
							"locationName": "RemoveNetworkService"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilter": {
							"shape": "Sc5",
							"locationName": "trafficMirrorFilter"
						}
					}
				}
			},
			"ModifyTrafficMirrorFilterRule": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorFilterRuleId"
					],
					"members": {
						"TrafficMirrorFilterRuleId": {},
						"TrafficDirection": {},
						"RuleNumber": {
							"type": "integer"
						},
						"RuleAction": {},
						"DestinationPortRange": {
							"shape": "Sce"
						},
						"SourcePortRange": {
							"shape": "Sce"
						},
						"Protocol": {
							"type": "integer"
						},
						"DestinationCidrBlock": {},
						"SourceCidrBlock": {},
						"Description": {},
						"RemoveFields": {
							"locationName": "RemoveField",
							"type": "list",
							"member": {}
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorFilterRule": {
							"shape": "Sc7",
							"locationName": "trafficMirrorFilterRule"
						}
					}
				}
			},
			"ModifyTrafficMirrorSession": {
				"input": {
					"type": "structure",
					"required": [
						"TrafficMirrorSessionId"
					],
					"members": {
						"TrafficMirrorSessionId": {},
						"TrafficMirrorTargetId": {},
						"TrafficMirrorFilterId": {},
						"PacketLength": {
							"type": "integer"
						},
						"SessionNumber": {
							"type": "integer"
						},
						"VirtualNetworkId": {
							"type": "integer"
						},
						"Description": {},
						"RemoveFields": {
							"locationName": "RemoveField",
							"type": "list",
							"member": {}
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrafficMirrorSession": {
							"shape": "Sci",
							"locationName": "trafficMirrorSession"
						}
					}
				}
			},
			"ModifyTransitGatewayVpcAttachment": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayAttachmentId": {},
						"AddSubnetIds": {
							"shape": "Sd"
						},
						"RemoveSubnetIds": {
							"shape": "Sd"
						},
						"Options": {
							"type": "structure",
							"members": {
								"DnsSupport": {},
								"Ipv6Support": {}
							}
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayVpcAttachment": {
							"shape": "Sb",
							"locationName": "transitGatewayVpcAttachment"
						}
					}
				}
			},
			"ModifyVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VolumeId": {},
						"Size": {
							"type": "integer"
						},
						"VolumeType": {},
						"Iops": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeModification": {
							"shape": "Swj",
							"locationName": "volumeModification"
						}
					}
				}
			},
			"ModifyVolumeAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"AutoEnableIO": {
							"shape": "Snr"
						},
						"VolumeId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyVpcAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"EnableDnsHostnames": {
							"shape": "Snr"
						},
						"EnableDnsSupport": {
							"shape": "Snr"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"ModifyVpcEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"VpcEndpointId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcEndpointId": {},
						"ResetPolicy": {
							"type": "boolean"
						},
						"PolicyDocument": {},
						"AddRouteTableIds": {
							"shape": "Sd",
							"locationName": "AddRouteTableId"
						},
						"RemoveRouteTableIds": {
							"shape": "Sd",
							"locationName": "RemoveRouteTableId"
						},
						"AddSubnetIds": {
							"shape": "Sd",
							"locationName": "AddSubnetId"
						},
						"RemoveSubnetIds": {
							"shape": "Sd",
							"locationName": "RemoveSubnetId"
						},
						"AddSecurityGroupIds": {
							"shape": "Sd",
							"locationName": "AddSecurityGroupId"
						},
						"RemoveSecurityGroupIds": {
							"shape": "Sd",
							"locationName": "RemoveSecurityGroupId"
						},
						"PrivateDnsEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyVpcEndpointConnectionNotification": {
				"input": {
					"type": "structure",
					"required": [
						"ConnectionNotificationId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ConnectionNotificationId": {},
						"ConnectionNotificationArn": {},
						"ConnectionEvents": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReturnValue": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyVpcEndpointServiceConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceId": {},
						"AcceptanceRequired": {
							"type": "boolean"
						},
						"AddNetworkLoadBalancerArns": {
							"shape": "Sd",
							"locationName": "AddNetworkLoadBalancerArn"
						},
						"RemoveNetworkLoadBalancerArns": {
							"shape": "Sd",
							"locationName": "RemoveNetworkLoadBalancerArn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyVpcEndpointServicePermissions": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceId": {},
						"AddAllowedPrincipals": {
							"shape": "Sd"
						},
						"RemoveAllowedPrincipals": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReturnValue": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyVpcPeeringConnectionOptions": {
				"input": {
					"type": "structure",
					"required": [
						"VpcPeeringConnectionId"
					],
					"members": {
						"AccepterPeeringConnectionOptions": {
							"shape": "S13l"
						},
						"DryRun": {
							"type": "boolean"
						},
						"RequesterPeeringConnectionOptions": {
							"shape": "S13l"
						},
						"VpcPeeringConnectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccepterPeeringConnectionOptions": {
							"shape": "S13n",
							"locationName": "accepterPeeringConnectionOptions"
						},
						"RequesterPeeringConnectionOptions": {
							"shape": "S13n",
							"locationName": "requesterPeeringConnectionOptions"
						}
					}
				}
			},
			"ModifyVpcTenancy": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId",
						"InstanceTenancy"
					],
					"members": {
						"VpcId": {},
						"InstanceTenancy": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReturnValue": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyVpnConnection": {
				"input": {
					"type": "structure",
					"required": [
						"VpnConnectionId"
					],
					"members": {
						"VpnConnectionId": {},
						"TransitGatewayId": {},
						"VpnGatewayId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnConnection": {
							"shape": "Se9",
							"locationName": "vpnConnection"
						}
					}
				}
			},
			"MonitorInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceMonitorings": {
							"shape": "S13v",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"MoveAddressToVpc": {
				"input": {
					"type": "structure",
					"required": [
						"PublicIp"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIp": {
							"locationName": "publicIp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AllocationId": {
							"locationName": "allocationId"
						},
						"Status": {
							"locationName": "status"
						}
					}
				}
			},
			"ProvisionByoipCidr": {
				"input": {
					"type": "structure",
					"required": [
						"Cidr"
					],
					"members": {
						"Cidr": {},
						"CidrAuthorizationContext": {
							"type": "structure",
							"required": [
								"Message",
								"Signature"
							],
							"members": {
								"Message": {},
								"Signature": {}
							}
						},
						"Description": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByoipCidr": {
							"shape": "S12",
							"locationName": "byoipCidr"
						}
					}
				}
			},
			"PurchaseHostReservation": {
				"input": {
					"type": "structure",
					"required": [
						"HostIdSet",
						"OfferingId"
					],
					"members": {
						"ClientToken": {},
						"CurrencyCode": {},
						"HostIdSet": {
							"shape": "Szr"
						},
						"LimitPrice": {},
						"OfferingId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientToken": {
							"locationName": "clientToken"
						},
						"CurrencyCode": {
							"locationName": "currencyCode"
						},
						"Purchase": {
							"shape": "Szt",
							"locationName": "purchase"
						},
						"TotalHourlyPrice": {
							"locationName": "totalHourlyPrice"
						},
						"TotalUpfrontPrice": {
							"locationName": "totalUpfrontPrice"
						}
					}
				}
			},
			"PurchaseReservedInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceCount",
						"ReservedInstancesOfferingId"
					],
					"members": {
						"InstanceCount": {
							"type": "integer"
						},
						"ReservedInstancesOfferingId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"LimitPrice": {
							"locationName": "limitPrice",
							"type": "structure",
							"members": {
								"Amount": {
									"locationName": "amount",
									"type": "double"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						}
					}
				}
			},
			"PurchaseScheduledInstances": {
				"input": {
					"type": "structure",
					"required": [
						"PurchaseRequests"
					],
					"members": {
						"ClientToken": {
							"idempotencyToken": true
						},
						"DryRun": {
							"type": "boolean"
						},
						"PurchaseRequests": {
							"locationName": "PurchaseRequest",
							"type": "list",
							"member": {
								"locationName": "PurchaseRequest",
								"type": "structure",
								"required": [
									"InstanceCount",
									"PurchaseToken"
								],
								"members": {
									"InstanceCount": {
										"type": "integer"
									},
									"PurchaseToken": {}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScheduledInstanceSet": {
							"locationName": "scheduledInstanceSet",
							"type": "list",
							"member": {
								"shape": "Ssh",
								"locationName": "item"
							}
						}
					}
				}
			},
			"RebootInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"RegisterImage": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"ImageLocation": {},
						"Architecture": {
							"locationName": "architecture"
						},
						"BlockDeviceMappings": {
							"shape": "S7h",
							"locationName": "BlockDeviceMapping"
						},
						"Description": {
							"locationName": "description"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EnaSupport": {
							"locationName": "enaSupport",
							"type": "boolean"
						},
						"KernelId": {
							"locationName": "kernelId"
						},
						"Name": {
							"locationName": "name"
						},
						"BillingProducts": {
							"locationName": "BillingProduct",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"RamdiskId": {
							"locationName": "ramdiskId"
						},
						"RootDeviceName": {
							"locationName": "rootDeviceName"
						},
						"SriovNetSupport": {
							"locationName": "sriovNetSupport"
						},
						"VirtualizationType": {
							"locationName": "virtualizationType"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageId": {
							"locationName": "imageId"
						}
					}
				}
			},
			"RejectTransitGatewayVpcAttachment": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayAttachmentId"
					],
					"members": {
						"TransitGatewayAttachmentId": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TransitGatewayVpcAttachment": {
							"shape": "Sb",
							"locationName": "transitGatewayVpcAttachment"
						}
					}
				}
			},
			"RejectVpcEndpointConnections": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceId",
						"VpcEndpointIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ServiceId": {},
						"VpcEndpointIds": {
							"shape": "Sd",
							"locationName": "VpcEndpointId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "Sm",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"RejectVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"required": [
						"VpcPeeringConnectionId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ReleaseAddress": {
				"input": {
					"type": "structure",
					"members": {
						"AllocationId": {},
						"PublicIp": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"ReleaseHosts": {
				"input": {
					"type": "structure",
					"required": [
						"HostIds"
					],
					"members": {
						"HostIds": {
							"shape": "Sm5",
							"locationName": "hostId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Successful": {
							"shape": "S1e",
							"locationName": "successful"
						},
						"Unsuccessful": {
							"shape": "S11q",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"ReplaceIamInstanceProfileAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"IamInstanceProfile",
						"AssociationId"
					],
					"members": {
						"IamInstanceProfile": {
							"shape": "S1y"
						},
						"AssociationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociation": {
							"shape": "S20",
							"locationName": "iamInstanceProfileAssociation"
						}
					}
				}
			},
			"ReplaceNetworkAclAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId",
						"NetworkAclId"
					],
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NewAssociationId": {
							"locationName": "newAssociationId"
						}
					}
				}
			},
			"ReplaceNetworkAclEntry": {
				"input": {
					"type": "structure",
					"required": [
						"Egress",
						"NetworkAclId",
						"Protocol",
						"RuleAction",
						"RuleNumber"
					],
					"members": {
						"CidrBlock": {
							"locationName": "cidrBlock"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Egress": {
							"locationName": "egress",
							"type": "boolean"
						},
						"IcmpTypeCode": {
							"shape": "Sab",
							"locationName": "Icmp"
						},
						"Ipv6CidrBlock": {
							"locationName": "ipv6CidrBlock"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						},
						"PortRange": {
							"shape": "Sac",
							"locationName": "portRange"
						},
						"Protocol": {
							"locationName": "protocol"
						},
						"RuleAction": {
							"locationName": "ruleAction"
						},
						"RuleNumber": {
							"locationName": "ruleNumber",
							"type": "integer"
						}
					}
				}
			},
			"ReplaceRoute": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DestinationCidrBlock": {
							"locationName": "destinationCidrBlock"
						},
						"DestinationIpv6CidrBlock": {
							"locationName": "destinationIpv6CidrBlock"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EgressOnlyInternetGatewayId": {
							"locationName": "egressOnlyInternetGatewayId"
						},
						"GatewayId": {
							"locationName": "gatewayId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"NatGatewayId": {
							"locationName": "natGatewayId"
						},
						"TransitGatewayId": {},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				}
			},
			"ReplaceRouteTableAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId",
						"RouteTableId"
					],
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NewAssociationId": {
							"locationName": "newAssociationId"
						}
					}
				}
			},
			"ReplaceTransitGatewayRoute": {
				"input": {
					"type": "structure",
					"required": [
						"DestinationCidrBlock",
						"TransitGatewayRouteTableId"
					],
					"members": {
						"DestinationCidrBlock": {},
						"TransitGatewayRouteTableId": {},
						"TransitGatewayAttachmentId": {},
						"Blackhole": {
							"type": "boolean"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Route": {
							"shape": "Scz",
							"locationName": "route"
						}
					}
				}
			},
			"ReportInstanceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"Instances",
						"ReasonCodes",
						"Status"
					],
					"members": {
						"Description": {
							"locationName": "description"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EndTime": {
							"locationName": "endTime",
							"type": "timestamp"
						},
						"Instances": {
							"shape": "Si5",
							"locationName": "instanceId"
						},
						"ReasonCodes": {
							"locationName": "reasonCode",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						},
						"Status": {
							"locationName": "status"
						}
					}
				}
			},
			"RequestSpotFleet": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestConfig"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotFleetRequestConfig": {
							"shape": "Stj",
							"locationName": "spotFleetRequestConfig"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						}
					}
				}
			},
			"RequestSpotInstances": {
				"input": {
					"type": "structure",
					"members": {
						"AvailabilityZoneGroup": {
							"locationName": "availabilityZoneGroup"
						},
						"BlockDurationMinutes": {
							"locationName": "blockDurationMinutes",
							"type": "integer"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceCount": {
							"locationName": "instanceCount",
							"type": "integer"
						},
						"LaunchGroup": {
							"locationName": "launchGroup"
						},
						"LaunchSpecification": {
							"type": "structure",
							"members": {
								"SecurityGroupIds": {
									"shape": "Sd",
									"locationName": "SecurityGroupId"
								},
								"SecurityGroups": {
									"shape": "Sd",
									"locationName": "SecurityGroup"
								},
								"AddressingType": {
									"locationName": "addressingType"
								},
								"BlockDeviceMappings": {
									"shape": "Sms",
									"locationName": "blockDeviceMapping"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"IamInstanceProfile": {
									"shape": "S1y",
									"locationName": "iamInstanceProfile"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"Monitoring": {
									"shape": "Sub",
									"locationName": "monitoring"
								},
								"NetworkInterfaces": {
									"shape": "Stq",
									"locationName": "NetworkInterface"
								},
								"Placement": {
									"shape": "Sts",
									"locationName": "placement"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"UserData": {
									"locationName": "userData"
								}
							}
						},
						"SpotPrice": {
							"locationName": "spotPrice"
						},
						"Type": {
							"locationName": "type"
						},
						"ValidFrom": {
							"locationName": "validFrom",
							"type": "timestamp"
						},
						"ValidUntil": {
							"locationName": "validUntil",
							"type": "timestamp"
						},
						"InstanceInterruptionBehavior": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotInstanceRequests": {
							"shape": "Su8",
							"locationName": "spotInstanceRequestSet"
						}
					}
				}
			},
			"ResetEbsDefaultKmsKeyId": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						}
					}
				}
			},
			"ResetFpgaImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"FpgaImageId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"FpgaImageId": {},
						"Attribute": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ResetImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"ImageId"
					],
					"members": {
						"Attribute": {},
						"ImageId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"ResetInstanceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"InstanceId"
					],
					"members": {
						"Attribute": {
							"locationName": "attribute"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						}
					}
				}
			},
			"ResetNetworkInterfaceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"SourceDestCheck": {
							"locationName": "sourceDestCheck"
						}
					}
				}
			},
			"ResetSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"Attribute",
						"SnapshotId"
					],
					"members": {
						"Attribute": {},
						"SnapshotId": {},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"RestoreAddressToClassic": {
				"input": {
					"type": "structure",
					"required": [
						"PublicIp"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIp": {
							"locationName": "publicIp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicIp": {
							"locationName": "publicIp"
						},
						"Status": {
							"locationName": "status"
						}
					}
				}
			},
			"RevokeClientVpnIngress": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId",
						"TargetNetworkCidr"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"TargetNetworkCidr": {},
						"AccessGroupId": {},
						"RevokeAllGroups": {
							"type": "boolean"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"shape": "S30",
							"locationName": "status"
						}
					}
				}
			},
			"RevokeSecurityGroupEgress": {
				"input": {
					"type": "structure",
					"required": [
						"GroupId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupId": {
							"locationName": "groupId"
						},
						"IpPermissions": {
							"shape": "S33",
							"locationName": "ipPermissions"
						},
						"CidrIp": {
							"locationName": "cidrIp"
						},
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"SourceSecurityGroupName": {
							"locationName": "sourceSecurityGroupName"
						},
						"SourceSecurityGroupOwnerId": {
							"locationName": "sourceSecurityGroupOwnerId"
						}
					}
				}
			},
			"RevokeSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"members": {
						"CidrIp": {},
						"FromPort": {
							"type": "integer"
						},
						"GroupId": {},
						"GroupName": {},
						"IpPermissions": {
							"shape": "S33"
						},
						"IpProtocol": {},
						"SourceSecurityGroupName": {},
						"SourceSecurityGroupOwnerId": {},
						"ToPort": {
							"type": "integer"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"RunInstances": {
				"input": {
					"type": "structure",
					"required": [
						"MaxCount",
						"MinCount"
					],
					"members": {
						"BlockDeviceMappings": {
							"shape": "S7h",
							"locationName": "BlockDeviceMapping"
						},
						"ImageId": {},
						"InstanceType": {},
						"Ipv6AddressCount": {
							"type": "integer"
						},
						"Ipv6Addresses": {
							"shape": "S9e",
							"locationName": "Ipv6Address"
						},
						"KernelId": {},
						"KeyName": {},
						"MaxCount": {
							"type": "integer"
						},
						"MinCount": {
							"type": "integer"
						},
						"Monitoring": {
							"shape": "Sub"
						},
						"Placement": {
							"shape": "S6q"
						},
						"RamdiskId": {},
						"SecurityGroupIds": {
							"shape": "S8a",
							"locationName": "SecurityGroupId"
						},
						"SecurityGroups": {
							"shape": "S8o",
							"locationName": "SecurityGroup"
						},
						"SubnetId": {},
						"UserData": {},
						"AdditionalInfo": {
							"locationName": "additionalInfo"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"DisableApiTermination": {
							"locationName": "disableApiTermination",
							"type": "boolean"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"EbsOptimized": {
							"locationName": "ebsOptimized",
							"type": "boolean"
						},
						"IamInstanceProfile": {
							"shape": "S1y",
							"locationName": "iamInstanceProfile"
						},
						"InstanceInitiatedShutdownBehavior": {
							"locationName": "instanceInitiatedShutdownBehavior"
						},
						"NetworkInterfaces": {
							"shape": "Stq",
							"locationName": "networkInterface"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"ElasticGpuSpecification": {
							"type": "list",
							"member": {
								"shape": "S8l",
								"locationName": "item"
							}
						},
						"ElasticInferenceAccelerators": {
							"locationName": "ElasticInferenceAccelerator",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"Type"
								],
								"members": {
									"Type": {}
								}
							}
						},
						"TagSpecifications": {
							"shape": "S19",
							"locationName": "TagSpecification"
						},
						"LaunchTemplate": {
							"type": "structure",
							"members": {
								"LaunchTemplateId": {},
								"LaunchTemplateName": {},
								"Version": {}
							}
						},
						"InstanceMarketOptions": {
							"type": "structure",
							"members": {
								"MarketType": {},
								"SpotOptions": {
									"type": "structure",
									"members": {
										"MaxPrice": {},
										"SpotInstanceType": {},
										"BlockDurationMinutes": {
											"type": "integer"
										},
										"ValidUntil": {
											"type": "timestamp"
										},
										"InstanceInterruptionBehavior": {}
									}
								}
							}
						},
						"CreditSpecification": {
							"shape": "S8u"
						},
						"CpuOptions": {
							"type": "structure",
							"members": {
								"CoreCount": {
									"type": "integer"
								},
								"ThreadsPerCore": {
									"type": "integer"
								}
							}
						},
						"CapacityReservationSpecification": {
							"shape": "S121"
						},
						"HibernationOptions": {
							"type": "structure",
							"members": {
								"Configured": {
									"type": "boolean"
								}
							}
						},
						"LicenseSpecifications": {
							"locationName": "LicenseSpecification",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"LicenseConfigurationArn": {}
								}
							}
						}
					}
				},
				"output": {
					"shape": "Sog"
				}
			},
			"RunScheduledInstances": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchSpecification",
						"ScheduledInstanceId"
					],
					"members": {
						"ClientToken": {
							"idempotencyToken": true
						},
						"DryRun": {
							"type": "boolean"
						},
						"InstanceCount": {
							"type": "integer"
						},
						"LaunchSpecification": {
							"type": "structure",
							"required": [
								"ImageId"
							],
							"members": {
								"BlockDeviceMappings": {
									"locationName": "BlockDeviceMapping",
									"type": "list",
									"member": {
										"locationName": "BlockDeviceMapping",
										"type": "structure",
										"members": {
											"DeviceName": {},
											"Ebs": {
												"type": "structure",
												"members": {
													"DeleteOnTermination": {
														"type": "boolean"
													},
													"Encrypted": {
														"type": "boolean"
													},
													"Iops": {
														"type": "integer"
													},
													"SnapshotId": {},
													"VolumeSize": {
														"type": "integer"
													},
													"VolumeType": {}
												}
											},
											"NoDevice": {},
											"VirtualName": {}
										}
									}
								},
								"EbsOptimized": {
									"type": "boolean"
								},
								"IamInstanceProfile": {
									"type": "structure",
									"members": {
										"Arn": {},
										"Name": {}
									}
								},
								"ImageId": {},
								"InstanceType": {},
								"KernelId": {},
								"KeyName": {},
								"Monitoring": {
									"type": "structure",
									"members": {
										"Enabled": {
											"type": "boolean"
										}
									}
								},
								"NetworkInterfaces": {
									"locationName": "NetworkInterface",
									"type": "list",
									"member": {
										"locationName": "NetworkInterface",
										"type": "structure",
										"members": {
											"AssociatePublicIpAddress": {
												"type": "boolean"
											},
											"DeleteOnTermination": {
												"type": "boolean"
											},
											"Description": {},
											"DeviceIndex": {
												"type": "integer"
											},
											"Groups": {
												"shape": "S169",
												"locationName": "Group"
											},
											"Ipv6AddressCount": {
												"type": "integer"
											},
											"Ipv6Addresses": {
												"locationName": "Ipv6Address",
												"type": "list",
												"member": {
													"locationName": "Ipv6Address",
													"type": "structure",
													"members": {
														"Ipv6Address": {}
													}
												}
											},
											"NetworkInterfaceId": {},
											"PrivateIpAddress": {},
											"PrivateIpAddressConfigs": {
												"locationName": "PrivateIpAddressConfig",
												"type": "list",
												"member": {
													"locationName": "PrivateIpAddressConfigSet",
													"type": "structure",
													"members": {
														"Primary": {
															"type": "boolean"
														},
														"PrivateIpAddress": {}
													}
												}
											},
											"SecondaryPrivateIpAddressCount": {
												"type": "integer"
											},
											"SubnetId": {}
										}
									}
								},
								"Placement": {
									"type": "structure",
									"members": {
										"AvailabilityZone": {},
										"GroupName": {}
									}
								},
								"RamdiskId": {},
								"SecurityGroupIds": {
									"shape": "S169",
									"locationName": "SecurityGroupId"
								},
								"SubnetId": {},
								"UserData": {}
							}
						},
						"ScheduledInstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceIdSet": {
							"locationName": "instanceIdSet",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						}
					}
				}
			},
			"SearchTransitGatewayRoutes": {
				"input": {
					"type": "structure",
					"required": [
						"TransitGatewayRouteTableId",
						"Filters"
					],
					"members": {
						"TransitGatewayRouteTableId": {},
						"Filters": {
							"shape": "Sh6",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Routes": {
							"locationName": "routeSet",
							"type": "list",
							"member": {
								"shape": "Scz",
								"locationName": "item"
							}
						},
						"AdditionalRoutesAvailable": {
							"locationName": "additionalRoutesAvailable",
							"type": "boolean"
						}
					}
				}
			},
			"StartInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"AdditionalInfo": {
							"locationName": "additionalInfo"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StartingInstances": {
							"shape": "S16n",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"StopInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"Hibernate": {
							"type": "boolean"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Force": {
							"locationName": "force",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StoppingInstances": {
							"shape": "S16n",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"TerminateClientVpnConnections": {
				"input": {
					"type": "structure",
					"required": [
						"ClientVpnEndpointId"
					],
					"members": {
						"ClientVpnEndpointId": {},
						"ConnectionId": {},
						"Username": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientVpnEndpointId": {
							"locationName": "clientVpnEndpointId"
						},
						"Username": {
							"locationName": "username"
						},
						"ConnectionStatuses": {
							"locationName": "connectionStatuses",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ConnectionId": {
										"locationName": "connectionId"
									},
									"PreviousStatus": {
										"shape": "Sik",
										"locationName": "previousStatus"
									},
									"CurrentStatus": {
										"shape": "Sik",
										"locationName": "currentStatus"
									}
								}
							}
						}
					}
				}
			},
			"TerminateInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TerminatingInstances": {
							"shape": "S16n",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"UnassignIpv6Addresses": {
				"input": {
					"type": "structure",
					"required": [
						"Ipv6Addresses",
						"NetworkInterfaceId"
					],
					"members": {
						"Ipv6Addresses": {
							"shape": "S1j",
							"locationName": "ipv6Addresses"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"UnassignedIpv6Addresses": {
							"shape": "S1j",
							"locationName": "unassignedIpv6Addresses"
						}
					}
				}
			},
			"UnassignPrivateIpAddresses": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId",
						"PrivateIpAddresses"
					],
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"PrivateIpAddresses": {
							"shape": "S1m",
							"locationName": "privateIpAddress"
						}
					}
				}
			},
			"UnmonitorInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Si5",
							"locationName": "InstanceId"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceMonitorings": {
							"shape": "S13v",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"UpdateSecurityGroupRuleDescriptionsEgress": {
				"input": {
					"type": "structure",
					"required": [
						"IpPermissions"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"GroupId": {},
						"GroupName": {},
						"IpPermissions": {
							"shape": "S33"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"UpdateSecurityGroupRuleDescriptionsIngress": {
				"input": {
					"type": "structure",
					"required": [
						"IpPermissions"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"GroupId": {},
						"GroupName": {},
						"IpPermissions": {
							"shape": "S33"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"WithdrawByoipCidr": {
				"input": {
					"type": "structure",
					"required": [
						"Cidr"
					],
					"members": {
						"Cidr": {},
						"DryRun": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByoipCidr": {
							"shape": "S12",
							"locationName": "byoipCidr"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"locationName": "ReservedInstanceId"
				}
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "TargetConfigurationRequest",
					"type": "structure",
					"required": [
						"OfferingId"
					],
					"members": {
						"InstanceCount": {
							"type": "integer"
						},
						"OfferingId": {}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"TransitGatewayAttachmentId": {
						"locationName": "transitGatewayAttachmentId"
					},
					"TransitGatewayId": {
						"locationName": "transitGatewayId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"VpcOwnerId": {
						"locationName": "vpcOwnerId"
					},
					"State": {
						"locationName": "state"
					},
					"SubnetIds": {
						"shape": "Sd",
						"locationName": "subnetIds"
					},
					"CreationTime": {
						"locationName": "creationTime",
						"type": "timestamp"
					},
					"Options": {
						"locationName": "options",
						"type": "structure",
						"members": {
							"DnsSupport": {
								"locationName": "dnsSupport"
							},
							"Ipv6Support": {
								"locationName": "ipv6Support"
							}
						}
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sd": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Si": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Key": {
							"locationName": "key"
						},
						"Value": {
							"locationName": "value"
						}
					}
				}
			},
			"Sm": {
				"type": "list",
				"member": {
					"shape": "Sn",
					"locationName": "item"
				}
			},
			"Sn": {
				"type": "structure",
				"members": {
					"Error": {
						"locationName": "error",
						"type": "structure",
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							}
						}
					},
					"ResourceId": {
						"locationName": "resourceId"
					}
				}
			},
			"Sr": {
				"type": "structure",
				"members": {
					"AccepterVpcInfo": {
						"shape": "Ss",
						"locationName": "accepterVpcInfo"
					},
					"ExpirationTime": {
						"locationName": "expirationTime",
						"type": "timestamp"
					},
					"RequesterVpcInfo": {
						"shape": "Ss",
						"locationName": "requesterVpcInfo"
					},
					"Status": {
						"locationName": "status",
						"type": "structure",
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							}
						}
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"Ss": {
				"type": "structure",
				"members": {
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"Ipv6CidrBlockSet": {
						"locationName": "ipv6CidrBlockSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Ipv6CidrBlock": {
									"locationName": "ipv6CidrBlock"
								}
							}
						}
					},
					"CidrBlockSet": {
						"locationName": "cidrBlockSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CidrBlock": {
									"locationName": "cidrBlock"
								}
							}
						}
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"PeeringOptions": {
						"locationName": "peeringOptions",
						"type": "structure",
						"members": {
							"AllowDnsResolutionFromRemoteVpc": {
								"locationName": "allowDnsResolutionFromRemoteVpc",
								"type": "boolean"
							},
							"AllowEgressFromLocalClassicLinkToRemoteVpc": {
								"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
								"type": "boolean"
							},
							"AllowEgressFromLocalVpcToRemoteClassicLink": {
								"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
								"type": "boolean"
							}
						}
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"Region": {
						"locationName": "region"
					}
				}
			},
			"S12": {
				"type": "structure",
				"members": {
					"Cidr": {
						"locationName": "cidr"
					},
					"Description": {
						"locationName": "description"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"State": {
						"locationName": "state"
					}
				}
			},
			"S19": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"ResourceType": {
							"locationName": "resourceType"
						},
						"Tags": {
							"shape": "Si",
							"locationName": "Tag"
						}
					}
				}
			},
			"S1e": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"S1g": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"S1j": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"S1m": {
				"type": "list",
				"member": {
					"locationName": "PrivateIpAddress"
				}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"Arn": {
						"locationName": "arn"
					},
					"Name": {
						"locationName": "name"
					}
				}
			},
			"S20": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"IamInstanceProfile": {
						"shape": "S21",
						"locationName": "iamInstanceProfile"
					},
					"State": {
						"locationName": "state"
					},
					"Timestamp": {
						"locationName": "timestamp",
						"type": "timestamp"
					}
				}
			},
			"S21": {
				"type": "structure",
				"members": {
					"Arn": {
						"locationName": "arn"
					},
					"Id": {
						"locationName": "id"
					}
				}
			},
			"S27": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"Ipv6CidrBlockState": {
						"locationName": "ipv6CidrBlockState",
						"type": "structure",
						"members": {
							"State": {
								"locationName": "state"
							},
							"StatusMessage": {
								"locationName": "statusMessage"
							}
						}
					}
				}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"TransitGatewayRouteTableId": {
						"locationName": "transitGatewayRouteTableId"
					},
					"TransitGatewayAttachmentId": {
						"locationName": "transitGatewayAttachmentId"
					},
					"ResourceId": {
						"locationName": "resourceId"
					},
					"ResourceType": {
						"locationName": "resourceType"
					},
					"State": {
						"locationName": "state"
					}
				}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"Ipv6CidrBlockState": {
						"shape": "S2i",
						"locationName": "ipv6CidrBlockState"
					}
				}
			},
			"S2i": {
				"type": "structure",
				"members": {
					"State": {
						"locationName": "state"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					}
				}
			},
			"S2k": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"CidrBlockState": {
						"shape": "S2i",
						"locationName": "cidrBlockState"
					}
				}
			},
			"S2m": {
				"type": "list",
				"member": {
					"locationName": "groupId"
				}
			},
			"S2s": {
				"type": "structure",
				"members": {
					"AttachTime": {
						"locationName": "attachTime",
						"type": "timestamp"
					},
					"Device": {
						"locationName": "device"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"State": {
						"locationName": "status"
					},
					"VolumeId": {
						"locationName": "volumeId"
					},
					"DeleteOnTermination": {
						"locationName": "deleteOnTermination",
						"type": "boolean"
					}
				}
			},
			"S2w": {
				"type": "structure",
				"members": {
					"State": {
						"locationName": "state"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"S30": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"S33": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"IpRanges": {
							"locationName": "ipRanges",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CidrIp": {
										"locationName": "cidrIp"
									},
									"Description": {
										"locationName": "description"
									}
								}
							}
						},
						"Ipv6Ranges": {
							"locationName": "ipv6Ranges",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CidrIpv6": {
										"locationName": "cidrIpv6"
									},
									"Description": {
										"locationName": "description"
									}
								}
							}
						},
						"PrefixListIds": {
							"locationName": "prefixListIds",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Description": {
										"locationName": "description"
									},
									"PrefixListId": {
										"locationName": "prefixListId"
									}
								}
							}
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"UserIdGroupPairs": {
							"locationName": "groups",
							"type": "list",
							"member": {
								"shape": "S3c",
								"locationName": "item"
							}
						}
					}
				}
			},
			"S3c": {
				"type": "structure",
				"members": {
					"Description": {
						"locationName": "description"
					},
					"GroupId": {
						"locationName": "groupId"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"PeeringStatus": {
						"locationName": "peeringStatus"
					},
					"UserId": {
						"locationName": "userId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"S3f": {
				"type": "structure",
				"members": {
					"S3": {
						"type": "structure",
						"members": {
							"AWSAccessKeyId": {},
							"Bucket": {
								"locationName": "bucket"
							},
							"Prefix": {
								"locationName": "prefix"
							},
							"UploadPolicy": {
								"locationName": "uploadPolicy",
								"type": "blob"
							},
							"UploadPolicySignature": {
								"locationName": "uploadPolicySignature"
							}
						}
					}
				}
			},
			"S3j": {
				"type": "structure",
				"members": {
					"BundleId": {
						"locationName": "bundleId"
					},
					"BundleTaskError": {
						"locationName": "error",
						"type": "structure",
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							}
						}
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Progress": {
						"locationName": "progress"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"State": {
						"locationName": "state"
					},
					"Storage": {
						"shape": "S3f",
						"locationName": "storage"
					},
					"UpdateTime": {
						"locationName": "updateTime",
						"type": "timestamp"
					}
				}
			},
			"S3w": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"ClientToken": {
							"locationName": "clientToken"
						},
						"CreateDate": {
							"locationName": "createDate",
							"type": "timestamp"
						},
						"InstanceCounts": {
							"locationName": "instanceCounts",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceCount": {
										"locationName": "instanceCount",
										"type": "integer"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						},
						"PriceSchedules": {
							"locationName": "priceSchedules",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Active": {
										"locationName": "active",
										"type": "boolean"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"Price": {
										"locationName": "price",
										"type": "double"
									},
									"Term": {
										"locationName": "term",
										"type": "long"
									}
								}
							}
						},
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						},
						"ReservedInstancesListingId": {
							"locationName": "reservedInstancesListingId"
						},
						"Status": {
							"locationName": "status"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						},
						"Tags": {
							"shape": "Si",
							"locationName": "tagSet"
						},
						"UpdateDate": {
							"locationName": "updateDate",
							"type": "timestamp"
						}
					}
				}
			},
			"S4h": {
				"type": "list",
				"member": {
					"locationName": "SpotInstanceRequestId"
				}
			},
			"S50": {
				"type": "structure",
				"members": {
					"CapacityReservationId": {
						"locationName": "capacityReservationId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"CapacityReservationArn": {
						"locationName": "capacityReservationArn"
					},
					"AvailabilityZoneId": {
						"locationName": "availabilityZoneId"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"InstancePlatform": {
						"locationName": "instancePlatform"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"Tenancy": {
						"locationName": "tenancy"
					},
					"TotalInstanceCount": {
						"locationName": "totalInstanceCount",
						"type": "integer"
					},
					"AvailableInstanceCount": {
						"locationName": "availableInstanceCount",
						"type": "integer"
					},
					"EbsOptimized": {
						"locationName": "ebsOptimized",
						"type": "boolean"
					},
					"EphemeralStorage": {
						"locationName": "ephemeralStorage",
						"type": "boolean"
					},
					"State": {
						"locationName": "state"
					},
					"EndDate": {
						"locationName": "endDate",
						"type": "timestamp"
					},
					"EndDateType": {
						"locationName": "endDateType"
					},
					"InstanceMatchCriteria": {
						"locationName": "instanceMatchCriteria"
					},
					"CreateDate": {
						"locationName": "createDate",
						"type": "timestamp"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"S58": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"CloudwatchLogGroup": {},
					"CloudwatchLogStream": {}
				}
			},
			"S5b": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"S5f": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"S5k": {
				"type": "structure",
				"members": {
					"BgpAsn": {
						"locationName": "bgpAsn"
					},
					"CustomerGatewayId": {
						"locationName": "customerGatewayId"
					},
					"IpAddress": {
						"locationName": "ipAddress"
					},
					"State": {
						"locationName": "state"
					},
					"Type": {
						"locationName": "type"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"S5n": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"AvailabilityZoneId": {
						"locationName": "availabilityZoneId"
					},
					"AvailableIpAddressCount": {
						"locationName": "availableIpAddressCount",
						"type": "integer"
					},
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"DefaultForAz": {
						"locationName": "defaultForAz",
						"type": "boolean"
					},
					"MapPublicIpOnLaunch": {
						"locationName": "mapPublicIpOnLaunch",
						"type": "boolean"
					},
					"State": {
						"locationName": "state"
					},
					"SubnetId": {
						"locationName": "subnetId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"AssignIpv6AddressOnCreation": {
						"locationName": "assignIpv6AddressOnCreation",
						"type": "boolean"
					},
					"Ipv6CidrBlockAssociationSet": {
						"locationName": "ipv6CidrBlockAssociationSet",
						"type": "list",
						"member": {
							"shape": "S27",
							"locationName": "item"
						}
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"SubnetArn": {
						"locationName": "subnetArn"
					}
				}
			},
			"S5s": {
				"type": "structure",
				"members": {
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"DhcpOptionsId": {
						"locationName": "dhcpOptionsId"
					},
					"State": {
						"locationName": "state"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"InstanceTenancy": {
						"locationName": "instanceTenancy"
					},
					"Ipv6CidrBlockAssociationSet": {
						"locationName": "ipv6CidrBlockAssociationSet",
						"type": "list",
						"member": {
							"shape": "S2h",
							"locationName": "item"
						}
					},
					"CidrBlockAssociationSet": {
						"locationName": "cidrBlockAssociationSet",
						"type": "list",
						"member": {
							"shape": "S2k",
							"locationName": "item"
						}
					},
					"IsDefault": {
						"locationName": "isDefault",
						"type": "boolean"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"S61": {
				"type": "structure",
				"members": {
					"DhcpConfigurations": {
						"locationName": "dhcpConfigurationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Key": {
									"locationName": "key"
								},
								"Values": {
									"locationName": "valueSet",
									"type": "list",
									"member": {
										"shape": "S65",
										"locationName": "item"
									}
								}
							}
						}
					},
					"DhcpOptionsId": {
						"locationName": "dhcpOptionsId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"S65": {
				"type": "structure",
				"members": {
					"Value": {
						"locationName": "value"
					}
				}
			},
			"S68": {
				"type": "structure",
				"members": {
					"Attachments": {
						"shape": "S69",
						"locationName": "attachmentSet"
					},
					"EgressOnlyInternetGatewayId": {
						"locationName": "egressOnlyInternetGatewayId"
					}
				}
			},
			"S69": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"State": {
							"locationName": "state"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"S6q": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"Affinity": {
						"locationName": "affinity"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"PartitionNumber": {
						"locationName": "partitionNumber",
						"type": "integer"
					},
					"HostId": {
						"locationName": "hostId"
					},
					"Tenancy": {
						"locationName": "tenancy"
					},
					"SpreadDomain": {
						"locationName": "spreadDomain"
					}
				}
			},
			"S6r": {
				"type": "structure",
				"required": [
					"TotalTargetCapacity"
				],
				"members": {
					"TotalTargetCapacity": {
						"type": "integer"
					},
					"OnDemandTargetCapacity": {
						"type": "integer"
					},
					"SpotTargetCapacity": {
						"type": "integer"
					},
					"DefaultTargetCapacityType": {}
				}
			},
			"S6y": {
				"type": "structure",
				"members": {
					"LaunchTemplateSpecification": {
						"shape": "S6z",
						"locationName": "launchTemplateSpecification"
					},
					"Overrides": {
						"shape": "S70",
						"locationName": "overrides"
					}
				}
			},
			"S6z": {
				"type": "structure",
				"members": {
					"LaunchTemplateId": {
						"locationName": "launchTemplateId"
					},
					"LaunchTemplateName": {
						"locationName": "launchTemplateName"
					},
					"Version": {
						"locationName": "version"
					}
				}
			},
			"S70": {
				"type": "structure",
				"members": {
					"InstanceType": {
						"locationName": "instanceType"
					},
					"MaxPrice": {
						"locationName": "maxPrice"
					},
					"SubnetId": {
						"locationName": "subnetId"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"WeightedCapacity": {
						"locationName": "weightedCapacity",
						"type": "double"
					},
					"Priority": {
						"locationName": "priority",
						"type": "double"
					},
					"Placement": {
						"locationName": "placement",
						"type": "structure",
						"members": {
							"GroupName": {
								"locationName": "groupName"
							}
						}
					}
				}
			},
			"S75": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"S7e": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"Key": {}
				}
			},
			"S7h": {
				"type": "list",
				"member": {
					"shape": "S7i",
					"locationName": "BlockDeviceMapping"
				}
			},
			"S7i": {
				"type": "structure",
				"members": {
					"DeviceName": {
						"locationName": "deviceName"
					},
					"VirtualName": {
						"locationName": "virtualName"
					},
					"Ebs": {
						"locationName": "ebs",
						"type": "structure",
						"members": {
							"DeleteOnTermination": {
								"locationName": "deleteOnTermination",
								"type": "boolean"
							},
							"Iops": {
								"locationName": "iops",
								"type": "integer"
							},
							"SnapshotId": {
								"locationName": "snapshotId"
							},
							"VolumeSize": {
								"locationName": "volumeSize",
								"type": "integer"
							},
							"VolumeType": {
								"locationName": "volumeType"
							},
							"Encrypted": {
								"locationName": "encrypted",
								"type": "boolean"
							},
							"KmsKeyId": {}
						}
					},
					"NoDevice": {
						"locationName": "noDevice"
					}
				}
			},
			"S7s": {
				"type": "structure",
				"members": {
					"Description": {
						"locationName": "description"
					},
					"ExportTaskId": {
						"locationName": "exportTaskId"
					},
					"ExportToS3Task": {
						"locationName": "exportToS3",
						"type": "structure",
						"members": {
							"ContainerFormat": {
								"locationName": "containerFormat"
							},
							"DiskImageFormat": {
								"locationName": "diskImageFormat"
							},
							"S3Bucket": {
								"locationName": "s3Bucket"
							},
							"S3Key": {
								"locationName": "s3Key"
							}
						}
					},
					"InstanceExportDetails": {
						"locationName": "instanceExport",
						"type": "structure",
						"members": {
							"InstanceId": {
								"locationName": "instanceId"
							},
							"TargetEnvironment": {
								"locationName": "targetEnvironment"
							}
						}
					},
					"State": {
						"locationName": "state"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					}
				}
			},
			"S7y": {
				"type": "structure",
				"members": {
					"Attachments": {
						"shape": "S69",
						"locationName": "attachmentSet"
					},
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"S83": {
				"type": "structure",
				"members": {
					"KernelId": {},
					"EbsOptimized": {
						"type": "boolean"
					},
					"IamInstanceProfile": {
						"type": "structure",
						"members": {
							"Arn": {},
							"Name": {}
						}
					},
					"BlockDeviceMappings": {
						"locationName": "BlockDeviceMapping",
						"type": "list",
						"member": {
							"locationName": "BlockDeviceMapping",
							"type": "structure",
							"members": {
								"DeviceName": {},
								"VirtualName": {},
								"Ebs": {
									"type": "structure",
									"members": {
										"Encrypted": {
											"type": "boolean"
										},
										"DeleteOnTermination": {
											"type": "boolean"
										},
										"Iops": {
											"type": "integer"
										},
										"KmsKeyId": {},
										"SnapshotId": {},
										"VolumeSize": {
											"type": "integer"
										},
										"VolumeType": {}
									}
								},
								"NoDevice": {}
							}
						}
					},
					"NetworkInterfaces": {
						"locationName": "NetworkInterface",
						"type": "list",
						"member": {
							"locationName": "InstanceNetworkInterfaceSpecification",
							"type": "structure",
							"members": {
								"AssociatePublicIpAddress": {
									"type": "boolean"
								},
								"DeleteOnTermination": {
									"type": "boolean"
								},
								"Description": {},
								"DeviceIndex": {
									"type": "integer"
								},
								"Groups": {
									"shape": "S8a",
									"locationName": "SecurityGroupId"
								},
								"InterfaceType": {},
								"Ipv6AddressCount": {
									"type": "integer"
								},
								"Ipv6Addresses": {
									"type": "list",
									"member": {
										"locationName": "InstanceIpv6Address",
										"type": "structure",
										"members": {
											"Ipv6Address": {}
										}
									}
								},
								"NetworkInterfaceId": {},
								"PrivateIpAddress": {},
								"PrivateIpAddresses": {
									"shape": "S8d"
								},
								"SecondaryPrivateIpAddressCount": {
									"type": "integer"
								},
								"SubnetId": {}
							}
						}
					},
					"ImageId": {},
					"InstanceType": {},
					"KeyName": {},
					"Monitoring": {
						"type": "structure",
						"members": {
							"Enabled": {
								"type": "boolean"
							}
						}
					},
					"Placement": {
						"type": "structure",
						"members": {
							"AvailabilityZone": {},
							"Affinity": {},
							"GroupName": {},
							"HostId": {},
							"Tenancy": {},
							"SpreadDomain": {}
						}
					},
					"RamDiskId": {},
					"DisableApiTermination": {
						"type": "boolean"
					},
					"InstanceInitiatedShutdownBehavior": {},
					"UserData": {},
					"TagSpecifications": {
						"locationName": "TagSpecification",
						"type": "list",
						"member": {
							"locationName": "LaunchTemplateTagSpecificationRequest",
							"type": "structure",
							"members": {
								"ResourceType": {},
								"Tags": {
									"shape": "Si",
									"locationName": "Tag"
								}
							}
						}
					},
					"ElasticGpuSpecifications": {
						"locationName": "ElasticGpuSpecification",
						"type": "list",
						"member": {
							"shape": "S8l",
							"locationName": "ElasticGpuSpecification"
						}
					},
					"ElasticInferenceAccelerators": {
						"locationName": "ElasticInferenceAccelerator",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"required": [
								"Type"
							],
							"members": {
								"Type": {}
							}
						}
					},
					"SecurityGroupIds": {
						"shape": "S8a",
						"locationName": "SecurityGroupId"
					},
					"SecurityGroups": {
						"shape": "S8o",
						"locationName": "SecurityGroup"
					},
					"InstanceMarketOptions": {
						"type": "structure",
						"members": {
							"MarketType": {},
							"SpotOptions": {
								"type": "structure",
								"members": {
									"MaxPrice": {},
									"SpotInstanceType": {},
									"BlockDurationMinutes": {
										"type": "integer"
									},
									"ValidUntil": {
										"type": "timestamp"
									},
									"InstanceInterruptionBehavior": {}
								}
							}
						}
					},
					"CreditSpecification": {
						"shape": "S8u"
					},
					"CpuOptions": {
						"type": "structure",
						"members": {
							"CoreCount": {
								"type": "integer"
							},
							"ThreadsPerCore": {
								"type": "integer"
							}
						}
					},
					"CapacityReservationSpecification": {
						"type": "structure",
						"members": {
							"CapacityReservationPreference": {},
							"CapacityReservationTarget": {
								"shape": "S8y"
							}
						}
					},
					"LicenseSpecifications": {
						"locationName": "LicenseSpecification",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"LicenseConfigurationArn": {}
							}
						}
					},
					"HibernationOptions": {
						"type": "structure",
						"members": {
							"Configured": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"S8a": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroupId"
				}
			},
			"S8d": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Primary": {
							"locationName": "primary",
							"type": "boolean"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						}
					}
				}
			},
			"S8l": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {}
				}
			},
			"S8o": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroup"
				}
			},
			"S8u": {
				"type": "structure",
				"required": [
					"CpuCredits"
				],
				"members": {
					"CpuCredits": {}
				}
			},
			"S8y": {
				"type": "structure",
				"members": {
					"CapacityReservationId": {}
				}
			},
			"S93": {
				"type": "structure",
				"members": {
					"LaunchTemplateId": {
						"locationName": "launchTemplateId"
					},
					"LaunchTemplateName": {
						"locationName": "launchTemplateName"
					},
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"CreatedBy": {
						"locationName": "createdBy"
					},
					"DefaultVersionNumber": {
						"locationName": "defaultVersionNumber",
						"type": "long"
					},
					"LatestVersionNumber": {
						"locationName": "latestVersionNumber",
						"type": "long"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"S96": {
				"type": "structure",
				"members": {
					"LaunchTemplateId": {
						"locationName": "launchTemplateId"
					},
					"LaunchTemplateName": {
						"locationName": "launchTemplateName"
					},
					"VersionNumber": {
						"locationName": "versionNumber",
						"type": "long"
					},
					"VersionDescription": {
						"locationName": "versionDescription"
					},
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"CreatedBy": {
						"locationName": "createdBy"
					},
					"DefaultVersion": {
						"locationName": "defaultVersion",
						"type": "boolean"
					},
					"LaunchTemplateData": {
						"shape": "S97",
						"locationName": "launchTemplateData"
					}
				}
			},
			"S97": {
				"type": "structure",
				"members": {
					"KernelId": {
						"locationName": "kernelId"
					},
					"EbsOptimized": {
						"locationName": "ebsOptimized",
						"type": "boolean"
					},
					"IamInstanceProfile": {
						"locationName": "iamInstanceProfile",
						"type": "structure",
						"members": {
							"Arn": {
								"locationName": "arn"
							},
							"Name": {
								"locationName": "name"
							}
						}
					},
					"BlockDeviceMappings": {
						"locationName": "blockDeviceMappingSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"DeviceName": {
									"locationName": "deviceName"
								},
								"VirtualName": {
									"locationName": "virtualName"
								},
								"Ebs": {
									"locationName": "ebs",
									"type": "structure",
									"members": {
										"Encrypted": {
											"locationName": "encrypted",
											"type": "boolean"
										},
										"DeleteOnTermination": {
											"locationName": "deleteOnTermination",
											"type": "boolean"
										},
										"Iops": {
											"locationName": "iops",
											"type": "integer"
										},
										"KmsKeyId": {
											"locationName": "kmsKeyId"
										},
										"SnapshotId": {
											"locationName": "snapshotId"
										},
										"VolumeSize": {
											"locationName": "volumeSize",
											"type": "integer"
										},
										"VolumeType": {
											"locationName": "volumeType"
										}
									}
								},
								"NoDevice": {
									"locationName": "noDevice"
								}
							}
						}
					},
					"NetworkInterfaces": {
						"locationName": "networkInterfaceSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AssociatePublicIpAddress": {
									"locationName": "associatePublicIpAddress",
									"type": "boolean"
								},
								"DeleteOnTermination": {
									"locationName": "deleteOnTermination",
									"type": "boolean"
								},
								"Description": {
									"locationName": "description"
								},
								"DeviceIndex": {
									"locationName": "deviceIndex",
									"type": "integer"
								},
								"Groups": {
									"shape": "S2m",
									"locationName": "groupSet"
								},
								"InterfaceType": {
									"locationName": "interfaceType"
								},
								"Ipv6AddressCount": {
									"locationName": "ipv6AddressCount",
									"type": "integer"
								},
								"Ipv6Addresses": {
									"shape": "S9e",
									"locationName": "ipv6AddressesSet"
								},
								"NetworkInterfaceId": {
									"locationName": "networkInterfaceId"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								},
								"PrivateIpAddresses": {
									"shape": "S8d",
									"locationName": "privateIpAddressesSet"
								},
								"SecondaryPrivateIpAddressCount": {
									"locationName": "secondaryPrivateIpAddressCount",
									"type": "integer"
								},
								"SubnetId": {
									"locationName": "subnetId"
								}
							}
						}
					},
					"ImageId": {
						"locationName": "imageId"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"KeyName": {
						"locationName": "keyName"
					},
					"Monitoring": {
						"locationName": "monitoring",
						"type": "structure",
						"members": {
							"Enabled": {
								"locationName": "enabled",
								"type": "boolean"
							}
						}
					},
					"Placement": {
						"locationName": "placement",
						"type": "structure",
						"members": {
							"AvailabilityZone": {
								"locationName": "availabilityZone"
							},
							"Affinity": {
								"locationName": "affinity"
							},
							"GroupName": {
								"locationName": "groupName"
							},
							"HostId": {
								"locationName": "hostId"
							},
							"Tenancy": {
								"locationName": "tenancy"
							},
							"SpreadDomain": {
								"locationName": "spreadDomain"
							}
						}
					},
					"RamDiskId": {
						"locationName": "ramDiskId"
					},
					"DisableApiTermination": {
						"locationName": "disableApiTermination",
						"type": "boolean"
					},
					"InstanceInitiatedShutdownBehavior": {
						"locationName": "instanceInitiatedShutdownBehavior"
					},
					"UserData": {
						"locationName": "userData"
					},
					"TagSpecifications": {
						"locationName": "tagSpecificationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ResourceType": {
									"locationName": "resourceType"
								},
								"Tags": {
									"shape": "Si",
									"locationName": "tagSet"
								}
							}
						}
					},
					"ElasticGpuSpecifications": {
						"locationName": "elasticGpuSpecificationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Type": {
									"locationName": "type"
								}
							}
						}
					},
					"ElasticInferenceAccelerators": {
						"locationName": "elasticInferenceAcceleratorSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Type": {
									"locationName": "type"
								}
							}
						}
					},
					"SecurityGroupIds": {
						"shape": "Sd",
						"locationName": "securityGroupIdSet"
					},
					"SecurityGroups": {
						"shape": "Sd",
						"locationName": "securityGroupSet"
					},
					"InstanceMarketOptions": {
						"locationName": "instanceMarketOptions",
						"type": "structure",
						"members": {
							"MarketType": {
								"locationName": "marketType"
							},
							"SpotOptions": {
								"locationName": "spotOptions",
								"type": "structure",
								"members": {
									"MaxPrice": {
										"locationName": "maxPrice"
									},
									"SpotInstanceType": {
										"locationName": "spotInstanceType"
									},
									"BlockDurationMinutes": {
										"locationName": "blockDurationMinutes",
										"type": "integer"
									},
									"ValidUntil": {
										"locationName": "validUntil",
										"type": "timestamp"
									},
									"InstanceInterruptionBehavior": {
										"locationName": "instanceInterruptionBehavior"
									}
								}
							}
						}
					},
					"CreditSpecification": {
						"locationName": "creditSpecification",
						"type": "structure",
						"members": {
							"CpuCredits": {
								"locationName": "cpuCredits"
							}
						}
					},
					"CpuOptions": {
						"locationName": "cpuOptions",
						"type": "structure",
						"members": {
							"CoreCount": {
								"locationName": "coreCount",
								"type": "integer"
							},
							"ThreadsPerCore": {
								"locationName": "threadsPerCore",
								"type": "integer"
							}
						}
					},
					"CapacityReservationSpecification": {
						"locationName": "capacityReservationSpecification",
						"type": "structure",
						"members": {
							"CapacityReservationPreference": {
								"locationName": "capacityReservationPreference"
							},
							"CapacityReservationTarget": {
								"shape": "S9t",
								"locationName": "capacityReservationTarget"
							}
						}
					},
					"LicenseSpecifications": {
						"locationName": "licenseSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"LicenseConfigurationArn": {
									"locationName": "licenseConfigurationArn"
								}
							}
						}
					},
					"HibernationOptions": {
						"locationName": "hibernationOptions",
						"type": "structure",
						"members": {
							"Configured": {
								"locationName": "configured",
								"type": "boolean"
							}
						}
					}
				}
			},
			"S9e": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Ipv6Address": {
							"locationName": "ipv6Address"
						}
					}
				}
			},
			"S9t": {
				"type": "structure",
				"members": {
					"CapacityReservationId": {
						"locationName": "capacityReservationId"
					}
				}
			},
			"S9z": {
				"type": "structure",
				"members": {
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"DeleteTime": {
						"locationName": "deleteTime",
						"type": "timestamp"
					},
					"FailureCode": {
						"locationName": "failureCode"
					},
					"FailureMessage": {
						"locationName": "failureMessage"
					},
					"NatGatewayAddresses": {
						"locationName": "natGatewayAddressSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AllocationId": {
									"locationName": "allocationId"
								},
								"NetworkInterfaceId": {
									"locationName": "networkInterfaceId"
								},
								"PrivateIp": {
									"locationName": "privateIp"
								},
								"PublicIp": {
									"locationName": "publicIp"
								}
							}
						}
					},
					"NatGatewayId": {
						"locationName": "natGatewayId"
					},
					"ProvisionedBandwidth": {
						"locationName": "provisionedBandwidth",
						"type": "structure",
						"members": {
							"ProvisionTime": {
								"locationName": "provisionTime",
								"type": "timestamp"
							},
							"Provisioned": {
								"locationName": "provisioned"
							},
							"RequestTime": {
								"locationName": "requestTime",
								"type": "timestamp"
							},
							"Requested": {
								"locationName": "requested"
							},
							"Status": {
								"locationName": "status"
							}
						}
					},
					"State": {
						"locationName": "state"
					},
					"SubnetId": {
						"locationName": "subnetId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sa6": {
				"type": "structure",
				"members": {
					"Associations": {
						"locationName": "associationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"NetworkAclAssociationId": {
									"locationName": "networkAclAssociationId"
								},
								"NetworkAclId": {
									"locationName": "networkAclId"
								},
								"SubnetId": {
									"locationName": "subnetId"
								}
							}
						}
					},
					"Entries": {
						"locationName": "entrySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"CidrBlock": {
									"locationName": "cidrBlock"
								},
								"Egress": {
									"locationName": "egress",
									"type": "boolean"
								},
								"IcmpTypeCode": {
									"shape": "Sab",
									"locationName": "icmpTypeCode"
								},
								"Ipv6CidrBlock": {
									"locationName": "ipv6CidrBlock"
								},
								"PortRange": {
									"shape": "Sac",
									"locationName": "portRange"
								},
								"Protocol": {
									"locationName": "protocol"
								},
								"RuleAction": {
									"locationName": "ruleAction"
								},
								"RuleNumber": {
									"locationName": "ruleNumber",
									"type": "integer"
								}
							}
						}
					},
					"IsDefault": {
						"locationName": "default",
						"type": "boolean"
					},
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					}
				}
			},
			"Sab": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code",
						"type": "integer"
					},
					"Type": {
						"locationName": "type",
						"type": "integer"
					}
				}
			},
			"Sac": {
				"type": "structure",
				"members": {
					"From": {
						"locationName": "from",
						"type": "integer"
					},
					"To": {
						"locationName": "to",
						"type": "integer"
					}
				}
			},
			"Sai": {
				"type": "structure",
				"members": {
					"Association": {
						"shape": "Saj",
						"locationName": "association"
					},
					"Attachment": {
						"shape": "Sak",
						"locationName": "attachment"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"Description": {
						"locationName": "description"
					},
					"Groups": {
						"shape": "Sal",
						"locationName": "groupSet"
					},
					"InterfaceType": {
						"locationName": "interfaceType"
					},
					"Ipv6Addresses": {
						"locationName": "ipv6AddressesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Ipv6Address": {
									"locationName": "ipv6Address"
								}
							}
						}
					},
					"MacAddress": {
						"locationName": "macAddress"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"PrivateDnsName": {
						"locationName": "privateDnsName"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"PrivateIpAddresses": {
						"locationName": "privateIpAddressesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Association": {
									"shape": "Saj",
									"locationName": "association"
								},
								"Primary": {
									"locationName": "primary",
									"type": "boolean"
								},
								"PrivateDnsName": {
									"locationName": "privateDnsName"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								}
							}
						}
					},
					"RequesterId": {
						"locationName": "requesterId"
					},
					"RequesterManaged": {
						"locationName": "requesterManaged",
						"type": "boolean"
					},
					"SourceDestCheck": {
						"locationName": "sourceDestCheck",
						"type": "boolean"
					},
					"Status": {
						"locationName": "status"
					},
					"SubnetId": {
						"locationName": "subnetId"
					},
					"TagSet": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"VpcId": {
						"locationName": "vpcId"
					}
				}
			},
			"Saj": {
				"type": "structure",
				"members": {
					"AllocationId": {
						"locationName": "allocationId"
					},
					"AssociationId": {
						"locationName": "associationId"
					},
					"IpOwnerId": {
						"locationName": "ipOwnerId"
					},
					"PublicDnsName": {
						"locationName": "publicDnsName"
					},
					"PublicIp": {
						"locationName": "publicIp"
					}
				}
			},
			"Sak": {
				"type": "structure",
				"members": {
					"AttachTime": {
						"locationName": "attachTime",
						"type": "timestamp"
					},
					"AttachmentId": {
						"locationName": "attachmentId"
					},
					"DeleteOnTermination": {
						"locationName": "deleteOnTermination",
						"type": "boolean"
					},
					"DeviceIndex": {
						"locationName": "deviceIndex",
						"type": "integer"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"InstanceOwnerId": {
						"locationName": "instanceOwnerId"
					},
					"Status": {
						"locationName": "status"
					}
				}
			},
			"Sal": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"GroupName": {
							"locationName": "groupName"
						},
						"GroupId": {
							"locationName": "groupId"
						}
					}
				}
			},
			"Saw": {
				"type": "structure",
				"members": {
					"NetworkInterfacePermissionId": {
						"locationName": "networkInterfacePermissionId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"AwsAccountId": {
						"locationName": "awsAccountId"
					},
					"AwsService": {
						"locationName": "awsService"
					},
					"Permission": {
						"locationName": "permission"
					},
					"PermissionState": {
						"locationName": "permissionState",
						"type": "structure",
						"members": {
							"State": {
								"locationName": "state"
							},
							"StatusMessage": {
								"locationName": "statusMessage"
							}
						}
					}
				}
			},
			"Sb9": {
				"type": "structure",
				"members": {
					"Associations": {
						"locationName": "associationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Main": {
									"locationName": "main",
									"type": "boolean"
								},
								"RouteTableAssociationId": {
									"locationName": "routeTableAssociationId"
								},
								"RouteTableId": {
									"locationName": "routeTableId"
								},
								"SubnetId": {
									"locationName": "subnetId"
								}
							}
						}
					},
					"PropagatingVgws": {
						"locationName": "propagatingVgwSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"GatewayId": {
									"locationName": "gatewayId"
								}
							}
						}
					},
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"Routes": {
						"locationName": "routeSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"DestinationCidrBlock": {
									"locationName": "destinationCidrBlock"
								},
								"DestinationIpv6CidrBlock": {
									"locationName": "destinationIpv6CidrBlock"
								},
								"DestinationPrefixListId": {
									"locationName": "destinationPrefixListId"
								},
								"EgressOnlyInternetGatewayId": {
									"locationName": "egressOnlyInternetGatewayId"
								},
								"GatewayId": {
									"locationName": "gatewayId"
								},
								"InstanceId": {
									"locationName": "instanceId"
								},
								"InstanceOwnerId": {
									"locationName": "instanceOwnerId"
								},
								"NatGatewayId": {
									"locationName": "natGatewayId"
								},
								"TransitGatewayId": {
									"locationName": "transitGatewayId"
								},
								"NetworkInterfaceId": {
									"locationName": "networkInterfaceId"
								},
								"Origin": {
									"locationName": "origin"
								},
								"State": {
									"locationName": "state"
								},
								"VpcPeeringConnectionId": {
									"locationName": "vpcPeeringConnectionId"
								}
							}
						}
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					}
				}
			},
			"Sbl": {
				"type": "structure",
				"members": {
					"DataEncryptionKeyId": {
						"locationName": "dataEncryptionKeyId"
					},
					"Description": {
						"locationName": "description"
					},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Progress": {
						"locationName": "progress"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"State": {
						"locationName": "status"
					},
					"StateMessage": {
						"locationName": "statusMessage"
					},
					"VolumeId": {
						"locationName": "volumeId"
					},
					"VolumeSize": {
						"locationName": "volumeSize",
						"type": "integer"
					},
					"OwnerAlias": {
						"locationName": "ownerAlias"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sbw": {
				"type": "structure",
				"members": {
					"Bucket": {
						"locationName": "bucket"
					},
					"Fault": {
						"shape": "Sbx",
						"locationName": "fault"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Prefix": {
						"locationName": "prefix"
					},
					"State": {
						"locationName": "state"
					}
				}
			},
			"Sbx": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"Sc2": {
				"type": "list",
				"member": {}
			},
			"Sc5": {
				"type": "structure",
				"members": {
					"TrafficMirrorFilterId": {
						"locationName": "trafficMirrorFilterId"
					},
					"IngressFilterRules": {
						"shape": "Sc6",
						"locationName": "ingressFilterRuleSet"
					},
					"EgressFilterRules": {
						"shape": "Sc6",
						"locationName": "egressFilterRuleSet"
					},
					"NetworkServices": {
						"shape": "Scb",
						"locationName": "networkServiceSet"
					},
					"Description": {
						"locationName": "description"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sc6": {
				"type": "list",
				"member": {
					"shape": "Sc7",
					"locationName": "item"
				}
			},
			"Sc7": {
				"type": "structure",
				"members": {
					"TrafficMirrorFilterRuleId": {
						"locationName": "trafficMirrorFilterRuleId"
					},
					"TrafficMirrorFilterId": {
						"locationName": "trafficMirrorFilterId"
					},
					"TrafficDirection": {
						"locationName": "trafficDirection"
					},
					"RuleNumber": {
						"locationName": "ruleNumber",
						"type": "integer"
					},
					"RuleAction": {
						"locationName": "ruleAction"
					},
					"Protocol": {
						"locationName": "protocol",
						"type": "integer"
					},
					"DestinationPortRange": {
						"shape": "Sca",
						"locationName": "destinationPortRange"
					},
					"SourcePortRange": {
						"shape": "Sca",
						"locationName": "sourcePortRange"
					},
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"SourceCidrBlock": {
						"locationName": "sourceCidrBlock"
					},
					"Description": {
						"locationName": "description"
					}
				}
			},
			"Sca": {
				"type": "structure",
				"members": {
					"FromPort": {
						"locationName": "fromPort",
						"type": "integer"
					},
					"ToPort": {
						"locationName": "toPort",
						"type": "integer"
					}
				}
			},
			"Scb": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Sce": {
				"type": "structure",
				"members": {
					"FromPort": {
						"type": "integer"
					},
					"ToPort": {
						"type": "integer"
					}
				}
			},
			"Sci": {
				"type": "structure",
				"members": {
					"TrafficMirrorSessionId": {
						"locationName": "trafficMirrorSessionId"
					},
					"TrafficMirrorTargetId": {
						"locationName": "trafficMirrorTargetId"
					},
					"TrafficMirrorFilterId": {
						"locationName": "trafficMirrorFilterId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"PacketLength": {
						"locationName": "packetLength",
						"type": "integer"
					},
					"SessionNumber": {
						"locationName": "sessionNumber",
						"type": "integer"
					},
					"VirtualNetworkId": {
						"locationName": "virtualNetworkId",
						"type": "integer"
					},
					"Description": {
						"locationName": "description"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Scl": {
				"type": "structure",
				"members": {
					"TrafficMirrorTargetId": {
						"locationName": "trafficMirrorTargetId"
					},
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"NetworkLoadBalancerArn": {
						"locationName": "networkLoadBalancerArn"
					},
					"Type": {
						"locationName": "type"
					},
					"Description": {
						"locationName": "description"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Scu": {
				"type": "structure",
				"members": {
					"TransitGatewayId": {
						"locationName": "transitGatewayId"
					},
					"TransitGatewayArn": {
						"locationName": "transitGatewayArn"
					},
					"State": {
						"locationName": "state"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Description": {
						"locationName": "description"
					},
					"CreationTime": {
						"locationName": "creationTime",
						"type": "timestamp"
					},
					"Options": {
						"locationName": "options",
						"type": "structure",
						"members": {
							"AmazonSideAsn": {
								"locationName": "amazonSideAsn",
								"type": "long"
							},
							"AutoAcceptSharedAttachments": {
								"locationName": "autoAcceptSharedAttachments"
							},
							"DefaultRouteTableAssociation": {
								"locationName": "defaultRouteTableAssociation"
							},
							"AssociationDefaultRouteTableId": {
								"locationName": "associationDefaultRouteTableId"
							},
							"DefaultRouteTablePropagation": {
								"locationName": "defaultRouteTablePropagation"
							},
							"PropagationDefaultRouteTableId": {
								"locationName": "propagationDefaultRouteTableId"
							},
							"VpnEcmpSupport": {
								"locationName": "vpnEcmpSupport"
							},
							"DnsSupport": {
								"locationName": "dnsSupport"
							}
						}
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Scz": {
				"type": "structure",
				"members": {
					"DestinationCidrBlock": {
						"locationName": "destinationCidrBlock"
					},
					"TransitGatewayAttachments": {
						"locationName": "transitGatewayAttachments",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ResourceId": {
									"locationName": "resourceId"
								},
								"TransitGatewayAttachmentId": {
									"locationName": "transitGatewayAttachmentId"
								},
								"ResourceType": {
									"locationName": "resourceType"
								}
							}
						}
					},
					"Type": {
						"locationName": "type"
					},
					"State": {
						"locationName": "state"
					}
				}
			},
			"Sd6": {
				"type": "structure",
				"members": {
					"TransitGatewayRouteTableId": {
						"locationName": "transitGatewayRouteTableId"
					},
					"TransitGatewayId": {
						"locationName": "transitGatewayId"
					},
					"State": {
						"locationName": "state"
					},
					"DefaultAssociationRouteTable": {
						"locationName": "defaultAssociationRouteTable",
						"type": "boolean"
					},
					"DefaultPropagationRouteTable": {
						"locationName": "defaultPropagationRouteTable",
						"type": "boolean"
					},
					"CreationTime": {
						"locationName": "creationTime",
						"type": "timestamp"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sdc": {
				"type": "structure",
				"members": {
					"Attachments": {
						"locationName": "attachmentSet",
						"type": "list",
						"member": {
							"shape": "S2s",
							"locationName": "item"
						}
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"Size": {
						"locationName": "size",
						"type": "integer"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"State": {
						"locationName": "status"
					},
					"VolumeId": {
						"locationName": "volumeId"
					},
					"Iops": {
						"locationName": "iops",
						"type": "integer"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"VolumeType": {
						"locationName": "volumeType"
					}
				}
			},
			"Sdk": {
				"type": "structure",
				"members": {
					"VpcEndpointId": {
						"locationName": "vpcEndpointId"
					},
					"VpcEndpointType": {
						"locationName": "vpcEndpointType"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"ServiceName": {
						"locationName": "serviceName"
					},
					"State": {
						"locationName": "state"
					},
					"PolicyDocument": {
						"locationName": "policyDocument"
					},
					"RouteTableIds": {
						"shape": "Sd",
						"locationName": "routeTableIdSet"
					},
					"SubnetIds": {
						"shape": "Sd",
						"locationName": "subnetIdSet"
					},
					"Groups": {
						"locationName": "groupSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"GroupId": {
									"locationName": "groupId"
								},
								"GroupName": {
									"locationName": "groupName"
								}
							}
						}
					},
					"PrivateDnsEnabled": {
						"locationName": "privateDnsEnabled",
						"type": "boolean"
					},
					"RequesterManaged": {
						"locationName": "requesterManaged",
						"type": "boolean"
					},
					"NetworkInterfaceIds": {
						"shape": "Sd",
						"locationName": "networkInterfaceIdSet"
					},
					"DnsEntries": {
						"shape": "Sdo",
						"locationName": "dnsEntrySet"
					},
					"CreationTimestamp": {
						"locationName": "creationTimestamp",
						"type": "timestamp"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"OwnerId": {
						"locationName": "ownerId"
					}
				}
			},
			"Sdo": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"DnsName": {
							"locationName": "dnsName"
						},
						"HostedZoneId": {
							"locationName": "hostedZoneId"
						}
					}
				}
			},
			"Sds": {
				"type": "structure",
				"members": {
					"ConnectionNotificationId": {
						"locationName": "connectionNotificationId"
					},
					"ServiceId": {
						"locationName": "serviceId"
					},
					"VpcEndpointId": {
						"locationName": "vpcEndpointId"
					},
					"ConnectionNotificationType": {
						"locationName": "connectionNotificationType"
					},
					"ConnectionNotificationArn": {
						"locationName": "connectionNotificationArn"
					},
					"ConnectionEvents": {
						"shape": "Sd",
						"locationName": "connectionEvents"
					},
					"ConnectionNotificationState": {
						"locationName": "connectionNotificationState"
					}
				}
			},
			"Sdx": {
				"type": "structure",
				"members": {
					"ServiceType": {
						"shape": "Sdy",
						"locationName": "serviceType"
					},
					"ServiceId": {
						"locationName": "serviceId"
					},
					"ServiceName": {
						"locationName": "serviceName"
					},
					"ServiceState": {
						"locationName": "serviceState"
					},
					"AvailabilityZones": {
						"shape": "Sd",
						"locationName": "availabilityZoneSet"
					},
					"AcceptanceRequired": {
						"locationName": "acceptanceRequired",
						"type": "boolean"
					},
					"ManagesVpcEndpoints": {
						"locationName": "managesVpcEndpoints",
						"type": "boolean"
					},
					"NetworkLoadBalancerArns": {
						"shape": "Sd",
						"locationName": "networkLoadBalancerArnSet"
					},
					"BaseEndpointDnsNames": {
						"shape": "Sd",
						"locationName": "baseEndpointDnsNameSet"
					},
					"PrivateDnsName": {
						"locationName": "privateDnsName"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sdy": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"ServiceType": {
							"locationName": "serviceType"
						}
					}
				}
			},
			"Se9": {
				"type": "structure",
				"members": {
					"CustomerGatewayConfiguration": {
						"locationName": "customerGatewayConfiguration"
					},
					"CustomerGatewayId": {
						"locationName": "customerGatewayId"
					},
					"Category": {
						"locationName": "category"
					},
					"State": {
						"locationName": "state"
					},
					"Type": {
						"locationName": "type"
					},
					"VpnConnectionId": {
						"locationName": "vpnConnectionId"
					},
					"VpnGatewayId": {
						"locationName": "vpnGatewayId"
					},
					"TransitGatewayId": {
						"locationName": "transitGatewayId"
					},
					"Options": {
						"locationName": "options",
						"type": "structure",
						"members": {
							"StaticRoutesOnly": {
								"locationName": "staticRoutesOnly",
								"type": "boolean"
							}
						}
					},
					"Routes": {
						"locationName": "routes",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"DestinationCidrBlock": {
									"locationName": "destinationCidrBlock"
								},
								"Source": {
									"locationName": "source"
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					},
					"VgwTelemetry": {
						"locationName": "vgwTelemetry",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AcceptedRouteCount": {
									"locationName": "acceptedRouteCount",
									"type": "integer"
								},
								"LastStatusChange": {
									"locationName": "lastStatusChange",
									"type": "timestamp"
								},
								"OutsideIpAddress": {
									"locationName": "outsideIpAddress"
								},
								"Status": {
									"locationName": "status"
								},
								"StatusMessage": {
									"locationName": "statusMessage"
								}
							}
						}
					}
				}
			},
			"Sel": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"State": {
						"locationName": "state"
					},
					"Type": {
						"locationName": "type"
					},
					"VpcAttachments": {
						"locationName": "attachments",
						"type": "list",
						"member": {
							"shape": "S2w",
							"locationName": "item"
						}
					},
					"VpnGatewayId": {
						"locationName": "vpnGatewayId"
					},
					"AmazonSideAsn": {
						"locationName": "amazonSideAsn",
						"type": "long"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sew": {
				"type": "list",
				"member": {}
			},
			"Sfe": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Sh6": {
				"type": "list",
				"member": {
					"locationName": "Filter",
					"type": "structure",
					"members": {
						"Name": {},
						"Values": {
							"shape": "Sd",
							"locationName": "Value"
						}
					}
				}
			},
			"Shf": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Deadline": {
							"locationName": "deadline",
							"type": "timestamp"
						},
						"Resource": {
							"locationName": "resource"
						},
						"UseLongIds": {
							"locationName": "useLongIds",
							"type": "boolean"
						}
					}
				}
			},
			"Si5": {
				"type": "list",
				"member": {
					"locationName": "InstanceId"
				}
			},
			"Sik": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"Sje": {
				"type": "structure",
				"members": {
					"ConversionTaskId": {
						"locationName": "conversionTaskId"
					},
					"ExpirationTime": {
						"locationName": "expirationTime"
					},
					"ImportInstance": {
						"locationName": "importInstance",
						"type": "structure",
						"members": {
							"Description": {
								"locationName": "description"
							},
							"InstanceId": {
								"locationName": "instanceId"
							},
							"Platform": {
								"locationName": "platform"
							},
							"Volumes": {
								"locationName": "volumes",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"members": {
										"AvailabilityZone": {
											"locationName": "availabilityZone"
										},
										"BytesConverted": {
											"locationName": "bytesConverted",
											"type": "long"
										},
										"Description": {
											"locationName": "description"
										},
										"Image": {
											"shape": "Sji",
											"locationName": "image"
										},
										"Status": {
											"locationName": "status"
										},
										"StatusMessage": {
											"locationName": "statusMessage"
										},
										"Volume": {
											"shape": "Sjj",
											"locationName": "volume"
										}
									}
								}
							}
						}
					},
					"ImportVolume": {
						"locationName": "importVolume",
						"type": "structure",
						"members": {
							"AvailabilityZone": {
								"locationName": "availabilityZone"
							},
							"BytesConverted": {
								"locationName": "bytesConverted",
								"type": "long"
							},
							"Description": {
								"locationName": "description"
							},
							"Image": {
								"shape": "Sji",
								"locationName": "image"
							},
							"Volume": {
								"shape": "Sjj",
								"locationName": "volume"
							}
						}
					},
					"State": {
						"locationName": "state"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Tags": {
						"shape": "Si",
						"locationName": "tagSet"
					}
				}
			},
			"Sji": {
				"type": "structure",
				"members": {
					"Checksum": {
						"locationName": "checksum"
					},
					"Format": {
						"locationName": "format"
					},
					"ImportManifestUrl": {
						"locationName": "importManifestUrl"
					},
					"Size": {
						"locationName": "size",
						"type": "long"
					}
				}
			},
			"Sjj": {
				"type": "structure",
				"members": {
					"Id": {
						"locationName": "id"
					},
					"Size": {
						"locationName": "size",
						"type": "long"
					}
				}
			},
			"Ski": {
				"type": "structure",
				"members": {
					"EventDescription": {
						"locationName": "eventDescription"
					},
					"EventSubType": {
						"locationName": "eventSubType"
					},
					"InstanceId": {
						"locationName": "instanceId"
					}
				}
			},
			"Skl": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"InstanceType": {
							"locationName": "instanceType"
						},
						"SpotInstanceRequestId": {
							"locationName": "spotInstanceRequestId"
						},
						"InstanceHealth": {
							"locationName": "instanceHealth"
						}
					}
				}
			},
			"Sla": {
				"type": "structure",
				"members": {
					"FpgaImageId": {
						"locationName": "fpgaImageId"
					},
					"Name": {
						"locationName": "name"
					},
					"Description": {
						"locationName": "description"
					},
					"LoadPermissions": {
						"locationName": "loadPermissions",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"UserId": {
									"locationName": "userId"
								},
								"Group": {
									"locationName": "group"
								}
							}
						}
					},
					"ProductCodes": {
						"shape": "Sle",
						"locationName": "productCodes"
					}
				}
			},
			"Sle": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"ProductCodeId": {
							"locationName": "productCode"
						},
						"ProductCodeType": {
							"locationName": "type"
						}
					}
				}
			},
			"Slj": {
				"type": "list",
				"member": {
					"locationName": "Owner"
				}
			},
			"Sm2": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Sm5": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Sms": {
				"type": "list",
				"member": {
					"shape": "S7i",
					"locationName": "item"
				}
			},
			"Smt": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Group": {
							"locationName": "group"
						},
						"UserId": {
							"locationName": "userId"
						}
					}
				}
			},
			"Sn6": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"Sn9": {
				"type": "list",
				"member": {
					"locationName": "ImportTaskId"
				}
			},
			"Snd": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Description": {
							"locationName": "description"
						},
						"DeviceName": {
							"locationName": "deviceName"
						},
						"DiskImageSize": {
							"locationName": "diskImageSize",
							"type": "double"
						},
						"Format": {
							"locationName": "format"
						},
						"Progress": {
							"locationName": "progress"
						},
						"SnapshotId": {
							"locationName": "snapshotId"
						},
						"Status": {
							"locationName": "status"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						},
						"Url": {
							"locationName": "url"
						},
						"UserBucket": {
							"shape": "Snf",
							"locationName": "userBucket"
						}
					}
				}
			},
			"Snf": {
				"type": "structure",
				"members": {
					"S3Bucket": {
						"locationName": "s3Bucket"
					},
					"S3Key": {
						"locationName": "s3Key"
					}
				}
			},
			"Snk": {
				"type": "structure",
				"members": {
					"Description": {
						"locationName": "description"
					},
					"DiskImageSize": {
						"locationName": "diskImageSize",
						"type": "double"
					},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"Format": {
						"locationName": "format"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"Progress": {
						"locationName": "progress"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"Status": {
						"locationName": "status"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Url": {
						"locationName": "url"
					},
					"UserBucket": {
						"shape": "Snf",
						"locationName": "userBucket"
					}
				}
			},
			"Sno": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"DeviceName": {
							"locationName": "deviceName"
						},
						"Ebs": {
							"locationName": "ebs",
							"type": "structure",
							"members": {
								"AttachTime": {
									"locationName": "attachTime",
									"type": "timestamp"
								},
								"DeleteOnTermination": {
									"locationName": "deleteOnTermination",
									"type": "boolean"
								},
								"Status": {
									"locationName": "status"
								},
								"VolumeId": {
									"locationName": "volumeId"
								}
							}
						}
					}
				}
			},
			"Snr": {
				"type": "structure",
				"members": {
					"Value": {
						"locationName": "value",
						"type": "boolean"
					}
				}
			},
			"So2": {
				"type": "structure",
				"members": {
					"InstanceEventId": {
						"locationName": "instanceEventId"
					},
					"Code": {
						"locationName": "code"
					},
					"Description": {
						"locationName": "description"
					},
					"NotAfter": {
						"locationName": "notAfter",
						"type": "timestamp"
					},
					"NotBefore": {
						"locationName": "notBefore",
						"type": "timestamp"
					},
					"NotBeforeDeadline": {
						"locationName": "notBeforeDeadline",
						"type": "timestamp"
					}
				}
			},
			"So5": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code",
						"type": "integer"
					},
					"Name": {
						"locationName": "name"
					}
				}
			},
			"So7": {
				"type": "structure",
				"members": {
					"Details": {
						"locationName": "details",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ImpairedSince": {
									"locationName": "impairedSince",
									"type": "timestamp"
								},
								"Name": {
									"locationName": "name"
								},
								"Status": {
									"locationName": "status"
								}
							}
						}
					},
					"Status": {
						"locationName": "status"
					}
				}
			},
			"Sog": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "Sal",
						"locationName": "groupSet"
					},
					"Instances": {
						"locationName": "instancesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"AmiLaunchIndex": {
									"locationName": "amiLaunchIndex",
									"type": "integer"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"InstanceId": {
									"locationName": "instanceId"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"LaunchTime": {
									"locationName": "launchTime",
									"type": "timestamp"
								},
								"Monitoring": {
									"shape": "Soj",
									"locationName": "monitoring"
								},
								"Placement": {
									"shape": "S6q",
									"locationName": "placement"
								},
								"Platform": {
									"locationName": "platform"
								},
								"PrivateDnsName": {
									"locationName": "privateDnsName"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								},
								"ProductCodes": {
									"shape": "Sle",
									"locationName": "productCodes"
								},
								"PublicDnsName": {
									"locationName": "dnsName"
								},
								"PublicIpAddress": {
									"locationName": "ipAddress"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"State": {
									"shape": "So5",
									"locationName": "instanceState"
								},
								"StateTransitionReason": {
									"locationName": "reason"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"VpcId": {
									"locationName": "vpcId"
								},
								"Architecture": {
									"locationName": "architecture"
								},
								"BlockDeviceMappings": {
									"shape": "Sno",
									"locationName": "blockDeviceMapping"
								},
								"ClientToken": {
									"locationName": "clientToken"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"EnaSupport": {
									"locationName": "enaSupport",
									"type": "boolean"
								},
								"Hypervisor": {
									"locationName": "hypervisor"
								},
								"IamInstanceProfile": {
									"shape": "S21",
									"locationName": "iamInstanceProfile"
								},
								"InstanceLifecycle": {
									"locationName": "instanceLifecycle"
								},
								"ElasticGpuAssociations": {
									"locationName": "elasticGpuAssociationSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"ElasticGpuId": {
												"locationName": "elasticGpuId"
											},
											"ElasticGpuAssociationId": {
												"locationName": "elasticGpuAssociationId"
											},
											"ElasticGpuAssociationState": {
												"locationName": "elasticGpuAssociationState"
											},
											"ElasticGpuAssociationTime": {
												"locationName": "elasticGpuAssociationTime"
											}
										}
									}
								},
								"ElasticInferenceAcceleratorAssociations": {
									"locationName": "elasticInferenceAcceleratorAssociationSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"ElasticInferenceAcceleratorArn": {
												"locationName": "elasticInferenceAcceleratorArn"
											},
											"ElasticInferenceAcceleratorAssociationId": {
												"locationName": "elasticInferenceAcceleratorAssociationId"
											},
											"ElasticInferenceAcceleratorAssociationState": {
												"locationName": "elasticInferenceAcceleratorAssociationState"
											},
											"ElasticInferenceAcceleratorAssociationTime": {
												"locationName": "elasticInferenceAcceleratorAssociationTime",
												"type": "timestamp"
											}
										}
									}
								},
								"NetworkInterfaces": {
									"locationName": "networkInterfaceSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"Association": {
												"shape": "Sos",
												"locationName": "association"
											},
											"Attachment": {
												"locationName": "attachment",
												"type": "structure",
												"members": {
													"AttachTime": {
														"locationName": "attachTime",
														"type": "timestamp"
													},
													"AttachmentId": {
														"locationName": "attachmentId"
													},
													"DeleteOnTermination": {
														"locationName": "deleteOnTermination",
														"type": "boolean"
													},
													"DeviceIndex": {
														"locationName": "deviceIndex",
														"type": "integer"
													},
													"Status": {
														"locationName": "status"
													}
												}
											},
											"Description": {
												"locationName": "description"
											},
											"Groups": {
												"shape": "Sal",
												"locationName": "groupSet"
											},
											"Ipv6Addresses": {
												"shape": "S9e",
												"locationName": "ipv6AddressesSet"
											},
											"MacAddress": {
												"locationName": "macAddress"
											},
											"NetworkInterfaceId": {
												"locationName": "networkInterfaceId"
											},
											"OwnerId": {
												"locationName": "ownerId"
											},
											"PrivateDnsName": {
												"locationName": "privateDnsName"
											},
											"PrivateIpAddress": {
												"locationName": "privateIpAddress"
											},
											"PrivateIpAddresses": {
												"locationName": "privateIpAddressesSet",
												"type": "list",
												"member": {
													"locationName": "item",
													"type": "structure",
													"members": {
														"Association": {
															"shape": "Sos",
															"locationName": "association"
														},
														"Primary": {
															"locationName": "primary",
															"type": "boolean"
														},
														"PrivateDnsName": {
															"locationName": "privateDnsName"
														},
														"PrivateIpAddress": {
															"locationName": "privateIpAddress"
														}
													}
												}
											},
											"SourceDestCheck": {
												"locationName": "sourceDestCheck",
												"type": "boolean"
											},
											"Status": {
												"locationName": "status"
											},
											"SubnetId": {
												"locationName": "subnetId"
											},
											"VpcId": {
												"locationName": "vpcId"
											},
											"InterfaceType": {
												"locationName": "interfaceType"
											}
										}
									}
								},
								"RootDeviceName": {
									"locationName": "rootDeviceName"
								},
								"RootDeviceType": {
									"locationName": "rootDeviceType"
								},
								"SecurityGroups": {
									"shape": "Sal",
									"locationName": "groupSet"
								},
								"SourceDestCheck": {
									"locationName": "sourceDestCheck",
									"type": "boolean"
								},
								"SpotInstanceRequestId": {
									"locationName": "spotInstanceRequestId"
								},
								"SriovNetSupport": {
									"locationName": "sriovNetSupport"
								},
								"StateReason": {
									"shape": "Sn6",
									"locationName": "stateReason"
								},
								"Tags": {
									"shape": "Si",
									"locationName": "tagSet"
								},
								"VirtualizationType": {
									"locationName": "virtualizationType"
								},
								"CpuOptions": {
									"locationName": "cpuOptions",
									"type": "structure",
									"members": {
										"CoreCount": {
											"locationName": "coreCount",
											"type": "integer"
										},
										"ThreadsPerCore": {
											"locationName": "threadsPerCore",
											"type": "integer"
										}
									}
								},
								"CapacityReservationId": {
									"locationName": "capacityReservationId"
								},
								"CapacityReservationSpecification": {
									"locationName": "capacityReservationSpecification",
									"type": "structure",
									"members": {
										"CapacityReservationPreference": {
											"locationName": "capacityReservationPreference"
										},
										"CapacityReservationTarget": {
											"shape": "S9t",
											"locationName": "capacityReservationTarget"
										}
									}
								},
								"HibernationOptions": {
									"locationName": "hibernationOptions",
									"type": "structure",
									"members": {
										"Configured": {
											"locationName": "configured",
											"type": "boolean"
										}
									}
								},
								"Licenses": {
									"locationName": "licenseSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"LicenseConfigurationArn": {
												"locationName": "licenseConfigurationArn"
											}
										}
									}
								}
							}
						}
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"RequesterId": {
						"locationName": "requesterId"
					},
					"ReservationId": {
						"locationName": "reservationId"
					}
				}
			},
			"Soj": {
				"type": "structure",
				"members": {
					"State": {
						"locationName": "state"
					}
				}
			},
			"Sos": {
				"type": "structure",
				"members": {
					"IpOwnerId": {
						"locationName": "ipOwnerId"
					},
					"PublicDnsName": {
						"locationName": "publicDnsName"
					},
					"PublicIp": {
						"locationName": "publicIp"
					}
				}
			},
			"Sr3": {
				"type": "list",
				"member": {
					"locationName": "ReservedInstancesId"
				}
			},
			"Srb": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Amount": {
							"locationName": "amount",
							"type": "double"
						},
						"Frequency": {
							"locationName": "frequency"
						}
					}
				}
			},
			"Sro": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"Platform": {
						"locationName": "platform"
					},
					"Scope": {
						"locationName": "scope"
					}
				}
			},
			"Ssa": {
				"type": "structure",
				"members": {
					"Frequency": {
						"locationName": "frequency"
					},
					"Interval": {
						"locationName": "interval",
						"type": "integer"
					},
					"OccurrenceDaySet": {
						"locationName": "occurrenceDaySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "integer"
						}
					},
					"OccurrenceRelativeToEnd": {
						"locationName": "occurrenceRelativeToEnd",
						"type": "boolean"
					},
					"OccurrenceUnit": {
						"locationName": "occurrenceUnit"
					}
				}
			},
			"Ssh": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"CreateDate": {
						"locationName": "createDate",
						"type": "timestamp"
					},
					"HourlyPrice": {
						"locationName": "hourlyPrice"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"NetworkPlatform": {
						"locationName": "networkPlatform"
					},
					"NextSlotStartTime": {
						"locationName": "nextSlotStartTime",
						"type": "timestamp"
					},
					"Platform": {
						"locationName": "platform"
					},
					"PreviousSlotEndTime": {
						"locationName": "previousSlotEndTime",
						"type": "timestamp"
					},
					"Recurrence": {
						"shape": "Ssa",
						"locationName": "recurrence"
					},
					"ScheduledInstanceId": {
						"locationName": "scheduledInstanceId"
					},
					"SlotDurationInHours": {
						"locationName": "slotDurationInHours",
						"type": "integer"
					},
					"TermEndDate": {
						"locationName": "termEndDate",
						"type": "timestamp"
					},
					"TermStartDate": {
						"locationName": "termStartDate",
						"type": "timestamp"
					},
					"TotalScheduledInstanceHours": {
						"locationName": "totalScheduledInstanceHours",
						"type": "integer"
					}
				}
			},
			"Sso": {
				"type": "list",
				"member": {
					"locationName": "GroupName"
				}
			},
			"Ssw": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Group": {
							"locationName": "group"
						},
						"UserId": {
							"locationName": "userId"
						}
					}
				}
			},
			"Stj": {
				"type": "structure",
				"required": [
					"IamFleetRole",
					"TargetCapacity"
				],
				"members": {
					"AllocationStrategy": {
						"locationName": "allocationStrategy"
					},
					"OnDemandAllocationStrategy": {
						"locationName": "onDemandAllocationStrategy"
					},
					"ClientToken": {
						"locationName": "clientToken"
					},
					"ExcessCapacityTerminationPolicy": {
						"locationName": "excessCapacityTerminationPolicy"
					},
					"FulfilledCapacity": {
						"locationName": "fulfilledCapacity",
						"type": "double"
					},
					"OnDemandFulfilledCapacity": {
						"locationName": "onDemandFulfilledCapacity",
						"type": "double"
					},
					"IamFleetRole": {
						"locationName": "iamFleetRole"
					},
					"LaunchSpecifications": {
						"locationName": "launchSpecifications",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"SecurityGroups": {
									"shape": "Sal",
									"locationName": "groupSet"
								},
								"AddressingType": {
									"locationName": "addressingType"
								},
								"BlockDeviceMappings": {
									"shape": "Sms",
									"locationName": "blockDeviceMapping"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"IamInstanceProfile": {
									"shape": "S1y",
									"locationName": "iamInstanceProfile"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"Monitoring": {
									"locationName": "monitoring",
									"type": "structure",
									"members": {
										"Enabled": {
											"locationName": "enabled",
											"type": "boolean"
										}
									}
								},
								"NetworkInterfaces": {
									"shape": "Stq",
									"locationName": "networkInterfaceSet"
								},
								"Placement": {
									"shape": "Sts",
									"locationName": "placement"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"SpotPrice": {
									"locationName": "spotPrice"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"UserData": {
									"locationName": "userData"
								},
								"WeightedCapacity": {
									"locationName": "weightedCapacity",
									"type": "double"
								},
								"TagSpecifications": {
									"locationName": "tagSpecificationSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"ResourceType": {
												"locationName": "resourceType"
											},
											"Tags": {
												"shape": "Si",
												"locationName": "tag"
											}
										}
									}
								}
							}
						}
					},
					"LaunchTemplateConfigs": {
						"locationName": "launchTemplateConfigs",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"LaunchTemplateSpecification": {
									"shape": "S6z",
									"locationName": "launchTemplateSpecification"
								},
								"Overrides": {
									"locationName": "overrides",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"InstanceType": {
												"locationName": "instanceType"
											},
											"SpotPrice": {
												"locationName": "spotPrice"
											},
											"SubnetId": {
												"locationName": "subnetId"
											},
											"AvailabilityZone": {
												"locationName": "availabilityZone"
											},
											"WeightedCapacity": {
												"locationName": "weightedCapacity",
												"type": "double"
											},
											"Priority": {
												"locationName": "priority",
												"type": "double"
											}
										}
									}
								}
							}
						}
					},
					"SpotPrice": {
						"locationName": "spotPrice"
					},
					"TargetCapacity": {
						"locationName": "targetCapacity",
						"type": "integer"
					},
					"OnDemandTargetCapacity": {
						"locationName": "onDemandTargetCapacity",
						"type": "integer"
					},
					"OnDemandMaxTotalPrice": {
						"locationName": "onDemandMaxTotalPrice"
					},
					"SpotMaxTotalPrice": {
						"locationName": "spotMaxTotalPrice"
					},
					"TerminateInstancesWithExpiration": {
						"locationName": "terminateInstancesWithExpiration",
						"type": "boolean"
					},
					"Type": {
						"locationName": "type"
					},
					"ValidFrom": {
						"locationName": "validFrom",
						"type": "timestamp"
					},
					"ValidUntil": {
						"locationName": "validUntil",
						"type": "timestamp"
					},
					"ReplaceUnhealthyInstances": {
						"locationName": "replaceUnhealthyInstances",
						"type": "boolean"
					},
					"InstanceInterruptionBehavior": {
						"locationName": "instanceInterruptionBehavior"
					},
					"LoadBalancersConfig": {
						"locationName": "loadBalancersConfig",
						"type": "structure",
						"members": {
							"ClassicLoadBalancersConfig": {
								"locationName": "classicLoadBalancersConfig",
								"type": "structure",
								"members": {
									"ClassicLoadBalancers": {
										"locationName": "classicLoadBalancers",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Name": {
													"locationName": "name"
												}
											}
										}
									}
								}
							},
							"TargetGroupsConfig": {
								"locationName": "targetGroupsConfig",
								"type": "structure",
								"members": {
									"TargetGroups": {
										"locationName": "targetGroups",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Arn": {
													"locationName": "arn"
												}
											}
										}
									}
								}
							}
						}
					},
					"InstancePoolsToUseCount": {
						"locationName": "instancePoolsToUseCount",
						"type": "integer"
					}
				}
			},
			"Stq": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"AssociatePublicIpAddress": {
							"locationName": "associatePublicIpAddress",
							"type": "boolean"
						},
						"DeleteOnTermination": {
							"locationName": "deleteOnTermination",
							"type": "boolean"
						},
						"Description": {
							"locationName": "description"
						},
						"DeviceIndex": {
							"locationName": "deviceIndex",
							"type": "integer"
						},
						"Groups": {
							"shape": "S8a",
							"locationName": "SecurityGroupId"
						},
						"Ipv6AddressCount": {
							"locationName": "ipv6AddressCount",
							"type": "integer"
						},
						"Ipv6Addresses": {
							"shape": "S9e",
							"locationName": "ipv6AddressesSet",
							"queryName": "Ipv6Addresses"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"PrivateIpAddresses": {
							"shape": "S8d",
							"locationName": "privateIpAddressesSet",
							"queryName": "PrivateIpAddresses"
						},
						"SecondaryPrivateIpAddressCount": {
							"locationName": "secondaryPrivateIpAddressCount",
							"type": "integer"
						},
						"SubnetId": {
							"locationName": "subnetId"
						},
						"InterfaceType": {}
					}
				}
			},
			"Sts": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"Tenancy": {
						"locationName": "tenancy"
					}
				}
			},
			"Su8": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"ActualBlockHourlyPrice": {
							"locationName": "actualBlockHourlyPrice"
						},
						"AvailabilityZoneGroup": {
							"locationName": "availabilityZoneGroup"
						},
						"BlockDurationMinutes": {
							"locationName": "blockDurationMinutes",
							"type": "integer"
						},
						"CreateTime": {
							"locationName": "createTime",
							"type": "timestamp"
						},
						"Fault": {
							"shape": "Sbx",
							"locationName": "fault"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"LaunchGroup": {
							"locationName": "launchGroup"
						},
						"LaunchSpecification": {
							"locationName": "launchSpecification",
							"type": "structure",
							"members": {
								"UserData": {
									"locationName": "userData"
								},
								"SecurityGroups": {
									"shape": "Sal",
									"locationName": "groupSet"
								},
								"AddressingType": {
									"locationName": "addressingType"
								},
								"BlockDeviceMappings": {
									"shape": "Sms",
									"locationName": "blockDeviceMapping"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"IamInstanceProfile": {
									"shape": "S1y",
									"locationName": "iamInstanceProfile"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"NetworkInterfaces": {
									"shape": "Stq",
									"locationName": "networkInterfaceSet"
								},
								"Placement": {
									"shape": "Sts",
									"locationName": "placement"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"Monitoring": {
									"shape": "Sub",
									"locationName": "monitoring"
								}
							}
						},
						"LaunchedAvailabilityZone": {
							"locationName": "launchedAvailabilityZone"
						},
						"ProductDescription": {
							"locationName": "productDescription"
						},
						"SpotInstanceRequestId": {
							"locationName": "spotInstanceRequestId"
						},
						"SpotPrice": {
							"locationName": "spotPrice"
						},
						"State": {
							"locationName": "state"
						},
						"Status": {
							"locationName": "status",
							"type": "structure",
							"members": {
								"Code": {
									"locationName": "code"
								},
								"Message": {
									"locationName": "message"
								},
								"UpdateTime": {
									"locationName": "updateTime",
									"type": "timestamp"
								}
							}
						},
						"Tags": {
							"shape": "Si",
							"locationName": "tagSet"
						},
						"Type": {
							"locationName": "type"
						},
						"ValidFrom": {
							"locationName": "validFrom",
							"type": "timestamp"
						},
						"ValidUntil": {
							"locationName": "validUntil",
							"type": "timestamp"
						},
						"InstanceInterruptionBehavior": {
							"locationName": "instanceInterruptionBehavior"
						}
					}
				}
			},
			"Sub": {
				"type": "structure",
				"required": [
					"Enabled"
				],
				"members": {
					"Enabled": {
						"locationName": "enabled",
						"type": "boolean"
					}
				}
			},
			"Suq": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"IpRanges": {
							"locationName": "ipRanges",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"PrefixListIds": {
							"locationName": "prefixListIds",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"UserIdGroupPairs": {
							"locationName": "groups",
							"type": "list",
							"member": {
								"shape": "S3c",
								"locationName": "item"
							}
						}
					}
				}
			},
			"Svf": {
				"type": "list",
				"member": {}
			},
			"Sw0": {
				"type": "list",
				"member": {
					"locationName": "VolumeId"
				}
			},
			"Swj": {
				"type": "structure",
				"members": {
					"VolumeId": {
						"locationName": "volumeId"
					},
					"ModificationState": {
						"locationName": "modificationState"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"TargetSize": {
						"locationName": "targetSize",
						"type": "integer"
					},
					"TargetIops": {
						"locationName": "targetIops",
						"type": "integer"
					},
					"TargetVolumeType": {
						"locationName": "targetVolumeType"
					},
					"OriginalSize": {
						"locationName": "originalSize",
						"type": "integer"
					},
					"OriginalIops": {
						"locationName": "originalIops",
						"type": "integer"
					},
					"OriginalVolumeType": {
						"locationName": "originalVolumeType"
					},
					"Progress": {
						"locationName": "progress",
						"type": "long"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"EndTime": {
						"locationName": "endTime",
						"type": "timestamp"
					}
				}
			},
			"Swp": {
				"type": "list",
				"member": {
					"locationName": "VpcId"
				}
			},
			"Syc": {
				"type": "structure",
				"members": {
					"TransitGatewayAttachmentId": {
						"locationName": "transitGatewayAttachmentId"
					},
					"ResourceId": {
						"locationName": "resourceId"
					},
					"ResourceType": {
						"locationName": "resourceType"
					},
					"TransitGatewayRouteTableId": {
						"locationName": "transitGatewayRouteTableId"
					},
					"State": {
						"locationName": "state"
					}
				}
			},
			"Szr": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Szt": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"CurrencyCode": {
							"locationName": "currencyCode"
						},
						"Duration": {
							"locationName": "duration",
							"type": "integer"
						},
						"HostIdSet": {
							"shape": "Sm2",
							"locationName": "hostIdSet"
						},
						"HostReservationId": {
							"locationName": "hostReservationId"
						},
						"HourlyPrice": {
							"locationName": "hourlyPrice"
						},
						"InstanceFamily": {
							"locationName": "instanceFamily"
						},
						"PaymentOption": {
							"locationName": "paymentOption"
						},
						"UpfrontPrice": {
							"locationName": "upfrontPrice"
						}
					}
				}
			},
			"S101": {
				"type": "structure",
				"members": {
					"HourlyPrice": {
						"locationName": "hourlyPrice"
					},
					"RemainingTotalValue": {
						"locationName": "remainingTotalValue"
					},
					"RemainingUpfrontValue": {
						"locationName": "remainingUpfrontValue"
					}
				}
			},
			"S10m": {
				"type": "structure",
				"members": {
					"Comment": {},
					"UploadEnd": {
						"type": "timestamp"
					},
					"UploadSize": {
						"type": "double"
					},
					"UploadStart": {
						"type": "timestamp"
					}
				}
			},
			"S10p": {
				"type": "structure",
				"members": {
					"S3Bucket": {},
					"S3Key": {}
				}
			},
			"S10u": {
				"type": "structure",
				"required": [
					"Bytes",
					"Format",
					"ImportManifestUrl"
				],
				"members": {
					"Bytes": {
						"locationName": "bytes",
						"type": "long"
					},
					"Format": {
						"locationName": "format"
					},
					"ImportManifestUrl": {
						"locationName": "importManifestUrl"
					}
				}
			},
			"S10v": {
				"type": "structure",
				"required": [
					"Size"
				],
				"members": {
					"Size": {
						"locationName": "size",
						"type": "long"
					}
				}
			},
			"S11h": {
				"type": "list",
				"member": {
					"locationName": "UserId"
				}
			},
			"S11i": {
				"type": "list",
				"member": {
					"locationName": "UserGroup"
				}
			},
			"S11j": {
				"type": "list",
				"member": {
					"locationName": "ProductCode"
				}
			},
			"S11l": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Group": {},
						"UserId": {}
					}
				}
			},
			"S11q": {
				"type": "list",
				"member": {
					"shape": "Sn",
					"locationName": "item"
				}
			},
			"S121": {
				"type": "structure",
				"members": {
					"CapacityReservationPreference": {},
					"CapacityReservationTarget": {
						"shape": "S8y"
					}
				}
			},
			"S13l": {
				"type": "structure",
				"members": {
					"AllowDnsResolutionFromRemoteVpc": {
						"type": "boolean"
					},
					"AllowEgressFromLocalClassicLinkToRemoteVpc": {
						"type": "boolean"
					},
					"AllowEgressFromLocalVpcToRemoteClassicLink": {
						"type": "boolean"
					}
				}
			},
			"S13n": {
				"type": "structure",
				"members": {
					"AllowDnsResolutionFromRemoteVpc": {
						"locationName": "allowDnsResolutionFromRemoteVpc",
						"type": "boolean"
					},
					"AllowEgressFromLocalClassicLinkToRemoteVpc": {
						"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
						"type": "boolean"
					},
					"AllowEgressFromLocalVpcToRemoteClassicLink": {
						"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
						"type": "boolean"
					}
				}
			},
			"S13v": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Monitoring": {
							"shape": "Soj",
							"locationName": "monitoring"
						}
					}
				}
			},
			"S169": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroupId"
				}
			},
			"S16n": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"CurrentState": {
							"shape": "So5",
							"locationName": "currentState"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"PreviousState": {
							"shape": "So5",
							"locationName": "previousState"
						}
					}
				}
			}
		}
	};

/***/ },
/* 1717 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeAccountAttributes": {
				"result_key": "AccountAttributes"
			},
			"DescribeAddresses": {
				"result_key": "Addresses"
			},
			"DescribeAvailabilityZones": {
				"result_key": "AvailabilityZones"
			},
			"DescribeBundleTasks": {
				"result_key": "BundleTasks"
			},
			"DescribeByoipCidrs": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ByoipCidrs"
			},
			"DescribeCapacityReservations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "CapacityReservations"
			},
			"DescribeClassicLinkInstances": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Instances"
			},
			"DescribeClientVpnAuthorizationRules": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "AuthorizationRules"
			},
			"DescribeClientVpnConnections": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Connections"
			},
			"DescribeClientVpnEndpoints": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ClientVpnEndpoints"
			},
			"DescribeClientVpnRoutes": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Routes"
			},
			"DescribeClientVpnTargetNetworks": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ClientVpnTargetNetworks"
			},
			"DescribeConversionTasks": {
				"result_key": "ConversionTasks"
			},
			"DescribeCustomerGateways": {
				"result_key": "CustomerGateways"
			},
			"DescribeDhcpOptions": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "DhcpOptions"
			},
			"DescribeEgressOnlyInternetGateways": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "EgressOnlyInternetGateways"
			},
			"DescribeExportTasks": {
				"result_key": "ExportTasks"
			},
			"DescribeFleets": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Fleets"
			},
			"DescribeFlowLogs": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "FlowLogs"
			},
			"DescribeFpgaImages": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "FpgaImages"
			},
			"DescribeHostReservationOfferings": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "OfferingSet"
			},
			"DescribeHostReservations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "HostReservationSet"
			},
			"DescribeHosts": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Hosts"
			},
			"DescribeIamInstanceProfileAssociations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "IamInstanceProfileAssociations"
			},
			"DescribeImages": {
				"result_key": "Images"
			},
			"DescribeImportImageTasks": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ImportImageTasks"
			},
			"DescribeImportSnapshotTasks": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ImportSnapshotTasks"
			},
			"DescribeInstanceCreditSpecifications": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "InstanceCreditSpecifications"
			},
			"DescribeInstanceStatus": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "InstanceStatuses"
			},
			"DescribeInstances": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Reservations"
			},
			"DescribeInternetGateways": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "InternetGateways"
			},
			"DescribeKeyPairs": {
				"result_key": "KeyPairs"
			},
			"DescribeLaunchTemplateVersions": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "LaunchTemplateVersions"
			},
			"DescribeLaunchTemplates": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "LaunchTemplates"
			},
			"DescribeMovingAddresses": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "MovingAddressStatuses"
			},
			"DescribeNatGateways": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "NatGateways"
			},
			"DescribeNetworkAcls": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "NetworkAcls"
			},
			"DescribeNetworkInterfacePermissions": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "NetworkInterfacePermissions"
			},
			"DescribeNetworkInterfaces": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "NetworkInterfaces"
			},
			"DescribePlacementGroups": {
				"result_key": "PlacementGroups"
			},
			"DescribePrefixLists": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "PrefixLists"
			},
			"DescribePrincipalIdFormat": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Principals"
			},
			"DescribePublicIpv4Pools": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "PublicIpv4Pools"
			},
			"DescribeRegions": {
				"result_key": "Regions"
			},
			"DescribeReservedInstances": {
				"result_key": "ReservedInstances"
			},
			"DescribeReservedInstancesListings": {
				"result_key": "ReservedInstancesListings"
			},
			"DescribeReservedInstancesModifications": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "ReservedInstancesModifications"
			},
			"DescribeReservedInstancesOfferings": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ReservedInstancesOfferings"
			},
			"DescribeRouteTables": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "RouteTables"
			},
			"DescribeScheduledInstanceAvailability": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ScheduledInstanceAvailabilitySet"
			},
			"DescribeScheduledInstances": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ScheduledInstanceSet"
			},
			"DescribeSecurityGroups": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "SecurityGroups"
			},
			"DescribeSnapshots": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Snapshots"
			},
			"DescribeSpotFleetRequests": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "SpotFleetRequestConfigs"
			},
			"DescribeSpotInstanceRequests": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "SpotInstanceRequests"
			},
			"DescribeSpotPriceHistory": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "SpotPriceHistory"
			},
			"DescribeStaleSecurityGroups": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "StaleSecurityGroupSet"
			},
			"DescribeSubnets": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Subnets"
			},
			"DescribeTags": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Tags"
			},
			"DescribeTrafficMirrorFilters": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TrafficMirrorFilters"
			},
			"DescribeTrafficMirrorSessions": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TrafficMirrorSessions"
			},
			"DescribeTrafficMirrorTargets": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TrafficMirrorTargets"
			},
			"DescribeTransitGatewayAttachments": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TransitGatewayAttachments"
			},
			"DescribeTransitGatewayRouteTables": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TransitGatewayRouteTables"
			},
			"DescribeTransitGatewayVpcAttachments": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TransitGatewayVpcAttachments"
			},
			"DescribeTransitGateways": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TransitGateways"
			},
			"DescribeVolumeStatus": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "VolumeStatuses"
			},
			"DescribeVolumes": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Volumes"
			},
			"DescribeVolumesModifications": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "VolumesModifications"
			},
			"DescribeVpcClassicLinkDnsSupport": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Vpcs"
			},
			"DescribeVpcEndpointConnectionNotifications": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ConnectionNotificationSet"
			},
			"DescribeVpcEndpointConnections": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "VpcEndpointConnections"
			},
			"DescribeVpcEndpointServiceConfigurations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ServiceConfigurations"
			},
			"DescribeVpcEndpointServicePermissions": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "AllowedPrincipals"
			},
			"DescribeVpcEndpoints": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "VpcEndpoints"
			},
			"DescribeVpcPeeringConnections": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "VpcPeeringConnections"
			},
			"DescribeVpcs": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Vpcs"
			},
			"DescribeVpnConnections": {
				"result_key": "VpnConnections"
			},
			"DescribeVpnGateways": {
				"result_key": "VpnGateways"
			},
			"GetTransitGatewayAttachmentPropagations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TransitGatewayAttachmentPropagations"
			},
			"GetTransitGatewayRouteTableAssociations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Associations"
			},
			"GetTransitGatewayRouteTablePropagations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "TransitGatewayRouteTablePropagations"
			}
		}
	};

/***/ },
/* 1718 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"InstanceExists": {
				"delay": 5,
				"maxAttempts": 40,
				"operation": "DescribeInstances",
				"acceptors": [
					{
						"matcher": "path",
						"expected": true,
						"argument": "length(Reservations[]) > `0`",
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstanceID.NotFound",
						"state": "retry"
					}
				]
			},
			"BundleTaskComplete": {
				"delay": 15,
				"operation": "DescribeBundleTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "complete",
						"matcher": "pathAll",
						"state": "success",
						"argument": "BundleTasks[].State"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "BundleTasks[].State"
					}
				]
			},
			"ConversionTaskCancelled": {
				"delay": 15,
				"operation": "DescribeConversionTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "cancelled",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ConversionTasks[].State"
					}
				]
			},
			"ConversionTaskCompleted": {
				"delay": 15,
				"operation": "DescribeConversionTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "completed",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ConversionTasks[].State"
					},
					{
						"expected": "cancelled",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "ConversionTasks[].State"
					},
					{
						"expected": "cancelling",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "ConversionTasks[].State"
					}
				]
			},
			"ConversionTaskDeleted": {
				"delay": 15,
				"operation": "DescribeConversionTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ConversionTasks[].State"
					}
				]
			},
			"CustomerGatewayAvailable": {
				"delay": 15,
				"operation": "DescribeCustomerGateways",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "CustomerGateways[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "CustomerGateways[].State"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "CustomerGateways[].State"
					}
				]
			},
			"ExportTaskCancelled": {
				"delay": 15,
				"operation": "DescribeExportTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "cancelled",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ExportTasks[].State"
					}
				]
			},
			"ExportTaskCompleted": {
				"delay": 15,
				"operation": "DescribeExportTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "completed",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ExportTasks[].State"
					}
				]
			},
			"ImageExists": {
				"operation": "DescribeImages",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"matcher": "path",
						"expected": true,
						"argument": "length(Images[]) > `0`",
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidAMIID.NotFound",
						"state": "retry"
					}
				]
			},
			"ImageAvailable": {
				"operation": "DescribeImages",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "Images[].State",
						"expected": "available"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "Images[].State",
						"expected": "failed"
					}
				]
			},
			"InstanceRunning": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "running",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "shutting-down",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstanceID.NotFound",
						"state": "retry"
					}
				]
			},
			"InstanceStatusOk": {
				"operation": "DescribeInstanceStatus",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "InstanceStatuses[].InstanceStatus.Status",
						"expected": "ok"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstanceID.NotFound",
						"state": "retry"
					}
				]
			},
			"InstanceStopped": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "stopped",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					}
				]
			},
			"InstanceTerminated": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "terminated",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					}
				]
			},
			"KeyPairExists": {
				"operation": "DescribeKeyPairs",
				"delay": 5,
				"maxAttempts": 6,
				"acceptors": [
					{
						"expected": true,
						"matcher": "path",
						"state": "success",
						"argument": "length(KeyPairs[].KeyName) > `0`"
					},
					{
						"expected": "InvalidKeyPair.NotFound",
						"matcher": "error",
						"state": "retry"
					}
				]
			},
			"NatGatewayAvailable": {
				"operation": "DescribeNatGateways",
				"delay": 15,
				"maxAttempts": 40,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "NatGateways[].State",
						"expected": "available"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "NatGateways[].State",
						"expected": "failed"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "NatGateways[].State",
						"expected": "deleting"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "NatGateways[].State",
						"expected": "deleted"
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "NatGatewayNotFound"
					}
				]
			},
			"NetworkInterfaceAvailable": {
				"operation": "DescribeNetworkInterfaces",
				"delay": 20,
				"maxAttempts": 10,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "NetworkInterfaces[].Status"
					},
					{
						"expected": "InvalidNetworkInterfaceID.NotFound",
						"matcher": "error",
						"state": "failure"
					}
				]
			},
			"PasswordDataAvailable": {
				"operation": "GetPasswordData",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "path",
						"argument": "length(PasswordData) > `0`",
						"expected": true
					}
				]
			},
			"SnapshotCompleted": {
				"delay": 15,
				"operation": "DescribeSnapshots",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "completed",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Snapshots[].State"
					}
				]
			},
			"SpotInstanceRequestFulfilled": {
				"operation": "DescribeSpotInstanceRequests",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "fulfilled"
					},
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "request-canceled-and-instance-running"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "schedule-expired"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "canceled-before-fulfillment"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "bad-parameters"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "system-error"
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "InvalidSpotInstanceRequestID.NotFound"
					}
				]
			},
			"SubnetAvailable": {
				"delay": 15,
				"operation": "DescribeSubnets",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Subnets[].State"
					}
				]
			},
			"SystemStatusOk": {
				"operation": "DescribeInstanceStatus",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "InstanceStatuses[].SystemStatus.Status",
						"expected": "ok"
					}
				]
			},
			"VolumeAvailable": {
				"delay": 15,
				"operation": "DescribeVolumes",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Volumes[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Volumes[].State"
					}
				]
			},
			"VolumeDeleted": {
				"delay": 15,
				"operation": "DescribeVolumes",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Volumes[].State"
					},
					{
						"matcher": "error",
						"expected": "InvalidVolume.NotFound",
						"state": "success"
					}
				]
			},
			"VolumeInUse": {
				"delay": 15,
				"operation": "DescribeVolumes",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "in-use",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Volumes[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Volumes[].State"
					}
				]
			},
			"VpcAvailable": {
				"delay": 15,
				"operation": "DescribeVpcs",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Vpcs[].State"
					}
				]
			},
			"VpcExists": {
				"operation": "DescribeVpcs",
				"delay": 1,
				"maxAttempts": 5,
				"acceptors": [
					{
						"matcher": "status",
						"expected": 200,
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidVpcID.NotFound",
						"state": "retry"
					}
				]
			},
			"VpnConnectionAvailable": {
				"delay": 15,
				"operation": "DescribeVpnConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VpnConnections[].State"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "VpnConnections[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "VpnConnections[].State"
					}
				]
			},
			"VpnConnectionDeleted": {
				"delay": 15,
				"operation": "DescribeVpnConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VpnConnections[].State"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "VpnConnections[].State"
					}
				]
			},
			"VpcPeeringConnectionExists": {
				"delay": 15,
				"operation": "DescribeVpcPeeringConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"matcher": "status",
						"expected": 200,
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidVpcPeeringConnectionID.NotFound",
						"state": "retry"
					}
				]
			},
			"VpcPeeringConnectionDeleted": {
				"delay": 15,
				"operation": "DescribeVpcPeeringConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VpcPeeringConnections[].Status.Code"
					},
					{
						"matcher": "error",
						"expected": "InvalidVpcPeeringConnectionID.NotFound",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 1719 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-09-21",
			"endpointPrefix": "api.ecr",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon ECR",
			"serviceFullName": "Amazon EC2 Container Registry",
			"serviceId": "ECR",
			"signatureVersion": "v4",
			"signingName": "ecr",
			"targetPrefix": "AmazonEC2ContainerRegistry_V20150921",
			"uid": "ecr-2015-09-21"
		},
		"operations": {
			"BatchCheckLayerAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"layerDigests"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"layerDigests": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"layers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"layerDigest": {},
									"layerAvailability": {},
									"layerSize": {
										"type": "long"
									},
									"mediaType": {}
								}
							}
						},
						"failures": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"layerDigest": {},
									"failureCode": {},
									"failureReason": {}
								}
							}
						}
					}
				}
			},
			"BatchDeleteImage": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"imageIds"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageIds": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"imageIds": {
							"shape": "Si"
						},
						"failures": {
							"shape": "Sn"
						}
					}
				}
			},
			"BatchGetImage": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"imageIds"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageIds": {
							"shape": "Si"
						},
						"acceptedMediaTypes": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"images": {
							"type": "list",
							"member": {
								"shape": "Sv"
							}
						},
						"failures": {
							"shape": "Sn"
						}
					}
				}
			},
			"CompleteLayerUpload": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"uploadId",
						"layerDigests"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"layerDigests": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"layerDigest": {}
					}
				}
			},
			"CreateRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"tags": {
							"shape": "S12"
						},
						"imageTagMutability": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repository": {
							"shape": "S18"
						}
					}
				}
			},
			"DeleteLifecyclePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"lifecyclePolicyText": {},
						"lastEvaluatedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"DeleteRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repository": {
							"shape": "S18"
						}
					}
				}
			},
			"DeleteRepositoryPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {}
					}
				}
			},
			"DescribeImages": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageIds": {
							"shape": "Si"
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"filter": {
							"type": "structure",
							"members": {
								"tagStatus": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"imageDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"registryId": {},
									"repositoryName": {},
									"imageDigest": {},
									"imageTags": {
										"shape": "S1u"
									},
									"imageSizeInBytes": {
										"type": "long"
									},
									"imagePushedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeRepositories": {
				"input": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryNames": {
							"type": "list",
							"member": {}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositories": {
							"type": "list",
							"member": {
								"shape": "S18"
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetAuthorizationToken": {
				"input": {
					"type": "structure",
					"members": {
						"registryIds": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizationData": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"authorizationToken": {},
									"expiresAt": {
										"type": "timestamp"
									},
									"proxyEndpoint": {}
								}
							}
						}
					}
				}
			},
			"GetDownloadUrlForLayer": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"layerDigest"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"layerDigest": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"downloadUrl": {},
						"layerDigest": {}
					}
				}
			},
			"GetLifecyclePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"lifecyclePolicyText": {},
						"lastEvaluatedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetLifecyclePolicyPreview": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageIds": {
							"shape": "Si"
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"filter": {
							"type": "structure",
							"members": {
								"tagStatus": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"lifecyclePolicyText": {},
						"status": {},
						"nextToken": {},
						"previewResults": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"imageTags": {
										"shape": "S1u"
									},
									"imageDigest": {},
									"imagePushedAt": {
										"type": "timestamp"
									},
									"action": {
										"type": "structure",
										"members": {
											"type": {}
										}
									},
									"appliedRulePriority": {
										"type": "integer"
									}
								}
							}
						},
						"summary": {
							"type": "structure",
							"members": {
								"expiringImageTotalCount": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"GetRepositoryPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {}
					}
				}
			},
			"InitiateLayerUpload": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"uploadId": {},
						"partSize": {
							"type": "long"
						}
					}
				}
			},
			"ListImages": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"filter": {
							"type": "structure",
							"members": {
								"tagStatus": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"imageIds": {
							"shape": "Si"
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "S12"
						}
					}
				}
			},
			"PutImage": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"imageManifest"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageManifest": {},
						"imageTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"image": {
							"shape": "Sv"
						}
					}
				}
			},
			"PutImageTagMutability": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"imageTagMutability"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageTagMutability": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageTagMutability": {}
					}
				}
			},
			"PutLifecyclePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"lifecyclePolicyText"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"lifecyclePolicyText": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"lifecyclePolicyText": {}
					}
				}
			},
			"SetRepositoryPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"policyText"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {}
					}
				}
			},
			"StartLifecyclePolicyPreview": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"lifecyclePolicyText": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"lifecyclePolicyText": {},
						"status": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {},
						"tagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UploadLayerPart": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"uploadId",
						"partFirstByte",
						"partLastByte",
						"layerPartBlob"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"partFirstByte": {
							"type": "long"
						},
						"partLastByte": {
							"type": "long"
						},
						"layerPartBlob": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"lastByteReceived": {
							"type": "long"
						}
					}
				}
			}
		},
		"shapes": {
			"Si": {
				"type": "list",
				"member": {
					"shape": "Sj"
				}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"imageDigest": {},
					"imageTag": {}
				}
			},
			"Sn": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"imageId": {
							"shape": "Sj"
						},
						"failureCode": {},
						"failureReason": {}
					}
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryName": {},
					"imageId": {
						"shape": "Sj"
					},
					"imageManifest": {}
				}
			},
			"S12": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S18": {
				"type": "structure",
				"members": {
					"repositoryArn": {},
					"registryId": {},
					"repositoryName": {},
					"repositoryUri": {},
					"createdAt": {
						"type": "timestamp"
					},
					"imageTagMutability": {}
				}
			},
			"S1u": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1720 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeImages": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "imageDetails"
			},
			"DescribeRepositories": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "repositories"
			},
			"ListImages": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "imageIds"
			}
		}
	};

/***/ },
/* 1721 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-13",
			"endpointPrefix": "ecs",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon ECS",
			"serviceFullName": "Amazon EC2 Container Service",
			"serviceId": "ECS",
			"signatureVersion": "v4",
			"targetPrefix": "AmazonEC2ContainerServiceV20141113",
			"uid": "ecs-2014-11-13"
		},
		"operations": {
			"CreateCluster": {
				"input": {
					"type": "structure",
					"members": {
						"clusterName": {},
						"tags": {
							"shape": "S3"
						},
						"settings": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"cluster": {
							"shape": "Sb"
						}
					}
				}
			},
			"CreateService": {
				"input": {
					"type": "structure",
					"required": [
						"serviceName"
					],
					"members": {
						"cluster": {},
						"serviceName": {},
						"taskDefinition": {},
						"loadBalancers": {
							"shape": "Sg"
						},
						"serviceRegistries": {
							"shape": "Sj"
						},
						"desiredCount": {
							"type": "integer"
						},
						"clientToken": {},
						"launchType": {},
						"platformVersion": {},
						"role": {},
						"deploymentConfiguration": {
							"shape": "Sm"
						},
						"placementConstraints": {
							"shape": "Sn"
						},
						"placementStrategy": {
							"shape": "Sq"
						},
						"networkConfiguration": {
							"shape": "St"
						},
						"healthCheckGracePeriodSeconds": {
							"type": "integer"
						},
						"schedulingStrategy": {},
						"deploymentController": {
							"shape": "Sy"
						},
						"tags": {
							"shape": "S3"
						},
						"enableECSManagedTags": {
							"type": "boolean"
						},
						"propagateTags": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"service": {
							"shape": "S13"
						}
					}
				}
			},
			"CreateTaskSet": {
				"input": {
					"type": "structure",
					"required": [
						"service",
						"cluster",
						"taskDefinition"
					],
					"members": {
						"service": {},
						"cluster": {},
						"externalId": {},
						"taskDefinition": {},
						"networkConfiguration": {
							"shape": "St"
						},
						"loadBalancers": {
							"shape": "Sg"
						},
						"serviceRegistries": {
							"shape": "Sj"
						},
						"launchType": {},
						"platformVersion": {},
						"scale": {
							"shape": "S17"
						},
						"clientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskSet": {
							"shape": "S15"
						}
					}
				}
			},
			"DeleteAccountSetting": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"principalArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"setting": {
							"shape": "S1k"
						}
					}
				}
			},
			"DeleteAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"attributes"
					],
					"members": {
						"cluster": {},
						"attributes": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "S1m"
						}
					}
				}
			},
			"DeleteCluster": {
				"input": {
					"type": "structure",
					"required": [
						"cluster"
					],
					"members": {
						"cluster": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"cluster": {
							"shape": "Sb"
						}
					}
				}
			},
			"DeleteService": {
				"input": {
					"type": "structure",
					"required": [
						"service"
					],
					"members": {
						"cluster": {},
						"service": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"service": {
							"shape": "S13"
						}
					}
				}
			},
			"DeleteTaskSet": {
				"input": {
					"type": "structure",
					"required": [
						"cluster",
						"service",
						"taskSet"
					],
					"members": {
						"cluster": {},
						"service": {},
						"taskSet": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskSet": {
							"shape": "S15"
						}
					}
				}
			},
			"DeregisterContainerInstance": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstance"
					],
					"members": {
						"cluster": {},
						"containerInstance": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstance": {
							"shape": "S1z"
						}
					}
				}
			},
			"DeregisterTaskDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition"
					],
					"members": {
						"taskDefinition": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinition": {
							"shape": "S2a"
						}
					}
				}
			},
			"DescribeClusters": {
				"input": {
					"type": "structure",
					"members": {
						"clusters": {
							"shape": "Sv"
						},
						"include": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"clusters": {
							"type": "list",
							"member": {
								"shape": "Sb"
							}
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"DescribeContainerInstances": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstances"
					],
					"members": {
						"cluster": {},
						"containerInstances": {
							"shape": "Sv"
						},
						"include": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstances": {
							"shape": "S48"
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"DescribeServices": {
				"input": {
					"type": "structure",
					"required": [
						"services"
					],
					"members": {
						"cluster": {},
						"services": {
							"shape": "Sv"
						},
						"include": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"services": {
							"type": "list",
							"member": {
								"shape": "S13"
							}
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"DescribeTaskDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition"
					],
					"members": {
						"taskDefinition": {},
						"include": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinition": {
							"shape": "S2a"
						},
						"tags": {
							"shape": "S3"
						}
					}
				}
			},
			"DescribeTaskSets": {
				"input": {
					"type": "structure",
					"required": [
						"cluster",
						"service"
					],
					"members": {
						"cluster": {},
						"service": {},
						"taskSets": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskSets": {
							"shape": "S14"
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"DescribeTasks": {
				"input": {
					"type": "structure",
					"required": [
						"tasks"
					],
					"members": {
						"cluster": {},
						"tasks": {
							"shape": "Sv"
						},
						"include": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"shape": "S4o"
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"DiscoverPollEndpoint": {
				"input": {
					"type": "structure",
					"members": {
						"containerInstance": {},
						"cluster": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"endpoint": {},
						"telemetryEndpoint": {}
					}
				}
			},
			"ListAccountSettings": {
				"input": {
					"type": "structure",
					"members": {
						"name": {},
						"value": {},
						"principalArn": {},
						"effectiveSettings": {
							"type": "boolean"
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"settings": {
							"type": "list",
							"member": {
								"shape": "S1k"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"targetType"
					],
					"members": {
						"cluster": {},
						"targetType": {},
						"attributeName": {},
						"attributeValue": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "S1m"
						},
						"nextToken": {}
					}
				}
			},
			"ListClusters": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"clusterArns": {
							"shape": "Sv"
						},
						"nextToken": {}
					}
				}
			},
			"ListContainerInstances": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"filter": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstanceArns": {
							"shape": "Sv"
						},
						"nextToken": {}
					}
				}
			},
			"ListServices": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"launchType": {},
						"schedulingStrategy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"serviceArns": {
							"shape": "Sv"
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "S3"
						}
					}
				}
			},
			"ListTaskDefinitionFamilies": {
				"input": {
					"type": "structure",
					"members": {
						"familyPrefix": {},
						"status": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"families": {
							"shape": "Sv"
						},
						"nextToken": {}
					}
				}
			},
			"ListTaskDefinitions": {
				"input": {
					"type": "structure",
					"members": {
						"familyPrefix": {},
						"status": {},
						"sort": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinitionArns": {
							"shape": "Sv"
						},
						"nextToken": {}
					}
				}
			},
			"ListTasks": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"containerInstance": {},
						"family": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"startedBy": {},
						"serviceName": {},
						"desiredStatus": {},
						"launchType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskArns": {
							"shape": "Sv"
						},
						"nextToken": {}
					}
				}
			},
			"PutAccountSetting": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"value"
					],
					"members": {
						"name": {},
						"value": {},
						"principalArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"setting": {
							"shape": "S1k"
						}
					}
				}
			},
			"PutAccountSettingDefault": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"value"
					],
					"members": {
						"name": {},
						"value": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"setting": {
							"shape": "S1k"
						}
					}
				}
			},
			"PutAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"attributes"
					],
					"members": {
						"cluster": {},
						"attributes": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "S1m"
						}
					}
				}
			},
			"RegisterContainerInstance": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"instanceIdentityDocument": {},
						"instanceIdentityDocumentSignature": {},
						"totalResources": {
							"shape": "S22"
						},
						"versionInfo": {
							"shape": "S21"
						},
						"containerInstanceArn": {},
						"attributes": {
							"shape": "S1m"
						},
						"platformDevices": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"id",
									"type"
								],
								"members": {
									"id": {},
									"type": {}
								}
							}
						},
						"tags": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstance": {
							"shape": "S1z"
						}
					}
				}
			},
			"RegisterTaskDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"family",
						"containerDefinitions"
					],
					"members": {
						"family": {},
						"taskRoleArn": {},
						"executionRoleArn": {},
						"networkMode": {},
						"containerDefinitions": {
							"shape": "S2b"
						},
						"volumes": {
							"shape": "S3f"
						},
						"placementConstraints": {
							"shape": "S3n"
						},
						"requiresCompatibilities": {
							"shape": "S3q"
						},
						"cpu": {},
						"memory": {},
						"tags": {
							"shape": "S3"
						},
						"pidMode": {},
						"ipcMode": {},
						"proxyConfiguration": {
							"shape": "S3u"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinition": {
							"shape": "S2a"
						},
						"tags": {
							"shape": "S3"
						}
					}
				}
			},
			"RunTask": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition"
					],
					"members": {
						"cluster": {},
						"taskDefinition": {},
						"overrides": {
							"shape": "S4q"
						},
						"count": {
							"type": "integer"
						},
						"startedBy": {},
						"group": {},
						"placementConstraints": {
							"shape": "Sn"
						},
						"placementStrategy": {
							"shape": "Sq"
						},
						"launchType": {},
						"platformVersion": {},
						"networkConfiguration": {
							"shape": "St"
						},
						"tags": {
							"shape": "S3"
						},
						"enableECSManagedTags": {
							"type": "boolean"
						},
						"propagateTags": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"shape": "S4o"
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"StartTask": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition",
						"containerInstances"
					],
					"members": {
						"cluster": {},
						"taskDefinition": {},
						"overrides": {
							"shape": "S4q"
						},
						"containerInstances": {
							"shape": "Sv"
						},
						"startedBy": {},
						"group": {},
						"networkConfiguration": {
							"shape": "St"
						},
						"tags": {
							"shape": "S3"
						},
						"enableECSManagedTags": {
							"type": "boolean"
						},
						"propagateTags": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"shape": "S4o"
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"StopTask": {
				"input": {
					"type": "structure",
					"required": [
						"task"
					],
					"members": {
						"cluster": {},
						"task": {},
						"reason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"task": {
							"shape": "S4p"
						}
					}
				}
			},
			"SubmitAttachmentStateChanges": {
				"input": {
					"type": "structure",
					"required": [
						"attachments"
					],
					"members": {
						"cluster": {},
						"attachments": {
							"shape": "S6c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"acknowledgment": {}
					}
				}
			},
			"SubmitContainerStateChange": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"task": {},
						"containerName": {},
						"status": {},
						"exitCode": {
							"type": "integer"
						},
						"reason": {},
						"networkBindings": {
							"shape": "S4v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"acknowledgment": {}
					}
				}
			},
			"SubmitTaskStateChange": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"task": {},
						"status": {},
						"reason": {},
						"containers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"containerName": {},
									"exitCode": {
										"type": "integer"
									},
									"networkBindings": {
										"shape": "S4v"
									},
									"reason": {},
									"status": {}
								}
							}
						},
						"attachments": {
							"shape": "S6c"
						},
						"pullStartedAt": {
							"type": "timestamp"
						},
						"pullStoppedAt": {
							"type": "timestamp"
						},
						"executionStoppedAt": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"acknowledgment": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {},
						"tagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateContainerAgent": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstance"
					],
					"members": {
						"cluster": {},
						"containerInstance": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstance": {
							"shape": "S1z"
						}
					}
				}
			},
			"UpdateContainerInstancesState": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstances",
						"status"
					],
					"members": {
						"cluster": {},
						"containerInstances": {
							"shape": "Sv"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstances": {
							"shape": "S48"
						},
						"failures": {
							"shape": "S42"
						}
					}
				}
			},
			"UpdateService": {
				"input": {
					"type": "structure",
					"required": [
						"service"
					],
					"members": {
						"cluster": {},
						"service": {},
						"desiredCount": {
							"type": "integer"
						},
						"taskDefinition": {},
						"deploymentConfiguration": {
							"shape": "Sm"
						},
						"networkConfiguration": {
							"shape": "St"
						},
						"platformVersion": {},
						"forceNewDeployment": {
							"type": "boolean"
						},
						"healthCheckGracePeriodSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"service": {
							"shape": "S13"
						}
					}
				}
			},
			"UpdateServicePrimaryTaskSet": {
				"input": {
					"type": "structure",
					"required": [
						"cluster",
						"service",
						"primaryTaskSet"
					],
					"members": {
						"cluster": {},
						"service": {},
						"primaryTaskSet": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskSet": {
							"shape": "S15"
						}
					}
				}
			},
			"UpdateTaskSet": {
				"input": {
					"type": "structure",
					"required": [
						"cluster",
						"service",
						"taskSet",
						"scale"
					],
					"members": {
						"cluster": {},
						"service": {},
						"taskSet": {},
						"scale": {
							"shape": "S17"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskSet": {
							"shape": "S15"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"S7": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"value": {}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"clusterArn": {},
					"clusterName": {},
					"status": {},
					"registeredContainerInstancesCount": {
						"type": "integer"
					},
					"runningTasksCount": {
						"type": "integer"
					},
					"pendingTasksCount": {
						"type": "integer"
					},
					"activeServicesCount": {
						"type": "integer"
					},
					"statistics": {
						"type": "list",
						"member": {
							"shape": "Se"
						}
					},
					"tags": {
						"shape": "S3"
					},
					"settings": {
						"shape": "S7"
					}
				}
			},
			"Se": {
				"type": "structure",
				"members": {
					"name": {},
					"value": {}
				}
			},
			"Sg": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"targetGroupArn": {},
						"loadBalancerName": {},
						"containerName": {},
						"containerPort": {
							"type": "integer"
						}
					}
				}
			},
			"Sj": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"registryArn": {},
						"port": {
							"type": "integer"
						},
						"containerName": {},
						"containerPort": {
							"type": "integer"
						}
					}
				}
			},
			"Sm": {
				"type": "structure",
				"members": {
					"maximumPercent": {
						"type": "integer"
					},
					"minimumHealthyPercent": {
						"type": "integer"
					}
				}
			},
			"Sn": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"type": {},
						"expression": {}
					}
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"type": {},
						"field": {}
					}
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"awsvpcConfiguration": {
						"type": "structure",
						"required": [
							"subnets"
						],
						"members": {
							"subnets": {
								"shape": "Sv"
							},
							"securityGroups": {
								"shape": "Sv"
							},
							"assignPublicIp": {}
						}
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {}
				}
			},
			"S13": {
				"type": "structure",
				"members": {
					"serviceArn": {},
					"serviceName": {},
					"clusterArn": {},
					"loadBalancers": {
						"shape": "Sg"
					},
					"serviceRegistries": {
						"shape": "Sj"
					},
					"status": {},
					"desiredCount": {
						"type": "integer"
					},
					"runningCount": {
						"type": "integer"
					},
					"pendingCount": {
						"type": "integer"
					},
					"launchType": {},
					"platformVersion": {},
					"taskDefinition": {},
					"deploymentConfiguration": {
						"shape": "Sm"
					},
					"taskSets": {
						"shape": "S14"
					},
					"deployments": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"id": {},
								"status": {},
								"taskDefinition": {},
								"desiredCount": {
									"type": "integer"
								},
								"pendingCount": {
									"type": "integer"
								},
								"runningCount": {
									"type": "integer"
								},
								"createdAt": {
									"type": "timestamp"
								},
								"updatedAt": {
									"type": "timestamp"
								},
								"launchType": {},
								"platformVersion": {},
								"networkConfiguration": {
									"shape": "St"
								}
							}
						}
					},
					"roleArn": {},
					"events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"id": {},
								"createdAt": {
									"type": "timestamp"
								},
								"message": {}
							}
						}
					},
					"createdAt": {
						"type": "timestamp"
					},
					"placementConstraints": {
						"shape": "Sn"
					},
					"placementStrategy": {
						"shape": "Sq"
					},
					"networkConfiguration": {
						"shape": "St"
					},
					"healthCheckGracePeriodSeconds": {
						"type": "integer"
					},
					"schedulingStrategy": {},
					"deploymentController": {
						"shape": "Sy"
					},
					"tags": {
						"shape": "S3"
					},
					"createdBy": {},
					"enableECSManagedTags": {
						"type": "boolean"
					},
					"propagateTags": {}
				}
			},
			"S14": {
				"type": "list",
				"member": {
					"shape": "S15"
				}
			},
			"S15": {
				"type": "structure",
				"members": {
					"id": {},
					"taskSetArn": {},
					"serviceArn": {},
					"clusterArn": {},
					"startedBy": {},
					"externalId": {},
					"status": {},
					"taskDefinition": {},
					"computedDesiredCount": {
						"type": "integer"
					},
					"pendingCount": {
						"type": "integer"
					},
					"runningCount": {
						"type": "integer"
					},
					"createdAt": {
						"type": "timestamp"
					},
					"updatedAt": {
						"type": "timestamp"
					},
					"launchType": {},
					"platformVersion": {},
					"networkConfiguration": {
						"shape": "St"
					},
					"loadBalancers": {
						"shape": "Sg"
					},
					"serviceRegistries": {
						"shape": "Sj"
					},
					"scale": {
						"shape": "S17"
					},
					"stabilityStatus": {},
					"stabilityStatusAt": {
						"type": "timestamp"
					}
				}
			},
			"S17": {
				"type": "structure",
				"members": {
					"value": {
						"type": "double"
					},
					"unit": {}
				}
			},
			"S1k": {
				"type": "structure",
				"members": {
					"name": {},
					"value": {},
					"principalArn": {}
				}
			},
			"S1m": {
				"type": "list",
				"member": {
					"shape": "S1n"
				}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"value": {},
					"targetType": {},
					"targetId": {}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"containerInstanceArn": {},
					"ec2InstanceId": {},
					"version": {
						"type": "long"
					},
					"versionInfo": {
						"shape": "S21"
					},
					"remainingResources": {
						"shape": "S22"
					},
					"registeredResources": {
						"shape": "S22"
					},
					"status": {},
					"statusReason": {},
					"agentConnected": {
						"type": "boolean"
					},
					"runningTasksCount": {
						"type": "integer"
					},
					"pendingTasksCount": {
						"type": "integer"
					},
					"agentUpdateStatus": {},
					"attributes": {
						"shape": "S1m"
					},
					"registeredAt": {
						"type": "timestamp"
					},
					"attachments": {
						"shape": "S25"
					},
					"tags": {
						"shape": "S3"
					}
				}
			},
			"S21": {
				"type": "structure",
				"members": {
					"agentVersion": {},
					"agentHash": {},
					"dockerVersion": {}
				}
			},
			"S22": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"type": {},
						"doubleValue": {
							"type": "double"
						},
						"longValue": {
							"type": "long"
						},
						"integerValue": {
							"type": "integer"
						},
						"stringSetValue": {
							"shape": "Sv"
						}
					}
				}
			},
			"S25": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"id": {},
						"type": {},
						"status": {},
						"details": {
							"type": "list",
							"member": {
								"shape": "Se"
							}
						}
					}
				}
			},
			"S2a": {
				"type": "structure",
				"members": {
					"taskDefinitionArn": {},
					"containerDefinitions": {
						"shape": "S2b"
					},
					"family": {},
					"taskRoleArn": {},
					"executionRoleArn": {},
					"networkMode": {},
					"revision": {
						"type": "integer"
					},
					"volumes": {
						"shape": "S3f"
					},
					"status": {},
					"requiresAttributes": {
						"type": "list",
						"member": {
							"shape": "S1n"
						}
					},
					"placementConstraints": {
						"shape": "S3n"
					},
					"compatibilities": {
						"shape": "S3q"
					},
					"requiresCompatibilities": {
						"shape": "S3q"
					},
					"cpu": {},
					"memory": {},
					"pidMode": {},
					"ipcMode": {},
					"proxyConfiguration": {
						"shape": "S3u"
					}
				}
			},
			"S2b": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"image": {},
						"repositoryCredentials": {
							"type": "structure",
							"required": [
								"credentialsParameter"
							],
							"members": {
								"credentialsParameter": {}
							}
						},
						"cpu": {
							"type": "integer"
						},
						"memory": {
							"type": "integer"
						},
						"memoryReservation": {
							"type": "integer"
						},
						"links": {
							"shape": "Sv"
						},
						"portMappings": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"containerPort": {
										"type": "integer"
									},
									"hostPort": {
										"type": "integer"
									},
									"protocol": {}
								}
							}
						},
						"essential": {
							"type": "boolean"
						},
						"entryPoint": {
							"shape": "Sv"
						},
						"command": {
							"shape": "Sv"
						},
						"environment": {
							"shape": "S2h"
						},
						"mountPoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"sourceVolume": {},
									"containerPath": {},
									"readOnly": {
										"type": "boolean"
									}
								}
							}
						},
						"volumesFrom": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"sourceContainer": {},
									"readOnly": {
										"type": "boolean"
									}
								}
							}
						},
						"linuxParameters": {
							"type": "structure",
							"members": {
								"capabilities": {
									"type": "structure",
									"members": {
										"add": {
											"shape": "Sv"
										},
										"drop": {
											"shape": "Sv"
										}
									}
								},
								"devices": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"hostPath"
										],
										"members": {
											"hostPath": {},
											"containerPath": {},
											"permissions": {
												"type": "list",
												"member": {}
											}
										}
									}
								},
								"initProcessEnabled": {
									"type": "boolean"
								},
								"sharedMemorySize": {
									"type": "integer"
								},
								"tmpfs": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"containerPath",
											"size"
										],
										"members": {
											"containerPath": {},
											"size": {
												"type": "integer"
											},
											"mountOptions": {
												"shape": "Sv"
											}
										}
									}
								}
							}
						},
						"secrets": {
							"shape": "S2u"
						},
						"dependsOn": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"containerName",
									"condition"
								],
								"members": {
									"containerName": {},
									"condition": {}
								}
							}
						},
						"startTimeout": {
							"type": "integer"
						},
						"stopTimeout": {
							"type": "integer"
						},
						"hostname": {},
						"user": {},
						"workingDirectory": {},
						"disableNetworking": {
							"type": "boolean"
						},
						"privileged": {
							"type": "boolean"
						},
						"readonlyRootFilesystem": {
							"type": "boolean"
						},
						"dnsServers": {
							"shape": "Sv"
						},
						"dnsSearchDomains": {
							"shape": "Sv"
						},
						"extraHosts": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"hostname",
									"ipAddress"
								],
								"members": {
									"hostname": {},
									"ipAddress": {}
								}
							}
						},
						"dockerSecurityOptions": {
							"shape": "Sv"
						},
						"interactive": {
							"type": "boolean"
						},
						"pseudoTerminal": {
							"type": "boolean"
						},
						"dockerLabels": {
							"type": "map",
							"key": {},
							"value": {}
						},
						"ulimits": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"name",
									"softLimit",
									"hardLimit"
								],
								"members": {
									"name": {},
									"softLimit": {
										"type": "integer"
									},
									"hardLimit": {
										"type": "integer"
									}
								}
							}
						},
						"logConfiguration": {
							"type": "structure",
							"required": [
								"logDriver"
							],
							"members": {
								"logDriver": {},
								"options": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"secretOptions": {
									"shape": "S2u"
								}
							}
						},
						"healthCheck": {
							"type": "structure",
							"required": [
								"command"
							],
							"members": {
								"command": {
									"shape": "Sv"
								},
								"interval": {
									"type": "integer"
								},
								"timeout": {
									"type": "integer"
								},
								"retries": {
									"type": "integer"
								},
								"startPeriod": {
									"type": "integer"
								}
							}
						},
						"systemControls": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"namespace": {},
									"value": {}
								}
							}
						},
						"resourceRequirements": {
							"shape": "S3b"
						}
					}
				}
			},
			"S2h": {
				"type": "list",
				"member": {
					"shape": "Se"
				}
			},
			"S2u": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"name",
						"valueFrom"
					],
					"members": {
						"name": {},
						"valueFrom": {}
					}
				}
			},
			"S3b": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"value",
						"type"
					],
					"members": {
						"value": {},
						"type": {}
					}
				}
			},
			"S3f": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"host": {
							"type": "structure",
							"members": {
								"sourcePath": {}
							}
						},
						"dockerVolumeConfiguration": {
							"type": "structure",
							"members": {
								"scope": {},
								"autoprovision": {
									"type": "boolean"
								},
								"driver": {},
								"driverOpts": {
									"shape": "S3k"
								},
								"labels": {
									"shape": "S3k"
								}
							}
						}
					}
				}
			},
			"S3k": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S3n": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"type": {},
						"expression": {}
					}
				}
			},
			"S3q": {
				"type": "list",
				"member": {}
			},
			"S3u": {
				"type": "structure",
				"required": [
					"containerName"
				],
				"members": {
					"type": {},
					"containerName": {},
					"properties": {
						"type": "list",
						"member": {
							"shape": "Se"
						}
					}
				}
			},
			"S42": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"arn": {},
						"reason": {}
					}
				}
			},
			"S48": {
				"type": "list",
				"member": {
					"shape": "S1z"
				}
			},
			"S4o": {
				"type": "list",
				"member": {
					"shape": "S4p"
				}
			},
			"S4p": {
				"type": "structure",
				"members": {
					"taskArn": {},
					"clusterArn": {},
					"taskDefinitionArn": {},
					"containerInstanceArn": {},
					"overrides": {
						"shape": "S4q"
					},
					"lastStatus": {},
					"desiredStatus": {},
					"cpu": {},
					"memory": {},
					"containers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"containerArn": {},
								"taskArn": {},
								"name": {},
								"lastStatus": {},
								"exitCode": {
									"type": "integer"
								},
								"reason": {},
								"networkBindings": {
									"shape": "S4v"
								},
								"networkInterfaces": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"attachmentId": {},
											"privateIpv4Address": {},
											"ipv6Address": {}
										}
									}
								},
								"healthStatus": {},
								"cpu": {},
								"memory": {},
								"memoryReservation": {},
								"gpuIds": {
									"type": "list",
									"member": {}
								}
							}
						}
					},
					"startedBy": {},
					"version": {
						"type": "long"
					},
					"stoppedReason": {},
					"stopCode": {},
					"connectivity": {},
					"connectivityAt": {
						"type": "timestamp"
					},
					"pullStartedAt": {
						"type": "timestamp"
					},
					"pullStoppedAt": {
						"type": "timestamp"
					},
					"executionStoppedAt": {
						"type": "timestamp"
					},
					"createdAt": {
						"type": "timestamp"
					},
					"startedAt": {
						"type": "timestamp"
					},
					"stoppingAt": {
						"type": "timestamp"
					},
					"stoppedAt": {
						"type": "timestamp"
					},
					"group": {},
					"launchType": {},
					"platformVersion": {},
					"attachments": {
						"shape": "S25"
					},
					"healthStatus": {},
					"tags": {
						"shape": "S3"
					}
				}
			},
			"S4q": {
				"type": "structure",
				"members": {
					"containerOverrides": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {},
								"command": {
									"shape": "Sv"
								},
								"environment": {
									"shape": "S2h"
								},
								"cpu": {
									"type": "integer"
								},
								"memory": {
									"type": "integer"
								},
								"memoryReservation": {
									"type": "integer"
								},
								"resourceRequirements": {
									"shape": "S3b"
								}
							}
						}
					},
					"taskRoleArn": {},
					"executionRoleArn": {}
				}
			},
			"S4v": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"bindIP": {},
						"containerPort": {
							"type": "integer"
						},
						"hostPort": {
							"type": "integer"
						},
						"protocol": {}
					}
				}
			},
			"S6c": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"attachmentArn",
						"status"
					],
					"members": {
						"attachmentArn": {},
						"status": {}
					}
				}
			}
		}
	};

/***/ },
/* 1722 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListClusters": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "clusterArns"
			},
			"ListContainerInstances": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "containerInstanceArns"
			},
			"ListServices": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "serviceArns"
			},
			"ListTaskDefinitionFamilies": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "families"
			},
			"ListTaskDefinitions": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "taskDefinitionArns"
			},
			"ListTasks": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "taskArns"
			}
		}
	};

/***/ },
/* 1723 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"TasksRunning": {
				"delay": 6,
				"operation": "DescribeTasks",
				"maxAttempts": 100,
				"acceptors": [
					{
						"expected": "STOPPED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "tasks[].lastStatus"
					},
					{
						"expected": "MISSING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "failures[].reason"
					},
					{
						"expected": "RUNNING",
						"matcher": "pathAll",
						"state": "success",
						"argument": "tasks[].lastStatus"
					}
				]
			},
			"TasksStopped": {
				"delay": 6,
				"operation": "DescribeTasks",
				"maxAttempts": 100,
				"acceptors": [
					{
						"expected": "STOPPED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "tasks[].lastStatus"
					}
				]
			},
			"ServicesStable": {
				"delay": 15,
				"operation": "DescribeServices",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "MISSING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "failures[].reason"
					},
					{
						"expected": "DRAINING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "services[].status"
					},
					{
						"expected": "INACTIVE",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "services[].status"
					},
					{
						"expected": true,
						"matcher": "path",
						"state": "success",
						"argument": "length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"
					}
				]
			},
			"ServicesInactive": {
				"delay": 15,
				"operation": "DescribeServices",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "MISSING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "failures[].reason"
					},
					{
						"expected": "INACTIVE",
						"matcher": "pathAny",
						"state": "success",
						"argument": "services[].status"
					}
				]
			}
		}
	};

/***/ },
/* 1724 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-02-02",
			"endpointPrefix": "elasticache",
			"protocol": "query",
			"serviceFullName": "Amazon ElastiCache",
			"serviceId": "ElastiCache",
			"signatureVersion": "v4",
			"uid": "elasticache-2015-02-02",
			"xmlNamespace": "http://elasticache.amazonaws.com/doc/2015-02-02/"
		},
		"operations": {
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"shape": "S5",
					"resultWrapper": "AddTagsToResourceResult"
				}
			},
			"AuthorizeCacheSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName",
						"EC2SecurityGroupName",
						"EC2SecurityGroupOwnerId"
					],
					"members": {
						"CacheSecurityGroupName": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeCacheSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"CacheSecurityGroup": {
							"shape": "S8"
						}
					}
				}
			},
			"BatchApplyUpdateAction": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupIds",
						"ServiceUpdateName"
					],
					"members": {
						"ReplicationGroupIds": {
							"shape": "Sc"
						},
						"ServiceUpdateName": {}
					}
				},
				"output": {
					"shape": "Sd",
					"resultWrapper": "BatchApplyUpdateActionResult"
				}
			},
			"BatchStopUpdateAction": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupIds",
						"ServiceUpdateName"
					],
					"members": {
						"ReplicationGroupIds": {
							"shape": "Sc"
						},
						"ServiceUpdateName": {}
					}
				},
				"output": {
					"shape": "Sd",
					"resultWrapper": "BatchStopUpdateActionResult"
				}
			},
			"CopySnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceSnapshotName",
						"TargetSnapshotName"
					],
					"members": {
						"SourceSnapshotName": {},
						"TargetSnapshotName": {},
						"TargetBucket": {}
					}
				},
				"output": {
					"resultWrapper": "CopySnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"CreateCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId"
					],
					"members": {
						"CacheClusterId": {},
						"ReplicationGroupId": {},
						"AZMode": {},
						"PreferredAvailabilityZone": {},
						"PreferredAvailabilityZones": {
							"shape": "Sy"
						},
						"NumCacheNodes": {
							"type": "integer"
						},
						"CacheNodeType": {},
						"Engine": {},
						"EngineVersion": {},
						"CacheParameterGroupName": {},
						"CacheSubnetGroupName": {},
						"CacheSecurityGroupNames": {
							"shape": "Sz"
						},
						"SecurityGroupIds": {
							"shape": "S10"
						},
						"Tags": {
							"shape": "S3"
						},
						"SnapshotArns": {
							"shape": "S11"
						},
						"SnapshotName": {},
						"PreferredMaintenanceWindow": {},
						"Port": {
							"type": "integer"
						},
						"NotificationTopicArn": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"AuthToken": {}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "S14"
						}
					}
				}
			},
			"CreateCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName",
						"CacheParameterGroupFamily",
						"Description"
					],
					"members": {
						"CacheParameterGroupName": {},
						"CacheParameterGroupFamily": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheParameterGroupResult",
					"type": "structure",
					"members": {
						"CacheParameterGroup": {
							"shape": "S1j"
						}
					}
				}
			},
			"CreateCacheSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName",
						"Description"
					],
					"members": {
						"CacheSecurityGroupName": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheSecurityGroupResult",
					"type": "structure",
					"members": {
						"CacheSecurityGroup": {
							"shape": "S8"
						}
					}
				}
			},
			"CreateCacheSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSubnetGroupName",
						"CacheSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"CacheSubnetGroupName": {},
						"CacheSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1n"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheSubnetGroupResult",
					"type": "structure",
					"members": {
						"CacheSubnetGroup": {
							"shape": "S1p"
						}
					}
				}
			},
			"CreateReplicationGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId",
						"ReplicationGroupDescription"
					],
					"members": {
						"ReplicationGroupId": {},
						"ReplicationGroupDescription": {},
						"PrimaryClusterId": {},
						"AutomaticFailoverEnabled": {
							"type": "boolean"
						},
						"NumCacheClusters": {
							"type": "integer"
						},
						"PreferredCacheClusterAZs": {
							"shape": "Sv"
						},
						"NumNodeGroups": {
							"type": "integer"
						},
						"ReplicasPerNodeGroup": {
							"type": "integer"
						},
						"NodeGroupConfiguration": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "NodeGroupConfiguration"
							}
						},
						"CacheNodeType": {},
						"Engine": {},
						"EngineVersion": {},
						"CacheParameterGroupName": {},
						"CacheSubnetGroupName": {},
						"CacheSecurityGroupNames": {
							"shape": "Sz"
						},
						"SecurityGroupIds": {
							"shape": "S10"
						},
						"Tags": {
							"shape": "S3"
						},
						"SnapshotArns": {
							"shape": "S11"
						},
						"SnapshotName": {},
						"PreferredMaintenanceWindow": {},
						"Port": {
							"type": "integer"
						},
						"NotificationTopicArn": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"AuthToken": {},
						"TransitEncryptionEnabled": {
							"type": "boolean"
						},
						"AtRestEncryptionEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateReplicationGroupResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1w"
						}
					}
				}
			},
			"CreateSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotName"
					],
					"members": {
						"ReplicationGroupId": {},
						"CacheClusterId": {},
						"SnapshotName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"DecreaseReplicaCount": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId",
						"ApplyImmediately"
					],
					"members": {
						"ReplicationGroupId": {},
						"NewReplicaCount": {
							"type": "integer"
						},
						"ReplicaConfiguration": {
							"shape": "S2a"
						},
						"ReplicasToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DecreaseReplicaCountResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1w"
						}
					}
				}
			},
			"DeleteCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId"
					],
					"members": {
						"CacheClusterId": {},
						"FinalSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "S14"
						}
					}
				}
			},
			"DeleteCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName"
					],
					"members": {
						"CacheParameterGroupName": {}
					}
				}
			},
			"DeleteCacheSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName"
					],
					"members": {
						"CacheSecurityGroupName": {}
					}
				}
			},
			"DeleteCacheSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSubnetGroupName"
					],
					"members": {
						"CacheSubnetGroupName": {}
					}
				}
			},
			"DeleteReplicationGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId"
					],
					"members": {
						"ReplicationGroupId": {},
						"RetainPrimaryCluster": {
							"type": "boolean"
						},
						"FinalSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReplicationGroupResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1w"
						}
					}
				}
			},
			"DeleteSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotName"
					],
					"members": {
						"SnapshotName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"DescribeCacheClusters": {
				"input": {
					"type": "structure",
					"members": {
						"CacheClusterId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"ShowCacheNodeInfo": {
							"type": "boolean"
						},
						"ShowCacheClustersNotInReplicationGroups": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheClustersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheClusters": {
							"type": "list",
							"member": {
								"shape": "S14",
								"locationName": "CacheCluster"
							}
						}
					}
				}
			},
			"DescribeCacheEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"CacheParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "CacheEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"CacheParameterGroupFamily": {},
									"CacheEngineDescription": {},
									"CacheEngineVersionDescription": {}
								}
							}
						}
					}
				}
			},
			"DescribeCacheParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"CacheParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1j",
								"locationName": "CacheParameterGroup"
							}
						}
					}
				}
			},
			"DescribeCacheParameters": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName"
					],
					"members": {
						"CacheParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheParametersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Parameters": {
							"shape": "S2z"
						},
						"CacheNodeTypeSpecificParameters": {
							"shape": "S32"
						}
					}
				}
			},
			"DescribeCacheSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"CacheSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "S8",
								"locationName": "CacheSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeCacheSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"CacheSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S1p",
								"locationName": "CacheSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupFamily"
					],
					"members": {
						"CacheParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"CacheParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2z"
								},
								"CacheNodeTypeSpecificParameters": {
									"shape": "S32"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeReplicationGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ReplicationGroupId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReplicationGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReplicationGroups": {
							"type": "list",
							"member": {
								"shape": "S1w",
								"locationName": "ReplicationGroup"
							}
						}
					}
				}
			},
			"DescribeReservedCacheNodes": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedCacheNodeId": {},
						"ReservedCacheNodesOfferingId": {},
						"CacheNodeType": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedCacheNodesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedCacheNodes": {
							"type": "list",
							"member": {
								"shape": "S3q",
								"locationName": "ReservedCacheNode"
							}
						}
					}
				}
			},
			"DescribeReservedCacheNodesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedCacheNodesOfferingId": {},
						"CacheNodeType": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedCacheNodesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedCacheNodesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedCacheNodesOffering",
								"type": "structure",
								"members": {
									"ReservedCacheNodesOfferingId": {},
									"CacheNodeType": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"ProductDescription": {},
									"OfferingType": {},
									"RecurringCharges": {
										"shape": "S3r"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeServiceUpdates": {
				"input": {
					"type": "structure",
					"members": {
						"ServiceUpdateName": {},
						"ServiceUpdateStatus": {
							"shape": "S3y"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeServiceUpdatesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ServiceUpdates": {
							"type": "list",
							"member": {
								"locationName": "ServiceUpdate",
								"type": "structure",
								"members": {
									"ServiceUpdateName": {},
									"ServiceUpdateReleaseDate": {
										"type": "timestamp"
									},
									"ServiceUpdateEndDate": {
										"type": "timestamp"
									},
									"ServiceUpdateSeverity": {},
									"ServiceUpdateRecommendedApplyByDate": {
										"type": "timestamp"
									},
									"ServiceUpdateStatus": {},
									"ServiceUpdateDescription": {},
									"ServiceUpdateType": {},
									"Engine": {},
									"EngineVersion": {},
									"AutoUpdateAfterRecommendedApplyByDate": {
										"type": "boolean"
									},
									"EstimatedUpdateTime": {}
								}
							}
						}
					}
				}
			},
			"DescribeSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"ReplicationGroupId": {},
						"CacheClusterId": {},
						"SnapshotName": {},
						"SnapshotSource": {},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"ShowNodeGroupConfig": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Snapshots": {
							"type": "list",
							"member": {
								"shape": "Sm",
								"locationName": "Snapshot"
							}
						}
					}
				}
			},
			"DescribeUpdateActions": {
				"input": {
					"type": "structure",
					"members": {
						"ServiceUpdateName": {},
						"ReplicationGroupIds": {
							"shape": "Sc"
						},
						"ServiceUpdateStatus": {
							"shape": "S3y"
						},
						"ServiceUpdateTimeRange": {
							"type": "structure",
							"members": {
								"StartTime": {
									"type": "timestamp"
								},
								"EndTime": {
									"type": "timestamp"
								}
							}
						},
						"UpdateActionStatus": {
							"type": "list",
							"member": {}
						},
						"ShowNodeLevelUpdateStatus": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeUpdateActionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"UpdateActions": {
							"type": "list",
							"member": {
								"locationName": "UpdateAction",
								"type": "structure",
								"members": {
									"ReplicationGroupId": {},
									"ServiceUpdateName": {},
									"ServiceUpdateReleaseDate": {
										"type": "timestamp"
									},
									"ServiceUpdateSeverity": {},
									"ServiceUpdateStatus": {},
									"ServiceUpdateRecommendedApplyByDate": {
										"type": "timestamp"
									},
									"ServiceUpdateType": {},
									"UpdateActionAvailableDate": {
										"type": "timestamp"
									},
									"UpdateActionStatus": {},
									"NodesUpdated": {},
									"UpdateActionStatusModifiedDate": {
										"type": "timestamp"
									},
									"SlaMet": {},
									"NodeGroupUpdateStatus": {
										"type": "list",
										"member": {
											"locationName": "NodeGroupUpdateStatus",
											"type": "structure",
											"members": {
												"NodeGroupId": {},
												"NodeGroupMemberUpdateStatus": {
													"type": "list",
													"member": {
														"locationName": "NodeGroupMemberUpdateStatus",
														"type": "structure",
														"members": {
															"CacheClusterId": {},
															"CacheNodeId": {},
															"NodeUpdateStatus": {},
															"NodeDeletionDate": {
																"type": "timestamp"
															},
															"NodeUpdateStartDate": {
																"type": "timestamp"
															},
															"NodeUpdateEndDate": {
																"type": "timestamp"
															},
															"NodeUpdateInitiatedBy": {},
															"NodeUpdateInitiatedDate": {
																"type": "timestamp"
															},
															"NodeUpdateStatusModifiedDate": {
																"type": "timestamp"
															}
														}
													}
												}
											}
										}
									},
									"EstimatedUpdateTime": {}
								}
							}
						}
					}
				}
			},
			"IncreaseReplicaCount": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId",
						"ApplyImmediately"
					],
					"members": {
						"ReplicationGroupId": {},
						"NewReplicaCount": {
							"type": "integer"
						},
						"ReplicaConfiguration": {
							"shape": "S2a"
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "IncreaseReplicaCountResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1w"
						}
					}
				}
			},
			"ListAllowedNodeTypeModifications": {
				"input": {
					"type": "structure",
					"members": {
						"CacheClusterId": {},
						"ReplicationGroupId": {}
					}
				},
				"output": {
					"resultWrapper": "ListAllowedNodeTypeModificationsResult",
					"type": "structure",
					"members": {
						"ScaleUpModifications": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {}
					}
				},
				"output": {
					"shape": "S5",
					"resultWrapper": "ListTagsForResourceResult"
				}
			},
			"ModifyCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId"
					],
					"members": {
						"CacheClusterId": {},
						"NumCacheNodes": {
							"type": "integer"
						},
						"CacheNodeIdsToRemove": {
							"shape": "S18"
						},
						"AZMode": {},
						"NewAvailabilityZones": {
							"shape": "Sy"
						},
						"CacheSecurityGroupNames": {
							"shape": "Sz"
						},
						"SecurityGroupIds": {
							"shape": "S10"
						},
						"PreferredMaintenanceWindow": {},
						"NotificationTopicArn": {},
						"CacheParameterGroupName": {},
						"NotificationTopicStatus": {},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"CacheNodeType": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "S14"
						}
					}
				}
			},
			"ModifyCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName",
						"ParameterNameValues"
					],
					"members": {
						"CacheParameterGroupName": {},
						"ParameterNameValues": {
							"shape": "S4u"
						}
					}
				},
				"output": {
					"shape": "S4w",
					"resultWrapper": "ModifyCacheParameterGroupResult"
				}
			},
			"ModifyCacheSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSubnetGroupName"
					],
					"members": {
						"CacheSubnetGroupName": {},
						"CacheSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1n"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyCacheSubnetGroupResult",
					"type": "structure",
					"members": {
						"CacheSubnetGroup": {
							"shape": "S1p"
						}
					}
				}
			},
			"ModifyReplicationGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId"
					],
					"members": {
						"ReplicationGroupId": {},
						"ReplicationGroupDescription": {},
						"PrimaryClusterId": {},
						"SnapshottingClusterId": {},
						"AutomaticFailoverEnabled": {
							"type": "boolean"
						},
						"CacheSecurityGroupNames": {
							"shape": "Sz"
						},
						"SecurityGroupIds": {
							"shape": "S10"
						},
						"PreferredMaintenanceWindow": {},
						"NotificationTopicArn": {},
						"CacheParameterGroupName": {},
						"NotificationTopicStatus": {},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"CacheNodeType": {},
						"NodeGroupId": {
							"deprecated": true
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyReplicationGroupResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1w"
						}
					}
				}
			},
			"ModifyReplicationGroupShardConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId",
						"NodeGroupCount",
						"ApplyImmediately"
					],
					"members": {
						"ReplicationGroupId": {},
						"NodeGroupCount": {
							"type": "integer"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"ReshardingConfiguration": {
							"type": "list",
							"member": {
								"locationName": "ReshardingConfiguration",
								"type": "structure",
								"members": {
									"NodeGroupId": {},
									"PreferredAvailabilityZones": {
										"shape": "Sv"
									}
								}
							}
						},
						"NodeGroupsToRemove": {
							"type": "list",
							"member": {
								"locationName": "NodeGroupToRemove"
							}
						},
						"NodeGroupsToRetain": {
							"type": "list",
							"member": {
								"locationName": "NodeGroupToRetain"
							}
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyReplicationGroupShardConfigurationResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1w"
						}
					}
				}
			},
			"PurchaseReservedCacheNodesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedCacheNodesOfferingId"
					],
					"members": {
						"ReservedCacheNodesOfferingId": {},
						"ReservedCacheNodeId": {},
						"CacheNodeCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedCacheNodesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedCacheNode": {
							"shape": "S3q"
						}
					}
				}
			},
			"RebootCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId",
						"CacheNodeIdsToReboot"
					],
					"members": {
						"CacheClusterId": {},
						"CacheNodeIdsToReboot": {
							"shape": "S18"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "S14"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"shape": "S5",
					"resultWrapper": "RemoveTagsFromResourceResult"
				}
			},
			"ResetCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName"
					],
					"members": {
						"CacheParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"ParameterNameValues": {
							"shape": "S4u"
						}
					}
				},
				"output": {
					"shape": "S4w",
					"resultWrapper": "ResetCacheParameterGroupResult"
				}
			},
			"RevokeCacheSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName",
						"EC2SecurityGroupName",
						"EC2SecurityGroupOwnerId"
					],
					"members": {
						"CacheSecurityGroupName": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeCacheSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"CacheSecurityGroup": {
							"shape": "S8"
						}
					}
				}
			},
			"TestFailover": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId",
						"NodeGroupId"
					],
					"members": {
						"ReplicationGroupId": {},
						"NodeGroupId": {}
					}
				},
				"output": {
					"resultWrapper": "TestFailoverResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1w"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S5": {
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "S3"
					}
				}
			},
			"S8": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"CacheSecurityGroupName": {},
					"Description": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sc": {
				"type": "list",
				"member": {}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"ProcessedUpdateActions": {
						"type": "list",
						"member": {
							"locationName": "ProcessedUpdateAction",
							"type": "structure",
							"members": {
								"ReplicationGroupId": {},
								"ServiceUpdateName": {},
								"UpdateActionStatus": {}
							}
						}
					},
					"UnprocessedUpdateActions": {
						"type": "list",
						"member": {
							"locationName": "UnprocessedUpdateAction",
							"type": "structure",
							"members": {
								"ReplicationGroupId": {},
								"ServiceUpdateName": {},
								"ErrorType": {},
								"ErrorMessage": {}
							}
						}
					}
				}
			},
			"Sm": {
				"type": "structure",
				"members": {
					"SnapshotName": {},
					"ReplicationGroupId": {},
					"ReplicationGroupDescription": {},
					"CacheClusterId": {},
					"SnapshotStatus": {},
					"SnapshotSource": {},
					"CacheNodeType": {},
					"Engine": {},
					"EngineVersion": {},
					"NumCacheNodes": {
						"type": "integer"
					},
					"PreferredAvailabilityZone": {},
					"CacheClusterCreateTime": {
						"type": "timestamp"
					},
					"PreferredMaintenanceWindow": {},
					"TopicArn": {},
					"Port": {
						"type": "integer"
					},
					"CacheParameterGroupName": {},
					"CacheSubnetGroupName": {},
					"VpcId": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"NumNodeGroups": {
						"type": "integer"
					},
					"AutomaticFailover": {},
					"NodeSnapshots": {
						"type": "list",
						"member": {
							"locationName": "NodeSnapshot",
							"type": "structure",
							"members": {
								"CacheClusterId": {},
								"NodeGroupId": {},
								"CacheNodeId": {},
								"NodeGroupConfiguration": {
									"shape": "St"
								},
								"CacheSize": {},
								"CacheNodeCreateTime": {
									"type": "timestamp"
								},
								"SnapshotCreateTime": {
									"type": "timestamp"
								}
							},
							"wrapper": true
						}
					}
				},
				"wrapper": true
			},
			"St": {
				"type": "structure",
				"members": {
					"NodeGroupId": {},
					"Slots": {},
					"ReplicaCount": {
						"type": "integer"
					},
					"PrimaryAvailabilityZone": {},
					"ReplicaAvailabilityZones": {
						"shape": "Sv"
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "AvailabilityZone"
				}
			},
			"Sy": {
				"type": "list",
				"member": {
					"locationName": "PreferredAvailabilityZone"
				}
			},
			"Sz": {
				"type": "list",
				"member": {
					"locationName": "CacheSecurityGroupName"
				}
			},
			"S10": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroupId"
				}
			},
			"S11": {
				"type": "list",
				"member": {
					"locationName": "SnapshotArn"
				}
			},
			"S14": {
				"type": "structure",
				"members": {
					"CacheClusterId": {},
					"ConfigurationEndpoint": {
						"shape": "S15"
					},
					"ClientDownloadLandingPage": {},
					"CacheNodeType": {},
					"Engine": {},
					"EngineVersion": {},
					"CacheClusterStatus": {},
					"NumCacheNodes": {
						"type": "integer"
					},
					"PreferredAvailabilityZone": {},
					"CacheClusterCreateTime": {
						"type": "timestamp"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"NumCacheNodes": {
								"type": "integer"
							},
							"CacheNodeIdsToRemove": {
								"shape": "S18"
							},
							"EngineVersion": {},
							"CacheNodeType": {}
						}
					},
					"NotificationConfiguration": {
						"type": "structure",
						"members": {
							"TopicArn": {},
							"TopicStatus": {}
						}
					},
					"CacheSecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "CacheSecurityGroup",
							"type": "structure",
							"members": {
								"CacheSecurityGroupName": {},
								"Status": {}
							}
						}
					},
					"CacheParameterGroup": {
						"type": "structure",
						"members": {
							"CacheParameterGroupName": {},
							"ParameterApplyStatus": {},
							"CacheNodeIdsToReboot": {
								"shape": "S18"
							}
						}
					},
					"CacheSubnetGroupName": {},
					"CacheNodes": {
						"type": "list",
						"member": {
							"locationName": "CacheNode",
							"type": "structure",
							"members": {
								"CacheNodeId": {},
								"CacheNodeStatus": {},
								"CacheNodeCreateTime": {
									"type": "timestamp"
								},
								"Endpoint": {
									"shape": "S15"
								},
								"ParameterGroupStatus": {},
								"SourceCacheNodeId": {},
								"CustomerAvailabilityZone": {}
							}
						}
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SecurityGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SecurityGroupId": {},
								"Status": {}
							}
						}
					},
					"ReplicationGroupId": {},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"AuthTokenEnabled": {
						"type": "boolean"
					},
					"TransitEncryptionEnabled": {
						"type": "boolean"
					},
					"AtRestEncryptionEnabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S15": {
				"type": "structure",
				"members": {
					"Address": {},
					"Port": {
						"type": "integer"
					}
				}
			},
			"S18": {
				"type": "list",
				"member": {
					"locationName": "CacheNodeId"
				}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"CacheParameterGroupName": {},
					"CacheParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1n": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"CacheSubnetGroupName": {},
					"CacheSubnetGroupDescription": {},
					"VpcId": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"type": "structure",
									"members": {
										"Name": {}
									},
									"wrapper": true
								}
							}
						}
					}
				},
				"wrapper": true
			},
			"S1w": {
				"type": "structure",
				"members": {
					"ReplicationGroupId": {},
					"Description": {},
					"Status": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"PrimaryClusterId": {},
							"AutomaticFailoverStatus": {},
							"Resharding": {
								"type": "structure",
								"members": {
									"SlotMigration": {
										"type": "structure",
										"members": {
											"ProgressPercentage": {
												"type": "double"
											}
										}
									}
								}
							}
						}
					},
					"MemberClusters": {
						"type": "list",
						"member": {
							"locationName": "ClusterId"
						}
					},
					"NodeGroups": {
						"type": "list",
						"member": {
							"locationName": "NodeGroup",
							"type": "structure",
							"members": {
								"NodeGroupId": {},
								"Status": {},
								"PrimaryEndpoint": {
									"shape": "S15"
								},
								"ReaderEndpoint": {
									"shape": "S15"
								},
								"Slots": {},
								"NodeGroupMembers": {
									"type": "list",
									"member": {
										"locationName": "NodeGroupMember",
										"type": "structure",
										"members": {
											"CacheClusterId": {},
											"CacheNodeId": {},
											"ReadEndpoint": {
												"shape": "S15"
											},
											"PreferredAvailabilityZone": {},
											"CurrentRole": {}
										}
									}
								}
							}
						}
					},
					"SnapshottingClusterId": {},
					"AutomaticFailover": {},
					"ConfigurationEndpoint": {
						"shape": "S15"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"ClusterEnabled": {
						"type": "boolean"
					},
					"CacheNodeType": {},
					"AuthTokenEnabled": {
						"type": "boolean"
					},
					"TransitEncryptionEnabled": {
						"type": "boolean"
					},
					"AtRestEncryptionEnabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S2a": {
				"type": "list",
				"member": {
					"locationName": "ConfigureShard",
					"type": "structure",
					"required": [
						"NodeGroupId",
						"NewReplicaCount"
					],
					"members": {
						"NodeGroupId": {},
						"NewReplicaCount": {
							"type": "integer"
						},
						"PreferredAvailabilityZones": {
							"shape": "Sy"
						}
					}
				}
			},
			"S2z": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ChangeType": {}
					}
				}
			},
			"S32": {
				"type": "list",
				"member": {
					"locationName": "CacheNodeTypeSpecificParameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"Description": {},
						"Source": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"CacheNodeTypeSpecificValues": {
							"type": "list",
							"member": {
								"locationName": "CacheNodeTypeSpecificValue",
								"type": "structure",
								"members": {
									"CacheNodeType": {},
									"Value": {}
								}
							}
						},
						"ChangeType": {}
					}
				}
			},
			"S3q": {
				"type": "structure",
				"members": {
					"ReservedCacheNodeId": {},
					"ReservedCacheNodesOfferingId": {},
					"CacheNodeType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CacheNodeCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"State": {},
					"RecurringCharges": {
						"shape": "S3r"
					},
					"ReservationARN": {}
				},
				"wrapper": true
			},
			"S3r": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S3y": {
				"type": "list",
				"member": {}
			},
			"S4u": {
				"type": "list",
				"member": {
					"locationName": "ParameterNameValue",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {}
					}
				}
			},
			"S4w": {
				"type": "structure",
				"members": {
					"CacheParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 1725 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeCacheClusters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "CacheClusters"
			},
			"DescribeCacheEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "CacheEngineVersions"
			},
			"DescribeCacheParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "CacheParameterGroups"
			},
			"DescribeCacheParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeCacheSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "CacheSecurityGroups"
			},
			"DescribeCacheSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "CacheSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeReplicationGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReplicationGroups"
			},
			"DescribeReservedCacheNodes": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedCacheNodes"
			},
			"DescribeReservedCacheNodesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedCacheNodesOfferings"
			},
			"DescribeServiceUpdates": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ServiceUpdates"
			},
			"DescribeSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Snapshots"
			},
			"DescribeUpdateActions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "UpdateActions"
			}
		}
	};

/***/ },
/* 1726 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"CacheClusterAvailable": {
				"acceptors": [
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "available",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "incompatible-network",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "restore-failed",
						"matcher": "pathAny",
						"state": "failure"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache cluster is available.",
				"maxAttempts": 40,
				"operation": "DescribeCacheClusters"
			},
			"CacheClusterDeleted": {
				"acceptors": [
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"expected": "CacheClusterNotFound",
						"matcher": "error",
						"state": "success"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "available",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "incompatible-network",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "restore-failed",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "snapshotting",
						"matcher": "pathAny",
						"state": "failure"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache cluster is deleted.",
				"maxAttempts": 40,
				"operation": "DescribeCacheClusters"
			},
			"ReplicationGroupAvailable": {
				"acceptors": [
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "available",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache replication group is available.",
				"maxAttempts": 40,
				"operation": "DescribeReplicationGroups"
			},
			"ReplicationGroupDeleted": {
				"acceptors": [
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "available",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"expected": "ReplicationGroupNotFoundFault",
						"matcher": "error",
						"state": "success"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache replication group is deleted.",
				"maxAttempts": 40,
				"operation": "DescribeReplicationGroups"
			}
		}
	};

/***/ },
/* 1727 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-12-01",
			"endpointPrefix": "elasticbeanstalk",
			"protocol": "query",
			"serviceAbbreviation": "Elastic Beanstalk",
			"serviceFullName": "AWS Elastic Beanstalk",
			"serviceId": "Elastic Beanstalk",
			"signatureVersion": "v4",
			"uid": "elasticbeanstalk-2010-12-01",
			"xmlNamespace": "http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"
		},
		"operations": {
			"AbortEnvironmentUpdate": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				}
			},
			"ApplyEnvironmentManagedAction": {
				"input": {
					"type": "structure",
					"required": [
						"ActionId"
					],
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"ActionId": {}
					}
				},
				"output": {
					"resultWrapper": "ApplyEnvironmentManagedActionResult",
					"type": "structure",
					"members": {
						"ActionId": {},
						"ActionDescription": {},
						"ActionType": {},
						"Status": {}
					}
				}
			},
			"CheckDNSAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"CNAMEPrefix"
					],
					"members": {
						"CNAMEPrefix": {}
					}
				},
				"output": {
					"resultWrapper": "CheckDNSAvailabilityResult",
					"type": "structure",
					"members": {
						"Available": {
							"type": "boolean"
						},
						"FullyQualifiedCNAME": {}
					}
				}
			},
			"ComposeEnvironments": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"GroupName": {},
						"VersionLabels": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"shape": "Si",
					"resultWrapper": "ComposeEnvironmentsResult"
				}
			},
			"CreateApplication": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"Description": {},
						"ResourceLifecycleConfig": {
							"shape": "S17"
						},
						"Tags": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"shape": "S1h",
					"resultWrapper": "CreateApplicationResult"
				}
			},
			"CreateApplicationVersion": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"VersionLabel"
					],
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"Description": {},
						"SourceBuildInformation": {
							"shape": "S1n"
						},
						"SourceBundle": {
							"shape": "S1r"
						},
						"BuildConfiguration": {
							"type": "structure",
							"required": [
								"CodeBuildServiceRole",
								"Image"
							],
							"members": {
								"ArtifactName": {},
								"CodeBuildServiceRole": {},
								"ComputeType": {},
								"Image": {},
								"TimeoutInMinutes": {
									"type": "integer"
								}
							}
						},
						"AutoCreateApplication": {
							"type": "boolean"
						},
						"Process": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"shape": "S1z",
					"resultWrapper": "CreateApplicationVersionResult"
				}
			},
			"CreateConfigurationTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"TemplateName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"SolutionStackName": {},
						"PlatformArn": {},
						"SourceConfiguration": {
							"type": "structure",
							"members": {
								"ApplicationName": {},
								"TemplateName": {}
							}
						},
						"EnvironmentId": {},
						"Description": {},
						"OptionSettings": {
							"shape": "S25"
						},
						"Tags": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"shape": "S2b",
					"resultWrapper": "CreateConfigurationTemplateResult"
				}
			},
			"CreateEnvironment": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"EnvironmentName": {},
						"GroupName": {},
						"Description": {},
						"CNAMEPrefix": {},
						"Tier": {
							"shape": "S11"
						},
						"Tags": {
							"shape": "S1d"
						},
						"VersionLabel": {},
						"TemplateName": {},
						"SolutionStackName": {},
						"PlatformArn": {},
						"OptionSettings": {
							"shape": "S25"
						},
						"OptionsToRemove": {
							"shape": "S2e"
						}
					}
				},
				"output": {
					"shape": "Sk",
					"resultWrapper": "CreateEnvironmentResult"
				}
			},
			"CreatePlatformVersion": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformName",
						"PlatformVersion",
						"PlatformDefinitionBundle"
					],
					"members": {
						"PlatformName": {},
						"PlatformVersion": {},
						"PlatformDefinitionBundle": {
							"shape": "S1r"
						},
						"EnvironmentName": {},
						"OptionSettings": {
							"shape": "S25"
						},
						"Tags": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"resultWrapper": "CreatePlatformVersionResult",
					"type": "structure",
					"members": {
						"PlatformSummary": {
							"shape": "S2k"
						},
						"Builder": {
							"type": "structure",
							"members": {
								"ARN": {}
							}
						}
					}
				}
			},
			"CreateStorageLocation": {
				"output": {
					"resultWrapper": "CreateStorageLocationResult",
					"type": "structure",
					"members": {
						"S3Bucket": {}
					}
				}
			},
			"DeleteApplication": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"TerminateEnvByForce": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteApplicationVersion": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"VersionLabel"
					],
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"DeleteSourceBundle": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteConfigurationTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"TemplateName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {}
					}
				}
			},
			"DeleteEnvironmentConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"EnvironmentName"
					],
					"members": {
						"ApplicationName": {},
						"EnvironmentName": {}
					}
				}
			},
			"DeletePlatformVersion": {
				"input": {
					"type": "structure",
					"members": {
						"PlatformArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeletePlatformVersionResult",
					"type": "structure",
					"members": {
						"PlatformSummary": {
							"shape": "S2k"
						}
					}
				}
			},
			"DescribeAccountAttributes": {
				"output": {
					"resultWrapper": "DescribeAccountAttributesResult",
					"type": "structure",
					"members": {
						"ResourceQuotas": {
							"type": "structure",
							"members": {
								"ApplicationQuota": {
									"shape": "S37"
								},
								"ApplicationVersionQuota": {
									"shape": "S37"
								},
								"EnvironmentQuota": {
									"shape": "S37"
								},
								"ConfigurationTemplateQuota": {
									"shape": "S37"
								},
								"CustomPlatformQuota": {
									"shape": "S37"
								}
							}
						}
					}
				}
			},
			"DescribeApplicationVersions": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"VersionLabels": {
							"shape": "S1k"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeApplicationVersionsResult",
					"type": "structure",
					"members": {
						"ApplicationVersions": {
							"type": "list",
							"member": {
								"shape": "S20"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeApplications": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeApplicationsResult",
					"type": "structure",
					"members": {
						"Applications": {
							"type": "list",
							"member": {
								"shape": "S1i"
							}
						}
					}
				}
			},
			"DescribeConfigurationOptions": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"EnvironmentName": {},
						"SolutionStackName": {},
						"PlatformArn": {},
						"Options": {
							"shape": "S2e"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeConfigurationOptionsResult",
					"type": "structure",
					"members": {
						"SolutionStackName": {},
						"PlatformArn": {},
						"Options": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Namespace": {},
									"Name": {},
									"DefaultValue": {},
									"ChangeSeverity": {},
									"UserDefined": {
										"type": "boolean"
									},
									"ValueType": {},
									"ValueOptions": {
										"type": "list",
										"member": {}
									},
									"MinValue": {
										"type": "integer"
									},
									"MaxValue": {
										"type": "integer"
									},
									"MaxLength": {
										"type": "integer"
									},
									"Regex": {
										"type": "structure",
										"members": {
											"Pattern": {},
											"Label": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeConfigurationSettings": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"EnvironmentName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeConfigurationSettingsResult",
					"type": "structure",
					"members": {
						"ConfigurationSettings": {
							"type": "list",
							"member": {
								"shape": "S2b"
							}
						}
					}
				}
			},
			"DescribeEnvironmentHealth": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"AttributeNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentHealthResult",
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"HealthStatus": {},
						"Status": {},
						"Color": {},
						"Causes": {
							"shape": "S43"
						},
						"ApplicationMetrics": {
							"shape": "S45"
						},
						"InstancesHealth": {
							"type": "structure",
							"members": {
								"NoData": {
									"type": "integer"
								},
								"Unknown": {
									"type": "integer"
								},
								"Pending": {
									"type": "integer"
								},
								"Ok": {
									"type": "integer"
								},
								"Info": {
									"type": "integer"
								},
								"Warning": {
									"type": "integer"
								},
								"Degraded": {
									"type": "integer"
								},
								"Severe": {
									"type": "integer"
								}
							}
						},
						"RefreshedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeEnvironmentManagedActionHistory": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentManagedActionHistoryResult",
					"type": "structure",
					"members": {
						"ManagedActionHistoryItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ActionId": {},
									"ActionType": {},
									"ActionDescription": {},
									"FailureType": {},
									"Status": {},
									"FailureDescription": {},
									"ExecutedTime": {
										"type": "timestamp"
									},
									"FinishedTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeEnvironmentManagedActions": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"Status": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentManagedActionsResult",
					"type": "structure",
					"members": {
						"ManagedActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ActionId": {},
									"ActionDescription": {},
									"ActionType": {},
									"Status": {},
									"WindowStartTime": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeEnvironmentResources": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentResourcesResult",
					"type": "structure",
					"members": {
						"EnvironmentResources": {
							"type": "structure",
							"members": {
								"EnvironmentName": {},
								"AutoScalingGroups": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"Instances": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Id": {}
										}
									}
								},
								"LaunchConfigurations": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"LaunchTemplates": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Id": {}
										}
									}
								},
								"LoadBalancers": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"Triggers": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"Queues": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"URL": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeEnvironments": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"EnvironmentIds": {
							"type": "list",
							"member": {}
						},
						"EnvironmentNames": {
							"type": "list",
							"member": {}
						},
						"IncludeDeleted": {
							"type": "boolean"
						},
						"IncludedDeletedBackTo": {
							"type": "timestamp"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"shape": "Si",
					"resultWrapper": "DescribeEnvironmentsResult"
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"TemplateName": {},
						"EnvironmentId": {},
						"EnvironmentName": {},
						"PlatformArn": {},
						"RequestId": {},
						"Severity": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventDate": {
										"type": "timestamp"
									},
									"Message": {},
									"ApplicationName": {},
									"VersionLabel": {},
									"TemplateName": {},
									"EnvironmentName": {},
									"PlatformArn": {},
									"RequestId": {},
									"Severity": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancesHealth": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"AttributeNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeInstancesHealthResult",
					"type": "structure",
					"members": {
						"InstanceHealthList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InstanceId": {},
									"HealthStatus": {},
									"Color": {},
									"Causes": {
										"shape": "S43"
									},
									"LaunchedAt": {
										"type": "timestamp"
									},
									"ApplicationMetrics": {
										"shape": "S45"
									},
									"System": {
										"type": "structure",
										"members": {
											"CPUUtilization": {
												"type": "structure",
												"members": {
													"User": {
														"type": "double"
													},
													"Nice": {
														"type": "double"
													},
													"System": {
														"type": "double"
													},
													"Idle": {
														"type": "double"
													},
													"IOWait": {
														"type": "double"
													},
													"IRQ": {
														"type": "double"
													},
													"SoftIRQ": {
														"type": "double"
													},
													"Privileged": {
														"type": "double"
													}
												}
											},
											"LoadAverage": {
												"type": "list",
												"member": {
													"type": "double"
												}
											}
										}
									},
									"Deployment": {
										"type": "structure",
										"members": {
											"VersionLabel": {},
											"DeploymentId": {
												"type": "long"
											},
											"Status": {},
											"DeploymentTime": {
												"type": "timestamp"
											}
										}
									},
									"AvailabilityZone": {},
									"InstanceType": {}
								}
							}
						},
						"RefreshedAt": {
							"type": "timestamp"
						},
						"NextToken": {}
					}
				}
			},
			"DescribePlatformVersion": {
				"input": {
					"type": "structure",
					"members": {
						"PlatformArn": {}
					}
				},
				"output": {
					"resultWrapper": "DescribePlatformVersionResult",
					"type": "structure",
					"members": {
						"PlatformDescription": {
							"type": "structure",
							"members": {
								"PlatformArn": {},
								"PlatformOwner": {},
								"PlatformName": {},
								"PlatformVersion": {},
								"SolutionStackName": {},
								"PlatformStatus": {},
								"DateCreated": {
									"type": "timestamp"
								},
								"DateUpdated": {
									"type": "timestamp"
								},
								"PlatformCategory": {},
								"Description": {},
								"Maintainer": {},
								"OperatingSystemName": {},
								"OperatingSystemVersion": {},
								"ProgrammingLanguages": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"Version": {}
										}
									}
								},
								"Frameworks": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"Version": {}
										}
									}
								},
								"CustomAmiList": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"VirtualizationType": {},
											"ImageId": {}
										}
									}
								},
								"SupportedTierList": {
									"shape": "S2q"
								},
								"SupportedAddonList": {
									"shape": "S2s"
								}
							}
						}
					}
				}
			},
			"ListAvailableSolutionStacks": {
				"output": {
					"resultWrapper": "ListAvailableSolutionStacksResult",
					"type": "structure",
					"members": {
						"SolutionStacks": {
							"type": "list",
							"member": {}
						},
						"SolutionStackDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SolutionStackName": {},
									"PermittedFileTypes": {
										"type": "list",
										"member": {}
									}
								}
							}
						}
					}
				}
			},
			"ListPlatformVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"Operator": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListPlatformVersionsResult",
					"type": "structure",
					"members": {
						"PlatformSummaryList": {
							"type": "list",
							"member": {
								"shape": "S2k"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"ResourceArn": {},
						"ResourceTags": {
							"shape": "S6x"
						}
					}
				}
			},
			"RebuildEnvironment": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				}
			},
			"RequestEnvironmentInfo": {
				"input": {
					"type": "structure",
					"required": [
						"InfoType"
					],
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"InfoType": {}
					}
				}
			},
			"RestartAppServer": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				}
			},
			"RetrieveEnvironmentInfo": {
				"input": {
					"type": "structure",
					"required": [
						"InfoType"
					],
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"InfoType": {}
					}
				},
				"output": {
					"resultWrapper": "RetrieveEnvironmentInfoResult",
					"type": "structure",
					"members": {
						"EnvironmentInfo": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InfoType": {},
									"Ec2InstanceId": {},
									"SampleTimestamp": {
										"type": "timestamp"
									},
									"Message": {}
								}
							}
						}
					}
				}
			},
			"SwapEnvironmentCNAMEs": {
				"input": {
					"type": "structure",
					"members": {
						"SourceEnvironmentId": {},
						"SourceEnvironmentName": {},
						"DestinationEnvironmentId": {},
						"DestinationEnvironmentName": {}
					}
				}
			},
			"TerminateEnvironment": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"TerminateResources": {
							"type": "boolean"
						},
						"ForceTerminate": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "Sk",
					"resultWrapper": "TerminateEnvironmentResult"
				}
			},
			"UpdateApplication": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "S1h",
					"resultWrapper": "UpdateApplicationResult"
				}
			},
			"UpdateApplicationResourceLifecycle": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"ResourceLifecycleConfig"
					],
					"members": {
						"ApplicationName": {},
						"ResourceLifecycleConfig": {
							"shape": "S17"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateApplicationResourceLifecycleResult",
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"ResourceLifecycleConfig": {
							"shape": "S17"
						}
					}
				}
			},
			"UpdateApplicationVersion": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"VersionLabel"
					],
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "S1z",
					"resultWrapper": "UpdateApplicationVersionResult"
				}
			},
			"UpdateConfigurationTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"TemplateName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"Description": {},
						"OptionSettings": {
							"shape": "S25"
						},
						"OptionsToRemove": {
							"shape": "S2e"
						}
					}
				},
				"output": {
					"shape": "S2b",
					"resultWrapper": "UpdateConfigurationTemplateResult"
				}
			},
			"UpdateEnvironment": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"EnvironmentId": {},
						"EnvironmentName": {},
						"GroupName": {},
						"Description": {},
						"Tier": {
							"shape": "S11"
						},
						"VersionLabel": {},
						"TemplateName": {},
						"SolutionStackName": {},
						"PlatformArn": {},
						"OptionSettings": {
							"shape": "S25"
						},
						"OptionsToRemove": {
							"shape": "S2e"
						}
					}
				},
				"output": {
					"shape": "Sk",
					"resultWrapper": "UpdateEnvironmentResult"
				}
			},
			"UpdateTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"TagsToAdd": {
							"shape": "S6x"
						},
						"TagsToRemove": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ValidateConfigurationSettings": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"OptionSettings"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"EnvironmentName": {},
						"OptionSettings": {
							"shape": "S25"
						}
					}
				},
				"output": {
					"resultWrapper": "ValidateConfigurationSettingsResult",
					"type": "structure",
					"members": {
						"Messages": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Message": {},
									"Severity": {},
									"Namespace": {},
									"OptionName": {}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {
			"Si": {
				"type": "structure",
				"members": {
					"Environments": {
						"type": "list",
						"member": {
							"shape": "Sk"
						}
					},
					"NextToken": {}
				}
			},
			"Sk": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"ApplicationName": {},
					"VersionLabel": {},
					"SolutionStackName": {},
					"PlatformArn": {},
					"TemplateName": {},
					"Description": {},
					"EndpointURL": {},
					"CNAME": {},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"Status": {},
					"AbortableOperationInProgress": {
						"type": "boolean"
					},
					"Health": {},
					"HealthStatus": {},
					"Resources": {
						"type": "structure",
						"members": {
							"LoadBalancer": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"Domain": {},
									"Listeners": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Protocol": {},
												"Port": {
													"type": "integer"
												}
											}
										}
									}
								}
							}
						}
					},
					"Tier": {
						"shape": "S11"
					},
					"EnvironmentLinks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LinkName": {},
								"EnvironmentName": {}
							}
						}
					},
					"EnvironmentArn": {}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"Name": {},
					"Type": {},
					"Version": {}
				}
			},
			"S17": {
				"type": "structure",
				"members": {
					"ServiceRole": {},
					"VersionLifecycleConfig": {
						"type": "structure",
						"members": {
							"MaxCountRule": {
								"type": "structure",
								"required": [
									"Enabled"
								],
								"members": {
									"Enabled": {
										"type": "boolean"
									},
									"MaxCount": {
										"type": "integer"
									},
									"DeleteSourceFromS3": {
										"type": "boolean"
									}
								}
							},
							"MaxAgeRule": {
								"type": "structure",
								"required": [
									"Enabled"
								],
								"members": {
									"Enabled": {
										"type": "boolean"
									},
									"MaxAgeInDays": {
										"type": "integer"
									},
									"DeleteSourceFromS3": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"S1d": {
				"type": "list",
				"member": {
					"shape": "S1e"
				}
			},
			"S1e": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S1h": {
				"type": "structure",
				"members": {
					"Application": {
						"shape": "S1i"
					}
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"ApplicationArn": {},
					"ApplicationName": {},
					"Description": {},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"Versions": {
						"shape": "S1k"
					},
					"ConfigurationTemplates": {
						"type": "list",
						"member": {}
					},
					"ResourceLifecycleConfig": {
						"shape": "S17"
					}
				}
			},
			"S1k": {
				"type": "list",
				"member": {}
			},
			"S1n": {
				"type": "structure",
				"required": [
					"SourceType",
					"SourceRepository",
					"SourceLocation"
				],
				"members": {
					"SourceType": {},
					"SourceRepository": {},
					"SourceLocation": {}
				}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"S3Bucket": {},
					"S3Key": {}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"ApplicationVersion": {
						"shape": "S20"
					}
				}
			},
			"S20": {
				"type": "structure",
				"members": {
					"ApplicationVersionArn": {},
					"ApplicationName": {},
					"Description": {},
					"VersionLabel": {},
					"SourceBuildInformation": {
						"shape": "S1n"
					},
					"BuildArn": {},
					"SourceBundle": {
						"shape": "S1r"
					},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"Status": {}
				}
			},
			"S25": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ResourceName": {},
						"Namespace": {},
						"OptionName": {},
						"Value": {}
					}
				}
			},
			"S2b": {
				"type": "structure",
				"members": {
					"SolutionStackName": {},
					"PlatformArn": {},
					"ApplicationName": {},
					"TemplateName": {},
					"Description": {},
					"EnvironmentName": {},
					"DeploymentStatus": {},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"OptionSettings": {
						"shape": "S25"
					}
				}
			},
			"S2e": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ResourceName": {},
						"Namespace": {},
						"OptionName": {}
					}
				}
			},
			"S2k": {
				"type": "structure",
				"members": {
					"PlatformArn": {},
					"PlatformOwner": {},
					"PlatformStatus": {},
					"PlatformCategory": {},
					"OperatingSystemName": {},
					"OperatingSystemVersion": {},
					"SupportedTierList": {
						"shape": "S2q"
					},
					"SupportedAddonList": {
						"shape": "S2s"
					}
				}
			},
			"S2q": {
				"type": "list",
				"member": {}
			},
			"S2s": {
				"type": "list",
				"member": {}
			},
			"S37": {
				"type": "structure",
				"members": {
					"Maximum": {
						"type": "integer"
					}
				}
			},
			"S43": {
				"type": "list",
				"member": {}
			},
			"S45": {
				"type": "structure",
				"members": {
					"Duration": {
						"type": "integer"
					},
					"RequestCount": {
						"type": "integer"
					},
					"StatusCodes": {
						"type": "structure",
						"members": {
							"Status2xx": {
								"type": "integer"
							},
							"Status3xx": {
								"type": "integer"
							},
							"Status4xx": {
								"type": "integer"
							},
							"Status5xx": {
								"type": "integer"
							}
						}
					},
					"Latency": {
						"type": "structure",
						"members": {
							"P999": {
								"type": "double"
							},
							"P99": {
								"type": "double"
							},
							"P95": {
								"type": "double"
							},
							"P90": {
								"type": "double"
							},
							"P85": {
								"type": "double"
							},
							"P75": {
								"type": "double"
							},
							"P50": {
								"type": "double"
							},
							"P10": {
								"type": "double"
							}
						}
					}
				}
			},
			"S6x": {
				"type": "list",
				"member": {
					"shape": "S1e"
				}
			}
		}
	};

/***/ },
/* 1728 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeApplicationVersions": {
				"result_key": "ApplicationVersions"
			},
			"DescribeApplications": {
				"result_key": "Applications"
			},
			"DescribeConfigurationOptions": {
				"result_key": "Options"
			},
			"DescribeEnvironments": {
				"result_key": "Environments"
			},
			"DescribeEvents": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "Events"
			},
			"ListAvailableSolutionStacks": {
				"result_key": "SolutionStacks"
			}
		}
	};

/***/ },
/* 1729 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-02-01",
			"endpointPrefix": "elasticfilesystem",
			"protocol": "rest-json",
			"serviceAbbreviation": "EFS",
			"serviceFullName": "Amazon Elastic File System",
			"serviceId": "EFS",
			"signatureVersion": "v4",
			"uid": "elasticfilesystem-2015-02-01"
		},
		"operations": {
			"CreateFileSystem": {
				"http": {
					"requestUri": "/2015-02-01/file-systems",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CreationToken"
					],
					"members": {
						"CreationToken": {},
						"PerformanceMode": {},
						"Encrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"ThroughputMode": {},
						"ProvisionedThroughputInMibps": {
							"type": "double"
						},
						"Tags": {
							"shape": "S8"
						}
					}
				},
				"output": {
					"shape": "Sc"
				}
			},
			"CreateMountTarget": {
				"http": {
					"requestUri": "/2015-02-01/mount-targets",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId",
						"SubnetId"
					],
					"members": {
						"FileSystemId": {},
						"SubnetId": {},
						"IpAddress": {},
						"SecurityGroups": {
							"shape": "So"
						}
					}
				},
				"output": {
					"shape": "Sq"
				}
			},
			"CreateTags": {
				"http": {
					"requestUri": "/2015-02-01/create-tags/{FileSystemId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId",
						"Tags"
					],
					"members": {
						"FileSystemId": {
							"location": "uri",
							"locationName": "FileSystemId"
						},
						"Tags": {
							"shape": "S8"
						}
					}
				}
			},
			"DeleteFileSystem": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-02-01/file-systems/{FileSystemId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId"
					],
					"members": {
						"FileSystemId": {
							"location": "uri",
							"locationName": "FileSystemId"
						}
					}
				}
			},
			"DeleteMountTarget": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-02-01/mount-targets/{MountTargetId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"MountTargetId"
					],
					"members": {
						"MountTargetId": {
							"location": "uri",
							"locationName": "MountTargetId"
						}
					}
				}
			},
			"DeleteTags": {
				"http": {
					"requestUri": "/2015-02-01/delete-tags/{FileSystemId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId",
						"TagKeys"
					],
					"members": {
						"FileSystemId": {
							"location": "uri",
							"locationName": "FileSystemId"
						},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"DescribeFileSystems": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-02-01/file-systems",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"CreationToken": {
							"location": "querystring",
							"locationName": "CreationToken"
						},
						"FileSystemId": {
							"location": "querystring",
							"locationName": "FileSystemId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Marker": {},
						"FileSystems": {
							"type": "list",
							"member": {
								"shape": "Sc"
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeLifecycleConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId"
					],
					"members": {
						"FileSystemId": {
							"location": "uri",
							"locationName": "FileSystemId"
						}
					}
				},
				"output": {
					"shape": "S14"
				}
			},
			"DescribeMountTargetSecurityGroups": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"MountTargetId"
					],
					"members": {
						"MountTargetId": {
							"location": "uri",
							"locationName": "MountTargetId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"SecurityGroups"
					],
					"members": {
						"SecurityGroups": {
							"shape": "So"
						}
					}
				}
			},
			"DescribeMountTargets": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-02-01/mount-targets",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"FileSystemId": {
							"location": "querystring",
							"locationName": "FileSystemId"
						},
						"MountTargetId": {
							"location": "querystring",
							"locationName": "MountTargetId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Marker": {},
						"MountTargets": {
							"type": "list",
							"member": {
								"shape": "Sq"
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeTags": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-02-01/tags/{FileSystemId}/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId"
					],
					"members": {
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"FileSystemId": {
							"location": "uri",
							"locationName": "FileSystemId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Marker": {},
						"Tags": {
							"shape": "S8"
						},
						"NextMarker": {}
					}
				}
			},
			"ModifyMountTargetSecurityGroups": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-02-01/mount-targets/{MountTargetId}/security-groups",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"MountTargetId"
					],
					"members": {
						"MountTargetId": {
							"location": "uri",
							"locationName": "MountTargetId"
						},
						"SecurityGroups": {
							"shape": "So"
						}
					}
				}
			},
			"PutLifecycleConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId",
						"LifecyclePolicies"
					],
					"members": {
						"FileSystemId": {
							"location": "uri",
							"locationName": "FileSystemId"
						},
						"LifecyclePolicies": {
							"shape": "S15"
						}
					}
				},
				"output": {
					"shape": "S14"
				}
			},
			"UpdateFileSystem": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-02-01/file-systems/{FileSystemId}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"FileSystemId"
					],
					"members": {
						"FileSystemId": {
							"location": "uri",
							"locationName": "FileSystemId"
						},
						"ThroughputMode": {},
						"ProvisionedThroughputInMibps": {
							"type": "double"
						}
					}
				},
				"output": {
					"shape": "Sc"
				}
			}
		},
		"shapes": {
			"S8": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sc": {
				"type": "structure",
				"required": [
					"OwnerId",
					"CreationToken",
					"FileSystemId",
					"CreationTime",
					"LifeCycleState",
					"NumberOfMountTargets",
					"SizeInBytes",
					"PerformanceMode",
					"Tags"
				],
				"members": {
					"OwnerId": {},
					"CreationToken": {},
					"FileSystemId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"LifeCycleState": {},
					"Name": {},
					"NumberOfMountTargets": {
						"type": "integer"
					},
					"SizeInBytes": {
						"type": "structure",
						"required": [
							"Value"
						],
						"members": {
							"Value": {
								"type": "long"
							},
							"Timestamp": {
								"type": "timestamp"
							},
							"ValueInIA": {
								"type": "long"
							},
							"ValueInStandard": {
								"type": "long"
							}
						}
					},
					"PerformanceMode": {},
					"Encrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"ThroughputMode": {},
					"ProvisionedThroughputInMibps": {
						"type": "double"
					},
					"Tags": {
						"shape": "S8"
					}
				}
			},
			"So": {
				"type": "list",
				"member": {}
			},
			"Sq": {
				"type": "structure",
				"required": [
					"MountTargetId",
					"FileSystemId",
					"SubnetId",
					"LifeCycleState"
				],
				"members": {
					"OwnerId": {},
					"MountTargetId": {},
					"FileSystemId": {},
					"SubnetId": {},
					"LifeCycleState": {},
					"IpAddress": {},
					"NetworkInterfaceId": {}
				}
			},
			"S14": {
				"type": "structure",
				"members": {
					"LifecyclePolicies": {
						"shape": "S15"
					}
				}
			},
			"S15": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"TransitionToIA": {}
					}
				}
			}
		}
	};

/***/ },
/* 1730 */
1641,
/* 1731 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-06-01",
			"endpointPrefix": "elasticloadbalancing",
			"protocol": "query",
			"serviceFullName": "Elastic Load Balancing",
			"serviceId": "Elastic Load Balancing",
			"signatureVersion": "v4",
			"uid": "elasticloadbalancing-2012-06-01",
			"xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"
		},
		"operations": {
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerNames",
						"Tags"
					],
					"members": {
						"LoadBalancerNames": {
							"shape": "S2"
						},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"resultWrapper": "AddTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"ApplySecurityGroupsToLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"SecurityGroups"
					],
					"members": {
						"LoadBalancerName": {},
						"SecurityGroups": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "ApplySecurityGroupsToLoadBalancerResult",
					"type": "structure",
					"members": {
						"SecurityGroups": {
							"shape": "Sa"
						}
					}
				}
			},
			"AttachLoadBalancerToSubnets": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Subnets"
					],
					"members": {
						"LoadBalancerName": {},
						"Subnets": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"resultWrapper": "AttachLoadBalancerToSubnetsResult",
					"type": "structure",
					"members": {
						"Subnets": {
							"shape": "Se"
						}
					}
				}
			},
			"ConfigureHealthCheck": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"HealthCheck"
					],
					"members": {
						"LoadBalancerName": {},
						"HealthCheck": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"resultWrapper": "ConfigureHealthCheckResult",
					"type": "structure",
					"members": {
						"HealthCheck": {
							"shape": "Si"
						}
					}
				}
			},
			"CreateAppCookieStickinessPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName",
						"CookieName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {},
						"CookieName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateAppCookieStickinessPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateLBCookieStickinessPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {},
						"CookieExpirationPeriod": {
							"type": "long"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLBCookieStickinessPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Listeners"
					],
					"members": {
						"LoadBalancerName": {},
						"Listeners": {
							"shape": "Sx"
						},
						"AvailabilityZones": {
							"shape": "S13"
						},
						"Subnets": {
							"shape": "Se"
						},
						"SecurityGroups": {
							"shape": "Sa"
						},
						"Scheme": {},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerResult",
					"type": "structure",
					"members": {
						"DNSName": {}
					}
				}
			},
			"CreateLoadBalancerListeners": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Listeners"
					],
					"members": {
						"LoadBalancerName": {},
						"Listeners": {
							"shape": "Sx"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerListenersResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateLoadBalancerPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName",
						"PolicyTypeName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {},
						"PolicyTypeName": {},
						"PolicyAttributes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AttributeName": {},
									"AttributeValue": {}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName"
					],
					"members": {
						"LoadBalancerName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancerListeners": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerPorts"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerPorts": {
							"type": "list",
							"member": {
								"type": "integer"
							}
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerListenersResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancerPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterInstancesFromLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Instances"
					],
					"members": {
						"LoadBalancerName": {},
						"Instances": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"resultWrapper": "DeregisterInstancesFromLoadBalancerResult",
					"type": "structure",
					"members": {
						"Instances": {
							"shape": "S1p"
						}
					}
				}
			},
			"DescribeAccountLimits": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeAccountLimitsResult",
					"type": "structure",
					"members": {
						"Limits": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Max": {}
								}
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeInstanceHealth": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName"
					],
					"members": {
						"LoadBalancerName": {},
						"Instances": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeInstanceHealthResult",
					"type": "structure",
					"members": {
						"InstanceStates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InstanceId": {},
									"State": {},
									"ReasonCode": {},
									"Description": {}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName"
					],
					"members": {
						"LoadBalancerName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"LoadBalancerAttributes": {
							"shape": "S2a"
						}
					}
				}
			},
			"DescribeLoadBalancerPolicies": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerName": {},
						"PolicyNames": {
							"shape": "S2s"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerPoliciesResult",
					"type": "structure",
					"members": {
						"PolicyDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PolicyName": {},
									"PolicyTypeName": {},
									"PolicyAttributeDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"AttributeName": {},
												"AttributeValue": {}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancerPolicyTypes": {
				"input": {
					"type": "structure",
					"members": {
						"PolicyTypeNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerPolicyTypesResult",
					"type": "structure",
					"members": {
						"PolicyTypeDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PolicyTypeName": {},
									"Description": {},
									"PolicyAttributeTypeDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"AttributeName": {},
												"AttributeType": {},
												"Description": {},
												"DefaultValue": {},
												"Cardinality": {}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancers": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerNames": {
							"shape": "S2"
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancersResult",
					"type": "structure",
					"members": {
						"LoadBalancerDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"DNSName": {},
									"CanonicalHostedZoneName": {},
									"CanonicalHostedZoneNameID": {},
									"ListenerDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Listener": {
													"shape": "Sy"
												},
												"PolicyNames": {
													"shape": "S2s"
												}
											}
										}
									},
									"Policies": {
										"type": "structure",
										"members": {
											"AppCookieStickinessPolicies": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"PolicyName": {},
														"CookieName": {}
													}
												}
											},
											"LBCookieStickinessPolicies": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"PolicyName": {},
														"CookieExpirationPeriod": {
															"type": "long"
														}
													}
												}
											},
											"OtherPolicies": {
												"shape": "S2s"
											}
										}
									},
									"BackendServerDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"InstancePort": {
													"type": "integer"
												},
												"PolicyNames": {
													"shape": "S2s"
												}
											}
										}
									},
									"AvailabilityZones": {
										"shape": "S13"
									},
									"Subnets": {
										"shape": "Se"
									},
									"VPCId": {},
									"Instances": {
										"shape": "S1p"
									},
									"HealthCheck": {
										"shape": "Si"
									},
									"SourceSecurityGroup": {
										"type": "structure",
										"members": {
											"OwnerAlias": {},
											"GroupName": {}
										}
									},
									"SecurityGroups": {
										"shape": "Sa"
									},
									"CreatedTime": {
										"type": "timestamp"
									},
									"Scheme": {}
								}
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerNames"
					],
					"members": {
						"LoadBalancerNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"TagDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"Tags": {
										"shape": "S4"
									}
								}
							}
						}
					}
				}
			},
			"DetachLoadBalancerFromSubnets": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Subnets"
					],
					"members": {
						"LoadBalancerName": {},
						"Subnets": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachLoadBalancerFromSubnetsResult",
					"type": "structure",
					"members": {
						"Subnets": {
							"shape": "Se"
						}
					}
				}
			},
			"DisableAvailabilityZonesForLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"AvailabilityZones"
					],
					"members": {
						"LoadBalancerName": {},
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				},
				"output": {
					"resultWrapper": "DisableAvailabilityZonesForLoadBalancerResult",
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				}
			},
			"EnableAvailabilityZonesForLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"AvailabilityZones"
					],
					"members": {
						"LoadBalancerName": {},
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				},
				"output": {
					"resultWrapper": "EnableAvailabilityZonesForLoadBalancerResult",
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				}
			},
			"ModifyLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerAttributes"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerAttributes": {
							"shape": "S2a"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerAttributes": {
							"shape": "S2a"
						}
					}
				}
			},
			"RegisterInstancesWithLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Instances"
					],
					"members": {
						"LoadBalancerName": {},
						"Instances": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"resultWrapper": "RegisterInstancesWithLoadBalancerResult",
					"type": "structure",
					"members": {
						"Instances": {
							"shape": "S1p"
						}
					}
				}
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerNames",
						"Tags"
					],
					"members": {
						"LoadBalancerNames": {
							"shape": "S2"
						},
						"Tags": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "RemoveTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetLoadBalancerListenerSSLCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerPort",
						"SSLCertificateId"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerPort": {
							"type": "integer"
						},
						"SSLCertificateId": {}
					}
				},
				"output": {
					"resultWrapper": "SetLoadBalancerListenerSSLCertificateResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetLoadBalancerPoliciesForBackendServer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"InstancePort",
						"PolicyNames"
					],
					"members": {
						"LoadBalancerName": {},
						"InstancePort": {
							"type": "integer"
						},
						"PolicyNames": {
							"shape": "S2s"
						}
					}
				},
				"output": {
					"resultWrapper": "SetLoadBalancerPoliciesForBackendServerResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetLoadBalancerPoliciesOfListener": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerPort",
						"PolicyNames"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerPort": {
							"type": "integer"
						},
						"PolicyNames": {
							"shape": "S2s"
						}
					}
				},
				"output": {
					"resultWrapper": "SetLoadBalancerPoliciesOfListenerResult",
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sa": {
				"type": "list",
				"member": {}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Si": {
				"type": "structure",
				"required": [
					"Target",
					"Interval",
					"Timeout",
					"UnhealthyThreshold",
					"HealthyThreshold"
				],
				"members": {
					"Target": {},
					"Interval": {
						"type": "integer"
					},
					"Timeout": {
						"type": "integer"
					},
					"UnhealthyThreshold": {
						"type": "integer"
					},
					"HealthyThreshold": {
						"type": "integer"
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"shape": "Sy"
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Protocol",
					"LoadBalancerPort",
					"InstancePort"
				],
				"members": {
					"Protocol": {},
					"LoadBalancerPort": {
						"type": "integer"
					},
					"InstanceProtocol": {},
					"InstancePort": {
						"type": "integer"
					},
					"SSLCertificateId": {}
				}
			},
			"S13": {
				"type": "list",
				"member": {}
			},
			"S1p": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"InstanceId": {}
					}
				}
			},
			"S2a": {
				"type": "structure",
				"members": {
					"CrossZoneLoadBalancing": {
						"type": "structure",
						"required": [
							"Enabled"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							}
						}
					},
					"AccessLog": {
						"type": "structure",
						"required": [
							"Enabled"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"S3BucketName": {},
							"EmitInterval": {
								"type": "integer"
							},
							"S3BucketPrefix": {}
						}
					},
					"ConnectionDraining": {
						"type": "structure",
						"required": [
							"Enabled"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Timeout": {
								"type": "integer"
							}
						}
					},
					"ConnectionSettings": {
						"type": "structure",
						"required": [
							"IdleTimeout"
						],
						"members": {
							"IdleTimeout": {
								"type": "integer"
							}
						}
					},
					"AdditionalAttributes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S2s": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1732 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeInstanceHealth": {
				"result_key": "InstanceStates"
			},
			"DescribeLoadBalancerPolicies": {
				"result_key": "PolicyDescriptions"
			},
			"DescribeLoadBalancerPolicyTypes": {
				"result_key": "PolicyTypeDescriptions"
			},
			"DescribeLoadBalancers": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "LoadBalancerDescriptions"
			}
		}
	};

/***/ },
/* 1733 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"InstanceDeregistered": {
				"delay": 15,
				"operation": "DescribeInstanceHealth",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "OutOfService",
						"matcher": "pathAll",
						"state": "success",
						"argument": "InstanceStates[].State"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstance",
						"state": "success"
					}
				]
			},
			"AnyInstanceInService": {
				"acceptors": [
					{
						"argument": "InstanceStates[].State",
						"expected": "InService",
						"matcher": "pathAny",
						"state": "success"
					}
				],
				"delay": 15,
				"maxAttempts": 40,
				"operation": "DescribeInstanceHealth"
			},
			"InstanceInService": {
				"acceptors": [
					{
						"argument": "InstanceStates[].State",
						"expected": "InService",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstance",
						"state": "retry"
					}
				],
				"delay": 15,
				"maxAttempts": 40,
				"operation": "DescribeInstanceHealth"
			}
		}
	};

/***/ },
/* 1734 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-12-01",
			"endpointPrefix": "elasticloadbalancing",
			"protocol": "query",
			"serviceAbbreviation": "Elastic Load Balancing v2",
			"serviceFullName": "Elastic Load Balancing",
			"serviceId": "Elastic Load Balancing v2",
			"signatureVersion": "v4",
			"uid": "elasticloadbalancingv2-2015-12-01",
			"xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"
		},
		"operations": {
			"AddListenerCertificates": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn",
						"Certificates"
					],
					"members": {
						"ListenerArn": {},
						"Certificates": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"resultWrapper": "AddListenerCertificatesResult",
					"type": "structure",
					"members": {
						"Certificates": {
							"shape": "S3"
						}
					}
				}
			},
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArns",
						"Tags"
					],
					"members": {
						"ResourceArns": {
							"shape": "S9"
						},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "AddTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateListener": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"Protocol",
						"Port",
						"DefaultActions"
					],
					"members": {
						"LoadBalancerArn": {},
						"Protocol": {},
						"Port": {
							"type": "integer"
						},
						"SslPolicy": {},
						"Certificates": {
							"shape": "S3"
						},
						"DefaultActions": {
							"shape": "Sl"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateListenerResult",
					"type": "structure",
					"members": {
						"Listeners": {
							"shape": "S1s"
						}
					}
				}
			},
			"CreateLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Subnets": {
							"shape": "S1w"
						},
						"SubnetMappings": {
							"shape": "S1y"
						},
						"SecurityGroups": {
							"shape": "S21"
						},
						"Scheme": {},
						"Tags": {
							"shape": "Sb"
						},
						"Type": {},
						"IpAddressType": {}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerResult",
					"type": "structure",
					"members": {
						"LoadBalancers": {
							"shape": "S27"
						}
					}
				}
			},
			"CreateRule": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn",
						"Conditions",
						"Priority",
						"Actions"
					],
					"members": {
						"ListenerArn": {},
						"Conditions": {
							"shape": "S2n"
						},
						"Priority": {
							"type": "integer"
						},
						"Actions": {
							"shape": "Sl"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateRuleResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S33"
						}
					}
				}
			},
			"CreateTargetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Protocol": {},
						"Port": {
							"type": "integer"
						},
						"VpcId": {},
						"HealthCheckProtocol": {},
						"HealthCheckPort": {},
						"HealthCheckEnabled": {
							"type": "boolean"
						},
						"HealthCheckPath": {},
						"HealthCheckIntervalSeconds": {
							"type": "integer"
						},
						"HealthCheckTimeoutSeconds": {
							"type": "integer"
						},
						"HealthyThresholdCount": {
							"type": "integer"
						},
						"UnhealthyThresholdCount": {
							"type": "integer"
						},
						"Matcher": {
							"shape": "S3g"
						},
						"TargetType": {}
					}
				},
				"output": {
					"resultWrapper": "CreateTargetGroupResult",
					"type": "structure",
					"members": {
						"TargetGroups": {
							"shape": "S3k"
						}
					}
				}
			},
			"DeleteListener": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn"
					],
					"members": {
						"ListenerArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteListenerResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn"
					],
					"members": {
						"LoadBalancerArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleArn"
					],
					"members": {
						"RuleArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTargetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteTargetGroupResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterTargets": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn",
						"Targets"
					],
					"members": {
						"TargetGroupArn": {},
						"Targets": {
							"shape": "S3w"
						}
					}
				},
				"output": {
					"resultWrapper": "DeregisterTargetsResult",
					"type": "structure",
					"members": {}
				}
			},
			"DescribeAccountLimits": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeAccountLimitsResult",
					"type": "structure",
					"members": {
						"Limits": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Max": {}
								}
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeListenerCertificates": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn"
					],
					"members": {
						"ListenerArn": {},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeListenerCertificatesResult",
					"type": "structure",
					"members": {
						"Certificates": {
							"shape": "S3"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeListeners": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerArn": {},
						"ListenerArns": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeListenersResult",
					"type": "structure",
					"members": {
						"Listeners": {
							"shape": "S1s"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn"
					],
					"members": {
						"LoadBalancerArn": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S4f"
						}
					}
				}
			},
			"DescribeLoadBalancers": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerArns": {
							"shape": "S3m"
						},
						"Names": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancersResult",
					"type": "structure",
					"members": {
						"LoadBalancers": {
							"shape": "S27"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeRules": {
				"input": {
					"type": "structure",
					"members": {
						"ListenerArn": {},
						"RuleArns": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeRulesResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S33"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeSSLPolicies": {
				"input": {
					"type": "structure",
					"members": {
						"Names": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSSLPoliciesResult",
					"type": "structure",
					"members": {
						"SslPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SslProtocols": {
										"type": "list",
										"member": {}
									},
									"Ciphers": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Name": {},
												"Priority": {
													"type": "integer"
												}
											}
										}
									},
									"Name": {}
								}
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArns"
					],
					"members": {
						"ResourceArns": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"TagDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceArn": {},
									"Tags": {
										"shape": "Sb"
									}
								}
							}
						}
					}
				}
			},
			"DescribeTargetGroupAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeTargetGroupAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S56"
						}
					}
				}
			},
			"DescribeTargetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerArn": {},
						"TargetGroupArns": {
							"type": "list",
							"member": {}
						},
						"Names": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTargetGroupsResult",
					"type": "structure",
					"members": {
						"TargetGroups": {
							"shape": "S3k"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeTargetHealth": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {},
						"Targets": {
							"shape": "S3w"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTargetHealthResult",
					"type": "structure",
					"members": {
						"TargetHealthDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Target": {
										"shape": "S3x"
									},
									"HealthCheckPort": {},
									"TargetHealth": {
										"type": "structure",
										"members": {
											"State": {},
											"Reason": {},
											"Description": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"ModifyListener": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn"
					],
					"members": {
						"ListenerArn": {},
						"Port": {
							"type": "integer"
						},
						"Protocol": {},
						"SslPolicy": {},
						"Certificates": {
							"shape": "S3"
						},
						"DefaultActions": {
							"shape": "Sl"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyListenerResult",
					"type": "structure",
					"members": {
						"Listeners": {
							"shape": "S1s"
						}
					}
				}
			},
			"ModifyLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"Attributes"
					],
					"members": {
						"LoadBalancerArn": {},
						"Attributes": {
							"shape": "S4f"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S4f"
						}
					}
				}
			},
			"ModifyRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleArn"
					],
					"members": {
						"RuleArn": {},
						"Conditions": {
							"shape": "S2n"
						},
						"Actions": {
							"shape": "Sl"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyRuleResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S33"
						}
					}
				}
			},
			"ModifyTargetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {},
						"HealthCheckProtocol": {},
						"HealthCheckPort": {},
						"HealthCheckPath": {},
						"HealthCheckEnabled": {
							"type": "boolean"
						},
						"HealthCheckIntervalSeconds": {
							"type": "integer"
						},
						"HealthCheckTimeoutSeconds": {
							"type": "integer"
						},
						"HealthyThresholdCount": {
							"type": "integer"
						},
						"UnhealthyThresholdCount": {
							"type": "integer"
						},
						"Matcher": {
							"shape": "S3g"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyTargetGroupResult",
					"type": "structure",
					"members": {
						"TargetGroups": {
							"shape": "S3k"
						}
					}
				}
			},
			"ModifyTargetGroupAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn",
						"Attributes"
					],
					"members": {
						"TargetGroupArn": {},
						"Attributes": {
							"shape": "S56"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyTargetGroupAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S56"
						}
					}
				}
			},
			"RegisterTargets": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn",
						"Targets"
					],
					"members": {
						"TargetGroupArn": {},
						"Targets": {
							"shape": "S3w"
						}
					}
				},
				"output": {
					"resultWrapper": "RegisterTargetsResult",
					"type": "structure",
					"members": {}
				}
			},
			"RemoveListenerCertificates": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn",
						"Certificates"
					],
					"members": {
						"ListenerArn": {},
						"Certificates": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"resultWrapper": "RemoveListenerCertificatesResult",
					"type": "structure",
					"members": {}
				}
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArns",
						"TagKeys"
					],
					"members": {
						"ResourceArns": {
							"shape": "S9"
						},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "RemoveTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIpAddressType": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"IpAddressType"
					],
					"members": {
						"LoadBalancerArn": {},
						"IpAddressType": {}
					}
				},
				"output": {
					"resultWrapper": "SetIpAddressTypeResult",
					"type": "structure",
					"members": {
						"IpAddressType": {}
					}
				}
			},
			"SetRulePriorities": {
				"input": {
					"type": "structure",
					"required": [
						"RulePriorities"
					],
					"members": {
						"RulePriorities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RuleArn": {},
									"Priority": {
										"type": "integer"
									}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "SetRulePrioritiesResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S33"
						}
					}
				}
			},
			"SetSecurityGroups": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"SecurityGroups"
					],
					"members": {
						"LoadBalancerArn": {},
						"SecurityGroups": {
							"shape": "S21"
						}
					}
				},
				"output": {
					"resultWrapper": "SetSecurityGroupsResult",
					"type": "structure",
					"members": {
						"SecurityGroupIds": {
							"shape": "S21"
						}
					}
				}
			},
			"SetSubnets": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn"
					],
					"members": {
						"LoadBalancerArn": {},
						"Subnets": {
							"shape": "S1w"
						},
						"SubnetMappings": {
							"shape": "S1y"
						}
					}
				},
				"output": {
					"resultWrapper": "SetSubnetsResult",
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"shape": "S2g"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"CertificateArn": {},
						"IsDefault": {
							"type": "boolean"
						}
					}
				}
			},
			"S9": {
				"type": "list",
				"member": {}
			},
			"Sb": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sl": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"Type": {},
						"TargetGroupArn": {},
						"AuthenticateOidcConfig": {
							"type": "structure",
							"required": [
								"Issuer",
								"AuthorizationEndpoint",
								"TokenEndpoint",
								"UserInfoEndpoint",
								"ClientId"
							],
							"members": {
								"Issuer": {},
								"AuthorizationEndpoint": {},
								"TokenEndpoint": {},
								"UserInfoEndpoint": {},
								"ClientId": {},
								"ClientSecret": {},
								"SessionCookieName": {},
								"Scope": {},
								"SessionTimeout": {
									"type": "long"
								},
								"AuthenticationRequestExtraParams": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"OnUnauthenticatedRequest": {},
								"UseExistingClientSecret": {
									"type": "boolean"
								}
							}
						},
						"AuthenticateCognitoConfig": {
							"type": "structure",
							"required": [
								"UserPoolArn",
								"UserPoolClientId",
								"UserPoolDomain"
							],
							"members": {
								"UserPoolArn": {},
								"UserPoolClientId": {},
								"UserPoolDomain": {},
								"SessionCookieName": {},
								"Scope": {},
								"SessionTimeout": {
									"type": "long"
								},
								"AuthenticationRequestExtraParams": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"OnUnauthenticatedRequest": {}
							}
						},
						"Order": {
							"type": "integer"
						},
						"RedirectConfig": {
							"type": "structure",
							"required": [
								"StatusCode"
							],
							"members": {
								"Protocol": {},
								"Port": {},
								"Host": {},
								"Path": {},
								"Query": {},
								"StatusCode": {}
							}
						},
						"FixedResponseConfig": {
							"type": "structure",
							"required": [
								"StatusCode"
							],
							"members": {
								"MessageBody": {},
								"StatusCode": {},
								"ContentType": {}
							}
						}
					}
				}
			},
			"S1s": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ListenerArn": {},
						"LoadBalancerArn": {},
						"Port": {
							"type": "integer"
						},
						"Protocol": {},
						"Certificates": {
							"shape": "S3"
						},
						"SslPolicy": {},
						"DefaultActions": {
							"shape": "Sl"
						}
					}
				}
			},
			"S1w": {
				"type": "list",
				"member": {}
			},
			"S1y": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"SubnetId": {},
						"AllocationId": {}
					}
				}
			},
			"S21": {
				"type": "list",
				"member": {}
			},
			"S27": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"LoadBalancerArn": {},
						"DNSName": {},
						"CanonicalHostedZoneId": {},
						"CreatedTime": {
							"type": "timestamp"
						},
						"LoadBalancerName": {},
						"Scheme": {},
						"VpcId": {},
						"State": {
							"type": "structure",
							"members": {
								"Code": {},
								"Reason": {}
							}
						},
						"Type": {},
						"AvailabilityZones": {
							"shape": "S2g"
						},
						"SecurityGroups": {
							"shape": "S21"
						},
						"IpAddressType": {}
					}
				}
			},
			"S2g": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ZoneName": {},
						"SubnetId": {},
						"LoadBalancerAddresses": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IpAddress": {},
									"AllocationId": {}
								}
							}
						}
					}
				}
			},
			"S2n": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Field": {},
						"Values": {
							"shape": "S2q"
						},
						"HostHeaderConfig": {
							"type": "structure",
							"members": {
								"Values": {
									"shape": "S2q"
								}
							}
						},
						"PathPatternConfig": {
							"type": "structure",
							"members": {
								"Values": {
									"shape": "S2q"
								}
							}
						},
						"HttpHeaderConfig": {
							"type": "structure",
							"members": {
								"HttpHeaderName": {},
								"Values": {
									"shape": "S2q"
								}
							}
						},
						"QueryStringConfig": {
							"type": "structure",
							"members": {
								"Values": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Key": {},
											"Value": {}
										}
									}
								}
							}
						},
						"HttpRequestMethodConfig": {
							"type": "structure",
							"members": {
								"Values": {
									"shape": "S2q"
								}
							}
						},
						"SourceIpConfig": {
							"type": "structure",
							"members": {
								"Values": {
									"shape": "S2q"
								}
							}
						}
					}
				}
			},
			"S2q": {
				"type": "list",
				"member": {}
			},
			"S33": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"RuleArn": {},
						"Priority": {},
						"Conditions": {
							"shape": "S2n"
						},
						"Actions": {
							"shape": "Sl"
						},
						"IsDefault": {
							"type": "boolean"
						}
					}
				}
			},
			"S3g": {
				"type": "structure",
				"required": [
					"HttpCode"
				],
				"members": {
					"HttpCode": {}
				}
			},
			"S3k": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"TargetGroupArn": {},
						"TargetGroupName": {},
						"Protocol": {},
						"Port": {
							"type": "integer"
						},
						"VpcId": {},
						"HealthCheckProtocol": {},
						"HealthCheckPort": {},
						"HealthCheckEnabled": {
							"type": "boolean"
						},
						"HealthCheckIntervalSeconds": {
							"type": "integer"
						},
						"HealthCheckTimeoutSeconds": {
							"type": "integer"
						},
						"HealthyThresholdCount": {
							"type": "integer"
						},
						"UnhealthyThresholdCount": {
							"type": "integer"
						},
						"HealthCheckPath": {},
						"Matcher": {
							"shape": "S3g"
						},
						"LoadBalancerArns": {
							"shape": "S3m"
						},
						"TargetType": {}
					}
				}
			},
			"S3m": {
				"type": "list",
				"member": {}
			},
			"S3w": {
				"type": "list",
				"member": {
					"shape": "S3x"
				}
			},
			"S3x": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {}
				}
			},
			"S4f": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S56": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			}
		}
	};

/***/ },
/* 1735 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeListeners": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "Listeners"
			},
			"DescribeLoadBalancers": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "LoadBalancers"
			},
			"DescribeTargetGroups": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "TargetGroups"
			}
		}
	};

/***/ },
/* 1736 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"LoadBalancerExists": {
				"delay": 15,
				"operation": "DescribeLoadBalancers",
				"maxAttempts": 40,
				"acceptors": [
					{
						"matcher": "status",
						"expected": 200,
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "LoadBalancerNotFound",
						"state": "retry"
					}
				]
			},
			"LoadBalancerAvailable": {
				"delay": 15,
				"operation": "DescribeLoadBalancers",
				"maxAttempts": 40,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "LoadBalancers[].State.Code",
						"expected": "active"
					},
					{
						"state": "retry",
						"matcher": "pathAny",
						"argument": "LoadBalancers[].State.Code",
						"expected": "provisioning"
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "LoadBalancerNotFound"
					}
				]
			},
			"LoadBalancersDeleted": {
				"delay": 15,
				"operation": "DescribeLoadBalancers",
				"maxAttempts": 40,
				"acceptors": [
					{
						"state": "retry",
						"matcher": "pathAll",
						"argument": "LoadBalancers[].State.Code",
						"expected": "active"
					},
					{
						"matcher": "error",
						"expected": "LoadBalancerNotFound",
						"state": "success"
					}
				]
			},
			"TargetInService": {
				"delay": 15,
				"maxAttempts": 40,
				"operation": "DescribeTargetHealth",
				"acceptors": [
					{
						"argument": "TargetHealthDescriptions[].TargetHealth.State",
						"expected": "healthy",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstance",
						"state": "retry"
					}
				]
			},
			"TargetDeregistered": {
				"delay": 15,
				"maxAttempts": 40,
				"operation": "DescribeTargetHealth",
				"acceptors": [
					{
						"matcher": "error",
						"expected": "InvalidTarget",
						"state": "success"
					},
					{
						"argument": "TargetHealthDescriptions[].TargetHealth.State",
						"expected": "unused",
						"matcher": "pathAll",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 1737 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2009-03-31",
			"endpointPrefix": "elasticmapreduce",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon EMR",
			"serviceFullName": "Amazon Elastic MapReduce",
			"serviceId": "EMR",
			"signatureVersion": "v4",
			"targetPrefix": "ElasticMapReduce",
			"uid": "elasticmapreduce-2009-03-31"
		},
		"operations": {
			"AddInstanceFleet": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"InstanceFleet"
					],
					"members": {
						"ClusterId": {},
						"InstanceFleet": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClusterId": {},
						"InstanceFleetId": {}
					}
				}
			},
			"AddInstanceGroups": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceGroups",
						"JobFlowId"
					],
					"members": {
						"InstanceGroups": {
							"shape": "Sq"
						},
						"JobFlowId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobFlowId": {},
						"InstanceGroupIds": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"AddJobFlowSteps": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowId",
						"Steps"
					],
					"members": {
						"JobFlowId": {},
						"Steps": {
							"shape": "S1b"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StepIds": {
							"shape": "S1k"
						}
					}
				}
			},
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"Tags"
					],
					"members": {
						"ResourceId": {},
						"Tags": {
							"shape": "S1n"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelSteps": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterId": {},
						"StepIds": {
							"shape": "S1k"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CancelStepsInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StepId": {},
									"Status": {},
									"Reason": {}
								}
							}
						}
					}
				}
			},
			"CreateSecurityConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"SecurityConfiguration"
					],
					"members": {
						"Name": {},
						"SecurityConfiguration": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Name",
						"CreationDateTime"
					],
					"members": {
						"Name": {},
						"CreationDateTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"DeleteSecurityConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Cluster": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Status": {
									"shape": "S25"
								},
								"Ec2InstanceAttributes": {
									"type": "structure",
									"members": {
										"Ec2KeyName": {},
										"Ec2SubnetId": {},
										"RequestedEc2SubnetIds": {
											"shape": "S2b"
										},
										"Ec2AvailabilityZone": {},
										"RequestedEc2AvailabilityZones": {
											"shape": "S2b"
										},
										"IamInstanceProfile": {},
										"EmrManagedMasterSecurityGroup": {},
										"EmrManagedSlaveSecurityGroup": {},
										"ServiceAccessSecurityGroup": {},
										"AdditionalMasterSecurityGroups": {
											"shape": "S2c"
										},
										"AdditionalSlaveSecurityGroups": {
											"shape": "S2c"
										}
									}
								},
								"InstanceCollectionType": {},
								"LogUri": {},
								"RequestedAmiVersion": {},
								"RunningAmiVersion": {},
								"ReleaseLabel": {},
								"AutoTerminate": {
									"type": "boolean"
								},
								"TerminationProtected": {
									"type": "boolean"
								},
								"VisibleToAllUsers": {
									"type": "boolean"
								},
								"Applications": {
									"shape": "S2f"
								},
								"Tags": {
									"shape": "S1n"
								},
								"ServiceRole": {},
								"NormalizedInstanceHours": {
									"type": "integer"
								},
								"MasterPublicDnsName": {},
								"Configurations": {
									"shape": "Sh"
								},
								"SecurityConfiguration": {},
								"AutoScalingRole": {},
								"ScaleDownBehavior": {},
								"CustomAmiId": {},
								"EbsRootVolumeSize": {
									"type": "integer"
								},
								"RepoUpgradeOnBoot": {},
								"KerberosAttributes": {
									"shape": "S2j"
								}
							}
						}
					}
				}
			},
			"DescribeJobFlows": {
				"input": {
					"type": "structure",
					"members": {
						"CreatedAfter": {
							"type": "timestamp"
						},
						"CreatedBefore": {
							"type": "timestamp"
						},
						"JobFlowIds": {
							"shape": "S1i"
						},
						"JobFlowStates": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobFlows": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"JobFlowId",
									"Name",
									"ExecutionStatusDetail",
									"Instances"
								],
								"members": {
									"JobFlowId": {},
									"Name": {},
									"LogUri": {},
									"AmiVersion": {},
									"ExecutionStatusDetail": {
										"type": "structure",
										"required": [
											"State",
											"CreationDateTime"
										],
										"members": {
											"State": {},
											"CreationDateTime": {
												"type": "timestamp"
											},
											"StartDateTime": {
												"type": "timestamp"
											},
											"ReadyDateTime": {
												"type": "timestamp"
											},
											"EndDateTime": {
												"type": "timestamp"
											},
											"LastStateChangeReason": {}
										}
									},
									"Instances": {
										"type": "structure",
										"required": [
											"MasterInstanceType",
											"SlaveInstanceType",
											"InstanceCount"
										],
										"members": {
											"MasterInstanceType": {},
											"MasterPublicDnsName": {},
											"MasterInstanceId": {},
											"SlaveInstanceType": {},
											"InstanceCount": {
												"type": "integer"
											},
											"InstanceGroups": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"Market",
														"InstanceRole",
														"InstanceType",
														"InstanceRequestCount",
														"InstanceRunningCount",
														"State",
														"CreationDateTime"
													],
													"members": {
														"InstanceGroupId": {},
														"Name": {},
														"Market": {},
														"InstanceRole": {},
														"BidPrice": {},
														"InstanceType": {},
														"InstanceRequestCount": {
															"type": "integer"
														},
														"InstanceRunningCount": {
															"type": "integer"
														},
														"State": {},
														"LastStateChangeReason": {},
														"CreationDateTime": {
															"type": "timestamp"
														},
														"StartDateTime": {
															"type": "timestamp"
														},
														"ReadyDateTime": {
															"type": "timestamp"
														},
														"EndDateTime": {
															"type": "timestamp"
														}
													}
												}
											},
											"NormalizedInstanceHours": {
												"type": "integer"
											},
											"Ec2KeyName": {},
											"Ec2SubnetId": {},
											"Placement": {
												"shape": "S2v"
											},
											"KeepJobFlowAliveWhenNoSteps": {
												"type": "boolean"
											},
											"TerminationProtected": {
												"type": "boolean"
											},
											"HadoopVersion": {}
										}
									},
									"Steps": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"StepConfig",
												"ExecutionStatusDetail"
											],
											"members": {
												"StepConfig": {
													"shape": "S1c"
												},
												"ExecutionStatusDetail": {
													"type": "structure",
													"required": [
														"State",
														"CreationDateTime"
													],
													"members": {
														"State": {},
														"CreationDateTime": {
															"type": "timestamp"
														},
														"StartDateTime": {
															"type": "timestamp"
														},
														"EndDateTime": {
															"type": "timestamp"
														},
														"LastStateChangeReason": {}
													}
												}
											}
										}
									},
									"BootstrapActions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"BootstrapActionConfig": {
													"shape": "S32"
												}
											}
										}
									},
									"SupportedProducts": {
										"shape": "S34"
									},
									"VisibleToAllUsers": {
										"type": "boolean"
									},
									"JobFlowRole": {},
									"ServiceRole": {},
									"AutoScalingRole": {},
									"ScaleDownBehavior": {}
								}
							}
						}
					}
				},
				"deprecated": true
			},
			"DescribeSecurityConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"SecurityConfiguration": {},
						"CreationDateTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeStep": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"StepId"
					],
					"members": {
						"ClusterId": {},
						"StepId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Step": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Config": {
									"shape": "S3a"
								},
								"ActionOnFailure": {},
								"Status": {
									"shape": "S3b"
								}
							}
						}
					}
				}
			},
			"ListBootstrapActions": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BootstrapActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"ScriptPath": {},
									"Args": {
										"shape": "S2c"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListClusters": {
				"input": {
					"type": "structure",
					"members": {
						"CreatedAfter": {
							"type": "timestamp"
						},
						"CreatedBefore": {
							"type": "timestamp"
						},
						"ClusterStates": {
							"type": "list",
							"member": {}
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Clusters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Status": {
										"shape": "S25"
									},
									"NormalizedInstanceHours": {
										"type": "integer"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListInstanceFleets": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceFleets": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Status": {
										"type": "structure",
										"members": {
											"State": {},
											"StateChangeReason": {
												"type": "structure",
												"members": {
													"Code": {},
													"Message": {}
												}
											},
											"Timeline": {
												"type": "structure",
												"members": {
													"CreationDateTime": {
														"type": "timestamp"
													},
													"ReadyDateTime": {
														"type": "timestamp"
													},
													"EndDateTime": {
														"type": "timestamp"
													}
												}
											}
										}
									},
									"InstanceFleetType": {},
									"TargetOnDemandCapacity": {
										"type": "integer"
									},
									"TargetSpotCapacity": {
										"type": "integer"
									},
									"ProvisionedOnDemandCapacity": {
										"type": "integer"
									},
									"ProvisionedSpotCapacity": {
										"type": "integer"
									},
									"InstanceTypeSpecifications": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"InstanceType": {},
												"WeightedCapacity": {
													"type": "integer"
												},
												"BidPrice": {},
												"BidPriceAsPercentageOfOnDemandPrice": {
													"type": "double"
												},
												"Configurations": {
													"shape": "Sh"
												},
												"EbsBlockDevices": {
													"shape": "S42"
												},
												"EbsOptimized": {
													"type": "boolean"
												}
											}
										}
									},
									"LaunchSpecifications": {
										"shape": "Sk"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListInstanceGroups": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Market": {},
									"InstanceGroupType": {},
									"BidPrice": {},
									"InstanceType": {},
									"RequestedInstanceCount": {
										"type": "integer"
									},
									"RunningInstanceCount": {
										"type": "integer"
									},
									"Status": {
										"type": "structure",
										"members": {
											"State": {},
											"StateChangeReason": {
												"type": "structure",
												"members": {
													"Code": {},
													"Message": {}
												}
											},
											"Timeline": {
												"type": "structure",
												"members": {
													"CreationDateTime": {
														"type": "timestamp"
													},
													"ReadyDateTime": {
														"type": "timestamp"
													},
													"EndDateTime": {
														"type": "timestamp"
													}
												}
											}
										}
									},
									"Configurations": {
										"shape": "Sh"
									},
									"ConfigurationsVersion": {
										"type": "long"
									},
									"LastSuccessfullyAppliedConfigurations": {
										"shape": "Sh"
									},
									"LastSuccessfullyAppliedConfigurationsVersion": {
										"type": "long"
									},
									"EbsBlockDevices": {
										"shape": "S42"
									},
									"EbsOptimized": {
										"type": "boolean"
									},
									"ShrinkPolicy": {
										"shape": "S4f"
									},
									"AutoScalingPolicy": {
										"shape": "S4j"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListInstances": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {},
						"InstanceGroupTypes": {
							"type": "list",
							"member": {}
						},
						"InstanceFleetId": {},
						"InstanceFleetType": {},
						"InstanceStates": {
							"type": "list",
							"member": {}
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Ec2InstanceId": {},
									"PublicDnsName": {},
									"PublicIpAddress": {},
									"PrivateDnsName": {},
									"PrivateIpAddress": {},
									"Status": {
										"type": "structure",
										"members": {
											"State": {},
											"StateChangeReason": {
												"type": "structure",
												"members": {
													"Code": {},
													"Message": {}
												}
											},
											"Timeline": {
												"type": "structure",
												"members": {
													"CreationDateTime": {
														"type": "timestamp"
													},
													"ReadyDateTime": {
														"type": "timestamp"
													},
													"EndDateTime": {
														"type": "timestamp"
													}
												}
											}
										}
									},
									"InstanceGroupId": {},
									"InstanceFleetId": {},
									"Market": {},
									"InstanceType": {},
									"EbsVolumes": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Device": {},
												"VolumeId": {}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListSecurityConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecurityConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"CreationDateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListSteps": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"StepStates": {
							"type": "list",
							"member": {}
						},
						"StepIds": {
							"shape": "S1i"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Steps": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Config": {
										"shape": "S3a"
									},
									"ActionOnFailure": {},
									"Status": {
										"shape": "S3b"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ModifyInstanceFleet": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"InstanceFleet"
					],
					"members": {
						"ClusterId": {},
						"InstanceFleet": {
							"type": "structure",
							"required": [
								"InstanceFleetId"
							],
							"members": {
								"InstanceFleetId": {},
								"TargetOnDemandCapacity": {
									"type": "integer"
								},
								"TargetSpotCapacity": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"ModifyInstanceGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterId": {},
						"InstanceGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"InstanceGroupId"
								],
								"members": {
									"InstanceGroupId": {},
									"InstanceCount": {
										"type": "integer"
									},
									"EC2InstanceIdsToTerminate": {
										"type": "list",
										"member": {}
									},
									"ShrinkPolicy": {
										"shape": "S4f"
									},
									"Configurations": {
										"shape": "Sh"
									}
								}
							}
						}
					}
				}
			},
			"PutAutoScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"InstanceGroupId",
						"AutoScalingPolicy"
					],
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {},
						"AutoScalingPolicy": {
							"shape": "Su"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {},
						"AutoScalingPolicy": {
							"shape": "S4j"
						}
					}
				}
			},
			"RemoveAutoScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"InstanceGroupId"
					],
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"TagKeys"
					],
					"members": {
						"ResourceId": {},
						"TagKeys": {
							"shape": "S2c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RunJobFlow": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Instances"
					],
					"members": {
						"Name": {},
						"LogUri": {},
						"AdditionalInfo": {},
						"AmiVersion": {},
						"ReleaseLabel": {},
						"Instances": {
							"type": "structure",
							"members": {
								"MasterInstanceType": {},
								"SlaveInstanceType": {},
								"InstanceCount": {
									"type": "integer"
								},
								"InstanceGroups": {
									"shape": "Sq"
								},
								"InstanceFleets": {
									"type": "list",
									"member": {
										"shape": "S3"
									}
								},
								"Ec2KeyName": {},
								"Placement": {
									"shape": "S2v"
								},
								"KeepJobFlowAliveWhenNoSteps": {
									"type": "boolean"
								},
								"TerminationProtected": {
									"type": "boolean"
								},
								"HadoopVersion": {},
								"Ec2SubnetId": {},
								"Ec2SubnetIds": {
									"shape": "S2b"
								},
								"EmrManagedMasterSecurityGroup": {},
								"EmrManagedSlaveSecurityGroup": {},
								"ServiceAccessSecurityGroup": {},
								"AdditionalMasterSecurityGroups": {
									"shape": "S5p"
								},
								"AdditionalSlaveSecurityGroups": {
									"shape": "S5p"
								}
							}
						},
						"Steps": {
							"shape": "S1b"
						},
						"BootstrapActions": {
							"type": "list",
							"member": {
								"shape": "S32"
							}
						},
						"SupportedProducts": {
							"shape": "S34"
						},
						"NewSupportedProducts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Args": {
										"shape": "S1i"
									}
								}
							}
						},
						"Applications": {
							"shape": "S2f"
						},
						"Configurations": {
							"shape": "Sh"
						},
						"VisibleToAllUsers": {
							"type": "boolean"
						},
						"JobFlowRole": {},
						"ServiceRole": {},
						"Tags": {
							"shape": "S1n"
						},
						"SecurityConfiguration": {},
						"AutoScalingRole": {},
						"ScaleDownBehavior": {},
						"CustomAmiId": {},
						"EbsRootVolumeSize": {
							"type": "integer"
						},
						"RepoUpgradeOnBoot": {},
						"KerberosAttributes": {
							"shape": "S2j"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobFlowId": {}
					}
				}
			},
			"SetTerminationProtection": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowIds",
						"TerminationProtected"
					],
					"members": {
						"JobFlowIds": {
							"shape": "S1i"
						},
						"TerminationProtected": {
							"type": "boolean"
						}
					}
				}
			},
			"SetVisibleToAllUsers": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowIds",
						"VisibleToAllUsers"
					],
					"members": {
						"JobFlowIds": {
							"shape": "S1i"
						},
						"VisibleToAllUsers": {
							"type": "boolean"
						}
					}
				}
			},
			"TerminateJobFlows": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowIds"
					],
					"members": {
						"JobFlowIds": {
							"shape": "S1i"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "structure",
				"required": [
					"InstanceFleetType"
				],
				"members": {
					"Name": {},
					"InstanceFleetType": {},
					"TargetOnDemandCapacity": {
						"type": "integer"
					},
					"TargetSpotCapacity": {
						"type": "integer"
					},
					"InstanceTypeConfigs": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"InstanceType"
							],
							"members": {
								"InstanceType": {},
								"WeightedCapacity": {
									"type": "integer"
								},
								"BidPrice": {},
								"BidPriceAsPercentageOfOnDemandPrice": {
									"type": "double"
								},
								"EbsConfiguration": {
									"shape": "Sa"
								},
								"Configurations": {
									"shape": "Sh"
								}
							}
						}
					},
					"LaunchSpecifications": {
						"shape": "Sk"
					}
				}
			},
			"Sa": {
				"type": "structure",
				"members": {
					"EbsBlockDeviceConfigs": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"VolumeSpecification"
							],
							"members": {
								"VolumeSpecification": {
									"shape": "Sd"
								},
								"VolumesPerInstance": {
									"type": "integer"
								}
							}
						}
					},
					"EbsOptimized": {
						"type": "boolean"
					}
				}
			},
			"Sd": {
				"type": "structure",
				"required": [
					"VolumeType",
					"SizeInGB"
				],
				"members": {
					"VolumeType": {},
					"Iops": {
						"type": "integer"
					},
					"SizeInGB": {
						"type": "integer"
					}
				}
			},
			"Sh": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Classification": {},
						"Configurations": {
							"shape": "Sh"
						},
						"Properties": {
							"shape": "Sj"
						}
					}
				}
			},
			"Sj": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sk": {
				"type": "structure",
				"required": [
					"SpotSpecification"
				],
				"members": {
					"SpotSpecification": {
						"type": "structure",
						"required": [
							"TimeoutDurationMinutes",
							"TimeoutAction"
						],
						"members": {
							"TimeoutDurationMinutes": {
								"type": "integer"
							},
							"TimeoutAction": {},
							"BlockDurationMinutes": {
								"type": "integer"
							}
						}
					}
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"InstanceRole",
						"InstanceType",
						"InstanceCount"
					],
					"members": {
						"Name": {},
						"Market": {},
						"InstanceRole": {},
						"BidPrice": {},
						"InstanceType": {},
						"InstanceCount": {
							"type": "integer"
						},
						"Configurations": {
							"shape": "Sh"
						},
						"EbsConfiguration": {
							"shape": "Sa"
						},
						"AutoScalingPolicy": {
							"shape": "Su"
						}
					}
				}
			},
			"Su": {
				"type": "structure",
				"required": [
					"Constraints",
					"Rules"
				],
				"members": {
					"Constraints": {
						"shape": "Sv"
					},
					"Rules": {
						"shape": "Sw"
					}
				}
			},
			"Sv": {
				"type": "structure",
				"required": [
					"MinCapacity",
					"MaxCapacity"
				],
				"members": {
					"MinCapacity": {
						"type": "integer"
					},
					"MaxCapacity": {
						"type": "integer"
					}
				}
			},
			"Sw": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Action",
						"Trigger"
					],
					"members": {
						"Name": {},
						"Description": {},
						"Action": {
							"type": "structure",
							"required": [
								"SimpleScalingPolicyConfiguration"
							],
							"members": {
								"Market": {},
								"SimpleScalingPolicyConfiguration": {
									"type": "structure",
									"required": [
										"ScalingAdjustment"
									],
									"members": {
										"AdjustmentType": {},
										"ScalingAdjustment": {
											"type": "integer"
										},
										"CoolDown": {
											"type": "integer"
										}
									}
								}
							}
						},
						"Trigger": {
							"type": "structure",
							"required": [
								"CloudWatchAlarmDefinition"
							],
							"members": {
								"CloudWatchAlarmDefinition": {
									"type": "structure",
									"required": [
										"ComparisonOperator",
										"MetricName",
										"Period",
										"Threshold"
									],
									"members": {
										"ComparisonOperator": {},
										"EvaluationPeriods": {
											"type": "integer"
										},
										"MetricName": {},
										"Namespace": {},
										"Period": {
											"type": "integer"
										},
										"Statistic": {},
										"Threshold": {
											"type": "double"
										},
										"Unit": {},
										"Dimensions": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"Key": {},
													"Value": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S1b": {
				"type": "list",
				"member": {
					"shape": "S1c"
				}
			},
			"S1c": {
				"type": "structure",
				"required": [
					"Name",
					"HadoopJarStep"
				],
				"members": {
					"Name": {},
					"ActionOnFailure": {},
					"HadoopJarStep": {
						"type": "structure",
						"required": [
							"Jar"
						],
						"members": {
							"Properties": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Key": {},
										"Value": {}
									}
								}
							},
							"Jar": {},
							"MainClass": {},
							"Args": {
								"shape": "S1i"
							}
						}
					}
				}
			},
			"S1i": {
				"type": "list",
				"member": {}
			},
			"S1k": {
				"type": "list",
				"member": {}
			},
			"S1n": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S25": {
				"type": "structure",
				"members": {
					"State": {},
					"StateChangeReason": {
						"type": "structure",
						"members": {
							"Code": {},
							"Message": {}
						}
					},
					"Timeline": {
						"type": "structure",
						"members": {
							"CreationDateTime": {
								"type": "timestamp"
							},
							"ReadyDateTime": {
								"type": "timestamp"
							},
							"EndDateTime": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"S2b": {
				"type": "list",
				"member": {}
			},
			"S2c": {
				"type": "list",
				"member": {}
			},
			"S2f": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Name": {},
						"Version": {},
						"Args": {
							"shape": "S2c"
						},
						"AdditionalInfo": {
							"shape": "Sj"
						}
					}
				}
			},
			"S2j": {
				"type": "structure",
				"required": [
					"Realm",
					"KdcAdminPassword"
				],
				"members": {
					"Realm": {},
					"KdcAdminPassword": {},
					"CrossRealmTrustPrincipalPassword": {},
					"ADDomainJoinUser": {},
					"ADDomainJoinPassword": {}
				}
			},
			"S2v": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {},
					"AvailabilityZones": {
						"shape": "S2b"
					}
				}
			},
			"S32": {
				"type": "structure",
				"required": [
					"Name",
					"ScriptBootstrapAction"
				],
				"members": {
					"Name": {},
					"ScriptBootstrapAction": {
						"type": "structure",
						"required": [
							"Path"
						],
						"members": {
							"Path": {},
							"Args": {
								"shape": "S1i"
							}
						}
					}
				}
			},
			"S34": {
				"type": "list",
				"member": {}
			},
			"S3a": {
				"type": "structure",
				"members": {
					"Jar": {},
					"Properties": {
						"shape": "Sj"
					},
					"MainClass": {},
					"Args": {
						"shape": "S2c"
					}
				}
			},
			"S3b": {
				"type": "structure",
				"members": {
					"State": {},
					"StateChangeReason": {
						"type": "structure",
						"members": {
							"Code": {},
							"Message": {}
						}
					},
					"FailureDetails": {
						"type": "structure",
						"members": {
							"Reason": {},
							"Message": {},
							"LogFile": {}
						}
					},
					"Timeline": {
						"type": "structure",
						"members": {
							"CreationDateTime": {
								"type": "timestamp"
							},
							"StartDateTime": {
								"type": "timestamp"
							},
							"EndDateTime": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"S42": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"VolumeSpecification": {
							"shape": "Sd"
						},
						"Device": {}
					}
				}
			},
			"S4f": {
				"type": "structure",
				"members": {
					"DecommissionTimeout": {
						"type": "integer"
					},
					"InstanceResizePolicy": {
						"type": "structure",
						"members": {
							"InstancesToTerminate": {
								"shape": "S4h"
							},
							"InstancesToProtect": {
								"shape": "S4h"
							},
							"InstanceTerminationTimeout": {
								"type": "integer"
							}
						}
					}
				}
			},
			"S4h": {
				"type": "list",
				"member": {}
			},
			"S4j": {
				"type": "structure",
				"members": {
					"Status": {
						"type": "structure",
						"members": {
							"State": {},
							"StateChangeReason": {
								"type": "structure",
								"members": {
									"Code": {},
									"Message": {}
								}
							}
						}
					},
					"Constraints": {
						"shape": "Sv"
					},
					"Rules": {
						"shape": "Sw"
					}
				}
			},
			"S5p": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1738 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeJobFlows": {
				"result_key": "JobFlows"
			},
			"ListBootstrapActions": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "BootstrapActions"
			},
			"ListClusters": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "Clusters"
			},
			"ListInstanceFleets": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "InstanceFleets"
			},
			"ListInstanceGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "InstanceGroups"
			},
			"ListInstances": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "Instances"
			},
			"ListSecurityConfigurations": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "SecurityConfigurations"
			},
			"ListSteps": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "Steps"
			}
		}
	};

/***/ },
/* 1739 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"ClusterRunning": {
				"delay": 30,
				"operation": "DescribeCluster",
				"maxAttempts": 60,
				"acceptors": [
					{
						"state": "success",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "RUNNING"
					},
					{
						"state": "success",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "WAITING"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATING"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATED"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATED_WITH_ERRORS"
					}
				]
			},
			"StepComplete": {
				"delay": 30,
				"operation": "DescribeStep",
				"maxAttempts": 60,
				"acceptors": [
					{
						"state": "success",
						"matcher": "path",
						"argument": "Step.Status.State",
						"expected": "COMPLETED"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Step.Status.State",
						"expected": "FAILED"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Step.Status.State",
						"expected": "CANCELLED"
					}
				]
			},
			"ClusterTerminated": {
				"delay": 30,
				"operation": "DescribeCluster",
				"maxAttempts": 60,
				"acceptors": [
					{
						"state": "success",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATED"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATED_WITH_ERRORS"
					}
				]
			}
		}
	};

/***/ },
/* 1740 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-09-25",
			"endpointPrefix": "elastictranscoder",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Elastic Transcoder",
			"serviceId": "Elastic Transcoder",
			"signatureVersion": "v4",
			"uid": "elastictranscoder-2012-09-25"
		},
		"operations": {
			"CancelJob": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2012-09-25/jobs/{Id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateJob": {
				"http": {
					"requestUri": "/2012-09-25/jobs",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"PipelineId"
					],
					"members": {
						"PipelineId": {},
						"Input": {
							"shape": "S5"
						},
						"Inputs": {
							"shape": "St"
						},
						"Output": {
							"shape": "Su"
						},
						"Outputs": {
							"type": "list",
							"member": {
								"shape": "Su"
							}
						},
						"OutputKeyPrefix": {},
						"Playlists": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Format": {},
									"OutputKeys": {
										"shape": "S1l"
									},
									"HlsContentProtection": {
										"shape": "S1m"
									},
									"PlayReadyDrm": {
										"shape": "S1q"
									}
								}
							}
						},
						"UserMetadata": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Job": {
							"shape": "S1y"
						}
					}
				}
			},
			"CreatePipeline": {
				"http": {
					"requestUri": "/2012-09-25/pipelines",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"InputBucket",
						"Role"
					],
					"members": {
						"Name": {},
						"InputBucket": {},
						"OutputBucket": {},
						"Role": {},
						"AwsKmsKeyArn": {},
						"Notifications": {
							"shape": "S2a"
						},
						"ContentConfig": {
							"shape": "S2c"
						},
						"ThumbnailConfig": {
							"shape": "S2c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						},
						"Warnings": {
							"shape": "S2n"
						}
					}
				}
			},
			"CreatePreset": {
				"http": {
					"requestUri": "/2012-09-25/presets",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Container"
					],
					"members": {
						"Name": {},
						"Description": {},
						"Container": {},
						"Video": {
							"shape": "S2r"
						},
						"Audio": {
							"shape": "S37"
						},
						"Thumbnails": {
							"shape": "S3i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Preset": {
							"shape": "S3m"
						},
						"Warning": {}
					}
				}
			},
			"DeletePipeline": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2012-09-25/pipelines/{Id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePreset": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2012-09-25/presets/{Id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ListJobsByPipeline": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/jobsByPipeline/{PipelineId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"PipelineId"
					],
					"members": {
						"PipelineId": {
							"location": "uri",
							"locationName": "PipelineId"
						},
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Jobs": {
							"shape": "S3v"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListJobsByStatus": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/jobsByStatus/{Status}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {
							"location": "uri",
							"locationName": "Status"
						},
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Jobs": {
							"shape": "S3v"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPipelines": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/pipelines"
				},
				"input": {
					"type": "structure",
					"members": {
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipelines": {
							"type": "list",
							"member": {
								"shape": "S2l"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPresets": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/presets"
				},
				"input": {
					"type": "structure",
					"members": {
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Presets": {
							"type": "list",
							"member": {
								"shape": "S3m"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ReadJob": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/jobs/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Job": {
							"shape": "S1y"
						}
					}
				}
			},
			"ReadPipeline": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/pipelines/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						},
						"Warnings": {
							"shape": "S2n"
						}
					}
				}
			},
			"ReadPreset": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/presets/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Preset": {
							"shape": "S3m"
						}
					}
				}
			},
			"TestRole": {
				"http": {
					"requestUri": "/2012-09-25/roleTests",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Role",
						"InputBucket",
						"OutputBucket",
						"Topics"
					],
					"members": {
						"Role": {},
						"InputBucket": {},
						"OutputBucket": {},
						"Topics": {
							"type": "list",
							"member": {}
						}
					},
					"deprecated": true
				},
				"output": {
					"type": "structure",
					"members": {
						"Success": {},
						"Messages": {
							"type": "list",
							"member": {}
						}
					},
					"deprecated": true
				},
				"deprecated": true
			},
			"UpdatePipeline": {
				"http": {
					"method": "PUT",
					"requestUri": "/2012-09-25/pipelines/{Id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Name": {},
						"InputBucket": {},
						"Role": {},
						"AwsKmsKeyArn": {},
						"Notifications": {
							"shape": "S2a"
						},
						"ContentConfig": {
							"shape": "S2c"
						},
						"ThumbnailConfig": {
							"shape": "S2c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						},
						"Warnings": {
							"shape": "S2n"
						}
					}
				}
			},
			"UpdatePipelineNotifications": {
				"http": {
					"requestUri": "/2012-09-25/pipelines/{Id}/notifications"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Notifications"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Notifications": {
							"shape": "S2a"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						}
					}
				}
			},
			"UpdatePipelineStatus": {
				"http": {
					"requestUri": "/2012-09-25/pipelines/{Id}/status"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Status"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "structure",
				"members": {
					"Key": {},
					"FrameRate": {},
					"Resolution": {},
					"AspectRatio": {},
					"Interlaced": {},
					"Container": {},
					"Encryption": {
						"shape": "Sc"
					},
					"TimeSpan": {
						"shape": "Sg"
					},
					"InputCaptions": {
						"type": "structure",
						"members": {
							"MergePolicy": {},
							"CaptionSources": {
								"shape": "Sk"
							}
						}
					},
					"DetectedProperties": {
						"type": "structure",
						"members": {
							"Width": {
								"type": "integer"
							},
							"Height": {
								"type": "integer"
							},
							"FrameRate": {},
							"FileSize": {
								"type": "long"
							},
							"DurationMillis": {
								"type": "long"
							}
						}
					}
				}
			},
			"Sc": {
				"type": "structure",
				"members": {
					"Mode": {},
					"Key": {},
					"KeyMd5": {},
					"InitializationVector": {}
				}
			},
			"Sg": {
				"type": "structure",
				"members": {
					"StartTime": {},
					"Duration": {}
				}
			},
			"Sk": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Language": {},
						"TimeOffset": {},
						"Label": {},
						"Encryption": {
							"shape": "Sc"
						}
					}
				}
			},
			"St": {
				"type": "list",
				"member": {
					"shape": "S5"
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"Key": {},
					"ThumbnailPattern": {},
					"ThumbnailEncryption": {
						"shape": "Sc"
					},
					"Rotate": {},
					"PresetId": {},
					"SegmentDuration": {},
					"Watermarks": {
						"shape": "Sx"
					},
					"AlbumArt": {
						"shape": "S11"
					},
					"Composition": {
						"shape": "S19",
						"deprecated": true
					},
					"Captions": {
						"shape": "S1b"
					},
					"Encryption": {
						"shape": "Sc"
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PresetWatermarkId": {},
						"InputKey": {},
						"Encryption": {
							"shape": "Sc"
						}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"MergePolicy": {},
					"Artwork": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InputKey": {},
								"MaxWidth": {},
								"MaxHeight": {},
								"SizingPolicy": {},
								"PaddingPolicy": {},
								"AlbumArtFormat": {},
								"Encryption": {
									"shape": "Sc"
								}
							}
						}
					}
				}
			},
			"S19": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"TimeSpan": {
							"shape": "Sg"
						}
					},
					"deprecated": true
				},
				"deprecated": true
			},
			"S1b": {
				"type": "structure",
				"members": {
					"MergePolicy": {
						"deprecated": true
					},
					"CaptionSources": {
						"shape": "Sk",
						"deprecated": true
					},
					"CaptionFormats": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Format": {},
								"Pattern": {},
								"Encryption": {
									"shape": "Sc"
								}
							}
						}
					}
				}
			},
			"S1l": {
				"type": "list",
				"member": {}
			},
			"S1m": {
				"type": "structure",
				"members": {
					"Method": {},
					"Key": {},
					"KeyMd5": {},
					"InitializationVector": {},
					"LicenseAcquisitionUrl": {},
					"KeyStoragePolicy": {}
				}
			},
			"S1q": {
				"type": "structure",
				"members": {
					"Format": {},
					"Key": {},
					"KeyMd5": {},
					"KeyId": {},
					"InitializationVector": {},
					"LicenseAcquisitionUrl": {}
				}
			},
			"S1v": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"Id": {},
					"Arn": {},
					"PipelineId": {},
					"Input": {
						"shape": "S5"
					},
					"Inputs": {
						"shape": "St"
					},
					"Output": {
						"shape": "S1z"
					},
					"Outputs": {
						"type": "list",
						"member": {
							"shape": "S1z"
						}
					},
					"OutputKeyPrefix": {},
					"Playlists": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Format": {},
								"OutputKeys": {
									"shape": "S1l"
								},
								"HlsContentProtection": {
									"shape": "S1m"
								},
								"PlayReadyDrm": {
									"shape": "S1q"
								},
								"Status": {},
								"StatusDetail": {}
							}
						}
					},
					"Status": {},
					"UserMetadata": {
						"shape": "S1v"
					},
					"Timing": {
						"type": "structure",
						"members": {
							"SubmitTimeMillis": {
								"type": "long"
							},
							"StartTimeMillis": {
								"type": "long"
							},
							"FinishTimeMillis": {
								"type": "long"
							}
						}
					}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"Id": {},
					"Key": {},
					"ThumbnailPattern": {},
					"ThumbnailEncryption": {
						"shape": "Sc"
					},
					"Rotate": {},
					"PresetId": {},
					"SegmentDuration": {},
					"Status": {},
					"StatusDetail": {},
					"Duration": {
						"type": "long"
					},
					"Width": {
						"type": "integer"
					},
					"Height": {
						"type": "integer"
					},
					"FrameRate": {},
					"FileSize": {
						"type": "long"
					},
					"DurationMillis": {
						"type": "long"
					},
					"Watermarks": {
						"shape": "Sx"
					},
					"AlbumArt": {
						"shape": "S11"
					},
					"Composition": {
						"shape": "S19",
						"deprecated": true
					},
					"Captions": {
						"shape": "S1b"
					},
					"Encryption": {
						"shape": "Sc"
					},
					"AppliedColorSpaceConversion": {}
				}
			},
			"S2a": {
				"type": "structure",
				"members": {
					"Progressing": {},
					"Completed": {},
					"Warning": {},
					"Error": {}
				}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"StorageClass": {},
					"Permissions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"GranteeType": {},
								"Grantee": {},
								"Access": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			},
			"S2l": {
				"type": "structure",
				"members": {
					"Id": {},
					"Arn": {},
					"Name": {},
					"Status": {},
					"InputBucket": {},
					"OutputBucket": {},
					"Role": {},
					"AwsKmsKeyArn": {},
					"Notifications": {
						"shape": "S2a"
					},
					"ContentConfig": {
						"shape": "S2c"
					},
					"ThumbnailConfig": {
						"shape": "S2c"
					}
				}
			},
			"S2n": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Code": {},
						"Message": {}
					}
				}
			},
			"S2r": {
				"type": "structure",
				"members": {
					"Codec": {},
					"CodecOptions": {
						"type": "map",
						"key": {},
						"value": {}
					},
					"KeyframesMaxDist": {},
					"FixedGOP": {},
					"BitRate": {},
					"FrameRate": {},
					"MaxFrameRate": {},
					"Resolution": {},
					"AspectRatio": {},
					"MaxWidth": {},
					"MaxHeight": {},
					"DisplayAspectRatio": {},
					"SizingPolicy": {},
					"PaddingPolicy": {},
					"Watermarks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"MaxWidth": {},
								"MaxHeight": {},
								"SizingPolicy": {},
								"HorizontalAlign": {},
								"HorizontalOffset": {},
								"VerticalAlign": {},
								"VerticalOffset": {},
								"Opacity": {},
								"Target": {}
							}
						}
					}
				}
			},
			"S37": {
				"type": "structure",
				"members": {
					"Codec": {},
					"SampleRate": {},
					"BitRate": {},
					"Channels": {},
					"AudioPackingMode": {},
					"CodecOptions": {
						"type": "structure",
						"members": {
							"Profile": {},
							"BitDepth": {},
							"BitOrder": {},
							"Signed": {}
						}
					}
				}
			},
			"S3i": {
				"type": "structure",
				"members": {
					"Format": {},
					"Interval": {},
					"Resolution": {},
					"AspectRatio": {},
					"MaxWidth": {},
					"MaxHeight": {},
					"SizingPolicy": {},
					"PaddingPolicy": {}
				}
			},
			"S3m": {
				"type": "structure",
				"members": {
					"Id": {},
					"Arn": {},
					"Name": {},
					"Description": {},
					"Container": {},
					"Audio": {
						"shape": "S37"
					},
					"Video": {
						"shape": "S2r"
					},
					"Thumbnails": {
						"shape": "S3i"
					},
					"Type": {}
				}
			},
			"S3v": {
				"type": "list",
				"member": {
					"shape": "S1y"
				}
			}
		}
	};

/***/ },
/* 1741 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListJobsByPipeline": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Jobs"
			},
			"ListJobsByStatus": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Jobs"
			},
			"ListPipelines": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Pipelines"
			},
			"ListPresets": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Presets"
			}
		}
	};

/***/ },
/* 1742 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"JobComplete": {
				"delay": 30,
				"operation": "ReadJob",
				"maxAttempts": 120,
				"acceptors": [
					{
						"expected": "Complete",
						"matcher": "path",
						"state": "success",
						"argument": "Job.Status"
					},
					{
						"expected": "Canceled",
						"matcher": "path",
						"state": "failure",
						"argument": "Job.Status"
					},
					{
						"expected": "Error",
						"matcher": "path",
						"state": "failure",
						"argument": "Job.Status"
					}
				]
			}
		}
	};

/***/ },
/* 1743 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-12-01",
			"endpointPrefix": "email",
			"protocol": "query",
			"serviceAbbreviation": "Amazon SES",
			"serviceFullName": "Amazon Simple Email Service",
			"serviceId": "SES",
			"signatureVersion": "v4",
			"signingName": "ses",
			"uid": "email-2010-12-01",
			"xmlNamespace": "http://ses.amazonaws.com/doc/2010-12-01/"
		},
		"operations": {
			"CloneReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"OriginalRuleSetName"
					],
					"members": {
						"RuleSetName": {},
						"OriginalRuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "CloneReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateConfigurationSet": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSet"
					],
					"members": {
						"ConfigurationSet": {
							"shape": "S5"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateConfigurationSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateConfigurationSetEventDestination": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"EventDestination"
					],
					"members": {
						"ConfigurationSetName": {},
						"EventDestination": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateConfigurationSetEventDestinationResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateConfigurationSetTrackingOptions": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"TrackingOptions"
					],
					"members": {
						"ConfigurationSetName": {},
						"TrackingOptions": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateConfigurationSetTrackingOptionsResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateCustomVerificationEmailTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"TemplateName",
						"FromEmailAddress",
						"TemplateSubject",
						"TemplateContent",
						"SuccessRedirectionURL",
						"FailureRedirectionURL"
					],
					"members": {
						"TemplateName": {},
						"FromEmailAddress": {},
						"TemplateSubject": {},
						"TemplateContent": {},
						"SuccessRedirectionURL": {},
						"FailureRedirectionURL": {}
					}
				}
			},
			"CreateReceiptFilter": {
				"input": {
					"type": "structure",
					"required": [
						"Filter"
					],
					"members": {
						"Filter": {
							"shape": "S10"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateReceiptFilterResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"Rule"
					],
					"members": {
						"RuleSetName": {},
						"After": {},
						"Rule": {
							"shape": "S18"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateReceiptRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName"
					],
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"Template"
					],
					"members": {
						"Template": {
							"shape": "S20"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateTemplateResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteConfigurationSet": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName"
					],
					"members": {
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteConfigurationSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteConfigurationSetEventDestination": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"EventDestinationName"
					],
					"members": {
						"ConfigurationSetName": {},
						"EventDestinationName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteConfigurationSetEventDestinationResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteConfigurationSetTrackingOptions": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName"
					],
					"members": {
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteConfigurationSetTrackingOptionsResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteCustomVerificationEmailTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"TemplateName"
					],
					"members": {
						"TemplateName": {}
					}
				}
			},
			"DeleteIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"Identity"
					],
					"members": {
						"Identity": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteIdentityResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteIdentityPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"PolicyName"
					],
					"members": {
						"Identity": {},
						"PolicyName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteIdentityPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteReceiptFilter": {
				"input": {
					"type": "structure",
					"required": [
						"FilterName"
					],
					"members": {
						"FilterName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReceiptFilterResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleName"
					],
					"members": {
						"RuleSetName": {},
						"RuleName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReceiptRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName"
					],
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"TemplateName"
					],
					"members": {
						"TemplateName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteTemplateResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteVerifiedEmailAddress": {
				"input": {
					"type": "structure",
					"required": [
						"EmailAddress"
					],
					"members": {
						"EmailAddress": {}
					}
				}
			},
			"DescribeActiveReceiptRuleSet": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "DescribeActiveReceiptRuleSetResult",
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S2t"
						},
						"Rules": {
							"shape": "S2v"
						}
					}
				}
			},
			"DescribeConfigurationSet": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName"
					],
					"members": {
						"ConfigurationSetName": {},
						"ConfigurationSetAttributeNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeConfigurationSetResult",
					"type": "structure",
					"members": {
						"ConfigurationSet": {
							"shape": "S5"
						},
						"EventDestinations": {
							"type": "list",
							"member": {
								"shape": "S9"
							}
						},
						"TrackingOptions": {
							"shape": "Sp"
						},
						"DeliveryOptions": {
							"shape": "S31"
						},
						"ReputationOptions": {
							"type": "structure",
							"members": {
								"SendingEnabled": {
									"type": "boolean"
								},
								"ReputationMetricsEnabled": {
									"type": "boolean"
								},
								"LastFreshStart": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"DescribeReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleName"
					],
					"members": {
						"RuleSetName": {},
						"RuleName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReceiptRuleResult",
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "S18"
						}
					}
				}
			},
			"DescribeReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName"
					],
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReceiptRuleSetResult",
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S2t"
						},
						"Rules": {
							"shape": "S2v"
						}
					}
				}
			},
			"GetAccountSendingEnabled": {
				"output": {
					"resultWrapper": "GetAccountSendingEnabledResult",
					"type": "structure",
					"members": {
						"Enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"GetCustomVerificationEmailTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"TemplateName"
					],
					"members": {
						"TemplateName": {}
					}
				},
				"output": {
					"resultWrapper": "GetCustomVerificationEmailTemplateResult",
					"type": "structure",
					"members": {
						"TemplateName": {},
						"FromEmailAddress": {},
						"TemplateSubject": {},
						"TemplateContent": {},
						"SuccessRedirectionURL": {},
						"FailureRedirectionURL": {}
					}
				}
			},
			"GetIdentityDkimAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityDkimAttributesResult",
					"type": "structure",
					"required": [
						"DkimAttributes"
					],
					"members": {
						"DkimAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"DkimEnabled",
									"DkimVerificationStatus"
								],
								"members": {
									"DkimEnabled": {
										"type": "boolean"
									},
									"DkimVerificationStatus": {},
									"DkimTokens": {
										"shape": "S3h"
									}
								}
							}
						}
					}
				}
			},
			"GetIdentityMailFromDomainAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityMailFromDomainAttributesResult",
					"type": "structure",
					"required": [
						"MailFromDomainAttributes"
					],
					"members": {
						"MailFromDomainAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"MailFromDomain",
									"MailFromDomainStatus",
									"BehaviorOnMXFailure"
								],
								"members": {
									"MailFromDomain": {},
									"MailFromDomainStatus": {},
									"BehaviorOnMXFailure": {}
								}
							}
						}
					}
				}
			},
			"GetIdentityNotificationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityNotificationAttributesResult",
					"type": "structure",
					"required": [
						"NotificationAttributes"
					],
					"members": {
						"NotificationAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"BounceTopic",
									"ComplaintTopic",
									"DeliveryTopic",
									"ForwardingEnabled"
								],
								"members": {
									"BounceTopic": {},
									"ComplaintTopic": {},
									"DeliveryTopic": {},
									"ForwardingEnabled": {
										"type": "boolean"
									},
									"HeadersInBounceNotificationsEnabled": {
										"type": "boolean"
									},
									"HeadersInComplaintNotificationsEnabled": {
										"type": "boolean"
									},
									"HeadersInDeliveryNotificationsEnabled": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"GetIdentityPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"PolicyNames"
					],
					"members": {
						"Identity": {},
						"PolicyNames": {
							"shape": "S3w"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityPoliciesResult",
					"type": "structure",
					"required": [
						"Policies"
					],
					"members": {
						"Policies": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"GetIdentityVerificationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityVerificationAttributesResult",
					"type": "structure",
					"required": [
						"VerificationAttributes"
					],
					"members": {
						"VerificationAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"VerificationStatus"
								],
								"members": {
									"VerificationStatus": {},
									"VerificationToken": {}
								}
							}
						}
					}
				}
			},
			"GetSendQuota": {
				"output": {
					"resultWrapper": "GetSendQuotaResult",
					"type": "structure",
					"members": {
						"Max24HourSend": {
							"type": "double"
						},
						"MaxSendRate": {
							"type": "double"
						},
						"SentLast24Hours": {
							"type": "double"
						}
					}
				}
			},
			"GetSendStatistics": {
				"output": {
					"resultWrapper": "GetSendStatisticsResult",
					"type": "structure",
					"members": {
						"SendDataPoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "timestamp"
									},
									"DeliveryAttempts": {
										"type": "long"
									},
									"Bounces": {
										"type": "long"
									},
									"Complaints": {
										"type": "long"
									},
									"Rejects": {
										"type": "long"
									}
								}
							}
						}
					}
				}
			},
			"GetTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"TemplateName"
					],
					"members": {
						"TemplateName": {}
					}
				},
				"output": {
					"resultWrapper": "GetTemplateResult",
					"type": "structure",
					"members": {
						"Template": {
							"shape": "S20"
						}
					}
				}
			},
			"ListConfigurationSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListConfigurationSetsResult",
					"type": "structure",
					"members": {
						"ConfigurationSets": {
							"type": "list",
							"member": {
								"shape": "S5"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListCustomVerificationEmailTemplates": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListCustomVerificationEmailTemplatesResult",
					"type": "structure",
					"members": {
						"CustomVerificationEmailTemplates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TemplateName": {},
									"FromEmailAddress": {},
									"TemplateSubject": {},
									"SuccessRedirectionURL": {},
									"FailureRedirectionURL": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentities": {
				"input": {
					"type": "structure",
					"members": {
						"IdentityType": {},
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListIdentitiesResult",
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S3c"
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"Identity"
					],
					"members": {
						"Identity": {}
					}
				},
				"output": {
					"resultWrapper": "ListIdentityPoliciesResult",
					"type": "structure",
					"required": [
						"PolicyNames"
					],
					"members": {
						"PolicyNames": {
							"shape": "S3w"
						}
					}
				}
			},
			"ListReceiptFilters": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "ListReceiptFiltersResult",
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"shape": "S10"
							}
						}
					}
				}
			},
			"ListReceiptRuleSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListReceiptRuleSetsResult",
					"type": "structure",
					"members": {
						"RuleSets": {
							"type": "list",
							"member": {
								"shape": "S2t"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTemplates": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListTemplatesResult",
					"type": "structure",
					"members": {
						"TemplatesMetadata": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"CreatedTimestamp": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListVerifiedEmailAddresses": {
				"output": {
					"resultWrapper": "ListVerifiedEmailAddressesResult",
					"type": "structure",
					"members": {
						"VerifiedEmailAddresses": {
							"shape": "S54"
						}
					}
				}
			},
			"PutConfigurationSetDeliveryOptions": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName"
					],
					"members": {
						"ConfigurationSetName": {},
						"DeliveryOptions": {
							"shape": "S31"
						}
					}
				},
				"output": {
					"resultWrapper": "PutConfigurationSetDeliveryOptionsResult",
					"type": "structure",
					"members": {}
				}
			},
			"PutIdentityPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"PolicyName",
						"Policy"
					],
					"members": {
						"Identity": {},
						"PolicyName": {},
						"Policy": {}
					}
				},
				"output": {
					"resultWrapper": "PutIdentityPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"ReorderReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleNames"
					],
					"members": {
						"RuleSetName": {},
						"RuleNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "ReorderReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"SendBounce": {
				"input": {
					"type": "structure",
					"required": [
						"OriginalMessageId",
						"BounceSender",
						"BouncedRecipientInfoList"
					],
					"members": {
						"OriginalMessageId": {},
						"BounceSender": {},
						"Explanation": {},
						"MessageDsn": {
							"type": "structure",
							"required": [
								"ReportingMta"
							],
							"members": {
								"ReportingMta": {},
								"ArrivalDate": {
									"type": "timestamp"
								},
								"ExtensionFields": {
									"shape": "S5i"
								}
							}
						},
						"BouncedRecipientInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Recipient"
								],
								"members": {
									"Recipient": {},
									"RecipientArn": {},
									"BounceType": {},
									"RecipientDsnFields": {
										"type": "structure",
										"required": [
											"Action",
											"Status"
										],
										"members": {
											"FinalRecipient": {},
											"Action": {},
											"RemoteMta": {},
											"Status": {},
											"DiagnosticCode": {},
											"LastAttemptDate": {
												"type": "timestamp"
											},
											"ExtensionFields": {
												"shape": "S5i"
											}
										}
									}
								}
							}
						},
						"BounceSenderArn": {}
					}
				},
				"output": {
					"resultWrapper": "SendBounceResult",
					"type": "structure",
					"members": {
						"MessageId": {}
					}
				}
			},
			"SendBulkTemplatedEmail": {
				"input": {
					"type": "structure",
					"required": [
						"Source",
						"Template",
						"Destinations"
					],
					"members": {
						"Source": {},
						"SourceArn": {},
						"ReplyToAddresses": {
							"shape": "S54"
						},
						"ReturnPath": {},
						"ReturnPathArn": {},
						"ConfigurationSetName": {},
						"DefaultTags": {
							"shape": "S5x"
						},
						"Template": {},
						"TemplateArn": {},
						"DefaultTemplateData": {},
						"Destinations": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Destination"
								],
								"members": {
									"Destination": {
										"shape": "S64"
									},
									"ReplacementTags": {
										"shape": "S5x"
									},
									"ReplacementTemplateData": {}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "SendBulkTemplatedEmailResult",
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Status": {},
									"Error": {},
									"MessageId": {}
								}
							}
						}
					}
				}
			},
			"SendCustomVerificationEmail": {
				"input": {
					"type": "structure",
					"required": [
						"EmailAddress",
						"TemplateName"
					],
					"members": {
						"EmailAddress": {},
						"TemplateName": {},
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "SendCustomVerificationEmailResult",
					"type": "structure",
					"members": {
						"MessageId": {}
					}
				}
			},
			"SendEmail": {
				"input": {
					"type": "structure",
					"required": [
						"Source",
						"Destination",
						"Message"
					],
					"members": {
						"Source": {},
						"Destination": {
							"shape": "S64"
						},
						"Message": {
							"type": "structure",
							"required": [
								"Subject",
								"Body"
							],
							"members": {
								"Subject": {
									"shape": "S6e"
								},
								"Body": {
									"type": "structure",
									"members": {
										"Text": {
											"shape": "S6e"
										},
										"Html": {
											"shape": "S6e"
										}
									}
								}
							}
						},
						"ReplyToAddresses": {
							"shape": "S54"
						},
						"ReturnPath": {},
						"SourceArn": {},
						"ReturnPathArn": {},
						"Tags": {
							"shape": "S5x"
						},
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "SendEmailResult",
					"type": "structure",
					"required": [
						"MessageId"
					],
					"members": {
						"MessageId": {}
					}
				}
			},
			"SendRawEmail": {
				"input": {
					"type": "structure",
					"required": [
						"RawMessage"
					],
					"members": {
						"Source": {},
						"Destinations": {
							"shape": "S54"
						},
						"RawMessage": {
							"type": "structure",
							"required": [
								"Data"
							],
							"members": {
								"Data": {
									"type": "blob"
								}
							}
						},
						"FromArn": {},
						"SourceArn": {},
						"ReturnPathArn": {},
						"Tags": {
							"shape": "S5x"
						},
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "SendRawEmailResult",
					"type": "structure",
					"required": [
						"MessageId"
					],
					"members": {
						"MessageId": {}
					}
				}
			},
			"SendTemplatedEmail": {
				"input": {
					"type": "structure",
					"required": [
						"Source",
						"Destination",
						"Template",
						"TemplateData"
					],
					"members": {
						"Source": {},
						"Destination": {
							"shape": "S64"
						},
						"ReplyToAddresses": {
							"shape": "S54"
						},
						"ReturnPath": {},
						"SourceArn": {},
						"ReturnPathArn": {},
						"Tags": {
							"shape": "S5x"
						},
						"ConfigurationSetName": {},
						"Template": {},
						"TemplateArn": {},
						"TemplateData": {}
					}
				},
				"output": {
					"resultWrapper": "SendTemplatedEmailResult",
					"type": "structure",
					"required": [
						"MessageId"
					],
					"members": {
						"MessageId": {}
					}
				}
			},
			"SetActiveReceiptRuleSet": {
				"input": {
					"type": "structure",
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "SetActiveReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityDkimEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"DkimEnabled"
					],
					"members": {
						"Identity": {},
						"DkimEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityDkimEnabledResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityFeedbackForwardingEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"ForwardingEnabled"
					],
					"members": {
						"Identity": {},
						"ForwardingEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityFeedbackForwardingEnabledResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityHeadersInNotificationsEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"NotificationType",
						"Enabled"
					],
					"members": {
						"Identity": {},
						"NotificationType": {},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityHeadersInNotificationsEnabledResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityMailFromDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Identity"
					],
					"members": {
						"Identity": {},
						"MailFromDomain": {},
						"BehaviorOnMXFailure": {}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityMailFromDomainResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityNotificationTopic": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"NotificationType"
					],
					"members": {
						"Identity": {},
						"NotificationType": {},
						"SnsTopic": {}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityNotificationTopicResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetReceiptRulePosition": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleName"
					],
					"members": {
						"RuleSetName": {},
						"RuleName": {},
						"After": {}
					}
				},
				"output": {
					"resultWrapper": "SetReceiptRulePositionResult",
					"type": "structure",
					"members": {}
				}
			},
			"TestRenderTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"TemplateName",
						"TemplateData"
					],
					"members": {
						"TemplateName": {},
						"TemplateData": {}
					}
				},
				"output": {
					"resultWrapper": "TestRenderTemplateResult",
					"type": "structure",
					"members": {
						"RenderedTemplate": {}
					}
				}
			},
			"UpdateAccountSendingEnabled": {
				"input": {
					"type": "structure",
					"members": {
						"Enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateConfigurationSetEventDestination": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"EventDestination"
					],
					"members": {
						"ConfigurationSetName": {},
						"EventDestination": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateConfigurationSetEventDestinationResult",
					"type": "structure",
					"members": {}
				}
			},
			"UpdateConfigurationSetReputationMetricsEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"Enabled"
					],
					"members": {
						"ConfigurationSetName": {},
						"Enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateConfigurationSetSendingEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"Enabled"
					],
					"members": {
						"ConfigurationSetName": {},
						"Enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateConfigurationSetTrackingOptions": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"TrackingOptions"
					],
					"members": {
						"ConfigurationSetName": {},
						"TrackingOptions": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateConfigurationSetTrackingOptionsResult",
					"type": "structure",
					"members": {}
				}
			},
			"UpdateCustomVerificationEmailTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"TemplateName"
					],
					"members": {
						"TemplateName": {},
						"FromEmailAddress": {},
						"TemplateSubject": {},
						"TemplateContent": {},
						"SuccessRedirectionURL": {},
						"FailureRedirectionURL": {}
					}
				}
			},
			"UpdateReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"Rule"
					],
					"members": {
						"RuleSetName": {},
						"Rule": {
							"shape": "S18"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateReceiptRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"UpdateTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"Template"
					],
					"members": {
						"Template": {
							"shape": "S20"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateTemplateResult",
					"type": "structure",
					"members": {}
				}
			},
			"VerifyDomainDkim": {
				"input": {
					"type": "structure",
					"required": [
						"Domain"
					],
					"members": {
						"Domain": {}
					}
				},
				"output": {
					"resultWrapper": "VerifyDomainDkimResult",
					"type": "structure",
					"required": [
						"DkimTokens"
					],
					"members": {
						"DkimTokens": {
							"shape": "S3h"
						}
					}
				}
			},
			"VerifyDomainIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"Domain"
					],
					"members": {
						"Domain": {}
					}
				},
				"output": {
					"resultWrapper": "VerifyDomainIdentityResult",
					"type": "structure",
					"required": [
						"VerificationToken"
					],
					"members": {
						"VerificationToken": {}
					}
				}
			},
			"VerifyEmailAddress": {
				"input": {
					"type": "structure",
					"required": [
						"EmailAddress"
					],
					"members": {
						"EmailAddress": {}
					}
				}
			},
			"VerifyEmailIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"EmailAddress"
					],
					"members": {
						"EmailAddress": {}
					}
				},
				"output": {
					"resultWrapper": "VerifyEmailIdentityResult",
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"S9": {
				"type": "structure",
				"required": [
					"Name",
					"MatchingEventTypes"
				],
				"members": {
					"Name": {},
					"Enabled": {
						"type": "boolean"
					},
					"MatchingEventTypes": {
						"type": "list",
						"member": {}
					},
					"KinesisFirehoseDestination": {
						"type": "structure",
						"required": [
							"IAMRoleARN",
							"DeliveryStreamARN"
						],
						"members": {
							"IAMRoleARN": {},
							"DeliveryStreamARN": {}
						}
					},
					"CloudWatchDestination": {
						"type": "structure",
						"required": [
							"DimensionConfigurations"
						],
						"members": {
							"DimensionConfigurations": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"DimensionName",
										"DimensionValueSource",
										"DefaultDimensionValue"
									],
									"members": {
										"DimensionName": {},
										"DimensionValueSource": {},
										"DefaultDimensionValue": {}
									}
								}
							}
						}
					},
					"SNSDestination": {
						"type": "structure",
						"required": [
							"TopicARN"
						],
						"members": {
							"TopicARN": {}
						}
					}
				}
			},
			"Sp": {
				"type": "structure",
				"members": {
					"CustomRedirectDomain": {}
				}
			},
			"S10": {
				"type": "structure",
				"required": [
					"Name",
					"IpFilter"
				],
				"members": {
					"Name": {},
					"IpFilter": {
						"type": "structure",
						"required": [
							"Policy",
							"Cidr"
						],
						"members": {
							"Policy": {},
							"Cidr": {}
						}
					}
				}
			},
			"S18": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Enabled": {
						"type": "boolean"
					},
					"TlsPolicy": {},
					"Recipients": {
						"type": "list",
						"member": {}
					},
					"Actions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"S3Action": {
									"type": "structure",
									"required": [
										"BucketName"
									],
									"members": {
										"TopicArn": {},
										"BucketName": {},
										"ObjectKeyPrefix": {},
										"KmsKeyArn": {}
									}
								},
								"BounceAction": {
									"type": "structure",
									"required": [
										"SmtpReplyCode",
										"Message",
										"Sender"
									],
									"members": {
										"TopicArn": {},
										"SmtpReplyCode": {},
										"StatusCode": {},
										"Message": {},
										"Sender": {}
									}
								},
								"WorkmailAction": {
									"type": "structure",
									"required": [
										"OrganizationArn"
									],
									"members": {
										"TopicArn": {},
										"OrganizationArn": {}
									}
								},
								"LambdaAction": {
									"type": "structure",
									"required": [
										"FunctionArn"
									],
									"members": {
										"TopicArn": {},
										"FunctionArn": {},
										"InvocationType": {}
									}
								},
								"StopAction": {
									"type": "structure",
									"required": [
										"Scope"
									],
									"members": {
										"Scope": {},
										"TopicArn": {}
									}
								},
								"AddHeaderAction": {
									"type": "structure",
									"required": [
										"HeaderName",
										"HeaderValue"
									],
									"members": {
										"HeaderName": {},
										"HeaderValue": {}
									}
								},
								"SNSAction": {
									"type": "structure",
									"required": [
										"TopicArn"
									],
									"members": {
										"TopicArn": {},
										"Encoding": {}
									}
								}
							}
						}
					},
					"ScanEnabled": {
						"type": "boolean"
					}
				}
			},
			"S20": {
				"type": "structure",
				"required": [
					"TemplateName"
				],
				"members": {
					"TemplateName": {},
					"SubjectPart": {},
					"TextPart": {},
					"HtmlPart": {}
				}
			},
			"S2t": {
				"type": "structure",
				"members": {
					"Name": {},
					"CreatedTimestamp": {
						"type": "timestamp"
					}
				}
			},
			"S2v": {
				"type": "list",
				"member": {
					"shape": "S18"
				}
			},
			"S31": {
				"type": "structure",
				"members": {
					"TlsPolicy": {}
				}
			},
			"S3c": {
				"type": "list",
				"member": {}
			},
			"S3h": {
				"type": "list",
				"member": {}
			},
			"S3w": {
				"type": "list",
				"member": {}
			},
			"S54": {
				"type": "list",
				"member": {}
			},
			"S5i": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Value"
					],
					"members": {
						"Name": {},
						"Value": {}
					}
				}
			},
			"S5x": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Value"
					],
					"members": {
						"Name": {},
						"Value": {}
					}
				}
			},
			"S64": {
				"type": "structure",
				"members": {
					"ToAddresses": {
						"shape": "S54"
					},
					"CcAddresses": {
						"shape": "S54"
					},
					"BccAddresses": {
						"shape": "S54"
					}
				}
			},
			"S6e": {
				"type": "structure",
				"required": [
					"Data"
				],
				"members": {
					"Data": {},
					"Charset": {}
				}
			}
		}
	};

/***/ },
/* 1744 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCustomVerificationEmailTemplates": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"ListIdentities": {
				"input_token": "NextToken",
				"limit_key": "MaxItems",
				"output_token": "NextToken",
				"result_key": "Identities"
			},
			"ListVerifiedEmailAddresses": {
				"result_key": "VerifiedEmailAddresses"
			}
		}
	};

/***/ },
/* 1745 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"IdentityExists": {
				"delay": 3,
				"operation": "GetIdentityVerificationAttributes",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": "Success",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VerificationAttributes.*.VerificationStatus"
					}
				]
			}
		}
	};

/***/ },
/* 1746 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-10-07",
			"endpointPrefix": "events",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon CloudWatch Events",
			"serviceId": "CloudWatch Events",
			"signatureVersion": "v4",
			"targetPrefix": "AWSEvents",
			"uid": "events-2015-10-07"
		},
		"operations": {
			"ActivateEventSource": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				}
			},
			"CreateEventBus": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"EventSourceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EventBusArn": {}
					}
				}
			},
			"CreatePartnerEventSource": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Account"
					],
					"members": {
						"Name": {},
						"Account": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EventSourceArn": {}
					}
				}
			},
			"DeactivateEventSource": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				}
			},
			"DeleteEventBus": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				}
			},
			"DeletePartnerEventSource": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Account"
					],
					"members": {
						"Name": {},
						"Account": {}
					}
				}
			},
			"DeleteRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"EventBusName": {},
						"Force": {
							"type": "boolean"
						}
					}
				}
			},
			"DescribeEventBus": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"Arn": {},
						"Policy": {}
					}
				}
			},
			"DescribeEventSource": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Arn": {},
						"CreatedBy": {},
						"CreationTime": {
							"type": "timestamp"
						},
						"ExpirationTime": {
							"type": "timestamp"
						},
						"Name": {},
						"State": {}
					}
				}
			},
			"DescribePartnerEventSource": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Arn": {},
						"Name": {}
					}
				}
			},
			"DescribeRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"EventBusName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"Arn": {},
						"EventPattern": {},
						"ScheduleExpression": {},
						"State": {},
						"Description": {},
						"RoleArn": {},
						"ManagedBy": {},
						"EventBusName": {}
					}
				}
			},
			"DisableRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"EventBusName": {}
					}
				}
			},
			"EnableRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"EventBusName": {}
					}
				}
			},
			"ListEventBuses": {
				"input": {
					"type": "structure",
					"members": {
						"NamePrefix": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EventBuses": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Arn": {},
									"Policy": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListEventSources": {
				"input": {
					"type": "structure",
					"members": {
						"NamePrefix": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EventSources": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Arn": {},
									"CreatedBy": {},
									"CreationTime": {
										"type": "timestamp"
									},
									"ExpirationTime": {
										"type": "timestamp"
									},
									"Name": {},
									"State": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListPartnerEventSourceAccounts": {
				"input": {
					"type": "structure",
					"required": [
						"EventSourceName"
					],
					"members": {
						"EventSourceName": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PartnerEventSourceAccounts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Account": {},
									"CreationTime": {
										"type": "timestamp"
									},
									"ExpirationTime": {
										"type": "timestamp"
									},
									"State": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListPartnerEventSources": {
				"input": {
					"type": "structure",
					"required": [
						"NamePrefix"
					],
					"members": {
						"NamePrefix": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PartnerEventSources": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Arn": {},
									"Name": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListRuleNamesByTarget": {
				"input": {
					"type": "structure",
					"required": [
						"TargetArn"
					],
					"members": {
						"TargetArn": {},
						"EventBusName": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuleNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"ListRules": {
				"input": {
					"type": "structure",
					"members": {
						"NamePrefix": {},
						"EventBusName": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Arn": {},
									"EventPattern": {},
									"State": {},
									"Description": {},
									"ScheduleExpression": {},
									"RoleArn": {},
									"ManagedBy": {},
									"EventBusName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN"
					],
					"members": {
						"ResourceARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S1u"
						}
					}
				}
			},
			"ListTargetsByRule": {
				"input": {
					"type": "structure",
					"required": [
						"Rule"
					],
					"members": {
						"Rule": {},
						"EventBusName": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Targets": {
							"shape": "S20"
						},
						"NextToken": {}
					}
				}
			},
			"PutEvents": {
				"input": {
					"type": "structure",
					"required": [
						"Entries"
					],
					"members": {
						"Entries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Time": {
										"type": "timestamp"
									},
									"Source": {},
									"Resources": {
										"shape": "S2y"
									},
									"DetailType": {},
									"Detail": {},
									"EventBusName": {}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEntryCount": {
							"type": "integer"
						},
						"Entries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"PutPartnerEvents": {
				"input": {
					"type": "structure",
					"required": [
						"Entries"
					],
					"members": {
						"Entries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Time": {
										"type": "timestamp"
									},
									"Source": {},
									"Resources": {
										"shape": "S2y"
									},
									"DetailType": {},
									"Detail": {}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEntryCount": {
							"type": "integer"
						},
						"Entries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"PutPermission": {
				"input": {
					"type": "structure",
					"required": [
						"Action",
						"Principal",
						"StatementId"
					],
					"members": {
						"EventBusName": {},
						"Action": {},
						"Principal": {},
						"StatementId": {},
						"Condition": {
							"type": "structure",
							"required": [
								"Type",
								"Key",
								"Value"
							],
							"members": {
								"Type": {},
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"PutRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"ScheduleExpression": {},
						"EventPattern": {},
						"State": {},
						"Description": {},
						"RoleArn": {},
						"Tags": {
							"shape": "S1u"
						},
						"EventBusName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuleArn": {}
					}
				}
			},
			"PutTargets": {
				"input": {
					"type": "structure",
					"required": [
						"Rule",
						"Targets"
					],
					"members": {
						"Rule": {},
						"EventBusName": {},
						"Targets": {
							"shape": "S20"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEntryCount": {
							"type": "integer"
						},
						"FailedEntries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TargetId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"RemovePermission": {
				"input": {
					"type": "structure",
					"required": [
						"StatementId"
					],
					"members": {
						"StatementId": {},
						"EventBusName": {}
					}
				}
			},
			"RemoveTargets": {
				"input": {
					"type": "structure",
					"required": [
						"Rule",
						"Ids"
					],
					"members": {
						"Rule": {},
						"EventBusName": {},
						"Ids": {
							"type": "list",
							"member": {}
						},
						"Force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEntryCount": {
							"type": "integer"
						},
						"FailedEntries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TargetId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"Tags"
					],
					"members": {
						"ResourceARN": {},
						"Tags": {
							"shape": "S1u"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"TestEventPattern": {
				"input": {
					"type": "structure",
					"required": [
						"EventPattern",
						"Event"
					],
					"members": {
						"EventPattern": {},
						"Event": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Result": {
							"type": "boolean"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"TagKeys"
					],
					"members": {
						"ResourceARN": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S1u": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S20": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Id",
						"Arn"
					],
					"members": {
						"Id": {},
						"Arn": {},
						"RoleArn": {},
						"Input": {},
						"InputPath": {},
						"InputTransformer": {
							"type": "structure",
							"required": [
								"InputTemplate"
							],
							"members": {
								"InputPathsMap": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"InputTemplate": {}
							}
						},
						"KinesisParameters": {
							"type": "structure",
							"required": [
								"PartitionKeyPath"
							],
							"members": {
								"PartitionKeyPath": {}
							}
						},
						"RunCommandParameters": {
							"type": "structure",
							"required": [
								"RunCommandTargets"
							],
							"members": {
								"RunCommandTargets": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Key",
											"Values"
										],
										"members": {
											"Key": {},
											"Values": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						},
						"EcsParameters": {
							"type": "structure",
							"required": [
								"TaskDefinitionArn"
							],
							"members": {
								"TaskDefinitionArn": {},
								"TaskCount": {
									"type": "integer"
								},
								"LaunchType": {},
								"NetworkConfiguration": {
									"type": "structure",
									"members": {
										"awsvpcConfiguration": {
											"type": "structure",
											"required": [
												"Subnets"
											],
											"members": {
												"Subnets": {
													"shape": "S2m"
												},
												"SecurityGroups": {
													"shape": "S2m"
												},
												"AssignPublicIp": {}
											}
										}
									}
								},
								"PlatformVersion": {},
								"Group": {}
							}
						},
						"BatchParameters": {
							"type": "structure",
							"required": [
								"JobDefinition",
								"JobName"
							],
							"members": {
								"JobDefinition": {},
								"JobName": {},
								"ArrayProperties": {
									"type": "structure",
									"members": {
										"Size": {
											"type": "integer"
										}
									}
								},
								"RetryStrategy": {
									"type": "structure",
									"members": {
										"Attempts": {
											"type": "integer"
										}
									}
								}
							}
						},
						"SqsParameters": {
							"type": "structure",
							"members": {
								"MessageGroupId": {}
							}
						}
					}
				}
			},
			"S2m": {
				"type": "list",
				"member": {}
			},
			"S2y": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1747 */
1641,
/* 1748 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-08-04",
			"endpointPrefix": "firehose",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Firehose",
			"serviceFullName": "Amazon Kinesis Firehose",
			"serviceId": "Firehose",
			"signatureVersion": "v4",
			"targetPrefix": "Firehose_20150804",
			"uid": "firehose-2015-08-04"
		},
		"operations": {
			"CreateDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {},
						"DeliveryStreamType": {},
						"KinesisStreamSourceConfiguration": {
							"type": "structure",
							"required": [
								"KinesisStreamARN",
								"RoleARN"
							],
							"members": {
								"KinesisStreamARN": {},
								"RoleARN": {}
							}
						},
						"S3DestinationConfiguration": {
							"shape": "S7",
							"deprecated": true
						},
						"ExtendedS3DestinationConfiguration": {
							"type": "structure",
							"required": [
								"RoleARN",
								"BucketARN"
							],
							"members": {
								"RoleARN": {},
								"BucketARN": {},
								"Prefix": {},
								"ErrorOutputPrefix": {},
								"BufferingHints": {
									"shape": "Sb"
								},
								"CompressionFormat": {},
								"EncryptionConfiguration": {
									"shape": "Sf"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"S3BackupMode": {},
								"S3BackupConfiguration": {
									"shape": "S7"
								},
								"DataFormatConversionConfiguration": {
									"shape": "Sx"
								}
							}
						},
						"RedshiftDestinationConfiguration": {
							"type": "structure",
							"required": [
								"RoleARN",
								"ClusterJDBCURL",
								"CopyCommand",
								"Username",
								"Password",
								"S3Configuration"
							],
							"members": {
								"RoleARN": {},
								"ClusterJDBCURL": {},
								"CopyCommand": {
									"shape": "S1o"
								},
								"Username": {
									"shape": "S1s"
								},
								"Password": {
									"shape": "S1t"
								},
								"RetryOptions": {
									"shape": "S1u"
								},
								"S3Configuration": {
									"shape": "S7"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"S3BackupMode": {},
								"S3BackupConfiguration": {
									"shape": "S7"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								}
							}
						},
						"ElasticsearchDestinationConfiguration": {
							"type": "structure",
							"required": [
								"RoleARN",
								"DomainARN",
								"IndexName",
								"TypeName",
								"S3Configuration"
							],
							"members": {
								"RoleARN": {},
								"DomainARN": {},
								"IndexName": {},
								"TypeName": {},
								"IndexRotationPeriod": {},
								"BufferingHints": {
									"shape": "S22"
								},
								"RetryOptions": {
									"shape": "S25"
								},
								"S3BackupMode": {},
								"S3Configuration": {
									"shape": "S7"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								}
							}
						},
						"SplunkDestinationConfiguration": {
							"type": "structure",
							"required": [
								"HECEndpoint",
								"HECEndpointType",
								"HECToken",
								"S3Configuration"
							],
							"members": {
								"HECEndpoint": {},
								"HECEndpointType": {},
								"HECToken": {},
								"HECAcknowledgmentTimeoutInSeconds": {
									"type": "integer"
								},
								"RetryOptions": {
									"shape": "S2d"
								},
								"S3BackupMode": {},
								"S3Configuration": {
									"shape": "S7"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								}
							}
						},
						"Tags": {
							"shape": "S2g"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeliveryStreamARN": {}
					}
				}
			},
			"DeleteDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartDestinationId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DeliveryStreamDescription"
					],
					"members": {
						"DeliveryStreamDescription": {
							"type": "structure",
							"required": [
								"DeliveryStreamName",
								"DeliveryStreamARN",
								"DeliveryStreamStatus",
								"DeliveryStreamType",
								"VersionId",
								"Destinations",
								"HasMoreDestinations"
							],
							"members": {
								"DeliveryStreamName": {},
								"DeliveryStreamARN": {},
								"DeliveryStreamStatus": {},
								"DeliveryStreamEncryptionConfiguration": {
									"type": "structure",
									"members": {
										"Status": {}
									}
								},
								"DeliveryStreamType": {},
								"VersionId": {},
								"CreateTimestamp": {
									"type": "timestamp"
								},
								"LastUpdateTimestamp": {
									"type": "timestamp"
								},
								"Source": {
									"type": "structure",
									"members": {
										"KinesisStreamSourceDescription": {
											"type": "structure",
											"members": {
												"KinesisStreamARN": {},
												"RoleARN": {},
												"DeliveryStartTimestamp": {
													"type": "timestamp"
												}
											}
										}
									}
								},
								"Destinations": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"DestinationId"
										],
										"members": {
											"DestinationId": {},
											"S3DestinationDescription": {
												"shape": "S33"
											},
											"ExtendedS3DestinationDescription": {
												"type": "structure",
												"required": [
													"RoleARN",
													"BucketARN",
													"BufferingHints",
													"CompressionFormat",
													"EncryptionConfiguration"
												],
												"members": {
													"RoleARN": {},
													"BucketARN": {},
													"Prefix": {},
													"ErrorOutputPrefix": {},
													"BufferingHints": {
														"shape": "Sb"
													},
													"CompressionFormat": {},
													"EncryptionConfiguration": {
														"shape": "Sf"
													},
													"CloudWatchLoggingOptions": {
														"shape": "Sj"
													},
													"ProcessingConfiguration": {
														"shape": "So"
													},
													"S3BackupMode": {},
													"S3BackupDescription": {
														"shape": "S33"
													},
													"DataFormatConversionConfiguration": {
														"shape": "Sx"
													}
												}
											},
											"RedshiftDestinationDescription": {
												"type": "structure",
												"required": [
													"RoleARN",
													"ClusterJDBCURL",
													"CopyCommand",
													"Username",
													"S3DestinationDescription"
												],
												"members": {
													"RoleARN": {},
													"ClusterJDBCURL": {},
													"CopyCommand": {
														"shape": "S1o"
													},
													"Username": {
														"shape": "S1s"
													},
													"RetryOptions": {
														"shape": "S1u"
													},
													"S3DestinationDescription": {
														"shape": "S33"
													},
													"ProcessingConfiguration": {
														"shape": "So"
													},
													"S3BackupMode": {},
													"S3BackupDescription": {
														"shape": "S33"
													},
													"CloudWatchLoggingOptions": {
														"shape": "Sj"
													}
												}
											},
											"ElasticsearchDestinationDescription": {
												"type": "structure",
												"members": {
													"RoleARN": {},
													"DomainARN": {},
													"IndexName": {},
													"TypeName": {},
													"IndexRotationPeriod": {},
													"BufferingHints": {
														"shape": "S22"
													},
													"RetryOptions": {
														"shape": "S25"
													},
													"S3BackupMode": {},
													"S3DestinationDescription": {
														"shape": "S33"
													},
													"ProcessingConfiguration": {
														"shape": "So"
													},
													"CloudWatchLoggingOptions": {
														"shape": "Sj"
													}
												}
											},
											"SplunkDestinationDescription": {
												"type": "structure",
												"members": {
													"HECEndpoint": {},
													"HECEndpointType": {},
													"HECToken": {},
													"HECAcknowledgmentTimeoutInSeconds": {
														"type": "integer"
													},
													"RetryOptions": {
														"shape": "S2d"
													},
													"S3BackupMode": {},
													"S3DestinationDescription": {
														"shape": "S33"
													},
													"ProcessingConfiguration": {
														"shape": "So"
													},
													"CloudWatchLoggingOptions": {
														"shape": "Sj"
													}
												}
											}
										}
									}
								},
								"HasMoreDestinations": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"ListDeliveryStreams": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"DeliveryStreamType": {},
						"ExclusiveStartDeliveryStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DeliveryStreamNames",
						"HasMoreDeliveryStreams"
					],
					"members": {
						"DeliveryStreamNames": {
							"type": "list",
							"member": {}
						},
						"HasMoreDeliveryStreams": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {},
						"ExclusiveStartTagKey": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags",
						"HasMoreTags"
					],
					"members": {
						"Tags": {
							"type": "list",
							"member": {
								"shape": "S2h"
							}
						},
						"HasMoreTags": {
							"type": "boolean"
						}
					}
				}
			},
			"PutRecord": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"Record"
					],
					"members": {
						"DeliveryStreamName": {},
						"Record": {
							"shape": "S3h"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RecordId"
					],
					"members": {
						"RecordId": {},
						"Encrypted": {
							"type": "boolean"
						}
					}
				}
			},
			"PutRecordBatch": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"Records"
					],
					"members": {
						"DeliveryStreamName": {},
						"Records": {
							"type": "list",
							"member": {
								"shape": "S3h"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"FailedPutCount",
						"RequestResponses"
					],
					"members": {
						"FailedPutCount": {
							"type": "integer"
						},
						"Encrypted": {
							"type": "boolean"
						},
						"RequestResponses": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RecordId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"StartDeliveryStreamEncryption": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StopDeliveryStreamEncryption": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"TagDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"Tags"
					],
					"members": {
						"DeliveryStreamName": {},
						"Tags": {
							"shape": "S2g"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"TagKeys"
					],
					"members": {
						"DeliveryStreamName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateDestination": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"CurrentDeliveryStreamVersionId",
						"DestinationId"
					],
					"members": {
						"DeliveryStreamName": {},
						"CurrentDeliveryStreamVersionId": {},
						"DestinationId": {},
						"S3DestinationUpdate": {
							"shape": "S42",
							"deprecated": true
						},
						"ExtendedS3DestinationUpdate": {
							"type": "structure",
							"members": {
								"RoleARN": {},
								"BucketARN": {},
								"Prefix": {},
								"ErrorOutputPrefix": {},
								"BufferingHints": {
									"shape": "Sb"
								},
								"CompressionFormat": {},
								"EncryptionConfiguration": {
									"shape": "Sf"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"S3BackupMode": {},
								"S3BackupUpdate": {
									"shape": "S42"
								},
								"DataFormatConversionConfiguration": {
									"shape": "Sx"
								}
							}
						},
						"RedshiftDestinationUpdate": {
							"type": "structure",
							"members": {
								"RoleARN": {},
								"ClusterJDBCURL": {},
								"CopyCommand": {
									"shape": "S1o"
								},
								"Username": {
									"shape": "S1s"
								},
								"Password": {
									"shape": "S1t"
								},
								"RetryOptions": {
									"shape": "S1u"
								},
								"S3Update": {
									"shape": "S42"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"S3BackupMode": {},
								"S3BackupUpdate": {
									"shape": "S42"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								}
							}
						},
						"ElasticsearchDestinationUpdate": {
							"type": "structure",
							"members": {
								"RoleARN": {},
								"DomainARN": {},
								"IndexName": {},
								"TypeName": {},
								"IndexRotationPeriod": {},
								"BufferingHints": {
									"shape": "S22"
								},
								"RetryOptions": {
									"shape": "S25"
								},
								"S3Update": {
									"shape": "S42"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								}
							}
						},
						"SplunkDestinationUpdate": {
							"type": "structure",
							"members": {
								"HECEndpoint": {},
								"HECEndpointType": {},
								"HECToken": {},
								"HECAcknowledgmentTimeoutInSeconds": {
									"type": "integer"
								},
								"RetryOptions": {
									"shape": "S2d"
								},
								"S3BackupMode": {},
								"S3Update": {
									"shape": "S42"
								},
								"ProcessingConfiguration": {
									"shape": "So"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sj"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S7": {
				"type": "structure",
				"required": [
					"RoleARN",
					"BucketARN"
				],
				"members": {
					"RoleARN": {},
					"BucketARN": {},
					"Prefix": {},
					"ErrorOutputPrefix": {},
					"BufferingHints": {
						"shape": "Sb"
					},
					"CompressionFormat": {},
					"EncryptionConfiguration": {
						"shape": "Sf"
					},
					"CloudWatchLoggingOptions": {
						"shape": "Sj"
					}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"SizeInMBs": {
						"type": "integer"
					},
					"IntervalInSeconds": {
						"type": "integer"
					}
				}
			},
			"Sf": {
				"type": "structure",
				"members": {
					"NoEncryptionConfig": {},
					"KMSEncryptionConfig": {
						"type": "structure",
						"required": [
							"AWSKMSKeyARN"
						],
						"members": {
							"AWSKMSKeyARN": {}
						}
					}
				}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"LogGroupName": {},
					"LogStreamName": {}
				}
			},
			"So": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Processors": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Type"
							],
							"members": {
								"Type": {},
								"Parameters": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"ParameterName",
											"ParameterValue"
										],
										"members": {
											"ParameterName": {},
											"ParameterValue": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"SchemaConfiguration": {
						"type": "structure",
						"members": {
							"RoleARN": {},
							"CatalogId": {},
							"DatabaseName": {},
							"TableName": {},
							"Region": {},
							"VersionId": {}
						}
					},
					"InputFormatConfiguration": {
						"type": "structure",
						"members": {
							"Deserializer": {
								"type": "structure",
								"members": {
									"OpenXJsonSerDe": {
										"type": "structure",
										"members": {
											"ConvertDotsInJsonKeysToUnderscores": {
												"type": "boolean"
											},
											"CaseInsensitive": {
												"type": "boolean"
											},
											"ColumnToJsonKeyMappings": {
												"type": "map",
												"key": {},
												"value": {}
											}
										}
									},
									"HiveJsonSerDe": {
										"type": "structure",
										"members": {
											"TimestampFormats": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						}
					},
					"OutputFormatConfiguration": {
						"type": "structure",
						"members": {
							"Serializer": {
								"type": "structure",
								"members": {
									"ParquetSerDe": {
										"type": "structure",
										"members": {
											"BlockSizeBytes": {
												"type": "integer"
											},
											"PageSizeBytes": {
												"type": "integer"
											},
											"Compression": {},
											"EnableDictionaryCompression": {
												"type": "boolean"
											},
											"MaxPaddingBytes": {
												"type": "integer"
											},
											"WriterVersion": {}
										}
									},
									"OrcSerDe": {
										"type": "structure",
										"members": {
											"StripeSizeBytes": {
												"type": "integer"
											},
											"BlockSizeBytes": {
												"type": "integer"
											},
											"RowIndexStride": {
												"type": "integer"
											},
											"EnablePadding": {
												"type": "boolean"
											},
											"PaddingTolerance": {
												"type": "double"
											},
											"Compression": {},
											"BloomFilterColumns": {
												"type": "list",
												"member": {}
											},
											"BloomFilterFalsePositiveProbability": {
												"type": "double"
											},
											"DictionaryKeyThreshold": {
												"type": "double"
											},
											"FormatVersion": {}
										}
									}
								}
							}
						}
					},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S1o": {
				"type": "structure",
				"required": [
					"DataTableName"
				],
				"members": {
					"DataTableName": {},
					"DataTableColumns": {},
					"CopyOptions": {}
				}
			},
			"S1s": {
				"type": "string",
				"sensitive": true
			},
			"S1t": {
				"type": "string",
				"sensitive": true
			},
			"S1u": {
				"type": "structure",
				"members": {
					"DurationInSeconds": {
						"type": "integer"
					}
				}
			},
			"S22": {
				"type": "structure",
				"members": {
					"IntervalInSeconds": {
						"type": "integer"
					},
					"SizeInMBs": {
						"type": "integer"
					}
				}
			},
			"S25": {
				"type": "structure",
				"members": {
					"DurationInSeconds": {
						"type": "integer"
					}
				}
			},
			"S2d": {
				"type": "structure",
				"members": {
					"DurationInSeconds": {
						"type": "integer"
					}
				}
			},
			"S2g": {
				"type": "list",
				"member": {
					"shape": "S2h"
				}
			},
			"S2h": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S33": {
				"type": "structure",
				"required": [
					"RoleARN",
					"BucketARN",
					"BufferingHints",
					"CompressionFormat",
					"EncryptionConfiguration"
				],
				"members": {
					"RoleARN": {},
					"BucketARN": {},
					"Prefix": {},
					"ErrorOutputPrefix": {},
					"BufferingHints": {
						"shape": "Sb"
					},
					"CompressionFormat": {},
					"EncryptionConfiguration": {
						"shape": "Sf"
					},
					"CloudWatchLoggingOptions": {
						"shape": "Sj"
					}
				}
			},
			"S3h": {
				"type": "structure",
				"required": [
					"Data"
				],
				"members": {
					"Data": {
						"type": "blob"
					}
				}
			},
			"S42": {
				"type": "structure",
				"members": {
					"RoleARN": {},
					"BucketARN": {},
					"Prefix": {},
					"ErrorOutputPrefix": {},
					"BufferingHints": {
						"shape": "Sb"
					},
					"CompressionFormat": {},
					"EncryptionConfiguration": {
						"shape": "Sf"
					},
					"CloudWatchLoggingOptions": {
						"shape": "Sj"
					}
				}
			}
		}
	};

/***/ },
/* 1749 */
1641,
/* 1750 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-10-01",
			"endpointPrefix": "gamelift",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon GameLift",
			"serviceId": "GameLift",
			"signatureVersion": "v4",
			"targetPrefix": "GameLift",
			"uid": "gamelift-2015-10-01"
		},
		"operations": {
			"AcceptMatch": {
				"input": {
					"type": "structure",
					"required": [
						"TicketId",
						"PlayerIds",
						"AcceptanceType"
					],
					"members": {
						"TicketId": {},
						"PlayerIds": {
							"shape": "S3"
						},
						"AcceptanceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"RoutingStrategy"
					],
					"members": {
						"Name": {},
						"Description": {},
						"RoutingStrategy": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Alias": {
							"shape": "Se"
						}
					}
				}
			},
			"CreateBuild": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {},
						"Version": {},
						"StorageLocation": {
							"shape": "Sj"
						},
						"OperatingSystem": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Build": {
							"shape": "Sn"
						},
						"UploadCredentials": {
							"shape": "Sr"
						},
						"StorageLocation": {
							"shape": "Sj"
						}
					}
				}
			},
			"CreateFleet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"EC2InstanceType"
					],
					"members": {
						"Name": {},
						"Description": {},
						"BuildId": {},
						"ScriptId": {},
						"ServerLaunchPath": {},
						"ServerLaunchParameters": {},
						"LogPaths": {
							"shape": "S3"
						},
						"EC2InstanceType": {},
						"EC2InboundPermissions": {
							"shape": "Sv"
						},
						"NewGameSessionProtectionPolicy": {},
						"RuntimeConfiguration": {
							"shape": "S11"
						},
						"ResourceCreationLimitPolicy": {
							"shape": "S17"
						},
						"MetricGroups": {
							"shape": "S19"
						},
						"PeerVpcAwsAccountId": {},
						"PeerVpcId": {},
						"FleetType": {},
						"InstanceRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetAttributes": {
							"shape": "S1d"
						}
					}
				}
			},
			"CreateGameSession": {
				"input": {
					"type": "structure",
					"required": [
						"MaximumPlayerSessionCount"
					],
					"members": {
						"FleetId": {},
						"AliasId": {},
						"MaximumPlayerSessionCount": {
							"type": "integer"
						},
						"Name": {},
						"GameProperties": {
							"shape": "S1i"
						},
						"CreatorId": {},
						"GameSessionId": {},
						"IdempotencyToken": {},
						"GameSessionData": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSession": {
							"shape": "S1p"
						}
					}
				}
			},
			"CreateGameSessionQueue": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"TimeoutInSeconds": {
							"type": "integer"
						},
						"PlayerLatencyPolicies": {
							"shape": "S1x"
						},
						"Destinations": {
							"shape": "S1z"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionQueue": {
							"shape": "S22"
						}
					}
				}
			},
			"CreateMatchmakingConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"GameSessionQueueArns",
						"RequestTimeoutSeconds",
						"AcceptanceRequired",
						"RuleSetName"
					],
					"members": {
						"Name": {},
						"Description": {},
						"GameSessionQueueArns": {
							"shape": "S24"
						},
						"RequestTimeoutSeconds": {
							"type": "integer"
						},
						"AcceptanceTimeoutSeconds": {
							"type": "integer"
						},
						"AcceptanceRequired": {
							"type": "boolean"
						},
						"RuleSetName": {},
						"NotificationTarget": {},
						"AdditionalPlayerCount": {
							"type": "integer"
						},
						"CustomEventData": {},
						"GameProperties": {
							"shape": "S1i"
						},
						"GameSessionData": {},
						"BackfillMode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Configuration": {
							"shape": "S2c"
						}
					}
				}
			},
			"CreateMatchmakingRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"RuleSetBody"
					],
					"members": {
						"Name": {},
						"RuleSetBody": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RuleSet"
					],
					"members": {
						"RuleSet": {
							"shape": "S2g"
						}
					}
				}
			},
			"CreatePlayerSession": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId",
						"PlayerId"
					],
					"members": {
						"GameSessionId": {},
						"PlayerId": {},
						"PlayerData": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlayerSession": {
							"shape": "S2k"
						}
					}
				}
			},
			"CreatePlayerSessions": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId",
						"PlayerIds"
					],
					"members": {
						"GameSessionId": {},
						"PlayerIds": {
							"type": "list",
							"member": {}
						},
						"PlayerDataMap": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlayerSessions": {
							"shape": "S2r"
						}
					}
				}
			},
			"CreateScript": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {},
						"Version": {},
						"StorageLocation": {
							"shape": "Sj"
						},
						"ZipFile": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Script": {
							"shape": "S2v"
						}
					}
				}
			},
			"CreateVpcPeeringAuthorization": {
				"input": {
					"type": "structure",
					"required": [
						"GameLiftAwsAccountId",
						"PeerVpcId"
					],
					"members": {
						"GameLiftAwsAccountId": {},
						"PeerVpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringAuthorization": {
							"shape": "S2y"
						}
					}
				}
			},
			"CreateVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"PeerVpcAwsAccountId",
						"PeerVpcId"
					],
					"members": {
						"FleetId": {},
						"PeerVpcAwsAccountId": {},
						"PeerVpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {}
					}
				}
			},
			"DeleteBuild": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {}
					}
				}
			},
			"DeleteFleet": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {}
					}
				}
			},
			"DeleteGameSessionQueue": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteMatchmakingConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteMatchmakingRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"FleetId"
					],
					"members": {
						"Name": {},
						"FleetId": {}
					}
				}
			},
			"DeleteScript": {
				"input": {
					"type": "structure",
					"required": [
						"ScriptId"
					],
					"members": {
						"ScriptId": {}
					}
				}
			},
			"DeleteVpcPeeringAuthorization": {
				"input": {
					"type": "structure",
					"required": [
						"GameLiftAwsAccountId",
						"PeerVpcId"
					],
					"members": {
						"GameLiftAwsAccountId": {},
						"PeerVpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"VpcPeeringConnectionId"
					],
					"members": {
						"FleetId": {},
						"VpcPeeringConnectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Alias": {
							"shape": "Se"
						}
					}
				}
			},
			"DescribeBuild": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Build": {
							"shape": "Sn"
						}
					}
				}
			},
			"DescribeEC2InstanceLimits": {
				"input": {
					"type": "structure",
					"members": {
						"EC2InstanceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EC2InstanceLimits": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EC2InstanceType": {},
									"CurrentInstances": {
										"type": "integer"
									},
									"InstanceLimit": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DescribeFleetAttributes": {
				"input": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S3p"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetAttributes": {
							"type": "list",
							"member": {
								"shape": "S1d"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeFleetCapacity": {
				"input": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S3p"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetCapacity": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"InstanceType": {},
									"InstanceCounts": {
										"type": "structure",
										"members": {
											"DESIRED": {
												"type": "integer"
											},
											"MINIMUM": {
												"type": "integer"
											},
											"MAXIMUM": {
												"type": "integer"
											},
											"PENDING": {
												"type": "integer"
											},
											"ACTIVE": {
												"type": "integer"
											},
											"IDLE": {
												"type": "integer"
											},
											"TERMINATING": {
												"type": "integer"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeFleetEvents": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"ResourceId": {},
									"EventCode": {},
									"Message": {},
									"EventTime": {
										"type": "timestamp"
									},
									"PreSignedLogUrl": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeFleetPortSettings": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InboundPermissions": {
							"shape": "Sv"
						}
					}
				}
			},
			"DescribeFleetUtilization": {
				"input": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S3p"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetUtilization": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"ActiveServerProcessCount": {
										"type": "integer"
									},
									"ActiveGameSessionCount": {
										"type": "integer"
									},
									"CurrentPlayerSessionCount": {
										"type": "integer"
									},
									"MaximumPlayerSessionCount": {
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeGameSessionDetails": {
				"input": {
					"type": "structure",
					"members": {
						"FleetId": {},
						"GameSessionId": {},
						"AliasId": {},
						"StatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GameSession": {
										"shape": "S1p"
									},
									"ProtectionPolicy": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeGameSessionPlacement": {
				"input": {
					"type": "structure",
					"required": [
						"PlacementId"
					],
					"members": {
						"PlacementId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionPlacement": {
							"shape": "S4e"
						}
					}
				}
			},
			"DescribeGameSessionQueues": {
				"input": {
					"type": "structure",
					"members": {
						"Names": {
							"type": "list",
							"member": {}
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionQueues": {
							"type": "list",
							"member": {
								"shape": "S22"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeGameSessions": {
				"input": {
					"type": "structure",
					"members": {
						"FleetId": {},
						"GameSessionId": {},
						"AliasId": {},
						"StatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessions": {
							"shape": "S4r"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstances": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"InstanceId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"InstanceId": {},
									"IpAddress": {},
									"OperatingSystem": {},
									"Type": {},
									"Status": {},
									"CreationTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMatchmaking": {
				"input": {
					"type": "structure",
					"required": [
						"TicketIds"
					],
					"members": {
						"TicketIds": {
							"shape": "S4z"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TicketList": {
							"type": "list",
							"member": {
								"shape": "S52"
							}
						}
					}
				}
			},
			"DescribeMatchmakingConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"Names": {
							"shape": "S4z"
						},
						"RuleSetName": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Configurations": {
							"type": "list",
							"member": {
								"shape": "S2c"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMatchmakingRuleSets": {
				"input": {
					"type": "structure",
					"members": {
						"Names": {
							"type": "list",
							"member": {}
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RuleSets"
					],
					"members": {
						"RuleSets": {
							"type": "list",
							"member": {
								"shape": "S2g"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePlayerSessions": {
				"input": {
					"type": "structure",
					"members": {
						"GameSessionId": {},
						"PlayerId": {},
						"PlayerSessionId": {},
						"PlayerSessionStatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlayerSessions": {
							"shape": "S2r"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeRuntimeConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuntimeConfiguration": {
							"shape": "S11"
						}
					}
				}
			},
			"DescribeScalingPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"StatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalingPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"Name": {},
									"Status": {},
									"ScalingAdjustment": {
										"type": "integer"
									},
									"ScalingAdjustmentType": {},
									"ComparisonOperator": {},
									"Threshold": {
										"type": "double"
									},
									"EvaluationPeriods": {
										"type": "integer"
									},
									"MetricName": {},
									"PolicyType": {},
									"TargetConfiguration": {
										"shape": "S62"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScript": {
				"input": {
					"type": "structure",
					"required": [
						"ScriptId"
					],
					"members": {
						"ScriptId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Script": {
							"shape": "S2v"
						}
					}
				}
			},
			"DescribeVpcPeeringAuthorizations": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringAuthorizations": {
							"type": "list",
							"member": {
								"shape": "S2y"
							}
						}
					}
				}
			},
			"DescribeVpcPeeringConnections": {
				"input": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringConnections": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"IpV4CidrBlock": {},
									"VpcPeeringConnectionId": {},
									"Status": {
										"type": "structure",
										"members": {
											"Code": {},
											"Message": {}
										}
									},
									"PeerVpcId": {},
									"GameLiftVpcId": {}
								}
							}
						}
					}
				}
			},
			"GetGameSessionLogUrl": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId"
					],
					"members": {
						"GameSessionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PreSignedUrl": {}
					}
				}
			},
			"GetInstanceAccess": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"InstanceId"
					],
					"members": {
						"FleetId": {},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceAccess": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceId": {},
								"IpAddress": {},
								"OperatingSystem": {},
								"Credentials": {
									"type": "structure",
									"members": {
										"UserName": {},
										"Secret": {}
									},
									"sensitive": true
								}
							}
						}
					}
				}
			},
			"ListAliases": {
				"input": {
					"type": "structure",
					"members": {
						"RoutingStrategyType": {},
						"Name": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Aliases": {
							"type": "list",
							"member": {
								"shape": "Se"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListBuilds": {
				"input": {
					"type": "structure",
					"members": {
						"Status": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Builds": {
							"type": "list",
							"member": {
								"shape": "Sn"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListFleets": {
				"input": {
					"type": "structure",
					"members": {
						"BuildId": {},
						"ScriptId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S3p"
						},
						"NextToken": {}
					}
				}
			},
			"ListScripts": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Scripts": {
							"type": "list",
							"member": {
								"shape": "S2v"
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"FleetId",
						"MetricName"
					],
					"members": {
						"Name": {},
						"FleetId": {},
						"ScalingAdjustment": {
							"type": "integer"
						},
						"ScalingAdjustmentType": {},
						"Threshold": {
							"type": "double"
						},
						"ComparisonOperator": {},
						"EvaluationPeriods": {
							"type": "integer"
						},
						"MetricName": {},
						"PolicyType": {},
						"TargetConfiguration": {
							"shape": "S62"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {}
					}
				}
			},
			"RequestUploadCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UploadCredentials": {
							"shape": "Sr"
						},
						"StorageLocation": {
							"shape": "Sj"
						}
					}
				}
			},
			"ResolveAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"SearchGameSessions": {
				"input": {
					"type": "structure",
					"members": {
						"FleetId": {},
						"AliasId": {},
						"FilterExpression": {},
						"SortExpression": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessions": {
							"shape": "S4r"
						},
						"NextToken": {}
					}
				}
			},
			"StartFleetActions": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"Actions"
					],
					"members": {
						"FleetId": {},
						"Actions": {
							"shape": "S1f"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StartGameSessionPlacement": {
				"input": {
					"type": "structure",
					"required": [
						"PlacementId",
						"GameSessionQueueName",
						"MaximumPlayerSessionCount"
					],
					"members": {
						"PlacementId": {},
						"GameSessionQueueName": {},
						"GameProperties": {
							"shape": "S1i"
						},
						"MaximumPlayerSessionCount": {
							"type": "integer"
						},
						"GameSessionName": {},
						"PlayerLatencies": {
							"shape": "S4g"
						},
						"DesiredPlayerSessions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PlayerId": {},
									"PlayerData": {}
								}
							}
						},
						"GameSessionData": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionPlacement": {
							"shape": "S4e"
						}
					}
				}
			},
			"StartMatchBackfill": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationName",
						"GameSessionArn",
						"Players"
					],
					"members": {
						"TicketId": {},
						"ConfigurationName": {},
						"GameSessionArn": {},
						"Players": {
							"shape": "S55"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MatchmakingTicket": {
							"shape": "S52"
						}
					}
				}
			},
			"StartMatchmaking": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationName",
						"Players"
					],
					"members": {
						"TicketId": {},
						"ConfigurationName": {},
						"Players": {
							"shape": "S55"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MatchmakingTicket": {
							"shape": "S52"
						}
					}
				}
			},
			"StopFleetActions": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"Actions"
					],
					"members": {
						"FleetId": {},
						"Actions": {
							"shape": "S1f"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StopGameSessionPlacement": {
				"input": {
					"type": "structure",
					"required": [
						"PlacementId"
					],
					"members": {
						"PlacementId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionPlacement": {
							"shape": "S4e"
						}
					}
				}
			},
			"StopMatchmaking": {
				"input": {
					"type": "structure",
					"required": [
						"TicketId"
					],
					"members": {
						"TicketId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {},
						"Name": {},
						"Description": {},
						"RoutingStrategy": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Alias": {
							"shape": "Se"
						}
					}
				}
			},
			"UpdateBuild": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {},
						"Name": {},
						"Version": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Build": {
							"shape": "Sn"
						}
					}
				}
			},
			"UpdateFleetAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"Name": {},
						"Description": {},
						"NewGameSessionProtectionPolicy": {},
						"ResourceCreationLimitPolicy": {
							"shape": "S17"
						},
						"MetricGroups": {
							"shape": "S19"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"UpdateFleetCapacity": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"DesiredInstances": {
							"type": "integer"
						},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"UpdateFleetPortSettings": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"InboundPermissionAuthorizations": {
							"shape": "Sv"
						},
						"InboundPermissionRevocations": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"UpdateGameSession": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId"
					],
					"members": {
						"GameSessionId": {},
						"MaximumPlayerSessionCount": {
							"type": "integer"
						},
						"Name": {},
						"PlayerSessionCreationPolicy": {},
						"ProtectionPolicy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSession": {
							"shape": "S1p"
						}
					}
				}
			},
			"UpdateGameSessionQueue": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"TimeoutInSeconds": {
							"type": "integer"
						},
						"PlayerLatencyPolicies": {
							"shape": "S1x"
						},
						"Destinations": {
							"shape": "S1z"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionQueue": {
							"shape": "S22"
						}
					}
				}
			},
			"UpdateMatchmakingConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Description": {},
						"GameSessionQueueArns": {
							"shape": "S24"
						},
						"RequestTimeoutSeconds": {
							"type": "integer"
						},
						"AcceptanceTimeoutSeconds": {
							"type": "integer"
						},
						"AcceptanceRequired": {
							"type": "boolean"
						},
						"RuleSetName": {},
						"NotificationTarget": {},
						"AdditionalPlayerCount": {
							"type": "integer"
						},
						"CustomEventData": {},
						"GameProperties": {
							"shape": "S1i"
						},
						"GameSessionData": {},
						"BackfillMode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Configuration": {
							"shape": "S2c"
						}
					}
				}
			},
			"UpdateRuntimeConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"RuntimeConfiguration"
					],
					"members": {
						"FleetId": {},
						"RuntimeConfiguration": {
							"shape": "S11"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuntimeConfiguration": {
							"shape": "S11"
						}
					}
				}
			},
			"UpdateScript": {
				"input": {
					"type": "structure",
					"required": [
						"ScriptId"
					],
					"members": {
						"ScriptId": {},
						"Name": {},
						"Version": {},
						"StorageLocation": {
							"shape": "Sj"
						},
						"ZipFile": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Script": {
							"shape": "S2v"
						}
					}
				}
			},
			"ValidateMatchmakingRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetBody"
					],
					"members": {
						"RuleSetBody": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Valid": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {}
			},
			"S9": {
				"type": "structure",
				"members": {
					"Type": {},
					"FleetId": {},
					"Message": {}
				}
			},
			"Se": {
				"type": "structure",
				"members": {
					"AliasId": {},
					"Name": {},
					"AliasArn": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "S9"
					},
					"CreationTime": {
						"type": "timestamp"
					},
					"LastUpdatedTime": {
						"type": "timestamp"
					}
				}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"Key": {},
					"RoleArn": {},
					"ObjectVersion": {}
				}
			},
			"Sn": {
				"type": "structure",
				"members": {
					"BuildId": {},
					"Name": {},
					"Version": {},
					"Status": {},
					"SizeOnDisk": {
						"type": "long"
					},
					"OperatingSystem": {},
					"CreationTime": {
						"type": "timestamp"
					}
				}
			},
			"Sr": {
				"type": "structure",
				"members": {
					"AccessKeyId": {},
					"SecretAccessKey": {},
					"SessionToken": {}
				},
				"sensitive": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"FromPort",
						"ToPort",
						"IpRange",
						"Protocol"
					],
					"members": {
						"FromPort": {
							"type": "integer"
						},
						"ToPort": {
							"type": "integer"
						},
						"IpRange": {},
						"Protocol": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"ServerProcesses": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LaunchPath",
								"ConcurrentExecutions"
							],
							"members": {
								"LaunchPath": {},
								"Parameters": {},
								"ConcurrentExecutions": {
									"type": "integer"
								}
							}
						}
					},
					"MaxConcurrentGameSessionActivations": {
						"type": "integer"
					},
					"GameSessionActivationTimeoutSeconds": {
						"type": "integer"
					}
				}
			},
			"S17": {
				"type": "structure",
				"members": {
					"NewGameSessionsPerCreator": {
						"type": "integer"
					},
					"PolicyPeriodInMinutes": {
						"type": "integer"
					}
				}
			},
			"S19": {
				"type": "list",
				"member": {}
			},
			"S1d": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"FleetArn": {},
					"FleetType": {},
					"InstanceType": {},
					"Description": {},
					"Name": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"TerminationTime": {
						"type": "timestamp"
					},
					"Status": {},
					"BuildId": {},
					"ScriptId": {},
					"ServerLaunchPath": {},
					"ServerLaunchParameters": {},
					"LogPaths": {
						"shape": "S3"
					},
					"NewGameSessionProtectionPolicy": {},
					"OperatingSystem": {},
					"ResourceCreationLimitPolicy": {
						"shape": "S17"
					},
					"MetricGroups": {
						"shape": "S19"
					},
					"StoppedActions": {
						"shape": "S1f"
					},
					"InstanceRoleArn": {}
				}
			},
			"S1f": {
				"type": "list",
				"member": {}
			},
			"S1i": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"GameSessionId": {},
					"Name": {},
					"FleetId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"TerminationTime": {
						"type": "timestamp"
					},
					"CurrentPlayerSessionCount": {
						"type": "integer"
					},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Status": {},
					"StatusReason": {},
					"GameProperties": {
						"shape": "S1i"
					},
					"IpAddress": {},
					"Port": {
						"type": "integer"
					},
					"PlayerSessionCreationPolicy": {},
					"CreatorId": {},
					"GameSessionData": {},
					"MatchmakerData": {}
				}
			},
			"S1x": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"MaximumIndividualPlayerLatencyMilliseconds": {
							"type": "integer"
						},
						"PolicyDurationSeconds": {
							"type": "integer"
						}
					}
				}
			},
			"S1z": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"DestinationArn": {}
					}
				}
			},
			"S22": {
				"type": "structure",
				"members": {
					"Name": {},
					"GameSessionQueueArn": {},
					"TimeoutInSeconds": {
						"type": "integer"
					},
					"PlayerLatencyPolicies": {
						"shape": "S1x"
					},
					"Destinations": {
						"shape": "S1z"
					}
				}
			},
			"S24": {
				"type": "list",
				"member": {}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"Name": {},
					"Description": {},
					"GameSessionQueueArns": {
						"shape": "S24"
					},
					"RequestTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceTimeoutSeconds": {
						"type": "integer"
					},
					"AcceptanceRequired": {
						"type": "boolean"
					},
					"RuleSetName": {},
					"NotificationTarget": {},
					"AdditionalPlayerCount": {
						"type": "integer"
					},
					"CustomEventData": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"GameProperties": {
						"shape": "S1i"
					},
					"GameSessionData": {},
					"BackfillMode": {}
				}
			},
			"S2g": {
				"type": "structure",
				"required": [
					"RuleSetBody"
				],
				"members": {
					"RuleSetName": {},
					"RuleSetBody": {},
					"CreationTime": {
						"type": "timestamp"
					}
				}
			},
			"S2k": {
				"type": "structure",
				"members": {
					"PlayerSessionId": {},
					"PlayerId": {},
					"GameSessionId": {},
					"FleetId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"TerminationTime": {
						"type": "timestamp"
					},
					"Status": {},
					"IpAddress": {},
					"Port": {
						"type": "integer"
					},
					"PlayerData": {}
				}
			},
			"S2r": {
				"type": "list",
				"member": {
					"shape": "S2k"
				}
			},
			"S2v": {
				"type": "structure",
				"members": {
					"ScriptId": {},
					"Name": {},
					"Version": {},
					"SizeOnDisk": {
						"type": "long"
					},
					"CreationTime": {
						"type": "timestamp"
					},
					"StorageLocation": {
						"shape": "Sj"
					}
				}
			},
			"S2y": {
				"type": "structure",
				"members": {
					"GameLiftAwsAccountId": {},
					"PeerVpcAwsAccountId": {},
					"PeerVpcId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"ExpirationTime": {
						"type": "timestamp"
					}
				}
			},
			"S3p": {
				"type": "list",
				"member": {}
			},
			"S4e": {
				"type": "structure",
				"members": {
					"PlacementId": {},
					"GameSessionQueueName": {},
					"Status": {},
					"GameProperties": {
						"shape": "S1i"
					},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"GameSessionName": {},
					"GameSessionId": {},
					"GameSessionArn": {},
					"GameSessionRegion": {},
					"PlayerLatencies": {
						"shape": "S4g"
					},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"IpAddress": {},
					"Port": {
						"type": "integer"
					},
					"PlacedPlayerSessions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"PlayerId": {},
								"PlayerSessionId": {}
							}
						}
					},
					"GameSessionData": {},
					"MatchmakerData": {}
				}
			},
			"S4g": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PlayerId": {},
						"RegionIdentifier": {},
						"LatencyInMilliseconds": {
							"type": "float"
						}
					}
				}
			},
			"S4r": {
				"type": "list",
				"member": {
					"shape": "S1p"
				}
			},
			"S4z": {
				"type": "list",
				"member": {}
			},
			"S52": {
				"type": "structure",
				"members": {
					"TicketId": {},
					"ConfigurationName": {},
					"Status": {},
					"StatusReason": {},
					"StatusMessage": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"Players": {
						"shape": "S55"
					},
					"GameSessionConnectionInfo": {
						"type": "structure",
						"members": {
							"GameSessionArn": {},
							"IpAddress": {},
							"Port": {
								"type": "integer"
							},
							"MatchedPlayerSessions": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"PlayerId": {},
										"PlayerSessionId": {}
									}
								}
							}
						}
					},
					"EstimatedWaitTime": {
						"type": "integer"
					}
				}
			},
			"S55": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PlayerId": {},
						"PlayerAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"S": {},
									"N": {
										"type": "double"
									},
									"SL": {
										"shape": "S3"
									},
									"SDM": {
										"type": "map",
										"key": {},
										"value": {
											"type": "double"
										}
									}
								}
							}
						},
						"Team": {},
						"LatencyInMs": {
							"type": "map",
							"key": {},
							"value": {
								"type": "integer"
							}
						}
					}
				}
			},
			"S62": {
				"type": "structure",
				"required": [
					"TargetValue"
				],
				"members": {
					"TargetValue": {
						"type": "double"
					}
				}
			}
		}
	};

/***/ },
/* 1751 */
1641,
/* 1752 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-05-08",
			"endpointPrefix": "iam",
			"globalEndpoint": "iam.amazonaws.com",
			"protocol": "query",
			"serviceAbbreviation": "IAM",
			"serviceFullName": "AWS Identity and Access Management",
			"serviceId": "IAM",
			"signatureVersion": "v4",
			"uid": "iam-2010-05-08",
			"xmlNamespace": "https://iam.amazonaws.com/doc/2010-05-08/"
		},
		"operations": {
			"AddClientIDToOpenIDConnectProvider": {
				"input": {
					"type": "structure",
					"required": [
						"OpenIDConnectProviderArn",
						"ClientID"
					],
					"members": {
						"OpenIDConnectProviderArn": {},
						"ClientID": {}
					}
				}
			},
			"AddRoleToInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceProfileName",
						"RoleName"
					],
					"members": {
						"InstanceProfileName": {},
						"RoleName": {}
					}
				}
			},
			"AddUserToGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserName"
					],
					"members": {
						"GroupName": {},
						"UserName": {}
					}
				}
			},
			"AttachGroupPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"PolicyArn"
					],
					"members": {
						"GroupName": {},
						"PolicyArn": {}
					}
				}
			},
			"AttachRolePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"PolicyArn"
					],
					"members": {
						"RoleName": {},
						"PolicyArn": {}
					}
				}
			},
			"AttachUserPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"PolicyArn"
					],
					"members": {
						"UserName": {},
						"PolicyArn": {}
					}
				}
			},
			"ChangePassword": {
				"input": {
					"type": "structure",
					"required": [
						"OldPassword",
						"NewPassword"
					],
					"members": {
						"OldPassword": {
							"shape": "Sf"
						},
						"NewPassword": {
							"shape": "Sf"
						}
					}
				}
			},
			"CreateAccessKey": {
				"input": {
					"type": "structure",
					"members": {
						"UserName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateAccessKeyResult",
					"type": "structure",
					"required": [
						"AccessKey"
					],
					"members": {
						"AccessKey": {
							"type": "structure",
							"required": [
								"UserName",
								"AccessKeyId",
								"Status",
								"SecretAccessKey"
							],
							"members": {
								"UserName": {},
								"AccessKeyId": {},
								"Status": {},
								"SecretAccessKey": {
									"type": "string",
									"sensitive": true
								},
								"CreateDate": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"CreateAccountAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AccountAlias"
					],
					"members": {
						"AccountAlias": {}
					}
				}
			},
			"CreateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"Path": {},
						"GroupName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateGroupResult",
					"type": "structure",
					"required": [
						"Group"
					],
					"members": {
						"Group": {
							"shape": "Ss"
						}
					}
				}
			},
			"CreateInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceProfileName"
					],
					"members": {
						"InstanceProfileName": {},
						"Path": {}
					}
				},
				"output": {
					"resultWrapper": "CreateInstanceProfileResult",
					"type": "structure",
					"required": [
						"InstanceProfile"
					],
					"members": {
						"InstanceProfile": {
							"shape": "Sw"
						}
					}
				}
			},
			"CreateLoginProfile": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"Password"
					],
					"members": {
						"UserName": {},
						"Password": {
							"shape": "Sf"
						},
						"PasswordResetRequired": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLoginProfileResult",
					"type": "structure",
					"required": [
						"LoginProfile"
					],
					"members": {
						"LoginProfile": {
							"shape": "S1b"
						}
					}
				}
			},
			"CreateOpenIDConnectProvider": {
				"input": {
					"type": "structure",
					"required": [
						"Url",
						"ThumbprintList"
					],
					"members": {
						"Url": {},
						"ClientIDList": {
							"shape": "S1e"
						},
						"ThumbprintList": {
							"shape": "S1f"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateOpenIDConnectProviderResult",
					"type": "structure",
					"members": {
						"OpenIDConnectProviderArn": {}
					}
				}
			},
			"CreatePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName",
						"PolicyDocument"
					],
					"members": {
						"PolicyName": {},
						"Path": {},
						"PolicyDocument": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreatePolicyResult",
					"type": "structure",
					"members": {
						"Policy": {
							"shape": "S1n"
						}
					}
				}
			},
			"CreatePolicyVersion": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn",
						"PolicyDocument"
					],
					"members": {
						"PolicyArn": {},
						"PolicyDocument": {},
						"SetAsDefault": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreatePolicyVersionResult",
					"type": "structure",
					"members": {
						"PolicyVersion": {
							"shape": "S1s"
						}
					}
				}
			},
			"CreateRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"AssumeRolePolicyDocument"
					],
					"members": {
						"Path": {},
						"RoleName": {},
						"AssumeRolePolicyDocument": {},
						"Description": {},
						"MaxSessionDuration": {
							"type": "integer"
						},
						"PermissionsBoundary": {},
						"Tags": {
							"shape": "S14"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateRoleResult",
					"type": "structure",
					"required": [
						"Role"
					],
					"members": {
						"Role": {
							"shape": "Sy"
						}
					}
				}
			},
			"CreateSAMLProvider": {
				"input": {
					"type": "structure",
					"required": [
						"SAMLMetadataDocument",
						"Name"
					],
					"members": {
						"SAMLMetadataDocument": {},
						"Name": {}
					}
				},
				"output": {
					"resultWrapper": "CreateSAMLProviderResult",
					"type": "structure",
					"members": {
						"SAMLProviderArn": {}
					}
				}
			},
			"CreateServiceLinkedRole": {
				"input": {
					"type": "structure",
					"required": [
						"AWSServiceName"
					],
					"members": {
						"AWSServiceName": {},
						"Description": {},
						"CustomSuffix": {}
					}
				},
				"output": {
					"resultWrapper": "CreateServiceLinkedRoleResult",
					"type": "structure",
					"members": {
						"Role": {
							"shape": "Sy"
						}
					}
				}
			},
			"CreateServiceSpecificCredential": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"ServiceName"
					],
					"members": {
						"UserName": {},
						"ServiceName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateServiceSpecificCredentialResult",
					"type": "structure",
					"members": {
						"ServiceSpecificCredential": {
							"shape": "S25"
						}
					}
				}
			},
			"CreateUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"Path": {},
						"UserName": {},
						"PermissionsBoundary": {},
						"Tags": {
							"shape": "S14"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateUserResult",
					"type": "structure",
					"members": {
						"User": {
							"shape": "S2b"
						}
					}
				}
			},
			"CreateVirtualMFADevice": {
				"input": {
					"type": "structure",
					"required": [
						"VirtualMFADeviceName"
					],
					"members": {
						"Path": {},
						"VirtualMFADeviceName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateVirtualMFADeviceResult",
					"type": "structure",
					"required": [
						"VirtualMFADevice"
					],
					"members": {
						"VirtualMFADevice": {
							"shape": "S2f"
						}
					}
				}
			},
			"DeactivateMFADevice": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"SerialNumber"
					],
					"members": {
						"UserName": {},
						"SerialNumber": {}
					}
				}
			},
			"DeleteAccessKey": {
				"input": {
					"type": "structure",
					"required": [
						"AccessKeyId"
					],
					"members": {
						"UserName": {},
						"AccessKeyId": {}
					}
				}
			},
			"DeleteAccountAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AccountAlias"
					],
					"members": {
						"AccountAlias": {}
					}
				}
			},
			"DeleteAccountPasswordPolicy": {},
			"DeleteGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {}
					}
				}
			},
			"DeleteGroupPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"PolicyName"
					],
					"members": {
						"GroupName": {},
						"PolicyName": {}
					}
				}
			},
			"DeleteInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceProfileName"
					],
					"members": {
						"InstanceProfileName": {}
					}
				}
			},
			"DeleteLoginProfile": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {}
					}
				}
			},
			"DeleteOpenIDConnectProvider": {
				"input": {
					"type": "structure",
					"required": [
						"OpenIDConnectProviderArn"
					],
					"members": {
						"OpenIDConnectProviderArn": {}
					}
				}
			},
			"DeletePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn"
					],
					"members": {
						"PolicyArn": {}
					}
				}
			},
			"DeletePolicyVersion": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn",
						"VersionId"
					],
					"members": {
						"PolicyArn": {},
						"VersionId": {}
					}
				}
			},
			"DeleteRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {}
					}
				}
			},
			"DeleteRolePermissionsBoundary": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {}
					}
				}
			},
			"DeleteRolePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"PolicyName"
					],
					"members": {
						"RoleName": {},
						"PolicyName": {}
					}
				}
			},
			"DeleteSAMLProvider": {
				"input": {
					"type": "structure",
					"required": [
						"SAMLProviderArn"
					],
					"members": {
						"SAMLProviderArn": {}
					}
				}
			},
			"DeleteSSHPublicKey": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"SSHPublicKeyId"
					],
					"members": {
						"UserName": {},
						"SSHPublicKeyId": {}
					}
				}
			},
			"DeleteServerCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"ServerCertificateName"
					],
					"members": {
						"ServerCertificateName": {}
					}
				}
			},
			"DeleteServiceLinkedRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteServiceLinkedRoleResult",
					"type": "structure",
					"required": [
						"DeletionTaskId"
					],
					"members": {
						"DeletionTaskId": {}
					}
				}
			},
			"DeleteServiceSpecificCredential": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceSpecificCredentialId"
					],
					"members": {
						"UserName": {},
						"ServiceSpecificCredentialId": {}
					}
				}
			},
			"DeleteSigningCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateId"
					],
					"members": {
						"UserName": {},
						"CertificateId": {}
					}
				}
			},
			"DeleteUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {}
					}
				}
			},
			"DeleteUserPermissionsBoundary": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {}
					}
				}
			},
			"DeleteUserPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"PolicyName"
					],
					"members": {
						"UserName": {},
						"PolicyName": {}
					}
				}
			},
			"DeleteVirtualMFADevice": {
				"input": {
					"type": "structure",
					"required": [
						"SerialNumber"
					],
					"members": {
						"SerialNumber": {}
					}
				}
			},
			"DetachGroupPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"PolicyArn"
					],
					"members": {
						"GroupName": {},
						"PolicyArn": {}
					}
				}
			},
			"DetachRolePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"PolicyArn"
					],
					"members": {
						"RoleName": {},
						"PolicyArn": {}
					}
				}
			},
			"DetachUserPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"PolicyArn"
					],
					"members": {
						"UserName": {},
						"PolicyArn": {}
					}
				}
			},
			"EnableMFADevice": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"SerialNumber",
						"AuthenticationCode1",
						"AuthenticationCode2"
					],
					"members": {
						"UserName": {},
						"SerialNumber": {},
						"AuthenticationCode1": {},
						"AuthenticationCode2": {}
					}
				}
			},
			"GenerateCredentialReport": {
				"output": {
					"resultWrapper": "GenerateCredentialReportResult",
					"type": "structure",
					"members": {
						"State": {},
						"Description": {}
					}
				}
			},
			"GenerateOrganizationsAccessReport": {
				"input": {
					"type": "structure",
					"required": [
						"EntityPath"
					],
					"members": {
						"EntityPath": {},
						"OrganizationsPolicyId": {}
					}
				},
				"output": {
					"resultWrapper": "GenerateOrganizationsAccessReportResult",
					"type": "structure",
					"members": {
						"JobId": {}
					}
				}
			},
			"GenerateServiceLastAccessedDetails": {
				"input": {
					"type": "structure",
					"required": [
						"Arn"
					],
					"members": {
						"Arn": {}
					}
				},
				"output": {
					"resultWrapper": "GenerateServiceLastAccessedDetailsResult",
					"type": "structure",
					"members": {
						"JobId": {}
					}
				}
			},
			"GetAccessKeyLastUsed": {
				"input": {
					"type": "structure",
					"required": [
						"AccessKeyId"
					],
					"members": {
						"AccessKeyId": {}
					}
				},
				"output": {
					"resultWrapper": "GetAccessKeyLastUsedResult",
					"type": "structure",
					"members": {
						"UserName": {},
						"AccessKeyLastUsed": {
							"type": "structure",
							"required": [
								"LastUsedDate",
								"ServiceName",
								"Region"
							],
							"members": {
								"LastUsedDate": {
									"type": "timestamp"
								},
								"ServiceName": {},
								"Region": {}
							}
						}
					}
				}
			},
			"GetAccountAuthorizationDetails": {
				"input": {
					"type": "structure",
					"members": {
						"Filter": {
							"type": "list",
							"member": {}
						},
						"MaxItems": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "GetAccountAuthorizationDetailsResult",
					"type": "structure",
					"members": {
						"UserDetailList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Path": {},
									"UserName": {},
									"UserId": {},
									"Arn": {},
									"CreateDate": {
										"type": "timestamp"
									},
									"UserPolicyList": {
										"shape": "S41"
									},
									"GroupList": {
										"type": "list",
										"member": {}
									},
									"AttachedManagedPolicies": {
										"shape": "S44"
									},
									"PermissionsBoundary": {
										"shape": "S12"
									},
									"Tags": {
										"shape": "S14"
									}
								}
							}
						},
						"GroupDetailList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Path": {},
									"GroupName": {},
									"GroupId": {},
									"Arn": {},
									"CreateDate": {
										"type": "timestamp"
									},
									"GroupPolicyList": {
										"shape": "S41"
									},
									"AttachedManagedPolicies": {
										"shape": "S44"
									}
								}
							}
						},
						"RoleDetailList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Path": {},
									"RoleName": {},
									"RoleId": {},
									"Arn": {},
									"CreateDate": {
										"type": "timestamp"
									},
									"AssumeRolePolicyDocument": {},
									"InstanceProfileList": {
										"shape": "S4a"
									},
									"RolePolicyList": {
										"shape": "S41"
									},
									"AttachedManagedPolicies": {
										"shape": "S44"
									},
									"PermissionsBoundary": {
										"shape": "S12"
									},
									"Tags": {
										"shape": "S14"
									}
								}
							}
						},
						"Policies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PolicyName": {},
									"PolicyId": {},
									"Arn": {},
									"Path": {},
									"DefaultVersionId": {},
									"AttachmentCount": {
										"type": "integer"
									},
									"PermissionsBoundaryUsageCount": {
										"type": "integer"
									},
									"IsAttachable": {
										"type": "boolean"
									},
									"Description": {},
									"CreateDate": {
										"type": "timestamp"
									},
									"UpdateDate": {
										"type": "timestamp"
									},
									"PolicyVersionList": {
										"shape": "S4d"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"GetAccountPasswordPolicy": {
				"output": {
					"resultWrapper": "GetAccountPasswordPolicyResult",
					"type": "structure",
					"required": [
						"PasswordPolicy"
					],
					"members": {
						"PasswordPolicy": {
							"type": "structure",
							"members": {
								"MinimumPasswordLength": {
									"type": "integer"
								},
								"RequireSymbols": {
									"type": "boolean"
								},
								"RequireNumbers": {
									"type": "boolean"
								},
								"RequireUppercaseCharacters": {
									"type": "boolean"
								},
								"RequireLowercaseCharacters": {
									"type": "boolean"
								},
								"AllowUsersToChangePassword": {
									"type": "boolean"
								},
								"ExpirePasswords": {
									"type": "boolean"
								},
								"MaxPasswordAge": {
									"type": "integer"
								},
								"PasswordReusePrevention": {
									"type": "integer"
								},
								"HardExpiry": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"GetAccountSummary": {
				"output": {
					"resultWrapper": "GetAccountSummaryResult",
					"type": "structure",
					"members": {
						"SummaryMap": {
							"type": "map",
							"key": {},
							"value": {
								"type": "integer"
							}
						}
					}
				}
			},
			"GetContextKeysForCustomPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyInputList"
					],
					"members": {
						"PolicyInputList": {
							"shape": "S4q"
						}
					}
				},
				"output": {
					"shape": "S4r",
					"resultWrapper": "GetContextKeysForCustomPolicyResult"
				}
			},
			"GetContextKeysForPrincipalPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicySourceArn"
					],
					"members": {
						"PolicySourceArn": {},
						"PolicyInputList": {
							"shape": "S4q"
						}
					}
				},
				"output": {
					"shape": "S4r",
					"resultWrapper": "GetContextKeysForPrincipalPolicyResult"
				}
			},
			"GetCredentialReport": {
				"output": {
					"resultWrapper": "GetCredentialReportResult",
					"type": "structure",
					"members": {
						"Content": {
							"type": "blob"
						},
						"ReportFormat": {},
						"GeneratedTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "GetGroupResult",
					"type": "structure",
					"required": [
						"Group",
						"Users"
					],
					"members": {
						"Group": {
							"shape": "Ss"
						},
						"Users": {
							"shape": "S50"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"GetGroupPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"PolicyName"
					],
					"members": {
						"GroupName": {},
						"PolicyName": {}
					}
				},
				"output": {
					"resultWrapper": "GetGroupPolicyResult",
					"type": "structure",
					"required": [
						"GroupName",
						"PolicyName",
						"PolicyDocument"
					],
					"members": {
						"GroupName": {},
						"PolicyName": {},
						"PolicyDocument": {}
					}
				}
			},
			"GetInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceProfileName"
					],
					"members": {
						"InstanceProfileName": {}
					}
				},
				"output": {
					"resultWrapper": "GetInstanceProfileResult",
					"type": "structure",
					"required": [
						"InstanceProfile"
					],
					"members": {
						"InstanceProfile": {
							"shape": "Sw"
						}
					}
				}
			},
			"GetLoginProfile": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {}
					}
				},
				"output": {
					"resultWrapper": "GetLoginProfileResult",
					"type": "structure",
					"required": [
						"LoginProfile"
					],
					"members": {
						"LoginProfile": {
							"shape": "S1b"
						}
					}
				}
			},
			"GetOpenIDConnectProvider": {
				"input": {
					"type": "structure",
					"required": [
						"OpenIDConnectProviderArn"
					],
					"members": {
						"OpenIDConnectProviderArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetOpenIDConnectProviderResult",
					"type": "structure",
					"members": {
						"Url": {},
						"ClientIDList": {
							"shape": "S1e"
						},
						"ThumbprintList": {
							"shape": "S1f"
						},
						"CreateDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetOrganizationsAccessReport": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxItems": {
							"type": "integer"
						},
						"Marker": {},
						"SortKey": {}
					}
				},
				"output": {
					"resultWrapper": "GetOrganizationsAccessReportResult",
					"type": "structure",
					"required": [
						"JobStatus",
						"JobCreationDate"
					],
					"members": {
						"JobStatus": {},
						"JobCreationDate": {
							"type": "timestamp"
						},
						"JobCompletionDate": {
							"type": "timestamp"
						},
						"NumberOfServicesAccessible": {
							"type": "integer"
						},
						"NumberOfServicesNotAccessed": {
							"type": "integer"
						},
						"AccessDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ServiceName",
									"ServiceNamespace"
								],
								"members": {
									"ServiceName": {},
									"ServiceNamespace": {},
									"Region": {},
									"EntityPath": {},
									"LastAuthenticatedTime": {
										"type": "timestamp"
									},
									"TotalAuthenticatedEntities": {
										"type": "integer"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {},
						"ErrorDetails": {
							"shape": "S5i"
						}
					}
				}
			},
			"GetPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn"
					],
					"members": {
						"PolicyArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetPolicyResult",
					"type": "structure",
					"members": {
						"Policy": {
							"shape": "S1n"
						}
					}
				}
			},
			"GetPolicyVersion": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn",
						"VersionId"
					],
					"members": {
						"PolicyArn": {},
						"VersionId": {}
					}
				},
				"output": {
					"resultWrapper": "GetPolicyVersionResult",
					"type": "structure",
					"members": {
						"PolicyVersion": {
							"shape": "S1s"
						}
					}
				}
			},
			"GetRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {}
					}
				},
				"output": {
					"resultWrapper": "GetRoleResult",
					"type": "structure",
					"required": [
						"Role"
					],
					"members": {
						"Role": {
							"shape": "Sy"
						}
					}
				}
			},
			"GetRolePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"PolicyName"
					],
					"members": {
						"RoleName": {},
						"PolicyName": {}
					}
				},
				"output": {
					"resultWrapper": "GetRolePolicyResult",
					"type": "structure",
					"required": [
						"RoleName",
						"PolicyName",
						"PolicyDocument"
					],
					"members": {
						"RoleName": {},
						"PolicyName": {},
						"PolicyDocument": {}
					}
				}
			},
			"GetSAMLProvider": {
				"input": {
					"type": "structure",
					"required": [
						"SAMLProviderArn"
					],
					"members": {
						"SAMLProviderArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetSAMLProviderResult",
					"type": "structure",
					"members": {
						"SAMLMetadataDocument": {},
						"CreateDate": {
							"type": "timestamp"
						},
						"ValidUntil": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetSSHPublicKey": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"SSHPublicKeyId",
						"Encoding"
					],
					"members": {
						"UserName": {},
						"SSHPublicKeyId": {},
						"Encoding": {}
					}
				},
				"output": {
					"resultWrapper": "GetSSHPublicKeyResult",
					"type": "structure",
					"members": {
						"SSHPublicKey": {
							"shape": "S5w"
						}
					}
				}
			},
			"GetServerCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"ServerCertificateName"
					],
					"members": {
						"ServerCertificateName": {}
					}
				},
				"output": {
					"resultWrapper": "GetServerCertificateResult",
					"type": "structure",
					"required": [
						"ServerCertificate"
					],
					"members": {
						"ServerCertificate": {
							"type": "structure",
							"required": [
								"ServerCertificateMetadata",
								"CertificateBody"
							],
							"members": {
								"ServerCertificateMetadata": {
									"shape": "S62"
								},
								"CertificateBody": {},
								"CertificateChain": {}
							}
						}
					}
				}
			},
			"GetServiceLastAccessedDetails": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxItems": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "GetServiceLastAccessedDetailsResult",
					"type": "structure",
					"required": [
						"JobStatus",
						"JobCreationDate",
						"ServicesLastAccessed",
						"JobCompletionDate"
					],
					"members": {
						"JobStatus": {},
						"JobCreationDate": {
							"type": "timestamp"
						},
						"ServicesLastAccessed": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ServiceName",
									"ServiceNamespace"
								],
								"members": {
									"ServiceName": {},
									"LastAuthenticated": {
										"type": "timestamp"
									},
									"ServiceNamespace": {},
									"LastAuthenticatedEntity": {},
									"TotalAuthenticatedEntities": {
										"type": "integer"
									}
								}
							}
						},
						"JobCompletionDate": {
							"type": "timestamp"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {},
						"Error": {
							"shape": "S5i"
						}
					}
				}
			},
			"GetServiceLastAccessedDetailsWithEntities": {
				"input": {
					"type": "structure",
					"required": [
						"JobId",
						"ServiceNamespace"
					],
					"members": {
						"JobId": {},
						"ServiceNamespace": {},
						"MaxItems": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "GetServiceLastAccessedDetailsWithEntitiesResult",
					"type": "structure",
					"required": [
						"JobStatus",
						"JobCreationDate",
						"JobCompletionDate",
						"EntityDetailsList"
					],
					"members": {
						"JobStatus": {},
						"JobCreationDate": {
							"type": "timestamp"
						},
						"JobCompletionDate": {
							"type": "timestamp"
						},
						"EntityDetailsList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"EntityInfo"
								],
								"members": {
									"EntityInfo": {
										"type": "structure",
										"required": [
											"Arn",
											"Name",
											"Type",
											"Id"
										],
										"members": {
											"Arn": {},
											"Name": {},
											"Type": {},
											"Id": {},
											"Path": {}
										}
									},
									"LastAuthenticated": {
										"type": "timestamp"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {},
						"Error": {
							"shape": "S5i"
						}
					}
				}
			},
			"GetServiceLinkedRoleDeletionStatus": {
				"input": {
					"type": "structure",
					"required": [
						"DeletionTaskId"
					],
					"members": {
						"DeletionTaskId": {}
					}
				},
				"output": {
					"resultWrapper": "GetServiceLinkedRoleDeletionStatusResult",
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {},
						"Reason": {
							"type": "structure",
							"members": {
								"Reason": {},
								"RoleUsageList": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Region": {},
											"Resources": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"GetUser": {
				"input": {
					"type": "structure",
					"members": {
						"UserName": {}
					}
				},
				"output": {
					"resultWrapper": "GetUserResult",
					"type": "structure",
					"required": [
						"User"
					],
					"members": {
						"User": {
							"shape": "S2b"
						}
					}
				}
			},
			"GetUserPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"PolicyName"
					],
					"members": {
						"UserName": {},
						"PolicyName": {}
					}
				},
				"output": {
					"resultWrapper": "GetUserPolicyResult",
					"type": "structure",
					"required": [
						"UserName",
						"PolicyName",
						"PolicyDocument"
					],
					"members": {
						"UserName": {},
						"PolicyName": {},
						"PolicyDocument": {}
					}
				}
			},
			"ListAccessKeys": {
				"input": {
					"type": "structure",
					"members": {
						"UserName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListAccessKeysResult",
					"type": "structure",
					"required": [
						"AccessKeyMetadata"
					],
					"members": {
						"AccessKeyMetadata": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"UserName": {},
									"AccessKeyId": {},
									"Status": {},
									"CreateDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListAccountAliases": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListAccountAliasesResult",
					"type": "structure",
					"required": [
						"AccountAliases"
					],
					"members": {
						"AccountAliases": {
							"type": "list",
							"member": {}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListAttachedGroupPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {},
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListAttachedGroupPoliciesResult",
					"type": "structure",
					"members": {
						"AttachedPolicies": {
							"shape": "S44"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListAttachedRolePolicies": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {},
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListAttachedRolePoliciesResult",
					"type": "structure",
					"members": {
						"AttachedPolicies": {
							"shape": "S44"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListAttachedUserPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {},
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListAttachedUserPoliciesResult",
					"type": "structure",
					"members": {
						"AttachedPolicies": {
							"shape": "S44"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListEntitiesForPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn"
					],
					"members": {
						"PolicyArn": {},
						"EntityFilter": {},
						"PathPrefix": {},
						"PolicyUsageFilter": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListEntitiesForPolicyResult",
					"type": "structure",
					"members": {
						"PolicyGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GroupName": {},
									"GroupId": {}
								}
							}
						},
						"PolicyUsers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"UserName": {},
									"UserId": {}
								}
							}
						},
						"PolicyRoles": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RoleName": {},
									"RoleId": {}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListGroupPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListGroupPoliciesResult",
					"type": "structure",
					"required": [
						"PolicyNames"
					],
					"members": {
						"PolicyNames": {
							"shape": "S7g"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListGroups": {
				"input": {
					"type": "structure",
					"members": {
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListGroupsResult",
					"type": "structure",
					"required": [
						"Groups"
					],
					"members": {
						"Groups": {
							"shape": "S7k"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListGroupsForUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListGroupsForUserResult",
					"type": "structure",
					"required": [
						"Groups"
					],
					"members": {
						"Groups": {
							"shape": "S7k"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListInstanceProfiles": {
				"input": {
					"type": "structure",
					"members": {
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListInstanceProfilesResult",
					"type": "structure",
					"required": [
						"InstanceProfiles"
					],
					"members": {
						"InstanceProfiles": {
							"shape": "S4a"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListInstanceProfilesForRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListInstanceProfilesForRoleResult",
					"type": "structure",
					"required": [
						"InstanceProfiles"
					],
					"members": {
						"InstanceProfiles": {
							"shape": "S4a"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListMFADevices": {
				"input": {
					"type": "structure",
					"members": {
						"UserName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListMFADevicesResult",
					"type": "structure",
					"required": [
						"MFADevices"
					],
					"members": {
						"MFADevices": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"UserName",
									"SerialNumber",
									"EnableDate"
								],
								"members": {
									"UserName": {},
									"SerialNumber": {},
									"EnableDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListOpenIDConnectProviders": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "ListOpenIDConnectProvidersResult",
					"type": "structure",
					"members": {
						"OpenIDConnectProviderList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Arn": {}
								}
							}
						}
					}
				}
			},
			"ListPolicies": {
				"input": {
					"type": "structure",
					"members": {
						"Scope": {},
						"OnlyAttached": {
							"type": "boolean"
						},
						"PathPrefix": {},
						"PolicyUsageFilter": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListPoliciesResult",
					"type": "structure",
					"members": {
						"Policies": {
							"type": "list",
							"member": {
								"shape": "S1n"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListPoliciesGrantingServiceAccess": {
				"input": {
					"type": "structure",
					"required": [
						"Arn",
						"ServiceNamespaces"
					],
					"members": {
						"Marker": {},
						"Arn": {},
						"ServiceNamespaces": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "ListPoliciesGrantingServiceAccessResult",
					"type": "structure",
					"required": [
						"PoliciesGrantingServiceAccess"
					],
					"members": {
						"PoliciesGrantingServiceAccess": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ServiceNamespace": {},
									"Policies": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"PolicyName",
												"PolicyType"
											],
											"members": {
												"PolicyName": {},
												"PolicyType": {},
												"PolicyArn": {},
												"EntityType": {},
												"EntityName": {}
											}
										}
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListPolicyVersions": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn"
					],
					"members": {
						"PolicyArn": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListPolicyVersionsResult",
					"type": "structure",
					"members": {
						"Versions": {
							"shape": "S4d"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListRolePolicies": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListRolePoliciesResult",
					"type": "structure",
					"required": [
						"PolicyNames"
					],
					"members": {
						"PolicyNames": {
							"shape": "S7g"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListRoleTags": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListRoleTagsResult",
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S14"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListRoles": {
				"input": {
					"type": "structure",
					"members": {
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListRolesResult",
					"type": "structure",
					"required": [
						"Roles"
					],
					"members": {
						"Roles": {
							"shape": "Sx"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListSAMLProviders": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "ListSAMLProvidersResult",
					"type": "structure",
					"members": {
						"SAMLProviderList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Arn": {},
									"ValidUntil": {
										"type": "timestamp"
									},
									"CreateDate": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"ListSSHPublicKeys": {
				"input": {
					"type": "structure",
					"members": {
						"UserName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListSSHPublicKeysResult",
					"type": "structure",
					"members": {
						"SSHPublicKeys": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"UserName",
									"SSHPublicKeyId",
									"Status",
									"UploadDate"
								],
								"members": {
									"UserName": {},
									"SSHPublicKeyId": {},
									"Status": {},
									"UploadDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListServerCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListServerCertificatesResult",
					"type": "structure",
					"required": [
						"ServerCertificateMetadataList"
					],
					"members": {
						"ServerCertificateMetadataList": {
							"type": "list",
							"member": {
								"shape": "S62"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListServiceSpecificCredentials": {
				"input": {
					"type": "structure",
					"members": {
						"UserName": {},
						"ServiceName": {}
					}
				},
				"output": {
					"resultWrapper": "ListServiceSpecificCredentialsResult",
					"type": "structure",
					"members": {
						"ServiceSpecificCredentials": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"UserName",
									"Status",
									"ServiceUserName",
									"CreateDate",
									"ServiceSpecificCredentialId",
									"ServiceName"
								],
								"members": {
									"UserName": {},
									"Status": {},
									"ServiceUserName": {},
									"CreateDate": {
										"type": "timestamp"
									},
									"ServiceSpecificCredentialId": {},
									"ServiceName": {}
								}
							}
						}
					}
				}
			},
			"ListSigningCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"UserName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListSigningCertificatesResult",
					"type": "structure",
					"required": [
						"Certificates"
					],
					"members": {
						"Certificates": {
							"type": "list",
							"member": {
								"shape": "S92"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListUserPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListUserPoliciesResult",
					"type": "structure",
					"required": [
						"PolicyNames"
					],
					"members": {
						"PolicyNames": {
							"shape": "S7g"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListUserTags": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListUserTagsResult",
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S14"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListUsers": {
				"input": {
					"type": "structure",
					"members": {
						"PathPrefix": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListUsersResult",
					"type": "structure",
					"required": [
						"Users"
					],
					"members": {
						"Users": {
							"shape": "S50"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"ListVirtualMFADevices": {
				"input": {
					"type": "structure",
					"members": {
						"AssignmentStatus": {},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListVirtualMFADevicesResult",
					"type": "structure",
					"required": [
						"VirtualMFADevices"
					],
					"members": {
						"VirtualMFADevices": {
							"type": "list",
							"member": {
								"shape": "S2f"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {}
					}
				}
			},
			"PutGroupPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"PolicyName",
						"PolicyDocument"
					],
					"members": {
						"GroupName": {},
						"PolicyName": {},
						"PolicyDocument": {}
					}
				}
			},
			"PutRolePermissionsBoundary": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"PermissionsBoundary"
					],
					"members": {
						"RoleName": {},
						"PermissionsBoundary": {}
					}
				}
			},
			"PutRolePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"PolicyName",
						"PolicyDocument"
					],
					"members": {
						"RoleName": {},
						"PolicyName": {},
						"PolicyDocument": {}
					}
				}
			},
			"PutUserPermissionsBoundary": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"PermissionsBoundary"
					],
					"members": {
						"UserName": {},
						"PermissionsBoundary": {}
					}
				}
			},
			"PutUserPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"PolicyName",
						"PolicyDocument"
					],
					"members": {
						"UserName": {},
						"PolicyName": {},
						"PolicyDocument": {}
					}
				}
			},
			"RemoveClientIDFromOpenIDConnectProvider": {
				"input": {
					"type": "structure",
					"required": [
						"OpenIDConnectProviderArn",
						"ClientID"
					],
					"members": {
						"OpenIDConnectProviderArn": {},
						"ClientID": {}
					}
				}
			},
			"RemoveRoleFromInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceProfileName",
						"RoleName"
					],
					"members": {
						"InstanceProfileName": {},
						"RoleName": {}
					}
				}
			},
			"RemoveUserFromGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserName"
					],
					"members": {
						"GroupName": {},
						"UserName": {}
					}
				}
			},
			"ResetServiceSpecificCredential": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceSpecificCredentialId"
					],
					"members": {
						"UserName": {},
						"ServiceSpecificCredentialId": {}
					}
				},
				"output": {
					"resultWrapper": "ResetServiceSpecificCredentialResult",
					"type": "structure",
					"members": {
						"ServiceSpecificCredential": {
							"shape": "S25"
						}
					}
				}
			},
			"ResyncMFADevice": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"SerialNumber",
						"AuthenticationCode1",
						"AuthenticationCode2"
					],
					"members": {
						"UserName": {},
						"SerialNumber": {},
						"AuthenticationCode1": {},
						"AuthenticationCode2": {}
					}
				}
			},
			"SetDefaultPolicyVersion": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyArn",
						"VersionId"
					],
					"members": {
						"PolicyArn": {},
						"VersionId": {}
					}
				}
			},
			"SetSecurityTokenServicePreferences": {
				"input": {
					"type": "structure",
					"required": [
						"GlobalEndpointTokenVersion"
					],
					"members": {
						"GlobalEndpointTokenVersion": {}
					}
				}
			},
			"SimulateCustomPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyInputList",
						"ActionNames"
					],
					"members": {
						"PolicyInputList": {
							"shape": "S4q"
						},
						"ActionNames": {
							"shape": "S9s"
						},
						"ResourceArns": {
							"shape": "S9u"
						},
						"ResourcePolicy": {},
						"ResourceOwner": {},
						"CallerArn": {},
						"ContextEntries": {
							"shape": "S9w"
						},
						"ResourceHandlingOption": {},
						"MaxItems": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"shape": "Sa2",
					"resultWrapper": "SimulateCustomPolicyResult"
				}
			},
			"SimulatePrincipalPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicySourceArn",
						"ActionNames"
					],
					"members": {
						"PolicySourceArn": {},
						"PolicyInputList": {
							"shape": "S4q"
						},
						"ActionNames": {
							"shape": "S9s"
						},
						"ResourceArns": {
							"shape": "S9u"
						},
						"ResourcePolicy": {},
						"ResourceOwner": {},
						"CallerArn": {},
						"ContextEntries": {
							"shape": "S9w"
						},
						"ResourceHandlingOption": {},
						"MaxItems": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"shape": "Sa2",
					"resultWrapper": "SimulatePrincipalPolicyResult"
				}
			},
			"TagRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"Tags"
					],
					"members": {
						"RoleName": {},
						"Tags": {
							"shape": "S14"
						}
					}
				}
			},
			"TagUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"Tags"
					],
					"members": {
						"UserName": {},
						"Tags": {
							"shape": "S14"
						}
					}
				}
			},
			"UntagRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"TagKeys"
					],
					"members": {
						"RoleName": {},
						"TagKeys": {
							"shape": "Sam"
						}
					}
				}
			},
			"UntagUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"TagKeys"
					],
					"members": {
						"UserName": {},
						"TagKeys": {
							"shape": "Sam"
						}
					}
				}
			},
			"UpdateAccessKey": {
				"input": {
					"type": "structure",
					"required": [
						"AccessKeyId",
						"Status"
					],
					"members": {
						"UserName": {},
						"AccessKeyId": {},
						"Status": {}
					}
				}
			},
			"UpdateAccountPasswordPolicy": {
				"input": {
					"type": "structure",
					"members": {
						"MinimumPasswordLength": {
							"type": "integer"
						},
						"RequireSymbols": {
							"type": "boolean"
						},
						"RequireNumbers": {
							"type": "boolean"
						},
						"RequireUppercaseCharacters": {
							"type": "boolean"
						},
						"RequireLowercaseCharacters": {
							"type": "boolean"
						},
						"AllowUsersToChangePassword": {
							"type": "boolean"
						},
						"MaxPasswordAge": {
							"type": "integer"
						},
						"PasswordReusePrevention": {
							"type": "integer"
						},
						"HardExpiry": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateAssumeRolePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"PolicyDocument"
					],
					"members": {
						"RoleName": {},
						"PolicyDocument": {}
					}
				}
			},
			"UpdateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {},
						"NewPath": {},
						"NewGroupName": {}
					}
				}
			},
			"UpdateLoginProfile": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {},
						"Password": {
							"shape": "Sf"
						},
						"PasswordResetRequired": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateOpenIDConnectProviderThumbprint": {
				"input": {
					"type": "structure",
					"required": [
						"OpenIDConnectProviderArn",
						"ThumbprintList"
					],
					"members": {
						"OpenIDConnectProviderArn": {},
						"ThumbprintList": {
							"shape": "S1f"
						}
					}
				}
			},
			"UpdateRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName"
					],
					"members": {
						"RoleName": {},
						"Description": {},
						"MaxSessionDuration": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateRoleResult",
					"type": "structure",
					"members": {}
				}
			},
			"UpdateRoleDescription": {
				"input": {
					"type": "structure",
					"required": [
						"RoleName",
						"Description"
					],
					"members": {
						"RoleName": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "UpdateRoleDescriptionResult",
					"type": "structure",
					"members": {
						"Role": {
							"shape": "Sy"
						}
					}
				}
			},
			"UpdateSAMLProvider": {
				"input": {
					"type": "structure",
					"required": [
						"SAMLMetadataDocument",
						"SAMLProviderArn"
					],
					"members": {
						"SAMLMetadataDocument": {},
						"SAMLProviderArn": {}
					}
				},
				"output": {
					"resultWrapper": "UpdateSAMLProviderResult",
					"type": "structure",
					"members": {
						"SAMLProviderArn": {}
					}
				}
			},
			"UpdateSSHPublicKey": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"SSHPublicKeyId",
						"Status"
					],
					"members": {
						"UserName": {},
						"SSHPublicKeyId": {},
						"Status": {}
					}
				}
			},
			"UpdateServerCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"ServerCertificateName"
					],
					"members": {
						"ServerCertificateName": {},
						"NewPath": {},
						"NewServerCertificateName": {}
					}
				}
			},
			"UpdateServiceSpecificCredential": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceSpecificCredentialId",
						"Status"
					],
					"members": {
						"UserName": {},
						"ServiceSpecificCredentialId": {},
						"Status": {}
					}
				}
			},
			"UpdateSigningCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateId",
						"Status"
					],
					"members": {
						"UserName": {},
						"CertificateId": {},
						"Status": {}
					}
				}
			},
			"UpdateUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserName"
					],
					"members": {
						"UserName": {},
						"NewPath": {},
						"NewUserName": {}
					}
				}
			},
			"UploadSSHPublicKey": {
				"input": {
					"type": "structure",
					"required": [
						"UserName",
						"SSHPublicKeyBody"
					],
					"members": {
						"UserName": {},
						"SSHPublicKeyBody": {}
					}
				},
				"output": {
					"resultWrapper": "UploadSSHPublicKeyResult",
					"type": "structure",
					"members": {
						"SSHPublicKey": {
							"shape": "S5w"
						}
					}
				}
			},
			"UploadServerCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"ServerCertificateName",
						"CertificateBody",
						"PrivateKey"
					],
					"members": {
						"Path": {},
						"ServerCertificateName": {},
						"CertificateBody": {},
						"PrivateKey": {
							"type": "string",
							"sensitive": true
						},
						"CertificateChain": {}
					}
				},
				"output": {
					"resultWrapper": "UploadServerCertificateResult",
					"type": "structure",
					"members": {
						"ServerCertificateMetadata": {
							"shape": "S62"
						}
					}
				}
			},
			"UploadSigningCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateBody"
					],
					"members": {
						"UserName": {},
						"CertificateBody": {}
					}
				},
				"output": {
					"resultWrapper": "UploadSigningCertificateResult",
					"type": "structure",
					"required": [
						"Certificate"
					],
					"members": {
						"Certificate": {
							"shape": "S92"
						}
					}
				}
			}
		},
		"shapes": {
			"Sf": {
				"type": "string",
				"sensitive": true
			},
			"Ss": {
				"type": "structure",
				"required": [
					"Path",
					"GroupName",
					"GroupId",
					"Arn",
					"CreateDate"
				],
				"members": {
					"Path": {},
					"GroupName": {},
					"GroupId": {},
					"Arn": {},
					"CreateDate": {
						"type": "timestamp"
					}
				}
			},
			"Sw": {
				"type": "structure",
				"required": [
					"Path",
					"InstanceProfileName",
					"InstanceProfileId",
					"Arn",
					"CreateDate",
					"Roles"
				],
				"members": {
					"Path": {},
					"InstanceProfileName": {},
					"InstanceProfileId": {},
					"Arn": {},
					"CreateDate": {
						"type": "timestamp"
					},
					"Roles": {
						"shape": "Sx"
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"shape": "Sy"
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Path",
					"RoleName",
					"RoleId",
					"Arn",
					"CreateDate"
				],
				"members": {
					"Path": {},
					"RoleName": {},
					"RoleId": {},
					"Arn": {},
					"CreateDate": {
						"type": "timestamp"
					},
					"AssumeRolePolicyDocument": {},
					"Description": {},
					"MaxSessionDuration": {
						"type": "integer"
					},
					"PermissionsBoundary": {
						"shape": "S12"
					},
					"Tags": {
						"shape": "S14"
					}
				}
			},
			"S12": {
				"type": "structure",
				"members": {
					"PermissionsBoundaryType": {},
					"PermissionsBoundaryArn": {}
				}
			},
			"S14": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"required": [
					"UserName",
					"CreateDate"
				],
				"members": {
					"UserName": {},
					"CreateDate": {
						"type": "timestamp"
					},
					"PasswordResetRequired": {
						"type": "boolean"
					}
				}
			},
			"S1e": {
				"type": "list",
				"member": {}
			},
			"S1f": {
				"type": "list",
				"member": {}
			},
			"S1n": {
				"type": "structure",
				"members": {
					"PolicyName": {},
					"PolicyId": {},
					"Arn": {},
					"Path": {},
					"DefaultVersionId": {},
					"AttachmentCount": {
						"type": "integer"
					},
					"PermissionsBoundaryUsageCount": {
						"type": "integer"
					},
					"IsAttachable": {
						"type": "boolean"
					},
					"Description": {},
					"CreateDate": {
						"type": "timestamp"
					},
					"UpdateDate": {
						"type": "timestamp"
					}
				}
			},
			"S1s": {
				"type": "structure",
				"members": {
					"Document": {},
					"VersionId": {},
					"IsDefaultVersion": {
						"type": "boolean"
					},
					"CreateDate": {
						"type": "timestamp"
					}
				}
			},
			"S25": {
				"type": "structure",
				"required": [
					"CreateDate",
					"ServiceName",
					"ServiceUserName",
					"ServicePassword",
					"ServiceSpecificCredentialId",
					"UserName",
					"Status"
				],
				"members": {
					"CreateDate": {
						"type": "timestamp"
					},
					"ServiceName": {},
					"ServiceUserName": {},
					"ServicePassword": {
						"type": "string",
						"sensitive": true
					},
					"ServiceSpecificCredentialId": {},
					"UserName": {},
					"Status": {}
				}
			},
			"S2b": {
				"type": "structure",
				"required": [
					"Path",
					"UserName",
					"UserId",
					"Arn",
					"CreateDate"
				],
				"members": {
					"Path": {},
					"UserName": {},
					"UserId": {},
					"Arn": {},
					"CreateDate": {
						"type": "timestamp"
					},
					"PasswordLastUsed": {
						"type": "timestamp"
					},
					"PermissionsBoundary": {
						"shape": "S12"
					},
					"Tags": {
						"shape": "S14"
					}
				}
			},
			"S2f": {
				"type": "structure",
				"required": [
					"SerialNumber"
				],
				"members": {
					"SerialNumber": {},
					"Base32StringSeed": {
						"shape": "S2h"
					},
					"QRCodePNG": {
						"shape": "S2h"
					},
					"User": {
						"shape": "S2b"
					},
					"EnableDate": {
						"type": "timestamp"
					}
				}
			},
			"S2h": {
				"type": "blob",
				"sensitive": true
			},
			"S41": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PolicyName": {},
						"PolicyDocument": {}
					}
				}
			},
			"S44": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PolicyName": {},
						"PolicyArn": {}
					}
				}
			},
			"S4a": {
				"type": "list",
				"member": {
					"shape": "Sw"
				}
			},
			"S4d": {
				"type": "list",
				"member": {
					"shape": "S1s"
				}
			},
			"S4q": {
				"type": "list",
				"member": {}
			},
			"S4r": {
				"type": "structure",
				"members": {
					"ContextKeyNames": {
						"shape": "S4s"
					}
				}
			},
			"S4s": {
				"type": "list",
				"member": {}
			},
			"S50": {
				"type": "list",
				"member": {
					"shape": "S2b"
				}
			},
			"S5i": {
				"type": "structure",
				"required": [
					"Message",
					"Code"
				],
				"members": {
					"Message": {},
					"Code": {}
				}
			},
			"S5w": {
				"type": "structure",
				"required": [
					"UserName",
					"SSHPublicKeyId",
					"Fingerprint",
					"SSHPublicKeyBody",
					"Status"
				],
				"members": {
					"UserName": {},
					"SSHPublicKeyId": {},
					"Fingerprint": {},
					"SSHPublicKeyBody": {},
					"Status": {},
					"UploadDate": {
						"type": "timestamp"
					}
				}
			},
			"S62": {
				"type": "structure",
				"required": [
					"Path",
					"ServerCertificateName",
					"ServerCertificateId",
					"Arn"
				],
				"members": {
					"Path": {},
					"ServerCertificateName": {},
					"ServerCertificateId": {},
					"Arn": {},
					"UploadDate": {
						"type": "timestamp"
					},
					"Expiration": {
						"type": "timestamp"
					}
				}
			},
			"S7g": {
				"type": "list",
				"member": {}
			},
			"S7k": {
				"type": "list",
				"member": {
					"shape": "Ss"
				}
			},
			"S92": {
				"type": "structure",
				"required": [
					"UserName",
					"CertificateId",
					"CertificateBody",
					"Status"
				],
				"members": {
					"UserName": {},
					"CertificateId": {},
					"CertificateBody": {},
					"Status": {},
					"UploadDate": {
						"type": "timestamp"
					}
				}
			},
			"S9s": {
				"type": "list",
				"member": {}
			},
			"S9u": {
				"type": "list",
				"member": {}
			},
			"S9w": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ContextKeyName": {},
						"ContextKeyValues": {
							"type": "list",
							"member": {}
						},
						"ContextKeyType": {}
					}
				}
			},
			"Sa2": {
				"type": "structure",
				"members": {
					"EvaluationResults": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"EvalActionName",
								"EvalDecision"
							],
							"members": {
								"EvalActionName": {},
								"EvalResourceName": {},
								"EvalDecision": {},
								"MatchedStatements": {
									"shape": "Sa6"
								},
								"MissingContextValues": {
									"shape": "S4s"
								},
								"OrganizationsDecisionDetail": {
									"type": "structure",
									"members": {
										"AllowedByOrganizations": {
											"type": "boolean"
										}
									}
								},
								"EvalDecisionDetails": {
									"shape": "Sae"
								},
								"ResourceSpecificResults": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"EvalResourceName",
											"EvalResourceDecision"
										],
										"members": {
											"EvalResourceName": {},
											"EvalResourceDecision": {},
											"MatchedStatements": {
												"shape": "Sa6"
											},
											"MissingContextValues": {
												"shape": "S4s"
											},
											"EvalDecisionDetails": {
												"shape": "Sae"
											}
										}
									}
								}
							}
						}
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Marker": {}
				}
			},
			"Sa6": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"SourcePolicyId": {},
						"SourcePolicyType": {},
						"StartPosition": {
							"shape": "Saa"
						},
						"EndPosition": {
							"shape": "Saa"
						}
					}
				}
			},
			"Saa": {
				"type": "structure",
				"members": {
					"Line": {
						"type": "integer"
					},
					"Column": {
						"type": "integer"
					}
				}
			},
			"Sae": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sam": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1753 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetAccountAuthorizationDetails": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": [
					"UserDetailList",
					"GroupDetailList",
					"RoleDetailList",
					"Policies"
				]
			},
			"GetGroup": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Users"
			},
			"ListAccessKeys": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "AccessKeyMetadata"
			},
			"ListAccountAliases": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "AccountAliases"
			},
			"ListAttachedGroupPolicies": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "AttachedPolicies"
			},
			"ListAttachedRolePolicies": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "AttachedPolicies"
			},
			"ListAttachedUserPolicies": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "AttachedPolicies"
			},
			"ListEntitiesForPolicy": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": [
					"PolicyGroups",
					"PolicyUsers",
					"PolicyRoles"
				]
			},
			"ListGroupPolicies": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "PolicyNames"
			},
			"ListGroups": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Groups"
			},
			"ListGroupsForUser": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Groups"
			},
			"ListInstanceProfiles": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "InstanceProfiles"
			},
			"ListInstanceProfilesForRole": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "InstanceProfiles"
			},
			"ListMFADevices": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "MFADevices"
			},
			"ListPolicies": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Policies"
			},
			"ListPolicyVersions": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Versions"
			},
			"ListRolePolicies": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "PolicyNames"
			},
			"ListRoles": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Roles"
			},
			"ListSAMLProviders": {
				"result_key": "SAMLProviderList"
			},
			"ListSSHPublicKeys": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "SSHPublicKeys"
			},
			"ListServerCertificates": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "ServerCertificateMetadataList"
			},
			"ListSigningCertificates": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Certificates"
			},
			"ListUserPolicies": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "PolicyNames"
			},
			"ListUsers": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "Users"
			},
			"ListVirtualMFADevices": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "VirtualMFADevices"
			},
			"SimulateCustomPolicy": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "EvaluationResults"
			},
			"SimulatePrincipalPolicy": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "Marker",
				"result_key": "EvaluationResults"
			}
		}
	};

/***/ },
/* 1754 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"InstanceProfileExists": {
				"delay": 1,
				"operation": "GetInstanceProfile",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"state": "retry",
						"matcher": "status",
						"expected": 404
					}
				]
			},
			"UserExists": {
				"delay": 1,
				"operation": "GetUser",
				"maxAttempts": 20,
				"acceptors": [
					{
						"state": "success",
						"matcher": "status",
						"expected": 200
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "NoSuchEntity"
					}
				]
			},
			"RoleExists": {
				"delay": 1,
				"operation": "GetRole",
				"maxAttempts": 20,
				"acceptors": [
					{
						"state": "success",
						"matcher": "status",
						"expected": 200
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "NoSuchEntity"
					}
				]
			},
			"PolicyExists": {
				"delay": 1,
				"operation": "GetPolicy",
				"maxAttempts": 20,
				"acceptors": [
					{
						"state": "success",
						"matcher": "status",
						"expected": 200
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "NoSuchEntity"
					}
				]
			}
		}
	};

/***/ },
/* 1755 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-02-16",
			"endpointPrefix": "inspector",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Inspector",
			"serviceId": "Inspector",
			"signatureVersion": "v4",
			"targetPrefix": "InspectorService",
			"uid": "inspector-2016-02-16"
		},
		"operations": {
			"AddAttributesToFindings": {
				"input": {
					"type": "structure",
					"required": [
						"findingArns",
						"attributes"
					],
					"members": {
						"findingArns": {
							"shape": "S2"
						},
						"attributes": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"failedItems"
					],
					"members": {
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"CreateAssessmentTarget": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetName"
					],
					"members": {
						"assessmentTargetName": {},
						"resourceGroupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTargetArn"
					],
					"members": {
						"assessmentTargetArn": {}
					}
				}
			},
			"CreateAssessmentTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArn",
						"assessmentTemplateName",
						"durationInSeconds",
						"rulesPackageArns"
					],
					"members": {
						"assessmentTargetArn": {},
						"assessmentTemplateName": {},
						"durationInSeconds": {
							"type": "integer"
						},
						"rulesPackageArns": {
							"shape": "Sj"
						},
						"userAttributesForFindings": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn"
					],
					"members": {
						"assessmentTemplateArn": {}
					}
				}
			},
			"CreateExclusionsPreview": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn"
					],
					"members": {
						"assessmentTemplateArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"previewToken"
					],
					"members": {
						"previewToken": {}
					}
				}
			},
			"CreateResourceGroup": {
				"input": {
					"type": "structure",
					"required": [
						"resourceGroupTags"
					],
					"members": {
						"resourceGroupTags": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"resourceGroupArn"
					],
					"members": {
						"resourceGroupArn": {}
					}
				}
			},
			"DeleteAssessmentRun": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {}
					}
				}
			},
			"DeleteAssessmentTarget": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArn"
					],
					"members": {
						"assessmentTargetArn": {}
					}
				}
			},
			"DeleteAssessmentTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn"
					],
					"members": {
						"assessmentTemplateArn": {}
					}
				}
			},
			"DescribeAssessmentRuns": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArns"
					],
					"members": {
						"assessmentRunArns": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRuns",
						"failedItems"
					],
					"members": {
						"assessmentRuns": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"assessmentTemplateArn",
									"state",
									"durationInSeconds",
									"rulesPackageArns",
									"userAttributesForFindings",
									"createdAt",
									"stateChangedAt",
									"dataCollected",
									"stateChanges",
									"notifications",
									"findingCounts"
								],
								"members": {
									"arn": {},
									"name": {},
									"assessmentTemplateArn": {},
									"state": {},
									"durationInSeconds": {
										"type": "integer"
									},
									"rulesPackageArns": {
										"type": "list",
										"member": {}
									},
									"userAttributesForFindings": {
										"shape": "S4"
									},
									"createdAt": {
										"type": "timestamp"
									},
									"startedAt": {
										"type": "timestamp"
									},
									"completedAt": {
										"type": "timestamp"
									},
									"stateChangedAt": {
										"type": "timestamp"
									},
									"dataCollected": {
										"type": "boolean"
									},
									"stateChanges": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"stateChangedAt",
												"state"
											],
											"members": {
												"stateChangedAt": {
													"type": "timestamp"
												},
												"state": {}
											}
										}
									},
									"notifications": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"date",
												"event",
												"error"
											],
											"members": {
												"date": {
													"type": "timestamp"
												},
												"event": {},
												"message": {},
												"error": {
													"type": "boolean"
												},
												"snsTopicArn": {},
												"snsPublishStatusCode": {}
											}
										}
									},
									"findingCounts": {
										"type": "map",
										"key": {},
										"value": {
											"type": "integer"
										}
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeAssessmentTargets": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArns"
					],
					"members": {
						"assessmentTargetArns": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTargets",
						"failedItems"
					],
					"members": {
						"assessmentTargets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"createdAt",
									"updatedAt"
								],
								"members": {
									"arn": {},
									"name": {},
									"resourceGroupArn": {},
									"createdAt": {
										"type": "timestamp"
									},
									"updatedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeAssessmentTemplates": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArns"
					],
					"members": {
						"assessmentTemplateArns": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTemplates",
						"failedItems"
					],
					"members": {
						"assessmentTemplates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"assessmentTargetArn",
									"durationInSeconds",
									"rulesPackageArns",
									"userAttributesForFindings",
									"assessmentRunCount",
									"createdAt"
								],
								"members": {
									"arn": {},
									"name": {},
									"assessmentTargetArn": {},
									"durationInSeconds": {
										"type": "integer"
									},
									"rulesPackageArns": {
										"shape": "Sj"
									},
									"userAttributesForFindings": {
										"shape": "S4"
									},
									"lastAssessmentRunArn": {},
									"assessmentRunCount": {
										"type": "integer"
									},
									"createdAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeCrossAccountAccessRole": {
				"output": {
					"type": "structure",
					"required": [
						"roleArn",
						"valid",
						"registeredAt"
					],
					"members": {
						"roleArn": {},
						"valid": {
							"type": "boolean"
						},
						"registeredAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeExclusions": {
				"input": {
					"type": "structure",
					"required": [
						"exclusionArns"
					],
					"members": {
						"exclusionArns": {
							"type": "list",
							"member": {}
						},
						"locale": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"exclusions",
						"failedItems"
					],
					"members": {
						"exclusions": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"arn",
									"title",
									"description",
									"recommendation",
									"scopes"
								],
								"members": {
									"arn": {},
									"title": {},
									"description": {},
									"recommendation": {},
									"scopes": {
										"shape": "S1x"
									},
									"attributes": {
										"shape": "S21"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeFindings": {
				"input": {
					"type": "structure",
					"required": [
						"findingArns"
					],
					"members": {
						"findingArns": {
							"shape": "Sy"
						},
						"locale": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"findings",
						"failedItems"
					],
					"members": {
						"findings": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"attributes",
									"userAttributes",
									"createdAt",
									"updatedAt"
								],
								"members": {
									"arn": {},
									"schemaVersion": {
										"type": "integer"
									},
									"service": {},
									"serviceAttributes": {
										"type": "structure",
										"required": [
											"schemaVersion"
										],
										"members": {
											"schemaVersion": {
												"type": "integer"
											},
											"assessmentRunArn": {},
											"rulesPackageArn": {}
										}
									},
									"assetType": {},
									"assetAttributes": {
										"type": "structure",
										"required": [
											"schemaVersion"
										],
										"members": {
											"schemaVersion": {
												"type": "integer"
											},
											"agentId": {},
											"autoScalingGroup": {},
											"amiId": {},
											"hostname": {},
											"ipv4Addresses": {
												"type": "list",
												"member": {}
											},
											"tags": {
												"type": "list",
												"member": {
													"shape": "S2i"
												}
											},
											"networkInterfaces": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"networkInterfaceId": {},
														"subnetId": {},
														"vpcId": {},
														"privateDnsName": {},
														"privateIpAddress": {},
														"privateIpAddresses": {
															"type": "list",
															"member": {
																"type": "structure",
																"members": {
																	"privateDnsName": {},
																	"privateIpAddress": {}
																}
															}
														},
														"publicDnsName": {},
														"publicIp": {},
														"ipv6Addresses": {
															"type": "list",
															"member": {}
														},
														"securityGroups": {
															"type": "list",
															"member": {
																"type": "structure",
																"members": {
																	"groupName": {},
																	"groupId": {}
																}
															}
														}
													}
												}
											}
										}
									},
									"id": {},
									"title": {},
									"description": {},
									"recommendation": {},
									"severity": {},
									"numericSeverity": {
										"type": "double"
									},
									"confidence": {
										"type": "integer"
									},
									"indicatorOfCompromise": {
										"type": "boolean"
									},
									"attributes": {
										"shape": "S21"
									},
									"userAttributes": {
										"shape": "S4"
									},
									"createdAt": {
										"type": "timestamp"
									},
									"updatedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeResourceGroups": {
				"input": {
					"type": "structure",
					"required": [
						"resourceGroupArns"
					],
					"members": {
						"resourceGroupArns": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"resourceGroups",
						"failedItems"
					],
					"members": {
						"resourceGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"tags",
									"createdAt"
								],
								"members": {
									"arn": {},
									"tags": {
										"shape": "Sp"
									},
									"createdAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeRulesPackages": {
				"input": {
					"type": "structure",
					"required": [
						"rulesPackageArns"
					],
					"members": {
						"rulesPackageArns": {
							"shape": "Sy"
						},
						"locale": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"rulesPackages",
						"failedItems"
					],
					"members": {
						"rulesPackages": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"version",
									"provider"
								],
								"members": {
									"arn": {},
									"name": {},
									"version": {},
									"provider": {},
									"description": {}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"GetAssessmentReport": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn",
						"reportFileFormat",
						"reportType"
					],
					"members": {
						"assessmentRunArn": {},
						"reportFileFormat": {},
						"reportType": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"status"
					],
					"members": {
						"status": {},
						"url": {}
					}
				}
			},
			"GetExclusionsPreview": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn",
						"previewToken"
					],
					"members": {
						"assessmentTemplateArn": {},
						"previewToken": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"locale": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"previewStatus"
					],
					"members": {
						"previewStatus": {},
						"exclusionPreviews": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"title",
									"description",
									"recommendation",
									"scopes"
								],
								"members": {
									"title": {},
									"description": {},
									"recommendation": {},
									"scopes": {
										"shape": "S1x"
									},
									"attributes": {
										"shape": "S21"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetTelemetryMetadata": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"telemetryMetadata"
					],
					"members": {
						"telemetryMetadata": {
							"shape": "S3j"
						}
					}
				}
			},
			"ListAssessmentRunAgents": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {},
						"filter": {
							"type": "structure",
							"required": [
								"agentHealths",
								"agentHealthCodes"
							],
							"members": {
								"agentHealths": {
									"type": "list",
									"member": {}
								},
								"agentHealthCodes": {
									"type": "list",
									"member": {}
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRunAgents"
					],
					"members": {
						"assessmentRunAgents": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"agentId",
									"assessmentRunArn",
									"agentHealth",
									"agentHealthCode",
									"telemetryMetadata"
								],
								"members": {
									"agentId": {},
									"assessmentRunArn": {},
									"agentHealth": {},
									"agentHealthCode": {},
									"agentHealthDetails": {},
									"autoScalingGroup": {},
									"telemetryMetadata": {
										"shape": "S3j"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAssessmentRuns": {
				"input": {
					"type": "structure",
					"members": {
						"assessmentTemplateArns": {
							"shape": "S3x"
						},
						"filter": {
							"type": "structure",
							"members": {
								"namePattern": {},
								"states": {
									"type": "list",
									"member": {}
								},
								"durationRange": {
									"shape": "S41"
								},
								"rulesPackageArns": {
									"shape": "S42"
								},
								"startTimeRange": {
									"shape": "S43"
								},
								"completionTimeRange": {
									"shape": "S43"
								},
								"stateChangeTimeRange": {
									"shape": "S43"
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRunArns"
					],
					"members": {
						"assessmentRunArns": {
							"shape": "S45"
						},
						"nextToken": {}
					}
				}
			},
			"ListAssessmentTargets": {
				"input": {
					"type": "structure",
					"members": {
						"filter": {
							"type": "structure",
							"members": {
								"assessmentTargetNamePattern": {}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTargetArns"
					],
					"members": {
						"assessmentTargetArns": {
							"shape": "S45"
						},
						"nextToken": {}
					}
				}
			},
			"ListAssessmentTemplates": {
				"input": {
					"type": "structure",
					"members": {
						"assessmentTargetArns": {
							"shape": "S3x"
						},
						"filter": {
							"type": "structure",
							"members": {
								"namePattern": {},
								"durationRange": {
									"shape": "S41"
								},
								"rulesPackageArns": {
									"shape": "S42"
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTemplateArns"
					],
					"members": {
						"assessmentTemplateArns": {
							"shape": "S45"
						},
						"nextToken": {}
					}
				}
			},
			"ListEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"resourceArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"subscriptions"
					],
					"members": {
						"subscriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"resourceArn",
									"topicArn",
									"eventSubscriptions"
								],
								"members": {
									"resourceArn": {},
									"topicArn": {},
									"eventSubscriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"event",
												"subscribedAt"
											],
											"members": {
												"event": {},
												"subscribedAt": {
													"type": "timestamp"
												}
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListExclusions": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"exclusionArns"
					],
					"members": {
						"exclusionArns": {
							"shape": "S45"
						},
						"nextToken": {}
					}
				}
			},
			"ListFindings": {
				"input": {
					"type": "structure",
					"members": {
						"assessmentRunArns": {
							"shape": "S3x"
						},
						"filter": {
							"type": "structure",
							"members": {
								"agentIds": {
									"type": "list",
									"member": {}
								},
								"autoScalingGroups": {
									"type": "list",
									"member": {}
								},
								"ruleNames": {
									"type": "list",
									"member": {}
								},
								"severities": {
									"type": "list",
									"member": {}
								},
								"rulesPackageArns": {
									"shape": "S42"
								},
								"attributes": {
									"shape": "S21"
								},
								"userAttributes": {
									"shape": "S21"
								},
								"creationTimeRange": {
									"shape": "S43"
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"findingArns"
					],
					"members": {
						"findingArns": {
							"shape": "S45"
						},
						"nextToken": {}
					}
				}
			},
			"ListRulesPackages": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"rulesPackageArns"
					],
					"members": {
						"rulesPackageArns": {
							"shape": "S45"
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"tags"
					],
					"members": {
						"tags": {
							"shape": "S4x"
						}
					}
				}
			},
			"PreviewAgents": {
				"input": {
					"type": "structure",
					"required": [
						"previewAgentsArn"
					],
					"members": {
						"previewAgentsArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"agentPreviews"
					],
					"members": {
						"agentPreviews": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"agentId"
								],
								"members": {
									"hostname": {},
									"agentId": {},
									"autoScalingGroup": {},
									"agentHealth": {},
									"agentVersion": {},
									"operatingSystem": {},
									"kernelVersion": {},
									"ipv4Address": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"RegisterCrossAccountAccessRole": {
				"input": {
					"type": "structure",
					"required": [
						"roleArn"
					],
					"members": {
						"roleArn": {}
					}
				}
			},
			"RemoveAttributesFromFindings": {
				"input": {
					"type": "structure",
					"required": [
						"findingArns",
						"attributeKeys"
					],
					"members": {
						"findingArns": {
							"shape": "S2"
						},
						"attributeKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"failedItems"
					],
					"members": {
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"SetTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "S4x"
						}
					}
				}
			},
			"StartAssessmentRun": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn"
					],
					"members": {
						"assessmentTemplateArn": {},
						"assessmentRunName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {}
					}
				}
			},
			"StopAssessmentRun": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {},
						"stopAction": {}
					}
				}
			},
			"SubscribeToEvent": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"event",
						"topicArn"
					],
					"members": {
						"resourceArn": {},
						"event": {},
						"topicArn": {}
					}
				}
			},
			"UnsubscribeFromEvent": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"event",
						"topicArn"
					],
					"members": {
						"resourceArn": {},
						"event": {},
						"topicArn": {}
					}
				}
			},
			"UpdateAssessmentTarget": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArn",
						"assessmentTargetName"
					],
					"members": {
						"assessmentTargetArn": {},
						"assessmentTargetName": {},
						"resourceGroupArn": {}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S4": {
				"type": "list",
				"member": {
					"shape": "S5"
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"key"
				],
				"members": {
					"key": {},
					"value": {}
				}
			},
			"S9": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"failureCode",
						"retryable"
					],
					"members": {
						"failureCode": {},
						"retryable": {
							"type": "boolean"
						}
					}
				}
			},
			"Sj": {
				"type": "list",
				"member": {}
			},
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"Sy": {
				"type": "list",
				"member": {}
			},
			"S1x": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"S21": {
				"type": "list",
				"member": {
					"shape": "S5"
				}
			},
			"S2i": {
				"type": "structure",
				"required": [
					"key"
				],
				"members": {
					"key": {},
					"value": {}
				}
			},
			"S3j": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"messageType",
						"count"
					],
					"members": {
						"messageType": {},
						"count": {
							"type": "long"
						},
						"dataSize": {
							"type": "long"
						}
					}
				}
			},
			"S3x": {
				"type": "list",
				"member": {}
			},
			"S41": {
				"type": "structure",
				"members": {
					"minSeconds": {
						"type": "integer"
					},
					"maxSeconds": {
						"type": "integer"
					}
				}
			},
			"S42": {
				"type": "list",
				"member": {}
			},
			"S43": {
				"type": "structure",
				"members": {
					"beginDate": {
						"type": "timestamp"
					},
					"endDate": {
						"type": "timestamp"
					}
				}
			},
			"S45": {
				"type": "list",
				"member": {}
			},
			"S4x": {
				"type": "list",
				"member": {
					"shape": "S2i"
				}
			}
		}
	};

/***/ },
/* 1756 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetExclusionsPreview": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListAssessmentRunAgents": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListAssessmentRuns": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListAssessmentTargets": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListAssessmentTemplates": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListEventSubscriptions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListExclusions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListFindings": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"ListRulesPackages": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"PreviewAgents": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			}
		}
	};

/***/ },
/* 1757 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-05-28",
			"endpointPrefix": "iot",
			"protocol": "rest-json",
			"serviceFullName": "AWS IoT",
			"serviceId": "IoT",
			"signatureVersion": "v4",
			"signingName": "execute-api",
			"uid": "iot-2015-05-28"
		},
		"operations": {
			"AcceptCertificateTransfer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/accept-certificate-transfer/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						}
					}
				}
			},
			"AddThingToBillingGroup": {
				"http": {
					"method": "PUT",
					"requestUri": "/billing-groups/addThingToBillingGroup"
				},
				"input": {
					"type": "structure",
					"members": {
						"billingGroupName": {},
						"billingGroupArn": {},
						"thingName": {},
						"thingArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AddThingToThingGroup": {
				"http": {
					"method": "PUT",
					"requestUri": "/thing-groups/addThingToThingGroup"
				},
				"input": {
					"type": "structure",
					"members": {
						"thingGroupName": {},
						"thingGroupArn": {},
						"thingName": {},
						"thingArn": {},
						"overrideDynamicGroups": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateTargetsWithJob": {
				"http": {
					"requestUri": "/jobs/{jobId}/targets"
				},
				"input": {
					"type": "structure",
					"required": [
						"targets",
						"jobId"
					],
					"members": {
						"targets": {
							"shape": "Sg"
						},
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"comment": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobArn": {},
						"jobId": {},
						"description": {}
					}
				}
			},
			"AttachPolicy": {
				"http": {
					"method": "PUT",
					"requestUri": "/target-policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"target"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"target": {}
					}
				}
			},
			"AttachPrincipalPolicy": {
				"http": {
					"method": "PUT",
					"requestUri": "/principal-policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"principal"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-iot-principal"
						}
					}
				},
				"deprecated": true
			},
			"AttachSecurityProfile": {
				"http": {
					"method": "PUT",
					"requestUri": "/security-profiles/{securityProfileName}/targets"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileName",
						"securityProfileTargetArn"
					],
					"members": {
						"securityProfileName": {
							"location": "uri",
							"locationName": "securityProfileName"
						},
						"securityProfileTargetArn": {
							"location": "querystring",
							"locationName": "securityProfileTargetArn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AttachThingPrincipal": {
				"http": {
					"method": "PUT",
					"requestUri": "/things/{thingName}/principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName",
						"principal"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-principal"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelAuditMitigationActionsTask": {
				"http": {
					"method": "PUT",
					"requestUri": "/audit/mitigationactions/tasks/{taskId}/cancel"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelAuditTask": {
				"http": {
					"method": "PUT",
					"requestUri": "/audit/tasks/{taskId}/cancel"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelCertificateTransfer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/cancel-certificate-transfer/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						}
					}
				}
			},
			"CancelJob": {
				"http": {
					"method": "PUT",
					"requestUri": "/jobs/{jobId}/cancel"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"reasonCode": {},
						"comment": {},
						"force": {
							"location": "querystring",
							"locationName": "force",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobArn": {},
						"jobId": {},
						"description": {}
					}
				}
			},
			"CancelJobExecution": {
				"http": {
					"method": "PUT",
					"requestUri": "/things/{thingName}/jobs/{jobId}/cancel"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"thingName"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"force": {
							"location": "querystring",
							"locationName": "force",
							"type": "boolean"
						},
						"expectedVersion": {
							"type": "long"
						},
						"statusDetails": {
							"shape": "S1b"
						}
					}
				}
			},
			"ClearDefaultAuthorizer": {
				"http": {
					"method": "DELETE",
					"requestUri": "/default-authorizer"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateAuthorizer": {
				"http": {
					"requestUri": "/authorizer/{authorizerName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"authorizerName",
						"authorizerFunctionArn",
						"tokenKeyName",
						"tokenSigningPublicKeys"
					],
					"members": {
						"authorizerName": {
							"location": "uri",
							"locationName": "authorizerName"
						},
						"authorizerFunctionArn": {},
						"tokenKeyName": {},
						"tokenSigningPublicKeys": {
							"shape": "S1k"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizerName": {},
						"authorizerArn": {}
					}
				}
			},
			"CreateBillingGroup": {
				"http": {
					"requestUri": "/billing-groups/{billingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"billingGroupName"
					],
					"members": {
						"billingGroupName": {
							"location": "uri",
							"locationName": "billingGroupName"
						},
						"billingGroupProperties": {
							"shape": "S1r"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"billingGroupName": {},
						"billingGroupArn": {},
						"billingGroupId": {}
					}
				}
			},
			"CreateCertificateFromCsr": {
				"http": {
					"requestUri": "/certificates"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateSigningRequest"
					],
					"members": {
						"certificateSigningRequest": {},
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {},
						"certificatePem": {}
					}
				}
			},
			"CreateDynamicThingGroup": {
				"http": {
					"requestUri": "/dynamic-thing-groups/{thingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName",
						"queryString"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						},
						"thingGroupProperties": {
							"shape": "S25"
						},
						"indexName": {},
						"queryString": {},
						"queryVersion": {},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingGroupName": {},
						"thingGroupArn": {},
						"thingGroupId": {},
						"indexName": {},
						"queryString": {},
						"queryVersion": {}
					}
				}
			},
			"CreateJob": {
				"http": {
					"method": "PUT",
					"requestUri": "/jobs/{jobId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"targets"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"targets": {
							"shape": "Sg"
						},
						"documentSource": {},
						"document": {},
						"description": {},
						"presignedUrlConfig": {
							"shape": "S2k"
						},
						"targetSelection": {},
						"jobExecutionsRolloutConfig": {
							"shape": "S2o"
						},
						"abortConfig": {
							"shape": "S2v"
						},
						"timeoutConfig": {
							"shape": "S32"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobArn": {},
						"jobId": {},
						"description": {}
					}
				}
			},
			"CreateKeysAndCertificate": {
				"http": {
					"requestUri": "/keys-and-certificate"
				},
				"input": {
					"type": "structure",
					"members": {
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {},
						"certificatePem": {},
						"keyPair": {
							"type": "structure",
							"members": {
								"PublicKey": {},
								"PrivateKey": {
									"type": "string",
									"sensitive": true
								}
							}
						}
					}
				}
			},
			"CreateMitigationAction": {
				"http": {
					"requestUri": "/mitigationactions/actions/{actionName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"actionName",
						"roleArn",
						"actionParams"
					],
					"members": {
						"actionName": {
							"location": "uri",
							"locationName": "actionName"
						},
						"roleArn": {},
						"actionParams": {
							"shape": "S3c"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"actionArn": {},
						"actionId": {}
					}
				}
			},
			"CreateOTAUpdate": {
				"http": {
					"requestUri": "/otaUpdates/{otaUpdateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"otaUpdateId",
						"targets",
						"files",
						"roleArn"
					],
					"members": {
						"otaUpdateId": {
							"location": "uri",
							"locationName": "otaUpdateId"
						},
						"description": {},
						"targets": {
							"shape": "S3v"
						},
						"targetSelection": {},
						"awsJobExecutionsRolloutConfig": {
							"shape": "S3x"
						},
						"files": {
							"shape": "S3z"
						},
						"roleArn": {},
						"additionalParameters": {
							"shape": "S4w"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"otaUpdateId": {},
						"awsIotJobId": {},
						"otaUpdateArn": {},
						"awsIotJobArn": {},
						"otaUpdateStatus": {}
					}
				}
			},
			"CreatePolicy": {
				"http": {
					"requestUri": "/policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyDocument"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyDocument": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyName": {},
						"policyArn": {},
						"policyDocument": {},
						"policyVersionId": {}
					}
				}
			},
			"CreatePolicyVersion": {
				"http": {
					"requestUri": "/policies/{policyName}/version"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyDocument"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyDocument": {},
						"setAsDefault": {
							"location": "querystring",
							"locationName": "setAsDefault",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyArn": {},
						"policyDocument": {},
						"policyVersionId": {},
						"isDefaultVersion": {
							"type": "boolean"
						}
					}
				}
			},
			"CreateRoleAlias": {
				"http": {
					"requestUri": "/role-aliases/{roleAlias}"
				},
				"input": {
					"type": "structure",
					"required": [
						"roleAlias",
						"roleArn"
					],
					"members": {
						"roleAlias": {
							"location": "uri",
							"locationName": "roleAlias"
						},
						"roleArn": {},
						"credentialDurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleAlias": {},
						"roleAliasArn": {}
					}
				}
			},
			"CreateScheduledAudit": {
				"http": {
					"requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"frequency",
						"targetCheckNames",
						"scheduledAuditName"
					],
					"members": {
						"frequency": {},
						"dayOfMonth": {},
						"dayOfWeek": {},
						"targetCheckNames": {
							"shape": "S5k"
						},
						"scheduledAuditName": {
							"location": "uri",
							"locationName": "scheduledAuditName"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"scheduledAuditArn": {}
					}
				}
			},
			"CreateSecurityProfile": {
				"http": {
					"requestUri": "/security-profiles/{securityProfileName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileName"
					],
					"members": {
						"securityProfileName": {
							"location": "uri",
							"locationName": "securityProfileName"
						},
						"securityProfileDescription": {},
						"behaviors": {
							"shape": "S5r"
						},
						"alertTargets": {
							"shape": "S68"
						},
						"additionalMetricsToRetain": {
							"shape": "S6c"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"securityProfileName": {},
						"securityProfileArn": {}
					}
				}
			},
			"CreateStream": {
				"http": {
					"requestUri": "/streams/{streamId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"streamId",
						"files",
						"roleArn"
					],
					"members": {
						"streamId": {
							"location": "uri",
							"locationName": "streamId"
						},
						"description": {},
						"files": {
							"shape": "S6h"
						},
						"roleArn": {},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"streamId": {},
						"streamArn": {},
						"description": {},
						"streamVersion": {
							"type": "integer"
						}
					}
				}
			},
			"CreateThing": {
				"http": {
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"thingTypeName": {},
						"attributePayload": {
							"shape": "S27"
						},
						"billingGroupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingName": {},
						"thingArn": {},
						"thingId": {}
					}
				}
			},
			"CreateThingGroup": {
				"http": {
					"requestUri": "/thing-groups/{thingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						},
						"parentGroupName": {},
						"thingGroupProperties": {
							"shape": "S25"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingGroupName": {},
						"thingGroupArn": {},
						"thingGroupId": {}
					}
				}
			},
			"CreateThingType": {
				"http": {
					"requestUri": "/thing-types/{thingTypeName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						},
						"thingTypeProperties": {
							"shape": "S6t"
						},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingTypeName": {},
						"thingTypeArn": {},
						"thingTypeId": {}
					}
				}
			},
			"CreateTopicRule": {
				"http": {
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName",
						"topicRulePayload"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						},
						"topicRulePayload": {
							"shape": "S71"
						},
						"tags": {
							"location": "header",
							"locationName": "x-amz-tagging"
						}
					},
					"payload": "topicRulePayload"
				}
			},
			"DeleteAccountAuditConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/audit/configuration"
				},
				"input": {
					"type": "structure",
					"members": {
						"deleteScheduledAudits": {
							"location": "querystring",
							"locationName": "deleteScheduledAudits",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteAuthorizer": {
				"http": {
					"method": "DELETE",
					"requestUri": "/authorizer/{authorizerName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"authorizerName"
					],
					"members": {
						"authorizerName": {
							"location": "uri",
							"locationName": "authorizerName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteBillingGroup": {
				"http": {
					"method": "DELETE",
					"requestUri": "/billing-groups/{billingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"billingGroupName"
					],
					"members": {
						"billingGroupName": {
							"location": "uri",
							"locationName": "billingGroupName"
						},
						"expectedVersion": {
							"location": "querystring",
							"locationName": "expectedVersion",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteCACertificate": {
				"http": {
					"method": "DELETE",
					"requestUri": "/cacertificate/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteCertificate": {
				"http": {
					"method": "DELETE",
					"requestUri": "/certificates/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"forceDelete": {
							"location": "querystring",
							"locationName": "forceDelete",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteDynamicThingGroup": {
				"http": {
					"method": "DELETE",
					"requestUri": "/dynamic-thing-groups/{thingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						},
						"expectedVersion": {
							"location": "querystring",
							"locationName": "expectedVersion",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteJob": {
				"http": {
					"method": "DELETE",
					"requestUri": "/jobs/{jobId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"force": {
							"location": "querystring",
							"locationName": "force",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteJobExecution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"thingName",
						"executionNumber"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"executionNumber": {
							"location": "uri",
							"locationName": "executionNumber",
							"type": "long"
						},
						"force": {
							"location": "querystring",
							"locationName": "force",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteMitigationAction": {
				"http": {
					"method": "DELETE",
					"requestUri": "/mitigationactions/actions/{actionName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"actionName"
					],
					"members": {
						"actionName": {
							"location": "uri",
							"locationName": "actionName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteOTAUpdate": {
				"http": {
					"method": "DELETE",
					"requestUri": "/otaUpdates/{otaUpdateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"otaUpdateId"
					],
					"members": {
						"otaUpdateId": {
							"location": "uri",
							"locationName": "otaUpdateId"
						},
						"deleteStream": {
							"location": "querystring",
							"locationName": "deleteStream",
							"type": "boolean"
						},
						"forceDeleteAWSJob": {
							"location": "querystring",
							"locationName": "forceDeleteAWSJob",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						}
					}
				}
			},
			"DeletePolicyVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/policies/{policyName}/version/{policyVersionId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyVersionId"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyVersionId": {
							"location": "uri",
							"locationName": "policyVersionId"
						}
					}
				}
			},
			"DeleteRegistrationCode": {
				"http": {
					"method": "DELETE",
					"requestUri": "/registrationcode"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRoleAlias": {
				"http": {
					"method": "DELETE",
					"requestUri": "/role-aliases/{roleAlias}"
				},
				"input": {
					"type": "structure",
					"required": [
						"roleAlias"
					],
					"members": {
						"roleAlias": {
							"location": "uri",
							"locationName": "roleAlias"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteScheduledAudit": {
				"http": {
					"method": "DELETE",
					"requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"scheduledAuditName"
					],
					"members": {
						"scheduledAuditName": {
							"location": "uri",
							"locationName": "scheduledAuditName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteSecurityProfile": {
				"http": {
					"method": "DELETE",
					"requestUri": "/security-profiles/{securityProfileName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileName"
					],
					"members": {
						"securityProfileName": {
							"location": "uri",
							"locationName": "securityProfileName"
						},
						"expectedVersion": {
							"location": "querystring",
							"locationName": "expectedVersion",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteStream": {
				"http": {
					"method": "DELETE",
					"requestUri": "/streams/{streamId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"streamId"
					],
					"members": {
						"streamId": {
							"location": "uri",
							"locationName": "streamId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteThing": {
				"http": {
					"method": "DELETE",
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"expectedVersion": {
							"location": "querystring",
							"locationName": "expectedVersion",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteThingGroup": {
				"http": {
					"method": "DELETE",
					"requestUri": "/thing-groups/{thingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						},
						"expectedVersion": {
							"location": "querystring",
							"locationName": "expectedVersion",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteThingType": {
				"http": {
					"method": "DELETE",
					"requestUri": "/thing-types/{thingTypeName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTopicRule": {
				"http": {
					"method": "DELETE",
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					}
				}
			},
			"DeleteV2LoggingLevel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v2LoggingLevel"
				},
				"input": {
					"type": "structure",
					"required": [
						"targetType",
						"targetName"
					],
					"members": {
						"targetType": {
							"location": "querystring",
							"locationName": "targetType"
						},
						"targetName": {
							"location": "querystring",
							"locationName": "targetName"
						}
					}
				}
			},
			"DeprecateThingType": {
				"http": {
					"requestUri": "/thing-types/{thingTypeName}/deprecate"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						},
						"undoDeprecate": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeAccountAuditConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/configuration"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleArn": {},
						"auditNotificationTargetConfigurations": {
							"shape": "Sa4"
						},
						"auditCheckConfigurations": {
							"shape": "Sa8"
						}
					}
				}
			},
			"DescribeAuditFinding": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/findings/{findingId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"findingId"
					],
					"members": {
						"findingId": {
							"location": "uri",
							"locationName": "findingId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"finding": {
							"shape": "Sad"
						}
					}
				}
			},
			"DescribeAuditMitigationActionsTask": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/mitigationactions/tasks/{taskId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskStatus": {},
						"startTime": {
							"type": "timestamp"
						},
						"endTime": {
							"type": "timestamp"
						},
						"taskStatistics": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"totalFindingsCount": {
										"type": "long"
									},
									"failedFindingsCount": {
										"type": "long"
									},
									"succeededFindingsCount": {
										"type": "long"
									},
									"skippedFindingsCount": {
										"type": "long"
									},
									"canceledFindingsCount": {
										"type": "long"
									}
								}
							}
						},
						"target": {
							"shape": "Sb2"
						},
						"auditCheckToActionsMapping": {
							"shape": "Sb6"
						},
						"actionsDefinition": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"id": {},
									"roleArn": {},
									"actionParams": {
										"shape": "S3c"
									}
								}
							}
						}
					}
				}
			},
			"DescribeAuditTask": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/tasks/{taskId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskStatus": {},
						"taskType": {},
						"taskStartTime": {
							"type": "timestamp"
						},
						"taskStatistics": {
							"type": "structure",
							"members": {
								"totalChecks": {
									"type": "integer"
								},
								"inProgressChecks": {
									"type": "integer"
								},
								"waitingForDataCollectionChecks": {
									"type": "integer"
								},
								"compliantChecks": {
									"type": "integer"
								},
								"nonCompliantChecks": {
									"type": "integer"
								},
								"failedChecks": {
									"type": "integer"
								},
								"canceledChecks": {
									"type": "integer"
								}
							}
						},
						"scheduledAuditName": {},
						"auditDetails": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"checkRunStatus": {},
									"checkCompliant": {
										"type": "boolean"
									},
									"totalResourcesCount": {
										"type": "long"
									},
									"nonCompliantResourcesCount": {
										"type": "long"
									},
									"errorCode": {},
									"message": {}
								}
							}
						}
					}
				}
			},
			"DescribeAuthorizer": {
				"http": {
					"method": "GET",
					"requestUri": "/authorizer/{authorizerName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"authorizerName"
					],
					"members": {
						"authorizerName": {
							"location": "uri",
							"locationName": "authorizerName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizerDescription": {
							"shape": "Sbw"
						}
					}
				}
			},
			"DescribeBillingGroup": {
				"http": {
					"method": "GET",
					"requestUri": "/billing-groups/{billingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"billingGroupName"
					],
					"members": {
						"billingGroupName": {
							"location": "uri",
							"locationName": "billingGroupName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"billingGroupName": {},
						"billingGroupId": {},
						"billingGroupArn": {},
						"version": {
							"type": "long"
						},
						"billingGroupProperties": {
							"shape": "S1r"
						},
						"billingGroupMetadata": {
							"type": "structure",
							"members": {
								"creationDate": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"DescribeCACertificate": {
				"http": {
					"method": "GET",
					"requestUri": "/cacertificate/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateDescription": {
							"type": "structure",
							"members": {
								"certificateArn": {},
								"certificateId": {},
								"status": {},
								"certificatePem": {},
								"ownedBy": {},
								"creationDate": {
									"type": "timestamp"
								},
								"autoRegistrationStatus": {},
								"lastModifiedDate": {
									"type": "timestamp"
								},
								"customerVersion": {
									"type": "integer"
								},
								"generationId": {},
								"validity": {
									"shape": "Sca"
								}
							}
						},
						"registrationConfig": {
							"shape": "Scb"
						}
					}
				}
			},
			"DescribeCertificate": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateDescription": {
							"type": "structure",
							"members": {
								"certificateArn": {},
								"certificateId": {},
								"caCertificateId": {},
								"status": {},
								"certificatePem": {},
								"ownedBy": {},
								"previousOwnedBy": {},
								"creationDate": {
									"type": "timestamp"
								},
								"lastModifiedDate": {
									"type": "timestamp"
								},
								"customerVersion": {
									"type": "integer"
								},
								"transferData": {
									"type": "structure",
									"members": {
										"transferMessage": {},
										"rejectReason": {},
										"transferDate": {
											"type": "timestamp"
										},
										"acceptDate": {
											"type": "timestamp"
										},
										"rejectDate": {
											"type": "timestamp"
										}
									}
								},
								"generationId": {},
								"validity": {
									"shape": "Sca"
								}
							}
						}
					}
				}
			},
			"DescribeDefaultAuthorizer": {
				"http": {
					"method": "GET",
					"requestUri": "/default-authorizer"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizerDescription": {
							"shape": "Sbw"
						}
					}
				}
			},
			"DescribeEndpoint": {
				"http": {
					"method": "GET",
					"requestUri": "/endpoint"
				},
				"input": {
					"type": "structure",
					"members": {
						"endpointType": {
							"location": "querystring",
							"locationName": "endpointType"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"endpointAddress": {}
					}
				}
			},
			"DescribeEventConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/event-configurations"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"eventConfigurations": {
							"shape": "Scr"
						},
						"creationDate": {
							"type": "timestamp"
						},
						"lastModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeIndex": {
				"http": {
					"method": "GET",
					"requestUri": "/indices/{indexName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"indexName"
					],
					"members": {
						"indexName": {
							"location": "uri",
							"locationName": "indexName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"indexName": {},
						"indexStatus": {},
						"schema": {}
					}
				}
			},
			"DescribeJob": {
				"http": {
					"method": "GET",
					"requestUri": "/jobs/{jobId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"documentSource": {},
						"job": {
							"type": "structure",
							"members": {
								"jobArn": {},
								"jobId": {},
								"targetSelection": {},
								"status": {},
								"forceCanceled": {
									"type": "boolean"
								},
								"reasonCode": {},
								"comment": {},
								"targets": {
									"shape": "Sg"
								},
								"description": {},
								"presignedUrlConfig": {
									"shape": "S2k"
								},
								"jobExecutionsRolloutConfig": {
									"shape": "S2o"
								},
								"abortConfig": {
									"shape": "S2v"
								},
								"createdAt": {
									"type": "timestamp"
								},
								"lastUpdatedAt": {
									"type": "timestamp"
								},
								"completedAt": {
									"type": "timestamp"
								},
								"jobProcessDetails": {
									"type": "structure",
									"members": {
										"processingTargets": {
											"type": "list",
											"member": {}
										},
										"numberOfCanceledThings": {
											"type": "integer"
										},
										"numberOfSucceededThings": {
											"type": "integer"
										},
										"numberOfFailedThings": {
											"type": "integer"
										},
										"numberOfRejectedThings": {
											"type": "integer"
										},
										"numberOfQueuedThings": {
											"type": "integer"
										},
										"numberOfInProgressThings": {
											"type": "integer"
										},
										"numberOfRemovedThings": {
											"type": "integer"
										},
										"numberOfTimedOutThings": {
											"type": "integer"
										}
									}
								},
								"timeoutConfig": {
									"shape": "S32"
								}
							}
						}
					}
				}
			},
			"DescribeJobExecution": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}/jobs/{jobId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"thingName"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"executionNumber": {
							"location": "querystring",
							"locationName": "executionNumber",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"execution": {
							"type": "structure",
							"members": {
								"jobId": {},
								"status": {},
								"forceCanceled": {
									"type": "boolean"
								},
								"statusDetails": {
									"type": "structure",
									"members": {
										"detailsMap": {
											"shape": "S1b"
										}
									}
								},
								"thingArn": {},
								"queuedAt": {
									"type": "timestamp"
								},
								"startedAt": {
									"type": "timestamp"
								},
								"lastUpdatedAt": {
									"type": "timestamp"
								},
								"executionNumber": {
									"type": "long"
								},
								"versionNumber": {
									"type": "long"
								},
								"approximateSecondsBeforeTimedOut": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"DescribeMitigationAction": {
				"http": {
					"method": "GET",
					"requestUri": "/mitigationactions/actions/{actionName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"actionName"
					],
					"members": {
						"actionName": {
							"location": "uri",
							"locationName": "actionName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"actionName": {},
						"actionType": {},
						"actionArn": {},
						"actionId": {},
						"roleArn": {},
						"actionParams": {
							"shape": "S3c"
						},
						"creationDate": {
							"type": "timestamp"
						},
						"lastModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeRoleAlias": {
				"http": {
					"method": "GET",
					"requestUri": "/role-aliases/{roleAlias}"
				},
				"input": {
					"type": "structure",
					"required": [
						"roleAlias"
					],
					"members": {
						"roleAlias": {
							"location": "uri",
							"locationName": "roleAlias"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleAliasDescription": {
							"type": "structure",
							"members": {
								"roleAlias": {},
								"roleAliasArn": {},
								"roleArn": {},
								"owner": {},
								"credentialDurationSeconds": {
									"type": "integer"
								},
								"creationDate": {
									"type": "timestamp"
								},
								"lastModifiedDate": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"DescribeScheduledAudit": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"scheduledAuditName"
					],
					"members": {
						"scheduledAuditName": {
							"location": "uri",
							"locationName": "scheduledAuditName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"frequency": {},
						"dayOfMonth": {},
						"dayOfWeek": {},
						"targetCheckNames": {
							"shape": "S5k"
						},
						"scheduledAuditName": {},
						"scheduledAuditArn": {}
					}
				}
			},
			"DescribeSecurityProfile": {
				"http": {
					"method": "GET",
					"requestUri": "/security-profiles/{securityProfileName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileName"
					],
					"members": {
						"securityProfileName": {
							"location": "uri",
							"locationName": "securityProfileName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"securityProfileName": {},
						"securityProfileArn": {},
						"securityProfileDescription": {},
						"behaviors": {
							"shape": "S5r"
						},
						"alertTargets": {
							"shape": "S68"
						},
						"additionalMetricsToRetain": {
							"shape": "S6c"
						},
						"version": {
							"type": "long"
						},
						"creationDate": {
							"type": "timestamp"
						},
						"lastModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeStream": {
				"http": {
					"method": "GET",
					"requestUri": "/streams/{streamId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"streamId"
					],
					"members": {
						"streamId": {
							"location": "uri",
							"locationName": "streamId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"streamInfo": {
							"type": "structure",
							"members": {
								"streamId": {},
								"streamArn": {},
								"streamVersion": {
									"type": "integer"
								},
								"description": {},
								"files": {
									"shape": "S6h"
								},
								"createdAt": {
									"type": "timestamp"
								},
								"lastUpdatedAt": {
									"type": "timestamp"
								},
								"roleArn": {}
							}
						}
					}
				}
			},
			"DescribeThing": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"defaultClientId": {},
						"thingName": {},
						"thingId": {},
						"thingArn": {},
						"thingTypeName": {},
						"attributes": {
							"shape": "S28"
						},
						"version": {
							"type": "long"
						},
						"billingGroupName": {}
					}
				}
			},
			"DescribeThingGroup": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-groups/{thingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingGroupName": {},
						"thingGroupId": {},
						"thingGroupArn": {},
						"version": {
							"type": "long"
						},
						"thingGroupProperties": {
							"shape": "S25"
						},
						"thingGroupMetadata": {
							"type": "structure",
							"members": {
								"parentGroupName": {},
								"rootToParentThingGroups": {
									"shape": "Se4"
								},
								"creationDate": {
									"type": "timestamp"
								}
							}
						},
						"indexName": {},
						"queryString": {},
						"queryVersion": {},
						"status": {}
					}
				}
			},
			"DescribeThingRegistrationTask": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-registration-tasks/{taskId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskId": {},
						"creationDate": {
							"type": "timestamp"
						},
						"lastModifiedDate": {
							"type": "timestamp"
						},
						"templateBody": {},
						"inputFileBucket": {},
						"inputFileKey": {},
						"roleArn": {},
						"status": {},
						"message": {},
						"successCount": {
							"type": "integer"
						},
						"failureCount": {
							"type": "integer"
						},
						"percentageProgress": {
							"type": "integer"
						}
					}
				}
			},
			"DescribeThingType": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-types/{thingTypeName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingTypeName": {},
						"thingTypeId": {},
						"thingTypeArn": {},
						"thingTypeProperties": {
							"shape": "S6t"
						},
						"thingTypeMetadata": {
							"shape": "Seh"
						}
					}
				}
			},
			"DetachPolicy": {
				"http": {
					"requestUri": "/target-policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"target"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"target": {}
					}
				}
			},
			"DetachPrincipalPolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/principal-policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"principal"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-iot-principal"
						}
					}
				},
				"deprecated": true
			},
			"DetachSecurityProfile": {
				"http": {
					"method": "DELETE",
					"requestUri": "/security-profiles/{securityProfileName}/targets"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileName",
						"securityProfileTargetArn"
					],
					"members": {
						"securityProfileName": {
							"location": "uri",
							"locationName": "securityProfileName"
						},
						"securityProfileTargetArn": {
							"location": "querystring",
							"locationName": "securityProfileTargetArn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DetachThingPrincipal": {
				"http": {
					"method": "DELETE",
					"requestUri": "/things/{thingName}/principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName",
						"principal"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-principal"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisableTopicRule": {
				"http": {
					"requestUri": "/rules/{ruleName}/disable"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					}
				}
			},
			"EnableTopicRule": {
				"http": {
					"requestUri": "/rules/{ruleName}/enable"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					}
				}
			},
			"GetEffectivePolicies": {
				"http": {
					"requestUri": "/effective-policies"
				},
				"input": {
					"type": "structure",
					"members": {
						"principal": {},
						"cognitoIdentityPoolId": {},
						"thingName": {
							"location": "querystring",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"effectivePolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"policyName": {},
									"policyArn": {},
									"policyDocument": {}
								}
							}
						}
					}
				}
			},
			"GetIndexingConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/indexing/config"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingIndexingConfiguration": {
							"shape": "Sey"
						},
						"thingGroupIndexingConfiguration": {
							"shape": "Sf1"
						}
					}
				}
			},
			"GetJobDocument": {
				"http": {
					"method": "GET",
					"requestUri": "/jobs/{jobId}/job-document"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"document": {}
					}
				}
			},
			"GetLoggingOptions": {
				"http": {
					"method": "GET",
					"requestUri": "/loggingOptions"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleArn": {},
						"logLevel": {}
					}
				}
			},
			"GetOTAUpdate": {
				"http": {
					"method": "GET",
					"requestUri": "/otaUpdates/{otaUpdateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"otaUpdateId"
					],
					"members": {
						"otaUpdateId": {
							"location": "uri",
							"locationName": "otaUpdateId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"otaUpdateInfo": {
							"type": "structure",
							"members": {
								"otaUpdateId": {},
								"otaUpdateArn": {},
								"creationDate": {
									"type": "timestamp"
								},
								"lastModifiedDate": {
									"type": "timestamp"
								},
								"description": {},
								"targets": {
									"shape": "S3v"
								},
								"awsJobExecutionsRolloutConfig": {
									"shape": "S3x"
								},
								"targetSelection": {},
								"otaUpdateFiles": {
									"shape": "S3z"
								},
								"otaUpdateStatus": {},
								"awsIotJobId": {},
								"awsIotJobArn": {},
								"errorInfo": {
									"type": "structure",
									"members": {
										"code": {},
										"message": {}
									}
								},
								"additionalParameters": {
									"shape": "S4w"
								}
							}
						}
					}
				}
			},
			"GetPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyName": {},
						"policyArn": {},
						"policyDocument": {},
						"defaultVersionId": {},
						"creationDate": {
							"type": "timestamp"
						},
						"lastModifiedDate": {
							"type": "timestamp"
						},
						"generationId": {}
					}
				}
			},
			"GetPolicyVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/policies/{policyName}/version/{policyVersionId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyVersionId"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyVersionId": {
							"location": "uri",
							"locationName": "policyVersionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyArn": {},
						"policyName": {},
						"policyDocument": {},
						"policyVersionId": {},
						"isDefaultVersion": {
							"type": "boolean"
						},
						"creationDate": {
							"type": "timestamp"
						},
						"lastModifiedDate": {
							"type": "timestamp"
						},
						"generationId": {}
					}
				}
			},
			"GetRegistrationCode": {
				"http": {
					"method": "GET",
					"requestUri": "/registrationcode"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"registrationCode": {}
					}
				}
			},
			"GetStatistics": {
				"http": {
					"requestUri": "/indices/statistics"
				},
				"input": {
					"type": "structure",
					"required": [
						"queryString"
					],
					"members": {
						"indexName": {},
						"queryString": {},
						"aggregationField": {},
						"queryVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"statistics": {
							"type": "structure",
							"members": {
								"count": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"GetTopicRule": {
				"http": {
					"method": "GET",
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ruleArn": {},
						"rule": {
							"type": "structure",
							"members": {
								"ruleName": {},
								"sql": {},
								"description": {},
								"createdAt": {
									"type": "timestamp"
								},
								"actions": {
									"shape": "S74"
								},
								"ruleDisabled": {
									"type": "boolean"
								},
								"awsIotSqlVersion": {},
								"errorAction": {
									"shape": "S75"
								}
							}
						}
					}
				}
			},
			"GetV2LoggingOptions": {
				"http": {
					"method": "GET",
					"requestUri": "/v2LoggingOptions"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleArn": {},
						"defaultLogLevel": {},
						"disableAllLogs": {
							"type": "boolean"
						}
					}
				}
			},
			"ListActiveViolations": {
				"http": {
					"method": "GET",
					"requestUri": "/active-violations"
				},
				"input": {
					"type": "structure",
					"members": {
						"thingName": {
							"location": "querystring",
							"locationName": "thingName"
						},
						"securityProfileName": {
							"location": "querystring",
							"locationName": "securityProfileName"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"activeViolations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"violationId": {},
									"thingName": {},
									"securityProfileName": {},
									"behavior": {
										"shape": "S5s"
									},
									"lastViolationValue": {
										"shape": "S5x"
									},
									"lastViolationTime": {
										"type": "timestamp"
									},
									"violationStartTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAttachedPolicies": {
				"http": {
					"requestUri": "/attached-policies/{target}"
				},
				"input": {
					"type": "structure",
					"required": [
						"target"
					],
					"members": {
						"target": {
							"location": "uri",
							"locationName": "target"
						},
						"recursive": {
							"location": "querystring",
							"locationName": "recursive",
							"type": "boolean"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policies": {
							"shape": "Sg9"
						},
						"nextMarker": {}
					}
				}
			},
			"ListAuditFindings": {
				"http": {
					"requestUri": "/audit/findings"
				},
				"input": {
					"type": "structure",
					"members": {
						"taskId": {},
						"checkName": {},
						"resourceIdentifier": {
							"shape": "Sai"
						},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {},
						"startTime": {
							"type": "timestamp"
						},
						"endTime": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"findings": {
							"type": "list",
							"member": {
								"shape": "Sad"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAuditMitigationActionsExecutions": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/mitigationactions/executions"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId",
						"findingId"
					],
					"members": {
						"taskId": {
							"location": "querystring",
							"locationName": "taskId"
						},
						"actionStatus": {
							"location": "querystring",
							"locationName": "actionStatus"
						},
						"findingId": {
							"location": "querystring",
							"locationName": "findingId"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"actionsExecutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"taskId": {},
									"findingId": {},
									"actionName": {},
									"actionId": {},
									"status": {},
									"startTime": {
										"type": "timestamp"
									},
									"endTime": {
										"type": "timestamp"
									},
									"errorCode": {},
									"message": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAuditMitigationActionsTasks": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/mitigationactions/tasks"
				},
				"input": {
					"type": "structure",
					"required": [
						"startTime",
						"endTime"
					],
					"members": {
						"auditTaskId": {
							"location": "querystring",
							"locationName": "auditTaskId"
						},
						"findingId": {
							"location": "querystring",
							"locationName": "findingId"
						},
						"taskStatus": {
							"location": "querystring",
							"locationName": "taskStatus"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"startTime": {
							"location": "querystring",
							"locationName": "startTime",
							"type": "timestamp"
						},
						"endTime": {
							"location": "querystring",
							"locationName": "endTime",
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"taskId": {},
									"startTime": {
										"type": "timestamp"
									},
									"taskStatus": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAuditTasks": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/tasks"
				},
				"input": {
					"type": "structure",
					"required": [
						"startTime",
						"endTime"
					],
					"members": {
						"startTime": {
							"location": "querystring",
							"locationName": "startTime",
							"type": "timestamp"
						},
						"endTime": {
							"location": "querystring",
							"locationName": "endTime",
							"type": "timestamp"
						},
						"taskType": {
							"location": "querystring",
							"locationName": "taskType"
						},
						"taskStatus": {
							"location": "querystring",
							"locationName": "taskStatus"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"taskId": {},
									"taskStatus": {},
									"taskType": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAuthorizers": {
				"http": {
					"method": "GET",
					"requestUri": "/authorizers/"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						},
						"status": {
							"location": "querystring",
							"locationName": "status"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"authorizerName": {},
									"authorizerArn": {}
								}
							}
						},
						"nextMarker": {}
					}
				}
			},
			"ListBillingGroups": {
				"http": {
					"method": "GET",
					"requestUri": "/billing-groups"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"namePrefixFilter": {
							"location": "querystring",
							"locationName": "namePrefixFilter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"billingGroups": {
							"type": "list",
							"member": {
								"shape": "Se5"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListCACertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/cacertificates"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"certificateArn": {},
									"certificateId": {},
									"status": {},
									"creationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextMarker": {}
					}
				}
			},
			"ListCertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificates": {
							"shape": "Sh6"
						},
						"nextMarker": {}
					}
				}
			},
			"ListCertificatesByCA": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates-by-ca/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"caCertificateId"
					],
					"members": {
						"caCertificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificates": {
							"shape": "Sh6"
						},
						"nextMarker": {}
					}
				}
			},
			"ListIndices": {
				"http": {
					"method": "GET",
					"requestUri": "/indices"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"indexNames": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListJobExecutionsForJob": {
				"http": {
					"method": "GET",
					"requestUri": "/jobs/{jobId}/things"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"status": {
							"location": "querystring",
							"locationName": "status"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"executionSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"thingArn": {},
									"jobExecutionSummary": {
										"shape": "Shj"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListJobExecutionsForThing": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}/jobs"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"status": {
							"location": "querystring",
							"locationName": "status"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"executionSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"jobId": {},
									"jobExecutionSummary": {
										"shape": "Shj"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListJobs": {
				"http": {
					"method": "GET",
					"requestUri": "/jobs"
				},
				"input": {
					"type": "structure",
					"members": {
						"status": {
							"location": "querystring",
							"locationName": "status"
						},
						"targetSelection": {
							"location": "querystring",
							"locationName": "targetSelection"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"thingGroupName": {
							"location": "querystring",
							"locationName": "thingGroupName"
						},
						"thingGroupId": {
							"location": "querystring",
							"locationName": "thingGroupId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"jobArn": {},
									"jobId": {},
									"thingGroupId": {},
									"targetSelection": {},
									"status": {},
									"createdAt": {
										"type": "timestamp"
									},
									"lastUpdatedAt": {
										"type": "timestamp"
									},
									"completedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListMitigationActions": {
				"http": {
					"method": "GET",
					"requestUri": "/mitigationactions/actions"
				},
				"input": {
					"type": "structure",
					"members": {
						"actionType": {
							"location": "querystring",
							"locationName": "actionType"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"actionIdentifiers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"actionName": {},
									"actionArn": {},
									"creationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListOTAUpdates": {
				"http": {
					"method": "GET",
					"requestUri": "/otaUpdates"
				},
				"input": {
					"type": "structure",
					"members": {
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"otaUpdateStatus": {
							"location": "querystring",
							"locationName": "otaUpdateStatus"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"otaUpdates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"otaUpdateId": {},
									"otaUpdateArn": {},
									"creationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListOutgoingCertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates-out-going"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"outgoingCertificates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"certificateArn": {},
									"certificateId": {},
									"transferredTo": {},
									"transferDate": {
										"type": "timestamp"
									},
									"transferMessage": {},
									"creationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextMarker": {}
					}
				}
			},
			"ListPolicies": {
				"http": {
					"method": "GET",
					"requestUri": "/policies"
				},
				"input": {
					"type": "structure",
					"members": {
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policies": {
							"shape": "Sg9"
						},
						"nextMarker": {}
					}
				}
			},
			"ListPolicyPrincipals": {
				"http": {
					"method": "GET",
					"requestUri": "/policy-principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "header",
							"locationName": "x-amzn-iot-policy"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"principals": {
							"shape": "Si8"
						},
						"nextMarker": {}
					}
				},
				"deprecated": true
			},
			"ListPolicyVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/policies/{policyName}/version"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyVersions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"versionId": {},
									"isDefaultVersion": {
										"type": "boolean"
									},
									"createDate": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"ListPrincipalPolicies": {
				"http": {
					"method": "GET",
					"requestUri": "/principal-policies"
				},
				"input": {
					"type": "structure",
					"required": [
						"principal"
					],
					"members": {
						"principal": {
							"location": "header",
							"locationName": "x-amzn-iot-principal"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policies": {
							"shape": "Sg9"
						},
						"nextMarker": {}
					}
				},
				"deprecated": true
			},
			"ListPrincipalThings": {
				"http": {
					"method": "GET",
					"requestUri": "/principals/things"
				},
				"input": {
					"type": "structure",
					"required": [
						"principal"
					],
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-principal"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"things": {
							"shape": "Sii"
						},
						"nextToken": {}
					}
				}
			},
			"ListRoleAliases": {
				"http": {
					"method": "GET",
					"requestUri": "/role-aliases"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleAliases": {
							"type": "list",
							"member": {}
						},
						"nextMarker": {}
					}
				}
			},
			"ListScheduledAudits": {
				"http": {
					"method": "GET",
					"requestUri": "/audit/scheduledaudits"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"scheduledAudits": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"scheduledAuditName": {},
									"scheduledAuditArn": {},
									"frequency": {},
									"dayOfMonth": {},
									"dayOfWeek": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListSecurityProfiles": {
				"http": {
					"method": "GET",
					"requestUri": "/security-profiles"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"securityProfileIdentifiers": {
							"type": "list",
							"member": {
								"shape": "Sit"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListSecurityProfilesForTarget": {
				"http": {
					"method": "GET",
					"requestUri": "/security-profiles-for-target"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileTargetArn"
					],
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"recursive": {
							"location": "querystring",
							"locationName": "recursive",
							"type": "boolean"
						},
						"securityProfileTargetArn": {
							"location": "querystring",
							"locationName": "securityProfileTargetArn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"securityProfileTargetMappings": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"securityProfileIdentifier": {
										"shape": "Sit"
									},
									"target": {
										"shape": "Siy"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListStreams": {
				"http": {
					"method": "GET",
					"requestUri": "/streams"
				},
				"input": {
					"type": "structure",
					"members": {
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"streams": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"streamId": {},
									"streamArn": {},
									"streamVersion": {
										"type": "integer"
									},
									"description": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/tags"
				},
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {
							"location": "querystring",
							"locationName": "resourceArn"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "S1t"
						},
						"nextToken": {}
					}
				}
			},
			"ListTargetsForPolicy": {
				"http": {
					"requestUri": "/policy-targets/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"targets": {
							"type": "list",
							"member": {}
						},
						"nextMarker": {}
					}
				}
			},
			"ListTargetsForSecurityProfile": {
				"http": {
					"method": "GET",
					"requestUri": "/security-profiles/{securityProfileName}/targets"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileName"
					],
					"members": {
						"securityProfileName": {
							"location": "uri",
							"locationName": "securityProfileName"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"securityProfileTargets": {
							"type": "list",
							"member": {
								"shape": "Siy"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListThingGroups": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-groups"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"parentGroup": {
							"location": "querystring",
							"locationName": "parentGroup"
						},
						"namePrefixFilter": {
							"location": "querystring",
							"locationName": "namePrefixFilter"
						},
						"recursive": {
							"location": "querystring",
							"locationName": "recursive",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingGroups": {
							"shape": "Se4"
						},
						"nextToken": {}
					}
				}
			},
			"ListThingGroupsForThing": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}/thing-groups"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingGroups": {
							"shape": "Se4"
						},
						"nextToken": {}
					}
				}
			},
			"ListThingPrincipals": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}/principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"principals": {
							"shape": "Si8"
						}
					}
				}
			},
			"ListThingRegistrationTaskReports": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-registration-tasks/{taskId}/reports"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId",
						"reportType"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						},
						"reportType": {
							"location": "querystring",
							"locationName": "reportType"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"resourceLinks": {
							"type": "list",
							"member": {}
						},
						"reportType": {},
						"nextToken": {}
					}
				}
			},
			"ListThingRegistrationTasks": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-registration-tasks"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"status": {
							"location": "querystring",
							"locationName": "status"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskIds": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListThingTypes": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-types"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"thingTypeName": {
							"location": "querystring",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingTypes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"thingTypeName": {},
									"thingTypeArn": {},
									"thingTypeProperties": {
										"shape": "S6t"
									},
									"thingTypeMetadata": {
										"shape": "Seh"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListThings": {
				"http": {
					"method": "GET",
					"requestUri": "/things"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"attributeName": {
							"location": "querystring",
							"locationName": "attributeName"
						},
						"attributeValue": {
							"location": "querystring",
							"locationName": "attributeValue"
						},
						"thingTypeName": {
							"location": "querystring",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"things": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"thingName": {},
									"thingTypeName": {},
									"thingArn": {},
									"attributes": {
										"shape": "S28"
									},
									"version": {
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListThingsInBillingGroup": {
				"http": {
					"method": "GET",
					"requestUri": "/billing-groups/{billingGroupName}/things"
				},
				"input": {
					"type": "structure",
					"required": [
						"billingGroupName"
					],
					"members": {
						"billingGroupName": {
							"location": "uri",
							"locationName": "billingGroupName"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"things": {
							"shape": "Sii"
						},
						"nextToken": {}
					}
				}
			},
			"ListThingsInThingGroup": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-groups/{thingGroupName}/things"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						},
						"recursive": {
							"location": "querystring",
							"locationName": "recursive",
							"type": "boolean"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"things": {
							"shape": "Sii"
						},
						"nextToken": {}
					}
				}
			},
			"ListTopicRules": {
				"http": {
					"method": "GET",
					"requestUri": "/rules"
				},
				"input": {
					"type": "structure",
					"members": {
						"topic": {
							"location": "querystring",
							"locationName": "topic"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"ruleDisabled": {
							"location": "querystring",
							"locationName": "ruleDisabled",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"rules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ruleArn": {},
									"ruleName": {},
									"topicPattern": {},
									"createdAt": {
										"type": "timestamp"
									},
									"ruleDisabled": {
										"type": "boolean"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListV2LoggingLevels": {
				"http": {
					"method": "GET",
					"requestUri": "/v2LoggingLevel"
				},
				"input": {
					"type": "structure",
					"members": {
						"targetType": {
							"location": "querystring",
							"locationName": "targetType"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"logTargetConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logTarget": {
										"shape": "Ske"
									},
									"logLevel": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListViolationEvents": {
				"http": {
					"method": "GET",
					"requestUri": "/violation-events"
				},
				"input": {
					"type": "structure",
					"required": [
						"startTime",
						"endTime"
					],
					"members": {
						"startTime": {
							"location": "querystring",
							"locationName": "startTime",
							"type": "timestamp"
						},
						"endTime": {
							"location": "querystring",
							"locationName": "endTime",
							"type": "timestamp"
						},
						"thingName": {
							"location": "querystring",
							"locationName": "thingName"
						},
						"securityProfileName": {
							"location": "querystring",
							"locationName": "securityProfileName"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"violationEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"violationId": {},
									"thingName": {},
									"securityProfileName": {},
									"behavior": {
										"shape": "S5s"
									},
									"metricValue": {
										"shape": "S5x"
									},
									"violationEventType": {},
									"violationEventTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"RegisterCACertificate": {
				"http": {
					"requestUri": "/cacertificate"
				},
				"input": {
					"type": "structure",
					"required": [
						"caCertificate",
						"verificationCertificate"
					],
					"members": {
						"caCertificate": {},
						"verificationCertificate": {},
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						},
						"allowAutoRegistration": {
							"location": "querystring",
							"locationName": "allowAutoRegistration",
							"type": "boolean"
						},
						"registrationConfig": {
							"shape": "Scb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {}
					}
				}
			},
			"RegisterCertificate": {
				"http": {
					"requestUri": "/certificate/register"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificatePem"
					],
					"members": {
						"certificatePem": {},
						"caCertificatePem": {},
						"setAsActive": {
							"deprecated": true,
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {}
					}
				}
			},
			"RegisterThing": {
				"http": {
					"requestUri": "/things"
				},
				"input": {
					"type": "structure",
					"required": [
						"templateBody"
					],
					"members": {
						"templateBody": {},
						"parameters": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificatePem": {},
						"resourceArns": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"RejectCertificateTransfer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/reject-certificate-transfer/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"rejectReason": {}
					}
				}
			},
			"RemoveThingFromBillingGroup": {
				"http": {
					"method": "PUT",
					"requestUri": "/billing-groups/removeThingFromBillingGroup"
				},
				"input": {
					"type": "structure",
					"members": {
						"billingGroupName": {},
						"billingGroupArn": {},
						"thingName": {},
						"thingArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RemoveThingFromThingGroup": {
				"http": {
					"method": "PUT",
					"requestUri": "/thing-groups/removeThingFromThingGroup"
				},
				"input": {
					"type": "structure",
					"members": {
						"thingGroupName": {},
						"thingGroupArn": {},
						"thingName": {},
						"thingArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ReplaceTopicRule": {
				"http": {
					"method": "PATCH",
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName",
						"topicRulePayload"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						},
						"topicRulePayload": {
							"shape": "S71"
						}
					},
					"payload": "topicRulePayload"
				}
			},
			"SearchIndex": {
				"http": {
					"requestUri": "/indices/search"
				},
				"input": {
					"type": "structure",
					"required": [
						"queryString"
					],
					"members": {
						"indexName": {},
						"queryString": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"queryVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"things": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"thingName": {},
									"thingId": {},
									"thingTypeName": {},
									"thingGroupNames": {
										"shape": "Sl6"
									},
									"attributes": {
										"shape": "S28"
									},
									"shadow": {},
									"connectivity": {
										"type": "structure",
										"members": {
											"connected": {
												"type": "boolean"
											},
											"timestamp": {
												"type": "long"
											}
										}
									}
								}
							}
						},
						"thingGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"thingGroupName": {},
									"thingGroupId": {},
									"thingGroupDescription": {},
									"attributes": {
										"shape": "S28"
									},
									"parentGroupNames": {
										"shape": "Sl6"
									}
								}
							}
						}
					}
				}
			},
			"SetDefaultAuthorizer": {
				"http": {
					"requestUri": "/default-authorizer"
				},
				"input": {
					"type": "structure",
					"required": [
						"authorizerName"
					],
					"members": {
						"authorizerName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizerName": {},
						"authorizerArn": {}
					}
				}
			},
			"SetDefaultPolicyVersion": {
				"http": {
					"method": "PATCH",
					"requestUri": "/policies/{policyName}/version/{policyVersionId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyVersionId"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyVersionId": {
							"location": "uri",
							"locationName": "policyVersionId"
						}
					}
				}
			},
			"SetLoggingOptions": {
				"http": {
					"requestUri": "/loggingOptions"
				},
				"input": {
					"type": "structure",
					"required": [
						"loggingOptionsPayload"
					],
					"members": {
						"loggingOptionsPayload": {
							"type": "structure",
							"required": [
								"roleArn"
							],
							"members": {
								"roleArn": {},
								"logLevel": {}
							}
						}
					},
					"payload": "loggingOptionsPayload"
				}
			},
			"SetV2LoggingLevel": {
				"http": {
					"requestUri": "/v2LoggingLevel"
				},
				"input": {
					"type": "structure",
					"required": [
						"logTarget",
						"logLevel"
					],
					"members": {
						"logTarget": {
							"shape": "Ske"
						},
						"logLevel": {}
					}
				}
			},
			"SetV2LoggingOptions": {
				"http": {
					"requestUri": "/v2LoggingOptions"
				},
				"input": {
					"type": "structure",
					"members": {
						"roleArn": {},
						"defaultLogLevel": {},
						"disableAllLogs": {
							"type": "boolean"
						}
					}
				}
			},
			"StartAuditMitigationActionsTask": {
				"http": {
					"requestUri": "/audit/mitigationactions/tasks/{taskId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId",
						"target",
						"auditCheckToActionsMapping",
						"clientRequestToken"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						},
						"target": {
							"shape": "Sb2"
						},
						"auditCheckToActionsMapping": {
							"shape": "Sb6"
						},
						"clientRequestToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskId": {}
					}
				}
			},
			"StartOnDemandAuditTask": {
				"http": {
					"requestUri": "/audit/tasks"
				},
				"input": {
					"type": "structure",
					"required": [
						"targetCheckNames"
					],
					"members": {
						"targetCheckNames": {
							"shape": "S5k"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskId": {}
					}
				}
			},
			"StartThingRegistrationTask": {
				"http": {
					"requestUri": "/thing-registration-tasks"
				},
				"input": {
					"type": "structure",
					"required": [
						"templateBody",
						"inputFileBucket",
						"inputFileKey",
						"roleArn"
					],
					"members": {
						"templateBody": {},
						"inputFileBucket": {},
						"inputFileKey": {},
						"roleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskId": {}
					}
				}
			},
			"StopThingRegistrationTask": {
				"http": {
					"method": "PUT",
					"requestUri": "/thing-registration-tasks/{taskId}/cancel"
				},
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {
							"location": "uri",
							"locationName": "taskId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/tags"
				},
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "S1t"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"TestAuthorization": {
				"http": {
					"requestUri": "/test-authorization"
				},
				"input": {
					"type": "structure",
					"required": [
						"authInfos"
					],
					"members": {
						"principal": {},
						"cognitoIdentityPoolId": {},
						"authInfos": {
							"type": "list",
							"member": {
								"shape": "Slw"
							}
						},
						"clientId": {
							"location": "querystring",
							"locationName": "clientId"
						},
						"policyNamesToAdd": {
							"shape": "Sm0"
						},
						"policyNamesToSkip": {
							"shape": "Sm0"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authResults": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"authInfo": {
										"shape": "Slw"
									},
									"allowed": {
										"type": "structure",
										"members": {
											"policies": {
												"shape": "Sg9"
											}
										}
									},
									"denied": {
										"type": "structure",
										"members": {
											"implicitDeny": {
												"type": "structure",
												"members": {
													"policies": {
														"shape": "Sg9"
													}
												}
											},
											"explicitDeny": {
												"type": "structure",
												"members": {
													"policies": {
														"shape": "Sg9"
													}
												}
											}
										}
									},
									"authDecision": {},
									"missingContextValues": {
										"type": "list",
										"member": {}
									}
								}
							}
						}
					}
				}
			},
			"TestInvokeAuthorizer": {
				"http": {
					"requestUri": "/authorizer/{authorizerName}/test"
				},
				"input": {
					"type": "structure",
					"required": [
						"authorizerName",
						"token",
						"tokenSignature"
					],
					"members": {
						"authorizerName": {
							"location": "uri",
							"locationName": "authorizerName"
						},
						"token": {},
						"tokenSignature": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"isAuthenticated": {
							"type": "boolean"
						},
						"principalId": {},
						"policyDocuments": {
							"type": "list",
							"member": {}
						},
						"refreshAfterInSeconds": {
							"type": "integer"
						},
						"disconnectAfterInSeconds": {
							"type": "integer"
						}
					}
				}
			},
			"TransferCertificate": {
				"http": {
					"method": "PATCH",
					"requestUri": "/transfer-certificate/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId",
						"targetAwsAccount"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"targetAwsAccount": {
							"location": "querystring",
							"locationName": "targetAwsAccount"
						},
						"transferMessage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"transferredCertificateArn": {}
					}
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/untag"
				},
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {},
						"tagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateAccountAuditConfiguration": {
				"http": {
					"method": "PATCH",
					"requestUri": "/audit/configuration"
				},
				"input": {
					"type": "structure",
					"members": {
						"roleArn": {},
						"auditNotificationTargetConfigurations": {
							"shape": "Sa4"
						},
						"auditCheckConfigurations": {
							"shape": "Sa8"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateAuthorizer": {
				"http": {
					"method": "PUT",
					"requestUri": "/authorizer/{authorizerName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"authorizerName"
					],
					"members": {
						"authorizerName": {
							"location": "uri",
							"locationName": "authorizerName"
						},
						"authorizerFunctionArn": {},
						"tokenKeyName": {},
						"tokenSigningPublicKeys": {
							"shape": "S1k"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizerName": {},
						"authorizerArn": {}
					}
				}
			},
			"UpdateBillingGroup": {
				"http": {
					"method": "PATCH",
					"requestUri": "/billing-groups/{billingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"billingGroupName",
						"billingGroupProperties"
					],
					"members": {
						"billingGroupName": {
							"location": "uri",
							"locationName": "billingGroupName"
						},
						"billingGroupProperties": {
							"shape": "S1r"
						},
						"expectedVersion": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"version": {
							"type": "long"
						}
					}
				}
			},
			"UpdateCACertificate": {
				"http": {
					"method": "PUT",
					"requestUri": "/cacertificate/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						},
						"newStatus": {
							"location": "querystring",
							"locationName": "newStatus"
						},
						"newAutoRegistrationStatus": {
							"location": "querystring",
							"locationName": "newAutoRegistrationStatus"
						},
						"registrationConfig": {
							"shape": "Scb"
						},
						"removeAutoRegistration": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateCertificate": {
				"http": {
					"method": "PUT",
					"requestUri": "/certificates/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId",
						"newStatus"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"newStatus": {
							"location": "querystring",
							"locationName": "newStatus"
						}
					}
				}
			},
			"UpdateDynamicThingGroup": {
				"http": {
					"method": "PATCH",
					"requestUri": "/dynamic-thing-groups/{thingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName",
						"thingGroupProperties"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						},
						"thingGroupProperties": {
							"shape": "S25"
						},
						"expectedVersion": {
							"type": "long"
						},
						"indexName": {},
						"queryString": {},
						"queryVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"version": {
							"type": "long"
						}
					}
				}
			},
			"UpdateEventConfigurations": {
				"http": {
					"method": "PATCH",
					"requestUri": "/event-configurations"
				},
				"input": {
					"type": "structure",
					"members": {
						"eventConfigurations": {
							"shape": "Scr"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateIndexingConfiguration": {
				"http": {
					"requestUri": "/indexing/config"
				},
				"input": {
					"type": "structure",
					"members": {
						"thingIndexingConfiguration": {
							"shape": "Sey"
						},
						"thingGroupIndexingConfiguration": {
							"shape": "Sf1"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateJob": {
				"http": {
					"method": "PATCH",
					"requestUri": "/jobs/{jobId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {
							"location": "uri",
							"locationName": "jobId"
						},
						"description": {},
						"presignedUrlConfig": {
							"shape": "S2k"
						},
						"jobExecutionsRolloutConfig": {
							"shape": "S2o"
						},
						"abortConfig": {
							"shape": "S2v"
						},
						"timeoutConfig": {
							"shape": "S32"
						}
					}
				}
			},
			"UpdateMitigationAction": {
				"http": {
					"method": "PATCH",
					"requestUri": "/mitigationactions/actions/{actionName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"actionName"
					],
					"members": {
						"actionName": {
							"location": "uri",
							"locationName": "actionName"
						},
						"roleArn": {},
						"actionParams": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"actionArn": {},
						"actionId": {}
					}
				}
			},
			"UpdateRoleAlias": {
				"http": {
					"method": "PUT",
					"requestUri": "/role-aliases/{roleAlias}"
				},
				"input": {
					"type": "structure",
					"required": [
						"roleAlias"
					],
					"members": {
						"roleAlias": {
							"location": "uri",
							"locationName": "roleAlias"
						},
						"roleArn": {},
						"credentialDurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleAlias": {},
						"roleAliasArn": {}
					}
				}
			},
			"UpdateScheduledAudit": {
				"http": {
					"method": "PATCH",
					"requestUri": "/audit/scheduledaudits/{scheduledAuditName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"scheduledAuditName"
					],
					"members": {
						"frequency": {},
						"dayOfMonth": {},
						"dayOfWeek": {},
						"targetCheckNames": {
							"shape": "S5k"
						},
						"scheduledAuditName": {
							"location": "uri",
							"locationName": "scheduledAuditName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"scheduledAuditArn": {}
					}
				}
			},
			"UpdateSecurityProfile": {
				"http": {
					"method": "PATCH",
					"requestUri": "/security-profiles/{securityProfileName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"securityProfileName"
					],
					"members": {
						"securityProfileName": {
							"location": "uri",
							"locationName": "securityProfileName"
						},
						"securityProfileDescription": {},
						"behaviors": {
							"shape": "S5r"
						},
						"alertTargets": {
							"shape": "S68"
						},
						"additionalMetricsToRetain": {
							"shape": "S6c"
						},
						"deleteBehaviors": {
							"type": "boolean"
						},
						"deleteAlertTargets": {
							"type": "boolean"
						},
						"deleteAdditionalMetricsToRetain": {
							"type": "boolean"
						},
						"expectedVersion": {
							"location": "querystring",
							"locationName": "expectedVersion",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"securityProfileName": {},
						"securityProfileArn": {},
						"securityProfileDescription": {},
						"behaviors": {
							"shape": "S5r"
						},
						"alertTargets": {
							"shape": "S68"
						},
						"additionalMetricsToRetain": {
							"shape": "S6c"
						},
						"version": {
							"type": "long"
						},
						"creationDate": {
							"type": "timestamp"
						},
						"lastModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"UpdateStream": {
				"http": {
					"method": "PUT",
					"requestUri": "/streams/{streamId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"streamId"
					],
					"members": {
						"streamId": {
							"location": "uri",
							"locationName": "streamId"
						},
						"description": {},
						"files": {
							"shape": "S6h"
						},
						"roleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"streamId": {},
						"streamArn": {},
						"description": {},
						"streamVersion": {
							"type": "integer"
						}
					}
				}
			},
			"UpdateThing": {
				"http": {
					"method": "PATCH",
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"thingTypeName": {},
						"attributePayload": {
							"shape": "S27"
						},
						"expectedVersion": {
							"type": "long"
						},
						"removeThingType": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateThingGroup": {
				"http": {
					"method": "PATCH",
					"requestUri": "/thing-groups/{thingGroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingGroupName",
						"thingGroupProperties"
					],
					"members": {
						"thingGroupName": {
							"location": "uri",
							"locationName": "thingGroupName"
						},
						"thingGroupProperties": {
							"shape": "S25"
						},
						"expectedVersion": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"version": {
							"type": "long"
						}
					}
				}
			},
			"UpdateThingGroupsForThing": {
				"http": {
					"method": "PUT",
					"requestUri": "/thing-groups/updateThingGroupsForThing"
				},
				"input": {
					"type": "structure",
					"members": {
						"thingName": {},
						"thingGroupsToAdd": {
							"shape": "Snn"
						},
						"thingGroupsToRemove": {
							"shape": "Snn"
						},
						"overrideDynamicGroups": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ValidateSecurityProfileBehaviors": {
				"http": {
					"requestUri": "/security-profile-behaviors/validate"
				},
				"input": {
					"type": "structure",
					"required": [
						"behaviors"
					],
					"members": {
						"behaviors": {
							"shape": "S5r"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"valid": {
							"type": "boolean"
						},
						"validationErrors": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"errorMessage": {}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {
			"Sg": {
				"type": "list",
				"member": {}
			},
			"S1b": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1k": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"billingGroupDescription": {}
				}
			},
			"S1t": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S25": {
				"type": "structure",
				"members": {
					"thingGroupDescription": {},
					"attributePayload": {
						"shape": "S27"
					}
				}
			},
			"S27": {
				"type": "structure",
				"members": {
					"attributes": {
						"shape": "S28"
					},
					"merge": {
						"type": "boolean"
					}
				}
			},
			"S28": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S2k": {
				"type": "structure",
				"members": {
					"roleArn": {},
					"expiresInSec": {
						"type": "long"
					}
				}
			},
			"S2o": {
				"type": "structure",
				"members": {
					"maximumPerMinute": {
						"type": "integer"
					},
					"exponentialRate": {
						"type": "structure",
						"required": [
							"baseRatePerMinute",
							"incrementFactor",
							"rateIncreaseCriteria"
						],
						"members": {
							"baseRatePerMinute": {
								"type": "integer"
							},
							"incrementFactor": {
								"type": "double"
							},
							"rateIncreaseCriteria": {
								"type": "structure",
								"members": {
									"numberOfNotifiedThings": {
										"type": "integer"
									},
									"numberOfSucceededThings": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"S2v": {
				"type": "structure",
				"required": [
					"criteriaList"
				],
				"members": {
					"criteriaList": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"failureType",
								"action",
								"thresholdPercentage",
								"minNumberOfExecutedThings"
							],
							"members": {
								"failureType": {},
								"action": {},
								"thresholdPercentage": {
									"type": "double"
								},
								"minNumberOfExecutedThings": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"S32": {
				"type": "structure",
				"members": {
					"inProgressTimeoutInMinutes": {
						"type": "long"
					}
				}
			},
			"S3c": {
				"type": "structure",
				"members": {
					"updateDeviceCertificateParams": {
						"type": "structure",
						"required": [
							"action"
						],
						"members": {
							"action": {}
						}
					},
					"updateCACertificateParams": {
						"type": "structure",
						"required": [
							"action"
						],
						"members": {
							"action": {}
						}
					},
					"addThingsToThingGroupParams": {
						"type": "structure",
						"required": [
							"thingGroupNames"
						],
						"members": {
							"thingGroupNames": {
								"type": "list",
								"member": {}
							},
							"overrideDynamicGroups": {
								"type": "boolean"
							}
						}
					},
					"replaceDefaultPolicyVersionParams": {
						"type": "structure",
						"required": [
							"templateName"
						],
						"members": {
							"templateName": {}
						}
					},
					"enableIoTLoggingParams": {
						"type": "structure",
						"required": [
							"roleArnForLogging",
							"logLevel"
						],
						"members": {
							"roleArnForLogging": {},
							"logLevel": {}
						}
					},
					"publishFindingToSnsParams": {
						"type": "structure",
						"required": [
							"topicArn"
						],
						"members": {
							"topicArn": {}
						}
					}
				}
			},
			"S3v": {
				"type": "list",
				"member": {}
			},
			"S3x": {
				"type": "structure",
				"members": {
					"maximumPerMinute": {
						"type": "integer"
					}
				}
			},
			"S3z": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"fileName": {},
						"fileVersion": {},
						"fileLocation": {
							"type": "structure",
							"members": {
								"stream": {
									"type": "structure",
									"members": {
										"streamId": {},
										"fileId": {
											"type": "integer"
										}
									}
								},
								"s3Location": {
									"shape": "S47"
								}
							}
						},
						"codeSigning": {
							"type": "structure",
							"members": {
								"awsSignerJobId": {},
								"startSigningJobParameter": {
									"type": "structure",
									"members": {
										"signingProfileParameter": {
											"type": "structure",
											"members": {
												"certificateArn": {},
												"platform": {},
												"certificatePathOnDevice": {}
											}
										},
										"signingProfileName": {},
										"destination": {
											"type": "structure",
											"members": {
												"s3Destination": {
													"type": "structure",
													"members": {
														"bucket": {},
														"prefix": {}
													}
												}
											}
										}
									}
								},
								"customCodeSigning": {
									"type": "structure",
									"members": {
										"signature": {
											"type": "structure",
											"members": {
												"inlineDocument": {
													"type": "blob"
												}
											}
										},
										"certificateChain": {
											"type": "structure",
											"members": {
												"certificateName": {},
												"inlineDocument": {}
											}
										},
										"hashAlgorithm": {},
										"signatureAlgorithm": {}
									}
								}
							}
						},
						"attributes": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"S47": {
				"type": "structure",
				"members": {
					"bucket": {},
					"key": {},
					"version": {}
				}
			},
			"S4w": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S5k": {
				"type": "list",
				"member": {}
			},
			"S5r": {
				"type": "list",
				"member": {
					"shape": "S5s"
				}
			},
			"S5s": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"metric": {},
					"criteria": {
						"type": "structure",
						"members": {
							"comparisonOperator": {},
							"value": {
								"shape": "S5x"
							},
							"durationSeconds": {
								"type": "integer"
							},
							"consecutiveDatapointsToAlarm": {
								"type": "integer"
							},
							"consecutiveDatapointsToClear": {
								"type": "integer"
							},
							"statisticalThreshold": {
								"type": "structure",
								"members": {
									"statistic": {}
								}
							}
						}
					}
				}
			},
			"S5x": {
				"type": "structure",
				"members": {
					"count": {
						"type": "long"
					},
					"cidrs": {
						"type": "list",
						"member": {}
					},
					"ports": {
						"type": "list",
						"member": {
							"type": "integer"
						}
					}
				}
			},
			"S68": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"alertTargetArn",
						"roleArn"
					],
					"members": {
						"alertTargetArn": {},
						"roleArn": {}
					}
				}
			},
			"S6c": {
				"type": "list",
				"member": {}
			},
			"S6h": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"fileId": {
							"type": "integer"
						},
						"s3Location": {
							"shape": "S47"
						}
					}
				}
			},
			"S6t": {
				"type": "structure",
				"members": {
					"thingTypeDescription": {},
					"searchableAttributes": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S71": {
				"type": "structure",
				"required": [
					"sql",
					"actions"
				],
				"members": {
					"sql": {},
					"description": {},
					"actions": {
						"shape": "S74"
					},
					"ruleDisabled": {
						"type": "boolean"
					},
					"awsIotSqlVersion": {},
					"errorAction": {
						"shape": "S75"
					}
				}
			},
			"S74": {
				"type": "list",
				"member": {
					"shape": "S75"
				}
			},
			"S75": {
				"type": "structure",
				"members": {
					"dynamoDB": {
						"type": "structure",
						"required": [
							"tableName",
							"roleArn",
							"hashKeyField",
							"hashKeyValue"
						],
						"members": {
							"tableName": {},
							"roleArn": {},
							"operation": {},
							"hashKeyField": {},
							"hashKeyValue": {},
							"hashKeyType": {},
							"rangeKeyField": {},
							"rangeKeyValue": {},
							"rangeKeyType": {},
							"payloadField": {}
						}
					},
					"dynamoDBv2": {
						"type": "structure",
						"required": [
							"roleArn",
							"putItem"
						],
						"members": {
							"roleArn": {},
							"putItem": {
								"type": "structure",
								"required": [
									"tableName"
								],
								"members": {
									"tableName": {}
								}
							}
						}
					},
					"lambda": {
						"type": "structure",
						"required": [
							"functionArn"
						],
						"members": {
							"functionArn": {}
						}
					},
					"sns": {
						"type": "structure",
						"required": [
							"targetArn",
							"roleArn"
						],
						"members": {
							"targetArn": {},
							"roleArn": {},
							"messageFormat": {}
						}
					},
					"sqs": {
						"type": "structure",
						"required": [
							"roleArn",
							"queueUrl"
						],
						"members": {
							"roleArn": {},
							"queueUrl": {},
							"useBase64": {
								"type": "boolean"
							}
						}
					},
					"kinesis": {
						"type": "structure",
						"required": [
							"roleArn",
							"streamName"
						],
						"members": {
							"roleArn": {},
							"streamName": {},
							"partitionKey": {}
						}
					},
					"republish": {
						"type": "structure",
						"required": [
							"roleArn",
							"topic"
						],
						"members": {
							"roleArn": {},
							"topic": {},
							"qos": {
								"type": "integer"
							}
						}
					},
					"s3": {
						"type": "structure",
						"required": [
							"roleArn",
							"bucketName",
							"key"
						],
						"members": {
							"roleArn": {},
							"bucketName": {},
							"key": {},
							"cannedAcl": {}
						}
					},
					"firehose": {
						"type": "structure",
						"required": [
							"roleArn",
							"deliveryStreamName"
						],
						"members": {
							"roleArn": {},
							"deliveryStreamName": {},
							"separator": {}
						}
					},
					"cloudwatchMetric": {
						"type": "structure",
						"required": [
							"roleArn",
							"metricNamespace",
							"metricName",
							"metricValue",
							"metricUnit"
						],
						"members": {
							"roleArn": {},
							"metricNamespace": {},
							"metricName": {},
							"metricValue": {},
							"metricUnit": {},
							"metricTimestamp": {}
						}
					},
					"cloudwatchAlarm": {
						"type": "structure",
						"required": [
							"roleArn",
							"alarmName",
							"stateReason",
							"stateValue"
						],
						"members": {
							"roleArn": {},
							"alarmName": {},
							"stateReason": {},
							"stateValue": {}
						}
					},
					"elasticsearch": {
						"type": "structure",
						"required": [
							"roleArn",
							"endpoint",
							"index",
							"type",
							"id"
						],
						"members": {
							"roleArn": {},
							"endpoint": {},
							"index": {},
							"type": {},
							"id": {}
						}
					},
					"salesforce": {
						"type": "structure",
						"required": [
							"token",
							"url"
						],
						"members": {
							"token": {},
							"url": {}
						}
					},
					"iotAnalytics": {
						"type": "structure",
						"members": {
							"channelArn": {},
							"channelName": {},
							"roleArn": {}
						}
					},
					"iotEvents": {
						"type": "structure",
						"required": [
							"inputName",
							"roleArn"
						],
						"members": {
							"inputName": {},
							"messageId": {},
							"roleArn": {}
						}
					},
					"stepFunctions": {
						"type": "structure",
						"required": [
							"stateMachineName",
							"roleArn"
						],
						"members": {
							"executionNamePrefix": {},
							"stateMachineName": {},
							"roleArn": {}
						}
					}
				}
			},
			"Sa4": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"targetArn": {},
						"roleArn": {},
						"enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"Sa8": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"Sad": {
				"type": "structure",
				"members": {
					"findingId": {},
					"taskId": {},
					"checkName": {},
					"taskStartTime": {
						"type": "timestamp"
					},
					"findingTime": {
						"type": "timestamp"
					},
					"severity": {},
					"nonCompliantResource": {
						"type": "structure",
						"members": {
							"resourceType": {},
							"resourceIdentifier": {
								"shape": "Sai"
							},
							"additionalInfo": {
								"shape": "San"
							}
						}
					},
					"relatedResources": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"resourceType": {},
								"resourceIdentifier": {
									"shape": "Sai"
								},
								"additionalInfo": {
									"shape": "San"
								}
							}
						}
					},
					"reasonForNonCompliance": {},
					"reasonForNonComplianceCode": {}
				}
			},
			"Sai": {
				"type": "structure",
				"members": {
					"deviceCertificateId": {},
					"caCertificateId": {},
					"cognitoIdentityPoolId": {},
					"clientId": {},
					"policyVersionIdentifier": {
						"type": "structure",
						"members": {
							"policyName": {},
							"policyVersionId": {}
						}
					},
					"account": {}
				}
			},
			"San": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sb2": {
				"type": "structure",
				"members": {
					"auditTaskId": {},
					"findingIds": {
						"type": "list",
						"member": {}
					},
					"auditCheckToReasonCodeFilter": {
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"Sb6": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {}
				}
			},
			"Sbw": {
				"type": "structure",
				"members": {
					"authorizerName": {},
					"authorizerArn": {},
					"authorizerFunctionArn": {},
					"tokenKeyName": {},
					"tokenSigningPublicKeys": {
						"shape": "S1k"
					},
					"status": {},
					"creationDate": {
						"type": "timestamp"
					},
					"lastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"Sca": {
				"type": "structure",
				"members": {
					"notBefore": {
						"type": "timestamp"
					},
					"notAfter": {
						"type": "timestamp"
					}
				}
			},
			"Scb": {
				"type": "structure",
				"members": {
					"templateBody": {},
					"roleArn": {}
				}
			},
			"Scr": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"Se4": {
				"type": "list",
				"member": {
					"shape": "Se5"
				}
			},
			"Se5": {
				"type": "structure",
				"members": {
					"groupName": {},
					"groupArn": {}
				}
			},
			"Seh": {
				"type": "structure",
				"members": {
					"deprecated": {
						"type": "boolean"
					},
					"deprecationDate": {
						"type": "timestamp"
					},
					"creationDate": {
						"type": "timestamp"
					}
				}
			},
			"Sey": {
				"type": "structure",
				"required": [
					"thingIndexingMode"
				],
				"members": {
					"thingIndexingMode": {},
					"thingConnectivityIndexingMode": {}
				}
			},
			"Sf1": {
				"type": "structure",
				"required": [
					"thingGroupIndexingMode"
				],
				"members": {
					"thingGroupIndexingMode": {}
				}
			},
			"Sg9": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"policyName": {},
						"policyArn": {}
					}
				}
			},
			"Sh6": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {},
						"status": {},
						"creationDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"Shj": {
				"type": "structure",
				"members": {
					"status": {},
					"queuedAt": {
						"type": "timestamp"
					},
					"startedAt": {
						"type": "timestamp"
					},
					"lastUpdatedAt": {
						"type": "timestamp"
					},
					"executionNumber": {
						"type": "long"
					}
				}
			},
			"Si8": {
				"type": "list",
				"member": {}
			},
			"Sii": {
				"type": "list",
				"member": {}
			},
			"Sit": {
				"type": "structure",
				"required": [
					"name",
					"arn"
				],
				"members": {
					"name": {},
					"arn": {}
				}
			},
			"Siy": {
				"type": "structure",
				"required": [
					"arn"
				],
				"members": {
					"arn": {}
				}
			},
			"Ske": {
				"type": "structure",
				"required": [
					"targetType"
				],
				"members": {
					"targetType": {},
					"targetName": {}
				}
			},
			"Sl6": {
				"type": "list",
				"member": {}
			},
			"Slw": {
				"type": "structure",
				"members": {
					"actionType": {},
					"resources": {
						"type": "list",
						"member": {}
					}
				}
			},
			"Sm0": {
				"type": "list",
				"member": {}
			},
			"Snn": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1758 */
1641,
/* 1759 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "iot-data-2015-05-28",
			"apiVersion": "2015-05-28",
			"endpointPrefix": "data.iot",
			"protocol": "rest-json",
			"serviceFullName": "AWS IoT Data Plane",
			"serviceId": "IoT Data Plane",
			"signatureVersion": "v4",
			"signingName": "iotdata"
		},
		"operations": {
			"DeleteThingShadow": {
				"http": {
					"method": "DELETE",
					"requestUri": "/things/{thingName}/shadow"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"payload"
					],
					"members": {
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			},
			"GetThingShadow": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}/shadow"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			},
			"Publish": {
				"http": {
					"requestUri": "/topics/{topic}"
				},
				"input": {
					"type": "structure",
					"required": [
						"topic"
					],
					"members": {
						"topic": {
							"location": "uri",
							"locationName": "topic"
						},
						"qos": {
							"location": "querystring",
							"locationName": "qos",
							"type": "integer"
						},
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			},
			"UpdateThingShadow": {
				"http": {
					"requestUri": "/things/{thingName}/shadow"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName",
						"payload"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				},
				"output": {
					"type": "structure",
					"members": {
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 1760 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-12-02",
			"endpointPrefix": "kinesis",
			"jsonVersion": "1.1",
			"protocol": "json",
			"protocolSettings": {
				"h2": "eventstream"
			},
			"serviceAbbreviation": "Kinesis",
			"serviceFullName": "Amazon Kinesis",
			"serviceId": "Kinesis",
			"signatureVersion": "v4",
			"targetPrefix": "Kinesis_20131202",
			"uid": "kinesis-2013-12-02"
		},
		"operations": {
			"AddTagsToStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"Tags"
					],
					"members": {
						"StreamName": {},
						"Tags": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"CreateStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardCount"
					],
					"members": {
						"StreamName": {},
						"ShardCount": {
							"type": "integer"
						}
					}
				}
			},
			"DecreaseStreamRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"RetentionPeriodHours"
					],
					"members": {
						"StreamName": {},
						"RetentionPeriodHours": {
							"type": "integer"
						}
					}
				}
			},
			"DeleteStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"EnforceConsumerDeletion": {
							"type": "boolean"
						}
					}
				}
			},
			"DeregisterStreamConsumer": {
				"input": {
					"type": "structure",
					"members": {
						"StreamARN": {},
						"ConsumerName": {},
						"ConsumerARN": {}
					}
				}
			},
			"DescribeLimits": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"ShardLimit",
						"OpenShardCount"
					],
					"members": {
						"ShardLimit": {
							"type": "integer"
						},
						"OpenShardCount": {
							"type": "integer"
						}
					}
				}
			},
			"DescribeStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartShardId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamDescription"
					],
					"members": {
						"StreamDescription": {
							"type": "structure",
							"required": [
								"StreamName",
								"StreamARN",
								"StreamStatus",
								"Shards",
								"HasMoreShards",
								"RetentionPeriodHours",
								"StreamCreationTimestamp",
								"EnhancedMonitoring"
							],
							"members": {
								"StreamName": {},
								"StreamARN": {},
								"StreamStatus": {},
								"Shards": {
									"shape": "Sp"
								},
								"HasMoreShards": {
									"type": "boolean"
								},
								"RetentionPeriodHours": {
									"type": "integer"
								},
								"StreamCreationTimestamp": {
									"type": "timestamp"
								},
								"EnhancedMonitoring": {
									"shape": "Sw"
								},
								"EncryptionType": {},
								"KeyId": {}
							}
						}
					}
				}
			},
			"DescribeStreamConsumer": {
				"input": {
					"type": "structure",
					"members": {
						"StreamARN": {},
						"ConsumerName": {},
						"ConsumerARN": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ConsumerDescription"
					],
					"members": {
						"ConsumerDescription": {
							"type": "structure",
							"required": [
								"ConsumerName",
								"ConsumerARN",
								"ConsumerStatus",
								"ConsumerCreationTimestamp",
								"StreamARN"
							],
							"members": {
								"ConsumerName": {},
								"ConsumerARN": {},
								"ConsumerStatus": {},
								"ConsumerCreationTimestamp": {
									"type": "timestamp"
								},
								"StreamARN": {}
							}
						}
					}
				}
			},
			"DescribeStreamSummary": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamDescriptionSummary"
					],
					"members": {
						"StreamDescriptionSummary": {
							"type": "structure",
							"required": [
								"StreamName",
								"StreamARN",
								"StreamStatus",
								"RetentionPeriodHours",
								"StreamCreationTimestamp",
								"EnhancedMonitoring",
								"OpenShardCount"
							],
							"members": {
								"StreamName": {},
								"StreamARN": {},
								"StreamStatus": {},
								"RetentionPeriodHours": {
									"type": "integer"
								},
								"StreamCreationTimestamp": {
									"type": "timestamp"
								},
								"EnhancedMonitoring": {
									"shape": "Sw"
								},
								"EncryptionType": {},
								"KeyId": {},
								"OpenShardCount": {
									"type": "integer"
								},
								"ConsumerCount": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"DisableEnhancedMonitoring": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardLevelMetrics"
					],
					"members": {
						"StreamName": {},
						"ShardLevelMetrics": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"shape": "S1b"
				}
			},
			"EnableEnhancedMonitoring": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardLevelMetrics"
					],
					"members": {
						"StreamName": {},
						"ShardLevelMetrics": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"shape": "S1b"
				}
			},
			"GetRecords": {
				"input": {
					"type": "structure",
					"required": [
						"ShardIterator"
					],
					"members": {
						"ShardIterator": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Records"
					],
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"SequenceNumber",
									"Data",
									"PartitionKey"
								],
								"members": {
									"SequenceNumber": {},
									"ApproximateArrivalTimestamp": {
										"type": "timestamp"
									},
									"Data": {
										"type": "blob"
									},
									"PartitionKey": {},
									"EncryptionType": {}
								}
							}
						},
						"NextShardIterator": {},
						"MillisBehindLatest": {
							"type": "long"
						}
					}
				}
			},
			"GetShardIterator": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardId",
						"ShardIteratorType"
					],
					"members": {
						"StreamName": {},
						"ShardId": {},
						"ShardIteratorType": {},
						"StartingSequenceNumber": {},
						"Timestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ShardIterator": {}
					}
				}
			},
			"IncreaseStreamRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"RetentionPeriodHours"
					],
					"members": {
						"StreamName": {},
						"RetentionPeriodHours": {
							"type": "integer"
						}
					}
				}
			},
			"ListShards": {
				"input": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"NextToken": {},
						"ExclusiveStartShardId": {},
						"MaxResults": {
							"type": "integer"
						},
						"StreamCreationTimestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Shards": {
							"shape": "Sp"
						},
						"NextToken": {}
					}
				}
			},
			"ListStreamConsumers": {
				"input": {
					"type": "structure",
					"required": [
						"StreamARN"
					],
					"members": {
						"StreamARN": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"StreamCreationTimestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Consumers": {
							"type": "list",
							"member": {
								"shape": "S1y"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStreams": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamNames",
						"HasMoreStreams"
					],
					"members": {
						"StreamNames": {
							"type": "list",
							"member": {}
						},
						"HasMoreStreams": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"ExclusiveStartTagKey": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags",
						"HasMoreTags"
					],
					"members": {
						"Tags": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key"
								],
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"HasMoreTags": {
							"type": "boolean"
						}
					}
				}
			},
			"MergeShards": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardToMerge",
						"AdjacentShardToMerge"
					],
					"members": {
						"StreamName": {},
						"ShardToMerge": {},
						"AdjacentShardToMerge": {}
					}
				}
			},
			"PutRecord": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"Data",
						"PartitionKey"
					],
					"members": {
						"StreamName": {},
						"Data": {
							"type": "blob"
						},
						"PartitionKey": {},
						"ExplicitHashKey": {},
						"SequenceNumberForOrdering": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ShardId",
						"SequenceNumber"
					],
					"members": {
						"ShardId": {},
						"SequenceNumber": {},
						"EncryptionType": {}
					}
				}
			},
			"PutRecords": {
				"input": {
					"type": "structure",
					"required": [
						"Records",
						"StreamName"
					],
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Data",
									"PartitionKey"
								],
								"members": {
									"Data": {
										"type": "blob"
									},
									"ExplicitHashKey": {},
									"PartitionKey": {}
								}
							}
						},
						"StreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Records"
					],
					"members": {
						"FailedRecordCount": {
							"type": "integer"
						},
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SequenceNumber": {},
									"ShardId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						},
						"EncryptionType": {}
					}
				}
			},
			"RegisterStreamConsumer": {
				"input": {
					"type": "structure",
					"required": [
						"StreamARN",
						"ConsumerName"
					],
					"members": {
						"StreamARN": {},
						"ConsumerName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Consumer"
					],
					"members": {
						"Consumer": {
							"shape": "S1y"
						}
					}
				}
			},
			"RemoveTagsFromStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"TagKeys"
					],
					"members": {
						"StreamName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"SplitShard": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardToSplit",
						"NewStartingHashKey"
					],
					"members": {
						"StreamName": {},
						"ShardToSplit": {},
						"NewStartingHashKey": {}
					}
				}
			},
			"StartStreamEncryption": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"EncryptionType",
						"KeyId"
					],
					"members": {
						"StreamName": {},
						"EncryptionType": {},
						"KeyId": {}
					}
				}
			},
			"StopStreamEncryption": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"EncryptionType",
						"KeyId"
					],
					"members": {
						"StreamName": {},
						"EncryptionType": {},
						"KeyId": {}
					}
				}
			},
			"UpdateShardCount": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"TargetShardCount",
						"ScalingType"
					],
					"members": {
						"StreamName": {},
						"TargetShardCount": {
							"type": "integer"
						},
						"ScalingType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"CurrentShardCount": {
							"type": "integer"
						},
						"TargetShardCount": {
							"type": "integer"
						}
					}
				}
			}
		},
		"shapes": {
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ShardId",
						"HashKeyRange",
						"SequenceNumberRange"
					],
					"members": {
						"ShardId": {},
						"ParentShardId": {},
						"AdjacentParentShardId": {},
						"HashKeyRange": {
							"type": "structure",
							"required": [
								"StartingHashKey",
								"EndingHashKey"
							],
							"members": {
								"StartingHashKey": {},
								"EndingHashKey": {}
							}
						},
						"SequenceNumberRange": {
							"type": "structure",
							"required": [
								"StartingSequenceNumber"
							],
							"members": {
								"StartingSequenceNumber": {},
								"EndingSequenceNumber": {}
							}
						}
					}
				}
			},
			"Sw": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ShardLevelMetrics": {
							"shape": "Sy"
						}
					}
				}
			},
			"Sy": {
				"type": "list",
				"member": {}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"StreamName": {},
					"CurrentShardLevelMetrics": {
						"shape": "Sy"
					},
					"DesiredShardLevelMetrics": {
						"shape": "Sy"
					}
				}
			},
			"S1y": {
				"type": "structure",
				"required": [
					"ConsumerName",
					"ConsumerARN",
					"ConsumerStatus",
					"ConsumerCreationTimestamp"
				],
				"members": {
					"ConsumerName": {},
					"ConsumerARN": {},
					"ConsumerStatus": {},
					"ConsumerCreationTimestamp": {
						"type": "timestamp"
					}
				}
			}
		}
	};

/***/ },
/* 1761 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeStream": {
				"input_token": "ExclusiveStartShardId",
				"limit_key": "Limit",
				"more_results": "StreamDescription.HasMoreShards",
				"output_token": "StreamDescription.Shards[-1].ShardId",
				"result_key": "StreamDescription.Shards"
			},
			"ListStreamConsumers": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"ListStreams": {
				"input_token": "ExclusiveStartStreamName",
				"limit_key": "Limit",
				"more_results": "HasMoreStreams",
				"output_token": "StreamNames[-1]",
				"result_key": "StreamNames"
			}
		}
	};

/***/ },
/* 1762 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"StreamExists": {
				"delay": 10,
				"operation": "DescribeStream",
				"maxAttempts": 18,
				"acceptors": [
					{
						"expected": "ACTIVE",
						"matcher": "path",
						"state": "success",
						"argument": "StreamDescription.StreamStatus"
					}
				]
			},
			"StreamNotExists": {
				"delay": 10,
				"operation": "DescribeStream",
				"maxAttempts": 18,
				"acceptors": [
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 1763 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-09-30",
			"endpointPrefix": "kinesisvideo",
			"protocol": "rest-json",
			"serviceAbbreviation": "Kinesis Video Archived Media",
			"serviceFullName": "Amazon Kinesis Video Streams Archived Media",
			"serviceId": "Kinesis Video Archived Media",
			"signatureVersion": "v4",
			"uid": "kinesis-video-archived-media-2017-09-30"
		},
		"operations": {
			"GetDASHStreamingSessionURL": {
				"http": {
					"requestUri": "/getDASHStreamingSessionURL"
				},
				"input": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"StreamARN": {},
						"PlaybackMode": {},
						"DisplayFragmentTimestamp": {},
						"DisplayFragmentNumber": {},
						"DASHFragmentSelector": {
							"type": "structure",
							"members": {
								"FragmentSelectorType": {},
								"TimestampRange": {
									"type": "structure",
									"members": {
										"StartTimestamp": {
											"type": "timestamp"
										},
										"EndTimestamp": {
											"type": "timestamp"
										}
									}
								}
							}
						},
						"Expires": {
							"type": "integer"
						},
						"MaxManifestFragmentResults": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DASHStreamingSessionURL": {}
					}
				}
			},
			"GetHLSStreamingSessionURL": {
				"http": {
					"requestUri": "/getHLSStreamingSessionURL"
				},
				"input": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"StreamARN": {},
						"PlaybackMode": {},
						"HLSFragmentSelector": {
							"type": "structure",
							"members": {
								"FragmentSelectorType": {},
								"TimestampRange": {
									"type": "structure",
									"members": {
										"StartTimestamp": {
											"type": "timestamp"
										},
										"EndTimestamp": {
											"type": "timestamp"
										}
									}
								}
							}
						},
						"ContainerFormat": {},
						"DiscontinuityMode": {},
						"DisplayFragmentTimestamp": {},
						"Expires": {
							"type": "integer"
						},
						"MaxMediaPlaylistFragmentResults": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HLSStreamingSessionURL": {}
					}
				}
			},
			"GetMediaForFragmentList": {
				"http": {
					"requestUri": "/getMediaForFragmentList"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"Fragments"
					],
					"members": {
						"StreamName": {},
						"Fragments": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Payload": {
							"type": "blob",
							"streaming": true
						}
					},
					"payload": "Payload"
				}
			},
			"ListFragments": {
				"http": {
					"requestUri": "/listFragments"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"MaxResults": {
							"type": "long"
						},
						"NextToken": {},
						"FragmentSelector": {
							"type": "structure",
							"required": [
								"FragmentSelectorType",
								"TimestampRange"
							],
							"members": {
								"FragmentSelectorType": {},
								"TimestampRange": {
									"type": "structure",
									"required": [
										"StartTimestamp",
										"EndTimestamp"
									],
									"members": {
										"StartTimestamp": {
											"type": "timestamp"
										},
										"EndTimestamp": {
											"type": "timestamp"
										}
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Fragments": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FragmentNumber": {},
									"FragmentSizeInBytes": {
										"type": "long"
									},
									"ProducerTimestamp": {
										"type": "timestamp"
									},
									"ServerTimestamp": {
										"type": "timestamp"
									},
									"FragmentLengthInMilliseconds": {
										"type": "long"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 1764 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListFragments": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Fragments"
			}
		}
	};

/***/ },
/* 1765 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-09-30",
			"endpointPrefix": "kinesisvideo",
			"protocol": "rest-json",
			"serviceAbbreviation": "Kinesis Video Media",
			"serviceFullName": "Amazon Kinesis Video Streams Media",
			"serviceId": "Kinesis Video Media",
			"signatureVersion": "v4",
			"uid": "kinesis-video-media-2017-09-30"
		},
		"operations": {
			"GetMedia": {
				"http": {
					"requestUri": "/getMedia"
				},
				"input": {
					"type": "structure",
					"required": [
						"StartSelector"
					],
					"members": {
						"StreamName": {},
						"StreamARN": {},
						"StartSelector": {
							"type": "structure",
							"required": [
								"StartSelectorType"
							],
							"members": {
								"StartSelectorType": {},
								"AfterFragmentNumber": {},
								"StartTimestamp": {
									"type": "timestamp"
								},
								"ContinuationToken": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Payload": {
							"type": "blob",
							"streaming": true
						}
					},
					"payload": "Payload"
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 1766 */
1641,
/* 1767 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-09-30",
			"endpointPrefix": "kinesisvideo",
			"protocol": "rest-json",
			"serviceAbbreviation": "Kinesis Video",
			"serviceFullName": "Amazon Kinesis Video Streams",
			"serviceId": "Kinesis Video",
			"signatureVersion": "v4",
			"uid": "kinesisvideo-2017-09-30"
		},
		"operations": {
			"CreateStream": {
				"http": {
					"requestUri": "/createStream"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"DeviceName": {},
						"StreamName": {},
						"MediaType": {},
						"KmsKeyId": {},
						"DataRetentionInHours": {
							"type": "integer"
						},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamARN": {}
					}
				}
			},
			"DeleteStream": {
				"http": {
					"requestUri": "/deleteStream"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamARN"
					],
					"members": {
						"StreamARN": {},
						"CurrentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeStream": {
				"http": {
					"requestUri": "/describeStream"
				},
				"input": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"StreamARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamInfo": {
							"shape": "Sh"
						}
					}
				}
			},
			"GetDataEndpoint": {
				"http": {
					"requestUri": "/getDataEndpoint"
				},
				"input": {
					"type": "structure",
					"required": [
						"APIName"
					],
					"members": {
						"StreamName": {},
						"StreamARN": {},
						"APIName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataEndpoint": {}
					}
				}
			},
			"ListStreams": {
				"http": {
					"requestUri": "/listStreams"
				},
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"StreamNameCondition": {
							"type": "structure",
							"members": {
								"ComparisonOperator": {},
								"ComparisonValue": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamInfoList": {
							"type": "list",
							"member": {
								"shape": "Sh"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForStream": {
				"http": {
					"requestUri": "/listTagsForStream"
				},
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"StreamARN": {},
						"StreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"Tags": {
							"shape": "S7"
						}
					}
				}
			},
			"TagStream": {
				"http": {
					"requestUri": "/tagStream"
				},
				"input": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"StreamARN": {},
						"StreamName": {},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagStream": {
				"http": {
					"requestUri": "/untagStream"
				},
				"input": {
					"type": "structure",
					"required": [
						"TagKeyList"
					],
					"members": {
						"StreamARN": {},
						"StreamName": {},
						"TagKeyList": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateDataRetention": {
				"http": {
					"requestUri": "/updateDataRetention"
				},
				"input": {
					"type": "structure",
					"required": [
						"CurrentVersion",
						"Operation",
						"DataRetentionChangeInHours"
					],
					"members": {
						"StreamName": {},
						"StreamARN": {},
						"CurrentVersion": {},
						"Operation": {},
						"DataRetentionChangeInHours": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateStream": {
				"http": {
					"requestUri": "/updateStream"
				},
				"input": {
					"type": "structure",
					"required": [
						"CurrentVersion"
					],
					"members": {
						"StreamName": {},
						"StreamARN": {},
						"CurrentVersion": {},
						"DeviceName": {},
						"MediaType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S7": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sh": {
				"type": "structure",
				"members": {
					"DeviceName": {},
					"StreamName": {},
					"StreamARN": {},
					"MediaType": {},
					"KmsKeyId": {},
					"Version": {},
					"Status": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"DataRetentionInHours": {
						"type": "integer"
					}
				}
			}
		}
	};

/***/ },
/* 1768 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListStreams": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "StreamInfoList"
			}
		}
	};

/***/ },
/* 1769 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-01",
			"endpointPrefix": "kms",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "KMS",
			"serviceFullName": "AWS Key Management Service",
			"serviceId": "KMS",
			"signatureVersion": "v4",
			"targetPrefix": "TrentService",
			"uid": "kms-2014-11-01"
		},
		"operations": {
			"CancelKeyDeletion": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {}
					}
				}
			},
			"ConnectCustomKeyStore": {
				"input": {
					"type": "structure",
					"required": [
						"CustomKeyStoreId"
					],
					"members": {
						"CustomKeyStoreId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasName",
						"TargetKeyId"
					],
					"members": {
						"AliasName": {},
						"TargetKeyId": {}
					}
				}
			},
			"CreateCustomKeyStore": {
				"input": {
					"type": "structure",
					"required": [
						"CustomKeyStoreName",
						"CloudHsmClusterId",
						"TrustAnchorCertificate",
						"KeyStorePassword"
					],
					"members": {
						"CustomKeyStoreName": {},
						"CloudHsmClusterId": {},
						"TrustAnchorCertificate": {},
						"KeyStorePassword": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CustomKeyStoreId": {}
					}
				}
			},
			"CreateGrant": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"GranteePrincipal",
						"Operations"
					],
					"members": {
						"KeyId": {},
						"GranteePrincipal": {},
						"RetiringPrincipal": {},
						"Operations": {
							"shape": "Sh"
						},
						"Constraints": {
							"shape": "Sj"
						},
						"GrantTokens": {
							"shape": "Sn"
						},
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GrantToken": {},
						"GrantId": {}
					}
				}
			},
			"CreateKey": {
				"input": {
					"type": "structure",
					"members": {
						"Policy": {},
						"Description": {},
						"KeyUsage": {},
						"Origin": {},
						"CustomKeyStoreId": {},
						"BypassPolicyLockoutSafetyCheck": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyMetadata": {
							"shape": "S13"
						}
					}
				}
			},
			"Decrypt": {
				"input": {
					"type": "structure",
					"required": [
						"CiphertextBlob"
					],
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"EncryptionContext": {
							"shape": "Sk"
						},
						"GrantTokens": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {},
						"Plaintext": {
							"shape": "S1d"
						}
					}
				}
			},
			"DeleteAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasName"
					],
					"members": {
						"AliasName": {}
					}
				}
			},
			"DeleteCustomKeyStore": {
				"input": {
					"type": "structure",
					"required": [
						"CustomKeyStoreId"
					],
					"members": {
						"CustomKeyStoreId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteImportedKeyMaterial": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"DescribeCustomKeyStores": {
				"input": {
					"type": "structure",
					"members": {
						"CustomKeyStoreId": {},
						"CustomKeyStoreName": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CustomKeyStores": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CustomKeyStoreId": {},
									"CustomKeyStoreName": {},
									"CloudHsmClusterId": {},
									"TrustAnchorCertificate": {},
									"ConnectionState": {},
									"ConnectionErrorCode": {},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"DescribeKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"GrantTokens": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyMetadata": {
							"shape": "S13"
						}
					}
				}
			},
			"DisableKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"DisableKeyRotation": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"DisconnectCustomKeyStore": {
				"input": {
					"type": "structure",
					"required": [
						"CustomKeyStoreId"
					],
					"members": {
						"CustomKeyStoreId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"EnableKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"EnableKeyRotation": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"Encrypt": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"Plaintext"
					],
					"members": {
						"KeyId": {},
						"Plaintext": {
							"shape": "S1d"
						},
						"EncryptionContext": {
							"shape": "Sk"
						},
						"GrantTokens": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"KeyId": {}
					}
				}
			},
			"GenerateDataKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"EncryptionContext": {
							"shape": "Sk"
						},
						"NumberOfBytes": {
							"type": "integer"
						},
						"KeySpec": {},
						"GrantTokens": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"Plaintext": {
							"shape": "S1d"
						},
						"KeyId": {}
					}
				}
			},
			"GenerateDataKeyWithoutPlaintext": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"EncryptionContext": {
							"shape": "Sk"
						},
						"KeySpec": {},
						"NumberOfBytes": {
							"type": "integer"
						},
						"GrantTokens": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"KeyId": {}
					}
				}
			},
			"GenerateRandom": {
				"input": {
					"type": "structure",
					"members": {
						"NumberOfBytes": {
							"type": "integer"
						},
						"CustomKeyStoreId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Plaintext": {
							"shape": "S1d"
						}
					}
				}
			},
			"GetKeyPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"PolicyName"
					],
					"members": {
						"KeyId": {},
						"PolicyName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {}
					}
				}
			},
			"GetKeyRotationStatus": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyRotationEnabled": {
							"type": "boolean"
						}
					}
				}
			},
			"GetParametersForImport": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"WrappingAlgorithm",
						"WrappingKeySpec"
					],
					"members": {
						"KeyId": {},
						"WrappingAlgorithm": {},
						"WrappingKeySpec": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {},
						"ImportToken": {
							"type": "blob"
						},
						"PublicKey": {
							"shape": "S1d"
						},
						"ParametersValidTo": {
							"type": "timestamp"
						}
					}
				}
			},
			"ImportKeyMaterial": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"ImportToken",
						"EncryptedKeyMaterial"
					],
					"members": {
						"KeyId": {},
						"ImportToken": {
							"type": "blob"
						},
						"EncryptedKeyMaterial": {
							"type": "blob"
						},
						"ValidTo": {
							"type": "timestamp"
						},
						"ExpirationModel": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ListAliases": {
				"input": {
					"type": "structure",
					"members": {
						"KeyId": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Aliases": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AliasName": {},
									"AliasArn": {},
									"TargetKeyId": {}
								}
							}
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListGrants": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"Limit": {
							"type": "integer"
						},
						"Marker": {},
						"KeyId": {}
					}
				},
				"output": {
					"shape": "S2o"
				}
			},
			"ListKeyPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PolicyNames": {
							"type": "list",
							"member": {}
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListKeys": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Keys": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"KeyId": {},
									"KeyArn": {}
								}
							}
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListResourceTags": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "Sy"
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListRetirableGrants": {
				"input": {
					"type": "structure",
					"required": [
						"RetiringPrincipal"
					],
					"members": {
						"Limit": {
							"type": "integer"
						},
						"Marker": {},
						"RetiringPrincipal": {}
					}
				},
				"output": {
					"shape": "S2o"
				}
			},
			"PutKeyPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"PolicyName",
						"Policy"
					],
					"members": {
						"KeyId": {},
						"PolicyName": {},
						"Policy": {},
						"BypassPolicyLockoutSafetyCheck": {
							"type": "boolean"
						}
					}
				}
			},
			"ReEncrypt": {
				"input": {
					"type": "structure",
					"required": [
						"CiphertextBlob",
						"DestinationKeyId"
					],
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"SourceEncryptionContext": {
							"shape": "Sk"
						},
						"DestinationKeyId": {},
						"DestinationEncryptionContext": {
							"shape": "Sk"
						},
						"GrantTokens": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"SourceKeyId": {},
						"KeyId": {}
					}
				}
			},
			"RetireGrant": {
				"input": {
					"type": "structure",
					"members": {
						"GrantToken": {},
						"KeyId": {},
						"GrantId": {}
					}
				}
			},
			"RevokeGrant": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"GrantId"
					],
					"members": {
						"KeyId": {},
						"GrantId": {}
					}
				}
			},
			"ScheduleKeyDeletion": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"PendingWindowInDays": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {},
						"DeletionDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"Tags"
					],
					"members": {
						"KeyId": {},
						"Tags": {
							"shape": "Sy"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"TagKeys"
					],
					"members": {
						"KeyId": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"UpdateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasName",
						"TargetKeyId"
					],
					"members": {
						"AliasName": {},
						"TargetKeyId": {}
					}
				}
			},
			"UpdateCustomKeyStore": {
				"input": {
					"type": "structure",
					"required": [
						"CustomKeyStoreId"
					],
					"members": {
						"CustomKeyStoreId": {},
						"NewCustomKeyStoreName": {},
						"KeyStorePassword": {
							"shape": "Sd"
						},
						"CloudHsmClusterId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateKeyDescription": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"Description"
					],
					"members": {
						"KeyId": {},
						"Description": {}
					}
				}
			}
		},
		"shapes": {
			"Sd": {
				"type": "string",
				"sensitive": true
			},
			"Sh": {
				"type": "list",
				"member": {}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"EncryptionContextSubset": {
						"shape": "Sk"
					},
					"EncryptionContextEquals": {
						"shape": "Sk"
					}
				}
			},
			"Sk": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sn": {
				"type": "list",
				"member": {}
			},
			"Sy": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"TagKey",
						"TagValue"
					],
					"members": {
						"TagKey": {},
						"TagValue": {}
					}
				}
			},
			"S13": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"AWSAccountId": {},
					"KeyId": {},
					"Arn": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"Description": {},
					"KeyUsage": {},
					"KeyState": {},
					"DeletionDate": {
						"type": "timestamp"
					},
					"ValidTo": {
						"type": "timestamp"
					},
					"Origin": {},
					"CustomKeyStoreId": {},
					"CloudHsmClusterId": {},
					"ExpirationModel": {},
					"KeyManager": {}
				}
			},
			"S1d": {
				"type": "blob",
				"sensitive": true
			},
			"S2o": {
				"type": "structure",
				"members": {
					"Grants": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"KeyId": {},
								"GrantId": {},
								"Name": {},
								"CreationDate": {
									"type": "timestamp"
								},
								"GranteePrincipal": {},
								"RetiringPrincipal": {},
								"IssuingAccount": {},
								"Operations": {
									"shape": "Sh"
								},
								"Constraints": {
									"shape": "Sj"
								}
							}
						}
					},
					"NextMarker": {},
					"Truncated": {
						"type": "boolean"
					}
				}
			}
		}
	};

/***/ },
/* 1770 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListAliases": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "Aliases"
			},
			"ListGrants": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "Grants"
			},
			"ListKeyPolicies": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "PolicyNames"
			},
			"ListKeys": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "Keys"
			}
		}
	};

/***/ },
/* 1771 */
/***/ function(module, exports) {

	module.exports = {
		"metadata": {
			"apiVersion": "2014-11-11",
			"endpointPrefix": "lambda",
			"serviceFullName": "AWS Lambda",
			"serviceId": "Lambda",
			"signatureVersion": "v4",
			"protocol": "rest-json"
		},
		"operations": {
			"AddEventSource": {
				"http": {
					"requestUri": "/2014-11-13/event-source-mappings/"
				},
				"input": {
					"type": "structure",
					"required": [
						"EventSource",
						"FunctionName",
						"Role"
					],
					"members": {
						"EventSource": {},
						"FunctionName": {},
						"Role": {},
						"BatchSize": {
							"type": "integer"
						},
						"Parameters": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"DeleteFunction": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2014-11-13/functions/{FunctionName}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						}
					}
				}
			},
			"GetEventSource": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/event-source-mappings/{UUID}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"GetFunction": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/functions/{FunctionName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Configuration": {
							"shape": "Se"
						},
						"Code": {
							"type": "structure",
							"members": {
								"RepositoryType": {},
								"Location": {}
							}
						}
					}
				}
			},
			"GetFunctionConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						}
					}
				},
				"output": {
					"shape": "Se"
				}
			},
			"InvokeAsync": {
				"http": {
					"requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"InvokeArgs"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"InvokeArgs": {
							"shape": "Sq"
						}
					},
					"payload": "InvokeArgs"
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"location": "statusCode",
							"type": "integer"
						}
					}
				}
			},
			"ListEventSources": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/event-source-mappings/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"EventSourceArn": {
							"location": "querystring",
							"locationName": "EventSource"
						},
						"FunctionName": {
							"location": "querystring",
							"locationName": "FunctionName"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"EventSources": {
							"type": "list",
							"member": {
								"shape": "S7"
							}
						}
					}
				}
			},
			"ListFunctions": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/functions/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Functions": {
							"type": "list",
							"member": {
								"shape": "Se"
							}
						}
					}
				}
			},
			"RemoveEventSource": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2014-11-13/event-source-mappings/{UUID}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				}
			},
			"UpdateFunctionConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Role": {
							"location": "querystring",
							"locationName": "Role"
						},
						"Handler": {
							"location": "querystring",
							"locationName": "Handler"
						},
						"Description": {
							"location": "querystring",
							"locationName": "Description"
						},
						"Timeout": {
							"location": "querystring",
							"locationName": "Timeout",
							"type": "integer"
						},
						"MemorySize": {
							"location": "querystring",
							"locationName": "MemorySize",
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "Se"
				}
			},
			"UploadFunction": {
				"http": {
					"method": "PUT",
					"requestUri": "/2014-11-13/functions/{FunctionName}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"FunctionZip",
						"Runtime",
						"Role",
						"Handler",
						"Mode"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"FunctionZip": {
							"shape": "Sq"
						},
						"Runtime": {
							"location": "querystring",
							"locationName": "Runtime"
						},
						"Role": {
							"location": "querystring",
							"locationName": "Role"
						},
						"Handler": {
							"location": "querystring",
							"locationName": "Handler"
						},
						"Mode": {
							"location": "querystring",
							"locationName": "Mode"
						},
						"Description": {
							"location": "querystring",
							"locationName": "Description"
						},
						"Timeout": {
							"location": "querystring",
							"locationName": "Timeout",
							"type": "integer"
						},
						"MemorySize": {
							"location": "querystring",
							"locationName": "MemorySize",
							"type": "integer"
						}
					},
					"payload": "FunctionZip"
				},
				"output": {
					"shape": "Se"
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S7": {
				"type": "structure",
				"members": {
					"UUID": {},
					"BatchSize": {
						"type": "integer"
					},
					"EventSource": {},
					"FunctionName": {},
					"Parameters": {
						"shape": "S6"
					},
					"Role": {},
					"LastModified": {
						"type": "timestamp"
					},
					"IsActive": {
						"type": "boolean"
					},
					"Status": {}
				}
			},
			"Se": {
				"type": "structure",
				"members": {
					"FunctionName": {},
					"FunctionARN": {},
					"ConfigurationId": {},
					"Runtime": {},
					"Role": {},
					"Handler": {},
					"Mode": {},
					"CodeSize": {
						"type": "long"
					},
					"Description": {},
					"Timeout": {
						"type": "integer"
					},
					"MemorySize": {
						"type": "integer"
					},
					"LastModified": {
						"type": "timestamp"
					}
				}
			},
			"Sq": {
				"type": "blob",
				"streaming": true
			}
		}
	};

/***/ },
/* 1772 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListEventSources": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"limit_key": "MaxItems",
				"result_key": "EventSources"
			},
			"ListFunctions": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"limit_key": "MaxItems",
				"result_key": "Functions"
			}
		}
	};

/***/ },
/* 1773 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-03-31",
			"endpointPrefix": "lambda",
			"protocol": "rest-json",
			"serviceFullName": "AWS Lambda",
			"serviceId": "Lambda",
			"signatureVersion": "v4",
			"uid": "lambda-2015-03-31"
		},
		"operations": {
			"AddLayerVersionPermission": {
				"http": {
					"requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"LayerName",
						"VersionNumber",
						"StatementId",
						"Action",
						"Principal"
					],
					"members": {
						"LayerName": {
							"location": "uri",
							"locationName": "LayerName"
						},
						"VersionNumber": {
							"location": "uri",
							"locationName": "VersionNumber",
							"type": "long"
						},
						"StatementId": {},
						"Action": {},
						"Principal": {},
						"OrganizationId": {},
						"RevisionId": {
							"location": "querystring",
							"locationName": "RevisionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Statement": {},
						"RevisionId": {}
					}
				}
			},
			"AddPermission": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/policy",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"StatementId",
						"Action",
						"Principal"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"StatementId": {},
						"Action": {},
						"Principal": {},
						"SourceArn": {},
						"SourceAccount": {},
						"EventSourceToken": {},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						},
						"RevisionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Statement": {}
					}
				}
			},
			"CreateAlias": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name",
						"FunctionVersion"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {},
						"FunctionVersion": {},
						"Description": {},
						"RoutingConfig": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"shape": "Sr"
				}
			},
			"CreateEventSourceMapping": {
				"http": {
					"requestUri": "/2015-03-31/event-source-mappings/",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"EventSourceArn",
						"FunctionName"
					],
					"members": {
						"EventSourceArn": {},
						"FunctionName": {},
						"Enabled": {
							"type": "boolean"
						},
						"BatchSize": {
							"type": "integer"
						},
						"StartingPosition": {},
						"StartingPositionTimestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"shape": "Sy"
				}
			},
			"CreateFunction": {
				"http": {
					"requestUri": "/2015-03-31/functions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Runtime",
						"Role",
						"Handler",
						"Code"
					],
					"members": {
						"FunctionName": {},
						"Runtime": {},
						"Role": {},
						"Handler": {},
						"Code": {
							"type": "structure",
							"members": {
								"ZipFile": {
									"shape": "S14"
								},
								"S3Bucket": {},
								"S3Key": {},
								"S3ObjectVersion": {}
							}
						},
						"Description": {},
						"Timeout": {
							"type": "integer"
						},
						"MemorySize": {
							"type": "integer"
						},
						"Publish": {
							"type": "boolean"
						},
						"VpcConfig": {
							"shape": "S1b"
						},
						"DeadLetterConfig": {
							"shape": "S1g"
						},
						"Environment": {
							"shape": "S1i"
						},
						"KMSKeyArn": {},
						"TracingConfig": {
							"shape": "S1n"
						},
						"Tags": {
							"shape": "S1p"
						},
						"Layers": {
							"shape": "S1s"
						}
					}
				},
				"output": {
					"shape": "S1u"
				}
			},
			"DeleteAlias": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {
							"location": "uri",
							"locationName": "Name"
						}
					}
				}
			},
			"DeleteEventSourceMapping": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				},
				"output": {
					"shape": "Sy"
				}
			},
			"DeleteFunction": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/functions/{FunctionName}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				}
			},
			"DeleteFunctionConcurrency": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-10-31/functions/{FunctionName}/concurrency",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						}
					}
				}
			},
			"DeleteLayerVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"LayerName",
						"VersionNumber"
					],
					"members": {
						"LayerName": {
							"location": "uri",
							"locationName": "LayerName"
						},
						"VersionNumber": {
							"location": "uri",
							"locationName": "VersionNumber",
							"type": "long"
						}
					}
				}
			},
			"GetAccountSettings": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-08-19/account-settings/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountLimit": {
							"type": "structure",
							"members": {
								"TotalCodeSize": {
									"type": "long"
								},
								"CodeSizeUnzipped": {
									"type": "long"
								},
								"CodeSizeZipped": {
									"type": "long"
								},
								"ConcurrentExecutions": {
									"type": "integer"
								},
								"UnreservedConcurrentExecutions": {
									"type": "integer"
								}
							}
						},
						"AccountUsage": {
							"type": "structure",
							"members": {
								"TotalCodeSize": {
									"type": "long"
								},
								"FunctionCount": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"GetAlias": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {
							"location": "uri",
							"locationName": "Name"
						}
					}
				},
				"output": {
					"shape": "Sr"
				}
			},
			"GetEventSourceMapping": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				},
				"output": {
					"shape": "Sy"
				}
			},
			"GetFunction": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Configuration": {
							"shape": "S1u"
						},
						"Code": {
							"type": "structure",
							"members": {
								"RepositoryType": {},
								"Location": {}
							}
						},
						"Tags": {
							"shape": "S1p"
						},
						"Concurrency": {
							"shape": "S2n"
						}
					}
				}
			},
			"GetFunctionConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				},
				"output": {
					"shape": "S1u"
				}
			},
			"GetLayerVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"LayerName",
						"VersionNumber"
					],
					"members": {
						"LayerName": {
							"location": "uri",
							"locationName": "LayerName"
						},
						"VersionNumber": {
							"location": "uri",
							"locationName": "VersionNumber",
							"type": "long"
						}
					}
				},
				"output": {
					"shape": "S2r"
				}
			},
			"GetLayerVersionByArn": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-10-31/layers?find=LayerVersion",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Arn"
					],
					"members": {
						"Arn": {
							"location": "querystring",
							"locationName": "Arn"
						}
					}
				},
				"output": {
					"shape": "S2r"
				}
			},
			"GetLayerVersionPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"LayerName",
						"VersionNumber"
					],
					"members": {
						"LayerName": {
							"location": "uri",
							"locationName": "LayerName"
						},
						"VersionNumber": {
							"location": "uri",
							"locationName": "VersionNumber",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {},
						"RevisionId": {}
					}
				}
			},
			"GetPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/policy",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {},
						"RevisionId": {}
					}
				}
			},
			"Invoke": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/invocations"
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"InvocationType": {
							"location": "header",
							"locationName": "X-Amz-Invocation-Type"
						},
						"LogType": {
							"location": "header",
							"locationName": "X-Amz-Log-Type"
						},
						"ClientContext": {
							"location": "header",
							"locationName": "X-Amz-Client-Context"
						},
						"Payload": {
							"shape": "S14"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					},
					"payload": "Payload"
				},
				"output": {
					"type": "structure",
					"members": {
						"StatusCode": {
							"location": "statusCode",
							"type": "integer"
						},
						"FunctionError": {
							"location": "header",
							"locationName": "X-Amz-Function-Error"
						},
						"LogResult": {
							"location": "header",
							"locationName": "X-Amz-Log-Result"
						},
						"Payload": {
							"shape": "S14"
						},
						"ExecutedVersion": {
							"location": "header",
							"locationName": "X-Amz-Executed-Version"
						}
					},
					"payload": "Payload"
				}
			},
			"InvokeAsync": {
				"http": {
					"requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"InvokeArgs"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"InvokeArgs": {
							"type": "blob",
							"streaming": true
						}
					},
					"deprecated": true,
					"payload": "InvokeArgs"
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"location": "statusCode",
							"type": "integer"
						}
					},
					"deprecated": true
				},
				"deprecated": true
			},
			"ListAliases": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"FunctionVersion": {
							"location": "querystring",
							"locationName": "FunctionVersion"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Aliases": {
							"type": "list",
							"member": {
								"shape": "Sr"
							}
						}
					}
				}
			},
			"ListEventSourceMappings": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/event-source-mappings/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"EventSourceArn": {
							"location": "querystring",
							"locationName": "EventSourceArn"
						},
						"FunctionName": {
							"location": "querystring",
							"locationName": "FunctionName"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"EventSourceMappings": {
							"type": "list",
							"member": {
								"shape": "Sy"
							}
						}
					}
				}
			},
			"ListFunctions": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"MasterRegion": {
							"location": "querystring",
							"locationName": "MasterRegion"
						},
						"FunctionVersion": {
							"location": "querystring",
							"locationName": "FunctionVersion"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Functions": {
							"shape": "S3k"
						}
					}
				}
			},
			"ListLayerVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-10-31/layers/{LayerName}/versions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"LayerName"
					],
					"members": {
						"CompatibleRuntime": {
							"location": "querystring",
							"locationName": "CompatibleRuntime"
						},
						"LayerName": {
							"location": "uri",
							"locationName": "LayerName"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"LayerVersions": {
							"type": "list",
							"member": {
								"shape": "S3p"
							}
						}
					}
				}
			},
			"ListLayers": {
				"http": {
					"method": "GET",
					"requestUri": "/2018-10-31/layers",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"CompatibleRuntime": {
							"location": "querystring",
							"locationName": "CompatibleRuntime"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Layers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LayerName": {},
									"LayerArn": {},
									"LatestMatchingVersion": {
										"shape": "S3p"
									}
								}
							}
						}
					}
				}
			},
			"ListTags": {
				"http": {
					"method": "GET",
					"requestUri": "/2017-03-31/tags/{ARN}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "uri",
							"locationName": "ARN"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S1p"
						}
					}
				}
			},
			"ListVersionsByFunction": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/versions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Versions": {
							"shape": "S3k"
						}
					}
				}
			},
			"PublishLayerVersion": {
				"http": {
					"requestUri": "/2018-10-31/layers/{LayerName}/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"LayerName",
						"Content"
					],
					"members": {
						"LayerName": {
							"location": "uri",
							"locationName": "LayerName"
						},
						"Description": {},
						"Content": {
							"type": "structure",
							"members": {
								"S3Bucket": {},
								"S3Key": {},
								"S3ObjectVersion": {},
								"ZipFile": {
									"shape": "S14"
								}
							}
						},
						"CompatibleRuntimes": {
							"shape": "S2u"
						},
						"LicenseInfo": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Content": {
							"shape": "S2s"
						},
						"LayerArn": {},
						"LayerVersionArn": {},
						"Description": {},
						"CreatedDate": {},
						"Version": {
							"type": "long"
						},
						"CompatibleRuntimes": {
							"shape": "S2u"
						},
						"LicenseInfo": {}
					}
				}
			},
			"PublishVersion": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"CodeSha256": {},
						"Description": {},
						"RevisionId": {}
					}
				},
				"output": {
					"shape": "S1u"
				}
			},
			"PutFunctionConcurrency": {
				"http": {
					"method": "PUT",
					"requestUri": "/2017-10-31/functions/{FunctionName}/concurrency",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"ReservedConcurrentExecutions"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"ReservedConcurrentExecutions": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S2n"
				}
			},
			"RemoveLayerVersionPermission": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy/{StatementId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"LayerName",
						"VersionNumber",
						"StatementId"
					],
					"members": {
						"LayerName": {
							"location": "uri",
							"locationName": "LayerName"
						},
						"VersionNumber": {
							"location": "uri",
							"locationName": "VersionNumber",
							"type": "long"
						},
						"StatementId": {
							"location": "uri",
							"locationName": "StatementId"
						},
						"RevisionId": {
							"location": "querystring",
							"locationName": "RevisionId"
						}
					}
				}
			},
			"RemovePermission": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/functions/{FunctionName}/policy/{StatementId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"StatementId"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"StatementId": {
							"location": "uri",
							"locationName": "StatementId"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						},
						"RevisionId": {
							"location": "querystring",
							"locationName": "RevisionId"
						}
					}
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2017-03-31/tags/{ARN}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "uri",
							"locationName": "ARN"
						},
						"Tags": {
							"shape": "S1p"
						}
					}
				}
			},
			"UntagResource": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2017-03-31/tags/{ARN}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "uri",
							"locationName": "ARN"
						},
						"TagKeys": {
							"location": "querystring",
							"locationName": "tagKeys",
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"UpdateAlias": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {
							"location": "uri",
							"locationName": "Name"
						},
						"FunctionVersion": {},
						"Description": {},
						"RoutingConfig": {
							"shape": "Sn"
						},
						"RevisionId": {}
					}
				},
				"output": {
					"shape": "Sr"
				}
			},
			"UpdateEventSourceMapping": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						},
						"FunctionName": {},
						"Enabled": {
							"type": "boolean"
						},
						"BatchSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "Sy"
				}
			},
			"UpdateFunctionCode": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/functions/{FunctionName}/code",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"ZipFile": {
							"shape": "S14"
						},
						"S3Bucket": {},
						"S3Key": {},
						"S3ObjectVersion": {},
						"Publish": {
							"type": "boolean"
						},
						"DryRun": {
							"type": "boolean"
						},
						"RevisionId": {}
					}
				},
				"output": {
					"shape": "S1u"
				}
			},
			"UpdateFunctionConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Role": {},
						"Handler": {},
						"Description": {},
						"Timeout": {
							"type": "integer"
						},
						"MemorySize": {
							"type": "integer"
						},
						"VpcConfig": {
							"shape": "S1b"
						},
						"Environment": {
							"shape": "S1i"
						},
						"Runtime": {},
						"DeadLetterConfig": {
							"shape": "S1g"
						},
						"KMSKeyArn": {},
						"TracingConfig": {
							"shape": "S1n"
						},
						"RevisionId": {},
						"Layers": {
							"shape": "S1s"
						}
					}
				},
				"output": {
					"shape": "S1u"
				}
			}
		},
		"shapes": {
			"Sn": {
				"type": "structure",
				"members": {
					"AdditionalVersionWeights": {
						"type": "map",
						"key": {},
						"value": {
							"type": "double"
						}
					}
				}
			},
			"Sr": {
				"type": "structure",
				"members": {
					"AliasArn": {},
					"Name": {},
					"FunctionVersion": {},
					"Description": {},
					"RoutingConfig": {
						"shape": "Sn"
					},
					"RevisionId": {}
				}
			},
			"Sy": {
				"type": "structure",
				"members": {
					"UUID": {},
					"BatchSize": {
						"type": "integer"
					},
					"EventSourceArn": {},
					"FunctionArn": {},
					"LastModified": {
						"type": "timestamp"
					},
					"LastProcessingResult": {},
					"State": {},
					"StateTransitionReason": {}
				}
			},
			"S14": {
				"type": "blob",
				"sensitive": true
			},
			"S1b": {
				"type": "structure",
				"members": {
					"SubnetIds": {
						"shape": "S1c"
					},
					"SecurityGroupIds": {
						"shape": "S1e"
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {}
			},
			"S1e": {
				"type": "list",
				"member": {}
			},
			"S1g": {
				"type": "structure",
				"members": {
					"TargetArn": {}
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"Variables": {
						"shape": "S1j"
					}
				}
			},
			"S1j": {
				"type": "map",
				"key": {
					"type": "string",
					"sensitive": true
				},
				"value": {
					"type": "string",
					"sensitive": true
				},
				"sensitive": true
			},
			"S1n": {
				"type": "structure",
				"members": {
					"Mode": {}
				}
			},
			"S1p": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1s": {
				"type": "list",
				"member": {}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"FunctionName": {},
					"FunctionArn": {},
					"Runtime": {},
					"Role": {},
					"Handler": {},
					"CodeSize": {
						"type": "long"
					},
					"Description": {},
					"Timeout": {
						"type": "integer"
					},
					"MemorySize": {
						"type": "integer"
					},
					"LastModified": {},
					"CodeSha256": {},
					"Version": {},
					"VpcConfig": {
						"type": "structure",
						"members": {
							"SubnetIds": {
								"shape": "S1c"
							},
							"SecurityGroupIds": {
								"shape": "S1e"
							},
							"VpcId": {}
						}
					},
					"DeadLetterConfig": {
						"shape": "S1g"
					},
					"Environment": {
						"type": "structure",
						"members": {
							"Variables": {
								"shape": "S1j"
							},
							"Error": {
								"type": "structure",
								"members": {
									"ErrorCode": {},
									"Message": {
										"type": "string",
										"sensitive": true
									}
								}
							}
						}
					},
					"KMSKeyArn": {},
					"TracingConfig": {
						"type": "structure",
						"members": {
							"Mode": {}
						}
					},
					"MasterArn": {},
					"RevisionId": {},
					"Layers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Arn": {},
								"CodeSize": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S2n": {
				"type": "structure",
				"members": {
					"ReservedConcurrentExecutions": {
						"type": "integer"
					}
				}
			},
			"S2r": {
				"type": "structure",
				"members": {
					"Content": {
						"shape": "S2s"
					},
					"LayerArn": {},
					"LayerVersionArn": {},
					"Description": {},
					"CreatedDate": {},
					"Version": {
						"type": "long"
					},
					"CompatibleRuntimes": {
						"shape": "S2u"
					},
					"LicenseInfo": {}
				}
			},
			"S2s": {
				"type": "structure",
				"members": {
					"Location": {},
					"CodeSha256": {},
					"CodeSize": {
						"type": "long"
					}
				}
			},
			"S2u": {
				"type": "list",
				"member": {}
			},
			"S3k": {
				"type": "list",
				"member": {
					"shape": "S1u"
				}
			},
			"S3p": {
				"type": "structure",
				"members": {
					"LayerVersionArn": {},
					"Version": {
						"type": "long"
					},
					"Description": {},
					"CreatedDate": {},
					"CompatibleRuntimes": {
						"shape": "S2u"
					},
					"LicenseInfo": {}
				}
			}
		}
	};

/***/ },
/* 1774 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListEventSourceMappings": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"output_token": "NextMarker",
				"result_key": "EventSourceMappings"
			},
			"ListFunctions": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"output_token": "NextMarker",
				"result_key": "Functions"
			}
		}
	};

/***/ },
/* 1775 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"FunctionExists": {
				"delay": 1,
				"operation": "GetFunction",
				"maxAttempts": 20,
				"acceptors": [
					{
						"state": "success",
						"matcher": "status",
						"expected": 200
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "ResourceNotFoundException"
					}
				]
			}
		}
	};

/***/ },
/* 1776 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-04-19",
			"endpointPrefix": "models.lex",
			"jsonVersion": "1.1",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Lex Model Building Service",
			"serviceId": "Lex Model Building Service",
			"signatureVersion": "v4",
			"signingName": "lex",
			"uid": "lex-models-2017-04-19"
		},
		"operations": {
			"CreateBotVersion": {
				"http": {
					"requestUri": "/bots/{name}/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"checksum": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"intents": {
							"shape": "S6"
						},
						"clarificationPrompt": {
							"shape": "Sa"
						},
						"abortStatement": {
							"shape": "Si"
						},
						"status": {},
						"failureReason": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"idleSessionTTLInSeconds": {
							"type": "integer"
						},
						"voiceId": {},
						"checksum": {},
						"version": {},
						"locale": {},
						"childDirected": {
							"type": "boolean"
						}
					}
				}
			},
			"CreateIntentVersion": {
				"http": {
					"requestUri": "/intents/{name}/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"checksum": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"slots": {
							"shape": "Sq"
						},
						"sampleUtterances": {
							"shape": "Sy"
						},
						"confirmationPrompt": {
							"shape": "Sa"
						},
						"rejectionStatement": {
							"shape": "Si"
						},
						"followUpPrompt": {
							"shape": "Sz"
						},
						"conclusionStatement": {
							"shape": "Si"
						},
						"dialogCodeHook": {
							"shape": "S10"
						},
						"fulfillmentActivity": {
							"shape": "S13"
						},
						"parentIntentSignature": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {},
						"checksum": {}
					}
				}
			},
			"CreateSlotTypeVersion": {
				"http": {
					"requestUri": "/slottypes/{name}/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"checksum": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"enumerationValues": {
							"shape": "S19"
						},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {},
						"checksum": {},
						"valueSelectionStrategy": {}
					}
				}
			},
			"DeleteBot": {
				"http": {
					"method": "DELETE",
					"requestUri": "/bots/{name}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						}
					}
				}
			},
			"DeleteBotAlias": {
				"http": {
					"method": "DELETE",
					"requestUri": "/bots/{botName}/aliases/{name}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"botName"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"botName": {
							"location": "uri",
							"locationName": "botName"
						}
					}
				}
			},
			"DeleteBotChannelAssociation": {
				"http": {
					"method": "DELETE",
					"requestUri": "/bots/{botName}/aliases/{aliasName}/channels/{name}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"botName",
						"botAlias"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "aliasName"
						}
					}
				}
			},
			"DeleteBotVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/bots/{name}/versions/{version}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"version"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"version": {
							"location": "uri",
							"locationName": "version"
						}
					}
				}
			},
			"DeleteIntent": {
				"http": {
					"method": "DELETE",
					"requestUri": "/intents/{name}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						}
					}
				}
			},
			"DeleteIntentVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/intents/{name}/versions/{version}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"version"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"version": {
							"location": "uri",
							"locationName": "version"
						}
					}
				}
			},
			"DeleteSlotType": {
				"http": {
					"method": "DELETE",
					"requestUri": "/slottypes/{name}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						}
					}
				}
			},
			"DeleteSlotTypeVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/slottypes/{name}/version/{version}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"version"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"version": {
							"location": "uri",
							"locationName": "version"
						}
					}
				}
			},
			"DeleteUtterances": {
				"http": {
					"method": "DELETE",
					"requestUri": "/bots/{botName}/utterances/{userId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"userId"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						}
					}
				}
			},
			"GetBot": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/{name}/versions/{versionoralias}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"versionOrAlias"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"versionOrAlias": {
							"location": "uri",
							"locationName": "versionoralias"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"intents": {
							"shape": "S6"
						},
						"clarificationPrompt": {
							"shape": "Sa"
						},
						"abortStatement": {
							"shape": "Si"
						},
						"status": {},
						"failureReason": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"idleSessionTTLInSeconds": {
							"type": "integer"
						},
						"voiceId": {},
						"checksum": {},
						"version": {},
						"locale": {},
						"childDirected": {
							"type": "boolean"
						}
					}
				}
			},
			"GetBotAlias": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/{botName}/aliases/{name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"botName"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"botName": {
							"location": "uri",
							"locationName": "botName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"botVersion": {},
						"botName": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"checksum": {}
					}
				}
			},
			"GetBotAliases": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/{botName}/aliases/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"botName"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nameContains": {
							"location": "querystring",
							"locationName": "nameContains"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BotAliases": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"description": {},
									"botVersion": {},
									"botName": {},
									"lastUpdatedDate": {
										"type": "timestamp"
									},
									"createdDate": {
										"type": "timestamp"
									},
									"checksum": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetBotChannelAssociation": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/{botName}/aliases/{aliasName}/channels/{name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"botName",
						"botAlias"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "aliasName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"botAlias": {},
						"botName": {},
						"createdDate": {
							"type": "timestamp"
						},
						"type": {},
						"botConfiguration": {
							"shape": "S24"
						},
						"status": {},
						"failureReason": {}
					}
				}
			},
			"GetBotChannelAssociations": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/{botName}/aliases/{aliasName}/channels/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "aliasName"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nameContains": {
							"location": "querystring",
							"locationName": "nameContains"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"botChannelAssociations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"description": {},
									"botAlias": {},
									"botName": {},
									"createdDate": {
										"type": "timestamp"
									},
									"type": {},
									"botConfiguration": {
										"shape": "S24"
									},
									"status": {},
									"failureReason": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetBotVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/{name}/versions/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"bots": {
							"shape": "S2d"
						},
						"nextToken": {}
					}
				}
			},
			"GetBots": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nameContains": {
							"location": "querystring",
							"locationName": "nameContains"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"bots": {
							"shape": "S2d"
						},
						"nextToken": {}
					}
				}
			},
			"GetBuiltinIntent": {
				"http": {
					"method": "GET",
					"requestUri": "/builtins/intents/{signature}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"signature"
					],
					"members": {
						"signature": {
							"location": "uri",
							"locationName": "signature"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"signature": {},
						"supportedLocales": {
							"shape": "S2j"
						},
						"slots": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {}
								}
							}
						}
					}
				}
			},
			"GetBuiltinIntents": {
				"http": {
					"method": "GET",
					"requestUri": "/builtins/intents/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"locale": {
							"location": "querystring",
							"locationName": "locale"
						},
						"signatureContains": {
							"location": "querystring",
							"locationName": "signatureContains"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"intents": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"signature": {},
									"supportedLocales": {
										"shape": "S2j"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetBuiltinSlotTypes": {
				"http": {
					"method": "GET",
					"requestUri": "/builtins/slottypes/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"locale": {
							"location": "querystring",
							"locationName": "locale"
						},
						"signatureContains": {
							"location": "querystring",
							"locationName": "signatureContains"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"slotTypes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"signature": {},
									"supportedLocales": {
										"shape": "S2j"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetExport": {
				"http": {
					"method": "GET",
					"requestUri": "/exports/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"version",
						"resourceType",
						"exportType"
					],
					"members": {
						"name": {
							"location": "querystring",
							"locationName": "name"
						},
						"version": {
							"location": "querystring",
							"locationName": "version"
						},
						"resourceType": {
							"location": "querystring",
							"locationName": "resourceType"
						},
						"exportType": {
							"location": "querystring",
							"locationName": "exportType"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"version": {},
						"resourceType": {},
						"exportType": {},
						"exportStatus": {},
						"failureReason": {},
						"url": {}
					}
				}
			},
			"GetImport": {
				"http": {
					"method": "GET",
					"requestUri": "/imports/{importId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"importId"
					],
					"members": {
						"importId": {
							"location": "uri",
							"locationName": "importId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"resourceType": {},
						"mergeStrategy": {},
						"importId": {},
						"importStatus": {},
						"failureReason": {
							"type": "list",
							"member": {}
						},
						"createdDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetIntent": {
				"http": {
					"method": "GET",
					"requestUri": "/intents/{name}/versions/{version}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"version"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"version": {
							"location": "uri",
							"locationName": "version"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"slots": {
							"shape": "Sq"
						},
						"sampleUtterances": {
							"shape": "Sy"
						},
						"confirmationPrompt": {
							"shape": "Sa"
						},
						"rejectionStatement": {
							"shape": "Si"
						},
						"followUpPrompt": {
							"shape": "Sz"
						},
						"conclusionStatement": {
							"shape": "Si"
						},
						"dialogCodeHook": {
							"shape": "S10"
						},
						"fulfillmentActivity": {
							"shape": "S13"
						},
						"parentIntentSignature": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {},
						"checksum": {}
					}
				}
			},
			"GetIntentVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/intents/{name}/versions/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"intents": {
							"shape": "S3a"
						},
						"nextToken": {}
					}
				}
			},
			"GetIntents": {
				"http": {
					"method": "GET",
					"requestUri": "/intents/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nameContains": {
							"location": "querystring",
							"locationName": "nameContains"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"intents": {
							"shape": "S3a"
						},
						"nextToken": {}
					}
				}
			},
			"GetSlotType": {
				"http": {
					"method": "GET",
					"requestUri": "/slottypes/{name}/versions/{version}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"version"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"version": {
							"location": "uri",
							"locationName": "version"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"enumerationValues": {
							"shape": "S19"
						},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {},
						"checksum": {},
						"valueSelectionStrategy": {}
					}
				}
			},
			"GetSlotTypeVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/slottypes/{name}/versions/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"slotTypes": {
							"shape": "S3i"
						},
						"nextToken": {}
					}
				}
			},
			"GetSlotTypes": {
				"http": {
					"method": "GET",
					"requestUri": "/slottypes/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nameContains": {
							"location": "querystring",
							"locationName": "nameContains"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"slotTypes": {
							"shape": "S3i"
						},
						"nextToken": {}
					}
				}
			},
			"GetUtterancesView": {
				"http": {
					"method": "GET",
					"requestUri": "/bots/{botname}/utterances?view=aggregation",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botVersions",
						"statusType"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botname"
						},
						"botVersions": {
							"location": "querystring",
							"locationName": "bot_versions",
							"type": "list",
							"member": {}
						},
						"statusType": {
							"location": "querystring",
							"locationName": "status_type"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"botName": {},
						"utterances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"botVersion": {},
									"utterances": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"utteranceString": {},
												"count": {
													"type": "integer"
												},
												"distinctUsers": {
													"type": "integer"
												},
												"firstUtteredDate": {
													"type": "timestamp"
												},
												"lastUtteredDate": {
													"type": "timestamp"
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"PutBot": {
				"http": {
					"method": "PUT",
					"requestUri": "/bots/{name}/versions/$LATEST",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"locale",
						"childDirected"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"description": {},
						"intents": {
							"shape": "S6"
						},
						"clarificationPrompt": {
							"shape": "Sa"
						},
						"abortStatement": {
							"shape": "Si"
						},
						"idleSessionTTLInSeconds": {
							"type": "integer"
						},
						"voiceId": {},
						"checksum": {},
						"processBehavior": {},
						"locale": {},
						"childDirected": {
							"type": "boolean"
						},
						"createVersion": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"intents": {
							"shape": "S6"
						},
						"clarificationPrompt": {
							"shape": "Sa"
						},
						"abortStatement": {
							"shape": "Si"
						},
						"status": {},
						"failureReason": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"idleSessionTTLInSeconds": {
							"type": "integer"
						},
						"voiceId": {},
						"checksum": {},
						"version": {},
						"locale": {},
						"childDirected": {
							"type": "boolean"
						},
						"createVersion": {
							"type": "boolean"
						}
					}
				}
			},
			"PutBotAlias": {
				"http": {
					"method": "PUT",
					"requestUri": "/bots/{botName}/aliases/{name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name",
						"botVersion",
						"botName"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"description": {},
						"botVersion": {},
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"checksum": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"botVersion": {},
						"botName": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"checksum": {}
					}
				}
			},
			"PutIntent": {
				"http": {
					"method": "PUT",
					"requestUri": "/intents/{name}/versions/$LATEST",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"description": {},
						"slots": {
							"shape": "Sq"
						},
						"sampleUtterances": {
							"shape": "Sy"
						},
						"confirmationPrompt": {
							"shape": "Sa"
						},
						"rejectionStatement": {
							"shape": "Si"
						},
						"followUpPrompt": {
							"shape": "Sz"
						},
						"conclusionStatement": {
							"shape": "Si"
						},
						"dialogCodeHook": {
							"shape": "S10"
						},
						"fulfillmentActivity": {
							"shape": "S13"
						},
						"parentIntentSignature": {},
						"checksum": {},
						"createVersion": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"slots": {
							"shape": "Sq"
						},
						"sampleUtterances": {
							"shape": "Sy"
						},
						"confirmationPrompt": {
							"shape": "Sa"
						},
						"rejectionStatement": {
							"shape": "Si"
						},
						"followUpPrompt": {
							"shape": "Sz"
						},
						"conclusionStatement": {
							"shape": "Si"
						},
						"dialogCodeHook": {
							"shape": "S10"
						},
						"fulfillmentActivity": {
							"shape": "S13"
						},
						"parentIntentSignature": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {},
						"checksum": {},
						"createVersion": {
							"type": "boolean"
						}
					}
				}
			},
			"PutSlotType": {
				"http": {
					"method": "PUT",
					"requestUri": "/slottypes/{name}/versions/$LATEST",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {
							"location": "uri",
							"locationName": "name"
						},
						"description": {},
						"enumerationValues": {
							"shape": "S19"
						},
						"checksum": {},
						"valueSelectionStrategy": {},
						"createVersion": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"enumerationValues": {
							"shape": "S19"
						},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {},
						"checksum": {},
						"valueSelectionStrategy": {},
						"createVersion": {
							"type": "boolean"
						}
					}
				}
			},
			"StartImport": {
				"http": {
					"requestUri": "/imports/",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"payload",
						"resourceType",
						"mergeStrategy"
					],
					"members": {
						"payload": {
							"type": "blob"
						},
						"resourceType": {},
						"mergeStrategy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"name": {},
						"resourceType": {},
						"mergeStrategy": {},
						"importId": {},
						"importStatus": {},
						"createdDate": {
							"type": "timestamp"
						}
					}
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"intentName",
						"intentVersion"
					],
					"members": {
						"intentName": {},
						"intentVersion": {}
					}
				}
			},
			"Sa": {
				"type": "structure",
				"required": [
					"messages",
					"maxAttempts"
				],
				"members": {
					"messages": {
						"shape": "Sb"
					},
					"maxAttempts": {
						"type": "integer"
					},
					"responseCard": {}
				}
			},
			"Sb": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"contentType",
						"content"
					],
					"members": {
						"contentType": {},
						"content": {},
						"groupNumber": {
							"type": "integer"
						}
					}
				}
			},
			"Si": {
				"type": "structure",
				"required": [
					"messages"
				],
				"members": {
					"messages": {
						"shape": "Sb"
					},
					"responseCard": {}
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"name",
						"slotConstraint"
					],
					"members": {
						"name": {},
						"description": {},
						"slotConstraint": {},
						"slotType": {},
						"slotTypeVersion": {},
						"valueElicitationPrompt": {
							"shape": "Sa"
						},
						"priority": {
							"type": "integer"
						},
						"sampleUtterances": {
							"type": "list",
							"member": {}
						},
						"responseCard": {}
					}
				}
			},
			"Sy": {
				"type": "list",
				"member": {}
			},
			"Sz": {
				"type": "structure",
				"required": [
					"prompt",
					"rejectionStatement"
				],
				"members": {
					"prompt": {
						"shape": "Sa"
					},
					"rejectionStatement": {
						"shape": "Si"
					}
				}
			},
			"S10": {
				"type": "structure",
				"required": [
					"uri",
					"messageVersion"
				],
				"members": {
					"uri": {},
					"messageVersion": {}
				}
			},
			"S13": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"codeHook": {
						"shape": "S10"
					}
				}
			},
			"S19": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"value"
					],
					"members": {
						"value": {},
						"synonyms": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S24": {
				"type": "map",
				"key": {},
				"value": {},
				"sensitive": true
			},
			"S2d": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"status": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {}
					}
				}
			},
			"S2j": {
				"type": "list",
				"member": {}
			},
			"S3a": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {}
					}
				}
			},
			"S3i": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"lastUpdatedDate": {
							"type": "timestamp"
						},
						"createdDate": {
							"type": "timestamp"
						},
						"version": {}
					}
				}
			}
		}
	};

/***/ },
/* 1777 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetBotAliases": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetBotChannelAssociations": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetBotVersions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetBots": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetBuiltinIntents": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetBuiltinSlotTypes": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetIntentVersions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetIntents": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetSlotTypeVersions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			},
			"GetSlotTypes": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults"
			}
		}
	};

/***/ },
/* 1778 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-03-28",
			"endpointPrefix": "logs",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon CloudWatch Logs",
			"serviceId": "CloudWatch Logs",
			"signatureVersion": "v4",
			"targetPrefix": "Logs_20140328",
			"uid": "logs-2014-03-28"
		},
		"operations": {
			"AssociateKmsKey": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"kmsKeyId"
					],
					"members": {
						"logGroupName": {},
						"kmsKeyId": {}
					}
				}
			},
			"CancelExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {}
					}
				}
			},
			"CreateExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"from",
						"to",
						"destination"
					],
					"members": {
						"taskName": {},
						"logGroupName": {},
						"logStreamNamePrefix": {},
						"from": {
							"type": "long"
						},
						"to": {
							"type": "long"
						},
						"destination": {},
						"destinationPrefix": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskId": {}
					}
				}
			},
			"CreateLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"kmsKeyId": {},
						"tags": {
							"shape": "Se"
						}
					}
				}
			},
			"CreateLogStream": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {}
					}
				}
			},
			"DeleteDestination": {
				"input": {
					"type": "structure",
					"required": [
						"destinationName"
					],
					"members": {
						"destinationName": {}
					}
				}
			},
			"DeleteLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {}
					}
				}
			},
			"DeleteLogStream": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {}
					}
				}
			},
			"DeleteMetricFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName"
					],
					"members": {
						"logGroupName": {},
						"filterName": {}
					}
				}
			},
			"DeleteResourcePolicy": {
				"input": {
					"type": "structure",
					"members": {
						"policyName": {}
					}
				}
			},
			"DeleteRetentionPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {}
					}
				}
			},
			"DeleteSubscriptionFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName"
					],
					"members": {
						"logGroupName": {},
						"filterName": {}
					}
				}
			},
			"DescribeDestinations": {
				"input": {
					"type": "structure",
					"members": {
						"DestinationNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"destinations": {
							"type": "list",
							"member": {
								"shape": "Sx"
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeExportTasks": {
				"input": {
					"type": "structure",
					"members": {
						"taskId": {},
						"statusCode": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"exportTasks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"taskId": {},
									"taskName": {},
									"logGroupName": {},
									"from": {
										"type": "long"
									},
									"to": {
										"type": "long"
									},
									"destination": {},
									"destinationPrefix": {},
									"status": {
										"type": "structure",
										"members": {
											"code": {},
											"message": {}
										}
									},
									"executionInfo": {
										"type": "structure",
										"members": {
											"creationTime": {
												"type": "long"
											},
											"completionTime": {
												"type": "long"
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeLogGroups": {
				"input": {
					"type": "structure",
					"members": {
						"logGroupNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"logGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logGroupName": {},
									"creationTime": {
										"type": "long"
									},
									"retentionInDays": {
										"type": "integer"
									},
									"metricFilterCount": {
										"type": "integer"
									},
									"arn": {},
									"storedBytes": {
										"type": "long"
									},
									"kmsKeyId": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeLogStreams": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"logStreamNamePrefix": {},
						"orderBy": {},
						"descending": {
							"type": "boolean"
						},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"logStreams": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logStreamName": {},
									"creationTime": {
										"type": "long"
									},
									"firstEventTimestamp": {
										"type": "long"
									},
									"lastEventTimestamp": {
										"type": "long"
									},
									"lastIngestionTime": {
										"type": "long"
									},
									"uploadSequenceToken": {},
									"arn": {},
									"storedBytes": {
										"deprecated": true,
										"deprecatedMessage": "Starting on June 17, 2019, this parameter will be deprecated for log streams, and will be reported as zero. This change applies only to log streams. The storedBytes parameter for log groups is not affected.",
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeMetricFilters": {
				"input": {
					"type": "structure",
					"members": {
						"logGroupName": {},
						"filterNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						},
						"metricName": {},
						"metricNamespace": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"metricFilters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"filterName": {},
									"filterPattern": {},
									"metricTransformations": {
										"shape": "S1v"
									},
									"creationTime": {
										"type": "long"
									},
									"logGroupName": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeQueries": {
				"input": {
					"type": "structure",
					"members": {
						"logGroupName": {},
						"status": {},
						"maxResults": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"queries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"queryId": {},
									"queryString": {},
									"status": {},
									"createTime": {
										"type": "long"
									},
									"logGroupName": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeResourcePolicies": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"resourcePolicies": {
							"type": "list",
							"member": {
								"shape": "S2a"
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeSubscriptionFilters": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"filterNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"subscriptionFilters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"filterName": {},
									"logGroupName": {},
									"filterPattern": {},
									"destinationArn": {},
									"roleArn": {},
									"distribution": {},
									"creationTime": {
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DisassociateKmsKey": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {}
					}
				}
			},
			"FilterLogEvents": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"logStreamNames": {
							"type": "list",
							"member": {}
						},
						"logStreamNamePrefix": {},
						"startTime": {
							"type": "long"
						},
						"endTime": {
							"type": "long"
						},
						"filterPattern": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						},
						"interleaved": {
							"deprecated": true,
							"deprecatedMessage": "Starting on June 17, 2019, this parameter will be ignored and the value will be assumed to be true. The response from this operation will always interleave events from multiple log streams within a log group.",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logStreamName": {},
									"timestamp": {
										"type": "long"
									},
									"message": {},
									"ingestionTime": {
										"type": "long"
									},
									"eventId": {}
								}
							}
						},
						"searchedLogStreams": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logStreamName": {},
									"searchedCompletely": {
										"type": "boolean"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetLogEvents": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {},
						"startTime": {
							"type": "long"
						},
						"endTime": {
							"type": "long"
						},
						"nextToken": {},
						"limit": {
							"type": "integer"
						},
						"startFromHead": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"timestamp": {
										"type": "long"
									},
									"message": {},
									"ingestionTime": {
										"type": "long"
									}
								}
							}
						},
						"nextForwardToken": {},
						"nextBackwardToken": {}
					}
				}
			},
			"GetLogGroupFields": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"time": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"logGroupFields": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"percent": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"GetLogRecord": {
				"input": {
					"type": "structure",
					"required": [
						"logRecordPointer"
					],
					"members": {
						"logRecordPointer": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"logRecord": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"GetQueryResults": {
				"input": {
					"type": "structure",
					"required": [
						"queryId"
					],
					"members": {
						"queryId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"results": {
							"type": "list",
							"member": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"field": {},
										"value": {}
									}
								}
							}
						},
						"statistics": {
							"type": "structure",
							"members": {
								"recordsMatched": {
									"type": "double"
								},
								"recordsScanned": {
									"type": "double"
								},
								"bytesScanned": {
									"type": "double"
								}
							}
						},
						"status": {}
					}
				}
			},
			"ListTagsLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "Se"
						}
					}
				}
			},
			"PutDestination": {
				"input": {
					"type": "structure",
					"required": [
						"destinationName",
						"targetArn",
						"roleArn"
					],
					"members": {
						"destinationName": {},
						"targetArn": {},
						"roleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"destination": {
							"shape": "Sx"
						}
					}
				}
			},
			"PutDestinationPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"destinationName",
						"accessPolicy"
					],
					"members": {
						"destinationName": {},
						"accessPolicy": {}
					}
				}
			},
			"PutLogEvents": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName",
						"logEvents"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {},
						"logEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"timestamp",
									"message"
								],
								"members": {
									"timestamp": {
										"type": "long"
									},
									"message": {}
								}
							}
						},
						"sequenceToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"nextSequenceToken": {},
						"rejectedLogEventsInfo": {
							"type": "structure",
							"members": {
								"tooNewLogEventStartIndex": {
									"type": "integer"
								},
								"tooOldLogEventEndIndex": {
									"type": "integer"
								},
								"expiredLogEventEndIndex": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"PutMetricFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName",
						"filterPattern",
						"metricTransformations"
					],
					"members": {
						"logGroupName": {},
						"filterName": {},
						"filterPattern": {},
						"metricTransformations": {
							"shape": "S1v"
						}
					}
				}
			},
			"PutResourcePolicy": {
				"input": {
					"type": "structure",
					"members": {
						"policyName": {},
						"policyDocument": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"resourcePolicy": {
							"shape": "S2a"
						}
					}
				}
			},
			"PutRetentionPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"retentionInDays"
					],
					"members": {
						"logGroupName": {},
						"retentionInDays": {
							"type": "integer"
						}
					}
				}
			},
			"PutSubscriptionFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName",
						"filterPattern",
						"destinationArn"
					],
					"members": {
						"logGroupName": {},
						"filterName": {},
						"filterPattern": {},
						"destinationArn": {},
						"roleArn": {},
						"distribution": {}
					}
				}
			},
			"StartQuery": {
				"input": {
					"type": "structure",
					"required": [
						"startTime",
						"endTime",
						"queryString"
					],
					"members": {
						"logGroupName": {},
						"logGroupNames": {
							"type": "list",
							"member": {}
						},
						"startTime": {
							"type": "long"
						},
						"endTime": {
							"type": "long"
						},
						"queryString": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"queryId": {}
					}
				}
			},
			"StopQuery": {
				"input": {
					"type": "structure",
					"required": [
						"queryId"
					],
					"members": {
						"queryId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"success": {
							"type": "boolean"
						}
					}
				}
			},
			"TagLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"tags"
					],
					"members": {
						"logGroupName": {},
						"tags": {
							"shape": "Se"
						}
					}
				}
			},
			"TestMetricFilter": {
				"input": {
					"type": "structure",
					"required": [
						"filterPattern",
						"logEventMessages"
					],
					"members": {
						"filterPattern": {},
						"logEventMessages": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"matches": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"eventNumber": {
										"type": "long"
									},
									"eventMessage": {},
									"extractedValues": {
										"type": "map",
										"key": {},
										"value": {}
									}
								}
							}
						}
					}
				}
			},
			"UntagLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"tags"
					],
					"members": {
						"logGroupName": {},
						"tags": {
							"type": "list",
							"member": {}
						}
					}
				}
			}
		},
		"shapes": {
			"Se": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"destinationName": {},
					"targetArn": {},
					"roleArn": {},
					"accessPolicy": {},
					"arn": {},
					"creationTime": {
						"type": "long"
					}
				}
			},
			"S1v": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"metricName",
						"metricNamespace",
						"metricValue"
					],
					"members": {
						"metricName": {},
						"metricNamespace": {},
						"metricValue": {},
						"defaultValue": {
							"type": "double"
						}
					}
				}
			},
			"S2a": {
				"type": "structure",
				"members": {
					"policyName": {},
					"policyDocument": {},
					"lastUpdatedTime": {
						"type": "long"
					}
				}
			}
		}
	};

/***/ },
/* 1779 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDestinations": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": "destinations"
			},
			"DescribeLogGroups": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": "logGroups"
			},
			"DescribeLogStreams": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": "logStreams"
			},
			"DescribeMetricFilters": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": "metricFilters"
			},
			"DescribeSubscriptionFilters": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": "subscriptionFilters"
			},
			"FilterLogEvents": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": [
					"events",
					"searchedLogStreams"
				]
			},
			"GetLogEvents": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextForwardToken",
				"result_key": "events"
			}
		}
	};

/***/ },
/* 1780 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "machinelearning-2014-12-12",
			"apiVersion": "2014-12-12",
			"endpointPrefix": "machinelearning",
			"jsonVersion": "1.1",
			"serviceFullName": "Amazon Machine Learning",
			"serviceId": "Machine Learning",
			"signatureVersion": "v4",
			"targetPrefix": "AmazonML_20141212",
			"protocol": "json"
		},
		"operations": {
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"Tags",
						"ResourceId",
						"ResourceType"
					],
					"members": {
						"Tags": {
							"shape": "S2"
						},
						"ResourceId": {},
						"ResourceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {}
					}
				}
			},
			"CreateBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId",
						"MLModelId",
						"BatchPredictionDataSourceId",
						"OutputUri"
					],
					"members": {
						"BatchPredictionId": {},
						"BatchPredictionName": {},
						"MLModelId": {},
						"BatchPredictionDataSourceId": {},
						"OutputUri": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {}
					}
				}
			},
			"CreateDataSourceFromRDS": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"RDSData",
						"RoleARN"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {},
						"RDSData": {
							"type": "structure",
							"required": [
								"DatabaseInformation",
								"SelectSqlQuery",
								"DatabaseCredentials",
								"S3StagingLocation",
								"ResourceRole",
								"ServiceRole",
								"SubnetId",
								"SecurityGroupIds"
							],
							"members": {
								"DatabaseInformation": {
									"shape": "Sf"
								},
								"SelectSqlQuery": {},
								"DatabaseCredentials": {
									"type": "structure",
									"required": [
										"Username",
										"Password"
									],
									"members": {
										"Username": {},
										"Password": {}
									}
								},
								"S3StagingLocation": {},
								"DataRearrangement": {},
								"DataSchema": {},
								"DataSchemaUri": {},
								"ResourceRole": {},
								"ServiceRole": {},
								"SubnetId": {},
								"SecurityGroupIds": {
									"type": "list",
									"member": {}
								}
							}
						},
						"RoleARN": {},
						"ComputeStatistics": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"CreateDataSourceFromRedshift": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"DataSpec",
						"RoleARN"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {},
						"DataSpec": {
							"type": "structure",
							"required": [
								"DatabaseInformation",
								"SelectSqlQuery",
								"DatabaseCredentials",
								"S3StagingLocation"
							],
							"members": {
								"DatabaseInformation": {
									"shape": "Sy"
								},
								"SelectSqlQuery": {},
								"DatabaseCredentials": {
									"type": "structure",
									"required": [
										"Username",
										"Password"
									],
									"members": {
										"Username": {},
										"Password": {}
									}
								},
								"S3StagingLocation": {},
								"DataRearrangement": {},
								"DataSchema": {},
								"DataSchemaUri": {}
							}
						},
						"RoleARN": {},
						"ComputeStatistics": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"CreateDataSourceFromS3": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"DataSpec"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {},
						"DataSpec": {
							"type": "structure",
							"required": [
								"DataLocationS3"
							],
							"members": {
								"DataLocationS3": {},
								"DataRearrangement": {},
								"DataSchema": {},
								"DataSchemaLocationS3": {}
							}
						},
						"ComputeStatistics": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"CreateEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId",
						"MLModelId",
						"EvaluationDataSourceId"
					],
					"members": {
						"EvaluationId": {},
						"EvaluationName": {},
						"MLModelId": {},
						"EvaluationDataSourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {}
					}
				}
			},
			"CreateMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId",
						"MLModelType",
						"TrainingDataSourceId"
					],
					"members": {
						"MLModelId": {},
						"MLModelName": {},
						"MLModelType": {},
						"Parameters": {
							"shape": "S1d"
						},
						"TrainingDataSourceId": {},
						"Recipe": {},
						"RecipeUri": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {}
					}
				}
			},
			"CreateRealtimeEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {},
						"RealtimeEndpointInfo": {
							"shape": "S1j"
						}
					}
				}
			},
			"DeleteBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId"
					],
					"members": {
						"BatchPredictionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {}
					}
				}
			},
			"DeleteDataSource": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId"
					],
					"members": {
						"DataSourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"DeleteEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId"
					],
					"members": {
						"EvaluationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {}
					}
				}
			},
			"DeleteMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {}
					}
				}
			},
			"DeleteRealtimeEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {},
						"RealtimeEndpointInfo": {
							"shape": "S1j"
						}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"TagKeys",
						"ResourceId",
						"ResourceType"
					],
					"members": {
						"TagKeys": {
							"type": "list",
							"member": {}
						},
						"ResourceId": {},
						"ResourceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {}
					}
				}
			},
			"DescribeBatchPredictions": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"BatchPredictionId": {},
									"MLModelId": {},
									"BatchPredictionDataSourceId": {},
									"InputDataLocationS3": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"Name": {},
									"Status": {},
									"OutputUri": {},
									"Message": {},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									},
									"TotalRecordCount": {
										"type": "long"
									},
									"InvalidRecordCount": {
										"type": "long"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeDataSources": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DataSourceId": {},
									"DataLocationS3": {},
									"DataRearrangement": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"DataSizeInBytes": {
										"type": "long"
									},
									"NumberOfFiles": {
										"type": "long"
									},
									"Name": {},
									"Status": {},
									"Message": {},
									"RedshiftMetadata": {
										"shape": "S2i"
									},
									"RDSMetadata": {
										"shape": "S2j"
									},
									"RoleARN": {},
									"ComputeStatistics": {
										"type": "boolean"
									},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeEvaluations": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EvaluationId": {},
									"MLModelId": {},
									"EvaluationDataSourceId": {},
									"InputDataLocationS3": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"Name": {},
									"Status": {},
									"PerformanceMetrics": {
										"shape": "S2q"
									},
									"Message": {},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMLModels": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"MLModelId": {},
									"TrainingDataSourceId": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"Name": {},
									"Status": {},
									"SizeInBytes": {
										"type": "long"
									},
									"EndpointInfo": {
										"shape": "S1j"
									},
									"TrainingParameters": {
										"shape": "S1d"
									},
									"InputDataLocationS3": {},
									"Algorithm": {},
									"MLModelType": {},
									"ScoreThreshold": {
										"type": "float"
									},
									"ScoreThresholdLastUpdatedAt": {
										"type": "timestamp"
									},
									"Message": {},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"ResourceType"
					],
					"members": {
						"ResourceId": {},
						"ResourceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {},
						"Tags": {
							"shape": "S2"
						}
					}
				}
			},
			"GetBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId"
					],
					"members": {
						"BatchPredictionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {},
						"MLModelId": {},
						"BatchPredictionDataSourceId": {},
						"InputDataLocationS3": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"Name": {},
						"Status": {},
						"OutputUri": {},
						"LogUri": {},
						"Message": {},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						},
						"TotalRecordCount": {
							"type": "long"
						},
						"InvalidRecordCount": {
							"type": "long"
						}
					}
				}
			},
			"GetDataSource": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId"
					],
					"members": {
						"DataSourceId": {},
						"Verbose": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {},
						"DataLocationS3": {},
						"DataRearrangement": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"DataSizeInBytes": {
							"type": "long"
						},
						"NumberOfFiles": {
							"type": "long"
						},
						"Name": {},
						"Status": {},
						"LogUri": {},
						"Message": {},
						"RedshiftMetadata": {
							"shape": "S2i"
						},
						"RDSMetadata": {
							"shape": "S2j"
						},
						"RoleARN": {},
						"ComputeStatistics": {
							"type": "boolean"
						},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						},
						"DataSourceSchema": {}
					}
				}
			},
			"GetEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId"
					],
					"members": {
						"EvaluationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {},
						"MLModelId": {},
						"EvaluationDataSourceId": {},
						"InputDataLocationS3": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"Name": {},
						"Status": {},
						"PerformanceMetrics": {
							"shape": "S2q"
						},
						"LogUri": {},
						"Message": {},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {},
						"Verbose": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {},
						"TrainingDataSourceId": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"Name": {},
						"Status": {},
						"SizeInBytes": {
							"type": "long"
						},
						"EndpointInfo": {
							"shape": "S1j"
						},
						"TrainingParameters": {
							"shape": "S1d"
						},
						"InputDataLocationS3": {},
						"MLModelType": {},
						"ScoreThreshold": {
							"type": "float"
						},
						"ScoreThresholdLastUpdatedAt": {
							"type": "timestamp"
						},
						"LogUri": {},
						"Message": {},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						},
						"Recipe": {},
						"Schema": {}
					}
				}
			},
			"Predict": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId",
						"Record",
						"PredictEndpoint"
					],
					"members": {
						"MLModelId": {},
						"Record": {
							"type": "map",
							"key": {},
							"value": {}
						},
						"PredictEndpoint": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Prediction": {
							"type": "structure",
							"members": {
								"predictedLabel": {},
								"predictedValue": {
									"type": "float"
								},
								"predictedScores": {
									"type": "map",
									"key": {},
									"value": {
										"type": "float"
									}
								},
								"details": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						}
					}
				}
			},
			"UpdateBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId",
						"BatchPredictionName"
					],
					"members": {
						"BatchPredictionId": {},
						"BatchPredictionName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {}
					}
				}
			},
			"UpdateDataSource": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"DataSourceName"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"UpdateEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId",
						"EvaluationName"
					],
					"members": {
						"EvaluationId": {},
						"EvaluationName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {}
					}
				}
			},
			"UpdateMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {},
						"MLModelName": {},
						"ScoreThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sf": {
				"type": "structure",
				"required": [
					"InstanceIdentifier",
					"DatabaseName"
				],
				"members": {
					"InstanceIdentifier": {},
					"DatabaseName": {}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"DatabaseName",
					"ClusterIdentifier"
				],
				"members": {
					"DatabaseName": {},
					"ClusterIdentifier": {}
				}
			},
			"S1d": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"PeakRequestsPerSecond": {
						"type": "integer"
					},
					"CreatedAt": {
						"type": "timestamp"
					},
					"EndpointUrl": {},
					"EndpointStatus": {}
				}
			},
			"S2i": {
				"type": "structure",
				"members": {
					"RedshiftDatabase": {
						"shape": "Sy"
					},
					"DatabaseUserName": {},
					"SelectSqlQuery": {}
				}
			},
			"S2j": {
				"type": "structure",
				"members": {
					"Database": {
						"shape": "Sf"
					},
					"DatabaseUserName": {},
					"SelectSqlQuery": {},
					"ResourceRole": {},
					"ServiceRole": {},
					"DataPipelineId": {}
				}
			},
			"S2q": {
				"type": "structure",
				"members": {
					"Properties": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			}
		},
		"examples": {}
	};

/***/ },
/* 1781 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeBatchPredictions": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			},
			"DescribeDataSources": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			},
			"DescribeEvaluations": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			},
			"DescribeMLModels": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			}
		}
	};

/***/ },
/* 1782 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DataSourceAvailable": {
				"delay": 30,
				"operation": "DescribeDataSources",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			},
			"MLModelAvailable": {
				"delay": 30,
				"operation": "DescribeMLModels",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			},
			"EvaluationAvailable": {
				"delay": 30,
				"operation": "DescribeEvaluations",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			},
			"BatchPredictionAvailable": {
				"delay": 30,
				"operation": "DescribeBatchPredictions",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			}
		}
	};

/***/ },
/* 1783 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-07-01",
			"endpointPrefix": "marketplacecommerceanalytics",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Marketplace Commerce Analytics",
			"serviceId": "Marketplace Commerce Analytics",
			"signatureVersion": "v4",
			"signingName": "marketplacecommerceanalytics",
			"targetPrefix": "MarketplaceCommerceAnalytics20150701",
			"uid": "marketplacecommerceanalytics-2015-07-01"
		},
		"operations": {
			"GenerateDataSet": {
				"input": {
					"type": "structure",
					"required": [
						"dataSetType",
						"dataSetPublicationDate",
						"roleNameArn",
						"destinationS3BucketName",
						"snsTopicArn"
					],
					"members": {
						"dataSetType": {},
						"dataSetPublicationDate": {
							"type": "timestamp"
						},
						"roleNameArn": {},
						"destinationS3BucketName": {},
						"destinationS3Prefix": {},
						"snsTopicArn": {},
						"customerDefinedValues": {
							"shape": "S8"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"dataSetRequestId": {}
					}
				}
			},
			"StartSupportDataExport": {
				"input": {
					"type": "structure",
					"required": [
						"dataSetType",
						"fromDate",
						"roleNameArn",
						"destinationS3BucketName",
						"snsTopicArn"
					],
					"members": {
						"dataSetType": {},
						"fromDate": {
							"type": "timestamp"
						},
						"roleNameArn": {},
						"destinationS3BucketName": {},
						"destinationS3Prefix": {},
						"snsTopicArn": {},
						"customerDefinedValues": {
							"shape": "S8"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"dataSetRequestId": {}
					}
				}
			}
		},
		"shapes": {
			"S8": {
				"type": "map",
				"key": {},
				"value": {}
			}
		}
	};

/***/ },
/* 1784 */
1641,
/* 1785 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-09-01",
			"endpointPrefix": "data.mediastore",
			"protocol": "rest-json",
			"serviceAbbreviation": "MediaStore Data",
			"serviceFullName": "AWS Elemental MediaStore Data Plane",
			"serviceId": "MediaStore Data",
			"signatureVersion": "v4",
			"signingName": "mediastore",
			"uid": "mediastore-data-2017-09-01"
		},
		"operations": {
			"DeleteObject": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Path+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Path"
					],
					"members": {
						"Path": {
							"location": "uri",
							"locationName": "Path"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeObject": {
				"http": {
					"method": "HEAD",
					"requestUri": "/{Path+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Path"
					],
					"members": {
						"Path": {
							"location": "uri",
							"locationName": "Path"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						}
					}
				}
			},
			"GetObject": {
				"http": {
					"method": "GET",
					"requestUri": "/{Path+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Path"
					],
					"members": {
						"Path": {
							"location": "uri",
							"locationName": "Path"
						},
						"Range": {
							"location": "header",
							"locationName": "Range"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StatusCode"
					],
					"members": {
						"Body": {
							"shape": "Se"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentRange": {
							"location": "header",
							"locationName": "Content-Range"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						},
						"StatusCode": {
							"location": "statusCode",
							"type": "integer"
						}
					},
					"payload": "Body"
				}
			},
			"ListItems": {
				"http": {
					"method": "GET"
				},
				"input": {
					"type": "structure",
					"members": {
						"Path": {
							"location": "querystring",
							"locationName": "Path"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "MaxResults",
							"type": "integer"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "NextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Type": {},
									"ETag": {},
									"LastModified": {
										"type": "timestamp"
									},
									"ContentType": {},
									"ContentLength": {
										"type": "long"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutObject": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Path+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Body",
						"Path"
					],
					"members": {
						"Body": {
							"shape": "Se"
						},
						"Path": {
							"location": "uri",
							"locationName": "Path"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"UploadAvailability": {
							"location": "header",
							"locationName": "x-amz-upload-availability"
						}
					},
					"payload": "Body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ContentSHA256": {},
						"ETag": {},
						"StorageClass": {}
					}
				},
				"authtype": "v4-unsigned-body"
			}
		},
		"shapes": {
			"Se": {
				"type": "blob",
				"streaming": true
			}
		}
	};

/***/ },
/* 1786 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListItems": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1787 */
/***/ function(module, exports) {

	module.exports = {
		"acm": {
			"name": "ACM",
			"cors": true
		},
		"apigateway": {
			"name": "APIGateway",
			"cors": true
		},
		"applicationautoscaling": {
			"prefix": "application-autoscaling",
			"name": "ApplicationAutoScaling",
			"cors": true
		},
		"appstream": {
			"name": "AppStream"
		},
		"autoscaling": {
			"name": "AutoScaling",
			"cors": true
		},
		"batch": {
			"name": "Batch"
		},
		"budgets": {
			"name": "Budgets"
		},
		"clouddirectory": {
			"name": "CloudDirectory",
			"versions": [
				"2016-05-10*"
			]
		},
		"cloudformation": {
			"name": "CloudFormation",
			"cors": true
		},
		"cloudfront": {
			"name": "CloudFront",
			"versions": [
				"2013-05-12*",
				"2013-11-11*",
				"2014-05-31*",
				"2014-10-21*",
				"2014-11-06*",
				"2015-04-17*",
				"2015-07-27*",
				"2015-09-17*",
				"2016-01-13*",
				"2016-01-28*",
				"2016-08-01*",
				"2016-08-20*",
				"2016-09-07*",
				"2016-09-29*",
				"2016-11-25*",
				"2017-03-25*",
				"2017-10-30*",
				"2018-06-18*",
				"2018-11-05*"
			],
			"cors": true
		},
		"cloudhsm": {
			"name": "CloudHSM",
			"cors": true
		},
		"cloudsearch": {
			"name": "CloudSearch"
		},
		"cloudsearchdomain": {
			"name": "CloudSearchDomain"
		},
		"cloudtrail": {
			"name": "CloudTrail",
			"cors": true
		},
		"cloudwatch": {
			"prefix": "monitoring",
			"name": "CloudWatch",
			"cors": true
		},
		"cloudwatchevents": {
			"prefix": "events",
			"name": "CloudWatchEvents",
			"versions": [
				"2014-02-03*"
			],
			"cors": true
		},
		"cloudwatchlogs": {
			"prefix": "logs",
			"name": "CloudWatchLogs",
			"cors": true
		},
		"codebuild": {
			"name": "CodeBuild",
			"cors": true
		},
		"codecommit": {
			"name": "CodeCommit",
			"cors": true
		},
		"codedeploy": {
			"name": "CodeDeploy",
			"cors": true
		},
		"codepipeline": {
			"name": "CodePipeline",
			"cors": true
		},
		"cognitoidentity": {
			"prefix": "cognito-identity",
			"name": "CognitoIdentity",
			"cors": true
		},
		"cognitoidentityserviceprovider": {
			"prefix": "cognito-idp",
			"name": "CognitoIdentityServiceProvider",
			"cors": true
		},
		"cognitosync": {
			"prefix": "cognito-sync",
			"name": "CognitoSync",
			"cors": true
		},
		"configservice": {
			"prefix": "config",
			"name": "ConfigService",
			"cors": true
		},
		"cur": {
			"name": "CUR",
			"cors": true
		},
		"datapipeline": {
			"name": "DataPipeline"
		},
		"devicefarm": {
			"name": "DeviceFarm",
			"cors": true
		},
		"directconnect": {
			"name": "DirectConnect",
			"cors": true
		},
		"directoryservice": {
			"prefix": "ds",
			"name": "DirectoryService"
		},
		"discovery": {
			"name": "Discovery"
		},
		"dms": {
			"name": "DMS"
		},
		"dynamodb": {
			"name": "DynamoDB",
			"cors": true
		},
		"dynamodbstreams": {
			"prefix": "streams.dynamodb",
			"name": "DynamoDBStreams",
			"cors": true
		},
		"ec2": {
			"name": "EC2",
			"versions": [
				"2013-06-15*",
				"2013-10-15*",
				"2014-02-01*",
				"2014-05-01*",
				"2014-06-15*",
				"2014-09-01*",
				"2014-10-01*",
				"2015-03-01*",
				"2015-04-15*",
				"2015-10-01*",
				"2016-04-01*",
				"2016-09-15*"
			],
			"cors": true
		},
		"ecr": {
			"name": "ECR",
			"cors": true
		},
		"ecs": {
			"name": "ECS",
			"cors": true
		},
		"efs": {
			"prefix": "elasticfilesystem",
			"name": "EFS",
			"cors": true
		},
		"elasticache": {
			"name": "ElastiCache",
			"versions": [
				"2012-11-15*",
				"2014-03-24*",
				"2014-07-15*",
				"2014-09-30*"
			],
			"cors": true
		},
		"elasticbeanstalk": {
			"name": "ElasticBeanstalk",
			"cors": true
		},
		"elb": {
			"prefix": "elasticloadbalancing",
			"name": "ELB",
			"cors": true
		},
		"elbv2": {
			"prefix": "elasticloadbalancingv2",
			"name": "ELBv2",
			"cors": true
		},
		"emr": {
			"prefix": "elasticmapreduce",
			"name": "EMR",
			"cors": true
		},
		"es": {
			"name": "ES"
		},
		"elastictranscoder": {
			"name": "ElasticTranscoder",
			"cors": true
		},
		"firehose": {
			"name": "Firehose",
			"cors": true
		},
		"gamelift": {
			"name": "GameLift",
			"cors": true
		},
		"glacier": {
			"name": "Glacier"
		},
		"health": {
			"name": "Health"
		},
		"iam": {
			"name": "IAM",
			"cors": true
		},
		"importexport": {
			"name": "ImportExport"
		},
		"inspector": {
			"name": "Inspector",
			"versions": [
				"2015-08-18*"
			],
			"cors": true
		},
		"iot": {
			"name": "Iot",
			"cors": true
		},
		"iotdata": {
			"prefix": "iot-data",
			"name": "IotData",
			"cors": true
		},
		"kinesis": {
			"name": "Kinesis",
			"cors": true
		},
		"kinesisanalytics": {
			"name": "KinesisAnalytics"
		},
		"kms": {
			"name": "KMS",
			"cors": true
		},
		"lambda": {
			"name": "Lambda",
			"cors": true
		},
		"lexruntime": {
			"prefix": "runtime.lex",
			"name": "LexRuntime",
			"cors": true
		},
		"lightsail": {
			"name": "Lightsail"
		},
		"machinelearning": {
			"name": "MachineLearning",
			"cors": true
		},
		"marketplacecommerceanalytics": {
			"name": "MarketplaceCommerceAnalytics",
			"cors": true
		},
		"marketplacemetering": {
			"prefix": "meteringmarketplace",
			"name": "MarketplaceMetering"
		},
		"mturk": {
			"prefix": "mturk-requester",
			"name": "MTurk",
			"cors": true
		},
		"mobileanalytics": {
			"name": "MobileAnalytics",
			"cors": true
		},
		"opsworks": {
			"name": "OpsWorks",
			"cors": true
		},
		"opsworkscm": {
			"name": "OpsWorksCM"
		},
		"organizations": {
			"name": "Organizations"
		},
		"pinpoint": {
			"name": "Pinpoint"
		},
		"polly": {
			"name": "Polly",
			"cors": true
		},
		"rds": {
			"name": "RDS",
			"versions": [
				"2014-09-01*"
			],
			"cors": true
		},
		"redshift": {
			"name": "Redshift",
			"cors": true
		},
		"rekognition": {
			"name": "Rekognition",
			"cors": true
		},
		"resourcegroupstaggingapi": {
			"name": "ResourceGroupsTaggingAPI"
		},
		"route53": {
			"name": "Route53",
			"cors": true
		},
		"route53domains": {
			"name": "Route53Domains",
			"cors": true
		},
		"s3": {
			"name": "S3",
			"dualstackAvailable": true,
			"cors": true
		},
		"s3control": {
			"name": "S3Control",
			"dualstackAvailable": true
		},
		"servicecatalog": {
			"name": "ServiceCatalog",
			"cors": true
		},
		"ses": {
			"prefix": "email",
			"name": "SES",
			"cors": true
		},
		"shield": {
			"name": "Shield"
		},
		"simpledb": {
			"prefix": "sdb",
			"name": "SimpleDB"
		},
		"sms": {
			"name": "SMS"
		},
		"snowball": {
			"name": "Snowball"
		},
		"sns": {
			"name": "SNS",
			"cors": true
		},
		"sqs": {
			"name": "SQS",
			"cors": true
		},
		"ssm": {
			"name": "SSM",
			"cors": true
		},
		"storagegateway": {
			"name": "StorageGateway",
			"cors": true
		},
		"stepfunctions": {
			"prefix": "states",
			"name": "StepFunctions"
		},
		"sts": {
			"name": "STS",
			"cors": true
		},
		"support": {
			"name": "Support"
		},
		"swf": {
			"name": "SWF"
		},
		"xray": {
			"name": "XRay"
		},
		"waf": {
			"name": "WAF",
			"cors": true
		},
		"wafregional": {
			"prefix": "waf-regional",
			"name": "WAFRegional"
		},
		"workdocs": {
			"name": "WorkDocs",
			"cors": true
		},
		"workspaces": {
			"name": "WorkSpaces"
		},
		"codestar": {
			"name": "CodeStar"
		},
		"lexmodelbuildingservice": {
			"prefix": "lex-models",
			"name": "LexModelBuildingService",
			"cors": true
		},
		"marketplaceentitlementservice": {
			"prefix": "entitlement.marketplace",
			"name": "MarketplaceEntitlementService"
		},
		"athena": {
			"name": "Athena"
		},
		"greengrass": {
			"name": "Greengrass"
		},
		"dax": {
			"name": "DAX"
		},
		"migrationhub": {
			"prefix": "AWSMigrationHub",
			"name": "MigrationHub"
		},
		"cloudhsmv2": {
			"name": "CloudHSMV2"
		},
		"glue": {
			"name": "Glue"
		},
		"mobile": {
			"name": "Mobile"
		},
		"pricing": {
			"name": "Pricing",
			"cors": true
		},
		"costexplorer": {
			"prefix": "ce",
			"name": "CostExplorer",
			"cors": true
		},
		"mediaconvert": {
			"name": "MediaConvert"
		},
		"medialive": {
			"name": "MediaLive"
		},
		"mediapackage": {
			"name": "MediaPackage"
		},
		"mediastore": {
			"name": "MediaStore"
		},
		"mediastoredata": {
			"prefix": "mediastore-data",
			"name": "MediaStoreData",
			"cors": true
		},
		"appsync": {
			"name": "AppSync"
		},
		"guardduty": {
			"name": "GuardDuty"
		},
		"mq": {
			"name": "MQ"
		},
		"comprehend": {
			"name": "Comprehend",
			"cors": true
		},
		"iotjobsdataplane": {
			"prefix": "iot-jobs-data",
			"name": "IoTJobsDataPlane"
		},
		"kinesisvideoarchivedmedia": {
			"prefix": "kinesis-video-archived-media",
			"name": "KinesisVideoArchivedMedia",
			"cors": true
		},
		"kinesisvideomedia": {
			"prefix": "kinesis-video-media",
			"name": "KinesisVideoMedia",
			"cors": true
		},
		"kinesisvideo": {
			"name": "KinesisVideo",
			"cors": true
		},
		"sagemakerruntime": {
			"prefix": "runtime.sagemaker",
			"name": "SageMakerRuntime"
		},
		"sagemaker": {
			"name": "SageMaker"
		},
		"translate": {
			"name": "Translate",
			"cors": true
		},
		"resourcegroups": {
			"prefix": "resource-groups",
			"name": "ResourceGroups",
			"cors": true
		},
		"alexaforbusiness": {
			"name": "AlexaForBusiness"
		},
		"cloud9": {
			"name": "Cloud9"
		},
		"serverlessapplicationrepository": {
			"prefix": "serverlessrepo",
			"name": "ServerlessApplicationRepository"
		},
		"servicediscovery": {
			"name": "ServiceDiscovery"
		},
		"workmail": {
			"name": "WorkMail"
		},
		"autoscalingplans": {
			"prefix": "autoscaling-plans",
			"name": "AutoScalingPlans"
		},
		"transcribeservice": {
			"prefix": "transcribe",
			"name": "TranscribeService"
		},
		"connect": {
			"name": "Connect"
		},
		"acmpca": {
			"prefix": "acm-pca",
			"name": "ACMPCA"
		},
		"fms": {
			"name": "FMS"
		},
		"secretsmanager": {
			"name": "SecretsManager",
			"cors": true
		},
		"iotanalytics": {
			"name": "IoTAnalytics"
		},
		"iot1clickdevicesservice": {
			"prefix": "iot1click-devices",
			"name": "IoT1ClickDevicesService"
		},
		"iot1clickprojects": {
			"prefix": "iot1click-projects",
			"name": "IoT1ClickProjects"
		},
		"pi": {
			"name": "PI"
		},
		"neptune": {
			"name": "Neptune"
		},
		"mediatailor": {
			"name": "MediaTailor"
		},
		"eks": {
			"name": "EKS"
		},
		"macie": {
			"name": "Macie"
		},
		"dlm": {
			"name": "DLM"
		},
		"signer": {
			"name": "Signer"
		},
		"chime": {
			"name": "Chime"
		},
		"pinpointemail": {
			"prefix": "pinpoint-email",
			"name": "PinpointEmail"
		},
		"ram": {
			"name": "RAM"
		},
		"route53resolver": {
			"name": "Route53Resolver"
		},
		"pinpointsmsvoice": {
			"prefix": "sms-voice",
			"name": "PinpointSMSVoice"
		},
		"quicksight": {
			"name": "QuickSight"
		},
		"rdsdataservice": {
			"prefix": "rds-data",
			"name": "RDSDataService"
		},
		"amplify": {
			"name": "Amplify"
		},
		"datasync": {
			"name": "DataSync"
		},
		"robomaker": {
			"name": "RoboMaker"
		},
		"transfer": {
			"name": "Transfer"
		},
		"globalaccelerator": {
			"name": "GlobalAccelerator"
		},
		"comprehendmedical": {
			"name": "ComprehendMedical",
			"cors": true
		},
		"kinesisanalyticsv2": {
			"name": "KinesisAnalyticsV2"
		},
		"mediaconnect": {
			"name": "MediaConnect"
		},
		"fsx": {
			"name": "FSx"
		},
		"securityhub": {
			"name": "SecurityHub"
		},
		"appmesh": {
			"name": "AppMesh",
			"versions": [
				"2018-10-01*"
			]
		},
		"licensemanager": {
			"prefix": "license-manager",
			"name": "LicenseManager"
		},
		"kafka": {
			"name": "Kafka"
		},
		"apigatewaymanagementapi": {
			"name": "ApiGatewayManagementApi"
		},
		"apigatewayv2": {
			"name": "ApiGatewayV2"
		},
		"docdb": {
			"name": "DocDB"
		},
		"backup": {
			"name": "Backup"
		},
		"worklink": {
			"name": "WorkLink"
		},
		"textract": {
			"name": "Textract"
		},
		"managedblockchain": {
			"name": "ManagedBlockchain"
		},
		"mediapackagevod": {
			"prefix": "mediapackage-vod",
			"name": "MediaPackageVod"
		},
		"groundstation": {
			"name": "GroundStation"
		},
		"iotthingsgraph": {
			"name": "IoTThingsGraph"
		},
		"iotevents": {
			"name": "IoTEvents"
		},
		"ioteventsdata": {
			"prefix": "iotevents-data",
			"name": "IoTEventsData"
		},
		"personalize": {
			"name": "Personalize",
			"cors": true
		},
		"personalizeevents": {
			"prefix": "personalize-events",
			"name": "PersonalizeEvents",
			"cors": true
		},
		"personalizeruntime": {
			"prefix": "personalize-runtime",
			"name": "PersonalizeRuntime",
			"cors": true
		},
		"applicationinsights": {
			"prefix": "application-insights",
			"name": "ApplicationInsights"
		},
		"servicequotas": {
			"prefix": "service-quotas",
			"name": "ServiceQuotas"
		},
		"ec2instanceconnect": {
			"prefix": "ec2-instance-connect",
			"name": "EC2InstanceConnect"
		},
		"eventbridge": {
			"name": "EventBridge"
		},
		"lakeformation": {
			"name": "LakeFormation"
		}
	};

/***/ },
/* 1788 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-05",
			"endpointPrefix": "mobileanalytics",
			"serviceFullName": "Amazon Mobile Analytics",
			"serviceId": "Mobile Analytics",
			"signatureVersion": "v4",
			"protocol": "rest-json"
		},
		"operations": {
			"PutEvents": {
				"http": {
					"requestUri": "/2014-06-05/events",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"events",
						"clientContext"
					],
					"members": {
						"events": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"eventType",
									"timestamp"
								],
								"members": {
									"eventType": {},
									"timestamp": {},
									"session": {
										"type": "structure",
										"members": {
											"id": {},
											"duration": {
												"type": "long"
											},
											"startTimestamp": {},
											"stopTimestamp": {}
										}
									},
									"version": {},
									"attributes": {
										"type": "map",
										"key": {},
										"value": {}
									},
									"metrics": {
										"type": "map",
										"key": {},
										"value": {
											"type": "double"
										}
									}
								}
							}
						},
						"clientContext": {
							"location": "header",
							"locationName": "x-amz-Client-Context"
						},
						"clientContextEncoding": {
							"location": "header",
							"locationName": "x-amz-Client-Context-Encoding"
						}
					}
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 1789 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-08-01",
			"endpointPrefix": "monitoring",
			"protocol": "query",
			"serviceAbbreviation": "CloudWatch",
			"serviceFullName": "Amazon CloudWatch",
			"serviceId": "CloudWatch",
			"signatureVersion": "v4",
			"uid": "monitoring-2010-08-01",
			"xmlNamespace": "http://monitoring.amazonaws.com/doc/2010-08-01/"
		},
		"operations": {
			"DeleteAlarms": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmNames"
					],
					"members": {
						"AlarmNames": {
							"shape": "S2"
						}
					}
				}
			},
			"DeleteAnomalyDetector": {
				"input": {
					"type": "structure",
					"required": [
						"Namespace",
						"MetricName",
						"Stat"
					],
					"members": {
						"Namespace": {},
						"MetricName": {},
						"Dimensions": {
							"shape": "S7"
						},
						"Stat": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteAnomalyDetectorResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteDashboards": {
				"input": {
					"type": "structure",
					"required": [
						"DashboardNames"
					],
					"members": {
						"DashboardNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteDashboardsResult",
					"type": "structure",
					"members": {}
				}
			},
			"DescribeAlarmHistory": {
				"input": {
					"type": "structure",
					"members": {
						"AlarmName": {},
						"HistoryItemType": {},
						"StartDate": {
							"type": "timestamp"
						},
						"EndDate": {
							"type": "timestamp"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAlarmHistoryResult",
					"type": "structure",
					"members": {
						"AlarmHistoryItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AlarmName": {},
									"Timestamp": {
										"type": "timestamp"
									},
									"HistoryItemType": {},
									"HistorySummary": {},
									"HistoryData": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAlarms": {
				"input": {
					"type": "structure",
					"members": {
						"AlarmNames": {
							"shape": "S2"
						},
						"AlarmNamePrefix": {},
						"StateValue": {},
						"ActionPrefix": {},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAlarmsResult",
					"type": "structure",
					"members": {
						"MetricAlarms": {
							"shape": "Sw"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAlarmsForMetric": {
				"input": {
					"type": "structure",
					"required": [
						"MetricName",
						"Namespace"
					],
					"members": {
						"MetricName": {},
						"Namespace": {},
						"Statistic": {},
						"ExtendedStatistic": {},
						"Dimensions": {
							"shape": "S7"
						},
						"Period": {
							"type": "integer"
						},
						"Unit": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAlarmsForMetricResult",
					"type": "structure",
					"members": {
						"MetricAlarms": {
							"shape": "Sw"
						}
					}
				}
			},
			"DescribeAnomalyDetectors": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Namespace": {},
						"MetricName": {},
						"Dimensions": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeAnomalyDetectorsResult",
					"type": "structure",
					"members": {
						"AnomalyDetectors": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Namespace": {},
									"MetricName": {},
									"Dimensions": {
										"shape": "S7"
									},
									"Stat": {},
									"Configuration": {
										"shape": "S1u"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DisableAlarmActions": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmNames"
					],
					"members": {
						"AlarmNames": {
							"shape": "S2"
						}
					}
				}
			},
			"EnableAlarmActions": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmNames"
					],
					"members": {
						"AlarmNames": {
							"shape": "S2"
						}
					}
				}
			},
			"GetDashboard": {
				"input": {
					"type": "structure",
					"required": [
						"DashboardName"
					],
					"members": {
						"DashboardName": {}
					}
				},
				"output": {
					"resultWrapper": "GetDashboardResult",
					"type": "structure",
					"members": {
						"DashboardArn": {},
						"DashboardBody": {},
						"DashboardName": {}
					}
				}
			},
			"GetMetricData": {
				"input": {
					"type": "structure",
					"required": [
						"MetricDataQueries",
						"StartTime",
						"EndTime"
					],
					"members": {
						"MetricDataQueries": {
							"shape": "S1f"
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"NextToken": {},
						"ScanBy": {},
						"MaxDatapoints": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "GetMetricDataResult",
					"type": "structure",
					"members": {
						"MetricDataResults": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Label": {},
									"Timestamps": {
										"type": "list",
										"member": {
											"type": "timestamp"
										}
									},
									"Values": {
										"type": "list",
										"member": {
											"type": "double"
										}
									},
									"StatusCode": {},
									"Messages": {
										"shape": "S2e"
									}
								}
							}
						},
						"NextToken": {},
						"Messages": {
							"shape": "S2e"
						}
					}
				}
			},
			"GetMetricStatistics": {
				"input": {
					"type": "structure",
					"required": [
						"Namespace",
						"MetricName",
						"StartTime",
						"EndTime",
						"Period"
					],
					"members": {
						"Namespace": {},
						"MetricName": {},
						"Dimensions": {
							"shape": "S7"
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Period": {
							"type": "integer"
						},
						"Statistics": {
							"type": "list",
							"member": {}
						},
						"ExtendedStatistics": {
							"type": "list",
							"member": {}
						},
						"Unit": {}
					}
				},
				"output": {
					"resultWrapper": "GetMetricStatisticsResult",
					"type": "structure",
					"members": {
						"Label": {},
						"Datapoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "timestamp"
									},
									"SampleCount": {
										"type": "double"
									},
									"Average": {
										"type": "double"
									},
									"Sum": {
										"type": "double"
									},
									"Minimum": {
										"type": "double"
									},
									"Maximum": {
										"type": "double"
									},
									"Unit": {},
									"ExtendedStatistics": {
										"type": "map",
										"key": {},
										"value": {
											"type": "double"
										}
									}
								},
								"xmlOrder": [
									"Timestamp",
									"SampleCount",
									"Average",
									"Sum",
									"Minimum",
									"Maximum",
									"Unit",
									"ExtendedStatistics"
								]
							}
						}
					}
				}
			},
			"GetMetricWidgetImage": {
				"input": {
					"type": "structure",
					"required": [
						"MetricWidget"
					],
					"members": {
						"MetricWidget": {},
						"OutputFormat": {}
					}
				},
				"output": {
					"resultWrapper": "GetMetricWidgetImageResult",
					"type": "structure",
					"members": {
						"MetricWidgetImage": {
							"type": "blob"
						}
					}
				}
			},
			"ListDashboards": {
				"input": {
					"type": "structure",
					"members": {
						"DashboardNamePrefix": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListDashboardsResult",
					"type": "structure",
					"members": {
						"DashboardEntries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DashboardName": {},
									"DashboardArn": {},
									"LastModified": {
										"type": "timestamp"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListMetrics": {
				"input": {
					"type": "structure",
					"members": {
						"Namespace": {},
						"MetricName": {},
						"Dimensions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Name"
								],
								"members": {
									"Name": {},
									"Value": {}
								}
							}
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListMetricsResult",
					"type": "structure",
					"members": {
						"Metrics": {
							"type": "list",
							"member": {
								"shape": "S1j"
							}
						},
						"NextToken": {}
					},
					"xmlOrder": [
						"Metrics",
						"NextToken"
					]
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN"
					],
					"members": {
						"ResourceARN": {}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S39"
						}
					}
				}
			},
			"PutAnomalyDetector": {
				"input": {
					"type": "structure",
					"required": [
						"Namespace",
						"MetricName",
						"Stat"
					],
					"members": {
						"Namespace": {},
						"MetricName": {},
						"Dimensions": {
							"shape": "S7"
						},
						"Stat": {},
						"Configuration": {
							"shape": "S1u"
						}
					}
				},
				"output": {
					"resultWrapper": "PutAnomalyDetectorResult",
					"type": "structure",
					"members": {}
				}
			},
			"PutDashboard": {
				"input": {
					"type": "structure",
					"required": [
						"DashboardName",
						"DashboardBody"
					],
					"members": {
						"DashboardName": {},
						"DashboardBody": {}
					}
				},
				"output": {
					"resultWrapper": "PutDashboardResult",
					"type": "structure",
					"members": {
						"DashboardValidationMessages": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DataPath": {},
									"Message": {}
								}
							}
						}
					}
				}
			},
			"PutMetricAlarm": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmName",
						"EvaluationPeriods",
						"ComparisonOperator"
					],
					"members": {
						"AlarmName": {},
						"AlarmDescription": {},
						"ActionsEnabled": {
							"type": "boolean"
						},
						"OKActions": {
							"shape": "S11"
						},
						"AlarmActions": {
							"shape": "S11"
						},
						"InsufficientDataActions": {
							"shape": "S11"
						},
						"MetricName": {},
						"Namespace": {},
						"Statistic": {},
						"ExtendedStatistic": {},
						"Dimensions": {
							"shape": "S7"
						},
						"Period": {
							"type": "integer"
						},
						"Unit": {},
						"EvaluationPeriods": {
							"type": "integer"
						},
						"DatapointsToAlarm": {
							"type": "integer"
						},
						"Threshold": {
							"type": "double"
						},
						"ComparisonOperator": {},
						"TreatMissingData": {},
						"EvaluateLowSampleCountPercentile": {},
						"Metrics": {
							"shape": "S1f"
						},
						"Tags": {
							"shape": "S39"
						},
						"ThresholdMetricId": {}
					}
				}
			},
			"PutMetricData": {
				"input": {
					"type": "structure",
					"required": [
						"Namespace",
						"MetricData"
					],
					"members": {
						"Namespace": {},
						"MetricData": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"MetricName"
								],
								"members": {
									"MetricName": {},
									"Dimensions": {
										"shape": "S7"
									},
									"Timestamp": {
										"type": "timestamp"
									},
									"Value": {
										"type": "double"
									},
									"StatisticValues": {
										"type": "structure",
										"required": [
											"SampleCount",
											"Sum",
											"Minimum",
											"Maximum"
										],
										"members": {
											"SampleCount": {
												"type": "double"
											},
											"Sum": {
												"type": "double"
											},
											"Minimum": {
												"type": "double"
											},
											"Maximum": {
												"type": "double"
											}
										}
									},
									"Values": {
										"type": "list",
										"member": {
											"type": "double"
										}
									},
									"Counts": {
										"type": "list",
										"member": {
											"type": "double"
										}
									},
									"Unit": {},
									"StorageResolution": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"SetAlarmState": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmName",
						"StateValue",
						"StateReason"
					],
					"members": {
						"AlarmName": {},
						"StateValue": {},
						"StateReason": {},
						"StateReasonData": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"Tags"
					],
					"members": {
						"ResourceARN": {},
						"Tags": {
							"shape": "S39"
						}
					}
				},
				"output": {
					"resultWrapper": "TagResourceResult",
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"TagKeys"
					],
					"members": {
						"ResourceARN": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "UntagResourceResult",
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S7": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Value"
					],
					"members": {
						"Name": {},
						"Value": {}
					},
					"xmlOrder": [
						"Name",
						"Value"
					]
				}
			},
			"Sw": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"AlarmName": {},
						"AlarmArn": {},
						"AlarmDescription": {},
						"AlarmConfigurationUpdatedTimestamp": {
							"type": "timestamp"
						},
						"ActionsEnabled": {
							"type": "boolean"
						},
						"OKActions": {
							"shape": "S11"
						},
						"AlarmActions": {
							"shape": "S11"
						},
						"InsufficientDataActions": {
							"shape": "S11"
						},
						"StateValue": {},
						"StateReason": {},
						"StateReasonData": {},
						"StateUpdatedTimestamp": {
							"type": "timestamp"
						},
						"MetricName": {},
						"Namespace": {},
						"Statistic": {},
						"ExtendedStatistic": {},
						"Dimensions": {
							"shape": "S7"
						},
						"Period": {
							"type": "integer"
						},
						"Unit": {},
						"EvaluationPeriods": {
							"type": "integer"
						},
						"DatapointsToAlarm": {
							"type": "integer"
						},
						"Threshold": {
							"type": "double"
						},
						"ComparisonOperator": {},
						"TreatMissingData": {},
						"EvaluateLowSampleCountPercentile": {},
						"Metrics": {
							"shape": "S1f"
						},
						"ThresholdMetricId": {}
					},
					"xmlOrder": [
						"AlarmName",
						"AlarmArn",
						"AlarmDescription",
						"AlarmConfigurationUpdatedTimestamp",
						"ActionsEnabled",
						"OKActions",
						"AlarmActions",
						"InsufficientDataActions",
						"StateValue",
						"StateReason",
						"StateReasonData",
						"StateUpdatedTimestamp",
						"MetricName",
						"Namespace",
						"Statistic",
						"Dimensions",
						"Period",
						"Unit",
						"EvaluationPeriods",
						"Threshold",
						"ComparisonOperator",
						"ExtendedStatistic",
						"TreatMissingData",
						"EvaluateLowSampleCountPercentile",
						"DatapointsToAlarm",
						"Metrics",
						"ThresholdMetricId"
					]
				}
			},
			"S11": {
				"type": "list",
				"member": {}
			},
			"S1f": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {},
						"MetricStat": {
							"type": "structure",
							"required": [
								"Metric",
								"Period",
								"Stat"
							],
							"members": {
								"Metric": {
									"shape": "S1j"
								},
								"Period": {
									"type": "integer"
								},
								"Stat": {},
								"Unit": {}
							}
						},
						"Expression": {},
						"Label": {},
						"ReturnData": {
							"type": "boolean"
						}
					}
				}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"Namespace": {},
					"MetricName": {},
					"Dimensions": {
						"shape": "S7"
					}
				},
				"xmlOrder": [
					"Namespace",
					"MetricName",
					"Dimensions"
				]
			},
			"S1u": {
				"type": "structure",
				"members": {
					"ExcludedTimeRanges": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"StartTime",
								"EndTime"
							],
							"members": {
								"StartTime": {
									"type": "timestamp"
								},
								"EndTime": {
									"type": "timestamp"
								}
							},
							"xmlOrder": [
								"StartTime",
								"EndTime"
							]
						}
					},
					"MetricTimezone": {}
				}
			},
			"S2e": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Code": {},
						"Value": {}
					}
				}
			},
			"S39": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			}
		}
	};

/***/ },
/* 1790 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeAlarmHistory": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "AlarmHistoryItems"
			},
			"DescribeAlarms": {
				"input_token": "NextToken",
				"limit_key": "MaxRecords",
				"output_token": "NextToken",
				"result_key": "MetricAlarms"
			},
			"DescribeAlarmsForMetric": {
				"result_key": "MetricAlarms"
			},
			"GetMetricData": {
				"input_token": "NextToken",
				"limit_key": "MaxDatapoints",
				"output_token": "NextToken",
				"result_key": [
					"MetricDataResults",
					"Messages"
				]
			},
			"ListDashboards": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "DashboardEntries"
			},
			"ListMetrics": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Metrics"
			}
		}
	};

/***/ },
/* 1791 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"AlarmExists": {
				"delay": 5,
				"maxAttempts": 40,
				"operation": "DescribeAlarms",
				"acceptors": [
					{
						"matcher": "path",
						"expected": true,
						"argument": "length(MetricAlarms[]) > `0`",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 1792 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-01-17",
			"endpointPrefix": "mturk-requester",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon MTurk",
			"serviceFullName": "Amazon Mechanical Turk",
			"serviceId": "MTurk",
			"signatureVersion": "v4",
			"targetPrefix": "MTurkRequesterServiceV20170117",
			"uid": "mturk-requester-2017-01-17"
		},
		"operations": {
			"AcceptQualificationRequest": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationRequestId"
					],
					"members": {
						"QualificationRequestId": {},
						"IntegerValue": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ApproveAssignment": {
				"input": {
					"type": "structure",
					"required": [
						"AssignmentId"
					],
					"members": {
						"AssignmentId": {},
						"RequesterFeedback": {},
						"OverrideRejection": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"AssociateQualificationWithWorker": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationTypeId",
						"WorkerId"
					],
					"members": {
						"QualificationTypeId": {},
						"WorkerId": {},
						"IntegerValue": {
							"type": "integer"
						},
						"SendNotification": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateAdditionalAssignmentsForHIT": {
				"input": {
					"type": "structure",
					"required": [
						"HITId",
						"NumberOfAdditionalAssignments"
					],
					"members": {
						"HITId": {},
						"NumberOfAdditionalAssignments": {
							"type": "integer"
						},
						"UniqueRequestToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateHIT": {
				"input": {
					"type": "structure",
					"required": [
						"LifetimeInSeconds",
						"AssignmentDurationInSeconds",
						"Reward",
						"Title",
						"Description"
					],
					"members": {
						"MaxAssignments": {
							"type": "integer"
						},
						"AutoApprovalDelayInSeconds": {
							"type": "long"
						},
						"LifetimeInSeconds": {
							"type": "long"
						},
						"AssignmentDurationInSeconds": {
							"type": "long"
						},
						"Reward": {},
						"Title": {},
						"Keywords": {},
						"Description": {},
						"Question": {},
						"RequesterAnnotation": {},
						"QualificationRequirements": {
							"shape": "Si"
						},
						"UniqueRequestToken": {},
						"AssignmentReviewPolicy": {
							"shape": "Sq"
						},
						"HITReviewPolicy": {
							"shape": "Sq"
						},
						"HITLayoutId": {},
						"HITLayoutParameters": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HIT": {
							"shape": "Sz"
						}
					}
				}
			},
			"CreateHITType": {
				"input": {
					"type": "structure",
					"required": [
						"AssignmentDurationInSeconds",
						"Reward",
						"Title",
						"Description"
					],
					"members": {
						"AutoApprovalDelayInSeconds": {
							"type": "long"
						},
						"AssignmentDurationInSeconds": {
							"type": "long"
						},
						"Reward": {},
						"Title": {},
						"Keywords": {},
						"Description": {},
						"QualificationRequirements": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HITTypeId": {}
					}
				},
				"idempotent": true
			},
			"CreateHITWithHITType": {
				"input": {
					"type": "structure",
					"required": [
						"HITTypeId",
						"LifetimeInSeconds"
					],
					"members": {
						"HITTypeId": {},
						"MaxAssignments": {
							"type": "integer"
						},
						"LifetimeInSeconds": {
							"type": "long"
						},
						"Question": {},
						"RequesterAnnotation": {},
						"UniqueRequestToken": {},
						"AssignmentReviewPolicy": {
							"shape": "Sq"
						},
						"HITReviewPolicy": {
							"shape": "Sq"
						},
						"HITLayoutId": {},
						"HITLayoutParameters": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HIT": {
							"shape": "Sz"
						}
					}
				}
			},
			"CreateQualificationType": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Description",
						"QualificationTypeStatus"
					],
					"members": {
						"Name": {},
						"Keywords": {},
						"Description": {},
						"QualificationTypeStatus": {},
						"RetryDelayInSeconds": {
							"type": "long"
						},
						"Test": {},
						"AnswerKey": {},
						"TestDurationInSeconds": {
							"type": "long"
						},
						"AutoGranted": {
							"type": "boolean"
						},
						"AutoGrantedValue": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"QualificationType": {
							"shape": "S1a"
						}
					}
				}
			},
			"CreateWorkerBlock": {
				"input": {
					"type": "structure",
					"required": [
						"WorkerId",
						"Reason"
					],
					"members": {
						"WorkerId": {},
						"Reason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteHIT": {
				"input": {
					"type": "structure",
					"required": [
						"HITId"
					],
					"members": {
						"HITId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"DeleteQualificationType": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationTypeId"
					],
					"members": {
						"QualificationTypeId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"DeleteWorkerBlock": {
				"input": {
					"type": "structure",
					"required": [
						"WorkerId"
					],
					"members": {
						"WorkerId": {},
						"Reason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"DisassociateQualificationFromWorker": {
				"input": {
					"type": "structure",
					"required": [
						"WorkerId",
						"QualificationTypeId"
					],
					"members": {
						"WorkerId": {},
						"QualificationTypeId": {},
						"Reason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"GetAccountBalance": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AvailableBalance": {},
						"OnHoldBalance": {}
					}
				},
				"idempotent": true
			},
			"GetAssignment": {
				"input": {
					"type": "structure",
					"required": [
						"AssignmentId"
					],
					"members": {
						"AssignmentId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Assignment": {
							"shape": "S1p"
						},
						"HIT": {
							"shape": "Sz"
						}
					}
				},
				"idempotent": true
			},
			"GetFileUploadURL": {
				"input": {
					"type": "structure",
					"required": [
						"AssignmentId",
						"QuestionIdentifier"
					],
					"members": {
						"AssignmentId": {},
						"QuestionIdentifier": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileUploadURL": {}
					}
				},
				"idempotent": true
			},
			"GetHIT": {
				"input": {
					"type": "structure",
					"required": [
						"HITId"
					],
					"members": {
						"HITId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HIT": {
							"shape": "Sz"
						}
					}
				},
				"idempotent": true
			},
			"GetQualificationScore": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationTypeId",
						"WorkerId"
					],
					"members": {
						"QualificationTypeId": {},
						"WorkerId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Qualification": {
							"shape": "S1x"
						}
					}
				},
				"idempotent": true
			},
			"GetQualificationType": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationTypeId"
					],
					"members": {
						"QualificationTypeId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"QualificationType": {
							"shape": "S1a"
						}
					}
				},
				"idempotent": true
			},
			"ListAssignmentsForHIT": {
				"input": {
					"type": "structure",
					"required": [
						"HITId"
					],
					"members": {
						"HITId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"AssignmentStatuses": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"NumResults": {
							"type": "integer"
						},
						"Assignments": {
							"type": "list",
							"member": {
								"shape": "S1p"
							}
						}
					}
				},
				"idempotent": true
			},
			"ListBonusPayments": {
				"input": {
					"type": "structure",
					"members": {
						"HITId": {},
						"AssignmentId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NumResults": {
							"type": "integer"
						},
						"NextToken": {},
						"BonusPayments": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WorkerId": {},
									"BonusAmount": {},
									"AssignmentId": {},
									"Reason": {},
									"GrantTime": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"ListHITs": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"NumResults": {
							"type": "integer"
						},
						"HITs": {
							"shape": "S2d"
						}
					}
				},
				"idempotent": true
			},
			"ListHITsForQualificationType": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationTypeId"
					],
					"members": {
						"QualificationTypeId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"NumResults": {
							"type": "integer"
						},
						"HITs": {
							"shape": "S2d"
						}
					}
				},
				"idempotent": true
			},
			"ListQualificationRequests": {
				"input": {
					"type": "structure",
					"members": {
						"QualificationTypeId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NumResults": {
							"type": "integer"
						},
						"NextToken": {},
						"QualificationRequests": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"QualificationRequestId": {},
									"QualificationTypeId": {},
									"WorkerId": {},
									"Test": {},
									"Answer": {},
									"SubmitTime": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"ListQualificationTypes": {
				"input": {
					"type": "structure",
					"required": [
						"MustBeRequestable"
					],
					"members": {
						"Query": {},
						"MustBeRequestable": {
							"type": "boolean"
						},
						"MustBeOwnedByCaller": {
							"type": "boolean"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NumResults": {
							"type": "integer"
						},
						"NextToken": {},
						"QualificationTypes": {
							"type": "list",
							"member": {
								"shape": "S1a"
							}
						}
					}
				},
				"idempotent": true
			},
			"ListReviewPolicyResultsForHIT": {
				"input": {
					"type": "structure",
					"required": [
						"HITId"
					],
					"members": {
						"HITId": {},
						"PolicyLevels": {
							"type": "list",
							"member": {}
						},
						"RetrieveActions": {
							"type": "boolean"
						},
						"RetrieveResults": {
							"type": "boolean"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HITId": {},
						"AssignmentReviewPolicy": {
							"shape": "Sq"
						},
						"HITReviewPolicy": {
							"shape": "Sq"
						},
						"AssignmentReviewReport": {
							"shape": "S2r"
						},
						"HITReviewReport": {
							"shape": "S2r"
						},
						"NextToken": {}
					}
				},
				"idempotent": true
			},
			"ListReviewableHITs": {
				"input": {
					"type": "structure",
					"members": {
						"HITTypeId": {},
						"Status": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"NumResults": {
							"type": "integer"
						},
						"HITs": {
							"shape": "S2d"
						}
					}
				},
				"idempotent": true
			},
			"ListWorkerBlocks": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"NumResults": {
							"type": "integer"
						},
						"WorkerBlocks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WorkerId": {},
									"Reason": {}
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"ListWorkersWithQualificationType": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationTypeId"
					],
					"members": {
						"QualificationTypeId": {},
						"Status": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"NumResults": {
							"type": "integer"
						},
						"Qualifications": {
							"type": "list",
							"member": {
								"shape": "S1x"
							}
						}
					}
				},
				"idempotent": true
			},
			"NotifyWorkers": {
				"input": {
					"type": "structure",
					"required": [
						"Subject",
						"MessageText",
						"WorkerIds"
					],
					"members": {
						"Subject": {},
						"MessageText": {},
						"WorkerIds": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NotifyWorkersFailureStatuses": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"NotifyWorkersFailureCode": {},
									"NotifyWorkersFailureMessage": {},
									"WorkerId": {}
								}
							}
						}
					}
				}
			},
			"RejectAssignment": {
				"input": {
					"type": "structure",
					"required": [
						"AssignmentId",
						"RequesterFeedback"
					],
					"members": {
						"AssignmentId": {},
						"RequesterFeedback": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"RejectQualificationRequest": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationRequestId"
					],
					"members": {
						"QualificationRequestId": {},
						"Reason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"SendBonus": {
				"input": {
					"type": "structure",
					"required": [
						"WorkerId",
						"BonusAmount",
						"AssignmentId",
						"Reason"
					],
					"members": {
						"WorkerId": {},
						"BonusAmount": {},
						"AssignmentId": {},
						"Reason": {},
						"UniqueRequestToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"SendTestEventNotification": {
				"input": {
					"type": "structure",
					"required": [
						"Notification",
						"TestEventType"
					],
					"members": {
						"Notification": {
							"shape": "S3k"
						},
						"TestEventType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateExpirationForHIT": {
				"input": {
					"type": "structure",
					"required": [
						"HITId",
						"ExpireAt"
					],
					"members": {
						"HITId": {},
						"ExpireAt": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"UpdateHITReviewStatus": {
				"input": {
					"type": "structure",
					"required": [
						"HITId"
					],
					"members": {
						"HITId": {},
						"Revert": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"UpdateHITTypeOfHIT": {
				"input": {
					"type": "structure",
					"required": [
						"HITId",
						"HITTypeId"
					],
					"members": {
						"HITId": {},
						"HITTypeId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"UpdateNotificationSettings": {
				"input": {
					"type": "structure",
					"required": [
						"HITTypeId"
					],
					"members": {
						"HITTypeId": {},
						"Notification": {
							"shape": "S3k"
						},
						"Active": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"UpdateQualificationType": {
				"input": {
					"type": "structure",
					"required": [
						"QualificationTypeId"
					],
					"members": {
						"QualificationTypeId": {},
						"Description": {},
						"QualificationTypeStatus": {},
						"Test": {},
						"AnswerKey": {},
						"TestDurationInSeconds": {
							"type": "long"
						},
						"RetryDelayInSeconds": {
							"type": "long"
						},
						"AutoGranted": {
							"type": "boolean"
						},
						"AutoGrantedValue": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"QualificationType": {
							"shape": "S1a"
						}
					}
				}
			}
		},
		"shapes": {
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"QualificationTypeId",
						"Comparator"
					],
					"members": {
						"QualificationTypeId": {},
						"Comparator": {},
						"IntegerValues": {
							"type": "list",
							"member": {
								"type": "integer"
							}
						},
						"LocaleValues": {
							"type": "list",
							"member": {
								"shape": "Sn"
							}
						},
						"RequiredToPreview": {
							"deprecated": true,
							"type": "boolean"
						},
						"ActionsGuarded": {}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"Country"
				],
				"members": {
					"Country": {},
					"Subdivision": {}
				}
			},
			"Sq": {
				"type": "structure",
				"required": [
					"PolicyName"
				],
				"members": {
					"PolicyName": {},
					"Parameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Values": {
									"shape": "St"
								},
								"MapEntries": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Key": {},
											"Values": {
												"shape": "St"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"St": {
				"type": "list",
				"member": {}
			},
			"Sw": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Value"
					],
					"members": {
						"Name": {},
						"Value": {}
					}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"HITId": {},
					"HITTypeId": {},
					"HITGroupId": {},
					"HITLayoutId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"Title": {},
					"Description": {},
					"Question": {},
					"Keywords": {},
					"HITStatus": {},
					"MaxAssignments": {
						"type": "integer"
					},
					"Reward": {},
					"AutoApprovalDelayInSeconds": {
						"type": "long"
					},
					"Expiration": {
						"type": "timestamp"
					},
					"AssignmentDurationInSeconds": {
						"type": "long"
					},
					"RequesterAnnotation": {},
					"QualificationRequirements": {
						"shape": "Si"
					},
					"HITReviewStatus": {},
					"NumberOfAssignmentsPending": {
						"type": "integer"
					},
					"NumberOfAssignmentsAvailable": {
						"type": "integer"
					},
					"NumberOfAssignmentsCompleted": {
						"type": "integer"
					}
				}
			},
			"S1a": {
				"type": "structure",
				"members": {
					"QualificationTypeId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"Name": {},
					"Description": {},
					"Keywords": {},
					"QualificationTypeStatus": {},
					"Test": {},
					"TestDurationInSeconds": {
						"type": "long"
					},
					"AnswerKey": {},
					"RetryDelayInSeconds": {
						"type": "long"
					},
					"IsRequestable": {
						"type": "boolean"
					},
					"AutoGranted": {
						"type": "boolean"
					},
					"AutoGrantedValue": {
						"type": "integer"
					}
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"AssignmentId": {},
					"WorkerId": {},
					"HITId": {},
					"AssignmentStatus": {},
					"AutoApprovalTime": {
						"type": "timestamp"
					},
					"AcceptTime": {
						"type": "timestamp"
					},
					"SubmitTime": {
						"type": "timestamp"
					},
					"ApprovalTime": {
						"type": "timestamp"
					},
					"RejectionTime": {
						"type": "timestamp"
					},
					"Deadline": {
						"type": "timestamp"
					},
					"Answer": {},
					"RequesterFeedback": {}
				}
			},
			"S1x": {
				"type": "structure",
				"members": {
					"QualificationTypeId": {},
					"WorkerId": {},
					"GrantTime": {
						"type": "timestamp"
					},
					"IntegerValue": {
						"type": "integer"
					},
					"LocaleValue": {
						"shape": "Sn"
					},
					"Status": {}
				}
			},
			"S2d": {
				"type": "list",
				"member": {
					"shape": "Sz"
				}
			},
			"S2r": {
				"type": "structure",
				"members": {
					"ReviewResults": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ActionId": {},
								"SubjectId": {},
								"SubjectType": {},
								"QuestionId": {},
								"Key": {},
								"Value": {}
							}
						}
					},
					"ReviewActions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ActionId": {},
								"ActionName": {},
								"TargetId": {},
								"TargetType": {},
								"Status": {},
								"CompleteTime": {
									"type": "timestamp"
								},
								"Result": {},
								"ErrorCode": {}
							}
						}
					}
				}
			},
			"S3k": {
				"type": "structure",
				"required": [
					"Destination",
					"Transport",
					"Version",
					"EventTypes"
				],
				"members": {
					"Destination": {},
					"Transport": {},
					"Version": {},
					"EventTypes": {
						"type": "list",
						"member": {}
					}
				}
			}
		}
	};

/***/ },
/* 1793 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListAssignmentsForHIT": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListBonusPayments": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListHITs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListHITsForQualificationType": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListQualificationRequests": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListQualificationTypes": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListReviewPolicyResultsForHIT": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListReviewableHITs": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListWorkerBlocks": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListWorkersWithQualificationType": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1794 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-02-18",
			"endpointPrefix": "opsworks",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS OpsWorks",
			"serviceId": "OpsWorks",
			"signatureVersion": "v4",
			"targetPrefix": "OpsWorks_20130218",
			"uid": "opsworks-2013-02-18"
		},
		"operations": {
			"AssignInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"LayerIds"
					],
					"members": {
						"InstanceId": {},
						"LayerIds": {
							"shape": "S3"
						}
					}
				}
			},
			"AssignVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {},
						"InstanceId": {}
					}
				}
			},
			"AssociateElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {},
						"InstanceId": {}
					}
				}
			},
			"AttachElasticLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticLoadBalancerName",
						"LayerId"
					],
					"members": {
						"ElasticLoadBalancerName": {},
						"LayerId": {}
					}
				}
			},
			"CloneStack": {
				"input": {
					"type": "structure",
					"required": [
						"SourceStackId",
						"ServiceRoleArn"
					],
					"members": {
						"SourceStackId": {},
						"Name": {},
						"Region": {},
						"VpcId": {},
						"Attributes": {
							"shape": "S8"
						},
						"ServiceRoleArn": {},
						"DefaultInstanceProfileArn": {},
						"DefaultOs": {},
						"HostnameTheme": {},
						"DefaultAvailabilityZone": {},
						"DefaultSubnetId": {},
						"CustomJson": {},
						"ConfigurationManager": {
							"shape": "Sa"
						},
						"ChefConfiguration": {
							"shape": "Sb"
						},
						"UseCustomCookbooks": {
							"type": "boolean"
						},
						"UseOpsworksSecurityGroups": {
							"type": "boolean"
						},
						"CustomCookbooksSource": {
							"shape": "Sd"
						},
						"DefaultSshKeyName": {},
						"ClonePermissions": {
							"type": "boolean"
						},
						"CloneAppIds": {
							"shape": "S3"
						},
						"DefaultRootDeviceType": {},
						"AgentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"CreateApp": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"Name",
						"Type"
					],
					"members": {
						"StackId": {},
						"Shortname": {},
						"Name": {},
						"Description": {},
						"DataSources": {
							"shape": "Si"
						},
						"Type": {},
						"AppSource": {
							"shape": "Sd"
						},
						"Domains": {
							"shape": "S3"
						},
						"EnableSsl": {
							"type": "boolean"
						},
						"SslConfiguration": {
							"shape": "Sl"
						},
						"Attributes": {
							"shape": "Sm"
						},
						"Environment": {
							"shape": "So"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AppId": {}
					}
				}
			},
			"CreateDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"Command"
					],
					"members": {
						"StackId": {},
						"AppId": {},
						"InstanceIds": {
							"shape": "S3"
						},
						"LayerIds": {
							"shape": "S3"
						},
						"Command": {
							"shape": "Ss"
						},
						"Comment": {},
						"CustomJson": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeploymentId": {}
					}
				}
			},
			"CreateInstance": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"LayerIds",
						"InstanceType"
					],
					"members": {
						"StackId": {},
						"LayerIds": {
							"shape": "S3"
						},
						"InstanceType": {},
						"AutoScalingType": {},
						"Hostname": {},
						"Os": {},
						"AmiId": {},
						"SshKeyName": {},
						"AvailabilityZone": {},
						"VirtualizationType": {},
						"SubnetId": {},
						"Architecture": {},
						"RootDeviceType": {},
						"BlockDeviceMappings": {
							"shape": "Sz"
						},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"EbsOptimized": {
							"type": "boolean"
						},
						"AgentVersion": {},
						"Tenancy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {}
					}
				}
			},
			"CreateLayer": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"Type",
						"Name",
						"Shortname"
					],
					"members": {
						"StackId": {},
						"Type": {},
						"Name": {},
						"Shortname": {},
						"Attributes": {
							"shape": "S17"
						},
						"CloudWatchLogsConfiguration": {
							"shape": "S19"
						},
						"CustomInstanceProfileArn": {},
						"CustomJson": {},
						"CustomSecurityGroupIds": {
							"shape": "S3"
						},
						"Packages": {
							"shape": "S3"
						},
						"VolumeConfigurations": {
							"shape": "S1f"
						},
						"EnableAutoHealing": {
							"type": "boolean"
						},
						"AutoAssignElasticIps": {
							"type": "boolean"
						},
						"AutoAssignPublicIps": {
							"type": "boolean"
						},
						"CustomRecipes": {
							"shape": "S1h"
						},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"UseEbsOptimizedInstances": {
							"type": "boolean"
						},
						"LifecycleEventConfiguration": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LayerId": {}
					}
				}
			},
			"CreateStack": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Region",
						"ServiceRoleArn",
						"DefaultInstanceProfileArn"
					],
					"members": {
						"Name": {},
						"Region": {},
						"VpcId": {},
						"Attributes": {
							"shape": "S8"
						},
						"ServiceRoleArn": {},
						"DefaultInstanceProfileArn": {},
						"DefaultOs": {},
						"HostnameTheme": {},
						"DefaultAvailabilityZone": {},
						"DefaultSubnetId": {},
						"CustomJson": {},
						"ConfigurationManager": {
							"shape": "Sa"
						},
						"ChefConfiguration": {
							"shape": "Sb"
						},
						"UseCustomCookbooks": {
							"type": "boolean"
						},
						"UseOpsworksSecurityGroups": {
							"type": "boolean"
						},
						"CustomCookbooksSource": {
							"shape": "Sd"
						},
						"DefaultSshKeyName": {},
						"DefaultRootDeviceType": {},
						"AgentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"CreateUserProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamUserArn"
					],
					"members": {
						"IamUserArn": {},
						"SshUsername": {},
						"SshPublicKey": {},
						"AllowSelfManagement": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamUserArn": {}
					}
				}
			},
			"DeleteApp": {
				"input": {
					"type": "structure",
					"required": [
						"AppId"
					],
					"members": {
						"AppId": {}
					}
				}
			},
			"DeleteInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"DeleteElasticIp": {
							"type": "boolean"
						},
						"DeleteVolumes": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteLayer": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {}
					}
				}
			},
			"DeleteStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				}
			},
			"DeleteUserProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamUserArn"
					],
					"members": {
						"IamUserArn": {}
					}
				}
			},
			"DeregisterEcsCluster": {
				"input": {
					"type": "structure",
					"required": [
						"EcsClusterArn"
					],
					"members": {
						"EcsClusterArn": {}
					}
				}
			},
			"DeregisterElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {}
					}
				}
			},
			"DeregisterInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"DeregisterRdsDbInstance": {
				"input": {
					"type": "structure",
					"required": [
						"RdsDbInstanceArn"
					],
					"members": {
						"RdsDbInstanceArn": {}
					}
				}
			},
			"DeregisterVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {}
					}
				}
			},
			"DescribeAgentVersions": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"ConfigurationManager": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AgentVersions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Version": {},
									"ConfigurationManager": {
										"shape": "Sa"
									}
								}
							}
						}
					}
				}
			},
			"DescribeApps": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"AppIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Apps": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AppId": {},
									"StackId": {},
									"Shortname": {},
									"Name": {},
									"Description": {},
									"DataSources": {
										"shape": "Si"
									},
									"Type": {},
									"AppSource": {
										"shape": "Sd"
									},
									"Domains": {
										"shape": "S3"
									},
									"EnableSsl": {
										"type": "boolean"
									},
									"SslConfiguration": {
										"shape": "Sl"
									},
									"Attributes": {
										"shape": "Sm"
									},
									"CreatedAt": {},
									"Environment": {
										"shape": "So"
									}
								}
							}
						}
					}
				}
			},
			"DescribeCommands": {
				"input": {
					"type": "structure",
					"members": {
						"DeploymentId": {},
						"InstanceId": {},
						"CommandIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Commands": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CommandId": {},
									"InstanceId": {},
									"DeploymentId": {},
									"CreatedAt": {},
									"AcknowledgedAt": {},
									"CompletedAt": {},
									"Status": {},
									"ExitCode": {
										"type": "integer"
									},
									"LogUrl": {},
									"Type": {}
								}
							}
						}
					}
				}
			},
			"DescribeDeployments": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"AppId": {},
						"DeploymentIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Deployments": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DeploymentId": {},
									"StackId": {},
									"AppId": {},
									"CreatedAt": {},
									"CompletedAt": {},
									"Duration": {
										"type": "integer"
									},
									"IamUserArn": {},
									"Comment": {},
									"Command": {
										"shape": "Ss"
									},
									"Status": {},
									"CustomJson": {},
									"InstanceIds": {
										"shape": "S3"
									}
								}
							}
						}
					}
				}
			},
			"DescribeEcsClusters": {
				"input": {
					"type": "structure",
					"members": {
						"EcsClusterArns": {
							"shape": "S3"
						},
						"StackId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EcsClusters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EcsClusterArn": {},
									"EcsClusterName": {},
									"StackId": {},
									"RegisteredAt": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeElasticIps": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"StackId": {},
						"Ips": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ElasticIps": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Ip": {},
									"Name": {},
									"Domain": {},
									"Region": {},
									"InstanceId": {}
								}
							}
						}
					}
				}
			},
			"DescribeElasticLoadBalancers": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"LayerIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ElasticLoadBalancers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ElasticLoadBalancerName": {},
									"Region": {},
									"DnsName": {},
									"StackId": {},
									"LayerId": {},
									"VpcId": {},
									"AvailabilityZones": {
										"shape": "S3"
									},
									"SubnetIds": {
										"shape": "S3"
									},
									"Ec2InstanceIds": {
										"shape": "S3"
									}
								}
							}
						}
					}
				}
			},
			"DescribeInstances": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"LayerId": {},
						"InstanceIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AgentVersion": {},
									"AmiId": {},
									"Architecture": {},
									"Arn": {},
									"AutoScalingType": {},
									"AvailabilityZone": {},
									"BlockDeviceMappings": {
										"shape": "Sz"
									},
									"CreatedAt": {},
									"EbsOptimized": {
										"type": "boolean"
									},
									"Ec2InstanceId": {},
									"EcsClusterArn": {},
									"EcsContainerInstanceArn": {},
									"ElasticIp": {},
									"Hostname": {},
									"InfrastructureClass": {},
									"InstallUpdatesOnBoot": {
										"type": "boolean"
									},
									"InstanceId": {},
									"InstanceProfileArn": {},
									"InstanceType": {},
									"LastServiceErrorId": {},
									"LayerIds": {
										"shape": "S3"
									},
									"Os": {},
									"Platform": {},
									"PrivateDns": {},
									"PrivateIp": {},
									"PublicDns": {},
									"PublicIp": {},
									"RegisteredBy": {},
									"ReportedAgentVersion": {},
									"ReportedOs": {
										"type": "structure",
										"members": {
											"Family": {},
											"Name": {},
											"Version": {}
										}
									},
									"RootDeviceType": {},
									"RootDeviceVolumeId": {},
									"SecurityGroupIds": {
										"shape": "S3"
									},
									"SshHostDsaKeyFingerprint": {},
									"SshHostRsaKeyFingerprint": {},
									"SshKeyName": {},
									"StackId": {},
									"Status": {},
									"SubnetId": {},
									"Tenancy": {},
									"VirtualizationType": {}
								}
							}
						}
					}
				}
			},
			"DescribeLayers": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"LayerIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Layers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Arn": {},
									"StackId": {},
									"LayerId": {},
									"Type": {},
									"Name": {},
									"Shortname": {},
									"Attributes": {
										"shape": "S17"
									},
									"CloudWatchLogsConfiguration": {
										"shape": "S19"
									},
									"CustomInstanceProfileArn": {},
									"CustomJson": {},
									"CustomSecurityGroupIds": {
										"shape": "S3"
									},
									"DefaultSecurityGroupNames": {
										"shape": "S3"
									},
									"Packages": {
										"shape": "S3"
									},
									"VolumeConfigurations": {
										"shape": "S1f"
									},
									"EnableAutoHealing": {
										"type": "boolean"
									},
									"AutoAssignElasticIps": {
										"type": "boolean"
									},
									"AutoAssignPublicIps": {
										"type": "boolean"
									},
									"DefaultRecipes": {
										"shape": "S1h"
									},
									"CustomRecipes": {
										"shape": "S1h"
									},
									"CreatedAt": {},
									"InstallUpdatesOnBoot": {
										"type": "boolean"
									},
									"UseEbsOptimizedInstances": {
										"type": "boolean"
									},
									"LifecycleEventConfiguration": {
										"shape": "S1i"
									}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"LayerIds"
					],
					"members": {
						"LayerIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoadBasedAutoScalingConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LayerId": {},
									"Enable": {
										"type": "boolean"
									},
									"UpScaling": {
										"shape": "S36"
									},
									"DownScaling": {
										"shape": "S36"
									}
								}
							}
						}
					}
				}
			},
			"DescribeMyUserProfile": {
				"output": {
					"type": "structure",
					"members": {
						"UserProfile": {
							"type": "structure",
							"members": {
								"IamUserArn": {},
								"Name": {},
								"SshUsername": {},
								"SshPublicKey": {}
							}
						}
					}
				}
			},
			"DescribeOperatingSystems": {
				"output": {
					"type": "structure",
					"members": {
						"OperatingSystems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Id": {},
									"Type": {},
									"ConfigurationManagers": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Name": {},
												"Version": {}
											}
										}
									},
									"ReportedName": {},
									"ReportedVersion": {},
									"Supported": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"DescribePermissions": {
				"input": {
					"type": "structure",
					"members": {
						"IamUserArn": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Permissions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackId": {},
									"IamUserArn": {},
									"AllowSsh": {
										"type": "boolean"
									},
									"AllowSudo": {
										"type": "boolean"
									},
									"Level": {}
								}
							}
						}
					}
				}
			},
			"DescribeRaidArrays": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"StackId": {},
						"RaidArrayIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RaidArrays": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RaidArrayId": {},
									"InstanceId": {},
									"Name": {},
									"RaidLevel": {
										"type": "integer"
									},
									"NumberOfDisks": {
										"type": "integer"
									},
									"Size": {
										"type": "integer"
									},
									"Device": {},
									"MountPoint": {},
									"AvailabilityZone": {},
									"CreatedAt": {},
									"StackId": {},
									"VolumeType": {},
									"Iops": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DescribeRdsDbInstances": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {},
						"RdsDbInstanceArns": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RdsDbInstances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RdsDbInstanceArn": {},
									"DbInstanceIdentifier": {},
									"DbUser": {},
									"DbPassword": {},
									"Region": {},
									"Address": {},
									"Engine": {},
									"StackId": {},
									"MissingOnRds": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"DescribeServiceErrors": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"InstanceId": {},
						"ServiceErrorIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceErrors": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ServiceErrorId": {},
									"StackId": {},
									"InstanceId": {},
									"Type": {},
									"Message": {},
									"CreatedAt": {}
								}
							}
						}
					}
				}
			},
			"DescribeStackProvisioningParameters": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AgentInstallerUrl": {},
						"Parameters": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"DescribeStackSummary": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StackSummary": {
							"type": "structure",
							"members": {
								"StackId": {},
								"Name": {},
								"Arn": {},
								"LayersCount": {
									"type": "integer"
								},
								"AppsCount": {
									"type": "integer"
								},
								"InstancesCount": {
									"type": "structure",
									"members": {
										"Assigning": {
											"type": "integer"
										},
										"Booting": {
											"type": "integer"
										},
										"ConnectionLost": {
											"type": "integer"
										},
										"Deregistering": {
											"type": "integer"
										},
										"Online": {
											"type": "integer"
										},
										"Pending": {
											"type": "integer"
										},
										"Rebooting": {
											"type": "integer"
										},
										"Registered": {
											"type": "integer"
										},
										"Registering": {
											"type": "integer"
										},
										"Requested": {
											"type": "integer"
										},
										"RunningSetup": {
											"type": "integer"
										},
										"SetupFailed": {
											"type": "integer"
										},
										"ShuttingDown": {
											"type": "integer"
										},
										"StartFailed": {
											"type": "integer"
										},
										"StopFailed": {
											"type": "integer"
										},
										"Stopped": {
											"type": "integer"
										},
										"Stopping": {
											"type": "integer"
										},
										"Terminated": {
											"type": "integer"
										},
										"Terminating": {
											"type": "integer"
										},
										"Unassigning": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeStacks": {
				"input": {
					"type": "structure",
					"members": {
						"StackIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Stacks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackId": {},
									"Name": {},
									"Arn": {},
									"Region": {},
									"VpcId": {},
									"Attributes": {
										"shape": "S8"
									},
									"ServiceRoleArn": {},
									"DefaultInstanceProfileArn": {},
									"DefaultOs": {},
									"HostnameTheme": {},
									"DefaultAvailabilityZone": {},
									"DefaultSubnetId": {},
									"CustomJson": {},
									"ConfigurationManager": {
										"shape": "Sa"
									},
									"ChefConfiguration": {
										"shape": "Sb"
									},
									"UseCustomCookbooks": {
										"type": "boolean"
									},
									"UseOpsworksSecurityGroups": {
										"type": "boolean"
									},
									"CustomCookbooksSource": {
										"shape": "Sd"
									},
									"DefaultSshKeyName": {},
									"CreatedAt": {},
									"DefaultRootDeviceType": {},
									"AgentVersion": {}
								}
							}
						}
					}
				}
			},
			"DescribeTimeBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TimeBasedAutoScalingConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InstanceId": {},
									"AutoScalingSchedule": {
										"shape": "S4b"
									}
								}
							}
						}
					}
				}
			},
			"DescribeUserProfiles": {
				"input": {
					"type": "structure",
					"members": {
						"IamUserArns": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserProfiles": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IamUserArn": {},
									"Name": {},
									"SshUsername": {},
									"SshPublicKey": {},
									"AllowSelfManagement": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"DescribeVolumes": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"StackId": {},
						"RaidArrayId": {},
						"VolumeIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Volumes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeId": {},
									"Ec2VolumeId": {},
									"Name": {},
									"RaidArrayId": {},
									"InstanceId": {},
									"Status": {},
									"Size": {
										"type": "integer"
									},
									"Device": {},
									"MountPoint": {},
									"Region": {},
									"AvailabilityZone": {},
									"VolumeType": {},
									"Iops": {
										"type": "integer"
									},
									"Encrypted": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"DetachElasticLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticLoadBalancerName",
						"LayerId"
					],
					"members": {
						"ElasticLoadBalancerName": {},
						"LayerId": {}
					}
				}
			},
			"DisassociateElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {}
					}
				}
			},
			"GetHostnameSuggestion": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LayerId": {},
						"Hostname": {}
					}
				}
			},
			"GrantAccess": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"ValidForInMinutes": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TemporaryCredential": {
							"type": "structure",
							"members": {
								"Username": {},
								"Password": {},
								"ValidForInMinutes": {
									"type": "integer"
								},
								"InstanceId": {}
							}
						}
					}
				}
			},
			"ListTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S50"
						},
						"NextToken": {}
					}
				}
			},
			"RebootInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"RegisterEcsCluster": {
				"input": {
					"type": "structure",
					"required": [
						"EcsClusterArn",
						"StackId"
					],
					"members": {
						"EcsClusterArn": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EcsClusterArn": {}
					}
				}
			},
			"RegisterElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp",
						"StackId"
					],
					"members": {
						"ElasticIp": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ElasticIp": {}
					}
				}
			},
			"RegisterInstance": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {},
						"Hostname": {},
						"PublicIp": {},
						"PrivateIp": {},
						"RsaPublicKey": {},
						"RsaPublicKeyFingerprint": {},
						"InstanceIdentity": {
							"type": "structure",
							"members": {
								"Document": {},
								"Signature": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {}
					}
				}
			},
			"RegisterRdsDbInstance": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"RdsDbInstanceArn",
						"DbUser",
						"DbPassword"
					],
					"members": {
						"StackId": {},
						"RdsDbInstanceArn": {},
						"DbUser": {},
						"DbPassword": {}
					}
				}
			},
			"RegisterVolume": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"Ec2VolumeId": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeId": {}
					}
				}
			},
			"SetLoadBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {},
						"Enable": {
							"type": "boolean"
						},
						"UpScaling": {
							"shape": "S36"
						},
						"DownScaling": {
							"shape": "S36"
						}
					}
				}
			},
			"SetPermission": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"IamUserArn"
					],
					"members": {
						"StackId": {},
						"IamUserArn": {},
						"AllowSsh": {
							"type": "boolean"
						},
						"AllowSudo": {
							"type": "boolean"
						},
						"Level": {}
					}
				}
			},
			"SetTimeBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"AutoScalingSchedule": {
							"shape": "S4b"
						}
					}
				}
			},
			"StartInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"StartStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				}
			},
			"StopInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"Force": {
							"type": "boolean"
						}
					}
				}
			},
			"StopStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Tags"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S50"
						}
					}
				}
			},
			"UnassignInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"UnassignVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeys"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"UpdateApp": {
				"input": {
					"type": "structure",
					"required": [
						"AppId"
					],
					"members": {
						"AppId": {},
						"Name": {},
						"Description": {},
						"DataSources": {
							"shape": "Si"
						},
						"Type": {},
						"AppSource": {
							"shape": "Sd"
						},
						"Domains": {
							"shape": "S3"
						},
						"EnableSsl": {
							"type": "boolean"
						},
						"SslConfiguration": {
							"shape": "Sl"
						},
						"Attributes": {
							"shape": "Sm"
						},
						"Environment": {
							"shape": "So"
						}
					}
				}
			},
			"UpdateElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {},
						"Name": {}
					}
				}
			},
			"UpdateInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"LayerIds": {
							"shape": "S3"
						},
						"InstanceType": {},
						"AutoScalingType": {},
						"Hostname": {},
						"Os": {},
						"AmiId": {},
						"SshKeyName": {},
						"Architecture": {},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"EbsOptimized": {
							"type": "boolean"
						},
						"AgentVersion": {}
					}
				}
			},
			"UpdateLayer": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {},
						"Name": {},
						"Shortname": {},
						"Attributes": {
							"shape": "S17"
						},
						"CloudWatchLogsConfiguration": {
							"shape": "S19"
						},
						"CustomInstanceProfileArn": {},
						"CustomJson": {},
						"CustomSecurityGroupIds": {
							"shape": "S3"
						},
						"Packages": {
							"shape": "S3"
						},
						"VolumeConfigurations": {
							"shape": "S1f"
						},
						"EnableAutoHealing": {
							"type": "boolean"
						},
						"AutoAssignElasticIps": {
							"type": "boolean"
						},
						"AutoAssignPublicIps": {
							"type": "boolean"
						},
						"CustomRecipes": {
							"shape": "S1h"
						},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"UseEbsOptimizedInstances": {
							"type": "boolean"
						},
						"LifecycleEventConfiguration": {
							"shape": "S1i"
						}
					}
				}
			},
			"UpdateMyUserProfile": {
				"input": {
					"type": "structure",
					"members": {
						"SshPublicKey": {}
					}
				}
			},
			"UpdateRdsDbInstance": {
				"input": {
					"type": "structure",
					"required": [
						"RdsDbInstanceArn"
					],
					"members": {
						"RdsDbInstanceArn": {},
						"DbUser": {},
						"DbPassword": {}
					}
				}
			},
			"UpdateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {},
						"Name": {},
						"Attributes": {
							"shape": "S8"
						},
						"ServiceRoleArn": {},
						"DefaultInstanceProfileArn": {},
						"DefaultOs": {},
						"HostnameTheme": {},
						"DefaultAvailabilityZone": {},
						"DefaultSubnetId": {},
						"CustomJson": {},
						"ConfigurationManager": {
							"shape": "Sa"
						},
						"ChefConfiguration": {
							"shape": "Sb"
						},
						"UseCustomCookbooks": {
							"type": "boolean"
						},
						"CustomCookbooksSource": {
							"shape": "Sd"
						},
						"DefaultSshKeyName": {},
						"DefaultRootDeviceType": {},
						"UseOpsworksSecurityGroups": {
							"type": "boolean"
						},
						"AgentVersion": {}
					}
				}
			},
			"UpdateUserProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamUserArn"
					],
					"members": {
						"IamUserArn": {},
						"SshUsername": {},
						"SshPublicKey": {},
						"AllowSelfManagement": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {},
						"Name": {},
						"MountPoint": {}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {}
			},
			"S8": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sa": {
				"type": "structure",
				"members": {
					"Name": {},
					"Version": {}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"ManageBerkshelf": {
						"type": "boolean"
					},
					"BerkshelfVersion": {}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"Type": {},
					"Url": {},
					"Username": {},
					"Password": {},
					"SshKey": {},
					"Revision": {}
				}
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Type": {},
						"Arn": {},
						"DatabaseName": {}
					}
				}
			},
			"Sl": {
				"type": "structure",
				"required": [
					"Certificate",
					"PrivateKey"
				],
				"members": {
					"Certificate": {},
					"PrivateKey": {},
					"Chain": {}
				}
			},
			"Sm": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"So": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {},
						"Secure": {
							"type": "boolean"
						}
					}
				}
			},
			"Ss": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Args": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S3"
						}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"DeviceName": {},
						"NoDevice": {},
						"VirtualName": {},
						"Ebs": {
							"type": "structure",
							"members": {
								"SnapshotId": {},
								"Iops": {
									"type": "integer"
								},
								"VolumeSize": {
									"type": "integer"
								},
								"VolumeType": {},
								"DeleteOnTermination": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"S17": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S19": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"LogStreams": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LogGroupName": {},
								"DatetimeFormat": {},
								"TimeZone": {},
								"File": {},
								"FileFingerprintLines": {},
								"MultiLineStartPattern": {},
								"InitialPosition": {},
								"Encoding": {},
								"BufferDuration": {
									"type": "integer"
								},
								"BatchCount": {
									"type": "integer"
								},
								"BatchSize": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"S1f": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"MountPoint",
						"NumberOfDisks",
						"Size"
					],
					"members": {
						"MountPoint": {},
						"RaidLevel": {
							"type": "integer"
						},
						"NumberOfDisks": {
							"type": "integer"
						},
						"Size": {
							"type": "integer"
						},
						"VolumeType": {},
						"Iops": {
							"type": "integer"
						},
						"Encrypted": {
							"type": "boolean"
						}
					}
				}
			},
			"S1h": {
				"type": "structure",
				"members": {
					"Setup": {
						"shape": "S3"
					},
					"Configure": {
						"shape": "S3"
					},
					"Deploy": {
						"shape": "S3"
					},
					"Undeploy": {
						"shape": "S3"
					},
					"Shutdown": {
						"shape": "S3"
					}
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"Shutdown": {
						"type": "structure",
						"members": {
							"ExecutionTimeout": {
								"type": "integer"
							},
							"DelayUntilElbConnectionsDrained": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"S36": {
				"type": "structure",
				"members": {
					"InstanceCount": {
						"type": "integer"
					},
					"ThresholdsWaitTime": {
						"type": "integer"
					},
					"IgnoreMetricsTime": {
						"type": "integer"
					},
					"CpuThreshold": {
						"type": "double"
					},
					"MemoryThreshold": {
						"type": "double"
					},
					"LoadThreshold": {
						"type": "double"
					},
					"Alarms": {
						"shape": "S3"
					}
				}
			},
			"S4b": {
				"type": "structure",
				"members": {
					"Monday": {
						"shape": "S4c"
					},
					"Tuesday": {
						"shape": "S4c"
					},
					"Wednesday": {
						"shape": "S4c"
					},
					"Thursday": {
						"shape": "S4c"
					},
					"Friday": {
						"shape": "S4c"
					},
					"Saturday": {
						"shape": "S4c"
					},
					"Sunday": {
						"shape": "S4c"
					}
				}
			},
			"S4c": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S50": {
				"type": "map",
				"key": {},
				"value": {}
			}
		}
	};

/***/ },
/* 1795 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeApps": {
				"result_key": "Apps"
			},
			"DescribeCommands": {
				"result_key": "Commands"
			},
			"DescribeDeployments": {
				"result_key": "Deployments"
			},
			"DescribeEcsClusters": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "EcsClusters"
			},
			"DescribeElasticIps": {
				"result_key": "ElasticIps"
			},
			"DescribeElasticLoadBalancers": {
				"result_key": "ElasticLoadBalancers"
			},
			"DescribeInstances": {
				"result_key": "Instances"
			},
			"DescribeLayers": {
				"result_key": "Layers"
			},
			"DescribeLoadBasedAutoScaling": {
				"result_key": "LoadBasedAutoScalingConfigurations"
			},
			"DescribePermissions": {
				"result_key": "Permissions"
			},
			"DescribeRaidArrays": {
				"result_key": "RaidArrays"
			},
			"DescribeServiceErrors": {
				"result_key": "ServiceErrors"
			},
			"DescribeStacks": {
				"result_key": "Stacks"
			},
			"DescribeTimeBasedAutoScaling": {
				"result_key": "TimeBasedAutoScalingConfigurations"
			},
			"DescribeUserProfiles": {
				"result_key": "UserProfiles"
			},
			"DescribeVolumes": {
				"result_key": "Volumes"
			}
		}
	};

/***/ },
/* 1796 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"AppExists": {
				"delay": 1,
				"operation": "DescribeApps",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"matcher": "status",
						"expected": 400,
						"state": "failure"
					}
				]
			},
			"DeploymentSuccessful": {
				"delay": 15,
				"operation": "DescribeDeployments",
				"maxAttempts": 40,
				"description": "Wait until a deployment has completed successfully.",
				"acceptors": [
					{
						"expected": "successful",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Deployments[].Status"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Deployments[].Status"
					}
				]
			},
			"InstanceOnline": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is online.",
				"acceptors": [
					{
						"expected": "online",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "shutting_down",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "start_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopped",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stop_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			},
			"InstanceRegistered": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is registered.",
				"acceptors": [
					{
						"expected": "registered",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "shutting_down",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopped",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stop_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			},
			"InstanceStopped": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is stopped.",
				"acceptors": [
					{
						"expected": "stopped",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "booting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "requested",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "running_setup",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "start_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stop_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			},
			"InstanceTerminated": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is terminated.",
				"acceptors": [
					{
						"expected": "terminated",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "success"
					},
					{
						"expected": "booting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "online",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "requested",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "running_setup",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "start_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			}
		}
	};

/***/ },
/* 1797 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2018-05-22",
			"endpointPrefix": "personalize",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Personalize",
			"serviceId": "Personalize",
			"signatureVersion": "v4",
			"signingName": "personalize",
			"targetPrefix": "AmazonPersonalize",
			"uid": "personalize-2018-05-22"
		},
		"operations": {
			"CreateCampaign": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"solutionVersionArn",
						"minProvisionedTPS"
					],
					"members": {
						"name": {},
						"solutionVersionArn": {},
						"minProvisionedTPS": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"campaignArn": {}
					}
				},
				"idempotent": true
			},
			"CreateDataset": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"schemaArn",
						"datasetGroupArn",
						"datasetType"
					],
					"members": {
						"name": {},
						"schemaArn": {},
						"datasetGroupArn": {},
						"datasetType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasetArn": {}
					}
				},
				"idempotent": true
			},
			"CreateDatasetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"roleArn": {},
						"kmsKeyArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasetGroupArn": {}
					}
				}
			},
			"CreateDatasetImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"jobName",
						"datasetArn",
						"dataSource",
						"roleArn"
					],
					"members": {
						"jobName": {},
						"datasetArn": {},
						"dataSource": {
							"shape": "Se"
						},
						"roleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasetImportJobArn": {}
					}
				}
			},
			"CreateEventTracker": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"datasetGroupArn"
					],
					"members": {
						"name": {},
						"datasetGroupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"eventTrackerArn": {},
						"trackingId": {}
					}
				},
				"idempotent": true
			},
			"CreateSchema": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"schema"
					],
					"members": {
						"name": {},
						"schema": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"schemaArn": {}
					}
				},
				"idempotent": true
			},
			"CreateSolution": {
				"input": {
					"type": "structure",
					"required": [
						"name",
						"datasetGroupArn"
					],
					"members": {
						"name": {},
						"performHPO": {
							"type": "boolean"
						},
						"performAutoML": {
							"type": "boolean"
						},
						"recipeArn": {},
						"datasetGroupArn": {},
						"eventType": {},
						"solutionConfig": {
							"shape": "Sr"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"solutionArn": {}
					}
				}
			},
			"CreateSolutionVersion": {
				"input": {
					"type": "structure",
					"required": [
						"solutionArn"
					],
					"members": {
						"solutionArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"solutionVersionArn": {}
					}
				}
			},
			"DeleteCampaign": {
				"input": {
					"type": "structure",
					"required": [
						"campaignArn"
					],
					"members": {
						"campaignArn": {}
					}
				},
				"idempotent": true
			},
			"DeleteDataset": {
				"input": {
					"type": "structure",
					"required": [
						"datasetArn"
					],
					"members": {
						"datasetArn": {}
					}
				},
				"idempotent": true
			},
			"DeleteDatasetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"datasetGroupArn"
					],
					"members": {
						"datasetGroupArn": {}
					}
				},
				"idempotent": true
			},
			"DeleteEventTracker": {
				"input": {
					"type": "structure",
					"required": [
						"eventTrackerArn"
					],
					"members": {
						"eventTrackerArn": {}
					}
				},
				"idempotent": true
			},
			"DeleteSchema": {
				"input": {
					"type": "structure",
					"required": [
						"schemaArn"
					],
					"members": {
						"schemaArn": {}
					}
				},
				"idempotent": true
			},
			"DeleteSolution": {
				"input": {
					"type": "structure",
					"required": [
						"solutionArn"
					],
					"members": {
						"solutionArn": {}
					}
				},
				"idempotent": true
			},
			"DescribeAlgorithm": {
				"input": {
					"type": "structure",
					"required": [
						"algorithmArn"
					],
					"members": {
						"algorithmArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"algorithm": {
							"type": "structure",
							"members": {
								"name": {},
								"algorithmArn": {},
								"algorithmImage": {
									"type": "structure",
									"required": [
										"dockerURI"
									],
									"members": {
										"name": {},
										"dockerURI": {}
									}
								},
								"defaultHyperParameters": {
									"shape": "S1e"
								},
								"defaultHyperParameterRanges": {
									"type": "structure",
									"members": {
										"integerHyperParameterRanges": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"name": {},
													"minValue": {
														"type": "integer"
													},
													"maxValue": {
														"type": "integer"
													},
													"isTunable": {
														"type": "boolean"
													}
												}
											}
										},
										"continuousHyperParameterRanges": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"name": {},
													"minValue": {
														"type": "double"
													},
													"maxValue": {
														"type": "double"
													},
													"isTunable": {
														"type": "boolean"
													}
												}
											}
										},
										"categoricalHyperParameterRanges": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"name": {},
													"values": {
														"shape": "S1c"
													},
													"isTunable": {
														"type": "boolean"
													}
												}
											}
										}
									}
								},
								"defaultResourceConfig": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"trainingInputMode": {},
								"roleArn": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeCampaign": {
				"input": {
					"type": "structure",
					"required": [
						"campaignArn"
					],
					"members": {
						"campaignArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"campaign": {
							"type": "structure",
							"members": {
								"name": {},
								"campaignArn": {},
								"solutionVersionArn": {},
								"minProvisionedTPS": {
									"type": "integer"
								},
								"status": {},
								"failureReason": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								},
								"latestCampaignUpdate": {
									"type": "structure",
									"members": {
										"solutionVersionArn": {},
										"minProvisionedTPS": {
											"type": "integer"
										},
										"status": {},
										"failureReason": {},
										"creationDateTime": {
											"type": "timestamp"
										},
										"lastUpdatedDateTime": {
											"type": "timestamp"
										}
									}
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeDataset": {
				"input": {
					"type": "structure",
					"required": [
						"datasetArn"
					],
					"members": {
						"datasetArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"dataset": {
							"type": "structure",
							"members": {
								"name": {},
								"datasetArn": {},
								"datasetGroupArn": {},
								"datasetType": {},
								"schemaArn": {},
								"status": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeDatasetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"datasetGroupArn"
					],
					"members": {
						"datasetGroupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasetGroup": {
							"type": "structure",
							"members": {
								"name": {},
								"datasetGroupArn": {},
								"status": {},
								"roleArn": {},
								"kmsKeyArn": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								},
								"failureReason": {}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeDatasetImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"datasetImportJobArn"
					],
					"members": {
						"datasetImportJobArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasetImportJob": {
							"type": "structure",
							"members": {
								"jobName": {},
								"datasetImportJobArn": {},
								"datasetArn": {},
								"dataSource": {
									"shape": "Se"
								},
								"roleArn": {},
								"status": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								},
								"failureReason": {}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeEventTracker": {
				"input": {
					"type": "structure",
					"required": [
						"eventTrackerArn"
					],
					"members": {
						"eventTrackerArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"eventTracker": {
							"type": "structure",
							"members": {
								"name": {},
								"eventTrackerArn": {},
								"accountId": {},
								"trackingId": {},
								"datasetGroupArn": {},
								"status": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeFeatureTransformation": {
				"input": {
					"type": "structure",
					"required": [
						"featureTransformationArn"
					],
					"members": {
						"featureTransformationArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"featureTransformation": {
							"type": "structure",
							"members": {
								"name": {},
								"featureTransformationArn": {},
								"defaultParameters": {
									"type": "map",
									"key": {},
									"value": {}
								},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								},
								"status": {}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeRecipe": {
				"input": {
					"type": "structure",
					"required": [
						"recipeArn"
					],
					"members": {
						"recipeArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"recipe": {
							"type": "structure",
							"members": {
								"name": {},
								"recipeArn": {},
								"algorithmArn": {},
								"featureTransformationArn": {},
								"status": {},
								"description": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"recipeType": {},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeSchema": {
				"input": {
					"type": "structure",
					"required": [
						"schemaArn"
					],
					"members": {
						"schemaArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"schema": {
							"type": "structure",
							"members": {
								"name": {},
								"schemaArn": {},
								"schema": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeSolution": {
				"input": {
					"type": "structure",
					"required": [
						"solutionArn"
					],
					"members": {
						"solutionArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"solution": {
							"type": "structure",
							"members": {
								"name": {},
								"solutionArn": {},
								"performHPO": {
									"type": "boolean"
								},
								"performAutoML": {
									"type": "boolean"
								},
								"recipeArn": {},
								"datasetGroupArn": {},
								"eventType": {},
								"solutionConfig": {
									"shape": "Sr"
								},
								"autoMLResult": {
									"type": "structure",
									"members": {
										"bestRecipeArn": {}
									}
								},
								"status": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								},
								"latestSolutionVersion": {
									"shape": "S37"
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"DescribeSolutionVersion": {
				"input": {
					"type": "structure",
					"required": [
						"solutionVersionArn"
					],
					"members": {
						"solutionVersionArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"solutionVersion": {
							"type": "structure",
							"members": {
								"solutionVersionArn": {},
								"solutionArn": {},
								"performHPO": {
									"type": "boolean"
								},
								"performAutoML": {
									"type": "boolean"
								},
								"recipeArn": {},
								"eventType": {},
								"datasetGroupArn": {},
								"solutionConfig": {
									"shape": "Sr"
								},
								"status": {},
								"failureReason": {},
								"creationDateTime": {
									"type": "timestamp"
								},
								"lastUpdatedDateTime": {
									"type": "timestamp"
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"GetSolutionMetrics": {
				"input": {
					"type": "structure",
					"required": [
						"solutionVersionArn"
					],
					"members": {
						"solutionVersionArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"solutionVersionArn": {},
						"metrics": {
							"type": "map",
							"key": {},
							"value": {
								"type": "double"
							}
						}
					}
				}
			},
			"ListCampaigns": {
				"input": {
					"type": "structure",
					"members": {
						"solutionArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"campaigns": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"campaignArn": {},
									"status": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									},
									"failureReason": {}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListDatasetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasetGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"datasetGroupArn": {},
									"status": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									},
									"failureReason": {}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListDatasetImportJobs": {
				"input": {
					"type": "structure",
					"members": {
						"datasetArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasetImportJobs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"datasetImportJobArn": {},
									"jobName": {},
									"status": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									},
									"failureReason": {}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListDatasets": {
				"input": {
					"type": "structure",
					"members": {
						"datasetGroupArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"datasets": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"datasetArn": {},
									"datasetType": {},
									"status": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListEventTrackers": {
				"input": {
					"type": "structure",
					"members": {
						"datasetGroupArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"eventTrackers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"eventTrackerArn": {},
									"status": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListRecipes": {
				"input": {
					"type": "structure",
					"members": {
						"recipeProvider": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"recipes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"recipeArn": {},
									"status": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListSchemas": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"schemas": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"schemaArn": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListSolutionVersions": {
				"input": {
					"type": "structure",
					"members": {
						"solutionArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"solutionVersions": {
							"type": "list",
							"member": {
								"shape": "S37"
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"ListSolutions": {
				"input": {
					"type": "structure",
					"members": {
						"datasetGroupArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"solutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"solutionArn": {},
									"status": {},
									"creationDateTime": {
										"type": "timestamp"
									},
									"lastUpdatedDateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				},
				"idempotent": true
			},
			"UpdateCampaign": {
				"input": {
					"type": "structure",
					"required": [
						"campaignArn"
					],
					"members": {
						"campaignArn": {},
						"solutionVersionArn": {},
						"minProvisionedTPS": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"campaignArn": {}
					}
				},
				"idempotent": true
			}
		},
		"shapes": {
			"Se": {
				"type": "structure",
				"members": {
					"dataLocation": {}
				}
			},
			"Sr": {
				"type": "structure",
				"members": {
					"eventValueThreshold": {},
					"hpoConfig": {
						"type": "structure",
						"members": {
							"hpoObjective": {
								"type": "structure",
								"members": {
									"type": {},
									"metricName": {},
									"metricRegex": {}
								}
							},
							"hpoResourceConfig": {
								"type": "structure",
								"members": {
									"maxNumberOfTrainingJobs": {},
									"maxParallelTrainingJobs": {}
								}
							},
							"algorithmHyperParameterRanges": {
								"type": "structure",
								"members": {
									"integerHyperParameterRanges": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"name": {},
												"minValue": {
													"type": "integer"
												},
												"maxValue": {
													"type": "integer"
												}
											}
										}
									},
									"continuousHyperParameterRanges": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"name": {},
												"minValue": {
													"type": "double"
												},
												"maxValue": {
													"type": "double"
												}
											}
										}
									},
									"categoricalHyperParameterRanges": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"name": {},
												"values": {
													"shape": "S1c"
												}
											}
										}
									}
								}
							}
						}
					},
					"algorithmHyperParameters": {
						"shape": "S1e"
					},
					"featureTransformationParameters": {
						"type": "map",
						"key": {},
						"value": {}
					},
					"autoMLConfig": {
						"type": "structure",
						"members": {
							"metricName": {},
							"recipeList": {
								"type": "list",
								"member": {}
							}
						}
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {}
			},
			"S1e": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S37": {
				"type": "structure",
				"members": {
					"solutionVersionArn": {},
					"status": {},
					"creationDateTime": {
						"type": "timestamp"
					},
					"lastUpdatedDateTime": {
						"type": "timestamp"
					},
					"failureReason": {}
				}
			}
		}
	};

/***/ },
/* 1798 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCampaigns": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "campaigns"
			},
			"ListDatasetGroups": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "datasetGroups"
			},
			"ListDatasetImportJobs": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "datasetImportJobs"
			},
			"ListDatasets": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "datasets"
			},
			"ListEventTrackers": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "eventTrackers"
			},
			"ListRecipes": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "recipes"
			},
			"ListSchemas": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "schemas"
			},
			"ListSolutionVersions": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "solutionVersions"
			},
			"ListSolutions": {
				"input_token": "nextToken",
				"limit_key": "maxResults",
				"output_token": "nextToken",
				"result_key": "solutions"
			}
		}
	};

/***/ },
/* 1799 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2018-03-22",
			"endpointPrefix": "personalize-events",
			"jsonVersion": "1.1",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Personalize Events",
			"serviceId": "Personalize Events",
			"signatureVersion": "v4",
			"signingName": "personalize",
			"uid": "personalize-events-2018-03-22"
		},
		"operations": {
			"PutEvents": {
				"http": {
					"requestUri": "/events"
				},
				"input": {
					"type": "structure",
					"required": [
						"trackingId",
						"sessionId",
						"eventList"
					],
					"members": {
						"trackingId": {},
						"userId": {},
						"sessionId": {},
						"eventList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"eventType",
									"properties",
									"sentAt"
								],
								"members": {
									"eventId": {},
									"eventType": {},
									"properties": {
										"jsonvalue": true
									},
									"sentAt": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 1800 */
1641,
/* 1801 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2018-05-22",
			"endpointPrefix": "personalize-runtime",
			"jsonVersion": "1.1",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Personalize Runtime",
			"serviceId": "Personalize Runtime",
			"signatureVersion": "v4",
			"signingName": "personalize",
			"uid": "personalize-runtime-2018-05-22"
		},
		"operations": {
			"GetPersonalizedRanking": {
				"http": {
					"requestUri": "/personalize-ranking"
				},
				"input": {
					"type": "structure",
					"required": [
						"campaignArn",
						"inputList",
						"userId"
					],
					"members": {
						"campaignArn": {},
						"inputList": {
							"type": "list",
							"member": {}
						},
						"userId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"personalizedRanking": {
							"shape": "S7"
						}
					}
				},
				"idempotent": true
			},
			"GetRecommendations": {
				"http": {
					"requestUri": "/recommendations"
				},
				"input": {
					"type": "structure",
					"required": [
						"campaignArn"
					],
					"members": {
						"campaignArn": {},
						"itemId": {},
						"userId": {},
						"numResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"itemList": {
							"shape": "S7"
						}
					}
				},
				"idempotent": true
			}
		},
		"shapes": {
			"S7": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"itemId": {}
					}
				}
			}
		}
	};

/***/ },
/* 1802 */
1641,
/* 1803 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-06-10",
			"endpointPrefix": "polly",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Polly",
			"serviceId": "Polly",
			"signatureVersion": "v4",
			"uid": "polly-2016-06-10"
		},
		"operations": {
			"DeleteLexicon": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/lexicons/{LexiconName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {
							"shape": "S2",
							"location": "uri",
							"locationName": "LexiconName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeVoices": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/voices",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"Engine": {
							"location": "querystring",
							"locationName": "Engine"
						},
						"LanguageCode": {
							"location": "querystring",
							"locationName": "LanguageCode"
						},
						"IncludeAdditionalLanguageCodes": {
							"location": "querystring",
							"locationName": "IncludeAdditionalLanguageCodes",
							"type": "boolean"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "NextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Voices": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Gender": {},
									"Id": {},
									"LanguageCode": {},
									"LanguageName": {},
									"Name": {},
									"AdditionalLanguageCodes": {
										"type": "list",
										"member": {}
									},
									"SupportedEngines": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetLexicon": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/lexicons/{LexiconName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {
							"shape": "S2",
							"location": "uri",
							"locationName": "LexiconName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Lexicon": {
							"type": "structure",
							"members": {
								"Content": {},
								"Name": {
									"shape": "S2"
								}
							}
						},
						"LexiconAttributes": {
							"shape": "Sm"
						}
					}
				}
			},
			"GetSpeechSynthesisTask": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/synthesisTasks/{TaskId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"TaskId"
					],
					"members": {
						"TaskId": {
							"location": "uri",
							"locationName": "TaskId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SynthesisTask": {
							"shape": "Sv"
						}
					}
				}
			},
			"ListLexicons": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/lexicons",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {
							"location": "querystring",
							"locationName": "NextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Lexicons": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {
										"shape": "S2"
									},
									"Attributes": {
										"shape": "Sm"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListSpeechSynthesisTasks": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/synthesisTasks",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"location": "querystring",
							"locationName": "MaxResults",
							"type": "integer"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "NextToken"
						},
						"Status": {
							"location": "querystring",
							"locationName": "Status"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"SynthesisTasks": {
							"type": "list",
							"member": {
								"shape": "Sv"
							}
						}
					}
				}
			},
			"PutLexicon": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/lexicons/{LexiconName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Content"
					],
					"members": {
						"Name": {
							"shape": "S2",
							"location": "uri",
							"locationName": "LexiconName"
						},
						"Content": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StartSpeechSynthesisTask": {
				"http": {
					"requestUri": "/v1/synthesisTasks",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"OutputFormat",
						"OutputS3BucketName",
						"Text",
						"VoiceId"
					],
					"members": {
						"Engine": {},
						"LanguageCode": {},
						"LexiconNames": {
							"shape": "S12"
						},
						"OutputFormat": {},
						"OutputS3BucketName": {},
						"OutputS3KeyPrefix": {},
						"SampleRate": {},
						"SnsTopicArn": {},
						"SpeechMarkTypes": {
							"shape": "S15"
						},
						"Text": {},
						"TextType": {},
						"VoiceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SynthesisTask": {
							"shape": "Sv"
						}
					}
				}
			},
			"SynthesizeSpeech": {
				"http": {
					"requestUri": "/v1/speech",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"OutputFormat",
						"Text",
						"VoiceId"
					],
					"members": {
						"Engine": {},
						"LanguageCode": {},
						"LexiconNames": {
							"shape": "S12"
						},
						"OutputFormat": {},
						"SampleRate": {},
						"SpeechMarkTypes": {
							"shape": "S15"
						},
						"Text": {},
						"TextType": {},
						"VoiceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AudioStream": {
							"type": "blob",
							"streaming": true
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"RequestCharacters": {
							"location": "header",
							"locationName": "x-amzn-RequestCharacters",
							"type": "integer"
						}
					},
					"payload": "AudioStream"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "string",
				"sensitive": true
			},
			"Sm": {
				"type": "structure",
				"members": {
					"Alphabet": {},
					"LanguageCode": {},
					"LastModified": {
						"type": "timestamp"
					},
					"LexiconArn": {},
					"LexemesCount": {
						"type": "integer"
					},
					"Size": {
						"type": "integer"
					}
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"Engine": {},
					"TaskId": {},
					"TaskStatus": {},
					"TaskStatusReason": {},
					"OutputUri": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"RequestCharacters": {
						"type": "integer"
					},
					"SnsTopicArn": {},
					"LexiconNames": {
						"shape": "S12"
					},
					"OutputFormat": {},
					"SampleRate": {},
					"SpeechMarkTypes": {
						"shape": "S15"
					},
					"TextType": {},
					"VoiceId": {},
					"LanguageCode": {}
				}
			},
			"S12": {
				"type": "list",
				"member": {
					"shape": "S2"
				}
			},
			"S15": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1804 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListSpeechSynthesisTasks": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1805 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-10-15",
			"endpointPrefix": "api.pricing",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "AWS Pricing",
			"serviceFullName": "AWS Price List Service",
			"serviceId": "Pricing",
			"signatureVersion": "v4",
			"signingName": "pricing",
			"targetPrefix": "AWSPriceListService",
			"uid": "pricing-2017-10-15"
		},
		"operations": {
			"DescribeServices": {
				"input": {
					"type": "structure",
					"members": {
						"ServiceCode": {},
						"FormatVersion": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Services": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ServiceCode": {},
									"AttributeNames": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"FormatVersion": {},
						"NextToken": {}
					}
				}
			},
			"GetAttributeValues": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceCode",
						"AttributeName"
					],
					"members": {
						"ServiceCode": {},
						"AttributeName": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AttributeValues": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Value": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetProducts": {
				"input": {
					"type": "structure",
					"members": {
						"ServiceCode": {},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Type",
									"Field",
									"Value"
								],
								"members": {
									"Type": {},
									"Field": {},
									"Value": {}
								}
							}
						},
						"FormatVersion": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FormatVersion": {},
						"PriceList": {
							"type": "list",
							"member": {
								"jsonvalue": true
							}
						},
						"NextToken": {}
					}
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 1806 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeServices": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"GetAttributeValues": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"GetProducts": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1807 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-01-10",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"serviceId": "RDS",
			"signatureVersion": "v4",
			"uid": "rds-2013-01-10",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2013-01-10/"
		},
		"operations": {
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"AllocatedStorage",
						"DBInstanceClass",
						"Engine",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S1c"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"SourceIds": {
							"shape": "S5"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1o"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S25"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S25",
											"locationName": "CharacterSet"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1c",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2f"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S11",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"DBParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2f"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S6"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S6"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S6"
									},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S1o",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S14",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S3m",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S3o"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S9"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S2f"
						}
					}
				},
				"output": {
					"shape": "S3z",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"DBSecurityGroupMemberships": {
										"shape": "Sp"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "Sq"
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1o"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S3m"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2f"
						}
					}
				},
				"output": {
					"shape": "S3z",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"Id": {},
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S5"
					},
					"EventCategoriesList": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					}
				},
				"wrapper": true
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "Sv"
					},
					"VpcSecurityGroups": {
						"shape": "Sx"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S11"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMembership": {
						"type": "structure",
						"members": {
							"OptionGroupName": {},
							"Status": {}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S14"
								},
								"SubnetStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S14": {
				"type": "structure",
				"members": {
					"Name": {},
					"ProvisionedIopsCapable": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S1c": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1i": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1o": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Port": {
									"type": "integer"
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sv"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sx"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {}
				},
				"wrapper": true
			},
			"S25": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S2f": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S3m": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S3o"
					}
				},
				"wrapper": true
			},
			"S3o": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S3z": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 1808 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDBEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBEngineVersions"
			},
			"DescribeDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstances"
			},
			"DescribeDBParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBParameterGroups"
			},
			"DescribeDBParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeDBSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSecurityGroups"
			},
			"DescribeDBSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSnapshots"
			},
			"DescribeDBSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeOptionGroupOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupOptions"
			},
			"DescribeOptionGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupsList"
			},
			"DescribeOrderableDBInstanceOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableDBInstanceOptions"
			},
			"DescribeReservedDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstances"
			},
			"DescribeReservedDBInstancesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstancesOfferings"
			},
			"ListTagsForResource": {
				"result_key": "TagList"
			}
		}
	};

/***/ },
/* 1809 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-02-12",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"serviceId": "RDS",
			"signatureVersion": "v4",
			"uid": "rds-2013-02-12",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2013-02-12/"
		},
		"operations": {
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"AllocatedStorage",
						"DBInstanceClass",
						"Engine",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S1d"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1j"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"SourceIds": {
							"shape": "S5"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1p"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S28"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S28",
											"locationName": "CharacterSet"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBLogFiles": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"FilenameContains": {},
						"FileLastWritten": {
							"type": "long"
						},
						"FileSize": {
							"type": "long"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBLogFilesResult",
					"type": "structure",
					"members": {
						"DescribeDBLogFiles": {
							"type": "list",
							"member": {
								"locationName": "DescribeDBLogFilesDetails",
								"type": "structure",
								"members": {
									"LogFileName": {},
									"LastWritten": {
										"type": "long"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1d",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2n"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S11",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"DBParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2n"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S6"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S6"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S6"
									},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									},
									"Persistent": {
										"type": "boolean"
									},
									"OptionGroupOptionSettings": {
										"type": "list",
										"member": {
											"locationName": "OptionGroupOptionSetting",
											"type": "structure",
											"members": {
												"SettingName": {},
												"SettingDescription": {},
												"DefaultValue": {},
												"ApplyType": {},
												"AllowedValues": {},
												"IsModifiable": {
													"type": "boolean"
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S1p",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S14",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S3w",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S3y"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DownloadDBLogFilePortion": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"LogFileName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"LogFileName": {},
						"Marker": {},
						"NumberOfLines": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DownloadDBLogFilePortionResult",
					"type": "structure",
					"members": {
						"LogFileData": {},
						"Marker": {},
						"AdditionalDataPending": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S9"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S2n"
						}
					}
				},
				"output": {
					"shape": "S4b",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1j"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"DBSecurityGroupMemberships": {
										"shape": "Sp"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "Sq"
									},
									"OptionSettings": {
										"type": "list",
										"member": {
											"shape": "S1t",
											"locationName": "OptionSetting"
										}
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1p"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S3w"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2n"
						}
					}
				},
				"output": {
					"shape": "S4b",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S5"
					},
					"EventCategoriesList": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {}
				},
				"wrapper": true
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "Sv"
					},
					"VpcSecurityGroups": {
						"shape": "Sx"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S11"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupMembership",
							"type": "structure",
							"members": {
								"OptionGroupName": {},
								"Status": {}
							}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S14"
								},
								"SubnetStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S14": {
				"type": "structure",
				"members": {
					"Name": {},
					"ProvisionedIopsCapable": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S1d": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1j": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Persistent": {
									"type": "boolean"
								},
								"Port": {
									"type": "integer"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1t",
										"locationName": "OptionSetting"
									}
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sv"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sx"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {}
				},
				"wrapper": true
			},
			"S1t": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {},
					"DefaultValue": {},
					"Description": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"IsCollection": {
						"type": "boolean"
					}
				}
			},
			"S28": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S2n": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S3w": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S3y"
					}
				},
				"wrapper": true
			},
			"S3y": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S4b": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 1810 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDBEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBEngineVersions"
			},
			"DescribeDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstances"
			},
			"DescribeDBLogFiles": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DescribeDBLogFiles"
			},
			"DescribeDBParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBParameterGroups"
			},
			"DescribeDBParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeDBSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSecurityGroups"
			},
			"DescribeDBSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSnapshots"
			},
			"DescribeDBSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeOptionGroupOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupOptions"
			},
			"DescribeOptionGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupsList"
			},
			"DescribeOrderableDBInstanceOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableDBInstanceOptions"
			},
			"DescribeReservedDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstances"
			},
			"DescribeReservedDBInstancesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstancesOfferings"
			},
			"DownloadDBLogFilePortion": {
				"input_token": "Marker",
				"limit_key": "NumberOfLines",
				"more_results": "AdditionalDataPending",
				"output_token": "Marker",
				"result_key": "LogFileData"
			},
			"ListTagsForResource": {
				"result_key": "TagList"
			}
		}
	};

/***/ },
/* 1811 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-09-09",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"serviceId": "RDS",
			"signatureVersion": "v4",
			"uid": "rds-2013-09-09",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2013-09-09/"
		},
		"operations": {
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"AllocatedStorage",
						"DBInstanceClass",
						"Engine",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						},
						"DBSubnetGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S1f"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1l"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"SourceIds": {
							"shape": "S5"
						},
						"Enabled": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1r"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S2d"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S2d",
											"locationName": "CharacterSet"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBLogFiles": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"FilenameContains": {},
						"FileLastWritten": {
							"type": "long"
						},
						"FileSize": {
							"type": "long"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBLogFilesResult",
					"type": "structure",
					"members": {
						"DescribeDBLogFiles": {
							"type": "list",
							"member": {
								"locationName": "DescribeDBLogFilesDetails",
								"type": "structure",
								"members": {
									"LogFileName": {},
									"LastWritten": {
										"type": "long"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1f",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2s"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S11",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"DBParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2s"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {},
						"Filters": {
							"shape": "S27"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S6"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S6"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S6"
									},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									},
									"Persistent": {
										"type": "boolean"
									},
									"Permanent": {
										"type": "boolean"
									},
									"OptionGroupOptionSettings": {
										"type": "list",
										"member": {
											"locationName": "OptionGroupOptionSetting",
											"type": "structure",
											"members": {
												"SettingName": {},
												"SettingDescription": {},
												"DefaultValue": {},
												"ApplyType": {},
												"AllowedValues": {},
												"IsModifiable": {
													"type": "boolean"
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S1r",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S14",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S41",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S43"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DownloadDBLogFilePortion": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"LogFileName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"LogFileName": {},
						"Marker": {},
						"NumberOfLines": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DownloadDBLogFilePortionResult",
					"type": "structure",
					"members": {
						"LogFileData": {},
						"Marker": {},
						"AdditionalDataPending": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {},
						"Filters": {
							"shape": "S27"
						}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S9"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S2s"
						}
					}
				},
				"output": {
					"shape": "S4g",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1l"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"DBSecurityGroupMemberships": {
										"shape": "Sp"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "Sq"
									},
									"OptionSettings": {
										"type": "list",
										"member": {
											"shape": "S1v",
											"locationName": "OptionSetting"
										}
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1r"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S41"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2s"
						}
					}
				},
				"output": {
					"shape": "S4g",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S5"
					},
					"EventCategoriesList": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PercentProgress": {
						"type": "integer"
					},
					"SourceRegion": {}
				},
				"wrapper": true
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "Sv"
					},
					"VpcSecurityGroups": {
						"shape": "Sx"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S11"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupMembership",
							"type": "structure",
							"members": {
								"OptionGroupName": {},
								"Status": {}
							}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"StatusInfos": {
						"type": "list",
						"member": {
							"locationName": "DBInstanceStatusInfo",
							"type": "structure",
							"members": {
								"StatusType": {},
								"Normal": {
									"type": "boolean"
								},
								"Status": {},
								"Message": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S14"
								},
								"SubnetStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S14": {
				"type": "structure",
				"members": {
					"Name": {},
					"ProvisionedIopsCapable": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S1f": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1l": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"Port": {
									"type": "integer"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1v",
										"locationName": "OptionSetting"
									}
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sv"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sx"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {}
				},
				"wrapper": true
			},
			"S1v": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {},
					"DefaultValue": {},
					"Description": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"IsCollection": {
						"type": "boolean"
					}
				}
			},
			"S27": {
				"type": "list",
				"member": {
					"locationName": "Filter",
					"type": "structure",
					"required": [
						"Name",
						"Values"
					],
					"members": {
						"Name": {},
						"Values": {
							"type": "list",
							"member": {
								"locationName": "Value"
							}
						}
					}
				}
			},
			"S2d": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S2s": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S41": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S43"
					}
				},
				"wrapper": true
			},
			"S43": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S4g": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 1812 */
1810,
/* 1813 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DBInstanceAvailable": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-restore",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-parameters",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-parameters",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-restore",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			},
			"DBInstanceDeleted": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "resetting-master-credentials",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			}
		}
	};

/***/ },
/* 1814 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-09-01",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"serviceId": "RDS",
			"signatureVersion": "v4",
			"uid": "rds-2014-09-01",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2014-09-01/"
		},
		"operations": {
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBParameterGroupIdentifier",
						"TargetDBParameterGroupIdentifier",
						"TargetDBParameterGroupDescription"
					],
					"members": {
						"SourceDBParameterGroupIdentifier": {},
						"TargetDBParameterGroupIdentifier": {},
						"TargetDBParameterGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "Sk"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sn"
						}
					}
				}
			},
			"CopyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceOptionGroupIdentifier",
						"TargetOptionGroupIdentifier",
						"TargetOptionGroupDescription"
					],
					"members": {
						"SourceOptionGroupIdentifier": {},
						"TargetOptionGroupIdentifier": {},
						"TargetOptionGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"AllocatedStorage",
						"DBInstanceClass",
						"Engine",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "S13"
						},
						"VpcSecurityGroupIds": {
							"shape": "S14"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						},
						"DBSubnetGroupName": {},
						"StorageType": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sn"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1u"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S1b"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"SourceIds": {
							"shape": "S5"
						},
						"Enabled": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "St"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sn"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S2h"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S2h",
											"locationName": "CharacterSet"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "S17",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBLogFiles": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"FilenameContains": {},
						"FileLastWritten": {
							"type": "long"
						},
						"FileSize": {
							"type": "long"
						},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBLogFilesResult",
					"type": "structure",
					"members": {
						"DescribeDBLogFiles": {
							"type": "list",
							"member": {
								"locationName": "DescribeDBLogFilesDetails",
								"type": "structure",
								"members": {
									"LogFileName": {},
									"LastWritten": {
										"type": "long"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2w"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sn",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S1b",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"DBParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2w"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {},
						"Filters": {
							"shape": "S2b"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S6"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S6"
						},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S6"
									},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									},
									"Persistent": {
										"type": "boolean"
									},
									"Permanent": {
										"type": "boolean"
									},
									"OptionGroupOptionSettings": {
										"type": "list",
										"member": {
											"locationName": "OptionGroupOptionSetting",
											"type": "structure",
											"members": {
												"SettingName": {},
												"SettingDescription": {},
												"DefaultValue": {},
												"ApplyType": {},
												"AllowedValues": {},
												"IsModifiable": {
													"type": "boolean"
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Filters": {
							"shape": "S2b"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S1e",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									},
									"StorageType": {},
									"SupportsIops": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S45",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S2b"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S47"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DownloadDBLogFilePortion": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"LogFileName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"LogFileName": {},
						"Marker": {},
						"NumberOfLines": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DownloadDBLogFilePortionResult",
					"type": "structure",
					"members": {
						"LogFileData": {},
						"Marker": {},
						"AdditionalDataPending": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {},
						"Filters": {
							"shape": "S2b"
						}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S9"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSecurityGroups": {
							"shape": "S13"
						},
						"VpcSecurityGroupIds": {
							"shape": "S14"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S2w"
						}
					}
				},
				"output": {
					"shape": "S4k",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1u"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S1b"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"DBSecurityGroupMemberships": {
										"shape": "S13"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "S14"
									},
									"OptionSettings": {
										"type": "list",
										"member": {
											"shape": "Sx",
											"locationName": "OptionSetting"
										}
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "St"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S45"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2w"
						}
					}
				},
				"output": {
					"shape": "S4k",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "S9"
						},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "S9"
						},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S17"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S5"
					},
					"EventCategoriesList": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"Sn": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PercentProgress": {
						"type": "integer"
					},
					"SourceRegion": {},
					"StorageType": {},
					"TdeCredentialArn": {}
				},
				"wrapper": true
			},
			"St": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"Port": {
									"type": "integer"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "Sx",
										"locationName": "OptionSetting"
									}
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sy"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "S10"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {}
				},
				"wrapper": true
			},
			"Sx": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {},
					"DefaultValue": {},
					"Description": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"IsCollection": {
						"type": "boolean"
					}
				}
			},
			"Sy": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"S10": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"S14": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"S17": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "Sy"
					},
					"VpcSecurityGroups": {
						"shape": "S10"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S1b"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {},
							"StorageType": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupMembership",
							"type": "structure",
							"members": {
								"OptionGroupName": {},
								"Status": {}
							}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"StatusInfos": {
						"type": "list",
						"member": {
							"locationName": "DBInstanceStatusInfo",
							"type": "structure",
							"members": {
								"StatusType": {},
								"Normal": {
									"type": "boolean"
								},
								"Status": {},
								"Message": {}
							}
						}
					},
					"StorageType": {},
					"TdeCredentialArn": {}
				},
				"wrapper": true
			},
			"S1b": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S1e"
								},
								"SubnetStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S1e": {
				"type": "structure",
				"members": {
					"Name": {}
				},
				"wrapper": true
			},
			"S1u": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S2b": {
				"type": "list",
				"member": {
					"locationName": "Filter",
					"type": "structure",
					"required": [
						"Name",
						"Values"
					],
					"members": {
						"Name": {},
						"Values": {
							"type": "list",
							"member": {
								"locationName": "Value"
							}
						}
					}
				}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S2w": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S45": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S47"
					}
				},
				"wrapper": true
			},
			"S47": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S4k": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 1815 */
1641,
/* 1816 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-10-31",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"serviceId": "RDS",
			"signatureVersion": "v4",
			"uid": "rds-2014-10-31",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2014-10-31/"
		},
		"operations": {
			"AddRoleToDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"RoleArn"
					],
					"members": {
						"DBClusterIdentifier": {},
						"RoleArn": {},
						"FeatureName": {}
					}
				}
			},
			"AddRoleToDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"RoleArn",
						"FeatureName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"RoleArn": {},
						"FeatureName": {}
					}
				}
			},
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S6"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				}
			},
			"ApplyPendingMaintenanceAction": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceIdentifier",
						"ApplyAction",
						"OptInType"
					],
					"members": {
						"ResourceIdentifier": {},
						"ApplyAction": {},
						"OptInType": {}
					}
				},
				"output": {
					"resultWrapper": "ApplyPendingMaintenanceActionResult",
					"type": "structure",
					"members": {
						"ResourcePendingMaintenanceActions": {
							"shape": "Sf"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sl"
						}
					}
				}
			},
			"BacktrackDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"BacktrackTo"
					],
					"members": {
						"DBClusterIdentifier": {},
						"BacktrackTo": {
							"type": "timestamp"
						},
						"Force": {
							"type": "boolean"
						},
						"UseEarliestTimeOnPointInTimeUnavailable": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "Ss",
					"resultWrapper": "BacktrackDBClusterResult"
				}
			},
			"CopyDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBClusterParameterGroupIdentifier",
						"TargetDBClusterParameterGroupIdentifier",
						"TargetDBClusterParameterGroupDescription"
					],
					"members": {
						"SourceDBClusterParameterGroupIdentifier": {},
						"TargetDBClusterParameterGroupIdentifier": {},
						"TargetDBClusterParameterGroupDescription": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBClusterParameterGroupResult",
					"type": "structure",
					"members": {
						"DBClusterParameterGroup": {
							"shape": "Sv"
						}
					}
				}
			},
			"CopyDBClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBClusterSnapshotIdentifier",
						"TargetDBClusterSnapshotIdentifier"
					],
					"members": {
						"SourceDBClusterSnapshotIdentifier": {},
						"TargetDBClusterSnapshotIdentifier": {},
						"KmsKeyId": {},
						"PreSignedUrl": {},
						"CopyTags": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sb"
						},
						"SourceRegion": {}
					}
				},
				"output": {
					"resultWrapper": "CopyDBClusterSnapshotResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshot": {
							"shape": "Sy"
						}
					}
				}
			},
			"CopyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBParameterGroupIdentifier",
						"TargetDBParameterGroupIdentifier",
						"TargetDBParameterGroupDescription"
					],
					"members": {
						"SourceDBParameterGroupIdentifier": {},
						"TargetDBParameterGroupIdentifier": {},
						"TargetDBParameterGroupDescription": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S13"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {},
						"KmsKeyId": {},
						"Tags": {
							"shape": "Sb"
						},
						"CopyTags": {
							"type": "boolean"
						},
						"PreSignedUrl": {},
						"OptionGroupName": {},
						"SourceRegion": {}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S16"
						}
					}
				}
			},
			"CopyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceOptionGroupIdentifier",
						"TargetOptionGroupIdentifier",
						"TargetOptionGroupDescription"
					],
					"members": {
						"SourceOptionGroupIdentifier": {},
						"TargetOptionGroupIdentifier": {},
						"TargetOptionGroupDescription": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1c"
						}
					}
				}
			},
			"CreateDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"Engine"
					],
					"members": {
						"AvailabilityZones": {
							"shape": "Sz"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"CharacterSetName": {},
						"DatabaseName": {},
						"DBClusterIdentifier": {},
						"DBClusterParameterGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"DBSubnetGroupName": {},
						"Engine": {},
						"EngineVersion": {},
						"Port": {
							"type": "integer"
						},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"OptionGroupName": {},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"ReplicationSourceIdentifier": {},
						"Tags": {
							"shape": "Sb"
						},
						"StorageEncrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"PreSignedUrl": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"BacktrackWindow": {
							"type": "long"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"EngineMode": {},
						"ScalingConfiguration": {
							"shape": "S1p"
						},
						"DeletionProtection": {
							"type": "boolean"
						},
						"GlobalClusterIdentifier": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"SourceRegion": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"CreateDBClusterEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"DBClusterEndpointIdentifier",
						"EndpointType"
					],
					"members": {
						"DBClusterIdentifier": {},
						"DBClusterEndpointIdentifier": {},
						"EndpointType": {},
						"StaticMembers": {
							"shape": "S1s"
						},
						"ExcludedMembers": {
							"shape": "S1s"
						}
					}
				},
				"output": {
					"shape": "S24",
					"resultWrapper": "CreateDBClusterEndpointResult"
				}
			},
			"CreateDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBClusterParameterGroupResult",
					"type": "structure",
					"members": {
						"DBClusterParameterGroup": {
							"shape": "Sv"
						}
					}
				}
			},
			"CreateDBClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier",
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {},
						"DBClusterIdentifier": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBClusterSnapshotResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshot": {
							"shape": "Sy"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBInstanceClass",
						"Engine"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "S2a"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sb"
						},
						"DBClusterIdentifier": {},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"StorageEncrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"Domain": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"MonitoringInterval": {
							"type": "integer"
						},
						"MonitoringRoleArn": {},
						"DomainIAMRoleName": {},
						"PromotionTier": {
							"type": "integer"
						},
						"Timezone": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"EnablePerformanceInsights": {
							"type": "boolean"
						},
						"PerformanceInsightsKMSKeyId": {},
						"PerformanceInsightsRetentionPeriod": {
							"type": "integer"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"ProcessorFeatures": {
							"shape": "S18"
						},
						"DeletionProtection": {
							"type": "boolean"
						},
						"MaxAllocatedStorage": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sb"
						},
						"DBSubnetGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"StorageType": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"MonitoringInterval": {
							"type": "integer"
						},
						"MonitoringRoleArn": {},
						"KmsKeyId": {},
						"PreSignedUrl": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"EnablePerformanceInsights": {
							"type": "boolean"
						},
						"PerformanceInsightsKMSKeyId": {},
						"PerformanceInsightsRetentionPeriod": {
							"type": "integer"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"ProcessorFeatures": {
							"shape": "S18"
						},
						"UseDefaultProcessorFeatures": {
							"type": "boolean"
						},
						"DeletionProtection": {
							"type": "boolean"
						},
						"SourceRegion": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S13"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sl"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S16"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S35"
						},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S2g"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S8"
						},
						"SourceIds": {
							"shape": "S7"
						},
						"Enabled": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S6"
						}
					}
				}
			},
			"CreateGlobalCluster": {
				"input": {
					"type": "structure",
					"members": {
						"GlobalClusterIdentifier": {},
						"SourceDBClusterIdentifier": {},
						"Engine": {},
						"EngineVersion": {},
						"DeletionProtection": {
							"type": "boolean"
						},
						"DatabaseName": {},
						"StorageEncrypted": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateGlobalClusterResult",
					"type": "structure",
					"members": {
						"GlobalCluster": {
							"shape": "S3b"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1c"
						}
					}
				}
			},
			"DeleteDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"DeleteDBClusterEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterEndpointIdentifier"
					],
					"members": {
						"DBClusterEndpointIdentifier": {}
					}
				},
				"output": {
					"shape": "S24",
					"resultWrapper": "DeleteDBClusterEndpointResult"
				}
			},
			"DeleteDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName"
					],
					"members": {
						"DBClusterParameterGroupName": {}
					}
				}
			},
			"DeleteDBClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBClusterSnapshotResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshot": {
							"shape": "Sy"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {},
						"DeleteAutomatedBackups": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"DeleteDBInstanceAutomatedBackup": {
				"input": {
					"type": "structure",
					"required": [
						"DbiResourceId"
					],
					"members": {
						"DbiResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceAutomatedBackupResult",
					"type": "structure",
					"members": {
						"DBInstanceAutomatedBackup": {
							"shape": "S3r"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S16"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S6"
						}
					}
				}
			},
			"DeleteGlobalCluster": {
				"input": {
					"type": "structure",
					"required": [
						"GlobalClusterIdentifier"
					],
					"members": {
						"GlobalClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteGlobalClusterResult",
					"type": "structure",
					"members": {
						"GlobalCluster": {
							"shape": "S3b"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeAccountAttributes": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "DescribeAccountAttributesResult",
					"type": "structure",
					"members": {
						"AccountQuotas": {
							"type": "list",
							"member": {
								"locationName": "AccountQuota",
								"type": "structure",
								"members": {
									"AccountQuotaName": {},
									"Used": {
										"type": "long"
									},
									"Max": {
										"type": "long"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"CertificateIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCertificatesResult",
					"type": "structure",
					"members": {
						"Certificates": {
							"type": "list",
							"member": {
								"locationName": "Certificate",
								"type": "structure",
								"members": {
									"CertificateIdentifier": {},
									"CertificateType": {},
									"Thumbprint": {},
									"ValidFrom": {
										"type": "timestamp"
									},
									"ValidTill": {
										"type": "timestamp"
									},
									"CertificateArn": {}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBClusterBacktracks": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"BacktrackIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterBacktracksResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusterBacktracks": {
							"type": "list",
							"member": {
								"shape": "Ss",
								"locationName": "DBClusterBacktrack"
							}
						}
					}
				}
			},
			"DescribeDBClusterEndpoints": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterIdentifier": {},
						"DBClusterEndpointIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterEndpointsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusterEndpoints": {
							"type": "list",
							"member": {
								"shape": "S24",
								"locationName": "DBClusterEndpointList"
							}
						}
					}
				}
			},
			"DescribeDBClusterParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterParameterGroupName": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusterParameterGroups": {
							"type": "list",
							"member": {
								"shape": "Sv",
								"locationName": "DBClusterParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"Source": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S4q"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBClusterSnapshotAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterSnapshotAttributesResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshotAttributesResult": {
							"shape": "S4w"
						}
					}
				}
			},
			"DescribeDBClusterSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterIdentifier": {},
						"DBClusterSnapshotIdentifier": {},
						"SnapshotType": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"IncludeShared": {
							"type": "boolean"
						},
						"IncludePublic": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusterSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sy",
								"locationName": "DBClusterSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBClusters": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"IncludeShared": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClustersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusters": {
							"type": "list",
							"member": {
								"shape": "S1r",
								"locationName": "DBCluster"
							}
						}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						},
						"ListSupportedTimezones": {
							"type": "boolean"
						},
						"IncludeAll": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S5a"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S5a",
											"locationName": "CharacterSet"
										}
									},
									"ValidUpgradeTarget": {
										"type": "list",
										"member": {
											"locationName": "UpgradeTarget",
											"type": "structure",
											"members": {
												"Engine": {},
												"EngineVersion": {},
												"Description": {},
												"AutoUpgrade": {
													"type": "boolean"
												},
												"IsMajorVersionUpgrade": {
													"type": "boolean"
												}
											}
										}
									},
									"SupportedTimezones": {
										"type": "list",
										"member": {
											"locationName": "Timezone",
											"type": "structure",
											"members": {
												"TimezoneName": {}
											}
										}
									},
									"ExportableLogTypes": {
										"shape": "S1o"
									},
									"SupportsLogExportsToCloudwatchLogs": {
										"type": "boolean"
									},
									"SupportsReadReplica": {
										"type": "boolean"
									},
									"SupportedEngineModes": {
										"shape": "S4t"
									},
									"SupportedFeatureNames": {
										"type": "list",
										"member": {}
									},
									"Status": {}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstanceAutomatedBackups": {
				"input": {
					"type": "structure",
					"members": {
						"DbiResourceId": {},
						"DBInstanceIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstanceAutomatedBackupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstanceAutomatedBackups": {
							"type": "list",
							"member": {
								"shape": "S3r",
								"locationName": "DBInstanceAutomatedBackup"
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "S2c",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBLogFiles": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"FilenameContains": {},
						"FileLastWritten": {
							"type": "long"
						},
						"FileSize": {
							"type": "long"
						},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBLogFilesResult",
					"type": "structure",
					"members": {
						"DescribeDBLogFiles": {
							"type": "list",
							"member": {
								"locationName": "DescribeDBLogFilesDetails",
								"type": "structure",
								"members": {
									"LogFileName": {},
									"LastWritten": {
										"type": "long"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S13",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S4q"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sl",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshotAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotAttributesResult",
					"type": "structure",
					"members": {
						"DBSnapshotAttributesResult": {
							"shape": "S61"
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"IncludeShared": {
							"type": "boolean"
						},
						"IncludePublic": {
							"type": "boolean"
						},
						"DbiResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "S16",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S2g",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultClusterParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"shape": "S6c"
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"shape": "S6c"
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {},
						"Filters": {
							"shape": "S49"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S8"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S6",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S8"
						},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S8"
									},
									"Date": {
										"type": "timestamp"
									},
									"SourceArn": {}
								}
							}
						}
					}
				}
			},
			"DescribeGlobalClusters": {
				"input": {
					"type": "structure",
					"members": {
						"GlobalClusterIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeGlobalClustersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"GlobalClusters": {
							"type": "list",
							"member": {
								"shape": "S3b",
								"locationName": "GlobalClusterMember"
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									},
									"OptionsConflictsWith": {
										"type": "list",
										"member": {
											"locationName": "OptionConflictName"
										}
									},
									"Persistent": {
										"type": "boolean"
									},
									"Permanent": {
										"type": "boolean"
									},
									"RequiresAutoMinorEngineVersionUpgrade": {
										"type": "boolean"
									},
									"VpcOnly": {
										"type": "boolean"
									},
									"SupportsOptionVersionDowngrade": {
										"type": "boolean"
									},
									"OptionGroupOptionSettings": {
										"type": "list",
										"member": {
											"locationName": "OptionGroupOptionSetting",
											"type": "structure",
											"members": {
												"SettingName": {},
												"SettingDescription": {},
												"DefaultValue": {},
												"ApplyType": {},
												"AllowedValues": {},
												"IsModifiable": {
													"type": "boolean"
												},
												"IsRequired": {
													"type": "boolean"
												},
												"MinimumEngineVersionPerAllowedValue": {
													"type": "list",
													"member": {
														"locationName": "MinimumEngineVersionPerAllowedValue",
														"type": "structure",
														"members": {
															"AllowedValue": {},
															"MinimumEngineVersion": {}
														}
													}
												}
											}
										}
									},
									"OptionGroupOptionVersions": {
										"type": "list",
										"member": {
											"locationName": "OptionVersion",
											"type": "structure",
											"members": {
												"Version": {},
												"IsDefault": {
													"type": "boolean"
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Filters": {
							"shape": "S49"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S1c",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S2j",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									},
									"SupportsStorageEncryption": {
										"type": "boolean"
									},
									"StorageType": {},
									"SupportsIops": {
										"type": "boolean"
									},
									"SupportsEnhancedMonitoring": {
										"type": "boolean"
									},
									"SupportsIAMDatabaseAuthentication": {
										"type": "boolean"
									},
									"SupportsPerformanceInsights": {
										"type": "boolean"
									},
									"MinStorageSize": {
										"type": "integer"
									},
									"MaxStorageSize": {
										"type": "integer"
									},
									"MinIopsPerDbInstance": {
										"type": "integer"
									},
									"MaxIopsPerDbInstance": {
										"type": "integer"
									},
									"MinIopsPerGib": {
										"type": "double"
									},
									"MaxIopsPerGib": {
										"type": "double"
									},
									"AvailableProcessorFeatures": {
										"shape": "S7f"
									},
									"SupportedEngineModes": {
										"shape": "S4t"
									},
									"SupportsStorageAutoscaling": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribePendingMaintenanceActions": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceIdentifier": {},
						"Filters": {
							"shape": "S49"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribePendingMaintenanceActionsResult",
					"type": "structure",
					"members": {
						"PendingMaintenanceActions": {
							"type": "list",
							"member": {
								"shape": "Sf",
								"locationName": "ResourcePendingMaintenanceActions"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S7n",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S49"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S7p"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeSourceRegions": {
				"input": {
					"type": "structure",
					"members": {
						"RegionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"Filters": {
							"shape": "S49"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSourceRegionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"SourceRegions": {
							"type": "list",
							"member": {
								"locationName": "SourceRegion",
								"type": "structure",
								"members": {
									"RegionName": {},
									"Endpoint": {},
									"Status": {}
								}
							}
						}
					}
				}
			},
			"DescribeValidDBInstanceModifications": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeValidDBInstanceModificationsResult",
					"type": "structure",
					"members": {
						"ValidDBInstanceModificationsMessage": {
							"type": "structure",
							"members": {
								"Storage": {
									"type": "list",
									"member": {
										"locationName": "ValidStorageOptions",
										"type": "structure",
										"members": {
											"StorageType": {},
											"StorageSize": {
												"shape": "S84"
											},
											"ProvisionedIops": {
												"shape": "S84"
											},
											"IopsToStorageRatio": {
												"type": "list",
												"member": {
													"locationName": "DoubleRange",
													"type": "structure",
													"members": {
														"From": {
															"type": "double"
														},
														"To": {
															"type": "double"
														}
													}
												}
											},
											"SupportsStorageAutoscaling": {
												"type": "boolean"
											}
										}
									}
								},
								"ValidProcessorFeatures": {
									"shape": "S7f"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DownloadDBLogFilePortion": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"LogFileName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"LogFileName": {},
						"Marker": {},
						"NumberOfLines": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DownloadDBLogFilePortionResult",
					"type": "structure",
					"members": {
						"LogFileData": {},
						"Marker": {},
						"AdditionalDataPending": {
							"type": "boolean"
						}
					}
				}
			},
			"FailoverDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"TargetDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "FailoverDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {},
						"Filters": {
							"shape": "S49"
						}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "Sb"
						}
					}
				}
			},
			"ModifyCurrentDBClusterCapacity": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"Capacity": {
							"type": "integer"
						},
						"SecondsBeforeTimeout": {
							"type": "integer"
						},
						"TimeoutAction": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyCurrentDBClusterCapacityResult",
					"type": "structure",
					"members": {
						"DBClusterIdentifier": {},
						"PendingCapacity": {
							"type": "integer"
						},
						"CurrentCapacity": {
							"type": "integer"
						},
						"SecondsBeforeTimeout": {
							"type": "integer"
						},
						"TimeoutAction": {}
					}
				}
			},
			"ModifyDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"NewDBClusterIdentifier": {},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"DBClusterParameterGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"Port": {
							"type": "integer"
						},
						"MasterUserPassword": {},
						"OptionGroupName": {},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"BacktrackWindow": {
							"type": "long"
						},
						"CloudwatchLogsExportConfiguration": {
							"shape": "S8h"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"DBInstanceParameterGroupName": {},
						"ScalingConfiguration": {
							"shape": "S1p"
						},
						"DeletionProtection": {
							"type": "boolean"
						},
						"EnableHttpEndpoint": {
							"type": "boolean"
						},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"ModifyDBClusterEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterEndpointIdentifier"
					],
					"members": {
						"DBClusterEndpointIdentifier": {},
						"EndpointType": {},
						"StaticMembers": {
							"shape": "S1s"
						},
						"ExcludedMembers": {
							"shape": "S1s"
						}
					}
				},
				"output": {
					"shape": "S24",
					"resultWrapper": "ModifyDBClusterEndpointResult"
				}
			},
			"ModifyDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"Parameters": {
							"shape": "S4q"
						}
					}
				},
				"output": {
					"shape": "S8l",
					"resultWrapper": "ModifyDBClusterParameterGroupResult"
				}
			},
			"ModifyDBClusterSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier",
						"AttributeName"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {},
						"AttributeName": {},
						"ValuesToAdd": {
							"shape": "S4z"
						},
						"ValuesToRemove": {
							"shape": "S4z"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBClusterSnapshotAttributeResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshotAttributesResult": {
							"shape": "S4w"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSubnetGroupName": {},
						"DBSecurityGroups": {
							"shape": "S2a"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"CACertificateIdentifier": {},
						"Domain": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"MonitoringInterval": {
							"type": "integer"
						},
						"DBPortNumber": {
							"type": "integer"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"MonitoringRoleArn": {},
						"DomainIAMRoleName": {},
						"PromotionTier": {
							"type": "integer"
						},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"EnablePerformanceInsights": {
							"type": "boolean"
						},
						"PerformanceInsightsKMSKeyId": {},
						"PerformanceInsightsRetentionPeriod": {
							"type": "integer"
						},
						"CloudwatchLogsExportConfiguration": {
							"shape": "S8h"
						},
						"ProcessorFeatures": {
							"shape": "S18"
						},
						"UseDefaultProcessorFeatures": {
							"type": "boolean"
						},
						"DeletionProtection": {
							"type": "boolean"
						},
						"MaxAllocatedStorage": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S4q"
						}
					}
				},
				"output": {
					"shape": "S8r",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"EngineVersion": {},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S16"
						}
					}
				}
			},
			"ModifyDBSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"AttributeName"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"AttributeName": {},
						"ValuesToAdd": {
							"shape": "S4z"
						},
						"ValuesToRemove": {
							"shape": "S4z"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSnapshotAttributeResult",
					"type": "structure",
					"members": {
						"DBSnapshotAttributesResult": {
							"shape": "S61"
						}
					}
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S35"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S2g"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S8"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S6"
						}
					}
				}
			},
			"ModifyGlobalCluster": {
				"input": {
					"type": "structure",
					"members": {
						"GlobalClusterIdentifier": {},
						"NewGlobalClusterIdentifier": {},
						"DeletionProtection": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyGlobalClusterResult",
					"type": "structure",
					"members": {
						"GlobalCluster": {
							"shape": "S3b"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"OptionVersion": {},
									"DBSecurityGroupMemberships": {
										"shape": "S2a"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "S1m"
									},
									"OptionSettings": {
										"type": "list",
										"member": {
											"shape": "S1g",
											"locationName": "OptionSetting"
										}
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1c"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"PromoteReadReplicaDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						},
						"Tags": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S7n"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"RemoveFromGlobalCluster": {
				"input": {
					"type": "structure",
					"members": {
						"GlobalClusterIdentifier": {},
						"DbClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveFromGlobalClusterResult",
					"type": "structure",
					"members": {
						"GlobalCluster": {
							"shape": "S3b"
						}
					}
				}
			},
			"RemoveRoleFromDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"RoleArn"
					],
					"members": {
						"DBClusterIdentifier": {},
						"RoleArn": {},
						"FeatureName": {}
					}
				}
			},
			"RemoveRoleFromDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"RoleArn",
						"FeatureName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"RoleArn": {},
						"FeatureName": {}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S6"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S4q"
						}
					}
				},
				"output": {
					"shape": "S8l",
					"resultWrapper": "ResetDBClusterParameterGroupResult"
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S4q"
						}
					}
				},
				"output": {
					"shape": "S8r",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBClusterFromS3": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"Engine",
						"MasterUsername",
						"MasterUserPassword",
						"SourceEngine",
						"SourceEngineVersion",
						"S3BucketName",
						"S3IngestionRoleArn"
					],
					"members": {
						"AvailabilityZones": {
							"shape": "Sz"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"CharacterSetName": {},
						"DatabaseName": {},
						"DBClusterIdentifier": {},
						"DBClusterParameterGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"DBSubnetGroupName": {},
						"Engine": {},
						"EngineVersion": {},
						"Port": {
							"type": "integer"
						},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"OptionGroupName": {},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"Tags": {
							"shape": "Sb"
						},
						"StorageEncrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"SourceEngine": {},
						"SourceEngineVersion": {},
						"S3BucketName": {},
						"S3Prefix": {},
						"S3IngestionRoleArn": {},
						"BacktrackWindow": {
							"type": "long"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"DeletionProtection": {
							"type": "boolean"
						},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBClusterFromS3Result",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"RestoreDBClusterFromSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"SnapshotIdentifier",
						"Engine"
					],
					"members": {
						"AvailabilityZones": {
							"shape": "Sz"
						},
						"DBClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"Engine": {},
						"EngineVersion": {},
						"Port": {
							"type": "integer"
						},
						"DBSubnetGroupName": {},
						"DatabaseName": {},
						"OptionGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"Tags": {
							"shape": "Sb"
						},
						"KmsKeyId": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"BacktrackWindow": {
							"type": "long"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"EngineMode": {},
						"ScalingConfiguration": {
							"shape": "S1p"
						},
						"DBClusterParameterGroupName": {},
						"DeletionProtection": {
							"type": "boolean"
						},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBClusterFromSnapshotResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"RestoreDBClusterToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"SourceDBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"RestoreType": {},
						"SourceDBClusterIdentifier": {},
						"RestoreToTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"Port": {
							"type": "integer"
						},
						"DBSubnetGroupName": {},
						"OptionGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"Tags": {
							"shape": "Sb"
						},
						"KmsKeyId": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"BacktrackWindow": {
							"type": "long"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"DBClusterParameterGroupName": {},
						"DeletionProtection": {
							"type": "boolean"
						},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBClusterToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "Sb"
						},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"Domain": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"DomainIAMRoleName": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"ProcessorFeatures": {
							"shape": "S18"
						},
						"UseDefaultProcessorFeatures": {
							"type": "boolean"
						},
						"DBParameterGroupName": {},
						"DeletionProtection": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"RestoreDBInstanceFromS3": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBInstanceClass",
						"Engine",
						"SourceEngine",
						"SourceEngineVersion",
						"S3BucketName",
						"S3IngestionRoleArn"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "S2a"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sb"
						},
						"StorageType": {},
						"StorageEncrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"MonitoringInterval": {
							"type": "integer"
						},
						"MonitoringRoleArn": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"SourceEngine": {},
						"SourceEngineVersion": {},
						"S3BucketName": {},
						"S3Prefix": {},
						"S3IngestionRoleArn": {},
						"EnablePerformanceInsights": {
							"type": "boolean"
						},
						"PerformanceInsightsKMSKeyId": {},
						"PerformanceInsightsRetentionPeriod": {
							"type": "integer"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"ProcessorFeatures": {
							"shape": "S18"
						},
						"UseDefaultProcessorFeatures": {
							"type": "boolean"
						},
						"DeletionProtection": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromS3Result",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sb"
						},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"VpcSecurityGroupIds": {
							"shape": "S1m"
						},
						"Domain": {},
						"DomainIAMRoleName": {},
						"EnableIAMDatabaseAuthentication": {
							"type": "boolean"
						},
						"EnableCloudwatchLogsExports": {
							"shape": "S1o"
						},
						"ProcessorFeatures": {
							"shape": "S18"
						},
						"UseDefaultProcessorFeatures": {
							"type": "boolean"
						},
						"DBParameterGroupName": {},
						"DeletionProtection": {
							"type": "boolean"
						},
						"SourceDbiResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sl"
						}
					}
				}
			},
			"StartActivityStream": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Mode",
						"KmsKeyId"
					],
					"members": {
						"ResourceArn": {},
						"Mode": {},
						"KmsKeyId": {},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "StartActivityStreamResult",
					"type": "structure",
					"members": {
						"KmsKeyId": {},
						"KinesisStreamName": {},
						"Status": {},
						"Mode": {},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				}
			},
			"StartDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "StartDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"StartDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "StartDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			},
			"StopActivityStream": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "StopActivityStreamResult",
					"type": "structure",
					"members": {
						"KmsKeyId": {},
						"KinesisStreamName": {},
						"Status": {}
					}
				}
			},
			"StopDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "StopDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1r"
						}
					}
				}
			},
			"StopDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "StopDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S2c"
						}
					}
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S7"
					},
					"EventCategoriesList": {
						"shape": "S8"
					},
					"Enabled": {
						"type": "boolean"
					},
					"EventSubscriptionArn": {}
				},
				"wrapper": true
			},
			"S7": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S8": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"Sb": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sf": {
				"type": "structure",
				"members": {
					"ResourceIdentifier": {},
					"PendingMaintenanceActionDetails": {
						"type": "list",
						"member": {
							"locationName": "PendingMaintenanceAction",
							"type": "structure",
							"members": {
								"Action": {},
								"AutoAppliedAfterDate": {
									"type": "timestamp"
								},
								"ForcedApplyDate": {
									"type": "timestamp"
								},
								"OptInStatus": {},
								"CurrentApplyDate": {
									"type": "timestamp"
								},
								"Description": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sl": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					},
					"DBSecurityGroupArn": {}
				},
				"wrapper": true
			},
			"Ss": {
				"type": "structure",
				"members": {
					"DBClusterIdentifier": {},
					"BacktrackIdentifier": {},
					"BacktrackTo": {
						"type": "timestamp"
					},
					"BacktrackedFrom": {
						"type": "timestamp"
					},
					"BacktrackRequestCreationTime": {
						"type": "timestamp"
					},
					"Status": {}
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"DBClusterParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"DBClusterParameterGroupArn": {}
				},
				"wrapper": true
			},
			"Sy": {
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"shape": "Sz"
					},
					"DBClusterSnapshotIdentifier": {},
					"DBClusterIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"VpcId": {},
					"ClusterCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"PercentProgress": {
						"type": "integer"
					},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DBClusterSnapshotArn": {},
					"SourceDBClusterSnapshotArn": {},
					"IAMDatabaseAuthenticationEnabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"Sz": {
				"type": "list",
				"member": {
					"locationName": "AvailabilityZone"
				}
			},
			"S13": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"DBParameterGroupArn": {}
				},
				"wrapper": true
			},
			"S16": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PercentProgress": {
						"type": "integer"
					},
					"SourceRegion": {},
					"SourceDBSnapshotIdentifier": {},
					"StorageType": {},
					"TdeCredentialArn": {},
					"Encrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DBSnapshotArn": {},
					"Timezone": {},
					"IAMDatabaseAuthenticationEnabled": {
						"type": "boolean"
					},
					"ProcessorFeatures": {
						"shape": "S18"
					},
					"DbiResourceId": {}
				},
				"wrapper": true
			},
			"S18": {
				"type": "list",
				"member": {
					"locationName": "ProcessorFeature",
					"type": "structure",
					"members": {
						"Name": {},
						"Value": {}
					}
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"Port": {
									"type": "integer"
								},
								"OptionVersion": {},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1g",
										"locationName": "OptionSetting"
									}
								},
								"DBSecurityGroupMemberships": {
									"shape": "S1h"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "S1j"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {},
					"OptionGroupArn": {}
				},
				"wrapper": true
			},
			"S1g": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {},
					"DefaultValue": {},
					"Description": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"IsCollection": {
						"type": "boolean"
					}
				}
			},
			"S1h": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"S1j": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S1m": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"S1o": {
				"type": "list",
				"member": {}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"MinCapacity": {
						"type": "integer"
					},
					"MaxCapacity": {
						"type": "integer"
					},
					"AutoPause": {
						"type": "boolean"
					},
					"SecondsUntilAutoPause": {
						"type": "integer"
					},
					"TimeoutAction": {}
				}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"AllocatedStorage": {
						"type": "integer"
					},
					"AvailabilityZones": {
						"shape": "Sz"
					},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"CharacterSetName": {},
					"DatabaseName": {},
					"DBClusterIdentifier": {},
					"DBClusterParameterGroup": {},
					"DBSubnetGroup": {},
					"Status": {},
					"PercentProgress": {},
					"EarliestRestorableTime": {
						"type": "timestamp"
					},
					"Endpoint": {},
					"ReaderEndpoint": {},
					"CustomEndpoints": {
						"shape": "S1s"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"Engine": {},
					"EngineVersion": {},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"Port": {
						"type": "integer"
					},
					"MasterUsername": {},
					"DBClusterOptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "DBClusterOptionGroup",
							"type": "structure",
							"members": {
								"DBClusterOptionGroupName": {},
								"Status": {}
							}
						}
					},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"ReplicationSourceIdentifier": {},
					"ReadReplicaIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaIdentifier"
						}
					},
					"DBClusterMembers": {
						"type": "list",
						"member": {
							"locationName": "DBClusterMember",
							"type": "structure",
							"members": {
								"DBInstanceIdentifier": {},
								"IsClusterWriter": {
									"type": "boolean"
								},
								"DBClusterParameterGroupStatus": {},
								"PromotionTier": {
									"type": "integer"
								}
							},
							"wrapper": true
						}
					},
					"VpcSecurityGroups": {
						"shape": "S1j"
					},
					"HostedZoneId": {},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DbClusterResourceId": {},
					"DBClusterArn": {},
					"AssociatedRoles": {
						"type": "list",
						"member": {
							"locationName": "DBClusterRole",
							"type": "structure",
							"members": {
								"RoleArn": {},
								"Status": {},
								"FeatureName": {}
							}
						}
					},
					"IAMDatabaseAuthenticationEnabled": {
						"type": "boolean"
					},
					"CloneGroupId": {},
					"ClusterCreateTime": {
						"type": "timestamp"
					},
					"EarliestBacktrackTime": {
						"type": "timestamp"
					},
					"BacktrackWindow": {
						"type": "long"
					},
					"BacktrackConsumedChangeRecords": {
						"type": "long"
					},
					"EnabledCloudwatchLogsExports": {
						"shape": "S1o"
					},
					"Capacity": {
						"type": "integer"
					},
					"EngineMode": {},
					"ScalingConfigurationInfo": {
						"type": "structure",
						"members": {
							"MinCapacity": {
								"type": "integer"
							},
							"MaxCapacity": {
								"type": "integer"
							},
							"AutoPause": {
								"type": "boolean"
							},
							"SecondsUntilAutoPause": {
								"type": "integer"
							},
							"TimeoutAction": {}
						}
					},
					"DeletionProtection": {
						"type": "boolean"
					},
					"HttpEndpointEnabled": {
						"type": "boolean"
					},
					"ActivityStreamMode": {},
					"ActivityStreamStatus": {},
					"ActivityStreamKmsKeyId": {},
					"ActivityStreamKinesisStreamName": {},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"CrossAccountClone": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S1s": {
				"type": "list",
				"member": {}
			},
			"S24": {
				"type": "structure",
				"members": {
					"DBClusterEndpointIdentifier": {},
					"DBClusterIdentifier": {},
					"DBClusterEndpointResourceIdentifier": {},
					"Endpoint": {},
					"Status": {},
					"EndpointType": {},
					"CustomEndpointType": {},
					"StaticMembers": {
						"shape": "S1s"
					},
					"ExcludedMembers": {
						"shape": "S1s"
					},
					"DBClusterEndpointArn": {}
				}
			},
			"S2a": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"shape": "S2d"
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "S1h"
					},
					"VpcSecurityGroups": {
						"shape": "S1j"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S2g"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"LicenseModel": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {},
							"StorageType": {},
							"CACertificateIdentifier": {},
							"DBSubnetGroupName": {},
							"PendingCloudwatchLogsExports": {
								"type": "structure",
								"members": {
									"LogTypesToEnable": {
										"shape": "S1o"
									},
									"LogTypesToDisable": {
										"shape": "S1o"
									}
								}
							},
							"ProcessorFeatures": {
								"shape": "S18"
							}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"ReadReplicaDBClusterIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBClusterIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupMembership",
							"type": "structure",
							"members": {
								"OptionGroupName": {},
								"Status": {}
							}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"StatusInfos": {
						"type": "list",
						"member": {
							"locationName": "DBInstanceStatusInfo",
							"type": "structure",
							"members": {
								"StatusType": {},
								"Normal": {
									"type": "boolean"
								},
								"Status": {},
								"Message": {}
							}
						}
					},
					"StorageType": {},
					"TdeCredentialArn": {},
					"DbInstancePort": {
						"type": "integer"
					},
					"DBClusterIdentifier": {},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DbiResourceId": {},
					"CACertificateIdentifier": {},
					"DomainMemberships": {
						"type": "list",
						"member": {
							"locationName": "DomainMembership",
							"type": "structure",
							"members": {
								"Domain": {},
								"Status": {},
								"FQDN": {},
								"IAMRoleName": {}
							}
						}
					},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"MonitoringInterval": {
						"type": "integer"
					},
					"EnhancedMonitoringResourceArn": {},
					"MonitoringRoleArn": {},
					"PromotionTier": {
						"type": "integer"
					},
					"DBInstanceArn": {},
					"Timezone": {},
					"IAMDatabaseAuthenticationEnabled": {
						"type": "boolean"
					},
					"PerformanceInsightsEnabled": {
						"type": "boolean"
					},
					"PerformanceInsightsKMSKeyId": {},
					"PerformanceInsightsRetentionPeriod": {
						"type": "integer"
					},
					"EnabledCloudwatchLogsExports": {
						"shape": "S1o"
					},
					"ProcessorFeatures": {
						"shape": "S18"
					},
					"DeletionProtection": {
						"type": "boolean"
					},
					"AssociatedRoles": {
						"type": "list",
						"member": {
							"locationName": "DBInstanceRole",
							"type": "structure",
							"members": {
								"RoleArn": {},
								"FeatureName": {},
								"Status": {}
							}
						}
					},
					"ListenerEndpoint": {
						"shape": "S2d"
					},
					"MaxAllocatedStorage": {
						"type": "integer"
					}
				},
				"wrapper": true
			},
			"S2d": {
				"type": "structure",
				"members": {
					"Address": {},
					"Port": {
						"type": "integer"
					},
					"HostedZoneId": {}
				}
			},
			"S2g": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S2j"
								},
								"SubnetStatus": {}
							}
						}
					},
					"DBSubnetGroupArn": {}
				},
				"wrapper": true
			},
			"S2j": {
				"type": "structure",
				"members": {
					"Name": {}
				},
				"wrapper": true
			},
			"S35": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S3b": {
				"type": "structure",
				"members": {
					"GlobalClusterIdentifier": {},
					"GlobalClusterResourceId": {},
					"GlobalClusterArn": {},
					"Status": {},
					"Engine": {},
					"EngineVersion": {},
					"DatabaseName": {},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"DeletionProtection": {
						"type": "boolean"
					},
					"GlobalClusterMembers": {
						"type": "list",
						"member": {
							"locationName": "GlobalClusterMember",
							"type": "structure",
							"members": {
								"DBClusterArn": {},
								"Readers": {
									"type": "list",
									"member": {}
								},
								"IsWriter": {
									"type": "boolean"
								}
							},
							"wrapper": true
						}
					}
				},
				"wrapper": true
			},
			"S3r": {
				"type": "structure",
				"members": {
					"DBInstanceArn": {},
					"DbiResourceId": {},
					"Region": {},
					"DBInstanceIdentifier": {},
					"RestoreWindow": {
						"type": "structure",
						"members": {
							"EarliestTime": {
								"type": "timestamp"
							},
							"LatestTime": {
								"type": "timestamp"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"Engine": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"TdeCredentialArn": {},
					"Encrypted": {
						"type": "boolean"
					},
					"StorageType": {},
					"KmsKeyId": {},
					"Timezone": {},
					"IAMDatabaseAuthenticationEnabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S49": {
				"type": "list",
				"member": {
					"locationName": "Filter",
					"type": "structure",
					"required": [
						"Name",
						"Values"
					],
					"members": {
						"Name": {},
						"Values": {
							"type": "list",
							"member": {
								"locationName": "Value"
							}
						}
					}
				}
			},
			"S4q": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {},
						"SupportedEngineModes": {
							"shape": "S4t"
						}
					}
				}
			},
			"S4t": {
				"type": "list",
				"member": {}
			},
			"S4w": {
				"type": "structure",
				"members": {
					"DBClusterSnapshotIdentifier": {},
					"DBClusterSnapshotAttributes": {
						"type": "list",
						"member": {
							"locationName": "DBClusterSnapshotAttribute",
							"type": "structure",
							"members": {
								"AttributeName": {},
								"AttributeValues": {
									"shape": "S4z"
								}
							}
						}
					}
				},
				"wrapper": true
			},
			"S4z": {
				"type": "list",
				"member": {
					"locationName": "AttributeValue"
				}
			},
			"S5a": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S61": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBSnapshotAttributes": {
						"type": "list",
						"member": {
							"locationName": "DBSnapshotAttribute",
							"type": "structure",
							"members": {
								"AttributeName": {},
								"AttributeValues": {
									"shape": "S4z"
								}
							},
							"wrapper": true
						}
					}
				},
				"wrapper": true
			},
			"S6c": {
				"type": "structure",
				"members": {
					"DBParameterGroupFamily": {},
					"Marker": {},
					"Parameters": {
						"shape": "S4q"
					}
				},
				"wrapper": true
			},
			"S7f": {
				"type": "list",
				"member": {
					"locationName": "AvailableProcessorFeature",
					"type": "structure",
					"members": {
						"Name": {},
						"DefaultValue": {},
						"AllowedValues": {}
					}
				}
			},
			"S7n": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S7p"
					},
					"ReservedDBInstanceArn": {}
				},
				"wrapper": true
			},
			"S7p": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S84": {
				"type": "list",
				"member": {
					"locationName": "Range",
					"type": "structure",
					"members": {
						"From": {
							"type": "integer"
						},
						"To": {
							"type": "integer"
						},
						"Step": {
							"type": "integer"
						}
					}
				}
			},
			"S8h": {
				"type": "structure",
				"members": {
					"EnableLogTypes": {
						"shape": "S1o"
					},
					"DisableLogTypes": {
						"shape": "S1o"
					}
				}
			},
			"S8l": {
				"type": "structure",
				"members": {
					"DBClusterParameterGroupName": {}
				}
			},
			"S8r": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 1817 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDBClusters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBClusters"
			},
			"DescribeDBEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBEngineVersions"
			},
			"DescribeDBInstanceAutomatedBackups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstanceAutomatedBackups"
			},
			"DescribeDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstances"
			},
			"DescribeDBLogFiles": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DescribeDBLogFiles"
			},
			"DescribeDBParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBParameterGroups"
			},
			"DescribeDBParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeDBSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSecurityGroups"
			},
			"DescribeDBSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSnapshots"
			},
			"DescribeDBSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeGlobalClusters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "GlobalClusters"
			},
			"DescribeOptionGroupOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupOptions"
			},
			"DescribeOptionGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupsList"
			},
			"DescribeOrderableDBInstanceOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableDBInstanceOptions"
			},
			"DescribeReservedDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstances"
			},
			"DescribeReservedDBInstancesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstancesOfferings"
			},
			"DownloadDBLogFilePortion": {
				"input_token": "Marker",
				"limit_key": "NumberOfLines",
				"more_results": "AdditionalDataPending",
				"output_token": "Marker",
				"result_key": "LogFileData"
			},
			"ListTagsForResource": {
				"result_key": "TagList"
			}
		}
	};

/***/ },
/* 1818 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DBInstanceAvailable": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-restore",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-parameters",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			},
			"DBInstanceDeleted": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "DBInstanceNotFound",
						"matcher": "error",
						"state": "success"
					},
					{
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "resetting-master-credentials",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			},
			"DBSnapshotAvailable": {
				"delay": 30,
				"operation": "DescribeDBSnapshots",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "incompatible-restore",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "incompatible-parameters",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					}
				]
			},
			"DBSnapshotDeleted": {
				"delay": 30,
				"operation": "DescribeDBSnapshots",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "DBSnapshotNotFound",
						"matcher": "error",
						"state": "success"
					},
					{
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					},
					{
						"expected": "resetting-master-credentials",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBSnapshots[].Status"
					}
				]
			}
		}
	};

/***/ },
/* 1819 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-12-01",
			"endpointPrefix": "redshift",
			"protocol": "query",
			"serviceFullName": "Amazon Redshift",
			"serviceId": "Redshift",
			"signatureVersion": "v4",
			"uid": "redshift-2012-12-01",
			"xmlNamespace": "http://redshift.amazonaws.com/doc/2012-12-01/"
		},
		"operations": {
			"AcceptReservedNodeExchange": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedNodeId",
						"TargetReservedNodeOfferingId"
					],
					"members": {
						"ReservedNodeId": {},
						"TargetReservedNodeOfferingId": {}
					}
				},
				"output": {
					"resultWrapper": "AcceptReservedNodeExchangeResult",
					"type": "structure",
					"members": {
						"ExchangedReservedNode": {
							"shape": "S4"
						}
					}
				}
			},
			"AuthorizeClusterSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName"
					],
					"members": {
						"ClusterSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeClusterSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"ClusterSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"AuthorizeSnapshotAccess": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier",
						"AccountWithRestoreAccess"
					],
					"members": {
						"SnapshotIdentifier": {},
						"SnapshotClusterIdentifier": {},
						"AccountWithRestoreAccess": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeSnapshotAccessResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"BatchDeleteClusterSnapshots": {
				"input": {
					"type": "structure",
					"required": [
						"Identifiers"
					],
					"members": {
						"Identifiers": {
							"type": "list",
							"member": {
								"shape": "Sv",
								"locationName": "DeleteClusterSnapshotMessage"
							}
						}
					}
				},
				"output": {
					"resultWrapper": "BatchDeleteClusterSnapshotsResult",
					"type": "structure",
					"members": {
						"Resources": {
							"shape": "Sx"
						},
						"Errors": {
							"type": "list",
							"member": {
								"shape": "Sz",
								"locationName": "SnapshotErrorMessage"
							}
						}
					}
				}
			},
			"BatchModifyClusterSnapshots": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifierList"
					],
					"members": {
						"SnapshotIdentifierList": {
							"shape": "Sx"
						},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"Force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "BatchModifyClusterSnapshotsResult",
					"type": "structure",
					"members": {
						"Resources": {
							"shape": "Sx"
						},
						"Errors": {
							"type": "list",
							"member": {
								"shape": "Sz",
								"locationName": "SnapshotErrorMessage"
							}
						}
					}
				}
			},
			"CancelResize": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"shape": "S14",
					"resultWrapper": "CancelResizeResult"
				}
			},
			"CopyClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceSnapshotIdentifier",
						"TargetSnapshotIdentifier"
					],
					"members": {
						"SourceSnapshotIdentifier": {},
						"SourceSnapshotClusterIdentifier": {},
						"TargetSnapshotIdentifier": {},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"CreateCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"NodeType",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"ClusterIdentifier": {},
						"ClusterType": {},
						"NodeType": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"ClusterSecurityGroups": {
							"shape": "S1d"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1e"
						},
						"ClusterSubnetGroupName": {},
						"AvailabilityZone": {},
						"PreferredMaintenanceWindow": {},
						"ClusterParameterGroupName": {},
						"AutomatedSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"Port": {
							"type": "integer"
						},
						"ClusterVersion": {},
						"AllowVersionUpgrade": {
							"type": "boolean"
						},
						"NumberOfNodes": {
							"type": "integer"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Encrypted": {
							"type": "boolean"
						},
						"HsmClientCertificateIdentifier": {},
						"HsmConfigurationIdentifier": {},
						"ElasticIp": {},
						"Tags": {
							"shape": "Sg"
						},
						"KmsKeyId": {},
						"EnhancedVpcRouting": {
							"type": "boolean"
						},
						"AdditionalInfo": {},
						"IamRoles": {
							"shape": "S1g"
						},
						"MaintenanceTrackName": {},
						"SnapshotScheduleIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"CreateClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName",
						"ParameterGroupFamily",
						"Description"
					],
					"members": {
						"ParameterGroupName": {},
						"ParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterParameterGroupResult",
					"type": "structure",
					"members": {
						"ClusterParameterGroup": {
							"shape": "S29"
						}
					}
				}
			},
			"CreateClusterSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName",
						"Description"
					],
					"members": {
						"ClusterSecurityGroupName": {},
						"Description": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterSecurityGroupResult",
					"type": "structure",
					"members": {
						"ClusterSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier",
						"ClusterIdentifier"
					],
					"members": {
						"SnapshotIdentifier": {},
						"ClusterIdentifier": {},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"CreateClusterSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSubnetGroupName",
						"Description",
						"SubnetIds"
					],
					"members": {
						"ClusterSubnetGroupName": {},
						"Description": {},
						"SubnetIds": {
							"shape": "S2f"
						},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterSubnetGroupResult",
					"type": "structure",
					"members": {
						"ClusterSubnetGroup": {
							"shape": "S2h"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"SourceIds": {
							"shape": "S2o"
						},
						"EventCategories": {
							"shape": "S2p"
						},
						"Severity": {},
						"Enabled": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S2r"
						}
					}
				}
			},
			"CreateHsmClientCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"HsmClientCertificateIdentifier"
					],
					"members": {
						"HsmClientCertificateIdentifier": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateHsmClientCertificateResult",
					"type": "structure",
					"members": {
						"HsmClientCertificate": {
							"shape": "S2u"
						}
					}
				}
			},
			"CreateHsmConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"HsmConfigurationIdentifier",
						"Description",
						"HsmIpAddress",
						"HsmPartitionName",
						"HsmPartitionPassword",
						"HsmServerPublicCertificate"
					],
					"members": {
						"HsmConfigurationIdentifier": {},
						"Description": {},
						"HsmIpAddress": {},
						"HsmPartitionName": {},
						"HsmPartitionPassword": {},
						"HsmServerPublicCertificate": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateHsmConfigurationResult",
					"type": "structure",
					"members": {
						"HsmConfiguration": {
							"shape": "S2x"
						}
					}
				}
			},
			"CreateSnapshotCopyGrant": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotCopyGrantName"
					],
					"members": {
						"SnapshotCopyGrantName": {},
						"KmsKeyId": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateSnapshotCopyGrantResult",
					"type": "structure",
					"members": {
						"SnapshotCopyGrant": {
							"shape": "S30"
						}
					}
				}
			},
			"CreateSnapshotSchedule": {
				"input": {
					"type": "structure",
					"members": {
						"ScheduleDefinitions": {
							"shape": "S32"
						},
						"ScheduleIdentifier": {},
						"ScheduleDescription": {},
						"Tags": {
							"shape": "Sg"
						},
						"DryRun": {
							"type": "boolean"
						},
						"NextInvocations": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S33",
					"resultWrapper": "CreateSnapshotScheduleResult"
				}
			},
			"CreateTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "Sg"
						}
					}
				}
			},
			"DeleteCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"SkipFinalClusterSnapshot": {
							"type": "boolean"
						},
						"FinalClusterSnapshotIdentifier": {},
						"FinalClusterSnapshotRetentionPeriod": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"DeleteClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName"
					],
					"members": {
						"ParameterGroupName": {}
					}
				}
			},
			"DeleteClusterSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName"
					],
					"members": {
						"ClusterSecurityGroupName": {}
					}
				}
			},
			"DeleteClusterSnapshot": {
				"input": {
					"shape": "Sv"
				},
				"output": {
					"resultWrapper": "DeleteClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"DeleteClusterSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSubnetGroupName"
					],
					"members": {
						"ClusterSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				}
			},
			"DeleteHsmClientCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"HsmClientCertificateIdentifier"
					],
					"members": {
						"HsmClientCertificateIdentifier": {}
					}
				}
			},
			"DeleteHsmConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"HsmConfigurationIdentifier"
					],
					"members": {
						"HsmConfigurationIdentifier": {}
					}
				}
			},
			"DeleteSnapshotCopyGrant": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotCopyGrantName"
					],
					"members": {
						"SnapshotCopyGrantName": {}
					}
				}
			},
			"DeleteSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"ScheduleIdentifier"
					],
					"members": {
						"ScheduleIdentifier": {}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"shape": "S3k"
						}
					}
				}
			},
			"DescribeAccountAttributes": {
				"input": {
					"type": "structure",
					"members": {
						"AttributeNames": {
							"type": "list",
							"member": {
								"locationName": "AttributeName"
							}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeAccountAttributesResult",
					"type": "structure",
					"members": {
						"AccountAttributes": {
							"type": "list",
							"member": {
								"locationName": "AccountAttribute",
								"type": "structure",
								"members": {
									"AttributeName": {},
									"AttributeValues": {
										"type": "list",
										"member": {
											"locationName": "AttributeValueTarget",
											"type": "structure",
											"members": {
												"AttributeValue": {}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeClusterDbRevisions": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterDbRevisionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ClusterDbRevisions": {
							"type": "list",
							"member": {
								"locationName": "ClusterDbRevision",
								"type": "structure",
								"members": {
									"ClusterIdentifier": {},
									"CurrentDatabaseRevision": {},
									"DatabaseRevisionReleaseDate": {
										"type": "timestamp"
									},
									"RevisionTargets": {
										"type": "list",
										"member": {
											"locationName": "RevisionTarget",
											"type": "structure",
											"members": {
												"DatabaseRevision": {},
												"Description": {},
												"DatabaseRevisionReleaseDate": {
													"type": "timestamp"
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeClusterParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S29",
								"locationName": "ClusterParameterGroup"
							}
						}
					}
				}
			},
			"DescribeClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName"
					],
					"members": {
						"ParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S44"
						},
						"Marker": {}
					}
				}
			},
			"DescribeClusterSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ClusterSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "ClusterSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeClusterSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"SnapshotType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"OwnerAccount": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						},
						"ClusterExists": {
							"type": "boolean"
						},
						"SortingEntities": {
							"type": "list",
							"member": {
								"locationName": "SnapshotSortingEntity",
								"type": "structure",
								"required": [
									"Attribute"
								],
								"members": {
									"Attribute": {},
									"SortOrder": {}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Snapshots": {
							"type": "list",
							"member": {
								"shape": "Sm",
								"locationName": "Snapshot"
							}
						}
					}
				}
			},
			"DescribeClusterSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ClusterSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S2h",
								"locationName": "ClusterSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeClusterTracks": {
				"input": {
					"type": "structure",
					"members": {
						"MaintenanceTrackName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterTracksResult",
					"type": "structure",
					"members": {
						"MaintenanceTracks": {
							"type": "list",
							"member": {
								"locationName": "MaintenanceTrack",
								"type": "structure",
								"members": {
									"MaintenanceTrackName": {},
									"DatabaseVersion": {},
									"UpdateTargets": {
										"type": "list",
										"member": {
											"locationName": "UpdateTarget",
											"type": "structure",
											"members": {
												"MaintenanceTrackName": {},
												"DatabaseVersion": {},
												"SupportedOperations": {
													"type": "list",
													"member": {
														"locationName": "SupportedOperation",
														"type": "structure",
														"members": {
															"OperationName": {}
														}
													}
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeClusterVersions": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterVersion": {},
						"ClusterParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ClusterVersions": {
							"type": "list",
							"member": {
								"locationName": "ClusterVersion",
								"type": "structure",
								"members": {
									"ClusterVersion": {},
									"ClusterParameterGroupFamily": {},
									"Description": {}
								}
							}
						}
					}
				}
			},
			"DescribeClusters": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClustersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Clusters": {
							"type": "list",
							"member": {
								"shape": "S1i",
								"locationName": "Cluster"
							}
						}
					}
				}
			},
			"DescribeDefaultClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupFamily"
					],
					"members": {
						"ParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDefaultClusterParametersResult",
					"type": "structure",
					"members": {
						"DefaultClusterParameters": {
							"type": "structure",
							"members": {
								"ParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S44"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"Events": {
										"type": "list",
										"member": {
											"locationName": "EventInfoMap",
											"type": "structure",
											"members": {
												"EventId": {},
												"EventCategories": {
													"shape": "S2p"
												},
												"EventDescription": {},
												"Severity": {}
											},
											"wrapper": true
										}
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S2r",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S2p"
									},
									"Severity": {},
									"Date": {
										"type": "timestamp"
									},
									"EventId": {}
								}
							}
						}
					}
				}
			},
			"DescribeHsmClientCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"HsmClientCertificateIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeHsmClientCertificatesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"HsmClientCertificates": {
							"type": "list",
							"member": {
								"shape": "S2u",
								"locationName": "HsmClientCertificate"
							}
						}
					}
				}
			},
			"DescribeHsmConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"HsmConfigurationIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeHsmConfigurationsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"HsmConfigurations": {
							"type": "list",
							"member": {
								"shape": "S2x",
								"locationName": "HsmConfiguration"
							}
						}
					}
				}
			},
			"DescribeLoggingStatus": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"shape": "S5n",
					"resultWrapper": "DescribeLoggingStatusResult"
				}
			},
			"DescribeOrderableClusterOptions": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterVersion": {},
						"NodeType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableClusterOptionsResult",
					"type": "structure",
					"members": {
						"OrderableClusterOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableClusterOption",
								"type": "structure",
								"members": {
									"ClusterVersion": {},
									"ClusterType": {},
									"NodeType": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S2k",
											"locationName": "AvailabilityZone"
										}
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedNodeOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedNodeOfferingId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedNodeOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedNodeOfferings": {
							"shape": "S5v"
						}
					}
				}
			},
			"DescribeReservedNodes": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedNodeId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedNodesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedNodes": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "ReservedNode"
							}
						}
					}
				}
			},
			"DescribeResize": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"shape": "S14",
					"resultWrapper": "DescribeResizeResult"
				}
			},
			"DescribeSnapshotCopyGrants": {
				"input": {
					"type": "structure",
					"members": {
						"SnapshotCopyGrantName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSnapshotCopyGrantsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"SnapshotCopyGrants": {
							"type": "list",
							"member": {
								"shape": "S30",
								"locationName": "SnapshotCopyGrant"
							}
						}
					}
				}
			},
			"DescribeSnapshotSchedules": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"ScheduleIdentifier": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSnapshotSchedulesResult",
					"type": "structure",
					"members": {
						"SnapshotSchedules": {
							"type": "list",
							"member": {
								"shape": "S33",
								"locationName": "SnapshotSchedule"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeStorage": {
				"output": {
					"resultWrapper": "DescribeStorageResult",
					"type": "structure",
					"members": {
						"TotalBackupSizeInMegaBytes": {
							"type": "double"
						},
						"TotalProvisionedStorageInMegaBytes": {
							"type": "double"
						}
					}
				}
			},
			"DescribeTableRestoreStatus": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"TableRestoreRequestId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeTableRestoreStatusResult",
					"type": "structure",
					"members": {
						"TableRestoreStatusDetails": {
							"type": "list",
							"member": {
								"shape": "S6b",
								"locationName": "TableRestoreStatus"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceName": {},
						"ResourceType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S3k"
						},
						"TagValues": {
							"shape": "S3z"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"TaggedResources": {
							"type": "list",
							"member": {
								"locationName": "TaggedResource",
								"type": "structure",
								"members": {
									"Tag": {
										"shape": "Sh"
									},
									"ResourceName": {},
									"ResourceType": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DisableLogging": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"shape": "S5n",
					"resultWrapper": "DisableLoggingResult"
				}
			},
			"DisableSnapshotCopy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DisableSnapshotCopyResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"EnableLogging": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"BucketName"
					],
					"members": {
						"ClusterIdentifier": {},
						"BucketName": {},
						"S3KeyPrefix": {}
					}
				},
				"output": {
					"shape": "S5n",
					"resultWrapper": "EnableLoggingResult"
				}
			},
			"EnableSnapshotCopy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"DestinationRegion"
					],
					"members": {
						"ClusterIdentifier": {},
						"DestinationRegion": {},
						"RetentionPeriod": {
							"type": "integer"
						},
						"SnapshotCopyGrantName": {},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "EnableSnapshotCopyResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"GetClusterCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"DbUser",
						"ClusterIdentifier"
					],
					"members": {
						"DbUser": {},
						"DbName": {},
						"ClusterIdentifier": {},
						"DurationSeconds": {
							"type": "integer"
						},
						"AutoCreate": {
							"type": "boolean"
						},
						"DbGroups": {
							"type": "list",
							"member": {
								"locationName": "DbGroup"
							}
						}
					}
				},
				"output": {
					"resultWrapper": "GetClusterCredentialsResult",
					"type": "structure",
					"members": {
						"DbUser": {},
						"DbPassword": {
							"type": "string",
							"sensitive": true
						},
						"Expiration": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetReservedNodeExchangeOfferings": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedNodeId"
					],
					"members": {
						"ReservedNodeId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "GetReservedNodeExchangeOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedNodeOfferings": {
							"shape": "S5v"
						}
					}
				}
			},
			"ModifyCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"ClusterType": {},
						"NodeType": {},
						"NumberOfNodes": {
							"type": "integer"
						},
						"ClusterSecurityGroups": {
							"shape": "S1d"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1e"
						},
						"MasterUserPassword": {},
						"ClusterParameterGroupName": {},
						"AutomatedSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"PreferredMaintenanceWindow": {},
						"ClusterVersion": {},
						"AllowVersionUpgrade": {
							"type": "boolean"
						},
						"HsmClientCertificateIdentifier": {},
						"HsmConfigurationIdentifier": {},
						"NewClusterIdentifier": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"ElasticIp": {},
						"EnhancedVpcRouting": {
							"type": "boolean"
						},
						"MaintenanceTrackName": {},
						"Encrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"ModifyClusterDbRevision": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"RevisionTarget"
					],
					"members": {
						"ClusterIdentifier": {},
						"RevisionTarget": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterDbRevisionResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"ModifyClusterIamRoles": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"AddIamRoles": {
							"shape": "S1g"
						},
						"RemoveIamRoles": {
							"shape": "S1g"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterIamRolesResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"ModifyClusterMaintenance": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"DeferMaintenance": {
							"type": "boolean"
						},
						"DeferMaintenanceIdentifier": {},
						"DeferMaintenanceStartTime": {
							"type": "timestamp"
						},
						"DeferMaintenanceEndTime": {
							"type": "timestamp"
						},
						"DeferMaintenanceDuration": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterMaintenanceResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"ModifyClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName",
						"Parameters"
					],
					"members": {
						"ParameterGroupName": {},
						"Parameters": {
							"shape": "S44"
						}
					}
				},
				"output": {
					"shape": "S72",
					"resultWrapper": "ModifyClusterParameterGroupResult"
				}
			},
			"ModifyClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier"
					],
					"members": {
						"SnapshotIdentifier": {},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"Force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"ModifyClusterSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"ScheduleIdentifier": {},
						"DisassociateSchedule": {
							"type": "boolean"
						}
					}
				}
			},
			"ModifyClusterSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"ClusterSubnetGroupName": {},
						"Description": {},
						"SubnetIds": {
							"shape": "S2f"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterSubnetGroupResult",
					"type": "structure",
					"members": {
						"ClusterSubnetGroup": {
							"shape": "S2h"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"SourceIds": {
							"shape": "S2o"
						},
						"EventCategories": {
							"shape": "S2p"
						},
						"Severity": {},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S2r"
						}
					}
				}
			},
			"ModifySnapshotCopyRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"RetentionPeriod"
					],
					"members": {
						"ClusterIdentifier": {},
						"RetentionPeriod": {
							"type": "integer"
						},
						"Manual": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifySnapshotCopyRetentionPeriodResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"ModifySnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"ScheduleIdentifier",
						"ScheduleDefinitions"
					],
					"members": {
						"ScheduleIdentifier": {},
						"ScheduleDefinitions": {
							"shape": "S32"
						}
					}
				},
				"output": {
					"shape": "S33",
					"resultWrapper": "ModifySnapshotScheduleResult"
				}
			},
			"PurchaseReservedNodeOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedNodeOfferingId"
					],
					"members": {
						"ReservedNodeOfferingId": {},
						"NodeCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedNodeOfferingResult",
					"type": "structure",
					"members": {
						"ReservedNode": {
							"shape": "S4"
						}
					}
				}
			},
			"RebootCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RebootClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"ResetClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName"
					],
					"members": {
						"ParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S44"
						}
					}
				},
				"output": {
					"shape": "S72",
					"resultWrapper": "ResetClusterParameterGroupResult"
				}
			},
			"ResizeCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"NumberOfNodes"
					],
					"members": {
						"ClusterIdentifier": {},
						"ClusterType": {},
						"NodeType": {},
						"NumberOfNodes": {
							"type": "integer"
						},
						"Classic": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ResizeClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"RestoreFromClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"SnapshotIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"SnapshotClusterIdentifier": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"AllowVersionUpgrade": {
							"type": "boolean"
						},
						"ClusterSubnetGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"OwnerAccount": {},
						"HsmClientCertificateIdentifier": {},
						"HsmConfigurationIdentifier": {},
						"ElasticIp": {},
						"ClusterParameterGroupName": {},
						"ClusterSecurityGroups": {
							"shape": "S1d"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1e"
						},
						"PreferredMaintenanceWindow": {},
						"AutomatedSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"ManualSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"KmsKeyId": {},
						"NodeType": {},
						"EnhancedVpcRouting": {
							"type": "boolean"
						},
						"AdditionalInfo": {},
						"IamRoles": {
							"shape": "S1g"
						},
						"MaintenanceTrackName": {},
						"SnapshotScheduleIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreFromClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			},
			"RestoreTableFromClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"SnapshotIdentifier",
						"SourceDatabaseName",
						"SourceTableName",
						"NewTableName"
					],
					"members": {
						"ClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"SourceDatabaseName": {},
						"SourceSchemaName": {},
						"SourceTableName": {},
						"TargetDatabaseName": {},
						"TargetSchemaName": {},
						"NewTableName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreTableFromClusterSnapshotResult",
					"type": "structure",
					"members": {
						"TableRestoreStatus": {
							"shape": "S6b"
						}
					}
				}
			},
			"RevokeClusterSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName"
					],
					"members": {
						"ClusterSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeClusterSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"ClusterSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"RevokeSnapshotAccess": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier",
						"AccountWithRestoreAccess"
					],
					"members": {
						"SnapshotIdentifier": {},
						"SnapshotClusterIdentifier": {},
						"AccountWithRestoreAccess": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeSnapshotAccessResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sm"
						}
					}
				}
			},
			"RotateEncryptionKey": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RotateEncryptionKeyResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "S1i"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"ReservedNodeId": {},
					"ReservedNodeOfferingId": {},
					"NodeType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"NodeCount": {
						"type": "integer"
					},
					"State": {},
					"OfferingType": {},
					"RecurringCharges": {
						"shape": "S8"
					},
					"ReservedNodeOfferingType": {}
				},
				"wrapper": true
			},
			"S8": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"ClusterSecurityGroupName": {},
					"Description": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupOwnerId": {},
								"Tags": {
									"shape": "Sg"
								}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {},
								"Tags": {
									"shape": "Sg"
								}
							}
						}
					},
					"Tags": {
						"shape": "Sg"
					}
				},
				"wrapper": true
			},
			"Sg": {
				"type": "list",
				"member": {
					"shape": "Sh",
					"locationName": "Tag"
				}
			},
			"Sh": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"Sm": {
				"type": "structure",
				"members": {
					"SnapshotIdentifier": {},
					"ClusterIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"ClusterCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"ClusterVersion": {},
					"SnapshotType": {},
					"NodeType": {},
					"NumberOfNodes": {
						"type": "integer"
					},
					"DBName": {},
					"VpcId": {},
					"Encrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"EncryptedWithHSM": {
						"type": "boolean"
					},
					"AccountsWithRestoreAccess": {
						"type": "list",
						"member": {
							"locationName": "AccountWithRestoreAccess",
							"type": "structure",
							"members": {
								"AccountId": {},
								"AccountAlias": {}
							}
						}
					},
					"OwnerAccount": {},
					"TotalBackupSizeInMegaBytes": {
						"type": "double"
					},
					"ActualIncrementalBackupSizeInMegaBytes": {
						"type": "double"
					},
					"BackupProgressInMegaBytes": {
						"type": "double"
					},
					"CurrentBackupRateInMegaBytesPerSecond": {
						"type": "double"
					},
					"EstimatedSecondsToCompletion": {
						"type": "long"
					},
					"ElapsedTimeInSeconds": {
						"type": "long"
					},
					"SourceRegion": {},
					"Tags": {
						"shape": "Sg"
					},
					"RestorableNodeTypes": {
						"type": "list",
						"member": {
							"locationName": "NodeType"
						}
					},
					"EnhancedVpcRouting": {
						"type": "boolean"
					},
					"MaintenanceTrackName": {},
					"ManualSnapshotRetentionPeriod": {
						"type": "integer"
					},
					"ManualSnapshotRemainingDays": {
						"type": "integer"
					},
					"SnapshotRetentionStartTime": {
						"type": "timestamp"
					}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "structure",
				"required": [
					"SnapshotIdentifier"
				],
				"members": {
					"SnapshotIdentifier": {},
					"SnapshotClusterIdentifier": {}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"locationName": "String"
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"SnapshotIdentifier": {},
					"SnapshotClusterIdentifier": {},
					"FailureCode": {},
					"FailureReason": {}
				}
			},
			"S14": {
				"type": "structure",
				"members": {
					"TargetNodeType": {},
					"TargetNumberOfNodes": {
						"type": "integer"
					},
					"TargetClusterType": {},
					"Status": {},
					"ImportTablesCompleted": {
						"type": "list",
						"member": {}
					},
					"ImportTablesInProgress": {
						"type": "list",
						"member": {}
					},
					"ImportTablesNotStarted": {
						"type": "list",
						"member": {}
					},
					"AvgResizeRateInMegaBytesPerSecond": {
						"type": "double"
					},
					"TotalResizeDataInMegaBytes": {
						"type": "long"
					},
					"ProgressInMegaBytes": {
						"type": "long"
					},
					"ElapsedTimeInSeconds": {
						"type": "long"
					},
					"EstimatedTimeToCompletionInSeconds": {
						"type": "long"
					},
					"ResizeType": {},
					"Message": {},
					"TargetEncryptionType": {},
					"DataTransferProgressPercent": {
						"type": "double"
					}
				}
			},
			"S1d": {
				"type": "list",
				"member": {
					"locationName": "ClusterSecurityGroupName"
				}
			},
			"S1e": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"S1g": {
				"type": "list",
				"member": {
					"locationName": "IamRoleArn"
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"ClusterIdentifier": {},
					"NodeType": {},
					"ClusterStatus": {},
					"ClusterAvailabilityStatus": {},
					"ModifyStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"ClusterCreateTime": {
						"type": "timestamp"
					},
					"AutomatedSnapshotRetentionPeriod": {
						"type": "integer"
					},
					"ManualSnapshotRetentionPeriod": {
						"type": "integer"
					},
					"ClusterSecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "ClusterSecurityGroup",
							"type": "structure",
							"members": {
								"ClusterSecurityGroupName": {},
								"Status": {}
							}
						}
					},
					"VpcSecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "VpcSecurityGroup",
							"type": "structure",
							"members": {
								"VpcSecurityGroupId": {},
								"Status": {}
							}
						}
					},
					"ClusterParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "ClusterParameterGroup",
							"type": "structure",
							"members": {
								"ParameterGroupName": {},
								"ParameterApplyStatus": {},
								"ClusterParameterStatusList": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ParameterName": {},
											"ParameterApplyStatus": {},
											"ParameterApplyErrorDescription": {}
										}
									}
								}
							}
						}
					},
					"ClusterSubnetGroupName": {},
					"VpcId": {},
					"AvailabilityZone": {},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"MasterUserPassword": {},
							"NodeType": {},
							"NumberOfNodes": {
								"type": "integer"
							},
							"ClusterType": {},
							"ClusterVersion": {},
							"AutomatedSnapshotRetentionPeriod": {
								"type": "integer"
							},
							"ClusterIdentifier": {},
							"PubliclyAccessible": {
								"type": "boolean"
							},
							"EnhancedVpcRouting": {
								"type": "boolean"
							},
							"MaintenanceTrackName": {},
							"EncryptionType": {}
						}
					},
					"ClusterVersion": {},
					"AllowVersionUpgrade": {
						"type": "boolean"
					},
					"NumberOfNodes": {
						"type": "integer"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Encrypted": {
						"type": "boolean"
					},
					"RestoreStatus": {
						"type": "structure",
						"members": {
							"Status": {},
							"CurrentRestoreRateInMegaBytesPerSecond": {
								"type": "double"
							},
							"SnapshotSizeInMegaBytes": {
								"type": "long"
							},
							"ProgressInMegaBytes": {
								"type": "long"
							},
							"ElapsedTimeInSeconds": {
								"type": "long"
							},
							"EstimatedTimeToCompletionInSeconds": {
								"type": "long"
							}
						}
					},
					"DataTransferProgress": {
						"type": "structure",
						"members": {
							"Status": {},
							"CurrentRateInMegaBytesPerSecond": {
								"type": "double"
							},
							"TotalDataInMegaBytes": {
								"type": "long"
							},
							"DataTransferredInMegaBytes": {
								"type": "long"
							},
							"EstimatedTimeToCompletionInSeconds": {
								"type": "long"
							},
							"ElapsedTimeInSeconds": {
								"type": "long"
							}
						}
					},
					"HsmStatus": {
						"type": "structure",
						"members": {
							"HsmClientCertificateIdentifier": {},
							"HsmConfigurationIdentifier": {},
							"Status": {}
						}
					},
					"ClusterSnapshotCopyStatus": {
						"type": "structure",
						"members": {
							"DestinationRegion": {},
							"RetentionPeriod": {
								"type": "long"
							},
							"ManualSnapshotRetentionPeriod": {
								"type": "integer"
							},
							"SnapshotCopyGrantName": {}
						}
					},
					"ClusterPublicKey": {},
					"ClusterNodes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"NodeRole": {},
								"PrivateIPAddress": {},
								"PublicIPAddress": {}
							}
						}
					},
					"ElasticIpStatus": {
						"type": "structure",
						"members": {
							"ElasticIp": {},
							"Status": {}
						}
					},
					"ClusterRevisionNumber": {},
					"Tags": {
						"shape": "Sg"
					},
					"KmsKeyId": {},
					"EnhancedVpcRouting": {
						"type": "boolean"
					},
					"IamRoles": {
						"type": "list",
						"member": {
							"locationName": "ClusterIamRole",
							"type": "structure",
							"members": {
								"IamRoleArn": {},
								"ApplyStatus": {}
							}
						}
					},
					"PendingActions": {
						"type": "list",
						"member": {}
					},
					"MaintenanceTrackName": {},
					"ElasticResizeNumberOfNodeOptions": {},
					"DeferredMaintenanceWindows": {
						"type": "list",
						"member": {
							"locationName": "DeferredMaintenanceWindow",
							"type": "structure",
							"members": {
								"DeferMaintenanceIdentifier": {},
								"DeferMaintenanceStartTime": {
									"type": "timestamp"
								},
								"DeferMaintenanceEndTime": {
									"type": "timestamp"
								}
							}
						}
					},
					"SnapshotScheduleIdentifier": {},
					"SnapshotScheduleState": {},
					"ExpectedNextSnapshotScheduleTime": {
						"type": "timestamp"
					},
					"ExpectedNextSnapshotScheduleTimeStatus": {},
					"ResizeInfo": {
						"type": "structure",
						"members": {
							"ResizeType": {},
							"AllowCancelResize": {
								"type": "boolean"
							}
						}
					}
				},
				"wrapper": true
			},
			"S29": {
				"type": "structure",
				"members": {
					"ParameterGroupName": {},
					"ParameterGroupFamily": {},
					"Description": {},
					"Tags": {
						"shape": "Sg"
					}
				},
				"wrapper": true
			},
			"S2f": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"ClusterSubnetGroupName": {},
					"Description": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S2k"
								},
								"SubnetStatus": {}
							}
						}
					},
					"Tags": {
						"shape": "Sg"
					}
				},
				"wrapper": true
			},
			"S2k": {
				"type": "structure",
				"members": {
					"Name": {},
					"SupportedPlatforms": {
						"type": "list",
						"member": {
							"locationName": "SupportedPlatform",
							"type": "structure",
							"members": {
								"Name": {}
							},
							"wrapper": true
						}
					}
				},
				"wrapper": true
			},
			"S2o": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S2p": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S2r": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {
						"type": "timestamp"
					},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S2o"
					},
					"EventCategoriesList": {
						"shape": "S2p"
					},
					"Severity": {},
					"Enabled": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sg"
					}
				},
				"wrapper": true
			},
			"S2u": {
				"type": "structure",
				"members": {
					"HsmClientCertificateIdentifier": {},
					"HsmClientCertificatePublicKey": {},
					"Tags": {
						"shape": "Sg"
					}
				},
				"wrapper": true
			},
			"S2x": {
				"type": "structure",
				"members": {
					"HsmConfigurationIdentifier": {},
					"Description": {},
					"HsmIpAddress": {},
					"HsmPartitionName": {},
					"Tags": {
						"shape": "Sg"
					}
				},
				"wrapper": true
			},
			"S30": {
				"type": "structure",
				"members": {
					"SnapshotCopyGrantName": {},
					"KmsKeyId": {},
					"Tags": {
						"shape": "Sg"
					}
				},
				"wrapper": true
			},
			"S32": {
				"type": "list",
				"member": {
					"locationName": "ScheduleDefinition"
				}
			},
			"S33": {
				"type": "structure",
				"members": {
					"ScheduleDefinitions": {
						"shape": "S32"
					},
					"ScheduleIdentifier": {},
					"ScheduleDescription": {},
					"Tags": {
						"shape": "Sg"
					},
					"NextInvocations": {
						"type": "list",
						"member": {
							"locationName": "SnapshotTime",
							"type": "timestamp"
						}
					},
					"AssociatedClusterCount": {
						"type": "integer"
					},
					"AssociatedClusters": {
						"type": "list",
						"member": {
							"locationName": "ClusterAssociatedToSchedule",
							"type": "structure",
							"members": {
								"ClusterIdentifier": {},
								"ScheduleAssociationState": {}
							}
						}
					}
				}
			},
			"S3k": {
				"type": "list",
				"member": {
					"locationName": "TagKey"
				}
			},
			"S3z": {
				"type": "list",
				"member": {
					"locationName": "TagValue"
				}
			},
			"S44": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"DataType": {},
						"AllowedValues": {},
						"ApplyType": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {}
					}
				}
			},
			"S5n": {
				"type": "structure",
				"members": {
					"LoggingEnabled": {
						"type": "boolean"
					},
					"BucketName": {},
					"S3KeyPrefix": {},
					"LastSuccessfulDeliveryTime": {
						"type": "timestamp"
					},
					"LastFailureTime": {
						"type": "timestamp"
					},
					"LastFailureMessage": {}
				}
			},
			"S5v": {
				"type": "list",
				"member": {
					"locationName": "ReservedNodeOffering",
					"type": "structure",
					"members": {
						"ReservedNodeOfferingId": {},
						"NodeType": {},
						"Duration": {
							"type": "integer"
						},
						"FixedPrice": {
							"type": "double"
						},
						"UsagePrice": {
							"type": "double"
						},
						"CurrencyCode": {},
						"OfferingType": {},
						"RecurringCharges": {
							"shape": "S8"
						},
						"ReservedNodeOfferingType": {}
					},
					"wrapper": true
				}
			},
			"S6b": {
				"type": "structure",
				"members": {
					"TableRestoreRequestId": {},
					"Status": {},
					"Message": {},
					"RequestTime": {
						"type": "timestamp"
					},
					"ProgressInMegaBytes": {
						"type": "long"
					},
					"TotalDataInMegaBytes": {
						"type": "long"
					},
					"ClusterIdentifier": {},
					"SnapshotIdentifier": {},
					"SourceDatabaseName": {},
					"SourceSchemaName": {},
					"SourceTableName": {},
					"TargetDatabaseName": {},
					"TargetSchemaName": {},
					"NewTableName": {}
				},
				"wrapper": true
			},
			"S72": {
				"type": "structure",
				"members": {
					"ParameterGroupName": {},
					"ParameterGroupStatus": {}
				}
			}
		}
	};

/***/ },
/* 1820 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeClusterParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ParameterGroups"
			},
			"DescribeClusterParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeClusterSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ClusterSecurityGroups"
			},
			"DescribeClusterSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Snapshots"
			},
			"DescribeClusterSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ClusterSubnetGroups"
			},
			"DescribeClusterVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ClusterVersions"
			},
			"DescribeClusters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Clusters"
			},
			"DescribeDefaultClusterParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "DefaultClusterParameters.Marker",
				"result_key": "DefaultClusterParameters.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeHsmClientCertificates": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "HsmClientCertificates"
			},
			"DescribeHsmConfigurations": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "HsmConfigurations"
			},
			"DescribeOrderableClusterOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableClusterOptions"
			},
			"DescribeReservedNodeOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedNodeOfferings"
			},
			"DescribeReservedNodes": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedNodes"
			}
		}
	};

/***/ },
/* 1821 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"ClusterAvailable": {
				"delay": 60,
				"operation": "DescribeClusters",
				"maxAttempts": 30,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Clusters[].ClusterStatus"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Clusters[].ClusterStatus"
					},
					{
						"expected": "ClusterNotFound",
						"matcher": "error",
						"state": "retry"
					}
				]
			},
			"ClusterDeleted": {
				"delay": 60,
				"operation": "DescribeClusters",
				"maxAttempts": 30,
				"acceptors": [
					{
						"expected": "ClusterNotFound",
						"matcher": "error",
						"state": "success"
					},
					{
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Clusters[].ClusterStatus"
					},
					{
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Clusters[].ClusterStatus"
					}
				]
			},
			"ClusterRestored": {
				"operation": "DescribeClusters",
				"maxAttempts": 30,
				"delay": 60,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "Clusters[].RestoreStatus.Status",
						"expected": "completed"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "Clusters[].ClusterStatus",
						"expected": "deleting"
					}
				]
			},
			"SnapshotAvailable": {
				"delay": 15,
				"operation": "DescribeClusterSnapshots",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Snapshots[].Status"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Snapshots[].Status"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Snapshots[].Status"
					}
				]
			}
		}
	};

/***/ },
/* 1822 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-06-27",
			"endpointPrefix": "rekognition",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Rekognition",
			"serviceId": "Rekognition",
			"signatureVersion": "v4",
			"targetPrefix": "RekognitionService",
			"uid": "rekognition-2016-06-27"
		},
		"operations": {
			"CompareFaces": {
				"input": {
					"type": "structure",
					"required": [
						"SourceImage",
						"TargetImage"
					],
					"members": {
						"SourceImage": {
							"shape": "S2"
						},
						"TargetImage": {
							"shape": "S2"
						},
						"SimilarityThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SourceImageFace": {
							"type": "structure",
							"members": {
								"BoundingBox": {
									"shape": "Sb"
								},
								"Confidence": {
									"type": "float"
								}
							}
						},
						"FaceMatches": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Similarity": {
										"type": "float"
									},
									"Face": {
										"shape": "Sf"
									}
								}
							}
						},
						"UnmatchedFaces": {
							"type": "list",
							"member": {
								"shape": "Sf"
							}
						},
						"SourceImageOrientationCorrection": {},
						"TargetImageOrientationCorrection": {}
					}
				}
			},
			"CreateCollection": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId"
					],
					"members": {
						"CollectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StatusCode": {
							"type": "integer"
						},
						"CollectionArn": {},
						"FaceModelVersion": {}
					}
				}
			},
			"CreateStreamProcessor": {
				"input": {
					"type": "structure",
					"required": [
						"Input",
						"Output",
						"Name",
						"Settings",
						"RoleArn"
					],
					"members": {
						"Input": {
							"shape": "Su"
						},
						"Output": {
							"shape": "Sx"
						},
						"Name": {},
						"Settings": {
							"shape": "S11"
						},
						"RoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamProcessorArn": {}
					}
				}
			},
			"DeleteCollection": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId"
					],
					"members": {
						"CollectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StatusCode": {
							"type": "integer"
						}
					}
				}
			},
			"DeleteFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"FaceIds"
					],
					"members": {
						"CollectionId": {},
						"FaceIds": {
							"shape": "S19"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeletedFaces": {
							"shape": "S19"
						}
					}
				}
			},
			"DeleteStreamProcessor": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeCollection": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId"
					],
					"members": {
						"CollectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FaceCount": {
							"type": "long"
						},
						"FaceModelVersion": {},
						"CollectionARN": {},
						"CreationTimestamp": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeStreamProcessor": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"StreamProcessorArn": {},
						"Status": {},
						"StatusMessage": {},
						"CreationTimestamp": {
							"type": "timestamp"
						},
						"LastUpdateTimestamp": {
							"type": "timestamp"
						},
						"Input": {
							"shape": "Su"
						},
						"Output": {
							"shape": "Sx"
						},
						"RoleArn": {},
						"Settings": {
							"shape": "S11"
						}
					}
				}
			},
			"DetectFaces": {
				"input": {
					"type": "structure",
					"required": [
						"Image"
					],
					"members": {
						"Image": {
							"shape": "S2"
						},
						"Attributes": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FaceDetails": {
							"type": "list",
							"member": {
								"shape": "S1q"
							}
						},
						"OrientationCorrection": {}
					}
				}
			},
			"DetectLabels": {
				"input": {
					"type": "structure",
					"required": [
						"Image"
					],
					"members": {
						"Image": {
							"shape": "S2"
						},
						"MaxLabels": {
							"type": "integer"
						},
						"MinConfidence": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Labels": {
							"type": "list",
							"member": {
								"shape": "S28"
							}
						},
						"OrientationCorrection": {},
						"LabelModelVersion": {}
					}
				}
			},
			"DetectModerationLabels": {
				"input": {
					"type": "structure",
					"required": [
						"Image"
					],
					"members": {
						"Image": {
							"shape": "S2"
						},
						"MinConfidence": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ModerationLabels": {
							"type": "list",
							"member": {
								"shape": "S2g"
							}
						},
						"ModerationModelVersion": {}
					}
				}
			},
			"DetectText": {
				"input": {
					"type": "structure",
					"required": [
						"Image"
					],
					"members": {
						"Image": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TextDetections": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DetectedText": {},
									"Type": {},
									"Id": {
										"type": "integer"
									},
									"ParentId": {
										"type": "integer"
									},
									"Confidence": {
										"type": "float"
									},
									"Geometry": {
										"type": "structure",
										"members": {
											"BoundingBox": {
												"shape": "Sb"
											},
											"Polygon": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"X": {
															"type": "float"
														},
														"Y": {
															"type": "float"
														}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"GetCelebrityInfo": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Urls": {
							"shape": "S2s"
						},
						"Name": {}
					}
				}
			},
			"GetCelebrityRecognition": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"SortBy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobStatus": {},
						"StatusMessage": {},
						"VideoMetadata": {
							"shape": "S32"
						},
						"NextToken": {},
						"Celebrities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "long"
									},
									"Celebrity": {
										"type": "structure",
										"members": {
											"Urls": {
												"shape": "S2s"
											},
											"Name": {},
											"Id": {},
											"Confidence": {
												"type": "float"
											},
											"BoundingBox": {
												"shape": "Sb"
											},
											"Face": {
												"shape": "S1q"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"GetContentModeration": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"SortBy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobStatus": {},
						"StatusMessage": {},
						"VideoMetadata": {
							"shape": "S32"
						},
						"ModerationLabels": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "long"
									},
									"ModerationLabel": {
										"shape": "S2g"
									}
								}
							}
						},
						"NextToken": {},
						"ModerationModelVersion": {}
					}
				}
			},
			"GetFaceDetection": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobStatus": {},
						"StatusMessage": {},
						"VideoMetadata": {
							"shape": "S32"
						},
						"NextToken": {},
						"Faces": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "long"
									},
									"Face": {
										"shape": "S1q"
									}
								}
							}
						}
					}
				}
			},
			"GetFaceSearch": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"SortBy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobStatus": {},
						"StatusMessage": {},
						"NextToken": {},
						"VideoMetadata": {
							"shape": "S32"
						},
						"Persons": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "long"
									},
									"Person": {
										"shape": "S3l"
									},
									"FaceMatches": {
										"shape": "S3n"
									}
								}
							}
						}
					}
				}
			},
			"GetLabelDetection": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"SortBy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobStatus": {},
						"StatusMessage": {},
						"VideoMetadata": {
							"shape": "S32"
						},
						"NextToken": {},
						"Labels": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "long"
									},
									"Label": {
										"shape": "S28"
									}
								}
							}
						},
						"LabelModelVersion": {}
					}
				}
			},
			"GetPersonTracking": {
				"input": {
					"type": "structure",
					"required": [
						"JobId"
					],
					"members": {
						"JobId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"SortBy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobStatus": {},
						"StatusMessage": {},
						"VideoMetadata": {
							"shape": "S32"
						},
						"NextToken": {},
						"Persons": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "long"
									},
									"Person": {
										"shape": "S3l"
									}
								}
							}
						}
					}
				}
			},
			"IndexFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"Image"
					],
					"members": {
						"CollectionId": {},
						"Image": {
							"shape": "S2"
						},
						"ExternalImageId": {},
						"DetectionAttributes": {
							"shape": "S1m"
						},
						"MaxFaces": {
							"type": "integer"
						},
						"QualityFilter": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FaceRecords": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Face": {
										"shape": "S3p"
									},
									"FaceDetail": {
										"shape": "S1q"
									}
								}
							}
						},
						"OrientationCorrection": {},
						"FaceModelVersion": {},
						"UnindexedFaces": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Reasons": {
										"type": "list",
										"member": {}
									},
									"FaceDetail": {
										"shape": "S1q"
									}
								}
							}
						}
					}
				}
			},
			"ListCollections": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CollectionIds": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"FaceModelVersions": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ListFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId"
					],
					"members": {
						"CollectionId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Faces": {
							"type": "list",
							"member": {
								"shape": "S3p"
							}
						},
						"NextToken": {},
						"FaceModelVersion": {}
					}
				}
			},
			"ListStreamProcessors": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"StreamProcessors": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Status": {}
								}
							}
						}
					}
				}
			},
			"RecognizeCelebrities": {
				"input": {
					"type": "structure",
					"required": [
						"Image"
					],
					"members": {
						"Image": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CelebrityFaces": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Urls": {
										"shape": "S2s"
									},
									"Name": {},
									"Id": {},
									"Face": {
										"shape": "Sf"
									},
									"MatchConfidence": {
										"type": "float"
									}
								}
							}
						},
						"UnrecognizedFaces": {
							"type": "list",
							"member": {
								"shape": "Sf"
							}
						},
						"OrientationCorrection": {}
					}
				}
			},
			"SearchFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"FaceId"
					],
					"members": {
						"CollectionId": {},
						"FaceId": {},
						"MaxFaces": {
							"type": "integer"
						},
						"FaceMatchThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SearchedFaceId": {},
						"FaceMatches": {
							"shape": "S3n"
						},
						"FaceModelVersion": {}
					}
				}
			},
			"SearchFacesByImage": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"Image"
					],
					"members": {
						"CollectionId": {},
						"Image": {
							"shape": "S2"
						},
						"MaxFaces": {
							"type": "integer"
						},
						"FaceMatchThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SearchedFaceBoundingBox": {
							"shape": "Sb"
						},
						"SearchedFaceConfidence": {
							"type": "float"
						},
						"FaceMatches": {
							"shape": "S3n"
						},
						"FaceModelVersion": {}
					}
				}
			},
			"StartCelebrityRecognition": {
				"input": {
					"type": "structure",
					"required": [
						"Video"
					],
					"members": {
						"Video": {
							"shape": "S4z"
						},
						"ClientRequestToken": {},
						"NotificationChannel": {
							"shape": "S51"
						},
						"JobTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {}
					}
				},
				"idempotent": true
			},
			"StartContentModeration": {
				"input": {
					"type": "structure",
					"required": [
						"Video"
					],
					"members": {
						"Video": {
							"shape": "S4z"
						},
						"MinConfidence": {
							"type": "float"
						},
						"ClientRequestToken": {},
						"NotificationChannel": {
							"shape": "S51"
						},
						"JobTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {}
					}
				},
				"idempotent": true
			},
			"StartFaceDetection": {
				"input": {
					"type": "structure",
					"required": [
						"Video"
					],
					"members": {
						"Video": {
							"shape": "S4z"
						},
						"ClientRequestToken": {},
						"NotificationChannel": {
							"shape": "S51"
						},
						"FaceAttributes": {},
						"JobTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {}
					}
				},
				"idempotent": true
			},
			"StartFaceSearch": {
				"input": {
					"type": "structure",
					"required": [
						"Video",
						"CollectionId"
					],
					"members": {
						"Video": {
							"shape": "S4z"
						},
						"ClientRequestToken": {},
						"FaceMatchThreshold": {
							"type": "float"
						},
						"CollectionId": {},
						"NotificationChannel": {
							"shape": "S51"
						},
						"JobTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {}
					}
				},
				"idempotent": true
			},
			"StartLabelDetection": {
				"input": {
					"type": "structure",
					"required": [
						"Video"
					],
					"members": {
						"Video": {
							"shape": "S4z"
						},
						"ClientRequestToken": {},
						"MinConfidence": {
							"type": "float"
						},
						"NotificationChannel": {
							"shape": "S51"
						},
						"JobTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {}
					}
				},
				"idempotent": true
			},
			"StartPersonTracking": {
				"input": {
					"type": "structure",
					"required": [
						"Video"
					],
					"members": {
						"Video": {
							"shape": "S4z"
						},
						"ClientRequestToken": {},
						"NotificationChannel": {
							"shape": "S51"
						},
						"JobTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobId": {}
					}
				},
				"idempotent": true
			},
			"StartStreamProcessor": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StopStreamProcessor": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"members": {
					"Bytes": {
						"type": "blob"
					},
					"S3Object": {
						"shape": "S4"
					}
				}
			},
			"S4": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"Name": {},
					"Version": {}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"Width": {
						"type": "float"
					},
					"Height": {
						"type": "float"
					},
					"Left": {
						"type": "float"
					},
					"Top": {
						"type": "float"
					}
				}
			},
			"Sf": {
				"type": "structure",
				"members": {
					"BoundingBox": {
						"shape": "Sb"
					},
					"Confidence": {
						"type": "float"
					},
					"Landmarks": {
						"shape": "Sg"
					},
					"Pose": {
						"shape": "Sj"
					},
					"Quality": {
						"shape": "Sl"
					}
				}
			},
			"Sg": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Type": {},
						"X": {
							"type": "float"
						},
						"Y": {
							"type": "float"
						}
					}
				}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"Roll": {
						"type": "float"
					},
					"Yaw": {
						"type": "float"
					},
					"Pitch": {
						"type": "float"
					}
				}
			},
			"Sl": {
				"type": "structure",
				"members": {
					"Brightness": {
						"type": "float"
					},
					"Sharpness": {
						"type": "float"
					}
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"KinesisVideoStream": {
						"type": "structure",
						"members": {
							"Arn": {}
						}
					}
				}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"KinesisDataStream": {
						"type": "structure",
						"members": {
							"Arn": {}
						}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"FaceSearch": {
						"type": "structure",
						"members": {
							"CollectionId": {},
							"FaceMatchThreshold": {
								"type": "float"
							}
						}
					}
				}
			},
			"S19": {
				"type": "list",
				"member": {}
			},
			"S1m": {
				"type": "list",
				"member": {}
			},
			"S1q": {
				"type": "structure",
				"members": {
					"BoundingBox": {
						"shape": "Sb"
					},
					"AgeRange": {
						"type": "structure",
						"members": {
							"Low": {
								"type": "integer"
							},
							"High": {
								"type": "integer"
							}
						}
					},
					"Smile": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Eyeglasses": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Sunglasses": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Gender": {
						"type": "structure",
						"members": {
							"Value": {},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Beard": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Mustache": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"EyesOpen": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"MouthOpen": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Emotions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"Confidence": {
									"type": "float"
								}
							}
						}
					},
					"Landmarks": {
						"shape": "Sg"
					},
					"Pose": {
						"shape": "Sj"
					},
					"Quality": {
						"shape": "Sl"
					},
					"Confidence": {
						"type": "float"
					}
				}
			},
			"S28": {
				"type": "structure",
				"members": {
					"Name": {},
					"Confidence": {
						"type": "float"
					},
					"Instances": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"BoundingBox": {
									"shape": "Sb"
								},
								"Confidence": {
									"type": "float"
								}
							}
						}
					},
					"Parents": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {}
							}
						}
					}
				}
			},
			"S2g": {
				"type": "structure",
				"members": {
					"Confidence": {
						"type": "float"
					},
					"Name": {},
					"ParentName": {}
				}
			},
			"S2s": {
				"type": "list",
				"member": {}
			},
			"S32": {
				"type": "structure",
				"members": {
					"Codec": {},
					"DurationMillis": {
						"type": "long"
					},
					"Format": {},
					"FrameRate": {
						"type": "float"
					},
					"FrameHeight": {
						"type": "long"
					},
					"FrameWidth": {
						"type": "long"
					}
				}
			},
			"S3l": {
				"type": "structure",
				"members": {
					"Index": {
						"type": "long"
					},
					"BoundingBox": {
						"shape": "Sb"
					},
					"Face": {
						"shape": "S1q"
					}
				}
			},
			"S3n": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Similarity": {
							"type": "float"
						},
						"Face": {
							"shape": "S3p"
						}
					}
				}
			},
			"S3p": {
				"type": "structure",
				"members": {
					"FaceId": {},
					"BoundingBox": {
						"shape": "Sb"
					},
					"ImageId": {},
					"ExternalImageId": {},
					"Confidence": {
						"type": "float"
					}
				}
			},
			"S4z": {
				"type": "structure",
				"members": {
					"S3Object": {
						"shape": "S4"
					}
				}
			},
			"S51": {
				"type": "structure",
				"required": [
					"SNSTopicArn",
					"RoleArn"
				],
				"members": {
					"SNSTopicArn": {},
					"RoleArn": {}
				}
			}
		}
	};

/***/ },
/* 1823 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetCelebrityRecognition": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetContentModeration": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetFaceDetection": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetFaceSearch": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetLabelDetection": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetPersonTracking": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"ListCollections": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "CollectionIds"
			},
			"ListFaces": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Faces"
			},
			"ListStreamProcessors": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			}
		}
	};

/***/ },
/* 1824 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-11-27",
			"endpointPrefix": "resource-groups",
			"protocol": "rest-json",
			"serviceAbbreviation": "Resource Groups",
			"serviceFullName": "AWS Resource Groups",
			"serviceId": "Resource Groups",
			"signatureVersion": "v4",
			"signingName": "resource-groups",
			"uid": "resource-groups-2017-11-27"
		},
		"operations": {
			"CreateGroup": {
				"http": {
					"requestUri": "/groups"
				},
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ResourceQuery"
					],
					"members": {
						"Name": {},
						"Description": {},
						"ResourceQuery": {
							"shape": "S4"
						},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "Sb"
						},
						"ResourceQuery": {
							"shape": "S4"
						},
						"Tags": {
							"shape": "S7"
						}
					}
				}
			},
			"DeleteGroup": {
				"http": {
					"method": "DELETE",
					"requestUri": "/groups/{GroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {
							"location": "uri",
							"locationName": "GroupName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "Sb"
						}
					}
				}
			},
			"GetGroup": {
				"http": {
					"method": "GET",
					"requestUri": "/groups/{GroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {
							"location": "uri",
							"locationName": "GroupName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "Sb"
						}
					}
				}
			},
			"GetGroupQuery": {
				"http": {
					"method": "GET",
					"requestUri": "/groups/{GroupName}/query"
				},
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {
							"location": "uri",
							"locationName": "GroupName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GroupQuery": {
							"shape": "Sj"
						}
					}
				}
			},
			"GetTags": {
				"http": {
					"method": "GET",
					"requestUri": "/resources/{Arn}/tags"
				},
				"input": {
					"type": "structure",
					"required": [
						"Arn"
					],
					"members": {
						"Arn": {
							"location": "uri",
							"locationName": "Arn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Arn": {},
						"Tags": {
							"shape": "S7"
						}
					}
				}
			},
			"ListGroupResources": {
				"http": {
					"requestUri": "/groups/{GroupName}/resource-identifiers-list"
				},
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {
							"location": "uri",
							"locationName": "GroupName"
						},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Name",
									"Values"
								],
								"members": {
									"Name": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceIdentifiers": {
							"shape": "Sv"
						},
						"NextToken": {},
						"QueryErrors": {
							"shape": "Sz"
						}
					}
				}
			},
			"ListGroups": {
				"http": {
					"requestUri": "/groups-list"
				},
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Name",
									"Values"
								],
								"members": {
									"Name": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GroupIdentifiers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GroupName": {},
									"GroupArn": {}
								}
							}
						},
						"Groups": {
							"deprecated": true,
							"deprecatedMessage": "This field is deprecated, use GroupIdentifiers instead.",
							"type": "list",
							"member": {
								"shape": "Sb"
							}
						},
						"NextToken": {}
					}
				}
			},
			"SearchResources": {
				"http": {
					"requestUri": "/resources/search"
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceQuery"
					],
					"members": {
						"ResourceQuery": {
							"shape": "S4"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceIdentifiers": {
							"shape": "Sv"
						},
						"NextToken": {},
						"QueryErrors": {
							"shape": "Sz"
						}
					}
				}
			},
			"Tag": {
				"http": {
					"method": "PUT",
					"requestUri": "/resources/{Arn}/tags"
				},
				"input": {
					"type": "structure",
					"required": [
						"Arn",
						"Tags"
					],
					"members": {
						"Arn": {
							"location": "uri",
							"locationName": "Arn"
						},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Arn": {},
						"Tags": {
							"shape": "S7"
						}
					}
				}
			},
			"Untag": {
				"http": {
					"method": "PATCH",
					"requestUri": "/resources/{Arn}/tags"
				},
				"input": {
					"type": "structure",
					"required": [
						"Arn",
						"Keys"
					],
					"members": {
						"Arn": {
							"location": "uri",
							"locationName": "Arn"
						},
						"Keys": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Arn": {},
						"Keys": {
							"shape": "S1i"
						}
					}
				}
			},
			"UpdateGroup": {
				"http": {
					"method": "PUT",
					"requestUri": "/groups/{GroupName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"GroupName": {
							"location": "uri",
							"locationName": "GroupName"
						},
						"Description": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "Sb"
						}
					}
				}
			},
			"UpdateGroupQuery": {
				"http": {
					"method": "PUT",
					"requestUri": "/groups/{GroupName}/query"
				},
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"ResourceQuery"
					],
					"members": {
						"GroupName": {
							"location": "uri",
							"locationName": "GroupName"
						},
						"ResourceQuery": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GroupQuery": {
							"shape": "Sj"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"required": [
					"Type",
					"Query"
				],
				"members": {
					"Type": {},
					"Query": {}
				}
			},
			"S7": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"GroupArn",
					"Name"
				],
				"members": {
					"GroupArn": {},
					"Name": {},
					"Description": {}
				}
			},
			"Sj": {
				"type": "structure",
				"required": [
					"GroupName",
					"ResourceQuery"
				],
				"members": {
					"GroupName": {},
					"ResourceQuery": {
						"shape": "S4"
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ResourceArn": {},
						"ResourceType": {}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ErrorCode": {},
						"Message": {}
					}
				}
			},
			"S1i": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1825 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListGroupResources": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListGroups": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"SearchResources": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1826 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-04-01",
			"endpointPrefix": "route53",
			"globalEndpoint": "route53.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "Route 53",
			"serviceFullName": "Amazon Route 53",
			"serviceId": "Route 53",
			"signatureVersion": "v4",
			"uid": "route53-2013-04-01"
		},
		"operations": {
			"AssociateVPCWithHostedZone": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/associatevpc"
				},
				"input": {
					"locationName": "AssociateVPCWithHostedZoneRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"ChangeResourceRecordSets": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/rrset/"
				},
				"input": {
					"locationName": "ChangeResourceRecordSetsRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"ChangeBatch"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"ChangeBatch": {
							"type": "structure",
							"required": [
								"Changes"
							],
							"members": {
								"Comment": {},
								"Changes": {
									"type": "list",
									"member": {
										"locationName": "Change",
										"type": "structure",
										"required": [
											"Action",
											"ResourceRecordSet"
										],
										"members": {
											"Action": {},
											"ResourceRecordSet": {
												"shape": "Sh"
											}
										}
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"ChangeTagsForResource": {
				"http": {
					"requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
				},
				"input": {
					"locationName": "ChangeTagsForResourceRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {
							"location": "uri",
							"locationName": "ResourceType"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"AddTags": {
							"shape": "S15"
						},
						"RemoveTagKeys": {
							"type": "list",
							"member": {
								"locationName": "Key"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateHealthCheck": {
				"http": {
					"requestUri": "/2013-04-01/healthcheck",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateHealthCheckRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"CallerReference",
						"HealthCheckConfig"
					],
					"members": {
						"CallerReference": {},
						"HealthCheckConfig": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheck",
						"Location"
					],
					"members": {
						"HealthCheck": {
							"shape": "S1z"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateHostedZone": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateHostedZoneRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Name",
						"CallerReference"
					],
					"members": {
						"Name": {},
						"VPC": {
							"shape": "S3"
						},
						"CallerReference": {},
						"HostedZoneConfig": {
							"shape": "S2h"
						},
						"DelegationSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZone",
						"ChangeInfo",
						"DelegationSet",
						"Location"
					],
					"members": {
						"HostedZone": {
							"shape": "S2k"
						},
						"ChangeInfo": {
							"shape": "S8"
						},
						"DelegationSet": {
							"shape": "S2m"
						},
						"VPC": {
							"shape": "S3"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateQueryLoggingConfig": {
				"http": {
					"requestUri": "/2013-04-01/queryloggingconfig",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateQueryLoggingConfigRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"CloudWatchLogsLogGroupArn"
					],
					"members": {
						"HostedZoneId": {},
						"CloudWatchLogsLogGroupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"QueryLoggingConfig",
						"Location"
					],
					"members": {
						"QueryLoggingConfig": {
							"shape": "S2r"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateReusableDelegationSet": {
				"http": {
					"requestUri": "/2013-04-01/delegationset",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateReusableDelegationSetRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"CallerReference"
					],
					"members": {
						"CallerReference": {},
						"HostedZoneId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DelegationSet",
						"Location"
					],
					"members": {
						"DelegationSet": {
							"shape": "S2m"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateTrafficPolicy": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicy",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateTrafficPolicyRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Name",
						"Document"
					],
					"members": {
						"Name": {},
						"Document": {},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy",
						"Location"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S30"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateTrafficPolicyInstance": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicyinstance",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateTrafficPolicyInstanceRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"Name",
						"TTL",
						"TrafficPolicyId",
						"TrafficPolicyVersion"
					],
					"members": {
						"HostedZoneId": {},
						"Name": {},
						"TTL": {
							"type": "long"
						},
						"TrafficPolicyId": {},
						"TrafficPolicyVersion": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstance",
						"Location"
					],
					"members": {
						"TrafficPolicyInstance": {
							"shape": "S35"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateTrafficPolicyVersion": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicy/{Id}",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateTrafficPolicyVersionRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id",
						"Document"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Document": {},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy",
						"Location"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S30"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateVPCAssociationAuthorization": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
				},
				"input": {
					"locationName": "CreateVPCAssociationAuthorizationRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {},
						"VPC": {
							"shape": "S3"
						}
					}
				}
			},
			"DeleteHealthCheck": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteHostedZone": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/hostedzone/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"DeleteQueryLoggingConfig": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/queryloggingconfig/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteReusableDelegationSet": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/delegationset/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTrafficPolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Version"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Version": {
							"location": "uri",
							"locationName": "Version",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTrafficPolicyInstance": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteVPCAssociationAuthorization": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"
				},
				"input": {
					"locationName": "DeleteVPCAssociationAuthorizationRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociateVPCFromHostedZone": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/disassociatevpc"
				},
				"input": {
					"locationName": "DisassociateVPCFromHostedZoneRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"GetAccountLimit": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/accountlimit/{Type}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"Type": {
							"location": "uri",
							"locationName": "Type"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Limit",
						"Count"
					],
					"members": {
						"Limit": {
							"type": "structure",
							"required": [
								"Type",
								"Value"
							],
							"members": {
								"Type": {},
								"Value": {
									"type": "long"
								}
							}
						},
						"Count": {
							"type": "long"
						}
					}
				}
			},
			"GetChange": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/change/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"GetCheckerIpRanges": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/checkeripranges"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"CheckerIpRanges"
					],
					"members": {
						"CheckerIpRanges": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetGeoLocation": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/geolocation"
				},
				"input": {
					"type": "structure",
					"members": {
						"ContinentCode": {
							"location": "querystring",
							"locationName": "continentcode"
						},
						"CountryCode": {
							"location": "querystring",
							"locationName": "countrycode"
						},
						"SubdivisionCode": {
							"location": "querystring",
							"locationName": "subdivisioncode"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"GeoLocationDetails"
					],
					"members": {
						"GeoLocationDetails": {
							"shape": "S47"
						}
					}
				}
			},
			"GetHealthCheck": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheck"
					],
					"members": {
						"HealthCheck": {
							"shape": "S1z"
						}
					}
				}
			},
			"GetHealthCheckCount": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheckcount"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheckCount"
					],
					"members": {
						"HealthCheckCount": {
							"type": "long"
						}
					}
				}
			},
			"GetHealthCheckLastFailureReason": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheckObservations"
					],
					"members": {
						"HealthCheckObservations": {
							"shape": "S4i"
						}
					}
				}
			},
			"GetHealthCheckStatus": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/status"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheckObservations"
					],
					"members": {
						"HealthCheckObservations": {
							"shape": "S4i"
						}
					}
				}
			},
			"GetHostedZone": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZone"
					],
					"members": {
						"HostedZone": {
							"shape": "S2k"
						},
						"DelegationSet": {
							"shape": "S2m"
						},
						"VPCs": {
							"shape": "S4q"
						}
					}
				}
			},
			"GetHostedZoneCount": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzonecount"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZoneCount"
					],
					"members": {
						"HostedZoneCount": {
							"type": "long"
						}
					}
				}
			},
			"GetHostedZoneLimit": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzonelimit/{Id}/{Type}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Type",
						"HostedZoneId"
					],
					"members": {
						"Type": {
							"location": "uri",
							"locationName": "Type"
						},
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Limit",
						"Count"
					],
					"members": {
						"Limit": {
							"type": "structure",
							"required": [
								"Type",
								"Value"
							],
							"members": {
								"Type": {},
								"Value": {
									"type": "long"
								}
							}
						},
						"Count": {
							"type": "long"
						}
					}
				}
			},
			"GetQueryLoggingConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/queryloggingconfig/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"QueryLoggingConfig"
					],
					"members": {
						"QueryLoggingConfig": {
							"shape": "S2r"
						}
					}
				}
			},
			"GetReusableDelegationSet": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/delegationset/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DelegationSet"
					],
					"members": {
						"DelegationSet": {
							"shape": "S2m"
						}
					}
				}
			},
			"GetReusableDelegationSetLimit": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/reusabledelegationsetlimit/{Id}/{Type}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Type",
						"DelegationSetId"
					],
					"members": {
						"Type": {
							"location": "uri",
							"locationName": "Type"
						},
						"DelegationSetId": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Limit",
						"Count"
					],
					"members": {
						"Limit": {
							"type": "structure",
							"required": [
								"Type",
								"Value"
							],
							"members": {
								"Type": {},
								"Value": {
									"type": "long"
								}
							}
						},
						"Count": {
							"type": "long"
						}
					}
				}
			},
			"GetTrafficPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Version"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Version": {
							"location": "uri",
							"locationName": "Version",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S30"
						}
					}
				}
			},
			"GetTrafficPolicyInstance": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstance"
					],
					"members": {
						"TrafficPolicyInstance": {
							"shape": "S35"
						}
					}
				}
			},
			"GetTrafficPolicyInstanceCount": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstancecount"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstanceCount"
					],
					"members": {
						"TrafficPolicyInstanceCount": {
							"type": "integer"
						}
					}
				}
			},
			"ListGeoLocations": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/geolocations"
				},
				"input": {
					"type": "structure",
					"members": {
						"StartContinentCode": {
							"location": "querystring",
							"locationName": "startcontinentcode"
						},
						"StartCountryCode": {
							"location": "querystring",
							"locationName": "startcountrycode"
						},
						"StartSubdivisionCode": {
							"location": "querystring",
							"locationName": "startsubdivisioncode"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"GeoLocationDetailsList",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"GeoLocationDetailsList": {
							"type": "list",
							"member": {
								"shape": "S47",
								"locationName": "GeoLocationDetails"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextContinentCode": {},
						"NextCountryCode": {},
						"NextSubdivisionCode": {},
						"MaxItems": {}
					}
				}
			},
			"ListHealthChecks": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthChecks",
						"Marker",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"HealthChecks": {
							"type": "list",
							"member": {
								"shape": "S1z",
								"locationName": "HealthCheck"
							}
						},
						"Marker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListHostedZones": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						},
						"DelegationSetId": {
							"location": "querystring",
							"locationName": "delegationsetid"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZones",
						"Marker",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"HostedZones": {
							"shape": "S5o"
						},
						"Marker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListHostedZonesByName": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzonesbyname"
				},
				"input": {
					"type": "structure",
					"members": {
						"DNSName": {
							"location": "querystring",
							"locationName": "dnsname"
						},
						"HostedZoneId": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZones",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"HostedZones": {
							"shape": "S5o"
						},
						"DNSName": {},
						"HostedZoneId": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextDNSName": {},
						"NextHostedZoneId": {},
						"MaxItems": {}
					}
				}
			},
			"ListQueryLoggingConfigs": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/queryloggingconfig"
				},
				"input": {
					"type": "structure",
					"members": {
						"HostedZoneId": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nexttoken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxresults"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"QueryLoggingConfigs"
					],
					"members": {
						"QueryLoggingConfigs": {
							"type": "list",
							"member": {
								"shape": "S2r",
								"locationName": "QueryLoggingConfig"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListResourceRecordSets": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone/{Id}/rrset"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"StartRecordName": {
							"location": "querystring",
							"locationName": "name"
						},
						"StartRecordType": {
							"location": "querystring",
							"locationName": "type"
						},
						"StartRecordIdentifier": {
							"location": "querystring",
							"locationName": "identifier"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceRecordSets",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"ResourceRecordSets": {
							"type": "list",
							"member": {
								"shape": "Sh",
								"locationName": "ResourceRecordSet"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextRecordName": {},
						"NextRecordType": {},
						"NextRecordIdentifier": {},
						"MaxItems": {}
					}
				}
			},
			"ListReusableDelegationSets": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/delegationset"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DelegationSets",
						"Marker",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"DelegationSets": {
							"type": "list",
							"member": {
								"shape": "S2m",
								"locationName": "DelegationSet"
							}
						},
						"Marker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {
							"location": "uri",
							"locationName": "ResourceType"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceTagSet"
					],
					"members": {
						"ResourceTagSet": {
							"shape": "S64"
						}
					}
				}
			},
			"ListTagsForResources": {
				"http": {
					"requestUri": "/2013-04-01/tags/{ResourceType}"
				},
				"input": {
					"locationName": "ListTagsForResourcesRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceIds"
					],
					"members": {
						"ResourceType": {
							"location": "uri",
							"locationName": "ResourceType"
						},
						"ResourceIds": {
							"type": "list",
							"member": {
								"locationName": "ResourceId"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceTagSets"
					],
					"members": {
						"ResourceTagSets": {
							"type": "list",
							"member": {
								"shape": "S64",
								"locationName": "ResourceTagSet"
							}
						}
					}
				}
			},
			"ListTrafficPolicies": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicies"
				},
				"input": {
					"type": "structure",
					"members": {
						"TrafficPolicyIdMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyid"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicySummaries",
						"IsTruncated",
						"TrafficPolicyIdMarker",
						"MaxItems"
					],
					"members": {
						"TrafficPolicySummaries": {
							"type": "list",
							"member": {
								"locationName": "TrafficPolicySummary",
								"type": "structure",
								"required": [
									"Id",
									"Name",
									"Type",
									"LatestVersion",
									"TrafficPolicyCount"
								],
								"members": {
									"Id": {},
									"Name": {},
									"Type": {},
									"LatestVersion": {
										"type": "integer"
									},
									"TrafficPolicyCount": {
										"type": "integer"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"TrafficPolicyIdMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyInstances": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstances"
				},
				"input": {
					"type": "structure",
					"members": {
						"HostedZoneIdMarker": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"TrafficPolicyInstanceNameMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancename"
						},
						"TrafficPolicyInstanceTypeMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancetype"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstances",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"TrafficPolicyInstances": {
							"shape": "S6f"
						},
						"HostedZoneIdMarker": {},
						"TrafficPolicyInstanceNameMarker": {},
						"TrafficPolicyInstanceTypeMarker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyInstancesByHostedZone": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstances/hostedzone"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId"
					],
					"members": {
						"HostedZoneId": {
							"location": "querystring",
							"locationName": "id"
						},
						"TrafficPolicyInstanceNameMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancename"
						},
						"TrafficPolicyInstanceTypeMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancetype"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstances",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"TrafficPolicyInstances": {
							"shape": "S6f"
						},
						"TrafficPolicyInstanceNameMarker": {},
						"TrafficPolicyInstanceTypeMarker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyInstancesByPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstances/trafficpolicy"
				},
				"input": {
					"type": "structure",
					"required": [
						"TrafficPolicyId",
						"TrafficPolicyVersion"
					],
					"members": {
						"TrafficPolicyId": {
							"location": "querystring",
							"locationName": "id"
						},
						"TrafficPolicyVersion": {
							"location": "querystring",
							"locationName": "version",
							"type": "integer"
						},
						"HostedZoneIdMarker": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"TrafficPolicyInstanceNameMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancename"
						},
						"TrafficPolicyInstanceTypeMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancetype"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstances",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"TrafficPolicyInstances": {
							"shape": "S6f"
						},
						"HostedZoneIdMarker": {},
						"TrafficPolicyInstanceNameMarker": {},
						"TrafficPolicyInstanceTypeMarker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicies/{Id}/versions"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"TrafficPolicyVersionMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyversion"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicies",
						"IsTruncated",
						"TrafficPolicyVersionMarker",
						"MaxItems"
					],
					"members": {
						"TrafficPolicies": {
							"type": "list",
							"member": {
								"shape": "S30",
								"locationName": "TrafficPolicy"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"TrafficPolicyVersionMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListVPCAssociationAuthorizations": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nexttoken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxresults"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPCs"
					],
					"members": {
						"HostedZoneId": {},
						"NextToken": {},
						"VPCs": {
							"shape": "S4q"
						}
					}
				}
			},
			"TestDNSAnswer": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/testdnsanswer"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId",
						"RecordName",
						"RecordType"
					],
					"members": {
						"HostedZoneId": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"RecordName": {
							"location": "querystring",
							"locationName": "recordname"
						},
						"RecordType": {
							"location": "querystring",
							"locationName": "recordtype"
						},
						"ResolverIP": {
							"location": "querystring",
							"locationName": "resolverip"
						},
						"EDNS0ClientSubnetIP": {
							"location": "querystring",
							"locationName": "edns0clientsubnetip"
						},
						"EDNS0ClientSubnetMask": {
							"location": "querystring",
							"locationName": "edns0clientsubnetmask"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Nameserver",
						"RecordName",
						"RecordType",
						"RecordData",
						"ResponseCode",
						"Protocol"
					],
					"members": {
						"Nameserver": {},
						"RecordName": {},
						"RecordType": {},
						"RecordData": {
							"type": "list",
							"member": {
								"locationName": "RecordDataEntry"
							}
						},
						"ResponseCode": {},
						"Protocol": {}
					}
				}
			},
			"UpdateHealthCheck": {
				"http": {
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
				},
				"input": {
					"locationName": "UpdateHealthCheckRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						},
						"HealthCheckVersion": {
							"type": "long"
						},
						"IPAddress": {},
						"Port": {
							"type": "integer"
						},
						"ResourcePath": {},
						"FullyQualifiedDomainName": {},
						"SearchString": {},
						"FailureThreshold": {
							"type": "integer"
						},
						"Inverted": {
							"type": "boolean"
						},
						"Disabled": {
							"type": "boolean"
						},
						"HealthThreshold": {
							"type": "integer"
						},
						"ChildHealthChecks": {
							"shape": "S1q"
						},
						"EnableSNI": {
							"type": "boolean"
						},
						"Regions": {
							"shape": "S1s"
						},
						"AlarmIdentifier": {
							"shape": "S1u"
						},
						"InsufficientDataHealthStatus": {},
						"ResetElements": {
							"type": "list",
							"member": {
								"locationName": "ResettableElementName"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheck"
					],
					"members": {
						"HealthCheck": {
							"shape": "S1z"
						}
					}
				}
			},
			"UpdateHostedZoneComment": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}"
				},
				"input": {
					"locationName": "UpdateHostedZoneCommentRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZone"
					],
					"members": {
						"HostedZone": {
							"shape": "S2k"
						}
					}
				}
			},
			"UpdateTrafficPolicyComment": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
				},
				"input": {
					"locationName": "UpdateTrafficPolicyCommentRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id",
						"Version",
						"Comment"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Version": {
							"location": "uri",
							"locationName": "Version",
							"type": "integer"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S30"
						}
					}
				}
			},
			"UpdateTrafficPolicyInstance": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
				},
				"input": {
					"locationName": "UpdateTrafficPolicyInstanceRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id",
						"TTL",
						"TrafficPolicyId",
						"TrafficPolicyVersion"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"TTL": {
							"type": "long"
						},
						"TrafficPolicyId": {},
						"TrafficPolicyVersion": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstance"
					],
					"members": {
						"TrafficPolicyInstance": {
							"shape": "S35"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "structure",
				"members": {
					"VPCRegion": {},
					"VPCId": {}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"SubmittedAt"
				],
				"members": {
					"Id": {},
					"Status": {},
					"SubmittedAt": {
						"type": "timestamp"
					},
					"Comment": {}
				}
			},
			"Sh": {
				"type": "structure",
				"required": [
					"Name",
					"Type"
				],
				"members": {
					"Name": {},
					"Type": {},
					"SetIdentifier": {},
					"Weight": {
						"type": "long"
					},
					"Region": {},
					"GeoLocation": {
						"type": "structure",
						"members": {
							"ContinentCode": {},
							"CountryCode": {},
							"SubdivisionCode": {}
						}
					},
					"Failover": {},
					"MultiValueAnswer": {
						"type": "boolean"
					},
					"TTL": {
						"type": "long"
					},
					"ResourceRecords": {
						"type": "list",
						"member": {
							"locationName": "ResourceRecord",
							"type": "structure",
							"required": [
								"Value"
							],
							"members": {
								"Value": {}
							}
						}
					},
					"AliasTarget": {
						"type": "structure",
						"required": [
							"HostedZoneId",
							"DNSName",
							"EvaluateTargetHealth"
						],
						"members": {
							"HostedZoneId": {},
							"DNSName": {},
							"EvaluateTargetHealth": {
								"type": "boolean"
							}
						}
					},
					"HealthCheckId": {},
					"TrafficPolicyInstanceId": {}
				}
			},
			"S15": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"IPAddress": {},
					"Port": {
						"type": "integer"
					},
					"Type": {},
					"ResourcePath": {},
					"FullyQualifiedDomainName": {},
					"SearchString": {},
					"RequestInterval": {
						"type": "integer"
					},
					"FailureThreshold": {
						"type": "integer"
					},
					"MeasureLatency": {
						"type": "boolean"
					},
					"Inverted": {
						"type": "boolean"
					},
					"Disabled": {
						"type": "boolean"
					},
					"HealthThreshold": {
						"type": "integer"
					},
					"ChildHealthChecks": {
						"shape": "S1q"
					},
					"EnableSNI": {
						"type": "boolean"
					},
					"Regions": {
						"shape": "S1s"
					},
					"AlarmIdentifier": {
						"shape": "S1u"
					},
					"InsufficientDataHealthStatus": {}
				}
			},
			"S1q": {
				"type": "list",
				"member": {
					"locationName": "ChildHealthCheck"
				}
			},
			"S1s": {
				"type": "list",
				"member": {
					"locationName": "Region"
				}
			},
			"S1u": {
				"type": "structure",
				"required": [
					"Region",
					"Name"
				],
				"members": {
					"Region": {},
					"Name": {}
				}
			},
			"S1z": {
				"type": "structure",
				"required": [
					"Id",
					"CallerReference",
					"HealthCheckConfig",
					"HealthCheckVersion"
				],
				"members": {
					"Id": {},
					"CallerReference": {},
					"LinkedService": {
						"shape": "S20"
					},
					"HealthCheckConfig": {
						"shape": "S1d"
					},
					"HealthCheckVersion": {
						"type": "long"
					},
					"CloudWatchAlarmConfiguration": {
						"type": "structure",
						"required": [
							"EvaluationPeriods",
							"Threshold",
							"ComparisonOperator",
							"Period",
							"MetricName",
							"Namespace",
							"Statistic"
						],
						"members": {
							"EvaluationPeriods": {
								"type": "integer"
							},
							"Threshold": {
								"type": "double"
							},
							"ComparisonOperator": {},
							"Period": {
								"type": "integer"
							},
							"MetricName": {},
							"Namespace": {},
							"Statistic": {},
							"Dimensions": {
								"type": "list",
								"member": {
									"locationName": "Dimension",
									"type": "structure",
									"required": [
										"Name",
										"Value"
									],
									"members": {
										"Name": {},
										"Value": {}
									}
								}
							}
						}
					}
				}
			},
			"S20": {
				"type": "structure",
				"members": {
					"ServicePrincipal": {},
					"Description": {}
				}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"Comment": {},
					"PrivateZone": {
						"type": "boolean"
					}
				}
			},
			"S2k": {
				"type": "structure",
				"required": [
					"Id",
					"Name",
					"CallerReference"
				],
				"members": {
					"Id": {},
					"Name": {},
					"CallerReference": {},
					"Config": {
						"shape": "S2h"
					},
					"ResourceRecordSetCount": {
						"type": "long"
					},
					"LinkedService": {
						"shape": "S20"
					}
				}
			},
			"S2m": {
				"type": "structure",
				"required": [
					"NameServers"
				],
				"members": {
					"Id": {},
					"CallerReference": {},
					"NameServers": {
						"type": "list",
						"member": {
							"locationName": "NameServer"
						}
					}
				}
			},
			"S2r": {
				"type": "structure",
				"required": [
					"Id",
					"HostedZoneId",
					"CloudWatchLogsLogGroupArn"
				],
				"members": {
					"Id": {},
					"HostedZoneId": {},
					"CloudWatchLogsLogGroupArn": {}
				}
			},
			"S30": {
				"type": "structure",
				"required": [
					"Id",
					"Version",
					"Name",
					"Type",
					"Document"
				],
				"members": {
					"Id": {},
					"Version": {
						"type": "integer"
					},
					"Name": {},
					"Type": {},
					"Document": {},
					"Comment": {}
				}
			},
			"S35": {
				"type": "structure",
				"required": [
					"Id",
					"HostedZoneId",
					"Name",
					"TTL",
					"State",
					"Message",
					"TrafficPolicyId",
					"TrafficPolicyVersion",
					"TrafficPolicyType"
				],
				"members": {
					"Id": {},
					"HostedZoneId": {},
					"Name": {},
					"TTL": {
						"type": "long"
					},
					"State": {},
					"Message": {},
					"TrafficPolicyId": {},
					"TrafficPolicyVersion": {
						"type": "integer"
					},
					"TrafficPolicyType": {}
				}
			},
			"S47": {
				"type": "structure",
				"members": {
					"ContinentCode": {},
					"ContinentName": {},
					"CountryCode": {},
					"CountryName": {},
					"SubdivisionCode": {},
					"SubdivisionName": {}
				}
			},
			"S4i": {
				"type": "list",
				"member": {
					"locationName": "HealthCheckObservation",
					"type": "structure",
					"members": {
						"Region": {},
						"IPAddress": {},
						"StatusReport": {
							"type": "structure",
							"members": {
								"Status": {},
								"CheckedTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"S4q": {
				"type": "list",
				"member": {
					"shape": "S3",
					"locationName": "VPC"
				}
			},
			"S5o": {
				"type": "list",
				"member": {
					"shape": "S2k",
					"locationName": "HostedZone"
				}
			},
			"S64": {
				"type": "structure",
				"members": {
					"ResourceType": {},
					"ResourceId": {},
					"Tags": {
						"shape": "S15"
					}
				}
			},
			"S6f": {
				"type": "list",
				"member": {
					"shape": "S35",
					"locationName": "TrafficPolicyInstance"
				}
			}
		}
	};

/***/ },
/* 1827 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListHealthChecks": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "NextMarker",
				"result_key": "HealthChecks"
			},
			"ListHostedZones": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "NextMarker",
				"result_key": "HostedZones"
			},
			"ListResourceRecordSets": {
				"input_token": [
					"StartRecordName",
					"StartRecordType",
					"StartRecordIdentifier"
				],
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": [
					"NextRecordName",
					"NextRecordType",
					"NextRecordIdentifier"
				],
				"result_key": "ResourceRecordSets"
			}
		}
	};

/***/ },
/* 1828 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"ResourceRecordSetsChanged": {
				"delay": 30,
				"maxAttempts": 60,
				"operation": "GetChange",
				"acceptors": [
					{
						"matcher": "path",
						"expected": "INSYNC",
						"argument": "ChangeInfo.Status",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 1829 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-05-15",
			"endpointPrefix": "route53domains",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Route 53 Domains",
			"serviceId": "Route 53 Domains",
			"signatureVersion": "v4",
			"targetPrefix": "Route53Domains_v20140515",
			"uid": "route53domains-2014-05-15"
		},
		"operations": {
			"CheckDomainAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"IdnLangCode": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Availability"
					],
					"members": {
						"Availability": {}
					}
				}
			},
			"CheckDomainTransferability": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"AuthCode": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Transferability"
					],
					"members": {
						"Transferability": {
							"type": "structure",
							"members": {
								"Transferable": {}
							}
						}
					}
				}
			},
			"DeleteTagsForDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"TagsToDelete"
					],
					"members": {
						"DomainName": {},
						"TagsToDelete": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisableDomainAutoRenew": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisableDomainTransferLock": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"EnableDomainAutoRenew": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"EnableDomainTransferLock": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"GetContactReachabilityStatus": {
				"input": {
					"type": "structure",
					"members": {
						"domainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"domainName": {},
						"status": {}
					}
				}
			},
			"GetDomainDetail": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DomainName",
						"Nameservers",
						"AdminContact",
						"RegistrantContact",
						"TechContact"
					],
					"members": {
						"DomainName": {},
						"Nameservers": {
							"shape": "St"
						},
						"AutoRenew": {
							"type": "boolean"
						},
						"AdminContact": {
							"shape": "Sz"
						},
						"RegistrantContact": {
							"shape": "Sz"
						},
						"TechContact": {
							"shape": "Sz"
						},
						"AdminPrivacy": {
							"type": "boolean"
						},
						"RegistrantPrivacy": {
							"type": "boolean"
						},
						"TechPrivacy": {
							"type": "boolean"
						},
						"RegistrarName": {},
						"WhoIsServer": {},
						"RegistrarUrl": {},
						"AbuseContactEmail": {},
						"AbuseContactPhone": {},
						"RegistryDomainId": {},
						"CreationDate": {
							"type": "timestamp"
						},
						"UpdatedDate": {
							"type": "timestamp"
						},
						"ExpirationDate": {
							"type": "timestamp"
						},
						"Reseller": {},
						"DnsSec": {},
						"StatusList": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetDomainSuggestions": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"SuggestionCount",
						"OnlyAvailable"
					],
					"members": {
						"DomainName": {},
						"SuggestionCount": {
							"type": "integer"
						},
						"OnlyAvailable": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SuggestionsList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DomainName": {},
									"Availability": {}
								}
							}
						}
					}
				}
			},
			"GetOperationDetail": {
				"input": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OperationId": {},
						"Status": {},
						"Message": {},
						"DomainName": {},
						"Type": {},
						"SubmittedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"ListDomains": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Domains"
					],
					"members": {
						"Domains": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"DomainName"
								],
								"members": {
									"DomainName": {},
									"AutoRenew": {
										"type": "boolean"
									},
									"TransferLock": {
										"type": "boolean"
									},
									"Expiry": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextPageMarker": {}
					}
				}
			},
			"ListOperations": {
				"input": {
					"type": "structure",
					"members": {
						"SubmittedSince": {
							"type": "timestamp"
						},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Operations"
					],
					"members": {
						"Operations": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"OperationId",
									"Status",
									"Type",
									"SubmittedDate"
								],
								"members": {
									"OperationId": {},
									"Status": {},
									"Type": {},
									"SubmittedDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextPageMarker": {}
					}
				}
			},
			"ListTagsForDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagList"
					],
					"members": {
						"TagList": {
							"shape": "S29"
						}
					}
				}
			},
			"RegisterDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"DurationInYears",
						"AdminContact",
						"RegistrantContact",
						"TechContact"
					],
					"members": {
						"DomainName": {},
						"IdnLangCode": {},
						"DurationInYears": {
							"type": "integer"
						},
						"AutoRenew": {
							"type": "boolean"
						},
						"AdminContact": {
							"shape": "Sz"
						},
						"RegistrantContact": {
							"shape": "Sz"
						},
						"TechContact": {
							"shape": "Sz"
						},
						"PrivacyProtectAdminContact": {
							"type": "boolean"
						},
						"PrivacyProtectRegistrantContact": {
							"type": "boolean"
						},
						"PrivacyProtectTechContact": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"RenewDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"CurrentExpiryYear"
					],
					"members": {
						"DomainName": {},
						"DurationInYears": {
							"type": "integer"
						},
						"CurrentExpiryYear": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"ResendContactReachabilityEmail": {
				"input": {
					"type": "structure",
					"members": {
						"domainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"domainName": {},
						"emailAddress": {},
						"isAlreadyVerified": {
							"type": "boolean"
						}
					}
				}
			},
			"RetrieveDomainAuthCode": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"AuthCode"
					],
					"members": {
						"AuthCode": {
							"shape": "S7"
						}
					}
				}
			},
			"TransferDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"DurationInYears",
						"AdminContact",
						"RegistrantContact",
						"TechContact"
					],
					"members": {
						"DomainName": {},
						"IdnLangCode": {},
						"DurationInYears": {
							"type": "integer"
						},
						"Nameservers": {
							"shape": "St"
						},
						"AuthCode": {
							"shape": "S7"
						},
						"AutoRenew": {
							"type": "boolean"
						},
						"AdminContact": {
							"shape": "Sz"
						},
						"RegistrantContact": {
							"shape": "Sz"
						},
						"TechContact": {
							"shape": "Sz"
						},
						"PrivacyProtectAdminContact": {
							"type": "boolean"
						},
						"PrivacyProtectRegistrantContact": {
							"type": "boolean"
						},
						"PrivacyProtectTechContact": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateDomainContact": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"AdminContact": {
							"shape": "Sz"
						},
						"RegistrantContact": {
							"shape": "Sz"
						},
						"TechContact": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateDomainContactPrivacy": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"AdminPrivacy": {
							"type": "boolean"
						},
						"RegistrantPrivacy": {
							"type": "boolean"
						},
						"TechPrivacy": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateDomainNameservers": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"Nameservers"
					],
					"members": {
						"DomainName": {},
						"FIAuthKey": {
							"deprecated": true
						},
						"Nameservers": {
							"shape": "St"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateTagsForDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"TagsToUpdate": {
							"shape": "S29"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ViewBilling": {
				"input": {
					"type": "structure",
					"members": {
						"Start": {
							"type": "timestamp"
						},
						"End": {
							"type": "timestamp"
						},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextPageMarker": {},
						"BillingRecords": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DomainName": {},
									"Operation": {},
									"InvoiceId": {},
									"BillDate": {
										"type": "timestamp"
									},
									"Price": {
										"type": "double"
									}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {
			"S7": {
				"type": "string",
				"sensitive": true
			},
			"St": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"GlueIps": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"FirstName": {},
					"LastName": {},
					"ContactType": {},
					"OrganizationName": {},
					"AddressLine1": {},
					"AddressLine2": {},
					"City": {},
					"State": {},
					"CountryCode": {},
					"ZipCode": {},
					"PhoneNumber": {},
					"Email": {},
					"Fax": {},
					"ExtraParams": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Name",
								"Value"
							],
							"members": {
								"Name": {},
								"Value": {}
							}
						}
					}
				},
				"sensitive": true
			},
			"S29": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			}
		}
	};

/***/ },
/* 1830 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListDomains": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"output_token": "NextPageMarker",
				"result_key": "Domains"
			},
			"ListOperations": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"output_token": "NextPageMarker",
				"result_key": "Operations"
			}
		}
	};

/***/ },
/* 1831 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-11-28",
			"endpointPrefix": "runtime.lex",
			"jsonVersion": "1.1",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Lex Runtime Service",
			"serviceId": "Lex Runtime Service",
			"signatureVersion": "v4",
			"signingName": "lex",
			"uid": "runtime.lex-2016-11-28"
		},
		"operations": {
			"DeleteSession": {
				"http": {
					"method": "DELETE",
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"botName": {},
						"botAlias": {},
						"userId": {},
						"sessionId": {}
					}
				}
			},
			"GetSession": {
				"http": {
					"method": "GET",
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"recentIntentSummaryView": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"dialogActionType"
								],
								"members": {
									"intentName": {},
									"slots": {
										"shape": "Sc"
									},
									"confirmationStatus": {},
									"dialogActionType": {},
									"fulfillmentState": {},
									"slotToElicit": {}
								}
							}
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"sessionId": {},
						"dialogAction": {
							"shape": "Sg"
						}
					}
				}
			},
			"PostContent": {
				"http": {
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/content"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId",
						"contentType",
						"inputStream"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						},
						"sessionAttributes": {
							"shape": "Sk",
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-session-attributes"
						},
						"requestAttributes": {
							"shape": "Sk",
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-request-attributes"
						},
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"accept": {
							"location": "header",
							"locationName": "Accept"
						},
						"inputStream": {
							"shape": "Sn"
						}
					},
					"payload": "inputStream"
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"intentName": {
							"location": "header",
							"locationName": "x-amz-lex-intent-name"
						},
						"slots": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-slots"
						},
						"sessionAttributes": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-session-attributes"
						},
						"message": {
							"shape": "Sh",
							"location": "header",
							"locationName": "x-amz-lex-message"
						},
						"messageFormat": {
							"location": "header",
							"locationName": "x-amz-lex-message-format"
						},
						"dialogState": {
							"location": "header",
							"locationName": "x-amz-lex-dialog-state"
						},
						"slotToElicit": {
							"location": "header",
							"locationName": "x-amz-lex-slot-to-elicit"
						},
						"inputTranscript": {
							"location": "header",
							"locationName": "x-amz-lex-input-transcript"
						},
						"audioStream": {
							"shape": "Sn"
						}
					},
					"payload": "audioStream"
				},
				"authtype": "v4-unsigned-body"
			},
			"PostText": {
				"http": {
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/text"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId",
						"inputText"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"requestAttributes": {
							"shape": "Sc"
						},
						"inputText": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"intentName": {},
						"slots": {
							"shape": "Sc"
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"message": {
							"shape": "Sh"
						},
						"messageFormat": {},
						"dialogState": {},
						"slotToElicit": {},
						"responseCard": {
							"type": "structure",
							"members": {
								"version": {},
								"contentType": {},
								"genericAttachments": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"title": {},
											"subTitle": {},
											"attachmentLinkUrl": {},
											"imageUrl": {},
											"buttons": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"text",
														"value"
													],
													"members": {
														"text": {},
														"value": {}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"PutSession": {
				"http": {
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/session"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						},
						"sessionAttributes": {
							"shape": "Sc"
						},
						"dialogAction": {
							"shape": "Sg"
						},
						"accept": {
							"location": "header",
							"locationName": "Accept"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"intentName": {
							"location": "header",
							"locationName": "x-amz-lex-intent-name"
						},
						"slots": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-slots"
						},
						"sessionAttributes": {
							"jsonvalue": true,
							"location": "header",
							"locationName": "x-amz-lex-session-attributes"
						},
						"message": {
							"shape": "Sh",
							"location": "header",
							"locationName": "x-amz-lex-message"
						},
						"messageFormat": {
							"location": "header",
							"locationName": "x-amz-lex-message-format"
						},
						"dialogState": {
							"location": "header",
							"locationName": "x-amz-lex-dialog-state"
						},
						"slotToElicit": {
							"location": "header",
							"locationName": "x-amz-lex-slot-to-elicit"
						},
						"audioStream": {
							"shape": "Sn"
						},
						"sessionId": {
							"location": "header",
							"locationName": "x-amz-lex-session-id"
						}
					},
					"payload": "audioStream"
				}
			}
		},
		"shapes": {
			"Sc": {
				"type": "map",
				"key": {},
				"value": {},
				"sensitive": true
			},
			"Sg": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"intentName": {},
					"slots": {
						"shape": "Sc"
					},
					"slotToElicit": {},
					"fulfillmentState": {},
					"message": {
						"shape": "Sh"
					},
					"messageFormat": {}
				}
			},
			"Sh": {
				"type": "string",
				"sensitive": true
			},
			"Sk": {
				"type": "string",
				"sensitive": true
			},
			"Sn": {
				"type": "blob",
				"streaming": true
			}
		}
	};

/***/ },
/* 1832 */
1641,
/* 1833 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2006-03-01",
			"checksumFormat": "md5",
			"endpointPrefix": "s3",
			"globalEndpoint": "s3.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "Amazon S3",
			"serviceFullName": "Amazon Simple Storage Service",
			"serviceId": "S3",
			"signatureVersion": "s3",
			"uid": "s3-2006-03-01"
		},
		"operations": {
			"AbortMultipartUpload": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"CompleteMultipartUpload": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MultipartUpload": {
							"locationName": "CompleteMultipartUpload",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Parts": {
									"locationName": "Part",
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ETag": {},
											"PartNumber": {
												"type": "integer"
											}
										}
									},
									"flattened": true
								}
							}
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "MultipartUpload"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {},
						"Bucket": {},
						"Key": {},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"ETag": {},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"CopyObject": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CopySource",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"CopySource": {
							"location": "header",
							"locationName": "x-amz-copy-source"
						},
						"CopySourceIfMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-match"
						},
						"CopySourceIfModifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-modified-since",
							"type": "timestamp"
						},
						"CopySourceIfNoneMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-none-match"
						},
						"CopySourceIfUnmodifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-unmodified-since",
							"type": "timestamp"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"MetadataDirective": {
							"location": "header",
							"locationName": "x-amz-metadata-directive"
						},
						"TaggingDirective": {
							"location": "header",
							"locationName": "x-amz-tagging-directive"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"CopySourceSSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
						},
						"CopySourceSSECustomerKey": {
							"shape": "S1d",
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
						},
						"CopySourceSSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopyObjectResult": {
							"type": "structure",
							"members": {
								"ETag": {},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"CopySourceVersionId": {
							"location": "header",
							"locationName": "x-amz-copy-source-version-id"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "CopyObjectResult"
				},
				"alias": "PutObjectCopy"
			},
			"CreateBucket": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CreateBucketConfiguration": {
							"locationName": "CreateBucketConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"LocationConstraint": {}
							}
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"ObjectLockEnabledForBucket": {
							"location": "header",
							"locationName": "x-amz-bucket-object-lock-enabled",
							"type": "boolean"
						}
					},
					"payload": "CreateBucketConfiguration"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				},
				"alias": "PutBucket"
			},
			"CreateMultipartUpload": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?uploads"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AbortDate": {
							"location": "header",
							"locationName": "x-amz-abort-date",
							"type": "timestamp"
						},
						"AbortRuleId": {
							"location": "header",
							"locationName": "x-amz-abort-rule-id"
						},
						"Bucket": {
							"locationName": "Bucket"
						},
						"Key": {},
						"UploadId": {},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				},
				"alias": "InitiateMultipartUpload"
			},
			"DeleteBucket": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketAnalyticsConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?analytics",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketCors": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?cors",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketEncryption": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?encryption",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketInventoryConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?inventory",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketLifecycle": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?lifecycle",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketMetricsConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?metrics",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketPolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?policy",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketReplication": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?replication",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketTagging": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?tagging",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketWebsite": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?website",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteObject": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"BypassGovernanceRetention": {
							"location": "header",
							"locationName": "x-amz-bypass-governance-retention",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"DeleteObjectTagging": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}?tagging",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						}
					}
				}
			},
			"DeleteObjects": {
				"http": {
					"requestUri": "/{Bucket}?delete"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Delete"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delete": {
							"locationName": "Delete",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Objects"
							],
							"members": {
								"Objects": {
									"locationName": "Object",
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Key"
										],
										"members": {
											"Key": {},
											"VersionId": {}
										}
									},
									"flattened": true
								},
								"Quiet": {
									"type": "boolean"
								}
							}
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"BypassGovernanceRetention": {
							"location": "header",
							"locationName": "x-amz-bypass-governance-retention",
							"type": "boolean"
						}
					},
					"payload": "Delete"
				},
				"output": {
					"type": "structure",
					"members": {
						"Deleted": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"VersionId": {},
									"DeleteMarker": {
										"type": "boolean"
									},
									"DeleteMarkerVersionId": {}
								}
							},
							"flattened": true
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"Errors": {
							"locationName": "Error",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"VersionId": {},
									"Code": {},
									"Message": {}
								}
							},
							"flattened": true
						}
					}
				},
				"alias": "DeleteMultipleObjects"
			},
			"DeletePublicAccessBlock": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?publicAccessBlock",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"GetBucketAccelerateConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?accelerate"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {}
					}
				}
			},
			"GetBucketAcl": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Owner": {
							"shape": "S32"
						},
						"Grants": {
							"shape": "S35",
							"locationName": "AccessControlList"
						}
					}
				}
			},
			"GetBucketAnalyticsConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AnalyticsConfiguration": {
							"shape": "S3e"
						}
					},
					"payload": "AnalyticsConfiguration"
				}
			},
			"GetBucketCors": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?cors"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CORSRules": {
							"shape": "S3u",
							"locationName": "CORSRule"
						}
					}
				}
			},
			"GetBucketEncryption": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?encryption"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServerSideEncryptionConfiguration": {
							"shape": "S47"
						}
					},
					"payload": "ServerSideEncryptionConfiguration"
				}
			},
			"GetBucketInventoryConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InventoryConfiguration": {
							"shape": "S4d"
						}
					},
					"payload": "InventoryConfiguration"
				}
			},
			"GetBucketLifecycle": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S4t",
							"locationName": "Rule"
						}
					}
				},
				"deprecated": true
			},
			"GetBucketLifecycleConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S58",
							"locationName": "Rule"
						}
					}
				}
			},
			"GetBucketLocation": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?location"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LocationConstraint": {}
					}
				}
			},
			"GetBucketLogging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?logging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoggingEnabled": {
							"shape": "S5i"
						}
					}
				}
			},
			"GetBucketMetricsConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MetricsConfiguration": {
							"shape": "S5q"
						}
					},
					"payload": "MetricsConfiguration"
				}
			},
			"GetBucketNotification": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"shape": "S5t"
				},
				"output": {
					"shape": "S5u"
				},
				"deprecated": true
			},
			"GetBucketNotificationConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"shape": "S5t"
				},
				"output": {
					"shape": "S65"
				}
			},
			"GetBucketPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?policy"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {}
					},
					"payload": "Policy"
				}
			},
			"GetBucketPolicyStatus": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?policyStatus"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PolicyStatus": {
							"type": "structure",
							"members": {
								"IsPublic": {
									"locationName": "IsPublic",
									"type": "boolean"
								}
							}
						}
					},
					"payload": "PolicyStatus"
				}
			},
			"GetBucketReplication": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?replication"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReplicationConfiguration": {
							"shape": "S6s"
						}
					},
					"payload": "ReplicationConfiguration"
				}
			},
			"GetBucketRequestPayment": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?requestPayment"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Payer": {}
					}
				}
			},
			"GetBucketTagging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagSet"
					],
					"members": {
						"TagSet": {
							"shape": "S3k"
						}
					}
				}
			},
			"GetBucketVersioning": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?versioning"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {},
						"MFADelete": {
							"locationName": "MfaDelete"
						}
					}
				}
			},
			"GetBucketWebsite": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?website"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RedirectAllRequestsTo": {
							"shape": "S7l"
						},
						"IndexDocument": {
							"shape": "S7o"
						},
						"ErrorDocument": {
							"shape": "S7q"
						},
						"RoutingRules": {
							"shape": "S7r"
						}
					}
				}
			},
			"GetObject": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						},
						"IfModifiedSince": {
							"location": "header",
							"locationName": "If-Modified-Since",
							"type": "timestamp"
						},
						"IfNoneMatch": {
							"location": "header",
							"locationName": "If-None-Match"
						},
						"IfUnmodifiedSince": {
							"location": "header",
							"locationName": "If-Unmodified-Since",
							"type": "timestamp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Range": {
							"location": "header",
							"locationName": "Range"
						},
						"ResponseCacheControl": {
							"location": "querystring",
							"locationName": "response-cache-control"
						},
						"ResponseContentDisposition": {
							"location": "querystring",
							"locationName": "response-content-disposition"
						},
						"ResponseContentEncoding": {
							"location": "querystring",
							"locationName": "response-content-encoding"
						},
						"ResponseContentLanguage": {
							"location": "querystring",
							"locationName": "response-content-language"
						},
						"ResponseContentType": {
							"location": "querystring",
							"locationName": "response-content-type"
						},
						"ResponseExpires": {
							"location": "querystring",
							"locationName": "response-expires",
							"type": "timestamp"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"AcceptRanges": {
							"location": "header",
							"locationName": "accept-ranges"
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"Restore": {
							"location": "header",
							"locationName": "x-amz-restore"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"MissingMeta": {
							"location": "header",
							"locationName": "x-amz-missing-meta",
							"type": "integer"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentRange": {
							"location": "header",
							"locationName": "Content-Range"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"ReplicationStatus": {
							"location": "header",
							"locationName": "x-amz-replication-status"
						},
						"PartsCount": {
							"location": "header",
							"locationName": "x-amz-mp-parts-count",
							"type": "integer"
						},
						"TagCount": {
							"location": "header",
							"locationName": "x-amz-tagging-count",
							"type": "integer"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					},
					"payload": "Body"
				}
			},
			"GetObjectAcl": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Owner": {
							"shape": "S32"
						},
						"Grants": {
							"shape": "S35",
							"locationName": "AccessControlList"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"GetObjectLegalHold": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?legal-hold"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LegalHold": {
							"shape": "S8q"
						}
					},
					"payload": "LegalHold"
				}
			},
			"GetObjectLockConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?object-lock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ObjectLockConfiguration": {
							"shape": "S8t"
						}
					},
					"payload": "ObjectLockConfiguration"
				}
			},
			"GetObjectRetention": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?retention"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Retention": {
							"shape": "S91"
						}
					},
					"payload": "Retention"
				}
			},
			"GetObjectTagging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagSet"
					],
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"TagSet": {
							"shape": "S3k"
						}
					}
				}
			},
			"GetObjectTorrent": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?torrent"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "Body"
				}
			},
			"GetPublicAccessBlock": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?publicAccessBlock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicAccessBlockConfiguration": {
							"shape": "S98"
						}
					},
					"payload": "PublicAccessBlockConfiguration"
				}
			},
			"HeadBucket": {
				"http": {
					"method": "HEAD",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"HeadObject": {
				"http": {
					"method": "HEAD",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						},
						"IfModifiedSince": {
							"location": "header",
							"locationName": "If-Modified-Since",
							"type": "timestamp"
						},
						"IfNoneMatch": {
							"location": "header",
							"locationName": "If-None-Match"
						},
						"IfUnmodifiedSince": {
							"location": "header",
							"locationName": "If-Unmodified-Since",
							"type": "timestamp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Range": {
							"location": "header",
							"locationName": "Range"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"AcceptRanges": {
							"location": "header",
							"locationName": "accept-ranges"
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"Restore": {
							"location": "header",
							"locationName": "x-amz-restore"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"MissingMeta": {
							"location": "header",
							"locationName": "x-amz-missing-meta",
							"type": "integer"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"ReplicationStatus": {
							"location": "header",
							"locationName": "x-amz-replication-status"
						},
						"PartsCount": {
							"location": "header",
							"locationName": "x-amz-mp-parts-count",
							"type": "integer"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					}
				}
			},
			"ListBucketAnalyticsConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"AnalyticsConfigurationList": {
							"locationName": "AnalyticsConfiguration",
							"type": "list",
							"member": {
								"shape": "S3e"
							},
							"flattened": true
						}
					}
				}
			},
			"ListBucketInventoryConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ContinuationToken": {},
						"InventoryConfigurationList": {
							"locationName": "InventoryConfiguration",
							"type": "list",
							"member": {
								"shape": "S4d"
							},
							"flattened": true
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextContinuationToken": {}
					}
				}
			},
			"ListBucketMetricsConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"MetricsConfigurationList": {
							"locationName": "MetricsConfiguration",
							"type": "list",
							"member": {
								"shape": "S5q"
							},
							"flattened": true
						}
					}
				}
			},
			"ListBuckets": {
				"http": {
					"method": "GET"
				},
				"output": {
					"type": "structure",
					"members": {
						"Buckets": {
							"type": "list",
							"member": {
								"locationName": "Bucket",
								"type": "structure",
								"members": {
									"Name": {},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"Owner": {
							"shape": "S32"
						}
					}
				},
				"alias": "GetService"
			},
			"ListMultipartUploads": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?uploads"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"KeyMarker": {
							"location": "querystring",
							"locationName": "key-marker"
						},
						"MaxUploads": {
							"location": "querystring",
							"locationName": "max-uploads",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"UploadIdMarker": {
							"location": "querystring",
							"locationName": "upload-id-marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Bucket": {},
						"KeyMarker": {},
						"UploadIdMarker": {},
						"NextKeyMarker": {},
						"Prefix": {},
						"Delimiter": {},
						"NextUploadIdMarker": {},
						"MaxUploads": {
							"type": "integer"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Uploads": {
							"locationName": "Upload",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"UploadId": {},
									"Key": {},
									"Initiated": {
										"type": "timestamp"
									},
									"StorageClass": {},
									"Owner": {
										"shape": "S32"
									},
									"Initiator": {
										"shape": "Sa5"
									}
								}
							},
							"flattened": true
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {}
					}
				}
			},
			"ListObjectVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?versions"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"KeyMarker": {
							"location": "querystring",
							"locationName": "key-marker"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"VersionIdMarker": {
							"location": "querystring",
							"locationName": "version-id-marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"KeyMarker": {},
						"VersionIdMarker": {},
						"NextKeyMarker": {},
						"NextVersionIdMarker": {},
						"Versions": {
							"locationName": "Version",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ETag": {},
									"Size": {
										"type": "integer"
									},
									"StorageClass": {},
									"Key": {},
									"VersionId": {},
									"IsLatest": {
										"type": "boolean"
									},
									"LastModified": {
										"type": "timestamp"
									},
									"Owner": {
										"shape": "S32"
									}
								}
							},
							"flattened": true
						},
						"DeleteMarkers": {
							"locationName": "DeleteMarker",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Owner": {
										"shape": "S32"
									},
									"Key": {},
									"VersionId": {},
									"IsLatest": {
										"type": "boolean"
									},
									"LastModified": {
										"type": "timestamp"
									}
								}
							},
							"flattened": true
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {}
					}
				},
				"alias": "GetBucketObjectVersions"
			},
			"ListObjects": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {},
						"NextMarker": {},
						"Contents": {
							"shape": "Sao"
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {}
					}
				},
				"alias": "GetBucket"
			},
			"ListObjectsV2": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?list-type=2"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						},
						"FetchOwner": {
							"location": "querystring",
							"locationName": "fetch-owner",
							"type": "boolean"
						},
						"StartAfter": {
							"location": "querystring",
							"locationName": "start-after"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"Contents": {
							"shape": "Sao"
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "Sa6"
						},
						"EncodingType": {},
						"KeyCount": {
							"type": "integer"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"StartAfter": {}
					}
				}
			},
			"ListParts": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MaxParts": {
							"location": "querystring",
							"locationName": "max-parts",
							"type": "integer"
						},
						"PartNumberMarker": {
							"location": "querystring",
							"locationName": "part-number-marker",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AbortDate": {
							"location": "header",
							"locationName": "x-amz-abort-date",
							"type": "timestamp"
						},
						"AbortRuleId": {
							"location": "header",
							"locationName": "x-amz-abort-rule-id"
						},
						"Bucket": {},
						"Key": {},
						"UploadId": {},
						"PartNumberMarker": {
							"type": "integer"
						},
						"NextPartNumberMarker": {
							"type": "integer"
						},
						"MaxParts": {
							"type": "integer"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Parts": {
							"locationName": "Part",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PartNumber": {
										"type": "integer"
									},
									"LastModified": {
										"type": "timestamp"
									},
									"ETag": {},
									"Size": {
										"type": "integer"
									}
								}
							},
							"flattened": true
						},
						"Initiator": {
							"shape": "Sa5"
						},
						"Owner": {
							"shape": "S32"
						},
						"StorageClass": {},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutBucketAccelerateConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?accelerate"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"AccelerateConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"AccelerateConfiguration": {
							"locationName": "AccelerateConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Status": {}
							}
						}
					},
					"payload": "AccelerateConfiguration"
				}
			},
			"PutBucketAcl": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"AccessControlPolicy": {
							"shape": "Sb6",
							"locationName": "AccessControlPolicy",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						}
					},
					"payload": "AccessControlPolicy"
				}
			},
			"PutBucketAnalyticsConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"AnalyticsConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"AnalyticsConfiguration": {
							"shape": "S3e",
							"locationName": "AnalyticsConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "AnalyticsConfiguration"
				}
			},
			"PutBucketCors": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?cors"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CORSConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CORSConfiguration": {
							"locationName": "CORSConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"CORSRules"
							],
							"members": {
								"CORSRules": {
									"shape": "S3u",
									"locationName": "CORSRule"
								}
							}
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "CORSConfiguration"
				}
			},
			"PutBucketEncryption": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?encryption"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"ServerSideEncryptionConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ServerSideEncryptionConfiguration": {
							"shape": "S47",
							"locationName": "ServerSideEncryptionConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "ServerSideEncryptionConfiguration"
				}
			},
			"PutBucketInventoryConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"InventoryConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"InventoryConfiguration": {
							"shape": "S4d",
							"locationName": "InventoryConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "InventoryConfiguration"
				}
			},
			"PutBucketLifecycle": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"LifecycleConfiguration": {
							"locationName": "LifecycleConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"shape": "S4t",
									"locationName": "Rule"
								}
							}
						}
					},
					"payload": "LifecycleConfiguration"
				},
				"deprecated": true
			},
			"PutBucketLifecycleConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"LifecycleConfiguration": {
							"locationName": "LifecycleConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"shape": "S58",
									"locationName": "Rule"
								}
							}
						}
					},
					"payload": "LifecycleConfiguration"
				}
			},
			"PutBucketLogging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?logging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"BucketLoggingStatus"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"BucketLoggingStatus": {
							"locationName": "BucketLoggingStatus",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"LoggingEnabled": {
									"shape": "S5i"
								}
							}
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "BucketLoggingStatus"
				}
			},
			"PutBucketMetricsConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"MetricsConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"MetricsConfiguration": {
							"shape": "S5q",
							"locationName": "MetricsConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "MetricsConfiguration"
				}
			},
			"PutBucketNotification": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"NotificationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"NotificationConfiguration": {
							"shape": "S5u",
							"locationName": "NotificationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "NotificationConfiguration"
				},
				"deprecated": true
			},
			"PutBucketNotificationConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"NotificationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"NotificationConfiguration": {
							"shape": "S65",
							"locationName": "NotificationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "NotificationConfiguration"
				}
			},
			"PutBucketPolicy": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?policy"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Policy"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ConfirmRemoveSelfBucketAccess": {
							"location": "header",
							"locationName": "x-amz-confirm-remove-self-bucket-access",
							"type": "boolean"
						},
						"Policy": {}
					},
					"payload": "Policy"
				}
			},
			"PutBucketReplication": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?replication"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"ReplicationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ReplicationConfiguration": {
							"shape": "S6s",
							"locationName": "ReplicationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Token": {
							"location": "header",
							"locationName": "x-amz-bucket-object-lock-token"
						}
					},
					"payload": "ReplicationConfiguration"
				}
			},
			"PutBucketRequestPayment": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?requestPayment"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"RequestPaymentConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"RequestPaymentConfiguration": {
							"locationName": "RequestPaymentConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Payer"
							],
							"members": {
								"Payer": {}
							}
						}
					},
					"payload": "RequestPaymentConfiguration"
				}
			},
			"PutBucketTagging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Tagging"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Tagging": {
							"shape": "Sbt",
							"locationName": "Tagging",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "Tagging"
				}
			},
			"PutBucketVersioning": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?versioning"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"VersioningConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"VersioningConfiguration": {
							"locationName": "VersioningConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"MFADelete": {
									"locationName": "MfaDelete"
								},
								"Status": {}
							}
						}
					},
					"payload": "VersioningConfiguration"
				}
			},
			"PutBucketWebsite": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?website"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"WebsiteConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"WebsiteConfiguration": {
							"locationName": "WebsiteConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"ErrorDocument": {
									"shape": "S7q"
								},
								"IndexDocument": {
									"shape": "S7o"
								},
								"RedirectAllRequestsTo": {
									"shape": "S7l"
								},
								"RoutingRules": {
									"shape": "S7r"
								}
							}
						}
					},
					"payload": "WebsiteConfiguration"
				}
			},
			"PutObject": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						},
						"ObjectLockMode": {
							"location": "header",
							"locationName": "x-amz-object-lock-mode"
						},
						"ObjectLockRetainUntilDate": {
							"shape": "S1h",
							"location": "header",
							"locationName": "x-amz-object-lock-retain-until-date"
						},
						"ObjectLockLegalHoldStatus": {
							"location": "header",
							"locationName": "x-amz-object-lock-legal-hold"
						}
					},
					"payload": "Body"
				},
				"output": {
					"type": "structure",
					"members": {
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"SSEKMSEncryptionContext": {
							"shape": "S1b",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-context"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectAcl": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"AccessControlPolicy": {
							"shape": "Sb6",
							"locationName": "AccessControlPolicy",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					},
					"payload": "AccessControlPolicy"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectLegalHold": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?legal-hold"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"LegalHold": {
							"shape": "S8q",
							"locationName": "LegalHold",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "LegalHold"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectLockConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?object-lock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ObjectLockConfiguration": {
							"shape": "S8t",
							"locationName": "ObjectLockConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Token": {
							"location": "header",
							"locationName": "x-amz-bucket-object-lock-token"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "ObjectLockConfiguration"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectRetention": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?retention"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Retention": {
							"shape": "S91",
							"locationName": "Retention",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"BypassGovernanceRetention": {
							"location": "header",
							"locationName": "x-amz-bypass-governance-retention",
							"type": "boolean"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "Retention"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectTagging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"Tagging"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Tagging": {
							"shape": "Sbt",
							"locationName": "Tagging",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "Tagging"
				},
				"output": {
					"type": "structure",
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						}
					}
				}
			},
			"PutPublicAccessBlock": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?publicAccessBlock"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"PublicAccessBlockConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"PublicAccessBlockConfiguration": {
							"shape": "S98",
							"locationName": "PublicAccessBlockConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "PublicAccessBlockConfiguration"
				}
			},
			"RestoreObject": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?restore"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RestoreRequest": {
							"locationName": "RestoreRequest",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Days": {
									"type": "integer"
								},
								"GlacierJobParameters": {
									"type": "structure",
									"required": [
										"Tier"
									],
									"members": {
										"Tier": {}
									}
								},
								"Type": {},
								"Tier": {},
								"Description": {},
								"SelectParameters": {
									"type": "structure",
									"required": [
										"InputSerialization",
										"ExpressionType",
										"Expression",
										"OutputSerialization"
									],
									"members": {
										"InputSerialization": {
											"shape": "Scj"
										},
										"ExpressionType": {},
										"Expression": {},
										"OutputSerialization": {
											"shape": "Scy"
										}
									}
								},
								"OutputLocation": {
									"type": "structure",
									"members": {
										"S3": {
											"type": "structure",
											"required": [
												"BucketName",
												"Prefix"
											],
											"members": {
												"BucketName": {},
												"Prefix": {},
												"Encryption": {
													"type": "structure",
													"required": [
														"EncryptionType"
													],
													"members": {
														"EncryptionType": {},
														"KMSKeyId": {
															"shape": "Sj"
														},
														"KMSContext": {}
													}
												},
												"CannedACL": {},
												"AccessControlList": {
													"shape": "S35"
												},
												"Tagging": {
													"shape": "Sbt"
												},
												"UserMetadata": {
													"type": "list",
													"member": {
														"locationName": "MetadataEntry",
														"type": "structure",
														"members": {
															"Name": {},
															"Value": {}
														}
													}
												},
												"StorageClass": {}
											}
										}
									}
								}
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "RestoreRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"RestoreOutputPath": {
							"location": "header",
							"locationName": "x-amz-restore-output-path"
						}
					}
				},
				"alias": "PostObjectRestore"
			},
			"SelectObjectContent": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?select&select-type=2"
				},
				"input": {
					"locationName": "SelectObjectContentRequest",
					"xmlNamespace": {
						"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
					},
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"Expression",
						"ExpressionType",
						"InputSerialization",
						"OutputSerialization"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"Expression": {},
						"ExpressionType": {},
						"RequestProgress": {
							"type": "structure",
							"members": {
								"Enabled": {
									"type": "boolean"
								}
							}
						},
						"InputSerialization": {
							"shape": "Scj"
						},
						"OutputSerialization": {
							"shape": "Scy"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Payload": {
							"type": "structure",
							"members": {
								"Records": {
									"type": "structure",
									"members": {
										"Payload": {
											"eventpayload": true,
											"type": "blob"
										}
									},
									"event": true
								},
								"Stats": {
									"type": "structure",
									"members": {
										"Details": {
											"eventpayload": true,
											"type": "structure",
											"members": {
												"BytesScanned": {
													"type": "long"
												},
												"BytesProcessed": {
													"type": "long"
												},
												"BytesReturned": {
													"type": "long"
												}
											}
										}
									},
									"event": true
								},
								"Progress": {
									"type": "structure",
									"members": {
										"Details": {
											"eventpayload": true,
											"type": "structure",
											"members": {
												"BytesScanned": {
													"type": "long"
												},
												"BytesProcessed": {
													"type": "long"
												},
												"BytesReturned": {
													"type": "long"
												}
											}
										}
									},
									"event": true
								},
								"Cont": {
									"type": "structure",
									"members": {},
									"event": true
								},
								"End": {
									"type": "structure",
									"members": {},
									"event": true
								}
							},
							"eventstream": true
						}
					},
					"payload": "Payload"
				}
			},
			"UploadPart": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"PartNumber",
						"UploadId"
					],
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "Body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"UploadPartCopy": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CopySource",
						"Key",
						"PartNumber",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CopySource": {
							"location": "header",
							"locationName": "x-amz-copy-source"
						},
						"CopySourceIfMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-match"
						},
						"CopySourceIfModifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-modified-since",
							"type": "timestamp"
						},
						"CopySourceIfNoneMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-none-match"
						},
						"CopySourceIfUnmodifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-unmodified-since",
							"type": "timestamp"
						},
						"CopySourceRange": {
							"location": "header",
							"locationName": "x-amz-copy-source-range"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"CopySourceSSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
						},
						"CopySourceSSECustomerKey": {
							"shape": "S1d",
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
						},
						"CopySourceSSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopySourceVersionId": {
							"location": "header",
							"locationName": "x-amz-copy-source-version-id"
						},
						"CopyPartResult": {
							"type": "structure",
							"members": {
								"ETag": {},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "CopyPartResult"
				}
			}
		},
		"shapes": {
			"Sj": {
				"type": "string",
				"sensitive": true
			},
			"S11": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S19": {
				"type": "blob",
				"sensitive": true
			},
			"S1b": {
				"type": "string",
				"sensitive": true
			},
			"S1d": {
				"type": "blob",
				"sensitive": true
			},
			"S1h": {
				"type": "timestamp",
				"timestampFormat": "iso8601"
			},
			"S32": {
				"type": "structure",
				"members": {
					"DisplayName": {},
					"ID": {}
				}
			},
			"S35": {
				"type": "list",
				"member": {
					"locationName": "Grant",
					"type": "structure",
					"members": {
						"Grantee": {
							"shape": "S37"
						},
						"Permission": {}
					}
				}
			},
			"S37": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"DisplayName": {},
					"EmailAddress": {},
					"ID": {},
					"Type": {
						"locationName": "xsi:type",
						"xmlAttribute": true
					},
					"URI": {}
				},
				"xmlNamespace": {
					"prefix": "xsi",
					"uri": "http://www.w3.org/2001/XMLSchema-instance"
				}
			},
			"S3e": {
				"type": "structure",
				"required": [
					"Id",
					"StorageClassAnalysis"
				],
				"members": {
					"Id": {},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S3h"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3k",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					},
					"StorageClassAnalysis": {
						"type": "structure",
						"members": {
							"DataExport": {
								"type": "structure",
								"required": [
									"OutputSchemaVersion",
									"Destination"
								],
								"members": {
									"OutputSchemaVersion": {},
									"Destination": {
										"type": "structure",
										"required": [
											"S3BucketDestination"
										],
										"members": {
											"S3BucketDestination": {
												"type": "structure",
												"required": [
													"Format",
													"Bucket"
												],
												"members": {
													"Format": {},
													"BucketAccountId": {},
													"Bucket": {},
													"Prefix": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S3h": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S3k": {
				"type": "list",
				"member": {
					"shape": "S3h",
					"locationName": "Tag"
				}
			},
			"S3u": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AllowedMethods",
						"AllowedOrigins"
					],
					"members": {
						"AllowedHeaders": {
							"locationName": "AllowedHeader",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"AllowedMethods": {
							"locationName": "AllowedMethod",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"AllowedOrigins": {
							"locationName": "AllowedOrigin",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"ExposeHeaders": {
							"locationName": "ExposeHeader",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"MaxAgeSeconds": {
							"type": "integer"
						}
					}
				},
				"flattened": true
			},
			"S47": {
				"type": "structure",
				"required": [
					"Rules"
				],
				"members": {
					"Rules": {
						"locationName": "Rule",
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ApplyServerSideEncryptionByDefault": {
									"type": "structure",
									"required": [
										"SSEAlgorithm"
									],
									"members": {
										"SSEAlgorithm": {},
										"KMSMasterKeyID": {
											"shape": "Sj"
										}
									}
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S4d": {
				"type": "structure",
				"required": [
					"Destination",
					"IsEnabled",
					"Id",
					"IncludedObjectVersions",
					"Schedule"
				],
				"members": {
					"Destination": {
						"type": "structure",
						"required": [
							"S3BucketDestination"
						],
						"members": {
							"S3BucketDestination": {
								"type": "structure",
								"required": [
									"Bucket",
									"Format"
								],
								"members": {
									"AccountId": {},
									"Bucket": {},
									"Format": {},
									"Prefix": {},
									"Encryption": {
										"type": "structure",
										"members": {
											"SSES3": {
												"locationName": "SSE-S3",
												"type": "structure",
												"members": {}
											},
											"SSEKMS": {
												"locationName": "SSE-KMS",
												"type": "structure",
												"required": [
													"KeyId"
												],
												"members": {
													"KeyId": {
														"shape": "Sj"
													}
												}
											}
										}
									}
								}
							}
						}
					},
					"IsEnabled": {
						"type": "boolean"
					},
					"Filter": {
						"type": "structure",
						"required": [
							"Prefix"
						],
						"members": {
							"Prefix": {}
						}
					},
					"Id": {},
					"IncludedObjectVersions": {},
					"OptionalFields": {
						"type": "list",
						"member": {
							"locationName": "Field"
						}
					},
					"Schedule": {
						"type": "structure",
						"required": [
							"Frequency"
						],
						"members": {
							"Frequency": {}
						}
					}
				}
			},
			"S4t": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Prefix",
						"Status"
					],
					"members": {
						"Expiration": {
							"shape": "S4v"
						},
						"ID": {},
						"Prefix": {},
						"Status": {},
						"Transition": {
							"shape": "S50"
						},
						"NoncurrentVersionTransition": {
							"shape": "S52"
						},
						"NoncurrentVersionExpiration": {
							"shape": "S53"
						},
						"AbortIncompleteMultipartUpload": {
							"shape": "S54"
						}
					}
				},
				"flattened": true
			},
			"S4v": {
				"type": "structure",
				"members": {
					"Date": {
						"shape": "S4w"
					},
					"Days": {
						"type": "integer"
					},
					"ExpiredObjectDeleteMarker": {
						"type": "boolean"
					}
				}
			},
			"S4w": {
				"type": "timestamp",
				"timestampFormat": "iso8601"
			},
			"S50": {
				"type": "structure",
				"members": {
					"Date": {
						"shape": "S4w"
					},
					"Days": {
						"type": "integer"
					},
					"StorageClass": {}
				}
			},
			"S52": {
				"type": "structure",
				"members": {
					"NoncurrentDays": {
						"type": "integer"
					},
					"StorageClass": {}
				}
			},
			"S53": {
				"type": "structure",
				"members": {
					"NoncurrentDays": {
						"type": "integer"
					}
				}
			},
			"S54": {
				"type": "structure",
				"members": {
					"DaysAfterInitiation": {
						"type": "integer"
					}
				}
			},
			"S58": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Expiration": {
							"shape": "S4v"
						},
						"ID": {},
						"Prefix": {
							"deprecated": true
						},
						"Filter": {
							"type": "structure",
							"members": {
								"Prefix": {},
								"Tag": {
									"shape": "S3h"
								},
								"And": {
									"type": "structure",
									"members": {
										"Prefix": {},
										"Tags": {
											"shape": "S3k",
											"flattened": true,
											"locationName": "Tag"
										}
									}
								}
							}
						},
						"Status": {},
						"Transitions": {
							"locationName": "Transition",
							"type": "list",
							"member": {
								"shape": "S50"
							},
							"flattened": true
						},
						"NoncurrentVersionTransitions": {
							"locationName": "NoncurrentVersionTransition",
							"type": "list",
							"member": {
								"shape": "S52"
							},
							"flattened": true
						},
						"NoncurrentVersionExpiration": {
							"shape": "S53"
						},
						"AbortIncompleteMultipartUpload": {
							"shape": "S54"
						}
					}
				},
				"flattened": true
			},
			"S5i": {
				"type": "structure",
				"required": [
					"TargetBucket",
					"TargetPrefix"
				],
				"members": {
					"TargetBucket": {},
					"TargetGrants": {
						"type": "list",
						"member": {
							"locationName": "Grant",
							"type": "structure",
							"members": {
								"Grantee": {
									"shape": "S37"
								},
								"Permission": {}
							}
						}
					},
					"TargetPrefix": {}
				}
			},
			"S5q": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S3h"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3k",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					}
				}
			},
			"S5t": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"S5u": {
				"type": "structure",
				"members": {
					"TopicConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Events": {
								"shape": "S5x",
								"locationName": "Event"
							},
							"Event": {
								"deprecated": true
							},
							"Topic": {}
						}
					},
					"QueueConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Event": {
								"deprecated": true
							},
							"Events": {
								"shape": "S5x",
								"locationName": "Event"
							},
							"Queue": {}
						}
					},
					"CloudFunctionConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Event": {
								"deprecated": true
							},
							"Events": {
								"shape": "S5x",
								"locationName": "Event"
							},
							"CloudFunction": {},
							"InvocationRole": {}
						}
					}
				}
			},
			"S5x": {
				"type": "list",
				"member": {},
				"flattened": true
			},
			"S65": {
				"type": "structure",
				"members": {
					"TopicConfigurations": {
						"locationName": "TopicConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"TopicArn",
								"Events"
							],
							"members": {
								"Id": {},
								"TopicArn": {
									"locationName": "Topic"
								},
								"Events": {
									"shape": "S5x",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S68"
								}
							}
						},
						"flattened": true
					},
					"QueueConfigurations": {
						"locationName": "QueueConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"QueueArn",
								"Events"
							],
							"members": {
								"Id": {},
								"QueueArn": {
									"locationName": "Queue"
								},
								"Events": {
									"shape": "S5x",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S68"
								}
							}
						},
						"flattened": true
					},
					"LambdaFunctionConfigurations": {
						"locationName": "CloudFunctionConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LambdaFunctionArn",
								"Events"
							],
							"members": {
								"Id": {},
								"LambdaFunctionArn": {
									"locationName": "CloudFunction"
								},
								"Events": {
									"shape": "S5x",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S68"
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S68": {
				"type": "structure",
				"members": {
					"Key": {
						"locationName": "S3Key",
						"type": "structure",
						"members": {
							"FilterRules": {
								"locationName": "FilterRule",
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {},
										"Value": {}
									}
								},
								"flattened": true
							}
						}
					}
				}
			},
			"S6s": {
				"type": "structure",
				"required": [
					"Role",
					"Rules"
				],
				"members": {
					"Role": {},
					"Rules": {
						"locationName": "Rule",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Status",
								"Destination"
							],
							"members": {
								"ID": {},
								"Priority": {
									"type": "integer"
								},
								"Prefix": {
									"deprecated": true
								},
								"Filter": {
									"type": "structure",
									"members": {
										"Prefix": {},
										"Tag": {
											"shape": "S3h"
										},
										"And": {
											"type": "structure",
											"members": {
												"Prefix": {},
												"Tags": {
													"shape": "S3k",
													"flattened": true,
													"locationName": "Tag"
												}
											}
										}
									}
								},
								"Status": {},
								"SourceSelectionCriteria": {
									"type": "structure",
									"members": {
										"SseKmsEncryptedObjects": {
											"type": "structure",
											"required": [
												"Status"
											],
											"members": {
												"Status": {}
											}
										}
									}
								},
								"Destination": {
									"type": "structure",
									"required": [
										"Bucket"
									],
									"members": {
										"Bucket": {},
										"Account": {},
										"StorageClass": {},
										"AccessControlTranslation": {
											"type": "structure",
											"required": [
												"Owner"
											],
											"members": {
												"Owner": {}
											}
										},
										"EncryptionConfiguration": {
											"type": "structure",
											"members": {
												"ReplicaKmsKeyID": {}
											}
										}
									}
								},
								"DeleteMarkerReplication": {
									"type": "structure",
									"members": {
										"Status": {}
									}
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S7l": {
				"type": "structure",
				"required": [
					"HostName"
				],
				"members": {
					"HostName": {},
					"Protocol": {}
				}
			},
			"S7o": {
				"type": "structure",
				"required": [
					"Suffix"
				],
				"members": {
					"Suffix": {}
				}
			},
			"S7q": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {}
				}
			},
			"S7r": {
				"type": "list",
				"member": {
					"locationName": "RoutingRule",
					"type": "structure",
					"required": [
						"Redirect"
					],
					"members": {
						"Condition": {
							"type": "structure",
							"members": {
								"HttpErrorCodeReturnedEquals": {},
								"KeyPrefixEquals": {}
							}
						},
						"Redirect": {
							"type": "structure",
							"members": {
								"HostName": {},
								"HttpRedirectCode": {},
								"Protocol": {},
								"ReplaceKeyPrefixWith": {},
								"ReplaceKeyWith": {}
							}
						}
					}
				}
			},
			"S8q": {
				"type": "structure",
				"members": {
					"Status": {}
				}
			},
			"S8t": {
				"type": "structure",
				"members": {
					"ObjectLockEnabled": {},
					"Rule": {
						"type": "structure",
						"members": {
							"DefaultRetention": {
								"type": "structure",
								"members": {
									"Mode": {},
									"Days": {
										"type": "integer"
									},
									"Years": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"S91": {
				"type": "structure",
				"members": {
					"Mode": {},
					"RetainUntilDate": {
						"shape": "S4w"
					}
				}
			},
			"S98": {
				"type": "structure",
				"members": {
					"BlockPublicAcls": {
						"locationName": "BlockPublicAcls",
						"type": "boolean"
					},
					"IgnorePublicAcls": {
						"locationName": "IgnorePublicAcls",
						"type": "boolean"
					},
					"BlockPublicPolicy": {
						"locationName": "BlockPublicPolicy",
						"type": "boolean"
					},
					"RestrictPublicBuckets": {
						"locationName": "RestrictPublicBuckets",
						"type": "boolean"
					}
				}
			},
			"Sa5": {
				"type": "structure",
				"members": {
					"ID": {},
					"DisplayName": {}
				}
			},
			"Sa6": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Prefix": {}
					}
				},
				"flattened": true
			},
			"Sao": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"LastModified": {
							"type": "timestamp"
						},
						"ETag": {},
						"Size": {
							"type": "integer"
						},
						"StorageClass": {},
						"Owner": {
							"shape": "S32"
						}
					}
				},
				"flattened": true
			},
			"Sb6": {
				"type": "structure",
				"members": {
					"Grants": {
						"shape": "S35",
						"locationName": "AccessControlList"
					},
					"Owner": {
						"shape": "S32"
					}
				}
			},
			"Sbt": {
				"type": "structure",
				"required": [
					"TagSet"
				],
				"members": {
					"TagSet": {
						"shape": "S3k"
					}
				}
			},
			"Scj": {
				"type": "structure",
				"members": {
					"CSV": {
						"type": "structure",
						"members": {
							"FileHeaderInfo": {},
							"Comments": {},
							"QuoteEscapeCharacter": {},
							"RecordDelimiter": {},
							"FieldDelimiter": {},
							"QuoteCharacter": {},
							"AllowQuotedRecordDelimiter": {
								"type": "boolean"
							}
						}
					},
					"CompressionType": {},
					"JSON": {
						"type": "structure",
						"members": {
							"Type": {}
						}
					},
					"Parquet": {
						"type": "structure",
						"members": {}
					}
				}
			},
			"Scy": {
				"type": "structure",
				"members": {
					"CSV": {
						"type": "structure",
						"members": {
							"QuoteFields": {},
							"QuoteEscapeCharacter": {},
							"RecordDelimiter": {},
							"FieldDelimiter": {},
							"QuoteCharacter": {}
						}
					},
					"JSON": {
						"type": "structure",
						"members": {
							"RecordDelimiter": {}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1834 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListBuckets": {
				"result_key": "Buckets"
			},
			"ListMultipartUploads": {
				"input_token": [
					"KeyMarker",
					"UploadIdMarker"
				],
				"limit_key": "MaxUploads",
				"more_results": "IsTruncated",
				"output_token": [
					"NextKeyMarker",
					"NextUploadIdMarker"
				],
				"result_key": [
					"Uploads",
					"CommonPrefixes"
				]
			},
			"ListObjectVersions": {
				"input_token": [
					"KeyMarker",
					"VersionIdMarker"
				],
				"limit_key": "MaxKeys",
				"more_results": "IsTruncated",
				"output_token": [
					"NextKeyMarker",
					"NextVersionIdMarker"
				],
				"result_key": [
					"Versions",
					"DeleteMarkers",
					"CommonPrefixes"
				]
			},
			"ListObjects": {
				"input_token": "Marker",
				"limit_key": "MaxKeys",
				"more_results": "IsTruncated",
				"output_token": "NextMarker || Contents[-1].Key",
				"result_key": [
					"Contents",
					"CommonPrefixes"
				]
			},
			"ListObjectsV2": {
				"input_token": "ContinuationToken",
				"limit_key": "MaxKeys",
				"output_token": "NextContinuationToken",
				"result_key": [
					"Contents",
					"CommonPrefixes"
				]
			},
			"ListParts": {
				"input_token": "PartNumberMarker",
				"limit_key": "MaxParts",
				"more_results": "IsTruncated",
				"output_token": "NextPartNumberMarker",
				"result_key": "Parts"
			}
		}
	};

/***/ },
/* 1835 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"BucketExists": {
				"delay": 5,
				"operation": "HeadBucket",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 301,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 403,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 404,
						"matcher": "status",
						"state": "retry"
					}
				]
			},
			"BucketNotExists": {
				"delay": 5,
				"operation": "HeadBucket",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 404,
						"matcher": "status",
						"state": "success"
					}
				]
			},
			"ObjectExists": {
				"delay": 5,
				"operation": "HeadObject",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 404,
						"matcher": "status",
						"state": "retry"
					}
				]
			},
			"ObjectNotExists": {
				"delay": 5,
				"operation": "HeadObject",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 404,
						"matcher": "status",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 1836 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-10-17",
			"endpointPrefix": "secretsmanager",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Secrets Manager",
			"serviceId": "Secrets Manager",
			"signatureVersion": "v4",
			"signingName": "secretsmanager",
			"targetPrefix": "secretsmanager",
			"uid": "secretsmanager-2017-10-17"
		},
		"operations": {
			"CancelRotateSecret": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"VersionId": {}
					}
				}
			},
			"CreateSecret": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"Description": {},
						"KmsKeyId": {},
						"SecretBinary": {
							"shape": "Sc"
						},
						"SecretString": {
							"shape": "Sd"
						},
						"Tags": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"VersionId": {}
					}
				}
			},
			"DeleteResourcePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {}
					}
				}
			},
			"DeleteSecret": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {},
						"RecoveryWindowInDays": {
							"type": "long"
						},
						"ForceDeleteWithoutRecovery": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"DeletionDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeSecret": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"Description": {},
						"KmsKeyId": {},
						"RotationEnabled": {
							"type": "boolean"
						},
						"RotationLambdaARN": {},
						"RotationRules": {
							"shape": "Su"
						},
						"LastRotatedDate": {
							"type": "timestamp"
						},
						"LastChangedDate": {
							"type": "timestamp"
						},
						"LastAccessedDate": {
							"type": "timestamp"
						},
						"DeletedDate": {
							"type": "timestamp"
						},
						"Tags": {
							"shape": "Se"
						},
						"VersionIdsToStages": {
							"shape": "S10"
						},
						"OwningService": {}
					}
				}
			},
			"GetRandomPassword": {
				"input": {
					"type": "structure",
					"members": {
						"PasswordLength": {
							"type": "long"
						},
						"ExcludeCharacters": {},
						"ExcludeNumbers": {
							"type": "boolean"
						},
						"ExcludePunctuation": {
							"type": "boolean"
						},
						"ExcludeUppercase": {
							"type": "boolean"
						},
						"ExcludeLowercase": {
							"type": "boolean"
						},
						"IncludeSpace": {
							"type": "boolean"
						},
						"RequireEachIncludedType": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RandomPassword": {
							"type": "string",
							"sensitive": true
						}
					}
				}
			},
			"GetResourcePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"ResourcePolicy": {}
					}
				}
			},
			"GetSecretValue": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {},
						"VersionId": {},
						"VersionStage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"VersionId": {},
						"SecretBinary": {
							"shape": "Sc"
						},
						"SecretString": {
							"shape": "Sd"
						},
						"VersionStages": {
							"shape": "S11"
						},
						"CreatedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"ListSecretVersionIds": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"IncludeDeprecated": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Versions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VersionId": {},
									"VersionStages": {
										"shape": "S11"
									},
									"LastAccessedDate": {
										"type": "timestamp"
									},
									"CreatedDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {},
						"ARN": {},
						"Name": {}
					}
				}
			},
			"ListSecrets": {
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecretList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ARN": {},
									"Name": {},
									"Description": {},
									"KmsKeyId": {},
									"RotationEnabled": {
										"type": "boolean"
									},
									"RotationLambdaARN": {},
									"RotationRules": {
										"shape": "Su"
									},
									"LastRotatedDate": {
										"type": "timestamp"
									},
									"LastChangedDate": {
										"type": "timestamp"
									},
									"LastAccessedDate": {
										"type": "timestamp"
									},
									"DeletedDate": {
										"type": "timestamp"
									},
									"Tags": {
										"shape": "Se"
									},
									"SecretVersionsToStages": {
										"shape": "S10"
									},
									"OwningService": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutResourcePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId",
						"ResourcePolicy"
					],
					"members": {
						"SecretId": {},
						"ResourcePolicy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {}
					}
				}
			},
			"PutSecretValue": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"SecretBinary": {
							"shape": "Sc"
						},
						"SecretString": {
							"shape": "Sd"
						},
						"VersionStages": {
							"shape": "S11"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"VersionId": {},
						"VersionStages": {
							"shape": "S11"
						}
					}
				}
			},
			"RestoreSecret": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {}
					}
				}
			},
			"RotateSecret": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"RotationLambdaARN": {},
						"RotationRules": {
							"shape": "Su"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"VersionId": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId",
						"Tags"
					],
					"members": {
						"SecretId": {},
						"Tags": {
							"shape": "Se"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId",
						"TagKeys"
					],
					"members": {
						"SecretId": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"UpdateSecret": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId"
					],
					"members": {
						"SecretId": {},
						"ClientRequestToken": {
							"idempotencyToken": true
						},
						"Description": {},
						"KmsKeyId": {},
						"SecretBinary": {
							"shape": "Sc"
						},
						"SecretString": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {},
						"VersionId": {}
					}
				}
			},
			"UpdateSecretVersionStage": {
				"input": {
					"type": "structure",
					"required": [
						"SecretId",
						"VersionStage"
					],
					"members": {
						"SecretId": {},
						"VersionStage": {},
						"RemoveFromVersionId": {},
						"MoveToVersionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ARN": {},
						"Name": {}
					}
				}
			}
		},
		"shapes": {
			"Sc": {
				"type": "blob",
				"sensitive": true
			},
			"Sd": {
				"type": "string",
				"sensitive": true
			},
			"Se": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"AutomaticallyAfterDays": {
						"type": "long"
					}
				}
			},
			"S10": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S11"
				}
			},
			"S11": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1837 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListSecretVersionIds": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			},
			"ListSecrets": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 1838 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-12-10",
			"endpointPrefix": "servicecatalog",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Service Catalog",
			"serviceId": "Service Catalog",
			"signatureVersion": "v4",
			"targetPrefix": "AWS242ServiceCatalogService",
			"uid": "servicecatalog-2015-12-10"
		},
		"operations": {
			"AcceptPortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PortfolioShareType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateBudgetWithResource": {
				"input": {
					"type": "structure",
					"required": [
						"BudgetName",
						"ResourceId"
					],
					"members": {
						"BudgetName": {},
						"ResourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociatePrincipalWithPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"PrincipalARN",
						"PrincipalType"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PrincipalARN": {},
						"PrincipalType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateProductWithPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PortfolioId": {},
						"SourcePortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateServiceActionWithProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId",
						"ServiceActionId"
					],
					"members": {
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"ServiceActionId": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateTagOptionWithResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"TagOptionId"
					],
					"members": {
						"ResourceId": {},
						"TagOptionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"BatchAssociateServiceActionWithProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceActionAssociations"
					],
					"members": {
						"ServiceActionAssociations": {
							"shape": "Sm"
						},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedServiceActionAssociations": {
							"shape": "Sp"
						}
					}
				}
			},
			"BatchDisassociateServiceActionFromProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceActionAssociations"
					],
					"members": {
						"ServiceActionAssociations": {
							"shape": "Sm"
						},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedServiceActionAssociations": {
							"shape": "Sp"
						}
					}
				}
			},
			"CopyProduct": {
				"input": {
					"type": "structure",
					"required": [
						"SourceProductArn",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"SourceProductArn": {},
						"TargetProductId": {},
						"TargetProductName": {},
						"SourceProvisioningArtifactIdentifiers": {
							"type": "list",
							"member": {
								"type": "map",
								"key": {},
								"value": {}
							}
						},
						"CopyOptions": {
							"type": "list",
							"member": {}
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopyProductToken": {}
					}
				}
			},
			"CreateConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"ProductId",
						"Parameters",
						"Type",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"ProductId": {},
						"Parameters": {},
						"Type": {},
						"Description": {},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetail": {
							"shape": "S1b"
						},
						"ConstraintParameters": {},
						"Status": {}
					}
				}
			},
			"CreatePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"DisplayName",
						"ProviderName",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"DisplayName": {},
						"Description": {},
						"ProviderName": {},
						"Tags": {
							"shape": "S1i"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetail": {
							"shape": "S1n"
						},
						"Tags": {
							"shape": "S1q"
						}
					}
				}
			},
			"CreatePortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"AccountId": {},
						"OrganizationNode": {
							"shape": "S1s"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioShareToken": {}
					}
				}
			},
			"CreateProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Owner",
						"ProductType",
						"ProvisioningArtifactParameters",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"Name": {},
						"Owner": {},
						"Description": {},
						"Distributor": {},
						"SupportDescription": {},
						"SupportEmail": {},
						"SupportUrl": {},
						"ProductType": {},
						"Tags": {
							"shape": "S1i"
						},
						"ProvisioningArtifactParameters": {
							"shape": "S23"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetail": {
							"shape": "S2c"
						},
						"ProvisioningArtifactDetail": {
							"shape": "S2h"
						},
						"Tags": {
							"shape": "S1q"
						}
					}
				}
			},
			"CreateProvisionedProductPlan": {
				"input": {
					"type": "structure",
					"required": [
						"PlanName",
						"PlanType",
						"ProductId",
						"ProvisionedProductName",
						"ProvisioningArtifactId",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"PlanName": {},
						"PlanType": {},
						"NotificationArns": {
							"shape": "S2n"
						},
						"PathId": {},
						"ProductId": {},
						"ProvisionedProductName": {},
						"ProvisioningArtifactId": {},
						"ProvisioningParameters": {
							"shape": "S2q"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						},
						"Tags": {
							"shape": "S1q"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlanName": {},
						"PlanId": {},
						"ProvisionProductId": {},
						"ProvisionedProductName": {},
						"ProvisioningArtifactId": {}
					}
				}
			},
			"CreateProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"Parameters",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"Parameters": {
							"shape": "S23"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetail": {
							"shape": "S2h"
						},
						"Info": {
							"shape": "S26"
						},
						"Status": {}
					}
				}
			},
			"CreateServiceAction": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"DefinitionType",
						"Definition",
						"IdempotencyToken"
					],
					"members": {
						"Name": {},
						"DefinitionType": {},
						"Definition": {
							"shape": "S31"
						},
						"Description": {},
						"AcceptLanguage": {},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceActionDetail": {
							"shape": "S36"
						}
					}
				}
			},
			"CreateTagOption": {
				"input": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TagOptionDetail": {
							"shape": "S3c"
						}
					}
				}
			},
			"DeleteConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"AccountId": {},
						"OrganizationNode": {
							"shape": "S1s"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioShareToken": {}
					}
				}
			},
			"DeleteProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteProvisionedProductPlan": {
				"input": {
					"type": "structure",
					"required": [
						"PlanId"
					],
					"members": {
						"AcceptLanguage": {},
						"PlanId": {},
						"IgnoreErrors": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteServiceAction": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTagOption": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetail": {
							"shape": "S1b"
						},
						"ConstraintParameters": {},
						"Status": {}
					}
				}
			},
			"DescribeCopyProductStatus": {
				"input": {
					"type": "structure",
					"required": [
						"CopyProductToken"
					],
					"members": {
						"AcceptLanguage": {},
						"CopyProductToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopyProductStatus": {},
						"TargetProductId": {},
						"StatusDetail": {}
					}
				}
			},
			"DescribePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetail": {
							"shape": "S1n"
						},
						"Tags": {
							"shape": "S1q"
						},
						"TagOptions": {
							"shape": "S43"
						},
						"Budgets": {
							"shape": "S44"
						}
					}
				}
			},
			"DescribePortfolioShareStatus": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioShareToken"
					],
					"members": {
						"PortfolioShareToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioShareToken": {},
						"PortfolioId": {},
						"OrganizationNodeValue": {},
						"Status": {},
						"ShareDetails": {
							"type": "structure",
							"members": {
								"SuccessfulShares": {
									"type": "list",
									"member": {}
								},
								"ShareErrors": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Accounts": {
												"type": "list",
												"member": {}
											},
											"Message": {},
											"Error": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewSummary": {
							"shape": "S2d"
						},
						"ProvisioningArtifacts": {
							"shape": "S4i"
						},
						"Budgets": {
							"shape": "S44"
						}
					}
				}
			},
			"DescribeProductAsAdmin": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetail": {
							"shape": "S2c"
						},
						"ProvisioningArtifactSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Description": {},
									"CreatedTime": {
										"type": "timestamp"
									},
									"ProvisioningArtifactMetadata": {
										"shape": "S26"
									}
								}
							}
						},
						"Tags": {
							"shape": "S1q"
						},
						"TagOptions": {
							"shape": "S43"
						},
						"Budgets": {
							"shape": "S44"
						}
					}
				}
			},
			"DescribeProductView": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewSummary": {
							"shape": "S2d"
						},
						"ProvisioningArtifacts": {
							"shape": "S4i"
						}
					}
				}
			},
			"DescribeProvisionedProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisionedProductDetail": {
							"shape": "S4t"
						},
						"CloudWatchDashboards": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {}
								}
							}
						}
					}
				}
			},
			"DescribeProvisionedProductPlan": {
				"input": {
					"type": "structure",
					"required": [
						"PlanId"
					],
					"members": {
						"AcceptLanguage": {},
						"PlanId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisionedProductPlanDetails": {
							"type": "structure",
							"members": {
								"CreatedTime": {
									"type": "timestamp"
								},
								"PathId": {},
								"ProductId": {},
								"PlanName": {},
								"PlanId": {},
								"ProvisionProductId": {},
								"ProvisionProductName": {},
								"PlanType": {},
								"ProvisioningArtifactId": {},
								"Status": {},
								"UpdatedTime": {
									"type": "timestamp"
								},
								"NotificationArns": {
									"shape": "S2n"
								},
								"ProvisioningParameters": {
									"shape": "S2q"
								},
								"Tags": {
									"shape": "S1q"
								},
								"StatusMessage": {}
							}
						},
						"ResourceChanges": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Action": {},
									"LogicalResourceId": {},
									"PhysicalResourceId": {},
									"ResourceType": {},
									"Replacement": {},
									"Scope": {
										"type": "list",
										"member": {}
									},
									"Details": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Target": {
													"type": "structure",
													"members": {
														"Attribute": {},
														"Name": {},
														"RequiresRecreation": {}
													}
												},
												"Evaluation": {},
												"CausingEntity": {}
											}
										}
									}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"DescribeProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProvisioningArtifactId",
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProvisioningArtifactId": {},
						"ProductId": {},
						"Verbose": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetail": {
							"shape": "S2h"
						},
						"Info": {
							"shape": "S26"
						},
						"Status": {}
					}
				}
			},
			"DescribeProvisioningParameters": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"PathId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactParameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ParameterKey": {},
									"DefaultValue": {},
									"ParameterType": {},
									"IsNoEcho": {
										"type": "boolean"
									},
									"Description": {},
									"ParameterConstraints": {
										"type": "structure",
										"members": {
											"AllowedValues": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						},
						"ConstraintSummaries": {
							"shape": "S65"
						},
						"UsageInstructions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"Value": {}
								}
							}
						},
						"TagOptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"ProvisioningArtifactPreferences": {
							"type": "structure",
							"members": {
								"StackSetAccounts": {
									"shape": "S6f"
								},
								"StackSetRegions": {
									"shape": "S6g"
								}
							}
						}
					}
				}
			},
			"DescribeRecord": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S6k"
						},
						"RecordOutputs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"OutputKey": {},
									"OutputValue": {},
									"Description": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"DescribeServiceAction": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceActionDetail": {
							"shape": "S36"
						}
					}
				}
			},
			"DescribeServiceActionExecutionParameters": {
				"input": {
					"type": "structure",
					"required": [
						"ProvisionedProductId",
						"ServiceActionId"
					],
					"members": {
						"ProvisionedProductId": {},
						"ServiceActionId": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceActionParameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Type": {},
									"DefaultValues": {
										"shape": "S77"
									}
								}
							}
						}
					}
				}
			},
			"DescribeTagOption": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TagOptionDetail": {
							"shape": "S3c"
						}
					}
				}
			},
			"DisableAWSOrganizationsAccess": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociateBudgetFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"BudgetName",
						"ResourceId"
					],
					"members": {
						"BudgetName": {},
						"ResourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociatePrincipalFromPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"PrincipalARN"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PrincipalARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociateProductFromPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociateServiceActionFromProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId",
						"ServiceActionId"
					],
					"members": {
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"ServiceActionId": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociateTagOptionFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"TagOptionId"
					],
					"members": {
						"ResourceId": {},
						"TagOptionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"EnableAWSOrganizationsAccess": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ExecuteProvisionedProductPlan": {
				"input": {
					"type": "structure",
					"required": [
						"PlanId",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"PlanId": {},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S6k"
						}
					}
				}
			},
			"ExecuteProvisionedProductServiceAction": {
				"input": {
					"type": "structure",
					"required": [
						"ProvisionedProductId",
						"ServiceActionId",
						"ExecuteToken"
					],
					"members": {
						"ProvisionedProductId": {},
						"ServiceActionId": {},
						"ExecuteToken": {
							"idempotencyToken": true
						},
						"AcceptLanguage": {},
						"Parameters": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "S77"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S6k"
						}
					}
				}
			},
			"GetAWSOrganizationsAccessStatus": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccessStatus": {}
					}
				}
			},
			"ListAcceptedPortfolioShares": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						},
						"PortfolioShareType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetails": {
							"shape": "S7z"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListBudgetsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"AcceptLanguage": {},
						"ResourceId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Budgets": {
							"shape": "S44"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListConstraintsForPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"ProductId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetails": {
							"type": "list",
							"member": {
								"shape": "S1b"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListLaunchPaths": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchPathSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"ConstraintSummaries": {
										"shape": "S65"
									},
									"Tags": {
										"shape": "S1q"
									},
									"Name": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListOrganizationPortfolioAccess": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"OrganizationNodeType"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"OrganizationNodeType": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OrganizationNodes": {
							"type": "list",
							"member": {
								"shape": "S1s"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPortfolioAccess": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountIds": {
							"type": "list",
							"member": {}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPortfolios": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetails": {
							"shape": "S7z"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPortfoliosForProduct": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetails": {
							"shape": "S7z"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPrincipalsForPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Principals": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PrincipalARN": {},
									"PrincipalType": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListProvisionedProductPlans": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"ProvisionProductId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {},
						"AccessLevelFilter": {
							"shape": "S8p"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisionedProductPlans": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PlanName": {},
									"PlanId": {},
									"ProvisionProductId": {},
									"ProvisionProductName": {},
									"PlanType": {},
									"ProvisioningArtifactId": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListProvisioningArtifacts": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetails": {
							"type": "list",
							"member": {
								"shape": "S2h"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListProvisioningArtifactsForServiceAction": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceActionId"
					],
					"members": {
						"ServiceActionId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactViews": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ProductViewSummary": {
										"shape": "S2d"
									},
									"ProvisioningArtifact": {
										"shape": "S4j"
									}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListRecordHistory": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"AccessLevelFilter": {
							"shape": "S8p"
						},
						"SearchFilter": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetails": {
							"type": "list",
							"member": {
								"shape": "S6k"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListResourcesForTagOption": {
				"input": {
					"type": "structure",
					"required": [
						"TagOptionId"
					],
					"members": {
						"TagOptionId": {},
						"ResourceType": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"ARN": {},
									"Name": {},
									"Description": {},
									"CreatedTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"PageToken": {}
					}
				}
			},
			"ListServiceActions": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceActionSummaries": {
							"shape": "S9k"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListServiceActionsForProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceActionSummaries": {
							"shape": "S9k"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListStackInstancesForProvisionedProduct": {
				"input": {
					"type": "structure",
					"required": [
						"ProvisionedProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProvisionedProductId": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StackInstances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Account": {},
									"Region": {},
									"StackInstanceStatus": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListTagOptions": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {},
								"Active": {
									"type": "boolean"
								}
							}
						},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TagOptionDetails": {
							"shape": "S43"
						},
						"PageToken": {}
					}
				}
			},
			"ProvisionProduct": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId",
						"ProvisionedProductName",
						"ProvisionToken"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"PathId": {},
						"ProvisionedProductName": {},
						"ProvisioningParameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"ProvisioningPreferences": {
							"type": "structure",
							"members": {
								"StackSetAccounts": {
									"shape": "S6f"
								},
								"StackSetRegions": {
									"shape": "S6g"
								},
								"StackSetFailureToleranceCount": {
									"type": "integer"
								},
								"StackSetFailureTolerancePercentage": {
									"type": "integer"
								},
								"StackSetMaxConcurrencyCount": {
									"type": "integer"
								},
								"StackSetMaxConcurrencyPercentage": {
									"type": "integer"
								}
							}
						},
						"Tags": {
							"shape": "S1q"
						},
						"NotificationArns": {
							"shape": "S2n"
						},
						"ProvisionToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S6k"
						}
					}
				}
			},
			"RejectPortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PortfolioShareType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ScanProvisionedProducts": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"AccessLevelFilter": {
							"shape": "S8p"
						},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisionedProducts": {
							"type": "list",
							"member": {
								"shape": "S4t"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"SearchProducts": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"Filters": {
							"shape": "Saa"
						},
						"PageSize": {
							"type": "integer"
						},
						"SortBy": {},
						"SortOrder": {},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewSummaries": {
							"type": "list",
							"member": {
								"shape": "S2d"
							}
						},
						"ProductViewAggregations": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Value": {},
										"ApproximateCount": {
											"type": "integer"
										}
									}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"SearchProductsAsAdmin": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"Filters": {
							"shape": "Saa"
						},
						"SortBy": {},
						"SortOrder": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						},
						"ProductSource": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetails": {
							"type": "list",
							"member": {
								"shape": "S2c"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"SearchProvisionedProducts": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"AccessLevelFilter": {
							"shape": "S8p"
						},
						"Filters": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {}
							}
						},
						"SortBy": {},
						"SortOrder": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisionedProducts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Arn": {},
									"Type": {},
									"Id": {},
									"Status": {},
									"StatusMessage": {},
									"CreatedTime": {
										"type": "timestamp"
									},
									"IdempotencyToken": {},
									"LastRecordId": {},
									"Tags": {
										"shape": "S1q"
									},
									"PhysicalId": {},
									"ProductId": {},
									"ProvisioningArtifactId": {},
									"UserArn": {},
									"UserArnSession": {}
								}
							}
						},
						"TotalResultsCount": {
							"type": "integer"
						},
						"NextPageToken": {}
					}
				}
			},
			"TerminateProvisionedProduct": {
				"input": {
					"type": "structure",
					"required": [
						"TerminateToken"
					],
					"members": {
						"ProvisionedProductName": {},
						"ProvisionedProductId": {},
						"TerminateToken": {
							"idempotencyToken": true
						},
						"IgnoreErrors": {
							"type": "boolean"
						},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S6k"
						}
					}
				}
			},
			"UpdateConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"Description": {},
						"Parameters": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetail": {
							"shape": "S1b"
						},
						"ConstraintParameters": {},
						"Status": {}
					}
				}
			},
			"UpdatePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"DisplayName": {},
						"Description": {},
						"ProviderName": {},
						"AddTags": {
							"shape": "S1i"
						},
						"RemoveTags": {
							"shape": "Sbb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetail": {
							"shape": "S1n"
						},
						"Tags": {
							"shape": "S1q"
						}
					}
				}
			},
			"UpdateProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"Name": {},
						"Owner": {},
						"Description": {},
						"Distributor": {},
						"SupportDescription": {},
						"SupportEmail": {},
						"SupportUrl": {},
						"AddTags": {
							"shape": "S1i"
						},
						"RemoveTags": {
							"shape": "Sbb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetail": {
							"shape": "S2c"
						},
						"Tags": {
							"shape": "S1q"
						}
					}
				}
			},
			"UpdateProvisionedProduct": {
				"input": {
					"type": "structure",
					"required": [
						"UpdateToken"
					],
					"members": {
						"AcceptLanguage": {},
						"ProvisionedProductName": {},
						"ProvisionedProductId": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"PathId": {},
						"ProvisioningParameters": {
							"shape": "S2q"
						},
						"ProvisioningPreferences": {
							"type": "structure",
							"members": {
								"StackSetAccounts": {
									"shape": "S6f"
								},
								"StackSetRegions": {
									"shape": "S6g"
								},
								"StackSetFailureToleranceCount": {
									"type": "integer"
								},
								"StackSetFailureTolerancePercentage": {
									"type": "integer"
								},
								"StackSetMaxConcurrencyCount": {
									"type": "integer"
								},
								"StackSetMaxConcurrencyPercentage": {
									"type": "integer"
								},
								"StackSetOperationType": {}
							}
						},
						"Tags": {
							"shape": "S1q"
						},
						"UpdateToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S6k"
						}
					}
				}
			},
			"UpdateProvisionedProductProperties": {
				"input": {
					"type": "structure",
					"required": [
						"ProvisionedProductId",
						"ProvisionedProductProperties",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"ProvisionedProductId": {},
						"ProvisionedProductProperties": {
							"shape": "Sbk"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisionedProductId": {},
						"ProvisionedProductProperties": {
							"shape": "Sbk"
						},
						"RecordId": {},
						"Status": {}
					}
				}
			},
			"UpdateProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"Name": {},
						"Description": {},
						"Active": {
							"type": "boolean"
						},
						"Guidance": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetail": {
							"shape": "S2h"
						},
						"Info": {
							"shape": "S26"
						},
						"Status": {}
					}
				}
			},
			"UpdateServiceAction": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {},
						"Name": {},
						"Definition": {
							"shape": "S31"
						},
						"Description": {},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceActionDetail": {
							"shape": "S36"
						}
					}
				}
			},
			"UpdateTagOption": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {},
						"Value": {},
						"Active": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TagOptionDetail": {
							"shape": "S3c"
						}
					}
				}
			}
		},
		"shapes": {
			"Sm": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ServiceActionId",
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"ServiceActionId": {},
						"ProductId": {},
						"ProvisioningArtifactId": {}
					}
				}
			},
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ServiceActionId": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"ErrorCode": {},
						"ErrorMessage": {}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"ConstraintId": {},
					"Type": {},
					"Description": {},
					"Owner": {}
				}
			},
			"S1i": {
				"type": "list",
				"member": {
					"shape": "S1j"
				}
			},
			"S1j": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S1n": {
				"type": "structure",
				"members": {
					"Id": {},
					"ARN": {},
					"DisplayName": {},
					"Description": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"ProviderName": {}
				}
			},
			"S1q": {
				"type": "list",
				"member": {
					"shape": "S1j"
				}
			},
			"S1s": {
				"type": "structure",
				"members": {
					"Type": {},
					"Value": {}
				}
			},
			"S23": {
				"type": "structure",
				"required": [
					"Info"
				],
				"members": {
					"Name": {},
					"Description": {},
					"Info": {
						"shape": "S26"
					},
					"Type": {},
					"DisableTemplateValidation": {
						"type": "boolean"
					}
				}
			},
			"S26": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"ProductViewSummary": {
						"shape": "S2d"
					},
					"Status": {},
					"ProductARN": {},
					"CreatedTime": {
						"type": "timestamp"
					}
				}
			},
			"S2d": {
				"type": "structure",
				"members": {
					"Id": {},
					"ProductId": {},
					"Name": {},
					"Owner": {},
					"ShortDescription": {},
					"Type": {},
					"Distributor": {},
					"HasDefaultPath": {
						"type": "boolean"
					},
					"SupportEmail": {},
					"SupportDescription": {},
					"SupportUrl": {}
				}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Description": {},
					"Type": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"Active": {
						"type": "boolean"
					},
					"Guidance": {}
				}
			},
			"S2n": {
				"type": "list",
				"member": {}
			},
			"S2q": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {},
						"UsePreviousValue": {
							"type": "boolean"
						}
					}
				}
			},
			"S31": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S36": {
				"type": "structure",
				"members": {
					"ServiceActionSummary": {
						"shape": "S37"
					},
					"Definition": {
						"shape": "S31"
					}
				}
			},
			"S37": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Description": {},
					"DefinitionType": {}
				}
			},
			"S3c": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {},
					"Active": {
						"type": "boolean"
					},
					"Id": {}
				}
			},
			"S43": {
				"type": "list",
				"member": {
					"shape": "S3c"
				}
			},
			"S44": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"BudgetName": {}
					}
				}
			},
			"S4i": {
				"type": "list",
				"member": {
					"shape": "S4j"
				}
			},
			"S4j": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Description": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"Guidance": {}
				}
			},
			"S4t": {
				"type": "structure",
				"members": {
					"Name": {},
					"Arn": {},
					"Type": {},
					"Id": {},
					"Status": {},
					"StatusMessage": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"IdempotencyToken": {},
					"LastRecordId": {},
					"ProductId": {},
					"ProvisioningArtifactId": {}
				}
			},
			"S65": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Type": {},
						"Description": {}
					}
				}
			},
			"S6f": {
				"type": "list",
				"member": {}
			},
			"S6g": {
				"type": "list",
				"member": {}
			},
			"S6k": {
				"type": "structure",
				"members": {
					"RecordId": {},
					"ProvisionedProductName": {},
					"Status": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"UpdatedTime": {
						"type": "timestamp"
					},
					"ProvisionedProductType": {},
					"RecordType": {},
					"ProvisionedProductId": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {},
					"RecordErrors": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Code": {},
								"Description": {}
							}
						}
					},
					"RecordTags": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S77": {
				"type": "list",
				"member": {}
			},
			"S7z": {
				"type": "list",
				"member": {
					"shape": "S1n"
				}
			},
			"S8p": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S9k": {
				"type": "list",
				"member": {
					"shape": "S37"
				}
			},
			"Saa": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {}
				}
			},
			"Sbb": {
				"type": "list",
				"member": {}
			},
			"Sbk": {
				"type": "map",
				"key": {},
				"value": {}
			}
		}
	};

/***/ },
/* 1839 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListAcceptedPortfolioShares": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListBudgetsForResource": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListConstraintsForPortfolio": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListLaunchPaths": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListOrganizationPortfolioAccess": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListPortfolios": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListPortfoliosForProduct": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListPrincipalsForPortfolio": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListProvisioningArtifactsForServiceAction": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListResourcesForTagOption": {
				"input_token": "PageToken",
				"output_token": "PageToken",
				"limit_key": "PageSize"
			},
			"ListServiceActions": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListServiceActionsForProvisioningArtifact": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"ListTagOptions": {
				"input_token": "PageToken",
				"output_token": "PageToken",
				"limit_key": "PageSize"
			},
			"SearchProducts": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"SearchProductsAsAdmin": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			},
			"SearchProvisionedProducts": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"limit_key": "PageSize"
			}
		}
	};

/***/ },
/* 1840 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-03-31",
			"endpointPrefix": "sns",
			"protocol": "query",
			"serviceAbbreviation": "Amazon SNS",
			"serviceFullName": "Amazon Simple Notification Service",
			"serviceId": "SNS",
			"signatureVersion": "v4",
			"uid": "sns-2010-03-31",
			"xmlNamespace": "http://sns.amazonaws.com/doc/2010-03-31/"
		},
		"operations": {
			"AddPermission": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Label",
						"AWSAccountId",
						"ActionName"
					],
					"members": {
						"TopicArn": {},
						"Label": {},
						"AWSAccountId": {
							"type": "list",
							"member": {}
						},
						"ActionName": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"CheckIfPhoneNumberIsOptedOut": {
				"input": {
					"type": "structure",
					"required": [
						"phoneNumber"
					],
					"members": {
						"phoneNumber": {}
					}
				},
				"output": {
					"resultWrapper": "CheckIfPhoneNumberIsOptedOutResult",
					"type": "structure",
					"members": {
						"isOptedOut": {
							"type": "boolean"
						}
					}
				}
			},
			"ConfirmSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Token"
					],
					"members": {
						"TopicArn": {},
						"Token": {},
						"AuthenticateOnUnsubscribe": {}
					}
				},
				"output": {
					"resultWrapper": "ConfirmSubscriptionResult",
					"type": "structure",
					"members": {
						"SubscriptionArn": {}
					}
				}
			},
			"CreatePlatformApplication": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Platform",
						"Attributes"
					],
					"members": {
						"Name": {},
						"Platform": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				},
				"output": {
					"resultWrapper": "CreatePlatformApplicationResult",
					"type": "structure",
					"members": {
						"PlatformApplicationArn": {}
					}
				}
			},
			"CreatePlatformEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn",
						"Token"
					],
					"members": {
						"PlatformApplicationArn": {},
						"Token": {},
						"CustomUserData": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				},
				"output": {
					"resultWrapper": "CreatePlatformEndpointResult",
					"type": "structure",
					"members": {
						"EndpointArn": {}
					}
				}
			},
			"CreateTopic": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Attributes": {
							"shape": "Sp"
						},
						"Tags": {
							"shape": "Ss"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateTopicResult",
					"type": "structure",
					"members": {
						"TopicArn": {}
					}
				}
			},
			"DeleteEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"EndpointArn"
					],
					"members": {
						"EndpointArn": {}
					}
				}
			},
			"DeletePlatformApplication": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn"
					],
					"members": {
						"PlatformApplicationArn": {}
					}
				}
			},
			"DeleteTopic": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn"
					],
					"members": {
						"TopicArn": {}
					}
				}
			},
			"GetEndpointAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"EndpointArn"
					],
					"members": {
						"EndpointArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetEndpointAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"GetPlatformApplicationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn"
					],
					"members": {
						"PlatformApplicationArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetPlatformApplicationAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"GetSMSAttributes": {
				"input": {
					"type": "structure",
					"members": {
						"attributes": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "GetSMSAttributesResult",
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"GetSubscriptionAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionArn"
					],
					"members": {
						"SubscriptionArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetSubscriptionAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S19"
						}
					}
				}
			},
			"GetTopicAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn"
					],
					"members": {
						"TopicArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetTopicAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sp"
						}
					}
				}
			},
			"ListEndpointsByPlatformApplication": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn"
					],
					"members": {
						"PlatformApplicationArn": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListEndpointsByPlatformApplicationResult",
					"type": "structure",
					"members": {
						"Endpoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EndpointArn": {},
									"Attributes": {
										"shape": "Sj"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListPhoneNumbersOptedOut": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListPhoneNumbersOptedOutResult",
					"type": "structure",
					"members": {
						"phoneNumbers": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListPlatformApplications": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListPlatformApplicationsResult",
					"type": "structure",
					"members": {
						"PlatformApplications": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PlatformApplicationArn": {},
									"Attributes": {
										"shape": "Sj"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListSubscriptionsResult",
					"type": "structure",
					"members": {
						"Subscriptions": {
							"shape": "S1r"
						},
						"NextToken": {}
					}
				}
			},
			"ListSubscriptionsByTopic": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn"
					],
					"members": {
						"TopicArn": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListSubscriptionsByTopicResult",
					"type": "structure",
					"members": {
						"Subscriptions": {
							"shape": "S1r"
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "Ss"
						}
					}
				}
			},
			"ListTopics": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListTopicsResult",
					"type": "structure",
					"members": {
						"Topics": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TopicArn": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"OptInPhoneNumber": {
				"input": {
					"type": "structure",
					"required": [
						"phoneNumber"
					],
					"members": {
						"phoneNumber": {}
					}
				},
				"output": {
					"resultWrapper": "OptInPhoneNumberResult",
					"type": "structure",
					"members": {}
				}
			},
			"Publish": {
				"input": {
					"type": "structure",
					"required": [
						"Message"
					],
					"members": {
						"TopicArn": {},
						"TargetArn": {},
						"PhoneNumber": {},
						"Message": {},
						"Subject": {},
						"MessageStructure": {},
						"MessageAttributes": {
							"type": "map",
							"key": {
								"locationName": "Name"
							},
							"value": {
								"locationName": "Value",
								"type": "structure",
								"required": [
									"DataType"
								],
								"members": {
									"DataType": {},
									"StringValue": {},
									"BinaryValue": {
										"type": "blob"
									}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "PublishResult",
					"type": "structure",
					"members": {
						"MessageId": {}
					}
				}
			},
			"RemovePermission": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Label"
					],
					"members": {
						"TopicArn": {},
						"Label": {}
					}
				}
			},
			"SetEndpointAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"EndpointArn",
						"Attributes"
					],
					"members": {
						"EndpointArn": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"SetPlatformApplicationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn",
						"Attributes"
					],
					"members": {
						"PlatformApplicationArn": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"SetSMSAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"attributes"
					],
					"members": {
						"attributes": {
							"shape": "Sj"
						}
					}
				},
				"output": {
					"resultWrapper": "SetSMSAttributesResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetSubscriptionAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionArn",
						"AttributeName"
					],
					"members": {
						"SubscriptionArn": {},
						"AttributeName": {},
						"AttributeValue": {}
					}
				}
			},
			"SetTopicAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"AttributeName"
					],
					"members": {
						"TopicArn": {},
						"AttributeName": {},
						"AttributeValue": {}
					}
				}
			},
			"Subscribe": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Protocol"
					],
					"members": {
						"TopicArn": {},
						"Protocol": {},
						"Endpoint": {},
						"Attributes": {
							"shape": "S19"
						},
						"ReturnSubscriptionArn": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SubscribeResult",
					"type": "structure",
					"members": {
						"SubscriptionArn": {}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Tags"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "Ss"
						}
					}
				},
				"output": {
					"resultWrapper": "TagResourceResult",
					"type": "structure",
					"members": {}
				}
			},
			"Unsubscribe": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionArn"
					],
					"members": {
						"SubscriptionArn": {}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeys"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "UntagResourceResult",
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"Sj": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sp": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Ss": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S19": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1r": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"SubscriptionArn": {},
						"Owner": {},
						"Protocol": {},
						"Endpoint": {},
						"TopicArn": {}
					}
				}
			}
		}
	};

/***/ },
/* 1841 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListEndpointsByPlatformApplication": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Endpoints"
			},
			"ListPlatformApplications": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "PlatformApplications"
			},
			"ListSubscriptions": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Subscriptions"
			},
			"ListSubscriptionsByTopic": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Subscriptions"
			},
			"ListTopics": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Topics"
			}
		}
	};

/***/ },
/* 1842 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-11-05",
			"endpointPrefix": "sqs",
			"protocol": "query",
			"serviceAbbreviation": "Amazon SQS",
			"serviceFullName": "Amazon Simple Queue Service",
			"serviceId": "SQS",
			"signatureVersion": "v4",
			"uid": "sqs-2012-11-05",
			"xmlNamespace": "http://queue.amazonaws.com/doc/2012-11-05/"
		},
		"operations": {
			"AddPermission": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Label",
						"AWSAccountIds",
						"Actions"
					],
					"members": {
						"QueueUrl": {},
						"Label": {},
						"AWSAccountIds": {
							"type": "list",
							"member": {
								"locationName": "AWSAccountId"
							},
							"flattened": true
						},
						"Actions": {
							"type": "list",
							"member": {
								"locationName": "ActionName"
							},
							"flattened": true
						}
					}
				}
			},
			"ChangeMessageVisibility": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"ReceiptHandle",
						"VisibilityTimeout"
					],
					"members": {
						"QueueUrl": {},
						"ReceiptHandle": {},
						"VisibilityTimeout": {
							"type": "integer"
						}
					}
				}
			},
			"ChangeMessageVisibilityBatch": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Entries"
					],
					"members": {
						"QueueUrl": {},
						"Entries": {
							"type": "list",
							"member": {
								"locationName": "ChangeMessageVisibilityBatchRequestEntry",
								"type": "structure",
								"required": [
									"Id",
									"ReceiptHandle"
								],
								"members": {
									"Id": {},
									"ReceiptHandle": {},
									"VisibilityTimeout": {
										"type": "integer"
									}
								}
							},
							"flattened": true
						}
					}
				},
				"output": {
					"resultWrapper": "ChangeMessageVisibilityBatchResult",
					"type": "structure",
					"required": [
						"Successful",
						"Failed"
					],
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"locationName": "ChangeMessageVisibilityBatchResultEntry",
								"type": "structure",
								"required": [
									"Id"
								],
								"members": {
									"Id": {}
								}
							},
							"flattened": true
						},
						"Failed": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueName"
					],
					"members": {
						"QueueName": {},
						"Attributes": {
							"shape": "Sh",
							"locationName": "Attribute"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateQueueResult",
					"type": "structure",
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"DeleteMessage": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"ReceiptHandle"
					],
					"members": {
						"QueueUrl": {},
						"ReceiptHandle": {}
					}
				}
			},
			"DeleteMessageBatch": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Entries"
					],
					"members": {
						"QueueUrl": {},
						"Entries": {
							"type": "list",
							"member": {
								"locationName": "DeleteMessageBatchRequestEntry",
								"type": "structure",
								"required": [
									"Id",
									"ReceiptHandle"
								],
								"members": {
									"Id": {},
									"ReceiptHandle": {}
								}
							},
							"flattened": true
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteMessageBatchResult",
					"type": "structure",
					"required": [
						"Successful",
						"Failed"
					],
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"locationName": "DeleteMessageBatchResultEntry",
								"type": "structure",
								"required": [
									"Id"
								],
								"members": {
									"Id": {}
								}
							},
							"flattened": true
						},
						"Failed": {
							"shape": "Sd"
						}
					}
				}
			},
			"DeleteQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"GetQueueAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {},
						"AttributeNames": {
							"shape": "St"
						}
					}
				},
				"output": {
					"resultWrapper": "GetQueueAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sh",
							"locationName": "Attribute"
						}
					}
				}
			},
			"GetQueueUrl": {
				"input": {
					"type": "structure",
					"required": [
						"QueueName"
					],
					"members": {
						"QueueName": {},
						"QueueOwnerAWSAccountId": {}
					}
				},
				"output": {
					"resultWrapper": "GetQueueUrlResult",
					"type": "structure",
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"ListDeadLetterSourceQueues": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {}
					}
				},
				"output": {
					"resultWrapper": "ListDeadLetterSourceQueuesResult",
					"type": "structure",
					"required": [
						"queueUrls"
					],
					"members": {
						"queueUrls": {
							"shape": "Sz"
						}
					}
				}
			},
			"ListQueueTags": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {}
					}
				},
				"output": {
					"resultWrapper": "ListQueueTagsResult",
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S12",
							"locationName": "Tag"
						}
					}
				}
			},
			"ListQueues": {
				"input": {
					"type": "structure",
					"members": {
						"QueueNamePrefix": {}
					}
				},
				"output": {
					"resultWrapper": "ListQueuesResult",
					"type": "structure",
					"members": {
						"QueueUrls": {
							"shape": "Sz"
						}
					}
				}
			},
			"PurgeQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"ReceiveMessage": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {},
						"AttributeNames": {
							"shape": "St"
						},
						"MessageAttributeNames": {
							"type": "list",
							"member": {
								"locationName": "MessageAttributeName"
							},
							"flattened": true
						},
						"MaxNumberOfMessages": {
							"type": "integer"
						},
						"VisibilityTimeout": {
							"type": "integer"
						},
						"WaitTimeSeconds": {
							"type": "integer"
						},
						"ReceiveRequestAttemptId": {}
					}
				},
				"output": {
					"resultWrapper": "ReceiveMessageResult",
					"type": "structure",
					"members": {
						"Messages": {
							"type": "list",
							"member": {
								"locationName": "Message",
								"type": "structure",
								"members": {
									"MessageId": {},
									"ReceiptHandle": {},
									"MD5OfBody": {},
									"Body": {},
									"Attributes": {
										"locationName": "Attribute",
										"type": "map",
										"key": {
											"locationName": "Name"
										},
										"value": {
											"locationName": "Value"
										},
										"flattened": true
									},
									"MD5OfMessageAttributes": {},
									"MessageAttributes": {
										"shape": "S1g",
										"locationName": "MessageAttribute"
									}
								}
							},
							"flattened": true
						}
					}
				}
			},
			"RemovePermission": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Label"
					],
					"members": {
						"QueueUrl": {},
						"Label": {}
					}
				}
			},
			"SendMessage": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"MessageBody"
					],
					"members": {
						"QueueUrl": {},
						"MessageBody": {},
						"DelaySeconds": {
							"type": "integer"
						},
						"MessageAttributes": {
							"shape": "S1g",
							"locationName": "MessageAttribute"
						},
						"MessageDeduplicationId": {},
						"MessageGroupId": {}
					}
				},
				"output": {
					"resultWrapper": "SendMessageResult",
					"type": "structure",
					"members": {
						"MD5OfMessageBody": {},
						"MD5OfMessageAttributes": {},
						"MessageId": {},
						"SequenceNumber": {}
					}
				}
			},
			"SendMessageBatch": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Entries"
					],
					"members": {
						"QueueUrl": {},
						"Entries": {
							"type": "list",
							"member": {
								"locationName": "SendMessageBatchRequestEntry",
								"type": "structure",
								"required": [
									"Id",
									"MessageBody"
								],
								"members": {
									"Id": {},
									"MessageBody": {},
									"DelaySeconds": {
										"type": "integer"
									},
									"MessageAttributes": {
										"shape": "S1g",
										"locationName": "MessageAttribute"
									},
									"MessageDeduplicationId": {},
									"MessageGroupId": {}
								}
							},
							"flattened": true
						}
					}
				},
				"output": {
					"resultWrapper": "SendMessageBatchResult",
					"type": "structure",
					"required": [
						"Successful",
						"Failed"
					],
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"locationName": "SendMessageBatchResultEntry",
								"type": "structure",
								"required": [
									"Id",
									"MessageId",
									"MD5OfMessageBody"
								],
								"members": {
									"Id": {},
									"MessageId": {},
									"MD5OfMessageBody": {},
									"MD5OfMessageAttributes": {},
									"SequenceNumber": {}
								}
							},
							"flattened": true
						},
						"Failed": {
							"shape": "Sd"
						}
					}
				}
			},
			"SetQueueAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Attributes"
					],
					"members": {
						"QueueUrl": {},
						"Attributes": {
							"shape": "Sh",
							"locationName": "Attribute"
						}
					}
				}
			},
			"TagQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Tags"
					],
					"members": {
						"QueueUrl": {},
						"Tags": {
							"shape": "S12"
						}
					}
				}
			},
			"UntagQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"TagKeys"
					],
					"members": {
						"QueueUrl": {},
						"TagKeys": {
							"type": "list",
							"member": {
								"locationName": "TagKey"
							},
							"flattened": true
						}
					}
				}
			}
		},
		"shapes": {
			"Sd": {
				"type": "list",
				"member": {
					"locationName": "BatchResultErrorEntry",
					"type": "structure",
					"required": [
						"Id",
						"SenderFault",
						"Code"
					],
					"members": {
						"Id": {},
						"SenderFault": {
							"type": "boolean"
						},
						"Code": {},
						"Message": {}
					}
				},
				"flattened": true
			},
			"Sh": {
				"type": "map",
				"key": {
					"locationName": "Name"
				},
				"value": {
					"locationName": "Value"
				},
				"flattened": true,
				"locationName": "Attribute"
			},
			"St": {
				"type": "list",
				"member": {
					"locationName": "AttributeName"
				},
				"flattened": true
			},
			"Sz": {
				"type": "list",
				"member": {
					"locationName": "QueueUrl"
				},
				"flattened": true
			},
			"S12": {
				"type": "map",
				"key": {
					"locationName": "Key"
				},
				"value": {
					"locationName": "Value"
				},
				"flattened": true,
				"locationName": "Tag"
			},
			"S1g": {
				"type": "map",
				"key": {
					"locationName": "Name"
				},
				"value": {
					"locationName": "Value",
					"type": "structure",
					"required": [
						"DataType"
					],
					"members": {
						"StringValue": {},
						"BinaryValue": {
							"type": "blob"
						},
						"StringListValues": {
							"flattened": true,
							"locationName": "StringListValue",
							"type": "list",
							"member": {
								"locationName": "StringListValue"
							}
						},
						"BinaryListValues": {
							"flattened": true,
							"locationName": "BinaryListValue",
							"type": "list",
							"member": {
								"locationName": "BinaryListValue",
								"type": "blob"
							}
						},
						"DataType": {}
					}
				},
				"flattened": true
			}
		}
	};

/***/ },
/* 1843 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListQueues": {
				"result_key": "QueueUrls"
			}
		}
	};

/***/ },
/* 1844 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-06",
			"endpointPrefix": "ssm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon SSM",
			"serviceFullName": "Amazon Simple Systems Manager (SSM)",
			"serviceId": "SSM",
			"signatureVersion": "v4",
			"targetPrefix": "AmazonSSM",
			"uid": "ssm-2014-11-06"
		},
		"operations": {
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId",
						"Tags"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelCommand": {
				"input": {
					"type": "structure",
					"required": [
						"CommandId"
					],
					"members": {
						"CommandId": {},
						"InstanceIds": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelMaintenanceWindowExecution": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId"
					],
					"members": {
						"WindowExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionId": {}
					}
				}
			},
			"CreateActivation": {
				"input": {
					"type": "structure",
					"required": [
						"IamRole"
					],
					"members": {
						"Description": {},
						"DefaultInstanceName": {},
						"IamRole": {},
						"RegistrationLimit": {
							"type": "integer"
						},
						"ExpirationDate": {
							"type": "timestamp"
						},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ActivationId": {},
						"ActivationCode": {}
					}
				}
			},
			"CreateAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {},
						"InstanceId": {},
						"Parameters": {
							"shape": "St"
						},
						"Targets": {
							"shape": "Sx"
						},
						"ScheduleExpression": {},
						"OutputLocation": {
							"shape": "S13"
						},
						"AssociationName": {},
						"AutomationTargetParameterName": {},
						"MaxErrors": {},
						"MaxConcurrency": {},
						"ComplianceSeverity": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S1e"
						}
					}
				}
			},
			"CreateAssociationBatch": {
				"input": {
					"type": "structure",
					"required": [
						"Entries"
					],
					"members": {
						"Entries": {
							"type": "list",
							"member": {
								"shape": "S1s"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"shape": "S1e"
							}
						},
						"Failed": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Entry": {
										"shape": "S1s"
									},
									"Message": {},
									"Fault": {}
								}
							}
						}
					}
				}
			},
			"CreateDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Content",
						"Name"
					],
					"members": {
						"Content": {},
						"Attachments": {
							"shape": "S21"
						},
						"Name": {},
						"VersionName": {},
						"DocumentType": {},
						"DocumentFormat": {},
						"TargetType": {},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentDescription": {
							"shape": "S2c"
						}
					}
				}
			},
			"CreateMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Schedule",
						"Duration",
						"Cutoff",
						"AllowUnassociatedTargets"
					],
					"members": {
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"StartDate": {},
						"EndDate": {},
						"Schedule": {},
						"ScheduleTimezone": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {}
					}
				}
			},
			"CreateOpsItem": {
				"input": {
					"type": "structure",
					"required": [
						"Description",
						"Source",
						"Title"
					],
					"members": {
						"Description": {},
						"OperationalData": {
							"shape": "S3a"
						},
						"Notifications": {
							"shape": "S3f"
						},
						"Priority": {
							"type": "integer"
						},
						"RelatedOpsItems": {
							"shape": "S3j"
						},
						"Source": {},
						"Title": {},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OpsItemId": {}
					}
				}
			},
			"CreatePatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"OperatingSystem": {},
						"Name": {},
						"GlobalFilters": {
							"shape": "S3r"
						},
						"ApprovalRules": {
							"shape": "S3x"
						},
						"ApprovedPatches": {
							"shape": "S43"
						},
						"ApprovedPatchesComplianceLevel": {},
						"ApprovedPatchesEnableNonSecurity": {
							"type": "boolean"
						},
						"RejectedPatches": {
							"shape": "S43"
						},
						"RejectedPatchesAction": {},
						"Description": {},
						"Sources": {
							"shape": "S47"
						},
						"ClientToken": {
							"idempotencyToken": true
						},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {}
					}
				}
			},
			"CreateResourceDataSync": {
				"input": {
					"type": "structure",
					"required": [
						"SyncName",
						"S3Destination"
					],
					"members": {
						"SyncName": {},
						"S3Destination": {
							"shape": "S4h"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteActivation": {
				"input": {
					"type": "structure",
					"required": [
						"ActivationId"
					],
					"members": {
						"ActivationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteAssociation": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {},
						"InstanceId": {},
						"AssociationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {},
						"VersionName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteInventory": {
				"input": {
					"type": "structure",
					"required": [
						"TypeName"
					],
					"members": {
						"TypeName": {},
						"SchemaDeleteOption": {},
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeletionId": {},
						"TypeName": {},
						"DeletionSummary": {
							"shape": "S50"
						}
					}
				}
			},
			"DeleteMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {}
					}
				}
			},
			"DeleteParameter": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteParameters": {
				"input": {
					"type": "structure",
					"required": [
						"Names"
					],
					"members": {
						"Names": {
							"shape": "S5d"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeletedParameters": {
							"shape": "S5d"
						},
						"InvalidParameters": {
							"shape": "S5d"
						}
					}
				}
			},
			"DeletePatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {}
					}
				}
			},
			"DeleteResourceDataSync": {
				"input": {
					"type": "structure",
					"required": [
						"SyncName"
					],
					"members": {
						"SyncName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterManagedInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterPatchBaselineForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId",
						"PatchGroup"
					],
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				}
			},
			"DeregisterTargetFromMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"WindowTargetId"
					],
					"members": {
						"WindowId": {},
						"WindowTargetId": {},
						"Safe": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"WindowTargetId": {}
					}
				}
			},
			"DeregisterTaskFromMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"WindowTaskId"
					],
					"members": {
						"WindowId": {},
						"WindowTaskId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"WindowTaskId": {}
					}
				}
			},
			"DescribeActivations": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FilterKey": {},
									"FilterValues": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ActivationList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ActivationId": {},
									"Description": {},
									"DefaultInstanceName": {},
									"IamRole": {},
									"RegistrationLimit": {
										"type": "integer"
									},
									"RegistrationsCount": {
										"type": "integer"
									},
									"ExpirationDate": {
										"type": "timestamp"
									},
									"Expired": {
										"type": "boolean"
									},
									"CreatedDate": {
										"type": "timestamp"
									},
									"Tags": {
										"shape": "S4"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAssociation": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {},
						"InstanceId": {},
						"AssociationId": {},
						"AssociationVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S1e"
						}
					}
				}
			},
			"DescribeAssociationExecutionTargets": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId",
						"ExecutionId"
					],
					"members": {
						"AssociationId": {},
						"ExecutionId": {},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Value"
								],
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationExecutionTargets": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AssociationId": {},
									"AssociationVersion": {},
									"ExecutionId": {},
									"ResourceId": {},
									"ResourceType": {},
									"Status": {},
									"DetailedStatus": {},
									"LastExecutionDate": {
										"type": "timestamp"
									},
									"OutputSource": {
										"type": "structure",
										"members": {
											"OutputSourceId": {},
											"OutputSourceType": {}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAssociationExecutions": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Value",
									"Type"
								],
								"members": {
									"Key": {},
									"Value": {},
									"Type": {}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationExecutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AssociationId": {},
									"AssociationVersion": {},
									"ExecutionId": {},
									"Status": {},
									"DetailedStatus": {},
									"CreatedTime": {
										"type": "timestamp"
									},
									"LastExecutionDate": {
										"type": "timestamp"
									},
									"ResourceCountByStatus": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAutomationExecutions": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AutomationExecutionMetadataList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutomationExecutionId": {},
									"DocumentName": {},
									"DocumentVersion": {},
									"AutomationExecutionStatus": {},
									"ExecutionStartTime": {
										"type": "timestamp"
									},
									"ExecutionEndTime": {
										"type": "timestamp"
									},
									"ExecutedBy": {},
									"LogFile": {},
									"Outputs": {
										"shape": "S78"
									},
									"Mode": {},
									"ParentAutomationExecutionId": {},
									"CurrentStepName": {},
									"CurrentAction": {},
									"FailureMessage": {},
									"TargetParameterName": {},
									"Targets": {
										"shape": "Sx"
									},
									"TargetMaps": {
										"shape": "S7d"
									},
									"ResolvedTargets": {
										"shape": "S7i"
									},
									"MaxConcurrency": {},
									"MaxErrors": {},
									"Target": {},
									"AutomationType": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAutomationStepExecutions": {
				"input": {
					"type": "structure",
					"required": [
						"AutomationExecutionId"
					],
					"members": {
						"AutomationExecutionId": {},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"ReverseOrder": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StepExecutions": {
							"shape": "S7s"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAvailablePatches": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "S88"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Patches": {
							"type": "list",
							"member": {
								"shape": "S8g"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {},
						"VersionName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Document": {
							"shape": "S2c"
						}
					}
				}
			},
			"DescribeDocumentPermission": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"PermissionType"
					],
					"members": {
						"Name": {},
						"PermissionType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountIds": {
							"shape": "S8x"
						}
					}
				}
			},
			"DescribeEffectiveInstanceAssociations": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Associations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AssociationId": {},
									"InstanceId": {},
									"Content": {},
									"AssociationVersion": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeEffectivePatchesForPatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EffectivePatches": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Patch": {
										"shape": "S8g"
									},
									"PatchStatus": {
										"type": "structure",
										"members": {
											"DeploymentStatus": {},
											"ComplianceLevel": {},
											"ApprovalDate": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstanceAssociationsStatus": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceAssociationStatusInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AssociationId": {},
									"Name": {},
									"DocumentVersion": {},
									"AssociationVersion": {},
									"InstanceId": {},
									"ExecutionDate": {
										"type": "timestamp"
									},
									"Status": {},
									"DetailedStatus": {},
									"ExecutionSummary": {},
									"ErrorCode": {},
									"OutputUrl": {
										"type": "structure",
										"members": {
											"S3OutputUrl": {
												"type": "structure",
												"members": {
													"OutputUrl": {}
												}
											}
										}
									},
									"AssociationName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstanceInformation": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceInformationFilterList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"key",
									"valueSet"
								],
								"members": {
									"key": {},
									"valueSet": {
										"shape": "S9n"
									}
								}
							}
						},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values"
								],
								"members": {
									"Key": {},
									"Values": {
										"shape": "S9n"
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceInformationList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InstanceId": {},
									"PingStatus": {},
									"LastPingDateTime": {
										"type": "timestamp"
									},
									"AgentVersion": {},
									"IsLatestVersion": {
										"type": "boolean"
									},
									"PlatformType": {},
									"PlatformName": {},
									"PlatformVersion": {},
									"ActivationId": {},
									"IamRole": {},
									"RegistrationDate": {
										"type": "timestamp"
									},
									"ResourceType": {},
									"Name": {},
									"IPAddress": {},
									"ComputerName": {},
									"AssociationStatus": {},
									"LastAssociationExecutionDate": {
										"type": "timestamp"
									},
									"LastSuccessfulAssociationExecutionDate": {
										"type": "timestamp"
									},
									"AssociationOverview": {
										"type": "structure",
										"members": {
											"DetailedStatus": {},
											"InstanceAssociationStatusAggregatedCount": {
												"type": "map",
												"key": {},
												"value": {
													"type": "integer"
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancePatchStates": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Sb"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstancePatchStates": {
							"type": "list",
							"member": {
								"shape": "Sa7"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancePatchStatesForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"PatchGroup"
					],
					"members": {
						"PatchGroup": {},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values",
									"Type"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									},
									"Type": {}
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstancePatchStates": {
							"type": "list",
							"member": {
								"shape": "Sa7"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancePatches": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"Filters": {
							"shape": "S88"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Patches": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Title",
									"KBId",
									"Classification",
									"Severity",
									"State",
									"InstalledTime"
								],
								"members": {
									"Title": {},
									"KBId": {},
									"Classification": {},
									"Severity": {},
									"State": {},
									"InstalledTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInventoryDeletions": {
				"input": {
					"type": "structure",
					"members": {
						"DeletionId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InventoryDeletions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DeletionId": {},
									"TypeName": {},
									"DeletionStartTime": {
										"type": "timestamp"
									},
									"LastStatus": {},
									"LastStatusMessage": {},
									"DeletionSummary": {
										"shape": "S50"
									},
									"LastStatusUpdateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowExecutionTaskInvocations": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId",
						"TaskId"
					],
					"members": {
						"WindowExecutionId": {},
						"TaskId": {},
						"Filters": {
							"shape": "Sb8"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionTaskInvocationIdentities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowExecutionId": {},
									"TaskExecutionId": {},
									"InvocationId": {},
									"ExecutionId": {},
									"TaskType": {},
									"Parameters": {
										"shape": "Sbk"
									},
									"Status": {},
									"StatusDetails": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"OwnerInformation": {
										"shape": "Saa"
									},
									"WindowTargetId": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowExecutionTasks": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId"
					],
					"members": {
						"WindowExecutionId": {},
						"Filters": {
							"shape": "Sb8"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionTaskIdentities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowExecutionId": {},
									"TaskExecutionId": {},
									"Status": {},
									"StatusDetails": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"TaskArn": {},
									"TaskType": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowExecutions": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Filters": {
							"shape": "Sb8"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"WindowExecutionId": {},
									"Status": {},
									"StatusDetails": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowSchedule": {
				"input": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"Targets": {
							"shape": "Sx"
						},
						"ResourceType": {},
						"Filters": {
							"shape": "S88"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScheduledWindowExecutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"Name": {},
									"ExecutionTime": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowTargets": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Filters": {
							"shape": "Sb8"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Targets": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"WindowTargetId": {},
									"ResourceType": {},
									"Targets": {
										"shape": "Sx"
									},
									"OwnerInformation": {
										"shape": "Saa"
									},
									"Name": {},
									"Description": {
										"shape": "S2y"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowTasks": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Filters": {
							"shape": "Sb8"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tasks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"WindowTaskId": {},
									"TaskArn": {},
									"Type": {},
									"Targets": {
										"shape": "Sx"
									},
									"TaskParameters": {
										"shape": "Scb"
									},
									"Priority": {
										"type": "integer"
									},
									"LoggingInfo": {
										"shape": "Sch"
									},
									"ServiceRoleArn": {},
									"MaxConcurrency": {},
									"MaxErrors": {},
									"Name": {},
									"Description": {
										"shape": "S2y"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindows": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sb8"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowIdentities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"Name": {},
									"Description": {
										"shape": "S2y"
									},
									"Enabled": {
										"type": "boolean"
									},
									"Duration": {
										"type": "integer"
									},
									"Cutoff": {
										"type": "integer"
									},
									"Schedule": {},
									"ScheduleTimezone": {},
									"EndDate": {},
									"StartDate": {},
									"NextExecutionTime": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowsForTarget": {
				"input": {
					"type": "structure",
					"required": [
						"Targets",
						"ResourceType"
					],
					"members": {
						"Targets": {
							"shape": "Sx"
						},
						"ResourceType": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowIdentities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"Name": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeOpsItems": {
				"input": {
					"type": "structure",
					"members": {
						"OpsItemFilters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values",
									"Operator"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									},
									"Operator": {}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"OpsItemSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CreatedBy": {},
									"CreatedTime": {
										"type": "timestamp"
									},
									"LastModifiedBy": {},
									"LastModifiedTime": {
										"type": "timestamp"
									},
									"Priority": {
										"type": "integer"
									},
									"Source": {},
									"Status": {},
									"OpsItemId": {},
									"Title": {},
									"OperationalData": {
										"shape": "S3a"
									}
								}
							}
						}
					}
				}
			},
			"DescribeParameters": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"ParameterFilters": {
							"shape": "Sdb"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Type": {},
									"KeyId": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"LastModifiedUser": {},
									"Description": {},
									"AllowedPattern": {},
									"Version": {
										"type": "long"
									},
									"Tier": {},
									"Policies": {
										"shape": "Sdq"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePatchBaselines": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "S88"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineIdentities": {
							"type": "list",
							"member": {
								"shape": "Sdv"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePatchGroupState": {
				"input": {
					"type": "structure",
					"required": [
						"PatchGroup"
					],
					"members": {
						"PatchGroup": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "integer"
						},
						"InstancesWithInstalledPatches": {
							"type": "integer"
						},
						"InstancesWithInstalledOtherPatches": {
							"type": "integer"
						},
						"InstancesWithInstalledRejectedPatches": {
							"type": "integer"
						},
						"InstancesWithMissingPatches": {
							"type": "integer"
						},
						"InstancesWithFailedPatches": {
							"type": "integer"
						},
						"InstancesWithNotApplicablePatches": {
							"type": "integer"
						},
						"InstancesWithUnreportedNotApplicablePatches": {
							"type": "integer"
						}
					}
				}
			},
			"DescribePatchGroups": {
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"Filters": {
							"shape": "S88"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Mappings": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PatchGroup": {},
									"BaselineIdentity": {
										"shape": "Sdv"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePatchProperties": {
				"input": {
					"type": "structure",
					"required": [
						"OperatingSystem",
						"Property"
					],
					"members": {
						"OperatingSystem": {},
						"Property": {},
						"PatchSet": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Properties": {
							"type": "list",
							"member": {
								"type": "map",
								"key": {},
								"value": {}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeSessions": {
				"input": {
					"type": "structure",
					"required": [
						"State"
					],
					"members": {
						"State": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"key",
									"value"
								],
								"members": {
									"key": {},
									"value": {}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Sessions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SessionId": {},
									"Target": {},
									"Status": {},
									"StartDate": {
										"type": "timestamp"
									},
									"EndDate": {
										"type": "timestamp"
									},
									"DocumentName": {},
									"Owner": {},
									"Details": {},
									"OutputUrl": {
										"type": "structure",
										"members": {
											"S3OutputUrl": {},
											"CloudWatchOutputUrl": {}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetAutomationExecution": {
				"input": {
					"type": "structure",
					"required": [
						"AutomationExecutionId"
					],
					"members": {
						"AutomationExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AutomationExecution": {
							"type": "structure",
							"members": {
								"AutomationExecutionId": {},
								"DocumentName": {},
								"DocumentVersion": {},
								"ExecutionStartTime": {
									"type": "timestamp"
								},
								"ExecutionEndTime": {
									"type": "timestamp"
								},
								"AutomationExecutionStatus": {},
								"StepExecutions": {
									"shape": "S7s"
								},
								"StepExecutionsTruncated": {
									"type": "boolean"
								},
								"Parameters": {
									"shape": "S78"
								},
								"Outputs": {
									"shape": "S78"
								},
								"FailureMessage": {},
								"Mode": {},
								"ParentAutomationExecutionId": {},
								"ExecutedBy": {},
								"CurrentStepName": {},
								"CurrentAction": {},
								"TargetParameterName": {},
								"Targets": {
									"shape": "Sx"
								},
								"TargetMaps": {
									"shape": "S7d"
								},
								"ResolvedTargets": {
									"shape": "S7i"
								},
								"MaxConcurrency": {},
								"MaxErrors": {},
								"Target": {},
								"TargetLocations": {
									"shape": "Sex"
								},
								"ProgressCounters": {
									"type": "structure",
									"members": {
										"TotalSteps": {
											"type": "integer"
										},
										"SuccessSteps": {
											"type": "integer"
										},
										"FailedSteps": {
											"type": "integer"
										},
										"CancelledSteps": {
											"type": "integer"
										},
										"TimedOutSteps": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"GetCommandInvocation": {
				"input": {
					"type": "structure",
					"required": [
						"CommandId",
						"InstanceId"
					],
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"PluginName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"Comment": {},
						"DocumentName": {},
						"DocumentVersion": {},
						"PluginName": {},
						"ResponseCode": {
							"type": "integer"
						},
						"ExecutionStartDateTime": {},
						"ExecutionElapsedTime": {},
						"ExecutionEndDateTime": {},
						"Status": {},
						"StatusDetails": {},
						"StandardOutputContent": {},
						"StandardOutputUrl": {},
						"StandardErrorContent": {},
						"StandardErrorUrl": {},
						"CloudWatchOutputConfig": {
							"shape": "Sf9"
						}
					}
				}
			},
			"GetConnectionStatus": {
				"input": {
					"type": "structure",
					"required": [
						"Target"
					],
					"members": {
						"Target": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Target": {},
						"Status": {}
					}
				}
			},
			"GetDefaultPatchBaseline": {
				"input": {
					"type": "structure",
					"members": {
						"OperatingSystem": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"OperatingSystem": {}
					}
				}
			},
			"GetDeployablePatchSnapshotForInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"SnapshotId"
					],
					"members": {
						"InstanceId": {},
						"SnapshotId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"SnapshotId": {},
						"SnapshotDownloadUrl": {},
						"Product": {}
					}
				}
			},
			"GetDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"VersionName": {},
						"DocumentVersion": {},
						"DocumentFormat": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"VersionName": {},
						"DocumentVersion": {},
						"Status": {},
						"StatusInformation": {},
						"Content": {},
						"DocumentType": {},
						"DocumentFormat": {},
						"AttachmentsContent": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Size": {
										"type": "long"
									},
									"Hash": {},
									"HashType": {},
									"Url": {}
								}
							}
						}
					}
				}
			},
			"GetInventory": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sfu"
						},
						"Aggregators": {
							"shape": "Sg0"
						},
						"ResultAttributes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"TypeName"
								],
								"members": {
									"TypeName": {}
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Entities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Data": {
										"type": "map",
										"key": {},
										"value": {
											"type": "structure",
											"required": [
												"TypeName",
												"SchemaVersion",
												"Content"
											],
											"members": {
												"TypeName": {},
												"SchemaVersion": {},
												"CaptureTime": {},
												"ContentHash": {},
												"Content": {
													"shape": "Sgh"
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetInventorySchema": {
				"input": {
					"type": "structure",
					"members": {
						"TypeName": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Aggregator": {
							"type": "boolean"
						},
						"SubType": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Schemas": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"TypeName",
									"Attributes"
								],
								"members": {
									"TypeName": {},
									"Version": {},
									"Attributes": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"Name",
												"DataType"
											],
											"members": {
												"Name": {},
												"DataType": {}
											}
										}
									},
									"DisplayName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"StartDate": {},
						"EndDate": {},
						"Schedule": {},
						"ScheduleTimezone": {},
						"NextExecutionTime": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"Enabled": {
							"type": "boolean"
						},
						"CreatedDate": {
							"type": "timestamp"
						},
						"ModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetMaintenanceWindowExecution": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId"
					],
					"members": {
						"WindowExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionId": {},
						"TaskIds": {
							"type": "list",
							"member": {}
						},
						"Status": {},
						"StatusDetails": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetMaintenanceWindowExecutionTask": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId",
						"TaskId"
					],
					"members": {
						"WindowExecutionId": {},
						"TaskId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionId": {},
						"TaskExecutionId": {},
						"TaskArn": {},
						"ServiceRole": {},
						"Type": {},
						"TaskParameters": {
							"type": "list",
							"member": {
								"shape": "Scb"
							},
							"sensitive": true
						},
						"Priority": {
							"type": "integer"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"Status": {},
						"StatusDetails": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetMaintenanceWindowExecutionTaskInvocation": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId",
						"TaskId",
						"InvocationId"
					],
					"members": {
						"WindowExecutionId": {},
						"TaskId": {},
						"InvocationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionId": {},
						"TaskExecutionId": {},
						"InvocationId": {},
						"ExecutionId": {},
						"TaskType": {},
						"Parameters": {
							"shape": "Sbk"
						},
						"Status": {},
						"StatusDetails": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"OwnerInformation": {
							"shape": "Saa"
						},
						"WindowTargetId": {}
					}
				}
			},
			"GetMaintenanceWindowTask": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"WindowTaskId"
					],
					"members": {
						"WindowId": {},
						"WindowTaskId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"WindowTaskId": {},
						"Targets": {
							"shape": "Sx"
						},
						"TaskArn": {},
						"ServiceRoleArn": {},
						"TaskType": {},
						"TaskParameters": {
							"shape": "Scb"
						},
						"TaskInvocationParameters": {
							"shape": "Sh8"
						},
						"Priority": {
							"type": "integer"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"LoggingInfo": {
							"shape": "Sch"
						},
						"Name": {},
						"Description": {
							"shape": "S2y"
						}
					}
				}
			},
			"GetOpsItem": {
				"input": {
					"type": "structure",
					"required": [
						"OpsItemId"
					],
					"members": {
						"OpsItemId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OpsItem": {
							"type": "structure",
							"members": {
								"CreatedBy": {},
								"CreatedTime": {
									"type": "timestamp"
								},
								"Description": {},
								"LastModifiedBy": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"Notifications": {
									"shape": "S3f"
								},
								"Priority": {
									"type": "integer"
								},
								"RelatedOpsItems": {
									"shape": "S3j"
								},
								"Status": {},
								"OpsItemId": {},
								"Version": {},
								"Title": {},
								"Source": {},
								"OperationalData": {
									"shape": "S3a"
								}
							}
						}
					}
				}
			},
			"GetOpsSummary": {
				"input": {
					"type": "structure",
					"required": [
						"Aggregators"
					],
					"members": {
						"Filters": {
							"shape": "Shs"
						},
						"Aggregators": {
							"shape": "Shy"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Entities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Data": {
										"type": "map",
										"key": {},
										"value": {
											"type": "structure",
											"members": {
												"Content": {
													"type": "list",
													"member": {
														"type": "map",
														"key": {},
														"value": {}
													}
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetParameter": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"WithDecryption": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameter": {
							"shape": "Sih"
						}
					}
				}
			},
			"GetParameterHistory": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"WithDecryption": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Type": {},
									"KeyId": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"LastModifiedUser": {},
									"Description": {},
									"Value": {},
									"AllowedPattern": {},
									"Version": {
										"type": "long"
									},
									"Labels": {
										"shape": "Sio"
									},
									"Tier": {},
									"Policies": {
										"shape": "Sdq"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetParameters": {
				"input": {
					"type": "structure",
					"required": [
						"Names"
					],
					"members": {
						"Names": {
							"shape": "S5d"
						},
						"WithDecryption": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "Sis"
						},
						"InvalidParameters": {
							"shape": "S5d"
						}
					}
				}
			},
			"GetParametersByPath": {
				"input": {
					"type": "structure",
					"required": [
						"Path"
					],
					"members": {
						"Path": {},
						"Recursive": {
							"type": "boolean"
						},
						"ParameterFilters": {
							"shape": "Sdb"
						},
						"WithDecryption": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "Sis"
						},
						"NextToken": {}
					}
				}
			},
			"GetPatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"Name": {},
						"OperatingSystem": {},
						"GlobalFilters": {
							"shape": "S3r"
						},
						"ApprovalRules": {
							"shape": "S3x"
						},
						"ApprovedPatches": {
							"shape": "S43"
						},
						"ApprovedPatchesComplianceLevel": {},
						"ApprovedPatchesEnableNonSecurity": {
							"type": "boolean"
						},
						"RejectedPatches": {
							"shape": "S43"
						},
						"RejectedPatchesAction": {},
						"PatchGroups": {
							"type": "list",
							"member": {}
						},
						"CreatedDate": {
							"type": "timestamp"
						},
						"ModifiedDate": {
							"type": "timestamp"
						},
						"Description": {},
						"Sources": {
							"shape": "S47"
						}
					}
				}
			},
			"GetPatchBaselineForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"PatchGroup"
					],
					"members": {
						"PatchGroup": {},
						"OperatingSystem": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"PatchGroup": {},
						"OperatingSystem": {}
					}
				}
			},
			"GetServiceSetting": {
				"input": {
					"type": "structure",
					"required": [
						"SettingId"
					],
					"members": {
						"SettingId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceSetting": {
							"shape": "Sj4"
						}
					}
				}
			},
			"LabelParameterVersion": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Labels"
					],
					"members": {
						"Name": {},
						"ParameterVersion": {
							"type": "long"
						},
						"Labels": {
							"shape": "Sio"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidLabels": {
							"shape": "Sio"
						}
					}
				}
			},
			"ListAssociationVersions": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationVersions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AssociationId": {},
									"AssociationVersion": {},
									"CreatedDate": {
										"type": "timestamp"
									},
									"Name": {},
									"DocumentVersion": {},
									"Parameters": {
										"shape": "St"
									},
									"Targets": {
										"shape": "Sx"
									},
									"ScheduleExpression": {},
									"OutputLocation": {
										"shape": "S13"
									},
									"AssociationName": {},
									"MaxErrors": {},
									"MaxConcurrency": {},
									"ComplianceSeverity": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListAssociations": {
				"input": {
					"type": "structure",
					"members": {
						"AssociationFilterList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"key",
									"value"
								],
								"members": {
									"key": {},
									"value": {}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Associations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"InstanceId": {},
									"AssociationId": {},
									"AssociationVersion": {},
									"DocumentVersion": {},
									"Targets": {
										"shape": "Sx"
									},
									"LastExecutionDate": {
										"type": "timestamp"
									},
									"Overview": {
										"shape": "S1l"
									},
									"ScheduleExpression": {},
									"AssociationName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListCommandInvocations": {
				"input": {
					"type": "structure",
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"Filters": {
							"shape": "Sjm"
						},
						"Details": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CommandInvocations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CommandId": {},
									"InstanceId": {},
									"InstanceName": {},
									"Comment": {},
									"DocumentName": {},
									"DocumentVersion": {},
									"RequestedDateTime": {
										"type": "timestamp"
									},
									"Status": {},
									"StatusDetails": {},
									"TraceOutput": {},
									"StandardOutputUrl": {},
									"StandardErrorUrl": {},
									"CommandPlugins": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Name": {},
												"Status": {},
												"StatusDetails": {},
												"ResponseCode": {
													"type": "integer"
												},
												"ResponseStartDateTime": {
													"type": "timestamp"
												},
												"ResponseFinishDateTime": {
													"type": "timestamp"
												},
												"Output": {},
												"StandardOutputUrl": {},
												"StandardErrorUrl": {},
												"OutputS3Region": {},
												"OutputS3BucketName": {},
												"OutputS3KeyPrefix": {}
											}
										}
									},
									"ServiceRole": {},
									"NotificationConfig": {
										"shape": "Sha"
									},
									"CloudWatchOutputConfig": {
										"shape": "Sf9"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListCommands": {
				"input": {
					"type": "structure",
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"Filters": {
							"shape": "Sjm"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Commands": {
							"type": "list",
							"member": {
								"shape": "Sk2"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListComplianceItems": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sk9"
						},
						"ResourceIds": {
							"type": "list",
							"member": {}
						},
						"ResourceTypes": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ComplianceType": {},
									"ResourceType": {},
									"ResourceId": {},
									"Id": {},
									"Title": {},
									"Status": {},
									"Severity": {},
									"ExecutionSummary": {
										"shape": "Skr"
									},
									"Details": {
										"shape": "Sku"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListComplianceSummaries": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sk9"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceSummaryItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ComplianceType": {},
									"CompliantSummary": {
										"shape": "Skz"
									},
									"NonCompliantSummary": {
										"shape": "Sl2"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListDocumentVersions": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentVersions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"DocumentVersion": {},
									"VersionName": {},
									"CreatedDate": {
										"type": "timestamp"
									},
									"IsDefaultVersion": {
										"type": "boolean"
									},
									"DocumentFormat": {},
									"Status": {},
									"StatusInformation": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListDocuments": {
				"input": {
					"type": "structure",
					"members": {
						"DocumentFilterList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"key",
									"value"
								],
								"members": {
									"key": {},
									"value": {}
								}
							}
						},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentIdentifiers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Owner": {},
									"VersionName": {},
									"PlatformTypes": {
										"shape": "S2q"
									},
									"DocumentVersion": {},
									"DocumentType": {},
									"SchemaVersion": {},
									"DocumentFormat": {},
									"TargetType": {},
									"Tags": {
										"shape": "S4"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListInventoryEntries": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"TypeName"
					],
					"members": {
						"InstanceId": {},
						"TypeName": {},
						"Filters": {
							"shape": "Sfu"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TypeName": {},
						"InstanceId": {},
						"SchemaVersion": {},
						"CaptureTime": {},
						"Entries": {
							"shape": "Sgh"
						},
						"NextToken": {}
					}
				}
			},
			"ListResourceComplianceSummaries": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sk9"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceComplianceSummaryItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ComplianceType": {},
									"ResourceType": {},
									"ResourceId": {},
									"Status": {},
									"OverallSeverity": {},
									"ExecutionSummary": {
										"shape": "Skr"
									},
									"CompliantSummary": {
										"shape": "Skz"
									},
									"NonCompliantSummary": {
										"shape": "Sl2"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListResourceDataSync": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceDataSyncItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SyncName": {},
									"S3Destination": {
										"shape": "S4h"
									},
									"LastSyncTime": {
										"type": "timestamp"
									},
									"LastSuccessfulSyncTime": {
										"type": "timestamp"
									},
									"LastStatus": {},
									"SyncCreatedTime": {
										"type": "timestamp"
									},
									"LastSyncStatusMessage": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyDocumentPermission": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"PermissionType"
					],
					"members": {
						"Name": {},
						"PermissionType": {},
						"AccountIdsToAdd": {
							"shape": "S8x"
						},
						"AccountIdsToRemove": {
							"shape": "S8x"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"PutComplianceItems": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"ResourceType",
						"ComplianceType",
						"ExecutionSummary",
						"Items"
					],
					"members": {
						"ResourceId": {},
						"ResourceType": {},
						"ComplianceType": {},
						"ExecutionSummary": {
							"shape": "Skr"
						},
						"Items": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Severity",
									"Status"
								],
								"members": {
									"Id": {},
									"Title": {},
									"Severity": {},
									"Status": {},
									"Details": {
										"shape": "Sku"
									}
								}
							}
						},
						"ItemContentHash": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"PutInventory": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Items"
					],
					"members": {
						"InstanceId": {},
						"Items": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"TypeName",
									"SchemaVersion",
									"CaptureTime"
								],
								"members": {
									"TypeName": {},
									"SchemaVersion": {},
									"CaptureTime": {},
									"ContentHash": {},
									"Content": {
										"shape": "Sgh"
									},
									"Context": {
										"type": "map",
										"key": {},
										"value": {}
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Message": {}
					}
				}
			},
			"PutParameter": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Value",
						"Type"
					],
					"members": {
						"Name": {},
						"Description": {},
						"Value": {},
						"Type": {},
						"KeyId": {},
						"Overwrite": {
							"type": "boolean"
						},
						"AllowedPattern": {},
						"Tags": {
							"shape": "S4"
						},
						"Tier": {},
						"Policies": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Version": {
							"type": "long"
						}
					}
				}
			},
			"RegisterDefaultPatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {}
					}
				}
			},
			"RegisterPatchBaselineForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId",
						"PatchGroup"
					],
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				}
			},
			"RegisterTargetWithMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"ResourceType",
						"Targets"
					],
					"members": {
						"WindowId": {},
						"ResourceType": {},
						"Targets": {
							"shape": "Sx"
						},
						"OwnerInformation": {
							"shape": "Saa"
						},
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowTargetId": {}
					}
				}
			},
			"RegisterTaskWithMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"Targets",
						"TaskArn",
						"TaskType",
						"MaxConcurrency",
						"MaxErrors"
					],
					"members": {
						"WindowId": {},
						"Targets": {
							"shape": "Sx"
						},
						"TaskArn": {},
						"ServiceRoleArn": {},
						"TaskType": {},
						"TaskParameters": {
							"shape": "Scb"
						},
						"TaskInvocationParameters": {
							"shape": "Sh8"
						},
						"Priority": {
							"type": "integer"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"LoggingInfo": {
							"shape": "Sch"
						},
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowTaskId": {}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId",
						"TagKeys"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ResetServiceSetting": {
				"input": {
					"type": "structure",
					"required": [
						"SettingId"
					],
					"members": {
						"SettingId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceSetting": {
							"shape": "Sj4"
						}
					}
				}
			},
			"ResumeSession": {
				"input": {
					"type": "structure",
					"required": [
						"SessionId"
					],
					"members": {
						"SessionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SessionId": {},
						"TokenValue": {},
						"StreamUrl": {}
					}
				}
			},
			"SendAutomationSignal": {
				"input": {
					"type": "structure",
					"required": [
						"AutomationExecutionId",
						"SignalType"
					],
					"members": {
						"AutomationExecutionId": {},
						"SignalType": {},
						"Payload": {
							"shape": "S78"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"SendCommand": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentName"
					],
					"members": {
						"InstanceIds": {
							"shape": "Sb"
						},
						"Targets": {
							"shape": "Sx"
						},
						"DocumentName": {},
						"DocumentVersion": {},
						"DocumentHash": {},
						"DocumentHashType": {},
						"TimeoutSeconds": {
							"type": "integer"
						},
						"Comment": {},
						"Parameters": {
							"shape": "St"
						},
						"OutputS3Region": {},
						"OutputS3BucketName": {},
						"OutputS3KeyPrefix": {},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"ServiceRoleArn": {},
						"NotificationConfig": {
							"shape": "Sha"
						},
						"CloudWatchOutputConfig": {
							"shape": "Sf9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Command": {
							"shape": "Sk2"
						}
					}
				}
			},
			"StartAssociationsOnce": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationIds"
					],
					"members": {
						"AssociationIds": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StartAutomationExecution": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentName"
					],
					"members": {
						"DocumentName": {},
						"DocumentVersion": {},
						"Parameters": {
							"shape": "S78"
						},
						"ClientToken": {},
						"Mode": {},
						"TargetParameterName": {},
						"Targets": {
							"shape": "Sx"
						},
						"TargetMaps": {
							"shape": "S7d"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"TargetLocations": {
							"shape": "Sex"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AutomationExecutionId": {}
					}
				}
			},
			"StartSession": {
				"input": {
					"type": "structure",
					"required": [
						"Target"
					],
					"members": {
						"Target": {},
						"DocumentName": {},
						"Parameters": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SessionId": {},
						"TokenValue": {},
						"StreamUrl": {}
					}
				}
			},
			"StopAutomationExecution": {
				"input": {
					"type": "structure",
					"required": [
						"AutomationExecutionId"
					],
					"members": {
						"AutomationExecutionId": {},
						"Type": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"TerminateSession": {
				"input": {
					"type": "structure",
					"required": [
						"SessionId"
					],
					"members": {
						"SessionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SessionId": {}
					}
				}
			},
			"UpdateAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {},
						"Parameters": {
							"shape": "St"
						},
						"DocumentVersion": {},
						"ScheduleExpression": {},
						"OutputLocation": {
							"shape": "S13"
						},
						"Name": {},
						"Targets": {
							"shape": "Sx"
						},
						"AssociationName": {},
						"AssociationVersion": {},
						"AutomationTargetParameterName": {},
						"MaxErrors": {},
						"MaxConcurrency": {},
						"ComplianceSeverity": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S1e"
						}
					}
				}
			},
			"UpdateAssociationStatus": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"InstanceId",
						"AssociationStatus"
					],
					"members": {
						"Name": {},
						"InstanceId": {},
						"AssociationStatus": {
							"shape": "S1h"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S1e"
						}
					}
				}
			},
			"UpdateDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Content",
						"Name"
					],
					"members": {
						"Content": {},
						"Attachments": {
							"shape": "S21"
						},
						"Name": {},
						"VersionName": {},
						"DocumentVersion": {},
						"DocumentFormat": {},
						"TargetType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentDescription": {
							"shape": "S2c"
						}
					}
				}
			},
			"UpdateDocumentDefaultVersion": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"DocumentVersion"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Description": {
							"type": "structure",
							"members": {
								"Name": {},
								"DefaultVersion": {},
								"DefaultVersionName": {}
							}
						}
					}
				}
			},
			"UpdateMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"StartDate": {},
						"EndDate": {},
						"Schedule": {},
						"ScheduleTimezone": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"Enabled": {
							"type": "boolean"
						},
						"Replace": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"StartDate": {},
						"EndDate": {},
						"Schedule": {},
						"ScheduleTimezone": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateMaintenanceWindowTarget": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"WindowTargetId"
					],
					"members": {
						"WindowId": {},
						"WindowTargetId": {},
						"Targets": {
							"shape": "Sx"
						},
						"OwnerInformation": {
							"shape": "Saa"
						},
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"Replace": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"WindowTargetId": {},
						"Targets": {
							"shape": "Sx"
						},
						"OwnerInformation": {
							"shape": "Saa"
						},
						"Name": {},
						"Description": {
							"shape": "S2y"
						}
					}
				}
			},
			"UpdateMaintenanceWindowTask": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"WindowTaskId"
					],
					"members": {
						"WindowId": {},
						"WindowTaskId": {},
						"Targets": {
							"shape": "Sx"
						},
						"TaskArn": {},
						"ServiceRoleArn": {},
						"TaskParameters": {
							"shape": "Scb"
						},
						"TaskInvocationParameters": {
							"shape": "Sh8"
						},
						"Priority": {
							"type": "integer"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"LoggingInfo": {
							"shape": "Sch"
						},
						"Name": {},
						"Description": {
							"shape": "S2y"
						},
						"Replace": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"WindowTaskId": {},
						"Targets": {
							"shape": "Sx"
						},
						"TaskArn": {},
						"ServiceRoleArn": {},
						"TaskParameters": {
							"shape": "Scb"
						},
						"TaskInvocationParameters": {
							"shape": "Sh8"
						},
						"Priority": {
							"type": "integer"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"LoggingInfo": {
							"shape": "Sch"
						},
						"Name": {},
						"Description": {
							"shape": "S2y"
						}
					}
				}
			},
			"UpdateManagedInstanceRole": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"IamRole"
					],
					"members": {
						"InstanceId": {},
						"IamRole": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateOpsItem": {
				"input": {
					"type": "structure",
					"required": [
						"OpsItemId"
					],
					"members": {
						"Description": {},
						"OperationalData": {
							"shape": "S3a"
						},
						"OperationalDataToDelete": {
							"type": "list",
							"member": {}
						},
						"Notifications": {
							"shape": "S3f"
						},
						"Priority": {
							"type": "integer"
						},
						"RelatedOpsItems": {
							"shape": "S3j"
						},
						"Status": {},
						"OpsItemId": {},
						"Title": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdatePatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {},
						"Name": {},
						"GlobalFilters": {
							"shape": "S3r"
						},
						"ApprovalRules": {
							"shape": "S3x"
						},
						"ApprovedPatches": {
							"shape": "S43"
						},
						"ApprovedPatchesComplianceLevel": {},
						"ApprovedPatchesEnableNonSecurity": {
							"type": "boolean"
						},
						"RejectedPatches": {
							"shape": "S43"
						},
						"RejectedPatchesAction": {},
						"Description": {},
						"Sources": {
							"shape": "S47"
						},
						"Replace": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"Name": {},
						"OperatingSystem": {},
						"GlobalFilters": {
							"shape": "S3r"
						},
						"ApprovalRules": {
							"shape": "S3x"
						},
						"ApprovedPatches": {
							"shape": "S43"
						},
						"ApprovedPatchesComplianceLevel": {},
						"ApprovedPatchesEnableNonSecurity": {
							"type": "boolean"
						},
						"RejectedPatches": {
							"shape": "S43"
						},
						"RejectedPatchesAction": {},
						"CreatedDate": {
							"type": "timestamp"
						},
						"ModifiedDate": {
							"type": "timestamp"
						},
						"Description": {},
						"Sources": {
							"shape": "S47"
						}
					}
				}
			},
			"UpdateServiceSetting": {
				"input": {
					"type": "structure",
					"required": [
						"SettingId",
						"SettingValue"
					],
					"members": {
						"SettingId": {},
						"SettingValue": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sb": {
				"type": "list",
				"member": {}
			},
			"St": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S13": {
				"type": "structure",
				"members": {
					"S3Location": {
						"type": "structure",
						"members": {
							"OutputS3Region": {},
							"OutputS3BucketName": {},
							"OutputS3KeyPrefix": {}
						}
					}
				}
			},
			"S1e": {
				"type": "structure",
				"members": {
					"Name": {},
					"InstanceId": {},
					"AssociationVersion": {},
					"Date": {
						"type": "timestamp"
					},
					"LastUpdateAssociationDate": {
						"type": "timestamp"
					},
					"Status": {
						"shape": "S1h"
					},
					"Overview": {
						"shape": "S1l"
					},
					"DocumentVersion": {},
					"AutomationTargetParameterName": {},
					"Parameters": {
						"shape": "St"
					},
					"AssociationId": {},
					"Targets": {
						"shape": "Sx"
					},
					"ScheduleExpression": {},
					"OutputLocation": {
						"shape": "S13"
					},
					"LastExecutionDate": {
						"type": "timestamp"
					},
					"LastSuccessfulExecutionDate": {
						"type": "timestamp"
					},
					"AssociationName": {},
					"MaxErrors": {},
					"MaxConcurrency": {},
					"ComplianceSeverity": {}
				}
			},
			"S1h": {
				"type": "structure",
				"required": [
					"Date",
					"Name",
					"Message"
				],
				"members": {
					"Date": {
						"type": "timestamp"
					},
					"Name": {},
					"Message": {},
					"AdditionalInfo": {}
				}
			},
			"S1l": {
				"type": "structure",
				"members": {
					"Status": {},
					"DetailedStatus": {},
					"AssociationStatusAggregatedCount": {
						"type": "map",
						"key": {},
						"value": {
							"type": "integer"
						}
					}
				}
			},
			"S1s": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"InstanceId": {},
					"Parameters": {
						"shape": "St"
					},
					"AutomationTargetParameterName": {},
					"DocumentVersion": {},
					"Targets": {
						"shape": "Sx"
					},
					"ScheduleExpression": {},
					"OutputLocation": {
						"shape": "S13"
					},
					"AssociationName": {},
					"MaxErrors": {},
					"MaxConcurrency": {},
					"ComplianceSeverity": {}
				}
			},
			"S21": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"Sha1": {},
					"Hash": {},
					"HashType": {},
					"Name": {},
					"VersionName": {},
					"Owner": {},
					"CreatedDate": {
						"type": "timestamp"
					},
					"Status": {},
					"StatusInformation": {},
					"DocumentVersion": {},
					"Description": {},
					"Parameters": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Type": {},
								"Description": {},
								"DefaultValue": {}
							}
						}
					},
					"PlatformTypes": {
						"shape": "S2q"
					},
					"DocumentType": {},
					"SchemaVersion": {},
					"LatestVersion": {},
					"DefaultVersion": {},
					"DocumentFormat": {},
					"TargetType": {},
					"Tags": {
						"shape": "S4"
					},
					"AttachmentsInformation": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {}
							}
						}
					}
				}
			},
			"S2q": {
				"type": "list",
				"member": {}
			},
			"S2y": {
				"type": "string",
				"sensitive": true
			},
			"S3a": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Value": {},
						"Type": {}
					}
				}
			},
			"S3f": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Arn": {}
					}
				}
			},
			"S3j": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"OpsItemId"
					],
					"members": {
						"OpsItemId": {}
					}
				}
			},
			"S3r": {
				"type": "structure",
				"required": [
					"PatchFilters"
				],
				"members": {
					"PatchFilters": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Key",
								"Values"
							],
							"members": {
								"Key": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			},
			"S3x": {
				"type": "structure",
				"required": [
					"PatchRules"
				],
				"members": {
					"PatchRules": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"PatchFilterGroup",
								"ApproveAfterDays"
							],
							"members": {
								"PatchFilterGroup": {
									"shape": "S3r"
								},
								"ComplianceLevel": {},
								"ApproveAfterDays": {
									"type": "integer"
								},
								"EnableNonSecurity": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"S43": {
				"type": "list",
				"member": {}
			},
			"S47": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Products",
						"Configuration"
					],
					"members": {
						"Name": {},
						"Products": {
							"type": "list",
							"member": {}
						},
						"Configuration": {
							"type": "string",
							"sensitive": true
						}
					}
				}
			},
			"S4h": {
				"type": "structure",
				"required": [
					"BucketName",
					"SyncFormat",
					"Region"
				],
				"members": {
					"BucketName": {},
					"Prefix": {},
					"SyncFormat": {},
					"Region": {},
					"AWSKMSKeyARN": {}
				}
			},
			"S50": {
				"type": "structure",
				"members": {
					"TotalCount": {
						"type": "integer"
					},
					"RemainingCount": {
						"type": "integer"
					},
					"SummaryItems": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Version": {},
								"Count": {
									"type": "integer"
								},
								"RemainingCount": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"S5d": {
				"type": "list",
				"member": {}
			},
			"S78": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {}
				}
			},
			"S7d": {
				"type": "list",
				"member": {
					"type": "map",
					"key": {},
					"value": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S7i": {
				"type": "structure",
				"members": {
					"ParameterValues": {
						"type": "list",
						"member": {}
					},
					"Truncated": {
						"type": "boolean"
					}
				}
			},
			"S7s": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"StepName": {},
						"Action": {},
						"TimeoutSeconds": {
							"type": "long"
						},
						"OnFailure": {},
						"MaxAttempts": {
							"type": "integer"
						},
						"ExecutionStartTime": {
							"type": "timestamp"
						},
						"ExecutionEndTime": {
							"type": "timestamp"
						},
						"StepStatus": {},
						"ResponseCode": {},
						"Inputs": {
							"type": "map",
							"key": {},
							"value": {}
						},
						"Outputs": {
							"shape": "S78"
						},
						"Response": {},
						"FailureMessage": {},
						"FailureDetails": {
							"type": "structure",
							"members": {
								"FailureStage": {},
								"FailureType": {},
								"Details": {
									"shape": "S78"
								}
							}
						},
						"StepExecutionId": {},
						"OverriddenParameters": {
							"shape": "S78"
						},
						"IsEnd": {
							"type": "boolean"
						},
						"NextStep": {},
						"IsCritical": {
							"type": "boolean"
						},
						"ValidNextSteps": {
							"type": "list",
							"member": {}
						},
						"Targets": {
							"shape": "Sx"
						},
						"TargetLocation": {
							"shape": "S81"
						}
					}
				}
			},
			"S81": {
				"type": "structure",
				"members": {
					"Accounts": {
						"type": "list",
						"member": {}
					},
					"Regions": {
						"type": "list",
						"member": {}
					},
					"TargetLocationMaxConcurrency": {},
					"TargetLocationMaxErrors": {},
					"ExecutionRoleName": {}
				}
			},
			"S88": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S8g": {
				"type": "structure",
				"members": {
					"Id": {},
					"ReleaseDate": {
						"type": "timestamp"
					},
					"Title": {},
					"Description": {},
					"ContentUrl": {},
					"Vendor": {},
					"ProductFamily": {},
					"Product": {},
					"Classification": {},
					"MsrcSeverity": {},
					"KbNumber": {},
					"MsrcNumber": {},
					"Language": {}
				}
			},
			"S8x": {
				"type": "list",
				"member": {}
			},
			"S9n": {
				"type": "list",
				"member": {}
			},
			"Sa7": {
				"type": "structure",
				"required": [
					"InstanceId",
					"PatchGroup",
					"BaselineId",
					"OperationStartTime",
					"OperationEndTime",
					"Operation"
				],
				"members": {
					"InstanceId": {},
					"PatchGroup": {},
					"BaselineId": {},
					"SnapshotId": {},
					"InstallOverrideList": {},
					"OwnerInformation": {
						"shape": "Saa"
					},
					"InstalledCount": {
						"type": "integer"
					},
					"InstalledOtherCount": {
						"type": "integer"
					},
					"InstalledRejectedCount": {
						"type": "integer"
					},
					"MissingCount": {
						"type": "integer"
					},
					"FailedCount": {
						"type": "integer"
					},
					"UnreportedNotApplicableCount": {
						"type": "integer"
					},
					"NotApplicableCount": {
						"type": "integer"
					},
					"OperationStartTime": {
						"type": "timestamp"
					},
					"OperationEndTime": {
						"type": "timestamp"
					},
					"Operation": {}
				}
			},
			"Saa": {
				"type": "string",
				"sensitive": true
			},
			"Sb8": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"Sbk": {
				"type": "string",
				"sensitive": true
			},
			"Scb": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Values": {
							"type": "list",
							"member": {
								"type": "string",
								"sensitive": true
							},
							"sensitive": true
						}
					},
					"sensitive": true
				},
				"sensitive": true
			},
			"Sch": {
				"type": "structure",
				"required": [
					"S3BucketName",
					"S3Region"
				],
				"members": {
					"S3BucketName": {},
					"S3KeyPrefix": {},
					"S3Region": {}
				}
			},
			"Sdb": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Option": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"Sdq": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PolicyText": {},
						"PolicyType": {},
						"PolicyStatus": {}
					}
				}
			},
			"Sdv": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"BaselineName": {},
					"OperatingSystem": {},
					"BaselineDescription": {},
					"DefaultBaseline": {
						"type": "boolean"
					}
				}
			},
			"Sex": {
				"type": "list",
				"member": {
					"shape": "S81"
				}
			},
			"Sf9": {
				"type": "structure",
				"members": {
					"CloudWatchLogGroupName": {},
					"CloudWatchOutputEnabled": {
						"type": "boolean"
					}
				}
			},
			"Sfu": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Values"
					],
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						},
						"Type": {}
					}
				}
			},
			"Sg0": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Expression": {},
						"Aggregators": {
							"shape": "Sg0"
						},
						"Groups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Name",
									"Filters"
								],
								"members": {
									"Name": {},
									"Filters": {
										"shape": "Sfu"
									}
								}
							}
						}
					}
				}
			},
			"Sgh": {
				"type": "list",
				"member": {
					"type": "map",
					"key": {},
					"value": {}
				}
			},
			"Sh8": {
				"type": "structure",
				"members": {
					"RunCommand": {
						"type": "structure",
						"members": {
							"Comment": {},
							"DocumentHash": {},
							"DocumentHashType": {},
							"NotificationConfig": {
								"shape": "Sha"
							},
							"OutputS3BucketName": {},
							"OutputS3KeyPrefix": {},
							"Parameters": {
								"shape": "St"
							},
							"ServiceRoleArn": {},
							"TimeoutSeconds": {
								"type": "integer"
							}
						}
					},
					"Automation": {
						"type": "structure",
						"members": {
							"DocumentVersion": {},
							"Parameters": {
								"shape": "S78"
							}
						}
					},
					"StepFunctions": {
						"type": "structure",
						"members": {
							"Input": {
								"type": "string",
								"sensitive": true
							},
							"Name": {}
						}
					},
					"Lambda": {
						"type": "structure",
						"members": {
							"ClientContext": {},
							"Qualifier": {},
							"Payload": {
								"type": "blob",
								"sensitive": true
							}
						}
					}
				}
			},
			"Sha": {
				"type": "structure",
				"members": {
					"NotificationArn": {},
					"NotificationEvents": {
						"type": "list",
						"member": {}
					},
					"NotificationType": {}
				}
			},
			"Shs": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Values"
					],
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						},
						"Type": {}
					}
				}
			},
			"Shy": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"AggregatorType": {},
						"TypeName": {},
						"AttributeName": {},
						"Values": {
							"type": "map",
							"key": {},
							"value": {}
						},
						"Filters": {
							"shape": "Shs"
						},
						"Aggregators": {
							"shape": "Shy"
						}
					}
				}
			},
			"Sih": {
				"type": "structure",
				"members": {
					"Name": {},
					"Type": {},
					"Value": {},
					"Version": {
						"type": "long"
					},
					"Selector": {},
					"SourceResult": {},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"ARN": {}
				}
			},
			"Sio": {
				"type": "list",
				"member": {}
			},
			"Sis": {
				"type": "list",
				"member": {
					"shape": "Sih"
				}
			},
			"Sj4": {
				"type": "structure",
				"members": {
					"SettingId": {},
					"SettingValue": {},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"LastModifiedUser": {},
					"ARN": {},
					"Status": {}
				}
			},
			"Sjm": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key",
						"value"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"Sk2": {
				"type": "structure",
				"members": {
					"CommandId": {},
					"DocumentName": {},
					"DocumentVersion": {},
					"Comment": {},
					"ExpiresAfter": {
						"type": "timestamp"
					},
					"Parameters": {
						"shape": "St"
					},
					"InstanceIds": {
						"shape": "Sb"
					},
					"Targets": {
						"shape": "Sx"
					},
					"RequestedDateTime": {
						"type": "timestamp"
					},
					"Status": {},
					"StatusDetails": {},
					"OutputS3Region": {},
					"OutputS3BucketName": {},
					"OutputS3KeyPrefix": {},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"TargetCount": {
						"type": "integer"
					},
					"CompletedCount": {
						"type": "integer"
					},
					"ErrorCount": {
						"type": "integer"
					},
					"DeliveryTimedOutCount": {
						"type": "integer"
					},
					"ServiceRole": {},
					"NotificationConfig": {
						"shape": "Sha"
					},
					"CloudWatchOutputConfig": {
						"shape": "Sf9"
					}
				}
			},
			"Sk9": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						},
						"Type": {}
					}
				}
			},
			"Skr": {
				"type": "structure",
				"required": [
					"ExecutionTime"
				],
				"members": {
					"ExecutionTime": {
						"type": "timestamp"
					},
					"ExecutionId": {},
					"ExecutionType": {}
				}
			},
			"Sku": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Skz": {
				"type": "structure",
				"members": {
					"CompliantCount": {
						"type": "integer"
					},
					"SeveritySummary": {
						"shape": "Sl1"
					}
				}
			},
			"Sl1": {
				"type": "structure",
				"members": {
					"CriticalCount": {
						"type": "integer"
					},
					"HighCount": {
						"type": "integer"
					},
					"MediumCount": {
						"type": "integer"
					},
					"LowCount": {
						"type": "integer"
					},
					"InformationalCount": {
						"type": "integer"
					},
					"UnspecifiedCount": {
						"type": "integer"
					}
				}
			},
			"Sl2": {
				"type": "structure",
				"members": {
					"NonCompliantCount": {
						"type": "integer"
					},
					"SeveritySummary": {
						"shape": "Sl1"
					}
				}
			}
		}
	};

/***/ },
/* 1845 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeActivations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ActivationList"
			},
			"DescribeInstanceInformation": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "InstanceInformationList"
			},
			"DescribeParameters": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetParameterHistory": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"GetParametersByPath": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"ListAssociations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Associations"
			},
			"ListCommandInvocations": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "CommandInvocations"
			},
			"ListCommands": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Commands"
			},
			"ListDocuments": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "DocumentIdentifiers"
			}
		}
	};

/***/ },
/* 1846 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-06-30",
			"endpointPrefix": "storagegateway",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Storage Gateway",
			"serviceId": "Storage Gateway",
			"signatureVersion": "v4",
			"targetPrefix": "StorageGateway_20130630",
			"uid": "storagegateway-2013-06-30"
		},
		"operations": {
			"ActivateGateway": {
				"input": {
					"type": "structure",
					"required": [
						"ActivationKey",
						"GatewayName",
						"GatewayTimezone",
						"GatewayRegion"
					],
					"members": {
						"ActivationKey": {},
						"GatewayName": {},
						"GatewayTimezone": {},
						"GatewayRegion": {},
						"GatewayType": {},
						"TapeDriveType": {},
						"MediumChangerType": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"AddCache": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskIds"
					],
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"Tags"
					],
					"members": {
						"ResourceARN": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceARN": {}
					}
				}
			},
			"AddUploadBuffer": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskIds"
					],
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"AddWorkingStorage": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskIds"
					],
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sg"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"AssignTapePool": {
				"input": {
					"type": "structure",
					"required": [
						"TapeARN",
						"PoolId"
					],
					"members": {
						"TapeARN": {},
						"PoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"AttachVolume": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"VolumeARN",
						"NetworkInterfaceId"
					],
					"members": {
						"GatewayARN": {},
						"TargetName": {},
						"VolumeARN": {},
						"NetworkInterfaceId": {},
						"DiskId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"TargetARN": {}
					}
				}
			},
			"CancelArchival": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"CancelRetrieval": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"CreateCachediSCSIVolume": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"VolumeSizeInBytes",
						"TargetName",
						"NetworkInterfaceId",
						"ClientToken"
					],
					"members": {
						"GatewayARN": {},
						"VolumeSizeInBytes": {
							"type": "long"
						},
						"SnapshotId": {},
						"TargetName": {},
						"SourceVolumeARN": {},
						"NetworkInterfaceId": {},
						"ClientToken": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"TargetARN": {}
					}
				}
			},
			"CreateNFSFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"ClientToken",
						"GatewayARN",
						"Role",
						"LocationARN"
					],
					"members": {
						"ClientToken": {},
						"NFSFileShareDefaults": {
							"shape": "S1c"
						},
						"GatewayARN": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"Role": {},
						"LocationARN": {},
						"DefaultStorageClass": {},
						"ObjectACL": {},
						"ClientList": {
							"shape": "S1j"
						},
						"Squash": {},
						"ReadOnly": {
							"type": "boolean"
						},
						"GuessMIMETypeEnabled": {
							"type": "boolean"
						},
						"RequesterPays": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"CreateSMBFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"ClientToken",
						"GatewayARN",
						"Role",
						"LocationARN"
					],
					"members": {
						"ClientToken": {},
						"GatewayARN": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"Role": {},
						"LocationARN": {},
						"DefaultStorageClass": {},
						"ObjectACL": {},
						"ReadOnly": {
							"type": "boolean"
						},
						"GuessMIMETypeEnabled": {
							"type": "boolean"
						},
						"RequesterPays": {
							"type": "boolean"
						},
						"SMBACLEnabled": {
							"type": "boolean"
						},
						"AdminUserList": {
							"shape": "S1p"
						},
						"ValidUserList": {
							"shape": "S1p"
						},
						"InvalidUserList": {
							"shape": "S1p"
						},
						"Authentication": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"CreateSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN",
						"SnapshotDescription"
					],
					"members": {
						"VolumeARN": {},
						"SnapshotDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"SnapshotId": {}
					}
				}
			},
			"CreateSnapshotFromVolumeRecoveryPoint": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN",
						"SnapshotDescription"
					],
					"members": {
						"VolumeARN": {},
						"SnapshotDescription": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SnapshotId": {},
						"VolumeARN": {},
						"VolumeRecoveryPointTime": {}
					}
				}
			},
			"CreateStorediSCSIVolume": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskId",
						"PreserveExistingData",
						"TargetName",
						"NetworkInterfaceId"
					],
					"members": {
						"GatewayARN": {},
						"DiskId": {},
						"SnapshotId": {},
						"PreserveExistingData": {
							"type": "boolean"
						},
						"TargetName": {},
						"NetworkInterfaceId": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"VolumeSizeInBytes": {
							"type": "long"
						},
						"TargetARN": {}
					}
				}
			},
			"CreateTapeWithBarcode": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeSizeInBytes",
						"TapeBarcode"
					],
					"members": {
						"GatewayARN": {},
						"TapeSizeInBytes": {
							"type": "long"
						},
						"TapeBarcode": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"PoolId": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"CreateTapes": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeSizeInBytes",
						"ClientToken",
						"NumTapesToCreate",
						"TapeBarcodePrefix"
					],
					"members": {
						"GatewayARN": {},
						"TapeSizeInBytes": {
							"type": "long"
						},
						"ClientToken": {},
						"NumTapesToCreate": {
							"type": "integer"
						},
						"TapeBarcodePrefix": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"PoolId": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARNs": {
							"shape": "S2a"
						}
					}
				}
			},
			"DeleteBandwidthRateLimit": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"BandwidthType"
					],
					"members": {
						"GatewayARN": {},
						"BandwidthType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"DeleteChapCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"TargetARN",
						"InitiatorName"
					],
					"members": {
						"TargetARN": {},
						"InitiatorName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TargetARN": {},
						"InitiatorName": {}
					}
				}
			},
			"DeleteFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARN"
					],
					"members": {
						"FileShareARN": {},
						"ForceDelete": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"DeleteGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"DeleteSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {}
					}
				}
			},
			"DeleteTape": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"DeleteTapeArchive": {
				"input": {
					"type": "structure",
					"required": [
						"TapeARN"
					],
					"members": {
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"DeleteVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {}
					}
				}
			},
			"DescribeBandwidthRateLimit": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"AverageUploadRateLimitInBitsPerSec": {
							"type": "long"
						},
						"AverageDownloadRateLimitInBitsPerSec": {
							"type": "long"
						}
					}
				}
			},
			"DescribeCache": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sg"
						},
						"CacheAllocatedInBytes": {
							"type": "long"
						},
						"CacheUsedPercentage": {
							"type": "double"
						},
						"CacheDirtyPercentage": {
							"type": "double"
						},
						"CacheHitPercentage": {
							"type": "double"
						},
						"CacheMissPercentage": {
							"type": "double"
						}
					}
				}
			},
			"DescribeCachediSCSIVolumes": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARNs"
					],
					"members": {
						"VolumeARNs": {
							"shape": "S31"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CachediSCSIVolumes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeId": {},
									"VolumeType": {},
									"VolumeStatus": {},
									"VolumeAttachmentStatus": {},
									"VolumeSizeInBytes": {
										"type": "long"
									},
									"VolumeProgress": {
										"type": "double"
									},
									"SourceSnapshotId": {},
									"VolumeiSCSIAttributes": {
										"shape": "S3a"
									},
									"CreatedDate": {
										"type": "timestamp"
									},
									"VolumeUsedInBytes": {
										"type": "long"
									},
									"KMSKey": {},
									"TargetName": {}
								}
							}
						}
					}
				}
			},
			"DescribeChapCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"TargetARN"
					],
					"members": {
						"TargetARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChapCredentials": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TargetARN": {},
									"SecretToAuthenticateInitiator": {
										"shape": "S3j"
									},
									"InitiatorName": {},
									"SecretToAuthenticateTarget": {
										"shape": "S3j"
									}
								}
							}
						}
					}
				}
			},
			"DescribeGatewayInformation": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"GatewayId": {},
						"GatewayName": {},
						"GatewayTimezone": {},
						"GatewayState": {},
						"GatewayNetworkInterfaces": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Ipv4Address": {},
									"MacAddress": {},
									"Ipv6Address": {}
								}
							}
						},
						"GatewayType": {},
						"NextUpdateAvailabilityDate": {},
						"LastSoftwareUpdate": {},
						"Ec2InstanceId": {},
						"Ec2InstanceRegion": {},
						"Tags": {
							"shape": "S9"
						},
						"VPCEndpoint": {}
					}
				}
			},
			"DescribeMaintenanceStartTime": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"HourOfDay": {
							"type": "integer"
						},
						"MinuteOfHour": {
							"type": "integer"
						},
						"DayOfWeek": {
							"type": "integer"
						},
						"DayOfMonth": {
							"type": "integer"
						},
						"Timezone": {}
					}
				}
			},
			"DescribeNFSFileShares": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARNList"
					],
					"members": {
						"FileShareARNList": {
							"shape": "S41"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NFSFileShareInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"NFSFileShareDefaults": {
										"shape": "S1c"
									},
									"FileShareARN": {},
									"FileShareId": {},
									"FileShareStatus": {},
									"GatewayARN": {},
									"KMSEncrypted": {
										"type": "boolean"
									},
									"KMSKey": {},
									"Path": {},
									"Role": {},
									"LocationARN": {},
									"DefaultStorageClass": {},
									"ObjectACL": {},
									"ClientList": {
										"shape": "S1j"
									},
									"Squash": {},
									"ReadOnly": {
										"type": "boolean"
									},
									"GuessMIMETypeEnabled": {
										"type": "boolean"
									},
									"RequesterPays": {
										"type": "boolean"
									},
									"Tags": {
										"shape": "S9"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSMBFileShares": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARNList"
					],
					"members": {
						"FileShareARNList": {
							"shape": "S41"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SMBFileShareInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FileShareARN": {},
									"FileShareId": {},
									"FileShareStatus": {},
									"GatewayARN": {},
									"KMSEncrypted": {
										"type": "boolean"
									},
									"KMSKey": {},
									"Path": {},
									"Role": {},
									"LocationARN": {},
									"DefaultStorageClass": {},
									"ObjectACL": {},
									"ReadOnly": {
										"type": "boolean"
									},
									"GuessMIMETypeEnabled": {
										"type": "boolean"
									},
									"RequesterPays": {
										"type": "boolean"
									},
									"SMBACLEnabled": {
										"type": "boolean"
									},
									"AdminUserList": {
										"shape": "S1p"
									},
									"ValidUserList": {
										"shape": "S1p"
									},
									"InvalidUserList": {
										"shape": "S1p"
									},
									"Authentication": {},
									"Tags": {
										"shape": "S9"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSMBSettings": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"DomainName": {},
						"SMBGuestPasswordSet": {
							"type": "boolean"
						},
						"SMBSecurityStrategy": {}
					}
				}
			},
			"DescribeSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"StartAt": {
							"type": "integer"
						},
						"RecurrenceInHours": {
							"type": "integer"
						},
						"Description": {},
						"Timezone": {}
					}
				}
			},
			"DescribeStorediSCSIVolumes": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARNs"
					],
					"members": {
						"VolumeARNs": {
							"shape": "S31"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StorediSCSIVolumes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeId": {},
									"VolumeType": {},
									"VolumeStatus": {},
									"VolumeAttachmentStatus": {},
									"VolumeSizeInBytes": {
										"type": "long"
									},
									"VolumeProgress": {
										"type": "double"
									},
									"VolumeDiskId": {},
									"SourceSnapshotId": {},
									"PreservedExistingData": {
										"type": "boolean"
									},
									"VolumeiSCSIAttributes": {
										"shape": "S3a"
									},
									"CreatedDate": {
										"type": "timestamp"
									},
									"VolumeUsedInBytes": {
										"type": "long"
									},
									"KMSKey": {},
									"TargetName": {}
								}
							}
						}
					}
				}
			},
			"DescribeTapeArchives": {
				"input": {
					"type": "structure",
					"members": {
						"TapeARNs": {
							"shape": "S2a"
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeArchives": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeBarcode": {},
									"TapeCreatedDate": {
										"type": "timestamp"
									},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"CompletionTime": {
										"type": "timestamp"
									},
									"RetrievedTo": {},
									"TapeStatus": {},
									"TapeUsedInBytes": {
										"type": "long"
									},
									"KMSKey": {},
									"PoolId": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeTapeRecoveryPoints": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"TapeRecoveryPointInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeRecoveryPointTime": {
										"type": "timestamp"
									},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"TapeStatus": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeTapes": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARNs": {
							"shape": "S2a"
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tapes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeBarcode": {},
									"TapeCreatedDate": {
										"type": "timestamp"
									},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"TapeStatus": {},
									"VTLDevice": {},
									"Progress": {
										"type": "double"
									},
									"TapeUsedInBytes": {
										"type": "long"
									},
									"KMSKey": {},
									"PoolId": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeUploadBuffer": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sg"
						},
						"UploadBufferUsedInBytes": {
							"type": "long"
						},
						"UploadBufferAllocatedInBytes": {
							"type": "long"
						}
					}
				}
			},
			"DescribeVTLDevices": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"VTLDeviceARNs": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"VTLDevices": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VTLDeviceARN": {},
									"VTLDeviceType": {},
									"VTLDeviceVendor": {},
									"VTLDeviceProductIdentifier": {},
									"DeviceiSCSIAttributes": {
										"type": "structure",
										"members": {
											"TargetARN": {},
											"NetworkInterfaceId": {},
											"NetworkInterfacePort": {
												"type": "integer"
											},
											"ChapEnabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeWorkingStorage": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sg"
						},
						"WorkingStorageUsedInBytes": {
							"type": "long"
						},
						"WorkingStorageAllocatedInBytes": {
							"type": "long"
						}
					}
				}
			},
			"DetachVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {},
						"ForceDetach": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {}
					}
				}
			},
			"DisableGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"JoinDomain": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DomainName",
						"UserName",
						"Password"
					],
					"members": {
						"GatewayARN": {},
						"DomainName": {},
						"OrganizationalUnit": {},
						"DomainControllers": {
							"type": "list",
							"member": {}
						},
						"UserName": {},
						"Password": {
							"type": "string",
							"sensitive": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"ListFileShares": {
				"input": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Marker": {},
						"NextMarker": {},
						"FileShareInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FileShareType": {},
									"FileShareARN": {},
									"FileShareId": {},
									"FileShareStatus": {},
									"GatewayARN": {}
								}
							}
						}
					}
				}
			},
			"ListGateways": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Gateways": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GatewayId": {},
									"GatewayARN": {},
									"GatewayType": {},
									"GatewayOperationalState": {},
									"GatewayName": {},
									"Ec2InstanceId": {},
									"Ec2InstanceRegion": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListLocalDisks": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Disks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DiskId": {},
									"DiskPath": {},
									"DiskNode": {},
									"DiskStatus": {},
									"DiskSizeInBytes": {
										"type": "long"
									},
									"DiskAllocationType": {},
									"DiskAllocationResource": {},
									"DiskAttributeList": {
										"type": "list",
										"member": {}
									}
								}
							}
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN"
					],
					"members": {
						"ResourceARN": {},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceARN": {},
						"Marker": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"ListTapes": {
				"input": {
					"type": "structure",
					"members": {
						"TapeARNs": {
							"shape": "S2a"
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeBarcode": {},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"TapeStatus": {},
									"GatewayARN": {},
									"PoolId": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListVolumeInitiators": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Initiators": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ListVolumeRecoveryPoints": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"VolumeRecoveryPointInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeSizeInBytes": {
										"type": "long"
									},
									"VolumeUsageInBytes": {
										"type": "long"
									},
									"VolumeRecoveryPointTime": {}
								}
							}
						}
					}
				}
			},
			"ListVolumes": {
				"input": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Marker": {},
						"VolumeInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeId": {},
									"GatewayARN": {},
									"GatewayId": {},
									"VolumeType": {},
									"VolumeSizeInBytes": {
										"type": "long"
									},
									"VolumeAttachmentStatus": {}
								}
							}
						}
					}
				}
			},
			"NotifyWhenUploaded": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARN"
					],
					"members": {
						"FileShareARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {},
						"NotificationId": {}
					}
				}
			},
			"RefreshCache": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARN"
					],
					"members": {
						"FileShareARN": {},
						"FolderList": {
							"type": "list",
							"member": {}
						},
						"Recursive": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {},
						"NotificationId": {}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"TagKeys"
					],
					"members": {
						"ResourceARN": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceARN": {}
					}
				}
			},
			"ResetCache": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"RetrieveTapeArchive": {
				"input": {
					"type": "structure",
					"required": [
						"TapeARN",
						"GatewayARN"
					],
					"members": {
						"TapeARN": {},
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"RetrieveTapeRecoveryPoint": {
				"input": {
					"type": "structure",
					"required": [
						"TapeARN",
						"GatewayARN"
					],
					"members": {
						"TapeARN": {},
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"SetLocalConsolePassword": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"LocalConsolePassword"
					],
					"members": {
						"GatewayARN": {},
						"LocalConsolePassword": {
							"type": "string",
							"sensitive": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"SetSMBGuestPassword": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"Password"
					],
					"members": {
						"GatewayARN": {},
						"Password": {
							"type": "string",
							"sensitive": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"ShutdownGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"StartGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateBandwidthRateLimit": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"AverageUploadRateLimitInBitsPerSec": {
							"type": "long"
						},
						"AverageDownloadRateLimitInBitsPerSec": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateChapCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"TargetARN",
						"SecretToAuthenticateInitiator",
						"InitiatorName"
					],
					"members": {
						"TargetARN": {},
						"SecretToAuthenticateInitiator": {
							"shape": "S3j"
						},
						"InitiatorName": {},
						"SecretToAuthenticateTarget": {
							"shape": "S3j"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TargetARN": {},
						"InitiatorName": {}
					}
				}
			},
			"UpdateGatewayInformation": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"GatewayName": {},
						"GatewayTimezone": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"GatewayName": {}
					}
				}
			},
			"UpdateGatewaySoftwareNow": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateMaintenanceStartTime": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"HourOfDay",
						"MinuteOfHour"
					],
					"members": {
						"GatewayARN": {},
						"HourOfDay": {
							"type": "integer"
						},
						"MinuteOfHour": {
							"type": "integer"
						},
						"DayOfWeek": {
							"type": "integer"
						},
						"DayOfMonth": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateNFSFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARN"
					],
					"members": {
						"FileShareARN": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"NFSFileShareDefaults": {
							"shape": "S1c"
						},
						"DefaultStorageClass": {},
						"ObjectACL": {},
						"ClientList": {
							"shape": "S1j"
						},
						"Squash": {},
						"ReadOnly": {
							"type": "boolean"
						},
						"GuessMIMETypeEnabled": {
							"type": "boolean"
						},
						"RequesterPays": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"UpdateSMBFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARN"
					],
					"members": {
						"FileShareARN": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"DefaultStorageClass": {},
						"ObjectACL": {},
						"ReadOnly": {
							"type": "boolean"
						},
						"GuessMIMETypeEnabled": {
							"type": "boolean"
						},
						"RequesterPays": {
							"type": "boolean"
						},
						"SMBACLEnabled": {
							"type": "boolean"
						},
						"AdminUserList": {
							"shape": "S1p"
						},
						"ValidUserList": {
							"shape": "S1p"
						},
						"InvalidUserList": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"UpdateSMBSecurityStrategy": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"SMBSecurityStrategy"
					],
					"members": {
						"GatewayARN": {},
						"SMBSecurityStrategy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN",
						"StartAt",
						"RecurrenceInHours"
					],
					"members": {
						"VolumeARN": {},
						"StartAt": {
							"type": "integer"
						},
						"RecurrenceInHours": {
							"type": "integer"
						},
						"Description": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {}
					}
				}
			},
			"UpdateVTLDeviceType": {
				"input": {
					"type": "structure",
					"required": [
						"VTLDeviceARN",
						"DeviceType"
					],
					"members": {
						"VTLDeviceARN": {},
						"DeviceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VTLDeviceARN": {}
					}
				}
			}
		},
		"shapes": {
			"S9": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sg": {
				"type": "list",
				"member": {}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"FileMode": {},
					"DirectoryMode": {},
					"GroupId": {
						"type": "long"
					},
					"OwnerId": {
						"type": "long"
					}
				}
			},
			"S1j": {
				"type": "list",
				"member": {}
			},
			"S1p": {
				"type": "list",
				"member": {}
			},
			"S2a": {
				"type": "list",
				"member": {}
			},
			"S31": {
				"type": "list",
				"member": {}
			},
			"S3a": {
				"type": "structure",
				"members": {
					"TargetARN": {},
					"NetworkInterfaceId": {},
					"NetworkInterfacePort": {
						"type": "integer"
					},
					"LunNumber": {
						"type": "integer"
					},
					"ChapEnabled": {
						"type": "boolean"
					}
				}
			},
			"S3j": {
				"type": "string",
				"sensitive": true
			},
			"S41": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 1847 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeCachediSCSIVolumes": {
				"result_key": "CachediSCSIVolumes"
			},
			"DescribeStorediSCSIVolumes": {
				"result_key": "StorediSCSIVolumes"
			},
			"DescribeTapeArchives": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "TapeArchives"
			},
			"DescribeTapeRecoveryPoints": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "TapeRecoveryPointInfos"
			},
			"DescribeTapes": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "Tapes"
			},
			"DescribeVTLDevices": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "VTLDevices"
			},
			"ListFileShares": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"non_aggregate_keys": [
					"Marker"
				],
				"output_token": "NextMarker",
				"result_key": "FileShareInfoList"
			},
			"ListGateways": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "Gateways"
			},
			"ListLocalDisks": {
				"result_key": "Disks"
			},
			"ListTagsForResource": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"non_aggregate_keys": [
					"ResourceARN"
				],
				"output_token": "Marker",
				"result_key": "Tags"
			},
			"ListTapes": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "TapeInfos"
			},
			"ListVolumeRecoveryPoints": {
				"result_key": "VolumeRecoveryPointInfos"
			},
			"ListVolumes": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "VolumeInfos"
			}
		}
	};

/***/ },
/* 1848 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-08-10",
			"endpointPrefix": "streams.dynamodb",
			"jsonVersion": "1.0",
			"protocol": "json",
			"serviceFullName": "Amazon DynamoDB Streams",
			"serviceId": "DynamoDB Streams",
			"signatureVersion": "v4",
			"signingName": "dynamodb",
			"targetPrefix": "DynamoDBStreams_20120810",
			"uid": "streams-dynamodb-2012-08-10"
		},
		"operations": {
			"DescribeStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamArn"
					],
					"members": {
						"StreamArn": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartShardId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamDescription": {
							"type": "structure",
							"members": {
								"StreamArn": {},
								"StreamLabel": {},
								"StreamStatus": {},
								"StreamViewType": {},
								"CreationRequestDateTime": {
									"type": "timestamp"
								},
								"TableName": {},
								"KeySchema": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"AttributeName",
											"KeyType"
										],
										"members": {
											"AttributeName": {},
											"KeyType": {}
										}
									}
								},
								"Shards": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ShardId": {},
											"SequenceNumberRange": {
												"type": "structure",
												"members": {
													"StartingSequenceNumber": {},
													"EndingSequenceNumber": {}
												}
											},
											"ParentShardId": {}
										}
									}
								},
								"LastEvaluatedShardId": {}
							}
						}
					}
				}
			},
			"GetRecords": {
				"input": {
					"type": "structure",
					"required": [
						"ShardIterator"
					],
					"members": {
						"ShardIterator": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"eventID": {},
									"eventName": {},
									"eventVersion": {},
									"eventSource": {},
									"awsRegion": {},
									"dynamodb": {
										"type": "structure",
										"members": {
											"ApproximateCreationDateTime": {
												"type": "timestamp"
											},
											"Keys": {
												"shape": "Sr"
											},
											"NewImage": {
												"shape": "Sr"
											},
											"OldImage": {
												"shape": "Sr"
											},
											"SequenceNumber": {},
											"SizeBytes": {
												"type": "long"
											},
											"StreamViewType": {}
										}
									},
									"userIdentity": {
										"type": "structure",
										"members": {
											"PrincipalId": {},
											"Type": {}
										}
									}
								}
							}
						},
						"NextShardIterator": {}
					}
				}
			},
			"GetShardIterator": {
				"input": {
					"type": "structure",
					"required": [
						"StreamArn",
						"ShardId",
						"ShardIteratorType"
					],
					"members": {
						"StreamArn": {},
						"ShardId": {},
						"ShardIteratorType": {},
						"SequenceNumber": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ShardIterator": {}
					}
				}
			},
			"ListStreams": {
				"input": {
					"type": "structure",
					"members": {
						"TableName": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartStreamArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Streams": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StreamArn": {},
									"TableName": {},
									"StreamLabel": {}
								}
							}
						},
						"LastEvaluatedStreamArn": {}
					}
				}
			}
		},
		"shapes": {
			"Sr": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "St"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"S": {},
					"N": {},
					"B": {
						"type": "blob"
					},
					"SS": {
						"type": "list",
						"member": {}
					},
					"NS": {
						"type": "list",
						"member": {}
					},
					"BS": {
						"type": "list",
						"member": {
							"type": "blob"
						}
					},
					"M": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "St"
						}
					},
					"L": {
						"type": "list",
						"member": {
							"shape": "St"
						}
					},
					"NULL": {
						"type": "boolean"
					},
					"BOOL": {
						"type": "boolean"
					}
				}
			}
		}
	};

/***/ },
/* 1849 */
1641,
/* 1850 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-06-15",
			"endpointPrefix": "sts",
			"globalEndpoint": "sts.amazonaws.com",
			"protocol": "query",
			"serviceAbbreviation": "AWS STS",
			"serviceFullName": "AWS Security Token Service",
			"serviceId": "STS",
			"signatureVersion": "v4",
			"uid": "sts-2011-06-15",
			"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
		},
		"operations": {
			"AssumeRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						},
						"ExternalId": {},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"AssumedRoleUser": {
							"shape": "Sh"
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"AssumeRoleWithSAML": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"PrincipalArn",
						"SAMLAssertion"
					],
					"members": {
						"RoleArn": {},
						"PrincipalArn": {},
						"SAMLAssertion": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithSAMLResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"AssumedRoleUser": {
							"shape": "Sh"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Subject": {},
						"SubjectType": {},
						"Issuer": {},
						"Audience": {},
						"NameQualifier": {}
					}
				}
			},
			"AssumeRoleWithWebIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName",
						"WebIdentityToken"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"WebIdentityToken": {},
						"ProviderId": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithWebIdentityResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"SubjectFromWebIdentityToken": {},
						"AssumedRoleUser": {
							"shape": "Sh"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Provider": {},
						"Audience": {}
					}
				}
			},
			"DecodeAuthorizationMessage": {
				"input": {
					"type": "structure",
					"required": [
						"EncodedMessage"
					],
					"members": {
						"EncodedMessage": {}
					}
				},
				"output": {
					"resultWrapper": "DecodeAuthorizationMessageResult",
					"type": "structure",
					"members": {
						"DecodedMessage": {}
					}
				}
			},
			"GetAccessKeyInfo": {
				"input": {
					"type": "structure",
					"required": [
						"AccessKeyId"
					],
					"members": {
						"AccessKeyId": {}
					}
				},
				"output": {
					"resultWrapper": "GetAccessKeyInfoResult",
					"type": "structure",
					"members": {
						"Account": {}
					}
				}
			},
			"GetCallerIdentity": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "GetCallerIdentityResult",
					"type": "structure",
					"members": {
						"UserId": {},
						"Account": {},
						"Arn": {}
					}
				}
			},
			"GetFederationToken": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Policy": {},
						"PolicyArns": {
							"shape": "S4"
						},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "GetFederationTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						},
						"FederatedUser": {
							"type": "structure",
							"required": [
								"FederatedUserId",
								"Arn"
							],
							"members": {
								"FederatedUserId": {},
								"Arn": {}
							}
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"GetSessionToken": {
				"input": {
					"type": "structure",
					"members": {
						"DurationSeconds": {
							"type": "integer"
						},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "GetSessionTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sc"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"arn": {}
					}
				}
			},
			"Sc": {
				"type": "structure",
				"required": [
					"AccessKeyId",
					"SecretAccessKey",
					"SessionToken",
					"Expiration"
				],
				"members": {
					"AccessKeyId": {},
					"SecretAccessKey": {},
					"SessionToken": {},
					"Expiration": {
						"type": "timestamp"
					}
				}
			},
			"Sh": {
				"type": "structure",
				"required": [
					"AssumedRoleId",
					"Arn"
				],
				"members": {
					"AssumedRoleId": {},
					"Arn": {}
				}
			}
		}
	};

/***/ },
/* 1851 */
1641,
/* 1852 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-07-01",
			"endpointPrefix": "translate",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Translate",
			"serviceId": "Translate",
			"signatureVersion": "v4",
			"signingName": "translate",
			"targetPrefix": "AWSShineFrontendService_20170701",
			"uid": "translate-2017-07-01"
		},
		"operations": {
			"DeleteTerminology": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				}
			},
			"GetTerminology": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"TerminologyDataFormat"
					],
					"members": {
						"Name": {},
						"TerminologyDataFormat": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TerminologyProperties": {
							"shape": "S6"
						},
						"TerminologyDataLocation": {
							"type": "structure",
							"required": [
								"RepositoryType",
								"Location"
							],
							"members": {
								"RepositoryType": {},
								"Location": {}
							}
						}
					}
				}
			},
			"ImportTerminology": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"MergeStrategy",
						"TerminologyData"
					],
					"members": {
						"Name": {},
						"MergeStrategy": {},
						"Description": {},
						"TerminologyData": {
							"type": "structure",
							"required": [
								"File",
								"Format"
							],
							"members": {
								"File": {
									"type": "blob",
									"sensitive": true
								},
								"Format": {}
							}
						},
						"EncryptionKey": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TerminologyProperties": {
							"shape": "S6"
						}
					}
				}
			},
			"ListTerminologies": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TerminologyPropertiesList": {
							"type": "list",
							"member": {
								"shape": "S6"
							}
						},
						"NextToken": {}
					}
				}
			},
			"TranslateText": {
				"input": {
					"type": "structure",
					"required": [
						"Text",
						"SourceLanguageCode",
						"TargetLanguageCode"
					],
					"members": {
						"Text": {},
						"TerminologyNames": {
							"type": "list",
							"member": {}
						},
						"SourceLanguageCode": {},
						"TargetLanguageCode": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TranslatedText",
						"SourceLanguageCode",
						"TargetLanguageCode"
					],
					"members": {
						"TranslatedText": {},
						"SourceLanguageCode": {},
						"TargetLanguageCode": {},
						"AppliedTerminologies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Terms": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"SourceText": {},
												"TargetText": {}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "structure",
				"members": {
					"Name": {},
					"Description": {},
					"Arn": {},
					"SourceLanguageCode": {},
					"TargetLanguageCodes": {
						"type": "list",
						"member": {}
					},
					"EncryptionKey": {
						"shape": "Sb"
					},
					"SizeBytes": {
						"type": "integer"
					},
					"TermCount": {
						"type": "integer"
					},
					"CreatedAt": {
						"type": "timestamp"
					},
					"LastUpdatedAt": {
						"type": "timestamp"
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Type",
					"Id"
				],
				"members": {
					"Type": {},
					"Id": {}
				}
			}
		}
	};

/***/ },
/* 1853 */
1641,
/* 1854 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-08-24",
			"endpointPrefix": "waf",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "WAF",
			"serviceFullName": "AWS WAF",
			"serviceId": "WAF",
			"signatureVersion": "v4",
			"targetPrefix": "AWSWAF_20150824",
			"uid": "waf-2015-08-24"
		},
		"operations": {
			"CreateByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByteMatchSet": {
							"shape": "S5"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateGeoMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GeoMatchSet": {
							"shape": "Sh"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IPSet": {
							"shape": "So"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateRateBasedRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"MetricName",
						"RateKey",
						"RateLimit",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"MetricName": {},
						"RateKey": {},
						"RateLimit": {
							"type": "long"
						},
						"ChangeToken": {},
						"Tags": {
							"shape": "Sx"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "S12"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateRegexMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RegexMatchSet": {
							"shape": "S19"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateRegexPatternSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RegexPatternSet": {
							"shape": "S1e"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"MetricName",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"MetricName": {},
						"ChangeToken": {},
						"Tags": {
							"shape": "Sx"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "S1j"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateRuleGroup": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"MetricName",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"MetricName": {},
						"ChangeToken": {},
						"Tags": {
							"shape": "Sx"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuleGroup": {
							"shape": "S1m"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SizeConstraintSet": {
							"shape": "S1p"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SqlInjectionMatchSet": {
							"shape": "S1w"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"MetricName",
						"DefaultAction",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"MetricName": {},
						"DefaultAction": {
							"shape": "S20"
						},
						"ChangeToken": {},
						"Tags": {
							"shape": "Sx"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WebACL": {
							"shape": "S23"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"XssMatchSet": {
							"shape": "S2f"
						},
						"ChangeToken": {}
					}
				}
			},
			"DeleteByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"ByteMatchSetId",
						"ChangeToken"
					],
					"members": {
						"ByteMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteGeoMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"GeoMatchSetId",
						"ChangeToken"
					],
					"members": {
						"GeoMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"IPSetId",
						"ChangeToken"
					],
					"members": {
						"IPSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteLoggingConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePermissionPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRateBasedRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId",
						"ChangeToken"
					],
					"members": {
						"RuleId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteRegexMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"RegexMatchSetId",
						"ChangeToken"
					],
					"members": {
						"RegexMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteRegexPatternSet": {
				"input": {
					"type": "structure",
					"required": [
						"RegexPatternSetId",
						"ChangeToken"
					],
					"members": {
						"RegexPatternSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId",
						"ChangeToken"
					],
					"members": {
						"RuleId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteRuleGroup": {
				"input": {
					"type": "structure",
					"required": [
						"RuleGroupId",
						"ChangeToken"
					],
					"members": {
						"RuleGroupId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"SizeConstraintSetId",
						"ChangeToken"
					],
					"members": {
						"SizeConstraintSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"SqlInjectionMatchSetId",
						"ChangeToken"
					],
					"members": {
						"SqlInjectionMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"WebACLId",
						"ChangeToken"
					],
					"members": {
						"WebACLId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"XssMatchSetId",
						"ChangeToken"
					],
					"members": {
						"XssMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"GetByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"ByteMatchSetId"
					],
					"members": {
						"ByteMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByteMatchSet": {
							"shape": "S5"
						}
					}
				}
			},
			"GetChangeToken": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"GetChangeTokenStatus": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeToken"
					],
					"members": {
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeTokenStatus": {}
					}
				}
			},
			"GetGeoMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"GeoMatchSetId"
					],
					"members": {
						"GeoMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GeoMatchSet": {
							"shape": "Sh"
						}
					}
				}
			},
			"GetIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"IPSetId"
					],
					"members": {
						"IPSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IPSet": {
							"shape": "So"
						}
					}
				}
			},
			"GetLoggingConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoggingConfiguration": {
							"shape": "S3n"
						}
					}
				}
			},
			"GetPermissionPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {}
					}
				}
			},
			"GetRateBasedRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId"
					],
					"members": {
						"RuleId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "S12"
						}
					}
				}
			},
			"GetRateBasedRuleManagedKeys": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId"
					],
					"members": {
						"RuleId": {},
						"NextMarker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ManagedKeys": {
							"type": "list",
							"member": {}
						},
						"NextMarker": {}
					}
				}
			},
			"GetRegexMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"RegexMatchSetId"
					],
					"members": {
						"RegexMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RegexMatchSet": {
							"shape": "S19"
						}
					}
				}
			},
			"GetRegexPatternSet": {
				"input": {
					"type": "structure",
					"required": [
						"RegexPatternSetId"
					],
					"members": {
						"RegexPatternSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RegexPatternSet": {
							"shape": "S1e"
						}
					}
				}
			},
			"GetRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId"
					],
					"members": {
						"RuleId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "S1j"
						}
					}
				}
			},
			"GetRuleGroup": {
				"input": {
					"type": "structure",
					"required": [
						"RuleGroupId"
					],
					"members": {
						"RuleGroupId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuleGroup": {
							"shape": "S1m"
						}
					}
				}
			},
			"GetSampledRequests": {
				"input": {
					"type": "structure",
					"required": [
						"WebAclId",
						"RuleId",
						"TimeWindow",
						"MaxItems"
					],
					"members": {
						"WebAclId": {},
						"RuleId": {},
						"TimeWindow": {
							"shape": "S49"
						},
						"MaxItems": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SampledRequests": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Request",
									"Weight"
								],
								"members": {
									"Request": {
										"type": "structure",
										"members": {
											"ClientIP": {},
											"Country": {},
											"URI": {},
											"Method": {},
											"HTTPVersion": {},
											"Headers": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"Name": {},
														"Value": {}
													}
												}
											}
										}
									},
									"Weight": {
										"type": "long"
									},
									"Timestamp": {
										"type": "timestamp"
									},
									"Action": {},
									"RuleWithinRuleGroup": {}
								}
							}
						},
						"PopulationSize": {
							"type": "long"
						},
						"TimeWindow": {
							"shape": "S49"
						}
					}
				}
			},
			"GetSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"SizeConstraintSetId"
					],
					"members": {
						"SizeConstraintSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SizeConstraintSet": {
							"shape": "S1p"
						}
					}
				}
			},
			"GetSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"SqlInjectionMatchSetId"
					],
					"members": {
						"SqlInjectionMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SqlInjectionMatchSet": {
							"shape": "S1w"
						}
					}
				}
			},
			"GetWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"WebACLId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WebACL": {
							"shape": "S23"
						}
					}
				}
			},
			"GetXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"XssMatchSetId"
					],
					"members": {
						"XssMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"XssMatchSet": {
							"shape": "S2f"
						}
					}
				}
			},
			"ListActivatedRulesInRuleGroup": {
				"input": {
					"type": "structure",
					"members": {
						"RuleGroupId": {},
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"ActivatedRules": {
							"shape": "S24"
						}
					}
				}
			},
			"ListByteMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"ByteMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ByteMatchSetId",
									"Name"
								],
								"members": {
									"ByteMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListGeoMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"GeoMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"GeoMatchSetId",
									"Name"
								],
								"members": {
									"GeoMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListIPSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"IPSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IPSetId",
									"Name"
								],
								"members": {
									"IPSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListLoggingConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoggingConfigurations": {
							"type": "list",
							"member": {
								"shape": "S3n"
							}
						},
						"NextMarker": {}
					}
				}
			},
			"ListRateBasedRules": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Rules": {
							"shape": "S5k"
						}
					}
				}
			},
			"ListRegexMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"RegexMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"RegexMatchSetId",
									"Name"
								],
								"members": {
									"RegexMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListRegexPatternSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"RegexPatternSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"RegexPatternSetId",
									"Name"
								],
								"members": {
									"RegexPatternSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListRuleGroups": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"RuleGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"RuleGroupId",
									"Name"
								],
								"members": {
									"RuleGroupId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListRules": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Rules": {
							"shape": "S5k"
						}
					}
				}
			},
			"ListSizeConstraintSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"SizeConstraintSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"SizeConstraintSetId",
									"Name"
								],
								"members": {
									"SizeConstraintSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListSqlInjectionMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"SqlInjectionMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"SqlInjectionMatchSetId",
									"Name"
								],
								"members": {
									"SqlInjectionMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListSubscribedRuleGroups": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"RuleGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"RuleGroupId",
									"Name",
									"MetricName"
								],
								"members": {
									"RuleGroupId": {},
									"Name": {},
									"MetricName": {}
								}
							}
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN"
					],
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						},
						"ResourceARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"TagInfoForResource": {
							"type": "structure",
							"members": {
								"ResourceARN": {},
								"TagList": {
									"shape": "Sx"
								}
							}
						}
					}
				}
			},
			"ListWebACLs": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"WebACLs": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"WebACLId",
									"Name"
								],
								"members": {
									"WebACLId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListXssMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"XssMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"XssMatchSetId",
									"Name"
								],
								"members": {
									"XssMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"PutLoggingConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"LoggingConfiguration"
					],
					"members": {
						"LoggingConfiguration": {
							"shape": "S3n"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoggingConfiguration": {
							"shape": "S3n"
						}
					}
				}
			},
			"PutPermissionPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Policy"
					],
					"members": {
						"ResourceArn": {},
						"Policy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"Tags"
					],
					"members": {
						"ResourceARN": {},
						"Tags": {
							"shape": "Sx"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"TagKeys"
					],
					"members": {
						"ResourceARN": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"ByteMatchSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"ByteMatchSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"ByteMatchTuple"
								],
								"members": {
									"Action": {},
									"ByteMatchTuple": {
										"shape": "S8"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateGeoMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"GeoMatchSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"GeoMatchSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"GeoMatchConstraint"
								],
								"members": {
									"Action": {},
									"GeoMatchConstraint": {
										"shape": "Sj"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"IPSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"IPSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"IPSetDescriptor"
								],
								"members": {
									"Action": {},
									"IPSetDescriptor": {
										"shape": "Sq"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateRateBasedRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId",
						"ChangeToken",
						"Updates",
						"RateLimit"
					],
					"members": {
						"RuleId": {},
						"ChangeToken": {},
						"Updates": {
							"shape": "S7a"
						},
						"RateLimit": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateRegexMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"RegexMatchSetId",
						"Updates",
						"ChangeToken"
					],
					"members": {
						"RegexMatchSetId": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"RegexMatchTuple"
								],
								"members": {
									"Action": {},
									"RegexMatchTuple": {
										"shape": "S1b"
									}
								}
							}
						},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateRegexPatternSet": {
				"input": {
					"type": "structure",
					"required": [
						"RegexPatternSetId",
						"Updates",
						"ChangeToken"
					],
					"members": {
						"RegexPatternSetId": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"RegexPatternString"
								],
								"members": {
									"Action": {},
									"RegexPatternString": {}
								}
							}
						},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"RuleId": {},
						"ChangeToken": {},
						"Updates": {
							"shape": "S7a"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateRuleGroup": {
				"input": {
					"type": "structure",
					"required": [
						"RuleGroupId",
						"Updates",
						"ChangeToken"
					],
					"members": {
						"RuleGroupId": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"ActivatedRule"
								],
								"members": {
									"Action": {},
									"ActivatedRule": {
										"shape": "S25"
									}
								}
							}
						},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"SizeConstraintSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"SizeConstraintSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"SizeConstraint"
								],
								"members": {
									"Action": {},
									"SizeConstraint": {
										"shape": "S1r"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"SqlInjectionMatchSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"SqlInjectionMatchSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"SqlInjectionMatchTuple"
								],
								"members": {
									"Action": {},
									"SqlInjectionMatchTuple": {
										"shape": "S1y"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"WebACLId",
						"ChangeToken"
					],
					"members": {
						"WebACLId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"ActivatedRule"
								],
								"members": {
									"Action": {},
									"ActivatedRule": {
										"shape": "S25"
									}
								}
							}
						},
						"DefaultAction": {
							"shape": "S20"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"XssMatchSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"XssMatchSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"XssMatchTuple"
								],
								"members": {
									"Action": {},
									"XssMatchTuple": {
										"shape": "S2h"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "structure",
				"required": [
					"ByteMatchSetId",
					"ByteMatchTuples"
				],
				"members": {
					"ByteMatchSetId": {},
					"Name": {},
					"ByteMatchTuples": {
						"type": "list",
						"member": {
							"shape": "S8"
						}
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TargetString",
					"TextTransformation",
					"PositionalConstraint"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TargetString": {
						"type": "blob"
					},
					"TextTransformation": {},
					"PositionalConstraint": {}
				}
			},
			"S9": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {},
					"Data": {}
				}
			},
			"Sh": {
				"type": "structure",
				"required": [
					"GeoMatchSetId",
					"GeoMatchConstraints"
				],
				"members": {
					"GeoMatchSetId": {},
					"Name": {},
					"GeoMatchConstraints": {
						"type": "list",
						"member": {
							"shape": "Sj"
						}
					}
				}
			},
			"Sj": {
				"type": "structure",
				"required": [
					"Type",
					"Value"
				],
				"members": {
					"Type": {},
					"Value": {}
				}
			},
			"So": {
				"type": "structure",
				"required": [
					"IPSetId",
					"IPSetDescriptors"
				],
				"members": {
					"IPSetId": {},
					"Name": {},
					"IPSetDescriptors": {
						"type": "list",
						"member": {
							"shape": "Sq"
						}
					}
				}
			},
			"Sq": {
				"type": "structure",
				"required": [
					"Type",
					"Value"
				],
				"members": {
					"Type": {},
					"Value": {}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"RuleId",
					"MatchPredicates",
					"RateKey",
					"RateLimit"
				],
				"members": {
					"RuleId": {},
					"Name": {},
					"MetricName": {},
					"MatchPredicates": {
						"shape": "S13"
					},
					"RateKey": {},
					"RateLimit": {
						"type": "long"
					}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"shape": "S14"
				}
			},
			"S14": {
				"type": "structure",
				"required": [
					"Negated",
					"Type",
					"DataId"
				],
				"members": {
					"Negated": {
						"type": "boolean"
					},
					"Type": {},
					"DataId": {}
				}
			},
			"S19": {
				"type": "structure",
				"members": {
					"RegexMatchSetId": {},
					"Name": {},
					"RegexMatchTuples": {
						"type": "list",
						"member": {
							"shape": "S1b"
						}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TextTransformation",
					"RegexPatternSetId"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TextTransformation": {},
					"RegexPatternSetId": {}
				}
			},
			"S1e": {
				"type": "structure",
				"required": [
					"RegexPatternSetId",
					"RegexPatternStrings"
				],
				"members": {
					"RegexPatternSetId": {},
					"Name": {},
					"RegexPatternStrings": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S1j": {
				"type": "structure",
				"required": [
					"RuleId",
					"Predicates"
				],
				"members": {
					"RuleId": {},
					"Name": {},
					"MetricName": {},
					"Predicates": {
						"shape": "S13"
					}
				}
			},
			"S1m": {
				"type": "structure",
				"required": [
					"RuleGroupId"
				],
				"members": {
					"RuleGroupId": {},
					"Name": {},
					"MetricName": {}
				}
			},
			"S1p": {
				"type": "structure",
				"required": [
					"SizeConstraintSetId",
					"SizeConstraints"
				],
				"members": {
					"SizeConstraintSetId": {},
					"Name": {},
					"SizeConstraints": {
						"type": "list",
						"member": {
							"shape": "S1r"
						}
					}
				}
			},
			"S1r": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TextTransformation",
					"ComparisonOperator",
					"Size"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TextTransformation": {},
					"ComparisonOperator": {},
					"Size": {
						"type": "long"
					}
				}
			},
			"S1w": {
				"type": "structure",
				"required": [
					"SqlInjectionMatchSetId",
					"SqlInjectionMatchTuples"
				],
				"members": {
					"SqlInjectionMatchSetId": {},
					"Name": {},
					"SqlInjectionMatchTuples": {
						"type": "list",
						"member": {
							"shape": "S1y"
						}
					}
				}
			},
			"S1y": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TextTransformation"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TextTransformation": {}
				}
			},
			"S20": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {}
				}
			},
			"S23": {
				"type": "structure",
				"required": [
					"WebACLId",
					"DefaultAction",
					"Rules"
				],
				"members": {
					"WebACLId": {},
					"Name": {},
					"MetricName": {},
					"DefaultAction": {
						"shape": "S20"
					},
					"Rules": {
						"shape": "S24"
					},
					"WebACLArn": {}
				}
			},
			"S24": {
				"type": "list",
				"member": {
					"shape": "S25"
				}
			},
			"S25": {
				"type": "structure",
				"required": [
					"Priority",
					"RuleId"
				],
				"members": {
					"Priority": {
						"type": "integer"
					},
					"RuleId": {},
					"Action": {
						"shape": "S20"
					},
					"OverrideAction": {
						"type": "structure",
						"required": [
							"Type"
						],
						"members": {
							"Type": {}
						}
					},
					"Type": {},
					"ExcludedRules": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"RuleId"
							],
							"members": {
								"RuleId": {}
							}
						}
					}
				}
			},
			"S2f": {
				"type": "structure",
				"required": [
					"XssMatchSetId",
					"XssMatchTuples"
				],
				"members": {
					"XssMatchSetId": {},
					"Name": {},
					"XssMatchTuples": {
						"type": "list",
						"member": {
							"shape": "S2h"
						}
					}
				}
			},
			"S2h": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TextTransformation"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TextTransformation": {}
				}
			},
			"S3n": {
				"type": "structure",
				"required": [
					"ResourceArn",
					"LogDestinationConfigs"
				],
				"members": {
					"ResourceArn": {},
					"LogDestinationConfigs": {
						"type": "list",
						"member": {}
					},
					"RedactedFields": {
						"type": "list",
						"member": {
							"shape": "S9"
						}
					}
				}
			},
			"S49": {
				"type": "structure",
				"required": [
					"StartTime",
					"EndTime"
				],
				"members": {
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					}
				}
			},
			"S5k": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"RuleId",
						"Name"
					],
					"members": {
						"RuleId": {},
						"Name": {}
					}
				}
			},
			"S7a": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Action",
						"Predicate"
					],
					"members": {
						"Action": {},
						"Predicate": {
							"shape": "S14"
						}
					}
				}
			}
		}
	};

/***/ },
/* 1855 */
1641,
/* 1856 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-05-01",
			"endpointPrefix": "workdocs",
			"jsonVersion": "1.1",
			"protocol": "rest-json",
			"serviceFullName": "Amazon WorkDocs",
			"serviceId": "WorkDocs",
			"signatureVersion": "v4",
			"uid": "workdocs-2016-05-01"
		},
		"operations": {
			"AbortDocumentVersionUpload": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId",
						"VersionId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"VersionId": {
							"location": "uri",
							"locationName": "VersionId"
						}
					}
				}
			},
			"ActivateUser": {
				"http": {
					"requestUri": "/api/v1/users/{UserId}/activation",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"UserId"
					],
					"members": {
						"UserId": {
							"location": "uri",
							"locationName": "UserId"
						},
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"User": {
							"shape": "S8"
						}
					}
				}
			},
			"AddResourcePermissions": {
				"http": {
					"requestUri": "/api/v1/resources/{ResourceId}/permissions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"Principals"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"Principals": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Id",
									"Type",
									"Role"
								],
								"members": {
									"Id": {},
									"Type": {},
									"Role": {}
								}
							}
						},
						"NotificationOptions": {
							"type": "structure",
							"members": {
								"SendEmail": {
									"type": "boolean"
								},
								"EmailMessage": {
									"shape": "St"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ShareResults": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PrincipalId": {},
									"InviteePrincipalId": {},
									"Role": {},
									"Status": {},
									"ShareId": {},
									"StatusMessage": {
										"shape": "St"
									}
								}
							}
						}
					}
				}
			},
			"CreateComment": {
				"http": {
					"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId",
						"VersionId",
						"Text"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"VersionId": {
							"location": "uri",
							"locationName": "VersionId"
						},
						"ParentId": {},
						"ThreadId": {},
						"Text": {
							"shape": "S10"
						},
						"Visibility": {},
						"NotifyCollaborators": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Comment": {
							"shape": "S13"
						}
					}
				}
			},
			"CreateCustomMetadata": {
				"http": {
					"method": "PUT",
					"requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"CustomMetadata"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionid"
						},
						"CustomMetadata": {
							"shape": "S16"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateFolder": {
				"http": {
					"requestUri": "/api/v1/folders",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"ParentFolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"Name": {},
						"ParentFolderId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S1d"
						}
					}
				}
			},
			"CreateLabels": {
				"http": {
					"method": "PUT",
					"requestUri": "/api/v1/resources/{ResourceId}/labels",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"Labels"
					],
					"members": {
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"Labels": {
							"shape": "S1g"
						},
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateNotificationSubscription": {
				"http": {
					"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"OrganizationId",
						"Endpoint",
						"Protocol",
						"SubscriptionType"
					],
					"members": {
						"OrganizationId": {
							"location": "uri",
							"locationName": "OrganizationId"
						},
						"Endpoint": {},
						"Protocol": {},
						"SubscriptionType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Subscription": {
							"shape": "S1p"
						}
					}
				}
			},
			"CreateUser": {
				"http": {
					"requestUri": "/api/v1/users",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"Username",
						"GivenName",
						"Surname",
						"Password"
					],
					"members": {
						"OrganizationId": {},
						"Username": {},
						"EmailAddress": {},
						"GivenName": {},
						"Surname": {},
						"Password": {
							"type": "string",
							"sensitive": true
						},
						"TimeZoneId": {},
						"StorageRule": {
							"shape": "Sj"
						},
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"User": {
							"shape": "S8"
						}
					}
				}
			},
			"DeactivateUser": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/users/{UserId}/activation",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"UserId"
					],
					"members": {
						"UserId": {
							"location": "uri",
							"locationName": "UserId"
						},
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						}
					}
				}
			},
			"DeleteComment": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId",
						"VersionId",
						"CommentId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"VersionId": {
							"location": "uri",
							"locationName": "VersionId"
						},
						"CommentId": {
							"location": "uri",
							"locationName": "CommentId"
						}
					}
				}
			},
			"DeleteCustomMetadata": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/resources/{ResourceId}/customMetadata",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"Keys": {
							"location": "querystring",
							"locationName": "keys",
							"type": "list",
							"member": {}
						},
						"DeleteAll": {
							"location": "querystring",
							"locationName": "deleteAll",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteDocument": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/documents/{DocumentId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						}
					}
				}
			},
			"DeleteFolder": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/folders/{FolderId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"FolderId": {
							"location": "uri",
							"locationName": "FolderId"
						}
					}
				}
			},
			"DeleteFolderContents": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/folders/{FolderId}/contents",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"FolderId": {
							"location": "uri",
							"locationName": "FolderId"
						}
					}
				}
			},
			"DeleteLabels": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/resources/{ResourceId}/labels",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"Labels": {
							"shape": "S1g",
							"location": "querystring",
							"locationName": "labels"
						},
						"DeleteAll": {
							"location": "querystring",
							"locationName": "deleteAll",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteNotificationSubscription": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionId",
						"OrganizationId"
					],
					"members": {
						"SubscriptionId": {
							"location": "uri",
							"locationName": "SubscriptionId"
						},
						"OrganizationId": {
							"location": "uri",
							"locationName": "OrganizationId"
						}
					}
				}
			},
			"DeleteUser": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/users/{UserId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"UserId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"UserId": {
							"location": "uri",
							"locationName": "UserId"
						}
					}
				}
			},
			"DescribeActivities": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/activities",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"StartTime": {
							"location": "querystring",
							"locationName": "startTime",
							"type": "timestamp"
						},
						"EndTime": {
							"location": "querystring",
							"locationName": "endTime",
							"type": "timestamp"
						},
						"OrganizationId": {
							"location": "querystring",
							"locationName": "organizationId"
						},
						"ActivityTypes": {
							"location": "querystring",
							"locationName": "activityTypes"
						},
						"ResourceId": {
							"location": "querystring",
							"locationName": "resourceId"
						},
						"UserId": {
							"location": "querystring",
							"locationName": "userId"
						},
						"IncludeIndirectActivities": {
							"location": "querystring",
							"locationName": "includeIndirectActivities",
							"type": "boolean"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserActivities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"TimeStamp": {
										"type": "timestamp"
									},
									"IsIndirectActivity": {
										"type": "boolean"
									},
									"OrganizationId": {},
									"Initiator": {
										"shape": "S2d"
									},
									"Participants": {
										"type": "structure",
										"members": {
											"Users": {
												"type": "list",
												"member": {
													"shape": "S2d"
												}
											},
											"Groups": {
												"shape": "S2g"
											}
										}
									},
									"ResourceMetadata": {
										"shape": "S2j"
									},
									"OriginalParent": {
										"shape": "S2j"
									},
									"CommentMetadata": {
										"type": "structure",
										"members": {
											"CommentId": {},
											"Contributor": {
												"shape": "S8"
											},
											"CreatedTimestamp": {
												"type": "timestamp"
											},
											"CommentStatus": {},
											"RecipientId": {}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeComments": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}/comments",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId",
						"VersionId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"VersionId": {
							"location": "uri",
							"locationName": "VersionId"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Comments": {
							"type": "list",
							"member": {
								"shape": "S13"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDocumentVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/documents/{DocumentId}/versions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Include": {
							"location": "querystring",
							"locationName": "include"
						},
						"Fields": {
							"location": "querystring",
							"locationName": "fields"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentVersions": {
							"type": "list",
							"member": {
								"shape": "S2u"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeFolderContents": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/folders/{FolderId}/contents",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"FolderId": {
							"location": "uri",
							"locationName": "FolderId"
						},
						"Sort": {
							"location": "querystring",
							"locationName": "sort"
						},
						"Order": {
							"location": "querystring",
							"locationName": "order"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"Type": {
							"location": "querystring",
							"locationName": "type"
						},
						"Include": {
							"location": "querystring",
							"locationName": "include"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Folders": {
							"shape": "S37"
						},
						"Documents": {
							"shape": "S38"
						},
						"Marker": {}
					}
				}
			},
			"DescribeGroups": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/groups",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"SearchQuery"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"SearchQuery": {
							"shape": "S3b",
							"location": "querystring",
							"locationName": "searchQuery"
						},
						"OrganizationId": {
							"location": "querystring",
							"locationName": "organizationId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "S2g"
						},
						"Marker": {}
					}
				}
			},
			"DescribeNotificationSubscriptions": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/organizations/{OrganizationId}/subscriptions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"OrganizationId"
					],
					"members": {
						"OrganizationId": {
							"location": "uri",
							"locationName": "OrganizationId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Subscriptions": {
							"type": "list",
							"member": {
								"shape": "S1p"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeResourcePermissions": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/resources/{ResourceId}/permissions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"PrincipalId": {
							"location": "querystring",
							"locationName": "principalId"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Principals": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Type": {},
									"Roles": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Role": {},
												"Type": {}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeRootFolders": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/me/root",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"AuthenticationToken"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Folders": {
							"shape": "S37"
						},
						"Marker": {}
					}
				}
			},
			"DescribeUsers": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/users",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"OrganizationId": {
							"location": "querystring",
							"locationName": "organizationId"
						},
						"UserIds": {
							"location": "querystring",
							"locationName": "userIds"
						},
						"Query": {
							"shape": "S3b",
							"location": "querystring",
							"locationName": "query"
						},
						"Include": {
							"location": "querystring",
							"locationName": "include"
						},
						"Order": {
							"location": "querystring",
							"locationName": "order"
						},
						"Sort": {
							"location": "querystring",
							"locationName": "sort"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Fields": {
							"location": "querystring",
							"locationName": "fields"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Users": {
							"type": "list",
							"member": {
								"shape": "S8"
							}
						},
						"TotalNumberOfUsers": {
							"deprecated": true,
							"type": "long"
						},
						"Marker": {}
					}
				}
			},
			"GetCurrentUser": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/me",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"AuthenticationToken"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"User": {
							"shape": "S8"
						}
					}
				}
			},
			"GetDocument": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/documents/{DocumentId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"IncludeCustomMetadata": {
							"location": "querystring",
							"locationName": "includeCustomMetadata",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S39"
						},
						"CustomMetadata": {
							"shape": "S16"
						}
					}
				}
			},
			"GetDocumentPath": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/documents/{DocumentId}/path",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Fields": {
							"location": "querystring",
							"locationName": "fields"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Path": {
							"shape": "S42"
						}
					}
				}
			},
			"GetDocumentVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId",
						"VersionId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"VersionId": {
							"location": "uri",
							"locationName": "VersionId"
						},
						"Fields": {
							"location": "querystring",
							"locationName": "fields"
						},
						"IncludeCustomMetadata": {
							"location": "querystring",
							"locationName": "includeCustomMetadata",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S2u"
						},
						"CustomMetadata": {
							"shape": "S16"
						}
					}
				}
			},
			"GetFolder": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/folders/{FolderId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"FolderId": {
							"location": "uri",
							"locationName": "FolderId"
						},
						"IncludeCustomMetadata": {
							"location": "querystring",
							"locationName": "includeCustomMetadata",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S1d"
						},
						"CustomMetadata": {
							"shape": "S16"
						}
					}
				}
			},
			"GetFolderPath": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/folders/{FolderId}/path",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"FolderId": {
							"location": "uri",
							"locationName": "FolderId"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Fields": {
							"location": "querystring",
							"locationName": "fields"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Path": {
							"shape": "S42"
						}
					}
				}
			},
			"GetResources": {
				"http": {
					"method": "GET",
					"requestUri": "/api/v1/resources",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"UserId": {
							"location": "querystring",
							"locationName": "userId"
						},
						"CollectionType": {
							"location": "querystring",
							"locationName": "collectionType"
						},
						"Limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Folders": {
							"shape": "S37"
						},
						"Documents": {
							"shape": "S38"
						},
						"Marker": {}
					}
				}
			},
			"InitiateDocumentVersionUpload": {
				"http": {
					"requestUri": "/api/v1/documents",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"ParentFolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"Id": {},
						"Name": {},
						"ContentCreatedTimestamp": {
							"type": "timestamp"
						},
						"ContentModifiedTimestamp": {
							"type": "timestamp"
						},
						"ContentType": {},
						"DocumentSizeInBytes": {
							"type": "long"
						},
						"ParentFolderId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S39"
						},
						"UploadMetadata": {
							"type": "structure",
							"members": {
								"UploadUrl": {
									"shape": "S2z"
								},
								"SignedHeaders": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						}
					}
				}
			},
			"RemoveAllResourcePermissions": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/resources/{ResourceId}/permissions",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						}
					}
				}
			},
			"RemoveResourcePermission": {
				"http": {
					"method": "DELETE",
					"requestUri": "/api/v1/resources/{ResourceId}/permissions/{PrincipalId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"PrincipalId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"PrincipalId": {
							"location": "uri",
							"locationName": "PrincipalId"
						},
						"PrincipalType": {
							"location": "querystring",
							"locationName": "type"
						}
					}
				}
			},
			"UpdateDocument": {
				"http": {
					"method": "PATCH",
					"requestUri": "/api/v1/documents/{DocumentId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"Name": {},
						"ParentFolderId": {},
						"ResourceState": {}
					}
				}
			},
			"UpdateDocumentVersion": {
				"http": {
					"method": "PATCH",
					"requestUri": "/api/v1/documents/{DocumentId}/versions/{VersionId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"DocumentId",
						"VersionId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"DocumentId": {
							"location": "uri",
							"locationName": "DocumentId"
						},
						"VersionId": {
							"location": "uri",
							"locationName": "VersionId"
						},
						"VersionStatus": {}
					}
				}
			},
			"UpdateFolder": {
				"http": {
					"method": "PATCH",
					"requestUri": "/api/v1/folders/{FolderId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FolderId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"FolderId": {
							"location": "uri",
							"locationName": "FolderId"
						},
						"Name": {},
						"ParentFolderId": {},
						"ResourceState": {}
					}
				}
			},
			"UpdateUser": {
				"http": {
					"method": "PATCH",
					"requestUri": "/api/v1/users/{UserId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"UserId"
					],
					"members": {
						"AuthenticationToken": {
							"shape": "S2",
							"location": "header",
							"locationName": "Authentication"
						},
						"UserId": {
							"location": "uri",
							"locationName": "UserId"
						},
						"GivenName": {},
						"Surname": {},
						"Type": {},
						"StorageRule": {
							"shape": "Sj"
						},
						"TimeZoneId": {},
						"Locale": {},
						"GrantPoweruserPrivileges": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"User": {
							"shape": "S8"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "string",
				"sensitive": true
			},
			"S8": {
				"type": "structure",
				"members": {
					"Id": {},
					"Username": {},
					"EmailAddress": {},
					"GivenName": {},
					"Surname": {},
					"OrganizationId": {},
					"RootFolderId": {},
					"RecycleBinFolderId": {},
					"Status": {},
					"Type": {},
					"CreatedTimestamp": {
						"type": "timestamp"
					},
					"ModifiedTimestamp": {
						"type": "timestamp"
					},
					"TimeZoneId": {},
					"Locale": {},
					"Storage": {
						"type": "structure",
						"members": {
							"StorageUtilizedInBytes": {
								"type": "long"
							},
							"StorageRule": {
								"shape": "Sj"
							}
						}
					}
				}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"StorageAllocatedInBytes": {
						"type": "long"
					},
					"StorageType": {}
				}
			},
			"St": {
				"type": "string",
				"sensitive": true
			},
			"S10": {
				"type": "string",
				"sensitive": true
			},
			"S13": {
				"type": "structure",
				"required": [
					"CommentId"
				],
				"members": {
					"CommentId": {},
					"ParentId": {},
					"ThreadId": {},
					"Text": {
						"shape": "S10"
					},
					"Contributor": {
						"shape": "S8"
					},
					"CreatedTimestamp": {
						"type": "timestamp"
					},
					"Status": {},
					"Visibility": {},
					"RecipientId": {}
				}
			},
			"S16": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1d": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"CreatorId": {},
					"ParentFolderId": {},
					"CreatedTimestamp": {
						"type": "timestamp"
					},
					"ModifiedTimestamp": {
						"type": "timestamp"
					},
					"ResourceState": {},
					"Signature": {},
					"Labels": {
						"shape": "S1g"
					},
					"Size": {
						"type": "long"
					},
					"LatestVersionSize": {
						"type": "long"
					}
				}
			},
			"S1g": {
				"type": "list",
				"member": {}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"SubscriptionId": {},
					"EndPoint": {},
					"Protocol": {}
				}
			},
			"S2d": {
				"type": "structure",
				"members": {
					"Id": {},
					"Username": {},
					"GivenName": {},
					"Surname": {},
					"EmailAddress": {}
				}
			},
			"S2g": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Id": {},
						"Name": {}
					}
				}
			},
			"S2j": {
				"type": "structure",
				"members": {
					"Type": {},
					"Name": {},
					"OriginalName": {},
					"Id": {},
					"VersionId": {},
					"Owner": {
						"shape": "S2d"
					},
					"ParentId": {}
				}
			},
			"S2u": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"ContentType": {},
					"Size": {
						"type": "long"
					},
					"Signature": {},
					"Status": {},
					"CreatedTimestamp": {
						"type": "timestamp"
					},
					"ModifiedTimestamp": {
						"type": "timestamp"
					},
					"ContentCreatedTimestamp": {
						"type": "timestamp"
					},
					"ContentModifiedTimestamp": {
						"type": "timestamp"
					},
					"CreatorId": {},
					"Thumbnail": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S2z"
						}
					},
					"Source": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S2z"
						}
					}
				}
			},
			"S2z": {
				"type": "string",
				"sensitive": true
			},
			"S37": {
				"type": "list",
				"member": {
					"shape": "S1d"
				}
			},
			"S38": {
				"type": "list",
				"member": {
					"shape": "S39"
				}
			},
			"S39": {
				"type": "structure",
				"members": {
					"Id": {},
					"CreatorId": {},
					"ParentFolderId": {},
					"CreatedTimestamp": {
						"type": "timestamp"
					},
					"ModifiedTimestamp": {
						"type": "timestamp"
					},
					"LatestVersionMetadata": {
						"shape": "S2u"
					},
					"ResourceState": {},
					"Labels": {
						"shape": "S1g"
					}
				}
			},
			"S3b": {
				"type": "string",
				"sensitive": true
			},
			"S42": {
				"type": "structure",
				"members": {
					"Components": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 1857 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDocumentVersions": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "DocumentVersions"
			},
			"DescribeFolderContents": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": [
					"Folders",
					"Documents"
				]
			},
			"DescribeUsers": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "Users"
			}
		}
	};

/***/ },
/* 1858 */
1647,
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(2494);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 1860 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = camelCase;
	var regExp = /([A-Z])/g;
	
	/**
	 * Replace a string passed from String#replace.
	 * @param {String} str
	 * @return {String}
	 */
	function replace(str) {
	  return "-" + str.toLowerCase();
	}
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    converted[prop.replace(regExp, replace)] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jssCompose;
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Set selector.
	 *
	 * @param {Object} original rule
	 * @param {String} className class string
	 * @return {Boolean} flag, indicating function was successfull or not
	 */
	function registerClass(rule, className) {
	  // Skip falsy values
	  if (!className) return true;
	
	  // Support array of class names `{composes: ['foo', 'bar']}`
	  if (Array.isArray(className)) {
	    for (var index = 0; index < className.length; index++) {
	      var isSetted = registerClass(rule, className[index]);
	      if (!isSetted) return false;
	    }
	
	    return true;
	  }
	
	  // Support space separated class names `{composes: 'foo bar'}`
	  if (className.indexOf(' ') > -1) {
	    return registerClass(rule, className.split(' '));
	  }
	
	  var parent = rule.options.parent;
	
	  // It is a ref to a local rule.
	
	  if (className[0] === '$') {
	    var refRule = parent.getRule(className.substr(1));
	
	    if (!refRule) {
	      (0, _warning2.default)(false, '[JSS] Referenced rule is not defined. \r\n%s', rule);
	      return false;
	    }
	
	    if (refRule === rule) {
	      (0, _warning2.default)(false, '[JSS] Cyclic composition detected. \r\n%s', rule);
	      return false;
	    }
	
	    parent.classes[rule.key] += ' ' + parent.classes[refRule.key];
	
	    return true;
	  }
	
	  rule.options.parent.classes[rule.key] += ' ' + className;
	
	  return true;
	}
	
	/**
	 * Convert compose property to additional class, remove property from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssCompose() {
	  function onProcessStyle(style, rule) {
	    if (!style.composes) return style;
	    registerClass(rule, style.composes);
	    // Remove composes property to prevent infinite loop.
	    delete style.composes;
	    return style;
	  }
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 1862 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Generated jss-default-unit CSS property units
	 *
	 * @type object
	 */
	exports['default'] = {
	  'animation-delay': 'ms',
	  'animation-duration': 'ms',
	  'background-position': 'px',
	  'background-position-x': 'px',
	  'background-position-y': 'px',
	  'background-size': 'px',
	  border: 'px',
	  'border-bottom': 'px',
	  'border-bottom-left-radius': 'px',
	  'border-bottom-right-radius': 'px',
	  'border-bottom-width': 'px',
	  'border-left': 'px',
	  'border-left-width': 'px',
	  'border-radius': 'px',
	  'border-right': 'px',
	  'border-right-width': 'px',
	  'border-spacing': 'px',
	  'border-top': 'px',
	  'border-top-left-radius': 'px',
	  'border-top-right-radius': 'px',
	  'border-top-width': 'px',
	  'border-width': 'px',
	  'border-after-width': 'px',
	  'border-before-width': 'px',
	  'border-end-width': 'px',
	  'border-horizontal-spacing': 'px',
	  'border-start-width': 'px',
	  'border-vertical-spacing': 'px',
	  bottom: 'px',
	  'box-shadow': 'px',
	  'column-gap': 'px',
	  'column-rule': 'px',
	  'column-rule-width': 'px',
	  'column-width': 'px',
	  'flex-basis': 'px',
	  'font-size': 'px',
	  'font-size-delta': 'px',
	  height: 'px',
	  left: 'px',
	  'letter-spacing': 'px',
	  'logical-height': 'px',
	  'logical-width': 'px',
	  margin: 'px',
	  'margin-after': 'px',
	  'margin-before': 'px',
	  'margin-bottom': 'px',
	  'margin-left': 'px',
	  'margin-right': 'px',
	  'margin-top': 'px',
	  'max-height': 'px',
	  'max-width': 'px',
	  'margin-end': 'px',
	  'margin-start': 'px',
	  'mask-position-x': 'px',
	  'mask-position-y': 'px',
	  'mask-size': 'px',
	  'max-logical-height': 'px',
	  'max-logical-width': 'px',
	  'min-height': 'px',
	  'min-width': 'px',
	  'min-logical-height': 'px',
	  'min-logical-width': 'px',
	  motion: 'px',
	  'motion-offset': 'px',
	  outline: 'px',
	  'outline-offset': 'px',
	  'outline-width': 'px',
	  padding: 'px',
	  'padding-bottom': 'px',
	  'padding-left': 'px',
	  'padding-right': 'px',
	  'padding-top': 'px',
	  'padding-after': 'px',
	  'padding-before': 'px',
	  'padding-end': 'px',
	  'padding-start': 'px',
	  'perspective-origin-x': '%',
	  'perspective-origin-y': '%',
	  perspective: 'px',
	  right: 'px',
	  'shape-margin': 'px',
	  size: 'px',
	  'text-indent': 'px',
	  'text-stroke': 'px',
	  'text-stroke-width': 'px',
	  top: 'px',
	  'transform-origin': '%',
	  'transform-origin-x': '%',
	  'transform-origin-y': '%',
	  'transform-origin-z': '%',
	  'transition-delay': 'ms',
	  'transition-duration': 'ms',
	  'vertical-align': 'px',
	  width: 'px',
	  'word-spacing': 'px',
	  // Not existing properties.
	  // Used to avoid issues with jss-expand intergration.
	  'box-shadow-x': 'px',
	  'box-shadow-y': 'px',
	  'box-shadow-blur': 'px',
	  'box-shadow-spread': 'px',
	  'font-line-height': 'px',
	  'text-shadow-x': 'px',
	  'text-shadow-y': 'px',
	  'text-shadow-blur': 'px'
	};

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = defaultUnit;
	
	var _defaultUnits = __webpack_require__(1862);
	
	var _defaultUnits2 = _interopRequireDefault(_defaultUnits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	  var newObj = {};
	  for (var key in obj) {
	    newObj[key] = obj[key];
	    newObj[key.replace(regExp, replace)] = obj[key];
	  }
	  return newObj;
	}
	
	var units = addCamelCasedVersion(_defaultUnits2['default']);
	
	/**
	 * Recursive deep style passing function
	 *
	 * @param {String} current property
	 * @param {(Object|Array|Number|String)} property value
	 * @param {Object} options
	 * @return {(Object|Array|Number|String)} resulting value
	 */
	function iterate(prop, value, options) {
	  if (!value) return value;
	
	  var convertedValue = value;
	
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  if (type === 'object' && Array.isArray(value)) type = 'array';
	
	  switch (type) {
	    case 'object':
	      if (prop === 'fallbacks') {
	        for (var innerProp in value) {
	          value[innerProp] = iterate(innerProp, value[innerProp], options);
	        }
	        break;
	      }
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
	      }
	      break;
	    case 'array':
	      for (var i = 0; i < value.length; i++) {
	        value[i] = iterate(prop, value[i], options);
	      }
	      break;
	    case 'number':
	      if (value !== 0) {
	        convertedValue = value + (options[prop] || units[prop] || '');
	      }
	      break;
	    default:
	      break;
	  }
	
	  return convertedValue;
	}
	
	/**
	 * Add unit to numeric values.
	 */
	function defaultUnit() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = jssExpand;
	
	var _props = __webpack_require__(1865);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Map values by given prop.
	 *
	 * @param {Array} array of values
	 * @param {String} original property
	 * @param {String} original rule
	 * @return {String} mapped values
	 */
	function mapValuesByProp(value, prop, rule) {
	  return value.map(function (item) {
	    return objectToString(item, prop, rule);
	  });
	}
	
	/**
	 * Convert array to string.
	 *
	 * @param {Array} array of values
	 * @param {String} original property
	 * @param {Object} sheme, for converting arrays in strings
	 * @param {Object} original rule
	 * @return {String} converted string
	 */
	function arrayToString(value, prop, scheme, rule) {
	  if (scheme[prop] == null) return value.join(',');
	  if (value.length === 0) return '';
	  if (Array.isArray(value[0])) return arrayToString(value[0], prop, scheme);
	  if (_typeof(value[0]) === 'object') return mapValuesByProp(value, prop, rule);
	  return value.join(' ');
	}
	
	/**
	 * Convert object to string.
	 *
	 * @param {Object} object of values
	 * @param {String} original property
	 * @param {Object} original rule
	 * @param {Boolean} is fallback prop
	 * @return {String} converted string
	 */
	function objectToString(value, prop, rule, isFallback) {
	  if (!(_props.propObj[prop] || _props.customPropObj[prop])) return '';
	
	  var result = [];
	
	  // Check if exists any non-standart property
	  if (_props.customPropObj[prop]) {
	    value = customPropsToStyle(value, rule, _props.customPropObj[prop], isFallback);
	  }
	
	  // Pass throught all standart props
	  if (Object.keys(value).length) {
	    for (var baseProp in _props.propObj[prop]) {
	      if (value[baseProp]) {
	        if (Array.isArray(value[baseProp])) {
	          result.push(arrayToString(value[baseProp], baseProp, _props.propArrayInObj));
	        } else result.push(value[baseProp]);
	        continue;
	      }
	
	      // Add default value from props config.
	      if (_props.propObj[prop][baseProp] != null) {
	        result.push(_props.propObj[prop][baseProp]);
	      }
	    }
	  }
	
	  return result.join(' ');
	}
	
	/**
	 * Convert custom properties values to styles adding them to rule directly
	 *
	 * @param {Object} object of values
	 * @param {Object} original rule
	 * @param {String} property, that contain partial custom properties
	 * @param {Boolean} is fallback prop
	 * @return {Object} value without custom properties, that was already added to rule
	 */
	function customPropsToStyle(value, rule, customProps, isFallback) {
	  for (var prop in customProps) {
	    var propName = customProps[prop];
	
	    // If current property doesn't exist already in rule - add new one
	    if (typeof value[prop] !== 'undefined' && (isFallback || !rule.prop(propName))) {
	      var appendedValue = styleDetector(_defineProperty({}, propName, value[prop]), rule)[propName];
	
	      // Add style directly in rule
	      if (isFallback) rule.style.fallbacks[propName] = appendedValue;else rule.style[propName] = appendedValue;
	    }
	    // Delete converted property to avoid double converting
	    delete value[prop];
	  }
	
	  return value;
	}
	
	/**
	 * Detect if a style needs to be converted.
	 *
	 * @param {Object} style
	 * @param {Object} rule
	 * @param {Boolean} is fallback prop
	 * @return {Object} convertedStyle
	 */
	function styleDetector(style, rule, isFallback) {
	  for (var prop in style) {
	    var value = style[prop];
	
	    if (Array.isArray(value)) {
	      // Check double arrays to avoid recursion.
	      if (!Array.isArray(value[0])) {
	        if (prop === 'fallbacks') {
	          for (var index = 0; index < style.fallbacks.length; index++) {
	            style.fallbacks[index] = styleDetector(style.fallbacks[index], rule, true);
	          }
	          continue;
	        }
	
	        style[prop] = arrayToString(value, prop, _props.propArray);
	        // Avoid creating properties with empty values
	        if (!style[prop]) delete style[prop];
	      }
	    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      if (prop === 'fallbacks') {
	        style.fallbacks = styleDetector(style.fallbacks, rule, true);
	        continue;
	      }
	
	      style[prop] = objectToString(value, prop, rule, isFallback);
	      // Avoid creating properties with empty values
	      if (!style[prop]) delete style[prop];
	    }
	
	    // Maybe a computed value resulting in an empty string
	    else if (style[prop] === '') delete style[prop];
	  }
	
	  return style;
	}
	
	/**
	 * Adds possibility to write expanded styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssExpand() {
	  function onProcessStyle(style, rule) {
	    if (!style || rule.type !== 'style') return style;
	
	    if (Array.isArray(style)) {
	      // Pass rules one by one and reformat them
	      for (var index = 0; index < style.length; index++) {
	        style[index] = styleDetector(style[index], rule);
	      }
	      return style;
	    }
	
	    return styleDetector(style, rule);
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 1865 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * A scheme for converting properties from array to regular style.
	 * All properties listed below will be transformed to a string separated by space.
	 */
	var propArray = exports.propArray = {
	  'background-size': true,
	  'background-position': true,
	  border: true,
	  'border-bottom': true,
	  'border-left': true,
	  'border-top': true,
	  'border-right': true,
	  'border-radius': true,
	  'box-shadow': true,
	  flex: true,
	  margin: true,
	  padding: true,
	  outline: true,
	  'transform-origin': true,
	  transform: true,
	  transition: true
	};
	
	/**
	 * A scheme for converting arrays to regular styles inside of objects.
	 * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
	 */
	var propArrayInObj = exports.propArrayInObj = {
	  position: true, // background-position
	  size: true // background-size
	};
	
	/**
	 * A scheme for parsing and building correct styles from passed objects.
	 */
	var propObj = exports.propObj = {
	  padding: {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  },
	  margin: {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  },
	  background: {
	    attachment: null,
	    color: null,
	    image: null,
	    position: null,
	    repeat: null
	  },
	  border: {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-top': {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-right': {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-bottom': {
	    width: null,
	    style: null,
	    color: null
	  },
	  'border-left': {
	    width: null,
	    style: null,
	    color: null
	  },
	  outline: {
	    width: null,
	    style: null,
	    color: null
	  },
	  'list-style': {
	    type: null,
	    position: null,
	    image: null
	  },
	  transition: {
	    property: null,
	    duration: null,
	    'timing-function': null,
	    timingFunction: null, // Needed for avoiding comilation issues with jss-camel-case
	    delay: null
	  },
	  animation: {
	    name: null,
	    duration: null,
	    'timing-function': null,
	    timingFunction: null, // Needed to avoid compilation issues with jss-camel-case
	    delay: null,
	    'iteration-count': null,
	    iterationCount: null, // Needed to avoid compilation issues with jss-camel-case
	    direction: null,
	    'fill-mode': null,
	    fillMode: null, // Needed to avoid compilation issues with jss-camel-case
	    'play-state': null,
	    playState: null // Needed to avoid compilation issues with jss-camel-case
	  },
	  'box-shadow': {
	    x: 0,
	    y: 0,
	    blur: 0,
	    spread: 0,
	    color: null,
	    inset: null
	  },
	  'text-shadow': {
	    x: 0,
	    y: 0,
	    blur: null,
	    color: null
	  }
	};
	
	/**
	 * A scheme for converting non-standart properties inside object.
	 * For e.g.: include 'border-radius' property inside 'border' object.
	 */
	var customPropObj = exports.customPropObj = {
	  border: {
	    radius: 'border-radius'
	  },
	  background: {
	    size: 'background-size',
	    image: 'background-image'
	  },
	  font: {
	    style: 'font-style',
	    variant: 'font-variant',
	    weight: 'font-weight',
	    stretch: 'font-stretch',
	    size: 'font-size',
	    family: 'font-family',
	    lineHeight: 'line-height', // Needed to avoid compilation issues with jss-camel-case
	    'line-height': 'line-height'
	  },
	  flex: {
	    grow: 'flex-grow',
	    basis: 'flex-basis',
	    direction: 'flex-direction',
	    wrap: 'flex-wrap',
	    flow: 'flex-flow',
	    shrink: 'flex-shrink'
	  },
	  align: {
	    self: 'align-self',
	    items: 'align-items',
	    content: 'align-content'
	  }
	};

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = jssExtend;
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isObject = function isObject(obj) {
	  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
	};
	
	/**
	 * Recursively extend styles.
	 */
	function extend(style, rule, sheet) {
	  var newStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (typeof style.extend === 'string') {
	    if (sheet) {
	      var refRule = sheet.getRule(style.extend);
	      if (refRule) {
	        if (refRule === rule) (0, _warning2['default'])(false, '[JSS] A rule tries to extend itself \r\n%s', rule);else if (refRule.options.parent) {
	          var originalStyle = refRule.options.parent.rules.raw[style.extend];
	          extend(originalStyle, rule, sheet, newStyle);
	        }
	      }
	    }
	  } else if (Array.isArray(style.extend)) {
	    for (var index = 0; index < style.extend.length; index++) {
	      extend(style.extend[index], rule, sheet, newStyle);
	    }
	  } else {
	    for (var prop in style.extend) {
	      if (prop === 'extend') {
	        extend(style.extend.extend, rule, sheet, newStyle);
	      } else if (isObject(style.extend[prop])) {
	        if (!newStyle[prop]) newStyle[prop] = {};
	        extend(style.extend[prop], rule, sheet, newStyle[prop]);
	      } else {
	        newStyle[prop] = style.extend[prop];
	      }
	    }
	  }
	  // Copy base style.
	  for (var _prop in style) {
	    if (_prop === 'extend') continue;
	    if (isObject(newStyle[_prop]) && isObject(style[_prop])) {
	      extend(style[_prop], rule, sheet, newStyle[_prop]);
	    } else if (isObject(style[_prop])) {
	      newStyle[_prop] = extend(style[_prop], rule, sheet);
	    } else {
	      newStyle[_prop] = style[_prop];
	    }
	  }
	
	  return newStyle;
	}
	
	/**
	 * Handle `extend` property.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssExtend() {
	  function onProcessStyle(style, rule, sheet) {
	    return style.extend ? extend(style, rule, sheet) : style;
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = jssGlobal;
	
	var _jss = __webpack_require__(518);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var propKey = '@global';
	var prefixKey = '@global ';
	
	var GlobalContainerRule = function () {
	  function GlobalContainerRule(key, styles, options) {
	    _classCallCheck(this, GlobalContainerRule);
	
	    this.type = 'global';
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _jss.RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector], { selector: selector });
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Get a rule.
	   */
	
	
	  _createClass(GlobalContainerRule, [{
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Create and register rule, run plugins.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, style, options) {
	      var rule = this.rules.add(name, style, options);
	      this.options.jss.plugins.onProcessRule(rule);
	      return rule;
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.rules.toString();
	    }
	  }]);
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule = function () {
	  function GlobalPrefixedRule(name, style, options) {
	    _classCallCheck(this, GlobalPrefixedRule);
	
	    this.name = name;
	    this.options = options;
	    var selector = name.substr(prefixKey.length);
	    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
	      parent: this,
	      selector: selector
	    }));
	  }
	
	  _createClass(GlobalPrefixedRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      return this.rule.toString(options);
	    }
	  }]);
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + ' ' + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  var rules = style[propKey];
	
	  if (!rules) return;
	
	  for (var name in rules) {
	    options.sheet.addRule(name, rules[name], _extends({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[propKey];
	}
	
	function handlePrefixedGlobalRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop.substr(0, propKey.length) !== propKey) continue;
	
	    var selector = addScope(prop.substr(propKey.length), rule.selector);
	    options.sheet.addRule(selector, style[prop], _extends({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (name === propKey) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent.type === 'global') {
	        options.global = true;
	      }
	    }
	
	    if (options.global) options.selector = name;
	
	    return null;
	  }
	
	  function onProcessRule(rule) {
	    if (rule.type !== 'style') return;
	
	    handleNestedGlobalContainerRule(rule);
	    handlePrefixedGlobalRule(rule);
	  }
	
	  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
	}

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = jssNested;
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container) {
	    return function (match, key) {
	      var rule = container.getRule(key);
	      if (rule) return rule.selector;
	      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
	      return key;
	    };
	  }
	
	  var hasAnd = function hasAnd(str) {
	    return str.indexOf('&') !== -1;
	  };
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', ';
	        // Replace all & by the parent or prefix & with the parent.
	        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, options) {
	    // Options has been already created, now we only increase index.
	    if (options) return _extends({}, options, { index: options.index + 1 });
	
	    var nestingLevel = rule.options.nestingLevel;
	
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    return _extends({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1
	    });
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    var container = rule.options.parent;
	    var options = void 0;
	    var replaceRef = void 0;
	    for (var prop in style) {
	      var isNested = hasAnd(prop);
	      var isNestedConditional = prop[0] === '@';
	
	      if (!isNested && !isNestedConditional) continue;
	
	      options = getOptions(rule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, rule.selector
	        // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	        );if (!replaceRef) replaceRef = getReplaceRef(container
	        // Replace all $refs.
	        );selector = selector.replace(refRegExp, replaceRef);
	
	        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, _defineProperty({}, rule.key, style[prop]), options);
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jssExtend = __webpack_require__(1866);
	
	var _jssExtend2 = _interopRequireDefault(_jssExtend);
	
	var _jssNested = __webpack_require__(1868);
	
	var _jssNested2 = _interopRequireDefault(_jssNested);
	
	var _jssCamelCase = __webpack_require__(1860);
	
	var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);
	
	var _jssDefaultUnit = __webpack_require__(1863);
	
	var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);
	
	var _jssVendorPrefixer = __webpack_require__(1871);
	
	var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);
	
	var _jssPropsSort = __webpack_require__(1870);
	
	var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);
	
	var _jssCompose = __webpack_require__(1861);
	
	var _jssCompose2 = _interopRequireDefault(_jssCompose);
	
	var _jssExpand = __webpack_require__(1864);
	
	var _jssExpand2 = _interopRequireDefault(_jssExpand);
	
	var _jssGlobal = __webpack_require__(1867);
	
	var _jssGlobal2 = _interopRequireDefault(_jssGlobal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return {
	    plugins: [(0, _jssGlobal2.default)(options.global), (0, _jssExtend2.default)(options.extend), (0, _jssNested2.default)(options.nested), (0, _jssCompose2.default)(options.compose), (0, _jssCamelCase2.default)(options.camelCase), (0, _jssDefaultUnit2.default)(options.defaultUnit), (0, _jssExpand2.default)(options.expand), (0, _jssVendorPrefixer2.default)(options.vendorPrefixer), (0, _jssPropsSort2.default)(options.propsSort)]
	  };
	};

/***/ },
/* 1870 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = jssPropsSort;
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  function sort(prop0, prop1) {
	    return prop0.length - prop1.length;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    var newStyle = {};
	    var props = Object.keys(style).sort(sort);
	    for (var prop in props) {
	      newStyle[props[prop]] = style[props[prop]];
	    }
	    return newStyle;
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = jssVendorPrefixer;
	
	var _cssVendor = __webpack_require__(1415);
	
	var vendor = _interopRequireWildcard(_cssVendor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
	    }
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      var value = style[prop];
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, value);
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, value);
	  }
	
	  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StyleSheet = __webpack_require__(1874);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _PluginsRegistry = __webpack_require__(1873);
	
	var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);
	
	var _rules = __webpack_require__(1875);
	
	var _rules2 = _interopRequireDefault(_rules);
	
	var _sheets = __webpack_require__(308);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	var _createGenerateClassName = __webpack_require__(520);
	
	var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);
	
	var _createRule2 = __webpack_require__(521);
	
	var _createRule3 = _interopRequireDefault(_createRule2);
	
	var _findRenderer = __webpack_require__(1884);
	
	var _findRenderer2 = _interopRequireDefault(_findRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Jss = function () {
	  function Jss(options) {
	    _classCallCheck(this, Jss);
	
	    this.version = "8.1.0";
	    this.plugins = new _PluginsRegistry2['default']();
	
	    // eslint-disable-next-line prefer-spread
	    this.use.apply(this, _rules2['default']);
	    this.setup(options);
	  }
	
	  _createClass(Jss, [{
	    key: 'setup',
	    value: function setup() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var createGenerateClassName = options.createGenerateClassName || _createGenerateClassName2['default'];
	      this.generateClassName = createGenerateClassName();
	      this.options = _extends({}, options, {
	        createGenerateClassName: createGenerateClassName,
	        Renderer: (0, _findRenderer2['default'])(options)
	        // eslint-disable-next-line prefer-spread
	      });if (options.plugins) this.use.apply(this, options.plugins);
	      return this;
	    }
	
	    /**
	     * Create a Style Sheet.
	     */
	
	  }, {
	    key: 'createStyleSheet',
	    value: function createStyleSheet(styles) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var index = options.index;
	      if (typeof index !== 'number') {
	        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
	      }
	      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
	        jss: this,
	        generateClassName: options.generateClassName || this.generateClassName,
	        insertionPoint: this.options.insertionPoint,
	        Renderer: this.options.Renderer,
	        index: index
	      }));
	      this.plugins.onProcessSheet(sheet);
	      return sheet;
	    }
	
	    /**
	     * Detach the Style Sheet and remove it from the registry.
	     */
	
	  }, {
	    key: 'removeStyleSheet',
	    value: function removeStyleSheet(sheet) {
	      sheet.detach();
	      _sheets2['default'].remove(sheet);
	      return this;
	    }
	
	    /**
	     * Create a rule without a Style Sheet.
	     */
	
	  }, {
	    key: 'createRule',
	    value: function createRule(name) {
	      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      // Enable rule without name for inline styles.
	      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	        options = style;
	        style = name;
	        name = undefined;
	      }
	
	      // Cast from RuleFactoryOptions to RuleOptions
	      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	      var ruleOptions = options;
	
	      ruleOptions.jss = this;
	      ruleOptions.Renderer = this.options.Renderer;
	      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
	      if (!ruleOptions.classes) ruleOptions.classes = {};
	      var rule = (0, _createRule3['default'])(name, style, ruleOptions);
	      this.plugins.onProcessRule(rule);
	
	      return rule;
	    }
	
	    /**
	     * Register plugin. Passed function will be invoked with a rule instance.
	     */
	
	  }, {
	    key: 'use',
	    value: function use() {
	      var _this = this;
	
	      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
	        plugins[_key] = arguments[_key];
	      }
	
	      plugins.forEach(function (plugin) {
	        return _this.plugins.use(plugin);
	      });
	      return this;
	    }
	  }]);
	
	  return Jss;
	}();
	
	exports['default'] = Jss;

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PluginsRegistry = function () {
	  function PluginsRegistry() {
	    _classCallCheck(this, PluginsRegistry);
	
	    this.hooks = {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: []
	
	      /**
	       * Call `onCreateRule` hooks and return an object if returned by a hook.
	       */
	    };
	  }
	
	  _createClass(PluginsRegistry, [{
	    key: 'onCreateRule',
	    value: function onCreateRule(name, decl, options) {
	      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
	        var rule = this.hooks.onCreateRule[i](name, decl, options);
	        if (rule) return rule;
	      }
	      return null;
	    }
	
	    /**
	     * Call `onProcessRule` hooks.
	     */
	
	  }, {
	    key: 'onProcessRule',
	    value: function onProcessRule(rule) {
	      if (rule.isProcessed) return;
	      var sheet = rule.options.sheet;
	
	      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
	        this.hooks.onProcessRule[i](rule, sheet);
	      }
	
	      // $FlowFixMe
	      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	
	      rule.isProcessed = true;
	    }
	
	    /**
	     * Call `onProcessStyle` hooks.
	     */
	
	  }, {
	    key: 'onProcessStyle',
	    value: function onProcessStyle(style, rule, sheet) {
	      var nextStyle = style;
	
	      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
	        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
	        // $FlowFixMe
	        rule.style = nextStyle;
	      }
	    }
	
	    /**
	     * Call `onProcessSheet` hooks.
	     */
	
	  }, {
	    key: 'onProcessSheet',
	    value: function onProcessSheet(sheet) {
	      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
	        this.hooks.onProcessSheet[i](sheet);
	      }
	    }
	
	    /**
	     * Call `onChangeValue` hooks.
	     */
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(value, prop, rule) {
	      var processedValue = value;
	      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
	        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
	      }
	      return processedValue;
	    }
	
	    /**
	     * Register a plugin.
	     * If function is passed, it is a shortcut for `{onProcessRule}`.
	     */
	
	  }, {
	    key: 'use',
	    value: function use(plugin) {
	      for (var name in plugin) {
	        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
	      }
	    }
	  }]);
	
	  return PluginsRegistry;
	}();
	
	exports['default'] = PluginsRegistry;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _linkRule = __webpack_require__(522);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	var _RuleList = __webpack_require__(206);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleSheet = function () {
	  function StyleSheet(styles, options) {
	    _classCallCheck(this, StyleSheet);
	
	    this.attached = false;
	    this.deployed = false;
	    this.linked = false;
	    this.classes = {};
	    this.options = _extends({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes
	    });
	    this.renderer = new options.Renderer(this);
	    this.rules = new _RuleList2['default'](this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  _createClass(StyleSheet, [{
	    key: 'attach',
	    value: function attach() {
	      if (this.attached) return this;
	      if (!this.deployed) this.deploy();
	      this.renderer.attach();
	      if (!this.linked && this.options.link) this.link();
	      this.attached = true;
	      return this;
	    }
	
	    /**
	     * Remove renderable from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      if (!this.attached) return this;
	      this.renderer.detach();
	      this.attached = false;
	      return this;
	    }
	
	    /**
	     * Add a rule to the current stylesheet.
	     * Will insert a rule also after the stylesheet has been rendered first time.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, decl, options) {
	      var queue = this.queue;
	
	      // Plugins can create rules.
	      // In order to preserve the right order, we need to queue all `.addRule` calls,
	      // which happen after the first `rules.add()` call.
	
	      if (this.attached && !queue) this.queue = [];
	
	      var rule = this.rules.add(name, decl, options);
	      this.options.jss.plugins.onProcessRule(rule);
	
	      if (this.attached) {
	        if (!this.deployed) return rule;
	        // Don't insert rule directly if there is no stringified version yet.
	        // It will be inserted all together when .attach is called.
	        if (queue) queue.push(rule);else {
	          this.insertRule(rule);
	          if (this.queue) {
	            this.queue.forEach(this.insertRule, this);
	            this.queue = undefined;
	          }
	        }
	        return rule;
	      }
	
	      // We can't add rules to a detached style node.
	      // We will redeploy the sheet once user will attach it.
	      this.deployed = false;
	
	      return rule;
	    }
	
	    /**
	     * Insert rule into the StyleSheet
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule) {
	      var renderable = this.renderer.insertRule(rule);
	      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
	    }
	
	    /**
	     * Create and add rules.
	     * Will render also after Style Sheet was rendered the first time.
	     */
	
	  }, {
	    key: 'addRules',
	    value: function addRules(styles, options) {
	      var added = [];
	      for (var name in styles) {
	        added.push(this.addRule(name, styles[name], options));
	      }
	      return added;
	    }
	
	    /**
	     * Get a rule by name.
	     */
	
	  }, {
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Delete a rule by name.
	     * Returns `true`: if rule has been deleted from the DOM.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(name) {
	      var rule = this.rules.get(name);
	
	      if (!rule) return false;
	
	      this.rules.remove(rule);
	
	      if (this.attached && rule.renderable) {
	        return this.renderer.deleteRule(rule.renderable);
	      }
	
	      return true;
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Deploy pure CSS string to a renderable.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      this.renderer.deploy();
	      this.deployed = true;
	      return this;
	    }
	
	    /**
	     * Link renderable CSS rules from sheet with their corresponding models.
	     */
	
	  }, {
	    key: 'link',
	    value: function link() {
	      var cssRules = this.renderer.getRules();
	
	      // Is undefined when VirtualRenderer is used.
	      if (cssRules) this.rules.link(cssRules);
	      this.linked = true;
	      return this;
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'update',
	    value: function update(name, data) {
	      this.rules.update(name, data);
	      return this;
	    }
	
	    /**
	     * Convert rules to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return this.rules.toString(options);
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	exports['default'] = StyleSheet;

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleRule = __webpack_require__(1881);
	
	var _SimpleRule2 = _interopRequireDefault(_SimpleRule);
	
	var _KeyframesRule = __webpack_require__(1880);
	
	var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);
	
	var _ConditionalRule = __webpack_require__(1878);
	
	var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);
	
	var _FontFaceRule = __webpack_require__(1879);
	
	var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);
	
	var _ViewportRule = __webpack_require__(1882);
	
	var _ViewportRule2 = _interopRequireDefault(_ViewportRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var classes = {
	  '@charset': _SimpleRule2['default'],
	  '@import': _SimpleRule2['default'],
	  '@namespace': _SimpleRule2['default'],
	  '@keyframes': _KeyframesRule2['default'],
	  '@media': _ConditionalRule2['default'],
	  '@supports': _ConditionalRule2['default'],
	  '@font-face': _FontFaceRule2['default'],
	  '@viewport': _ViewportRule2['default'],
	  '@-ms-viewport': _ViewportRule2['default']
	
	  /**
	   * Generate plugins which will register all rules.
	   */
	};
	exports['default'] = Object.keys(classes).map(function (key) {
	  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
	  var re = new RegExp('^' + key);
	  var onCreateRule = function onCreateRule(name, decl, options) {
	    return re.test(name) ? new classes[key](name, decl, options) : null;
	  };
	  return { onCreateRule: onCreateRule };
	});

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _sheets = __webpack_require__(308);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Get a style property.
	 */
	function getStyle(rule, prop) {
	  try {
	    return rule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	}
	
	/**
	 * Set a style property.
	 */
	function setStyle(rule, prop, value) {
	  try {
	    rule.style.setProperty(prop, value);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	  return true;
	}
	
	function extractSelector(cssText) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  return cssText.substr(from, cssText.indexOf('{') - 1);
	}
	
	var CSSRuleTypes = {
	  STYLE_RULE: 1,
	  KEYFRAMES_RULE: 7
	
	  /**
	   * Get the selector.
	   */
	};function getSelector(rule) {
	  if (rule.type === CSSRuleTypes.STYLE_RULE) return rule.selectorText;
	  if (rule.type === CSSRuleTypes.KEYFRAMES_RULE) {
	    var name = rule.name;
	
	    if (name) return '@keyframes ' + name;
	
	    // There is no rule.name in the following browsers:
	    // - IE 9
	    // - Safari 7.1.8
	    // - Mobile Safari 9.0.0
	    var cssText = rule.cssText;
	
	    return '@' + extractSelector(cssText, cssText.indexOf('keyframes'));
	  }
	
	  return extractSelector(rule.cssText);
	}
	
	/**
	 * Set the selector.
	 */
	function setSelector(rule, selectorText) {
	  rule.selectorText = selectorText;
	
	  // Return false if setter was not successful.
	  // Currently works in chrome only.
	  return rule.selectorText === selectorText;
	}
	
	/**
	 * Gets the `head` element upon the first call and caches it.
	 */
	var getHead = function () {
	  var head = void 0;
	  return function () {
	    if (!head) head = document.head || document.getElementsByTagName('head')[0];
	    return head;
	  };
	}();
	
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find attached sheet with the highest index.
	 */
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a comment with "jss" inside.
	 */
	function findCommentNode(text) {
	  var head = getHead();
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry = _sheets2['default'].registry;
	
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	    if (sheet) return sheet.renderer.element;
	
	    // Otherwise insert after the last attached.
	    sheet = findHighestSheet(registry, options);
	    if (sheet) return sheet.renderer.element.nextElementSibling;
	  }
	
	  // Try to find a comment placeholder if registry is empty.
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	    if (comment) return comment.nextSibling;
	    // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
	  }
	
	  return null;
	}
	
	/**
	 * Insert style element into the DOM.
	 */
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	
	  var prevNode = findPrevNode(options);
	
	  if (prevNode) {
	    var parentNode = prevNode.parentNode;
	
	    if (parentNode) parentNode.insertBefore(style, prevNode);
	    return;
	  }
	
	  // Works with iframes and any node types.
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var _parentNode = insertionPointElement.parentNode;
	
	    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
	    return;
	  }
	
	  getHead().insertBefore(style, prevNode);
	}
	
	var DomRenderer = function () {
	  function DomRenderer(sheet) {
	    _classCallCheck(this, DomRenderer);
	
	    this.getStyle = getStyle;
	    this.setStyle = setStyle;
	    this.setSelector = setSelector;
	    this.getSelector = getSelector;
	    this.hasInsertedRules = false;
	
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) _sheets2['default'].add(sheet);
	
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || document.createElement('style');
	    this.element.type = 'text/css';
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	  }
	
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	
	
	  _createClass(DomRenderer, [{
	    key: 'attach',
	    value: function attach() {
	      // In the case the element node is external and it is already in the DOM.
	      if (this.element.parentNode || !this.sheet) return;
	
	      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	      // browsers remove those rules.
	      // TODO figure out if its a bug and if it is known.
	      // Workaround is to redeploy the sheet before attaching as a string.
	      if (this.hasInsertedRules) {
	        this.deploy();
	        this.hasInsertedRules = false;
	      }
	
	      insertStyle(this.element, this.sheet.options);
	    }
	
	    /**
	     * Remove style element from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      this.element.parentNode.removeChild(this.element);
	    }
	
	    /**
	     * Inject CSS string into element.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      if (!this.sheet) return;
	      this.element.textContent = '\n' + this.sheet.toString() + '\n';
	    }
	
	    /**
	     * Insert a rule into element.
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule) {
	      var sheet = this.element.sheet;
	      var cssRules = sheet.cssRules;
	
	      var index = cssRules.length;
	      var str = rule.toString();
	
	      if (!str) return false;
	
	      try {
	        sheet.insertRule(str, index);
	      } catch (err) {
	        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
	        return false;
	      }
	
	      this.hasInsertedRules = true;
	
	      return cssRules[index];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(rule) {
	      var sheet = this.element.sheet;
	      var cssRules = sheet.cssRules;
	
	      for (var _index = 0; _index < cssRules.length; _index++) {
	        if (rule === cssRules[_index]) {
	          sheet.deleteRule(_index);
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * Get all rules elements.
	     */
	
	  }, {
	    key: 'getRules',
	    value: function getRules() {
	      return this.element.sheet.cssRules;
	    }
	  }]);
	
	  return DomRenderer;
	}();
	
	exports['default'] = DomRenderer;

/***/ },
/* 1877 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable class-methods-use-this */
	
	/**
	 * Rendering backend to do nothing in nodejs.
	 */
	var VirtualRenderer = function () {
	  function VirtualRenderer() {
	    _classCallCheck(this, VirtualRenderer);
	  }
	
	  _createClass(VirtualRenderer, [{
	    key: 'setStyle',
	    value: function setStyle() {
	      return true;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return '';
	    }
	  }, {
	    key: 'setSelector',
	    value: function setSelector() {
	      return true;
	    }
	  }, {
	    key: 'getSelector',
	    value: function getSelector() {
	      return '';
	    }
	  }, {
	    key: 'attach',
	    value: function attach() {}
	  }, {
	    key: 'detach',
	    value: function detach() {}
	  }, {
	    key: 'deploy',
	    value: function deploy() {}
	  }, {
	    key: 'insertRule',
	    value: function insertRule() {
	      return false;
	    }
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule() {
	      return true;
	    }
	  }, {
	    key: 'getRules',
	    value: function getRules() {}
	  }]);
	
	  return VirtualRenderer;
	}();
	
	exports['default'] = VirtualRenderer;

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RuleList = __webpack_require__(206);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Conditional rule for @media, @supports
	 */
	var ConditionalRule = function () {
	  function ConditionalRule(key, styles, options) {
	    _classCallCheck(this, ConditionalRule);
	
	    this.type = 'conditional';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Get a rule.
	   */
	
	
	  _createClass(ConditionalRule, [{
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Create and register rule, run plugins.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, style, options) {
	      var rule = this.rules.add(name, style, options);
	      this.options.jss.plugins.onProcessRule(rule);
	      return rule;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };
	
	      var inner = this.rules.toString(options);
	      return inner ? this.key + ' {\n' + inner + '\n}' : '';
	    }
	  }]);
	
	  return ConditionalRule;
	}();
	
	exports['default'] = ConditionalRule;

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(309);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FontFaceRule = function () {
	  function FontFaceRule(key, style, options) {
	    _classCallCheck(this, FontFaceRule);
	
	    this.type = 'font-face';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(FontFaceRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      if (Array.isArray(this.style)) {
	        var str = '';
	        for (var index = 0; index < this.style.length; index++) {
	          str += (0, _toCss2['default'])(this.key, this.style[index]);
	          if (this.style[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return (0, _toCss2['default'])(this.key, this.style, options);
	    }
	  }]);
	
	  return FontFaceRule;
	}();
	
	exports['default'] = FontFaceRule;

/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RuleList = __webpack_require__(206);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Rule for @keyframes
	 */
	var KeyframesRule = function () {
	  function KeyframesRule(key, frames, options) {
	    _classCallCheck(this, KeyframesRule);
	
	    this.type = 'keyframes';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends({}, this.options, {
	        parent: this,
	        selector: name
	      }));
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(KeyframesRule, [{
	    key: 'toString',
	    value: function toString() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };
	
	      var inner = this.rules.toString(options);
	      if (inner) inner += '\n';
	      return this.key + ' {\n' + inner + '}';
	    }
	  }]);
	
	  return KeyframesRule;
	}();
	
	exports['default'] = KeyframesRule;

/***/ },
/* 1881 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SimpleRule = function () {
	  function SimpleRule(key, value, options) {
	    _classCallCheck(this, SimpleRule);
	
	    this.type = 'simple';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  _createClass(SimpleRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      if (Array.isArray(this.value)) {
	        var str = '';
	        for (var index = 0; index < this.value.length; index++) {
	          str += this.key + ' ' + this.value[index] + ';';
	          if (this.value[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return this.key + ' ' + this.value + ';';
	    }
	  }]);
	
	  return SimpleRule;
	}();
	
	exports['default'] = SimpleRule;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(309);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ViewportRule = function () {
	  function ViewportRule(key, style, options) {
	    _classCallCheck(this, ViewportRule);
	
	    this.type = 'viewport';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(ViewportRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      return (0, _toCss2['default'])(this.key, this.style, options);
	    }
	  }]);
	
	  return ViewportRule;
	}();
	
	exports['default'] = ViewportRule;

/***/ },
/* 1883 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = cloneStyle;
	var isArray = Array.isArray;
	function cloneStyle(style) {
	  // Support empty values in case user ends up with them by accident.
	  if (style == null) return style;
	
	  // Support string value for SimpleRule.
	  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);
	  if (typeOfStyle === 'string' || typeOfStyle === 'number') return style;
	
	  // Support array for FontFaceRule.
	  if (isArray(style)) return style.map(cloneStyle);
	
	  var newStyle = {};
	  for (var name in style) {
	    var value = style[name];
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      newStyle[name] = cloneStyle(value);
	      continue;
	    }
	    newStyle[name] = value;
	  }
	
	  return newStyle;
	}

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = findRenderer;
	
	var _isInBrowser = __webpack_require__(205);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _DomRenderer = __webpack_require__(1876);
	
	var _DomRenderer2 = _interopRequireDefault(_DomRenderer);
	
	var _VirtualRenderer = __webpack_require__(1877);
	
	var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Find proper renderer.
	 * Option `virtual` is used to force use of VirtualRenderer even if DOM is
	 * detected, used for testing only.
	 */
	function findRenderer() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (options.Renderer) return options.Renderer;
	  var useVirtual = options.virtual || !_isInBrowser2['default'];
	  return useVirtual ? _VirtualRenderer2['default'] : _DomRenderer2['default'];
	}

/***/ },
/* 1885 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	exports['default'] = function (styles) {
	  // eslint-disable-next-line no-shadow
	  function extract(styles) {
	    var to = null;
	
	    for (var key in styles) {
	      var value = styles[key];
	      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	      if (type === 'function') {
	        if (!to) to = {};
	        to[key] = value;
	      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	        var extracted = extract(value);
	        if (extracted) {
	          if (!to) to = {};
	          to[key] = extracted;
	        }
	      }
	    }
	
	    return to;
	  }
	
	  return extract(styles);
	};

/***/ },
/* 1886 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports['default'] = function (rule, data, RuleList) {
	  if (rule.type === 'style') {
	    for (var prop in rule.style) {
	      var value = rule.style[prop];
	      if (typeof value === 'function') {
	        rule.prop(prop, value(data));
	      }
	    }
	  } else if (rule.rules instanceof RuleList) {
	    rule.rules.update(data);
	  }
	};

/***/ },
/* 1887 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// http://www.rajdeepd.com/articles/chrome/localstrg/LocalStorageSample.htm
	
	// NOTE:
	// this varies from actual localStorage in some subtle ways
	
	// also, there is no persistence
	// TODO persist
	(function () {
	  "use strict";
	
	  var db;
	
	  function LocalStorage() {
	  }
	  db = LocalStorage;
	
	  db.prototype.getItem = function (key) {
	    if (this.hasOwnProperty(key)) {
	      return String(this[key]);
	    }
	    return null;
	  };
	
	  db.prototype.setItem = function (key, val) {
	    this[key] = String(val);
	  };
	
	  db.prototype.removeItem = function (key) {
	    delete this[key];
	  };
	
	  db.prototype.clear = function () {
	    var self = this;
	    Object.keys(self).forEach(function (key) {
	      self[key] = undefined;
	      delete self[key];
	    });
	  };
	
	  db.prototype.key = function (i) {
	    i = i || 0;
	    return Object.keys(this)[i];
	  };
	
	  db.prototype.__defineGetter__('length', function () {
	    return Object.keys(this).length;
	  });
	
	  if (global.localStorage) {
	    module.exports = localStorage;
	  } else {
	    module.exports = new LocalStorage();
	  }
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	 * without support for iteratee shorthands, which iterates over `collection`
	 * using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFindKey(collection, predicate, eachFunc) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = key;
	      return false;
	    }
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * This method is like `_.find` except that it returns the key of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element,
	 *  else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findKey(users, function(o) { return o.age < 40; });
	 * // => 'barney' (iteration order is not guaranteed)
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findKey(users, { 'age': 1, 'active': true });
	 * // => 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findKey(users, 'active');
	 * // => 'barney'
	 */
	function findKey(object, predicate) {
	  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = findKey;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(107)(module)))

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(107)(module)))

/***/ },
/* 1890 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(115),
	    root = __webpack_require__(87);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1942),
	    hashDelete = __webpack_require__(1943),
	    hashGet = __webpack_require__(1944),
	    hashHas = __webpack_require__(1945),
	    hashSet = __webpack_require__(1946);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(115),
	    root = __webpack_require__(87);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(115),
	    root = __webpack_require__(87);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(311),
	    setCacheAdd = __webpack_require__(1965),
	    setCacheHas = __webpack_require__(1966);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(87);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(115),
	    root = __webpack_require__(87);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1898 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1899 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 1900 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1925),
	    isArguments = __webpack_require__(316),
	    isArray = __webpack_require__(79),
	    isBuffer = __webpack_require__(317),
	    isIndex = __webpack_require__(312),
	    isTypedArray = __webpack_require__(320);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1902 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 1903 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1904 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(532),
	    keys = __webpack_require__(166);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1906 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(80);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1910),
	    createBaseEach = __webpack_require__(1931);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1907);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1932);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1909),
	    keys = __webpack_require__(166);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1903),
	    isArray = __webpack_require__(79);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1912 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(140),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(525),
	    equalArrays = __webpack_require__(534),
	    equalByTag = __webpack_require__(1933),
	    equalObjects = __webpack_require__(1934),
	    getTag = __webpack_require__(536),
	    isArray = __webpack_require__(79),
	    isBuffer = __webpack_require__(317),
	    isTypedArray = __webpack_require__(320);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(525),
	    baseIsEqual = __webpack_require__(529);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(215),
	    isMasked = __webpack_require__(1948),
	    isObject = __webpack_require__(80),
	    toSource = __webpack_require__(541);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(140),
	    isLength = __webpack_require__(318),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1919),
	    baseMatchesProperty = __webpack_require__(1920),
	    identity = __webpack_require__(315),
	    isArray = __webpack_require__(79),
	    property = __webpack_require__(1983);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1915),
	    getMatchData = __webpack_require__(1936),
	    matchesStrictComparable = __webpack_require__(539);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(529),
	    get = __webpack_require__(1979),
	    hasIn = __webpack_require__(1980),
	    isKey = __webpack_require__(313),
	    isStrictComparable = __webpack_require__(538),
	    matchesStrictComparable = __webpack_require__(539),
	    toKey = __webpack_require__(213);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1921 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(528);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(315),
	    overRest = __webpack_require__(1964),
	    setToString = __webpack_require__(1968);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1977),
	    defineProperty = __webpack_require__(533),
	    identity = __webpack_require__(315);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1925 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1926 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(209),
	    arrayMap = __webpack_require__(1902),
	    isArray = __webpack_require__(79),
	    isSymbol = __webpack_require__(319);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1927 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1928 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(87);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(1923),
	    isIterateeCall = __webpack_require__(537);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(165);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1932 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(209),
	    Uint8Array = __webpack_require__(1896),
	    eq = __webpack_require__(214),
	    equalArrays = __webpack_require__(534),
	    mapToArray = __webpack_require__(1959),
	    setToArray = __webpack_require__(1967);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1935);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1911),
	    getSymbols = __webpack_require__(1939),
	    keys = __webpack_require__(166);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(538),
	    keys = __webpack_require__(166);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(540);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(209);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1900),
	    stubArray = __webpack_require__(1984);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1940 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(531),
	    isArguments = __webpack_require__(316),
	    isArray = __webpack_require__(79),
	    isIndex = __webpack_require__(312),
	    isLength = __webpack_require__(318),
	    toKey = __webpack_require__(213);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(212);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1943 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(212);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(212);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(212);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1947 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1929);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1949 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(210);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(210);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(210);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(210);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1892),
	    ListCache = __webpack_require__(208),
	    Map = __webpack_require__(310);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(211);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1959 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1982);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(540);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(535);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ },
/* 1963 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1898);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 1965 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1966 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1967 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1924),
	    shortOut = __webpack_require__(1969);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 1969 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(208);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1971 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1972 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1973 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(208),
	    Map = __webpack_require__(310),
	    MapCache = __webpack_require__(311);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1960);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(526),
	    copyObject = __webpack_require__(532),
	    createAssigner = __webpack_require__(1930),
	    isArrayLike = __webpack_require__(165),
	    isPrototype = __webpack_require__(314),
	    keys = __webpack_require__(166);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 1977 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1899),
	    baseEvery = __webpack_require__(1908),
	    baseIteratee = __webpack_require__(1918),
	    isArray = __webpack_require__(79),
	    isIterateeCall = __webpack_require__(537);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(528);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1912),
	    hasPath = __webpack_require__(1941);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(530),
	    getTag = __webpack_require__(536),
	    isArguments = __webpack_require__(316),
	    isArray = __webpack_require__(79),
	    isArrayLike = __webpack_require__(165),
	    isBuffer = __webpack_require__(317),
	    isPrototype = __webpack_require__(314),
	    isTypedArray = __webpack_require__(320);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(311);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1921),
	    basePropertyDeep = __webpack_require__(1922),
	    isKey = __webpack_require__(313),
	    toKey = __webpack_require__(213);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1984 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1985 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1926);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedSwitch = __webpack_require__(2012);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(2026);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(2027);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Checkbox.propTypes =  false ? {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = Checkbox;

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(1987);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(2022);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(545);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(2010);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(547);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(1998);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(207);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(326);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(543);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      height: spacing.desktopToolbarHeight + 'px',
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      if (_this.props.multiple) {
	        if (!_this.state.open) {
	          _this.setState({ open: true });
	        }
	      } else {
	        event.persist();
	        _this.setState({
	          open: false
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, index, child.props.value);
	          }
	
	          _this.close(_events2.default.isKeyboard(event));
	        });
	      }
	    }, _this.handleChange = function (event, value) {
	      if (_this.props.multiple && _this.props.onChange) {
	        _this.props.onChange(event, undefined, value);
	      }
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          selectionRenderer = _props.selectionRenderer,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          iconButton = _props.iconButton,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      if (!multiple) {
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value === child.props.value) {
	            if (selectionRenderer) {
	              displayValue = selectionRenderer(value, child);
	            } else {
	              // This will need to be improved (in case primaryText is a node)
	              displayValue = child.props.label || child.props.primaryText;
	            }
	          }
	        });
	      } else {
	        var values = [];
	        var selectionRendererChildren = [];
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value && value.indexOf(child.props.value) > -1) {
	            if (selectionRenderer) {
	              values.push(child.props.value);
	              selectionRendererChildren.push(child);
	            } else {
	              values.push(child.props.label || child.props.primaryText);
	            }
	          }
	        });
	
	        displayValue = [];
	        if (selectionRenderer) {
	          displayValue = selectionRenderer(values, selectionRendererChildren);
	        } else {
	          displayValue = values.join(', ');
	        }
	      }
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onClick: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              disabled: disabled,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            iconButton
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              multiple: multiple,
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              onChange: this.handleChange,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle,
	              autoWidth: autoWidth,
	              width: !autoWidth && menuStyle ? menuStyle.width : null
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
	  openImmediately: false,
	  maxHeight: 500,
	  multiple: false,
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DropDownMenu.propTypes =  false ? {
	  /**
	   * This is the point on the anchor that the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides default `SvgIcon` dropdown arrow component.
	   */
	  iconButton: _propTypes2.default.node,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = DropDownMenu;

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FontIcon.propTypes =  false ? {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = FontIcon;

/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(1990);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _EnhancedButton = __webpack_require__(549);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(1991);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(2016);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(2032);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'default'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	IconButton.propTypes =  false ? {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _propTypes2.default.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseOut: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _propTypes2.default.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes4.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _propTypes2.default.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _propTypes2.default.bool
	} : {};
	exports.default = IconButton;

/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(125);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(325);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(549);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(543);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(2024);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(2025);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(1994);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
	      insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedItems = props.nestedItems,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;
	
	  var styles = {
	    root: {
	      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	
	      if (_this.props.primaryTogglesNestedList) {
	        _this.handleNestedListToggle(event);
	      }
	    }, _this.handleNestedListToggle = function (event) {
	      if (_this.props.leftCheckbox) {
	        event.preventDefault();
	      }
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      if (this.button) {
	        var buttonEl = _reactDom2.default.findDOMNode(this.button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            this.button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          isKeyboardFocused = _props3.isKeyboardFocused,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onClick = _props3.onClick,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onClick: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: containerElement
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onClick: this.handleTouchTap,
	            disabled: disabled,
	            ref: function ref(node) {
	              return _this2.button = node;
	            },
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  containerElement: 'span',
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ListItem.propTypes =  false ? {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _propTypes2.default.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the ListItem. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * ListItem in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _propTypes2.default.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * Use to control if the list item should render as keyboard focused.  If
	   * undefined (default), this will be automatically managed.  If provided,
	   * it will change the components style.  Note that this will not change the
	   * actual focus - and should only be used when you want to simulate
	   * keyboard focus (eg. in a rich text input autocomplete).
	   */
	  isKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _propTypes2.default.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the list item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the list item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _propTypes2.default.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _propTypes2.default.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ListItem;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(544);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	NestedList.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  nestedLevel: _propTypes2.default.number.isRequired,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = NestedList;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Paper.propTypes =  false ? {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Set to true to generate a circular paper container.
	   */
	  circle: _propTypes2.default.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _propTypes2.default.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Paper;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(217);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationDefault.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationDefault;

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(217);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(101);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'center');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationVertical.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationVertical;

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(2007);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(321);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          dropDownMenuProps = _props.dropDownMenuProps,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          selectionRenderer = _props.selectionRenderer,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          (0, _extends3.default)({
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight,
	            multiple: multiple,
	            selectionRenderer: selectionRenderer
	          }, dropDownMenuProps),
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false,
	  multiple: false
	};
	SelectField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SelectField.propTypes =  false ? {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Object that can handle and override any property of component DropDownMenu.
	   */
	  dropDownMenuProps: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item, or undefined
	   * if `multiple` is true.
	   * @param {any} payload If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Customize the rendering of the selected item.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = SelectField;

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	Subheader.propTypes =  false ? {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Subheader;

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SvgIcon.propTypes =  false ? {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : {};
	exports.default = SvgIcon;

/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(359);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' // because the shadow has position: 'absolute'
	    },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'auto'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(_this.props.value, event);
	    }, _this.handleChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.syncHeightWithShadow(event.target.value);
	      }
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow(this.props.value);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
	        this.syncHeightWithShadow(nextProps.value, null, nextProps);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event, props) {
	      var shadow = this.refs.shadow;
	      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;
	
	      if (displayText !== undefined) {
	        shadow.value = displayText;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      props = props || this.props;
	
	      if (props.rowsMax >= props.rows) {
	        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        var input = this.refs.input;
	        var cursorPosition = input.selectionStart;
	        this.setState({
	          height: newHeight
	        }, function () {
	          input.setSelectionRange(cursorPosition, cursorPosition);
	        });
	
	        if (props.onHeightChange) {
	          props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          hintText = _props.hintText,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	      var props = {};
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = valueLink.value;
	        props.valueLink = valueLink;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value
	        }, props)),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedTextarea.propTypes =  false ? {
	  defaultValue: _propTypes2.default.any,
	  disabled: _propTypes2.default.bool,
	  hintText: _propTypes2.default.node,
	  onChange: _propTypes2.default.func,
	  onHeightChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number,
	  rowsMax: _propTypes2.default.number,
	  shadowStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  textareaStyle: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = EnhancedTextarea;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(125);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(2002);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(2004);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(2005);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(2006);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitOpacity: 1,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated style).
	    },
	    inputNative: {
	      appearance: 'textfield' // Improve type search style.
	    }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.setState({ hasValue: isValid(event.target.value) });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled && !this.props.disabled) {
	        this.setState({
	          isFocused: false
	        });
	      }
	
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax,
	          hintText: hintText
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TextField.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _propTypes2.default.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _propTypes2.default.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * The value of the text field.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = TextField;

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	TextFieldHint.propTypes =  false ? {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _propTypes2.default.node
	} : {};
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onClick = props.onClick;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onClick: onClick
	    },
	    children
	  );
	};
	
	TextFieldLabel.propTypes =  false ? {
	  /**
	   * The label contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _propTypes2.default.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 1,
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottomStyle: 'dotted',
	      borderBottomWidth: 2,
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 2,
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(focusedUnderline) })
	  );
	};
	
	TextFieldUnderline.propTypes =  false ? propTypes : {};
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(2003);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	BeforeAfterWrapper.propTypes =  false ? {
	  afterElementType: _propTypes2.default.string,
	  afterStyle: _propTypes2.default.object,
	  beforeElementType: _propTypes2.default.string,
	  beforeStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  elementType: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = BeforeAfterWrapper;

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(125);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(324);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CircleRipple.propTypes =  false ? {
	  aborted: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  touchGenerated: _propTypes2.default.bool
	} : {};
	exports.default = CircleRipple;

/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BeforeAfterWrapper = __webpack_require__(2008);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	ClearFix.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = ClearFix;

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(326);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  onClickAway: _propTypes2.default.func
	} : {};
	exports.default = ClickAwayListener;

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(359);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(207);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(550);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(551);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(217);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'checked', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var touchHandlers = showTouchRipple ? {
	        onMouseUp: this.handleMouseUp,
	        onMouseDown: this.handleMouseDown,
	        onMouseLeave: this.handleMouseLeave,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        checked: this.state.switched,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange
	      }, touchHandlers));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedSwitch.propTypes =  false ? {
	  checked: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  defaultChecked: _propTypes2.default.bool,
	  disableFocusRipple: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  inputStyle: _propTypes2.default.object,
	  inputType: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.node,
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  labelStyle: _propTypes2.default.object,
	  name: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onParentShouldUpdate: _propTypes2.default.func,
	  onSwitch: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  rippleColor: _propTypes2.default.string,
	  rippleStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  switchElement: _propTypes2.default.element.isRequired,
	  switched: _propTypes2.default.bool.isRequired,
	  thumbStyle: _propTypes2.default.object,
	  trackStyle: _propTypes2.default.object,
	  value: _propTypes2.default.any
	} : {};
	exports.default = EnhancedSwitch;

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _dom = __webpack_require__(553);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RenderToLayer.propTypes =  false ? {
	  componentClickAway: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  useLayerForClickAway: _propTypes2.default.bool
	} : {};
	exports.default = RenderToLayer;

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(264);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _ScaleInChild = __webpack_require__(2015);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleIn.propTypes =  false ? {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleIn;

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(324);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleInChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleInChild;

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(32);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(30);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(23);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(42);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: borderRadius,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: tooltip.opacity,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tooltip.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
	  label: _propTypes2.default.node.isRequired,
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  touch: _propTypes2.default.bool,
	  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
	} : {};
	exports.default = Tooltip;

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(24);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(20);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(26);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(25);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getMuiTheme = __webpack_require__(552);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MuiThemeProvider.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  muiTheme: _propTypes2.default.object
	} : {};
	exports.default = MuiThemeProvider;

/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(323);
	
	var _colorManipulator = __webpack_require__(325);
	
	var _spacing = __webpack_require__(2019);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  borderRadius: 2,
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ },
/* 2019 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(323);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ },
/* 2021 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(154);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(142);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(154);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(142);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(154);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(142);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(154);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(142);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(154);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(142);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(154);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(142);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
	    var prefixer = new Prefixer({
	      userAgent: userAgent
	    });
	
	    return function (style) {
	      return prefixer.prefix(style);
	    };
	  }
	};
	
	var _createPrefixer = __webpack_require__(1622);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _createPrefixer3 = __webpack_require__(1614);
	
	var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);
	
	var _autoprefixerDynamic = __webpack_require__(2029);
	
	var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);
	
	var _autoprefixerStatic = __webpack_require__(2030);
	
	var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1615);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(1616);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1617);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1618);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1619);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(1620);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1621);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
	}; /* eslint-disable */

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1623);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(1624);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1625);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1626);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1627);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(1628);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1629);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
	}; /* eslint-disable */

/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(53);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(1360);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 554,
		"./af.js": 554,
		"./ar": 561,
		"./ar-dz": 555,
		"./ar-dz.js": 555,
		"./ar-kw": 556,
		"./ar-kw.js": 556,
		"./ar-ly": 557,
		"./ar-ly.js": 557,
		"./ar-ma": 558,
		"./ar-ma.js": 558,
		"./ar-sa": 559,
		"./ar-sa.js": 559,
		"./ar-tn": 560,
		"./ar-tn.js": 560,
		"./ar.js": 561,
		"./az": 562,
		"./az.js": 562,
		"./be": 563,
		"./be.js": 563,
		"./bg": 564,
		"./bg.js": 564,
		"./bm": 565,
		"./bm.js": 565,
		"./bn": 566,
		"./bn.js": 566,
		"./bo": 567,
		"./bo.js": 567,
		"./br": 568,
		"./br.js": 568,
		"./bs": 569,
		"./bs.js": 569,
		"./ca": 570,
		"./ca.js": 570,
		"./cs": 571,
		"./cs.js": 571,
		"./cv": 572,
		"./cv.js": 572,
		"./cy": 573,
		"./cy.js": 573,
		"./da": 574,
		"./da.js": 574,
		"./de": 577,
		"./de-at": 575,
		"./de-at.js": 575,
		"./de-ch": 576,
		"./de-ch.js": 576,
		"./de.js": 577,
		"./dv": 578,
		"./dv.js": 578,
		"./el": 579,
		"./el.js": 579,
		"./en-SG": 580,
		"./en-SG.js": 580,
		"./en-au": 581,
		"./en-au.js": 581,
		"./en-ca": 582,
		"./en-ca.js": 582,
		"./en-gb": 583,
		"./en-gb.js": 583,
		"./en-ie": 584,
		"./en-ie.js": 584,
		"./en-il": 585,
		"./en-il.js": 585,
		"./en-nz": 586,
		"./en-nz.js": 586,
		"./eo": 587,
		"./eo.js": 587,
		"./es": 590,
		"./es-do": 588,
		"./es-do.js": 588,
		"./es-us": 589,
		"./es-us.js": 589,
		"./es.js": 590,
		"./et": 591,
		"./et.js": 591,
		"./eu": 592,
		"./eu.js": 592,
		"./fa": 593,
		"./fa.js": 593,
		"./fi": 594,
		"./fi.js": 594,
		"./fo": 595,
		"./fo.js": 595,
		"./fr": 598,
		"./fr-ca": 596,
		"./fr-ca.js": 596,
		"./fr-ch": 597,
		"./fr-ch.js": 597,
		"./fr.js": 598,
		"./fy": 599,
		"./fy.js": 599,
		"./ga": 600,
		"./ga.js": 600,
		"./gd": 601,
		"./gd.js": 601,
		"./gl": 602,
		"./gl.js": 602,
		"./gom-latn": 603,
		"./gom-latn.js": 603,
		"./gu": 604,
		"./gu.js": 604,
		"./he": 605,
		"./he.js": 605,
		"./hi": 606,
		"./hi.js": 606,
		"./hr": 607,
		"./hr.js": 607,
		"./hu": 608,
		"./hu.js": 608,
		"./hy-am": 609,
		"./hy-am.js": 609,
		"./id": 610,
		"./id.js": 610,
		"./is": 611,
		"./is.js": 611,
		"./it": 613,
		"./it-ch": 612,
		"./it-ch.js": 612,
		"./it.js": 613,
		"./ja": 614,
		"./ja.js": 614,
		"./jv": 615,
		"./jv.js": 615,
		"./ka": 616,
		"./ka.js": 616,
		"./kk": 617,
		"./kk.js": 617,
		"./km": 618,
		"./km.js": 618,
		"./kn": 619,
		"./kn.js": 619,
		"./ko": 620,
		"./ko.js": 620,
		"./ku": 621,
		"./ku.js": 621,
		"./ky": 622,
		"./ky.js": 622,
		"./lb": 623,
		"./lb.js": 623,
		"./lo": 624,
		"./lo.js": 624,
		"./lt": 625,
		"./lt.js": 625,
		"./lv": 626,
		"./lv.js": 626,
		"./me": 627,
		"./me.js": 627,
		"./mi": 628,
		"./mi.js": 628,
		"./mk": 629,
		"./mk.js": 629,
		"./ml": 630,
		"./ml.js": 630,
		"./mn": 631,
		"./mn.js": 631,
		"./mr": 632,
		"./mr.js": 632,
		"./ms": 634,
		"./ms-my": 633,
		"./ms-my.js": 633,
		"./ms.js": 634,
		"./mt": 635,
		"./mt.js": 635,
		"./my": 636,
		"./my.js": 636,
		"./nb": 637,
		"./nb.js": 637,
		"./ne": 638,
		"./ne.js": 638,
		"./nl": 640,
		"./nl-be": 639,
		"./nl-be.js": 639,
		"./nl.js": 640,
		"./nn": 641,
		"./nn.js": 641,
		"./pa-in": 642,
		"./pa-in.js": 642,
		"./pl": 643,
		"./pl.js": 643,
		"./pt": 645,
		"./pt-br": 644,
		"./pt-br.js": 644,
		"./pt.js": 645,
		"./ro": 646,
		"./ro.js": 646,
		"./ru": 647,
		"./ru.js": 647,
		"./sd": 648,
		"./sd.js": 648,
		"./se": 649,
		"./se.js": 649,
		"./si": 650,
		"./si.js": 650,
		"./sk": 651,
		"./sk.js": 651,
		"./sl": 652,
		"./sl.js": 652,
		"./sq": 653,
		"./sq.js": 653,
		"./sr": 655,
		"./sr-cyrl": 654,
		"./sr-cyrl.js": 654,
		"./sr.js": 655,
		"./ss": 656,
		"./ss.js": 656,
		"./sv": 657,
		"./sv.js": 657,
		"./sw": 658,
		"./sw.js": 658,
		"./ta": 659,
		"./ta.js": 659,
		"./te": 660,
		"./te.js": 660,
		"./tet": 661,
		"./tet.js": 661,
		"./tg": 662,
		"./tg.js": 662,
		"./th": 663,
		"./th.js": 663,
		"./tl-ph": 664,
		"./tl-ph.js": 664,
		"./tlh": 665,
		"./tlh.js": 665,
		"./tr": 666,
		"./tr.js": 666,
		"./tzl": 667,
		"./tzl.js": 667,
		"./tzm": 669,
		"./tzm-latn": 668,
		"./tzm-latn.js": 668,
		"./tzm.js": 669,
		"./ug-cn": 670,
		"./ug-cn.js": 670,
		"./uk": 671,
		"./uk.js": 671,
		"./ur": 672,
		"./ur.js": 672,
		"./uz": 674,
		"./uz-latn": 673,
		"./uz-latn.js": 673,
		"./uz.js": 674,
		"./vi": 675,
		"./vi.js": 675,
		"./x-pseudo": 676,
		"./x-pseudo.js": 676,
		"./yo": 677,
		"./yo.js": 677,
		"./zh-cn": 678,
		"./zh-cn.js": 678,
		"./zh-hk": 679,
		"./zh-hk.js": 679,
		"./zh-tw": 680,
		"./zh-tw.js": 680
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2034;


/***/ },
/* 2035 */
/***/ function(module, exports) {

	(function(root) {
	  var isOn = false;
	  var scrollbarSize;
	  var scrollTop;
	
	  function getScrollbarSize() {
	    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
	
	    var doc = document.documentElement;
	    var dummyScroller = document.createElement('div');
	    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
	    doc.appendChild(dummyScroller);
	    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
	    doc.removeChild(dummyScroller);
	    return scrollbarSize;
	  }
	
	  function hasScrollbar() {
	    return document.documentElement.scrollHeight > window.innerHeight;
	  }
	
	  function on(options) {
	    if (typeof document === 'undefined' || isOn) return;
	    var doc = document.documentElement;
	    scrollTop = window.pageYOffset;
	    if (hasScrollbar()) {
	      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
	    } else {
	      doc.style.width = '100%';
	    }
	    doc.style.position = 'fixed';
	    doc.style.top = -scrollTop + 'px';
	    doc.style.overflow = 'hidden';
	    isOn = true;
	  }
	
	  function off() {
	    if (typeof document === 'undefined' || !isOn) return;
	    var doc = document.documentElement;
	    doc.style.width = '';
	    doc.style.position = '';
	    doc.style.top = '';
	    doc.style.overflow = '';
	    window.scroll(0, scrollTop);
	    isOn = false;
	  }
	
	  function toggle() {
	    if (isOn) {
	      off();
	      return;
	    }
	    on();
	  }
	
	  var noScroll = {
	    on: on,
	    off: off,
	    toggle: toggle,
	  };
	
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = noScroll;
	  } else {
	    root.noScroll = noScroll;
	  }
	})(this);


/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(681);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(681);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(683);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(360);
	var assign = __webpack_require__(16);
	
	var ReactPropTypesSecret = __webpack_require__(683);
	var checkPropTypes = __webpack_require__(2038);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2041 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ },
/* 2042 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(143);
	
	
	/**
	 * A function that always returns `false`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.T
	 * @example
	 *
	 *      R.F(); //=> false
	 */
	module.exports = always(false);


/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	var always = __webpack_require__(143);
	
	
	/**
	 * A function that always returns `true`. Any passed in parameters are ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig * -> Boolean
	 * @param {*}
	 * @return {Boolean}
	 * @see R.always, R.F
	 * @example
	 *
	 *      R.T(); //=> true
	 */
	module.exports = always(true);


/***/ },
/* 2045 */
/***/ function(module, exports) {

	/**
	 * A special placeholder value used to specify "gaps" within curried functions,
	 * allowing partial application of any combination of arguments, regardless of
	 * their positions.
	 *
	 * If `g` is a curried ternary function and `_` is `R.__`, the following are
	 * equivalent:
	 *
	 *   - `g(1, 2, 3)`
	 *   - `g(_, 2, 3)(1)`
	 *   - `g(_, _, 3)(1)(2)`
	 *   - `g(_, _, 3)(1, 2)`
	 *   - `g(_, 2, _)(1, 3)`
	 *   - `g(_, 2)(1)(3)`
	 *   - `g(_, 2)(1, 3)`
	 *   - `g(_, 2)(_, 3)(1)`
	 *
	 * @constant
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @example
	 *
	 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
	 *      greet('Alice'); //=> 'Hello, Alice!'
	 */
	module.exports = {'@@functional/placeholder': true};


/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry1 = __webpack_require__(12);
	var curryN = __webpack_require__(49);
	
	
	/**
	 * Creates a new list iteration function from an existing one by adding two new
	 * parameters to its callback function: the current index, and the entire list.
	 *
	 * This would turn, for instance, Ramda's simple `map` function into one that
	 * more closely resembles `Array.prototype.map`. Note that this will only work
	 * for functions in which the iteration callback function is the first
	 * parameter, and where the list is the last parameter. (This latter might be
	 * unimportant if the list parameter is not used.)
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category Function
	 * @category List
	 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
	 * @param {Function} fn A list iteration function that does not pass index or list to its callback
	 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
	 * @example
	 *
	 *      var mapIndexed = R.addIndex(R.map);
	 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
	 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
	 */
	module.exports = _curry1(function addIndex(fn) {
	  return curryN(fn.length, function() {
	    var idx = 0;
	    var origFn = arguments[0];
	    var list = arguments[arguments.length - 1];
	    var args = Array.prototype.slice.call(arguments, 0);
	    args[0] = function() {
	      var result = origFn.apply(this, _concat(arguments, [idx, list]));
	      idx += 1;
	      return result;
	    };
	    return fn.apply(this, args);
	  });
	});


/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xall = __webpack_require__(2118);
	
	
	/**
	 * Returns `true` if all elements of the list match the predicate, `false` if
	 * there are any that don't.
	 *
	 * Dispatches to the `all` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
	 *         otherwise.
	 * @see R.any, R.none, R.transduce
	 * @example
	 *
	 *      var equals3 = R.equals(3);
	 *      R.all(equals3)([3, 3, 3, 3]); //=> true
	 *      R.all(equals3)([3, 3, 1, 3]); //=> false
	 */
	module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
	  var idx = 0;
	  while (idx < list.length) {
	    if (!fn(list[idx])) {
	      return false;
	    }
	    idx += 1;
	  }
	  return true;
	}));


/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var curryN = __webpack_require__(49);
	var max = __webpack_require__(144);
	var pluck = __webpack_require__(174);
	var reduce = __webpack_require__(67);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if every one of the provided predicates is satisfied
	 * by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.anyPass
	 * @example
	 *
	 *      var isQueen = R.propEq('rank', 'Q');
	 *      var isSpade = R.propEq('suit', '♠︎');
	 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
	 *
	 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
	 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
	 */
	module.exports = _curry1(function allPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (!preds[idx].apply(this, arguments)) {
	        return false;
	      }
	      idx += 1;
	    }
	    return true;
	  });
	});


/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var curryN = __webpack_require__(49);
	var max = __webpack_require__(144);
	var pluck = __webpack_require__(174);
	var reduce = __webpack_require__(67);
	
	
	/**
	 * Takes a list of predicates and returns a predicate that returns true for a
	 * given list of arguments if at least one of the provided predicates is
	 * satisfied by those arguments.
	 *
	 * The function returned is a curried function whose arity matches that of the
	 * highest-arity predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Logic
	 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
	 * @param {Array} predicates An array of predicates to check
	 * @return {Function} The combined predicate
	 * @see R.allPass
	 * @example
	 *
	 *      var isClub = R.propEq('suit', '♣');
	 *      var isSpade = R.propEq('suit', '♠');
	 *      var isBlackCard = R.anyPass([isClub, isSpade]);
	 *
	 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
	 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
	 */
	module.exports = _curry1(function anyPass(preds) {
	  return curryN(reduce(max, 0, pluck('length', preds)), function() {
	    var idx = 0;
	    var len = preds.length;
	    while (idx < len) {
	      if (preds[idx].apply(this, arguments)) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  });
	});


/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	var _aperture = __webpack_require__(2101);
	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xaperture = __webpack_require__(2119);
	
	
	/**
	 * Returns a new list, composed of n-tuples of consecutive elements If `n` is
	 * greater than the length of the list, an empty list is returned.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @param {Number} n The size of the tuples to create
	 * @param {Array} list The list to split into `n`-length tuples
	 * @return {Array} The resulting list of `n`-length tuples
	 * @see R.transduce
	 * @example
	 *
	 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
	 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
	 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
	 */
	module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a new list containing the contents of the given list, followed by
	 * the given element.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} el The element to add to the end of the new list.
	 * @param {Array} list The list of elements to add a new item to.
	 *        list.
	 * @return {Array} A new list containing the elements of the old list followed by `el`.
	 * @see R.prepend
	 * @example
	 *
	 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
	 *      R.append('tests', []); //=> ['tests']
	 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
	 */
	module.exports = _curry2(function append(el, list) {
	  return _concat(list, [el]);
	});


/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var apply = __webpack_require__(687);
	var curryN = __webpack_require__(49);
	var map = __webpack_require__(59);
	var max = __webpack_require__(144);
	var pluck = __webpack_require__(174);
	var reduce = __webpack_require__(67);
	var values = __webpack_require__(739);
	
	
	/**
	 * Given a spec object recursively mapping properties to functions, creates a
	 * function producing an object of the same structure, by mapping each property
	 * to the result of calling its associated function with the supplied arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
	 * @param {Object} spec an object recursively mapping properties to functions for
	 *        producing the values for these properties.
	 * @return {Function} A function that returns an object of the same structure
	 * as `spec', with each property set to the value returned by calling its
	 * associated function with the supplied arguments.
	 * @see R.converge, R.juxt
	 * @example
	 *
	 *      var getMetrics = R.applySpec({
	 *                                      sum: R.add,
	 *                                      nested: { mul: R.multiply }
	 *                                   });
	 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
	 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
	 */
	module.exports = _curry1(function applySpec(spec) {
	  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
	             spec);
	  return curryN(reduce(max, 0, pluck('length', values(spec))),
	                function() {
	                  var args = arguments;
	                  return map(function(f) { return apply(f, args); }, spec);
	                });
	});


/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Makes an ascending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.ascend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByYoungestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function ascend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa < bb ? -1 : aa > bb ? 1 : 0;
	});


/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var nAry = __webpack_require__(230);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 2 parameters. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> c) -> (a, b -> c)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 2.
	 * @example
	 *
	 *      var takesThreeArgs = function(a, b, c) {
	 *        return [a, b, c];
	 *      };
	 *      takesThreeArgs.length; //=> 3
	 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
	 *
	 *      var takesTwoArgs = R.binary(takesThreeArgs);
	 *      takesTwoArgs.length; //=> 2
	 *      // Only 2 arguments are passed to the wrapped function
	 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
	 * @symb R.binary(f)(a, b, c) = f(a, b)
	 */
	module.exports = _curry1(function binary(fn) {
	  return nAry(2, fn);
	});


/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isFunction = __webpack_require__(224);
	var and = __webpack_require__(685);
	var lift = __webpack_require__(229);
	
	
	/**
	 * A function which calls the two provided functions and returns the `&&`
	 * of the results.
	 * It returns the result of the first function if it is false-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * false-y value.
	 *
	 * In addition to functions, `R.both` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f A predicate
	 * @param {Function} g Another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
	 * @see R.and
	 * @example
	 *
	 *      var gt10 = R.gt(R.__, 10)
	 *      var lt20 = R.lt(R.__, 20)
	 *      var f = R.both(gt10, lt20);
	 *      f(15); //=> true
	 *      f(30); //=> false
	 */
	module.exports = _curry2(function both(f, g) {
	  return _isFunction(f) ?
	    function _both() {
	      return f.apply(this, arguments) && g.apply(this, arguments);
	    } :
	    lift(and)(f, g);
	});


/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	var curry = __webpack_require__(221);
	
	
	/**
	 * Returns the result of calling its first argument with the remaining
	 * arguments. This is occasionally useful as a converging function for
	 * `R.converge`: the left branch can produce a function while the right branch
	 * produces a value to be passed to that function as an argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig (*... -> a),*... -> a
	 * @param {Function} fn The function to apply to the remaining arguments.
	 * @param {...*} args Any number of positional arguments.
	 * @return {*}
	 * @see R.apply
	 * @example
	 *
	 *      R.call(R.add, 1, 2); //=> 3
	 *
	 *      var indentN = R.pipe(R.times(R.always(' ')),
	 *                           R.join(''),
	 *                           R.replace(/^(?!$)/gm));
	 *
	 *      var format = R.converge(R.call, [
	 *                                  R.pipe(R.prop('indent'), indentN),
	 *                                  R.prop('value')
	 *                              ]);
	 *
	 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
	 * @symb R.call(f, a, b) = f(a, b)
	 */
	module.exports = curry(function call(fn) {
	  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
	});


/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	/**
	 * Restricts a number to be within a range.
	 *
	 * Also works for other ordered types such as Strings and Dates.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a -> a
	 * @param {Number} minimum The lower limit of the clamp (inclusive)
	 * @param {Number} maximum The upper limit of the clamp (inclusive)
	 * @param {Number} value Value to be clamped
	 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
	 * @example
	 *
	 *      R.clamp(1, 10, -5) // => 1
	 *      R.clamp(1, 10, 15) // => 10
	 *      R.clamp(1, 10, 4)  // => 4
	 */
	module.exports = _curry3(function clamp(min, max, value) {
	  if (min > max) {
	    throw new Error('min must not be greater than max in clamp(min, max, value)');
	  }
	  return value < min ? min :
	         value > max ? max :
	         value;
	});


/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(700);
	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Creates a deep copy of the value which may contain (nested) `Array`s and
	 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
	 * assigned by reference rather than copied
	 *
	 * Dispatches to a `clone` method if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {*} -> {*}
	 * @param {*} value The object or array to clone
	 * @return {*} A deeply cloned copy of `val`
	 * @example
	 *
	 *      var objects = [{}, {}, {}];
	 *      var objectsClone = R.clone(objects);
	 *      objects === objectsClone; //=> false
	 *      objects[0] === objectsClone[0]; //=> false
	 */
	module.exports = _curry1(function clone(value) {
	  return value != null && typeof value.clone === 'function' ?
	    value.clone() :
	    _clone(value, [], [], true);
	});


/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Makes a comparator function out of a function that reports whether the first
	 * element is less than the second.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a, b -> Boolean) -> (a, b -> Number)
	 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
	 * is less than the second, `false` otherwise
	 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
	 * @example
	 *
	 *      var byAge = R.comparator((a, b) => a.age < b.age);
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByIncreasingAge = R.sort(byAge, people);
	 */
	module.exports = _curry1(function comparator(pred) {
	  return function(a, b) {
	    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
	  };
	});


/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	var lift = __webpack_require__(229);
	var not = __webpack_require__(722);
	
	
	/**
	 * Takes a function `f` and returns a function `g` such that if called with the same arguments
	 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
	 *
	 * `R.complement` may be applied to any functor
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> *) -> (*... -> Boolean)
	 * @param {Function} f
	 * @return {Function}
	 * @see R.not
	 * @example
	 *
	 *      var isNotNil = R.complement(R.isNil);
	 *      isNil(null); //=> true
	 *      isNotNil(null); //=> false
	 *      isNil(7); //=> false
	 *      isNotNil(7); //=> true
	 */
	module.exports = lift(not);


/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	var pipeP = __webpack_require__(729);
	var reverse = __webpack_require__(233);
	
	
	/**
	 * Performs right-to-left composition of one or more Promise-returning
	 * functions. The rightmost function may have any arity; the remaining
	 * functions must be unary.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
	 * @param {...Function} functions The functions to compose
	 * @return {Function}
	 * @see R.pipeP
	 * @example
	 *
	 *      var db = {
	 *        users: {
	 *          JOE: {
	 *            name: 'Joe',
	 *            followers: ['STEVE', 'SUZY']
	 *          }
	 *        }
	 *      }
	 *
	 *      // We'll pretend to do a db lookup which returns a promise
	 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
	 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
	 *      lookupUser('JOE').then(lookupFollowers)
	 *
	 *      //  followersForUser :: String -> Promise [UserId]
	 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
	 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
	 *      // Followers: ["STEVE","SUZY"]
	 */
	module.exports = function composeP() {
	  if (arguments.length === 0) {
	    throw new Error('composeP requires at least one argument');
	  }
	  return pipeP.apply(this, reverse(arguments));
	};


/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _curry1 = __webpack_require__(12);
	var map = __webpack_require__(59);
	var max = __webpack_require__(144);
	var reduce = __webpack_require__(67);
	
	
	/**
	 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
	 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
	 * to `fn` are applied to each of the predicates in turn until one returns a
	 * "truthy" value, at which point `fn` returns the result of applying its
	 * arguments to the corresponding transformer. If none of the predicates
	 * matches, `fn` returns undefined.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Logic
	 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
	 * @param {Array} pairs A list of [predicate, transformer]
	 * @return {Function}
	 * @example
	 *
	 *      var fn = R.cond([
	 *        [R.equals(0),   R.always('water freezes at 0°C')],
	 *        [R.equals(100), R.always('water boils at 100°C')],
	 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
	 *      ]);
	 *      fn(0); //=> 'water freezes at 0°C'
	 *      fn(50); //=> 'nothing special happens at 50°C'
	 *      fn(100); //=> 'water boils at 100°C'
	 */
	module.exports = _curry1(function cond(pairs) {
	  var arity = reduce(max,
	                     0,
	                     map(function(pair) { return pair[0].length; }, pairs));
	  return _arity(arity, function() {
	    var idx = 0;
	    while (idx < pairs.length) {
	      if (pairs[idx][0].apply(this, arguments)) {
	        return pairs[idx][1].apply(this, arguments);
	      }
	      idx += 1;
	    }
	  });
	});


/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var constructN = __webpack_require__(691);
	
	
	/**
	 * Wraps a constructor function inside a curried function that can be called
	 * with the same arguments and returns the same type.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (* -> {*}) -> (* -> {*})
	 * @param {Function} fn The constructor function to wrap.
	 * @return {Function} A wrapped, curried constructor function.
	 * @example
	 *
	 *      // Constructor function
	 *      function Animal(kind) {
	 *        this.kind = kind;
	 *      };
	 *      Animal.prototype.sighting = function() {
	 *        return "It's a " + this.kind + "!";
	 *      }
	 *
	 *      var AnimalConstructor = R.construct(Animal)
	 *
	 *      // Notice we no longer need the 'new' keyword:
	 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
	 *
	 *      var animalTypes = ["Lion", "Tiger", "Bear"];
	 *      var animalSighting = R.invoker(0, 'sighting');
	 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
	 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
	 */
	module.exports = _curry1(function construct(Fn) {
	  return constructN(Fn.length, Fn);
	});


/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(117);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if the specified value is equal, in `R.equals` terms, to at
	 * least one element of the given list; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Boolean
	 * @param {Object} a The item to compare against.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
	 * @see R.any
	 * @example
	 *
	 *      R.contains(3, [1, 2, 3]); //=> true
	 *      R.contains(4, [1, 2, 3]); //=> false
	 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
	 *      R.contains([42], [[42]]); //=> true
	 */
	module.exports = _curry2(_contains);


/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(231);
	
	
	/**
	 * Counts the elements of a list according to how many match each value of a
	 * key generated by the supplied function. Returns an object mapping the keys
	 * produced by `fn` to the number of occurrences in the list. Note that all
	 * keys are coerced to strings because of how JavaScript objects work.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> String) -> [a] -> {*}
	 * @param {Function} fn The function used to map values to keys.
	 * @param {Array} list The list to count elements from.
	 * @return {Object} An object mapping keys to number of occurrences in the list.
	 * @example
	 *
	 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
	 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
	 *
	 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
	 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
	 */
	module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(219);
	
	
	/**
	 * Decrements its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n - 1
	 * @see R.inc
	 * @example
	 *
	 *      R.dec(42); //=> 41
	 */
	module.exports = add(-1);


/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Makes a descending comparator function out of a function that returns a value
	 * that can be compared with `<` and `>`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Function
	 * @sig Ord b => (a -> b) -> a -> a -> Number
	 * @param {Function} fn A function of arity one that returns a value that can be compared
	 * @param {*} a The first item to be compared.
	 * @param {*} b The second item to be compared.
	 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
	 * @example
	 *
	 *      var byAge = R.descend(R.prop('age'));
	 *      var people = [
	 *        // ...
	 *      ];
	 *      var peopleByOldestFirst = R.sort(byAge, people);
	 */
	module.exports = _curry3(function descend(fn, a, b) {
	  var aa = fn(a);
	  var bb = fn(b);
	  return aa > bb ? -1 : aa < bb ? 1 : 0;
	});


/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var assoc = __webpack_require__(168);
	var dissoc = __webpack_require__(330);
	
	
	/**
	 * Makes a shallow clone of an object, omitting the property at the given path.
	 * Note that this copies and flattens prototype properties onto the new object
	 * as well. All non-primitive properties are copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.11.0
	 * @category Object
	 * @sig [String] -> {k: v} -> {k: v}
	 * @param {Array} path The path to the value to omit
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object without the property at path
	 * @see R.assocPath
	 * @example
	 *
	 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
	 */
	module.exports = _curry2(function dissocPath(path, obj) {
	  switch (path.length) {
	    case 0:
	      return obj;
	    case 1:
	      return dissoc(path[0], obj);
	    default:
	      var head = path[0];
	      var tail = Array.prototype.slice.call(path, 1);
	      return obj[head] == null ? obj : assoc(head, dissocPath(tail, obj[head]), obj);
	  }
	});


/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Divides two numbers. Equivalent to `a / b`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a / b`.
	 * @see R.multiply
	 * @example
	 *
	 *      R.divide(71, 100); //=> 0.71
	 *
	 *      var half = R.divide(R.__, 2);
	 *      half(42); //=> 21
	 *
	 *      var reciprocal = R.divide(1);
	 *      reciprocal(4);   //=> 0.25
	 */
	module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _dropLast = __webpack_require__(2103);
	var _xdropLast = __webpack_require__(2122);
	
	
	/**
	 * Returns a list containing all but the last `n` elements of the given `list`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements of `list` to skip.
	 * @param {Array} list The list of elements to consider.
	 * @return {Array} A copy of the list with only the first `list.length - n` elements
	 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
	 * @example
	 *
	 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
	 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
	 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
	 *      R.dropLast(3, 'ramda');               //=> 'ra'
	 */
	module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _dropLastWhile = __webpack_require__(2104);
	var _xdropLastWhile = __webpack_require__(2123);
	
	
	/**
	 * Returns a new list excluding all the tailing elements of a given list which
	 * satisfy the supplied predicate function. It passes each value from the right
	 * to the supplied predicate function, skipping elements until the predicate
	 * function returns a `falsy` value. The predicate function is applied to one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} predicate The function to be called on each element
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
	 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
	 * @example
	 *
	 *      var lteThree = x => x <= 3;
	 *
	 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _dispatchable = __webpack_require__(39);
	var _xdropRepeatsWith = __webpack_require__(712);
	var dropRepeatsWith = __webpack_require__(697);
	var equals = __webpack_require__(81);
	
	
	/**
	 * Returns a new list without any consecutively repeating elements. `R.equals`
	 * is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig [a] -> [a]
	 * @param {Array} list The array to consider.
	 * @return {Array} `list` without repeating elements.
	 * @see R.transduce
	 * @example
	 *
	 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
	 */
	module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xdropWhile = __webpack_require__(2124);
	
	
	/**
	 * Returns a new list excluding the leading elements of a given list which
	 * satisfy the supplied predicate function. It passes each value to the supplied
	 * predicate function, skipping elements while the predicate function returns
	 * `true`. The predicate function is applied to one argument: *(value)*.
	 *
	 * Dispatches to the `dropWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.takeWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var lteTwo = x => x <= 2;
	 *
	 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
	 */
	module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && pred(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, idx);
	}));


/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isFunction = __webpack_require__(224);
	var lift = __webpack_require__(229);
	var or = __webpack_require__(724);
	
	
	/**
	 * A function wrapping calls to the two functions in an `||` operation,
	 * returning the result of the first function if it is truth-y and the result
	 * of the second function otherwise. Note that this is short-circuited,
	 * meaning that the second function will not be invoked if the first returns a
	 * truth-y value.
	 *
	 * In addition to functions, `R.either` also accepts any fantasy-land compatible
	 * applicative functor.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
	 * @param {Function} f a predicate
	 * @param {Function} g another predicate
	 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
	 * @see R.or
	 * @example
	 *
	 *      var gt10 = x => x > 10;
	 *      var even = x => x % 2 === 0;
	 *      var f = R.either(gt10, even);
	 *      f(101); //=> true
	 *      f(8); //=> true
	 */
	module.exports = _curry2(function either(f, g) {
	  return _isFunction(f) ?
	    function _either() {
	      return f.apply(this, arguments) || g.apply(this, arguments);
	    } :
	    lift(or)(f, g);
	});


/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var equals = __webpack_require__(81);
	
	
	/**
	 * Takes a function and two values in its domain and returns `true` if the
	 * values map to the same value in the codomain; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Relation
	 * @sig (a -> b) -> a -> a -> Boolean
	 * @param {Function} f
	 * @param {*} x
	 * @param {*} y
	 * @return {Boolean}
	 * @example
	 *
	 *      R.eqBy(Math.abs, 5, -5); //=> true
	 */
	module.exports = _curry3(function eqBy(f, x, y) {
	  return equals(f(x), f(y));
	});


/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var equals = __webpack_require__(81);
	
	
	/**
	 * Reports whether two objects have the same value, in `R.equals` terms, for
	 * the specified property. Useful as a curried predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig k -> {k: v} -> {k: v} -> Boolean
	 * @param {String} prop The name of the property to compare
	 * @param {Object} obj1
	 * @param {Object} obj2
	 * @return {Boolean}
	 *
	 * @example
	 *
	 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
	 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
	 *      R.eqProps('a', o1, o2); //=> false
	 *      R.eqProps('c', o1, o2); //=> true
	 */
	module.exports = _curry3(function eqProps(prop, obj1, obj2) {
	  return equals(obj1[prop], obj2[prop]);
	});


/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Creates a new object by recursively evolving a shallow copy of `object`,
	 * according to the `transformation` functions. All non-primitive properties
	 * are copied by reference.
	 *
	 * A `transformation` function will not be invoked if its corresponding key
	 * does not exist in the evolved object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
	 * @param {Object} transformations The object specifying transformation functions to apply
	 *        to the object.
	 * @param {Object} object The object to be transformed.
	 * @return {Object} The transformed object.
	 * @example
	 *
	 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
	 *      var transformations = {
	 *        firstName: R.trim,
	 *        lastName: R.trim, // Will not get invoked.
	 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
	 *      };
	 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
	 */
	module.exports = _curry2(function evolve(transformations, object) {
	  var result = {};
	  var transformation, key, type;
	  for (key in object) {
	    transformation = transformations[key];
	    type = typeof transformation;
	    result[key] = type === 'function'                 ? transformation(object[key])
	                : transformation && type === 'object' ? evolve(transformation, object[key])
	                                                      : object[key];
	  }
	  return result;
	});


/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xfind = __webpack_require__(2126);
	
	
	/**
	 * Returns the first element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Dispatches to the `find` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 *        desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
	 *      R.find(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx += 1;
	  }
	}));


/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xfindIndex = __webpack_require__(2127);
	
	
	/**
	 * Returns the index of the first element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
	 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
	 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx += 1;
	  }
	  return -1;
	}));


/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xfindLast = __webpack_require__(2128);
	
	
	/**
	 * Returns the last element of the list which matches the predicate, or
	 * `undefined` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> a | undefined
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Object} The element found, or `undefined`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
	 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
	 */
	module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return list[idx];
	    }
	    idx -= 1;
	  }
	}));


/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xfindLastIndex = __webpack_require__(2129);
	
	
	/**
	 * Returns the index of the last element of the list which matches the
	 * predicate, or `-1` if no element matches.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Number
	 * @param {Function} fn The predicate function used to determine if the element is the
	 * desired one.
	 * @param {Array} list The array to consider.
	 * @return {Number} The index of the element found, or `-1`.
	 * @see R.transduce
	 * @example
	 *
	 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
	 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
	 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
	 */
	module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0) {
	    if (fn(list[idx])) {
	      return idx;
	    }
	    idx -= 1;
	  }
	  return -1;
	}));


/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _makeFlat = __webpack_require__(710);
	
	
	/**
	 * Returns a new list by pulling every item out of it (and all its sub-arrays)
	 * and putting them in a new array, depth-first.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b]
	 * @param {Array} list The array to consider.
	 * @return {Array} The flattened list.
	 * @see R.unnest
	 * @example
	 *
	 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
	 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
	 */
	module.exports = _curry1(_makeFlat(true));


/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(169);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Iterate over an input `list`, calling a provided function `fn` for each
	 * element in the list.
	 *
	 * `fn` receives one argument: *(value)*.
	 *
	 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.forEach` method. For more
	 * details on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
	 *
	 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
	 * the original array. In some libraries this function is named `each`.
	 *
	 * Dispatches to the `forEach` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig (a -> *) -> [a] -> [a]
	 * @param {Function} fn The function to invoke. Receives one argument, `value`.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} The original list.
	 * @see R.addIndex
	 * @example
	 *
	 *      var printXPlusFive = x => console.log(x + 5);
	 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
	 *      // logs 6
	 *      // logs 7
	 *      // logs 8
	 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
	 */
	module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
	  var len = list.length;
	  var idx = 0;
	  while (idx < len) {
	    fn(list[idx]);
	    idx += 1;
	  }
	  return list;
	}));


/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var keys = __webpack_require__(63);
	
	
	/**
	 * Iterate over an input `object`, calling a provided function `fn` for each
	 * key and value in the object.
	 *
	 * `fn` receives three argument: *(value, key, obj)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Object
	 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
	 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
	 * @param {Object} obj The object to iterate over.
	 * @return {Object} The original object.
	 * @example
	 *
	 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
	 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
	 *      // logs x:1
	 *      // logs y:2
	 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
	 */
	module.exports = _curry2(function forEachObjIndexed(fn, obj) {
	  var keyList = keys(obj);
	  var idx = 0;
	  while (idx < keyList.length) {
	    var key = keyList[idx];
	    fn(obj[key], key, obj);
	    idx += 1;
	  }
	  return obj;
	});


/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Creates a new object from a list key-value pairs. If a key appears in
	 * multiple pairs, the rightmost pair is included in the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [[k,v]] -> {k: v}
	 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
	 * @return {Object} The object made by pairing up `keys` and `values`.
	 * @see R.toPairs, R.pair
	 * @example
	 *
	 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry1(function fromPairs(pairs) {
	  var result = {};
	  var idx = 0;
	  while (idx < pairs.length) {
	    result[pairs[idx][0]] = pairs[idx][1];
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(169);
	var _curry2 = __webpack_require__(6);
	var reduceBy = __webpack_require__(231);
	
	/**
	 * Splits a list into sub-lists stored in an object, based on the result of
	 * calling a String-returning function on each element, and grouping the
	 * results according to values returned.
	 *
	 * Dispatches to the `groupBy` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> String) -> [a] -> {String: [a]}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} list The array to group
	 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
	 *         that produced that key when passed to `fn`.
	 * @see R.transduce
	 * @example
	 *
	 *      var byGrade = R.groupBy(function(student) {
	 *        var score = student.score;
	 *        return score < 65 ? 'F' :
	 *               score < 70 ? 'D' :
	 *               score < 80 ? 'C' :
	 *               score < 90 ? 'B' : 'A';
	 *      });
	 *      var students = [{name: 'Abby', score: 84},
	 *                      {name: 'Eddy', score: 58},
	 *                      // ...
	 *                      {name: 'Jack', score: 69}];
	 *      byGrade(students);
	 *      // {
	 *      //   'A': [{name: 'Dianne', score: 99}],
	 *      //   'B': [{name: 'Abby', score: 84}]
	 *      //   // ...,
	 *      //   'F': [{name: 'Eddy', score: 58}]
	 *      // }
	 */
	module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
	  if (acc == null) {
	    acc = [];
	  }
	  acc.push(item);
	  return acc;
	}, null)));


/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	/**
	 * Takes a list and returns a list of lists where each sublist's elements are
	 * all "equal" according to the provided equality function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.21.0
	 * @category List
	 * @sig ((a, a) → Boolean) → [a] → [[a]]
	 * @param {Function} fn Function for determining whether two given (adjacent)
	 *        elements should be in the same group
	 * @param {Array} list The array to group. Also accepts a string, which will be
	 *        treated as a list of characters.
	 * @return {List} A list that contains sublists of equal elements,
	 *         whose concatenations are equal to the original list.
	 * @example
	 *
	 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
	 *
	 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
	 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
	 *
	 * R.groupWith(R.eqBy(isVowel), 'aestiou')
	 * //=> ['ae', 'st', 'iou']
	 */
	module.exports = _curry2(function(fn, list) {
	  var res = [];
	  var idx = 0;
	  var len = list.length;
	  while (idx < len) {
	    var nextidx = idx + 1;
	    while (nextidx < len && fn(list[idx], list[nextidx])) {
	      nextidx += 1;
	    }
	    res.push(list.slice(idx, nextidx));
	    idx = nextidx;
	  }
	  return res;
	});


/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if the first argument is greater than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.lt
	 * @example
	 *
	 *      R.gt(2, 1); //=> true
	 *      R.gt(2, 2); //=> false
	 *      R.gt(2, 3); //=> false
	 *      R.gt('a', 'z'); //=> false
	 *      R.gt('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if the first argument is greater than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.lte
	 * @example
	 *
	 *      R.gte(2, 1); //=> true
	 *      R.gte(2, 2); //=> true
	 *      R.gte(2, 3); //=> false
	 *      R.gte('a', 'z'); //=> false
	 *      R.gte('z', 'a'); //=> true
	 */
	module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _has = __webpack_require__(52);
	
	
	/**
	 * Returns whether or not an object has an own property with the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      var hasName = R.has('name');
	 *      hasName({name: 'alice'});   //=> true
	 *      hasName({name: 'bob'});     //=> true
	 *      hasName({});                //=> false
	 *
	 *      var point = {x: 0, y: 0};
	 *      var pointHas = R.has(R.__, point);
	 *      pointHas('x');  //=> true
	 *      pointHas('y');  //=> true
	 *      pointHas('z');  //=> false
	 */
	module.exports = _curry2(_has);


/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns whether or not an object or its prototype chain has a property with
	 * the specified name
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Object
	 * @sig s -> {s: x} -> Boolean
	 * @param {String} prop The name of the property to check for.
	 * @param {Object} obj The object to query.
	 * @return {Boolean} Whether the property exists.
	 * @example
	 *
	 *      function Rectangle(width, height) {
	 *        this.width = width;
	 *        this.height = height;
	 *      }
	 *      Rectangle.prototype.area = function() {
	 *        return this.width * this.height;
	 *      };
	 *
	 *      var square = new Rectangle(2, 2);
	 *      R.hasIn('width', square);  //=> true
	 *      R.hasIn('area', square);  //=> true
	 */
	module.exports = _curry2(function hasIn(prop, obj) {
	  return prop in obj;
	});


/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	var nth = __webpack_require__(172);
	
	
	/**
	 * Returns the first element of the given list or string. In some libraries
	 * this function is named `first`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> a | Undefined
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {*}
	 * @see R.tail, R.init, R.last
	 * @example
	 *
	 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
	 *      R.head([]); //=> undefined
	 *
	 *      R.head('abc'); //=> 'a'
	 *      R.head(''); //=> ''
	 */
	module.exports = nth(0);


/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var curryN = __webpack_require__(49);
	
	
	/**
	 * Creates a function that will process either the `onTrue` or the `onFalse`
	 * function depending upon the result of the `condition` predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Logic
	 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
	 * @param {Function} condition A predicate function
	 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
	 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
	 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
	 *                    function depending upon the result of the `condition` predicate.
	 * @see R.unless, R.when
	 * @example
	 *
	 *      var incCount = R.ifElse(
	 *        R.has('count'),
	 *        R.over(R.lensProp('count'), R.inc),
	 *        R.assoc('count', 1)
	 *      );
	 *      incCount({});           //=> { count: 1 }
	 *      incCount({ count: 1 }); //=> { count: 2 }
	 */
	module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
	  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
	    function _ifElse() {
	      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
	    }
	  );
	});


/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	var add = __webpack_require__(219);
	
	
	/**
	 * Increments its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number} n + 1
	 * @see R.dec
	 * @example
	 *
	 *      R.inc(42); //=> 43
	 */
	module.exports = add(1);


/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	var reduceBy = __webpack_require__(231);
	
	
	/**
	 * Given a function that generates a key, turns a list of objects into an
	 * object indexing the objects by the given key. Note that if multiple
	 * objects generate the same value for the indexing key only the last value
	 * will be included in the generated object.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
	 * @param {Function} fn Function :: a -> String
	 * @param {Array} array The array of objects to index
	 * @return {Object} An object indexing each array element by the given property.
	 * @example
	 *
	 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
	 *      R.indexBy(R.prop('id'), list);
	 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
	 */
	module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _indexOf = __webpack_require__(705);
	var _isArray = __webpack_require__(102);
	
	
	/**
	 * Returns the position of the first occurrence of an item in an array, or -1
	 * if the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.lastIndexOf
	 * @example
	 *
	 *      R.indexOf(3, [1,2,3,4]); //=> 2
	 *      R.indexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function indexOf(target, xs) {
	  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
	    xs.indexOf(target) :
	    _indexOf(xs, target, 0);
	});


/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	var slice = __webpack_require__(118);
	
	
	/**
	 * Returns all but the last element of the given list or string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.last, R.head, R.tail
	 * @example
	 *
	 *      R.init([1, 2, 3]);  //=> [1, 2]
	 *      R.init([1, 2]);     //=> [1]
	 *      R.init([1]);        //=> []
	 *      R.init([]);         //=> []
	 *
	 *      R.init('abc');  //=> 'ab'
	 *      R.init('ab');   //=> 'a'
	 *      R.init('a');    //=> ''
	 *      R.init('');     //=> ''
	 */
	module.exports = slice(0, -1);


/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Inserts the supplied element into the list, at index `index`. _Note that
	 * this is not destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> a -> [a] -> [a]
	 * @param {Number} index The position to insert the element
	 * @param {*} elt The element to insert into the Array
	 * @param {Array} list The list to insert into
	 * @return {Array} A new Array with `elt` inserted at `index`.
	 * @example
	 *
	 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
	 */
	module.exports = _curry3(function insert(idx, elt, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(idx, 0, elt);
	  return result;
	});


/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Inserts the sub-list into the list, at index `index`. _Note that this is not
	 * destructive_: it returns a copy of the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category List
	 * @sig Number -> [a] -> [a] -> [a]
	 * @param {Number} index The position to insert the sub-list
	 * @param {Array} elts The sub-list to insert into the Array
	 * @param {Array} list The list to insert the sub-list into
	 * @return {Array} A new Array with `elts` inserted starting at `index`.
	 * @example
	 *
	 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
	 */
	module.exports = _curry3(function insertAll(idx, elts, list) {
	  idx = idx < list.length && idx >= 0 ? idx : list.length;
	  return [].concat(Array.prototype.slice.call(list, 0, idx),
	                   elts,
	                   Array.prototype.slice.call(list, idx));
	});


/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(117);
	
	
	// A simple Set type that honours R.equals semantics
	module.exports = (function() {
	  function _Set() {
	    /* globals Set */
	    this._nativeSet = typeof Set === 'function' ? new Set() : null;
	    this._items = {};
	  }
	
	  // until we figure out why jsdoc chokes on this
	  // @param item The item to add to the Set
	  // @returns {boolean} true if the item did not exist prior, otherwise false
	  //
	  _Set.prototype.add = function(item) {
	    return !hasOrAdd(item, true, this);
	  };
	
	  //
	  // @param item The item to check for existence in the Set
	  // @returns {boolean} true if the item exists in the Set, otherwise false
	  //
	  _Set.prototype.has = function(item) {
	    return hasOrAdd(item, false, this);
	  };
	
	  //
	  // Combines the logic for checking whether an item is a member of the set and
	  // for adding a new item to the set.
	  //
	  // @param item       The item to check or add to the Set instance.
	  // @param shouldAdd  If true, the item will be added to the set if it doesn't
	  //                   already exist.
	  // @param set        The set instance to check or add to.
	  // @return {boolean} true if the item already existed, otherwise false.
	  //
	  function hasOrAdd(item, shouldAdd, set) {
	    var type = typeof item;
	    var prevSize, newSize;
	    switch (type) {
	      case 'string':
	      case 'number':
	        // distinguish between +0 and -0
	        if (item === 0 && 1 / item === -Infinity) {
	          if (set._items['-0']) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items['-0'] = true;
	            }
	            return false;
	          }
	        }
	        // these types can all utilise the native Set
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = {};
	              set._items[type][item] = true;
	            }
	            return false;
	          } else if (item in set._items[type]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][item] = true;
	            }
	            return false;
	          }
	        }
	
	      case 'boolean':
	        // set._items['boolean'] holds a two element array
	        // representing [ falseExists, trueExists ]
	        if (type in set._items) {
	          var bIdx = item ? 1 : 0;
	          if (set._items[type][bIdx]) {
	            return true;
	          } else {
	            if (shouldAdd) {
	              set._items[type][bIdx] = true;
	            }
	            return false;
	          }
	        } else {
	          if (shouldAdd) {
	            set._items[type] = item ? [false, true] : [true, false];
	          }
	          return false;
	        }
	
	      case 'function':
	        // compare functions for reference equality
	        if (set._nativeSet !== null) {
	          if (shouldAdd) {
	            prevSize = set._nativeSet.size;
	            set._nativeSet.add(item);
	            newSize = set._nativeSet.size;
	            return newSize === prevSize;
	          } else {
	            return set._nativeSet.has(item);
	          }
	        } else {
	          if (!(type in set._items)) {
	            if (shouldAdd) {
	              set._items[type] = [item];
	            }
	            return false;
	          }
	          if (!_contains(item, set._items[type])) {
	            if (shouldAdd) {
	              set._items[type].push(item);
	            }
	            return false;
	          }
	          return true;
	        }
	
	      case 'undefined':
	        if (set._items[type]) {
	          return true;
	        } else {
	          if (shouldAdd) {
	            set._items[type] = true;
	          }
	          return false;
	        }
	
	      case 'object':
	        if (item === null) {
	          if (!set._items['null']) {
	            if (shouldAdd) {
	              set._items['null'] = true;
	            }
	            return false;
	          }
	          return true;
	        }
	      /* falls through */
	      default:
	        // reduce the search size of heterogeneous sets by creating buckets
	        // for each type.
	        type = Object.prototype.toString.call(item);
	        if (!(type in set._items)) {
	          if (shouldAdd) {
	            set._items[type] = [item];
	          }
	          return false;
	        }
	        // scan through all previously applied items
	        if (!_contains(item, set._items[type])) {
	          if (shouldAdd) {
	            set._items[type].push(item);
	          }
	          return false;
	        }
	        return true;
	    }
	  }
	  return _Set;
	}());


/***/ },
/* 2101 */
/***/ function(module, exports) {

	module.exports = function _aperture(n, list) {
	  var idx = 0;
	  var limit = list.length - (n - 1);
	  var acc = new Array(limit >= 0 ? limit : 0);
	  while (idx < limit) {
	    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
	    idx += 1;
	  }
	  return acc;
	};


/***/ },
/* 2102 */
/***/ function(module, exports) {

	module.exports = function _arrayFromIterator(iter) {
	  var list = [];
	  var next;
	  while (!(next = iter.next()).done) {
	    list.push(next.value);
	  }
	  return list;
	};


/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	var take = __webpack_require__(734);
	
	module.exports = function dropLast(n, xs) {
	  return take(n < xs.length ? xs.length - n : 0, xs);
	};


/***/ },
/* 2104 */
/***/ function(module, exports) {

	module.exports = function dropLastWhile(pred, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && pred(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx + 1);
	};


/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	var _arrayFromIterator = __webpack_require__(2102);
	var _functionName = __webpack_require__(2108);
	var _has = __webpack_require__(52);
	var identical = __webpack_require__(699);
	var keys = __webpack_require__(63);
	var type = __webpack_require__(339);
	
	
	module.exports = function _equals(a, b, stackA, stackB) {
	  if (identical(a, b)) {
	    return true;
	  }
	
	  if (type(a) !== type(b)) {
	    return false;
	  }
	
	  if (a == null || b == null) {
	    return false;
	  }
	
	  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
	    return typeof a.equals === 'function' && a.equals(b) &&
	           typeof b.equals === 'function' && b.equals(a);
	  }
	
	  switch (type(a)) {
	    case 'Arguments':
	    case 'Array':
	    case 'Object':
	      if (typeof a.constructor === 'function' &&
	          _functionName(a.constructor) === 'Promise') {
	        return a === b;
	      }
	      break;
	    case 'Boolean':
	    case 'Number':
	    case 'String':
	      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
	        return false;
	      }
	      break;
	    case 'Date':
	      if (!identical(a.valueOf(), b.valueOf())) {
	        return false;
	      }
	      break;
	    case 'Error':
	      return a.name === b.name && a.message === b.message;
	    case 'RegExp':
	      if (!(a.source === b.source &&
	            a.global === b.global &&
	            a.ignoreCase === b.ignoreCase &&
	            a.multiline === b.multiline &&
	            a.sticky === b.sticky &&
	            a.unicode === b.unicode)) {
	        return false;
	      }
	      break;
	    case 'Map':
	    case 'Set':
	      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
	        return false;
	      }
	      break;
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float32Array':
	    case 'Float64Array':
	      break;
	    case 'ArrayBuffer':
	      break;
	    default:
	      // Values of other types are only equal if identical.
	      return false;
	  }
	
	  var keysA = keys(a);
	  if (keysA.length !== keys(b).length) {
	    return false;
	  }
	
	  var idx = stackA.length - 1;
	  while (idx >= 0) {
	    if (stackA[idx] === a) {
	      return stackB[idx] === b;
	    }
	    idx -= 1;
	  }
	
	  stackA.push(a);
	  stackB.push(b);
	  idx = keysA.length - 1;
	  while (idx >= 0) {
	    var key = keysA[idx];
	    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
	      return false;
	    }
	    idx -= 1;
	  }
	  stackA.pop();
	  stackB.pop();
	  return true;
	};


/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	var _forceReduced = __webpack_require__(2107);
	var _reduce = __webpack_require__(62);
	var _xfBase = __webpack_require__(43);
	var isArrayLike = __webpack_require__(171);
	
	module.exports = (function() {
	  var preservingReduced = function(xf) {
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return xf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        var ret = xf['@@transducer/step'](result, input);
	        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
	      }
	    };
	  };
	
	  return function _xcat(xf) {
	    var rxf = preservingReduced(xf);
	    return {
	      '@@transducer/init': _xfBase.init,
	      '@@transducer/result': function(result) {
	        return rxf['@@transducer/result'](result);
	      },
	      '@@transducer/step': function(result, input) {
	        return !isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
	      }
	    };
	  };
	}());


/***/ },
/* 2107 */
/***/ function(module, exports) {

	module.exports = function _forceReduced(x) {
	  return {
	    '@@transducer/value': x,
	    '@@transducer/reduced': true
	  };
	};


/***/ },
/* 2108 */
/***/ function(module, exports) {

	module.exports = function _functionName(f) {
	  // String(x => x) evaluates to "x => x", so the pattern may not match.
	  var match = String(f).match(/^function (\w*)/);
	  return match == null ? '' : match[1];
	};


/***/ },
/* 2109 */
/***/ function(module, exports) {

	module.exports = function _isRegExp(x) {
	  return Object.prototype.toString.call(x) === '[object RegExp]';
	};


/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(52);
	
	// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	module.exports = function _objectAssign(target) {
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  var output = Object(target);
	  var idx = 1;
	  var length = arguments.length;
	  while (idx < length) {
	    var source = arguments[idx];
	    if (source != null) {
	      for (var nextKey in source) {
	        if (_has(nextKey, source)) {
	          output[nextKey] = source[nextKey];
	        }
	      }
	    }
	    idx += 1;
	  }
	  return output;
	};


/***/ },
/* 2111 */
/***/ function(module, exports) {

	module.exports = function _of(x) { return [x]; };


/***/ },
/* 2112 */
/***/ function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ },
/* 2113 */
/***/ function(module, exports) {

	module.exports = function _pipeP(f, g) {
	  return function() {
	    var ctx = this;
	    return f.apply(ctx, arguments).then(function(x) {
	      return g.call(ctx, x);
	    });
	  };
	};


/***/ },
/* 2114 */
/***/ function(module, exports) {

	module.exports = function _quote(s) {
	  var escaped = s
	    .replace(/\\/g, '\\\\')
	    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
	    .replace(/\f/g, '\\f')
	    .replace(/\n/g, '\\n')
	    .replace(/\r/g, '\\r')
	    .replace(/\t/g, '\\t')
	    .replace(/\v/g, '\\v')
	    .replace(/\0/g, '\\0');
	
	  return '"' + escaped.replace(/"/g, '\\"') + '"';
	};


/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(333);
	var _identity = __webpack_require__(335);
	var _isTransformer = __webpack_require__(336);
	var isArrayLike = __webpack_require__(171);
	var objOf = __webpack_require__(723);
	
	
	module.exports = (function() {
	  var _stepCatArray = {
	    '@@transducer/init': Array,
	    '@@transducer/step': function(xs, x) {
	      xs.push(x);
	      return xs;
	    },
	    '@@transducer/result': _identity
	  };
	  var _stepCatString = {
	    '@@transducer/init': String,
	    '@@transducer/step': function(a, b) { return a + b; },
	    '@@transducer/result': _identity
	  };
	  var _stepCatObject = {
	    '@@transducer/init': Object,
	    '@@transducer/step': function(result, input) {
	      return _assign(
	        result,
	        isArrayLike(input) ? objOf(input[0], input[1]) : input
	      );
	    },
	    '@@transducer/result': _identity
	  };
	
	  return function _stepCat(obj) {
	    if (_isTransformer(obj)) {
	      return obj;
	    }
	    if (isArrayLike(obj)) {
	      return _stepCatArray;
	    }
	    if (typeof obj === 'string') {
	      return _stepCatString;
	    }
	    if (typeof obj === 'object') {
	      return _stepCatObject;
	    }
	    throw new Error('Cannot create transformer for ' + obj);
	  };
	}());


/***/ },
/* 2116 */
/***/ function(module, exports) {

	/**
	 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
	 */
	module.exports = (function() {
	  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };
	
	  return typeof Date.prototype.toISOString === 'function' ?
	    function _toISOString(d) {
	      return d.toISOString();
	    } :
	    function _toISOString(d) {
	      return (
	        d.getUTCFullYear() + '-' +
	        pad(d.getUTCMonth() + 1) + '-' +
	        pad(d.getUTCDate()) + 'T' +
	        pad(d.getUTCHours()) + ':' +
	        pad(d.getUTCMinutes()) + ':' +
	        pad(d.getUTCSeconds()) + '.' +
	        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
	      );
	    };
	}());


/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(117);
	var _map = __webpack_require__(227);
	var _quote = __webpack_require__(2114);
	var _toISOString = __webpack_require__(2116);
	var keys = __webpack_require__(63);
	var reject = __webpack_require__(232);
	
	
	module.exports = function _toString(x, seen) {
	  var recur = function recur(y) {
	    var xs = seen.concat([x]);
	    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
	  };
	
	  //  mapPairs :: (Object, [String]) -> [String]
	  var mapPairs = function(obj, keys) {
	    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
	  };
	
	  switch (Object.prototype.toString.call(x)) {
	    case '[object Arguments]':
	      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
	    case '[object Array]':
	      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
	    case '[object Boolean]':
	      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
	    case '[object Date]':
	      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
	    case '[object Null]':
	      return 'null';
	    case '[object Number]':
	      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
	    case '[object String]':
	      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
	    case '[object Undefined]':
	      return 'undefined';
	    default:
	      if (typeof x.toString === 'function') {
	        var repr = x.toString();
	        if (repr !== '[object Object]') {
	          return repr;
	        }
	      }
	      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
	  }
	};


/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduced = __webpack_require__(103);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XAll(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.all = true;
	  }
	  XAll.prototype['@@transducer/init'] = _xfBase.init;
	  XAll.prototype['@@transducer/result'] = function(result) {
	    if (this.all) {
	      result = this.xf['@@transducer/step'](result, true);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XAll.prototype['@@transducer/step'] = function(result, input) {
	    if (!this.f(input)) {
	      this.all = false;
	      result = _reduced(this.xf['@@transducer/step'](result, false));
	    }
	    return result;
	  };
	
	  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
	}());


/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XAperture(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XAperture.prototype['@@transducer/init'] = _xfBase.init;
	  XAperture.prototype['@@transducer/result'] = function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XAperture.prototype['@@transducer/step'] = function(result, input) {
	    this.store(input);
	    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
	  };
	  XAperture.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	  XAperture.prototype.getCopy = function() {
	    return _concat(Array.prototype.slice.call(this.acc, this.pos),
	                   Array.prototype.slice.call(this.acc, 0, this.pos));
	  };
	
	  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
	}());


/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _flatCat = __webpack_require__(2106);
	var map = __webpack_require__(59);
	
	
	module.exports = _curry2(function _xchain(f, xf) {
	  return map(f, _flatCat(xf));
	});


/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XDrop(n, xf) {
	    this.xf = xf;
	    this.n = n;
	  }
	  XDrop.prototype['@@transducer/init'] = _xfBase.init;
	  XDrop.prototype['@@transducer/result'] = _xfBase.result;
	  XDrop.prototype['@@transducer/step'] = function(result, input) {
	    if (this.n > 0) {
	      this.n -= 1;
	      return result;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
	}());


/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XDropLast(n, xf) {
	    this.xf = xf;
	    this.pos = 0;
	    this.full = false;
	    this.acc = new Array(n);
	  }
	  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLast.prototype['@@transducer/result'] =  function(result) {
	    this.acc = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.full) {
	      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
	    }
	    this.store(input);
	    return result;
	  };
	  XDropLast.prototype.store = function(input) {
	    this.acc[this.pos] = input;
	    this.pos += 1;
	    if (this.pos === this.acc.length) {
	      this.pos = 0;
	      this.full = true;
	    }
	  };
	
	  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
	}());


/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduce = __webpack_require__(62);
	var _xfBase = __webpack_require__(43);
	
	module.exports = (function() {
	  function XDropLastWhile(fn, xf) {
	    this.f = fn;
	    this.retained = [];
	    this.xf = xf;
	  }
	  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
	    this.retained = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.retain(result, input)
	                         : this.flush(result, input);
	  };
	  XDropLastWhile.prototype.flush = function(result, input) {
	    result = _reduce(
	      this.xf['@@transducer/step'],
	      result,
	      this.retained
	    );
	    this.retained = [];
	    return this.xf['@@transducer/step'](result, input);
	  };
	  XDropLastWhile.prototype.retain = function(result, input) {
	    this.retained.push(input);
	    return result;
	  };
	
	  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
	}());


/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XDropWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f) {
	      if (this.f(input)) {
	        return result;
	      }
	      this.f = null;
	    }
	    return this.xf['@@transducer/step'](result, input);
	  };
	
	  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
	}());


/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XFilter(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFilter.prototype['@@transducer/init'] = _xfBase.init;
	  XFilter.prototype['@@transducer/result'] = _xfBase.result;
	  XFilter.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
	  };
	
	  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
	}());


/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduced = __webpack_require__(103);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XFind(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.found = false;
	  }
	  XFind.prototype['@@transducer/init'] = _xfBase.init;
	  XFind.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, void 0);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFind.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, input));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
	}());


/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduced = __webpack_require__(103);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XFindIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.found = false;
	  }
	  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindIndex.prototype['@@transducer/result'] = function(result) {
	    if (!this.found) {
	      result = this.xf['@@transducer/step'](result, -1);
	    }
	    return this.xf['@@transducer/result'](result);
	  };
	  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.found = true;
	      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
	}());


/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XFindLast(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLast.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
	  };
	  XFindLast.prototype['@@transducer/step'] = function(result, input) {
	    if (this.f(input)) {
	      this.last = input;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
	}());


/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XFindLastIndex(f, xf) {
	    this.xf = xf;
	    this.f = f;
	    this.idx = -1;
	    this.lastIdx = -1;
	  }
	  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
	  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
	    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
	  };
	  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
	    this.idx += 1;
	    if (this.f(input)) {
	      this.lastIdx = this.idx;
	    }
	    return result;
	  };
	
	  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
	}());


/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XMap(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XMap.prototype['@@transducer/init'] = _xfBase.init;
	  XMap.prototype['@@transducer/result'] = _xfBase.result;
	  XMap.prototype['@@transducer/step'] = function(result, input) {
	    return this.xf['@@transducer/step'](result, this.f(input));
	  };
	
	  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
	}());


/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(223);
	var _has = __webpack_require__(52);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
	    this.valueFn = valueFn;
	    this.valueAcc = valueAcc;
	    this.keyFn = keyFn;
	    this.xf = xf;
	    this.inputs = {};
	  }
	  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
	  XReduceBy.prototype['@@transducer/result'] = function(result) {
	    var key;
	    for (key in this.inputs) {
	      if (_has(key, this.inputs)) {
	        result = this.xf['@@transducer/step'](result, this.inputs[key]);
	        if (result['@@transducer/reduced']) {
	          result = result['@@transducer/value'];
	          break;
	        }
	      }
	    }
	    this.inputs = null;
	    return this.xf['@@transducer/result'](result);
	  };
	  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
	    var key = this.keyFn(input);
	    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
	    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
	    return result;
	  };
	
	  return _curryN(4, [],
	                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
	                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
	                 });
	}());


/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduced = __webpack_require__(103);
	var _xfBase = __webpack_require__(43);
	
	module.exports = (function() {
	  function XTake(n, xf) {
	    this.xf = xf;
	    this.n = n;
	    this.i = 0;
	  }
	  XTake.prototype['@@transducer/init'] = _xfBase.init;
	  XTake.prototype['@@transducer/result'] = _xfBase.result;
	  XTake.prototype['@@transducer/step'] = function(result, input) {
	    this.i += 1;
	    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
	    return this.i >= this.n ? _reduced(ret) : ret;
	  };
	
	  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
	}());


/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduced = __webpack_require__(103);
	var _xfBase = __webpack_require__(43);
	
	
	module.exports = (function() {
	  function XTakeWhile(f, xf) {
	    this.xf = xf;
	    this.f = f;
	  }
	  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
	  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
	  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
	    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
	  };
	
	  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
	}());


/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(117);
	var _curry2 = __webpack_require__(6);
	var _filter = __webpack_require__(704);
	var flip = __webpack_require__(222);
	var uniq = __webpack_require__(340);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The list of elements found in both `list1` and `list2`.
	 * @see R.intersectionWith
	 * @example
	 *
	 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
	 */
	module.exports = _curry2(function intersection(list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  return uniq(_filter(flip(_contains)(lookupList), filteredList));
	});


/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	var _containsWith = __webpack_require__(334);
	var _curry3 = __webpack_require__(13);
	var uniqWith = __webpack_require__(341);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of those
	 * elements common to both lists. Duplication is determined according to the
	 * value returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate function that determines whether
	 *        the two supplied elements are equal.
	 * @param {Array} list1 One list of items to compare
	 * @param {Array} list2 A second list of items to compare
	 * @return {Array} A new list containing those elements common to both lists.
	 * @see R.intersection
	 * @example
	 *
	 *      var buffaloSpringfield = [
	 *        {id: 824, name: 'Richie Furay'},
	 *        {id: 956, name: 'Dewey Martin'},
	 *        {id: 313, name: 'Bruce Palmer'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *      var csny = [
	 *        {id: 204, name: 'David Crosby'},
	 *        {id: 456, name: 'Stephen Stills'},
	 *        {id: 539, name: 'Graham Nash'},
	 *        {id: 177, name: 'Neil Young'}
	 *      ];
	 *
	 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
	 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
	 */
	module.exports = _curry3(function intersectionWith(pred, list1, list2) {
	  var lookupList, filteredList;
	  if (list1.length > list2.length) {
	    lookupList = list1;
	    filteredList = list2;
	  } else {
	    lookupList = list2;
	    filteredList = list1;
	  }
	  var results = [];
	  var idx = 0;
	  while (idx < filteredList.length) {
	    if (_containsWith(pred, filteredList[idx], lookupList)) {
	      results[results.length] = filteredList[idx];
	    }
	    idx += 1;
	  }
	  return uniqWith(pred, results);
	});


/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(169);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Creates a new list with the separator interposed between elements.
	 *
	 * Dispatches to the `intersperse` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category List
	 * @sig a -> [a] -> [a]
	 * @param {*} separator The element to add to the list.
	 * @param {Array} list The list to be interposed.
	 * @return {Array} The new list.
	 * @example
	 *
	 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
	 */
	module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
	  var out = [];
	  var idx = 0;
	  var length = list.length;
	  while (idx < length) {
	    if (idx === length - 1) {
	      out.push(list[idx]);
	    } else {
	      out.push(list[idx], separator);
	    }
	    idx += 1;
	  }
	  return out;
	}));


/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	var _clone = __webpack_require__(700);
	var _curry3 = __webpack_require__(13);
	var _isTransformer = __webpack_require__(336);
	var _reduce = __webpack_require__(62);
	var _stepCat = __webpack_require__(2115);
	
	
	/**
	 * Transforms the items of the list with the transducer and appends the
	 * transformed items to the accumulator using an appropriate iterator function
	 * based on the accumulator type.
	 *
	 * The accumulator can be an array, string, object or a transformer. Iterated
	 * items will be appended to arrays and concatenated to strings. Objects will
	 * be merged directly or 2-item arrays will be merged as key, value pairs.
	 *
	 * The accumulator can also be a transformer object that provides a 2-arity
	 * reducing iterator function, step, 0-arity initial value function, init, and
	 * 1-arity result extraction function result. The step function is used as the
	 * iterator function in reduce. The result function is used to convert the
	 * final accumulator into the return type and in most cases is R.identity. The
	 * init function is used to provide the initial accumulator.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig a -> (b -> b) -> [c] -> a
	 * @param {*} acc The initial accumulator value.
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.into([], transducer, numbers); //=> [2, 3]
	 *
	 *      var intoArray = R.into([]);
	 *      intoArray(transducer, numbers); //=> [2, 3]
	 */
	module.exports = _curry3(function into(acc, xf, list) {
	  return _isTransformer(acc) ?
	    _reduce(xf(acc), acc['@@transducer/init'](), list) :
	    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
	});


/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _has = __webpack_require__(52);
	var keys = __webpack_require__(63);
	
	
	/**
	 * Same as R.invertObj, however this accounts for objects with duplicate values
	 * by putting the values into an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: [ s, ... ]}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object with keys
	 * in an array.
	 * @example
	 *
	 *      var raceResultsByFirstName = {
	 *        first: 'alice',
	 *        second: 'jake',
	 *        third: 'alice',
	 *      };
	 *      R.invert(raceResultsByFirstName);
	 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
	 */
	module.exports = _curry1(function invert(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    var val = obj[key];
	    var list = _has(val, out) ? out[val] : (out[val] = []);
	    list[list.length] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var keys = __webpack_require__(63);
	
	
	/**
	 * Returns a new object with the keys of the given object as values, and the
	 * values of the given object, which are coerced to strings, as keys. Note
	 * that the last key found is preferred when handling the same value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig {s: x} -> {x: s}
	 * @param {Object} obj The object or array to invert
	 * @return {Object} out A new object
	 * @example
	 *
	 *      var raceResults = {
	 *        first: 'alice',
	 *        second: 'jake'
	 *      };
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': 'first', 'jake':'second' }
	 *
	 *      // Alternatively:
	 *      var raceResults = ['alice', 'jake'];
	 *      R.invertObj(raceResults);
	 *      //=> { 'alice': '0', 'jake':'1' }
	 */
	module.exports = _curry1(function invertObj(obj) {
	  var props = keys(obj);
	  var len = props.length;
	  var idx = 0;
	  var out = {};
	
	  while (idx < len) {
	    var key = props[idx];
	    out[obj[key]] = key;
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var empty = __webpack_require__(698);
	var equals = __webpack_require__(81);
	
	
	/**
	 * Returns `true` if the given value is its type's empty value; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Logic
	 * @sig a -> Boolean
	 * @param {*} x
	 * @return {Boolean}
	 * @see R.empty
	 * @example
	 *
	 *      R.isEmpty([1, 2, 3]);   //=> false
	 *      R.isEmpty([]);          //=> true
	 *      R.isEmpty('');          //=> true
	 *      R.isEmpty(null);        //=> false
	 *      R.isEmpty({});          //=> true
	 *      R.isEmpty({length: 0}); //=> false
	 */
	module.exports = _curry1(function isEmpty(x) {
	  return x != null && equals(x, empty(x));
	});


/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Checks if the input value is `null` or `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Type
	 * @sig * -> Boolean
	 * @param {*} x The value to test.
	 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
	 * @example
	 *
	 *      R.isNil(null); //=> true
	 *      R.isNil(undefined); //=> true
	 *      R.isNil(0); //=> false
	 *      R.isNil([]); //=> false
	 */
	module.exports = _curry1(function isNil(x) { return x == null; });


/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(170);
	
	
	/**
	 * Returns a string made by inserting the `separator` between each element and
	 * concatenating all the elements into a single string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig String -> [a] -> String
	 * @param {Number|String} separator The string used to separate the elements.
	 * @param {Array} xs The elements to join into a string.
	 * @return {String} str The string made by concatenating `xs` with `separator`.
	 * @see R.split
	 * @example
	 *
	 *      var spacer = R.join(' ');
	 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
	 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
	 */
	module.exports = invoker(1, 'join');


/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Returns a list containing the names of all the properties of the supplied
	 * object, including prototype properties.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.keysIn(f); //=> ['x', 'y']
	 */
	module.exports = _curry1(function keysIn(obj) {
	  var prop;
	  var ks = [];
	  for (prop in obj) {
	    ks[ks.length] = prop;
	  }
	  return ks;
	});


/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isArray = __webpack_require__(102);
	var equals = __webpack_require__(81);
	
	
	/**
	 * Returns the position of the last occurrence of an item in an array, or -1 if
	 * the item is not included in the array. `R.equals` is used to determine
	 * equality.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig a -> [a] -> Number
	 * @param {*} target The item to find.
	 * @param {Array} xs The array to search in.
	 * @return {Number} the index of the target, or -1 if the target is not found.
	 * @see R.indexOf
	 * @example
	 *
	 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
	 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
	 */
	module.exports = _curry2(function lastIndexOf(target, xs) {
	  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
	    return xs.lastIndexOf(target);
	  } else {
	    var idx = xs.length - 1;
	    while (idx >= 0) {
	      if (equals(xs[idx], target)) {
	        return idx;
	      }
	      idx -= 1;
	    }
	    return -1;
	  }
	});


/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var lens = __webpack_require__(228);
	var nth = __webpack_require__(172);
	var update = __webpack_require__(737);
	
	
	/**
	 * Returns a lens whose focus is the specified index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Number -> Lens s a
	 * @param {Number} n
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var headLens = R.lensIndex(0);
	 *
	 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
	 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
	 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
	 */
	module.exports = _curry1(function lensIndex(n) {
	  return lens(nth(n), update(n));
	});


/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var assocPath = __webpack_require__(688);
	var lens = __webpack_require__(228);
	var path = __webpack_require__(173);
	
	
	/**
	 * Returns a lens whose focus is the specified path.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig [Idx] -> Lens s a
	 * @param {Array} path The path to use.
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
	 *
	 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> 2
	 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
	 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
	 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
	 */
	module.exports = _curry1(function lensPath(p) {
	  return lens(path(p), assocPath(p));
	});


/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var assoc = __webpack_require__(168);
	var lens = __webpack_require__(228);
	var prop = __webpack_require__(337);
	
	
	/**
	 * Returns a lens whose focus is the specified property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig String -> Lens s a
	 * @param {String} k
	 * @return {Lens}
	 * @see R.view, R.set, R.over
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});            //=> 1
	 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
	 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
	 */
	module.exports = _curry1(function lensProp(k) {
	  return lens(prop(k), assoc(k));
	});


/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if the first argument is less than the second; `false`
	 * otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {*} a
	 * @param {*} b
	 * @return {Boolean}
	 * @see R.gt
	 * @example
	 *
	 *      R.lt(2, 1); //=> false
	 *      R.lt(2, 2); //=> false
	 *      R.lt(2, 3); //=> true
	 *      R.lt('a', 'z'); //=> true
	 *      R.lt('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns `true` if the first argument is less than or equal to the second;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> Boolean
	 * @param {Number} a
	 * @param {Number} b
	 * @return {Boolean}
	 * @see R.gte
	 * @example
	 *
	 *      R.lte(2, 1); //=> false
	 *      R.lte(2, 2); //=> true
	 *      R.lte(2, 3); //=> true
	 *      R.lte('a', 'z'); //=> true
	 *      R.lte('z', 'a'); //=> false
	 */
	module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * The mapAccum function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from left to right, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * The iterator function receives two arguments, *acc* and *value*, and should
	 * return a tuple *[acc, value]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccumRight
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var appender = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
	 * @symb R.mapAccum(f, a, [b, c, d]) = [
	 *   f(f(f(a, b)[0], c)[0], d)[0],
	 *   [
	 *     f(a, b)[1],
	 *     f(f(a, b)[0], c)[1],
	 *     f(f(f(a, b)[0], c)[0], d)[1]
	 *   ]
	 * ]
	 */
	module.exports = _curry3(function mapAccum(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [];
	  var tuple = [acc];
	  while (idx < len) {
	    tuple = fn(tuple[0], list[idx]);
	    result[idx] = tuple[1];
	    idx += 1;
	  }
	  return [tuple[0], result];
	});


/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * The mapAccumRight function behaves like a combination of map and reduce; it
	 * applies a function to each element of a list, passing an accumulating
	 * parameter from right to left, and returning a final value of this
	 * accumulator together with the new list.
	 *
	 * Similar to `mapAccum`, except moves through the input list from the right to
	 * the left.
	 *
	 * The iterator function receives two arguments, *value* and *acc*, and should
	 * return a tuple *[value, acc]*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
	 * @param {Function} fn The function to be called on every element of the input `list`.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.addIndex, R.mapAccum
	 * @example
	 *
	 *      var digits = ['1', '2', '3', '4'];
	 *      var append = (a, b) => [a + b, a + b];
	 *
	 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
	 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
	 *   [
	 *     f(b, f(c, f(d, a)[0])[0])[1],
	 *     f(c, f(d, a)[0])[1],
	 *     f(d, a)[1],
	 *   ]
	 *   f(b, f(c, f(d, a)[0])[0])[0],
	 * ]
	 */
	module.exports = _curry3(function mapAccumRight(fn, acc, list) {
	  var idx = list.length - 1;
	  var result = [];
	  var tuple = [acc];
	  while (idx >= 0) {
	    tuple = fn(list[idx], tuple[0]);
	    result[idx] = tuple[1];
	    idx -= 1;
	  }
	  return [result, tuple[0]];
	});


/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _reduce = __webpack_require__(62);
	var keys = __webpack_require__(63);
	
	
	/**
	 * An Object-specific version of `map`. The function is applied to three
	 * arguments: *(value, key, obj)*. If only the value is significant, use
	 * `map` instead.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Object
	 * @sig ((*, String, Object) -> *) -> Object -> Object
	 * @param {Function} fn
	 * @param {Object} obj
	 * @return {Object}
	 * @see R.map
	 * @example
	 *
	 *      var values = { x: 1, y: 2, z: 3 };
	 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
	 *
	 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
	 */
	module.exports = _curry2(function mapObjIndexed(fn, obj) {
	  return _reduce(function(acc, key) {
	    acc[key] = fn(obj[key], key, obj);
	    return acc;
	  }, {}, keys(obj));
	});


/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Tests a regular expression against a String. Note that this function will
	 * return an empty array when there are no matches. This differs from
	 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
	 * which returns `null` when there are no matches.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig RegExp -> String -> [String | Undefined]
	 * @param {RegExp} rx A regular expression.
	 * @param {String} str The string to match against
	 * @return {Array} The list of matches or empty array.
	 * @see R.test
	 * @example
	 *
	 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
	 *      R.match(/a/, 'b'); //=> []
	 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
	 */
	module.exports = _curry2(function match(rx, str) {
	  return str.match(rx) || [];
	});


/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isInteger = __webpack_require__(707);
	
	
	/**
	 * mathMod behaves like the modulo operator should mathematically, unlike the
	 * `%` operator (and by extension, R.modulo). So while "-17 % 5" is -2,
	 * mathMod(-17, 5) is 3. mathMod requires Integer arguments, and returns NaN
	 * when the modulus is zero or negative.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} m The dividend.
	 * @param {Number} p the modulus.
	 * @return {Number} The result of `b mod a`.
	 * @example
	 *
	 *      R.mathMod(-17, 5);  //=> 3
	 *      R.mathMod(17, 5);   //=> 2
	 *      R.mathMod(17, -5);  //=> NaN
	 *      R.mathMod(17, 0);   //=> NaN
	 *      R.mathMod(17.2, 5); //=> NaN
	 *      R.mathMod(17, 5.3); //=> NaN
	 *
	 *      var clock = R.mathMod(R.__, 12);
	 *      clock(15); //=> 3
	 *      clock(24); //=> 0
	 *
	 *      var seventeenMod = R.mathMod(17);
	 *      seventeenMod(3);  //=> 2
	 *      seventeenMod(4);  //=> 1
	 *      seventeenMod(10); //=> 7
	 */
	module.exports = _curry2(function mathMod(m, p) {
	  if (!_isInteger(m)) { return NaN; }
	  if (!_isInteger(p) || p < 1) { return NaN; }
	  return ((m % p) + p) % p;
	});


/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * larger result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.max, R.minBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.maxBy(square, -3, 2); //=> -3
	 *
	 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
	 *      R.reduce(R.maxBy(square), 0, []); //=> 0
	 */
	module.exports = _curry3(function maxBy(f, a, b) {
	  return f(b) > f(a) ? b : a;
	});


/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var mean = __webpack_require__(719);
	
	
	/**
	 * Returns the median of the given list of numbers.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list
	 * @return {Number}
	 * @example
	 *
	 *      R.median([2, 9, 7]); //=> 7
	 *      R.median([7, 2, 10, 9]); //=> 8
	 *      R.median([]); //=> NaN
	 */
	module.exports = _curry1(function median(list) {
	  var len = list.length;
	  if (len === 0) {
	    return NaN;
	  }
	  var width = 2 - len % 2;
	  var idx = (len - width) / 2;
	  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    return a < b ? -1 : a > b ? 1 : 0;
	  }).slice(idx, idx + width));
	});


/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _curry1 = __webpack_require__(12);
	var _has = __webpack_require__(52);
	var toString = __webpack_require__(175);
	
	
	/**
	 * Creates a new function that, when invoked, caches the result of calling `fn`
	 * for a given argument set and returns the result. Subsequent calls to the
	 * memoized `fn` with the same argument set will not result in an additional
	 * call to `fn`; instead, the cached result for that set of arguments will be
	 * returned.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (*... -> a) -> (*... -> a)
	 * @param {Function} fn The function to memoize.
	 * @return {Function} Memoized version of `fn`.
	 * @example
	 *
	 *      var count = 0;
	 *      var factorial = R.memoize(n => {
	 *        count += 1;
	 *        return R.product(R.range(1, n + 1));
	 *      });
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      factorial(5); //=> 120
	 *      count; //=> 1
	 */
	module.exports = _curry1(function memoize(fn) {
	  var cache = {};
	  return _arity(fn.length, function() {
	    var key = toString(arguments);
	    if (!_has(key, cache)) {
	      cache[key] = fn.apply(this, arguments);
	    }
	    return cache[key];
	  });
	});


/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(333);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Create a new object with the own properties of the first object merged with
	 * the own properties of the second object. If a key exists in both objects,
	 * the value from the second object will be used.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> {k: v} -> {k: v}
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.mergeWith, R.mergeWithKey
	 * @example
	 *
	 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
	 *      //=> { 'name': 'fred', 'age': 40 }
	 *
	 *      var resetToDefault = R.merge(R.__, {x: 0});
	 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
	 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
	 */
	module.exports = _curry2(function merge(l, r) {
	  return _assign({}, l, r);
	});


/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	var _assign = __webpack_require__(333);
	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Merges a list of objects together into one object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig [{k: v}] -> {k: v}
	 * @param {Array} list An array of objects
	 * @return {Object} A merged object.
	 * @see R.reduce
	 * @example
	 *
	 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
	 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
	 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
	 */
	module.exports = _curry1(function mergeAll(list) {
	  return _assign.apply(null, [{}].concat(list));
	});


/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var mergeWithKey = __webpack_require__(720);
	
	
	/**
	 * Creates a new object with the own properties of the two provided objects. If
	 * a key exists in both objects, the provided function is applied to the values
	 * associated with the key in each object, with the result being used as the
	 * value associated with the key in the returned object. The key will be
	 * excluded from the returned object if the resulting value is `undefined`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Object
	 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
	 * @param {Function} fn
	 * @param {Object} l
	 * @param {Object} r
	 * @return {Object}
	 * @see R.merge, R.mergeWithKey
	 * @example
	 *
	 *      R.mergeWith(R.concat,
	 *                  { a: true, values: [10, 20] },
	 *                  { b: true, values: [15, 35] });
	 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
	 */
	module.exports = _curry3(function mergeWith(fn, l, r) {
	  return mergeWithKey(function(_, _l, _r) {
	    return fn(_l, _r);
	  }, l, r);
	});


/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns the smaller of its two arguments.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord a => a -> a -> a
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.minBy, R.max
	 * @example
	 *
	 *      R.min(789, 123); //=> 123
	 *      R.min('a', 'b'); //=> 'a'
	 */
	module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Takes a function and two values, and returns whichever value produces the
	 * smaller result when passed to the provided function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> a -> a -> a
	 * @param {Function} f
	 * @param {*} a
	 * @param {*} b
	 * @return {*}
	 * @see R.min, R.maxBy
	 * @example
	 *
	 *      //  square :: Number -> Number
	 *      var square = n => n * n;
	 *
	 *      R.minBy(square, -3, 2); //=> 2
	 *
	 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
	 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
	 */
	module.exports = _curry3(function minBy(f, a, b) {
	  return f(b) < f(a) ? b : a;
	});


/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Divides the first parameter by the second and returns the remainder. Note
	 * that this function preserves the JavaScript-style behavior for modulo. For
	 * mathematical modulo see `mathMod`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The value to the divide.
	 * @param {Number} b The pseudo-modulus
	 * @return {Number} The result of `b % a`.
	 * @see R.mathMod
	 * @example
	 *
	 *      R.modulo(17, 3); //=> 2
	 *      // JS behavior:
	 *      R.modulo(-17, 3); //=> -2
	 *      R.modulo(17, -3); //=> 2
	 *
	 *      var isOdd = R.modulo(R.__, 2);
	 *      isOdd(42); //=> 0
	 *      isOdd(21); //=> 1
	 */
	module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Negates its argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Math
	 * @sig Number -> Number
	 * @param {Number} n
	 * @return {Number}
	 * @example
	 *
	 *      R.negate(42); //=> -42
	 */
	module.exports = _curry1(function negate(n) { return -n; });


/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	var _complement = __webpack_require__(702);
	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xany = __webpack_require__(711);
	var any = __webpack_require__(686);
	
	
	/**
	 * Returns `true` if no elements of the list match the predicate, `false`
	 * otherwise.
	 *
	 * Dispatches to the `any` method of the second argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> Boolean
	 * @param {Function} fn The predicate function.
	 * @param {Array} list The array to consider.
	 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
	 * @see R.all, R.any
	 * @example
	 *
	 *      var isEven = n => n % 2 === 0;
	 *
	 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
	 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
	 */
	module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var curryN = __webpack_require__(49);
	var nth = __webpack_require__(172);
	
	
	/**
	 * Returns a function which returns its nth argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category Function
	 * @sig Number -> *... -> *
	 * @param {Number} n
	 * @return {Function}
	 * @example
	 *
	 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
	 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
	 * @symb R.nthArg(-1)(a, b, c) = c
	 * @symb R.nthArg(0)(a, b, c) = a
	 * @symb R.nthArg(1)(a, b, c) = b
	 */
	module.exports = _curry1(function nthArg(n) {
	  var arity = n < 0 ? 1 : n + 1;
	  return curryN(arity, function() {
	    return nth(n, arguments);
	  });
	});


/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _of = __webpack_require__(2111);
	
	
	/**
	 * Returns a singleton array containing the value provided.
	 *
	 * Note this `of` is different from the ES6 `of`; See
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category Function
	 * @sig a -> [a]
	 * @param {*} x any value
	 * @return {Array} An array wrapping `x`.
	 * @example
	 *
	 *      R.of(null); //=> [null]
	 *      R.of([42]); //=> [[42]]
	 */
	module.exports = _curry1(_of);


/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(117);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a partial copy of an object omitting the keys specified.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [String] -> {String: *} -> {String: *}
	 * @param {Array} names an array of String property names to omit from the new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with properties from `names` not on it.
	 * @see R.pick
	 * @example
	 *
	 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
	 */
	module.exports = _curry2(function omit(names, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (!_contains(prop, names)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Accepts a function `fn` and returns a function that guards invocation of
	 * `fn` such that `fn` can only ever be called once, no matter how many times
	 * the returned function is invoked. The first value calculated is returned in
	 * subsequent invocations.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a... -> b) -> (a... -> b)
	 * @param {Function} fn The function to wrap in a call-only-once wrapper.
	 * @return {Function} The wrapped function.
	 * @example
	 *
	 *      var addOneOnce = R.once(x => x + 1);
	 *      addOneOnce(10); //=> 11
	 *      addOneOnce(addOneOnce(50)); //=> 11
	 */
	module.exports = _curry1(function once(fn) {
	  var called = false;
	  var result;
	  return _arity(fn.length, function() {
	    if (called) {
	      return result;
	    }
	    called = true;
	    result = fn.apply(this, arguments);
	    return result;
	  });
	});


/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category List
	 * @sig a -> b -> (a,b)
	 * @param {*} fst
	 * @param {*} snd
	 * @return {Array}
	 * @see R.objOf, R.of
	 * @example
	 *
	 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
	 */
	module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _createPartialApplicator = __webpack_require__(703);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided initially followed by the arguments provided to `g`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partialRight
	 * @example
	 *
	 *      var multiply2 = (a, b) => a * b;
	 *      var double = R.partial(multiply2, [2]);
	 *      double(2); //=> 4
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var sayHello = R.partial(greet, ['Hello']);
	 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
	 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
	 */
	module.exports = _createPartialApplicator(_concat);


/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _createPartialApplicator = __webpack_require__(703);
	var flip = __webpack_require__(222);
	
	
	/**
	 * Takes a function `f` and a list of arguments, and returns a function `g`.
	 * When applied, `g` returns the result of applying `f` to the arguments
	 * provided to `g` followed by the arguments provided initially.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Function
	 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
	 * @param {Function} f
	 * @param {Array} args
	 * @return {Function}
	 * @see R.partial
	 * @example
	 *
	 *      var greet = (salutation, title, firstName, lastName) =>
	 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
	 *
	 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
	 *
	 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
	 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
	 */
	module.exports = _createPartialApplicator(flip(_concat));


/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	var filter = __webpack_require__(331);
	var juxt = __webpack_require__(715);
	var reject = __webpack_require__(232);
	
	
	/**
	 * Takes a predicate and a list or other "filterable" object and returns the
	 * pair of filterable objects of the same type of elements which do and do not
	 * satisfy, the predicate, respectively.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
	 * @param {Function} pred A predicate to determine which side the element belongs to.
	 * @param {Array} filterable the list (or other filterable) to partition.
	 * @return {Array} An array, containing first the subset of elements that satisfy the
	 *         predicate, and second the subset of elements that do not satisfy.
	 * @see R.filter, R.reject
	 * @example
	 *
	 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
	 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
	 *
	 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
	 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
	 */
	module.exports = juxt([filter, reject]);


/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var equals = __webpack_require__(81);
	var path = __webpack_require__(173);
	
	
	/**
	 * Determines whether a nested path on an object has a specific value, in
	 * `R.equals` terms. Most likely used to filter a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category Relation
	 * @typedefn Idx = String | Int
	 * @sig [Idx] -> a -> {a} -> Boolean
	 * @param {Array} path The path of the nested property to use
	 * @param {*} val The value to compare the nested property with
	 * @param {Object} obj The object to check the nested property in
	 * @return {Boolean} `true` if the value equals the nested object property,
	 *         `false` otherwise.
	 * @example
	 *
	 *      var user1 = { address: { zipCode: 90210 } };
	 *      var user2 = { address: { zipCode: 55555 } };
	 *      var user3 = { name: 'Bob' };
	 *      var users = [ user1, user2, user3 ];
	 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
	 *      R.filter(isFamous, users); //=> [ user1 ]
	 */
	module.exports = _curry3(function pathEq(_path, val, obj) {
	  return equals(path(_path, obj), val);
	});


/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var defaultTo = __webpack_require__(693);
	var path = __webpack_require__(173);
	
	
	/**
	 * If the given, non-null object has a value at the given path, returns the
	 * value at that path. Otherwise returns the provided default value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Object
	 * @typedefn Idx = String | Int
	 * @sig a -> [Idx] -> {a} -> a
	 * @param {*} d The default value.
	 * @param {Array} p The path to use.
	 * @param {Object} obj The object to retrieve the nested property from.
	 * @return {*} The data at `path` of the supplied object or the default value.
	 * @example
	 *
	 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
	 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
	 */
	module.exports = _curry3(function pathOr(d, p, obj) {
	  return defaultTo(d, path(p, obj));
	});


/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var path = __webpack_require__(173);
	
	
	/**
	 * Returns `true` if the specified object property at given path satisfies the
	 * given predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Logic
	 * @typedefn Idx = String | Int
	 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
	 * @param {Function} pred
	 * @param {Array} propPath
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propSatisfies, R.path
	 * @example
	 *
	 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
	 */
	module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
	  return propPath.length > 0 && pred(path(propPath, obj));
	});


/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys specified. If
	 * the key does not exist, the property is ignored.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> {k: v}
	 * @param {Array} names an array of String property names to copy onto a new object
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties from `names` on it.
	 * @see R.omit, R.props
	 * @example
	 *
	 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
	 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
	 */
	module.exports = _curry2(function pick(names, obj) {
	  var result = {};
	  var idx = 0;
	  while (idx < names.length) {
	    if (names[idx] in obj) {
	      result[names[idx]] = obj[names[idx]];
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	var composeK = __webpack_require__(690);
	var reverse = __webpack_require__(233);
	
	/**
	 * Returns the left-to-right Kleisli composition of the provided functions,
	 * each of which must return a value of a type supported by [`chain`](#chain).
	 *
	 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Function
	 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
	 * @param {...Function}
	 * @return {Function}
	 * @see R.composeK
	 * @example
	 *
	 *      //  parseJson :: String -> Maybe *
	 *      //  get :: String -> Object -> Maybe *
	 *
	 *      //  getStateCode :: Maybe String -> Maybe String
	 *      var getStateCode = R.pipeK(
	 *        parseJson,
	 *        get('user'),
	 *        get('address'),
	 *        get('state'),
	 *        R.compose(Maybe.of, R.toUpper)
	 *      );
	 *
	 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
	 *      //=> Just('NY')
	 *      getStateCode('[Invalid JSON]');
	 *      //=> Nothing()
	 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
	 */
	module.exports = function pipeK() {
	  if (arguments.length === 0) {
	    throw new Error('pipeK requires at least one argument');
	  }
	  return composeK.apply(this, reverse(arguments));
	};


/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	var multiply = __webpack_require__(721);
	var reduce = __webpack_require__(67);
	
	
	/**
	 * Multiplies together all the elements of a list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig [Number] -> Number
	 * @param {Array} list An array of numbers
	 * @return {Number} The product of all the numbers in the list.
	 * @see R.reduce
	 * @example
	 *
	 *      R.product([2,4,6,8,100,1]); //=> 38400
	 */
	module.exports = reduce(multiply, 1);


/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	var _map = __webpack_require__(227);
	var identity = __webpack_require__(332);
	var pickAll = __webpack_require__(726);
	var useWith = __webpack_require__(738);
	
	
	/**
	 * Reasonable analog to SQL `select` statement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @category Relation
	 * @sig [k] -> [{k: v}] -> [{k: v}]
	 * @param {Array} props The property names to project
	 * @param {Array} objs The objects to query
	 * @return {Array} An array of objects with just the `props` properties.
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
	 *      var kids = [abby, fred];
	 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
	 */
	module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var equals = __webpack_require__(81);
	
	
	/**
	 * Returns `true` if the specified object property is equal, in `R.equals`
	 * terms, to the given value; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig String -> a -> Object -> Boolean
	 * @param {String} name
	 * @param {*} val
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.equals, R.propSatisfies
	 * @example
	 *
	 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
	 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
	 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
	 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
	 *      var kids = [abby, fred, rusty, alois];
	 *      var hasBrownHair = R.propEq('hair', 'brown');
	 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
	 */
	module.exports = _curry3(function propEq(name, val, obj) {
	  return equals(val, obj[name]);
	});


/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var is = __webpack_require__(714);
	
	
	/**
	 * Returns `true` if the specified object property is of the given type;
	 * `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Type
	 * @sig Type -> String -> Object -> Boolean
	 * @param {Function} type
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.is, R.propSatisfies
	 * @example
	 *
	 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
	 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
	 *      R.propIs(Number, 'x', {});            //=> false
	 */
	module.exports = _curry3(function propIs(type, name, obj) {
	  return is(type, obj[name]);
	});


/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var _has = __webpack_require__(52);
	
	
	/**
	 * If the given, non-null object has an own property with the specified name,
	 * returns the value of that property. Otherwise returns the provided default
	 * value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Object
	 * @sig a -> String -> Object -> a
	 * @param {*} val The default value.
	 * @param {String} p The name of the property to return.
	 * @param {Object} obj The object to query.
	 * @return {*} The value of given property of the supplied object or the default value.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var favorite = R.prop('favoriteLibrary');
	 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
	 *
	 *      favorite(alice);  //=> undefined
	 *      favoriteWithDefault(alice);  //=> 'Ramda'
	 */
	module.exports = _curry3(function propOr(val, p, obj) {
	  return (obj != null && _has(p, obj)) ? obj[p] : val;
	});


/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Returns `true` if the specified object property satisfies the given
	 * predicate; `false` otherwise.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Logic
	 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
	 * @param {Function} pred
	 * @param {String} name
	 * @param {*} obj
	 * @return {Boolean}
	 * @see R.propEq, R.propIs
	 * @example
	 *
	 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
	 */
	module.exports = _curry3(function propSatisfies(pred, name, obj) {
	  return pred(obj[name]);
	});


/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig [k] -> {k: v} -> [v]
	 * @param {Array} ps The property names to fetch
	 * @param {Object} obj The object to query
	 * @return {Array} The corresponding values or partially applied function.
	 * @example
	 *
	 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
	 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
	 *
	 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
	 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
	 */
	module.exports = _curry2(function props(ps, obj) {
	  var len = ps.length;
	  var out = [];
	  var idx = 0;
	
	  while (idx < len) {
	    out[idx] = obj[ps[idx]];
	    idx += 1;
	  }
	
	  return out;
	});


/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _isNumber = __webpack_require__(708);
	
	
	/**
	 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig Number -> Number -> [Number]
	 * @param {Number} from The first number in the list.
	 * @param {Number} to One more than the last number in the list.
	 * @return {Array} The list of numbers in tthe set `[a, b)`.
	 * @example
	 *
	 *      R.range(1, 5);    //=> [1, 2, 3, 4]
	 *      R.range(50, 53);  //=> [50, 51, 52]
	 */
	module.exports = _curry2(function range(from, to) {
	  if (!(_isNumber(from) && _isNumber(to))) {
	    throw new TypeError('Both arguments to range must be numbers');
	  }
	  var result = [];
	  var n = from;
	  while (n < to) {
	    result.push(n);
	    n += 1;
	  }
	  return result;
	});


/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	var _curryN = __webpack_require__(223);
	var _reduce = __webpack_require__(62);
	var _reduced = __webpack_require__(103);
	
	
	/**
	 * Like `reduce`, `reduceWhile` returns a single item by iterating through
	 * the list, successively calling the iterator function. `reduceWhile` also
	 * takes a predicate that is evaluated before each step. If the predicate returns
	 * `false`, it "short-circuits" the iteration and returns the current value
	 * of the accumulator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.22.0
	 * @category List
	 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} pred The predicate. It is passed the accumulator and the
	 *        current element.
	 * @param {Function} fn The iterator function. Receives two values, the
	 *        accumulator and the current element.
	 * @param {*} a The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced
	 * @example
	 *
	 *      var isOdd = (acc, x) => x % 2 === 1;
	 *      var xs = [1, 3, 5, 60, 777, 800];
	 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
	 *
	 *      var ys = [2, 4, 6]
	 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
	 */
	module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
	  return _reduce(function(acc, x) {
	    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
	  }, a, list);
	});


/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _reduced = __webpack_require__(103);
	
	/**
	 * Returns a value wrapped to indicate that it is the final value of the reduce
	 * and transduce functions. The returned value should be considered a black
	 * box: the internal structure is not guaranteed to be stable.
	 *
	 * Note: this optimization is unavailable to functions not explicitly listed
	 * above. For instance, it is not currently supported by reduceRight.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.15.0
	 * @category List
	 * @sig a -> *
	 * @param {*} x The final value of the reduce.
	 * @return {*} The wrapped value.
	 * @see R.reduce, R.transduce
	 * @example
	 *
	 *      R.reduce(
	 *        R.pipe(R.add, R.when(R.gte(R.__, 10), R.reduced)),
	 *        0,
	 *        [1, 2, 3, 4, 5]) // 10
	 */
	
	module.exports = _curry1(_reduced);


/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Removes the sub-list of `list` starting at index `start` and containing
	 * `count` elements. _Note that this is not destructive_: it returns a copy of
	 * the list with the changes.
	 * <small>No lists have been harmed in the application of this function.</small>
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.2
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @param {Number} start The position to start removing elements
	 * @param {Number} count The number of elements to remove
	 * @param {Array} list The list to remove from
	 * @return {Array} A new Array with `count` elements from `start` removed.
	 * @example
	 *
	 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
	 */
	module.exports = _curry3(function remove(start, count, list) {
	  var result = Array.prototype.slice.call(list, 0);
	  result.splice(start, count);
	  return result;
	});


/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var always = __webpack_require__(143);
	var times = __webpack_require__(735);
	
	
	/**
	 * Returns a fixed list of size `n` containing a specified identical value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.1
	 * @category List
	 * @sig a -> n -> [a]
	 * @param {*} value The value to repeat.
	 * @param {Number} n The desired size of the output list.
	 * @return {Array} A new array containing `n` `value`s.
	 * @example
	 *
	 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
	 *
	 *      var obj = {};
	 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
	 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
	 * @symb R.repeat(a, 0) = []
	 * @symb R.repeat(a, 1) = [a]
	 * @symb R.repeat(a, 2) = [a, a]
	 */
	module.exports = _curry2(function repeat(value, n) {
	  return times(always(value), n);
	});


/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Replace a substring or regex match in a string with a replacement.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.7.0
	 * @category String
	 * @sig RegExp|String -> String -> String -> String
	 * @param {RegExp|String} pattern A regular expression or a substring to match.
	 * @param {String} replacement The string to replace the matches with.
	 * @param {String} str The String to do the search and replacement in.
	 * @return {String} The result.
	 * @example
	 *
	 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
	 *
	 *      // Use the "g" (global) flag to replace all occurrences:
	 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
	 */
	module.exports = _curry3(function replace(regex, replacement, str) {
	  return str.replace(regex, replacement);
	});


/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Scan is similar to reduce, but returns a list of successively reduced values
	 * from the left
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a,b -> a) -> a -> [b] -> [a]
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {Array} A list of all intermediately reduced values.
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
	 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
	 */
	module.exports = _curry3(function scan(fn, acc, list) {
	  var idx = 0;
	  var len = list.length;
	  var result = [acc];
	  while (idx < len) {
	    acc = fn(acc, list[idx]);
	    result[idx + 1] = acc;
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var always = __webpack_require__(143);
	var over = __webpack_require__(725);
	
	
	/**
	 * Returns the result of "setting" the portion of the given data structure
	 * focused by the given lens to the given value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> a -> s -> s
	 * @param {Lens} lens
	 * @param {*} v
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
	 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
	 */
	module.exports = _curry3(function set(lens, v, x) {
	  return over(lens, always(v), x);
	});


/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a copy of the list, sorted according to the comparator function,
	 * which should accept two values at a time and return a negative number if the
	 * first value is smaller, a positive number if it's larger, and zero if they
	 * are equal. Please note that this is a **copy** of the list. It does not
	 * modify the original.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,a -> Number) -> [a] -> [a]
	 * @param {Function} comparator A sorting function :: a -> b -> Int
	 * @param {Array} list The list to sort
	 * @return {Array} a new array with its elements sorted by the comparator function.
	 * @example
	 *
	 *      var diff = function(a, b) { return a - b; };
	 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
	 */
	module.exports = _curry2(function sort(comparator, list) {
	  return Array.prototype.slice.call(list, 0).sort(comparator);
	});


/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Sorts the list according to the supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig Ord b => (a -> b) -> [a] -> [a]
	 * @param {Function} fn
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted by the keys generated by `fn`.
	 * @example
	 *
	 *      var sortByFirstItem = R.sortBy(R.prop(0));
	 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
	 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
	 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
	 *      var alice = {
	 *        name: 'ALICE',
	 *        age: 101
	 *      };
	 *      var bob = {
	 *        name: 'Bob',
	 *        age: -10
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 314.159
	 *      };
	 *      var people = [clara, bob, alice];
	 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
	 */
	module.exports = _curry2(function sortBy(fn, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var aa = fn(a);
	    var bb = fn(b);
	    return aa < bb ? -1 : aa > bb ? 1 : 0;
	  });
	});


/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Sorts a list according to a list of comparators.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.23.0
	 * @category Relation
	 * @sig [a -> a -> Number] -> [a] -> [a]
	 * @param {Array} functions A list of comparator functions.
	 * @param {Array} list The list to sort.
	 * @return {Array} A new list sorted according to the comarator functions.
	 * @example
	 *
	 *      var alice = {
	 *        name: 'alice',
	 *        age: 40
	 *      };
	 *      var bob = {
	 *        name: 'bob',
	 *        age: 30
	 *      };
	 *      var clara = {
	 *        name: 'clara',
	 *        age: 40
	 *      };
	 *      var people = [clara, bob, alice];
	 *      var ageNameSort = R.sortWith([
	 *        R.descend(R.prop('age')),
	 *        R.ascend(R.prop('name'))
	 *      ]);
	 *      ageNameSort(people); //=> [alice, clara, bob]
	 */
	module.exports = _curry2(function sortWith(fns, list) {
	  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
	    var result = 0;
	    var i = 0;
	    while (result === 0 && i < fns.length) {
	      result = fns[i](a, b);
	      i += 1;
	    }
	    return result;
	  });
	});


/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(170);
	
	
	/**
	 * Splits a string into an array of strings based on the given
	 * separator.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category String
	 * @sig (String | RegExp) -> String -> [String]
	 * @param {String|RegExp} sep The pattern.
	 * @param {String} str The string to separate into an array.
	 * @return {Array} The array of strings from `str` separated by `str`.
	 * @see R.join
	 * @example
	 *
	 *      var pathComponents = R.split('/');
	 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
	 *
	 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
	 */
	module.exports = invoker(1, 'split');


/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var length = __webpack_require__(717);
	var slice = __webpack_require__(118);
	
	
	/**
	 * Splits a given list or string at a given index.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig Number -> [a] -> [[a], [a]]
	 * @sig Number -> String -> [String, String]
	 * @param {Number} index The index where the array/string is split.
	 * @param {Array|String} array The array/string to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
	 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
	 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
	 */
	module.exports = _curry2(function splitAt(index, array) {
	  return [slice(0, index, array), slice(index, length(array), array)];
	});


/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var slice = __webpack_require__(118);
	
	
	/**
	 * Splits a collection into slices of the specified length.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [[a]]
	 * @sig Number -> String -> [String]
	 * @param {Number} n
	 * @param {Array} list
	 * @return {Array}
	 * @example
	 *
	 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
	 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
	 */
	module.exports = _curry2(function splitEvery(n, list) {
	  if (n <= 0) {
	    throw new Error('First argument to splitEvery must be a positive integer');
	  }
	  var result = [];
	  var idx = 0;
	  while (idx < list.length) {
	    result.push(slice(idx, idx += n, list));
	  }
	  return result;
	});


/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Takes a list and a predicate and returns a pair of lists with the following properties:
	 *
	 *  - the result of concatenating the two output lists is equivalent to the input list;
	 *  - none of the elements of the first output list satisfies the predicate; and
	 *  - if the second output list is non-empty, its first element satisfies the predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
	 * @param {Function} pred The predicate that determines where the array is split.
	 * @param {Array} list The array to be split.
	 * @return {Array}
	 * @example
	 *
	 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
	 */
	module.exports = _curry2(function splitWhen(pred, list) {
	  var idx = 0;
	  var len = list.length;
	  var prefix = [];
	
	  while (idx < len && !pred(list[idx])) {
	    prefix.push(list[idx]);
	    idx += 1;
	  }
	
	  return [prefix, Array.prototype.slice.call(list, idx)];
	});


/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Subtracts its second argument from its first argument.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Math
	 * @sig Number -> Number -> Number
	 * @param {Number} a The first value.
	 * @param {Number} b The second value.
	 * @return {Number} The result of `a - b`.
	 * @see R.add
	 * @example
	 *
	 *      R.subtract(10, 8); //=> 2
	 *
	 *      var minus5 = R.subtract(R.__, 5);
	 *      minus5(17); //=> 12
	 *
	 *      var complementaryAngle = R.subtract(90);
	 *      complementaryAngle(30); //=> 60
	 *      complementaryAngle(72); //=> 18
	 */
	module.exports = _curry2(function subtract(a, b) {
	  return Number(a) - Number(b);
	});


/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var concat = __webpack_require__(329);
	var difference = __webpack_require__(694);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
	 * @example
	 *
	 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
	 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
	 */
	module.exports = _curry2(function symmetricDifference(list1, list2) {
	  return concat(difference(list1, list2), difference(list2, list1));
	});


/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var concat = __webpack_require__(329);
	var differenceWith = __webpack_require__(695);
	
	
	/**
	 * Finds the set (i.e. no duplicates) of all elements contained in the first or
	 * second list, but not both. Duplication is determined according to the value
	 * returned by applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category Relation
	 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The elements in `list1` or `list2`, but not both.
	 * @see R.symmetricDifference, R.difference, R.differenceWith
	 * @example
	 *
	 *      var eqA = R.eqBy(R.prop('a'));
	 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
	 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
	 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
	 */
	module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
	  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
	});


/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var drop = __webpack_require__(696);
	
	
	/**
	 * Returns a new list containing the last `n` elements of the given list.
	 * If `n > list.length`, returns a list of `list.length` elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig Number -> [a] -> [a]
	 * @sig Number -> String -> String
	 * @param {Number} n The number of elements to return.
	 * @param {Array} xs The collection to consider.
	 * @return {Array}
	 * @see R.dropLast
	 * @example
	 *
	 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
	 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
	 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
	 *      R.takeLast(3, 'ramda');               //=> 'mda'
	 */
	module.exports = _curry2(function takeLast(n, xs) {
	  return drop(n >= 0 ? xs.length - n : 0, xs);
	});


/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a new list containing the last `n` elements of a given list, passing
	 * each value to the supplied predicate function, and terminating when the
	 * predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropLastWhile, R.addIndex
	 * @example
	 *
	 *      var isNotOne = x => x !== 1;
	 *
	 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
	 */
	module.exports = _curry2(function takeLastWhile(fn, list) {
	  var idx = list.length - 1;
	  while (idx >= 0 && fn(list[idx])) {
	    idx -= 1;
	  }
	  return Array.prototype.slice.call(list, idx + 1);
	});


/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var _dispatchable = __webpack_require__(39);
	var _xtakeWhile = __webpack_require__(2133);
	
	
	/**
	 * Returns a new list containing the first `n` elements of a given list,
	 * passing each value to the supplied predicate function, and terminating when
	 * the predicate function returns `false`. Excludes the element that caused the
	 * predicate function to fail. The predicate function is passed one argument:
	 * *(value)*.
	 *
	 * Dispatches to the `takeWhile` method of the second argument, if present.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a -> Boolean) -> [a] -> [a]
	 * @param {Function} fn The function called per iteration.
	 * @param {Array} list The collection to iterate over.
	 * @return {Array} A new array.
	 * @see R.dropWhile, R.transduce, R.addIndex
	 * @example
	 *
	 *      var isNotFour = x => x !== 4;
	 *
	 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
	 */
	module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
	  var idx = 0;
	  var len = list.length;
	  while (idx < len && fn(list[idx])) {
	    idx += 1;
	  }
	  return Array.prototype.slice.call(list, 0, idx);
	}));


/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Runs the given function with the supplied object, then returns the object.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (a -> *) -> a -> a
	 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
	 * @param {*} x
	 * @return {*} `x`.
	 * @example
	 *
	 *      var sayX = x => console.log('x is ' + x);
	 *      R.tap(sayX, 100); //=> 100
	 *      // logs 'x is 100'
	 * @symb R.tap(f, a) = a
	 */
	module.exports = _curry2(function tap(fn, x) {
	  fn(x);
	  return x;
	});


/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	var _cloneRegExp = __webpack_require__(701);
	var _curry2 = __webpack_require__(6);
	var _isRegExp = __webpack_require__(2109);
	var toString = __webpack_require__(175);
	
	
	/**
	 * Determines whether a given string matches a given regular expression.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category String
	 * @sig RegExp -> String -> Boolean
	 * @param {RegExp} pattern
	 * @param {String} str
	 * @return {Boolean}
	 * @see R.match
	 * @example
	 *
	 *      R.test(/^x/, 'xyz'); //=> true
	 *      R.test(/^y/, 'xyz'); //=> false
	 */
	module.exports = _curry2(function test(pattern, str) {
	  if (!_isRegExp(pattern)) {
	    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
	  }
	  return _cloneRegExp(pattern).test(str);
	});


/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(170);
	
	
	/**
	 * The lower case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to lower case.
	 * @return {String} The lower case version of `str`.
	 * @see R.toUpper
	 * @example
	 *
	 *      R.toLower('XYZ'); //=> 'xyz'
	 */
	module.exports = invoker(0, 'toLowerCase');


/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var _has = __webpack_require__(52);
	
	
	/**
	 * Converts an object into an array of key, value arrays. Only the object's
	 * own properties are used.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own properties.
	 * @see R.fromPairs
	 * @example
	 *
	 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
	 */
	module.exports = _curry1(function toPairs(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    if (_has(prop, obj)) {
	      pairs[pairs.length] = [prop, obj[prop]];
	    }
	  }
	  return pairs;
	});


/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Converts an object into an array of key, value arrays. The object's own
	 * properties and prototype properties are used. Note that the order of the
	 * output array is not guaranteed to be consistent across different JS
	 * platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.4.0
	 * @category Object
	 * @sig {String: *} -> [[String,*]]
	 * @param {Object} obj The object to extract from
	 * @return {Array} An array of key, value arrays from the object's own
	 *         and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
	 */
	module.exports = _curry1(function toPairsIn(obj) {
	  var pairs = [];
	  for (var prop in obj) {
	    pairs[pairs.length] = [prop, obj[prop]];
	  }
	  return pairs;
	});


/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	var invoker = __webpack_require__(170);
	
	
	/**
	 * The upper case version of a string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.9.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to upper case.
	 * @return {String} The upper case version of `str`.
	 * @see R.toLower
	 * @example
	 *
	 *      R.toUpper('abc'); //=> 'ABC'
	 */
	module.exports = invoker(0, 'toUpperCase');


/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	var _reduce = __webpack_require__(62);
	var _xwrap = __webpack_require__(713);
	var curryN = __webpack_require__(49);
	
	
	/**
	 * Initializes a transducer using supplied iterator function. Returns a single
	 * item by iterating through the list, successively calling the transformed
	 * iterator function and passing it an accumulator value and the current value
	 * from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It will be
	 * wrapped as a transformer to initialize the transducer. A transformer can be
	 * passed directly in place of an iterator function. In both cases, iteration
	 * may be stopped early with the `R.reduced` function.
	 *
	 * A transducer is a function that accepts a transformer and returns a
	 * transformer and can be composed directly.
	 *
	 * A transformer is an an object that provides a 2-arity reducing iterator
	 * function, step, 0-arity initial value function, init, and 1-arity result
	 * extraction function, result. The step function is used as the iterator
	 * function in reduce. The result function is used to convert the final
	 * accumulator into the return type and in most cases is R.identity. The init
	 * function can be used to provide an initial accumulator, but is ignored by
	 * transduce.
	 *
	 * The iteration is performed with R.reduce after initializing the transducer.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.12.0
	 * @category List
	 * @sig (c -> c) -> (a,b -> a) -> a -> [b] -> a
	 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array. Wrapped as transformer, if necessary, and used to
	 *        initialize the transducer
	 * @param {*} acc The initial accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduce, R.reduced, R.into
	 * @example
	 *
	 *      var numbers = [1, 2, 3, 4];
	 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
	 *
	 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
	 */
	module.exports = curryN(4, function transduce(xf, fn, acc, list) {
	  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
	});


/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Transposes the rows and columns of a 2D list.
	 * When passed a list of `n` lists of length `x`,
	 * returns a list of `x` lists of length `n`.
	 *
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [[a]] -> [[a]]
	 * @param {Array} list A 2D list
	 * @return {Array} A 2D list
	 * @example
	 *
	 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
	 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 *
	 * If some of the rows are shorter than the following rows, their elements are skipped:
	 *
	 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
	 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
	 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
	 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
	 */
	module.exports = _curry1(function transpose(outerlist) {
	  var i = 0;
	  var result = [];
	  while (i < outerlist.length) {
	    var innerlist = outerlist[i];
	    var j = 0;
	    while (j < innerlist.length) {
	      if (typeof result[j] === 'undefined') {
	        result[j] = [];
	      }
	      result[j].push(innerlist[j]);
	      j += 1;
	    }
	    i += 1;
	  }
	  return result;
	});


/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	var map = __webpack_require__(59);
	var sequence = __webpack_require__(732);
	
	
	/**
	 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
	 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
	 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
	 * into an Applicative of Traversable.
	 *
	 * Dispatches to the `sequence` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
	 * @param {Function} of
	 * @param {Function} f
	 * @param {*} traversable
	 * @return {*}
	 * @see R.sequence
	 * @example
	 *
	 *      // Returns `Nothing` if the given divisor is `0`
	 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
	 *
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
	 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
	 */
	module.exports = _curry3(function traverse(of, f, traversable) {
	  return sequence(of, map(f, traversable));
	});


/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Removes (strips) whitespace from both ends of the string.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category String
	 * @sig String -> String
	 * @param {String} str The string to trim.
	 * @return {String} Trimmed version of `str`.
	 * @example
	 *
	 *      R.trim('   xyz  '); //=> 'xyz'
	 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
	 */
	module.exports = (function() {
	  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
	           '\u2029\uFEFF';
	  var zeroWidth = '\u200b';
	  var hasProtoTrim = (typeof String.prototype.trim === 'function');
	  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
	    return _curry1(function trim(str) {
	      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
	      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
	      return str.replace(beginRx, '').replace(endRx, '');
	    });
	  } else {
	    return _curry1(function trim(str) {
	      return str.trim();
	    });
	  }
	}());


/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(82);
	var _concat = __webpack_require__(66);
	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
	 * function evaluates the `tryer`; if it does not throw, it simply returns the
	 * result. If the `tryer` *does* throw, the returned function evaluates the
	 * `catcher` function and returns its result. Note that for effective
	 * composition with this function, both the `tryer` and `catcher` functions
	 * must return the same type of results.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Function
	 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
	 * @param {Function} tryer The function that may throw.
	 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
	 * @return {Function} A new function that will catch exceptions and send then to the catcher.
	 * @example
	 *
	 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
	 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
	 */
	module.exports = _curry2(function _tryCatch(tryer, catcher) {
	  return _arity(tryer.length, function() {
	    try {
	      return tryer.apply(this, arguments);
	    } catch (e) {
	      return catcher.apply(this, _concat([e], arguments));
	    }
	  });
	});


/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Takes a function `fn`, which takes a single array argument, and returns a
	 * function which:
	 *
	 *   - takes any number of positional arguments;
	 *   - passes these arguments to `fn` as an array; and
	 *   - returns the result.
	 *
	 * In other words, R.unapply derives a variadic function from a function which
	 * takes an array. R.unapply is the inverse of R.apply.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Function
	 * @sig ([*...] -> a) -> (*... -> a)
	 * @param {Function} fn
	 * @return {Function}
	 * @see R.apply
	 * @example
	 *
	 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
	 * @symb R.unapply(f)(a, b) = f([a, b])
	 */
	module.exports = _curry1(function unapply(fn) {
	  return function() {
	    return fn(Array.prototype.slice.call(arguments, 0));
	  };
	});


/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	var nAry = __webpack_require__(230);
	
	
	/**
	 * Wraps a function of any arity (including nullary) in a function that accepts
	 * exactly 1 parameter. Any extraneous parameters will not be passed to the
	 * supplied function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Function
	 * @sig (* -> b) -> (a -> b)
	 * @param {Function} fn The function to wrap.
	 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
	 *         arity 1.
	 * @example
	 *
	 *      var takesTwoArgs = function(a, b) {
	 *        return [a, b];
	 *      };
	 *      takesTwoArgs.length; //=> 2
	 *      takesTwoArgs(1, 2); //=> [1, 2]
	 *
	 *      var takesOneArg = R.unary(takesTwoArgs);
	 *      takesOneArg.length; //=> 1
	 *      // Only 1 argument is passed to the wrapped function
	 *      takesOneArg(1, 2); //=> [1, undefined]
	 * @symb R.unary(f)(a, b, c) = f(a)
	 */
	module.exports = _curry1(function unary(fn) {
	  return nAry(1, fn);
	});


/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var curryN = __webpack_require__(49);
	
	
	/**
	 * Returns a function of arity `n` from a (manually) curried function.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Function
	 * @sig Number -> (a -> b) -> (a -> c)
	 * @param {Number} length The arity for the returned function.
	 * @param {Function} fn The function to uncurry.
	 * @return {Function} A new function.
	 * @see R.curry
	 * @example
	 *
	 *      var addFour = a => b => c => d => a + b + c + d;
	 *
	 *      var uncurriedAddFour = R.uncurryN(4, addFour);
	 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
	 */
	module.exports = _curry2(function uncurryN(depth, fn) {
	  return curryN(depth, function() {
	    var currentDepth = 1;
	    var value = fn;
	    var idx = 0;
	    var endIdx;
	    while (currentDepth <= depth && typeof value === 'function') {
	      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
	      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
	      currentDepth += 1;
	      idx = endIdx;
	    }
	    return value;
	  });
	});


/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Builds a list from a seed value. Accepts an iterator function, which returns
	 * either false to stop iteration or an array of length 2 containing the value
	 * to add to the resulting list and the seed to be used in the next call to the
	 * iterator function.
	 *
	 * The iterator function receives one argument: *(seed)*.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category List
	 * @sig (a -> [b]) -> * -> [b]
	 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
	 *        either false to quit iteration or an array of length two to proceed. The element
	 *        at index 0 of this array will be added to the resulting array, and the element
	 *        at index 1 will be passed to the next call to `fn`.
	 * @param {*} seed The seed value.
	 * @return {Array} The final list.
	 * @example
	 *
	 *      var f = n => n > 50 ? false : [-n, n + 10];
	 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
	 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
	 */
	module.exports = _curry2(function unfold(fn, seed) {
	  var pair = fn(seed);
	  var result = [];
	  while (pair && pair.length) {
	    result[result.length] = pair[0];
	    pair = fn(pair[1]);
	  }
	  return result;
	});


/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry2 = __webpack_require__(6);
	var compose = __webpack_require__(220);
	var uniq = __webpack_require__(340);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig [*] -> [*] -> [*]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @example
	 *
	 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
	 */
	module.exports = _curry2(compose(uniq, _concat));


/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	var _concat = __webpack_require__(66);
	var _curry3 = __webpack_require__(13);
	var uniqWith = __webpack_require__(341);
	
	
	/**
	 * Combines two lists into a set (i.e. no duplicates) composed of the elements
	 * of each list. Duplication is determined according to the value returned by
	 * applying the supplied predicate to two list elements.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Relation
	 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
	 * @param {Function} pred A predicate used to test whether two items are equal.
	 * @param {Array} list1 The first list.
	 * @param {Array} list2 The second list.
	 * @return {Array} The first and second lists concatenated, with
	 *         duplicates removed.
	 * @see R.union
	 * @example
	 *
	 *      var l1 = [{a: 1}, {a: 2}];
	 *      var l2 = [{a: 1}, {a: 4}];
	 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
	 */
	module.exports = _curry3(function unionWith(pred, list1, list2) {
	  return uniqWith(pred, _concat(list1, list2));
	});


/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is not satisfied, the function will return the result of
	 * calling the `whenFalseFn` function with the same argument. If the predicate
	 * is satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred        A predicate function
	 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
	 *                               to a falsy value.
	 * @param {*}        x           An object to test with the `pred` function and
	 *                               pass to `whenFalseFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
	 * @see R.ifElse, R.when
	 * @example
	 *
	 *      // coerceArray :: (a|[a]) -> [a]
	 *      var coerceArray = R.unless(R.isArrayLike, R.of);
	 *      coerceArray([1, 2, 3]); //=> [1, 2, 3]
	 *      coerceArray(1);         //=> [1]
	 */
	module.exports = _curry3(function unless(pred, whenFalseFn, x) {
	  return pred(x) ? x : whenFalseFn(x);
	});


/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	var _identity = __webpack_require__(335);
	var chain = __webpack_require__(328);
	
	
	/**
	 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
	 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig Chain c => c (c a) -> c a
	 * @param {*} list
	 * @return {*}
	 * @see R.flatten, R.chain
	 * @example
	 *
	 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
	 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
	 */
	module.exports = chain(_identity);


/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Takes a predicate, a transformation function, and an initial value,
	 * and returns a value of the same type as the initial value.
	 * It does so by applying the transformation until the predicate is satisfied,
	 * at which point it returns the satisfactory value.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.20.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred A predicate function
	 * @param {Function} fn The iterator function
	 * @param {*} init Initial value
	 * @return {*} Final value that satisfies predicate
	 * @example
	 *
	 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
	 */
	module.exports = _curry3(function until(pred, fn, init) {
	  var val = init;
	  while (!pred(val)) {
	    val = fn(val);
	  }
	  return val;
	});


/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(12);
	
	
	/**
	 * Returns a list of all the properties, including prototype properties, of the
	 * supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.2.0
	 * @category Object
	 * @sig {k: v} -> [v]
	 * @param {Object} obj The object to extract values from
	 * @return {Array} An array of the values of the object's own and prototype properties.
	 * @example
	 *
	 *      var F = function() { this.x = 'X'; };
	 *      F.prototype.y = 'Y';
	 *      var f = new F();
	 *      R.valuesIn(f); //=> ['X', 'Y']
	 */
	module.exports = _curry1(function valuesIn(obj) {
	  var prop;
	  var vs = [];
	  for (prop in obj) {
	    vs[vs.length] = obj[prop];
	  }
	  return vs;
	});


/***/ },
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Returns a "view" of the given data structure, determined by the given lens.
	 * The lens's focus determines which portion of the data structure is visible.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.16.0
	 * @category Object
	 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
	 * @sig Lens s a -> s -> a
	 * @param {Lens} lens
	 * @param {*} x
	 * @return {*}
	 * @see R.prop, R.lensIndex, R.lensProp
	 * @example
	 *
	 *      var xLens = R.lensProp('x');
	 *
	 *      R.view(xLens, {x: 1, y: 2});  //=> 1
	 *      R.view(xLens, {x: 4, y: 2});  //=> 4
	 */
	module.exports = (function() {
	  // `Const` is a functor that effectively ignores the function given to `map`.
	  var Const = function(x) {
	    return {value: x, map: function() { return this; }};
	  };
	
	  return _curry2(function view(lens, x) {
	    // Using `Const` effectively ignores the setter function of the `lens`,
	    // leaving the value returned by the getter function unmodified.
	    return lens(Const)(x).value;
	  });
	}());


/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Tests the final argument by passing it to the given predicate function. If
	 * the predicate is satisfied, the function will return the result of calling
	 * the `whenTrueFn` function with the same argument. If the predicate is not
	 * satisfied, the argument is returned as is.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.18.0
	 * @category Logic
	 * @sig (a -> Boolean) -> (a -> a) -> a -> a
	 * @param {Function} pred       A predicate function
	 * @param {Function} whenTrueFn A function to invoke when the `condition`
	 *                              evaluates to a truthy value.
	 * @param {*}        x          An object to test with the `pred` function and
	 *                              pass to `whenTrueFn` if necessary.
	 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
	 * @see R.ifElse, R.unless
	 * @example
	 *
	 *      // truncate :: String -> String
	 *      var truncate = R.when(
	 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
	 *        R.pipe(R.take(10), R.append('…'), R.join(''))
	 *      );
	 *      truncate('12345');         //=> '12345'
	 *      truncate('0123456789ABC'); //=> '0123456789…'
	 */
	module.exports = _curry3(function when(pred, whenTrueFn, x) {
	  return pred(x) ? whenTrueFn(x) : x;
	});


/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	var equals = __webpack_require__(81);
	var map = __webpack_require__(59);
	var where = __webpack_require__(740);
	
	
	/**
	 * Takes a spec object and a test object; returns true if the test satisfies
	 * the spec, false otherwise. An object satisfies the spec if, for each of the
	 * spec's own properties, accessing that property of the object gives the same
	 * value (in `R.equals` terms) as accessing that property of the spec.
	 *
	 * `whereEq` is a specialization of [`where`](#where).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.14.0
	 * @category Object
	 * @sig {String: *} -> {String: *} -> Boolean
	 * @param {Object} spec
	 * @param {Object} testObj
	 * @return {Boolean}
	 * @see R.where
	 * @example
	 *
	 *      // pred :: Object -> Boolean
	 *      var pred = R.whereEq({a: 1, b: 2});
	 *
	 *      pred({a: 1});              //=> false
	 *      pred({a: 1, b: 2});        //=> true
	 *      pred({a: 1, b: 2, c: 3});  //=> true
	 *      pred({a: 1, b: 1});        //=> false
	 */
	module.exports = _curry2(function whereEq(spec, testObj) {
	  return where(map(equals, spec), testObj);
	});


/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	var _contains = __webpack_require__(117);
	var _curry2 = __webpack_require__(6);
	var flip = __webpack_require__(222);
	var reject = __webpack_require__(232);
	
	
	/**
	 * Returns a new list without values in the first argument.
	 * `R.equals` is used to determine equality.
	 *
	 * Acts as a transducer if a transformer is given in list position.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.19.0
	 * @category List
	 * @sig [a] -> [a] -> [a]
	 * @param {Array} list1 The values to be removed from `list2`.
	 * @param {Array} list2 The array to remove values from.
	 * @return {Array} The new array without values in `list1`.
	 * @see R.transduce
	 * @example
	 *
	 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
	 */
	module.exports = _curry2(function(xs, list) {
	  return reject(flip(_contains)(xs), list);
	});


/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Creates a new list out of the two supplied by creating each possible pair
	 * from the lists.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} as The first list.
	 * @param {Array} bs The second list.
	 * @return {Array} The list made by combining each possible pair from
	 *         `as` and `bs` into pairs (`[a, b]`).
	 * @example
	 *
	 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
	 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
	 */
	module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
	  var idx = 0;
	  var ilen = a.length;
	  var j;
	  var jlen = b.length;
	  var result = [];
	  while (idx < ilen) {
	    j = 0;
	    while (j < jlen) {
	      result[result.length] = [a[idx], b[j]];
	      j += 1;
	    }
	    idx += 1;
	  }
	  return result;
	});


/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Creates a new list out of the two supplied by pairing up equally-positioned
	 * items from both lists. The returned list is truncated to the length of the
	 * shorter of the two input lists.
	 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [b] -> [[a,b]]
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
	 * @example
	 *
	 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
	 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
	 */
	module.exports = _curry2(function zip(a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = [a[idx], b[idx]];
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(6);
	
	
	/**
	 * Creates a new object out of a list of keys and a list of values.
	 * Key/value pairing is truncated to the length of the shorter of the two lists.
	 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.3.0
	 * @category List
	 * @sig [String] -> [*] -> {String: *}
	 * @param {Array} keys The array that will be properties on the output object.
	 * @param {Array} values The list of values on the output object.
	 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
	 * @example
	 *
	 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry2(function zipObj(keys, values) {
	  var idx = 0;
	  var len = Math.min(keys.length, values.length);
	  var out = {};
	  while (idx < len) {
	    out[keys[idx]] = values[idx];
	    idx += 1;
	  }
	  return out;
	});


/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(13);
	
	
	/**
	 * Creates a new list out of the two supplied by applying the function to each
	 * equally-positioned pair in the lists. The returned list is truncated to the
	 * length of the shorter of the two input lists.
	 *
	 * @function
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig (a,b -> c) -> [a] -> [b] -> [c]
	 * @param {Function} fn The function used to combine the two elements into one value.
	 * @param {Array} list1 The first array to consider.
	 * @param {Array} list2 The second array to consider.
	 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
	 *         using `fn`.
	 * @example
	 *
	 *      var f = (x, y) => {
	 *        // ...
	 *      };
	 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
	 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
	 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
	 */
	module.exports = _curry3(function zipWith(fn, a, b) {
	  var rv = [];
	  var idx = 0;
	  var len = Math.min(a.length, b.length);
	  while (idx < len) {
	    rv[idx] = fn(a[idx], b[idx]);
	    idx += 1;
	  }
	  return rv;
	});


/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2237);


/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2238);
	
	function scrollIntoView(elem, container, config) {
	  config = config || {};
	  // document 归一化到 window
	  if (container.nodeType === 9) {
	    container = util.getWindow(container);
	  }
	
	  var allowHorizontalScroll = config.allowHorizontalScroll;
	  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
	  var alignWithTop = config.alignWithTop;
	  var alignWithLeft = config.alignWithLeft;
	
	  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
	
	  var isWin = util.isWindow(container);
	  var elemOffset = util.offset(elem);
	  var eh = util.outerHeight(elem);
	  var ew = util.outerWidth(elem);
	  var containerOffset, ch, cw, containerScroll,
	    diffTop, diffBottom, win,
	    winScroll, ww, wh;
	
	  if (isWin) {
	    win = container;
	    wh = util.height(win);
	    ww = util.width(win);
	    winScroll = {
	      left: util.scrollLeft(win),
	      top: util.scrollTop(win)
	    };
	    // elem 相对 container 可视视窗的距离
	    diffTop = {
	      left: elemOffset.left - winScroll.left,
	      top: elemOffset.top - winScroll.top
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (winScroll.left + ww),
	      top: elemOffset.top + eh - (winScroll.top + wh)
	    };
	    containerScroll = winScroll;
	  } else {
	    containerOffset = util.offset(container);
	    ch = container.clientHeight;
	    cw = container.clientWidth;
	    containerScroll = {
	      left: container.scrollLeft,
	      top: container.scrollTop
	    };
	    // elem 相对 container 可视视窗的距离
	    // 注意边框, offset 是边框到根节点
	    diffTop = {
	      left: elemOffset.left - (containerOffset.left +
	      (parseFloat(util.css(container, 'borderLeftWidth')) || 0)),
	      top: elemOffset.top - (containerOffset.top +
	      (parseFloat(util.css(container, 'borderTopWidth')) || 0))
	    };
	    diffBottom = {
	      left: elemOffset.left + ew -
	      (containerOffset.left + cw +
	      (parseFloat(util.css(container, 'borderRightWidth')) || 0)),
	      top: elemOffset.top + eh -
	      (containerOffset.top + ch +
	      (parseFloat(util.css(container, 'borderBottomWidth')) || 0))
	    };
	  }
	
	  if (diffTop.top < 0 || diffBottom.top > 0) {
	    // 强制向上
	    if (alignWithTop === true) {
	      util.scrollTop(container, containerScroll.top + diffTop.top);
	    } else if (alignWithTop === false) {
	      util.scrollTop(container, containerScroll.top + diffBottom.top);
	    } else {
	      // 自动调整
	      if (diffTop.top < 0) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  } else {
	    if (!onlyScrollIfNeeded) {
	      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
	      if (alignWithTop) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  }
	
	  if (allowHorizontalScroll) {
	    if (diffTop.left < 0 || diffBottom.left > 0) {
	      // 强制向上
	      if (alignWithLeft === true) {
	        util.scrollLeft(container, containerScroll.left + diffTop.left);
	      } else if (alignWithLeft === false) {
	        util.scrollLeft(container, containerScroll.left + diffBottom.left);
	      } else {
	        // 自动调整
	        if (diffTop.left < 0) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    } else {
	      if (!onlyScrollIfNeeded) {
	        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
	        if (alignWithLeft) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    }
	  }
	}
	
	module.exports = scrollIntoView;


/***/ },
/* 2238 */
/***/ function(module, exports) {

	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	function getClientPosition(elem) {
	  var box, x, y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {left: x, top: y};
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    //ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      //quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, computedStyle) {
	  var val = '';
	  var d = elem.ownerDocument;
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if ((computedStyle = (computedStyle || d.defaultView.getComputedStyle(elem, null)))) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/,
	  CURRENT_STYLE = 'currentStyle',
	  RUNTIME_STYLE = 'runtimeStyle',
	  LEFT = 'left',
	  PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style,
	      left = style[LEFT],
	      rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : (ret || 0);
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	var getComputedStyleX;
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setOffset(elem, offset) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var old = getOffset(elem),
	    ret = {},
	    current, key;
	
	  for (key in offset) {
	    current = parseFloat(css(elem, key)) || 0;
	    ret[key] = current + offset[key] - old[key];
	  }
	  css(elem, ret);
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'],
	  CONTENT_INDEX = -1,
	  PADDING_INDEX = 2,
	  BORDER_INDEX = 1,
	  MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {},
	    style = elem.style,
	    name;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    old[name] = style[name];
	    style[name] = options[name];
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    style[name] = old[name];
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0, prop, j, i;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp;
	        if (prop === 'border') {
	          cssProp = prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /*jshint eqeqeq:false*/
	  return obj != null && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	      //firefox chrome documentElement.scrollHeight< body.scrollHeight
	      //ie standard mode : documentElement.scrollHeight> body.scrollHeight
	      d.documentElement['scroll' + name],
	      //quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	      d.body['scroll' + name],
	      domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name,
	      doc = win.document,
	      body = doc.body,
	      documentElement = doc.documentElement,
	      documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp ||
	      body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, extra) {
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'],
	    borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue == null || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue == null || (Number(cssBoxValue)) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'],
	          which, computedStyle);
	    } else {
	      return cssBoxValue;
	    }
	  } else if (borderBoxValueOrIsBorderBox) {
	    return val + (extra === BORDER_INDEX ? 0 :
	        (extra === PADDING_INDEX ?
	          -getPBMWidth(elem, ['border'], which, computedStyle) :
	          getPBMWidth(elem, ['margin'], which, computedStyle)));
	  } else {
	    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra),
	        which, computedStyle);
	  }
	}
	
	var cssShow = {position: 'absolute', visibility: 'hidden', display: 'block'};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay(elem) {
	  var val, args = arguments;
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, val) {
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function css(el, name, value) {
	  if (typeof name === 'object') {
	    for (var i in name) {
	      css(el, i, name[i]);
	    }
	    return;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	  } else {
	    return getComputedStyleX(el, name);
	  }
	}
	
	function mix(to, from) {
	  for (var i in from) {
	    to[i] = from[i];
	  }
	  return to;
	}
	
	var utils = module.exports = {
	  getWindow: function (node) {
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function (el, value) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value);
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function (obj) {
	    var ret = {};
	    for (var i in obj) {
	      ret[i] = obj[i];
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        ret.overflow[i] = obj.overflow[i];
	      }
	    }
	    return ret;
	  },
	  mix: mix,
	  scrollLeft: function (w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollLeft(w);
	      } else {
	        window.scrollTo(v, getScrollTop(w));
	      }
	    } else {
	      if (v === undefined) {
	        return w.scrollLeft;
	      } else {
	        w.scrollLeft = v;
	      }
	    }
	  },
	  scrollTop: function (w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollTop(w);
	      } else {
	        window.scrollTo(getScrollLeft(w), v);
	      }
	    } else {
	      if (v === undefined) {
	        return w.scrollTop;
	      } else {
	        w.scrollTop = v;
	      }
	    }
	  },
	  merge: function () {
	    var ret = {};
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, arguments[i]);
	    }
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);


/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _themrShape = __webpack_require__(2241);
	
	var _themrShape2 = _interopRequireDefault(_themrShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemeProvider = (_temp = _class = function (_Component) {
	  _inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    _classCallCheck(this, ThemeProvider);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    return {
	      themr: {
	        theme: this.props.theme
	      }
	    };
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  theme: _propTypes2.default.object.isRequired
	}, _class.defaultProps = {
	  theme: {}
	}, _class.childContextTypes = {
	  themr: _themrShape2.default.isRequired
	}, _temp);
	exports.default = ThemeProvider;

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.themeable = themeable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(2242);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(78);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @typedef {Object.<string, TReactCSSThemrTheme>} TReactCSSThemrTheme
	 */
	
	/**
	 * @typedef {{}} TReactCSSThemrOptions
	 * @property {String|Boolean} [composeTheme=COMPOSE_DEEPLY]
	 */
	
	var COMPOSE_DEEPLY = 'deeply';
	var COMPOSE_SOFTLY = 'softly';
	var DONT_COMPOSE = false;
	
	var DEFAULT_OPTIONS = {
	  composeTheme: COMPOSE_DEEPLY,
	  mapThemrProps: defaultMapThemrProps
	};
	
	var THEMR_CONFIG = typeof Symbol !== 'undefined' ? Symbol('THEMR_CONFIG') : '__REACT_CSS_THEMR_CONFIG__';
	
	/**
	 * Themr decorator
	 * @param {String|Number|Symbol} componentName - Component name
	 * @param {TReactCSSThemrTheme} [localTheme] - Base theme
	 * @param {{}} [options] - Themr options
	 * @returns {function(ThemedComponent:Function):Function} - ThemedComponent
	 */
	
	exports.default = function (componentName, localTheme) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return function (ThemedComponent) {
	    var _class, _temp;
	
	    var _DEFAULT_OPTIONS$opti = _extends({}, DEFAULT_OPTIONS, options),
	        optionComposeTheme = _DEFAULT_OPTIONS$opti.composeTheme,
	        optionMapThemrProps = _DEFAULT_OPTIONS$opti.mapThemrProps;
	
	    validateComposeOption(optionComposeTheme);
	
	    var config = ThemedComponent[THEMR_CONFIG];
	    if (config && config.componentName === componentName) {
	      config.localTheme = themeable(config.localTheme, localTheme);
	      return ThemedComponent;
	    }
	
	    config = {
	      componentName: componentName,
	      localTheme: localTheme
	    };
	
	    /**
	     * @property {{wrappedInstance: *}} refs
	     */
	    var Themed = (_temp = _class = function (_Component) {
	      _inherits(Themed, _Component);
	
	      function Themed() {
	        _classCallCheck(this, Themed);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));
	
	        _this.theme_ = _this.calcTheme(_this.props);
	        return _this;
	      }
	
	      Themed.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(true, 'DEPRECATED: To access the wrapped instance, you have to pass ' + '{ innerRef: fn } and retrieve with a callback ref style.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Themed.prototype.getNamespacedTheme = function getNamespacedTheme(props) {
	        var themeNamespace = props.themeNamespace,
	            theme = props.theme;
	
	        if (!themeNamespace) return theme;
	        if (themeNamespace && !theme) throw new Error('Invalid themeNamespace use in react-css-themr. ' + 'themeNamespace prop should be used only with theme prop.');
	
	        return Object.keys(theme).filter(function (key) {
	          return key.startsWith(themeNamespace);
	        }).reduce(function (result, key) {
	          var _extends2;
	
	          return _extends({}, result, (_extends2 = {}, _extends2[removeNamespace(key, themeNamespace)] = theme[key], _extends2));
	        }, {});
	      };
	
	      Themed.prototype.getThemeNotComposed = function getThemeNotComposed(props) {
	        if (props.theme) return this.getNamespacedTheme(props);
	        if (config.localTheme) return config.localTheme;
	        return this.getContextTheme();
	      };
	
	      Themed.prototype.getContextTheme = function getContextTheme() {
	        return this.context.themr ? this.context.themr.theme[config.componentName] : {};
	      };
	
	      Themed.prototype.getTheme = function getTheme(props) {
	        return props.composeTheme === COMPOSE_SOFTLY ? _extends({}, this.getContextTheme(), config.localTheme, this.getNamespacedTheme(props)) : themeable(themeable(this.getContextTheme(), config.localTheme), this.getNamespacedTheme(props));
	      };
	
	      Themed.prototype.calcTheme = function calcTheme(props) {
	        var composeTheme = props.composeTheme;
	
	        return composeTheme ? this.getTheme(props) : this.getThemeNotComposed(props);
	      };
	
	      Themed.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (nextProps.composeTheme !== this.props.composeTheme || nextProps.theme !== this.props.theme || nextProps.themeNamespace !== this.props.themeNamespace) {
	          this.theme_ = this.calcTheme(nextProps);
	        }
	      };
	
	      Themed.prototype.render = function render() {
	        return _react2.default.createElement(ThemedComponent, this.props.mapThemrProps(this.props, this.theme_));
	      };
	
	      return Themed;
	    }(_react.Component), _class.displayName = 'Themed' + ThemedComponent.name, _class.contextTypes = {
	      themr: _propTypes2.default.object
	    }, _class.propTypes = _extends({}, ThemedComponent.propTypes, {
	      composeTheme: _propTypes2.default.oneOf([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE]),
	      innerRef: _propTypes2.default.func,
	      theme: _propTypes2.default.object,
	      themeNamespace: _propTypes2.default.string,
	      mapThemrProps: _propTypes2.default.func
	    }), _class.defaultProps = _extends({}, ThemedComponent.defaultProps, {
	      composeTheme: optionComposeTheme,
	      mapThemrProps: optionMapThemrProps
	    }), _temp);
	
	
	    Themed[THEMR_CONFIG] = config;
	
	    return (0, _hoistNonReactStatics2.default)(Themed, ThemedComponent);
	  };
	};
	
	/**
	 * Merges passed themes by concatenating string keys and processing nested themes
	 *
	 * @param {...TReactCSSThemrTheme} themes - Themes
	 * @returns {TReactCSSThemrTheme} - Resulting theme
	 */
	
	
	function themeable() {
	  for (var _len2 = arguments.length, themes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    themes[_key2] = arguments[_key2];
	  }
	
	  return themes.reduce(function (acc, theme) {
	    return merge(acc, theme);
	  }, {});
	}
	
	/**
	 * @param {TReactCSSThemrTheme} [original] - Original theme
	 * @param {TReactCSSThemrTheme} [mixin] - Mixin theme
	 * @returns {TReactCSSThemrTheme} - resulting theme
	 */
	function merge() {
	  var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var mixin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  //make a copy to avoid mutations of nested objects
	  //also strip all functions injected by isomorphic-style-loader
	  var result = Object.keys(original).reduce(function (acc, key) {
	    var value = original[key];
	    if (typeof value !== 'function') {
	      acc[key] = value;
	    }
	    return acc;
	  }, {});
	
	  //traverse mixin keys and merge them to resulting theme
	  Object.keys(mixin).forEach(function (key) {
	    //there's no need to set any defaults here
	    var originalValue = result[key];
	    var mixinValue = mixin[key];
	
	    switch (typeof mixinValue === 'undefined' ? 'undefined' : _typeof(mixinValue)) {
	      case 'object':
	        {
	          //possibly nested theme object
	          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
	            case 'object':
	              {
	                //exactly nested theme object - go recursive
	                result[key] = merge(originalValue, mixinValue);
	                break;
	              }
	
	            case 'undefined':
	              {
	                //original does not contain this nested key - just take it as is
	                result[key] = mixinValue;
	                break;
	              }
	
	            default:
	              {
	                //can't merge an object with a non-object
	                throw new Error('You are merging object ' + key + ' with a non-object ' + originalValue);
	              }
	          }
	          break;
	        }
	
	      case 'undefined': //fallthrough - handles accidentally unset values which may come from props
	      case 'function':
	        {
	          //this handles issue when isomorphic-style-loader addes helper functions to css-module
	          break; //just skip
	        }
	
	      default:
	        {
	          //plain values
	          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
	            case 'object':
	              {
	                //can't merge a non-object with an object
	                throw new Error('You are merging non-object ' + mixinValue + ' with an object ' + key);
	              }
	
	            case 'undefined':
	              {
	                //mixin key is new to original theme - take it as is
	                result[key] = mixinValue;
	                break;
	              }
	            case 'function':
	              {
	                //this handles issue when isomorphic-style-loader addes helper functions to css-module
	                break; //just skip
	              }
	
	            default:
	              {
	                //finally we can merge
	                result[key] = originalValue.split(' ').concat(mixinValue.split(' ')).filter(function (item, pos, self) {
	                  return self.indexOf(item) === pos && item !== '';
	                }).join(' ');
	                break;
	              }
	          }
	          break;
	        }
	    }
	  });
	
	  return result;
	}
	
	/**
	 * Validates compose option
	 *
	 * @param {String|Boolean} composeTheme - Compose them option
	 * @throws
	 * @returns {undefined}
	 */
	function validateComposeOption(composeTheme) {
	  if ([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE].indexOf(composeTheme) === -1) {
	    throw new Error('Invalid composeTheme option for react-css-themr. Valid composition options are ' + COMPOSE_DEEPLY + ', ' + COMPOSE_SOFTLY + ' and ' + DONT_COMPOSE + '. The given option was ' + composeTheme);
	  }
	}
	
	/**
	 * Removes namespace from key
	 *
	 * @param {String} key - Key
	 * @param {String} themeNamespace - Theme namespace
	 * @returns {String} - Key
	 */
	function removeNamespace(key, themeNamespace) {
	  var capitalized = key.substr(themeNamespace.length);
	  return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
	}
	
	/**
	 * Maps props and theme to an object that will be used to pass down props to the
	 * decorated component.
	 *
	 * @param {Object} ownProps - All props given to the decorated component
	 * @param {Object} theme - Calculated then that should be passed down
	 * @returns {Object} - Props that will be passed down to the decorated component
	 */
	function defaultMapThemrProps(ownProps, theme) {
	  var composeTheme = ownProps.composeTheme,
	      innerRef = ownProps.innerRef,
	      themeNamespace = ownProps.themeNamespace,
	      mapThemrProps = ownProps.mapThemrProps,
	      rest = _objectWithoutProperties(ownProps, ['composeTheme', 'innerRef', 'themeNamespace', 'mapThemrProps']);
	
	  return _extends({}, rest, {
	    ref: innerRef,
	    theme: theme
	  });
	}

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  theme: _propTypes2.default.object.isRequired
	});

/***/ },
/* 2242 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 2243 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var focusNode = __webpack_require__(511);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(177);
	var ExecutionEnvironment = __webpack_require__(51);
	var FallbackCompositionState = __webpack_require__(2251);
	var SyntheticCompositionEvent = __webpack_require__(2288);
	var SyntheticInputEvent = __webpack_require__(2291);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(743);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactInstrumentation = __webpack_require__(68);
	
	var camelizeStyleName = __webpack_require__(1596);
	var dangerousStyleValue = __webpack_require__(2297);
	var hyphenateStyleName = __webpack_require__(1603);
	var memoizeStringOnly = __webpack_require__(1606);
	var warning = __webpack_require__(17);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(176);
	var EventPropagators = __webpack_require__(177);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(83);
	var SyntheticEvent = __webpack_require__(88);
	
	var inputValueTracking = __webpack_require__(759);
	var getEventTarget = __webpack_require__(355);
	var isEventSupported = __webpack_require__(356);
	var isTextInputElement = __webpack_require__(761);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var DOMLazyTree = __webpack_require__(145);
	var ExecutionEnvironment = __webpack_require__(51);
	
	var createNodesFromMarkup = __webpack_require__(1599);
	var emptyFunction = __webpack_require__(77);
	var invariant = __webpack_require__(14);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 2249 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(177);
	var ReactDOMComponentTree = __webpack_require__(36);
	var SyntheticMouseEvent = __webpack_require__(235);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(119);
	
	var getTextContentAccessor = __webpack_require__(758);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(146);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(147);
	
	var instantiateReactComponent = __webpack_require__(760);
	var KeyEscapeUtils = __webpack_require__(347);
	var shouldUpdateReactComponent = __webpack_require__(357);
	var traverseAllChildren = __webpack_require__(763);
	var warning = __webpack_require__(17);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(849);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(343);
	var ReactDOMIDOperations = __webpack_require__(2261);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22),
	    _assign = __webpack_require__(16);
	
	var React = __webpack_require__(151);
	var ReactComponentEnvironment = __webpack_require__(349);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactErrorUtils = __webpack_require__(350);
	var ReactInstanceMap = __webpack_require__(178);
	var ReactInstrumentation = __webpack_require__(68);
	var ReactNodeTypes = __webpack_require__(753);
	var ReactReconciler = __webpack_require__(147);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(137);
	var invariant = __webpack_require__(14);
	var shallowEqual = __webpack_require__(164);
	var shouldUpdateReactComponent = __webpack_require__(357);
	var warning = __webpack_require__(17);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDefaultInjection = __webpack_require__(2269);
	var ReactMount = __webpack_require__(752);
	var ReactReconciler = __webpack_require__(147);
	var ReactUpdates = __webpack_require__(83);
	var ReactVersion = __webpack_require__(2282);
	
	var findDOMNode = __webpack_require__(2298);
	var getHostComponentFromComposite = __webpack_require__(757);
	var renderSubtreeIntoContainer = __webpack_require__(2305);
	var warning = __webpack_require__(17);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22),
	    _assign = __webpack_require__(16);
	
	var AutoFocusUtils = __webpack_require__(2244);
	var CSSPropertyOperations = __webpack_require__(2246);
	var DOMLazyTree = __webpack_require__(145);
	var DOMNamespaces = __webpack_require__(344);
	var DOMProperty = __webpack_require__(146);
	var DOMPropertyOperations = __webpack_require__(745);
	var EventPluginHub = __webpack_require__(176);
	var EventPluginRegistry = __webpack_require__(345);
	var ReactBrowserEventEmitter = __webpack_require__(234);
	var ReactDOMComponentFlags = __webpack_require__(746);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMInput = __webpack_require__(2262);
	var ReactDOMOption = __webpack_require__(2263);
	var ReactDOMSelect = __webpack_require__(747);
	var ReactDOMTextarea = __webpack_require__(2266);
	var ReactInstrumentation = __webpack_require__(68);
	var ReactMultiChild = __webpack_require__(2275);
	var ReactServerRenderingTransaction = __webpack_require__(2280);
	
	var emptyFunction = __webpack_require__(77);
	var escapeTextContentForBrowser = __webpack_require__(237);
	var invariant = __webpack_require__(14);
	var isEventSupported = __webpack_require__(356);
	var shallowEqual = __webpack_require__(164);
	var inputValueTracking = __webpack_require__(759);
	var validateDOMNesting = __webpack_require__(358);
	var warning = __webpack_require__(17);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 2258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(358);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var DOMLazyTree = __webpack_require__(145);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 2260 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(343);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22),
	    _assign = __webpack_require__(16);
	
	var DOMPropertyOperations = __webpack_require__(745);
	var LinkedValueUtils = __webpack_require__(348);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(83);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var React = __webpack_require__(151);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMSelect = __webpack_require__(747);
	
	var warning = __webpack_require__(17);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	var getNodeForCharacterOffset = __webpack_require__(2302);
	var getTextContentAccessor = __webpack_require__(758);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22),
	    _assign = __webpack_require__(16);
	
	var DOMChildrenOperations = __webpack_require__(343);
	var DOMLazyTree = __webpack_require__(145);
	var ReactDOMComponentTree = __webpack_require__(36);
	
	var escapeTextContentForBrowser = __webpack_require__(237);
	var invariant = __webpack_require__(14);
	var validateDOMNesting = __webpack_require__(358);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22),
	    _assign = __webpack_require__(16);
	
	var LinkedValueUtils = __webpack_require__(348);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(83);
	
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactUpdates = __webpack_require__(83);
	var Transaction = __webpack_require__(236);
	
	var emptyFunction = __webpack_require__(77);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(2243);
	var BeforeInputEventPlugin = __webpack_require__(2245);
	var ChangeEventPlugin = __webpack_require__(2247);
	var DefaultEventPluginOrder = __webpack_require__(2249);
	var EnterLeaveEventPlugin = __webpack_require__(2250);
	var HTMLDOMPropertyConfig = __webpack_require__(2252);
	var ReactComponentBrowserEnvironment = __webpack_require__(2254);
	var ReactDOMComponent = __webpack_require__(2257);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactDOMEmptyComponent = __webpack_require__(2259);
	var ReactDOMTreeTraversal = __webpack_require__(2267);
	var ReactDOMTextComponent = __webpack_require__(2265);
	var ReactDefaultBatchingStrategy = __webpack_require__(2268);
	var ReactEventListener = __webpack_require__(2272);
	var ReactInjection = __webpack_require__(2273);
	var ReactReconcileTransaction = __webpack_require__(2278);
	var SVGDOMPropertyConfig = __webpack_require__(2283);
	var SelectEventPlugin = __webpack_require__(2284);
	var SimpleEventPlugin = __webpack_require__(2285);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 2270 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(176);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var EventListener = __webpack_require__(510);
	var ExecutionEnvironment = __webpack_require__(51);
	var PooledClass = __webpack_require__(119);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(83);
	
	var getEventTarget = __webpack_require__(355);
	var getUnboundedScrollPosition = __webpack_require__(1601);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(146);
	var EventPluginHub = __webpack_require__(176);
	var EventPluginUtils = __webpack_require__(346);
	var ReactComponentEnvironment = __webpack_require__(349);
	var ReactEmptyComponent = __webpack_require__(748);
	var ReactBrowserEventEmitter = __webpack_require__(234);
	var ReactHostComponent = __webpack_require__(750);
	var ReactUpdates = __webpack_require__(83);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(2296);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var ReactComponentEnvironment = __webpack_require__(349);
	var ReactInstanceMap = __webpack_require__(178);
	var ReactInstrumentation = __webpack_require__(68);
	
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactReconciler = __webpack_require__(147);
	var ReactChildReconciler = __webpack_require__(2253);
	
	var emptyFunction = __webpack_require__(77);
	var flattenChildren = __webpack_require__(2299);
	var invariant = __webpack_require__(14);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 2277 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var CallbackQueue = __webpack_require__(744);
	var PooledClass = __webpack_require__(119);
	var ReactBrowserEventEmitter = __webpack_require__(234);
	var ReactInputSelection = __webpack_require__(751);
	var ReactInstrumentation = __webpack_require__(68);
	var Transaction = __webpack_require__(236);
	var ReactUpdateQueue = __webpack_require__(351);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(2276);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var PooledClass = __webpack_require__(119);
	var Transaction = __webpack_require__(236);
	var ReactInstrumentation = __webpack_require__(68);
	var ReactServerUpdateQueue = __webpack_require__(2281);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(351);
	
	var warning = __webpack_require__(17);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 2282 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 2283 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(177);
	var ExecutionEnvironment = __webpack_require__(51);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInputSelection = __webpack_require__(751);
	var SyntheticEvent = __webpack_require__(88);
	
	var getActiveElement = __webpack_require__(512);
	var isTextInputElement = __webpack_require__(761);
	var shallowEqual = __webpack_require__(164);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var EventListener = __webpack_require__(510);
	var EventPropagators = __webpack_require__(177);
	var ReactDOMComponentTree = __webpack_require__(36);
	var SyntheticAnimationEvent = __webpack_require__(2286);
	var SyntheticClipboardEvent = __webpack_require__(2287);
	var SyntheticEvent = __webpack_require__(88);
	var SyntheticFocusEvent = __webpack_require__(2290);
	var SyntheticKeyboardEvent = __webpack_require__(2292);
	var SyntheticMouseEvent = __webpack_require__(235);
	var SyntheticDragEvent = __webpack_require__(2289);
	var SyntheticTouchEvent = __webpack_require__(2293);
	var SyntheticTransitionEvent = __webpack_require__(2294);
	var SyntheticUIEvent = __webpack_require__(179);
	var SyntheticWheelEvent = __webpack_require__(2295);
	
	var emptyFunction = __webpack_require__(77);
	var getEventCharCode = __webpack_require__(353);
	var invariant = __webpack_require__(14);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(88);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(88);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(88);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(235);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(179);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(88);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(179);
	
	var getEventCharCode = __webpack_require__(353);
	var getEventKey = __webpack_require__(2300);
	var getEventModifierState = __webpack_require__(354);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(179);
	
	var getEventModifierState = __webpack_require__(354);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(88);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(235);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 2296 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(743);
	var warning = __webpack_require__(17);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(22);
	
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactDOMComponentTree = __webpack_require__(36);
	var ReactInstanceMap = __webpack_require__(178);
	
	var getHostComponentFromComposite = __webpack_require__(757);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(347);
	var traverseAllChildren = __webpack_require__(763);
	var warning = __webpack_require__(17);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_REGION":"us-east-1","REACT_APP_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_DEV_URL":"https://api.myrecruitboard.com","REACT_APP_PROD_IDENTITY_POOL_ID":"us-east-1:98c27e23-8505-4151-b284-33fdbdaf5c5e","REACT_APP_PROD_CLIENT_ID":"2cqfk5fm73rilfj1fm1g29fsa7","REACT_APP_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin","REACT_APP_PROD_REGION":"us-east-1","REACT_APP_AWS_ACCESS_KEY_ID":"AKIAXGXI6TJ44SLMS3VU","REACT_APP_AWS_SECRET_ACCESS_KEY":"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","REACT_APP_PROD_USER_POOL_ID":"us-east-1_gq9355VWI","REACT_APP_PROD_ADMIN_URL":"https://ruslnt154d.execute-api.us-east-1.amazonaws.com/prod/admin"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(849);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(353);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 2301 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 2302 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(51);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(237);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(752);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 2306 */
868,
/* 2307 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 2308 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 2309 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 2310 */
/***/ function(module, exports) {

	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	module.exports = _inherits;

/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(2309);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ },
/* 2312 */
/***/ function(module, exports) {

	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(764);
	
	var assertThisInitialized = __webpack_require__(2306);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ },
/* 2314 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(2));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 10);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports.default = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(6));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(7));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(8));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI.default.ga.apply(_testModeAPI.default, arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2.default)(s, _titleCase);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn.default)('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn.default)('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return false;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA.default)(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn.default)('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'arguments\');');
	      (0, _log.default)("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn.default)('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn.default)('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn.default)('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log.default)('called ga(\'set\', fieldsObject);');
	    (0, _log.default)("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log.default)('called ga(\'send\', fieldObject);');
	    (0, _log.default)("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log.default)("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn.default)('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim.default)(rawPath);
	
	  if (path === '') {
	    (0, _warn.default)('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'send\', \'pageview\', path);');
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log.default)("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn.default)('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash.default)((0, _trim.default)(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn.default)('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log.default)('called ga(\'send\', \'pageview\', path);');
	      (0, _log.default)("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || !value || typeof value !== 'number') {
	      (0, _warn.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn.default)('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn.default)('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn.default)('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn.default)('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn.default)('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   */
	  require: function require(rawName, options) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn.default)('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim.default)(rawName);
	
	      if (name === '') {
	        (0, _warn.default)('`name` cannot be an empty string in .require()');
	        return;
	      } // Optional Fields
	
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn.default)('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn.default)('Empty `options` given to .require()');
	        }
	
	        ga('require', name, options);
	
	        if (_debug) {
	          (0, _log.default)("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga('require', name);
	
	        if (_debug) {
	          (0, _log.default)("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
	      payload = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      actionType = arguments.length <= 2 ? undefined : arguments[2];
	      payload = arguments.length <= 3 ? undefined : arguments[3];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn.default)('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn.default)('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	            (0, _log.default)("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	            (0, _log.default)("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log.default)("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn.default)('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn.default)('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI.default;
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI.default
	};
	exports.default = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(5));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function format(s, titleCase) {
	  if ((0, _mightBeEmail.default)(s)) {
	    (0, _warn.default)('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  if (titleCase) {
	    return (0, _toTitleCase.default)(s);
	  }
	
	  return s;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return /[^@]+@[^@]+/.test(s);
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	
	function toTitleCase(string) {
	  return (0, _trim.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	
	function _default(options) {
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports.default = _default;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(11));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink.default.origTrackLink = _OutboundLink.default.trackLink;
	_OutboundLink.default.trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink.default;
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread({}, Defaults, {
	  OutboundLink: OutboundLink
	});
	
	exports.default = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(12));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  function OutboundLink() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          oldProps = _objectWithoutProperties(_this$props2, ["to"]);
	
	      var props = _objectSpread({}, oldProps, {
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (this.props.target === NEWTAB) {
	        props.rel = 'noopener noreferrer';
	      }
	
	      delete props.eventLabel;
	      return _react.default.createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports.default = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn.default)('ga tracking not enabled');
	});
	
	_defineProperty(OutboundLink, "propTypes", {
	  eventLabel: _propTypes.default.string.isRequired,
	  target: _propTypes.default.string,
	  to: _propTypes.default.string,
	  onClick: _propTypes.default.func,
	  trackerNames: _propTypes.default.arrayOf(_propTypes.default.string)
	});
	
	_defineProperty(OutboundLink, "defaultProps", {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	});
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__12__;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(765);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2317 */
/***/ function(module, exports) {

	/** @license React v16.9.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
	exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};


/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _jss = __webpack_require__(239);
	
	var _jss2 = _interopRequireDefault(_jss);
	
	var _ns = __webpack_require__(361);
	
	var ns = _interopRequireWildcard(_ns);
	
	var _contextTypes = __webpack_require__(766);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JssProvider = function (_Component) {
	  _inherits(JssProvider, _Component);
	
	  function JssProvider() {
	    _classCallCheck(this, JssProvider);
	
	    return _possibleConstructorReturn(this, (JssProvider.__proto__ || Object.getPrototypeOf(JssProvider)).apply(this, arguments));
	  }
	
	  _createClass(JssProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _ref;
	
	      var generateClassName = this.props.generateClassName;
	
	
	      if (!generateClassName) {
	        var createGenerateClassName = _jss.createGenerateClassNameDefault;
	        var localJss = this.props.jss;
	
	        if (localJss && localJss.options.createGenerateClassName) {
	          createGenerateClassName = localJss.options.createGenerateClassName;
	        }
	        generateClassName = createGenerateClassName();
	      }
	
	      return _ref = {}, _defineProperty(_ref, ns.sheetOptions, {
	        generateClassName: generateClassName
	      }), _defineProperty(_ref, ns.providerId, Math.random()), _defineProperty(_ref, ns.jss, this.props.jss), _defineProperty(_ref, ns.sheetsRegistry, this.props.registry), _ref;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return JssProvider;
	}(_react.Component);
	
	JssProvider.propTypes = {
	  jss: (0, _propTypes.instanceOf)(_jss2['default'].constructor),
	  registry: (0, _propTypes.instanceOf)(_jss.SheetsRegistry),
	  generateClassName: _propTypes.func,
	  children: _propTypes.node.isRequired
	};
	JssProvider.childContextTypes = _contextTypes2['default'];
	exports['default'] = JssProvider;

/***/ },
/* 2319 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Adds `composes` property to each top level rule
	 * in order to have a composed class name for dynamic style sheets.
	 *
	 * @param {StyleSheet} staticSheet
	 * @param {Object} styles
	 * @return {Object|null}
	 */
	exports["default"] = function (staticSheet, styles) {
	  for (var name in styles) {
	    var className = staticSheet.classes[name];
	    if (!className) break;
	    styles[name] = _extends({}, styles[name], { composes: className });
	  }
	
	  if (styles) {
	    for (var _name in staticSheet.classes) {
	      var _className = styles[_name];
	      if (!_className) {
	        styles[_name] = { composes: staticSheet.classes[_name] };
	      }
	    }
	  }
	
	  return styles;
	};

/***/ },
/* 2320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theming = __webpack_require__(858);
	
	var _theming2 = _interopRequireDefault(_theming);
	
	var _jss = __webpack_require__(239);
	
	var _jss2 = _interopRequireDefault(_jss);
	
	var _compose = __webpack_require__(2319);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _getDisplayName = __webpack_require__(2321);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _ns = __webpack_require__(361);
	
	var ns = _interopRequireWildcard(_ns);
	
	var _contextTypes = __webpack_require__(766);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Like a Symbol
	var dynamicStylesNs = Math.random();
	
	/*
	 * # Use cases
	 *
	 * - Unthemed component accepts styles object
	 * - Themed component accepts styles creator function which takes theme as a single argument
	 * - Multiple instances will re-use the same static sheet via sheets manager
	 * - Sheet manager identifies static sheets by theme as a key
	 * - For unthemed components theme is an empty object
	 * - The very first instance will add static sheet to sheets manager
	 * - Every further instances will get that static sheet from sheet manager
	 * - Every mount of every instance will call method `sheetsManager.manage`,
	 * thus incrementing reference counter.
	 * - Every unmount of every instance will call method `sheetsManager.unmanage`,
	 * thus decrementing reference counter.
	 * - `sheetsManager.unmanage` under the hood will detach static sheet once reference
	 * counter is zero.
	 * - Dynamic styles are not shared between instances
	 *
	 */
	
	var getStyles = function getStyles(stylesOrCreator, theme) {
	  if (typeof stylesOrCreator !== 'function') {
	    return stylesOrCreator;
	  }
	  return stylesOrCreator(theme);
	};
	
	/**
	 * Wrap a Component into a JSS Container Component.
	 *
	 * @param {Object|Function} stylesOrCreator
	 * @param {Component} InnerComponent
	 * @param {Object} [options]
	 * @return {Component}
	 */
	
	exports['default'] = function (stylesOrCreator, InnerComponent) {
	  var _class, _temp, _initialiseProps;
	
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var isThemingEnabled = typeof stylesOrCreator === 'function';
	
	  var _options$theming = options.theming,
	      theming = _options$theming === undefined ? _theming2['default'] : _options$theming,
	      sheetOptions = _objectWithoutProperties(options, ['theming']);
	
	  var themeListener = theming.themeListener;
	
	  var displayName = 'Jss(' + (0, _getDisplayName2['default'])(InnerComponent) + ')';
	  var noTheme = {};
	  var manager = new _jss.SheetsManager();
	  var providerId = void 0;
	
	  return _temp = _class = function (_Component) {
	    _inherits(Jss, _Component);
	
	    function Jss(props, context) {
	      _classCallCheck(this, Jss);
	
	      var _this = _possibleConstructorReturn(this, (Jss.__proto__ || Object.getPrototypeOf(Jss)).call(this, props, context));
	
	      _initialiseProps.call(_this);
	
	      var theme = isThemingEnabled ? themeListener.initial(context) : noTheme;
	
	      _this.state = _this.createState({ theme: theme });
	      return _this;
	    }
	
	    _createClass(Jss, [{
	      key: 'createState',
	      value: function createState(_ref) {
	        var theme = _ref.theme,
	            dynamicSheet = _ref.dynamicSheet;
	
	        var staticSheet = this.manager.get(theme);
	        var dynamicStyles = void 0;
	
	        if (!staticSheet) {
	          var styles = getStyles(stylesOrCreator, theme);
	          staticSheet = this.jss.createStyleSheet(styles, _extends({}, sheetOptions, this.context[ns.sheetOptions], {
	            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Static'
	          }));
	          this.manager.add(theme, staticSheet);
	          dynamicStyles = (0, _compose2['default'])(staticSheet, (0, _jss.getDynamicStyles)(styles));
	          staticSheet[dynamicStylesNs] = dynamicStyles;
	        } else dynamicStyles = staticSheet[dynamicStylesNs];
	
	        if (dynamicStyles) {
	          dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _extends({}, sheetOptions, this.context[ns.sheetOptions], {
	            meta: displayName + ', ' + (isThemingEnabled ? 'Themed' : 'Unthemed') + ', Dynamic',
	            link: true
	          }));
	        }
	
	        return { theme: theme, dynamicSheet: dynamicSheet };
	      }
	    }, {
	      key: 'manage',
	      value: function manage(_ref2) {
	        var theme = _ref2.theme,
	            dynamicSheet = _ref2.dynamicSheet;
	
	        var registry = this.context[ns.sheetsRegistry];
	
	        var staticSheet = this.manager.manage(theme);
	        if (registry) registry.add(staticSheet);
	
	        if (dynamicSheet) {
	          dynamicSheet.update(this.props).attach();
	          if (registry) registry.add(dynamicSheet);
	        }
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.manage(this.state);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (isThemingEnabled) {
	          this.unsubscribe = themeListener.subscribe(this.context, this.setTheme);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var dynamicSheet = this.state.dynamicSheet;
	
	        if (dynamicSheet) dynamicSheet.update(nextProps);
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if (isThemingEnabled && this.state.theme !== nextState.theme) {
	          var newState = this.createState(nextState);
	          this.manage(newState);
	          this.manager.unmanage(this.state.theme);
	          this.setState(newState);
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        // We remove previous dynamicSheet only after new one was created to avoid FOUC.
	        if (prevState.dynamicSheet !== this.state.dynamicSheet) {
	          this.jss.removeStyleSheet(prevState.dynamicSheet);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (isThemingEnabled && typeof this.unsubscribe === 'function') {
	          this.unsubscribe();
	        }
	
	        this.manager.unmanage(this.state.theme);
	        if (this.state.dynamicSheet) {
	          this.state.dynamicSheet.detach();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            theme = _state.theme,
	            dynamicSheet = _state.dynamicSheet;
	
	        var sheet = dynamicSheet || this.manager.get(theme);
	        var reactJssProps = { sheet: sheet, classes: sheet.classes };
	        if (isThemingEnabled) reactJssProps.theme = theme;
	        return _react2['default'].createElement(InnerComponent, _extends({}, reactJssProps, this.props));
	      }
	    }, {
	      key: 'jss',
	      get: function get() {
	        return this.context[ns.jss] || _jss2['default'];
	      }
	    }, {
	      key: 'manager',
	      get: function get() {
	        if (providerId && this.context[ns.providerId] !== providerId) {
	          manager = new _jss.SheetsManager();
	        }
	        providerId = this.context[ns.providerId];
	
	        return manager;
	      }
	    }]);
	
	    return Jss;
	  }(_react.Component), _class.displayName = displayName, _class.InnerComponent = InnerComponent, _class.contextTypes = _extends({}, _contextTypes2['default'], isThemingEnabled && themeListener.contextTypes), _class.defaultProps = InnerComponent.defaultProps, _initialiseProps = function _initialiseProps() {
	    var _this2 = this;
	
	    this.setTheme = function (theme) {
	      return _this2.setState({ theme: theme });
	    };
	  }, _temp;
	};

/***/ },
/* 2321 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports['default'] = function (Component) {
	  return Component.displayName || Component.name || 'Component';
	};

/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _theming = __webpack_require__(858);
	
	Object.defineProperty(exports, 'ThemeProvider', {
	  enumerable: true,
	  get: function get() {
	    return _theming.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, 'withTheme', {
	  enumerable: true,
	  get: function get() {
	    return _theming.withTheme;
	  }
	});
	Object.defineProperty(exports, 'createTheming', {
	  enumerable: true,
	  get: function get() {
	    return _theming.createTheming;
	  }
	});
	
	var _JssProvider = __webpack_require__(2318);
	
	Object.defineProperty(exports, 'JssProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_JssProvider)['default'];
	  }
	});
	
	var _jss = __webpack_require__(239);
	
	Object.defineProperty(exports, 'jss', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_jss)['default'];
	  }
	});
	Object.defineProperty(exports, 'SheetsRegistry', {
	  enumerable: true,
	  get: function get() {
	    return _jss.SheetsRegistry;
	  }
	});
	Object.defineProperty(exports, 'createGenerateClassName', {
	  enumerable: true,
	  get: function get() {
	    return _jss.createGenerateClassNameDefault;
	  }
	});
	
	var _injectSheet = __webpack_require__(2323);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_injectSheet)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = injectSheet;
	
	var _hoistNonReactStatics = __webpack_require__(2324);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _createHoc = __webpack_require__(2320);
	
	var _createHoc2 = _interopRequireDefault(_createHoc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Global index counter to preserve source order.
	 * As we create the style sheet during componentWillMount lifecycle,
	 * children are handled after the parents, so the order of style elements would
	 * be parent->child. It is a problem though when a parent passes a className
	 * which needs to override any childs styles. StyleSheet of the child has a higher
	 * specificity, because of the source order.
	 * So our solution is to render sheets them in the reverse order child->sheet, so
	 * that parent has a higher specificity.
	 *
	 * @type {Number}
	 */
	var indexCounter = -100000;
	
	var NoRenderer = function NoRenderer(_ref) {
	  var children = _ref.children;
	  return children || null;
	};
	
	/**
	 * HOC creator function that wrapps the user component.
	 *
	 * `injectSheet(styles, [options])(Component)`
	 *
	 * @api public
	 */
	function injectSheet(stylesOrSheet) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (options.index === undefined) {
	    options.index = indexCounter++;
	  }
	  return function () {
	    var InnerComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NoRenderer;
	
	    var Jss = (0, _createHoc2['default'])(stylesOrSheet, InnerComponent, options);
	    return (0, _hoistNonReactStatics2['default'])(Jss, InnerComponent, { inner: true });
	  };
	}

/***/ },
/* 2324 */
2242,
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
	var isBrowser = typeof window !== 'undefined';
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (isBrowser) {
	        if (!this.props.container) {
	          this.container = document.createElement('div');
	          document.body.appendChild(this.container);
	        } else {
	          this.container = this.props.container;
	        }
	        this.renderLayer();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unmountComponentAtNode(this.container);
	      }
	      if (!this.props.container) {
	        document.body.removeChild(this.container);
	      }
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (useCreatePortal) {
	        return _reactDom2.default.createPortal(this.props.children, this.container);
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node, // eslint-disable-line
	  container: _propTypes2.default.object // eslint-disable-line
	};
	
	exports.default = Portal;

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(21);
	var DOMFactories = __webpack_require__(742);
	var PropTypes = __webpack_require__(2);
	var ExecutionEnvironment = __webpack_require__(2332);
	var ModalPortal = React.createFactory(__webpack_require__(2327));
	var ariaAppHider = __webpack_require__(2328);
	var refCount = __webpack_require__(2330);
	var elementClass = __webpack_require__(1421);
	var renderSubtreeIntoContainer = __webpack_require__(21).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(524);
	var createReactClass = __webpack_require__(304);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = createReactClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: PropTypes.bool.isRequired,
	    style: PropTypes.shape({
	      content: PropTypes.object,
	      overlay: PropTypes.object
	    }),
	    portalClassName: PropTypes.string,
	    bodyOpenClassName: PropTypes.string,
	    appElement: PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: PropTypes.func,
	    onRequestClose: PropTypes.func,
	    closeTimeoutMS: PropTypes.number,
	    ariaHideApp: PropTypes.bool,
	    shouldCloseOnOverlayClick: PropTypes.bool,
	    parentSelector: PropTypes.func,
	    role: PropTypes.string,
	    contentLabel: PropTypes.string.isRequired
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      portalClassName: 'ReactModalPortal',
	      bodyOpenClassName: 'ReactModal__Body--open',
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true,
	      parentSelector: function () { return document.body; }
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = this.props.portalClassName;
	
	    if (this.props.isOpen) refCount.add(this);
	
	    var parent = getParentElement(this.props.parentSelector);
	    parent.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillUpdate: function(newProps) {
	    if(newProps.portalClassName !== this.props.portalClassName) {
	      this.node.className = newProps.portalClassName;
	    }
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    if (newProps.isOpen) refCount.add(this);
	    if (!newProps.isOpen) refCount.remove(this);
	    var currentParent = getParentElement(this.props.parentSelector);
	    var newParent = getParentElement(newProps.parentSelector);
	
	    if(newParent !== currentParent) {
	      currentParent.removeChild(this.node);
	      newParent.appendChild(this.node);
	    }
	
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    if (!this.node) return;
	
	    refCount.remove(this);
	
	    if (this.props.ariaHideApp) {
	      ariaAppHider.show(this.props.appElement);
	    }
	
	    var state = this.portal.state;
	    var now = Date.now();
	    var closesAt = state.isOpen && this.props.closeTimeoutMS
	      && (state.closesAt
	        || now + this.props.closeTimeoutMS);
	
	    if (closesAt) {
	      if (!state.beforeClose) {
	        this.portal.closeWithTimeout();
	      }
	
	      var that = this;
	      setTimeout(function() { that.removePortal(); }, closesAt - now);
	    } else {
	      this.removePortal();
	    }
	  },
	
	  removePortal: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    var parent = getParentElement(this.props.parentSelector);
	    parent.removeChild(this.node);
	
	    if (refCount.count() === 0) {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen || refCount.count() > 0) {
	      elementClass(document.body).add(this.props.bodyOpenClassName);
	    } else {
	      elementClass(document.body).remove(this.props.bodyOpenClassName);
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return DOMFactories.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var DOMFactories = __webpack_require__(742);
	var focusManager = __webpack_require__(2329);
	var scopeTab = __webpack_require__(2331);
	var Assign = __webpack_require__(524);
	var createReactClass = __webpack_require__(304);
	
	var div = DOMFactories.div;
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: 'ReactModal__Overlay',
	  content: 'ReactModal__Content'
	};
	
	var ModalPortal = module.exports = createReactClass({
	
	  displayName: 'ModalPortal',
	  shouldClose: null,
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  afterClose: function () {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  open: function () {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    // Don't steal focus from inner elements
	    if (!this.contentHasFocus()) {
	      this.refs.content.focus();
	    }
	  },
	
	  closeWithTimeout: function() {
	    var closesAt = Date.now() + this.props.closeTimeoutMS;
	    this.setState({beforeClose: true, closesAt: closesAt}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	      closesAt: null
	    }, this.afterClose);
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayOnClick: function (event) {
	    if (this.shouldClose === null) {
	      this.shouldClose = true;
	    }
	
	    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	    this.shouldClose = null;
	  },
	
	  handleContentOnClick: function () {
	    this.shouldClose = false;
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.state.isOpen && !this.state.beforeClose;
	  },
	
	  contentHasFocus: function() {
	    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
	  },
	
	  buildClassName: function(which, additional) {
	    var classNames = (typeof additional === 'object') ? additional : {
	      base: CLASS_NAMES[which],
	      afterOpen: CLASS_NAMES[which] + "--after-open",
	      beforeClose: CLASS_NAMES[which] + "--before-close"
	    };
	    var className = classNames.base;
	    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
	    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
	    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onClick: this.handleOverlayOnClick
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown,
	          onClick: this.handleContentOnClick,
	          role: this.props.role,
	          "aria-label": this.props.contentLabel
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },
/* 2328 */
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(768);
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElements.push(document.activeElement);
	};
	
	exports.returnFocus = function() {
	  var toFocus = null;
	  try {
	    toFocus = focusLaterElements.pop();
	    toFocus.focus();
	    return;
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
	  }
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};


/***/ },
/* 2330 */
/***/ function(module, exports) {

	var modals = [];
	
	module.exports = {
	  add: function (element) {
	    if (modals.indexOf(element) === -1) {
	      modals.push(element);
	    }
	  },
	  remove: function (element) {
	    var index = modals.indexOf(element);
	    if (index === -1) {
	      return;
	    }
	    modals.splice(index, 1);
	  },
	  count: function () {
	    return modals.length;
	  }
	};


/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(768);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(392));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _PropTypes = __webpack_require__(771);
	
	var _warning = _interopRequireDefault(__webpack_require__(362));
	
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(267));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(268));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(769));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(2342));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(2335));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(2336));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(2337));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(2338));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(265);
	
	var _wrapMapToProps = __webpack_require__(770);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(770);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(267));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(772));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(268));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(2339));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 2339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(54);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(362));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 2340 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 2341 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 2342 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(360);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 2344 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  overlay: {
	    background: 'rgba(0, 0, 0, 0.75)',
	    display: 'flex',
	    alignItems: 'flex-start',
	    justifyContent: 'center',
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    zIndex: 1000,
	    padding: '1.2rem'
	  },
	  overlayLittle: {
	    alignItems: 'center'
	  },
	  modal: {
	    maxWidth: 800,
	    position: 'relative',
	    padding: '1.2rem',
	    background: '#ffffff',
	    backgroundClip: 'padding-box',
	    boxShadow: '0 12px 15px 0 rgba(0,0,0,0.25)'
	  },
	  closeIcon: {
	    position: 'absolute',
	    top: '14px',
	    right: '14px',
	    cursor: 'pointer'
	  },
	  transitionEnter: {
	    opacity: '0.01'
	  },
	  transitionEnterActive: {
	    opacity: 1,
	    transition: 'opacity 500ms cubic-bezier(0.23, 1, 0.32, 1)'
	  },
	  transitionLeave: {
	    opacity: 1
	  },
	  transitionLeaveActive: {
	    opacity: '0.01',
	    transition: 'opacity 500ms cubic-bezier(0.23, 1, 0.32, 1)'
	  }
	};

/***/ },
/* 2345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(775);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(114);
	
	var _Router = __webpack_require__(364);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(775);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(114);
	
	var _Router = __webpack_require__(364);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 2347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(778);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(774);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(773);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(779);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(780);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(781);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(782);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(366);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(243);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(784);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(89);
	
	var _reducer = __webpack_require__(777);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedRouter = function (_Component) {
	  _inherits(ConnectedRouter, _Component);
	
	  function ConnectedRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
	      _this.store.dispatch({
	        type: _reducer.LOCATION_CHANGE,
	        payload: location
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        propsStore = _props.store,
	        history = _props.history,
	        isSSR = _props.isSSR;
	
	    this.store = propsStore || this.context.store;
	    this.handleLocationChange(history.location);
	
	    if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
	  };
	
	  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
	  };
	
	  ConnectedRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, this.props);
	  };
	
	  return ConnectedRouter;
	}(_react.Component);
	
	ConnectedRouter.propTypes = {
	  store: _propTypes2.default.object,
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node,
	  isSSR: _propTypes2.default.bool
	};
	ConnectedRouter.contextTypes = {
	  store: _propTypes2.default.object
	};
	exports.default = ConnectedRouter;

/***/ },
/* 2357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerMiddleware;
	
	var _actions = __webpack_require__(776);
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, args);
	      };
	    };
	  };
	}

/***/ },
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMatchSelector = exports.getLocation = undefined;
	
	var _reactRouter = __webpack_require__(89);
	
	var getLocation = exports.getLocation = function getLocation(state) {
	  return state.router.location;
	};
	
	var createMatchSelector = exports.createMatchSelector = function createMatchSelector(path) {
	  var lastPathname = null;
	  var lastMatch = null;
	  return function (state) {
	    var _ref = getLocation(state) || {},
	        pathname = _ref.pathname;
	
	    if (pathname === lastPathname) {
	      return lastMatch;
	    }
	    lastPathname = pathname;
	    var match = (0, _reactRouter.matchPath)(pathname, path);
	    if (!match || !lastMatch || match.url !== lastMatch.url) {
	      lastMatch = match;
	    }
	    return lastMatch;
	  };
	};

/***/ },
/* 2359 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 2360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(2361));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 2361 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(367);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ },
/* 2363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ },
/* 2364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2368);

/***/ },
/* 2365 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 2366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(2367);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(367);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(2365);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(785);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(304);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(2369);
	
	var _dots = __webpack_require__(2363);
	
	var _arrows = __webpack_require__(2362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    typeof slide === 'number' && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ },
/* 2367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(786);
	
	var _helpers = __webpack_require__(367);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = parseInt(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(2366);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(1859);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(785);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(1411);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(1425);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(16);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
	    var cssClasses;
	
	    if (child.props.className) {
	      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Step = function (_Component) {
	  _inherits(Step, _Component);
	
	  function Step() {
	    _classCallCheck(this, Step);
	
	    var _this = _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this));
	
	    _this.getStyles = _this.getStyles.bind(_this);
	    return _this;
	  }
	
	  _createClass(Step, [{
	    key: 'getStyles',
	    value: function getStyles() {
	      var _props = this.props,
	          activeColor = _props.activeColor,
	          completeColor = _props.completeColor,
	          defaultColor = _props.defaultColor,
	          circleFontColor = _props.circleFontColor,
	          activeTitleColor = _props.activeTitleColor,
	          completeTitleColor = _props.completeTitleColor,
	          defaultTitleColor = _props.defaultTitleColor,
	          size = _props.size,
	          circleFontSize = _props.circleFontSize,
	          titleFontSize = _props.titleFontSize,
	          circleTop = _props.circleTop,
	          titleTop = _props.titleTop,
	          width = _props.width,
	          completeOpacity = _props.completeOpacity,
	          activeOpacity = _props.activeOpacity,
	          defaultOpacity = _props.defaultOpacity,
	          completeTitleOpacity = _props.completeTitleOpacity,
	          activeTitleOpacity = _props.activeTitleOpacity,
	          defaultTitleOpacity = _props.defaultTitleOpacity,
	          barStyle = _props.barStyle,
	          defaultBarColor = _props.defaultBarColor,
	          completeBarColor = _props.completeBarColor,
	          defaultBorderColor = _props.defaultBorderColor,
	          completeBorderColor = _props.completeBorderColor,
	          activeBorderColor = _props.activeBorderColor,
	          defaultBorderStyle = _props.defaultBorderStyle,
	          completeBorderStyle = _props.completeBorderStyle,
	          activeBorderStyle = _props.activeBorderStyle,
	          lineMarginOffset = _props.lineMarginOffset,
	          defaultBorderWidth = _props.defaultBorderWidth;
	
	
	      return {
	        step: {
	          width: width + '%',
	          display: 'table-cell',
	          position: 'relative',
	          paddingTop: circleTop
	        },
	        circle: {
	          width: size,
	          height: size,
	          margin: '0 auto',
	          backgroundColor: defaultColor,
	          borderRadius: '50%',
	          textAlign: 'center',
	          padding: 1,
	          fontSize: circleFontSize,
	          color: circleFontColor,
	          display: 'block',
	          opacity: defaultOpacity,
	          borderWidth: defaultBorderColor ? defaultBorderWidth : 0,
	          borderColor: defaultBorderColor,
	          borderStyle: defaultBorderStyle
	        },
	        activeCircle: {
	          backgroundColor: activeColor,
	          opacity: activeOpacity,
	          borderWidth: activeBorderColor ? defaultBorderWidth : 0,
	          borderColor: activeBorderColor,
	          borderStyle: activeBorderStyle
	        },
	        completedCircle: {
	          backgroundColor: completeColor,
	          opacity: completeOpacity,
	          borderWidth: completeBorderColor ? defaultBorderWidth : 0,
	          borderColor: completeBorderColor,
	          borderStyle: completeBorderStyle
	        },
	        index: {
	          lineHeight: size + circleFontSize / 4 + 'px',
	          color: circleFontColor
	        },
	        title: {
	          marginTop: titleTop,
	          fontSize: titleFontSize,
	          fontWeight: '300',
	          textAlign: 'center',
	          display: 'block',
	          color: defaultTitleColor,
	          opacity: defaultTitleOpacity
	        },
	        activeTitle: {
	          color: activeTitleColor,
	          opacity: activeTitleOpacity
	        },
	        completedTitle: {
	          color: completeTitleColor,
	          opacity: completeTitleOpacity
	        },
	        leftBar: {
	          position: 'absolute',
	          top: circleTop + size / 2,
	          height: 1,
	          borderTopStyle: barStyle,
	          borderTopWidth: 1,
	          borderTopColor: defaultBarColor,
	          left: 0,
	          right: '50%',
	          marginRight: size / 2 + lineMarginOffset,
	          opacity: defaultOpacity
	        },
	        rightBar: {
	          position: 'absolute',
	          top: circleTop + size / 2,
	          height: 1,
	          borderTopStyle: barStyle,
	          borderTopWidth: 1,
	          borderTopColor: defaultBarColor,
	          right: 0,
	          left: '50%',
	          marginLeft: size / 2 + lineMarginOffset,
	          opacity: defaultOpacity
	        },
	        completedBar: {
	          borderTopStyle: barStyle,
	          borderTopWidth: 1,
	          borderTopColor: completeBarColor,
	          opacity: completeOpacity
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          title = _props2.title,
	          icon = _props2.icon,
	          index = _props2.index,
	          active = _props2.active,
	          completed = _props2.completed,
	          first = _props2.first,
	          isLast = _props2.isLast,
	          href = _props2.href,
	          onClick = _props2.onClick;
	
	
	      var styles = this.getStyles();
	      var circleStyle = Object.assign(styles.circle, completed ? styles.completedCircle : {}, active ? styles.activeCircle : {});
	      var titleStyle = Object.assign(styles.title, completed ? styles.completedTitle : {}, active ? styles.activeTitle : {});
	      var leftStyle = Object.assign(styles.leftBar, active || completed ? styles.completedBar : {});
	      var rightStyle = Object.assign(styles.rightBar, completed ? styles.completedBar : {});
	
	      var stepContent = icon ? _react2.default.createElement('img', { src: icon, alt: index + 1 }) : index + 1;
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.step },
	        _react2.default.createElement(
	          'div',
	          { style: circleStyle },
	          active || completed ? _react2.default.createElement(
	            'a',
	            { href: href, onClick: onClick, style: styles.index },
	            stepContent
	          ) : _react2.default.createElement(
	            'span',
	            { style: styles.index },
	            stepContent
	          )
	        ),
	        active || completed ? _react2.default.createElement(
	          'a',
	          { href: href, onClick: onClick, style: titleStyle },
	          title
	        ) : _react2.default.createElement(
	          'div',
	          { style: titleStyle },
	          title
	        ),
	        !first && _react2.default.createElement('div', { style: leftStyle }),
	        !isLast && _react2.default.createElement('div', { style: rightStyle })
	      );
	    }
	  }]);
	
	  return Step;
	}(_react.Component);
	
	exports.default = Step;
	
	
	Step.defaultProps = {
	  activeColor: '#5096FF',
	  completeColor: '#5096FF',
	  defaultColor: '#E0E0E0',
	  activeTitleColor: '#000',
	  completeTitleColor: '#000',
	  defaultTitleColor: '#757575',
	  circleFontColor: '#FFF',
	  size: 32,
	  circleFontSize: 16,
	  titleFontSize: 16,
	  circleTop: 24,
	  titleTop: 8,
	  defaultBarColor: '#E0E0E0',
	  barStyle: 'solid',
	  borderStyle: 'solid',
	  lineMarginOffset: 4,
	  defaultBorderWidth: 3
	};
	
	Step.propTypes = {
	  width: _propTypes.PropTypes.number.isRequired,
	  activeColor: _propTypes.PropTypes.string,
	  completeColor: _propTypes.PropTypes.string,
	  defaultColor: _propTypes.PropTypes.string,
	  activeTitleColor: _propTypes.PropTypes.string,
	  completeTitleColor: _propTypes.PropTypes.string,
	  defaultTitleColor: _propTypes.PropTypes.string,
	  circleFontColor: _propTypes.PropTypes.string,
	  size: _propTypes.PropTypes.number,
	  circleFontSize: _propTypes.PropTypes.number,
	  titleFontSize: _propTypes.PropTypes.number,
	  circleTop: _propTypes.PropTypes.number,
	  titleTop: _propTypes.PropTypes.number,
	  title: _propTypes.PropTypes.string,
	  index: _propTypes.PropTypes.number,
	  active: _propTypes.PropTypes.bool,
	  completed: _propTypes.PropTypes.bool,
	  first: _propTypes.PropTypes.bool,
	  isLast: _propTypes.PropTypes.bool,
	  completeOpacity: _propTypes.PropTypes.string,
	  activeOpacity: _propTypes.PropTypes.string,
	  defaultOpacity: _propTypes.PropTypes.string,
	  completeTitleOpacity: _propTypes.PropTypes.string,
	  activeTitleOpacity: _propTypes.PropTypes.string,
	  defaultTitleOpacity: _propTypes.PropTypes.string,
	  barStyle: _propTypes.PropTypes.string,
	  defaultBarColor: _propTypes.PropTypes.string,
	  completeBarColor: _propTypes.PropTypes.string,
	  defaultBorderColor: _propTypes.PropTypes.string,
	  completeBorderColor: _propTypes.PropTypes.string,
	  activeBorderColor: _propTypes.PropTypes.string,
	  defaultBorderStyle: _propTypes.PropTypes.string,
	  completeBorderStyle: _propTypes.PropTypes.string,
	  activeBorderStyle: _propTypes.PropTypes.string,
	  lineMarginOffset: _propTypes.PropTypes.number,
	  defaultBorderWidth: _propTypes.PropTypes.number
	};

/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _Step = __webpack_require__(2370);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    width: '100%',
	    minHeight: 0,
	    padding: 0
	  },
	  stepper: {
	    display: 'table',
	    width: '100%',
	    margin: '0 auto'
	  }
	};
	
	function Stepper(_ref) {
	  var activeStep = _ref.activeStep,
	      steps = _ref.steps,
	      disabledSteps = _ref.disabledSteps,
	      activeColor = _ref.activeColor,
	      completeColor = _ref.completeColor,
	      defaultColor = _ref.defaultColor,
	      circleFontColor = _ref.circleFontColor,
	      activeTitleColor = _ref.activeTitleColor,
	      completeTitleColor = _ref.completeTitleColor,
	      defaultTitleColor = _ref.defaultTitleColor,
	      size = _ref.size,
	      circleFontSize = _ref.circleFontSize,
	      titleFontSize = _ref.titleFontSize,
	      circleTop = _ref.circleTop,
	      titleTop = _ref.titleTop,
	      completeOpacity = _ref.completeOpacity,
	      activeOpacity = _ref.activeOpacity,
	      defaultOpacity = _ref.defaultOpacity,
	      completeTitleOpacity = _ref.completeTitleOpacity,
	      activeTitleOpacity = _ref.activeTitleOpacity,
	      defaultTitleOpacity = _ref.defaultTitleOpacity,
	      barStyle = _ref.barStyle,
	      defaultBorderColor = _ref.defaultBorderColor,
	      completeBorderColor = _ref.completeBorderColor,
	      activeBorderColor = _ref.activeBorderColor,
	      defaultBorderStyle = _ref.defaultBorderStyle,
	      completeBorderStyle = _ref.completeBorderStyle,
	      activeBorderStyle = _ref.activeBorderStyle,
	      defaultBarColor = _ref.defaultBarColor,
	      completeBarColor = _ref.completeBarColor,
	      lineMarginOffset = _ref.lineMarginOffset,
	      defaultBorderWidth = _ref.defaultBorderWidth;
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.root },
	    _react2.default.createElement(
	      'div',
	      { style: styles.stepper },
	      steps.map(function (step, index) {
	        return _react2.default.createElement(_Step2.default, {
	          key: index,
	          width: 100 / steps.length,
	          title: step.title,
	          icon: step.icon,
	          href: step.href,
	          onClick: step.onClick,
	          active: !(disabledSteps || []).includes(index) && index === activeStep,
	          completed: !(disabledSteps || []).includes(index) && index < activeStep,
	          first: index === 0,
	          isLast: index === steps.length - 1,
	          index: index,
	          activeColor: activeColor,
	          completeColor: completeColor,
	          defaultColor: defaultColor,
	          circleFontColor: circleFontColor,
	          activeTitleColor: activeTitleColor,
	          completeTitleColor: completeTitleColor,
	          defaultTitleColor: defaultTitleColor,
	          size: size,
	          circleFontSize: circleFontSize,
	          titleFontSize: titleFontSize,
	          circleTop: circleTop,
	          titleTop: titleTop,
	          defaultOpacity: defaultOpacity,
	          completeOpacity: completeOpacity,
	          activeOpacity: activeOpacity,
	          defaultTitleOpacity: defaultTitleOpacity,
	          completeTitleOpacity: completeTitleOpacity,
	          activeTitleOpacity: activeTitleOpacity,
	          barStyle: barStyle,
	          defaultBorderColor: defaultBorderColor,
	          completeBorderColor: completeBorderColor,
	          activeBorderColor: activeBorderColor,
	          defaultBorderStyle: defaultBorderStyle,
	          defaultBorderWidth: defaultBorderWidth,
	          completeBorderStyle: completeBorderStyle,
	          activeBorderStyle: activeBorderStyle,
	          defaultBarColor: defaultBarColor,
	          completeBarColor: completeBarColor,
	          lineMarginOffset: lineMarginOffset
	        });
	      })
	    )
	  );
	}
	
	Stepper.defaultProps = {
	  activeStep: 0
	};
	
	Stepper.propTypes = {
	  activeStep: _propTypes.PropTypes.number,
	  steps: _propTypes.PropTypes.array,
	  activeColor: _propTypes.PropTypes.string,
	  completeColor: _propTypes.PropTypes.string,
	  defaultColor: _propTypes.PropTypes.string,
	  activeTitleColor: _propTypes.PropTypes.string,
	  completeTitleColor: _propTypes.PropTypes.string,
	  defaultTitleColor: _propTypes.PropTypes.string,
	  circleFontColor: _propTypes.PropTypes.string,
	  size: _propTypes.PropTypes.number,
	  circleFontSize: _propTypes.PropTypes.number,
	  titleFontSize: _propTypes.PropTypes.number,
	  circleTop: _propTypes.PropTypes.number,
	  titleTop: _propTypes.PropTypes.number,
	  defaultOpacity: _propTypes.PropTypes.string,
	  completeOpacity: _propTypes.PropTypes.string,
	  activeOpacity: _propTypes.PropTypes.string,
	  defaultTitleOpacity: _propTypes.PropTypes.string,
	  completeTitleOpacity: _propTypes.PropTypes.string,
	  activeTitleOpacity: _propTypes.PropTypes.string,
	  barStyle: _propTypes.PropTypes.string,
	  defaultBarColor: _propTypes.PropTypes.string,
	  completeBarColor: _propTypes.PropTypes.string,
	  defaultBorderColor: _propTypes.PropTypes.string,
	  completeBorderColor: _propTypes.PropTypes.string,
	  activeBorderColor: _propTypes.PropTypes.string,
	  defaultBorderStyle: _propTypes.PropTypes.string,
	  completeBorderStyle: _propTypes.PropTypes.string,
	  activeBorderStyle: _propTypes.PropTypes.string,
	  lineMarginOffset: _propTypes.PropTypes.number,
	  defaultBorderWidth: _propTypes.PropTypes.number
	};
	
	exports.default = Stepper;

/***/ },
/* 2372 */
/***/ function(module, exports) {

	// GENERATED DO NOT EDIT
	module.exports = [
	  "alignContent",
	  "MozAlignContent",
	  "WebkitAlignContent",
	  "MSAlignContent",
	  "OAlignContent",
	  "alignItems",
	  "MozAlignItems",
	  "WebkitAlignItems",
	  "MSAlignItems",
	  "OAlignItems",
	  "alignSelf",
	  "MozAlignSelf",
	  "WebkitAlignSelf",
	  "MSAlignSelf",
	  "OAlignSelf",
	  "all",
	  "MozAll",
	  "WebkitAll",
	  "MSAll",
	  "OAll",
	  "animation",
	  "MozAnimation",
	  "WebkitAnimation",
	  "MSAnimation",
	  "OAnimation",
	  "animationDelay",
	  "MozAnimationDelay",
	  "WebkitAnimationDelay",
	  "MSAnimationDelay",
	  "OAnimationDelay",
	  "animationDirection",
	  "MozAnimationDirection",
	  "WebkitAnimationDirection",
	  "MSAnimationDirection",
	  "OAnimationDirection",
	  "animationDuration",
	  "MozAnimationDuration",
	  "WebkitAnimationDuration",
	  "MSAnimationDuration",
	  "OAnimationDuration",
	  "animationFillMode",
	  "MozAnimationFillMode",
	  "WebkitAnimationFillMode",
	  "MSAnimationFillMode",
	  "OAnimationFillMode",
	  "animationIterationCount",
	  "MozAnimationIterationCount",
	  "WebkitAnimationIterationCount",
	  "MSAnimationIterationCount",
	  "OAnimationIterationCount",
	  "animationName",
	  "MozAnimationName",
	  "WebkitAnimationName",
	  "MSAnimationName",
	  "OAnimationName",
	  "animationPlayState",
	  "MozAnimationPlayState",
	  "WebkitAnimationPlayState",
	  "MSAnimationPlayState",
	  "OAnimationPlayState",
	  "animationTimingFunction",
	  "MozAnimationTimingFunction",
	  "WebkitAnimationTimingFunction",
	  "MSAnimationTimingFunction",
	  "OAnimationTimingFunction",
	  "backfaceVisibility",
	  "MozBackfaceVisibility",
	  "WebkitBackfaceVisibility",
	  "MSBackfaceVisibility",
	  "OBackfaceVisibility",
	  "background",
	  "MozBackground",
	  "WebkitBackground",
	  "MSBackground",
	  "OBackground",
	  "backgroundAttachment",
	  "MozBackgroundAttachment",
	  "WebkitBackgroundAttachment",
	  "MSBackgroundAttachment",
	  "OBackgroundAttachment",
	  "backgroundBlendMode",
	  "MozBackgroundBlendMode",
	  "WebkitBackgroundBlendMode",
	  "MSBackgroundBlendMode",
	  "OBackgroundBlendMode",
	  "backgroundClip",
	  "MozBackgroundClip",
	  "WebkitBackgroundClip",
	  "MSBackgroundClip",
	  "OBackgroundClip",
	  "backgroundColor",
	  "MozBackgroundColor",
	  "WebkitBackgroundColor",
	  "MSBackgroundColor",
	  "OBackgroundColor",
	  "backgroundImage",
	  "MozBackgroundImage",
	  "WebkitBackgroundImage",
	  "MSBackgroundImage",
	  "OBackgroundImage",
	  "backgroundOrigin",
	  "MozBackgroundOrigin",
	  "WebkitBackgroundOrigin",
	  "MSBackgroundOrigin",
	  "OBackgroundOrigin",
	  "backgroundPosition",
	  "MozBackgroundPosition",
	  "WebkitBackgroundPosition",
	  "MSBackgroundPosition",
	  "OBackgroundPosition",
	  "backgroundRepeat",
	  "MozBackgroundRepeat",
	  "WebkitBackgroundRepeat",
	  "MSBackgroundRepeat",
	  "OBackgroundRepeat",
	  "backgroundSize",
	  "MozBackgroundSize",
	  "WebkitBackgroundSize",
	  "MSBackgroundSize",
	  "OBackgroundSize",
	  "blockSize",
	  "MozBlockSize",
	  "WebkitBlockSize",
	  "MSBlockSize",
	  "OBlockSize",
	  "border",
	  "MozBorder",
	  "WebkitBorder",
	  "MSBorder",
	  "OBorder",
	  "borderBlockEnd",
	  "MozBorderBlockEnd",
	  "WebkitBorderBlockEnd",
	  "MSBorderBlockEnd",
	  "OBorderBlockEnd",
	  "borderBlockEndColor",
	  "MozBorderBlockEndColor",
	  "WebkitBorderBlockEndColor",
	  "MSBorderBlockEndColor",
	  "OBorderBlockEndColor",
	  "borderBlockEndStyle",
	  "MozBorderBlockEndStyle",
	  "WebkitBorderBlockEndStyle",
	  "MSBorderBlockEndStyle",
	  "OBorderBlockEndStyle",
	  "borderBlockEndWidth",
	  "MozBorderBlockEndWidth",
	  "WebkitBorderBlockEndWidth",
	  "MSBorderBlockEndWidth",
	  "OBorderBlockEndWidth",
	  "borderBlockStart",
	  "MozBorderBlockStart",
	  "WebkitBorderBlockStart",
	  "MSBorderBlockStart",
	  "OBorderBlockStart",
	  "borderBlockStartColor",
	  "MozBorderBlockStartColor",
	  "WebkitBorderBlockStartColor",
	  "MSBorderBlockStartColor",
	  "OBorderBlockStartColor",
	  "borderBlockStartStyle",
	  "MozBorderBlockStartStyle",
	  "WebkitBorderBlockStartStyle",
	  "MSBorderBlockStartStyle",
	  "OBorderBlockStartStyle",
	  "borderBlockStartWidth",
	  "MozBorderBlockStartWidth",
	  "WebkitBorderBlockStartWidth",
	  "MSBorderBlockStartWidth",
	  "OBorderBlockStartWidth",
	  "borderBottom",
	  "MozBorderBottom",
	  "WebkitBorderBottom",
	  "MSBorderBottom",
	  "OBorderBottom",
	  "borderBottomColor",
	  "MozBorderBottomColor",
	  "WebkitBorderBottomColor",
	  "MSBorderBottomColor",
	  "OBorderBottomColor",
	  "borderBottomLeftRadius",
	  "MozBorderBottomLeftRadius",
	  "WebkitBorderBottomLeftRadius",
	  "MSBorderBottomLeftRadius",
	  "OBorderBottomLeftRadius",
	  "borderBottomRightRadius",
	  "MozBorderBottomRightRadius",
	  "WebkitBorderBottomRightRadius",
	  "MSBorderBottomRightRadius",
	  "OBorderBottomRightRadius",
	  "borderBottomStyle",
	  "MozBorderBottomStyle",
	  "WebkitBorderBottomStyle",
	  "MSBorderBottomStyle",
	  "OBorderBottomStyle",
	  "borderBottomWidth",
	  "MozBorderBottomWidth",
	  "WebkitBorderBottomWidth",
	  "MSBorderBottomWidth",
	  "OBorderBottomWidth",
	  "borderCollapse",
	  "MozBorderCollapse",
	  "WebkitBorderCollapse",
	  "MSBorderCollapse",
	  "OBorderCollapse",
	  "borderColor",
	  "MozBorderColor",
	  "WebkitBorderColor",
	  "MSBorderColor",
	  "OBorderColor",
	  "borderImage",
	  "MozBorderImage",
	  "WebkitBorderImage",
	  "MSBorderImage",
	  "OBorderImage",
	  "borderImageOutset",
	  "MozBorderImageOutset",
	  "WebkitBorderImageOutset",
	  "MSBorderImageOutset",
	  "OBorderImageOutset",
	  "borderImageRepeat",
	  "MozBorderImageRepeat",
	  "WebkitBorderImageRepeat",
	  "MSBorderImageRepeat",
	  "OBorderImageRepeat",
	  "borderImageSlice",
	  "MozBorderImageSlice",
	  "WebkitBorderImageSlice",
	  "MSBorderImageSlice",
	  "OBorderImageSlice",
	  "borderImageSource",
	  "MozBorderImageSource",
	  "WebkitBorderImageSource",
	  "MSBorderImageSource",
	  "OBorderImageSource",
	  "borderImageWidth",
	  "MozBorderImageWidth",
	  "WebkitBorderImageWidth",
	  "MSBorderImageWidth",
	  "OBorderImageWidth",
	  "borderInlineEnd",
	  "MozBorderInlineEnd",
	  "WebkitBorderInlineEnd",
	  "MSBorderInlineEnd",
	  "OBorderInlineEnd",
	  "borderInlineEndColor",
	  "MozBorderInlineEndColor",
	  "WebkitBorderInlineEndColor",
	  "MSBorderInlineEndColor",
	  "OBorderInlineEndColor",
	  "borderInlineEndStyle",
	  "MozBorderInlineEndStyle",
	  "WebkitBorderInlineEndStyle",
	  "MSBorderInlineEndStyle",
	  "OBorderInlineEndStyle",
	  "borderInlineEndWidth",
	  "MozBorderInlineEndWidth",
	  "WebkitBorderInlineEndWidth",
	  "MSBorderInlineEndWidth",
	  "OBorderInlineEndWidth",
	  "borderInlineStart",
	  "MozBorderInlineStart",
	  "WebkitBorderInlineStart",
	  "MSBorderInlineStart",
	  "OBorderInlineStart",
	  "borderInlineStartColor",
	  "MozBorderInlineStartColor",
	  "WebkitBorderInlineStartColor",
	  "MSBorderInlineStartColor",
	  "OBorderInlineStartColor",
	  "borderInlineStartStyle",
	  "MozBorderInlineStartStyle",
	  "WebkitBorderInlineStartStyle",
	  "MSBorderInlineStartStyle",
	  "OBorderInlineStartStyle",
	  "borderInlineStartWidth",
	  "MozBorderInlineStartWidth",
	  "WebkitBorderInlineStartWidth",
	  "MSBorderInlineStartWidth",
	  "OBorderInlineStartWidth",
	  "borderLeft",
	  "MozBorderLeft",
	  "WebkitBorderLeft",
	  "MSBorderLeft",
	  "OBorderLeft",
	  "borderLeftColor",
	  "MozBorderLeftColor",
	  "WebkitBorderLeftColor",
	  "MSBorderLeftColor",
	  "OBorderLeftColor",
	  "borderLeftStyle",
	  "MozBorderLeftStyle",
	  "WebkitBorderLeftStyle",
	  "MSBorderLeftStyle",
	  "OBorderLeftStyle",
	  "borderLeftWidth",
	  "MozBorderLeftWidth",
	  "WebkitBorderLeftWidth",
	  "MSBorderLeftWidth",
	  "OBorderLeftWidth",
	  "borderRadius",
	  "MozBorderRadius",
	  "WebkitBorderRadius",
	  "MSBorderRadius",
	  "OBorderRadius",
	  "borderRight",
	  "MozBorderRight",
	  "WebkitBorderRight",
	  "MSBorderRight",
	  "OBorderRight",
	  "borderRightColor",
	  "MozBorderRightColor",
	  "WebkitBorderRightColor",
	  "MSBorderRightColor",
	  "OBorderRightColor",
	  "borderRightStyle",
	  "MozBorderRightStyle",
	  "WebkitBorderRightStyle",
	  "MSBorderRightStyle",
	  "OBorderRightStyle",
	  "borderRightWidth",
	  "MozBorderRightWidth",
	  "WebkitBorderRightWidth",
	  "MSBorderRightWidth",
	  "OBorderRightWidth",
	  "borderSpacing",
	  "MozBorderSpacing",
	  "WebkitBorderSpacing",
	  "MSBorderSpacing",
	  "OBorderSpacing",
	  "borderStyle",
	  "MozBorderStyle",
	  "WebkitBorderStyle",
	  "MSBorderStyle",
	  "OBorderStyle",
	  "borderTop",
	  "MozBorderTop",
	  "WebkitBorderTop",
	  "MSBorderTop",
	  "OBorderTop",
	  "borderTopColor",
	  "MozBorderTopColor",
	  "WebkitBorderTopColor",
	  "MSBorderTopColor",
	  "OBorderTopColor",
	  "borderTopLeftRadius",
	  "MozBorderTopLeftRadius",
	  "WebkitBorderTopLeftRadius",
	  "MSBorderTopLeftRadius",
	  "OBorderTopLeftRadius",
	  "borderTopRightRadius",
	  "MozBorderTopRightRadius",
	  "WebkitBorderTopRightRadius",
	  "MSBorderTopRightRadius",
	  "OBorderTopRightRadius",
	  "borderTopStyle",
	  "MozBorderTopStyle",
	  "WebkitBorderTopStyle",
	  "MSBorderTopStyle",
	  "OBorderTopStyle",
	  "borderTopWidth",
	  "MozBorderTopWidth",
	  "WebkitBorderTopWidth",
	  "MSBorderTopWidth",
	  "OBorderTopWidth",
	  "borderWidth",
	  "MozBorderWidth",
	  "WebkitBorderWidth",
	  "MSBorderWidth",
	  "OBorderWidth",
	  "bottom",
	  "MozBottom",
	  "WebkitBottom",
	  "MSBottom",
	  "OBottom",
	  "boxDecorationBreak",
	  "MozBoxDecorationBreak",
	  "WebkitBoxDecorationBreak",
	  "MSBoxDecorationBreak",
	  "OBoxDecorationBreak",
	  "boxShadow",
	  "MozBoxShadow",
	  "WebkitBoxShadow",
	  "MSBoxShadow",
	  "OBoxShadow",
	  "boxSizing",
	  "MozBoxSizing",
	  "WebkitBoxSizing",
	  "MSBoxSizing",
	  "OBoxSizing",
	  "breakAfter",
	  "MozBreakAfter",
	  "WebkitBreakAfter",
	  "MSBreakAfter",
	  "OBreakAfter",
	  "breakBefore",
	  "MozBreakBefore",
	  "WebkitBreakBefore",
	  "MSBreakBefore",
	  "OBreakBefore",
	  "breakInside",
	  "MozBreakInside",
	  "WebkitBreakInside",
	  "MSBreakInside",
	  "OBreakInside",
	  "captionSide",
	  "MozCaptionSide",
	  "WebkitCaptionSide",
	  "MSCaptionSide",
	  "OCaptionSide",
	  "caretColor",
	  "MozCaretColor",
	  "WebkitCaretColor",
	  "MSCaretColor",
	  "OCaretColor",
	  "ch",
	  "MozCh",
	  "WebkitCh",
	  "MSCh",
	  "OCh",
	  "clear",
	  "MozClear",
	  "WebkitClear",
	  "MSClear",
	  "OClear",
	  "clip",
	  "MozClip",
	  "WebkitClip",
	  "MSClip",
	  "OClip",
	  "clipPath",
	  "MozClipPath",
	  "WebkitClipPath",
	  "MSClipPath",
	  "OClipPath",
	  "cm",
	  "MozCm",
	  "WebkitCm",
	  "MSCm",
	  "OCm",
	  "color",
	  "MozColor",
	  "WebkitColor",
	  "MSColor",
	  "OColor",
	  "columnCount",
	  "MozColumnCount",
	  "WebkitColumnCount",
	  "MSColumnCount",
	  "OColumnCount",
	  "columnFill",
	  "MozColumnFill",
	  "WebkitColumnFill",
	  "MSColumnFill",
	  "OColumnFill",
	  "columnGap",
	  "MozColumnGap",
	  "WebkitColumnGap",
	  "MSColumnGap",
	  "OColumnGap",
	  "columnRule",
	  "MozColumnRule",
	  "WebkitColumnRule",
	  "MSColumnRule",
	  "OColumnRule",
	  "columnRuleColor",
	  "MozColumnRuleColor",
	  "WebkitColumnRuleColor",
	  "MSColumnRuleColor",
	  "OColumnRuleColor",
	  "columnRuleStyle",
	  "MozColumnRuleStyle",
	  "WebkitColumnRuleStyle",
	  "MSColumnRuleStyle",
	  "OColumnRuleStyle",
	  "columnRuleWidth",
	  "MozColumnRuleWidth",
	  "WebkitColumnRuleWidth",
	  "MSColumnRuleWidth",
	  "OColumnRuleWidth",
	  "columnSpan",
	  "MozColumnSpan",
	  "WebkitColumnSpan",
	  "MSColumnSpan",
	  "OColumnSpan",
	  "columnWidth",
	  "MozColumnWidth",
	  "WebkitColumnWidth",
	  "MSColumnWidth",
	  "OColumnWidth",
	  "columns",
	  "MozColumns",
	  "WebkitColumns",
	  "MSColumns",
	  "OColumns",
	  "content",
	  "MozContent",
	  "WebkitContent",
	  "MSContent",
	  "OContent",
	  "counterIncrement",
	  "MozCounterIncrement",
	  "WebkitCounterIncrement",
	  "MSCounterIncrement",
	  "OCounterIncrement",
	  "counterReset",
	  "MozCounterReset",
	  "WebkitCounterReset",
	  "MSCounterReset",
	  "OCounterReset",
	  "cursor",
	  "MozCursor",
	  "WebkitCursor",
	  "MSCursor",
	  "OCursor",
	  "deg",
	  "MozDeg",
	  "WebkitDeg",
	  "MSDeg",
	  "ODeg",
	  "direction",
	  "MozDirection",
	  "WebkitDirection",
	  "MSDirection",
	  "ODirection",
	  "display",
	  "MozDisplay",
	  "WebkitDisplay",
	  "MSDisplay",
	  "ODisplay",
	  "dpcm",
	  "MozDpcm",
	  "WebkitDpcm",
	  "MSDpcm",
	  "ODpcm",
	  "dpi",
	  "MozDpi",
	  "WebkitDpi",
	  "MSDpi",
	  "ODpi",
	  "dppx",
	  "MozDppx",
	  "WebkitDppx",
	  "MSDppx",
	  "ODppx",
	  "em",
	  "MozEm",
	  "WebkitEm",
	  "MSEm",
	  "OEm",
	  "emptyCells",
	  "MozEmptyCells",
	  "WebkitEmptyCells",
	  "MSEmptyCells",
	  "OEmptyCells",
	  "ex",
	  "MozEx",
	  "WebkitEx",
	  "MSEx",
	  "OEx",
	  "filter",
	  "MozFilter",
	  "WebkitFilter",
	  "MSFilter",
	  "OFilter",
	  "flexBasis",
	  "MozFlexBasis",
	  "WebkitFlexBasis",
	  "MSFlexBasis",
	  "OFlexBasis",
	  "flexDirection",
	  "MozFlexDirection",
	  "WebkitFlexDirection",
	  "MSFlexDirection",
	  "OFlexDirection",
	  "flexFlow",
	  "MozFlexFlow",
	  "WebkitFlexFlow",
	  "MSFlexFlow",
	  "OFlexFlow",
	  "flexGrow",
	  "MozFlexGrow",
	  "WebkitFlexGrow",
	  "MSFlexGrow",
	  "OFlexGrow",
	  "flexShrink",
	  "MozFlexShrink",
	  "WebkitFlexShrink",
	  "MSFlexShrink",
	  "OFlexShrink",
	  "flexWrap",
	  "MozFlexWrap",
	  "WebkitFlexWrap",
	  "MSFlexWrap",
	  "OFlexWrap",
	  "float",
	  "MozFloat",
	  "WebkitFloat",
	  "MSFloat",
	  "OFloat",
	  "font",
	  "MozFont",
	  "WebkitFont",
	  "MSFont",
	  "OFont",
	  "fontFamily",
	  "MozFontFamily",
	  "WebkitFontFamily",
	  "MSFontFamily",
	  "OFontFamily",
	  "fontFeatureSettings",
	  "MozFontFeatureSettings",
	  "WebkitFontFeatureSettings",
	  "MSFontFeatureSettings",
	  "OFontFeatureSettings",
	  "fontKerning",
	  "MozFontKerning",
	  "WebkitFontKerning",
	  "MSFontKerning",
	  "OFontKerning",
	  "fontLanguageOverride",
	  "MozFontLanguageOverride",
	  "WebkitFontLanguageOverride",
	  "MSFontLanguageOverride",
	  "OFontLanguageOverride",
	  "fontSize",
	  "MozFontSize",
	  "WebkitFontSize",
	  "MSFontSize",
	  "OFontSize",
	  "fontSizeAdjust",
	  "MozFontSizeAdjust",
	  "WebkitFontSizeAdjust",
	  "MSFontSizeAdjust",
	  "OFontSizeAdjust",
	  "fontStretch",
	  "MozFontStretch",
	  "WebkitFontStretch",
	  "MSFontStretch",
	  "OFontStretch",
	  "fontStyle",
	  "MozFontStyle",
	  "WebkitFontStyle",
	  "MSFontStyle",
	  "OFontStyle",
	  "fontSynthesis",
	  "MozFontSynthesis",
	  "WebkitFontSynthesis",
	  "MSFontSynthesis",
	  "OFontSynthesis",
	  "fontVariant",
	  "MozFontVariant",
	  "WebkitFontVariant",
	  "MSFontVariant",
	  "OFontVariant",
	  "fontVariantAlternates",
	  "MozFontVariantAlternates",
	  "WebkitFontVariantAlternates",
	  "MSFontVariantAlternates",
	  "OFontVariantAlternates",
	  "fontVariantCaps",
	  "MozFontVariantCaps",
	  "WebkitFontVariantCaps",
	  "MSFontVariantCaps",
	  "OFontVariantCaps",
	  "fontVariantEastAsian",
	  "MozFontVariantEastAsian",
	  "WebkitFontVariantEastAsian",
	  "MSFontVariantEastAsian",
	  "OFontVariantEastAsian",
	  "fontVariantLigatures",
	  "MozFontVariantLigatures",
	  "WebkitFontVariantLigatures",
	  "MSFontVariantLigatures",
	  "OFontVariantLigatures",
	  "fontVariantNumeric",
	  "MozFontVariantNumeric",
	  "WebkitFontVariantNumeric",
	  "MSFontVariantNumeric",
	  "OFontVariantNumeric",
	  "fontVariantPosition",
	  "MozFontVariantPosition",
	  "WebkitFontVariantPosition",
	  "MSFontVariantPosition",
	  "OFontVariantPosition",
	  "fontWeight",
	  "MozFontWeight",
	  "WebkitFontWeight",
	  "MSFontWeight",
	  "OFontWeight",
	  "fr",
	  "MozFr",
	  "WebkitFr",
	  "MSFr",
	  "OFr",
	  "grad",
	  "MozGrad",
	  "WebkitGrad",
	  "MSGrad",
	  "OGrad",
	  "grid",
	  "MozGrid",
	  "WebkitGrid",
	  "MSGrid",
	  "OGrid",
	  "gridArea",
	  "MozGridArea",
	  "WebkitGridArea",
	  "MSGridArea",
	  "OGridArea",
	  "gridAutoColumns",
	  "MozGridAutoColumns",
	  "WebkitGridAutoColumns",
	  "MSGridAutoColumns",
	  "OGridAutoColumns",
	  "gridAutoFlow",
	  "MozGridAutoFlow",
	  "WebkitGridAutoFlow",
	  "MSGridAutoFlow",
	  "OGridAutoFlow",
	  "gridAutoRows",
	  "MozGridAutoRows",
	  "WebkitGridAutoRows",
	  "MSGridAutoRows",
	  "OGridAutoRows",
	  "gridColumn",
	  "MozGridColumn",
	  "WebkitGridColumn",
	  "MSGridColumn",
	  "OGridColumn",
	  "gridColumnEnd",
	  "MozGridColumnEnd",
	  "WebkitGridColumnEnd",
	  "MSGridColumnEnd",
	  "OGridColumnEnd",
	  "gridColumnGap",
	  "MozGridColumnGap",
	  "WebkitGridColumnGap",
	  "MSGridColumnGap",
	  "OGridColumnGap",
	  "gridColumnStart",
	  "MozGridColumnStart",
	  "WebkitGridColumnStart",
	  "MSGridColumnStart",
	  "OGridColumnStart",
	  "gridGap",
	  "MozGridGap",
	  "WebkitGridGap",
	  "MSGridGap",
	  "OGridGap",
	  "gridRow",
	  "MozGridRow",
	  "WebkitGridRow",
	  "MSGridRow",
	  "OGridRow",
	  "gridRowEnd",
	  "MozGridRowEnd",
	  "WebkitGridRowEnd",
	  "MSGridRowEnd",
	  "OGridRowEnd",
	  "gridRowGap",
	  "MozGridRowGap",
	  "WebkitGridRowGap",
	  "MSGridRowGap",
	  "OGridRowGap",
	  "gridRowStart",
	  "MozGridRowStart",
	  "WebkitGridRowStart",
	  "MSGridRowStart",
	  "OGridRowStart",
	  "gridTemplate",
	  "MozGridTemplate",
	  "WebkitGridTemplate",
	  "MSGridTemplate",
	  "OGridTemplate",
	  "gridTemplateAreas",
	  "MozGridTemplateAreas",
	  "WebkitGridTemplateAreas",
	  "MSGridTemplateAreas",
	  "OGridTemplateAreas",
	  "gridTemplateColumns",
	  "MozGridTemplateColumns",
	  "WebkitGridTemplateColumns",
	  "MSGridTemplateColumns",
	  "OGridTemplateColumns",
	  "gridTemplateRows",
	  "MozGridTemplateRows",
	  "WebkitGridTemplateRows",
	  "MSGridTemplateRows",
	  "OGridTemplateRows",
	  "height",
	  "MozHeight",
	  "WebkitHeight",
	  "MSHeight",
	  "OHeight",
	  "hyphens",
	  "MozHyphens",
	  "WebkitHyphens",
	  "MSHyphens",
	  "OHyphens",
	  "hz",
	  "MozHz",
	  "WebkitHz",
	  "MSHz",
	  "OHz",
	  "imageOrientation",
	  "MozImageOrientation",
	  "WebkitImageOrientation",
	  "MSImageOrientation",
	  "OImageOrientation",
	  "imageRendering",
	  "MozImageRendering",
	  "WebkitImageRendering",
	  "MSImageRendering",
	  "OImageRendering",
	  "imageResolution",
	  "MozImageResolution",
	  "WebkitImageResolution",
	  "MSImageResolution",
	  "OImageResolution",
	  "imeMode",
	  "MozImeMode",
	  "WebkitImeMode",
	  "MSImeMode",
	  "OImeMode",
	  "in",
	  "MozIn",
	  "WebkitIn",
	  "MSIn",
	  "OIn",
	  "inherit",
	  "MozInherit",
	  "WebkitInherit",
	  "MSInherit",
	  "OInherit",
	  "initial",
	  "MozInitial",
	  "WebkitInitial",
	  "MSInitial",
	  "OInitial",
	  "inlineSize",
	  "MozInlineSize",
	  "WebkitInlineSize",
	  "MSInlineSize",
	  "OInlineSize",
	  "isolation",
	  "MozIsolation",
	  "WebkitIsolation",
	  "MSIsolation",
	  "OIsolation",
	  "justifyContent",
	  "MozJustifyContent",
	  "WebkitJustifyContent",
	  "MSJustifyContent",
	  "OJustifyContent",
	  "khz",
	  "MozKhz",
	  "WebkitKhz",
	  "MSKhz",
	  "OKhz",
	  "left",
	  "MozLeft",
	  "WebkitLeft",
	  "MSLeft",
	  "OLeft",
	  "letterSpacing",
	  "MozLetterSpacing",
	  "WebkitLetterSpacing",
	  "MSLetterSpacing",
	  "OLetterSpacing",
	  "lineBreak",
	  "MozLineBreak",
	  "WebkitLineBreak",
	  "MSLineBreak",
	  "OLineBreak",
	  "lineHeight",
	  "MozLineHeight",
	  "WebkitLineHeight",
	  "MSLineHeight",
	  "OLineHeight",
	  "listStyle",
	  "MozListStyle",
	  "WebkitListStyle",
	  "MSListStyle",
	  "OListStyle",
	  "listStyleImage",
	  "MozListStyleImage",
	  "WebkitListStyleImage",
	  "MSListStyleImage",
	  "OListStyleImage",
	  "listStylePosition",
	  "MozListStylePosition",
	  "WebkitListStylePosition",
	  "MSListStylePosition",
	  "OListStylePosition",
	  "listStyleType",
	  "MozListStyleType",
	  "WebkitListStyleType",
	  "MSListStyleType",
	  "OListStyleType",
	  "margin",
	  "MozMargin",
	  "WebkitMargin",
	  "MSMargin",
	  "OMargin",
	  "marginBlockEnd",
	  "MozMarginBlockEnd",
	  "WebkitMarginBlockEnd",
	  "MSMarginBlockEnd",
	  "OMarginBlockEnd",
	  "marginBlockStart",
	  "MozMarginBlockStart",
	  "WebkitMarginBlockStart",
	  "MSMarginBlockStart",
	  "OMarginBlockStart",
	  "marginBottom",
	  "MozMarginBottom",
	  "WebkitMarginBottom",
	  "MSMarginBottom",
	  "OMarginBottom",
	  "marginInlineEnd",
	  "MozMarginInlineEnd",
	  "WebkitMarginInlineEnd",
	  "MSMarginInlineEnd",
	  "OMarginInlineEnd",
	  "marginInlineStart",
	  "MozMarginInlineStart",
	  "WebkitMarginInlineStart",
	  "MSMarginInlineStart",
	  "OMarginInlineStart",
	  "marginLeft",
	  "MozMarginLeft",
	  "WebkitMarginLeft",
	  "MSMarginLeft",
	  "OMarginLeft",
	  "marginRight",
	  "MozMarginRight",
	  "WebkitMarginRight",
	  "MSMarginRight",
	  "OMarginRight",
	  "marginTop",
	  "MozMarginTop",
	  "WebkitMarginTop",
	  "MSMarginTop",
	  "OMarginTop",
	  "mask",
	  "MozMask",
	  "WebkitMask",
	  "MSMask",
	  "OMask",
	  "maskClip",
	  "MozMaskClip",
	  "WebkitMaskClip",
	  "MSMaskClip",
	  "OMaskClip",
	  "maskComposite",
	  "MozMaskComposite",
	  "WebkitMaskComposite",
	  "MSMaskComposite",
	  "OMaskComposite",
	  "maskImage",
	  "MozMaskImage",
	  "WebkitMaskImage",
	  "MSMaskImage",
	  "OMaskImage",
	  "maskMode",
	  "MozMaskMode",
	  "WebkitMaskMode",
	  "MSMaskMode",
	  "OMaskMode",
	  "maskOrigin",
	  "MozMaskOrigin",
	  "WebkitMaskOrigin",
	  "MSMaskOrigin",
	  "OMaskOrigin",
	  "maskPosition",
	  "MozMaskPosition",
	  "WebkitMaskPosition",
	  "MSMaskPosition",
	  "OMaskPosition",
	  "maskRepeat",
	  "MozMaskRepeat",
	  "WebkitMaskRepeat",
	  "MSMaskRepeat",
	  "OMaskRepeat",
	  "maskSize",
	  "MozMaskSize",
	  "WebkitMaskSize",
	  "MSMaskSize",
	  "OMaskSize",
	  "maskType",
	  "MozMaskType",
	  "WebkitMaskType",
	  "MSMaskType",
	  "OMaskType",
	  "maxHeight",
	  "MozMaxHeight",
	  "WebkitMaxHeight",
	  "MSMaxHeight",
	  "OMaxHeight",
	  "maxWidth",
	  "MozMaxWidth",
	  "WebkitMaxWidth",
	  "MSMaxWidth",
	  "OMaxWidth",
	  "minBlockSize",
	  "MozMinBlockSize",
	  "WebkitMinBlockSize",
	  "MSMinBlockSize",
	  "OMinBlockSize",
	  "minHeight",
	  "MozMinHeight",
	  "WebkitMinHeight",
	  "MSMinHeight",
	  "OMinHeight",
	  "minInlineSize",
	  "MozMinInlineSize",
	  "WebkitMinInlineSize",
	  "MSMinInlineSize",
	  "OMinInlineSize",
	  "minWidth",
	  "MozMinWidth",
	  "WebkitMinWidth",
	  "MSMinWidth",
	  "OMinWidth",
	  "mixBlendMode",
	  "MozMixBlendMode",
	  "WebkitMixBlendMode",
	  "MSMixBlendMode",
	  "OMixBlendMode",
	  "mm",
	  "MozMm",
	  "WebkitMm",
	  "MSMm",
	  "OMm",
	  "ms",
	  "MozMs",
	  "WebkitMs",
	  "MSMs",
	  "OMs",
	  "objectFit",
	  "MozObjectFit",
	  "WebkitObjectFit",
	  "MSObjectFit",
	  "OObjectFit",
	  "objectPosition",
	  "MozObjectPosition",
	  "WebkitObjectPosition",
	  "MSObjectPosition",
	  "OObjectPosition",
	  "offsetBlockEnd",
	  "MozOffsetBlockEnd",
	  "WebkitOffsetBlockEnd",
	  "MSOffsetBlockEnd",
	  "OOffsetBlockEnd",
	  "offsetBlockStart",
	  "MozOffsetBlockStart",
	  "WebkitOffsetBlockStart",
	  "MSOffsetBlockStart",
	  "OOffsetBlockStart",
	  "offsetInlineEnd",
	  "MozOffsetInlineEnd",
	  "WebkitOffsetInlineEnd",
	  "MSOffsetInlineEnd",
	  "OOffsetInlineEnd",
	  "offsetInlineStart",
	  "MozOffsetInlineStart",
	  "WebkitOffsetInlineStart",
	  "MSOffsetInlineStart",
	  "OOffsetInlineStart",
	  "opacity",
	  "MozOpacity",
	  "WebkitOpacity",
	  "MSOpacity",
	  "OOpacity",
	  "order",
	  "MozOrder",
	  "WebkitOrder",
	  "MSOrder",
	  "OOrder",
	  "orphans",
	  "MozOrphans",
	  "WebkitOrphans",
	  "MSOrphans",
	  "OOrphans",
	  "outline",
	  "MozOutline",
	  "WebkitOutline",
	  "MSOutline",
	  "OOutline",
	  "outlineColor",
	  "MozOutlineColor",
	  "WebkitOutlineColor",
	  "MSOutlineColor",
	  "OOutlineColor",
	  "outlineOffset",
	  "MozOutlineOffset",
	  "WebkitOutlineOffset",
	  "MSOutlineOffset",
	  "OOutlineOffset",
	  "outlineStyle",
	  "MozOutlineStyle",
	  "WebkitOutlineStyle",
	  "MSOutlineStyle",
	  "OOutlineStyle",
	  "outlineWidth",
	  "MozOutlineWidth",
	  "WebkitOutlineWidth",
	  "MSOutlineWidth",
	  "OOutlineWidth",
	  "overflow",
	  "MozOverflow",
	  "WebkitOverflow",
	  "MSOverflow",
	  "OOverflow",
	  "overflowWrap",
	  "MozOverflowWrap",
	  "WebkitOverflowWrap",
	  "MSOverflowWrap",
	  "OOverflowWrap",
	  "overflowX",
	  "MozOverflowX",
	  "WebkitOverflowX",
	  "MSOverflowX",
	  "OOverflowX",
	  "overflowY",
	  "MozOverflowY",
	  "WebkitOverflowY",
	  "MSOverflowY",
	  "OOverflowY",
	  "padding",
	  "MozPadding",
	  "WebkitPadding",
	  "MSPadding",
	  "OPadding",
	  "paddingBlockEnd",
	  "MozPaddingBlockEnd",
	  "WebkitPaddingBlockEnd",
	  "MSPaddingBlockEnd",
	  "OPaddingBlockEnd",
	  "paddingBlockStart",
	  "MozPaddingBlockStart",
	  "WebkitPaddingBlockStart",
	  "MSPaddingBlockStart",
	  "OPaddingBlockStart",
	  "paddingBottom",
	  "MozPaddingBottom",
	  "WebkitPaddingBottom",
	  "MSPaddingBottom",
	  "OPaddingBottom",
	  "paddingInlineEnd",
	  "MozPaddingInlineEnd",
	  "WebkitPaddingInlineEnd",
	  "MSPaddingInlineEnd",
	  "OPaddingInlineEnd",
	  "paddingInlineStart",
	  "MozPaddingInlineStart",
	  "WebkitPaddingInlineStart",
	  "MSPaddingInlineStart",
	  "OPaddingInlineStart",
	  "paddingLeft",
	  "MozPaddingLeft",
	  "WebkitPaddingLeft",
	  "MSPaddingLeft",
	  "OPaddingLeft",
	  "paddingRight",
	  "MozPaddingRight",
	  "WebkitPaddingRight",
	  "MSPaddingRight",
	  "OPaddingRight",
	  "paddingTop",
	  "MozPaddingTop",
	  "WebkitPaddingTop",
	  "MSPaddingTop",
	  "OPaddingTop",
	  "pageBreakAfter",
	  "MozPageBreakAfter",
	  "WebkitPageBreakAfter",
	  "MSPageBreakAfter",
	  "OPageBreakAfter",
	  "pageBreakBefore",
	  "MozPageBreakBefore",
	  "WebkitPageBreakBefore",
	  "MSPageBreakBefore",
	  "OPageBreakBefore",
	  "pageBreakInside",
	  "MozPageBreakInside",
	  "WebkitPageBreakInside",
	  "MSPageBreakInside",
	  "OPageBreakInside",
	  "pc",
	  "MozPc",
	  "WebkitPc",
	  "MSPc",
	  "OPc",
	  "perspective",
	  "MozPerspective",
	  "WebkitPerspective",
	  "MSPerspective",
	  "OPerspective",
	  "perspectiveOrigin",
	  "MozPerspectiveOrigin",
	  "WebkitPerspectiveOrigin",
	  "MSPerspectiveOrigin",
	  "OPerspectiveOrigin",
	  "pointerEvents",
	  "MozPointerEvents",
	  "WebkitPointerEvents",
	  "MSPointerEvents",
	  "OPointerEvents",
	  "position",
	  "MozPosition",
	  "WebkitPosition",
	  "MSPosition",
	  "OPosition",
	  "pt",
	  "MozPt",
	  "WebkitPt",
	  "MSPt",
	  "OPt",
	  "px",
	  "MozPx",
	  "WebkitPx",
	  "MSPx",
	  "OPx",
	  "q",
	  "MozQ",
	  "WebkitQ",
	  "MSQ",
	  "OQ",
	  "quotes",
	  "MozQuotes",
	  "WebkitQuotes",
	  "MSQuotes",
	  "OQuotes",
	  "rad",
	  "MozRad",
	  "WebkitRad",
	  "MSRad",
	  "ORad",
	  "rem",
	  "MozRem",
	  "WebkitRem",
	  "MSRem",
	  "ORem",
	  "resize",
	  "MozResize",
	  "WebkitResize",
	  "MSResize",
	  "OResize",
	  "revert",
	  "MozRevert",
	  "WebkitRevert",
	  "MSRevert",
	  "ORevert",
	  "right",
	  "MozRight",
	  "WebkitRight",
	  "MSRight",
	  "ORight",
	  "rubyAlign",
	  "MozRubyAlign",
	  "WebkitRubyAlign",
	  "MSRubyAlign",
	  "ORubyAlign",
	  "rubyMerge",
	  "MozRubyMerge",
	  "WebkitRubyMerge",
	  "MSRubyMerge",
	  "ORubyMerge",
	  "rubyPosition",
	  "MozRubyPosition",
	  "WebkitRubyPosition",
	  "MSRubyPosition",
	  "ORubyPosition",
	  "s",
	  "MozS",
	  "WebkitS",
	  "MSS",
	  "OS",
	  "scrollBehavior",
	  "MozScrollBehavior",
	  "WebkitScrollBehavior",
	  "MSScrollBehavior",
	  "OScrollBehavior",
	  "scrollSnapCoordinate",
	  "MozScrollSnapCoordinate",
	  "WebkitScrollSnapCoordinate",
	  "MSScrollSnapCoordinate",
	  "OScrollSnapCoordinate",
	  "scrollSnapDestination",
	  "MozScrollSnapDestination",
	  "WebkitScrollSnapDestination",
	  "MSScrollSnapDestination",
	  "OScrollSnapDestination",
	  "scrollSnapType",
	  "MozScrollSnapType",
	  "WebkitScrollSnapType",
	  "MSScrollSnapType",
	  "OScrollSnapType",
	  "shapeImageThreshold",
	  "MozShapeImageThreshold",
	  "WebkitShapeImageThreshold",
	  "MSShapeImageThreshold",
	  "OShapeImageThreshold",
	  "shapeMargin",
	  "MozShapeMargin",
	  "WebkitShapeMargin",
	  "MSShapeMargin",
	  "OShapeMargin",
	  "shapeOutside",
	  "MozShapeOutside",
	  "WebkitShapeOutside",
	  "MSShapeOutside",
	  "OShapeOutside",
	  "tabSize",
	  "MozTabSize",
	  "WebkitTabSize",
	  "MSTabSize",
	  "OTabSize",
	  "tableLayout",
	  "MozTableLayout",
	  "WebkitTableLayout",
	  "MSTableLayout",
	  "OTableLayout",
	  "textAlign",
	  "MozTextAlign",
	  "WebkitTextAlign",
	  "MSTextAlign",
	  "OTextAlign",
	  "textAlignLast",
	  "MozTextAlignLast",
	  "WebkitTextAlignLast",
	  "MSTextAlignLast",
	  "OTextAlignLast",
	  "textCombineUpright",
	  "MozTextCombineUpright",
	  "WebkitTextCombineUpright",
	  "MSTextCombineUpright",
	  "OTextCombineUpright",
	  "textDecoration",
	  "MozTextDecoration",
	  "WebkitTextDecoration",
	  "MSTextDecoration",
	  "OTextDecoration",
	  "textDecorationColor",
	  "MozTextDecorationColor",
	  "WebkitTextDecorationColor",
	  "MSTextDecorationColor",
	  "OTextDecorationColor",
	  "textDecorationLine",
	  "MozTextDecorationLine",
	  "WebkitTextDecorationLine",
	  "MSTextDecorationLine",
	  "OTextDecorationLine",
	  "textDecorationStyle",
	  "MozTextDecorationStyle",
	  "WebkitTextDecorationStyle",
	  "MSTextDecorationStyle",
	  "OTextDecorationStyle",
	  "textEmphasis",
	  "MozTextEmphasis",
	  "WebkitTextEmphasis",
	  "MSTextEmphasis",
	  "OTextEmphasis",
	  "textEmphasisColor",
	  "MozTextEmphasisColor",
	  "WebkitTextEmphasisColor",
	  "MSTextEmphasisColor",
	  "OTextEmphasisColor",
	  "textEmphasisPosition",
	  "MozTextEmphasisPosition",
	  "WebkitTextEmphasisPosition",
	  "MSTextEmphasisPosition",
	  "OTextEmphasisPosition",
	  "textEmphasisStyle",
	  "MozTextEmphasisStyle",
	  "WebkitTextEmphasisStyle",
	  "MSTextEmphasisStyle",
	  "OTextEmphasisStyle",
	  "textIndent",
	  "MozTextIndent",
	  "WebkitTextIndent",
	  "MSTextIndent",
	  "OTextIndent",
	  "textOrientation",
	  "MozTextOrientation",
	  "WebkitTextOrientation",
	  "MSTextOrientation",
	  "OTextOrientation",
	  "textOverflow",
	  "MozTextOverflow",
	  "WebkitTextOverflow",
	  "MSTextOverflow",
	  "OTextOverflow",
	  "textRendering",
	  "MozTextRendering",
	  "WebkitTextRendering",
	  "MSTextRendering",
	  "OTextRendering",
	  "textShadow",
	  "MozTextShadow",
	  "WebkitTextShadow",
	  "MSTextShadow",
	  "OTextShadow",
	  "textTransform",
	  "MozTextTransform",
	  "WebkitTextTransform",
	  "MSTextTransform",
	  "OTextTransform",
	  "textUnderlinePosition",
	  "MozTextUnderlinePosition",
	  "WebkitTextUnderlinePosition",
	  "MSTextUnderlinePosition",
	  "OTextUnderlinePosition",
	  "top",
	  "MozTop",
	  "WebkitTop",
	  "MSTop",
	  "OTop",
	  "touchAction",
	  "MozTouchAction",
	  "WebkitTouchAction",
	  "MSTouchAction",
	  "OTouchAction",
	  "transform",
	  "MozTransform",
	  "WebkitTransform",
	  "msTransform",
	  "OTransform",
	  "transformBox",
	  "MozTransformBox",
	  "WebkitTransformBox",
	  "MSTransformBox",
	  "OTransformBox",
	  "transformOrigin",
	  "MozTransformOrigin",
	  "WebkitTransformOrigin",
	  "MSTransformOrigin",
	  "OTransformOrigin",
	  "transformStyle",
	  "MozTransformStyle",
	  "WebkitTransformStyle",
	  "MSTransformStyle",
	  "OTransformStyle",
	  "transition",
	  "MozTransition",
	  "WebkitTransition",
	  "MSTransition",
	  "OTransition",
	  "transitionDelay",
	  "MozTransitionDelay",
	  "WebkitTransitionDelay",
	  "MSTransitionDelay",
	  "OTransitionDelay",
	  "transitionDuration",
	  "MozTransitionDuration",
	  "WebkitTransitionDuration",
	  "MSTransitionDuration",
	  "OTransitionDuration",
	  "transitionProperty",
	  "MozTransitionProperty",
	  "WebkitTransitionProperty",
	  "MSTransitionProperty",
	  "OTransitionProperty",
	  "transitionTimingFunction",
	  "MozTransitionTimingFunction",
	  "WebkitTransitionTimingFunction",
	  "MSTransitionTimingFunction",
	  "OTransitionTimingFunction",
	  "turn",
	  "MozTurn",
	  "WebkitTurn",
	  "MSTurn",
	  "OTurn",
	  "unicodeBidi",
	  "MozUnicodeBidi",
	  "WebkitUnicodeBidi",
	  "MSUnicodeBidi",
	  "OUnicodeBidi",
	  "unset",
	  "MozUnset",
	  "WebkitUnset",
	  "MSUnset",
	  "OUnset",
	  "verticalAlign",
	  "MozVerticalAlign",
	  "WebkitVerticalAlign",
	  "MSVerticalAlign",
	  "OVerticalAlign",
	  "vh",
	  "MozVh",
	  "WebkitVh",
	  "MSVh",
	  "OVh",
	  "visibility",
	  "MozVisibility",
	  "WebkitVisibility",
	  "MSVisibility",
	  "OVisibility",
	  "vmax",
	  "MozVmax",
	  "WebkitVmax",
	  "MSVmax",
	  "OVmax",
	  "vmin",
	  "MozVmin",
	  "WebkitVmin",
	  "MSVmin",
	  "OVmin",
	  "vw",
	  "MozVw",
	  "WebkitVw",
	  "MSVw",
	  "OVw",
	  "whiteSpace",
	  "MozWhiteSpace",
	  "WebkitWhiteSpace",
	  "MSWhiteSpace",
	  "OWhiteSpace",
	  "widows",
	  "MozWidows",
	  "WebkitWidows",
	  "MSWidows",
	  "OWidows",
	  "width",
	  "MozWidth",
	  "WebkitWidth",
	  "MSWidth",
	  "OWidth",
	  "willChange",
	  "MozWillChange",
	  "WebkitWillChange",
	  "MSWillChange",
	  "OWillChange",
	  "wordBreak",
	  "MozWordBreak",
	  "WebkitWordBreak",
	  "MSWordBreak",
	  "OWordBreak",
	  "wordSpacing",
	  "MozWordSpacing",
	  "WebkitWordSpacing",
	  "MSWordSpacing",
	  "OWordSpacing",
	  "wordWrap",
	  "MozWordWrap",
	  "WebkitWordWrap",
	  "MSWordWrap",
	  "OWordWrap",
	  "writingMode",
	  "MozWritingMode",
	  "WebkitWritingMode",
	  "MSWritingMode",
	  "OWritingMode",
	  "zIndex",
	  "MozZIndex",
	  "WebkitZIndex",
	  "MSZIndex",
	  "OZIndex",
	  "fontSize",
	  "MozFontSize",
	  "WebkitFontSize",
	  "MSFontSize",
	  "OFontSize",
	  "flex",
	  "MozFlex",
	  "WebkitFlex",
	  "MSFlex",
	  "OFlex",
	  "fr",
	  "MozFr",
	  "WebkitFr",
	  "MSFr",
	  "OFr",
	  "overflowScrolling",
	  "MozOverflowScrolling",
	  "WebkitOverflowScrolling",
	  "MSOverflowScrolling",
	  "OOverflowScrolling",
	  "userSelect",
	  "MozUserSelect",
	  "WebkitUserSelect",
	  "MSUserSelect",
	  "OUserSelect"
	]


/***/ },
/* 2373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Autocomplete = exports.autocompleteFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames4 = __webpack_require__(3);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _utils = __webpack_require__(60);
	
	var _identifiers = __webpack_require__(9);
	
	var _Chip = __webpack_require__(790);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Input = __webpack_require__(149);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var POSITION = {
	  AUTO: 'auto',
	  DOWN: 'down',
	  UP: 'up'
	};
	
	var factory = function factory(Chip, Input) {
	  var Autocomplete = function (_Component) {
	    _inherits(Autocomplete, _Component);
	
	    function Autocomplete() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Autocomplete);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        direction: _this.props.direction,
	        focus: false,
	        showAllSuggestions: _this.props.showSuggestionsWhenValueIsSet,
	        query: _this.props.query ? _this.props.query : _this.query(_this.props.value),
	        isValueAnObject: false
	      }, _this.handleChange = function (values, event) {
	        var value = _this.props.multiple ? values : values[0];
	        var showAllSuggestions = _this.props.showSuggestionsWhenValueIsSet;
	
	        var query = _this.query(value);
	        if (_this.props.onChange) _this.props.onChange(value, event);
	        if (_this.props.keepFocusOnChange) {
	          _this.setState({ query: query, showAllSuggestions: showAllSuggestions });
	        } else {
	          _this.setState({ focus: false, query: query, showAllSuggestions: showAllSuggestions }, function () {
	            _reactDom2.default.findDOMNode(_this).querySelector('input').blur();
	          });
	        }
	        _this.updateQuery(query, _this.props.query);
	      }, _this.handleMouseDown = function (event) {
	        _this.selectOrCreateActiveItem(event);
	      }, _this.handleQueryBlur = function (event) {
	        if (_this.state.focus) _this.setState({ focus: false });
	        if (_this.props.onBlur) _this.props.onBlur(event, _this.state.active);
	      }, _this.updateQuery = function (query, notify) {
	        if (notify && _this.props.onQueryChange) _this.props.onQueryChange(query);
	        _this.setState({ query: query });
	      }, _this.handleQueryChange = function (value) {
	        var query = _this.clearQuery ? '' : value;
	        _this.clearQuery = false;
	
	        _this.updateQuery(query, true);
	        _this.setState({ showAllSuggestions: query ? false : _this.props.showSuggestionsWhenValueIsSet, active: null });
	      }, _this.handleQueryFocus = function (event) {
	        event.target.scrollTop = 0;
	        _this.setState({ active: '', focus: true });
	        if (_this.props.onFocus) _this.props.onFocus(event);
	      }, _this.handleQueryKeyDown = function (event) {
	        // Mark query for clearing in handleQueryChange when pressing backspace and showing all suggestions.
	        _this.clearQuery = event.which === 8 && _this.props.showSuggestionsWhenValueIsSet && _this.state.showAllSuggestions;
	
	        if (event.which === 13) {
	          _this.selectOrCreateActiveItem(event);
	        }
	
	        if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	      }, _this.handleQueryKeyUp = function (event) {
	        if (event.which === 27) _reactDom2.default.findDOMNode(_this).querySelector('input').blur();
	
	        if ([40, 38].indexOf(event.which) !== -1) {
	          var suggestionsKeys = [].concat(_toConsumableArray(_this.suggestions().keys()));
	          var index = suggestionsKeys.indexOf(_this.state.active) + (event.which === 40 ? +1 : -1);
	          if (index < 0) index = suggestionsKeys.length - 1;
	          if (index >= suggestionsKeys.length) index = 0;
	          _this.setState({ active: suggestionsKeys[index] });
	        }
	
	        if (_this.props.onKeyUp) _this.props.onKeyUp(event);
	      }, _this.handleSuggestionHover = function (event) {
	        _this.setState({ active: event.target.id });
	      }, _this.select = function (event, target) {
	        _events2.default.pauseEvent(event);
	        var values = _this.values(_this.props.value);
	        var source = _this.source();
	        var newValue = target === void 0 ? event.target.id : target;
	
	        if (_this.isValueAnObject()) {
	          var newItem = Array.from(source).reduce(function (obj, _ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                k = _ref3[0],
	                value = _ref3[1];
	
	            if (k === newValue) {
	              obj[k] = value;
	            }
	            return obj;
	          }, {});
	
	          if (Object.keys(newItem).length === 0 && newValue) {
	            newItem[newValue] = newValue;
	          }
	
	          return _this.handleChange(Object.assign(_this.mapToObject(values), newItem), event);
	        }
	
	        _this.handleChange([newValue].concat(_toConsumableArray(values.keys())), event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Autocomplete, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!this.props.multiple) {
	          var query = nextProps.query ? nextProps.query : this.query(nextProps.value);
	          this.updateQuery(query, false);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        if (!this.state.focus && nextState.focus && this.props.direction === POSITION.AUTO) {
	          var direction = this.calculateDirection();
	          if (this.state.direction !== direction) {
	            this.setState({ direction: direction });
	          }
	        }
	        return true;
	      }
	    }, {
	      key: 'calculateDirection',
	      value: function calculateDirection() {
	        if (this.props.direction === 'auto') {
	          var client = _reactDom2.default.findDOMNode(this.inputNode).getBoundingClientRect();
	          var screen_height = window.innerHeight || document.documentElement.offsetHeight;
	          var up = client.top > screen_height / 2 + client.height;
	          return up ? 'up' : 'down';
	        }
	        return this.props.direction;
	      }
	    }, {
	      key: 'query',
	      value: function query(key) {
	        var query_value = '';
	        if (!this.props.multiple && (0, _utils.isValuePresent)(key)) {
	          var source_value = this.source().get('' + key);
	          query_value = source_value || key;
	        }
	        return query_value;
	      }
	    }, {
	      key: 'selectOrCreateActiveItem',
	      value: function selectOrCreateActiveItem(event) {
	        var target = this.state.active;
	        if (!target) {
	          target = this.props.allowCreate ? this.state.query : [].concat(_toConsumableArray(this.suggestions().keys()))[0];
	          this.setState({ active: target });
	        }
	        this.select(event, target);
	      }
	    }, {
	      key: 'normalise',
	      value: function normalise(value) {
	        var sdiak = 'áâäąáâäąččććççĉĉďđďđééěëēėęéěëēėęĝĝğğġġģģĥĥħħíîíîĩĩīīĭĭįįi̇ıĵĵķķĸĺĺļļŀŀłłĺľĺľňńņŋŋņňńŉóöôőøōōóöőôøřřŕŕŗŗššśśŝŝşşţţťťŧŧũũūūŭŭůůűűúüúüűųųŵŵýyŷŷýyžžźźżżß';
	        var bdiak = 'AAAAAAAACCCCCCCCDDDDEEEEEEEEEEEEEGGGGGGGGHHHHIIIIIIIIIIIIIIJJKKKLLLLLLLLLLLLNNNNNNNNNOOOOOOOOOOOORRRRRRSSSSSSSSTTTTTTUUUUUUUUUUUUUUUUUWWYYYYYYZZZZZZS';
	
	        var normalised = '';
	        for (var p = 0; p < value.length; p++) {
	          if (sdiak.indexOf(value.charAt(p)) !== -1) {
	            normalised += bdiak.charAt(sdiak.indexOf(value.charAt(p)));
	          } else {
	            normalised += value.charAt(p);
	          }
	        }
	
	        return normalised.toLowerCase().trim();
	      }
	    }, {
	      key: 'suggestions',
	      value: function suggestions() {
	        var suggest = new Map();
	        var rawQuery = this.state.query || (this.props.multiple ? '' : this.props.value);
	        var query = this.normalise('' + rawQuery);
	        var values = this.values();
	        var source = this.source();
	
	        // Suggest any non-set value which matches the query
	        if (this.props.multiple) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var _step$value = _slicedToArray(_step.value, 2),
	                  key = _step$value[0],
	                  value = _step$value[1];
	
	              if (!values.has(key) && this.matches(this.normalise(value), query)) {
	                suggest.set(key, value);
	              }
	            }
	
	            // When multiple is false, suggest any value which matches the query if showAllSuggestions is false
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        } else if (query && !this.state.showAllSuggestions) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = source[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var _step2$value = _slicedToArray(_step2.value, 2),
	                  key = _step2$value[0],
	                  value = _step2$value[1];
	
	              if (this.matches(this.normalise(value), query)) {
	                suggest.set(key, value);
	              }
	            }
	
	            // When multiple is false, suggest all values when showAllSuggestions is true
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        } else {
	          suggest = source;
	        }
	
	        return suggest;
	      }
	    }, {
	      key: 'matches',
	      value: function matches(value, query) {
	        var suggestionMatch = this.props.suggestionMatch;
	
	
	        if (suggestionMatch === 'disabled') {
	          return true;
	        } else if (suggestionMatch === 'start') {
	          return value.startsWith(query);
	        } else if (suggestionMatch === 'anywhere') {
	          return value.includes(query);
	        } else if (suggestionMatch === 'word') {
	          var re = new RegExp('\\b' + query, 'g');
	          return re.test(value);
	        } else if (suggestionMatch === 'none') {
	          return value;
	        }
	
	        return false;
	      }
	    }, {
	      key: 'source',
	      value: function source() {
	        var src = this.props.source;
	
	        if (src.hasOwnProperty('length')) {
	          return new Map(src.map(function (item) {
	            return Array.isArray(item) ? [].concat(_toConsumableArray(item)) : [item, item];
	          }));
	        }
	        return new Map(Object.keys(src).map(function (key) {
	          return ['' + key, src[key]];
	        }));
	      }
	    }, {
	      key: 'values',
	      value: function values() {
	        var vals = this.props.multiple ? this.props.value : [this.props.value];
	
	        if (!vals) vals = [];
	
	        if (this.props.showSelectedWhenNotInSource && this.isValueAnObject()) {
	          return new Map(Object.entries(vals));
	        }
	
	        var valueMap = new Map();
	
	        var stringVals = vals.map(function (v) {
	          return '' + v;
	        });
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = this.source()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _step3$value = _slicedToArray(_step3.value, 2),
	                k = _step3$value[0],
	                v = _step3$value[1];
	
	            if (stringVals.indexOf(k) !== -1) valueMap.set(k, v);
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        return valueMap;
	      }
	    }, {
	      key: 'unselect',
	      value: function unselect(key, event) {
	        if (!this.props.disabled) {
	          var values = this.values(this.props.value);
	
	          values.delete(key);
	
	          if (this.isValueAnObject()) {
	            return this.handleChange(this.mapToObject(values), event);
	          }
	
	          this.handleChange([].concat(_toConsumableArray(values.keys())), event);
	        }
	      }
	    }, {
	      key: 'isValueAnObject',
	      value: function isValueAnObject() {
	        return !Array.isArray(this.props.value) && _typeof(this.props.value) === 'object';
	      }
	    }, {
	      key: 'mapToObject',
	      value: function mapToObject(map) {
	        return Array.from(map).reduce(function (obj, _ref4) {
	          var _ref5 = _slicedToArray(_ref4, 2),
	              k = _ref5[0],
	              value = _ref5[1];
	
	          obj[k] = value;
	          return obj;
	        }, {});
	      }
	    }, {
	      key: 'renderSelected',
	      value: function renderSelected() {
	        var _this2 = this;
	
	        if (this.props.multiple) {
	          var selectedItems = [].concat(_toConsumableArray(this.values())).map(function (_ref6) {
	            var _ref7 = _slicedToArray(_ref6, 2),
	                key = _ref7[0],
	                value = _ref7[1];
	
	            return _react2.default.createElement(
	              Chip,
	              {
	                key: key,
	                className: _this2.props.theme.value,
	                deletable: true,
	                onDeleteClick: _this2.unselect.bind(_this2, key)
	              },
	              value
	            );
	          });
	
	          return _react2.default.createElement(
	            'ul',
	            { className: this.props.theme.values },
	            selectedItems
	          );
	        }
	      }
	    }, {
	      key: 'renderSuggestions',
	      value: function renderSuggestions() {
	        var _this3 = this;
	
	        var theme = this.props.theme;
	
	        var suggestions = [].concat(_toConsumableArray(this.suggestions())).map(function (_ref8) {
	          var _ref9 = _slicedToArray(_ref8, 2),
	              key = _ref9[0],
	              value = _ref9[1];
	
	          var className = (0, _classnames5.default)(theme.suggestion, _defineProperty({}, theme.active, _this3.state.active === key));
	          return _react2.default.createElement(
	            'li',
	            {
	              id: key,
	              key: key,
	              className: className,
	              onMouseDown: _this3.handleMouseDown,
	              onMouseOver: _this3.handleSuggestionHover
	            },
	            value
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          {
	            className: (0, _classnames5.default)(theme.suggestions, _defineProperty({}, theme.up, this.state.direction === 'up'))
	          },
	          suggestions
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props = this.props,
	            allowCreate = _props.allowCreate,
	            error = _props.error,
	            label = _props.label,
	            source = _props.source,
	            suggestionMatch = _props.suggestionMatch,
	            query = _props.query,
	            selectedPosition = _props.selectedPosition,
	            keepFocusOnChange = _props.keepFocusOnChange,
	            showSuggestionsWhenValueIsSet = _props.showSuggestionsWhenValueIsSet,
	            showSelectedWhenNotInSource = _props.showSelectedWhenNotInSource,
	            onQueryChange = _props.onQueryChange,
	            theme = _props.theme,
	            other = _objectWithoutProperties(_props, ['allowCreate', 'error', 'label', 'source', 'suggestionMatch', 'query', 'selectedPosition', 'keepFocusOnChange', 'showSuggestionsWhenValueIsSet', 'showSelectedWhenNotInSource', 'onQueryChange', 'theme']);
	
	        var className = (0, _classnames5.default)(theme.autocomplete, _defineProperty({}, theme.focus, this.state.focus), this.props.className);
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'autocomplete', className: className },
	          this.props.selectedPosition === 'above' ? this.renderSelected() : null,
	          _react2.default.createElement(Input, _extends({}, other, {
	            ref: function ref(node) {
	              _this4.inputNode = node;
	            },
	            autoComplete: 'off',
	            className: theme.input,
	            error: error,
	            label: label,
	            onBlur: this.handleQueryBlur,
	            onChange: this.handleQueryChange,
	            onFocus: this.handleQueryFocus,
	            onKeyDown: this.handleQueryKeyDown,
	            onKeyUp: this.handleQueryKeyUp,
	            theme: theme,
	            themeNamespace: 'input',
	            value: this.state.query
	          })),
	          this.renderSuggestions(),
	          this.props.selectedPosition === 'below' ? this.renderSelected() : null
	        );
	      }
	    }]);
	
	    return Autocomplete;
	  }(_react.Component);
	
	  Autocomplete.propTypes = {
	    allowCreate: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    direction: _propTypes2.default.oneOf(['auto', 'up', 'down']),
	    disabled: _propTypes2.default.bool,
	    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    keepFocusOnChange: _propTypes2.default.bool,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    multiple: _propTypes2.default.bool,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onKeyDown: _propTypes2.default.func,
	    onKeyUp: _propTypes2.default.func,
	    onQueryChange: _propTypes2.default.func,
	    query: _propTypes2.default.string,
	    selectedPosition: _propTypes2.default.oneOf(['above', 'below', 'none']),
	    showSelectedWhenNotInSource: _propTypes2.default.bool,
	    showSuggestionsWhenValueIsSet: _propTypes2.default.bool,
	    source: _propTypes2.default.any,
	    suggestionMatch: _propTypes2.default.oneOf(['disabled', 'start', 'anywhere', 'word', 'none']),
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      autocomplete: _propTypes2.default.string,
	      focus: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      suggestion: _propTypes2.default.string,
	      suggestions: _propTypes2.default.string,
	      up: _propTypes2.default.string,
	      value: _propTypes2.default.string,
	      values: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.any
	  };
	  Autocomplete.defaultProps = {
	    allowCreate: false,
	    className: '',
	    direction: 'auto',
	    keepFocusOnChange: false,
	    multiple: true,
	    selectedPosition: 'above',
	    showSelectedWhenNotInSource: false,
	    showSuggestionsWhenValueIsSet: false,
	    source: {},
	    suggestionMatch: 'start'
	  };
	
	
	  return Autocomplete;
	};
	
	var Autocomplete = factory(_Chip2.default, _Input2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.AUTOCOMPLETE, null, { withRef: true })(Autocomplete);
	exports.autocompleteFactory = factory;
	exports.Autocomplete = Autocomplete;

/***/ },
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BrowseButton = exports.browseButtonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var SimpleBrowseButton = function (_Component) {
	    _inherits(SimpleBrowseButton, _Component);
	
	    function SimpleBrowseButton() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, SimpleBrowseButton);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleBrowseButton.__proto__ || Object.getPrototypeOf(SimpleBrowseButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.getShape = function () {
	        if (_this.props.raised) return 'raised';
	        if (_this.props.floating) return 'floating';
	        return 'flat';
	      }, _this.handleMouseUp = function (event) {
	        _this.labelNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.labelNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _this.handleFileChange = function (event) {
	        if (_this.props.onChange) _this.props.onChange(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SimpleBrowseButton, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            accept = _props.accept,
	            children = _props.children,
	            className = _props.className,
	            flat = _props.flat,
	            floating = _props.floating,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            label = _props.label,
	            mini = _props.mini,
	            multiple = _props.multiple,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            raised = _props.raised,
	            theme = _props.theme,
	            others = _objectWithoutProperties(_props, ['accent', 'accept', 'children', 'className', 'flat', 'floating', 'icon', 'inverse', 'label', 'mini', 'multiple', 'neutral', 'primary', 'raised', 'theme']);
	
	        var element = 'label';
	        var level = this.getLevel();
	        var shape = this.getShape();
	
	        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, {
	          ref: function ref(node) {
	            _this2.labelNode = node;
	          },
	          onChange: null,
	          className: classes,
	          disabled: this.props.disabled,
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave,
	          'data-react-toolbox': 'label'
	        });
	
	        return _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, _react2.default.createElement(
	          'span',
	          null,
	          label
	        ), _react2.default.createElement('input', {
	          className: classes,
	          type: 'file',
	          accept: accept,
	          multiple: multiple,
	          onChange: this.handleFileChange
	        }), children);
	      }
	    }]);
	
	    return SimpleBrowseButton;
	  }(_react.Component);
	
	  SimpleBrowseButton.propTypes = {
	    accent: _propTypes2.default.bool,
	    accept: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    flat: _propTypes2.default.bool,
	    floating: _propTypes2.default.bool,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    label: _propTypes2.default.string,
	    mini: _propTypes2.default.bool,
	    multiple: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    raised: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  SimpleBrowseButton.defaultProps = {
	    accent: false,
	    accept: '*/*',
	    className: '',
	    flat: false,
	    floating: false,
	    mini: false,
	    multiple: false,
	    neutral: true,
	    primary: false,
	    raised: false
	  };
	
	
	  return ripple(SimpleBrowseButton);
	};
	
	var BrowseButton = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(BrowseButton);
	exports.browseButtonFactory = factory;
	exports.BrowseButton = BrowseButton;

/***/ },
/* 2375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Card = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Card = function Card(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      raised = _ref.raised,
	      theme = _ref.theme,
	      other = _objectWithoutProperties(_ref, ['children', 'className', 'raised', 'theme']);
	
	  var classes = (0, _classnames3.default)(theme.card, _defineProperty({}, theme.raised, raised), className);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ 'data-react-toolbox': 'card', className: classes }, other),
	    children
	  );
	};
	
	Card.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  raised: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    card: _propTypes2.default.string,
	    raised: _propTypes2.default.string
	  })
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(Card);
	exports.Card = Card;

/***/ },
/* 2376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardActions = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CardActions = function CardActions(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      theme = _ref.theme,
	      other = _objectWithoutProperties(_ref, ['children', 'className', 'theme']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: (0, _classnames2.default)(theme.cardActions, className) }, other),
	    children
	  );
	};
	
	CardActions.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  theme: _propTypes2.default.shape({
	    cardActions: _propTypes2.default.string
	  })
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardActions);
	exports.CardActions = CardActions;

/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardMedia = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _classnames3 = __webpack_require__(3);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CardMedia = function CardMedia(_ref) {
	  var aspectRatio = _ref.aspectRatio,
	      children = _ref.children,
	      className = _ref.className,
	      color = _ref.color,
	      contentOverlay = _ref.contentOverlay,
	      image = _ref.image,
	      theme = _ref.theme,
	      other = _objectWithoutProperties(_ref, ['aspectRatio', 'children', 'className', 'color', 'contentOverlay', 'image', 'theme']);
	
	  var classes = (0, _classnames4.default)(theme.cardMedia, _defineProperty({}, theme[aspectRatio], aspectRatio), className);
	
	  var innerClasses = (0, _classnames4.default)(theme.content, _defineProperty({}, theme.contentOverlay, contentOverlay));
	
	  var bgStyle = {
	    backgroundColor: color || undefined,
	    backgroundImage: typeof image === 'string' ? 'url(\'' + image + '\')' : undefined
	  };
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ style: bgStyle, className: classes }, other),
	    _react2.default.createElement(
	      'div',
	      { className: innerClasses },
	      children
	    )
	  );
	};
	
	CardMedia.propTypes = {
	  aspectRatio: _propTypes2.default.oneOf(['wide', 'square']),
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  contentOverlay: _propTypes2.default.bool,
	  image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  theme: _propTypes2.default.shape({
	    cardMedia: _propTypes2.default.string,
	    content: _propTypes2.default.string,
	    contentOverlay: _propTypes2.default.string,
	    square: _propTypes2.default.string,
	    wide: _propTypes2.default.string
	  })
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardMedia);
	exports.CardMedia = CardMedia;

/***/ },
/* 2378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardText = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CardText = function CardText(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      theme = _ref.theme,
	      other = _objectWithoutProperties(_ref, ['children', 'className', 'theme']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: (0, _classnames2.default)(theme.cardText, className) }, other),
	    typeof children === 'string' ? _react2.default.createElement(
	      'p',
	      null,
	      children
	    ) : children
	  );
	};
	
	CardText.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  theme: _propTypes2.default.shape({
	    cardText: _propTypes2.default.string
	  })
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardText);
	exports.CardText = CardText;

/***/ },
/* 2379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cardTitleFactory = exports.CardTitle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Avatar = __webpack_require__(245);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var factory = function factory(Avatar) {
	  var CardTitle = function CardTitle(_ref) {
	    var _classnames;
	
	    var avatar = _ref.avatar,
	        children = _ref.children,
	        className = _ref.className,
	        subtitle = _ref.subtitle,
	        theme = _ref.theme,
	        title = _ref.title,
	        other = _objectWithoutProperties(_ref, ['avatar', 'children', 'className', 'subtitle', 'theme', 'title']);
	
	    var classes = (0, _classnames3.default)(theme.cardTitle, (_classnames = {}, _defineProperty(_classnames, theme.small, avatar), _defineProperty(_classnames, theme.large, !avatar), _classnames), className);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ className: classes }, other),
	      typeof avatar === 'string' ? _react2.default.createElement(Avatar, { image: avatar, theme: theme }) : avatar,
	      _react2.default.createElement(
	        'div',
	        null,
	        title && _react2.default.createElement(
	          'h5',
	          { className: theme.title },
	          title
	        ),
	        children && typeof children === 'string' && _react2.default.createElement(
	          'h5',
	          { className: theme.title },
	          children
	        ),
	        subtitle && _react2.default.createElement(
	          'p',
	          { className: theme.subtitle },
	          subtitle
	        ),
	        children && typeof children !== 'string' && children
	      )
	    );
	  };
	
	  CardTitle.propTypes = {
	    avatar: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.array]),
	    className: _propTypes2.default.string,
	    subtitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    theme: _propTypes2.default.shape({
	      large: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      small: _propTypes2.default.string,
	      subtitle: _propTypes2.default.string
	    }),
	    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
	  };
	
	  return CardTitle;
	};
	
	var CardTitle = factory(_Avatar2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.CARD)(CardTitle);
	exports.CardTitle = CardTitle;
	exports.cardTitleFactory = factory;

/***/ },
/* 2380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CardTitle = exports.CardText = exports.CardMedia = exports.CardActions = exports.Card = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Card = __webpack_require__(2375);
	
	var _CardActions = __webpack_require__(2376);
	
	var _CardMedia = __webpack_require__(2377);
	
	var _CardText = __webpack_require__(2378);
	
	var _CardTitle = __webpack_require__(2379);
	
	var _avatar = __webpack_require__(246);
	
	var _theme = __webpack_require__(1434);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardTitle = (0, _CardTitle.cardTitleFactory)(_avatar.Avatar);
	var ThemedCard = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_Card.Card);
	var ThemedCardActions = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_CardActions.CardActions);
	var ThemedCardMedia = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_CardMedia.CardMedia);
	var ThemedCardText = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(_CardText.CardText);
	var ThemedCardTitle = (0, _reactCssThemr.themr)(_identifiers.CARD, _theme2.default)(CardTitle);
	
	exports.default = ThemedCard;
	exports.Card = ThemedCard;
	exports.CardActions = ThemedCardActions;
	exports.CardMedia = ThemedCardMedia;
	exports.CardText = ThemedCardText;
	exports.CardTitle = ThemedCardTitle;

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Day = function (_Component) {
	  _inherits(Day, _Component);
	
	  function Day() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Day.__proto__ || Object.getPrototypeOf(Day)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      if (!_this.props.disabled && _this.props.onClick) {
	        _this.props.onClick(_this.props.day);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Day, [{
	    key: 'dayStyle',
	    value: function dayStyle() {
	      if (this.props.day === 1) {
	        var e = this.props.sundayFirstDayOfWeek ? 0 : 1;
	        var firstDay = _time2.default.getFirstWeekDay(this.props.viewDate) - e;
	        return {
	          marginLeft: (firstDay >= 0 ? firstDay : 6) * (100 / 7) + '%'
	        };
	      }
	      return undefined;
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected() {
	      var sameYear = this.props.viewDate.getFullYear() === this.props.selectedDate.getFullYear();
	      var sameMonth = this.props.viewDate.getMonth() === this.props.selectedDate.getMonth();
	      var sameDay = this.props.day === this.props.selectedDate.getDate();
	      return sameYear && sameMonth && sameDay;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var className = (0, _classnames3.default)(this.props.theme.day, (_classnames = {}, _defineProperty(_classnames, this.props.theme.active, this.isSelected()), _defineProperty(_classnames, this.props.theme.disabled, this.props.disabled), _classnames));
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'day', className: className, style: this.dayStyle() },
	        _react2.default.createElement(
	          'span',
	          { onClick: this.handleClick },
	          this.props.day
	        )
	      );
	    }
	  }]);
	
	  return Day;
	}(_react.Component);
	
	Day.propTypes = {
	  day: _propTypes2.default.number,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.instanceOf(Date),
	  sundayFirstDayOfWeek: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    day: _propTypes2.default.string,
	    disabled: _propTypes2.default.string
	  }),
	  viewDate: _propTypes2.default.instanceOf(Date)
	};
	exports.default = Day;

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(60);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _CalendarDay = __webpack_require__(2381);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Month = function (_Component) {
	  _inherits(Month, _Component);
	
	  function Month() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.handleDayClick = function (day) {
	      if (_this.props.onDayClick) _this.props.onDayClick(day);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Month, [{
	    key: 'isDayDisabled',
	    value: function isDayDisabled(date) {
	      var _props = this.props,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          enabledDates = _props.enabledDates,
	          disabledDates = _props.disabledDates;
	
	      var compareDate = function compareDate(compDate) {
	        return date.getTime() === compDate.getTime();
	      };
	      var dateInDisabled = disabledDates.filter(compareDate).length > 0;
	      var dateInEnabled = enabledDates.filter(compareDate).length > 0;
	      return _time2.default.dateOutOfRange(date, minDate, maxDate) || enabledDates.length > 0 && !dateInEnabled || dateInDisabled;
	    }
	  }, {
	    key: 'renderWeeks',
	    value: function renderWeeks() {
	      var _this2 = this;
	
	      var days = (0, _utils.range)(0, 7).map(function (d) {
	        return _time2.default.getDayOfWeekLetter(d, _this2.props.locale);
	      });
	      var source = this.props.sundayFirstDayOfWeek ? days : [].concat(_toConsumableArray(days.slice(1)), [days[0]]);
	      return source.map(function (day, i) {
	        return _react2.default.createElement(
	          'span',
	          { key: i },
	          day
	        );
	      }); // eslint-disable-line
	    }
	  }, {
	    key: 'renderDays',
	    value: function renderDays() {
	      var _this3 = this;
	
	      return (0, _utils.range)(1, _time2.default.getDaysInMonth(this.props.viewDate) + 1).map(function (i) {
	        var date = new Date(_this3.props.viewDate.getFullYear(), _this3.props.viewDate.getMonth(), i);
	        return _react2.default.createElement(_CalendarDay2.default, {
	          key: i,
	          day: i,
	          disabled: _this3.isDayDisabled(date),
	          onClick: _this3.handleDayClick,
	          selectedDate: _this3.props.selectedDate,
	          theme: _this3.props.theme,
	          viewDate: _this3.props.viewDate,
	          sundayFirstDayOfWeek: _this3.props.sundayFirstDayOfWeek
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fullMonth = _time2.default.getFullMonth(this.props.viewDate, this.props.locale);
	      var fullYear = this.props.viewDate.getFullYear();
	      return _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'month', className: this.props.theme.month },
	        _react2.default.createElement(
	          'span',
	          { className: this.props.theme.title },
	          fullMonth,
	          ' ',
	          fullYear
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.theme.week },
	          this.renderWeeks()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.theme.days },
	          this.renderDays()
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.Component);
	
	Month.propTypes = {
	  disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	  enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	  locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  maxDate: _propTypes2.default.instanceOf(Date),
	  minDate: _propTypes2.default.instanceOf(Date),
	  onDayClick: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.instanceOf(Date),
	  sundayFirstDayOfWeek: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    days: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    week: _propTypes2.default.string
	  }),
	  viewDate: _propTypes2.default.instanceOf(Date)
	};
	Month.defaultProps = {
	  disabledDates: [],
	  enabledDates: []
	};
	exports.default = Month;

/***/ },
/* 2383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DatePicker = exports.Calendar = exports.datePickerFactory = exports.DatePickerDialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _IconButton = __webpack_require__(248);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Input = __webpack_require__(149);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Dialog = __webpack_require__(370);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Calendar = __webpack_require__(792);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _DatePickerDialog = __webpack_require__(793);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Input, DatePickerDialog) {
	  var DatePicker = function (_Component) {
	    _inherits(DatePicker, _Component);
	
	    function DatePicker() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, DatePicker);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        active: _this.props.active
	      }, _this.handleDismiss = function () {
	        _this.setState({ active: false });
	        if (_this.props.onDismiss) {
	          _this.props.onDismiss();
	        }
	      }, _this.handleInputFocus = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	      }, _this.handleInputBlur = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: false });
	      }, _this.handleInputClick = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	        if (_this.props.onClick) _this.props.onClick(event);
	      }, _this.handleInputKeyPress = function (event) {
	        if (event.charCode === 13) {
	          _events2.default.pauseEvent(event);
	          _this.setState({ active: true });
	        }
	        if (_this.props.onKeyPress) _this.props.onKeyPress(event);
	      }, _this.handleSelect = function (value, event) {
	        if (_this.props.onChange) _this.props.onChange(value, event);
	        _this.setState({ active: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DatePicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.active !== this.props.active && this.state.active !== nextProps.active) {
	          this.setState({ active: nextProps.active });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            onDismiss = _props.onDismiss,
	            autoOk = _props.autoOk,
	            cancelLabel = _props.cancelLabel,
	            enabledDates = _props.enabledDates,
	            disabledDates = _props.disabledDates,
	            inputClassName = _props.inputClassName,
	            inputFormat = _props.inputFormat,
	            locale = _props.locale,
	            maxDate = _props.maxDate,
	            minDate = _props.minDate,
	            okLabel = _props.okLabel,
	            onEscKeyDown = _props.onEscKeyDown,
	            onOverlayClick = _props.onOverlayClick,
	            readonly = _props.readonly,
	            sundayFirstDayOfWeek = _props.sundayFirstDayOfWeek,
	            value = _props.value,
	            others = _objectWithoutProperties(_props, ['active', 'onDismiss', 'autoOk', 'cancelLabel', 'enabledDates', 'disabledDates', 'inputClassName', 'inputFormat', 'locale', 'maxDate', 'minDate', 'okLabel', 'onEscKeyDown', 'onOverlayClick', 'readonly', 'sundayFirstDayOfWeek', 'value']);
	
	        var finalInputFormat = inputFormat || _time2.default.formatDate;
	        var date = Object.prototype.toString.call(value) === '[object Date]' ? value : undefined;
	        var formattedDate = date === undefined ? '' : finalInputFormat(value, locale);
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'date-picker', className: this.props.theme.container },
	          _react2.default.createElement(Input, _extends({}, others, {
	            className: (0, _classnames3.default)(this.props.theme.input, _defineProperty({}, inputClassName, inputClassName)),
	            disabled: readonly,
	            error: this.props.error,
	            icon: this.props.icon,
	            label: this.props.label,
	            name: this.props.name,
	            onFocus: this.handleInputFocus,
	            onKeyPress: this.handleInputKeyPress,
	            onClick: this.handleInputClick,
	            readOnly: true,
	            type: 'text',
	            value: formattedDate
	          })),
	          _react2.default.createElement(DatePickerDialog, {
	            active: this.state.active,
	            autoOk: autoOk,
	            cancelLabel: cancelLabel,
	            className: this.props.className,
	            disabledDates: disabledDates,
	            enabledDates: enabledDates,
	            locale: locale,
	            maxDate: maxDate,
	            minDate: minDate,
	            name: this.props.name,
	            onDismiss: this.handleDismiss,
	            okLabel: okLabel,
	            onEscKeyDown: onEscKeyDown || this.handleDismiss,
	            onOverlayClick: onOverlayClick || this.handleDismiss,
	            onSelect: this.handleSelect,
	            sundayFirstDayOfWeek: sundayFirstDayOfWeek,
	            theme: this.props.theme,
	            value: date
	          })
	        );
	      }
	    }]);
	
	    return DatePicker;
	  }(_react.Component);
	
	  DatePicker.propTypes = {
	    active: _propTypes2.default.bool,
	    autoOk: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    error: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inputClassName: _propTypes2.default.string,
	    inputFormat: _propTypes2.default.func,
	    label: _propTypes2.default.string,
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    readonly: _propTypes2.default.bool,
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      container: _propTypes2.default.string,
	      input: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string])
	  };
	  DatePicker.defaultProps = {
	    active: false,
	    locale: 'en',
	    sundayFirstDayOfWeek: false
	  };
	
	
	  return DatePicker;
	};
	
	var Calendar = (0, _Calendar2.default)(_IconButton2.default);
	var DatePickerDialog = (0, _DatePickerDialog2.default)(_Dialog2.default, Calendar);
	var DatePicker = factory(_Input2.default, DatePickerDialog);
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DATE_PICKER)(DatePicker);
	exports.DatePickerDialog = DatePickerDialog;
	exports.datePickerFactory = factory;
	exports.Calendar = Calendar;
	exports.DatePicker = DatePicker;

/***/ },
/* 2384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DatePickerDialog = exports.DatePicker = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _DatePicker = __webpack_require__(2383);
	
	var _DatePickerDialog = __webpack_require__(793);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _Calendar = __webpack_require__(792);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _button = __webpack_require__(31);
	
	var _input = __webpack_require__(33);
	
	var _dialog = __webpack_require__(371);
	
	var _theme = __webpack_require__(1437);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Calendar = (0, _Calendar2.default)(_button.IconButton);
	var DatePickerDialog = (0, _DatePickerDialog2.default)(_dialog.Dialog, Calendar);
	var DatePicker = (0, _DatePicker.datePickerFactory)(_input.Input, DatePickerDialog);
	
	var ThemedDatePicker = (0, _reactCssThemr.themr)(_identifiers.DATE_PICKER, _theme2.default)(DatePicker);
	exports.default = ThemedDatePicker;
	exports.DatePicker = ThemedDatePicker;
	
	
	var ThemedDatePickerDialog = (0, _reactCssThemr.themr)(_identifiers.DIALOG, _theme2.default)(DatePickerDialog);
	exports.DatePickerDialog = ThemedDatePickerDialog;

/***/ },
/* 2385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dropdown = exports.dropdownFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames4 = __webpack_require__(3);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Input = __webpack_require__(149);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */
	
	
	var factory = function factory(Input) {
	  var Dropdown = function (_Component) {
	    _inherits(Dropdown, _Component);
	
	    function Dropdown() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Dropdown);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        active: false,
	        up: false
	      }, _this.getDocumentEvents = function () {
	        return {
	          click: _this.handleDocumentClick,
	          touchend: _this.handleDocumentClick
	        };
	      }, _this.getSelectedItem = function () {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = _this.props.source[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            if (item[_this.props.valueKey] === _this.props.value) return item;
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        return !_this.props.allowBlank ? _this.props.source[0] : undefined;
	      }, _this.handleSelect = function (item, event) {
	        if (_this.props.onBlur) _this.props.onBlur(event);
	        if (!_this.props.disabled && _this.props.onChange) {
	          if (_this.props.name) event.target.name = _this.props.name;
	          _this.props.onChange(item, event);
	          _this.close();
	        }
	      }, _this.handleClick = function (event) {
	        _this.open(event);
	        _events2.default.pauseEvent(event);
	        if (_this.props.onClick) _this.props.onClick(event);
	      }, _this.handleDocumentClick = function (event) {
	        if (_this.state.active && !_events2.default.targetIsDescendant(event, _reactDom2.default.findDOMNode(_this))) {
	          _this.setState({ active: false });
	        }
	      }, _this.close = function () {
	        if (_this.state.active) {
	          _this.setState({ active: false });
	        }
	      }, _this.open = function (event) {
	        if (_this.state.active) return;
	        var client = event.target.getBoundingClientRect();
	        var screenHeight = window.innerHeight || document.documentElement.offsetHeight;
	        var up = _this.props.auto ? client.top > screenHeight / 2 + client.height : false;
	        _this.setState({ active: true, up: up });
	      }, _this.handleFocus = function (event) {
	        event.stopPropagation();
	        if (!_this.props.disabled) _this.open(event);
	        if (_this.props.onFocus) _this.props.onFocus(event);
	      }, _this.handleBlur = function (event) {
	        event.stopPropagation();
	        if (_this.state.active) _this.close();
	        if (_this.props.onBlur) _this.props.onBlur(event);
	      }, _this.renderValue = function (item, idx) {
	        var _classnames;
	
	        var _this$props = _this.props,
	            labelKey = _this$props.labelKey,
	            theme = _this$props.theme,
	            valueKey = _this$props.valueKey;
	
	        var className = (0, _classnames5.default)((_classnames = {}, _defineProperty(_classnames, theme.selected, item[valueKey] === _this.props.value), _defineProperty(_classnames, theme.disabled, item.disabled), _classnames));
	        return _react2.default.createElement(
	          'li',
	          {
	            key: idx,
	            className: className,
	            onMouseDown: !item.disabled && _this.handleSelect.bind(_this, item[valueKey])
	          },
	          _this.props.template ? _this.props.template(item) : item[labelKey]
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Dropdown, [{
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if (!this.state.active && nextState.active) {
	          _events2.default.addEventsToDocument(this.getDocumentEvents());
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        if (prevState.active && !this.state.active) {
	          _events2.default.removeEventsFromDocument(this.getDocumentEvents());
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.state.active) {
	          _events2.default.removeEventsFromDocument(this.getDocumentEvents());
	        }
	      }
	    }, {
	      key: 'renderTemplateValue',
	      value: function renderTemplateValue(selected) {
	        var _classnames2;
	
	        var theme = this.props.theme;
	
	        var className = (0, _classnames5.default)(theme.field, (_classnames2 = {}, _defineProperty(_classnames2, theme.errored, this.props.error), _defineProperty(_classnames2, theme.disabled, this.props.disabled), _defineProperty(_classnames2, theme.required, this.props.required), _classnames2));
	
	        return _react2.default.createElement(
	          'div',
	          { className: className, onClick: this.handleClick },
	          _react2.default.createElement(
	            'div',
	            { className: theme.templateValue + ' ' + theme.value },
	            this.props.template(selected)
	          ),
	          this.props.label ? _react2.default.createElement(
	            'label',
	            { className: theme.label },
	            this.props.label,
	            this.props.required ? _react2.default.createElement(
	              'span',
	              { className: theme.required },
	              ' * '
	            ) : null
	          ) : null,
	          this.props.error ? _react2.default.createElement(
	            'span',
	            { className: theme.error },
	            this.props.error
	          ) : null
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames3;
	
	        var _props = this.props,
	            allowBlank = _props.allowBlank,
	            auto = _props.auto,
	            labelKey = _props.labelKey,
	            required = _props.required,
	            onChange = _props.onChange,
	            onFocus = _props.onFocus,
	            onBlur = _props.onBlur,
	            source = _props.source,
	            template = _props.template,
	            theme = _props.theme,
	            valueKey = _props.valueKey,
	            others = _objectWithoutProperties(_props, ['allowBlank', 'auto', 'labelKey', 'required', 'onChange', 'onFocus', 'onBlur', 'source', 'template', 'theme', 'valueKey']);
	
	        var selected = this.getSelectedItem();
	        var className = (0, _classnames5.default)(theme.dropdown, (_classnames3 = {}, _defineProperty(_classnames3, theme.up, this.state.up), _defineProperty(_classnames3, theme.active, this.state.active), _defineProperty(_classnames3, theme.disabled, this.props.disabled), _defineProperty(_classnames3, theme.required, this.props.required), _classnames3), this.props.className);
	
	        return _react2.default.createElement(
	          'div',
	          {
	            className: className,
	            'data-react-toolbox': 'dropdown',
	            onBlur: this.handleBlur,
	            onFocus: this.handleFocus,
	            tabIndex: '-1'
	          },
	          _react2.default.createElement(Input, _extends({}, others, {
	            tabIndex: '0',
	            className: theme.value,
	            onClick: this.handleClick,
	            required: this.props.required,
	            readOnly: true,
	            type: template && selected ? 'hidden' : null,
	            theme: theme,
	            themeNamespace: 'input',
	            value: selected && selected[labelKey] ? selected[labelKey] : ''
	          })),
	          template && selected ? this.renderTemplateValue(selected) : null,
	          _react2.default.createElement(
	            'ul',
	            { className: theme.values },
	            source.map(this.renderValue)
	          )
	        );
	      }
	    }]);
	
	    return Dropdown;
	  }(_react.Component);
	
	  Dropdown.propTypes = {
	    allowBlank: _propTypes2.default.bool,
	    auto: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    error: _propTypes2.default.string,
	    label: _propTypes2.default.string,
	    labelKey: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    required: _propTypes2.default.bool,
	    source: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])).isRequired,
	    template: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      disabled: _propTypes2.default.string,
	      dropdown: _propTypes2.default.string,
	      error: _propTypes2.default.string,
	      errored: _propTypes2.default.string,
	      field: _propTypes2.default.string,
	      label: _propTypes2.default.string,
	      required: _propTypes2.default.string,
	      selected: _propTypes2.default.string,
	      templateValue: _propTypes2.default.string,
	      up: _propTypes2.default.string,
	      value: _propTypes2.default.string,
	      values: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    valueKey: _propTypes2.default.string
	  };
	  Dropdown.defaultProps = {
	    auto: true,
	    className: '',
	    allowBlank: true,
	    disabled: false,
	    labelKey: 'label',
	    required: false,
	    valueKey: 'value'
	  };
	
	
	  return Dropdown;
	};
	
	var Dropdown = factory(_Input2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DROPDOWN)(Dropdown);
	exports.dropdownFactory = factory;
	exports.Dropdown = Dropdown;

/***/ },
/* 2386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dropdown = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Dropdown = __webpack_require__(2385);
	
	var _input = __webpack_require__(33);
	
	var _theme = __webpack_require__(1440);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dropdown = (0, _Dropdown.dropdownFactory)(_input.Input);
	var ThemedDropdown = (0, _reactCssThemr.themr)(_identifiers.DROPDOWN, _theme2.default)(Dropdown);
	
	exports.default = ThemedDropdown;
	exports.Dropdown = ThemedDropdown;

/***/ },
/* 2387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Layout = exports.layoutFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _utils = __webpack_require__(60);
	
	var _filterReactChildren = __webpack_require__(820);
	
	var _filterReactChildren2 = _interopRequireDefault(_filterReactChildren);
	
	var _isComponentOfType = __webpack_require__(181);
	
	var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);
	
	var _AppBar = __webpack_require__(787);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _NavDrawer = __webpack_require__(795);
	
	var _NavDrawer2 = _interopRequireDefault(_NavDrawer);
	
	var _Sidebar = __webpack_require__(796);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _isBrowser = __webpack_require__(2418);
	
	var _isBrowser2 = _interopRequireDefault(_isBrowser);
	
	var _breakpoints = __webpack_require__(2415);
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(AppBar, NavDrawer, Sidebar) {
	  var isNavDrawer = function isNavDrawer(child) {
	    return (0, _isComponentOfType2.default)(NavDrawer, child);
	  };
	  var isSidebar = function isSidebar(child) {
	    return (0, _isComponentOfType2.default)(Sidebar, child);
	  };
	  var isAppBar = function isAppBar(child) {
	    return (0, _isComponentOfType2.default)(AppBar, child);
	  };
	  var isUnknown = function isUnknown(child) {
	    return !isNavDrawer(child) && !isSidebar(child) && !isAppBar(child);
	  };
	
	  var Layout = function (_Component) {
	    _inherits(Layout, _Component);
	
	    function Layout() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Layout);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Layout.__proto__ || Object.getPrototypeOf(Layout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        width: (0, _isBrowser2.default)() && (0, _utils.getViewport)().width
	      }, _this.handleResize = function () {
	        _this.setState({ width: (0, _utils.getViewport)().width });
	      }, _this.isPinned = function (sideNav) {
	        if (sideNav) {
	          var _sideNav$props = sideNav.props,
	              permanentAt = _sideNav$props.permanentAt,
	              pinned = _sideNav$props.pinned;
	          var width = _this.state.width;
	
	          return width > _breakpoints2.default[permanentAt] || pinned;
	        }
	        return undefined;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Layout, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!this.state.width) this.handleResize();
	        window.addEventListener('resize', this.handleResize);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.handleResize);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames;
	
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className,
	            theme = _props.theme,
	            rest = _objectWithoutProperties(_props, ['children', 'className', 'theme']);
	
	        var appBar = (0, _filterReactChildren2.default)(children, isAppBar)[0];
	        var navDrawer = (0, _filterReactChildren2.default)(children, isNavDrawer)[0];
	        var sidebar = (0, _filterReactChildren2.default)(children, isSidebar)[0];
	        var unknown = (0, _filterReactChildren2.default)(children, isUnknown);
	        var appBarFixed = appBar && appBar.props.fixed;
	        var navDrawerPinned = this.isPinned(navDrawer);
	        var navDrawerClipped = navDrawer && navDrawer.props.clipped;
	        var sidebarWidth = sidebar && sidebar.props.width;
	        var sidebarPinned = this.isPinned(sidebar);
	        var sidebarClipped = sidebar && sidebar.props.clipped;
	
	        var clonedAppBar = appBar && (0, _react.cloneElement)(appBar, {
	          theme: theme,
	          themeNamespace: 'appbar'
	        });
	
	        var clonedLeftSideNav = navDrawer && (0, _react.cloneElement)(navDrawer, {
	          clipped: navDrawerClipped,
	          pinned: navDrawerPinned
	        });
	
	        var clonedRightSideNav = sidebar && (0, _react.cloneElement)(sidebar, {
	          clipped: sidebarClipped,
	          pinned: sidebarPinned
	        });
	
	        var _className = (0, _classnames3.default)(theme.layout, theme['sidebarWidth' + sidebarWidth], (_classnames = {}, _defineProperty(_classnames, theme.navDrawerPinned, navDrawerPinned), _defineProperty(_classnames, theme.navDrawerClipped, navDrawerClipped), _defineProperty(_classnames, theme.sidebarPinned, sidebarPinned), _defineProperty(_classnames, theme.sidebarClipped, sidebarClipped), _defineProperty(_classnames, theme.appbarFixed, appBarFixed), _classnames), className);
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, rest, { className: _className }),
	          clonedLeftSideNav,
	          clonedAppBar,
	          unknown,
	          clonedRightSideNav
	        );
	      }
	    }]);
	
	    return Layout;
	  }(_react.Component);
	
	  Layout.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    theme: _propTypes2.default.shape({
	      appbarFixed: _propTypes2.default.string,
	      layout: _propTypes2.default.string,
	      navDrawerClipped: _propTypes2.default.string,
	      navDrawerPinned: _propTypes2.default.string,
	      sidebarClipped: _propTypes2.default.string,
	      sidebarPinned: _propTypes2.default.string
	    })
	  };
	  Layout.defaultProps = {
	    className: ''
	  };
	
	
	  return Layout;
	};
	
	var Layout = factory(_AppBar2.default, _NavDrawer2.default, _Sidebar2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(Layout);
	exports.layoutFactory = factory;
	exports.Layout = Layout;

/***/ },
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Panel = function Panel(_ref) {
	  var bodyScroll = _ref.bodyScroll,
	      children = _ref.children,
	      className = _ref.className,
	      theme = _ref.theme,
	      other = _objectWithoutProperties(_ref, ['bodyScroll', 'children', 'className', 'theme']);
	
	  var _className = (0, _classnames2.default)(theme.panel, _defineProperty({}, theme.bodyScroll, bodyScroll), className);
	  return _react2.default.createElement(
	    'div',
	    _extends({}, other, { 'data-react-toolbox': 'panel', className: _className }),
	    children
	  );
	};
	
	Panel.propTypes = {
	  bodyScroll: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  theme: _propTypes2.default.shape({
	    panel: _propTypes2.default.string
	  })
	};
	
	Panel.defaultProps = {
	  bodyScroll: true,
	  className: ''
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LAYOUT)(Panel);
	exports.Panel = Panel;

/***/ },
/* 2389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = exports.NavDrawer = exports.Sidebar = exports.Layout = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Layout = __webpack_require__(2387);
	
	var _Sidebar = __webpack_require__(796);
	
	var _NavDrawer = __webpack_require__(795);
	
	var _Panel = __webpack_require__(2388);
	
	var _app_bar = __webpack_require__(788);
	
	var _drawer = __webpack_require__(373);
	
	var _theme = __webpack_require__(1442);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var injectTheme = function injectTheme(component) {
	  return (0, _reactCssThemr.themr)(_identifiers.LAYOUT, _theme2.default)(component);
	};
	var ThemedNavDrawer = injectTheme((0, _NavDrawer.navDrawerFactory)(_drawer.Drawer));
	var ThemedSidebar = injectTheme((0, _Sidebar.sidebarFactory)(_drawer.Drawer));
	var ThemedPanel = injectTheme(_Panel.Panel);
	var ThemedLayout = injectTheme((0, _Layout.layoutFactory)(_app_bar.AppBar, ThemedNavDrawer, ThemedSidebar));
	
	exports.default = ThemedLayout;
	exports.Layout = ThemedLayout;
	exports.Sidebar = ThemedSidebar;
	exports.NavDrawer = ThemedNavDrawer;
	exports.Panel = ThemedPanel;

/***/ },
/* 2390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.List = exports.listFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ListItem = __webpack_require__(799);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mergeProp = function mergeProp(propName, child, parent) {
	  return child[propName] !== undefined ? child[propName] : parent[propName];
	};
	
	var factory = function factory(ListItem) {
	  var List = function (_Component) {
	    _inherits(List, _Component);
	
	    function List() {
	      _classCallCheck(this, List);
	
	      return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	    }
	
	    _createClass(List, [{
	      key: 'renderItems',
	      value: function renderItems() {
	        var _this2 = this;
	
	        return _react2.default.Children.map(this.props.children, function (item) {
	          if (item === null || item === undefined) {
	            return item;
	          } else if (item.type === ListItem) {
	            var selectable = mergeProp('selectable', item.props, _this2.props);
	            var ripple = mergeProp('ripple', item.props, _this2.props);
	            return _react2.default.cloneElement(item, { selectable: selectable, ripple: ripple });
	          }
	          return _react2.default.cloneElement(item);
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          'ul',
	          { 'data-react-toolbox': 'list', className: (0, _classnames2.default)(this.props.theme.list, this.props.className) },
	          this.renderItems()
	        );
	      }
	    }]);
	
	    return List;
	  }(_react.Component);
	
	  List.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    theme: _propTypes2.default.shape({
	      list: _propTypes2.default.string
	    })
	  };
	  List.defaultProps = {
	    className: '',
	    ripple: false,
	    selectable: false
	  };
	
	
	  return List;
	};
	
	var List = factory(_ListItem2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(List);
	exports.listFactory = factory;
	exports.List = List;

/***/ },
/* 2391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListCheckbox = exports.listCheckboxFactory = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Checkbox = __webpack_require__(249);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _ListItemContent = __webpack_require__(252);
	
	var _ListItemContent2 = _interopRequireDefault(_ListItemContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var factory = function factory(Checkbox, ListItemContent) {
	  var ListCheckbox = function ListCheckbox(_ref) {
	    var caption = _ref.caption,
	        checked = _ref.checked,
	        className = _ref.className,
	        disabled = _ref.disabled,
	        legend = _ref.legend,
	        name = _ref.name,
	        onBlur = _ref.onBlur,
	        onChange = _ref.onChange,
	        onFocus = _ref.onFocus,
	        theme = _ref.theme;
	
	    var _className = (0, _classnames3.default)(theme.item, theme.checkboxItem, _defineProperty({}, theme.disabled, disabled), className);
	
	    return _react2.default.createElement(
	      'li',
	      { className: _className },
	      _react2.default.createElement(Checkbox, {
	        checked: checked,
	        className: theme.checkbox,
	        disabled: disabled,
	        label: _react2.default.createElement(ListItemContent, { caption: caption, legend: legend }),
	        name: name,
	        onBlur: onBlur,
	        onChange: onChange,
	        onFocus: onFocus
	      })
	    );
	  };
	
	  ListCheckbox.propTypes = {
	    caption: _propTypes2.default.string,
	    checked: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    legend: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      checkbox: _propTypes2.default.string,
	      checkboxItem: _propTypes2.default.string,
	      disabled: _propTypes2.default.string,
	      item: _propTypes2.default.string
	    })
	  };
	
	  ListCheckbox.defaultProps = {
	    checked: false,
	    disabled: false
	  };
	
	  return ListCheckbox;
	};
	
	var ListCheckbox = factory(_Checkbox2.default, _ListItemContent2.default);
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListCheckbox);
	exports.listCheckboxFactory = factory;
	exports.ListCheckbox = ListCheckbox;

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListDivider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListDivider = function ListDivider(_ref) {
	  var inset = _ref.inset,
	      theme = _ref.theme;
	  return _react2.default.createElement('hr', { className: inset ? theme.divider + ' ' + theme.inset : theme.divider });
	};
	
	ListDivider.propTypes = {
	  inset: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    divider: _propTypes2.default.string,
	    inset: _propTypes2.default.string
	  })
	};
	
	ListDivider.defaultProps = {
	  inset: false
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListDivider);
	exports.ListDivider = ListDivider;

/***/ },
/* 2393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ListSubHeader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListSubHeader = function ListSubHeader(_ref) {
	  var caption = _ref.caption,
	      className = _ref.className,
	      theme = _ref.theme;
	  return _react2.default.createElement(
	    'h5',
	    { className: (0, _classnames2.default)(theme.subheader, className) },
	    caption
	  );
	};
	
	ListSubHeader.propTypes = {
	  caption: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  theme: _propTypes2.default.object // eslint-disable-line
	};
	
	ListSubHeader.defaultProps = {
	  className: ''
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.LIST)(ListSubHeader);
	exports.ListSubHeader = ListSubHeader;

/***/ },
/* 2394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.List = exports.ListItem = exports.ListDivider = exports.ListCheckbox = exports.ListItemText = exports.ListSubHeader = exports.ListItemLayout = exports.ListItemContent = exports.ListItemActions = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _avatar = __webpack_require__(246);
	
	var _checkbox = __webpack_require__(369);
	
	var _ListItemText = __webpack_require__(803);
	
	var _ListItemAction = __webpack_require__(800);
	
	var _ListSubHeader = __webpack_require__(2393);
	
	var _ListDivider = __webpack_require__(2392);
	
	var _List = __webpack_require__(2390);
	
	var _ListItem = __webpack_require__(799);
	
	var _ListCheckbox = __webpack_require__(2391);
	
	var _ListItemActions = __webpack_require__(801);
	
	var _ListItemContent = __webpack_require__(252);
	
	var _ListItemLayout = __webpack_require__(802);
	
	var _ripple = __webpack_require__(105);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _theme = __webpack_require__(1444);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyTheme = function applyTheme(Component) {
	  return (0, _reactCssThemr.themr)(_identifiers.LIST, _theme2.default)(Component);
	};
	var ripple = (0, _ripple2.default)({ centered: false, listItemIgnore: true });
	var ThemedListItemAction = applyTheme(_ListItemAction.ListItemAction);
	var ThemedListSubHeader = applyTheme(_ListSubHeader.ListSubHeader);
	var ThemedListItemText = applyTheme(_ListItemText.ListItemText);
	var ThemedListDivider = applyTheme(_ListDivider.ListDivider);
	var ThemedListItemContent = applyTheme((0, _ListItemContent.listItemContentFactory)(ThemedListItemText));
	var ThemedListItemActions = applyTheme((0, _ListItemActions.listItemActionsFactory)(ThemedListItemAction));
	var ThemedListItemLayout = applyTheme((0, _ListItemLayout.listItemLayoutFactory)(_avatar.Avatar, ThemedListItemContent, ThemedListItemActions));
	var ThemedListCheckbox = applyTheme((0, _ListCheckbox.listCheckboxFactory)(_checkbox.Checkbox, ThemedListItemContent));
	var ThemedListItem = applyTheme((0, _ListItem.listItemFactory)(ripple, ThemedListItemLayout, ThemedListItemContent));
	var ThemedList = applyTheme((0, _List.listFactory)(ThemedListItem));
	
	exports.ListItemActions = ThemedListItemActions;
	exports.ListItemContent = ThemedListItemContent;
	exports.ListItemLayout = ThemedListItemLayout;
	exports.ListSubHeader = ThemedListSubHeader;
	exports.ListItemText = ThemedListItemText;
	exports.ListCheckbox = ThemedListCheckbox;
	exports.ListDivider = ThemedListDivider;
	exports.ListItem = ThemedListItem;
	exports.List = ThemedList;

/***/ },
/* 2395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconMenu = exports.iconMenuFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _IconButton = __webpack_require__(248);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Menu = __webpack_require__(804);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(IconButton, Menu) {
	  var IconMenu = function (_Component) {
	    _inherits(IconMenu, _Component);
	
	    function IconMenu() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, IconMenu);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconMenu.__proto__ || Object.getPrototypeOf(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        active: _this.props.active
	      }, _this.handleButtonClick = function (event) {
	        _this.setState({ active: !_this.state.active });
	        if (_this.props.onClick) _this.props.onClick(event);
	      }, _this.handleMenuHide = function () {
	        _this.setState({ active: false });
	        if (_this.props.onHide) _this.props.onHide();
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(IconMenu, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.state.active !== nextProps.active) {
	          this.setState({ active: nextProps.active });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            children = _props.children,
	            className = _props.className,
	            icon = _props.icon,
	            iconRipple = _props.iconRipple,
	            inverse = _props.inverse,
	            menuRipple = _props.menuRipple,
	            onHide = _props.onHide,
	            onSelect = _props.onSelect,
	            onShow = _props.onShow,
	            position = _props.position,
	            selectable = _props.selectable,
	            selected = _props.selected,
	            theme = _props.theme,
	            other = _objectWithoutProperties(_props, ['active', 'children', 'className', 'icon', 'iconRipple', 'inverse', 'menuRipple', 'onHide', 'onSelect', 'onShow', 'position', 'selectable', 'selected', 'theme']);
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, other, { className: (0, _classnames2.default)(theme.iconMenu, className) }),
	          _react2.default.createElement(IconButton, {
	            className: theme.icon,
	            icon: icon,
	            inverse: inverse,
	            onClick: this.handleButtonClick,
	            ripple: iconRipple
	          }),
	          _react2.default.createElement(
	            Menu,
	            {
	              active: this.state.active,
	              onHide: this.handleMenuHide,
	              onSelect: onSelect,
	              onShow: onShow,
	              position: position,
	              ripple: menuRipple,
	              selectable: selectable,
	              selected: selected,
	              theme: theme
	            },
	            children
	          )
	        );
	      }
	    }]);
	
	    return IconMenu;
	  }(_react.Component);
	
	  IconMenu.propTypes = {
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    iconRipple: _propTypes2.default.bool,
	    inverse: _propTypes2.default.bool,
	    menuRipple: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func,
	    onHide: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    onShow: _propTypes2.default.func,
	    position: _propTypes2.default.string,
	    selectable: _propTypes2.default.bool,
	    selected: _propTypes2.default.node,
	    theme: _propTypes2.default.shape({
	      icon: _propTypes2.default.string,
	      iconMenu: _propTypes2.default.string
	    })
	  };
	  IconMenu.defaultProps = {
	    active: false,
	    className: '',
	    icon: 'more_vert',
	    iconRipple: true,
	    menuRipple: true,
	    position: 'auto',
	    selectable: false
	  };
	
	
	  return IconMenu;
	};
	
	var IconMenu = factory(_IconButton2.default, _Menu2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(IconMenu);
	exports.iconMenuFactory = factory;
	exports.IconMenu = IconMenu;

/***/ },
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MenuDivider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuDivider = function MenuDivider(_ref) {
	  var theme = _ref.theme;
	  return _react2.default.createElement('hr', { 'data-react-toolbox': 'menu-divider', className: theme.menuDivider });
	};
	
	MenuDivider.propTypes = {
	  theme: _propTypes2.default.shape({
	    menuDivider: _propTypes2.default.string
	  })
	};
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.MENU)(MenuDivider);
	exports.MenuDivider = MenuDivider;

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Navigation = exports.navigationFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Button = __webpack_require__(247);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(797);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var factory = function factory(Button, Link) {
	  var Navigation = function Navigation(_ref) {
	    var actions = _ref.actions,
	        children = _ref.children,
	        className = _ref.className,
	        routes = _ref.routes,
	        theme = _ref.theme,
	        type = _ref.type;
	
	    var _className = (0, _classnames2.default)(theme[type], className);
	    var buttons = actions.map(function (action, index) {
	      return _react2.default.createElement(Button, _extends({ className: theme.button, key: index }, action)) // eslint-disable-line
	      ;
	    });
	
	    var links = routes.map(function (route, index) {
	      return _react2.default.createElement(Link, _extends({ className: theme.link, key: index }, route)) // eslint-disable-line
	      ;
	    });
	
	    return _react2.default.createElement(
	      'nav',
	      { 'data-react-toolbox': 'navigation', className: _className },
	      links,
	      buttons,
	      children
	    );
	  };
	
	  Navigation.propTypes = {
	    actions: _propTypes2.default.array, // eslint-disable-line
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    routes: _propTypes2.default.array, // eslint-disable-line
	    theme: _propTypes2.default.shape({
	      button: _propTypes2.default.string,
	      horizontal: _propTypes2.default.string,
	      link: _propTypes2.default.string,
	      vertical: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.oneOf(['vertical', 'horizontal'])
	  };
	
	  Navigation.defaultProps = {
	    actions: [],
	    className: '',
	    type: 'horizontal',
	    routes: []
	  };
	
	  return Navigation;
	};
	
	var Navigation = factory(_Button2.default, _Link2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.NAVIGATION)(Navigation);
	exports.navigationFactory = factory;
	exports.Navigation = Navigation;

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Navigation = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Navigation = __webpack_require__(2397);
	
	var _button = __webpack_require__(31);
	
	var _link = __webpack_require__(798);
	
	var _theme = __webpack_require__(1446);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedNavigation = (0, _reactCssThemr.themr)(_identifiers.NAVIGATION, _theme2.default)((0, _Navigation.navigationFactory)(_button.Button, _link.Link));
	exports.default = ThemedNavigation;
	exports.Navigation = ThemedNavigation;

/***/ },
/* 2399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RadioGroup = exports.radioGroupFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _RadioButton = __webpack_require__(810);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _isComponentOfType = __webpack_require__(181);
	
	var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(RadioButton) {
	  var RadioGroup = function (_Component) {
	    _inherits(RadioGroup, _Component);
	
	    function RadioGroup() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, RadioGroup);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value, event) {
	        if (_this.props.onChange) _this.props.onChange(value, event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(RadioGroup, [{
	      key: 'renderRadioButtons',
	      value: function renderRadioButtons() {
	        var _this2 = this;
	
	        return _react2.default.Children.map(this.props.children, function (child) {
	          return !(0, _isComponentOfType2.default)(RadioButton, child) ? child : _react2.default.cloneElement(child, {
	            checked: child.props.value === _this2.props.value,
	            disabled: _this2.props.disabled || child.props.disabled,
	            onChange: _this2.handleChange.bind(_this2, child.props.value)
	          });
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'radio-group', className: this.props.className },
	          this.renderRadioButtons()
	        );
	      }
	    }]);
	
	    return RadioGroup;
	  }(_react.Component);
	
	  RadioGroup.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    value: _propTypes2.default.string
	  };
	  RadioGroup.defaultProps = {
	    className: '',
	    disabled: false
	  };
	
	
	  return RadioGroup;
	};
	
	var RadioGroup = factory(_RadioButton2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.RADIO)(RadioGroup);
	exports.radioGroupFactory = factory;
	exports.RadioGroup = RadioGroup;

/***/ },
/* 2400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = exports.sliderFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactStyleProptype = __webpack_require__(244);
	
	var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _utils = __webpack_require__(60);
	
	var _identifiers = __webpack_require__(9);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ProgressBar = __webpack_require__(808);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _Input = __webpack_require__(149);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYS = {
	  ENTER: 'Enter',
	  ESC: 'Escape',
	  ARROW_UP: 'ArrowUp',
	  ARROW_DOWN: 'ArrowDown'
	};
	
	var factory = function factory(ProgressBar, Input) {
	  var Slider = function (_Component) {
	    _inherits(Slider, _Component);
	
	    function Slider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Slider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slider.__proto__ || Object.getPrototypeOf(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        inputFocused: false,
	        inputValue: null,
	        sliderLength: 0,
	        sliderStart: 0
	      }, _this.handleInputFocus = function () {
	        _this.setState({
	          inputFocused: true,
	          inputValue: _this.valueForInput(_this.props.value)
	        });
	      }, _this.handleInputChange = function (value) {
	        _this.setState({ inputValue: value });
	      }, _this.handleInputBlur = function (event) {
	        var value = _this.state.inputValue || 0;
	        _this.setState({ inputFocused: false, inputValue: null }, function () {
	          _this.props.onChange(_this.trimValue(value), event);
	        });
	      }, _this.handleKeyDown = function (event) {
	        var _this$props = _this.props,
	            disabled = _this$props.disabled,
	            step = _this$props.step;
	        var ARROW_DOWN = KEYS.ARROW_DOWN,
	            ARROW_UP = KEYS.ARROW_UP,
	            ENTER = KEYS.ENTER,
	            ESC = KEYS.ESC;
	
	
	        if (disabled) return;
	        if ([ENTER, ESC].includes(event.code)) _this.inputNode.blur();
	        if (event.code === ARROW_UP) _this.addToValue(step);
	        if (event.code === ARROW_DOWN) _this.addToValue(-step);
	      }, _this.handleMouseDown = function (event) {
	        if (_this.state.inputFocused) _this.inputNode.blur();
	        _events2.default.addEventsToDocument(_this.getMouseEventMap());
	        _this.start(_events2.default.getMousePosition(event));
	        _events2.default.pauseEvent(event);
	      }, _this.handleMouseMove = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.move(_events2.default.getMousePosition(event));
	      }, _this.handleMouseUp = function () {
	        _this.end(_this.getMouseEventMap());
	      }, _this.handleResize = function (event, callback) {
	        var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(_this.progressbarNode).getBoundingClientRect(),
	            left = _ReactDOM$findDOMNode.left,
	            right = _ReactDOM$findDOMNode.right;
	
	        var cb = callback || function () {};
	        _this.setState({ sliderStart: left, sliderLength: right - left }, cb);
	      }, _this.handleSliderBlur = function () {
	        _events2.default.removeEventsFromDocument(_this.getKeyboardEvents());
	      }, _this.handleSliderFocus = function () {
	        _events2.default.addEventsToDocument(_this.getKeyboardEvents());
	      }, _this.handleTouchEnd = function () {
	        _this.end(_this.getTouchEventMap());
	      }, _this.handleTouchMove = function (event) {
	        _this.move(_events2.default.getTouchPosition(event));
	      }, _this.handleTouchStart = function (event) {
	        if (_this.state.inputFocused) _this.inputNode.blur();
	        _this.start(_events2.default.getTouchPosition(event));
	        _events2.default.addEventsToDocument(_this.getTouchEventMap());
	        _events2.default.pauseEvent(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Slider, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this.handleResize);
	        this.handleResize();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.state.inputFocused && this.props.value !== nextProps.value) {
	          this.setState({ inputValue: this.valueForInput(nextProps.value) });
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return this.state.inputFocused || !nextState.inputFocused;
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if (nextState.pressed !== this.state.pressed) {
	          if (nextState.pressed) {
	            this.props.onDragStart();
	          } else {
	            this.props.onDragStop();
	          }
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.handleResize);
	        _events2.default.removeEventsFromDocument(this.getMouseEventMap());
	        _events2.default.removeEventsFromDocument(this.getTouchEventMap());
	        _events2.default.removeEventsFromDocument(this.getKeyboardEvents());
	      }
	    }, {
	      key: 'getKeyboardEvents',
	      value: function getKeyboardEvents() {
	        return {
	          keydown: this.handleKeyDown
	        };
	      }
	    }, {
	      key: 'getMouseEventMap',
	      value: function getMouseEventMap() {
	        return {
	          mousemove: this.handleMouseMove,
	          mouseup: this.handleMouseUp
	        };
	      }
	    }, {
	      key: 'getTouchEventMap',
	      value: function getTouchEventMap() {
	        return {
	          touchmove: this.handleTouchMove,
	          touchend: this.handleTouchEnd
	        };
	      }
	    }, {
	      key: 'addToValue',
	      value: function addToValue(increment) {
	        var value = this.state.inputFocused ? parseFloat(this.state.inputValue) : this.props.value;
	        value = this.trimValue(value + increment);
	        if (value !== this.props.value) this.props.onChange(value);
	      }
	    }, {
	      key: 'end',
	      value: function end(revents) {
	        _events2.default.removeEventsFromDocument(revents);
	        this.setState({ pressed: false });
	      }
	    }, {
	      key: 'knobOffset',
	      value: function knobOffset() {
	        var _props = this.props,
	            max = _props.max,
	            min = _props.min,
	            value = _props.value;
	
	        return 100 * ((value - min) / (max - min));
	      }
	    }, {
	      key: 'move',
	      value: function move(position) {
	        var newValue = this.positionToValue(position);
	        if (newValue !== this.props.value) this.props.onChange(newValue);
	      }
	    }, {
	      key: 'positionToValue',
	      value: function positionToValue(position) {
	        var _state = this.state,
	            start = _state.sliderStart,
	            length = _state.sliderLength;
	        var _props2 = this.props,
	            max = _props2.max,
	            min = _props2.min,
	            step = _props2.step;
	
	        var pos = (position.x - start) / length * (max - min);
	        return this.trimValue(Math.round(pos / step) * step + min);
	      }
	    }, {
	      key: 'start',
	      value: function start(position) {
	        var _this2 = this;
	
	        this.handleResize(null, function () {
	          _this2.setState({ pressed: true });
	          _this2.props.onChange(_this2.positionToValue(position));
	        });
	      }
	    }, {
	      key: 'stepDecimals',
	      value: function stepDecimals() {
	        return (this.props.step.toString().split('.')[1] || []).length;
	      }
	    }, {
	      key: 'trimValue',
	      value: function trimValue(value) {
	        if (value < this.props.min) return this.props.min;
	        if (value > this.props.max) return this.props.max;
	        return (0, _utils.round)(value, this.stepDecimals());
	      }
	    }, {
	      key: 'valueForInput',
	      value: function valueForInput(value) {
	        var decimals = this.stepDecimals();
	        return decimals > 0 ? value.toFixed(decimals) : value.toString();
	      }
	    }, {
	      key: 'renderSnaps',
	      value: function renderSnaps() {
	        var _this3 = this;
	
	        if (!this.props.snaps) return undefined;
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.theme.snaps },
	          (0, _utils.range)(0, (this.props.max - this.props.min) / this.props.step).map(function (i) {
	            return _react2.default.createElement('div', { key: 'span-' + i, className: _this3.props.theme.snap });
	          })
	        );
	      }
	    }, {
	      key: 'renderInput',
	      value: function renderInput() {
	        var _this4 = this;
	
	        if (!this.props.editable) return undefined;
	        return _react2.default.createElement(Input, {
	          innerRef: function innerRef(node) {
	            _this4.inputNode = node;
	          },
	          className: this.props.theme.input,
	          disabled: this.props.disabled,
	          onFocus: this.handleInputFocus,
	          onChange: this.handleInputChange,
	          onBlur: this.handleInputBlur,
	          value: this.state.inputFocused ? this.state.inputValue : this.valueForInput(this.props.value)
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this5 = this;
	
	        var theme = this.props.theme;
	
	        var knobStyles = { left: this.knobOffset() + '%' };
	        var className = (0, _classnames3.default)(theme.slider, (_classnames = {}, _defineProperty(_classnames, theme.editable, this.props.editable), _defineProperty(_classnames, theme.disabled, this.props.disabled), _defineProperty(_classnames, theme.pinned, this.props.pinned), _defineProperty(_classnames, theme.pressed, this.state.pressed), _defineProperty(_classnames, theme.ring, this.props.value === this.props.min), _classnames), this.props.className);
	
	        return _react2.default.createElement(
	          'div',
	          {
	            className: className,
	            disabled: this.props.disabled,
	            'data-react-toolbox': 'slider',
	            onBlur: this.handleSliderBlur,
	            onFocus: this.handleSliderFocus,
	            style: this.props.style,
	            tabIndex: '0'
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              ref: function ref(node) {
	                _this5.sliderNode = node;
	              },
	              className: theme.container,
	              onMouseDown: this.handleMouseDown,
	              onTouchStart: this.handleTouchStart
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  _this5.knobNode = node;
	                },
	                className: theme.knob,
	                onMouseDown: this.handleMouseDown,
	                onTouchStart: this.handleTouchStart,
	                style: knobStyles
	              },
	              _react2.default.createElement('div', { className: theme.innerknob, 'data-value': parseInt(this.props.value, 10) })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: theme.progress },
	              _react2.default.createElement(ProgressBar, {
	                disabled: this.props.disabled,
	                ref: function ref(node) {
	                  _this5.progressbarNode = node;
	                },
	                className: theme.innerprogress,
	                max: this.props.max,
	                min: this.props.min,
	                mode: 'determinate',
	                value: this.props.value,
	                buffer: this.props.buffer
	              }),
	              this.renderSnaps()
	            )
	          ),
	          this.renderInput()
	        );
	      }
	    }]);
	
	    return Slider;
	  }(_react.Component);
	
	  Slider.propTypes = {
	    buffer: _propTypes2.default.number,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    editable: _propTypes2.default.bool,
	    max: _propTypes2.default.number,
	    min: _propTypes2.default.number,
	    onChange: _propTypes2.default.func,
	    onDragStart: _propTypes2.default.func,
	    onDragStop: _propTypes2.default.func,
	    pinned: _propTypes2.default.bool,
	    snaps: _propTypes2.default.bool,
	    step: _propTypes2.default.number,
	    style: _reactStyleProptype2.default,
	    theme: _propTypes2.default.shape({
	      container: _propTypes2.default.string,
	      editable: _propTypes2.default.string,
	      innerknob: _propTypes2.default.string,
	      innerprogress: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      knob: _propTypes2.default.string,
	      pinned: _propTypes2.default.string,
	      pressed: _propTypes2.default.string,
	      progress: _propTypes2.default.string,
	      ring: _propTypes2.default.string,
	      slider: _propTypes2.default.string,
	      snap: _propTypes2.default.string,
	      snaps: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.number
	  };
	  Slider.defaultProps = {
	    buffer: 0,
	    className: '',
	    editable: false,
	    max: 100,
	    min: 0,
	    onDragStart: function onDragStart() {},
	    onDragStop: function onDragStop() {},
	    pinned: false,
	    snaps: false,
	    step: 0.01,
	    value: 0
	  };
	
	
	  return Slider;
	};
	
	var Slider = factory(_ProgressBar2.default, _Input2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.SLIDER)(Slider);
	exports.sliderFactory = factory;
	exports.Slider = Slider;

/***/ },
/* 2401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _progress_bar = __webpack_require__(253);
	
	var _input = __webpack_require__(33);
	
	var _Slider = __webpack_require__(2400);
	
	var _theme = __webpack_require__(1451);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedSlider = (0, _reactCssThemr.themr)(_identifiers.SLIDER, _theme2.default)((0, _Slider.sliderFactory)(_progress_bar.ProgressBar, _input.Input));
	exports.default = ThemedSlider;
	exports.Slider = ThemedSlider;

/***/ },
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Snackbar = exports.snackbarFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _ActivableRenderer = __webpack_require__(374);
	
	var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);
	
	var _Button = __webpack_require__(247);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Portal = __webpack_require__(250);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Button) {
	  var Snackbar = function (_Component) {
	    _inherits(Snackbar, _Component);
	
	    function Snackbar() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Snackbar);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.scheduleTimeout = function (props) {
	        var onTimeout = props.onTimeout,
	            timeout = props.timeout;
	
	        if (_this.curTimeout) clearTimeout(_this.curTimeout);
	        _this.curTimeout = setTimeout(function () {
	          if (onTimeout) onTimeout();
	          _this.curTimeout = null;
	        }, timeout);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Snackbar, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.active && this.props.timeout) {
	          this.scheduleTimeout(this.props);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.active && nextProps.timeout) {
	          this.scheduleTimeout(nextProps);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        clearTimeout(this.curTimeout);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            action = _props.action,
	            active = _props.active,
	            children = _props.children,
	            label = _props.label,
	            onClick = _props.onClick,
	            theme = _props.theme,
	            type = _props.type;
	
	        var className = (0, _classnames3.default)([theme.snackbar, theme[type]], _defineProperty({}, theme.active, active), this.props.className);
	
	        return _react2.default.createElement(
	          _Portal2.default,
	          { className: theme.portal },
	          _react2.default.createElement(
	            'div',
	            { 'data-react-toolbox': 'snackbar', className: className },
	            _react2.default.createElement(
	              'span',
	              { className: theme.label },
	              label,
	              children
	            ),
	            action ? _react2.default.createElement(Button, { className: theme.button, label: action, onClick: onClick }) : null
	          )
	        );
	      }
	    }]);
	
	    return Snackbar;
	  }(_react.Component);
	
	  Snackbar.propTypes = {
	    action: _propTypes2.default.string,
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    onClick: _propTypes2.default.func,
	    onTimeout: _propTypes2.default.func, // eslint-disable-line
	    theme: _propTypes2.default.shape({
	      accept: _propTypes2.default.string,
	      active: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      cancel: _propTypes2.default.string,
	      label: _propTypes2.default.string,
	      snackbar: _propTypes2.default.string,
	      warning: _propTypes2.default.string
	    }),
	    timeout: _propTypes2.default.number,
	    type: _propTypes2.default.oneOf(['accept', 'cancel', 'warning'])
	  };
	
	
	  return (0, _ActivableRenderer2.default)()(Snackbar);
	};
	
	var Snackbar = factory(_Button2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.SNACKBAR)(Snackbar);
	exports.snackbarFactory = factory;
	exports.Snackbar = Snackbar;

/***/ },
/* 2403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Snackbar = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Snackbar = __webpack_require__(2402);
	
	var _button = __webpack_require__(31);
	
	var _theme = __webpack_require__(1452);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedSnackbar = (0, _reactCssThemr.themr)(_identifiers.SNACKBAR, _theme2.default)((0, _Snackbar.snackbarFactory)(_button.Button));
	
	exports.default = ThemedSnackbar;
	exports.Snackbar = ThemedSnackbar;

/***/ },
/* 2404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Switch = exports.switchFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _Ripple = __webpack_require__(84);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	var _Thumb = __webpack_require__(811);
	
	var _Thumb2 = _interopRequireDefault(_Thumb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Thumb) {
	  var Switch = function (_Component) {
	    _inherits(Switch, _Component);
	
	    function Switch() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Switch);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.handleToggle = function (event) {
	        if (event.pageX !== 0 && event.pageY !== 0) _this.blur();
	        if (!_this.props.disabled && _this.props.onChange) {
	          _this.props.onChange(!_this.props.checked, event);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Switch, [{
	      key: 'blur',
	      value: function blur() {
	        this.inputNode.blur();
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this.inputNode.focus();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            checked = _props.checked,
	            className = _props.className,
	            disabled = _props.disabled,
	            onChange = _props.onChange,
	            ripple = _props.ripple,
	            theme = _props.theme,
	            others = _objectWithoutProperties(_props, ['checked', 'className', 'disabled', 'onChange', 'ripple', 'theme']);
	
	        var _className = (0, _classnames2.default)(theme[disabled ? 'disabled' : 'field'], className);
	        return _react2.default.createElement(
	          'label',
	          { 'data-react-toolbox': 'switch', className: _className },
	          _react2.default.createElement('input', _extends({}, others, {
	            checked: this.props.checked,
	            className: theme.input,
	            onClick: this.handleToggle,
	            readOnly: true,
	            ref: function ref(node) {
	              _this2.inputNode = node;
	            },
	            type: 'checkbox'
	          })),
	          _react2.default.createElement(
	            'span',
	            { className: theme[checked ? 'on' : 'off'] },
	            _react2.default.createElement(Thumb, { disabled: this.props.disabled, theme: theme, ripple: ripple })
	          ),
	          this.props.label ? _react2.default.createElement(
	            'span',
	            { className: theme.text },
	            this.props.label
	          ) : null
	        );
	      }
	    }]);
	
	    return Switch;
	  }(_react.Component);
	
	  Switch.propTypes = {
	    checked: _propTypes2.default.bool,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    label: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    ripple: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      disabled: _propTypes2.default.string,
	      field: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      off: _propTypes2.default.string,
	      on: _propTypes2.default.string,
	      ripple: _propTypes2.default.string,
	      text: _propTypes2.default.string,
	      thumb: _propTypes2.default.string
	    })
	  };
	  Switch.defaultProps = {
	    checked: false,
	    className: '',
	    disabled: false
	  };
	
	
	  return Switch;
	};
	
	var Thumb = (0, _Thumb2.default)((0, _Ripple2.default)({ centered: true, spread: 2.6 }));
	var Switch = factory(Thumb);
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.SWITCH)(Switch);
	exports.switchFactory = factory;
	exports.Switch = Switch;

/***/ },
/* 2405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Table = exports.tableFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(3);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _filterReactChildren = __webpack_require__(820);
	
	var _filterReactChildren2 = _interopRequireDefault(_filterReactChildren);
	
	var _isComponentOfType = __webpack_require__(181);
	
	var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);
	
	var _identifiers = __webpack_require__(9);
	
	var _TableHead = __webpack_require__(813);
	
	var _TableHead2 = _interopRequireDefault(_TableHead);
	
	var _TableRow = __webpack_require__(814);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(TableHead, TableRow) {
	  var isTableHead = function isTableHead(child) {
	    return (0, _isComponentOfType2.default)(TableHead, child);
	  };
	  var isTableRow = function isTableRow(child) {
	    return (0, _isComponentOfType2.default)(TableRow, child);
	  };
	
	  var Table = function (_Component) {
	    _inherits(Table, _Component);
	
	    function Table() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Table);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.getRowTuples = function () {
	        return _react2.default.Children.toArray((0, _filterReactChildren2.default)(_this.props.children, isTableRow)).map(function (child, index) {
	          return [index, Boolean(child.props.selected)];
	        });
	      }, _this.handleHeadSelect = function (value) {
	        if (_this.props.onRowSelect) {
	          _this.props.onRowSelect(value ? _this.getRowTuples().map(function (item) {
	            return item[0];
	          }) : []);
	        }
	      }, _this.handleRowSelect = function (idx) {
	        if (_this.props.onRowSelect) {
	          if (_this.props.multiSelectable) {
	            var current = _this.getRowTuples().filter(function (item) {
	              return item[1];
	            }).map(function (item) {
	              return item[0];
	            });
	            var rowIndex = current.indexOf(idx);
	            var indexes = rowIndex !== -1 ? [].concat(_toConsumableArray(current.slice(0, rowIndex)), _toConsumableArray(current.slice(rowIndex + 1))) : [].concat(_toConsumableArray(current), [idx]);
	            _this.props.onRowSelect(indexes);
	          } else {
	            _this.props.onRowSelect([idx]);
	          }
	        }
	      }, _this.renderHead = function () {
	        var tuples = _this.getRowTuples();
	        var selected = tuples.filter(function (item) {
	          return item[1];
	        }).length === tuples.length;
	        return _react2.default.Children.map((0, _filterReactChildren2.default)(_this.props.children, isTableHead), function (child) {
	          return (0, _react.cloneElement)(child, {
	            selected: selected,
	            multiSelectable: _this.props.multiSelectable,
	            onSelect: _this.handleHeadSelect,
	            selectable: _this.props.selectable
	          });
	        });
	      }, _this.renderRows = function () {
	        return _react2.default.Children.map((0, _filterReactChildren2.default)(_this.props.children, isTableRow), function (child, idx) {
	          return (0, _react.cloneElement)(child, {
	            idx: idx,
	            onSelect: _this.handleRowSelect,
	            selectable: _this.props.selectable
	          });
	        });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Table, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            multiSelectable = _props.multiSelectable,
	            onRowSelect = _props.onRowSelect,
	            selectable = _props.selectable,
	            theme = _props.theme,
	            rest = _objectWithoutProperties(_props, ['className', 'multiSelectable', 'onRowSelect', 'selectable', 'theme']);
	
	        return _react2.default.createElement(
	          'table',
	          _extends({}, rest, { className: (0, _classnames2.default)(theme.table, className) }),
	          _react2.default.createElement(
	            'thead',
	            { className: theme.head },
	            this.renderHead()
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.renderRows()
	          )
	        );
	      }
	    }]);
	
	    return Table;
	  }(_react.Component);
	
	  Table.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    multiSelectable: _propTypes2.default.bool,
	    onRowSelect: _propTypes2.default.func,
	    selectable: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      head: _propTypes2.default.string,
	      table: _propTypes2.default.string
	    })
	  };
	  Table.defaultProps = {
	    className: '',
	    multiSelectable: false,
	    selectable: true
	  };
	
	
	  return Table;
	};
	
	var Table = factory(_TableHead2.default, _TableRow2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TABLE)(Table);
	exports.tableFactory = factory;
	exports.Table = Table;

/***/ },
/* 2406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TableCell = exports.TableRow = exports.TableHead = exports.Table = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _checkbox = __webpack_require__(369);
	
	var _font_icon = __webpack_require__(794);
	
	var _Table = __webpack_require__(2405);
	
	var _TableHead = __webpack_require__(813);
	
	var _TableRow = __webpack_require__(814);
	
	var _TableCell = __webpack_require__(376);
	
	var _theme = __webpack_require__(1454);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyTheme = function applyTheme(Component) {
	  return (0, _reactCssThemr.themr)(_identifiers.TABLE, _theme2.default)(Component);
	};
	var ThemedTableCell = applyTheme((0, _TableCell.tableCellFactory)(_font_icon.FontIcon));
	var ThemedTableHead = applyTheme((0, _TableHead.tableHeadFactory)(_checkbox.Checkbox, ThemedTableCell));
	var ThemedTableRow = applyTheme((0, _TableRow.tableRowFactory)(_checkbox.Checkbox, ThemedTableCell));
	var ThemedTable = applyTheme((0, _Table.tableFactory)(ThemedTableHead, ThemedTableRow));
	
	exports.default = ThemedTable;
	exports.Table = ThemedTable;
	exports.TableHead = ThemedTableHead;
	exports.TableRow = ThemedTableRow;
	exports.TableCell = ThemedTableCell;

/***/ },
/* 2407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tabs = exports.tabsFactory = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames3 = __webpack_require__(3);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _FontIcon = __webpack_require__(45);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _isComponentOfType = __webpack_require__(181);
	
	var _isComponentOfType2 = _interopRequireDefault(_isComponentOfType);
	
	var _Tab = __webpack_require__(815);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabContent = __webpack_require__(816);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Tab, TabContent, FontIcon) {
	  var isTab = function isTab(child) {
	    return (0, _isComponentOfType2.default)(Tab, child);
	  };
	  var isTabContent = function isTabContent(child) {
	    return (0, _isComponentOfType2.default)(TabContent, child);
	  };
	
	  var Tabs = function (_Component) {
	    _inherits(Tabs, _Component);
	
	    function Tabs() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Tabs);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        pointer: {},
	        arrows: {}
	      }, _this.handleHeaderClick = function (idx) {
	        if (_this.props.onChange) {
	          _this.props.onChange(idx);
	        }
	      }, _this.handleResize = function () {
	        if (_this.resizeTimeout) clearTimeout(_this.resizeTimeout);
	        _this.resizeTimeout = setTimeout(function () {
	          _this.updatePointer(_this.props.index);
	          _this.updateArrows();
	        }, 100);
	      }, _this.updatePointer = function (idx) {
	        if (_this.navigationNode && _this.navigationNode.children[idx]) {
	          _this.updatePointerAnimationFrame = window.requestAnimationFrame(function () {
	            var nav = _this.navigationNode.getBoundingClientRect();
	            var label = _this.navigationNode.children[idx].getBoundingClientRect();
	            var scrollLeft = _this.navigationNode.scrollLeft;
	            _this.setState({
	              pointer: {
	                top: nav.height + 'px',
	                left: label.left + scrollLeft - nav.left + 'px',
	                width: label.width + 'px'
	              }
	            });
	          });
	        }
	      }, _this.updateArrows = function () {
	        var idx = _this.navigationNode.children.length - 2;
	
	        if (idx >= 0) {
	          var scrollLeft = _this.navigationNode.scrollLeft;
	          var nav = _this.navigationNode.getBoundingClientRect();
	          var lastLabel = _this.navigationNode.children[idx].getBoundingClientRect();
	
	          _this.setState({
	            arrows: {
	              left: scrollLeft > 0,
	              right: nav.right < lastLabel.right - 5
	            }
	          });
	        }
	      }, _this.scrollNavigation = function (factor) {
	        var oldScrollLeft = _this.navigationNode.scrollLeft;
	        _this.navigationNode.scrollLeft += factor * _this.navigationNode.clientWidth;
	        if (_this.navigationNode.scrollLeft !== oldScrollLeft) {
	          _this.updateArrows();
	        }
	      }, _this.scrollRight = function () {
	        return _this.scrollNavigation(-1);
	      }, _this.scrollLeft = function () {
	        return _this.scrollNavigation(+1);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Tabs, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this.handleResize);
	        this.handleResize();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            index = _props.index,
	            children = _props.children;
	        var prevIndex = prevProps.index,
	            prevChildren = prevProps.children;
	
	
	        if (index !== prevIndex || children !== prevChildren) {
	          this.updatePointer(index);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.handleResize);
	        clearTimeout(this.resizeTimeout);
	        if (this.updatePointerAnimationFrame) cancelAnimationFrame(this.updatePointerAnimationFrame);
	      }
	    }, {
	      key: 'parseChildren',
	      value: function parseChildren() {
	        var _this2 = this;
	
	        var headers = [];
	        var contents = [];
	
	        _react2.default.Children.forEach(this.props.children, function (item) {
	          if (isTab(item)) {
	            headers.push(item);
	            if (item.props.children) {
	              contents.push(_react2.default.createElement(
	                TabContent,
	                { theme: _this2.props.theme },
	                item.props.children
	              ));
	            }
	          } else if (isTabContent(item)) {
	            contents.push(item);
	          }
	        });
	
	        return { headers: headers, contents: contents };
	      }
	    }, {
	      key: 'renderHeaders',
	      value: function renderHeaders(headers) {
	        var _this3 = this;
	
	        return headers.map(function (item, idx) {
	          return _react2.default.cloneElement(item, {
	            children: null,
	            key: idx, // eslint-disable-line
	            index: idx,
	            theme: _this3.props.theme,
	            active: _this3.props.index === idx,
	            onClick: function onClick(event, index) {
	              _this3.handleHeaderClick(index);
	              if (item.props.onClick) item.props.onClick(event);
	            }
	          });
	        });
	      }
	    }, {
	      key: 'renderContents',
	      value: function renderContents(contents) {
	        var _this4 = this;
	
	        var contentElements = contents.map(function (item, idx) {
	          return _react2.default.cloneElement(item, {
	            key: idx, // eslint-disable-line
	            theme: _this4.props.theme,
	            active: _this4.props.index === idx,
	            hidden: _this4.props.index !== idx && _this4.props.hideMode === 'display',
	            tabIndex: idx
	          });
	        });
	
	        return this.props.hideMode === 'display' ? contentElements : contentElements.filter(function (item, idx) {
	          return idx === _this4.props.index;
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames2,
	            _this5 = this;
	
	        var _props2 = this.props,
	            className = _props2.className,
	            disableAnimatedBottomBorder = _props2.disableAnimatedBottomBorder,
	            theme = _props2.theme,
	            fixed = _props2.fixed,
	            inverse = _props2.inverse;
	        var _state$arrows = this.state.arrows,
	            hasLeftArrow = _state$arrows.left,
	            hasRightArrow = _state$arrows.right;
	
	        var _parseChildren = this.parseChildren(),
	            headers = _parseChildren.headers,
	            contents = _parseChildren.contents;
	
	        var classNamePointer = (0, _classnames4.default)(theme.pointer, _defineProperty({}, theme.disableAnimation, disableAnimatedBottomBorder));
	
	        var classNames = (0, _classnames4.default)(theme.tabs, (_classnames2 = {}, _defineProperty(_classnames2, theme.fixed, fixed), _defineProperty(_classnames2, theme.inverse, inverse), _classnames2), className);
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'tabs', className: classNames },
	          _react2.default.createElement(
	            'div',
	            { className: theme.navigationContainer },
	            hasLeftArrow && _react2.default.createElement(
	              'div',
	              { className: theme.arrowContainer, onClick: this.scrollRight },
	              _react2.default.createElement(FontIcon, { className: theme.arrow, value: 'keyboard_arrow_left' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: theme.navigation, role: 'tablist', ref: function ref(node) {
	                  _this5.navigationNode = node;
	                } },
	              this.renderHeaders(headers),
	              _react2.default.createElement('span', { className: classNamePointer, style: this.state.pointer })
	            ),
	            hasRightArrow && _react2.default.createElement(
	              'div',
	              { className: theme.arrowContainer, onClick: this.scrollLeft },
	              _react2.default.createElement(FontIcon, { className: theme.arrow, value: 'keyboard_arrow_right' })
	            )
	          ),
	          this.renderContents(contents)
	        );
	      }
	    }]);
	
	    return Tabs;
	  }(_react.Component);
	
	  Tabs.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disableAnimatedBottomBorder: _propTypes2.default.bool,
	    fixed: _propTypes2.default.bool,
	    hideMode: _propTypes2.default.oneOf(['display', 'unmounted']),
	    index: _propTypes2.default.number,
	    inverse: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      arrow: _propTypes2.default.string,
	      arrowContainer: _propTypes2.default.string,
	      disableAnimation: _propTypes2.default.string,
	      fixed: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      navigation: _propTypes2.default.string,
	      navigationContainer: _propTypes2.default.string,
	      pointer: _propTypes2.default.string,
	      tabs: _propTypes2.default.string
	    })
	  };
	  Tabs.defaultProps = {
	    index: 0,
	    fixed: false,
	    inverse: false,
	    hideMode: 'unmounted'
	  };
	
	
	  return Tabs;
	};
	
	var Tabs = factory(_Tab2.default, _TabContent2.default, _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TABS)(Tabs);
	exports.tabsFactory = factory;
	exports.Tabs = Tabs;

/***/ },
/* 2408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(846);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransition = __webpack_require__(845);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _utils = __webpack_require__(60);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _ClockHours = __webpack_require__(2409);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(2410);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Clock = function (_Component) {
	  _inherits(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Clock.__proto__ || Object.getPrototypeOf(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      center: { x: null, y: null },
	      radius: 0
	    }, _this.handleHourChange = function (hours) {
	      if (_this.props.time.getHours() !== hours) {
	        _this.props.onChange(_time2.default.setHours(_this.props.time, _this.adaptHourToFormat(hours)));
	      }
	    }, _this.handleMinuteChange = function (minutes) {
	      if (_this.props.time.getMinutes() !== minutes) {
	        _this.props.onChange(_time2.default.setMinutes(_this.props.time, minutes));
	      }
	    }, _this.handleCalculateShape = function () {
	      var _this$placeholderNode = _this.placeholderNode.getBoundingClientRect(),
	          top = _this$placeholderNode.top,
	          left = _this$placeholderNode.left,
	          width = _this$placeholderNode.width;
	
	      _this.setState({
	        center: {
	          x: left + (width / 2 - window.pageXOffset),
	          y: top + (width / 2 - window.pageXOffset)
	        },
	        radius: width / 2
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Clock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      window.addEventListener('resize', this.handleCalculateShape);
	      setTimeout(function () {
	        _this2.handleCalculateShape();
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleCalculateShape);
	    }
	  }, {
	    key: 'adaptHourToFormat',
	    value: function adaptHourToFormat(hour) {
	      if (this.props.format === 'ampm') {
	        if (_time2.default.getTimeMode(this.props.time) === 'pm') {
	          return hour < 12 ? hour + 12 : hour;
	        }
	        return hour === 12 ? 0 : hour;
	      }
	      return hour;
	    }
	  }, {
	    key: 'renderHours',
	    value: function renderHours() {
	      return _react2.default.createElement(_ClockHours2.default, {
	        center: this.state.center,
	        format: this.props.format,
	        onChange: this.handleHourChange,
	        radius: this.state.radius,
	        selected: this.props.time.getHours(),
	        spacing: this.state.radius * 0.18,
	        onHandMoved: this.props.onHandMoved,
	        theme: this.props.theme
	      });
	    }
	  }, {
	    key: 'renderMinutes',
	    value: function renderMinutes() {
	      return _react2.default.createElement(_ClockMinutes2.default, {
	        center: this.state.center,
	        onChange: this.handleMinuteChange,
	        radius: this.state.radius,
	        selected: this.props.time.getMinutes(),
	        spacing: this.state.radius * 0.18,
	        onHandMoved: this.props.onHandMoved,
	        theme: this.props.theme
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var theme = this.props.theme;
	
	      var animation = this.state.display === 'hours' ? 'zoomOut' : 'zoomIn';
	      var animationModule = (0, _utils.getAnimationModule)(animation, theme);
	      return _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'clock', className: theme.clock },
	        _react2.default.createElement(
	          'div',
	          {
	            className: theme.placeholder,
	            style: { height: this.state.radius * 2 },
	            ref: function ref(node) {
	              _this3.placeholderNode = node;
	            }
	          },
	          _react2.default.createElement(
	            _TransitionGroup2.default,
	            null,
	            _react2.default.createElement(
	              _CSSTransition2.default,
	              { classNames: animationModule, timeout: 500 },
	              _react2.default.createElement(
	                'div',
	                {
	                  key: this.props.display,
	                  className: theme.clockWrapper,
	                  style: { height: this.state.radius * 2 }
	                },
	                this.props.display === 'hours' ? this.renderHours() : null,
	                this.props.display === 'minutes' ? this.renderMinutes() : null
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Clock;
	}(_react.Component);
	
	Clock.propTypes = {
	  display: _propTypes2.default.oneOf(['hours', 'minutes']),
	  format: _propTypes2.default.oneOf(['24hr', 'ampm']),
	  onChange: _propTypes2.default.func,
	  onHandMoved: _propTypes2.default.func,
	  theme: _propTypes2.default.shape({
	    clock: _propTypes2.default.string,
	    clockWrapper: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string
	  }),
	  time: _propTypes2.default.instanceOf(Date)
	};
	Clock.defaultProps = {
	  className: '',
	  display: 'hours',
	  format: '24hr',
	  time: new Date()
	};
	exports.default = Clock;

/***/ },
/* 2409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(60);
	
	var _ClockHand = __webpack_require__(818);
	
	var _ClockHand2 = _interopRequireDefault(_ClockHand);
	
	var _ClockFace = __webpack_require__(817);
	
	var _ClockFace2 = _interopRequireDefault(_ClockFace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var outerNumbers = [0].concat(_toConsumableArray((0, _utils.range)(13, 24)));
	var innerNumbers = [12].concat(_toConsumableArray((0, _utils.range)(1, 12)));
	var innerSpacing = 1.7;
	var step = 360 / 12;
	
	var Hours = function (_Component) {
	  _inherits(Hours, _Component);
	
	  function Hours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hours.__proto__ || Object.getPrototypeOf(Hours)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: _this.props.format === '24hr' && _this.props.selected > 0 && _this.props.selected <= 12
	    }, _this.handleHandMove = function (degrees, radius) {
	      var currentInner = radius < _this.props.radius - _this.props.spacing * innerSpacing;
	      if (_this.props.format === '24hr' && _this.state.inner !== currentInner) {
	        _this.setState({ inner: currentInner }, function () {
	          _this.props.onChange(_this.valueFromDegrees(degrees));
	        });
	      } else {
	        _this.props.onChange(_this.valueFromDegrees(degrees));
	      }
	    }, _this.handleMouseDown = function (event) {
	      _this.handNode.mouseStart(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.handNode.touchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hours, [{
	    key: 'valueFromDegrees',
	    value: function valueFromDegrees(degrees) {
	      if (this.props.format === 'ampm' || this.props.format === '24hr' && this.state.inner) {
	        return innerNumbers[degrees / step];
	      }
	      return outerNumbers[degrees / step];
	    }
	  }, {
	    key: 'renderInnerFace',
	    value: function renderInnerFace(innerRadius) {
	      if (this.props.format !== '24hr') return undefined;
	      return _react2.default.createElement(_ClockFace2.default, {
	        onTouchStart: this.handleTouchStart,
	        onMouseDown: this.handleMouseDown,
	        numbers: innerNumbers,
	        spacing: this.props.spacing,
	        radius: innerRadius,
	        theme: this.props.theme,
	        active: this.props.selected
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          format = _props.format,
	          selected = _props.selected,
	          radius = _props.radius,
	          spacing = _props.spacing,
	          center = _props.center,
	          onHandMoved = _props.onHandMoved;
	
	      var is24hr = format === '24hr';
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ClockFace2.default, {
	          onTouchStart: this.handleTouchStart,
	          onMouseDown: this.handleMouseDown,
	          numbers: is24hr ? outerNumbers : innerNumbers,
	          spacing: spacing,
	          radius: radius,
	          twoDigits: is24hr,
	          active: is24hr ? selected : selected % 12 || 12,
	          theme: this.props.theme
	        }),
	        this.renderInnerFace(radius - spacing * innerSpacing),
	        _react2.default.createElement(_ClockHand2.default, {
	          ref: function ref(node) {
	            _this2.handNode = node;
	          },
	          angle: selected * step,
	          length: (this.state.inner ? radius - spacing * innerSpacing : radius) - spacing,
	          onMove: this.handleHandMove,
	          theme: this.props.theme,
	          onMoved: onHandMoved,
	          origin: center,
	          step: step
	        })
	      );
	    }
	  }]);
	
	  return Hours;
	}(_react.Component);
	
	Hours.propTypes = {
	  center: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  format: _propTypes2.default.oneOf(['24hr', 'ampm']),
	  onChange: _propTypes2.default.func,
	  onHandMoved: _propTypes2.default.func,
	  radius: _propTypes2.default.number,
	  selected: _propTypes2.default.number,
	  spacing: _propTypes2.default.number,
	  theme: _propTypes2.default.object // eslint-disable-line
	};
	exports.default = Hours;

/***/ },
/* 2410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(60);
	
	var _ClockHand = __webpack_require__(818);
	
	var _ClockHand2 = _interopRequireDefault(_ClockHand);
	
	var _ClockFace = __webpack_require__(817);
	
	var _ClockFace2 = _interopRequireDefault(_ClockFace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var minutes = (0, _utils.range)(0, 60, 5);
	var step = 360 / 60;
	
	var Minutes = function (_Component) {
	  _inherits(Minutes, _Component);
	
	  function Minutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Minutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Minutes.__proto__ || Object.getPrototypeOf(Minutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleHandMove = function (degrees) {
	      _this.props.onChange(degrees / step);
	    }, _this.handleMouseDown = function (event) {
	      _this.handNode.mouseStart(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.handNode.touchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Minutes, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ClockFace2.default, {
	          onTouchStart: this.handleTouchStart,
	          onMouseDown: this.handleMouseDown,
	          numbers: minutes,
	          spacing: this.props.spacing,
	          radius: this.props.radius,
	          active: this.props.selected,
	          theme: this.props.theme,
	          twoDigits: true
	        }),
	        _react2.default.createElement(_ClockHand2.default, {
	          ref: function ref(node) {
	            _this2.handNode = node;
	          },
	          className: minutes.indexOf(this.props.selected) === -1 ? this.props.theme.small : '',
	          angle: this.props.selected * step,
	          length: this.props.radius - this.props.spacing,
	          onMove: this.handleHandMove,
	          origin: this.props.center,
	          theme: this.props.theme,
	          step: step
	        })
	      );
	    }
	  }]);
	
	  return Minutes;
	}(_react.Component);
	
	Minutes.propTypes = {
	  center: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  onChange: _propTypes2.default.func,
	  radius: _propTypes2.default.number,
	  selected: _propTypes2.default.number,
	  spacing: _propTypes2.default.number,
	  theme: _propTypes2.default.shape({
	    small: _propTypes2.default.string
	  })
	};
	Minutes.defaultProps = {
	  selected: 0,
	  onChange: null
	};
	exports.default = Minutes;

/***/ },
/* 2411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimePicker = exports.timePickerFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _Dialog = __webpack_require__(370);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Input = __webpack_require__(149);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _TimePickerDialog = __webpack_require__(819);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(TimePickerDialog, Input) {
	  var TimePicker = function (_Component) {
	    _inherits(TimePicker, _Component);
	
	    function TimePicker() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TimePicker);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        active: _this.props.active
	      }, _this.handleDismiss = function () {
	        _this.setState({ active: false });
	        if (_this.props.onDismiss) {
	          _this.props.onDismiss();
	        }
	      }, _this.handleInputFocus = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	      }, _this.handleInputBlur = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: false });
	      }, _this.handleInputClick = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	        if (_this.props.onClick) _this.props.onClick(event);
	      }, _this.handleInputKeyPress = function (event) {
	        if (event.charCode === 13) {
	          _events2.default.pauseEvent(event);
	          _this.setState({ active: true });
	        }
	        if (_this.props.onKeyPress) _this.props.onKeyPress(event);
	      }, _this.handleSelect = function (value, event) {
	        if (_this.props.onChange) _this.props.onChange(value, event);
	        _this.setState({ active: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TimePicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.active !== this.props.active && this.state.active !== nextProps.active) {
	          this.setState({ active: nextProps.active });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            onDismiss = _props.onDismiss,
	            cancelLabel = _props.cancelLabel,
	            format = _props.format,
	            inputClassName = _props.inputClassName,
	            okLabel = _props.okLabel,
	            onEscKeyDown = _props.onEscKeyDown,
	            onOverlayClick = _props.onOverlayClick,
	            readonly = _props.readonly,
	            value = _props.value,
	            others = _objectWithoutProperties(_props, ['active', 'onDismiss', 'cancelLabel', 'format', 'inputClassName', 'okLabel', 'onEscKeyDown', 'onOverlayClick', 'readonly', 'value']);
	
	        var formattedTime = value ? _time2.default.formatTime(value, format) : '';
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'time-picker', className: this.props.theme.container },
	          _react2.default.createElement(Input, _extends({}, others, {
	            className: (0, _classnames3.default)(this.props.theme.input, _defineProperty({}, inputClassName, inputClassName)),
	            disabled: readonly,
	            error: this.props.error,
	            label: this.props.label,
	            name: this.props.name,
	            onKeyPress: this.handleInputKeyPress,
	            onClick: this.handleInputClick,
	            readOnly: true,
	            type: 'text',
	            value: formattedTime
	          })),
	          _react2.default.createElement(TimePickerDialog, {
	            active: this.state.active,
	            cancelLabel: cancelLabel,
	            className: this.props.className,
	            format: format,
	            name: this.props.name,
	            okLabel: okLabel,
	            onDismiss: this.handleDismiss,
	            onEscKeyDown: onEscKeyDown || this.handleDismiss,
	            onOverlayClick: onOverlayClick || this.handleDismiss,
	            onSelect: this.handleSelect,
	            theme: this.props.theme,
	            value: this.props.value
	          })
	        );
	      }
	    }]);
	
	    return TimePicker;
	  }(_react.Component);
	
	  TimePicker.propTypes = {
	    active: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    error: _propTypes2.default.string,
	    format: _propTypes2.default.oneOf(['24hr', 'ampm']),
	    inputClassName: _propTypes2.default.string,
	    label: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    readonly: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      container: _propTypes2.default.string,
	      input: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.instanceOf(Date)
	  };
	  TimePicker.defaultProps = {
	    active: false,
	    className: '',
	    format: '24hr'
	  };
	
	
	  return TimePicker;
	};
	
	var TimePickerDialog = (0, _TimePickerDialog2.default)(_Dialog2.default);
	var TimePicker = factory(TimePickerDialog, _Input2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.TIME_PICKER)(TimePicker);
	exports.timePickerFactory = factory;
	exports.TimePicker = TimePicker;

/***/ },
/* 2412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimePicker = undefined;
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _identifiers = __webpack_require__(9);
	
	var _TimePicker = __webpack_require__(2411);
	
	var _TimePickerDialog = __webpack_require__(819);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _dialog = __webpack_require__(371);
	
	var _input = __webpack_require__(33);
	
	var _theme = __webpack_require__(1456);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = (0, _TimePickerDialog2.default)(_dialog.Dialog);
	var ThemedTimePicker = (0, _reactCssThemr.themr)(_identifiers.TIME_PICKER, _theme2.default)((0, _TimePicker.timePickerFactory)(TimePickerDialog, _input.Input));
	exports.default = ThemedTimePicker;
	exports.TimePicker = ThemedTimePicker;

/***/ },
/* 2413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(3);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(8);
	
	var _Portal = __webpack_require__(250);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _utils = __webpack_require__(60);
	
	var _identifiers = __webpack_require__(9);
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POSITION = {
	  BOTTOM: 'bottom',
	  HORIZONTAL: 'horizontal',
	  LEFT: 'left',
	  RIGHT: 'right',
	  TOP: 'top',
	  VERTICAL: 'vertical'
	};
	
	var defaults = {
	  className: '',
	  delay: 0,
	  hideOnClick: true,
	  passthrough: true,
	  showOnClick: false,
	  position: POSITION.VERTICAL,
	  theme: {}
	};
	
	var tooltipFactory = function tooltipFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _defaults$options = _extends({}, defaults, options),
	      defaultClassName = _defaults$options.className,
	      defaultDelay = _defaults$options.delay,
	      defaultHideOnClick = _defaults$options.hideOnClick,
	      defaultShowOnClick = _defaults$options.showOnClick,
	      defaultPassthrough = _defaults$options.passthrough,
	      defaultPosition = _defaults$options.position,
	      defaultTheme = _defaults$options.theme;
	
	  return function (ComposedComponent) {
	    var TooltippedComponent = function (_Component) {
	      _inherits(TooltippedComponent, _Component);
	
	      function TooltippedComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TooltippedComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltippedComponent.__proto__ || Object.getPrototypeOf(TooltippedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          active: false,
	          position: _this.props.tooltipPosition,
	          visible: false
	        }, _this.onTransformEnd = function (e) {
	          if (e.propertyName === 'transform') {
	            _events2.default.removeEventListenerOnTransitionEnded(_this.tooltipNode, _this.onTransformEnd);
	            _this.setState({ visible: false });
	          }
	        }, _this.handleMouseEnter = function (event) {
	          _this.activate(_this.calculatePosition(event.currentTarget));
	          if (_this.props.onMouseEnter) _this.props.onMouseEnter(event);
	        }, _this.handleMouseLeave = function (event) {
	          _this.deactivate();
	          if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	        }, _this.handleClick = function (event) {
	          if (_this.props.tooltipHideOnClick && _this.state.active) {
	            _this.deactivate();
	          }
	
	          if (_this.props.tooltipShowOnClick && !_this.state.active) {
	            _this.activate(_this.calculatePosition(event.currentTarget));
	          }
	
	          if (_this.props.onClick) _this.props.onClick(event);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(TooltippedComponent, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (this.tooltipNode) {
	            _events2.default.removeEventListenerOnTransitionEnded(this.tooltipNode, this.onTransformEnd);
	          }
	          if (this.timeout) clearTimeout(this.timeout);
	        }
	      }, {
	        key: 'getPosition',
	        value: function getPosition(element) {
	          var tooltipPosition = this.props.tooltipPosition;
	
	          if (tooltipPosition === POSITION.HORIZONTAL) {
	            var origin = element.getBoundingClientRect();
	
	            var _getViewport = (0, _utils.getViewport)(),
	                ww = _getViewport.width;
	
	            var toRight = origin.left < ww / 2 - origin.width / 2;
	            return toRight ? POSITION.RIGHT : POSITION.LEFT;
	          } else if (tooltipPosition === POSITION.VERTICAL) {
	            var _origin = element.getBoundingClientRect();
	
	            var _getViewport2 = (0, _utils.getViewport)(),
	                wh = _getViewport2.height;
	
	            var toBottom = _origin.top < wh / 2 - _origin.height / 2;
	            return toBottom ? POSITION.BOTTOM : POSITION.TOP;
	          }
	          return tooltipPosition;
	        }
	      }, {
	        key: 'activate',
	        value: function activate(_ref2) {
	          var _this2 = this;
	
	          var top = _ref2.top,
	              left = _ref2.left,
	              position = _ref2.position;
	
	          if (this.timeout) clearTimeout(this.timeout);
	          this.setState({ visible: true, position: position });
	          this.timeout = setTimeout(function () {
	            _this2.setState({ active: true, top: top, left: left });
	          }, this.props.tooltipDelay);
	        }
	      }, {
	        key: 'deactivate',
	        value: function deactivate() {
	          if (this.timeout) clearTimeout(this.timeout);
	          if (this.state.active) {
	            _events2.default.addEventListenerOnTransitionEnded(this.tooltipNode, this.onTransformEnd);
	            this.setState({ active: false });
	          } else if (this.state.visible) {
	            this.setState({ visible: false });
	          }
	        }
	      }, {
	        key: 'calculatePosition',
	        value: function calculatePosition(element) {
	          var position = this.getPosition(element);
	
	          var _element$getBoundingC = element.getBoundingClientRect(),
	              top = _element$getBoundingC.top,
	              left = _element$getBoundingC.left,
	              height = _element$getBoundingC.height,
	              width = _element$getBoundingC.width;
	
	          var xOffset = window.scrollX || window.pageXOffset;
	          var yOffset = window.scrollY || window.pageYOffset;
	          if (position === POSITION.BOTTOM) {
	            return {
	              top: top + height + yOffset,
	              left: left + width / 2 + xOffset,
	              position: position
	            };
	          } else if (position === POSITION.TOP) {
	            return {
	              top: top + yOffset,
	              left: left + width / 2 + xOffset,
	              position: position
	            };
	          } else if (position === POSITION.LEFT) {
	            return {
	              top: top + height / 2 + yOffset,
	              left: left + xOffset,
	              position: position
	            };
	          } else if (position === POSITION.RIGHT) {
	            return {
	              top: top + height / 2 + yOffset,
	              left: left + width + xOffset,
	              position: position
	            };
	          }
	          return undefined;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _classnames,
	              _this3 = this;
	
	          var _state = this.state,
	              active = _state.active,
	              left = _state.left,
	              top = _state.top,
	              position = _state.position,
	              visible = _state.visible;
	
	          var positionClass = 'tooltip' + (position.charAt(0).toUpperCase() + position.slice(1));
	
	          var _props = this.props,
	              children = _props.children,
	              className = _props.className,
	              theme = _props.theme,
	              onClick = _props.onClick,
	              onMouseEnter = _props.onMouseEnter,
	              onMouseLeave = _props.onMouseLeave,
	              tooltip = _props.tooltip,
	              tooltipDelay = _props.tooltipDelay,
	              tooltipHideOnClick = _props.tooltipHideOnClick,
	              tooltipPosition = _props.tooltipPosition,
	              tooltipShowOnClick = _props.tooltipShowOnClick,
	              other = _objectWithoutProperties(_props, ['children', 'className', 'theme', 'onClick', 'onMouseEnter', 'onMouseLeave', 'tooltip', 'tooltipDelay', 'tooltipHideOnClick', 'tooltipPosition', 'tooltipShowOnClick']);
	
	          var _className = (0, _classnames3.default)(theme.tooltip, (_classnames = {}, _defineProperty(_classnames, theme.tooltipActive, active), _defineProperty(_classnames, theme[positionClass], theme[positionClass]), _classnames));
	
	          var childProps = _extends({}, other, {
	            className: className,
	            onClick: this.handleClick,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave
	          });
	
	          var shouldPass = typeof ComposedComponent !== 'string' && defaultPassthrough;
	          var finalProps = shouldPass ? _extends({}, childProps, { theme: theme }) : childProps;
	
	          return _react2.default.createElement(ComposedComponent, finalProps, children, visible && _react2.default.createElement(
	            _Portal2.default,
	            null,
	            _react2.default.createElement(
	              'span',
	              {
	                ref: function ref(node) {
	                  _this3.tooltipNode = node;
	                },
	                className: _className,
	                'data-react-toolbox': 'tooltip',
	                style: { top: top, left: left }
	              },
	              _react2.default.createElement(
	                'span',
	                { className: theme.tooltipInner },
	                tooltip
	              )
	            )
	          ));
	        }
	      }]);
	
	      return TooltippedComponent;
	    }(_react.Component);
	
	    TooltippedComponent.propTypes = {
	      children: _propTypes2.default.node,
	      className: _propTypes2.default.string,
	      onClick: _propTypes2.default.func,
	      onMouseEnter: _propTypes2.default.func,
	      onMouseLeave: _propTypes2.default.func,
	      theme: _propTypes2.default.shape({
	        tooltip: _propTypes2.default.string,
	        tooltipActive: _propTypes2.default.string,
	        tooltipWrapper: _propTypes2.default.string
	      }),
	      tooltip: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	      tooltipDelay: _propTypes2.default.number,
	      tooltipHideOnClick: _propTypes2.default.bool,
	      tooltipPosition: _propTypes2.default.oneOf(Object.keys(POSITION).map(function (key) {
	        return POSITION[key];
	      })),
	      tooltipShowOnClick: _propTypes2.default.bool
	    };
	    TooltippedComponent.defaultProps = {
	      className: defaultClassName,
	      tooltipDelay: defaultDelay,
	      tooltipHideOnClick: defaultHideOnClick,
	      tooltipPosition: defaultPosition,
	      tooltipShowOnClick: defaultShowOnClick
	    };
	
	
	    return (0, _reactCssThemr.themr)(_identifiers.TOOLTIP, defaultTheme)(TooltippedComponent);
	  };
	};
	
	exports.default = tooltipFactory;

/***/ },
/* 2414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tooltipFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Tooltip = __webpack_require__(2413);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _theme = __webpack_require__(1457);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var themedTooltipFactory = function themedTooltipFactory(options) {
	  return (0, _Tooltip2.default)(_extends({}, options, { theme: _theme2.default }));
	};
	exports.default = (0, _Tooltip2.default)({ theme: _theme2.default });
	exports.tooltipFactory = themedTooltipFactory;

/***/ },
/* 2415 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  xxs: 480,
	  xs: 600,
	  smTablet: 720,
	  sm: 840,
	  md: 960,
	  lgTablet: 1024,
	  lg: 1280,
	  xl: 1440,
	  xxl: 1600,
	  xxxl: 1920
	};

/***/ },
/* 2416 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasOwnProperty;
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

/***/ },
/* 2417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.time = exports.prefixer = exports.events = undefined;
	
	var _utils = __webpack_require__(60);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _events = __webpack_require__(90);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _prefixer = __webpack_require__(255);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	var _time = __webpack_require__(91);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { events: _events2.default, prefixer: _prefixer2.default, time: _time2.default };
	exports.events = _events2.default;
	exports.prefixer = _prefixer2.default;
	exports.time = _time2.default;

/***/ },
/* 2418 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBrowser;
	function isBrowser() {
	  return typeof window !== 'undefined' && window.document;
	}

/***/ },
/* 2419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2421);
	
	__webpack_require__(2422);
	
	__webpack_require__(2420);
	
	__webpack_require__(2423);
	
	__webpack_require__(2425);
	
	__webpack_require__(2424);
	
	__webpack_require__(2426);

/***/ },
/* 2420 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2451);
	module.exports = __webpack_require__(64).Array.findIndex;


/***/ },
/* 2421 */
[2536, 844, 2452, 64],
/* 2422 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(842);
	module.exports = __webpack_require__(64).Array.values;


/***/ },
/* 2423 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(843);
	__webpack_require__(844);
	__webpack_require__(2462);
	__webpack_require__(2453);
	__webpack_require__(2459);
	__webpack_require__(2458);
	__webpack_require__(2457);
	module.exports = __webpack_require__(64).Map;


/***/ },
/* 2424 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2454);
	module.exports = __webpack_require__(64).String.includes;


/***/ },
/* 2425 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2455);
	module.exports = __webpack_require__(64).String.startsWith;


/***/ },
/* 2426 */
[2537, 2456, 843, 2460, 2461, 64],
/* 2427 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(258);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 2428 */
[2539, 150, 185, 2450],
/* 2429 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(121);
	var IObject = __webpack_require__(827);
	var toObject = __webpack_require__(263);
	var toLength = __webpack_require__(185);
	var asc = __webpack_require__(2431);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 2430 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	var isArray = __webpack_require__(829);
	var SPECIES = __webpack_require__(46)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(2430);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 2432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(92).f;
	var create = __webpack_require__(381);
	var redefineAll = __webpack_require__(837);
	var ctx = __webpack_require__(121);
	var anInstance = __webpack_require__(823);
	var forOf = __webpack_require__(258);
	var $iterDefine = __webpack_require__(379);
	var step = __webpack_require__(832);
	var setSpecies = __webpack_require__(2448);
	var DESCRIPTORS = __webpack_require__(106);
	var fastKey = __webpack_require__(380).fastKey;
	var validate = __webpack_require__(839);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 2433 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(377);
	var from = __webpack_require__(2427);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(71);
	var $export = __webpack_require__(85);
	var redefine = __webpack_require__(124);
	var redefineAll = __webpack_require__(837);
	var meta = __webpack_require__(380);
	var forOf = __webpack_require__(258);
	var anInstance = __webpack_require__(823);
	var isObject = __webpack_require__(72);
	var fails = __webpack_require__(182);
	var $iterDetect = __webpack_require__(831);
	var setToStringTag = __webpack_require__(261);
	var inheritIfRequired = __webpack_require__(2439);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 2435 */
[2541, 92, 184],
/* 2436 */
[2545, 260, 835, 382],
/* 2437 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(262)('native-function-to-string', Function.toString);


/***/ },
/* 2438 */
[2547, 71],
/* 2439 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	var setPrototypeOf = __webpack_require__(2447).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 2440 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(72);
	var cof = __webpack_require__(256);
	var MATCH = __webpack_require__(46)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 2441 */
[2553, 381, 184, 261, 123, 46],
/* 2442 */
[2559, 92, 120, 260, 106],
/* 2443 */
[2561, 150, 834],
/* 2444 */
[2563, 122, 263, 383],
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(85);
	var aFunction = __webpack_require__(821);
	var ctx = __webpack_require__(121);
	var forOf = __webpack_require__(258);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 2446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(85);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 2447 */
[2566, 72, 120, 121, 833],
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(71);
	var dP = __webpack_require__(92);
	var DESCRIPTORS = __webpack_require__(106);
	var SPECIES = __webpack_require__(46)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 2449 */
[2570, 384, 257],
/* 2450 */
[2571, 384],
/* 2451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(85);
	var $find = __webpack_require__(2429)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(822)(KEY);


/***/ },
/* 2452 */
[2580, 121, 85, 263, 830, 828, 185, 2435, 841, 831],
/* 2453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(2432);
	var validate = __webpack_require__(839);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(2434)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 2454 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(85);
	var context = __webpack_require__(838);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(825)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 2455 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(85);
	var toLength = __webpack_require__(185);
	var context = __webpack_require__(838);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(825)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 2456 */
[2583, 71, 122, 106, 85, 124, 380, 182, 262, 261, 186, 46, 840, 386, 2436, 829, 120, 72, 263, 150, 385, 184, 381, 2443, 833, 835, 92, 260, 834, 382, 259, 123],
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(2445)('Map');


/***/ },
/* 2458 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(2446)('Map');


/***/ },
/* 2459 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(85);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(2433)('Map') });


/***/ },
/* 2460 */
[2584, 386],
/* 2461 */
[2585, 386],
/* 2462 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(842);
	var getKeys = __webpack_require__(260);
	var redefine = __webpack_require__(124);
	var global = __webpack_require__(71);
	var hide = __webpack_require__(123);
	var Iterators = __webpack_require__(183);
	var wks = __webpack_require__(46);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 2463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(21));
	
	var _reactLifecyclesCompat = __webpack_require__(767);
	
	var _PropTypes = __webpack_require__(847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 2464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(264);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransitionGroupChild = __webpack_require__(2466);
	
	var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);
	
	var _PropTypes = __webpack_require__(848);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  transitionName: _PropTypes.nameShape.isRequired,
	
	  transitionAppear: _propTypes2.default.bool,
	  transitionEnter: _propTypes2.default.bool,
	  transitionLeave: _propTypes2.default.bool,
	  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
	  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
	  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
	};
	
	var defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	var CSSTransitionGroup = function (_React$Component) {
	  _inherits(CSSTransitionGroup, _React$Component);
	
	  function CSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // We need to provide this childFactory so that
	  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	  // leave while it is leaving.
	
	
	  CSSTransitionGroup.prototype.render = function render() {
	    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return CSSTransitionGroup;
	}(_react2.default.Component);
	
	CSSTransitionGroup.displayName = 'CSSTransitionGroup';
	
	
	CSSTransitionGroup.propTypes =  false ? propTypes : {};
	CSSTransitionGroup.defaultProps = defaultProps;
	
	exports.default = CSSTransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _addClass = __webpack_require__(503);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(504);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _requestAnimationFrame = __webpack_require__(1420);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _properties = __webpack_require__(1419);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(21);
	
	var _PropTypes = __webpack_require__(848);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var events = [];
	if (_properties.transitionEnd) events.push(_properties.transitionEnd);
	if (_properties.animationEnd) events.push(_properties.animationEnd);
	
	function addEndListener(node, listener) {
	  if (events.length) {
	    events.forEach(function (e) {
	      return node.addEventListener(e, listener, false);
	    });
	  } else {
	    setTimeout(listener, 0);
	  }
	
	  return function () {
	    if (!events.length) return;
	    events.forEach(function (e) {
	      return node.removeEventListener(e, listener, false);
	    });
	  };
	}
	
	var propTypes = {
	  children: _propTypes2.default.node,
	  name: _PropTypes.nameShape.isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: _propTypes2.default.bool,
	  enter: _propTypes2.default.bool,
	  leave: _propTypes2.default.bool,
	  appearTimeout: _propTypes2.default.number,
	  enterTimeout: _propTypes2.default.number,
	  leaveTimeout: _propTypes2.default.number
	};
	
	var CSSTransitionGroupChild = function (_React$Component) {
	  _inherits(CSSTransitionGroupChild, _React$Component);
	
	  function CSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounted = true;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
	    var node = (0, _reactDom.findDOMNode)(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timer = null;
	    var removeListeners = void 0;
	
	    (0, _addClass2.default)(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // Clean-up the animation after the specified delay
	    var finish = function finish(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timer);
	      if (removeListeners) removeListeners();
	
	      (0, _removeClass2.default)(node, className);
	      (0, _removeClass2.default)(node, activeClassName);
	
	      if (removeListeners) removeListeners();
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    if (timeout) {
	      timer = setTimeout(finish, timeout);
	      this.transitionTimeouts.push(timer);
	    } else if (_properties.transitionEnd) {
	      removeListeners = addEndListener(node, finish);
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
	    var _this2 = this;
	
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.rafHandle) {
	      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
	        return _this2.flushClassNameAndNodeQueue();
	      });
	    }
	  };
	
	  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
	    if (!this.unmounted) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        // This is for to force a repaint,
	        // which is necessary in order to transition styles when adding a class name.
	        /* eslint-disable no-unused-expressions */
	        obj.node.scrollTop;
	        /* eslint-enable no-unused-expressions */
	        (0, _addClass2.default)(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.rafHandle = null;
	  };
	
	  CSSTransitionGroupChild.prototype.render = function render() {
	    var props = _extends({}, this.props);
	    delete props.name;
	    delete props.appear;
	    delete props.enter;
	    delete props.leave;
	    delete props.appearTimeout;
	    delete props.enterTimeout;
	    delete props.leaveTimeout;
	    delete props.children;
	    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
	  };
	
	  return CSSTransitionGroupChild;
	}(_react2.default.Component);
	
	CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
	
	
	CSSTransitionGroupChild.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransitionGroupChild;
	module.exports = exports['default'];

/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CSSTransitionGroup = __webpack_require__(2465);
	
	var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);
	
	var _TransitionGroup = __webpack_require__(264);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  TransitionGroup: _TransitionGroup2.default,
	  CSSTransitionGroup: _CSSTransitionGroup2.default
	};

/***/ },
/* 2468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 2469 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(153);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(2470);
	var ReactElement = __webpack_require__(152);
	
	var emptyFunction = __webpack_require__(77);
	var traverseAllChildren = __webpack_require__(2481);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 2472 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(153),
	    _assign = __webpack_require__(16);
	
	var ReactComponent = __webpack_require__(387);
	var ReactElement = __webpack_require__(152);
	var ReactPropTypeLocationNames = __webpack_require__(2474);
	var ReactNoopUpdateQueue = __webpack_require__(388);
	
	var emptyObject = __webpack_require__(137);
	var invariant = __webpack_require__(14);
	var warning = __webpack_require__(17);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 2473 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(152);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 2474 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 2475 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(152),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(682);
	
	module.exports = factory(isValidElement);

/***/ },
/* 2476 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(16);
	
	var ReactComponent = __webpack_require__(387);
	var ReactNoopUpdateQueue = __webpack_require__(388);
	
	var emptyObject = __webpack_require__(137);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 2477 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ },
/* 2478 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 2479 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 2480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(153);
	
	var ReactElement = __webpack_require__(152);
	
	var invariant = __webpack_require__(14);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 2481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(153);
	
	var ReactCurrentOwner = __webpack_require__(93);
	var REACT_ELEMENT_TYPE = __webpack_require__(850);
	
	var getIteratorFn = __webpack_require__(2478);
	var invariant = __webpack_require__(14);
	var KeyEscapeUtils = __webpack_require__(2469);
	var warning = __webpack_require__(17);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 2482 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 2483 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 2484 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ },
/* 2485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(852);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(853);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ },
/* 2486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var compose = __webpack_require__(265).compose;
	
	exports.__esModule = true;
	exports.composeWithDevTools = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
	    function() {
	      if (arguments.length === 0) return undefined;
	      if (typeof arguments[0] === 'object') return compose;
	      return compose.apply(null, arguments);
	    }
	);
	
	exports.devToolsEnhancer = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION__ :
	    function() { return function(noop) { return noop; } }
	);


/***/ },
/* 2487 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 2488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(854);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 2489 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 2490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(855);
	
	var _isPlainObject = __webpack_require__(542);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(856);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 2491 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 2492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(61)))

/***/ },
/* 2493 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 2494 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2496);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(107)(module)))

/***/ },
/* 2496 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createThemeProvider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isFunction = __webpack_require__(1633);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(1634);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _channel = __webpack_require__(266);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _brcast = __webpack_require__(1410);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Provide a theme to an entire react component tree via context
	 * and event listeners (have to do both context
	 * and event emitter as pure components block context updates)
	 */
	
	function createThemeProvider() {
	  var _class, _temp2;
	
	  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  return _temp2 = _class = function (_React$Component) {
	    _inherits(ThemeProvider, _React$Component);
	
	    function ThemeProvider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ThemeProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.broadcast = (0, _brcast2.default)(_this.getTheme()), _this.setOuterTheme = function (theme) {
	        _this.outerTheme = theme;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ThemeProvider, [{
	      key: 'getTheme',
	
	
	      // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	      value: function getTheme(passedTheme) {
	        var theme = passedTheme || this.props.theme;
	        if ((0, _isFunction2.default)(theme)) {
	          var mergedTheme = theme(this.outerTheme);
	          if (!(0, _isPlainObject2.default)(mergedTheme)) {
	            throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	          }
	          return mergedTheme;
	        }
	        if (!(0, _isPlainObject2.default)(theme)) {
	          throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	        }
	
	        if (!this.outerTheme) {
	          return theme;
	        }
	
	        return _extends({}, this.outerTheme, theme);
	      }
	    }, {
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return _defineProperty({}, CHANNEL, this.broadcast);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // create a new subscription for keeping track of outer theme, if present
	        if (this.context[CHANNEL]) {
	          this.subscriptionId = this.context[CHANNEL].subscribe(this.setOuterTheme);
	        }
	      }
	
	      // set broadcast state by merging outer theme with own
	
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (this.context[CHANNEL]) {
	          this.setOuterTheme(this.context[CHANNEL].getState());
	          this.broadcast.setState(this.getTheme());
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.theme !== nextProps.theme) {
	          this.broadcast.setState(this.getTheme(nextProps.theme));
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.subscriptionId !== undefined) {
	          this.context[CHANNEL].unsubscribe(this.subscriptionId);
	          delete this.subscriptionId;
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        if (!this.props.children) {
	          return null;
	        }
	        return _react2.default.Children.only(this.props.children);
	      }
	    }]);
	
	    return ThemeProvider;
	  }(_react2.default.Component), _class.propTypes = {
	    children: _propTypes2.default.element,
	    theme: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.func]).isRequired
	  }, _class.childContextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.object.isRequired), _class.contextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.object), _temp2;
	}

/***/ },
/* 2498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createWithTheme;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _channel = __webpack_require__(266);
	
	var _channel2 = _interopRequireDefault(_channel);
	
	var _createThemeListener = __webpack_require__(857);
	
	var _createThemeListener2 = _interopRequireDefault(_createThemeListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDisplayName = function getDisplayName(Component) {
	  return Component.displayName || Component.name || 'Component';
	};
	
	function createWithTheme() {
	  var CHANNEL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _channel2.default;
	
	  var themeListener = (0, _createThemeListener2.default)(CHANNEL);
	  return function (Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	      _inherits(WithTheme, _React$Component);
	
	      function WithTheme(props, context) {
	        _classCallCheck(this, WithTheme);
	
	        var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props, context));
	
	        _this.state = { theme: themeListener.initial(context) };
	        _this.setTheme = function (theme) {
	          return _this.setState({ theme: theme });
	        };
	        return _this;
	      }
	
	      _createClass(WithTheme, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.unsubscribe = themeListener.subscribe(this.context, this.setTheme);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (typeof this.unsubscribe === 'function') {
	            this.unsubscribe();
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var theme = this.state.theme;
	
	
	          return _react2.default.createElement(Component, _extends({ theme: theme }, this.props));
	        }
	      }]);
	
	      return WithTheme;
	    }(_react2.default.Component), _class.displayName = 'WithTheme(' + getDisplayName(Component) + ')', _class.contextTypes = themeListener.contextTypes, _temp;
	  };
	}

/***/ },
/* 2499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ },
/* 2500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 2501 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 2502 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 2503 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 2504 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 2505 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 2506 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLAttribute, create;
	
	  create = __webpack_require__(58);
	
	  module.exports = XMLAttribute = (function() {
	    function XMLAttribute(parent, name, value) {
	      this.stringify = parent.stringify;
	      if (name == null) {
	        throw new Error("Missing attribute name of element " + parent.name);
	      }
	      if (value == null) {
	        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
	      }
	      this.name = this.stringify.attName(name);
	      this.value = this.stringify.attValue(value);
	    }
	
	    XMLAttribute.prototype.clone = function() {
	      return create(XMLAttribute.prototype, this);
	    };
	
	    XMLAttribute.prototype.toString = function(options, level) {
	      return ' ' + this.name + '="' + this.value + '"';
	    };
	
	    return XMLAttribute;
	
	  })();
	
	}).call(this);


/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLBuilder, XMLDeclaration, XMLDocType, XMLElement, XMLStringifier;
	
	  XMLStringifier = __webpack_require__(2513);
	
	  XMLDeclaration = __webpack_require__(863);
	
	  XMLDocType = __webpack_require__(864);
	
	  XMLElement = __webpack_require__(865);
	
	  module.exports = XMLBuilder = (function() {
	    function XMLBuilder(name, options) {
	      var root, temp;
	      if (name == null) {
	        throw new Error("Root element needs a name");
	      }
	      if (options == null) {
	        options = {};
	      }
	      this.options = options;
	      this.stringify = new XMLStringifier(options);
	      temp = new XMLElement(this, 'doc');
	      root = temp.element(name);
	      root.isRoot = true;
	      root.documentObject = this;
	      this.rootObject = root;
	      if (!options.headless) {
	        root.declaration(options);
	        if ((options.pubID != null) || (options.sysID != null)) {
	          root.doctype(options);
	        }
	      }
	    }
	
	    XMLBuilder.prototype.root = function() {
	      return this.rootObject;
	    };
	
	    XMLBuilder.prototype.end = function(options) {
	      return this.toString(options);
	    };
	
	    XMLBuilder.prototype.toString = function(options) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      r = '';
	      if (this.xmldec != null) {
	        r += this.xmldec.toString(options);
	      }
	      if (this.doctype != null) {
	        r += this.doctype.toString(options);
	      }
	      r += this.rootObject.toString(options);
	      if (pretty && r.slice(-newline.length) === newline) {
	        r = r.slice(0, -newline.length);
	      }
	      return r;
	    };
	
	    return XMLBuilder;
	
	  })();
	
	}).call(this);


/***/ },
/* 2508 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLDTDAttList, create;
	
	  create = __webpack_require__(58);
	
	  module.exports = XMLDTDAttList = (function() {
	    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      this.stringify = parent.stringify;
	      if (elementName == null) {
	        throw new Error("Missing DTD element name");
	      }
	      if (attributeName == null) {
	        throw new Error("Missing DTD attribute name");
	      }
	      if (!attributeType) {
	        throw new Error("Missing DTD attribute type");
	      }
	      if (!defaultValueType) {
	        throw new Error("Missing DTD attribute default");
	      }
	      if (defaultValueType.indexOf('#') !== 0) {
	        defaultValueType = '#' + defaultValueType;
	      }
	      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
	        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
	      }
	      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
	        throw new Error("Default value only applies to #FIXED or #DEFAULT");
	      }
	      this.elementName = this.stringify.eleName(elementName);
	      this.attributeName = this.stringify.attName(attributeName);
	      this.attributeType = this.stringify.dtdAttType(attributeType);
	      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
	      this.defaultValueType = defaultValueType;
	    }
	
	    XMLDTDAttList.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<!ATTLIST ' + this.elementName + ' ' + this.attributeName + ' ' + this.attributeType;
	      if (this.defaultValueType !== '#DEFAULT') {
	        r += ' ' + this.defaultValueType;
	      }
	      if (this.defaultValue) {
	        r += ' "' + this.defaultValue + '"';
	      }
	      r += '>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLDTDAttList;
	
	  })();
	
	}).call(this);


/***/ },
/* 2509 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLDTDElement, create;
	
	  create = __webpack_require__(58);
	
	  module.exports = XMLDTDElement = (function() {
	    function XMLDTDElement(parent, name, value) {
	      this.stringify = parent.stringify;
	      if (name == null) {
	        throw new Error("Missing DTD element name");
	      }
	      if (!value) {
	        value = '(#PCDATA)';
	      }
	      if (Array.isArray(value)) {
	        value = '(' + value.join(',') + ')';
	      }
	      this.name = this.stringify.eleName(name);
	      this.value = this.stringify.dtdElementValue(value);
	    }
	
	    XMLDTDElement.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<!ELEMENT ' + this.name + ' ' + this.value + '>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLDTDElement;
	
	  })();
	
	}).call(this);


/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLDTDEntity, create, isObject;
	
	  create = __webpack_require__(58);
	
	  isObject = __webpack_require__(80);
	
	  module.exports = XMLDTDEntity = (function() {
	    function XMLDTDEntity(parent, pe, name, value) {
	      this.stringify = parent.stringify;
	      if (name == null) {
	        throw new Error("Missing entity name");
	      }
	      if (value == null) {
	        throw new Error("Missing entity value");
	      }
	      this.pe = !!pe;
	      this.name = this.stringify.eleName(name);
	      if (!isObject(value)) {
	        this.value = this.stringify.dtdEntityValue(value);
	      } else {
	        if (!value.pubID && !value.sysID) {
	          throw new Error("Public and/or system identifiers are required for an external entity");
	        }
	        if (value.pubID && !value.sysID) {
	          throw new Error("System identifier is required for a public external entity");
	        }
	        if (value.pubID != null) {
	          this.pubID = this.stringify.dtdPubID(value.pubID);
	        }
	        if (value.sysID != null) {
	          this.sysID = this.stringify.dtdSysID(value.sysID);
	        }
	        if (value.nData != null) {
	          this.nData = this.stringify.dtdNData(value.nData);
	        }
	        if (this.pe && this.nData) {
	          throw new Error("Notation declaration is not allowed in a parameter entity");
	        }
	      }
	    }
	
	    XMLDTDEntity.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<!ENTITY';
	      if (this.pe) {
	        r += ' %';
	      }
	      r += ' ' + this.name;
	      if (this.value) {
	        r += ' "' + this.value + '"';
	      } else {
	        if (this.pubID && this.sysID) {
	          r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
	        } else if (this.sysID) {
	          r += ' SYSTEM "' + this.sysID + '"';
	        }
	        if (this.nData) {
	          r += ' NDATA ' + this.nData;
	        }
	      }
	      r += '>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLDTDEntity;
	
	  })();
	
	}).call(this);


/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLDTDNotation, create;
	
	  create = __webpack_require__(58);
	
	  module.exports = XMLDTDNotation = (function() {
	    function XMLDTDNotation(parent, name, value) {
	      this.stringify = parent.stringify;
	      if (name == null) {
	        throw new Error("Missing notation name");
	      }
	      if (!value.pubID && !value.sysID) {
	        throw new Error("Public or system identifiers are required for an external entity");
	      }
	      this.name = this.stringify.eleName(name);
	      if (value.pubID != null) {
	        this.pubID = this.stringify.dtdPubID(value.pubID);
	      }
	      if (value.sysID != null) {
	        this.sysID = this.stringify.dtdSysID(value.sysID);
	      }
	    }
	
	    XMLDTDNotation.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += '<!NOTATION ' + this.name;
	      if (this.pubID && this.sysID) {
	        r += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"';
	      } else if (this.pubID) {
	        r += ' PUBLIC "' + this.pubID + '"';
	      } else if (this.sysID) {
	        r += ' SYSTEM "' + this.sysID + '"';
	      }
	      r += '>';
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLDTDNotation;
	
	  })();
	
	}).call(this);


/***/ },
/* 2512 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLNode, XMLRaw, create,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  create = __webpack_require__(58);
	
	  XMLNode = __webpack_require__(155);
	
	  module.exports = XMLRaw = (function(superClass) {
	    extend(XMLRaw, superClass);
	
	    function XMLRaw(parent, text) {
	      XMLRaw.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing raw text");
	      }
	      this.value = this.stringify.raw(text);
	    }
	
	    XMLRaw.prototype.clone = function() {
	      return create(XMLRaw.prototype, this);
	    };
	
	    XMLRaw.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += this.value;
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLRaw;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 2513 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLStringifier,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    hasProp = {}.hasOwnProperty;
	
	  module.exports = XMLStringifier = (function() {
	    function XMLStringifier(options) {
	      this.assertLegalChar = bind(this.assertLegalChar, this);
	      var key, ref, value;
	      this.allowSurrogateChars = options != null ? options.allowSurrogateChars : void 0;
	      this.noDoubleEncoding = options != null ? options.noDoubleEncoding : void 0;
	      ref = (options != null ? options.stringify : void 0) || {};
	      for (key in ref) {
	        if (!hasProp.call(ref, key)) continue;
	        value = ref[key];
	        this[key] = value;
	      }
	    }
	
	    XMLStringifier.prototype.eleName = function(val) {
	      val = '' + val || '';
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.eleText = function(val) {
	      val = '' + val || '';
	      return this.assertLegalChar(this.elEscape(val));
	    };
	
	    XMLStringifier.prototype.cdata = function(val) {
	      val = '' + val || '';
	      if (val.match(/]]>/)) {
	        throw new Error("Invalid CDATA text: " + val);
	      }
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.comment = function(val) {
	      val = '' + val || '';
	      if (val.match(/--/)) {
	        throw new Error("Comment text cannot contain double-hypen: " + val);
	      }
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.raw = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.attName = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.attValue = function(val) {
	      val = '' + val || '';
	      return this.attEscape(val);
	    };
	
	    XMLStringifier.prototype.insTarget = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.insValue = function(val) {
	      val = '' + val || '';
	      if (val.match(/\?>/)) {
	        throw new Error("Invalid processing instruction value: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlVersion = function(val) {
	      val = '' + val || '';
	      if (!val.match(/1\.[0-9]+/)) {
	        throw new Error("Invalid version number: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlEncoding = function(val) {
	      val = '' + val || '';
	      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-]|-)*$/)) {
	        throw new Error("Invalid encoding: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlStandalone = function(val) {
	      if (val) {
	        return "yes";
	      } else {
	        return "no";
	      }
	    };
	
	    XMLStringifier.prototype.dtdPubID = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdSysID = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdElementValue = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdAttType = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdAttDefault = function(val) {
	      if (val != null) {
	        return '' + val || '';
	      } else {
	        return val;
	      }
	    };
	
	    XMLStringifier.prototype.dtdEntityValue = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdNData = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.convertAttKey = '@';
	
	    XMLStringifier.prototype.convertPIKey = '?';
	
	    XMLStringifier.prototype.convertTextKey = '#text';
	
	    XMLStringifier.prototype.convertCDataKey = '#cdata';
	
	    XMLStringifier.prototype.convertCommentKey = '#comment';
	
	    XMLStringifier.prototype.convertRawKey = '#raw';
	
	    XMLStringifier.prototype.assertLegalChar = function(str) {
	      var chars, chr;
	      if (this.allowSurrogateChars) {
	        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/;
	      } else {
	        chars = /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE-\uFFFF]/;
	      }
	      chr = str.match(chars);
	      if (chr) {
	        throw new Error("Invalid character (" + chr + ") in string: " + str + " at index " + chr.index);
	      }
	      return str;
	    };
	
	    XMLStringifier.prototype.elEscape = function(str) {
	      var ampregex;
	      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
	      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
	    };
	
	    XMLStringifier.prototype.attEscape = function(str) {
	      var ampregex;
	      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
	      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
	    };
	
	    return XMLStringifier;
	
	  })();
	
	}).call(this);


/***/ },
/* 2514 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLNode, XMLText, create,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  create = __webpack_require__(58);
	
	  XMLNode = __webpack_require__(155);
	
	  module.exports = XMLText = (function(superClass) {
	    extend(XMLText, superClass);
	
	    function XMLText(parent, text) {
	      XMLText.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing element text");
	      }
	      this.value = this.stringify.eleText(text);
	    }
	
	    XMLText.prototype.clone = function() {
	      return create(XMLText.prototype, this);
	    };
	
	    XMLText.prototype.toString = function(options, level) {
	      var indent, newline, offset, pretty, r, ref, ref1, ref2, space;
	      pretty = (options != null ? options.pretty : void 0) || false;
	      indent = (ref = options != null ? options.indent : void 0) != null ? ref : '  ';
	      offset = (ref1 = options != null ? options.offset : void 0) != null ? ref1 : 0;
	      newline = (ref2 = options != null ? options.newline : void 0) != null ? ref2 : '\n';
	      level || (level = 0);
	      space = new Array(level + offset + 1).join(indent);
	      r = '';
	      if (pretty) {
	        r += space;
	      }
	      r += this.value;
	      if (pretty) {
	        r += newline;
	      }
	      return r;
	    };
	
	    return XMLText;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	(function() {
	  var XMLBuilder, assign;
	
	  assign = __webpack_require__(1976);
	
	  XMLBuilder = __webpack_require__(2507);
	
	  module.exports.create = function(name, xmldec, doctype, options) {
	    options = assign({}, xmldec, doctype, options);
	    return new XMLBuilder(name, options).root();
	  };
	
	}).call(this);


/***/ },
/* 2516 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	var AWS = __webpack_require__(__webpack_module_template_argument_1__);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cognitoidentity'] = {};
	AWS.CognitoIdentity = Service.defineService('cognitoidentity', ['2014-06-30']);
	__webpack_require__(__webpack_module_template_argument_2__);
	Object.defineProperty(apiLoader.services['cognitoidentity'], '2014-06-30', {
	  get: function get() {
	    var model = __webpack_require__(__webpack_module_template_argument_3__);
	    model.paginators = __webpack_require__(__webpack_module_template_argument_4__).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CognitoIdentity;


/***/ },
/* 2517 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	var AWS = __webpack_require__(__webpack_module_template_argument_1__);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['cognitoidentityserviceprovider'] = {};
	AWS.CognitoIdentityServiceProvider = Service.defineService('cognitoidentityserviceprovider', ['2016-04-18']);
	Object.defineProperty(apiLoader.services['cognitoidentityserviceprovider'], '2016-04-18', {
	  get: function get() {
	    var model = __webpack_require__(__webpack_module_template_argument_2__);
	    model.paginators = __webpack_require__(__webpack_module_template_argument_3__).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.CognitoIdentityServiceProvider;


/***/ },
/* 2518 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	var AWS = __webpack_require__(__webpack_module_template_argument_1__);
	var Service = AWS.Service;
	var apiLoader = AWS.apiLoader;
	
	apiLoader.services['sts'] = {};
	AWS.STS = Service.defineService('sts', ['2011-06-15']);
	__webpack_require__(__webpack_module_template_argument_2__);
	Object.defineProperty(apiLoader.services['sts'], '2011-06-15', {
	  get: function get() {
	    var model = __webpack_require__(__webpack_module_template_argument_3__);
	    model.paginators = __webpack_require__(__webpack_module_template_argument_4__).pagination;
	    return model;
	  },
	  enumerable: true,
	  configurable: true
	});
	
	module.exports = AWS.STS;


/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var EventEmitter = __webpack_require__(507).EventEmitter;
	__webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * @api private
	 */
	AWS.XHRClient = AWS.util.inherit({
	  handleRequest: function handleRequest(httpRequest, httpOptions, callback, errCallback) {
	    var self = this;
	    var endpoint = httpRequest.endpoint;
	    var emitter = new EventEmitter();
	    var href = endpoint.protocol + '//' + endpoint.hostname;
	    if (endpoint.port !== 80 && endpoint.port !== 443) {
	      href += ':' + endpoint.port;
	    }
	    href += httpRequest.path;
	
	    var xhr = new XMLHttpRequest(), headersEmitted = false;
	    httpRequest.stream = xhr;
	
	    xhr.addEventListener('readystatechange', function() {
	      try {
	        if (xhr.status === 0) return; // 0 code is invalid
	      } catch (e) { return; }
	
	      if (this.readyState >= this.HEADERS_RECEIVED && !headersEmitted) {
	        emitter.statusCode = xhr.status;
	        emitter.headers = self.parseHeaders(xhr.getAllResponseHeaders());
	        emitter.emit(
	          'headers',
	          emitter.statusCode,
	          emitter.headers,
	          xhr.statusText
	        );
	        headersEmitted = true;
	      }
	      if (this.readyState === this.DONE) {
	        self.finishRequest(xhr, emitter);
	      }
	    }, false);
	    xhr.upload.addEventListener('progress', function (evt) {
	      emitter.emit('sendProgress', evt);
	    });
	    xhr.addEventListener('progress', function (evt) {
	      emitter.emit('receiveProgress', evt);
	    }, false);
	    xhr.addEventListener('timeout', function () {
	      errCallback(AWS.util.error(new Error('Timeout'), {code: 'TimeoutError'}));
	    }, false);
	    xhr.addEventListener('error', function () {
	      errCallback(AWS.util.error(new Error('Network Failure'), {
	        code: 'NetworkingError'
	      }));
	    }, false);
	    xhr.addEventListener('abort', function () {
	      errCallback(AWS.util.error(new Error('Request aborted'), {
	        code: 'RequestAbortedError'
	      }));
	    }, false);
	
	    callback(emitter);
	    xhr.open(httpRequest.method, href, httpOptions.xhrAsync !== false);
	    AWS.util.each(httpRequest.headers, function (key, value) {
	      if (key !== 'Content-Length' && key !== 'User-Agent' && key !== 'Host') {
	        xhr.setRequestHeader(key, value);
	      }
	    });
	
	    if (httpOptions.timeout && httpOptions.xhrAsync !== false) {
	      xhr.timeout = httpOptions.timeout;
	    }
	
	    if (httpOptions.xhrWithCredentials) {
	      xhr.withCredentials = true;
	    }
	    try { xhr.responseType = 'arraybuffer'; } catch (e) {}
	
	    try {
	      if (httpRequest.body) {
	        xhr.send(httpRequest.body);
	      } else {
	        xhr.send();
	      }
	    } catch (err) {
	      if (httpRequest.body && typeof httpRequest.body.buffer === 'object') {
	        xhr.send(httpRequest.body.buffer); // send ArrayBuffer directly
	      } else {
	        throw err;
	      }
	    }
	
	    return emitter;
	  },
	
	  parseHeaders: function parseHeaders(rawHeaders) {
	    var headers = {};
	    AWS.util.arrayEach(rawHeaders.split(/\r?\n/), function (line) {
	      var key = line.split(':', 1)[0];
	      var value = line.substring(key.length + 2);
	      if (key.length > 0) headers[key.toLowerCase()] = value;
	    });
	    return headers;
	  },
	
	  finishRequest: function finishRequest(xhr, emitter) {
	    var buffer;
	    if (xhr.responseType === 'arraybuffer' && xhr.response) {
	      var ab = xhr.response;
	      buffer = new AWS.util.Buffer(ab.byteLength);
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < buffer.length; ++i) {
	        buffer[i] = view[i];
	      }
	    }
	
	    try {
	      if (!buffer && typeof xhr.responseText === 'string') {
	        buffer = new AWS.util.Buffer(xhr.responseText);
	      }
	    } catch (e) {}
	
	    if (buffer) emitter.emit('data', buffer);
	    emitter.emit('end');
	  }
	});
	
	/**
	 * @api private
	 */
	AWS.HttpClient.prototype = AWS.XHRClient.prototype;
	
	/**
	 * @api private
	 */
	AWS.HttpClient.streamsApiVersion = 1;


/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2012-2013 Amazon.com, Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License"). You
	 * may not use this file except in compliance with the License. A copy of
	 * the License is located at
	 *
	 *     http://aws.amazon.com/apache2.0/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
	 * ANY KIND, either express or implied. See the License for the specific
	 * language governing permissions and limitations under the License.
	 */
	
	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	var jmespath = __webpack_require__(139);
	
	/**
	 * @api private
	 */
	function CHECK_ACCEPTORS(resp) {
	  var waiter = resp.request._waiter;
	  var acceptors = waiter.config.acceptors;
	  var acceptorMatched = false;
	  var state = 'retry';
	
	  acceptors.forEach(function(acceptor) {
	    if (!acceptorMatched) {
	      var matcher = waiter.matchers[acceptor.matcher];
	      if (matcher && matcher(resp, acceptor.expected, acceptor.argument)) {
	        acceptorMatched = true;
	        state = acceptor.state;
	      }
	    }
	  });
	
	  if (!acceptorMatched && resp.error) state = 'failure';
	
	  if (state === 'success') {
	    waiter.setSuccess(resp);
	  } else {
	    waiter.setError(resp, state === 'retry');
	  }
	}
	
	/**
	 * @api private
	 */
	AWS.ResourceWaiter = inherit({
	  /**
	   * Waits for a given state on a service object
	   * @param service [Service] the service object to wait on
	   * @param state [String] the state (defined in waiter configuration) to wait
	   *   for.
	   * @example Create a waiter for running EC2 instances
	   *   var ec2 = new AWS.EC2;
	   *   var waiter = new AWS.ResourceWaiter(ec2, 'instanceRunning');
	   */
	  constructor: function constructor(service, state) {
	    this.service = service;
	    this.state = state;
	    this.loadWaiterConfig(this.state);
	  },
	
	  service: null,
	
	  state: null,
	
	  config: null,
	
	  matchers: {
	    path: function(resp, expected, argument) {
	      try {
	        var result = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      return jmespath.strictDeepEqual(result,expected);
	    },
	
	    pathAll: function(resp, expected, argument) {
	      try {
	        var results = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      if (!Array.isArray(results)) results = [results];
	      var numResults = results.length;
	      if (!numResults) return false;
	      for (var ind = 0 ; ind < numResults; ind++) {
	        if (!jmespath.strictDeepEqual(results[ind], expected)) {
	          return false;
	        }
	      }
	      return true;
	    },
	
	    pathAny: function(resp, expected, argument) {
	      try {
	        var results = jmespath.search(resp.data, argument);
	      } catch (err) {
	        return false;
	      }
	
	      if (!Array.isArray(results)) results = [results];
	      var numResults = results.length;
	      for (var ind = 0 ; ind < numResults; ind++) {
	        if (jmespath.strictDeepEqual(results[ind], expected)) {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    status: function(resp, expected) {
	      var statusCode = resp.httpResponse.statusCode;
	      return (typeof statusCode === 'number') && (statusCode === expected);
	    },
	
	    error: function(resp, expected) {
	      if (typeof expected === 'string' && resp.error) {
	        return expected === resp.error.code;
	      }
	      // if expected is not string, can be boolean indicating presence of error
	      return expected === !!resp.error;
	    }
	  },
	
	  listeners: new AWS.SequentialExecutor().addNamedListeners(function(add) {
	    add('RETRY_CHECK', 'retry', function(resp) {
	      var waiter = resp.request._waiter;
	      if (resp.error && resp.error.code === 'ResourceNotReady') {
	        resp.error.retryDelay = (waiter.config.delay || 0) * 1000;
	      }
	    });
	
	    add('CHECK_OUTPUT', 'extractData', CHECK_ACCEPTORS);
	
	    add('CHECK_ERROR', 'extractError', CHECK_ACCEPTORS);
	  }),
	
	  /**
	   * @return [AWS.Request]
	   */
	  wait: function wait(params, callback) {
	    if (typeof params === 'function') {
	      callback = params; params = undefined;
	    }
	
	    if (params && params.$waiter) {
	      params = AWS.util.copy(params);
	      if (typeof params.$waiter.delay === 'number') {
	        this.config.delay = params.$waiter.delay;
	      }
	      if (typeof params.$waiter.maxAttempts === 'number') {
	        this.config.maxAttempts = params.$waiter.maxAttempts;
	      }
	      delete params.$waiter;
	    }
	
	    var request = this.service.makeRequest(this.config.operation, params);
	    request._waiter = this;
	    request.response.maxRetries = this.config.maxAttempts;
	    request.addListeners(this.listeners);
	
	    if (callback) request.send(callback);
	    return request;
	  },
	
	  setSuccess: function setSuccess(resp) {
	    resp.error = null;
	    resp.data = resp.data || {};
	    resp.request.removeAllListeners('extractData');
	  },
	
	  setError: function setError(resp, retryable) {
	    resp.data = null;
	    resp.error = AWS.util.error(resp.error || new Error(), {
	      code: 'ResourceNotReady',
	      message: 'Resource is not in the state ' + this.state,
	      retryable: retryable
	    });
	  },
	
	  /**
	   * Loads waiter configuration from API configuration
	   *
	   * @api private
	   */
	  loadWaiterConfig: function loadWaiterConfig(state) {
	    if (!this.service.api.waiters[state]) {
	      throw new AWS.util.error(new Error(), {
	        code: 'StateNotFoundError',
	        message: 'State ' + state + ' not found.'
	      });
	    }
	
	    this.config = AWS.util.copy(this.service.api.waiters[state]);
	  }
	});


/***/ },
/* 2521 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	var inherit = AWS.util.inherit;
	var jmespath = __webpack_require__(139);
	
	/**
	 * This class encapsulates the response information
	 * from a service request operation sent through {AWS.Request}.
	 * The response object has two main properties for getting information
	 * back from a request:
	 *
	 * ## The `data` property
	 *
	 * The `response.data` property contains the serialized object data
	 * retrieved from the service request. For instance, for an
	 * Amazon DynamoDB `listTables` method call, the response data might
	 * look like:
	 *
	 * ```
	 * > resp.data
	 * { TableNames:
	 *    [ 'table1', 'table2', ... ] }
	 * ```
	 *
	 * The `data` property can be null if an error occurs (see below).
	 *
	 * ## The `error` property
	 *
	 * In the event of a service error (or transfer error), the
	 * `response.error` property will be filled with the given
	 * error data in the form:
	 *
	 * ```
	 * { code: 'SHORT_UNIQUE_ERROR_CODE',
	 *   message: 'Some human readable error message' }
	 * ```
	 *
	 * In the case of an error, the `data` property will be `null`.
	 * Note that if you handle events that can be in a failure state,
	 * you should always check whether `response.error` is set
	 * before attempting to access the `response.data` property.
	 *
	 * @!attribute data
	 *   @readonly
	 *   @!group Data Properties
	 *   @note Inside of a {AWS.Request~httpData} event, this
	 *     property contains a single raw packet instead of the
	 *     full de-serialized service response.
	 *   @return [Object] the de-serialized response data
	 *     from the service.
	 *
	 * @!attribute error
	 *   An structure containing information about a service
	 *   or networking error.
	 *   @readonly
	 *   @!group Data Properties
	 *   @note This attribute is only filled if a service or
	 *     networking error occurs.
	 *   @return [Error]
	 *     * code [String] a unique short code representing the
	 *       error that was emitted.
	 *     * message [String] a longer human readable error message
	 *     * retryable [Boolean] whether the error message is
	 *       retryable.
	 *     * statusCode [Numeric] in the case of a request that reached the service,
	 *       this value contains the response status code.
	 *     * time [Date] the date time object when the error occurred.
	 *     * hostname [String] set when a networking error occurs to easily
	 *       identify the endpoint of the request.
	 *     * region [String] set when a networking error occurs to easily
	 *       identify the region of the request.
	 *
	 * @!attribute requestId
	 *   @readonly
	 *   @!group Data Properties
	 *   @return [String] the unique request ID associated with the response.
	 *     Log this value when debugging requests for AWS support.
	 *
	 * @!attribute retryCount
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Integer] the number of retries that were
	 *     attempted before the request was completed.
	 *
	 * @!attribute redirectCount
	 *   @readonly
	 *   @!group Operation Properties
	 *   @return [Integer] the number of redirects that were
	 *     followed before the request was completed.
	 *
	 * @!attribute httpResponse
	 *   @readonly
	 *   @!group HTTP Properties
	 *   @return [AWS.HttpResponse] the raw HTTP response object
	 *     containing the response headers and body information
	 *     from the server.
	 *
	 * @see AWS.Request
	 */
	AWS.Response = inherit({
	
	  /**
	   * @api private
	   */
	  constructor: function Response(request) {
	    this.request = request;
	    this.data = null;
	    this.error = null;
	    this.retryCount = 0;
	    this.redirectCount = 0;
	    this.httpResponse = new AWS.HttpResponse();
	    if (request) {
	      this.maxRetries = request.service.numRetries();
	      this.maxRedirects = request.service.config.maxRedirects;
	    }
	  },
	
	  /**
	   * Creates a new request for the next page of response data, calling the
	   * callback with the page data if a callback is provided.
	   *
	   * @callback callback function(err, data)
	   *   Called when a page of data is returned from the next request.
	   *
	   *   @param err [Error] an error object, if an error occurred in the request
	   *   @param data [Object] the next page of data, or null, if there are no
	   *     more pages left.
	   * @return [AWS.Request] the request object for the next page of data
	   * @return [null] if no callback is provided and there are no pages left
	   *   to retrieve.
	   * @since v1.4.0
	   */
	  nextPage: function nextPage(callback) {
	    var config;
	    var service = this.request.service;
	    var operation = this.request.operation;
	    try {
	      config = service.paginationConfig(operation, true);
	    } catch (e) { this.error = e; }
	
	    if (!this.hasNextPage()) {
	      if (callback) callback(this.error, null);
	      else if (this.error) throw this.error;
	      return null;
	    }
	
	    var params = AWS.util.copy(this.request.params);
	    if (!this.nextPageTokens) {
	      return callback ? callback(null, null) : null;
	    } else {
	      var inputTokens = config.inputToken;
	      if (typeof inputTokens === 'string') inputTokens = [inputTokens];
	      for (var i = 0; i < inputTokens.length; i++) {
	        params[inputTokens[i]] = this.nextPageTokens[i];
	      }
	      return service.makeRequest(this.request.operation, params, callback);
	    }
	  },
	
	  /**
	   * @return [Boolean] whether more pages of data can be returned by further
	   *   requests
	   * @since v1.4.0
	   */
	  hasNextPage: function hasNextPage() {
	    this.cacheNextPageTokens();
	    if (this.nextPageTokens) return true;
	    if (this.nextPageTokens === undefined) return undefined;
	    else return false;
	  },
	
	  /**
	   * @api private
	   */
	  cacheNextPageTokens: function cacheNextPageTokens() {
	    if (Object.prototype.hasOwnProperty.call(this, 'nextPageTokens')) return this.nextPageTokens;
	    this.nextPageTokens = undefined;
	
	    var config = this.request.service.paginationConfig(this.request.operation);
	    if (!config) return this.nextPageTokens;
	
	    this.nextPageTokens = null;
	    if (config.moreResults) {
	      if (!jmespath.search(this.data, config.moreResults)) {
	        return this.nextPageTokens;
	      }
	    }
	
	    var exprs = config.outputToken;
	    if (typeof exprs === 'string') exprs = [exprs];
	    AWS.util.arrayEach.call(this, exprs, function (expr) {
	      var output = jmespath.search(this.data, expr);
	      if (output) {
	        this.nextPageTokens = this.nextPageTokens || [];
	        this.nextPageTokens.push(output);
	      }
	    });
	
	    return this.nextPageTokens;
	  }
	
	});


/***/ },
/* 2522 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	AWS.util.update(AWS.CognitoIdentity.prototype, {
	  getOpenIdToken: function getOpenIdToken(params, callback) {
	    return this.makeUnauthenticatedRequest('getOpenIdToken', params, callback);
	  },
	
	  getId: function getId(params, callback) {
	    return this.makeUnauthenticatedRequest('getId', params, callback);
	  },
	
	  getCredentialsForIdentity: function getCredentialsForIdentity(params, callback) {
	    return this.makeUnauthenticatedRequest('getCredentialsForIdentity', params, callback);
	  }
	});


/***/ },
/* 2523 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var AWS = __webpack_require__(__webpack_module_template_argument_0__);
	
	AWS.util.update(AWS.STS.prototype, {
	  /**
	   * @overload credentialsFrom(data, credentials = null)
	   *   Creates a credentials object from STS response data containing
	   *   credentials information. Useful for quickly setting AWS credentials.
	   *
	   *   @note This is a low-level utility function. If you want to load temporary
	   *     credentials into your process for subsequent requests to AWS resources,
	   *     you should use {AWS.TemporaryCredentials} instead.
	   *   @param data [map] data retrieved from a call to {getFederatedToken},
	   *     {getSessionToken}, {assumeRole}, or {assumeRoleWithWebIdentity}.
	   *   @param credentials [AWS.Credentials] an optional credentials object to
	   *     fill instead of creating a new object. Useful when modifying an
	   *     existing credentials object from a refresh call.
	   *   @return [AWS.TemporaryCredentials] the set of temporary credentials
	   *     loaded from a raw STS operation response.
	   *   @example Using credentialsFrom to load global AWS credentials
	   *     var sts = new AWS.STS();
	   *     sts.getSessionToken(function (err, data) {
	   *       if (err) console.log("Error getting credentials");
	   *       else {
	   *         AWS.config.credentials = sts.credentialsFrom(data);
	   *       }
	   *     });
	   *   @see AWS.TemporaryCredentials
	   */
	  credentialsFrom: function credentialsFrom(data, credentials) {
	    if (!data) return null;
	    if (!credentials) credentials = new AWS.TemporaryCredentials();
	    credentials.expired = false;
	    credentials.accessKeyId = data.Credentials.AccessKeyId;
	    credentials.secretAccessKey = data.Credentials.SecretAccessKey;
	    credentials.sessionToken = data.Credentials.SessionToken;
	    credentials.expireTime = data.Credentials.Expiration;
	    return credentials;
	  },
	
	  assumeRoleWithWebIdentity: function assumeRoleWithWebIdentity(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithWebIdentity', params, callback);
	  },
	
	  assumeRoleWithSAML: function assumeRoleWithSAML(params, callback) {
	    return this.makeUnauthenticatedRequest('assumeRoleWithSAML', params, callback);
	  }
	});


/***/ },
/* 2524 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var punycode = __webpack_require__(__webpack_module_template_argument_0__);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(218);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a puny coded representation of "domain".
	      // It only converts the part of the domain name that
	      // has non ASCII characters. I.e. it dosent matter if
	      // you call it with a domain that already is in ASCII.
	      var domainArray = this.hostname.split('.');
	      var newOut = [];
	      for (var i = 0; i < domainArray.length; ++i) {
	        var s = domainArray[i];
	        newOut.push(s.match(/[^A-Za-z0-9_-]/) ?
	            'xn--' + punycode.encode(s) : s);
	      }
	      this.hostname = newOut.join('.');
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  Object.keys(this).forEach(function(k) {
	    result[k] = this[k];
	  }, this);
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    Object.keys(relative).forEach(function(k) {
	      if (k !== 'protocol')
	        result[k] = relative[k];
	    });
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      Object.keys(relative).forEach(function(k) {
	        result[k] = relative[k];
	      });
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especialy happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!isNull(result.pathname) || !isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host) && (last === '.' || last === '..') ||
	      last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last == '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especialy happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!isNull(result.pathname) || !isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};
	
	function isString(arg) {
	  return typeof arg === "string";
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isNull(arg) {
	  return arg === null;
	}
	function isNullOrUndefined(arg) {
	  return  arg == null;
	}


/***/ },
/* 2525 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var v1 = __webpack_require__(__webpack_module_template_argument_0__);
	var v4 = __webpack_require__(__webpack_module_template_argument_1__);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 2526 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AccountDropdown = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _AccountDropdown2 = _interopRequireDefault(_AccountDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AccountDropdown2.default;

/***/ },
/* 2527 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _View = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _View2.default;

/***/ },
/* 2528 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Rtiles = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Rtiles2 = _interopRequireDefault(_Rtiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Rtiles2.default;

/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DashBoardHeader = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _DashBoardHeader2 = _interopRequireDefault(_DashBoardHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DashBoardHeader2.default;

/***/ },
/* 2530 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Actionable = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Actionable2 = _interopRequireDefault(_Actionable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Actionable2.default;

/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sessionSelector = exports.session = exports.initialState = undefined;
	
	var _handlers;
	
	var _reducers = __webpack_require__(35);
	
	var _immutable = __webpack_require__(11);
	
	var _reselect = __webpack_require__(40);
	
	var _RegisterActionTypes = __webpack_require__(201);
	
	var _LoginActionTypes = __webpack_require__(130);
	
	var _SessionActionTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // use of immutablejs for various js operations to simplify our work
	
	
	var initialState = exports.initialState = (0, _immutable.Map)({
	  session: {},
	  user: {},
	  isValid: true,
	  attributes: (0, _immutable.Map)(),
	  userLoggedOut: false,
	  time: 0
	});
	
	var handlers = (_handlers = {}, _defineProperty(_handlers, _RegisterActionTypes.REGISTER_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    session: action.session,
	    user: action.user
	  });
	}), _defineProperty(_handlers, _LoginActionTypes.LOGIN_SUCCESSFUL, function (state, action) {
	  return state.merge({
	    session: action.session,
	    user: action.user
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_VALID, function (state, action) {
	  return state.merge({
	    session: action.session,
	    user: action.user,
	    isValid: true,
	    attributes: action.attributes
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_LOGOUT, function (state) {
	  var date = new Date();
	  return state.merge({
	    session: {},
	    user: {},
	    isValid: false,
	    time: date.getTime(),
	    attributes: (0, _immutable.Map)(),
	    userLoggedOut: true
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.LOCATION_CHANGE, function (state) {
	  var date = new Date();
	  return state.merge({
	    time: date.getTime()
	  });
	}), _defineProperty(_handlers, _SessionActionTypes.SESSION_ATTRIB, function (state, action) {
	  return state.merge({
	    attributes: action.attributes
	  });
	}), _handlers);
	
	var session = exports.session = (0, _reducers.createReducer)(initialState, handlers);
	
	// LOGIN SELECTOR
	var getSession = function getSession(state) {
	  return state.session.get('session');
	};
	var getUser = function getUser(state) {
	  return state.session.get('user');
	};
	var getIsValid = function getIsValid(state) {
	  return state.session.get('isValid');
	};
	var getAttributes = function getAttributes(state) {
	  return state.session.get('attributes');
	};
	var time = function time(state) {
	  return state.session.get('time');
	};
	var userLoggedOut = function userLoggedOut(state) {
	  return state.session.get('userLoggedOut');
	};
	var sessionSelector = exports.sessionSelector = (0, _reselect.createStructuredSelector)({
	  session: getSession,
	  user: getUser,
	  isValid: getIsValid,
	  attributes: getAttributes,
	  time: time,
	  userLoggedOut: userLoggedOut
	});

/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Session = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Session2.default;

/***/ },
/* 2533 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Login2.default;

/***/ },
/* 2534 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AthleteById = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _AthleteById2 = _interopRequireDefault(_AthleteById);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AthleteById2.default;

/***/ },
/* 2535 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Parent = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Parent2 = _interopRequireDefault(_Parent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Parent2.default;

/***/ },
/* 2536 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	__webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__).Array.from;


/***/ },
/* 2537 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	__webpack_require__(__webpack_module_template_argument_0__);
	__webpack_require__(__webpack_module_template_argument_1__);
	__webpack_require__(__webpack_module_template_argument_2__);
	__webpack_require__(__webpack_module_template_argument_3__);
	module.exports = __webpack_require__(__webpack_module_template_argument_4__).Symbol;


/***/ },
/* 2538 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 2539 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 2540 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 2541 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 2542 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 2543 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2544 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 2545 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 2546 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 2547 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 2548 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 2549 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 2553 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 2555 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 2557 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 2558 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 2560 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 2561 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 2562 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 2563 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 2564 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 2565 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 2566 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 2569 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 2570 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 2571 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 2572 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 2573 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 2574 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 2575 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 2576 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 2577 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 2578 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 2579 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 2580 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 2581 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 2582 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 2583 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_18__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_19__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_20__);
	var _create = __webpack_require__(__webpack_module_template_argument_21__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_22__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_23__);
	var $GOPS = __webpack_require__(__webpack_module_template_argument_24__);
	var $DP = __webpack_require__(__webpack_module_template_argument_25__);
	var $keys = __webpack_require__(__webpack_module_template_argument_26__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_27__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_28__).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_29__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_30__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 2584 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ },
/* 2585 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.8104f500.js